import { ref as ge, computed as D, capitalize as hj, readonly as SI, inject as Wv, getCurrentInstance as RI, resolveComponent as P, createElementBlock as z, openBlock as T, createTextVNode as q, createVNode as w, withCtx as k, toValue as Qe, reactive as lt, toRef as xe, watch as Ct, isReactive as fj, toRefs as Nn, onScopeDispose as AI, watchEffect as dx, onUnmounted as Em, isRef as Xe, unref as v, onMounted as wi, defineComponent as U, mergeModels as Br, useModel as zn, useSlots as DI, createBlock as O, createCommentVNode as j, renderSlot as Ve, Fragment as ve, createElementVNode as re, resolveDynamicComponent as Mr, normalizeProps as sn, guardReactiveProps as kn, toDisplayString as ie, mergeProps as yt, renderList as ln, createSlots as Ut, markRaw as mj, normalizeClass as Bt, normalizeStyle as b0, KeepAlive as hx, withAsyncContext as fx, onActivated as yj, provide as EI, onBeforeMount as MI, h as Mm, getCurrentScope as gj, withKeys as PI, withModifiers as ek, useAttrs as Eh, onBeforeUnmount as CI, Transition as mx, createStaticVNode as Pm } from "vue";
import { DivergingBarChart as vj, LineChart as tk, ScatterPlot as _j, useChartCursor as OI, useChartSelection as II, ChartCursor as wj, ChartSelection as bj, ChartZoom as kj } from "@prefecthq/vue-charts";
import { asArray as Sa, isDefined as Vt, toPluralString as Ks, showToast as He, isDateBefore as Tj, isDateBeforeOrEqual as xj, isDateAfter as Sj, isDateAfterOrEqual as Rj, isNotNullish as ri, isArray as eu, mapDateRangeSelectValueToDateRange as Aj, isDateRangeSelectPeriod as ND, isDateRangeSelectAroundUnit as LD, isDateRangeSelectType as BD, scrollToValidationError as Dj, useThemeTokens as Ej, PCombobox as ts, PToggle as Mh, PNumberInput as Ca, PTextarea as nk, PDateInput as UD, randomId as Cm, PLabel as nr, PTextInput as Mj, PIcon as vo, PEmptyResults as el, useAttrsStylesAndClasses as Pj, PCodeInput as Cj, sortStringArray as Ph, kebabCase as FI, PEmptyState as na, PKeyValue as Lt, PTags as am, POverflowMenuItem as rk, useAttrsStylesClassesAndListeners as Oj, PButton as Zo, PContent as NI, PIconButtonMenu as Ij, PTagWrapper as Fj, PSelect as Om, PListItemInput as Nj, PListItem as Lj, media as _s, PForm as Vv, positions as qr, usePopOverGroup as Bj, toPixels as Uj, PPopOver as Hv, useColorTheme as Xj, PTag as LI, PCode as $j, PTagsInput as Wj, PButtonGroup as Vj, PTable as BI, PBreadCrumbs as Hj, useWizardStep as yx, isSelectOptionNormalized as XD, ToastPlugin as jj } from "@prefecthq/prefect-design";
import { createActions as Fn, SubscriptionManager as zj, RouteParam as Ba, InvalidRouteParamValue as Zr, getLocationQueryForSchema as qj, NumberRouteParam as _o, StringRouteParam as Xt, BooleanRouteParam as Yo, DateRouteParam as mo, useRouteQueryParams as Gj, NullableBooleanRouteParam as Yj, useSubscriptionWithDependencies as xt, useRouteQueryParam as dn, useSubscription as mt, useLocalStorage as hl, watchableArgs as Qj, unrefArgs as Kj, useNow as gx, useElementRect as UI, useSessionStorage as Zj, useDebouncedRef as ns, useIntersectionObserver as XI, useValidation as bn, useValidationObserver as Ms, useRouteParam as Jj, useKeyDown as $I, usePatchRef as mr, refreshChannel as WI } from "@prefecthq/vue-compositions";
import { useForm as ez, useField as Rs } from "vee-validate";
import { useRouter as rs, useRoute as kc } from "vue-router";
const tz = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  get ActivityChart() {
    return c4;
  },
  get ArtifactCard() {
    return hh;
  },
  get ArtifactCollections() {
    return vde;
  },
  get ArtifactCollectionsEmptyState() {
    return p4;
  },
  get ArtifactDataMarkdown() {
    return d4;
  },
  get ArtifactDataRaw() {
    return wde;
  },
  get ArtifactDataResult() {
    return h4;
  },
  get ArtifactDataUnknown() {
    return f4;
  },
  get ArtifactDataView() {
    return N2;
  },
  get ArtifactDescription() {
    return m4;
  },
  get ArtifactDetails() {
    return Nde;
  },
  get ArtifactKeyIconText() {
    return L2;
  },
  get ArtifactMenu() {
    return Lde;
  },
  get ArtifactTimeline() {
    return Qde;
  },
  get ArtifactTypeSelect() {
    return y4;
  },
  get AutomationIconText() {
    return g4;
  },
  get AutomationMenu() {
    return ehe;
  },
  get BetaBadge() {
    return v4;
  },
  get BlockCapabilityBlockDocumentInput() {
    return _4;
  },
  get BlockDocumentCard() {
    return dhe;
  },
  get BlockDocumentCombobox() {
    return KN;
  },
  get BlockDocumentInput() {
    return C2;
  },
  get BlockDocumentKeyValue() {
    return hhe;
  },
  get BlockDocumentMenu() {
    return fhe;
  },
  get BlockDocumentsTable() {
    return _he;
  },
  get BlockIconText() {
    return V0;
  },
  get BlockSchemaCapabilities() {
    return whe;
  },
  get BlockSchemaCapabilitySelect() {
    return bhe;
  },
  get BlockSchemaCreateForm() {
    return GN;
  },
  get BlockSchemaEditForm() {
    return khe;
  },
  get BlockTypeCard() {
    return She;
  },
  get BlockTypeCardLayout() {
    return w4;
  },
  get BlockTypeCardPreview() {
    return P2;
  },
  get BlockTypeList() {
    return YN;
  },
  get BlockTypeSelect() {
    return k4;
  },
  get BlockTypeSnippet() {
    return U2;
  },
  get BlocksPageEmptyState() {
    return The;
  },
  get CodeBanner() {
    return Mhe;
  },
  get CollectionCardPreview() {
    return T4;
  },
  get CollectionItemCard() {
    return Nhe;
  },
  get CollectionsList() {
    return Xhe;
  },
  get ColorModeSelect() {
    return Vhe;
  },
  get ColorModeSelectOption() {
    return Nk;
  },
  get ConcurrencyLimitActiveRuns() {
    return ife;
  },
  get ConcurrencyLimitDetails() {
    return lfe;
  },
  get ConcurrencyLimitMenu() {
    return H2;
  },
  get ConcurrencyLimitResetModal() {
    return S4;
  },
  get ConcurrencyLimitV2Menu() {
    return P4;
  },
  get ConcurrencyLimitV2ResetModal() {
    return C4;
  },
  get ConcurrencyLimitV2Toggle() {
    return O4;
  },
  get ConcurrencyLimitsCreateModal() {
    return j2;
  },
  get ConcurrencyLimitsPageEmptyState() {
    return R4;
  },
  get ConcurrencyLimitsTable() {
    return cfe;
  },
  get ConcurrencyLimitsV2CreateModal() {
    return D4;
  },
  get ConcurrencyLimitsV2EmptyState() {
    return E4;
  },
  get ConcurrencyLimitsV2Table() {
    return pfe;
  },
  get ConcurrencyLimitsV2UpdateModal() {
    return M4;
  },
  get ConcurrencyTableActiveSlots() {
    return I4;
  },
  get ConfirmDeleteModal() {
    return _r;
  },
  get ConfirmStateChangeModal() {
    return z2;
  },
  get CopyOverflowMenuItem() {
    return uo;
  },
  get CopyableWrapper() {
    return fh;
  },
  get CronScheduleForm() {
    return L4;
  },
  get CumulativeTaskRunsCard() {
    return kfe;
  },
  get DashboardWorkPoolsCard() {
    return nve;
  },
  get DateInput() {
    return $0;
  },
  get DateRangeInput() {
    return rve;
  },
  get DateRangeSelect() {
    return fL;
  },
  get DayOrDescriptionModal() {
    return N4;
  },
  get DeploymentCombobox() {
    return oS;
  },
  get DeploymentComboboxOption() {
    return zk;
  },
  get DeploymentConfiguration() {
    return ive;
  },
  get DeploymentCustomRunOverflowMenuItem() {
    return sS;
  },
  get DeploymentDeprecatedMessage() {
    return lve;
  },
  get DeploymentDescription() {
    return cve;
  },
  get DeploymentDescriptionEmptyState() {
    return pve;
  },
  get DeploymentDetails() {
    return mve;
  },
  get DeploymentDisableToggle() {
    return aS;
  },
  get DeploymentForm() {
    return _ve;
  },
  get DeploymentIconText() {
    return $h;
  },
  get DeploymentList() {
    return Sve;
  },
  get DeploymentMenu() {
    return Ave;
  },
  get DeploymentQuickRunOverflowMenuItem() {
    return lS;
  },
  get DeploymentRelationships() {
    return dS;
  },
  get DeploymentScheduleCard() {
    return vL;
  },
  get DeploymentScheduleMenu() {
    return _L;
  },
  get DeploymentScheduleTags() {
    return bL;
  },
  get DeploymentScheduleToggle() {
    return kL;
  },
  get DeploymentSchedulesFieldset() {
    return wL;
  },
  get DeploymentStatusBadge() {
    return hS;
  },
  get DeploymentStatusIcon() {
    return SL;
  },
  get DeploymentStatusSelect() {
    return RL;
  },
  get DeploymentTagsInput() {
    return fS;
  },
  get DeploymentToggle() {
    return gL;
  },
  get DeploymentsCount() {
    return TL;
  },
  get DeploymentsDeleteButton() {
    return xL;
  },
  get DeploymentsPageEmptyState() {
    return $ve;
  },
  get DocumentationButton() {
    return Os;
  },
  get DurationIconText() {
    return Cc;
  },
  get DurationInput() {
    return AL;
  },
  get EventCard() {
    return mS;
  },
  get EventRelatedKeyValue() {
    return F_;
  },
  get EventResourceCombobox() {
    return Yve;
  },
  get EventResourceIconText() {
    return g_e;
  },
  get EventResourceKeyValue() {
    return N_;
  },
  get EventsCombobox() {
    return qk;
  },
  get ExploreEventsButton() {
    return EL;
  },
  get ExtraInfoModal() {
    return E_;
  },
  get ExtraInfoTooltip() {
    return yS;
  },
  get FlowActivityChart() {
    return v_e;
  },
  get FlowCombobox() {
    return gS;
  },
  get FlowDetails() {
    return b_e;
  },
  get FlowIconText() {
    return cS;
  },
  get FlowList() {
    return S_e;
  },
  get FlowMenu() {
    return R_e;
  },
  get FlowPopover() {
    return PL;
  },
  get FlowRouterLink() {
    return tv;
  },
  get FlowRunArtifacts() {
    return I_e;
  },
  get FlowRunAutomation() {
    return CL;
  },
  get FlowRunBreadCrumbs() {
    return nS;
  },
  get FlowRunCancelButton() {
    return OL;
  },
  get FlowRunCancelModal() {
    return vS;
  },
  get FlowRunCreateForm() {
    return H_e;
  },
  get FlowRunDeployment() {
    return R_;
  },
  get FlowRunDetails() {
    return z_e;
  },
  get FlowRunFilteredList() {
    return q_e;
  },
  get FlowRunFlow() {
    return pS;
  },
  get FlowRunGraph() {
    return cOe;
  },
  get FlowRunGraphArtifactCard() {
    return XU;
  },
  get FlowRunGraphArtifactDrawer() {
    return hOe;
  },
  get FlowRunGraphArtifactsPopover() {
    return mOe;
  },
  get FlowRunGraphConfirmation() {
    return IL;
  },
  get FlowRunGraphEventPopover() {
    return gOe;
  },
  get FlowRunGraphEventsPopover() {
    return wOe;
  },
  get FlowRunGraphPopover() {
    return gy;
  },
  get FlowRunGraphSelectionPanel() {
    return TOe;
  },
  get FlowRunGraphStatePopover() {
    return SOe;
  },
  get FlowRunHistoryCard() {
    return AOe;
  },
  get FlowRunIconText() {
    return ty;
  },
  get FlowRunJobVariableOverridesLabeledInput() {
    return L_;
  },
  get FlowRunList() {
    return sw;
  },
  get FlowRunListItem() {
    return OOe;
  },
  get FlowRunLogs() {
    return UOe;
  },
  get FlowRunLogsDownloadButton() {
    return $U;
  },
  get FlowRunMenu() {
    return $Oe;
  },
  get FlowRunName() {
    return vR;
  },
  get FlowRunParentFlowRun() {
    return WU;
  },
  get FlowRunPopOver() {
    return VU;
  },
  get FlowRunPopOverContent() {
    return rS;
  },
  get FlowRunResumeButton() {
    return HU;
  },
  get FlowRunResumeModal() {
    return gR;
  },
  get FlowRunRetryButton() {
    return jU;
  },
  get FlowRunRetryModal() {
    return _R;
  },
  get FlowRunStartTime() {
    return ay;
  },
  get FlowRunStateTypeTab() {
    return GU;
  },
  get FlowRunSuspendButton() {
    return YU;
  },
  get FlowRunSuspendModal() {
    return bR;
  },
  get FlowRunTagsInput() {
    return wR;
  },
  get FlowRunTaskRuns() {
    return PIe;
  },
  get FlowRunTimelineSubFlowRunDetails() {
    return QU;
  },
  get FlowRunTimelineTaskDetails() {
    return KU;
  },
  get FlowRunWorkPool() {
    return ny;
  },
  get FlowRunWorkQueue() {
    return ry;
  },
  get FlowRunsBarChart() {
    return Vh;
  },
  get FlowRunsDeleteButton() {
    return zU;
  },
  get FlowRunsFilterGroup() {
    return qOe;
  },
  get FlowRunsPageEmptyState() {
    return GOe;
  },
  get FlowRunsScatterPlot() {
    return QOe;
  },
  get FlowRunsSort() {
    return qU;
  },
  get FlowsDeleteButton() {
    return ZU;
  },
  get FlowsFilterGroup() {
    return UIe;
  },
  get FlowsPageEmptyState() {
    return XIe;
  },
  get FormattedDate() {
    return hn;
  },
  get FourZeroFour() {
    return WIe;
  },
  get IconTextCount() {
    return JU;
  },
  get IntervalScheduleForm() {
    return eX;
  },
  get JobVariableOverridesInput() {
    return wS;
  },
  get JsonInput() {
    return Rr;
  },
  get LastFlowRun() {
    return kR;
  },
  get LogLevelLabel() {
    return tX;
  },
  get LogLevelSelect() {
    return TR;
  },
  get LogRow() {
    return nX;
  },
  get LogoImage() {
    return fu;
  },
  get LogsContainer() {
    return xR;
  },
  get LogsSort() {
    return SR;
  },
  get MarketingBanner() {
    return t8e;
  },
  get MiniDeploymentHistory() {
    return rX;
  },
  get MiniFlowHistory() {
    return oX;
  },
  get NextFlowRun() {
    return RR;
  },
  get NotificationDetails() {
    return AR;
  },
  get NotificationForm() {
    return d8e;
  },
  get NotificationMenu() {
    return sX;
  },
  get NotificationStatusSelect() {
    return aX;
  },
  get NotificationToggle() {
    return iX;
  },
  get NotificationsPageEmptyState() {
    return h8e;
  },
  get NotificationsTable() {
    return _8e;
  },
  get PageHeading() {
    return nn;
  },
  get PageHeadingAccountSettings() {
    return x8e;
  },
  get PageHeadingApiKeys() {
    return S8e;
  },
  get PageHeadingArtifact() {
    return R8e;
  },
  get PageHeadingArtifactKey() {
    return A8e;
  },
  get PageHeadingArtifacts() {
    return D8e;
  },
  get PageHeadingAutomation() {
    return M8e;
  },
  get PageHeadingBlock() {
    return P8e;
  },
  get PageHeadingBlockEdit() {
    return C8e;
  },
  get PageHeadingBlocks() {
    return O8e;
  },
  get PageHeadingBlocksCatalog() {
    return I8e;
  },
  get PageHeadingBlocksCatalogCreate() {
    return F8e;
  },
  get PageHeadingBlocksCatalogView() {
    return N8e;
  },
  get PageHeadingConcurrencyLimit() {
    return L8e;
  },
  get PageHeadingConcurrencyLimits() {
    return B8e;
  },
  get PageHeadingDeployment() {
    return U8e;
  },
  get PageHeadingDeploymentDuplicate() {
    return X8e;
  },
  get PageHeadingDeploymentEdit() {
    return $8e;
  },
  get PageHeadingDeployments() {
    return W8e;
  },
  get PageHeadingFlow() {
    return V8e;
  },
  get PageHeadingFlowCollection() {
    return H8e;
  },
  get PageHeadingFlowCollections() {
    return j8e;
  },
  get PageHeadingFlowRun() {
    return Q8e;
  },
  get PageHeadingFlowRunCreate() {
    return K8e;
  },
  get PageHeadingFlowRuns() {
    return e3e;
  },
  get PageHeadingFlows() {
    return t3e;
  },
  get PageHeadingNotificationCreate() {
    return n3e;
  },
  get PageHeadingNotificationEdit() {
    return r3e;
  },
  get PageHeadingNotifications() {
    return o3e;
  },
  get PageHeadingRuns() {
    return s3e;
  },
  get PageHeadingTaskRun() {
    return a3e;
  },
  get PageHeadingVariables() {
    return i3e;
  },
  get PageHeadingWorkPool() {
    return u3e;
  },
  get PageHeadingWorkPoolCreate() {
    return l3e;
  },
  get PageHeadingWorkPoolEdit() {
    return c3e;
  },
  get PageHeadingWorkPoolQueue() {
    return p3e;
  },
  get PageHeadingWorkPoolQueueCreate() {
    return d3e;
  },
  get PageHeadingWorkPoolQueueEdit() {
    return h3e;
  },
  get PageHeadingWorkPools() {
    return f3e;
  },
  get PageHeadingWorkspaceSettings() {
    return m3e;
  },
  get ParametersTable() {
    return v3e;
  },
  get ProcessTypeBadge() {
    return dX;
  },
  get QuickRunParametersModal() {
    return iS;
  },
  get ResourceLink() {
    return _3e;
  },
  get ResultsCount() {
    return Uo;
  },
  get RunMenu() {
    return hX;
  },
  get SaveFilterModal() {
    return cX;
  },
  get SavedFilters() {
    return ER;
  },
  get SavedFiltersDeleteModal() {
    return lX;
  },
  get SavedFiltersMenu() {
    return pX;
  },
  get ScheduleFieldset() {
    return S3e;
  },
  get ScheduleFormModal() {
    return iw;
  },
  get SchemaForm() {
    return R3e;
  },
  get SchemaFormFields() {
    return ed;
  },
  get SchemaFormFieldsWithValues() {
    return fX;
  },
  get SchemaFormInput() {
    return Pk;
  },
  get SchemaFormProperties() {
    return BN;
  },
  get SchemaFormProperty() {
    return bp;
  },
  get SchemaFormPropertyAllOf() {
    return UN;
  },
  get SchemaFormPropertyAnyOf() {
    return qN;
  },
  get SchemaInput() {
    return D3e;
  },
  get SchemaPropertiesKeyValues() {
    return X2;
  },
  get SchemaPropertyKeyValue() {
    return b4;
  },
  get SearchInput() {
    return Wo;
  },
  get SelectedCount() {
    return td;
  },
  get SeparatedList() {
    return px;
  },
  get StateBadge() {
    return Dr;
  },
  get StateIcon() {
    return $2;
  },
  get StateListItem() {
    return W2;
  },
  get StateNameSelect() {
    return qh;
  },
  get StateSelect() {
    return F4;
  },
  get StatisticKeyValue() {
    return Jl;
  },
  get SubmitButton() {
    return Pc;
  },
  get TaskRunArtifacts() {
    return P3e;
  },
  get TaskRunDetails() {
    return O3e;
  },
  get TaskRunIconText() {
    return B2;
  },
  get TaskRunList() {
    return V2;
  },
  get TaskRunListItem() {
    return x4;
  },
  get TaskRunLogs() {
    return X3e;
  },
  get TaskRunMenu() {
    return mX;
  },
  get TaskRunsDeleteButton() {
    return $3e;
  },
  get TaskRunsSort() {
    return yX;
  },
  get TimeSpanFilter() {
    return W3e;
  },
  get TimezoneSelect() {
    return M_;
  },
  get ToastFlowRunCreate() {
    return uS;
  },
  get UseDeploymentSlot() {
    return mL;
  },
  get UseFlowSlot() {
    return ML;
  },
  get VariableCreateModal() {
    return MR;
  },
  get VariableDuplicateModal() {
    return gX;
  },
  get VariableEditModal() {
    return PR;
  },
  get VariableMenu() {
    return vX;
  },
  get VariableTagsInput() {
    return wX;
  },
  get VariablesDeleteButton() {
    return _X;
  },
  get VariablesPageEmptyState() {
    return V3e;
  },
  get VariablesTable() {
    return q3e;
  },
  get ViewModeButtonGroup() {
    return S_;
  },
  get WorkPoolBaseJobTemplateFormSection() {
    return CR;
  },
  get WorkPoolCard() {
    return TX;
  },
  get WorkPoolCombobox() {
    return aw;
  },
  get WorkPoolCreateWizard() {
    return aFe;
  },
  get WorkPoolCreateWizardStepInformation() {
    return xX;
  },
  get WorkPoolCreateWizardStepInfrastructureConfiguration() {
    return SX;
  },
  get WorkPoolCreateWizardStepInfrastructureType() {
    return RX;
  },
  get WorkPoolDetails() {
    return dFe;
  },
  get WorkPoolEditForm() {
    return hFe;
  },
  get WorkPoolIconText() {
    return Wh;
  },
  get WorkPoolLateIndicator() {
    return fFe;
  },
  get WorkPoolList() {
    return AX;
  },
  get WorkPoolMenu() {
    return mFe;
  },
  get WorkPoolQueueCombobox() {
    return _S;
  },
  get WorkPoolQueueCreateForm() {
    return yFe;
  },
  get WorkPoolQueueDetails() {
    return _Fe;
  },
  get WorkPoolQueueEditForm() {
    return wFe;
  },
  get WorkPoolQueueMenu() {
    return bFe;
  },
  get WorkPoolQueuePriorityLabel() {
    return uw;
  },
  get WorkPoolQueueStatusBadge() {
    return OR;
  },
  get WorkPoolQueueStatusIcon() {
    return D_;
  },
  get WorkPoolQueueToggle() {
    return IR;
  },
  get WorkPoolQueueUpcomingFlowRunsList() {
    return SFe;
  },
  get WorkPoolQueuesDeleteButton() {
    return DX;
  },
  get WorkPoolQueuesTable() {
    return TFe;
  },
  get WorkPoolStatusBadge() {
    return EX;
  },
  get WorkPoolStatusIcon() {
    return I_;
  },
  get WorkPoolStatusSelect() {
    return MX;
  },
  get WorkPoolToggle() {
    return FR;
  },
  get WorkPoolTypeSelect() {
    return PX;
  },
  get WorkPools() {
    return EFe;
  },
  get WorkPoolsPageEmptyState() {
    return MFe;
  },
  get WorkQueueCombobox() {
    return CX;
  },
  get WorkQueueIconText() {
    return lw;
  },
  get WorkQueueStatusSelect() {
    return OX;
  },
  get WorkerMenu() {
    return bX;
  },
  get WorkerStatusBadge() {
    return kX;
  },
  get WorkersLateIndicator() {
    return $v;
  },
  get WorkersTable() {
    return Q3e;
  },
  get WorkspaceDashboardFlowRunsCard() {
    return CFe;
  },
  get WorkspaceEventDetails() {
    return OFe;
  },
  get WorkspaceEventMenu() {
    return IFe;
  },
  get WorkspaceEventsLineChart() {
    return LFe;
  },
  get WorkspaceEventsTimeline() {
    return qFe;
  },
  get WorkspaceVariableCombobox() {
    return e4;
  }
}, Symbol.toStringTag, { value: "Module" }));
function VI(t, e) {
  return function() {
    return t.apply(e, arguments);
  };
}
const { toString: nz } = Object.prototype, { getPrototypeOf: vx } = Object, { iterator: jv, toStringTag: HI } = Symbol, zv = /* @__PURE__ */ ((t) => (e) => {
  const n = nz.call(e);
  return t[n] || (t[n] = n.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), bi = (t) => (t = t.toLowerCase(), (e) => zv(e) === t), qv = (t) => (e) => typeof e === t, { isArray: Ch } = Array, rh = qv("undefined");
function Im(t) {
  return t !== null && !rh(t) && t.constructor !== null && !rh(t.constructor) && ws(t.constructor.isBuffer) && t.constructor.isBuffer(t);
}
const jI = bi("ArrayBuffer");
function rz(t) {
  let e;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? e = ArrayBuffer.isView(t) : e = t && t.buffer && jI(t.buffer), e;
}
const oz = qv("string"), ws = qv("function"), zI = qv("number"), Fm = (t) => t !== null && typeof t == "object", sz = (t) => t === !0 || t === !1, Xg = (t) => {
  if (zv(t) !== "object")
    return !1;
  const e = vx(t);
  return (e === null || e === Object.prototype || Object.getPrototypeOf(e) === null) && !(HI in t) && !(jv in t);
}, az = (t) => {
  if (!Fm(t) || Im(t))
    return !1;
  try {
    return Object.keys(t).length === 0 && Object.getPrototypeOf(t) === Object.prototype;
  } catch {
    return !1;
  }
}, iz = bi("Date"), uz = bi("File"), lz = bi("Blob"), cz = bi("FileList"), pz = (t) => Fm(t) && ws(t.pipe), dz = (t) => {
  let e;
  return t && (typeof FormData == "function" && t instanceof FormData || ws(t.append) && ((e = zv(t)) === "formdata" || // detect form-data instance
  e === "object" && ws(t.toString) && t.toString() === "[object FormData]"));
}, hz = bi("URLSearchParams"), [fz, mz, yz, gz] = ["ReadableStream", "Request", "Response", "Headers"].map(bi), vz = (t) => t.trim ? t.trim() : t.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function Nm(t, e, { allOwnKeys: n = !1 } = {}) {
  if (t === null || typeof t > "u")
    return;
  let r, o;
  if (typeof t != "object" && (t = [t]), Ch(t))
    for (r = 0, o = t.length; r < o; r++)
      e.call(null, t[r], r, t);
  else {
    if (Im(t))
      return;
    const s = n ? Object.getOwnPropertyNames(t) : Object.keys(t), i = s.length;
    let u;
    for (r = 0; r < i; r++)
      u = s[r], e.call(null, t[u], u, t);
  }
}
function qI(t, e) {
  if (Im(t))
    return null;
  e = e.toLowerCase();
  const n = Object.keys(t);
  let r = n.length, o;
  for (; r-- > 0; )
    if (o = n[r], e === o.toLowerCase())
      return o;
  return null;
}
const pp = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global, GI = (t) => !rh(t) && t !== pp;
function ok() {
  const { caseless: t, skipUndefined: e } = GI(this) && this || {}, n = {}, r = (o, s) => {
    const i = t && qI(n, s) || s;
    Xg(n[i]) && Xg(o) ? n[i] = ok(n[i], o) : Xg(o) ? n[i] = ok({}, o) : Ch(o) ? n[i] = o.slice() : (!e || !rh(o)) && (n[i] = o);
  };
  for (let o = 0, s = arguments.length; o < s; o++)
    arguments[o] && Nm(arguments[o], r);
  return n;
}
const _z = (t, e, n, { allOwnKeys: r } = {}) => (Nm(e, (o, s) => {
  n && ws(o) ? t[s] = VI(o, n) : t[s] = o;
}, { allOwnKeys: r }), t), wz = (t) => (t.charCodeAt(0) === 65279 && (t = t.slice(1)), t), bz = (t, e, n, r) => {
  t.prototype = Object.create(e.prototype, r), t.prototype.constructor = t, Object.defineProperty(t, "super", {
    value: e.prototype
  }), n && Object.assign(t.prototype, n);
}, kz = (t, e, n, r) => {
  let o, s, i;
  const u = {};
  if (e = e || {}, t == null) return e;
  do {
    for (o = Object.getOwnPropertyNames(t), s = o.length; s-- > 0; )
      i = o[s], (!r || r(i, t, e)) && !u[i] && (e[i] = t[i], u[i] = !0);
    t = n !== !1 && vx(t);
  } while (t && (!n || n(t, e)) && t !== Object.prototype);
  return e;
}, Tz = (t, e, n) => {
  t = String(t), (n === void 0 || n > t.length) && (n = t.length), n -= e.length;
  const r = t.indexOf(e, n);
  return r !== -1 && r === n;
}, xz = (t) => {
  if (!t) return null;
  if (Ch(t)) return t;
  let e = t.length;
  if (!zI(e)) return null;
  const n = new Array(e);
  for (; e-- > 0; )
    n[e] = t[e];
  return n;
}, Sz = /* @__PURE__ */ ((t) => (e) => t && e instanceof t)(typeof Uint8Array < "u" && vx(Uint8Array)), Rz = (t, e) => {
  const r = (t && t[jv]).call(t);
  let o;
  for (; (o = r.next()) && !o.done; ) {
    const s = o.value;
    e.call(t, s[0], s[1]);
  }
}, Az = (t, e) => {
  let n;
  const r = [];
  for (; (n = t.exec(e)) !== null; )
    r.push(n);
  return r;
}, Dz = bi("HTMLFormElement"), Ez = (t) => t.toLowerCase().replace(
  /[-_\s]([a-z\d])(\w*)/g,
  function(n, r, o) {
    return r.toUpperCase() + o;
  }
), $D = (({ hasOwnProperty: t }) => (e, n) => t.call(e, n))(Object.prototype), Mz = bi("RegExp"), YI = (t, e) => {
  const n = Object.getOwnPropertyDescriptors(t), r = {};
  Nm(n, (o, s) => {
    let i;
    (i = e(o, s, t)) !== !1 && (r[s] = i || o);
  }), Object.defineProperties(t, r);
}, Pz = (t) => {
  YI(t, (e, n) => {
    if (ws(t) && ["arguments", "caller", "callee"].indexOf(n) !== -1)
      return !1;
    const r = t[n];
    if (ws(r)) {
      if (e.enumerable = !1, "writable" in e) {
        e.writable = !1;
        return;
      }
      e.set || (e.set = () => {
        throw Error("Can not rewrite read-only method '" + n + "'");
      });
    }
  });
}, Cz = (t, e) => {
  const n = {}, r = (o) => {
    o.forEach((s) => {
      n[s] = !0;
    });
  };
  return Ch(t) ? r(t) : r(String(t).split(e)), n;
}, Oz = () => {
}, Iz = (t, e) => t != null && Number.isFinite(t = +t) ? t : e;
function Fz(t) {
  return !!(t && ws(t.append) && t[HI] === "FormData" && t[jv]);
}
const Nz = (t) => {
  const e = new Array(10), n = (r, o) => {
    if (Fm(r)) {
      if (e.indexOf(r) >= 0)
        return;
      if (Im(r))
        return r;
      if (!("toJSON" in r)) {
        e[o] = r;
        const s = Ch(r) ? [] : {};
        return Nm(r, (i, u) => {
          const l = n(i, o + 1);
          !rh(l) && (s[u] = l);
        }), e[o] = void 0, s;
      }
    }
    return r;
  };
  return n(t, 0);
}, Lz = bi("AsyncFunction"), Bz = (t) => t && (Fm(t) || ws(t)) && ws(t.then) && ws(t.catch), QI = ((t, e) => t ? setImmediate : e ? ((n, r) => (pp.addEventListener("message", ({ source: o, data: s }) => {
  o === pp && s === n && r.length && r.shift()();
}, !1), (o) => {
  r.push(o), pp.postMessage(n, "*");
}))(`axios@${Math.random()}`, []) : (n) => setTimeout(n))(
  typeof setImmediate == "function",
  ws(pp.postMessage)
), Uz = typeof queueMicrotask < "u" ? queueMicrotask.bind(pp) : typeof process < "u" && process.nextTick || QI, Xz = (t) => t != null && ws(t[jv]), De = {
  isArray: Ch,
  isArrayBuffer: jI,
  isBuffer: Im,
  isFormData: dz,
  isArrayBufferView: rz,
  isString: oz,
  isNumber: zI,
  isBoolean: sz,
  isObject: Fm,
  isPlainObject: Xg,
  isEmptyObject: az,
  isReadableStream: fz,
  isRequest: mz,
  isResponse: yz,
  isHeaders: gz,
  isUndefined: rh,
  isDate: iz,
  isFile: uz,
  isBlob: lz,
  isRegExp: Mz,
  isFunction: ws,
  isStream: pz,
  isURLSearchParams: hz,
  isTypedArray: Sz,
  isFileList: cz,
  forEach: Nm,
  merge: ok,
  extend: _z,
  trim: vz,
  stripBOM: wz,
  inherits: bz,
  toFlatObject: kz,
  kindOf: zv,
  kindOfTest: bi,
  endsWith: Tz,
  toArray: xz,
  forEachEntry: Rz,
  matchAll: Az,
  isHTMLForm: Dz,
  hasOwnProperty: $D,
  hasOwnProp: $D,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors: YI,
  freezeMethods: Pz,
  toObjectSet: Cz,
  toCamelCase: Ez,
  noop: Oz,
  toFiniteNumber: Iz,
  findKey: qI,
  global: pp,
  isContextDefined: GI,
  isSpecCompliantForm: Fz,
  toJSONObject: Nz,
  isAsyncFn: Lz,
  isThenable: Bz,
  setImmediate: QI,
  asap: Uz,
  isIterable: Xz
};
function Zt(t, e, n, r, o) {
  Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = t, this.name = "AxiosError", e && (this.code = e), n && (this.config = n), r && (this.request = r), o && (this.response = o, this.status = o.status ? o.status : null);
}
De.inherits(Zt, Error, {
  toJSON: function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: De.toJSONObject(this.config),
      code: this.code,
      status: this.status
    };
  }
});
const KI = Zt.prototype, ZI = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED",
  "ERR_NOT_SUPPORT",
  "ERR_INVALID_URL"
  // eslint-disable-next-line func-names
].forEach((t) => {
  ZI[t] = { value: t };
});
Object.defineProperties(Zt, ZI);
Object.defineProperty(KI, "isAxiosError", { value: !0 });
Zt.from = (t, e, n, r, o, s) => {
  const i = Object.create(KI);
  De.toFlatObject(t, i, function(c) {
    return c !== Error.prototype;
  }, (a) => a !== "isAxiosError");
  const u = t && t.message ? t.message : "Error", l = e == null && t ? t.code : e;
  return Zt.call(i, u, l, n, r, o), t && i.cause == null && Object.defineProperty(i, "cause", { value: t, configurable: !0 }), i.name = t && t.name || "Error", s && Object.assign(i, s), i;
};
const $z = null;
function sk(t) {
  return De.isPlainObject(t) || De.isArray(t);
}
function JI(t) {
  return De.endsWith(t, "[]") ? t.slice(0, -2) : t;
}
function WD(t, e, n) {
  return t ? t.concat(e).map(function(o, s) {
    return o = JI(o), !n && s ? "[" + o + "]" : o;
  }).join(n ? "." : "") : e;
}
function Wz(t) {
  return De.isArray(t) && !t.some(sk);
}
const Vz = De.toFlatObject(De, {}, null, function(e) {
  return /^is[A-Z]/.test(e);
});
function Gv(t, e, n) {
  if (!De.isObject(t))
    throw new TypeError("target must be an object");
  e = e || new FormData(), n = De.toFlatObject(n, {
    metaTokens: !0,
    dots: !1,
    indexes: !1
  }, !1, function(g, _) {
    return !De.isUndefined(_[g]);
  });
  const r = n.metaTokens, o = n.visitor || c, s = n.dots, i = n.indexes, l = (n.Blob || typeof Blob < "u" && Blob) && De.isSpecCompliantForm(e);
  if (!De.isFunction(o))
    throw new TypeError("visitor must be a function");
  function a(m) {
    if (m === null) return "";
    if (De.isDate(m))
      return m.toISOString();
    if (De.isBoolean(m))
      return m.toString();
    if (!l && De.isBlob(m))
      throw new Zt("Blob is not supported. Use a Buffer instead.");
    return De.isArrayBuffer(m) || De.isTypedArray(m) ? l && typeof Blob == "function" ? new Blob([m]) : Buffer.from(m) : m;
  }
  function c(m, g, _) {
    let b = m;
    if (m && !_ && typeof m == "object") {
      if (De.endsWith(g, "{}"))
        g = r ? g : g.slice(0, -2), m = JSON.stringify(m);
      else if (De.isArray(m) && Wz(m) || (De.isFileList(m) || De.endsWith(g, "[]")) && (b = De.toArray(m)))
        return g = JI(g), b.forEach(function(S, E) {
          !(De.isUndefined(S) || S === null) && e.append(
            // eslint-disable-next-line no-nested-ternary
            i === !0 ? WD([g], E, s) : i === null ? g : g + "[]",
            a(S)
          );
        }), !1;
    }
    return sk(m) ? !0 : (e.append(WD(_, g, s), a(m)), !1);
  }
  const p = [], d = Object.assign(Vz, {
    defaultVisitor: c,
    convertValue: a,
    isVisitable: sk
  });
  function h(m, g) {
    if (!De.isUndefined(m)) {
      if (p.indexOf(m) !== -1)
        throw Error("Circular reference detected in " + g.join("."));
      p.push(m), De.forEach(m, function(b, x) {
        (!(De.isUndefined(b) || b === null) && o.call(
          e,
          b,
          De.isString(x) ? x.trim() : x,
          g,
          d
        )) === !0 && h(b, g ? g.concat(x) : [x]);
      }), p.pop();
    }
  }
  if (!De.isObject(t))
    throw new TypeError("data must be an object");
  return h(t), e;
}
function VD(t) {
  const e = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(t).replace(/[!'()~]|%20|%00/g, function(r) {
    return e[r];
  });
}
function _x(t, e) {
  this._pairs = [], t && Gv(t, this, e);
}
const e8 = _x.prototype;
e8.append = function(e, n) {
  this._pairs.push([e, n]);
};
e8.toString = function(e) {
  const n = e ? function(r) {
    return e.call(this, r, VD);
  } : VD;
  return this._pairs.map(function(o) {
    return n(o[0]) + "=" + n(o[1]);
  }, "").join("&");
};
function Hz(t) {
  return encodeURIComponent(t).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+");
}
function t8(t, e, n) {
  if (!e)
    return t;
  const r = n && n.encode || Hz;
  De.isFunction(n) && (n = {
    serialize: n
  });
  const o = n && n.serialize;
  let s;
  if (o ? s = o(e, n) : s = De.isURLSearchParams(e) ? e.toString() : new _x(e, n).toString(r), s) {
    const i = t.indexOf("#");
    i !== -1 && (t = t.slice(0, i)), t += (t.indexOf("?") === -1 ? "?" : "&") + s;
  }
  return t;
}
class HD {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(e, n, r) {
    return this.handlers.push({
      fulfilled: e,
      rejected: n,
      synchronous: r ? r.synchronous : !1,
      runWhen: r ? r.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(e) {
    this.handlers[e] && (this.handlers[e] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(e) {
    De.forEach(this.handlers, function(r) {
      r !== null && e(r);
    });
  }
}
const n8 = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
}, jz = typeof URLSearchParams < "u" ? URLSearchParams : _x, zz = typeof FormData < "u" ? FormData : null, qz = typeof Blob < "u" ? Blob : null, Gz = {
  isBrowser: !0,
  classes: {
    URLSearchParams: jz,
    FormData: zz,
    Blob: qz
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
}, wx = typeof window < "u" && typeof document < "u", ak = typeof navigator == "object" && navigator || void 0, Yz = wx && (!ak || ["ReactNative", "NativeScript", "NS"].indexOf(ak.product) < 0), Qz = typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function", Kz = wx && window.location.href || "http://localhost", Zz = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  hasBrowserEnv: wx,
  hasStandardBrowserEnv: Yz,
  hasStandardBrowserWebWorkerEnv: Qz,
  navigator: ak,
  origin: Kz
}, Symbol.toStringTag, { value: "Module" })), Fo = {
  ...Zz,
  ...Gz
};
function Jz(t, e) {
  return Gv(t, new Fo.classes.URLSearchParams(), {
    visitor: function(n, r, o, s) {
      return Fo.isNode && De.isBuffer(n) ? (this.append(r, n.toString("base64")), !1) : s.defaultVisitor.apply(this, arguments);
    },
    ...e
  });
}
function eq(t) {
  return De.matchAll(/\w+|\[(\w*)]/g, t).map((e) => e[0] === "[]" ? "" : e[1] || e[0]);
}
function tq(t) {
  const e = {}, n = Object.keys(t);
  let r;
  const o = n.length;
  let s;
  for (r = 0; r < o; r++)
    s = n[r], e[s] = t[s];
  return e;
}
function r8(t) {
  function e(n, r, o, s) {
    let i = n[s++];
    if (i === "__proto__") return !0;
    const u = Number.isFinite(+i), l = s >= n.length;
    return i = !i && De.isArray(o) ? o.length : i, l ? (De.hasOwnProp(o, i) ? o[i] = [o[i], r] : o[i] = r, !u) : ((!o[i] || !De.isObject(o[i])) && (o[i] = []), e(n, r, o[i], s) && De.isArray(o[i]) && (o[i] = tq(o[i])), !u);
  }
  if (De.isFormData(t) && De.isFunction(t.entries)) {
    const n = {};
    return De.forEachEntry(t, (r, o) => {
      e(eq(r), o, n, 0);
    }), n;
  }
  return null;
}
function nq(t, e, n) {
  if (De.isString(t))
    try {
      return (e || JSON.parse)(t), De.trim(t);
    } catch (r) {
      if (r.name !== "SyntaxError")
        throw r;
    }
  return (n || JSON.stringify)(t);
}
const Lm = {
  transitional: n8,
  adapter: ["xhr", "http", "fetch"],
  transformRequest: [function(e, n) {
    const r = n.getContentType() || "", o = r.indexOf("application/json") > -1, s = De.isObject(e);
    if (s && De.isHTMLForm(e) && (e = new FormData(e)), De.isFormData(e))
      return o ? JSON.stringify(r8(e)) : e;
    if (De.isArrayBuffer(e) || De.isBuffer(e) || De.isStream(e) || De.isFile(e) || De.isBlob(e) || De.isReadableStream(e))
      return e;
    if (De.isArrayBufferView(e))
      return e.buffer;
    if (De.isURLSearchParams(e))
      return n.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), e.toString();
    let u;
    if (s) {
      if (r.indexOf("application/x-www-form-urlencoded") > -1)
        return Jz(e, this.formSerializer).toString();
      if ((u = De.isFileList(e)) || r.indexOf("multipart/form-data") > -1) {
        const l = this.env && this.env.FormData;
        return Gv(
          u ? { "files[]": e } : e,
          l && new l(),
          this.formSerializer
        );
      }
    }
    return s || o ? (n.setContentType("application/json", !1), nq(e)) : e;
  }],
  transformResponse: [function(e) {
    const n = this.transitional || Lm.transitional, r = n && n.forcedJSONParsing, o = this.responseType === "json";
    if (De.isResponse(e) || De.isReadableStream(e))
      return e;
    if (e && De.isString(e) && (r && !this.responseType || o)) {
      const i = !(n && n.silentJSONParsing) && o;
      try {
        return JSON.parse(e, this.parseReviver);
      } catch (u) {
        if (i)
          throw u.name === "SyntaxError" ? Zt.from(u, Zt.ERR_BAD_RESPONSE, this, null, this.response) : u;
      }
    }
    return e;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: Fo.classes.FormData,
    Blob: Fo.classes.Blob
  },
  validateStatus: function(e) {
    return e >= 200 && e < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
De.forEach(["delete", "get", "head", "post", "put", "patch"], (t) => {
  Lm.headers[t] = {};
});
const rq = De.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), oq = (t) => {
  const e = {};
  let n, r, o;
  return t && t.split(`
`).forEach(function(i) {
    o = i.indexOf(":"), n = i.substring(0, o).trim().toLowerCase(), r = i.substring(o + 1).trim(), !(!n || e[n] && rq[n]) && (n === "set-cookie" ? e[n] ? e[n].push(r) : e[n] = [r] : e[n] = e[n] ? e[n] + ", " + r : r);
  }), e;
}, jD = Symbol("internals");
function cf(t) {
  return t && String(t).trim().toLowerCase();
}
function $g(t) {
  return t === !1 || t == null ? t : De.isArray(t) ? t.map($g) : String(t);
}
function sq(t) {
  const e = /* @__PURE__ */ Object.create(null), n = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let r;
  for (; r = n.exec(t); )
    e[r[1]] = r[2];
  return e;
}
const aq = (t) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(t.trim());
function y1(t, e, n, r, o) {
  if (De.isFunction(r))
    return r.call(this, e, n);
  if (o && (e = n), !!De.isString(e)) {
    if (De.isString(r))
      return e.indexOf(r) !== -1;
    if (De.isRegExp(r))
      return r.test(e);
  }
}
function iq(t) {
  return t.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (e, n, r) => n.toUpperCase() + r);
}
function uq(t, e) {
  const n = De.toCamelCase(" " + e);
  ["get", "set", "has"].forEach((r) => {
    Object.defineProperty(t, r + n, {
      value: function(o, s, i) {
        return this[r].call(this, e, o, s, i);
      },
      configurable: !0
    });
  });
}
let bs = class {
  constructor(e) {
    e && this.set(e);
  }
  set(e, n, r) {
    const o = this;
    function s(u, l, a) {
      const c = cf(l);
      if (!c)
        throw new Error("header name must be a non-empty string");
      const p = De.findKey(o, c);
      (!p || o[p] === void 0 || a === !0 || a === void 0 && o[p] !== !1) && (o[p || l] = $g(u));
    }
    const i = (u, l) => De.forEach(u, (a, c) => s(a, c, l));
    if (De.isPlainObject(e) || e instanceof this.constructor)
      i(e, n);
    else if (De.isString(e) && (e = e.trim()) && !aq(e))
      i(oq(e), n);
    else if (De.isObject(e) && De.isIterable(e)) {
      let u = {}, l, a;
      for (const c of e) {
        if (!De.isArray(c))
          throw TypeError("Object iterator must return a key-value pair");
        u[a = c[0]] = (l = u[a]) ? De.isArray(l) ? [...l, c[1]] : [l, c[1]] : c[1];
      }
      i(u, n);
    } else
      e != null && s(n, e, r);
    return this;
  }
  get(e, n) {
    if (e = cf(e), e) {
      const r = De.findKey(this, e);
      if (r) {
        const o = this[r];
        if (!n)
          return o;
        if (n === !0)
          return sq(o);
        if (De.isFunction(n))
          return n.call(this, o, r);
        if (De.isRegExp(n))
          return n.exec(o);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(e, n) {
    if (e = cf(e), e) {
      const r = De.findKey(this, e);
      return !!(r && this[r] !== void 0 && (!n || y1(this, this[r], r, n)));
    }
    return !1;
  }
  delete(e, n) {
    const r = this;
    let o = !1;
    function s(i) {
      if (i = cf(i), i) {
        const u = De.findKey(r, i);
        u && (!n || y1(r, r[u], u, n)) && (delete r[u], o = !0);
      }
    }
    return De.isArray(e) ? e.forEach(s) : s(e), o;
  }
  clear(e) {
    const n = Object.keys(this);
    let r = n.length, o = !1;
    for (; r--; ) {
      const s = n[r];
      (!e || y1(this, this[s], s, e, !0)) && (delete this[s], o = !0);
    }
    return o;
  }
  normalize(e) {
    const n = this, r = {};
    return De.forEach(this, (o, s) => {
      const i = De.findKey(r, s);
      if (i) {
        n[i] = $g(o), delete n[s];
        return;
      }
      const u = e ? iq(s) : String(s).trim();
      u !== s && delete n[s], n[u] = $g(o), r[u] = !0;
    }), this;
  }
  concat(...e) {
    return this.constructor.concat(this, ...e);
  }
  toJSON(e) {
    const n = /* @__PURE__ */ Object.create(null);
    return De.forEach(this, (r, o) => {
      r != null && r !== !1 && (n[o] = e && De.isArray(r) ? r.join(", ") : r);
    }), n;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([e, n]) => e + ": " + n).join(`
`);
  }
  getSetCookie() {
    return this.get("set-cookie") || [];
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(e) {
    return e instanceof this ? e : new this(e);
  }
  static concat(e, ...n) {
    const r = new this(e);
    return n.forEach((o) => r.set(o)), r;
  }
  static accessor(e) {
    const r = (this[jD] = this[jD] = {
      accessors: {}
    }).accessors, o = this.prototype;
    function s(i) {
      const u = cf(i);
      r[u] || (uq(o, i), r[u] = !0);
    }
    return De.isArray(e) ? e.forEach(s) : s(e), this;
  }
};
bs.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
De.reduceDescriptors(bs.prototype, ({ value: t }, e) => {
  let n = e[0].toUpperCase() + e.slice(1);
  return {
    get: () => t,
    set(r) {
      this[n] = r;
    }
  };
});
De.freezeMethods(bs);
function g1(t, e) {
  const n = this || Lm, r = e || n, o = bs.from(r.headers);
  let s = r.data;
  return De.forEach(t, function(u) {
    s = u.call(n, s, o.normalize(), e ? e.status : void 0);
  }), o.normalize(), s;
}
function o8(t) {
  return !!(t && t.__CANCEL__);
}
function Oh(t, e, n) {
  Zt.call(this, t ?? "canceled", Zt.ERR_CANCELED, e, n), this.name = "CanceledError";
}
De.inherits(Oh, Zt, {
  __CANCEL__: !0
});
function s8(t, e, n) {
  const r = n.config.validateStatus;
  !n.status || !r || r(n.status) ? t(n) : e(new Zt(
    "Request failed with status code " + n.status,
    [Zt.ERR_BAD_REQUEST, Zt.ERR_BAD_RESPONSE][Math.floor(n.status / 100) - 4],
    n.config,
    n.request,
    n
  ));
}
function lq(t) {
  const e = /^([-+\w]{1,25})(:?\/\/|:)/.exec(t);
  return e && e[1] || "";
}
function cq(t, e) {
  t = t || 10;
  const n = new Array(t), r = new Array(t);
  let o = 0, s = 0, i;
  return e = e !== void 0 ? e : 1e3, function(l) {
    const a = Date.now(), c = r[s];
    i || (i = a), n[o] = l, r[o] = a;
    let p = s, d = 0;
    for (; p !== o; )
      d += n[p++], p = p % t;
    if (o = (o + 1) % t, o === s && (s = (s + 1) % t), a - i < e)
      return;
    const h = c && a - c;
    return h ? Math.round(d * 1e3 / h) : void 0;
  };
}
function pq(t, e) {
  let n = 0, r = 1e3 / e, o, s;
  const i = (a, c = Date.now()) => {
    n = c, o = null, s && (clearTimeout(s), s = null), t(...a);
  };
  return [(...a) => {
    const c = Date.now(), p = c - n;
    p >= r ? i(a, c) : (o = a, s || (s = setTimeout(() => {
      s = null, i(o);
    }, r - p)));
  }, () => o && i(o)];
}
const k0 = (t, e, n = 3) => {
  let r = 0;
  const o = cq(50, 250);
  return pq((s) => {
    const i = s.loaded, u = s.lengthComputable ? s.total : void 0, l = i - r, a = o(l), c = i <= u;
    r = i;
    const p = {
      loaded: i,
      total: u,
      progress: u ? i / u : void 0,
      bytes: l,
      rate: a || void 0,
      estimated: a && u && c ? (u - i) / a : void 0,
      event: s,
      lengthComputable: u != null,
      [e ? "download" : "upload"]: !0
    };
    t(p);
  }, n);
}, zD = (t, e) => {
  const n = t != null;
  return [(r) => e[0]({
    lengthComputable: n,
    total: t,
    loaded: r
  }), e[1]];
}, qD = (t) => (...e) => De.asap(() => t(...e)), dq = Fo.hasStandardBrowserEnv ? /* @__PURE__ */ ((t, e) => (n) => (n = new URL(n, Fo.origin), t.protocol === n.protocol && t.host === n.host && (e || t.port === n.port)))(
  new URL(Fo.origin),
  Fo.navigator && /(msie|trident)/i.test(Fo.navigator.userAgent)
) : () => !0, hq = Fo.hasStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  {
    write(t, e, n, r, o, s) {
      const i = [t + "=" + encodeURIComponent(e)];
      De.isNumber(n) && i.push("expires=" + new Date(n).toGMTString()), De.isString(r) && i.push("path=" + r), De.isString(o) && i.push("domain=" + o), s === !0 && i.push("secure"), document.cookie = i.join("; ");
    },
    read(t) {
      const e = document.cookie.match(new RegExp("(^|;\\s*)(" + t + ")=([^;]*)"));
      return e ? decodeURIComponent(e[3]) : null;
    },
    remove(t) {
      this.write(t, "", Date.now() - 864e5);
    }
  }
) : (
  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {
    },
    read() {
      return null;
    },
    remove() {
    }
  }
);
function fq(t) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(t);
}
function mq(t, e) {
  return e ? t.replace(/\/?\/$/, "") + "/" + e.replace(/^\/+/, "") : t;
}
function a8(t, e, n) {
  let r = !fq(e);
  return t && (r || n == !1) ? mq(t, e) : e;
}
const GD = (t) => t instanceof bs ? { ...t } : t;
function Cp(t, e) {
  e = e || {};
  const n = {};
  function r(a, c, p, d) {
    return De.isPlainObject(a) && De.isPlainObject(c) ? De.merge.call({ caseless: d }, a, c) : De.isPlainObject(c) ? De.merge({}, c) : De.isArray(c) ? c.slice() : c;
  }
  function o(a, c, p, d) {
    if (De.isUndefined(c)) {
      if (!De.isUndefined(a))
        return r(void 0, a, p, d);
    } else return r(a, c, p, d);
  }
  function s(a, c) {
    if (!De.isUndefined(c))
      return r(void 0, c);
  }
  function i(a, c) {
    if (De.isUndefined(c)) {
      if (!De.isUndefined(a))
        return r(void 0, a);
    } else return r(void 0, c);
  }
  function u(a, c, p) {
    if (p in e)
      return r(a, c);
    if (p in t)
      return r(void 0, a);
  }
  const l = {
    url: s,
    method: s,
    data: s,
    baseURL: i,
    transformRequest: i,
    transformResponse: i,
    paramsSerializer: i,
    timeout: i,
    timeoutMessage: i,
    withCredentials: i,
    withXSRFToken: i,
    adapter: i,
    responseType: i,
    xsrfCookieName: i,
    xsrfHeaderName: i,
    onUploadProgress: i,
    onDownloadProgress: i,
    decompress: i,
    maxContentLength: i,
    maxBodyLength: i,
    beforeRedirect: i,
    transport: i,
    httpAgent: i,
    httpsAgent: i,
    cancelToken: i,
    socketPath: i,
    responseEncoding: i,
    validateStatus: u,
    headers: (a, c, p) => o(GD(a), GD(c), p, !0)
  };
  return De.forEach(Object.keys({ ...t, ...e }), function(c) {
    const p = l[c] || o, d = p(t[c], e[c], c);
    De.isUndefined(d) && p !== u || (n[c] = d);
  }), n;
}
const i8 = (t) => {
  const e = Cp({}, t);
  let { data: n, withXSRFToken: r, xsrfHeaderName: o, xsrfCookieName: s, headers: i, auth: u } = e;
  if (e.headers = i = bs.from(i), e.url = t8(a8(e.baseURL, e.url, e.allowAbsoluteUrls), t.params, t.paramsSerializer), u && i.set(
    "Authorization",
    "Basic " + btoa((u.username || "") + ":" + (u.password ? unescape(encodeURIComponent(u.password)) : ""))
  ), De.isFormData(n)) {
    if (Fo.hasStandardBrowserEnv || Fo.hasStandardBrowserWebWorkerEnv)
      i.setContentType(void 0);
    else if (De.isFunction(n.getHeaders)) {
      const l = n.getHeaders(), a = ["content-type", "content-length"];
      Object.entries(l).forEach(([c, p]) => {
        a.includes(c.toLowerCase()) && i.set(c, p);
      });
    }
  }
  if (Fo.hasStandardBrowserEnv && (r && De.isFunction(r) && (r = r(e)), r || r !== !1 && dq(e.url))) {
    const l = o && s && hq.read(s);
    l && i.set(o, l);
  }
  return e;
}, yq = typeof XMLHttpRequest < "u", gq = yq && function(t) {
  return new Promise(function(n, r) {
    const o = i8(t);
    let s = o.data;
    const i = bs.from(o.headers).normalize();
    let { responseType: u, onUploadProgress: l, onDownloadProgress: a } = o, c, p, d, h, m;
    function g() {
      h && h(), m && m(), o.cancelToken && o.cancelToken.unsubscribe(c), o.signal && o.signal.removeEventListener("abort", c);
    }
    let _ = new XMLHttpRequest();
    _.open(o.method.toUpperCase(), o.url, !0), _.timeout = o.timeout;
    function b() {
      if (!_)
        return;
      const S = bs.from(
        "getAllResponseHeaders" in _ && _.getAllResponseHeaders()
      ), A = {
        data: !u || u === "text" || u === "json" ? _.responseText : _.response,
        status: _.status,
        statusText: _.statusText,
        headers: S,
        config: t,
        request: _
      };
      s8(function(M) {
        n(M), g();
      }, function(M) {
        r(M), g();
      }, A), _ = null;
    }
    "onloadend" in _ ? _.onloadend = b : _.onreadystatechange = function() {
      !_ || _.readyState !== 4 || _.status === 0 && !(_.responseURL && _.responseURL.indexOf("file:") === 0) || setTimeout(b);
    }, _.onabort = function() {
      _ && (r(new Zt("Request aborted", Zt.ECONNABORTED, t, _)), _ = null);
    }, _.onerror = function(E) {
      const A = E && E.message ? E.message : "Network Error", C = new Zt(A, Zt.ERR_NETWORK, t, _);
      C.event = E || null, r(C), _ = null;
    }, _.ontimeout = function() {
      let E = o.timeout ? "timeout of " + o.timeout + "ms exceeded" : "timeout exceeded";
      const A = o.transitional || n8;
      o.timeoutErrorMessage && (E = o.timeoutErrorMessage), r(new Zt(
        E,
        A.clarifyTimeoutError ? Zt.ETIMEDOUT : Zt.ECONNABORTED,
        t,
        _
      )), _ = null;
    }, s === void 0 && i.setContentType(null), "setRequestHeader" in _ && De.forEach(i.toJSON(), function(E, A) {
      _.setRequestHeader(A, E);
    }), De.isUndefined(o.withCredentials) || (_.withCredentials = !!o.withCredentials), u && u !== "json" && (_.responseType = o.responseType), a && ([d, m] = k0(a, !0), _.addEventListener("progress", d)), l && _.upload && ([p, h] = k0(l), _.upload.addEventListener("progress", p), _.upload.addEventListener("loadend", h)), (o.cancelToken || o.signal) && (c = (S) => {
      _ && (r(!S || S.type ? new Oh(null, t, _) : S), _.abort(), _ = null);
    }, o.cancelToken && o.cancelToken.subscribe(c), o.signal && (o.signal.aborted ? c() : o.signal.addEventListener("abort", c)));
    const x = lq(o.url);
    if (x && Fo.protocols.indexOf(x) === -1) {
      r(new Zt("Unsupported protocol " + x + ":", Zt.ERR_BAD_REQUEST, t));
      return;
    }
    _.send(s || null);
  });
}, vq = (t, e) => {
  const { length: n } = t = t ? t.filter(Boolean) : [];
  if (e || n) {
    let r = new AbortController(), o;
    const s = function(a) {
      if (!o) {
        o = !0, u();
        const c = a instanceof Error ? a : this.reason;
        r.abort(c instanceof Zt ? c : new Oh(c instanceof Error ? c.message : c));
      }
    };
    let i = e && setTimeout(() => {
      i = null, s(new Zt(`timeout ${e} of ms exceeded`, Zt.ETIMEDOUT));
    }, e);
    const u = () => {
      t && (i && clearTimeout(i), i = null, t.forEach((a) => {
        a.unsubscribe ? a.unsubscribe(s) : a.removeEventListener("abort", s);
      }), t = null);
    };
    t.forEach((a) => a.addEventListener("abort", s));
    const { signal: l } = r;
    return l.unsubscribe = () => De.asap(u), l;
  }
}, _q = function* (t, e) {
  let n = t.byteLength;
  if (n < e) {
    yield t;
    return;
  }
  let r = 0, o;
  for (; r < n; )
    o = r + e, yield t.slice(r, o), r = o;
}, wq = async function* (t, e) {
  for await (const n of bq(t))
    yield* _q(n, e);
}, bq = async function* (t) {
  if (t[Symbol.asyncIterator]) {
    yield* t;
    return;
  }
  const e = t.getReader();
  try {
    for (; ; ) {
      const { done: n, value: r } = await e.read();
      if (n)
        break;
      yield r;
    }
  } finally {
    await e.cancel();
  }
}, YD = (t, e, n, r) => {
  const o = wq(t, e);
  let s = 0, i, u = (l) => {
    i || (i = !0, r && r(l));
  };
  return new ReadableStream({
    async pull(l) {
      try {
        const { done: a, value: c } = await o.next();
        if (a) {
          u(), l.close();
          return;
        }
        let p = c.byteLength;
        if (n) {
          let d = s += p;
          n(d);
        }
        l.enqueue(new Uint8Array(c));
      } catch (a) {
        throw u(a), a;
      }
    },
    cancel(l) {
      return u(l), o.return();
    }
  }, {
    highWaterMark: 2
  });
}, QD = 64 * 1024, { isFunction: og } = De, kq = (({ Request: t, Response: e }) => ({
  Request: t,
  Response: e
}))(De.global), {
  ReadableStream: KD,
  TextEncoder: ZD
} = De.global, JD = (t, ...e) => {
  try {
    return !!t(...e);
  } catch {
    return !1;
  }
}, Tq = (t) => {
  t = De.merge.call({
    skipUndefined: !0
  }, kq, t);
  const { fetch: e, Request: n, Response: r } = t, o = e ? og(e) : typeof fetch == "function", s = og(n), i = og(r);
  if (!o)
    return !1;
  const u = o && og(KD), l = o && (typeof ZD == "function" ? /* @__PURE__ */ ((m) => (g) => m.encode(g))(new ZD()) : async (m) => new Uint8Array(await new n(m).arrayBuffer())), a = s && u && JD(() => {
    let m = !1;
    const g = new n(Fo.origin, {
      body: new KD(),
      method: "POST",
      get duplex() {
        return m = !0, "half";
      }
    }).headers.has("Content-Type");
    return m && !g;
  }), c = i && u && JD(() => De.isReadableStream(new r("").body)), p = {
    stream: c && ((m) => m.body)
  };
  o && ["text", "arrayBuffer", "blob", "formData", "stream"].forEach((m) => {
    !p[m] && (p[m] = (g, _) => {
      let b = g && g[m];
      if (b)
        return b.call(g);
      throw new Zt(`Response type '${m}' is not supported`, Zt.ERR_NOT_SUPPORT, _);
    });
  });
  const d = async (m) => {
    if (m == null)
      return 0;
    if (De.isBlob(m))
      return m.size;
    if (De.isSpecCompliantForm(m))
      return (await new n(Fo.origin, {
        method: "POST",
        body: m
      }).arrayBuffer()).byteLength;
    if (De.isArrayBufferView(m) || De.isArrayBuffer(m))
      return m.byteLength;
    if (De.isURLSearchParams(m) && (m = m + ""), De.isString(m))
      return (await l(m)).byteLength;
  }, h = async (m, g) => {
    const _ = De.toFiniteNumber(m.getContentLength());
    return _ ?? d(g);
  };
  return async (m) => {
    let {
      url: g,
      method: _,
      data: b,
      signal: x,
      cancelToken: S,
      timeout: E,
      onDownloadProgress: A,
      onUploadProgress: C,
      responseType: M,
      headers: L,
      withCredentials: X = "same-origin",
      fetchOptions: te
    } = i8(m), B = e || fetch;
    M = M ? (M + "").toLowerCase() : "text";
    let W = vq([x, S && S.toAbortSignal()], E), G = null;
    const ne = W && W.unsubscribe && (() => {
      W.unsubscribe();
    });
    let de;
    try {
      if (C && a && _ !== "get" && _ !== "head" && (de = await h(L, b)) !== 0) {
        let J = new n(g, {
          method: "POST",
          body: b,
          duplex: "half"
        }), oe;
        if (De.isFormData(b) && (oe = J.headers.get("content-type")) && L.setContentType(oe), J.body) {
          const [ue, me] = zD(
            de,
            k0(qD(C))
          );
          b = YD(J.body, QD, ue, me);
        }
      }
      De.isString(X) || (X = X ? "include" : "omit");
      const V = s && "credentials" in n.prototype, Y = {
        ...te,
        signal: W,
        method: _.toUpperCase(),
        headers: L.normalize().toJSON(),
        body: b,
        duplex: "half",
        credentials: V ? X : void 0
      };
      G = s && new n(g, Y);
      let Q = await (s ? B(G, te) : B(g, Y));
      const ae = c && (M === "stream" || M === "response");
      if (c && (A || ae && ne)) {
        const J = {};
        ["status", "statusText", "headers"].forEach((pe) => {
          J[pe] = Q[pe];
        });
        const oe = De.toFiniteNumber(Q.headers.get("content-length")), [ue, me] = A && zD(
          oe,
          k0(qD(A), !0)
        ) || [];
        Q = new r(
          YD(Q.body, QD, ue, () => {
            me && me(), ne && ne();
          }),
          J
        );
      }
      M = M || "text";
      let Z = await p[De.findKey(p, M) || "text"](Q, m);
      return !ae && ne && ne(), await new Promise((J, oe) => {
        s8(J, oe, {
          data: Z,
          headers: bs.from(Q.headers),
          status: Q.status,
          statusText: Q.statusText,
          config: m,
          request: G
        });
      });
    } catch (V) {
      throw ne && ne(), V && V.name === "TypeError" && /Load failed|fetch/i.test(V.message) ? Object.assign(
        new Zt("Network Error", Zt.ERR_NETWORK, m, G),
        {
          cause: V.cause || V
        }
      ) : Zt.from(V, V && V.code, m, G);
    }
  };
}, xq = /* @__PURE__ */ new Map(), u8 = (t) => {
  let e = t ? t.env : {};
  const { fetch: n, Request: r, Response: o } = e, s = [
    r,
    o,
    n
  ];
  let i = s.length, u = i, l, a, c = xq;
  for (; u--; )
    l = s[u], a = c.get(l), a === void 0 && c.set(l, a = u ? /* @__PURE__ */ new Map() : Tq(e)), c = a;
  return a;
};
u8();
const ik = {
  http: $z,
  xhr: gq,
  fetch: {
    get: u8
  }
};
De.forEach(ik, (t, e) => {
  if (t) {
    try {
      Object.defineProperty(t, "name", { value: e });
    } catch {
    }
    Object.defineProperty(t, "adapterName", { value: e });
  }
});
const eE = (t) => `- ${t}`, Sq = (t) => De.isFunction(t) || t === null || t === !1, l8 = {
  getAdapter: (t, e) => {
    t = De.isArray(t) ? t : [t];
    const { length: n } = t;
    let r, o;
    const s = {};
    for (let i = 0; i < n; i++) {
      r = t[i];
      let u;
      if (o = r, !Sq(r) && (o = ik[(u = String(r)).toLowerCase()], o === void 0))
        throw new Zt(`Unknown adapter '${u}'`);
      if (o && (De.isFunction(o) || (o = o.get(e))))
        break;
      s[u || "#" + i] = o;
    }
    if (!o) {
      const i = Object.entries(s).map(
        ([l, a]) => `adapter ${l} ` + (a === !1 ? "is not supported by the environment" : "is not available in the build")
      );
      let u = n ? i.length > 1 ? `since :
` + i.map(eE).join(`
`) : " " + eE(i[0]) : "as no adapter specified";
      throw new Zt(
        "There is no suitable adapter to dispatch the request " + u,
        "ERR_NOT_SUPPORT"
      );
    }
    return o;
  },
  adapters: ik
};
function v1(t) {
  if (t.cancelToken && t.cancelToken.throwIfRequested(), t.signal && t.signal.aborted)
    throw new Oh(null, t);
}
function tE(t) {
  return v1(t), t.headers = bs.from(t.headers), t.data = g1.call(
    t,
    t.transformRequest
  ), ["post", "put", "patch"].indexOf(t.method) !== -1 && t.headers.setContentType("application/x-www-form-urlencoded", !1), l8.getAdapter(t.adapter || Lm.adapter, t)(t).then(function(r) {
    return v1(t), r.data = g1.call(
      t,
      t.transformResponse,
      r
    ), r.headers = bs.from(r.headers), r;
  }, function(r) {
    return o8(r) || (v1(t), r && r.response && (r.response.data = g1.call(
      t,
      t.transformResponse,
      r.response
    ), r.response.headers = bs.from(r.response.headers))), Promise.reject(r);
  });
}
const c8 = "1.12.2", Yv = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((t, e) => {
  Yv[t] = function(r) {
    return typeof r === t || "a" + (e < 1 ? "n " : " ") + t;
  };
});
const nE = {};
Yv.transitional = function(e, n, r) {
  function o(s, i) {
    return "[Axios v" + c8 + "] Transitional option '" + s + "'" + i + (r ? ". " + r : "");
  }
  return (s, i, u) => {
    if (e === !1)
      throw new Zt(
        o(i, " has been removed" + (n ? " in " + n : "")),
        Zt.ERR_DEPRECATED
      );
    return n && !nE[i] && (nE[i] = !0, console.warn(
      o(
        i,
        " has been deprecated since v" + n + " and will be removed in the near future"
      )
    )), e ? e(s, i, u) : !0;
  };
};
Yv.spelling = function(e) {
  return (n, r) => (console.warn(`${r} is likely a misspelling of ${e}`), !0);
};
function Rq(t, e, n) {
  if (typeof t != "object")
    throw new Zt("options must be an object", Zt.ERR_BAD_OPTION_VALUE);
  const r = Object.keys(t);
  let o = r.length;
  for (; o-- > 0; ) {
    const s = r[o], i = e[s];
    if (i) {
      const u = t[s], l = u === void 0 || i(u, s, t);
      if (l !== !0)
        throw new Zt("option " + s + " must be " + l, Zt.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (n !== !0)
      throw new Zt("Unknown option " + s, Zt.ERR_BAD_OPTION);
  }
}
const Wg = {
  assertOptions: Rq,
  validators: Yv
}, Xi = Wg.validators;
let vp = class {
  constructor(e) {
    this.defaults = e || {}, this.interceptors = {
      request: new HD(),
      response: new HD()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(e, n) {
    try {
      return await this._request(e, n);
    } catch (r) {
      if (r instanceof Error) {
        let o = {};
        Error.captureStackTrace ? Error.captureStackTrace(o) : o = new Error();
        const s = o.stack ? o.stack.replace(/^.+\n/, "") : "";
        try {
          r.stack ? s && !String(r.stack).endsWith(s.replace(/^.+\n.+\n/, "")) && (r.stack += `
` + s) : r.stack = s;
        } catch {
        }
      }
      throw r;
    }
  }
  _request(e, n) {
    typeof e == "string" ? (n = n || {}, n.url = e) : n = e || {}, n = Cp(this.defaults, n);
    const { transitional: r, paramsSerializer: o, headers: s } = n;
    r !== void 0 && Wg.assertOptions(r, {
      silentJSONParsing: Xi.transitional(Xi.boolean),
      forcedJSONParsing: Xi.transitional(Xi.boolean),
      clarifyTimeoutError: Xi.transitional(Xi.boolean)
    }, !1), o != null && (De.isFunction(o) ? n.paramsSerializer = {
      serialize: o
    } : Wg.assertOptions(o, {
      encode: Xi.function,
      serialize: Xi.function
    }, !0)), n.allowAbsoluteUrls !== void 0 || (this.defaults.allowAbsoluteUrls !== void 0 ? n.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls : n.allowAbsoluteUrls = !0), Wg.assertOptions(n, {
      baseUrl: Xi.spelling("baseURL"),
      withXsrfToken: Xi.spelling("withXSRFToken")
    }, !0), n.method = (n.method || this.defaults.method || "get").toLowerCase();
    let i = s && De.merge(
      s.common,
      s[n.method]
    );
    s && De.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      (m) => {
        delete s[m];
      }
    ), n.headers = bs.concat(i, s);
    const u = [];
    let l = !0;
    this.interceptors.request.forEach(function(g) {
      typeof g.runWhen == "function" && g.runWhen(n) === !1 || (l = l && g.synchronous, u.unshift(g.fulfilled, g.rejected));
    });
    const a = [];
    this.interceptors.response.forEach(function(g) {
      a.push(g.fulfilled, g.rejected);
    });
    let c, p = 0, d;
    if (!l) {
      const m = [tE.bind(this), void 0];
      for (m.unshift(...u), m.push(...a), d = m.length, c = Promise.resolve(n); p < d; )
        c = c.then(m[p++], m[p++]);
      return c;
    }
    d = u.length;
    let h = n;
    for (; p < d; ) {
      const m = u[p++], g = u[p++];
      try {
        h = m(h);
      } catch (_) {
        g.call(this, _);
        break;
      }
    }
    try {
      c = tE.call(this, h);
    } catch (m) {
      return Promise.reject(m);
    }
    for (p = 0, d = a.length; p < d; )
      c = c.then(a[p++], a[p++]);
    return c;
  }
  getUri(e) {
    e = Cp(this.defaults, e);
    const n = a8(e.baseURL, e.url, e.allowAbsoluteUrls);
    return t8(n, e.params, e.paramsSerializer);
  }
};
De.forEach(["delete", "get", "head", "options"], function(e) {
  vp.prototype[e] = function(n, r) {
    return this.request(Cp(r || {}, {
      method: e,
      url: n,
      data: (r || {}).data
    }));
  };
});
De.forEach(["post", "put", "patch"], function(e) {
  function n(r) {
    return function(s, i, u) {
      return this.request(Cp(u || {}, {
        method: e,
        headers: r ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: s,
        data: i
      }));
    };
  }
  vp.prototype[e] = n(), vp.prototype[e + "Form"] = n(!0);
});
let Aq = class p8 {
  constructor(e) {
    if (typeof e != "function")
      throw new TypeError("executor must be a function.");
    let n;
    this.promise = new Promise(function(s) {
      n = s;
    });
    const r = this;
    this.promise.then((o) => {
      if (!r._listeners) return;
      let s = r._listeners.length;
      for (; s-- > 0; )
        r._listeners[s](o);
      r._listeners = null;
    }), this.promise.then = (o) => {
      let s;
      const i = new Promise((u) => {
        r.subscribe(u), s = u;
      }).then(o);
      return i.cancel = function() {
        r.unsubscribe(s);
      }, i;
    }, e(function(s, i, u) {
      r.reason || (r.reason = new Oh(s, i, u), n(r.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(e) {
    if (this.reason) {
      e(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(e) : this._listeners = [e];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(e) {
    if (!this._listeners)
      return;
    const n = this._listeners.indexOf(e);
    n !== -1 && this._listeners.splice(n, 1);
  }
  toAbortSignal() {
    const e = new AbortController(), n = (r) => {
      e.abort(r);
    };
    return this.subscribe(n), e.signal.unsubscribe = () => this.unsubscribe(n), e.signal;
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let e;
    return {
      token: new p8(function(o) {
        e = o;
      }),
      cancel: e
    };
  }
};
function Dq(t) {
  return function(n) {
    return t.apply(null, n);
  };
}
function Eq(t) {
  return De.isObject(t) && t.isAxiosError === !0;
}
const uk = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511
};
Object.entries(uk).forEach(([t, e]) => {
  uk[e] = t;
});
function d8(t) {
  const e = new vp(t), n = VI(vp.prototype.request, e);
  return De.extend(n, vp.prototype, e, { allOwnKeys: !0 }), De.extend(n, e, null, { allOwnKeys: !0 }), n.create = function(o) {
    return d8(Cp(t, o));
  }, n;
}
const Ur = d8(Lm);
Ur.Axios = vp;
Ur.CanceledError = Oh;
Ur.CancelToken = Aq;
Ur.isCancel = o8;
Ur.VERSION = c8;
Ur.toFormData = Gv;
Ur.AxiosError = Zt;
Ur.Cancel = Ur.CanceledError;
Ur.all = function(e) {
  return Promise.all(e);
};
Ur.spread = Dq;
Ur.isAxiosError = Eq;
Ur.mergeConfig = Cp;
Ur.AxiosHeaders = bs;
Ur.formToJSON = (t) => r8(De.isHTMLForm(t) ? new FormData(t) : t);
Ur.getAdapter = l8.getAdapter;
Ur.HttpStatusCode = uk;
Ur.default = Ur;
const {
  Axios: b4e,
  AxiosError: k4e,
  CanceledError: T4e,
  isCancel: x4e,
  CancelToken: S4e,
  VERSION: R4e,
  all: A4e,
  Cancel: D4e,
  isAxiosError: bx,
  spread: E4e,
  toFormData: M4e,
  AxiosHeaders: P4e,
  HttpStatusCode: C4e,
  formToJSON: O4e,
  getAdapter: I4e,
  mergeConfig: F4e
} = Ur;
function h8(t, e) {
  return JSON.stringify(t) === JSON.stringify(e);
}
function Gt(t) {
  return t == null;
}
function f8(t) {
  return t === null;
}
function Mq(t) {
  return t != null;
}
function Qv(t) {
  return t !== void 0;
}
const Pq = (t) => t.baseUrl, Cq = { "X-PREFECT-UI": !0 }, Oq = (t) => {
  const e = {};
  return t.token && (e.Authorization = `bearer ${t.token}`), e;
};
class kx {
  apiConfig;
  apiHeaders = [Cq, Oq];
  apiBaseUrl = Pq;
  routePrefix;
  instanceSetupHook;
  constructor(e, n = null) {
    this.apiConfig = e, this.instanceSetupHook = n;
  }
  getConfig() {
    return typeof this.apiConfig == "function" ? this.apiConfig() : this.apiConfig;
  }
  composeBaseUrl() {
    return typeof this.apiBaseUrl == "string" ? this.apiBaseUrl : this.apiBaseUrl(this.getConfig());
  }
  composeHeaders() {
    return Sa(this.apiHeaders).reduce((n, r) => {
      const o = typeof r == "function" ? r(this.getConfig()) : r;
      return {
        ...n,
        ...o
      };
    }, {});
  }
  combinePath(e) {
    const n = /(\/+)/g;
    return [this.routePrefix, e].filter(Qv).join("/").replace(n, "/");
  }
  instance() {
    const e = {
      baseURL: this.composeBaseUrl(),
      headers: this.composeHeaders()
    }, n = Ur.create(e);
    return this.instanceSetupHook && this.instanceSetupHook(n), n;
  }
  get(e, n) {
    const r = this.combinePath(e);
    return this.instance().get(r, n);
  }
  delete(e, n) {
    const r = this.combinePath(e);
    return this.instance().delete(r, n);
  }
  head(e, n) {
    const r = this.combinePath(e);
    return this.instance().head(r, n);
  }
  options(e, n) {
    const r = this.combinePath(e);
    return this.instance().options(r, n);
  }
  // axios uses any for the data argument
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  post(e, n, r) {
    const o = this.combinePath(e);
    return this.instance().post(o, n, r);
  }
  // axios uses any for the data argument
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  put(e, n, r) {
    const o = this.combinePath(e);
    return this.instance().put(o, n, r);
  }
  // axios uses any for the data argument
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  patch(e, n, r) {
    const o = this.combinePath(e);
    return this.instance().patch(o, n, r);
  }
}
class m8 extends Error {
  constructor(e) {
    super(`Batch lookup failed for id: ${JSON.stringify(e)}`);
  }
}
class hi {
  callback;
  options;
  queue = /* @__PURE__ */ new Map();
  timeout = void 0;
  waitingSince = null;
  constructor(e, n = {}) {
    this.callback = e, this.options = n;
  }
  batch(e) {
    if (this.queue.has(e)) {
      const { response: s } = this.queue.get(e);
      return s;
    }
    let n, r;
    const o = new Promise((...s) => {
      [n, r] = s;
    });
    return this.queue.set(e, {
      response: o,
      resolve: n,
      reject: r
    }), this.requestProcessQueue(), o;
  }
  process() {
    this.processQueue();
  }
  requestProcessQueue() {
    if (this.shouldProcessNow()) {
      this.processQueue();
      return;
    }
    this.waitToProcessQueue();
  }
  waitToProcessQueue() {
    this.waitingSince === null && (this.waitingSince = Date.now()), clearTimeout(this.timeout), this.timeout = setTimeout(() => this.processQueue());
  }
  shouldProcessNow() {
    return this.maxBatchSizeReached() || this.maxWaitReached();
  }
  maxBatchSizeReached() {
    const { maxBatchSize: e = 1 / 0 } = this.options;
    return this.queue.size >= e;
  }
  maxWaitReached() {
    const { maxWaitMilliseconds: e = 1 / 0 } = this.options, n = Date.now(), r = this.waitingSince ?? 0;
    return n - r >= e;
  }
  getBatchToProcess() {
    const e = new Map(this.queue);
    return this.queue.clear(), this.waitingSince = null, clearTimeout(this.timeout), e;
  }
  async processQueue() {
    const e = this.getBatchToProcess(), n = Array.from(e.keys());
    try {
      const r = await this.callback(n);
      return this.isBatchCallbackLookup(r) ? this.resolveBatchUsingLookup(e, r) : this.resolveBatchUsingMap(e, r);
    } catch (r) {
      this.rejectBatch(e, r);
    }
  }
  resolveBatchUsingMap(e, n) {
    e.forEach(({ resolve: r, reject: o }, s) => {
      const i = n.get(s);
      if (i === void 0) {
        o(new m8(s));
        return;
      }
      r(i);
    });
  }
  resolveBatchUsingLookup(e, n) {
    e.forEach(async ({ resolve: r }, o) => {
      r(await n(o));
    });
  }
  rejectBatch(e, n) {
    e.forEach(({ reject: r }) => r(n));
  }
  isBatchCallbackLookup(e) {
    return typeof e == "function";
  }
}
const N4e = ["access:deploymentScheduleFlowRunInfraOverrides"], Iq = [
  "create:artifact",
  "create:automation",
  "create:block",
  "create:concurrency_limit",
  "create:deployment",
  "create:flow_run",
  "create:flow",
  "create:log",
  "create:notification_policy",
  "create:saved_search",
  "create:task_run",
  "create:variable",
  "create:work_queue",
  "create:work_pool",
  "create:workspace_bot_access",
  "create:workspace_user_access",
  "delete:artifact",
  "delete:automation",
  "delete:block",
  "delete:concurrency_limit",
  "delete:deployment",
  "delete:flow_run",
  "delete:flow",
  "delete:notification_policy",
  "delete:saved_search",
  "delete:task_run",
  "delete:work_queue",
  "delete:work_pool",
  "delete:worker",
  "delete:workspace_bot_access",
  "delete:workspace_user_access",
  "delete:variable",
  "read:artifact",
  "read:automation",
  "read:block",
  "read:concurrency_limit",
  "read:deployment",
  "read:flow_run",
  "read:flow",
  "read:log",
  "read:notification_policy",
  "read:saved_search",
  "read:task_run",
  "read:variable",
  "read:work_queue",
  "read:work_pool",
  "read:worker",
  "read:workspace_bot_access",
  "read:workspace_settings",
  "read:workspace_user_access",
  "run:deployment",
  "update:automation",
  "update:block",
  "update:concurrency_limit",
  "update:deployment",
  "update:flow_run",
  "update:flow",
  "update:notification_policy",
  "update:task_run",
  "update:variable",
  "update:work_queue",
  "update:work_pool",
  "update:workspace_bot_access",
  "update:workspace_settings",
  "update:workspace_user_access",
  "update:workspace"
];
function L4e(t) {
  const e = ge(t);
  return new Proxy({}, {
    get(n, r) {
      return new Proxy({}, {
        get(o, s) {
          return e.value.includes(`${r.toString()}:${s.toString()}`);
        }
      });
    }
  });
}
const Fq = Symbol("canInjectionKey"), Nq = function(t) {
  switch (t.type) {
    case "run-deployment":
      return Uq(t);
    case "pause-deployment":
    case "resume-deployment":
      return $q(t);
    case "pause-work-queue":
    case "resume-work-queue":
      return Vq(t);
    case "pause-work-pool":
    case "resume-work-pool":
      return jq(t);
    case "pause-automation":
    case "resume-automation":
      return qq(t);
    case "send-notification":
      return Yq(t);
    case "cancel-flow-run":
    case "suspend-flow-run":
    case "resume-flow-run":
    case "change-flow-run-state":
    case "do-nothing":
      return t;
    default:
      const e = t;
      throw new Error(`Automation action type is missing case for: ${e.type}`);
  }
}, Lq = function(t) {
  switch (t.type) {
    case "run-deployment":
      return Bq(t);
    case "pause-deployment":
    case "resume-deployment":
      return Xq(t);
    case "pause-work-queue":
    case "resume-work-queue":
      return Wq(t);
    case "pause-work-pool":
    case "resume-work-pool":
      return Hq(t);
    case "pause-automation":
    case "resume-automation":
      return zq(t);
    case "send-notification":
      return Gq(t);
    case "cancel-flow-run":
    case "suspend-flow-run":
    case "change-flow-run-state":
    case "resume-flow-run":
    case "do-nothing":
      return t;
    default:
      const e = t;
      throw new Error(`Automation action type is missing case for: ${e.type}`);
  }
};
function Bq(t) {
  return t.deploymentId ? {
    type: t.type,
    source: "selected",
    parameters: t.parameters,
    deployment_id: t.deploymentId,
    job_variables: t.jobVariables
  } : {
    type: t.type,
    source: "inferred"
  };
}
function Uq(t) {
  return t.source === "inferred" ? {
    type: t.type,
    deploymentId: null,
    parameters: null,
    jobVariables: void 0
  } : {
    type: t.type,
    parameters: t.parameters,
    deploymentId: t.deployment_id,
    jobVariables: t.job_variables ?? {}
  };
}
function Xq(t) {
  return t.deploymentId ? {
    type: t.type,
    source: "selected",
    deployment_id: t.deploymentId
  } : {
    type: t.type,
    source: "inferred"
  };
}
function $q(t) {
  return t.source === "inferred" ? {
    type: t.type,
    deploymentId: null
  } : {
    type: t.type,
    deploymentId: t.deployment_id
  };
}
function Wq(t) {
  return t.workQueueId ? {
    type: t.type,
    source: "selected",
    work_queue_id: t.workQueueId
  } : {
    type: t.type,
    source: "inferred"
  };
}
function Vq(t) {
  return t.source === "inferred" ? {
    type: t.type,
    workQueueId: null
  } : {
    type: t.type,
    workQueueId: t.work_queue_id
  };
}
function Hq(t) {
  return t.workPoolId ? {
    type: t.type,
    source: "selected",
    work_pool_id: t.workPoolId
  } : {
    type: t.type,
    source: "inferred"
  };
}
function jq(t) {
  return t.source === "inferred" ? {
    type: t.type,
    workPoolId: null
  } : {
    type: t.type,
    workPoolId: t.work_pool_id
  };
}
function zq(t) {
  return t.automationId ? {
    type: t.type,
    source: "selected",
    automation_id: t.automationId
  } : {
    type: t.type,
    source: "inferred"
  };
}
function qq(t) {
  return t.source === "inferred" ? {
    type: t.type,
    automationId: null
  } : {
    type: t.type,
    automationId: t.automation_id
  };
}
function Gq({ type: t, blockDocumentId: e, subject: n, body: r }) {
  return {
    type: t,
    block_document_id: e,
    subject: n,
    body: r
  };
}
function Yq({ type: t, block_document_id: e, subject: n, body: r }) {
  return {
    type: t,
    blockDocumentId: e,
    subject: n,
    body: r
  };
}
function to(t) {
  const e = new Set(t);
  function n(r) {
    return e.has(r);
  }
  return {
    values: t,
    isValue: n
  };
}
const { values: oh, isValue: B4e } = to([
  "completed",
  "running",
  "scheduled",
  "pending",
  "failed",
  "cancelled",
  "cancelling",
  "crashed",
  "paused"
]);
function y8(t) {
  return typeof t == "string" && oh.includes(t.toLowerCase());
}
const Qq = ["scheduled", "pending"];
function Kq(t) {
  return typeof t == "string" && Qq.includes(t);
}
const g8 = [
  "completed",
  "cancelled",
  "failed",
  "crashed"
];
function fi(t) {
  return typeof t == "string" && g8.includes(t);
}
const v8 = ["running", "scheduled", "pending", "paused"];
function _8(t) {
  return v8.includes(t);
}
function w8(t) {
  return typeof t == "string" && t === "paused";
}
function b8(t) {
  return typeof t == "string" && t === "running";
}
class Zq extends kx {
  routePrefix = "/health";
  getHealth() {
    return this.get().then(({ data: e }) => e);
  }
  async isHealthy() {
    try {
      return await this.getHealth();
    } catch {
      return !1;
    }
  }
}
class Jq extends Error {
  constructor() {
    super("Cannot call workspace routes without providing AccountId and WorkspaceId in api configuration.");
  }
}
function eG(t) {
  return "accountId" in t && "workspaceId" in t && "token" in t;
}
const tG = (t) => {
  if (!eG(t))
    return t.baseUrl;
  if (t.accountId && t.workspaceId)
    return `${t.baseUrl}/accounts/${t.accountId}/workspaces/${t.workspaceId}`;
  throw new Jq();
};
class qn extends kx {
  apiBaseUrl = tG;
}
class nG extends qn {
  routePrefix = "/ui";
  nextRunsBatcher = new hi(async (e) => {
    const n = await this.getNextRunsByFlow(e);
    return new Map(Object.entries(n));
  }, { maxBatchSize: 200 });
  async getFlowRunHistory(e) {
    const n = ye.map("FlowRunsFilter", e, "FlowRunsFilterRequest"), { data: r } = await this.post("/flow_runs/history", n);
    return ye.map("UiFlowRunHistoryResponse", r, "UiFlowRunHistory");
  }
  async getTaskRunsCountByState(e) {
    const n = ye.map("TaskRunsFilter", e, "TaskRunsFilterRequest"), { data: r } = await this.post("/task_runs/count", n);
    return ye.map("UiTaskRunCountsByStateResponse", r, "UiTaskRunCountsByState");
  }
  async getDeploymentsCountByFlow(e) {
    const n = { flow_ids: e }, { data: r } = await this.post("/flows/count-deployments", n);
    return r;
  }
  async getNextRunsByFlow(e) {
    const n = { flow_ids: e }, { data: r } = await this.post("/flows/next-runs", n);
    return ye.map("UiNextFlowRunByFlowResponse", r, "UiNextFlowRunByFlow");
  }
  getNextRunByFlow(e) {
    return this.nextRunsBatcher.batch(e);
  }
  async getFlowRunTaskCounts(e) {
    const { data: n } = await this.post("/flow_runs/count-task-runs", { flow_run_ids: e });
    return n;
  }
  getFlowRunTaskCountBatcher = new hi(async (e) => {
    const n = await this.getFlowRunTaskCounts(e);
    return (r) => n[r];
  }, { maxBatchSize: 200 });
  getFlowRunTaskCount(e) {
    return this.getFlowRunTaskCountBatcher.batch(e);
  }
}
class rG extends qn {
  routePrefix = "/artifacts";
  batcher = new hi(async (e) => {
    if (e.length === 1) {
      const [r] = e, { data: o } = await this.get(`/${r}`);
      return () => ye.map("ArtifactResponse", o, "Artifact");
    }
    const n = await this.getArtifacts({ artifacts: { id: e } });
    return cu(n, "id");
  }, { maxBatchSize: 200 });
  keyBatcher = new hi(async (e) => {
    if (e.length === 1) {
      const [r] = e, { data: o } = await this.get(`/${r}/latest`);
      return () => ye.map("ArtifactCollectionResponse", o, "ArtifactCollection");
    }
    const n = await this.getArtifactCollections({ artifacts: { key: e } });
    return cu(n, "key");
  }, { maxBatchSize: 200 });
  getArtifact(e) {
    return this.batcher.batch(e);
  }
  getArtifactCollection(e) {
    return this.keyBatcher.batch(e);
  }
  async getArtifacts(e = {}) {
    const n = ye.map("ArtifactsFilter", e, "ArtifactsFilterRequest"), { data: r } = await this.post("filter", n);
    return ye.map("ArtifactResponse", r, "Artifact");
  }
  async getArtifactsCount(e = {}) {
    const n = ye.map("ArtifactsFilter", e, "ArtifactsFilterRequest"), { data: r } = await this.post("count", n);
    return r;
  }
  async getArtifactCollections(e = {}) {
    const n = ye.map("ArtifactsFilter", e, "ArtifactsFilterRequest"), { data: r } = await this.post("latest/filter", n);
    return ye.map("ArtifactCollectionResponse", r, "ArtifactCollection");
  }
  async getArtifactCollectionsCount(e = {}) {
    const n = ye.map("ArtifactsFilter", e, "ArtifactsFilterRequest"), { data: r } = await this.post("latest/count", n);
    return r;
  }
  deleteArtifact(e) {
    return this.delete(`/${e}`);
  }
}
function k8(t) {
  return typeof t.status == "number";
}
function oG(t) {
  return k8(t.response);
}
function T8(t) {
  return typeof t == "number" ? t : k8(t) ? t.status : oG(t) ? T8(t.response) : 0;
}
function sG(t) {
  const e = T8(t);
  return {
    is: (n) => vt[n] === e,
    isInRange: (n) => aG[n].includes(e)
  };
}
const vt = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  OK: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  MultipleChoices: 300,
  MovedPermanently: 301,
  MovedTemporarily: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  RequestEntityTooLarge: 413,
  RequestURITooLong: 414,
  UnsupportedMediaType: 415,
  RequestedRangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  InsufficientSpaceOnResource: 419,
  MethodFailure: 420,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HTTPVersionNotSupported: 505,
  InsufficientStorage: 507,
  NetworkAuthenticationRequired: 511
}, aG = {
  informational: [
    vt.Continue,
    vt.SwitchingProtocols,
    vt.Processing
  ],
  successful: [
    vt.OK,
    vt.Created,
    vt.Accepted,
    vt.NonAuthoritativeInformation,
    vt.NoContent,
    vt.ResetContent,
    vt.PartialContent,
    vt.MultiStatus
  ],
  redirection: [
    vt.MultipleChoices,
    vt.MovedPermanently,
    vt.MovedTemporarily,
    vt.SeeOther,
    vt.NotModified,
    vt.UseProxy,
    vt.TemporaryRedirect,
    vt.PermanentRedirect
  ],
  clientError: [
    vt.BadRequest,
    vt.Unauthorized,
    vt.PaymentRequired,
    vt.Forbidden,
    vt.NotFound,
    vt.MethodNotAllowed,
    vt.NotAcceptable,
    vt.ProxyAuthenticationRequired,
    vt.RequestTimeout,
    vt.Conflict,
    vt.Gone,
    vt.LengthRequired,
    vt.PreconditionFailed,
    vt.RequestEntityTooLarge,
    vt.RequestURITooLong,
    vt.UnsupportedMediaType,
    vt.RequestedRangeNotSatisfiable,
    vt.ExpectationFailed,
    vt.ImATeapot,
    vt.InsufficientSpaceOnResource,
    vt.MethodFailure,
    vt.MisdirectedRequest,
    vt.UnprocessableEntity,
    vt.Locked,
    vt.FailedDependency,
    vt.PreconditionRequired,
    vt.TooManyRequests,
    vt.RequestHeaderFieldsTooLarge,
    vt.UnavailableForLegalReasons
  ],
  serverError: [
    vt.InternalServerError,
    vt.NotImplemented,
    vt.BadGateway,
    vt.ServiceUnavailable,
    vt.GatewayTimeout,
    vt.HTTPVersionNotSupported,
    vt.InsufficientStorage,
    vt.NetworkAuthenticationRequired
  ]
};
class iG extends qn {
  routePrefix = "/automations";
  async getAutomation(e) {
    const { data: n } = await this.get(`/${e}`);
    return ye.map("AutomationResponse", n, "Automation");
  }
  async getAutomations(e = {}) {
    const { data: n } = await this.post("/filter", e);
    return ye.map("AutomationResponse", n, "Automation");
  }
  deleteAutomation(e) {
    return this.delete(`/${e}`);
  }
  enableAutomation(e, n = !0) {
    return this.patch(`/${e}`, { enabled: n });
  }
  async validateTemplate(e) {
    try {
      return await this.post("/templates/validate", e), !0;
    } catch (n) {
      if (uG(n)) {
        const { line: r, message: o } = n.response.data.error;
        return `Error on line ${r}: ${o} `;
      }
      throw n;
    }
  }
  async getResourceAutomations(e) {
    const { data: n } = await this.get(`related-to/${e}`);
    return ye.map("AutomationResponse", n, "Automation");
  }
}
function uG(t) {
  return bx(t) ? sG(t).is("UnprocessableEntity") : !1;
}
class lG extends qn {
  routePrefix = "/block_capabilities";
  async getBlockCapabilities() {
    const { data: e } = await this.get("/");
    return e;
  }
}
class cG extends qn {
  routePrefix = "/block_documents";
  batcher = new hi(async (e) => {
    if (e.length === 1) {
      const [r] = e;
      return this.getSingleBlockDocument.bind(this, r);
    }
    const n = await this.getBlockDocuments({
      blockDocuments: {
        id: e,
        isAnonymous: null
      }
    });
    return cu(n, "id");
  }, { maxBatchSize: 200 });
  getBlockDocument(e) {
    return this.batcher.batch(e);
  }
  async getSingleBlockDocument(e) {
    const { data: n } = await this.get(`/${e}`);
    return ye.map("BlockDocumentResponse", n, "BlockDocument");
  }
  async getBlockDocuments(e = {}) {
    const n = ye.map("BlockDocumentsFilter", e, "BlockDocumentsFilterRequest"), { data: r } = await this.post("/filter", n);
    return ye.map("BlockDocumentResponse", r, "BlockDocument");
  }
  async createBlockDocument(e) {
    const { data: n } = await this.post("/", ye.map("BlockDocumentCreate", e, "BlockDocumentCreateRequest"));
    return ye.map("BlockDocumentResponse", n, "BlockDocument");
  }
  updateBlockDocument(e, n) {
    const r = ye.map("BlockDocumentUpdate", { mergeExistingData: !1, ...n }, "BlockDocumentUpdateRequest");
    return this.patch(`/${e}`, r);
  }
  deleteBlockDocument(e) {
    return this.delete(`/${e}`);
  }
  async getBlockDocumentsCount(e = {}) {
    const n = ye.map("BlockDocumentsFilter", e, "BlockDocumentsFilterRequest"), { data: r } = await this.post("/count", n);
    return r;
  }
}
class pG extends qn {
  routePrefix = "/block_schemas";
  async getBlockSchema(e) {
    const { data: n } = await this.get(`/${e}`);
    return ye.map("BlockSchemaResponse", n, "BlockSchema");
  }
  async getBlockSchemas(e = {}) {
    const n = ye.map("BlockSchemasFilter", e, "BlockSchemasFilterRequest"), { data: r } = await this.post("/filter", n);
    return ye.map("BlockSchemaResponse", r, "BlockSchema");
  }
  async getBlockSchemaForBlockType(e) {
    const n = {
      blockSchemas: {
        blockTypeId: [e]
      }
    }, { data: r } = await this.post("/filter", ye.map("BlockSchemasFilter", n, "BlockSchemasFilterRequest")), [o] = r;
    return ye.map("BlockSchemaResponse", o, "BlockSchema");
  }
}
class dG extends qn {
  routePrefix = "/block_types";
  async getBlockType(e) {
    const { data: n } = await this.get(`/${e}`);
    return ye.map("BlockTypeResponse", n, "BlockType");
  }
  async getBlockTypeBySlug(e) {
    const { data: n } = await this.get(`/slug/${e}`);
    return ye.map("BlockTypeResponse", n, "BlockType");
  }
  async getBlockTypes(e = {}) {
    const n = ye.map("BlockTypesFilter", e, "BlockTypesFilterRequest"), { data: r } = await this.post("/filter", n);
    return ye.map("BlockTypeResponse", r, "BlockType");
  }
  async getBlockDocumentsByBlockTypeSlug(e) {
    const { data: n } = await this.get(`/slug/${e}/block_documents`);
    return ye.map("BlockDocumentResponse", n, "BlockDocument");
  }
}
class hG extends qn {
  routePrefix = "/concurrency_limits";
  async getConcurrencyLimits(e = {}) {
    const { data: n } = await this.post("/filter", e);
    return ye.map("ConcurrencyLimitResponse", n, "ConcurrencyLimit");
  }
  async getConcurrencyLimit(e) {
    const { data: n } = await this.get(`/${e}`);
    return ye.map("ConcurrencyLimitResponse", n, "ConcurrencyLimit");
  }
  async getConcurrencyLimitByTag(e) {
    const { data: n } = await this.get(`/tag/${e}`);
    return ye.map("ConcurrencyLimitResponse", n, "ConcurrencyLimit");
  }
  async createConcurrencyLimit(e) {
    const { data: n } = await this.post("/", ye.map("ConcurrencyLimitCreate", e, "ConcurrencyLimitCreateRequest"));
    return ye.map("ConcurrencyLimitResponse", n, "ConcurrencyLimit");
  }
  deleteConcurrencyLimit(e) {
    return this.delete(`/${e}`);
  }
  deleteConcurrencyLimitByTag(e) {
    return this.delete(`/tag/${e}`);
  }
  async resetConcurrencyLimitByTag(e) {
    const { data: n } = await this.post(`/tag/${e}/reset`);
    return ye.map("ConcurrencyLimitResponse", n, "ConcurrencyLimit");
  }
}
class fG extends qn {
  routePrefix = "/v2/concurrency_limits";
  async getConcurrencyV2Limits(e = {}) {
    const { data: n } = await this.post("/filter", e);
    return ye.map("ConcurrencyV2LimitResponse", n, "ConcurrencyV2Limit");
  }
  async getConcurrencyV2Limit(e) {
    const { data: n } = await this.get(`/${e}`);
    return ye.map("ConcurrencyV2LimitResponse", n, "ConcurrencyV2Limit");
  }
  async createConcurrencyV2Limit(e) {
    const { data: n } = await this.post("/", ye.map("ConcurrencyV2LimitCreate", e, "ConcurrencyV2CreateRequest"));
    return ye.map("ConcurrencyV2LimitResponse", n, "ConcurrencyV2Limit");
  }
  async updateConcurrencyV2Limit(e, n) {
    const { data: r } = await this.patch(`/${e}`, ye.map("ConcurrencyV2LimitUpdate", n, "ConcurrencyV2UpdateRequest"));
    return ye.map("ConcurrencyV2LimitResponse", r, "ConcurrencyV2Limit");
  }
  deleteConcurrencyV2Limit(e) {
    return this.delete(`/${e}`);
  }
  async bulkIncrementActiveSlots(e, n, r) {
    const { data: o } = await this.post("/bulk_increment", { names: e, slots: n, mode: r });
    return o;
  }
  async bulkDecrementActiveSlots(e, n, r) {
    const { data: o } = await this.post("/bulk_decrement", { names: e, slots: n, mode: r });
    return o;
  }
}
const { random: Sr, floor: Vd, ceil: mG } = Math, Yn = (t, e) => Vd(Sr() * (e - t + 1) + t), x8 = (t) => Yn(0, 1) < t, yG = () => Yn(1, 3) == 1 ? Qr(rE(10, 100)) : Qr(rE(101, 1e3));
function U4e(t) {
  return `${t}`.length;
}
function S8(t) {
  return Array.isArray(t);
}
function cu(t, e) {
  return t.reduce((n, r) => (n.set(r[e], r), n), /* @__PURE__ */ new Map());
}
const Qr = (t) => t[Vd(Sr() * t.length)], rE = (t, e) => Array.from({ length: e - t }, (n, r) => t + r);
function Bm(t) {
  return [...new Set(t)];
}
function X4e(t) {
  return t !== void 0 && t.length > 0;
}
function tl(t) {
  return t == null ? [] : Array.isArray(t) ? t : [t];
}
function $4e(t, e) {
  if (t.length !== e.length)
    return !1;
  const n = [...e];
  return t.every((r) => n.some((o, s) => {
    const i = r.toString() === o.toString();
    return i && n.splice(s, 1), i;
  }));
}
function gG(t) {
  return t[t.length - 1];
}
function vG(t) {
  return t.slice(0, t.length - 1);
}
function W4e(t) {
  let e = t.length, n;
  for (; e != 0; )
    n = Math.floor(Math.random() * e), e--, [t[e], t[n]] = [t[n], t[e]];
  return t;
}
function Tc(t) {
  return Array.isArray(t) && t.length === 0;
}
function T0(t) {
  return Array.isArray(t) && t.length > 0 && t.every((e) => typeof e == "string");
}
function lk(t) {
  return Array.isArray(t) && t.length > 0 && t.every((e) => typeof e == "number");
}
function V4e(t) {
  if (Array.isArray(t)) {
    const [e] = t;
    return e;
  }
  return t;
}
function Tx(t, e) {
  return new Array(t).fill(null).map((n, r) => e(r));
}
function H4e(t, e, n) {
  const r = e ?? 1, o = n ?? t.length, s = Yn(r, o), i = [...t];
  return Tx(s, () => {
    const l = Yn(0, i.length - 1);
    return i.splice(l, 1)[0];
  });
}
function j4e(t, ...e) {
  return t.some((n) => e.every((r) => r.includes(n)));
}
function z4e(t, e) {
  return t.reduce((n, r) => {
    const o = r[e], s = n.get(o) ?? [];
    return s.push(r), n.set(o, s), n;
  }, /* @__PURE__ */ new Map());
}
function _G(t, e) {
  return t.reduce(([n, r], o) => (e(o) ? n.push(o) : r.push(o), [n, r]), [[], []]);
}
function xx(t, e, n) {
  const r = t.indexOf(e);
  return n === !0 || r === -1 ? [...t, e] : t.filter((s) => s !== e);
}
class wG extends qn {
  routePrefix = "/deployments";
  batcher = new hi(async (e) => {
    if (e.length === 1) {
      const [r] = e;
      return this.getSingleDeployment.bind(this, r);
    }
    const n = await this.getDeployments({
      deployments: {
        id: e
      }
    });
    return cu(n, "id");
  }, { maxBatchSize: 200 });
  getDeployment(e) {
    return this.batcher.batch(e);
  }
  async getSingleDeployment(e) {
    const { data: n } = await this.get(`/${e}`);
    return ye.map("DeploymentResponse", n, "Deployment");
  }
  async getDeployments(e = {}) {
    const n = ye.map("DeploymentsFilter", e, "DeploymentsFilterRequest"), { data: r } = await this.post("/filter", n);
    return ye.map("DeploymentResponse", r, "Deployment");
  }
  async getDeploymentsPaginated(e = {}) {
    const n = ye.map("DeploymentsPaginationFilter", e, "DeploymentsPaginationFilterRequest"), { data: r } = await this.post("/paginate", n);
    return ye.map("DeploymentPaginationResponse", r, "DeploymentsPagination");
  }
  async getDeploymentsCount(e = {}) {
    const n = ye.map("DeploymentsFilter", e, "DeploymentsFilterRequest"), { data: r } = await this.post("/count", n);
    return r;
  }
  async createDeployment(e) {
    const n = ye.map("DeploymentCreate", e, "DeploymentCreateRequest"), { data: r } = await this.post("/", n);
    return ye.map("DeploymentResponse", r, "Deployment");
  }
  async createDeploymentFlowRun(e, n) {
    const r = ye.map("DeploymentFlowRunCreateV2", n, "DeploymentFlowRunRequest"), { data: o } = await this.post(`/${e}/create_flow_run`, r);
    return ye.map("FlowRunResponse", o, "FlowRun");
  }
  updateDeploymentV2(e, n) {
    const r = ye.map("DeploymentUpdateV2", n, "DeploymentUpdateRequest");
    return this.patch(`/${e}`, r);
  }
  pauseDeployment(e) {
    return this.post(`/${e}/set_schedule_inactive`);
  }
  resumeDeployment(e) {
    return this.post(`/${e}/set_schedule_active`);
  }
  deleteDeployment(e) {
    return this.delete(`/${e}`);
  }
  disableDeployment(e) {
    return this.post(`/${e}/disable`);
  }
  enableDeployment(e) {
    return this.post(`/${e}/enable`);
  }
}
class bG extends qn {
  routePrefix = "/deployments";
  createDeploymentSchedule(e, n) {
    const r = ye.map("DeploymentScheduleCreate", n, "DeploymentScheduleCreateRequest");
    return this.post(`/${e}/schedules`, [r]);
  }
  updateDeploymentSchedule(e, n, r) {
    const o = ye.map("DeploymentScheduleUpdate", r, "DeploymentScheduleUpdateRequest");
    return this.patch(`/${e}/schedules/${n}`, o);
  }
  deleteDeploymentSchedule(e, n) {
    return this.delete(`/${e}/schedules/${n}`);
  }
}
const R8 = 7, x0 = 365.2425, kG = Math.pow(10, 8) * 24 * 60 * 60 * 1e3, q4e = -kG, Um = 6048e5, A8 = 864e5, Ia = 6e4, nl = 36e5, Kv = 1e3, oE = 525600, Nd = 43200, S0 = 1440, sh = 60, D8 = 3, E8 = 12, M8 = 4, ac = 3600, Oa = 60, ic = ac * 24, Ih = ic * 7, P8 = ic * x0, C8 = P8 / 12, TG = C8 * 3, sE = Symbol.for("constructDateFrom");
function gt(t, e) {
  return typeof t == "function" ? t(e) : t && typeof t == "object" && sE in t ? t[sE](e) : t instanceof Date ? new t.constructor(e) : new Date(e);
}
function Pe(t, e) {
  return gt(e || t, t);
}
function pu(t, e, n) {
  const r = Pe(t, n?.in);
  return isNaN(e) ? gt(n?.in || t, NaN) : (e && r.setDate(r.getDate() + e), r);
}
function Xm(t, e, n) {
  const r = Pe(t, n?.in);
  if (isNaN(e)) return gt(n?.in || t, NaN);
  if (!e)
    return r;
  const o = r.getDate(), s = gt(n?.in || t, r.getTime());
  s.setMonth(r.getMonth() + e + 1, 0);
  const i = s.getDate();
  return o >= i ? s : (r.setFullYear(
    s.getFullYear(),
    s.getMonth(),
    o
  ), r);
}
function Ad(t, e, n) {
  const {
    years: r = 0,
    months: o = 0,
    weeks: s = 0,
    days: i = 0,
    hours: u = 0,
    minutes: l = 0,
    seconds: a = 0
  } = e, c = Pe(t, n?.in), p = o || r ? Xm(c, o + r * 12) : c, d = i || s ? pu(p, i + s * 7) : p, h = l + u * 60, g = (a + h * 60) * 1e3;
  return gt(n?.in || t, +d + g);
}
function O8(t, e) {
  return Pe(t, e?.in).getDay() === 6;
}
function I8(t, e) {
  return Pe(t, e?.in).getDay() === 0;
}
function Hd(t, e) {
  const n = Pe(t, e?.in).getDay();
  return n === 0 || n === 6;
}
function F8(t, e, n) {
  const r = Pe(t, n?.in), o = Hd(r, n);
  if (isNaN(e)) return gt(n?.in, NaN);
  const s = r.getHours(), i = e < 0 ? -1 : 1, u = Math.trunc(e / 5);
  r.setDate(r.getDate() + u * 7);
  let l = Math.abs(e % 5);
  for (; l > 0; )
    r.setDate(r.getDate() + i), Hd(r, n) || (l -= 1);
  return o && Hd(r, n) && e !== 0 && (O8(r, n) && r.setDate(r.getDate() + (i < 0 ? 2 : -1)), I8(r, n) && r.setDate(r.getDate() + (i < 0 ? 1 : -2))), r.setHours(s), r;
}
function Zv(t, e, n) {
  return gt(n?.in || t, +Pe(t) + e);
}
function Sx(t, e, n) {
  return Zv(t, e * nl, n);
}
let N8 = {};
function os() {
  return N8;
}
function xG(t) {
  N8 = t;
}
function Do(t, e) {
  const n = os(), r = e?.weekStartsOn ?? e?.locale?.options?.weekStartsOn ?? n.weekStartsOn ?? n.locale?.options?.weekStartsOn ?? 0, o = Pe(t, e?.in), s = o.getDay(), i = (s < r ? 7 : 0) + s - r;
  return o.setDate(o.getDate() - i), o.setHours(0, 0, 0, 0), o;
}
function mi(t, e) {
  return Do(t, { ...e, weekStartsOn: 1 });
}
function dc(t, e) {
  const n = Pe(t, e?.in), r = n.getFullYear(), o = gt(n, 0);
  o.setFullYear(r + 1, 0, 4), o.setHours(0, 0, 0, 0);
  const s = mi(o), i = gt(n, 0);
  i.setFullYear(r, 0, 4), i.setHours(0, 0, 0, 0);
  const u = mi(i);
  return n.getTime() >= s.getTime() ? r + 1 : n.getTime() >= u.getTime() ? r : r - 1;
}
function As(t) {
  const e = Pe(t), n = new Date(
    Date.UTC(
      e.getFullYear(),
      e.getMonth(),
      e.getDate(),
      e.getHours(),
      e.getMinutes(),
      e.getSeconds(),
      e.getMilliseconds()
    )
  );
  return n.setUTCFullYear(e.getFullYear()), +t - +n;
}
function Ln(t, ...e) {
  const n = gt.bind(
    null,
    t || e.find((r) => typeof r == "object")
  );
  return e.map(n);
}
function ah(t, e) {
  const n = Pe(t, e?.in);
  return n.setHours(0, 0, 0, 0), n;
}
function tu(t, e, n) {
  const [r, o] = Ln(
    n?.in,
    t,
    e
  ), s = ah(r), i = ah(o), u = +s - As(s), l = +i - As(i);
  return Math.round((u - l) / A8);
}
function hc(t, e) {
  const n = dc(t, e), r = gt(e?.in || t, 0);
  return r.setFullYear(n, 0, 4), r.setHours(0, 0, 0, 0), mi(r);
}
function L8(t, e, n) {
  let r = Pe(t, n?.in);
  const o = tu(
    r,
    hc(r, n)
  ), s = gt(n?.in || t, 0);
  return s.setFullYear(e, 0, 4), s.setHours(0, 0, 0, 0), r = hc(s), r.setDate(r.getDate() + o), r;
}
function B8(t, e, n) {
  return L8(t, dc(t, n) + e, n);
}
function Jv(t, e, n) {
  const r = Pe(t, n?.in);
  return r.setTime(r.getTime() + e * Ia), r;
}
function Rx(t, e, n) {
  return Xm(t, e * 3, n);
}
function Ax(t, e, n) {
  return Zv(t, e * 1e3, n);
}
function e_(t, e, n) {
  return pu(t, e * 7, n);
}
function U8(t, e, n) {
  return Xm(t, e * 12, n);
}
function SG(t, e, n) {
  const [r, o] = [
    +Pe(t.start, n?.in),
    +Pe(t.end, n?.in)
  ].sort((u, l) => u - l), [s, i] = [
    +Pe(e.start, n?.in),
    +Pe(e.end, n?.in)
  ].sort((u, l) => u - l);
  return n?.inclusive ? r <= i && s <= o : r < i && s < o;
}
function Dx(t, e) {
  let n, r = e?.in;
  return t.forEach((o) => {
    !r && typeof o == "object" && (r = gt.bind(null, o));
    const s = Pe(o, r);
    (!n || n < s || isNaN(+s)) && (n = s);
  }), gt(r, n || NaN);
}
function X8(t, e) {
  let n, r = e?.in;
  return t.forEach((o) => {
    !r && typeof o == "object" && (r = gt.bind(null, o));
    const s = Pe(o, r);
    (!n || n > s || isNaN(+s)) && (n = s);
  }), gt(r, n || NaN);
}
function RG(t, e, n) {
  const [r, o, s] = Ln(
    n?.in,
    t,
    e.start,
    e.end
  );
  return X8([Dx([r, o], n), s], n);
}
function $8(t, e) {
  const n = +Pe(t);
  if (isNaN(n)) return NaN;
  let r, o;
  return e.forEach((s, i) => {
    const u = Pe(s);
    if (isNaN(+u)) {
      r = NaN, o = NaN;
      return;
    }
    const l = Math.abs(n - +u);
    (r == null || l < o) && (r = i, o = l);
  }), r;
}
function AG(t, e, n) {
  const [r, ...o] = Ln(
    n?.in,
    t,
    ...e
  ), s = $8(r, o);
  if (typeof s == "number" && isNaN(s))
    return gt(r, NaN);
  if (s !== void 0) return o[s];
}
function nu(t, e) {
  const n = +Pe(t) - +Pe(e);
  return n < 0 ? -1 : n > 0 ? 1 : n;
}
function DG(t, e) {
  const n = +Pe(t) - +Pe(e);
  return n > 0 ? -1 : n < 0 ? 1 : n;
}
function Jr(t) {
  return gt(t, Date.now());
}
function EG(t) {
  const e = Math.trunc(t / R8);
  return e === 0 ? 0 : e;
}
function $m(t, e, n) {
  const [r, o] = Ln(
    n?.in,
    t,
    e
  );
  return +ah(r) == +ah(o);
}
function Wm(t) {
  return t instanceof Date || typeof t == "object" && Object.prototype.toString.call(t) === "[object Date]";
}
function Fa(t) {
  return !(!Wm(t) && typeof t != "number" || isNaN(+Pe(t)));
}
function MG(t, e, n) {
  const [r, o] = Ln(
    n?.in,
    t,
    e
  );
  if (!Fa(r) || !Fa(o)) return NaN;
  const s = tu(r, o), i = s < 0 ? -1 : 1, u = Math.trunc(s / 7);
  let l = u * 5, a = pu(o, u * 7);
  for (; !$m(r, a); )
    l += Hd(a, n) ? 0 : i, a = pu(a, i);
  return l === 0 ? 0 : l;
}
function W8(t, e, n) {
  const [r, o] = Ln(
    n?.in,
    t,
    e
  );
  return dc(r, n) - dc(o, n);
}
function PG(t, e, n) {
  const [r, o] = Ln(
    n?.in,
    t,
    e
  ), s = mi(r), i = mi(o), u = +s - As(s), l = +i - As(i);
  return Math.round((u - l) / Um);
}
function R0(t, e, n) {
  const [r, o] = Ln(
    n?.in,
    t,
    e
  ), s = r.getFullYear() - o.getFullYear(), i = r.getMonth() - o.getMonth();
  return s * 12 + i;
}
function ck(t, e) {
  const n = Pe(t, e?.in);
  return Math.trunc(n.getMonth() / 3) + 1;
}
function Vg(t, e, n) {
  const [r, o] = Ln(
    n?.in,
    t,
    e
  ), s = r.getFullYear() - o.getFullYear(), i = ck(r) - ck(o);
  return s * 4 + i;
}
function A0(t, e, n) {
  const [r, o] = Ln(
    n?.in,
    t,
    e
  ), s = Do(r, n), i = Do(o, n), u = +s - As(s), l = +i - As(i);
  return Math.round((u - l) / Um);
}
function Qf(t, e, n) {
  const [r, o] = Ln(
    n?.in,
    t,
    e
  );
  return r.getFullYear() - o.getFullYear();
}
function Ex(t, e, n) {
  const [r, o] = Ln(
    n?.in,
    t,
    e
  ), s = aE(r, o), i = Math.abs(
    tu(r, o)
  );
  r.setDate(r.getDate() - s * i);
  const u = +(aE(r, o) === -s), l = s * (i - u);
  return l === 0 ? 0 : l;
}
function aE(t, e) {
  const n = t.getFullYear() - e.getFullYear() || t.getMonth() - e.getMonth() || t.getDate() - e.getDate() || t.getHours() - e.getHours() || t.getMinutes() - e.getMinutes() || t.getSeconds() - e.getSeconds() || t.getMilliseconds() - e.getMilliseconds();
  return n < 0 ? -1 : n > 0 ? 1 : n;
}
function xc(t) {
  return (e) => {
    const r = (t ? Math[t] : Math.trunc)(e);
    return r === 0 ? 0 : r;
  };
}
function D0(t, e, n) {
  const [r, o] = Ln(
    n?.in,
    t,
    e
  ), s = (+r - +o) / nl;
  return xc(n?.roundingMethod)(s);
}
function V8(t, e, n) {
  return B8(t, -e, n);
}
function CG(t, e, n) {
  const [r, o] = Ln(
    n?.in,
    t,
    e
  ), s = nu(r, o), i = Math.abs(
    W8(r, o, n)
  ), u = V8(r, s * i, n), l = +(nu(u, o) === -s), a = s * (i - l);
  return a === 0 ? 0 : a;
}
function Mx(t, e) {
  return +Pe(t) - +Pe(e);
}
function E0(t, e, n) {
  const r = Mx(t, e) / Ia;
  return xc(n?.roundingMethod)(r);
}
function Px(t, e) {
  const n = Pe(t, e?.in);
  return n.setHours(23, 59, 59, 999), n;
}
function Cx(t, e) {
  const n = Pe(t, e?.in), r = n.getMonth();
  return n.setFullYear(n.getFullYear(), r + 1, 0), n.setHours(23, 59, 59, 999), n;
}
function H8(t, e) {
  const n = Pe(t, e?.in);
  return +Px(n, e) == +Cx(n, e);
}
function t_(t, e, n) {
  const [r, o, s] = Ln(
    n?.in,
    t,
    t,
    e
  ), i = nu(o, s), u = Math.abs(
    R0(o, s)
  );
  if (u < 1) return 0;
  o.getMonth() === 1 && o.getDate() > 27 && o.setDate(30), o.setMonth(o.getMonth() - i * u);
  let l = nu(o, s) === -i;
  H8(r) && u === 1 && nu(r, s) === 1 && (l = !1);
  const a = i * (u - +l);
  return a === 0 ? 0 : a;
}
function OG(t, e, n) {
  const r = t_(t, e, n) / 3;
  return xc(n?.roundingMethod)(r);
}
function uc(t, e, n) {
  const r = Mx(t, e) / 1e3;
  return xc(n?.roundingMethod)(r);
}
function IG(t, e, n) {
  const r = Ex(t, e, n) / 7;
  return xc(n?.roundingMethod)(r);
}
function j8(t, e, n) {
  const [r, o] = Ln(
    n?.in,
    t,
    e
  ), s = nu(r, o), i = Math.abs(Qf(r, o));
  r.setFullYear(1584), o.setFullYear(1584);
  const u = nu(r, o) === -s, l = s * (i - +u);
  return l === 0 ? 0 : l;
}
function fl(t, e) {
  const [n, r] = Ln(t, e.start, e.end);
  return { start: n, end: r };
}
function z8(t, e) {
  const { start: n, end: r } = fl(e?.in, t);
  let o = +n > +r;
  const s = o ? +n : +r, i = o ? r : n;
  i.setHours(0, 0, 0, 0);
  let u = e?.step ?? 1;
  if (!u) return [];
  u < 0 && (u = -u, o = !o);
  const l = [];
  for (; +i <= s; )
    l.push(gt(n, i)), i.setDate(i.getDate() + u), i.setHours(0, 0, 0, 0);
  return o ? l.reverse() : l;
}
function FG(t, e) {
  const { start: n, end: r } = fl(e?.in, t);
  let o = +n > +r;
  const s = o ? +n : +r, i = o ? r : n;
  i.setMinutes(0, 0, 0);
  let u = e?.step ?? 1;
  if (!u) return [];
  u < 0 && (u = -u, o = !o);
  const l = [];
  for (; +i <= s; )
    l.push(gt(n, i)), i.setHours(i.getHours() + u);
  return o ? l.reverse() : l;
}
function NG(t, e) {
  const { start: n, end: r } = fl(e?.in, t);
  n.setSeconds(0, 0);
  let o = +n > +r;
  const s = o ? +n : +r;
  let i = o ? r : n, u = e?.step ?? 1;
  if (!u) return [];
  u < 0 && (u = -u, o = !o);
  const l = [];
  for (; +i <= s; )
    l.push(gt(n, i)), i = Jv(i, u);
  return o ? l.reverse() : l;
}
function LG(t, e) {
  const { start: n, end: r } = fl(e?.in, t);
  let o = +n > +r;
  const s = o ? +n : +r, i = o ? r : n;
  i.setHours(0, 0, 0, 0), i.setDate(1);
  let u = e?.step ?? 1;
  if (!u) return [];
  u < 0 && (u = -u, o = !o);
  const l = [];
  for (; +i <= s; )
    l.push(gt(n, i)), i.setMonth(i.getMonth() + u);
  return o ? l.reverse() : l;
}
function dp(t, e) {
  const n = Pe(t, e?.in), r = n.getMonth(), o = r - r % 3;
  return n.setMonth(o, 1), n.setHours(0, 0, 0, 0), n;
}
function BG(t, e) {
  const { start: n, end: r } = fl(e?.in, t);
  let o = +n > +r;
  const s = o ? +dp(n) : +dp(r);
  let i = dp(o ? r : n), u = e?.step ?? 1;
  if (!u) return [];
  u < 0 && (u = -u, o = !o);
  const l = [];
  for (; +i <= s; )
    l.push(gt(n, i)), i = Rx(i, u);
  return o ? l.reverse() : l;
}
function UG(t, e) {
  const { start: n, end: r } = fl(e?.in, t);
  let o = +n > +r;
  const s = Do(o ? r : n, e), i = Do(o ? n : r, e);
  s.setHours(15), i.setHours(15);
  const u = +i.getTime();
  let l = s, a = e?.step ?? 1;
  if (!a) return [];
  a < 0 && (a = -a, o = !o);
  const c = [];
  for (; +l <= u; )
    l.setHours(0), c.push(gt(n, l)), l = e_(l, a), l.setHours(15);
  return o ? c.reverse() : c;
}
function Ox(t, e) {
  const { start: n, end: r } = fl(e?.in, t), o = z8({ start: n, end: r }, e), s = [];
  let i = 0;
  for (; i < o.length; ) {
    const u = o[i++];
    Hd(u) && s.push(gt(n, u));
  }
  return s;
}
function n_(t, e) {
  const n = Pe(t, e?.in);
  return n.setDate(1), n.setHours(0, 0, 0, 0), n;
}
function XG(t, e) {
  const n = n_(t, e), r = Cx(t, e);
  return Ox({ start: n, end: r }, e);
}
function q8(t, e) {
  const n = Pe(t, e?.in), r = n.getFullYear();
  return n.setFullYear(r + 1, 0, 0), n.setHours(23, 59, 59, 999), n;
}
function Ix(t, e) {
  const n = Pe(t, e?.in);
  return n.setFullYear(n.getFullYear(), 0, 1), n.setHours(0, 0, 0, 0), n;
}
function $G(t, e) {
  const n = Ix(t, e), r = q8(t, e);
  return Ox({ start: n, end: r }, e);
}
function WG(t, e) {
  const { start: n, end: r } = fl(e?.in, t);
  let o = +n > +r;
  const s = o ? +n : +r, i = o ? r : n;
  i.setHours(0, 0, 0, 0), i.setMonth(0, 1);
  let u = e?.step ?? 1;
  if (!u) return [];
  u < 0 && (u = -u, o = !o);
  const l = [];
  for (; +i <= s; )
    l.push(gt(n, i)), i.setFullYear(i.getFullYear() + u);
  return o ? l.reverse() : l;
}
function VG(t, e) {
  const n = Pe(t, e?.in), r = n.getFullYear(), o = 9 + Math.floor(r / 10) * 10;
  return n.setFullYear(o, 11, 31), n.setHours(23, 59, 59, 999), n;
}
function G8(t, e) {
  const n = Pe(t, e?.in);
  return n.setMinutes(59, 59, 999), n;
}
function Y8(t, e) {
  const n = os(), r = e?.weekStartsOn ?? e?.locale?.options?.weekStartsOn ?? n.weekStartsOn ?? n.locale?.options?.weekStartsOn ?? 0, o = Pe(t, e?.in), s = o.getDay(), i = (s < r ? -7 : 0) + 6 - (s - r);
  return o.setDate(o.getDate() + i), o.setHours(23, 59, 59, 999), o;
}
function HG(t, e) {
  return Y8(t, { ...e, weekStartsOn: 1 });
}
function jG(t, e) {
  const n = dc(t, e), r = gt(e?.in || t, 0);
  r.setFullYear(n + 1, 0, 4), r.setHours(0, 0, 0, 0);
  const o = mi(r, e);
  return o.setMilliseconds(o.getMilliseconds() - 1), o;
}
function zG(t, e) {
  const n = Pe(t, e?.in);
  return n.setSeconds(59, 999), n;
}
function qG(t, e) {
  const n = Pe(t, e?.in), r = n.getMonth(), o = r - r % 3 + 3;
  return n.setMonth(o, 0), n.setHours(23, 59, 59, 999), n;
}
function GG(t, e) {
  const n = Pe(t, e?.in);
  return n.setMilliseconds(999), n;
}
function YG(t) {
  return Px(Date.now(), t);
}
function QG(t) {
  const e = Jr(t?.in), n = e.getFullYear(), r = e.getMonth(), o = e.getDate(), s = Jr(t?.in);
  return s.setFullYear(n, r, o + 1), s.setHours(23, 59, 59, 999), t?.in ? t.in(s) : s;
}
function KG(t) {
  const e = Jr(t?.in), n = gt(t?.in, 0);
  return n.setFullYear(e.getFullYear(), e.getMonth(), e.getDate() - 1), n.setHours(23, 59, 59, 999), n;
}
const ZG = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, JG = (t, e, n) => {
  let r;
  const o = ZG[t];
  return typeof o == "string" ? r = o : e === 1 ? r = o.one : r = o.other.replace("{{count}}", e.toString()), n?.addSuffix ? n.comparison && n.comparison > 0 ? "in " + r : r + " ago" : r;
};
function _1(t) {
  return (e = {}) => {
    const n = e.width ? String(e.width) : t.defaultWidth;
    return t.formats[n] || t.formats[t.defaultWidth];
  };
}
const eY = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, tY = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, nY = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, rY = {
  date: _1({
    formats: eY,
    defaultWidth: "full"
  }),
  time: _1({
    formats: tY,
    defaultWidth: "full"
  }),
  dateTime: _1({
    formats: nY,
    defaultWidth: "full"
  })
}, oY = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, sY = (t, e, n, r) => oY[t];
function pf(t) {
  return (e, n) => {
    const r = n?.context ? String(n.context) : "standalone";
    let o;
    if (r === "formatting" && t.formattingValues) {
      const i = t.defaultFormattingWidth || t.defaultWidth, u = n?.width ? String(n.width) : i;
      o = t.formattingValues[u] || t.formattingValues[i];
    } else {
      const i = t.defaultWidth, u = n?.width ? String(n.width) : t.defaultWidth;
      o = t.values[u] || t.values[i];
    }
    const s = t.argumentCallback ? t.argumentCallback(e) : e;
    return o[s];
  };
}
const aY = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, iY = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, uY = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
}, lY = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
}, cY = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, pY = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, dY = (t, e) => {
  const n = Number(t), r = n % 100;
  if (r > 20 || r < 10)
    switch (r % 10) {
      case 1:
        return n + "st";
      case 2:
        return n + "nd";
      case 3:
        return n + "rd";
    }
  return n + "th";
}, hY = {
  ordinalNumber: dY,
  era: pf({
    values: aY,
    defaultWidth: "wide"
  }),
  quarter: pf({
    values: iY,
    defaultWidth: "wide",
    argumentCallback: (t) => t - 1
  }),
  month: pf({
    values: uY,
    defaultWidth: "wide"
  }),
  day: pf({
    values: lY,
    defaultWidth: "wide"
  }),
  dayPeriod: pf({
    values: cY,
    defaultWidth: "wide",
    formattingValues: pY,
    defaultFormattingWidth: "wide"
  })
};
function df(t) {
  return (e, n = {}) => {
    const r = n.width, o = r && t.matchPatterns[r] || t.matchPatterns[t.defaultMatchWidth], s = e.match(o);
    if (!s)
      return null;
    const i = s[0], u = r && t.parsePatterns[r] || t.parsePatterns[t.defaultParseWidth], l = Array.isArray(u) ? mY(u, (p) => p.test(i)) : (
      // [TODO] -- I challenge you to fix the type
      fY(u, (p) => p.test(i))
    );
    let a;
    a = t.valueCallback ? t.valueCallback(l) : l, a = n.valueCallback ? (
      // [TODO] -- I challenge you to fix the type
      n.valueCallback(a)
    ) : a;
    const c = e.slice(i.length);
    return { value: a, rest: c };
  };
}
function fY(t, e) {
  for (const n in t)
    if (Object.prototype.hasOwnProperty.call(t, n) && e(t[n]))
      return n;
}
function mY(t, e) {
  for (let n = 0; n < t.length; n++)
    if (e(t[n]))
      return n;
}
function yY(t) {
  return (e, n = {}) => {
    const r = e.match(t.matchPattern);
    if (!r) return null;
    const o = r[0], s = e.match(t.parsePattern);
    if (!s) return null;
    let i = t.valueCallback ? t.valueCallback(s[0]) : s[0];
    i = n.valueCallback ? n.valueCallback(i) : i;
    const u = e.slice(o.length);
    return { value: i, rest: u };
  };
}
const gY = /^(\d+)(th|st|nd|rd)?/i, vY = /\d+/i, _Y = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, wY = {
  any: [/^b/i, /^(a|c)/i]
}, bY = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, kY = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, TY = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, xY = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, SY = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, RY = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, AY = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, DY = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, EY = {
  ordinalNumber: yY({
    matchPattern: gY,
    parsePattern: vY,
    valueCallback: (t) => parseInt(t, 10)
  }),
  era: df({
    matchPatterns: _Y,
    defaultMatchWidth: "wide",
    parsePatterns: wY,
    defaultParseWidth: "any"
  }),
  quarter: df({
    matchPatterns: bY,
    defaultMatchWidth: "wide",
    parsePatterns: kY,
    defaultParseWidth: "any",
    valueCallback: (t) => t + 1
  }),
  month: df({
    matchPatterns: TY,
    defaultMatchWidth: "wide",
    parsePatterns: xY,
    defaultParseWidth: "any"
  }),
  day: df({
    matchPatterns: SY,
    defaultMatchWidth: "wide",
    parsePatterns: RY,
    defaultParseWidth: "any"
  }),
  dayPeriod: df({
    matchPatterns: AY,
    defaultMatchWidth: "any",
    parsePatterns: DY,
    defaultParseWidth: "any"
  })
}, Fh = {
  code: "en-US",
  formatDistance: JG,
  formatLong: rY,
  formatRelative: sY,
  localize: hY,
  match: EY,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
function Q8(t, e) {
  const n = Pe(t, e?.in);
  return tu(n, Ix(n)) + 1;
}
function Fx(t, e) {
  const n = Pe(t, e?.in), r = +mi(n) - +hc(n);
  return Math.round(r / Um) + 1;
}
function r_(t, e) {
  const n = Pe(t, e?.in), r = n.getFullYear(), o = os(), s = e?.firstWeekContainsDate ?? e?.locale?.options?.firstWeekContainsDate ?? o.firstWeekContainsDate ?? o.locale?.options?.firstWeekContainsDate ?? 1, i = gt(e?.in || t, 0);
  i.setFullYear(r + 1, 0, s), i.setHours(0, 0, 0, 0);
  const u = Do(i, e), l = gt(e?.in || t, 0);
  l.setFullYear(r, 0, s), l.setHours(0, 0, 0, 0);
  const a = Do(l, e);
  return +n >= +u ? r + 1 : +n >= +a ? r : r - 1;
}
function M0(t, e) {
  const n = os(), r = e?.firstWeekContainsDate ?? e?.locale?.options?.firstWeekContainsDate ?? n.firstWeekContainsDate ?? n.locale?.options?.firstWeekContainsDate ?? 1, o = r_(t, e), s = gt(e?.in || t, 0);
  return s.setFullYear(o, 0, r), s.setHours(0, 0, 0, 0), Do(s, e);
}
function Nx(t, e) {
  const n = Pe(t, e?.in), r = +Do(n, e) - +M0(n, e);
  return Math.round(r / Um) + 1;
}
function kt(t, e) {
  const n = t < 0 ? "-" : "", r = Math.abs(t).toString().padStart(e, "0");
  return n + r;
}
const ji = {
  // Year
  y(t, e) {
    const n = t.getFullYear(), r = n > 0 ? n : 1 - n;
    return kt(e === "yy" ? r % 100 : r, e.length);
  },
  // Month
  M(t, e) {
    const n = t.getMonth();
    return e === "M" ? String(n + 1) : kt(n + 1, 2);
  },
  // Day of the month
  d(t, e) {
    return kt(t.getDate(), e.length);
  },
  // AM or PM
  a(t, e) {
    const n = t.getHours() / 12 >= 1 ? "pm" : "am";
    switch (e) {
      case "a":
      case "aa":
        return n.toUpperCase();
      case "aaa":
        return n;
      case "aaaaa":
        return n[0];
      case "aaaa":
      default:
        return n === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h(t, e) {
    return kt(t.getHours() % 12 || 12, e.length);
  },
  // Hour [0-23]
  H(t, e) {
    return kt(t.getHours(), e.length);
  },
  // Minute
  m(t, e) {
    return kt(t.getMinutes(), e.length);
  },
  // Second
  s(t, e) {
    return kt(t.getSeconds(), e.length);
  },
  // Fraction of second
  S(t, e) {
    const n = e.length, r = t.getMilliseconds(), o = Math.trunc(
      r * Math.pow(10, n - 3)
    );
    return kt(o, e.length);
  }
}, wd = {
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, pk = {
  // Era
  G: function(t, e, n) {
    const r = t.getFullYear() > 0 ? 1 : 0;
    switch (e) {
      // AD, BC
      case "G":
      case "GG":
      case "GGG":
        return n.era(r, { width: "abbreviated" });
      // A, B
      case "GGGGG":
        return n.era(r, { width: "narrow" });
      // Anno Domini, Before Christ
      case "GGGG":
      default:
        return n.era(r, { width: "wide" });
    }
  },
  // Year
  y: function(t, e, n) {
    if (e === "yo") {
      const r = t.getFullYear(), o = r > 0 ? r : 1 - r;
      return n.ordinalNumber(o, { unit: "year" });
    }
    return ji.y(t, e);
  },
  // Local week-numbering year
  Y: function(t, e, n, r) {
    const o = r_(t, r), s = o > 0 ? o : 1 - o;
    if (e === "YY") {
      const i = s % 100;
      return kt(i, 2);
    }
    return e === "Yo" ? n.ordinalNumber(s, { unit: "year" }) : kt(s, e.length);
  },
  // ISO week-numbering year
  R: function(t, e) {
    const n = dc(t);
    return kt(n, e.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(t, e) {
    const n = t.getFullYear();
    return kt(n, e.length);
  },
  // Quarter
  Q: function(t, e, n) {
    const r = Math.ceil((t.getMonth() + 1) / 3);
    switch (e) {
      // 1, 2, 3, 4
      case "Q":
        return String(r);
      // 01, 02, 03, 04
      case "QQ":
        return kt(r, 2);
      // 1st, 2nd, 3rd, 4th
      case "Qo":
        return n.ordinalNumber(r, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "QQQ":
        return n.quarter(r, {
          width: "abbreviated",
          context: "formatting"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "QQQQQ":
        return n.quarter(r, {
          width: "narrow",
          context: "formatting"
        });
      // 1st quarter, 2nd quarter, ...
      case "QQQQ":
      default:
        return n.quarter(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(t, e, n) {
    const r = Math.ceil((t.getMonth() + 1) / 3);
    switch (e) {
      // 1, 2, 3, 4
      case "q":
        return String(r);
      // 01, 02, 03, 04
      case "qq":
        return kt(r, 2);
      // 1st, 2nd, 3rd, 4th
      case "qo":
        return n.ordinalNumber(r, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "qqq":
        return n.quarter(r, {
          width: "abbreviated",
          context: "standalone"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "qqqqq":
        return n.quarter(r, {
          width: "narrow",
          context: "standalone"
        });
      // 1st quarter, 2nd quarter, ...
      case "qqqq":
      default:
        return n.quarter(r, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(t, e, n) {
    const r = t.getMonth();
    switch (e) {
      case "M":
      case "MM":
        return ji.M(t, e);
      // 1st, 2nd, ..., 12th
      case "Mo":
        return n.ordinalNumber(r + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "MMM":
        return n.month(r, {
          width: "abbreviated",
          context: "formatting"
        });
      // J, F, ..., D
      case "MMMMM":
        return n.month(r, {
          width: "narrow",
          context: "formatting"
        });
      // January, February, ..., December
      case "MMMM":
      default:
        return n.month(r, { width: "wide", context: "formatting" });
    }
  },
  // Stand-alone month
  L: function(t, e, n) {
    const r = t.getMonth();
    switch (e) {
      // 1, 2, ..., 12
      case "L":
        return String(r + 1);
      // 01, 02, ..., 12
      case "LL":
        return kt(r + 1, 2);
      // 1st, 2nd, ..., 12th
      case "Lo":
        return n.ordinalNumber(r + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "LLL":
        return n.month(r, {
          width: "abbreviated",
          context: "standalone"
        });
      // J, F, ..., D
      case "LLLLL":
        return n.month(r, {
          width: "narrow",
          context: "standalone"
        });
      // January, February, ..., December
      case "LLLL":
      default:
        return n.month(r, { width: "wide", context: "standalone" });
    }
  },
  // Local week of year
  w: function(t, e, n, r) {
    const o = Nx(t, r);
    return e === "wo" ? n.ordinalNumber(o, { unit: "week" }) : kt(o, e.length);
  },
  // ISO week of year
  I: function(t, e, n) {
    const r = Fx(t);
    return e === "Io" ? n.ordinalNumber(r, { unit: "week" }) : kt(r, e.length);
  },
  // Day of the month
  d: function(t, e, n) {
    return e === "do" ? n.ordinalNumber(t.getDate(), { unit: "date" }) : ji.d(t, e);
  },
  // Day of year
  D: function(t, e, n) {
    const r = Q8(t);
    return e === "Do" ? n.ordinalNumber(r, { unit: "dayOfYear" }) : kt(r, e.length);
  },
  // Day of week
  E: function(t, e, n) {
    const r = t.getDay();
    switch (e) {
      // Tue
      case "E":
      case "EE":
      case "EEE":
        return n.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "EEEEE":
        return n.day(r, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "EEEEEE":
        return n.day(r, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "EEEE":
      default:
        return n.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(t, e, n, r) {
    const o = t.getDay(), s = (o - r.weekStartsOn + 8) % 7 || 7;
    switch (e) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case "e":
        return String(s);
      // Padded numerical value
      case "ee":
        return kt(s, 2);
      // 1st, 2nd, ..., 7th
      case "eo":
        return n.ordinalNumber(s, { unit: "day" });
      case "eee":
        return n.day(o, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "eeeee":
        return n.day(o, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "eeeeee":
        return n.day(o, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "eeee":
      default:
        return n.day(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(t, e, n, r) {
    const o = t.getDay(), s = (o - r.weekStartsOn + 8) % 7 || 7;
    switch (e) {
      // Numerical value (same as in `e`)
      case "c":
        return String(s);
      // Padded numerical value
      case "cc":
        return kt(s, e.length);
      // 1st, 2nd, ..., 7th
      case "co":
        return n.ordinalNumber(s, { unit: "day" });
      case "ccc":
        return n.day(o, {
          width: "abbreviated",
          context: "standalone"
        });
      // T
      case "ccccc":
        return n.day(o, {
          width: "narrow",
          context: "standalone"
        });
      // Tu
      case "cccccc":
        return n.day(o, {
          width: "short",
          context: "standalone"
        });
      // Tuesday
      case "cccc":
      default:
        return n.day(o, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(t, e, n) {
    const r = t.getDay(), o = r === 0 ? 7 : r;
    switch (e) {
      // 2
      case "i":
        return String(o);
      // 02
      case "ii":
        return kt(o, e.length);
      // 2nd
      case "io":
        return n.ordinalNumber(o, { unit: "day" });
      // Tue
      case "iii":
        return n.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "iiiii":
        return n.day(r, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "iiiiii":
        return n.day(r, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "iiii":
      default:
        return n.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(t, e, n) {
    const o = t.getHours() / 12 >= 1 ? "pm" : "am";
    switch (e) {
      case "a":
      case "aa":
        return n.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return n.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return n.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return n.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(t, e, n) {
    const r = t.getHours();
    let o;
    switch (r === 12 ? o = wd.noon : r === 0 ? o = wd.midnight : o = r / 12 >= 1 ? "pm" : "am", e) {
      case "b":
      case "bb":
        return n.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return n.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return n.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return n.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(t, e, n) {
    const r = t.getHours();
    let o;
    switch (r >= 17 ? o = wd.evening : r >= 12 ? o = wd.afternoon : r >= 4 ? o = wd.morning : o = wd.night, e) {
      case "B":
      case "BB":
      case "BBB":
        return n.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return n.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return n.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(t, e, n) {
    if (e === "ho") {
      let r = t.getHours() % 12;
      return r === 0 && (r = 12), n.ordinalNumber(r, { unit: "hour" });
    }
    return ji.h(t, e);
  },
  // Hour [0-23]
  H: function(t, e, n) {
    return e === "Ho" ? n.ordinalNumber(t.getHours(), { unit: "hour" }) : ji.H(t, e);
  },
  // Hour [0-11]
  K: function(t, e, n) {
    const r = t.getHours() % 12;
    return e === "Ko" ? n.ordinalNumber(r, { unit: "hour" }) : kt(r, e.length);
  },
  // Hour [1-24]
  k: function(t, e, n) {
    let r = t.getHours();
    return r === 0 && (r = 24), e === "ko" ? n.ordinalNumber(r, { unit: "hour" }) : kt(r, e.length);
  },
  // Minute
  m: function(t, e, n) {
    return e === "mo" ? n.ordinalNumber(t.getMinutes(), { unit: "minute" }) : ji.m(t, e);
  },
  // Second
  s: function(t, e, n) {
    return e === "so" ? n.ordinalNumber(t.getSeconds(), { unit: "second" }) : ji.s(t, e);
  },
  // Fraction of second
  S: function(t, e) {
    return ji.S(t, e);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(t, e, n) {
    const r = t.getTimezoneOffset();
    if (r === 0)
      return "Z";
    switch (e) {
      // Hours and optional minutes
      case "X":
        return uE(r);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`
      case "XXXX":
      case "XX":
        return tp(r);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`
      case "XXXXX":
      case "XXX":
      // Hours and minutes with `:` delimiter
      default:
        return tp(r, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(t, e, n) {
    const r = t.getTimezoneOffset();
    switch (e) {
      // Hours and optional minutes
      case "x":
        return uE(r);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`
      case "xxxx":
      case "xx":
        return tp(r);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`
      case "xxxxx":
      case "xxx":
      // Hours and minutes with `:` delimiter
      default:
        return tp(r, ":");
    }
  },
  // Timezone (GMT)
  O: function(t, e, n) {
    const r = t.getTimezoneOffset();
    switch (e) {
      // Short
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + iE(r, ":");
      // Long
      case "OOOO":
      default:
        return "GMT" + tp(r, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(t, e, n) {
    const r = t.getTimezoneOffset();
    switch (e) {
      // Short
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + iE(r, ":");
      // Long
      case "zzzz":
      default:
        return "GMT" + tp(r, ":");
    }
  },
  // Seconds timestamp
  t: function(t, e, n) {
    const r = Math.trunc(+t / 1e3);
    return kt(r, e.length);
  },
  // Milliseconds timestamp
  T: function(t, e, n) {
    return kt(+t, e.length);
  }
};
function iE(t, e = "") {
  const n = t > 0 ? "-" : "+", r = Math.abs(t), o = Math.trunc(r / 60), s = r % 60;
  return s === 0 ? n + String(o) : n + String(o) + e + kt(s, 2);
}
function uE(t, e) {
  return t % 60 === 0 ? (t > 0 ? "-" : "+") + kt(Math.abs(t) / 60, 2) : tp(t, e);
}
function tp(t, e = "") {
  const n = t > 0 ? "-" : "+", r = Math.abs(t), o = kt(Math.trunc(r / 60), 2), s = kt(r % 60, 2);
  return n + o + e + s;
}
const lE = (t, e) => {
  switch (t) {
    case "P":
      return e.date({ width: "short" });
    case "PP":
      return e.date({ width: "medium" });
    case "PPP":
      return e.date({ width: "long" });
    case "PPPP":
    default:
      return e.date({ width: "full" });
  }
}, K8 = (t, e) => {
  switch (t) {
    case "p":
      return e.time({ width: "short" });
    case "pp":
      return e.time({ width: "medium" });
    case "ppp":
      return e.time({ width: "long" });
    case "pppp":
    default:
      return e.time({ width: "full" });
  }
}, MY = (t, e) => {
  const n = t.match(/(P+)(p+)?/) || [], r = n[1], o = n[2];
  if (!o)
    return lE(t, e);
  let s;
  switch (r) {
    case "P":
      s = e.dateTime({ width: "short" });
      break;
    case "PP":
      s = e.dateTime({ width: "medium" });
      break;
    case "PPP":
      s = e.dateTime({ width: "long" });
      break;
    case "PPPP":
    default:
      s = e.dateTime({ width: "full" });
      break;
  }
  return s.replace("{{date}}", lE(r, e)).replace("{{time}}", K8(o, e));
}, P0 = {
  p: K8,
  P: MY
}, PY = /^D+$/, CY = /^Y+$/, OY = ["D", "DD", "YY", "YYYY"];
function Z8(t) {
  return PY.test(t);
}
function J8(t) {
  return CY.test(t);
}
function dk(t, e, n) {
  const r = IY(t, e, n);
  if (console.warn(r), OY.includes(t)) throw new RangeError(r);
}
function IY(t, e, n) {
  const r = t[0] === "Y" ? "years" : "days of the month";
  return `Use \`${t.toLowerCase()}\` instead of \`${t}\` (in \`${e}\`) for formatting ${r} to the input \`${n}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
const FY = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, NY = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, LY = /^'([^]*?)'?$/, BY = /''/g, UY = /[a-zA-Z]/;
function rl(t, e, n) {
  const r = os(), o = n?.locale ?? r.locale ?? Fh, s = n?.firstWeekContainsDate ?? n?.locale?.options?.firstWeekContainsDate ?? r.firstWeekContainsDate ?? r.locale?.options?.firstWeekContainsDate ?? 1, i = n?.weekStartsOn ?? n?.locale?.options?.weekStartsOn ?? r.weekStartsOn ?? r.locale?.options?.weekStartsOn ?? 0, u = Pe(t, n?.in);
  if (!Fa(u))
    throw new RangeError("Invalid time value");
  let l = e.match(NY).map((c) => {
    const p = c[0];
    if (p === "p" || p === "P") {
      const d = P0[p];
      return d(c, o.formatLong);
    }
    return c;
  }).join("").match(FY).map((c) => {
    if (c === "''")
      return { isToken: !1, value: "'" };
    const p = c[0];
    if (p === "'")
      return { isToken: !1, value: XY(c) };
    if (pk[p])
      return { isToken: !0, value: c };
    if (p.match(UY))
      throw new RangeError(
        "Format string contains an unescaped latin alphabet character `" + p + "`"
      );
    return { isToken: !1, value: c };
  });
  o.localize.preprocessor && (l = o.localize.preprocessor(u, l));
  const a = {
    firstWeekContainsDate: s,
    weekStartsOn: i,
    locale: o
  };
  return l.map((c) => {
    if (!c.isToken) return c.value;
    const p = c.value;
    (!n?.useAdditionalWeekYearTokens && J8(p) || !n?.useAdditionalDayOfYearTokens && Z8(p)) && dk(p, e, String(t));
    const d = pk[p[0]];
    return d(u, p, o.localize, a);
  }).join("");
}
function XY(t) {
  const e = t.match(LY);
  return e ? e[1].replace(BY, "'") : t;
}
function e3(t, e, n) {
  const r = os(), o = n?.locale ?? r.locale ?? Fh, s = 2520, i = nu(t, e);
  if (isNaN(i)) throw new RangeError("Invalid time value");
  const u = Object.assign({}, n, {
    addSuffix: n?.addSuffix,
    comparison: i
  }), [l, a] = Ln(
    n?.in,
    ...i > 0 ? [e, t] : [t, e]
  ), c = uc(a, l), p = (As(a) - As(l)) / 1e3, d = Math.round((c - p) / 60);
  let h;
  if (d < 2)
    return n?.includeSeconds ? c < 5 ? o.formatDistance("lessThanXSeconds", 5, u) : c < 10 ? o.formatDistance("lessThanXSeconds", 10, u) : c < 20 ? o.formatDistance("lessThanXSeconds", 20, u) : c < 40 ? o.formatDistance("halfAMinute", 0, u) : c < 60 ? o.formatDistance("lessThanXMinutes", 1, u) : o.formatDistance("xMinutes", 1, u) : d === 0 ? o.formatDistance("lessThanXMinutes", 1, u) : o.formatDistance("xMinutes", d, u);
  if (d < 45)
    return o.formatDistance("xMinutes", d, u);
  if (d < 90)
    return o.formatDistance("aboutXHours", 1, u);
  if (d < S0) {
    const m = Math.round(d / 60);
    return o.formatDistance("aboutXHours", m, u);
  } else {
    if (d < s)
      return o.formatDistance("xDays", 1, u);
    if (d < Nd) {
      const m = Math.round(d / S0);
      return o.formatDistance("xDays", m, u);
    } else if (d < Nd * 2)
      return h = Math.round(d / Nd), o.formatDistance("aboutXMonths", h, u);
  }
  if (h = t_(a, l), h < 12) {
    const m = Math.round(d / Nd);
    return o.formatDistance("xMonths", m, u);
  } else {
    const m = h % 12, g = Math.trunc(h / 12);
    return m < 3 ? o.formatDistance("aboutXYears", g, u) : m < 9 ? o.formatDistance("overXYears", g, u) : o.formatDistance("almostXYears", g + 1, u);
  }
}
function t3(t, e, n) {
  const r = os(), o = n?.locale ?? r.locale ?? Fh, s = nu(t, e);
  if (isNaN(s))
    throw new RangeError("Invalid time value");
  const i = Object.assign({}, n, {
    addSuffix: n?.addSuffix,
    comparison: s
  }), [u, l] = Ln(
    n?.in,
    ...s > 0 ? [e, t] : [t, e]
  ), a = xc(n?.roundingMethod ?? "round"), c = l.getTime() - u.getTime(), p = c / Ia, d = As(l) - As(u), h = (c - d) / Ia, m = n?.unit;
  let g;
  if (m ? g = m : p < 1 ? g = "second" : p < 60 ? g = "minute" : p < S0 ? g = "hour" : h < Nd ? g = "day" : h < oE ? g = "month" : g = "year", g === "second") {
    const _ = a(c / 1e3);
    return o.formatDistance("xSeconds", _, i);
  } else if (g === "minute") {
    const _ = a(p);
    return o.formatDistance("xMinutes", _, i);
  } else if (g === "hour") {
    const _ = a(p / 60);
    return o.formatDistance("xHours", _, i);
  } else if (g === "day") {
    const _ = a(h / S0);
    return o.formatDistance("xDays", _, i);
  } else if (g === "month") {
    const _ = a(h / Nd);
    return _ === 12 && m !== "month" ? o.formatDistance("xYears", 1, i) : o.formatDistance("xMonths", _, i);
  } else {
    const _ = a(h / oE);
    return o.formatDistance("xYears", _, i);
  }
}
function $Y(t, e) {
  return e3(t, Jr(t), e);
}
function WY(t, e) {
  return t3(t, Jr(t), e);
}
const VY = [
  "years",
  "months",
  "weeks",
  "days",
  "hours",
  "minutes",
  "seconds"
];
function HY(t, e) {
  const n = os(), r = e?.locale ?? n.locale ?? Fh, o = e?.format ?? VY, s = e?.zero ?? !1, i = e?.delimiter ?? " ";
  return r.formatDistance ? o.reduce((l, a) => {
    const c = `x${a.replace(/(^.)/, (d) => d.toUpperCase())}`, p = t[a];
    return p !== void 0 && (s || t[a]) ? l.concat(r.formatDistance(c, p)) : l;
  }, []).join(i) : "";
}
function jY(t, e) {
  const n = Pe(t, e?.in);
  if (isNaN(+n))
    throw new RangeError("Invalid time value");
  const r = e?.format ?? "extended", o = e?.representation ?? "complete";
  let s = "", i = "";
  const u = r === "extended" ? "-" : "", l = r === "extended" ? ":" : "";
  if (o !== "time") {
    const a = kt(n.getDate(), 2), c = kt(n.getMonth() + 1, 2);
    s = `${kt(n.getFullYear(), 4)}${u}${c}${u}${a}`;
  }
  if (o !== "date") {
    const a = n.getTimezoneOffset();
    if (a !== 0) {
      const g = Math.abs(a), _ = kt(Math.trunc(g / 60), 2), b = kt(g % 60, 2);
      i = `${a < 0 ? "+" : "-"}${_}:${b}`;
    } else
      i = "Z";
    const c = kt(n.getHours(), 2), p = kt(n.getMinutes(), 2), d = kt(n.getSeconds(), 2), h = s === "" ? "" : "T", m = [c, p, d].join(l);
    s = `${s}${h}${m}${i}`;
  }
  return s;
}
function zY(t, e) {
  const n = Pe(t, e?.in);
  if (!Fa(n))
    throw new RangeError("Invalid time value");
  const r = e?.format ?? "extended", o = e?.representation ?? "complete";
  let s = "";
  const i = r === "extended" ? "-" : "", u = r === "extended" ? ":" : "";
  if (o !== "time") {
    const l = kt(n.getDate(), 2), a = kt(n.getMonth() + 1, 2);
    s = `${kt(n.getFullYear(), 4)}${i}${a}${i}${l}`;
  }
  if (o !== "date") {
    const l = kt(n.getHours(), 2), a = kt(n.getMinutes(), 2), c = kt(n.getSeconds(), 2);
    s = `${s}${s === "" ? "" : " "}${l}${u}${a}${u}${c}`;
  }
  return s;
}
function qY(t) {
  const {
    years: e = 0,
    months: n = 0,
    days: r = 0,
    hours: o = 0,
    minutes: s = 0,
    seconds: i = 0
  } = t;
  return `P${e}Y${n}M${r}DT${o}H${s}M${i}S`;
}
function GY(t, e) {
  const n = Pe(t, e?.in);
  if (!Fa(n))
    throw new RangeError("Invalid time value");
  const r = e?.fractionDigits ?? 0, o = kt(n.getDate(), 2), s = kt(n.getMonth() + 1, 2), i = n.getFullYear(), u = kt(n.getHours(), 2), l = kt(n.getMinutes(), 2), a = kt(n.getSeconds(), 2);
  let c = "";
  if (r > 0) {
    const h = n.getMilliseconds(), m = Math.trunc(
      h * Math.pow(10, r - 3)
    );
    c = "." + kt(m, r);
  }
  let p = "";
  const d = n.getTimezoneOffset();
  if (d !== 0) {
    const h = Math.abs(d), m = kt(Math.trunc(h / 60), 2), g = kt(h % 60, 2);
    p = `${d < 0 ? "+" : "-"}${m}:${g}`;
  } else
    p = "Z";
  return `${i}-${s}-${o}T${u}:${l}:${a}${c}${p}`;
}
const YY = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"], QY = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec"
];
function KY(t) {
  const e = Pe(t);
  if (!Fa(e))
    throw new RangeError("Invalid time value");
  const n = YY[e.getUTCDay()], r = kt(e.getUTCDate(), 2), o = QY[e.getUTCMonth()], s = e.getUTCFullYear(), i = kt(e.getUTCHours(), 2), u = kt(e.getUTCMinutes(), 2), l = kt(e.getUTCSeconds(), 2);
  return `${n}, ${r} ${o} ${s} ${i}:${u}:${l} GMT`;
}
function ZY(t, e, n) {
  const [r, o] = Ln(n?.in, t, e), s = os(), i = n?.locale ?? s.locale ?? Fh, u = n?.weekStartsOn ?? n?.locale?.options?.weekStartsOn ?? s.weekStartsOn ?? s.locale?.options?.weekStartsOn ?? 0, l = tu(r, o);
  if (isNaN(l))
    throw new RangeError("Invalid time value");
  let a;
  l < -6 ? a = "other" : l < -1 ? a = "lastWeek" : l < 0 ? a = "yesterday" : l < 1 ? a = "today" : l < 2 ? a = "tomorrow" : l < 7 ? a = "nextWeek" : a = "other";
  const c = i.formatRelative(a, r, o, {
    locale: i,
    weekStartsOn: u
  });
  return rl(r, c, { locale: i, weekStartsOn: u });
}
function JY(t, e) {
  return Pe(t * 1e3, e?.in);
}
function n3(t, e) {
  return Pe(t, e?.in).getDate();
}
function o_(t, e) {
  return Pe(t, e?.in).getDay();
}
function r3(t, e) {
  const n = Pe(t, e?.in), r = n.getFullYear(), o = n.getMonth(), s = gt(n, 0);
  return s.setFullYear(r, o + 1, 0), s.setHours(0, 0, 0, 0), s.getDate();
}
function o3(t, e) {
  const r = Pe(t, e?.in).getFullYear();
  return r % 400 === 0 || r % 4 === 0 && r % 100 !== 0;
}
function eQ(t, e) {
  const n = Pe(t, e?.in);
  return Number.isNaN(+n) ? NaN : o3(n) ? 366 : 365;
}
function tQ(t, e) {
  const r = Pe(t, e?.in).getFullYear();
  return Math.floor(r / 10) * 10;
}
function Lx() {
  return Object.assign({}, os());
}
function nQ(t, e) {
  return Pe(t, e?.in).getHours();
}
function s3(t, e) {
  const n = Pe(t, e?.in).getDay();
  return n === 0 ? 7 : n;
}
function rQ(t, e) {
  const n = hc(t, e), o = +hc(e_(n, 60)) - +n;
  return Math.round(o / Um);
}
function oQ(t) {
  return Pe(t).getMilliseconds();
}
function sQ(t, e) {
  return Pe(t, e?.in).getMinutes();
}
function aQ(t, e) {
  return Pe(t, e?.in).getMonth();
}
function iQ(t, e) {
  const [n, r] = [
    +Pe(t.start),
    +Pe(t.end)
  ].sort((p, d) => p - d), [o, s] = [
    +Pe(e.start),
    +Pe(e.end)
  ].sort((p, d) => p - d);
  if (!(n < s && o < r)) return 0;
  const u = o < n ? n : o, l = u - As(u), a = s > r ? r : s, c = a - As(a);
  return Math.ceil((c - l) / A8);
}
function uQ(t) {
  return Pe(t).getSeconds();
}
function lQ(t) {
  return +Pe(t);
}
function cQ(t) {
  return Math.trunc(+Pe(t) / 1e3);
}
function pQ(t, e) {
  const n = os(), r = e?.weekStartsOn ?? e?.locale?.options?.weekStartsOn ?? n.weekStartsOn ?? n.locale?.options?.weekStartsOn ?? 0, o = n3(Pe(t, e?.in));
  if (isNaN(o)) return NaN;
  const s = o_(n_(t, e));
  let i = r - s;
  i <= 0 && (i += 7);
  const u = o - i;
  return Math.ceil(u / 7) + 1;
}
function a3(t, e) {
  const n = Pe(t, e?.in), r = n.getMonth();
  return n.setFullYear(n.getFullYear(), r + 1, 0), n.setHours(0, 0, 0, 0), Pe(n, e?.in);
}
function dQ(t, e) {
  const n = Pe(t, e?.in);
  return A0(
    a3(n, e),
    n_(n, e),
    e
  ) + 1;
}
function hQ(t, e) {
  return Pe(t, e?.in).getFullYear();
}
function fQ(t) {
  return Math.trunc(t * nl);
}
function mQ(t) {
  return Math.trunc(t * sh);
}
function yQ(t) {
  return Math.trunc(t * ac);
}
function gQ(t, e, n) {
  const [r, o] = Ln(n?.in, t, e);
  if (isNaN(+r)) throw new TypeError("Start date is invalid");
  if (isNaN(+o)) throw new TypeError("End date is invalid");
  if (n?.assertPositive && +r > +o)
    throw new TypeError("End date must be after start date");
  return { start: r, end: o };
}
function vQ(t, e) {
  const { start: n, end: r } = fl(e?.in, t), o = {}, s = j8(r, n);
  s && (o.years = s);
  const i = Ad(n, { years: o.years }), u = t_(r, i);
  u && (o.months = u);
  const l = Ad(i, { months: o.months }), a = Ex(r, l);
  a && (o.days = a);
  const c = Ad(l, { days: o.days }), p = D0(r, c);
  p && (o.hours = p);
  const d = Ad(c, { hours: o.hours }), h = E0(r, d);
  h && (o.minutes = h);
  const m = Ad(d, { minutes: o.minutes }), g = uc(r, m);
  return g && (o.seconds = g), o;
}
function _Q(t, e, n) {
  let r;
  return wQ(e) ? r = e : n = e, new Intl.DateTimeFormat(n?.locale, r).format(
    Pe(t)
  );
}
function wQ(t) {
  return t !== void 0 && !("locale" in t);
}
function bQ(t, e, n) {
  let r = 0, o;
  const [s, i] = Ln(
    n?.in,
    t,
    e
  );
  if (n?.unit)
    o = n?.unit, o === "second" ? r = uc(s, i) : o === "minute" ? r = E0(s, i) : o === "hour" ? r = D0(s, i) : o === "day" ? r = tu(s, i) : o === "week" ? r = A0(s, i) : o === "month" ? r = R0(s, i) : o === "quarter" ? r = Vg(s, i) : o === "year" && (r = Qf(s, i));
  else {
    const l = uc(s, i);
    Math.abs(l) < Oa ? (r = uc(s, i), o = "second") : Math.abs(l) < ac ? (r = E0(s, i), o = "minute") : Math.abs(l) < ic && Math.abs(tu(s, i)) < 1 ? (r = D0(s, i), o = "hour") : Math.abs(l) < Ih && (r = tu(s, i)) && Math.abs(r) < 7 ? o = "day" : Math.abs(l) < C8 ? (r = A0(s, i), o = "week") : Math.abs(l) < TG ? (r = R0(s, i), o = "month") : Math.abs(l) < P8 && Vg(s, i) < 4 ? (r = Vg(s, i), o = "quarter") : (r = Qf(s, i), o = "year");
  }
  return new Intl.RelativeTimeFormat(n?.locale, {
    numeric: "auto",
    ...n
  }).format(r, o);
}
function kQ(t, e) {
  return +Pe(t) > +Pe(e);
}
function TQ(t, e) {
  return +Pe(t) < +Pe(e);
}
function xQ(t, e) {
  return +Pe(t) == +Pe(e);
}
function SQ(t, e, n) {
  const r = new Date(t, e, n);
  return r.getFullYear() === t && r.getMonth() === e && r.getDate() === n;
}
function RQ(t, e) {
  return Pe(t, e?.in).getDate() === 1;
}
function AQ(t, e) {
  return Pe(t, e?.in).getDay() === 5;
}
function DQ(t) {
  return +Pe(t) > Date.now();
}
function i3(t, e) {
  const n = EQ(e) ? new e(0) : gt(e, 0);
  return n.setFullYear(t.getFullYear(), t.getMonth(), t.getDate()), n.setHours(
    t.getHours(),
    t.getMinutes(),
    t.getSeconds(),
    t.getMilliseconds()
  ), n;
}
function EQ(t) {
  return typeof t == "function" && t.prototype?.constructor === t;
}
const MQ = 10;
class u3 {
  subPriority = 0;
  validate(e, n) {
    return !0;
  }
}
class PQ extends u3 {
  constructor(e, n, r, o, s) {
    super(), this.value = e, this.validateValue = n, this.setValue = r, this.priority = o, s && (this.subPriority = s);
  }
  validate(e, n) {
    return this.validateValue(e, this.value, n);
  }
  set(e, n, r) {
    return this.setValue(e, n, this.value, r);
  }
}
class CQ extends u3 {
  priority = MQ;
  subPriority = -1;
  constructor(e, n) {
    super(), this.context = e || ((r) => gt(n, r));
  }
  set(e, n) {
    return n.timestampIsSet ? e : gt(e, i3(e, this.context));
  }
}
class An {
  run(e, n, r, o) {
    const s = this.parse(e, n, r, o);
    return s ? {
      setter: new PQ(
        s.value,
        this.validate,
        this.set,
        this.priority,
        this.subPriority
      ),
      rest: s.rest
    } : null;
  }
  validate(e, n, r) {
    return !0;
  }
}
class OQ extends An {
  priority = 140;
  parse(e, n, r) {
    switch (n) {
      // AD, BC
      case "G":
      case "GG":
      case "GGG":
        return r.era(e, { width: "abbreviated" }) || r.era(e, { width: "narrow" });
      // A, B
      case "GGGGG":
        return r.era(e, { width: "narrow" });
      // Anno Domini, Before Christ
      case "GGGG":
      default:
        return r.era(e, { width: "wide" }) || r.era(e, { width: "abbreviated" }) || r.era(e, { width: "narrow" });
    }
  }
  set(e, n, r) {
    return n.era = r, e.setFullYear(r, 0, 1), e.setHours(0, 0, 0, 0), e;
  }
  incompatibleTokens = ["R", "u", "t", "T"];
}
const Nr = {
  month: /^(1[0-2]|0?\d)/,
  // 0 to 12
  date: /^(3[0-1]|[0-2]?\d)/,
  // 0 to 31
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
  // 0 to 366
  week: /^(5[0-3]|[0-4]?\d)/,
  // 0 to 53
  hour23h: /^(2[0-3]|[0-1]?\d)/,
  // 0 to 23
  hour24h: /^(2[0-4]|[0-1]?\d)/,
  // 0 to 24
  hour11h: /^(1[0-1]|0?\d)/,
  // 0 to 11
  hour12h: /^(1[0-2]|0?\d)/,
  // 0 to 12
  minute: /^[0-5]?\d/,
  // 0 to 59
  second: /^[0-5]?\d/,
  // 0 to 59
  singleDigit: /^\d/,
  // 0 to 9
  twoDigits: /^\d{1,2}/,
  // 0 to 99
  threeDigits: /^\d{1,3}/,
  // 0 to 999
  fourDigits: /^\d{1,4}/,
  // 0 to 9999
  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/,
  // 0 to 9, -0 to -9
  twoDigitsSigned: /^-?\d{1,2}/,
  // 0 to 99, -0 to -99
  threeDigitsSigned: /^-?\d{1,3}/,
  // 0 to 999, -0 to -999
  fourDigitsSigned: /^-?\d{1,4}/
  // 0 to 9999, -0 to -9999
}, Yi = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};
function Lr(t, e) {
  return t && {
    value: e(t.value),
    rest: t.rest
  };
}
function yr(t, e) {
  const n = e.match(t);
  return n ? {
    value: parseInt(n[0], 10),
    rest: e.slice(n[0].length)
  } : null;
}
function Qi(t, e) {
  const n = e.match(t);
  if (!n)
    return null;
  if (n[0] === "Z")
    return {
      value: 0,
      rest: e.slice(1)
    };
  const r = n[1] === "+" ? 1 : -1, o = n[2] ? parseInt(n[2], 10) : 0, s = n[3] ? parseInt(n[3], 10) : 0, i = n[5] ? parseInt(n[5], 10) : 0;
  return {
    value: r * (o * nl + s * Ia + i * Kv),
    rest: e.slice(n[0].length)
  };
}
function l3(t) {
  return yr(Nr.anyDigitsSigned, t);
}
function Er(t, e) {
  switch (t) {
    case 1:
      return yr(Nr.singleDigit, e);
    case 2:
      return yr(Nr.twoDigits, e);
    case 3:
      return yr(Nr.threeDigits, e);
    case 4:
      return yr(Nr.fourDigits, e);
    default:
      return yr(new RegExp("^\\d{1," + t + "}"), e);
  }
}
function C0(t, e) {
  switch (t) {
    case 1:
      return yr(Nr.singleDigitSigned, e);
    case 2:
      return yr(Nr.twoDigitsSigned, e);
    case 3:
      return yr(Nr.threeDigitsSigned, e);
    case 4:
      return yr(Nr.fourDigitsSigned, e);
    default:
      return yr(new RegExp("^-?\\d{1," + t + "}"), e);
  }
}
function Bx(t) {
  switch (t) {
    case "morning":
      return 4;
    case "evening":
      return 17;
    case "pm":
    case "noon":
    case "afternoon":
      return 12;
    case "am":
    case "midnight":
    case "night":
    default:
      return 0;
  }
}
function c3(t, e) {
  const n = e > 0, r = n ? e : 1 - e;
  let o;
  if (r <= 50)
    o = t || 100;
  else {
    const s = r + 50, i = Math.trunc(s / 100) * 100, u = t >= s % 100;
    o = t + i - (u ? 100 : 0);
  }
  return n ? o : 1 - o;
}
function p3(t) {
  return t % 400 === 0 || t % 4 === 0 && t % 100 !== 0;
}
class IQ extends An {
  priority = 130;
  incompatibleTokens = ["Y", "R", "u", "w", "I", "i", "e", "c", "t", "T"];
  parse(e, n, r) {
    const o = (s) => ({
      year: s,
      isTwoDigitYear: n === "yy"
    });
    switch (n) {
      case "y":
        return Lr(Er(4, e), o);
      case "yo":
        return Lr(
          r.ordinalNumber(e, {
            unit: "year"
          }),
          o
        );
      default:
        return Lr(Er(n.length, e), o);
    }
  }
  validate(e, n) {
    return n.isTwoDigitYear || n.year > 0;
  }
  set(e, n, r) {
    const o = e.getFullYear();
    if (r.isTwoDigitYear) {
      const i = c3(
        r.year,
        o
      );
      return e.setFullYear(i, 0, 1), e.setHours(0, 0, 0, 0), e;
    }
    const s = !("era" in n) || n.era === 1 ? r.year : 1 - r.year;
    return e.setFullYear(s, 0, 1), e.setHours(0, 0, 0, 0), e;
  }
}
class FQ extends An {
  priority = 130;
  parse(e, n, r) {
    const o = (s) => ({
      year: s,
      isTwoDigitYear: n === "YY"
    });
    switch (n) {
      case "Y":
        return Lr(Er(4, e), o);
      case "Yo":
        return Lr(
          r.ordinalNumber(e, {
            unit: "year"
          }),
          o
        );
      default:
        return Lr(Er(n.length, e), o);
    }
  }
  validate(e, n) {
    return n.isTwoDigitYear || n.year > 0;
  }
  set(e, n, r, o) {
    const s = r_(e, o);
    if (r.isTwoDigitYear) {
      const u = c3(
        r.year,
        s
      );
      return e.setFullYear(
        u,
        0,
        o.firstWeekContainsDate
      ), e.setHours(0, 0, 0, 0), Do(e, o);
    }
    const i = !("era" in n) || n.era === 1 ? r.year : 1 - r.year;
    return e.setFullYear(i, 0, o.firstWeekContainsDate), e.setHours(0, 0, 0, 0), Do(e, o);
  }
  incompatibleTokens = [
    "y",
    "R",
    "u",
    "Q",
    "q",
    "M",
    "L",
    "I",
    "d",
    "D",
    "i",
    "t",
    "T"
  ];
}
class NQ extends An {
  priority = 130;
  parse(e, n) {
    return C0(n === "R" ? 4 : n.length, e);
  }
  set(e, n, r) {
    const o = gt(e, 0);
    return o.setFullYear(r, 0, 4), o.setHours(0, 0, 0, 0), mi(o);
  }
  incompatibleTokens = [
    "G",
    "y",
    "Y",
    "u",
    "Q",
    "q",
    "M",
    "L",
    "w",
    "d",
    "D",
    "e",
    "c",
    "t",
    "T"
  ];
}
class LQ extends An {
  priority = 130;
  parse(e, n) {
    return C0(n === "u" ? 4 : n.length, e);
  }
  set(e, n, r) {
    return e.setFullYear(r, 0, 1), e.setHours(0, 0, 0, 0), e;
  }
  incompatibleTokens = ["G", "y", "Y", "R", "w", "I", "i", "e", "c", "t", "T"];
}
class BQ extends An {
  priority = 120;
  parse(e, n, r) {
    switch (n) {
      // 1, 2, 3, 4
      case "Q":
      case "QQ":
        return Er(n.length, e);
      // 1st, 2nd, 3rd, 4th
      case "Qo":
        return r.ordinalNumber(e, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "QQQ":
        return r.quarter(e, {
          width: "abbreviated",
          context: "formatting"
        }) || r.quarter(e, {
          width: "narrow",
          context: "formatting"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "QQQQQ":
        return r.quarter(e, {
          width: "narrow",
          context: "formatting"
        });
      // 1st quarter, 2nd quarter, ...
      case "QQQQ":
      default:
        return r.quarter(e, {
          width: "wide",
          context: "formatting"
        }) || r.quarter(e, {
          width: "abbreviated",
          context: "formatting"
        }) || r.quarter(e, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  validate(e, n) {
    return n >= 1 && n <= 4;
  }
  set(e, n, r) {
    return e.setMonth((r - 1) * 3, 1), e.setHours(0, 0, 0, 0), e;
  }
  incompatibleTokens = [
    "Y",
    "R",
    "q",
    "M",
    "L",
    "w",
    "I",
    "d",
    "D",
    "i",
    "e",
    "c",
    "t",
    "T"
  ];
}
class UQ extends An {
  priority = 120;
  parse(e, n, r) {
    switch (n) {
      // 1, 2, 3, 4
      case "q":
      case "qq":
        return Er(n.length, e);
      // 1st, 2nd, 3rd, 4th
      case "qo":
        return r.ordinalNumber(e, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "qqq":
        return r.quarter(e, {
          width: "abbreviated",
          context: "standalone"
        }) || r.quarter(e, {
          width: "narrow",
          context: "standalone"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "qqqqq":
        return r.quarter(e, {
          width: "narrow",
          context: "standalone"
        });
      // 1st quarter, 2nd quarter, ...
      case "qqqq":
      default:
        return r.quarter(e, {
          width: "wide",
          context: "standalone"
        }) || r.quarter(e, {
          width: "abbreviated",
          context: "standalone"
        }) || r.quarter(e, {
          width: "narrow",
          context: "standalone"
        });
    }
  }
  validate(e, n) {
    return n >= 1 && n <= 4;
  }
  set(e, n, r) {
    return e.setMonth((r - 1) * 3, 1), e.setHours(0, 0, 0, 0), e;
  }
  incompatibleTokens = [
    "Y",
    "R",
    "Q",
    "M",
    "L",
    "w",
    "I",
    "d",
    "D",
    "i",
    "e",
    "c",
    "t",
    "T"
  ];
}
class XQ extends An {
  incompatibleTokens = [
    "Y",
    "R",
    "q",
    "Q",
    "L",
    "w",
    "I",
    "D",
    "i",
    "e",
    "c",
    "t",
    "T"
  ];
  priority = 110;
  parse(e, n, r) {
    const o = (s) => s - 1;
    switch (n) {
      // 1, 2, ..., 12
      case "M":
        return Lr(
          yr(Nr.month, e),
          o
        );
      // 01, 02, ..., 12
      case "MM":
        return Lr(Er(2, e), o);
      // 1st, 2nd, ..., 12th
      case "Mo":
        return Lr(
          r.ordinalNumber(e, {
            unit: "month"
          }),
          o
        );
      // Jan, Feb, ..., Dec
      case "MMM":
        return r.month(e, {
          width: "abbreviated",
          context: "formatting"
        }) || r.month(e, { width: "narrow", context: "formatting" });
      // J, F, ..., D
      case "MMMMM":
        return r.month(e, {
          width: "narrow",
          context: "formatting"
        });
      // January, February, ..., December
      case "MMMM":
      default:
        return r.month(e, { width: "wide", context: "formatting" }) || r.month(e, {
          width: "abbreviated",
          context: "formatting"
        }) || r.month(e, { width: "narrow", context: "formatting" });
    }
  }
  validate(e, n) {
    return n >= 0 && n <= 11;
  }
  set(e, n, r) {
    return e.setMonth(r, 1), e.setHours(0, 0, 0, 0), e;
  }
}
class $Q extends An {
  priority = 110;
  parse(e, n, r) {
    const o = (s) => s - 1;
    switch (n) {
      // 1, 2, ..., 12
      case "L":
        return Lr(
          yr(Nr.month, e),
          o
        );
      // 01, 02, ..., 12
      case "LL":
        return Lr(Er(2, e), o);
      // 1st, 2nd, ..., 12th
      case "Lo":
        return Lr(
          r.ordinalNumber(e, {
            unit: "month"
          }),
          o
        );
      // Jan, Feb, ..., Dec
      case "LLL":
        return r.month(e, {
          width: "abbreviated",
          context: "standalone"
        }) || r.month(e, { width: "narrow", context: "standalone" });
      // J, F, ..., D
      case "LLLLL":
        return r.month(e, {
          width: "narrow",
          context: "standalone"
        });
      // January, February, ..., December
      case "LLLL":
      default:
        return r.month(e, { width: "wide", context: "standalone" }) || r.month(e, {
          width: "abbreviated",
          context: "standalone"
        }) || r.month(e, { width: "narrow", context: "standalone" });
    }
  }
  validate(e, n) {
    return n >= 0 && n <= 11;
  }
  set(e, n, r) {
    return e.setMonth(r, 1), e.setHours(0, 0, 0, 0), e;
  }
  incompatibleTokens = [
    "Y",
    "R",
    "q",
    "Q",
    "M",
    "w",
    "I",
    "D",
    "i",
    "e",
    "c",
    "t",
    "T"
  ];
}
function d3(t, e, n) {
  const r = Pe(t, n?.in), o = Nx(r, n) - e;
  return r.setDate(r.getDate() - o * 7), Pe(r, n?.in);
}
class WQ extends An {
  priority = 100;
  parse(e, n, r) {
    switch (n) {
      case "w":
        return yr(Nr.week, e);
      case "wo":
        return r.ordinalNumber(e, { unit: "week" });
      default:
        return Er(n.length, e);
    }
  }
  validate(e, n) {
    return n >= 1 && n <= 53;
  }
  set(e, n, r, o) {
    return Do(d3(e, r, o), o);
  }
  incompatibleTokens = [
    "y",
    "R",
    "u",
    "q",
    "Q",
    "M",
    "L",
    "I",
    "d",
    "D",
    "i",
    "t",
    "T"
  ];
}
function h3(t, e, n) {
  const r = Pe(t, n?.in), o = Fx(r, n) - e;
  return r.setDate(r.getDate() - o * 7), r;
}
class VQ extends An {
  priority = 100;
  parse(e, n, r) {
    switch (n) {
      case "I":
        return yr(Nr.week, e);
      case "Io":
        return r.ordinalNumber(e, { unit: "week" });
      default:
        return Er(n.length, e);
    }
  }
  validate(e, n) {
    return n >= 1 && n <= 53;
  }
  set(e, n, r) {
    return mi(h3(e, r));
  }
  incompatibleTokens = [
    "y",
    "Y",
    "u",
    "q",
    "Q",
    "M",
    "L",
    "w",
    "d",
    "D",
    "e",
    "c",
    "t",
    "T"
  ];
}
const HQ = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], jQ = [
  31,
  29,
  31,
  30,
  31,
  30,
  31,
  31,
  30,
  31,
  30,
  31
];
class zQ extends An {
  priority = 90;
  subPriority = 1;
  parse(e, n, r) {
    switch (n) {
      case "d":
        return yr(Nr.date, e);
      case "do":
        return r.ordinalNumber(e, { unit: "date" });
      default:
        return Er(n.length, e);
    }
  }
  validate(e, n) {
    const r = e.getFullYear(), o = p3(r), s = e.getMonth();
    return o ? n >= 1 && n <= jQ[s] : n >= 1 && n <= HQ[s];
  }
  set(e, n, r) {
    return e.setDate(r), e.setHours(0, 0, 0, 0), e;
  }
  incompatibleTokens = [
    "Y",
    "R",
    "q",
    "Q",
    "w",
    "I",
    "D",
    "i",
    "e",
    "c",
    "t",
    "T"
  ];
}
class qQ extends An {
  priority = 90;
  subpriority = 1;
  parse(e, n, r) {
    switch (n) {
      case "D":
      case "DD":
        return yr(Nr.dayOfYear, e);
      case "Do":
        return r.ordinalNumber(e, { unit: "date" });
      default:
        return Er(n.length, e);
    }
  }
  validate(e, n) {
    const r = e.getFullYear();
    return p3(r) ? n >= 1 && n <= 366 : n >= 1 && n <= 365;
  }
  set(e, n, r) {
    return e.setMonth(0, r), e.setHours(0, 0, 0, 0), e;
  }
  incompatibleTokens = [
    "Y",
    "R",
    "q",
    "Q",
    "M",
    "L",
    "w",
    "I",
    "d",
    "E",
    "i",
    "e",
    "c",
    "t",
    "T"
  ];
}
function s_(t, e, n) {
  const r = os(), o = n?.weekStartsOn ?? n?.locale?.options?.weekStartsOn ?? r.weekStartsOn ?? r.locale?.options?.weekStartsOn ?? 0, s = Pe(t, n?.in), i = s.getDay(), l = (e % 7 + 7) % 7, a = 7 - o, c = e < 0 || e > 6 ? e - (i + a) % 7 : (l + a) % 7 - (i + a) % 7;
  return pu(s, c, n);
}
class GQ extends An {
  priority = 90;
  parse(e, n, r) {
    switch (n) {
      // Tue
      case "E":
      case "EE":
      case "EEE":
        return r.day(e, {
          width: "abbreviated",
          context: "formatting"
        }) || r.day(e, { width: "short", context: "formatting" }) || r.day(e, { width: "narrow", context: "formatting" });
      // T
      case "EEEEE":
        return r.day(e, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "EEEEEE":
        return r.day(e, { width: "short", context: "formatting" }) || r.day(e, { width: "narrow", context: "formatting" });
      // Tuesday
      case "EEEE":
      default:
        return r.day(e, { width: "wide", context: "formatting" }) || r.day(e, {
          width: "abbreviated",
          context: "formatting"
        }) || r.day(e, { width: "short", context: "formatting" }) || r.day(e, { width: "narrow", context: "formatting" });
    }
  }
  validate(e, n) {
    return n >= 0 && n <= 6;
  }
  set(e, n, r, o) {
    return e = s_(e, r, o), e.setHours(0, 0, 0, 0), e;
  }
  incompatibleTokens = ["D", "i", "e", "c", "t", "T"];
}
class YQ extends An {
  priority = 90;
  parse(e, n, r, o) {
    const s = (i) => {
      const u = Math.floor((i - 1) / 7) * 7;
      return (i + o.weekStartsOn + 6) % 7 + u;
    };
    switch (n) {
      // 3
      case "e":
      case "ee":
        return Lr(Er(n.length, e), s);
      // 3rd
      case "eo":
        return Lr(
          r.ordinalNumber(e, {
            unit: "day"
          }),
          s
        );
      // Tue
      case "eee":
        return r.day(e, {
          width: "abbreviated",
          context: "formatting"
        }) || r.day(e, { width: "short", context: "formatting" }) || r.day(e, { width: "narrow", context: "formatting" });
      // T
      case "eeeee":
        return r.day(e, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "eeeeee":
        return r.day(e, { width: "short", context: "formatting" }) || r.day(e, { width: "narrow", context: "formatting" });
      // Tuesday
      case "eeee":
      default:
        return r.day(e, { width: "wide", context: "formatting" }) || r.day(e, {
          width: "abbreviated",
          context: "formatting"
        }) || r.day(e, { width: "short", context: "formatting" }) || r.day(e, { width: "narrow", context: "formatting" });
    }
  }
  validate(e, n) {
    return n >= 0 && n <= 6;
  }
  set(e, n, r, o) {
    return e = s_(e, r, o), e.setHours(0, 0, 0, 0), e;
  }
  incompatibleTokens = [
    "y",
    "R",
    "u",
    "q",
    "Q",
    "M",
    "L",
    "I",
    "d",
    "D",
    "E",
    "i",
    "c",
    "t",
    "T"
  ];
}
class QQ extends An {
  priority = 90;
  parse(e, n, r, o) {
    const s = (i) => {
      const u = Math.floor((i - 1) / 7) * 7;
      return (i + o.weekStartsOn + 6) % 7 + u;
    };
    switch (n) {
      // 3
      case "c":
      case "cc":
        return Lr(Er(n.length, e), s);
      // 3rd
      case "co":
        return Lr(
          r.ordinalNumber(e, {
            unit: "day"
          }),
          s
        );
      // Tue
      case "ccc":
        return r.day(e, {
          width: "abbreviated",
          context: "standalone"
        }) || r.day(e, { width: "short", context: "standalone" }) || r.day(e, { width: "narrow", context: "standalone" });
      // T
      case "ccccc":
        return r.day(e, {
          width: "narrow",
          context: "standalone"
        });
      // Tu
      case "cccccc":
        return r.day(e, { width: "short", context: "standalone" }) || r.day(e, { width: "narrow", context: "standalone" });
      // Tuesday
      case "cccc":
      default:
        return r.day(e, { width: "wide", context: "standalone" }) || r.day(e, {
          width: "abbreviated",
          context: "standalone"
        }) || r.day(e, { width: "short", context: "standalone" }) || r.day(e, { width: "narrow", context: "standalone" });
    }
  }
  validate(e, n) {
    return n >= 0 && n <= 6;
  }
  set(e, n, r, o) {
    return e = s_(e, r, o), e.setHours(0, 0, 0, 0), e;
  }
  incompatibleTokens = [
    "y",
    "R",
    "u",
    "q",
    "Q",
    "M",
    "L",
    "I",
    "d",
    "D",
    "E",
    "i",
    "e",
    "t",
    "T"
  ];
}
function f3(t, e, n) {
  const r = Pe(t, n?.in), o = s3(r, n), s = e - o;
  return pu(r, s, n);
}
class KQ extends An {
  priority = 90;
  parse(e, n, r) {
    const o = (s) => s === 0 ? 7 : s;
    switch (n) {
      // 2
      case "i":
      case "ii":
        return Er(n.length, e);
      // 2nd
      case "io":
        return r.ordinalNumber(e, { unit: "day" });
      // Tue
      case "iii":
        return Lr(
          r.day(e, {
            width: "abbreviated",
            context: "formatting"
          }) || r.day(e, {
            width: "short",
            context: "formatting"
          }) || r.day(e, {
            width: "narrow",
            context: "formatting"
          }),
          o
        );
      // T
      case "iiiii":
        return Lr(
          r.day(e, {
            width: "narrow",
            context: "formatting"
          }),
          o
        );
      // Tu
      case "iiiiii":
        return Lr(
          r.day(e, {
            width: "short",
            context: "formatting"
          }) || r.day(e, {
            width: "narrow",
            context: "formatting"
          }),
          o
        );
      // Tuesday
      case "iiii":
      default:
        return Lr(
          r.day(e, {
            width: "wide",
            context: "formatting"
          }) || r.day(e, {
            width: "abbreviated",
            context: "formatting"
          }) || r.day(e, {
            width: "short",
            context: "formatting"
          }) || r.day(e, {
            width: "narrow",
            context: "formatting"
          }),
          o
        );
    }
  }
  validate(e, n) {
    return n >= 1 && n <= 7;
  }
  set(e, n, r) {
    return e = f3(e, r), e.setHours(0, 0, 0, 0), e;
  }
  incompatibleTokens = [
    "y",
    "Y",
    "u",
    "q",
    "Q",
    "M",
    "L",
    "w",
    "d",
    "D",
    "E",
    "e",
    "c",
    "t",
    "T"
  ];
}
class ZQ extends An {
  priority = 80;
  parse(e, n, r) {
    switch (n) {
      case "a":
      case "aa":
      case "aaa":
        return r.dayPeriod(e, {
          width: "abbreviated",
          context: "formatting"
        }) || r.dayPeriod(e, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaaa":
        return r.dayPeriod(e, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return r.dayPeriod(e, {
          width: "wide",
          context: "formatting"
        }) || r.dayPeriod(e, {
          width: "abbreviated",
          context: "formatting"
        }) || r.dayPeriod(e, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(e, n, r) {
    return e.setHours(Bx(r), 0, 0, 0), e;
  }
  incompatibleTokens = ["b", "B", "H", "k", "t", "T"];
}
class JQ extends An {
  priority = 80;
  parse(e, n, r) {
    switch (n) {
      case "b":
      case "bb":
      case "bbb":
        return r.dayPeriod(e, {
          width: "abbreviated",
          context: "formatting"
        }) || r.dayPeriod(e, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbbb":
        return r.dayPeriod(e, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return r.dayPeriod(e, {
          width: "wide",
          context: "formatting"
        }) || r.dayPeriod(e, {
          width: "abbreviated",
          context: "formatting"
        }) || r.dayPeriod(e, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(e, n, r) {
    return e.setHours(Bx(r), 0, 0, 0), e;
  }
  incompatibleTokens = ["a", "B", "H", "k", "t", "T"];
}
class eK extends An {
  priority = 80;
  parse(e, n, r) {
    switch (n) {
      case "B":
      case "BB":
      case "BBB":
        return r.dayPeriod(e, {
          width: "abbreviated",
          context: "formatting"
        }) || r.dayPeriod(e, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBBB":
        return r.dayPeriod(e, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return r.dayPeriod(e, {
          width: "wide",
          context: "formatting"
        }) || r.dayPeriod(e, {
          width: "abbreviated",
          context: "formatting"
        }) || r.dayPeriod(e, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(e, n, r) {
    return e.setHours(Bx(r), 0, 0, 0), e;
  }
  incompatibleTokens = ["a", "b", "t", "T"];
}
class tK extends An {
  priority = 70;
  parse(e, n, r) {
    switch (n) {
      case "h":
        return yr(Nr.hour12h, e);
      case "ho":
        return r.ordinalNumber(e, { unit: "hour" });
      default:
        return Er(n.length, e);
    }
  }
  validate(e, n) {
    return n >= 1 && n <= 12;
  }
  set(e, n, r) {
    const o = e.getHours() >= 12;
    return o && r < 12 ? e.setHours(r + 12, 0, 0, 0) : !o && r === 12 ? e.setHours(0, 0, 0, 0) : e.setHours(r, 0, 0, 0), e;
  }
  incompatibleTokens = ["H", "K", "k", "t", "T"];
}
class nK extends An {
  priority = 70;
  parse(e, n, r) {
    switch (n) {
      case "H":
        return yr(Nr.hour23h, e);
      case "Ho":
        return r.ordinalNumber(e, { unit: "hour" });
      default:
        return Er(n.length, e);
    }
  }
  validate(e, n) {
    return n >= 0 && n <= 23;
  }
  set(e, n, r) {
    return e.setHours(r, 0, 0, 0), e;
  }
  incompatibleTokens = ["a", "b", "h", "K", "k", "t", "T"];
}
class rK extends An {
  priority = 70;
  parse(e, n, r) {
    switch (n) {
      case "K":
        return yr(Nr.hour11h, e);
      case "Ko":
        return r.ordinalNumber(e, { unit: "hour" });
      default:
        return Er(n.length, e);
    }
  }
  validate(e, n) {
    return n >= 0 && n <= 11;
  }
  set(e, n, r) {
    return e.getHours() >= 12 && r < 12 ? e.setHours(r + 12, 0, 0, 0) : e.setHours(r, 0, 0, 0), e;
  }
  incompatibleTokens = ["h", "H", "k", "t", "T"];
}
class oK extends An {
  priority = 70;
  parse(e, n, r) {
    switch (n) {
      case "k":
        return yr(Nr.hour24h, e);
      case "ko":
        return r.ordinalNumber(e, { unit: "hour" });
      default:
        return Er(n.length, e);
    }
  }
  validate(e, n) {
    return n >= 1 && n <= 24;
  }
  set(e, n, r) {
    const o = r <= 24 ? r % 24 : r;
    return e.setHours(o, 0, 0, 0), e;
  }
  incompatibleTokens = ["a", "b", "h", "H", "K", "t", "T"];
}
class sK extends An {
  priority = 60;
  parse(e, n, r) {
    switch (n) {
      case "m":
        return yr(Nr.minute, e);
      case "mo":
        return r.ordinalNumber(e, { unit: "minute" });
      default:
        return Er(n.length, e);
    }
  }
  validate(e, n) {
    return n >= 0 && n <= 59;
  }
  set(e, n, r) {
    return e.setMinutes(r, 0, 0), e;
  }
  incompatibleTokens = ["t", "T"];
}
class aK extends An {
  priority = 50;
  parse(e, n, r) {
    switch (n) {
      case "s":
        return yr(Nr.second, e);
      case "so":
        return r.ordinalNumber(e, { unit: "second" });
      default:
        return Er(n.length, e);
    }
  }
  validate(e, n) {
    return n >= 0 && n <= 59;
  }
  set(e, n, r) {
    return e.setSeconds(r, 0), e;
  }
  incompatibleTokens = ["t", "T"];
}
class iK extends An {
  priority = 30;
  parse(e, n) {
    const r = (o) => Math.trunc(o * Math.pow(10, -n.length + 3));
    return Lr(Er(n.length, e), r);
  }
  set(e, n, r) {
    return e.setMilliseconds(r), e;
  }
  incompatibleTokens = ["t", "T"];
}
class uK extends An {
  priority = 10;
  parse(e, n) {
    switch (n) {
      case "X":
        return Qi(
          Yi.basicOptionalMinutes,
          e
        );
      case "XX":
        return Qi(Yi.basic, e);
      case "XXXX":
        return Qi(
          Yi.basicOptionalSeconds,
          e
        );
      case "XXXXX":
        return Qi(
          Yi.extendedOptionalSeconds,
          e
        );
      case "XXX":
      default:
        return Qi(Yi.extended, e);
    }
  }
  set(e, n, r) {
    return n.timestampIsSet ? e : gt(
      e,
      e.getTime() - As(e) - r
    );
  }
  incompatibleTokens = ["t", "T", "x"];
}
class lK extends An {
  priority = 10;
  parse(e, n) {
    switch (n) {
      case "x":
        return Qi(
          Yi.basicOptionalMinutes,
          e
        );
      case "xx":
        return Qi(Yi.basic, e);
      case "xxxx":
        return Qi(
          Yi.basicOptionalSeconds,
          e
        );
      case "xxxxx":
        return Qi(
          Yi.extendedOptionalSeconds,
          e
        );
      case "xxx":
      default:
        return Qi(Yi.extended, e);
    }
  }
  set(e, n, r) {
    return n.timestampIsSet ? e : gt(
      e,
      e.getTime() - As(e) - r
    );
  }
  incompatibleTokens = ["t", "T", "X"];
}
class cK extends An {
  priority = 40;
  parse(e) {
    return l3(e);
  }
  set(e, n, r) {
    return [gt(e, r * 1e3), { timestampIsSet: !0 }];
  }
  incompatibleTokens = "*";
}
class pK extends An {
  priority = 20;
  parse(e) {
    return l3(e);
  }
  set(e, n, r) {
    return [gt(e, r), { timestampIsSet: !0 }];
  }
  incompatibleTokens = "*";
}
const m3 = {
  G: new OQ(),
  y: new IQ(),
  Y: new FQ(),
  R: new NQ(),
  u: new LQ(),
  Q: new BQ(),
  q: new UQ(),
  M: new XQ(),
  L: new $Q(),
  w: new WQ(),
  I: new VQ(),
  d: new zQ(),
  D: new qQ(),
  E: new GQ(),
  e: new YQ(),
  c: new QQ(),
  i: new KQ(),
  a: new ZQ(),
  b: new JQ(),
  B: new eK(),
  h: new tK(),
  H: new nK(),
  K: new rK(),
  k: new oK(),
  m: new sK(),
  s: new aK(),
  S: new iK(),
  X: new uK(),
  x: new lK(),
  t: new cK(),
  T: new pK()
}, dK = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, hK = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, fK = /^'([^]*?)'?$/, mK = /''/g, yK = /\S/, gK = /[a-zA-Z]/;
function ki(t, e, n, r) {
  const o = () => gt(r?.in || n, NaN), s = Lx(), i = r?.locale ?? s.locale ?? Fh, u = r?.firstWeekContainsDate ?? r?.locale?.options?.firstWeekContainsDate ?? s.firstWeekContainsDate ?? s.locale?.options?.firstWeekContainsDate ?? 1, l = r?.weekStartsOn ?? r?.locale?.options?.weekStartsOn ?? s.weekStartsOn ?? s.locale?.options?.weekStartsOn ?? 0;
  if (!e)
    return t ? o() : Pe(n, r?.in);
  const a = {
    firstWeekContainsDate: u,
    weekStartsOn: l,
    locale: i
  }, c = [new CQ(r?.in, n)], p = e.match(hK).map((_) => {
    const b = _[0];
    if (b in P0) {
      const x = P0[b];
      return x(_, i.formatLong);
    }
    return _;
  }).join("").match(dK), d = [];
  for (let _ of p) {
    !r?.useAdditionalWeekYearTokens && J8(_) && dk(_, e, t), !r?.useAdditionalDayOfYearTokens && Z8(_) && dk(_, e, t);
    const b = _[0], x = m3[b];
    if (x) {
      const { incompatibleTokens: S } = x;
      if (Array.isArray(S)) {
        const A = d.find(
          (C) => S.includes(C.token) || C.token === b
        );
        if (A)
          throw new RangeError(
            `The format string mustn't contain \`${A.fullToken}\` and \`${_}\` at the same time`
          );
      } else if (x.incompatibleTokens === "*" && d.length > 0)
        throw new RangeError(
          `The format string mustn't contain \`${_}\` and any other token at the same time`
        );
      d.push({ token: b, fullToken: _ });
      const E = x.run(
        t,
        _,
        i.match,
        a
      );
      if (!E)
        return o();
      c.push(E.setter), t = E.rest;
    } else {
      if (b.match(gK))
        throw new RangeError(
          "Format string contains an unescaped latin alphabet character `" + b + "`"
        );
      if (_ === "''" ? _ = "'" : b === "'" && (_ = vK(_)), t.indexOf(_) === 0)
        t = t.slice(_.length);
      else
        return o();
    }
  }
  if (t.length > 0 && yK.test(t))
    return o();
  const h = c.map((_) => _.priority).sort((_, b) => b - _).filter((_, b, x) => x.indexOf(_) === b).map(
    (_) => c.filter((b) => b.priority === _).sort((b, x) => x.subPriority - b.subPriority)
  ).map((_) => _[0]);
  let m = Pe(n, r?.in);
  if (isNaN(+m)) return o();
  const g = {};
  for (const _ of h) {
    if (!_.validate(m, a))
      return o();
    const b = _.set(m, g, a);
    Array.isArray(b) ? (m = b[0], Object.assign(g, b[1])) : m = b;
  }
  return m;
}
function vK(t) {
  return t.match(fK)[1].replace(mK, "'");
}
function _K(t, e, n) {
  return Fa(ki(t, e, /* @__PURE__ */ new Date(), n));
}
function wK(t, e) {
  return Pe(t, e?.in).getDay() === 1;
}
function bK(t) {
  return +Pe(t) < Date.now();
}
function hk(t, e) {
  const n = Pe(t, e?.in);
  return n.setMinutes(0, 0, 0), n;
}
function y3(t, e, n) {
  const [r, o] = Ln(
    n?.in,
    t,
    e
  );
  return +hk(r) == +hk(o);
}
function Ux(t, e, n) {
  const [r, o] = Ln(
    n?.in,
    t,
    e
  );
  return +Do(r, n) == +Do(o, n);
}
function g3(t, e, n) {
  return Ux(t, e, { ...n, weekStartsOn: 1 });
}
function kK(t, e, n) {
  const [r, o] = Ln(
    n?.in,
    t,
    e
  );
  return +hc(r) == +hc(o);
}
function fk(t, e) {
  const n = Pe(t, e?.in);
  return n.setSeconds(0, 0), n;
}
function v3(t, e) {
  return +fk(t) == +fk(e);
}
function _3(t, e, n) {
  const [r, o] = Ln(
    n?.in,
    t,
    e
  );
  return r.getFullYear() === o.getFullYear() && r.getMonth() === o.getMonth();
}
function w3(t, e, n) {
  const [r, o] = Ln(
    n?.in,
    t,
    e
  );
  return +dp(r) == +dp(o);
}
function mk(t, e) {
  const n = Pe(t, e?.in);
  return n.setMilliseconds(0), n;
}
function b3(t, e) {
  return +mk(t) == +mk(e);
}
function k3(t, e, n) {
  const [r, o] = Ln(
    n?.in,
    t,
    e
  );
  return r.getFullYear() === o.getFullYear();
}
function TK(t, e) {
  return y3(
    Pe(t, e?.in),
    Jr(e?.in || t)
  );
}
function xK(t, e) {
  return g3(
    gt(e?.in || t, t),
    Jr(e?.in || t)
  );
}
function SK(t) {
  return v3(t, Jr(t));
}
function RK(t, e) {
  return _3(
    gt(e?.in || t, t),
    Jr(e?.in || t)
  );
}
function AK(t, e) {
  return w3(
    gt(e?.in || t, t),
    Jr(e?.in || t)
  );
}
function DK(t) {
  return b3(t, Jr(t));
}
function EK(t, e) {
  return Ux(
    gt(e?.in || t, t),
    Jr(e?.in || t),
    e
  );
}
function MK(t, e) {
  return k3(
    gt(e?.in || t, t),
    Jr(e?.in || t)
  );
}
function PK(t, e) {
  return Pe(t, e?.in).getDay() === 4;
}
function CK(t, e) {
  return $m(
    gt(e?.in || t, t),
    Jr(e?.in || t)
  );
}
function OK(t, e) {
  return $m(
    t,
    pu(Jr(e?.in || t), 1),
    e
  );
}
function IK(t, e) {
  return Pe(t, e?.in).getDay() === 2;
}
function FK(t, e) {
  return Pe(t, e?.in).getDay() === 3;
}
function NK(t, e, n) {
  const r = +Pe(t, n?.in), [o, s] = [
    +Pe(e.start, n?.in),
    +Pe(e.end, n?.in)
  ].sort((i, u) => i - u);
  return r >= o && r <= s;
}
function a_(t, e, n) {
  return pu(t, -e, n);
}
function LK(t, e) {
  return $m(
    gt(e?.in || t, t),
    a_(Jr(e?.in || t), 1)
  );
}
function BK(t, e) {
  const n = Pe(t, e?.in), r = n.getFullYear(), o = 9 + Math.floor(r / 10) * 10;
  return n.setFullYear(o + 1, 0, 0), n.setHours(0, 0, 0, 0), Pe(n, e?.in);
}
function T3(t, e) {
  const n = os(), r = e?.weekStartsOn ?? e?.locale?.options?.weekStartsOn ?? n.weekStartsOn ?? n.locale?.options?.weekStartsOn ?? 0, o = Pe(t, e?.in), s = o.getDay(), i = (s < r ? -7 : 0) + 6 - (s - r);
  return o.setHours(0, 0, 0, 0), o.setDate(o.getDate() + i), o;
}
function UK(t, e) {
  return T3(t, { ...e, weekStartsOn: 1 });
}
function XK(t, e) {
  const n = dc(t, e), r = gt(e?.in || t, 0);
  r.setFullYear(n + 1, 0, 4), r.setHours(0, 0, 0, 0);
  const o = mi(r, e);
  return o.setDate(o.getDate() - 1), o;
}
function $K(t, e) {
  const n = Pe(t, e?.in), r = n.getMonth(), o = r - r % 3 + 3;
  return n.setMonth(o, 0), n.setHours(0, 0, 0, 0), n;
}
function WK(t, e) {
  const n = Pe(t, e?.in), r = n.getFullYear();
  return n.setFullYear(r + 1, 0, 0), n.setHours(0, 0, 0, 0), n;
}
const VK = /(\w)\1*|''|'(''|[^'])+('|$)|./g, HK = /^'([^]*?)'?$/, jK = /''/g, zK = /[a-zA-Z]/;
function qK(t, e) {
  const n = Pe(t);
  if (!Fa(n))
    throw new RangeError("Invalid time value");
  const r = e.match(VK);
  return r ? r.map((s) => {
    if (s === "''")
      return "'";
    const i = s[0];
    if (i === "'")
      return GK(s);
    const u = ji[i];
    if (u)
      return u(n, s);
    if (i.match(zK))
      throw new RangeError(
        "Format string contains an unescaped latin alphabet character `" + i + "`"
      );
    return s;
  }).join("") : "";
}
function GK(t) {
  const e = t.match(HK);
  return e ? e[1].replace(jK, "'") : t;
}
function YK({
  years: t,
  months: e,
  weeks: n,
  days: r,
  hours: o,
  minutes: s,
  seconds: i
}) {
  let u = 0;
  t && (u += t * x0), e && (u += e * (x0 / 12)), n && (u += n * 7), r && (u += r);
  let l = u * 24 * 60 * 60;
  return o && (l += o * 60 * 60), s && (l += s * 60), i && (l += i), Math.trunc(l * 1e3);
}
function QK(t) {
  const e = t / nl;
  return Math.trunc(e);
}
function x3(t) {
  const e = t / Ia;
  return Math.trunc(e);
}
function KK(t) {
  const e = t / Kv;
  return Math.trunc(e);
}
function ZK(t) {
  const e = t / sh;
  return Math.trunc(e);
}
function S3(t) {
  return Math.trunc(t * Ia);
}
function JK(t) {
  return Math.trunc(t * Oa);
}
function eZ(t) {
  const e = t / D8;
  return Math.trunc(e);
}
function tZ(t) {
  const e = t / E8;
  return Math.trunc(e);
}
function Sc(t, e, n) {
  let r = e - o_(t, n);
  return r <= 0 && (r += 7), pu(t, r, n);
}
function nZ(t, e) {
  return Sc(t, 5, e);
}
function rZ(t, e) {
  return Sc(t, 1, e);
}
function oZ(t, e) {
  return Sc(t, 6, e);
}
function sZ(t, e) {
  return Sc(t, 0, e);
}
function aZ(t, e) {
  return Sc(t, 4, e);
}
function iZ(t, e) {
  return Sc(t, 2, e);
}
function uZ(t, e) {
  return Sc(t, 3, e);
}
function Hg(t, e) {
  const n = () => gt(e?.in, NaN), r = e?.additionalDigits ?? 2, o = dZ(t);
  let s;
  if (o.date) {
    const a = hZ(o.date, r);
    s = fZ(a.restDateString, a.year);
  }
  if (!s || isNaN(+s)) return n();
  const i = +s;
  let u = 0, l;
  if (o.time && (u = mZ(o.time), isNaN(u)))
    return n();
  if (o.timezone) {
    if (l = yZ(o.timezone), isNaN(l)) return n();
  } else {
    const a = new Date(i + u), c = Pe(0, e?.in);
    return c.setFullYear(
      a.getUTCFullYear(),
      a.getUTCMonth(),
      a.getUTCDate()
    ), c.setHours(
      a.getUTCHours(),
      a.getUTCMinutes(),
      a.getUTCSeconds(),
      a.getUTCMilliseconds()
    ), c;
  }
  return Pe(i + u + l, e?.in);
}
const sg = {
  dateTimeDelimiter: /[T ]/,
  timeZoneDelimiter: /[Z ]/i,
  timezone: /([Z+-].*)$/
}, lZ = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/, cZ = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/, pZ = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function dZ(t) {
  const e = {}, n = t.split(sg.dateTimeDelimiter);
  let r;
  if (n.length > 2)
    return e;
  if (/:/.test(n[0]) ? r = n[0] : (e.date = n[0], r = n[1], sg.timeZoneDelimiter.test(e.date) && (e.date = t.split(sg.timeZoneDelimiter)[0], r = t.substr(
    e.date.length,
    t.length
  ))), r) {
    const o = sg.timezone.exec(r);
    o ? (e.time = r.replace(o[1], ""), e.timezone = o[1]) : e.time = r;
  }
  return e;
}
function hZ(t, e) {
  const n = new RegExp(
    "^(?:(\\d{4}|[+-]\\d{" + (4 + e) + "})|(\\d{2}|[+-]\\d{" + (2 + e) + "})$)"
  ), r = t.match(n);
  if (!r) return { year: NaN, restDateString: "" };
  const o = r[1] ? parseInt(r[1]) : null, s = r[2] ? parseInt(r[2]) : null;
  return {
    year: s === null ? o : s * 100,
    restDateString: t.slice((r[1] || r[2]).length)
  };
}
function fZ(t, e) {
  if (e === null) return /* @__PURE__ */ new Date(NaN);
  const n = t.match(lZ);
  if (!n) return /* @__PURE__ */ new Date(NaN);
  const r = !!n[4], o = hf(n[1]), s = hf(n[2]) - 1, i = hf(n[3]), u = hf(n[4]), l = hf(n[5]) - 1;
  if (r)
    return bZ(e, u, l) ? gZ(e, u, l) : /* @__PURE__ */ new Date(NaN);
  {
    const a = /* @__PURE__ */ new Date(0);
    return !_Z(e, s, i) || !wZ(e, o) ? /* @__PURE__ */ new Date(NaN) : (a.setUTCFullYear(e, s, Math.max(o, i)), a);
  }
}
function hf(t) {
  return t ? parseInt(t) : 1;
}
function mZ(t) {
  const e = t.match(cZ);
  if (!e) return NaN;
  const n = w1(e[1]), r = w1(e[2]), o = w1(e[3]);
  return kZ(n, r, o) ? n * nl + r * Ia + o * 1e3 : NaN;
}
function w1(t) {
  return t && parseFloat(t.replace(",", ".")) || 0;
}
function yZ(t) {
  if (t === "Z") return 0;
  const e = t.match(pZ);
  if (!e) return 0;
  const n = e[1] === "+" ? -1 : 1, r = parseInt(e[2]), o = e[3] && parseInt(e[3]) || 0;
  return TZ(r, o) ? n * (r * nl + o * Ia) : NaN;
}
function gZ(t, e, n) {
  const r = /* @__PURE__ */ new Date(0);
  r.setUTCFullYear(t, 0, 4);
  const o = r.getUTCDay() || 7, s = (e - 1) * 7 + n + 1 - o;
  return r.setUTCDate(r.getUTCDate() + s), r;
}
const vZ = [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function R3(t) {
  return t % 400 === 0 || t % 4 === 0 && t % 100 !== 0;
}
function _Z(t, e, n) {
  return e >= 0 && e <= 11 && n >= 1 && n <= (vZ[e] || (R3(t) ? 29 : 28));
}
function wZ(t, e) {
  return e >= 1 && e <= (R3(t) ? 366 : 365);
}
function bZ(t, e, n) {
  return e >= 1 && e <= 53 && n >= 0 && n <= 6;
}
function kZ(t, e, n) {
  return t === 24 ? e === 0 && n === 0 : n >= 0 && n < 60 && e >= 0 && e < 60 && t >= 0 && t < 25;
}
function TZ(t, e) {
  return e >= 0 && e <= 59;
}
function xZ(t, e) {
  const n = t.match(
    /(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2}):(\d{2})(?:\.(\d{0,7}))?(?:Z|(.)(\d{2}):?(\d{2})?)?/
  );
  return Pe(
    n ? Date.UTC(
      +n[1],
      +n[2] - 1,
      +n[3],
      +n[4] - (+n[9] || 0) * (n[8] == "-" ? -1 : 1),
      +n[5] - (+n[10] || 0) * (n[8] == "-" ? -1 : 1),
      +n[6],
      +((n[7] || "0") + "00").substring(0, 3)
    ) : NaN,
    e?.in
  );
}
function Rc(t, e, n) {
  let r = o_(t, n) - e;
  return r <= 0 && (r += 7), a_(t, r, n);
}
function SZ(t, e) {
  return Rc(t, 5, e);
}
function RZ(t, e) {
  return Rc(t, 1, e);
}
function AZ(t, e) {
  return Rc(t, 6, e);
}
function DZ(t, e) {
  return Rc(t, 0, e);
}
function EZ(t, e) {
  return Rc(t, 4, e);
}
function MZ(t, e) {
  return Rc(t, 2, e);
}
function PZ(t, e) {
  return Rc(t, 3, e);
}
function CZ(t) {
  return Math.trunc(t * D8);
}
function OZ(t) {
  const e = t / M8;
  return Math.trunc(e);
}
function IZ(t, e) {
  const n = e?.nearestTo ?? 1;
  if (n < 1 || n > 12)
    return gt(e?.in || t, NaN);
  const r = Pe(t, e?.in), o = r.getMinutes() / 60, s = r.getSeconds() / 60 / 60, i = r.getMilliseconds() / 1e3 / 60 / 60, u = r.getHours() + o + s + i, l = e?.roundingMethod ?? "round", c = xc(l)(u / n) * n;
  return r.setHours(c, 0, 0, 0), r;
}
function FZ(t, e) {
  const n = e?.nearestTo ?? 1;
  if (n < 1 || n > 30) return gt(t, NaN);
  const r = Pe(t, e?.in), o = r.getSeconds() / 60, s = r.getMilliseconds() / 1e3 / 60, i = r.getMinutes() + o + s, u = e?.roundingMethod ?? "round", a = xc(u)(i / n) * n;
  return r.setMinutes(a, 0, 0), r;
}
function NZ(t) {
  const e = t / ac;
  return Math.trunc(e);
}
function LZ(t) {
  return t * Kv;
}
function BZ(t) {
  const e = t / Oa;
  return Math.trunc(e);
}
function Xx(t, e, n) {
  const r = Pe(t, n?.in), o = r.getFullYear(), s = r.getDate(), i = gt(n?.in || t, 0);
  i.setFullYear(o, e, 15), i.setHours(0, 0, 0, 0);
  const u = r3(i);
  return r.setMonth(e, Math.min(s, u)), r;
}
function UZ(t, e, n) {
  let r = Pe(t, n?.in);
  return isNaN(+r) ? gt(n?.in || t, NaN) : (e.year != null && r.setFullYear(e.year), e.month != null && (r = Xx(r, e.month)), e.date != null && r.setDate(e.date), e.hours != null && r.setHours(e.hours), e.minutes != null && r.setMinutes(e.minutes), e.seconds != null && r.setSeconds(e.seconds), e.milliseconds != null && r.setMilliseconds(e.milliseconds), r);
}
function XZ(t, e, n) {
  const r = Pe(t, n?.in);
  return r.setDate(e), r;
}
function $Z(t, e, n) {
  const r = Pe(t, n?.in);
  return r.setMonth(0), r.setDate(e), r;
}
function WZ(t) {
  const e = {}, n = os();
  for (const r in n)
    Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
  for (const r in t)
    Object.prototype.hasOwnProperty.call(t, r) && (t[r] === void 0 ? delete e[r] : e[r] = t[r]);
  xG(e);
}
function VZ(t, e, n) {
  const r = Pe(t, n?.in);
  return r.setHours(e), r;
}
function HZ(t, e, n) {
  const r = Pe(t, n?.in);
  return r.setMilliseconds(e), r;
}
function jZ(t, e, n) {
  const r = Pe(t, n?.in);
  return r.setMinutes(e), r;
}
function zZ(t, e, n) {
  const r = Pe(t, n?.in), o = Math.trunc(r.getMonth() / 3) + 1, s = e - o;
  return Xx(r, r.getMonth() + s * 3);
}
function qZ(t, e, n) {
  const r = Pe(t, n?.in);
  return r.setSeconds(e), r;
}
function GZ(t, e, n) {
  const r = os(), o = n?.firstWeekContainsDate ?? n?.locale?.options?.firstWeekContainsDate ?? r.firstWeekContainsDate ?? r.locale?.options?.firstWeekContainsDate ?? 1, s = tu(
    Pe(t, n?.in),
    M0(t, n),
    n
  ), i = gt(n?.in || t, 0);
  i.setFullYear(e, 0, o), i.setHours(0, 0, 0, 0);
  const u = M0(i, n);
  return u.setDate(u.getDate() + s), u;
}
function YZ(t, e, n) {
  const r = Pe(t, n?.in);
  return isNaN(+r) ? gt(n?.in || t, NaN) : (r.setFullYear(e), r);
}
function QZ(t, e) {
  const n = Pe(t, e?.in), r = n.getFullYear(), o = Math.floor(r / 10) * 10;
  return n.setFullYear(o, 0, 1), n.setHours(0, 0, 0, 0), n;
}
function A3(t) {
  return ah(Date.now(), t);
}
function KZ(t) {
  const e = Jr(t?.in), n = e.getFullYear(), r = e.getMonth(), o = e.getDate(), s = gt(t?.in, 0);
  return s.setFullYear(n, r, o + 1), s.setHours(0, 0, 0, 0), s;
}
function ZZ(t) {
  const e = Jr(t?.in), n = e.getFullYear(), r = e.getMonth(), o = e.getDate(), s = Jr(t?.in);
  return s.setFullYear(n, r, o - 1), s.setHours(0, 0, 0, 0), s;
}
function D3(t, e, n) {
  return Xm(t, -e, n);
}
function JZ(t, e, n) {
  const {
    years: r = 0,
    months: o = 0,
    weeks: s = 0,
    days: i = 0,
    hours: u = 0,
    minutes: l = 0,
    seconds: a = 0
  } = e, c = D3(t, o + r * 12, n), p = a_(c, i + s * 7, n), d = l + u * 60, m = (a + d * 60) * 1e3;
  return gt(n?.in || t, +p - m);
}
function eJ(t, e, n) {
  return F8(t, -e, n);
}
function $x(t, e, n) {
  return Sx(t, -e, n);
}
function tJ(t, e, n) {
  return Zv(t, -e, n);
}
function E3(t, e, n) {
  return Jv(t, -e, n);
}
function nJ(t, e, n) {
  return Rx(t, -e, n);
}
function O0(t, e, n) {
  return Ax(t, -e, n);
}
function M3(t, e, n) {
  return e_(t, -e, n);
}
function rJ(t, e, n) {
  return U8(t, -e, n);
}
function oJ(t) {
  return Math.trunc(t * R8);
}
function sJ(t) {
  return Math.trunc(t * x0);
}
function aJ(t) {
  return Math.trunc(t * E8);
}
function iJ(t) {
  return Math.trunc(t * M8);
}
const uJ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  add: Ad,
  addBusinessDays: F8,
  addDays: pu,
  addHours: Sx,
  addISOWeekYears: B8,
  addMilliseconds: Zv,
  addMinutes: Jv,
  addMonths: Xm,
  addQuarters: Rx,
  addSeconds: Ax,
  addWeeks: e_,
  addYears: U8,
  areIntervalsOverlapping: SG,
  clamp: RG,
  closestIndexTo: $8,
  closestTo: AG,
  compareAsc: nu,
  compareDesc: DG,
  constructFrom: gt,
  constructNow: Jr,
  daysToWeeks: EG,
  differenceInBusinessDays: MG,
  differenceInCalendarDays: tu,
  differenceInCalendarISOWeekYears: W8,
  differenceInCalendarISOWeeks: PG,
  differenceInCalendarMonths: R0,
  differenceInCalendarQuarters: Vg,
  differenceInCalendarWeeks: A0,
  differenceInCalendarYears: Qf,
  differenceInDays: Ex,
  differenceInHours: D0,
  differenceInISOWeekYears: CG,
  differenceInMilliseconds: Mx,
  differenceInMinutes: E0,
  differenceInMonths: t_,
  differenceInQuarters: OG,
  differenceInSeconds: uc,
  differenceInWeeks: IG,
  differenceInYears: j8,
  eachDayOfInterval: z8,
  eachHourOfInterval: FG,
  eachMinuteOfInterval: NG,
  eachMonthOfInterval: LG,
  eachQuarterOfInterval: BG,
  eachWeekOfInterval: UG,
  eachWeekendOfInterval: Ox,
  eachWeekendOfMonth: XG,
  eachWeekendOfYear: $G,
  eachYearOfInterval: WG,
  endOfDay: Px,
  endOfDecade: VG,
  endOfHour: G8,
  endOfISOWeek: HG,
  endOfISOWeekYear: jG,
  endOfMinute: zG,
  endOfMonth: Cx,
  endOfQuarter: qG,
  endOfSecond: GG,
  endOfToday: YG,
  endOfTomorrow: QG,
  endOfWeek: Y8,
  endOfYear: q8,
  endOfYesterday: KG,
  format: rl,
  formatDate: rl,
  formatDistance: e3,
  formatDistanceStrict: t3,
  formatDistanceToNow: $Y,
  formatDistanceToNowStrict: WY,
  formatDuration: HY,
  formatISO: jY,
  formatISO9075: zY,
  formatISODuration: qY,
  formatRFC3339: GY,
  formatRFC7231: KY,
  formatRelative: ZY,
  formatters: pk,
  fromUnixTime: JY,
  getDate: n3,
  getDay: o_,
  getDayOfYear: Q8,
  getDaysInMonth: r3,
  getDaysInYear: eQ,
  getDecade: tQ,
  getDefaultOptions: Lx,
  getHours: nQ,
  getISODay: s3,
  getISOWeek: Fx,
  getISOWeekYear: dc,
  getISOWeeksInYear: rQ,
  getMilliseconds: oQ,
  getMinutes: sQ,
  getMonth: aQ,
  getOverlappingDaysInIntervals: iQ,
  getQuarter: ck,
  getSeconds: uQ,
  getTime: lQ,
  getUnixTime: cQ,
  getWeek: Nx,
  getWeekOfMonth: pQ,
  getWeekYear: r_,
  getWeeksInMonth: dQ,
  getYear: hQ,
  hoursToMilliseconds: fQ,
  hoursToMinutes: mQ,
  hoursToSeconds: yQ,
  interval: gQ,
  intervalToDuration: vQ,
  intlFormat: _Q,
  intlFormatDistance: bQ,
  isAfter: kQ,
  isBefore: TQ,
  isDate: Wm,
  isEqual: xQ,
  isExists: SQ,
  isFirstDayOfMonth: RQ,
  isFriday: AQ,
  isFuture: DQ,
  isLastDayOfMonth: H8,
  isLeapYear: o3,
  isMatch: _K,
  isMonday: wK,
  isPast: bK,
  isSameDay: $m,
  isSameHour: y3,
  isSameISOWeek: g3,
  isSameISOWeekYear: kK,
  isSameMinute: v3,
  isSameMonth: _3,
  isSameQuarter: w3,
  isSameSecond: b3,
  isSameWeek: Ux,
  isSameYear: k3,
  isSaturday: O8,
  isSunday: I8,
  isThisHour: TK,
  isThisISOWeek: xK,
  isThisMinute: SK,
  isThisMonth: RK,
  isThisQuarter: AK,
  isThisSecond: DK,
  isThisWeek: EK,
  isThisYear: MK,
  isThursday: PK,
  isToday: CK,
  isTomorrow: OK,
  isTuesday: IK,
  isValid: Fa,
  isWednesday: FK,
  isWeekend: Hd,
  isWithinInterval: NK,
  isYesterday: LK,
  lastDayOfDecade: BK,
  lastDayOfISOWeek: UK,
  lastDayOfISOWeekYear: XK,
  lastDayOfMonth: a3,
  lastDayOfQuarter: $K,
  lastDayOfWeek: T3,
  lastDayOfYear: WK,
  lightFormat: qK,
  lightFormatters: ji,
  longFormatters: P0,
  max: Dx,
  milliseconds: YK,
  millisecondsToHours: QK,
  millisecondsToMinutes: x3,
  millisecondsToSeconds: KK,
  min: X8,
  minutesToHours: ZK,
  minutesToMilliseconds: S3,
  minutesToSeconds: JK,
  monthsToQuarters: eZ,
  monthsToYears: tZ,
  nextDay: Sc,
  nextFriday: nZ,
  nextMonday: rZ,
  nextSaturday: oZ,
  nextSunday: sZ,
  nextThursday: aZ,
  nextTuesday: iZ,
  nextWednesday: uZ,
  parse: ki,
  parseISO: Hg,
  parseJSON: xZ,
  parsers: m3,
  previousDay: Rc,
  previousFriday: SZ,
  previousMonday: RZ,
  previousSaturday: AZ,
  previousSunday: DZ,
  previousThursday: EZ,
  previousTuesday: MZ,
  previousWednesday: PZ,
  quartersToMonths: CZ,
  quartersToYears: OZ,
  roundToNearestHours: IZ,
  roundToNearestMinutes: FZ,
  secondsToHours: NZ,
  secondsToMilliseconds: LZ,
  secondsToMinutes: BZ,
  set: UZ,
  setDate: XZ,
  setDay: s_,
  setDayOfYear: $Z,
  setDefaultOptions: WZ,
  setHours: VZ,
  setISODay: f3,
  setISOWeek: h3,
  setISOWeekYear: L8,
  setMilliseconds: HZ,
  setMinutes: jZ,
  setMonth: Xx,
  setQuarter: zZ,
  setSeconds: qZ,
  setWeek: d3,
  setWeekYear: GZ,
  setYear: YZ,
  startOfDay: ah,
  startOfDecade: QZ,
  startOfHour: hk,
  startOfISOWeek: mi,
  startOfISOWeekYear: hc,
  startOfMinute: fk,
  startOfMonth: n_,
  startOfQuarter: dp,
  startOfSecond: mk,
  startOfToday: A3,
  startOfTomorrow: KZ,
  startOfWeek: Do,
  startOfWeekYear: M0,
  startOfYear: Ix,
  startOfYesterday: ZZ,
  sub: JZ,
  subBusinessDays: eJ,
  subDays: a_,
  subHours: $x,
  subISOWeekYears: V8,
  subMilliseconds: tJ,
  subMinutes: E3,
  subMonths: D3,
  subQuarters: nJ,
  subSeconds: O0,
  subWeeks: M3,
  subYears: rJ,
  toDate: Pe,
  transpose: i3,
  weeksToDays: oJ,
  yearsToDays: sJ,
  yearsToMonths: aJ,
  yearsToQuarters: iJ
}, Symbol.toStringTag, { value: "Module" }));
function cE(t, e, n) {
  const r = Lx(), o = pJ(t, n.timeZone, n.locale ?? r.locale);
  return "formatToParts" in o ? lJ(o, e) : cJ(o, e);
}
function lJ(t, e) {
  const n = t.formatToParts(e);
  for (let r = n.length - 1; r >= 0; --r)
    if (n[r].type === "timeZoneName")
      return n[r].value;
}
function cJ(t, e) {
  const n = t.format(e).replace(/\u200E/g, ""), r = / [\w-+ ]+$/.exec(n);
  return r ? r[0].substr(1) : "";
}
function pJ(t, e, n) {
  return new Intl.DateTimeFormat(n ? [n.code, "en-US"] : void 0, {
    timeZone: e,
    timeZoneName: t
  });
}
function dJ(t, e) {
  const n = gJ(e);
  return "formatToParts" in n ? fJ(n, t) : mJ(n, t);
}
const hJ = {
  year: 0,
  month: 1,
  day: 2,
  hour: 3,
  minute: 4,
  second: 5
};
function fJ(t, e) {
  try {
    const n = t.formatToParts(e), r = [];
    for (let o = 0; o < n.length; o++) {
      const s = hJ[n[o].type];
      s !== void 0 && (r[s] = parseInt(n[o].value, 10));
    }
    return r;
  } catch (n) {
    if (n instanceof RangeError)
      return [NaN];
    throw n;
  }
}
function mJ(t, e) {
  const n = t.format(e), r = /(\d+)\/(\d+)\/(\d+),? (\d+):(\d+):(\d+)/.exec(n);
  return [
    parseInt(r[3], 10),
    parseInt(r[1], 10),
    parseInt(r[2], 10),
    parseInt(r[4], 10),
    parseInt(r[5], 10),
    parseInt(r[6], 10)
  ];
}
const b1 = {}, pE = new Intl.DateTimeFormat("en-US", {
  hourCycle: "h23",
  timeZone: "America/New_York",
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
  hour: "2-digit",
  minute: "2-digit",
  second: "2-digit"
}).format(/* @__PURE__ */ new Date("2014-06-25T04:00:00.123Z")), yJ = pE === "06/25/2014, 00:00:00" || pE === "‎06‎/‎25‎/‎2014‎ ‎00‎:‎00‎:‎00";
function gJ(t) {
  return b1[t] || (b1[t] = yJ ? new Intl.DateTimeFormat("en-US", {
    hourCycle: "h23",
    timeZone: t,
    year: "numeric",
    month: "numeric",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit"
  }) : new Intl.DateTimeFormat("en-US", {
    hour12: !1,
    timeZone: t,
    year: "numeric",
    month: "numeric",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit"
  })), b1[t];
}
function Wx(t, e, n, r, o, s, i) {
  const u = /* @__PURE__ */ new Date(0);
  return u.setUTCFullYear(t, e, n), u.setUTCHours(r, o, s, i), u;
}
const dE = 36e5, vJ = 6e4, k1 = {
  timezoneZ: /^(Z)$/,
  timezoneHH: /^([+-]\d{2})$/,
  timezoneHHMM: /^([+-])(\d{2}):?(\d{2})$/
};
function Vm(t, e, n) {
  if (!t)
    return 0;
  let r = k1.timezoneZ.exec(t);
  if (r)
    return 0;
  let o, s;
  if (r = k1.timezoneHH.exec(t), r)
    return o = parseInt(r[1], 10), hE(o) ? -(o * dE) : NaN;
  if (r = k1.timezoneHHMM.exec(t), r) {
    o = parseInt(r[2], 10);
    const i = parseInt(r[3], 10);
    return hE(o, i) ? (s = Math.abs(o) * dE + i * vJ, r[1] === "+" ? -s : s) : NaN;
  }
  if (bJ(t)) {
    e = new Date(e || Date.now());
    const i = n ? e : _J(e), u = yk(i, t);
    return -(n ? u : wJ(e, u, t));
  }
  return NaN;
}
function _J(t) {
  return Wx(t.getFullYear(), t.getMonth(), t.getDate(), t.getHours(), t.getMinutes(), t.getSeconds(), t.getMilliseconds());
}
function yk(t, e) {
  const n = dJ(t, e), r = Wx(n[0], n[1] - 1, n[2], n[3] % 24, n[4], n[5], 0).getTime();
  let o = t.getTime();
  const s = o % 1e3;
  return o -= s >= 0 ? s : 1e3 + s, r - o;
}
function wJ(t, e, n) {
  let o = t.getTime() - e;
  const s = yk(new Date(o), n);
  if (e === s)
    return e;
  o -= s - e;
  const i = yk(new Date(o), n);
  return s === i ? s : Math.max(s, i);
}
function hE(t, e) {
  return -23 <= t && t <= 23 && (e == null || 0 <= e && e <= 59);
}
const fE = {};
function bJ(t) {
  if (fE[t])
    return !0;
  try {
    return new Intl.DateTimeFormat(void 0, { timeZone: t }), fE[t] = !0, !0;
  } catch {
    return !1;
  }
}
const kJ = 60 * 1e3, TJ = {
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(t, e, n) {
    const r = T1(n.timeZone, t);
    if (r === 0)
      return "Z";
    switch (e) {
      // Hours and optional minutes
      case "X":
        return mE(r);
      // Hours, minutes and optional seconds without `:` delimeter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`
      case "XXXX":
      case "XX":
        return Dd(r);
      // Hours, minutes and optional seconds with `:` delimeter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`
      case "XXXXX":
      case "XXX":
      // Hours and minutes with `:` delimeter
      default:
        return Dd(r, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(t, e, n) {
    const r = T1(n.timeZone, t);
    switch (e) {
      // Hours and optional minutes
      case "x":
        return mE(r);
      // Hours, minutes and optional seconds without `:` delimeter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`
      case "xxxx":
      case "xx":
        return Dd(r);
      // Hours, minutes and optional seconds with `:` delimeter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`
      case "xxxxx":
      case "xxx":
      // Hours and minutes with `:` delimeter
      default:
        return Dd(r, ":");
    }
  },
  // Timezone (GMT)
  O: function(t, e, n) {
    const r = T1(n.timeZone, t);
    switch (e) {
      // Short
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + xJ(r, ":");
      // Long
      case "OOOO":
      default:
        return "GMT" + Dd(r, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(t, e, n) {
    switch (e) {
      // Short
      case "z":
      case "zz":
      case "zzz":
        return cE("short", t, n);
      // Long
      case "zzzz":
      default:
        return cE("long", t, n);
    }
  }
};
function T1(t, e) {
  const n = t ? Vm(t, e, !0) / kJ : e?.getTimezoneOffset() ?? 0;
  if (Number.isNaN(n))
    throw new RangeError("Invalid time zone specified: " + t);
  return n;
}
function I0(t, e) {
  const n = t < 0 ? "-" : "";
  let r = Math.abs(t).toString();
  for (; r.length < e; )
    r = "0" + r;
  return n + r;
}
function Dd(t, e = "") {
  const n = t > 0 ? "-" : "+", r = Math.abs(t), o = I0(Math.floor(r / 60), 2), s = I0(Math.floor(r % 60), 2);
  return n + o + e + s;
}
function mE(t, e) {
  return t % 60 === 0 ? (t > 0 ? "-" : "+") + I0(Math.abs(t) / 60, 2) : Dd(t, e);
}
function xJ(t, e = "") {
  const n = t > 0 ? "-" : "+", r = Math.abs(t), o = Math.floor(r / 60), s = r % 60;
  return s === 0 ? n + String(o) : n + String(o) + e + I0(s, 2);
}
function yE(t) {
  const e = new Date(Date.UTC(t.getFullYear(), t.getMonth(), t.getDate(), t.getHours(), t.getMinutes(), t.getSeconds(), t.getMilliseconds()));
  return e.setUTCFullYear(t.getFullYear()), +t - +e;
}
const P3 = /(Z|[+-]\d{2}(?::?\d{2})?| UTC| [a-zA-Z]+\/[a-zA-Z_]+(?:\/[a-zA-Z_]+)?)$/, x1 = 36e5, gE = 6e4, SJ = 2, Qo = {
  dateTimePattern: /^([0-9W+-]+)(T| )(.*)/,
  datePattern: /^([0-9W+-]+)(.*)/,
  // year tokens
  YY: /^(\d{2})$/,
  YYY: [
    /^([+-]\d{2})$/,
    // 0 additional digits
    /^([+-]\d{3})$/,
    // 1 additional digit
    /^([+-]\d{4})$/
    // 2 additional digits
  ],
  YYYY: /^(\d{4})/,
  YYYYY: [
    /^([+-]\d{4})/,
    // 0 additional digits
    /^([+-]\d{5})/,
    // 1 additional digit
    /^([+-]\d{6})/
    // 2 additional digits
  ],
  // date tokens
  MM: /^-(\d{2})$/,
  DDD: /^-?(\d{3})$/,
  MMDD: /^-?(\d{2})-?(\d{2})$/,
  Www: /^-?W(\d{2})$/,
  WwwD: /^-?W(\d{2})-?(\d{1})$/,
  HH: /^(\d{2}([.,]\d*)?)$/,
  HHMM: /^(\d{2}):?(\d{2}([.,]\d*)?)$/,
  HHMMSS: /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/,
  // time zone tokens (to identify the presence of a tz)
  timeZone: P3
};
function F0(t, e = {}) {
  if (arguments.length < 1)
    throw new TypeError("1 argument required, but only " + arguments.length + " present");
  if (t === null)
    return /* @__PURE__ */ new Date(NaN);
  const n = e.additionalDigits == null ? SJ : Number(e.additionalDigits);
  if (n !== 2 && n !== 1 && n !== 0)
    throw new RangeError("additionalDigits must be 0, 1 or 2");
  if (t instanceof Date || typeof t == "object" && Object.prototype.toString.call(t) === "[object Date]")
    return new Date(t.getTime());
  if (typeof t == "number" || Object.prototype.toString.call(t) === "[object Number]")
    return new Date(t);
  if (Object.prototype.toString.call(t) !== "[object String]")
    return /* @__PURE__ */ new Date(NaN);
  const r = RJ(t), { year: o, restDateString: s } = AJ(r.date, n), i = DJ(s, o);
  if (i === null || isNaN(i.getTime()))
    return /* @__PURE__ */ new Date(NaN);
  if (i) {
    const u = i.getTime();
    let l = 0, a;
    if (r.time && (l = EJ(r.time), l === null || isNaN(l)))
      return /* @__PURE__ */ new Date(NaN);
    if (r.timeZone || e.timeZone) {
      if (a = Vm(r.timeZone || e.timeZone, new Date(u + l)), isNaN(a))
        return /* @__PURE__ */ new Date(NaN);
    } else
      a = yE(new Date(u + l)), a = yE(new Date(u + l + a));
    return new Date(u + l + a);
  } else
    return /* @__PURE__ */ new Date(NaN);
}
function RJ(t) {
  const e = {};
  let n = Qo.dateTimePattern.exec(t), r;
  if (n ? (e.date = n[1], r = n[3]) : (n = Qo.datePattern.exec(t), n ? (e.date = n[1], r = n[2]) : (e.date = null, r = t)), r) {
    const o = Qo.timeZone.exec(r);
    o ? (e.time = r.replace(o[1], ""), e.timeZone = o[1].trim()) : e.time = r;
  }
  return e;
}
function AJ(t, e) {
  if (t) {
    const n = Qo.YYY[e], r = Qo.YYYYY[e];
    let o = Qo.YYYY.exec(t) || r.exec(t);
    if (o) {
      const s = o[1];
      return {
        year: parseInt(s, 10),
        restDateString: t.slice(s.length)
      };
    }
    if (o = Qo.YY.exec(t) || n.exec(t), o) {
      const s = o[1];
      return {
        year: parseInt(s, 10) * 100,
        restDateString: t.slice(s.length)
      };
    }
  }
  return {
    year: null
  };
}
function DJ(t, e) {
  if (e === null)
    return null;
  let n, r, o;
  if (!t || !t.length)
    return n = /* @__PURE__ */ new Date(0), n.setUTCFullYear(e), n;
  let s = Qo.MM.exec(t);
  if (s)
    return n = /* @__PURE__ */ new Date(0), r = parseInt(s[1], 10) - 1, _E(e, r) ? (n.setUTCFullYear(e, r), n) : /* @__PURE__ */ new Date(NaN);
  if (s = Qo.DDD.exec(t), s) {
    n = /* @__PURE__ */ new Date(0);
    const i = parseInt(s[1], 10);
    return CJ(e, i) ? (n.setUTCFullYear(e, 0, i), n) : /* @__PURE__ */ new Date(NaN);
  }
  if (s = Qo.MMDD.exec(t), s) {
    n = /* @__PURE__ */ new Date(0), r = parseInt(s[1], 10) - 1;
    const i = parseInt(s[2], 10);
    return _E(e, r, i) ? (n.setUTCFullYear(e, r, i), n) : /* @__PURE__ */ new Date(NaN);
  }
  if (s = Qo.Www.exec(t), s)
    return o = parseInt(s[1], 10) - 1, wE(o) ? vE(e, o) : /* @__PURE__ */ new Date(NaN);
  if (s = Qo.WwwD.exec(t), s) {
    o = parseInt(s[1], 10) - 1;
    const i = parseInt(s[2], 10) - 1;
    return wE(o, i) ? vE(e, o, i) : /* @__PURE__ */ new Date(NaN);
  }
  return null;
}
function EJ(t) {
  let e, n, r = Qo.HH.exec(t);
  if (r)
    return e = parseFloat(r[1].replace(",", ".")), S1(e) ? e % 24 * x1 : NaN;
  if (r = Qo.HHMM.exec(t), r)
    return e = parseInt(r[1], 10), n = parseFloat(r[2].replace(",", ".")), S1(e, n) ? e % 24 * x1 + n * gE : NaN;
  if (r = Qo.HHMMSS.exec(t), r) {
    e = parseInt(r[1], 10), n = parseInt(r[2], 10);
    const o = parseFloat(r[3].replace(",", "."));
    return S1(e, n, o) ? e % 24 * x1 + n * gE + o * 1e3 : NaN;
  }
  return null;
}
function vE(t, e, n) {
  e = e || 0, n = n || 0;
  const r = /* @__PURE__ */ new Date(0);
  r.setUTCFullYear(t, 0, 4);
  const o = r.getUTCDay() || 7, s = e * 7 + n + 1 - o;
  return r.setUTCDate(r.getUTCDate() + s), r;
}
const MJ = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], PJ = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function C3(t) {
  return t % 400 === 0 || t % 4 === 0 && t % 100 !== 0;
}
function _E(t, e, n) {
  if (e < 0 || e > 11)
    return !1;
  if (n != null) {
    if (n < 1)
      return !1;
    const r = C3(t);
    if (r && n > PJ[e] || !r && n > MJ[e])
      return !1;
  }
  return !0;
}
function CJ(t, e) {
  if (e < 1)
    return !1;
  const n = C3(t);
  return !(n && e > 366 || !n && e > 365);
}
function wE(t, e) {
  return !(t < 0 || t > 52 || e != null && (e < 0 || e > 6));
}
function S1(t, e, n) {
  return !(t < 0 || t >= 25 || e != null && (e < 0 || e >= 60) || n != null && (n < 0 || n >= 60));
}
const OJ = /([xXOz]+)|''|'(''|[^'])+('|$)/g;
function IJ(t, e, n = {}) {
  e = String(e);
  const r = e.match(OJ);
  if (r) {
    const o = F0(n.originalDate || t, n);
    e = r.reduce(function(s, i) {
      if (i[0] === "'")
        return s;
      const u = s.indexOf(i), l = s[u - 1] === "'", a = s.replace(i, "'" + TJ[i[0]](o, i, n) + "'");
      return l ? a.substring(0, u - 1) + a.substring(u + 1) : a;
    }, e);
  }
  return rl(t, e, n);
}
function O3(t, e, n) {
  t = F0(t, n);
  const r = Vm(e, t, !0), o = new Date(t.getTime() - r), s = /* @__PURE__ */ new Date(0);
  return s.setFullYear(o.getUTCFullYear(), o.getUTCMonth(), o.getUTCDate()), s.setHours(o.getUTCHours(), o.getUTCMinutes(), o.getUTCSeconds(), o.getUTCMilliseconds()), s;
}
function FJ(t, e, n, r) {
  return r = {
    ...r,
    timeZone: e,
    originalDate: t
  }, IJ(O3(t, e, { timeZone: r.timeZone }), n, r);
}
function I3(t, e, n) {
  if (typeof t == "string" && !t.match(P3))
    return F0(t, { ...n, timeZone: e });
  t = F0(t, n);
  const r = Wx(t.getFullYear(), t.getMonth(), t.getDate(), t.getHours(), t.getMinutes(), t.getSeconds(), t.getMilliseconds()).getTime(), o = Vm(e, new Date(r));
  return new Date(r + o);
}
function gk(t, e) {
  return -Vm(t, e);
}
const ms = {
  year: 31536e3,
  day: 86400,
  hour: 3600,
  minute: 60,
  second: 1
};
function F3(t) {
  const e = Math.floor(t / ms.year), n = Math.floor(t % ms.year / ms.day), r = Math.floor(t % ms.year % ms.day / ms.hour), o = Math.floor(t % ms.year % ms.day % ms.hour / ms.minute), s = Math.ceil(t % ms.year % ms.day % ms.hour % ms.minute);
  return { years: e, days: n, hours: r, minutes: o, seconds: s };
}
function N3(t, e = !0) {
  return `${t === 1 && !e ? "" : t}`;
}
function ff(t, e, n = !0) {
  return `${N3(e, n)} ${t}${e !== 1 ? "s" : ""}`;
}
function mf(t, e, n = !0) {
  return `${N3(e, n)}${t}`;
}
function _p(t, e = !0) {
  const { years: n, days: r, hours: o, minutes: s, seconds: i } = F3(t), u = n ? ff("year", n, e) : "", l = r ? ff("day", r, e) : "", a = o ? ff("hour", o, e) : "", c = s ? ff("minute", s, e) : "", p = i ? ff("second", i, e) : "";
  return [u, l, a, c, p].map((d) => d || "").join(" ");
}
function fc(t, e = !0) {
  const { years: n, days: r, hours: o, minutes: s, seconds: i } = F3(t), u = mf("y", n, e), l = mf("d", r, e), a = mf("h", o, e), c = mf("m", s, e), p = mf("s", i, e);
  switch (!0) {
    case (n > 0 && r == 0):
      return u;
    case (n > 0 && r > 0):
      return `${u} ${l}`;
    case (r > 0 && o == 0):
      return l;
    case (r > 0 && o > 0):
      return `${l} ${a}`;
    case (o > 0 && s == 0):
      return `${a} ${c}`;
    case (o > 0 && s > 0):
      return `${a} ${c}`;
    case (s > 0 && i == 0):
      return c;
    case (s > 0 && i > 0):
      return `${c} ${p}`;
    default:
      return p;
  }
}
const i_ = "MMM do, yyyy", Vx = "hh:mm a", L3 = `${i_} 'at' ${Vx}`, u_ = "hh:mm:ss a", Hx = "hh:mm a", l_ = "yyyy/MM/dd", B3 = `${l_} ${u_}`, U3 = `${l_} ${Hx}`, NJ = 24;
function ol(t) {
  return Wm(t);
}
function wp(t) {
  return ol(t) && !Fa(t);
}
function vk(t, e) {
  return t.getTime() - e.getTime();
}
function Xo(t, e = i_) {
  const n = _k(t);
  return N0(n, e);
}
function G4e(t, e = /* @__PURE__ */ new Date()) {
  return ki(t, i_, e);
}
function X3(t) {
  return Xo(t, Vx);
}
function Y4e(t, e = /* @__PURE__ */ new Date()) {
  return ki(t, Vx, e);
}
function LJ(t) {
  return Xo(t, L3);
}
function Q4e(t, e = /* @__PURE__ */ new Date()) {
  return ki(t, L3, e);
}
function $3(t) {
  return Xo(t, u_);
}
function K4e(t, e = /* @__PURE__ */ new Date()) {
  return ki(t, u_, e);
}
function Z4e(t) {
  return Xo(t, Hx);
}
function J4e(t, e = /* @__PURE__ */ new Date()) {
  return ki(t, Hx, e);
}
function eLe(t) {
  return Xo(t, l_);
}
function tLe(t, e = /* @__PURE__ */ new Date()) {
  return ki(t, l_, e);
}
function qs(t) {
  return Xo(t, B3);
}
function bE(t, e = /* @__PURE__ */ new Date()) {
  return ki(t, B3, e);
}
function nLe(t) {
  return Xo(t, U3);
}
function rLe(t, e = /* @__PURE__ */ new Date()) {
  return ki(t, U3, e);
}
function W3(t, e = /* @__PURE__ */ new Date()) {
  const n = _k(t), r = _k(e), o = Gr.differenceInSeconds(r, n), s = Gr.isBefore(n, r), i = fc(Math.abs(o));
  return s ? `${i} ago` : `in ${i}`;
}
const V3 = "yyyy-MM-dd";
function BJ(t) {
  return Gr.format(t, V3);
}
function oLe(t) {
  return Gr.parse(t, V3, /* @__PURE__ */ new Date());
}
const Op = ge(null), H3 = "Etc/UTC";
function sLe(t) {
  return t === H3;
}
const UJ = -(/* @__PURE__ */ new Date()).getTimezoneOffset(), XJ = D(() => Op.value === null ? S3(UJ) : gk(Op.value)), aLe = D(() => x3(XJ.value));
function Zs(t, e = Op.value) {
  if (t.timezone && (t = ci(t, t.timezone)), e) {
    const n = O3(t, e);
    return n.timezone = e, n;
  }
  return t;
}
function ci(t, e = Op.value) {
  if (e) {
    const n = I3(t, e);
    return n.timezone = void 0, n;
  }
  return t;
}
function _k(t) {
  return t ? typeof t == "string" ? new Date(t) : t.timezone ? ci(t) : t : /* @__PURE__ */ new Date();
}
function N0(t, e, n = Op.value) {
  return t.timezone || !n ? rl(t, e) : FJ(t, n, e);
}
function $J(t) {
  return t.length === 0;
}
function WJ() {
  return Zs(/* @__PURE__ */ new Date());
}
function iLe(t) {
  return (t ? new Date(t) : WJ()).getTime();
}
const Gr = new Proxy({ ...uJ }, {
  get(t, e, n) {
    const r = Reflect.get(t, e, n);
    return typeof r != "function" ? r : (...o) => {
      const s = o.map((u) => ol(u) && u.timezone ? ci(u, u.timezone) : u), i = r.apply(this, s);
      return ol(i) ? $J(o) ? ci(i) : Zs(i) : i;
    };
  }
});
function VJ(t, e) {
  const n = t.getHours() - Zs(t, e).getHours();
  return Sx(t, n);
}
function HJ(t, e) {
  const n = t.getHours() - Zs(t, e).getHours();
  return $x(t, n);
}
class jJ extends qn {
  routePrefix = "/events";
  async getEvents(e) {
    const n = ye.map("WorkspaceEventsFilter", e, "WorkspaceEventsFilterRequest"), { data: r } = await this.post("/filter", n);
    return ye.map("WorkspaceEventsResponse", r, "WorkspaceEvents");
  }
  async getEvent(e, n) {
    const r = Gr.startOfDay(n), o = Gr.endOfDay(n), s = {
      id: { id: [e] },
      occurred: {
        since: r,
        until: o
      }
    }, { events: i } = await this.getEvents(s), [u] = i;
    return u;
  }
  async getFirstEvent(e) {
    const { events: n } = await this.getEvents(e), [r] = n;
    return r;
  }
  async getNextPage(e) {
    const { data: n } = await this.get(`/filter/next${e}`);
    return ye.map("WorkspaceEventsResponse", n, "WorkspaceEvents");
  }
  async getEventsCount(e, n) {
    const r = ye.map("WorkspaceEventsFilter", n, "WorkspaceEventsFilterRequest"), { data: o } = await this.post(`/count-by/${e}`, r);
    return ye.map("WorkspaceEventsCountResponse", o, "WorkspaceEventsCount");
  }
  async getEventsHistory(e) {
    const { unit: n = "hour", interval: r = 1 } = e, o = ye.map("WorkspaceEventsHistory", { ...e, unit: n, interval: r }, "WorkspaceEventsHistoryRequest"), { data: s } = await this.post("/count-by/time", o);
    return ye.map("WorkspaceEventsCountResponse", s, "HistogramDataPoint");
  }
}
class zJ extends qn {
  routePrefix = "/flow_runs";
  batcher = new hi(async (e) => {
    if (e.length === 1) {
      const [r] = e, { data: o } = await this.get(`/${r}`);
      return () => ye.map("FlowRunResponse", o, "FlowRun");
    }
    const n = await this.getFlowRuns({
      flowRuns: {
        id: e
      }
    });
    return cu(n, "id");
  }, { maxBatchSize: 200 });
  getFlowRun(e) {
    return this.batcher.batch(e);
  }
  async getFlowRuns(e = {}) {
    const n = ye.map("FlowRunsFilter", e, "FlowRunsFilterRequest"), { data: r } = await this.post("/filter", n);
    return ye.map("FlowRunResponse", r, "FlowRun");
  }
  async getFlowRunsPaginated(e = {}) {
    const n = ye.map("FlowRunsPaginationFilter", e, "FlowRunsPaginationFilterRequest"), { data: r } = await this.post("/paginate", n);
    return ye.map("FlowRunsPaginationResponse", r, "FlowRunsPagination");
  }
  async getFlowRunsCount(e = {}) {
    const n = ye.map("FlowRunsFilter", e, "FlowRunsFilterRequest"), { data: r } = await this.post("/count", n);
    return r;
  }
  async getFlowRunsHistory(e) {
    const n = ye.map("FlowRunsHistoryFilter", e, "FlowRunsHistoryFilterRequest"), { data: r } = await this.post("/history", n);
    return ye.map("FlowRunHistoryResponse", r, "RunHistory");
  }
  async getFlowRunsAverageLateness(e) {
    const n = ye.map("FlowRunsFilter", e, "FlowRunsFilterRequest"), { data: r } = await this.post("/lateness", n);
    return r;
  }
  async getFlowRunsGraph(e, { nestedTaskRunGraphs: n }) {
    const { data: r } = await this.get(`/${e}/graph-v2`);
    return ye.map("RunGraphDataResponse", { graph: r, nestedTaskRunGraphs: n }, "RunGraphData");
  }
  async getFlowRunInputDescription(e, n) {
    if (!n)
      return null;
    try {
      const { data: r } = await this.get(`/${e}/input/${n.description}`);
      return r;
    } catch {
      return console.error("Flow run input description not found"), null;
    }
  }
  async getFlowRunInputSchema(e, n) {
    const { data: r } = await this.get(`/${e}/input/${n.schema}`);
    return ye.map("SchemaResponse", r, "Schema");
  }
  async getFlowRunInputSchemaV2(e, n) {
    const { data: r } = await this.get(`/${e}/input/${n.schema}`);
    return r;
  }
  retryFlowRun(e) {
    return this.setFlowRunState(e, {
      state: {
        type: "scheduled",
        name: "AwaitingRetry",
        message: "Retry from the UI"
      }
    }, !1);
  }
  setFlowRunState(e, n, r = !0) {
    const o = ye.map("StateUpdate", n, "StateUpdateRequest");
    return this.post(`/${e}/set_state`, { state: o.state, force: r });
  }
  async resumeFlowRun(e, n) {
    if (n) {
      const { data: o } = await this.post(`/${e}/resume`, { run_input: n });
      return ye.map("OrchestrationResultResponse", o, "OrchestrationResult");
    }
    const { data: r } = await this.post(`/${e}/resume`);
    return ye.map("OrchestrationResultResponse", r, "OrchestrationResult");
  }
  async resumeFlowRunV2(e, n) {
    const { data: r } = await this.post(`/${e}/resume`, { run_input: n });
    return ye.map("OrchestrationResultResponse", r, "OrchestrationResult");
  }
  deleteFlowRun(e) {
    return this.delete(`/${e}`);
  }
  async downloadFlowRunLogs(e, n) {
    const { data: r } = await this.get(`/${e}/logs/download`, {
      responseType: "stream"
    }), o = URL.createObjectURL(new Blob([r])), s = document.createElement("a"), i = n ?? "logs";
    s.href = o, s.setAttribute("download", `${i}.csv`), s.click(), URL.revokeObjectURL(o);
  }
  async getFlowRunJobConfig(e) {
    const { data: n } = await this.get(`${e}/job/config`);
    return n;
  }
}
class qJ extends qn {
  routePrefix = "/flows";
  batcher = new hi(async (e) => {
    if (e.length === 1) {
      const [r] = e, { data: o } = await this.get(`${r}`);
      return () => ye.map("FlowResponse", o, "Flow");
    }
    const n = await this.getFlows({
      flows: {
        id: e
      }
    });
    return cu(n, "id");
  }, { maxBatchSize: 200 });
  getFlow(e) {
    return this.batcher.batch(e);
  }
  async getFlows(e = {}) {
    const n = ye.map("FlowsFilter", e, "FlowsFilterRequest"), { data: r } = await this.post("filter", n);
    return ye.map("FlowResponse", r, "Flow");
  }
  async getFlowsPaginated(e = {}) {
    const n = ye.map("FlowsPaginationFilter", e, "FlowsPaginationFilterRequest"), { data: r } = await this.post("/paginate", n);
    return ye.map("FlowsPaginationResponse", r, "FlowsPagination");
  }
  async getFlowsCount(e = {}) {
    const n = ye.map("FlowsFilter", e, "FlowsFilterRequest"), { data: r } = await this.post("count", n);
    return r;
  }
  deleteFlow(e) {
    return this.delete(`/${e}`);
  }
}
class GJ extends qn {
  routePrefix = "/logs";
  async getLogs(e = {}) {
    const n = ye.map("LogsFilter", e, "LogsFilterRequest"), { data: r } = await this.post("/filter", n);
    return ye.map("LogResponse", r, "Log");
  }
}
class YJ extends qn {
  routePrefix = "/flow_run_notification_policies";
  async getNotification(e) {
    const { data: n } = await this.get(`/${e}`);
    return ye.map("NotificationResponse", n, "Notification");
  }
  async createNotification(e) {
    const { data: n } = await this.post("/", ye.map("NotificationCreate", e, "NotificationCreateRequest"));
    return ye.map("NotificationResponse", n, "Notification");
  }
  async getNotifications(e = {}) {
    const n = ye.map("NotificationsFilter", e, "NotificationsFilterRequest"), { data: r } = await this.post("/filter", n);
    return ye.map("NotificationResponse", r, "Notification");
  }
  updateNotification(e, n) {
    return this.patch(`/${e}`, ye.map("NotificationUpdate", n, "NotificationUpdateRequest"));
  }
  deleteNotification(e) {
    return this.delete(`/${e}`);
  }
}
class QJ extends qn {
  routePrefix = "/saved_searches";
  async getSavedSearches(e = {}) {
    const n = ye.map("SavedSearchesFilter", e, "SavedSearchesFilterRequest"), { data: r } = await this.post("/filter", n);
    return r.map((s) => {
      try {
        return ye.map("SavedSearchResponse", s, "SavedSearch");
      } catch (i) {
        console.error(i);
      }
    }).filter(Vt);
  }
  async getSavedSearch(e) {
    const { data: n } = await this.get(`/${e}`);
    return ye.map("SavedSearchResponse", n, "SavedSearch");
  }
  async createSavedSearch(e) {
    const n = ye.map("SavedSearchCreate", e, "SavedSearchCreateRequest"), { data: r } = await this.put("/", n);
    return ye.map("SavedSearchResponse", r, "SavedSearch");
  }
  deleteSavedSearch(e) {
    return this.delete(`/${e}`);
  }
}
function uLe(t) {
  const e = {};
  for (const n in t)
    Object.prototype.hasOwnProperty.call(t, n) && (e[t[n]] = n);
  return e;
}
function R1(t, e) {
  const n = { ...t };
  return e.forEach((r) => delete n[r]), n;
}
function KJ(t) {
  if (t === null || typeof t != "object")
    return t;
  if (Wm(t))
    return new Date(t);
  const e = new t();
  for (const n in t)
    e[n] = KJ(t[n]);
  return e;
}
function lLe(t, e) {
  return (typeof e == "string" || typeof e == "symbol") && e in t;
}
function ZJ(t, e) {
  const n = Object.entries(t), r = {};
  return n.reduce((o, [s, i]) => {
    const u = e(s, i);
    return o[u] = t[s], o;
  }, r);
}
function Ds(t, e) {
  const n = Object.entries(t), r = {};
  return n.reduce((o, [s, i]) => (o[s] = e(s, i), o), r);
}
function JJ(t, e) {
  const n = Object.entries(t), r = {};
  return n.reduce((o, [s, i]) => {
    const [u, l] = e(s, i);
    return o[u] = l, o;
  }, r);
}
function ru(t) {
  return typeof t == "object" && !Array.isArray(t) && t !== null && Object.keys(t).length === 0;
}
function cLe(t) {
  return Object.values(t).every((e) => e !== void 0);
}
function eee(t, e) {
  return Object.values(t).map((r) => r?.toString().toLowerCase() ?? "").join("").includes(e.toLowerCase());
}
function wn(t) {
  return t !== null && typeof t == "object" && !Array.isArray(t) && !Wm(t);
}
function lc(t, ...e) {
  if (e.length === 0)
    return t;
  const [n, ...r] = e, o = Bm([...Object.keys(t), ...Object.keys(n)]);
  for (const s of o) {
    const i = t[s], u = n[s];
    if (i !== u) {
      if (wn(i) && wn(u)) {
        lc(i, u);
        continue;
      }
      if (wn(i) && wn(n) && !(s in n)) {
        lc(i, { [s]: {} });
        continue;
      }
      t[s] = n[s];
    }
  }
  return lc(t, ...r);
}
function Wn(t) {
  const e = {}, n = Object.keys(t);
  for (const r of n) {
    const o = t[r];
    if (o !== void 0) {
      if (wn(o)) {
        const s = Wn(o);
        Object.keys(s).length && (e[r] = s);
        continue;
      }
      e[r] = o;
    }
  }
  return e;
}
const tee = function(t) {
  return {
    definitions: this.map("SchemaPropertiesResponse", t.definitions, "SchemaProperties"),
    position: t.position,
    blockTypeSlug: t.block_type_slug,
    $ref: t.$ref,
    anyOf: t.anyOf,
    allOf: t.allOf,
    example: t.example,
    default: t.default,
    const: t.const,
    description: t.description,
    enum: t.enum,
    format: t.format,
    items: t.items,
    prefixItems: t.prefixItems,
    properties: this.map("SchemaPropertiesResponse", t.properties, "SchemaProperties"),
    required: t.required,
    title: t.title,
    type: t.type,
    maxItems: t.maxItems,
    minItems: t.minItems
  };
}, nee = function(t) {
  return Ds(t, (e, n) => this.map("SchemaPropertyResponse", n, "SchemaProperty"));
}, ree = function(t) {
  return {
    position: t.position,
    blockTypeSlug: t.block_type_slug,
    $ref: t.$ref,
    anyOf: t.anyOf,
    allOf: t.allOf,
    example: t.example,
    default: t.default,
    const: t.const,
    description: t.description,
    enum: t.enum,
    format: t.format,
    items: t.items,
    prefixItems: t.prefixItems,
    properties: this.map("SchemaPropertiesResponse", t.properties, "SchemaProperties"),
    required: t.required,
    title: t.title,
    type: t.type,
    maxItems: t.maxItems,
    minItems: t.minItems
  };
}, oee = function(t) {
  return {
    definitions: this.map("SchemaProperties", t.definitions, "SchemaPropertiesResponse"),
    position: t.position,
    block_type_slug: t.blockTypeSlug,
    $ref: t.$ref,
    anyOf: t.anyOf,
    allOf: t.allOf,
    example: t.example,
    default: t.default,
    const: t.const,
    description: t.description,
    enum: t.enum,
    format: t.format,
    items: t.items,
    prefixItems: t.prefixItems,
    properties: this.map("SchemaProperties", t.properties, "SchemaPropertiesResponse"),
    required: t.required,
    title: t.title,
    type: t.type,
    maxItems: t.maxItems,
    minItems: t.minItems
  };
}, see = function(t) {
  return Ds(t, (e, n) => this.map("SchemaProperty", n, "SchemaPropertyResponse"));
}, aee = function(t) {
  return {
    position: t.position,
    block_type_slug: t.blockTypeSlug,
    $ref: t.$ref,
    anyOf: t.anyOf,
    allOf: t.allOf,
    example: t.example,
    default: t.default,
    const: t.const,
    description: t.description,
    enum: t.enum,
    format: t.format,
    items: t.items,
    prefixItems: t.prefixItems,
    properties: this.map("SchemaProperties", t.properties, "SchemaPropertiesResponse"),
    required: t.required,
    title: t.title,
    type: t.type,
    maxItems: t.maxItems,
    minItems: t.minItems
  };
}, iee = {
  SchemaResponse: { Schema: tee },
  SchemaPropertyResponse: { SchemaProperty: ree },
  SchemaPropertiesResponse: { SchemaProperties: nee },
  Schema: { SchemaResponse: oee },
  SchemaProperty: { SchemaPropertyResponse: aee },
  SchemaProperties: { SchemaPropertiesResponse: see }
};
let uee = class {
  mapperFunctions;
  constructor(e) {
    this.mapperFunctions = e;
  }
  map(e, n, r) {
    if (n == null)
      return n;
    const o = this.bindMapper(this.mapperFunctions[e][r]);
    return Array.isArray(n) ? n.map(o) : o(n);
  }
  mapEntries(e, n, r) {
    if (n == null)
      return n;
    const o = {};
    return Object.entries(n).reduce((s, [i, u]) => (s[i] = this.map(e, u, r), s), o);
  }
  bindMapper(e) {
    return e.bind(this);
  }
};
const jx = new uee(iee);
class lee extends qn {
  routePrefix = "/ui/schemas/";
  async validateSchemaValues(e, n) {
    const { data: r } = await this.post("/validate", {
      schema: jx.map("Schema", n, "SchemaResponse"),
      values: e
    });
    return r;
  }
  async validateSchemaValue(e, n, r) {
    const o = F2.create("noun"), s = {
      definitions: r.definitions,
      properties: {
        [o]: n
      }
    }, i = {
      [o]: e
    }, u = await this.validateSchemaValues(i, s);
    if (!u.valid) {
      const [l] = u.errors;
      if (!wn(l))
        throw new Error("Unexpected schema validation error response");
      return {
        valid: !1,
        errors: l.errors
      };
    }
    return u;
  }
}
class cee extends qn {
  routePrefix = "/task_runs";
  batcher = new hi(async (e) => {
    if (e.length === 1) {
      const [r] = e, { data: o } = await this.get(`/${r}`);
      return () => ye.map("TaskRunResponse", o, "TaskRun");
    }
    const n = await this.getTaskRuns({
      taskRuns: {
        id: e
      }
    });
    return cu(n, "id");
  }, { maxBatchSize: 200 });
  getTaskRun(e) {
    return this.batcher.batch(e);
  }
  async getTaskRuns(e = {}) {
    const n = ye.map("TaskRunsFilter", e, "TaskRunsFilterRequest"), { data: r } = await this.post("/filter", n);
    return ye.map("TaskRunResponse", r, "TaskRun");
  }
  async getTaskRunsPaginated(e = {}) {
    const n = ye.map("TaskRunsPaginationFilter", e, "TaskRunsPaginationFilterRequest"), { data: r } = await this.post("/paginate", n);
    return ye.map("TaskRunsPaginationResponse", r, "TaskRunsPagination");
  }
  async getTaskRunsCount(e = {}) {
    const n = ye.map("TaskRunsFilter", e, "TaskRunsFilterRequest"), { data: r } = await this.post("/count", n);
    return r;
  }
  setTaskRunState(e, n) {
    const r = ye.map("StateUpdate", n, "StateUpdateRequest");
    return this.post(`/${e}/set_state`, { state: r.state, force: !0 });
  }
  deleteTaskRun(e) {
    return this.delete(`/${e}`);
  }
  async getTaskRunsHistory(e) {
    const n = ye.map("TaskRunsHistoryFilter", e, "TaskRunsHistoryFilterRequest"), { data: r } = await this.post("/history", n);
    return ye.map("TaskRunHistoryResponse", r, "TaskRunHistory");
  }
}
class pee extends qn {
  routePrefix = "/variables";
  async getVariable(e) {
    const { data: n } = await this.get(`/${e}`);
    return n ? ye.map("VariableResponse", n, "Variable") : null;
  }
  async getVariableByName(e) {
    const { data: n } = await this.get(`/name/${e}`);
    return n ? ye.map("VariableResponse", n, "Variable") : null;
  }
  async getVariablesCount(e = {}) {
    const n = ye.map("VariablesFilter", e, "VariablesFilterRequest"), { data: r } = await this.post("/count", n);
    return r;
  }
  async getVariables(e = {}) {
    const n = ye.map("VariablesFilter", e, "VariablesFilterRequest"), { data: r } = await this.post("/filter", n);
    return ye.map("VariableResponse", r, "Variable");
  }
  async createVariable(e) {
    const n = ye.map("VariableCreate", e, "VariableCreateRequest"), { data: r } = await this.post("/", n);
    return ye.map("VariableResponse", r, "Variable");
  }
  async editVariable(e, n) {
    const r = ye.map("VariableEdit", n, "VariableEditRequest"), { data: o } = await this.patch(`/${e}`, r);
    return ye.map("VariableResponse", o, "Variable");
  }
  deleteVariable(e) {
    return this.delete(`/${e}`);
  }
}
class dee extends qn {
  routePrefix = "/work_pools/";
  async createWorkPoolQueue(e, n) {
    const r = ye.map("WorkPoolQueueCreate", n, "WorkPoolQueueCreateRequest"), { data: o } = await this.post(`/${e}/queues`, r);
    return ye.map("WorkPoolQueueResponse", o, "WorkPoolQueue");
  }
  async getWorkPoolQueues(e, n = {}) {
    const r = ye.map("WorkPoolQueuesFilter", n, "WorkPoolQueuesFilterRequest"), { data: o } = await this.post(`/${e}/queues/filter`, r);
    return ye.map("WorkPoolQueueResponse", o, "WorkPoolQueue");
  }
  async getWorkPoolQueueByName(e, n) {
    const { data: r } = await this.get(`/${e}/queues/${n}`);
    return ye.map("WorkPoolQueueResponse", r, "WorkPoolQueue");
  }
  updateWorkPoolQueue(e, n, r) {
    const o = ye.map("WorkPoolQueueEdit", r, "WorkPoolQueueEditRequest");
    return this.patch(`/${e}/queues/${n}`, o);
  }
  pauseWorkPoolQueue(e, n) {
    return this.patch(`/${e}/queues/${n}`, { is_paused: !0 });
  }
  resumeWorkPoolQueue(e, n) {
    return this.patch(`/${e}/queues/${n}`, { is_paused: !1 });
  }
  deleteWorkPoolQueue(e, n) {
    return this.delete(`/${e}/queues/${n}`);
  }
  updateWorkPoolQueuePriority(e, n, r) {
    return this.patch(`/${e}/queues/${n}/update_priority`, { priority: r });
  }
}
function zx(t) {
  return typeof t == "object" && t !== null && "$ref" in t;
}
function L0(t) {
  return typeof t == "object" && t !== null && "blockTypeSlug" in t && "blockDocumentId" in t;
}
function j3(t) {
  return typeof t == "object" && t !== null && "type" in t && t.type === "span" && "seconds" in t && typeof t.seconds == "number";
}
function z3(t) {
  return typeof t == "object" && t !== null && "type" in t && t.type === "range" && "startDate" in t && typeof t.startDate == "string" && "endDate" in t && typeof t.endDate == "string";
}
function q3(t) {
  return typeof t == "object" && t !== null && "type" in t && t.type === "period" && "period" in t && t.period === "Today";
}
function G3(t) {
  return typeof t == "object" && t !== null && "type" in t && t.type === "around" && "date" in t && typeof t.date == "string" && "unit" in t && typeof t.unit == "string";
}
function hee(t) {
  return j3(t) || z3(t) || q3(t) || G3(t);
}
function dLe(t) {
  return !!t.rrule;
}
function hLe(t) {
  return !!t.cron;
}
function fLe(t) {
  return !!t.interval;
}
function fee(t) {
  return !!t.rrule;
}
function mee(t) {
  return !!t.cron;
}
function yee(t) {
  return !!t.interval;
}
function gee(t) {
  return t.input_type === "constant";
}
function vee(t) {
  return t.input_type === "parameter";
}
function _ee(t) {
  return t.input_type === "task_run";
}
const Y3 = [
  "result",
  "markdown",
  "table",
  "progress",
  "image",
  "unknown"
], wk = {
  default: "Artifact",
  markdown: "ArtifactMarkdown",
  table: "ArtifactTable",
  result: "ArtifactResult",
  progress: "ArtifactProgress",
  image: "ArtifactImage",
  unknown: "Artifact"
};
class Q3 {
  id;
  key;
  kind = "artifact";
  flowRunId;
  taskRunId;
  created;
  updated;
  type;
  description;
  data;
  metadata;
  constructor(e) {
    this.id = e.id, this.created = e.created, this.updated = e.updated, this.key = e.key, this.type = e.type, this.description = e.description, this.data = e.data, this.metadata = e.metadata, this.flowRunId = e.flowRunId, this.taskRunId = e.taskRunId;
  }
}
class wee {
  id;
  latestId;
  key;
  flowRunId;
  taskRunId;
  created;
  updated;
  kind = "artifactCollection";
  type;
  description;
  data;
  metadata;
  constructor(e) {
    this.id = e.id, this.latestId = e.latestId, this.created = e.created, this.updated = e.updated, this.key = e.key, this.type = e.type, this.description = e.description, this.data = e.data, this.metadata = e.metadata, this.flowRunId = e.flowRunId, this.taskRunId = e.taskRunId;
  }
}
class K3 {
  id;
  created;
  updated;
  isAnonymous;
  kind = "blockDocument";
  name;
  data;
  blockSchemaId;
  blockSchema;
  blockTypeId;
  blockType;
  blockDocumentReferences;
  can;
  constructor(e) {
    this.id = e.id, this.created = e.created, this.updated = e.updated, this.isAnonymous = e.isAnonymous, this.name = e.name, this.data = e.data, this.blockSchemaId = e.blockSchemaId, this.blockSchema = e.blockSchema, this.blockTypeId = e.blockTypeId, this.blockType = e.blockType, this.blockDocumentReferences = e.blockDocumentReferences, this.can = e.can;
  }
}
function bee(t) {
  return "name" in t;
}
class Z3 {
  id;
  created;
  updated;
  kind = "blockSchema";
  checksum;
  fields;
  blockTypeId;
  blockType;
  capabilities;
  constructor(e) {
    this.id = e.id, this.created = e.created, this.updated = e.updated, this.checksum = e.checksum, this.fields = e.fields, this.blockTypeId = e.blockTypeId, this.blockType = e.blockType, this.capabilities = e.capabilities;
  }
}
class J3 {
  id;
  kind = "blockType";
  created;
  updated;
  name;
  slug;
  logoUrl;
  documentationUrl;
  description;
  codeExample;
  constructor(e) {
    this.id = e.id, this.created = e.created, this.updated = e.updated, this.name = e.name, this.slug = e.slug, this.logoUrl = e.logoUrl, this.documentationUrl = e.documentationUrl, this.description = e.description, this.codeExample = e.codeExample;
  }
}
var Yr = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Nh(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var A1 = { exports: {} }, kE;
function kee() {
  return kE || (kE = 1, function(t, e) {
    (function(r, o) {
      t.exports = o();
    })(globalThis, () => (
      /******/
      (() => {
        var n = {
          /***/
          949: (
            /***/
            (i, u, l) => {
              Object.defineProperty(u, "__esModule", { value: !0 }), u.CronParser = void 0;
              var a = l(515), c = function() {
                function p(d, h, m) {
                  h === void 0 && (h = !0), m === void 0 && (m = !1), this.expression = d, this.dayOfWeekStartIndexZero = h, this.monthStartIndexZero = m;
                }
                return p.prototype.parse = function() {
                  var d, h, m = (d = this.expression) !== null && d !== void 0 ? d : "";
                  if (m === "@reboot")
                    return h = ["@reboot", "", "", "", "", "", ""], h;
                  if (m.startsWith("@")) {
                    var g = this.parseSpecial(this.expression);
                    h = this.extractParts(g);
                  } else
                    h = this.extractParts(this.expression);
                  return this.normalize(h), this.validate(h), h;
                }, p.prototype.parseSpecial = function(d) {
                  var h = {
                    "@yearly": "0 0 1 1 *",
                    "@annually": "0 0 1 1 *",
                    "@monthly": "0 0 1 * *",
                    "@weekly": "0 0 * * 0",
                    "@daily": "0 0 * * *",
                    "@midnight": "0 0 * * *",
                    "@hourly": "0 * * * *",
                    "@reboot": "@reboot"
                  }, m = h[d];
                  if (!m)
                    throw new Error("Unknown special expression.");
                  return m;
                }, p.prototype.extractParts = function(d) {
                  if (!this.expression)
                    throw new Error("cron expression is empty");
                  for (var h = d.trim().split(/[ ]+/), m = 0; m < h.length; m++)
                    if (h[m].includes(",")) {
                      var g = h[m].split(",").map(function(b) {
                        return b.trim();
                      }).filter(function(b) {
                        return b !== "";
                      }).map(function(b) {
                        return isNaN(Number(b)) ? b : Number(b);
                      }).filter(function(b) {
                        return b !== null && b !== "";
                      });
                      g.length === 0 && g.push("*"), g.sort(function(b, x) {
                        return b !== null && x !== null ? b - x : 0;
                      }), h[m] = g.map(function(b) {
                        return b !== null ? b.toString() : "";
                      }).join(",");
                    }
                  if (h.length < 5)
                    throw new Error("Expression has only ".concat(h.length, " part").concat(h.length == 1 ? "" : "s", ". At least 5 parts are required."));
                  if (h.length == 5)
                    h.unshift(""), h.push("");
                  else if (h.length == 6) {
                    var _ = /\d{4}$/.test(h[5]) || h[4] == "?" || h[2] == "?";
                    _ ? h.unshift("") : h.push("");
                  } else if (h.length > 7)
                    throw new Error("Expression has ".concat(h.length, " parts; too many!"));
                  return h;
                }, p.prototype.normalize = function(d) {
                  var h = this;
                  if (d[3] = d[3].replace("?", "*"), d[5] = d[5].replace("?", "*"), d[2] = d[2].replace("?", "*"), d[0].indexOf("0/") == 0 && (d[0] = d[0].replace("0/", "*/")), d[1].indexOf("0/") == 0 && (d[1] = d[1].replace("0/", "*/")), d[2].indexOf("0/") == 0 && (d[2] = d[2].replace("0/", "*/")), d[3].indexOf("1/") == 0 && (d[3] = d[3].replace("1/", "*/")), d[4].indexOf("1/") == 0 && (d[4] = d[4].replace("1/", "*/")), d[6].indexOf("1/") == 0 && (d[6] = d[6].replace("1/", "*/")), d[5] = d[5].replace(/(^\d)|([^#/\s]\d)/g, function(A) {
                    var C = A.replace(/\D/, ""), M = C;
                    return h.dayOfWeekStartIndexZero ? C == "7" && (M = "0") : M = (parseInt(C) - 1).toString(), A.replace(C, M);
                  }), d[5] == "L" && (d[5] = "6"), d[3] == "?" && (d[3] = "*"), d[3].indexOf("W") > -1 && (d[3].indexOf(",") > -1 || d[3].indexOf("-") > -1))
                    throw new Error("The 'W' character can be specified only when the day-of-month is a single day, not a range or list of days.");
                  var m = {
                    SUN: 0,
                    MON: 1,
                    TUE: 2,
                    WED: 3,
                    THU: 4,
                    FRI: 5,
                    SAT: 6
                  };
                  for (var g in m)
                    d[5] = d[5].replace(new RegExp(g, "gi"), m[g].toString());
                  d[4] = d[4].replace(/(^\d{1,2})|([^#/\s]\d{1,2})/g, function(A) {
                    var C = A.replace(/\D/, ""), M = C;
                    return h.monthStartIndexZero && (M = (parseInt(C) + 1).toString()), A.replace(C, M);
                  });
                  var _ = {
                    JAN: 1,
                    FEB: 2,
                    MAR: 3,
                    APR: 4,
                    MAY: 5,
                    JUN: 6,
                    JUL: 7,
                    AUG: 8,
                    SEP: 9,
                    OCT: 10,
                    NOV: 11,
                    DEC: 12
                  };
                  for (var b in _)
                    d[4] = d[4].replace(new RegExp(b, "gi"), _[b].toString());
                  d[0] == "0" && (d[0] = ""), !/\*|\-|\,|\//.test(d[2]) && (/\*|\//.test(d[1]) || /\*|\//.test(d[0])) && (d[2] += "-".concat(d[2]));
                  for (var x = 0; x < d.length; x++)
                    if (d[x].indexOf(",") != -1 && (d[x] = d[x].split(",").filter(function(A) {
                      return A !== "";
                    }).join(",") || "*"), d[x] == "*/1" && (d[x] = "*"), d[x].indexOf("/") > -1 && !/^\*|\-|\,/.test(d[x])) {
                      var S = null;
                      switch (x) {
                        case 4:
                          S = "12";
                          break;
                        case 5:
                          S = "6";
                          break;
                        case 6:
                          S = "9999";
                          break;
                        default:
                          S = null;
                          break;
                      }
                      if (S !== null) {
                        var E = d[x].split("/");
                        d[x] = "".concat(E[0], "-").concat(S, "/").concat(E[1]);
                      }
                    }
                }, p.prototype.validate = function(d) {
                  var h = "0-9,\\-*/";
                  this.validateOnlyExpectedCharactersFound(d[0], h), this.validateOnlyExpectedCharactersFound(d[1], h), this.validateOnlyExpectedCharactersFound(d[2], h), this.validateOnlyExpectedCharactersFound(d[3], "0-9,\\-*/LW"), this.validateOnlyExpectedCharactersFound(d[4], h), this.validateOnlyExpectedCharactersFound(d[5], "0-9,\\-*/L#"), this.validateOnlyExpectedCharactersFound(d[6], h), this.validateAnyRanges(d);
                }, p.prototype.validateAnyRanges = function(d) {
                  a.default.secondRange(d[0]), a.default.minuteRange(d[1]), a.default.hourRange(d[2]), a.default.dayOfMonthRange(d[3]), a.default.monthRange(d[4], this.monthStartIndexZero), a.default.dayOfWeekRange(d[5], this.dayOfWeekStartIndexZero);
                }, p.prototype.validateOnlyExpectedCharactersFound = function(d, h) {
                  var m = d.match(new RegExp("[^".concat(h, "]+"), "gi"));
                  if (m && m.length)
                    throw new Error("Expression contains invalid values: '".concat(m.toString(), "'"));
                }, p;
              }();
              u.CronParser = c;
            }
          ),
          /***/
          333: (
            /***/
            (i, u, l) => {
              Object.defineProperty(u, "__esModule", { value: !0 }), u.ExpressionDescriptor = void 0;
              var a = l(823), c = l(949), p = function() {
                function d(h, m) {
                  if (this.expression = h, this.options = m, this.expressionParts = new Array(5), !this.options.locale && d.defaultLocale && (this.options.locale = d.defaultLocale), !d.locales[this.options.locale]) {
                    var g = Object.keys(d.locales)[0];
                    console.warn("Locale '".concat(this.options.locale, "' could not be found; falling back to '").concat(g, "'.")), this.options.locale = g;
                  }
                  this.i18n = d.locales[this.options.locale], m.use24HourTimeFormat === void 0 && (m.use24HourTimeFormat = this.i18n.use24HourTimeFormatByDefault());
                }
                return d.toString = function(h, m) {
                  var g = m === void 0 ? {} : m, _ = g.throwExceptionOnParseError, b = _ === void 0 ? !0 : _, x = g.verbose, S = x === void 0 ? !1 : x, E = g.dayOfWeekStartIndexZero, A = E === void 0 ? !0 : E, C = g.monthStartIndexZero, M = C === void 0 ? !1 : C, L = g.use24HourTimeFormat, X = g.locale, te = X === void 0 ? null : X, B = {
                    throwExceptionOnParseError: b,
                    verbose: S,
                    dayOfWeekStartIndexZero: A,
                    monthStartIndexZero: M,
                    use24HourTimeFormat: L,
                    locale: te
                  };
                  B.tzOffset && console.warn("'tzOffset' option has been deprecated and is no longer supported.");
                  var W = new d(h, B);
                  return W.getFullDescription();
                }, d.initialize = function(h, m) {
                  m === void 0 && (m = "en"), d.specialCharacters = ["/", "-", ",", "*"], d.defaultLocale = m, h.load(d.locales);
                }, d.prototype.getFullDescription = function() {
                  var h, m, g = "";
                  try {
                    var _ = new c.CronParser(this.expression, this.options.dayOfWeekStartIndexZero, this.options.monthStartIndexZero);
                    if (this.expressionParts = _.parse(), this.expressionParts[0] === "@reboot")
                      return ((m = (h = this.i18n).atReboot) === null || m === void 0 ? void 0 : m.call(h)) || "Run once, at startup";
                    var b = this.getTimeOfDayDescription(), x = this.getDayOfMonthDescription(), S = this.getMonthDescription(), E = this.getDayOfWeekDescription(), A = this.getYearDescription();
                    g += b + x + E + S + A, g = this.transformVerbosity(g, !!this.options.verbose), g = g.charAt(0).toLocaleUpperCase() + g.substr(1);
                  } catch (C) {
                    if (!this.options.throwExceptionOnParseError)
                      g = this.i18n.anErrorOccuredWhenGeneratingTheExpressionD();
                    else
                      throw "".concat(C);
                  }
                  return g;
                }, d.prototype.getTimeOfDayDescription = function() {
                  var h = this.expressionParts[0], m = this.expressionParts[1], g = this.expressionParts[2], _ = "";
                  if (!a.StringUtilities.containsAny(m, d.specialCharacters) && !a.StringUtilities.containsAny(g, d.specialCharacters) && !a.StringUtilities.containsAny(h, d.specialCharacters))
                    _ += this.i18n.atSpace() + this.formatTime(g, m, h);
                  else if (!h && m.indexOf("-") > -1 && !(m.indexOf(",") > -1) && !(m.indexOf("/") > -1) && !a.StringUtilities.containsAny(g, d.specialCharacters)) {
                    var b = m.split("-");
                    _ += a.StringUtilities.format(this.i18n.everyMinuteBetweenX0AndX1(), this.formatTime(g, b[0], ""), this.formatTime(g, b[1], ""));
                  } else if (!h && g.indexOf(",") > -1 && g.indexOf("-") == -1 && g.indexOf("/") == -1 && !a.StringUtilities.containsAny(m, d.specialCharacters)) {
                    var x = g.split(",");
                    _ += this.i18n.at();
                    for (var S = 0; S < x.length; S++)
                      _ += " ", _ += this.formatTime(x[S], m, ""), S < x.length - 2 && (_ += ","), S == x.length - 2 && (_ += this.i18n.spaceAnd());
                  } else {
                    var E = this.getSecondsDescription(), A = this.getMinutesDescription(), C = this.getHoursDescription();
                    if (_ += E, _ && A && (_ += ", "), _ += A, A === C)
                      return _;
                    _ && C && (_ += ", "), _ += C;
                  }
                  return _;
                }, d.prototype.getSecondsDescription = function() {
                  var h = this, m = this.getSegmentDescription(this.expressionParts[0], this.i18n.everySecond(), function(g) {
                    return g;
                  }, function(g) {
                    return a.StringUtilities.format(h.i18n.everyX0Seconds(g), g);
                  }, function(g) {
                    return h.i18n.secondsX0ThroughX1PastTheMinute();
                  }, function(g) {
                    return g == "0" ? "" : parseInt(g) < 20 ? h.i18n.atX0SecondsPastTheMinute(g) : h.i18n.atX0SecondsPastTheMinuteGt20() || h.i18n.atX0SecondsPastTheMinute(g);
                  });
                  return m;
                }, d.prototype.getMinutesDescription = function() {
                  var h = this, m = this.expressionParts[0], g = this.expressionParts[2], _ = this.getSegmentDescription(this.expressionParts[1], this.i18n.everyMinute(), function(b) {
                    return b;
                  }, function(b) {
                    return a.StringUtilities.format(h.i18n.everyX0Minutes(b), b);
                  }, function(b) {
                    return h.i18n.minutesX0ThroughX1PastTheHour();
                  }, function(b) {
                    try {
                      return b == "0" && g.indexOf("/") == -1 && m == "" ? h.i18n.everyHour() : parseInt(b) < 20 ? h.i18n.atX0MinutesPastTheHour(b) : h.i18n.atX0MinutesPastTheHourGt20() || h.i18n.atX0MinutesPastTheHour(b);
                    } catch {
                      return h.i18n.atX0MinutesPastTheHour(b);
                    }
                  });
                  return _;
                }, d.prototype.getHoursDescription = function() {
                  var h = this, m = this.expressionParts[2], g = 0, _ = [];
                  m.split("/")[0].split(",").forEach(function(S) {
                    var E = S.split("-");
                    E.length === 2 && _.push({ value: E[1], index: g + 1 }), g += E.length;
                  });
                  var b = 0, x = this.getSegmentDescription(m, this.i18n.everyHour(), function(S) {
                    var E = _.find(function(C) {
                      return C.value === S && C.index === b;
                    }), A = E && h.expressionParts[1] !== "0";
                    return b++, A ? h.formatTime(S, "59", "") : h.formatTime(S, "0", "");
                  }, function(S) {
                    return a.StringUtilities.format(h.i18n.everyX0Hours(S), S);
                  }, function(S) {
                    return h.i18n.betweenX0AndX1();
                  }, function(S) {
                    return h.i18n.atX0();
                  });
                  return x;
                }, d.prototype.getDayOfWeekDescription = function() {
                  var h = this, m = this.i18n.daysOfTheWeek(), g = null;
                  return this.expressionParts[5] == "*" ? g = "" : g = this.getSegmentDescription(this.expressionParts[5], this.i18n.commaEveryDay(), function(_, b) {
                    var x = _;
                    _.indexOf("#") > -1 ? x = _.substring(0, _.indexOf("#")) : _.indexOf("L") > -1 && (x = x.replace("L", ""));
                    var S = parseInt(x), E = h.i18n.daysOfTheWeekInCase ? h.i18n.daysOfTheWeekInCase(b)[S] : m[S];
                    if (_.indexOf("#") > -1) {
                      var A = null, C = _.substring(_.indexOf("#") + 1), M = _.substring(0, _.indexOf("#"));
                      switch (C) {
                        case "1":
                          A = h.i18n.first(M);
                          break;
                        case "2":
                          A = h.i18n.second(M);
                          break;
                        case "3":
                          A = h.i18n.third(M);
                          break;
                        case "4":
                          A = h.i18n.fourth(M);
                          break;
                        case "5":
                          A = h.i18n.fifth(M);
                          break;
                      }
                      E = A + " " + E;
                    }
                    return E;
                  }, function(_) {
                    return parseInt(_) == 1 ? "" : a.StringUtilities.format(h.i18n.commaEveryX0DaysOfTheWeek(_), _);
                  }, function(_) {
                    var b = _.substring(0, _.indexOf("-")), x = h.expressionParts[3] != "*";
                    return x ? h.i18n.commaAndX0ThroughX1(b) : h.i18n.commaX0ThroughX1(b);
                  }, function(_) {
                    var b = null;
                    if (_.indexOf("#") > -1) {
                      var x = _.substring(_.indexOf("#") + 1), S = _.substring(0, _.indexOf("#"));
                      b = h.i18n.commaOnThe(x, S).trim() + h.i18n.spaceX0OfTheMonth();
                    } else if (_.indexOf("L") > -1)
                      b = h.i18n.commaOnTheLastX0OfTheMonth(_.replace("L", ""));
                    else {
                      var E = h.expressionParts[3] != "*";
                      b = E ? h.i18n.commaAndOnX0() : h.i18n.commaOnlyOnX0(_);
                    }
                    return b;
                  }), g;
                }, d.prototype.getMonthDescription = function() {
                  var h = this, m = this.i18n.monthsOfTheYear(), g = this.getSegmentDescription(this.expressionParts[4], "", function(_, b) {
                    return b && h.i18n.monthsOfTheYearInCase ? h.i18n.monthsOfTheYearInCase(b)[parseInt(_) - 1] : m[parseInt(_) - 1];
                  }, function(_) {
                    return parseInt(_) == 1 ? "" : a.StringUtilities.format(h.i18n.commaEveryX0Months(_), _);
                  }, function(_) {
                    return h.i18n.commaMonthX0ThroughMonthX1() || h.i18n.commaX0ThroughX1();
                  }, function(_) {
                    return h.i18n.commaOnlyInMonthX0 ? h.i18n.commaOnlyInMonthX0() : h.i18n.commaOnlyInX0();
                  });
                  return g;
                }, d.prototype.getDayOfMonthDescription = function() {
                  var h = this, m = null, g = this.expressionParts[3];
                  switch (g) {
                    case "L":
                      m = this.i18n.commaOnTheLastDayOfTheMonth();
                      break;
                    case "WL":
                    case "LW":
                      m = this.i18n.commaOnTheLastWeekdayOfTheMonth();
                      break;
                    default:
                      var _ = g.match(/(\d{1,2}W)|(W\d{1,2})/);
                      if (_) {
                        var b = parseInt(_[0].replace("W", "")), x = b == 1 ? this.i18n.firstWeekday() : a.StringUtilities.format(this.i18n.weekdayNearestDayX0(), b.toString());
                        m = a.StringUtilities.format(this.i18n.commaOnTheX0OfTheMonth(), x);
                        break;
                      } else {
                        var S = g.match(/L-(\d{1,2})/);
                        if (S) {
                          var E = S[1];
                          m = a.StringUtilities.format(this.i18n.commaDaysBeforeTheLastDayOfTheMonth(E), E);
                          break;
                        } else {
                          if (g == "*" && this.expressionParts[5] != "*")
                            return "";
                          m = this.getSegmentDescription(g, this.i18n.commaEveryDay(), function(A) {
                            return A == "L" ? h.i18n.lastDay() : h.i18n.dayX0 ? a.StringUtilities.format(h.i18n.dayX0(), A) : A;
                          }, function(A) {
                            return A == "1" ? h.i18n.commaEveryDay() : h.i18n.commaEveryX0Days(A);
                          }, function(A) {
                            return h.i18n.commaBetweenDayX0AndX1OfTheMonth(A);
                          }, function(A) {
                            return h.i18n.commaOnDayX0OfTheMonth(A);
                          });
                        }
                        break;
                      }
                  }
                  return m;
                }, d.prototype.getYearDescription = function() {
                  var h = this, m = this.getSegmentDescription(this.expressionParts[6], "", function(g) {
                    return /^\d+$/.test(g) ? new Date(parseInt(g), 1).getFullYear().toString() : g;
                  }, function(g) {
                    return a.StringUtilities.format(h.i18n.commaEveryX0Years(g), g);
                  }, function(g) {
                    return h.i18n.commaYearX0ThroughYearX1() || h.i18n.commaX0ThroughX1();
                  }, function(g) {
                    return h.i18n.commaOnlyInYearX0 ? h.i18n.commaOnlyInYearX0() : h.i18n.commaOnlyInX0();
                  });
                  return m;
                }, d.prototype.getSegmentDescription = function(h, m, g, _, b, x) {
                  var S = null, E = h.indexOf("/") > -1, A = h.indexOf("-") > -1, C = h.indexOf(",") > -1;
                  if (!h)
                    S = "";
                  else if (h === "*")
                    S = m;
                  else if (!E && !A && !C)
                    S = a.StringUtilities.format(x(h), g(h));
                  else if (C) {
                    for (var M = h.split(","), L = "", X = 0; X < M.length; X++)
                      if (X > 0 && M.length > 2 && (L += ",", X < M.length - 1 && (L += " ")), X > 0 && M.length > 1 && (X == M.length - 1 || M.length == 2) && (L += "".concat(this.i18n.spaceAnd(), " ")), M[X].indexOf("/") > -1 || M[X].indexOf("-") > -1) {
                        var te = M[X].indexOf("-") > -1 && M[X].indexOf("/") == -1, B = this.getSegmentDescription(M[X], m, g, _, te ? this.i18n.commaX0ThroughX1 : b, x);
                        te && (B = B.replace(", ", "")), L += B;
                      } else E ? L += this.getSegmentDescription(M[X], m, g, _, b, x) : L += g(M[X]);
                    E ? S = L : S = a.StringUtilities.format(x(h), L);
                  } else if (E) {
                    var M = h.split("/");
                    if (S = a.StringUtilities.format(_(M[1]), M[1]), M[0].indexOf("-") > -1) {
                      var W = this.generateRangeSegmentDescription(M[0], b, g);
                      W.indexOf(", ") != 0 && (S += ", "), S += W;
                    } else if (M[0].indexOf("*") == -1) {
                      var G = a.StringUtilities.format(x(M[0]), g(M[0]));
                      G = G.replace(", ", ""), S += a.StringUtilities.format(this.i18n.commaStartingX0(), G);
                    }
                  } else A && (S = this.generateRangeSegmentDescription(h, b, g));
                  return S;
                }, d.prototype.generateRangeSegmentDescription = function(h, m, g) {
                  var _ = "", b = h.split("-"), x = g(b[0], 1), S = g(b[1], 2), E = m(h);
                  return _ += a.StringUtilities.format(E, x, S), _;
                }, d.prototype.formatTime = function(h, m, g) {
                  var _ = 0, b = 0, x = parseInt(h) + _, S = parseInt(m) + b;
                  S >= 60 ? (S -= 60, x += 1) : S < 0 && (S += 60, x -= 1), x >= 24 ? x = x - 24 : x < 0 && (x = 24 + x);
                  var E = "", A = !1;
                  this.options.use24HourTimeFormat || (A = !!(this.i18n.setPeriodBeforeTime && this.i18n.setPeriodBeforeTime()), E = A ? "".concat(this.getPeriod(x), " ") : " ".concat(this.getPeriod(x)), x > 12 && (x -= 12), x === 0 && (x = 12));
                  var C = "";
                  return g && (C = ":".concat(("00" + g).substring(g.length))), "".concat(A ? E : "").concat(("00" + x.toString()).substring(x.toString().length), ":").concat(("00" + S.toString()).substring(S.toString().length)).concat(C).concat(A ? "" : E);
                }, d.prototype.transformVerbosity = function(h, m) {
                  if (!m && (h = h.replace(new RegExp(", ".concat(this.i18n.everyMinute()), "g"), ""), h = h.replace(new RegExp(", ".concat(this.i18n.everyHour()), "g"), ""), h = h.replace(new RegExp(this.i18n.commaEveryDay(), "g"), ""), h = h.replace(/\, ?$/, ""), this.i18n.conciseVerbosityReplacements))
                    for (var g = 0, _ = Object.entries(this.i18n.conciseVerbosityReplacements()); g < _.length; g++) {
                      var b = _[g], x = b[0], S = b[1];
                      h = h.replace(new RegExp(x, "g"), S);
                    }
                  return h;
                }, d.prototype.getPeriod = function(h) {
                  return h >= 12 ? this.i18n.pm && this.i18n.pm() || "PM" : this.i18n.am && this.i18n.am() || "AM";
                }, d.locales = {}, d;
              }();
              u.ExpressionDescriptor = p;
            }
          ),
          /***/
          99: (
            /***/
            (i, u, l) => {
              Object.defineProperty(u, "__esModule", { value: !0 }), u.sr = u.hr = u.bg = u.my = u.vi = u.ar = u.th = u.af = u.hu = u.be = u.ca = u.fa = u.sw = u.sl = u.fi = u.sk = u.cs = u.he = u.ja = u.zh_TW = u.zh_CN = u.uk = u.tr = u.ru = u.ro = u.pt_PT = u.pt_BR = u.pl = u.sv = u.nb = u.nl = u.ko = u.id = u.it = u.fr = u.es = u.de = u.da = u.en = void 0;
              var a = l(486);
              Object.defineProperty(u, "en", { enumerable: !0, get: function() {
                return a.en;
              } });
              var c = l(506);
              Object.defineProperty(u, "da", { enumerable: !0, get: function() {
                return c.da;
              } });
              var p = l(230);
              Object.defineProperty(u, "de", { enumerable: !0, get: function() {
                return p.de;
              } });
              var d = l(153);
              Object.defineProperty(u, "es", { enumerable: !0, get: function() {
                return d.es;
              } });
              var h = l(517);
              Object.defineProperty(u, "fr", { enumerable: !0, get: function() {
                return h.fr;
              } });
              var m = l(488);
              Object.defineProperty(u, "it", { enumerable: !0, get: function() {
                return m.it;
              } });
              var g = l(72);
              Object.defineProperty(u, "id", { enumerable: !0, get: function() {
                return g.id;
              } });
              var _ = l(839);
              Object.defineProperty(u, "ko", { enumerable: !0, get: function() {
                return _.ko;
              } });
              var b = l(647);
              Object.defineProperty(u, "nl", { enumerable: !0, get: function() {
                return b.nl;
              } });
              var x = l(957);
              Object.defineProperty(u, "nb", { enumerable: !0, get: function() {
                return x.nb;
              } });
              var S = l(544);
              Object.defineProperty(u, "sv", { enumerable: !0, get: function() {
                return S.sv;
              } });
              var E = l(905);
              Object.defineProperty(u, "pl", { enumerable: !0, get: function() {
                return E.pl;
              } });
              var A = l(556);
              Object.defineProperty(u, "pt_BR", { enumerable: !0, get: function() {
                return A.pt_BR;
              } });
              var C = l(163);
              Object.defineProperty(u, "pt_PT", { enumerable: !0, get: function() {
                return C.pt_PT;
              } });
              var M = l(614);
              Object.defineProperty(u, "ro", { enumerable: !0, get: function() {
                return M.ro;
              } });
              var L = l(892);
              Object.defineProperty(u, "ru", { enumerable: !0, get: function() {
                return L.ru;
              } });
              var X = l(631);
              Object.defineProperty(u, "tr", { enumerable: !0, get: function() {
                return X.tr;
              } });
              var te = l(225);
              Object.defineProperty(u, "uk", { enumerable: !0, get: function() {
                return te.uk;
              } });
              var B = l(571);
              Object.defineProperty(u, "zh_CN", { enumerable: !0, get: function() {
                return B.zh_CN;
              } });
              var W = l(983);
              Object.defineProperty(u, "zh_TW", { enumerable: !0, get: function() {
                return W.zh_TW;
              } });
              var G = l(904);
              Object.defineProperty(u, "ja", { enumerable: !0, get: function() {
                return G.ja;
              } });
              var ne = l(82);
              Object.defineProperty(u, "he", { enumerable: !0, get: function() {
                return ne.he;
              } });
              var de = l(651);
              Object.defineProperty(u, "cs", { enumerable: !0, get: function() {
                return de.cs;
              } });
              var V = l(923);
              Object.defineProperty(u, "sk", { enumerable: !0, get: function() {
                return V.sk;
              } });
              var Y = l(964);
              Object.defineProperty(u, "fi", { enumerable: !0, get: function() {
                return Y.fi;
              } });
              var Q = l(474);
              Object.defineProperty(u, "sl", { enumerable: !0, get: function() {
                return Q.sl;
              } });
              var ae = l(799);
              Object.defineProperty(u, "sw", { enumerable: !0, get: function() {
                return ae.sw;
              } });
              var Z = l(804);
              Object.defineProperty(u, "fa", { enumerable: !0, get: function() {
                return Z.fa;
              } });
              var J = l(845);
              Object.defineProperty(u, "ca", { enumerable: !0, get: function() {
                return J.ca;
              } });
              var oe = l(348);
              Object.defineProperty(u, "be", { enumerable: !0, get: function() {
                return oe.be;
              } });
              var ue = l(194);
              Object.defineProperty(u, "hu", { enumerable: !0, get: function() {
                return ue.hu;
              } });
              var me = l(810);
              Object.defineProperty(u, "af", { enumerable: !0, get: function() {
                return me.af;
              } });
              var pe = l(33);
              Object.defineProperty(u, "th", { enumerable: !0, get: function() {
                return pe.th;
              } });
              var Be = l(574);
              Object.defineProperty(u, "ar", { enumerable: !0, get: function() {
                return Be.ar;
              } });
              var Ie = l(292);
              Object.defineProperty(u, "vi", { enumerable: !0, get: function() {
                return Ie.vi;
              } });
              var Me = l(919);
              Object.defineProperty(u, "my", { enumerable: !0, get: function() {
                return Me.my;
              } });
              var fe = l(622);
              Object.defineProperty(u, "bg", { enumerable: !0, get: function() {
                return fe.bg;
              } });
              var Te = l(131);
              Object.defineProperty(u, "hr", { enumerable: !0, get: function() {
                return Te.hr;
              } });
              var Ae = l(716);
              Object.defineProperty(u, "sr", { enumerable: !0, get: function() {
                return Ae.sr;
              } });
            }
          ),
          /***/
          420: (
            /***/
            (i, u, l) => {
              Object.defineProperty(u, "__esModule", { value: !0 }), u.allLocalesLoader = void 0;
              var a = l(99), c = function() {
                function p() {
                }
                return p.prototype.load = function(d) {
                  for (var h in a)
                    a.hasOwnProperty(h) && (d[h] = new a[h]());
                }, p;
              }();
              u.allLocalesLoader = c;
            }
          ),
          /***/
          810: (
            /***/
            (i, u) => {
              Object.defineProperty(u, "__esModule", { value: !0 }), u.af = void 0;
              var l = function() {
                function a() {
                }
                return a.prototype.atX0SecondsPastTheMinuteGt20 = function() {
                  return null;
                }, a.prototype.atX0MinutesPastTheHourGt20 = function() {
                  return null;
                }, a.prototype.commaMonthX0ThroughMonthX1 = function() {
                  return null;
                }, a.prototype.commaYearX0ThroughYearX1 = function() {
                  return ", jaar %s na %s";
                }, a.prototype.use24HourTimeFormatByDefault = function() {
                  return !0;
                }, a.prototype.anErrorOccuredWhenGeneratingTheExpressionD = function() {
                  return "Daar was 'n fout om die tydsuitdrukking the genereer. Raadpleeg asb die uitdrukking formaat.";
                }, a.prototype.everyMinute = function() {
                  return "elke minuut";
                }, a.prototype.everyHour = function() {
                  return "elke uur";
                }, a.prototype.atSpace = function() {
                  return "Teen ";
                }, a.prototype.everyMinuteBetweenX0AndX1 = function() {
                  return "Elke minuut tussen %s en %s";
                }, a.prototype.at = function() {
                  return "Teen";
                }, a.prototype.spaceAnd = function() {
                  return " en";
                }, a.prototype.everySecond = function() {
                  return "elke sekonde";
                }, a.prototype.everyX0Seconds = function() {
                  return "elke %s sekonde";
                }, a.prototype.secondsX0ThroughX1PastTheMinute = function() {
                  return "sekonde %s deur na %s na die minuut";
                }, a.prototype.atX0SecondsPastTheMinute = function() {
                  return "teen %s sekondes na die minuut";
                }, a.prototype.everyX0Minutes = function() {
                  return "elke %s minute";
                }, a.prototype.minutesX0ThroughX1PastTheHour = function() {
                  return "minute %s deur na %s na die uur";
                }, a.prototype.atX0MinutesPastTheHour = function() {
                  return "teen %s minute na die uur";
                }, a.prototype.everyX0Hours = function() {
                  return "elke %s ure";
                }, a.prototype.betweenX0AndX1 = function() {
                  return "tussen %s en %s";
                }, a.prototype.atX0 = function() {
                  return "teen %s";
                }, a.prototype.commaEveryDay = function() {
                  return ", elke dag";
                }, a.prototype.commaEveryX0DaysOfTheWeek = function() {
                  return ", elke %s dae van die week";
                }, a.prototype.commaX0ThroughX1 = function() {
                  return ", %s deur na %s";
                }, a.prototype.commaAndX0ThroughX1 = function() {
                  return ", en %s deur na %s";
                }, a.prototype.first = function() {
                  return "eerste";
                }, a.prototype.second = function() {
                  return "tweede";
                }, a.prototype.third = function() {
                  return "derde";
                }, a.prototype.fourth = function() {
                  return "vierde";
                }, a.prototype.fifth = function() {
                  return "vyfde";
                }, a.prototype.commaOnThe = function() {
                  return ", op die ";
                }, a.prototype.spaceX0OfTheMonth = function() {
                  return " %s van die maand";
                }, a.prototype.lastDay = function() {
                  return "die laaste dag";
                }, a.prototype.commaOnTheLastX0OfTheMonth = function() {
                  return ", op die laaste %s van die maand";
                }, a.prototype.commaOnlyOnX0 = function() {
                  return ", net op %s";
                }, a.prototype.commaAndOnX0 = function() {
                  return ", en op %s";
                }, a.prototype.commaEveryX0Months = function() {
                  return ", elke %s maande";
                }, a.prototype.commaOnlyInX0 = function() {
                  return ", net in %s";
                }, a.prototype.commaOnTheLastDayOfTheMonth = function() {
                  return ", op die laaste dag van die maand";
                }, a.prototype.commaOnTheLastWeekdayOfTheMonth = function() {
                  return ", op die laaste weeksdag van die maand";
                }, a.prototype.commaDaysBeforeTheLastDayOfTheMonth = function() {
                  return ", %s dae voor die laaste dag van die maand";
                }, a.prototype.firstWeekday = function() {
                  return "eerste weeksdag";
                }, a.prototype.weekdayNearestDayX0 = function() {
                  return "weeksdag naaste aan dag %s";
                }, a.prototype.commaOnTheX0OfTheMonth = function() {
                  return ", op die %s van die maande";
                }, a.prototype.commaEveryX0Days = function() {
                  return ", elke %s dae";
                }, a.prototype.commaBetweenDayX0AndX1OfTheMonth = function() {
                  return ", tussen dag %s en %s van die maand";
                }, a.prototype.commaOnDayX0OfTheMonth = function() {
                  return ", op dag %s van die maand";
                }, a.prototype.commaEveryHour = function() {
                  return ", elke uur";
                }, a.prototype.commaEveryX0Years = function() {
                  return ", elke %s jare";
                }, a.prototype.commaStartingX0 = function() {
                  return ", beginnende %s";
                }, a.prototype.daysOfTheWeek = function() {
                  return ["Sondag", "Maandag", "Dinsdag", "Woensdag", "Donderdag", "Vrydag", "Saterdag"];
                }, a.prototype.monthsOfTheYear = function() {
                  return [
                    "Januarie",
                    "Februarie",
                    "Maart",
                    "April",
                    "Mei",
                    "Junie",
                    "Julie",
                    "Augustus",
                    "September",
                    "Oktober",
                    "November",
                    "Desember"
                  ];
                }, a;
              }();
              u.af = l;
            }
          ),
          /***/
          574: (
            /***/
            (i, u) => {
              Object.defineProperty(u, "__esModule", { value: !0 }), u.ar = void 0;
              var l = function() {
                function a() {
                }
                return a.prototype.atX0SecondsPastTheMinuteGt20 = function() {
                  return null;
                }, a.prototype.atX0MinutesPastTheHourGt20 = function() {
                  return null;
                }, a.prototype.commaMonthX0ThroughMonthX1 = function() {
                  return null;
                }, a.prototype.commaYearX0ThroughYearX1 = function() {
                  return null;
                }, a.prototype.use24HourTimeFormatByDefault = function() {
                  return !0;
                }, a.prototype.anErrorOccuredWhenGeneratingTheExpressionD = function() {
                  return "حدث خطأ في إنشاء وصف المصطلح٠ تأكد من تركيب مصطلح الكرون";
                }, a.prototype.everyMinute = function() {
                  return "كل دقيقة";
                }, a.prototype.everyHour = function() {
                  return "كل ساعة";
                }, a.prototype.atSpace = function() {
                  return " ";
                }, a.prototype.everyMinuteBetweenX0AndX1 = function() {
                  return "كل دقيقة بين %s و %s";
                }, a.prototype.at = function() {
                  return "";
                }, a.prototype.spaceAnd = function() {
                  return " و";
                }, a.prototype.everySecond = function() {
                  return "كل ثانية";
                }, a.prototype.everyX0Seconds = function() {
                  return "كل %s ثواني";
                }, a.prototype.secondsX0ThroughX1PastTheMinute = function() {
                  return "الثواني %s حتى %s من بداية الدقيقة";
                }, a.prototype.atX0SecondsPastTheMinute = function() {
                  return "الثانية %s من بداية الدقيقة";
                }, a.prototype.everyX0Minutes = function() {
                  return "كل %s دقائق";
                }, a.prototype.minutesX0ThroughX1PastTheHour = function() {
                  return "الدقائق %s حتى %s من بداية الساعة";
                }, a.prototype.atX0MinutesPastTheHour = function() {
                  return "الدقيقة %s من بداية الساعة";
                }, a.prototype.everyX0Hours = function() {
                  return "كل %s ساعات";
                }, a.prototype.betweenX0AndX1 = function() {
                  return "بين %s و %s";
                }, a.prototype.atX0 = function() {
                  return "%s";
                }, a.prototype.commaEveryDay = function() {
                  return "، كل يوم";
                }, a.prototype.commaEveryX0DaysOfTheWeek = function() {
                  return "، كل %s من أيام الأسبوع";
                }, a.prototype.commaX0ThroughX1 = function() {
                  return "، %s حتى %s";
                }, a.prototype.commaAndX0ThroughX1 = function() {
                  return "، و %s حتى %s";
                }, a.prototype.first = function() {
                  return "أول";
                }, a.prototype.second = function() {
                  return "ثاني";
                }, a.prototype.third = function() {
                  return "ثالث";
                }, a.prototype.fourth = function() {
                  return "رابع";
                }, a.prototype.fifth = function() {
                  return "خامس";
                }, a.prototype.commaOnThe = function() {
                  return "، في ال";
                }, a.prototype.spaceX0OfTheMonth = function() {
                  return " %s من الشهر";
                }, a.prototype.lastDay = function() {
                  return "اليوم الأخير";
                }, a.prototype.commaOnTheLastX0OfTheMonth = function() {
                  return "، في اخر %s من الشهر";
                }, a.prototype.commaOnlyOnX0 = function() {
                  return "، %s فقط";
                }, a.prototype.commaAndOnX0 = function() {
                  return "، وفي %s";
                }, a.prototype.commaEveryX0Months = function() {
                  return "، كل %s أشهر";
                }, a.prototype.commaOnlyInX0 = function() {
                  return "، %s فقط";
                }, a.prototype.commaOnTheLastDayOfTheMonth = function() {
                  return "، في اخر يوم من الشهر";
                }, a.prototype.commaOnTheLastWeekdayOfTheMonth = function() {
                  return "، في اخر يوم أسبوع من الشهر";
                }, a.prototype.commaDaysBeforeTheLastDayOfTheMonth = function() {
                  return "، %s أيام قبل اخر يوم من الشهر";
                }, a.prototype.firstWeekday = function() {
                  return "اول ايام الأسبوع";
                }, a.prototype.weekdayNearestDayX0 = function() {
                  return "يوم الأسبوع الأقرب ليوم %s";
                }, a.prototype.commaOnTheX0OfTheMonth = function() {
                  return "، في %s من الشهر";
                }, a.prototype.commaEveryX0Days = function() {
                  return "، كل %s أيام";
                }, a.prototype.commaBetweenDayX0AndX1OfTheMonth = function() {
                  return "، بين يوم %s و %s من الشهر";
                }, a.prototype.commaOnDayX0OfTheMonth = function() {
                  return "، في اليوم %s من الشهر";
                }, a.prototype.commaEveryHour = function() {
                  return "، كل ساعة";
                }, a.prototype.commaEveryX0Years = function() {
                  return "، كل %s سنوات";
                }, a.prototype.commaStartingX0 = function() {
                  return "، بداية من %s";
                }, a.prototype.daysOfTheWeek = function() {
                  return ["الأحد", "الإثنين", "الثلاثاء", "الأربعاء", "الخميس", "الجمعة", "السبت"];
                }, a.prototype.monthsOfTheYear = function() {
                  return [
                    "يناير",
                    "فبراير",
                    "مارس",
                    "ابريل",
                    "مايو",
                    "يونيو",
                    "يوليو",
                    "أغسطس",
                    "سبتمبر",
                    "أكتوبر",
                    "نوفمبر",
                    "ديسمبر"
                  ];
                }, a;
              }();
              u.ar = l;
            }
          ),
          /***/
          348: (
            /***/
            (i, u) => {
              Object.defineProperty(u, "__esModule", { value: !0 }), u.be = void 0;
              var l = function() {
                function a() {
                }
                return a.prototype.atX0SecondsPastTheMinuteGt20 = function() {
                  return null;
                }, a.prototype.atX0MinutesPastTheHourGt20 = function() {
                  return null;
                }, a.prototype.commaMonthX0ThroughMonthX1 = function() {
                  return null;
                }, a.prototype.commaYearX0ThroughYearX1 = function() {
                  return null;
                }, a.prototype.use24HourTimeFormatByDefault = function() {
                  return !1;
                }, a.prototype.everyMinute = function() {
                  return "кожную хвіліну";
                }, a.prototype.everyHour = function() {
                  return "кожную гадзіну";
                }, a.prototype.anErrorOccuredWhenGeneratingTheExpressionD = function() {
                  return "Адбылася памылка падчас генерацыі апісання выразы. Праверце сінтаксіс крон-выразы.";
                }, a.prototype.atSpace = function() {
                  return "У ";
                }, a.prototype.everyMinuteBetweenX0AndX1 = function() {
                  return "Кожную хвіліну з %s да %s";
                }, a.prototype.at = function() {
                  return "У";
                }, a.prototype.spaceAnd = function() {
                  return " і";
                }, a.prototype.everySecond = function() {
                  return "кожную секунду";
                }, a.prototype.everyX0Seconds = function() {
                  return "кожныя %s секунд";
                }, a.prototype.secondsX0ThroughX1PastTheMinute = function() {
                  return "секунды з %s па %s";
                }, a.prototype.atX0SecondsPastTheMinute = function() {
                  return "у %s секунд";
                }, a.prototype.everyX0Minutes = function() {
                  return "кожныя %s хвілін";
                }, a.prototype.minutesX0ThroughX1PastTheHour = function() {
                  return "хвіліны з %s па %s";
                }, a.prototype.atX0MinutesPastTheHour = function() {
                  return "у %s хвілін";
                }, a.prototype.everyX0Hours = function() {
                  return "кожныя %s гадзін";
                }, a.prototype.betweenX0AndX1 = function() {
                  return "з %s па %s";
                }, a.prototype.atX0 = function() {
                  return "у %s";
                }, a.prototype.commaEveryDay = function() {
                  return ", кожны дзень";
                }, a.prototype.commaEveryX0DaysOfTheWeek = function() {
                  return ", кожныя %s дзён тыдня";
                }, a.prototype.commaX0ThroughX1 = function() {
                  return ", %s па %s";
                }, a.prototype.commaAndX0ThroughX1 = function() {
                  return ", і %s па %s";
                }, a.prototype.first = function() {
                  return "першы";
                }, a.prototype.second = function() {
                  return "другі";
                }, a.prototype.third = function() {
                  return "трэці";
                }, a.prototype.fourth = function() {
                  return "чацвёрты";
                }, a.prototype.fifth = function() {
                  return "пяты";
                }, a.prototype.commaOnThe = function() {
                  return ", у ";
                }, a.prototype.spaceX0OfTheMonth = function() {
                  return " %s месяца";
                }, a.prototype.lastDay = function() {
                  return "апошні дзень";
                }, a.prototype.commaOnTheLastX0OfTheMonth = function() {
                  return ", у апошні %s месяца";
                }, a.prototype.commaOnlyOnX0 = function() {
                  return ", толькі ў %s";
                }, a.prototype.commaAndOnX0 = function() {
                  return ", і ў %s";
                }, a.prototype.commaEveryX0Months = function() {
                  return ", кожныя %s месяцаў";
                }, a.prototype.commaOnlyInX0 = function() {
                  return ", толькі ў %s";
                }, a.prototype.commaOnTheLastDayOfTheMonth = function() {
                  return ", у апошні дзень месяца";
                }, a.prototype.commaOnTheLastWeekdayOfTheMonth = function() {
                  return ", у апошні будні дзень месяца";
                }, a.prototype.commaDaysBeforeTheLastDayOfTheMonth = function() {
                  return ", %s дзён да апошняга дня месяца";
                }, a.prototype.firstWeekday = function() {
                  return "першы будны дзень";
                }, a.prototype.weekdayNearestDayX0 = function() {
                  return "найбліжэйшы будны дзень да %s";
                }, a.prototype.commaOnTheX0OfTheMonth = function() {
                  return ", у %s месяцы";
                }, a.prototype.commaEveryX0Days = function() {
                  return ", кожныя %s дзён";
                }, a.prototype.commaBetweenDayX0AndX1OfTheMonth = function() {
                  return ", з %s па %s лік месяца";
                }, a.prototype.commaOnDayX0OfTheMonth = function() {
                  return ", у %s лік месяца";
                }, a.prototype.commaEveryX0Years = function() {
                  return ", кожныя %s гадоў";
                }, a.prototype.commaStartingX0 = function() {
                  return ", пачатак %s";
                }, a.prototype.daysOfTheWeek = function() {
                  return ["нядзеля", "панядзелак", "аўторак", "серада", "чацвер", "пятніца", "субота"];
                }, a.prototype.monthsOfTheYear = function() {
                  return [
                    "студзень",
                    "люты",
                    "сакавік",
                    "красавік",
                    "травень",
                    "чэрвень",
                    "ліпень",
                    "жнівень",
                    "верасень",
                    "кастрычнік",
                    "лістапад",
                    "снежань"
                  ];
                }, a;
              }();
              u.be = l;
            }
          ),
          /***/
          622: (
            /***/
            (i, u) => {
              Object.defineProperty(u, "__esModule", { value: !0 }), u.bg = void 0;
              var l = function(d, h) {
                var m = d != null ? Number(d) : 0;
                return m < 2 ? h[0] : h[1];
              }, a = function(d, h) {
                var m = d != null ? Number(d) : 0;
                return h[[1, 0, 0, 1, 0, 0, 1][m]];
              }, c = function(d, h) {
                var m = d != null ? Number(d) : 1;
                m = Math.max(Math.min(m < 10 || m > 20 && m % 10 !== 0 ? m % 10 : 3, 3), 1) - 1;
                var g = ["м", "ж", "ср"].indexOf(h);
                return ["в", "р", "т"][m] + ["и", "а", "о"][g];
              }, p = function() {
                function d() {
                }
                return d.prototype.atX0SecondsPastTheMinuteGt20 = function() {
                  return null;
                }, d.prototype.atX0MinutesPastTheHourGt20 = function() {
                  return null;
                }, d.prototype.commaMonthX0ThroughMonthX1 = function() {
                  return null;
                }, d.prototype.commaYearX0ThroughYearX1 = function() {
                  return null;
                }, d.prototype.use24HourTimeFormatByDefault = function() {
                  return !0;
                }, d.prototype.everyMinute = function() {
                  return "всяка минута";
                }, d.prototype.everyHour = function() {
                  return "всеки час";
                }, d.prototype.anErrorOccuredWhenGeneratingTheExpressionD = function() {
                  return "Възникна грешка при генериране на описанието на израза. Проверете синтаксиса на cron израза.";
                }, d.prototype.atSpace = function() {
                  return "В ";
                }, d.prototype.everyMinuteBetweenX0AndX1 = function() {
                  return "Всяка минута от %s до %s";
                }, d.prototype.at = function() {
                  return "В";
                }, d.prototype.spaceAnd = function() {
                  return " и";
                }, d.prototype.everySecond = function() {
                  return "всяка секунда";
                }, d.prototype.everyX0Seconds = function(h) {
                  return "всеки %s секунди";
                }, d.prototype.secondsX0ThroughX1PastTheMinute = function() {
                  return "секунди от %s до %s";
                }, d.prototype.atX0SecondsPastTheMinute = function(h) {
                  return "%s-".concat(c(h, "ж"), " секунда");
                }, d.prototype.everyX0Minutes = function(h) {
                  return "всеки %s минути";
                }, d.prototype.minutesX0ThroughX1PastTheHour = function() {
                  return "минути от %s до %s";
                }, d.prototype.atX0MinutesPastTheHour = function(h) {
                  return "%s-".concat(c(h, "ж"), " минутa");
                }, d.prototype.everyX0Hours = function(h) {
                  return "всеки %s часа";
                }, d.prototype.betweenX0AndX1 = function() {
                  return "от %s до %s";
                }, d.prototype.atX0 = function() {
                  return "в %s";
                }, d.prototype.commaEveryDay = function() {
                  return ", всеки ден";
                }, d.prototype.commaEveryX0DaysOfTheWeek = function(h) {
                  return l(h, [", всеки %s ден от седмицата", ", всеки %s дена от седмицата"]);
                }, d.prototype.commaX0ThroughX1 = function(h) {
                  return ", от %s до %s";
                }, d.prototype.commaAndX0ThroughX1 = function(h) {
                  return " и от %s до %s";
                }, d.prototype.first = function(h) {
                  return a(h, ["первият", "первата"]);
                }, d.prototype.second = function(h) {
                  return a(h, ["вторият", "втората"]);
                }, d.prototype.third = function(h) {
                  return a(h, ["третият", "третата"]);
                }, d.prototype.fourth = function(h) {
                  return a(h, ["четвертият", "четвертата"]);
                }, d.prototype.fifth = function(h) {
                  return a(h, ["петият", "петата"]);
                }, d.prototype.commaOnThe = function(h) {
                  return ", ";
                }, d.prototype.spaceX0OfTheMonth = function() {
                  return " %s на месеца";
                }, d.prototype.lastDay = function() {
                  return "последният ден";
                }, d.prototype.commaOnTheLastX0OfTheMonth = function(h) {
                  return a(h, [", в последният %s от месеца", ", в последната %s отмесеца"]);
                }, d.prototype.commaOnlyOnX0 = function(h) {
                  return ", %s";
                }, d.prototype.commaAndOnX0 = function() {
                  return " и %s";
                }, d.prototype.commaEveryX0Months = function(h) {
                  return " всеки %s месеца";
                }, d.prototype.commaOnlyInMonthX0 = function() {
                  return ", %s";
                }, d.prototype.commaOnlyInX0 = function() {
                  return ", в %s";
                }, d.prototype.commaOnTheLastDayOfTheMonth = function() {
                  return ", в последният ден на месеца";
                }, d.prototype.commaOnTheLastWeekdayOfTheMonth = function() {
                  return ", в последния делничен ден от месеца";
                }, d.prototype.commaDaysBeforeTheLastDayOfTheMonth = function(h) {
                  return l(h, [", %s ден преди края на месеца", ", %s дена преди края на месеца"]);
                }, d.prototype.firstWeekday = function() {
                  return "първият делничен ден";
                }, d.prototype.weekdayNearestDayX0 = function() {
                  return "най-близкият делничен ден до %s число";
                }, d.prototype.commaOnTheX0OfTheMonth = function() {
                  return ", на %s число от месеца";
                }, d.prototype.commaEveryX0Days = function(h) {
                  return l(h, [", всеки %s ден", ", всеки %s дена"]);
                }, d.prototype.commaBetweenDayX0AndX1OfTheMonth = function(h) {
                  var m, g = (m = h?.split("-")) !== null && m !== void 0 ? m : [];
                  return ", от %s-".concat(c(g[0], "ср"), " до %s-").concat(c(g[1], "ср"), " число на месеца");
                }, d.prototype.commaOnDayX0OfTheMonth = function(h) {
                  return ", на %s-".concat(c(h, "ср"), " число от месеца");
                }, d.prototype.commaEveryX0Years = function(h) {
                  return l(h, [", всяка %s година", ", всеки %s години"]);
                }, d.prototype.commaStartingX0 = function() {
                  return ", започвайки %s";
                }, d.prototype.daysOfTheWeek = function() {
                  return ["неделя", "понеделник", "вторник", "сряда", "четвъртък", "петък", "събота"];
                }, d.prototype.monthsOfTheYear = function() {
                  return ["януари", "февруари", "март", "април", "май", "юни", "юли", "август", "септевмври", "октомври", "ноември", "декември"];
                }, d;
              }();
              u.bg = p;
            }
          ),
          /***/
          845: (
            /***/
            (i, u) => {
              Object.defineProperty(u, "__esModule", { value: !0 }), u.ca = void 0;
              var l = function() {
                function a() {
                }
                return a.prototype.atX0SecondsPastTheMinuteGt20 = function() {
                  return null;
                }, a.prototype.atX0MinutesPastTheHourGt20 = function() {
                  return null;
                }, a.prototype.commaMonthX0ThroughMonthX1 = function() {
                  return null;
                }, a.prototype.commaYearX0ThroughYearX1 = function() {
                  return null;
                }, a.prototype.use24HourTimeFormatByDefault = function() {
                  return !0;
                }, a.prototype.anErrorOccuredWhenGeneratingTheExpressionD = function() {
                  return "S'ha produït un error mentres es generava la descripció de l'expressió. Revisi la sintaxi de la expressió de cron.";
                }, a.prototype.at = function() {
                  return "A les";
                }, a.prototype.atSpace = function() {
                  return "A les ";
                }, a.prototype.atX0 = function() {
                  return "a les %s";
                }, a.prototype.atX0MinutesPastTheHour = function() {
                  return "als %s minuts de l'hora";
                }, a.prototype.atX0SecondsPastTheMinute = function() {
                  return "als %s segonds del minut";
                }, a.prototype.betweenX0AndX1 = function() {
                  return "entre les %s i les %s";
                }, a.prototype.commaBetweenDayX0AndX1OfTheMonth = function() {
                  return ", entre els dies %s i %s del mes";
                }, a.prototype.commaEveryDay = function() {
                  return ", cada dia";
                }, a.prototype.commaEveryX0Days = function() {
                  return ", cada %s dies";
                }, a.prototype.commaEveryX0DaysOfTheWeek = function() {
                  return ", cada %s dies de la setmana";
                }, a.prototype.commaEveryX0Months = function() {
                  return ", cada %s mesos";
                }, a.prototype.commaOnDayX0OfTheMonth = function() {
                  return ", el dia %s del mes";
                }, a.prototype.commaOnlyInX0 = function() {
                  return ", sólo en %s";
                }, a.prototype.commaOnlyOnX0 = function() {
                  return ", només el %s";
                }, a.prototype.commaAndOnX0 = function() {
                  return ", i el %s";
                }, a.prototype.commaOnThe = function() {
                  return ", en el ";
                }, a.prototype.commaOnTheLastDayOfTheMonth = function() {
                  return ", en l'últim dia del mes";
                }, a.prototype.commaOnTheLastWeekdayOfTheMonth = function() {
                  return ", en l'últim dia de la setmana del mes";
                }, a.prototype.commaDaysBeforeTheLastDayOfTheMonth = function() {
                  return ", %s dies abans de l'últim dia del mes";
                }, a.prototype.commaOnTheLastX0OfTheMonth = function() {
                  return ", en l'últim %s del mes";
                }, a.prototype.commaOnTheX0OfTheMonth = function() {
                  return ", en el %s del mes";
                }, a.prototype.commaX0ThroughX1 = function() {
                  return ", de %s a %s";
                }, a.prototype.commaAndX0ThroughX1 = function() {
                  return ", i de %s a %s";
                }, a.prototype.everyHour = function() {
                  return "cada hora";
                }, a.prototype.everyMinute = function() {
                  return "cada minut";
                }, a.prototype.everyMinuteBetweenX0AndX1 = function() {
                  return "cada minut entre les %s i les %s";
                }, a.prototype.everySecond = function() {
                  return "cada segon";
                }, a.prototype.everyX0Hours = function() {
                  return "cada %s hores";
                }, a.prototype.everyX0Minutes = function() {
                  return "cada %s minuts";
                }, a.prototype.everyX0Seconds = function() {
                  return "cada %s segons";
                }, a.prototype.fifth = function() {
                  return "cinquè";
                }, a.prototype.first = function() {
                  return "primer";
                }, a.prototype.firstWeekday = function() {
                  return "primer dia de la setmana";
                }, a.prototype.fourth = function() {
                  return "quart";
                }, a.prototype.minutesX0ThroughX1PastTheHour = function() {
                  return "del minut %s al %s passada l'hora";
                }, a.prototype.second = function() {
                  return "segon";
                }, a.prototype.secondsX0ThroughX1PastTheMinute = function() {
                  return "En els segons %s al %s de cada minut";
                }, a.prototype.spaceAnd = function() {
                  return " i";
                }, a.prototype.spaceX0OfTheMonth = function() {
                  return " %s del mes";
                }, a.prototype.lastDay = function() {
                  return "l'últim dia";
                }, a.prototype.third = function() {
                  return "tercer";
                }, a.prototype.weekdayNearestDayX0 = function() {
                  return "dia de la setmana més proper al %s";
                }, a.prototype.commaEveryX0Years = function() {
                  return ", cada %s anys";
                }, a.prototype.commaStartingX0 = function() {
                  return ", començant %s";
                }, a.prototype.daysOfTheWeek = function() {
                  return ["diumenge", "dilluns", "dimarts", "dimecres", "dijous", "divendres", "dissabte"];
                }, a.prototype.monthsOfTheYear = function() {
                  return [
                    "gener",
                    "febrer",
                    "març",
                    "abril",
                    "maig",
                    "juny",
                    "juliol",
                    "agost",
                    "setembre",
                    "octubre",
                    "novembre",
                    "desembre"
                  ];
                }, a;
              }();
              u.ca = l;
            }
          ),
          /***/
          651: (
            /***/
            (i, u) => {
              Object.defineProperty(u, "__esModule", { value: !0 }), u.cs = void 0;
              var l = function() {
                function a() {
                }
                return a.prototype.atX0SecondsPastTheMinuteGt20 = function() {
                  return null;
                }, a.prototype.atX0MinutesPastTheHourGt20 = function() {
                  return null;
                }, a.prototype.commaMonthX0ThroughMonthX1 = function() {
                  return null;
                }, a.prototype.commaYearX0ThroughYearX1 = function() {
                  return null;
                }, a.prototype.use24HourTimeFormatByDefault = function() {
                  return !0;
                }, a.prototype.anErrorOccuredWhenGeneratingTheExpressionD = function() {
                  return "Při vytváření popisu došlo k chybě. Zkontrolujte prosím správnost syntaxe cronu.";
                }, a.prototype.everyMinute = function() {
                  return "každou minutu";
                }, a.prototype.everyHour = function() {
                  return "každou hodinu";
                }, a.prototype.atSpace = function() {
                  return "V ";
                }, a.prototype.everyMinuteBetweenX0AndX1 = function() {
                  return "Každou minutu mezi %s a %s";
                }, a.prototype.at = function() {
                  return "V";
                }, a.prototype.spaceAnd = function() {
                  return " a";
                }, a.prototype.everySecond = function() {
                  return "každou sekundu";
                }, a.prototype.everyX0Seconds = function() {
                  return "každých %s sekund";
                }, a.prototype.secondsX0ThroughX1PastTheMinute = function() {
                  return "sekundy od %s do %s";
                }, a.prototype.atX0SecondsPastTheMinute = function() {
                  return "v %s sekund";
                }, a.prototype.everyX0Minutes = function() {
                  return "každých %s minut";
                }, a.prototype.minutesX0ThroughX1PastTheHour = function() {
                  return "minuty od %s do %s";
                }, a.prototype.atX0MinutesPastTheHour = function() {
                  return "v %s minut";
                }, a.prototype.everyX0Hours = function() {
                  return "každých %s hodin";
                }, a.prototype.betweenX0AndX1 = function() {
                  return "mezi %s a %s";
                }, a.prototype.atX0 = function() {
                  return "v %s";
                }, a.prototype.commaEveryDay = function() {
                  return ", každý den";
                }, a.prototype.commaEveryX0DaysOfTheWeek = function() {
                  return ", každých %s dní v týdnu";
                }, a.prototype.commaX0ThroughX1 = function() {
                  return ", od %s do %s";
                }, a.prototype.commaAndX0ThroughX1 = function() {
                  return ", a od %s do %s";
                }, a.prototype.first = function() {
                  return "první";
                }, a.prototype.second = function() {
                  return "druhý";
                }, a.prototype.third = function() {
                  return "třetí";
                }, a.prototype.fourth = function() {
                  return "čtvrtý";
                }, a.prototype.fifth = function() {
                  return "pátý";
                }, a.prototype.commaOnThe = function() {
                  return ", ";
                }, a.prototype.spaceX0OfTheMonth = function() {
                  return " %s v měsíci";
                }, a.prototype.lastDay = function() {
                  return "poslední den";
                }, a.prototype.commaOnTheLastX0OfTheMonth = function() {
                  return ", poslední %s v měsíci";
                }, a.prototype.commaOnlyOnX0 = function() {
                  return ", pouze v %s";
                }, a.prototype.commaAndOnX0 = function() {
                  return ", a v %s";
                }, a.prototype.commaEveryX0Months = function() {
                  return ", každých %s měsíců";
                }, a.prototype.commaOnlyInX0 = function() {
                  return ", pouze v %s";
                }, a.prototype.commaOnTheLastDayOfTheMonth = function() {
                  return ", poslední den v měsíci";
                }, a.prototype.commaOnTheLastWeekdayOfTheMonth = function() {
                  return ", poslední pracovní den v měsíci";
                }, a.prototype.commaDaysBeforeTheLastDayOfTheMonth = function() {
                  return ", %s dní před posledním dnem v měsíci";
                }, a.prototype.firstWeekday = function() {
                  return "první pracovní den";
                }, a.prototype.weekdayNearestDayX0 = function() {
                  return "pracovní den nejblíže %s. dni";
                }, a.prototype.commaOnTheX0OfTheMonth = function() {
                  return ", v %s v měsíci";
                }, a.prototype.commaEveryX0Days = function() {
                  return ", každých %s dnů";
                }, a.prototype.commaBetweenDayX0AndX1OfTheMonth = function() {
                  return ", mezi dny %s a %s v měsíci";
                }, a.prototype.commaOnDayX0OfTheMonth = function() {
                  return ", %s. den v měsíci";
                }, a.prototype.commaEveryX0Years = function() {
                  return ", každých %s roků";
                }, a.prototype.commaStartingX0 = function() {
                  return ", začínající %s";
                }, a.prototype.daysOfTheWeek = function() {
                  return ["Neděle", "Pondělí", "Úterý", "Středa", "Čtvrtek", "Pátek", "Sobota"];
                }, a.prototype.monthsOfTheYear = function() {
                  return [
                    "Leden",
                    "Únor",
                    "Březen",
                    "Duben",
                    "Květen",
                    "Červen",
                    "Červenec",
                    "Srpen",
                    "Září",
                    "Říjen",
                    "Listopad",
                    "Prosinec"
                  ];
                }, a;
              }();
              u.cs = l;
            }
          ),
          /***/
          506: (
            /***/
            (i, u) => {
              Object.defineProperty(u, "__esModule", { value: !0 }), u.da = void 0;
              var l = function() {
                function a() {
                }
                return a.prototype.use24HourTimeFormatByDefault = function() {
                  return !0;
                }, a.prototype.anErrorOccuredWhenGeneratingTheExpressionD = function() {
                  return "Der opstod en fejl ved generering af udtryksbeskrivelsen. Tjek cron-ekspressionssyntaxen.";
                }, a.prototype.at = function() {
                  return "kl";
                }, a.prototype.atSpace = function() {
                  return "kl ";
                }, a.prototype.atX0 = function() {
                  return "kl %s";
                }, a.prototype.atX0MinutesPastTheHour = function() {
                  return "%s minutter efter timeskift";
                }, a.prototype.atX0SecondsPastTheMinute = function() {
                  return "%s sekunder efter minutskift";
                }, a.prototype.betweenX0AndX1 = function() {
                  return "mellem %s og %s";
                }, a.prototype.commaBetweenDayX0AndX1OfTheMonth = function() {
                  return ", mellem dag %s og %s i måneden";
                }, a.prototype.commaEveryDay = function() {
                  return ", hver dag";
                }, a.prototype.commaEveryX0Days = function() {
                  return ", hver %s. dag";
                }, a.prototype.commaEveryX0DaysOfTheWeek = function() {
                  return ", hver %s. ugedag";
                }, a.prototype.commaEveryX0Months = function() {
                  return ", hver %s. måned";
                }, a.prototype.commaEveryX0Years = function() {
                  return ", hvert %s. år";
                }, a.prototype.commaOnDayX0OfTheMonth = function() {
                  return ", på dag %s i måneden";
                }, a.prototype.commaOnlyInX0 = function() {
                  return ", kun i %s";
                }, a.prototype.commaOnlyOnX0 = function(c) {
                  return ", på enhver %s";
                }, a.prototype.commaAndOnX0 = function() {
                  return ", og på %s";
                }, a.prototype.commaOnThe = function() {
                  return ", på den ";
                }, a.prototype.commaOnTheLastDayOfTheMonth = function() {
                  return ", på den sidste dag i måneden";
                }, a.prototype.commaOnTheLastWeekdayOfTheMonth = function() {
                  return ", på den sidste hverdag i måneden";
                }, a.prototype.commaDaysBeforeTheLastDayOfTheMonth = function() {
                  return ", %s dage før den sidste dag i måneden";
                }, a.prototype.commaOnTheLastX0OfTheMonth = function() {
                  return ", på den sidste %s i måneden";
                }, a.prototype.commaOnTheX0OfTheMonth = function() {
                  return ", på den %s i måneden";
                }, a.prototype.commaX0ThroughX1 = function() {
                  return ", %s til og med %s";
                }, a.prototype.commaAndX0ThroughX1 = function() {
                  return ", og %s til og med %s";
                }, a.prototype.everyHour = function() {
                  return "hver time";
                }, a.prototype.everyMinute = function() {
                  return "hvert minut";
                }, a.prototype.everyMinuteBetweenX0AndX1 = function() {
                  return "hvert minut mellem %s og %s";
                }, a.prototype.everySecond = function() {
                  return "hvert sekund";
                }, a.prototype.everyX0Hours = function() {
                  return "hver %s. time";
                }, a.prototype.everyX0Minutes = function() {
                  return "hvert %s. minut";
                }, a.prototype.everyX0Seconds = function() {
                  return "hvert %s. sekund";
                }, a.prototype.fifth = function() {
                  return "femte";
                }, a.prototype.first = function() {
                  return "første";
                }, a.prototype.firstWeekday = function() {
                  return "første hverdag";
                }, a.prototype.fourth = function() {
                  return "fjerde";
                }, a.prototype.minutesX0ThroughX1PastTheHour = function() {
                  return "minutterne fra %s til og med %s hver time";
                }, a.prototype.second = function() {
                  return "anden";
                }, a.prototype.secondsX0ThroughX1PastTheMinute = function() {
                  return "sekunderne fra %s til og med %s hvert minut";
                }, a.prototype.spaceAnd = function() {
                  return " og";
                }, a.prototype.spaceX0OfTheMonth = function() {
                  return " %s i måneden";
                }, a.prototype.lastDay = function() {
                  return "sidste dag";
                }, a.prototype.third = function() {
                  return "tredje";
                }, a.prototype.weekdayNearestDayX0 = function() {
                  return "hverdag nærmest dag %s";
                }, a.prototype.commaMonthX0ThroughMonthX1 = function() {
                  return null;
                }, a.prototype.commaYearX0ThroughYearX1 = function() {
                  return null;
                }, a.prototype.atX0MinutesPastTheHourGt20 = function() {
                  return null;
                }, a.prototype.atX0SecondsPastTheMinuteGt20 = function() {
                  return null;
                }, a.prototype.commaStartingX0 = function() {
                  return ", startende %s";
                }, a.prototype.daysOfTheWeek = function() {
                  return ["søndag", "mandag", "tirsdag", "onsdag", "torsdag", "fredag", "lørdag"];
                }, a.prototype.monthsOfTheYear = function() {
                  return [
                    "januar",
                    "februar",
                    "marts",
                    "april",
                    "maj",
                    "juni",
                    "juli",
                    "august",
                    "september",
                    "oktober",
                    "november",
                    "december"
                  ];
                }, a;
              }();
              u.da = l;
            }
          ),
          /***/
          230: (
            /***/
            (i, u) => {
              Object.defineProperty(u, "__esModule", { value: !0 }), u.de = void 0;
              var l = function() {
                function a() {
                }
                return a.prototype.atX0SecondsPastTheMinuteGt20 = function() {
                  return null;
                }, a.prototype.atX0MinutesPastTheHourGt20 = function() {
                  return null;
                }, a.prototype.commaMonthX0ThroughMonthX1 = function() {
                  return null;
                }, a.prototype.commaYearX0ThroughYearX1 = function() {
                  return null;
                }, a.prototype.use24HourTimeFormatByDefault = function() {
                  return !0;
                }, a.prototype.everyMinute = function() {
                  return "jede Minute";
                }, a.prototype.everyHour = function() {
                  return "jede Stunde";
                }, a.prototype.anErrorOccuredWhenGeneratingTheExpressionD = function() {
                  return "Beim Generieren der Ausdrucksbeschreibung ist ein Fehler aufgetreten. Überprüfen Sie die Syntax des Cron-Ausdrucks.";
                }, a.prototype.atSpace = function() {
                  return "Um ";
                }, a.prototype.everyMinuteBetweenX0AndX1 = function() {
                  return "Jede Minute zwischen %s und %s";
                }, a.prototype.at = function() {
                  return "Um";
                }, a.prototype.spaceAnd = function() {
                  return " und";
                }, a.prototype.everySecond = function() {
                  return "Jede Sekunde";
                }, a.prototype.everyX0Seconds = function() {
                  return "alle %s Sekunden";
                }, a.prototype.secondsX0ThroughX1PastTheMinute = function() {
                  return "Sekunden %s bis %s";
                }, a.prototype.atX0SecondsPastTheMinute = function() {
                  return "bei Sekunde %s";
                }, a.prototype.everyX0Minutes = function() {
                  return "alle %s Minuten";
                }, a.prototype.minutesX0ThroughX1PastTheHour = function() {
                  return "Minuten %s bis %s";
                }, a.prototype.atX0MinutesPastTheHour = function() {
                  return "bei Minute %s";
                }, a.prototype.everyX0Hours = function() {
                  return "alle %s Stunden";
                }, a.prototype.betweenX0AndX1 = function() {
                  return "zwischen %s und %s";
                }, a.prototype.atX0 = function() {
                  return "um %s";
                }, a.prototype.commaEveryDay = function() {
                  return ", jeden Tag";
                }, a.prototype.commaEveryX0DaysOfTheWeek = function() {
                  return ", alle %s Tage der Woche";
                }, a.prototype.commaX0ThroughX1 = function() {
                  return ", %s bis %s";
                }, a.prototype.commaAndX0ThroughX1 = function() {
                  return ", und %s bis %s";
                }, a.prototype.first = function() {
                  return "ersten";
                }, a.prototype.second = function() {
                  return "zweiten";
                }, a.prototype.third = function() {
                  return "dritten";
                }, a.prototype.fourth = function() {
                  return "vierten";
                }, a.prototype.fifth = function() {
                  return "fünften";
                }, a.prototype.commaOnThe = function() {
                  return ", am ";
                }, a.prototype.spaceX0OfTheMonth = function() {
                  return " %s des Monats";
                }, a.prototype.lastDay = function() {
                  return "der letzte Tag";
                }, a.prototype.commaOnTheLastX0OfTheMonth = function() {
                  return ", am letzten %s des Monats";
                }, a.prototype.commaOnlyOnX0 = function() {
                  return ", nur jeden %s";
                }, a.prototype.commaAndOnX0 = function() {
                  return ", und jeden %s";
                }, a.prototype.commaEveryX0Months = function() {
                  return ", alle %s Monate";
                }, a.prototype.commaOnlyInX0 = function() {
                  return ", nur im %s";
                }, a.prototype.commaOnTheLastDayOfTheMonth = function() {
                  return ", am letzten Tag des Monats";
                }, a.prototype.commaOnTheLastWeekdayOfTheMonth = function() {
                  return ", am letzten Werktag des Monats";
                }, a.prototype.commaDaysBeforeTheLastDayOfTheMonth = function() {
                  return ", %s tage vor dem letzten Tag des Monats";
                }, a.prototype.firstWeekday = function() {
                  return "ersten Werktag";
                }, a.prototype.weekdayNearestDayX0 = function() {
                  return "Werktag am nächsten zum %s Tag";
                }, a.prototype.commaOnTheX0OfTheMonth = function() {
                  return ", am %s des Monats";
                }, a.prototype.commaEveryX0Days = function() {
                  return ", alle %s Tage";
                }, a.prototype.commaBetweenDayX0AndX1OfTheMonth = function() {
                  return ", zwischen Tag %s und %s des Monats";
                }, a.prototype.commaOnDayX0OfTheMonth = function() {
                  return ", an Tag %s des Monats";
                }, a.prototype.commaEveryX0Years = function() {
                  return ", alle %s Jahre";
                }, a.prototype.commaStartingX0 = function() {
                  return ", beginnend %s";
                }, a.prototype.daysOfTheWeek = function() {
                  return ["Sonntag", "Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag"];
                }, a.prototype.monthsOfTheYear = function() {
                  return [
                    "Januar",
                    "Februar",
                    "März",
                    "April",
                    "Mai",
                    "Juni",
                    "Juli",
                    "August",
                    "September",
                    "Oktober",
                    "November",
                    "Dezember"
                  ];
                }, a;
              }();
              u.de = l;
            }
          ),
          /***/
          486: (
            /***/
            (i, u) => {
              Object.defineProperty(u, "__esModule", { value: !0 }), u.en = void 0;
              var l = function() {
                function a() {
                }
                return a.prototype.atX0SecondsPastTheMinuteGt20 = function() {
                  return null;
                }, a.prototype.atX0MinutesPastTheHourGt20 = function() {
                  return null;
                }, a.prototype.commaMonthX0ThroughMonthX1 = function() {
                  return null;
                }, a.prototype.commaYearX0ThroughYearX1 = function() {
                  return null;
                }, a.prototype.use24HourTimeFormatByDefault = function() {
                  return !1;
                }, a.prototype.anErrorOccuredWhenGeneratingTheExpressionD = function() {
                  return "An error occurred when generating the expression description. Check the cron expression syntax.";
                }, a.prototype.everyMinute = function() {
                  return "every minute";
                }, a.prototype.everyHour = function() {
                  return "every hour";
                }, a.prototype.atSpace = function() {
                  return "At ";
                }, a.prototype.everyMinuteBetweenX0AndX1 = function() {
                  return "Every minute between %s and %s";
                }, a.prototype.at = function() {
                  return "At";
                }, a.prototype.spaceAnd = function() {
                  return " and";
                }, a.prototype.everySecond = function() {
                  return "every second";
                }, a.prototype.everyX0Seconds = function() {
                  return "every %s seconds";
                }, a.prototype.secondsX0ThroughX1PastTheMinute = function() {
                  return "seconds %s through %s past the minute";
                }, a.prototype.atX0SecondsPastTheMinute = function() {
                  return "at %s seconds past the minute";
                }, a.prototype.everyX0Minutes = function() {
                  return "every %s minutes";
                }, a.prototype.minutesX0ThroughX1PastTheHour = function() {
                  return "minutes %s through %s past the hour";
                }, a.prototype.atX0MinutesPastTheHour = function() {
                  return "at %s minutes past the hour";
                }, a.prototype.everyX0Hours = function() {
                  return "every %s hours";
                }, a.prototype.betweenX0AndX1 = function() {
                  return "between %s and %s";
                }, a.prototype.atX0 = function() {
                  return "at %s";
                }, a.prototype.commaEveryDay = function() {
                  return ", every day";
                }, a.prototype.commaEveryX0DaysOfTheWeek = function() {
                  return ", every %s days of the week";
                }, a.prototype.commaX0ThroughX1 = function() {
                  return ", %s through %s";
                }, a.prototype.commaAndX0ThroughX1 = function() {
                  return ", %s through %s";
                }, a.prototype.first = function() {
                  return "first";
                }, a.prototype.second = function() {
                  return "second";
                }, a.prototype.third = function() {
                  return "third";
                }, a.prototype.fourth = function() {
                  return "fourth";
                }, a.prototype.fifth = function() {
                  return "fifth";
                }, a.prototype.commaOnThe = function() {
                  return ", on the ";
                }, a.prototype.spaceX0OfTheMonth = function() {
                  return " %s of the month";
                }, a.prototype.lastDay = function() {
                  return "the last day";
                }, a.prototype.commaOnTheLastX0OfTheMonth = function() {
                  return ", on the last %s of the month";
                }, a.prototype.commaOnlyOnX0 = function() {
                  return ", only on %s";
                }, a.prototype.commaAndOnX0 = function() {
                  return ", and on %s";
                }, a.prototype.commaEveryX0Months = function() {
                  return ", every %s months";
                }, a.prototype.commaOnlyInX0 = function() {
                  return ", only in %s";
                }, a.prototype.commaOnTheLastDayOfTheMonth = function() {
                  return ", on the last day of the month";
                }, a.prototype.commaOnTheLastWeekdayOfTheMonth = function() {
                  return ", on the last weekday of the month";
                }, a.prototype.commaDaysBeforeTheLastDayOfTheMonth = function() {
                  return ", %s days before the last day of the month";
                }, a.prototype.firstWeekday = function() {
                  return "first weekday";
                }, a.prototype.weekdayNearestDayX0 = function() {
                  return "weekday nearest day %s";
                }, a.prototype.commaOnTheX0OfTheMonth = function() {
                  return ", on the %s of the month";
                }, a.prototype.commaEveryX0Days = function() {
                  return ", every %s days";
                }, a.prototype.commaBetweenDayX0AndX1OfTheMonth = function() {
                  return ", between day %s and %s of the month";
                }, a.prototype.commaOnDayX0OfTheMonth = function() {
                  return ", on day %s of the month";
                }, a.prototype.commaEveryHour = function() {
                  return ", every hour";
                }, a.prototype.commaEveryX0Years = function() {
                  return ", every %s years";
                }, a.prototype.commaStartingX0 = function() {
                  return ", starting %s";
                }, a.prototype.daysOfTheWeek = function() {
                  return ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
                }, a.prototype.monthsOfTheYear = function() {
                  return [
                    "January",
                    "February",
                    "March",
                    "April",
                    "May",
                    "June",
                    "July",
                    "August",
                    "September",
                    "October",
                    "November",
                    "December"
                  ];
                }, a.prototype.atReboot = function() {
                  return "Run once, at startup";
                }, a;
              }();
              u.en = l;
            }
          ),
          /***/
          153: (
            /***/
            (i, u) => {
              Object.defineProperty(u, "__esModule", { value: !0 }), u.es = void 0;
              var l = function() {
                function a() {
                }
                return a.prototype.atX0SecondsPastTheMinuteGt20 = function() {
                  return null;
                }, a.prototype.atX0MinutesPastTheHourGt20 = function() {
                  return null;
                }, a.prototype.commaMonthX0ThroughMonthX1 = function() {
                  return null;
                }, a.prototype.commaYearX0ThroughYearX1 = function() {
                  return null;
                }, a.prototype.use24HourTimeFormatByDefault = function() {
                  return !0;
                }, a.prototype.anErrorOccuredWhenGeneratingTheExpressionD = function() {
                  return "Ocurrió un error mientras se generaba la descripción de la expresión. Revise la sintaxis de la expresión de cron.";
                }, a.prototype.at = function() {
                  return "A las";
                }, a.prototype.atSpace = function() {
                  return "A las ";
                }, a.prototype.atX0 = function() {
                  return "a las %s";
                }, a.prototype.atX0MinutesPastTheHour = function() {
                  return "a los %s minutos de la hora";
                }, a.prototype.atX0SecondsPastTheMinute = function() {
                  return "a los %s segundos del minuto";
                }, a.prototype.betweenX0AndX1 = function() {
                  return "entre las %s y las %s";
                }, a.prototype.commaBetweenDayX0AndX1OfTheMonth = function() {
                  return ", entre los días %s y %s del mes";
                }, a.prototype.commaEveryDay = function() {
                  return ", cada día";
                }, a.prototype.commaEveryX0Days = function() {
                  return ", cada %s días";
                }, a.prototype.commaEveryX0DaysOfTheWeek = function() {
                  return ", cada %s días de la semana";
                }, a.prototype.commaEveryX0Months = function() {
                  return ", cada %s meses";
                }, a.prototype.commaOnDayX0OfTheMonth = function() {
                  return ", el día %s del mes";
                }, a.prototype.commaOnlyInX0 = function() {
                  return ", sólo en %s";
                }, a.prototype.commaOnlyOnX0 = function() {
                  return ", sólo el %s";
                }, a.prototype.commaAndOnX0 = function() {
                  return ", y el %s";
                }, a.prototype.commaOnThe = function() {
                  return ", en el ";
                }, a.prototype.commaOnTheLastDayOfTheMonth = function() {
                  return ", en el último día del mes";
                }, a.prototype.commaOnTheLastWeekdayOfTheMonth = function() {
                  return ", en el último día de la semana del mes";
                }, a.prototype.commaDaysBeforeTheLastDayOfTheMonth = function() {
                  return ", %s días antes del último día del mes";
                }, a.prototype.commaOnTheLastX0OfTheMonth = function() {
                  return ", en el último %s del mes";
                }, a.prototype.commaOnTheX0OfTheMonth = function() {
                  return ", en el %s del mes";
                }, a.prototype.commaX0ThroughX1 = function() {
                  return ", de %s a %s";
                }, a.prototype.commaAndX0ThroughX1 = function() {
                  return ", y de %s a %s";
                }, a.prototype.everyHour = function() {
                  return "cada hora";
                }, a.prototype.everyMinute = function() {
                  return "cada minuto";
                }, a.prototype.everyMinuteBetweenX0AndX1 = function() {
                  return "cada minuto entre las %s y las %s";
                }, a.prototype.everySecond = function() {
                  return "cada segundo";
                }, a.prototype.everyX0Hours = function() {
                  return "cada %s horas";
                }, a.prototype.everyX0Minutes = function() {
                  return "cada %s minutos";
                }, a.prototype.everyX0Seconds = function() {
                  return "cada %s segundos";
                }, a.prototype.fifth = function() {
                  return "quinto";
                }, a.prototype.first = function() {
                  return "primero";
                }, a.prototype.firstWeekday = function() {
                  return "primer día de la semana";
                }, a.prototype.fourth = function() {
                  return "cuarto";
                }, a.prototype.minutesX0ThroughX1PastTheHour = function() {
                  return "del minuto %s al %s pasada la hora";
                }, a.prototype.second = function() {
                  return "segundo";
                }, a.prototype.secondsX0ThroughX1PastTheMinute = function() {
                  return "En los segundos %s al %s de cada minuto";
                }, a.prototype.spaceAnd = function() {
                  return " y";
                }, a.prototype.spaceX0OfTheMonth = function() {
                  return " %s del mes";
                }, a.prototype.lastDay = function() {
                  return "el último día";
                }, a.prototype.third = function() {
                  return "tercer";
                }, a.prototype.weekdayNearestDayX0 = function() {
                  return "día de la semana más próximo al %s";
                }, a.prototype.commaEveryX0Years = function() {
                  return ", cada %s años";
                }, a.prototype.commaStartingX0 = function() {
                  return ", comenzando %s";
                }, a.prototype.daysOfTheWeek = function() {
                  return ["domingo", "lunes", "martes", "miércoles", "jueves", "viernes", "sábado"];
                }, a.prototype.monthsOfTheYear = function() {
                  return [
                    "enero",
                    "febrero",
                    "marzo",
                    "abril",
                    "mayo",
                    "junio",
                    "julio",
                    "agosto",
                    "septiembre",
                    "octubre",
                    "noviembre",
                    "diciembre"
                  ];
                }, a;
              }();
              u.es = l;
            }
          ),
          /***/
          804: (
            /***/
            (i, u) => {
              Object.defineProperty(u, "__esModule", { value: !0 }), u.fa = void 0;
              var l = function() {
                function a() {
                }
                return a.prototype.atX0SecondsPastTheMinuteGt20 = function() {
                  return null;
                }, a.prototype.atX0MinutesPastTheHourGt20 = function() {
                  return null;
                }, a.prototype.commaMonthX0ThroughMonthX1 = function() {
                  return null;
                }, a.prototype.commaYearX0ThroughYearX1 = function() {
                  return null;
                }, a.prototype.use24HourTimeFormatByDefault = function() {
                  return !0;
                }, a.prototype.anErrorOccuredWhenGeneratingTheExpressionD = function() {
                  return "خطایی در نمایش توضیحات این وظیفه رخ داد. لطفا ساختار آن را بررسی کنید.";
                }, a.prototype.everyMinute = function() {
                  return "هر دقیقه";
                }, a.prototype.everyHour = function() {
                  return "هر ساعت";
                }, a.prototype.atSpace = function() {
                  return "در ";
                }, a.prototype.everyMinuteBetweenX0AndX1 = function() {
                  return "هر دقیقه بین %s و %s";
                }, a.prototype.at = function() {
                  return "در";
                }, a.prototype.spaceAnd = function() {
                  return " و";
                }, a.prototype.everySecond = function() {
                  return "هر ثانیه";
                }, a.prototype.everyX0Seconds = function() {
                  return "هر %s ثانیه";
                }, a.prototype.secondsX0ThroughX1PastTheMinute = function() {
                  return "ثانیه %s تا %s دقیقه گذشته";
                }, a.prototype.atX0SecondsPastTheMinute = function() {
                  return "در %s قانیه از دقیقه گذشته";
                }, a.prototype.everyX0Minutes = function() {
                  return "هر %s دقیقه";
                }, a.prototype.minutesX0ThroughX1PastTheHour = function() {
                  return "دقیقه %s تا %s ساعت گذشته";
                }, a.prototype.atX0MinutesPastTheHour = function() {
                  return "در %s دقیقه پس از ساعت";
                }, a.prototype.everyX0Hours = function() {
                  return "هر %s ساعت";
                }, a.prototype.betweenX0AndX1 = function() {
                  return "بین %s و %s";
                }, a.prototype.atX0 = function() {
                  return "در %s";
                }, a.prototype.commaEveryDay = function() {
                  return ", هر روز";
                }, a.prototype.commaEveryX0DaysOfTheWeek = function() {
                  return ", هر %s روز از هفته";
                }, a.prototype.commaX0ThroughX1 = function() {
                  return ", %s تا %s";
                }, a.prototype.commaAndX0ThroughX1 = function() {
                  return ", و %s تا %s";
                }, a.prototype.first = function() {
                  return "اول";
                }, a.prototype.second = function() {
                  return "دوم";
                }, a.prototype.third = function() {
                  return "سوم";
                }, a.prototype.fourth = function() {
                  return "چهارم";
                }, a.prototype.fifth = function() {
                  return "پنجم";
                }, a.prototype.commaOnThe = function() {
                  return ", در ";
                }, a.prototype.spaceX0OfTheMonth = function() {
                  return " %s ماه";
                }, a.prototype.lastDay = function() {
                  return "آخرین روز";
                }, a.prototype.commaOnTheLastX0OfTheMonth = function() {
                  return ", در %s ماه";
                }, a.prototype.commaOnlyOnX0 = function() {
                  return ", فقط در %s";
                }, a.prototype.commaAndOnX0 = function() {
                  return ", و در %s";
                }, a.prototype.commaEveryX0Months = function() {
                  return ", هر %s ماه";
                }, a.prototype.commaOnlyInX0 = function() {
                  return ", فقط در %s";
                }, a.prototype.commaOnTheLastDayOfTheMonth = function() {
                  return ", در آخرین روز ماه";
                }, a.prototype.commaOnTheLastWeekdayOfTheMonth = function() {
                  return ", در آخرین روز ماه";
                }, a.prototype.commaDaysBeforeTheLastDayOfTheMonth = function() {
                  return ", %s روز قبل از آخرین روز ماه";
                }, a.prototype.firstWeekday = function() {
                  return "اولین روز";
                }, a.prototype.weekdayNearestDayX0 = function() {
                  return "روز نزدیک به روز %s";
                }, a.prototype.commaOnTheX0OfTheMonth = function() {
                  return ", در %s ماه";
                }, a.prototype.commaEveryX0Days = function() {
                  return ", هر %s روز";
                }, a.prototype.commaBetweenDayX0AndX1OfTheMonth = function() {
                  return ", بین روز %s و %s ماه";
                }, a.prototype.commaOnDayX0OfTheMonth = function() {
                  return ", در %s ماه";
                }, a.prototype.commaEveryMinute = function() {
                  return ", هر minute";
                }, a.prototype.commaEveryHour = function() {
                  return ", هر ساعت";
                }, a.prototype.commaEveryX0Years = function() {
                  return ", هر %s سال";
                }, a.prototype.commaStartingX0 = function() {
                  return ", آغاز %s";
                }, a.prototype.daysOfTheWeek = function() {
                  return ["یک‌شنبه", "دوشنبه", "سه‌شنبه", "چهارشنبه", "پنج‌شنبه", "جمعه", "شنبه"];
                }, a.prototype.monthsOfTheYear = function() {
                  return ["ژانویه", "فوریه", "مارس", "آپریل", "مه", "ژوئن", "ژوئیه", "آگوست", "سپتامبر", "اکتبر", "نوامبر", "دسامبر"];
                }, a;
              }();
              u.fa = l;
            }
          ),
          /***/
          964: (
            /***/
            (i, u) => {
              Object.defineProperty(u, "__esModule", { value: !0 }), u.fi = void 0;
              var l = function() {
                function a() {
                }
                return a.prototype.use24HourTimeFormatByDefault = function() {
                  return !0;
                }, a.prototype.anErrorOccuredWhenGeneratingTheExpressionD = function() {
                  return "Virhe kuvauksen generoinnissa. Tarkista cron-syntaksi.";
                }, a.prototype.at = function() {
                  return "Klo";
                }, a.prototype.atSpace = function() {
                  return "Klo ";
                }, a.prototype.atX0 = function() {
                  return "klo %s";
                }, a.prototype.atX0MinutesPastTheHour = function() {
                  return "%s minuuttia yli";
                }, a.prototype.atX0MinutesPastTheHourGt20 = function() {
                  return "%s minuuttia yli";
                }, a.prototype.atX0SecondsPastTheMinute = function() {
                  return "%s sekunnnin jälkeen";
                }, a.prototype.betweenX0AndX1 = function() {
                  return "%s - %s välillä";
                }, a.prototype.commaBetweenDayX0AndX1OfTheMonth = function() {
                  return ", kuukauden päivien %s ja %s välillä";
                }, a.prototype.commaEveryDay = function() {
                  return ", joka päivä";
                }, a.prototype.commaEveryHour = function() {
                  return ", joka tunti";
                }, a.prototype.commaEveryMinute = function() {
                  return ", joka minuutti";
                }, a.prototype.commaEveryX0Days = function() {
                  return ", joka %s. päivä";
                }, a.prototype.commaEveryX0DaysOfTheWeek = function() {
                  return ", joka %s. viikonpäivä";
                }, a.prototype.commaEveryX0Months = function() {
                  return ", joka %s. kuukausi";
                }, a.prototype.commaEveryX0Years = function() {
                  return ", joka %s. vuosi";
                }, a.prototype.commaOnDayX0OfTheMonth = function() {
                  return ", kuukauden %s päivä";
                }, a.prototype.commaOnlyInX0 = function() {
                  return ", vain %s";
                }, a.prototype.commaOnlyOnX0 = function() {
                  return ", vain %s";
                }, a.prototype.commaOnThe = function() {
                  return ",";
                }, a.prototype.commaOnTheLastDayOfTheMonth = function() {
                  return ", kuukauden viimeisenä päivänä";
                }, a.prototype.commaOnTheLastWeekdayOfTheMonth = function() {
                  return ", kuukauden viimeisenä viikonpäivänä";
                }, a.prototype.commaOnTheLastX0OfTheMonth = function() {
                  return ", kuukauden viimeinen %s";
                }, a.prototype.commaOnTheX0OfTheMonth = function() {
                  return ", kuukauden %s";
                }, a.prototype.commaX0ThroughX1 = function() {
                  return ", %s - %s";
                }, a.prototype.commaAndX0ThroughX1 = function() {
                  return ", %s - %s";
                }, a.prototype.commaDaysBeforeTheLastDayOfTheMonth = function() {
                  return ", %s päivää ennen kuukauden viimeistä päivää";
                }, a.prototype.commaStartingX0 = function() {
                  return ", alkaen %s";
                }, a.prototype.everyHour = function() {
                  return "joka tunti";
                }, a.prototype.everyMinute = function() {
                  return "joka minuutti";
                }, a.prototype.everyMinuteBetweenX0AndX1 = function() {
                  return "joka minuutti %s - %s välillä";
                }, a.prototype.everySecond = function() {
                  return "joka sekunti";
                }, a.prototype.everyX0Hours = function() {
                  return "joka %s. tunti";
                }, a.prototype.everyX0Minutes = function() {
                  return "joka %s. minuutti";
                }, a.prototype.everyX0Seconds = function() {
                  return "joka %s. sekunti";
                }, a.prototype.fifth = function() {
                  return "viides";
                }, a.prototype.first = function() {
                  return "ensimmäinen";
                }, a.prototype.firstWeekday = function() {
                  return "ensimmäinen viikonpäivä";
                }, a.prototype.fourth = function() {
                  return "neljäs";
                }, a.prototype.minutesX0ThroughX1PastTheHour = function() {
                  return "joka tunti minuuttien %s - %s välillä";
                }, a.prototype.second = function() {
                  return "toinen";
                }, a.prototype.secondsX0ThroughX1PastTheMinute = function() {
                  return "joka minuutti sekunttien %s - %s välillä";
                }, a.prototype.spaceAnd = function() {
                  return " ja";
                }, a.prototype.spaceAndSpace = function() {
                  return " ja ";
                }, a.prototype.spaceX0OfTheMonth = function() {
                  return " %s kuukaudessa";
                }, a.prototype.third = function() {
                  return "kolmas";
                }, a.prototype.weekdayNearestDayX0 = function() {
                  return "viikonpäivä lähintä %s päivää";
                }, a.prototype.atX0SecondsPastTheMinuteGt20 = function() {
                  return null;
                }, a.prototype.commaMonthX0ThroughMonthX1 = function() {
                  return null;
                }, a.prototype.commaYearX0ThroughYearX1 = function() {
                  return null;
                }, a.prototype.lastDay = function() {
                  return "viimeinen päivä";
                }, a.prototype.commaAndOnX0 = function() {
                  return ", ja edelleen %s";
                }, a.prototype.daysOfTheWeek = function() {
                  return ["sunnuntai", "maanantai", "tiistai", "keskiviikko", "torstai", "perjantai", "lauantai"];
                }, a.prototype.monthsOfTheYear = function() {
                  return [
                    "tammikuu",
                    "helmikuu",
                    "maaliskuu",
                    "huhtikuu",
                    "toukokuu",
                    "kesäkuu",
                    "heinäkuu",
                    "elokuu",
                    "syyskuu",
                    "lokakuu",
                    "marraskuu",
                    "joulukuu"
                  ];
                }, a;
              }();
              u.fi = l;
            }
          ),
          /***/
          517: (
            /***/
            (i, u) => {
              Object.defineProperty(u, "__esModule", { value: !0 }), u.fr = void 0;
              var l = function() {
                function a() {
                }
                return a.prototype.conciseVerbosityReplacements = function() {
                  return {
                    "de le": "du"
                  };
                }, a.prototype.atX0SecondsPastTheMinuteGt20 = function() {
                  return null;
                }, a.prototype.atX0MinutesPastTheHourGt20 = function() {
                  return null;
                }, a.prototype.commaMonthX0ThroughMonthX1 = function() {
                  return null;
                }, a.prototype.commaYearX0ThroughYearX1 = function() {
                  return null;
                }, a.prototype.use24HourTimeFormatByDefault = function() {
                  return !0;
                }, a.prototype.anErrorOccuredWhenGeneratingTheExpressionD = function() {
                  return "Une erreur est survenue en générant la description de l'expression cron. Vérifiez sa syntaxe.";
                }, a.prototype.everyMinute = function() {
                  return "toutes les minutes";
                }, a.prototype.everyHour = function() {
                  return "toutes les heures";
                }, a.prototype.atSpace = function() {
                  return "À ";
                }, a.prototype.everyMinuteBetweenX0AndX1 = function() {
                  return "Toutes les minutes entre %s et %s";
                }, a.prototype.at = function() {
                  return "À";
                }, a.prototype.spaceAnd = function() {
                  return " et";
                }, a.prototype.everySecond = function() {
                  return "toutes les secondes";
                }, a.prototype.everyX0Seconds = function() {
                  return "toutes les %s secondes";
                }, a.prototype.secondsX0ThroughX1PastTheMinute = function() {
                  return "les secondes entre %s et %s après la minute";
                }, a.prototype.atX0SecondsPastTheMinute = function() {
                  return "%s secondes après la minute";
                }, a.prototype.everyX0Minutes = function() {
                  return "toutes les %s minutes";
                }, a.prototype.minutesX0ThroughX1PastTheHour = function() {
                  return "les minutes entre %s et %s après l'heure";
                }, a.prototype.atX0MinutesPastTheHour = function() {
                  return "%s minutes après l'heure";
                }, a.prototype.everyX0Hours = function() {
                  return "toutes les %s heures";
                }, a.prototype.betweenX0AndX1 = function() {
                  return "de %s à %s";
                }, a.prototype.atX0 = function() {
                  return "%s";
                }, a.prototype.commaEveryDay = function() {
                  return ", tous les jours";
                }, a.prototype.commaEveryX0DaysOfTheWeek = function() {
                  return ", tous les %s jours de la semaine";
                }, a.prototype.commaX0ThroughX1 = function() {
                  return ", de %s à %s";
                }, a.prototype.commaAndX0ThroughX1 = function() {
                  return ", et de %s à %s";
                }, a.prototype.first = function() {
                  return "premier";
                }, a.prototype.second = function() {
                  return "second";
                }, a.prototype.third = function() {
                  return "troisième";
                }, a.prototype.fourth = function() {
                  return "quatrième";
                }, a.prototype.fifth = function() {
                  return "cinquième";
                }, a.prototype.commaOnThe = function() {
                  return ", le ";
                }, a.prototype.spaceX0OfTheMonth = function() {
                  return " %s du mois";
                }, a.prototype.lastDay = function() {
                  return "le dernier jour";
                }, a.prototype.commaOnTheLastX0OfTheMonth = function() {
                  return ", le dernier %s du mois";
                }, a.prototype.commaOnlyOnX0 = function() {
                  return ", uniquement le %s";
                }, a.prototype.commaAndOnX0 = function() {
                  return ", et %s";
                }, a.prototype.commaEveryX0Months = function() {
                  return ", tous les %s mois";
                }, a.prototype.commaOnlyInX0 = function() {
                  return ", uniquement en %s";
                }, a.prototype.commaOnTheLastDayOfTheMonth = function() {
                  return ", le dernier jour du mois";
                }, a.prototype.commaOnTheLastWeekdayOfTheMonth = function() {
                  return ", le dernier jour ouvrable du mois";
                }, a.prototype.commaDaysBeforeTheLastDayOfTheMonth = function() {
                  return ", %s jours avant le dernier jour du mois";
                }, a.prototype.firstWeekday = function() {
                  return "premier jour ouvrable";
                }, a.prototype.weekdayNearestDayX0 = function() {
                  return "jour ouvrable le plus proche du %s";
                }, a.prototype.commaOnTheX0OfTheMonth = function() {
                  return ", le %s du mois";
                }, a.prototype.commaEveryX0Days = function() {
                  return ", tous les %s jours";
                }, a.prototype.commaBetweenDayX0AndX1OfTheMonth = function() {
                  return ", du %s au %s du mois";
                }, a.prototype.commaOnDayX0OfTheMonth = function() {
                  return ", le %s du mois";
                }, a.prototype.commaEveryHour = function() {
                  return ", chaque heure";
                }, a.prototype.commaEveryX0Years = function() {
                  return ", tous les %s ans";
                }, a.prototype.commaDaysX0ThroughX1 = function() {
                  return ", du %s au %s";
                }, a.prototype.commaStartingX0 = function() {
                  return ", à partir de %s";
                }, a.prototype.daysOfTheWeek = function() {
                  return ["dimanche", "lundi", "mardi", "mercredi", "jeudi", "vendredi", "samedi"];
                }, a.prototype.monthsOfTheYear = function() {
                  return [
                    "janvier",
                    "février",
                    "mars",
                    "avril",
                    "mai",
                    "juin",
                    "juillet",
                    "août",
                    "septembre",
                    "octobre",
                    "novembre",
                    "décembre"
                  ];
                }, a;
              }();
              u.fr = l;
            }
          ),
          /***/
          82: (
            /***/
            (i, u) => {
              Object.defineProperty(u, "__esModule", { value: !0 }), u.he = void 0;
              var l = function() {
                function a() {
                }
                return a.prototype.atX0SecondsPastTheMinuteGt20 = function() {
                  return null;
                }, a.prototype.atX0MinutesPastTheHourGt20 = function() {
                  return null;
                }, a.prototype.commaMonthX0ThroughMonthX1 = function() {
                  return null;
                }, a.prototype.commaYearX0ThroughYearX1 = function() {
                  return null;
                }, a.prototype.use24HourTimeFormatByDefault = function() {
                  return !0;
                }, a.prototype.anErrorOccuredWhenGeneratingTheExpressionD = function() {
                  return "אירעה שגיאה בעת יצירת תיאור הביטוי. בדוק את תחביר הביטוי cron.";
                }, a.prototype.everyMinute = function() {
                  return "כל דקה";
                }, a.prototype.everyHour = function() {
                  return "כל שעה";
                }, a.prototype.atSpace = function() {
                  return "ב ";
                }, a.prototype.everyMinuteBetweenX0AndX1 = function() {
                  return "כל דקה %s עד %s";
                }, a.prototype.at = function() {
                  return "ב";
                }, a.prototype.spaceAnd = function() {
                  return " ו";
                }, a.prototype.everySecond = function() {
                  return "כל שניה";
                }, a.prototype.everyX0Seconds = function() {
                  return "כל %s שניות";
                }, a.prototype.secondsX0ThroughX1PastTheMinute = function() {
                  return "%s עד %s שניות של הדקה";
                }, a.prototype.atX0SecondsPastTheMinute = function() {
                  return "ב %s שניות של הדקה";
                }, a.prototype.everyX0Minutes = function() {
                  return "כל %s דקות";
                }, a.prototype.minutesX0ThroughX1PastTheHour = function() {
                  return "%s עד %s דקות של השעה";
                }, a.prototype.atX0MinutesPastTheHour = function() {
                  return "ב %s דקות של השעה";
                }, a.prototype.everyX0Hours = function() {
                  return "כל %s שעות";
                }, a.prototype.betweenX0AndX1 = function() {
                  return "%s עד %s";
                }, a.prototype.atX0 = function() {
                  return "ב %s";
                }, a.prototype.commaEveryDay = function() {
                  return ", כל יום";
                }, a.prototype.commaEveryX0DaysOfTheWeek = function() {
                  return ", כל %s ימים בשבוע";
                }, a.prototype.commaX0ThroughX1 = function() {
                  return ", %s עד %s";
                }, a.prototype.commaAndX0ThroughX1 = function() {
                  return ", ו %s עד %s";
                }, a.prototype.first = function() {
                  return "ראשון";
                }, a.prototype.second = function() {
                  return "שני";
                }, a.prototype.third = function() {
                  return "שלישי";
                }, a.prototype.fourth = function() {
                  return "רביעי";
                }, a.prototype.fifth = function() {
                  return "חמישי";
                }, a.prototype.commaOnThe = function() {
                  return ", ב ";
                }, a.prototype.spaceX0OfTheMonth = function() {
                  return " %s של החודש";
                }, a.prototype.lastDay = function() {
                  return "היום האחרון";
                }, a.prototype.commaOnTheLastX0OfTheMonth = function() {
                  return ", רק ב %s של החודש";
                }, a.prototype.commaOnlyOnX0 = function() {
                  return ", רק ב %s";
                }, a.prototype.commaAndOnX0 = function() {
                  return ", וב %s";
                }, a.prototype.commaEveryX0Months = function() {
                  return ", כל %s חודשים";
                }, a.prototype.commaOnlyInX0 = function() {
                  return ", רק ב %s";
                }, a.prototype.commaOnTheLastDayOfTheMonth = function() {
                  return ", ביום האחרון של החודש";
                }, a.prototype.commaOnTheLastWeekdayOfTheMonth = function() {
                  return ", ביום החול האחרון של החודש";
                }, a.prototype.commaDaysBeforeTheLastDayOfTheMonth = function() {
                  return ", %s ימים לפני היום האחרון בחודש";
                }, a.prototype.firstWeekday = function() {
                  return "יום החול הראשון";
                }, a.prototype.weekdayNearestDayX0 = function() {
                  return "יום החול הראשון הקרוב אל %s";
                }, a.prototype.commaOnTheX0OfTheMonth = function() {
                  return ", ביום ה%s של החודש";
                }, a.prototype.commaEveryX0Days = function() {
                  return ", כל %s ימים";
                }, a.prototype.commaBetweenDayX0AndX1OfTheMonth = function() {
                  return ", בין היום ה%s וה%s של החודש";
                }, a.prototype.commaOnDayX0OfTheMonth = function() {
                  return ", ביום ה%s של החודש";
                }, a.prototype.commaEveryX0Years = function() {
                  return ", כל %s שנים";
                }, a.prototype.commaStartingX0 = function() {
                  return ", החל מ %s";
                }, a.prototype.daysOfTheWeek = function() {
                  return ["יום ראשון", "יום שני", "יום שלישי", "יום רביעי", "יום חמישי", "יום שישי", "יום שבת"];
                }, a.prototype.monthsOfTheYear = function() {
                  return ["ינואר", "פברואר", "מרץ", "אפריל", "מאי", "יוני", "יולי", "אוגוסט", "ספטמבר", "אוקטובר", "נובמבר", "דצמבר"];
                }, a;
              }();
              u.he = l;
            }
          ),
          /***/
          131: (
            /***/
            (i, u) => {
              Object.defineProperty(u, "__esModule", { value: !0 }), u.hr = void 0;
              var l = function() {
                function a() {
                }
                return a.prototype.use24HourTimeFormatByDefault = function() {
                  return !0;
                }, a.prototype.anErrorOccuredWhenGeneratingTheExpressionD = function() {
                  return "Došlo je do pogreške pri generiranju izraza. Provjerite sintaksu cron izraza.";
                }, a.prototype.at = function() {
                  return "U";
                }, a.prototype.atSpace = function() {
                  return "U ";
                }, a.prototype.atX0 = function() {
                  return "u %s";
                }, a.prototype.atX0MinutesPastTheHour = function() {
                  return "u %s minuta nakon punog sata";
                }, a.prototype.atX0SecondsPastTheMinute = function() {
                  return "u %s sekundi nakon pune minute";
                }, a.prototype.betweenX0AndX1 = function() {
                  return "između %s i %s";
                }, a.prototype.commaBetweenDayX0AndX1OfTheMonth = function() {
                  return ", između %s. i %s. dana u mjesecu";
                }, a.prototype.commaEveryDay = function() {
                  return ", svaki dan";
                }, a.prototype.commaEveryX0Days = function() {
                  return ", svakih %s dana";
                }, a.prototype.commaEveryX0DaysOfTheWeek = function() {
                  return ", svakih %s dana u tjednu";
                }, a.prototype.commaEveryX0Months = function() {
                  return ", svakih %s mjeseci";
                }, a.prototype.commaEveryX0Years = function() {
                  return ", svakih %s godina";
                }, a.prototype.commaOnDayX0OfTheMonth = function() {
                  return ", %s. dan u mjesecu";
                }, a.prototype.commaOnlyInX0 = function() {
                  return ", samo u %s";
                }, a.prototype.commaOnlyOnX0 = function() {
                  return ", samo %s";
                }, a.prototype.commaAndOnX0 = function() {
                  return ", i %s";
                }, a.prototype.commaOnThe = function() {
                  return ", ";
                }, a.prototype.commaOnTheLastDayOfTheMonth = function() {
                  return ", zadnji dan u mjesecu";
                }, a.prototype.commaOnTheLastWeekdayOfTheMonth = function() {
                  return ", zadnji radni dan u mjesecu";
                }, a.prototype.commaDaysBeforeTheLastDayOfTheMonth = function() {
                  return ", %s dana prije kraja mjeseca";
                }, a.prototype.commaOnTheLastX0OfTheMonth = function() {
                  return ", zadnji %s u mjesecu";
                }, a.prototype.commaOnTheX0OfTheMonth = function() {
                  return ", %s u mjesecu";
                }, a.prototype.commaX0ThroughX1 = function() {
                  return ", od %s do %s";
                }, a.prototype.commaAndX0ThroughX1 = function() {
                  return ", i od %s do %s";
                }, a.prototype.everyHour = function() {
                  return "svaki sat";
                }, a.prototype.everyMinute = function() {
                  return "svaku minutu";
                }, a.prototype.everyMinuteBetweenX0AndX1 = function() {
                  return "Svaku minutu između %s i %s";
                }, a.prototype.everySecond = function() {
                  return "svaku sekundu";
                }, a.prototype.everyX0Hours = function() {
                  return "svakih %s sati";
                }, a.prototype.everyX0Minutes = function() {
                  return "svakih %s minuta";
                }, a.prototype.everyX0Seconds = function() {
                  return "svakih %s sekundi";
                }, a.prototype.fifth = function() {
                  return "peti";
                }, a.prototype.first = function() {
                  return "prvi";
                }, a.prototype.firstWeekday = function() {
                  return "prvi radni dan";
                }, a.prototype.fourth = function() {
                  return "četvrti";
                }, a.prototype.minutesX0ThroughX1PastTheHour = function() {
                  return "minute od %s do %s nakon punog sata";
                }, a.prototype.second = function() {
                  return "drugi";
                }, a.prototype.secondsX0ThroughX1PastTheMinute = function() {
                  return "sekunde od %s do %s nakon pune minute";
                }, a.prototype.spaceAnd = function() {
                  return " i";
                }, a.prototype.spaceX0OfTheMonth = function() {
                  return " %s u mjesecu";
                }, a.prototype.lastDay = function() {
                  return "zadnji dan";
                }, a.prototype.third = function() {
                  return "treći";
                }, a.prototype.weekdayNearestDayX0 = function() {
                  return "radni dan najbliži %s. danu";
                }, a.prototype.commaMonthX0ThroughMonthX1 = function() {
                  return null;
                }, a.prototype.commaYearX0ThroughYearX1 = function() {
                  return null;
                }, a.prototype.atX0MinutesPastTheHourGt20 = function() {
                  return null;
                }, a.prototype.atX0SecondsPastTheMinuteGt20 = function() {
                  return null;
                }, a.prototype.commaStartingX0 = function() {
                  return ", počevši od %s";
                }, a.prototype.daysOfTheWeek = function() {
                  return [
                    "Nedjelja",
                    "Ponedjeljak",
                    "Utorak",
                    "Srijeda",
                    "Četvrtak",
                    "Petak",
                    "Subota"
                  ];
                }, a.prototype.monthsOfTheYear = function() {
                  return [
                    "siječanj",
                    "veljača",
                    "ožujak",
                    "travanj",
                    "svibanj",
                    "lipanj",
                    "srpanj",
                    "kolovoz",
                    "rujan",
                    "listopad",
                    "studeni",
                    "prosinac"
                  ];
                }, a;
              }();
              u.hr = l;
            }
          ),
          /***/
          194: (
            /***/
            (i, u) => {
              Object.defineProperty(u, "__esModule", { value: !0 }), u.hu = void 0;
              var l = function() {
                function a() {
                }
                return a.prototype.atX0SecondsPastTheMinuteGt20 = function() {
                  return null;
                }, a.prototype.atX0MinutesPastTheHourGt20 = function() {
                  return null;
                }, a.prototype.commaMonthX0ThroughMonthX1 = function() {
                  return null;
                }, a.prototype.commaYearX0ThroughYearX1 = function() {
                  return null;
                }, a.prototype.use24HourTimeFormatByDefault = function() {
                  return !0;
                }, a.prototype.anErrorOccuredWhenGeneratingTheExpressionD = function() {
                  return "Hiba történt a kifejezésleírás generálásakor. Ellenőrizze a cron kifejezés szintaxisát.";
                }, a.prototype.everyMinute = function() {
                  return "minden percben";
                }, a.prototype.everyHour = function() {
                  return "minden órában";
                }, a.prototype.atSpace = function() {
                  return "Ekkor: ";
                }, a.prototype.everyMinuteBetweenX0AndX1 = function() {
                  return "percenként %s és %s között";
                }, a.prototype.at = function() {
                  return "Ekkor:";
                }, a.prototype.spaceAnd = function() {
                  return " és";
                }, a.prototype.everySecond = function() {
                  return "minden másodpercben";
                }, a.prototype.everyX0Seconds = function() {
                  return "%s másodpercenként";
                }, a.prototype.secondsX0ThroughX1PastTheMinute = function() {
                  return "%s. másodpercben %s perc után";
                }, a.prototype.atX0SecondsPastTheMinute = function() {
                  return "%s. másodpercben";
                }, a.prototype.everyX0Minutes = function() {
                  return "minden %s. percben";
                }, a.prototype.minutesX0ThroughX1PastTheHour = function() {
                  return "%s. percben %s óra után";
                }, a.prototype.atX0MinutesPastTheHour = function() {
                  return "%s. percben";
                }, a.prototype.everyX0Hours = function() {
                  return "minden %s órában";
                }, a.prototype.betweenX0AndX1 = function() {
                  return "%s és %s között";
                }, a.prototype.atX0 = function() {
                  return "ekkor %s";
                }, a.prototype.commaEveryDay = function() {
                  return ", minden nap";
                }, a.prototype.commaEveryX0DaysOfTheWeek = function() {
                  return ", a hét minden %s napján";
                }, a.prototype.commaX0ThroughX1 = function() {
                  return ", %s - %s";
                }, a.prototype.commaAndX0ThroughX1 = function() {
                  return ", és %s - %s";
                }, a.prototype.first = function() {
                  return "első";
                }, a.prototype.second = function() {
                  return "második";
                }, a.prototype.third = function() {
                  return "harmadik";
                }, a.prototype.fourth = function() {
                  return "negyedik";
                }, a.prototype.fifth = function() {
                  return "ötödik";
                }, a.prototype.commaOnThe = function() {
                  return ", ";
                }, a.prototype.spaceX0OfTheMonth = function() {
                  return " %s a hónapban";
                }, a.prototype.lastDay = function() {
                  return "az utolsó nap";
                }, a.prototype.commaOnTheLastX0OfTheMonth = function() {
                  return ", a hónap utolsó %s";
                }, a.prototype.commaOnlyOnX0 = function() {
                  return ", csak ekkor: %s";
                }, a.prototype.commaAndOnX0 = function() {
                  return ", és %s";
                }, a.prototype.commaEveryX0Months = function() {
                  return ", minden %s hónapban";
                }, a.prototype.commaOnlyInX0 = function() {
                  return ", csak ekkor: %s";
                }, a.prototype.commaOnTheLastDayOfTheMonth = function() {
                  return ", a hónap utolsó napján";
                }, a.prototype.commaOnTheLastWeekdayOfTheMonth = function() {
                  return ", a hónap utolsó hétköznapján";
                }, a.prototype.commaDaysBeforeTheLastDayOfTheMonth = function() {
                  return ", %s nappal a hónap utolsó napja előtt";
                }, a.prototype.firstWeekday = function() {
                  return "első hétköznap";
                }, a.prototype.weekdayNearestDayX0 = function() {
                  return "hétköznap legközelebbi nap %s";
                }, a.prototype.commaOnTheX0OfTheMonth = function() {
                  return ", a hónap %s";
                }, a.prototype.commaEveryX0Days = function() {
                  return ", %s naponként";
                }, a.prototype.commaBetweenDayX0AndX1OfTheMonth = function() {
                  return ", a hónap %s és %s napja között";
                }, a.prototype.commaOnDayX0OfTheMonth = function() {
                  return ", a hónap %s napján";
                }, a.prototype.commaEveryHour = function() {
                  return ", minden órában";
                }, a.prototype.commaEveryX0Years = function() {
                  return ", %s évente";
                }, a.prototype.commaStartingX0 = function() {
                  return ", %s kezdettel";
                }, a.prototype.daysOfTheWeek = function() {
                  return ["vasárnap", "hétfő", "kedd", "szerda", "csütörtök", "péntek", "szombat"];
                }, a.prototype.monthsOfTheYear = function() {
                  return [
                    "január",
                    "február",
                    "március",
                    "április",
                    "május",
                    "június",
                    "július",
                    "augusztus",
                    "szeptember",
                    "október",
                    "november",
                    "december"
                  ];
                }, a;
              }();
              u.hu = l;
            }
          ),
          /***/
          72: (
            /***/
            (i, u) => {
              Object.defineProperty(u, "__esModule", { value: !0 }), u.id = void 0;
              var l = function() {
                function a() {
                }
                return a.prototype.atX0SecondsPastTheMinuteGt20 = function() {
                  return null;
                }, a.prototype.atX0MinutesPastTheHourGt20 = function() {
                  return null;
                }, a.prototype.commaMonthX0ThroughMonthX1 = function() {
                  return null;
                }, a.prototype.commaYearX0ThroughYearX1 = function() {
                  return null;
                }, a.prototype.use24HourTimeFormatByDefault = function() {
                  return !0;
                }, a.prototype.anErrorOccuredWhenGeneratingTheExpressionD = function() {
                  return "Terjadi kesalahan saat membuat deskripsi ekspresi. Periksa sintaks ekspresi cron.";
                }, a.prototype.everyMinute = function() {
                  return "setiap menit";
                }, a.prototype.everyHour = function() {
                  return "setiap jam";
                }, a.prototype.atSpace = function() {
                  return "Pada ";
                }, a.prototype.everyMinuteBetweenX0AndX1 = function() {
                  return "Setiap menit diantara %s dan %s";
                }, a.prototype.at = function() {
                  return "Pada";
                }, a.prototype.spaceAnd = function() {
                  return " dan";
                }, a.prototype.everySecond = function() {
                  return "setiap detik";
                }, a.prototype.everyX0Seconds = function() {
                  return "setiap %s detik";
                }, a.prototype.secondsX0ThroughX1PastTheMinute = function() {
                  return "detik ke %s sampai %s melewati menit";
                }, a.prototype.atX0SecondsPastTheMinute = function() {
                  return "pada %s detik lewat satu menit";
                }, a.prototype.everyX0Minutes = function() {
                  return "setiap %s menit";
                }, a.prototype.minutesX0ThroughX1PastTheHour = function() {
                  return "menit ke %s sampai %s melewati jam";
                }, a.prototype.atX0MinutesPastTheHour = function() {
                  return "pada %s menit melewati jam";
                }, a.prototype.everyX0Hours = function() {
                  return "setiap %s jam";
                }, a.prototype.betweenX0AndX1 = function() {
                  return "diantara %s dan %s";
                }, a.prototype.atX0 = function() {
                  return "pada %s";
                }, a.prototype.commaEveryDay = function() {
                  return ", setiap hari";
                }, a.prototype.commaEveryX0DaysOfTheWeek = function() {
                  return ", setiap hari %s  dalam seminggu";
                }, a.prototype.commaX0ThroughX1 = function() {
                  return ", %s sampai %s";
                }, a.prototype.commaAndX0ThroughX1 = function() {
                  return ", dan %s sampai %s";
                }, a.prototype.first = function() {
                  return "pertama";
                }, a.prototype.second = function() {
                  return "kedua";
                }, a.prototype.third = function() {
                  return "ketiga";
                }, a.prototype.fourth = function() {
                  return "keempat";
                }, a.prototype.fifth = function() {
                  return "kelima";
                }, a.prototype.commaOnThe = function() {
                  return ", di ";
                }, a.prototype.spaceX0OfTheMonth = function() {
                  return " %s pada bulan";
                }, a.prototype.lastDay = function() {
                  return "hari terakhir";
                }, a.prototype.commaOnTheLastX0OfTheMonth = function() {
                  return ", pada %s terakhir bulan ini";
                }, a.prototype.commaOnlyOnX0 = function() {
                  return ", hanya pada %s";
                }, a.prototype.commaAndOnX0 = function() {
                  return ", dan pada %s";
                }, a.prototype.commaEveryX0Months = function() {
                  return ", setiap bulan %s ";
                }, a.prototype.commaOnlyInX0 = function() {
                  return ", hanya pada %s";
                }, a.prototype.commaOnTheLastDayOfTheMonth = function() {
                  return ", pada hari terakhir bulan ini";
                }, a.prototype.commaOnTheLastWeekdayOfTheMonth = function() {
                  return ", pada hari kerja terakhir setiap bulan";
                }, a.prototype.commaDaysBeforeTheLastDayOfTheMonth = function() {
                  return ", %s hari sebelum hari terakhir setiap bulan";
                }, a.prototype.firstWeekday = function() {
                  return "hari kerja pertama";
                }, a.prototype.weekdayNearestDayX0 = function() {
                  return "hari kerja terdekat %s";
                }, a.prototype.commaOnTheX0OfTheMonth = function() {
                  return ", pada %s bulan ini";
                }, a.prototype.commaEveryX0Days = function() {
                  return ", setiap %s hari";
                }, a.prototype.commaBetweenDayX0AndX1OfTheMonth = function() {
                  return ", antara hari %s dan %s dalam sebulan";
                }, a.prototype.commaOnDayX0OfTheMonth = function() {
                  return ", pada hari %s dalam sebulan";
                }, a.prototype.commaEveryHour = function() {
                  return ", setiap jam";
                }, a.prototype.commaEveryX0Years = function() {
                  return ", setiap %s tahun";
                }, a.prototype.commaStartingX0 = function() {
                  return ", mulai pada %s";
                }, a.prototype.daysOfTheWeek = function() {
                  return ["Minggu", "Senin", "Selasa", "Rabu", "Kamis", "Jumat", "Sabtu"];
                }, a.prototype.monthsOfTheYear = function() {
                  return [
                    "Januari",
                    "Februari",
                    "Maret",
                    "April",
                    "Mei",
                    "Juni",
                    "Juli",
                    "Agustus",
                    "September",
                    "Oktober",
                    "November",
                    "Desember"
                  ];
                }, a;
              }();
              u.id = l;
            }
          ),
          /***/
          488: (
            /***/
            (i, u) => {
              Object.defineProperty(u, "__esModule", { value: !0 }), u.it = void 0;
              var l = function() {
                function a() {
                }
                return a.prototype.atX0SecondsPastTheMinuteGt20 = function() {
                  return null;
                }, a.prototype.atX0MinutesPastTheHourGt20 = function() {
                  return null;
                }, a.prototype.commaMonthX0ThroughMonthX1 = function() {
                  return null;
                }, a.prototype.commaYearX0ThroughYearX1 = function() {
                  return null;
                }, a.prototype.use24HourTimeFormatByDefault = function() {
                  return !0;
                }, a.prototype.anErrorOccuredWhenGeneratingTheExpressionD = function() {
                  return "È verificato un errore durante la generazione la descrizione espressione. Controllare la sintassi delle espressioni cron.";
                }, a.prototype.at = function() {
                  return "Alle";
                }, a.prototype.atSpace = function() {
                  return "Alle ";
                }, a.prototype.atX0 = function() {
                  return "alle %s";
                }, a.prototype.atX0MinutesPastTheHour = function() {
                  return "al %s minuto passata l'ora";
                }, a.prototype.atX0SecondsPastTheMinute = function() {
                  return "al %s secondo passato il minuto";
                }, a.prototype.betweenX0AndX1 = function() {
                  return "tra le %s e le %s";
                }, a.prototype.commaBetweenDayX0AndX1OfTheMonth = function() {
                  return ", tra il giorno %s e %s del mese";
                }, a.prototype.commaEveryDay = function() {
                  return ", ogni giorno";
                }, a.prototype.commaEveryX0Days = function() {
                  return ", ogni %s giorni";
                }, a.prototype.commaEveryX0DaysOfTheWeek = function() {
                  return ", ogni %s giorni della settimana";
                }, a.prototype.commaEveryX0Months = function() {
                  return ", ogni %s mesi";
                }, a.prototype.commaEveryX0Years = function() {
                  return ", ogni %s anni";
                }, a.prototype.commaOnDayX0OfTheMonth = function() {
                  return ", il giorno %s del mese";
                }, a.prototype.commaOnlyInX0 = function() {
                  return ", solo in %s";
                }, a.prototype.commaOnlyOnX0 = function() {
                  return ", solo il %s";
                }, a.prototype.commaAndOnX0 = function() {
                  return ", e il %s";
                }, a.prototype.commaOnThe = function() {
                  return ", il ";
                }, a.prototype.commaOnTheLastDayOfTheMonth = function() {
                  return ", l'ultimo giorno del mese";
                }, a.prototype.commaOnTheLastWeekdayOfTheMonth = function() {
                  return ", nell'ultima settimana del mese";
                }, a.prototype.commaDaysBeforeTheLastDayOfTheMonth = function() {
                  return ", %s giorni prima dell'ultimo giorno del mese";
                }, a.prototype.commaOnTheLastX0OfTheMonth = function() {
                  return ", l'ultimo %s del mese";
                }, a.prototype.commaOnTheX0OfTheMonth = function() {
                  return ", il %s del mese";
                }, a.prototype.commaX0ThroughX1 = function() {
                  return ", %s al %s";
                }, a.prototype.commaAndX0ThroughX1 = function() {
                  return ", e %s al %s";
                }, a.prototype.everyHour = function() {
                  return "ogni ora";
                }, a.prototype.everyMinute = function() {
                  return "ogni minuto";
                }, a.prototype.everyMinuteBetweenX0AndX1 = function() {
                  return "Ogni minuto tra le %s e le %s";
                }, a.prototype.everySecond = function() {
                  return "ogni secondo";
                }, a.prototype.everyX0Hours = function() {
                  return "ogni %s ore";
                }, a.prototype.everyX0Minutes = function() {
                  return "ogni %s minuti";
                }, a.prototype.everyX0Seconds = function() {
                  return "ogni %s secondi";
                }, a.prototype.fifth = function() {
                  return "quinto";
                }, a.prototype.first = function() {
                  return "primo";
                }, a.prototype.firstWeekday = function() {
                  return "primo giorno della settimana";
                }, a.prototype.fourth = function() {
                  return "quarto";
                }, a.prototype.minutesX0ThroughX1PastTheHour = function() {
                  return "minuti %s al %s dopo l'ora";
                }, a.prototype.second = function() {
                  return "secondo";
                }, a.prototype.secondsX0ThroughX1PastTheMinute = function() {
                  return "secondi %s al %s oltre il minuto";
                }, a.prototype.spaceAnd = function() {
                  return " e";
                }, a.prototype.spaceX0OfTheMonth = function() {
                  return " %s del mese";
                }, a.prototype.lastDay = function() {
                  return "l'ultimo giorno";
                }, a.prototype.third = function() {
                  return "terzo";
                }, a.prototype.weekdayNearestDayX0 = function() {
                  return "giorno della settimana più vicino al %s";
                }, a.prototype.commaStartingX0 = function() {
                  return ", a partire %s";
                }, a.prototype.daysOfTheWeek = function() {
                  return ["domenica", "lunedì", "martedì", "mercoledì", "giovedì", "venerdì", "sabato"];
                }, a.prototype.monthsOfTheYear = function() {
                  return [
                    "gennaio",
                    "febbraio",
                    "marzo",
                    "aprile",
                    "maggio",
                    "giugno",
                    "luglio",
                    "agosto",
                    "settembre",
                    "ottobre",
                    "novembre",
                    "dicembre"
                  ];
                }, a;
              }();
              u.it = l;
            }
          ),
          /***/
          904: (
            /***/
            (i, u) => {
              Object.defineProperty(u, "__esModule", { value: !0 }), u.ja = void 0;
              var l = function() {
                function a() {
                }
                return a.prototype.use24HourTimeFormatByDefault = function() {
                  return !0;
                }, a.prototype.everyMinute = function() {
                  return "毎分";
                }, a.prototype.everyHour = function() {
                  return "毎時";
                }, a.prototype.anErrorOccuredWhenGeneratingTheExpressionD = function() {
                  return "式の記述を生成する際にエラーが発生しました。Cron 式の構文を確認してください。";
                }, a.prototype.atSpace = function() {
                  return "次において実施";
                }, a.prototype.everyMinuteBetweenX0AndX1 = function() {
                  return "%s から %s まで毎分";
                }, a.prototype.at = function() {
                  return "次において実施";
                }, a.prototype.spaceAnd = function() {
                  return "と";
                }, a.prototype.everySecond = function() {
                  return "毎秒";
                }, a.prototype.everyX0Seconds = function() {
                  return "%s 秒ごと";
                }, a.prototype.secondsX0ThroughX1PastTheMinute = function() {
                  return "毎分 %s 秒から %s 秒まで";
                }, a.prototype.atX0SecondsPastTheMinute = function() {
                  return "毎分 %s 秒過ぎ";
                }, a.prototype.everyX0Minutes = function() {
                  return "%s 分ごと";
                }, a.prototype.minutesX0ThroughX1PastTheHour = function() {
                  return "毎時 %s 分から %s 分まで";
                }, a.prototype.atX0MinutesPastTheHour = function() {
                  return "毎時 %s 分過ぎ";
                }, a.prototype.everyX0Hours = function() {
                  return "%s 時間ごと";
                }, a.prototype.betweenX0AndX1 = function() {
                  return "%s と %s の間";
                }, a.prototype.atX0 = function() {
                  return "次において実施 %s";
                }, a.prototype.commaEveryDay = function() {
                  return "、毎日";
                }, a.prototype.commaEveryX0DaysOfTheWeek = function() {
                  return "、週のうち %s 日ごと";
                }, a.prototype.commaX0ThroughX1 = function() {
                  return "、%s から %s まで";
                }, a.prototype.commaAndX0ThroughX1 = function() {
                  return "、%s から %s まで";
                }, a.prototype.first = function() {
                  return "1 番目";
                }, a.prototype.second = function() {
                  return "2 番目";
                }, a.prototype.third = function() {
                  return "3 番目";
                }, a.prototype.fourth = function() {
                  return "4 番目";
                }, a.prototype.fifth = function() {
                  return "5 番目";
                }, a.prototype.commaOnThe = function() {
                  return "次に";
                }, a.prototype.spaceX0OfTheMonth = function() {
                  return "月のうち %s";
                }, a.prototype.commaOnTheLastX0OfTheMonth = function() {
                  return "月の最後の %s に";
                }, a.prototype.commaOnlyOnX0 = function() {
                  return "%s にのみ";
                }, a.prototype.commaEveryX0Months = function() {
                  return "、%s か月ごと";
                }, a.prototype.commaOnlyInX0 = function() {
                  return "%s でのみ";
                }, a.prototype.commaOnTheLastDayOfTheMonth = function() {
                  return "次の最終日に";
                }, a.prototype.commaOnTheLastWeekdayOfTheMonth = function() {
                  return "月の最後の平日に";
                }, a.prototype.firstWeekday = function() {
                  return "最初の平日";
                }, a.prototype.weekdayNearestDayX0 = function() {
                  return "%s 日の直近の平日";
                }, a.prototype.commaOnTheX0OfTheMonth = function() {
                  return "月の %s に";
                }, a.prototype.commaEveryX0Days = function() {
                  return "、%s 日ごと";
                }, a.prototype.commaBetweenDayX0AndX1OfTheMonth = function() {
                  return "、月の %s 日から %s 日の間";
                }, a.prototype.commaOnDayX0OfTheMonth = function() {
                  return "、月の %s 日目";
                }, a.prototype.spaceAndSpace = function() {
                  return "と";
                }, a.prototype.commaEveryMinute = function() {
                  return "、毎分";
                }, a.prototype.commaEveryHour = function() {
                  return "、毎時";
                }, a.prototype.commaEveryX0Years = function() {
                  return "、%s 年ごと";
                }, a.prototype.commaStartingX0 = function() {
                  return "、%s に開始";
                }, a.prototype.aMPeriod = function() {
                  return "AM";
                }, a.prototype.pMPeriod = function() {
                  return "PM";
                }, a.prototype.commaDaysBeforeTheLastDayOfTheMonth = function() {
                  return "月の最終日の %s 日前";
                }, a.prototype.atX0SecondsPastTheMinuteGt20 = function() {
                  return null;
                }, a.prototype.atX0MinutesPastTheHourGt20 = function() {
                  return null;
                }, a.prototype.commaMonthX0ThroughMonthX1 = function() {
                  return null;
                }, a.prototype.commaYearX0ThroughYearX1 = function() {
                  return null;
                }, a.prototype.lastDay = function() {
                  return "最終日";
                }, a.prototype.commaAndOnX0 = function() {
                  return "、〜と %s";
                }, a.prototype.daysOfTheWeek = function() {
                  return ["日曜日", "月曜日", "火曜日", "水曜日", "木曜日", "金曜日", "土曜日"];
                }, a.prototype.monthsOfTheYear = function() {
                  return ["1月", "2月", "3月", "4月", "5月", "6月", "7月", "8月", "9月", "10月", "11月", "12月"];
                }, a;
              }();
              u.ja = l;
            }
          ),
          /***/
          839: (
            /***/
            (i, u) => {
              Object.defineProperty(u, "__esModule", { value: !0 }), u.ko = void 0;
              var l = function() {
                function a() {
                }
                return a.prototype.setPeriodBeforeTime = function() {
                  return !0;
                }, a.prototype.pm = function() {
                  return "오후";
                }, a.prototype.am = function() {
                  return "오전";
                }, a.prototype.atX0SecondsPastTheMinuteGt20 = function() {
                  return null;
                }, a.prototype.atX0MinutesPastTheHourGt20 = function() {
                  return null;
                }, a.prototype.commaMonthX0ThroughMonthX1 = function() {
                  return null;
                }, a.prototype.commaYearX0ThroughYearX1 = function() {
                  return null;
                }, a.prototype.use24HourTimeFormatByDefault = function() {
                  return !1;
                }, a.prototype.anErrorOccuredWhenGeneratingTheExpressionD = function() {
                  return "표현식 설명을 생성하는 중 오류가 발생했습니다. cron 표현식 구문을 확인하십시오.";
                }, a.prototype.everyMinute = function() {
                  return "1분마다";
                }, a.prototype.everyHour = function() {
                  return "1시간마다";
                }, a.prototype.atSpace = function() {
                  return "시간 ";
                }, a.prototype.everyMinuteBetweenX0AndX1 = function() {
                  return "%s 및 %s 사이에 매 분";
                }, a.prototype.at = function() {
                  return "시간";
                }, a.prototype.spaceAnd = function() {
                  return " 및";
                }, a.prototype.everySecond = function() {
                  return "1초마다";
                }, a.prototype.everyX0Seconds = function() {
                  return "%s초마다";
                }, a.prototype.secondsX0ThroughX1PastTheMinute = function() {
                  return "정분 후 %s초에서 %s초까지";
                }, a.prototype.atX0SecondsPastTheMinute = function() {
                  return "정분 후 %s초에서";
                }, a.prototype.everyX0Minutes = function() {
                  return "%s분마다";
                }, a.prototype.minutesX0ThroughX1PastTheHour = function() {
                  return "정시 후 %s분에서 %s분까지";
                }, a.prototype.atX0MinutesPastTheHour = function() {
                  return "정시 후 %s분에서";
                }, a.prototype.everyX0Hours = function() {
                  return "%s시간마다";
                }, a.prototype.betweenX0AndX1 = function() {
                  return "%s에서 %s 사이";
                }, a.prototype.atX0 = function() {
                  return "%s에서";
                }, a.prototype.commaEveryDay = function() {
                  return ", 매일";
                }, a.prototype.commaEveryX0DaysOfTheWeek = function() {
                  return ", 주 중 %s일마다";
                }, a.prototype.commaX0ThroughX1 = function() {
                  return ", %s에서 %s까지";
                }, a.prototype.commaAndX0ThroughX1 = function() {
                  return ", 및 %s에서 %s까지";
                }, a.prototype.first = function() {
                  return "첫 번째";
                }, a.prototype.second = function() {
                  return "두 번째";
                }, a.prototype.third = function() {
                  return "세 번째";
                }, a.prototype.fourth = function() {
                  return "네 번째";
                }, a.prototype.fifth = function() {
                  return "다섯 번째";
                }, a.prototype.commaOnThe = function() {
                  return ", 해당 ";
                }, a.prototype.spaceX0OfTheMonth = function() {
                  return " 해당 월의 %s";
                }, a.prototype.lastDay = function() {
                  return "마지막 날";
                }, a.prototype.commaOnTheLastX0OfTheMonth = function() {
                  return ", 해당 월의 마지막 %s";
                }, a.prototype.commaOnlyOnX0 = function() {
                  return ", %s에만";
                }, a.prototype.commaAndOnX0 = function() {
                  return ", 및 %s에";
                }, a.prototype.commaEveryX0Months = function() {
                  return ", %s개월마다";
                }, a.prototype.commaOnlyInX0 = function() {
                  return ", %s에만";
                }, a.prototype.commaOnTheLastDayOfTheMonth = function() {
                  return ", 해당 월의 마지막 날에";
                }, a.prototype.commaOnTheLastWeekdayOfTheMonth = function() {
                  return ", 해당 월의 마지막 평일에";
                }, a.prototype.commaDaysBeforeTheLastDayOfTheMonth = function() {
                  return ", 해당 월의 마지막 날 %s일 전";
                }, a.prototype.firstWeekday = function() {
                  return "첫 번째 평일";
                }, a.prototype.weekdayNearestDayX0 = function() {
                  return "%s일과 가장 가까운 평일";
                }, a.prototype.commaOnTheX0OfTheMonth = function() {
                  return ", 해당 월의 %s에";
                }, a.prototype.commaEveryX0Days = function() {
                  return ", %s일마다";
                }, a.prototype.commaBetweenDayX0AndX1OfTheMonth = function() {
                  return ", 해당 월의 %s일에서 %s일까지";
                }, a.prototype.commaOnDayX0OfTheMonth = function() {
                  return ", 해당 월의 %s일에";
                }, a.prototype.commaEveryMinute = function() {
                  return ", 1분마다";
                }, a.prototype.commaEveryHour = function() {
                  return ", 1시간마다";
                }, a.prototype.commaEveryX0Years = function() {
                  return ", %s년마다";
                }, a.prototype.commaStartingX0 = function() {
                  return ", %s부터";
                }, a.prototype.daysOfTheWeek = function() {
                  return ["일요일", "월요일", "화요일", "수요일", "목요일", "금요일", "토요일"];
                }, a.prototype.monthsOfTheYear = function() {
                  return ["1월", "2월", "3월", "4월", "5월", "6월", "7월", "8월", "9월", "10월", "11월", "12월"];
                }, a;
              }();
              u.ko = l;
            }
          ),
          /***/
          919: (
            /***/
            (i, u) => {
              Object.defineProperty(u, "__esModule", { value: !0 }), u.my = void 0;
              var l = function() {
                function a() {
                }
                return a.prototype.atX0SecondsPastTheMinuteGt20 = function() {
                  return null;
                }, a.prototype.atX0MinutesPastTheHourGt20 = function() {
                  return null;
                }, a.prototype.commaMonthX0ThroughMonthX1 = function() {
                  return null;
                }, a.prototype.commaYearX0ThroughYearX1 = function() {
                  return null;
                }, a.prototype.use24HourTimeFormatByDefault = function() {
                  return !1;
                }, a.prototype.anErrorOccuredWhenGeneratingTheExpressionD = function() {
                  return "Terdapat ralat semasa menjana penerangan ungkapan. Sila periksa sintaks ungkapan cron.";
                }, a.prototype.everyMinute = function() {
                  return "setiap minit";
                }, a.prototype.everyHour = function() {
                  return "setiap jam";
                }, a.prototype.atSpace = function() {
                  return "Pada ";
                }, a.prototype.everyMinuteBetweenX0AndX1 = function() {
                  return "Setiap minit antara %s dan %s";
                }, a.prototype.at = function() {
                  return "Pada";
                }, a.prototype.spaceAnd = function() {
                  return " dan";
                }, a.prototype.everySecond = function() {
                  return "setiap saat";
                }, a.prototype.everyX0Seconds = function() {
                  return "setiap %s saat";
                }, a.prototype.secondsX0ThroughX1PastTheMinute = function() {
                  return "saat ke %s hingga %s selepas minit";
                }, a.prototype.atX0SecondsPastTheMinute = function() {
                  return "pada %s saat selepas minit";
                }, a.prototype.everyX0Minutes = function() {
                  return "setiap %s minit";
                }, a.prototype.minutesX0ThroughX1PastTheHour = function() {
                  return "minit ke %s hingga %s selepas jam";
                }, a.prototype.atX0MinutesPastTheHour = function() {
                  return "pada %s minit selepas jam";
                }, a.prototype.everyX0Hours = function() {
                  return "setiap %s jam";
                }, a.prototype.betweenX0AndX1 = function() {
                  return "antara %s dan %s";
                }, a.prototype.atX0 = function() {
                  return "pada %s";
                }, a.prototype.commaEveryDay = function() {
                  return ", setiap hari";
                }, a.prototype.commaEveryX0DaysOfTheWeek = function() {
                  return ", setiap %s hari dalam minggu";
                }, a.prototype.commaX0ThroughX1 = function() {
                  return ", %s hingga %s";
                }, a.prototype.commaAndX0ThroughX1 = function() {
                  return ", dan %s hingga %s";
                }, a.prototype.first = function() {
                  return "pertama";
                }, a.prototype.second = function() {
                  return "kedua";
                }, a.prototype.third = function() {
                  return "ketiga";
                }, a.prototype.fourth = function() {
                  return "keempat";
                }, a.prototype.fifth = function() {
                  return "kelima";
                }, a.prototype.commaOnThe = function() {
                  return ", pada ";
                }, a.prototype.spaceX0OfTheMonth = function() {
                  return " %s pada bulan";
                }, a.prototype.lastDay = function() {
                  return "hari terakhir";
                }, a.prototype.commaOnTheLastX0OfTheMonth = function() {
                  return ", pada %s terakhir bulan";
                }, a.prototype.commaOnlyOnX0 = function() {
                  return ", hanya pada %s";
                }, a.prototype.commaAndOnX0 = function() {
                  return ", dan pada %s";
                }, a.prototype.commaEveryX0Months = function() {
                  return ", setiap bulan %s";
                }, a.prototype.commaOnlyInX0 = function() {
                  return ", hanya pada %s";
                }, a.prototype.commaOnTheLastDayOfTheMonth = function() {
                  return ", pada hari terakhir bulan";
                }, a.prototype.commaOnTheLastWeekdayOfTheMonth = function() {
                  return ", pada minggu terakhir bulan";
                }, a.prototype.commaDaysBeforeTheLastDayOfTheMonth = function() {
                  return ", %s hari sebelum hari terakhir bulan";
                }, a.prototype.firstWeekday = function() {
                  return "hari pertama minggu bekerja";
                }, a.prototype.weekdayNearestDayX0 = function() {
                  return "hari bekerja yang terdekat dengan %s";
                }, a.prototype.commaOnTheX0OfTheMonth = function() {
                  return ", pada %s bulan";
                }, a.prototype.commaEveryX0Days = function() {
                  return ", setiap %s hari";
                }, a.prototype.commaBetweenDayX0AndX1OfTheMonth = function() {
                  return ", antara hari %s dan %s dalam bulan";
                }, a.prototype.commaOnDayX0OfTheMonth = function() {
                  return ", pada hari %s dalam bulan";
                }, a.prototype.commaEveryHour = function() {
                  return ", setiap jam";
                }, a.prototype.commaEveryX0Years = function() {
                  return ", setiap %s tahun";
                }, a.prototype.commaStartingX0 = function() {
                  return ", bermula %s";
                }, a.prototype.daysOfTheWeek = function() {
                  return ["Ahad", "Isnin", "Selasa", "Rabu", "Khamis", "Jumaat", "Sabtu"];
                }, a.prototype.monthsOfTheYear = function() {
                  return [
                    "Januari",
                    "Februari",
                    "Mac",
                    "April",
                    "Mei",
                    "Jun",
                    "Julai",
                    "Ogos",
                    "September",
                    "Oktober",
                    "November",
                    "Disember"
                  ];
                }, a;
              }();
              u.my = l;
            }
          ),
          /***/
          957: (
            /***/
            (i, u) => {
              Object.defineProperty(u, "__esModule", { value: !0 }), u.nb = void 0;
              var l = function() {
                function a() {
                }
                return a.prototype.atX0SecondsPastTheMinuteGt20 = function() {
                  return null;
                }, a.prototype.atX0MinutesPastTheHourGt20 = function() {
                  return null;
                }, a.prototype.commaMonthX0ThroughMonthX1 = function() {
                  return null;
                }, a.prototype.commaYearX0ThroughYearX1 = function() {
                  return null;
                }, a.prototype.use24HourTimeFormatByDefault = function() {
                  return !0;
                }, a.prototype.anErrorOccuredWhenGeneratingTheExpressionD = function() {
                  return "En feil inntraff ved generering av uttrykksbeskrivelse. Sjekk cron syntaks.";
                }, a.prototype.at = function() {
                  return "Kl.";
                }, a.prototype.atSpace = function() {
                  return "Kl.";
                }, a.prototype.atX0 = function() {
                  return "på %s";
                }, a.prototype.atX0MinutesPastTheHour = function() {
                  return "på %s minutter etter timen";
                }, a.prototype.atX0SecondsPastTheMinute = function() {
                  return "på %s sekunder etter minuttet";
                }, a.prototype.betweenX0AndX1 = function() {
                  return "mellom %s og %s";
                }, a.prototype.commaBetweenDayX0AndX1OfTheMonth = function() {
                  return ", mellom dag %s og %s av måneden";
                }, a.prototype.commaEveryDay = function() {
                  return ", hver dag";
                }, a.prototype.commaEveryX0Days = function() {
                  return ", hver %s dag";
                }, a.prototype.commaEveryX0DaysOfTheWeek = function() {
                  return ", hver %s ukedag";
                }, a.prototype.commaEveryX0Months = function() {
                  return ", hver %s måned";
                }, a.prototype.commaEveryX0Years = function() {
                  return ", hvert %s år";
                }, a.prototype.commaOnDayX0OfTheMonth = function() {
                  return ", på dag %s av måneden";
                }, a.prototype.commaOnlyInX0 = function() {
                  return ", bare i %s";
                }, a.prototype.commaOnlyOnX0 = function() {
                  return ", på %s";
                }, a.prototype.commaAndOnX0 = function() {
                  return ", og på %s";
                }, a.prototype.commaOnThe = function() {
                  return ", på ";
                }, a.prototype.commaOnTheLastDayOfTheMonth = function() {
                  return ", på den siste dagen i måneden";
                }, a.prototype.commaOnTheLastWeekdayOfTheMonth = function() {
                  return ", den siste ukedagen i måneden";
                }, a.prototype.commaDaysBeforeTheLastDayOfTheMonth = function() {
                  return ", %s dager før den siste dagen i måneden";
                }, a.prototype.commaOnTheLastX0OfTheMonth = function() {
                  return ", på den siste %s av måneden";
                }, a.prototype.commaOnTheX0OfTheMonth = function() {
                  return ", på den %s av måneden";
                }, a.prototype.commaX0ThroughX1 = function() {
                  return ", %s til og med %s";
                }, a.prototype.commaAndX0ThroughX1 = function() {
                  return ", og %s til og med %s";
                }, a.prototype.everyHour = function() {
                  return "hver time";
                }, a.prototype.everyMinute = function() {
                  return "hvert minutt";
                }, a.prototype.everyMinuteBetweenX0AndX1 = function() {
                  return "Hvert minutt mellom %s og %s";
                }, a.prototype.everySecond = function() {
                  return "hvert sekund";
                }, a.prototype.everyX0Hours = function() {
                  return "hver %s time";
                }, a.prototype.everyX0Minutes = function() {
                  return "hvert %s minutt";
                }, a.prototype.everyX0Seconds = function() {
                  return "hvert %s sekund";
                }, a.prototype.fifth = function() {
                  return "femte";
                }, a.prototype.first = function() {
                  return "første";
                }, a.prototype.firstWeekday = function() {
                  return "første ukedag";
                }, a.prototype.fourth = function() {
                  return "fjerde";
                }, a.prototype.minutesX0ThroughX1PastTheHour = function() {
                  return "minuttene fra %s til og med %s etter timen";
                }, a.prototype.second = function() {
                  return "andre";
                }, a.prototype.secondsX0ThroughX1PastTheMinute = function() {
                  return "sekundene fra %s til og med %s etter minuttet";
                }, a.prototype.spaceAnd = function() {
                  return " og";
                }, a.prototype.spaceX0OfTheMonth = function() {
                  return " %s i måneden";
                }, a.prototype.lastDay = function() {
                  return "den siste dagen";
                }, a.prototype.third = function() {
                  return "tredje";
                }, a.prototype.weekdayNearestDayX0 = function() {
                  return "ukedag nærmest dag %s";
                }, a.prototype.commaStartingX0 = function() {
                  return ", starter %s";
                }, a.prototype.daysOfTheWeek = function() {
                  return ["søndag", "mandag", "tirsdag", "onsdag", "torsdag", "fredag", "lørdag"];
                }, a.prototype.monthsOfTheYear = function() {
                  return [
                    "januar",
                    "februar",
                    "mars",
                    "april",
                    "mai",
                    "juni",
                    "juli",
                    "august",
                    "september",
                    "oktober",
                    "november",
                    "desember"
                  ];
                }, a;
              }();
              u.nb = l;
            }
          ),
          /***/
          647: (
            /***/
            (i, u) => {
              Object.defineProperty(u, "__esModule", { value: !0 }), u.nl = void 0;
              var l = function() {
                function a() {
                }
                return a.prototype.atX0SecondsPastTheMinuteGt20 = function() {
                  return null;
                }, a.prototype.atX0MinutesPastTheHourGt20 = function() {
                  return null;
                }, a.prototype.commaMonthX0ThroughMonthX1 = function() {
                  return null;
                }, a.prototype.commaYearX0ThroughYearX1 = function() {
                  return null;
                }, a.prototype.use24HourTimeFormatByDefault = function() {
                  return !0;
                }, a.prototype.everyMinute = function() {
                  return "elke minuut";
                }, a.prototype.everyHour = function() {
                  return "elk uur";
                }, a.prototype.anErrorOccuredWhenGeneratingTheExpressionD = function() {
                  return "Er is een fout opgetreden bij het vertalen van de gegevens. Controleer de gegevens.";
                }, a.prototype.atSpace = function() {
                  return "Om ";
                }, a.prototype.everyMinuteBetweenX0AndX1 = function() {
                  return "Elke minuut tussen %s en %s";
                }, a.prototype.at = function() {
                  return "Om";
                }, a.prototype.spaceAnd = function() {
                  return " en";
                }, a.prototype.everySecond = function() {
                  return "elke seconde";
                }, a.prototype.everyX0Seconds = function() {
                  return "elke %s seconden";
                }, a.prototype.secondsX0ThroughX1PastTheMinute = function() {
                  return "seconden %s t/m %s na de minuut";
                }, a.prototype.atX0SecondsPastTheMinute = function() {
                  return "op %s seconden na de minuut";
                }, a.prototype.everyX0Minutes = function() {
                  return "elke %s minuten";
                }, a.prototype.minutesX0ThroughX1PastTheHour = function() {
                  return "minuut %s t/m %s na het uur";
                }, a.prototype.atX0MinutesPastTheHour = function() {
                  return "op %s minuten na het uur";
                }, a.prototype.everyX0Hours = function() {
                  return "elke %s uur";
                }, a.prototype.betweenX0AndX1 = function() {
                  return "tussen %s en %s";
                }, a.prototype.atX0 = function() {
                  return "om %s";
                }, a.prototype.commaEveryDay = function() {
                  return ", elke dag";
                }, a.prototype.commaEveryX0DaysOfTheWeek = function() {
                  return ", elke %s dagen van de week";
                }, a.prototype.commaX0ThroughX1 = function() {
                  return ", %s t/m %s";
                }, a.prototype.commaAndX0ThroughX1 = function() {
                  return ", en %s t/m %s";
                }, a.prototype.first = function() {
                  return "eerste";
                }, a.prototype.second = function() {
                  return "tweede";
                }, a.prototype.third = function() {
                  return "derde";
                }, a.prototype.fourth = function() {
                  return "vierde";
                }, a.prototype.fifth = function() {
                  return "vijfde";
                }, a.prototype.commaOnThe = function() {
                  return ", op de ";
                }, a.prototype.spaceX0OfTheMonth = function() {
                  return " %s van de maand";
                }, a.prototype.lastDay = function() {
                  return "de laatste dag";
                }, a.prototype.commaOnTheLastX0OfTheMonth = function() {
                  return ", op de laatste %s van de maand";
                }, a.prototype.commaOnlyOnX0 = function() {
                  return ", alleen op %s";
                }, a.prototype.commaAndOnX0 = function() {
                  return ", en op %s";
                }, a.prototype.commaEveryX0Months = function() {
                  return ", elke %s maanden";
                }, a.prototype.commaOnlyInX0 = function() {
                  return ", alleen in %s";
                }, a.prototype.commaOnTheLastDayOfTheMonth = function() {
                  return ", op de laatste dag van de maand";
                }, a.prototype.commaOnTheLastWeekdayOfTheMonth = function() {
                  return ", op de laatste werkdag van de maand";
                }, a.prototype.commaDaysBeforeTheLastDayOfTheMonth = function() {
                  return ", %s dagen vóór de laatste dag van de maand";
                }, a.prototype.firstWeekday = function() {
                  return "eerste werkdag";
                }, a.prototype.weekdayNearestDayX0 = function() {
                  return "werkdag dichtst bij dag %s";
                }, a.prototype.commaOnTheX0OfTheMonth = function() {
                  return ", op de %s van de maand";
                }, a.prototype.commaEveryX0Days = function() {
                  return ", elke %s dagen";
                }, a.prototype.commaBetweenDayX0AndX1OfTheMonth = function() {
                  return ", tussen dag %s en %s van de maand";
                }, a.prototype.commaOnDayX0OfTheMonth = function() {
                  return ", op dag %s van de maand";
                }, a.prototype.commaEveryX0Years = function() {
                  return ", elke %s jaren";
                }, a.prototype.commaStartingX0 = function() {
                  return ", beginnend %s";
                }, a.prototype.daysOfTheWeek = function() {
                  return ["zondag", "maandag", "dinsdag", "woensdag", "donderdag", "vrijdag", "zaterdag"];
                }, a.prototype.monthsOfTheYear = function() {
                  return [
                    "januari",
                    "februari",
                    "maart",
                    "april",
                    "mei",
                    "juni",
                    "juli",
                    "augustus",
                    "september",
                    "oktober",
                    "november",
                    "december"
                  ];
                }, a;
              }();
              u.nl = l;
            }
          ),
          /***/
          905: (
            /***/
            (i, u) => {
              Object.defineProperty(u, "__esModule", { value: !0 }), u.pl = void 0;
              var l = function() {
                function a() {
                }
                return a.prototype.atX0SecondsPastTheMinuteGt20 = function() {
                  return null;
                }, a.prototype.atX0MinutesPastTheHourGt20 = function() {
                  return null;
                }, a.prototype.commaMonthX0ThroughMonthX1 = function() {
                  return null;
                }, a.prototype.commaYearX0ThroughYearX1 = function() {
                  return null;
                }, a.prototype.use24HourTimeFormatByDefault = function() {
                  return !0;
                }, a.prototype.anErrorOccuredWhenGeneratingTheExpressionD = function() {
                  return "Wystąpił błąd podczas generowania opisu wyrażenia cron. Sprawdź składnię wyrażenia cron.";
                }, a.prototype.at = function() {
                  return "O";
                }, a.prototype.atSpace = function() {
                  return "O ";
                }, a.prototype.atX0 = function() {
                  return "o %s";
                }, a.prototype.atX0MinutesPastTheHour = function() {
                  return "w %s minucie";
                }, a.prototype.atX0SecondsPastTheMinute = function() {
                  return "w %s sekundzie";
                }, a.prototype.betweenX0AndX1 = function() {
                  return "od %s do %s";
                }, a.prototype.commaBetweenDayX0AndX1OfTheMonth = function() {
                  return ", od %s-ego do %s-ego dnia miesiąca";
                }, a.prototype.commaEveryDay = function() {
                  return ", co dzień";
                }, a.prototype.commaEveryX0Days = function() {
                  return ", co %s dni";
                }, a.prototype.commaEveryX0DaysOfTheWeek = function() {
                  return ", co %s dni tygodnia";
                }, a.prototype.commaEveryX0Months = function() {
                  return ", co %s miesięcy";
                }, a.prototype.commaEveryX0Years = function() {
                  return ", co %s lat";
                }, a.prototype.commaOnDayX0OfTheMonth = function() {
                  return ", %s-ego dnia miesiąca";
                }, a.prototype.commaOnlyInX0 = function() {
                  return ", tylko %s";
                }, a.prototype.commaOnlyOnX0 = function() {
                  return ", tylko %s";
                }, a.prototype.commaAndOnX0 = function() {
                  return ", i %s";
                }, a.prototype.commaOnThe = function() {
                  return ", ";
                }, a.prototype.commaOnTheLastDayOfTheMonth = function() {
                  return ", ostatni dzień miesiąca";
                }, a.prototype.commaOnTheLastWeekdayOfTheMonth = function() {
                  return ", ostatni dzień roboczy miesiąca";
                }, a.prototype.commaDaysBeforeTheLastDayOfTheMonth = function() {
                  return ", %s dni przed ostatnim dniem miesiąca";
                }, a.prototype.commaOnTheLastX0OfTheMonth = function() {
                  return ", ostatni %s miesiąca";
                }, a.prototype.commaOnTheX0OfTheMonth = function() {
                  return ", %s miesiąca";
                }, a.prototype.commaX0ThroughX1 = function() {
                  return ", od %s do %s";
                }, a.prototype.commaAndX0ThroughX1 = function() {
                  return ", i od %s do %s";
                }, a.prototype.everyHour = function() {
                  return "co godzinę";
                }, a.prototype.everyMinute = function() {
                  return "co minutę";
                }, a.prototype.everyMinuteBetweenX0AndX1 = function() {
                  return "Co minutę od %s do %s";
                }, a.prototype.everySecond = function() {
                  return "co sekundę";
                }, a.prototype.everyX0Hours = function() {
                  return "co %s godzin";
                }, a.prototype.everyX0Minutes = function() {
                  return "co %s minut";
                }, a.prototype.everyX0Seconds = function() {
                  return "co %s sekund";
                }, a.prototype.fifth = function() {
                  return "piąty";
                }, a.prototype.first = function() {
                  return "pierwszy";
                }, a.prototype.firstWeekday = function() {
                  return "pierwszy dzień roboczy";
                }, a.prototype.fourth = function() {
                  return "czwarty";
                }, a.prototype.minutesX0ThroughX1PastTheHour = function() {
                  return "minuty od %s do %s";
                }, a.prototype.second = function() {
                  return "drugi";
                }, a.prototype.secondsX0ThroughX1PastTheMinute = function() {
                  return "sekundy od %s do %s";
                }, a.prototype.spaceAnd = function() {
                  return " i";
                }, a.prototype.spaceX0OfTheMonth = function() {
                  return " %s miesiąca";
                }, a.prototype.lastDay = function() {
                  return "ostatni dzień";
                }, a.prototype.third = function() {
                  return "trzeci";
                }, a.prototype.weekdayNearestDayX0 = function() {
                  return "dzień roboczy najbliższy %s-ego dnia";
                }, a.prototype.commaStartingX0 = function() {
                  return ", startowy %s";
                }, a.prototype.daysOfTheWeek = function() {
                  return ["niedziela", "poniedziałek", "wtorek", "środa", "czwartek", "piątek", "sobota"];
                }, a.prototype.monthsOfTheYear = function() {
                  return [
                    "styczeń",
                    "luty",
                    "marzec",
                    "kwiecień",
                    "maj",
                    "czerwiec",
                    "lipiec",
                    "sierpień",
                    "wrzesień",
                    "październik",
                    "listopad",
                    "grudzień"
                  ];
                }, a;
              }();
              u.pl = l;
            }
          ),
          /***/
          556: (
            /***/
            (i, u) => {
              Object.defineProperty(u, "__esModule", { value: !0 }), u.pt_BR = void 0;
              var l = function() {
                function a() {
                }
                return a.prototype.atX0SecondsPastTheMinuteGt20 = function() {
                  return null;
                }, a.prototype.atX0MinutesPastTheHourGt20 = function() {
                  return null;
                }, a.prototype.commaMonthX0ThroughMonthX1 = function() {
                  return null;
                }, a.prototype.commaYearX0ThroughYearX1 = function() {
                  return null;
                }, a.prototype.use24HourTimeFormatByDefault = function() {
                  return !0;
                }, a.prototype.anErrorOccuredWhenGeneratingTheExpressionD = function() {
                  return "Ocorreu um erro ao gerar a descrição da expressão Cron.";
                }, a.prototype.at = function() {
                  return "às";
                }, a.prototype.atSpace = function() {
                  return "às ";
                }, a.prototype.atX0 = function() {
                  return "Às %s";
                }, a.prototype.atX0MinutesPastTheHour = function() {
                  return "aos %s minutos da hora";
                }, a.prototype.atX0SecondsPastTheMinute = function() {
                  return "aos %s segundos do minuto";
                }, a.prototype.betweenX0AndX1 = function() {
                  return "entre %s e %s";
                }, a.prototype.commaBetweenDayX0AndX1OfTheMonth = function() {
                  return ", entre os dias %s e %s do mês";
                }, a.prototype.commaEveryDay = function() {
                  return ", a cada dia";
                }, a.prototype.commaEveryX0Days = function() {
                  return ", a cada %s dias";
                }, a.prototype.commaEveryX0DaysOfTheWeek = function() {
                  return ", a cada %s dias de semana";
                }, a.prototype.commaEveryX0Months = function() {
                  return ", a cada %s meses";
                }, a.prototype.commaOnDayX0OfTheMonth = function() {
                  return ", no dia %s do mês";
                }, a.prototype.commaOnlyInX0 = function(c) {
                  return c && c.length > 1 && c[1] === "-" ? "somente %s" : ", somente em %s";
                }, a.prototype.commaOnlyOnX0 = function(c) {
                  return c && c.length > 1 && c[1] === "-" ? ", somente %s" : ", somente de %s";
                }, a.prototype.commaAndOnX0 = function() {
                  return ", e de %s";
                }, a.prototype.commaOnThe = function(c, p) {
                  return p === "6" || p === "0" ? ", no" : ", na ";
                }, a.prototype.commaOnTheLastDayOfTheMonth = function() {
                  return ", no último dia do mês";
                }, a.prototype.commaOnTheLastWeekdayOfTheMonth = function() {
                  return ", no último dia da semana do mês";
                }, a.prototype.commaDaysBeforeTheLastDayOfTheMonth = function() {
                  return ", %s dias antes do último dia do mês";
                }, a.prototype.commaOnTheLastX0OfTheMonth = function() {
                  return ", na última %s do mês";
                }, a.prototype.commaOnTheX0OfTheMonth = function() {
                  return ", no %s do mês";
                }, a.prototype.commaX0ThroughX1 = function() {
                  return ", de %s a %s";
                }, a.prototype.commaAndX0ThroughX1 = function() {
                  return ", e de %s a %s";
                }, a.prototype.everyHour = function() {
                  return "a cada hora";
                }, a.prototype.everyMinute = function() {
                  return "a cada minuto";
                }, a.prototype.everyMinuteBetweenX0AndX1 = function() {
                  return "a cada minuto entre %s e %s";
                }, a.prototype.everySecond = function() {
                  return "a cada segundo";
                }, a.prototype.everyX0Hours = function() {
                  return "a cada %s horas";
                }, a.prototype.everyX0Minutes = function() {
                  return "a cada %s minutos";
                }, a.prototype.everyX0Seconds = function() {
                  return "a cada %s segundos";
                }, a.prototype.fifth = function(c) {
                  return c === "6" || c === "0" ? "quinto" : "quinta";
                }, a.prototype.first = function(c) {
                  return c === "6" || c === "0" ? "primeiro" : "primeira";
                }, a.prototype.firstWeekday = function() {
                  return "primeiro dia da semana";
                }, a.prototype.fourth = function(c) {
                  return c === "6" || c === "0" ? "quarto" : "quarta";
                }, a.prototype.minutesX0ThroughX1PastTheHour = function() {
                  return "do minuto %s até %s de cada hora";
                }, a.prototype.second = function(c) {
                  return c === "6" || c === "0" ? "segundo" : "segunda";
                }, a.prototype.secondsX0ThroughX1PastTheMinute = function() {
                  return "No segundo %s até %s de cada minuto";
                }, a.prototype.spaceAnd = function() {
                  return " e";
                }, a.prototype.spaceX0OfTheMonth = function() {
                  return " %s do mês";
                }, a.prototype.lastDay = function() {
                  return "o último dia";
                }, a.prototype.third = function(c) {
                  return c === "6" || c === "0" ? "terceiro" : "terceira";
                }, a.prototype.weekdayNearestDayX0 = function() {
                  return "dia da semana mais próximo do dia %s";
                }, a.prototype.commaEveryX0Years = function() {
                  return ", a cada %s anos";
                }, a.prototype.commaStartingX0 = function() {
                  return ", iniciando %s";
                }, a.prototype.daysOfTheWeek = function() {
                  return ["domingo", "segunda-feira", "terça-feira", "quarta-feira", "quinta-feira", "sexta-feira", "sábado"];
                }, a.prototype.monthsOfTheYear = function() {
                  return [
                    "janeiro",
                    "fevereiro",
                    "março",
                    "abril",
                    "maio",
                    "junho",
                    "julho",
                    "agosto",
                    "setembro",
                    "outubro",
                    "novembro",
                    "dezembro"
                  ];
                }, a;
              }();
              u.pt_BR = l;
            }
          ),
          /***/
          163: (
            /***/
            (i, u) => {
              Object.defineProperty(u, "__esModule", { value: !0 }), u.pt_PT = void 0;
              var l = function() {
                function a() {
                }
                return a.prototype.atX0SecondsPastTheMinuteGt20 = function() {
                  return null;
                }, a.prototype.atX0MinutesPastTheHourGt20 = function() {
                  return null;
                }, a.prototype.commaMonthX0ThroughMonthX1 = function() {
                  return null;
                }, a.prototype.commaYearX0ThroughYearX1 = function() {
                  return null;
                }, a.prototype.use24HourTimeFormatByDefault = function() {
                  return !0;
                }, a.prototype.anErrorOccuredWhenGeneratingTheExpressionD = function() {
                  return "Ocorreu um erro ao gerar a descrição da expressão Cron.";
                }, a.prototype.at = function() {
                  return "às";
                }, a.prototype.atSpace = function() {
                  return "às ";
                }, a.prototype.atX0 = function() {
                  return "Às %s";
                }, a.prototype.atX0MinutesPastTheHour = function() {
                  return "aos %s minutos da hora";
                }, a.prototype.atX0SecondsPastTheMinute = function() {
                  return "aos %s segundos do minuto";
                }, a.prototype.betweenX0AndX1 = function() {
                  return "entre %s e %s";
                }, a.prototype.commaBetweenDayX0AndX1OfTheMonth = function() {
                  return ", entre os dias %s e %s do mês";
                }, a.prototype.commaEveryDay = function() {
                  return ", a cada dia";
                }, a.prototype.commaEveryX0Days = function() {
                  return ", a cada %s dias";
                }, a.prototype.commaEveryX0DaysOfTheWeek = function() {
                  return ", a cada %s dias de semana";
                }, a.prototype.commaEveryX0Months = function() {
                  return ", a cada %s meses";
                }, a.prototype.commaOnDayX0OfTheMonth = function() {
                  return ", no dia %s do mês";
                }, a.prototype.commaOnlyInX0 = function() {
                  return ", somente em %s";
                }, a.prototype.commaOnlyOnX0 = function() {
                  return ", somente de %s";
                }, a.prototype.commaAndOnX0 = function() {
                  return ", e de %s";
                }, a.prototype.commaOnThe = function(c, p) {
                  return p === "6" || p === "0" ? ", no" : ", na ";
                }, a.prototype.commaOnTheLastDayOfTheMonth = function() {
                  return ", no último dia do mês";
                }, a.prototype.commaOnTheLastWeekdayOfTheMonth = function() {
                  return ", no último dia da semana do mês";
                }, a.prototype.commaDaysBeforeTheLastDayOfTheMonth = function() {
                  return ", %s dias antes do último dia do mês";
                }, a.prototype.commaOnTheLastX0OfTheMonth = function() {
                  return ", na última %s do mês";
                }, a.prototype.commaOnTheX0OfTheMonth = function() {
                  return ", no %s do mês";
                }, a.prototype.commaX0ThroughX1 = function() {
                  return ", de %s a %s";
                }, a.prototype.commaAndX0ThroughX1 = function() {
                  return ", e de %s a %s";
                }, a.prototype.everyHour = function() {
                  return "a cada hora";
                }, a.prototype.everyMinute = function() {
                  return "a cada minuto";
                }, a.prototype.everyMinuteBetweenX0AndX1 = function() {
                  return "a cada minuto entre %s e %s";
                }, a.prototype.everySecond = function() {
                  return "a cada segundo";
                }, a.prototype.everyX0Hours = function() {
                  return "a cada %s horas";
                }, a.prototype.everyX0Minutes = function() {
                  return "a cada %s minutos";
                }, a.prototype.everyX0Seconds = function() {
                  return "a cada %s segundos";
                }, a.prototype.fifth = function(c) {
                  return c === "6" || c === "0" ? "quinto" : "quinta";
                }, a.prototype.first = function(c) {
                  return c === "6" || c === "0" ? "primeiro" : "primeira";
                }, a.prototype.firstWeekday = function() {
                  return "primeiro dia da semana";
                }, a.prototype.fourth = function(c) {
                  return c === "6" || c === "0" ? "quarto" : "quarta";
                }, a.prototype.minutesX0ThroughX1PastTheHour = function() {
                  return "do minuto %s até %s de cada hora";
                }, a.prototype.second = function(c) {
                  return c === "6" || c === "0" ? "segundo" : "segunda";
                }, a.prototype.secondsX0ThroughX1PastTheMinute = function() {
                  return "No segundo %s até %s de cada minuto";
                }, a.prototype.spaceAnd = function() {
                  return " e";
                }, a.prototype.spaceX0OfTheMonth = function() {
                  return " %s do mês";
                }, a.prototype.lastDay = function() {
                  return "o último dia";
                }, a.prototype.third = function(c) {
                  return c === "6" || c === "0" ? "terceiro" : "terceira";
                }, a.prototype.weekdayNearestDayX0 = function() {
                  return "dia da semana mais próximo do dia %s";
                }, a.prototype.commaEveryX0Years = function() {
                  return ", a cada %s anos";
                }, a.prototype.commaStartingX0 = function() {
                  return ", iniciando %s";
                }, a.prototype.daysOfTheWeek = function() {
                  return ["domingo", "segunda-feira", "terça-feira", "quarta-feira", "quinta-feira", "sexta-feira", "sábado"];
                }, a.prototype.monthsOfTheYear = function() {
                  return [
                    "janeiro",
                    "fevereiro",
                    "março",
                    "abril",
                    "maio",
                    "junho",
                    "julho",
                    "agosto",
                    "setembro",
                    "outubro",
                    "novembro",
                    "dezembro"
                  ];
                }, a;
              }();
              u.pt_PT = l;
            }
          ),
          /***/
          614: (
            /***/
            (i, u) => {
              Object.defineProperty(u, "__esModule", { value: !0 }), u.ro = void 0;
              var l = function() {
                function a() {
                }
                return a.prototype.use24HourTimeFormatByDefault = function() {
                  return !0;
                }, a.prototype.anErrorOccuredWhenGeneratingTheExpressionD = function() {
                  return "Eroare la generarea descrierii. Verificați sintaxa.";
                }, a.prototype.at = function() {
                  return "La";
                }, a.prototype.atSpace = function() {
                  return "La ";
                }, a.prototype.atX0 = function() {
                  return "la %s";
                }, a.prototype.atX0MinutesPastTheHour = function() {
                  return "la și %s minute";
                }, a.prototype.atX0SecondsPastTheMinute = function() {
                  return "la și %s secunde";
                }, a.prototype.betweenX0AndX1 = function() {
                  return "între %s și %s";
                }, a.prototype.commaBetweenDayX0AndX1OfTheMonth = function() {
                  return ", între zilele %s și %s ale lunii";
                }, a.prototype.commaEveryDay = function() {
                  return ", în fiecare zi";
                }, a.prototype.commaEveryX0Days = function() {
                  return ", la fiecare %s zile";
                }, a.prototype.commaEveryX0DaysOfTheWeek = function() {
                  return ", la fiecare a %s-a zi a săptămânii";
                }, a.prototype.commaEveryX0Months = function() {
                  return ", la fiecare %s luni";
                }, a.prototype.commaEveryX0Years = function() {
                  return ", o dată la %s ani";
                }, a.prototype.commaOnDayX0OfTheMonth = function() {
                  return ", în ziua %s a lunii";
                }, a.prototype.commaOnlyInX0 = function() {
                  return ", doar în %s";
                }, a.prototype.commaOnlyOnX0 = function() {
                  return ", doar %s";
                }, a.prototype.commaAndOnX0 = function() {
                  return ", și %s";
                }, a.prototype.commaOnThe = function() {
                  return ", în ";
                }, a.prototype.commaOnTheLastDayOfTheMonth = function() {
                  return ", în ultima zi a lunii";
                }, a.prototype.commaOnTheLastWeekdayOfTheMonth = function() {
                  return ", în ultima zi lucrătoare a lunii";
                }, a.prototype.commaDaysBeforeTheLastDayOfTheMonth = function() {
                  return ", %s zile înainte de ultima zi a lunii";
                }, a.prototype.commaOnTheLastX0OfTheMonth = function() {
                  return ", în ultima %s a lunii";
                }, a.prototype.commaOnTheX0OfTheMonth = function() {
                  return ", în %s a lunii";
                }, a.prototype.commaX0ThroughX1 = function() {
                  return ", de %s până %s";
                }, a.prototype.commaAndX0ThroughX1 = function() {
                  return ", și de %s până %s";
                }, a.prototype.everyHour = function() {
                  return "în fiecare oră";
                }, a.prototype.everyMinute = function() {
                  return "în fiecare minut";
                }, a.prototype.everyMinuteBetweenX0AndX1 = function() {
                  return "În fiecare minut între %s și %s";
                }, a.prototype.everySecond = function() {
                  return "în fiecare secundă";
                }, a.prototype.everyX0Hours = function() {
                  return "la fiecare %s ore";
                }, a.prototype.everyX0Minutes = function() {
                  return "la fiecare %s minute";
                }, a.prototype.everyX0Seconds = function() {
                  return "la fiecare %s secunde";
                }, a.prototype.fifth = function() {
                  return "a cincea";
                }, a.prototype.first = function() {
                  return "prima";
                }, a.prototype.firstWeekday = function() {
                  return "prima zi a săptămânii";
                }, a.prototype.fourth = function() {
                  return "a patra";
                }, a.prototype.minutesX0ThroughX1PastTheHour = function() {
                  return "între minutele %s și %s";
                }, a.prototype.second = function() {
                  return "a doua";
                }, a.prototype.secondsX0ThroughX1PastTheMinute = function() {
                  return "între secunda %s și secunda %s";
                }, a.prototype.spaceAnd = function() {
                  return " și";
                }, a.prototype.spaceX0OfTheMonth = function() {
                  return " %s a lunii";
                }, a.prototype.lastDay = function() {
                  return "ultima zi";
                }, a.prototype.third = function() {
                  return "a treia";
                }, a.prototype.weekdayNearestDayX0 = function() {
                  return "cea mai apropiată zi a săptămânii de ziua %s";
                }, a.prototype.commaMonthX0ThroughMonthX1 = function() {
                  return ", din %s până în %s";
                }, a.prototype.commaYearX0ThroughYearX1 = function() {
                  return ", din %s până în %s";
                }, a.prototype.atX0MinutesPastTheHourGt20 = function() {
                  return "la și %s de minute";
                }, a.prototype.atX0SecondsPastTheMinuteGt20 = function() {
                  return "la și %s de secunde";
                }, a.prototype.commaStartingX0 = function() {
                  return ", pornire %s";
                }, a.prototype.daysOfTheWeek = function() {
                  return ["duminică", "luni", "marți", "miercuri", "joi", "vineri", "sâmbătă"];
                }, a.prototype.monthsOfTheYear = function() {
                  return [
                    "ianuarie",
                    "februarie",
                    "martie",
                    "aprilie",
                    "mai",
                    "iunie",
                    "iulie",
                    "august",
                    "septembrie",
                    "octombrie",
                    "noiembrie",
                    "decembrie"
                  ];
                }, a;
              }();
              u.ro = l;
            }
          ),
          /***/
          892: (
            /***/
            (i, u) => {
              Object.defineProperty(u, "__esModule", { value: !0 }), u.ru = void 0;
              var l = function(p, d) {
                var h = Number(p);
                return h !== void 0 ? d[h % 100 > 4 && h % 100 < 20 ? 2 : [2, 0, 1, 1, 1, 2][h % 10 < 5 ? Math.abs(h) % 10 : 5]] : d[2];
              }, a = function(p, d) {
                var h = Number(p);
                return h !== void 0 ? d[h === 0 ? 0 : h === 1 || h === 2 || h === 4 ? 1 : 2] : d[1];
              }, c = function() {
                function p() {
                }
                return p.prototype.atX0SecondsPastTheMinuteGt20 = function() {
                  return null;
                }, p.prototype.atX0MinutesPastTheHourGt20 = function() {
                  return null;
                }, p.prototype.commaMonthX0ThroughMonthX1 = function() {
                  return null;
                }, p.prototype.commaYearX0ThroughYearX1 = function() {
                  return null;
                }, p.prototype.use24HourTimeFormatByDefault = function() {
                  return !0;
                }, p.prototype.everyMinute = function() {
                  return "каждую минуту";
                }, p.prototype.everyHour = function() {
                  return "каждый час";
                }, p.prototype.anErrorOccuredWhenGeneratingTheExpressionD = function() {
                  return "Произошла ошибка во время генерации описания выражения. Проверьте синтаксис крон-выражения.";
                }, p.prototype.atSpace = function() {
                  return "В ";
                }, p.prototype.everyMinuteBetweenX0AndX1 = function() {
                  return "Каждую минуту с %s по %s";
                }, p.prototype.at = function() {
                  return "В";
                }, p.prototype.spaceAnd = function() {
                  return " и";
                }, p.prototype.everySecond = function() {
                  return "каждую секунду";
                }, p.prototype.everyX0Seconds = function(d) {
                  return l(d, ["каждую %s секунду", "каждые %s секунды", "каждые %s секунд"]);
                }, p.prototype.secondsX0ThroughX1PastTheMinute = function() {
                  return "секунды с %s по %s";
                }, p.prototype.atX0SecondsPastTheMinute = function(d) {
                  return l(d, ["в %s секунду", "в %s секунды", "в %s секунд"]);
                }, p.prototype.everyX0Minutes = function(d) {
                  return l(d, ["каждую %s минуту", "каждые %s минуты", "каждые %s минут"]);
                }, p.prototype.minutesX0ThroughX1PastTheHour = function() {
                  return "минуты с %s по %s";
                }, p.prototype.atX0MinutesPastTheHour = function(d) {
                  return l(d, ["в %s минуту", "в %s минуты", "в %s минут"]);
                }, p.prototype.everyX0Hours = function(d) {
                  return l(d, ["каждый %s час", "каждые %s часа", "каждые %s часов"]);
                }, p.prototype.betweenX0AndX1 = function() {
                  return "с %s по %s";
                }, p.prototype.atX0 = function() {
                  return "в %s";
                }, p.prototype.commaEveryDay = function() {
                  return ", каждый день";
                }, p.prototype.commaEveryX0DaysOfTheWeek = function(d) {
                  return l(d, [", каждый %s день недели", ", каждые %s дня недели", ", каждые %s дней недели"]);
                }, p.prototype.commaX0ThroughX1 = function(d) {
                  return d && (d[0] == "2" || d[0] == "3") ? ", со %s по %s" : ", с %s по %s";
                }, p.prototype.commaAndX0ThroughX1 = function(d) {
                  return d && (d[0] == "2" || d[0] == "3") ? " и со %s по %s" : " и с %s по %s";
                }, p.prototype.first = function(d) {
                  return a(d, ["первое", "первый", "первую"]);
                }, p.prototype.second = function(d) {
                  return a(d, ["второе", "второй", "вторую"]);
                }, p.prototype.third = function(d) {
                  return a(d, ["третье", "третий", "третью"]);
                }, p.prototype.fourth = function(d) {
                  return a(d, ["четвертое", "четвертый", "четвертую"]);
                }, p.prototype.fifth = function(d) {
                  return a(d, ["пятое", "пятый", "пятую"]);
                }, p.prototype.commaOnThe = function(d) {
                  return d === "2" ? ", во " : ", в ";
                }, p.prototype.spaceX0OfTheMonth = function() {
                  return " %s месяца";
                }, p.prototype.lastDay = function() {
                  return "последний день";
                }, p.prototype.commaOnTheLastX0OfTheMonth = function(d) {
                  return a(d, [", в последнее %s месяца", ", в последний %s месяца", ", в последнюю %s месяца"]);
                }, p.prototype.commaOnlyOnX0 = function(d) {
                  return d && d[0] === "2" ? ", только во %s" : ", только в %s";
                }, p.prototype.commaAndOnX0 = function() {
                  return ", и %s";
                }, p.prototype.commaEveryX0Months = function(d) {
                  return l(d, ["", " каждые %s месяца", " каждые %s месяцев"]);
                }, p.prototype.commaOnlyInMonthX0 = function() {
                  return ", только %s";
                }, p.prototype.commaOnlyInX0 = function() {
                  return ", только в %s";
                }, p.prototype.commaOnTheLastDayOfTheMonth = function() {
                  return ", в последний день месяца";
                }, p.prototype.commaOnTheLastWeekdayOfTheMonth = function() {
                  return ", в последний будний день месяца";
                }, p.prototype.commaDaysBeforeTheLastDayOfTheMonth = function(d) {
                  return l(d, [
                    ", за %s день до конца месяца",
                    ", за %s дня до конца месяца",
                    ", за %s дней до конца месяца"
                  ]);
                }, p.prototype.firstWeekday = function() {
                  return "первый будний день";
                }, p.prototype.weekdayNearestDayX0 = function() {
                  return "ближайший будний день к %s числу";
                }, p.prototype.commaOnTheX0OfTheMonth = function() {
                  return ", в %s месяца";
                }, p.prototype.commaEveryX0Days = function(d) {
                  return l(d, [", каждый %s день", ", каждые %s дня", ", каждые %s дней"]);
                }, p.prototype.commaBetweenDayX0AndX1OfTheMonth = function(d) {
                  return d && d.substring(0, d.indexOf("-")) == "2" ? ", со %s по %s число месяца" : ", с %s по %s число месяца";
                }, p.prototype.commaOnDayX0OfTheMonth = function(d) {
                  return d && d[0] == "2" ? ", во %s число месяца" : ", в %s число месяца";
                }, p.prototype.commaEveryX0Years = function(d) {
                  return l(d, [", каждый %s год", ", каждые %s года", ", каждые %s лет"]);
                }, p.prototype.commaStartingX0 = function() {
                  return ", начало %s";
                }, p.prototype.daysOfTheWeek = function() {
                  return ["воскресенье", "понедельник", "вторник", "среда", "четверг", "пятница", "суббота"];
                }, p.prototype.daysOfTheWeekInCase = function(d) {
                  return d === void 0 && (d = 2), d == 1 ? ["воскресенья", "понедельника", "вторника", "среды", "четверга", "пятницы", "субботы"] : ["воскресенье", "понедельник", "вторник", "среду", "четверг", "пятницу", "субботу"];
                }, p.prototype.monthsOfTheYear = function() {
                  return [
                    "январь",
                    "февраль",
                    "март",
                    "апрель",
                    "май",
                    "июнь",
                    "июль",
                    "август",
                    "сентябрь",
                    "октябрь",
                    "ноябрь",
                    "декабрь"
                  ];
                }, p.prototype.monthsOfTheYearInCase = function(d) {
                  return d == 1 ? [
                    "января",
                    "февраля",
                    "марта",
                    "апреля",
                    "мая",
                    "июня",
                    "июля",
                    "августа",
                    "сентября",
                    "октября",
                    "ноября",
                    "декабря"
                  ] : this.monthsOfTheYear();
                }, p;
              }();
              u.ru = c;
            }
          ),
          /***/
          923: (
            /***/
            (i, u) => {
              Object.defineProperty(u, "__esModule", { value: !0 }), u.sk = void 0;
              var l = function() {
                function a() {
                }
                return a.prototype.atX0SecondsPastTheMinuteGt20 = function() {
                  return null;
                }, a.prototype.atX0MinutesPastTheHourGt20 = function() {
                  return null;
                }, a.prototype.commaMonthX0ThroughMonthX1 = function() {
                  return null;
                }, a.prototype.commaYearX0ThroughYearX1 = function() {
                  return null;
                }, a.prototype.use24HourTimeFormatByDefault = function() {
                  return !0;
                }, a.prototype.anErrorOccuredWhenGeneratingTheExpressionD = function() {
                  return "Pri vytváraní popisu došlo k chybe. Skontrolujte prosím správnosť syntaxe cronu.";
                }, a.prototype.everyMinute = function() {
                  return "každú minútu";
                }, a.prototype.everyHour = function() {
                  return "každú hodinu";
                }, a.prototype.atSpace = function() {
                  return "V ";
                }, a.prototype.everyMinuteBetweenX0AndX1 = function() {
                  return "Každú minútu medzi %s a %s";
                }, a.prototype.at = function() {
                  return "V";
                }, a.prototype.spaceAnd = function() {
                  return " a";
                }, a.prototype.everySecond = function() {
                  return "každú sekundu";
                }, a.prototype.everyX0Seconds = function() {
                  return "každých %s sekúnd";
                }, a.prototype.secondsX0ThroughX1PastTheMinute = function() {
                  return "sekundy od %s do %s";
                }, a.prototype.atX0SecondsPastTheMinute = function() {
                  return "v %s sekúnd";
                }, a.prototype.everyX0Minutes = function() {
                  return "každých %s minút";
                }, a.prototype.minutesX0ThroughX1PastTheHour = function() {
                  return "minúty od %s do %s";
                }, a.prototype.atX0MinutesPastTheHour = function() {
                  return "v %s minút";
                }, a.prototype.everyX0Hours = function() {
                  return "každých %s hodín";
                }, a.prototype.betweenX0AndX1 = function() {
                  return "medzi %s a %s";
                }, a.prototype.atX0 = function() {
                  return "v %s";
                }, a.prototype.commaEveryDay = function() {
                  return ", každý deň";
                }, a.prototype.commaEveryX0DaysOfTheWeek = function() {
                  return ", každých %s dní v týždni";
                }, a.prototype.commaX0ThroughX1 = function() {
                  return ", od %s do %s";
                }, a.prototype.commaAndX0ThroughX1 = function() {
                  return ", a od %s do %s";
                }, a.prototype.first = function() {
                  return "prvý";
                }, a.prototype.second = function() {
                  return "druhý";
                }, a.prototype.third = function() {
                  return "tretí";
                }, a.prototype.fourth = function() {
                  return "štvrtý";
                }, a.prototype.fifth = function() {
                  return "piaty";
                }, a.prototype.commaOnThe = function() {
                  return ", ";
                }, a.prototype.spaceX0OfTheMonth = function() {
                  return " %s v mesiaci";
                }, a.prototype.lastDay = function() {
                  return "posledný deň";
                }, a.prototype.commaOnTheLastX0OfTheMonth = function() {
                  return ", posledný %s v mesiaci";
                }, a.prototype.commaOnlyOnX0 = function() {
                  return ", iba v %s";
                }, a.prototype.commaAndOnX0 = function() {
                  return ", a v %s";
                }, a.prototype.commaEveryX0Months = function() {
                  return ", každých %s mesiacov";
                }, a.prototype.commaOnlyInX0 = function() {
                  return ", iba v %s";
                }, a.prototype.commaOnTheLastDayOfTheMonth = function() {
                  return ", posledný deň v mesiaci";
                }, a.prototype.commaOnTheLastWeekdayOfTheMonth = function() {
                  return ", posledný pracovný deň v mesiaci";
                }, a.prototype.commaDaysBeforeTheLastDayOfTheMonth = function() {
                  return ", %s dní pred posledným dňom v mesiaci";
                }, a.prototype.firstWeekday = function() {
                  return "prvý pracovný deň";
                }, a.prototype.weekdayNearestDayX0 = function() {
                  return "pracovný deň najbližšie %s. dňu";
                }, a.prototype.commaOnTheX0OfTheMonth = function() {
                  return ", v %s v mesiaci";
                }, a.prototype.commaEveryX0Days = function() {
                  return ", každých %s dní";
                }, a.prototype.commaBetweenDayX0AndX1OfTheMonth = function() {
                  return ", medzi dňami %s a %s v mesiaci";
                }, a.prototype.commaOnDayX0OfTheMonth = function() {
                  return ", %s. deň v mesiaci";
                }, a.prototype.commaEveryX0Years = function() {
                  return ", každých %s rokov";
                }, a.prototype.commaStartingX0 = function() {
                  return ", začínajúcich %s";
                }, a.prototype.daysOfTheWeek = function() {
                  return ["Nedeľa", "Pondelok", "Utorok", "Streda", "Štvrtok", "Piatok", "Sobota"];
                }, a.prototype.monthsOfTheYear = function() {
                  return [
                    "Január",
                    "Február",
                    "Marec",
                    "Apríl",
                    "Máj",
                    "Jún",
                    "Júl",
                    "August",
                    "September",
                    "Október",
                    "November",
                    "December"
                  ];
                }, a;
              }();
              u.sk = l;
            }
          ),
          /***/
          474: (
            /***/
            (i, u) => {
              Object.defineProperty(u, "__esModule", { value: !0 }), u.sl = void 0;
              var l = function() {
                function a() {
                }
                return a.prototype.use24HourTimeFormatByDefault = function() {
                  return !0;
                }, a.prototype.anErrorOccuredWhenGeneratingTheExpressionD = function() {
                  return "Pri generiranju opisa izraza je prišlo do napake. Preverite sintakso izraza cron.";
                }, a.prototype.at = function() {
                  return "Ob";
                }, a.prototype.atSpace = function() {
                  return "Ob ";
                }, a.prototype.atX0 = function() {
                  return "ob %s";
                }, a.prototype.atX0MinutesPastTheHour = function() {
                  return "ob %s.";
                }, a.prototype.atX0SecondsPastTheMinute = function() {
                  return "ob %s.";
                }, a.prototype.betweenX0AndX1 = function() {
                  return "od %s do %s";
                }, a.prototype.commaBetweenDayX0AndX1OfTheMonth = function() {
                  return ", od %s. do %s. dne v mesecu";
                }, a.prototype.commaEveryDay = function() {
                  return ", vsak dan";
                }, a.prototype.commaEveryX0Days = function() {
                  return ", vsakih %s dni";
                }, a.prototype.commaEveryX0DaysOfTheWeek = function() {
                  return ", vsakih %s dni v tednu";
                }, a.prototype.commaEveryX0Months = function() {
                  return ", vsakih %s mesecev";
                }, a.prototype.commaEveryX0Years = function() {
                  return ", vsakih %s let";
                }, a.prototype.commaOnDayX0OfTheMonth = function() {
                  return ", %s. dan v mesecu";
                }, a.prototype.commaOnlyInX0 = function() {
                  return ", samo v %s";
                }, a.prototype.commaOnlyOnX0 = function() {
                  return ", samo v %s";
                }, a.prototype.commaAndOnX0 = function() {
                  return "in naprej %s";
                }, a.prototype.commaOnThe = function() {
                  return ", ";
                }, a.prototype.commaOnTheLastDayOfTheMonth = function() {
                  return ", zadnji %s v mesecu";
                }, a.prototype.commaOnTheLastWeekdayOfTheMonth = function() {
                  return ", zadnji delovni dan v mesecu";
                }, a.prototype.commaDaysBeforeTheLastDayOfTheMonth = function() {
                  return ", %s dni pred koncem meseca";
                }, a.prototype.commaOnTheLastX0OfTheMonth = function() {
                  return ", zadnji %s v mesecu";
                }, a.prototype.commaOnTheX0OfTheMonth = function() {
                  return ", %s v mesecu";
                }, a.prototype.commaX0ThroughX1 = function() {
                  return ", od %s do %s";
                }, a.prototype.commaAndX0ThroughX1 = function() {
                  return ", in od %s do %s";
                }, a.prototype.everyHour = function() {
                  return "vsako uro";
                }, a.prototype.everyMinute = function() {
                  return "vsako minuto";
                }, a.prototype.everyMinuteBetweenX0AndX1 = function() {
                  return "Vsako minuto od %s do %s";
                }, a.prototype.everySecond = function() {
                  return "vsako sekundo";
                }, a.prototype.everyX0Hours = function() {
                  return "vsakih %s ur";
                }, a.prototype.everyX0Minutes = function() {
                  return "vsakih %s minut";
                }, a.prototype.everyX0Seconds = function() {
                  return "vsakih %s sekund";
                }, a.prototype.fifth = function() {
                  return "peti";
                }, a.prototype.first = function() {
                  return "prvi";
                }, a.prototype.firstWeekday = function() {
                  return "prvi delovni dan";
                }, a.prototype.fourth = function() {
                  return "četrti";
                }, a.prototype.minutesX0ThroughX1PastTheHour = function() {
                  return "minute od %s do %s";
                }, a.prototype.second = function() {
                  return "drugi";
                }, a.prototype.secondsX0ThroughX1PastTheMinute = function() {
                  return "sekunde od %s do %s";
                }, a.prototype.spaceAnd = function() {
                  return " in";
                }, a.prototype.spaceX0OfTheMonth = function() {
                  return " %s v mesecu";
                }, a.prototype.lastDay = function() {
                  return "zadnjič";
                }, a.prototype.third = function() {
                  return "tretji";
                }, a.prototype.weekdayNearestDayX0 = function() {
                  return "delovni dan, najbližji %s. dnevu";
                }, a.prototype.commaMonthX0ThroughMonthX1 = function() {
                  return null;
                }, a.prototype.commaYearX0ThroughYearX1 = function() {
                  return null;
                }, a.prototype.atX0MinutesPastTheHourGt20 = function() {
                  return null;
                }, a.prototype.atX0SecondsPastTheMinuteGt20 = function() {
                  return null;
                }, a.prototype.commaStartingX0 = function() {
                  return ", začenši %s";
                }, a.prototype.daysOfTheWeek = function() {
                  return ["Nedelja", "Ponedeljek", "Torek", "Sreda", "Četrtek", "Petek", "Sobota"];
                }, a.prototype.monthsOfTheYear = function() {
                  return [
                    "januar",
                    "februar",
                    "marec",
                    "april",
                    "maj",
                    "junij",
                    "julij",
                    "avgust",
                    "september",
                    "oktober",
                    "november",
                    "december"
                  ];
                }, a;
              }();
              u.sl = l;
            }
          ),
          /***/
          716: (
            /***/
            (i, u) => {
              Object.defineProperty(u, "__esModule", { value: !0 }), u.sr = void 0;
              var l = function() {
                function a() {
                }
                return a.prototype.use24HourTimeFormatByDefault = function() {
                  return !0;
                }, a.prototype.anErrorOccuredWhenGeneratingTheExpressionD = function() {
                  return "Došlo je do greške pri generisanju izraza. Proverite sintaksu cron izraza.";
                }, a.prototype.at = function() {
                  return "U";
                }, a.prototype.atSpace = function() {
                  return "U ";
                }, a.prototype.atX0 = function() {
                  return "u %s";
                }, a.prototype.atX0MinutesPastTheHour = function() {
                  return "u %s minuta posle punog sata";
                }, a.prototype.atX0SecondsPastTheMinute = function() {
                  return "u %s sekundi posle pune minute";
                }, a.prototype.betweenX0AndX1 = function() {
                  return "između %s i %s";
                }, a.prototype.commaBetweenDayX0AndX1OfTheMonth = function() {
                  return ", između %s. i %s. dana u mesecu";
                }, a.prototype.commaEveryDay = function() {
                  return ", svaki dan";
                }, a.prototype.commaEveryX0Days = function() {
                  return ", svakih %s dana";
                }, a.prototype.commaEveryX0DaysOfTheWeek = function() {
                  return ", svakih %s dana u nedelji";
                }, a.prototype.commaEveryX0Months = function() {
                  return ", svakih %s meseci";
                }, a.prototype.commaEveryX0Years = function() {
                  return ", svakih %s godina";
                }, a.prototype.commaOnDayX0OfTheMonth = function() {
                  return ", %s. dan u mesecu";
                }, a.prototype.commaOnlyInX0 = function() {
                  return ", samo u %s";
                }, a.prototype.commaOnlyOnX0 = function() {
                  return ", samo %s";
                }, a.prototype.commaAndOnX0 = function() {
                  return ", i %s";
                }, a.prototype.commaOnThe = function() {
                  return ", ";
                }, a.prototype.commaOnTheLastDayOfTheMonth = function() {
                  return ", poslednjeg dana u mesecu";
                }, a.prototype.commaOnTheLastWeekdayOfTheMonth = function() {
                  return ", poslednjeg radnog dana u mesecu";
                }, a.prototype.commaDaysBeforeTheLastDayOfTheMonth = function() {
                  return ", %s dana pre kraja meseca";
                }, a.prototype.commaOnTheLastX0OfTheMonth = function() {
                  return ", poslednji %s u mesecu";
                }, a.prototype.commaOnTheX0OfTheMonth = function() {
                  return ", %s u mesecu";
                }, a.prototype.commaX0ThroughX1 = function() {
                  return ", od %s do %s";
                }, a.prototype.commaAndX0ThroughX1 = function() {
                  return ", i od %s do %s";
                }, a.prototype.everyHour = function() {
                  return "svaki sat";
                }, a.prototype.everyMinute = function() {
                  return "svakog minuta";
                }, a.prototype.everyMinuteBetweenX0AndX1 = function() {
                  return "Svakog minuta između %s i %s";
                }, a.prototype.everySecond = function() {
                  return "svake sekunde";
                }, a.prototype.everyX0Hours = function() {
                  return "svakih %s sati";
                }, a.prototype.everyX0Minutes = function() {
                  return "svakih %s minuta";
                }, a.prototype.everyX0Seconds = function() {
                  return "svakih %s sekundi";
                }, a.prototype.fifth = function() {
                  return "peti";
                }, a.prototype.first = function() {
                  return "prvi";
                }, a.prototype.firstWeekday = function() {
                  return "prvi radni dan";
                }, a.prototype.fourth = function() {
                  return "četvrti";
                }, a.prototype.minutesX0ThroughX1PastTheHour = function() {
                  return "minute od %s do %s posle punog sata";
                }, a.prototype.second = function() {
                  return "drugi";
                }, a.prototype.secondsX0ThroughX1PastTheMinute = function() {
                  return "sekunde od %s do %s posle pune minute";
                }, a.prototype.spaceAnd = function() {
                  return " i";
                }, a.prototype.spaceX0OfTheMonth = function() {
                  return " %s u mesecu";
                }, a.prototype.lastDay = function() {
                  return "poslednji dan";
                }, a.prototype.third = function() {
                  return "treći";
                }, a.prototype.weekdayNearestDayX0 = function() {
                  return "radni dan najbliži %s. danu";
                }, a.prototype.commaMonthX0ThroughMonthX1 = function() {
                  return null;
                }, a.prototype.commaYearX0ThroughYearX1 = function() {
                  return null;
                }, a.prototype.atX0MinutesPastTheHourGt20 = function() {
                  return null;
                }, a.prototype.atX0SecondsPastTheMinuteGt20 = function() {
                  return null;
                }, a.prototype.commaStartingX0 = function() {
                  return ", počevši od %s";
                }, a.prototype.daysOfTheWeek = function() {
                  return [
                    "Nedelja",
                    "Ponedeljak",
                    "Utorak",
                    "Sreda",
                    "Četvrtak",
                    "Petak",
                    "Subota"
                  ];
                }, a.prototype.monthsOfTheYear = function() {
                  return [
                    "januar",
                    "februar",
                    "mart",
                    "april",
                    "maj",
                    "jun",
                    "jul",
                    "avgust",
                    "septembar",
                    "oktobar",
                    "novembar",
                    "decembar"
                  ];
                }, a;
              }();
              u.sr = l;
            }
          ),
          /***/
          544: (
            /***/
            (i, u) => {
              Object.defineProperty(u, "__esModule", { value: !0 }), u.sv = void 0;
              var l = function() {
                function a() {
                }
                return a.prototype.atX0SecondsPastTheMinuteGt20 = function() {
                  return null;
                }, a.prototype.atX0MinutesPastTheHourGt20 = function() {
                  return null;
                }, a.prototype.commaMonthX0ThroughMonthX1 = function() {
                  return null;
                }, a.prototype.commaYearX0ThroughYearX1 = function() {
                  return null;
                }, a.prototype.use24HourTimeFormatByDefault = function() {
                  return !0;
                }, a.prototype.anErrorOccuredWhenGeneratingTheExpressionD = function() {
                  return "Ett fel inträffade vid generering av uttryckets beskrivning. Kontrollera cron-uttryckets syntax.";
                }, a.prototype.everyMinute = function() {
                  return "varje minut";
                }, a.prototype.everyHour = function() {
                  return "varje timme";
                }, a.prototype.atSpace = function() {
                  return "Kl ";
                }, a.prototype.everyMinuteBetweenX0AndX1 = function() {
                  return "Varje minut mellan %s och %s";
                }, a.prototype.at = function() {
                  return "Kl";
                }, a.prototype.spaceAnd = function() {
                  return " och";
                }, a.prototype.everySecond = function() {
                  return "varje sekund";
                }, a.prototype.everyX0Seconds = function() {
                  return "varje %s sekund";
                }, a.prototype.secondsX0ThroughX1PastTheMinute = function() {
                  return "sekunderna från %s till och med %s efter minuten";
                }, a.prototype.atX0SecondsPastTheMinute = function() {
                  return "på %s sekunder efter minuten";
                }, a.prototype.everyX0Minutes = function() {
                  return "var %s minut";
                }, a.prototype.minutesX0ThroughX1PastTheHour = function() {
                  return "minuterna från %s till och med %s efter timmen";
                }, a.prototype.atX0MinutesPastTheHour = function() {
                  return "på %s minuten efter timmen";
                }, a.prototype.everyX0Hours = function() {
                  return "var %s timme";
                }, a.prototype.betweenX0AndX1 = function() {
                  return "mellan %s och %s";
                }, a.prototype.atX0 = function() {
                  return "kl %s";
                }, a.prototype.commaEveryDay = function() {
                  return ", varje dag";
                }, a.prototype.commaEveryX0DaysOfTheWeek = function() {
                  return ", var %s dag i veckan";
                }, a.prototype.commaX0ThroughX1 = function() {
                  return ", %s till %s";
                }, a.prototype.commaAndX0ThroughX1 = function() {
                  return ", och %s till %s";
                }, a.prototype.first = function() {
                  return "första";
                }, a.prototype.second = function() {
                  return "andra";
                }, a.prototype.third = function() {
                  return "tredje";
                }, a.prototype.fourth = function() {
                  return "fjärde";
                }, a.prototype.fifth = function() {
                  return "femte";
                }, a.prototype.commaOnThe = function() {
                  return ", den ";
                }, a.prototype.spaceX0OfTheMonth = function() {
                  return " %sen av månaden";
                }, a.prototype.lastDay = function() {
                  return "den sista dagen";
                }, a.prototype.commaOnTheLastX0OfTheMonth = function() {
                  return ", på sista %s av månaden";
                }, a.prototype.commaOnlyOnX0 = function() {
                  return ", varje %s";
                }, a.prototype.commaAndOnX0 = function() {
                  return ", och på %s";
                }, a.prototype.commaEveryX0Months = function() {
                  return ", var %s månad";
                }, a.prototype.commaOnlyInX0 = function() {
                  return ", bara på %s";
                }, a.prototype.commaOnTheLastDayOfTheMonth = function() {
                  return ", på sista dagen av månaden";
                }, a.prototype.commaOnTheLastWeekdayOfTheMonth = function() {
                  return ", på sista veckodag av månaden";
                }, a.prototype.commaDaysBeforeTheLastDayOfTheMonth = function() {
                  return ", %s dagar före den sista dagen i månaden";
                }, a.prototype.firstWeekday = function() {
                  return "första veckodag";
                }, a.prototype.weekdayNearestDayX0 = function() {
                  return "veckodagen närmast dag %s";
                }, a.prototype.commaOnTheX0OfTheMonth = function() {
                  return ", på den %s av månaden";
                }, a.prototype.commaEveryX0Days = function() {
                  return ", var %s dag";
                }, a.prototype.commaBetweenDayX0AndX1OfTheMonth = function() {
                  return ", mellan dag %s och %s av månaden";
                }, a.prototype.commaOnDayX0OfTheMonth = function() {
                  return ", på dag %s av månaden";
                }, a.prototype.commaEveryX0Years = function() {
                  return ", var %s år";
                }, a.prototype.commaStartingX0 = function() {
                  return ", startar %s";
                }, a.prototype.daysOfTheWeek = function() {
                  return ["söndag", "måndag", "tisdag", "onsdag", "torsdag", "fredag", "lördag"];
                }, a.prototype.monthsOfTheYear = function() {
                  return [
                    "januari",
                    "februari",
                    "mars",
                    "april",
                    "maj",
                    "juni",
                    "juli",
                    "augusti",
                    "september",
                    "oktober",
                    "november",
                    "december"
                  ];
                }, a;
              }();
              u.sv = l;
            }
          ),
          /***/
          799: (
            /***/
            (i, u) => {
              Object.defineProperty(u, "__esModule", { value: !0 }), u.sw = void 0;
              var l = function() {
                function a() {
                }
                return a.prototype.atX0SecondsPastTheMinuteGt20 = function() {
                  return null;
                }, a.prototype.atX0MinutesPastTheHourGt20 = function() {
                  return null;
                }, a.prototype.commaMonthX0ThroughMonthX1 = function() {
                  return null;
                }, a.prototype.commaYearX0ThroughYearX1 = function() {
                  return null;
                }, a.prototype.use24HourTimeFormatByDefault = function() {
                  return !0;
                }, a.prototype.anErrorOccuredWhenGeneratingTheExpressionD = function() {
                  return "Kuna tatizo wakati wa kutunga msemo. Angalia cron expression syntax.";
                }, a.prototype.everyMinute = function() {
                  return "kila dakika";
                }, a.prototype.everyHour = function() {
                  return "kila saa";
                }, a.prototype.atSpace = function() {
                  return "Kwa ";
                }, a.prototype.everyMinuteBetweenX0AndX1 = function() {
                  return "Kila dakika kwanzia %s hadi %s";
                }, a.prototype.at = function() {
                  return "Kwa";
                }, a.prototype.spaceAnd = function() {
                  return " na";
                }, a.prototype.everySecond = function() {
                  return "kila sekunde";
                }, a.prototype.everyX0Seconds = function() {
                  return "kila sekunde %s";
                }, a.prototype.secondsX0ThroughX1PastTheMinute = function() {
                  return "sekunde ya %s hadi %s baada ya dakika";
                }, a.prototype.atX0SecondsPastTheMinute = function() {
                  return "sekunde %s baada ya dakika";
                }, a.prototype.everyX0Minutes = function() {
                  return "kila dakika %s";
                }, a.prototype.minutesX0ThroughX1PastTheHour = function() {
                  return "minutes %s through %s past the hour";
                }, a.prototype.atX0MinutesPastTheHour = function() {
                  return "at %s minutes past the hour";
                }, a.prototype.everyX0Hours = function() {
                  return "every %s hours";
                }, a.prototype.betweenX0AndX1 = function() {
                  return "kati ya %s na %s";
                }, a.prototype.atX0 = function() {
                  return "kwenye %s";
                }, a.prototype.commaEveryDay = function() {
                  return ", kila siku";
                }, a.prototype.commaEveryX0DaysOfTheWeek = function() {
                  return ", kila siku %s ya wiki";
                }, a.prototype.commaX0ThroughX1 = function() {
                  return ", %s hadi %s";
                }, a.prototype.commaAndX0ThroughX1 = function() {
                  return ", na %s hadi %s";
                }, a.prototype.first = function() {
                  return "ya kwanza";
                }, a.prototype.second = function() {
                  return "ya pili";
                }, a.prototype.third = function() {
                  return "ya tatu";
                }, a.prototype.fourth = function() {
                  return "ya nne";
                }, a.prototype.fifth = function() {
                  return "ya tano";
                }, a.prototype.commaOnThe = function() {
                  return ", kwenye ";
                }, a.prototype.spaceX0OfTheMonth = function() {
                  return " siku %s ya mwezi";
                }, a.prototype.lastDay = function() {
                  return "siku ya mwisho";
                }, a.prototype.commaOnTheLastX0OfTheMonth = function() {
                  return ", siku ya %s ya mwezi";
                }, a.prototype.commaOnlyOnX0 = function() {
                  return ", kwa %s tu";
                }, a.prototype.commaAndOnX0 = function() {
                  return ", na pia %s";
                }, a.prototype.commaEveryX0Months = function() {
                  return ", kila mwezi wa %s";
                }, a.prototype.commaOnlyInX0 = function() {
                  return ", kwa %s tu";
                }, a.prototype.commaOnTheLastDayOfTheMonth = function() {
                  return ", siku ya mwisho wa mwezi";
                }, a.prototype.commaOnTheLastWeekdayOfTheMonth = function() {
                  return ", wikendi ya mwisho wa mwezi";
                }, a.prototype.commaDaysBeforeTheLastDayOfTheMonth = function() {
                  return ", siku ya %s kabla ya siku ya mwisho wa mwezi";
                }, a.prototype.firstWeekday = function() {
                  return "siku za kazi ya kwanza";
                }, a.prototype.weekdayNearestDayX0 = function() {
                  return "siku ya kazi karibu na siku ya %s";
                }, a.prototype.commaOnTheX0OfTheMonth = function() {
                  return ", siku ya %s ya mwezi";
                }, a.prototype.commaEveryX0Days = function() {
                  return ", kila siku %s";
                }, a.prototype.commaBetweenDayX0AndX1OfTheMonth = function() {
                  return ", kati ya siku %s na %s ya mwezi";
                }, a.prototype.commaOnDayX0OfTheMonth = function() {
                  return ", siku ya %s ya mwezi";
                }, a.prototype.commaEveryX0Years = function() {
                  return ", kila miaka %s";
                }, a.prototype.commaStartingX0 = function() {
                  return ", kwanzia %s";
                }, a.prototype.daysOfTheWeek = function() {
                  return ["Jumapili", "Jumatatu", "Jumanne", "Jumatano", "Alhamisi", "Ijumaa", "Jumamosi"];
                }, a.prototype.monthsOfTheYear = function() {
                  return [
                    "Januari",
                    "Februari",
                    "Machi",
                    "Aprili",
                    "Mei",
                    "Juni",
                    "Julai",
                    "Agosti",
                    "Septemba",
                    "Oktoba",
                    "Novemba",
                    "Desemba"
                  ];
                }, a;
              }();
              u.sw = l;
            }
          ),
          /***/
          33: (
            /***/
            (i, u) => {
              Object.defineProperty(u, "__esModule", { value: !0 }), u.th = void 0;
              var l = function() {
                function a() {
                }
                return a.prototype.atX0SecondsPastTheMinuteGt20 = function() {
                  return null;
                }, a.prototype.atX0MinutesPastTheHourGt20 = function() {
                  return null;
                }, a.prototype.commaMonthX0ThroughMonthX1 = function() {
                  return null;
                }, a.prototype.commaYearX0ThroughYearX1 = function() {
                  return null;
                }, a.prototype.use24HourTimeFormatByDefault = function() {
                  return !1;
                }, a.prototype.anErrorOccuredWhenGeneratingTheExpressionD = function() {
                  return "เกิดข้อผิดพลาดขณะสร้างคำอธิบายนิพจน์ ตรวจสอบไวยากรณ์นิพจน์ครอน";
                }, a.prototype.everyMinute = function() {
                  return "ทุกๆ นาที";
                }, a.prototype.everyHour = function() {
                  return "ทุกๆ ชั่วโมง";
                }, a.prototype.atSpace = function() {
                  return "เมื่อ ";
                }, a.prototype.everyMinuteBetweenX0AndX1 = function() {
                  return "ทุกๆ นาที %s และ %s";
                }, a.prototype.at = function() {
                  return "เมื่อ";
                }, a.prototype.spaceAnd = function() {
                  return " และ";
                }, a.prototype.everySecond = function() {
                  return "ทุกๆ วินาที";
                }, a.prototype.everyX0Seconds = function() {
                  return "ทุกๆ %s วินาที";
                }, a.prototype.secondsX0ThroughX1PastTheMinute = function() {
                  return "วินาที %s ถึง %s นาทีที่ผ่านมา";
                }, a.prototype.atX0SecondsPastTheMinute = function() {
                  return "เมื่อ %s วินาที นาทีที่ผ่านมา";
                }, a.prototype.everyX0Minutes = function() {
                  return "ทุกๆ %s นาที";
                }, a.prototype.minutesX0ThroughX1PastTheHour = function() {
                  return "นาที %s ถึง %s ชั่วโมงที่ผ่านมา";
                }, a.prototype.atX0MinutesPastTheHour = function() {
                  return "เมื่อ %s นาที ชั่วโมงที่ผ่านมา";
                }, a.prototype.everyX0Hours = function() {
                  return "ทุกๆ %s ชั่วโมง";
                }, a.prototype.betweenX0AndX1 = function() {
                  return "ระหว่าง %s ถึง %s";
                }, a.prototype.atX0 = function() {
                  return "เมื่อ %s";
                }, a.prototype.commaEveryDay = function() {
                  return ", ทุกๆ วัน";
                }, a.prototype.commaEveryX0DaysOfTheWeek = function() {
                  return ", ทุกๆ %s วันของสัปดาห์";
                }, a.prototype.commaX0ThroughX1 = function() {
                  return ", %s ถึง %s";
                }, a.prototype.commaAndX0ThroughX1 = function() {
                  return ", %s ถึง %s";
                }, a.prototype.first = function() {
                  return "แรก";
                }, a.prototype.second = function() {
                  return "ที่สอง";
                }, a.prototype.third = function() {
                  return "ที่สาม";
                }, a.prototype.fourth = function() {
                  return "ที่สี่";
                }, a.prototype.fifth = function() {
                  return "ที่ห้า";
                }, a.prototype.commaOnThe = function() {
                  return ", ในวัน ";
                }, a.prototype.spaceX0OfTheMonth = function() {
                  return " %s ของเดือน";
                }, a.prototype.lastDay = function() {
                  return "วันสุดท้าย";
                }, a.prototype.commaOnTheLastX0OfTheMonth = function() {
                  return ", ณ สุดท้าย %s ของเดือน";
                }, a.prototype.commaOnlyOnX0 = function() {
                  return ", เท่านั้น %s";
                }, a.prototype.commaAndOnX0 = function() {
                  return ", และใน %s";
                }, a.prototype.commaEveryX0Months = function() {
                  return ", ทุกๆ %s เดือน";
                }, a.prototype.commaOnlyInX0 = function() {
                  return ", เท่านั้น %s";
                }, a.prototype.commaOnTheLastDayOfTheMonth = function() {
                  return ", ในวันสิ้นเดือน";
                }, a.prototype.commaOnTheLastWeekdayOfTheMonth = function() {
                  return ", ในวันธรรมดาสุดท้ายของเดือน";
                }, a.prototype.commaDaysBeforeTheLastDayOfTheMonth = function() {
                  return ", %s วันก่อนวันสุดท้ายของเดือน";
                }, a.prototype.firstWeekday = function() {
                  return "วันธรรมดาวันแรก";
                }, a.prototype.weekdayNearestDayX0 = function() {
                  return "วันธรรมดาที่ใกล้ที่สุด %s";
                }, a.prototype.commaOnTheX0OfTheMonth = function() {
                  return ", ในวัน %s ของเดือน";
                }, a.prototype.commaEveryX0Days = function() {
                  return ", ทุกๆ %s วัน";
                }, a.prototype.commaBetweenDayX0AndX1OfTheMonth = function() {
                  return ", ระหว่างวัน %s และ %s ของเดือน";
                }, a.prototype.commaOnDayX0OfTheMonth = function() {
                  return ", ในวัน %s ของเดือน";
                }, a.prototype.commaEveryHour = function() {
                  return ", ทุกๆ ชั่วโมง";
                }, a.prototype.commaEveryX0Years = function() {
                  return ", ทุกๆ %s ปี";
                }, a.prototype.commaStartingX0 = function() {
                  return ", เริ่ม %s";
                }, a.prototype.daysOfTheWeek = function() {
                  return ["วันอาทิตย์", "วันจันทร์", "วันอังคาร", "วันพุธ", "วันพฤหัสบดี", "วันศุกร์", "วันเสาร์"];
                }, a.prototype.monthsOfTheYear = function() {
                  return [
                    "มกราคม",
                    "กุมภาพันธ์",
                    "มีนาคม",
                    "เมษายน",
                    "พฤษภาคม",
                    "มิถุนายน",
                    "กรกฎาคม",
                    "สิงหาคม",
                    "กันยายน",
                    "ตุลาคม",
                    "พฤศจิกายน",
                    "ธันวาคม"
                  ];
                }, a;
              }();
              u.th = l;
            }
          ),
          /***/
          631: (
            /***/
            (i, u) => {
              Object.defineProperty(u, "__esModule", { value: !0 }), u.tr = void 0;
              var l = function() {
                function a() {
                }
                return a.prototype.atX0SecondsPastTheMinuteGt20 = function() {
                  return null;
                }, a.prototype.atX0MinutesPastTheHourGt20 = function() {
                  return null;
                }, a.prototype.commaMonthX0ThroughMonthX1 = function() {
                  return null;
                }, a.prototype.commaYearX0ThroughYearX1 = function() {
                  return null;
                }, a.prototype.use24HourTimeFormatByDefault = function() {
                  return !0;
                }, a.prototype.everyMinute = function() {
                  return "her dakika";
                }, a.prototype.everyHour = function() {
                  return "her saat";
                }, a.prototype.anErrorOccuredWhenGeneratingTheExpressionD = function() {
                  return "İfade açıklamasını oluştururken bir hata oluştu. Cron ifadesini gözden geçirin.";
                }, a.prototype.atSpace = function() {
                  return "Saat ";
                }, a.prototype.everyMinuteBetweenX0AndX1 = function() {
                  return "Saat %s ve %s arasındaki her dakika";
                }, a.prototype.at = function() {
                  return "Saat";
                }, a.prototype.spaceAnd = function() {
                  return " ve";
                }, a.prototype.everySecond = function() {
                  return "her saniye";
                }, a.prototype.everyX0Seconds = function() {
                  return "her %s saniyede bir";
                }, a.prototype.secondsX0ThroughX1PastTheMinute = function() {
                  return "dakikaların %s. ve %s. saniyeleri arası";
                }, a.prototype.atX0SecondsPastTheMinute = function() {
                  return "dakikaların %s. saniyesinde";
                }, a.prototype.everyX0Minutes = function() {
                  return "her %s dakikada bir";
                }, a.prototype.minutesX0ThroughX1PastTheHour = function() {
                  return "saatlerin %s. ve %s. dakikaları arası";
                }, a.prototype.atX0MinutesPastTheHour = function() {
                  return "saatlerin %s. dakikasında";
                }, a.prototype.everyX0Hours = function() {
                  return "her %s saatte";
                }, a.prototype.betweenX0AndX1 = function() {
                  return "%s ile %s arasında";
                }, a.prototype.atX0 = function() {
                  return "saat %s";
                }, a.prototype.commaEveryDay = function() {
                  return ", her gün";
                }, a.prototype.commaEveryX0DaysOfTheWeek = function() {
                  return ", ayın her %s günü";
                }, a.prototype.commaX0ThroughX1 = function() {
                  return ", %s ile %s arasında";
                }, a.prototype.commaAndX0ThroughX1 = function() {
                  return ", ve %s ile %s arasında";
                }, a.prototype.first = function() {
                  return "ilk";
                }, a.prototype.second = function() {
                  return "ikinci";
                }, a.prototype.third = function() {
                  return "üçüncü";
                }, a.prototype.fourth = function() {
                  return "dördüncü";
                }, a.prototype.fifth = function() {
                  return "beşinci";
                }, a.prototype.commaOnThe = function() {
                  return ", ayın ";
                }, a.prototype.spaceX0OfTheMonth = function() {
                  return " %s günü";
                }, a.prototype.lastDay = function() {
                  return "son gün";
                }, a.prototype.commaOnTheLastX0OfTheMonth = function() {
                  return ", ayın son %s günü";
                }, a.prototype.commaOnlyOnX0 = function() {
                  return ", sadece %s günü";
                }, a.prototype.commaAndOnX0 = function() {
                  return ", ve %s";
                }, a.prototype.commaEveryX0Months = function() {
                  return ", %s ayda bir";
                }, a.prototype.commaOnlyInX0 = function() {
                  return ", sadece %s için";
                }, a.prototype.commaOnTheLastDayOfTheMonth = function() {
                  return ", ayın son günü";
                }, a.prototype.commaOnTheLastWeekdayOfTheMonth = function() {
                  return ", ayın son iş günü";
                }, a.prototype.commaDaysBeforeTheLastDayOfTheMonth = function() {
                  return ", %s ayın son gününden önceki günler";
                }, a.prototype.firstWeekday = function() {
                  return "ilk iş günü";
                }, a.prototype.weekdayNearestDayX0 = function() {
                  return "%s. günü sonrasındaki ilk iş günü";
                }, a.prototype.commaOnTheX0OfTheMonth = function() {
                  return ", ayın %s";
                }, a.prototype.commaEveryX0Days = function() {
                  return ", %s günde bir";
                }, a.prototype.commaBetweenDayX0AndX1OfTheMonth = function() {
                  return ", ayın %s. ve %s. günleri arası";
                }, a.prototype.commaOnDayX0OfTheMonth = function() {
                  return ", ayın %s. günü";
                }, a.prototype.commaEveryX0Years = function() {
                  return ", %s yılda bir";
                }, a.prototype.commaStartingX0 = function() {
                  return ", başlangıç %s";
                }, a.prototype.daysOfTheWeek = function() {
                  return ["Pazar", "Pazartesi", "Salı", "Çarşamba", "Perşembe", "Cuma", "Cumartesi"];
                }, a.prototype.monthsOfTheYear = function() {
                  return [
                    "Ocak",
                    "Şubat",
                    "Mart",
                    "Nisan",
                    "Mayıs",
                    "Haziran",
                    "Temmuz",
                    "Ağustos",
                    "Eylül",
                    "Ekim",
                    "Kasım",
                    "Aralık"
                  ];
                }, a;
              }();
              u.tr = l;
            }
          ),
          /***/
          225: (
            /***/
            (i, u) => {
              Object.defineProperty(u, "__esModule", { value: !0 }), u.uk = void 0;
              var l = function() {
                function a() {
                }
                return a.prototype.atX0SecondsPastTheMinuteGt20 = function() {
                  return null;
                }, a.prototype.atX0MinutesPastTheHourGt20 = function() {
                  return null;
                }, a.prototype.commaMonthX0ThroughMonthX1 = function() {
                  return null;
                }, a.prototype.commaYearX0ThroughYearX1 = function() {
                  return null;
                }, a.prototype.use24HourTimeFormatByDefault = function() {
                  return !0;
                }, a.prototype.everyMinute = function() {
                  return "щохвилини";
                }, a.prototype.everyHour = function() {
                  return "щогодини";
                }, a.prototype.anErrorOccuredWhenGeneratingTheExpressionD = function() {
                  return "ВІдбулася помилка підчас генерації опису. Перевірта правильність написання cron виразу.";
                }, a.prototype.atSpace = function() {
                  return "О ";
                }, a.prototype.everyMinuteBetweenX0AndX1 = function() {
                  return "Щохвилини між %s та %s";
                }, a.prototype.at = function() {
                  return "О";
                }, a.prototype.spaceAnd = function() {
                  return " та";
                }, a.prototype.everySecond = function() {
                  return "Щосекунди";
                }, a.prototype.everyX0Seconds = function() {
                  return "кожні %s секунд";
                }, a.prototype.secondsX0ThroughX1PastTheMinute = function() {
                  return "з %s по %s секунду";
                }, a.prototype.atX0SecondsPastTheMinute = function() {
                  return "о %s секунді";
                }, a.prototype.everyX0Minutes = function() {
                  return "кожні %s хвилин";
                }, a.prototype.minutesX0ThroughX1PastTheHour = function() {
                  return "з %s по %s хвилину";
                }, a.prototype.atX0MinutesPastTheHour = function() {
                  return "о %s хвилині";
                }, a.prototype.everyX0Hours = function() {
                  return "кожні %s годин";
                }, a.prototype.betweenX0AndX1 = function() {
                  return "між %s та %s";
                }, a.prototype.atX0 = function() {
                  return "о %s";
                }, a.prototype.commaEveryDay = function() {
                  return ", щоденно";
                }, a.prototype.commaEveryX0DaysOfTheWeek = function() {
                  return ", кожен %s день тижня";
                }, a.prototype.commaX0ThroughX1 = function() {
                  return ", %s по %s";
                }, a.prototype.commaAndX0ThroughX1 = function() {
                  return ", та %s по %s";
                }, a.prototype.first = function() {
                  return "перший";
                }, a.prototype.second = function() {
                  return "другий";
                }, a.prototype.third = function() {
                  return "третій";
                }, a.prototype.fourth = function() {
                  return "четвертий";
                }, a.prototype.fifth = function() {
                  return "п'ятий";
                }, a.prototype.commaOnThe = function() {
                  return ", в ";
                }, a.prototype.spaceX0OfTheMonth = function() {
                  return " %s місяця";
                }, a.prototype.lastDay = function() {
                  return "останній день";
                }, a.prototype.commaOnTheLastX0OfTheMonth = function() {
                  return ", в останній %s місяця";
                }, a.prototype.commaOnlyOnX0 = function() {
                  return ", тільки в %s";
                }, a.prototype.commaAndOnX0 = function() {
                  return ", і в %s";
                }, a.prototype.commaEveryX0Months = function() {
                  return ", кожен %s місяць";
                }, a.prototype.commaOnlyInX0 = function() {
                  return ", тільки в %s";
                }, a.prototype.commaOnTheLastDayOfTheMonth = function() {
                  return ", в останній день місяця";
                }, a.prototype.commaOnTheLastWeekdayOfTheMonth = function() {
                  return ", в останній будень місяця";
                }, a.prototype.commaDaysBeforeTheLastDayOfTheMonth = function() {
                  return ", %s днів до останнього дня місяця";
                }, a.prototype.firstWeekday = function() {
                  return "перший будень";
                }, a.prototype.weekdayNearestDayX0 = function() {
                  return "будень найближчий до %s дня";
                }, a.prototype.commaOnTheX0OfTheMonth = function() {
                  return ", в %s місяця";
                }, a.prototype.commaEveryX0Days = function() {
                  return ", кожен %s день";
                }, a.prototype.commaBetweenDayX0AndX1OfTheMonth = function() {
                  return ", між %s та %s днями місяця";
                }, a.prototype.commaOnDayX0OfTheMonth = function() {
                  return ", на %s день місяця";
                }, a.prototype.commaEveryX0Years = function() {
                  return ", кожні %s роки";
                }, a.prototype.commaStartingX0 = function() {
                  return ", початок %s";
                }, a.prototype.daysOfTheWeek = function() {
                  return ["неділя", "понеділок", "вівторок", "середа", "четвер", "п'ятниця", "субота"];
                }, a.prototype.monthsOfTheYear = function() {
                  return [
                    "січень",
                    "лютий",
                    "березень",
                    "квітень",
                    "травень",
                    "червень",
                    "липень",
                    "серпень",
                    "вересень",
                    "жовтень",
                    "листопад",
                    "грудень"
                  ];
                }, a;
              }();
              u.uk = l;
            }
          ),
          /***/
          292: (
            /***/
            (i, u) => {
              Object.defineProperty(u, "__esModule", { value: !0 }), u.vi = void 0;
              var l = function() {
                function a() {
                }
                return a.prototype.atX0SecondsPastTheMinuteGt20 = function() {
                  return null;
                }, a.prototype.atX0MinutesPastTheHourGt20 = function() {
                  return null;
                }, a.prototype.commaMonthX0ThroughMonthX1 = function() {
                  return null;
                }, a.prototype.commaYearX0ThroughYearX1 = function() {
                  return null;
                }, a.prototype.use24HourTimeFormatByDefault = function() {
                  return !0;
                }, a.prototype.anErrorOccuredWhenGeneratingTheExpressionD = function() {
                  return "Đã xảy ra lỗi khi tạo mô tả biểu thức. Vui lòng kiểm tra cú pháp biểu thức cron.";
                }, a.prototype.everyMinute = function() {
                  return "mỗi phút";
                }, a.prototype.everyHour = function() {
                  return "mỗi giờ";
                }, a.prototype.atSpace = function() {
                  return "Vào ";
                }, a.prototype.everyMinuteBetweenX0AndX1 = function() {
                  return "Mỗi phút giữa %s and %s";
                }, a.prototype.at = function() {
                  return "Vào";
                }, a.prototype.spaceAnd = function() {
                  return " và";
                }, a.prototype.everySecond = function() {
                  return "mỗi giây";
                }, a.prototype.everyX0Seconds = function() {
                  return "mỗi %s giây";
                }, a.prototype.secondsX0ThroughX1PastTheMinute = function() {
                  return "giây thứ %s qua phút thứ %s";
                }, a.prototype.atX0SecondsPastTheMinute = function() {
                  return "tại giây thứ %s của mỗi phút";
                }, a.prototype.everyX0Minutes = function() {
                  return "mỗi %s phút";
                }, a.prototype.minutesX0ThroughX1PastTheHour = function() {
                  return "phút thứ %s qua %s tiếng";
                }, a.prototype.atX0MinutesPastTheHour = function() {
                  return "vào %s phút của mỗi tiếng";
                }, a.prototype.everyX0Hours = function() {
                  return "mỗi %s tiếng";
                }, a.prototype.betweenX0AndX1 = function() {
                  return "giữa %s và %s";
                }, a.prototype.atX0 = function() {
                  return "vào %s";
                }, a.prototype.commaEveryDay = function() {
                  return ", mỗi ngày";
                }, a.prototype.commaEveryX0DaysOfTheWeek = function() {
                  return ", mỗi %s ngày trong tuần";
                }, a.prototype.commaX0ThroughX1 = function() {
                  return ", %s đến %s";
                }, a.prototype.commaAndX0ThroughX1 = function() {
                  return ", %s đến %s";
                }, a.prototype.first = function() {
                  return "đầu tiên";
                }, a.prototype.second = function() {
                  return "thứ 2";
                }, a.prototype.third = function() {
                  return "thứ 3";
                }, a.prototype.fourth = function() {
                  return "thứ 4";
                }, a.prototype.fifth = function() {
                  return "thứ 5";
                }, a.prototype.commaOnThe = function() {
                  return ", trên ";
                }, a.prototype.spaceX0OfTheMonth = function() {
                  return " %s của tháng";
                }, a.prototype.lastDay = function() {
                  return "ngày cuối cùng";
                }, a.prototype.commaOnTheLastX0OfTheMonth = function() {
                  return ", vào ngày %s cuối cùng của tháng";
                }, a.prototype.commaOnlyOnX0 = function() {
                  return ", chỉ trên %s";
                }, a.prototype.commaAndOnX0 = function() {
                  return ", và hơn %s";
                }, a.prototype.commaEveryX0Months = function() {
                  return ", mỗi ngày %s tháng";
                }, a.prototype.commaOnlyInX0 = function() {
                  return ", chỉ trong %s";
                }, a.prototype.commaOnTheLastDayOfTheMonth = function() {
                  return ", vào ngày cuối cùng của tháng";
                }, a.prototype.commaOnTheLastWeekdayOfTheMonth = function() {
                  return ", vào ngày cuối tuần của tháng";
                }, a.prototype.commaDaysBeforeTheLastDayOfTheMonth = function() {
                  return ", %s ngày trước ngày cuối cùng của tháng";
                }, a.prototype.firstWeekday = function() {
                  return "ngày đầu tuần";
                }, a.prototype.weekdayNearestDayX0 = function() {
                  return "ngày trong tuần ngày gần nhất %s";
                }, a.prototype.commaOnTheX0OfTheMonth = function() {
                  return ", vào ngày %s của tháng";
                }, a.prototype.commaEveryX0Days = function() {
                  return ", mỗi %s ngày";
                }, a.prototype.commaBetweenDayX0AndX1OfTheMonth = function() {
                  return ", giữa ngày %s và %s trong tháng";
                }, a.prototype.commaOnDayX0OfTheMonth = function() {
                  return ", vào %s ngày trong tháng";
                }, a.prototype.commaEveryHour = function() {
                  return ", mỗi tiếng";
                }, a.prototype.commaEveryX0Years = function() {
                  return ", mỗi %s năm";
                }, a.prototype.commaStartingX0 = function() {
                  return ", bắt đầu %s";
                }, a.prototype.daysOfTheWeek = function() {
                  return ["Chủ nhật", "Thứ 2", "Thứ 3", "Thứ 4", "Thứ 5", "Thứ 6", "Thứ 7"];
                }, a.prototype.monthsOfTheYear = function() {
                  return [
                    "Tháng 1",
                    "Tháng 2",
                    "Tháng 3",
                    "Tháng 4",
                    "Tháng 5",
                    "Tháng 6",
                    "Tháng 7",
                    "Tháng 8",
                    "Tháng 9",
                    "Tháng 10",
                    "Tháng 11",
                    "Tháng 12"
                  ];
                }, a;
              }();
              u.vi = l;
            }
          ),
          /***/
          571: (
            /***/
            (i, u) => {
              Object.defineProperty(u, "__esModule", { value: !0 }), u.zh_CN = void 0;
              var l = function() {
                function a() {
                }
                return a.prototype.setPeriodBeforeTime = function() {
                  return !0;
                }, a.prototype.pm = function() {
                  return "下午";
                }, a.prototype.am = function() {
                  return "上午";
                }, a.prototype.atX0SecondsPastTheMinuteGt20 = function() {
                  return null;
                }, a.prototype.atX0MinutesPastTheHourGt20 = function() {
                  return null;
                }, a.prototype.commaMonthX0ThroughMonthX1 = function() {
                  return null;
                }, a.prototype.commaYearX0ThroughYearX1 = function() {
                  return ", 从%s年至%s年";
                }, a.prototype.use24HourTimeFormatByDefault = function() {
                  return !1;
                }, a.prototype.everyMinute = function() {
                  return "每分钟";
                }, a.prototype.everyHour = function() {
                  return "每小时";
                }, a.prototype.anErrorOccuredWhenGeneratingTheExpressionD = function() {
                  return "生成表达式描述时发生了错误，请检查cron表达式语法。";
                }, a.prototype.atSpace = function() {
                  return "在";
                }, a.prototype.everyMinuteBetweenX0AndX1 = function() {
                  return "在 %s 至 %s 之间的每分钟";
                }, a.prototype.at = function() {
                  return "在";
                }, a.prototype.spaceAnd = function() {
                  return " 和";
                }, a.prototype.everySecond = function() {
                  return "每秒";
                }, a.prototype.everyX0Seconds = function() {
                  return "每隔 %s 秒";
                }, a.prototype.secondsX0ThroughX1PastTheMinute = function() {
                  return "在一分钟后的第 %s 到 %s 秒";
                }, a.prototype.atX0SecondsPastTheMinute = function() {
                  return "在一分钟后的第 %s 秒";
                }, a.prototype.everyX0Minutes = function() {
                  return "每隔 %s 分钟";
                }, a.prototype.minutesX0ThroughX1PastTheHour = function() {
                  return "在整点后的第 %s 到 %s 分钟";
                }, a.prototype.atX0MinutesPastTheHour = function() {
                  return "在整点后的第 %s 分钟";
                }, a.prototype.everyX0Hours = function() {
                  return "每隔 %s 小时";
                }, a.prototype.betweenX0AndX1 = function() {
                  return "在 %s 和 %s 之间";
                }, a.prototype.atX0 = function() {
                  return "在%s";
                }, a.prototype.commaEveryDay = function() {
                  return ", 每天";
                }, a.prototype.commaEveryX0DaysOfTheWeek = function() {
                  return ", 每周的每 %s 天";
                }, a.prototype.commaX0ThroughX1 = function() {
                  return ", %s至%s";
                }, a.prototype.commaAndX0ThroughX1 = function() {
                  return ", 和%s至%s";
                }, a.prototype.first = function() {
                  return "第一个";
                }, a.prototype.second = function() {
                  return "第二个";
                }, a.prototype.third = function() {
                  return "第三个";
                }, a.prototype.fourth = function() {
                  return "第四个";
                }, a.prototype.fifth = function() {
                  return "第五个";
                }, a.prototype.commaOnThe = function() {
                  return ", 限每月的";
                }, a.prototype.spaceX0OfTheMonth = function() {
                  return "%s";
                }, a.prototype.lastDay = function() {
                  return "本月最后一天";
                }, a.prototype.commaOnTheLastX0OfTheMonth = function() {
                  return ", 限每月的最后一个%s";
                }, a.prototype.commaOnlyOnX0 = function() {
                  return ", 仅%s";
                }, a.prototype.commaAndOnX0 = function() {
                  return ", 或者为%s";
                }, a.prototype.commaEveryX0Months = function() {
                  return ", 每隔 %s 个月";
                }, a.prototype.commaOnlyInX0 = function() {
                  return ", 仅限%s";
                }, a.prototype.commaOnlyInMonthX0 = function() {
                  return ", 仅于%s份";
                }, a.prototype.commaOnlyInYearX0 = function() {
                  return ", 仅于 %s 年";
                }, a.prototype.commaOnTheLastDayOfTheMonth = function() {
                  return ", 限每月的最后一天";
                }, a.prototype.commaOnTheLastWeekdayOfTheMonth = function() {
                  return ", 限每月的最后一个工作日";
                }, a.prototype.commaDaysBeforeTheLastDayOfTheMonth = function() {
                  return ", 限每月最后%s天";
                }, a.prototype.firstWeekday = function() {
                  return "第一个工作日";
                }, a.prototype.weekdayNearestDayX0 = function() {
                  return "最接近 %s 号的工作日";
                }, a.prototype.commaOnTheX0OfTheMonth = function() {
                  return ", 限每月的%s";
                }, a.prototype.commaEveryX0Days = function() {
                  return ", 每隔 %s 天";
                }, a.prototype.commaBetweenDayX0AndX1OfTheMonth = function() {
                  return ", 限每月的 %s 至 %s 之间";
                }, a.prototype.commaOnDayX0OfTheMonth = function() {
                  return ", 限每月%s";
                }, a.prototype.commaEveryX0Years = function() {
                  return ", 每隔 %s 年";
                }, a.prototype.commaStartingX0 = function() {
                  return ", %s开始";
                }, a.prototype.dayX0 = function() {
                  return " %s 号";
                }, a.prototype.daysOfTheWeek = function() {
                  return ["星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六"];
                }, a.prototype.monthsOfTheYear = function() {
                  return ["一月", "二月", "三月", "四月", "五月", "六月", "七月", "八月", "九月", "十月", "十一月", "十二月"];
                }, a;
              }();
              u.zh_CN = l;
            }
          ),
          /***/
          983: (
            /***/
            (i, u) => {
              Object.defineProperty(u, "__esModule", { value: !0 }), u.zh_TW = void 0;
              var l = function() {
                function a() {
                }
                return a.prototype.atX0SecondsPastTheMinuteGt20 = function() {
                  return null;
                }, a.prototype.atX0MinutesPastTheHourGt20 = function() {
                  return null;
                }, a.prototype.commaMonthX0ThroughMonthX1 = function() {
                  return null;
                }, a.prototype.commaYearX0ThroughYearX1 = function() {
                  return ", 從 %s 年至 %s 年";
                }, a.prototype.use24HourTimeFormatByDefault = function() {
                  return !0;
                }, a.prototype.everyMinute = function() {
                  return "每分鐘";
                }, a.prototype.everyHour = function() {
                  return "每小時";
                }, a.prototype.anErrorOccuredWhenGeneratingTheExpressionD = function() {
                  return "產生表達式描述時發生了錯誤，請檢查 cron 表達式語法。";
                }, a.prototype.atSpace = function() {
                  return "在 ";
                }, a.prototype.everyMinuteBetweenX0AndX1 = function() {
                  return "在 %s 和 %s 之間的每分鐘";
                }, a.prototype.at = function() {
                  return "在";
                }, a.prototype.spaceAnd = function() {
                  return " 和";
                }, a.prototype.everySecond = function() {
                  return "每秒";
                }, a.prototype.everyX0Seconds = function() {
                  return "每 %s 秒";
                }, a.prototype.secondsX0ThroughX1PastTheMinute = function() {
                  return "在一分鐘後的 %s 到 %s 秒";
                }, a.prototype.atX0SecondsPastTheMinute = function() {
                  return "在一分鐘後的 %s 秒";
                }, a.prototype.everyX0Minutes = function() {
                  return "每 %s 分鐘";
                }, a.prototype.minutesX0ThroughX1PastTheHour = function() {
                  return "在整點後的 %s 到 %s 分鐘";
                }, a.prototype.atX0MinutesPastTheHour = function() {
                  return "在整點後的 %s 分";
                }, a.prototype.everyX0Hours = function() {
                  return "每 %s 小時";
                }, a.prototype.betweenX0AndX1 = function() {
                  return "在 %s 和 %s 之間";
                }, a.prototype.atX0 = function() {
                  return "在 %s";
                }, a.prototype.commaEveryDay = function() {
                  return ", 每天";
                }, a.prototype.commaEveryX0DaysOfTheWeek = function() {
                  return ", 每週的每 %s 天";
                }, a.prototype.commaX0ThroughX1 = function() {
                  return ", %s 到 %s";
                }, a.prototype.commaAndX0ThroughX1 = function() {
                  return ", 和 %s 到 %s";
                }, a.prototype.first = function() {
                  return "第一個";
                }, a.prototype.second = function() {
                  return "第二個";
                }, a.prototype.third = function() {
                  return "第三個";
                }, a.prototype.fourth = function() {
                  return "第四個";
                }, a.prototype.fifth = function() {
                  return "第五個";
                }, a.prototype.commaOnThe = function() {
                  return ", 在每月 ";
                }, a.prototype.spaceX0OfTheMonth = function() {
                  return "%s ";
                }, a.prototype.lastDay = function() {
                  return "最後一天";
                }, a.prototype.commaOnTheLastX0OfTheMonth = function() {
                  return ", 每月的最後一個 %s ";
                }, a.prototype.commaOnlyOnX0 = function() {
                  return ", 僅在 %s";
                }, a.prototype.commaAndOnX0 = function() {
                  return ", 或 %s";
                }, a.prototype.commaEveryX0Months = function() {
                  return ", 每 %s 月";
                }, a.prototype.commaOnlyInX0 = function() {
                  return ", 僅在 %s";
                }, a.prototype.commaOnlyInMonthX0 = function() {
                  return ", 僅在 %s";
                }, a.prototype.commaOnlyInYearX0 = function() {
                  return ", 僅在 %s 年";
                }, a.prototype.commaOnTheLastDayOfTheMonth = function() {
                  return ", 每月的最後一天";
                }, a.prototype.commaOnTheLastWeekdayOfTheMonth = function() {
                  return ", 每月的最後一個工作日";
                }, a.prototype.commaDaysBeforeTheLastDayOfTheMonth = function() {
                  return ", %s 這個月的最後一天的前幾天";
                }, a.prototype.firstWeekday = function() {
                  return "第一個工作日";
                }, a.prototype.weekdayNearestDayX0 = function() {
                  return "最接近 %s 號的工作日";
                }, a.prototype.commaOnTheX0OfTheMonth = function() {
                  return ", 每月的 %s ";
                }, a.prototype.commaEveryX0Days = function() {
                  return ", 每 %s 天";
                }, a.prototype.commaBetweenDayX0AndX1OfTheMonth = function() {
                  return ", 在每月的 %s 和 %s 之間";
                }, a.prototype.commaOnDayX0OfTheMonth = function() {
                  return ", 每月的 %s";
                }, a.prototype.commaEveryX0Years = function() {
                  return ", 每 %s 年";
                }, a.prototype.commaStartingX0 = function() {
                  return ", %s 開始";
                }, a.prototype.dayX0 = function() {
                  return " %s 號";
                }, a.prototype.daysOfTheWeek = function() {
                  return ["星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六"];
                }, a.prototype.monthsOfTheYear = function() {
                  return ["一月", "二月", "三月", "四月", "五月", "六月", "七月", "八月", "九月", "十月", "十一月", "十二月"];
                }, a;
              }();
              u.zh_TW = l;
            }
          ),
          /***/
          515: (
            /***/
            (i, u) => {
              Object.defineProperty(u, "__esModule", { value: !0 });
              function l(c, p) {
                if (!c)
                  throw new Error(p);
              }
              var a = function() {
                function c() {
                }
                return c.secondRange = function(p) {
                  for (var d = p.split(","), h = 0; h < d.length; h++)
                    if (!isNaN(parseInt(d[h], 10))) {
                      var m = parseInt(d[h], 10);
                      l(m >= 0 && m <= 59, "seconds part must be >= 0 and <= 59");
                    }
                }, c.minuteRange = function(p) {
                  for (var d = p.split(","), h = 0; h < d.length; h++)
                    if (!isNaN(parseInt(d[h], 10))) {
                      var m = parseInt(d[h], 10);
                      l(m >= 0 && m <= 59, "minutes part must be >= 0 and <= 59");
                    }
                }, c.hourRange = function(p) {
                  for (var d = p.split(","), h = 0; h < d.length; h++)
                    if (!isNaN(parseInt(d[h], 10))) {
                      var m = parseInt(d[h], 10);
                      l(m >= 0 && m <= 23, "hours part must be >= 0 and <= 23");
                    }
                }, c.dayOfMonthRange = function(p) {
                  for (var d = p.split(","), h = 0; h < d.length; h++)
                    if (!isNaN(parseInt(d[h], 10))) {
                      var m = parseInt(d[h], 10);
                      l(m >= 1 && m <= 31, "DOM part must be >= 1 and <= 31");
                    }
                }, c.monthRange = function(p, d) {
                  for (var h = p.split(","), m = 0; m < h.length; m++)
                    if (!isNaN(parseInt(h[m], 10))) {
                      var g = parseInt(h[m], 10);
                      l(g >= 1 && g <= 12, d ? "month part must be >= 0 and <= 11" : "month part must be >= 1 and <= 12");
                    }
                }, c.dayOfWeekRange = function(p, d) {
                  for (var h = p.split(","), m = 0; m < h.length; m++)
                    if (!isNaN(parseInt(h[m], 10))) {
                      var g = parseInt(h[m], 10);
                      l(g >= 0 && g <= 6, d ? "DOW part must be >= 0 and <= 6" : "DOW part must be >= 1 and <= 7");
                    }
                }, c;
              }();
              u.default = a;
            }
          ),
          /***/
          823: (
            /***/
            (i, u) => {
              Object.defineProperty(u, "__esModule", { value: !0 }), u.StringUtilities = void 0;
              var l = function() {
                function a() {
                }
                return a.format = function(c) {
                  for (var p = [], d = 1; d < arguments.length; d++)
                    p[d - 1] = arguments[d];
                  return c.replace(/%s/g, function(h) {
                    return p.shift();
                  });
                }, a.containsAny = function(c, p) {
                  return p.some(function(d) {
                    return c.indexOf(d) > -1;
                  });
                }, a;
              }();
              u.StringUtilities = l;
            }
          )
          /******/
        }, r = {};
        function o(i) {
          var u = r[i];
          if (u !== void 0)
            return u.exports;
          var l = r[i] = {
            /******/
            // no module.id needed
            /******/
            // no module.loaded needed
            /******/
            exports: {}
            /******/
          };
          return n[i](l, l.exports, o), l.exports;
        }
        var s = {};
        return (() => {
          var i = s;
          Object.defineProperty(i, "__esModule", { value: !0 }), i.toString = void 0;
          var u = o(333), l = o(420);
          u.ExpressionDescriptor.initialize(new l.allLocalesLoader()), i.default = u.ExpressionDescriptor;
          var a = u.ExpressionDescriptor.toString;
          i.toString = a;
        })(), s;
      })()
    ));
  }(A1)), A1.exports;
}
var D1, TE;
function Tee() {
  if (TE) return D1;
  TE = 1;
  var t = kee();
  return D1 = t, D1;
}
var xee = Tee();
const See = /* @__PURE__ */ Nh(xee);
class Ree extends Error {
  constructor(e) {
    super(`Cron statement is too short. Expected >= 5, got ${e}`);
  }
}
var E1 = { exports: {} }, xE;
function Aee() {
  return xE || (xE = 1, function(t, e) {
    (function(r, o) {
      t.exports = o();
    })(globalThis, () => (
      /******/
      (() => {
        var n = {
          /***/
          949: (
            /***/
            (i, u, l) => {
              Object.defineProperty(u, "__esModule", { value: !0 }), u.CronParser = void 0;
              var a = l(515), c = function() {
                function p(d, h, m) {
                  h === void 0 && (h = !0), m === void 0 && (m = !1), this.expression = d, this.dayOfWeekStartIndexZero = h, this.monthStartIndexZero = m;
                }
                return p.prototype.parse = function() {
                  var d, h, m = (d = this.expression) !== null && d !== void 0 ? d : "";
                  if (m === "@reboot")
                    return h = ["@reboot", "", "", "", "", "", ""], h;
                  if (m.startsWith("@")) {
                    var g = this.parseSpecial(this.expression);
                    h = this.extractParts(g);
                  } else
                    h = this.extractParts(this.expression);
                  return this.normalize(h), this.validate(h), h;
                }, p.prototype.parseSpecial = function(d) {
                  var h = {
                    "@yearly": "0 0 1 1 *",
                    "@annually": "0 0 1 1 *",
                    "@monthly": "0 0 1 * *",
                    "@weekly": "0 0 * * 0",
                    "@daily": "0 0 * * *",
                    "@midnight": "0 0 * * *",
                    "@hourly": "0 * * * *",
                    "@reboot": "@reboot"
                  }, m = h[d];
                  if (!m)
                    throw new Error("Unknown special expression.");
                  return m;
                }, p.prototype.extractParts = function(d) {
                  if (!this.expression)
                    throw new Error("cron expression is empty");
                  for (var h = d.trim().split(/[ ]+/), m = 0; m < h.length; m++)
                    if (h[m].includes(",")) {
                      var g = h[m].split(",").map(function(b) {
                        return b.trim();
                      }).filter(function(b) {
                        return b !== "";
                      }).map(function(b) {
                        return isNaN(Number(b)) ? b : Number(b);
                      }).filter(function(b) {
                        return b !== null && b !== "";
                      });
                      g.length === 0 && g.push("*"), g.sort(function(b, x) {
                        return b !== null && x !== null ? b - x : 0;
                      }), h[m] = g.map(function(b) {
                        return b !== null ? b.toString() : "";
                      }).join(",");
                    }
                  if (h.length < 5)
                    throw new Error("Expression has only ".concat(h.length, " part").concat(h.length == 1 ? "" : "s", ". At least 5 parts are required."));
                  if (h.length == 5)
                    h.unshift(""), h.push("");
                  else if (h.length == 6) {
                    var _ = /\d{4}$/.test(h[5]) || h[4] == "?" || h[2] == "?";
                    _ ? h.unshift("") : h.push("");
                  } else if (h.length > 7)
                    throw new Error("Expression has ".concat(h.length, " parts; too many!"));
                  return h;
                }, p.prototype.normalize = function(d) {
                  var h = this;
                  if (d[3] = d[3].replace("?", "*"), d[5] = d[5].replace("?", "*"), d[2] = d[2].replace("?", "*"), d[0].indexOf("0/") == 0 && (d[0] = d[0].replace("0/", "*/")), d[1].indexOf("0/") == 0 && (d[1] = d[1].replace("0/", "*/")), d[2].indexOf("0/") == 0 && (d[2] = d[2].replace("0/", "*/")), d[3].indexOf("1/") == 0 && (d[3] = d[3].replace("1/", "*/")), d[4].indexOf("1/") == 0 && (d[4] = d[4].replace("1/", "*/")), d[6].indexOf("1/") == 0 && (d[6] = d[6].replace("1/", "*/")), d[5] = d[5].replace(/(^\d)|([^#/\s]\d)/g, function(A) {
                    var C = A.replace(/\D/, ""), M = C;
                    return h.dayOfWeekStartIndexZero ? C == "7" && (M = "0") : M = (parseInt(C) - 1).toString(), A.replace(C, M);
                  }), d[5] == "L" && (d[5] = "6"), d[3] == "?" && (d[3] = "*"), d[3].indexOf("W") > -1 && (d[3].indexOf(",") > -1 || d[3].indexOf("-") > -1))
                    throw new Error("The 'W' character can be specified only when the day-of-month is a single day, not a range or list of days.");
                  var m = {
                    SUN: 0,
                    MON: 1,
                    TUE: 2,
                    WED: 3,
                    THU: 4,
                    FRI: 5,
                    SAT: 6
                  };
                  for (var g in m)
                    d[5] = d[5].replace(new RegExp(g, "gi"), m[g].toString());
                  d[4] = d[4].replace(/(^\d{1,2})|([^#/\s]\d{1,2})/g, function(A) {
                    var C = A.replace(/\D/, ""), M = C;
                    return h.monthStartIndexZero && (M = (parseInt(C) + 1).toString()), A.replace(C, M);
                  });
                  var _ = {
                    JAN: 1,
                    FEB: 2,
                    MAR: 3,
                    APR: 4,
                    MAY: 5,
                    JUN: 6,
                    JUL: 7,
                    AUG: 8,
                    SEP: 9,
                    OCT: 10,
                    NOV: 11,
                    DEC: 12
                  };
                  for (var b in _)
                    d[4] = d[4].replace(new RegExp(b, "gi"), _[b].toString());
                  d[0] == "0" && (d[0] = ""), !/\*|\-|\,|\//.test(d[2]) && (/\*|\//.test(d[1]) || /\*|\//.test(d[0])) && (d[2] += "-".concat(d[2]));
                  for (var x = 0; x < d.length; x++)
                    if (d[x].indexOf(",") != -1 && (d[x] = d[x].split(",").filter(function(A) {
                      return A !== "";
                    }).join(",") || "*"), d[x] == "*/1" && (d[x] = "*"), d[x].indexOf("/") > -1 && !/^\*|\-|\,/.test(d[x])) {
                      var S = null;
                      switch (x) {
                        case 4:
                          S = "12";
                          break;
                        case 5:
                          S = "6";
                          break;
                        case 6:
                          S = "9999";
                          break;
                        default:
                          S = null;
                          break;
                      }
                      if (S !== null) {
                        var E = d[x].split("/");
                        d[x] = "".concat(E[0], "-").concat(S, "/").concat(E[1]);
                      }
                    }
                }, p.prototype.validate = function(d) {
                  var h = "0-9,\\-*/";
                  this.validateOnlyExpectedCharactersFound(d[0], h), this.validateOnlyExpectedCharactersFound(d[1], h), this.validateOnlyExpectedCharactersFound(d[2], h), this.validateOnlyExpectedCharactersFound(d[3], "0-9,\\-*/LW"), this.validateOnlyExpectedCharactersFound(d[4], h), this.validateOnlyExpectedCharactersFound(d[5], "0-9,\\-*/L#"), this.validateOnlyExpectedCharactersFound(d[6], h), this.validateAnyRanges(d);
                }, p.prototype.validateAnyRanges = function(d) {
                  a.default.secondRange(d[0]), a.default.minuteRange(d[1]), a.default.hourRange(d[2]), a.default.dayOfMonthRange(d[3]), a.default.monthRange(d[4], this.monthStartIndexZero), a.default.dayOfWeekRange(d[5], this.dayOfWeekStartIndexZero);
                }, p.prototype.validateOnlyExpectedCharactersFound = function(d, h) {
                  var m = d.match(new RegExp("[^".concat(h, "]+"), "gi"));
                  if (m && m.length)
                    throw new Error("Expression contains invalid values: '".concat(m.toString(), "'"));
                }, p;
              }();
              u.CronParser = c;
            }
          ),
          /***/
          333: (
            /***/
            (i, u, l) => {
              Object.defineProperty(u, "__esModule", { value: !0 }), u.ExpressionDescriptor = void 0;
              var a = l(823), c = l(949), p = function() {
                function d(h, m) {
                  if (this.expression = h, this.options = m, this.expressionParts = new Array(5), !this.options.locale && d.defaultLocale && (this.options.locale = d.defaultLocale), !d.locales[this.options.locale]) {
                    var g = Object.keys(d.locales)[0];
                    console.warn("Locale '".concat(this.options.locale, "' could not be found; falling back to '").concat(g, "'.")), this.options.locale = g;
                  }
                  this.i18n = d.locales[this.options.locale], m.use24HourTimeFormat === void 0 && (m.use24HourTimeFormat = this.i18n.use24HourTimeFormatByDefault());
                }
                return d.toString = function(h, m) {
                  var g = m === void 0 ? {} : m, _ = g.throwExceptionOnParseError, b = _ === void 0 ? !0 : _, x = g.verbose, S = x === void 0 ? !1 : x, E = g.dayOfWeekStartIndexZero, A = E === void 0 ? !0 : E, C = g.monthStartIndexZero, M = C === void 0 ? !1 : C, L = g.use24HourTimeFormat, X = g.locale, te = X === void 0 ? null : X, B = {
                    throwExceptionOnParseError: b,
                    verbose: S,
                    dayOfWeekStartIndexZero: A,
                    monthStartIndexZero: M,
                    use24HourTimeFormat: L,
                    locale: te
                  };
                  B.tzOffset && console.warn("'tzOffset' option has been deprecated and is no longer supported.");
                  var W = new d(h, B);
                  return W.getFullDescription();
                }, d.initialize = function(h, m) {
                  m === void 0 && (m = "en"), d.specialCharacters = ["/", "-", ",", "*"], d.defaultLocale = m, h.load(d.locales);
                }, d.prototype.getFullDescription = function() {
                  var h, m, g = "";
                  try {
                    var _ = new c.CronParser(this.expression, this.options.dayOfWeekStartIndexZero, this.options.monthStartIndexZero);
                    if (this.expressionParts = _.parse(), this.expressionParts[0] === "@reboot")
                      return ((m = (h = this.i18n).atReboot) === null || m === void 0 ? void 0 : m.call(h)) || "Run once, at startup";
                    var b = this.getTimeOfDayDescription(), x = this.getDayOfMonthDescription(), S = this.getMonthDescription(), E = this.getDayOfWeekDescription(), A = this.getYearDescription();
                    g += b + x + E + S + A, g = this.transformVerbosity(g, !!this.options.verbose), g = g.charAt(0).toLocaleUpperCase() + g.substr(1);
                  } catch (C) {
                    if (!this.options.throwExceptionOnParseError)
                      g = this.i18n.anErrorOccuredWhenGeneratingTheExpressionD();
                    else
                      throw "".concat(C);
                  }
                  return g;
                }, d.prototype.getTimeOfDayDescription = function() {
                  var h = this.expressionParts[0], m = this.expressionParts[1], g = this.expressionParts[2], _ = "";
                  if (!a.StringUtilities.containsAny(m, d.specialCharacters) && !a.StringUtilities.containsAny(g, d.specialCharacters) && !a.StringUtilities.containsAny(h, d.specialCharacters))
                    _ += this.i18n.atSpace() + this.formatTime(g, m, h);
                  else if (!h && m.indexOf("-") > -1 && !(m.indexOf(",") > -1) && !(m.indexOf("/") > -1) && !a.StringUtilities.containsAny(g, d.specialCharacters)) {
                    var b = m.split("-");
                    _ += a.StringUtilities.format(this.i18n.everyMinuteBetweenX0AndX1(), this.formatTime(g, b[0], ""), this.formatTime(g, b[1], ""));
                  } else if (!h && g.indexOf(",") > -1 && g.indexOf("-") == -1 && g.indexOf("/") == -1 && !a.StringUtilities.containsAny(m, d.specialCharacters)) {
                    var x = g.split(",");
                    _ += this.i18n.at();
                    for (var S = 0; S < x.length; S++)
                      _ += " ", _ += this.formatTime(x[S], m, ""), S < x.length - 2 && (_ += ","), S == x.length - 2 && (_ += this.i18n.spaceAnd());
                  } else {
                    var E = this.getSecondsDescription(), A = this.getMinutesDescription(), C = this.getHoursDescription();
                    if (_ += E, _ && A && (_ += ", "), _ += A, A === C)
                      return _;
                    _ && C && (_ += ", "), _ += C;
                  }
                  return _;
                }, d.prototype.getSecondsDescription = function() {
                  var h = this, m = this.getSegmentDescription(this.expressionParts[0], this.i18n.everySecond(), function(g) {
                    return g;
                  }, function(g) {
                    return a.StringUtilities.format(h.i18n.everyX0Seconds(g), g);
                  }, function(g) {
                    return h.i18n.secondsX0ThroughX1PastTheMinute();
                  }, function(g) {
                    return g == "0" ? "" : parseInt(g) < 20 ? h.i18n.atX0SecondsPastTheMinute(g) : h.i18n.atX0SecondsPastTheMinuteGt20() || h.i18n.atX0SecondsPastTheMinute(g);
                  });
                  return m;
                }, d.prototype.getMinutesDescription = function() {
                  var h = this, m = this.expressionParts[0], g = this.expressionParts[2], _ = this.getSegmentDescription(this.expressionParts[1], this.i18n.everyMinute(), function(b) {
                    return b;
                  }, function(b) {
                    return a.StringUtilities.format(h.i18n.everyX0Minutes(b), b);
                  }, function(b) {
                    return h.i18n.minutesX0ThroughX1PastTheHour();
                  }, function(b) {
                    try {
                      return b == "0" && g.indexOf("/") == -1 && m == "" ? h.i18n.everyHour() : parseInt(b) < 20 ? h.i18n.atX0MinutesPastTheHour(b) : h.i18n.atX0MinutesPastTheHourGt20() || h.i18n.atX0MinutesPastTheHour(b);
                    } catch {
                      return h.i18n.atX0MinutesPastTheHour(b);
                    }
                  });
                  return _;
                }, d.prototype.getHoursDescription = function() {
                  var h = this, m = this.expressionParts[2], g = 0, _ = [];
                  m.split("/")[0].split(",").forEach(function(S) {
                    var E = S.split("-");
                    E.length === 2 && _.push({ value: E[1], index: g + 1 }), g += E.length;
                  });
                  var b = 0, x = this.getSegmentDescription(m, this.i18n.everyHour(), function(S) {
                    var E = _.find(function(C) {
                      return C.value === S && C.index === b;
                    }), A = E && h.expressionParts[1] !== "0";
                    return b++, A ? h.formatTime(S, "59", "") : h.formatTime(S, "0", "");
                  }, function(S) {
                    return a.StringUtilities.format(h.i18n.everyX0Hours(S), S);
                  }, function(S) {
                    return h.i18n.betweenX0AndX1();
                  }, function(S) {
                    return h.i18n.atX0();
                  });
                  return x;
                }, d.prototype.getDayOfWeekDescription = function() {
                  var h = this, m = this.i18n.daysOfTheWeek(), g = null;
                  return this.expressionParts[5] == "*" ? g = "" : g = this.getSegmentDescription(this.expressionParts[5], this.i18n.commaEveryDay(), function(_, b) {
                    var x = _;
                    _.indexOf("#") > -1 ? x = _.substring(0, _.indexOf("#")) : _.indexOf("L") > -1 && (x = x.replace("L", ""));
                    var S = parseInt(x), E = h.i18n.daysOfTheWeekInCase ? h.i18n.daysOfTheWeekInCase(b)[S] : m[S];
                    if (_.indexOf("#") > -1) {
                      var A = null, C = _.substring(_.indexOf("#") + 1), M = _.substring(0, _.indexOf("#"));
                      switch (C) {
                        case "1":
                          A = h.i18n.first(M);
                          break;
                        case "2":
                          A = h.i18n.second(M);
                          break;
                        case "3":
                          A = h.i18n.third(M);
                          break;
                        case "4":
                          A = h.i18n.fourth(M);
                          break;
                        case "5":
                          A = h.i18n.fifth(M);
                          break;
                      }
                      E = A + " " + E;
                    }
                    return E;
                  }, function(_) {
                    return parseInt(_) == 1 ? "" : a.StringUtilities.format(h.i18n.commaEveryX0DaysOfTheWeek(_), _);
                  }, function(_) {
                    var b = _.substring(0, _.indexOf("-")), x = h.expressionParts[3] != "*";
                    return x ? h.i18n.commaAndX0ThroughX1(b) : h.i18n.commaX0ThroughX1(b);
                  }, function(_) {
                    var b = null;
                    if (_.indexOf("#") > -1) {
                      var x = _.substring(_.indexOf("#") + 1), S = _.substring(0, _.indexOf("#"));
                      b = h.i18n.commaOnThe(x, S).trim() + h.i18n.spaceX0OfTheMonth();
                    } else if (_.indexOf("L") > -1)
                      b = h.i18n.commaOnTheLastX0OfTheMonth(_.replace("L", ""));
                    else {
                      var E = h.expressionParts[3] != "*";
                      b = E ? h.i18n.commaAndOnX0() : h.i18n.commaOnlyOnX0(_);
                    }
                    return b;
                  }), g;
                }, d.prototype.getMonthDescription = function() {
                  var h = this, m = this.i18n.monthsOfTheYear(), g = this.getSegmentDescription(this.expressionParts[4], "", function(_, b) {
                    return b && h.i18n.monthsOfTheYearInCase ? h.i18n.monthsOfTheYearInCase(b)[parseInt(_) - 1] : m[parseInt(_) - 1];
                  }, function(_) {
                    return parseInt(_) == 1 ? "" : a.StringUtilities.format(h.i18n.commaEveryX0Months(_), _);
                  }, function(_) {
                    return h.i18n.commaMonthX0ThroughMonthX1() || h.i18n.commaX0ThroughX1();
                  }, function(_) {
                    return h.i18n.commaOnlyInMonthX0 ? h.i18n.commaOnlyInMonthX0() : h.i18n.commaOnlyInX0();
                  });
                  return g;
                }, d.prototype.getDayOfMonthDescription = function() {
                  var h = this, m = null, g = this.expressionParts[3];
                  switch (g) {
                    case "L":
                      m = this.i18n.commaOnTheLastDayOfTheMonth();
                      break;
                    case "WL":
                    case "LW":
                      m = this.i18n.commaOnTheLastWeekdayOfTheMonth();
                      break;
                    default:
                      var _ = g.match(/(\d{1,2}W)|(W\d{1,2})/);
                      if (_) {
                        var b = parseInt(_[0].replace("W", "")), x = b == 1 ? this.i18n.firstWeekday() : a.StringUtilities.format(this.i18n.weekdayNearestDayX0(), b.toString());
                        m = a.StringUtilities.format(this.i18n.commaOnTheX0OfTheMonth(), x);
                        break;
                      } else {
                        var S = g.match(/L-(\d{1,2})/);
                        if (S) {
                          var E = S[1];
                          m = a.StringUtilities.format(this.i18n.commaDaysBeforeTheLastDayOfTheMonth(E), E);
                          break;
                        } else {
                          if (g == "*" && this.expressionParts[5] != "*")
                            return "";
                          m = this.getSegmentDescription(g, this.i18n.commaEveryDay(), function(A) {
                            return A == "L" ? h.i18n.lastDay() : h.i18n.dayX0 ? a.StringUtilities.format(h.i18n.dayX0(), A) : A;
                          }, function(A) {
                            return A == "1" ? h.i18n.commaEveryDay() : h.i18n.commaEveryX0Days(A);
                          }, function(A) {
                            return h.i18n.commaBetweenDayX0AndX1OfTheMonth(A);
                          }, function(A) {
                            return h.i18n.commaOnDayX0OfTheMonth(A);
                          });
                        }
                        break;
                      }
                  }
                  return m;
                }, d.prototype.getYearDescription = function() {
                  var h = this, m = this.getSegmentDescription(this.expressionParts[6], "", function(g) {
                    return /^\d+$/.test(g) ? new Date(parseInt(g), 1).getFullYear().toString() : g;
                  }, function(g) {
                    return a.StringUtilities.format(h.i18n.commaEveryX0Years(g), g);
                  }, function(g) {
                    return h.i18n.commaYearX0ThroughYearX1() || h.i18n.commaX0ThroughX1();
                  }, function(g) {
                    return h.i18n.commaOnlyInYearX0 ? h.i18n.commaOnlyInYearX0() : h.i18n.commaOnlyInX0();
                  });
                  return m;
                }, d.prototype.getSegmentDescription = function(h, m, g, _, b, x) {
                  var S = null, E = h.indexOf("/") > -1, A = h.indexOf("-") > -1, C = h.indexOf(",") > -1;
                  if (!h)
                    S = "";
                  else if (h === "*")
                    S = m;
                  else if (!E && !A && !C)
                    S = a.StringUtilities.format(x(h), g(h));
                  else if (C) {
                    for (var M = h.split(","), L = "", X = 0; X < M.length; X++)
                      if (X > 0 && M.length > 2 && (L += ",", X < M.length - 1 && (L += " ")), X > 0 && M.length > 1 && (X == M.length - 1 || M.length == 2) && (L += "".concat(this.i18n.spaceAnd(), " ")), M[X].indexOf("/") > -1 || M[X].indexOf("-") > -1) {
                        var te = M[X].indexOf("-") > -1 && M[X].indexOf("/") == -1, B = this.getSegmentDescription(M[X], m, g, _, te ? this.i18n.commaX0ThroughX1 : b, x);
                        te && (B = B.replace(", ", "")), L += B;
                      } else E ? L += this.getSegmentDescription(M[X], m, g, _, b, x) : L += g(M[X]);
                    E ? S = L : S = a.StringUtilities.format(x(h), L);
                  } else if (E) {
                    var M = h.split("/");
                    if (S = a.StringUtilities.format(_(M[1]), M[1]), M[0].indexOf("-") > -1) {
                      var W = this.generateRangeSegmentDescription(M[0], b, g);
                      W.indexOf(", ") != 0 && (S += ", "), S += W;
                    } else if (M[0].indexOf("*") == -1) {
                      var G = a.StringUtilities.format(x(M[0]), g(M[0]));
                      G = G.replace(", ", ""), S += a.StringUtilities.format(this.i18n.commaStartingX0(), G);
                    }
                  } else A && (S = this.generateRangeSegmentDescription(h, b, g));
                  return S;
                }, d.prototype.generateRangeSegmentDescription = function(h, m, g) {
                  var _ = "", b = h.split("-"), x = g(b[0], 1), S = g(b[1], 2), E = m(h);
                  return _ += a.StringUtilities.format(E, x, S), _;
                }, d.prototype.formatTime = function(h, m, g) {
                  var _ = 0, b = 0, x = parseInt(h) + _, S = parseInt(m) + b;
                  S >= 60 ? (S -= 60, x += 1) : S < 0 && (S += 60, x -= 1), x >= 24 ? x = x - 24 : x < 0 && (x = 24 + x);
                  var E = "", A = !1;
                  this.options.use24HourTimeFormat || (A = !!(this.i18n.setPeriodBeforeTime && this.i18n.setPeriodBeforeTime()), E = A ? "".concat(this.getPeriod(x), " ") : " ".concat(this.getPeriod(x)), x > 12 && (x -= 12), x === 0 && (x = 12));
                  var C = "";
                  return g && (C = ":".concat(("00" + g).substring(g.length))), "".concat(A ? E : "").concat(("00" + x.toString()).substring(x.toString().length), ":").concat(("00" + S.toString()).substring(S.toString().length)).concat(C).concat(A ? "" : E);
                }, d.prototype.transformVerbosity = function(h, m) {
                  if (!m && (h = h.replace(new RegExp(", ".concat(this.i18n.everyMinute()), "g"), ""), h = h.replace(new RegExp(", ".concat(this.i18n.everyHour()), "g"), ""), h = h.replace(new RegExp(this.i18n.commaEveryDay(), "g"), ""), h = h.replace(/\, ?$/, ""), this.i18n.conciseVerbosityReplacements))
                    for (var g = 0, _ = Object.entries(this.i18n.conciseVerbosityReplacements()); g < _.length; g++) {
                      var b = _[g], x = b[0], S = b[1];
                      h = h.replace(new RegExp(x, "g"), S);
                    }
                  return h;
                }, d.prototype.getPeriod = function(h) {
                  return h >= 12 ? this.i18n.pm && this.i18n.pm() || "PM" : this.i18n.am && this.i18n.am() || "AM";
                }, d.locales = {}, d;
              }();
              u.ExpressionDescriptor = p;
            }
          ),
          /***/
          747: (
            /***/
            (i, u, l) => {
              Object.defineProperty(u, "__esModule", { value: !0 }), u.enLocaleLoader = void 0;
              var a = l(486), c = function() {
                function p() {
                }
                return p.prototype.load = function(d) {
                  d.en = new a.en();
                }, p;
              }();
              u.enLocaleLoader = c;
            }
          ),
          /***/
          486: (
            /***/
            (i, u) => {
              Object.defineProperty(u, "__esModule", { value: !0 }), u.en = void 0;
              var l = function() {
                function a() {
                }
                return a.prototype.atX0SecondsPastTheMinuteGt20 = function() {
                  return null;
                }, a.prototype.atX0MinutesPastTheHourGt20 = function() {
                  return null;
                }, a.prototype.commaMonthX0ThroughMonthX1 = function() {
                  return null;
                }, a.prototype.commaYearX0ThroughYearX1 = function() {
                  return null;
                }, a.prototype.use24HourTimeFormatByDefault = function() {
                  return !1;
                }, a.prototype.anErrorOccuredWhenGeneratingTheExpressionD = function() {
                  return "An error occurred when generating the expression description. Check the cron expression syntax.";
                }, a.prototype.everyMinute = function() {
                  return "every minute";
                }, a.prototype.everyHour = function() {
                  return "every hour";
                }, a.prototype.atSpace = function() {
                  return "At ";
                }, a.prototype.everyMinuteBetweenX0AndX1 = function() {
                  return "Every minute between %s and %s";
                }, a.prototype.at = function() {
                  return "At";
                }, a.prototype.spaceAnd = function() {
                  return " and";
                }, a.prototype.everySecond = function() {
                  return "every second";
                }, a.prototype.everyX0Seconds = function() {
                  return "every %s seconds";
                }, a.prototype.secondsX0ThroughX1PastTheMinute = function() {
                  return "seconds %s through %s past the minute";
                }, a.prototype.atX0SecondsPastTheMinute = function() {
                  return "at %s seconds past the minute";
                }, a.prototype.everyX0Minutes = function() {
                  return "every %s minutes";
                }, a.prototype.minutesX0ThroughX1PastTheHour = function() {
                  return "minutes %s through %s past the hour";
                }, a.prototype.atX0MinutesPastTheHour = function() {
                  return "at %s minutes past the hour";
                }, a.prototype.everyX0Hours = function() {
                  return "every %s hours";
                }, a.prototype.betweenX0AndX1 = function() {
                  return "between %s and %s";
                }, a.prototype.atX0 = function() {
                  return "at %s";
                }, a.prototype.commaEveryDay = function() {
                  return ", every day";
                }, a.prototype.commaEveryX0DaysOfTheWeek = function() {
                  return ", every %s days of the week";
                }, a.prototype.commaX0ThroughX1 = function() {
                  return ", %s through %s";
                }, a.prototype.commaAndX0ThroughX1 = function() {
                  return ", %s through %s";
                }, a.prototype.first = function() {
                  return "first";
                }, a.prototype.second = function() {
                  return "second";
                }, a.prototype.third = function() {
                  return "third";
                }, a.prototype.fourth = function() {
                  return "fourth";
                }, a.prototype.fifth = function() {
                  return "fifth";
                }, a.prototype.commaOnThe = function() {
                  return ", on the ";
                }, a.prototype.spaceX0OfTheMonth = function() {
                  return " %s of the month";
                }, a.prototype.lastDay = function() {
                  return "the last day";
                }, a.prototype.commaOnTheLastX0OfTheMonth = function() {
                  return ", on the last %s of the month";
                }, a.prototype.commaOnlyOnX0 = function() {
                  return ", only on %s";
                }, a.prototype.commaAndOnX0 = function() {
                  return ", and on %s";
                }, a.prototype.commaEveryX0Months = function() {
                  return ", every %s months";
                }, a.prototype.commaOnlyInX0 = function() {
                  return ", only in %s";
                }, a.prototype.commaOnTheLastDayOfTheMonth = function() {
                  return ", on the last day of the month";
                }, a.prototype.commaOnTheLastWeekdayOfTheMonth = function() {
                  return ", on the last weekday of the month";
                }, a.prototype.commaDaysBeforeTheLastDayOfTheMonth = function() {
                  return ", %s days before the last day of the month";
                }, a.prototype.firstWeekday = function() {
                  return "first weekday";
                }, a.prototype.weekdayNearestDayX0 = function() {
                  return "weekday nearest day %s";
                }, a.prototype.commaOnTheX0OfTheMonth = function() {
                  return ", on the %s of the month";
                }, a.prototype.commaEveryX0Days = function() {
                  return ", every %s days";
                }, a.prototype.commaBetweenDayX0AndX1OfTheMonth = function() {
                  return ", between day %s and %s of the month";
                }, a.prototype.commaOnDayX0OfTheMonth = function() {
                  return ", on day %s of the month";
                }, a.prototype.commaEveryHour = function() {
                  return ", every hour";
                }, a.prototype.commaEveryX0Years = function() {
                  return ", every %s years";
                }, a.prototype.commaStartingX0 = function() {
                  return ", starting %s";
                }, a.prototype.daysOfTheWeek = function() {
                  return ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
                }, a.prototype.monthsOfTheYear = function() {
                  return [
                    "January",
                    "February",
                    "March",
                    "April",
                    "May",
                    "June",
                    "July",
                    "August",
                    "September",
                    "October",
                    "November",
                    "December"
                  ];
                }, a.prototype.atReboot = function() {
                  return "Run once, at startup";
                }, a;
              }();
              u.en = l;
            }
          ),
          /***/
          515: (
            /***/
            (i, u) => {
              Object.defineProperty(u, "__esModule", { value: !0 });
              function l(c, p) {
                if (!c)
                  throw new Error(p);
              }
              var a = function() {
                function c() {
                }
                return c.secondRange = function(p) {
                  for (var d = p.split(","), h = 0; h < d.length; h++)
                    if (!isNaN(parseInt(d[h], 10))) {
                      var m = parseInt(d[h], 10);
                      l(m >= 0 && m <= 59, "seconds part must be >= 0 and <= 59");
                    }
                }, c.minuteRange = function(p) {
                  for (var d = p.split(","), h = 0; h < d.length; h++)
                    if (!isNaN(parseInt(d[h], 10))) {
                      var m = parseInt(d[h], 10);
                      l(m >= 0 && m <= 59, "minutes part must be >= 0 and <= 59");
                    }
                }, c.hourRange = function(p) {
                  for (var d = p.split(","), h = 0; h < d.length; h++)
                    if (!isNaN(parseInt(d[h], 10))) {
                      var m = parseInt(d[h], 10);
                      l(m >= 0 && m <= 23, "hours part must be >= 0 and <= 23");
                    }
                }, c.dayOfMonthRange = function(p) {
                  for (var d = p.split(","), h = 0; h < d.length; h++)
                    if (!isNaN(parseInt(d[h], 10))) {
                      var m = parseInt(d[h], 10);
                      l(m >= 1 && m <= 31, "DOM part must be >= 1 and <= 31");
                    }
                }, c.monthRange = function(p, d) {
                  for (var h = p.split(","), m = 0; m < h.length; m++)
                    if (!isNaN(parseInt(h[m], 10))) {
                      var g = parseInt(h[m], 10);
                      l(g >= 1 && g <= 12, d ? "month part must be >= 0 and <= 11" : "month part must be >= 1 and <= 12");
                    }
                }, c.dayOfWeekRange = function(p, d) {
                  for (var h = p.split(","), m = 0; m < h.length; m++)
                    if (!isNaN(parseInt(h[m], 10))) {
                      var g = parseInt(h[m], 10);
                      l(g >= 0 && g <= 6, d ? "DOW part must be >= 0 and <= 6" : "DOW part must be >= 1 and <= 7");
                    }
                }, c;
              }();
              u.default = a;
            }
          ),
          /***/
          823: (
            /***/
            (i, u) => {
              Object.defineProperty(u, "__esModule", { value: !0 }), u.StringUtilities = void 0;
              var l = function() {
                function a() {
                }
                return a.format = function(c) {
                  for (var p = [], d = 1; d < arguments.length; d++)
                    p[d - 1] = arguments[d];
                  return c.replace(/%s/g, function(h) {
                    return p.shift();
                  });
                }, a.containsAny = function(c, p) {
                  return p.some(function(d) {
                    return c.indexOf(d) > -1;
                  });
                }, a;
              }();
              u.StringUtilities = l;
            }
          )
          /******/
        }, r = {};
        function o(i) {
          var u = r[i];
          if (u !== void 0)
            return u.exports;
          var l = r[i] = {
            /******/
            // no module.id needed
            /******/
            // no module.loaded needed
            /******/
            exports: {}
            /******/
          };
          return n[i](l, l.exports, o), l.exports;
        }
        var s = {};
        return (() => {
          var i = s;
          Object.defineProperty(i, "__esModule", { value: !0 }), i.toString = void 0;
          var u = o(333), l = o(747);
          u.ExpressionDescriptor.initialize(new l.enLocaleLoader()), i.default = u.ExpressionDescriptor;
          var a = u.ExpressionDescriptor.toString;
          i.toString = a;
        })(), s;
      })()
    ));
  }(E1)), E1.exports;
}
var Dee = Aee();
const Eee = /* @__PURE__ */ Nh(Dee);
class SE extends Eee {
  getFullDescription() {
    try {
      return super.getFullDescription();
    } catch {
      return "";
    }
  }
  getSecondsDescription() {
    try {
      return super.getSecondsDescription();
    } catch {
      return "";
    }
  }
  getMinutesDescription() {
    try {
      return super.getMinutesDescription();
    } catch {
      return "";
    }
  }
  getHoursDescription() {
    try {
      return super.getHoursDescription();
    } catch {
      return "";
    }
  }
  getTimeOfDayDescription() {
    try {
      return super.getTimeOfDayDescription();
    } catch {
      return "";
    }
  }
  getDayOfMonthDescription() {
    try {
      return super.getDayOfMonthDescription();
    } catch {
      return "";
    }
  }
  getMonthDescription() {
    try {
      return super.getMonthDescription();
    } catch {
      return "";
    }
  }
  getDayOfWeekDescription() {
    try {
      return super.getDayOfWeekDescription();
    } catch {
      return "";
    }
  }
  getYearDescription() {
    try {
      return super.getYearDescription();
    } catch {
      return "";
    }
  }
  transformVerbosity(e, n) {
    return super.transformVerbosity(e, n);
  }
  constructor(e, n) {
    super(e, n), this.getFullDescription();
  }
}
const eF = {
  "@midnight": "Daily",
  "@hourly": "Hourly",
  "@daily": "Daily",
  "@weekly": "Weekly",
  "@monthly": "Monthly",
  "@yearly": "Yearly",
  "@annually": "Yearly"
};
function Mee(t) {
  return t in eF;
}
function zl(t) {
  return t ? t.split(" ").some((n) => n.toUpperCase() == "R" || n.toUpperCase() == "RANDOM") : !1;
}
class B0 {
  timezone;
  cron;
  dayOr;
  constructor(e) {
    this.timezone = e.timezone, this.cron = e.cron, this.dayOr = e.dayOr;
  }
  get raw() {
    return this.cron;
  }
  toString({ verbose: e = !1 } = {}) {
    let n = "";
    const r = new SE(this.cron, {}), o = this.cron.trim().split(" ");
    if (Mee(this.cron))
      return eF[this.cron];
    try {
      if (o.length < 5)
        throw new Ree(o.length);
      const s = o.length > 5, i = s ? 0 : -1, u = o.map((G) => zl(G) ? "*" : G).join(" "), l = new SE(u, {}), a = r.getTimeOfDayDescription(), c = r.getDayOfMonthDescription(), p = r.getMonthDescription(), d = r.getDayOfWeekDescription(), h = s && zl(o[0]), m = zl(o[i + 1]), g = zl(o[i + 2]), _ = h || m || g, b = s && h && m && g || m && g, x = zl(o[i + 3]), S = zl(o[i + 4]), E = zl(o[i + 5]), A = x || S || E, C = x && S && E;
      let M = _ ? l.getTimeOfDayDescription() : a, L = x ? l.getDayOfMonthDescription() : c, X = S ? l.getMonthDescription() : p, te = E ? l.getDayOfWeekDescription() : d;
      e: if (_) {
        const G = l.getSecondsDescription(), ne = l.getMinutesDescription(), de = l.getHoursDescription();
        if (b) {
          M = "at a random time";
          break e;
        }
        if (h) {
          m ? M = `at random time ${de}` : g ? M = `at random time ${ne}` : M = `at random second ${ne}, ${de}`;
          break e;
        }
        if (m) {
          g ? M = `${G} at a random minute and hour` : M = `${G} at a random time ${de}`;
          break e;
        }
        if (g) {
          G == "every hour" || ne == "every hour" ? M = "at a random hour" : M = `${G}${ne} of a random hour`;
          break e;
        }
      }
      e: if (A) {
        if (C) {
          L = "", X = "", te = "of a random day";
          break e;
        }
        if (x) {
          S ? (L = "of a random day", X = "and month") : L = "of a random day";
          break e;
        }
        if (S) {
          E && (te = "of a random day of the week"), X = "in a random month";
          break e;
        }
        if (E) {
          te = "of a random day of the week";
          break e;
        }
      }
      const B = [];
      M && B.push(M), te && (te = te.replace(", and", "")), L && (L = L.replace(", ", "")), te && L ? this.dayOr ? (B.push(te), B.push("or"), B.push(L)) : (B.push(te), B.push("and"), B.push(L)) : (te && B.push(te), L && B.push(L)), X && B.push(X);
      let W;
      W = B.reduce((G, ne) => (ne.startsWith(", ") ? G = `${G}${ne}` : G = `${G} ${ne}`, G.trim()), ""), W = r.transformVerbosity(W, !1), W = yi(W.trim()), n = W;
    } catch {
      try {
        n = See.toString(this.cron);
      } catch {
        return n = "Invalid", n;
      }
    } finally {
      e && (n = `${n}${this.timezone ? ` (${this.timezone})` : " (UTC)"}`);
    }
    return n;
  }
  toResponse() {
    return {
      cron: this.cron,
      timezone: this.timezone,
      day_or: this.dayOr
    };
  }
}
const { values: Pee, isValue: mLe } = to(["ENQUEUE", "CANCEL_NEW"]);
class Cee {
  id;
  kind = "deployment";
  created;
  createdBy;
  updated;
  updatedBy;
  name;
  version;
  versionInfo;
  description;
  flowId;
  versionId;
  paused;
  schedules;
  parameters;
  parameterOpenApiSchema;
  tags;
  manifestPath;
  path;
  entrypoint;
  storageDocumentId;
  infrastructureDocumentId;
  jobVariables;
  workQueueName;
  workPoolName;
  enforceParameterSchema;
  pullSteps;
  can;
  status;
  disabled;
  globalConcurrencyLimit;
  concurrencyOptions;
  constructor(e) {
    this.id = e.id, this.created = e.created, this.createdBy = e.createdBy, this.updated = e.updated, this.updatedBy = e.updatedBy, this.name = e.name, this.version = e.version, this.description = e.description, this.flowId = e.flowId, this.versionId = e.versionId, this.versionInfo = e.versionInfo, this.paused = e.paused, this.schedules = e.schedules, this.parameters = e.parameters, this.parameterOpenApiSchema = e.parameterOpenApiSchema, this.tags = e.tags, this.manifestPath = e.manifestPath, this.path = e.path, this.entrypoint = e.entrypoint, this.storageDocumentId = e.storageDocumentId, this.infrastructureDocumentId = e.infrastructureDocumentId, this.jobVariables = e.jobVariables, this.workQueueName = e.workQueueName, this.workPoolName = e.workPoolName, this.enforceParameterSchema = e.enforceParameterSchema, this.pullSteps = e.pullSteps, this.can = e.can, this.status = e.status, this.disabled = e.disabled, this.globalConcurrencyLimit = e.globalConcurrencyLimit, this.concurrencyOptions = e.concurrencyOptions;
  }
  get concurrencyLimit() {
    return this.globalConcurrencyLimit?.limit ?? null;
  }
  get deprecated() {
    return (this.manifestPath === "" || this.manifestPath === null) && (this.entrypoint === "" || this.entrypoint === null);
  }
  get appliedBy() {
    return this.updatedBy ? this.updatedBy.displayValue : this.createdBy ? this.createdBy.displayValue : null;
  }
}
class Oee {
  id;
  created;
  updated;
  slug;
  active;
  schedule;
  jobVariables;
  parameters;
  constructor(e) {
    this.id = e.id, this.created = e.created, this.updated = e.updated, this.slug = e.slug, this.active = e.active, this.schedule = e.schedule, this.jobVariables = e.jobVariables, this.parameters = e.parameters;
  }
}
const { values: bk, isValue: Iee } = to(["ready", "not_ready", "disabled"]);
function qx(t) {
  switch (t) {
    case "not_ready":
      return "Not Ready";
    case "ready":
      return "Ready";
    case "disabled":
      return "Disabled";
    default:
      const e = t;
      throw new Error(`getDeploymentStatusLabel missing case for status: ${e}`);
  }
}
class Fee {
  id;
  deploymentId;
  kind = "deployment-version";
  created;
  createdBy;
  updated;
  updatedBy;
  lastActive;
  name;
  description;
  versionInfo;
  tags;
  labels;
  entrypoint;
  pullSteps;
  parameters;
  parameterOpenApiSchema;
  jobVariables;
  workQueueName;
  workPoolName;
  enforceParameterSchema;
  constructor(e) {
    this.id = e.id, this.deploymentId = e.deploymentId, this.created = e.created, this.createdBy = e.createdBy, this.updated = e.updated, this.updatedBy = e.updatedBy, this.lastActive = e.lastActive, this.name = e.name, this.description = e.description, this.versionInfo = e.versionInfo, this.tags = e.tags ?? [], this.labels = e.labels, this.entrypoint = e.entrypoint, this.pullSteps = e.pullSteps, this.parameters = e.parameters, this.parameterOpenApiSchema = e.parameterOpenApiSchema, this.jobVariables = e.jobVariables, this.workQueueName = e.workQueueName, this.workPoolName = e.workPoolName, this.enforceParameterSchema = e.enforceParameterSchema;
  }
}
const Nee = Iq.map((t) => t.split(":")[0]);
function Ac() {
  const t = Nee;
  return new Proxy({}, {
    get(e, n) {
      if (t.includes(n))
        return !0;
    }
  });
}
class Lee {
  retries;
  retryDelay;
  retryJitterFactor;
  maxRetries;
  retryDelaySeconds;
  constructor(e) {
    this.retries = e.retries, this.retryDelay = e.retryDelay, this.retryJitterFactor = e.retryJitterFactor, this.maxRetries = e.maxRetries, this.retryDelaySeconds = e.retryDelaySeconds;
  }
}
class yLe extends Error {
  constructor() {
    super("filter date value is invalid");
  }
}
class gLe extends Error {
  constructor() {
    super("filter has an invalid prefix");
  }
}
class vLe extends Error {
  constructor() {
    super("unit is invalid");
  }
}
function Bee(t) {
  return ["and", "or"].includes(t);
}
function Uee(t) {
  return typeof t == "object" && t !== null && "type" in t && "version" in t;
}
class tF {
  id;
  kind = "flow";
  created;
  updated;
  name;
  description;
  constructor(e) {
    this.id = e.id, this.created = e.created, this.updated = e.updated, this.name = e.name, this.description = e.description;
  }
}
class Xee {
  storageTimestamp = /* @__PURE__ */ new Date();
}
class nF extends Xee {
  id;
  flowId;
  flowName;
  deploymentId;
  deploymentVersionId;
  workQueueName;
  kind = "flowRun";
  flowVersion;
  idempotencyKey;
  expectedStartTime;
  nextScheduledStartTime;
  parameters;
  autoScheduled;
  context;
  empiricalConfig;
  empiricalPolicy;
  estimatedRunTime;
  estimatedStartTimeDelta;
  totalRunTime;
  startTime;
  endTime;
  name;
  parentTaskRunId;
  stateId;
  stateName;
  stateType;
  state;
  tags;
  runCount;
  created;
  createdBy;
  updated;
  workPoolName;
  workPoolQueueName;
  jobVariables;
  constructor(e) {
    super(), this.id = e.id, this.deploymentId = e.deploymentId, this.flowId = e.flowId, this.deploymentVersionId = e.deploymentVersionId, this.flowName = e.flowName, this.flowVersion = e.flowVersion, this.idempotencyKey = e.idempotencyKey, this.expectedStartTime = e.expectedStartTime, this.nextScheduledStartTime = e.nextScheduledStartTime, this.parameters = e.parameters, this.autoScheduled = e.autoScheduled, this.context = e.context, this.empiricalConfig = e.empiricalConfig, this.empiricalPolicy = e.empiricalPolicy, this.estimatedRunTime = e.estimatedRunTime, this.estimatedStartTimeDelta = e.estimatedStartTimeDelta, this.totalRunTime = e.totalRunTime, this.startTime = e.startTime, this.endTime = e.endTime, this.name = e.name, this.parentTaskRunId = e.parentTaskRunId, this.stateId = e.stateId, this.stateName = e.stateName, this.stateType = e.stateType, this.state = e.state, this.tags = e.tags, this.runCount = e.runCount, this.created = e.created, this.createdBy = e.createdBy, this.updated = e.updated, this.workQueueName = e.workQueueName, this.workPoolName = e.workPoolName, this.workPoolQueueName = e.workPoolQueueName, this.jobVariables = e.jobVariables;
  }
  get duration() {
    return this.estimatedRunTime || this.totalRunTime;
  }
  isScheduled() {
    return this.stateType === "scheduled";
  }
  get delta() {
    return !this.estimatedStartTimeDelta || this.estimatedStartTimeDelta <= 60 ? null : `(${fc(this.estimatedStartTimeDelta)} late)`;
  }
}
class $ee {
  id;
  upstreamDependencies;
  state;
  expectedStartTime;
  estimatedRunTime;
  totalRunTime;
  startTime;
  endTime;
  constructor(e) {
    this.id = e.id, this.upstreamDependencies = e.upstreamDependencies, this.state = e.state, this.expectedStartTime = e.expectedStartTime, this.estimatedRunTime = e.estimatedRunTime, this.totalRunTime = e.totalRunTime, this.startTime = e.startTime, this.endTime = e.endTime;
  }
}
class im {
  timezone;
  interval;
  anchorDate;
  constructor(e) {
    this.timezone = e.timezone, this.interval = e.interval, this.anchorDate = e.anchorDate;
  }
  get raw() {
    return this.interval;
  }
  getIntervals() {
    let e = this.interval;
    const n = {
      seconds: 0,
      minutes: 0,
      hours: 0,
      days: 0
    };
    return n.seconds = e % Oa, e = Vd(e / Oa), n.minutes = e % sh, e = Vd(e / sh), n.hours = e % 24, e = Vd(e / 24), n.days = e, n;
  }
  toString({ verbose: e = !1, neat: n = !0 } = {}) {
    const { seconds: r, minutes: o, hours: s, days: i } = this.getIntervals(), u = [];
    r && (n && r === 1 && !o && !s && !i ? u.push("second") : u.push(`${r} ${Ks("second", r)}`)), o && (n && o === 1 && !r && !s && !i ? u.push("minute") : u.push(`${o} ${Ks("minute", o)}`)), s && (n && s === 1 && !r && !o && !i ? u.push("Hourly") : u.push(`${s} ${Ks("hour", s)}`)), i && (n && i === 1 && !r && !o && !s ? u.push("Daily") : u.push(`${i} ${Ks("day", i)}`));
    let l = u.reverse().join(", ");
    if (!l.includes("Every") && !l.includes("Daily") && !l.includes("Hourly") && (l = `Every ${l}`), this.anchorDate && e) {
      const a = N0(this.anchorDate, i_, this.timezone ?? "UTC"), c = N0(this.anchorDate, u_, this.timezone ?? "UTC");
      l += ` using ${a} at ${c} (${this.timezone ?? "UTC"}) as the anchor date`;
    }
    return l == "" && (l = "None"), l;
  }
  toResponse() {
    const e = this.anchorDate ?? /* @__PURE__ */ new Date(), n = this.timezone ?? "UTC", r = I3(e, n).toISOString();
    return {
      interval: this.interval,
      anchor_date: r,
      timezone: n
    };
  }
}
class jd extends Error {
  constructor() {
    super("SchemaValue is invalid");
  }
}
const RE = [0, 10, 20, 30, 40, 50];
class rF {
  id;
  created;
  updated;
  kind = "log";
  name;
  level;
  message;
  timestamp;
  flowRunId;
  taskRunId;
  workerId;
  constructor(e) {
    this.id = e.id, this.created = e.created, this.updated = e.updated, this.name = e.name, this.level = e.level, this.message = e.message, this.timestamp = e.timestamp, this.flowRunId = e.flowRunId, this.taskRunId = e.taskRunId, this.workerId = e.workerId;
  }
}
class _Le extends Error {
  constructor() {
    super("Schema property has no default value");
  }
}
const wLe = ["all", "active", "paused"];
class oF {
  id;
  created;
  updated;
  isActive;
  stateNames;
  tags;
  blockDocumentId;
  constructor(e) {
    this.id = e.id, this.created = e.created, this.updated = e.updated, this.isActive = e.isActive, this.stateNames = e.stateNames, this.tags = e.tags, this.blockDocumentId = e.blockDocumentId;
  }
}
class sF {
  timezone;
  rrule;
  constructor(e) {
    this.timezone = e.timezone, this.rrule = e.rrule;
  }
  get raw() {
    return this.rrule;
  }
  getRRule() {
    return this.rrule;
  }
  toString() {
    return this.rrule;
  }
  toResponse() {
    return {
      rrule: this.rrule,
      timezone: this.timezone
    };
  }
}
class Gx {
  stateType;
  stateName;
  countRuns;
  sumEstimatedRunTime;
  sumEstimatedLateness;
  constructor(e) {
    this.stateType = e.stateType, this.stateName = e.stateName, this.countRuns = e.countRuns, this.sumEstimatedRunTime = e.sumEstimatedRunTime, this.sumEstimatedLateness = e.sumEstimatedLateness;
  }
}
class aF {
  intervalStart;
  intervalEnd;
  states;
  constructor(e) {
    this.intervalStart = e.intervalStart, this.intervalEnd = e.intervalEnd, this.states = e.states.map((n) => new Gx(n));
  }
}
class Yx {
  id;
  name;
  filters;
  constructor(e) {
    this.id = e.id, this.name = e.name, this.filters = e.filters;
  }
}
function Wee(t) {
  return Qx(t) || um(t) || lm(t);
}
function Qx(t) {
  return typeof t == "object" && t !== null && "rrule" in t;
}
function um(t) {
  return typeof t == "object" && t !== null && "cron" in t;
}
function lm(t) {
  return typeof t == "object" && t !== null && "interval" in t;
}
const bLe = ["rrule", "cron", "interval"];
function Vee(t) {
  if (Wee(t)) {
    if (Qx(t))
      return "rrule";
    if (um(t))
      return "cron";
    if (lm(t))
      return "interval";
  }
  return null;
}
class Hee {
  inputType;
  type;
  constructor(e) {
    this.inputType = e.inputType, this.type = e.type;
  }
}
class jee {
  inputType;
  name;
  constructor(e) {
    this.inputType = e.inputType, this.name = e.name;
  }
}
class zee {
  inputType;
  id;
  constructor(e) {
    this.inputType = e.inputType, this.id = e.id;
  }
}
class iF {
  id;
  flowRunId;
  kind = "taskRun";
  cacheExpiration;
  cacheKey;
  created;
  dynamicKey;
  empiricalPolicy;
  estimatedRunTime;
  estimatedStartTimeDelta;
  totalRunTime;
  expectedStartTime;
  nextScheduledStartTime;
  runCount;
  name;
  taskInputs;
  taskKey;
  taskVersion;
  updated;
  startTime;
  endTime;
  stateId;
  stateType;
  stateName;
  state;
  tags;
  constructor(e) {
    this.id = e.id, this.flowRunId = e.flowRunId, this.cacheExpiration = e.cacheExpiration, this.cacheKey = e.cacheKey, this.created = e.created, this.dynamicKey = e.dynamicKey, this.empiricalPolicy = e.empiricalPolicy, this.estimatedRunTime = e.estimatedRunTime, this.estimatedStartTimeDelta = e.estimatedStartTimeDelta, this.totalRunTime = e.totalRunTime, this.expectedStartTime = e.expectedStartTime, this.nextScheduledStartTime = e.nextScheduledStartTime, this.runCount = e.runCount, this.name = e.name, this.taskInputs = e.taskInputs, this.taskKey = e.taskKey, this.taskVersion = e.taskVersion, this.updated = e.updated, this.startTime = e.startTime, this.endTime = e.endTime, this.stateId = e.stateId, this.stateType = e.stateType, this.stateName = e.stateName, this.state = e.state, this.tags = e.tags;
  }
  get duration() {
    return (this.estimatedRunTime && this.estimatedRunTime > 0 ? this.estimatedRunTime : this.totalRunTime) ?? 0;
  }
}
const Kx = 255, Zx = 5e3;
class qee {
  id;
  kind = "variable";
  created;
  updated;
  name;
  value;
  tags;
  get valueString() {
    return JSON.stringify(this.value);
  }
  constructor(e) {
    this.id = e.id, this.name = e.name, this.value = e.value, this.tags = e.tags, this.created = e.created, this.updated = e.updated;
  }
}
class Jx {
  id;
  kind = "workPool";
  created;
  updated;
  name;
  description;
  type;
  isPaused;
  isPushPool;
  isMexPool;
  defaultQueueId;
  concurrencyLimit;
  baseJobTemplate;
  status;
  can;
  constructor(e) {
    this.id = e.id, this.created = e.created, this.updated = e.updated, this.name = e.name, this.description = e.description, this.type = e.type, this.isPaused = e.isPaused, this.isPushPool = e.isPushPool, this.isMexPool = e.isMexPool, this.defaultQueueId = e.defaultQueueId, this.concurrencyLimit = e.concurrencyLimit, this.baseJobTemplate = e.baseJobTemplate, this.status = e.status, this.can = e.can;
  }
  get typeLabel() {
    return Hm(this.type);
  }
}
const { values: uF, isValue: kLe } = to(["ready", "paused", "not_ready"]);
function e2(t) {
  switch (t) {
    case "not_ready":
      return "Not Ready";
    case "paused":
      return "Paused";
    case "ready":
      return "Ready";
    default:
      const e = t;
      throw new Error(`getWorkPoolStatusLabel missing case for ${e}`);
  }
}
class t2 {
  id;
  kind = "queue";
  created;
  updated;
  workPoolId;
  workPoolName;
  name;
  description;
  isPaused;
  concurrencyLimit;
  priority;
  lastPolled;
  status;
  can;
  constructor(e) {
    this.id = e.id, this.created = e.created, this.updated = e.updated, this.workPoolId = e.workPoolId, this.workPoolName = e.workPoolName, this.name = e.name, this.description = e.description, this.isPaused = e.isPaused, this.concurrencyLimit = e.concurrencyLimit, this.priority = e.priority, this.lastPolled = e.lastPolled, this.status = e.status, this.can = e.can;
  }
}
class Gee extends t2 {
  disabled;
  constructor(e) {
    super(e), this.disabled = e.disabled;
  }
}
const { values: U0, isValue: Yee } = to(["ready", "not_ready", "paused"]), { values: TLe, isValue: Qee } = to(["READY", "NOT_READY", "PAUSED"]);
function n2(t) {
  switch (t) {
    case "not_ready":
      return "Not Ready";
    case "paused":
      return "Paused";
    case "ready":
      return "Ready";
    default:
      const e = t;
      throw new Error(`getWorkPoolStatusLabel missing case for ${e}`);
  }
}
class lF {
  id;
  kind = "worker";
  created;
  updated;
  name;
  workPoolId;
  lastHeartbeatTime;
  status;
  heartbeatIntervalSeconds;
  clientVersion;
  metadata;
  constructor(e) {
    this.id = e.id, this.created = e.created, this.updated = e.updated, this.name = e.name, this.workPoolId = e.workPoolId, this.lastHeartbeatTime = e.lastHeartbeatTime, this.status = e.status, this.heartbeatIntervalSeconds = e.heartbeatIntervalSeconds, this.clientVersion = e.clientVersion, this.metadata = e.metadata;
  }
}
const AE = ["online", "offline"];
function cF(t) {
  return t.startsWith("prefect.") || t.startsWith("prefect-cloud.") ? t.split(".").slice(1).join(".") : t;
}
function pF(t) {
  const e = new RegExp(`^(${dF.join("|")})\\.`, "g"), [, n = ""] = e.exec(t) ?? [], r = n.split(".").at(-1);
  return ete(r) ? r : null;
}
function r2(t) {
  const e = Zee(t) ?? t.split(".").at(-1) ?? null, n = t.split(".").at(-2) ?? null, r = pF(t);
  return {
    id: e,
    type: n,
    role: r
  };
}
function Kee(t) {
  const e = [], n = t.split(".");
  for (let r = 1; r < n.length; r++) {
    const o = n.slice(0, r).join(".");
    e.push(`${o}.*`);
  }
  return [...e, t];
}
function Zee(t) {
  const e = /([a-f0-9]{8}(?:-[a-f0-9]{4}){3}-[a-f0-9]{12})/i, [n = null] = e.exec(t) ?? [];
  return n;
}
const { values: dF } = to([
  "prefect.block-document",
  "prefect.deployment",
  "prefect.flow-run",
  "prefect.flow",
  "prefect.task-run",
  "prefect.work-queue",
  "prefect.work-pool",
  "prefect.tag",
  "prefect.concurrency-limit",
  "prefect.artifact-collection",
  "prefect.automation",
  "prefect.creator",
  // cloud only but here for simplicity
  "prefect-cloud.actor",
  "prefect-cloud.automation",
  "prefect-cloud.workspace",
  "prefect-cloud.webhook"
]), Jee = dF.map((t) => t.split(".").at(-1));
function ete(t) {
  return Jee.includes(t);
}
class hF {
  id;
  account;
  event;
  occurred;
  payload;
  received;
  related;
  resource;
  workspace;
  constructor(e) {
    this.id = e.id, this.account = e.account, this.event = e.event, this.occurred = e.occurred, this.payload = e.payload, this.received = e.received, this.related = e.related, this.resource = e.resource, this.workspace = e.workspace;
  }
  getRelatedByRole(e) {
    return this.related.find((n) => n["prefect.resource.role"] === e) ?? null;
  }
  get email() {
    return this.getRelatedByRole("actor")?.["prefect-cloud.email"] ?? "";
  }
  get actorName() {
    return this.getRelatedByRole("actor")?.["prefect-cloud.name"] ?? null;
  }
  get workspaceHandle() {
    return this.getRelatedByRole("workspace")?.["prefect-cloud.handle"] ?? "";
  }
  get occurredFormatted() {
    return qs(this.occurred);
  }
  get eventPrefectWithoutPrefix() {
    return cF(this.event);
  }
  get eventLabel() {
    const e = this.eventPrefectWithoutPrefix.replaceAll(/[_.-]/g, " ");
    return hj(e.toLocaleLowerCase());
  }
  get occurredDate() {
    return Xo(this.occurred);
  }
  get occurredTime() {
    return $3(this.occurred);
  }
  get resourceId() {
    return this.resource["prefect.resource.id"];
  }
}
function M1(t) {
  return t instanceof hF;
}
class tte {
  events;
  nextPage;
  total;
  constructor(e) {
    this.events = e.events, this.nextPage = e.nextPage, this.total = e.total;
  }
  get nextPageToken() {
    return this.nextPage === null ? null : this.nextPage.split("next")[1];
  }
  get pages() {
    return this.events.length === 0 ? 0 : Math.ceil(this.total / 50);
  }
}
class nte {
  count;
  label;
  value;
  startTime;
  endTime;
  constructor(e) {
    this.count = e.count, this.label = e.label, this.value = e.value, this.startTime = e.startTime, this.endTime = e.endTime;
  }
  get eventPrefectWithoutPrefix() {
    return cF(this.label);
  }
}
const { values: xLe, isValue: SLe } = to(["FrequencySla", "LatenessSla", "TimeToCompletionSla"]);
class rte {
  id;
  name;
  description;
  enabled;
  trigger;
  severity;
  type;
  created;
  updated;
  account;
  workspace;
  actor;
  constructor(e) {
    this.id = e.id, this.name = e.name, this.description = e.description, this.enabled = e.enabled, this.trigger = e.trigger, this.created = e.created, this.updated = e.updated, this.account = e.account, this.workspace = e.workspace, this.actor = e.actor, this.severity = e.severity, this.type = e.type;
  }
  durationInSeconds() {
    return this.trigger.within;
  }
  getSlaDefinitionKeyValuePairs() {
    switch (this.type) {
      case "FrequencySla":
        return [{ key: "Stale After", value: _p(this.trigger.within) }];
      case "LatenessSla":
        return [{ key: "Within", value: _p(this.trigger.within) }];
      case "TimeToCompletionSla":
        return [{ key: "Duration", value: _p(this.trigger.within) }];
      default:
        return [];
    }
  }
  getDisplaySlaType() {
    switch (this.type) {
      case "FrequencySla":
        return "Frequency";
      case "LatenessSla":
        return "Lateness";
      case "TimeToCompletionSla":
        return "Time to Completion";
      default:
        return "Time to Completion";
    }
  }
}
class ote extends qn {
  routePrefix = "/work_pools/";
  async createWorkPool(e) {
    const n = ye.map("WorkPoolCreate", e, "WorkPoolCreateRequest"), { data: r } = await this.post("/", n);
    return ye.map("WorkPoolResponse", r, "WorkPool");
  }
  async getWorkPoolByName(e) {
    const n = encodeURI(e), { data: r } = await this.get(`/${n}`);
    return ye.map("WorkPoolResponse", r, "WorkPool");
  }
  async getWorkPools(e = {}) {
    const n = ye.map("WorkPoolsFilter", e, "WorkPoolsFilterRequest"), { data: r } = await this.post("/filter", n);
    return ye.map("WorkPoolResponse", r, "WorkPool");
  }
  async getWorkPoolsCount(e = {}) {
    const n = ye.map("WorkPoolsFilter", e, "WorkPoolsFilterRequest"), { data: r } = await this.post("/count", n);
    return r;
  }
  async getWorkPoolById(e) {
    const n = {
      workPools: {
        id: [e]
      }
    }, r = ye.map("WorkPoolsFilter", n, "WorkPoolsFilterRequest"), { data: o } = await this.post("/filter", r), [s] = o;
    if (!s.id)
      throw new m8(e);
    return ye.map("WorkPoolResponse", s, "WorkPool");
  }
  updateWorkPool(e, n) {
    const r = ye.map("WorkPoolEdit", n, "WorkPoolEditRequest"), o = encodeURI(e);
    return this.patch(`/${o}`, r);
  }
  pauseWorkPool(e) {
    const n = encodeURI(e);
    return this.patch(`/${n}`, { is_paused: !0 });
  }
  resumeWorkPool(e) {
    const n = encodeURI(e);
    return this.patch(`/${n}`, { is_paused: !1 });
  }
  deleteWorkPool(e) {
    const n = encodeURI(e);
    return this.delete(`/${n}`);
  }
  async getWorkPoolScheduledRuns(e, n) {
    const r = ye.map("WorkerScheduledFlowRuns", n, "WorkerScheduledFlowRunsRequest"), o = encodeURI(e), { data: s } = await this.post(`/${o}/get_scheduled_flow_runs`, r);
    return ye.map("WorkerScheduledFlowRunResponse", s, "WorkerScheduledFlowRun");
  }
  async getWorkPoolLateRuns(e, n) {
    return (await this.getWorkPoolScheduledRuns(e, n)).filter((o) => o.flowRun.stateName === "Late");
  }
}
class ste extends qn {
  routePrefix = "/work_pools/";
  async getWorkers(e, n = {}) {
    const r = ye.map("WorkPoolWorkersFilter", n, "WorkPoolWorkersFilterRequest"), o = encodeURI(e), { data: s } = await this.post(`/${o}/workers/filter`, r);
    return ye.map("WorkPoolWorkerResponse", s, "WorkPoolWorker");
  }
  async getWorkersPaginated(e, n = {}) {
    const r = ye.map("WorkPoolWorkersPagination", n, "WorkPoolWorkersPaginationRequest"), o = encodeURI(e), { data: s } = await this.post(`/${o}/workers/paginate`, r);
    return ye.map("WorkPoolWorkersPaginationResponse", s, "PaginatedWorkPoolWorkers");
  }
  async getWorker(e, n) {
    const r = encodeURI(e), { data: o } = await this.get(`/${r}/workers/${n}`);
    return ye.map("WorkPoolWorkerResponse", o, "WorkPoolWorker");
  }
  deleteWorker(e) {
    const n = encodeURI(e.workPoolName), r = encodeURI(e.workerName);
    return this.delete(`/${n}/workers/${r}`);
  }
}
class ate extends qn {
  routePrefix = "/work_queues";
  idBatcher = new hi(async (e) => {
    if (e.length === 1) {
      const [r] = e, { data: o } = await this.get(`/${r}`);
      return () => ye.map("WorkPoolQueueResponse", o, "WorkPoolQueue");
    }
    const n = await this.getWorkQueues({
      workQueues: {
        id: e
      }
    });
    return cu(n, "id");
  }, { maxBatchSize: 200 });
  nameBatcher = new hi(async (e) => {
    if (e.length === 1) {
      const [r] = e, { data: o } = await this.get(`/name/${r}`);
      return () => ye.map("WorkPoolQueueResponse", o, "WorkPoolQueue");
    }
    const n = await this.getWorkQueues({
      workQueues: {
        name: e
      }
    });
    return cu(n, "id");
  }, { maxBatchSize: 200 });
  getWorkQueue(e) {
    return this.idBatcher.batch(e);
  }
  getWorkQueueByName(e) {
    return this.nameBatcher.batch(e);
  }
  async getWorkQueues(e) {
    const n = ye.map("WorkPoolQueuesFilter", e, "WorkPoolQueuesFilterRequest"), { data: r } = await this.post("/filter", n);
    return ye.map("WorkPoolQueueResponse", r, "WorkPoolQueue");
  }
  /** @deprecated Prefer `WorkspaceWorkPoolQueuesApi.createWorkPoolQueue` */
  async createWorkQueue(e) {
    const n = ye.map("WorkPoolQueueCreate", e, "WorkPoolQueueCreateRequest"), { data: r } = await this.post("/", n);
    return ye.map("WorkPoolQueueResponse", r, "WorkPoolQueue");
  }
  /** @deprecated Prefer `WorkspaceWorkPoolQueuesApi.pauseWorkPoolQueue` */
  pauseWorkQueue(e) {
    return this.patch(`/${e}`, { is_paused: !0 });
  }
  /** @deprecated Prefer `WorkspaceWorkPoolQueuesApi.resumeWorkPoolQueue` */
  resumeWorkQueue(e) {
    return this.patch(`/${e}`, { is_paused: !1 });
  }
  /** @deprecated Prefer `WorkspaceWorkPoolQueuesApi.updateWorkPoolQueue` */
  updateWorkQueue(e, n) {
    const r = ye.map("WorkPoolQueueEdit", n, "WorkPoolQueueEditRequest");
    return this.patch(`/${e}`, r);
  }
  /** @deprecated Prefer `WorkspaceWorkPoolQueuesApi.deleteWorkPoolQueue` */
  deleteWorkQueue(e) {
    return this.delete(`/${e}`);
  }
  async getRuns(e) {
    const { data: n } = await this.post(`/${e}/get_runs`);
    return ye.map("FlowRunResponse", n, "FlowRun");
  }
}
function RLe(t, e = null) {
  return {
    artifacts: Fn(new rG(t, e)),
    automations: Fn(new iG(t, e)),
    blockCapabilities: Fn(new lG(t, e)),
    blockDocuments: Fn(new cG(t, e)),
    blockSchemas: Fn(new pG(t, e)),
    blockTypes: Fn(new dG(t, e)),
    collections: Fn(new xce(t, e)),
    concurrencyLimits: Fn(new hG(t, e)),
    concurrencyV2Limits: Fn(new fG(t, e)),
    deployments: Fn(new wG(t, e)),
    deploymentSchedules: Fn(new bG(t, e)),
    flowRuns: Fn(new zJ(t, e)),
    flowRunStates: Fn(new nde(t, e)),
    flows: Fn(new qJ(t, e)),
    health: Fn(new Zq(t, e)),
    logs: Fn(new GJ(t, e)),
    notifications: Fn(new YJ(t, e)),
    savedSearches: Fn(new QJ(t, e)),
    taskRuns: Fn(new cee(t, e)),
    taskRunStates: Fn(new rde(t, e)),
    ui: Fn(new nG(t, e)),
    variables: Fn(new pee(t, e)),
    workPoolQueues: Fn(new dee(t, e)),
    workPools: Fn(new ote(t, e)),
    workPoolWorkers: Fn(new ste(t, e)),
    workQueues: Fn(new ate(t, e)),
    schemas: Fn(new lee(t, e)),
    events: Fn(new jJ(t, e))
  };
}
const ite = Symbol("WorkspaceApi");
function fF(t) {
  return typeof t == "boolean";
}
const ute = 5, mF = "cache-key", o2 = `${mF}-${ute}`;
function c_(t) {
  return `${o2}:${t}`;
}
function ALe(t, e) {
  const n = `${o2}-${e}___`, r = `${n}-${t}`;
  return lte(n, r), (o) => `${r}-${o}`;
}
function lte(t, e) {
  const n = (r) => r.startsWith(t) && !r.startsWith(e);
  Object.keys(sessionStorage).forEach((r) => {
    n(r) && sessionStorage.removeItem(r);
  }), Object.keys(localStorage).forEach((r) => {
    n(r) && localStorage.removeItem(r);
  });
}
function cte(t) {
  return t.startsWith(mF);
}
function DE(t) {
  return cte(t) ? !t.startsWith(o2) : !1;
}
function pte() {
  Object.keys(sessionStorage).forEach((n) => {
    DE(n) && sessionStorage.removeItem(n);
  }), Object.keys(localStorage).forEach((n) => {
    DE(n) && localStorage.removeItem(n);
  });
}
const s2 = [
  "achromatopsia",
  "deuteranopia",
  "deuteranomaly",
  "protaponia",
  "protanomaly",
  "tritanomaly",
  "tritanopia"
], yF = ge(null);
function kk(t) {
  return `color-mode-${t ?? "default"}`;
}
function EE(t) {
  return typeof t != "string" ? !1 : s2.includes(t);
}
function DLe(t) {
  s2.forEach((n) => document.body.classList.remove(kk(n)));
  const e = kk(t);
  document.body.classList.add(e), yF.value = t;
}
function dte() {
  return {
    value: SI(yF)
  };
}
function wt(...[t, e]) {
  return {
    component: t,
    props: e
  };
}
function hte(t, ...[e, n]) {
  return {
    component: e,
    props: n
  };
}
function fte(t) {
  return function(...e) {
    return hte(t, ...e);
  };
}
function gF(t, e = "Copied to clipboard!") {
  navigator.clipboard.writeText(t), He(e, "success");
}
const mte = {
  docs: {
    artifacts: "https://docs.prefect.io/latest/concepts/artifacts/",
    gettingStarted: "https://docs.prefect.io/latest/getting-started/overview/",
    flows: "https://docs.prefect.io/latest/concepts/flows/",
    flowRuns: "https://docs.prefect.io/latest/develop/write-flows#flow-runs",
    blocks: "https://docs.prefect.io/latest/concepts/blocks/",
    workQueues: "https://docs.prefect.io/latest/deploy/infrastructure-concepts/work-pools#work-queues",
    notifications: "https://docs.prefect.io/latest/guides/host/#devex-notifications",
    deployments: "https://docs.prefect.io/latest/concepts/deployments/",
    concurrency: "https://docs.prefect.io/latest/develop/write-tasks#concurrency",
    globalConcurrency: "https://docs.prefect.io/latest/guides/global-concurrency-limits/",
    automations: "https://docs.prefect.io/latest/automate/events/automations-triggers",
    automationTriggers: "https://docs.prefect.io/latest/automate/events/automations-triggers#triggers",
    workPools: "https://docs.prefect.io/latest/concepts/work-pools/",
    collections: "https://docs.prefect.io/integrations/integrations/",
    resultsPersistence: "https://docs.prefect.io/latest/develop/results#configuring-result-persistence",
    infrastructure: "https://docs.prefect.io/latest/concepts/infrastructure/",
    variables: "https://docs.prefect.io/latest/guides/variables/"
  },
  error: {
    activateDeployment: "Failed to activate deployment",
    activateDeploymentSchedule: "Failed to activate deployment schedule",
    activateNotification: "Failed to activate notification",
    activateWorkPool: "Failed to activate work pool",
    activateWorkPoolQueue: "Failed to activate work queue",
    activateWorkQueue: "Failed to activate work queue",
    cancelFlowRun: "Failed to cancel flow run",
    cancelFlowRuns: (t) => `Failed to cancel ${t} sub flow runs`,
    changeFlowRunState: "Failed to change flow run state",
    changeTaskRunState: "Failed to change task run state",
    createBlock: "Failed to create block",
    readFlowRuns: "Something went wrong loading flow runs, please try again.",
    createConcurrencyLimit: "Failed to create concurrency limit",
    resetConcurrencyLimit: "Failed to reset concurrency limit",
    resetConcurrencyV2Limit: "Failed to reset concurrency limit",
    createNotification: "Failed to create notification",
    createSavedSearch: "Failed to create saved filter",
    createSchedule: "Failed to create schedule",
    createVariable: "Failed to create variable",
    createWorkPool: "Failed to create work pool",
    createWorkPoolQueue: "Failed to create work queue",
    createWorkQueue: "Failed to create work queue",
    delete: (t) => `Failed to delete ${t}`,
    deleteSavedSearch: "Failed to delete saved filter",
    disableDeployment: "Failed to disable deployment",
    enableDeployment: "Failed to enable deployment",
    editVariable: "Failed to updated variable",
    duplicateVariable: "Failed to duplicate variable",
    invalidJSON: "Invalid JSON",
    pauseDeployment: "Failed to pause deployment",
    pauseDeploymentSchedule: "Failed to deactivate deployment schedule",
    pauseNotification: "Failed to pause notification",
    pauseWorkPool: "Failed to pause work pool",
    pauseWorkPoolQueue: "Failed to pause work queue",
    pauseWorkQueue: "Failed to pause work queue",
    removeSchedule: "Failed to remove schedule",
    resumeFlowRun: "Failed to resume flow run",
    retryRun: "Failed to retry flow run",
    scheduleFlowRun: "Failed to schedule flow run",
    scheduleSlugAlreadyExists: "A schedule with this slug already exists for this deployment",
    arrayValueTooLong: (t, e) => `${t} must have fewer than ${e} items`,
    stringValueTooLong: (t, e) => `${t} must be less than or equal to ${e} characters`,
    numberValueTooLarge: (t, e) => `${t} must be less than or equal to ${e}`,
    valueTooLarge: (t, e) => `${t} must be less than or equal to ${e}`,
    mustBeSnakeCase: (t) => `${t} may only contain letters, numbers, and underscores and may not begin or end with an underscore`,
    mustBeSlug: (t) => `${t} may only contain letters, numbers, dashes, and underscores and may not begin or end with a dash or underscore`,
    submitNotification: "Failed to submit notification",
    suspendFlowRun: "Failed to suspend flow run",
    updateBlock: "Failed to update block",
    updateConcurrencyLimit: "Failed to update concurrency limit",
    updateDeploymentSchedule: "Failed to update deployment schedule",
    updateNotification: "Failed to update notification",
    updateSchedule: "Failed to update schedule",
    updateWorkPool: "Failed to update work pool",
    updateWorkPoolQueue: "Failed to update work queue",
    updateWorkQueue: "Failed to update work queue",
    variableAlreadyExists: "A variable with this name already exists",
    automationToggle: (t) => t ? "Sorry, something went wrong enabling your automation" : "Sorry, something went wrong disabling your automation",
    automationDelete: "Sorry, something went wrong deleting your automation",
    automationCreate: "Sorry, something went wrong creating your automation",
    automationUpdate: "Sorry, something went wrong updating your automation"
  },
  success: {
    activateDeployment: "Deployment active",
    activateDeploymentSchedule: "Deployment schedule active",
    activateNotification: "Notification active",
    activateWorkPool: "Work pool active",
    activateWorkPoolQueue: "Work queue active",
    activateWorkQueue: "Work queue active",
    cancelFlowRun: "Flow run cancelled",
    changeFlowRunState: "Flow run state changed",
    changeTaskRunState: "Task run state changed",
    createBlock: "Block created",
    createConcurrencyLimit: "Concurrency limit added",
    resetConcurrencyLimit: "Concurrency limit reset",
    resetConcurrencyV2Limit: "Concurrency limit reset",
    createNotification: "Notification created",
    createSavedSearch: "Filter saved",
    createSchedule: "Schedule added",
    createVariable: "Variable created",
    createWorkPool: "Work pool created",
    createWorkPoolQueue: "Work queue created",
    createWorkQueue: "Work queue created",
    delete: (t) => `${t} deleted`,
    deleteSavedSearch: "Saved filter deleted",
    disableDeployment: "Deployment disabled",
    enableDeployment: "Deployment enabled",
    editVariable: "Variable updated",
    duplicateVariable: "Variable duplicated",
    pauseDeployment: "Deployment paused",
    pauseDeploymentSchedule: "Deployment schedule inactive",
    pauseNotification: "Notification paused",
    pauseWorkPool: "Work pool paused",
    pauseWorkPoolQueue: "Work queue paused",
    pauseWorkQueue: "Work queue paused",
    removeSchedule: "Schedule removed",
    resumeFlowRun: "Flow run resumed",
    retryRun: "Retrying run",
    scheduleFlowRun: "Flow run scheduled",
    suspendFlowRun: "Flow run suspended",
    updateBlock: "Block updated",
    updateDeploymentSchedule: "Deployment schedule updated",
    updateNotification: "Notification updated",
    updateConcurrencyLimit: "Concurrency limit updated",
    updateSchedule: "Schedule updated",
    updateWorkPool: "Work pool updated",
    updateWorkPoolQueue: "Work queue updated",
    updateWorkQueue: "Work queue updated",
    automationEnable: (t = !0) => t ? "Automation enabled" : "Automation disabled",
    automationDelete: "Automation deleted",
    automationCreate: "Automation created",
    automationUpdate: "Automation updated"
  },
  info: {
    form: "Form",
    json: "JSON",
    schemaHasNoProperties: "This schema has no properties",
    filtersActive: "Filters active",
    resetFilters: "Reset filters",
    deploymentName: "Deployment name",
    deploymentDisabled: "Deployment disabled, click to enable",
    deploymentEnabled: "Deployment enabled, click to disable",
    deploymentUpdateDisabled: "You do not have the right permissions to update this deployment",
    searchByDeploymentName: "Search by deployment name",
    workPools: "Work Pools",
    all: "All",
    active: "Active",
    inactive: "Inactive",
    lastFlowRunState: "Last Flow Run State",
    lastFlowRunStart: "Last Flow Run Start",
    schedule: "Schedule",
    with: "with",
    artifact: "Artifact",
    artifacts: "Artifacts",
    artifactsEmptyState: "Artifacts are byproducts of your runs; they can be anything from a markdown string to a table.",
    parameters: "Parameters",
    parameterOverrides: "Parameter Overrides",
    addTagPlaceholder: "Add tag (press enter to submit)",
    descriptionPlaceholder: "Add a description (supports Markdown)",
    parentRun: "Parent Run",
    flow: "Flow",
    searchByFlowName: "Search by flow name",
    deploymentTags: "Deployment tags",
    artifactSearch: "Search artifacts",
    variablesSearch: "Search variables",
    artifactCreated: (t) => `Created __${t}__`,
    artifactTypeChanged: (t) => `Changed to \`${t}\` artifact`,
    newVariable: "New variable",
    editVariable: (t) => `Edit ${t}`,
    duplicateVariable: (t) => `Duplicate ${t}`,
    deployment: "Deployment",
    close: "Close",
    save: "Save",
    name: "Name",
    thisVariable: "this variable",
    theseVariables: "these variables",
    value: "Value",
    latest: "Latest",
    item: "Item",
    noData: "No data",
    noVariables: "No variables",
    noDeployments: "No deployments",
    noFlowsOrDeploymentsMatchFilter: "No flows or deployments match your filters",
    deploymentsEmptyStateDescription: (t = "flows") => `Create a deployment to begin remotely managing __${t}__`,
    copyId: "Copy ID",
    copyName: "Copy name",
    copyValue: "Copy value",
    edit: "Edit",
    noSchedule: "No schedule",
    duplicate: "Duplicate",
    delete: "Delete",
    tags: "Tags",
    values: "Values",
    nextRun: "Next run",
    lastRun: "Last run",
    workPool: "Work Pool",
    workQueue: "Work Queue",
    filterByTags: "Filter by tags",
    invalidData: (t) => `Invalid data, see [documentation](${t}) for more information`,
    result: "Result",
    noResults: "No tracked results, enable [result persistence](https://docs.prefect.io/concepts/results/#persisting-results) to track results.",
    none: "None",
    noDescription: "No description",
    dashboardWorkPoolCardTitle: "Active Work Pools",
    dashboardWorkPoolCardEmpty: "There are no active work pools to show. Any work pools you do have are paused.",
    dashboardWorkPoolCardViewAll: "View all work pools",
    percentChangeOverTimePeriod: (t) => `${t}% change compared to the previous time period.`,
    jobVariables: "Job Variables",
    terminalTaskRunNoArtifacts: "This task run did not produce any artifacts; for more information on creating artifacts, see the [documentation](https://docs.prefect.io/concepts/artifacts).",
    nonTerminalTaskRunNoArtifacts: "This task run has not yet produced artifacts; for more information on creating artifacts, see the [documentation](https://docs.prefect.io/concepts/artifacts).",
    terminalFlowRunNoArtifacts: "This run did not produce any artifacts; for more information on creating artifacts, see the [documentation](https://docs.prefect.io/concepts/artifacts).",
    nonTerminalFlowRunNoArtifacts: "This run has not yet produced artifacts; for more information on creating artifacts, see the [documentation](https://docs.prefect.io/concepts/artifacts).",
    flowRun: "Flow run",
    taskRun: "Task run",
    taskRuns: "Task runs",
    variable: "Variable",
    variables: "Variables",
    created: "Created",
    create: "Create",
    lastUpdated: "Last Updated",
    deprecatedWorkQueue: "This work queue uses a deprecated tag-based approach to matching flow runs; it will continue to work but you can't modify it",
    deploymentMissingWorkQueue: "This deployment doesn't have an associated work queue; runs will be scheduled but won't be picked up by your agents",
    taskInput: "Task inputs show parameter keys and can also show task run relationships.",
    workPoolInfrastructureConfigurationInstructions: `Below you can configure defaults for deployments that use this work pool. Use the editor in the **Advanced** section to modify the existing configuration options, if needed.
If you don't need to change the default configuration, click **Create** to create your work pool!`,
    workPoolInfrastructureConfigurationAgent: `Prefect Agents handle infrastructure configuration via infrastructure blocks attached to deployments. You can hit **Create** to create this work pool and then head over to the **Blocks** tab to create an infrastructure block for your deployments.
To learn more about how to configure infrastructure for Prefect Agents, check out the [docs](https://docs.prefect.io/latest/concepts/infrastructure/).`,
    disableFlowRunCancel: "Only runs created from a deployment can be cancelled",
    flowRunGraphNotDisplayedHeader: "Manual graph rendering",
    flowRunGraphNotDisplayedCopy: "Large graphs are hidden by default. They may take time to generate and in extreme circumstances, may impact browser performance.",
    flowRunGraphNotDisplayedCta: "Display graph",
    removeTagFromFilter: "Remove tag from filter",
    filterByTag: "Filter by tag",
    removeResourceFromFilter: "Remove resource from filter",
    filterByResource: "Filter by resource"
  }
};
function yte(t) {
  return mte;
}
const le = yte("en");
function gte(t) {
  if (!bx(t) || !Vt(t.response))
    return !1;
  const { data: e } = t.response;
  return wn(e) && Ht(e.detail);
}
function vte(t) {
  if (!bx(t) || !Vt(t.response))
    return !1;
  const { data: e } = t.response;
  return wn(e) && e.exception_message === "Invalid request received.";
}
function _te(t) {
  return t.response.data.exception_detail[0].msg;
}
function Yt(t, e) {
  return gte(t) ? t.response.data.detail : vte(t) ? _te(t) : e;
}
async function Ua(t, e, n) {
  let r;
  try {
    const o = tl(t);
    return r = await e(...o), He(le.success.delete(n), "success"), r;
  } catch (o) {
    const s = Yt(o, le.error.delete(n.toLowerCase()));
    He(s, "error"), console.error(o);
  }
}
function ELe(t) {
  return typeof t == "function";
}
function p_(t) {
  const e = Wv(t);
  if (e === void 0)
    throw `Failed to inject value with key ${String(t)}`;
  return e;
}
function wte(t) {
  const n = RI()?.provides[t];
  return n !== void 0 ? n : p_(t);
}
function or(t, e) {
  return JSON.stringify(t, e, 2);
}
function ME(t) {
  try {
    const e = JSON.parse(t);
    return wn(e);
  } catch {
    return !1;
  }
}
function vF(t) {
  try {
    return JSON.parse(t), !0;
  } catch {
    return !1;
  }
}
function bte(t) {
  const [e] = t.toString();
  switch (e) {
    case "5":
      return "Critical";
    case "4":
      return "Error";
    case "3":
      return "Warning";
    case "2":
      return "Info";
    case "1":
      return "Debug";
    default:
      return "Custom";
  }
}
const kte = {
  // Regular colors
  30: "text-black dark:text-black",
  31: "text-red-600 dark:text-red-500",
  32: "text-green-600 dark:text-green-500",
  33: "text-yellow-600 dark:text-yellow-500",
  34: "text-blue-600 dark:text-blue-500",
  35: "text-purple-600 dark:text-purple-500",
  36: "text-cyan-600 dark:text-cyan-500",
  37: "text-gray-50 dark:text-gray-100",
  // Bright colors
  90: "text-gray-500 dark:text-gray-300",
  91: "text-red-500 dark:text-red-300",
  92: "text-green-500 dark:text-green-300",
  93: "text-yellow-500 dark:text-yellow-300",
  94: "text-blue-500 dark:text-blue-300",
  95: "text-purple-500 dark:text-purple-300",
  96: "text-cyan-500 dark:text-cyan-300",
  97: "text-white",
  // Background colors
  40: "bg-black",
  41: "bg-red-500",
  42: "bg-green-500",
  43: "bg-yellow-500",
  44: "bg-blue-500",
  45: "bg-purple-500",
  46: "bg-cyan-500",
  47: "bg-gray-100",
  // Bright background colors
  100: "bg-gray-300",
  101: "bg-red-300",
  102: "bg-green-300",
  103: "bg-yellow-300",
  104: "bg-blue-300",
  105: "bg-purple-300",
  106: "bg-cyan-300",
  107: "bg-white",
  // Text styling
  1: "font-bold",
  2: "opacity-75",
  3: "italic",
  4: "underline",
  9: "line-through",
  // Reset
  0: ""
}, Tte = /\u001b\[(\d+)m/g;
function ih(t) {
  return typeof t == "number";
}
function _F(t, e) {
  const n = t / e, r = Math.round((n + Number.EPSILON) * 1e4) / 100;
  if (!isNaN(r))
    return r;
}
function xte(t = {}) {
  return JJ(t, (e, n) => {
    const { default: r, ...o } = n;
    return [e, o];
  });
}
function Ste(t) {
  return {
    ...t,
    properties: xte(t.properties)
  };
}
var P1, PE;
function Rte() {
  if (PE) return P1;
  PE = 1;
  var t = "[object Symbol]", e = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g, n = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, r = "\\ud800-\\udfff", o = "\\u0300-\\u036f\\ufe20-\\ufe23", s = "\\u20d0-\\u20f0", i = "\\u2700-\\u27bf", u = "a-z\\xdf-\\xf6\\xf8-\\xff", l = "\\xac\\xb1\\xd7\\xf7", a = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", c = "\\u2000-\\u206f", p = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", d = "A-Z\\xc0-\\xd6\\xd8-\\xde", h = "\\ufe0e\\ufe0f", m = l + a + c + p, g = "['’]", _ = "[" + r + "]", b = "[" + m + "]", x = "[" + o + s + "]", S = "\\d+", E = "[" + i + "]", A = "[" + u + "]", C = "[^" + r + m + S + i + u + d + "]", M = "\\ud83c[\\udffb-\\udfff]", L = "(?:" + x + "|" + M + ")", X = "[^" + r + "]", te = "(?:\\ud83c[\\udde6-\\uddff]){2}", B = "[\\ud800-\\udbff][\\udc00-\\udfff]", W = "[" + d + "]", G = "\\u200d", ne = "(?:" + A + "|" + C + ")", de = "(?:" + W + "|" + C + ")", V = "(?:" + g + "(?:d|ll|m|re|s|t|ve))?", Y = "(?:" + g + "(?:D|LL|M|RE|S|T|VE))?", Q = L + "?", ae = "[" + h + "]?", Z = "(?:" + G + "(?:" + [X, te, B].join("|") + ")" + ae + Q + ")*", J = ae + Q + Z, oe = "(?:" + [E, te, B].join("|") + ")" + J, ue = "(?:" + [X + x + "?", x, te, B, _].join("|") + ")", me = RegExp(g, "g"), pe = RegExp(x, "g"), Be = RegExp(M + "(?=" + M + ")|" + ue + J, "g"), Ie = RegExp([
    W + "?" + A + "+" + V + "(?=" + [b, W, "$"].join("|") + ")",
    de + "+" + Y + "(?=" + [b, W + ne, "$"].join("|") + ")",
    W + "?" + ne + "+" + V,
    W + "+" + Y,
    S,
    oe
  ].join("|"), "g"), Me = RegExp("[" + G + r + o + s + h + "]"), fe = /[a-z][A-Z]|[A-Z]{2,}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/, Te = {
    // Latin-1 Supplement block.
    À: "A",
    Á: "A",
    Â: "A",
    Ã: "A",
    Ä: "A",
    Å: "A",
    à: "a",
    á: "a",
    â: "a",
    ã: "a",
    ä: "a",
    å: "a",
    Ç: "C",
    ç: "c",
    Ð: "D",
    ð: "d",
    È: "E",
    É: "E",
    Ê: "E",
    Ë: "E",
    è: "e",
    é: "e",
    ê: "e",
    ë: "e",
    Ì: "I",
    Í: "I",
    Î: "I",
    Ï: "I",
    ì: "i",
    í: "i",
    î: "i",
    ï: "i",
    Ñ: "N",
    ñ: "n",
    Ò: "O",
    Ó: "O",
    Ô: "O",
    Õ: "O",
    Ö: "O",
    Ø: "O",
    ò: "o",
    ó: "o",
    ô: "o",
    õ: "o",
    ö: "o",
    ø: "o",
    Ù: "U",
    Ú: "U",
    Û: "U",
    Ü: "U",
    ù: "u",
    ú: "u",
    û: "u",
    ü: "u",
    Ý: "Y",
    ý: "y",
    ÿ: "y",
    Æ: "Ae",
    æ: "ae",
    Þ: "Th",
    þ: "th",
    ß: "ss",
    // Latin Extended-A block.
    Ā: "A",
    Ă: "A",
    Ą: "A",
    ā: "a",
    ă: "a",
    ą: "a",
    Ć: "C",
    Ĉ: "C",
    Ċ: "C",
    Č: "C",
    ć: "c",
    ĉ: "c",
    ċ: "c",
    č: "c",
    Ď: "D",
    Đ: "D",
    ď: "d",
    đ: "d",
    Ē: "E",
    Ĕ: "E",
    Ė: "E",
    Ę: "E",
    Ě: "E",
    ē: "e",
    ĕ: "e",
    ė: "e",
    ę: "e",
    ě: "e",
    Ĝ: "G",
    Ğ: "G",
    Ġ: "G",
    Ģ: "G",
    ĝ: "g",
    ğ: "g",
    ġ: "g",
    ģ: "g",
    Ĥ: "H",
    Ħ: "H",
    ĥ: "h",
    ħ: "h",
    Ĩ: "I",
    Ī: "I",
    Ĭ: "I",
    Į: "I",
    İ: "I",
    ĩ: "i",
    ī: "i",
    ĭ: "i",
    į: "i",
    ı: "i",
    Ĵ: "J",
    ĵ: "j",
    Ķ: "K",
    ķ: "k",
    ĸ: "k",
    Ĺ: "L",
    Ļ: "L",
    Ľ: "L",
    Ŀ: "L",
    Ł: "L",
    ĺ: "l",
    ļ: "l",
    ľ: "l",
    ŀ: "l",
    ł: "l",
    Ń: "N",
    Ņ: "N",
    Ň: "N",
    Ŋ: "N",
    ń: "n",
    ņ: "n",
    ň: "n",
    ŋ: "n",
    Ō: "O",
    Ŏ: "O",
    Ő: "O",
    ō: "o",
    ŏ: "o",
    ő: "o",
    Ŕ: "R",
    Ŗ: "R",
    Ř: "R",
    ŕ: "r",
    ŗ: "r",
    ř: "r",
    Ś: "S",
    Ŝ: "S",
    Ş: "S",
    Š: "S",
    ś: "s",
    ŝ: "s",
    ş: "s",
    š: "s",
    Ţ: "T",
    Ť: "T",
    Ŧ: "T",
    ţ: "t",
    ť: "t",
    ŧ: "t",
    Ũ: "U",
    Ū: "U",
    Ŭ: "U",
    Ů: "U",
    Ű: "U",
    Ų: "U",
    ũ: "u",
    ū: "u",
    ŭ: "u",
    ů: "u",
    ű: "u",
    ų: "u",
    Ŵ: "W",
    ŵ: "w",
    Ŷ: "Y",
    ŷ: "y",
    Ÿ: "Y",
    Ź: "Z",
    Ż: "Z",
    Ž: "Z",
    ź: "z",
    ż: "z",
    ž: "z",
    Ĳ: "IJ",
    ĳ: "ij",
    Œ: "Oe",
    œ: "oe",
    ŉ: "'n",
    ſ: "ss"
  }, Ae = typeof Yr == "object" && Yr && Yr.Object === Object && Yr, we = typeof self == "object" && self && self.Object === Object && self, $e = Ae || we || Function("return this")();
  function ze(Ge, ct, bt, Dn) {
    for (var En = -1, Jn = Ge ? Ge.length : 0; ++En < Jn; )
      bt = ct(bt, Ge[En], En, Ge);
    return bt;
  }
  function Ue(Ge) {
    return Ge.split("");
  }
  function tt(Ge) {
    return Ge.match(e) || [];
  }
  function Ot(Ge) {
    return function(ct) {
      return Ge?.[ct];
    };
  }
  var cn = Ot(Te);
  function Xr(Ge) {
    return Me.test(Ge);
  }
  function Pn(Ge) {
    return fe.test(Ge);
  }
  function On(Ge) {
    return Xr(Ge) ? sr(Ge) : Ue(Ge);
  }
  function sr(Ge) {
    return Ge.match(Be) || [];
  }
  function Hn(Ge) {
    return Ge.match(Ie) || [];
  }
  var sa = Object.prototype, Eo = sa.toString, aa = $e.Symbol, ar = aa ? aa.prototype : void 0, Zn = ar ? ar.toString : void 0;
  function $r(Ge, ct, bt) {
    var Dn = -1, En = Ge.length;
    ct < 0 && (ct = -ct > En ? 0 : En + ct), bt = bt > En ? En : bt, bt < 0 && (bt += En), En = ct > bt ? 0 : bt - ct >>> 0, ct >>>= 0;
    for (var Jn = Array(En); ++Dn < En; )
      Jn[Dn] = Ge[Dn + ct];
    return Jn;
  }
  function gn(Ge) {
    if (typeof Ge == "string")
      return Ge;
    if (In(Ge))
      return Zn ? Zn.call(Ge) : "";
    var ct = Ge + "";
    return ct == "0" && 1 / Ge == -1 / 0 ? "-0" : ct;
  }
  function ko(Ge, ct, bt) {
    var Dn = Ge.length;
    return bt = bt === void 0 ? Dn : bt, !ct && bt >= Dn ? Ge : $r(Ge, ct, bt);
  }
  function Mo(Ge) {
    return function(ct) {
      ct = ke(ct);
      var bt = Xr(ct) ? On(ct) : void 0, Dn = bt ? bt[0] : ct.charAt(0), En = bt ? ko(bt, 1).join("") : ct.slice(1);
      return Dn[Ge]() + En;
    };
  }
  function Fs(Ge) {
    return function(ct) {
      return ze(Tt(It(ct).replace(me, "")), Ge, "");
    };
  }
  function To(Ge) {
    return !!Ge && typeof Ge == "object";
  }
  function In(Ge) {
    return typeof Ge == "symbol" || To(Ge) && Eo.call(Ge) == t;
  }
  function ke(Ge) {
    return Ge == null ? "" : gn(Ge);
  }
  var Re = Fs(function(Ge, ct, bt) {
    return ct = ct.toLowerCase(), Ge + (bt ? Qt(ct) : ct);
  });
  function Qt(Ge) {
    return on(ke(Ge).toLowerCase());
  }
  function It(Ge) {
    return Ge = ke(Ge), Ge && Ge.replace(n, cn).replace(pe, "");
  }
  var on = Mo("toUpperCase");
  function Tt(Ge, ct, bt) {
    return Ge = ke(Ge), ct = ct, ct === void 0 ? Pn(Ge) ? Hn(Ge) : tt(Ge) : Ge.match(ct) || [];
  }
  return P1 = Re, P1;
}
var Ate = Rte();
const Dte = /* @__PURE__ */ Nh(Ate), wF = ["a", "e", "i", "o", "u", "y"], Ete = (t) => t.endsWith("s") ? t : (t.match(/(ss|ish|ch|x|us)$/) ? t += "e" : t.endsWith("y") && !wF.includes(t.charAt(t.length - 2)) && (t = t.slice(0, t.length - 1), t += "ie"), `${t}s`);
function mc(t, e) {
  return e === 1 ? t : Ete(t);
}
function bF(t) {
  return t.replace(/\W+/g, " ").split(/ |\B(?=[A-Z])/).map((e) => e.toLowerCase()).join("_");
}
function Mte(t) {
  return t.replace(/([a-z])([A-Z])/g, "$1-$2").replace(/[\s_]+/g, "-").toLowerCase();
}
function Pte(t) {
  return Dte(t);
}
function Hm(t) {
  return t.replace(/^[-_]*(.)/, (e, n) => n.toUpperCase()).replace(/[-_]+(.)/g, (e, n) => ` ${n.toUpperCase()}`);
}
function Ht(t) {
  return typeof t == "string";
}
function yi(t) {
  const e = t.charAt(0).toUpperCase(), n = t.slice(1);
  return `${e}${n}`;
}
function Cte(t) {
  return t.toUpperCase();
}
function Ps(t) {
  return typeof t == "string" && t.trim().length === 0;
}
const Ote = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
function Ite(t) {
  return typeof t == "string" && Ote.test(t);
}
function MLe(t) {
  return t.replace(/\s/g, "");
}
function CE(t) {
  return (t ?? "").split(/(\"[^"]*\")/g).map((e) => e.startsWith('"') && e.endsWith('"') ? e : e.replace(/\s+/g, "")).join("");
}
function Ip(t) {
  if (Ht(t))
    try {
      const e = JSON.parse(t);
      return Ht(e) ? t : e;
    } catch {
    }
  return t;
}
function Fte(t) {
  switch (t) {
    case "cloud-run":
      return "Google Cloud Run";
    case "ecs":
      return "Amazon Elastic Container Service";
    default:
      return Hm(t);
  }
}
function gi(t, e) {
  return { ...t, query: e };
}
function PLe(t, e = window.location.pathname) {
  return gi(t, { redirect: e });
}
function CLe(t, e) {
  const n = { ...t.currentRoute.value.query };
  return e.forEach((r) => {
    delete n[r];
  }), n;
}
var Pf = { exports: {} };
Pf.exports;
var OE;
function Nte() {
  return OE || (OE = 1, function(t, e) {
    var n = 200, r = "__lodash_hash_undefined__", o = 1, s = 2, i = 9007199254740991, u = "[object Arguments]", l = "[object Array]", a = "[object AsyncFunction]", c = "[object Boolean]", p = "[object Date]", d = "[object Error]", h = "[object Function]", m = "[object GeneratorFunction]", g = "[object Map]", _ = "[object Number]", b = "[object Null]", x = "[object Object]", S = "[object Promise]", E = "[object Proxy]", A = "[object RegExp]", C = "[object Set]", M = "[object String]", L = "[object Symbol]", X = "[object Undefined]", te = "[object WeakMap]", B = "[object ArrayBuffer]", W = "[object DataView]", G = "[object Float32Array]", ne = "[object Float64Array]", de = "[object Int8Array]", V = "[object Int16Array]", Y = "[object Int32Array]", Q = "[object Uint8Array]", ae = "[object Uint8ClampedArray]", Z = "[object Uint16Array]", J = "[object Uint32Array]", oe = /[\\^$.*+?()[\]{}|]/g, ue = /^\[object .+?Constructor\]$/, me = /^(?:0|[1-9]\d*)$/, pe = {};
    pe[G] = pe[ne] = pe[de] = pe[V] = pe[Y] = pe[Q] = pe[ae] = pe[Z] = pe[J] = !0, pe[u] = pe[l] = pe[B] = pe[c] = pe[W] = pe[p] = pe[d] = pe[h] = pe[g] = pe[_] = pe[x] = pe[A] = pe[C] = pe[M] = pe[te] = !1;
    var Be = typeof Yr == "object" && Yr && Yr.Object === Object && Yr, Ie = typeof self == "object" && self && self.Object === Object && self, Me = Be || Ie || Function("return this")(), fe = e && !e.nodeType && e, Te = fe && !0 && t && !t.nodeType && t, Ae = Te && Te.exports === fe, we = Ae && Be.process, $e = function() {
      try {
        return we && we.binding && we.binding("util");
      } catch {
      }
    }(), ze = $e && $e.isTypedArray;
    function Ue(N, I) {
      for (var H = -1, se = N == null ? 0 : N.length, Ne = 0, Oe = []; ++H < se; ) {
        var Je = N[H];
        I(Je, H, N) && (Oe[Ne++] = Je);
      }
      return Oe;
    }
    function tt(N, I) {
      for (var H = -1, se = I.length, Ne = N.length; ++H < se; )
        N[Ne + H] = I[H];
      return N;
    }
    function Ot(N, I) {
      for (var H = -1, se = N == null ? 0 : N.length; ++H < se; )
        if (I(N[H], H, N))
          return !0;
      return !1;
    }
    function cn(N, I) {
      for (var H = -1, se = Array(N); ++H < N; )
        se[H] = I(H);
      return se;
    }
    function Xr(N) {
      return function(I) {
        return N(I);
      };
    }
    function Pn(N, I) {
      return N.has(I);
    }
    function On(N, I) {
      return N?.[I];
    }
    function sr(N) {
      var I = -1, H = Array(N.size);
      return N.forEach(function(se, Ne) {
        H[++I] = [Ne, se];
      }), H;
    }
    function Hn(N, I) {
      return function(H) {
        return N(I(H));
      };
    }
    function sa(N) {
      var I = -1, H = Array(N.size);
      return N.forEach(function(se) {
        H[++I] = se;
      }), H;
    }
    var Eo = Array.prototype, aa = Function.prototype, ar = Object.prototype, Zn = Me["__core-js_shared__"], $r = aa.toString, gn = ar.hasOwnProperty, ko = function() {
      var N = /[^.]+$/.exec(Zn && Zn.keys && Zn.keys.IE_PROTO || "");
      return N ? "Symbol(src)_1." + N : "";
    }(), Mo = ar.toString, Fs = RegExp(
      "^" + $r.call(gn).replace(oe, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
    ), To = Ae ? Me.Buffer : void 0, In = Me.Symbol, ke = Me.Uint8Array, Re = ar.propertyIsEnumerable, Qt = Eo.splice, It = In ? In.toStringTag : void 0, on = Object.getOwnPropertySymbols, Tt = To ? To.isBuffer : void 0, Ge = Hn(Object.keys, Object), ct = kr(Me, "DataView"), bt = kr(Me, "Map"), Dn = kr(Me, "Promise"), En = kr(Me, "Set"), Jn = kr(Me, "WeakMap"), Bn = kr(Object, "create"), po = Pr(ct), Ai = Pr(bt), ia = Pr(Dn), Ns = Pr(En), Ls = Pr(Jn), as = In ? In.prototype : void 0, Wr = as ? as.valueOf : void 0;
    function ir(N) {
      var I = -1, H = N == null ? 0 : N.length;
      for (this.clear(); ++I < H; ) {
        var se = N[I];
        this.set(se[0], se[1]);
      }
    }
    function Di() {
      this.__data__ = Bn ? Bn(null) : {}, this.size = 0;
    }
    function Ei(N) {
      var I = this.has(N) && delete this.__data__[N];
      return this.size -= I ? 1 : 0, I;
    }
    function Va(N) {
      var I = this.__data__;
      if (Bn) {
        var H = I[N];
        return H === r ? void 0 : H;
      }
      return gn.call(I, N) ? I[N] : void 0;
    }
    function Mi(N) {
      var I = this.__data__;
      return Bn ? I[N] !== void 0 : gn.call(I, N);
    }
    function Po(N, I) {
      var H = this.__data__;
      return this.size += this.has(N) ? 0 : 1, H[N] = Bn && I === void 0 ? r : I, this;
    }
    ir.prototype.clear = Di, ir.prototype.delete = Ei, ir.prototype.get = Va, ir.prototype.has = Mi, ir.prototype.set = Po;
    function Un(N) {
      var I = -1, H = N == null ? 0 : N.length;
      for (this.clear(); ++I < H; ) {
        var se = N[I];
        this.set(se[0], se[1]);
      }
    }
    function Tu() {
      this.__data__ = [], this.size = 0;
    }
    function Ha(N) {
      var I = this.__data__, H = ls(I, N);
      if (H < 0)
        return !1;
      var se = I.length - 1;
      return H == se ? I.pop() : Qt.call(I, H, 1), --this.size, !0;
    }
    function is(N) {
      var I = this.__data__, H = ls(I, N);
      return H < 0 ? void 0 : I[H][1];
    }
    function ua(N) {
      return ls(this.__data__, N) > -1;
    }
    function xu(N, I) {
      var H = this.__data__, se = ls(H, N);
      return se < 0 ? (++this.size, H.push([N, I])) : H[se][1] = I, this;
    }
    Un.prototype.clear = Tu, Un.prototype.delete = Ha, Un.prototype.get = is, Un.prototype.has = ua, Un.prototype.set = xu;
    function er(N) {
      var I = -1, H = N == null ? 0 : N.length;
      for (this.clear(); ++I < H; ) {
        var se = N[I];
        this.set(se[0], se[1]);
      }
    }
    function Pi() {
      this.size = 0, this.__data__ = {
        hash: new ir(),
        map: new (bt || Un)(),
        string: new ir()
      };
    }
    function Ci(N) {
      var I = Co(this, N).delete(N);
      return this.size -= I ? 1 : 0, I;
    }
    function la(N) {
      return Co(this, N).get(N);
    }
    function Fc(N) {
      return Co(this, N).has(N);
    }
    function Oi(N, I) {
      var H = Co(this, N), se = H.size;
      return H.set(N, I), this.size += H.size == se ? 0 : 1, this;
    }
    er.prototype.clear = Pi, er.prototype.delete = Ci, er.prototype.get = la, er.prototype.has = Fc, er.prototype.set = Oi;
    function us(N) {
      var I = -1, H = N == null ? 0 : N.length;
      for (this.__data__ = new er(); ++I < H; )
        this.add(N[I]);
    }
    function _l(N) {
      return this.__data__.set(N, r), this;
    }
    function wl(N) {
      return this.__data__.has(N);
    }
    us.prototype.add = us.prototype.push = _l, us.prototype.has = wl;
    function br(N) {
      var I = this.__data__ = new Un(N);
      this.size = I.size;
    }
    function bl() {
      this.__data__ = new Un(), this.size = 0;
    }
    function Nc(N) {
      var I = this.__data__, H = I.delete(N);
      return this.size = I.size, H;
    }
    function Lc(N) {
      return this.__data__.get(N);
    }
    function Bc(N) {
      return this.__data__.has(N);
    }
    function kl(N, I) {
      var H = this.__data__;
      if (H instanceof Un) {
        var se = H.__data__;
        if (!bt || se.length < n - 1)
          return se.push([N, I]), this.size = ++H.size, this;
        H = this.__data__ = new er(se);
      }
      return H.set(N, I), this.size = H.size, this;
    }
    br.prototype.clear = bl, br.prototype.delete = Nc, br.prototype.get = Lc, br.prototype.has = Bc, br.prototype.set = kl;
    function Tl(N, I) {
      var H = cs(N), se = !H && Cl(N), Ne = !H && !se && da(N), Oe = !H && !se && !Ne && Ni(N), Je = H || se || Ne || Oe, ut = Je ? cn(N.length, String) : [], Ye = ut.length;
      for (var et in N)
        gn.call(N, et) && !(Je && // Safari 9 has enumerable `arguments.length` in strict mode.
        (et == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
        Ne && (et == "offset" || et == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
        Oe && (et == "buffer" || et == "byteLength" || et == "byteOffset") || // Skip index properties.
        El(et, Ye))) && ut.push(et);
      return ut;
    }
    function ls(N, I) {
      for (var H = N.length; H--; )
        if (Ga(N[H][0], I))
          return H;
      return -1;
    }
    function Su(N, I, H) {
      var se = I(N);
      return cs(N) ? se : tt(se, H(N));
    }
    function Vo(N) {
      return N == null ? N === void 0 ? X : b : It && It in Object(N) ? Al(N) : Au(N);
    }
    function Ii(N) {
      return jo(N) && Vo(N) == u;
    }
    function ca(N, I, H, se, Ne) {
      return N === I ? !0 : N == null || I == null || !jo(N) && !jo(I) ? N !== N && I !== I : ja(N, I, H, se, ca, Ne);
    }
    function ja(N, I, H, se, Ne, Oe) {
      var Je = cs(N), ut = cs(I), Ye = Je ? l : ur(N), et = ut ? l : ur(I);
      Ye = Ye == u ? x : Ye, et = et == u ? x : et;
      var Ft = Ye == x, en = et == x, jt = Ye == et;
      if (jt && da(N)) {
        if (!da(I))
          return !1;
        Je = !0, Ft = !1;
      }
      if (jt && !Ft)
        return Oe || (Oe = new br()), Je || Ni(N) ? pa(N, I, H, se, Ne, Oe) : Uc(N, I, Ye, H, se, Ne, Oe);
      if (!(H & o)) {
        var Kt = Ft && gn.call(N, "__wrapped__"), Tn = en && gn.call(I, "__wrapped__");
        if (Kt || Tn) {
          var lr = Kt ? N.value() : N, Tr = Tn ? I.value() : I;
          return Oe || (Oe = new br()), Ne(lr, Tr, H, se, Oe);
        }
      }
      return jt ? (Oe || (Oe = new br()), Rl(N, I, H, se, Ne, Oe)) : !1;
    }
    function Ru(N) {
      if (!Fi(N) || Pl(N))
        return !1;
      var I = Ho(N) ? Fs : ue;
      return I.test(Pr(N));
    }
    function xl(N) {
      return jo(N) && Eu(N.length) && !!pe[Vo(N)];
    }
    function Sl(N) {
      if (!qa(N))
        return Ge(N);
      var I = [];
      for (var H in Object(N))
        gn.call(N, H) && H != "constructor" && I.push(H);
      return I;
    }
    function pa(N, I, H, se, Ne, Oe) {
      var Je = H & o, ut = N.length, Ye = I.length;
      if (ut != Ye && !(Je && Ye > ut))
        return !1;
      var et = Oe.get(N);
      if (et && Oe.get(I))
        return et == I;
      var Ft = -1, en = !0, jt = H & s ? new us() : void 0;
      for (Oe.set(N, I), Oe.set(I, N); ++Ft < ut; ) {
        var Kt = N[Ft], Tn = I[Ft];
        if (se)
          var lr = Je ? se(Tn, Kt, Ft, I, N, Oe) : se(Kt, Tn, Ft, N, I, Oe);
        if (lr !== void 0) {
          if (lr)
            continue;
          en = !1;
          break;
        }
        if (jt) {
          if (!Ot(I, function(Tr, ho) {
            if (!Pn(jt, ho) && (Kt === Tr || Ne(Kt, Tr, H, se, Oe)))
              return jt.push(ho);
          })) {
            en = !1;
            break;
          }
        } else if (!(Kt === Tn || Ne(Kt, Tn, H, se, Oe))) {
          en = !1;
          break;
        }
      }
      return Oe.delete(N), Oe.delete(I), en;
    }
    function Uc(N, I, H, se, Ne, Oe, Je) {
      switch (H) {
        case W:
          if (N.byteLength != I.byteLength || N.byteOffset != I.byteOffset)
            return !1;
          N = N.buffer, I = I.buffer;
        case B:
          return !(N.byteLength != I.byteLength || !Oe(new ke(N), new ke(I)));
        case c:
        case p:
        case _:
          return Ga(+N, +I);
        case d:
          return N.name == I.name && N.message == I.message;
        case A:
        case M:
          return N == I + "";
        case g:
          var ut = sr;
        case C:
          var Ye = se & o;
          if (ut || (ut = sa), N.size != I.size && !Ye)
            return !1;
          var et = Je.get(N);
          if (et)
            return et == I;
          se |= s, Je.set(N, I);
          var Ft = pa(ut(N), ut(I), se, Ne, Oe, Je);
          return Je.delete(N), Ft;
        case L:
          if (Wr)
            return Wr.call(N) == Wr.call(I);
      }
      return !1;
    }
    function Rl(N, I, H, se, Ne, Oe) {
      var Je = H & o, ut = za(N), Ye = ut.length, et = za(I), Ft = et.length;
      if (Ye != Ft && !Je)
        return !1;
      for (var en = Ye; en--; ) {
        var jt = ut[en];
        if (!(Je ? jt in I : gn.call(I, jt)))
          return !1;
      }
      var Kt = Oe.get(N);
      if (Kt && Oe.get(I))
        return Kt == I;
      var Tn = !0;
      Oe.set(N, I), Oe.set(I, N);
      for (var lr = Je; ++en < Ye; ) {
        jt = ut[en];
        var Tr = N[jt], ho = I[jt];
        if (se)
          var Ol = Je ? se(ho, Tr, jt, I, N, Oe) : se(Tr, ho, jt, N, I, Oe);
        if (!(Ol === void 0 ? Tr === ho || Ne(Tr, ho, H, se, Oe) : Ol)) {
          Tn = !1;
          break;
        }
        lr || (lr = jt == "constructor");
      }
      if (Tn && !lr) {
        var ha = N.constructor, cr = I.constructor;
        ha != cr && "constructor" in N && "constructor" in I && !(typeof ha == "function" && ha instanceof ha && typeof cr == "function" && cr instanceof cr) && (Tn = !1);
      }
      return Oe.delete(N), Oe.delete(I), Tn;
    }
    function za(N) {
      return Su(N, Xc, Dl);
    }
    function Co(N, I) {
      var H = N.__data__;
      return Ml(I) ? H[typeof I == "string" ? "string" : "hash"] : H.map;
    }
    function kr(N, I) {
      var H = On(N, I);
      return Ru(H) ? H : void 0;
    }
    function Al(N) {
      var I = gn.call(N, It), H = N[It];
      try {
        N[It] = void 0;
        var se = !0;
      } catch {
      }
      var Ne = Mo.call(N);
      return se && (I ? N[It] = H : delete N[It]), Ne;
    }
    var Dl = on ? function(N) {
      return N == null ? [] : (N = Object(N), Ue(on(N), function(I) {
        return Re.call(N, I);
      }));
    } : Sn, ur = Vo;
    (ct && ur(new ct(new ArrayBuffer(1))) != W || bt && ur(new bt()) != g || Dn && ur(Dn.resolve()) != S || En && ur(new En()) != C || Jn && ur(new Jn()) != te) && (ur = function(N) {
      var I = Vo(N), H = I == x ? N.constructor : void 0, se = H ? Pr(H) : "";
      if (se)
        switch (se) {
          case po:
            return W;
          case Ai:
            return g;
          case ia:
            return S;
          case Ns:
            return C;
          case Ls:
            return te;
        }
      return I;
    });
    function El(N, I) {
      return I = I ?? i, !!I && (typeof N == "number" || me.test(N)) && N > -1 && N % 1 == 0 && N < I;
    }
    function Ml(N) {
      var I = typeof N;
      return I == "string" || I == "number" || I == "symbol" || I == "boolean" ? N !== "__proto__" : N === null;
    }
    function Pl(N) {
      return !!ko && ko in N;
    }
    function qa(N) {
      var I = N && N.constructor, H = typeof I == "function" && I.prototype || ar;
      return N === H;
    }
    function Au(N) {
      return Mo.call(N);
    }
    function Pr(N) {
      if (N != null) {
        try {
          return $r.call(N);
        } catch {
        }
        try {
          return N + "";
        } catch {
        }
      }
      return "";
    }
    function Ga(N, I) {
      return N === I || N !== N && I !== I;
    }
    var Cl = Ii(/* @__PURE__ */ function() {
      return arguments;
    }()) ? Ii : function(N) {
      return jo(N) && gn.call(N, "callee") && !Re.call(N, "callee");
    }, cs = Array.isArray;
    function Du(N) {
      return N != null && Eu(N.length) && !Ho(N);
    }
    var da = Tt || vn;
    function Bs(N, I) {
      return ca(N, I);
    }
    function Ho(N) {
      if (!Fi(N))
        return !1;
      var I = Vo(N);
      return I == h || I == m || I == a || I == E;
    }
    function Eu(N) {
      return typeof N == "number" && N > -1 && N % 1 == 0 && N <= i;
    }
    function Fi(N) {
      var I = typeof N;
      return N != null && (I == "object" || I == "function");
    }
    function jo(N) {
      return N != null && typeof N == "object";
    }
    var Ni = ze ? Xr(ze) : xl;
    function Xc(N) {
      return Du(N) ? Tl(N) : Sl(N);
    }
    function Sn() {
      return [];
    }
    function vn() {
      return !1;
    }
    t.exports = Bs;
  }(Pf, Pf.exports)), Pf.exports;
}
var Lte = Nte();
const cm = /* @__PURE__ */ Nh(Lte), jg = [
  "Scheduled",
  "Late",
  "Resuming",
  "AwaitingRetry",
  "AwaitingConcurrencySlot",
  "Pending",
  "Paused",
  "Suspended",
  "Running",
  "Retrying",
  "Completed",
  "Cached",
  "Cancelled",
  "Cancelling",
  "Crashed",
  "Failed",
  "TimedOut"
], Bte = {
  Scheduled: "scheduled",
  Late: "scheduled",
  Resuming: "scheduled",
  AwaitingRetry: "scheduled",
  AwaitingConcurrencySlot: "scheduled",
  Pending: "pending",
  Paused: "paused",
  Suspended: "paused",
  Running: "running",
  Retrying: "running",
  Completed: "completed",
  Cached: "completed",
  Cancelled: "cancelled",
  Cancelling: "cancelling",
  Crashed: "crashed",
  Failed: "failed",
  TimedOut: "failed"
}, Ute = [
  "Pending",
  "Paused",
  "Suspended",
  "Running",
  "Retrying",
  "Completed",
  "Cancelled",
  "Cancelling",
  "Crashed",
  "Failed",
  "TimedOut"
];
function d_(t, e) {
  return cm(t, e);
}
const h_ = { type: "span", seconds: -Ih }, kF = {
  range: h_,
  state: [],
  flow: [],
  tag: [],
  deployment: [],
  workPool: [],
  workQueue: []
}, Xte = {
  range: h_,
  state: Ute.slice(),
  flow: [],
  tag: [],
  deployment: [],
  workPool: [],
  workQueue: []
}, TF = new Yx({
  id: null,
  name: "Past week",
  filters: kF
}), $te = new Yx({
  id: null,
  name: "Hide scheduled runs",
  filters: Xte
}), zg = {
  id: null,
  name: "Custom"
}, xF = {
  id: null,
  name: "Unsaved"
}, Tk = TF, Wte = [
  TF,
  $te
];
function uh(t = "Unknown") {
  const e = jg.find((n) => t.toLowerCase() === n.toLowerCase());
  if (e) {
    const n = Bte[e];
    return {
      name: e,
      type: n
    };
  }
  return {
    name: t,
    type: null
  };
}
function Vte(t) {
  const e = t ?? "Unknown", n = `state--${e.toLowerCase()}`, r = `${e}-style-sampler`;
  let o = document.getElementById(r);
  return o || (o = document.createElement("div"), o.classList.add(n), o.id = r, document.body.appendChild(o)), o;
}
function OLe(t) {
  const e = Vte(t), n = getComputedStyle(e);
  return {
    color: n.color,
    background: n.backgroundColor
  };
}
function SF(t) {
  switch (t) {
    case "completed":
    case "running":
    case "scheduled":
    case "pending":
    case "failed":
    case "cancelled":
    case "crashed":
    case "paused":
      return yi(t);
    default:
      return t;
  }
}
function lh(t) {
  const e = Ip(t);
  return Ht(e) ? e : JSON.stringify(e);
}
const ILe = new zj(), FLe = Symbol("workQueueSubscriptionKey"), NLe = Symbol("workQueuesListSubscriptionKey"), LLe = Symbol("flowsListSubscriptionKey"), BLe = Symbol("deploymentsListSubscriptionKey");
function RF(t, e) {
  let n;
  const r = new Promise((...s) => [n] = s), o = setTimeout(() => n(), t);
  return e?.addEventListener("abort", () => {
    clearTimeout(o), n();
  }), r;
}
const Vu = {
  Seconds: 1,
  Minutes: Oa,
  Hours: Oa * sh,
  Days: Oa * sh * NJ
}, AF = (t) => {
  const e = t % Vu.Days, n = t % Vu.Hours, r = t % Vu.Minutes, o = t % Vu.Seconds, s = t / Vu.Days, i = t / Vu.Hours, u = t / Vu.Minutes, l = t / Vu.Seconds;
  return {
    days: { value: s, remainder: e },
    hours: { value: i, remainder: n },
    minutes: { value: u, remainder: r },
    seconds: { value: l, remainder: o }
  };
}, IE = (t) => {
  const { days: e, hours: n, minutes: r, seconds: o } = AF(t);
  return e.value > 1 && !e.remainder ? e.value : n.value > 1 && !n.remainder ? n.value : r.value > 1 && !r.remainder ? r.value : o.value;
}, FE = (t) => {
  const { days: e, hours: n, minutes: r } = AF(t);
  return e.value > 1 && !e.remainder ? "Days" : n.value > 1 && !n.remainder ? "Hours" : r.value > 1 && !r.remainder ? "Minutes" : "Seconds";
}, Hte = /((?:https?|ftp):\/\/[^\s/$.?#].[^\s)"(]*)/g;
function jte(t) {
  return Array.isArray(t);
}
function DF(t, e) {
  const n = t("property");
  return async (r) => await n(r) === !0 ? !0 : e;
}
function qp(t, ...e) {
  return e.map((n) => {
    if (jte(n)) {
      const [r, o] = n;
      return DF(r, o);
    }
    return n(t);
  });
}
const zte = (t) => (e) => (n) => {
  const r = t(e);
  return Array.isArray(n) && n.every((o) => r(o) === !0) ? !0 : `Not every ${e} is valid`;
}, Kr = (t) => (e) => Gt(e) || Tc(e) || Ps(e) || wp(e) ? `${t} is required` : !0, qte = (t) => (e) => async (n) => await t(n) ? !0 : `${e} is invalid`, Gte = (t) => (e) => async (n) => await t(n) ? Kr(e)(n) : !0, EF = (t) => (e) => Gt(e) || Ps(e) || Ite(e) ? !0 : `${t} is not a valid email address`, ULe = zte(EF), Yte = (t) => (e) => (n) => Gt(n) || Ps(n) || Tc(n) || Array.isArray(n) && n.length < t || typeof n == "string" && n.length < t || typeof n == "number" && n < t ? !0 : `${e} must be less than ${t}`, Fp = (t) => (e) => (n) => Gt(n) || Ps(n) || Tc(n) ? !0 : Array.isArray(n) ? n.length <= t ? !0 : le.error.arrayValueTooLong(e, t) : typeof n == "string" ? n.length <= t ? !0 : le.error.stringValueTooLong(e, t) : typeof n == "number" ? n <= t ? !0 : le.error.numberValueTooLarge(e, t) : le.error.valueTooLarge(e, t), a2 = (t) => (e) => (n) => Gt(n) || Ps(n) || Tc(n) || Array.isArray(n) && n.length > t || typeof n == "string" && n.length > t || typeof n == "number" && n > t ? !0 : `${e} must be greater than ${t}`, MF = (t) => (e) => (n) => Gt(n) || Ps(n) || Tc(n) || Array.isArray(n) && n.length >= t || typeof n == "string" && n.length >= t || typeof n == "number" && n >= t ? !0 : `${e} must be greater than or equal to ${t}`, XLe = (t, { time: e = !1 } = {}) => (n) => (r) => Gt(r) || ol(r) && Tj(r, t) ? !0 : e ? `${n} must be less than ${qs(t)}` : `${n} must be less than ${Xo(t)}`, $Le = (t, { time: e = !1 } = {}) => (n) => (r) => Gt(r) || ol(r) && xj(r, t) ? !0 : e ? `${n} must be less than ${qs(t)}` : `${n} must be less than or equal to ${Xo(t)}`, WLe = (t, { time: e = !1 } = {}) => (n) => (r) => Gt(r) || ol(r) && Sj(r, t) ? !0 : e ? `${n} must be less than ${qs(t)}` : `${n} must be less than ${Xo(t)}`, VLe = (t, { time: e = !1 } = {}) => (n) => (r) => Gt(r) || ol(r) && Rj(r, t) ? !0 : e ? `${n} must be less than ${qs(t)}` : `${n} must be less than or equal to ${Xo(t)}`, ml = (t) => (e) => {
  if (Gt(e) || Ps(e))
    return !0;
  try {
    JSON.parse(e);
  } catch {
    return `${t} must be valid JSON`;
  }
  return !0;
}, Qte = /^[a-z0-9-]+$/, Kte = (t) => (e) => Gt(e) || Ps(e) || typeof e == "string" && Qte.test(e) ? !0 : `${t} must only contain lowercase letters, numbers, and dashes`, Zte = /^[a-z0-9]+(_+[a-z0-9]+)*$/, HLe = (t, e) => ri(t) && Ht(t) && Zte.test(t) || le.error.mustBeSnakeCase(e), Jte = /^[a-z0-9]+([_-]+[a-z0-9]+)*$/, f_ = (t, e) => Gt(t) || Ps(t) || typeof t == "string" && Jte.test(t) ? !0 : le.error.mustBeSlug(e), { values: jLe, isValue: ene } = to([
  "cancel-flow-run",
  "suspend-flow-run",
  "resume-flow-run",
  "change-flow-run-state",
  "run-deployment",
  "pause-deployment",
  "resume-deployment",
  "pause-work-queue",
  "resume-work-queue",
  "pause-work-pool",
  "resume-work-pool",
  "pause-automation",
  "resume-automation",
  "send-notification",
  "do-nothing"
]), zLe = {
  "cancel-flow-run": "Cancel a flow run",
  "suspend-flow-run": "Suspend a flow run",
  "resume-flow-run": "Resume a flow run",
  "change-flow-run-state": "Change flow run's state",
  "run-deployment": "Run a deployment",
  "pause-deployment": "Pause a deployment",
  "resume-deployment": "Resume a deployment",
  "pause-work-queue": "Pause a work queue",
  "resume-work-queue": "Resume a work queue",
  "pause-work-pool": "Pause a work pool",
  "resume-work-pool": "Resume a work pool",
  "pause-automation": "Pause an automation",
  "resume-automation": "Resume an automation",
  "send-notification": "Send a notification",
  "do-nothing": "Do nothing"
};
function ss(t, e) {
  return wn(t) && "type" in t && t.type === e;
}
function tne(t) {
  return ss(t, "cancel-flow-run");
}
function nne(t) {
  return ss(t, "suspend-flow-run");
}
function rne(t) {
  return ss(t, "resume-flow-run");
}
function one(t) {
  if (!ss(t, "change-flow-run-state"))
    return !1;
  const e = Ht(t.name) || Gt(t.name), n = y8(t.state), r = Ht(t.message) || Gt(t.message);
  return e && n && r;
}
function sne(t) {
  if (!ss(t, "run-deployment"))
    return !1;
  const e = Ht(t.deploymentId) || Gt(t.deploymentId), n = wn(t.parameters) || Gt(t.parameters);
  return e && n;
}
function ane(t) {
  return ss(t, "pause-deployment") ? Ht(t.deploymentId) || Gt(t.deploymentId) : !1;
}
function ine(t) {
  return ss(t, "resume-deployment") ? Ht(t.deploymentId) || Gt(t.deploymentId) : !1;
}
function une(t) {
  return ss(t, "pause-work-queue") ? Ht(t.workQueueId) || Gt(t.workQueueId) : !1;
}
function lne(t) {
  return ss(t, "resume-work-queue") ? Ht(t.workQueueId) || Gt(t.workQueueId) : !1;
}
function cne(t) {
  return ss(t, "pause-work-pool") ? Ht(t.workPoolId) || Gt(t.workPoolId) : !1;
}
function pne(t) {
  return ss(t, "resume-work-pool") ? Ht(t.workPoolId) || Gt(t.workPoolId) : !1;
}
function dne(t) {
  return ss(t, "pause-automation") ? Ht(t.automationId) || Gt(t.automationId) : !1;
}
function hne(t) {
  return ss(t, "resume-automation") ? Ht(t.automationId) || Gt(t.automationId) : !1;
}
function fne(t) {
  if (!ss(t, "send-notification"))
    return !1;
  const e = Ht(t.blockDocumentId) || Gt(t.blockDocumentId), n = Ht(t.subject), r = Ht(t.body);
  return e && n && r;
}
function mne(t) {
  return ss(t, "do-nothing");
}
const yne = {
  "cancel-flow-run": tne,
  "suspend-flow-run": nne,
  "resume-flow-run": rne,
  "change-flow-run-state": one,
  "run-deployment": sne,
  "pause-deployment": ane,
  "resume-deployment": ine,
  "pause-work-queue": une,
  "resume-work-queue": lne,
  "pause-work-pool": cne,
  "resume-work-pool": pne,
  "pause-automation": dne,
  "resume-automation": hne,
  "send-notification": fne,
  "do-nothing": mne
};
function PF(t) {
  return Object.values(yne).some((n) => n(t));
}
function qLe(t) {
  return wn(t) && ene(t.type);
}
function CF(t) {
  return wn(t) && "from" in t && t.from === "event";
}
function OF(t) {
  return wn(t) && "from" in t && t.from === "flow";
}
function IF(t) {
  return wn(t) && "from" in t && t.from === "workPool";
}
function FF(t) {
  return wn(t) && "from" in t && t.from === "workPoolQueue";
}
function gne(t) {
  return CF(t) || OF(t) || IF(t) || FF(t);
}
function vne(t) {
  return wn(t) && "actions" in t && eu(t.actions) && t.actions.every(PF);
}
const { values: _ne, isValue: wne } = to([
  "Reactive",
  "Proactive"
]);
function bne(t) {
  return wn(t) && t.type === "event" && wne(t.posture);
}
function kne(t) {
  return t.type === "compound";
}
function Tne(t) {
  return t.type === "sequence";
}
class xne {
  id;
  name;
  description;
  enabled;
  constructor(e) {
    this.id = e.id, this.name = e.name, this.description = e.description, this.enabled = e.enabled;
  }
}
const { values: GLe, isValue: Sne } = to([
  "Reactive",
  "Proactive"
]), jm = 0, zm = 1;
function qm(t) {
  switch (t) {
    case "Proactive":
      return "stays in";
    case "Reactive":
      return "enters";
    default:
      const e = t;
      throw new Error(`getAutomationTriggerEventPostureLabel missing case for ${e}`);
  }
}
class $o {
  type = "event";
  posture;
  match;
  matchRelated;
  forEach;
  after;
  expect;
  threshold;
  within;
  constructor(e) {
    this.posture = e.posture, this.match = e.match ?? {}, this.matchRelated = e.matchRelated ?? {}, this.forEach = e.forEach ?? [], this.after = e.after ?? [], this.expect = e.expect ?? [], this.threshold = e.threshold ?? zm, this.within = e.within ?? jm;
  }
}
function Ti(t) {
  return wn(t) && t.type === "event" && Sne(t.posture);
}
function NF(t) {
  return wn(t) && t.type === "compound" && eu(t.triggers) && t.triggers.every(BF);
}
function LF(t) {
  return wn(t) && t.type === "sequence" && eu(t.triggers) && t.triggers.every(BF);
}
function BF(t) {
  return Ti(t) || NF(t) || LF(t);
}
function Gp(t, e) {
  return e.length === 0 ? `${t}.*` : e.map((n) => `${t}.${n}`);
}
function Na(t, e) {
  return e === void 0 ? [] : Sa(e).includes(`${t}.*`) ? [] : Sa(e).filter((n) => n.startsWith(t)).map((n) => {
    const [, r] = n.split(`${t}.`);
    return r;
  });
}
function xk(t) {
  return t.length === 0 ? ["prefect.flow-run.*"] : t.map((e) => `prefect.flow-run.${e}`);
}
function UF(t) {
  return t.includes("prefect.flow-run.*") ? [] : t.filter((e) => e.startsWith("prefect.flow-run")).map((e) => {
    const [, n] = e.split("prefect.flow-run.");
    return n;
  });
}
function ch(t, e) {
  const n = Sa(e);
  if (n.length !== 0)
    return {
      "prefect.resource.role": t,
      "prefect.resource.id": Gp(`prefect.${t}`, n)
    };
}
function m_(t, e) {
  const n = Rne(t, "prefect.resource.id");
  return n.length === 0 ? !1 : e(n);
}
function Rne(t, e) {
  if (Ti(t)) {
    const n = t.match[e];
    return n ? Sa(n) : [];
  }
  return [];
}
function y_(t, e) {
  return Ti(t) ? t.forEach.every((n) => n.startsWith(e)) : !1;
}
function g_(t, e) {
  return Ti(t) ? e(t.expect) : !1;
}
function v_(t, e) {
  return Ti(t) ? e(t.after) : !1;
}
const { values: YLe, isValue: Sk } = to(["prefect.deployment.ready", "prefect.deployment.not-ready", "prefect.deployment.disabled"]);
function Ane(t) {
  return Ti(t) && m_(t, (e) => e.every((n) => n.startsWith("prefect.deployment"))) && y_(t, "prefect.resource.id") && v_(t, (e) => e.every((n) => Sk(n))) && g_(t, (e) => e.every((n) => Sk(n))) && t.threshold === zm;
}
function Dne(t) {
  return Ti(t) && m_(t, (e) => e.every((n) => n.startsWith("prefect.flow-run"))) && y_(t, "prefect.resource.id") && v_(t, (e) => e.every((n) => n.startsWith("prefect.flow-run"))) && g_(t, (e) => e.every((n) => n.startsWith("prefect.flow-run"))) && Ene(t) && t.threshold === zm;
}
function Ene(t) {
  return Mne(t) || NE(t, "prefect.flow") || NE(t, "prefect.tag");
}
function Mne(t) {
  return Object.keys(t.matchRelated).length === 0;
}
function NE(t, e) {
  const n = Pne(t, "prefect.resource.id");
  return n.length === 0 ? !1 : n.every((r) => r.startsWith(e));
}
function Pne(t, e) {
  if (Ti(t)) {
    const n = t.matchRelated[e];
    return n ? tl(n) : [];
  }
  return [];
}
const { values: QLe, isValue: Rk } = to(["prefect.work-pool.ready", "prefect.work-pool.not-ready", "prefect.work-pool.paused", "prefect.work-pool.not_ready"]);
function Cne(t) {
  return Ti(t) && m_(t, (e) => e.every((n) => n.startsWith("prefect.work-pool"))) && y_(t, "prefect.resource.id") && v_(t, (e) => e.every((n) => Rk(n))) && g_(t, (e) => e.every((n) => Rk(n))) && t.threshold === zm;
}
const { values: KLe, isValue: Ak } = to(["prefect.work-queue.ready", "prefect.work-queue.not-ready", "prefect.work-queue.paused"]);
function One(t) {
  return Ti(t) && m_(t, (e) => e.every((n) => n.startsWith("prefect.work-queue"))) && y_(t, "prefect.resource.id") && v_(t, (e) => e.every((n) => Ak(n))) && g_(t, (e) => e.every((n) => Ak(n))) && t.threshold === zm;
}
const { values: ZLe, isValue: Ine } = to([
  "deployment-status",
  "flow-run-state",
  "work-pool-status",
  "work-queue-status",
  "custom"
]), Fne = {
  "deployment-status": "Deployment status",
  "flow-run-state": "Flow run state",
  "work-pool-status": "Work pool status",
  "work-queue-status": "Work queue status",
  custom: "Custom"
};
function JLe(t) {
  return Fne[t];
}
const Nne = {
  "deployment-status": Ane,
  "flow-run-state": Dne,
  "work-pool-status": Cne,
  "work-queue-status": One
};
function Lne(t) {
  for (const [e, n] of Object.entries(Nne))
    if (n(t) && Ine(e))
      return e;
  return "custom";
}
const Bne = "all";
class Une {
  type = "compound";
  triggers;
  within;
  require;
  constructor(e) {
    this.within = e.within ?? 0, this.triggers = e.triggers ?? [], this.require = e.require ?? Bne;
  }
}
class Xne {
  type = "sequence";
  triggers;
  within;
  constructor(e) {
    this.within = e.within ?? 0, this.triggers = e.triggers ?? [];
  }
}
const $ne = (t) => new xne(t), Wne = function(t) {
  const e = {};
  return CF(t) ? {
    ...e,
    from: "event",
    eventId: t.event.id,
    occurred: this.map("Date", t.event.occurred, "string")
  } : OF(t) ? {
    ...e,
    from: "flow",
    flowId: t.flowId
  } : IF(t) ? {
    ...e,
    from: "workPool",
    workPoolId: t.workPoolId
  } : FF(t) ? {
    ...e,
    from: "workPoolQueue",
    workPoolQueueId: t.workPoolQueueId
  } : e;
}, Vne = function(t) {
  return {
    actions: t.actions.map((e) => encodeURIComponent(JSON.stringify(e)))
  };
}, Hne = function(t) {
  let e = {};
  return vne(t) && (e = {
    ...e,
    ...this.map("CreateAutomationActionQuery", t, "LocationQuery")
  }), gne(t) && (e = {
    ...e,
    ...this.map("CreateAutomationTriggerQuery", t, "LocationQuery")
  }), e;
}, jne = function(t) {
  return t.posture === "Reactive" ? qne(t) : Gne(t);
}, zne = function(t) {
  return t.posture === "Reactive" ? Yne(t) : Qne(t);
};
function qne(t) {
  return new $o({
    posture: "Reactive",
    match: {
      "prefect.resource.id": Gp("prefect.deployment", t.deployments)
    },
    forEach: ["prefect.resource.id"],
    expect: [Dk(t.status)]
  });
}
function Gne(t) {
  return new $o({
    posture: "Proactive",
    match: {
      "prefect.resource.id": Gp("prefect.deployment", t.deployments)
    },
    forEach: ["prefect.resource.id"],
    expect: [Dk(Kne(t.status))],
    after: [Dk(t.status)],
    within: t.time
  });
}
function Yne(t) {
  return {
    deployments: Na("prefect.deployment", t.match["prefect.resource.id"]),
    posture: "Reactive",
    status: XF(t.expect),
    time: t.within
  };
}
function Qne(t) {
  return {
    deployments: Na("prefect.deployment", t.match["prefect.resource.id"]),
    posture: "Proactive",
    status: XF(t.after),
    time: t.within
  };
}
function Kne(t) {
  return t === "ready" ? "not_ready" : "ready";
}
function Dk(t) {
  switch (t) {
    case "ready":
      return "prefect.deployment.ready";
    case "not_ready":
      return "prefect.deployment.not-ready";
    case "disabled":
      return "prefect.deployment.disabled";
    default:
      return `prefect.deployment.${t}`;
  }
}
const Zne = {
  "prefect.deployment.ready": "ready",
  "prefect.deployment.not-ready": "not_ready",
  "prefect.deployment.disabled": "disabled"
};
function XF(t) {
  for (const e of t)
    if (Sk(e))
      return Zne[e];
  throw new Error(`Unknown deployment status events: ${t}`);
}
const Jne = function(t) {
  return t.posture === "Reactive" ? rre(t) : ore(t);
}, ere = function(t) {
  return t.posture === "Reactive" ? tre(t) : nre(t);
};
function tre(t) {
  return {
    flowIds: Na("prefect.flow", t.matchRelated["prefect.resource.id"]),
    tags: Na("prefect.tag", t.matchRelated["prefect.resource.id"]),
    posture: "Reactive",
    states: UF(t.expect),
    time: t.within
  };
}
function nre(t) {
  return {
    flowIds: Na("prefect.flow", t.matchRelated["prefect.resource.id"]),
    tags: Na("prefect.tag", t.matchRelated["prefect.resource.id"]),
    posture: "Proactive",
    states: UF(t.after),
    time: t.within
  };
}
function rre(t) {
  return new $o({
    posture: "Reactive",
    match: {
      "prefect.resource.id": "prefect.flow-run.*"
    },
    matchRelated: {
      ...ch("flow", t.flowIds),
      ...ch("tag", t.tags)
    },
    forEach: ["prefect.resource.id"],
    expect: xk(t.states)
  });
}
function ore(t) {
  return new $o({
    posture: "Proactive",
    match: {
      "prefect.resource.id": "prefect.flow-run.*"
    },
    matchRelated: {
      ...ch("flow", t.flowIds),
      ...ch("tag", t.tags)
    },
    forEach: ["prefect.resource.id"],
    after: xk(t.states),
    expect: xk([]),
    within: t.time
  });
}
const sre = function(t) {
  if (bne(t))
    return new $o({
      posture: t.posture,
      threshold: t.threshold,
      match: t.match,
      matchRelated: t.match_related,
      forEach: t.for_each,
      after: t.after,
      expect: t.expect,
      within: t.within
    });
  if (kne(t))
    return new Une({
      triggers: this.map("AutomationTriggerResponse", t.triggers, "AutomationTrigger"),
      require: t.require,
      within: t.within
    });
  if (Tne(t))
    return new Xne({
      triggers: this.map("AutomationTriggerResponse", t.triggers, "AutomationTrigger"),
      within: t.within
    });
  const e = t;
  throw new Error(`Trigger map is not exhaustive: ${e.type}`);
}, are = function(t) {
  if (Ti(t))
    return {
      type: "event",
      match: t.match,
      match_related: t.matchRelated,
      after: t.after,
      expect: t.expect,
      for_each: t.forEach,
      posture: t.posture,
      threshold: t.threshold,
      within: t.within
    };
  if (NF(t))
    return {
      type: "compound",
      triggers: this.map("AutomationTrigger", t.triggers, "AutomationTriggerRequest"),
      require: t.require,
      within: t.within
    };
  if (LF(t))
    return {
      type: "sequence",
      triggers: this.map("AutomationTrigger", t.triggers, "AutomationTriggerRequest"),
      within: t.within
    };
  const e = t;
  throw new Error(`No mapper for automation trigger type: ${e.type}`);
}, ire = (t) => {
  const e = t.expect.concat(t.after), n = ["prefect.log.write", "prefect.task-run."];
  return {
    event: e.reduce((o, s) => (s.endsWith("*") ? (o.prefix ??= [], o.prefix.push(s.slice(0, -1))) : (o.name ??= [], o.name.push(s)), o.excludePrefix = n, o), {}),
    resource: ure(t.match),
    related: lre(t.matchRelated),
    occurred: {
      since: Gr.startOfWeek(/* @__PURE__ */ new Date()),
      until: Gr.endOfWeek(/* @__PURE__ */ new Date())
    }
  };
};
function ure(t) {
  const { ["prefect.resource.id"]: e, ...n } = t, { id: r, idPrefix: o } = $F(e);
  return { id: r, idPrefix: o, labels: n };
}
function lre(t) {
  const { ["prefect.resource.id"]: e, ...n } = t, { id: r } = $F(e), o = t["prefect.resource.role"] ? Sa(t["prefect.resource.role"]) : void 0;
  return { id: r, role: o, labels: n };
}
function $F(t) {
  const e = [], n = [];
  if (t)
    for (const r of Sa(t))
      r.endsWith("*") ? n.push(r.slice(0, -1)) : e.push(r);
  return { id: e, idPrefix: n };
}
const cre = function(t) {
  return t.posture === "Reactive" ? dre(t) : hre(t);
}, pre = function(t) {
  return t.posture === "Reactive" ? fre(t) : mre(t);
};
function dre(t) {
  return new $o({
    posture: "Reactive",
    match: {
      "prefect.resource.id": Gp("prefect.work-pool", t.workPools)
    },
    forEach: ["prefect.resource.id"],
    expect: Ek(t.status)
  });
}
function hre(t) {
  return new $o({
    posture: "Proactive",
    match: {
      "prefect.resource.id": Gp("prefect.work-pool", t.workPools)
    },
    forEach: ["prefect.resource.id"],
    expect: yre(t.status).flatMap(Ek),
    after: Ek(t.status),
    within: t.time
  });
}
function fre(t) {
  return {
    workPools: Na("prefect.work-pool", t.match["prefect.resource.id"]),
    posture: "Reactive",
    status: WF(t.expect),
    time: t.within
  };
}
function mre(t) {
  return {
    workPools: Na("prefect.work-pool", t.match["prefect.resource.id"]),
    posture: "Proactive",
    status: WF(t.after),
    time: t.within
  };
}
function yre(t) {
  return U0.filter((e) => e !== t);
}
function Ek(t) {
  switch (t) {
    case "ready":
      return ["prefect.work-pool.ready"];
    case "not_ready":
      return [
        "prefect.work-pool.not-ready",
        // compatibility with old event name
        // remove after data migration to adjust existing automation triggers
        // to use new event name
        "prefect.work-pool.not_ready"
      ];
    case "paused":
      return ["prefect.work-pool.paused"];
    case null:
      return [];
    default:
      return [`prefect.work-pool.${t}`];
  }
}
const gre = {
  "prefect.work-pool.ready": "ready",
  "prefect.work-pool.not-ready": "not_ready",
  "prefect.work-pool.not_ready": "not_ready",
  "prefect.work-pool.paused": "paused"
};
function WF(t) {
  for (const e of t)
    if (Rk(e))
      return gre[e];
  throw new Error(`Unknown work pool status events: ${t}`);
}
const vre = function(t) {
  return t.posture === "Reactive" ? _re(t) : wre(t);
};
function _re(t) {
  return new $o({
    posture: "Reactive",
    match: {
      "prefect.resource.id": Gp("prefect.work-queue", t.workQueues)
    },
    matchRelated: {
      ...ch("work-pool", t.workPools)
    },
    forEach: ["prefect.resource.id"],
    expect: [Mk(t.status)]
  });
}
function wre(t) {
  return new $o({
    posture: "Proactive",
    match: {
      "prefect.resource.id": Gp("prefect.work-queue", t.workQueues)
    },
    matchRelated: {
      ...ch("work-pool", t.workPools)
    },
    forEach: ["prefect.resource.id"],
    expect: bre(t.status).map(Mk),
    after: [Mk(t.status)],
    within: t.time
  });
}
function bre(t) {
  return uF.filter((e) => e !== t);
}
const kre = function(t) {
  return t.posture === "Reactive" ? Tre(t) : xre(t);
};
function Tre(t) {
  return {
    workPools: Na("prefect.work-pool", t.matchRelated["prefect.resource.id"]),
    workQueues: Na("prefect.work-queue", t.match["prefect.resource.id"]),
    status: VF(t),
    posture: "Reactive",
    time: t.within
  };
}
function xre(t) {
  return {
    workPools: Na("prefect.work-pool", t.matchRelated["prefect.resource.id"]),
    workQueues: Na("prefect.work-queue", t.match["prefect.resource.id"]),
    status: VF(t),
    posture: "Proactive",
    time: t.within
  };
}
const Sre = {
  "prefect.work-queue.ready": "ready",
  "prefect.work-queue.not-ready": "not_ready",
  "prefect.work-queue.paused": "paused"
};
function VF(t) {
  const e = t.posture === "Reactive" ? t.expect : t.after;
  for (const n of e)
    if (Ak(n))
      return Sre[n];
  throw new Error(`Unknown work queue status events: ${e}`);
}
function Mk(t) {
  switch (t) {
    case "not_ready":
      return "prefect.work-queue.not-ready";
    case "ready":
    case "paused":
      return `prefect.work-queue.${t}`;
    default:
      return `prefect.work-queue.${t}`;
  }
}
function eBe(t, e) {
  return t.type === e;
}
function i2(t) {
  return typeof t == "string" && Y3.includes(t) && t !== "unknown";
}
function tBe(t) {
  return typeof t == "object";
}
function nBe(t) {
  return typeof t == "string";
}
function HF(t) {
  return Array.isArray(t) && t.every((e) => wn(e));
}
function jF(t) {
  return !!t && typeof t == "object" && Object.values(t).every((e) => Array.isArray(e));
}
function Rre(t) {
  return HF(t) || jF(t);
}
const Are = function(t) {
  return new Q3({
    id: t.id,
    created: this.map("string", t.created, "Date"),
    updated: this.map("string", t.updated, "Date"),
    description: t.description,
    key: t.key,
    type: i2(t.type) ? t.type : "unknown",
    data: t.data,
    metadata: t.metadata_,
    flowRunId: t.flow_run_id,
    taskRunId: t.task_run_id
  });
}, Dre = function(t) {
  return new wee({
    id: t.id,
    latestId: t.latest_id,
    created: this.map("string", t.created, "Date"),
    updated: this.map("string", t.updated, "Date"),
    description: t.description,
    key: t.key,
    type: i2(t.type) ? t.type : "unknown",
    data: t.data,
    metadata: t.metadata_,
    flowRunId: t.flow_run_id,
    taskRunId: t.task_run_id
  });
}, Ere = function(t) {
  const e = this.map("BlockSchemaResponse", t.block_schema, "BlockSchema");
  return new K3({
    id: t.id,
    name: t.name,
    isAnonymous: t.is_anonymous,
    blockSchemaId: t.block_schema_id,
    blockTypeId: t.block_type_id,
    created: this.map("string", t.created, "Date"),
    updated: this.map("string", t.updated, "Date"),
    blockDocumentReferences: this.map("BlockDocumentReferencesResponse", t.block_document_references, "BlockDocumentReferences"),
    blockType: this.map("BlockTypeResponse", t.block_type, "BlockType"),
    blockSchema: e,
    data: this.map("SchemaValuesResponse", { values: t.data, references: t.block_document_references, schema: e.fields }, "SchemaValues"),
    can: Ac()
  });
}, Mre = function({ name: t, id: e }) {
  return {
    label: t,
    value: e
  };
}, Pre = function(t) {
  const { blockSchema: e, data: n } = t, r = e.fields, o = this.map("SchemaValues", { values: n, schema: r }, "SchemaValuesRequest");
  return bee(t) ? {
    name: t.name,
    block_schema_id: e.id,
    block_type_id: e.blockTypeId,
    data: o
  } : {
    is_anonymous: t.isAnonymous,
    block_schema_id: e.id,
    block_type_id: e.blockTypeId,
    data: o
  };
}, Cre = function(t) {
  const e = {};
  return Object.keys(t).reduce((n, r) => {
    const { block_document: o } = t[r], { block_type: s } = o, i = {
      id: o.id,
      isAnonymous: o.is_anonymous,
      name: o.name,
      blockType: this.map("BlockTypeResponse", s, "BlockType")
    };
    return n[r] = i, n;
  }, e);
}, Ore = function(t) {
  const { blockSchema: e, data: n, mergeExistingData: r } = t, o = e.fields;
  return {
    data: this.map("SchemaValues", { values: n, schema: o }, "SchemaValuesRequest"),
    merge_existing_data: r
  };
}, Ire = function(t) {
  return new Z3({
    id: t.id,
    checksum: t.checksum,
    blockTypeId: t.block_type_id,
    capabilities: t.capabilities,
    created: this.map("string", t.created, "Date"),
    updated: this.map("string", t.updated, "Date"),
    fields: this.map("SchemaResponse", t.fields, "Schema"),
    blockType: this.map("BlockTypeResponse", t.block_type, "BlockType")
  });
}, Fre = function(t) {
  return Ds(t, (e, n) => ({
    blockSchemaChecksum: n.block_schema_checksum,
    blockTypeSlug: n.block_type_slug
  }));
}, Nre = function(t) {
  return new J3({
    id: t.id,
    name: t.name,
    slug: t.slug,
    logoUrl: t.logo_url,
    documentationUrl: t.documentation_url,
    description: t.description,
    codeExample: t.code_example,
    created: this.map("string", t.created, "Date"),
    updated: this.map("string", t.updated, "Date")
  });
}, Lre = function(t) {
  return {
    collectionType: "flow",
    name: t.name,
    description: t.description.summary,
    returns: t.description.returns,
    examples: t.description.examples,
    documentationUrl: t.documentation_url,
    entrypoint: t.entrypoint,
    installCommand: t.install_command,
    logoUrl: t.logo_url,
    parameters: t.parameters,
    path: t.path_containing_flow,
    repositoryUrl: t.repo_url,
    slug: t.slug
  };
}, Bre = function(t) {
  return Object.entries(t).flatMap(([e, n]) => this.map("CollectionItemResponse", Object.values(n), "CollectionItem").map((o) => ({ ...o, category: e })));
}, Ure = function(t) {
  const { tag: e, id: n, created: r, updated: o } = t;
  return {
    tag: e,
    id: n,
    created: r,
    updated: o,
    activeSlots: t.active_slots,
    concurrencyLimit: t.concurrency_limit
  };
}, Xre = function(t) {
  const { tag: e } = t;
  return {
    tag: e,
    concurrency_limit: t.concurrencyLimit
  };
}, $re = function(t) {
  const {
    id: e,
    created: n,
    updated: r,
    active: o,
    name: s,
    limit: i
  } = t;
  return {
    id: e,
    created: n,
    updated: r,
    active: o,
    name: s,
    limit: i,
    activeSlots: t.active_slots,
    deniedSlots: t.denied_slots,
    slotDecayPerSecond: t.slot_decay_per_second,
    avgSlotOccupancySeconds: t.avg_slot_occupancy_seconds
  };
}, Wre = function(t) {
  const {
    active: e,
    name: n,
    limit: r
  } = t;
  return {
    active: e,
    name: n,
    limit: r,
    denied_slots: t.deniedSlots,
    slot_decay_per_second: t.slotDecayPerSecond
  };
}, Vre = function(t) {
  const {
    active: e,
    name: n,
    limit: r
  } = t;
  return {
    active: e,
    name: n,
    limit: r,
    active_slots: t.activeSlots,
    denied_slots: t.deniedSlots,
    slot_decay_per_second: t.slotDecayPerSecond
  };
}, Hre = function(t) {
  return {
    id: t.id,
    displayValue: t.display_value,
    type: t.type
  };
}, jre = function(t) {
  const { startDate: e, endDate: n } = this.map("DateRangeSelectValue", t.range, "DateRange");
  return {
    flowRuns: {
      tags: {
        anyName: t.tags
      },
      parentTaskRunIdNull: t.hideSubflows ? !0 : void 0
    },
    taskRuns: {
      startTimeAfter: e,
      startTimeBefore: n
    }
  };
}, zre = function(t) {
  const { startDate: e, endDate: n, timeSpanInSeconds: r } = this.map("DateRangeSelectValue", t.range, "DateRange");
  return {
    historyStart: e,
    historyEnd: n,
    historyIntervalSeconds: r / 20,
    flowRuns: {
      tags: {
        anyName: t.tags
      },
      parentTaskRunIdNull: t.hideSubflows ? !0 : void 0
    }
  };
}, qre = function(t) {
  const { startDate: e, endDate: n } = this.map("DateRangeSelectValue", t.range, "DateRange");
  return {
    flowRuns: {
      expectedStartTimeAfter: e,
      expectedStartTimeBefore: n,
      tags: {
        anyName: t.tags
      },
      parentTaskRunIdNull: t.hideSubflows ? !0 : void 0
    }
  };
}, Gre = function(t) {
  const { startDate: e, endDate: n } = this.map("DateRangeSelectValue", t.range, "DateRange");
  return {
    workers: {
      lastHeartbeatTimeAfter: e,
      lastHeartbeatTimeBefore: n
    }
  };
}, Yre = function(t) {
  return new Date(t);
}, Qre = function(t) {
  return t.toISOString();
}, Kre = (t) => {
  const e = Aj(t);
  if (!e)
    throw new Error("Failed to map date range because value is null");
  return e;
}, Dc = (t, e) => {
  const n = t.__vccOpts || t;
  for (const [r, o] of e)
    n[r] = o;
  return n;
}, Zre = {};
function Jre(t, e) {
  const n = P("p-link");
  return T(), z("span", null, [
    e[1] || (e[1] = q("There was an error validating your parameters. If the issue persists please ", -1)),
    w(n, { href: "https://github.com/PrefectHQ/prefect/issues/new/choose" }, {
      default: k(() => [...e[0] || (e[0] = [
        q("report an issue.", -1)
      ])]),
      _: 1
    })
  ]);
}
const u2 = /* @__PURE__ */ Dc(Zre, [["render", Jre]]);
var C1, LE;
function eoe() {
  if (LE) return C1;
  LE = 1;
  var t = "Expected a function", e = NaN, n = "[object Symbol]", r = /^\s+|\s+$/g, o = /^[-+]0x[0-9a-f]+$/i, s = /^0b[01]+$/i, i = /^0o[0-7]+$/i, u = parseInt, l = typeof Yr == "object" && Yr && Yr.Object === Object && Yr, a = typeof self == "object" && self && self.Object === Object && self, c = l || a || Function("return this")(), p = Object.prototype, d = p.toString, h = Math.max, m = Math.min, g = function() {
    return c.Date.now();
  };
  function _(A, C, M) {
    var L, X, te, B, W, G, ne = 0, de = !1, V = !1, Y = !0;
    if (typeof A != "function")
      throw new TypeError(t);
    C = E(C) || 0, b(M) && (de = !!M.leading, V = "maxWait" in M, te = V ? h(E(M.maxWait) || 0, C) : te, Y = "trailing" in M ? !!M.trailing : Y);
    function Q(Ie) {
      var Me = L, fe = X;
      return L = X = void 0, ne = Ie, B = A.apply(fe, Me), B;
    }
    function ae(Ie) {
      return ne = Ie, W = setTimeout(oe, C), de ? Q(Ie) : B;
    }
    function Z(Ie) {
      var Me = Ie - G, fe = Ie - ne, Te = C - Me;
      return V ? m(Te, te - fe) : Te;
    }
    function J(Ie) {
      var Me = Ie - G, fe = Ie - ne;
      return G === void 0 || Me >= C || Me < 0 || V && fe >= te;
    }
    function oe() {
      var Ie = g();
      if (J(Ie))
        return ue(Ie);
      W = setTimeout(oe, Z(Ie));
    }
    function ue(Ie) {
      return W = void 0, Y && L ? Q(Ie) : (L = X = void 0, B);
    }
    function me() {
      W !== void 0 && clearTimeout(W), ne = 0, L = G = X = W = void 0;
    }
    function pe() {
      return W === void 0 ? B : ue(g());
    }
    function Be() {
      var Ie = g(), Me = J(Ie);
      if (L = arguments, X = this, G = Ie, Me) {
        if (W === void 0)
          return ae(G);
        if (V)
          return W = setTimeout(oe, C), Q(G);
      }
      return W === void 0 && (W = setTimeout(oe, C)), B;
    }
    return Be.cancel = me, Be.flush = pe, Be;
  }
  function b(A) {
    var C = typeof A;
    return !!A && (C == "object" || C == "function");
  }
  function x(A) {
    return !!A && typeof A == "object";
  }
  function S(A) {
    return typeof A == "symbol" || x(A) && d.call(A) == n;
  }
  function E(A) {
    if (typeof A == "number")
      return A;
    if (S(A))
      return e;
    if (b(A)) {
      var C = typeof A.valueOf == "function" ? A.valueOf() : A;
      A = b(C) ? C + "" : C;
    }
    if (typeof A != "string")
      return A === 0 ? A : +A;
    A = A.replace(r, "");
    var M = s.test(A);
    return M || i.test(A) ? u(A.slice(2), M ? 2 : 8) : o.test(A) ? e : +A;
  }
  return C1 = _, C1;
}
var toe = eoe();
const __ = /* @__PURE__ */ Nh(toe), noe = ["CREATED_DESC", "UPDATED_DESC", "KEY_DESC", "KEY_ASC", "ID_ASC", "ID_DESC"], rBe = "CREATED_DESC";
function oBe(t) {
  return noe.includes(Qe(t));
}
const sBe = [
  { label: "Created", value: "CREATED_DESC" },
  { label: "Updated", value: "UPDATED_DESC" },
  { label: "A to Z", value: "KEY_ASC" },
  { label: "Z to A", value: "KEY_DESC" }
], roe = ["CREATED_DESC", "UPDATED_DESC", "NAME_DESC", "NAME_ASC"], ooe = "NAME_ASC";
function aBe(t) {
  return roe.includes(Qe(t));
}
const soe = [
  { label: "Created", value: "CREATED_DESC" },
  { label: "Updated", value: "UPDATED_DESC" },
  { label: "A to Z", value: "NAME_ASC" },
  { label: "Z to A", value: "NAME_DESC" }
], aoe = ["CREATED_DESC", "UPDATED_DESC", "NAME_DESC", "NAME_ASC"], w_ = "NAME_ASC";
function BE(t) {
  return aoe.includes(Qe(t));
}
const ioe = [
  { label: "Created", value: "CREATED_DESC" },
  { label: "A to Z", value: "NAME_ASC" },
  { label: "Z to A", value: "NAME_DESC" }
], uoe = ["CREATED_DESC", "UPDATED_DESC", "NAME_DESC", "NAME_ASC"], b_ = "NAME_ASC";
function UE(t) {
  return uoe.includes(Qe(t));
}
const loe = [
  { label: "Created", value: "CREATED_DESC" },
  { label: "A to Z", value: "NAME_ASC" },
  { label: "Z to A", value: "NAME_DESC" }
], coe = [
  "ID_DESC",
  "END_TIME_DESC",
  "CREATED_DESC",
  "NAME_DESC",
  "NAME_ASC",
  "EXPECTED_START_TIME_DESC",
  "EXPECTED_START_TIME_ASC",
  "NEXT_SCHEDULED_START_TIME_ASC",
  "START_TIME_DESC",
  "START_TIME_ASC",
  /**
   * Only supported by cloud
   */
  "DURATION_DESC",
  /**
   * Only supported by cloud
   */
  "LATENESS_DESC"
], Lh = "START_TIME_DESC";
function XE(t) {
  return coe.includes(Qe(t));
}
const poe = ["ID_DESC", "EXPECTED_START_TIME_ASC", "EXPECTED_START_TIME_DESC", "NAME_DESC", "NAME_ASC", "NEXT_SCHEDULED_START_TIME_ASC", "END_TIME_DESC"], zF = "EXPECTED_START_TIME_DESC";
function $E(t) {
  return poe.includes(Qe(t));
}
const doe = ["TIMESTAMP_ASC", "TIMESTAMP_DESC", "LEVEL_ASC", "LEVEL_DESC", "FLOW_RUN_ID_ASC", "FLOW_RUN_ID_DESC", "TASK_RUN_ID_ASC", "TASK_RUN_ID_DESC"], iBe = "TIMESTAMP_ASC";
function WE(t) {
  return doe.includes(Qe(t));
}
const hoe = ["NAME_DESC", "NAME_ASC", "BLOCK_TYPE_AND_NAME_ASC"], uBe = "BLOCK_TYPE_AND_NAME_ASC";
function VE(t) {
  return hoe.includes(Qe(t));
}
const foe = ["LAST_HEARTBEAT_ASC", "LAST_HEARTBEAT_DESC", "NAME_ASC", "NAME_DESC", "CLIENT_VERSION_ASC", "CLIENT_VERSION_DESC", "STATUS_ASC", "STATUS_DESC"], moe = "LAST_HEARTBEAT_DESC";
function lBe(t) {
  return foe.includes(Qe(t));
}
class yoe extends Ba {
  parse(e) {
    if (VE(e))
      return e;
    throw new Zr();
  }
  format(e) {
    if (VE(e))
      return e;
    throw new Zr();
  }
}
class qF extends Ba {
  parse(e) {
    if (UE(e))
      return e;
    throw new Zr();
  }
  format(e) {
    if (UE(e))
      return e;
    throw new Zr();
  }
}
class goe extends Ba {
  parse(e) {
    if (e === null || !Iee(e))
      throw new Zr();
    return e;
  }
  format(e) {
    return e;
  }
}
class voe extends Ba {
  parse(e) {
    if (e === null || typeof e != "string")
      throw new Zr();
    const n = JSON.parse(e);
    if (!Uee(n))
      throw new Zr();
    return n;
  }
  format(e) {
    return JSON.stringify(e);
  }
}
class l2 extends Ba {
  parse(e) {
    if (XE(e))
      return e;
    throw new Zr();
  }
  format(e) {
    if (XE(e))
      return e;
    throw new Zr();
  }
}
class GF extends Ba {
  parse(e) {
    if (BE(e))
      return e;
    throw new Zr();
  }
  format(e) {
    if (BE(e))
      return e;
    throw new Zr();
  }
}
class Ro extends Ba {
  parse(e) {
    if (e === null || !Bee(e))
      throw new Zr();
    return e;
  }
  format(e) {
    return `${e}`;
  }
}
class _oe extends Ba {
  parse(e) {
    if ($E(e))
      return e;
    throw new Zr();
  }
  format(e) {
    if ($E(e))
      return e;
    throw new Zr();
  }
}
function cBe(t) {
  return ["h", "d", "w", "m", "y"].includes(t);
}
const woe = ["date", "regex", "date-time", "time-delta", "email", "json-string", "password"], HE = [
  // prefect ui custom types
  "block",
  // open api types
  "null",
  "string",
  "boolean",
  "integer",
  "number",
  "array",
  "object"
], pBe = "#/definitions/";
function YF(t) {
  return typeof t == "object" && t !== null && !Array.isArray(t);
}
function zd(t, e) {
  return e in t;
}
function dBe(t) {
  return !!t.route;
}
const { values: hBe, isValue: fBe } = to(["ASC", "DESC"]);
function Kn(t, e) {
  const n = JSON.parse(JSON.stringify(t)), r = () => {
    lc(t, n);
  }, o = (u) => {
    lc(t, u);
  }, s = D(() => JSON.stringify(t) === JSON.stringify(n)), i = D(() => !s.value);
  return {
    filter: t,
    clear: r,
    set: o,
    isDefaultFilter: s,
    isCustomFilter: i
  };
}
function Gm(t, e) {
  const { sort: n = e, ...r } = fj(t) ? Nn(t) : t;
  return lt({ ...r, sort: n });
}
function ra(t, e) {
  lc(t, e), Ct(t, () => {
    lc(e, t);
  });
  const n = __(() => {
    cm(t, e) || lc(t, e);
  }, 100);
  Ct(e, () => {
    n();
  }, { deep: !0 });
}
function Ym(t, e, n) {
  const r = lt(e), o = Gj(t, r, n), s = lt(o);
  return Kn(s);
}
function Yp(t, e, n, r) {
  const o = Gm(e, n);
  return Ym(t, o, r);
}
function Qm(t = {}) {
  const e = lt(t), n = lt({
    operator: xe(e, "operator"),
    name: xe(e, "name"),
    anyName: xe(e, "anyName"),
    isNull: xe(e, "isNull")
  });
  return Kn(n);
}
const k_ = {
  operator: Ro,
  name: [Xt],
  anyName: [Xt],
  isNull: Yo
};
function boe(t = {}) {
  const e = lt(t), n = lt({
    operator: xe(e, "operator"),
    deploymentId: xe(e, "deploymentId"),
    versionId: xe(e, "versionId")
  });
  return Kn(n);
}
const koe = {
  operator: Ro,
  deploymentId: Xt,
  versionId: [Xt]
};
function Toe(t = {}) {
  const e = lt(t), n = lt({
    operator: xe(e, "operator"),
    deploymentId: xe(e, "deploymentId"),
    versionInfo: xe(e, "versionInfo")
  });
  return Kn(n);
}
const xoe = {
  operator: Ro,
  deploymentId: Xt,
  versionInfo: [voe]
};
function QF(t = {}) {
  const e = lt(t), n = lt({
    operator: xe(e, "operator"),
    name: xe(e, "name"),
    type: xe(e, "type")
  });
  return Kn(n);
}
const KF = {
  operator: Ro,
  type: [Xt],
  name: [Xt]
};
function ZF(t = {}) {
  const e = lt(t), n = Qm(e.tags), r = lt({
    operator: xe(e, "operator"),
    id: xe(e, "id"),
    name: xe(e, "name"),
    nameLike: xe(e, "nameLike"),
    tags: n.filter
  });
  return Kn(r);
}
const JF = {
  operator: Ro,
  id: [Xt],
  name: [Xt],
  nameLike: Xt,
  tags: k_
};
function eN(t = {}) {
  const e = lt(t), n = QF(e.state), r = Qm(e.tags), o = boe(e.deploymentVersionId), s = Toe(e.deploymentVersionInfo), i = lt({
    deploymentId: xe(e, "deploymentId"),
    deploymentIdNull: xe(e, "deploymentIdNull"),
    deploymentIdOperator: xe(e, "deploymentIdOperator"),
    deploymentVersionId: o.filter,
    deploymentVersionInfo: s.filter,
    expectedStartTimeAfter: xe(e, "expectedStartTimeAfter"),
    expectedStartTimeBefore: xe(e, "expectedStartTimeBefore"),
    flowVersion: xe(e, "flowVersion"),
    id: xe(e, "id"),
    name: xe(e, "name"),
    nameLike: xe(e, "nameLike"),
    nextExpectedStartTimeAfter: xe(e, "nextExpectedStartTimeAfter"),
    nextExpectedStartTimeBefore: xe(e, "nextExpectedStartTimeBefore"),
    notId: xe(e, "notId"),
    operator: xe(e, "operator"),
    parentTaskRunId: xe(e, "parentTaskRunId"),
    parentTaskRunIdNull: xe(e, "parentTaskRunIdNull"),
    parentTaskRunIdOperator: xe(e, "parentTaskRunIdOperator"),
    parentFlowRunId: xe(e, "parentFlowRunId"),
    startTimeAfter: xe(e, "startTimeAfter"),
    startTimeBefore: xe(e, "startTimeBefore"),
    startTimeNull: xe(e, "startTimeNull"),
    endTimeAfter: xe(e, "endTimeAfter"),
    endTimeBefore: xe(e, "endTimeBefore"),
    endTimeNull: xe(e, "endTimeNull"),
    state: n.filter,
    tags: r.filter,
    workQueueName: xe(e, "workQueueName"),
    workQueueNameIsNull: xe(e, "workQueueNameIsNull"),
    workQueueNameOperator: xe(e, "workQueueNameOperator"),
    workQueueId: xe(e, "workQueueId"),
    workQueueIdNull: xe(e, "workQueueIdNull"),
    workQueueIdOperator: xe(e, "workQueueIdOperator")
  });
  return Kn(i);
}
const tN = {
  operator: Ro,
  id: [Xt],
  notId: [Xt],
  name: [Xt],
  nameLike: Xt,
  tags: k_,
  deploymentIdOperator: Ro,
  deploymentId: [Xt],
  deploymentIdNull: Yo,
  deploymentVersionId: koe,
  deploymentVersionInfo: xoe,
  workQueueNameOperator: Ro,
  workQueueName: [Xt],
  workQueueNameIsNull: Yo,
  workQueueIdOperator: Ro,
  workQueueId: [Xt],
  workQueueIdNull: Yo,
  state: KF,
  flowVersion: [Xt],
  expectedStartTimeBefore: mo,
  expectedStartTimeAfter: mo,
  nextExpectedStartTimeBefore: mo,
  nextExpectedStartTimeAfter: mo,
  startTimeBefore: mo,
  startTimeAfter: mo,
  startTimeNull: Yo,
  endTimeBefore: mo,
  endTimeAfter: mo,
  endTimeNull: Yo,
  parentTaskRunIdOperator: Ro,
  parentTaskRunId: [Xt],
  parentTaskRunIdNull: Yo,
  parentFlowRunId: [Xt]
};
function nN(t = {}) {
  const e = lt(t), n = Qm(e.tags), r = QF(e.state), o = lt({
    id: xe(e, "id"),
    name: xe(e, "name"),
    nameLike: xe(e, "nameLike"),
    operator: xe(e, "operator"),
    startTimeAfter: xe(e, "startTimeAfter"),
    startTimeBefore: xe(e, "startTimeBefore"),
    startTimeNull: xe(e, "startTimeNull"),
    expectedStartTimeAfter: xe(e, "expectedStartTimeAfter"),
    expectedStartTimeBefore: xe(e, "expectedStartTimeBefore"),
    expectedStartTimeNull: xe(e, "expectedStartTimeNull"),
    state: r.filter,
    subFlowRunsExist: xe(e, "subFlowRunsExist"),
    tags: n.filter,
    flowRunId: xe(e, "flowRunId"),
    flowRunIdOperator: xe(e, "flowRunIdOperator"),
    flowRunIdNull: xe(e, "flowRunIdNull")
  });
  return Kn(o);
}
const rN = {
  operator: Ro,
  id: [Xt],
  name: [Xt],
  nameLike: Xt,
  tags: k_,
  state: KF,
  startTimeBefore: mo,
  startTimeAfter: mo,
  startTimeNull: Yo,
  expectedStartTimeBefore: mo,
  expectedStartTimeAfter: mo,
  expectedStartTimeNull: Yo,
  subFlowRunsExist: Yo,
  flowRunIdOperator: Ro,
  flowRunId: [Xt],
  flowRunIdNull: Yo
};
function oN(t = {}) {
  const e = lt(t), n = Qm(e.tags), r = lt({
    operator: xe(e, "operator"),
    id: xe(e, "id"),
    name: xe(e, "name"),
    nameLike: xe(e, "nameLike"),
    isScheduleActive: xe(e, "isScheduleActive"),
    workQueueName: xe(e, "workQueueName"),
    tags: n.filter,
    workQueueId: xe(e, "workQueueId"),
    status: xe(e, "status"),
    flowOrDeploymentNameLike: xe(e, "flowOrDeploymentNameLike"),
    paused: xe(e, "paused")
  });
  return Kn(r);
}
const sN = {
  operator: Ro,
  id: [Xt],
  name: [Xt],
  nameLike: Xt,
  isScheduleActive: Yo,
  workQueueName: [Xt],
  tags: k_,
  workQueueId: [Xt],
  status: [goe],
  flowOrDeploymentNameLike: Xt,
  paused: Yo
};
function c2(t = {}) {
  const e = lt(t), n = lt({
    operator: xe(e, "operator"),
    id: xe(e, "id"),
    name: xe(e, "name"),
    type: xe(e, "type")
  });
  return Kn(n);
}
const p2 = {
  operator: Ro,
  id: [Xt],
  name: [Xt],
  type: [Xt]
};
function aN(t = {}) {
  const e = lt(t), n = lt({
    operator: xe(e, "operator"),
    id: xe(e, "id"),
    name: xe(e, "name")
  });
  return Kn(n);
}
const iN = {
  operator: Ro,
  id: [Xt],
  name: [Xt]
};
function uN(t = {}) {
  const e = lt(t), n = lt({
    nameLike: xe(e, "nameLike"),
    slug: xe(e, "slug")
  });
  return Kn(n);
}
const lN = {
  nameLike: Xt,
  slug: [Xt]
};
function d2(t = {}) {
  const e = lt(t), n = lt({
    operator: xe(e, "operator"),
    id: xe(e, "id"),
    blockTypeId: xe(e, "blockTypeId"),
    blockCapabilities: xe(e, "blockCapabilities"),
    version: xe(e, "version")
  });
  return Kn(n);
}
const h2 = {
  operator: Ro,
  id: [Xt],
  blockTypeId: [Xt],
  blockCapabilities: [Xt],
  version: [Xt]
};
function Soe(t = {}) {
  const e = lt(t), n = lt({
    operator: xe(e, "operator"),
    id: xe(e, "id"),
    isAnonymous: xe(e, "isAnonymous"),
    blockTypeId: xe(e, "blockTypeId"),
    name: xe(e, "name"),
    nameLike: xe(e, "nameLike")
  });
  return Kn(n);
}
const Roe = {
  operator: Ro,
  id: [Xt],
  isAnonymous: Yj,
  blockTypeId: [Xt],
  name: [Xt],
  nameLike: Xt
};
function cN(t = {}) {
  const e = lt(t), n = uN(e.blockTypes), r = d2(e.blockSchemas), o = lt({
    blockSchemas: r.filter,
    blockTypes: n.filter,
    limit: xe(e, "limit"),
    offset: xe(e, "offset")
  });
  return Kn(o);
}
const Aoe = {
  blockTypes: lN,
  blockSchemas: h2,
  limit: _o,
  offset: _o
};
function mBe(t = {}, e) {
  const n = cN(t), { filter: r } = Ym(Aoe, t, e);
  return ra(n.filter, r), n;
}
function Doe(t = {}) {
  const e = lt(t), n = d2(e.blockSchemas), r = lt({
    blockSchemas: n.filter,
    limit: xe(e, "limit"),
    offset: xe(e, "offset")
  });
  return Kn(r);
}
const Eoe = {
  blockSchemas: h2,
  limit: _o,
  offset: _o
};
function yBe(t = {}, e) {
  const n = Doe(t), { filter: r } = Ym(Eoe, t, e);
  return ra(n.filter, r), n;
}
function Moe(t = {}) {
  const e = lt(t), n = uN(e.blockTypes), r = d2(e.blockSchemas), o = Soe(e.blockDocuments), s = lt({
    blockTypes: n.filter,
    blockSchemas: r.filter,
    blockDocuments: o.filter,
    includeSecrets: xe(e, "includeSecrets"),
    limit: xe(e, "limit"),
    offset: xe(e, "offset"),
    sort: xe(e, "sort")
  });
  return Kn(s);
}
const Poe = {
  blockTypes: lN,
  blockSchemas: h2,
  blockDocuments: Roe,
  limit: _o,
  offset: _o,
  includeSecrets: Yo,
  sort: yoe
};
function Coe(t = {}, e) {
  const n = Moe(t), { filter: r } = Ym(Poe, t, e);
  return ra(n.filter, r), n;
}
function Ooe(t = {}) {
  const e = lt(t), n = c2(e.workPools), r = lt({
    offset: xe(e, "offset"),
    limit: xe(e, "limit"),
    workPools: n.filter
  });
  return Kn(r);
}
const Ioe = {
  workPools: p2,
  offset: _o,
  limit: _o
};
function gBe(t = {}, e) {
  const n = Ooe(t), { filter: r } = Ym(Ioe, t, e);
  return ra(n.filter, r), n;
}
function T_(t, e) {
  const n = Gm(t, e), r = ZF(n.flows), o = eN(n.flowRuns), s = nN(n.taskRuns), i = oN(n.deployments), u = c2(n.workPools), l = aN(n.workPoolQueues), a = lt({
    flows: r.filter,
    flowRuns: o.filter,
    taskRuns: s.filter,
    deployments: i.filter,
    workPools: u.filter,
    workPoolQueues: l.filter,
    sort: xe(n, "sort"),
    offset: xe(n, "offset"),
    limit: xe(n, "limit")
  });
  return Kn(a);
}
function Foe(t = {}) {
  return T_(t, w_);
}
function f2(t = {}) {
  return T_(t, Lh);
}
function pN(t = {}) {
  return T_(t, zF);
}
function Noe(t = {}) {
  return T_(t, b_);
}
function m2(t, e) {
  const n = Gm(t, e), r = ZF(n.flows), o = eN(n.flowRuns), s = nN(n.taskRuns), i = oN(n.deployments), u = c2(n.workPools), l = aN(n.workPoolQueues), a = xe(n, "page");
  a.value || (a.value = 1);
  const c = lt({
    flows: r.filter,
    flowRuns: o.filter,
    taskRuns: s.filter,
    deployments: i.filter,
    workPools: u.filter,
    workPoolQueues: l.filter,
    sort: xe(n, "sort"),
    limit: xe(n, "limit"),
    page: a
  });
  return Kn(c);
}
function y2(t, e, n, r) {
  return e.page ??= 1, Yp(t, e, n, r);
}
const g2 = {
  flows: JF,
  flowRuns: tN,
  taskRuns: rN,
  deployments: sN,
  workPools: p2,
  workPoolQueues: iN,
  page: _o,
  limit: _o
};
function Loe(t = {}) {
  return m2(t, w_);
}
function Boe(t = {}) {
  return m2(t, b_);
}
function Uoe(t = {}) {
  return m2(t, Lh);
}
const Xoe = {
  ...g2,
  sort: GF
};
function $oe(t = {}, e) {
  const n = Loe(t), { filter: r } = y2(Xoe, t, w_, e);
  return ra(n.filter, r), n;
}
const Woe = {
  ...g2,
  sort: qF
};
function Voe(t = {}, e) {
  const n = Boe(t), { filter: r } = y2(Woe, t, b_, e);
  return ra(n.filter, r), n;
}
const Hoe = {
  ...g2,
  sort: l2
};
function dN(t = {}, e) {
  const n = Uoe(t), { filter: r } = y2(Hoe, t, Lh, e);
  return ra(n.filter, r), n;
}
function joe(t = {}) {
  const e = lt(t), n = Qm(e.tags), r = lt({
    id: xe(e, "id"),
    name: xe(e, "name"),
    nameLike: xe(e, "nameLike"),
    tags: n.filter
  });
  return Kn(r);
}
function zoe(t = {}) {
  const e = Gm(t, ooe), n = lt({
    variables: joe(e.variables).filter,
    offset: e.offset,
    limit: e.limit,
    sort: e.sort
  });
  return Kn(n);
}
const Km = {
  flows: JF,
  flowRuns: tN,
  taskRuns: rN,
  deployments: sN,
  workPools: p2,
  workPoolQueues: iN,
  offset: _o,
  limit: _o
}, qoe = {
  ...Km,
  sort: GF
};
function Goe(t = {}, e) {
  const n = Foe(t), { filter: r } = Yp(qoe, t, w_, e);
  return ra(n.filter, r), n;
}
const v2 = {
  ...Km,
  sort: l2
};
function vBe(t = {}, e) {
  const n = f2(t), { filter: r } = Yp(v2, t, Lh, e);
  return ra(n.filter, r), n;
}
function _Be(t) {
  return qj(v2, t);
}
const Yoe = {
  ...Km,
  sort: _oe
};
function wBe(t = {}, e) {
  const n = pN(t), { filter: r } = Yp(Yoe, t, zF, e);
  return ra(n.filter, r), n;
}
const Qoe = {
  ...Km,
  sort: qF
};
function bBe(t = {}, e) {
  const n = Noe(t), { filter: r } = Yp(Qoe, t, b_, e);
  return ra(n.filter, r), n;
}
function Koe(t) {
  const { filter: e, ...n } = f2(t);
  return e.flowRuns.expectedStartTimeAfter = Gr.subDays(Gr.startOfToday(), 7), e.flowRuns.expectedStartTimeBefore = Gr.addDays(Gr.endOfToday(), 1), {
    filter: e,
    ...n
  };
}
function kBe(t = {}, e) {
  const n = Koe(t), { filter: r } = Yp(v2, t, Lh, e);
  return ra(n.filter, r), n;
}
function Zoe(t) {
  const e = lt(t), { filter: n } = f2(e), r = lt({
    ...n,
    historyEnd: xe(e, "historyEnd"),
    historyStart: xe(e, "historyStart"),
    historyIntervalSeconds: xe(e, "historyIntervalSeconds")
  });
  return Kn(r);
}
const Joe = {
  ...Km,
  historyEnd: mo,
  historyStart: mo,
  historyIntervalSeconds: _o,
  sort: l2
};
function TBe(t, e) {
  const n = Zoe(t), { filter: r } = Yp(Joe, t, Lh, e);
  return ra(n.filter, r), n;
}
function ese(t = {}) {
  const e = lt(t), n = lt({
    operator: xe(e, "operator"),
    lastHeartbeatTimeAfter: xe(e, "lastHeartbeatTimeAfter"),
    lastHeartbeatTimeBefore: xe(e, "lastHeartbeatTimeBefore"),
    status: xe(e, "status"),
    name: xe(e, "name")
  });
  return Kn(n);
}
function xBe(t = {}) {
  const e = Gm(t, moe), n = lt({
    workers: ese(e.workers).filter,
    limit: e.limit,
    sort: e.sort,
    page: e.page
  });
  return Kn(n);
}
function Ke() {
  return p_(Fq);
}
function Se() {
  return p_(ite);
}
function _2(t) {
  const e = Se(), n = Ke(), o = xe(() => {
    if (!n.read.artifact)
      return null;
    const u = Qe(t);
    return u ? [u] : null;
  }), s = xt(e.artifacts.getArtifact, o), i = D(() => s.response);
  return {
    subscription: s,
    artifact: i
  };
}
function tse(t) {
  const e = Se(), n = Ke(), o = xe(() => {
    if (!n.read.artifact)
      return null;
    const u = Qe(t);
    return u ? [u] : null;
  }), s = xt(e.artifacts.getArtifactCollection, o), i = D(() => s.response);
  return {
    subscription: s,
    artifactCollection: i
  };
}
function nse(t) {
  const e = Se(), n = Ke(), r = D(() => {
    const i = Qe(t);
    return !i || !n.read.automation ? null : [i];
  }), o = xt(e.automations.getResourceAutomations, r), s = D(() => o.response);
  return {
    subscription: o,
    automations: s
  };
}
function x_(t) {
  const e = Se(), n = Ke(), o = xe(() => {
    if (!n.read.block)
      return null;
    const u = Qe(t);
    return u ? [u] : null;
  }), s = xt(e.blockDocuments.getBlockDocument, o), i = D(() => s.response);
  return {
    subscription: s,
    blockDocument: i
  };
}
var Cf = { exports: {} };
Cf.exports;
var jE;
function rse() {
  return jE || (jE = 1, function(t, e) {
    var n = 200, r = "__lodash_hash_undefined__", o = 800, s = 16, i = 9007199254740991, u = "[object Arguments]", l = "[object Array]", a = "[object AsyncFunction]", c = "[object Boolean]", p = "[object Date]", d = "[object Error]", h = "[object Function]", m = "[object GeneratorFunction]", g = "[object Map]", _ = "[object Number]", b = "[object Null]", x = "[object Object]", S = "[object Proxy]", E = "[object RegExp]", A = "[object Set]", C = "[object String]", M = "[object Undefined]", L = "[object WeakMap]", X = "[object ArrayBuffer]", te = "[object DataView]", B = "[object Float32Array]", W = "[object Float64Array]", G = "[object Int8Array]", ne = "[object Int16Array]", de = "[object Int32Array]", V = "[object Uint8Array]", Y = "[object Uint8ClampedArray]", Q = "[object Uint16Array]", ae = "[object Uint32Array]", Z = /[\\^$.*+?()[\]{}|]/g, J = /^\[object .+?Constructor\]$/, oe = /^(?:0|[1-9]\d*)$/, ue = {};
    ue[B] = ue[W] = ue[G] = ue[ne] = ue[de] = ue[V] = ue[Y] = ue[Q] = ue[ae] = !0, ue[u] = ue[l] = ue[X] = ue[c] = ue[te] = ue[p] = ue[d] = ue[h] = ue[g] = ue[_] = ue[x] = ue[E] = ue[A] = ue[C] = ue[L] = !1;
    var me = typeof Yr == "object" && Yr && Yr.Object === Object && Yr, pe = typeof self == "object" && self && self.Object === Object && self, Be = me || pe || Function("return this")(), Ie = e && !e.nodeType && e, Me = Ie && !0 && t && !t.nodeType && t, fe = Me && Me.exports === Ie, Te = fe && me.process, Ae = function() {
      try {
        var I = Me && Me.require && Me.require("util").types;
        return I || Te && Te.binding && Te.binding("util");
      } catch {
      }
    }(), we = Ae && Ae.isTypedArray;
    function $e(I, H, se) {
      switch (se.length) {
        case 0:
          return I.call(H);
        case 1:
          return I.call(H, se[0]);
        case 2:
          return I.call(H, se[0], se[1]);
        case 3:
          return I.call(H, se[0], se[1], se[2]);
      }
      return I.apply(H, se);
    }
    function ze(I, H) {
      for (var se = -1, Ne = Array(I); ++se < I; )
        Ne[se] = H(se);
      return Ne;
    }
    function Ue(I) {
      return function(H) {
        return I(H);
      };
    }
    function tt(I, H) {
      return I?.[H];
    }
    function Ot(I, H) {
      return function(se) {
        return I(H(se));
      };
    }
    var cn = Array.prototype, Xr = Function.prototype, Pn = Object.prototype, On = Be["__core-js_shared__"], sr = Xr.toString, Hn = Pn.hasOwnProperty, sa = function() {
      var I = /[^.]+$/.exec(On && On.keys && On.keys.IE_PROTO || "");
      return I ? "Symbol(src)_1." + I : "";
    }(), Eo = Pn.toString, aa = sr.call(Object), ar = RegExp(
      "^" + sr.call(Hn).replace(Z, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
    ), Zn = fe ? Be.Buffer : void 0, $r = Be.Symbol, gn = Be.Uint8Array;
    Zn && Zn.allocUnsafe;
    var ko = Ot(Object.getPrototypeOf, Object), Mo = Object.create, Fs = Pn.propertyIsEnumerable, To = cn.splice, In = $r ? $r.toStringTag : void 0, ke = function() {
      try {
        var I = Ru(Object, "defineProperty");
        return I({}, "", {}), I;
      } catch {
      }
    }(), Re = Zn ? Zn.isBuffer : void 0, Qt = Math.max, It = Date.now, on = Ru(Be, "Map"), Tt = Ru(Object, "create"), Ge = /* @__PURE__ */ function() {
      function I() {
      }
      return function(H) {
        if (!Bs(H))
          return {};
        if (Mo)
          return Mo(H);
        I.prototype = H;
        var se = new I();
        return I.prototype = void 0, se;
      };
    }();
    function ct(I) {
      var H = -1, se = I == null ? 0 : I.length;
      for (this.clear(); ++H < se; ) {
        var Ne = I[H];
        this.set(Ne[0], Ne[1]);
      }
    }
    function bt() {
      this.__data__ = Tt ? Tt(null) : {}, this.size = 0;
    }
    function Dn(I) {
      var H = this.has(I) && delete this.__data__[I];
      return this.size -= H ? 1 : 0, H;
    }
    function En(I) {
      var H = this.__data__;
      if (Tt) {
        var se = H[I];
        return se === r ? void 0 : se;
      }
      return Hn.call(H, I) ? H[I] : void 0;
    }
    function Jn(I) {
      var H = this.__data__;
      return Tt ? H[I] !== void 0 : Hn.call(H, I);
    }
    function Bn(I, H) {
      var se = this.__data__;
      return this.size += this.has(I) ? 0 : 1, se[I] = Tt && H === void 0 ? r : H, this;
    }
    ct.prototype.clear = bt, ct.prototype.delete = Dn, ct.prototype.get = En, ct.prototype.has = Jn, ct.prototype.set = Bn;
    function po(I) {
      var H = -1, se = I == null ? 0 : I.length;
      for (this.clear(); ++H < se; ) {
        var Ne = I[H];
        this.set(Ne[0], Ne[1]);
      }
    }
    function Ai() {
      this.__data__ = [], this.size = 0;
    }
    function ia(I) {
      var H = this.__data__, se = Ci(H, I);
      if (se < 0)
        return !1;
      var Ne = H.length - 1;
      return se == Ne ? H.pop() : To.call(H, se, 1), --this.size, !0;
    }
    function Ns(I) {
      var H = this.__data__, se = Ci(H, I);
      return se < 0 ? void 0 : H[se][1];
    }
    function Ls(I) {
      return Ci(this.__data__, I) > -1;
    }
    function as(I, H) {
      var se = this.__data__, Ne = Ci(se, I);
      return Ne < 0 ? (++this.size, se.push([I, H])) : se[Ne][1] = H, this;
    }
    po.prototype.clear = Ai, po.prototype.delete = ia, po.prototype.get = Ns, po.prototype.has = Ls, po.prototype.set = as;
    function Wr(I) {
      var H = -1, se = I == null ? 0 : I.length;
      for (this.clear(); ++H < se; ) {
        var Ne = I[H];
        this.set(Ne[0], Ne[1]);
      }
    }
    function ir() {
      this.size = 0, this.__data__ = {
        hash: new ct(),
        map: new (on || po)(),
        string: new ct()
      };
    }
    function Di(I) {
      var H = ja(this, I).delete(I);
      return this.size -= H ? 1 : 0, H;
    }
    function Ei(I) {
      return ja(this, I).get(I);
    }
    function Va(I) {
      return ja(this, I).has(I);
    }
    function Mi(I, H) {
      var se = ja(this, I), Ne = se.size;
      return se.set(I, H), this.size += se.size == Ne ? 0 : 1, this;
    }
    Wr.prototype.clear = ir, Wr.prototype.delete = Di, Wr.prototype.get = Ei, Wr.prototype.has = Va, Wr.prototype.set = Mi;
    function Po(I) {
      var H = this.__data__ = new po(I);
      this.size = H.size;
    }
    function Un() {
      this.__data__ = new po(), this.size = 0;
    }
    function Tu(I) {
      var H = this.__data__, se = H.delete(I);
      return this.size = H.size, se;
    }
    function Ha(I) {
      return this.__data__.get(I);
    }
    function is(I) {
      return this.__data__.has(I);
    }
    function ua(I, H) {
      var se = this.__data__;
      if (se instanceof po) {
        var Ne = se.__data__;
        if (!on || Ne.length < n - 1)
          return Ne.push([I, H]), this.size = ++se.size, this;
        se = this.__data__ = new Wr(Ne);
      }
      return se.set(I, H), this.size = se.size, this;
    }
    Po.prototype.clear = Un, Po.prototype.delete = Tu, Po.prototype.get = Ha, Po.prototype.has = is, Po.prototype.set = ua;
    function xu(I, H) {
      var se = Pr(I), Ne = !se && Au(I), Oe = !se && !Ne && cs(I), Je = !se && !Ne && !Oe && Fi(I), ut = se || Ne || Oe || Je, Ye = ut ? ze(I.length, String) : [], et = Ye.length;
      for (var Ft in I)
        ut && // Safari 9 has enumerable `arguments.length` in strict mode.
        (Ft == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
        Oe && (Ft == "offset" || Ft == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
        Je && (Ft == "buffer" || Ft == "byteLength" || Ft == "byteOffset") || // Skip index properties.
        pa(Ft, et)) || Ye.push(Ft);
      return Ye;
    }
    function er(I, H, se) {
      (se !== void 0 && !qa(I[H], se) || se === void 0 && !(H in I)) && la(I, H, se);
    }
    function Pi(I, H, se) {
      var Ne = I[H];
      (!(Hn.call(I, H) && qa(Ne, se)) || se === void 0 && !(H in I)) && la(I, H, se);
    }
    function Ci(I, H) {
      for (var se = I.length; se--; )
        if (qa(I[se][0], H))
          return se;
      return -1;
    }
    function la(I, H, se) {
      H == "__proto__" && ke ? ke(I, H, {
        configurable: !0,
        enumerable: !0,
        value: se,
        writable: !0
      }) : I[H] = se;
    }
    var Fc = ca();
    function Oi(I) {
      return I == null ? I === void 0 ? M : b : In && In in Object(I) ? xl(I) : Al(I);
    }
    function us(I) {
      return Ho(I) && Oi(I) == u;
    }
    function _l(I) {
      if (!Bs(I) || za(I))
        return !1;
      var H = Du(I) ? ar : J;
      return H.test(Pl(I));
    }
    function wl(I) {
      return Ho(I) && da(I.length) && !!ue[Oi(I)];
    }
    function br(I) {
      if (!Bs(I))
        return kr(I);
      var H = Co(I), se = [];
      for (var Ne in I)
        Ne == "constructor" && (H || !Hn.call(I, Ne)) || se.push(Ne);
      return se;
    }
    function bl(I, H, se, Ne, Oe) {
      I !== H && Fc(H, function(Je, ut) {
        if (Oe || (Oe = new Po()), Bs(Je))
          Nc(I, H, ut, se, bl, Ne, Oe);
        else {
          var Ye = Ne ? Ne(ur(I, ut), Je, ut + "", I, H, Oe) : void 0;
          Ye === void 0 && (Ye = Je), er(I, ut, Ye);
        }
      }, Ni);
    }
    function Nc(I, H, se, Ne, Oe, Je, ut) {
      var Ye = ur(I, se), et = ur(H, se), Ft = ut.get(et);
      if (Ft) {
        er(I, se, Ft);
        return;
      }
      var en = Je ? Je(Ye, et, se + "", I, H, ut) : void 0, jt = en === void 0;
      if (jt) {
        var Kt = Pr(et), Tn = !Kt && cs(et), lr = !Kt && !Tn && Fi(et);
        en = et, Kt || Tn || lr ? Pr(Ye) ? en = Ye : Cl(Ye) ? en = Su(Ye) : Tn ? (jt = !1, en = kl(et)) : lr ? (jt = !1, en = ls(et)) : en = [] : Eu(et) || Au(et) ? (en = Ye, Au(Ye) ? en = jo(Ye) : (!Bs(Ye) || Du(Ye)) && (en = Sl(et))) : jt = !1;
      }
      jt && (ut.set(et, en), Oe(en, et, Ne, Je, ut), ut.delete(et)), er(I, se, en);
    }
    function Lc(I, H) {
      return El(Dl(I, H, vn), I + "");
    }
    var Bc = ke ? function(I, H) {
      return ke(I, "toString", {
        configurable: !0,
        enumerable: !1,
        value: Sn(H),
        writable: !0
      });
    } : vn;
    function kl(I, H) {
      return I.slice();
    }
    function Tl(I) {
      var H = new I.constructor(I.byteLength);
      return new gn(H).set(new gn(I)), H;
    }
    function ls(I, H) {
      var se = Tl(I.buffer);
      return new I.constructor(se, I.byteOffset, I.length);
    }
    function Su(I, H) {
      var se = -1, Ne = I.length;
      for (H || (H = Array(Ne)); ++se < Ne; )
        H[se] = I[se];
      return H;
    }
    function Vo(I, H, se, Ne) {
      var Oe = !se;
      se || (se = {});
      for (var Je = -1, ut = H.length; ++Je < ut; ) {
        var Ye = H[Je], et = void 0;
        et === void 0 && (et = I[Ye]), Oe ? la(se, Ye, et) : Pi(se, Ye, et);
      }
      return se;
    }
    function Ii(I) {
      return Lc(function(H, se) {
        var Ne = -1, Oe = se.length, Je = Oe > 1 ? se[Oe - 1] : void 0, ut = Oe > 2 ? se[2] : void 0;
        for (Je = I.length > 3 && typeof Je == "function" ? (Oe--, Je) : void 0, ut && Uc(se[0], se[1], ut) && (Je = Oe < 3 ? void 0 : Je, Oe = 1), H = Object(H); ++Ne < Oe; ) {
          var Ye = se[Ne];
          Ye && I(H, Ye, Ne, Je);
        }
        return H;
      });
    }
    function ca(I) {
      return function(H, se, Ne) {
        for (var Oe = -1, Je = Object(H), ut = Ne(H), Ye = ut.length; Ye--; ) {
          var et = ut[++Oe];
          if (se(Je[et], et, Je) === !1)
            break;
        }
        return H;
      };
    }
    function ja(I, H) {
      var se = I.__data__;
      return Rl(H) ? se[typeof H == "string" ? "string" : "hash"] : se.map;
    }
    function Ru(I, H) {
      var se = tt(I, H);
      return _l(se) ? se : void 0;
    }
    function xl(I) {
      var H = Hn.call(I, In), se = I[In];
      try {
        I[In] = void 0;
        var Ne = !0;
      } catch {
      }
      var Oe = Eo.call(I);
      return Ne && (H ? I[In] = se : delete I[In]), Oe;
    }
    function Sl(I) {
      return typeof I.constructor == "function" && !Co(I) ? Ge(ko(I)) : {};
    }
    function pa(I, H) {
      var se = typeof I;
      return H = H ?? i, !!H && (se == "number" || se != "symbol" && oe.test(I)) && I > -1 && I % 1 == 0 && I < H;
    }
    function Uc(I, H, se) {
      if (!Bs(se))
        return !1;
      var Ne = typeof H;
      return (Ne == "number" ? Ga(se) && pa(H, se.length) : Ne == "string" && H in se) ? qa(se[H], I) : !1;
    }
    function Rl(I) {
      var H = typeof I;
      return H == "string" || H == "number" || H == "symbol" || H == "boolean" ? I !== "__proto__" : I === null;
    }
    function za(I) {
      return !!sa && sa in I;
    }
    function Co(I) {
      var H = I && I.constructor, se = typeof H == "function" && H.prototype || Pn;
      return I === se;
    }
    function kr(I) {
      var H = [];
      if (I != null)
        for (var se in Object(I))
          H.push(se);
      return H;
    }
    function Al(I) {
      return Eo.call(I);
    }
    function Dl(I, H, se) {
      return H = Qt(H === void 0 ? I.length - 1 : H, 0), function() {
        for (var Ne = arguments, Oe = -1, Je = Qt(Ne.length - H, 0), ut = Array(Je); ++Oe < Je; )
          ut[Oe] = Ne[H + Oe];
        Oe = -1;
        for (var Ye = Array(H + 1); ++Oe < H; )
          Ye[Oe] = Ne[Oe];
        return Ye[H] = se(ut), $e(I, this, Ye);
      };
    }
    function ur(I, H) {
      if (!(H === "constructor" && typeof I[H] == "function") && H != "__proto__")
        return I[H];
    }
    var El = Ml(Bc);
    function Ml(I) {
      var H = 0, se = 0;
      return function() {
        var Ne = It(), Oe = s - (Ne - se);
        if (se = Ne, Oe > 0) {
          if (++H >= o)
            return arguments[0];
        } else
          H = 0;
        return I.apply(void 0, arguments);
      };
    }
    function Pl(I) {
      if (I != null) {
        try {
          return sr.call(I);
        } catch {
        }
        try {
          return I + "";
        } catch {
        }
      }
      return "";
    }
    function qa(I, H) {
      return I === H || I !== I && H !== H;
    }
    var Au = us(/* @__PURE__ */ function() {
      return arguments;
    }()) ? us : function(I) {
      return Ho(I) && Hn.call(I, "callee") && !Fs.call(I, "callee");
    }, Pr = Array.isArray;
    function Ga(I) {
      return I != null && da(I.length) && !Du(I);
    }
    function Cl(I) {
      return Ho(I) && Ga(I);
    }
    var cs = Re || N;
    function Du(I) {
      if (!Bs(I))
        return !1;
      var H = Oi(I);
      return H == h || H == m || H == a || H == S;
    }
    function da(I) {
      return typeof I == "number" && I > -1 && I % 1 == 0 && I <= i;
    }
    function Bs(I) {
      var H = typeof I;
      return I != null && (H == "object" || H == "function");
    }
    function Ho(I) {
      return I != null && typeof I == "object";
    }
    function Eu(I) {
      if (!Ho(I) || Oi(I) != x)
        return !1;
      var H = ko(I);
      if (H === null)
        return !0;
      var se = Hn.call(H, "constructor") && H.constructor;
      return typeof se == "function" && se instanceof se && sr.call(se) == aa;
    }
    var Fi = we ? Ue(we) : wl;
    function jo(I) {
      return Vo(I, Ni(I));
    }
    function Ni(I) {
      return Ga(I) ? xu(I) : br(I);
    }
    var Xc = Ii(function(I, H, se) {
      bl(I, H, se);
    });
    function Sn(I) {
      return function() {
        return I;
      };
    }
    function vn(I) {
      return I;
    }
    function N() {
      return !1;
    }
    t.exports = Xc;
  }(Cf, Cf.exports)), Cf.exports;
}
var ose = rse();
const $t = /* @__PURE__ */ Nh(ose), hN = 200;
function SBe(t = 1, e) {
  const n = xe(t), r = D(() => Qe(e) ?? hN), o = D(() => (n.value - 1) * r.value);
  return {
    limit: r,
    offset: o,
    page: n
  };
}
function fN(t) {
  const e = D(() => Qe(t)), n = D(() => e.value.some((h) => h.loading)), r = D(() => e.value.some((h) => h.errored)), o = D(() => e.value.map((h) => h.error)), s = D(() => e.value.length > 0 && e.value.every((h) => h.executed)), i = D(() => e.value.map((h) => h.response)), u = D(() => e.value.some((h) => h.paused)), l = D(() => e.value.some((h) => h.late));
  return { subscriptions: lt({
    loading: n,
    errored: r,
    errors: o,
    executed: s,
    paused: u,
    late: l,
    responses: i,
    unsubscribe: () => {
      e.value.forEach((h) => h.unsubscribe());
    },
    refresh: async (h) => {
      const m = e.value.map((g) => g.refresh(h));
      await Promise.all(m);
    },
    isSubscribed: () => e.value.every((h) => h.isSubscribed())
  }) };
}
function mN({
  fetchMethod: t,
  fetchParameters: e,
  countMethod: n,
  countParameters: r,
  options: o
}) {
  const s = C(), i = A(), u = D(() => Math.ceil(c.value / S())), l = D(() => {
    if (Qv(i.value)) {
      const M = r();
      return M && $t([], M);
    }
    return null;
  }), a = xt(n, l, o), c = D(() => a.response ?? 0), p = lt([]), d = D(() => p.flatMap((M) => M.response ?? []));
  Ct([c, i, e], ([M, L, X]) => {
    if (M === 0 || L === 0 || X === null) {
      p.forEach((B) => B.unsubscribe()), p.splice(0);
      return;
    }
    const te = _(L).map((B) => {
      const W = b(B);
      return xt(t, W, o);
    });
    p.forEach((B) => B.unsubscribe()), p.splice(0, 1 / 0, ...te);
  }, { immediate: !0, deep: !0 });
  const { subscriptions: h } = fN(() => [
    a,
    ...p
  ]);
  function m() {
    if (s === "page") {
      i.value++;
      return;
    }
    i.value * S() <= d.value.length && i.value++;
  }
  function g() {
    i.value--;
  }
  function _(M) {
    return s === "page" ? [M] : Tx(M, (L) => L + 1);
  }
  function b(M) {
    return xe(() => {
      const L = e();
      if (L === null)
        return null;
      const [X, ...te] = L;
      return [x(M, X), ...te];
    });
  }
  function x(M, L) {
    const X = S(), te = E(M);
    return {
      ...L,
      offset: te,
      limit: X
    };
  }
  function S() {
    const [M] = e() ?? [];
    return M?.limit ?? hN;
  }
  function E(M) {
    const L = S();
    return (M - 1) * L;
  }
  function A() {
    return o?.page ? ge(o.page) : ge(s === "page" ? 1 : 0);
  }
  function C() {
    return o?.mode ?? "page";
  }
  return Ct(e, () => {
    i.value = 1;
  }, { deep: !0 }), AI(() => {
    h.unsubscribe();
  }), {
    subscriptions: h,
    results: d,
    total: c,
    page: i,
    pages: u,
    next: m,
    previous: g
  };
}
function sse(t, e) {
  const n = Se(), r = Ke(), o = () => {
    if (!r.read.block)
      return null;
    const i = Qe(t);
    return i ? [i] : null;
  }, s = mN({
    fetchMethod: n.blockDocuments.getBlockDocuments,
    fetchParameters: o,
    countMethod: n.blockDocuments.getBlockDocumentsCount,
    countParameters: o,
    options: e
  });
  return {
    ...s,
    blockDocuments: s.results
  };
}
function RBe(t) {
  const e = Se(), r = xe(() => {
    const i = Qe(t);
    return i ? [i] : null;
  }), o = xt(e.blockSchemas.getBlockSchema, r), s = D(() => o.response);
  return {
    subscription: o,
    blockSchema: s
  };
}
function yN(t) {
  const e = Se(), r = xe(() => {
    const i = Qe(t);
    return i ? [i] : null;
  }), o = xt(e.blockSchemas.getBlockSchemaForBlockType, r), s = D(() => o.response);
  return {
    subscription: o,
    blockSchema: s
  };
}
function ABe(t) {
  const e = Se(), r = xe(() => {
    const i = Qe(t);
    return i ? [i] : null;
  }), o = xt(e.blockTypes.getBlockType, r), s = D(() => o.response);
  return {
    subscription: o,
    blockType: s
  };
}
function DBe(t) {
  const e = Se(), r = xe(() => {
    const i = Qe(t);
    return i ? [i] : null;
  }), o = xt(e.blockTypes.getBlockTypeBySlug, r), s = D(() => o.response);
  return {
    subscription: o,
    blockType: s
  };
}
const ase = Symbol();
function Vn() {
  const t = Wv(ase, {});
  return { ...tz, ...t };
}
function ise() {
  return {
    interval: 3e4
  };
}
class use extends Ba {
  parse(e) {
    if (ND(e))
      return e;
    throw new Zr();
  }
  format(e) {
    if (ND(e))
      return e;
    throw new Zr();
  }
}
class lse extends Ba {
  parse(e) {
    if (LD(e))
      return e;
    throw new Zr();
  }
  format(e) {
    if (LD(e))
      return e;
    throw new Zr();
  }
}
class cse extends Ba {
  parse(e) {
    if (BD(e))
      return e;
    throw new Zr();
  }
  format(e) {
    if (BD(e))
      return e;
    throw new Zr();
  }
}
function gN(t = null) {
  const e = dn("date", mo), n = dn("endDate", mo), r = dn("period", use), o = dn("quantity", _o), s = dn("seconds", _o), i = dn("startDate", mo), u = dn("type", cse), l = dn("unit", lse);
  function a() {
    return i.value && n.value ? { type: "range", startDate: i.value, endDate: n.value } : t;
  }
  function c() {
    return s.value ? { type: "span", seconds: s.value } : t;
  }
  function p() {
    return e.value && l.value && o.value ? { type: "around", date: e.value, unit: l.value, quantity: o.value } : t;
  }
  function d() {
    return r.value ? { type: "period", period: r.value } : t;
  }
  const h = D({
    get() {
      if (!u.value)
        return t;
      switch (u.value) {
        case "range":
          return a();
        case "span":
          return c();
        case "around":
          return p();
        case "period":
          return d();
        default:
          const m = u.value;
          throw new Error(`No getter for ${m}`);
      }
    },
    set(m) {
      if (!m) {
        e.value = void 0, n.value = void 0, r.value = void 0, o.value = void 0, s.value = void 0, i.value = void 0, u.value = void 0, l.value = void 0;
        return;
      }
      switch (m.type) {
        case "range":
          e.value = void 0, n.value = m.endDate, r.value = void 0, o.value = void 0, s.value = void 0, i.value = m.startDate, u.value = "range", l.value = void 0;
          break;
        case "span":
          e.value = void 0, n.value = void 0, r.value = void 0, o.value = void 0, s.value = m.seconds, i.value = void 0, u.value = "span", l.value = void 0;
          break;
        case "around":
          e.value = m.date, n.value = void 0, r.value = void 0, o.value = m.quantity, s.value = void 0, i.value = void 0, u.value = "around", l.value = m.unit;
          break;
        case "period":
          e.value = void 0, n.value = void 0, r.value = m.period, o.value = void 0, s.value = void 0, i.value = void 0, u.value = "period", l.value = void 0;
          break;
        default:
          const g = m;
          throw new Error(`No setter for ${g}`);
      }
    }
  });
  return lt({
    range: h
  });
}
function Zm(t, e) {
  const n = Se(), r = Ke(), s = xe(() => {
    if (!r.read.deployment)
      return null;
    const l = Qe(t);
    return l ? [l] : null;
  }), i = xt(n.deployments.getDeployment, s, e), u = D(() => i.response);
  return {
    subscription: i,
    deployment: u
  };
}
function w2(t, e) {
  const n = Se(), r = Ke(), s = xe(() => {
    if (!r.read.deployment)
      return null;
    const d = Qe(t);
    return d ? [$t({}, d)] : null;
  }), i = xt(n.deployments.getDeploymentsPaginated, s, e), u = D(() => i.response?.results ?? []), l = D(() => i.response?.pages ?? 0), a = D(() => i.response?.limit ?? 0), c = D(() => i.response?.count ?? 0), p = D(() => i.response?.page ?? 1);
  return {
    subscription: i,
    deployments: u,
    pages: l,
    page: p,
    limit: a,
    count: c
  };
}
function EBe(t) {
  const e = Se(), n = Ke(), o = xe(() => {
    if (!n.read.deployment)
      return null;
    const u = Qe(t);
    return u ? [$t({}, u)] : null;
  }), s = xt(e.deployments.getDeploymentsCount, o), i = D(() => s.response);
  return {
    subscription: s,
    count: i
  };
}
function pse() {
  return window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : window.matchMedia("(prefers-color-scheme: light)").matches ? "light" : "no-preference";
}
function vN(t) {
  let e, n;
  switch (pse()) {
    case "dark":
      e = document.getElementById("favicon-16-dark"), n = document.getElementById("favicon-32-dark");
      break;
    default:
      e = document.getElementById("favicon-16"), n = document.getElementById("favicon-32");
      break;
  }
  const r = ge(t);
  dx(() => {
    t && (e?.setAttribute("href", `/ico/${r.value}.svg`), n?.setAttribute("href", `/ico/${r.value}.svg`));
  }), Em(() => {
    e?.setAttribute("href", "/ico/favicon-16x16.png"), n?.setAttribute("href", "/ico/favicon-32x32.png");
  });
}
function Ec(t, e) {
  const n = Se(), r = Ke(), s = xe(() => {
    if (!r.read.flow)
      return null;
    const l = Qe(t);
    return l ? [l] : null;
  }), i = xt(n.flows.getFlow, s, e), u = D(() => i.response);
  return {
    subscription: i,
    flow: u
  };
}
function yl(t, e) {
  const n = Se(), r = Ke(), s = xe(() => {
    if (!r.read.flow_run)
      return null;
    const l = Qe(t);
    return l ? [l] : null;
  }), i = xt(n.flowRuns.getFlowRun, s, e), u = D(() => i.response);
  return {
    subscription: i,
    flowRun: u
  };
}
function du(t, e) {
  const n = Se(), r = Ke(), s = xe(() => {
    if (!r.read.flow_run)
      return null;
    const l = Qe(t);
    return l ? [$t({}, l)] : null;
  }), i = xt(n.flowRuns.getFlowRunsCount, s, e);
  return {
    count: D(() => i.response),
    subscription: i
  };
}
function zE(t, e) {
  const n = xe(t), r = () => {
    const p = {
      flowRuns: {
        state: {
          type: ["COMPLETED", "FAILED", "CRASHED"]
        }
      }
    };
    return $t({}, n.value, p);
  }, { count: o, subscription: s } = du(r, e), i = () => {
    const p = {
      flowRuns: {
        state: {
          type: ["COMPLETED"]
        }
      }
    };
    return $t({}, n.value, p);
  }, { count: u, subscription: l } = du(i, e), a = D(() => {
    if (!(!u.value || !o.value))
      return _F(u.value, o.value);
  }), c = fN([
    s,
    l
  ]);
  return {
    completeness: a,
    subscriptions: c
  };
}
function MBe(t) {
  const e = D(() => Qe(t)?.stateType);
  vN(e);
}
function Qp(t, e) {
  const n = Se(), r = Ke(), s = xe(() => {
    if (!r.read.flow_run)
      return null;
    const l = Qe(t);
    return l ? [l] : null;
  }), i = xt(n.flowRuns.getFlowRuns, s, e), u = D(() => i.response ?? []);
  return {
    subscription: i,
    flowRuns: u
  };
}
function dse(t, e) {
  const n = Se(), r = Ke(), o = D(() => {
    if (!r.read.flow_run)
      return null;
    const u = Qe(t);
    return u ? [u] : null;
  }), s = xt(n.flowRuns.getFlowRunsAverageLateness, o, e), i = D(() => s.response);
  return {
    subscription: s,
    lateness: i
  };
}
function b2(t, e) {
  const n = Se(), r = Ke(), s = xe(() => {
    if (!r.read.flow_run)
      return null;
    const d = Qe(t);
    return d ? [$t({}, d)] : null;
  }), i = xt(n.flows.getFlowsPaginated, s, e), u = D(() => i.response?.results ?? []), l = D(() => i.response?.pages ?? 0), a = D(() => i.response?.limit ?? 0), c = D(() => i.response?.count ?? 0), p = D(() => i.response?.page ?? 1);
  return {
    subscription: i,
    flows: u,
    pages: l,
    page: p,
    limit: a,
    count: c
  };
}
function PBe(t) {
  const e = Se(), n = Ke(), o = xe(() => {
    if (!n.read.flow)
      return null;
    const u = Qe(t);
    return u ? [$t({}, u)] : null;
  }), s = xt(e.flows.getFlowsCount, o), i = D(() => s.response);
  return {
    subscription: s,
    count: i
  };
}
const Mc = (t) => {
  const { handleSubmit: e, ...n } = ez(t), r = (o, s) => e((l, a) => o(l, a), (l) => {
    s && s(l), Dj();
  });
  return r.withControlled = e.withControlled, {
    ...n,
    handleSubmit: r
  };
};
function hse(t, e) {
  const n = Se(), r = xe(t), o = mt(n.ui.getNextRunByFlow, [r], e), s = D(() => o.response);
  return {
    subscription: o,
    flowRun: s
  };
}
const fse = Symbol("SubscriptionIntervalKey");
function Xa(t) {
  return Wv(fse, t);
}
function CBe(t) {
  const n = ge(typeof t == "string" ? JSON.parse(t) : t), r = ge(or(n.value)), o = ge(!1);
  return Ct(r, (s) => {
    o.value = ME(s), o.value && (n.value = JSON.parse(s));
  }), Ct(n, (s) => {
    if (ME(r.value)) {
      const i = JSON.stringify(JSON.parse(r.value)), u = JSON.stringify(s);
      i !== u && (r.value = JSON.stringify(s));
    }
  }, { deep: !0 }), {
    valid: o,
    json: r,
    record: n
  };
}
function _N(t, e) {
  const n = Ke(), r = () => {
    if (!n.read.flow_run)
      return null;
    const u = /* @__PURE__ */ new Date(), l = Qe(t);
    return $t({}, l, {
      flowRuns: {
        expectedStartTimeBefore: u
      },
      sort: "EXPECTED_START_TIME_DESC",
      limit: 1
    });
  }, { flowRuns: o, subscription: s } = Qp(r, e), i = D(() => o.value.at(0));
  return {
    subscription: s,
    flowRun: i
  };
}
const mse = c_("prefect-ui-library-default-logs-sort");
function wN(t = "TIMESTAMP_ASC") {
  const { value: e, set: n } = hl(mse);
  return {
    sort: D({
      get() {
        return WE(e.value) ? e.value : t;
      },
      set(o) {
        WE(o) && n(o);
      }
    })
  };
}
function bN(t, e) {
  const n = Ke(), r = () => {
    if (!n.read.flow_run)
      return null;
    const u = Qe(t);
    return $t({}, u, {
      flowRuns: {
        state: {
          name: ["Scheduled"]
        }
      },
      sort: "EXPECTED_START_TIME_ASC",
      limit: 1
    });
  }, { flowRuns: o, subscription: s } = Qp(r, e), i = D(() => o.value.at(0));
  return {
    subscription: s,
    flowRun: i
  };
}
var Of = { exports: {} };
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
var yse = Of.exports, qE;
function gse() {
  return qE || (qE = 1, function(t, e) {
    (function() {
      var n, r = "4.17.21", o = 200, s = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", i = "Expected a function", u = "Invalid `variable` option passed into `_.template`", l = "__lodash_hash_undefined__", a = 500, c = "__lodash_placeholder__", p = 1, d = 2, h = 4, m = 1, g = 2, _ = 1, b = 2, x = 4, S = 8, E = 16, A = 32, C = 64, M = 128, L = 256, X = 512, te = 30, B = "...", W = 800, G = 16, ne = 1, de = 2, V = 3, Y = 1 / 0, Q = 9007199254740991, ae = 17976931348623157e292, Z = NaN, J = 4294967295, oe = J - 1, ue = J >>> 1, me = [
        ["ary", M],
        ["bind", _],
        ["bindKey", b],
        ["curry", S],
        ["curryRight", E],
        ["flip", X],
        ["partial", A],
        ["partialRight", C],
        ["rearg", L]
      ], pe = "[object Arguments]", Be = "[object Array]", Ie = "[object AsyncFunction]", Me = "[object Boolean]", fe = "[object Date]", Te = "[object DOMException]", Ae = "[object Error]", we = "[object Function]", $e = "[object GeneratorFunction]", ze = "[object Map]", Ue = "[object Number]", tt = "[object Null]", Ot = "[object Object]", cn = "[object Promise]", Xr = "[object Proxy]", Pn = "[object RegExp]", On = "[object Set]", sr = "[object String]", Hn = "[object Symbol]", sa = "[object Undefined]", Eo = "[object WeakMap]", aa = "[object WeakSet]", ar = "[object ArrayBuffer]", Zn = "[object DataView]", $r = "[object Float32Array]", gn = "[object Float64Array]", ko = "[object Int8Array]", Mo = "[object Int16Array]", Fs = "[object Int32Array]", To = "[object Uint8Array]", In = "[object Uint8ClampedArray]", ke = "[object Uint16Array]", Re = "[object Uint32Array]", Qt = /\b__p \+= '';/g, It = /\b(__p \+=) '' \+/g, on = /(__e\(.*?\)|\b__t\)) \+\n'';/g, Tt = /&(?:amp|lt|gt|quot|#39);/g, Ge = /[&<>"']/g, ct = RegExp(Tt.source), bt = RegExp(Ge.source), Dn = /<%-([\s\S]+?)%>/g, En = /<%([\s\S]+?)%>/g, Jn = /<%=([\s\S]+?)%>/g, Bn = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, po = /^\w*$/, Ai = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, ia = /[\\^$.*+?()[\]{}|]/g, Ns = RegExp(ia.source), Ls = /^\s+/, as = /\s/, Wr = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, ir = /\{\n\/\* \[wrapped with (.+)\] \*/, Di = /,? & /, Ei = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g, Va = /[()=,{}\[\]\/\s]/, Mi = /\\(\\)?/g, Po = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g, Un = /\w*$/, Tu = /^[-+]0x[0-9a-f]+$/i, Ha = /^0b[01]+$/i, is = /^\[object .+?Constructor\]$/, ua = /^0o[0-7]+$/i, xu = /^(?:0|[1-9]\d*)$/, er = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, Pi = /($^)/, Ci = /['\n\r\u2028\u2029\\]/g, la = "\\ud800-\\udfff", Fc = "\\u0300-\\u036f", Oi = "\\ufe20-\\ufe2f", us = "\\u20d0-\\u20ff", _l = Fc + Oi + us, wl = "\\u2700-\\u27bf", br = "a-z\\xdf-\\xf6\\xf8-\\xff", bl = "\\xac\\xb1\\xd7\\xf7", Nc = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", Lc = "\\u2000-\\u206f", Bc = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", kl = "A-Z\\xc0-\\xd6\\xd8-\\xde", Tl = "\\ufe0e\\ufe0f", ls = bl + Nc + Lc + Bc, Su = "['’]", Vo = "[" + la + "]", Ii = "[" + ls + "]", ca = "[" + _l + "]", ja = "\\d+", Ru = "[" + wl + "]", xl = "[" + br + "]", Sl = "[^" + la + ls + ja + wl + br + kl + "]", pa = "\\ud83c[\\udffb-\\udfff]", Uc = "(?:" + ca + "|" + pa + ")", Rl = "[^" + la + "]", za = "(?:\\ud83c[\\udde6-\\uddff]){2}", Co = "[\\ud800-\\udbff][\\udc00-\\udfff]", kr = "[" + kl + "]", Al = "\\u200d", Dl = "(?:" + xl + "|" + Sl + ")", ur = "(?:" + kr + "|" + Sl + ")", El = "(?:" + Su + "(?:d|ll|m|re|s|t|ve))?", Ml = "(?:" + Su + "(?:D|LL|M|RE|S|T|VE))?", Pl = Uc + "?", qa = "[" + Tl + "]?", Au = "(?:" + Al + "(?:" + [Rl, za, Co].join("|") + ")" + qa + Pl + ")*", Pr = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", Ga = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", Cl = qa + Pl + Au, cs = "(?:" + [Ru, za, Co].join("|") + ")" + Cl, Du = "(?:" + [Rl + ca + "?", ca, za, Co, Vo].join("|") + ")", da = RegExp(Su, "g"), Bs = RegExp(ca, "g"), Ho = RegExp(pa + "(?=" + pa + ")|" + Du + Cl, "g"), Eu = RegExp([
        kr + "?" + xl + "+" + El + "(?=" + [Ii, kr, "$"].join("|") + ")",
        ur + "+" + Ml + "(?=" + [Ii, kr + Dl, "$"].join("|") + ")",
        kr + "?" + Dl + "+" + El,
        kr + "+" + Ml,
        Ga,
        Pr,
        ja,
        cs
      ].join("|"), "g"), Fi = RegExp("[" + Al + la + _l + Tl + "]"), jo = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/, Ni = [
        "Array",
        "Buffer",
        "DataView",
        "Date",
        "Error",
        "Float32Array",
        "Float64Array",
        "Function",
        "Int8Array",
        "Int16Array",
        "Int32Array",
        "Map",
        "Math",
        "Object",
        "Promise",
        "RegExp",
        "Set",
        "String",
        "Symbol",
        "TypeError",
        "Uint8Array",
        "Uint8ClampedArray",
        "Uint16Array",
        "Uint32Array",
        "WeakMap",
        "_",
        "clearTimeout",
        "isFinite",
        "parseInt",
        "setTimeout"
      ], Xc = -1, Sn = {};
      Sn[$r] = Sn[gn] = Sn[ko] = Sn[Mo] = Sn[Fs] = Sn[To] = Sn[In] = Sn[ke] = Sn[Re] = !0, Sn[pe] = Sn[Be] = Sn[ar] = Sn[Me] = Sn[Zn] = Sn[fe] = Sn[Ae] = Sn[we] = Sn[ze] = Sn[Ue] = Sn[Ot] = Sn[Pn] = Sn[On] = Sn[sr] = Sn[Eo] = !1;
      var vn = {};
      vn[pe] = vn[Be] = vn[ar] = vn[Zn] = vn[Me] = vn[fe] = vn[$r] = vn[gn] = vn[ko] = vn[Mo] = vn[Fs] = vn[ze] = vn[Ue] = vn[Ot] = vn[Pn] = vn[On] = vn[sr] = vn[Hn] = vn[To] = vn[In] = vn[ke] = vn[Re] = !0, vn[Ae] = vn[we] = vn[Eo] = !1;
      var N = {
        // Latin-1 Supplement block.
        À: "A",
        Á: "A",
        Â: "A",
        Ã: "A",
        Ä: "A",
        Å: "A",
        à: "a",
        á: "a",
        â: "a",
        ã: "a",
        ä: "a",
        å: "a",
        Ç: "C",
        ç: "c",
        Ð: "D",
        ð: "d",
        È: "E",
        É: "E",
        Ê: "E",
        Ë: "E",
        è: "e",
        é: "e",
        ê: "e",
        ë: "e",
        Ì: "I",
        Í: "I",
        Î: "I",
        Ï: "I",
        ì: "i",
        í: "i",
        î: "i",
        ï: "i",
        Ñ: "N",
        ñ: "n",
        Ò: "O",
        Ó: "O",
        Ô: "O",
        Õ: "O",
        Ö: "O",
        Ø: "O",
        ò: "o",
        ó: "o",
        ô: "o",
        õ: "o",
        ö: "o",
        ø: "o",
        Ù: "U",
        Ú: "U",
        Û: "U",
        Ü: "U",
        ù: "u",
        ú: "u",
        û: "u",
        ü: "u",
        Ý: "Y",
        ý: "y",
        ÿ: "y",
        Æ: "Ae",
        æ: "ae",
        Þ: "Th",
        þ: "th",
        ß: "ss",
        // Latin Extended-A block.
        Ā: "A",
        Ă: "A",
        Ą: "A",
        ā: "a",
        ă: "a",
        ą: "a",
        Ć: "C",
        Ĉ: "C",
        Ċ: "C",
        Č: "C",
        ć: "c",
        ĉ: "c",
        ċ: "c",
        č: "c",
        Ď: "D",
        Đ: "D",
        ď: "d",
        đ: "d",
        Ē: "E",
        Ĕ: "E",
        Ė: "E",
        Ę: "E",
        Ě: "E",
        ē: "e",
        ĕ: "e",
        ė: "e",
        ę: "e",
        ě: "e",
        Ĝ: "G",
        Ğ: "G",
        Ġ: "G",
        Ģ: "G",
        ĝ: "g",
        ğ: "g",
        ġ: "g",
        ģ: "g",
        Ĥ: "H",
        Ħ: "H",
        ĥ: "h",
        ħ: "h",
        Ĩ: "I",
        Ī: "I",
        Ĭ: "I",
        Į: "I",
        İ: "I",
        ĩ: "i",
        ī: "i",
        ĭ: "i",
        į: "i",
        ı: "i",
        Ĵ: "J",
        ĵ: "j",
        Ķ: "K",
        ķ: "k",
        ĸ: "k",
        Ĺ: "L",
        Ļ: "L",
        Ľ: "L",
        Ŀ: "L",
        Ł: "L",
        ĺ: "l",
        ļ: "l",
        ľ: "l",
        ŀ: "l",
        ł: "l",
        Ń: "N",
        Ņ: "N",
        Ň: "N",
        Ŋ: "N",
        ń: "n",
        ņ: "n",
        ň: "n",
        ŋ: "n",
        Ō: "O",
        Ŏ: "O",
        Ő: "O",
        ō: "o",
        ŏ: "o",
        ő: "o",
        Ŕ: "R",
        Ŗ: "R",
        Ř: "R",
        ŕ: "r",
        ŗ: "r",
        ř: "r",
        Ś: "S",
        Ŝ: "S",
        Ş: "S",
        Š: "S",
        ś: "s",
        ŝ: "s",
        ş: "s",
        š: "s",
        Ţ: "T",
        Ť: "T",
        Ŧ: "T",
        ţ: "t",
        ť: "t",
        ŧ: "t",
        Ũ: "U",
        Ū: "U",
        Ŭ: "U",
        Ů: "U",
        Ű: "U",
        Ų: "U",
        ũ: "u",
        ū: "u",
        ŭ: "u",
        ů: "u",
        ű: "u",
        ų: "u",
        Ŵ: "W",
        ŵ: "w",
        Ŷ: "Y",
        ŷ: "y",
        Ÿ: "Y",
        Ź: "Z",
        Ż: "Z",
        Ž: "Z",
        ź: "z",
        ż: "z",
        ž: "z",
        Ĳ: "IJ",
        ĳ: "ij",
        Œ: "Oe",
        œ: "oe",
        ŉ: "'n",
        ſ: "s"
      }, I = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
      }, H = {
        "&amp;": "&",
        "&lt;": "<",
        "&gt;": ">",
        "&quot;": '"',
        "&#39;": "'"
      }, se = {
        "\\": "\\",
        "'": "'",
        "\n": "n",
        "\r": "r",
        "\u2028": "u2028",
        "\u2029": "u2029"
      }, Ne = parseFloat, Oe = parseInt, Je = typeof Yr == "object" && Yr && Yr.Object === Object && Yr, ut = typeof self == "object" && self && self.Object === Object && self, Ye = Je || ut || Function("return this")(), et = e && !e.nodeType && e, Ft = et && !0 && t && !t.nodeType && t, en = Ft && Ft.exports === et, jt = en && Je.process, Kt = function() {
        try {
          var _e = Ft && Ft.require && Ft.require("util").types;
          return _e || jt && jt.binding && jt.binding("util");
        } catch {
        }
      }(), Tn = Kt && Kt.isArrayBuffer, lr = Kt && Kt.isDate, Tr = Kt && Kt.isMap, ho = Kt && Kt.isRegExp, Ol = Kt && Kt.isSet, ha = Kt && Kt.isTypedArray;
      function cr(_e, Ce, Ee) {
        switch (Ee.length) {
          case 0:
            return _e.call(Ce);
          case 1:
            return _e.call(Ce, Ee[0]);
          case 2:
            return _e.call(Ce, Ee[0], Ee[1]);
          case 3:
            return _e.call(Ce, Ee[0], Ee[1], Ee[2]);
        }
        return _e.apply(Ce, Ee);
      }
      function NX(_e, Ce, Ee, it) {
        for (var Wt = -1, Rn = _e == null ? 0 : _e.length; ++Wt < Rn; ) {
          var oo = _e[Wt];
          Ce(it, oo, Ee(oo), _e);
        }
        return it;
      }
      function fa(_e, Ce) {
        for (var Ee = -1, it = _e == null ? 0 : _e.length; ++Ee < it && Ce(_e[Ee], Ee, _e) !== !1; )
          ;
        return _e;
      }
      function LX(_e, Ce) {
        for (var Ee = _e == null ? 0 : _e.length; Ee-- && Ce(_e[Ee], Ee, _e) !== !1; )
          ;
        return _e;
      }
      function LR(_e, Ce) {
        for (var Ee = -1, it = _e == null ? 0 : _e.length; ++Ee < it; )
          if (!Ce(_e[Ee], Ee, _e))
            return !1;
        return !0;
      }
      function Il(_e, Ce) {
        for (var Ee = -1, it = _e == null ? 0 : _e.length, Wt = 0, Rn = []; ++Ee < it; ) {
          var oo = _e[Ee];
          Ce(oo, Ee, _e) && (Rn[Wt++] = oo);
        }
        return Rn;
      }
      function _y(_e, Ce) {
        var Ee = _e == null ? 0 : _e.length;
        return !!Ee && id(_e, Ce, 0) > -1;
      }
      function hw(_e, Ce, Ee) {
        for (var it = -1, Wt = _e == null ? 0 : _e.length; ++it < Wt; )
          if (Ee(Ce, _e[it]))
            return !0;
        return !1;
      }
      function tr(_e, Ce) {
        for (var Ee = -1, it = _e == null ? 0 : _e.length, Wt = Array(it); ++Ee < it; )
          Wt[Ee] = Ce(_e[Ee], Ee, _e);
        return Wt;
      }
      function Fl(_e, Ce) {
        for (var Ee = -1, it = Ce.length, Wt = _e.length; ++Ee < it; )
          _e[Wt + Ee] = Ce[Ee];
        return _e;
      }
      function fw(_e, Ce, Ee, it) {
        var Wt = -1, Rn = _e == null ? 0 : _e.length;
        for (it && Rn && (Ee = _e[++Wt]); ++Wt < Rn; )
          Ee = Ce(Ee, _e[Wt], Wt, _e);
        return Ee;
      }
      function BX(_e, Ce, Ee, it) {
        var Wt = _e == null ? 0 : _e.length;
        for (it && Wt && (Ee = _e[--Wt]); Wt--; )
          Ee = Ce(Ee, _e[Wt], Wt, _e);
        return Ee;
      }
      function mw(_e, Ce) {
        for (var Ee = -1, it = _e == null ? 0 : _e.length; ++Ee < it; )
          if (Ce(_e[Ee], Ee, _e))
            return !0;
        return !1;
      }
      var UX = yw("length");
      function XX(_e) {
        return _e.split("");
      }
      function $X(_e) {
        return _e.match(Ei) || [];
      }
      function BR(_e, Ce, Ee) {
        var it;
        return Ee(_e, function(Wt, Rn, oo) {
          if (Ce(Wt, Rn, oo))
            return it = Rn, !1;
        }), it;
      }
      function wy(_e, Ce, Ee, it) {
        for (var Wt = _e.length, Rn = Ee + (it ? 1 : -1); it ? Rn-- : ++Rn < Wt; )
          if (Ce(_e[Rn], Rn, _e))
            return Rn;
        return -1;
      }
      function id(_e, Ce, Ee) {
        return Ce === Ce ? JX(_e, Ce, Ee) : wy(_e, UR, Ee);
      }
      function WX(_e, Ce, Ee, it) {
        for (var Wt = Ee - 1, Rn = _e.length; ++Wt < Rn; )
          if (it(_e[Wt], Ce))
            return Wt;
        return -1;
      }
      function UR(_e) {
        return _e !== _e;
      }
      function XR(_e, Ce) {
        var Ee = _e == null ? 0 : _e.length;
        return Ee ? vw(_e, Ce) / Ee : Z;
      }
      function yw(_e) {
        return function(Ce) {
          return Ce == null ? n : Ce[_e];
        };
      }
      function gw(_e) {
        return function(Ce) {
          return _e == null ? n : _e[Ce];
        };
      }
      function $R(_e, Ce, Ee, it, Wt) {
        return Wt(_e, function(Rn, oo, Xn) {
          Ee = it ? (it = !1, Rn) : Ce(Ee, Rn, oo, Xn);
        }), Ee;
      }
      function VX(_e, Ce) {
        var Ee = _e.length;
        for (_e.sort(Ce); Ee--; )
          _e[Ee] = _e[Ee].value;
        return _e;
      }
      function vw(_e, Ce) {
        for (var Ee, it = -1, Wt = _e.length; ++it < Wt; ) {
          var Rn = Ce(_e[it]);
          Rn !== n && (Ee = Ee === n ? Rn : Ee + Rn);
        }
        return Ee;
      }
      function _w(_e, Ce) {
        for (var Ee = -1, it = Array(_e); ++Ee < _e; )
          it[Ee] = Ce(Ee);
        return it;
      }
      function HX(_e, Ce) {
        return tr(Ce, function(Ee) {
          return [Ee, _e[Ee]];
        });
      }
      function WR(_e) {
        return _e && _e.slice(0, zR(_e) + 1).replace(Ls, "");
      }
      function Us(_e) {
        return function(Ce) {
          return _e(Ce);
        };
      }
      function ww(_e, Ce) {
        return tr(Ce, function(Ee) {
          return _e[Ee];
        });
      }
      function Gh(_e, Ce) {
        return _e.has(Ce);
      }
      function VR(_e, Ce) {
        for (var Ee = -1, it = _e.length; ++Ee < it && id(Ce, _e[Ee], 0) > -1; )
          ;
        return Ee;
      }
      function HR(_e, Ce) {
        for (var Ee = _e.length; Ee-- && id(Ce, _e[Ee], 0) > -1; )
          ;
        return Ee;
      }
      function jX(_e, Ce) {
        for (var Ee = _e.length, it = 0; Ee--; )
          _e[Ee] === Ce && ++it;
        return it;
      }
      var zX = gw(N), qX = gw(I);
      function GX(_e) {
        return "\\" + se[_e];
      }
      function YX(_e, Ce) {
        return _e == null ? n : _e[Ce];
      }
      function ud(_e) {
        return Fi.test(_e);
      }
      function QX(_e) {
        return jo.test(_e);
      }
      function KX(_e) {
        for (var Ce, Ee = []; !(Ce = _e.next()).done; )
          Ee.push(Ce.value);
        return Ee;
      }
      function bw(_e) {
        var Ce = -1, Ee = Array(_e.size);
        return _e.forEach(function(it, Wt) {
          Ee[++Ce] = [Wt, it];
        }), Ee;
      }
      function jR(_e, Ce) {
        return function(Ee) {
          return _e(Ce(Ee));
        };
      }
      function Nl(_e, Ce) {
        for (var Ee = -1, it = _e.length, Wt = 0, Rn = []; ++Ee < it; ) {
          var oo = _e[Ee];
          (oo === Ce || oo === c) && (_e[Ee] = c, Rn[Wt++] = Ee);
        }
        return Rn;
      }
      function by(_e) {
        var Ce = -1, Ee = Array(_e.size);
        return _e.forEach(function(it) {
          Ee[++Ce] = it;
        }), Ee;
      }
      function ZX(_e) {
        var Ce = -1, Ee = Array(_e.size);
        return _e.forEach(function(it) {
          Ee[++Ce] = [it, it];
        }), Ee;
      }
      function JX(_e, Ce, Ee) {
        for (var it = Ee - 1, Wt = _e.length; ++it < Wt; )
          if (_e[it] === Ce)
            return it;
        return -1;
      }
      function e$(_e, Ce, Ee) {
        for (var it = Ee + 1; it--; )
          if (_e[it] === Ce)
            return it;
        return it;
      }
      function ld(_e) {
        return ud(_e) ? n$(_e) : UX(_e);
      }
      function Ya(_e) {
        return ud(_e) ? r$(_e) : XX(_e);
      }
      function zR(_e) {
        for (var Ce = _e.length; Ce-- && as.test(_e.charAt(Ce)); )
          ;
        return Ce;
      }
      var t$ = gw(H);
      function n$(_e) {
        for (var Ce = Ho.lastIndex = 0; Ho.test(_e); )
          ++Ce;
        return Ce;
      }
      function r$(_e) {
        return _e.match(Ho) || [];
      }
      function o$(_e) {
        return _e.match(Eu) || [];
      }
      var s$ = function _e(Ce) {
        Ce = Ce == null ? Ye : cd.defaults(Ye.Object(), Ce, cd.pick(Ye, Ni));
        var Ee = Ce.Array, it = Ce.Date, Wt = Ce.Error, Rn = Ce.Function, oo = Ce.Math, Xn = Ce.Object, kw = Ce.RegExp, a$ = Ce.String, ma = Ce.TypeError, ky = Ee.prototype, i$ = Rn.prototype, pd = Xn.prototype, Ty = Ce["__core-js_shared__"], xy = i$.toString, Cn = pd.hasOwnProperty, u$ = 0, qR = function() {
          var f = /[^.]+$/.exec(Ty && Ty.keys && Ty.keys.IE_PROTO || "");
          return f ? "Symbol(src)_1." + f : "";
        }(), Sy = pd.toString, l$ = xy.call(Xn), c$ = Ye._, p$ = kw(
          "^" + xy.call(Cn).replace(ia, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
        ), Ry = en ? Ce.Buffer : n, Ll = Ce.Symbol, Ay = Ce.Uint8Array, GR = Ry ? Ry.allocUnsafe : n, Dy = jR(Xn.getPrototypeOf, Xn), YR = Xn.create, QR = pd.propertyIsEnumerable, Ey = ky.splice, KR = Ll ? Ll.isConcatSpreadable : n, Yh = Ll ? Ll.iterator : n, $c = Ll ? Ll.toStringTag : n, My = function() {
          try {
            var f = zc(Xn, "defineProperty");
            return f({}, "", {}), f;
          } catch {
          }
        }(), d$ = Ce.clearTimeout !== Ye.clearTimeout && Ce.clearTimeout, h$ = it && it.now !== Ye.Date.now && it.now, f$ = Ce.setTimeout !== Ye.setTimeout && Ce.setTimeout, Py = oo.ceil, Cy = oo.floor, Tw = Xn.getOwnPropertySymbols, m$ = Ry ? Ry.isBuffer : n, ZR = Ce.isFinite, y$ = ky.join, g$ = jR(Xn.keys, Xn), so = oo.max, Oo = oo.min, v$ = it.now, _$ = Ce.parseInt, JR = oo.random, w$ = ky.reverse, xw = zc(Ce, "DataView"), Qh = zc(Ce, "Map"), Sw = zc(Ce, "Promise"), dd = zc(Ce, "Set"), Kh = zc(Ce, "WeakMap"), Zh = zc(Xn, "create"), Oy = Kh && new Kh(), hd = {}, b$ = qc(xw), k$ = qc(Qh), T$ = qc(Sw), x$ = qc(dd), S$ = qc(Kh), Iy = Ll ? Ll.prototype : n, Jh = Iy ? Iy.valueOf : n, eA = Iy ? Iy.toString : n;
        function K(f) {
          if (xr(f) && !zt(f) && !(f instanceof pn)) {
            if (f instanceof ya)
              return f;
            if (Cn.call(f, "__wrapped__"))
              return tD(f);
          }
          return new ya(f);
        }
        var fd = /* @__PURE__ */ function() {
          function f() {
          }
          return function(y) {
            if (!pr(y))
              return {};
            if (YR)
              return YR(y);
            f.prototype = y;
            var R = new f();
            return f.prototype = n, R;
          };
        }();
        function Fy() {
        }
        function ya(f, y) {
          this.__wrapped__ = f, this.__actions__ = [], this.__chain__ = !!y, this.__index__ = 0, this.__values__ = n;
        }
        K.templateSettings = {
          /**
           * Used to detect `data` property values to be HTML-escaped.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */
          escape: Dn,
          /**
           * Used to detect code to be evaluated.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */
          evaluate: En,
          /**
           * Used to detect `data` property values to inject.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */
          interpolate: Jn,
          /**
           * Used to reference the data object in the template text.
           *
           * @memberOf _.templateSettings
           * @type {string}
           */
          variable: "",
          /**
           * Used to import variables into the compiled template.
           *
           * @memberOf _.templateSettings
           * @type {Object}
           */
          imports: {
            /**
             * A reference to the `lodash` function.
             *
             * @memberOf _.templateSettings.imports
             * @type {Function}
             */
            _: K
          }
        }, K.prototype = Fy.prototype, K.prototype.constructor = K, ya.prototype = fd(Fy.prototype), ya.prototype.constructor = ya;
        function pn(f) {
          this.__wrapped__ = f, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = J, this.__views__ = [];
        }
        function R$() {
          var f = new pn(this.__wrapped__);
          return f.__actions__ = ps(this.__actions__), f.__dir__ = this.__dir__, f.__filtered__ = this.__filtered__, f.__iteratees__ = ps(this.__iteratees__), f.__takeCount__ = this.__takeCount__, f.__views__ = ps(this.__views__), f;
        }
        function A$() {
          if (this.__filtered__) {
            var f = new pn(this);
            f.__dir__ = -1, f.__filtered__ = !0;
          } else
            f = this.clone(), f.__dir__ *= -1;
          return f;
        }
        function D$() {
          var f = this.__wrapped__.value(), y = this.__dir__, R = zt(f), F = y < 0, $ = R ? f.length : 0, ee = XW(0, $, this.__views__), ce = ee.start, he = ee.end, be = he - ce, Fe = F ? he : ce - 1, Le = this.__iteratees__, We = Le.length, nt = 0, ht = Oo(be, this.__takeCount__);
          if (!R || !F && $ == be && ht == be)
            return xA(f, this.__actions__);
          var Dt = [];
          e:
            for (; be-- && nt < ht; ) {
              Fe += y;
              for (var tn = -1, Et = f[Fe]; ++tn < We; ) {
                var an = Le[tn], mn = an.iteratee, Ws = an.type, Go = mn(Et);
                if (Ws == de)
                  Et = Go;
                else if (!Go) {
                  if (Ws == ne)
                    continue e;
                  break e;
                }
              }
              Dt[nt++] = Et;
            }
          return Dt;
        }
        pn.prototype = fd(Fy.prototype), pn.prototype.constructor = pn;
        function Wc(f) {
          var y = -1, R = f == null ? 0 : f.length;
          for (this.clear(); ++y < R; ) {
            var F = f[y];
            this.set(F[0], F[1]);
          }
        }
        function E$() {
          this.__data__ = Zh ? Zh(null) : {}, this.size = 0;
        }
        function M$(f) {
          var y = this.has(f) && delete this.__data__[f];
          return this.size -= y ? 1 : 0, y;
        }
        function P$(f) {
          var y = this.__data__;
          if (Zh) {
            var R = y[f];
            return R === l ? n : R;
          }
          return Cn.call(y, f) ? y[f] : n;
        }
        function C$(f) {
          var y = this.__data__;
          return Zh ? y[f] !== n : Cn.call(y, f);
        }
        function O$(f, y) {
          var R = this.__data__;
          return this.size += this.has(f) ? 0 : 1, R[f] = Zh && y === n ? l : y, this;
        }
        Wc.prototype.clear = E$, Wc.prototype.delete = M$, Wc.prototype.get = P$, Wc.prototype.has = C$, Wc.prototype.set = O$;
        function Mu(f) {
          var y = -1, R = f == null ? 0 : f.length;
          for (this.clear(); ++y < R; ) {
            var F = f[y];
            this.set(F[0], F[1]);
          }
        }
        function I$() {
          this.__data__ = [], this.size = 0;
        }
        function F$(f) {
          var y = this.__data__, R = Ny(y, f);
          if (R < 0)
            return !1;
          var F = y.length - 1;
          return R == F ? y.pop() : Ey.call(y, R, 1), --this.size, !0;
        }
        function N$(f) {
          var y = this.__data__, R = Ny(y, f);
          return R < 0 ? n : y[R][1];
        }
        function L$(f) {
          return Ny(this.__data__, f) > -1;
        }
        function B$(f, y) {
          var R = this.__data__, F = Ny(R, f);
          return F < 0 ? (++this.size, R.push([f, y])) : R[F][1] = y, this;
        }
        Mu.prototype.clear = I$, Mu.prototype.delete = F$, Mu.prototype.get = N$, Mu.prototype.has = L$, Mu.prototype.set = B$;
        function Pu(f) {
          var y = -1, R = f == null ? 0 : f.length;
          for (this.clear(); ++y < R; ) {
            var F = f[y];
            this.set(F[0], F[1]);
          }
        }
        function U$() {
          this.size = 0, this.__data__ = {
            hash: new Wc(),
            map: new (Qh || Mu)(),
            string: new Wc()
          };
        }
        function X$(f) {
          var y = Gy(this, f).delete(f);
          return this.size -= y ? 1 : 0, y;
        }
        function $$(f) {
          return Gy(this, f).get(f);
        }
        function W$(f) {
          return Gy(this, f).has(f);
        }
        function V$(f, y) {
          var R = Gy(this, f), F = R.size;
          return R.set(f, y), this.size += R.size == F ? 0 : 1, this;
        }
        Pu.prototype.clear = U$, Pu.prototype.delete = X$, Pu.prototype.get = $$, Pu.prototype.has = W$, Pu.prototype.set = V$;
        function Vc(f) {
          var y = -1, R = f == null ? 0 : f.length;
          for (this.__data__ = new Pu(); ++y < R; )
            this.add(f[y]);
        }
        function H$(f) {
          return this.__data__.set(f, l), this;
        }
        function j$(f) {
          return this.__data__.has(f);
        }
        Vc.prototype.add = Vc.prototype.push = H$, Vc.prototype.has = j$;
        function Qa(f) {
          var y = this.__data__ = new Mu(f);
          this.size = y.size;
        }
        function z$() {
          this.__data__ = new Mu(), this.size = 0;
        }
        function q$(f) {
          var y = this.__data__, R = y.delete(f);
          return this.size = y.size, R;
        }
        function G$(f) {
          return this.__data__.get(f);
        }
        function Y$(f) {
          return this.__data__.has(f);
        }
        function Q$(f, y) {
          var R = this.__data__;
          if (R instanceof Mu) {
            var F = R.__data__;
            if (!Qh || F.length < o - 1)
              return F.push([f, y]), this.size = ++R.size, this;
            R = this.__data__ = new Pu(F);
          }
          return R.set(f, y), this.size = R.size, this;
        }
        Qa.prototype.clear = z$, Qa.prototype.delete = q$, Qa.prototype.get = G$, Qa.prototype.has = Y$, Qa.prototype.set = Q$;
        function tA(f, y) {
          var R = zt(f), F = !R && Gc(f), $ = !R && !F && Wl(f), ee = !R && !F && !$ && vd(f), ce = R || F || $ || ee, he = ce ? _w(f.length, a$) : [], be = he.length;
          for (var Fe in f)
            (y || Cn.call(f, Fe)) && !(ce && // Safari 9 has enumerable `arguments.length` in strict mode.
            (Fe == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
            $ && (Fe == "offset" || Fe == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            ee && (Fe == "buffer" || Fe == "byteLength" || Fe == "byteOffset") || // Skip index properties.
            Fu(Fe, be))) && he.push(Fe);
          return he;
        }
        function nA(f) {
          var y = f.length;
          return y ? f[Nw(0, y - 1)] : n;
        }
        function K$(f, y) {
          return Yy(ps(f), Hc(y, 0, f.length));
        }
        function Z$(f) {
          return Yy(ps(f));
        }
        function Rw(f, y, R) {
          (R !== n && !Ka(f[y], R) || R === n && !(y in f)) && Cu(f, y, R);
        }
        function ef(f, y, R) {
          var F = f[y];
          (!(Cn.call(f, y) && Ka(F, R)) || R === n && !(y in f)) && Cu(f, y, R);
        }
        function Ny(f, y) {
          for (var R = f.length; R--; )
            if (Ka(f[R][0], y))
              return R;
          return -1;
        }
        function J$(f, y, R, F) {
          return Bl(f, function($, ee, ce) {
            y(F, $, R($), ce);
          }), F;
        }
        function rA(f, y) {
          return f && Bi(y, fo(y), f);
        }
        function eW(f, y) {
          return f && Bi(y, hs(y), f);
        }
        function Cu(f, y, R) {
          y == "__proto__" && My ? My(f, y, {
            configurable: !0,
            enumerable: !0,
            value: R,
            writable: !0
          }) : f[y] = R;
        }
        function Aw(f, y) {
          for (var R = -1, F = y.length, $ = Ee(F), ee = f == null; ++R < F; )
            $[R] = ee ? n : i1(f, y[R]);
          return $;
        }
        function Hc(f, y, R) {
          return f === f && (R !== n && (f = f <= R ? f : R), y !== n && (f = f >= y ? f : y)), f;
        }
        function ga(f, y, R, F, $, ee) {
          var ce, he = y & p, be = y & d, Fe = y & h;
          if (R && (ce = $ ? R(f, F, $, ee) : R(f)), ce !== n)
            return ce;
          if (!pr(f))
            return f;
          var Le = zt(f);
          if (Le) {
            if (ce = WW(f), !he)
              return ps(f, ce);
          } else {
            var We = Io(f), nt = We == we || We == $e;
            if (Wl(f))
              return AA(f, he);
            if (We == Ot || We == pe || nt && !$) {
              if (ce = be || nt ? {} : zA(f), !he)
                return be ? PW(f, eW(ce, f)) : MW(f, rA(ce, f));
            } else {
              if (!vn[We])
                return $ ? f : {};
              ce = VW(f, We, he);
            }
          }
          ee || (ee = new Qa());
          var ht = ee.get(f);
          if (ht)
            return ht;
          ee.set(f, ce), bD(f) ? f.forEach(function(Et) {
            ce.add(ga(Et, y, R, Et, f, ee));
          }) : _D(f) && f.forEach(function(Et, an) {
            ce.set(an, ga(Et, y, R, an, f, ee));
          });
          var Dt = Fe ? be ? qw : zw : be ? hs : fo, tn = Le ? n : Dt(f);
          return fa(tn || f, function(Et, an) {
            tn && (an = Et, Et = f[an]), ef(ce, an, ga(Et, y, R, an, f, ee));
          }), ce;
        }
        function tW(f) {
          var y = fo(f);
          return function(R) {
            return oA(R, f, y);
          };
        }
        function oA(f, y, R) {
          var F = R.length;
          if (f == null)
            return !F;
          for (f = Xn(f); F--; ) {
            var $ = R[F], ee = y[$], ce = f[$];
            if (ce === n && !($ in f) || !ee(ce))
              return !1;
          }
          return !0;
        }
        function sA(f, y, R) {
          if (typeof f != "function")
            throw new ma(i);
          return uf(function() {
            f.apply(n, R);
          }, y);
        }
        function tf(f, y, R, F) {
          var $ = -1, ee = _y, ce = !0, he = f.length, be = [], Fe = y.length;
          if (!he)
            return be;
          R && (y = tr(y, Us(R))), F ? (ee = hw, ce = !1) : y.length >= o && (ee = Gh, ce = !1, y = new Vc(y));
          e:
            for (; ++$ < he; ) {
              var Le = f[$], We = R == null ? Le : R(Le);
              if (Le = F || Le !== 0 ? Le : 0, ce && We === We) {
                for (var nt = Fe; nt--; )
                  if (y[nt] === We)
                    continue e;
                be.push(Le);
              } else ee(y, We, F) || be.push(Le);
            }
          return be;
        }
        var Bl = CA(Li), aA = CA(Ew, !0);
        function nW(f, y) {
          var R = !0;
          return Bl(f, function(F, $, ee) {
            return R = !!y(F, $, ee), R;
          }), R;
        }
        function Ly(f, y, R) {
          for (var F = -1, $ = f.length; ++F < $; ) {
            var ee = f[F], ce = y(ee);
            if (ce != null && (he === n ? ce === ce && !$s(ce) : R(ce, he)))
              var he = ce, be = ee;
          }
          return be;
        }
        function rW(f, y, R, F) {
          var $ = f.length;
          for (R = Jt(R), R < 0 && (R = -R > $ ? 0 : $ + R), F = F === n || F > $ ? $ : Jt(F), F < 0 && (F += $), F = R > F ? 0 : TD(F); R < F; )
            f[R++] = y;
          return f;
        }
        function iA(f, y) {
          var R = [];
          return Bl(f, function(F, $, ee) {
            y(F, $, ee) && R.push(F);
          }), R;
        }
        function xo(f, y, R, F, $) {
          var ee = -1, ce = f.length;
          for (R || (R = jW), $ || ($ = []); ++ee < ce; ) {
            var he = f[ee];
            y > 0 && R(he) ? y > 1 ? xo(he, y - 1, R, F, $) : Fl($, he) : F || ($[$.length] = he);
          }
          return $;
        }
        var Dw = OA(), uA = OA(!0);
        function Li(f, y) {
          return f && Dw(f, y, fo);
        }
        function Ew(f, y) {
          return f && uA(f, y, fo);
        }
        function By(f, y) {
          return Il(y, function(R) {
            return Nu(f[R]);
          });
        }
        function jc(f, y) {
          y = Xl(y, f);
          for (var R = 0, F = y.length; f != null && R < F; )
            f = f[Ui(y[R++])];
          return R && R == F ? f : n;
        }
        function lA(f, y, R) {
          var F = y(f);
          return zt(f) ? F : Fl(F, R(f));
        }
        function zo(f) {
          return f == null ? f === n ? sa : tt : $c && $c in Xn(f) ? UW(f) : ZW(f);
        }
        function Mw(f, y) {
          return f > y;
        }
        function oW(f, y) {
          return f != null && Cn.call(f, y);
        }
        function sW(f, y) {
          return f != null && y in Xn(f);
        }
        function aW(f, y, R) {
          return f >= Oo(y, R) && f < so(y, R);
        }
        function Pw(f, y, R) {
          for (var F = R ? hw : _y, $ = f[0].length, ee = f.length, ce = ee, he = Ee(ee), be = 1 / 0, Fe = []; ce--; ) {
            var Le = f[ce];
            ce && y && (Le = tr(Le, Us(y))), be = Oo(Le.length, be), he[ce] = !R && (y || $ >= 120 && Le.length >= 120) ? new Vc(ce && Le) : n;
          }
          Le = f[0];
          var We = -1, nt = he[0];
          e:
            for (; ++We < $ && Fe.length < be; ) {
              var ht = Le[We], Dt = y ? y(ht) : ht;
              if (ht = R || ht !== 0 ? ht : 0, !(nt ? Gh(nt, Dt) : F(Fe, Dt, R))) {
                for (ce = ee; --ce; ) {
                  var tn = he[ce];
                  if (!(tn ? Gh(tn, Dt) : F(f[ce], Dt, R)))
                    continue e;
                }
                nt && nt.push(Dt), Fe.push(ht);
              }
            }
          return Fe;
        }
        function iW(f, y, R, F) {
          return Li(f, function($, ee, ce) {
            y(F, R($), ee, ce);
          }), F;
        }
        function nf(f, y, R) {
          y = Xl(y, f), f = QA(f, y);
          var F = f == null ? f : f[Ui(_a(y))];
          return F == null ? n : cr(F, f, R);
        }
        function cA(f) {
          return xr(f) && zo(f) == pe;
        }
        function uW(f) {
          return xr(f) && zo(f) == ar;
        }
        function lW(f) {
          return xr(f) && zo(f) == fe;
        }
        function rf(f, y, R, F, $) {
          return f === y ? !0 : f == null || y == null || !xr(f) && !xr(y) ? f !== f && y !== y : cW(f, y, R, F, rf, $);
        }
        function cW(f, y, R, F, $, ee) {
          var ce = zt(f), he = zt(y), be = ce ? Be : Io(f), Fe = he ? Be : Io(y);
          be = be == pe ? Ot : be, Fe = Fe == pe ? Ot : Fe;
          var Le = be == Ot, We = Fe == Ot, nt = be == Fe;
          if (nt && Wl(f)) {
            if (!Wl(y))
              return !1;
            ce = !0, Le = !1;
          }
          if (nt && !Le)
            return ee || (ee = new Qa()), ce || vd(f) ? VA(f, y, R, F, $, ee) : LW(f, y, be, R, F, $, ee);
          if (!(R & m)) {
            var ht = Le && Cn.call(f, "__wrapped__"), Dt = We && Cn.call(y, "__wrapped__");
            if (ht || Dt) {
              var tn = ht ? f.value() : f, Et = Dt ? y.value() : y;
              return ee || (ee = new Qa()), $(tn, Et, R, F, ee);
            }
          }
          return nt ? (ee || (ee = new Qa()), BW(f, y, R, F, $, ee)) : !1;
        }
        function pW(f) {
          return xr(f) && Io(f) == ze;
        }
        function Cw(f, y, R, F) {
          var $ = R.length, ee = $, ce = !F;
          if (f == null)
            return !ee;
          for (f = Xn(f); $--; ) {
            var he = R[$];
            if (ce && he[2] ? he[1] !== f[he[0]] : !(he[0] in f))
              return !1;
          }
          for (; ++$ < ee; ) {
            he = R[$];
            var be = he[0], Fe = f[be], Le = he[1];
            if (ce && he[2]) {
              if (Fe === n && !(be in f))
                return !1;
            } else {
              var We = new Qa();
              if (F)
                var nt = F(Fe, Le, be, f, y, We);
              if (!(nt === n ? rf(Le, Fe, m | g, F, We) : nt))
                return !1;
            }
          }
          return !0;
        }
        function pA(f) {
          if (!pr(f) || qW(f))
            return !1;
          var y = Nu(f) ? p$ : is;
          return y.test(qc(f));
        }
        function dW(f) {
          return xr(f) && zo(f) == Pn;
        }
        function hW(f) {
          return xr(f) && Io(f) == On;
        }
        function fW(f) {
          return xr(f) && tg(f.length) && !!Sn[zo(f)];
        }
        function dA(f) {
          return typeof f == "function" ? f : f == null ? fs : typeof f == "object" ? zt(f) ? mA(f[0], f[1]) : fA(f) : ID(f);
        }
        function Ow(f) {
          if (!af(f))
            return g$(f);
          var y = [];
          for (var R in Xn(f))
            Cn.call(f, R) && R != "constructor" && y.push(R);
          return y;
        }
        function mW(f) {
          if (!pr(f))
            return KW(f);
          var y = af(f), R = [];
          for (var F in f)
            F == "constructor" && (y || !Cn.call(f, F)) || R.push(F);
          return R;
        }
        function Iw(f, y) {
          return f < y;
        }
        function hA(f, y) {
          var R = -1, F = ds(f) ? Ee(f.length) : [];
          return Bl(f, function($, ee, ce) {
            F[++R] = y($, ee, ce);
          }), F;
        }
        function fA(f) {
          var y = Yw(f);
          return y.length == 1 && y[0][2] ? GA(y[0][0], y[0][1]) : function(R) {
            return R === f || Cw(R, f, y);
          };
        }
        function mA(f, y) {
          return Kw(f) && qA(y) ? GA(Ui(f), y) : function(R) {
            var F = i1(R, f);
            return F === n && F === y ? u1(R, f) : rf(y, F, m | g);
          };
        }
        function Uy(f, y, R, F, $) {
          f !== y && Dw(y, function(ee, ce) {
            if ($ || ($ = new Qa()), pr(ee))
              yW(f, y, ce, R, Uy, F, $);
            else {
              var he = F ? F(Jw(f, ce), ee, ce + "", f, y, $) : n;
              he === n && (he = ee), Rw(f, ce, he);
            }
          }, hs);
        }
        function yW(f, y, R, F, $, ee, ce) {
          var he = Jw(f, R), be = Jw(y, R), Fe = ce.get(be);
          if (Fe) {
            Rw(f, R, Fe);
            return;
          }
          var Le = ee ? ee(he, be, R + "", f, y, ce) : n, We = Le === n;
          if (We) {
            var nt = zt(be), ht = !nt && Wl(be), Dt = !nt && !ht && vd(be);
            Le = be, nt || ht || Dt ? zt(he) ? Le = he : Cr(he) ? Le = ps(he) : ht ? (We = !1, Le = AA(be, !0)) : Dt ? (We = !1, Le = DA(be, !0)) : Le = [] : lf(be) || Gc(be) ? (Le = he, Gc(he) ? Le = xD(he) : (!pr(he) || Nu(he)) && (Le = zA(be))) : We = !1;
          }
          We && (ce.set(be, Le), $(Le, be, F, ee, ce), ce.delete(be)), Rw(f, R, Le);
        }
        function yA(f, y) {
          var R = f.length;
          if (R)
            return y += y < 0 ? R : 0, Fu(y, R) ? f[y] : n;
        }
        function gA(f, y, R) {
          y.length ? y = tr(y, function(ee) {
            return zt(ee) ? function(ce) {
              return jc(ce, ee.length === 1 ? ee[0] : ee);
            } : ee;
          }) : y = [fs];
          var F = -1;
          y = tr(y, Us(At()));
          var $ = hA(f, function(ee, ce, he) {
            var be = tr(y, function(Fe) {
              return Fe(ee);
            });
            return { criteria: be, index: ++F, value: ee };
          });
          return VX($, function(ee, ce) {
            return EW(ee, ce, R);
          });
        }
        function gW(f, y) {
          return vA(f, y, function(R, F) {
            return u1(f, F);
          });
        }
        function vA(f, y, R) {
          for (var F = -1, $ = y.length, ee = {}; ++F < $; ) {
            var ce = y[F], he = jc(f, ce);
            R(he, ce) && of(ee, Xl(ce, f), he);
          }
          return ee;
        }
        function vW(f) {
          return function(y) {
            return jc(y, f);
          };
        }
        function Fw(f, y, R, F) {
          var $ = F ? WX : id, ee = -1, ce = y.length, he = f;
          for (f === y && (y = ps(y)), R && (he = tr(f, Us(R))); ++ee < ce; )
            for (var be = 0, Fe = y[ee], Le = R ? R(Fe) : Fe; (be = $(he, Le, be, F)) > -1; )
              he !== f && Ey.call(he, be, 1), Ey.call(f, be, 1);
          return f;
        }
        function _A(f, y) {
          for (var R = f ? y.length : 0, F = R - 1; R--; ) {
            var $ = y[R];
            if (R == F || $ !== ee) {
              var ee = $;
              Fu($) ? Ey.call(f, $, 1) : Uw(f, $);
            }
          }
          return f;
        }
        function Nw(f, y) {
          return f + Cy(JR() * (y - f + 1));
        }
        function _W(f, y, R, F) {
          for (var $ = -1, ee = so(Py((y - f) / (R || 1)), 0), ce = Ee(ee); ee--; )
            ce[F ? ee : ++$] = f, f += R;
          return ce;
        }
        function Lw(f, y) {
          var R = "";
          if (!f || y < 1 || y > Q)
            return R;
          do
            y % 2 && (R += f), y = Cy(y / 2), y && (f += f);
          while (y);
          return R;
        }
        function rn(f, y) {
          return e1(YA(f, y, fs), f + "");
        }
        function wW(f) {
          return nA(_d(f));
        }
        function bW(f, y) {
          var R = _d(f);
          return Yy(R, Hc(y, 0, R.length));
        }
        function of(f, y, R, F) {
          if (!pr(f))
            return f;
          y = Xl(y, f);
          for (var $ = -1, ee = y.length, ce = ee - 1, he = f; he != null && ++$ < ee; ) {
            var be = Ui(y[$]), Fe = R;
            if (be === "__proto__" || be === "constructor" || be === "prototype")
              return f;
            if ($ != ce) {
              var Le = he[be];
              Fe = F ? F(Le, be, he) : n, Fe === n && (Fe = pr(Le) ? Le : Fu(y[$ + 1]) ? [] : {});
            }
            ef(he, be, Fe), he = he[be];
          }
          return f;
        }
        var wA = Oy ? function(f, y) {
          return Oy.set(f, y), f;
        } : fs, kW = My ? function(f, y) {
          return My(f, "toString", {
            configurable: !0,
            enumerable: !1,
            value: c1(y),
            writable: !0
          });
        } : fs;
        function TW(f) {
          return Yy(_d(f));
        }
        function va(f, y, R) {
          var F = -1, $ = f.length;
          y < 0 && (y = -y > $ ? 0 : $ + y), R = R > $ ? $ : R, R < 0 && (R += $), $ = y > R ? 0 : R - y >>> 0, y >>>= 0;
          for (var ee = Ee($); ++F < $; )
            ee[F] = f[F + y];
          return ee;
        }
        function xW(f, y) {
          var R;
          return Bl(f, function(F, $, ee) {
            return R = y(F, $, ee), !R;
          }), !!R;
        }
        function Xy(f, y, R) {
          var F = 0, $ = f == null ? F : f.length;
          if (typeof y == "number" && y === y && $ <= ue) {
            for (; F < $; ) {
              var ee = F + $ >>> 1, ce = f[ee];
              ce !== null && !$s(ce) && (R ? ce <= y : ce < y) ? F = ee + 1 : $ = ee;
            }
            return $;
          }
          return Bw(f, y, fs, R);
        }
        function Bw(f, y, R, F) {
          var $ = 0, ee = f == null ? 0 : f.length;
          if (ee === 0)
            return 0;
          y = R(y);
          for (var ce = y !== y, he = y === null, be = $s(y), Fe = y === n; $ < ee; ) {
            var Le = Cy(($ + ee) / 2), We = R(f[Le]), nt = We !== n, ht = We === null, Dt = We === We, tn = $s(We);
            if (ce)
              var Et = F || Dt;
            else Fe ? Et = Dt && (F || nt) : he ? Et = Dt && nt && (F || !ht) : be ? Et = Dt && nt && !ht && (F || !tn) : ht || tn ? Et = !1 : Et = F ? We <= y : We < y;
            Et ? $ = Le + 1 : ee = Le;
          }
          return Oo(ee, oe);
        }
        function bA(f, y) {
          for (var R = -1, F = f.length, $ = 0, ee = []; ++R < F; ) {
            var ce = f[R], he = y ? y(ce) : ce;
            if (!R || !Ka(he, be)) {
              var be = he;
              ee[$++] = ce === 0 ? 0 : ce;
            }
          }
          return ee;
        }
        function kA(f) {
          return typeof f == "number" ? f : $s(f) ? Z : +f;
        }
        function Xs(f) {
          if (typeof f == "string")
            return f;
          if (zt(f))
            return tr(f, Xs) + "";
          if ($s(f))
            return eA ? eA.call(f) : "";
          var y = f + "";
          return y == "0" && 1 / f == -Y ? "-0" : y;
        }
        function Ul(f, y, R) {
          var F = -1, $ = _y, ee = f.length, ce = !0, he = [], be = he;
          if (R)
            ce = !1, $ = hw;
          else if (ee >= o) {
            var Fe = y ? null : FW(f);
            if (Fe)
              return by(Fe);
            ce = !1, $ = Gh, be = new Vc();
          } else
            be = y ? [] : he;
          e:
            for (; ++F < ee; ) {
              var Le = f[F], We = y ? y(Le) : Le;
              if (Le = R || Le !== 0 ? Le : 0, ce && We === We) {
                for (var nt = be.length; nt--; )
                  if (be[nt] === We)
                    continue e;
                y && be.push(We), he.push(Le);
              } else $(be, We, R) || (be !== he && be.push(We), he.push(Le));
            }
          return he;
        }
        function Uw(f, y) {
          return y = Xl(y, f), f = QA(f, y), f == null || delete f[Ui(_a(y))];
        }
        function TA(f, y, R, F) {
          return of(f, y, R(jc(f, y)), F);
        }
        function $y(f, y, R, F) {
          for (var $ = f.length, ee = F ? $ : -1; (F ? ee-- : ++ee < $) && y(f[ee], ee, f); )
            ;
          return R ? va(f, F ? 0 : ee, F ? ee + 1 : $) : va(f, F ? ee + 1 : 0, F ? $ : ee);
        }
        function xA(f, y) {
          var R = f;
          return R instanceof pn && (R = R.value()), fw(y, function(F, $) {
            return $.func.apply($.thisArg, Fl([F], $.args));
          }, R);
        }
        function Xw(f, y, R) {
          var F = f.length;
          if (F < 2)
            return F ? Ul(f[0]) : [];
          for (var $ = -1, ee = Ee(F); ++$ < F; )
            for (var ce = f[$], he = -1; ++he < F; )
              he != $ && (ee[$] = tf(ee[$] || ce, f[he], y, R));
          return Ul(xo(ee, 1), y, R);
        }
        function SA(f, y, R) {
          for (var F = -1, $ = f.length, ee = y.length, ce = {}; ++F < $; ) {
            var he = F < ee ? y[F] : n;
            R(ce, f[F], he);
          }
          return ce;
        }
        function $w(f) {
          return Cr(f) ? f : [];
        }
        function Ww(f) {
          return typeof f == "function" ? f : fs;
        }
        function Xl(f, y) {
          return zt(f) ? f : Kw(f, y) ? [f] : eD(Mn(f));
        }
        var SW = rn;
        function $l(f, y, R) {
          var F = f.length;
          return R = R === n ? F : R, !y && R >= F ? f : va(f, y, R);
        }
        var RA = d$ || function(f) {
          return Ye.clearTimeout(f);
        };
        function AA(f, y) {
          if (y)
            return f.slice();
          var R = f.length, F = GR ? GR(R) : new f.constructor(R);
          return f.copy(F), F;
        }
        function Vw(f) {
          var y = new f.constructor(f.byteLength);
          return new Ay(y).set(new Ay(f)), y;
        }
        function RW(f, y) {
          var R = y ? Vw(f.buffer) : f.buffer;
          return new f.constructor(R, f.byteOffset, f.byteLength);
        }
        function AW(f) {
          var y = new f.constructor(f.source, Un.exec(f));
          return y.lastIndex = f.lastIndex, y;
        }
        function DW(f) {
          return Jh ? Xn(Jh.call(f)) : {};
        }
        function DA(f, y) {
          var R = y ? Vw(f.buffer) : f.buffer;
          return new f.constructor(R, f.byteOffset, f.length);
        }
        function EA(f, y) {
          if (f !== y) {
            var R = f !== n, F = f === null, $ = f === f, ee = $s(f), ce = y !== n, he = y === null, be = y === y, Fe = $s(y);
            if (!he && !Fe && !ee && f > y || ee && ce && be && !he && !Fe || F && ce && be || !R && be || !$)
              return 1;
            if (!F && !ee && !Fe && f < y || Fe && R && $ && !F && !ee || he && R && $ || !ce && $ || !be)
              return -1;
          }
          return 0;
        }
        function EW(f, y, R) {
          for (var F = -1, $ = f.criteria, ee = y.criteria, ce = $.length, he = R.length; ++F < ce; ) {
            var be = EA($[F], ee[F]);
            if (be) {
              if (F >= he)
                return be;
              var Fe = R[F];
              return be * (Fe == "desc" ? -1 : 1);
            }
          }
          return f.index - y.index;
        }
        function MA(f, y, R, F) {
          for (var $ = -1, ee = f.length, ce = R.length, he = -1, be = y.length, Fe = so(ee - ce, 0), Le = Ee(be + Fe), We = !F; ++he < be; )
            Le[he] = y[he];
          for (; ++$ < ce; )
            (We || $ < ee) && (Le[R[$]] = f[$]);
          for (; Fe--; )
            Le[he++] = f[$++];
          return Le;
        }
        function PA(f, y, R, F) {
          for (var $ = -1, ee = f.length, ce = -1, he = R.length, be = -1, Fe = y.length, Le = so(ee - he, 0), We = Ee(Le + Fe), nt = !F; ++$ < Le; )
            We[$] = f[$];
          for (var ht = $; ++be < Fe; )
            We[ht + be] = y[be];
          for (; ++ce < he; )
            (nt || $ < ee) && (We[ht + R[ce]] = f[$++]);
          return We;
        }
        function ps(f, y) {
          var R = -1, F = f.length;
          for (y || (y = Ee(F)); ++R < F; )
            y[R] = f[R];
          return y;
        }
        function Bi(f, y, R, F) {
          var $ = !R;
          R || (R = {});
          for (var ee = -1, ce = y.length; ++ee < ce; ) {
            var he = y[ee], be = F ? F(R[he], f[he], he, R, f) : n;
            be === n && (be = f[he]), $ ? Cu(R, he, be) : ef(R, he, be);
          }
          return R;
        }
        function MW(f, y) {
          return Bi(f, Qw(f), y);
        }
        function PW(f, y) {
          return Bi(f, HA(f), y);
        }
        function Wy(f, y) {
          return function(R, F) {
            var $ = zt(R) ? NX : J$, ee = y ? y() : {};
            return $(R, f, At(F, 2), ee);
          };
        }
        function md(f) {
          return rn(function(y, R) {
            var F = -1, $ = R.length, ee = $ > 1 ? R[$ - 1] : n, ce = $ > 2 ? R[2] : n;
            for (ee = f.length > 3 && typeof ee == "function" ? ($--, ee) : n, ce && qo(R[0], R[1], ce) && (ee = $ < 3 ? n : ee, $ = 1), y = Xn(y); ++F < $; ) {
              var he = R[F];
              he && f(y, he, F, ee);
            }
            return y;
          });
        }
        function CA(f, y) {
          return function(R, F) {
            if (R == null)
              return R;
            if (!ds(R))
              return f(R, F);
            for (var $ = R.length, ee = y ? $ : -1, ce = Xn(R); (y ? ee-- : ++ee < $) && F(ce[ee], ee, ce) !== !1; )
              ;
            return R;
          };
        }
        function OA(f) {
          return function(y, R, F) {
            for (var $ = -1, ee = Xn(y), ce = F(y), he = ce.length; he--; ) {
              var be = ce[f ? he : ++$];
              if (R(ee[be], be, ee) === !1)
                break;
            }
            return y;
          };
        }
        function CW(f, y, R) {
          var F = y & _, $ = sf(f);
          function ee() {
            var ce = this && this !== Ye && this instanceof ee ? $ : f;
            return ce.apply(F ? R : this, arguments);
          }
          return ee;
        }
        function IA(f) {
          return function(y) {
            y = Mn(y);
            var R = ud(y) ? Ya(y) : n, F = R ? R[0] : y.charAt(0), $ = R ? $l(R, 1).join("") : y.slice(1);
            return F[f]() + $;
          };
        }
        function yd(f) {
          return function(y) {
            return fw(CD(PD(y).replace(da, "")), f, "");
          };
        }
        function sf(f) {
          return function() {
            var y = arguments;
            switch (y.length) {
              case 0:
                return new f();
              case 1:
                return new f(y[0]);
              case 2:
                return new f(y[0], y[1]);
              case 3:
                return new f(y[0], y[1], y[2]);
              case 4:
                return new f(y[0], y[1], y[2], y[3]);
              case 5:
                return new f(y[0], y[1], y[2], y[3], y[4]);
              case 6:
                return new f(y[0], y[1], y[2], y[3], y[4], y[5]);
              case 7:
                return new f(y[0], y[1], y[2], y[3], y[4], y[5], y[6]);
            }
            var R = fd(f.prototype), F = f.apply(R, y);
            return pr(F) ? F : R;
          };
        }
        function OW(f, y, R) {
          var F = sf(f);
          function $() {
            for (var ee = arguments.length, ce = Ee(ee), he = ee, be = gd($); he--; )
              ce[he] = arguments[he];
            var Fe = ee < 3 && ce[0] !== be && ce[ee - 1] !== be ? [] : Nl(ce, be);
            if (ee -= Fe.length, ee < R)
              return UA(
                f,
                y,
                Vy,
                $.placeholder,
                n,
                ce,
                Fe,
                n,
                n,
                R - ee
              );
            var Le = this && this !== Ye && this instanceof $ ? F : f;
            return cr(Le, this, ce);
          }
          return $;
        }
        function FA(f) {
          return function(y, R, F) {
            var $ = Xn(y);
            if (!ds(y)) {
              var ee = At(R, 3);
              y = fo(y), R = function(he) {
                return ee($[he], he, $);
              };
            }
            var ce = f(y, R, F);
            return ce > -1 ? $[ee ? y[ce] : ce] : n;
          };
        }
        function NA(f) {
          return Iu(function(y) {
            var R = y.length, F = R, $ = ya.prototype.thru;
            for (f && y.reverse(); F--; ) {
              var ee = y[F];
              if (typeof ee != "function")
                throw new ma(i);
              if ($ && !ce && qy(ee) == "wrapper")
                var ce = new ya([], !0);
            }
            for (F = ce ? F : R; ++F < R; ) {
              ee = y[F];
              var he = qy(ee), be = he == "wrapper" ? Gw(ee) : n;
              be && Zw(be[0]) && be[1] == (M | S | A | L) && !be[4].length && be[9] == 1 ? ce = ce[qy(be[0])].apply(ce, be[3]) : ce = ee.length == 1 && Zw(ee) ? ce[he]() : ce.thru(ee);
            }
            return function() {
              var Fe = arguments, Le = Fe[0];
              if (ce && Fe.length == 1 && zt(Le))
                return ce.plant(Le).value();
              for (var We = 0, nt = R ? y[We].apply(this, Fe) : Le; ++We < R; )
                nt = y[We].call(this, nt);
              return nt;
            };
          });
        }
        function Vy(f, y, R, F, $, ee, ce, he, be, Fe) {
          var Le = y & M, We = y & _, nt = y & b, ht = y & (S | E), Dt = y & X, tn = nt ? n : sf(f);
          function Et() {
            for (var an = arguments.length, mn = Ee(an), Ws = an; Ws--; )
              mn[Ws] = arguments[Ws];
            if (ht)
              var Go = gd(Et), Vs = jX(mn, Go);
            if (F && (mn = MA(mn, F, $, ht)), ee && (mn = PA(mn, ee, ce, ht)), an -= Vs, ht && an < Fe) {
              var Or = Nl(mn, Go);
              return UA(
                f,
                y,
                Vy,
                Et.placeholder,
                R,
                mn,
                Or,
                he,
                be,
                Fe - an
              );
            }
            var Za = We ? R : this, Bu = nt ? Za[f] : f;
            return an = mn.length, he ? mn = JW(mn, he) : Dt && an > 1 && mn.reverse(), Le && be < an && (mn.length = be), this && this !== Ye && this instanceof Et && (Bu = tn || sf(Bu)), Bu.apply(Za, mn);
          }
          return Et;
        }
        function LA(f, y) {
          return function(R, F) {
            return iW(R, f, y(F), {});
          };
        }
        function Hy(f, y) {
          return function(R, F) {
            var $;
            if (R === n && F === n)
              return y;
            if (R !== n && ($ = R), F !== n) {
              if ($ === n)
                return F;
              typeof R == "string" || typeof F == "string" ? (R = Xs(R), F = Xs(F)) : (R = kA(R), F = kA(F)), $ = f(R, F);
            }
            return $;
          };
        }
        function Hw(f) {
          return Iu(function(y) {
            return y = tr(y, Us(At())), rn(function(R) {
              var F = this;
              return f(y, function($) {
                return cr($, F, R);
              });
            });
          });
        }
        function jy(f, y) {
          y = y === n ? " " : Xs(y);
          var R = y.length;
          if (R < 2)
            return R ? Lw(y, f) : y;
          var F = Lw(y, Py(f / ld(y)));
          return ud(y) ? $l(Ya(F), 0, f).join("") : F.slice(0, f);
        }
        function IW(f, y, R, F) {
          var $ = y & _, ee = sf(f);
          function ce() {
            for (var he = -1, be = arguments.length, Fe = -1, Le = F.length, We = Ee(Le + be), nt = this && this !== Ye && this instanceof ce ? ee : f; ++Fe < Le; )
              We[Fe] = F[Fe];
            for (; be--; )
              We[Fe++] = arguments[++he];
            return cr(nt, $ ? R : this, We);
          }
          return ce;
        }
        function BA(f) {
          return function(y, R, F) {
            return F && typeof F != "number" && qo(y, R, F) && (R = F = n), y = Lu(y), R === n ? (R = y, y = 0) : R = Lu(R), F = F === n ? y < R ? 1 : -1 : Lu(F), _W(y, R, F, f);
          };
        }
        function zy(f) {
          return function(y, R) {
            return typeof y == "string" && typeof R == "string" || (y = wa(y), R = wa(R)), f(y, R);
          };
        }
        function UA(f, y, R, F, $, ee, ce, he, be, Fe) {
          var Le = y & S, We = Le ? ce : n, nt = Le ? n : ce, ht = Le ? ee : n, Dt = Le ? n : ee;
          y |= Le ? A : C, y &= ~(Le ? C : A), y & x || (y &= -4);
          var tn = [
            f,
            y,
            $,
            ht,
            We,
            Dt,
            nt,
            he,
            be,
            Fe
          ], Et = R.apply(n, tn);
          return Zw(f) && KA(Et, tn), Et.placeholder = F, ZA(Et, f, y);
        }
        function jw(f) {
          var y = oo[f];
          return function(R, F) {
            if (R = wa(R), F = F == null ? 0 : Oo(Jt(F), 292), F && ZR(R)) {
              var $ = (Mn(R) + "e").split("e"), ee = y($[0] + "e" + (+$[1] + F));
              return $ = (Mn(ee) + "e").split("e"), +($[0] + "e" + (+$[1] - F));
            }
            return y(R);
          };
        }
        var FW = dd && 1 / by(new dd([, -0]))[1] == Y ? function(f) {
          return new dd(f);
        } : h1;
        function XA(f) {
          return function(y) {
            var R = Io(y);
            return R == ze ? bw(y) : R == On ? ZX(y) : HX(y, f(y));
          };
        }
        function Ou(f, y, R, F, $, ee, ce, he) {
          var be = y & b;
          if (!be && typeof f != "function")
            throw new ma(i);
          var Fe = F ? F.length : 0;
          if (Fe || (y &= -97, F = $ = n), ce = ce === n ? ce : so(Jt(ce), 0), he = he === n ? he : Jt(he), Fe -= $ ? $.length : 0, y & C) {
            var Le = F, We = $;
            F = $ = n;
          }
          var nt = be ? n : Gw(f), ht = [
            f,
            y,
            R,
            F,
            $,
            Le,
            We,
            ee,
            ce,
            he
          ];
          if (nt && QW(ht, nt), f = ht[0], y = ht[1], R = ht[2], F = ht[3], $ = ht[4], he = ht[9] = ht[9] === n ? be ? 0 : f.length : so(ht[9] - Fe, 0), !he && y & (S | E) && (y &= -25), !y || y == _)
            var Dt = CW(f, y, R);
          else y == S || y == E ? Dt = OW(f, y, he) : (y == A || y == (_ | A)) && !$.length ? Dt = IW(f, y, R, F) : Dt = Vy.apply(n, ht);
          var tn = nt ? wA : KA;
          return ZA(tn(Dt, ht), f, y);
        }
        function $A(f, y, R, F) {
          return f === n || Ka(f, pd[R]) && !Cn.call(F, R) ? y : f;
        }
        function WA(f, y, R, F, $, ee) {
          return pr(f) && pr(y) && (ee.set(y, f), Uy(f, y, n, WA, ee), ee.delete(y)), f;
        }
        function NW(f) {
          return lf(f) ? n : f;
        }
        function VA(f, y, R, F, $, ee) {
          var ce = R & m, he = f.length, be = y.length;
          if (he != be && !(ce && be > he))
            return !1;
          var Fe = ee.get(f), Le = ee.get(y);
          if (Fe && Le)
            return Fe == y && Le == f;
          var We = -1, nt = !0, ht = R & g ? new Vc() : n;
          for (ee.set(f, y), ee.set(y, f); ++We < he; ) {
            var Dt = f[We], tn = y[We];
            if (F)
              var Et = ce ? F(tn, Dt, We, y, f, ee) : F(Dt, tn, We, f, y, ee);
            if (Et !== n) {
              if (Et)
                continue;
              nt = !1;
              break;
            }
            if (ht) {
              if (!mw(y, function(an, mn) {
                if (!Gh(ht, mn) && (Dt === an || $(Dt, an, R, F, ee)))
                  return ht.push(mn);
              })) {
                nt = !1;
                break;
              }
            } else if (!(Dt === tn || $(Dt, tn, R, F, ee))) {
              nt = !1;
              break;
            }
          }
          return ee.delete(f), ee.delete(y), nt;
        }
        function LW(f, y, R, F, $, ee, ce) {
          switch (R) {
            case Zn:
              if (f.byteLength != y.byteLength || f.byteOffset != y.byteOffset)
                return !1;
              f = f.buffer, y = y.buffer;
            case ar:
              return !(f.byteLength != y.byteLength || !ee(new Ay(f), new Ay(y)));
            case Me:
            case fe:
            case Ue:
              return Ka(+f, +y);
            case Ae:
              return f.name == y.name && f.message == y.message;
            case Pn:
            case sr:
              return f == y + "";
            case ze:
              var he = bw;
            case On:
              var be = F & m;
              if (he || (he = by), f.size != y.size && !be)
                return !1;
              var Fe = ce.get(f);
              if (Fe)
                return Fe == y;
              F |= g, ce.set(f, y);
              var Le = VA(he(f), he(y), F, $, ee, ce);
              return ce.delete(f), Le;
            case Hn:
              if (Jh)
                return Jh.call(f) == Jh.call(y);
          }
          return !1;
        }
        function BW(f, y, R, F, $, ee) {
          var ce = R & m, he = zw(f), be = he.length, Fe = zw(y), Le = Fe.length;
          if (be != Le && !ce)
            return !1;
          for (var We = be; We--; ) {
            var nt = he[We];
            if (!(ce ? nt in y : Cn.call(y, nt)))
              return !1;
          }
          var ht = ee.get(f), Dt = ee.get(y);
          if (ht && Dt)
            return ht == y && Dt == f;
          var tn = !0;
          ee.set(f, y), ee.set(y, f);
          for (var Et = ce; ++We < be; ) {
            nt = he[We];
            var an = f[nt], mn = y[nt];
            if (F)
              var Ws = ce ? F(mn, an, nt, y, f, ee) : F(an, mn, nt, f, y, ee);
            if (!(Ws === n ? an === mn || $(an, mn, R, F, ee) : Ws)) {
              tn = !1;
              break;
            }
            Et || (Et = nt == "constructor");
          }
          if (tn && !Et) {
            var Go = f.constructor, Vs = y.constructor;
            Go != Vs && "constructor" in f && "constructor" in y && !(typeof Go == "function" && Go instanceof Go && typeof Vs == "function" && Vs instanceof Vs) && (tn = !1);
          }
          return ee.delete(f), ee.delete(y), tn;
        }
        function Iu(f) {
          return e1(YA(f, n, oD), f + "");
        }
        function zw(f) {
          return lA(f, fo, Qw);
        }
        function qw(f) {
          return lA(f, hs, HA);
        }
        var Gw = Oy ? function(f) {
          return Oy.get(f);
        } : h1;
        function qy(f) {
          for (var y = f.name + "", R = hd[y], F = Cn.call(hd, y) ? R.length : 0; F--; ) {
            var $ = R[F], ee = $.func;
            if (ee == null || ee == f)
              return $.name;
          }
          return y;
        }
        function gd(f) {
          var y = Cn.call(K, "placeholder") ? K : f;
          return y.placeholder;
        }
        function At() {
          var f = K.iteratee || p1;
          return f = f === p1 ? dA : f, arguments.length ? f(arguments[0], arguments[1]) : f;
        }
        function Gy(f, y) {
          var R = f.__data__;
          return zW(y) ? R[typeof y == "string" ? "string" : "hash"] : R.map;
        }
        function Yw(f) {
          for (var y = fo(f), R = y.length; R--; ) {
            var F = y[R], $ = f[F];
            y[R] = [F, $, qA($)];
          }
          return y;
        }
        function zc(f, y) {
          var R = YX(f, y);
          return pA(R) ? R : n;
        }
        function UW(f) {
          var y = Cn.call(f, $c), R = f[$c];
          try {
            f[$c] = n;
            var F = !0;
          } catch {
          }
          var $ = Sy.call(f);
          return F && (y ? f[$c] = R : delete f[$c]), $;
        }
        var Qw = Tw ? function(f) {
          return f == null ? [] : (f = Xn(f), Il(Tw(f), function(y) {
            return QR.call(f, y);
          }));
        } : f1, HA = Tw ? function(f) {
          for (var y = []; f; )
            Fl(y, Qw(f)), f = Dy(f);
          return y;
        } : f1, Io = zo;
        (xw && Io(new xw(new ArrayBuffer(1))) != Zn || Qh && Io(new Qh()) != ze || Sw && Io(Sw.resolve()) != cn || dd && Io(new dd()) != On || Kh && Io(new Kh()) != Eo) && (Io = function(f) {
          var y = zo(f), R = y == Ot ? f.constructor : n, F = R ? qc(R) : "";
          if (F)
            switch (F) {
              case b$:
                return Zn;
              case k$:
                return ze;
              case T$:
                return cn;
              case x$:
                return On;
              case S$:
                return Eo;
            }
          return y;
        });
        function XW(f, y, R) {
          for (var F = -1, $ = R.length; ++F < $; ) {
            var ee = R[F], ce = ee.size;
            switch (ee.type) {
              case "drop":
                f += ce;
                break;
              case "dropRight":
                y -= ce;
                break;
              case "take":
                y = Oo(y, f + ce);
                break;
              case "takeRight":
                f = so(f, y - ce);
                break;
            }
          }
          return { start: f, end: y };
        }
        function $W(f) {
          var y = f.match(ir);
          return y ? y[1].split(Di) : [];
        }
        function jA(f, y, R) {
          y = Xl(y, f);
          for (var F = -1, $ = y.length, ee = !1; ++F < $; ) {
            var ce = Ui(y[F]);
            if (!(ee = f != null && R(f, ce)))
              break;
            f = f[ce];
          }
          return ee || ++F != $ ? ee : ($ = f == null ? 0 : f.length, !!$ && tg($) && Fu(ce, $) && (zt(f) || Gc(f)));
        }
        function WW(f) {
          var y = f.length, R = new f.constructor(y);
          return y && typeof f[0] == "string" && Cn.call(f, "index") && (R.index = f.index, R.input = f.input), R;
        }
        function zA(f) {
          return typeof f.constructor == "function" && !af(f) ? fd(Dy(f)) : {};
        }
        function VW(f, y, R) {
          var F = f.constructor;
          switch (y) {
            case ar:
              return Vw(f);
            case Me:
            case fe:
              return new F(+f);
            case Zn:
              return RW(f, R);
            case $r:
            case gn:
            case ko:
            case Mo:
            case Fs:
            case To:
            case In:
            case ke:
            case Re:
              return DA(f, R);
            case ze:
              return new F();
            case Ue:
            case sr:
              return new F(f);
            case Pn:
              return AW(f);
            case On:
              return new F();
            case Hn:
              return DW(f);
          }
        }
        function HW(f, y) {
          var R = y.length;
          if (!R)
            return f;
          var F = R - 1;
          return y[F] = (R > 1 ? "& " : "") + y[F], y = y.join(R > 2 ? ", " : " "), f.replace(Wr, `{
/* [wrapped with ` + y + `] */
`);
        }
        function jW(f) {
          return zt(f) || Gc(f) || !!(KR && f && f[KR]);
        }
        function Fu(f, y) {
          var R = typeof f;
          return y = y ?? Q, !!y && (R == "number" || R != "symbol" && xu.test(f)) && f > -1 && f % 1 == 0 && f < y;
        }
        function qo(f, y, R) {
          if (!pr(R))
            return !1;
          var F = typeof y;
          return (F == "number" ? ds(R) && Fu(y, R.length) : F == "string" && y in R) ? Ka(R[y], f) : !1;
        }
        function Kw(f, y) {
          if (zt(f))
            return !1;
          var R = typeof f;
          return R == "number" || R == "symbol" || R == "boolean" || f == null || $s(f) ? !0 : po.test(f) || !Bn.test(f) || y != null && f in Xn(y);
        }
        function zW(f) {
          var y = typeof f;
          return y == "string" || y == "number" || y == "symbol" || y == "boolean" ? f !== "__proto__" : f === null;
        }
        function Zw(f) {
          var y = qy(f), R = K[y];
          if (typeof R != "function" || !(y in pn.prototype))
            return !1;
          if (f === R)
            return !0;
          var F = Gw(R);
          return !!F && f === F[0];
        }
        function qW(f) {
          return !!qR && qR in f;
        }
        var GW = Ty ? Nu : m1;
        function af(f) {
          var y = f && f.constructor, R = typeof y == "function" && y.prototype || pd;
          return f === R;
        }
        function qA(f) {
          return f === f && !pr(f);
        }
        function GA(f, y) {
          return function(R) {
            return R == null ? !1 : R[f] === y && (y !== n || f in Xn(R));
          };
        }
        function YW(f) {
          var y = Jy(f, function(F) {
            return R.size === a && R.clear(), F;
          }), R = y.cache;
          return y;
        }
        function QW(f, y) {
          var R = f[1], F = y[1], $ = R | F, ee = $ < (_ | b | M), ce = F == M && R == S || F == M && R == L && f[7].length <= y[8] || F == (M | L) && y[7].length <= y[8] && R == S;
          if (!(ee || ce))
            return f;
          F & _ && (f[2] = y[2], $ |= R & _ ? 0 : x);
          var he = y[3];
          if (he) {
            var be = f[3];
            f[3] = be ? MA(be, he, y[4]) : he, f[4] = be ? Nl(f[3], c) : y[4];
          }
          return he = y[5], he && (be = f[5], f[5] = be ? PA(be, he, y[6]) : he, f[6] = be ? Nl(f[5], c) : y[6]), he = y[7], he && (f[7] = he), F & M && (f[8] = f[8] == null ? y[8] : Oo(f[8], y[8])), f[9] == null && (f[9] = y[9]), f[0] = y[0], f[1] = $, f;
        }
        function KW(f) {
          var y = [];
          if (f != null)
            for (var R in Xn(f))
              y.push(R);
          return y;
        }
        function ZW(f) {
          return Sy.call(f);
        }
        function YA(f, y, R) {
          return y = so(y === n ? f.length - 1 : y, 0), function() {
            for (var F = arguments, $ = -1, ee = so(F.length - y, 0), ce = Ee(ee); ++$ < ee; )
              ce[$] = F[y + $];
            $ = -1;
            for (var he = Ee(y + 1); ++$ < y; )
              he[$] = F[$];
            return he[y] = R(ce), cr(f, this, he);
          };
        }
        function QA(f, y) {
          return y.length < 2 ? f : jc(f, va(y, 0, -1));
        }
        function JW(f, y) {
          for (var R = f.length, F = Oo(y.length, R), $ = ps(f); F--; ) {
            var ee = y[F];
            f[F] = Fu(ee, R) ? $[ee] : n;
          }
          return f;
        }
        function Jw(f, y) {
          if (!(y === "constructor" && typeof f[y] == "function") && y != "__proto__")
            return f[y];
        }
        var KA = JA(wA), uf = f$ || function(f, y) {
          return Ye.setTimeout(f, y);
        }, e1 = JA(kW);
        function ZA(f, y, R) {
          var F = y + "";
          return e1(f, HW(F, eV($W(F), R)));
        }
        function JA(f) {
          var y = 0, R = 0;
          return function() {
            var F = v$(), $ = G - (F - R);
            if (R = F, $ > 0) {
              if (++y >= W)
                return arguments[0];
            } else
              y = 0;
            return f.apply(n, arguments);
          };
        }
        function Yy(f, y) {
          var R = -1, F = f.length, $ = F - 1;
          for (y = y === n ? F : y; ++R < y; ) {
            var ee = Nw(R, $), ce = f[ee];
            f[ee] = f[R], f[R] = ce;
          }
          return f.length = y, f;
        }
        var eD = YW(function(f) {
          var y = [];
          return f.charCodeAt(0) === 46 && y.push(""), f.replace(Ai, function(R, F, $, ee) {
            y.push($ ? ee.replace(Mi, "$1") : F || R);
          }), y;
        });
        function Ui(f) {
          if (typeof f == "string" || $s(f))
            return f;
          var y = f + "";
          return y == "0" && 1 / f == -Y ? "-0" : y;
        }
        function qc(f) {
          if (f != null) {
            try {
              return xy.call(f);
            } catch {
            }
            try {
              return f + "";
            } catch {
            }
          }
          return "";
        }
        function eV(f, y) {
          return fa(me, function(R) {
            var F = "_." + R[0];
            y & R[1] && !_y(f, F) && f.push(F);
          }), f.sort();
        }
        function tD(f) {
          if (f instanceof pn)
            return f.clone();
          var y = new ya(f.__wrapped__, f.__chain__);
          return y.__actions__ = ps(f.__actions__), y.__index__ = f.__index__, y.__values__ = f.__values__, y;
        }
        function tV(f, y, R) {
          (R ? qo(f, y, R) : y === n) ? y = 1 : y = so(Jt(y), 0);
          var F = f == null ? 0 : f.length;
          if (!F || y < 1)
            return [];
          for (var $ = 0, ee = 0, ce = Ee(Py(F / y)); $ < F; )
            ce[ee++] = va(f, $, $ += y);
          return ce;
        }
        function nV(f) {
          for (var y = -1, R = f == null ? 0 : f.length, F = 0, $ = []; ++y < R; ) {
            var ee = f[y];
            ee && ($[F++] = ee);
          }
          return $;
        }
        function rV() {
          var f = arguments.length;
          if (!f)
            return [];
          for (var y = Ee(f - 1), R = arguments[0], F = f; F--; )
            y[F - 1] = arguments[F];
          return Fl(zt(R) ? ps(R) : [R], xo(y, 1));
        }
        var oV = rn(function(f, y) {
          return Cr(f) ? tf(f, xo(y, 1, Cr, !0)) : [];
        }), sV = rn(function(f, y) {
          var R = _a(y);
          return Cr(R) && (R = n), Cr(f) ? tf(f, xo(y, 1, Cr, !0), At(R, 2)) : [];
        }), aV = rn(function(f, y) {
          var R = _a(y);
          return Cr(R) && (R = n), Cr(f) ? tf(f, xo(y, 1, Cr, !0), n, R) : [];
        });
        function iV(f, y, R) {
          var F = f == null ? 0 : f.length;
          return F ? (y = R || y === n ? 1 : Jt(y), va(f, y < 0 ? 0 : y, F)) : [];
        }
        function uV(f, y, R) {
          var F = f == null ? 0 : f.length;
          return F ? (y = R || y === n ? 1 : Jt(y), y = F - y, va(f, 0, y < 0 ? 0 : y)) : [];
        }
        function lV(f, y) {
          return f && f.length ? $y(f, At(y, 3), !0, !0) : [];
        }
        function cV(f, y) {
          return f && f.length ? $y(f, At(y, 3), !0) : [];
        }
        function pV(f, y, R, F) {
          var $ = f == null ? 0 : f.length;
          return $ ? (R && typeof R != "number" && qo(f, y, R) && (R = 0, F = $), rW(f, y, R, F)) : [];
        }
        function nD(f, y, R) {
          var F = f == null ? 0 : f.length;
          if (!F)
            return -1;
          var $ = R == null ? 0 : Jt(R);
          return $ < 0 && ($ = so(F + $, 0)), wy(f, At(y, 3), $);
        }
        function rD(f, y, R) {
          var F = f == null ? 0 : f.length;
          if (!F)
            return -1;
          var $ = F - 1;
          return R !== n && ($ = Jt(R), $ = R < 0 ? so(F + $, 0) : Oo($, F - 1)), wy(f, At(y, 3), $, !0);
        }
        function oD(f) {
          var y = f == null ? 0 : f.length;
          return y ? xo(f, 1) : [];
        }
        function dV(f) {
          var y = f == null ? 0 : f.length;
          return y ? xo(f, Y) : [];
        }
        function hV(f, y) {
          var R = f == null ? 0 : f.length;
          return R ? (y = y === n ? 1 : Jt(y), xo(f, y)) : [];
        }
        function fV(f) {
          for (var y = -1, R = f == null ? 0 : f.length, F = {}; ++y < R; ) {
            var $ = f[y];
            F[$[0]] = $[1];
          }
          return F;
        }
        function sD(f) {
          return f && f.length ? f[0] : n;
        }
        function mV(f, y, R) {
          var F = f == null ? 0 : f.length;
          if (!F)
            return -1;
          var $ = R == null ? 0 : Jt(R);
          return $ < 0 && ($ = so(F + $, 0)), id(f, y, $);
        }
        function yV(f) {
          var y = f == null ? 0 : f.length;
          return y ? va(f, 0, -1) : [];
        }
        var gV = rn(function(f) {
          var y = tr(f, $w);
          return y.length && y[0] === f[0] ? Pw(y) : [];
        }), vV = rn(function(f) {
          var y = _a(f), R = tr(f, $w);
          return y === _a(R) ? y = n : R.pop(), R.length && R[0] === f[0] ? Pw(R, At(y, 2)) : [];
        }), _V = rn(function(f) {
          var y = _a(f), R = tr(f, $w);
          return y = typeof y == "function" ? y : n, y && R.pop(), R.length && R[0] === f[0] ? Pw(R, n, y) : [];
        });
        function wV(f, y) {
          return f == null ? "" : y$.call(f, y);
        }
        function _a(f) {
          var y = f == null ? 0 : f.length;
          return y ? f[y - 1] : n;
        }
        function bV(f, y, R) {
          var F = f == null ? 0 : f.length;
          if (!F)
            return -1;
          var $ = F;
          return R !== n && ($ = Jt(R), $ = $ < 0 ? so(F + $, 0) : Oo($, F - 1)), y === y ? e$(f, y, $) : wy(f, UR, $, !0);
        }
        function kV(f, y) {
          return f && f.length ? yA(f, Jt(y)) : n;
        }
        var TV = rn(aD);
        function aD(f, y) {
          return f && f.length && y && y.length ? Fw(f, y) : f;
        }
        function xV(f, y, R) {
          return f && f.length && y && y.length ? Fw(f, y, At(R, 2)) : f;
        }
        function SV(f, y, R) {
          return f && f.length && y && y.length ? Fw(f, y, n, R) : f;
        }
        var RV = Iu(function(f, y) {
          var R = f == null ? 0 : f.length, F = Aw(f, y);
          return _A(f, tr(y, function($) {
            return Fu($, R) ? +$ : $;
          }).sort(EA)), F;
        });
        function AV(f, y) {
          var R = [];
          if (!(f && f.length))
            return R;
          var F = -1, $ = [], ee = f.length;
          for (y = At(y, 3); ++F < ee; ) {
            var ce = f[F];
            y(ce, F, f) && (R.push(ce), $.push(F));
          }
          return _A(f, $), R;
        }
        function t1(f) {
          return f == null ? f : w$.call(f);
        }
        function DV(f, y, R) {
          var F = f == null ? 0 : f.length;
          return F ? (R && typeof R != "number" && qo(f, y, R) ? (y = 0, R = F) : (y = y == null ? 0 : Jt(y), R = R === n ? F : Jt(R)), va(f, y, R)) : [];
        }
        function EV(f, y) {
          return Xy(f, y);
        }
        function MV(f, y, R) {
          return Bw(f, y, At(R, 2));
        }
        function PV(f, y) {
          var R = f == null ? 0 : f.length;
          if (R) {
            var F = Xy(f, y);
            if (F < R && Ka(f[F], y))
              return F;
          }
          return -1;
        }
        function CV(f, y) {
          return Xy(f, y, !0);
        }
        function OV(f, y, R) {
          return Bw(f, y, At(R, 2), !0);
        }
        function IV(f, y) {
          var R = f == null ? 0 : f.length;
          if (R) {
            var F = Xy(f, y, !0) - 1;
            if (Ka(f[F], y))
              return F;
          }
          return -1;
        }
        function FV(f) {
          return f && f.length ? bA(f) : [];
        }
        function NV(f, y) {
          return f && f.length ? bA(f, At(y, 2)) : [];
        }
        function LV(f) {
          var y = f == null ? 0 : f.length;
          return y ? va(f, 1, y) : [];
        }
        function BV(f, y, R) {
          return f && f.length ? (y = R || y === n ? 1 : Jt(y), va(f, 0, y < 0 ? 0 : y)) : [];
        }
        function UV(f, y, R) {
          var F = f == null ? 0 : f.length;
          return F ? (y = R || y === n ? 1 : Jt(y), y = F - y, va(f, y < 0 ? 0 : y, F)) : [];
        }
        function XV(f, y) {
          return f && f.length ? $y(f, At(y, 3), !1, !0) : [];
        }
        function $V(f, y) {
          return f && f.length ? $y(f, At(y, 3)) : [];
        }
        var WV = rn(function(f) {
          return Ul(xo(f, 1, Cr, !0));
        }), VV = rn(function(f) {
          var y = _a(f);
          return Cr(y) && (y = n), Ul(xo(f, 1, Cr, !0), At(y, 2));
        }), HV = rn(function(f) {
          var y = _a(f);
          return y = typeof y == "function" ? y : n, Ul(xo(f, 1, Cr, !0), n, y);
        });
        function jV(f) {
          return f && f.length ? Ul(f) : [];
        }
        function zV(f, y) {
          return f && f.length ? Ul(f, At(y, 2)) : [];
        }
        function qV(f, y) {
          return y = typeof y == "function" ? y : n, f && f.length ? Ul(f, n, y) : [];
        }
        function n1(f) {
          if (!(f && f.length))
            return [];
          var y = 0;
          return f = Il(f, function(R) {
            if (Cr(R))
              return y = so(R.length, y), !0;
          }), _w(y, function(R) {
            return tr(f, yw(R));
          });
        }
        function iD(f, y) {
          if (!(f && f.length))
            return [];
          var R = n1(f);
          return y == null ? R : tr(R, function(F) {
            return cr(y, n, F);
          });
        }
        var GV = rn(function(f, y) {
          return Cr(f) ? tf(f, y) : [];
        }), YV = rn(function(f) {
          return Xw(Il(f, Cr));
        }), QV = rn(function(f) {
          var y = _a(f);
          return Cr(y) && (y = n), Xw(Il(f, Cr), At(y, 2));
        }), KV = rn(function(f) {
          var y = _a(f);
          return y = typeof y == "function" ? y : n, Xw(Il(f, Cr), n, y);
        }), ZV = rn(n1);
        function JV(f, y) {
          return SA(f || [], y || [], ef);
        }
        function e7(f, y) {
          return SA(f || [], y || [], of);
        }
        var t7 = rn(function(f) {
          var y = f.length, R = y > 1 ? f[y - 1] : n;
          return R = typeof R == "function" ? (f.pop(), R) : n, iD(f, R);
        });
        function uD(f) {
          var y = K(f);
          return y.__chain__ = !0, y;
        }
        function n7(f, y) {
          return y(f), f;
        }
        function Qy(f, y) {
          return y(f);
        }
        var r7 = Iu(function(f) {
          var y = f.length, R = y ? f[0] : 0, F = this.__wrapped__, $ = function(ee) {
            return Aw(ee, f);
          };
          return y > 1 || this.__actions__.length || !(F instanceof pn) || !Fu(R) ? this.thru($) : (F = F.slice(R, +R + (y ? 1 : 0)), F.__actions__.push({
            func: Qy,
            args: [$],
            thisArg: n
          }), new ya(F, this.__chain__).thru(function(ee) {
            return y && !ee.length && ee.push(n), ee;
          }));
        });
        function o7() {
          return uD(this);
        }
        function s7() {
          return new ya(this.value(), this.__chain__);
        }
        function a7() {
          this.__values__ === n && (this.__values__ = kD(this.value()));
          var f = this.__index__ >= this.__values__.length, y = f ? n : this.__values__[this.__index__++];
          return { done: f, value: y };
        }
        function i7() {
          return this;
        }
        function u7(f) {
          for (var y, R = this; R instanceof Fy; ) {
            var F = tD(R);
            F.__index__ = 0, F.__values__ = n, y ? $.__wrapped__ = F : y = F;
            var $ = F;
            R = R.__wrapped__;
          }
          return $.__wrapped__ = f, y;
        }
        function l7() {
          var f = this.__wrapped__;
          if (f instanceof pn) {
            var y = f;
            return this.__actions__.length && (y = new pn(this)), y = y.reverse(), y.__actions__.push({
              func: Qy,
              args: [t1],
              thisArg: n
            }), new ya(y, this.__chain__);
          }
          return this.thru(t1);
        }
        function c7() {
          return xA(this.__wrapped__, this.__actions__);
        }
        var p7 = Wy(function(f, y, R) {
          Cn.call(f, R) ? ++f[R] : Cu(f, R, 1);
        });
        function d7(f, y, R) {
          var F = zt(f) ? LR : nW;
          return R && qo(f, y, R) && (y = n), F(f, At(y, 3));
        }
        function h7(f, y) {
          var R = zt(f) ? Il : iA;
          return R(f, At(y, 3));
        }
        var f7 = FA(nD), m7 = FA(rD);
        function y7(f, y) {
          return xo(Ky(f, y), 1);
        }
        function g7(f, y) {
          return xo(Ky(f, y), Y);
        }
        function v7(f, y, R) {
          return R = R === n ? 1 : Jt(R), xo(Ky(f, y), R);
        }
        function lD(f, y) {
          var R = zt(f) ? fa : Bl;
          return R(f, At(y, 3));
        }
        function cD(f, y) {
          var R = zt(f) ? LX : aA;
          return R(f, At(y, 3));
        }
        var _7 = Wy(function(f, y, R) {
          Cn.call(f, R) ? f[R].push(y) : Cu(f, R, [y]);
        });
        function w7(f, y, R, F) {
          f = ds(f) ? f : _d(f), R = R && !F ? Jt(R) : 0;
          var $ = f.length;
          return R < 0 && (R = so($ + R, 0)), ng(f) ? R <= $ && f.indexOf(y, R) > -1 : !!$ && id(f, y, R) > -1;
        }
        var b7 = rn(function(f, y, R) {
          var F = -1, $ = typeof y == "function", ee = ds(f) ? Ee(f.length) : [];
          return Bl(f, function(ce) {
            ee[++F] = $ ? cr(y, ce, R) : nf(ce, y, R);
          }), ee;
        }), k7 = Wy(function(f, y, R) {
          Cu(f, R, y);
        });
        function Ky(f, y) {
          var R = zt(f) ? tr : hA;
          return R(f, At(y, 3));
        }
        function T7(f, y, R, F) {
          return f == null ? [] : (zt(y) || (y = y == null ? [] : [y]), R = F ? n : R, zt(R) || (R = R == null ? [] : [R]), gA(f, y, R));
        }
        var x7 = Wy(function(f, y, R) {
          f[R ? 0 : 1].push(y);
        }, function() {
          return [[], []];
        });
        function S7(f, y, R) {
          var F = zt(f) ? fw : $R, $ = arguments.length < 3;
          return F(f, At(y, 4), R, $, Bl);
        }
        function R7(f, y, R) {
          var F = zt(f) ? BX : $R, $ = arguments.length < 3;
          return F(f, At(y, 4), R, $, aA);
        }
        function A7(f, y) {
          var R = zt(f) ? Il : iA;
          return R(f, eg(At(y, 3)));
        }
        function D7(f) {
          var y = zt(f) ? nA : wW;
          return y(f);
        }
        function E7(f, y, R) {
          (R ? qo(f, y, R) : y === n) ? y = 1 : y = Jt(y);
          var F = zt(f) ? K$ : bW;
          return F(f, y);
        }
        function M7(f) {
          var y = zt(f) ? Z$ : TW;
          return y(f);
        }
        function P7(f) {
          if (f == null)
            return 0;
          if (ds(f))
            return ng(f) ? ld(f) : f.length;
          var y = Io(f);
          return y == ze || y == On ? f.size : Ow(f).length;
        }
        function C7(f, y, R) {
          var F = zt(f) ? mw : xW;
          return R && qo(f, y, R) && (y = n), F(f, At(y, 3));
        }
        var O7 = rn(function(f, y) {
          if (f == null)
            return [];
          var R = y.length;
          return R > 1 && qo(f, y[0], y[1]) ? y = [] : R > 2 && qo(y[0], y[1], y[2]) && (y = [y[0]]), gA(f, xo(y, 1), []);
        }), Zy = h$ || function() {
          return Ye.Date.now();
        };
        function I7(f, y) {
          if (typeof y != "function")
            throw new ma(i);
          return f = Jt(f), function() {
            if (--f < 1)
              return y.apply(this, arguments);
          };
        }
        function pD(f, y, R) {
          return y = R ? n : y, y = f && y == null ? f.length : y, Ou(f, M, n, n, n, n, y);
        }
        function dD(f, y) {
          var R;
          if (typeof y != "function")
            throw new ma(i);
          return f = Jt(f), function() {
            return --f > 0 && (R = y.apply(this, arguments)), f <= 1 && (y = n), R;
          };
        }
        var r1 = rn(function(f, y, R) {
          var F = _;
          if (R.length) {
            var $ = Nl(R, gd(r1));
            F |= A;
          }
          return Ou(f, F, y, R, $);
        }), hD = rn(function(f, y, R) {
          var F = _ | b;
          if (R.length) {
            var $ = Nl(R, gd(hD));
            F |= A;
          }
          return Ou(y, F, f, R, $);
        });
        function fD(f, y, R) {
          y = R ? n : y;
          var F = Ou(f, S, n, n, n, n, n, y);
          return F.placeholder = fD.placeholder, F;
        }
        function mD(f, y, R) {
          y = R ? n : y;
          var F = Ou(f, E, n, n, n, n, n, y);
          return F.placeholder = mD.placeholder, F;
        }
        function yD(f, y, R) {
          var F, $, ee, ce, he, be, Fe = 0, Le = !1, We = !1, nt = !0;
          if (typeof f != "function")
            throw new ma(i);
          y = wa(y) || 0, pr(R) && (Le = !!R.leading, We = "maxWait" in R, ee = We ? so(wa(R.maxWait) || 0, y) : ee, nt = "trailing" in R ? !!R.trailing : nt);
          function ht(Or) {
            var Za = F, Bu = $;
            return F = $ = n, Fe = Or, ce = f.apply(Bu, Za), ce;
          }
          function Dt(Or) {
            return Fe = Or, he = uf(an, y), Le ? ht(Or) : ce;
          }
          function tn(Or) {
            var Za = Or - be, Bu = Or - Fe, FD = y - Za;
            return We ? Oo(FD, ee - Bu) : FD;
          }
          function Et(Or) {
            var Za = Or - be, Bu = Or - Fe;
            return be === n || Za >= y || Za < 0 || We && Bu >= ee;
          }
          function an() {
            var Or = Zy();
            if (Et(Or))
              return mn(Or);
            he = uf(an, tn(Or));
          }
          function mn(Or) {
            return he = n, nt && F ? ht(Or) : (F = $ = n, ce);
          }
          function Ws() {
            he !== n && RA(he), Fe = 0, F = be = $ = he = n;
          }
          function Go() {
            return he === n ? ce : mn(Zy());
          }
          function Vs() {
            var Or = Zy(), Za = Et(Or);
            if (F = arguments, $ = this, be = Or, Za) {
              if (he === n)
                return Dt(be);
              if (We)
                return RA(he), he = uf(an, y), ht(be);
            }
            return he === n && (he = uf(an, y)), ce;
          }
          return Vs.cancel = Ws, Vs.flush = Go, Vs;
        }
        var F7 = rn(function(f, y) {
          return sA(f, 1, y);
        }), N7 = rn(function(f, y, R) {
          return sA(f, wa(y) || 0, R);
        });
        function L7(f) {
          return Ou(f, X);
        }
        function Jy(f, y) {
          if (typeof f != "function" || y != null && typeof y != "function")
            throw new ma(i);
          var R = function() {
            var F = arguments, $ = y ? y.apply(this, F) : F[0], ee = R.cache;
            if (ee.has($))
              return ee.get($);
            var ce = f.apply(this, F);
            return R.cache = ee.set($, ce) || ee, ce;
          };
          return R.cache = new (Jy.Cache || Pu)(), R;
        }
        Jy.Cache = Pu;
        function eg(f) {
          if (typeof f != "function")
            throw new ma(i);
          return function() {
            var y = arguments;
            switch (y.length) {
              case 0:
                return !f.call(this);
              case 1:
                return !f.call(this, y[0]);
              case 2:
                return !f.call(this, y[0], y[1]);
              case 3:
                return !f.call(this, y[0], y[1], y[2]);
            }
            return !f.apply(this, y);
          };
        }
        function B7(f) {
          return dD(2, f);
        }
        var U7 = SW(function(f, y) {
          y = y.length == 1 && zt(y[0]) ? tr(y[0], Us(At())) : tr(xo(y, 1), Us(At()));
          var R = y.length;
          return rn(function(F) {
            for (var $ = -1, ee = Oo(F.length, R); ++$ < ee; )
              F[$] = y[$].call(this, F[$]);
            return cr(f, this, F);
          });
        }), o1 = rn(function(f, y) {
          var R = Nl(y, gd(o1));
          return Ou(f, A, n, y, R);
        }), gD = rn(function(f, y) {
          var R = Nl(y, gd(gD));
          return Ou(f, C, n, y, R);
        }), X7 = Iu(function(f, y) {
          return Ou(f, L, n, n, n, y);
        });
        function $7(f, y) {
          if (typeof f != "function")
            throw new ma(i);
          return y = y === n ? y : Jt(y), rn(f, y);
        }
        function W7(f, y) {
          if (typeof f != "function")
            throw new ma(i);
          return y = y == null ? 0 : so(Jt(y), 0), rn(function(R) {
            var F = R[y], $ = $l(R, 0, y);
            return F && Fl($, F), cr(f, this, $);
          });
        }
        function V7(f, y, R) {
          var F = !0, $ = !0;
          if (typeof f != "function")
            throw new ma(i);
          return pr(R) && (F = "leading" in R ? !!R.leading : F, $ = "trailing" in R ? !!R.trailing : $), yD(f, y, {
            leading: F,
            maxWait: y,
            trailing: $
          });
        }
        function H7(f) {
          return pD(f, 1);
        }
        function j7(f, y) {
          return o1(Ww(y), f);
        }
        function z7() {
          if (!arguments.length)
            return [];
          var f = arguments[0];
          return zt(f) ? f : [f];
        }
        function q7(f) {
          return ga(f, h);
        }
        function G7(f, y) {
          return y = typeof y == "function" ? y : n, ga(f, h, y);
        }
        function Y7(f) {
          return ga(f, p | h);
        }
        function Q7(f, y) {
          return y = typeof y == "function" ? y : n, ga(f, p | h, y);
        }
        function K7(f, y) {
          return y == null || oA(f, y, fo(y));
        }
        function Ka(f, y) {
          return f === y || f !== f && y !== y;
        }
        var Z7 = zy(Mw), J7 = zy(function(f, y) {
          return f >= y;
        }), Gc = cA(/* @__PURE__ */ function() {
          return arguments;
        }()) ? cA : function(f) {
          return xr(f) && Cn.call(f, "callee") && !QR.call(f, "callee");
        }, zt = Ee.isArray, e9 = Tn ? Us(Tn) : uW;
        function ds(f) {
          return f != null && tg(f.length) && !Nu(f);
        }
        function Cr(f) {
          return xr(f) && ds(f);
        }
        function t9(f) {
          return f === !0 || f === !1 || xr(f) && zo(f) == Me;
        }
        var Wl = m$ || m1, n9 = lr ? Us(lr) : lW;
        function r9(f) {
          return xr(f) && f.nodeType === 1 && !lf(f);
        }
        function o9(f) {
          if (f == null)
            return !0;
          if (ds(f) && (zt(f) || typeof f == "string" || typeof f.splice == "function" || Wl(f) || vd(f) || Gc(f)))
            return !f.length;
          var y = Io(f);
          if (y == ze || y == On)
            return !f.size;
          if (af(f))
            return !Ow(f).length;
          for (var R in f)
            if (Cn.call(f, R))
              return !1;
          return !0;
        }
        function s9(f, y) {
          return rf(f, y);
        }
        function a9(f, y, R) {
          R = typeof R == "function" ? R : n;
          var F = R ? R(f, y) : n;
          return F === n ? rf(f, y, n, R) : !!F;
        }
        function s1(f) {
          if (!xr(f))
            return !1;
          var y = zo(f);
          return y == Ae || y == Te || typeof f.message == "string" && typeof f.name == "string" && !lf(f);
        }
        function i9(f) {
          return typeof f == "number" && ZR(f);
        }
        function Nu(f) {
          if (!pr(f))
            return !1;
          var y = zo(f);
          return y == we || y == $e || y == Ie || y == Xr;
        }
        function vD(f) {
          return typeof f == "number" && f == Jt(f);
        }
        function tg(f) {
          return typeof f == "number" && f > -1 && f % 1 == 0 && f <= Q;
        }
        function pr(f) {
          var y = typeof f;
          return f != null && (y == "object" || y == "function");
        }
        function xr(f) {
          return f != null && typeof f == "object";
        }
        var _D = Tr ? Us(Tr) : pW;
        function u9(f, y) {
          return f === y || Cw(f, y, Yw(y));
        }
        function l9(f, y, R) {
          return R = typeof R == "function" ? R : n, Cw(f, y, Yw(y), R);
        }
        function c9(f) {
          return wD(f) && f != +f;
        }
        function p9(f) {
          if (GW(f))
            throw new Wt(s);
          return pA(f);
        }
        function d9(f) {
          return f === null;
        }
        function h9(f) {
          return f == null;
        }
        function wD(f) {
          return typeof f == "number" || xr(f) && zo(f) == Ue;
        }
        function lf(f) {
          if (!xr(f) || zo(f) != Ot)
            return !1;
          var y = Dy(f);
          if (y === null)
            return !0;
          var R = Cn.call(y, "constructor") && y.constructor;
          return typeof R == "function" && R instanceof R && xy.call(R) == l$;
        }
        var a1 = ho ? Us(ho) : dW;
        function f9(f) {
          return vD(f) && f >= -Q && f <= Q;
        }
        var bD = Ol ? Us(Ol) : hW;
        function ng(f) {
          return typeof f == "string" || !zt(f) && xr(f) && zo(f) == sr;
        }
        function $s(f) {
          return typeof f == "symbol" || xr(f) && zo(f) == Hn;
        }
        var vd = ha ? Us(ha) : fW;
        function m9(f) {
          return f === n;
        }
        function y9(f) {
          return xr(f) && Io(f) == Eo;
        }
        function g9(f) {
          return xr(f) && zo(f) == aa;
        }
        var v9 = zy(Iw), _9 = zy(function(f, y) {
          return f <= y;
        });
        function kD(f) {
          if (!f)
            return [];
          if (ds(f))
            return ng(f) ? Ya(f) : ps(f);
          if (Yh && f[Yh])
            return KX(f[Yh]());
          var y = Io(f), R = y == ze ? bw : y == On ? by : _d;
          return R(f);
        }
        function Lu(f) {
          if (!f)
            return f === 0 ? f : 0;
          if (f = wa(f), f === Y || f === -Y) {
            var y = f < 0 ? -1 : 1;
            return y * ae;
          }
          return f === f ? f : 0;
        }
        function Jt(f) {
          var y = Lu(f), R = y % 1;
          return y === y ? R ? y - R : y : 0;
        }
        function TD(f) {
          return f ? Hc(Jt(f), 0, J) : 0;
        }
        function wa(f) {
          if (typeof f == "number")
            return f;
          if ($s(f))
            return Z;
          if (pr(f)) {
            var y = typeof f.valueOf == "function" ? f.valueOf() : f;
            f = pr(y) ? y + "" : y;
          }
          if (typeof f != "string")
            return f === 0 ? f : +f;
          f = WR(f);
          var R = Ha.test(f);
          return R || ua.test(f) ? Oe(f.slice(2), R ? 2 : 8) : Tu.test(f) ? Z : +f;
        }
        function xD(f) {
          return Bi(f, hs(f));
        }
        function w9(f) {
          return f ? Hc(Jt(f), -Q, Q) : f === 0 ? f : 0;
        }
        function Mn(f) {
          return f == null ? "" : Xs(f);
        }
        var b9 = md(function(f, y) {
          if (af(y) || ds(y)) {
            Bi(y, fo(y), f);
            return;
          }
          for (var R in y)
            Cn.call(y, R) && ef(f, R, y[R]);
        }), SD = md(function(f, y) {
          Bi(y, hs(y), f);
        }), rg = md(function(f, y, R, F) {
          Bi(y, hs(y), f, F);
        }), k9 = md(function(f, y, R, F) {
          Bi(y, fo(y), f, F);
        }), T9 = Iu(Aw);
        function x9(f, y) {
          var R = fd(f);
          return y == null ? R : rA(R, y);
        }
        var S9 = rn(function(f, y) {
          f = Xn(f);
          var R = -1, F = y.length, $ = F > 2 ? y[2] : n;
          for ($ && qo(y[0], y[1], $) && (F = 1); ++R < F; )
            for (var ee = y[R], ce = hs(ee), he = -1, be = ce.length; ++he < be; ) {
              var Fe = ce[he], Le = f[Fe];
              (Le === n || Ka(Le, pd[Fe]) && !Cn.call(f, Fe)) && (f[Fe] = ee[Fe]);
            }
          return f;
        }), R9 = rn(function(f) {
          return f.push(n, WA), cr(RD, n, f);
        });
        function A9(f, y) {
          return BR(f, At(y, 3), Li);
        }
        function D9(f, y) {
          return BR(f, At(y, 3), Ew);
        }
        function E9(f, y) {
          return f == null ? f : Dw(f, At(y, 3), hs);
        }
        function M9(f, y) {
          return f == null ? f : uA(f, At(y, 3), hs);
        }
        function P9(f, y) {
          return f && Li(f, At(y, 3));
        }
        function C9(f, y) {
          return f && Ew(f, At(y, 3));
        }
        function O9(f) {
          return f == null ? [] : By(f, fo(f));
        }
        function I9(f) {
          return f == null ? [] : By(f, hs(f));
        }
        function i1(f, y, R) {
          var F = f == null ? n : jc(f, y);
          return F === n ? R : F;
        }
        function F9(f, y) {
          return f != null && jA(f, y, oW);
        }
        function u1(f, y) {
          return f != null && jA(f, y, sW);
        }
        var N9 = LA(function(f, y, R) {
          y != null && typeof y.toString != "function" && (y = Sy.call(y)), f[y] = R;
        }, c1(fs)), L9 = LA(function(f, y, R) {
          y != null && typeof y.toString != "function" && (y = Sy.call(y)), Cn.call(f, y) ? f[y].push(R) : f[y] = [R];
        }, At), B9 = rn(nf);
        function fo(f) {
          return ds(f) ? tA(f) : Ow(f);
        }
        function hs(f) {
          return ds(f) ? tA(f, !0) : mW(f);
        }
        function U9(f, y) {
          var R = {};
          return y = At(y, 3), Li(f, function(F, $, ee) {
            Cu(R, y(F, $, ee), F);
          }), R;
        }
        function X9(f, y) {
          var R = {};
          return y = At(y, 3), Li(f, function(F, $, ee) {
            Cu(R, $, y(F, $, ee));
          }), R;
        }
        var $9 = md(function(f, y, R) {
          Uy(f, y, R);
        }), RD = md(function(f, y, R, F) {
          Uy(f, y, R, F);
        }), W9 = Iu(function(f, y) {
          var R = {};
          if (f == null)
            return R;
          var F = !1;
          y = tr(y, function(ee) {
            return ee = Xl(ee, f), F || (F = ee.length > 1), ee;
          }), Bi(f, qw(f), R), F && (R = ga(R, p | d | h, NW));
          for (var $ = y.length; $--; )
            Uw(R, y[$]);
          return R;
        });
        function V9(f, y) {
          return AD(f, eg(At(y)));
        }
        var H9 = Iu(function(f, y) {
          return f == null ? {} : gW(f, y);
        });
        function AD(f, y) {
          if (f == null)
            return {};
          var R = tr(qw(f), function(F) {
            return [F];
          });
          return y = At(y), vA(f, R, function(F, $) {
            return y(F, $[0]);
          });
        }
        function j9(f, y, R) {
          y = Xl(y, f);
          var F = -1, $ = y.length;
          for ($ || ($ = 1, f = n); ++F < $; ) {
            var ee = f == null ? n : f[Ui(y[F])];
            ee === n && (F = $, ee = R), f = Nu(ee) ? ee.call(f) : ee;
          }
          return f;
        }
        function z9(f, y, R) {
          return f == null ? f : of(f, y, R);
        }
        function q9(f, y, R, F) {
          return F = typeof F == "function" ? F : n, f == null ? f : of(f, y, R, F);
        }
        var DD = XA(fo), ED = XA(hs);
        function G9(f, y, R) {
          var F = zt(f), $ = F || Wl(f) || vd(f);
          if (y = At(y, 4), R == null) {
            var ee = f && f.constructor;
            $ ? R = F ? new ee() : [] : pr(f) ? R = Nu(ee) ? fd(Dy(f)) : {} : R = {};
          }
          return ($ ? fa : Li)(f, function(ce, he, be) {
            return y(R, ce, he, be);
          }), R;
        }
        function Y9(f, y) {
          return f == null ? !0 : Uw(f, y);
        }
        function Q9(f, y, R) {
          return f == null ? f : TA(f, y, Ww(R));
        }
        function K9(f, y, R, F) {
          return F = typeof F == "function" ? F : n, f == null ? f : TA(f, y, Ww(R), F);
        }
        function _d(f) {
          return f == null ? [] : ww(f, fo(f));
        }
        function Z9(f) {
          return f == null ? [] : ww(f, hs(f));
        }
        function J9(f, y, R) {
          return R === n && (R = y, y = n), R !== n && (R = wa(R), R = R === R ? R : 0), y !== n && (y = wa(y), y = y === y ? y : 0), Hc(wa(f), y, R);
        }
        function eH(f, y, R) {
          return y = Lu(y), R === n ? (R = y, y = 0) : R = Lu(R), f = wa(f), aW(f, y, R);
        }
        function tH(f, y, R) {
          if (R && typeof R != "boolean" && qo(f, y, R) && (y = R = n), R === n && (typeof y == "boolean" ? (R = y, y = n) : typeof f == "boolean" && (R = f, f = n)), f === n && y === n ? (f = 0, y = 1) : (f = Lu(f), y === n ? (y = f, f = 0) : y = Lu(y)), f > y) {
            var F = f;
            f = y, y = F;
          }
          if (R || f % 1 || y % 1) {
            var $ = JR();
            return Oo(f + $ * (y - f + Ne("1e-" + (($ + "").length - 1))), y);
          }
          return Nw(f, y);
        }
        var nH = yd(function(f, y, R) {
          return y = y.toLowerCase(), f + (R ? MD(y) : y);
        });
        function MD(f) {
          return l1(Mn(f).toLowerCase());
        }
        function PD(f) {
          return f = Mn(f), f && f.replace(er, zX).replace(Bs, "");
        }
        function rH(f, y, R) {
          f = Mn(f), y = Xs(y);
          var F = f.length;
          R = R === n ? F : Hc(Jt(R), 0, F);
          var $ = R;
          return R -= y.length, R >= 0 && f.slice(R, $) == y;
        }
        function oH(f) {
          return f = Mn(f), f && bt.test(f) ? f.replace(Ge, qX) : f;
        }
        function sH(f) {
          return f = Mn(f), f && Ns.test(f) ? f.replace(ia, "\\$&") : f;
        }
        var aH = yd(function(f, y, R) {
          return f + (R ? "-" : "") + y.toLowerCase();
        }), iH = yd(function(f, y, R) {
          return f + (R ? " " : "") + y.toLowerCase();
        }), uH = IA("toLowerCase");
        function lH(f, y, R) {
          f = Mn(f), y = Jt(y);
          var F = y ? ld(f) : 0;
          if (!y || F >= y)
            return f;
          var $ = (y - F) / 2;
          return jy(Cy($), R) + f + jy(Py($), R);
        }
        function cH(f, y, R) {
          f = Mn(f), y = Jt(y);
          var F = y ? ld(f) : 0;
          return y && F < y ? f + jy(y - F, R) : f;
        }
        function pH(f, y, R) {
          f = Mn(f), y = Jt(y);
          var F = y ? ld(f) : 0;
          return y && F < y ? jy(y - F, R) + f : f;
        }
        function dH(f, y, R) {
          return R || y == null ? y = 0 : y && (y = +y), _$(Mn(f).replace(Ls, ""), y || 0);
        }
        function hH(f, y, R) {
          return (R ? qo(f, y, R) : y === n) ? y = 1 : y = Jt(y), Lw(Mn(f), y);
        }
        function fH() {
          var f = arguments, y = Mn(f[0]);
          return f.length < 3 ? y : y.replace(f[1], f[2]);
        }
        var mH = yd(function(f, y, R) {
          return f + (R ? "_" : "") + y.toLowerCase();
        });
        function yH(f, y, R) {
          return R && typeof R != "number" && qo(f, y, R) && (y = R = n), R = R === n ? J : R >>> 0, R ? (f = Mn(f), f && (typeof y == "string" || y != null && !a1(y)) && (y = Xs(y), !y && ud(f)) ? $l(Ya(f), 0, R) : f.split(y, R)) : [];
        }
        var gH = yd(function(f, y, R) {
          return f + (R ? " " : "") + l1(y);
        });
        function vH(f, y, R) {
          return f = Mn(f), R = R == null ? 0 : Hc(Jt(R), 0, f.length), y = Xs(y), f.slice(R, R + y.length) == y;
        }
        function _H(f, y, R) {
          var F = K.templateSettings;
          R && qo(f, y, R) && (y = n), f = Mn(f), y = rg({}, y, F, $A);
          var $ = rg({}, y.imports, F.imports, $A), ee = fo($), ce = ww($, ee), he, be, Fe = 0, Le = y.interpolate || Pi, We = "__p += '", nt = kw(
            (y.escape || Pi).source + "|" + Le.source + "|" + (Le === Jn ? Po : Pi).source + "|" + (y.evaluate || Pi).source + "|$",
            "g"
          ), ht = "//# sourceURL=" + (Cn.call(y, "sourceURL") ? (y.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++Xc + "]") + `
`;
          f.replace(nt, function(Et, an, mn, Ws, Go, Vs) {
            return mn || (mn = Ws), We += f.slice(Fe, Vs).replace(Ci, GX), an && (he = !0, We += `' +
__e(` + an + `) +
'`), Go && (be = !0, We += `';
` + Go + `;
__p += '`), mn && (We += `' +
((__t = (` + mn + `)) == null ? '' : __t) +
'`), Fe = Vs + Et.length, Et;
          }), We += `';
`;
          var Dt = Cn.call(y, "variable") && y.variable;
          if (!Dt)
            We = `with (obj) {
` + We + `
}
`;
          else if (Va.test(Dt))
            throw new Wt(u);
          We = (be ? We.replace(Qt, "") : We).replace(It, "$1").replace(on, "$1;"), We = "function(" + (Dt || "obj") + `) {
` + (Dt ? "" : `obj || (obj = {});
`) + "var __t, __p = ''" + (he ? ", __e = _.escape" : "") + (be ? `, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
` : `;
`) + We + `return __p
}`;
          var tn = OD(function() {
            return Rn(ee, ht + "return " + We).apply(n, ce);
          });
          if (tn.source = We, s1(tn))
            throw tn;
          return tn;
        }
        function wH(f) {
          return Mn(f).toLowerCase();
        }
        function bH(f) {
          return Mn(f).toUpperCase();
        }
        function kH(f, y, R) {
          if (f = Mn(f), f && (R || y === n))
            return WR(f);
          if (!f || !(y = Xs(y)))
            return f;
          var F = Ya(f), $ = Ya(y), ee = VR(F, $), ce = HR(F, $) + 1;
          return $l(F, ee, ce).join("");
        }
        function TH(f, y, R) {
          if (f = Mn(f), f && (R || y === n))
            return f.slice(0, zR(f) + 1);
          if (!f || !(y = Xs(y)))
            return f;
          var F = Ya(f), $ = HR(F, Ya(y)) + 1;
          return $l(F, 0, $).join("");
        }
        function xH(f, y, R) {
          if (f = Mn(f), f && (R || y === n))
            return f.replace(Ls, "");
          if (!f || !(y = Xs(y)))
            return f;
          var F = Ya(f), $ = VR(F, Ya(y));
          return $l(F, $).join("");
        }
        function SH(f, y) {
          var R = te, F = B;
          if (pr(y)) {
            var $ = "separator" in y ? y.separator : $;
            R = "length" in y ? Jt(y.length) : R, F = "omission" in y ? Xs(y.omission) : F;
          }
          f = Mn(f);
          var ee = f.length;
          if (ud(f)) {
            var ce = Ya(f);
            ee = ce.length;
          }
          if (R >= ee)
            return f;
          var he = R - ld(F);
          if (he < 1)
            return F;
          var be = ce ? $l(ce, 0, he).join("") : f.slice(0, he);
          if ($ === n)
            return be + F;
          if (ce && (he += be.length - he), a1($)) {
            if (f.slice(he).search($)) {
              var Fe, Le = be;
              for ($.global || ($ = kw($.source, Mn(Un.exec($)) + "g")), $.lastIndex = 0; Fe = $.exec(Le); )
                var We = Fe.index;
              be = be.slice(0, We === n ? he : We);
            }
          } else if (f.indexOf(Xs($), he) != he) {
            var nt = be.lastIndexOf($);
            nt > -1 && (be = be.slice(0, nt));
          }
          return be + F;
        }
        function RH(f) {
          return f = Mn(f), f && ct.test(f) ? f.replace(Tt, t$) : f;
        }
        var AH = yd(function(f, y, R) {
          return f + (R ? " " : "") + y.toUpperCase();
        }), l1 = IA("toUpperCase");
        function CD(f, y, R) {
          return f = Mn(f), y = R ? n : y, y === n ? QX(f) ? o$(f) : $X(f) : f.match(y) || [];
        }
        var OD = rn(function(f, y) {
          try {
            return cr(f, n, y);
          } catch (R) {
            return s1(R) ? R : new Wt(R);
          }
        }), DH = Iu(function(f, y) {
          return fa(y, function(R) {
            R = Ui(R), Cu(f, R, r1(f[R], f));
          }), f;
        });
        function EH(f) {
          var y = f == null ? 0 : f.length, R = At();
          return f = y ? tr(f, function(F) {
            if (typeof F[1] != "function")
              throw new ma(i);
            return [R(F[0]), F[1]];
          }) : [], rn(function(F) {
            for (var $ = -1; ++$ < y; ) {
              var ee = f[$];
              if (cr(ee[0], this, F))
                return cr(ee[1], this, F);
            }
          });
        }
        function MH(f) {
          return tW(ga(f, p));
        }
        function c1(f) {
          return function() {
            return f;
          };
        }
        function PH(f, y) {
          return f == null || f !== f ? y : f;
        }
        var CH = NA(), OH = NA(!0);
        function fs(f) {
          return f;
        }
        function p1(f) {
          return dA(typeof f == "function" ? f : ga(f, p));
        }
        function IH(f) {
          return fA(ga(f, p));
        }
        function FH(f, y) {
          return mA(f, ga(y, p));
        }
        var NH = rn(function(f, y) {
          return function(R) {
            return nf(R, f, y);
          };
        }), LH = rn(function(f, y) {
          return function(R) {
            return nf(f, R, y);
          };
        });
        function d1(f, y, R) {
          var F = fo(y), $ = By(y, F);
          R == null && !(pr(y) && ($.length || !F.length)) && (R = y, y = f, f = this, $ = By(y, fo(y)));
          var ee = !(pr(R) && "chain" in R) || !!R.chain, ce = Nu(f);
          return fa($, function(he) {
            var be = y[he];
            f[he] = be, ce && (f.prototype[he] = function() {
              var Fe = this.__chain__;
              if (ee || Fe) {
                var Le = f(this.__wrapped__), We = Le.__actions__ = ps(this.__actions__);
                return We.push({ func: be, args: arguments, thisArg: f }), Le.__chain__ = Fe, Le;
              }
              return be.apply(f, Fl([this.value()], arguments));
            });
          }), f;
        }
        function BH() {
          return Ye._ === this && (Ye._ = c$), this;
        }
        function h1() {
        }
        function UH(f) {
          return f = Jt(f), rn(function(y) {
            return yA(y, f);
          });
        }
        var XH = Hw(tr), $H = Hw(LR), WH = Hw(mw);
        function ID(f) {
          return Kw(f) ? yw(Ui(f)) : vW(f);
        }
        function VH(f) {
          return function(y) {
            return f == null ? n : jc(f, y);
          };
        }
        var HH = BA(), jH = BA(!0);
        function f1() {
          return [];
        }
        function m1() {
          return !1;
        }
        function zH() {
          return {};
        }
        function qH() {
          return "";
        }
        function GH() {
          return !0;
        }
        function YH(f, y) {
          if (f = Jt(f), f < 1 || f > Q)
            return [];
          var R = J, F = Oo(f, J);
          y = At(y), f -= J;
          for (var $ = _w(F, y); ++R < f; )
            y(R);
          return $;
        }
        function QH(f) {
          return zt(f) ? tr(f, Ui) : $s(f) ? [f] : ps(eD(Mn(f)));
        }
        function KH(f) {
          var y = ++u$;
          return Mn(f) + y;
        }
        var ZH = Hy(function(f, y) {
          return f + y;
        }, 0), JH = jw("ceil"), ej = Hy(function(f, y) {
          return f / y;
        }, 1), tj = jw("floor");
        function nj(f) {
          return f && f.length ? Ly(f, fs, Mw) : n;
        }
        function rj(f, y) {
          return f && f.length ? Ly(f, At(y, 2), Mw) : n;
        }
        function oj(f) {
          return XR(f, fs);
        }
        function sj(f, y) {
          return XR(f, At(y, 2));
        }
        function aj(f) {
          return f && f.length ? Ly(f, fs, Iw) : n;
        }
        function ij(f, y) {
          return f && f.length ? Ly(f, At(y, 2), Iw) : n;
        }
        var uj = Hy(function(f, y) {
          return f * y;
        }, 1), lj = jw("round"), cj = Hy(function(f, y) {
          return f - y;
        }, 0);
        function pj(f) {
          return f && f.length ? vw(f, fs) : 0;
        }
        function dj(f, y) {
          return f && f.length ? vw(f, At(y, 2)) : 0;
        }
        return K.after = I7, K.ary = pD, K.assign = b9, K.assignIn = SD, K.assignInWith = rg, K.assignWith = k9, K.at = T9, K.before = dD, K.bind = r1, K.bindAll = DH, K.bindKey = hD, K.castArray = z7, K.chain = uD, K.chunk = tV, K.compact = nV, K.concat = rV, K.cond = EH, K.conforms = MH, K.constant = c1, K.countBy = p7, K.create = x9, K.curry = fD, K.curryRight = mD, K.debounce = yD, K.defaults = S9, K.defaultsDeep = R9, K.defer = F7, K.delay = N7, K.difference = oV, K.differenceBy = sV, K.differenceWith = aV, K.drop = iV, K.dropRight = uV, K.dropRightWhile = lV, K.dropWhile = cV, K.fill = pV, K.filter = h7, K.flatMap = y7, K.flatMapDeep = g7, K.flatMapDepth = v7, K.flatten = oD, K.flattenDeep = dV, K.flattenDepth = hV, K.flip = L7, K.flow = CH, K.flowRight = OH, K.fromPairs = fV, K.functions = O9, K.functionsIn = I9, K.groupBy = _7, K.initial = yV, K.intersection = gV, K.intersectionBy = vV, K.intersectionWith = _V, K.invert = N9, K.invertBy = L9, K.invokeMap = b7, K.iteratee = p1, K.keyBy = k7, K.keys = fo, K.keysIn = hs, K.map = Ky, K.mapKeys = U9, K.mapValues = X9, K.matches = IH, K.matchesProperty = FH, K.memoize = Jy, K.merge = $9, K.mergeWith = RD, K.method = NH, K.methodOf = LH, K.mixin = d1, K.negate = eg, K.nthArg = UH, K.omit = W9, K.omitBy = V9, K.once = B7, K.orderBy = T7, K.over = XH, K.overArgs = U7, K.overEvery = $H, K.overSome = WH, K.partial = o1, K.partialRight = gD, K.partition = x7, K.pick = H9, K.pickBy = AD, K.property = ID, K.propertyOf = VH, K.pull = TV, K.pullAll = aD, K.pullAllBy = xV, K.pullAllWith = SV, K.pullAt = RV, K.range = HH, K.rangeRight = jH, K.rearg = X7, K.reject = A7, K.remove = AV, K.rest = $7, K.reverse = t1, K.sampleSize = E7, K.set = z9, K.setWith = q9, K.shuffle = M7, K.slice = DV, K.sortBy = O7, K.sortedUniq = FV, K.sortedUniqBy = NV, K.split = yH, K.spread = W7, K.tail = LV, K.take = BV, K.takeRight = UV, K.takeRightWhile = XV, K.takeWhile = $V, K.tap = n7, K.throttle = V7, K.thru = Qy, K.toArray = kD, K.toPairs = DD, K.toPairsIn = ED, K.toPath = QH, K.toPlainObject = xD, K.transform = G9, K.unary = H7, K.union = WV, K.unionBy = VV, K.unionWith = HV, K.uniq = jV, K.uniqBy = zV, K.uniqWith = qV, K.unset = Y9, K.unzip = n1, K.unzipWith = iD, K.update = Q9, K.updateWith = K9, K.values = _d, K.valuesIn = Z9, K.without = GV, K.words = CD, K.wrap = j7, K.xor = YV, K.xorBy = QV, K.xorWith = KV, K.zip = ZV, K.zipObject = JV, K.zipObjectDeep = e7, K.zipWith = t7, K.entries = DD, K.entriesIn = ED, K.extend = SD, K.extendWith = rg, d1(K, K), K.add = ZH, K.attempt = OD, K.camelCase = nH, K.capitalize = MD, K.ceil = JH, K.clamp = J9, K.clone = q7, K.cloneDeep = Y7, K.cloneDeepWith = Q7, K.cloneWith = G7, K.conformsTo = K7, K.deburr = PD, K.defaultTo = PH, K.divide = ej, K.endsWith = rH, K.eq = Ka, K.escape = oH, K.escapeRegExp = sH, K.every = d7, K.find = f7, K.findIndex = nD, K.findKey = A9, K.findLast = m7, K.findLastIndex = rD, K.findLastKey = D9, K.floor = tj, K.forEach = lD, K.forEachRight = cD, K.forIn = E9, K.forInRight = M9, K.forOwn = P9, K.forOwnRight = C9, K.get = i1, K.gt = Z7, K.gte = J7, K.has = F9, K.hasIn = u1, K.head = sD, K.identity = fs, K.includes = w7, K.indexOf = mV, K.inRange = eH, K.invoke = B9, K.isArguments = Gc, K.isArray = zt, K.isArrayBuffer = e9, K.isArrayLike = ds, K.isArrayLikeObject = Cr, K.isBoolean = t9, K.isBuffer = Wl, K.isDate = n9, K.isElement = r9, K.isEmpty = o9, K.isEqual = s9, K.isEqualWith = a9, K.isError = s1, K.isFinite = i9, K.isFunction = Nu, K.isInteger = vD, K.isLength = tg, K.isMap = _D, K.isMatch = u9, K.isMatchWith = l9, K.isNaN = c9, K.isNative = p9, K.isNil = h9, K.isNull = d9, K.isNumber = wD, K.isObject = pr, K.isObjectLike = xr, K.isPlainObject = lf, K.isRegExp = a1, K.isSafeInteger = f9, K.isSet = bD, K.isString = ng, K.isSymbol = $s, K.isTypedArray = vd, K.isUndefined = m9, K.isWeakMap = y9, K.isWeakSet = g9, K.join = wV, K.kebabCase = aH, K.last = _a, K.lastIndexOf = bV, K.lowerCase = iH, K.lowerFirst = uH, K.lt = v9, K.lte = _9, K.max = nj, K.maxBy = rj, K.mean = oj, K.meanBy = sj, K.min = aj, K.minBy = ij, K.stubArray = f1, K.stubFalse = m1, K.stubObject = zH, K.stubString = qH, K.stubTrue = GH, K.multiply = uj, K.nth = kV, K.noConflict = BH, K.noop = h1, K.now = Zy, K.pad = lH, K.padEnd = cH, K.padStart = pH, K.parseInt = dH, K.random = tH, K.reduce = S7, K.reduceRight = R7, K.repeat = hH, K.replace = fH, K.result = j9, K.round = lj, K.runInContext = _e, K.sample = D7, K.size = P7, K.snakeCase = mH, K.some = C7, K.sortedIndex = EV, K.sortedIndexBy = MV, K.sortedIndexOf = PV, K.sortedLastIndex = CV, K.sortedLastIndexBy = OV, K.sortedLastIndexOf = IV, K.startCase = gH, K.startsWith = vH, K.subtract = cj, K.sum = pj, K.sumBy = dj, K.template = _H, K.times = YH, K.toFinite = Lu, K.toInteger = Jt, K.toLength = TD, K.toLower = wH, K.toNumber = wa, K.toSafeInteger = w9, K.toString = Mn, K.toUpper = bH, K.trim = kH, K.trimEnd = TH, K.trimStart = xH, K.truncate = SH, K.unescape = RH, K.uniqueId = KH, K.upperCase = AH, K.upperFirst = l1, K.each = lD, K.eachRight = cD, K.first = sD, d1(K, function() {
          var f = {};
          return Li(K, function(y, R) {
            Cn.call(K.prototype, R) || (f[R] = y);
          }), f;
        }(), { chain: !1 }), K.VERSION = r, fa(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(f) {
          K[f].placeholder = K;
        }), fa(["drop", "take"], function(f, y) {
          pn.prototype[f] = function(R) {
            R = R === n ? 1 : so(Jt(R), 0);
            var F = this.__filtered__ && !y ? new pn(this) : this.clone();
            return F.__filtered__ ? F.__takeCount__ = Oo(R, F.__takeCount__) : F.__views__.push({
              size: Oo(R, J),
              type: f + (F.__dir__ < 0 ? "Right" : "")
            }), F;
          }, pn.prototype[f + "Right"] = function(R) {
            return this.reverse()[f](R).reverse();
          };
        }), fa(["filter", "map", "takeWhile"], function(f, y) {
          var R = y + 1, F = R == ne || R == V;
          pn.prototype[f] = function($) {
            var ee = this.clone();
            return ee.__iteratees__.push({
              iteratee: At($, 3),
              type: R
            }), ee.__filtered__ = ee.__filtered__ || F, ee;
          };
        }), fa(["head", "last"], function(f, y) {
          var R = "take" + (y ? "Right" : "");
          pn.prototype[f] = function() {
            return this[R](1).value()[0];
          };
        }), fa(["initial", "tail"], function(f, y) {
          var R = "drop" + (y ? "" : "Right");
          pn.prototype[f] = function() {
            return this.__filtered__ ? new pn(this) : this[R](1);
          };
        }), pn.prototype.compact = function() {
          return this.filter(fs);
        }, pn.prototype.find = function(f) {
          return this.filter(f).head();
        }, pn.prototype.findLast = function(f) {
          return this.reverse().find(f);
        }, pn.prototype.invokeMap = rn(function(f, y) {
          return typeof f == "function" ? new pn(this) : this.map(function(R) {
            return nf(R, f, y);
          });
        }), pn.prototype.reject = function(f) {
          return this.filter(eg(At(f)));
        }, pn.prototype.slice = function(f, y) {
          f = Jt(f);
          var R = this;
          return R.__filtered__ && (f > 0 || y < 0) ? new pn(R) : (f < 0 ? R = R.takeRight(-f) : f && (R = R.drop(f)), y !== n && (y = Jt(y), R = y < 0 ? R.dropRight(-y) : R.take(y - f)), R);
        }, pn.prototype.takeRightWhile = function(f) {
          return this.reverse().takeWhile(f).reverse();
        }, pn.prototype.toArray = function() {
          return this.take(J);
        }, Li(pn.prototype, function(f, y) {
          var R = /^(?:filter|find|map|reject)|While$/.test(y), F = /^(?:head|last)$/.test(y), $ = K[F ? "take" + (y == "last" ? "Right" : "") : y], ee = F || /^find/.test(y);
          $ && (K.prototype[y] = function() {
            var ce = this.__wrapped__, he = F ? [1] : arguments, be = ce instanceof pn, Fe = he[0], Le = be || zt(ce), We = function(an) {
              var mn = $.apply(K, Fl([an], he));
              return F && nt ? mn[0] : mn;
            };
            Le && R && typeof Fe == "function" && Fe.length != 1 && (be = Le = !1);
            var nt = this.__chain__, ht = !!this.__actions__.length, Dt = ee && !nt, tn = be && !ht;
            if (!ee && Le) {
              ce = tn ? ce : new pn(this);
              var Et = f.apply(ce, he);
              return Et.__actions__.push({ func: Qy, args: [We], thisArg: n }), new ya(Et, nt);
            }
            return Dt && tn ? f.apply(this, he) : (Et = this.thru(We), Dt ? F ? Et.value()[0] : Et.value() : Et);
          });
        }), fa(["pop", "push", "shift", "sort", "splice", "unshift"], function(f) {
          var y = ky[f], R = /^(?:push|sort|unshift)$/.test(f) ? "tap" : "thru", F = /^(?:pop|shift)$/.test(f);
          K.prototype[f] = function() {
            var $ = arguments;
            if (F && !this.__chain__) {
              var ee = this.value();
              return y.apply(zt(ee) ? ee : [], $);
            }
            return this[R](function(ce) {
              return y.apply(zt(ce) ? ce : [], $);
            });
          };
        }), Li(pn.prototype, function(f, y) {
          var R = K[y];
          if (R) {
            var F = R.name + "";
            Cn.call(hd, F) || (hd[F] = []), hd[F].push({ name: y, func: R });
          }
        }), hd[Vy(n, b).name] = [{
          name: "wrapper",
          func: n
        }], pn.prototype.clone = R$, pn.prototype.reverse = A$, pn.prototype.value = D$, K.prototype.at = r7, K.prototype.chain = o7, K.prototype.commit = s7, K.prototype.next = a7, K.prototype.plant = u7, K.prototype.reverse = l7, K.prototype.toJSON = K.prototype.valueOf = K.prototype.value = c7, K.prototype.first = K.prototype.head, Yh && (K.prototype[Yh] = i7), K;
      }, cd = s$();
      Ft ? ((Ft.exports = cd)._ = cd, et._ = cd) : Ye._ = cd;
    }).call(yse);
  }(Of, Of.exports)), Of.exports;
}
var hu = gse();
function OBe(t) {
  const e = ge(t);
  return {
    schema: D(() => {
      const r = hu.merge({}, e.value);
      return r.required = [], ye.map("SchemaResponse", r, "Schema");
    })
  };
}
function IBe(t, e) {
  return D(() => e.value ? t : void 0);
}
function kN(t = {}, e) {
  const n = Se(), r = Ke(), s = xe(() => {
    if (!r.read.flow_run)
      return null;
    const m = Qe(t);
    return m ? [$t({}, m)] : null;
  }), i = xt(n.flowRuns.getFlowRunsPaginated, s, e), u = D(() => i.response?.results ?? []), l = D(() => i.response?.pages ?? 0), a = D(() => i.response?.limit ?? 0), c = D(() => i.response?.count ?? 0), p = D(() => i.response?.page ?? 1), d = D(() => i.error), h = D(() => i.errored);
  return {
    subscription: i,
    flowRuns: u,
    pages: l,
    page: p,
    limit: a,
    count: c,
    error: d,
    errored: h
  };
}
function FBe(t = {}, e) {
  const n = Se(), r = Ke(), s = xe(() => {
    if (!r.read.task_run)
      return null;
    const d = Qe(t);
    return d ? [$t({}, d)] : null;
  }), i = xt(n.taskRuns.getTaskRunsPaginated, s, e), u = D(() => i.response?.results ?? []), l = D(() => i.response?.pages ?? 0), a = D(() => i.response?.limit ?? 0), c = D(() => i.response?.count ?? 0), p = D(() => i.response?.page ?? 1);
  return {
    subscription: i,
    taskRuns: u,
    pages: l,
    page: p,
    limit: a,
    count: c
  };
}
function NBe(t, e = {}, n) {
  const r = Se(), o = Ke(), i = xe(() => {
    if (!o.read.work_pool)
      return null;
    const h = Qe(e), m = Qe(t);
    return h ? [m, $t({}, h)] : null;
  }), u = xt(r.workPoolWorkers.getWorkersPaginated, i, n), l = D(() => u.response?.workers ?? []), a = D(() => u.response?.pages ?? 0), c = D(() => u.response?.limit ?? 0), p = D(() => u.response?.count ?? 0), d = D(() => u.response?.page ?? 1);
  return {
    subscription: u,
    workers: l,
    pages: a,
    page: d,
    limit: c,
    count: p
  };
}
function pm(t) {
  if (typeof t == "object") {
    if (Xe(t))
      return v(t);
    if (S8(t))
      return vse(t);
    if (wn(t))
      return _se(t);
  }
  return t;
}
function vse(t) {
  return t.map((e) => pm(e));
}
function _se(t) {
  return Ds(t, (e, n) => pm(n));
}
function wse(...[t, e, n]) {
  let r = pm(t);
  return Ct(t, (...o) => {
    const s = pm(t);
    hu.isEqual(r, s) || (r = s, e(...o));
  }, n);
}
function k2(...[t, e, n = {}]) {
  const r = lt([]), o = e ?? [], s = ge(0), i = Qj(o);
  let u;
  const l = D(() => r.some((S) => S.loading)), a = D(() => r.some((S) => S.errored)), c = D(() => r.length ? r[0].error : void 0), p = D(() => r.some((S) => S.executed)), d = D(() => r.flatMap((S) => S.response ?? [])), h = D(() => r.some((S) => S.paused)), m = D(() => r.some((S) => S.late)), g = () => {
    r.forEach((S) => S.unsubscribe());
  }, _ = async () => {
    const S = r.map((E) => E.refresh());
    await Promise.all(S);
  }, b = () => r.every((S) => S.isSubscribed()), x = () => {
    const [S] = Kj(o), E = S.limit ?? 200;
    if (r.length * E > d.value.length)
      return;
    const A = (S.offset ?? E) * s.value, C = [{ ...S, offset: A, limit: E }], M = mt(t, C, n);
    r.push(lt(M)), s.value++;
  };
  return i !== null && (u = wse(i, () => {
    if (!b()) {
      u();
      return;
    }
    s.value = 0, g(), r.splice(0), x();
  }, { deep: !0 })), RI() && Em(() => {
    g(), u && u();
  }), lt({
    loading: l,
    executed: p,
    errored: a,
    error: c,
    response: d,
    paused: h,
    late: m,
    unsubscribe: g,
    refresh: _,
    isSubscribed: b,
    loadMore: x
  });
}
function bse(t, ...[e, n, r = {}]) {
  const o = Rs(e, n, {
    ...r,
    initialValue: t
  }), { value: s } = o;
  return Ct(s, (i) => t.value = i), Ct(t, (i) => {
    i !== s.value && (s.value = i);
  }), o;
}
function T2(t, ...[e = {}]) {
  const n = Mc({
    ...e
  });
  return Ct(() => n.values, (r) => {
    t.value = { ...r };
  }, { deep: !0 }), Ct(t, (r) => {
    JSON.stringify(r) !== JSON.stringify(n.values) && n.setValues(r);
  }), n;
}
function LBe(t, e) {
  const n = ge(t), r = ge(e), o = () => {
    !n.value || !r.value || (r.value.scrollTop = n.value.scrollTop, r.value.scrollLeft = n.value.scrollLeft);
  }, s = () => {
    n.value && n.value.addEventListener("scroll", o);
  }, i = () => {
    n.value && n.value.removeEventListener("scroll", o);
  };
  return wi(s), Em(i), {
    disconnect: i,
    source: n,
    target: r
  };
}
function St() {
  const t = ge(!1), e = D(() => t.value);
  function n() {
    t.value = !0;
  }
  function r() {
    t.value = !1;
  }
  function o() {
    t.value = !t.value;
  }
  return { isOpen: e, showModal: t, open: n, close: r, toggle: o };
}
const GE = ["Pending", "Running"];
function x2(t, e = 5e3) {
  const n = ge(t), r = D(() => {
    const o = n.value;
    return o === null ? !1 : typeof o == "object" ? GE.includes(o.stateName) : GE.includes(o);
  });
  return D(() => ({
    interval: r.value ? e : void 0
  }));
}
function BBe(t, e) {
  const n = ge(t), r = D(() => n.value.filter((i) => i.hidden !== !0).map((i) => i.label)), o = D(() => r.value.at(0)), s = ge(e ?? o.value);
  return Ct(r, (i) => {
    const u = s.value;
    u !== void 0 && (i.includes(u) || (s.value = o.value));
  }, { immediate: !0 }), {
    tabs: r,
    tab: s
  };
}
function Kp(t, e) {
  const n = Se(), r = Ke(), s = xe(() => {
    if (!r.read.task_run)
      return null;
    const l = Qe(t);
    return l ? [l] : null;
  }), i = xt(n.taskRuns.getTaskRun, s, e), u = D(() => i.response);
  return {
    subscription: i,
    taskRun: u
  };
}
function UBe(t) {
  const e = D(() => Qe(t)?.stateType);
  vN(e);
}
function kse(t) {
  const e = Se(), n = Ke(), o = xe(() => {
    if (!n.read.artifact)
      return null;
    const u = Qe(t);
    return u ? [{
      artifacts: {
        taskRunId: [u],
        type: ["result"]
      }
    }] : null;
  }), s = xt(e.artifacts.getArtifacts, o), i = D(() => s.response?.[0]);
  return {
    subscription: s,
    result: i
  };
}
function Tse(t, e) {
  const n = Se(), r = Ke(), s = xe(() => {
    if (!r.read.task_run)
      return null;
    const l = Qe(t);
    return l ? [l] : null;
  }), i = xt(n.taskRuns.getTaskRuns, s, e), u = D(() => i.response ?? []);
  return {
    subscription: i,
    taskRuns: u
  };
}
function hp(t, e) {
  const n = Se(), r = Ke(), s = xe(() => {
    if (!r.read.task_run)
      return null;
    const l = Qe(t);
    if (!l)
      return null;
    const a = xse(l);
    return [$t({}, a, l)];
  }), i = xt(n.taskRuns.getTaskRunsCount, s, e), u = D(() => i.response);
  return {
    subscription: i,
    count: u
  };
}
function xse(t) {
  return "subFlowRunsExist" in (t.taskRuns ?? {}) ? {} : {
    taskRuns: {
      subFlowRunsExist: !1
    }
  };
}
function XBe(t, e) {
  const n = Se(), r = Ke(), s = xe(() => {
    if (!r.read.task_run)
      return null;
    const l = Qe(t);
    if (!l)
      return null;
    const a = Sse(l);
    return [$t({}, a, l)];
  }), i = xt(n.ui.getTaskRunsCountByState, s, e), u = D(() => i.response);
  return {
    subscription: i,
    count: u
  };
}
function Sse(t) {
  return "subFlowRunsExist" in (t.taskRuns ?? {}) ? {} : {
    taskRuns: {
      subFlowRunsExist: !1
    }
  };
}
function Rse(t, e) {
  const n = Se(), r = Ke(), s = xe(() => {
    if (!r.read.task_run)
      return null;
    const l = Qe(t);
    return l ? [$t({}, l)] : null;
  }), i = xt(n.taskRuns.getTaskRunsHistory, s, e), u = D(() => i.response ?? []);
  return {
    subscription: i,
    history: u
  };
}
function Ase() {
  const { value: t } = dte(), e = Ej(), n = lt({});
  r(), Ct(t, () => r());
  function r() {
    requestAnimationFrame(() => {
      Object.assign(n, e, Dse());
    });
  }
  function o() {
    return SI(n);
  }
  return o;
}
const $Be = Ase();
function Dse() {
  const t = getComputedStyle(document.body);
  return {
    stateCompleted50: t.getPropertyValue("--state-completed-50"),
    stateCompleted100: t.getPropertyValue("--state-completed-100"),
    stateCompleted200: t.getPropertyValue("--state-completed-200"),
    stateCompleted300: t.getPropertyValue("--state-completed-300"),
    stateCompleted400: t.getPropertyValue("--state-completed-400"),
    stateCompleted500: t.getPropertyValue("--state-completed-500"),
    stateCompleted600: t.getPropertyValue("--state-completed-600"),
    stateCompleted700: t.getPropertyValue("--state-completed-700"),
    stateCompleted800: t.getPropertyValue("--state-completed-800"),
    stateCompleted900: t.getPropertyValue("--state-completed-900"),
    stateFailed50: t.getPropertyValue("--state-failed-50"),
    stateFailed100: t.getPropertyValue("--state-failed-100"),
    stateFailed200: t.getPropertyValue("--state-failed-200"),
    stateFailed300: t.getPropertyValue("--state-failed-300"),
    stateFailed400: t.getPropertyValue("--state-failed-400"),
    stateFailed500: t.getPropertyValue("--state-failed-500"),
    stateFailed600: t.getPropertyValue("--state-failed-600"),
    stateFailed700: t.getPropertyValue("--state-failed-700"),
    stateFailed800: t.getPropertyValue("--state-failed-800"),
    stateFailed900: t.getPropertyValue("--state-failed-900"),
    stateRunning50: t.getPropertyValue("--state-running-50"),
    stateRunning100: t.getPropertyValue("--state-running-100"),
    stateRunning200: t.getPropertyValue("--state-running-200"),
    stateRunning300: t.getPropertyValue("--state-running-300"),
    stateRunning400: t.getPropertyValue("--state-running-400"),
    stateRunning500: t.getPropertyValue("--state-running-500"),
    stateRunning600: t.getPropertyValue("--state-running-600"),
    stateRunning700: t.getPropertyValue("--state-running-700"),
    stateRunning800: t.getPropertyValue("--state-running-800"),
    stateRunning900: t.getPropertyValue("--state-running-900"),
    statePending50: t.getPropertyValue("--state-pending-50"),
    statePending100: t.getPropertyValue("--state-pending-100"),
    statePending200: t.getPropertyValue("--state-pending-200"),
    statePending300: t.getPropertyValue("--state-pending-300"),
    statePending400: t.getPropertyValue("--state-pending-400"),
    statePending500: t.getPropertyValue("--state-pending-500"),
    statePending600: t.getPropertyValue("--state-pending-600"),
    statePending700: t.getPropertyValue("--state-pending-700"),
    statePending800: t.getPropertyValue("--state-pending-800"),
    statePending900: t.getPropertyValue("--state-pending-900"),
    statePaused50: t.getPropertyValue("--state-paused-50"),
    statePaused100: t.getPropertyValue("--state-paused-100"),
    statePaused200: t.getPropertyValue("--state-paused-200"),
    statePaused300: t.getPropertyValue("--state-paused-300"),
    statePaused400: t.getPropertyValue("--state-paused-400"),
    statePaused500: t.getPropertyValue("--state-paused-500"),
    statePaused600: t.getPropertyValue("--state-paused-600"),
    statePaused700: t.getPropertyValue("--state-paused-700"),
    statePaused800: t.getPropertyValue("--state-paused-800"),
    statePaused900: t.getPropertyValue("--state-paused-900"),
    stateScheduled50: t.getPropertyValue("--state-scheduled-50"),
    stateScheduled100: t.getPropertyValue("--state-scheduled-100"),
    stateScheduled200: t.getPropertyValue("--state-scheduled-200"),
    stateScheduled300: t.getPropertyValue("--state-scheduled-300"),
    stateScheduled400: t.getPropertyValue("--state-scheduled-400"),
    stateScheduled500: t.getPropertyValue("--state-scheduled-500"),
    stateScheduled600: t.getPropertyValue("--state-scheduled-600"),
    stateScheduled700: t.getPropertyValue("--state-scheduled-700"),
    stateScheduled800: t.getPropertyValue("--state-scheduled-800"),
    stateScheduled900: t.getPropertyValue("--state-scheduled-900"),
    stateCancelled50: t.getPropertyValue("--state-cancelled-50"),
    stateCancelled100: t.getPropertyValue("--state-cancelled-100"),
    stateCancelled200: t.getPropertyValue("--state-cancelled-200"),
    stateCancelled300: t.getPropertyValue("--state-cancelled-300"),
    stateCancelled400: t.getPropertyValue("--state-cancelled-400"),
    stateCancelled500: t.getPropertyValue("--state-cancelled-500"),
    stateCancelled600: t.getPropertyValue("--state-cancelled-600"),
    stateCancelled700: t.getPropertyValue("--state-cancelled-700"),
    stateCancelled800: t.getPropertyValue("--state-cancelled-800"),
    stateCancelled900: t.getPropertyValue("--state-cancelled-900"),
    stateCrashed50: t.getPropertyValue("--state-crashed-50"),
    stateCrashed100: t.getPropertyValue("--state-crashed-100"),
    stateCrashed200: t.getPropertyValue("--state-crashed-200"),
    stateCrashed300: t.getPropertyValue("--state-crashed-300"),
    stateCrashed400: t.getPropertyValue("--state-crashed-400"),
    stateCrashed500: t.getPropertyValue("--state-crashed-500"),
    stateCrashed600: t.getPropertyValue("--state-crashed-600"),
    stateCrashed700: t.getPropertyValue("--state-crashed-700"),
    stateCrashed800: t.getPropertyValue("--state-crashed-800"),
    stateCrashed900: t.getPropertyValue("--state-crashed-900")
  };
}
function WBe(t) {
  const e = Se(), n = Ke(), o = xe(() => {
    if (!n.read.variable)
      return null;
    const u = Qe(t);
    return u ? [u] : null;
  }), s = xt(e.variables.getVariable, o), i = D(() => s.response);
  return {
    subscription: s,
    variable: i
  };
}
function TN(t, e) {
  const n = Se(), r = Ke(), o = () => {
    if (!r.read.variable)
      return null;
    const i = Qe(t);
    return Gt(i) ? [{}] : Array.isArray(i) ? i.length === 0 ? [{}] : [
      {
        variables: {
          id: i
        }
      }
    ] : [i];
  }, s = mN({
    fetchMethod: n.variables.getVariables,
    fetchParameters: o,
    countMethod: n.variables.getVariablesCount,
    countParameters: o,
    options: e
  });
  return {
    ...s,
    variables: s.results
  };
}
function VBe(t, e) {
  const n = Se(), r = Ke(), s = xe(() => {
    if (!r.read.worker)
      return null;
    const l = Qe(t), a = Qe(e);
    return !l || !a ? null : [l, a];
  }), i = xt(n.workPoolWorkers.getWorker, s), u = D(() => i.response);
  return {
    subscription: i,
    worker: u
  };
}
function Jm(t) {
  const e = Se(), n = Ke(), o = xe(() => {
    if (!n.read.work_pool)
      return null;
    const u = Qe(t);
    return u ? [u] : null;
  }), s = xt(e.workPools.getWorkPoolByName, o), i = D(() => s.response);
  return {
    subscription: s,
    workPool: i
  };
}
function xN(t) {
  const e = Se(), n = Ke(), o = xe(() => {
    if (!n.read.work_pool)
      return null;
    const u = Qe(t);
    return u ? [u] : null;
  }), s = xt(e.workPools.getWorkPoolById, o), i = D(() => s.response);
  return {
    subscription: s,
    workPool: i
  };
}
function SN(t, e) {
  const n = Se(), r = Ke(), { now: o } = gx({ interval: 1e3 }), i = xe(() => {
    if (!r.read.work_pool)
      return null;
    const p = Qe(t);
    return p ? [p] : null;
  }), u = xt(n.workPoolWorkers.getWorkers, i, e), l = D(() => u.response ?? []), a = D(() => {
    const p = l.value.map((d) => d.lastHeartbeatTime);
    return p.length === 0 ? null : Dx(p);
  }), c = D(() => {
    if (a.value !== null)
      return W3(a.value, o.value);
  });
  return {
    subscription: u,
    lastPolled: c
  };
}
function RN(t = {}) {
  const e = Se(), n = Ke(), o = xe(() => n.read.work_pool ? [Qe(t)] : null), s = xt(e.workPools.getWorkPoolsCount, o), i = D(() => s.response);
  return {
    subscription: s,
    workPoolCount: i
  };
}
function AN(t) {
  const e = Se(), n = Ke(), o = xe(() => {
    if (!n.read.flow_run)
      return null;
    const u = Qe(t);
    return u ? [u] : null;
  }), s = xt(e.workQueues.getWorkQueue, o), i = D(() => s.response);
  return {
    subscription: s,
    workPoolQueue: i
  };
}
function HBe(t) {
  const e = dn("tags", t.tags), n = gN(t.range), r = dn("hide-subflows", Yo, t.hideSubflows), o = D({
    get() {
      return n.range ?? t.range;
    },
    set(s) {
      n.range = s;
    }
  });
  return lt({
    range: o,
    tags: e,
    hideSubflows: r
  });
}
function jBe() {
  const t = dn("tag", []), e = dn("deployment", []), n = dn("workPool", []), r = dn("workQueue", []), o = dn("flow", []), s = dn("state", []), i = gN(), u = D({
    get() {
      return i.range ?? h_;
    },
    set(p) {
      i.range = p;
    }
  }), l = lt({
    range: u,
    tag: t,
    deployment: e,
    workPool: n,
    workQueue: r,
    flow: o,
    state: s
  }), a = D(() => d_(l, kF));
  function c(p) {
    u.value = p.range, t.value = p.tag ?? [], e.value = p.deployment ?? [], n.value = p.workPool ?? [], r.value = p.workQueue ?? [], o.value = p.flow ?? [], s.value = p.state ?? [];
  }
  return {
    filter: l,
    setFilter: c,
    isCustom: a
  };
}
function zBe(t) {
  return {
    automations: () => ({ name: "workspace.automations", params: { ...t } }),
    automation: (e) => ({ name: "workspace.automation.view", params: { ...t, automationId: e } }),
    automationCreate: (e) => {
      const n = ye.map("CreateAutomationQuery", e, "LocationQuery");
      return {
        name: "workspace.automation.create",
        params: { ...t },
        query: n
      };
    },
    automationEdit: (e) => ({ name: "workspace.automation.edit", params: { ...t, automationId: e } }),
    automateEvent: (e, n) => {
      const r = ye.map("CreateAutomationQuery", { from: "event", event: e, actions: n }, "LocationQuery");
      return {
        name: "workspace.automation.create",
        params: { ...t },
        query: r
      };
    },
    automateFlow: (e, n) => {
      const r = ye.map("CreateAutomationQuery", { from: "flow", flowId: e, actions: n }, "LocationQuery");
      return {
        name: "workspace.automation.create",
        params: { ...t },
        query: r
      };
    },
    automateWorkPool: (e, n) => {
      const r = ye.map("CreateAutomationQuery", { from: "workPool", workPoolId: e, actions: n }, "LocationQuery");
      return {
        name: "workspace.automation.create",
        params: { ...t },
        query: r
      };
    },
    automateWorkPoolQueue: (e, n) => {
      const r = ye.map("CreateAutomationQuery", { from: "workPoolQueue", workPoolQueueId: e, actions: n }, "LocationQuery");
      return {
        name: "workspace.automation.create",
        params: { ...t },
        query: r
      };
    },
    events: () => ({ name: "workspace.events" }),
    event: (e, n) => ({ name: "workspace.event", params: { eventId: e, eventDate: BJ(n) } }),
    artifact: (e) => ({ name: "workspace.artifacts.artifact", params: { artifactId: e, ...t } }),
    artifactKey: (e) => ({ name: "workspace.artifacts.artifact.key", params: { artifactKey: e, ...t } }),
    artifacts: () => ({ name: "workspace.artifacts", params: { ...t } }),
    dashboard: () => ({ name: "workspace.dashboard", params: { ...t } }),
    runs: (e) => ({ name: "workspace.runs", params: { ...t }, query: e }),
    /** @deprecated use workspace.runs instead */
    flowRuns: () => ({ name: "workspace.flow-runs", params: { ...t } }),
    flowRun: (e) => ({ name: "workspace.runs.flow-run", params: { flowRunId: e, ...t } }),
    taskRun: (e) => ({ name: "workspace.runs.task-run", params: { taskRunId: e, ...t } }),
    flows: () => ({ name: "workspace.flows", params: { ...t } }),
    flow: (e) => ({ name: "workspace.flows.flow", params: { flowId: e, ...t } }),
    flowCollections: () => ({ name: "workspace.flows.collections", params: { ...t } }),
    flowCollection: (e) => ({ name: "workspace.flows.collections.collection", params: { name: e, ...t } }),
    deployments: () => ({ name: "workspace.deployments", params: { ...t } }),
    deployment: (e, n, r) => ({ name: "workspace.deployments.deployment", params: { deploymentId: e, ...t }, query: { versionId: n, ...r } }),
    deploymentEdit: (e) => ({ name: "workspace.deployments.deployment-edit", params: { deploymentId: e, ...t } }),
    deploymentDuplicate: (e) => ({ name: "workspace.deployments.deployment-duplicate", params: { deploymentId: e, ...t } }),
    deploymentFlowRunCreate: (e, n) => {
      const r = n ? { parameters: encodeURIComponent(JSON.stringify(n)) } : {};
      return { name: "workspace.deployments.deployment-flow-run-create", params: { deploymentId: e, ...t }, query: r };
    },
    workQueues: () => ({ name: "workspace.work-queues", params: { ...t } }),
    workQueue: (e) => ({ name: "workspace.work-queues.work-queue", params: { workQueueId: e, ...t } }),
    workQueueCreate: () => ({ name: "workspace.work-queues.work-queue-create", params: { ...t } }),
    workQueueEdit: (e) => ({ name: "workspace.work-queues.work-queue-edit", params: { workQueueId: e, ...t } }),
    blocks: () => ({ name: "workspace.blocks", params: { ...t } }),
    blocksCatalog: () => ({ name: "workspace.blocks.catalog", params: { ...t } }),
    blocksCatalogView: (e) => ({ name: "workspace.blocks.catalog-view", params: { blockTypeSlug: e, ...t } }),
    blockCreate: (e) => ({ name: "workspace.blocks.block-create", params: { blockTypeSlug: e, ...t } }),
    block: (e) => ({ name: "workspace.blocks.block", params: { blockDocumentId: e, ...t } }),
    blockEdit: (e) => ({ name: "workspace.blocks.block-edit", params: { blockDocumentId: e, ...t } }),
    notifications: () => ({ name: "workspace.notifications", params: { ...t } }),
    notificationCreate: () => ({ name: "workspace.notifications.create", params: { ...t } }),
    notificationEdit: (e) => ({ name: "workspace.notifications.notification-edit", params: { notificationId: e, ...t } }),
    concurrencyLimit: (e) => ({ name: "workspace.concurrency-limits.concurrency-limit", params: { concurrencyLimitId: e, ...t } }),
    concurrencyLimits: () => ({ name: "workspace.concurrency-limits", params: { ...t } }),
    concurrencyLimitsV2: () => ({ name: "workspace.concurrency-limits-v2", params: { ...t } }),
    concurrencyLimitV2: (e) => ({ name: "workspace.concurrency-limits-v2.concurrency-limit", params: { concurrencyLimitId: e, ...t } }),
    variables: () => ({ name: "workspace.variables", params: { ...t } }),
    workPools: () => ({ name: "workspace.work-pools", params: { ...t } }),
    workPool: (e) => ({ name: "workspace.work-pools.work-pool", params: { workPoolName: e, ...t } }),
    workPoolCreate: () => ({ name: "workspace.work-pools.work-pool-create", params: { ...t } }),
    workPoolEdit: (e) => ({ name: "workspace.work-pools.work-pool-edit", params: { workPoolName: e, ...t } }),
    workPoolQueue: (e, n) => ({ name: "workspace.work-pools.work-pool.work-pool-queue", params: { workPoolName: e, workPoolQueueName: n, ...t } }),
    workPoolQueueCreate: (e) => ({ name: "workspace.work-pools.work-pool.work-pool-queue-create", params: { workPoolName: e, ...t } }),
    workPoolQueueEdit: (e, n) => ({ name: "workspace.work-pools.work-pool.work-pool-queue-edit", params: { workPoolName: e, workPoolQueueName: n, ...t } })
  };
}
const Ese = Symbol("WorkspaceRoutes");
function qBe(t) {
  return [
    {
      path: "dashboard",
      name: "workspace.dashboard",
      component: t.dashboard
    },
    {
      path: "runs",
      meta: {
        can: "read:flow_run"
      },
      children: [
        {
          name: "workspace.runs",
          path: "",
          component: () => import("./RunsPageWithDefaultFilter-CDapVdTS.js"),
          props: { component: t.runs }
        },
        {
          name: "workspace.runs.flow-run",
          path: "flow-run/:flowRunId",
          component: t.flowRun
        },
        {
          name: "workspace.runs.task-run",
          path: "task-run/:taskRunId",
          component: t.taskRun
        }
      ]
    },
    {
      path: "flow-runs",
      name: "workspace.flow-runs",
      redirect: (e) => ({ name: "workspace.runs", query: e.query, params: e.params }),
      children: [
        {
          name: "workspace.flow-runs.flow-run",
          path: "flow-run/:flowRunId",
          redirect: (e) => ({ name: "workspace.runs.flow-run", query: e.query, params: e.params })
        },
        {
          name: "workspace.flow-runs.task-run",
          path: "task-run/:taskRunId",
          redirect: (e) => ({ name: "workspace.runs.task-run", query: e.query, params: e.params })
        }
      ]
    },
    {
      path: "flows",
      meta: {
        can: "read:flow"
      },
      children: [
        {
          name: "workspace.flows",
          path: "",
          component: t.flows
        },
        {
          name: "workspace.flows.flow",
          path: "flow/:flowId",
          component: t.flow
        },
        {
          path: "collections",
          children: [
            {
              name: "workspace.flows.collections",
              path: "",
              component: t.flowCollections
            },
            {
              name: "workspace.flows.collections.collection",
              path: ":name",
              component: t.flowCollection
            }
          ]
        }
      ]
    },
    {
      path: "deployments",
      meta: {
        can: "read:deployment"
      },
      children: [
        {
          name: "workspace.deployments",
          path: "",
          component: t.deployments
        },
        {
          name: "workspace.deployments.deployment",
          path: "deployment/:deploymentId",
          component: t.deployment
        },
        {
          name: "workspace.deployments.deployment-edit",
          path: "deployment/:deploymentId/edit",
          component: t.deploymentEdit,
          meta: {
            can: "update:deployment"
          }
        },
        {
          name: "workspace.deployments.deployment-duplicate",
          path: "deployment/:deploymentId/duplicate",
          component: t.deploymentDuplicate,
          meta: {
            can: "create:deployment"
          }
        },
        {
          name: "workspace.deployments.deployment-flow-run-create",
          path: "deployment/:deploymentId/run",
          component: t.deploymentFlowRunCreate,
          meta: {
            can: "run:deployment"
          }
        }
      ]
    },
    {
      path: "work-queues",
      meta: {
        can: "read:work_queue"
      },
      children: [
        {
          name: "workspace.work-queues.work-queue",
          path: "work-queue/:workQueueId",
          component: t.workQueue ?? (() => import("./WorkQueueToWorkPoolQueueRedirect-L0NJih1T.js"))
        }
      ]
    },
    {
      path: "blocks",
      meta: {
        can: "read:block"
      },
      children: [
        {
          name: "workspace.blocks",
          path: "",
          component: t.blocks
        },
        {
          name: "workspace.blocks.catalog",
          path: "catalog",
          component: t.blocksCatalog,
          meta: {
            can: "create:block"
          }
        },
        {
          name: "workspace.blocks.catalog-view",
          path: "catalog/:blockTypeSlug",
          component: t.blocksCatalogView,
          meta: {
            can: "create:block"
          }
        },
        {
          name: "workspace.blocks.block-create",
          path: "catalog/:blockTypeSlug/create",
          component: t.blockCreate,
          meta: {
            can: "create:block"
          }
        },
        {
          name: "workspace.blocks.block",
          path: "block/:blockDocumentId",
          component: t.block
        },
        {
          name: "workspace.blocks.block-edit",
          path: "block/:blockDocumentId/edit",
          component: t.blockEdit,
          meta: {
            can: "update:block"
          }
        }
      ]
    },
    {
      path: "notifications",
      meta: {
        can: "read:notification_policy"
      },
      children: [
        {
          name: "workspace.notifications",
          path: "",
          component: t.notifications
        },
        {
          name: "workspace.notifications.create",
          path: "create",
          component: t.notificationCreate,
          meta: {
            can: "create:notification_policy"
          }
        },
        {
          name: "workspace.notifications.notification-edit",
          path: ":notificationId/edit",
          component: t.notificationEdit,
          meta: {
            can: "update:notification_policy"
          }
        }
      ]
    },
    {
      path: "concurrency-limits",
      meta: {
        can: "read:concurrency_limit"
      },
      children: [
        {
          name: "workspace.concurrency-limits",
          path: "",
          component: t.concurrencyLimits
        },
        {
          name: "workspace.concurrency-limits.concurrency-limit",
          path: "concurrency-limit/:concurrencyLimitId",
          component: t.concurrencyLimit
        }
      ]
    },
    {
      path: "concurrency-limits-v2",
      meta: {
        can: "read:concurrency_limit"
      },
      children: [
        {
          name: "workspace.concurrency-limits-v2",
          path: "",
          component: t.concurrencyLimitsV2
        },
        {
          name: "workspace.concurrency-limits-v2.concurrency-limit",
          path: "concurrency-limit-v2/:concurrencyLimitId",
          component: t.concurrencyLimitV2
        }
      ]
    },
    {
      path: "artifacts",
      children: [
        {
          name: "workspace.artifacts",
          path: "",
          component: t.artifacts
        },
        {
          name: "workspace.artifacts.artifact.key",
          path: "key/:artifactKey",
          component: t.artifactKey
        },
        {
          name: "workspace.artifacts.artifact",
          path: "artifact/:artifactId",
          component: t.artifact
        }
      ]
    },
    {
      name: "workspace.variables",
      path: "variables",
      meta: {
        can: "read:variable"
      },
      component: t.variables
    },
    {
      path: "work-pools",
      meta: {
        can: "read:work_pool"
      },
      children: [
        {
          name: "workspace.work-pools",
          path: "",
          component: t.workPools
        },
        {
          path: "work-pool/:workPoolName",
          children: [
            {
              name: "workspace.work-pools.work-pool",
              path: "",
              component: t.workPool
            },
            {
              name: "workspace.work-pools.work-pool.work-pool-queue",
              path: "queue/:workPoolQueueName",
              component: t.workPoolQueue,
              meta: {
                can: "read:work_queue"
              }
            },
            {
              name: "workspace.work-pools.work-pool.work-pool-queue-create",
              path: "queue/create",
              component: t.workPoolQueueCreate,
              meta: {
                can: "create:work_queue"
              }
            },
            {
              name: "workspace.work-pools.work-pool.work-pool-queue-edit",
              path: "queue/:workPoolQueueName/edit",
              component: t.workPoolQueueEdit,
              meta: {
                can: "update:work_queue"
              }
            }
          ]
        },
        {
          name: "workspace.work-pools.work-pool-create",
          path: "create",
          component: t.workPoolCreate,
          meta: {
            can: "create:work_pool"
          }
        },
        {
          name: "workspace.work-pools.work-pool-edit",
          path: "work-pool/:workPoolName/edit",
          component: t.workPoolEdit,
          meta: {
            can: "update:work_pool"
          }
        }
      ]
    },
    {
      path: "automations",
      meta: {
        can: "read:automation"
      },
      children: [
        {
          name: "workspace.automations",
          path: "",
          component: t.automations
        },
        {
          name: "workspace.automation.create",
          path: "create",
          component: t.automationCreate,
          meta: {
            can: "create:automation"
          }
        },
        {
          name: "workspace.automation.view",
          path: "automation/:automationId",
          component: t.automation
        },
        {
          name: "workspace.automation.edit",
          path: "automation/:automationId/edit",
          component: t.automationEdit,
          meta: {
            can: "update:automation"
          }
        }
      ]
    },
    {
      path: "events",
      children: [
        {
          name: "workspace.events",
          path: "",
          component: t.events,
          meta: {
            can: ["read:event"]
          }
        },
        {
          name: "workspace.event",
          path: "event/:eventDate/:eventId",
          component: t.event,
          meta: {
            can: "read:event"
          }
        }
      ]
    }
  ];
}
function je() {
  return p_(Ese);
}
function Mse(t, e) {
  const n = D(() => {
    const i = Qe(t), u = Qe(e);
    return !i || !u ? null : [i, u];
  }), r = Se(), o = xt(r.events.getEvent, n);
  return {
    event: D(() => o.response),
    subscription: o
  };
}
function Pse(t, e) {
  const n = Se(), o = xe(() => {
    const u = Qe(t);
    return u ? [$t({}, u)] : null;
  }), s = xt(n.events.getEvents, o, e), i = D(() => s.response?.events ?? []);
  return {
    subscription: s,
    events: i
  };
}
function GBe(t, e) {
  const n = ge(1), r = lt({}), o = Se(), s = D(() => [Qe(t)]), i = mt(o.events.getEvents, s, e), u = D(() => i.response), l = D(() => u.value?.pages), a = D(() => n.value <= 1 ? null : [r[n.value]]), c = xt(o.events.getNextPage, a), p = D(() => c.response), d = D(() => i.loading || c.loading), h = D(() => n.value === 1 ? u.value?.events ?? [] : p.value?.events ?? []), m = D(() => h.value.length === 0), g = D(() => u.value?.total ?? 0);
  return Ct(u, (_) => {
    _?.nextPageToken && (r[2] = _.nextPageToken);
  }), Ct(p, (_) => {
    _?.nextPageToken && (r[n.value + 1] = _.nextPageToken);
  }), {
    page: n,
    pages: l,
    loading: d,
    events: h,
    empty: m,
    count: g
  };
}
function Cs(t) {
  const e = D(() => Qe(t)["prefect.resource.id"]), n = D(() => r2(e.value)), r = D(() => n.value.id), o = D(() => n.value.role), s = D(() => n.value.type), i = D(() => {
    const u = Qe(t);
    return u["prefect.resource.name"] ?? u["prefect.name"] ?? u["prefect-cloud.name"] ?? null;
  });
  return {
    resourceId: e,
    id: r,
    role: o,
    type: s,
    name: i
  };
}
function YBe(t) {
  const e = ge(t);
  return Cs(e.value.resource);
}
const Cse = [
  0.01,
  0.025,
  0.05,
  0.075,
  0.1,
  0.25,
  0.5,
  0.75,
  1,
  2.5,
  5,
  7.5,
  10,
  25,
  50,
  75,
  100,
  250,
  500,
  750,
  1e3,
  2500,
  5e3,
  7500,
  1e4
], Ose = 15;
function Ise({
  startDate: t,
  endDate: e,
  container: n
}) {
  const r = ge(t), o = ge(e), s = ge(n), i = D(() => (o.value.getTime() - r.value.getTime()) / 1e3), { width: u } = UI(s), l = D(() => Math.max(1, Math.floor(u.value / Ose)));
  return {
    interval: D(() => {
      if (!s.value)
        return null;
      const c = i.value / l.value;
      return Cse.reduce((d, h) => Math.abs(h - c) < Math.abs(d - c) ? h : d);
    })
  };
}
function DN(t) {
  const e = ge(t.limit), n = ge(t.startDate), r = ge(t.endDate), o = ge(t.workspaces), s = ge(t.users), i = ge(t.events), u = ge(t.eventId);
  return D(() => {
    const { startDate: l, endDate: a } = ye.map("DateRangeSelectValue", { type: "span", seconds: -Ih }, "DateRange"), c = {
      occurred: {
        since: l,
        until: a
      }
    };
    if (e.value && (c.limit = e.value), n.value && (c.occurred.since = n.value), r.value && (c.occurred.until = r.value), o.value && (c.scope ??= {}, c.scope.workspace = o.value), s.value) {
      c.related ??= {};
      const p = ge([]);
      s.value.forEach((d) => p.value.push([d, "actor"])), c.related.resourcesInRoles = p.value, c.related.role = ["actor"];
    }
    return i.value && (c.event ??= {}, c.event.name = i.value), u.value && (c.id ??= {}, c.id.id = u.value), c;
  });
}
function QBe() {
  const t = rs(), e = kc(), n = qs(Gr.subDays(Gr.startOfToday(), 7)), r = dn("start-date", n), o = D({
    get() {
      return bE(r.value);
    },
    set(b) {
      r.value = qs(b);
    }
  }), s = qs(Gr.addDays(Gr.endOfToday(), 1)), i = dn("end-date", s), u = D({
    get() {
      return bE(i.value);
    },
    set(b) {
      i.value = qs(b);
    }
  }), l = dn("workspaces", []), a = dn("users", []), c = dn("events", []), p = DN({ startDate: o, endDate: u, workspaces: l, users: a, events: c }), d = D(() => !!l.value.length || !!a.value.length || !!c.value.length || r.value !== n || i.value !== s);
  function h(b) {
    const x = {};
    if (b.startDate) {
      const S = qs(b.startDate);
      S !== n && (x["start-date"] = S);
    }
    if (b.endDate) {
      const S = qs(b.endDate);
      S !== s && (x["end-date"] = S);
    }
    return x;
  }
  async function m(b) {
    const x = h(b);
    await t.push({ query: x });
  }
  async function g(b) {
    const x = h(b);
    await t.push({ query: { ...e.query, ...x } });
  }
  async function _() {
    await t.push({ query: {} });
  }
  return {
    startDate: o,
    endDate: u,
    workspaces: l,
    users: a,
    events: c,
    filter: p,
    hasFilters: d,
    setFilters: m,
    updateFilters: g,
    clearFilters: _
  };
}
function KBe(t) {
  const e = { ...t }, n = ge(e.startDate ? e.startDate : Gr.startOfToday()), r = ge(Gr.addDays(n.value, 1));
  return DN({ endDate: r, ...e });
}
function Fse(t, e) {
  const n = Se(), r = Ke(), s = xe(() => {
    if (!r.read.flow_run)
      return null;
    const l = Qe(t);
    return l ? [l] : null;
  }), i = xt(n.ui.getFlowRunTaskCount, s, e);
  return {
    count: D(() => i.response),
    subscription: i
  };
}
function EN(t, e) {
  const n = Se(), r = Ke(), s = xe(() => {
    if (!r.read.task_run)
      return null;
    const l = Qe(t);
    return l ? [$t({}, l)] : null;
  }), i = xt(n.workPools.getWorkPools, s, e), u = D(() => i.response ?? []);
  return {
    subscription: i,
    workPools: u
  };
}
function Nse(t, e) {
  const n = Se(), r = Ke(), s = xe(() => {
    if (!r.read.task_run)
      return null;
    const l = Qe(t);
    return l ? [$t({}, l)] : null;
  }), i = xt(n.workQueues.getWorkQueues, s, e), u = D(() => i.response ?? []);
  return {
    subscription: i,
    workQueues: u
  };
}
function MN(t) {
  const e = Se(), n = Ke(), r = D(() => {
    const i = Qe(t);
    return !i || !n.read.flow_run ? null : [i];
  }), o = xt(e.automations.getAutomation, r), s = D(() => o.response);
  return {
    subscription: o,
    automation: s
  };
}
const PN = Symbol();
function Zp() {
  return wte(PN);
}
const { values: ZBe, isValue: YE } = to([
  "none",
  "json",
  "jinja",
  "workspace_variable"
]);
function ey(t) {
  const e = Qe(t);
  return xa(e) ? e.__prefect_kind : "none";
}
function xa(t, e) {
  return wn(t) && YE(t.__prefect_kind) ? YE(e) ? t.__prefect_kind === e : !0 : !1;
}
function Lse(t) {
  return xa(t, "none") && "value" in t;
}
function X0(t) {
  return xa(t, "json") && (Ht(t.value) || !Vt(t.value));
}
function CN(t) {
  return xa(t, "jinja") && Ht(t.template);
}
function ON(t) {
  return xa(t, "workspace_variable") && (Ht(t.variable_name) || !Vt(t.variable_name));
}
function IN(t) {
  return wn(t) && Ht(t.$ref);
}
function Bse(t) {
  if (IN(t))
    return t;
}
class ph extends Error {
  constructor(e, n) {
    super(`Unable to convert prefect kind value from ${e} to ${n}`);
  }
}
function Use(t) {
  return t instanceof ph;
}
function FN(t, e) {
  const n = ey(t);
  if (CN(t))
    return Xse(t, e);
  if (ON(t))
    throw new ph(n, e);
  if (X0(t))
    return $se(t, e);
  if (n === "none")
    return Wse(t, e);
  throw new Error(`Unhandled prefect kind value in mapSchemaValue: ${n}`);
}
function Xse(t, e) {
  switch (e) {
    case "jinja":
      return t;
    case "workspace_variable":
      throw new ph("jinja", "workspace_variable");
    case "json":
      return {
        __prefect_kind: "json",
        value: t.template
      };
    case "none":
      if (vF(t.template))
        return JSON.parse(t.template);
      throw new ph("jinja", "none");
    default:
      throw new Error(`mapSchemaValueJson missing case for kind: ${e}`);
  }
}
function $se(t, e) {
  switch (e) {
    case "jinja":
      return {
        __prefect_kind: "jinja",
        template: t.value
      };
    case "workspace_variable":
      throw new ph("json", "workspace_variable");
    case "json":
      return t;
    case "none":
      if (Vt(t.value) && vF(t.value))
        return JSON.parse(t.value);
      throw new ph("json", "none");
    default:
      throw new Error(`mapSchemaValueJson missing case for kind: ${e}`);
  }
}
function Wse(t, e) {
  const n = Lse(t) ? t.value : t;
  switch (e) {
    case "jinja":
      return {
        __prefect_kind: "jinja",
        template: or(n)
      };
    case "workspace_variable":
      return {
        __prefect_kind: "workspace_variable"
      };
    case "json":
      let r = n;
      return Vt(n) && wn(n) && (r = Ds(n, (o, s) => FN(s, "none"))), {
        __prefect_kind: "json",
        value: or(r)
      };
    case "none":
      return t;
    default:
      throw new Error(`mapSchemaValueNone missing case for kind: ${e}`);
  }
}
function S2({ property: t, value: e }) {
  const n = {}, r = ge([]), { schema: o } = Zp(), s = Se();
  async function i(a) {
    if (X0(e.value) && a === "none") {
      const { valid: p } = await u();
      if (!p)
        return;
    }
    const c = ey(e.value);
    try {
      n[c] = structuredClone(pm(e.value));
    } catch (p) {
      console.error(p);
    }
    try {
      e.value = FN(e.value, a);
    } catch (p) {
      if (Use(p)) {
        if (a === "none") {
          e.value = n[a];
          return;
        }
        e.value = n[a] ?? { __prefect_kind: a };
      }
      throw p;
    }
  }
  async function u() {
    const a = await s.schemas.validateSchemaValue(Qe(e), Qe(t), o);
    return a.valid ? r.value = [] : r.value = a.errors, a;
  }
  const l = __(u, 1e3);
  return Ct(e, () => {
    r.value.length && l();
  }, { deep: !0 }), {
    errors: r,
    setKind: i
  };
}
const { values: JBe, isValue: e6e } = to([
  "null",
  "string",
  "boolean",
  "integer",
  "number",
  "array",
  "object"
]);
function zi(t, e) {
  return t === e;
}
const { isValue: Vse } = to([
  "string",
  "boolean",
  "integer",
  "number"
]), { values: t6e, isValue: n6e } = to([
  "date",
  "date-time",
  "password",
  "json-string"
]);
function Hse(t) {
  return Vt(t) && !Array.isArray(t);
}
function Np(t, e) {
  return Vt(t[e]);
}
const NN = /* @__PURE__ */ U({
  __name: "SchemaFormPropertyMenu",
  props: /* @__PURE__ */ Br({
    property: {},
    disabled: { type: Boolean }
  }, {
    kind: { required: !0 },
    kindModifiers: {},
    value: { required: !0 },
    valueModifiers: {}
  }),
  emits: ["update:kind", "update:value"],
  setup(t) {
    const e = zn(t, "kind"), n = zn(t, "value"), r = t, o = DI(), { kinds: s } = Zp(), i = D(() => s.length || o.default), u = D(() => zi(r.property.type, "object") && Gt(r.property.properties) ? !1 : zi(r.property.type, void 0) && Vt(r.property.enum) ? !0 : r.property.type !== void 0), l = D(() => Vt(r.property.default) ? ON(n.value) || CN(n.value) ? !0 : X0(n.value) ? !cm(n.value.value, or(r.property.default)) : !cm(n.value, r.property.default) : !1);
    function a(p) {
      return e.value !== p && (s.includes(p) || p === "none");
    }
    function c() {
      if (X0(n.value)) {
        n.value = {
          __prefect_kind: "json",
          value: or(r.property.default)
        };
        return;
      }
      n.value = r.property.default;
    }
    return (p, d) => {
      const h = P("p-overflow-menu-item"), m = P("p-divider"), g = P("p-icon-button-menu");
      return i.value ? (T(), O(g, {
        key: 0,
        size: "sm",
        class: "schema-form-property-menu"
      }, {
        default: k(() => [
          p.disabled ? j("", !0) : (T(), z(ve, { key: 0 }, [
            u.value ? (T(), z(ve, { key: 0 }, [
              a("none") ? (T(), O(h, {
                key: 0,
                label: "Use form input",
                onClick: d[0] || (d[0] = (_) => e.value = "none")
              })) : j("", !0)
            ], 64)) : j("", !0),
            a("json") ? (T(), O(h, {
              key: 1,
              label: "Use JSON input",
              onClick: d[1] || (d[1] = (_) => e.value = "json")
            })) : j("", !0),
            a("workspace_variable") ? (T(), O(h, {
              key: 2,
              label: "Select variable",
              onClick: d[2] || (d[2] = (_) => e.value = "workspace_variable")
            })) : j("", !0),
            a("jinja") ? (T(), O(h, {
              key: 3,
              label: "Use Jinja input",
              onClick: d[3] || (d[3] = (_) => e.value = "jinja")
            })) : j("", !0)
          ], 64)),
          w(m, { class: "schema-form-property-menu__divider" }),
          l.value ? (T(), O(h, {
            key: 1,
            label: "Use default value",
            onClick: c
          })) : j("", !0),
          Ve(p.$slots, "default")
        ]),
        _: 3
      })) : j("", !0);
    };
  }
});
function R2(t) {
  return wn(t) && "property" in t;
}
function A2(t) {
  return wn(t) && "index" in t;
}
function jse(t) {
  return A2(t) || R2(t);
}
function qg(t, e) {
  return Ht(t) ? e.filter(R2).filter((n) => n.property === t).flatMap((n) => n.errors) : e.filter(A2).filter((n) => n.index == t).flatMap((n) => n.errors);
}
function D2(t) {
  const e = t.filter(Ht), n = { pending: !1, valid: !0, validated: !0 };
  return e.length ? (n.valid = !1, {
    state: n,
    message: e.join(" and ")
  }) : {
    state: n,
    message: void 0
  };
}
function zse(t) {
  return t.filter(Ht);
}
function qse(t) {
  return t.filter(jse);
}
const Gse = { class: "schema-form-property-array-item__control" }, Yse = {
  key: 0,
  class: "schema-form-property-array-item__error"
}, Qse = /* @__PURE__ */ U({
  __name: "SchemaFormPropertyArrayItem",
  props: {
    property: {},
    value: {},
    isLast: { type: Boolean },
    isFirst: { type: Boolean },
    errors: {}
  },
  emits: ["update:value", "moveToTop", "moveToBottom", "deleteItem", "handleDown", "handleUp"],
  setup(t, { emit: e }) {
    const n = t, r = e, o = D({
      get() {
        return n.value;
      },
      set(c) {
        r("update:value", c);
      }
    }), s = D(() => ey(() => n.value)), { input: i } = I2(() => n.property, o, () => n.errors), { errors: u, setKind: l } = S2({ value: o, property: () => n.property }), a = D(() => {
      const c = u.value.length ? u.value : n.errors, p = zse(c), { message: d } = D2(p);
      return d;
    });
    return (c, p) => {
      const d = P("PIcon"), h = P("p-button"), m = P("p-overflow-menu-item"), g = P("p-content");
      return T(), O(g, {
        class: "schema-form-property-array-item",
        secondary: ""
      }, {
        default: k(() => [
          re("div", Gse, [
            w(d, {
              icon: "DragHandle",
              class: "schema-form-property-array-item__handle",
              onMousedown: p[0] || (p[0] = (_) => r("handleDown")),
              onMouseup: p[1] || (p[1] = (_) => r("handleUp"))
            }),
            (T(), O(Mr(v(i).component), sn(kn(v(i).props)), null, 16)),
            w(h, {
              icon: "TrashIcon",
              size: "sm",
              onClick: p[2] || (p[2] = (_) => r("deleteItem"))
            }),
            w(NN, {
              value: o.value,
              "onUpdate:value": p[5] || (p[5] = (_) => o.value = _),
              kind: s.value,
              property: c.property,
              "onUpdate:kind": v(l)
            }, {
              default: k(() => [
                c.isFirst ? j("", !0) : (T(), O(m, {
                  key: 0,
                  icon: "ArrowSmallUpIcon",
                  label: "Move to top",
                  onClick: p[3] || (p[3] = (_) => r("moveToTop"))
                })),
                c.isLast ? j("", !0) : (T(), O(m, {
                  key: 1,
                  icon: "ArrowSmallDownIcon",
                  label: "Move to bottom",
                  onClick: p[4] || (p[4] = (_) => r("moveToBottom"))
                }))
              ]),
              _: 1
            }, 8, ["value", "kind", "property", "onUpdate:kind"])
          ]),
          a.value ? (T(), z("p", Yse, ie(a.value), 1)) : j("", !0)
        ]),
        _: 1
      });
    };
  }
});
function dm(t, e) {
  const n = e.replace("#/definitions/", ""), r = t.definitions?.[n];
  if (!r)
    throw new Error(`Definition not found for ${e}`);
  return r;
}
function LN(t, e) {
  if (Np(t, "$ref")) {
    const { $ref: n, ...r } = t;
    return $t({}, dm(e, n), r);
  }
  return t;
}
function Jp(t, e) {
  const { schema: n } = Zp(), r = D(() => {
    const u = Qe(t);
    return LN(u, n);
  }), o = D(() => {
    const u = r.value.title ?? "";
    return Qe(e) ? u : `${u} (Optional)`.trim();
  }), s = D(() => {
    const { description: u = "" } = r.value;
    return u.replace(/\n(?!\n)/g, " ");
  }), i = D(() => !!r.value.const);
  return {
    property: r,
    label: o,
    description: s,
    disabled: i
  };
}
const Kse = { class: "schema-form-property-array-list" }, Zse = {
  key: 0,
  class: "schema-form-property-array-list__empty"
}, Jse = {
  key: 1,
  class: "schema-form-property-array-list__max"
}, eae = /* @__PURE__ */ U({
  __name: "SchemaFormPropertyArrayList",
  props: {
    property: {},
    value: {},
    errors: {},
    state: {}
  },
  emits: ["update:value"],
  setup(t, { emit: e }) {
    const n = t, { property: r } = Jp(() => n.property), o = D(() => !n.value?.length), s = e, i = D({
      get() {
        return n.value ?? [];
      },
      set(h) {
        if (h.length === 0) {
          s("update:value", void 0);
          return;
        }
        s("update:value", h);
      }
    }), u = D(() => {
      const h = n.property.maxItems ?? 1 / 0;
      return (n.value?.length ?? 0) < h;
    }), l = D(() => {
      const h = n.property.maxItems ?? 1 / 0;
      return (n.value?.length ?? 0) >= h;
    });
    function a(h) {
      return eu(r.value.prefixItems) ? r.value.prefixItems[h] ?? {} : eu(r.value.items) ? r.value.items[h] ?? {} : r.value.items ?? {};
    }
    function c() {
      const h = i.value.length;
      return a(h).default;
    }
    function p(h) {
      return h === 0;
    }
    function d(h) {
      return h === (n.value?.length ?? 0) - 1;
    }
    return (h, m) => {
      const g = P("p-draggable-list");
      return T(), z("div", Kse, [
        o.value ? (T(), z("p", Zse, " No items in this list ")) : j("", !0),
        w(g, yt({
          modelValue: i.value,
          "onUpdate:modelValue": m[0] || (m[0] = (_) => i.value = _)
        }, { allowCreate: u.value, generator: c, state: h.state }, { "allow-delete": "" }), {
          item: k(({ index: _, handleDown: b, handleUp: x, deleteItem: S, moveToTop: E, moveToBottom: A }) => [
            w(Qse, {
              value: i.value[_],
              "onUpdate:value": (C) => i.value[_] = C,
              property: a(_),
              errors: v(qg)(_, h.errors),
              "is-first": p(_),
              "is-last": d(_),
              onDeleteItem: S,
              onHandleDown: b,
              onHandleUp: x,
              onMoveToTop: E,
              onMoveToBottom: A
            }, null, 8, ["value", "onUpdate:value", "property", "errors", "is-first", "is-last", "onDeleteItem", "onHandleDown", "onHandleUp", "onMoveToTop", "onMoveToBottom"])
          ]),
          _: 1
        }, 16, ["modelValue"]),
        l.value ? (T(), z("p", Jse, " List can only have " + ie(v(r).maxItems) + " items ", 1)) : j("", !0)
      ]);
    };
  }
}), tae = /* @__PURE__ */ U({
  __name: "SchemaFormPropertyArray",
  props: {
    property: {},
    value: {},
    errors: {},
    state: {}
  },
  emits: ["update:value"],
  setup(t, { emit: e }) {
    const n = t, { schema: r } = Zp(), { property: o } = Jp(() => n.property), s = e;
    function i(a) {
      return ih(a) || Ht(a) || fF(a) || f8(a);
    }
    function u(a) {
      if (Array.isArray(a))
        return a.filter(i);
    }
    const l = D(() => {
      const { items: a } = o.value;
      if (Hse(a)) {
        const { type: c, enum: p } = LN(a, r);
        if (Vse(c) && p)
          return wt(ts, {
            modelValue: u(n.value),
            emptyMessage: "No items selected",
            state: n.state,
            options: p.filter(i).filter(Mq),
            multiple: !0,
            "onUpdate:modelValue": (d) => s("update:value", u(d))
          });
      }
      return wt(eae, {
        property: n.property,
        value: n.value,
        state: n.state,
        errors: n.errors,
        "onUpdate:value": (c) => s("update:value", c)
      });
    });
    return (a, c) => (T(), O(Mr(l.value.component), yt(l.value.props, { class: "schema-form-property-array" }), null, 16));
  }
}), nae = { class: "schema-form-input__description" }, Pk = /* @__PURE__ */ U({
  __name: "SchemaFormInput",
  props: {
    propKey: {},
    property: {}
  },
  setup(t) {
    const e = t, n = D(() => e.property.meta), r = D(() => {
      const c = e.property.title ?? "";
      return e.property.meta?.required ? c : `${c} (Optional)`;
    }), o = D(() => e.property.type === "null"), s = D(() => e.property.type === "block" ? `${e.propKey}.blockDocumentId` : e.propKey), i = D(() => n.value?.validators ?? []), { value: u, errorMessage: l, meta: a } = Rs(s, i);
    return (c, p) => {
      const d = P("p-markdown-renderer"), h = P("p-label");
      return T(), O(h, {
        class: "schema-form-input",
        label: r.value,
        message: v(l),
        state: v(a)
      }, {
        description: k(() => [
          re("div", nae, [
            c.property.description ? (T(), O(d, {
              key: 0,
              text: c.property.description,
              class: "schema-form-input__markdown"
            }, null, 8, ["text"])) : j("", !0),
            o.value ? (T(), O(v(E_), {
              key: 1,
              title: "Null Type"
            }, {
              default: k(() => [...p[1] || (p[1] = [
                q(" This field has a type 'None' and cannot be modified ", -1)
              ])]),
              _: 1
            })) : j("", !0)
          ])
        ]),
        default: k(() => [
          n.value && n.value.component ? (T(), O(Mr(n.value.component), yt({
            key: 0,
            modelValue: v(u),
            "onUpdate:modelValue": p[0] || (p[0] = (m) => Xe(u) ? u.value = m : null),
            class: "schema-form-input__component"
          }, { ...n.value.props, ...n.value.attrs }), null, 16, ["modelValue"])) : j("", !0)
        ]),
        _: 1
      }, 8, ["label", "message", "state"]);
    };
  }
}), BN = /* @__PURE__ */ U({
  __name: "SchemaFormProperties",
  props: {
    propKey: {},
    property: {}
  },
  setup(t) {
    const e = t, n = D(() => e.property.meta?.required ? e.property.title : `${e.property.title} (Optional)`);
    return (r, o) => {
      const s = P("p-content"), i = P("p-label");
      return T(), O(i, {
        label: n.value,
        description: r.property.description,
        class: "schema-form-properties"
      }, {
        default: k(() => [
          w(s, { class: "schema-form-properties__fields p-background" }, {
            default: k(() => [
              (T(!0), z(ve, null, ln(r.property.properties, (u, l) => (T(), O(bp, {
                key: l,
                property: u,
                "prop-key": `${r.propKey}.${l}`
              }, null, 8, ["property", "prop-key"]))), 128))
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["label", "description"]);
    };
  }
}), UN = /* @__PURE__ */ U({
  __name: "SchemaFormPropertyAllOf",
  props: {
    propKey: {},
    property: {}
  },
  setup(t) {
    return (e, n) => {
      const r = P("p-label");
      return T(), O(r, {
        label: e.property.title,
        description: e.property.description,
        class: "schema-form-property-all-of"
      }, {
        default: k(() => [
          (T(!0), z(ve, null, ln(e.property.allOf, (o, s) => (T(), O(bp, {
            key: s,
            "prop-key": e.propKey,
            property: o
          }, null, 8, ["prop-key", "property"]))), 128))
        ]),
        _: 1
      }, 8, ["label", "description"]);
    };
  }
}), r6e = 2, XN = fte("modelValue");
function Bh(t) {
  return $N(t, {});
}
function Ck(t, e = 0) {
  return zd(t, "properties") ? E2(t, {}) : dh(t, e).getDefaultValue();
}
function $N(t, e) {
  return E2(t, e);
}
function rae(t, e) {
  return WN(t, e) ?? {};
}
function E2(t, e, n = 0) {
  return dh(t, n).mapResponseValue(e);
}
function WN(t, e, n = 0) {
  return dh(t, n).mapRequestValue(e);
}
function oae(t) {
  const e = {
    autocomplete: "off"
  }, n = sae(t);
  return n && (e.placeholder = n), (t.minLength !== void 0 || t.minimum !== void 0) && (e.min = t.minLength ?? t.minimum), (t.maxLength !== void 0 || t.maximum !== void 0) && (e.max = t.maxLength ?? t.maximum), t.multipleOf && (e.step = t.multipleOf), e;
}
function sae(t) {
  const e = t.default ?? t.example ?? t.examples?.at(0);
  if (e)
    return typeof e == "string" ? e : or(e);
}
function aae({ component: t, props: e }) {
  switch (t) {
    case Rr:
      return XN(Rr, {
        showFormatButton: !0,
        showLineNumbers: !0,
        minLines: 3,
        ...e
      });
    default:
      return { component: t, props: e };
  }
}
function iae(t, e) {
  const { title: n = "Property" } = t, r = [], o = t.minLength ?? t.minimum ?? t.minItems;
  o !== void 0 && r.push(MF(o));
  const s = t.maxLength ?? t.maximum ?? t.maxItems;
  return s !== void 0 && r.push(Fp(s)), t.exclusiveMinimum !== void 0 && r.push(a2(t.exclusiveMinimum)), t.exclusiveMaximum !== void 0 && r.push(Yte(t.exclusiveMaximum)), e && r.push(Kr), qp(n, ...r);
}
function uae(t, e) {
  return e.reduce((n, r) => r(n), t);
}
function Ok(t, e) {
  return t.anyOf ? lae(t, e) : t.allOf ? cae(t, e) : (console.error("Schema property missing allOf and anyOf definitions", t, e), null);
}
function lae(t, e) {
  const n = VN(t, e);
  return n === null || n === -1 ? (console.log("Schema property with anyOf had a value but could not be associated with a definition", t, e), null) : t.anyOf[n];
}
function VN({ anyOf: t }, e) {
  return HN(t, e);
}
function cae(t, e) {
  const n = pae(t, e);
  return n === null || n === -1 ? (console.log("Schema property with allOf had a value but could not be associated with a definition", t, e), null) : t.allOf[n];
}
function pae({ allOf: t }, e) {
  return HN(t, e);
}
function HN(t, e) {
  if (zx(e))
    return t.findIndex((r) => r.type === "block");
  const n = Ip(e);
  if (wn(n) || Array.isArray(n))
    return QE(t, n);
  switch (typeof e) {
    case "number":
      return t.findIndex((r) => r.type == "number" || r.type === "integer");
    case "string":
      return t.findIndex((r) => r.type == "string");
    case "boolean":
      return t.findIndex((r) => r.type == "boolean");
    case "object":
      return QE(t, e);
    default:
      return null;
  }
}
function QE(t, e) {
  if (e === null)
    return null;
  if (L0(e))
    return t.findIndex((s) => s.blockTypeSlug === e.blockTypeSlug);
  if (Array.isArray(e))
    return t.findIndex((s) => s.type === "array");
  const n = Object.keys(e);
  if (n.length === 0)
    return t.findIndex((s) => s.type === "object");
  const [r, o] = t.reduce(([s, i], u, l) => {
    const a = Object.keys(u.properties ?? {}), c = n.filter((p) => a.includes(p)).length;
    return c > i ? [l, c] : [s, i];
  }, [0, 0]);
  if (o === 0) {
    const s = t.findIndex((i) => i.additionalProperties);
    return s !== -1 ? s : null;
  }
  return r;
}
class gl {
  /**
   * Can be extended to add property specific validation rules. Implemented here because this is not required
   */
  get validators() {
    return [];
  }
  /**
   * Can be extended to add property specific attrs rules. Implemented here because this is not required
   */
  get attrs() {
    return {};
  }
  property;
  level;
  withProps = XN;
  constructor({ property: e, level: n }) {
    this.property = e, this.level = n;
  }
  mapResponseValue(e) {
    try {
      return this.response(e);
    } catch (n) {
      n instanceof jd || console.error(n);
    }
    try {
      return this.response(this.default);
    } catch (n) {
      n instanceof jd || console.error(n);
    }
    return this.default;
  }
  mapRequestValue(e) {
    if (!this.isDefaultValue(e))
      return this.request(e);
  }
  getDefaultValue() {
    return this.default;
  }
  getComponent() {
    return this.component === null ? this.component : aae(this.component);
  }
  getValidators(e) {
    const { title: n = "Property" } = this.property, r = iae(this.property, e), o = qp(n, ...this.validators);
    return this.componentIs(Rr) && o.push(ml(n)), [...o, ...r];
  }
  getAttrs() {
    const e = oae(this.property);
    return { ...this.attrs, ...e };
  }
  getMeta(e) {
    const { component: n, props: r } = this.getComponent() ?? {};
    return {
      component: n,
      props: r,
      required: e,
      attrs: this.getAttrs(),
      validators: this.getValidators(e)
    };
  }
  componentIs(e) {
    return this.component?.component === e;
  }
  invalid() {
    throw new jd();
  }
  has(e) {
    return zd(this.property, e);
  }
  getSelectOptions() {
    const e = [], n = this.property.enum, r = this.property.items?.enum;
    if (!n && !r)
      return e;
    if (!this.property.meta?.required && !this.property.default && e.push({ label: "None", value: null }), T0(n) || lk(n)) {
      const o = n.map((s) => ({ label: `${s}`, value: s }));
      e.push(...o);
    }
    if (T0(r) || lk(r)) {
      const o = r.map((s) => ({ label: `${s}`, value: s }));
      e.push(...o);
    }
    return e;
  }
  isDefaultValue(e) {
    return h8(e, this.default);
  }
}
class dae extends gl {
  get component() {
    const e = this.getSelectOptions();
    return e.length ? this.withProps(ts, { options: e }) : this.withProps(Rr);
  }
  get default() {
    return this.componentIs(Rr) ? lh(this.property.default) ?? null : this.property.default ?? [];
  }
  request(e) {
    return this.componentIs(Rr) ? Ps(e) ? void 0 : Ip(e) : e;
  }
  response(e) {
    return Gt(e) ? this.invalid() : this.componentIs(Rr) ? typeof e == "string" ? e : lh(e) : Array.isArray(e) ? e : this.invalid();
  }
}
class hae extends gl {
  default = {
    blockTypeSlug: this.property.blockTypeSlug,
    blockDocumentId: this.getDefaultBlockDocumentId()
  };
  get component() {
    return this.withProps(C2, {
      blockTypeSlug: this.property.blockTypeSlug
    });
  }
  request(e) {
    return L0(e) ? e.blockDocumentId ? {
      $ref: {
        block_document_id: e.blockDocumentId
      }
    } : void 0 : e;
  }
  response(e) {
    if (L0(e))
      return e;
    this.invalid();
  }
  getDefaultBlockDocumentId() {
    return zx(this.property.default) ? this.property.default.$ref.block_document_id : null;
  }
}
class fae extends gl {
  get default() {
    return this.property.default ?? null;
  }
  mapRequestValue(e) {
    const n = this.request(e);
    if (!Gt(n))
      return n;
  }
  get component() {
    return this.withProps(Mh);
  }
  request(e) {
    return e;
  }
  response(e) {
    if (typeof e == "string") {
      if (e.toLowerCase() === "true")
        return !0;
      if (e.toLowerCase() === "false")
        return !1;
    }
    return typeof e != "boolean" ? this.invalid() : e;
  }
}
class mae extends gl {
  component = null;
  default = void 0;
  request(e) {
    return e;
  }
  response(e) {
    return e;
  }
}
class yae extends gl {
  get default() {
    return this.property.default ?? null;
  }
  get component() {
    return this.has("enum") ? this.withProps(ts, {
      options: this.getSelectOptions()
    }) : this.withProps(Ca);
  }
  get attrs() {
    return {
      step: "any"
    };
  }
  request(e) {
    return e;
  }
  response(e) {
    const n = parseFloat(e);
    return isNaN(n) ? this.invalid() : n;
  }
}
class gae extends gl {
  get component() {
    return this.has("properties") ? null : this.withProps(Rr);
  }
  get default() {
    return this.componentIs(Rr) ? lh(this.property.default) ?? null : this.property.default ?? {};
  }
  request(e) {
    if (this.componentIs(Rr))
      return Ps(e) ? void 0 : Ip(e);
    if (!YF(e))
      return;
    const n = Ds(this.property.properties ?? {}, (r, o) => {
      const s = e[r];
      return WN(o, s, this.level + 1);
    });
    if (!ru(n))
      return n;
  }
  response(e) {
    if (Gt(e))
      return this.invalid();
    if (this.componentIs(Rr))
      return lh(e);
    const n = Ip(e) ?? {};
    return Ds(this.property.properties ?? {}, (r, o) => {
      const s = n[r];
      return E2(o, s, this.level + 1);
    });
  }
}
const $0 = /* @__PURE__ */ U({
  __name: "DateInput",
  props: {
    modelValue: {},
    viewingDate: {},
    showTime: { type: Boolean },
    min: {},
    max: {}
  },
  emits: ["update:modelValue", "update:viewingDate"],
  setup(t, { emit: e }) {
    const n = t, r = e, o = D({
      get() {
        return n.modelValue ? Zs(n.modelValue) : null;
      },
      set(l) {
        r("update:modelValue", l ? ci(l) : null);
      }
    }), s = D({
      get() {
        return n.viewingDate ? Zs(n.viewingDate) : void 0;
      },
      set(l) {
        r("update:viewingDate", l ? ci(l) : void 0);
      }
    }), i = D(() => n.min ? Zs(n.min) : null), u = D(() => n.max ? Zs(n.max) : null);
    return (l, a) => {
      const c = P("p-date-input");
      return T(), O(c, {
        modelValue: o.value,
        "onUpdate:modelValue": a[0] || (a[0] = (p) => o.value = p),
        viewingDate: s.value,
        "onUpdate:viewingDate": a[1] || (a[1] = (p) => s.value = p),
        "show-time": l.showTime,
        min: i.value,
        max: u.value
      }, null, 8, ["modelValue", "viewingDate", "show-time", "min", "max"]);
    };
  }
}), Rr = /* @__PURE__ */ U({
  __name: "JsonInput",
  props: {
    minLines: {},
    modelValue: {},
    showFormatButton: { type: Boolean },
    showLineNumbers: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(t, { emit: e }) {
    const n = t, r = e, o = ge(n.modelValue ?? "");
    Ct(() => n.modelValue, (u) => {
      s(u, o.value) || (o.value = u ?? "");
    }), Ct(o, (u) => {
      s(u, n.modelValue) || r("update:modelValue", u);
    });
    function s(u, l) {
      return CE(u ?? "") === CE(l ?? "");
    }
    const i = () => {
      try {
        o.value = or(JSON.parse(o.value));
      } catch {
      }
    };
    return (u, l) => {
      const a = P("p-button"), c = P("p-code-input");
      return T(), O(c, yt({
        modelValue: o.value,
        "onUpdate:modelValue": l[0] || (l[0] = (p) => o.value = p),
        lang: "json",
        class: "json-input"
      }, { showLineNumbers: u.showLineNumbers, minLines: u.minLines }), Ut({ _: 2 }, [
        u.showFormatButton ? {
          name: "append",
          fn: k(() => [
            w(a, {
              class: "json-input__prettify-button",
              size: "sm",
              onClick: i
            }, {
              default: k(() => [...l[1] || (l[1] = [
                q(" Format ", -1)
              ])]),
              _: 1
            })
          ]),
          key: "0"
        } : void 0
      ]), 1040, ["modelValue"]);
    };
  }
});
class vae extends gl {
  get attrs() {
    return this.componentIs(nk) ? {
      rows: 1
    } : {};
  }
  get component() {
    if (this.has("enum"))
      return this.withProps(ts, {
        options: this.getSelectOptions()
      });
    switch (this.property.format) {
      case "date":
        return this.withProps(UD);
      case "date-time":
        return this.withProps($0, { showTime: !0 });
      case "json-string":
        return this.withProps(Rr);
      case "time-delta":
        return this.withProps(Ca);
      default:
        return this.withProps(nk);
    }
  }
  get default() {
    return this.componentIs(ts) ? this.property.default ?? null : this.componentIs($0) || this.componentIs(UD) ? Ht(this.property.default) ? Hg(this.property.default) : null : this.componentIs(Rr) ? lh(this.property.default) ?? "" : this.componentIs(Ca) ? this.property.default ?? null : this.property.default ?? "";
  }
  get validators() {
    const { format: e } = this.property;
    return e === "email" ? [EF] : e === "json-string" ? [ml] : [];
  }
  request(e) {
    switch (this.property.format) {
      case "date":
        return this.requestDateValue(e);
      case "date-time":
        return this.requestDateTimeValue(e);
      default:
        return e;
    }
  }
  response(e) {
    if (!Ht(e))
      throw new jd();
    switch (this.property.format) {
      case "date":
        return this.responseDateValue(e);
      case "date-time":
        return this.responseDateTimeValue(e);
      default:
        return e;
    }
  }
  requestDateValue(e) {
    return ol(e) ? rl(e, "yyyy-MM-dd") : e;
  }
  responseDateValue(e) {
    if (!Ht(e))
      throw new jd();
    const n = Hg(e);
    return Fa(n) ? n : this.invalid();
  }
  requestDateTimeValue(e) {
    return ol(e) ? e.toISOString() : e;
  }
  responseDateTimeValue(e) {
    if (!Ht(e))
      throw new jd();
    const n = Hg(e);
    return Fa(n) || this.invalid(), n;
  }
}
function jN(t) {
  try {
    if (!Ht(t))
      throw new Error();
    return {
      success: !0,
      value: JSON.parse(t)
    };
  } catch {
  }
  return {
    success: !1,
    value: t
  };
}
function KE(t) {
  try {
    return {
      success: !0,
      value: JSON.stringify(t)
    };
  } catch {
  }
  return {
    success: !1,
    value: t
  };
}
class _ae extends gl {
  get default() {
    let e = null;
    return this.has("default") ? e = this.property.default : (this.has("anyOf") || this.has("allOf")) && (e = this.getDefaultValueForFirstDefinition()), this.componentIs(Rr) ? KE(e).value ?? "" : e;
  }
  get component() {
    return this.has("anyOf") || this.has("allOf") ? null : this.withProps(Rr);
  }
  request(e) {
    if (this.has("anyOf") || this.has("allOf"))
      return this.referenceRequest(e);
    const { value: n } = jN(e);
    return n;
  }
  response(e) {
    if (this.has("anyOf") || this.has("allOf"))
      return this.referenceResponse(e);
    const { value: n } = KE(e);
    return n;
  }
  referenceResponse(e) {
    if (e === void 0)
      return this.invalid();
    const n = Ok(this.property, e);
    return n === null ? this.invalid() : dh(n, this.level).mapResponseValue(e);
  }
  referenceRequest(e) {
    if (this.isDefaultValueForReference(e))
      return;
    const n = Ok(this.property, e);
    if (n === null)
      return e;
    const o = dh(n, this.level).mapRequestValue(e);
    if (!ru(o))
      return o;
  }
  getDefaultValueForFirstDefinition() {
    const [e] = this.property.anyOf ?? this.property.allOf ?? [];
    if (e)
      return Ck(e);
    throw new Error("Could not find first definition for schema property");
  }
  isDefaultValueForReference(e) {
    return (this.property.anyOf ?? this.property.allOf ?? []).some((r) => h8(e, Ck(r)));
  }
}
class wae extends gl {
  get default() {
    return this.property.default ?? null;
  }
  get component() {
    return this.has("enum") ? this.withProps(ts, {
      options: this.getSelectOptions()
    }) : this.withProps(Ca);
  }
  request(e) {
    return e;
  }
  response(e) {
    const n = parseInt(e);
    return isNaN(n) ? this.invalid() : n;
  }
}
function dh(t, e) {
  const n = bae(t);
  return new n({
    property: t,
    level: e
  });
}
function bae(t) {
  switch (t.type) {
    case "string":
      return vae;
    case "integer":
      return wae;
    case "number":
      return yae;
    case "boolean":
      return fae;
    case "null":
      return mae;
    case "array":
      return dae;
    case "object":
      return gae;
    case "block":
      return hae;
    case void 0:
      return _ae;
    default:
      throw new Error(`getSchemaPropertyServiceConstructor missing case for ${t.type}`);
  }
}
const kae = (t) => {
  const { definitions: e, properties: n, ...r } = t, o = r;
  return e && n ? o.properties = M2(n, e) : o.properties = n, o;
};
function M2(t, e) {
  if (t)
    return Ds(t, (n, r) => Gg(r, e));
}
function Gg(t, e) {
  if (!t)
    return;
  const { $ref: n, properties: r, allOf: o, anyOf: s, items: i, ...u } = t;
  let l = u;
  if (n && (l = {
    ...l,
    ...Tae(n, e)
  }), r && (l.properties = M2(r, e)), o) {
    const a = o.map((c) => Gg(c, e));
    l.allOf = a;
  }
  return s && (l.anyOf = s.map((a) => Gg(a, e))), i && (l.items = Gg(i, e), l.title ??= l.items?.title, l.description ??= l.items?.description), l.type || (T0(l.enum) && (l.type = "string"), lk(l.enum) && (l.type = "integer")), l;
}
function Tae(t, e) {
  const [, n = ""] = t.match(/^(?:#\/definitions\/)(.*)/) ?? [], r = e[n];
  if (r)
    return r.blockTypeSlug && (r.type = "block"), r.properties && (r.properties = M2(r.properties, e)), r;
}
const xae = (t) => Kf(t, !1, 0);
function Sae({ required: t, properties: e }, n) {
  return Ds(e ?? {}, (r, o) => {
    const s = t?.includes(r) ?? !1;
    return Kf(o, s, n);
  });
}
function Kf(t, e, n) {
  const { properties: r, allOf: o, anyOf: s, items: i, ...u } = t, l = u;
  o && (l.allOf = o.map((p) => Kf(p, e, n))), s && (l.anyOf = s.map((p) => Kf(p, e, n))), i && (l.items = Kf(i, !1, n)), r && (l.properties = Sae(t, n + 1));
  const c = dh(t, n).getMeta(e);
  return c && (l.meta = mj(c)), l;
}
function zN(t, e) {
  return e === void 0 || Object.keys(e).length === 0 ? t : Ds(t, (n, r) => {
    const o = e[n];
    return o ? {
      blockTypeSlug: o.block_document.block_type.slug,
      blockDocumentId: o.block_document.id
    } : YF(r) ? zN(r, e) : r;
  });
}
const Rae = { class: "schema-form-property-any-of__section-header" }, qN = /* @__PURE__ */ U({
  __name: "SchemaFormPropertyAnyOf",
  props: {
    propKey: {},
    property: {}
  },
  setup(t) {
    const e = t, { value: n, setValue: r } = Rs(e.propKey), o = ge(VN(e.property, n.value) ?? 0), s = D(() => e.property.anyOf), i = D(() => s.value[o.value] ?? {}), u = D(() => e.property.title ?? e.propKey.split(".").pop()), l = D(() => i.value.type == "object"), a = D(() => e.property.description ?? i.value.description), c = D(() => s.value.map((d, h) => ({
      label: d.title ?? d.alias ?? d.format ?? d.type ?? "",
      value: h
    }))), p = s.value.map((d) => Ck(d));
    return Ct(o, (d) => {
      r(p[d]);
    }), Ct(n, (d) => {
      p[o.value] = d;
    }, { immediate: !0 }), (d, h) => {
      const m = P("p-button-group"), g = P("p-content"), _ = P("p-label");
      return T(), O(g, { class: "schema-form-property-any-of" }, {
        default: k(() => [
          re("h3", Rae, ie(u.value), 1),
          w(m, {
            modelValue: o.value,
            "onUpdate:modelValue": h[0] || (h[0] = (b) => o.value = b),
            options: c.value,
            small: ""
          }, null, 8, ["modelValue", "options"]),
          w(_, {
            class: "schema-form-property-any-of__fields p-background",
            description: a.value
          }, {
            default: k(() => [
              i.value.meta && i.value.meta.component ? (T(), O(bp, {
                key: 0,
                property: i.value,
                "prop-key": d.propKey
              }, null, 8, ["property", "prop-key"])) : l.value ? (T(), O(g, { key: 1 }, {
                default: k(() => [
                  (T(!0), z(ve, null, ln(i.value.properties, (b, x) => (T(), O(bp, {
                    key: x,
                    "prop-key": `${d.propKey}.${x}`,
                    property: b
                  }, null, 8, ["prop-key", "property"]))), 128))
                ]),
                _: 1
              })) : (T(), O(bp, {
                key: 2,
                property: i.value,
                "prop-key": d.propKey
              }, null, 8, ["property", "prop-key"]))
            ]),
            _: 1
          }, 8, ["description"])
        ]),
        _: 1
      });
    };
  }
}), Aae = { class: "schema-form-property" }, bp = /* @__PURE__ */ U({
  __name: "SchemaFormProperty",
  props: {
    propKey: {},
    property: {}
  },
  setup(t) {
    const e = t, n = D(() => e.property.type === "block" ? Pk : zd(e.property, "properties") ? BN : zd(e.property, "allOf") ? UN : zd(e.property, "anyOf") ? qN : Pk);
    return (r, o) => (T(), z("div", Aae, [
      (T(), O(Mr(n.value), sn(kn({ property: r.property, propKey: r.propKey })), null, 16))
    ]));
  }
}), ed = /* @__PURE__ */ U({
  __name: "SchemaFormFields",
  props: {
    schema: {},
    property: {}
  },
  setup(t) {
    const e = t;
    function n(o) {
      return e.property ? `${e.property}.${o}` : o;
    }
    const r = D(() => Object.entries(e.schema.properties ?? {}).sort(([, s], [, i]) => (s?.position ?? 1 / 0) - (i?.position ?? 1 / 0)));
    return (o, s) => {
      const i = P("p-content");
      return T(), O(i, { class: "schema-form-fields" }, {
        default: k(() => [
          (T(!0), z(ve, null, ln(r.value, ([u, l]) => (T(), O(bp, {
            key: n(u),
            "prop-key": n(u),
            property: l
          }, null, 8, ["prop-key", "property"]))), 128))
        ]),
        _: 1
      });
    };
  }
}), Pc = /* @__PURE__ */ U({
  __name: "SubmitButton",
  props: {
    action: { default: "Save" }
  },
  setup(t) {
    return (e, n) => {
      const r = P("p-button");
      return T(), O(r, {
        variant: "default",
        type: "submit"
      }, {
        default: k(() => [
          q(ie(e.action), 1)
        ]),
        _: 1
      });
    };
  }
}), GN = /* @__PURE__ */ U({
  __name: "BlockSchemaCreateForm",
  props: {
    blockSchema: {},
    hideFooter: { type: Boolean }
  },
  emits: ["submit", "cancel"],
  setup(t, { emit: e }) {
    const n = t, r = e, o = Se(), s = D(() => c_(`block-schema-form-${n.blockSchema.id}`)), { initialValue: i, remove: u, set: l } = Zj(s.value, {
      name: "",
      data: Bh(n.blockSchema.fields),
      blockSchema: n.blockSchema
    }), { values: a, handleSubmit: c } = Mc({
      initialValues: i
    }), p = () => async (b) => b && typeof b == "string" && (await o.blockDocuments.getBlockDocuments({
      blockTypes: {
        slug: [n.blockSchema.blockType.slug]
      },
      blockDocuments: {
        name: [b]
      }
    })).length ? "Block document names must be unique." : !0, { value: d, meta: h, errorMessage: m } = Rs("name", qp("Name", Kr, Kte, p));
    dx(() => l(a));
    const g = c((b) => {
      u(), r("submit", b);
    }), _ = () => {
      u(), r("cancel");
    };
    return (b, x) => {
      const S = P("p-text-input"), E = P("p-label"), A = P("p-content"), C = P("p-button"), M = P("p-form");
      return T(), O(M, {
        class: "block-schema-create-form",
        onSubmit: v(g)
      }, Ut({
        default: k(() => [
          w(A, null, {
            default: k(() => [
              w(E, {
                label: "Block Name",
                message: v(m),
                state: v(h)
              }, {
                default: k(() => [
                  w(S, {
                    modelValue: v(d),
                    "onUpdate:modelValue": x[0] || (x[0] = (L) => Xe(d) ? d.value = L : null),
                    state: v(h)
                  }, null, 8, ["modelValue", "state"])
                ]),
                _: 1
              }, 8, ["message", "state"]),
              w(ed, {
                schema: b.blockSchema.fields,
                property: "data"
              }, null, 8, ["schema"])
            ]),
            _: 1
          })
        ]),
        _: 2
      }, [
        b.hideFooter ? void 0 : {
          name: "footer",
          fn: k(() => [
            w(C, { onClick: _ }, {
              default: k(() => [...x[1] || (x[1] = [
                q(" Cancel ", -1)
              ])]),
              _: 1
            }),
            w(Pc, { action: "Create" })
          ]),
          key: "0"
        }
      ]), 1032, ["onSubmit"]);
    };
  }
}), Dae = ["src"], fu = /* @__PURE__ */ U({
  __name: "LogoImage",
  props: {
    url: {},
    size: { default: "md" }
  },
  setup(t) {
    const e = t, n = D(() => [`logo-image--size-${e.size}`]);
    return (r, o) => r.url ? (T(), z("div", {
      key: 0,
      class: Bt(["logo-image", n.value])
    }, [
      re("img", { src: r.url }, null, 8, Dae)
    ], 2)) : j("", !0);
  }
}), Eae = { class: "block-type-card-preview__actions" }, P2 = /* @__PURE__ */ U({
  __name: "BlockTypeCardPreview",
  props: {
    blockType: {}
  },
  setup(t) {
    const e = je();
    return (n, r) => {
      const o = P("p-icon"), s = P("p-heading"), i = P("p-markdown-renderer"), u = P("p-button"), l = P("p-card");
      return T(), O(l, { class: "block-type-card-preview" }, Ut({
        header: k(() => [
          n.blockType.logoUrl ? (T(), O(fu, {
            key: 0,
            url: n.blockType.logoUrl,
            class: "block-type-card-preview__logo",
            size: "lg"
          }, null, 8, ["url"])) : (T(), O(o, {
            key: 1,
            icon: "PBlock",
            class: "block-type-card-preview__icon"
          })),
          w(s, {
            class: "block-type-card-preview__name",
            heading: "4"
          }, {
            default: k(() => [
              q(ie(n.blockType.name), 1)
            ]),
            _: 1
          })
        ]),
        default: k(() => [
          n.blockType.description ? (T(), O(i, {
            key: 0,
            text: n.blockType.description,
            class: "block-type-card-preview__description"
          }, null, 8, ["text"])) : j("", !0)
        ]),
        _: 2
      }, [
        n.$slots.actions ? {
          name: "footer",
          fn: k(() => [
            re("div", Eae, [
              w(u, {
                size: "sm",
                variant: "ghost",
                to: v(e).blocksCatalogView(n.blockType.slug)
              }, {
                default: k(() => [...r[0] || (r[0] = [
                  q(" Details ", -1)
                ])]),
                _: 1
              }, 8, ["to"]),
              Ve(n.$slots, "actions")
            ])
          ]),
          key: "0"
        } : void 0
      ]), 1024);
    };
  }
}), Mae = {
  key: 0,
  class: "results-count"
}, Uo = /* @__PURE__ */ U({
  __name: "ResultsCount",
  props: {
    count: {},
    label: { default: "result" },
    limit: { default: void 0 }
  },
  setup(t) {
    return (e, n) => v(ih)(e.count) ? (T(), z("span", Mae, ie(e.count.toLocaleString()) + ie(v(ih)(e.limit) ? ` / ${e.limit.toLocaleString()}` : "") + " " + ie(v(mc)(e.label, e.count)), 1)) : j("", !0);
  }
}), Pae = { class: "search" }, Wo = /* @__PURE__ */ U({
  __name: "SearchInput",
  props: {
    modelValue: {},
    placeholder: { default: "Search..." },
    label: { default: void 0 },
    size: { default: "default" }
  },
  emits: ["update:modelValue"],
  setup(t, { emit: e }) {
    const n = t, r = e, o = D({
      get() {
        return n.modelValue;
      },
      set(i) {
        r("update:modelValue", i);
      }
    }), s = `search-${Cm()}`;
    return (i, u) => (T(), z("div", Pae, [
      i.label ? (T(), O(v(nr), {
        key: 0,
        for: s,
        label: i.label,
        class: "search__label"
      }, null, 8, ["label"])) : j("", !0),
      w(v(Mj), {
        id: s,
        modelValue: o.value,
        "onUpdate:modelValue": u[0] || (u[0] = (l) => o.value = l),
        type: "search",
        small: i.size === "small",
        placeholder: i.placeholder,
        class: "search__input"
      }, {
        prepend: k(() => [
          w(v(vo), {
            icon: "MagnifyingGlassIcon",
            class: "search__icon"
          })
        ]),
        _: 1
      }, 8, ["modelValue", "small", "placeholder"])
    ]));
  }
}), Cae = { class: "block-type-list" }, Oae = { class: "block-type-list__filters" }, Iae = { class: "block-type-list__types" }, YN = /* @__PURE__ */ U({
  __name: "BlockTypeList",
  props: {
    blockTypes: {},
    capability: {},
    useEmit: { type: Boolean }
  },
  emits: ["update:capability", "add"],
  setup(t, { emit: e }) {
    const n = t, r = e, o = je(), s = ge(""), i = D({
      get() {
        return n.capability;
      },
      set(d) {
        r("update:capability", d);
      }
    }), u = D(() => n.blockTypes.filter(c)), l = D(() => s.value.length || n.capability !== null), a = D(() => l.value && u.value.length === 0);
    function c({ name: d }) {
      return d.toLowerCase().includes(s.value.toLowerCase());
    }
    function p() {
      s.value = "", i.value = null;
    }
    return (d, h) => {
      const m = P("p-button");
      return T(), z("div", Cae, [
        re("div", Oae, [
          w(Uo, {
            label: "Block",
            count: u.value.length,
            class: "block-type-list__results"
          }, null, 8, ["count"]),
          w(Wo, {
            modelValue: s.value,
            "onUpdate:modelValue": h[0] || (h[0] = (g) => s.value = g),
            class: "block-type-list__search",
            size: "small",
            placeholder: "Search blocks"
          }, null, 8, ["modelValue"])
        ]),
        re("div", Iae, [
          (T(!0), z(ve, null, ln(u.value, (g) => (T(), O(P2, {
            key: g.id,
            "block-type": g
          }, {
            actions: k(() => [
              d.useEmit ? (T(), O(m, {
                key: 0,
                size: "sm",
                variant: "default",
                onClick: (_) => r("add", g)
              }, {
                default: k(() => [...h[1] || (h[1] = [
                  q(" Create ", -1)
                ])]),
                _: 1
              }, 8, ["onClick"])) : (T(), O(m, {
                key: 1,
                size: "sm",
                variant: "default",
                to: v(o).blockCreate(g.slug)
              }, {
                default: k(() => [...h[2] || (h[2] = [
                  q(" Create ", -1)
                ])]),
                _: 1
              }, 8, ["to"]))
            ]),
            _: 2
          }, 1032, ["block-type"]))), 128))
        ]),
        a.value ? (T(), O(v(el), { key: 0 }, {
          message: k(() => [...h[3] || (h[3] = [
            q(" No blocks ", -1)
          ])]),
          actions: k(() => [
            w(m, {
              size: "sm",
              onClick: p
            }, {
              default: k(() => [...h[4] || (h[4] = [
                q(" Clear Filters ", -1)
              ])]),
              _: 1
            })
          ]),
          _: 1
        })) : j("", !0)
      ]);
    };
  }
}), QN = /* @__PURE__ */ U({
  __name: "BlockCreateModal",
  props: {
    showModal: { type: Boolean },
    providedBlockType: {},
    capability: {}
  },
  emits: ["update:showModal", "refresh"],
  setup(t, { emit: e }) {
    const n = Se(), r = t, o = e, s = ge(r.providedBlockType), i = ge(r.capability ?? ""), u = Cm(), l = D(() => ({
      "block-create-modal--schema-creation": s.value
    })), a = (b) => {
      s.value = b;
    }, c = D({
      get() {
        return r.showModal;
      },
      set(b) {
        s.value = r.providedBlockType, o("update:showModal", b);
      }
    }), { filter: p } = cN({
      blockSchemas: {
        blockCapabilities: [i.value]
      }
    }), d = mt(n.blockTypes.getBlockTypes, [p]), h = D(() => d.response ?? []), m = D(() => [...h.value].filter((b) => b.name !== "Slack Incoming Webhook")), { blockSchema: g } = yN(() => s.value?.id), _ = async (b) => {
      try {
        const x = await n.blockDocuments.createBlockDocument(b);
        o("refresh", x);
      } catch (x) {
        console.error(x);
        const S = Yt(x, le.error.createBlock);
        He(S, "error");
      }
    };
    return (b, x) => {
      const S = P("p-heading"), E = P("p-modal");
      return T(), O(E, {
        showModal: c.value,
        "onUpdate:showModal": x[0] || (x[0] = (A) => c.value = A),
        class: Bt(["block-create-modal", l.value]),
        title: "Add a new block"
      }, Ut({
        default: k(() => [
          s.value ? j("", !0) : (T(), O(YN, {
            key: 0,
            capability: i.value,
            class: "block-create-modal__block-type-list",
            "use-emit": "",
            "block-types": m.value,
            onAdd: a
          }, null, 8, ["capability", "block-types"])),
          s.value ? (T(), z(ve, { key: 1 }, [
            w(S, { heading: "4" }, {
              default: k(() => [
                q(ie(s.value.name), 1)
              ]),
              _: 1
            }),
            v(g) ? (T(), O(GN, {
              key: 0,
              id: v(u),
              "block-schema": v(g),
              "hide-footer": "",
              onSubmit: _
            }, null, 8, ["id", "block-schema"])) : j("", !0)
          ], 64)) : j("", !0)
        ]),
        _: 2
      }, [
        v(g) ? {
          name: "actions",
          fn: k(() => [
            w(Pc, {
              action: "Create",
              form: v(u)
            }, null, 8, ["form"])
          ]),
          key: "0"
        } : void 0
      ]), 1032, ["showModal", "class"]);
    };
  }
}), KN = /* @__PURE__ */ U({
  __name: "BlockDocumentCombobox",
  props: {
    selected: {},
    blockDocuments: {},
    required: { type: Boolean }
  },
  emits: ["update:selected"],
  setup(t, { emit: e }) {
    const n = t, r = e, { classes: o, styles: s, attrs: i } = Pj(), u = D(() => {
      const a = ye.map("BlockDocument", n.blockDocuments, "SelectOption");
      return n.required ? a : [{ label: "None", value: null }, ...a];
    }), l = D({
      get() {
        return n.selected ?? null;
      },
      set(a) {
        r("update:selected", a);
      }
    });
    return (a, c) => {
      const p = P("p-combobox");
      return T(), z("div", {
        class: Bt(["block-documents-select", v(o)]),
        style: b0(v(s))
      }, [
        w(p, yt({
          modelValue: l.value,
          "onUpdate:modelValue": c[0] || (c[0] = (d) => l.value = d),
          options: u.value,
          required: a.required
        }, v(i)), null, 16, ["modelValue", "options", "required"])
      ], 6);
    };
  }
}), Fae = { class: "block-document-input" }, C2 = /* @__PURE__ */ U({
  __name: "BlockDocumentInput",
  props: {
    modelValue: {},
    blockTypeSlug: {},
    required: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(t, { emit: e }) {
    const n = t, r = e, o = D({
      get() {
        return n.modelValue ?? null;
      },
      set(g) {
        r("update:modelValue", g);
      }
    }), { showModal: s, open: i, close: u } = St(), l = Se(), a = D(() => n.blockTypeSlug), c = mt(l.blockTypes.getBlockTypeBySlug, [a]), p = D(() => c.response), d = mt(l.blockTypes.getBlockDocumentsByBlockTypeSlug, [a]), h = D(() => d.response ?? []), m = async (g) => {
      o.value = g.id, await d.refresh(), u();
    };
    return (g, _) => {
      const b = P("p-button");
      return T(), z("div", Fae, [
        p.value ? (T(), O(fu, {
          key: 0,
          url: p.value.logoUrl
        }, null, 8, ["url"])) : j("", !0),
        h.value.length ? (T(), O(KN, yt({
          key: 1,
          selected: o.value,
          "onUpdate:selected": _[0] || (_[0] = (x) => o.value = x),
          required: g.required
        }, { blockDocuments: h.value }, { class: "block-document-input__select" }), null, 16, ["selected", "required"])) : j("", !0),
        a.value ? (T(), O(b, {
          key: 2,
          "icon-append": "PlusIcon",
          onClick: v(i)
        }, {
          default: k(() => [..._[2] || (_[2] = [
            q(" Add ", -1)
          ])]),
          _: 1
        }, 8, ["onClick"])) : j("", !0),
        p.value ? (T(), O(QN, {
          key: 3,
          showModal: v(s),
          "onUpdate:showModal": _[1] || (_[1] = (x) => Xe(s) ? s.value = x : null),
          "provided-block-type": p.value,
          onRefresh: m
        }, null, 8, ["showModal", "provided-block-type"])) : j("", !0)
      ]);
    };
  }
}), Nae = /* @__PURE__ */ U({
  __name: "SchemaFormPropertyBlockDocument",
  props: {
    property: {},
    value: {},
    state: {}
  },
  emits: ["update:value"],
  setup(t, { emit: e }) {
    const n = t, r = e, o = D({
      get() {
        return n.value?.$ref ?? null;
      },
      set(s) {
        if (Gt(s)) {
          r("update:value", void 0);
          return;
        }
        r("update:value", {
          $ref: s
        });
      }
    });
    return (s, i) => (T(), O(C2, {
      modelValue: o.value,
      "onUpdate:modelValue": i[0] || (i[0] = (u) => o.value = u),
      "block-type-slug": s.property.blockTypeSlug,
      state: s.state,
      class: "schema-form-property-block-document"
    }, null, 8, ["modelValue", "block-type-slug", "state"]));
  }
});
function So(t, e) {
  if (typeof t == typeof e())
    return t;
}
function ZN(t) {
  if (Vt(t)) {
    try {
      if (Ht(t))
        return JSON.parse(t), t;
    } catch {
    }
    return or(t);
  }
}
const Lae = /* @__PURE__ */ U({
  __name: "SchemaFormPropertyBoolean",
  props: /* @__PURE__ */ Br({
    property: {},
    state: {}
  }, {
    value: { type: Boolean, default: void 0 },
    valueModifiers: {}
  }),
  emits: ["update:value"],
  setup(t) {
    const e = t, n = zn(t, "value");
    return Vt(n.value) || (n.value = So(e.property.default, Boolean) ?? !1), (r, o) => {
      const s = P("p-toggle");
      return T(), O(s, {
        modelValue: n.value,
        "onUpdate:modelValue": o[0] || (o[0] = (i) => n.value = i),
        state: r.state
      }, null, 8, ["modelValue", "state"]);
    };
  }
}), Bae = /* @__PURE__ */ U({
  __name: "SchemaFormPropertyInteger",
  props: {
    property: {},
    value: {},
    state: {}
  },
  emits: ["update:value"],
  setup(t, { emit: e }) {
    const n = t, r = e, { property: o } = Jp(() => n.property), s = D(() => o.value.enum ? wt(ts, {
      modelValue: n.value,
      state: n.state,
      options: o.value.enum.filter(ih),
      "onUpdate:modelValue": (i) => r("update:value", So(i, Number))
    }) : wt(Ca, {
      modelValue: So(n.value, Number),
      step: "1",
      state: n.state,
      "onUpdate:modelValue": (i) => r("update:value", So(i, Number))
    }));
    return (i, u) => (T(), O(Mr(s.value?.component), yt(s.value?.props, { class: "schema-form-property-integer" }), null, 16));
  }
}), Uae = { class: "schema-form-property-null" }, Xae = /* @__PURE__ */ U({
  __name: "SchemaFormPropertyNull",
  props: {
    property: {},
    value: {}
  },
  emits: ["update:value"],
  setup(t, { emit: e }) {
    return e("update:value", null), (r, o) => (T(), z("p", Uae, ' Property is type "None" '));
  }
}), $ae = { class: "schema-form-property__header" }, Wae = { class: "schema-form-property__description" }, Vae = ["disabled"], Hae = {
  key: 0,
  class: "schema-form-property__const"
}, O2 = /* @__PURE__ */ U({
  __name: "SchemaFormProperty",
  props: {
    property: {},
    value: {},
    required: { type: Boolean },
    errors: {},
    skipDefaultValueInitialization: { type: Boolean },
    propertyForValidation: {}
  },
  emits: ["update:value"],
  setup(t, { emit: e }) {
    const n = t, r = e, o = D(() => ey(() => n.value)), s = D(() => D2(A())), { property: i, label: u, description: l, disabled: a } = Jp(() => n.property, () => n.required), c = ge(!1), p = ge(null), d = D(() => c.value ? "Include value" : "Omit value"), h = ge(!1), { skipDefaultValueInitialization: m } = Zp(), g = D(() => ({
      label: {
        "schema-form-property__label--omitted": c.value
      },
      fields: {
        "schema-form-property__fields--omitted": c.value
      }
    })), _ = D({
      get() {
        if (ri(p.value))
          return p.value;
        if (Vt(n.value))
          return n.value;
        if (!h.value && Vt(i.value.default))
          return i.value.default;
      },
      set(C) {
        h.value && r("update:value", C);
      }
    });
    if (!m && !n.skipDefaultValueInitialization && !Vt(n.value) && Vt(i.value.default)) {
      r("update:value", i.value.default);
      const C = Ct(() => n.value, () => {
        cm(n.value, i.value.default) && (h.value = !0, C());
      });
    } else
      h.value = !0;
    const { errors: b, setKind: x } = S2({ value: _, property: () => n.propertyForValidation ?? n.property }), { input: S } = I2(i, _, A);
    function E() {
      if (c.value) {
        _.value = p.value, p.value = null, c.value = !1;
        return;
      }
      _.value = void 0, p.value = _.value, c.value = !0;
    }
    function A() {
      return b.value.length ? b.value : n.errors;
    }
    return (C, M) => {
      const L = P("p-overflow-menu-item"), X = P("p-markdown-renderer"), te = P("p-label");
      return h.value ? (T(), O(te, {
        key: 0,
        class: "schema-form-property",
        state: s.value.state,
        message: s.value.message
      }, Ut({
        label: k(() => [
          re("div", $ae, [
            re("span", {
              class: Bt(["schema-form-property__label", g.value.label])
            }, ie(v(u)), 3),
            w(NN, {
              value: _.value,
              "onUpdate:value": M[0] || (M[0] = (B) => _.value = B),
              kind: o.value,
              class: "ml-auto",
              property: v(i),
              disabled: c.value,
              flat: "",
              "onUpdate:kind": v(x)
            }, Ut({ _: 2 }, [
              C.required ? void 0 : {
                name: "default",
                fn: k(() => [
                  w(L, {
                    label: d.value,
                    onClick: E
                  }, null, 8, ["label"])
                ]),
                key: "0"
              }
            ]), 1032, ["value", "kind", "property", "disabled", "onUpdate:kind"])
          ])
        ]),
        default: k(() => [
          Ve(C.$slots, "default", { kind: o.value }),
          re("fieldset", {
            class: Bt(["schema-form-property__fields", g.value.fields]),
            disabled: v(a) || c.value
          }, [
            v(i).const ? (T(), z("p", Hae, ie(v(i).title ?? "Field") + " is a const and cannot be changed ", 1)) : j("", !0),
            (T(), O(hx, null, [
              (T(), O(Mr(v(S).component), sn(kn(v(S).props)), null, 16))
            ], 1024))
          ], 10, Vae)
        ]),
        _: 2
      }, [
        v(l) ? {
          name: "description",
          fn: k(() => [
            re("div", Wae, [
              w(X, {
                text: v(l),
                class: "schema-form-property__markdown"
              }, null, 8, ["text"])
            ])
          ]),
          key: "0"
        } : void 0
      ]), 1032, ["state", "message"])) : j("", !0);
    };
  }
}), jae = /* @__PURE__ */ U({
  __name: "SchemaFormPropertyAllOf",
  props: {
    property: {},
    value: {},
    required: { type: Boolean },
    errors: {}
  },
  emits: ["update:value"],
  setup(t, { emit: e }) {
    const n = t, r = e, o = D({
      get() {
        return n.value;
      },
      set(u) {
        r("update:value", u);
      }
    }), { schema: s } = Zp(), i = D(() => {
      const { allOf: u, ...l } = n.property, a = u.reduce((c, p) => Np(p, "$ref") ? $t({}, dm(s, p.$ref), c) : $t({}, c, p), {});
      return $t({}, a, l);
    });
    return (u, l) => (T(), O(O2, {
      value: o.value,
      "onUpdate:value": l[0] || (l[0] = (a) => o.value = a),
      property: i.value,
      required: u.required,
      errors: u.errors,
      "property-for-validation": u.property
    }, null, 8, ["value", "property", "required", "errors", "property-for-validation"]));
  }
}), zae = {
  null: "None",
  string: "str",
  boolean: "bool",
  integer: "int",
  number: "float",
  array: "list",
  object: "dict"
};
function qae(t) {
  return t ? zae[t] : "";
}
function ZE(t) {
  const e = qae(t.type);
  return t.title ?? t.format ?? e;
}
function Gae(t, e) {
  return t.anyOf.map((n) => Np(n, "$ref") ? dm(e, n.$ref) : n);
}
async function JE({ value: t, property: e, schema: n, api: r }) {
  const o = Vt(t) ? t : e.default;
  if (!Vt(o))
    return 0;
  const s = Gae(e, n);
  if (IN(o))
    return await Yae(o, s, r);
  switch (typeof o) {
    case "string":
      return s.findIndex((i) => i.type == "string");
    case "number":
      return s.findIndex((i) => i.type == "number" || i.type === "integer");
    case "boolean":
      return s.findIndex((i) => i.type == "boolean");
    case "object":
      return Qae(o, s);
    default:
      return -1;
  }
}
async function Yae(t, e, n) {
  const r = await n.blockDocuments.getBlockDocument(t.$ref), o = e.find((s) => s.blockTypeSlug === r.blockType.slug);
  return o ? e.indexOf(o) : -1;
}
function Qae(t, e) {
  return wn(t) ? Kae(t, e) : S8(t) ? e.findIndex((n) => n.type === "array") : t === null ? e.findIndex((n) => n.type === "null") : -1;
}
function Kae(t, e) {
  if (ru(t))
    return e.findIndex((s) => s.type === "object");
  const n = Object.keys(t), [r, o] = e.reduce(([s, i], u, l) => {
    const a = Object.keys(u.properties ?? {}), c = n.filter((p) => a.includes(p)).length;
    return c > i ? [l, c] : [s, i];
  }, [0, 0]);
  return o === 0 ? -1 : r;
}
const Zae = /* @__PURE__ */ U({
  __name: "SchemaFormPropertyAnyOf",
  props: {
    property: {},
    value: {},
    required: { type: Boolean },
    errors: {}
  },
  emits: ["update:value"],
  async setup(t, { emit: e }) {
    let n, r;
    const o = t, s = Se(), { schema: i } = Zp(), u = lt([]), l = ge(0), a = ge(!1);
    [n, r] = fx(() => b()), await n, r(), u[l.value] = o.value, yj(() => {
      b(), u[l.value] = o.value;
    });
    const c = e, p = D(() => xa(o.value) ? o.value : u[h.value]);
    async function d(x) {
      if (xa(x)) {
        c("update:value", x);
        return;
      }
      if (x === void 0) {
        u[h.value] = x, c("update:value", x);
        return;
      }
      let S = await JE({ value: x, property: o.property, api: s, schema: i });
      S === -1 && (console.warn("SchemaFormPropertyAnyOf could not determine the initial index for property value"), S = h.value), u[S] = x, l.value = S, c("update:value", x);
    }
    const h = D({
      get() {
        return l.value;
      },
      set(x) {
        l.value = x, c("update:value", u[x]);
      }
    }), m = D(() => {
      const x = o.property.anyOf[h.value], { anyOf: S, ...E } = o.property;
      return Np(x, "$ref") ? $t({}, dm(i, x.$ref), E) : $t({}, x, E);
    }), g = D(() => o.property.anyOf.map((x, S) => ({
      label: _(x),
      value: S
    })));
    function _(x) {
      if (x.$ref) {
        const S = dm(i, x.$ref);
        return ZE(S);
      }
      return ZE(x);
    }
    async function b() {
      const x = await JE({
        schema: i,
        property: o.property,
        value: o.value,
        api: s
      });
      if (x === -1) {
        console.warn("SchemaFormPropertyAnyOf could not determine the initial index for property value");
        return;
      }
      l.value = x;
    }
    return (x, S) => {
      const E = P("p-button-group");
      return T(), O(hx, null, [
        (T(), O(O2, {
          key: l.value,
          value: p.value,
          property: m.value,
          "property-for-validation": x.property,
          required: x.required,
          errors: x.errors,
          "skip-default-value-initialization": a.value,
          class: "schema-form-property-any-of-input",
          "onUpdate:value": d,
          onVnodeMounted: S[1] || (S[1] = () => a.value = !0)
        }, {
          default: k(({ kind: A }) => [
            A === "none" ? (T(), O(E, {
              key: 0,
              modelValue: h.value,
              "onUpdate:modelValue": S[0] || (S[0] = (C) => h.value = C),
              options: g.value,
              small: "",
              class: "mb-2"
            }, null, 8, ["modelValue", "options"])) : j("", !0)
          ]),
          _: 1
        }, 8, ["value", "property", "property-for-validation", "required", "errors", "skip-default-value-initialization"]))
      ], 1024);
    };
  }
}), Jae = /* @__PURE__ */ U({
  __name: "SchemaFormProperties",
  props: {
    parent: {},
    properties: {},
    values: {},
    errors: {}
  },
  emits: ["update:values"],
  setup(t, { emit: e }) {
    const n = t, r = e, o = D(() => Object.entries(n.properties).sort((p, d) => {
      const [, h] = p, [, m] = d, { position: g = 0 } = h, { position: _ = 0 } = m;
      return g - _;
    }));
    function s(p, d) {
      return p.title ? p : { ...p, title: Hm(d) };
    }
    function i(p) {
      return n.values?.[p];
    }
    function u(p, d) {
      a.push({ propertyKey: p, value: d }), c();
    }
    function l(p) {
      return n.parent.required?.includes(p) ?? !1;
    }
    const a = [], c = __(() => {
      const p = { ...n.values };
      a.forEach(({ propertyKey: d, value: h }) => {
        p[d] = h, Vt(h) || delete p[d];
      }), r("update:values", p);
    }, 10);
    return (p, d) => {
      const h = P("p-content");
      return T(), O(h, { class: "schema-form-properties" }, {
        default: k(() => [
          (T(!0), z(ve, null, ln(o.value, ([m, g]) => (T(), z(ve, { key: m }, [
            v(Np)(g, "allOf") ? (T(), O(jae, {
              key: 0,
              value: i(m),
              property: s(g, m),
              required: l(m),
              errors: v(qg)(m, p.errors),
              "onUpdate:value": (_) => u(m, _)
            }, null, 8, ["value", "property", "required", "errors", "onUpdate:value"])) : v(Np)(g, "anyOf") ? (T(), O(Zae, {
              key: 1,
              value: i(m),
              property: s(g, m),
              required: l(m),
              errors: v(qg)(m, p.errors),
              "onUpdate:value": (_) => u(m, _)
            }, null, 8, ["value", "property", "required", "errors", "onUpdate:value"])) : (T(), O(O2, {
              key: 2,
              value: i(m),
              property: s(g, m),
              required: l(m),
              errors: v(qg)(m, p.errors),
              "onUpdate:value": (_) => u(m, _)
            }, null, 8, ["value", "property", "required", "errors", "onUpdate:value"]))
          ], 64))), 128))
        ]),
        _: 1
      });
    };
  }
}), eM = Symbol(), eie = /* @__PURE__ */ U({
  __name: "SchemaFormPropertyObject",
  props: {
    property: {},
    values: {},
    errors: {}
  },
  emits: ["update:values"],
  setup(t, { emit: e }) {
    const n = t, r = Wv(eM, 0);
    EI(eM, r + 1);
    const o = e;
    if (Gt(n.property.properties)) {
      const u = Vt(n.values) ? n.values : n.property.default, l = {
        __prefect_kind: "json",
        value: ZN(u)
      };
      o("update:values", l);
    }
    const s = D(() => r === 0 ? "div" : "p-card"), i = D({
      get() {
        return n.values;
      },
      set(u) {
        o("update:values", u);
      }
    });
    return (u, l) => (T(), O(Mr(s.value), { class: "schema-form-property-object" }, {
      default: k(() => [
        w(Jae, {
          values: i.value,
          "onUpdate:values": l[0] || (l[0] = (a) => i.value = a),
          parent: u.property,
          properties: u.property.properties ?? {},
          errors: u.errors
        }, null, 8, ["values", "parent", "properties", "errors"])
      ]),
      _: 1
    }));
  }
}), tM = "yyyy-MM-dd", tie = /* @__PURE__ */ U({
  __name: "SchemaFormPropertyDate",
  props: {
    value: {}
  },
  emits: ["update:value"],
  setup(t, { emit: e }) {
    const n = t, r = e, o = D({
      get() {
        if (ri(n.value)) {
          const s = ki(n.value, tM, A3());
          return wp(s) ? void 0 : s;
        }
        return n.value;
      },
      set(s) {
        if (ri(s)) {
          r("update:value", rl(s, tM));
          return;
        }
        r("update:value", s);
      }
    });
    return (s, i) => {
      const u = P("p-date-input");
      return T(), O(u, {
        modelValue: o.value,
        "onUpdate:modelValue": i[0] || (i[0] = (l) => o.value = l),
        clearable: ""
      }, null, 8, ["modelValue"]);
    };
  }
}), nie = { class: "schema-form-property-date-time" }, rie = { class: "schema-form-property-date-time__input-container" }, nM = "yyyy-MM-dd'T'HH:mm:ss", oie = /* @__PURE__ */ U({
  __name: "SchemaFormPropertyDateTime",
  props: {
    value: {}
  },
  emits: ["update:value"],
  setup(t, { emit: e }) {
    const n = t, r = e, o = /(\.\d{1,9})?([+-]\d{2}:?\d{2}|Z)$/, s = /([+-]\d{2}:?\d{2}|Z)$/, i = ge(Op.value ?? "UTC"), u = D(() => d(n.value, i.value));
    MI(() => {
      ri(n.value) && (i.value = c(n.value) ?? Op.value ?? "UTC");
    });
    const l = D({
      get() {
        if (ri(n.value)) {
          const h = a(n.value), m = new Date(h);
          return wp(m) ? void 0 : m;
        }
        return n.value;
      },
      set(h) {
        if (ri(h)) {
          const m = d(h, i.value);
          r("update:value", m);
          return;
        }
        r("update:value", h);
      }
    });
    Ct(i, () => {
      if (ri(i.value) && ri(n.value)) {
        const h = d(n.value, i.value);
        r("update:value", h);
      }
    });
    function a(h) {
      return h.replace(o, "$1");
    }
    function c(h) {
      const m = new Date(h);
      if (wp(m))
        return null;
      const g = h.match(s);
      if (!g)
        return null;
      const [_] = g;
      if (_ === "Z")
        return "UTC";
      const [b, x] = _.replace("+", "").split(":").map(Number), S = b * 60 + (b >= 0 ? x : -x);
      return Intl.supportedValuesOf("timeZone").find((C) => {
        const M = gk(C);
        return Math.round(M / Ia) === S;
      }) ?? null;
    }
    function p(h) {
      if (h == "UTC" || !h)
        return "Z";
      const m = gk(h), g = m >= 0 ? "+" : "-", _ = Math.abs(Math.floor(m / nl)), b = Math.abs(Math.floor(m % nl / Ia));
      return `${g}${_.toString().padStart(2, "0")}:${b.toString().padStart(2, "0")}`;
    }
    function d(h, m) {
      const g = p(m);
      if (h instanceof Date)
        return rl(h, nM) + g;
      if (ri(h)) {
        const _ = a(h), b = new Date(_);
        return wp(b) ? void 0 : rl(b, nM) + g;
      }
      return h;
    }
    return (h, m) => {
      const g = P("p-date-input"), _ = P("p-code");
      return T(), z("div", nie, [
        re("div", rie, [
          w(g, {
            modelValue: l.value,
            "onUpdate:modelValue": m[0] || (m[0] = (b) => l.value = b),
            "show-time": "",
            clearable: "",
            class: "schema-form-property-date-time__date-input"
          }, null, 8, ["modelValue"]),
          w(v(M_), {
            modelValue: i.value,
            "onUpdate:modelValue": m[1] || (m[1] = (b) => i.value = b),
            class: "schema-form-property-date-time__timezone-select",
            "hide-unset": ""
          }, null, 8, ["modelValue"])
        ]),
        u.value ? (T(), O(_, { key: 0 }, {
          default: k(() => [
            q(ie(u.value), 1)
          ]),
          _: 1
        })) : j("", !0)
      ]);
    };
  }
}), sie = /* @__PURE__ */ U({
  __name: "SchemaFormPropertyString",
  props: {
    property: {},
    value: {},
    state: {}
  },
  emits: ["update:value"],
  setup(t, { emit: e }) {
    const n = t, r = e, { property: o } = Jp(() => n.property), s = D(() => {
      const { format: u, enum: l } = o.value;
      return u === "date" ? wt(tie, {
        value: n.value,
        state: n.state,
        "onUpdate:value": i
      }) : u === "date-time" ? wt(oie, {
        value: n.value,
        state: n.state,
        "onUpdate:value": i
      }) : u === "json-string" ? wt(Cj, {
        lang: "json",
        modelValue: n.value,
        state: n.state,
        "onUpdate:modelValue": i
      }) : l ? wt(ts, {
        modelValue: n.value,
        state: n.state,
        options: l.filter(Ht),
        "onUpdate:modelValue": i
      }) : wt(nk, {
        modelValue: n.value,
        state: n.state,
        rows: 1,
        "onUpdate:modelValue": i
      });
    });
    function i(u) {
      const l = So(u, String);
      if (l?.length === 0) {
        r("update:value", void 0);
        return;
      }
      r("update:value", l);
    }
    return (u, l) => (T(), O(Mr(s.value?.component), yt(s.value?.props, { class: "schema-form-property-string" }), null, 16));
  }
}), aie = /* @__PURE__ */ U({
  __name: "SchemaFormPropertyUnknown",
  props: {
    property: {},
    value: {},
    state: {}
  },
  emits: ["update:value"],
  setup(t, { emit: e }) {
    function n(l) {
      return Ht(l) || fF(l) || ih(l) || l === null;
    }
    function r(l) {
      if (n(l))
        return l;
    }
    const o = t, s = e, { property: i } = Jp(() => o.property);
    if (!Vt(i.value.enum)) {
      const l = Vt(o.value) ? o.value : i.value.default, a = {
        __prefect_kind: "json",
        value: ZN(l)
      };
      s("update:value", a);
    }
    const u = D(() => {
      const { enum: l } = i.value;
      return l ? wt(ts, {
        modelValue: r(o.value),
        state: o.state,
        options: l.filter(n).map((a) => ({ value: a, label: a?.toString() ?? "None" })),
        "onUpdate:modelValue": (a) => s("update:value", a)
      }) : wt(() => "");
    });
    return (l, a) => (T(), O(Mr(u.value.component), yt(u.value.props, { class: "schema-form-property-string" }), null, 16));
  }
}), rM = /* @__PURE__ */ U({
  __name: "SchemaFormPropertyInput",
  props: {
    property: {},
    value: {},
    errors: {},
    state: {}
  },
  emits: ["update:value"],
  setup(t, { emit: e }) {
    const n = t, r = e, { property: o } = Jp(() => n.property), s = D(() => {
      const { type: i } = o.value, { value: u } = n;
      if (Np(o.value, "blockTypeSlug"))
        return wt(Nae, {
          property: o.value,
          state: n.state,
          value: Bse(u),
          "onUpdate:value": (a) => r("update:value", a)
        });
      if (zi(i, "boolean"))
        return wt(Lae, {
          property: { ...o.value, type: i },
          value: So(u, Boolean),
          state: n.state,
          "onUpdate:value": (a) => r("update:value", So(a, Boolean))
        });
      if (zi(i, "string"))
        return wt(sie, {
          property: { ...o.value, type: i },
          value: So(u, String),
          state: n.state,
          "onUpdate:value": (a) => r("update:value", So(a, String))
        });
      if (zi(i, "integer"))
        return wt(Bae, {
          property: { ...o.value, type: i },
          value: So(u, Number),
          state: n.state,
          "onUpdate:value": (a) => r("update:value", So(a, Number))
        });
      if (zi(i, "number"))
        return wt(Ca, {
          modelValue: So(u, Number),
          step: "0.01",
          state: n.state,
          "onUpdate:modelValue": (a) => r("update:value", So(a, Number))
        });
      if (zi(i, "array"))
        return wt(tae, {
          property: { ...o.value, type: i },
          value: So(u, Array),
          errors: n.errors,
          state: n.state,
          "onUpdate:value": (a) => r("update:value", So(a, Array))
        });
      if (zi(i, "object"))
        return wt(eie, {
          property: { ...o.value, type: i },
          values: So(u, Object),
          errors: n.errors,
          "onUpdate:values": (a) => r("update:value", So(a, Object))
        });
      if (zi(i, "null"))
        return wt(Xae, {
          property: { ...o.value, type: i },
          value: null,
          "onUpdate:value": (a) => r("update:value", a)
        });
      if (zi(i, void 0))
        return wt(aie, {
          property: { ...o.value, type: i },
          value: u,
          state: n.state,
          "onUpdate:value": (a) => r("update:value", a)
        });
      const l = i;
      throw new Error(`SchemaFormPropertyInput missing case for ${l}`);
    });
    return (i, u) => (T(), O(Mr(s.value.component), yt(s.value.props, { class: "schema-form-property-input" }), null, 16));
  }
}), iie = {
  key: 0,
  class: "schema-form-property-errors"
}, uie = { key: 0 }, lie = { key: 1 }, cie = { key: 2 }, JN = /* @__PURE__ */ U({
  __name: "SchemaFormPropertyErrors",
  props: {
    errors: {}
  },
  setup(t) {
    return (e, n) => {
      const r = P("SchemaFormPropertyErrors", !0);
      return e.errors.length ? (T(), z("ul", iie, [
        (T(!0), z(ve, null, ln(e.errors, (o, s) => (T(), z(ve, { key: s }, [
          v(Ht)(o) ? (T(), z("li", uie, ie(o), 1)) : j("", !0),
          v(R2)(o) ? (T(), z("li", lie, [
            re("span", null, ie(o.property), 1),
            w(r, {
              errors: o.errors
            }, null, 8, ["errors"])
          ])) : j("", !0),
          v(A2)(o) ? (T(), z("li", cie, [
            re("span", null, "Index " + ie(o.index), 1),
            w(r, {
              errors: o.errors
            }, null, 8, ["errors"])
          ])) : j("", !0)
        ], 64))), 128))
      ])) : j("", !0);
    };
  }
}), pie = /* @__PURE__ */ U({
  __name: "SchemaFormPropertyKindJinja",
  props: {
    value: {},
    errors: {},
    state: {}
  },
  emits: ["update:value"],
  setup(t, { emit: e }) {
    const n = t, r = e, o = D({
      get() {
        return n.value.template;
      },
      set(s) {
        r("update:value", {
          __prefect_kind: "jinja",
          template: s
        });
      }
    });
    return (s, i) => {
      const u = P("p-code-input"), l = P("p-content");
      return T(), O(l, { class: "schema-form-property-kind-jinja" }, {
        default: k(() => [
          w(u, {
            modelValue: o.value,
            "onUpdate:modelValue": i[0] || (i[0] = (a) => o.value = a),
            lang: "jinja",
            state: s.state,
            "show-line-numbers": ""
          }, null, 8, ["modelValue", "state"]),
          w(JN, { errors: s.errors }, null, 8, ["errors"])
        ]),
        _: 1
      });
    };
  }
}), die = /* @__PURE__ */ U({
  __name: "SchemaFormPropertyKindJson",
  props: {
    value: {},
    errors: {},
    state: {}
  },
  emits: ["update:value"],
  setup(t, { emit: e }) {
    const n = t, r = e, o = D(() => qse(n.errors)), s = D({
      get() {
        return n.value.value;
      },
      set(i) {
        if (i?.length === 0) {
          r("update:value", {
            __prefect_kind: "json",
            value: void 0
          });
          return;
        }
        r("update:value", {
          __prefect_kind: "json",
          value: i
        });
      }
    });
    return (i, u) => {
      const l = P("p-code-input"), a = P("p-content");
      return T(), O(a, {
        secondary: "",
        class: "schema-form-property-kind-json"
      }, {
        default: k(() => [
          w(l, {
            modelValue: s.value,
            "onUpdate:modelValue": u[0] || (u[0] = (c) => s.value = c),
            lang: "json",
            state: i.state,
            "show-line-numbers": ""
          }, null, 8, ["modelValue", "state"]),
          w(JN, { errors: o.value }, null, 8, ["errors"])
        ]),
        _: 1
      });
    };
  }
}), e4 = /* @__PURE__ */ U({
  __name: "WorkspaceVariableCombobox",
  props: {
    selected: {},
    allowUnset: { type: Boolean }
  },
  emits: ["update:selected"],
  setup(t, { emit: e }) {
    const n = t, r = e, o = D({
      get() {
        return n.selected ?? null;
      },
      set(p) {
        r("update:selected", p);
      }
    }), s = ge(""), i = ns(s, 500), u = () => ({
      variables: {
        nameLike: i.value
      },
      limit: 20
    }), { variables: l, next: a } = TN(u, { mode: "infinite" }), c = D(() => {
      const p = l.value.map((d) => ({
        value: d.name,
        label: d.name
      }));
      return n.allowUnset && p.unshift({
        label: "None",
        value: null
      }), p;
    });
    return (p, d) => {
      const h = P("p-combobox");
      return T(), O(h, {
        modelValue: o.value,
        "onUpdate:modelValue": d[0] || (d[0] = (m) => o.value = m),
        search: s.value,
        "onUpdate:search": d[1] || (d[1] = (m) => s.value = m),
        class: "workspace-variable-combobox",
        options: c.value,
        manual: "",
        onBottom: v(a)
      }, null, 8, ["modelValue", "search", "options", "onBottom"]);
    };
  }
}), hie = /* @__PURE__ */ U({
  __name: "SchemaFormPropertyKindWorkspaceVariable",
  props: {
    value: {}
  },
  emits: ["update:value"],
  setup(t, { emit: e }) {
    const n = t, r = e, o = D({
      get() {
        return n.value.variable_name;
      },
      set(s) {
        r("update:value", {
          __prefect_kind: "workspace_variable",
          variable_name: s
        });
      }
    });
    return (s, i) => (T(), O(e4, {
      selected: o.value,
      "onUpdate:selected": i[0] || (i[0] = (u) => o.value = u),
      class: "schema-form-property-kind-workspace-variable"
    }, null, 8, ["selected"]));
  }
});
function I2(t, e, n) {
  return { input: D(() => {
    const o = Qe(t), s = Qe(n), { state: i } = D2(s);
    if (!xa(e.value))
      return wt(rM, {
        property: o,
        value: e.value,
        errors: s,
        state: i,
        "onUpdate:value": (l) => e.value = l
      });
    if (xa(e.value, "json"))
      return wt(die, {
        value: e.value,
        errors: s,
        state: i,
        "onUpdate:value": (l) => e.value = l
      });
    if (xa(e.value, "jinja"))
      return wt(pie, {
        value: e.value,
        errors: s,
        state: i,
        "onUpdate:value": (l) => e.value = l
      });
    if (xa(e.value, "workspace_variable"))
      return wt(hie, {
        value: e.value,
        "onUpdate:value": (l) => e.value = l
      });
    if (xa(e.value, "none"))
      return wt(rM, {
        property: o,
        value: e.value,
        errors: s,
        state: i,
        "onUpdate:value": (l) => e.value = l
      });
    const u = e.value;
    return console.error(new Error(`SchemaFormProperty input is not exhaustive: ${JSON.stringify(u)}`)), wt(() => "");
  }) };
}
const Uh = /* @__PURE__ */ U({
  __name: "SchemaInput",
  props: {
    schema: {},
    values: {},
    errors: {},
    kinds: {},
    skipDefaultValueInitialization: { type: Boolean }
  },
  emits: ["update:values"],
  setup(t, { emit: e }) {
    const n = t;
    EI(PN, {
      schema: n.schema,
      kinds: n.kinds,
      skipDefaultValueInitialization: n.skipDefaultValueInitialization
    });
    const r = e, o = D({
      get() {
        return n.values;
      },
      set(c) {
        r("update:values", c);
      }
    }), s = D(() => ey(() => n.values)), { errors: i, setKind: u } = S2({
      value: o,
      property: () => n.schema
    }), { input: l } = I2(() => n.schema, o, a);
    function a() {
      return i.value.length ? i.value : n.errors;
    }
    return (c, p) => {
      const d = P("p-content");
      return T(), O(d, { class: "schema-input" }, {
        default: k(() => [
          Ve(c.$slots, "default", {
            kind: s.value,
            setKind: v(u)
          }),
          (T(), O(Mr(v(l).component), sn(kn(v(l).props)), null, 16))
        ]),
        _: 3
      });
    };
  }
});
function Xh(t, e) {
  const n = Se(), r = ge([]), o = D(() => r.value.length === 0);
  async function s() {
    const l = Qe(t), a = Qe(e);
    if (Gt(l) || Gt(a))
      return !0;
    const { valid: c, errors: p } = await n.schemas.validateSchemaValues(a, l);
    return r.value = p, c;
  }
  function i() {
    r.value = [];
  }
  const u = __(s, 1e3);
  return Ct(() => Qe(e), () => {
    r.value.length && u();
  }, { deep: !0 }), {
    validate: s,
    errors: r,
    valid: o,
    reset: i
  };
}
const fie = /* @__PURE__ */ U({
  __name: "SchemaForm",
  props: {
    schema: {},
    values: {},
    kinds: {},
    loading: { type: [Boolean, null], default: null },
    validate: { type: Boolean }
  },
  emits: ["update:values", "update:loading", "submit"],
  setup(t, { emit: e }) {
    const n = t, r = e, o = D({
      get() {
        return n.values;
      },
      set(c) {
        r("update:values", c);
      }
    }), { errors: s, validate: i } = Xh(() => n.schema, o), u = ge(!1), l = D({
      get() {
        return n.loading ?? u.value;
      },
      set(c) {
        u.value = c, r("update:loading", c);
      }
    });
    async function a() {
      l.value = !0;
      try {
        if (n.validate && !await i())
          return;
      } catch (c) {
        console.error(c), He(Mm(u2), "error");
        return;
      } finally {
        l.value = !1;
      }
      r("submit", o.value);
    }
    return (c, p) => {
      const d = P("p-content"), h = P("p-form");
      return T(), O(h, {
        class: "schema-form",
        novalidate: "",
        onSubmit: a
      }, {
        default: k(() => [
          w(d, null, {
            default: k(() => [
              c.schema.properties ? (T(), O(Uh, {
                key: 0,
                values: o.value,
                "onUpdate:values": p[0] || (p[0] = (m) => o.value = m),
                schema: c.schema,
                errors: v(s),
                kinds: c.kinds
              }, {
                default: k((m) => [
                  Ve(c.$slots, "default", sn(kn(m)))
                ]),
                _: 3
              }, 8, ["values", "schema", "errors", "kinds"])) : j("", !0),
              Ve(c.$slots, "after-content")
            ]),
            _: 3
          })
        ]),
        _: 3
      });
    };
  }
}), mie = function(t) {
  return new Cee({
    id: t.id,
    created: this.map("string", t.created, "Date"),
    createdBy: this.map("CreatedOrUpdatedByResponse", t.created_by, "CreatedOrUpdatedBy"),
    updated: this.map("string", t.updated, "Date"),
    updatedBy: this.map("CreatedOrUpdatedByResponse", t.updated_by, "CreatedOrUpdatedBy"),
    name: t.name,
    version: t.version,
    versionInfo: t.version_info == null ? null : this.map("DeploymentVersionInfoResponse", t.version_info, "DeploymentVersionInfo"),
    description: t.description,
    flowId: t.flow_id,
    versionId: t.version_id,
    paused: t.paused,
    schedules: t.schedules.map((e) => this.map("DeploymentScheduleResponse", e, "DeploymentSchedule")),
    parameters: t.parameters,
    parameterOpenApiSchema: jx.map("SchemaResponse", t.parameter_openapi_schema ?? {}, "Schema"),
    tags: t.tags ? Ph(t.tags) : null,
    manifestPath: t.manifest_path,
    path: t.path,
    entrypoint: t.entrypoint,
    storageDocumentId: t.storage_document_id,
    infrastructureDocumentId: t.infrastructure_document_id,
    jobVariables: t.job_variables,
    workQueueName: t.work_queue_name,
    workPoolName: t.work_pool_name,
    enforceParameterSchema: t.enforce_parameter_schema,
    pullSteps: t.pull_steps,
    can: Ac(),
    status: this.map("ServerDeploymentStatus", t.status, "DeploymentStatus"),
    disabled: t.disabled ?? !1,
    globalConcurrencyLimit: this.map("ConcurrencyV2LimitResponse", t.global_concurrency_limit, "ConcurrencyV2Limit"),
    concurrencyOptions: t.concurrency_options == null ? null : yie(t.concurrency_options)
  });
};
function yie(t) {
  return {
    collisionStrategy: t.collision_strategy
  };
}
const gie = function(t) {
  return {
    description: t.description,
    parameters: t.parameters,
    paused: t.paused,
    tags: t.tags,
    work_queue_name: t.workQueueName,
    work_pool_name: t.workPoolName,
    job_variables: t.jobVariables,
    enforce_parameter_schema: t.enforceParameterSchema,
    concurrency_limit: t.concurrencyLimit,
    concurrency_options: t.concurrencyOptions == null ? null : t4(t.concurrencyOptions)
  };
}, vie = function(t) {
  return {
    name: t.name,
    parameters: t.parameters,
    idempotency_key: t.idempotencyKey,
    context: t.context,
    tags: t.tags,
    parent_task_run_id: t.parentTaskRunId,
    infrastructure_document_id: t.infrastructureDocumentId,
    state: this.map("StateCreate", t.state, "StateRequest"),
    empirical_policy: this.map("EmpiricalPolicy", t.empiricalPolicy, "EmpiricalPolicyRequest"),
    work_queue_name: t.workQueueName,
    job_variables: t.jobVariables,
    enforce_parameter_schema: t.enforceParameterSchema
  };
}, _ie = function(t) {
  return {
    name: t.name,
    description: t.description,
    flow_id: t.flowId,
    parameters: t.parameters,
    tags: t.tags,
    storage_document_id: t.storageDocumentId,
    infrastructure_document_id: t.infrastructureDocumentId,
    work_queue_name: t.workQueueName,
    work_pool_name: t.workPoolName,
    job_variables: t.jobVariables,
    enforce_parameter_schema: t.enforceParameterSchema,
    path: t.path,
    pull_steps: t.pullSteps,
    manifest_path: t.manifestPath,
    parameter_openapi_schema: t.parameterOpenApiSchema,
    entrypoint: t.entrypoint,
    version: t.version,
    paused: t.paused,
    concurrency_limit: t.concurrencyLimit,
    concurrency_options: t.concurrencyOptions == null ? null : t4(t.concurrencyOptions)
  };
};
function t4(t) {
  return {
    collision_strategy: t.collisionStrategy
  };
}
const wie = function(t) {
  return new Fee({
    id: t.id,
    created: this.map("string", t.created, "Date"),
    createdBy: this.map("CreatedOrUpdatedByResponse", t.created_by, "CreatedOrUpdatedBy"),
    updated: this.map("string", t.updated, "Date"),
    updatedBy: this.map("CreatedOrUpdatedByResponse", t.updated_by, "CreatedOrUpdatedBy"),
    lastActive: this.map("string", t.last_active, "Date"),
    name: t.name,
    deploymentId: t.deployment_id,
    description: t.description,
    versionInfo: this.map("DeploymentVersionInfoResponse", t.version_info, "DeploymentVersionInfo"),
    tags: t.tags ? Ph(t.tags) : null,
    labels: t.labels,
    entrypoint: t.entrypoint,
    pullSteps: t.pull_steps,
    parameters: t.parameters,
    parameterOpenApiSchema: jx.map("SchemaResponse", t.parameter_openapi_schema ?? {}, "Schema"),
    jobVariables: t.job_variables,
    workQueueName: t.work_queue_name,
    workPoolName: t.work_pool_name,
    enforceParameterSchema: t.enforce_parameter_schema
  });
}, bie = function(t) {
  return ZJ(t, (e) => Pte(e));
}, kie = function(t) {
  return new Oee({
    id: t.id,
    created: this.map("string", t.created, "Date"),
    updated: this.map("string", t.updated, "Date"),
    slug: t.slug ?? null,
    active: t.active,
    schedule: this.map("ScheduleResponse", t.schedule, "Schedule"),
    jobVariables: t.job_variables ?? {},
    parameters: t.parameters ?? {}
  });
}, Tie = function(t) {
  return {
    slug: t.slug ?? null,
    active: t.active,
    schedule: this.map("Schedule", t.schedule, "ScheduleRequest"),
    job_variables: t.jobVariables,
    parameters: t.parameters
  };
}, xie = function(t) {
  return {
    slug: t.slug ?? null,
    active: t.active,
    schedule: this.map("Schedule", t.schedule, "ScheduleRequest"),
    job_variables: t.jobVariables,
    parameters: t.parameters
  };
}, Sie = function(t) {
  const e = /* @__PURE__ */ new Date();
  return {
    deployments: {
      id: [t.deploymentId]
    },
    flowRuns: {
      expectedStartTimeAfter: O0(e, t.timeSpanInSeconds),
      expectedStartTimeBefore: e
    }
  };
}, Rie = function(t) {
  return t.toLowerCase();
}, Aie = function(t) {
  return t.toUpperCase();
}, Die = function(t) {
  return {
    intervalStart: t.intervalStart,
    intervalEnd: t.intervalEnd,
    data: t.states.reduce((e, n) => (e[n.stateType] = n.countRuns, e), {})
  };
}, Eie = function(t) {
  return new Lee({
    retries: t.retries,
    retryDelay: t.retry_delay,
    maxRetries: t.max_retries,
    retryJitterFactor: t.retry_jitter_factor,
    retryDelaySeconds: t.retry_delay_seconds
  });
}, Mie = function(t) {
  return {
    retries: t.retries,
    retry_delay: t.retryDelay,
    max_retries: t.maxRetries,
    retry_jitter_factor: t.retryJitterFactor,
    retry_delay_seconds: t.retryDelaySeconds
  };
}, Pie = function(t) {
  return {
    retries: t.retries,
    retry_delay: t.retryDelay,
    pause_keys: [],
    resuming: !1
  };
};
function zr(t) {
  return typeof t > "u" ? t : { operator: `${t}_` };
}
function Nt(t) {
  if (typeof t > "u")
    return t;
  if (t.length !== 0)
    return { any_: t };
}
function n4(t) {
  if (typeof t > "u")
    return t;
  if (t.length !== 0)
    return { not_any_: t };
}
function r4(t) {
  if (typeof t > "u")
    return t;
  if (t.length !== 0)
    return { all_: t };
}
function oi(t) {
  return typeof t > "u" ? t : { is_null_: t };
}
function mu(t) {
  if (t)
    return { like_: t };
}
function Kl(t) {
  return typeof t > "u" ? t : { before_: t.toISOString() };
}
function Zl(t) {
  return typeof t > "u" ? t : { after_: t.toISOString() };
}
function o4(t) {
  return typeof t > "u" ? t : { exists_: t };
}
function Ik(t) {
  return typeof t > "u" ? t : { eq_: t };
}
function Cie(t) {
  return typeof t > "u" ? t : { eq_: t };
}
function Oie(t) {
  return typeof t > "u" ? t : { ge_: t };
}
function Iie(t) {
  return typeof t > "u" ? t : { le_: t };
}
function Fie(t) {
  return typeof t > "u" ? t : { startswith_: Sa(t) };
}
const Nie = function(t) {
  return {
    ...zr(t.operator),
    ...r4(t.name),
    ...Nt(t.anyName),
    ...oi(t.isNull)
  };
}, Lie = function(t) {
  return Wn({
    ...zr(t.operator),
    type: Nt(t.type?.map((e) => e.toUpperCase())),
    name: Nt(t.name)
  });
}, Bie = function(t) {
  return Wn({
    ...zr(t.operator),
    id: Nt(t.id),
    name: {
      ...Nt(t.name),
      ...mu(t.nameLike)
    },
    tags: this.map("TagFilter", t.tags, "TagFilterRequest")
  });
}, Uie = function(t) {
  if (!t.deploymentId) {
    console.warn("Deployment ID is required for deployment version ID filter");
    return;
  }
  return Wn({
    ...zr(t.operator),
    deployment_id: t.deploymentId,
    ...Nt(t.versionId)
  });
}, Xie = function(t) {
  if (!t.deploymentId) {
    console.warn("Deployment ID is required for deployment version info filter");
    return;
  }
  return Wn({
    ...zr(t.operator),
    deployment_id: t.deploymentId,
    any_: t.versionInfo?.map((e) => ({
      ...e,
      type: e.type,
      version: e.version
    }))
  });
}, $ie = function(t) {
  return Wn({
    ...zr(t.operator),
    id: {
      ...Nt(t.id),
      ...n4(t.notId)
    },
    name: {
      ...Nt(t.name),
      ...mu(t.nameLike)
    },
    tags: this.map("TagFilter", t.tags, "TagFilterRequest"),
    deployment_id: {
      ...zr(t.deploymentIdOperator),
      ...Nt(t.deploymentId),
      ...oi(t.deploymentIdNull)
    },
    deployment_version_id: Object.keys(Wn(t.deploymentVersionId ?? {})).length > 0 ? this.map("DeploymentVersionIdFilter", t.deploymentVersionId, "DeploymentVersionIdFilterRequest") : void 0,
    deployment_version_info: Object.keys(Wn(t.deploymentVersionInfo ?? {})).length > 0 ? this.map("DeploymentVersionInfoFilter", t.deploymentVersionInfo, "DeploymentVersionInfoFilterRequest") : void 0,
    work_queue_name: {
      ...zr(t.workQueueNameOperator),
      ...Nt(t.workQueueName),
      ...oi(t.workQueueNameIsNull)
    },
    work_queue_id: {
      ...zr(t.workQueueIdOperator),
      ...Nt(t.workQueueId),
      ...oi(t.workQueueIdNull)
    },
    state: this.map("StateFilter", t.state, "StateFilterRequest"),
    flow_version: Nt(t.flowVersion),
    start_time: {
      ...Kl(t.startTimeBefore),
      ...Zl(t.startTimeAfter),
      ...oi(t.startTimeNull)
    },
    end_time: {
      ...Kl(t.endTimeBefore),
      ...Zl(t.endTimeAfter),
      ...oi(t.endTimeNull)
    },
    expected_start_time: {
      ...Kl(t.expectedStartTimeBefore),
      ...Zl(t.expectedStartTimeAfter)
    },
    next_scheduled_start_time: {
      ...Kl(t.nextExpectedStartTimeBefore),
      ...Zl(t.nextExpectedStartTimeAfter)
    },
    parent_task_run_id: {
      ...zr(t.parentTaskRunIdOperator),
      ...Nt(t.parentTaskRunId),
      ...oi(t.parentTaskRunIdNull)
    },
    parent_flow_run_id: {
      ...Nt(t.parentFlowRunId)
    }
  });
}, Wie = function(t) {
  return Wn({
    ...zr(t.operator),
    id: Nt(t.id),
    name: {
      ...Nt(t.name),
      ...mu(t.nameLike)
    },
    tags: this.map("TagFilter", t.tags, "TagFilterRequest"),
    state: this.map("StateFilter", t.state, "StateFilterRequest"),
    start_time: {
      ...Kl(t.startTimeBefore),
      ...Zl(t.startTimeAfter),
      ...oi(t.startTimeNull)
    },
    subflow_runs: o4(t.subFlowRunsExist),
    flow_run_id: {
      ...zr(t.flowRunIdOperator),
      ...Nt(t.flowRunId),
      ...oi(t.flowRunIdNull)
    },
    expected_start_time: {
      ...Kl(t.expectedStartTimeBefore),
      ...Zl(t.expectedStartTimeAfter),
      ...oi(t.expectedStartTimeNull)
    }
  });
}, Vie = function(t) {
  return Wn({
    ...zr(t.operator),
    tags: this.map("TagFilter", t.tags, "TagFilterRequest"),
    id: Nt(t.id),
    name: {
      ...Nt(t.name),
      ...mu(t.nameLike)
    },
    is_schedule_active: Ik(t.isScheduleActive),
    work_queue_name: Nt(t.workQueueName),
    flow_or_deployment_name: mu(t.flowOrDeploymentNameLike),
    status: Nt(t.status),
    paused: Ik(t.paused),
    work_queue_id: Nt(t.workQueueId)
  });
}, Hie = function(t) {
  return {
    ...zr(t.operator),
    id: Nt(t.id),
    name: Nt(t.name),
    type: Nt(t.type)
  };
}, jie = function(t) {
  return {
    ...zr(t.operator),
    id: Nt(t.id),
    name: Nt(t.name)
  };
}, zie = function(t) {
  return {
    id: Nt(t.id),
    key: {
      ...o4(t.keyExists),
      ...Nt(t.key),
      ...mu(t.keyLike)
    },
    type: {
      ...Nt(t.type),
      ...n4(t.notType)
    },
    flow_run_id: Nt(t.flowRunId),
    task_run_id: Nt(t.taskRunId)
  };
}, qie = function(t) {
  return {
    artifacts: this.map("ArtifactFilter", t.artifacts, "ArtifactFilterRequest"),
    flow_runs: this.map("FlowRunFilter", t.flowRuns, "FlowRunFilterRequest"),
    task_runs: this.map("TaskRunFilter", t.taskRuns, "TaskRunFilterRequest"),
    sort: t.sort,
    limit: t.limit,
    offset: t.offset
  };
}, Gie = function(t) {
  return {
    id: Nt(t.id),
    name: {
      ...Nt(t.name),
      ...mu(t.nameLike)
    },
    tags: this.map("TagFilter", t.tags, "TagFilterRequest")
  };
}, Yie = function(t) {
  return {
    variables: this.map("VariableFilter", t.variables, "VariableFilterRequest"),
    sort: t.sort,
    limit: t.limit,
    offset: t.offset
  };
}, Qie = function(t) {
  return Wn({
    flows: this.map("FlowFilter", t.flows, "FlowFilterRequest"),
    flow_runs: this.map("FlowRunFilter", t.flowRuns, "FlowRunFilterRequest"),
    task_runs: this.map("TaskRunFilter", t.taskRuns, "TaskRunFilterRequest"),
    deployments: this.map("DeploymentFilter", t.deployments, "DeploymentFilterRequest"),
    work_pools: this.map("WorkPoolFilter", t.workPools, "WorkPoolFilterRequest"),
    work_pool_queues: this.map("WorkPoolQueueFilter", t.workPoolQueues, "WorkPoolQueueFilterRequest"),
    sort: t.sort,
    limit: t.limit,
    offset: t.offset
  });
}, Kie = function(t) {
  return Wn({
    flows: this.map("FlowFilter", t.flows, "FlowFilterRequest"),
    flow_runs: this.map("FlowRunFilter", t.flowRuns, "FlowRunFilterRequest"),
    task_runs: this.map("TaskRunFilter", t.taskRuns, "TaskRunFilterRequest"),
    deployments: this.map("DeploymentFilter", t.deployments, "DeploymentFilterRequest"),
    work_pools: this.map("WorkPoolFilter", t.workPools, "WorkPoolFilterRequest"),
    work_pool_queues: this.map("WorkPoolQueueFilter", t.workPoolQueues, "WorkPoolQueueFilterRequest"),
    sort: t.sort,
    limit: t.limit,
    offset: t.offset
  });
}, Zie = function(t) {
  const { offset: e, ...n } = this.map("FlowsFilter", t, "FlowsFilterRequest");
  return {
    ...n,
    page: t.page
  };
}, Jie = function(t) {
  const { offset: e, ...n } = this.map("FlowRunsFilter", t, "FlowRunsFilterRequest");
  return {
    ...n,
    page: t.page
  };
}, eue = function(t) {
  const { offset: e, ...n } = this.map("TaskRunsFilter", t, "TaskRunsFilterRequest");
  return {
    ...n,
    page: t.page
  };
}, tue = function(t) {
  const { offset: e, ...n } = this.map("DeploymentsFilter", t, "DeploymentsFilterRequest");
  return {
    ...n,
    page: t.page
  };
}, nue = function(t) {
  const { historyStart: e, historyEnd: n, historyIntervalSeconds: r, ...o } = t;
  return Wn({
    ...this.map("FlowRunsFilter", o, "FlowRunsFilterRequest"),
    history_start: this.map("Date", e, "string"),
    history_end: this.map("Date", n, "string"),
    history_interval_seconds: r
  });
}, rue = function(t) {
  return Wn({
    flows: this.map("FlowFilter", t.flows, "FlowFilterRequest"),
    flow_runs: this.map("FlowRunFilter", t.flowRuns, "FlowRunFilterRequest"),
    task_runs: this.map("TaskRunFilter", t.taskRuns, "TaskRunFilterRequest"),
    deployments: this.map("DeploymentFilter", t.deployments, "DeploymentFilterRequest"),
    work_pools: this.map("WorkPoolFilter", t.workPools, "WorkPoolFilterRequest"),
    work_pool_queues: this.map("WorkPoolQueueFilter", t.workPoolQueues, "WorkPoolQueueFilterRequest"),
    sort: t.sort,
    limit: t.limit,
    offset: t.offset
  });
}, oue = function(t) {
  return Wn({
    flows: this.map("FlowFilter", t.flows, "FlowFilterRequest"),
    flow_runs: this.map("FlowRunFilter", t.flowRuns, "FlowRunFilterRequest"),
    task_runs: this.map("TaskRunFilter", t.taskRuns, "TaskRunFilterRequest"),
    deployments: this.map("DeploymentFilter", t.deployments, "DeploymentFilterRequest"),
    work_pools: this.map("WorkPoolFilter", t.workPools, "WorkPoolFilterRequest"),
    work_pool_queues: this.map("WorkPoolQueueFilter", t.workPoolQueues, "WorkPoolQueueFilterRequest"),
    sort: t.sort,
    limit: t.limit,
    offset: t.offset
  });
}, sue = function(t) {
  return {
    name: mu(t.nameLike),
    slug: Nt(t.slug)
  };
}, aue = function(t) {
  return {
    ...zr(t.operator),
    block_type_id: Nt(t.blockTypeId),
    block_capabilities: r4(t.blockCapabilities),
    id: Nt(t.id),
    version: Nt(t.version)
  };
}, iue = function(t) {
  return {
    ...zr(t.operator),
    id: Nt(t.id),
    is_anonymous: Cie(t.isAnonymous),
    block_type_id: Nt(t.blockTypeId),
    name: {
      ...Nt(t.name),
      ...mu(t.nameLike)
    }
  };
}, uue = function(t) {
  return Wn({
    flow_run_notification_policy_filter: {
      is_active: Ik(t.notification?.isActive)
    },
    offset: t.offset,
    limit: t.limit
  });
}, lue = function(t) {
  return {
    offset: t.offset,
    limit: t.limit
  };
}, cue = function(t) {
  return Wn({
    logs: {
      ...zr(t.logs?.operator),
      level: {
        ...Oie(t.logs?.levelGreaterThan),
        ...Iie(t.logs?.levelLessThan)
      },
      timestamp: {
        ...Kl(t.logs?.timestampBefore),
        ...Zl(t.logs?.timestampAfter)
      },
      flow_run_id: Nt(t.logs?.flowRunId),
      task_run_id: {
        ...Nt(t.logs?.taskRunId),
        ...oi(t.logs?.taskRunIdNull)
      },
      worker_id: Nt(t.logs?.workerId)
    },
    sort: t.sort,
    offset: t.offset,
    limit: t.limit
  });
}, pue = function(t) {
  return Wn({
    block_types: this.map("BlockTypeFilter", t.blockTypes, "BlockTypeFilterRequest"),
    block_schemas: this.map("BlockSchemaFilter", t.blockSchemas, "BlockSchemaFilterRequest"),
    offset: t.offset,
    limit: t.limit
  });
}, due = function(t) {
  return Wn({
    block_schemas: this.map("BlockSchemaFilter", t.blockSchemas, "BlockSchemaFilterRequest"),
    offset: t.offset,
    limit: t.limit
  });
}, hue = function(t) {
  return Wn({
    block_documents: this.map("BlockDocumentFilter", t.blockDocuments, "BlockDocumentFilterRequest"),
    block_schemas: this.map("BlockSchemaFilter", t.blockSchemas, "BlockSchemaFilterRequest"),
    block_types: this.map("BlockTypeFilter", t.blockTypes, "BlockTypeFilterRequest"),
    include_secrets: t.includeSecrets,
    offset: t.offset,
    limit: t.limit
  });
}, fue = function(t) {
  return Wn({
    work_pools: this.map("WorkPoolFilter", t.workPools, "WorkPoolFilterRequest"),
    offset: t.offset,
    limit: t.limit
  });
}, mue = function(t) {
  return Wn({
    ...zr(t.operator),
    last_heartbeat_time: {
      ...Zl(t.lastHeartbeatTimeAfter),
      ...Kl(t.lastHeartbeatTimeBefore)
    },
    name: mu(t.name),
    status: Nt(
      t.status ? [this.map("WorkPoolWorkerStatus", t.status, "ServerWorkPoolWorkerStatus")] : void 0
    )
  });
}, yue = function(t) {
  return Wn({
    workers: this.map("WorkersFilter", t.workers, "WorkersFilterRequest"),
    limit: t.limit,
    offset: t.offset
  });
}, gue = function(t) {
  return Wn({
    workers: this.map("WorkersFilter", t.workers, "WorkersFilterRequest"),
    sort: t.sort,
    page: t.page,
    limit: t.limit
  });
}, vue = function(t) {
  return Wn({
    work_queues: {
      ...zr(t.workQueues?.operator),
      id: Nt(t.workQueues?.id),
      name: {
        ...Nt(t.workQueues?.name),
        ...Fie(t.workQueues?.nameStartsWith)
      }
    },
    offset: t.offset,
    limit: t.limit
  });
}, _ue = function(t) {
  return {
    history_start: this.map("Date", t.historyStart, "string"),
    history_end: this.map("Date", t.historyEnd, "string"),
    history_interval_seconds: t.historyIntervalSeconds,
    flows: this.map("FlowFilter", t.flows, "FlowFilterRequest"),
    deployments: this.map("DeploymentFilter", t.deployments, "DeploymentFilterRequest"),
    flow_runs: this.map("FlowRunFilter", t.flowRuns, "FlowRunFilterRequest"),
    task_runs: this.map("TaskRunFilter", t.taskRuns, "TaskRunFilterRequest")
  };
}, wue = function(t) {
  return new tF({
    id: t.id,
    name: t.name,
    description: t.description,
    created: this.map("string", t.created, "Date"),
    updated: this.map("string", t.updated, "Date")
  });
}, bue = function(t) {
  return {
    id: t.id,
    name: t.name,
    description: t.description,
    created: this.map("Date", t.created, "string"),
    updated: this.map("Date", t.updated, "string")
  };
}, kue = function(t) {
  return new $o({
    posture: "Reactive",
    match: {
      "prefect.resource.id": "prefect.flow-run.*"
    },
    matchRelated: {
      "prefect.resource.role": "flow",
      "prefect.resource.id": `prefect.flow.${t.id}`
    },
    forEach: ["prefect.resource.id"]
  });
}, Tue = function(t) {
  return new nF({
    id: t.id,
    deploymentId: t.deployment_id,
    flowId: t.flow_id,
    deploymentVersionId: t.deployment_version_id,
    flowName: t.flow_name,
    flowVersion: t.flow_version,
    idempotencyKey: t.idempotency_key,
    expectedStartTime: this.map("string", t.expected_start_time, "Date"),
    nextScheduledStartTime: this.map("string", t.next_scheduled_start_time, "Date"),
    parameters: t.parameters,
    autoScheduled: t.auto_scheduled,
    context: t.context,
    empiricalConfig: t.empirical_config,
    empiricalPolicy: this.map("EmpiricalPolicyResponse", t.empirical_policy, "EmpiricalPolicy"),
    estimatedRunTime: t.estimated_run_time,
    estimatedStartTimeDelta: t.estimated_start_time_delta,
    totalRunTime: t.total_run_time,
    startTime: this.map("string", t.start_time, "Date"),
    endTime: this.map("string", t.end_time, "Date"),
    name: t.name,
    parentTaskRunId: t.parent_task_run_id,
    stateId: t.state_id,
    stateName: t.state_name,
    stateType: this.map("ServerStateType", t.state_type, "StateType"),
    state: this.map("StateResponse", t.state, "State"),
    tags: t.tags ? Ph(t.tags) : null,
    runCount: t.run_count,
    created: this.map("string", t.created, "Date"),
    createdBy: this.map("CreatedOrUpdatedByResponse", t.created_by, "CreatedOrUpdatedBy"),
    updated: this.map("string", t.updated, "Date"),
    workQueueName: t.work_queue_name,
    workPoolName: t.work_pool_name,
    workPoolQueueName: t.work_pool_queue_name,
    jobVariables: t.job_variables ?? {}
  });
}, xue = function(t) {
  return new aF({
    intervalStart: this.map("string", t.interval_start, "Date"),
    intervalEnd: this.map("string", t.interval_end, "Date"),
    states: this.map("StateHistoryResponse", t.states, "StateHistory")
  });
}, Sue = function(t) {
  return {
    interval_start: this.map("Date", t.intervalStart, "string"),
    interval_end: this.map("Date", t.intervalEnd, "string"),
    states: this.map("StateHistory", t.states, "StateHistoryResponse")
  };
}, Rue = function(t) {
  const { startDate: e, endDate: n } = this.map("DateRangeSelectValue", t.range, "DateRange");
  return {
    flows: {
      id: [t.flowId]
    },
    flowRuns: {
      startTimeAfter: e,
      startTimeBefore: n
    }
  };
}, Aue = function(t) {
  const { startDate: e, endDate: n } = this.map("DateRangeSelectValue", t.range, "DateRange");
  return {
    flows: {
      id: [t.flowId]
    },
    taskRuns: {
      startTimeAfter: e,
      startTimeBefore: n
    }
  };
}, Due = function(t) {
  return new rF({
    id: t.id,
    created: this.map("string", t.created, "Date"),
    updated: this.map("string", t.updated, "Date"),
    name: t.name,
    level: t.level,
    message: t.message,
    timestamp: this.map("string", t.timestamp, "Date"),
    flowRunId: t.flow_run_id,
    taskRunId: t.task_run_id,
    workerId: t.worker_id
  });
}, Eue = function(t) {
  return {
    id: t.id,
    created: this.map("Date", t.created, "string"),
    updated: this.map("Date", t.updated, "string"),
    name: t.name,
    level: t.level,
    message: t.message,
    timestamp: this.map("Date", t.timestamp, "string"),
    flow_run_id: t.flowRunId,
    task_run_id: t.taskRunId,
    worker_id: t.workerId
  };
}, Mue = function(t) {
  return {
    description: t.description,
    response: t.response,
    schema: t.schema
  };
}, Pue = function(t) {
  return {
    description: t.description,
    response: t.response,
    schema: t.schema
  };
}, Cue = function(t) {
  return {
    id: t.id,
    flowId: t.flow_id,
    name: t.name,
    stateName: t.state_name,
    stateType: this.map("ServerStateType", t.state_type, "StateType"),
    nextScheduledStartTime: this.map("string", t.next_scheduled_start_time, "Date")
  };
}, Oue = function(t) {
  return new oF({
    id: t.id,
    created: this.map("string", t.created, "Date"),
    updated: this.map("string", t.updated, "Date"),
    isActive: t.is_active,
    stateNames: t.state_names,
    tags: Ph(t.tags),
    blockDocumentId: t.block_document_id
  });
}, Iue = function(t) {
  return {
    state_names: t.stateNames ?? [],
    tags: t.tags ?? [],
    is_active: !0,
    block_document_id: t.blockDocumentId
  };
}, Fue = function(t) {
  return {
    state_names: t.stateNames,
    tags: t.tags,
    is_active: t.isActive,
    block_document_id: t.blockDocumentId
  };
}, Nue = function(t) {
  return parseFloat(t);
}, Lue = function(t) {
  return t.toLocaleString();
}, Bue = function(t) {
  return {
    status: t.status,
    details: t.details
  };
}, Uue = function(t) {
  const e = this.map("FlowRunResponse", t.results, "FlowRun");
  return {
    ...t,
    results: e
  };
}, Xue = function(t) {
  const e = this.map("TaskRunResponse", t.results, "TaskRun");
  return {
    ...t,
    results: e
  };
}, $ue = function(t) {
  const e = this.map("FlowResponse", t.results, "Flow");
  return {
    ...t,
    results: e
  };
}, Wue = function(t) {
  const e = this.map("DeploymentResponse", t.results, "Deployment");
  return {
    ...t,
    results: e
  };
}, Vue = function(t) {
  const e = t.artifacts?.map((n) => this.map("RunGraphArtifactResponse", n, "RunGraphArtifact")) ?? [];
  return {
    kind: t.kind,
    id: t.id,
    label: t.label,
    state_type: t.state_type,
    state_name: t.state_name,
    start_time: this.map("string", t.start_time, "Date"),
    end_time: this.map("string", t.end_time, "Date"),
    parents: t.parents,
    children: t.children,
    artifacts: e
  };
}, Hue = function(t) {
  const e = i2(t.type) ? t.type : "unknown";
  return e === "progress" ? {
    id: t.id,
    created: this.map("string", t.created, "Date"),
    key: t.key,
    type: "progress",
    data: t.data ?? 0
  } : {
    id: t.id,
    created: this.map("string", t.created, "Date"),
    key: t.key,
    type: e
  };
}, jue = function(t) {
  return {
    id: t.id,
    timestamp: this.map("string", t.timestamp, "Date"),
    type: t.type,
    name: t.name
  };
}, zue = function(t) {
  const { graph: e, nestedTaskRunGraphs: n } = t, r = new Map(e.nodes.map(([u, l]) => [
    u,
    this.map("RunGraphNodeResponse", l, "RunGraphNode")
  ])), o = /* @__PURE__ */ new Map();
  if (n) {
    const u = [];
    for (const [l, a] of e.nodes) {
      if (a.encapsulating?.length !== 1)
        continue;
      const c = a.encapsulating[0].id, p = r.get(c), d = r.get(l);
      if (!p)
        throw new Error("parent node not found");
      if (!d)
        throw new Error("node not found");
      const h = o.get(c) ?? que(p, o);
      h.nodes.set(l, d), e.root_node_ids.includes(l) && h.root_node_ids.push(l), o.set(c, h), u.push(l);
    }
    for (const l of u)
      r.delete(l);
  }
  const s = e.artifacts?.map((u) => this.map("RunGraphArtifactResponse", u, "RunGraphArtifact")) ?? [], i = e.states?.map((u) => this.map("RunGraphStateResponse", u, "RunGraphStateEvent")) ?? [];
  return {
    root_node_ids: e.root_node_ids,
    start_time: this.map("string", e.start_time, "Date"),
    end_time: this.map("string", e.end_time, "Date"),
    nodes: r,
    artifacts: s,
    states: i,
    nested_task_run_graphs: o
  };
};
function que(t, e) {
  return {
    root_node_ids: [],
    start_time: t.start_time,
    end_time: t.end_time,
    nodes: /* @__PURE__ */ new Map(),
    nested_task_run_graphs: e
  };
}
const Gue = function(t) {
  return new Yx({
    id: t.id,
    name: t.name,
    filters: Que(t.filters)
  });
}, Yue = function(t) {
  const e = {};
  t.deployment?.length && (e.deployment = t.deployment), t.flow?.length && (e.flow = t.flow), t.workPool?.length && (e.workPool = t.workPool), t.workQueue?.length && (e.workQueue = t.workQueue), t.tag?.length && (e.tag = t.tag), t.state?.length && (e.state = t.state);
  const { range: n } = t;
  switch (n.type) {
    case "around":
      e.type = "around", e.date = this.map("Date", n.date, "string"), e.unit = n.unit, e.quantity = n.quantity.toString();
      break;
    case "period":
      e.type = "period", e.period = n.period;
      break;
    case "range":
      e.type = "range", e.startDate = this.map("Date", n.startDate, "string"), e.endDate = this.map("Date", n.endDate, "string");
      break;
    case "span":
      e.type = "span", e.seconds = n.seconds.toString();
      break;
    default:
      const r = n;
      throw new Error(`Mapping saved search filters.range missing case for: ${r.type}`);
  }
  return e;
};
function Que(t = []) {
  return {
    state: Kue(t),
    flow: Ed(t, "flow"),
    tag: Ed(t, "tag"),
    deployment: Ed(t, "deployment"),
    workQueue: Ed(t, "workQueue"),
    workPool: Ed(t, "workPool"),
    range: Zue(t)
  };
}
function Ed(t, e) {
  const n = t.find((r) => r.property === e);
  return !n || !(Ht(n.value) || T0(n.value)) ? [] : tl(n.value);
}
function Kue(t) {
  return Ed(t, "state").map((n) => SF(n));
}
function Zue(t) {
  const e = t.find((o) => o.property === "range");
  if (!e || !hee(e.value))
    return h_;
  const n = e.value;
  if (z3(n))
    return {
      type: "range",
      startDate: ye.map("string", n.startDate, "Date"),
      endDate: ye.map("string", n.endDate, "Date")
    };
  if (G3(n))
    return {
      type: "around",
      date: ye.map("string", n.date, "Date"),
      unit: n.unit,
      quantity: n.quantity
    };
  if (j3(n) || q3(n))
    return n;
  const r = n;
  throw new Error(`No handler for date range type: ${r.type}`);
}
const Jue = function(t) {
  return {
    name: t.name,
    filters: ele(t.filters)
  };
};
function ele(t) {
  return t ? [
    bd(t, "flow"),
    bd(t, "tag"),
    bd(t, "deployment"),
    bd(t, "workPool"),
    bd(t, "workQueue"),
    bd(t, "workQueue"),
    tle(t.range)
  ].filter(ri) : [];
}
function bd(t, e) {
  const n = t[e];
  return Tc(n) ? null : { property: e, value: n, object: "flowRun", type: "", operation: "" };
}
function tle(t) {
  return t ? {
    property: "range",
    value: nle(t),
    object: "flowRun",
    type: "",
    operation: ""
  } : null;
}
function nle(t) {
  return t.type === "range" ? { type: "range", startDate: t.startDate.toISOString(), endDate: t.endDate.toISOString() } : t.type === "around" ? { type: "around", date: t.date.toISOString(), unit: t.unit, quantity: t.quantity } : t;
}
const rle = function(t) {
  const e = t.flow?.length ? t.flow : void 0, n = t.deployment?.length ? t.deployment : void 0, r = t.workPool?.length ? t.workPool : void 0, o = t.tag?.length ? t.tag : void 0, s = t.state?.length ? t.state : void 0, { startDate: i, endDate: u } = this.map("DateRangeSelectValue", t.range, "DateRange");
  return {
    flows: {
      id: e
    },
    deployments: {
      id: n
    },
    workPools: {
      name: r
    },
    flowRuns: {
      tags: {
        name: o
      },
      state: {
        name: s
      },
      startTimeAfter: i,
      startTimeBefore: u
    }
  };
}, ole = function(t) {
  const e = t.flow?.length ? t.flow : void 0, n = t.deployment?.length ? t.deployment : void 0, r = t.workPool?.length ? t.workPool : void 0, o = t.tag?.length ? t.tag : void 0, s = t.state?.length ? t.state : void 0, { startDate: i, endDate: u } = this.map("DateRangeSelectValue", t.range, "DateRange");
  return {
    flows: {
      id: e
    },
    deployments: {
      id: n
    },
    workPools: {
      name: r
    },
    taskRuns: {
      tags: {
        name: o
      },
      state: {
        name: s
      },
      expectedStartTimeAfter: i,
      expectedStartTimeBefore: u
    }
  };
}, sle = function(t) {
  return {
    id: t.id,
    x: t.timestamp,
    y: t.duration,
    itemClass: `scatter-plot-item scatter-plot-item--${t.stateType}`
  };
}, ale = function(t) {
  if (fee(t))
    return new sF({
      timezone: t.timezone,
      rrule: t.rrule
    });
  if (mee(t))
    return new B0({
      timezone: t.timezone,
      cron: t.cron,
      dayOr: t.day_or
    });
  if (yee(t))
    return t.anchor_date && t.timezone ? new im({
      timezone: t.timezone,
      interval: t.interval,
      anchorDate: this.map("string", t.anchor_date, "Date")
    }) : new im({
      interval: t.interval,
      timezone: null,
      anchorDate: null
    });
  throw "Invalid ScheduleResponse";
}, ile = function(t) {
  if (Qx(t))
    return {
      timezone: t.timezone,
      rrule: t.rrule
    };
  if (um(t))
    return {
      timezone: t.timezone,
      cron: t.cron,
      day_or: t.dayOr
    };
  if (lm(t))
    return t.anchorDate && t.timezone ? {
      timezone: t.timezone,
      interval: t.interval,
      anchor_date: this.map("Date", VJ(t.anchorDate, t.timezone), "string")
    } : {
      interval: t.interval,
      timezone: null,
      anchor_date: null
    };
  throw "Invalid ScheduleRequest";
}, ule = function(t) {
  return {
    timezone: t.timezone,
    rrule: t.rrule,
    cron: t.cron,
    day_or: t.dayOr,
    interval: t.interval,
    anchor_date: this.map("Date", t.anchorDate, "string")
  };
}, lle = (t) => {
  const { properties: e, ...n } = t, r = n;
  return r.properties = cle(e), r;
};
function cle(t) {
  if (t)
    return Ds(t, (e, n) => ple(n));
}
function ple(t) {
  if (!t)
    return;
  const e = { ...t };
  if (zx(t.default)) {
    const n = Ok(t, t.default);
    n && (e.default = {
      blockDocumentId: t.default.$ref.block_document_id,
      blockTypeSlug: n.blockTypeSlug
    });
  }
  return e;
}
const dle = [kae, lle, xae], hle = (t) => uae(t, dle), fle = function(t) {
  const { definitions: e, properties: n, $ref: r, secret_fields: o, block_type_slug: s, ...i } = t, u = {
    secretFields: o,
    blockTypeSlug: s,
    properties: this.map("SchemaPropertiesResponse", n, "SchemaProperties"),
    definitions: this.map("SchemaDefinitionsResponse", e, "SchemaDefinitions"),
    ...i
    // todo: this map isn't working (ts error). Not using this anywhere so commenting it out for now
    // blockSchemaReferences: this.map('BlockSchemaReferencesResponse', block_schema_references, 'BlockSchemaReferences'),
  };
  return r && (u.$ref = r), hle(u);
}, mle = function(t) {
  return Ds(t, (e, n) => this.map("SchemaResponse", n, "Schema"));
}, yle = function(t) {
  return Ds(t, (e, n) => this.map("SchemaPropertyResponse", n, "SchemaProperty"));
}, gle = function(t) {
  const { properties: e, $ref: n, block_type_slug: r, ...o } = t, s = {
    blockTypeSlug: r,
    ...o
  };
  return zd(t, "properties") && (s.properties = this.map("SchemaPropertiesResponse", e, "SchemaProperties")), n && (s.$ref = n), s;
}, vle = function(t) {
  return rae(t.schema, t.values);
}, _le = function(t) {
  let e = t.values;
  return t.references && (e = zN(e, t.references)), e = $N(t.schema, e), e;
}, wle = function(t) {
  return new rte({
    id: t.id,
    name: t.name,
    description: t.description,
    enabled: t.enabled,
    trigger: this.map("AutomationTriggerResponse", t.trigger, "AutomationTrigger"),
    type: t.type,
    severity: t.severity,
    created: this.map("string", t.created, "Date"),
    updated: this.map("string", t.updated, "Date"),
    account: t.account,
    workspace: t.workspace,
    actor: {
      actorId: t.actor.actor_id,
      handle: t.actor.handle,
      userId: t.actor.user_id,
      botId: t.actor.bot_id
    }
  });
}, ble = function(t) {
  return {
    id: t.id,
    type: this.map("ServerStateType", t.type, "StateType"),
    kind: "state",
    message: t.message,
    stateDetails: this.map("StateDetailsResponse", t.state_details, "StateDetails"),
    data: t.data,
    timestamp: this.map("string", t.timestamp, "Date"),
    name: t.name
  };
}, kle = function(t) {
  return {
    id: t.id,
    type: this.map("StateType", t.type, "ServerStateType"),
    message: t.message,
    state_details: this.map("StateDetails", t.stateDetails, "StateDetailsResponse"),
    data: t.data,
    timestamp: this.map("Date", t.timestamp, "string"),
    name: t.name
  };
}, Tle = function(t) {
  return {
    type: this.map("StateType", t.type, "ServerStateType"),
    message: t.message,
    state_details: t.stateDetails ? this.map("StateDetailsCreate", t.stateDetails, "StateDetailsRequest") : {},
    data: t.data,
    timestamp: this.map("Date", t.timestamp, "string"),
    name: t.name
  };
}, xle = function(t) {
  return {
    flowRunId: t.flow_run_id,
    taskRunId: t.task_run_id,
    childFlowRunId: t.child_flow_run_id,
    cacheKey: t.cache_key,
    scheduledTime: this.map("string", t.scheduled_time, "Date"),
    cacheExpiration: this.map("string", t.cache_expiration, "Date"),
    pauseTimeout: this.map("string", t.pause_timeout, "Date"),
    pauseReschedule: t.pause_reschedule,
    runInputKeyset: t.run_input_keyset
  };
}, Sle = function(t) {
  return {
    flow_run_id: t.flowRunId,
    task_run_id: t.taskRunId,
    child_flow_run_id: t.childFlowRunId,
    cache_key: t.cacheKey,
    scheduled_time: this.map("Date", t.scheduledTime, "string"),
    cache_expiration: this.map("Date", t.cacheExpiration, "string"),
    pause_timeout: this.map("Date", t.pauseTimeout, "string"),
    pause_reschedule: t.pauseReschedule,
    run_input_keyset: this.map("FlowRunInputKeyset", t.runInputKeyset, "FlowRunInputKeysetResponse")
  };
}, Rle = function(t) {
  return {
    flow_run_id: t.flowRunId,
    task_run_id: t.taskRunId,
    child_flow_run_id: t.childFlowRunId,
    cache_key: t.cacheKey,
    scheduled_time: t.scheduledTime ? this.map("Date", t.scheduledTime, "string") : null,
    cache_expiration: t.cacheExpiration ? this.map("Date", t.cacheExpiration, "string") : null
  };
}, Ale = function(t) {
  return {
    flow_run_id: t.flowRunId,
    task_run_id: t.taskRunId,
    child_flow_run_id: t.childFlowRunId,
    cache_key: t.cacheKey,
    pause_reschedule: t.pauseReschedule,
    scheduled_time: t.scheduledTime ? this.map("Date", t.scheduledTime, "string") : null,
    cache_expiration: t.cacheExpiration ? this.map("Date", t.cacheExpiration, "string") : null,
    pause_timeout: t.pauseTimeout ? this.map("Date", t.pauseTimeout, "string") : null
  };
}, Dle = function(t) {
  return new Gx({
    stateType: this.map("ServerStateType", t.state_type, "StateType"),
    stateName: t.state_name,
    countRuns: t.count_runs,
    sumEstimatedRunTime: t.sum_estimated_run_time,
    sumEstimatedLateness: t.sum_estimated_lateness
  });
}, Ele = function(t) {
  return {
    state_type: this.map("StateType", t.stateType, "ServerStateType"),
    state_name: t.stateName,
    count_runs: t.countRuns,
    sum_estimated_run_time: t.sumEstimatedRunTime,
    sum_estimated_lateness: t.sumEstimatedLateness
  };
}, Mle = function(t) {
  return t.toLowerCase();
}, Ple = function(t) {
  return t.toUpperCase();
}, Cle = function(t) {
  const { type: e, stateDetails: n, ...r } = t.state;
  return {
    state: {
      ...r,
      type: this.map("StateType", e, "ServerStateType"),
      state_details: this.map("StateDetails", n, "StateDetailsRequest")
    }
  };
}, Ole = function(t) {
  if (gee(t))
    return new Hee({
      inputType: t.input_type,
      type: t.type
    });
  if (vee(t))
    return new jee({
      inputType: t.input_type,
      name: t.name
    });
  if (_ee(t))
    return new zee({
      inputType: t.input_type,
      id: t.id
    });
  throw "Invalid TaskInputResponse";
}, Ile = function(t) {
  return {
    input_type: t.inputType,
    // eslint-disable-next-line no-extra-parens
    type: t.type,
    // eslint-disable-next-line no-extra-parens
    name: t.name,
    // eslint-disable-next-line no-extra-parens
    id: t.id
  };
}, Fle = function(t) {
  return new iF({
    id: t.id,
    flowRunId: t.flow_run_id,
    cacheExpiration: t.cache_expiration,
    cacheKey: t.cache_key,
    created: this.map("string", t.created, "Date"),
    dynamicKey: t.dynamic_key,
    empiricalPolicy: this.map("EmpiricalPolicyResponse", t.empirical_policy, "EmpiricalPolicy"),
    estimatedRunTime: t.estimated_run_time,
    estimatedStartTimeDelta: t.estimated_start_time_delta,
    totalRunTime: t.total_run_time,
    expectedStartTime: this.map("string", t.expected_start_time, "Date"),
    nextScheduledStartTime: this.map("string", t.next_scheduled_start_time, "Date"),
    runCount: t.run_count,
    name: t.name,
    taskInputs: this.mapEntries("TaskInputResponse", t.task_inputs, "TaskInput"),
    taskKey: t.task_key,
    taskVersion: t.task_version,
    updated: this.map("string", t.updated, "Date"),
    startTime: this.map("string", t.start_time, "Date"),
    endTime: this.map("string", t.end_time, "Date"),
    stateId: t.state_id,
    stateType: this.map("ServerStateType", t.state_type, "StateType"),
    stateName: t.state_name,
    state: this.map("StateResponse", t.state, "State"),
    tags: t.tags ? Ph(t.tags) : null
  });
}, Nle = function(t) {
  return {
    id: t.id,
    flow_run_id: t.flowRunId,
    cache_expiration: t.cacheExpiration,
    cache_key: t.cacheKey,
    created: this.map("Date", t.created, "string"),
    dynamic_key: t.dynamicKey,
    empirical_policy: this.map("EmpiricalPolicy", t.empiricalPolicy, "EmpiricalPolicyResponse"),
    estimated_run_time: t.estimatedRunTime,
    estimated_start_time_delta: t.estimatedStartTimeDelta,
    total_run_time: t.totalRunTime,
    expected_start_time: this.map("Date", t.expectedStartTime, "string"),
    next_scheduled_start_time: this.map("Date", t.nextScheduledStartTime, "string"),
    run_count: t.runCount,
    name: t.name,
    task_inputs: this.mapEntries("TaskInput", t.taskInputs, "TaskInputResponse"),
    task_key: t.taskKey,
    task_version: t.taskVersion,
    updated: this.map("Date", t.updated, "string"),
    start_time: this.map("Date", t.startTime, "string"),
    end_time: this.map("Date", t.endTime, "string"),
    state_id: t.stateId,
    state_type: this.map("StateType", t.stateType, "ServerStateType"),
    state_name: t.stateName,
    state: this.map("State", t.state, "StateResponse"),
    tags: t.tags
  };
}, Lle = function(t) {
  return {
    stateName: t.state_name,
    stateType: t.state_type,
    countRuns: t.count_runs,
    sumEstimatedLateness: t.sum_estimated_lateness,
    sumEstimatedRunTime: t.sum_estimated_run_time
  };
}, Ble = function(t) {
  return {
    intervalStart: this.map("string", t.interval_start, "Date"),
    intervalEnd: this.map("string", t.interval_end, "Date"),
    states: this.map("TaskRunHistoryStateResponse", t.states, "TaskRunHistoryState")
  };
}, Ule = function(t) {
  const n = /* @__PURE__ */ new Date(), { flows: r, flowRuns: o, deployments: s, taskRuns: i } = t, {
    startTimeBefore: u = n,
    startTimeAfter: l = $x(n, 24)
  } = i ?? {}, a = (u.getTime() - l.getTime()) / 1e3;
  return {
    flows: r,
    flowRuns: o,
    deployments: s,
    taskRuns: i,
    historyStart: l,
    historyEnd: u,
    historyIntervalSeconds: a / 20
  };
}, Xle = function(t) {
  return {
    id: t.id,
    stateType: this.map("ServerStateType", t.state_type, "StateType"),
    timestamp: this.map("string", t.timestamp, "Date"),
    duration: t.duration,
    lateness: t.lateness
  };
}, $le = function(t) {
  return Object.keys(t).reduce((e, n) => (e[n] = this.map("NextFlowRunResponse", t[n], "NextFlowRun"), e), {});
}, Wle = function(t) {
  return Object.entries(t).reduce((e, [n, r]) => (y8(n) && (e[ye.map("ServerStateType", n, "StateType")] = r), e), {});
}, Vle = function(t) {
  return new qee({
    id: t.id,
    name: t.name,
    value: t.value,
    tags: Ph(t.tags ?? []),
    created: this.map("string", t.created, "Date"),
    updated: this.map("string", t.updated, "Date")
  });
}, Hle = function(t) {
  return {
    name: t.name,
    value: JSON.parse(t.value),
    tags: t.tags
  };
}, jle = function(t) {
  return {
    name: t.name,
    value: JSON.parse(t.value),
    tags: t.tags
  };
}, zle = function(t) {
  return Object.values(t).flatMap((e) => Object.values(e)).map((e) => ({
    defaultBaseJobConfiguration: e.default_base_job_configuration,
    description: e.description,
    displayName: e.display_name,
    documentationUrl: e.documentation_url,
    installCommand: e.install_command,
    logoUrl: e.logo_url,
    type: e.type,
    isBeta: e.is_beta ?? !1,
    isPushPool: e.is_push_pool ?? !1,
    isMexPool: e.is_mex_pool ?? !1
  }));
}, qle = function(t) {
  const { values: e = {}, schema: n } = t;
  return Object.keys(n.variables?.properties ?? {}).forEach((o) => {
    if (n.variables?.properties) {
      const s = n.variables.properties[o];
      s !== void 0 && e[o] !== void 0 && (s.default = e[o]);
    }
  }), n;
}, Gle = function(t) {
  return {
    workPoolId: t.work_pool_id,
    workPoolQueueId: t.work_pool_queue_id,
    flowRun: this.map("FlowRunResponse", t.flow_run, "FlowRun")
  };
}, Yle = function(t) {
  return {
    work_pool_queue_names: t.workPoolQueueNames,
    scheduled_before: t.scheduledBefore,
    scheduled_after: t.scheduledAfter,
    limit: t.limit
  };
}, Qle = function(t) {
  return new Jx({
    id: t.id,
    created: this.map("string", t.created, "Date"),
    updated: this.map("string", t.updated, "Date"),
    name: t.name,
    description: t.description,
    type: t.type,
    isPaused: t.is_paused ?? !1,
    isPushPool: t.is_push_pool ?? !1,
    isMexPool: t.is_mex_pool ?? !1,
    concurrencyLimit: t.concurrency_limit,
    defaultQueueId: t.default_queue_id,
    baseJobTemplate: t.base_job_template,
    can: Ac(),
    status: this.map("ServerWorkPoolStatus", t.status, "WorkPoolStatus")
  });
}, Kle = function(t) {
  return {
    id: t.id,
    created: this.map("Date", t.created, "string"),
    updated: this.map("Date", t.updated, "string"),
    name: t.name,
    description: t.description,
    type: t.type,
    is_paused: t.isPaused,
    is_push_pool: t.isPushPool,
    is_mex_pool: t.isMexPool,
    concurrency_limit: t.concurrencyLimit,
    default_queue_id: t.defaultQueueId,
    base_job_template: t.baseJobTemplate,
    status: this.map("WorkPoolStatus", t.status, "ServerWorkPoolStatus")
  };
}, Zle = function(t) {
  const e = this.map(
    "WorkerSchemaProperty",
    { values: t.defaultVariableValues ?? {}, schema: t.baseJobTemplate ?? {} },
    "WorkerSchemaPropertyRequest"
  );
  return {
    name: t.name,
    description: t.description,
    type: t.type,
    is_paused: t.isPaused,
    concurrency_limit: t.concurrencyLimit,
    base_job_template: e
  };
}, Jle = function(t) {
  const e = this.map(
    "WorkerSchemaProperty",
    { values: t.updatedDefaultVariableValues ?? {}, schema: t.baseJobTemplate ?? {} },
    "WorkerSchemaPropertyRequest"
  );
  return {
    description: t.description,
    is_paused: t.isPaused,
    concurrency_limit: t.concurrencyLimit,
    base_job_template: e
  };
}, ece = function(t) {
  return new $o({
    posture: "Reactive",
    match: {
      "prefect.resource.id": `prefect.work-pool.${t.id}`
    },
    forEach: ["prefect.resource.id"],
    expect: ["prefect.work-pool.not-ready"]
  });
}, tce = function(t) {
  return new t2({
    id: t.id,
    created: this.map("string", t.created, "Date"),
    updated: this.map("string", t.updated, "Date"),
    workPoolId: t.work_pool_id,
    workPoolName: t.work_pool_name,
    name: t.name,
    description: t.description,
    isPaused: t.is_paused ?? !1,
    concurrencyLimit: t.concurrency_limit,
    priority: t.priority,
    lastPolled: this.map("string", t.last_polled, "Date"),
    status: t.status?.toLowerCase() ?? "not_ready",
    can: Ac()
  });
}, nce = function(t) {
  return {
    name: t.name,
    description: t.description,
    is_paused: t.isPaused,
    concurrency_limit: t.concurrencyLimit,
    priority: t.priority
  };
}, rce = function(t) {
  return {
    name: t.name,
    description: t.description,
    is_paused: t.isPaused,
    concurrency_limit: t.concurrencyLimit,
    priority: t.priority
  };
}, oce = function(t) {
  return new $o({
    posture: "Reactive",
    match: {
      "prefect.resource.id": `prefect.work-queue.${t.id}`
    },
    forEach: ["prefect.resource.id"],
    expect: ["prefect.work-queue.not-ready"]
  });
}, sce = function(t) {
  const e = t.toLowerCase();
  if (Yee(e))
    return e;
  throw new Error(`ServerWorkPoolStatus unable to be mapped to WorkPoolStatus: ${t}`);
}, ace = function(t) {
  const e = t.toLowerCase();
  if (Qee(e))
    return e;
  throw new Error(`WorkPoolStatus unable to be mapped to ServerWorkPoolStatus: ${t}`);
}, ice = function(t) {
  return new lF({
    id: t.id,
    created: this.map("string", t.created, "Date"),
    updated: this.map("string", t.updated, "Date"),
    name: t.name,
    workPoolId: t.work_pool_id,
    lastHeartbeatTime: this.map("string", t.last_heartbeat_time, "Date"),
    status: this.map("ServerWorkPoolWorkerStatus", t.status, "WorkPoolWorkerStatus"),
    clientVersion: t.client_version ? t.client_version : null,
    heartbeatIntervalSeconds: t.heartbeat_interval_seconds,
    metadata: t.metadata_ ? t.metadata_ : null
  });
}, uce = function(t) {
  return {
    workers: t.results.map((e) => this.map("WorkPoolWorkerResponse", e, "WorkPoolWorker")),
    count: t.count,
    limit: t.limit,
    page: t.page,
    pages: t.pages
  };
}, lce = function(t) {
  return t.toLowerCase();
}, cce = function(t) {
  return t.toUpperCase();
}, pce = function(t) {
  return new hF({
    id: t.id,
    account: t.account,
    event: t.event,
    payload: t.payload,
    related: t.related,
    resource: t.resource,
    workspace: t.workspace,
    occurred: this.map("string", t.occurred, "Date"),
    received: this.map("string", t.received, "Date")
  });
}, dce = function(t) {
  switch (pF(t.event)) {
    case "flow-run":
      return hce(t);
    case "work-queue":
      return fce(t);
    default:
      return mce(t);
  }
};
function hce(t) {
  const e = t.getRelatedByRole("flow");
  return new $o({
    posture: "Reactive",
    match: {
      "prefect.resource.id": t.resourceId
    },
    matchRelated: {
      "prefect.resource.role": "flow",
      "prefect.resource.id": e?.["prefect.resource.id"]
    },
    forEach: ["prefect.resource.id"],
    expect: [t.event]
  });
}
function fce(t) {
  const e = t.getRelatedByRole("work-queue");
  return new $o({
    posture: "Reactive",
    match: {
      "prefect.resource.id": t.resourceId
    },
    matchRelated: {
      "prefect.resource.role": "flow",
      "prefect.resource.id": e?.["prefect.resource.id"]
    },
    forEach: ["prefect.resource.id"],
    expect: [t.event]
  });
}
function mce(t) {
  return new $o({
    posture: "Reactive",
    match: {
      "prefect.resource.id": t.resourceId
    },
    expect: [t.event]
  });
}
const yce = function(t) {
  return new tte({
    events: this.map("WorkspaceEventResponse", t.events, "WorkspaceEvent"),
    nextPage: t.next_page,
    total: t.total
  });
}, gce = function(t) {
  return new nte({
    count: t.count,
    label: t.label,
    value: t.value,
    startTime: this.map("string", t.start_time, "Date"),
    endTime: this.map("string", t.end_time, "Date")
  });
}, vce = function(t) {
  return {
    value: t.count,
    intervalStart: this.map("string", t.start_time, "Date"),
    intervalEnd: this.map("string", t.end_time, "Date")
  };
}, _ce = function(t) {
  const { limit: e, occurred: n, resource: r, related: o, anyResource: s, event: i, ...u } = t, l = {
    occurred: {
      since: this.map("Date", n.since, "string"),
      until: this.map("Date", n.until, "string")
    },
    any_resource: {
      id: s?.id,
      id_prefix: s?.idPrefix,
      labels: s?.labels
    },
    resource: {
      id: r?.id,
      id_prefix: r?.idPrefix,
      labels: r?.labels,
      distinct: r?.distinct
    },
    related: {
      id: o?.id,
      labels: o?.labels,
      resources_in_roles: o?.resourcesInRoles,
      role: o?.role
    },
    event: {
      prefix: i?.prefix,
      name: i?.name,
      exclude_prefix: i?.excludePrefix,
      exclude_name: i?.excludeName
    },
    ...u
  };
  return {
    limit: e,
    filter: Wn(l)
  };
}, wce = function(t) {
  const { limit: e, filter: n = {} } = t, { occurred: r, any_resource: o, resource: s, related: i, event: u, ...l } = n, a = {
    limit: e,
    anyResource: {
      id: o?.id,
      idPrefix: o?.id_prefix,
      labels: o?.labels
    },
    resource: {
      id: s?.id,
      idPrefix: s?.id_prefix,
      labels: s?.labels,
      distinct: s?.distinct
    },
    related: {
      id: i?.id,
      labels: i?.labels,
      resourcesInRoles: i?.resources_in_roles,
      role: i?.role
    },
    event: {
      prefix: u?.prefix,
      name: u?.name,
      excludePrefix: u?.exclude_prefix,
      excludeName: u?.exclude_name
    },
    ...l
  };
  return r?.since && (a.occurred ??= {}, a.occurred.since = this.map("string", r.since, "Date")), r?.until && (a.occurred ??= {}, a.occurred.until = this.map("string", r.until, "Date")), Wn(a);
}, bce = function(t) {
  const { filter: e } = this.map("WorkspaceEventsFilter", t.filter, "WorkspaceEventsFilterRequest");
  return {
    time_unit: t.unit,
    time_interval: t.interval,
    filter: e
  };
}, kce = {
  ArtifactFilter: { ArtifactFilterRequest: zie },
  ArtifactResponse: { Artifact: Are },
  ArtifactCollectionResponse: { ArtifactCollection: Dre },
  ArtifactsFilter: { ArtifactsFilterRequest: qie },
  AutomationResponse: { Automation: $ne },
  AutomationActionResponse: { AutomationAction: Nq },
  AutomationAction: { AutomationActionRequest: Lq },
  BlockDocument: { SelectOption: Mre },
  BlockDocumentCreate: { BlockDocumentCreateRequest: Pre },
  BlockDocumentFilter: { BlockDocumentFilterRequest: iue },
  BlockDocumentReferencesResponse: { BlockDocumentReferences: Cre },
  BlockDocumentResponse: { BlockDocument: Ere },
  BlockDocumentsFilter: { BlockDocumentsFilterRequest: hue },
  BlockDocumentUpdate: { BlockDocumentUpdateRequest: Ore },
  BlockSchemaFilter: { BlockSchemaFilterRequest: aue },
  BlockSchemaReferencesResponse: { BlockSchemaReferences: Fre },
  BlockSchemaResponse: { BlockSchema: Ire },
  BlockSchemasFilter: { BlockSchemasFilterRequest: due },
  BlockTypeFilter: { BlockTypeFilterRequest: sue },
  BlockTypeResponse: { BlockType: Nre },
  BlockTypesFilter: { BlockTypesFilterRequest: pue },
  CollectionItemResponse: { CollectionItem: Lre },
  CollectionResponse: { CollectionItems: Bre },
  ConcurrencyLimitCreate: { ConcurrencyLimitCreateRequest: Xre },
  ConcurrencyLimitResponse: { ConcurrencyLimit: Ure },
  ConcurrencyV2LimitResponse: { ConcurrencyV2Limit: $re },
  ConcurrencyV2LimitCreate: { ConcurrencyV2CreateRequest: Wre },
  ConcurrencyV2LimitUpdate: { ConcurrencyV2UpdateRequest: Vre },
  CreateAutomationQuery: { LocationQuery: Hne },
  CreateAutomationTriggerQuery: { LocationQuery: Wne },
  CreateAutomationActionQuery: { LocationQuery: Vne },
  CreatedOrUpdatedByResponse: { CreatedOrUpdatedBy: Hre },
  Date: { string: Qre },
  DateRangeSelectValue: { DateRange: Kre },
  DeploymentCreate: { DeploymentCreateRequest: _ie },
  DeploymentFilter: { DeploymentFilterRequest: Vie },
  DeploymentsPaginationFilter: { DeploymentsPaginationFilterRequest: tue },
  DeploymentPaginationResponse: { DeploymentsPagination: Wue },
  DeploymentFlowRunCreateV2: { DeploymentFlowRunRequest: vie },
  DeploymentResponse: { Deployment: mie },
  DeploymentScheduleResponse: { DeploymentSchedule: kie },
  DeploymentScheduleCreate: { DeploymentScheduleCreateRequest: Tie },
  DeploymentScheduleUpdate: { DeploymentScheduleUpdateRequest: xie },
  DeploymentsFilter: { DeploymentsFilterRequest: oue },
  DeploymentStatus: { ServerDeploymentStatus: Aie },
  DeploymentStatsFilter: { FlowRunsFilter: Sie },
  DeploymentUpdateV2: { DeploymentUpdateRequest: gie },
  DeploymentVersionIdFilter: { DeploymentVersionIdFilterRequest: Uie },
  DeploymentVersionInfoFilter: { DeploymentVersionInfoFilterRequest: Xie },
  DeploymentVersionResponse: { DeploymentVersion: wie },
  DeploymentVersionInfoResponse: { DeploymentVersionInfo: bie },
  EmpiricalPolicy: { EmpiricalPolicyResponse: Mie, EmpiricalPolicyRequest: Pie },
  EmpiricalPolicyResponse: { EmpiricalPolicy: Eie },
  Flow: {
    FlowResponse: bue,
    AutomationTrigger: kue
  },
  FlowFilter: { FlowFilterRequest: Bie },
  FlowResponse: { Flow: wue },
  FlowsPaginationResponse: { FlowsPagination: $ue },
  FlowRunFilter: { FlowRunFilterRequest: $ie },
  FlowRunHistoryResponse: { RunHistory: xue },
  FlowRunInputKeyset: { FlowRunInputKeysetResponse: Mue },
  FlowRunInputKeysetResponse: { FlowRunInputKeyset: Pue },
  FlowRunResponse: { FlowRun: Tue },
  FlowRunsPaginationResponse: { FlowRunsPagination: Uue },
  TaskRunsPaginationResponse: { TaskRunsPagination: Xue },
  FlowRunsFilter: { FlowRunsFilterRequest: Kie },
  FlowRunsPaginationFilter: { FlowRunsPaginationFilterRequest: Jie },
  TaskRunsPaginationFilter: { TaskRunsPaginationFilterRequest: eue },
  FlowRunsHistoryFilter: { FlowRunsHistoryFilterRequest: nue },
  FlowsFilter: { FlowsFilterRequest: Qie },
  FlowsPaginationFilter: { FlowsPaginationFilterRequest: Zie },
  FlowStatsFilter: {
    FlowRunsFilter: Rue,
    TaskRunsFilter: Aue
  },
  Log: { LogResponse: Eue },
  LogResponse: { Log: Due },
  LogsFilter: { LogsFilterRequest: cue },
  NextFlowRunResponse: { NextFlowRun: Cue },
  NotificationCreate: { NotificationCreateRequest: Iue },
  NotificationResponse: { Notification: Oue },
  NotificationsFilter: { NotificationsFilterRequest: uue },
  NotificationUpdate: { NotificationUpdateRequest: Fue },
  number: { string: Lue },
  OrchestrationResultResponse: { OrchestrationResult: Bue },
  PrefectWorkerCollectionResponse: { WorkerCollectionItem: zle },
  RunGraphDataResponse: { RunGraphData: zue },
  RunGraphNodeResponse: { RunGraphNode: Vue },
  RunGraphArtifactResponse: { RunGraphArtifact: Hue },
  RunGraphStateResponse: { RunGraphStateEvent: jue },
  RunHistory: { FlowRunHistoryResponse: Sue, DivergingBarChartItem: Die },
  SavedSearchCreate: { SavedSearchCreateRequest: Jue },
  SavedSearchesFilter: { SavedSearchesFilterRequest: lue },
  SavedSearchFilter: {
    FlowRunsFilter: rle,
    TaskRunsFilter: ole,
    LocationQuery: Yue
  },
  SavedSearchResponse: { SavedSearch: Gue },
  Schedule: { ScheduleResponse: ule, ScheduleRequest: ile },
  ScheduleResponse: { Schedule: ale },
  SchemaDefinitionsResponse: { SchemaDefinitions: mle },
  SchemaPropertiesResponse: { SchemaProperties: yle },
  SchemaPropertyResponse: { SchemaProperty: gle },
  SchemaResponse: { Schema: fle },
  SchemaValues: { SchemaValuesRequest: vle },
  SchemaValuesResponse: { SchemaValues: _le },
  ServerDeploymentStatus: { DeploymentStatus: Rie },
  ServerStateType: { StateType: Mle },
  ServerWorkPoolStatus: { WorkPoolStatus: sce },
  ServerWorkPoolWorkerStatus: { WorkPoolWorkerStatus: lce },
  ServiceLevelAgreementResponse: { ServiceLevelAgreement: wle },
  State: { StateResponse: kle },
  StateCreate: { StateRequest: Tle },
  StateDetails: { StateDetailsResponse: Sle, StateDetailsRequest: Ale },
  StateDetailsCreate: { StateDetailsRequest: Rle },
  StateDetailsResponse: { StateDetails: xle },
  StateFilter: { StateFilterRequest: Lie },
  StateHistory: { StateHistoryResponse: Ele },
  StateHistoryResponse: { StateHistory: Dle },
  StateResponse: { State: ble },
  StateType: { ServerStateType: Ple },
  StateUpdate: { StateUpdateRequest: Cle },
  string: { Date: Yre, number: Nue },
  TagFilter: { TagFilterRequest: Nie },
  TaskInput: { TaskInputResponse: Ile },
  TaskInputResponse: { TaskInput: Ole },
  TaskRun: { TaskRunResponse: Nle },
  TaskRunFilter: { TaskRunFilterRequest: Wie },
  TaskRunResponse: { TaskRun: Fle },
  TaskRunsFilter: {
    TaskRunsFilterRequest: rue,
    TaskRunsHistoryFilter: Ule
  },
  TaskRunsHistoryFilter: { TaskRunsHistoryFilterRequest: _ue },
  UiFlowRunHistory: { ScatterPlotItem: sle },
  UiFlowRunHistoryResponse: { UiFlowRunHistory: Xle },
  UiNextFlowRunByFlowResponse: { UiNextFlowRunByFlow: $le },
  UiTaskRunCountsByStateResponse: { UiTaskRunCountsByState: Wle },
  VariableFilter: { VariableFilterRequest: Gie },
  VariablesFilter: { VariablesFilterRequest: Yie },
  VariableCreate: { VariableCreateRequest: jle },
  VariableEdit: { VariableEditRequest: Hle },
  VariableResponse: { Variable: Vle },
  WorkerScheduledFlowRunResponse: { WorkerScheduledFlowRun: Gle },
  WorkerScheduledFlowRuns: { WorkerScheduledFlowRunsRequest: Yle },
  WorkerSchemaProperty: { WorkerSchemaPropertyRequest: qle },
  WorkPool: {
    WorkPoolResponse: Kle,
    AutomationTrigger: ece
  },
  WorkPoolCreate: { WorkPoolCreateRequest: Zle },
  WorkPoolEdit: { WorkPoolEditRequest: Jle },
  WorkPoolFilter: { WorkPoolFilterRequest: Hie },
  WorkPoolQueue: { AutomationTrigger: oce },
  WorkPoolQueueCreate: { WorkPoolQueueCreateRequest: nce },
  WorkPoolQueueEdit: { WorkPoolQueueEditRequest: rce },
  WorkPoolQueueFilter: { WorkPoolQueueFilterRequest: jie },
  WorkPoolQueueResponse: { WorkPoolQueue: tce },
  WorkPoolQueuesFilter: { WorkPoolQueuesFilterRequest: vue },
  WorkPoolResponse: { WorkPool: Qle },
  WorkPoolsFilter: { WorkPoolsFilterRequest: fue },
  WorkPoolStatus: { ServerWorkPoolStatus: ace },
  WorkPoolWorkerResponse: { WorkPoolWorker: ice },
  WorkersFilter: { WorkersFilterRequest: mue },
  WorkPoolWorkersFilter: { WorkPoolWorkersFilterRequest: yue },
  WorkPoolWorkersPagination: { WorkPoolWorkersPaginationRequest: gue },
  WorkPoolWorkersPaginationResponse: { PaginatedWorkPoolWorkers: uce },
  WorkPoolWorkerStatus: { ServerWorkPoolWorkerStatus: cce },
  WorkspaceDashboardFilter: {
    TaskRunsFilter: jre,
    TaskRunsHistoryFilter: zre,
    FlowRunsFilter: qre,
    WorkersFilter: Gre
  },
  TaskRunHistoryStateResponse: { TaskRunHistoryState: Lle },
  TaskRunHistoryResponse: { TaskRunHistory: Ble },
  AutomationTrigger: {
    DeploymentStatusTrigger: zne,
    AutomationTriggerRequest: are,
    FlowRunStateTrigger: ere,
    WorkPoolStatusTrigger: pre,
    WorkQueueStatusTrigger: kre
  },
  AutomationTriggerEvent: { WorkspaceEventsFilter: ire },
  DeploymentStatusTrigger: { AutomationTrigger: jne },
  AutomationTriggerResponse: { AutomationTrigger: sre },
  FlowRunStateTrigger: { AutomationTrigger: Jne },
  WorkPoolStatusTrigger: { AutomationTrigger: cre },
  WorkQueueStatusTrigger: { AutomationTrigger: vre },
  WorkspaceEvent: { AutomationTrigger: dce },
  WorkspaceEventResponse: { WorkspaceEvent: pce },
  WorkspaceEventsResponse: { WorkspaceEvents: yce },
  WorkspaceEventsCountResponse: {
    WorkspaceEventsCount: gce,
    HistogramDataPoint: vce
  },
  WorkspaceEventsFilter: { WorkspaceEventsFilterRequest: _ce },
  WorkspaceEventsFilterRequest: { WorkspaceEventsFilter: wce },
  WorkspaceEventsHistory: { WorkspaceEventsHistoryRequest: bce }
};
class Tce {
  mapperFunctions;
  constructor(e) {
    this.mapperFunctions = e;
  }
  map(e, n, r) {
    if (n == null)
      return n;
    const o = this.bindMapper(this.mapperFunctions[e][r]);
    return Array.isArray(n) ? n.map(o) : o(n);
  }
  mapEntries(e, n, r) {
    if (n == null)
      return n;
    const o = {};
    return Object.entries(n).reduce((s, [i, u]) => (s[i] = this.map(e, u, r), s), o);
  }
  bindMapper(e) {
    return e.bind(this);
  }
}
const ye = new Tce(kce);
class xce extends kx {
  routePrefix = "/collections";
  getFlowCollection() {
    return this.get("/views/aggregate-flow-metadata").then(({ data: e }) => ye.map("CollectionResponse", e, "CollectionItems"));
  }
  getWorkerCollection() {
    return this.get("/views/aggregate-worker-metadata").then(({ data: e }) => ye.map("PrefectWorkerCollectionResponse", e, "WorkerCollectionItem"));
  }
}
const Sce = function(t = {}) {
  return {
    id: this.create("id"),
    deploymentId: this.create("id"),
    kind: "deployment-version",
    description: this.create("paragraph"),
    created: this.create("date"),
    createdBy: this.create("createdOrUpdatedBy"),
    updated: this.create("date"),
    updatedBy: this.create("createdOrUpdatedBy"),
    lastActive: this.create("date"),
    name: this.create("noun"),
    versionInfo: {
      type: "vcs:github",
      version: this.create("string"),
      branch: this.create("string"),
      url: this.create("url"),
      repository: this.create("string"),
      commitSha: this.create("string"),
      message: this.create("string")
    },
    tags: this.createMany("noun", this.create("number", [0, 5])),
    labels: {},
    entrypoint: this.create("id"),
    pullSteps: [],
    parameters: {},
    parameterOpenApiSchema: {},
    jobVariables: {},
    workQueueName: this.create("noun"),
    workPoolName: this.create("noun"),
    enforceParameterSchema: this.create("boolean"),
    ...t
  };
}, s4 = function() {
  return Math.random() < 0.5;
}, a4 = function(t, e) {
  return t || (t = /* @__PURE__ */ new Date(0)), e || (e = /* @__PURE__ */ new Date()), new Date(t.getTime() + Math.random() * (e.getTime() - t.getTime()));
}, Rce = function(t, e) {
  return this.create("date", [t, e]).toISOString();
}, i4 = function(t = 0, e = 100) {
  return Yn(t, e);
};
let Yg = ["alligator", "ant", "bear", "bee", "bird", "camel", "cat", "cheetah", "chicken", "chimpanzee", "cow", "crocodile", "deer", "dog", "dolphin", "duck", "eagle", "elephant", "fish", "fly", "fox", "frog", "giraffe", "goat", "goldfish", "hamster", "hippopotamus", "horse", "kangaroo", "kitten", "lion", "lobster", "monkey", "octopus", "owl", "panda", "pig", "puppy", "rabbit", "rat", "scorpion", "seal", "shark", "sheep", "snail", "snake", "spider", "squirrel", "tiger", "turtle", "wolf", "zebra", "apple", "apricot", "banana", "blackberry", "blueberry", "cherry", "cranberry", "currant", "fig", "grape", "grapefruit", "grapes", "kiwi", "kumquat", "lemon", "lime", "melon", "nectarine", "orange", "peach", "pear", "persimmon", "pineapple", "plum", "pomegranate", "prune", "raspberry", "strawberry", "tangerine", "watermelon"], Fk = ["adaptable", "adventurous", "affable", "affectionate", "agreeable", "alert", "alluring", "ambitious", "ambitious", "amiable", "amicable", "amused", "amusing", "boundless", "brave", "brave", "bright", "bright", "broad-minded", "calm", "calm", "capable", "careful", "charming", "charming", "cheerful", "coherent", "comfortable", "communicative", "compassionate", "confident", "conscientious", "considerate", "convivial", "cooperative", "courageous", "courageous", "courteous", "creative", "credible", "cultured", "dashing", "dazzling", "debonair", "decisive", "decisive", "decorous", "delightful", "detailed", "determined", "determined", "diligent", "diligent", "diplomatic", "discreet", "discreet", "dynamic", "dynamic", "eager", "easygoing", "efficient", "elated", "eminent", "emotional", "enchanting", "encouraging", "endurable", "energetic", "energetic", "entertaining", "enthusiastic", "enthusiastic", "excellent", "excited", "exclusive", "exuberant", "exuberant", "fabulous", "fair", "fair-minded", "faithful", "faithful", "fantastic", "fearless", "fearless", "fine", "forceful", "frank", "frank", "friendly", "friendly", "funny", "funny", "generous", "generous", "gentle", "gentle", "glorious", "good", "good", "gregarious", "happy", "hard-working", "harmonious", "helpful", "helpful", "hilarious", "honest", "honorable", "humorous", "imaginative", "impartial", "impartial", "independent", "industrious", "instinctive", "intellectual", "intelligent", "intuitive", "inventive", "jolly", "joyous", "kind", "kind", "kind-hearted", "knowledgeable", "level", "likeable", "lively", "lovely", "loving", "loving", "loyal", "lucky", "mature", "modern", "modest", "neat", "nice", "nice", "obedient", "optimistic", "painstaking", "passionate", "patient", "peaceful", "perfect", "persistent", "philosophical", "pioneering", "placid", "placid", "plausible", "pleasant", "plucky", "plucky", "polite", "powerful", "practical", "pro-active", "productive", "protective", "proud", "punctual", "quick-witted", "quiet", "quiet", "rational", "receptive", "reflective", "reliable", "relieved", "reserved", "resolute", "resourceful", "responsible", "rhetorical", "righteous", "romantic", "romantic", "sedate", "seemly", "selective", "self-assured", "self-confident", "self-disciplined", "sensible", "sensitive", "sensitive", "shrewd", "shy", "silly", "sincere", "sincere", "skillful", "smiling", "sociable", "splendid", "steadfast", "stimulating", "straightforward", "successful", "succinct", "sympathetic", "talented", "thoughtful", "thoughtful", "thrifty", "tidy", "tough", "tough", "trustworthy", "unassuming", "unbiased", "understanding", "unusual", "upbeat", "versatile", "vigorous", "vivacious", "warm", "warmhearted", "willing", "willing", "wise", "witty", "witty", "wonderful"], Ace = [
  "{{noun}} of the imagination how far away muse about bits of moving {{adjective}} {{noun}} preserve and cherish that pale, {{adjective}}, {{adjective}} {{noun}} the sky calls to us",
  "venture {{noun}} dream of the mind's eye the {{noun}} calls to us another world {{adjective}} permanence of the {{noun}}.",
  "a billion trillion encyclopaedia galactica {{adjective}} {{noun}} across the centuries the carbon in {{adjective}} {{noun}}?",
  "by accepting the {{noun}} or its derivative {{nouns}}. Therefore, for any liability to {{noun}} for claims brought by any {{noun}} to the page history is sufficient. Licensing notice: Each copy or copies of {{noun}}, provided that you cannot distribute so as to which you describe recipients' rights hereunder. However, you may modify your copy of this component of the {{noun}}, or portion thereof, is at Your sole responsibility, not on behalf of the printed materials and {{nouns}} within such {{nouns}} within which they are first used, and the following in a manner equivalent to the {{noun}}, it is up to the terms of this definition, '{{noun}}' means any patent claims against the {{nouns}} form or documentation, if provided along with the {{nouns}} must agree that use of the name of the licenses to their respective portions thereof.",
  "{{aNoun}} has the right to modify the terms of any of the {{nouns}}. Any material to the {{nouns}} or {{nouns}} thereof",
  "however, {{nouns}} have begun to rent {{nouns}} over the past few months, specifically for {{nouns}} associated with their {{nouns}}"
];
const Dce = [
  "to be more specific, ",
  "in recent years, ",
  "however, ",
  "by the way",
  "of course, ",
  "some assert that ",
  "if this was somewhat unclear, ",
  "unfortunately, that is wrong; on the contrary, ",
  "it's very tricky, if not impossible, ",
  "this could be, or perhaps ",
  "this is not to discredit the idea that ",
  "we know that ",
  "it's an undeniable fact, really; ",
  "framed in a different way, ",
  "what we don't know for sure is whether or not ",
  "as far as we can estimate, ",
  "as far as he is concerned, ",
  "the zeitgeist contends that ",
  "though we assume the latter, ",
  "far from the truth, ",
  "extending this logic, ",
  "nowhere is it disputed that ",
  "in modern times ",
  "in ancient times ",
  "recent controversy aside, ",
  "washing and polishing the car,",
  "having been a gymnast, ",
  "after a long day at school and work, ",
  "waking to the buzz of the alarm clock, ",
  "draped neatly on a hanger, ",
  "shouting with happiness, "
], Yl = (t) => {
  let e;
  for (; !e; )
    e = t[Yn(0, t.length - 1)];
  return e;
}, Ece = () => {
  const t = ".......!?!?;...".split("");
  return Yl(t);
}, Mce = (t) => t.endsWith("s") ? t : (t.match(/(ss|ish|ch|x|us)$/) ? t += "e" : t.endsWith("y") && !wF.includes(t.charAt(t.length - 2)) && (t = t.slice(0, t.length - 1), t += "ie"), `${t}s`), oM = (t) => {
  let e = "a";
  return t.match(/^(a|e|heir|herb|hour|i|o)/) && (e = "an"), `${e} ${t}`;
}, Pce = {
  noun: () => Yl(Yg),
  aNoun: () => oM(Yl(Yg)),
  nouns: () => Mce(Yl(Yg)),
  adjective: () => Yl(Fk),
  anAdjective: () => oM(Yl(Fk))
}, Cce = [
  "noun",
  "aNoun",
  "nouns",
  "adjective",
  "anAdjective"
], Oce = (t) => t.replace(/^[\s\xa0]+|[\s\xa0]+$/g, "").replace(/\r?\n|\r/g, " ").replace(/\s\s+|\r/g, " "), Ice = (t) => {
  let e = t;
  const n = t.match(/\{\{(.+?)\}\}/g);
  if (n?.length)
    for (const r of n) {
      const o = Oce(r.replace("{{", "").replace("}}", ""));
      let s = "";
      Cce.includes(o) && (s = Pce[o]()), e = e.replace(r, s);
    }
  return e;
}, Fce = () => Sr() < 0.33 ? Yl(Dce) : "", Nce = () => Ice(Yl(Ace)), u4 = () => {
  let e = Fce() + Nce();
  return e = e.charAt(0).toUpperCase() + e.slice(1), e += Ece(), e;
}, Lce = (t = 0) => {
  t || (t = Yn(3, 10));
  const e = Math.min(t, 15), n = [];
  for (; n.length < e; ) {
    const r = u4();
    n.push(r);
  }
  return n.join(" ");
}, Bce = () => {
  const t = Qr(Xce).replace("RANDOM", yG().toString()), e = Qr(Uce), n = x8(0.6) ? Qr($ce) : "";
  return [t, e, n].join("-").replace(/-+$/, "");
}, Uce = ["andromedae", "antliae", "apodis", "aquarii", "aquilae", "arae", "arietis", "aurigae", "bootis", "caeli", "camelopardalis", "cancri", "canis-majoris", "canis-minoris", "canum-venaticorum", "capricorni", "carinae", "cassiopeiae", "centauri", "ceti", "chamaeleontis", "circini", "columbae", "comae-berenices", "coronae-australis", "coronae-borealis", "corvi", "crateris", "crucis", "cygni", "delphini", "doradus", "draconis", "equulei", "eridani", "fornacis", "geminorum", "gruis", "horologii", "hydrae", "hydri", "indi", "lacertae", "leonis", "leonis-majoris", "leonis-minoris", "leporis", "librae", "lupi", "lyncis", "lyrae", "mensae", "microscopii", "monocerotis", "muscae", "normae", "octantis", "ophiuchi", "orion", "orionis", "pavonis", "pegasi", "persei", "phoenicis", "pictoris", "piscis-austrini", "piscium", "puppis", "pyxidis", "reticuli", "sagittae", "sagittarii", "sculptoris", "scuti", "serpentis", "sextantis", "tauri", "telescopii", "trianguli", "trianguli-australis", "tucanae", "ursae-majoris", "ursae-minoris", "velorum", "virginis", "volantis", "vulpeculae", "", "meridiana", "alphecca", "gienah", "deneb", "acrux", "sirius", "arcturus", "altair", "capella", "", "alkari", "adachi", "akechi", "akita", "ando", "aoki", "arai", "asai", "asano", "ashikaga", "ashina", "aso", "doi", "endo", "enya", "goto", "hara", "harada", "hatano", "hiraga", "hojo", "hondo", "hori", "hoshina", "hotta", "ikeda", "ina", "inagaki", "inoue", "ise", "ishida", "isshiki", "ito", "jo", "kagae", "kaneko", "kano", "kato", "katsura", "kawguchi", "kikuchi", "kira", "ko", "koide", "konishi", "kono", "koriki", "kuchiki", "kuki", "kuroda", "kuroki", "nagai", "naito", "naruse", "nasu", "nikaido", "nikki", "nishi", "nishina", "nishio", "nitta", "ochi", "oda", "okuda", "ooka", "oseki", "otani", "otera", "ouchi", "rokkaku", "saigo", "saito", "sakai", "sakurai", "sanada", "sano", "sasaki", "satake", "sato", "seki", "sengoku", "sen", "shinjo", "shoni", "so", "soga", "sonoda", "suzuki", "taguchi", "taira", "takeda", "tanaka", "tani", "toda", "todo", "togashi", "toki", "torii", "tsukushi", "tsutsui", "uesugi", "ujie", "ukita", "yagyu", "yonezu", "yoshida", "yoshii", "yuki", "", "newton", "einstein", "bohr", "darwin", "pasteur", "freud", "galilei", "kepler", "copernicus", "faraday", "maxwell", "bernard", "boas", "heisenburg", "pauling", "virchow", "rutherford", "dirac", "vesalius", "brahe", "buffon", "planck", "curie", "herschel", "lyell", "laplace", "hubble", "thomson", "born", "crick", "fermi", "euler", "liebig", "harvey", "malpighi", "huygens", "gauss", "haller", "kekule", "koch", "fischer", "mendeleev", "glashow", "watson", "bardeen", "neumann", "feynman", "wegener", "hawking", "laue", "bethe", "euclid", "mendel", "onnes", "morgan", "ehrlich", "mayr", "lamarck", "bayliss", "chomsky", "sanger", "dalton", "broglie", "linnaeus", "piaget", "simpson", "strauss", "margulis", "lorenz", "wilson", "hopkins", "elion", "selye", "teller", "libby", "haeckel", "salk", "kraepelin", "lysenko", "galton", "binet", "kinsey", "fleming", "skinner", "wundt", "galen", "avicenna", "descartes", "pascal", "boyle", "hooke", "halley", "bernoulli", "franklin", "priestley", "volta", "jenner", "cuvier", "humboldt", "davy", "babbage", "maury", "agassiz", "joule", "foucault", "kelvin", "lister", "kekule", "roentgen", "edison", "pavlov", "meitner", "waksman", "watt", "alvarez", "mead", "yalow", "khorana", "townes", "aristotle", "plato", "ptolemy", "khwarizmi", "davinci", "gutenberg", "", "landau", "nemtsov", "gamow", "", "adorn", "aglarond", "amroth", "andrast", "andrath", "anduin", "anfalas", "angmar", "angrenost", "annuminas", "anorien", "argonath", "arnor", "arthedain", "azanulbizar", "baranduin", "barad-dur", "barazinbar", "belfalas", "bruinen", "bundushathur", "calanhad", "calembel", "calenardhon", "caradhras", "carchost", "cardolan", "carnen", "celebdil", "celduin", "ciril", "dagorlad", "dorwinion", "dunharrow", "durthang", "dwimorberg", "dwimordene", "edoras", "egladil", "eilenach", "elostirion", "enedwaith", "eotheod", "erebor", "erech", "eregion", "erelas", "eriador", "erui", "esgaroth", "ethring", "evendim", "fangorn", "fanuidhol", "firiendfeld", "firienholt", "folde", "forlindon", "forlond", "fornost", "forodwaith", "forochel", "gilrain", "glanduin", "gondor", "gorgoroth", "greyling", "gunabad", "gwathlo", "halifirien", "harad", "harlond", "harnen", "harondor", "hoarwell", "imladris", "imloth", "isen", "ithilien", "kelos", "khand", "lamedon", "langwell", "lebbenin", "lefnui", "lhun", "limlight", "lindon", "lithlad", "lorien", "lossarnach", "lothlorien", "meduseld", "methedras", "minas", "mindolluin", "minhiriath", "mirrormere", "morannon", "mordor", "morgai", "morgulduin", "moria", "morthond", "mundburg", "nanduhirion", "narchost", "nardol", "naith", "nimrodel", "nindalf", "orthanc", "orodruin", "osgiliath", "pelargir", "pelennor", "poros", "rauros", "rhosgobel", "rhovanion", "rhudaur", "rhun", "ringlo", "sammath", "sarn", "serni", "sirith", "tarlang", "tharbad", "thrihyrne", "tolfalas", "udun", "umbar", "undeeps", "wold", "zirakzigil", "", "acamar", "achrady", "adarak", "adigeon", "ajilon", "akaali", "akritiri", "alastria", "aldea", "alfa", "algeron", "alonda", "althos", "alture", "amargosa", "amleth", "andevian", "andoria", "andros", "angosia", "antede", "antica", "antos", "achanis", "archer", "ardana", "argana", "argelius", "argratha", "argus", "ariannus", "arkaria", "arloff", "armus", "arret", "arvada", "aschelan", "astral", "atalia", "atbar", "athos", "atifs", "atlec", "atrea", "aucdet", "aurelia", "avenal", "axanar", "babel", "bajor", "balancar", "balosnee", "barisa", "barkon", "barradas", "barson", "barzan", "beltane", "benecia", "benthos", "benzar", "betazed", "bilana", "bilaren", "bolarus", "bopak", "boraal", "boradis", "boreal", "boreth", "borka", "boslic", "bracas", "braslota", "brax", "brekka", "brinda", "browder", "bryma", "bynaus", "caere", "cait", "calder", "caldik", "caldonia", "caldos", "caleb", "callinon", "calondia", "campor", "camus", "canopius", "capella", "carema", "carnel", "carraya", "casperia", "castal", "catulla", "celtris", "cerberus", "cestus", "chalna", "chaltok", "chandra", "chaya", "cheron", "cirrus", "coltar", "coridan", "corvan", "cygnet", "dakala", "daled", "danula", "daran", "davlos", "dayos", "decos", "dekendi", "delb", "delinia", "delios", "delos", "delvos", "deneva", "denobula", "deriben", "dessica", "detria", "devidia", "devos", "dimorus", "dinaal", "donatu", "doraf", "dorvan", "dozaria", "draken", "drayan", "draygo", "draylax", "draylon", "drema", "dreon", "dulisian", "durenia", "duronom", "dytallix", "efros", "ekos", "elanu", "elba", "ellora", "emila", "eminiar", "enara", "endicor", "erabus", "errikang", "evadne", "evora", "excalbia", "exo", "fabrina", "fahleena", "farius", "faynos", "felton", "fendaus", "fina", "finnea", "feris", "folnar", "forcas", "forlat", "fornax", "gagarin", "galador", "galen", "gallos", "galor", "galorda", "galvin", "gamelan", "ganalda", "garadius", "garenor", "garon", "gaspar", "gault", "gedi", "gema", "gamaris", "gemulon", "ghorusda", "gideon", "golana", "gonal", "gorthos", "gramilia", "grazer", "haakon", "hakton", "halana", "halee", "halii", "halka", "hanoli", "hanon", "hanoran", "harrakis", "harrod", "hayashi", "hekaras", "hemikek", "heva", "hoek", "holberg", "holna", "hottar", "hupyria", "hurada", "hurkos", "iadora", "iconia", "icor", "idran", "ilari", "ilecom", "ilidaria", "illyria", "inavar", "indri", "inferna", "ingraham", "invernia", "iraatan", "irtok", "itamish", "ivor", "iyaar", "izar", "janus", "japori", "jaros", "jerido", "jouret", "juhraya", "kabrel", "kaelon", "kaldra", "kallas", "kanda", "kantare", "karemma", "kataan", "katerrea", "kavaria", "kavis", "kazlati", "kelis", "kelton", "kelva", "kenda", "kentanna", "kesat", "kesprytt", "kessik", "khitomer", "khosia", "kiberia", "klaestron", "klavdia", "klendeth", "kolandra", "kolarus", "koltair", "kora", "koralis", "korat", "korma", "korridon", "korris", "kostolain", "kotara", "kotati", "kraus", "kressari", "krios", "ktaris", "kurill", "kurl", "kyana", "kylata", "kyria", "landris", "lappa", "largo", "lazon", "ledonia", "ledos", "legara", "lemma", "lerishi", "levinius", "ligobis", "ligon", "ligos", "lissepia", "loracus", "loren", "loval", "luria", "lya", "lyshan", "lysia", "magus", "makus", "malaya", "malcor", "malindi", "malkus", "malon", "malur", "manu", "maranga", "marcos", "mariah", "marijne", "mariposa", "marlonia", "marva", "matalas", "mataline", "mavala", "maxia", "mazar", "meezan", "meldrar", "meles", "melina", "melnos", "merak", "midos", "milika", "minara", "minnobia", "minos", "minshara", "miri", "miridian", "mislen", "mithren", "moab", "modean", "monac", "monea", "mordan", "morikin", "morska", "mudd", "mudor", "mundahla", "nagor", "nahmi", "nanibia", "napinne", "nerendra", "nausicaa", "nel", "nelvana", "nervala", "nessik", "neubilia", "neural", "nibia", "nibiru", "nigala", "nimbus", "ninipia", "nivoch", "norcadia", "norellus", "norkan", "norpin", "nyria", "oby", "ocampa", "oceanus", "ogat", "ogus", "ohniaka", "omekla", "orelious", "orendal", "organia", "orias", "ornara", "otar", "paan", "pacifica", "palamar", "panora", "paraagan", "parada", "parsion", "paxsor", "pegos", "peliar", "pellius", "pendari", "pentarus", "pentath", "penthara", "pernaia", "pollux", "porakas", "portas", "prakal", "pralor", "praxis", "preenos", "prema", "pullock", "pyris", "pythro", "qualor", "quarra", "quatal", "quazulu", "quinor", "rachelis", "rakal", "rakhar", "rakosa", "ramatis", "ramura", "rana", "ranza", "regulak", "reina", "relva", "remmii", "remus", "rhymus", "rinax", "risa", "rivos", "rochanie", "romulus", "ronara", "rondac", "rousseau", "ruah", "rubicun", "runara", "rura", "rutia", "sakura", "saltok", "salva", "sarona", "sarthong", "sauria", "scalos", "securus", "sefalla", "selay", "selek", "selenia", "septimis", "seros", "setlik", "shantil", "shelia", "sheva", "shiralea", "sikaris", "simperia", "sirrie", "sobras", "solais", "solosos", "sothis", "soukara", "stameris", "straleb", "styris", "sulvin", "sumiko", "surata", "tagra", "tagus", "takar", "takara", "talax", "talos", "tamar", "tandar", "tanuga", "tarakis", "tarellia", "taresia", "tarkalea", "tarod", "tarok", "tarsus", "taurus", "tavela", "teerza", "tellar", "telsius", "teplan", "terlina", "terosa", "tessen", "tessik", "tethys", "thalos", "thanatos", "thasus", "thelka", "thera", "tholia", "thurasia", "tiburon", "tilonus", "timor", "titus", "tohvun", "torad", "torga", "torman", "torona", "toroth", "torros", "tracken", "trebus", "trelkis", "triacus", "trialas", "triannon", "trill", "triona", "troyius", "turkana", "tyree", "tyrellia", "tyrus", "tzenketh", "udala", "ufandi", "umoth", "unefra", "uxal", "vacca", "vadris", "vagra", "valo", "valt", "vanden", "vandor", "vandros", "varala", "velara", "veloz", "vendikar", "ventani", "ventax", "verez", "veridian", "vico", "vilmoran", "vissia", "volan", "volchok", "wadi", "wysanti", "xanthras", "xantoras", "xendi", "xindus", "yadalla", "yadera", "yonada", "zadar", "zahl", "zakdorn", "zalkon", "zaran", "zayra", "zeon", "zetar", "zibalia", "zytchin", "", "acanceh", "acanmul", "actuncan", "aguateca", "akte", "almuchil", "ancona", "balakbal", "balamkku", "becan", "bejucal", "blanca", "bonampak", "cahal", "calakmul", "campeche", "cancuen", "cansacbe", "caracol", "cerros", "chac", "chactun", "chakalal", "chakokot", "chal", "chapayal", "chiapa", "chichen", "chichmul", "chijoj", "chinaha", "chocola", "chojolom", "chorro", "civiltuk", "coba", "comitan", "consacbe", "copan", "corona", "corozal", "cuca", "cuello", "culuba", "dzekilna", "ekab", "encanto", "gumarcaj", "hotzuc", "halakal", "hochob", "holactun", "huacutal", "ichmac", "ichmul", "ichpich", "ikil", "itsimte", "ixil", "iximche", "ixkun", "ixlu", "ixtelha", "ixtatan", "ixtutz", "jacawitz", "joyanca", "kabah", "kana", "kanki", "kantunil", "kaxuinic", "kayal", "kinal", "kiuic", "komchen", "lacanha", "maxcanu", "meco", "michol", "mixco", "mulchic", "muluch", "muneca", "naachtun", "nakbe", "nakum", "okop", "oxkintok", "oxpemul", "oxtankah", "palenque", "pechal", "pestac", "pixoy", "pomuch", "quirigua", "qumarkaj", "sabacche", "sacchana", "sacnicte", "sacul", "silvituc", "takalik", "tancah", "techoh", "tikal", "tohcok", "topoxte", "tunich", "ucanal", "uinic", "uitzina", "ukum", "uxbenka", "uxmal", "uxul", "waka", "xcambo", "xcaret", "xculoc", "xelha", "xlapak", "xpuhil", "xtampak", "xtobo", "xul", "xultun", "xupa", "xutilha", "yaxha", "yaxuna", "zacpeten", "zaculeu", "", "achernar", "acrab", "acubens", "adhara", "adhil", "adib", "ain", "albali", "alchibah", "aldebaran", "alfirk", "algebar", "algedi", "algenib", "algieba", "algol", "algorab", "alhena", "alioth", "alkaid", "alkes", "almak", "almeisan", "alnair", "alnasl", "alnilam", "alnitak", "alphard", "alphecca", "alpheratz", "alrescha", "alsafi", "alsuhail", "altair", "alterf", "aludra", "alula", "alya", "ankaa", "arkab", "arneb", "arrakis", "atik", "auva", "azha", "baham", "baten", "beid", "benetnash", "betelguese", "botein", "caph", "celbalrai", "chort", "cursa", "dabih", "deneb", "denebola", "diphda", "dschubba", "dubhe", "dulfim", "dziban", "edasich", "eltanin", "enif", "errai", "fomalhaut", "furud", "gienah", "gomeisa", "hadar", "hamal", "heka", "homam", "izar", "jabbah", "kaitos", "kaus", "keid", "kitalpha", "kochab", "kurhah", "lesath", "maasym", "maaz", "mankib", "marfik", "markab", "matar", "mebsuta", "megrez", "meissa", "mekbuda", "menkar", "merak", "mintaka", "mirak", "mizar", "mothallah", "muphrid", "murzim", "nashira", "nekkar", "nihal", "nusakan", "nushaba", "okda", "phact", "phad", "pherkad", "rastaban", "rigel", "rigilkent", "risha", "rukbah", "sabik", "sadalsuud", "sadr", "saiph", "scheat", "shaula", "shedir", "sheliak", "sheratan", "sirrah", "skat", "sulafat", "talitha", "tania", "tarf", "thuban", "vega", "wasat", "wezn", "yed", "zaurac", "zawiah", "", "cherika", "dunia", "duniya", "hullanta", "jata", "kiania", "kianira", "maleda", "maret", "marinda", "nyika", "nyota", "onile", "osumare", "sama", "sarraqa", "shanira", "zuvan"], Xce = ["alpha", "alpha2", "alpha3", "alpha4", "alpha5", "alpha6", "alphaRANDOM", "alphaRANDOM", "alphaRANDOM", "beta", "beta2", "beta3", "beta4", "beta5", "beta6", "betaRANDOM", "betaRANDOM", "betaRANDOM", "gamma", "gamma2", "gamma3", "gamma4", "gamma5", "gamma6", "gammaRANDOM", "gammaRANDOM", "gammaRANDOM", "delta", "delta2", "delta3", "delta4", "delta5", "delta6", "deltaRANDOM", "deltaRANDOM", "deltaRANDOM", "epsilon", "epsilon2", "epsilon3", "epsilon4", "epsilon5", "epsilon6", "epsilonRANDOM", "epsilonRANDOM", "epsilonRANDOM", "zeta", "zeta2", "zeta3", "zeta4", "zeta5", "zeta6", "zetaRANDOM", "zetaRANDOM", "zetaRANDOM", "eta", "eta2", "eta3", "eta4", "eta5", "eta6", "etaRANDOM", "etaRANDOM", "etaRANDOM", "theta", "theta2", "theta3", "theta4", "theta5", "theta6", "thetaRANDOM", "thetaRANDOM", "thetaRANDOM", "iota", "iota2", "iota3", "iota4", "iota5", "iota6", "iotaRANDOM", "iotaRANDOM", "iotaRANDOM", "kappa", "kappa2", "kappa3", "kappa4", "kappa5", "kappa6", "kappaRANDOM", "kappaRANDOM", "kappaRANDOM", "lambda", "lambda2", "lambda3", "lambda4", "lambda5", "lambda6", "lambdaRANDOM", "lambdaRANDOM", "lambdaRANDOM", "mu", "mu2", "mu3", "mu4", "mu5", "mu6", "muRANDOM", "muRANDOM", "muRANDOM", "nu", "nu2", "nu3", "nu4", "nu5", "nu6", "nuRANDOM", "nuRANDOM", "nuRANDOM", "xi", "xi2", "xi3", "xi4", "xi5", "xi6", "xiRANDOM", "xiRANDOM", "xiRANDOM", "omicron", "omicron2", "omicron3", "omicron4", "omicron5", "omicron6", "omicronRANDOM", "omicronRANDOM", "omicronRANDOM", "pi", "pi2", "pi3", "pi4", "pi5", "pi6", "piRANDOM", "piRANDOM", "piRANDOM", "rho", "rho2", "rho3", "rho4", "rho5", "rho6", "rhoRANDOM", "rhoRANDOM", "rhoRANDOM", "sigma", "sigma2", "sigma3", "sigma4", "sigma5", "sigma6", "sigmaRANDOM", "sigmaRANDOM", "sigmaRANDOM", "tau", "tau2", "tau3", "tau4", "tau5", "tau6", "tauRANDOM", "tauRANDOM", "tauRANDOM", "upsilon", "upsilon2", "upsilon3", "upsilon4", "upsilon5", "upsilon6", "upsilonRANDOM", "upsilonRANDOM", "upsilonRANDOM", "phi", "phi2", "phi3", "phi4", "phi5", "phi6", "phiRANDOM", "phiRANDOM", "phiRANDOM", "chi", "chi2", "chi3", "chi4", "chi5", "chi6", "chiRANDOM", "chiRANDOM", "chiRANDOM", "psi", "psi2", "psi3", "psi4", "psi5", "psi6", "psiRANDOM", "psiRANDOM", "psiRANDOM", "omega", "omega2", "omega3", "omega4", "omega5", "omega6", "omegaRANDOM", "omegaRANDOM", "omegaRANDOM"], $ce = ["a", "b", "c", "d", "e", "f", "g", "h", "k", "m", "n", "p", "q", "r", "v", "x", "y", "z", "adjunct", "anomaly", "band", "boundary", "cloud", "cluster", "collapse", "conflux", "expanse", "field", "fringe", "instability", "manifold", "mass", "nebula", "nebula", "point", "quadrant", "reach", "ring", "sector", "shift", "tensor", "terminus", "vector", "void", "warp"], sM = ["a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", "n", "o", "p", "q", "r", "s", "t", "u", "v", "w", "x", "y", "z"], Wce = function() {
  return sM[Math.floor(Math.random() * sM.length)];
}, Vce = function() {
  return Qr(Yg);
}, Hce = function() {
  return Qr(Fk);
}, l4 = function(t) {
  return t || (t = this.create("number", [5, 10])), new Array(t).fill(null).map(() => this.create("char")).join("");
}, jce = function() {
  return u4();
}, zce = function(t) {
  return Lce(t || Yn(2, 5));
}, qce = function() {
  return Bce();
}, Gce = [l4, i4, s4, a4], Yce = function() {
  return Qr(Object.values(Gce)).bind(this)();
}, Qce = function(t = {}) {
  const { type: e = Qr(Y3) } = t;
  let n = null;
  switch (e) {
    case "result":
      n = {
        type: Qr(["literal"]),
        value: this.create("string")
      };
      break;
    case "markdown":
      n = this.create("markdownString", [{ sections: 4 }]);
      break;
    case "table":
      n = this.create("table");
      break;
    case "unknown":
      n = JSON.stringify(this.create("table"));
      break;
  }
  return new Q3({
    id: this.create("id"),
    created: this.create("date"),
    updated: this.create("date"),
    key: Qr([null, this.create("noun")]),
    type: e,
    description: this.create("markdownString", [{ sections: 1 }]),
    flowRunId: this.create("id"),
    taskRunId: this.create("id"),
    data: n,
    metadata: {},
    ...t
  });
}, Kce = function(t = {}, e) {
  const n = this.create("blockType", [t.blockType]), r = this.create("blockSchema", [t.blockSchema]), o = this.create("blockDocumentData", [e]);
  return new K3({
    id: this.create("string"),
    created: this.create("date"),
    updated: this.create("date"),
    isAnonymous: this.create("boolean"),
    name: this.create("noun"),
    data: o,
    blockSchemaId: r.id,
    blockSchema: r,
    blockTypeId: n.id,
    blockType: n,
    blockDocumentReferences: {},
    can: Ac(),
    ...t
  });
}, Zce = ["email_addresses", "url"], Jce = function(t) {
  const e = {}, n = t ?? Qr(Zce);
  switch (n) {
    case "email_addresses":
      e[n] = this.createMany("email", this.create("number", [1, 3]));
      break;
    case "url":
      e[n] = `https://hooks.slack.com/${this.create("noun")}`;
      break;
    default:
      console.warn(`randomBlockDocumentData missing case for ${n}`), e[n] = [];
  }
  return e;
}, epe = function(t = {}) {
  const e = this.create("blockType", [t.blockType]);
  return new Z3({
    id: this.create("string"),
    created: this.create("date"),
    updated: this.create("date"),
    checksum: this.create("string"),
    fields: this.create("schema"),
    blockTypeId: e.id,
    blockType: e,
    capabilities: this.create("blockSchemaCapabilities"),
    ...t
  });
}, tpe = function() {
  return this.createMany("noun", this.create("number", [5, 10]));
}, npe = function() {
  return this.create("noun");
}, rpe = function(t = {}) {
  const e = this.create("noun");
  return new J3({
    id: this.create("string"),
    created: this.create("date"),
    updated: this.create("date"),
    slug: e,
    name: e,
    logoUrl: this.create("image"),
    documentationUrl: "docs.prefect.io",
    description: this.create("sentence"),
    codeExample: this.create("blockTypeSnippet"),
    ...t
  });
}, ope = function() {
  const t = this.create("noun");
  return `
\`\`\`python
from prefect.filesystem import ${yi(t)}

${t}_block = ${yi(t)}.load("BLOCK_NAME")
\`\`\`
  `.trim();
}, spe = function(t) {
  const e = this.create("runName");
  return {
    name: e,
    collectionType: "flow",
    category: this.create("noun"),
    description: this.create("sentence"),
    returns: this.create("string"),
    examples: this.createMany("paragraph", 1),
    documentationUrl: this.create("string"),
    entrypoint: this.create("string"),
    installCommand: this.create("string"),
    logoUrl: this.create("image"),
    path: this.create("string"),
    repositoryUrl: this.create("string"),
    slug: FI(e),
    parameters: null,
    ...t
  };
}, ape = function(t = {}) {
  return {
    id: this.create("id"),
    created: this.create("date"),
    updated: this.create("date"),
    tag: this.create("noun"),
    concurrencyLimit: this.create("number"),
    activeSlots: this.createMany("string", this.create("number", [0, 10])),
    ...t
  };
}, ipe = function(t = {}) {
  return {
    id: this.create("id"),
    name: this.create("noun"),
    limit: this.create("number"),
    created: this.create("date"),
    updated: this.create("date"),
    ...t
  };
}, upe = function(t = {}) {
  return {
    id: this.create("id"),
    displayValue: this.create("noun"),
    type: Qr(["USER", "BOT", "DEPLOYMENT"]),
    ...t
  };
}, lpe = function(t = {}) {
  const e = Sr() > 0.25, n = Sr() > 0.25 ? this.create("schedule") : null, r = Sr() > 0.25;
  return {
    id: this.create("id"),
    kind: "deployment",
    created: this.create("date"),
    createdBy: this.create("createdOrUpdatedBy"),
    updated: this.create("date"),
    updatedBy: this.create("createdOrUpdatedBy"),
    name: this.create("noun"),
    version: this.create("string"),
    description: this.create("paragraph"),
    flowId: this.create("id"),
    versionInfo: null,
    versionId: Sr() > 0.25 ? this.create("id").slice(0, 8) : null,
    schedule: n,
    schedules: this.create("deploymentSchedules"),
    paused: e,
    parameters: {},
    parameterOpenApiSchema: {},
    tags: this.createMany("noun", this.create("number", [0, 5])),
    manifestPath: this.create("id"),
    path: this.create("id"),
    entrypoint: this.create("id"),
    storageDocumentId: this.create("id"),
    infrastructureDocumentId: this.create("id"),
    jobVariables: {},
    deprecated: !1,
    workQueueName: null,
    workPoolName: Sr() > 0.05 ? this.create("noun") : null,
    appliedBy: Sr() > 0.05 ? this.create("noun") : null,
    enforceParameterSchema: this.create("boolean"),
    pullSteps: [],
    can: Ac(),
    status: this.create("deploymentStatus"),
    disabled: r,
    concurrencyLimit: null,
    globalConcurrencyLimit: null,
    concurrencyOptions: null,
    ...t
  };
}, cpe = function(t = {}) {
  const e = Yn(0, 3), n = [];
  for (let r = 0; r < e; r++)
    n[r] = {
      id: this.create("id"),
      created: this.create("date"),
      updated: this.create("date"),
      slug: Sr() > 0.25 ? this.create("string") : null,
      active: Sr() > 0.25,
      schedule: this.create("schedule"),
      jobVariables: {},
      parameters: {},
      ...t
    };
  return n;
}, ppe = function() {
  return [...bk][Math.floor(Math.random() * bk.length)];
}, dpe = function() {
  return `${this.create("noun")}@email.com`;
}, hpe = function(t = {}) {
  return new tF({
    id: this.create("id"),
    created: this.create("date"),
    description: this.create("paragraph"),
    updated: this.create("date"),
    name: this.create("noun"),
    ...t
  });
}, fpe = function(t = {}) {
  return {
    id: this.create("id"),
    created: this.create("date").toISOString(),
    description: this.create("paragraph"),
    updated: this.create("date").toISOString(),
    name: this.create("noun"),
    ...t
  };
}, mpe = function(t = {}) {
  const e = this.create("state");
  return new nF({
    id: this.create("id"),
    flowId: this.create("id"),
    flowName: Sr() > 0.7 ? this.create("noun") : null,
    deploymentId: Sr() > 0.7 ? this.create("id") : null,
    deploymentVersionId: Sr() > 0.7 ? this.create("id") : null,
    flowVersion: this.create("string"),
    idempotencyKey: this.create("string"),
    expectedStartTime: this.create("date"),
    nextScheduledStartTime: this.create("date"),
    parameters: {},
    autoScheduled: this.create("boolean"),
    context: {},
    empiricalConfig: {},
    empiricalPolicy: null,
    estimatedRunTime: this.create("number"),
    estimatedStartTimeDelta: this.create("number"),
    totalRunTime: this.create("number"),
    startTime: this.create("date"),
    endTime: this.create("date"),
    name: this.create("runName"),
    parentTaskRunId: Sr() > 0.9 ? this.create("id") : null,
    stateId: e.id,
    stateName: e.name,
    stateType: e.type,
    state: e,
    tags: this.createMany("noun", this.create("number", [0, 10])),
    runCount: this.create("number"),
    created: this.create("date"),
    createdBy: this.create("createdOrUpdatedBy"),
    updated: this.create("date"),
    workQueueName: Sr() > 0.7 ? this.create("noun") : null,
    workPoolName: Sr() > 0.7 ? this.create("noun") : null,
    workPoolQueueName: Sr() > 0.7 ? this.create("noun") : null,
    jobVariables: {},
    ...t
  });
}, ype = function(t = {}) {
  const e = this.create("taskRun", [{ id: t.id }]);
  return new $ee({
    upstreamDependencies: [],
    ...e,
    ...t
  });
}, gpe = function(t = {}) {
  const e = [], { size: n = 3, shape: r = "linear", fanMultiplier: o = 1, ids: s = this.createMany("id", n) } = t;
  if (t.size && n !== s.length)
    throw new Error("The number of ids must match the size of the graph");
  let i = 0;
  for (; e.length < n; ) {
    const u = this.create("graphNode", [{ id: s[i] }]);
    e.push(u), ++i;
  }
  if (r == "linear")
    for (let u = 1; u < e.length; ++u) {
      const l = { id: e[u - 1].id, inputType: "task_run" };
      e[u].upstreamDependencies = [l];
    }
  if (r == "fanOut" || r == "fanOutIn") {
    let u = 0;
    const l = [], a = () => {
      u++, l[u] = [];
    };
    e: for (let c = 0; c < e.length; ++c) {
      if (u == 0) {
        l.push([e[c]]), a();
        continue;
      }
      const p = l[u], d = l[u - 1], h = p.length, m = d.length, _ = { id: d[Vd(Sr() * m)].id, inputType: "task_run" };
      if (e[c].upstreamDependencies = [_], r == "fanOut" && h + 1 >= m * o) {
        l[u].push(e[c]), a();
        continue e;
      }
      if (r == "fanOutIn") {
        if (c > e.length / 2 && (h + 1) * o >= m) {
          l[u].push(e[c]), a();
          continue e;
        }
        if (h + 1 >= m * o) {
          l[u].push(e[c]), a();
          continue e;
        }
      }
      l[u].push(e[c]);
    }
  }
  return e;
}, vpe = function(t = {}) {
  return new aF({
    intervalStart: this.create("date"),
    intervalEnd: this.create("date"),
    // todo: Make this mock more realistic
    // mocking this with createMany produces pretty random data that doesn't follow business rules around states
    states: this.createMany("flowRunStateHistory", this.create("number", [1, 5])),
    ...t
  });
}, _pe = function(t = {}) {
  const e = this.create("state");
  return new Gx({
    stateType: e.type,
    stateName: e.name,
    countRuns: this.create("number"),
    sumEstimatedLateness: this.create("number"),
    sumEstimatedRunTime: this.create("number"),
    ...t
  });
}, wpe = function() {
  return Cm();
}, bpe = function(t) {
  let e = 100, n = 100;
  return t && (e = typeof t == "number" ? t : t.width, n = typeof t == "number" ? t : t.height), `https://picsum.photos/${e}/${n}`;
}, kpe = function() {
  return RE[Yn(0, RE.length - 1)];
}, Tpe = function(t = {}) {
  return new rF({
    id: this.create("id"),
    created: this.create("date"),
    updated: this.create("date"),
    name: `${this.create("adjective")}.${this.create("noun")}`,
    level: this.create("logLevel"),
    message: Sr() > 0.75 ? this.create("paragraph") : this.create("sentence"),
    timestamp: this.create("date"),
    flowRunId: this.create("id"),
    taskRunId: this.create("id"),
    workerId: this.create("id"),
    ...t
  });
}, xpe = function({ level: t = Yn(1, 6) } = {}) {
  return `${"#".repeat(t)} ${this.create("noun")}`;
}, Spe = function({ lines: t = Yn(1, 5) } = {}) {
  const e = [];
  for (let n = 0; n < t; n++)
    e.push(`> ${this.create("sentence")}`);
  return `
${e.join(`
`)}`;
}, Rpe = function({ lines: t = Yn(1, 5) } = {}) {
  const e = [];
  for (let n = 0; n < t; n++) {
    const r = Sr() > 0.95;
    let o = "";
    r ? o = `${this.create("sentence")} ${this.create("markdownCodeSpanString")} ${this.create("sentence")}` : o = this.create("sentence"), e.push(o);
  }
  return e.join(`
`);
}, Ape = function({ rows: t = Yn(4, 10), columns: e = Yn(3, 8) } = {}) {
  const n = [], r = [], o = [];
  for (let s = 0; s < e; s++) {
    const i = Qr([":--", ":--:", "--:"]);
    r.push(this.create("noun")), o.push(i);
  }
  n.push(`| ${r.join(" | ")} |`), n.push(`| ${o.join(" | ")} |`);
  for (let s = 0; s < t; s++) {
    const i = [];
    for (let u = 0; u < e; u++)
      i.push(this.create("noun"));
    n.push(`| ${i.join(" | ")} |`);
  }
  return `
${n.join(`
`)}
`;
}, Dpe = function() {
  return `\`${this.create("noun")}\``;
}, Epe = function({ lines: t = Yn(1, 5) } = {}) {
  const e = [];
  for (let n = 0; n < t; n++)
    e.push(this.create("sentence"));
  return `\`\`\`
${e.join(`
`)}
\`\`\``;
}, Mpe = ["header", "quote", "content", "code", "table"], Ppe = function({ sections: t = 5 } = {}) {
  const e = [];
  e.push({
    type: "header",
    content: this.create("markdownHeaderString", [{ level: 1 }]),
    level: 1
  });
  for (let n = 0; n < t; n++) {
    const r = e[e.length - 1], o = Qr(Mpe);
    if (o == "header" && n < t - 1) {
      let s = 1;
      r.type == "header" && r.level && r.level < 6 ? s = r.level + 1 : s = Yn(2, 5), e.push({
        type: "header",
        content: this.create("markdownHeaderString", [{ level: s }]),
        level: s
      });
      continue;
    }
    if (o == "quote") {
      e.push({
        type: "quote",
        content: this.create("markdownQuoteString")
      });
      continue;
    }
    if (o == "table") {
      e.push({
        type: "table",
        content: this.create("markdownTableString")
      });
      continue;
    }
    if (o == "code") {
      e.push({
        type: "content",
        content: this.create("markdownCodeBlockString")
      });
      continue;
    }
    e.push({
      type: "content",
      content: this.create("markdownContentString")
    });
  }
  return e.map((n) => n.content).join(`

`);
}, Cpe = function(t = {}) {
  return new oF({
    id: this.create("id"),
    created: this.create("date"),
    updated: this.create("date"),
    isActive: this.create("boolean"),
    stateNames: this.createMany("stateType", this.create("number", [0, 3])),
    tags: this.createMany("noun", this.create("number", [0, 3])),
    blockDocumentId: this.create("id"),
    ...t
  });
}, Ope = function(t = {}) {
  const { isActive: e, stateNames: n, tags: r, blockDocumentId: o } = this.create("notification");
  return {
    isActive: e,
    stateNames: n,
    tags: r,
    blockDocumentId: o,
    ...t
  };
}, Ipe = function(t = {}, e = F2.create("schema")) {
  const n = {};
  if (!e.properties)
    return {};
  const r = {
    date: this.create("date"),
    "date-time": this.create("date"),
    email: this.create("email"),
    "json-string": "{}",
    regex: "/w+/gi",
    "time-delta": 600,
    password: this.create("string")
  };
  Object.keys(e.properties).forEach((s) => {
    const { type: i, format: u, default: l } = e.properties[s];
    if (Yn(0, 10) > 8 && i !== "object")
      return;
    let a;
    switch (i) {
      case "array":
        a = this.createMany("string", Yn(0, 6));
        break;
      case "string":
        x8(0.1) ? a = u ? r[u] : this.create("sentence") : a = l;
        break;
      case "number":
      case "integer":
        a = this.create("number");
        break;
      case "boolean":
        a = this.create("boolean");
        break;
      case "object":
        a = "{}";
        break;
    }
    typeof a < "u" && (n[s] = a);
  });
  const o = { ...n, ...t };
  return ye.map("SchemaValuesResponse", { values: o, schema: e }, "SchemaValues");
}, aM = [1, 30, 60, 900, 1800, 3600, 86400], iM = [
  "* * * * *",
  "0 0 * * *",
  "@daily",
  "@hourly"
], uM = [
  "DTSTART:20120201T023000Z RRULE:FREQ=MONTHLY;COUNT=5",
  "DTSTART:20120201T023000Z RRULE:FREQ=DAILY;COUNT=30"
], Fpe = function({ type: t } = {}) {
  let e;
  const n = aM[Yn(0, aM.length - 1)], r = iM[Yn(0, iM.length - 1)], o = uM[Yn(0, uM.length - 1)], s = Qr(["interval", "cron", "rrule"]);
  switch (t ?? s) {
    case "interval":
      e = new im({ interval: n, timezone: null, anchorDate: this.create("date") });
      break;
    case "cron":
      e = new B0({ cron: r, timezone: null, dayOr: !1 });
      break;
    case "rrule":
      e = new sF({ rrule: o, timezone: null });
      break;
    default:
      throw new Error(`randomSchedule missing case for ${t ?? s}`);
  }
  return e;
}, Npe = function(t = {}) {
  const e = Qr(HE), n = e == "null" ? Qr(HE) : e, r = n == "string" && Yn(0, 10) > 8 ? Qr(woe) : void 0, o = {
    date: this.create("date"),
    "date-time": this.create("date"),
    email: this.create("email"),
    "json-string": "{}",
    regex: "/w+/gi",
    "time-delta": 600,
    password: this.create("string")
  }, s = {
    null: null,
    array: [],
    string: r ? o[r] : void 0,
    boolean: !1,
    integer: 1,
    number: 1.6,
    object: {},
    block: null
  };
  return {
    title: this.create("noun"),
    type: n,
    description: Yn(0, 10) > 7 ? this.create("sentence") : void 0,
    default: n == "object" || Yn(0, 10) > 4 ? s[n] : void 0,
    properties: n === "object" ? this.create("schemaProperties") : void 0,
    ...r ? { format: r } : {},
    ...t
  };
}, Lpe = function(t = {}) {
  const e = {
    title: "Open API Schema",
    type: "object",
    properties: this.create("schemaProperties"),
    ...t
  };
  return ye.map("SchemaResponse", e, "Schema");
}, Bpe = function(t = {}) {
  return {
    ...this.createMany("schemaProperty", this.create("number", [1, 5])).reduce((n = {}, r) => (n[Mte(r.title)] = r, n), {}),
    ...t
  };
}, Upe = function(t = {}) {
  const e = this.create("stateType"), n = yi(t.type ?? e);
  return {
    id: this.create("id"),
    type: e,
    kind: "state",
    message: this.create("sentence"),
    stateDetails: {
      flowRunId: this.create("id"),
      taskRunId: this.create("id"),
      childFlowRunId: Sr() > 0.9 ? this.create("id") : null,
      scheduledTime: this.create("date"),
      cacheKey: this.create("string"),
      cacheExpiration: this.create("date")
    },
    data: {
      encoding: this.create("string"),
      blob: this.create("string")
    },
    timestamp: this.create("date"),
    name: n,
    ...t
  };
}, Xpe = function() {
  return oh[Math.floor(Math.random() * oh.length)];
}, $pe = function(t = {}) {
  const e = this.create("number", [5, 10]), n = this.create("number", [10, 20]), { columnCount: r = e, rowCount: o = n } = t, s = this.createMany("noun", r), i = ["noun", "number", "boolean", "dateString", "email", "runName"], { keys: u = s, types: l = i } = t, a = u.reduce((p, d) => ({ ...p, [d]: Qr(l) }), {});
  return Array.from({ length: o }, () => u.reduce(
    (d, h) => ({ ...d, [h]: this.create(a[h]) }),
    {}
  ));
}, Wpe = function(t = {}) {
  const e = this.create("state");
  return new iF({
    id: this.create("id"),
    flowRunId: this.create("boolean") ? this.create("id") : null,
    cacheExpiration: this.create("string"),
    cacheKey: this.create("string"),
    created: this.create("date"),
    dynamicKey: this.create("string"),
    empiricalPolicy: null,
    estimatedRunTime: this.create("number"),
    estimatedStartTimeDelta: this.create("number"),
    totalRunTime: this.create("number"),
    expectedStartTime: this.create("date"),
    nextScheduledStartTime: this.create("boolean") ? this.create("date") : null,
    runCount: this.create("number"),
    name: this.create("runName"),
    taskInputs: {},
    taskKey: this.create("string"),
    taskVersion: this.create("string"),
    updated: this.create("date"),
    startTime: this.create("date"),
    endTime: this.create("date"),
    stateId: e.id,
    stateType: e.type,
    stateName: e.name,
    state: e,
    tags: this.createMany("noun", this.create("number", [0, 10])),
    ...t
  });
}, Vpe = function(t = {}) {
  return {
    id: this.create("string"),
    stateType: this.create("stateType"),
    duration: this.create("number", [1, 200]),
    lateness: this.create("number", [1, 200]),
    timestamp: this.create("date"),
    ...t
  };
}, lM = ["com", "net", "io", "org"], Hpe = function(t) {
  const n = t ?? this.create("boolean") ? "https" : "http", r = this.create("noun"), o = this.create("noun"), s = lM[this.create("number", [0, lM.length - 1])];
  return `${n}://${r}.${o}.${s}`;
}, jpe = function(t = {}) {
  return new lF({
    id: this.create("id"),
    created: this.create("date"),
    updated: this.create("date"),
    workPoolId: this.create("id"),
    name: this.create("noun"),
    lastHeartbeatTime: this.create("date"),
    status: this.create("workerStatus"),
    clientVersion: this.create("string"),
    metadata: { integrations: [{ name: this.create("string"), version: this.create("string") }], foo: "bar" },
    heartbeatIntervalSeconds: this.create("number"),
    ...t
  });
}, zpe = function() {
  return AE[Math.floor(Math.random() * AE.length)];
}, qpe = function(t = {}) {
  const e = this.create("noun");
  return new Jx({
    // Setting the id to the name allows us to reference the work pool by name
    // in the demo application key data stores without throwing errors.
    id: e,
    created: this.create("date"),
    updated: this.create("date"),
    name: e,
    description: this.create("paragraph"),
    type: this.create("noun"),
    isPaused: this.create("boolean"),
    isPushPool: this.create("boolean"),
    isMexPool: this.create("boolean"),
    concurrencyLimit: this.create("number"),
    defaultQueueId: this.create("id"),
    baseJobTemplate: this.create("parameters", [{}, this.create("schema")]),
    status: this.create("workPoolStatus"),
    can: Ac(),
    ...t
  });
}, Gpe = function(t = {}) {
  return new t2({
    id: this.create("id"),
    created: this.create("date"),
    updated: this.create("date"),
    workPoolId: this.create("id"),
    workPoolName: this.create("noun"),
    name: this.create("noun"),
    description: this.create("paragraph"),
    isPaused: this.create("boolean"),
    concurrencyLimit: this.create("number"),
    priority: this.create("number"),
    lastPolled: null,
    status: "ready",
    can: Ac(),
    ...t
  });
}, Ype = function() {
  return [...U0, null][Math.floor(Math.random() * U0.length)];
}, Qpe = {
  adjective: Hce,
  any: Yce,
  artifact: Qce,
  blockDocument: Kce,
  blockDocumentData: Jce,
  blockSchema: epe,
  blockSchemaCapabilities: tpe,
  blockSchemaCapability: npe,
  blockType: rpe,
  blockTypeSnippet: ope,
  boolean: s4,
  char: Wce,
  collectionItem: spe,
  concurrencyLimit: ape,
  concurrencyV2Limit: ipe,
  createdOrUpdatedBy: upe,
  date: a4,
  dateString: Rce,
  deployment: lpe,
  deploymentSchedules: cpe,
  deploymentStatus: ppe,
  deploymentVersion: Sce,
  email: dpe,
  flow: hpe,
  flowResponse: fpe,
  flowRun: mpe,
  flowRunGraph: gpe,
  flowRunHistory: vpe,
  flowRunStateHistory: _pe,
  graphNode: ype,
  id: wpe,
  image: bpe,
  log: Tpe,
  logLevel: kpe,
  markdownCodeBlockString: Epe,
  markdownCodeSpanString: Dpe,
  markdownContentString: Rpe,
  markdownHeaderString: xpe,
  markdownQuoteString: Spe,
  markdownString: Ppe,
  markdownTableString: Ape,
  notification: Cpe,
  notificationCreate: Ope,
  noun: Vce,
  number: i4,
  paragraph: zce,
  parameters: Ipe,
  runName: qce,
  schedule: Fpe,
  schema: Lpe,
  schemaProperties: Bpe,
  schemaProperty: Npe,
  sentence: jce,
  state: Upe,
  stateType: Xpe,
  string: l4,
  table: $pe,
  taskRun: Wpe,
  uiFlowRunHistory: Vpe,
  url: Hpe,
  worker: jpe,
  workerStatus: zpe,
  workPool: qpe,
  workPoolQueue: Gpe,
  workPoolStatus: Ype
};
class Kpe {
  mockerFunctions;
  constructor(e) {
    this.mockerFunctions = e;
  }
  create(...[e, n]) {
    return this.mockerFunctions[e].bind(this, ...n ?? [])();
  }
  createMany(...[e, n, r]) {
    const o = this.mockerFunctions[e].bind(this, ...r ?? []);
    return Tx(n, o);
  }
}
const F2 = new Kpe(Qpe);
class o6e {
  static global = [];
  static async before(e, n) {
    const r = this.getRouteGuards(e);
    for (const o of r) {
      const s = await o.before?.(e, n);
      if (this.isRouteLocation(s))
        return s;
    }
  }
  static after(e, n) {
    const r = this.getRouteGuards(e);
    for (const o of r)
      o.after?.(e, n);
  }
  static register(e) {
    this.global.push(e);
  }
  static getRouteGuards(e) {
    const n = e.matched.flatMap((r) => r.meta.guards ?? []);
    return [...this.global, ...n];
  }
  // test this
  static isRouteLocation(e) {
    return typeof e == "string" || typeof e == "object";
  }
}
class s6e {
  next = 1;
  get() {
    return this.next++;
  }
}
class Zpe {
  subscriptions = /* @__PURE__ */ new Map();
  store = lt(/* @__PURE__ */ new Map());
  add(e) {
    this.isNewValue(e) && this.store.set(e.id, e);
  }
  remove(e) {
    this.subscriptions.delete(e), this.store.delete(e);
  }
  get(e) {
    return this.store.get(e);
  }
  addAll(e) {
    e.forEach((n) => this.add(n));
  }
  removeAll(e) {
    e.forEach((n) => this.remove(n));
  }
  getAll(e) {
    return e.map((n) => this.get(n)).filter(Vt);
  }
  subscribe(e) {
    const n = Cm();
    return this.getSubscription(e).add(n), () => this.unsubscribe(e, n);
  }
  unsubscribe(e, n) {
    const r = this.getSubscription(e);
    r.delete(n), r.size === 0 && this.remove(e);
  }
  getSubscription(e) {
    const n = this.subscriptions.get(e);
    if (n)
      return n;
    const r = /* @__PURE__ */ new Set();
    return this.subscriptions.set(e, r), r;
  }
  isNewValue(e) {
    const n = this.store.get(e.id);
    return !(n && n.storageTimestamp.getTime() > e.storageTimestamp.getTime());
  }
}
function Jpe(t) {
  return gj() ? (AI(t), !0) : !1;
}
function ede(t) {
  return () => {
    let e, n;
    return Jpe(() => {
      e?.(), n?.();
    }), {
      add: (s) => t.add(s),
      addAll: (s) => t.addAll(s),
      remove: (s) => t.remove(s),
      removeAll: (s) => t.removeAll(s),
      get: (s) => {
        const i = e;
        return e = t.subscribe(s), i?.(), t.get(s);
      },
      getAll: (s) => {
        const i = n, u = s.map((l) => t.subscribe(l));
        return n = () => u.forEach((l) => l()), i?.(), t.getAll(s);
      }
    };
  };
}
const tde = new Zpe(), a6e = ede(tde);
class nde extends qn {
  routePrefix = "/flow_run_states";
  async getFlowRunState(e) {
    const { data: n } = await this.get(`/${e}`);
    return ye.map("StateResponse", n, "State");
  }
  async getFlowRunStates(e) {
    const { data: n } = await this.get(`?flow_run_id=${e}`);
    return ye.map("StateResponse", n, "State");
  }
}
class rde extends qn {
  routePrefix = "/task_run_states";
  async getTaskRunState(e) {
    const { data: n } = await this.get(`/${e}`);
    return ye.map("StateResponse", n, "State");
  }
  async getTaskRunStates(e) {
    const { data: n } = await this.get(`?task_run_id=${e}`);
    return ye.map("StateResponse", n, "State");
  }
}
const c4 = /* @__PURE__ */ U({
  __name: "ActivityChart",
  props: {
    intervalStart: {},
    intervalEnd: {},
    intervalSeconds: {},
    history: {}
  },
  setup(t) {
    const e = t, n = /* @__PURE__ */ new Map([
      ["completed", -1],
      ["running", -1],
      ["scheduled", -1],
      ["pending", -1],
      ["paused", -1],
      ["failed", 1],
      ["cancelled", 1],
      ["crashed", 1]
    ]), r = [...n.entries()].filter(([, u]) => u < 0).map(([u]) => u), o = [...n.entries()].filter(([, u]) => u > 0).map(([u]) => u), s = (u) => `bg-state-${u.toLowerCase()}-500`, i = D(
      () => ye.map("RunHistory", e.history, "DivergingBarChartItem").sort((u, l) => vk(u.intervalStart, l.intervalEnd))
    );
    return (u, l) => (T(), O(v(vj), {
      class: "activity-chart",
      items: i.value,
      "interval-start": u.intervalStart,
      "interval-end": u.intervalEnd,
      "interval-seconds": u.intervalSeconds,
      "positive-sentiment-keys": v(r),
      "negative-sentiment-keys": v(o),
      "static-median": "",
      "chart-padding": { top: 0, bottom: 0, middle: 4 }
    }, {
      default: k(({ key: a }) => [
        re("div", {
          class: Bt(["activity-chart__bar", s(a)])
        }, null, 2)
      ]),
      median: k(() => [...l[0] || (l[0] = [
        re("div", { class: "activity-chart__median" }, null, -1)
      ])]),
      empty: k(() => [...l[1] || (l[1] = [
        re("div", { class: "activity-chart__empty" }, null, -1)
      ])]),
      _: 1
    }, 8, ["items", "interval-start", "interval-end", "interval-seconds", "positive-sentiment-keys", "negative-sentiment-keys"]));
  }
}), ode = { class: "formatted-date__tooltip" }, sde = {
  type: "button",
  class: "formatted-date"
}, hn = /* @__PURE__ */ U({
  __name: "FormattedDate",
  props: {
    date: {},
    format: {}
  },
  setup(t) {
    const e = t, { now: n } = gx({ interval: 6e4 }), r = D(() => {
      switch (e.format) {
        case "numeric":
          return qs(e.date);
        case "date":
          return Xo(e.date);
        case "datetime":
          return LJ(e.date);
        case "relative":
        default:
          return W3(e.date, n.value);
      }
    });
    return (o, s) => {
      const i = P("p-tooltip");
      return T(), O(i, { "avoid-collisions": "" }, {
        content: k(() => [
          Ve(o.$slots, "tooltip", {}, () => [
            re("div", ode, ie(o.date), 1)
          ])
        ]),
        default: k(() => [
          re("button", sde, [
            Ve(o.$slots, "default", sn(kn({ date: r.value })), () => [
              q(ie(r.value), 1)
            ])
          ])
        ]),
        _: 3
      });
    };
  }
}), ade = {
  key: 0,
  class: "artifact-card__title"
}, ide = { class: "artifact-card__summary-item" }, ude = { class: "artifact-card__summary-item-label" }, lde = { class: "artifact-card__summary-item-value" }, cde = { class: "artifact-card__description-container" }, pde = {
  key: 1,
  class: "artifact-card__description-empty"
}, hh = /* @__PURE__ */ U({
  __name: "ArtifactCard",
  props: {
    artifact: {},
    condense: { type: Boolean },
    interactive: { type: Boolean }
  },
  setup(t) {
    const e = t, n = D(() => !!e.artifact.key), r = D(() => ({
      root: {
        "artifact-card--condensed": e.condense,
        "artifact-card--interactive": e.interactive
      },
      body: {
        "artifact-card__body--condensed": e.condense
      },
      header: {
        "artifact-card__header--condensed": e.condense
      },
      subheader: {
        "artifact-card__subheader--condensed": e.condense
      },
      summaryContainer: {
        "artifact-card__summary-container--condensed": e.condense
      }
    })), o = /^#+/, s = D(() => e.artifact.description ? e.artifact.description.trim().split(`
`)[0].replace(o, "").trim() : null);
    return (i, u) => {
      const l = P("p-markdown-renderer"), a = P("p-card");
      return T(), O(a, {
        class: Bt(["artifact-card", r.value.root])
      }, {
        default: k(() => [
          re("div", {
            class: Bt(["artifact-card__body", r.value.body])
          }, [
            re("header", {
              class: Bt(["artifact-card__header", r.value.header])
            }, [
              re("div", {
                class: Bt(["artifact-card__subheader", r.value.subheader])
              }, ie(i.artifact.type), 3),
              n.value ? (T(), z("div", ade, ie(i.artifact.key), 1)) : j("", !0)
            ], 2),
            Ve(i.$slots, "default", {}, () => [
              re("div", {
                class: Bt(["artifact-card__summary-container", r.value.summaryContainer])
              }, [
                re("div", ide, [
                  re("span", ude, [
                    Ve(i.$slots, "summary-label", {}, () => [
                      q(ie(v(le).info.created), 1)
                    ])
                  ]),
                  re("span", lde, [
                    Ve(i.$slots, "summary-value", {}, () => [
                      w(hn, {
                        date: i.artifact.created,
                        format: "datetime"
                      }, null, 8, ["date"])
                    ])
                  ])
                ])
              ], 2)
            ])
          ], 2),
          re("div", cde, [
            Ve(i.$slots, "description", {}, () => [
              s.value ? (T(), O(l, {
                key: 0,
                text: s.value,
                class: "artifact-card__description"
              }, null, 8, ["text"])) : (T(), z("p", pde, ie(v(le).info.noDescription), 1))
            ])
          ])
        ]),
        _: 3
      }, 8, ["class"]);
    };
  }
}), Os = /* @__PURE__ */ U({
  __name: "DocumentationButton",
  props: {
    to: {}
  },
  setup(t) {
    return (e, n) => {
      const r = P("p-button");
      return T(), O(r, {
        to: e.to,
        class: "documentation-button",
        target: "_blank",
        "icon-append": "ArrowTopRightOnSquareIcon"
      }, {
        default: k(() => [
          Ve(e.$slots, "default", {}, () => [
            n[0] || (n[0] = q(" View Docs ", -1))
          ])
        ]),
        _: 3
      }, 8, ["to"]);
    };
  }
}), p4 = /* @__PURE__ */ U({
  __name: "ArtifactCollectionsEmptyState",
  setup(t) {
    return (e, n) => (T(), O(v(na), { class: "artifact-collections-empty-state" }, {
      icon: k(() => [
        w(v(vo), { icon: "PhotoIcon" })
      ]),
      heading: k(() => [...n[0] || (n[0] = [
        q(" Create an artifact ", -1)
      ])]),
      description: k(() => [
        q(ie(v(le).info.artifactsEmptyState), 1)
      ]),
      actions: k(() => [
        w(Os, {
          to: v(le).docs.artifacts
        }, null, 8, ["to"])
      ]),
      _: 1
    }));
  }
}), dde = c_("prefect-ui-library-view-mode"), hde = "grid", { value: fde, set: mde } = hl(dde, hde), kp = D({
  get() {
    return fde.value;
  },
  set(t) {
    mde(t);
  }
}), W0 = /* @__PURE__ */ U({
  __name: "RowGridLayoutList",
  props: {
    items: {}
  },
  setup(t) {
    const e = t, n = D(() => e.items.length === 0), r = D(() => ({
      root: {
        "row-grid-layout-list--grid": !n.value && kp.value === "grid",
        "row-grid-layout-list--rows": !n.value && kp.value === "rows"
      }
    }));
    return (o, s) => {
      const i = P("p-virtual-scroller");
      return n.value ? Ve(o.$slots, "empty", { key: 0 }) : (T(), O(i, {
        key: 1,
        class: Bt(["row-grid-layout-list", r.value.root]),
        items: e.items
      }, {
        default: k(({ item: u }) => [
          Ve(o.$slots, "default", { item: u })
        ]),
        _: 3
      }, 8, ["items", "class"]));
    };
  }
}), S_ = /* @__PURE__ */ U({
  __name: "ViewModeButtonGroup",
  setup(t) {
    const e = [
      { value: "grid", icon: "Squares2X2Icon" },
      { value: "rows", icon: "Bars4Icon" }
    ];
    return (n, r) => {
      const o = P("p-button-group");
      return T(), O(o, {
        modelValue: v(kp),
        "onUpdate:modelValue": r[0] || (r[0] = (s) => Xe(kp) ? kp.value = s : null),
        options: e
      }, null, 8, ["modelValue"]);
    };
  }
}), yde = { class: "artifact-collections" }, gde = { class: "artifact-collections__filters" }, vde = /* @__PURE__ */ U({
  __name: "ArtifactCollections",
  setup(t) {
    const e = ge(""), n = ns(e, 1200), r = ge(null), o = Se(), s = je(), i = D(() => {
      const d = n.value ? n.value : void 0, h = !0, m = r.value ? [r.value] : void 0;
      return {
        artifacts: {
          keyExists: h,
          keyLike: d,
          type: m
        }
      };
    }), u = mt(o.artifacts.getArtifactCollections, [i]), l = mt(o.artifacts.getArtifactCollectionsCount, [i]), a = D(() => u.executed), c = D(() => u.response ?? []), p = D(() => l.response);
    return (d, h) => {
      const m = P("router-link");
      return T(), z("div", yde, [
        re("div", gde, [
          w(v(Uo), {
            label: v(le).info.artifact,
            count: p.value,
            class: "artifact-collections__results"
          }, null, 8, ["label", "count"]),
          w(v(Wo), {
            modelValue: e.value,
            "onUpdate:modelValue": h[0] || (h[0] = (g) => e.value = g),
            placeholder: v(le).info.artifactSearch,
            label: v(le).info.artifactSearch,
            class: "artifact-collections__search"
          }, null, 8, ["modelValue", "placeholder", "label"]),
          w(v(y4), {
            selected: r.value,
            "onUpdate:selected": h[1] || (h[1] = (g) => r.value = g),
            class: "artifact-collections__type"
          }, null, 8, ["selected"]),
          w(S_, { class: "artifact-collections__view-mode" })
        ]),
        a.value ? (T(), O(W0, {
          key: 0,
          items: c.value
        }, {
          default: k(({ item: g }) => [
            w(m, {
              to: v(s).artifactKey(g.key)
            }, {
              default: k(() => [
                w(hh, {
                  artifact: g,
                  interactive: ""
                }, {
                  "summary-label": k(() => [
                    q(ie(v(le).info.lastUpdated), 1)
                  ]),
                  "summary-value": k(() => [
                    w(hn, {
                      date: g.updated,
                      format: "datetime"
                    }, null, 8, ["date"])
                  ]),
                  _: 2
                }, 1032, ["artifact"])
              ]),
              _: 2
            }, 1032, ["to"])
          ]),
          empty: k(() => [
            w(p4)
          ]),
          _: 1
        }, 8, ["items"])) : j("", !0)
      ]);
    };
  }
}), d4 = /* @__PURE__ */ U({
  __name: "ArtifactDataMarkdown",
  props: {
    artifact: {}
  },
  setup(t) {
    const e = t, n = D(() => e.artifact.data);
    return (r, o) => {
      const s = P("p-markdown-renderer");
      return T(), O(s, {
        class: "artifact-data-markdown",
        text: n.value
      }, null, 8, ["text"]);
    };
  }
}), _de = { class: "artifact-data-raw" }, wde = /* @__PURE__ */ U({
  __name: "ArtifactDataRaw",
  props: {
    artifact: {}
  },
  setup(t) {
    const e = t, n = D(() => {
      const o = Ip(e.artifact.data ?? "");
      return JSON.stringify(o, null, 2);
    }), r = D(() => {
      switch (e.artifact.type) {
        case "markdown":
          return "gh-markdown";
        case "table":
        case "result":
        case "unknown":
        default:
          return "json";
      }
    });
    return (o, s) => {
      const i = P("p-code-highlight");
      return T(), z("section", _de, [
        w(v(fh), {
          "text-to-copy": n.value,
          class: "artifact-data-raw__copyable-wrapper"
        }, {
          default: k(() => [
            w(i, yt({ "show-line-numbers": "" }, { lang: r.value, text: n.value }, { class: "artifact-data-raw__code" }), null, 16)
          ]),
          _: 1
        }, 8, ["text-to-copy"])
      ]);
    };
  }
}), bde = { class: "artifact-data-result" }, h4 = /* @__PURE__ */ U({
  __name: "ArtifactDataResult",
  props: {
    artifact: {}
  },
  setup(t) {
    const e = t, n = D(() => Object.entries(e.artifact.data));
    return (r, o) => {
      const s = P("p-key-value");
      return T(), z("div", bde, [
        (T(!0), z(ve, null, ln(n.value, ([i, u]) => (T(), O(s, {
          key: i,
          label: i,
          value: u
        }, null, 8, ["label", "value"]))), 128))
      ]);
    };
  }
}), kde = { class: "artifact-data-unknown" }, f4 = /* @__PURE__ */ U({
  __name: "ArtifactDataUnknown",
  props: {
    artifact: {}
  },
  setup(t) {
    const e = t, n = D(() => e.artifact.data);
    return (r, o) => (T(), z("div", kde, ie(n.value), 1));
  }
}), Tde = { class: "artifact-data-progress" }, xde = /* @__PURE__ */ U({
  __name: "ArtifactDataProgress",
  props: {
    artifact: {}
  },
  setup(t) {
    return (e, n) => (T(), z("div", Tde, " Progress: " + ie(Math.trunc(e.artifact.data)) + "% ", 1));
  }
}), Sde = { class: "artifact-data-image" }, Rde = ["src"], Ade = /* @__PURE__ */ U({
  __name: "ArtifactDataImage",
  props: {
    artifact: {}
  },
  setup(t) {
    return (e, n) => {
      const r = P("p-link");
      return T(), z("div", Sde, [
        re("img", {
          src: e.artifact.data
        }, null, 8, Rde),
        n[1] || (n[1] = re("br", null, null, -1)),
        re("p", null, [
          n[0] || (n[0] = re("span", null, "Image URL: ", -1)),
          w(r, {
            to: e.artifact.data
          }, {
            default: k(() => [
              q(ie(e.artifact.data), 1)
            ]),
            _: 1
          }, 8, ["to"])
        ])
      ]);
    };
  }
}), Dde = { class: "artifact-data-table__results-count" }, Ede = { class: "artifact-data-table__count" }, Mde = { class: "artifact-data-table__count" }, Pde = { class: "artifact-data-table__cell" }, Cde = /* @__PURE__ */ U({
  __name: "ArtifactDataTable",
  props: {
    artifact: {}
  },
  setup(t) {
    const e = t, n = D(() => Ip(e.artifact.data)), r = D(() => Rre(e.artifact.data)), o = D(() => {
      if (HF(n.value))
        return n.value;
      if (jF(n.value)) {
        const d = [];
        return Object.entries(n.value).forEach(([h, m]) => {
          m.forEach((g, _) => {
            d[_] ??= {}, d[_][h] = g;
          });
        }), d;
      }
      return [];
    }), s = D(() => o.value.length === 0 ? [] : Object.keys(o.value[0])), i = ge(""), u = ns(i, 250), l = D(() => {
      if (!u.value)
        return o.value;
      const d = u.value.toLowerCase();
      return o.value.filter((h) => Object.values(h).join(" ").toLowerCase().includes(d));
    }), a = D(() => o.value.length), c = D(() => l.value.length), p = D(() => r.value ? le.info.noData : le.info.invalidData(le.docs.artifacts));
    return (d, h) => {
      const m = P("p-list-header"), g = P("p-markdown-renderer"), _ = P("p-empty-results"), b = P("p-table"), x = P("p-content");
      return T(), O(x, { class: "artifact-data-table" }, {
        default: k(() => [
          w(m, null, {
            controls: k(() => [
              re("span", Dde, [
                c.value !== a.value ? (T(), z(ve, { key: 0 }, [
                  re("span", Ede, ie(c.value), 1),
                  h[1] || (h[1] = q(" of ", -1))
                ], 64)) : j("", !0),
                re("span", Mde, ie(a.value), 1),
                q(" " + ie(v(Ks)(v(le).info.item, a.value)), 1)
              ]),
              w(v(Wo), {
                modelValue: i.value,
                "onUpdate:modelValue": h[0] || (h[0] = (S) => i.value = S)
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          w(b, { data: l.value }, Ut({
            "empty-state": k(() => [
              w(_, null, {
                default: k(() => [
                  w(g, { text: p.value }, null, 8, ["text"])
                ]),
                _: 1
              })
            ]),
            _: 2
          }, [
            ln(s.value, (S) => ({
              name: v(FI)(S),
              fn: k(({ row: E, column: A }) => [
                re("span", Pde, [
                  A.property && v(Ht)(E[A.property]) ? (T(), O(g, {
                    key: 0,
                    class: "artifact-data-table__cell-renderer",
                    text: E[A.property]
                  }, null, 8, ["text"])) : A.property ? (T(), z(ve, { key: 1 }, [
                    q(ie(E[A.property]), 1)
                  ], 64)) : j("", !0)
                ])
              ])
            }))
          ]), 1032, ["data"])
        ]),
        _: 1
      });
    };
  }
}), Ode = { class: "artifact-data-view" }, N2 = /* @__PURE__ */ U({
  __name: "ArtifactDataView",
  props: {
    artifact: {}
  },
  setup(t) {
    const e = t, n = D(() => e.artifact), r = D(() => {
      switch (e.artifact.type) {
        case "result":
          return h4;
        case "markdown":
          return d4;
        case "table":
          return Cde;
        case "progress":
          return xde;
        case "image":
          return Ade;
        case "unknown":
        default:
          return f4;
      }
    });
    return (o, s) => (T(), z("section", Ode, [
      (T(), O(Mr(r.value), { artifact: n.value }, null, 8, ["artifact"]))
    ]));
  }
}), Ide = { class: "artifact-description" }, m4 = /* @__PURE__ */ U({
  __name: "ArtifactDescription",
  props: {
    artifact: {}
  },
  setup(t) {
    const e = t, n = D(() => e.artifact.description ?? "");
    return (r, o) => {
      const s = P("p-markdown-renderer");
      return T(), z("section", Ide, [
        w(s, { text: n.value }, null, 8, ["text"])
      ]);
    };
  }
}), Fde = { class: "artifact-details" }, Nde = /* @__PURE__ */ U({
  __name: "ArtifactDetails",
  props: {
    artifact: {},
    alternate: { type: Boolean }
  },
  setup(t) {
    const e = t, n = Ke(), r = D(() => e.alternate ? 6 : 5), o = D(() => e.artifact.flowRunId), { flowRun: s } = yl(o), i = D(() => s.value?.state?.message), u = D(() => e.artifact.taskRunId), { taskRun: l } = Kp(u), a = D(() => !!e.artifact.key || !!o.value || !!u.value);
    return (c, p) => {
      const d = P("p-divider"), h = P("p-heading"), m = P("p-code"), g = P("p-text-truncate");
      return T(), z("div", Fde, [
        c.artifact ? (T(), z(ve, { key: 0 }, [
          a.value ? (T(), z(ve, { key: 0 }, [
            c.artifact.key ? (T(), O(v(Lt), {
              key: 0,
              label: "Artifact",
              alternate: c.alternate
            }, {
              value: k(() => [
                w(v(L2), {
                  "artifact-id": c.artifact.id
                }, null, 8, ["artifact-id"])
              ]),
              _: 1
            }, 8, ["alternate"])) : j("", !0),
            c.artifact.flowRunId ? (T(), O(v(Lt), {
              key: 1,
              label: "Flow Run",
              alternate: c.alternate
            }, {
              value: k(() => [
                w(v(ty), {
                  "flow-run-id": c.artifact.flowRunId
                }, null, 8, ["flow-run-id"])
              ]),
              _: 1
            }, 8, ["alternate"])) : j("", !0),
            c.artifact.taskRunId ? (T(), O(v(Lt), {
              key: 2,
              label: "Task Run",
              alternate: c.alternate
            }, {
              value: k(() => [
                w(v(B2), {
                  "task-run-id": c.artifact.taskRunId
                }, null, 8, ["task-run-id"])
              ]),
              _: 1
            }, 8, ["alternate"])) : j("", !0),
            w(d)
          ], 64)) : j("", !0),
          w(h, { heading: r.value }, {
            default: k(() => [...p[0] || (p[0] = [
              q(" Artifact ", -1)
            ])]),
            _: 1
          }, 8, ["heading"]),
          w(v(Lt), {
            label: "Key",
            alternate: c.alternate
          }, {
            value: k(() => [
              w(m, { inline: "" }, {
                default: k(() => [
                  q(ie(c.artifact.key), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["alternate"]),
          w(v(Lt), {
            label: "Type",
            alternate: c.alternate
          }, {
            value: k(() => [
              w(m, { inline: "" }, {
                default: k(() => [
                  q(ie(c.artifact.type), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["alternate"]),
          w(v(Lt), {
            label: "Created",
            alternate: c.alternate
          }, {
            value: k(() => [
              w(hn, {
                date: c.artifact.created,
                format: "numeric"
              }, null, 8, ["date"])
            ]),
            _: 1
          }, 8, ["alternate"])
        ], 64)) : j("", !0),
        v(n).read.flow_run && v(s) ? (T(), z(ve, { key: 1 }, [
          w(d),
          w(h, { heading: r.value }, {
            default: k(() => [...p[1] || (p[1] = [
              q(" Flow Run ", -1)
            ])]),
            _: 1
          }, 8, ["heading"]),
          w(v(Lt), {
            label: "Start Time",
            alternate: c.alternate
          }, {
            value: k(() => [
              w(v(ay), { "flow-run": v(s) }, null, 8, ["flow-run"])
            ]),
            _: 1
          }, 8, ["alternate"]),
          w(v(Lt), {
            label: "Duration",
            alternate: c.alternate
          }, {
            value: k(() => [
              w(v(Cc), {
                duration: v(s).duration
              }, null, 8, ["duration"])
            ]),
            _: 1
          }, 8, ["alternate"]),
          w(v(Lt), {
            label: "Created",
            alternate: c.alternate
          }, {
            value: k(() => [
              w(hn, {
                date: v(s).created,
                format: "numeric"
              }, null, 8, ["date"])
            ]),
            _: 1
          }, 8, ["alternate"]),
          v(s).createdBy ? (T(), O(v(Lt), {
            key: 0,
            label: "Created By",
            value: v(s).createdBy.displayValue,
            alternate: c.alternate
          }, null, 8, ["value", "alternate"])) : j("", !0),
          w(v(Lt), {
            label: "Last Updated",
            alternate: c.alternate
          }, {
            value: k(() => [
              w(hn, {
                date: v(s).updated,
                format: "numeric"
              }, null, 8, ["date"])
            ]),
            _: 1
          }, 8, ["alternate"]),
          w(v(Lt), {
            label: "Tags",
            alternate: c.alternate
          }, Ut({ _: 2 }, [
            v(s).tags?.length ? {
              name: "value",
              fn: k(() => [
                w(v(am), {
                  tags: v(s).tags
                }, null, 8, ["tags"])
              ]),
              key: "0"
            } : void 0
          ]), 1032, ["alternate"]),
          w(v(Lt), {
            label: "State Message",
            alternate: c.alternate
          }, Ut({ _: 2 }, [
            i.value ? {
              name: "value",
              fn: k(() => [
                w(g, { text: i.value }, null, 8, ["text"])
              ]),
              key: "0"
            } : void 0
          ]), 1032, ["alternate"])
        ], 64)) : j("", !0),
        v(n).read.task_run && v(l) ? (T(), z(ve, { key: 2 }, [
          w(d),
          w(h, { heading: r.value }, {
            default: k(() => [...p[2] || (p[2] = [
              q(" Task Run ", -1)
            ])]),
            _: 1
          }, 8, ["heading"]),
          w(v(Lt), {
            label: "Created",
            alternate: c.alternate
          }, {
            value: k(() => [
              w(hn, {
                date: v(l).created,
                format: "numeric"
              }, null, 8, ["date"])
            ]),
            _: 1
          }, 8, ["alternate"]),
          w(v(Lt), {
            label: "Last Updated",
            alternate: c.alternate
          }, {
            value: k(() => [
              w(hn, {
                date: v(l).updated,
                format: "numeric"
              }, null, 8, ["date"])
            ]),
            _: 1
          }, 8, ["alternate"]),
          w(v(Lt), {
            label: "Tags",
            alternate: c.alternate
          }, Ut({ _: 2 }, [
            v(l).tags?.length ? {
              name: "value",
              fn: k(() => [
                w(v(am), {
                  tags: v(l).tags
                }, null, 8, ["tags"])
              ]),
              key: "0"
            } : void 0
          ]), 1032, ["alternate"])
        ], 64)) : j("", !0)
      ]);
    };
  }
}), L2 = /* @__PURE__ */ U({
  __name: "ArtifactKeyIconText",
  props: {
    artifactId: {}
  },
  setup(t) {
    const e = t, n = je(), { artifactId: r } = Nn(e), { artifact: o } = _2(r), s = D(() => o.value?.key), i = D(() => wk[o.value?.type ?? "unknown"]);
    return (u, l) => {
      const a = P("p-icon-text"), c = P("p-link");
      return s.value ? (T(), O(c, {
        key: 0,
        to: v(n).artifactKey(s.value),
        class: "artifact-key-icon-text"
      }, {
        default: k(() => [
          w(a, { icon: i.value }, {
            default: k(() => [
              re("span", null, ie(s.value), 1)
            ]),
            _: 1
          }, 8, ["icon"])
        ]),
        _: 1
      }, 8, ["to"])) : j("", !0);
    };
  }
}), uo = /* @__PURE__ */ U({
  __name: "CopyOverflowMenuItem",
  props: {
    item: {},
    label: {}
  },
  setup(t) {
    return (e, n) => (T(), O(v(rk), {
      label: e.label,
      onClick: n[0] || (n[0] = (r) => v(gF)(e.item))
    }, null, 8, ["label"]));
  }
}), Lde = /* @__PURE__ */ U({
  inheritAttrs: !1,
  __name: "ArtifactMenu",
  props: {
    artifact: {}
  },
  setup(t) {
    return (e, n) => {
      const r = P("p-icon-button-menu");
      return T(), O(r, sn(kn(e.$attrs)), {
        default: k(() => [
          w(uo, {
            label: "Copy ID",
            item: e.artifact.id
          }, null, 8, ["item"]),
          Ve(e.$slots, "default", sn(kn({ artifact: e.artifact })))
        ]),
        _: 3
      }, 16);
    };
  }
}), ty = /* @__PURE__ */ U({
  __name: "FlowRunIconText",
  props: {
    flowRunId: {}
  },
  setup(t) {
    const e = t, n = je(), { flowRunId: r } = Nn(e), { flowRun: o } = yl(r), s = D(() => o.value?.name);
    return (i, u) => {
      const l = P("p-icon-text"), a = P("p-link");
      return T(), O(a, {
        to: v(n).flowRun(v(r)),
        class: "flow-run-icon-text"
      }, {
        default: k(() => [
          w(l, { icon: "FlowRun" }, {
            default: k(() => [
              re("span", null, ie(s.value), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["to"]);
    };
  }
}), B2 = /* @__PURE__ */ U({
  __name: "TaskRunIconText",
  props: {
    taskRunId: {}
  },
  setup(t) {
    const e = t, n = Se(), r = je(), o = mt(n.taskRuns.getTaskRun, [e.taskRunId]), s = D(() => o.response?.name);
    return (i, u) => {
      const l = P("p-icon-text"), a = P("p-link");
      return T(), O(a, {
        to: v(r).taskRun(i.taskRunId),
        class: "task-run-icon-text"
      }, {
        default: k(() => [
          w(l, { icon: "Task" }, {
            default: k(() => [
              re("span", null, ie(s.value), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["to"]);
    };
  }
}), Bde = {
  key: 0,
  class: "artifact-timeline-item-content__icon-text-container"
}, Ude = {
  key: 1,
  class: "artifact-timeline-item-content__icon-text-container"
}, Xde = {
  key: 0,
  class: "artifact-timeline-item-content__body"
}, $de = {
  key: 1,
  class: "artifact-timeline-item-content__loading"
}, Wde = /* @__PURE__ */ U({
  __name: "ArtifactTimelineItemContent",
  props: {
    artifact: {},
    expanded: { type: [Boolean, Array, null] },
    value: {}
  },
  emits: ["update:expanded"],
  setup(t, { emit: e }) {
    const n = t, r = e, o = D({
      get() {
        return n.expanded ?? void 0;
      },
      set(p) {
        r("update:expanded", p);
      }
    }), s = D(() => Gt(o.value) ? !1 : hu.isArray(o.value) ? o.value.includes(n.value) : o.value), i = ns(s, 1e3), u = () => {
      if (!Gt(o.value)) {
        if (hu.isArray(o.value)) {
          s.value ? o.value = o.value.filter((p) => p !== n.value) : o.value = [...o.value, n.value];
          return;
        }
        o.value = !o.value;
      }
    }, l = je(), a = D(() => n.artifact.id.slice(0, 8)), c = D(() => ({
      root: {
        "artifact-timeline-item-content--expanded": s.value
      },
      heading: {
        "artifact-timeline-item-content__heading--expanded": s.value
      }
    }));
    return (p, d) => {
      const h = P("p-link"), m = P("p-heading"), g = P("p-divider"), _ = P("p-markdown-renderer"), b = P("p-loading-icon"), x = P("p-card");
      return T(), O(x, {
        class: Bt(["artifact-timeline-item-content", c.value.root]),
        tabindex: "0",
        flat: !s.value,
        onKeyup: PI(ek(u, ["self"]), ["enter"])
      }, {
        default: k(() => [
          re("div", {
            class: Bt(["artifact-timeline-item-content__heading", c.value.heading]),
            onClick: u
          }, [
            w(m, { heading: "6" }, {
              default: k(() => [
                w(h, {
                  to: v(l).artifact(p.artifact.id),
                  title: p.artifact.id,
                  onClick: d[0] || (d[0] = ek(() => {
                  }, ["stop"]))
                }, {
                  default: k(() => [
                    q(ie(a.value), 1)
                  ]),
                  _: 1
                }, 8, ["to", "title"])
              ]),
              _: 1
            }),
            p.artifact.flowRunId ? (T(), z("div", Bde, [
              q(ie(v(le).info.flowRun) + " ", 1),
              w(ty, {
                class: "artifact-timeline-item-content__icon-text",
                "flow-run-id": p.artifact.flowRunId
              }, null, 8, ["flow-run-id"])
            ])) : j("", !0),
            p.artifact.taskRunId ? (T(), z("div", Ude, [
              q(ie(v(le).info.taskRun) + " ", 1),
              w(B2, {
                class: "artifact-timeline-item-content__icon-text",
                "task-run-id": p.artifact.taskRunId
              }, null, 8, ["task-run-id"])
            ])) : j("", !0)
          ], 2),
          s.value ? (T(), z(ve, { key: 0 }, [
            w(g),
            v(i) ? (T(), z("section", Xde, [
              p.artifact.description ? (T(), z(ve, { key: 0 }, [
                w(_, {
                  text: p.artifact.description
                }, null, 8, ["text"]),
                w(g)
              ], 64)) : j("", !0),
              w(N2, { artifact: p.artifact }, null, 8, ["artifact"])
            ])) : (T(), z("div", $de, [
              w(b)
            ]))
          ], 64)) : j("", !0)
        ]),
        _: 1
      }, 8, ["class", "flat", "onKeyup"]);
    };
  }
}), Vde = ["title"], Hde = {
  key: 0,
  class: "artifact-timeline-item-date__latest"
}, jde = { class: "artifact-timeline-item-date__time" }, zde = { class: "artifact-timeline-item-date__date" }, qde = /* @__PURE__ */ U({
  __name: "ArtifactTimelineItemDate",
  props: {
    artifact: {},
    latest: { type: Boolean }
  },
  setup(t) {
    return (e, n) => {
      const r = P("p-icon");
      return T(), z("div", {
        class: "artifact-timeline-item-date",
        title: v(qs)(e.artifact.created)
      }, [
        e.latest ? (T(), z("div", Hde, [
          w(r, {
            class: "artifact-timeline-item-date__latest-icon",
            icon: "TagIcon",
            size: "small"
          }),
          q(" " + ie(v(le).info.latest), 1)
        ])) : j("", !0),
        re("span", jde, ie(v(X3)(e.artifact.created)), 1),
        re("span", zde, ie(v(Xo)(e.artifact.created)), 1)
      ], 8, Vde);
    };
  }
}), Gde = { class: "artifact-timeline" }, Yde = { class: "artifact-timeline__content" }, cM = 10, Qde = /* @__PURE__ */ U({
  __name: "ArtifactTimeline",
  props: {
    artifactKey: {}
  },
  setup(t) {
    const e = t, n = Se(), r = ge([]), o = D(() => ({
      artifacts: {
        key: [e.artifactKey]
      },
      sort: "CREATED_DESC",
      limit: cM
    })), s = ge(0), i = D(() => ({
      ...o.value,
      offset: s.value
    })), { artifactCollection: u } = tse(e.artifactKey), l = D(() => u.value?.latestId), a = D(() => ({
      artifacts: {
        key: [e.artifactKey]
      }
    })), c = mt(n.artifacts.getArtifactsCount, [a]), p = D(() => c.response ?? 0), d = ge([]), h = async () => {
      const b = await n.artifacts.getArtifacts(i.value), S = [...new Map([...d.value, ...b].map((E) => [E.id, E])).values()].sort((E, A) => vk(A.created, E.created));
      d.value = S;
    }, m = async () => {
      const b = await n.artifacts.getArtifacts(o.value), S = [...new Map([...d.value, ...b].map((E) => [E.id, E])).values()].sort((E, A) => vk(A.created, E.created));
      d.value = S;
    };
    Ct(l, (b, x) => {
      b && !x ? r.value = [b] : m();
    }, { immediate: !0 }), Ct(s, h);
    const g = () => {
      d.value.length >= p.value || (s.value += cM);
    };
    MI(() => {
      m();
    });
    const _ = D(() => {
      const b = [];
      let x;
      return d.value.forEach((S) => {
        x && x !== S.type && b.push({
          id: `${S.id}-type-change`,
          data: le.info.artifactTypeChanged(x),
          icon: wk[S.type],
          type: "message"
        }), b.push({
          id: S.id,
          data: S,
          type: "artifact"
        }), x = S.type;
      }), b.push({
        id: `${e.artifactKey}-created`,
        data: le.info.artifactCreated(e.artifactKey),
        icon: wk.default,
        type: "message"
      }), b;
    });
    return (b, x) => {
      const S = P("p-markdown-renderer"), E = P("p-timeline");
      return T(), z("div", Gde, [
        w(E, {
          items: _.value,
          "item-estimate-height": 60,
          "item-key": "id",
          class: "artifact-timeline__timeline",
          onBottom: g
        }, {
          content: k(({ item: A }) => [
            re("div", Yde, [
              A.type == "artifact" ? (T(), O(Wde, {
                key: 0,
                expanded: r.value,
                "onUpdate:expanded": x[0] || (x[0] = (C) => r.value = C),
                artifact: A.data,
                value: A.data.id
              }, null, 8, ["expanded", "artifact", "value"])) : A.type == "message" ? (T(), O(S, {
                key: 1,
                text: A.data
              }, null, 8, ["text"])) : j("", !0)
            ])
          ]),
          date: k(({ item: A }) => [
            A.type == "artifact" ? (T(), O(qde, {
              key: 0,
              artifact: A.data,
              latest: A.data.id === l.value,
              class: "artifact-timeline__date"
            }, null, 8, ["artifact", "latest"])) : j("", !0)
          ]),
          _: 1
        }, 8, ["items"])
      ]);
    };
  }
}), y4 = /* @__PURE__ */ U({
  __name: "ArtifactTypeSelect",
  props: {
    selected: {}
  },
  emits: ["update:selected"],
  setup(t, { emit: e }) {
    const n = t, r = e, o = D({
      get() {
        return n.selected;
      },
      set(i) {
        r("update:selected", i);
      }
    }), s = [
      { label: "All types", value: null },
      { label: "Markdown", value: "markdown" },
      { label: "Table", value: "table" }
    ];
    return (i, u) => {
      const l = P("p-select");
      return T(), O(l, {
        modelValue: o.value,
        "onUpdate:modelValue": u[0] || (u[0] = (a) => o.value = a),
        options: s,
        class: "artifact-type-select"
      }, null, 8, ["modelValue"]);
    };
  }
}), g4 = /* @__PURE__ */ U({
  __name: "AutomationIconText",
  props: {
    automationId: {}
  },
  setup(t) {
    const e = t, n = Ke(), r = je(), o = D(() => e.automationId), { automation: s } = MN(o), i = D(() => s.value?.name);
    return (u, l) => {
      const a = P("p-icon-text"), c = P("p-link");
      return v(n).read.automation ? (T(), O(c, {
        key: 0,
        to: v(r).automation(o.value),
        class: "automation-icon-text"
      }, {
        default: k(() => [
          w(a, { icon: "Automation" }, {
            default: k(() => [
              re("span", null, ie(i.value), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["to"])) : j("", !0);
    };
  }
}), Kde = { class: "delete-modal__title" }, Zde = { class: "delete-modal__message" }, _r = /* @__PURE__ */ U({
  __name: "ConfirmDeleteModal",
  props: /* @__PURE__ */ Br({
    label: {},
    name: {},
    loading: { type: Boolean },
    action: { default: "Delete" }
  }, {
    showModal: { type: Boolean, required: !0 },
    showModalModifiers: {}
  }),
  emits: /* @__PURE__ */ Br(["delete"], ["update:showModal"]),
  setup(t, { emit: e }) {
    const n = zn(t, "showModal"), r = e, o = () => {
      r("delete"), n.value = !1;
    };
    return (s, i) => {
      const u = P("p-icon"), l = P("p-button"), a = P("p-modal");
      return T(), O(a, {
        showModal: n.value,
        "onUpdate:showModal": i[0] || (i[0] = (c) => n.value = c)
      }, {
        icon: k(() => [
          w(u, {
            icon: "ExclamationCircleIcon",
            class: "delete-modal__icon"
          })
        ]),
        title: k(() => [
          re("div", Kde, [
            Ve(s.$slots, "title", {}, () => [
              q(ie(`${s.action} ${s.label ?? s.name}`), 1)
            ])
          ])
        ]),
        actions: k(() => [
          Ve(s.$slots, "actions", {}, () => [
            w(l, {
              variant: "destructive",
              loading: s.loading,
              onClick: o
            }, {
              default: k(() => [
                q(ie(s.action), 1)
              ]),
              _: 1
            }, 8, ["loading"])
          ])
        ]),
        default: k(() => [
          re("span", Zde, [
            Ve(s.$slots, "message", {}, () => [
              q(" Are you sure you want to " + ie(s.action.toLowerCase()) + " " + ie(s.name) + "? ", 1)
            ])
          ])
        ]),
        _: 3
      }, 8, ["showModal"]);
    };
  }
}), Jde = ["href"], ehe = /* @__PURE__ */ U({
  inheritAttrs: !1,
  __name: "AutomationMenu",
  props: {
    automation: {}
  },
  emits: ["delete"],
  setup(t, { emit: e }) {
    const n = t, r = e, o = Ke(), s = Se(), i = je(), { showModal: u, open: l } = St();
    async function a() {
      try {
        await s.automations.deleteAutomation(n.automation.id), He(le.success.automationDelete, "success"), r("delete");
      } catch (c) {
        console.error(c);
        const p = Yt(c, le.error.automationDelete);
        He(p, "error");
      }
    }
    return (c, p) => {
      const d = P("p-overflow-menu-item"), h = P("router-link"), m = P("p-icon"), g = P("p-icon-button-menu");
      return T(), z(ve, null, [
        w(g, yt(c.$attrs, { class: "automation-menu" }), {
          default: k(() => [
            w(uo, {
              label: "Copy ID",
              item: c.automation.id
            }, null, 8, ["item"]),
            w(h, {
              to: v(i).automationEdit(c.automation.id)
            }, {
              default: k(() => [
                v(o).update.automation ? (T(), O(d, {
                  key: 0,
                  label: "Edit"
                })) : j("", !0)
              ]),
              _: 1
            }, 8, ["to"]),
            v(o).delete.automation ? (T(), O(d, {
              key: 0,
              label: "Delete",
              onClick: v(l)
            }, null, 8, ["onClick"])) : j("", !0),
            re("a", {
              href: v(le).docs.automations,
              target: "_blank"
            }, [
              w(d, null, {
                default: k(() => [
                  p[1] || (p[1] = q(" Documentation ", -1)),
                  w(m, {
                    class: "user-menu__icon",
                    icon: "ArrowTopRightOnSquareIcon"
                  })
                ]),
                _: 1
              })
            ], 8, Jde),
            Ve(c.$slots, "default")
          ]),
          _: 3
        }, 16),
        w(_r, {
          showModal: v(u),
          "onUpdate:showModal": p[0] || (p[0] = (_) => Xe(u) ? u.value = _ : null),
          name: c.automation.name,
          label: "Automation",
          onDelete: a
        }, null, 8, ["showModal", "name"])
      ], 64);
    };
  }
}), the = {}, nhe = { class: "beta-badge" };
function rhe(t, e) {
  return T(), z("span", nhe, " Beta ");
}
const v4 = /* @__PURE__ */ Dc(the, [["render", rhe]]), ohe = { class: "block-capability-block-document-input__option" }, she = { class: "block-capability-block-document-input__group" }, _4 = /* @__PURE__ */ U({
  inheritAttrs: !1,
  __name: "BlockCapabilityBlockDocumentInput",
  props: {
    modelValue: {},
    capability: {},
    useModal: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(t, { emit: e }) {
    const n = t, r = e, { capability: o } = Nn(n), s = Se(), { classes: i, styles: u, listeners: l, attrs: a } = Oj(), { showModal: c, open: p, close: d } = St(), h = je(), m = D({
      get() {
        return n.modelValue;
      },
      set(B) {
        r("update:modelValue", B);
      }
    }), g = D(() => n.modelValue ? [n.modelValue] : null), _ = xt(s.blockDocuments.getBlockDocument, g), b = D(() => _.response), x = D(() => ({
      blockSchemas: {
        blockCapabilities: [o.value]
      }
    })), S = mt(s.blockTypes.getBlockTypes, [x]), E = D(() => S.response ?? []), A = D(() => E.value.map((B) => B.slug)), C = D(() => A.value.length == 0 ? null : [{
      blockTypes: {
        slug: A.value
      }
    }]), M = xt(s.blockDocuments.getBlockDocuments, C), L = D(() => {
      const B = M.response ?? [];
      return b.value && !B.some((W) => W.id === b.value?.id) && B.push({
        ...b.value,
        name: "Anonymous Block"
      }), B;
    }), X = D(() => E.value.flatMap((B) => {
      const W = L.value.filter((ne) => ne.blockTypeId === B.id);
      return W.length === 0 ? [] : {
        blockType: B,
        label: B.name,
        options: ye.map("BlockDocument", W, "SelectOption")
      };
    })), te = async (B) => {
      m.value = B.id, await Promise.all([
        S.refresh(),
        M.refresh()
      ]), d();
    };
    return (B, W) => {
      const G = P("p-select"), ne = P("p-button");
      return T(), z("div", yt({
        class: ["block-capability-block-document-input", v(i)],
        style: v(u)
      }, v(l)), [
        w(G, yt({
          modelValue: m.value,
          "onUpdate:modelValue": W[0] || (W[0] = (de) => m.value = de)
        }, v(a), {
          options: X.value,
          class: "block-capability-block-document-input__select"
        }), {
          default: k(({ label: de, value: V }) => [
            re("div", ohe, [
              V === b.value?.id ? (T(), z(ve, { key: 0 }, [
                b.value ? (T(), O(fu, {
                  key: 0,
                  url: b.value.blockType.logoUrl,
                  class: "block-capability-block-document-input__logo"
                }, null, 8, ["url"])) : j("", !0)
              ], 64)) : j("", !0),
              q(" " + ie(de), 1)
            ])
          ]),
          group: k(({ group: de }) => [
            re("div", she, [
              de.blockType ? (T(), O(fu, {
                key: 0,
                url: de.blockType.logoUrl,
                class: "block-capability-block-document-input__logo"
              }, null, 8, ["url"])) : j("", !0),
              q(" " + ie(de.label), 1)
            ])
          ]),
          _: 1
        }, 16, ["modelValue", "options"]),
        B.useModal ? (T(), O(ne, {
          key: 0,
          "icon-append": "PlusIcon",
          onClick: v(p)
        }, {
          default: k(() => [...W[2] || (W[2] = [
            q(" Add ", -1)
          ])]),
          _: 1
        }, 8, ["onClick"])) : (T(), O(ne, {
          key: 1,
          "icon-append": "PlusIcon",
          to: v(gi)(v(h).blocksCatalog(), { capability: v(o) })
        }, {
          default: k(() => [...W[3] || (W[3] = [
            q(" Add ", -1)
          ])]),
          _: 1
        }, 8, ["to"])),
        w(QN, {
          showModal: v(c),
          "onUpdate:showModal": W[1] || (W[1] = (de) => Xe(c) ? c.value = de : null),
          capability: v(o),
          onRefresh: te
        }, null, 8, ["showModal", "capability"])
      ], 16);
    };
  }
}), ahe = { class: "block-type-card-layout" }, ihe = { class: "block-type-card-layout__content" }, w4 = /* @__PURE__ */ U({
  __name: "BlockTypeCardLayout",
  props: {
    blockType: {}
  },
  setup(t) {
    return (e, n) => {
      const r = P("p-card");
      return T(), O(r, null, {
        default: k(() => [
          re("div", ahe, [
            re("div", ihe, [
              Ve(e.$slots, "default")
            ]),
            w(P2, {
              "block-type": e.blockType,
              class: "block-type-card-layout__type"
            }, null, 8, ["block-type"])
          ])
        ]),
        _: 3
      });
    };
  }
}), uhe = { class: "copyable-wrapper" }, fh = /* @__PURE__ */ U({
  __name: "CopyableWrapper",
  props: {
    textToCopy: {}
  },
  setup(t) {
    const e = t;
    function n() {
      gF(e.textToCopy);
    }
    return (r, o) => (T(), z("div", uhe, [
      Ve(r.$slots, "default"),
      w(v(Zo), {
        size: "sm",
        variant: "ghost",
        class: "copyable-wrapper__button",
        title: "copy",
        icon: "DocumentDuplicateIcon",
        onClick: n
      })
    ]));
  }
}), U2 = /* @__PURE__ */ U({
  __name: "BlockTypeSnippet",
  props: {
    snippet: {},
    name: {}
  },
  setup(t) {
    const e = t, n = D(() => {
      const [, r = ""] = e.snippet.match(/```python([\S\s]*?)```/) ?? [];
      return r.replace("BLOCK_NAME", e.name ?? "block-name").trim();
    });
    return (r, o) => {
      const s = P("p-code-highlight");
      return T(), O(fh, {
        "text-to-copy": n.value,
        class: "block-type-snippet"
      }, {
        default: k(() => [
          w(s, {
            lang: "python",
            text: n.value,
            class: "block-type-snippet__code"
          }, null, 8, ["text"])
        ]),
        _: 1
      }, 8, ["text-to-copy"]);
    };
  }
}), lhe = { class: "schema-property-block-key-value" }, che = /* @__PURE__ */ U({
  __name: "SchemaPropertyBlockKeyValue",
  props: {
    property: {},
    value: {}
  },
  setup(t) {
    const e = t, n = Se(), r = je(), o = D(() => e.value.blockDocumentId ? [e.value.blockDocumentId] : null), s = xt(n.blockDocuments.getBlockDocument, o), i = D(() => s.response);
    return (u, l) => {
      const a = P("p-link");
      return T(), z("div", lhe, [
        w(v(Lt), {
          class: "block-document-key-value",
          label: u.property.title
        }, Ut({ _: 2 }, [
          i.value ? {
            name: "value",
            fn: k(() => [
              i.value ? (T(), O(a, {
                key: 0,
                to: v(r).block(i.value.id)
              }, {
                default: k(() => [
                  q(ie(i.value.name), 1)
                ]),
                _: 1
              }, 8, ["to"])) : j("", !0)
            ]),
            key: "0"
          } : void 0
        ]), 1032, ["label"])
      ]);
    };
  }
}), b4 = /* @__PURE__ */ U({
  __name: "SchemaPropertyKeyValue",
  props: {
    property: {},
    value: {},
    alternate: { type: Boolean }
  },
  setup(t) {
    const e = t, n = D(() => e.property.type === "array" || e.property.meta?.component === Rr), r = D(() => lh(e.value) ?? ""), o = D(() => typeof e.value == "object" && e.value !== null ? Array.isArray(e.value) ? e.value.length > 0 : Object.keys(e.value).length > 0 : typeof e.value < "u" && e.value !== null && e.value !== "");
    return (s, i) => {
      const u = P("p-code-highlight"), l = P("p-key-value");
      return v(L0)(s.value) ? (T(), O(che, sn(yt({ key: 0 }, { property: s.property, value: s.value })), null, 16)) : (T(), O(l, yt({
        key: 1,
        label: s.property.title,
        class: "schema-property-key-value"
      }, { value: s.value, alternate: s.alternate }), Ut({ _: 2 }, [
        o.value && n.value ? {
          name: "value",
          fn: k(() => [
            w(fh, { "text-to-copy": r.value }, {
              default: k(() => [
                w(u, {
                  lang: "json",
                  text: r.value
                }, null, 8, ["text"])
              ]),
              _: 1
            }, 8, ["text-to-copy"])
          ]),
          key: "0"
        } : void 0
      ]), 1040, ["label"]));
    };
  }
}), X2 = /* @__PURE__ */ U({
  __name: "SchemaPropertiesKeyValues",
  props: {
    schema: {},
    values: {},
    alternate: { type: Boolean }
  },
  setup(t) {
    const e = t;
    function n(o) {
      return e.values[o];
    }
    const r = D(() => Object.entries(e.schema.properties ?? {}).sort(([, s], [, i]) => (s?.position ?? 0) - (i?.position ?? 0)));
    return (o, s) => {
      const i = P("p-content");
      return T(), O(i, { class: "schema-properties-key-values" }, {
        default: k(() => [
          (T(!0), z(ve, null, ln(r.value, ([u, l]) => (T(), z(ve, { key: u }, [
            l ? (T(), O(b4, yt({
              key: 0,
              value: n(u)
            }, { ref_for: !0 }, { property: l, alternate: o.alternate }), null, 16, ["value"])) : j("", !0)
          ], 64))), 128))
        ]),
        _: 1
      });
    };
  }
}), phe = {
  key: 0,
  class: "block-document-card__help"
}, dhe = /* @__PURE__ */ U({
  __name: "BlockDocumentCard",
  props: {
    blockDocument: {}
  },
  setup(t) {
    const e = t, n = D(() => e.blockDocument.blockType), r = D(() => n.value.codeExample), o = D(() => e.blockDocument.name);
    return (s, i) => {
      const u = P("p-link");
      return T(), O(w4, {
        "block-type": s.blockDocument.blockType
      }, {
        default: k(() => [
          w(v(NI), { class: "block-document-card__content" }, {
            default: k(() => [
              n.value.codeExample || n.value.documentationUrl ? (T(), z("p", phe, [
                n.value.codeExample ? (T(), z(ve, { key: 0 }, [
                  i[0] || (i[0] = q(" Paste this snippet ", -1)),
                  i[1] || (i[1] = re("span", { class: "block-document-card__emphasized-section" }, "into your flows", -1)),
                  i[2] || (i[2] = q(" to use this block. ", -1))
                ], 64)) : j("", !0),
                n.value.documentationUrl ? (T(), z(ve, { key: 1 }, [
                  i[4] || (i[4] = q(" Need help? ", -1)),
                  w(u, {
                    to: n.value.documentationUrl
                  }, {
                    default: k(() => [...i[3] || (i[3] = [
                      q(" View Docs ", -1)
                    ])]),
                    _: 1
                  }, 8, ["to"])
                ], 64)) : j("", !0)
              ])) : j("", !0),
              r.value ? (T(), O(U2, sn(yt({ key: 1 }, { snippet: r.value, name: o.value })), null, 16)) : j("", !0),
              w(X2, {
                values: s.blockDocument.data,
                schema: s.blockDocument.blockSchema.fields
              }, null, 8, ["values", "schema"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["block-type"]);
    };
  }
}), hhe = /* @__PURE__ */ U({
  __name: "BlockDocumentKeyValue",
  props: {
    blockDocumentId: {}
  },
  setup(t) {
    const e = t, n = Se(), r = je(), o = mt(n.blockDocuments.getBlockDocument, [e.blockDocumentId]), s = D(() => o.response);
    return (i, u) => {
      const l = P("p-link");
      return s.value ? (T(), O(v(Lt), {
        key: 0,
        class: "block-document-key-value",
        label: s.value.blockType.name
      }, {
        value: k(() => [
          w(l, {
            to: v(r).block(s.value.id)
          }, {
            default: k(() => [
              q(ie(s.value.name), 1)
            ]),
            _: 1
          }, 8, ["to"])
        ]),
        _: 1
      }, 8, ["label"])) : j("", !0);
    };
  }
}), fhe = /* @__PURE__ */ U({
  inheritAttrs: !1,
  __name: "BlockDocumentMenu",
  props: {
    blockDocument: {}
  },
  emits: ["delete"],
  setup(t, { emit: e }) {
    const n = t, r = e, o = rs(), s = je(), i = Se(), { showModal: u, open: l } = St();
    function a() {
      o.push(s.blockEdit(n.blockDocument.id));
    }
    async function c(p) {
      await Ua(p, i.blockDocuments.deleteBlockDocument, "Block"), r("delete");
    }
    return (p, d) => (T(), z(ve, null, [
      w(v(Ij), sn(kn(p.$attrs)), {
        default: k(() => [
          w(uo, {
            label: "Copy Name",
            item: p.blockDocument.name
          }, null, 8, ["item"]),
          p.blockDocument.can.update ? (T(), O(v(rk), {
            key: 0,
            label: "Edit",
            onClick: a
          })) : j("", !0),
          p.blockDocument.can.delete ? (T(), O(v(rk), {
            key: 1,
            label: "Delete",
            onClick: v(l)
          }, null, 8, ["onClick"])) : j("", !0),
          Ve(p.$slots, "default", sn(kn({ blockDocument: p.blockDocument })))
        ]),
        _: 3
      }, 16),
      w(_r, {
        showModal: v(u),
        "onUpdate:showModal": d[0] || (d[0] = (h) => Xe(u) ? u.value = h : null),
        label: "Block",
        name: p.blockDocument.name,
        onDelete: d[1] || (d[1] = (h) => c(p.blockDocument.id))
      }, null, 8, ["showModal", "name"])
    ], 64));
  }
}), mhe = /* @__PURE__ */ U({
  __name: "BlocksDeleteButton",
  props: {
    selected: {}
  },
  emits: ["delete"],
  setup(t, { emit: e }) {
    const n = e, { showModal: r, open: o, close: s } = St(), i = Se(), u = Eh(), l = async (a) => {
      const c = D(() => a.length === 1 ? le.success.delete("Block") : le.success.delete(`${a.length} blocks`));
      try {
        const p = a.map(i.blockDocuments.deleteBlockDocument);
        await Promise.all(p), He(c, "success"), n("delete");
      } catch (p) {
        const d = Yt(p, le.error.delete("blocks"));
        He(d, "error");
      } finally {
        s();
      }
    };
    return (a, c) => {
      const p = P("p-button");
      return T(), z(ve, null, [
        a.selected.length > 0 ? (T(), O(p, yt({ key: 0 }, v(u), {
          icon: "TrashIcon",
          onClick: v(o)
        }), null, 16, ["onClick"])) : j("", !0),
        w(_r, {
          showModal: v(r),
          "onUpdate:showModal": c[0] || (c[0] = (d) => Xe(r) ? r.value = d : null),
          name: "selected blocks",
          label: "Blocks",
          onDelete: c[1] || (c[1] = (d) => l(a.selected))
        }, null, 8, ["showModal"])
      ], 64);
    };
  }
}), k4 = /* @__PURE__ */ U({
  __name: "BlockTypeSelect",
  props: {
    selected: {},
    allowUnset: { type: Boolean }
  },
  emits: ["update:selected"],
  setup(t, { emit: e }) {
    const n = t, r = e, o = D({
      get() {
        return n.selected ?? null;
      },
      set(a) {
        r("update:selected", a);
      }
    }), s = Se(), i = mt(s.blockTypes.getBlockTypes), u = D(() => i.response ?? []), l = D(() => {
      const a = u.value.map((c) => ({
        value: c.slug,
        label: c.name
      }));
      return n.allowUnset && a.unshift({
        value: null,
        label: "None"
      }), a;
    });
    return (a, c) => {
      const p = P("p-combobox");
      return T(), O(p, {
        modelValue: o.value,
        "onUpdate:modelValue": c[0] || (c[0] = (d) => o.value = d),
        options: l.value,
        "empty-message": "Block type",
        class: "block-type-combobox"
      }, {
        default: k(({ label: d }) => [
          q(" Type: " + ie(d), 1)
        ]),
        _: 1
      }, 8, ["modelValue", "options"]);
    };
  }
}), yhe = {
  key: 0,
  class: "selected-count"
}, td = /* @__PURE__ */ U({
  __name: "SelectedCount",
  props: {
    count: {},
    label: { default: "" }
  },
  setup(t) {
    const e = t, n = D(() => e.count && e.label !== "" ? mc(e.label, e.count) : "");
    return (r, o) => v(ih)(r.count) ? (T(), z("span", yhe, ie(r.count) + " " + ie(n.value) + " selected ", 1)) : j("", !0);
  }
}), ghe = { class: "block-documents-table__block" }, vhe = { class: "block-documents-table__content" }, _he = /* @__PURE__ */ U({
  __name: "BlockDocumentsTable",
  props: {
    filter: {}
  },
  emits: ["delete"],
  setup(t, { emit: e }) {
    const n = t, r = e, { BlockDocumentMenu: o } = Vn(), s = je(), i = (M) => [`deployment-list__${hu.snakeCase(M.label)}-column`], u = D(() => [
      {
        label: "Block"
      },
      {
        label: "Action",
        width: "64px"
      }
    ]), l = dn("page", _o, 1), a = ge([]), c = ge([]), p = ge(""), d = ns(p, 500), { value: h } = hl("block-documents-table-limit", 10), { filter: m } = Coe({
      blockSchemas: {
        blockCapabilities: a
      },
      blockDocuments: {
        nameLike: d
      },
      blockTypes: {
        slug: c
      },
      limit: h,
      sort: "BLOCK_TYPE_AND_NAME_ASC"
    }), { blockDocuments: g, total: _, pages: b, subscriptions: x } = sse(() => $t({}, n.filter, m), {
      page: l
    }), S = D(() => g.value.map(
      (M) => (M.can.delete || (M.disabled = !0), M)
    ));
    function E() {
      p.value = "", a.value = [], c.value = [];
    }
    const A = ge([]);
    function C() {
      A.value = [], x.refresh(), r("delete");
    }
    return (M, L) => {
      const X = P("p-list-header"), te = P("router-link"), B = P("p-button"), W = P("p-loading-icon"), G = P("p-table"), ne = P("p-pager"), de = P("p-content");
      return T(), O(de, { class: "block-documents-table" }, {
        default: k(() => [
          w(X, { sticky: "" }, {
            controls: k(() => [
              w(Wo, {
                modelValue: p.value,
                "onUpdate:modelValue": L[0] || (L[0] = (V) => p.value = V),
                placeholder: "Search blocks",
                size: "small",
                label: "Search blocks",
                class: "block-documents-table__search"
              }, null, 8, ["modelValue"]),
              w(k4, {
                selected: c.value,
                "onUpdate:selected": L[1] || (L[1] = (V) => c.value = V),
                class: "block-documents-table__type",
                small: ""
              }, null, 8, ["selected"])
            ]),
            default: k(() => [
              A.value.length === 0 ? (T(), O(Uo, {
                key: 0,
                label: "Block",
                count: v(_)
              }, null, 8, ["count"])) : (T(), O(td, {
                key: 1,
                count: A.value.length
              }, null, 8, ["count"])),
              A.value.length > 0 ? (T(), O(mhe, {
                key: 2,
                class: "block-documents-table__delete",
                selected: A.value.map((V) => V.id),
                size: "sm",
                onDelete: C
              }, null, 8, ["selected"])) : j("", !0)
            ]),
            _: 1
          }),
          w(G, {
            class: "block-documents-table__table",
            data: S.value,
            columns: u.value,
            selected: A.value,
            "column-classes": i,
            "onUpdate:selected": L[2] || (L[2] = (V) => A.value = V)
          }, {
            block: k(({ row: V }) => [
              re("div", ghe, [
                w(fu, {
                  url: V.blockType.logoUrl,
                  class: "block-documents-table__logo"
                }, null, 8, ["url"]),
                re("div", vhe, [
                  w(te, {
                    to: v(s).block(V.id),
                    class: "block-documents-table__block-name"
                  }, {
                    default: k(() => [
                      q(ie(V.name), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"]),
                  w(te, {
                    to: v(s).blocksCatalogView(V.blockType.slug),
                    class: "block-documents-table__block-type"
                  }, {
                    default: k(() => [
                      q(ie(V.blockType.name), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"])
                ])
              ])
            ]),
            "action-heading": k(() => [...L[5] || (L[5] = [
              re("span", null, null, -1)
            ])]),
            action: k(({ row: V }) => [
              w(v(o), {
                "block-document": V,
                small: "",
                onDelete: C
              }, null, 8, ["block-document"])
            ]),
            "empty-state": k(() => [
              v(x).executed ? (T(), O(v(el), { key: 0 }, {
                message: k(() => [...L[6] || (L[6] = [
                  q(" No blocks ", -1)
                ])]),
                actions: k(() => [
                  w(B, {
                    size: "sm",
                    onClick: E
                  }, {
                    default: k(() => [...L[7] || (L[7] = [
                      q(" Clear Filters ", -1)
                    ])]),
                    _: 1
                  })
                ]),
                _: 1
              })) : (T(), O(v(el), { key: 1 }, {
                message: k(() => [
                  w(W)
                ]),
                _: 1
              }))
            ]),
            _: 1
          }, 8, ["data", "columns", "selected"]),
          w(ne, {
            limit: v(h),
            "onUpdate:limit": L[3] || (L[3] = (V) => Xe(h) ? h.value = V : null),
            page: v(l),
            "onUpdate:page": L[4] || (L[4] = (V) => Xe(l) ? l.value = V : null),
            pages: v(b)
          }, null, 8, ["limit", "page", "pages"])
        ]),
        _: 1
      });
    };
  }
}), V0 = /* @__PURE__ */ U({
  __name: "BlockIconText",
  props: {
    blockDocumentId: {}
  },
  setup(t) {
    const e = t, n = Se(), r = je(), o = mt(n.blockDocuments.getBlockDocument, [e.blockDocumentId]), s = D(() => o.response?.name);
    return (i, u) => {
      const l = P("p-icon-text"), a = P("p-link");
      return T(), O(a, {
        to: v(r).block(i.blockDocumentId),
        class: "block-icon-text"
      }, {
        default: k(() => [
          w(l, { icon: "CubeIcon" }, {
            default: k(() => [
              re("span", null, ie(s.value), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["to"]);
    };
  }
}), whe = /* @__PURE__ */ U({
  __name: "BlockSchemaCapabilities",
  props: {
    capabilities: {},
    wrapper: { type: Boolean }
  },
  setup(t) {
    const e = t, n = D(() => e.wrapper ? Fj : am), r = D(() => e.capabilities.slice().sort((o, s) => o.localeCompare(s)));
    return (o, s) => (T(), O(Mr(n.value), {
      class: "block-schema-capabilities",
      tags: r.value
    }, null, 8, ["tags"]));
  }
}), bhe = /* @__PURE__ */ U({
  __name: "BlockSchemaCapabilitySelect",
  props: {
    selected: {},
    allowUnset: { type: Boolean }
  },
  emits: ["update:selected"],
  setup(t, { emit: e }) {
    const n = t, r = e, o = D({
      get() {
        return n.selected ?? null;
      },
      set(c) {
        r("update:selected", c);
      }
    }), s = Se(), i = mt(s.blockCapabilities.getBlockCapabilities), u = D(() => i.response ?? []), l = D(() => u.value.slice().sort((c, p) => c.localeCompare(p))), a = D(() => {
      const c = l.value.map((p) => ({
        value: p,
        label: p
      }));
      return n.allowUnset && c.unshift({
        value: null,
        label: "None"
      }), c;
    });
    return (c, p) => {
      const d = P("p-combobox");
      return T(), O(d, {
        modelValue: o.value,
        "onUpdate:modelValue": p[0] || (p[0] = (h) => o.value = h),
        options: a.value,
        "empty-message": "Block capability",
        class: "block-schema-capability-combobox"
      }, {
        default: k(({ label: h }) => [
          q(" Capability: " + ie(h), 1)
        ]),
        _: 1
      }, 8, ["modelValue", "options"]);
    };
  }
}), khe = /* @__PURE__ */ U({
  __name: "BlockSchemaEditForm",
  props: {
    blockSchema: {},
    data: {},
    name: {}
  },
  emits: ["submit", "cancel"],
  setup(t, { emit: e }) {
    const n = t, r = e, { handleSubmit: o } = Mc({
      initialValues: {
        data: n.data,
        blockSchema: n.blockSchema
      }
    }), s = o((u) => r("submit", u)), i = () => r("cancel");
    return (u, l) => {
      const a = P("p-text-input"), c = P("p-label"), p = P("p-content"), d = P("p-button"), h = P("p-form");
      return T(), O(h, {
        class: "block-schema-edit-form",
        onSubmit: v(s)
      }, {
        footer: k(() => [
          w(d, { onClick: i }, {
            default: k(() => [...l[0] || (l[0] = [
              q(" Cancel ", -1)
            ])]),
            _: 1
          }),
          w(Pc)
        ]),
        default: k(() => [
          w(p, null, {
            default: k(() => [
              w(c, {
                label: "Block Name",
                description: "Block names are not editable"
              }, {
                default: k(() => [
                  w(a, {
                    "model-value": u.name,
                    disabled: ""
                  }, null, 8, ["model-value"])
                ]),
                _: 1
              }),
              w(ed, {
                schema: u.blockSchema.fields,
                property: "data"
              }, null, 8, ["schema"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["onSubmit"]);
    };
  }
}), The = /* @__PURE__ */ U({
  __name: "BlocksPageEmptyState",
  setup(t) {
    const e = Ke(), n = je();
    return (r, o) => (T(), O(v(na), { class: "blocks-page-empty-state" }, {
      icon: k(() => [
        w(v(vo), { icon: "CubeIcon" })
      ]),
      heading: k(() => [...o[0] || (o[0] = [
        q(" Add a block to get started ", -1)
      ])]),
      description: k(() => [...o[1] || (o[1] = [
        q(" Blocks securely store credentials and configuration to easily manage connections to external systems. ", -1)
      ])]),
      actions: k(() => [
        v(e).create.block ? (T(), O(v(Zo), {
          key: 0,
          "icon-append": "PlusIcon",
          to: v(n).blocksCatalog(),
          primary: ""
        }, {
          default: k(() => [...o[2] || (o[2] = [
            q(" Add Block ", -1)
          ])]),
          _: 1
        }, 8, ["to"])) : j("", !0),
        w(Os, {
          to: v(le).docs.blocks
        }, null, 8, ["to"])
      ]),
      _: 1
    }));
  }
}), xhe = { class: "block-type-card__actions" }, She = /* @__PURE__ */ U({
  __name: "BlockTypeCard",
  props: {
    blockType: {}
  },
  setup(t) {
    const e = t, n = je(), r = D(() => {
      let o = e.blockType.description;
      return e.blockType.documentationUrl && (o += ` [Documentation](${e.blockType.documentationUrl})`), o;
    });
    return (o, s) => {
      const i = P("p-icon"), u = P("p-heading"), l = P("p-markdown-renderer"), a = P("p-content"), c = P("p-button"), p = P("p-link"), d = P("p-card");
      return T(), O(d, { class: "block-type-card" }, {
        header: k(() => [
          o.blockType.logoUrl ? (T(), O(fu, {
            key: 0,
            url: o.blockType.logoUrl,
            class: "block-type-card__logo",
            size: "lg"
          }, null, 8, ["url"])) : (T(), O(i, {
            key: 1,
            icon: "PBlock",
            class: "block-type-card__icon"
          })),
          w(u, {
            class: "block-type-card-preview__name",
            heading: "3"
          }, {
            default: k(() => [
              q(ie(o.blockType.name), 1)
            ]),
            _: 1
          })
        ]),
        footer: k(() => [
          re("div", xhe, [
            w(p, {
              to: v(n).blockCreate(o.blockType.slug),
              class: "block-type-card__action"
            }, {
              default: k(() => [
                w(c, {
                  variant: "default",
                  class: "block-type-card__button"
                }, {
                  default: k(() => [...s[1] || (s[1] = [
                    q(" Create ", -1)
                  ])]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["to"])
          ])
        ]),
        default: k(() => [
          w(a, null, {
            default: k(() => [
              r.value ? (T(), O(l, {
                key: 0,
                text: r.value,
                class: "block-type-card__description"
              }, null, 8, ["text"])) : j("", !0),
              o.blockType.codeExample ? (T(), z(ve, { key: 1 }, [
                w(u, {
                  class: "block-type-card-preview__name",
                  heading: "5"
                }, {
                  default: k(() => [...s[0] || (s[0] = [
                    q(" Example ", -1)
                  ])]),
                  _: 1
                }),
                w(U2, {
                  snippet: o.blockType.codeExample
                }, null, 8, ["snippet"])
              ], 64)) : j("", !0)
            ]),
            _: 1
          })
        ]),
        _: 1
      });
    };
  }
}), Rhe = { class: "code-banner p-background" }, Ahe = {
  key: 0,
  class: "code-banner__message"
}, Dhe = {
  key: 0,
  class: "code-banner__message-title"
}, Ehe = {
  key: 1,
  class: "code-banner__message-subtitle"
}, Mhe = /* @__PURE__ */ U({
  __name: "CodeBanner",
  props: {
    title: {},
    subtitle: {},
    command: {}
  },
  setup(t) {
    const e = DI();
    return (n, r) => {
      const o = P("p-terminal");
      return T(), z("div", Rhe, [
        n.title || v(e).title || n.subtitle || v(e).subtitle ? (T(), z("div", Ahe, [
          n.title || v(e).title ? (T(), z("div", Dhe, [
            Ve(n.$slots, "title", {}, () => [
              q(ie(n.title), 1)
            ])
          ])) : j("", !0),
          n.subtitle || v(e).subtitle ? (T(), z("div", Ehe, [
            Ve(n.$slots, "subtitle", {}, () => [
              q(ie(n.subtitle), 1)
            ])
          ])) : j("", !0)
        ])) : j("", !0),
        w(o, {
          command: n.command,
          class: "code-banner__terminal"
        }, null, 8, ["command"])
      ]);
    };
  }
}), Phe = { class: "collection-card-preview__type-tag" }, Che = { class: "collection-card-preview__name" }, Ohe = { class: "collection-card-preview__description" }, T4 = /* @__PURE__ */ U({
  __name: "CollectionCardPreview",
  props: {
    collectionItem: {}
  },
  setup(t) {
    const e = je();
    return (n, r) => {
      const o = P("p-tag"), s = P("p-link"), i = P("p-card");
      return T(), O(i, { class: "collection-card-preview" }, {
        default: k(() => [
          w(fu, {
            url: n.collectionItem.logoUrl,
            size: "lg",
            class: "collection-card-preview__logo"
          }, null, 8, ["url"]),
          re("div", Phe, [
            w(o, {
              label: n.collectionItem.collectionType
            }, null, 8, ["label"])
          ]),
          re("p", Che, [
            w(s, {
              to: v(e).flowCollection(n.collectionItem.name)
            }, {
              default: k(() => [
                q(ie(n.collectionItem.name), 1)
              ]),
              _: 1
            }, 8, ["to"])
          ]),
          re("p", Ohe, ie(n.collectionItem.description), 1)
        ]),
        _: 1
      });
    };
  }
}), Ihe = { class: "collection-card__actions" }, Fhe = ["href"], Nhe = /* @__PURE__ */ U({
  __name: "CollectionItemCard",
  props: {
    collectionItem: {}
  },
  setup(t) {
    return (e, n) => {
      const r = P("p-key-value"), o = P("p-markdown-renderer"), s = P("p-button"), i = P("p-content"), u = P("p-card");
      return T(), O(u, { class: "collection-card" }, {
        default: k(() => [
          e.collectionItem ? (T(), O(i, { key: 0 }, {
            default: k(() => [
              w(fu, {
                url: e.collectionItem.logoUrl,
                class: "collection-card__logo"
              }, null, 8, ["url"]),
              w(r, {
                label: "Name",
                value: e.collectionItem.name
              }, null, 8, ["value"]),
              w(r, {
                label: "Slug",
                value: e.collectionItem.slug
              }, null, 8, ["value"]),
              e.collectionItem.description ? (T(), O(r, {
                key: 0,
                label: "Description",
                value: e.collectionItem.description
              }, null, 8, ["value"])) : j("", !0),
              (T(!0), z(ve, null, ln(e.collectionItem.examples, (l, a) => (T(), O(r, {
                key: a,
                label: "Example",
                class: "collection-card__example"
              }, {
                value: k(() => [
                  w(o, { text: l }, null, 8, ["text"])
                ]),
                _: 2
              }, 1024))), 128)),
              re("div", Ihe, [
                e.collectionItem.documentationUrl ? (T(), z("a", {
                  key: 0,
                  href: e.collectionItem.documentationUrl,
                  target: "_blank"
                }, [
                  w(s, { "icon-append": "ArrowTopRightOnSquareIcon" }, {
                    default: k(() => [
                      Ve(e.$slots, "default", {}, () => [
                        n[0] || (n[0] = q(" View Docs ", -1))
                      ])
                    ]),
                    _: 3
                  })
                ], 8, Fhe)) : j("", !0)
              ])
            ]),
            _: 3
          })) : j("", !0)
        ]),
        _: 3
      });
    };
  }
}), Lhe = { class: "collections-list" }, Bhe = { class: "collections-list__filters" }, Uhe = { class: "collections-list__types" }, Xhe = /* @__PURE__ */ U({
  __name: "CollectionsList",
  setup(t) {
    const e = ge(""), n = Se(), r = mt(n.collections.getFlowCollection, []), o = D(() => r.response ?? []), s = D(() => o.value.filter(l)), i = D(() => !!e.value), u = D(() => r.executed && o.value.length === 0);
    function l({ name: c, category: p, slug: d }) {
      return `${c}.${p ?? ""}.${d}`.toLowerCase().includes(e.value.toLowerCase());
    }
    function a() {
      e.value = "";
    }
    return (c, p) => {
      const d = P("p-button"), h = P("p-empty-results");
      return T(), z("div", Lhe, [
        re("div", Bhe, [
          w(Uo, {
            label: "Flow",
            count: s.value.length,
            class: "collections-list__results"
          }, null, 8, ["count"]),
          w(Wo, {
            modelValue: e.value,
            "onUpdate:modelValue": p[0] || (p[0] = (m) => e.value = m),
            class: "collections-list__search",
            placeholder: "Search collections"
          }, null, 8, ["modelValue"])
        ]),
        re("div", Uhe, [
          (T(!0), z(ve, null, ln(s.value, (m) => (T(), O(T4, {
            key: m.name,
            "collection-item": m
          }, null, 8, ["collection-item"]))), 128))
        ]),
        u.value ? (T(), O(h, { key: 0 }, Ut({
          message: k(() => [
            p[1] || (p[1] = q(" No collections ", -1))
          ]),
          _: 2
        }, [
          i.value ? {
            name: "actions",
            fn: k(() => [
              w(d, {
                size: "sm",
                onClick: a
              }, {
                default: k(() => [...p[2] || (p[2] = [
                  q(" Clear Filters ", -1)
                ])]),
                _: 1
              })
            ]),
            key: "0"
          } : void 0
        ]), 1024)) : j("", !0)
      ]);
    };
  }
}), $he = { class: "color-mode-select-option__label" }, Whe = { class: "color-mode-select-option__states" }, Nk = /* @__PURE__ */ U({
  __name: "ColorModeSelectOption",
  props: {
    mode: {}
  },
  setup(t) {
    const e = t, n = D(() => kk(e.mode));
    function r(o) {
      return `color-mode-select-option__state--${o}`;
    }
    return (o, s) => (T(), z("div", {
      class: Bt(["color-mode-select-option", n.value])
    }, [
      re("div", $he, ie(o.mode ?? "default"), 1),
      re("div", Whe, [
        (T(!0), z(ve, null, ln(v(oh), (i) => (T(), z("span", {
          key: i,
          class: Bt(["color-mode-select-option__state", r(i)])
        }, null, 2))), 128))
      ])
    ], 2));
  }
}), Vhe = /* @__PURE__ */ U({
  __name: "ColorModeSelect",
  props: {
    selected: {}
  },
  emits: ["update:selected"],
  setup(t, { emit: e }) {
    const n = t, r = e, o = [{ label: "default", value: null }, ...s2.map((i) => ({ label: i, value: i }))], s = D({
      get() {
        return EE(n.selected) ? n.selected : null;
      },
      set(i) {
        i ? r("update:selected", i) : r("update:selected", null);
      }
    });
    return (i, u) => (T(), O(v(Om), {
      modelValue: s.value,
      "onUpdate:modelValue": u[0] || (u[0] = (l) => s.value = l),
      options: o,
      class: "color-mode-select"
    }, {
      option: k(({ option: l }) => [
        w(Nk, {
          mode: l.value
        }, null, 8, ["mode"])
      ]),
      default: k(({ value: l }) => [
        v(EE)(l) || l === null ? (T(), O(Nk, {
          key: 0,
          mode: l
        }, null, 8, ["mode"])) : j("", !0)
      ]),
      _: 1
    }, 8, ["modelValue"]));
  }
}), Hhe = { key: 1 }, jhe = { key: 1 }, $h = /* @__PURE__ */ U({
  __name: "DeploymentIconText",
  props: {
    deploymentId: {}
  },
  setup(t) {
    const e = t, n = je(), r = D(() => e.deploymentId), { deployment: o, subscription: s } = Zm(r), i = D(() => o.value?.name);
    return (u, l) => {
      const a = P("p-icon-text"), c = P("p-link");
      return v(o)?.can.read ? (T(), z(ve, { key: 0 }, [
        v(o) ? (T(), O(c, {
          key: 0,
          to: v(n).deployment(r.value),
          class: "deployment-icon-text"
        }, {
          default: k(() => [
            w(a, { icon: "PDeployment" }, {
              default: k(() => [
                re("span", null, ie(i.value), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["to"])) : v(s).executed ? (T(), z("span", Hhe, " Deployment not found ")) : j("", !0)
      ], 64)) : (T(), z("span", jhe, " No access "));
    };
  }
}), zhe = {
  key: 0,
  class: "flow-run-deployment"
}, R_ = /* @__PURE__ */ U({
  __name: "FlowRunDeployment",
  props: {
    deploymentId: {}
  },
  setup(t) {
    const e = t, { deployment: n } = Zm(() => e.deploymentId);
    return (r, o) => v(n)?.name ? (T(), z("div", zhe, [
      o[0] || (o[0] = re("span", null, "Deployment", -1)),
      o[1] || (o[1] = q()),
      w($h, { "deployment-id": r.deploymentId }, null, 8, ["deployment-id"])
    ])) : j("", !0);
  }
}), qhe = { key: 1 }, Ghe = { key: 1 }, Wh = /* @__PURE__ */ U({
  __name: "WorkPoolIconText",
  props: {
    workPoolName: {}
  },
  setup(t) {
    const e = t, n = je(), { workPool: r, subscription: o } = Jm(() => e.workPoolName);
    return (s, i) => {
      const u = P("p-icon-text"), l = P("p-link");
      return v(r)?.can.read ? (T(), z(ve, { key: 0 }, [
        v(r) ? (T(), O(l, {
          key: 0,
          to: v(n).workPool(s.workPoolName),
          class: "work-pool-icon-text"
        }, {
          default: k(() => [
            w(u, { icon: "PWorkPool" }, {
              default: k(() => [
                re("span", null, ie(s.workPoolName), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["to"])) : v(o).executed ? (T(), z("span", qhe, " Work pool not found ")) : j("", !0)
      ], 64)) : (T(), z("span", Ghe, " No access "));
    };
  }
}), Yhe = { class: "flow-run-work-pool" }, ny = /* @__PURE__ */ U({
  __name: "FlowRunWorkPool",
  props: {
    workPoolName: {}
  },
  setup(t) {
    return (e, n) => (T(), z("div", Yhe, [
      n[0] || (n[0] = re("span", null, "Work Pool", -1)),
      n[1] || (n[1] = q()),
      w(Wh, { "work-pool-name": e.workPoolName }, null, 8, ["work-pool-name"])
    ]));
  }
}), A_ = /* @__PURE__ */ U({
  __name: "StatusIcon",
  props: {
    status: {}
  },
  setup(t) {
    return (e, n) => (T(), z("div", {
      class: Bt(["status-icon", `status-icon--${e.status}`])
    }, null, 2));
  }
}), Qhe = {
  type: "button",
  class: "work-pool-queue-status-icon"
}, D_ = /* @__PURE__ */ U({
  __name: "WorkPoolQueueStatusIcon",
  props: {
    workPoolQueue: {}
  },
  setup(t) {
    const e = t, { workPool: n } = Jm(() => e.workPoolQueue.workPoolName), r = D(() => {
      switch (e.workPoolQueue.status) {
        case "paused":
          return { state: "paused", icon: "PauseCircleIcon", tooltip: "Work queue is paused. No work will be executed." };
        case "ready":
          return n.value?.isPushPool ? { state: "ready", icon: "CheckCircleIcon", tooltip: "Work queue is ready." } : { state: "ready", icon: "CheckCircleIcon", tooltip: "Work queue has at least one actively polling worker ready to execute work." };
        case "not_ready":
          return { state: "not_ready", icon: "ExclamationCircleIcon", tooltip: "Work queue does not have any actively polling workers ready to execute work." };
        default:
          const s = e.workPoolQueue.status;
          throw new Error(`Unhandled work pool queue status: ${s}`);
      }
    }), o = D(() => `work-pool-queue-status-icon--${r.value.state}`);
    return (s, i) => {
      const u = P("p-icon"), l = P("p-tooltip");
      return T(), O(l, {
        text: r.value.tooltip
      }, {
        default: k(() => [
          re("button", Qhe, [
            r.value.state === "ready" ? (T(), O(A_, {
              key: 0,
              status: "ready"
            })) : j("", !0),
            r.value.state !== "ready" ? (T(), O(u, {
              key: 1,
              icon: r.value.icon,
              size: "small",
              class: Bt(o.value)
            }, null, 8, ["icon", "class"])) : j("", !0)
          ])
        ]),
        _: 1
      }, 8, ["text"]);
    };
  }
}), Khe = { class: "flow-run-work-queue" }, ry = /* @__PURE__ */ U({
  __name: "FlowRunWorkQueue",
  props: {
    workQueueName: {},
    workPoolName: {},
    flowRunState: {}
  },
  setup(t) {
    const e = t, n = D(() => e.flowRunState && fi(e.flowRunState)), { workPoolName: r } = Nn(e), o = Se(), s = D(() => e.workPoolName ? [e.workPoolName, e.workQueueName] : null), i = Xa(), u = xt(o.workPoolQueues.getWorkPoolQueueByName, s, i), l = D(() => u.response);
    return (a, c) => (T(), z("div", Khe, [
      c[0] || (c[0] = re("span", null, "Work Queue", -1)),
      w(v(lw), {
        "work-queue-name": a.workQueueName,
        "work-pool-name": v(r)
      }, null, 8, ["work-queue-name", "work-pool-name"]),
      !n.value && v(r) ? (T(), z(ve, { key: 0 }, [
        l.value ? (T(), O(D_, {
          key: 0,
          "work-pool-queue": l.value
        }, null, 8, ["work-pool-queue"])) : j("", !0)
      ], 64)) : j("", !0)
    ]));
  }
}), $2 = /* @__PURE__ */ U({
  __name: "StateIcon",
  props: {
    stateType: {},
    shade: { default: 500 }
  },
  setup(t) {
    const e = t, n = D(() => e.stateType === "paused" ? "Pending" : e.stateType === "cancelling" ? "Cancelled" : yi(e.stateType ?? "QuestionMarkCircleIcon")), r = D(() => `text-state-${e.stateType}-${e.shade}`);
    return (o, s) => (T(), O(v(vo), {
      icon: n.value,
      class: Bt(r.value)
    }, null, 8, ["icon", "class"]));
  }
}), Dr = /* @__PURE__ */ U({
  __name: "StateBadge",
  props: {
    state: {},
    flat: { type: Boolean },
    dismissible: { type: Boolean },
    small: { type: Boolean }
  },
  setup(t) {
    const e = t, n = D(() => e.state?.type ?? uh(e.state?.name).type), r = D(() => e.state && !n.value), o = D(() => e.state?.name ?? "Unknown"), s = D(() => ({
      root: [
        `state--${n.value}`,
        {
          "state-badge--flat": e.flat
        }
      ],
      icon: {
        "state-badge__icon--small": e.small
      }
    })), i = D(() => e.flat ? 500 : 700);
    return (u, l) => {
      const a = P("p-tag");
      return T(), O(a, {
        class: Bt(["state-badge", s.value.root]),
        dismissible: u.dismissible,
        small: u.small
      }, {
        default: k(() => [
          r.value ? j("", !0) : (T(), O($2, {
            key: 0,
            "state-type": n.value,
            shade: i.value,
            class: Bt(["state-badge__icon", s.value.icon])
          }, null, 8, ["state-type", "shade", "class"])),
          re("span", null, ie(o.value), 1)
        ]),
        _: 1
      }, 8, ["class", "dismissible", "small"]);
    };
  }
}), Zhe = { class: "state-list-item__content-container" }, Jhe = { class: "state-list-item__content" }, efe = { class: "state-list-item__top-section" }, tfe = { class: "state-list-item__name" }, nfe = { class: "state-list-item__tags" }, rfe = {
  key: 0,
  class: "state-list-item__action"
}, ofe = {
  key: 0,
  class: "state-list-item__meta"
}, sfe = {
  key: 1,
  class: "state-list-item__relationships"
}, W2 = /* @__PURE__ */ U({
  __name: "StateListItem",
  props: {
    selectable: { type: Boolean },
    selected: { type: [Boolean, Array, null] },
    value: {},
    stateType: {},
    tags: {}
  },
  emits: ["update:selected"],
  setup(t, { emit: e }) {
    const n = t, r = D(() => n.selectable ? Nj : Lj), o = e, s = D({
      get() {
        return n.selected ?? void 0;
      },
      set(a) {
        o("update:selected", a);
      }
    }), i = D(() => `state-list-item--${n.stateType ?? "unknown"}`), u = D(() => _s.md ? "right" : "left"), l = D(() => n.tags ?? []);
    return (a, c) => {
      const p = P("p-tag-wrapper");
      return T(), O(Mr(r.value), {
        selected: s.value,
        "onUpdate:selected": c[0] || (c[0] = (d) => s.value = d),
        value: a.value,
        class: Bt(["state-list-item", i.value])
      }, {
        default: k(() => [
          re("div", Zhe, [
            re("div", Jhe, [
              re("div", efe, [
                re("div", tfe, [
                  Ve(a.$slots, "name")
                ]),
                re("div", nfe, [
                  Ve(a.$slots, "tags", {}, () => [
                    w(p, sn(kn({ tags: l.value, justify: u.value })), null, 16)
                  ])
                ]),
                a.$slots.action ? (T(), z("div", rfe, [
                  Ve(a.$slots, "action")
                ])) : j("", !0)
              ]),
              a.$slots.meta ? (T(), z("div", ofe, [
                Ve(a.$slots, "meta")
              ])) : j("", !0),
              a.$slots.relationships ? (T(), z("div", sfe, [
                Ve(a.$slots, "relationships")
              ])) : j("", !0)
            ])
          ]),
          Ve(a.$slots, "default")
        ]),
        _: 3
      }, 40, ["selected", "value", "class"]);
    };
  }
}), afe = { class: "task-run-list-item__breadcrumbs" }, x4 = /* @__PURE__ */ U({
  __name: "TaskRunListItem",
  props: {
    selectable: { type: Boolean },
    selected: { type: [Boolean, Array, null] },
    taskRun: {}
  },
  emits: ["update:selected"],
  setup(t, { emit: e }) {
    const n = t, r = e, o = D({
      get() {
        return n.selected ?? void 0;
      },
      set(A) {
        r("update:selected", A);
      }
    }), s = kc(), i = je(), u = D(() => n.taskRun.state?.type), l = D(() => n.taskRun.tags), a = D(() => n.taskRun.id), c = D(() => n.taskRun.startTime ?? n.taskRun.expectedStartTime), { flowRun: p } = yl(n.taskRun.flowRunId), d = D(() => s.name === i.flowRun("").name), h = D(() => n.taskRun.flowRunId && !d.value), { flow: m } = Ec(() => p.value?.flowId), g = D(() => n.taskRun.flowRunId && !d.value), _ = ge(!1), b = ge();
    function x(A) {
      A.forEach((C) => {
        C.isIntersecting && (_.value = !0, E());
      });
    }
    const { observe: S, disconnect: E } = XI(x);
    return wi(() => {
      S(b);
    }), (A, C) => {
      const M = P("p-link"), L = P("p-icon"), X = P("p-icon-text");
      return T(), z("div", {
        ref_key: "el",
        ref: b,
        class: "task-run-list-item"
      }, [
        w(W2, yt({
          selected: o.value,
          "onUpdate:selected": C[0] || (C[0] = (te) => o.value = te)
        }, { selectable: A.selectable, value: a.value, tags: l.value, stateType: u.value }), Ut({
          name: k(() => [
            re("div", afe, [
              g.value && v(m) ? (T(), z(ve, { key: 0 }, [
                w(M, {
                  class: "task-run-list-item__flow-name",
                  to: v(i).flow(v(m).id)
                }, {
                  default: k(() => [
                    q(ie(v(m).name), 1)
                  ]),
                  _: 1
                }, 8, ["to"]),
                w(L, {
                  icon: "ChevronRightIcon",
                  size: "small"
                })
              ], 64)) : j("", !0),
              h.value && v(p) ? (T(), z(ve, { key: 1 }, [
                w(M, {
                  to: v(i).flowRun(v(p).id)
                }, {
                  default: k(() => [
                    q(ie(v(p).name), 1)
                  ]),
                  _: 1
                }, 8, ["to"]),
                w(L, {
                  icon: "ChevronRightIcon",
                  size: "small"
                })
              ], 64)) : j("", !0),
              w(M, {
                to: v(i).taskRun(A.taskRun.id)
              }, {
                default: k(() => [
                  re("span", null, ie(A.taskRun.name), 1)
                ]),
                _: 1
              }, 8, ["to"])
            ])
          ]),
          meta: k(() => [
            w(Dr, {
              state: A.taskRun.state
            }, null, 8, ["state"]),
            w(X, { icon: "ClockIcon" }, {
              default: k(() => [
                q(ie(v(fc)(A.taskRun.duration)), 1)
              ]),
              _: 1
            }),
            c.value ? (T(), O(X, {
              key: 0,
              class: "flow-run-date-icon-text",
              icon: "CalendarIcon"
            }, {
              default: k(() => [
                w(hn, {
                  date: c.value,
                  format: "numeric"
                }, null, 8, ["date"])
              ]),
              _: 1
            })) : j("", !0)
          ]),
          _: 2
        }, [
          h.value && _.value ? {
            name: "relationships",
            fn: k(() => [
              v(p)?.deploymentId ? (T(), O(R_, {
                key: 0,
                "deployment-id": v(p).deploymentId
              }, null, 8, ["deployment-id"])) : j("", !0),
              v(p)?.workPoolName ? (T(), O(ny, {
                key: 1,
                "work-pool-name": v(p).workPoolName
              }, null, 8, ["work-pool-name"])) : j("", !0),
              v(p)?.workQueueName ? (T(), O(ry, {
                key: 2,
                "work-queue-name": v(p).workQueueName,
                "work-pool-name": v(p).workPoolName,
                "flow-run-state": v(p).stateType
              }, null, 8, ["work-queue-name", "work-pool-name", "flow-run-state"])) : j("", !0)
            ]),
            key: "0"
          } : void 0
        ]), 1040, ["selected"])
      ], 512);
    };
  }
}), V2 = /* @__PURE__ */ U({
  __name: "TaskRunList",
  props: {
    selectable: { type: Boolean },
    selected: {},
    taskRuns: {}
  },
  emits: ["update:selected"],
  setup(t, { emit: e }) {
    const n = t, r = e, o = D({
      get() {
        return n.selected ?? [];
      },
      set(s) {
        r("update:selected", s);
      }
    });
    return (s, i) => {
      const u = P("p-virtual-scroller");
      return T(), O(u, {
        items: s.taskRuns,
        class: "task-run-list"
      }, {
        default: k(({ item: l }) => [
          w(x4, yt({
            selected: o.value,
            "onUpdate:selected": i[0] || (i[0] = (a) => o.value = a)
          }, { taskRun: l, selectable: s.selectable }), null, 16, ["selected"])
        ]),
        _: 1
      }, 8, ["items"]);
    };
  }
}), ife = /* @__PURE__ */ U({
  __name: "ConcurrencyLimitActiveRuns",
  props: {
    activeSlots: {}
  },
  setup(t) {
    const e = t, n = D(() => e.activeSlots.length), r = D(() => ({
      taskRuns: {
        id: e.activeSlots
      }
    })), o = Se(), s = mt(o.taskRuns.getTaskRuns, [r]), i = D(() => s.response ?? []);
    return (u, l) => {
      const a = P("p-empty-results");
      return n.value ? (T(), O(V2, {
        key: 0,
        "task-runs": i.value
      }, null, 8, ["task-runs"])) : (T(), O(a, { key: 1 }, {
        message: k(() => [...l[0] || (l[0] = [
          q(" No active task runs ", -1)
        ])]),
        _: 1
      }));
    };
  }
}), ufe = { class: "concurrency-limit-details" }, lfe = /* @__PURE__ */ U({
  __name: "ConcurrencyLimitDetails",
  props: {
    concurrencyLimit: {},
    alternate: { type: Boolean }
  },
  setup(t) {
    return (e, n) => {
      const r = P("p-key-value"), o = P("p-divider");
      return T(), z("div", ufe, [
        w(r, {
          label: "Tag",
          value: e.concurrencyLimit.tag,
          alternate: e.alternate
        }, null, 8, ["value", "alternate"]),
        w(o),
        w(r, {
          label: "Concurrency Limit Count",
          value: e.concurrencyLimit.concurrencyLimit,
          alternate: e.alternate
        }, null, 8, ["value", "alternate"]),
        w(r, {
          label: "Concurrency Limit Active Task Runs Count",
          value: e.concurrencyLimit.activeSlots?.length,
          alternate: e.alternate
        }, null, 8, ["value", "alternate"]),
        w(r, {
          label: "Concurrency Limit ID",
          value: e.concurrencyLimit.id,
          alternate: e.alternate
        }, null, 8, ["value", "alternate"]),
        e.concurrencyLimit.created ? (T(), O(r, {
          key: 0,
          label: "Created",
          alternate: e.alternate
        }, {
          value: k(() => [
            w(hn, {
              date: e.concurrencyLimit.created,
              format: "numeric"
            }, null, 8, ["date"])
          ]),
          _: 1
        }, 8, ["alternate"])) : j("", !0),
        e.concurrencyLimit.updated ? (T(), O(r, {
          key: 1,
          label: "Updated",
          alternate: e.alternate
        }, {
          value: k(() => [
            w(hn, {
              date: e.concurrencyLimit.updated,
              format: "numeric"
            }, null, 8, ["date"])
          ]),
          _: 1
        }, 8, ["alternate"])) : j("", !0)
      ]);
    };
  }
}), H2 = /* @__PURE__ */ U({
  inheritAttrs: !1,
  __name: "ConcurrencyLimitMenu",
  props: {
    concurrencyLimit: {}
  },
  emits: ["delete"],
  setup(t, { emit: e }) {
    const n = e, r = Ke(), { showModal: o, open: s, close: i } = St(), { showModal: u, open: l } = St(), a = Se(), c = async (p) => {
      i(), await Ua(p, a.concurrencyLimits.deleteConcurrencyLimit, "Concurrency Limit"), n("delete", p);
    };
    return (p, d) => {
      const h = P("p-overflow-menu-item"), m = P("p-icon-button-menu");
      return T(), z(ve, null, [
        w(m, sn(kn(p.$attrs)), {
          default: k(() => [
            w(v(uo), {
              label: "Copy ID",
              item: p.concurrencyLimit.id
            }, null, 8, ["item"]),
            v(r).delete.concurrency_limit ? (T(), O(h, {
              key: 0,
              label: "Delete",
              onClick: v(s)
            }, null, 8, ["onClick"])) : j("", !0),
            v(r).update.concurrency_limit ? (T(), O(h, {
              key: 1,
              label: "Reset",
              onClick: v(l)
            }, null, 8, ["onClick"])) : j("", !0)
          ]),
          _: 1
        }, 16),
        w(v(_r), {
          showModal: v(o),
          "onUpdate:showModal": d[0] || (d[0] = (g) => Xe(o) ? o.value = g : null),
          name: p.concurrencyLimit.tag,
          label: "Concurrency Limit",
          onDelete: d[1] || (d[1] = (g) => c(p.concurrencyLimit.id))
        }, null, 8, ["showModal", "name"]),
        w(v(S4), {
          showModal: v(u),
          "onUpdate:showModal": d[2] || (d[2] = (g) => Xe(u) ? u.value = g : null),
          "concurrency-limit": p.concurrencyLimit
        }, null, 8, ["showModal", "concurrency-limit"])
      ], 64);
    };
  }
}), S4 = /* @__PURE__ */ U({
  __name: "ConcurrencyLimitResetModal",
  props: {
    showModal: { type: Boolean },
    concurrencyLimit: {}
  },
  emits: ["update:showModal"],
  setup(t, { emit: e }) {
    const n = t, r = e, o = D({
      get() {
        return n.showModal;
      },
      set(c) {
        r("update:showModal", c);
      }
    }), s = D(() => `Reset concurrency limit for tag ${n.concurrencyLimit.tag}?`), i = Se(), u = mt(i.concurrencyLimits.getConcurrencyLimit, [n.concurrencyLimit.id]), l = mt(i.concurrencyLimits.getConcurrencyLimits), a = async () => {
      try {
        await i.concurrencyLimits.resetConcurrencyLimitByTag(n.concurrencyLimit.tag), u.refresh(), l.refresh(), He(le.success.resetConcurrencyLimit, "success");
      } catch (c) {
        console.error(c);
        const p = Yt(c, le.error.resetConcurrencyLimit);
        He(p, "error");
      } finally {
        o.value = !1;
      }
    };
    return (c, p) => {
      const d = P("p-button"), h = P("p-modal");
      return T(), O(h, {
        showModal: o.value,
        "onUpdate:showModal": p[0] || (p[0] = (m) => o.value = m),
        class: "concurrency-limit-reset-modal",
        title: s.value
      }, {
        actions: k(() => [
          Ve(c.$slots, "actions", {}, () => [
            w(d, {
              variant: "default",
              onClick: a
            }, {
              default: k(() => [...p[1] || (p[1] = [
                q(" Reset ", -1)
              ])]),
              _: 1
            })
          ])
        ]),
        default: k(() => [
          p[2] || (p[2] = q(" This will reset the active task run count to 0. ", -1))
        ]),
        _: 3
      }, 8, ["showModal", "title"]);
    };
  }
}), j2 = /* @__PURE__ */ U({
  __name: "ConcurrencyLimitsCreateModal",
  props: {
    showModal: { type: Boolean }
  },
  emits: ["update:showModal"],
  setup(t, { emit: e }) {
    const n = t, r = e, { handleSubmit: o, resetForm: s, isSubmitting: i } = Mc(), u = {
      tag: Kr("Tag"),
      concurrencyLimit: qp("Limit", Kr, a2(0))
    }, { value: l, meta: a, errorMessage: c } = Rs("tag", u.tag), { value: p, meta: d, errorMessage: h } = Rs("concurrencyLimit", u.concurrencyLimit), m = D({
      get() {
        return n.showModal;
      },
      set(x) {
        r("update:showModal", x);
      }
    }), g = Se(), _ = mt(g.concurrencyLimits.getConcurrencyLimits), b = o(async (x) => {
      try {
        const { tag: S, concurrencyLimit: E } = x;
        await g.concurrencyLimits.createConcurrencyLimit({ tag: S, concurrencyLimit: E }), _.refresh(), He(le.success.createConcurrencyLimit, "success");
      } catch (S) {
        console.error(S);
        const E = Yt(S, le.error.createConcurrencyLimit);
        He(E, "error");
      } finally {
        s(), m.value = !1;
      }
    });
    return (x, S) => {
      const E = P("p-text-input"), A = P("p-content"), C = P("p-button"), M = P("p-modal");
      return T(), O(M, {
        showModal: m.value,
        "onUpdate:showModal": S[2] || (S[2] = (L) => m.value = L),
        class: "concurrency-limit-create-modal",
        title: "Add Task Run Concurrency Limit"
      }, {
        actions: k(() => [
          Ve(x.$slots, "actions", {}, () => [
            w(C, {
              variant: "default",
              loading: v(i),
              onClick: v(b)
            }, {
              default: k(() => [...S[3] || (S[3] = [
                q(" Add ", -1)
              ])]),
              _: 1
            }, 8, ["loading", "onClick"])
          ])
        ]),
        default: k(() => [
          w(v(Vv), {
            class: "concurrency-limit-create-form",
            onSubmit: v(b)
          }, {
            default: k(() => [
              w(A, null, {
                default: k(() => [
                  w(v(nr), {
                    label: "Tag",
                    message: v(c),
                    state: v(a)
                  }, {
                    default: k(() => [
                      w(E, {
                        modelValue: v(l),
                        "onUpdate:modelValue": S[0] || (S[0] = (L) => Xe(l) ? l.value = L : null),
                        state: v(a)
                      }, null, 8, ["modelValue", "state"])
                    ]),
                    _: 1
                  }, 8, ["message", "state"]),
                  w(v(nr), {
                    label: "Concurrency Limit",
                    message: v(h),
                    state: v(d)
                  }, {
                    default: k(() => [
                      w(v(Ca), {
                        modelValue: v(p),
                        "onUpdate:modelValue": S[1] || (S[1] = (L) => Xe(p) ? p.value = L : null),
                        min: 0,
                        state: v(d)
                      }, null, 8, ["modelValue", "state"])
                    ]),
                    _: 1
                  }, 8, ["message", "state"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["onSubmit"])
        ]),
        _: 3
      }, 8, ["showModal"]);
    };
  }
}), R4 = /* @__PURE__ */ U({
  __name: "ConcurrencyLimitsPageEmptyState",
  setup(t) {
    const { showModal: e, open: n } = St(), r = Ke();
    return (o, s) => (T(), O(v(na), { class: "concurrency-limit-page-empty-state" }, {
      icon: k(() => [
        w(v(vo), { icon: "Task" })
      ]),
      heading: k(() => [...s[1] || (s[1] = [
        q(" Add a concurrency limit for your task runs ", -1)
      ])]),
      description: k(() => [...s[2] || (s[2] = [
        q(" Creating a limit allows you to limit the number of tasks running simultaneously with a given tag. ", -1)
      ])]),
      actions: k(() => [
        v(r).create.concurrency_limit ? (T(), O(v(Zo), {
          key: 0,
          primary: "",
          "icon-append": "PlusIcon",
          onClick: v(n)
        }, {
          default: k(() => [...s[3] || (s[3] = [
            q(" Add Concurrency Limit ", -1)
          ])]),
          _: 1
        }, 8, ["onClick"])) : j("", !0),
        w(Os, {
          to: v(le).docs.concurrency
        }, null, 8, ["to"]),
        w(j2, {
          showModal: v(e),
          "onUpdate:showModal": s[0] || (s[0] = (i) => Xe(e) ? e.value = i : null)
        }, null, 8, ["showModal"])
      ]),
      _: 1
    }));
  }
}), cfe = /* @__PURE__ */ U({
  __name: "ConcurrencyLimitsTable",
  setup(t) {
    const e = Se(), n = [
      {
        property: "tag",
        label: "Tag"
      },
      {
        property: "concurrencyLimit",
        label: "Slots"
      },
      {
        property: "activeSlots",
        label: "Active Task Runs"
      },
      {
        label: "Action",
        width: "42px"
      }
    ], r = mt(e.concurrencyLimits.getConcurrencyLimits), o = D(() => r.response ?? []), s = D(() => r.executed && !o.value.length), i = D(() => r.executed), u = je();
    return (l, a) => {
      const c = P("p-link"), p = P("p-loading-icon"), d = P("p-table");
      return s.value && i.value ? (T(), O(v(R4), { key: 0 })) : (T(), O(d, {
        key: 1,
        class: "concurrency-limits-table__table",
        columns: n,
        data: o.value
      }, {
        tag: k(({ row: h }) => [
          w(c, {
            to: v(u).concurrencyLimit(h.id)
          }, {
            default: k(() => [
              q(ie(h.tag), 1)
            ]),
            _: 2
          }, 1032, ["to"])
        ]),
        "active-task-runs": k(({ row: h }) => [
          h.activeSlots ? (T(), O(v(I4), {
            key: 0,
            "active-slots": h.activeSlots
          }, null, 8, ["active-slots"])) : j("", !0)
        ]),
        "action-heading": k(() => [...a[1] || (a[1] = [
          re("span", null, null, -1)
        ])]),
        action: k(({ row: h }) => [
          w(v(H2), {
            size: "xs",
            "concurrency-limit": h,
            onDelete: a[0] || (a[0] = () => v(r).refresh())
          }, null, 8, ["concurrency-limit"])
        ]),
        "empty-state": k(() => [
          i.value ? (T(), O(v(el), { key: 0 }, {
            message: k(() => [...a[2] || (a[2] = [
              q(" No task concurrency limits ", -1)
            ])]),
            _: 1
          })) : (T(), O(v(el), { key: 1 }, {
            message: k(() => [
              w(p)
            ]),
            _: 1
          }))
        ]),
        _: 1
      }, 8, ["data"]));
    };
  }
}), H0 = (t, e) => Gt(t) || Tc(t) || Ps(t) || wp(t) ? `${e} is required` : !0, A4 = (t, e) => t == null || t > 0 ? !0 : `${e} must be greater than 0`, D4 = /* @__PURE__ */ U({
  __name: "ConcurrencyLimitsV2CreateModal",
  props: {
    showModal: { type: Boolean }
  },
  emits: ["update:showModal"],
  setup(t, { emit: e }) {
    const n = t, r = e, o = ge(""), { state: s, error: i } = bn(o, "Name", [H0]), u = ge(0), { state: l, error: a } = bn(u, "Limit", [
      H0,
      A4
    ]), c = ge(!0), p = ge(0), d = D({
      get() {
        return n.showModal;
      },
      set(E) {
        r("update:showModal", E);
      }
    }), h = Se(), m = mt(h.concurrencyV2Limits.getConcurrencyV2Limits), g = () => {
      o.value = "", u.value = 0, p.value = 0, c.value = !0;
    }, { valid: _, pending: b, validate: x } = Ms(), S = async () => {
      if (await x(), _.value)
        try {
          const E = {
            name: o.value,
            limit: u.value,
            slotDecayPerSecond: p.value,
            active: c.value
          };
          await h.concurrencyV2Limits.createConcurrencyV2Limit(E), m.refresh(), He(le.success.createConcurrencyLimit, "success");
        } catch (E) {
          console.error(E);
          const A = Yt(E, le.error.createConcurrencyLimit);
          He(A, "error");
        } finally {
          g(), d.value = !1;
        }
    };
    return (E, A) => {
      const C = P("p-text-input"), M = P("p-toggle"), L = P("p-content"), X = P("p-button"), te = P("p-modal");
      return T(), O(te, {
        showModal: d.value,
        "onUpdate:showModal": A[4] || (A[4] = (B) => d.value = B),
        class: "concurrency-limits-v2-create-modal",
        title: "Add Concurrency Limit"
      }, {
        actions: k(() => [
          Ve(E.$slots, "actions", {}, () => [
            w(X, {
              variant: "default",
              loading: v(b),
              onClick: S
            }, {
              default: k(() => [...A[5] || (A[5] = [
                q(" Create ", -1)
              ])]),
              _: 1
            }, 8, ["loading"])
          ])
        ]),
        default: k(() => [
          w(v(Vv), {
            class: "concurrency-limits-v2-create-form",
            onSubmit: S
          }, {
            default: k(() => [
              w(L, null, {
                default: k(() => [
                  w(v(nr), {
                    label: "Name",
                    message: v(i),
                    state: v(s)
                  }, {
                    default: k(() => [
                      w(C, {
                        modelValue: o.value,
                        "onUpdate:modelValue": A[0] || (A[0] = (B) => o.value = B),
                        state: v(s)
                      }, null, 8, ["modelValue", "state"])
                    ]),
                    _: 1
                  }, 8, ["message", "state"]),
                  w(v(nr), {
                    label: "Concurrency Limit",
                    message: v(a),
                    state: v(l)
                  }, {
                    default: k(() => [
                      w(v(Ca), {
                        modelValue: u.value,
                        "onUpdate:modelValue": A[1] || (A[1] = (B) => u.value = B),
                        min: 0,
                        state: v(l)
                      }, null, 8, ["modelValue", "state"])
                    ]),
                    _: 1
                  }, 8, ["message", "state"]),
                  w(v(nr), { label: "Slot Decay Per Second" }, {
                    default: k(() => [
                      w(v(Ca), {
                        modelValue: p.value,
                        "onUpdate:modelValue": A[2] || (A[2] = (B) => p.value = B),
                        min: 0
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  w(v(nr), { label: "Active" }, {
                    default: k(() => [
                      w(M, {
                        modelValue: c.value,
                        "onUpdate:modelValue": A[3] || (A[3] = (B) => c.value = B)
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 3
      }, 8, ["showModal"]);
    };
  }
}), E4 = /* @__PURE__ */ U({
  __name: "ConcurrencyLimitsV2EmptyState",
  setup(t) {
    const { showModal: e, open: n } = St(), r = Ke();
    return (o, s) => (T(), O(v(na), { class: "concurrency-limit-page-empty-state" }, {
      icon: k(() => [
        w(v(vo), { icon: "QueueListIcon" })
      ]),
      heading: k(() => [...s[1] || (s[1] = [
        q(" Add a concurrency limit ", -1)
      ])]),
      description: k(() => [...s[2] || (s[2] = [
        q(" Global concurrency limits can be applied to flow runs, task runs and any operation where you want to control concurrency. ", -1)
      ])]),
      actions: k(() => [
        v(r).create.concurrency_limit ? (T(), O(v(Zo), {
          key: 0,
          primary: "",
          "icon-append": "PlusIcon",
          onClick: v(n)
        }, {
          default: k(() => [...s[3] || (s[3] = [
            q(" Add Concurrency Limit ", -1)
          ])]),
          _: 1
        }, 8, ["onClick"])) : j("", !0),
        w(Os, {
          to: v(le).docs.globalConcurrency
        }, null, 8, ["to"]),
        w(D4, {
          showModal: v(e),
          "onUpdate:showModal": s[0] || (s[0] = (i) => Xe(e) ? e.value = i : null)
        }, null, 8, ["showModal"])
      ]),
      _: 1
    }));
  }
}), pfe = /* @__PURE__ */ U({
  __name: "ConcurrencyLimitsV2Table",
  setup(t) {
    const e = Se(), n = [
      {
        property: "name",
        label: "Name"
      },
      {
        property: "limit",
        label: "Limit"
      },
      {
        property: "activeSlots",
        label: "Active Slots"
      },
      {
        property: "slotDecayPerSecond",
        label: "Slot Decay per Second"
      },
      {
        property: "active",
        label: "Active"
      },
      {
        label: "Action",
        width: "42px"
      }
    ], r = mt(e.concurrencyV2Limits.getConcurrencyV2Limits), o = D(() => r.response ?? []), s = D(() => r.executed && !o.value.length), i = D(() => r.executed), u = je();
    return (l, a) => {
      const c = P("p-link"), p = P("p-empty-results"), d = P("p-loading-icon"), h = P("p-table");
      return s.value && i.value ? (T(), O(v(E4), { key: 0 })) : (T(), O(h, {
        key: 1,
        class: "concurrency-limits-v2-table",
        columns: n,
        data: o.value
      }, {
        tag: k(({ row: m }) => [
          w(c, {
            to: v(u).concurrencyLimit(m.id)
          }, {
            default: k(() => [
              q(ie(m.name), 1)
            ]),
            _: 2
          }, 1032, ["to"])
        ]),
        "active-slots": k(({ row: m }) => [
          q(ie(m.activeSlots), 1)
        ]),
        active: k(({ row: m }) => [
          w(v(O4), { limit: m }, null, 8, ["limit"])
        ]),
        "action-heading": k(() => [...a[1] || (a[1] = [
          re("span", null, null, -1)
        ])]),
        action: k(({ row: m }) => [
          w(v(P4), {
            size: "xs",
            "concurrency-limit": m,
            onDelete: a[0] || (a[0] = () => v(r).refresh())
          }, null, 8, ["concurrency-limit"])
        ]),
        "empty-state": k(() => [
          i.value ? (T(), O(p, { key: 0 }, {
            message: k(() => [...a[2] || (a[2] = [
              q(" No concurrency limits ", -1)
            ])]),
            _: 1
          })) : (T(), O(p, { key: 1 }, {
            message: k(() => [
              w(d)
            ]),
            _: 1
          }))
        ]),
        _: 1
      }, 8, ["data"]));
    };
  }
}), M4 = /* @__PURE__ */ U({
  __name: "ConcurrencyLimitsV2UpdateModal",
  props: /* @__PURE__ */ Br({
    concurrencyLimit: {}
  }, {
    showModal: { type: Boolean, required: !0 },
    showModalModifiers: {}
  }),
  emits: ["update:showModal"],
  setup(t) {
    const e = t, n = zn(t, "showModal"), r = D(() => `Update ${e.concurrencyLimit.name}`), o = ge(e.concurrencyLimit.name), { state: s, error: i } = bn(o, "Name", [H0]), u = ge(e.concurrencyLimit.limit), { state: l, error: a } = bn(u, "Limit", [
      H0,
      A4
    ]), c = ge(e.concurrencyLimit.active ?? !0), p = ge(e.concurrencyLimit.activeSlots ?? 0), d = ge(e.concurrencyLimit.slotDecayPerSecond ?? 0), h = Se(), m = mt(h.concurrencyV2Limits.getConcurrencyV2Limits);
    Ct(() => e.concurrencyLimit, () => {
      o.value = e.concurrencyLimit.name, u.value = e.concurrencyLimit.limit, c.value = e.concurrencyLimit.active ?? !0, p.value = e.concurrencyLimit.activeSlots ?? 0, d.value = e.concurrencyLimit.slotDecayPerSecond ?? 0;
    });
    const { valid: _, pending: b, validate: x } = Ms(), S = async () => {
      if (await x(), _.value)
        try {
          const E = {
            name: o.value,
            limit: u.value,
            active: c.value,
            activeSlots: p.value,
            slotDecayPerSecond: d.value
          };
          await h.concurrencyV2Limits.updateConcurrencyV2Limit(e.concurrencyLimit.id, E), m.refresh(), He(le.success.updateConcurrencyLimit, "success");
        } catch (E) {
          console.error(E);
          const A = Yt(E, le.error.updateConcurrencyLimit);
          He(A, "error");
        } finally {
          n.value = !1;
        }
    };
    return (E, A) => {
      const C = P("p-text-input"), M = P("p-toggle"), L = P("p-content"), X = P("p-button"), te = P("p-modal");
      return T(), O(te, {
        showModal: n.value,
        "onUpdate:showModal": A[5] || (A[5] = (B) => n.value = B),
        class: "concurrency-limits-v2-update-modal",
        title: r.value
      }, {
        actions: k(() => [
          Ve(E.$slots, "actions", {}, () => [
            w(X, {
              variant: "default",
              loading: v(b),
              onClick: S
            }, {
              default: k(() => [...A[6] || (A[6] = [
                q(" Update ", -1)
              ])]),
              _: 1
            }, 8, ["loading"])
          ])
        ]),
        default: k(() => [
          w(v(Vv), {
            class: "concurrency-limits-v2-update-form",
            onSubmit: S
          }, {
            default: k(() => [
              w(L, null, {
                default: k(() => [
                  w(v(nr), {
                    label: "Name",
                    message: v(i),
                    state: v(s)
                  }, {
                    default: k(() => [
                      w(C, {
                        modelValue: o.value,
                        "onUpdate:modelValue": A[0] || (A[0] = (B) => o.value = B),
                        state: v(s)
                      }, null, 8, ["modelValue", "state"])
                    ]),
                    _: 1
                  }, 8, ["message", "state"]),
                  w(v(nr), {
                    label: "Concurrency Limit",
                    message: v(a),
                    state: v(l)
                  }, {
                    default: k(() => [
                      w(v(Ca), {
                        modelValue: u.value,
                        "onUpdate:modelValue": A[1] || (A[1] = (B) => u.value = B),
                        min: 0,
                        state: v(l)
                      }, null, 8, ["modelValue", "state"])
                    ]),
                    _: 1
                  }, 8, ["message", "state"]),
                  w(v(nr), { label: "Slot Decay Per Second" }, {
                    default: k(() => [
                      w(v(Ca), {
                        modelValue: d.value,
                        "onUpdate:modelValue": A[2] || (A[2] = (B) => d.value = B),
                        min: 0
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  w(v(nr), { label: "Active Slots" }, {
                    default: k(() => [
                      w(v(Ca), {
                        modelValue: p.value,
                        "onUpdate:modelValue": A[3] || (A[3] = (B) => p.value = B),
                        min: 0
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  w(v(nr), { label: "Active" }, {
                    default: k(() => [
                      w(M, {
                        modelValue: c.value,
                        "onUpdate:modelValue": A[4] || (A[4] = (B) => c.value = B)
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 3
      }, 8, ["showModal", "title"]);
    };
  }
}), P4 = /* @__PURE__ */ U({
  inheritAttrs: !1,
  __name: "ConcurrencyLimitV2Menu",
  props: {
    concurrencyLimit: {}
  },
  emits: ["delete"],
  setup(t, { emit: e }) {
    const n = e, r = Ke(), { showModal: o, open: s, close: i } = St(), { showModal: u, open: l } = St(), { showModal: a, open: c } = St(), p = Se(), d = async (h) => {
      i(), await Ua(h, p.concurrencyV2Limits.deleteConcurrencyV2Limit, "Concurrency Limit"), n("delete", h);
    };
    return (h, m) => {
      const g = P("p-overflow-menu-item"), _ = P("p-icon-button-menu");
      return T(), z(ve, null, [
        w(_, sn(kn(h.$attrs)), {
          default: k(() => [
            w(v(uo), {
              label: "Copy ID",
              item: h.concurrencyLimit.id
            }, null, 8, ["item"]),
            v(r).delete.concurrency_limit ? (T(), O(g, {
              key: 0,
              label: "Delete",
              onClick: v(s)
            }, null, 8, ["onClick"])) : j("", !0),
            v(r).update.concurrency_limit ? (T(), O(g, {
              key: 1,
              label: "Edit",
              onClick: v(l)
            }, null, 8, ["onClick"])) : j("", !0),
            v(r).update.concurrency_limit ? (T(), O(g, {
              key: 2,
              label: "Reset",
              onClick: v(c)
            }, null, 8, ["onClick"])) : j("", !0)
          ]),
          _: 1
        }, 16),
        w(v(M4), {
          showModal: v(u),
          "onUpdate:showModal": m[0] || (m[0] = (b) => Xe(u) ? u.value = b : null),
          "concurrency-limit": h.concurrencyLimit
        }, null, 8, ["showModal", "concurrency-limit"]),
        w(v(C4), {
          showModal: v(a),
          "onUpdate:showModal": m[1] || (m[1] = (b) => Xe(a) ? a.value = b : null),
          "concurrency-limit": h.concurrencyLimit
        }, null, 8, ["showModal", "concurrency-limit"]),
        w(v(_r), {
          showModal: v(o),
          "onUpdate:showModal": m[2] || (m[2] = (b) => Xe(o) ? o.value = b : null),
          name: h.concurrencyLimit.name,
          label: "Concurrency Limit",
          onDelete: m[3] || (m[3] = (b) => d(h.concurrencyLimit.id))
        }, null, 8, ["showModal", "name"])
      ], 64);
    };
  }
}), C4 = /* @__PURE__ */ U({
  __name: "ConcurrencyLimitV2ResetModal",
  props: /* @__PURE__ */ Br({
    concurrencyLimit: {}
  }, {
    showModal: { type: Boolean },
    showModalModifiers: {}
  }),
  emits: ["update:showModal"],
  setup(t) {
    const e = t, n = zn(t, "showModal"), r = D(() => `Reset concurrency limit ${e.concurrencyLimit.name}?`), o = Se(), s = mt(o.concurrencyV2Limits.getConcurrencyV2Limit, [e.concurrencyLimit.id]), i = mt(o.concurrencyV2Limits.getConcurrencyV2Limits), u = async () => {
      try {
        await o.concurrencyV2Limits.updateConcurrencyV2Limit(e.concurrencyLimit.id, {
          activeSlots: 0
        }), s.refresh(), i.refresh(), He(le.success.resetConcurrencyLimit, "success");
      } catch (l) {
        console.error(l);
        const a = Yt(l, le.error.resetConcurrencyLimit);
        He(a, "error");
      } finally {
        n.value = !1;
      }
    };
    return (l, a) => {
      const c = P("p-button"), p = P("p-modal");
      return T(), O(p, {
        showModal: n.value,
        "onUpdate:showModal": a[0] || (a[0] = (d) => n.value = d),
        class: "concurrency-limit-reset-modal",
        title: r.value
      }, {
        actions: k(() => [
          Ve(l.$slots, "actions", {}, () => [
            w(c, {
              variant: "default",
              onClick: u
            }, {
              default: k(() => [...a[1] || (a[1] = [
                q(" Reset ", -1)
              ])]),
              _: 1
            })
          ])
        ]),
        default: k(() => [
          a[2] || (a[2] = q(" This will reset the active slots count to 0. ", -1))
        ]),
        _: 3
      }, 8, ["showModal", "title"]);
    };
  }
}), O4 = /* @__PURE__ */ U({
  __name: "ConcurrencyLimitV2Toggle",
  props: {
    limit: {}
  },
  emits: ["update"],
  setup(t, { emit: e }) {
    const n = t, r = Se(), o = mt(r.concurrencyV2Limits.getConcurrencyV2Limits), s = e, i = D({
      get() {
        return !!n.limit.active;
      },
      set(c) {
        a(c);
      }
    }), u = D(() => i.value ? "Set concurrency limit to inactive" : "Set concuurency limit to active"), l = ge(!1), a = async (c) => {
      l.value = !0;
      try {
        await r.concurrencyV2Limits.updateConcurrencyV2Limit(n.limit.id, { active: c }), He(le.success.updateConcurrencyLimit, "success"), o.refresh(), s("update");
      } catch (p) {
        const d = Yt(p, le.error.updateConcurrencyLimit);
        He(d, "error"), console.error(p);
      } finally {
        l.value = !1;
      }
    };
    return (c, p) => {
      const d = P("p-tooltip");
      return T(), O(d, { text: u.value }, {
        default: k(() => [
          w(v(Mh), {
            modelValue: i.value,
            "onUpdate:modelValue": p[0] || (p[0] = (h) => i.value = h),
            loading: l.value
          }, null, 8, ["modelValue", "loading"])
        ]),
        _: 1
      }, 8, ["text"]);
    };
  }
}), I4 = /* @__PURE__ */ U({
  __name: "ConcurrencyTableActiveSlots",
  props: {
    activeSlots: {}
  },
  setup(t) {
    const e = t, n = D(() => e.activeSlots.length);
    return (r, o) => n.value ? (T(), z(ve, { key: 1 }, [
      q(ie(n.value), 1)
    ], 64)) : (T(), z(ve, { key: 0 }, [
      q(" None ")
    ], 64));
  }
}), dfe = { class: "state-select" }, F4 = /* @__PURE__ */ U({
  __name: "StateSelect",
  props: {
    selected: {},
    emptyMessage: {},
    terminalState: { type: Boolean }
  },
  emits: ["update:selected"],
  setup(t, { emit: e }) {
    const n = t, r = e, o = D({
      get() {
        return n.selected ?? null;
      },
      set(l) {
        l ? s.value ? r("update:selected", eu(l) ? l : [l]) : r("update:selected", l) : r("update:selected", null);
      }
    }), s = D(() => eu(o.value)), i = D(() => n.terminalState ? g8.map((a) => ({
      label: yi(a),
      value: a
    })) : [...oh.map((a) => ({ label: yi(a), value: a })), { label: "Late", value: "late" }, { label: "Cancelling", value: "cancelling" }]), u = (l) => typeof l == "string" ? uh(l) : null;
    return (l, a) => (T(), z("div", dfe, [
      w(v(Om), {
        modelValue: o.value,
        "onUpdate:modelValue": a[0] || (a[0] = (c) => o.value = c),
        options: i.value,
        "empty-message": l.emptyMessage
      }, Ut({
        option: k(({ option: c }) => [
          w(Dr, {
            state: u(c.value)
          }, null, 8, ["state"])
        ]),
        _: 2
      }, [
        s.value ? {
          name: "tag",
          fn: k(({ value: c, dismiss: p }) => [
            w(Dr, {
              class: "state-select__option state-select__option--multiple",
              state: u(c),
              dismissible: "",
              onDismiss: p
            }, null, 8, ["state", "onDismiss"])
          ]),
          key: "0"
        } : {
          name: "default",
          fn: k(({ value: c }) => [
            w(Dr, {
              class: "state-select__option",
              state: u(c)
            }, null, 8, ["state"])
          ]),
          key: "1"
        }
      ]), 1032, ["modelValue", "options", "empty-message"])
    ]));
  }
}), hfe = { class: "state-change-modal__title" }, z2 = /* @__PURE__ */ U({
  __name: "ConfirmStateChangeModal",
  props: {
    showModal: { type: Boolean },
    label: { default: "" },
    run: {}
  },
  emits: ["update:showModal", "change"],
  setup(t, { emit: e }) {
    const n = t, r = e, o = D({
      get() {
        return n.showModal;
      },
      set(m) {
        r("update:showModal", m);
      }
    }), s = {
      type: [Kr("State")]
    }, { handleSubmit: i, handleReset: u, isSubmitting: l } = Mc(), { value: a, meta: c, errorMessage: p } = Rs("type", s.type), { value: d } = Rs("message"), h = i((m) => {
      r("change", m), o.value = !1;
    });
    return Ct(o, (m) => {
      m || u();
    }), (m, g) => {
      const _ = P("p-label"), b = P("p-text-input"), x = P("p-content"), S = P("p-form"), E = P("p-button"), A = P("p-modal");
      return T(), O(A, {
        showModal: o.value,
        "onUpdate:showModal": g[2] || (g[2] = (C) => o.value = C)
      }, {
        title: k(() => [
          re("div", hfe, [
            Ve(m.$slots, "title", {}, () => [
              q(ie(`Change ${m.label} State`), 1)
            ])
          ])
        ]),
        actions: k(() => [
          Ve(m.$slots, "actions", {}, () => [
            w(E, {
              variant: "default",
              class: "state-change-modal__state-change-button",
              loading: v(l),
              onClick: v(h)
            }, {
              default: k(() => [...g[3] || (g[3] = [
                q(" Change ", -1)
              ])]),
              _: 1
            }, 8, ["loading", "onClick"])
          ])
        ]),
        default: k(() => [
          w(S, { onSubmit: v(h) }, {
            default: k(() => [
              w(x, null, {
                default: k(() => [
                  w(_, {
                    label: `Current ${m.label} State`
                  }, {
                    default: k(() => [
                      w(Dr, {
                        state: m.run.state
                      }, null, 8, ["state"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  w(_, {
                    label: `Desired ${m.label} State`,
                    message: v(p),
                    state: v(c)
                  }, {
                    default: k(() => [
                      w(F4, {
                        selected: v(a),
                        "onUpdate:selected": g[0] || (g[0] = (C) => Xe(a) ? a.value = C : null),
                        "terminal-state": ""
                      }, null, 8, ["selected"])
                    ]),
                    _: 1
                  }, 8, ["label", "message", "state"]),
                  w(_, { label: "Reason (Optional)" }, {
                    default: k(() => [
                      w(b, {
                        modelValue: v(d),
                        "onUpdate:modelValue": g[1] || (g[1] = (C) => Xe(d) ? d.value = C : null)
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["onSubmit"])
        ]),
        _: 3
      }, 8, ["showModal"]);
    };
  }
}), ffe = {
  inheritAttrs: !1
}, E_ = /* @__PURE__ */ U({
  ...ffe,
  __name: "ExtraInfoModal",
  props: {
    title: {}
  },
  setup(t) {
    const e = Eh(), { showModal: n, open: r, close: o } = St();
    return (s, i) => {
      const u = P("p-icon"), l = P("p-button"), a = P("p-modal");
      return T(), z(ve, null, [
        re("button", yt({ class: "extra-info-modal" }, v(e), {
          type: "button",
          onClick: i[0] || (i[0] = ek(
            //@ts-ignore
            (...c) => v(r) && v(r)(...c),
            ["stop", "prevent"]
          ))
        }), [
          w(u, {
            icon: "InformationCircleIcon",
            class: "extra-info-modal__icon"
          })
        ], 16),
        w(a, {
          "show-modal": v(n),
          "onUpdate:showModal": i[1] || (i[1] = (c) => Xe(n) ? n.value = c : null),
          title: s.title
        }, {
          actions: k(() => [
            Ve(s.$slots, "actions")
          ]),
          cancel: k(() => [
            w(l, { onClick: v(o) }, {
              default: k(() => [...i[2] || (i[2] = [
                q(" Close ", -1)
              ])]),
              _: 1
            }, 8, ["onClick"])
          ]),
          default: k(() => [
            Ve(s.$slots, "default")
          ]),
          _: 3
        }, 8, ["show-modal", "title"])
      ], 64);
    };
  }
}), N4 = /* @__PURE__ */ U({
  __name: "DayOrDescriptionModal",
  setup(t) {
    return (e, n) => (T(), O(E_, { title: "Day Or" }, {
      default: k(() => [...n[0] || (n[0] = [
        q(' When the "Day Or" value is off, this schedule will connect day of the month and day of the week entries using OR logic; when on it will connect them using AND logic. ', -1)
      ])]),
      _: 1
    }));
  }
}), M_ = /* @__PURE__ */ U({
  __name: "TimezoneSelect",
  props: /* @__PURE__ */ Br({
    showTimestamp: { type: Boolean },
    hideUnset: { type: Boolean }
  }, {
    modelValue: { required: !0 },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(t) {
    const e = zn(t, "modelValue"), n = t, r = ge(/* @__PURE__ */ new Date()), o = D(() => n.showTimestamp ? N0(r.value, "hh:mm a", e.value) : void 0);
    function s() {
      r.value = /* @__PURE__ */ new Date();
    }
    const i = Oa - r.value.getSeconds(), u = Kv * i;
    let l = setTimeout(() => {
      s(), l = setInterval(() => s, Ia);
    }, u);
    Em(() => clearTimeout(l));
    function a(h) {
      return Hm(h).replaceAll("/", " / ");
    }
    const c = Intl.supportedValuesOf("timeZone").map((h) => ({ label: a(h), value: h })), p = Intl.DateTimeFormat().resolvedOptions().timeZone, d = D(() => {
      const h = [
        { label: a(p), value: p },
        { label: "UTC", value: H3 }
      ];
      return n.hideUnset || h.unshift({ label: "Use browser default", value: null }), [
        {
          label: "Suggested timezones",
          options: h
        },
        {
          label: "All timezones",
          options: c
        }
      ];
    });
    return (h, m) => {
      const g = P("p-combobox");
      return T(), O(g, {
        modelValue: e.value,
        "onUpdate:modelValue": m[0] || (m[0] = (_) => e.value = _),
        options: d.value,
        append: o.value
      }, null, 8, ["modelValue", "options", "append"]);
    };
  }
}), mfe = { class: "cron-schedule-form__row" }, yfe = { class: "cron-schedule-form__row" }, L4 = /* @__PURE__ */ U({
  __name: "CronScheduleForm",
  props: {
    hideActions: { type: Boolean },
    schedule: { default: () => new B0({ cron: "* * * * *", dayOr: !0, timezone: "UTC" }) }
  },
  emits: ["cancel", "update:schedule", "submit", "update:disabled"],
  setup(t, { emit: e }) {
    const n = t, r = e, o = () => zl(u.value) ? "Unsupported expression" : !0, s = () => {
      const _ = d.value.toString();
      return _ !== "" && _.toLowerCase() !== "invalid" ? !0 : "Invalid expression";
    }, i = {
      cron: [
        Kr("Expression"),
        s,
        o
      ]
    }, { value: u, meta: l, errors: a } = Rs("cron", i.cron, { initialValue: n.schedule.cron }), c = ge(n.schedule.timezone), p = ge(n.schedule.dayOr), d = D(() => new B0({
      cron: u.value,
      dayOr: p.value,
      timezone: c.value
    })), h = D(() => a.value.length > 0), m = () => {
      r("cancel");
    }, g = () => {
      h.value || r("submit", d.value);
    };
    return Ct(() => d.value, () => r("update:schedule", d.value)), Ct(() => h.value, () => r("update:disabled", h.value)), Ct(() => n.schedule, (_) => {
      c.value = _.timezone ?? c.value, u.value = _.cron, p.value = _.dayOr;
    }, { deep: !0 }), wi(() => {
      r("update:disabled", h.value), r("update:schedule", d.value);
    }), (_, b) => {
      const x = P("p-text-input"), S = P("p-label"), E = P("p-toggle"), A = P("p-content"), C = P("p-button"), M = P("p-form");
      return T(), O(M, { onSubmit: g }, Ut({
        default: k(() => [
          w(A, null, {
            default: k(() => [
              re("div", mfe, [
                w(S, {
                  label: "Value",
                  class: "cron-schedule-form__column--span-3",
                  state: v(l)
                }, {
                  message: k(() => [
                    q(ie(v(a)?.[0] ?? d.value), 1)
                  ]),
                  default: k(() => [
                    w(x, {
                      modelValue: v(u),
                      "onUpdate:modelValue": b[0] || (b[0] = (L) => Xe(u) ? u.value = L : null)
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["state"]),
                w(S, { class: "cron-schedule-form__column--span-1" }, {
                  label: k(() => [
                    re("span", null, [
                      b[3] || (b[3] = q(" Day Or ", -1)),
                      w(N4)
                    ])
                  ]),
                  default: k(() => [
                    w(E, {
                      modelValue: p.value,
                      "onUpdate:modelValue": b[1] || (b[1] = (L) => p.value = L),
                      class: "inline-block"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              re("div", yfe, [
                w(S, {
                  label: "Timezone",
                  class: "cron-schedule-form__column--span-2"
                }, {
                  default: k(() => [
                    w(M_, {
                      modelValue: c.value,
                      "onUpdate:modelValue": b[2] || (b[2] = (L) => c.value = L)
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          })
        ]),
        _: 2
      }, [
        _.hideActions ? void 0 : {
          name: "footer",
          fn: k(() => [
            Ve(_.$slots, "footer", { disabled: h.value }, () => [
              w(C, { onClick: m }, {
                default: k(() => [...b[4] || (b[4] = [
                  q(" Cancel ", -1)
                ])]),
                _: 1
              }),
              w(C, {
                variant: "default",
                disabled: h.value,
                type: "submit"
              }, {
                default: k(() => [...b[5] || (b[5] = [
                  q(" Save ", -1)
                ])]),
                _: 1
              }, 8, ["disabled"])
            ])
          ]),
          key: "0"
        }
      ]), 1024);
    };
  }
}), gfe = { class: "statistic-key-value__value" }, vfe = {
  key: 0,
  class: "statistic-key-value__label"
}, _fe = {
  key: 1,
  class: "statistic-key-value__meta"
}, Jl = /* @__PURE__ */ U({
  __name: "StatisticKeyValue",
  props: {
    value: {},
    label: {},
    meta: {},
    primary: { type: Boolean }
  },
  setup(t) {
    const e = t, n = D(() => ({
      "statistic-key-value--primary": e.primary
    }));
    return (r, o) => (T(), z("div", {
      class: Bt(["statistic-key-value", n.value])
    }, [
      re("span", gfe, ie(r.value.toLocaleString()), 1),
      v(Vt)(r.label) ? (T(), z("span", vfe, ie(r.label.toLocaleString()), 1)) : j("", !0),
      v(Vt)(r.meta) ? (T(), z("span", _fe, ie(r.meta.toLocaleString()), 1)) : j("", !0)
    ], 2));
  }
}), wfe = { class: "cumulative-task-runs-card__summary" }, bfe = { class: "cumulative-task-runs-card__chart-container" }, pM = 10, kfe = /* @__PURE__ */ U({
  __name: "CumulativeTaskRunsCard",
  props: {
    filter: { type: Function }
  },
  setup(t) {
    const e = t, n = Xa(), r = xe(e.filter), o = () => {
      const A = {
        taskRuns: {
          state: {
            type: ["COMPLETED", "FAILED", "CRASHED", "RUNNING"]
          }
        }
      };
      return $t({}, r.value, A);
    }, { count: s } = hp(o, n), i = D(() => {
      let A = s.value ?? 0;
      return m.value && (A = A - m.value), A;
    }), u = () => {
      const A = {
        taskRuns: {
          state: {
            type: ["COMPLETED"]
          }
        }
      };
      return $t({}, r.value, A);
    }, { count: l } = hp(u, n), a = D(() => E(l.value, i.value)), c = () => {
      const A = {
        taskRuns: {
          state: {
            type: ["FAILED", "CRASHED"]
          }
        }
      };
      return $t({}, r.value, A);
    }, { count: p } = hp(c, n), d = D(() => E(p.value, i.value)), h = () => {
      const A = {
        taskRuns: {
          state: {
            type: ["RUNNING"]
          }
        }
      };
      return $t({}, r.value, A);
    }, { count: m } = hp(h, n), { history: g } = Rse(() => ye.map("TaskRunsFilter", r.value, "TaskRunsHistoryFilter"), n), _ = D(() => {
      const A = [], C = [], M = [];
      return g.value.forEach((L) => {
        let X = 0, te = 0;
        L.states.forEach((G) => {
          G.stateType === "COMPLETED" ? X += G.countRuns : ["FAILED", "CRASHED"].includes(G.stateType) && (te += G.countRuns);
        });
        const [, B = 0] = A.at(-1) ?? [], [, W = 0] = C.at(-1) ?? [];
        A.push([L.intervalStart, B + X]), C.push([L.intervalStart, W + te]);
      }), {
        completed: A,
        failed: C,
        running: M
      };
    }), b = D(() => {
      const A = _.value.completed.map(([, X]) => X), C = _.value.failed.map(([, X]) => X);
      return Math.max(...A, ...C, 1);
    }), x = D(() => {
      const A = _.value.completed.map(([, X]) => X), M = Math.max(...A, 1);
      if (M === b.value)
        return M;
      let L = 1;
      for (; L <= pM; ) {
        if (M > b.value / L)
          return M * L;
        L++;
      }
      return M * L;
    }), S = D(() => {
      const A = _.value.failed.map(([, X]) => X), M = Math.max(...A, 1);
      if (M === b.value)
        return M;
      let L = 1;
      for (; L <= pM; ) {
        if (M > b.value / L)
          return M * L;
        L++;
      }
      return M * L;
    });
    function E(A, C) {
      if (Vt(A) && Vt(C)) {
        const M = _F(A, C);
        if (M)
          return `${M}%`;
      }
    }
    return (A, C) => {
      const M = P("p-heading"), L = P("p-card");
      return T(), O(L, { class: "cumulative-task-runs-card" }, {
        default: k(() => [
          w(M, { heading: "5" }, {
            default: k(() => [...C[0] || (C[0] = [
              q(" Task Runs ", -1)
            ])]),
            _: 1
          }),
          re("div", wfe, [
            v(Vt)(v(s)) ? (T(), O(Jl, {
              key: 0,
              value: v(s),
              primary: ""
            }, null, 8, ["value"])) : j("", !0),
            v(Vt)(v(m)) && v(m) > 0 ? (T(), O(Jl, {
              key: 1,
              value: v(m),
              label: "Running",
              class: "cumulative-task-runs-card__statistic--running"
            }, null, 8, ["value"])) : j("", !0),
            v(Vt)(v(l)) ? (T(), O(Jl, {
              key: 2,
              value: v(l),
              label: "Completed",
              meta: a.value,
              class: "cumulative-task-runs-card__statistic--completed"
            }, null, 8, ["value", "meta"])) : j("", !0),
            v(Vt)(v(p)) && v(p) > 0 ? (T(), O(Jl, {
              key: 3,
              value: v(p),
              label: "Failed",
              meta: d.value,
              class: "cumulative-task-runs-card__statistic--failed"
            }, null, 8, ["value", "meta"])) : j("", !0)
          ]),
          re("div", bfe, [
            v(Vt)(v(p)) && v(p) > 0 ? (T(), O(v(tk), {
              key: 0,
              data: _.value.failed,
              options: { maxValue: S.value },
              class: "cumulative-task-runs-card__chart cumulative-task-runs-card__chart--failed"
            }, null, 8, ["data", "options"])) : j("", !0),
            w(v(tk), {
              data: _.value.completed,
              options: { maxValue: x.value },
              class: "cumulative-task-runs-card__chart cumulative-task-runs-card__chart--completed"
            }, null, 8, ["data", "options"])
          ])
        ]),
        _: 1
      });
    };
  }
}), Tfe = { class: "dashboard-work-pool-card-detail" }, xfe = { class: "dashboard-work-pool-card-detail__label" }, Sfe = { class: "dashboard-work-pool-card-detail__value" }, ag = /* @__PURE__ */ U({
  __name: "DashboardWorkPoolCardDetail",
  props: {
    label: {}
  },
  setup(t) {
    return (e, n) => (T(), z("div", Tfe, [
      re("dt", xfe, ie(e.label), 1),
      re("dd", Sfe, [
        Ve(e.$slots, "default")
      ])
    ]));
  }
}), Rfe = {
  key: 0,
  class: "dashboard-work-pool-flow-runs-completeness"
}, Afe = {
  key: 1,
  class: "dashboard-work-pool-flow-runs-completeness__none"
}, Dfe = /* @__PURE__ */ U({
  __name: "DashboardWorkPoolFlowRunCompleteness",
  props: {
    workPool: {},
    filter: { type: Function }
  },
  setup(t) {
    const e = t, n = Xa(), r = D(() => {
      const a = Qe(e.filter), c = {
        workPools: {
          id: [e.workPool.id]
        }
      };
      return $t({}, a, c);
    }), o = D(() => {
      const a = Qe(e.filter), c = a?.flowRuns?.startTimeBefore, p = a?.flowRuns?.startTimeAfter;
      if (!c || !p)
        return null;
      const d = uc(c, p), h = O0(c.getTime(), d), m = O0(p.getTime(), d);
      return $t({}, a, {
        flowRuns: {
          startTimeBefore: h,
          startTimeAfter: m
        }
      });
    }), { completeness: s } = zE(r, n), { completeness: i } = zE(o, n), u = D(() => {
      if (!i.value || !s.value || i.value === s.value)
        return;
      const a = i.value * 100, c = s.value * 100, d = (a - c) / 100;
      return {
        change: Math.abs(d).toFixed(1),
        direction: i.value > s.value ? "-" : "+"
      };
    }), l = D(() => ({
      "dashboard-work-pool-flow-runs-completeness__difference--negative": u.value?.direction === "-",
      "dashboard-work-pool-flow-runs-completeness__difference--positive": u.value?.direction === "+"
    }));
    return (a, c) => {
      const p = P("p-tooltip");
      return v(s) ? (T(), z("span", Rfe, [
        re("span", null, ie(v(s)) + "%", 1),
        u.value ? (T(), O(p, {
          key: 0,
          text: v(le).info.percentChangeOverTimePeriod(`${u.value.direction}${u.value.change}`)
        }, {
          default: k(() => [
            re("span", {
              class: Bt(["dashboard-work-pool-flow-runs-completeness__difference", l.value])
            }, ie(u.value.direction) + " " + ie(u.value.change), 3)
          ]),
          _: 1
        }, 8, ["text"])) : j("", !0)
      ])) : (T(), z("span", Afe, " N/A "));
    };
  }
}), Efe = /* @__PURE__ */ U({
  __name: "DashboardWorkPoolFlowRunsTotal",
  props: {
    workPool: {},
    filter: { type: Function }
  },
  setup(t) {
    const e = t, n = () => {
      const s = Qe(e.filter), i = {
        workPools: {
          name: [e.workPool.name]
        },
        flowRuns: {
          state: {
            type: ["COMPLETED", "FAILED", "CRASHED"]
          }
        }
      };
      return $t({}, s, i);
    }, r = Xa(), { count: o } = du(n, r);
    return (s, i) => (T(), O(Jl, {
      class: "dashboard-work-pool-flow-runs-total",
      label: "total",
      value: v(o) ?? 0
    }, null, 8, ["value"]));
  }
}), Mfe = /* @__PURE__ */ U({
  __name: "DashboardWorkPoolLateCount",
  props: {
    workPool: {},
    filter: { type: Function }
  },
  setup(t) {
    const e = t, n = () => {
      const u = Qe(e.filter), l = {
        workPools: {
          name: [e.workPool.name]
        },
        flowRuns: {
          state: {
            name: ["late"]
          }
        }
      };
      return $t({}, u, l);
    }, r = Xa({ interval: 3e4 }), { count: o } = du(n, r), s = D(() => o.value ?? 0), i = D(() => ({
      "work-pool-late-count--zero": s.value < 1
    }));
    return (u, l) => (T(), z("span", {
      class: Bt(["work-pool-late-count", i.value])
    }, ie(s.value), 3));
  }
});
function Qg(t, e) {
  return t == null || e == null ? NaN : t < e ? -1 : t > e ? 1 : t >= e ? 0 : NaN;
}
function Pfe(t, e) {
  return t == null || e == null ? NaN : e < t ? -1 : e > t ? 1 : e >= t ? 0 : NaN;
}
function B4(t) {
  let e, n, r;
  t.length !== 2 ? (e = Qg, n = (u, l) => Qg(t(u), l), r = (u, l) => t(u) - l) : (e = t === Qg || t === Pfe ? t : Cfe, n = t, r = t);
  function o(u, l, a = 0, c = u.length) {
    if (a < c) {
      if (e(l, l) !== 0) return c;
      do {
        const p = a + c >>> 1;
        n(u[p], l) < 0 ? a = p + 1 : c = p;
      } while (a < c);
    }
    return a;
  }
  function s(u, l, a = 0, c = u.length) {
    if (a < c) {
      if (e(l, l) !== 0) return c;
      do {
        const p = a + c >>> 1;
        n(u[p], l) <= 0 ? a = p + 1 : c = p;
      } while (a < c);
    }
    return a;
  }
  function i(u, l, a = 0, c = u.length) {
    const p = o(u, l, a, c - 1);
    return p > a && r(u[p - 1], l) > -r(u[p], l) ? p - 1 : p;
  }
  return { left: o, center: i, right: s };
}
function Cfe() {
  return 0;
}
function Ofe(t) {
  return t === null ? NaN : +t;
}
const Ife = B4(Qg), Ffe = Ife.right;
B4(Ofe).center;
const Nfe = Math.sqrt(50), Lfe = Math.sqrt(10), Bfe = Math.sqrt(2);
function j0(t, e, n) {
  const r = (e - t) / Math.max(0, n), o = Math.floor(Math.log10(r)), s = r / Math.pow(10, o), i = s >= Nfe ? 10 : s >= Lfe ? 5 : s >= Bfe ? 2 : 1;
  let u, l, a;
  return o < 0 ? (a = Math.pow(10, -o) / i, u = Math.round(t * a), l = Math.round(e * a), u / a < t && ++u, l / a > e && --l, a = -a) : (a = Math.pow(10, o) * i, u = Math.round(t / a), l = Math.round(e / a), u * a < t && ++u, l * a > e && --l), l < u && 0.5 <= n && n < 2 ? j0(t, e, n * 2) : [u, l, a];
}
function Ufe(t, e, n) {
  if (e = +e, t = +t, n = +n, !(n > 0)) return [];
  if (t === e) return [t];
  const r = e < t, [o, s, i] = r ? j0(e, t, n) : j0(t, e, n);
  if (!(s >= o)) return [];
  const u = s - o + 1, l = new Array(u);
  if (r)
    if (i < 0) for (let a = 0; a < u; ++a) l[a] = (s - a) / -i;
    else for (let a = 0; a < u; ++a) l[a] = (s - a) * i;
  else if (i < 0) for (let a = 0; a < u; ++a) l[a] = (o + a) / -i;
  else for (let a = 0; a < u; ++a) l[a] = (o + a) * i;
  return l;
}
function Lk(t, e, n) {
  return e = +e, t = +t, n = +n, j0(t, e, n)[2];
}
function Xfe(t, e, n) {
  e = +e, t = +t, n = +n;
  const r = e < t, o = r ? Lk(e, t, n) : Lk(t, e, n);
  return (r ? -1 : 1) * (o < 0 ? 1 / -o : o);
}
var $fe = { value: () => {
} };
function U4() {
  for (var t = 0, e = arguments.length, n = {}, r; t < e; ++t) {
    if (!(r = arguments[t] + "") || r in n || /[\s.]/.test(r)) throw new Error("illegal type: " + r);
    n[r] = [];
  }
  return new Kg(n);
}
function Kg(t) {
  this._ = t;
}
function Wfe(t, e) {
  return t.trim().split(/^|\s+/).map(function(n) {
    var r = "", o = n.indexOf(".");
    if (o >= 0 && (r = n.slice(o + 1), n = n.slice(0, o)), n && !e.hasOwnProperty(n)) throw new Error("unknown type: " + n);
    return { type: n, name: r };
  });
}
Kg.prototype = U4.prototype = {
  constructor: Kg,
  on: function(t, e) {
    var n = this._, r = Wfe(t + "", n), o, s = -1, i = r.length;
    if (arguments.length < 2) {
      for (; ++s < i; ) if ((o = (t = r[s]).type) && (o = Vfe(n[o], t.name))) return o;
      return;
    }
    if (e != null && typeof e != "function") throw new Error("invalid callback: " + e);
    for (; ++s < i; )
      if (o = (t = r[s]).type) n[o] = dM(n[o], t.name, e);
      else if (e == null) for (o in n) n[o] = dM(n[o], t.name, null);
    return this;
  },
  copy: function() {
    var t = {}, e = this._;
    for (var n in e) t[n] = e[n].slice();
    return new Kg(t);
  },
  call: function(t, e) {
    if ((o = arguments.length - 2) > 0) for (var n = new Array(o), r = 0, o, s; r < o; ++r) n[r] = arguments[r + 2];
    if (!this._.hasOwnProperty(t)) throw new Error("unknown type: " + t);
    for (s = this._[t], r = 0, o = s.length; r < o; ++r) s[r].value.apply(e, n);
  },
  apply: function(t, e, n) {
    if (!this._.hasOwnProperty(t)) throw new Error("unknown type: " + t);
    for (var r = this._[t], o = 0, s = r.length; o < s; ++o) r[o].value.apply(e, n);
  }
};
function Vfe(t, e) {
  for (var n = 0, r = t.length, o; n < r; ++n)
    if ((o = t[n]).name === e)
      return o.value;
}
function dM(t, e, n) {
  for (var r = 0, o = t.length; r < o; ++r)
    if (t[r].name === e) {
      t[r] = $fe, t = t.slice(0, r).concat(t.slice(r + 1));
      break;
    }
  return n != null && t.push({ name: e, value: n }), t;
}
var Bk = "http://www.w3.org/1999/xhtml";
const hM = {
  svg: "http://www.w3.org/2000/svg",
  xhtml: Bk,
  xlink: "http://www.w3.org/1999/xlink",
  xml: "http://www.w3.org/XML/1998/namespace",
  xmlns: "http://www.w3.org/2000/xmlns/"
};
function P_(t) {
  var e = t += "", n = e.indexOf(":");
  return n >= 0 && (e = t.slice(0, n)) !== "xmlns" && (t = t.slice(n + 1)), hM.hasOwnProperty(e) ? { space: hM[e], local: t } : t;
}
function Hfe(t) {
  return function() {
    var e = this.ownerDocument, n = this.namespaceURI;
    return n === Bk && e.documentElement.namespaceURI === Bk ? e.createElement(t) : e.createElementNS(n, t);
  };
}
function jfe(t) {
  return function() {
    return this.ownerDocument.createElementNS(t.space, t.local);
  };
}
function X4(t) {
  var e = P_(t);
  return (e.local ? jfe : Hfe)(e);
}
function zfe() {
}
function q2(t) {
  return t == null ? zfe : function() {
    return this.querySelector(t);
  };
}
function qfe(t) {
  typeof t != "function" && (t = q2(t));
  for (var e = this._groups, n = e.length, r = new Array(n), o = 0; o < n; ++o)
    for (var s = e[o], i = s.length, u = r[o] = new Array(i), l, a, c = 0; c < i; ++c)
      (l = s[c]) && (a = t.call(l, l.__data__, c, s)) && ("__data__" in l && (a.__data__ = l.__data__), u[c] = a);
  return new vi(r, this._parents);
}
function Gfe(t) {
  return t == null ? [] : Array.isArray(t) ? t : Array.from(t);
}
function Yfe() {
  return [];
}
function $4(t) {
  return t == null ? Yfe : function() {
    return this.querySelectorAll(t);
  };
}
function Qfe(t) {
  return function() {
    return Gfe(t.apply(this, arguments));
  };
}
function Kfe(t) {
  typeof t == "function" ? t = Qfe(t) : t = $4(t);
  for (var e = this._groups, n = e.length, r = [], o = [], s = 0; s < n; ++s)
    for (var i = e[s], u = i.length, l, a = 0; a < u; ++a)
      (l = i[a]) && (r.push(t.call(l, l.__data__, a, i)), o.push(l));
  return new vi(r, o);
}
function W4(t) {
  return function() {
    return this.matches(t);
  };
}
function V4(t) {
  return function(e) {
    return e.matches(t);
  };
}
var Zfe = Array.prototype.find;
function Jfe(t) {
  return function() {
    return Zfe.call(this.children, t);
  };
}
function eme() {
  return this.firstElementChild;
}
function tme(t) {
  return this.select(t == null ? eme : Jfe(typeof t == "function" ? t : V4(t)));
}
var nme = Array.prototype.filter;
function rme() {
  return Array.from(this.children);
}
function ome(t) {
  return function() {
    return nme.call(this.children, t);
  };
}
function sme(t) {
  return this.selectAll(t == null ? rme : ome(typeof t == "function" ? t : V4(t)));
}
function ame(t) {
  typeof t != "function" && (t = W4(t));
  for (var e = this._groups, n = e.length, r = new Array(n), o = 0; o < n; ++o)
    for (var s = e[o], i = s.length, u = r[o] = [], l, a = 0; a < i; ++a)
      (l = s[a]) && t.call(l, l.__data__, a, s) && u.push(l);
  return new vi(r, this._parents);
}
function H4(t) {
  return new Array(t.length);
}
function ime() {
  return new vi(this._enter || this._groups.map(H4), this._parents);
}
function z0(t, e) {
  this.ownerDocument = t.ownerDocument, this.namespaceURI = t.namespaceURI, this._next = null, this._parent = t, this.__data__ = e;
}
z0.prototype = {
  constructor: z0,
  appendChild: function(t) {
    return this._parent.insertBefore(t, this._next);
  },
  insertBefore: function(t, e) {
    return this._parent.insertBefore(t, e);
  },
  querySelector: function(t) {
    return this._parent.querySelector(t);
  },
  querySelectorAll: function(t) {
    return this._parent.querySelectorAll(t);
  }
};
function ume(t) {
  return function() {
    return t;
  };
}
function lme(t, e, n, r, o, s) {
  for (var i = 0, u, l = e.length, a = s.length; i < a; ++i)
    (u = e[i]) ? (u.__data__ = s[i], r[i] = u) : n[i] = new z0(t, s[i]);
  for (; i < l; ++i)
    (u = e[i]) && (o[i] = u);
}
function cme(t, e, n, r, o, s, i) {
  var u, l, a = /* @__PURE__ */ new Map(), c = e.length, p = s.length, d = new Array(c), h;
  for (u = 0; u < c; ++u)
    (l = e[u]) && (d[u] = h = i.call(l, l.__data__, u, e) + "", a.has(h) ? o[u] = l : a.set(h, l));
  for (u = 0; u < p; ++u)
    h = i.call(t, s[u], u, s) + "", (l = a.get(h)) ? (r[u] = l, l.__data__ = s[u], a.delete(h)) : n[u] = new z0(t, s[u]);
  for (u = 0; u < c; ++u)
    (l = e[u]) && a.get(d[u]) === l && (o[u] = l);
}
function pme(t) {
  return t.__data__;
}
function dme(t, e) {
  if (!arguments.length) return Array.from(this, pme);
  var n = e ? cme : lme, r = this._parents, o = this._groups;
  typeof t != "function" && (t = ume(t));
  for (var s = o.length, i = new Array(s), u = new Array(s), l = new Array(s), a = 0; a < s; ++a) {
    var c = r[a], p = o[a], d = p.length, h = hme(t.call(c, c && c.__data__, a, r)), m = h.length, g = u[a] = new Array(m), _ = i[a] = new Array(m), b = l[a] = new Array(d);
    n(c, p, g, _, b, h, e);
    for (var x = 0, S = 0, E, A; x < m; ++x)
      if (E = g[x]) {
        for (x >= S && (S = x + 1); !(A = _[S]) && ++S < m; ) ;
        E._next = A || null;
      }
  }
  return i = new vi(i, r), i._enter = u, i._exit = l, i;
}
function hme(t) {
  return typeof t == "object" && "length" in t ? t : Array.from(t);
}
function fme() {
  return new vi(this._exit || this._groups.map(H4), this._parents);
}
function mme(t, e, n) {
  var r = this.enter(), o = this, s = this.exit();
  return typeof t == "function" ? (r = t(r), r && (r = r.selection())) : r = r.append(t + ""), e != null && (o = e(o), o && (o = o.selection())), n == null ? s.remove() : n(s), r && o ? r.merge(o).order() : o;
}
function yme(t) {
  for (var e = t.selection ? t.selection() : t, n = this._groups, r = e._groups, o = n.length, s = r.length, i = Math.min(o, s), u = new Array(o), l = 0; l < i; ++l)
    for (var a = n[l], c = r[l], p = a.length, d = u[l] = new Array(p), h, m = 0; m < p; ++m)
      (h = a[m] || c[m]) && (d[m] = h);
  for (; l < o; ++l)
    u[l] = n[l];
  return new vi(u, this._parents);
}
function gme() {
  for (var t = this._groups, e = -1, n = t.length; ++e < n; )
    for (var r = t[e], o = r.length - 1, s = r[o], i; --o >= 0; )
      (i = r[o]) && (s && i.compareDocumentPosition(s) ^ 4 && s.parentNode.insertBefore(i, s), s = i);
  return this;
}
function vme(t) {
  t || (t = _me);
  function e(p, d) {
    return p && d ? t(p.__data__, d.__data__) : !p - !d;
  }
  for (var n = this._groups, r = n.length, o = new Array(r), s = 0; s < r; ++s) {
    for (var i = n[s], u = i.length, l = o[s] = new Array(u), a, c = 0; c < u; ++c)
      (a = i[c]) && (l[c] = a);
    l.sort(e);
  }
  return new vi(o, this._parents).order();
}
function _me(t, e) {
  return t < e ? -1 : t > e ? 1 : t >= e ? 0 : NaN;
}
function wme() {
  var t = arguments[0];
  return arguments[0] = this, t.apply(null, arguments), this;
}
function bme() {
  return Array.from(this);
}
function kme() {
  for (var t = this._groups, e = 0, n = t.length; e < n; ++e)
    for (var r = t[e], o = 0, s = r.length; o < s; ++o) {
      var i = r[o];
      if (i) return i;
    }
  return null;
}
function Tme() {
  let t = 0;
  for (const e of this) ++t;
  return t;
}
function xme() {
  return !this.node();
}
function Sme(t) {
  for (var e = this._groups, n = 0, r = e.length; n < r; ++n)
    for (var o = e[n], s = 0, i = o.length, u; s < i; ++s)
      (u = o[s]) && t.call(u, u.__data__, s, o);
  return this;
}
function Rme(t) {
  return function() {
    this.removeAttribute(t);
  };
}
function Ame(t) {
  return function() {
    this.removeAttributeNS(t.space, t.local);
  };
}
function Dme(t, e) {
  return function() {
    this.setAttribute(t, e);
  };
}
function Eme(t, e) {
  return function() {
    this.setAttributeNS(t.space, t.local, e);
  };
}
function Mme(t, e) {
  return function() {
    var n = e.apply(this, arguments);
    n == null ? this.removeAttribute(t) : this.setAttribute(t, n);
  };
}
function Pme(t, e) {
  return function() {
    var n = e.apply(this, arguments);
    n == null ? this.removeAttributeNS(t.space, t.local) : this.setAttributeNS(t.space, t.local, n);
  };
}
function Cme(t, e) {
  var n = P_(t);
  if (arguments.length < 2) {
    var r = this.node();
    return n.local ? r.getAttributeNS(n.space, n.local) : r.getAttribute(n);
  }
  return this.each((e == null ? n.local ? Ame : Rme : typeof e == "function" ? n.local ? Pme : Mme : n.local ? Eme : Dme)(n, e));
}
function j4(t) {
  return t.ownerDocument && t.ownerDocument.defaultView || t.document && t || t.defaultView;
}
function Ome(t) {
  return function() {
    this.style.removeProperty(t);
  };
}
function Ime(t, e, n) {
  return function() {
    this.style.setProperty(t, e, n);
  };
}
function Fme(t, e, n) {
  return function() {
    var r = e.apply(this, arguments);
    r == null ? this.style.removeProperty(t) : this.style.setProperty(t, r, n);
  };
}
function Nme(t, e, n) {
  return arguments.length > 1 ? this.each((e == null ? Ome : typeof e == "function" ? Fme : Ime)(t, e, n ?? "")) : mh(this.node(), t);
}
function mh(t, e) {
  return t.style.getPropertyValue(e) || j4(t).getComputedStyle(t, null).getPropertyValue(e);
}
function Lme(t) {
  return function() {
    delete this[t];
  };
}
function Bme(t, e) {
  return function() {
    this[t] = e;
  };
}
function Ume(t, e) {
  return function() {
    var n = e.apply(this, arguments);
    n == null ? delete this[t] : this[t] = n;
  };
}
function Xme(t, e) {
  return arguments.length > 1 ? this.each((e == null ? Lme : typeof e == "function" ? Ume : Bme)(t, e)) : this.node()[t];
}
function z4(t) {
  return t.trim().split(/^|\s+/);
}
function G2(t) {
  return t.classList || new q4(t);
}
function q4(t) {
  this._node = t, this._names = z4(t.getAttribute("class") || "");
}
q4.prototype = {
  add: function(t) {
    var e = this._names.indexOf(t);
    e < 0 && (this._names.push(t), this._node.setAttribute("class", this._names.join(" ")));
  },
  remove: function(t) {
    var e = this._names.indexOf(t);
    e >= 0 && (this._names.splice(e, 1), this._node.setAttribute("class", this._names.join(" ")));
  },
  contains: function(t) {
    return this._names.indexOf(t) >= 0;
  }
};
function G4(t, e) {
  for (var n = G2(t), r = -1, o = e.length; ++r < o; ) n.add(e[r]);
}
function Y4(t, e) {
  for (var n = G2(t), r = -1, o = e.length; ++r < o; ) n.remove(e[r]);
}
function $me(t) {
  return function() {
    G4(this, t);
  };
}
function Wme(t) {
  return function() {
    Y4(this, t);
  };
}
function Vme(t, e) {
  return function() {
    (e.apply(this, arguments) ? G4 : Y4)(this, t);
  };
}
function Hme(t, e) {
  var n = z4(t + "");
  if (arguments.length < 2) {
    for (var r = G2(this.node()), o = -1, s = n.length; ++o < s; ) if (!r.contains(n[o])) return !1;
    return !0;
  }
  return this.each((typeof e == "function" ? Vme : e ? $me : Wme)(n, e));
}
function jme() {
  this.textContent = "";
}
function zme(t) {
  return function() {
    this.textContent = t;
  };
}
function qme(t) {
  return function() {
    var e = t.apply(this, arguments);
    this.textContent = e ?? "";
  };
}
function Gme(t) {
  return arguments.length ? this.each(t == null ? jme : (typeof t == "function" ? qme : zme)(t)) : this.node().textContent;
}
function Yme() {
  this.innerHTML = "";
}
function Qme(t) {
  return function() {
    this.innerHTML = t;
  };
}
function Kme(t) {
  return function() {
    var e = t.apply(this, arguments);
    this.innerHTML = e ?? "";
  };
}
function Zme(t) {
  return arguments.length ? this.each(t == null ? Yme : (typeof t == "function" ? Kme : Qme)(t)) : this.node().innerHTML;
}
function Jme() {
  this.nextSibling && this.parentNode.appendChild(this);
}
function eye() {
  return this.each(Jme);
}
function tye() {
  this.previousSibling && this.parentNode.insertBefore(this, this.parentNode.firstChild);
}
function nye() {
  return this.each(tye);
}
function rye(t) {
  var e = typeof t == "function" ? t : X4(t);
  return this.select(function() {
    return this.appendChild(e.apply(this, arguments));
  });
}
function oye() {
  return null;
}
function sye(t, e) {
  var n = typeof t == "function" ? t : X4(t), r = e == null ? oye : typeof e == "function" ? e : q2(e);
  return this.select(function() {
    return this.insertBefore(n.apply(this, arguments), r.apply(this, arguments) || null);
  });
}
function aye() {
  var t = this.parentNode;
  t && t.removeChild(this);
}
function iye() {
  return this.each(aye);
}
function uye() {
  var t = this.cloneNode(!1), e = this.parentNode;
  return e ? e.insertBefore(t, this.nextSibling) : t;
}
function lye() {
  var t = this.cloneNode(!0), e = this.parentNode;
  return e ? e.insertBefore(t, this.nextSibling) : t;
}
function cye(t) {
  return this.select(t ? lye : uye);
}
function pye(t) {
  return arguments.length ? this.property("__data__", t) : this.node().__data__;
}
function dye(t) {
  return function(e) {
    t.call(this, e, this.__data__);
  };
}
function hye(t) {
  return t.trim().split(/^|\s+/).map(function(e) {
    var n = "", r = e.indexOf(".");
    return r >= 0 && (n = e.slice(r + 1), e = e.slice(0, r)), { type: e, name: n };
  });
}
function fye(t) {
  return function() {
    var e = this.__on;
    if (e) {
      for (var n = 0, r = -1, o = e.length, s; n < o; ++n)
        s = e[n], (!t.type || s.type === t.type) && s.name === t.name ? this.removeEventListener(s.type, s.listener, s.options) : e[++r] = s;
      ++r ? e.length = r : delete this.__on;
    }
  };
}
function mye(t, e, n) {
  return function() {
    var r = this.__on, o, s = dye(e);
    if (r) {
      for (var i = 0, u = r.length; i < u; ++i)
        if ((o = r[i]).type === t.type && o.name === t.name) {
          this.removeEventListener(o.type, o.listener, o.options), this.addEventListener(o.type, o.listener = s, o.options = n), o.value = e;
          return;
        }
    }
    this.addEventListener(t.type, s, n), o = { type: t.type, name: t.name, value: e, listener: s, options: n }, r ? r.push(o) : this.__on = [o];
  };
}
function yye(t, e, n) {
  var r = hye(t + ""), o, s = r.length, i;
  if (arguments.length < 2) {
    var u = this.node().__on;
    if (u) {
      for (var l = 0, a = u.length, c; l < a; ++l)
        for (o = 0, c = u[l]; o < s; ++o)
          if ((i = r[o]).type === c.type && i.name === c.name)
            return c.value;
    }
    return;
  }
  for (u = e ? mye : fye, o = 0; o < s; ++o) this.each(u(r[o], e, n));
  return this;
}
function Q4(t, e, n) {
  var r = j4(t), o = r.CustomEvent;
  typeof o == "function" ? o = new o(e, n) : (o = r.document.createEvent("Event"), n ? (o.initEvent(e, n.bubbles, n.cancelable), o.detail = n.detail) : o.initEvent(e, !1, !1)), t.dispatchEvent(o);
}
function gye(t, e) {
  return function() {
    return Q4(this, t, e);
  };
}
function vye(t, e) {
  return function() {
    return Q4(this, t, e.apply(this, arguments));
  };
}
function _ye(t, e) {
  return this.each((typeof e == "function" ? vye : gye)(t, e));
}
function* wye() {
  for (var t = this._groups, e = 0, n = t.length; e < n; ++e)
    for (var r = t[e], o = 0, s = r.length, i; o < s; ++o)
      (i = r[o]) && (yield i);
}
var bye = [null];
function vi(t, e) {
  this._groups = t, this._parents = e;
}
function oy() {
  return new vi([[document.documentElement]], bye);
}
function kye() {
  return this;
}
vi.prototype = oy.prototype = {
  constructor: vi,
  select: qfe,
  selectAll: Kfe,
  selectChild: tme,
  selectChildren: sme,
  filter: ame,
  data: dme,
  enter: ime,
  exit: fme,
  join: mme,
  merge: yme,
  selection: kye,
  order: gme,
  sort: vme,
  call: wme,
  nodes: bme,
  node: kme,
  size: Tme,
  empty: xme,
  each: Sme,
  attr: Cme,
  style: Nme,
  property: Xme,
  classed: Hme,
  text: Gme,
  html: Zme,
  raise: eye,
  lower: nye,
  append: rye,
  insert: sye,
  remove: iye,
  clone: cye,
  datum: pye,
  on: yye,
  dispatch: _ye,
  [Symbol.iterator]: wye
};
function Y2(t, e, n) {
  t.prototype = e.prototype = n, n.constructor = t;
}
function K4(t, e) {
  var n = Object.create(t.prototype);
  for (var r in e) n[r] = e[r];
  return n;
}
function sy() {
}
var hm = 0.7, q0 = 1 / hm, qd = "\\s*([+-]?\\d+)\\s*", fm = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)\\s*", ou = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)%\\s*", Tye = /^#([0-9a-f]{3,8})$/, xye = new RegExp(`^rgb\\(${qd},${qd},${qd}\\)$`), Sye = new RegExp(`^rgb\\(${ou},${ou},${ou}\\)$`), Rye = new RegExp(`^rgba\\(${qd},${qd},${qd},${fm}\\)$`), Aye = new RegExp(`^rgba\\(${ou},${ou},${ou},${fm}\\)$`), Dye = new RegExp(`^hsl\\(${fm},${ou},${ou}\\)$`), Eye = new RegExp(`^hsla\\(${fm},${ou},${ou},${fm}\\)$`), fM = {
  aliceblue: 15792383,
  antiquewhite: 16444375,
  aqua: 65535,
  aquamarine: 8388564,
  azure: 15794175,
  beige: 16119260,
  bisque: 16770244,
  black: 0,
  blanchedalmond: 16772045,
  blue: 255,
  blueviolet: 9055202,
  brown: 10824234,
  burlywood: 14596231,
  cadetblue: 6266528,
  chartreuse: 8388352,
  chocolate: 13789470,
  coral: 16744272,
  cornflowerblue: 6591981,
  cornsilk: 16775388,
  crimson: 14423100,
  cyan: 65535,
  darkblue: 139,
  darkcyan: 35723,
  darkgoldenrod: 12092939,
  darkgray: 11119017,
  darkgreen: 25600,
  darkgrey: 11119017,
  darkkhaki: 12433259,
  darkmagenta: 9109643,
  darkolivegreen: 5597999,
  darkorange: 16747520,
  darkorchid: 10040012,
  darkred: 9109504,
  darksalmon: 15308410,
  darkseagreen: 9419919,
  darkslateblue: 4734347,
  darkslategray: 3100495,
  darkslategrey: 3100495,
  darkturquoise: 52945,
  darkviolet: 9699539,
  deeppink: 16716947,
  deepskyblue: 49151,
  dimgray: 6908265,
  dimgrey: 6908265,
  dodgerblue: 2003199,
  firebrick: 11674146,
  floralwhite: 16775920,
  forestgreen: 2263842,
  fuchsia: 16711935,
  gainsboro: 14474460,
  ghostwhite: 16316671,
  gold: 16766720,
  goldenrod: 14329120,
  gray: 8421504,
  green: 32768,
  greenyellow: 11403055,
  grey: 8421504,
  honeydew: 15794160,
  hotpink: 16738740,
  indianred: 13458524,
  indigo: 4915330,
  ivory: 16777200,
  khaki: 15787660,
  lavender: 15132410,
  lavenderblush: 16773365,
  lawngreen: 8190976,
  lemonchiffon: 16775885,
  lightblue: 11393254,
  lightcoral: 15761536,
  lightcyan: 14745599,
  lightgoldenrodyellow: 16448210,
  lightgray: 13882323,
  lightgreen: 9498256,
  lightgrey: 13882323,
  lightpink: 16758465,
  lightsalmon: 16752762,
  lightseagreen: 2142890,
  lightskyblue: 8900346,
  lightslategray: 7833753,
  lightslategrey: 7833753,
  lightsteelblue: 11584734,
  lightyellow: 16777184,
  lime: 65280,
  limegreen: 3329330,
  linen: 16445670,
  magenta: 16711935,
  maroon: 8388608,
  mediumaquamarine: 6737322,
  mediumblue: 205,
  mediumorchid: 12211667,
  mediumpurple: 9662683,
  mediumseagreen: 3978097,
  mediumslateblue: 8087790,
  mediumspringgreen: 64154,
  mediumturquoise: 4772300,
  mediumvioletred: 13047173,
  midnightblue: 1644912,
  mintcream: 16121850,
  mistyrose: 16770273,
  moccasin: 16770229,
  navajowhite: 16768685,
  navy: 128,
  oldlace: 16643558,
  olive: 8421376,
  olivedrab: 7048739,
  orange: 16753920,
  orangered: 16729344,
  orchid: 14315734,
  palegoldenrod: 15657130,
  palegreen: 10025880,
  paleturquoise: 11529966,
  palevioletred: 14381203,
  papayawhip: 16773077,
  peachpuff: 16767673,
  peru: 13468991,
  pink: 16761035,
  plum: 14524637,
  powderblue: 11591910,
  purple: 8388736,
  rebeccapurple: 6697881,
  red: 16711680,
  rosybrown: 12357519,
  royalblue: 4286945,
  saddlebrown: 9127187,
  salmon: 16416882,
  sandybrown: 16032864,
  seagreen: 3050327,
  seashell: 16774638,
  sienna: 10506797,
  silver: 12632256,
  skyblue: 8900331,
  slateblue: 6970061,
  slategray: 7372944,
  slategrey: 7372944,
  snow: 16775930,
  springgreen: 65407,
  steelblue: 4620980,
  tan: 13808780,
  teal: 32896,
  thistle: 14204888,
  tomato: 16737095,
  turquoise: 4251856,
  violet: 15631086,
  wheat: 16113331,
  white: 16777215,
  whitesmoke: 16119285,
  yellow: 16776960,
  yellowgreen: 10145074
};
Y2(sy, Lp, {
  copy(t) {
    return Object.assign(new this.constructor(), this, t);
  },
  displayable() {
    return this.rgb().displayable();
  },
  hex: mM,
  // Deprecated! Use color.formatHex.
  formatHex: mM,
  formatHex8: Mye,
  formatHsl: Pye,
  formatRgb: yM,
  toString: yM
});
function mM() {
  return this.rgb().formatHex();
}
function Mye() {
  return this.rgb().formatHex8();
}
function Pye() {
  return Z4(this).formatHsl();
}
function yM() {
  return this.rgb().formatRgb();
}
function Lp(t) {
  var e, n;
  return t = (t + "").trim().toLowerCase(), (e = Tye.exec(t)) ? (n = e[1].length, e = parseInt(e[1], 16), n === 6 ? gM(e) : n === 3 ? new ys(e >> 8 & 15 | e >> 4 & 240, e >> 4 & 15 | e & 240, (e & 15) << 4 | e & 15, 1) : n === 8 ? ig(e >> 24 & 255, e >> 16 & 255, e >> 8 & 255, (e & 255) / 255) : n === 4 ? ig(e >> 12 & 15 | e >> 8 & 240, e >> 8 & 15 | e >> 4 & 240, e >> 4 & 15 | e & 240, ((e & 15) << 4 | e & 15) / 255) : null) : (e = xye.exec(t)) ? new ys(e[1], e[2], e[3], 1) : (e = Sye.exec(t)) ? new ys(e[1] * 255 / 100, e[2] * 255 / 100, e[3] * 255 / 100, 1) : (e = Rye.exec(t)) ? ig(e[1], e[2], e[3], e[4]) : (e = Aye.exec(t)) ? ig(e[1] * 255 / 100, e[2] * 255 / 100, e[3] * 255 / 100, e[4]) : (e = Dye.exec(t)) ? wM(e[1], e[2] / 100, e[3] / 100, 1) : (e = Eye.exec(t)) ? wM(e[1], e[2] / 100, e[3] / 100, e[4]) : fM.hasOwnProperty(t) ? gM(fM[t]) : t === "transparent" ? new ys(NaN, NaN, NaN, 0) : null;
}
function gM(t) {
  return new ys(t >> 16 & 255, t >> 8 & 255, t & 255, 1);
}
function ig(t, e, n, r) {
  return r <= 0 && (t = e = n = NaN), new ys(t, e, n, r);
}
function Cye(t) {
  return t instanceof sy || (t = Lp(t)), t ? (t = t.rgb(), new ys(t.r, t.g, t.b, t.opacity)) : new ys();
}
function Uk(t, e, n, r) {
  return arguments.length === 1 ? Cye(t) : new ys(t, e, n, r ?? 1);
}
function ys(t, e, n, r) {
  this.r = +t, this.g = +e, this.b = +n, this.opacity = +r;
}
Y2(ys, Uk, K4(sy, {
  brighter(t) {
    return t = t == null ? q0 : Math.pow(q0, t), new ys(this.r * t, this.g * t, this.b * t, this.opacity);
  },
  darker(t) {
    return t = t == null ? hm : Math.pow(hm, t), new ys(this.r * t, this.g * t, this.b * t, this.opacity);
  },
  rgb() {
    return this;
  },
  clamp() {
    return new ys(Tp(this.r), Tp(this.g), Tp(this.b), G0(this.opacity));
  },
  displayable() {
    return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
  },
  hex: vM,
  // Deprecated! Use color.formatHex.
  formatHex: vM,
  formatHex8: Oye,
  formatRgb: _M,
  toString: _M
}));
function vM() {
  return `#${fp(this.r)}${fp(this.g)}${fp(this.b)}`;
}
function Oye() {
  return `#${fp(this.r)}${fp(this.g)}${fp(this.b)}${fp((isNaN(this.opacity) ? 1 : this.opacity) * 255)}`;
}
function _M() {
  const t = G0(this.opacity);
  return `${t === 1 ? "rgb(" : "rgba("}${Tp(this.r)}, ${Tp(this.g)}, ${Tp(this.b)}${t === 1 ? ")" : `, ${t})`}`;
}
function G0(t) {
  return isNaN(t) ? 1 : Math.max(0, Math.min(1, t));
}
function Tp(t) {
  return Math.max(0, Math.min(255, Math.round(t) || 0));
}
function fp(t) {
  return t = Tp(t), (t < 16 ? "0" : "") + t.toString(16);
}
function wM(t, e, n, r) {
  return r <= 0 ? t = e = n = NaN : n <= 0 || n >= 1 ? t = e = NaN : e <= 0 && (t = NaN), new ii(t, e, n, r);
}
function Z4(t) {
  if (t instanceof ii) return new ii(t.h, t.s, t.l, t.opacity);
  if (t instanceof sy || (t = Lp(t)), !t) return new ii();
  if (t instanceof ii) return t;
  t = t.rgb();
  var e = t.r / 255, n = t.g / 255, r = t.b / 255, o = Math.min(e, n, r), s = Math.max(e, n, r), i = NaN, u = s - o, l = (s + o) / 2;
  return u ? (e === s ? i = (n - r) / u + (n < r) * 6 : n === s ? i = (r - e) / u + 2 : i = (e - n) / u + 4, u /= l < 0.5 ? s + o : 2 - s - o, i *= 60) : u = l > 0 && l < 1 ? 0 : i, new ii(i, u, l, t.opacity);
}
function Iye(t, e, n, r) {
  return arguments.length === 1 ? Z4(t) : new ii(t, e, n, r ?? 1);
}
function ii(t, e, n, r) {
  this.h = +t, this.s = +e, this.l = +n, this.opacity = +r;
}
Y2(ii, Iye, K4(sy, {
  brighter(t) {
    return t = t == null ? q0 : Math.pow(q0, t), new ii(this.h, this.s, this.l * t, this.opacity);
  },
  darker(t) {
    return t = t == null ? hm : Math.pow(hm, t), new ii(this.h, this.s, this.l * t, this.opacity);
  },
  rgb() {
    var t = this.h % 360 + (this.h < 0) * 360, e = isNaN(t) || isNaN(this.s) ? 0 : this.s, n = this.l, r = n + (n < 0.5 ? n : 1 - n) * e, o = 2 * n - r;
    return new ys(
      O1(t >= 240 ? t - 240 : t + 120, o, r),
      O1(t, o, r),
      O1(t < 120 ? t + 240 : t - 120, o, r),
      this.opacity
    );
  },
  clamp() {
    return new ii(bM(this.h), ug(this.s), ug(this.l), G0(this.opacity));
  },
  displayable() {
    return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
  },
  formatHsl() {
    const t = G0(this.opacity);
    return `${t === 1 ? "hsl(" : "hsla("}${bM(this.h)}, ${ug(this.s) * 100}%, ${ug(this.l) * 100}%${t === 1 ? ")" : `, ${t})`}`;
  }
}));
function bM(t) {
  return t = (t || 0) % 360, t < 0 ? t + 360 : t;
}
function ug(t) {
  return Math.max(0, Math.min(1, t || 0));
}
function O1(t, e, n) {
  return (t < 60 ? e + (n - e) * t / 60 : t < 180 ? n : t < 240 ? e + (n - e) * (240 - t) / 60 : e) * 255;
}
const Q2 = (t) => () => t;
function Fye(t, e) {
  return function(n) {
    return t + n * e;
  };
}
function Nye(t, e, n) {
  return t = Math.pow(t, n), e = Math.pow(e, n) - t, n = 1 / n, function(r) {
    return Math.pow(t + r * e, n);
  };
}
function Lye(t) {
  return (t = +t) == 1 ? J4 : function(e, n) {
    return n - e ? Nye(e, n, t) : Q2(isNaN(e) ? n : e);
  };
}
function J4(t, e) {
  var n = e - t;
  return n ? Fye(t, n) : Q2(isNaN(t) ? e : t);
}
const Y0 = function t(e) {
  var n = Lye(e);
  function r(o, s) {
    var i = n((o = Uk(o)).r, (s = Uk(s)).r), u = n(o.g, s.g), l = n(o.b, s.b), a = J4(o.opacity, s.opacity);
    return function(c) {
      return o.r = i(c), o.g = u(c), o.b = l(c), o.opacity = a(c), o + "";
    };
  }
  return r.gamma = t, r;
}(1);
function Bye(t, e) {
  e || (e = []);
  var n = t ? Math.min(e.length, t.length) : 0, r = e.slice(), o;
  return function(s) {
    for (o = 0; o < n; ++o) r[o] = t[o] * (1 - s) + e[o] * s;
    return r;
  };
}
function Uye(t) {
  return ArrayBuffer.isView(t) && !(t instanceof DataView);
}
function Xye(t, e) {
  var n = e ? e.length : 0, r = t ? Math.min(n, t.length) : 0, o = new Array(r), s = new Array(n), i;
  for (i = 0; i < r; ++i) o[i] = K2(t[i], e[i]);
  for (; i < n; ++i) s[i] = e[i];
  return function(u) {
    for (i = 0; i < r; ++i) s[i] = o[i](u);
    return s;
  };
}
function $ye(t, e) {
  var n = /* @__PURE__ */ new Date();
  return t = +t, e = +e, function(r) {
    return n.setTime(t * (1 - r) + e * r), n;
  };
}
function si(t, e) {
  return t = +t, e = +e, function(n) {
    return t * (1 - n) + e * n;
  };
}
function Wye(t, e) {
  var n = {}, r = {}, o;
  (t === null || typeof t != "object") && (t = {}), (e === null || typeof e != "object") && (e = {});
  for (o in e)
    o in t ? n[o] = K2(t[o], e[o]) : r[o] = e[o];
  return function(s) {
    for (o in n) r[o] = n[o](s);
    return r;
  };
}
var Xk = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, I1 = new RegExp(Xk.source, "g");
function Vye(t) {
  return function() {
    return t;
  };
}
function Hye(t) {
  return function(e) {
    return t(e) + "";
  };
}
function eL(t, e) {
  var n = Xk.lastIndex = I1.lastIndex = 0, r, o, s, i = -1, u = [], l = [];
  for (t = t + "", e = e + ""; (r = Xk.exec(t)) && (o = I1.exec(e)); )
    (s = o.index) > n && (s = e.slice(n, s), u[i] ? u[i] += s : u[++i] = s), (r = r[0]) === (o = o[0]) ? u[i] ? u[i] += o : u[++i] = o : (u[++i] = null, l.push({ i, x: si(r, o) })), n = I1.lastIndex;
  return n < e.length && (s = e.slice(n), u[i] ? u[i] += s : u[++i] = s), u.length < 2 ? l[0] ? Hye(l[0].x) : Vye(e) : (e = l.length, function(a) {
    for (var c = 0, p; c < e; ++c) u[(p = l[c]).i] = p.x(a);
    return u.join("");
  });
}
function K2(t, e) {
  var n = typeof e, r;
  return e == null || n === "boolean" ? Q2(e) : (n === "number" ? si : n === "string" ? (r = Lp(e)) ? (e = r, Y0) : eL : e instanceof Lp ? Y0 : e instanceof Date ? $ye : Uye(e) ? Bye : Array.isArray(e) ? Xye : typeof e.valueOf != "function" && typeof e.toString != "function" || isNaN(e) ? Wye : si)(t, e);
}
function jye(t, e) {
  return t = +t, e = +e, function(n) {
    return Math.round(t * (1 - n) + e * n);
  };
}
var kM = 180 / Math.PI, $k = {
  translateX: 0,
  translateY: 0,
  rotate: 0,
  skewX: 0,
  scaleX: 1,
  scaleY: 1
};
function tL(t, e, n, r, o, s) {
  var i, u, l;
  return (i = Math.sqrt(t * t + e * e)) && (t /= i, e /= i), (l = t * n + e * r) && (n -= t * l, r -= e * l), (u = Math.sqrt(n * n + r * r)) && (n /= u, r /= u, l /= u), t * r < e * n && (t = -t, e = -e, l = -l, i = -i), {
    translateX: o,
    translateY: s,
    rotate: Math.atan2(e, t) * kM,
    skewX: Math.atan(l) * kM,
    scaleX: i,
    scaleY: u
  };
}
var lg;
function zye(t) {
  const e = new (typeof DOMMatrix == "function" ? DOMMatrix : WebKitCSSMatrix)(t + "");
  return e.isIdentity ? $k : tL(e.a, e.b, e.c, e.d, e.e, e.f);
}
function qye(t) {
  return t == null || (lg || (lg = document.createElementNS("http://www.w3.org/2000/svg", "g")), lg.setAttribute("transform", t), !(t = lg.transform.baseVal.consolidate())) ? $k : (t = t.matrix, tL(t.a, t.b, t.c, t.d, t.e, t.f));
}
function nL(t, e, n, r) {
  function o(a) {
    return a.length ? a.pop() + " " : "";
  }
  function s(a, c, p, d, h, m) {
    if (a !== p || c !== d) {
      var g = h.push("translate(", null, e, null, n);
      m.push({ i: g - 4, x: si(a, p) }, { i: g - 2, x: si(c, d) });
    } else (p || d) && h.push("translate(" + p + e + d + n);
  }
  function i(a, c, p, d) {
    a !== c ? (a - c > 180 ? c += 360 : c - a > 180 && (a += 360), d.push({ i: p.push(o(p) + "rotate(", null, r) - 2, x: si(a, c) })) : c && p.push(o(p) + "rotate(" + c + r);
  }
  function u(a, c, p, d) {
    a !== c ? d.push({ i: p.push(o(p) + "skewX(", null, r) - 2, x: si(a, c) }) : c && p.push(o(p) + "skewX(" + c + r);
  }
  function l(a, c, p, d, h, m) {
    if (a !== p || c !== d) {
      var g = h.push(o(h) + "scale(", null, ",", null, ")");
      m.push({ i: g - 4, x: si(a, p) }, { i: g - 2, x: si(c, d) });
    } else (p !== 1 || d !== 1) && h.push(o(h) + "scale(" + p + "," + d + ")");
  }
  return function(a, c) {
    var p = [], d = [];
    return a = t(a), c = t(c), s(a.translateX, a.translateY, c.translateX, c.translateY, p, d), i(a.rotate, c.rotate, p, d), u(a.skewX, c.skewX, p, d), l(a.scaleX, a.scaleY, c.scaleX, c.scaleY, p, d), a = c = null, function(h) {
      for (var m = -1, g = d.length, _; ++m < g; ) p[(_ = d[m]).i] = _.x(h);
      return p.join("");
    };
  };
}
var Gye = nL(zye, "px, ", "px)", "deg)"), Yye = nL(qye, ", ", ")", ")"), yh = 0, If = 0, yf = 0, rL = 1e3, Q0, Ff, K0 = 0, Bp = 0, C_ = 0, mm = typeof performance == "object" && performance.now ? performance : Date, oL = typeof window == "object" && window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function(t) {
  setTimeout(t, 17);
};
function Z2() {
  return Bp || (oL(Qye), Bp = mm.now() + C_);
}
function Qye() {
  Bp = 0;
}
function Z0() {
  this._call = this._time = this._next = null;
}
Z0.prototype = sL.prototype = {
  constructor: Z0,
  restart: function(t, e, n) {
    if (typeof t != "function") throw new TypeError("callback is not a function");
    n = (n == null ? Z2() : +n) + (e == null ? 0 : +e), !this._next && Ff !== this && (Ff ? Ff._next = this : Q0 = this, Ff = this), this._call = t, this._time = n, Wk();
  },
  stop: function() {
    this._call && (this._call = null, this._time = 1 / 0, Wk());
  }
};
function sL(t, e, n) {
  var r = new Z0();
  return r.restart(t, e, n), r;
}
function Kye() {
  Z2(), ++yh;
  for (var t = Q0, e; t; )
    (e = Bp - t._time) >= 0 && t._call.call(void 0, e), t = t._next;
  --yh;
}
function TM() {
  Bp = (K0 = mm.now()) + C_, yh = If = 0;
  try {
    Kye();
  } finally {
    yh = 0, Jye(), Bp = 0;
  }
}
function Zye() {
  var t = mm.now(), e = t - K0;
  e > rL && (C_ -= e, K0 = t);
}
function Jye() {
  for (var t, e = Q0, n, r = 1 / 0; e; )
    e._call ? (r > e._time && (r = e._time), t = e, e = e._next) : (n = e._next, e._next = null, e = t ? t._next = n : Q0 = n);
  Ff = t, Wk(r);
}
function Wk(t) {
  if (!yh) {
    If && (If = clearTimeout(If));
    var e = t - Bp;
    e > 24 ? (t < 1 / 0 && (If = setTimeout(TM, t - mm.now() - C_)), yf && (yf = clearInterval(yf))) : (yf || (K0 = mm.now(), yf = setInterval(Zye, rL)), yh = 1, oL(TM));
  }
}
function xM(t, e, n) {
  var r = new Z0();
  return e = e == null ? 0 : +e, r.restart((o) => {
    r.stop(), t(o + e);
  }, e, n), r;
}
var ege = U4("start", "end", "cancel", "interrupt"), tge = [], aL = 0, SM = 1, Vk = 2, Zg = 3, RM = 4, Hk = 5, Jg = 6;
function O_(t, e, n, r, o, s) {
  var i = t.__transition;
  if (!i) t.__transition = {};
  else if (n in i) return;
  nge(t, n, {
    name: e,
    index: r,
    // For context during callback.
    group: o,
    // For context during callback.
    on: ege,
    tween: tge,
    time: s.time,
    delay: s.delay,
    duration: s.duration,
    ease: s.ease,
    timer: null,
    state: aL
  });
}
function J2(t, e) {
  var n = xi(t, e);
  if (n.state > aL) throw new Error("too late; already scheduled");
  return n;
}
function vu(t, e) {
  var n = xi(t, e);
  if (n.state > Zg) throw new Error("too late; already running");
  return n;
}
function xi(t, e) {
  var n = t.__transition;
  if (!n || !(n = n[e])) throw new Error("transition not found");
  return n;
}
function nge(t, e, n) {
  var r = t.__transition, o;
  r[e] = n, n.timer = sL(s, 0, n.time);
  function s(a) {
    n.state = SM, n.timer.restart(i, n.delay, n.time), n.delay <= a && i(a - n.delay);
  }
  function i(a) {
    var c, p, d, h;
    if (n.state !== SM) return l();
    for (c in r)
      if (h = r[c], h.name === n.name) {
        if (h.state === Zg) return xM(i);
        h.state === RM ? (h.state = Jg, h.timer.stop(), h.on.call("interrupt", t, t.__data__, h.index, h.group), delete r[c]) : +c < e && (h.state = Jg, h.timer.stop(), h.on.call("cancel", t, t.__data__, h.index, h.group), delete r[c]);
      }
    if (xM(function() {
      n.state === Zg && (n.state = RM, n.timer.restart(u, n.delay, n.time), u(a));
    }), n.state = Vk, n.on.call("start", t, t.__data__, n.index, n.group), n.state === Vk) {
      for (n.state = Zg, o = new Array(d = n.tween.length), c = 0, p = -1; c < d; ++c)
        (h = n.tween[c].value.call(t, t.__data__, n.index, n.group)) && (o[++p] = h);
      o.length = p + 1;
    }
  }
  function u(a) {
    for (var c = a < n.duration ? n.ease.call(null, a / n.duration) : (n.timer.restart(l), n.state = Hk, 1), p = -1, d = o.length; ++p < d; )
      o[p].call(t, c);
    n.state === Hk && (n.on.call("end", t, t.__data__, n.index, n.group), l());
  }
  function l() {
    n.state = Jg, n.timer.stop(), delete r[e];
    for (var a in r) return;
    delete t.__transition;
  }
}
function rge(t, e) {
  var n = t.__transition, r, o, s = !0, i;
  if (n) {
    e = e == null ? null : e + "";
    for (i in n) {
      if ((r = n[i]).name !== e) {
        s = !1;
        continue;
      }
      o = r.state > Vk && r.state < Hk, r.state = Jg, r.timer.stop(), r.on.call(o ? "interrupt" : "cancel", t, t.__data__, r.index, r.group), delete n[i];
    }
    s && delete t.__transition;
  }
}
function oge(t) {
  return this.each(function() {
    rge(this, t);
  });
}
function sge(t, e) {
  var n, r;
  return function() {
    var o = vu(this, t), s = o.tween;
    if (s !== n) {
      r = n = s;
      for (var i = 0, u = r.length; i < u; ++i)
        if (r[i].name === e) {
          r = r.slice(), r.splice(i, 1);
          break;
        }
    }
    o.tween = r;
  };
}
function age(t, e, n) {
  var r, o;
  if (typeof n != "function") throw new Error();
  return function() {
    var s = vu(this, t), i = s.tween;
    if (i !== r) {
      o = (r = i).slice();
      for (var u = { name: e, value: n }, l = 0, a = o.length; l < a; ++l)
        if (o[l].name === e) {
          o[l] = u;
          break;
        }
      l === a && o.push(u);
    }
    s.tween = o;
  };
}
function ige(t, e) {
  var n = this._id;
  if (t += "", arguments.length < 2) {
    for (var r = xi(this.node(), n).tween, o = 0, s = r.length, i; o < s; ++o)
      if ((i = r[o]).name === t)
        return i.value;
    return null;
  }
  return this.each((e == null ? sge : age)(n, t, e));
}
function eS(t, e, n) {
  var r = t._id;
  return t.each(function() {
    var o = vu(this, r);
    (o.value || (o.value = {}))[e] = n.apply(this, arguments);
  }), function(o) {
    return xi(o, r).value[e];
  };
}
function iL(t, e) {
  var n;
  return (typeof e == "number" ? si : e instanceof Lp ? Y0 : (n = Lp(e)) ? (e = n, Y0) : eL)(t, e);
}
function uge(t) {
  return function() {
    this.removeAttribute(t);
  };
}
function lge(t) {
  return function() {
    this.removeAttributeNS(t.space, t.local);
  };
}
function cge(t, e, n) {
  var r, o = n + "", s;
  return function() {
    var i = this.getAttribute(t);
    return i === o ? null : i === r ? s : s = e(r = i, n);
  };
}
function pge(t, e, n) {
  var r, o = n + "", s;
  return function() {
    var i = this.getAttributeNS(t.space, t.local);
    return i === o ? null : i === r ? s : s = e(r = i, n);
  };
}
function dge(t, e, n) {
  var r, o, s;
  return function() {
    var i, u = n(this), l;
    return u == null ? void this.removeAttribute(t) : (i = this.getAttribute(t), l = u + "", i === l ? null : i === r && l === o ? s : (o = l, s = e(r = i, u)));
  };
}
function hge(t, e, n) {
  var r, o, s;
  return function() {
    var i, u = n(this), l;
    return u == null ? void this.removeAttributeNS(t.space, t.local) : (i = this.getAttributeNS(t.space, t.local), l = u + "", i === l ? null : i === r && l === o ? s : (o = l, s = e(r = i, u)));
  };
}
function fge(t, e) {
  var n = P_(t), r = n === "transform" ? Yye : iL;
  return this.attrTween(t, typeof e == "function" ? (n.local ? hge : dge)(n, r, eS(this, "attr." + t, e)) : e == null ? (n.local ? lge : uge)(n) : (n.local ? pge : cge)(n, r, e));
}
function mge(t, e) {
  return function(n) {
    this.setAttribute(t, e.call(this, n));
  };
}
function yge(t, e) {
  return function(n) {
    this.setAttributeNS(t.space, t.local, e.call(this, n));
  };
}
function gge(t, e) {
  var n, r;
  function o() {
    var s = e.apply(this, arguments);
    return s !== r && (n = (r = s) && yge(t, s)), n;
  }
  return o._value = e, o;
}
function vge(t, e) {
  var n, r;
  function o() {
    var s = e.apply(this, arguments);
    return s !== r && (n = (r = s) && mge(t, s)), n;
  }
  return o._value = e, o;
}
function _ge(t, e) {
  var n = "attr." + t;
  if (arguments.length < 2) return (n = this.tween(n)) && n._value;
  if (e == null) return this.tween(n, null);
  if (typeof e != "function") throw new Error();
  var r = P_(t);
  return this.tween(n, (r.local ? gge : vge)(r, e));
}
function wge(t, e) {
  return function() {
    J2(this, t).delay = +e.apply(this, arguments);
  };
}
function bge(t, e) {
  return e = +e, function() {
    J2(this, t).delay = e;
  };
}
function kge(t) {
  var e = this._id;
  return arguments.length ? this.each((typeof t == "function" ? wge : bge)(e, t)) : xi(this.node(), e).delay;
}
function Tge(t, e) {
  return function() {
    vu(this, t).duration = +e.apply(this, arguments);
  };
}
function xge(t, e) {
  return e = +e, function() {
    vu(this, t).duration = e;
  };
}
function Sge(t) {
  var e = this._id;
  return arguments.length ? this.each((typeof t == "function" ? Tge : xge)(e, t)) : xi(this.node(), e).duration;
}
function Rge(t, e) {
  if (typeof e != "function") throw new Error();
  return function() {
    vu(this, t).ease = e;
  };
}
function Age(t) {
  var e = this._id;
  return arguments.length ? this.each(Rge(e, t)) : xi(this.node(), e).ease;
}
function Dge(t, e) {
  return function() {
    var n = e.apply(this, arguments);
    if (typeof n != "function") throw new Error();
    vu(this, t).ease = n;
  };
}
function Ege(t) {
  if (typeof t != "function") throw new Error();
  return this.each(Dge(this._id, t));
}
function Mge(t) {
  typeof t != "function" && (t = W4(t));
  for (var e = this._groups, n = e.length, r = new Array(n), o = 0; o < n; ++o)
    for (var s = e[o], i = s.length, u = r[o] = [], l, a = 0; a < i; ++a)
      (l = s[a]) && t.call(l, l.__data__, a, s) && u.push(l);
  return new sl(r, this._parents, this._name, this._id);
}
function Pge(t) {
  if (t._id !== this._id) throw new Error();
  for (var e = this._groups, n = t._groups, r = e.length, o = n.length, s = Math.min(r, o), i = new Array(r), u = 0; u < s; ++u)
    for (var l = e[u], a = n[u], c = l.length, p = i[u] = new Array(c), d, h = 0; h < c; ++h)
      (d = l[h] || a[h]) && (p[h] = d);
  for (; u < r; ++u)
    i[u] = e[u];
  return new sl(i, this._parents, this._name, this._id);
}
function Cge(t) {
  return (t + "").trim().split(/^|\s+/).every(function(e) {
    var n = e.indexOf(".");
    return n >= 0 && (e = e.slice(0, n)), !e || e === "start";
  });
}
function Oge(t, e, n) {
  var r, o, s = Cge(e) ? J2 : vu;
  return function() {
    var i = s(this, t), u = i.on;
    u !== r && (o = (r = u).copy()).on(e, n), i.on = o;
  };
}
function Ige(t, e) {
  var n = this._id;
  return arguments.length < 2 ? xi(this.node(), n).on.on(t) : this.each(Oge(n, t, e));
}
function Fge(t) {
  return function() {
    var e = this.parentNode;
    for (var n in this.__transition) if (+n !== t) return;
    e && e.removeChild(this);
  };
}
function Nge() {
  return this.on("end.remove", Fge(this._id));
}
function Lge(t) {
  var e = this._name, n = this._id;
  typeof t != "function" && (t = q2(t));
  for (var r = this._groups, o = r.length, s = new Array(o), i = 0; i < o; ++i)
    for (var u = r[i], l = u.length, a = s[i] = new Array(l), c, p, d = 0; d < l; ++d)
      (c = u[d]) && (p = t.call(c, c.__data__, d, u)) && ("__data__" in c && (p.__data__ = c.__data__), a[d] = p, O_(a[d], e, n, d, a, xi(c, n)));
  return new sl(s, this._parents, e, n);
}
function Bge(t) {
  var e = this._name, n = this._id;
  typeof t != "function" && (t = $4(t));
  for (var r = this._groups, o = r.length, s = [], i = [], u = 0; u < o; ++u)
    for (var l = r[u], a = l.length, c, p = 0; p < a; ++p)
      if (c = l[p]) {
        for (var d = t.call(c, c.__data__, p, l), h, m = xi(c, n), g = 0, _ = d.length; g < _; ++g)
          (h = d[g]) && O_(h, e, n, g, d, m);
        s.push(d), i.push(c);
      }
  return new sl(s, i, e, n);
}
var Uge = oy.prototype.constructor;
function Xge() {
  return new Uge(this._groups, this._parents);
}
function $ge(t, e) {
  var n, r, o;
  return function() {
    var s = mh(this, t), i = (this.style.removeProperty(t), mh(this, t));
    return s === i ? null : s === n && i === r ? o : o = e(n = s, r = i);
  };
}
function uL(t) {
  return function() {
    this.style.removeProperty(t);
  };
}
function Wge(t, e, n) {
  var r, o = n + "", s;
  return function() {
    var i = mh(this, t);
    return i === o ? null : i === r ? s : s = e(r = i, n);
  };
}
function Vge(t, e, n) {
  var r, o, s;
  return function() {
    var i = mh(this, t), u = n(this), l = u + "";
    return u == null && (l = u = (this.style.removeProperty(t), mh(this, t))), i === l ? null : i === r && l === o ? s : (o = l, s = e(r = i, u));
  };
}
function Hge(t, e) {
  var n, r, o, s = "style." + e, i = "end." + s, u;
  return function() {
    var l = vu(this, t), a = l.on, c = l.value[s] == null ? u || (u = uL(e)) : void 0;
    (a !== n || o !== c) && (r = (n = a).copy()).on(i, o = c), l.on = r;
  };
}
function jge(t, e, n) {
  var r = (t += "") == "transform" ? Gye : iL;
  return e == null ? this.styleTween(t, $ge(t, r)).on("end.style." + t, uL(t)) : typeof e == "function" ? this.styleTween(t, Vge(t, r, eS(this, "style." + t, e))).each(Hge(this._id, t)) : this.styleTween(t, Wge(t, r, e), n).on("end.style." + t, null);
}
function zge(t, e, n) {
  return function(r) {
    this.style.setProperty(t, e.call(this, r), n);
  };
}
function qge(t, e, n) {
  var r, o;
  function s() {
    var i = e.apply(this, arguments);
    return i !== o && (r = (o = i) && zge(t, i, n)), r;
  }
  return s._value = e, s;
}
function Gge(t, e, n) {
  var r = "style." + (t += "");
  if (arguments.length < 2) return (r = this.tween(r)) && r._value;
  if (e == null) return this.tween(r, null);
  if (typeof e != "function") throw new Error();
  return this.tween(r, qge(t, e, n ?? ""));
}
function Yge(t) {
  return function() {
    this.textContent = t;
  };
}
function Qge(t) {
  return function() {
    var e = t(this);
    this.textContent = e ?? "";
  };
}
function Kge(t) {
  return this.tween("text", typeof t == "function" ? Qge(eS(this, "text", t)) : Yge(t == null ? "" : t + ""));
}
function Zge(t) {
  return function(e) {
    this.textContent = t.call(this, e);
  };
}
function Jge(t) {
  var e, n;
  function r() {
    var o = t.apply(this, arguments);
    return o !== n && (e = (n = o) && Zge(o)), e;
  }
  return r._value = t, r;
}
function e0e(t) {
  var e = "text";
  if (arguments.length < 1) return (e = this.tween(e)) && e._value;
  if (t == null) return this.tween(e, null);
  if (typeof t != "function") throw new Error();
  return this.tween(e, Jge(t));
}
function t0e() {
  for (var t = this._name, e = this._id, n = lL(), r = this._groups, o = r.length, s = 0; s < o; ++s)
    for (var i = r[s], u = i.length, l, a = 0; a < u; ++a)
      if (l = i[a]) {
        var c = xi(l, e);
        O_(l, t, n, a, i, {
          time: c.time + c.delay + c.duration,
          delay: 0,
          duration: c.duration,
          ease: c.ease
        });
      }
  return new sl(r, this._parents, t, n);
}
function n0e() {
  var t, e, n = this, r = n._id, o = n.size();
  return new Promise(function(s, i) {
    var u = { value: i }, l = { value: function() {
      --o === 0 && s();
    } };
    n.each(function() {
      var a = vu(this, r), c = a.on;
      c !== t && (e = (t = c).copy(), e._.cancel.push(u), e._.interrupt.push(u), e._.end.push(l)), a.on = e;
    }), o === 0 && s();
  });
}
var r0e = 0;
function sl(t, e, n, r) {
  this._groups = t, this._parents = e, this._name = n, this._id = r;
}
function lL() {
  return ++r0e;
}
var Uu = oy.prototype;
sl.prototype = {
  constructor: sl,
  select: Lge,
  selectAll: Bge,
  selectChild: Uu.selectChild,
  selectChildren: Uu.selectChildren,
  filter: Mge,
  merge: Pge,
  selection: Xge,
  transition: t0e,
  call: Uu.call,
  nodes: Uu.nodes,
  node: Uu.node,
  size: Uu.size,
  empty: Uu.empty,
  each: Uu.each,
  on: Ige,
  attr: fge,
  attrTween: _ge,
  style: jge,
  styleTween: Gge,
  text: Kge,
  textTween: e0e,
  remove: Nge,
  tween: ige,
  delay: kge,
  duration: Sge,
  ease: Age,
  easeVarying: Ege,
  end: n0e,
  [Symbol.iterator]: Uu[Symbol.iterator]
};
function o0e(t) {
  return ((t *= 2) <= 1 ? t * t * t : (t -= 2) * t * t + 2) / 2;
}
var s0e = {
  time: null,
  // Set on use.
  delay: 0,
  duration: 250,
  ease: o0e
};
function a0e(t, e) {
  for (var n; !(n = t.__transition) || !(n = n[e]); )
    if (!(t = t.parentNode))
      throw new Error(`transition ${e} not found`);
  return n;
}
function i0e(t) {
  var e, n;
  t instanceof sl ? (e = t._id, t = t._name) : (e = lL(), (n = s0e).time = Z2(), t = t == null ? null : t + "");
  for (var r = this._groups, o = r.length, s = 0; s < o; ++s)
    for (var i = r[s], u = i.length, l, a = 0; a < u; ++a)
      (l = i[a]) && O_(l, t, e, a, i, n || a0e(l, e));
  return new sl(r, this._parents, t, e);
}
oy.prototype.interrupt = oge;
oy.prototype.transition = i0e;
function u0e(t) {
  return Math.abs(t = Math.round(t)) >= 1e21 ? t.toLocaleString("en").replace(/,/g, "") : t.toString(10);
}
function J0(t, e) {
  if ((n = (t = e ? t.toExponential(e - 1) : t.toExponential()).indexOf("e")) < 0) return null;
  var n, r = t.slice(0, n);
  return [
    r.length > 1 ? r[0] + r.slice(2) : r,
    +t.slice(n + 1)
  ];
}
function gh(t) {
  return t = J0(Math.abs(t)), t ? t[1] : NaN;
}
function l0e(t, e) {
  return function(n, r) {
    for (var o = n.length, s = [], i = 0, u = t[0], l = 0; o > 0 && u > 0 && (l + u + 1 > r && (u = Math.max(1, r - l)), s.push(n.substring(o -= u, o + u)), !((l += u + 1) > r)); )
      u = t[i = (i + 1) % t.length];
    return s.reverse().join(e);
  };
}
function c0e(t) {
  return function(e) {
    return e.replace(/[0-9]/g, function(n) {
      return t[+n];
    });
  };
}
var p0e = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
function ev(t) {
  if (!(e = p0e.exec(t))) throw new Error("invalid format: " + t);
  var e;
  return new tS({
    fill: e[1],
    align: e[2],
    sign: e[3],
    symbol: e[4],
    zero: e[5],
    width: e[6],
    comma: e[7],
    precision: e[8] && e[8].slice(1),
    trim: e[9],
    type: e[10]
  });
}
ev.prototype = tS.prototype;
function tS(t) {
  this.fill = t.fill === void 0 ? " " : t.fill + "", this.align = t.align === void 0 ? ">" : t.align + "", this.sign = t.sign === void 0 ? "-" : t.sign + "", this.symbol = t.symbol === void 0 ? "" : t.symbol + "", this.zero = !!t.zero, this.width = t.width === void 0 ? void 0 : +t.width, this.comma = !!t.comma, this.precision = t.precision === void 0 ? void 0 : +t.precision, this.trim = !!t.trim, this.type = t.type === void 0 ? "" : t.type + "";
}
tS.prototype.toString = function() {
  return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === void 0 ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === void 0 ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
};
function d0e(t) {
  e: for (var e = t.length, n = 1, r = -1, o; n < e; ++n)
    switch (t[n]) {
      case ".":
        r = o = n;
        break;
      case "0":
        r === 0 && (r = n), o = n;
        break;
      default:
        if (!+t[n]) break e;
        r > 0 && (r = 0);
        break;
    }
  return r > 0 ? t.slice(0, r) + t.slice(o + 1) : t;
}
var cL;
function h0e(t, e) {
  var n = J0(t, e);
  if (!n) return t + "";
  var r = n[0], o = n[1], s = o - (cL = Math.max(-8, Math.min(8, Math.floor(o / 3))) * 3) + 1, i = r.length;
  return s === i ? r : s > i ? r + new Array(s - i + 1).join("0") : s > 0 ? r.slice(0, s) + "." + r.slice(s) : "0." + new Array(1 - s).join("0") + J0(t, Math.max(0, e + s - 1))[0];
}
function AM(t, e) {
  var n = J0(t, e);
  if (!n) return t + "";
  var r = n[0], o = n[1];
  return o < 0 ? "0." + new Array(-o).join("0") + r : r.length > o + 1 ? r.slice(0, o + 1) + "." + r.slice(o + 1) : r + new Array(o - r.length + 2).join("0");
}
const DM = {
  "%": (t, e) => (t * 100).toFixed(e),
  b: (t) => Math.round(t).toString(2),
  c: (t) => t + "",
  d: u0e,
  e: (t, e) => t.toExponential(e),
  f: (t, e) => t.toFixed(e),
  g: (t, e) => t.toPrecision(e),
  o: (t) => Math.round(t).toString(8),
  p: (t, e) => AM(t * 100, e),
  r: AM,
  s: h0e,
  X: (t) => Math.round(t).toString(16).toUpperCase(),
  x: (t) => Math.round(t).toString(16)
};
function EM(t) {
  return t;
}
var MM = Array.prototype.map, PM = ["y", "z", "a", "f", "p", "n", "µ", "m", "", "k", "M", "G", "T", "P", "E", "Z", "Y"];
function f0e(t) {
  var e = t.grouping === void 0 || t.thousands === void 0 ? EM : l0e(MM.call(t.grouping, Number), t.thousands + ""), n = t.currency === void 0 ? "" : t.currency[0] + "", r = t.currency === void 0 ? "" : t.currency[1] + "", o = t.decimal === void 0 ? "." : t.decimal + "", s = t.numerals === void 0 ? EM : c0e(MM.call(t.numerals, String)), i = t.percent === void 0 ? "%" : t.percent + "", u = t.minus === void 0 ? "−" : t.minus + "", l = t.nan === void 0 ? "NaN" : t.nan + "";
  function a(p) {
    p = ev(p);
    var d = p.fill, h = p.align, m = p.sign, g = p.symbol, _ = p.zero, b = p.width, x = p.comma, S = p.precision, E = p.trim, A = p.type;
    A === "n" ? (x = !0, A = "g") : DM[A] || (S === void 0 && (S = 12), E = !0, A = "g"), (_ || d === "0" && h === "=") && (_ = !0, d = "0", h = "=");
    var C = g === "$" ? n : g === "#" && /[boxX]/.test(A) ? "0" + A.toLowerCase() : "", M = g === "$" ? r : /[%p]/.test(A) ? i : "", L = DM[A], X = /[defgprs%]/.test(A);
    S = S === void 0 ? 6 : /[gprs]/.test(A) ? Math.max(1, Math.min(21, S)) : Math.max(0, Math.min(20, S));
    function te(B) {
      var W = C, G = M, ne, de, V;
      if (A === "c")
        G = L(B) + G, B = "";
      else {
        B = +B;
        var Y = B < 0 || 1 / B < 0;
        if (B = isNaN(B) ? l : L(Math.abs(B), S), E && (B = d0e(B)), Y && +B == 0 && m !== "+" && (Y = !1), W = (Y ? m === "(" ? m : u : m === "-" || m === "(" ? "" : m) + W, G = (A === "s" ? PM[8 + cL / 3] : "") + G + (Y && m === "(" ? ")" : ""), X) {
          for (ne = -1, de = B.length; ++ne < de; )
            if (V = B.charCodeAt(ne), 48 > V || V > 57) {
              G = (V === 46 ? o + B.slice(ne + 1) : B.slice(ne)) + G, B = B.slice(0, ne);
              break;
            }
        }
      }
      x && !_ && (B = e(B, 1 / 0));
      var Q = W.length + B.length + G.length, ae = Q < b ? new Array(b - Q + 1).join(d) : "";
      switch (x && _ && (B = e(ae + B, ae.length ? b - G.length : 1 / 0), ae = ""), h) {
        case "<":
          B = W + B + G + ae;
          break;
        case "=":
          B = W + ae + B + G;
          break;
        case "^":
          B = ae.slice(0, Q = ae.length >> 1) + W + B + G + ae.slice(Q);
          break;
        default:
          B = ae + W + B + G;
          break;
      }
      return s(B);
    }
    return te.toString = function() {
      return p + "";
    }, te;
  }
  function c(p, d) {
    var h = a((p = ev(p), p.type = "f", p)), m = Math.max(-8, Math.min(8, Math.floor(gh(d) / 3))) * 3, g = Math.pow(10, -m), _ = PM[8 + m / 3];
    return function(b) {
      return h(g * b) + _;
    };
  }
  return {
    format: a,
    formatPrefix: c
  };
}
var cg, pL, dL;
m0e({
  thousands: ",",
  grouping: [3],
  currency: ["$", ""]
});
function m0e(t) {
  return cg = f0e(t), pL = cg.format, dL = cg.formatPrefix, cg;
}
function y0e(t) {
  return Math.max(0, -gh(Math.abs(t)));
}
function g0e(t, e) {
  return Math.max(0, Math.max(-8, Math.min(8, Math.floor(gh(e) / 3))) * 3 - gh(Math.abs(t)));
}
function v0e(t, e) {
  return t = Math.abs(t), e = Math.abs(e) - t, Math.max(0, gh(e) - gh(t)) + 1;
}
function _0e(t, e) {
  switch (arguments.length) {
    case 0:
      break;
    case 1:
      this.range(t);
      break;
    default:
      this.range(e).domain(t);
      break;
  }
  return this;
}
function w0e(t) {
  return function() {
    return t;
  };
}
function b0e(t) {
  return +t;
}
var CM = [0, 1];
function pg(t) {
  return t;
}
function jk(t, e) {
  return (e -= t = +t) ? function(n) {
    return (n - t) / e;
  } : w0e(isNaN(e) ? NaN : 0.5);
}
function k0e(t, e) {
  var n;
  return t > e && (n = t, t = e, e = n), function(r) {
    return Math.max(t, Math.min(e, r));
  };
}
function T0e(t, e, n) {
  var r = t[0], o = t[1], s = e[0], i = e[1];
  return o < r ? (r = jk(o, r), s = n(i, s)) : (r = jk(r, o), s = n(s, i)), function(u) {
    return s(r(u));
  };
}
function x0e(t, e, n) {
  var r = Math.min(t.length, e.length) - 1, o = new Array(r), s = new Array(r), i = -1;
  for (t[r] < t[0] && (t = t.slice().reverse(), e = e.slice().reverse()); ++i < r; )
    o[i] = jk(t[i], t[i + 1]), s[i] = n(e[i], e[i + 1]);
  return function(u) {
    var l = Ffe(t, u, 1, r) - 1;
    return s[l](o[l](u));
  };
}
function S0e(t, e) {
  return e.domain(t.domain()).range(t.range()).interpolate(t.interpolate()).clamp(t.clamp()).unknown(t.unknown());
}
function R0e() {
  var t = CM, e = CM, n = K2, r, o, s, i = pg, u, l, a;
  function c() {
    var d = Math.min(t.length, e.length);
    return i !== pg && (i = k0e(t[0], t[d - 1])), u = d > 2 ? x0e : T0e, l = a = null, p;
  }
  function p(d) {
    return d == null || isNaN(d = +d) ? s : (l || (l = u(t.map(r), e, n)))(r(i(d)));
  }
  return p.invert = function(d) {
    return i(o((a || (a = u(e, t.map(r), si)))(d)));
  }, p.domain = function(d) {
    return arguments.length ? (t = Array.from(d, b0e), c()) : t.slice();
  }, p.range = function(d) {
    return arguments.length ? (e = Array.from(d), c()) : e.slice();
  }, p.rangeRound = function(d) {
    return e = Array.from(d), n = jye, c();
  }, p.clamp = function(d) {
    return arguments.length ? (i = d ? !0 : pg, c()) : i !== pg;
  }, p.interpolate = function(d) {
    return arguments.length ? (n = d, c()) : n;
  }, p.unknown = function(d) {
    return arguments.length ? (s = d, p) : s;
  }, function(d, h) {
    return r = d, o = h, c();
  };
}
function A0e(t, e, n, r) {
  var o = Xfe(t, e, n), s;
  switch (r = ev(r ?? ",f"), r.type) {
    case "s": {
      var i = Math.max(Math.abs(t), Math.abs(e));
      return r.precision == null && !isNaN(s = g0e(o, i)) && (r.precision = s), dL(r, i);
    }
    case "":
    case "e":
    case "g":
    case "p":
    case "r": {
      r.precision == null && !isNaN(s = v0e(o, Math.max(Math.abs(t), Math.abs(e)))) && (r.precision = s - (r.type === "e"));
      break;
    }
    case "f":
    case "%": {
      r.precision == null && !isNaN(s = y0e(o)) && (r.precision = s - (r.type === "%") * 2);
      break;
    }
  }
  return pL(r);
}
function D0e(t) {
  var e = t.domain;
  return t.ticks = function(n) {
    var r = e();
    return Ufe(r[0], r[r.length - 1], n ?? 10);
  }, t.tickFormat = function(n, r) {
    var o = e();
    return A0e(o[0], o[o.length - 1], n ?? 10, r);
  }, t.nice = function(n) {
    n == null && (n = 10);
    var r = e(), o = 0, s = r.length - 1, i = r[o], u = r[s], l, a, c = 10;
    for (u < i && (a = i, i = u, u = a, a = o, o = s, s = a); c-- > 0; ) {
      if (a = Lk(i, u, n), a === l)
        return r[o] = i, r[s] = u, e(r);
      if (a > 0)
        i = Math.floor(i / a) * a, u = Math.ceil(u / a) * a;
      else if (a < 0)
        i = Math.ceil(i * a) / a, u = Math.floor(u * a) / a;
      else
        break;
      l = a;
    }
    return t;
  }, t;
}
function OM(t) {
  return function(e) {
    return Math.sign(e) * Math.log1p(Math.abs(e / t));
  };
}
function IM(t) {
  return function(e) {
    return Math.sign(e) * Math.expm1(Math.abs(e)) * t;
  };
}
function E0e(t) {
  var e = 1, n = t(OM(e), IM(e));
  return n.constant = function(r) {
    return arguments.length ? t(OM(e = +r), IM(e)) : e;
  }, D0e(n);
}
function hL() {
  var t = E0e(R0e());
  return t.copy = function() {
    return S0e(t, hL()).constant(t.constant());
  }, _0e.apply(t, arguments);
}
function Nf(t, e, n) {
  this.k = t, this.x = e, this.y = n;
}
Nf.prototype = {
  constructor: Nf,
  scale: function(t) {
    return t === 1 ? this : new Nf(this.k * t, this.x, this.y);
  },
  translate: function(t, e) {
    return t === 0 & e === 0 ? this : new Nf(this.k, this.x + this.k * t, this.y + this.k * e);
  },
  apply: function(t) {
    return [t[0] * this.k + this.x, t[1] * this.k + this.y];
  },
  applyX: function(t) {
    return t * this.k + this.x;
  },
  applyY: function(t) {
    return t * this.k + this.y;
  },
  invert: function(t) {
    return [(t[0] - this.x) / this.k, (t[1] - this.y) / this.k];
  },
  invertX: function(t) {
    return (t - this.x) / this.k;
  },
  invertY: function(t) {
    return (t - this.y) / this.k;
  },
  rescaleX: function(t) {
    return t.copy().domain(t.range().map(this.invertX, this).map(t.invert, t));
  },
  rescaleY: function(t) {
    return t.copy().domain(t.range().map(this.invertY, this).map(t.invert, t));
  },
  toString: function() {
    return "translate(" + this.x + "," + this.y + ") scale(" + this.k + ")";
  }
};
Nf.prototype;
const Cc = /* @__PURE__ */ U({
  __name: "DurationIconText",
  props: {
    duration: {}
  },
  setup(t) {
    const e = t, n = D(() => fc(e.duration)), r = D(() => ({
      label: {
        "duration-icon-text__label--none": e.duration === 0
      }
    }));
    return (o, s) => {
      const i = P("p-icon-text");
      return T(), O(i, {
        icon: "ClockIcon",
        class: "duration-icon-text"
      }, {
        default: k(() => [
          re("span", {
            class: Bt(["duration-icon-text__label", r.value.label])
          }, ie(n.value), 3)
        ]),
        _: 1
      });
    };
  }
}), M0e = {
  key: 0,
  class: "flow-router-link"
}, P0e = { key: 0 }, C0e = { key: 0 }, tv = /* @__PURE__ */ U({
  __name: "FlowRouterLink",
  props: {
    flowId: {},
    before: {},
    after: {}
  },
  setup(t) {
    const e = t, n = Ke(), r = je(), o = kc(), s = rs(), i = D(() => s.resolve(r.flow(e.flowId))), u = D(() => o.matched.some(({ path: d }) => i.value.path == d)), l = D(() => n.read.flow && !u.value), a = D(() => l.value ? e.flowId : null), { flow: c } = Ec(a), p = D(() => c.value?.name ?? "");
    return (d, h) => {
      const m = P("p-link");
      return a.value ? (T(), z("span", M0e, [
        Ve(d.$slots, "before", {}, () => [
          d.before ? (T(), z("span", P0e, ie(d.before), 1)) : j("", !0)
        ]),
        w(m, {
          class: "flow-router-link__anchor",
          to: v(r).flow(a.value)
        }, {
          default: k(() => [
            Ve(d.$slots, "default", {}, () => [
              q(ie(p.value), 1)
            ])
          ]),
          _: 3
        }, 8, ["to"]),
        Ve(d.$slots, "after", {}, () => [
          d.after ? (T(), z("span", C0e, ie(d.after), 1)) : j("", !0)
        ])
      ])) : j("", !0);
    };
  }
}), O0e = { class: "flow-run-bread-crumbs" }, nS = /* @__PURE__ */ U({
  __name: "FlowRunBreadCrumbs",
  props: {
    flowRun: {},
    hideFlowName: { type: Boolean }
  },
  setup(t) {
    const e = t, n = je(), r = Jj("flowRunId"), o = D(() => r.value && e.flowRun.id === r.value ? "span" : "p-link");
    return (s, i) => {
      const u = P("p-icon");
      return T(), z("div", O0e, [
        s.hideFlowName ? j("", !0) : (T(), O(tv, {
          key: 0,
          "flow-id": s.flowRun.flowId,
          class: "flow-run-bread-crumbs__flow-link"
        }, {
          after: k(() => [
            w(u, {
              icon: "ChevronRightIcon",
              size: "small"
            })
          ]),
          _: 1
        }, 8, ["flow-id"])),
        (T(), O(Mr(o.value), {
          to: v(n).flowRun(s.flowRun.id),
          class: "flow-run-bread-crumbs__flow-run-link"
        }, {
          default: k(() => [
            re("span", null, ie(s.flowRun.name), 1)
          ]),
          _: 1
        }, 8, ["to"]))
      ]);
    };
  }
}), ay = /* @__PURE__ */ U({
  __name: "FlowRunStartTime",
  props: {
    flowRun: {}
  },
  setup(t) {
    return (e, n) => {
      const r = P("p-icon-text");
      return T(), O(r, {
        class: "flow-run-list-item-date",
        icon: "CalendarIcon"
      }, {
        default: k(() => [
          e.flowRun.startTime ? (T(), O(hn, {
            key: 0,
            date: e.flowRun.startTime,
            format: "numeric"
          }, {
            default: k(({ date: o }) => [
              q(ie(o) + " " + ie(e.flowRun.delta), 1)
            ]),
            _: 1
          }, 8, ["date"])) : e.flowRun.expectedStartTime ? (T(), O(hn, {
            key: 1,
            date: e.flowRun.expectedStartTime,
            format: "numeric"
          }, {
            default: k(({ date: o }) => [
              q(" Scheduled for " + ie(o) + " " + ie(e.flowRun.delta), 1)
            ]),
            _: 1
          }, 8, ["date"])) : (T(), z(ve, { key: 2 }, [
            q(" No start time ")
          ], 64))
        ]),
        _: 1
      });
    };
  }
}), I0e = {
  key: 0,
  class: "flow-run-popover-content"
}, F0e = { class: "flow-run-popover-content__aside" }, rS = /* @__PURE__ */ U({
  __name: "FlowRunPopOverContent",
  props: {
    flowRunId: {}
  },
  setup(t) {
    const e = t, { flowRun: n } = yl(() => e.flowRunId), r = D(() => n.value?.tags ?? []);
    return (o, s) => {
      const i = P("p-divider"), u = P("p-tags");
      return v(n) ? (T(), z("article", I0e, [
        w(nS, { "flow-run": v(n) }, null, 8, ["flow-run"]),
        w(Dr, {
          state: v(n).state,
          class: "max-w-fit"
        }, null, 8, ["state"]),
        w(i),
        re("aside", F0e, [
          v(n).deploymentId ? (T(), O($h, {
            key: 0,
            "deployment-id": v(n).deploymentId
          }, null, 8, ["deployment-id"])) : j("", !0),
          v(n).duration ? (T(), O(Cc, {
            key: 1,
            duration: v(n).duration
          }, null, 8, ["duration"])) : j("", !0),
          w(ay, { "flow-run": v(n) }, null, 8, ["flow-run"]),
          w(u, {
            class: "flow-run-popover-content__tags",
            tags: r.value
          }, null, 8, ["tags"])
        ])
      ])) : j("", !0);
    };
  }
}), N0e = ["onMouseover"], L0e = {
  key: 0,
  class: "flow-runs-bar-chart__pop-over"
}, FM = "flow-runs-bar-chart-pop-over", Vh = /* @__PURE__ */ U({
  __name: "FlowRunsBarChart",
  props: {
    filter: { type: Function },
    mini: { type: Boolean }
  },
  setup(t) {
    const e = t, n = D(() => e.mini ? 6 : 12), r = [qr.bottom, qr.right, qr.left, qr.top], { close: o } = Bj(FM), s = ge(), { width: i, height: u } = UI(s), l = D(() => Math.floor(i.value / n.value)), a = ns(l, 1e3), c = D(() => ({
      root: `grid-template-columns: repeat(${l.value}, 1fr)`
    })), p = D(() => ({
      root: {
        "flow-runs-bar-chart--mini": e.mini
      }
    })), d = () => {
      if (isNaN(a.value) || a.value === 0)
        return null;
      const A = Qe(e.filter), C = {
        limit: a.value,
        sort: "START_TIME_DESC"
      };
      return $t({}, A, C);
    }, { flowRuns: h } = Qp(d), m = D(() => E(h.value).slice(-l.value)), g = D(() => h.value.reduce((A, C) => C.duration > A ? C.duration : A, 0)), _ = D(() => {
      const A = hL();
      return A.domain([0, g.value]), A.range([0, u.value]), A;
    });
    function b(A) {
      if (A)
        return [
          `bg-state-${A.stateType}-500`,
          "flow-runs-bar-chart__bar-flow-run"
        ];
    }
    function x(A) {
      return A ? {
        height: Uj(_.value(A.duration))
      } : "";
    }
    function S(A, C) {
      return A ? A.id : `${C}`;
    }
    function E(A) {
      const { expectedStartTimeAfter: C, expectedStartTimeBefore: M } = Qe(e.filter).flowRuns ?? {};
      if (!M || !C)
        return [];
      const X = (M.getTime() - C.getTime()) / l.value, te = new Array(l.value).fill(null), B = te.length - 1, W = M.getTime() > (/* @__PURE__ */ new Date()).getTime(), G = W ? 1 : -1, ne = W ? A.sort((V, Y) => {
        const Q = V.startTime ?? V.expectedStartTime, ae = Y.startTime ?? Y.expectedStartTime;
        return !Q || !ae ? 0 : Q.getTime() - ae.getTime();
      }) : A;
      function de(V) {
        return V < 0 ? null : te[V] ? de(V + G) : V;
      }
      return ne.forEach((V) => {
        const Y = V.startTime ?? V.expectedStartTime;
        if (!Y)
          return;
        const Q = Math.min(Math.floor((Y.getTime() - C.getTime()) / X), B), ae = de(Q);
        ae !== null && (te[ae] = V);
      }), te;
    }
    return (A, C) => {
      const M = P("p-pop-over");
      return T(), z("div", {
        ref_key: "chart",
        ref: s,
        class: Bt(["flow-runs-bar-chart", p.value.root]),
        style: b0(c.value.root),
        onMouseleave: C[0] || (C[0] = //@ts-ignore
        (...L) => v(o) && v(o)(...L))
      }, [
        (T(!0), z(ve, null, ln(m.value, (L, X) => (T(), O(M, {
          key: S(L, X),
          class: "flow-runs-bar-chart__bar-container",
          to: s.value,
          placement: r,
          group: FM,
          "auto-close": ""
        }, {
          target: k(({ open: te }) => [
            re("div", {
              class: Bt(["flow-runs-bar-chart__bar", b(L)]),
              style: b0(x(L)),
              onMouseover: te
            }, null, 46, N0e)
          ]),
          default: k(() => [
            L ? (T(), z("div", L0e, [
              w(rS, {
                "flow-run-id": L.id
              }, null, 8, ["flow-run-id"])
            ])) : j("", !0)
          ]),
          _: 2
        }, 1032, ["to"]))), 128))
      ], 38);
    };
  }
}), B0e = {
  key: 0,
  class: "work-pool-average-late-time"
}, U0e = /* @__PURE__ */ U({
  __name: "WorkPoolAverageLateTime",
  props: {
    workPool: {},
    filter: { type: Function }
  },
  setup(t) {
    const e = t, n = Xa(), r = () => {
      const s = Qe(e.filter), i = {
        workPools: {
          id: [e.workPool.id]
        }
      };
      return $t({}, s, i);
    }, { lateness: o } = dse(r, n);
    return (s, i) => v(o) ? (T(), z("span", B0e, " (" + ie(v(fc)(v(o))) + " avg.) ", 1)) : j("", !0);
  }
}), X0e = { class: "work-pool-last-polled" }, $0e = {
  key: 1,
  class: "work-pool-last-polled__no-poll"
}, W0e = /* @__PURE__ */ U({
  __name: "WorkPoolLastPolled",
  props: {
    workPool: {}
  },
  setup(t) {
    const e = t, n = Xa(), r = D(() => e.workPool.name), { lastPolled: o } = SN(r, n);
    return (s, i) => (T(), z("span", X0e, [
      v(o) ? (T(), z(ve, { key: 0 }, [
        q(ie(v(o)), 1)
      ], 64)) : (T(), z("span", $0e, "N/A"))
    ]));
  }
}), V0e = { class: "work-pool-queue-status-array" }, H0e = {
  key: 1,
  class: "work-pool-queue-status-array__none"
}, j0e = {
  key: 2,
  class: "work-pool-queue-status-array__too-many"
}, NM = 50, z0e = /* @__PURE__ */ U({
  __name: "WorkPoolQueueStatusArray",
  props: {
    workPool: {}
  },
  setup(t) {
    const e = t, n = Se(), r = Xa(), o = mt(
      n.workPoolQueues.getWorkPoolQueues,
      [e.workPool.name, { limit: NM + 1 }],
      r
    ), s = D(() => o.response ?? []), i = D(() => s.value.length > NM);
    return (u, l) => (T(), z("div", V0e, [
      !i.value && s.value.length > 0 ? (T(!0), z(ve, { key: 0 }, ln(s.value, (a) => (T(), O(D_, {
        key: a.id,
        "work-pool-queue": a
      }, null, 8, ["work-pool-queue"]))), 128)) : j("", !0),
      !i.value && s.value.length < 1 ? (T(), z("span", H0e, "N/A")) : j("", !0),
      i.value ? (T(), z("span", j0e, "Too many to show here.")) : j("", !0)
    ]));
  }
}), q0e = {
  type: "button",
  class: "work-pool-status-icon"
}, I_ = /* @__PURE__ */ U({
  __name: "WorkPoolStatusIcon",
  props: {
    workPool: {}
  },
  setup(t) {
    const e = t, n = D(() => e.workPool.status), r = D(() => {
      switch (n.value) {
        case "ready":
          return e.workPool.isPushPool ? "Work pool is ready." : "Work pool has at least one online worker ready to execute work.";
        case "not_ready":
          return "Work pool does not have any online workers ready to execute work.";
        case "paused":
          return "Work pool is paused. No work will be executed.";
        default:
          return "";
      }
    });
    return (o, s) => {
      const i = P("p-icon"), u = P("p-tooltip");
      return n.value ? (T(), O(u, {
        key: 0,
        text: r.value
      }, {
        default: k(() => [
          re("button", q0e, [
            n.value !== "paused" ? (T(), O(A_, {
              key: 0,
              status: n.value
            }, null, 8, ["status"])) : j("", !0),
            n.value === "paused" ? (T(), O(i, {
              key: 1,
              icon: "PauseCircleIcon",
              size: "small",
              class: "work-pool-status-icon--paused"
            })) : j("", !0)
          ])
        ]),
        _: 1
      }, 8, ["text"])) : j("", !0);
    };
  }
}), G0e = { class: "dashboard-work-pool-card" }, Y0e = { class: "dashboard-work-pool-card__header" }, Q0e = { class: "dashboard-work-pool-card__name" }, K0e = { class: "dashboard-work-pool-card__details" }, Z0e = { class: "dashboard-work-pool-card__late-runs" }, J0e = /* @__PURE__ */ U({
  __name: "DashboardWorkPoolCard",
  props: {
    workPool: {},
    filter: {}
  },
  setup(t) {
    const e = t, n = je(), r = () => {
      const o = ye.map("WorkspaceDashboardFilter", e.filter, "FlowRunsFilter"), s = {
        workPools: {
          id: [e.workPool.id]
        }
      };
      return $t({}, o, s);
    };
    return (o, s) => {
      const i = P("p-link");
      return T(), z("div", G0e, [
        re("div", Y0e, [
          re("div", Q0e, [
            w(i, {
              to: v(n).workPool(o.workPool.name)
            }, {
              default: k(() => [
                q(ie(o.workPool.name), 1)
              ]),
              _: 1
            }, 8, ["to"]),
            w(I_, { "work-pool": o.workPool }, null, 8, ["work-pool"])
          ]),
          w(Vh, {
            class: "dashboard-work-pool-card__mini-bars",
            mini: "",
            filter: r
          }),
          w(Efe, {
            "work-pool": o.workPool,
            filter: r
          }, null, 8, ["work-pool"])
        ]),
        re("dl", K0e, [
          w(ag, { label: "Polled" }, {
            default: k(() => [
              w(W0e, { "work-pool": o.workPool }, null, 8, ["work-pool"])
            ]),
            _: 1
          }),
          w(ag, { label: "Work Queues" }, {
            default: k(() => [
              w(z0e, { "work-pool": o.workPool }, null, 8, ["work-pool"])
            ]),
            _: 1
          }),
          w(ag, { label: "Late runs" }, {
            default: k(() => [
              re("div", Z0e, [
                w(Mfe, {
                  "work-pool": o.workPool,
                  filter: r
                }, null, 8, ["work-pool"]),
                w(U0e, {
                  "work-pool": o.workPool,
                  filter: r
                }, null, 8, ["work-pool"])
              ])
            ]),
            _: 1
          }),
          w(ag, { label: "Completed" }, {
            default: k(() => [
              w(Dfe, {
                "work-pool": o.workPool,
                filter: r
              }, null, 8, ["work-pool"])
            ]),
            _: 1
          })
        ])
      ]);
    };
  }
}), eve = { class: "dashboard-work-pools-card__list" }, tve = {
  key: 0,
  class: "dashboard-work-pools-card__empty"
}, nve = /* @__PURE__ */ U({
  __name: "DashboardWorkPoolsCard",
  props: {
    filter: {}
  },
  setup(t) {
    const e = ise(), n = je(), r = Se(), o = mt(r.workPools.getWorkPools, [], e), s = D(() => (o.response ?? []).filter((l) => !l.isPaused)), i = D(() => o.response && s.value.length === 0);
    return (u, l) => {
      const a = P("p-heading"), c = P("p-link"), p = P("p-card");
      return T(), O(p, { class: "dashboard-work-pools-card" }, {
        default: k(() => [
          w(a, {
            heading: "5",
            class: "dashboard-work-pools-card__heading"
          }, {
            default: k(() => [
              re("span", null, ie(v(le).info.dashboardWorkPoolCardTitle), 1)
            ]),
            _: 1
          }),
          re("div", eve, [
            (T(!0), z(ve, null, ln(s.value, (d) => (T(), O(J0e, {
              key: d.id,
              "work-pool": d,
              filter: u.filter
            }, null, 8, ["work-pool", "filter"]))), 128))
          ]),
          i.value ? (T(), z("div", tve, [
            re("p", null, ie(v(le).info.dashboardWorkPoolCardEmpty), 1),
            w(c, {
              to: v(n).workPools()
            }, {
              default: k(() => [
                q(ie(v(le).info.dashboardWorkPoolCardViewAll), 1)
              ]),
              _: 1
            }, 8, ["to"])
          ])) : j("", !0)
        ]),
        _: 1
      });
    };
  }
}), rve = /* @__PURE__ */ U({
  __name: "DateRangeInput",
  props: {
    startDate: {},
    endDate: {},
    viewingDate: {}
  },
  emits: ["update:startDate", "update:endDate", "update:viewingDate"],
  setup(t, { emit: e }) {
    const n = t, r = e, o = D({
      get() {
        return n.startDate ? Zs(n.startDate) : null;
      },
      set(u) {
        r("update:startDate", u ? ci(u) : null);
      }
    }), s = D({
      get() {
        return n.endDate ? Zs(n.endDate) : null;
      },
      set(u) {
        r("update:endDate", u ? ci(u) : null);
      }
    }), i = D({
      get() {
        return n.viewingDate ? Zs(n.viewingDate) : void 0;
      },
      set(u) {
        r("update:viewingDate", u ? ci(u) : void 0);
      }
    });
    return (u, l) => {
      const a = P("p-date-range-input");
      return T(), O(a, {
        startDate: o.value,
        "onUpdate:startDate": l[0] || (l[0] = (c) => o.value = c),
        endDate: s.value,
        "onUpdate:endDate": l[1] || (l[1] = (c) => s.value = c),
        viewingDate: i.value,
        "onUpdate:viewingDate": l[2] || (l[2] = (c) => i.value = c)
      }, {
        date: k(({ date: c }) => [
          Ve(u.$slots, "default", { date: c })
        ]),
        _: 3
      }, 8, ["startDate", "endDate", "viewingDate"]);
    };
  }
}), fL = /* @__PURE__ */ U({
  __name: "DateRangeSelect",
  props: {
    modelValue: {}
  },
  emits: ["update:modelValue"],
  setup(t, { emit: e }) {
    const n = t, r = e, o = D({
      get() {
        return n.modelValue?.type === "range" ? {
          type: "range",
          startDate: Zs(n.modelValue.startDate),
          endDate: Zs(n.modelValue.endDate)
        } : n.modelValue;
      },
      set(s) {
        if (s?.type === "range") {
          r("update:modelValue", {
            type: "range",
            startDate: ci(s.startDate),
            endDate: ci(s.endDate)
          });
          return;
        }
        r("update:modelValue", s);
      }
    });
    return (s, i) => {
      const u = P("p-date-range-select");
      return T(), O(u, {
        modelValue: o.value,
        "onUpdate:modelValue": i[0] || (i[0] = (l) => o.value = l)
      }, null, 8, ["modelValue"]);
    };
  }
}), mL = /* @__PURE__ */ U({
  __name: "UseDeploymentSlot",
  props: {
    deploymentId: {}
  },
  setup(t) {
    const e = t, { deployment: n } = Zm(() => e.deploymentId);
    return (r, o) => v(n) ? Ve(r.$slots, "default", {
      key: 0,
      deployment: v(n)
    }) : j("", !0);
  }
}), ove = { class: "deployment-combobox__more" }, oS = /* @__PURE__ */ U({
  __name: "DeploymentCombobox",
  props: /* @__PURE__ */ Br({
    allowUnset: { type: Boolean }
  }, {
    selected: { required: !0 },
    selectedModifiers: {}
  }),
  emits: ["update:selected"],
  setup(t) {
    const e = zn(t, "selected"), n = t, r = je(), o = ge(""), s = ns(o, 500), { deployments: i, count: u } = w2(() => ({
      deployments: {
        flowOrDeploymentNameLike: s.value
      },
      limit: 100
    })), l = D(() => gi(r.deployments(), {
      "deployments.flowOrDeploymentNameLike": o.value
    })), a = D(() => {
      const c = i.value.map((p) => ({
        value: p.id,
        label: p.name,
        flowId: p.flowId
      }));
      return n.allowUnset && c.unshift({
        value: null,
        label: "None"
      }), c;
    });
    return (c, p) => {
      const d = P("p-link");
      return T(), O(v(ts), {
        modelValue: e.value,
        "onUpdate:modelValue": p[0] || (p[0] = (h) => e.value = h),
        search: o.value,
        "onUpdate:search": p[1] || (p[1] = (h) => o.value = h),
        options: a.value,
        manual: ""
      }, Ut({
        "combobox-options-empty": k(() => [
          p[2] || (p[2] = q(" No deployments ", -1))
        ]),
        default: k((h) => [
          Ve(c.$slots, "default", sn(kn(h)), () => [
            v(Ht)(h.value) ? (T(), O(mL, {
              key: 0,
              "deployment-id": h.value
            }, {
              default: k(({ deployment: m }) => [
                w(v(zk), {
                  "flow-id": m.flowId,
                  "deployment-name": m.name
                }, null, 8, ["flow-id", "deployment-name"])
              ]),
              _: 1
            }, 8, ["deployment-id"])) : j("", !0)
          ])
        ]),
        option: k(({ option: h }) => [
          Ve(c.$slots, "option", { option: h }, () => [
            h.flowId ? (T(), O(v(zk), {
              key: 0,
              "flow-id": h.flowId,
              "deployment-name": h.label
            }, null, 8, ["flow-id", "deployment-name"])) : j("", !0)
          ])
        ]),
        _: 2
      }, [
        v(u) > v(i).length ? {
          name: "bottom",
          fn: k(() => [
            re("p", ove, [
              q(ie(v(u) - v(i).length) + " more results. ", 1),
              re("span", null, [
                w(d, { to: l.value }, {
                  default: k(() => [...p[3] || (p[3] = [
                    q("Browse all", -1)
                  ])]),
                  _: 1
                }, 8, ["to"])
              ])
            ])
          ]),
          key: "0"
        } : void 0
      ]), 1032, ["modelValue", "search", "options"]);
    };
  }
}), sve = { class: "deployment-combobox-option" }, ave = { class: "deployment-combobox-option__flow-name" }, zk = /* @__PURE__ */ U({
  __name: "DeploymentComboboxOption",
  props: {
    flowId: {},
    deploymentName: {}
  },
  setup(t) {
    const e = t, { flow: n } = Ec(() => e.flowId);
    return (r, o) => {
      const s = P("p-icon");
      return T(), z("div", sve, [
        v(n) ? (T(), z(ve, { key: 0 }, [
          re("span", ave, ie(v(n).name), 1),
          w(s, {
            icon: "ChevronRightIcon",
            size: "small",
            class: "deployment-combobox-option__chevron"
          })
        ], 64)) : j("", !0),
        q(" " + ie(r.deploymentName), 1)
      ]);
    };
  }
}), ive = /* @__PURE__ */ U({
  __name: "DeploymentConfiguration",
  props: {
    deployment: {}
  },
  setup(t) {
    const e = t, n = D(() => e.deployment.jobVariables ? or(e.deployment.jobVariables) : "{}"), r = D(() => e.deployment.pullSteps ? or(e.deployment.pullSteps) : "[]");
    return (o, s) => {
      const i = P("p-heading"), u = P("p-code-highlight"), l = P("p-content");
      return T(), O(l, { class: "deployment-configuration" }, {
        default: k(() => [
          w(i, { heading: "4" }, {
            default: k(() => [...s[0] || (s[0] = [
              q(" Job Variables ", -1)
            ])]),
            _: 1
          }),
          o.deployment ? (T(), O(fh, {
            key: 0,
            "text-to-copy": n.value
          }, {
            default: k(() => [
              w(u, {
                lang: "json",
                text: n.value,
                class: "workspace-deployment__infra-overrides"
              }, null, 8, ["text"])
            ]),
            _: 1
          }, 8, ["text-to-copy"])) : j("", !0),
          w(i, { heading: "4" }, {
            default: k(() => [...s[1] || (s[1] = [
              q(" Pull Steps ", -1)
            ])]),
            _: 1
          }),
          w(fh, { "text-to-copy": r.value }, {
            default: k(() => [
              w(u, {
                lang: "json",
                text: r.value
              }, null, 8, ["text"])
            ]),
            _: 1
          }, 8, ["text-to-copy"])
        ]),
        _: 1
      });
    };
  }
}), sS = /* @__PURE__ */ U({
  __name: "DeploymentCustomRunOverflowMenuItem",
  props: {
    deployment: {}
  },
  setup(t) {
    const e = je();
    return (n, r) => {
      const o = P("p-overflow-menu-item"), s = P("router-link");
      return T(), O(s, {
        to: v(e).deploymentFlowRunCreate(n.deployment.id, n.deployment.parameters)
      }, {
        default: k(() => [
          w(o, null, {
            default: k(() => [
              Ve(n.$slots, "default", {}, () => [
                r[0] || (r[0] = q(" Custom run ", -1))
              ])
            ]),
            _: 3
          })
        ]),
        _: 3
      }, 8, ["to"]);
    };
  }
}), uve = "https://discourse.prefect.io/t/deployments-are-now-simplified-and-follow-a-declarative-syntax/1255", lve = /* @__PURE__ */ U({
  __name: "DeploymentDeprecatedMessage",
  setup(t) {
    return (e, n) => {
      const r = P("p-button");
      return T(), O(v(na), { class: "deprecated-message" }, {
        icon: k(() => [
          w(v(vo), { icon: "ExclamationCircleIcon" })
        ]),
        heading: k(() => [...n[0] || (n[0] = [
          q(" This deployment is deprecated ", -1)
        ])]),
        description: k(() => [...n[1] || (n[1] = [
          q(" With the General Availability release of Prefect 2, we modified the approach to creating deployments. ", -1)
        ])]),
        actions: k(() => [
          w(Os, {
            to: v(le).docs.deployments
          }, null, 8, ["to"]),
          re("a", {
            href: uve,
            target: "_blank"
          }, [
            w(r, {
              variant: "default",
              "icon-append": "ArrowTopRightOnSquareIcon"
            }, {
              default: k(() => [...n[2] || (n[2] = [
                q(" Find Out More ", -1)
              ])]),
              _: 1
            })
          ])
        ]),
        _: 1
      });
    };
  }
}), cve = /* @__PURE__ */ U({
  __name: "DeploymentDescription",
  props: {
    description: {}
  },
  setup(t) {
    return (e, n) => {
      const r = P("p-markdown-renderer");
      return T(), O(r, { text: e.description }, null, 8, ["text"]);
    };
  }
}), pve = /* @__PURE__ */ U({
  __name: "DeploymentDescriptionEmptyState",
  props: {
    deployment: {}
  },
  setup(t) {
    const e = je();
    return (n, r) => {
      const o = P("p-button");
      return T(), O(v(na), null, {
        icon: k(() => [
          w(v(vo), { icon: "Bars3BottomLeftIcon" })
        ]),
        heading: k(() => [...r[0] || (r[0] = [
          q(" Add deployment description ", -1)
        ])]),
        description: k(() => [...r[1] || (r[1] = [
          q(" You can do so by modifying your deployment here or by adding it as part of your deployment manifest configuration. ", -1)
        ])]),
        actions: k(() => [
          w(Os, {
            to: v(le).docs.deployments
          }, null, 8, ["to"]),
          n.deployment.can.update ? (T(), O(o, {
            key: 0,
            primary: "",
            to: v(e).deploymentEdit(n.deployment.id)
          }, {
            default: k(() => [...r[2] || (r[2] = [
              q(" Add Description ", -1)
            ])]),
            _: 1
          }, 8, ["to"])) : j("", !0)
        ]),
        _: 1
      });
    };
  }
}), yL = /* @__PURE__ */ U({
  __name: "AutomationIconText",
  props: {
    automationId: {}
  },
  setup(t) {
    const e = t, n = Se(), r = je(), o = mt(n.automations.getAutomation, [e.automationId]), s = D(() => o.response?.name);
    return (i, u) => {
      const l = P("p-icon-text"), a = P("p-link");
      return T(), O(a, {
        to: v(r).automation(i.automationId),
        class: "automation-icon-text"
      }, {
        default: k(() => [
          w(l, { icon: "Automation" }, {
            default: k(() => [
              re("span", null, ie(s.value), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["to"]);
    };
  }
}), dve = /* @__PURE__ */ U({
  __name: "DeploymentServiceLevelAgreementCard",
  props: {
    serviceLevelAgreement: {}
  },
  setup(t) {
    return (e, n) => {
      const r = P("p-key-value"), o = P("p-list-item");
      return T(), O(o, { class: "deployment-service-level-agreement-card" }, {
        default: k(() => [
          w(r, {
            class: "deployment-service-level-agreement-card__item",
            label: "Name",
            value: e.serviceLevelAgreement.name
          }, null, 8, ["value"]),
          w(r, {
            class: "deployment-service-level-agreement-card__item",
            label: "Type",
            value: e.serviceLevelAgreement.getDisplaySlaType()
          }, null, 8, ["value"]),
          w(r, {
            class: "deployment-service-level-agreement-card__item",
            label: "Severity",
            value: v(Cte)(e.serviceLevelAgreement.severity)
          }, null, 8, ["value"]),
          e.serviceLevelAgreement.description ? (T(), O(r, {
            key: 0,
            class: "deployment-service-level-agreement-card__item",
            label: "Description",
            value: e.serviceLevelAgreement.description
          }, null, 8, ["value"])) : j("", !0),
          (T(!0), z(ve, null, ln(e.serviceLevelAgreement.getSlaDefinitionKeyValuePairs(), (s) => (T(), O(r, {
            key: s.key,
            class: "deployment-service-level-agreement-card__item",
            label: s.key,
            value: s.value
          }, null, 8, ["label", "value"]))), 128))
        ]),
        _: 1
      });
    };
  }
}), gL = /* @__PURE__ */ U({
  __name: "DeploymentToggle",
  props: {
    deployment: {}
  },
  emits: ["update"],
  setup(t, { emit: e }) {
    const n = t, r = e, o = Se(), s = D({
      get() {
        return !n.deployment.paused;
      },
      set(a) {
        l(a);
      }
    }), i = lt({ pending: !1, valid: !0, validated: !1 }), u = D(() => n.deployment.can.update ? "Pause or resume all schedules" : le.info.deploymentUpdateDisabled), l = async (a) => {
      i.pending = !0;
      const c = a ? le.success.activateDeployment : le.success.pauseDeployment;
      try {
        await o.deployments.updateDeploymentV2(n.deployment.id, { paused: !a }), He(c, "success"), r("update");
      } catch (p) {
        const d = a ? le.error.activateDeployment : le.error.pauseDeployment, h = Yt(p, d);
        He(h, "error"), console.error(p);
      } finally {
        i.pending = !1;
      }
    };
    return (a, c) => {
      const p = P("p-toggle"), d = P("p-tooltip");
      return T(), O(d, {
        text: u.value,
        side: "left"
      }, {
        default: k(() => [
          w(p, {
            modelValue: s.value,
            "onUpdate:modelValue": c[0] || (c[0] = (h) => s.value = h),
            state: i,
            disabled: a.deployment.deprecated || a.deployment.disabled || !a.deployment.can.update
          }, null, 8, ["modelValue", "state", "disabled"])
        ]),
        _: 1
      }, 8, ["text"]);
    };
  }
}), hve = { class: "deployment-details" }, fve = { class: "deployment-details__schedule-label" }, mve = /* @__PURE__ */ U({
  __name: "DeploymentDetails",
  props: {
    deployment: {},
    alternate: { type: Boolean },
    slas: {}
  },
  emits: ["update"],
  setup(t, { emit: e }) {
    const n = t, r = e, o = Ke(), s = Se(), i = async (p) => {
      if (p.active === null || !p.schedule) {
        He("Must provide a schedule and indicate if it should be active or not.", "error");
        return;
      }
      try {
        await s.deploymentSchedules.createDeploymentSchedule(n.deployment.id, {
          active: p.active,
          schedule: p.schedule,
          jobVariables: p.jobVariables,
          parameters: p.parameters,
          slug: p.slug
        }), He(le.success.updateDeploymentSchedule, "success"), r("update");
      } catch {
        He(le.error.updateDeploymentSchedule, "error");
      }
    }, u = je(), l = D(() => `prefect.deployment.${n.deployment.id}`), { automations: a } = nse(l), c = D(() => ({
      actions: [{
        type: "run-deployment",
        deploymentId: n.deployment.id,
        parameters: {}
      }]
    }));
    return (p, d) => {
      const h = P("p-key-value"), m = P("p-button"), g = P("p-divider"), _ = P("p-tags");
      return T(), z("div", hve, [
        p.deployment.storageDocumentId ? (T(), O(h, {
          key: 0,
          label: "Storage",
          alternate: p.alternate
        }, {
          value: k(() => [
            w(v(V0), {
              "block-document-id": p.deployment.storageDocumentId
            }, null, 8, ["block-document-id"])
          ]),
          _: 1
        }, 8, ["alternate"])) : j("", !0),
        p.deployment.infrastructureDocumentId ? (T(), O(h, {
          key: 1,
          label: "Infrastructure",
          alternate: p.alternate
        }, {
          value: k(() => [
            w(v(V0), {
              "block-document-id": p.deployment.infrastructureDocumentId
            }, null, 8, ["block-document-id"])
          ]),
          _: 1
        }, 8, ["alternate"])) : j("", !0),
        w(h, {
          alternate: p.alternate,
          class: "items-stretch"
        }, {
          label: k(() => [
            re("div", fve, [
              d[2] || (d[2] = re("span", null, "Schedules", -1)),
              p.deployment.can.update && (p.deployment.schedules.length > 3 || p.deployment.paused) ? (T(), O(gL, {
                key: 0,
                deployment: p.deployment,
                onUpdate: d[0] || (d[0] = (b) => r("update"))
              }, null, 8, ["deployment"])) : j("", !0)
            ])
          ]),
          value: k(() => [
            w(v(wL), {
              deployment: p.deployment,
              schedules: p.deployment.schedules,
              onCreate: i,
              onUpdate: d[1] || (d[1] = (b) => r("update"))
            }, null, 8, ["deployment", "schedules"])
          ]),
          _: 1
        }, 8, ["alternate"]),
        Ve(p.$slots, "default", {}, () => [
          w(h, {
            label: "Triggers",
            value: v(a)
          }, {
            value: k(() => [
              (T(!0), z(ve, null, ln(v(a), (b) => (T(), z("div", {
                key: b.id,
                class: "deployment-details-triggers__value"
              }, [
                w(yL, {
                  "automation-id": b.id
                }, null, 8, ["automation-id"])
              ]))), 128)),
              p.deployment.disabled ? (T(), O(m, {
                key: 0,
                disabled: "",
                icon: "PlusIcon",
                size: "sm"
              }, {
                default: k(() => [...d[3] || (d[3] = [
                  q(" Add ", -1)
                ])]),
                _: 1
              })) : (T(), O(m, {
                key: 1,
                to: v(u).automationCreate(c.value),
                icon: "PlusIcon",
                size: "sm"
              }, {
                default: k(() => [...d[4] || (d[4] = [
                  q(" Add ", -1)
                ])]),
                _: 1
              }, 8, ["to"]))
            ]),
            _: 1
          }, 8, ["value"]),
          p.slas && p.slas.length > 0 ? (T(), O(h, {
            key: 0,
            class: "deployment-details__slas",
            label: "Service Level Agreements"
          }, {
            value: k(() => [
              (T(!0), z(ve, null, ln(p.slas, (b) => (T(), O(dve, {
                key: b.id,
                class: "deployment-details__sla-cards",
                "service-level-agreement": b
              }, null, 8, ["service-level-agreement"]))), 128))
            ]),
            _: 1
          })) : j("", !0)
        ]),
        w(g),
        w(h, {
          label: "Status",
          alternate: p.alternate
        }, {
          value: k(() => [
            w(v(hS), { deployment: p.deployment }, null, 8, ["deployment"])
          ]),
          _: 1
        }, 8, ["alternate"]),
        w(h, {
          label: "Created",
          alternate: p.alternate
        }, {
          value: k(() => [
            w(hn, {
              date: p.deployment.created,
              format: "numeric"
            }, null, 8, ["date"])
          ]),
          _: 1
        }, 8, ["alternate"]),
        p.deployment.createdBy ? (T(), O(h, {
          key: 2,
          label: "Created By",
          value: p.deployment.createdBy.displayValue,
          alternate: p.alternate
        }, null, 8, ["value", "alternate"])) : j("", !0),
        w(h, {
          label: "Last Updated",
          alternate: p.alternate
        }, {
          value: k(() => [
            w(hn, {
              date: p.deployment.updated,
              format: "numeric"
            }, null, 8, ["date"])
          ]),
          _: 1
        }, 8, ["alternate"]),
        p.deployment.updatedBy ? (T(), O(h, {
          key: 3,
          label: "Updated By",
          value: p.deployment.updatedBy.displayValue,
          alternate: p.alternate
        }, null, 8, ["value", "alternate"])) : j("", !0),
        w(h, {
          label: "Entrypoint",
          value: p.deployment.entrypoint,
          alternate: p.alternate
        }, null, 8, ["value", "alternate"]),
        w(h, {
          label: "Path",
          value: p.deployment.path,
          alternate: p.alternate
        }, null, 8, ["value", "alternate"]),
        w(h, {
          label: "Concurrency Limit",
          value: p.deployment.concurrencyLimit,
          alternate: p.alternate
        }, null, 8, ["value", "alternate"]),
        w(g),
        v(o).read.flow ? (T(), O(h, {
          key: 4,
          label: "Flow ID",
          value: p.deployment.flowId,
          alternate: p.alternate
        }, null, 8, ["value", "alternate"])) : j("", !0),
        w(h, {
          label: "Deployment ID",
          value: p.deployment.id,
          alternate: p.alternate
        }, null, 8, ["value", "alternate"]),
        w(h, {
          label: "Deployment Version",
          value: p.deployment.version,
          alternate: p.alternate
        }, null, 8, ["value", "alternate"]),
        w(h, {
          label: "Storage Document ID",
          value: p.deployment.storageDocumentId,
          alternate: p.alternate
        }, null, 8, ["value", "alternate"]),
        w(h, {
          label: "Infrastructure Document ID",
          value: p.deployment.infrastructureDocumentId,
          alternate: p.alternate
        }, null, 8, ["value", "alternate"]),
        w(h, {
          label: "Tags",
          alternate: p.alternate
        }, Ut({ _: 2 }, [
          p.deployment.tags?.length ? {
            name: "value",
            fn: k(() => [
              w(_, {
                tags: p.deployment.tags,
                class: "deployment-details__tags"
              }, null, 8, ["tags"])
            ]),
            key: "0"
          } : void 0
        ]), 1032, ["alternate"])
      ]);
    };
  }
}), aS = /* @__PURE__ */ U({
  __name: "DeploymentDisableToggle",
  props: {
    deployment: {}
  },
  emits: ["update"],
  setup(t, { emit: e }) {
    const n = t, r = e, o = Se(), s = D({
      get() {
        return !n.deployment.disabled;
      },
      set(a) {
        l(!!a);
      }
    }), i = D(() => n.deployment.can.update ? n.deployment.disabled ? le.info.deploymentDisabled : le.info.deploymentEnabled : le.info.deploymentUpdateDisabled), u = lt({ pending: !1, valid: !0, validated: !1 }), l = async (a) => {
      u.pending = !0;
      const c = a ? le.success.enableDeployment : le.success.disableDeployment;
      try {
        a ? await o.deployments.enableDeployment(n.deployment.id) : await o.deployments.disableDeployment(n.deployment.id), He(c, "success"), r("update");
      } catch (p) {
        const d = a ? le.error.enableDeployment : le.error.disableDeployment, h = Yt(p, d);
        He(h, "error"), console.error(p);
      } finally {
        u.pending = !1;
      }
    };
    return (a, c) => {
      const p = P("p-toggle"), d = P("p-tooltip");
      return T(), O(d, {
        text: i.value,
        side: "left"
      }, {
        default: k(() => [
          w(p, {
            modelValue: s.value,
            "onUpdate:modelValue": c[0] || (c[0] = (h) => s.value = h),
            state: u,
            disabled: a.deployment.deprecated || !a.deployment.can.update
          }, null, 8, ["modelValue", "state", "disabled"])
        ]),
        _: 1
      }, 8, ["text"]);
    };
  }
}), yve = { class: "flow-run-create-form-v2__header" }, gve = { class: "deployment-form__heading" }, vve = { class: "deployment-form__heading" }, _ve = /* @__PURE__ */ U({
  __name: "DeploymentForm",
  props: {
    deployment: {},
    mode: { default: () => "update" }
  },
  emits: ["submit", "cancel"],
  setup(t, { emit: e }) {
    const n = t, r = ge(n.deployment.name), o = ge(n.deployment.description), s = ge(n.deployment.workPoolName), i = ge(n.deployment.workQueueName), u = ge(n.deployment.concurrencyLimit), l = ge(n.deployment.concurrencyOptions?.collisionStrategy), a = ge(n.deployment.parameters), c = ge(n.deployment.tags), p = ge(or(n.deployment.jobVariables)), d = ge(n.deployment.enforceParameterSchema), h = D(() => ({ ...n.deployment.parameterOpenApiSchema, required: [] })), m = D(() => !ru(h.value.properties)), { validate: g } = Ms(), { errors: _, validate: b } = Xh(h, a), { state: x, error: S } = bn(p, ml("Job variables")), { state: E, error: A } = bn(r, (B) => {
      if (n.mode === "update")
        return !0;
      if (!B)
        return "Name is required";
      if (n.deployment.name === B)
        return "Name must be different from the original deployment";
    }), { state: C, error: M } = bn(u, (B) => B != null && B < 1 ? "Concurrency limit must be greater than 0. To unset, leave the field empty." : !0), L = e;
    async function X() {
      if (!await g())
        return;
      if (d.value)
        try {
          if (!await b())
            return;
        } catch (G) {
          console.error(G), He(Mm(u2), "error");
          return;
        }
      const W = p.value ? JSON.parse(p.value) : {};
      if (n.mode === "duplicate") {
        const G = {
          name: r.value,
          flowId: n.deployment.flowId,
          description: o.value,
          workPoolName: s.value,
          workQueueName: i.value,
          parameters: a.value,
          tags: c.value,
          enforceParameterSchema: d.value,
          jobVariables: W,
          parameterOpenApiSchema: n.deployment.parameterOpenApiSchema,
          manifestPath: n.deployment.manifestPath,
          path: n.deployment.path,
          version: null,
          paused: !1,
          schedules: [],
          entrypoint: n.deployment.entrypoint,
          storageDocumentId: n.deployment.storageDocumentId,
          infrastructureDocumentId: n.deployment.infrastructureDocumentId,
          pullSteps: n.deployment.pullSteps,
          concurrencyLimit: u.value,
          concurrencyOptions: l.value ? { collisionStrategy: l.value } : null
        };
        L("submit", G);
      } else {
        const G = {
          description: o.value,
          workPoolName: s.value,
          workQueueName: i.value,
          parameters: a.value,
          tags: c.value,
          enforceParameterSchema: d.value,
          jobVariables: W,
          concurrencyLimit: u.value,
          concurrencyOptions: l.value ? { collisionStrategy: l.value } : null
        };
        L("submit", G);
      }
    }
    const te = () => {
      L("cancel");
    };
    return (B, W) => {
      const G = P("p-text-input"), ne = P("p-label"), de = P("p-code-input"), V = P("p-tags-input"), Y = P("p-number-input"), Q = P("p-select"), ae = P("p-divider"), Z = P("p-overflow-menu-item"), J = P("p-icon-button-menu"), oe = P("p-toggle"), ue = P("p-button"), me = P("p-form");
      return T(), O(me, {
        class: "deployment-form p-background",
        onSubmit: X,
        onCancel: te
      }, {
        footer: k(() => [
          w(ue, { onClick: te }, {
            default: k(() => [...W[10] || (W[10] = [
              q(" Cancel ", -1)
            ])]),
            _: 1
          }),
          w(ue, {
            variant: "default",
            type: "submit"
          }, {
            default: k(() => [...W[11] || (W[11] = [
              q(" Save ", -1)
            ])]),
            _: 1
          })
        ]),
        default: k(() => [
          W[12] || (W[12] = re("h3", { class: "deployment-form__heading" }, " General ", -1)),
          w(ne, {
            label: "Name",
            state: v(E),
            message: v(A)
          }, {
            default: k(() => [
              w(G, {
                modelValue: r.value,
                "onUpdate:modelValue": W[0] || (W[0] = (pe) => r.value = pe),
                disabled: B.mode === "update"
              }, null, 8, ["modelValue", "disabled"])
            ]),
            _: 1
          }, 8, ["state", "message"]),
          w(ne, { label: "Description (Optional)" }, {
            default: k(() => [
              w(de, {
                modelValue: o.value,
                "onUpdate:modelValue": W[1] || (W[1] = (pe) => o.value = pe),
                class: "deployment-form__json",
                "min-lines": 3,
                lang: "markdown",
                "show-line-numbers": "",
                placeholder: v(le).info.descriptionPlaceholder
              }, null, 8, ["modelValue", "placeholder"])
            ]),
            _: 1
          }),
          w(ne, { label: "Work Pool (Optional)" }, {
            default: k(() => [
              w(v(aw), {
                selected: s.value,
                "onUpdate:selected": W[2] || (W[2] = (pe) => s.value = pe),
                "allow-unset": ""
              }, null, 8, ["selected"])
            ]),
            _: 1
          }),
          s.value ? (T(), O(ne, {
            key: 0,
            label: "Work Queue (Optional)"
          }, {
            default: k(() => [
              w(v(_S), {
                selected: i.value,
                "onUpdate:selected": W[3] || (W[3] = (pe) => i.value = pe),
                "work-pool-name": s.value,
                "allow-unset": ""
              }, null, 8, ["selected", "work-pool-name"])
            ]),
            _: 1
          })) : j("", !0),
          w(ne, { label: "Tags (Optional)" }, {
            default: k(() => [
              w(V, {
                modelValue: c.value,
                "onUpdate:modelValue": W[4] || (W[4] = (pe) => c.value = pe),
                "empty-message": "Add tags"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          w(ne, {
            label: "Concurrency Limit (Optional)",
            state: v(C),
            message: v(M)
          }, {
            default: k(() => [
              w(Y, {
                modelValue: u.value,
                "onUpdate:modelValue": W[5] || (W[5] = (pe) => u.value = pe),
                state: v(C),
                placeholder: "Unlimited"
              }, null, 8, ["modelValue", "state"])
            ]),
            _: 1
          }, 8, ["state", "message"]),
          w(ne, {
            label: "Concurrency Limit Collision Strategy (Optional)",
            description: "Configure behavior for runs once the concurrency limit is reached."
          }, {
            default: k(() => [
              w(Q, {
                modelValue: l.value,
                "onUpdate:modelValue": W[6] || (W[6] = (pe) => l.value = pe),
                options: v(Pee),
                "empty-message": "ENQUEUE"
              }, null, 8, ["modelValue", "options"])
            ]),
            _: 1
          }),
          w(ae),
          m.value ? (T(), O(v(Uh), {
            key: 1,
            values: a.value,
            "onUpdate:values": W[7] || (W[7] = (pe) => a.value = pe),
            schema: h.value,
            errors: v(_),
            kinds: ["none", "json"]
          }, {
            default: k(({ kind: pe, setKind: Be }) => [
              re("div", yve, [
                re("h3", gve, ie(v(le).info.parameters), 1),
                w(J, { small: "" }, {
                  default: k(() => [
                    pe === "json" ? (T(), O(Z, {
                      key: 0,
                      label: "Use form input",
                      onClick: (Ie) => Be("none")
                    }, null, 8, ["onClick"])) : j("", !0),
                    pe === "none" ? (T(), O(Z, {
                      key: 1,
                      label: "Use JSON input",
                      onClick: (Ie) => Be("json")
                    }, null, 8, ["onClick"])) : j("", !0)
                  ]),
                  _: 2
                }, 1024)
              ])
            ]),
            _: 1
          }, 8, ["values", "schema", "errors"])) : j("", !0),
          w(ne, { label: "Enforce Parameter Schema" }, {
            default: k(() => [
              w(oe, {
                modelValue: d.value,
                "onUpdate:modelValue": W[8] || (W[8] = (pe) => d.value = pe),
                disabled: !a.value
              }, null, 8, ["modelValue", "disabled"])
            ]),
            _: 1
          }),
          w(ae),
          re("h3", vve, ie(v(le).info.jobVariables), 1),
          w(ne, {
            label: "Job Variables (Optional)",
            message: v(S),
            state: v(x)
          }, {
            default: k(() => [
              w(v(wS), {
                modelValue: p.value,
                "onUpdate:modelValue": W[9] || (W[9] = (pe) => p.value = pe),
                state: v(x)
              }, null, 8, ["modelValue", "state"])
            ]),
            _: 1
          }, 8, ["message", "state"])
        ]),
        _: 1
      });
    };
  }
}), wve = { class: "deployment-list__schedules-heading" }, bve = { class: "deployment-list__tags-heading" }, kve = { class: "flex items-center gap-1" }, Tve = { class: "deployment-list__deployment" }, xve = { class: "deployment-list__action" }, Sve = /* @__PURE__ */ U({
  __name: "DeploymentList",
  props: {
    filter: {},
    prefix: {},
    deploymentDisableToggle: { type: Boolean },
    deploymentLimit: {}
  },
  emits: ["delete"],
  setup(t, { emit: e }) {
    const n = t, r = e, { DeploymentMenu: o } = Vn(), s = Ke(), i = je(), u = ge(), l = ns(u, 1200), a = dn("page", _o, 1), { value: c } = hl("deployment-list-limit", 10), { filter: p, clear: d, isCustomFilter: h } = Voe($t({}, n.filter, {
      deployments: {
        flowOrDeploymentNameLike: l
      },
      limit: c,
      page: a
    }), n.prefix), { deployments: m, subscription: g, count: _, pages: b } = w2(p, {
      interval: 3e4
    }), x = D(() => [
      {
        label: "Deployment"
      },
      {
        label: "Status",
        property: "status",
        width: "116px"
      },
      {
        label: "Activity",
        visible: _s.lg,
        maxWidth: "15%"
      },
      {
        label: "Tags",
        property: "tags",
        visible: _s.md,
        maxWidth: "15%"
      },
      {
        label: "Schedules",
        property: "schedules",
        visible: _s.md,
        maxWidth: "15%"
      },
      {
        label: "Action",
        width: "82px"
      }
    ]), S = (L) => [`deployment-list__${hu.snakeCase(L.label)}-column`], E = (L) => ({
      "deployment-list__row--subdued": L.paused
    }), A = ge([]);
    function C() {
      g.refresh();
    }
    const M = () => {
      A.value = [], C(), r("delete");
    };
    return (L, X) => {
      const te = P("p-select"), B = P("p-list-header"), W = P("router-link"), G = P("p-tag-wrapper"), ne = P("p-button"), de = P("PEmptyResults"), V = P("p-loading-icon"), Y = P("p-table"), Q = P("p-pager"), ae = P("p-content");
      return T(), O(ae, { class: "deployment-list" }, {
        default: k(() => [
          w(B, { sticky: "" }, {
            controls: k(() => [
              w(v(Wo), {
                modelValue: u.value,
                "onUpdate:modelValue": X[0] || (X[0] = (Z) => u.value = Z),
                size: "small",
                placeholder: "Search deployments...",
                class: "deployment-list__search-input",
                label: "Search deployments"
              }, null, 8, ["modelValue"]),
              w(v(fS), {
                selected: v(p).deployments.tags.name,
                "onUpdate:selected": X[1] || (X[1] = (Z) => v(p).deployments.tags.name = Z),
                small: "",
                multiple: ""
              }, null, 8, ["selected"])
            ]),
            sort: k(() => [
              w(te, {
                modelValue: v(p).sort,
                "onUpdate:modelValue": X[2] || (X[2] = (Z) => v(p).sort = Z),
                small: "",
                options: v(loe)
              }, null, 8, ["modelValue", "options"])
            ]),
            default: k(() => [
              A.value.length > 0 ? (T(), O(v(td), {
                key: 0,
                count: A.value.length
              }, null, 8, ["count"])) : L.deploymentLimit ? (T(), O(v(Uo), {
                key: 1,
                label: "Deployment",
                count: v(_),
                limit: L.deploymentLimit
              }, null, 8, ["count", "limit"])) : (T(), O(v(Uo), {
                key: 2,
                label: "Deployment",
                count: v(_)
              }, null, 8, ["count"])),
              v(s).delete.deployment ? (T(), O(v(xL), {
                key: 3,
                selected: A.value.map((Z) => Z.id),
                small: "",
                onDelete: M
              }, null, 8, ["selected"])) : j("", !0)
            ]),
            _: 1
          }),
          w(Y, {
            selected: v(s).delete.deployment ? A.value : void 0,
            data: v(m),
            columns: x.value,
            "header-classes": S,
            "column-classes": S,
            "row-classes": E,
            class: "deployment-list__table",
            "row-key": (Z) => Z.id,
            "onUpdate:selected": X[3] || (X[3] = (Z) => A.value = Z)
          }, {
            status: k(({ row: Z }) => [
              w(v(hS), {
                deployment: Z,
                small: ""
              }, null, 8, ["deployment"])
            ]),
            "schedules-heading": k(({ column: Z }) => [
              re("div", wve, ie(Z.label), 1)
            ]),
            "tags-heading": k(({ column: Z }) => [
              re("div", bve, ie(Z.label), 1)
            ]),
            "activity-heading": k(({ column: Z }) => [
              re("div", kve, [
                q(ie(Z.label) + " ", 1),
                w(v(yS), {
                  description: "Runs from the past week",
                  size: "small"
                })
              ])
            ]),
            "action-heading": k(() => [...X[6] || (X[6] = [
              re("span", null, null, -1)
            ])]),
            deployment: k(({ row: Z }) => [
              re("div", Tve, [
                w(W, {
                  to: v(i).deployment(Z.id),
                  class: "deployment-list__name",
                  title: Z.name
                }, {
                  default: k(() => [
                    q(ie(Z.name), 1)
                  ]),
                  _: 2
                }, 1032, ["to", "title"]),
                w(v(PL), {
                  "flow-id": Z.flowId,
                  class: "deployment-list__flow-name"
                }, null, 8, ["flow-id"])
              ])
            ]),
            schedules: k(({ row: Z }) => [
              w(v(bL), {
                schedules: Z.schedules,
                justify: "right"
              }, null, 8, ["schedules"])
            ]),
            tags: k(({ row: Z }) => [
              Z.tags ? (T(), O(G, {
                key: 0,
                tags: Z.tags,
                small: "",
                justify: "right"
              }, null, 8, ["tags"])) : j("", !0)
            ]),
            activity: k(({ row: Z }) => [
              w(v(rX), {
                class: "deployment-list__activity-chart",
                "deployment-id": Z.id,
                "time-span-in-seconds": v(Ih)
              }, null, 8, ["deployment-id", "time-span-in-seconds"])
            ]),
            action: k(({ row: Z }) => [
              re("div", xve, [
                L.deploymentDisableToggle ? (T(), O(v(aS), {
                  key: 0,
                  deployment: Z,
                  onUpdate: C
                }, null, 8, ["deployment"])) : j("", !0),
                w(v(o), {
                  class: "deployment-list__menu",
                  small: "",
                  "show-all": "",
                  deployment: Z,
                  flat: "",
                  onDelete: C
                }, null, 8, ["deployment"])
              ])
            ]),
            "empty-state": k(() => [
              v(g).executed ? (T(), O(de, { key: 0 }, Ut({
                message: k(() => [
                  X[7] || (X[7] = q(" No deployments ", -1))
                ]),
                _: 2
              }, [
                v(h) ? {
                  name: "actions",
                  fn: k(() => [
                    w(ne, {
                      small: "",
                      onClick: v(d)
                    }, {
                      default: k(() => [...X[8] || (X[8] = [
                        q(" Clear Filters ", -1)
                      ])]),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  key: "0"
                } : void 0
              ]), 1024)) : (T(), O(de, { key: 1 }, {
                message: k(() => [
                  w(V)
                ]),
                _: 1
              }))
            ]),
            _: 1
          }, 8, ["selected", "data", "columns", "row-key"]),
          w(Q, {
            limit: v(c),
            "onUpdate:limit": X[4] || (X[4] = (Z) => Xe(c) ? c.value = Z : null),
            page: v(a),
            "onUpdate:page": X[5] || (X[5] = (Z) => Xe(a) ? a.value = Z : null),
            pages: v(b)
          }, null, 8, ["limit", "page", "pages"])
        ]),
        _: 1
      });
    };
  }
}), Rve = { class: "quick-run-parameters-modal-v2__header" }, iS = /* @__PURE__ */ U({
  __name: "QuickRunParametersModal",
  props: /* @__PURE__ */ Br({
    deployment: {}
  }, {
    showModal: { type: Boolean, required: !0 },
    showModalModifiers: {}
  }),
  emits: ["update:showModal"],
  setup(t) {
    const e = zn(t, "showModal"), n = t, r = Se(), o = rs(), s = je(), i = Cm(), u = ge(!1), l = ge(n.deployment.enforceParameterSchema), a = ge({ ...n.deployment.parameters }), { subscription: c } = bN(() => ({
      deployments: {
        id: [n.deployment.id]
      }
    }));
    async function p() {
      u.value = !0;
      const d = {
        state: {
          type: "scheduled",
          message: "Run from the Prefect UI"
        },
        parameters: a.value,
        enforceParameterSchema: l.value
      };
      try {
        const h = await r.deployments.createDeploymentFlowRun(n.deployment.id, d);
        c.refresh();
        const m = Mm(uS, { flowRun: h, flowRunRoute: s.flowRun, router: o, immediate: !0 });
        He(m, "success");
      } catch (h) {
        const m = Yt(h, le.error.scheduleFlowRun);
        He(m, "error"), console.error(h);
        return;
      } finally {
        u.value = !1;
      }
      e.value = !1;
    }
    return (d, h) => {
      const m = P("p-overflow-menu-item"), g = P("p-icon-button-menu"), _ = P("p-checkbox"), b = P("p-modal");
      return T(), O(b, {
        showModal: e.value,
        "onUpdate:showModal": h[3] || (h[3] = (x) => e.value = x),
        class: "quick-run-parameters-modal-v2",
        title: "Run Deployment"
      }, {
        actions: k(() => [
          Ve(d.$slots, "actions", {}, () => [
            w(v(Zo), {
              type: "submit",
              loading: u.value,
              primary: "",
              form: v(i)
            }, {
              default: k(() => [...h[4] || (h[4] = [
                q(" Run ", -1)
              ])]),
              _: 1
            }, 8, ["loading", "form"])
          ])
        ]),
        default: k(() => [
          w(v(fie), {
            id: v(i),
            values: a.value,
            "onUpdate:values": h[1] || (h[1] = (x) => a.value = x),
            loading: u.value,
            "onUpdate:loading": h[2] || (h[2] = (x) => u.value = x),
            schema: d.deployment.parameterOpenApiSchema,
            validate: l.value,
            kinds: ["json", "workspace_variable"],
            onSubmit: p
          }, {
            default: k(({ kind: x, setKind: S }) => [
              re("div", Rve, [
                re("h3", null, ie(v(le).info.parameters), 1),
                w(g, { small: "" }, {
                  default: k(() => [
                    x === "json" ? (T(), O(m, {
                      key: 0,
                      label: "Use form input",
                      onClick: (E) => S("none")
                    }, null, 8, ["onClick"])) : j("", !0),
                    x === "none" ? (T(), O(m, {
                      key: 1,
                      label: "Use JSON input",
                      onClick: (E) => S("json")
                    }, null, 8, ["onClick"])) : j("", !0)
                  ]),
                  _: 2
                }, 1024)
              ])
            ]),
            "after-content": k(() => [
              w(_, {
                modelValue: l.value,
                "onUpdate:modelValue": h[0] || (h[0] = (x) => l.value = x),
                label: "Validate parameters"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["id", "values", "loading", "schema", "validate"])
        ]),
        _: 3
      }, 8, ["showModal"]);
    };
  }
}), Ave = /* @__PURE__ */ U({
  inheritAttrs: !1,
  __name: "DeploymentMenu",
  props: {
    deployment: {},
    showAll: { type: Boolean },
    allowDuplicate: { type: Boolean }
  },
  emits: ["delete"],
  setup(t, { emit: e }) {
    const n = e, { showModal: r, open: o, close: s } = St(), { showModal: i, open: u } = St(), l = Se(), a = je(), c = async (p) => {
      s(), await Ua(p, l.deployments.deleteDeployment, "Deployment"), n("delete", p);
    };
    return (p, d) => {
      const h = P("p-overflow-menu-item"), m = P("router-link"), g = P("p-icon-button-menu");
      return T(), z(ve, null, [
        w(g, sn(kn(p.$attrs)), {
          default: k(() => [
            p.deployment.can.run && p.showAll ? (T(), O(v(lS), {
              key: 0,
              deployment: p.deployment,
              "open-modal": v(u)
            }, null, 8, ["deployment", "open-modal"])) : j("", !0),
            p.deployment.can.run && p.showAll ? (T(), O(v(sS), {
              key: 1,
              deployment: p.deployment
            }, null, 8, ["deployment"])) : j("", !0),
            w(v(uo), {
              label: "Copy ID",
              item: p.deployment.id
            }, null, 8, ["item"]),
            !p.deployment.deprecated && p.deployment.can.update ? (T(), O(m, {
              key: 2,
              to: v(a).deploymentEdit(p.deployment.id)
            }, {
              default: k(() => [
                w(h, { label: "Edit" })
              ]),
              _: 1
            }, 8, ["to"])) : j("", !0),
            p.deployment.can.delete ? (T(), O(h, {
              key: 3,
              label: "Delete",
              onClick: v(o)
            }, null, 8, ["onClick"])) : j("", !0),
            p.allowDuplicate ? (T(), O(h, {
              key: 4,
              label: "Duplicate",
              to: v(a).deploymentDuplicate(p.deployment.id)
            }, null, 8, ["to"])) : j("", !0),
            Ve(p.$slots, "default", sn(kn({ deployment: p.deployment })))
          ]),
          _: 3
        }, 16),
        w(v(_r), {
          showModal: v(r),
          "onUpdate:showModal": d[0] || (d[0] = (_) => Xe(r) ? r.value = _ : null),
          label: "Deployment",
          name: p.deployment.name,
          onDelete: d[1] || (d[1] = (_) => c(p.deployment.id))
        }, null, 8, ["showModal", "name"]),
        w(iS, {
          showModal: v(i),
          "onUpdate:showModal": d[2] || (d[2] = (_) => Xe(i) ? i.value = _ : null),
          deployment: p.deployment
        }, null, 8, ["showModal", "deployment"])
      ], 64);
    };
  }
}), Dve = { class: "toast-flow-run-create" }, Eve = { class: "toast-flow-run-create__message" }, Mve = { class: "toast-flow-run-create__message--emphasized" }, Pve = { class: "toast-flow-run-create__message--emphasized" }, uS = /* @__PURE__ */ U({
  __name: "ToastFlowRunCreate",
  props: {
    flowRun: {},
    immediate: { type: Boolean },
    startTime: {},
    flowRunRoute: { type: Function },
    router: {}
  },
  setup(t) {
    const e = t, n = ge(e.router), r = () => {
      n.value.push(e.flowRunRoute(e.flowRun.id));
    };
    return (o, s) => (T(), z("div", Dve, [
      re("div", Eve, [
        re("span", Mve, ie(o.flowRun.name), 1),
        s[3] || (s[3] = q(" scheduled ", -1)),
        o.immediate ? (T(), z(ve, { key: 0 }, [
          s[0] || (s[0] = q(" to start ", -1)),
          s[1] || (s[1] = re("span", { class: "toast-flow-run-create__message--emphasized" }, "now", -1))
        ], 64)) : (T(), z(ve, { key: 1 }, [
          s[2] || (s[2] = q(" for ", -1)),
          re("span", Pve, ie(o.startTime?.toLocaleString()), 1)
        ], 64))
      ]),
      w(v(Zo), {
        class: "toast-flow-run-create__button",
        size: "sm",
        onClick: r
      }, {
        default: k(() => [...s[4] || (s[4] = [
          q(" View run ", -1)
        ])]),
        _: 1
      })
    ]));
  }
}), lS = /* @__PURE__ */ U({
  __name: "DeploymentQuickRunOverflowMenuItem",
  props: {
    deployment: {},
    openModal: { type: Function }
  },
  setup(t) {
    const e = t, n = Se(), r = rs(), o = je(), { subscription: s } = bN(() => ({
      deployments: {
        id: [e.deployment.id]
      }
    })), i = async () => {
      const u = e.deployment.parameterOpenApiSchema.required;
      if (u && u.length > 0) {
        e.openModal();
        return;
      }
      try {
        const l = await n.deployments.createDeploymentFlowRun(e.deployment.id, {
          state: {
            type: "scheduled",
            message: "Run from the Prefect UI with defaults"
          }
        });
        s.refresh();
        const a = Mm(uS, {
          flowRun: l,
          flowRunRoute: o.flowRun,
          router: r,
          immediate: !0
        });
        He(a, "success");
      } catch (l) {
        const a = Yt(l, le.error.scheduleFlowRun);
        He(a, "error"), console.error(l);
      }
    };
    return (u, l) => {
      const a = P("p-overflow-menu-item");
      return T(), O(a, { onClick: i }, {
        default: k(() => [
          Ve(u.$slots, "default", {}, () => [
            l[0] || (l[0] = q(" Quick run ", -1))
          ])
        ]),
        _: 3
      });
    };
  }
}), Cve = { key: 1 }, Ove = { key: 1 }, cS = /* @__PURE__ */ U({
  __name: "FlowIconText",
  props: {
    flowId: {}
  },
  setup(t) {
    const e = t, n = Ke(), r = je(), o = D(() => e.flowId), { flow: s, subscription: i } = Ec(o), u = D(() => s.value?.name);
    return (l, a) => {
      const c = P("p-icon-text"), p = P("p-link");
      return v(n).read.flow ? (T(), z(ve, { key: 0 }, [
        v(s) ? (T(), O(p, {
          key: 0,
          to: v(r).flow(o.value),
          class: "flow-icon-text"
        }, {
          default: k(() => [
            w(c, { icon: "Flow" }, {
              default: k(() => [
                re("span", null, ie(u.value), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["to"])) : v(i).executed ? (T(), z("span", Cve, " Flow not found ")) : j("", !0)
      ], 64)) : (T(), z("span", Ove, " No access "));
    };
  }
}), Ive = { class: "flow-run-flow" }, pS = /* @__PURE__ */ U({
  __name: "FlowRunFlow",
  props: {
    flowId: {}
  },
  setup(t) {
    return (e, n) => (T(), z("div", Ive, [
      re("span", null, ie(v(le).info.flow), 1),
      n[0] || (n[0] = q()),
      w(cS, { "flow-id": e.flowId }, null, 8, ["flow-id"])
    ]));
  }
}), Fve = { class: "deployment-relationships" }, dS = /* @__PURE__ */ U({
  __name: "DeploymentRelationships",
  props: {
    deployment: {}
  },
  setup(t) {
    return (e, n) => (T(), z("div", Fve, [
      e.deployment.flowId ? (T(), O(pS, {
        key: 0,
        "flow-id": e.deployment.flowId
      }, null, 8, ["flow-id"])) : j("", !0),
      e.deployment.workPoolName ? (T(), O(ny, {
        key: 1,
        "work-pool-name": e.deployment.workPoolName
      }, null, 8, ["work-pool-name"])) : j("", !0),
      e.deployment.workQueueName ? (T(), O(ry, {
        key: 2,
        "work-queue-name": e.deployment.workQueueName,
        "work-pool-name": e.deployment.workPoolName
      }, null, 8, ["work-queue-name", "work-pool-name"])) : j("", !0)
    ]));
  }
}), Nve = { class: "deployment-schedule-card__content" }, Lve = { class: "deployment-schedule-card__action" }, vL = /* @__PURE__ */ U({
  __name: "DeploymentScheduleCard",
  props: {
    deployment: {},
    deploymentSchedule: {}
  },
  emits: ["update"],
  setup(t) {
    const e = t, n = D(() => e.deploymentSchedule.slug ? e.deploymentSchedule.slug : e.deploymentSchedule.schedule.toString({ verbose: !1 }));
    return (r, o) => {
      const s = P("p-tooltip"), i = P("p-list-item");
      return T(), O(i, { class: "deployment-schedule-card" }, {
        default: k(() => [
          w(s, {
            text: r.deploymentSchedule.schedule.toString({ verbose: !0 })
          }, {
            default: k(() => [
              re("div", Nve, ie(n.value), 1)
            ]),
            _: 1
          }, 8, ["text"]),
          re("div", Lve, [
            w(v(kL), {
              deployment: r.deployment,
              schedule: r.deploymentSchedule,
              onUpdate: o[0] || (o[0] = (u) => r.$emit("update"))
            }, null, 8, ["deployment", "schedule"]),
            w(v(_L), {
              class: "deployment-schedule__menu",
              small: "",
              deployment: r.deployment,
              schedule: r.deploymentSchedule,
              onUpdate: o[1] || (o[1] = (u) => r.$emit("update")),
              onDelete: o[2] || (o[2] = (u) => r.$emit("update"))
            }, null, 8, ["deployment", "schedule"])
          ])
        ]),
        _: 1
      });
    };
  }
}), _L = /* @__PURE__ */ U({
  inheritAttrs: !1,
  __name: "DeploymentScheduleMenu",
  props: {
    deployment: {},
    schedule: {}
  },
  emits: ["update", "delete"],
  setup(t, { emit: e }) {
    const n = t, r = e, o = Se(), { showModal: s, open: i, close: u } = St(), l = ge(null), a = () => {
      l.value?.publicOpen?.();
    }, c = async (d, h) => {
      u(), await Ua([d, h], o.deploymentSchedules.deleteDeploymentSchedule, "Schedule"), r("delete", h);
    }, p = async (d) => {
      if (d.active === null || !d.schedule) {
        He("Unable to update schedule.", "error");
        return;
      }
      try {
        await o.deploymentSchedules.updateDeploymentSchedule(
          n.deployment.id,
          n.schedule.id,
          {
            active: d.active,
            schedule: d.schedule,
            jobVariables: d.jobVariables,
            parameters: d.parameters,
            slug: d.slug
          }
        ), He(le.success.updateDeploymentSchedule, "success"), r("update", d);
      } catch {
        He(le.error.updateDeploymentSchedule, "error");
      }
    };
    return (d, h) => {
      const m = P("p-overflow-menu-item"), g = P("p-icon-button-menu");
      return T(), z(ve, null, [
        w(g, sn(kn(d.$attrs)), {
          default: k(() => [
            w(v(uo), {
              label: "Copy ID",
              item: d.schedule.id
            }, null, 8, ["item"]),
            d.deployment.can.update ? (T(), O(m, {
              key: 0,
              label: "Edit",
              onClick: a
            })) : j("", !0),
            d.deployment.can.delete ? (T(), O(m, {
              key: 1,
              label: "Delete",
              onClick: v(i)
            }, null, 8, ["onClick"])) : j("", !0)
          ]),
          _: 1
        }, 16),
        w(v(iw), yt({
          ref_key: "scheduleFormModalRef",
          ref: l
        }, d.schedule, {
          slug: d.schedule.slug,
          "deployment-parameters": d.deployment.parameters,
          "schedule-parameters": d.schedule.parameters,
          "parameter-open-api-schema": d.deployment.parameterOpenApiSchema,
          deployment: d.deployment,
          "deployment-schedule-id": d.schedule.id,
          onSubmit: p
        }), null, 16, ["slug", "deployment-parameters", "schedule-parameters", "parameter-open-api-schema", "deployment", "deployment-schedule-id"]),
        w(v(_r), {
          showModal: v(s),
          "onUpdate:showModal": h[0] || (h[0] = (_) => Xe(s) ? s.value = _ : null),
          label: "Schedule",
          name: `${d.schedule.schedule.toString({ verbose: !1 })} schedule`,
          onDelete: h[1] || (h[1] = (_) => c(d.deployment.id, d.schedule.id))
        }, null, 8, ["showModal", "name"])
      ], 64);
    };
  }
}), Bve = { class: "deployment-schedule-fieldset" }, wL = /* @__PURE__ */ U({
  __name: "DeploymentSchedulesFieldset",
  props: {
    deployment: {},
    schedules: {}
  },
  emits: ["update", "create"],
  setup(t, { emit: e }) {
    const n = e, r = (s) => {
      n("create", s);
    }, o = (s, i) => s.created.getTime() - i.created.getTime();
    return (s, i) => {
      const u = P("p-button");
      return T(), z("div", Bve, [
        (T(!0), z(ve, null, ln(s.schedules.toSorted(o), (l) => (T(), O(v(vL), {
          key: l.id,
          deployment: s.deployment,
          "deployment-schedule": l,
          onUpdate: i[0] || (i[0] = (a) => n("update"))
        }, null, 8, ["deployment", "deployment-schedule"]))), 128)),
        s.deployment.can.update ? (T(), O(v(iw), {
          key: 0,
          slug: null,
          active: null,
          schedule: null,
          "job-variables": {},
          "deployment-parameters": s.deployment.parameters,
          "schedule-parameters": {},
          "parameter-open-api-schema": s.deployment.parameterOpenApiSchema,
          deployment: s.deployment,
          onSubmit: r
        }, {
          default: k(({ open: l }) => [
            w(u, {
              size: "sm",
              icon: "PlusIcon",
              disabled: s.deployment.disabled,
              onClick: l
            }, {
              default: k(() => [...i[1] || (i[1] = [
                q(" Schedule ", -1)
              ])]),
              _: 1
            }, 8, ["disabled", "onClick"])
          ]),
          _: 1
        }, 8, ["deployment-parameters", "parameter-open-api-schema", "deployment"])) : j("", !0)
      ]);
    };
  }
}), Uve = {
  key: 0,
  class: "deployment-schedule-tags__text--paused"
}, bL = /* @__PURE__ */ U({
  __name: "DeploymentScheduleTags",
  props: {
    schedules: {}
  },
  setup(t) {
    const e = D(() => ({
      tag: (n) => ({
        "deployment-list__schedule--inactive": !n.active
      })
    }));
    return (n, r) => {
      const o = P("p-tag"), s = P("p-tooltip"), i = P("p-tag-wrapper");
      return T(), O(i, {
        small: "",
        class: "deployment-schedule-tags"
      }, {
        default: k(() => [
          (T(!0), z(ve, null, ln(n.schedules, (u) => (T(), O(s, {
            key: u.id
          }, {
            content: k(() => [
              u.active ? j("", !0) : (T(), z("span", Uve, " (Paused) ")),
              q(" " + ie(u.schedule.toString({ verbose: !0 })), 1)
            ]),
            default: k(() => [
              w(o, {
                class: Bt(["deployment-schedule-tags__tag", e.value.tag(u)]),
                small: ""
              }, {
                default: k(() => [
                  q(ie(u.schedule), 1)
                ]),
                _: 2
              }, 1032, ["class"])
            ]),
            _: 2
          }, 1024))), 128))
        ]),
        _: 1
      });
    };
  }
}), kL = /* @__PURE__ */ U({
  __name: "DeploymentScheduleToggle",
  props: {
    deployment: {},
    schedule: {}
  },
  emits: ["update"],
  setup(t, { emit: e }) {
    const n = e, r = Se(), o = D({
      get() {
        return !!t.schedule.active;
      },
      set(l) {
        u(l);
      }
    }), s = ge(!1), i = D(() => t.deployment.can.update ? "Pause or resume this schedule" : le.info.deploymentUpdateDisabled), u = async (l) => {
      s.value = !0;
      try {
        await r.deploymentSchedules.updateDeploymentSchedule(
          t.deployment.id,
          t.schedule.id,
          {
            slug: t.schedule.slug,
            schedule: t.schedule.schedule,
            parameters: t.schedule.parameters ?? void 0,
            active: l
          }
        ), He(l ? le.success.activateDeploymentSchedule : le.success.pauseDeploymentSchedule, "success"), n("update", l);
      } catch (a) {
        const c = l ? le.error.activateDeploymentSchedule : le.error.pauseDeploymentSchedule, p = Yt(a, c);
        He(p, "error");
      } finally {
        s.value = !1;
      }
    };
    return (l, a) => {
      const c = P("p-toggle"), p = P("p-tooltip");
      return T(), O(p, {
        text: i.value,
        side: "left"
      }, {
        default: k(() => [
          w(c, {
            modelValue: o.value,
            "onUpdate:modelValue": a[0] || (a[0] = (d) => o.value = d),
            disabled: s.value || l.deployment.paused || l.deployment.disabled || !l.deployment.can.update
          }, null, 8, ["modelValue", "disabled"])
        ]),
        _: 1
      }, 8, ["text"]);
    };
  }
}), Xve = {
  key: 1,
  class: "deployments-count--none"
}, TL = /* @__PURE__ */ U({
  __name: "DeploymentsCount",
  props: {
    count: {},
    flowId: {}
  },
  setup(t) {
    const e = je();
    return (n, r) => {
      const o = P("p-link");
      return n.count ? (T(), O(o, {
        key: 0,
        class: "deployments-count",
        to: v(gi)(v(e).flow(n.flowId), { tab: "Deployments" })
      }, {
        default: k(() => [
          q(ie(n.count) + " " + ie(v(Ks)(v(le).info.deployment, n.count)), 1)
        ]),
        _: 1
      }, 8, ["to"])) : (T(), z("span", Xve, ie(v(le).info.none), 1));
    };
  }
}), xL = /* @__PURE__ */ U({
  inheritAttrs: !1,
  __name: "DeploymentsDeleteButton",
  props: {
    selected: {}
  },
  emits: ["delete"],
  setup(t, { emit: e }) {
    const n = e, { showModal: r, open: o, close: s } = St(), i = Se(), u = Eh(), l = async (a) => {
      const c = D(() => a.length === 1 ? le.success.delete("Deployment") : le.success.delete(`${a.length} deployments`));
      try {
        const p = a.map(i.deployments.deleteDeployment);
        await Promise.all(p), He(c, "success"), n("delete");
      } catch (p) {
        const d = Yt(p, le.error.delete("deployments"));
        He(d, "error");
      } finally {
        s();
      }
    };
    return (a, c) => {
      const p = P("p-button");
      return T(), z(ve, null, [
        a.selected.length > 0 ? (T(), O(p, yt({ key: 0 }, v(u), {
          icon: "TrashIcon",
          onClick: v(o)
        }), null, 16, ["onClick"])) : j("", !0),
        w(_r, {
          showModal: v(r),
          "onUpdate:showModal": c[0] || (c[0] = (d) => Xe(r) ? r.value = d : null),
          name: "selected deployments",
          label: "Deployments",
          onDelete: c[1] || (c[1] = (d) => l(a.selected))
        }, null, 8, ["showModal"])
      ], 64);
    };
  }
}), $ve = /* @__PURE__ */ U({
  __name: "DeploymentsPageEmptyState",
  setup(t) {
    return (e, n) => (T(), O(v(na), null, {
      icon: k(() => [
        w(v(vo), { icon: "Flow" }),
        w(v(vo), { icon: "EllipsisHorizontalIcon" }),
        w(v(vo), { icon: "PDeployment" })
      ]),
      heading: k(() => [...n[0] || (n[0] = [
        q(" Create a deployment to get started ", -1)
      ])]),
      description: k(() => [...n[1] || (n[1] = [
        q(" Deployments elevate workflows from functions you call manually to API objects that can be remotely triggered. ", -1)
      ])]),
      actions: k(() => [
        Ve(e.$slots, "actions", {}, () => [
          w(Os, {
            to: v(le).docs.deployments
          }, null, 8, ["to"])
        ])
      ]),
      _: 3
    }));
  }
}), SL = /* @__PURE__ */ U({
  __name: "DeploymentStatusIcon",
  props: {
    status: {}
  },
  setup(t) {
    const e = t, n = D(() => {
      switch (e.status) {
        case "ready":
          return "One or more processes are actively polling this deployment";
        case "not_ready":
          return "This deployment has not been polled in the past 60 seconds";
        case "disabled":
          return "This deployment is disabled and cannot be run";
        default:
          return "";
      }
    });
    return (r, o) => {
      const s = P("p-tooltip");
      return r.status ? (T(), O(s, {
        key: 0,
        class: "deployment-status-icon",
        text: n.value
      }, {
        default: k(() => [
          w(A_, { status: r.status }, null, 8, ["status"])
        ]),
        _: 1
      }, 8, ["text"])) : j("", !0);
    };
  }
}), hS = /* @__PURE__ */ U({
  __name: "DeploymentStatusBadge",
  props: {
    deployment: {}
  },
  setup(t) {
    const e = t, n = D(() => ({
      root: {
        "deployment-status-badge--ready": e.deployment.status === "ready",
        "deployment-status-badge--not-ready": e.deployment.status === "not_ready",
        "deployment-status-badge--disabled": e.deployment.status === "disabled"
      }
    }));
    return (r, o) => {
      const s = P("p-tag");
      return r.deployment.status ? (T(), O(s, {
        key: 0,
        class: Bt([n.value.root, "deployment-status-badge"])
      }, {
        default: k(() => [
          w(SL, {
            status: r.deployment.status
          }, null, 8, ["status"]),
          q(" " + ie(v(qx)(r.deployment.status)), 1)
        ]),
        _: 1
      }, 8, ["class"])) : j("", !0);
    };
  }
}), RL = /* @__PURE__ */ U({
  __name: "DeploymentStatusSelect",
  props: {
    selected: {}
  },
  emits: ["update:selected"],
  setup(t, { emit: e }) {
    const n = t, r = e, o = bk.map((i) => ({
      label: qx(i),
      value: i
    })), s = D({
      get() {
        return n.selected;
      },
      set(i) {
        r("update:selected", i);
      }
    });
    return (i, u) => {
      const l = P("p-select");
      return T(), O(l, {
        modelValue: s.value,
        "onUpdate:modelValue": u[0] || (u[0] = (a) => s.value = a),
        options: v(o)
      }, null, 8, ["modelValue", "options"]);
    };
  }
}), fS = /* @__PURE__ */ U({
  __name: "DeploymentTagsInput",
  props: {
    selected: {},
    emptyMessage: {},
    filter: {}
  },
  emits: ["update:selected"],
  setup(t, { emit: e }) {
    const n = t, r = e, o = D(() => n.emptyMessage ?? "All tags"), s = D({
      get() {
        return n.selected ?? null;
      },
      set(l) {
        r("update:selected", l);
      }
    }), { deployments: i } = w2(() => n.filter ?? {}), u = D(() => {
      const l = i.value.flatMap((a) => a.tags ?? []);
      return Bm(l).sort((a, c) => a.localeCompare(c));
    });
    return (l, a) => {
      const c = P("p-tags-input");
      return T(), O(c, yt({
        modelValue: s.value,
        "onUpdate:modelValue": a[0] || (a[0] = (p) => s.value = p),
        class: "deployment-tags-input",
        placeholder: "Search or enter new tag"
      }, { options: u.value, emptyMessage: o.value }), null, 16, ["modelValue"]);
    };
  }
}), Wve = { class: "duration-input" }, AL = /* @__PURE__ */ U({
  inheritAttrs: !1,
  __name: "DurationInput",
  props: {
    modelValue: {},
    min: {}
  },
  emits: ["update:modelValue"],
  setup(t, { emit: e }) {
    const n = t, r = e, o = ge(u(n.modelValue)), s = D(() => {
      const l = n.min ?? 0;
      return [
        { label: "Seconds", value: 1 },
        { label: "Minutes", value: Oa },
        { label: "Hours", value: ac },
        { label: "Days", value: ic }
      ].filter((c) => c.value >= l);
    });
    Ct(o, (l, a) => {
      r("update:modelValue", n.modelValue / a * l);
    });
    const i = D({
      get() {
        return n.modelValue / o.value;
      },
      set(l) {
        r("update:modelValue", l * o.value);
      }
    });
    function u(l) {
      return l % ic === 0 ? ic : l % ac === 0 ? ac : l % Oa === 0 ? Oa : 1;
    }
    return (l, a) => {
      const c = P("p-number-input"), p = P("p-select");
      return T(), z("div", Wve, [
        w(c, yt({
          modelValue: i.value,
          "onUpdate:modelValue": a[0] || (a[0] = (d) => i.value = d)
        }, l.$attrs, { min: l.min }), null, 16, ["modelValue", "min"]),
        a[2] || (a[2] = re("label", {
          class: "sr-only",
          for: "duration-input-unit"
        }, "Duration unit", -1)),
        w(p, {
          id: "duration-input-unit",
          modelValue: o.value,
          "onUpdate:modelValue": a[1] || (a[1] = (d) => o.value = d),
          options: s.value
        }, null, 8, ["modelValue", "options"])
      ]);
    };
  }
}), Vve = { class: "workspace-event-description" }, Hve = { class: "workspace-event-description__event" }, jve = { class: "workspace-event-description__tooltip" }, DL = /* @__PURE__ */ U({
  __name: "WorkspaceEventDescription",
  props: {
    event: {}
  },
  setup(t) {
    const e = t, n = je(), r = kc(), o = dn("events", []), s = D(() => Kee(e.event.event));
    function i(a) {
      return o.value.includes(a) ? "MinusSmallIcon" : "PlusSmallIcon";
    }
    function u(a) {
      const c = xx(o.value, a), p = { ...r.query, events: c };
      return gi(n.events(), p);
    }
    function l(a) {
      return o.value.includes(a) ? "Remove" : "Add";
    }
    return (a, c) => {
      const p = P("p-link"), d = P("p-icon-text"), h = P("p-tooltip");
      return T(), O(h, null, {
        content: k(() => [
          re("div", jve, [
            (T(!0), z(ve, null, ln(s.value, (m) => (T(), O(p, {
              key: m,
              to: u(m)
            }, {
              default: k(() => [
                w(d, {
                  icon: i(m)
                }, {
                  default: k(() => [
                    q(ie(l(m)) + " " + ie(m), 1)
                  ]),
                  _: 2
                }, 1032, ["icon"])
              ]),
              _: 2
            }, 1032, ["to"]))), 128))
          ])
        ]),
        default: k(() => [
          re("div", Vve, [
            w(p, {
              to: v(n).event(a.event.id, a.event.occurred)
            }, {
              default: k(() => [
                q(ie(a.event.eventLabel), 1)
              ]),
              _: 1
            }, 8, ["to"]),
            re("span", Hve, ie(a.event.event), 1)
          ])
        ]),
        _: 1
      });
    };
  }
}), zve = { class: "event-card p-background" }, mS = /* @__PURE__ */ U({
  __name: "EventCard",
  props: {
    eventId: {},
    occurred: {}
  },
  setup(t) {
    const e = t, { event: n } = Mse(() => e.eventId, () => e.occurred);
    return (r, o) => {
      const s = P("p-key-value"), i = P("p-loading-icon");
      return T(), z("div", zve, [
        v(n) ? (T(), z(ve, { key: 0 }, [
          w(DL, { event: v(n) }, null, 8, ["event"]),
          w(s, {
            label: "Occurred",
            alternate: ""
          }, {
            value: k(() => [
              w(hn, {
                date: v(n).occurred,
                format: "numeric"
              }, null, 8, ["date"])
            ]),
            _: 1
          }),
          w(v(N_), {
            class: "workspace-events-list-item__resource",
            event: v(n),
            alternate: ""
          }, null, 8, ["event"]),
          v(n).related.length ? (T(), O(v(F_), {
            key: 0,
            event: v(n),
            alternate: ""
          }, null, 8, ["event"])) : j("", !0)
        ], 64)) : (T(), O(i, { key: 1 }))
      ]);
    };
  }
}), qve = { class: "event-related-tags" }, Gve = /* @__PURE__ */ U({
  __name: "EventRelatedTags",
  props: {
    resources: {}
  },
  setup(t) {
    const e = kc(), n = je(), r = dn("resource", []);
    function o(l) {
      return l["prefect.resource.id"].split(".").at(-1);
    }
    function s(l) {
      const a = xx(r.value, l["prefect.resource.id"]), c = { ...e.query, resource: a };
      return gi(n.events(), c);
    }
    function i(l) {
      return r.value.includes(l["prefect.resource.id"]) ? "MinusSmallIcon" : "PlusSmallIcon";
    }
    function u(l) {
      return r.value.includes(l["prefect.resource.id"]) ? le.info.removeTagFromFilter : le.info.filterByTag;
    }
    return (l, a) => {
      const c = P("p-tag"), p = P("p-icon-text"), d = P("p-link"), h = P("p-tooltip");
      return T(), z("div", qve, [
        a[0] || (a[0] = q(" Tags ", -1)),
        (T(!0), z(ve, null, ln(l.resources, (m, g) => (T(), O(h, { key: g }, {
          content: k(() => [
            w(d, {
              to: s(m)
            }, {
              default: k(() => [
                w(p, {
                  icon: i(m)
                }, {
                  default: k(() => [
                    q(ie(u(m)), 1)
                  ]),
                  _: 2
                }, 1032, ["icon"])
              ]),
              _: 2
            }, 1032, ["to"])
          ]),
          default: k(() => [
            w(c, null, {
              default: k(() => [
                q(ie(o(m)), 1)
              ]),
              _: 2
            }, 1024)
          ]),
          _: 2
        }, 1024))), 128))
      ]);
    };
  }
}), F_ = /* @__PURE__ */ U({
  __name: "EventRelatedKeyValue",
  props: {
    event: {},
    alternate: { type: Boolean }
  },
  setup(t) {
    const e = t, { EventResourceIconText: n } = Vn(), r = D(() => e.event.related.length > 0 ? !0 : null), o = D(() => ({
      resources: {
        "event-related-key-value__resources--alternate": e.alternate
      }
    })), s = D(() => {
      const [i, u] = _G(e.event.related, (l) => {
        const { role: a } = r2(l["prefect.resource.id"]);
        return a === "tag";
      });
      return {
        tags: i,
        resources: u
      };
    });
    return (i, u) => {
      const l = P("p-key-value");
      return T(), O(l, yt({
        label: "Related Resources",
        class: "event-related-key-value"
      }, { alternate: i.alternate }), Ut({ _: 2 }, [
        r.value ? {
          name: "value",
          fn: k(() => [
            re("div", {
              class: Bt(["event-related-key-value__resources", o.value.resources])
            }, [
              (T(!0), z(ve, null, ln(s.value.resources, (a, c) => (T(), O(v(n), {
                key: c,
                resource: a
              }, null, 8, ["resource"]))), 128)),
              s.value.tags.length ? (T(), O(Gve, {
                key: 0,
                resources: s.value.tags
              }, null, 8, ["resources"])) : j("", !0)
            ], 2)
          ]),
          key: "0"
        } : void 0
      ]), 1040);
    };
  }
}), Yve = /* @__PURE__ */ U({
  __name: "EventResourceCombobox",
  props: /* @__PURE__ */ Br({
    multiple: { type: Boolean },
    additionalOptions: {}
  }, {
    selected: { required: !0 },
    selectedModifiers: {}
  }),
  emits: ["update:selected"],
  setup(t) {
    const e = zn(t, "selected"), n = t, r = Se(), o = mt(r.automations.getAutomations), s = D(() => o.response ?? []), i = mt(r.blockDocuments.getBlockDocuments), u = D(() => i.response ?? []), l = mt(r.deployments.getDeployments), a = D(() => l.response ?? []), c = mt(r.flows.getFlows), p = D(() => c.response ?? []), d = mt(r.workPools.getWorkPools), h = D(() => d.response ?? []), m = mt(r.workQueues.getWorkQueues, [{}]), g = D(() => m.response ?? []), _ = D(() => [
      {
        label: "Automations",
        options: s.value.map((b) => ({
          label: b.name,
          value: `prefect-cloud.automation.${b.id}`,
          type: "automation"
        }))
      },
      {
        label: "Blocks",
        options: u.value.map((b) => ({
          label: b.name,
          value: `prefect.block-document.${b.id}`,
          type: "block-document"
        }))
      },
      {
        label: "Deployments",
        options: a.value.map((b) => ({
          label: b.name,
          value: `prefect.deployment.${b.id}`,
          type: "deployment"
        }))
      },
      {
        label: "Flows",
        options: p.value.map((b) => ({
          label: b.name,
          value: `prefect.flow.${b.id}`,
          type: "flow"
        }))
      },
      {
        label: "Work Pools",
        options: h.value.map((b) => ({
          label: b.name,
          value: `prefect.work-pool.${b.id}`,
          type: "work-pool"
        }))
      },
      {
        label: "Work Queues",
        options: g.value.map((b) => ({
          label: `${b.workPoolName} > ${b.name}`,
          value: `prefect.work-queue.${b.id}`,
          type: "work-queue"
        }))
      },
      ...n.additionalOptions ?? []
    ]);
    return (b, x) => {
      const S = P("p-combobox");
      return T(), O(S, {
        modelValue: e.value,
        "onUpdate:modelValue": x[0] || (x[0] = (E) => e.value = E),
        options: _.value,
        multiple: b.multiple,
        "allow-unknown-value": "",
        "empty-message": "All resources",
        class: "event-resource-combobox"
      }, null, 8, ["modelValue", "options", "multiple"]);
    };
  }
}), Qve = {
  key: 0,
  class: "event-resource-automation-icon-text"
}, Kve = /* @__PURE__ */ U({
  __name: "EventResourceAutomationIconText",
  props: {
    resource: {}
  },
  setup(t) {
    const e = t, { ResourceLink: n } = Vn(), { resource: r } = Nn(e), { id: o, name: s, resourceId: i } = Cs(r), u = D(() => s.value ? null : o.value), { automation: l, subscription: a } = MN(u), c = D(() => s.value ?? l.value?.name), p = D(() => Vt(c.value) || a.errored);
    return (d, h) => {
      const m = P("p-icon-text");
      return p.value ? (T(), z("span", Qve, [
        v(o) && c.value ? (T(), z(ve, { key: 0 }, [
          h[0] || (h[0] = q(" Automation ", -1)),
          w(v(n), { resource: v(r) }, {
            default: k(() => [
              w(m, { icon: "Automation" }, {
                default: k(() => [
                  re("span", null, ie(c.value), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["resource"])
        ], 64)) : (T(), z(ve, { key: 1 }, [
          q(ie(v(i)), 1)
        ], 64))
      ])) : j("", !0);
    };
  }
}), Zve = {
  key: 0,
  class: "event-resource-task-run-icon-text"
}, Jve = /* @__PURE__ */ U({
  __name: "EventResourceBlockDocumentIconText",
  props: {
    resource: {}
  },
  setup(t) {
    const e = t, { ResourceLink: n } = Vn(), { resource: r } = Nn(e), { id: o, name: s, resourceId: i } = Cs(r), u = D(() => s.value ? null : o.value), { blockDocument: l, subscription: a } = x_(u), c = D(() => s.value ?? l.value?.name), p = D(() => Vt(c.value) || a.errored);
    return (d, h) => {
      const m = P("p-icon-text");
      return p.value ? (T(), z("span", Zve, [
        v(o) && c.value ? (T(), z(ve, { key: 0 }, [
          h[0] || (h[0] = q(" Block ", -1)),
          w(v(n), { resource: v(r) }, {
            default: k(() => [
              w(m, { icon: "CubeIcon" }, {
                default: k(() => [
                  re("span", null, ie(c.value), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["resource"])
        ], 64)) : (T(), z(ve, { key: 1 }, [
          q(ie(v(i)), 1)
        ], 64))
      ])) : j("", !0);
    };
  }
}), e_e = {
  key: 0,
  class: "event-resource-deployment-icon-text"
}, t_e = /* @__PURE__ */ U({
  __name: "EventResourceConcurrencyLimitIconText",
  props: {
    resource: {}
  },
  setup(t) {
    const e = t, { ResourceLink: n } = Vn(), r = Se(), { resource: o } = Nn(e), { id: s, name: i, resourceId: u } = Cs(o), l = ge(s.value ?? ""), a = mt(r.concurrencyV2Limits.getConcurrencyV2Limit, [l], {}), c = D(() => a.response), p = D(() => i.value ?? c.value?.name), d = D(() => Vt(p.value) || a.errored);
    return (h, m) => {
      const g = P("p-icon-text");
      return d.value ? (T(), z("span", e_e, [
        v(s) && p.value ? (T(), z(ve, { key: 0 }, [
          m[0] || (m[0] = q(" Concurrency Limit ", -1)),
          w(v(n), { resource: v(o) }, {
            default: k(() => [
              w(g, { icon: "QueueListIcon" }, {
                default: k(() => [
                  re("span", null, ie(p.value), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["resource"])
        ], 64)) : (T(), z(ve, { key: 1 }, [
          q(ie(v(u)), 1)
        ], 64))
      ])) : j("", !0);
    };
  }
}), n_e = {
  key: 0,
  class: "event-resource-deployment-icon-text"
}, r_e = /* @__PURE__ */ U({
  __name: "EventResourceDeploymentIconText",
  props: {
    resource: {}
  },
  setup(t) {
    const e = t, { ResourceLink: n } = Vn(), { resource: r } = Nn(e), { id: o, name: s, resourceId: i } = Cs(r), u = D(() => s.value ? null : o.value), { deployment: l, subscription: a } = Zm(u), c = D(() => s.value ?? l.value?.name), p = D(() => Vt(c.value) || a.errored);
    return (d, h) => {
      const m = P("p-icon-text");
      return p.value ? (T(), z("span", n_e, [
        v(o) && c.value ? (T(), z(ve, { key: 0 }, [
          h[0] || (h[0] = q(" Deployment ", -1)),
          w(v(n), { resource: v(r) }, {
            default: k(() => [
              w(m, { icon: "PDeployment" }, {
                default: k(() => [
                  re("span", null, ie(c.value), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["resource"])
        ], 64)) : (T(), z(ve, { key: 1 }, [
          q(ie(v(i)), 1)
        ], 64))
      ])) : j("", !0);
    };
  }
}), o_e = {
  key: 0,
  class: "event-resource-flow-icon-text"
}, s_e = /* @__PURE__ */ U({
  __name: "EventResourceFlowIconText",
  props: {
    resource: {}
  },
  setup(t) {
    const e = t, { ResourceLink: n } = Vn(), { resource: r } = Nn(e), { id: o, name: s, resourceId: i } = Cs(r), u = D(() => s.value ? null : o.value), { flow: l, subscription: a } = Ec(u), c = D(() => s.value ?? l.value?.name), p = D(() => Vt(c.value) || a.errored);
    return (d, h) => {
      const m = P("p-icon-text");
      return p.value ? (T(), z("span", o_e, [
        v(o) && c.value ? (T(), z(ve, { key: 0 }, [
          h[0] || (h[0] = q(" Flow ", -1)),
          w(v(n), { resource: v(r) }, {
            default: k(() => [
              w(m, { icon: "Flow" }, {
                default: k(() => [
                  re("span", null, ie(c.value), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["resource"])
        ], 64)) : (T(), z(ve, { key: 1 }, [
          q(ie(v(i)), 1)
        ], 64))
      ])) : j("", !0);
    };
  }
}), a_e = {
  key: 0,
  class: "event-resource-flow-run-icon-text"
}, i_e = /* @__PURE__ */ U({
  __name: "EventResourceFlowRunIconText",
  props: {
    resource: {}
  },
  setup(t) {
    const e = t, { ResourceLink: n } = Vn(), { resource: r } = Nn(e), { id: o, name: s, resourceId: i } = Cs(r), u = D(() => s.value ? null : o.value), { flowRun: l, subscription: a } = yl(u), c = D(() => s.value ?? l.value?.name), p = D(() => Vt(c.value) || a.errored);
    return (d, h) => {
      const m = P("p-icon-text");
      return p.value ? (T(), z("span", a_e, [
        v(o) && c.value ? (T(), z(ve, { key: 0 }, [
          h[0] || (h[0] = q(" Flow run ", -1)),
          w(v(n), { resource: v(r) }, {
            default: k(() => [
              w(m, { icon: "FlowRun" }, {
                default: k(() => [
                  re("span", null, ie(c.value), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["resource"])
        ], 64)) : (T(), z(ve, { key: 1 }, [
          q(ie(v(i)), 1)
        ], 64))
      ])) : j("", !0);
    };
  }
}), u_e = {
  key: 0,
  class: "event-resource-task-run-icon-text"
}, l_e = /* @__PURE__ */ U({
  __name: "EventResourceTaskRunIconText",
  props: {
    resource: {}
  },
  setup(t) {
    const e = t, { ResourceLink: n } = Vn(), { resource: r } = Nn(e), { id: o, name: s, resourceId: i } = Cs(r), u = D(() => s.value ? null : o.value), { taskRun: l, subscription: a } = Kp(u), c = D(() => s.value ?? l.value?.name), p = D(() => Vt(c.value) || a.errored);
    return (d, h) => {
      const m = P("p-icon-text");
      return p.value ? (T(), z("span", u_e, [
        v(o) && c.value ? (T(), z(ve, { key: 0 }, [
          h[0] || (h[0] = q(" Task run ", -1)),
          w(v(n), { resource: v(r) }, {
            default: k(() => [
              w(m, { icon: "PTaskRun" }, {
                default: k(() => [
                  re("span", null, ie(c.value), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["resource"])
        ], 64)) : (T(), z(ve, { key: 1 }, [
          q(ie(v(i)), 1)
        ], 64))
      ])) : j("", !0);
    };
  }
}), c_e = {
  key: 0,
  class: "event-resource-work-pool-icon-text"
}, p_e = /* @__PURE__ */ U({
  __name: "EventResourceWorkPoolIconText",
  props: {
    resource: {}
  },
  setup(t) {
    const e = t, { ResourceLink: n } = Vn(), { resource: r } = Nn(e), { id: o, name: s, resourceId: i } = Cs(r), u = D(() => s.value ? null : o.value), { workPool: l, subscription: a } = xN(u.value), c = D(() => s.value ?? l.value?.name), p = D(() => Vt(c.value) || a.errored);
    return (d, h) => {
      const m = P("p-icon-text");
      return p.value ? (T(), z("span", c_e, [
        v(s) || c.value ? (T(), z(ve, { key: 0 }, [
          h[0] || (h[0] = q(" Work pool ", -1)),
          w(v(n), { resource: v(r) }, {
            default: k(() => [
              w(m, { icon: "PWorkPool" }, {
                default: k(() => [
                  re("span", null, ie(c.value), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["resource"])
        ], 64)) : (T(), z(ve, { key: 1 }, [
          q(ie(v(i)), 1)
        ], 64))
      ])) : j("", !0);
    };
  }
}), d_e = {
  key: 0,
  class: "event-resource-work-queue-icon-text"
}, h_e = { key: 0 }, f_e = /* @__PURE__ */ U({
  __name: "EventResourceWorkQueueIconText",
  props: {
    resource: {}
  },
  setup(t) {
    const e = t, { ResourceLink: n } = Vn(), { resource: r } = Nn(e), { id: o, name: s, resourceId: i } = Cs(r), u = D(() => s.value ? null : o.value), { workPoolQueue: l, subscription: a } = AN(u), c = D(() => s.value ?? l.value?.name), p = D(() => l.value?.workPoolName), d = D(() => Vt(c.value) || a.errored);
    return (h, m) => {
      const g = P("p-icon-text");
      return d.value ? (T(), z("span", d_e, [
        v(o) && c.value ? (T(), z(ve, { key: 0 }, [
          m[0] || (m[0] = q(" Work queue ", -1)),
          w(v(n), { resource: v(r) }, {
            default: k(() => [
              w(g, { icon: "PWorkPool" }, {
                default: k(() => [
                  p.value ? (T(), z("span", h_e, ie(p.value) + " > ", 1)) : j("", !0),
                  re("span", null, ie(c.value), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["resource"])
        ], 64)) : (T(), z(ve, { key: 1 }, [
          q(ie(v(i)), 1)
        ], 64))
      ])) : j("", !0);
    };
  }
}), m_e = { class: "event-resource-icon-text" }, y_e = { key: 1 }, g_e = /* @__PURE__ */ U({
  __name: "EventResourceIconText",
  props: {
    resource: {}
  },
  setup(t) {
    const e = t, { resource: n } = Nn(e), { role: r, resourceId: o } = Cs(n), s = dn("related-resources", []), i = D(() => {
      switch (r.value) {
        case "work-queue":
          return f_e;
        case "work-pool":
          return p_e;
        case "flow-run":
          return i_e;
        case "automation":
          return Kve;
        case "flow":
          return s_e;
        case "deployment":
          return r_e;
        case "task-run":
          return l_e;
        case "block-document":
          return Jve;
        case "concurrency-limit":
          return t_e;
        default:
          return null;
      }
    }), u = D(() => s.value.includes(o.value)), l = D(() => u.value ? "MinusSmallIcon" : "PlusSmallIcon"), a = D(() => u.value ? le.info.removeResourceFromFilter : le.info.filterByResource), c = je(), p = rs(), d = kc(), h = D(() => {
      const m = xx(s.value, o.value), g = { ...d.query, resource: m }, _ = gi(c.events(), g);
      try {
        return p.resolve(_);
      } catch (b) {
        if (wn(b) && b.message === 'Missing required param "workspaceId"')
          return;
        console.error(b);
      }
      return null;
    });
    return (m, g) => {
      const _ = P("p-icon-text"), b = P("p-link"), x = P("p-tooltip");
      return T(), O(x, {
        disabled: !h.value
      }, {
        content: k(() => [
          h.value ? (T(), O(b, {
            key: 0,
            to: h.value
          }, {
            default: k(() => [
              w(_, { icon: l.value }, {
                default: k(() => [
                  q(ie(a.value), 1)
                ]),
                _: 1
              }, 8, ["icon"])
            ]),
            _: 1
          }, 8, ["to"])) : j("", !0)
        ]),
        default: k(() => [
          re("div", m_e, [
            i.value ? (T(), O(Mr(i.value), {
              key: 0,
              resource: v(n),
              class: "event-resource-icon-text__component"
            }, null, 8, ["resource"])) : (T(), z("span", y_e, ie(v(o)), 1))
          ])
        ]),
        _: 1
      }, 8, ["disabled"]);
    };
  }
}), N_ = /* @__PURE__ */ U({
  __name: "EventResourceKeyValue",
  props: {
    event: {},
    alternate: { type: Boolean }
  },
  setup(t) {
    const { EventResourceIconText: e } = Vn();
    return (n, r) => {
      const o = P("p-key-value");
      return T(), O(o, yt({
        label: "Resource",
        class: "event-resource-key-value"
      }, { alternate: n.alternate }), {
        value: k(() => [
          w(v(e), {
            resource: n.event.resource
          }, null, 8, ["resource"])
        ]),
        _: 1
      }, 16);
    };
  }
}), qk = /* @__PURE__ */ U({
  __name: "EventsCombobox",
  props: {
    selected: {},
    emptyMessage: {},
    filter: {},
    multiple: { type: Boolean }
  },
  emits: ["update:selected"],
  setup(t, { emit: e }) {
    const n = t, r = e, o = D({
      get() {
        return n.selected ?? null;
      },
      set(m) {
        r("update:selected", m);
      }
    }), s = Se(), i = G8(/* @__PURE__ */ new Date()), u = M3(i, 1), l = D(() => ({
      ...n.filter,
      occurred: {
        since: u,
        until: i,
        ...n.filter?.occurred
      }
    })), a = mt(s.events.getEventsCount, ["event", l]), c = D(() => a.response ?? []);
    function p(m) {
      const g = /* @__PURE__ */ new Set();
      return m.forEach((_) => {
        const b = _.split(".");
        for (let x = 1; x < b.length; x++) {
          const S = b.slice(0, x).join(".");
          g.add(S);
        }
      }), Array.from(g).filter((_) => {
        const b = m.filter((x) => x.startsWith(`${_}.`)).length;
        return b > 1 && b < m.length;
      }).map((_) => `${_}.*`);
    }
    const d = D(() => {
      const m = c.value.map((b) => b.label), g = p(m);
      return [...m, ...g].sort(h).map((b) => ({
        value: b,
        label: b
      }));
    });
    function h(m, g) {
      return m.localeCompare(g);
    }
    return (m, g) => {
      const _ = P("p-combobox");
      return T(), O(_, yt({
        modelValue: o.value,
        "onUpdate:modelValue": g[0] || (g[0] = (b) => o.value = b)
      }, { options: d.value, multiple: m.multiple }, {
        "empty-message": m.emptyMessage ?? "All events",
        "allow-unknown-value": ""
      }), {
        "combobox-options-empty": k(() => [...g[1] || (g[1] = [
          q(" No events ", -1)
        ])]),
        _: 1
      }, 16, ["modelValue", "empty-message"]);
    };
  }
}), EL = /* @__PURE__ */ U({
  __name: "ExploreEventsButton",
  props: {
    filter: {},
    selectionStart: {},
    selectionEnd: {}
  },
  setup(t) {
    const e = t, n = je(), r = D(() => {
      const { id: o = [], idPrefix: s = [] } = e.filter.anyResource ?? {}, i = [...o, ...s];
      return gi(n.events(), {
        resource: i,
        since: e.selectionStart?.toISOString(),
        until: e.selectionEnd?.toISOString()
      });
    });
    return (o, s) => {
      const i = P("p-button");
      return T(), O(i, {
        to: r.value,
        icon: "SparklesIcon",
        class: "explore-events-button",
        size: "sm"
      }, {
        default: k(() => [...s[0] || (s[0] = [
          re("span", { class: "explore-events-button__label" }, "Explore events", -1)
        ])]),
        _: 1
      }, 8, ["to"]);
    };
  }
}), yS = /* @__PURE__ */ U({
  __name: "ExtraInfoTooltip",
  props: {
    description: {},
    size: {}
  },
  setup(t) {
    return (e, n) => {
      const r = P("p-icon"), o = P("p-tooltip");
      return T(), O(o, {
        text: e.description,
        "avoid-collisions": ""
      }, {
        content: k(() => [
          Ve(e.$slots, "default")
        ]),
        default: k(() => [
          w(r, {
            size: e.size,
            icon: "InformationCircleIcon",
            class: "extra-info-tooltip__icon"
          }, null, 8, ["size"])
        ]),
        _: 3
      }, 8, ["text"]);
    };
  }
}), v_e = /* @__PURE__ */ U({
  __name: "FlowActivityChart",
  props: {
    flow: {}
  },
  setup(t) {
    const e = t, n = Se(), r = D(() => new Date(e.flow.created)), o = ge(/* @__PURE__ */ new Date()), s = D(() => mG((o.value.getTime() - r.value.getTime()) / 1e3 / 10)), i = D(() => ({
      historyEnd: o.value,
      historyStart: r.value,
      historyIntervalSeconds: s.value,
      flows: {
        id: [e.flow.id]
      }
    })), u = mt(n.flowRuns.getFlowRunsHistory, [i]), l = D(() => u.response ?? []);
    return (a, c) => (T(), O(c4, {
      history: l.value,
      "interval-start": r.value,
      "interval-end": o.value,
      "interval-seconds": s.value
    }, null, 8, ["history", "interval-start", "interval-end", "interval-seconds"]));
  }
}), ML = /* @__PURE__ */ U({
  __name: "UseFlowSlot",
  props: {
    flowId: {}
  },
  setup(t) {
    const e = t, { flow: n } = Ec(() => e.flowId);
    return (r, o) => v(n) ? Ve(r.$slots, "default", {
      key: 0,
      flow: v(n)
    }) : j("", !0);
  }
}), __e = { class: "flow-combobox__more" }, gS = /* @__PURE__ */ U({
  __name: "FlowCombobox",
  props: /* @__PURE__ */ Br({
    allowUnset: { type: Boolean }
  }, {
    selected: { required: !0 },
    selectedModifiers: {}
  }),
  emits: ["update:selected"],
  setup(t) {
    const e = zn(t, "selected"), n = t, r = je(), o = ge(""), s = ns(o, 500), { flows: i, count: u } = b2(() => ({
      flows: {
        nameLike: s.value
      },
      limit: 100
    })), l = D(() => gi(r.flows(), {
      "flows.nameLike": o.value
    })), a = D(() => {
      const c = i.value.map((p) => ({
        value: p.id,
        label: p.name
      }));
      return n.allowUnset && c.unshift({
        value: null,
        label: "None"
      }), c;
    });
    return (c, p) => {
      const d = P("p-link");
      return T(), O(v(ts), {
        modelValue: e.value,
        "onUpdate:modelValue": p[0] || (p[0] = (h) => e.value = h),
        search: o.value,
        "onUpdate:search": p[1] || (p[1] = (h) => o.value = h),
        options: a.value,
        manual: ""
      }, Ut({
        "combobox-options-empty": k(() => [
          p[2] || (p[2] = q(" No flows ", -1))
        ]),
        default: k((h) => [
          Ve(c.$slots, "default", sn(kn(h)), () => [
            v(Ht)(h.value) ? (T(), O(ML, {
              key: 0,
              "flow-id": h.value
            }, {
              default: k(({ flow: m }) => [
                q(ie(m.name), 1)
              ]),
              _: 1
            }, 8, ["flow-id"])) : j("", !0)
          ])
        ]),
        option: k(({ option: h }) => [
          Ve(c.$slots, "option", { option: h })
        ]),
        _: 2
      }, [
        v(u) > v(i).length ? {
          name: "bottom",
          fn: k(() => [
            re("p", __e, [
              q(ie(v(u) - v(i).length) + " more results. ", 1),
              re("span", null, [
                w(d, { to: l.value }, {
                  default: k(() => [...p[3] || (p[3] = [
                    q("Browse all", -1)
                  ])]),
                  _: 1
                }, 8, ["to"])
              ])
            ])
          ]),
          key: "0"
        } : void 0
      ]), 1032, ["modelValue", "search", "options"]);
    };
  }
}), w_e = { class: "flow-details" }, b_e = /* @__PURE__ */ U({
  __name: "FlowDetails",
  props: {
    flow: {},
    alternate: { type: Boolean }
  },
  setup(t) {
    return (e, n) => {
      const r = P("p-key-value");
      return T(), z("div", w_e, [
        w(r, {
          label: "Flow ID",
          value: e.flow.id,
          alternate: e.alternate
        }, null, 8, ["value", "alternate"]),
        w(r, {
          label: "Created",
          alternate: e.alternate
        }, {
          value: k(() => [
            w(hn, {
              date: e.flow.created,
              format: "numeric"
            }, null, 8, ["date"])
          ]),
          _: 1
        }, 8, ["alternate"]),
        w(r, {
          label: "Updated",
          alternate: e.alternate
        }, {
          value: k(() => [
            w(hn, {
              date: e.flow.updated,
              format: "numeric"
            }, null, 8, ["date"])
          ]),
          _: 1
        }, 8, ["alternate"])
      ]);
    };
  }
}), k_e = { class: "flow-list__name-col" }, T_e = { class: "flow-list__created-date" }, x_e = { class: "flow-list__action" }, S_e = /* @__PURE__ */ U({
  __name: "FlowList",
  props: {
    filter: {}
  },
  emits: ["delete"],
  setup(t, { emit: e }) {
    const n = t, { FlowMenu: r } = Vn(), o = Se(), s = Ke(), i = je(), { value: u } = hl("flow-list-limit", 10), l = dn("page", _o, 1), a = ge(), c = ns(a, 1200), { filter: p, clear: d, isCustomFilter: h } = $oe($t({}, n.filter, {
      flows: {
        nameLike: c
      },
      limit: u,
      page: l
    })), { flows: m, subscription: g, count: _, pages: b } = b2(p, {
      interval: 3e4
    }), S = xe(() => m.value.length > 0 ? [m.value.map((G) => G.id)] : null), E = xt(o.ui.getDeploymentsCountByFlow, S), A = D(() => E.response);
    function C(G) {
      return A.value?.[G] ?? 0;
    }
    const M = [
      {
        property: "name",
        label: "Name"
      },
      {
        label: "Last run"
      },
      {
        label: "Next run"
      },
      {
        label: "Deployments"
      },
      {
        label: "Activity"
      },
      {
        label: "Action"
      }
    ], L = (G) => [`flow-list__${bF(G.label)}-column`], X = ge([]);
    function te(G) {
      G && (X.value = X.value.filter((ne) => ne.id !== G)), g.refresh();
    }
    const B = e, W = () => {
      X.value = [], te(), B("delete");
    };
    return (G, ne) => {
      const de = P("p-select"), V = P("p-list-header"), Y = P("p-link"), Q = P("p-button"), ae = P("p-empty-results"), Z = P("p-loading-icon"), J = P("p-table"), oe = P("p-pager"), ue = P("p-content");
      return T(), O(ue, { class: "flow-list" }, {
        default: k(() => [
          w(V, { sticky: "" }, {
            controls: k(() => [
              w(v(Wo), {
                modelValue: a.value,
                "onUpdate:modelValue": ne[0] || (ne[0] = (me) => a.value = me),
                placeholder: "Flow names",
                label: "Search flows"
              }, null, 8, ["modelValue"]),
              w(v(wR), {
                selected: v(p).flowRuns.tags.name,
                "onUpdate:selected": ne[1] || (ne[1] = (me) => v(p).flowRuns.tags.name = me),
                multiple: ""
              }, null, 8, ["selected"])
            ]),
            sort: k(() => [
              w(de, {
                modelValue: v(p).sort,
                "onUpdate:modelValue": ne[2] || (ne[2] = (me) => v(p).sort = me),
                options: v(ioe)
              }, null, 8, ["modelValue", "options"])
            ]),
            default: k(() => [
              X.value.length == 0 ? (T(), O(v(Uo), {
                key: 0,
                label: "Flow",
                count: v(_)
              }, null, 8, ["count"])) : (T(), O(v(td), {
                key: 1,
                count: X.value.length
              }, null, 8, ["count"])),
              v(s).delete.flow ? (T(), O(v(ZU), {
                key: 2,
                selected: X.value.map((me) => me.id),
                size: "sm",
                onDelete: W
              }, null, 8, ["selected"])) : j("", !0)
            ]),
            _: 1
          }),
          w(J, {
            selected: v(s).delete.flow ? X.value : void 0,
            data: v(m),
            columns: M,
            "column-classes": L,
            "row-key": (me) => me.id,
            class: "flow-list__table",
            "onUpdate:selected": ne[3] || (ne[3] = (me) => X.value = me)
          }, {
            name: k(({ row: me }) => [
              re("div", k_e, [
                w(Y, {
                  to: v(i).flow(me.id),
                  class: "flow-list__name"
                }, {
                  default: k(() => [
                    re("span", null, ie(me.name), 1)
                  ]),
                  _: 2
                }, 1032, ["to"]),
                w(hn, {
                  date: me.created,
                  format: "numeric"
                }, {
                  default: k(({ date: pe }) => [
                    re("span", T_e, "Created " + ie(pe), 1)
                  ]),
                  _: 1
                }, 8, ["date"])
              ])
            ]),
            "last-run": k(({ row: me }) => [
              w(v(kR), {
                "flow-id": me.id
              }, null, 8, ["flow-id"])
            ]),
            "next-run": k(({ row: me }) => [
              w(v(RR), {
                "flow-id": me.id
              }, null, 8, ["flow-id"])
            ]),
            deployments: k(({ row: me }) => [
              w(v(TL), {
                count: C(me.id),
                "flow-id": me.id,
                class: "flow-list__deployment-count"
              }, null, 8, ["count", "flow-id"])
            ]),
            activity: k(({ row: me }) => [
              w(v(oX), {
                class: "flow-list__activity-chart",
                "flow-id": me.id,
                "time-span-in-seconds": -v(Ih)
              }, null, 8, ["flow-id", "time-span-in-seconds"])
            ]),
            "action-heading": k(() => [...ne[6] || (ne[6] = [
              re("span", null, null, -1)
            ])]),
            action: k(({ row: me }) => [
              re("div", x_e, [
                w(v(r), {
                  size: "xs",
                  flow: me,
                  flat: "",
                  onDelete: (pe) => te(me.id)
                }, null, 8, ["flow", "onDelete"])
              ])
            ]),
            "empty-state": k(() => [
              v(g).executed ? (T(), O(ae, { key: 0 }, Ut({
                message: k(() => [
                  ne[7] || (ne[7] = q(" No flows ", -1))
                ]),
                _: 2
              }, [
                v(h) ? {
                  name: "actions",
                  fn: k(() => [
                    w(Q, {
                      size: "sm",
                      onClick: v(d)
                    }, {
                      default: k(() => [...ne[8] || (ne[8] = [
                        q(" Clear Filters ", -1)
                      ])]),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  key: "0"
                } : void 0
              ]), 1024)) : (T(), O(ae, { key: 1 }, {
                message: k(() => [
                  w(Z)
                ]),
                _: 1
              }))
            ]),
            _: 1
          }, 8, ["selected", "data", "row-key"]),
          w(oe, {
            page: v(l),
            "onUpdate:page": ne[4] || (ne[4] = (me) => Xe(l) ? l.value = me : null),
            limit: v(u),
            "onUpdate:limit": ne[5] || (ne[5] = (me) => Xe(u) ? u.value = me : null),
            pages: v(b)
          }, null, 8, ["page", "limit", "pages"])
        ]),
        _: 1
      });
    };
  }
}), R_e = /* @__PURE__ */ U({
  inheritAttrs: !1,
  __name: "FlowMenu",
  props: {
    flow: {}
  },
  emits: ["delete"],
  setup(t, { emit: e }) {
    const n = Ke(), r = Se(), o = je(), { showModal: s, open: i } = St(), u = e, l = async (a) => {
      await Ua(a, r.flows.deleteFlow, "Flow"), u("delete", a);
    };
    return (a, c) => {
      const p = P("p-overflow-menu-item"), d = P("router-link"), h = P("p-icon-button-menu");
      return T(), z(ve, null, [
        w(h, sn(kn(a.$attrs)), {
          default: k(() => [
            w(uo, {
              label: "Copy ID",
              item: a.flow.id
            }, null, 8, ["item"]),
            v(n).delete.flow ? (T(), O(p, {
              key: 0,
              label: "Delete",
              value: a.flow.id,
              onClick: v(i)
            }, null, 8, ["value", "onClick"])) : j("", !0),
            Ve(a.$slots, "default", sn(kn({ flow: a.flow })), () => [
              v(n).create.automation ? (T(), O(d, {
                key: 0,
                to: v(o).automateFlow(a.flow.id)
              }, {
                default: k(() => [
                  w(p, { label: "Automate" })
                ]),
                _: 1
              }, 8, ["to"])) : j("", !0)
            ])
          ]),
          _: 3
        }, 16),
        a.flow ? (T(), O(v(_r), {
          key: 0,
          showModal: v(s),
          "onUpdate:showModal": c[0] || (c[0] = (m) => Xe(s) ? s.value = m : null),
          label: "Flow",
          name: a.flow.name,
          onDelete: c[1] || (c[1] = (m) => l(a.flow.id))
        }, null, 8, ["showModal", "name"])) : j("", !0)
      ], 64);
    };
  }
}), A_e = ["title"], D_e = {
  key: 0,
  class: "flow-popover__link"
}, E_e = ["title"], PL = /* @__PURE__ */ U({
  inheritAttrs: !1,
  __name: "FlowPopover",
  props: {
    flowId: {}
  },
  setup(t) {
    const e = t, n = [qr.top, qr.bottom, qr.right, qr.left], { flow: r } = Ec(() => e.flowId);
    return (o, s) => {
      const i = P("p-icon"), u = P("p-key-value"), l = P("p-content"), a = P("p-card"), c = P("p-pop-over");
      return T(), O(c, { placement: n }, {
        target: k(({ open: p, close: d, toggle: h }) => [
          Ve(o.$slots, "default", sn(kn({ open: p, close: d, toggle: h, flow: v(r) })), () => [
            w(v(tv), { "flow-id": o.flowId }, {
              default: k(() => [
                v(r) ? (T(), z("div", yt({
                  key: 0,
                  class: "flow-popover__link"
                }, o.$attrs), [
                  w(i, {
                    icon: "PFlow",
                    small: "",
                    class: "flow-popover__link-icon"
                  }),
                  re("span", {
                    class: "flow-popover__link-name",
                    title: v(r).name
                  }, ie(v(r).name), 9, A_e)
                ], 16)) : j("", !0)
              ]),
              _: 1
            }, 8, ["flow-id"])
          ])
        ]),
        default: k(() => [
          v(r) ? (T(), O(a, {
            key: 0,
            class: "flow-popover__card"
          }, {
            default: k(() => [
              w(l, null, {
                default: k(() => [
                  w(v(tv), { "flow-id": o.flowId }, {
                    default: k(() => [
                      v(r) ? (T(), z("div", D_e, [
                        w(i, {
                          icon: "PFlow",
                          small: "",
                          class: "flow-popover__link-icon"
                        }),
                        re("span", {
                          class: "flow-popover__link-name",
                          title: v(r).name
                        }, ie(v(r).name), 9, E_e)
                      ])) : j("", !0)
                    ]),
                    _: 1
                  }, 8, ["flow-id"]),
                  w(u, {
                    label: "Last run",
                    alternate: ""
                  }, {
                    value: k(() => [
                      w(v(kR), { "flow-id": o.flowId }, null, 8, ["flow-id"])
                    ]),
                    _: 1
                  }),
                  w(u, {
                    label: "Next run",
                    alternate: ""
                  }, {
                    value: k(() => [
                      w(v(RR), { "flow-id": o.flowId }, null, 8, ["flow-id"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })) : j("", !0)
        ]),
        _: 3
      });
    };
  }
}), M_e = { class: "flow-run-artifacts" }, P_e = { class: "flow-run-artifacts__button-group-container" }, C_e = { class: "flow-run-artifacts__none" }, O_e = { class: "flow-run-artifacts__none" }, I_e = /* @__PURE__ */ U({
  __name: "FlowRunArtifacts",
  props: {
    flowRun: {}
  },
  setup(t) {
    const e = t, { flowRun: n } = Nn(e), r = D(() => kp.value !== "grid"), o = Se(), s = je(), i = D(() => ({
      artifacts: {
        flowRunId: [e.flowRun.id],
        notType: ["result"]
      }
    })), u = x2(n), l = mt(o.artifacts.getArtifacts, [i], u), a = D(() => l.response ?? []), c = D(() => a.value.filter((g) => !!g.taskRunId)), p = D(() => a.value.filter((g) => !!g.flowRunId && !g.taskRunId)), d = D(() => l.executed && a.value.length > 0), h = D(() => fi(e.flowRun.state?.type)), m = D(() => l.executed && a.value.length === 0 ? h.value ? le.info.terminalFlowRunNoArtifacts : le.info.nonTerminalFlowRunNoArtifacts : "");
    return (g, _) => {
      const b = P("p-heading"), x = P("router-link"), S = P("p-markdown-renderer"), E = P("p-divider"), A = P("p-empty-state");
      return T(), z("div", M_e, [
        d.value ? (T(), z(ve, { key: 0 }, [
          re("div", P_e, [
            Ve(g.$slots, "actions"),
            w(S_, { class: "flow-run-artifacts__view-mode-button-group" })
          ]),
          w(b, {
            heading: "6",
            class: "flow-run-artifacts__subheading"
          }, {
            default: k(() => [
              q(ie(v(le).info.flowRun), 1)
            ]),
            _: 1
          }),
          w(W0, { items: p.value }, {
            default: k(({ item: C }) => [
              w(x, {
                to: v(s).artifact(C.id)
              }, {
                default: k(() => [
                  w(hh, {
                    artifact: C,
                    condense: r.value,
                    interactive: ""
                  }, null, 8, ["artifact", "condense"])
                ]),
                _: 2
              }, 1032, ["to"])
            ]),
            empty: k(() => [
              re("div", C_e, [
                w(S, {
                  text: v(le).info.none
                }, null, 8, ["text"])
              ])
            ]),
            _: 1
          }, 8, ["items"]),
          w(E),
          w(b, {
            heading: "6",
            class: "flow-run-artifacts__subheading"
          }, {
            default: k(() => [
              q(ie(v(le).info.taskRuns), 1)
            ]),
            _: 1
          }),
          w(W0, { items: c.value }, {
            default: k(({ item: C }) => [
              w(x, {
                to: v(s).artifact(C.id)
              }, {
                default: k(() => [
                  w(hh, {
                    artifact: C,
                    condense: r.value,
                    interactive: ""
                  }, null, 8, ["artifact", "condense"])
                ]),
                _: 2
              }, 1032, ["to"])
            ]),
            empty: k(() => [
              re("div", O_e, [
                w(S, {
                  text: v(le).info.none
                }, null, 8, ["text"])
              ])
            ]),
            _: 1
          }, 8, ["items"])
        ], 64)) : v(l).executed ? (T(), O(A, { key: 1 }, {
          description: k(() => [
            w(S, { text: m.value }, null, 8, ["text"])
          ]),
          _: 1
        })) : j("", !0)
      ]);
    };
  }
}), F_e = {
  key: 0,
  class: "flow-run-automation"
}, CL = /* @__PURE__ */ U({
  __name: "FlowRunAutomation",
  props: {
    flowRun: {}
  },
  setup(t) {
    const e = t, { events: n } = Pse(() => {
      if (!e.flowRun.expectedStartTime)
        return null;
      const o = Jv(e.flowRun.expectedStartTime, 5), s = E3(e.flowRun.expectedStartTime, 5);
      return {
        event: {
          name: ["prefect-cloud.automation.action.executed", "prefect.automation.action.executed"]
        },
        resource: {
          idPrefix: ["prefect-cloud.automation", "prefect.automation"]
        },
        related: {
          id: [`prefect.flow-run.${e.flowRun.id}`]
        },
        occurred: {
          since: s,
          until: o
        },
        limit: 1
      };
    }), r = D(() => {
      if (!n.value.length)
        return null;
      const [o] = n.value, { id: s, role: i } = r2(o.resource["prefect.resource.id"]);
      return i !== "automation" ? null : s;
    });
    return (o, s) => r.value ? (T(), z("div", F_e, [
      s[0] || (s[0] = re("span", null, "Automation", -1)),
      s[1] || (s[1] = q()),
      w(g4, { "automation-id": r.value }, null, 8, ["automation-id"])
    ])) : j("", !0);
  }
}), N_e = { class: "flow-run-cancel-modal__message" }, vS = /* @__PURE__ */ U({
  __name: "FlowRunCancelModal",
  props: /* @__PURE__ */ Br({
    flowRun: {}
  }, {
    showModal: { type: Boolean, required: !0 },
    showModalModifiers: {}
  }),
  emits: /* @__PURE__ */ Br(["update"], ["update:showModal"]),
  setup(t, { emit: e }) {
    const n = zn(t, "showModal"), r = e, o = Se(), s = ge(!1), i = ge(!1), { flowRuns: u, subscription: l } = Qp(() => ({
      flowRuns: {
        parentFlowRunId: [t.flowRun.id],
        state: {
          type: v8
        }
      }
    })), a = {
      type: "cancelling",
      name: "Cancelling"
    }, c = async () => {
      s.value = !0;
      try {
        await o.flowRuns.setFlowRunState(t.flowRun.id, { state: a }), i.value && await p(), r("update"), n.value = !1, He(le.success.cancelFlowRun, "success");
      } catch (h) {
        console.error(h);
        const m = Yt(h, le.error.cancelFlowRun);
        He(m, "error");
      } finally {
        s.value = !1;
      }
    };
    async function p() {
      await l.refresh();
      const h = u.value, m = 5, g = /* @__PURE__ */ new Set(), _ = /* @__PURE__ */ new Set();
      for (const S of h) {
        const E = d(S);
        g.add(E), _.add(E), E.finally(() => {
          _.delete(E);
        }), _.size >= m && await Promise.race(_);
      }
      const x = (await Promise.allSettled(g)).filter((S) => S.status === "rejected").map((S) => S.reason);
      if (x.length > 0)
        if (x.length === 1) {
          const S = Yt(x[0], le.error.cancelFlowRun);
          He(S, "error");
        } else
          He(le.error.cancelFlowRuns(x.length), "error");
    }
    async function d(h, m = 0) {
      try {
        await o.flowRuns.setFlowRunState(h.id, { state: a });
      } catch (g) {
        if (m < 2)
          return d(h, m + 1);
        throw g;
      }
    }
    return (h, m) => {
      const g = P("p-icon"), _ = P("p-label"), b = P("p-checkbox"), x = P("p-button"), S = P("p-modal");
      return h.flowRun ? (T(), O(S, {
        key: 0,
        showModal: n.value,
        "onUpdate:showModal": m[1] || (m[1] = (E) => n.value = E),
        title: "Cancel Flow Run"
      }, {
        icon: k(() => [
          w(g, {
            icon: "ExclamationCircleIcon",
            class: "flow-run-cancel-modal__icon"
          })
        ]),
        actions: k(() => [
          w(x, {
            variant: "destructive",
            loading: s.value,
            onClick: c
          }, {
            default: k(() => [...m[3] || (m[3] = [
              q(" Confirm ", -1)
            ])]),
            _: 1
          }, 8, ["loading"])
        ]),
        default: k(() => [
          w(_, { label: "Current Flow Run State" }, {
            default: k(() => [
              w(Dr, {
                state: h.flowRun.state
              }, null, 8, ["state"])
            ]),
            _: 1
          }),
          re("div", N_e, [
            q(" This will put flow run " + ie(h.flowRun.name) + " into a ", 1),
            w(Dr, { state: { name: "Cancelling", type: "cancelled" } }),
            m[2] || (m[2] = q(" state. ", -1))
          ]),
          v(u).length > 0 ? (T(), O(b, {
            key: 0,
            modelValue: i.value,
            "onUpdate:modelValue": m[0] || (m[0] = (E) => i.value = E),
            label: "Cancel all sub flow runs"
          }, null, 8, ["modelValue"])) : j("", !0)
        ]),
        _: 1
      }, 8, ["showModal"])) : j("", !0);
    };
  }
}), OL = /* @__PURE__ */ U({
  inheritAttrs: !1,
  __name: "FlowRunCancelButton",
  props: {
    flowRun: {}
  },
  emits: ["update"],
  setup(t, { emit: e }) {
    const n = e, r = Ke(), { showModal: o, open: s } = St(), i = D(() => !r.update.flow_run || !t.flowRun.stateType ? !1 : _8(t.flowRun.stateType)), u = D(() => !!(!t.flowRun.deploymentId && i.value));
    return (l, a) => {
      const c = P("p-button"), p = P("p-tooltip");
      return T(), z(ve, null, [
        u.value ? (T(), O(p, yt({
          key: 0,
          text: v(le).info.disableFlowRunCancel
        }, l.$attrs), {
          default: k(() => [
            w(c, {
              disabled: "",
              dangerous: ""
            }, {
              default: k(() => [...a[2] || (a[2] = [
                q(" Cancel ", -1)
              ])]),
              _: 1
            })
          ]),
          _: 1
        }, 16, ["text"])) : i.value ? (T(), O(c, {
          key: 1,
          dangerous: "",
          onClick: v(s)
        }, {
          default: k(() => [...a[3] || (a[3] = [
            q(" Cancel ", -1)
          ])]),
          _: 1
        }, 8, ["onClick"])) : j("", !0),
        w(vS, {
          showModal: v(o),
          "onUpdate:showModal": a[0] || (a[0] = (d) => Xe(o) ? o.value = d : null),
          "flow-run": l.flowRun,
          onUpdate: a[1] || (a[1] = (d) => n("update"))
        }, null, 8, ["showModal", "flow-run"])
      ], 64);
    };
  }
}), L_e = /* @__PURE__ */ U({
  __name: "FlowRunCreateFormTags",
  props: {
    deployment: {},
    tags: {}
  },
  emits: ["update:tags"],
  setup(t, { emit: e }) {
    const n = t, r = e, o = D({
      get() {
        return n.tags;
      },
      set(i) {
        r("update:tags", i);
      }
    }), s = D(() => n.deployment.tags?.map((i) => ({ label: i, value: i, disabled: !0 })));
    return (i, u) => {
      const l = P("p-tags-input");
      return T(), O(l, {
        modelValue: o.value,
        "onUpdate:modelValue": u[0] || (u[0] = (a) => o.value = a),
        class: "flow-run-create-form-tags",
        options: s.value
      }, null, 8, ["modelValue", "options"]);
    };
  }
}), B_e = /* @__PURE__ */ U({
  __name: "FlowRunCreateFormWhen",
  props: {
    start: {}
  },
  emits: ["update:start"],
  setup(t, { emit: e }) {
    const n = t, r = e, o = D({
      get() {
        return n.start;
      },
      set(l) {
        r("update:start", l);
      }
    }), s = ge("Now"), { state: i, error: u } = bn(o, Gte(() => s.value === "Later")("Start date"));
    return (l, a) => {
      const c = P("p-button-group"), p = P("p-label"), d = P("p-content");
      return T(), O(d, { class: "flow-run-create-form-when" }, {
        default: k(() => [
          w(c, {
            modelValue: s.value,
            "onUpdate:modelValue": a[0] || (a[0] = (h) => s.value = h),
            options: ["Now", "Later"],
            small: ""
          }, null, 8, ["modelValue"]),
          s.value == "Later" ? (T(), O(p, {
            key: 0,
            label: "Start date",
            message: v(u),
            state: v(i)
          }, {
            default: k(() => [
              w($0, {
                modelValue: o.value,
                "onUpdate:modelValue": a[1] || (a[1] = (h) => o.value = h),
                "show-time": ""
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["message", "state"])) : j("", !0)
        ]),
        _: 1
      });
    };
  }
}), _S = /* @__PURE__ */ U({
  __name: "WorkPoolQueueCombobox",
  props: {
    selected: {},
    workPoolName: {},
    emptyMessage: {},
    allowUnset: { type: Boolean }
  },
  emits: ["update:selected"],
  setup(t, { emit: e }) {
    const n = t, r = e, o = D(() => Array.isArray(n.selected)), s = D({
      get() {
        return n.selected ?? null;
      },
      set(p) {
        p ? o.value ? r("update:selected", Array.isArray(p) ? p : [p]) : r("update:selected", p) : r("update:selected", null);
      }
    }), i = Se(), u = D(() => n.workPoolName ? [n.workPoolName] : null), l = xt(i.workPoolQueues.getWorkPoolQueues, u), a = D(() => l.response ?? []), c = D(() => {
      const p = a.value.map((d) => ({
        value: d.name,
        label: d.name
      }));
      return n.allowUnset && p.unshift({
        value: null,
        label: "None"
      }), p;
    });
    return (p, d) => (T(), O(v(ts), {
      modelValue: s.value,
      "onUpdate:modelValue": d[0] || (d[0] = (h) => s.value = h),
      options: c.value,
      "empty-message": p.emptyMessage
    }, {
      "combobox-options-empty": k(() => [...d[1] || (d[1] = [
        q(" No work queues ", -1)
      ])]),
      default: k((h) => [
        Ve(p.$slots, "default", sn(kn(h)))
      ]),
      option: k(({ option: h }) => [
        Ve(p.$slots, "option", { option: h })
      ]),
      _: 3
    }, 8, ["modelValue", "options", "empty-message"]));
  }
}), U_e = /* @__PURE__ */ U({
  __name: "FlowRunCreateFormWorkQueueCombobox",
  props: {
    workQueueName: {},
    workPoolName: {}
  },
  emits: ["update:workQueueName"],
  setup(t, { emit: e }) {
    const n = t, r = e, { workPool: o } = Jm(() => n.workPoolName), s = D({
      get() {
        return n.workQueueName;
      },
      set(i) {
        r("update:workQueueName", i);
      }
    });
    return (i, u) => {
      const l = P("p-label");
      return v(o)?.isPushPool ? j("", !0) : (T(), O(l, {
        key: 0,
        label: `Work Queue for ${i.workPoolName} (Optional)`,
        class: "flow-run-create-form-work-queue-combobox"
      }, {
        default: k(() => [
          w(_S, {
            selected: s.value,
            "onUpdate:selected": u[0] || (u[0] = (a) => s.value = a),
            "work-pool-name": i.workPoolName
          }, null, 8, ["selected", "work-pool-name"])
        ]),
        _: 1
      }, 8, ["label"]));
    };
  }
}), wS = /* @__PURE__ */ U({
  __name: "JobVariableOverridesInput",
  props: {
    modelValue: {},
    modelModifiers: {}
  },
  emits: ["update:modelValue"],
  setup(t) {
    const e = zn(t, "modelValue");
    return (n, r) => (T(), O(Rr, {
      modelValue: e.value,
      "onUpdate:modelValue": r[0] || (r[0] = (o) => e.value = o),
      "show-line-numbers": "",
      "min-lines": 3,
      class: "job-variable-overrides-input",
      "show-format-button": ""
    }, null, 8, ["modelValue"]));
  }
}), X_e = { class: "flow-run-job-variable-overrides-labeled-input__label" }, L_ = /* @__PURE__ */ U({
  __name: "FlowRunJobVariableOverridesLabeledInput",
  props: {
    modelValue: {},
    modelModifiers: {}
  },
  emits: ["update:modelValue"],
  setup(t) {
    const e = zn(t, "modelValue"), { state: n, error: r } = bn(e, ml("Job variables"));
    return (o, s) => {
      const i = P("p-code"), u = P("p-label");
      return T(), O(u, {
        message: v(r),
        state: v(n)
      }, {
        label: k(() => [
          re("span", X_e, [
            s[4] || (s[4] = q(" Job Variables (Optional) ", -1)),
            w(yS, null, {
              default: k(() => [
                s[2] || (s[2] = q(" To use flow run job variables, make sure your workers are using ", -1)),
                w(i, { inline: "" }, {
                  default: k(() => [...s[1] || (s[1] = [
                    q(" prefect>=2.16.4 ", -1)
                  ])]),
                  _: 1
                }),
                s[3] || (s[3] = q(". ", -1))
              ]),
              _: 1
            })
          ])
        ]),
        default: k(() => [
          w(wS, {
            modelValue: e.value,
            "onUpdate:modelValue": s[0] || (s[0] = (l) => e.value = l),
            state: v(n)
          }, null, 8, ["modelValue", "state"])
        ]),
        _: 1
      }, 8, ["message", "state"]);
    };
  }
}), $_e = /* @__PURE__ */ U({
  __name: "FlowRunNameInput",
  props: {
    modelValue: {}
  },
  emits: ["update:modelValue"],
  setup(t, { emit: e }) {
    const n = t, r = e;
    wi(() => {
      n.modelValue || (o.value = s());
    });
    const o = D({
      get() {
        return n.modelValue;
      },
      set(i) {
        r("update:modelValue", i);
      }
    }), s = () => F2.create("runName");
    return (i, u) => {
      const l = P("p-button"), a = P("p-text-input");
      return T(), O(a, {
        modelValue: o.value,
        "onUpdate:modelValue": u[1] || (u[1] = (c) => o.value = c),
        class: "flow-run-name-input"
      }, {
        append: k(() => [
          w(l, {
            color: "primary",
            icon: "ArrowPathIcon",
            variant: "ghost",
            onClick: u[0] || (u[0] = (c) => o.value = s())
          })
        ]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }
}), W_e = { class: "flow-run-create-form-v2__header" }, V_e = { class: "flow-run-create-form-v2__retries" }, H_e = /* @__PURE__ */ U({
  __name: "FlowRunCreateForm",
  props: {
    deployment: {},
    parameters: {},
    disabled: { type: Boolean },
    name: {}
  },
  emits: ["submit", "cancel"],
  setup(t, { emit: e }) {
    const n = t, r = e, o = ge(n.deployment.enforceParameterSchema), s = D(() => n.deployment.parameterOpenApiSchema), i = D(() => !ru(n.deployment.parameterOpenApiSchema.properties ?? {})), { validate: u } = Ms(), l = ge(n.name), { state: a, error: c } = bn(l, Kr("name")), p = ge({ ...n.deployment.parameters, ...n.parameters ?? {} }), d = ge(null), h = ge(""), m = ge(n.deployment.tags ?? []), g = ge(n.deployment.workQueueName), _ = ge(null), b = ge(null), x = ge("{}"), { errors: S, validate: E } = Xh(s, p);
    async function A() {
      if (n.disabled)
        return;
      if (o.value)
        try {
          if (!(await Promise.all([
            u(),
            E()
          ])).every((L) => !!L))
            return;
        } catch (M) {
          console.error(M), He(Mm(u2), "error");
          return;
        }
      const C = {
        state: {
          type: "scheduled",
          message: h.value,
          stateDetails: {
            scheduledTime: d.value
          }
        },
        tags: m.value,
        workQueueName: g.value,
        empiricalPolicy: {
          retries: _.value,
          retryDelay: b.value,
          maxRetries: null,
          retryDelaySeconds: null,
          retryJitterFactor: null
        },
        name: l.value,
        parameters: p.value,
        jobVariables: x.value ? JSON.parse(x.value) : void 0,
        enforceParameterSchema: o.value
      };
      r("submit", C);
    }
    return (C, M) => {
      const L = P("p-label"), X = P("p-divider"), te = P("p-overflow-menu-item"), B = P("p-icon-button-menu"), W = P("p-checkbox"), G = P("p-content"), ne = P("p-textarea"), de = P("p-number-input"), V = P("p-accordion"), Y = P("p-button"), Q = P("p-form");
      return T(), O(Q, {
        class: "flow-run-create-form-v2 p-background",
        novalidate: "",
        onSubmit: A
      }, {
        footer: k(() => [
          w(Y, {
            onClick: M[10] || (M[10] = (ae) => r("cancel"))
          }, {
            default: k(() => [...M[12] || (M[12] = [
              q(" Cancel ", -1)
            ])]),
            _: 1
          }),
          w(Y, {
            variant: "default",
            type: "submit",
            disabled: C.disabled
          }, {
            default: k(() => [...M[13] || (M[13] = [
              q(" Submit ", -1)
            ])]),
            _: 1
          }, 8, ["disabled"])
        ]),
        default: k(() => [
          w(G, null, {
            default: k(() => [
              w(L, {
                label: "Run Name",
                state: v(a),
                message: v(c)
              }, {
                default: k(() => [
                  w($_e, {
                    modelValue: l.value,
                    "onUpdate:modelValue": M[0] || (M[0] = (ae) => l.value = ae),
                    state: v(a)
                  }, null, 8, ["modelValue", "state"])
                ]),
                _: 1
              }, 8, ["state", "message"]),
              i.value ? (T(), z(ve, { key: 0 }, [
                w(X),
                w(G, null, {
                  default: k(() => [
                    w(v(Uh), {
                      values: p.value,
                      "onUpdate:values": M[1] || (M[1] = (ae) => p.value = ae),
                      schema: s.value,
                      errors: v(S),
                      kinds: ["json", "workspace_variable"]
                    }, {
                      default: k(({ kind: ae, setKind: Z }) => [
                        re("div", W_e, [
                          re("h3", null, ie(v(le).info.parameters), 1),
                          w(B, { small: "" }, {
                            default: k(() => [
                              ae === "json" ? (T(), O(te, {
                                key: 0,
                                label: "Use form input",
                                onClick: (J) => Z("none")
                              }, null, 8, ["onClick"])) : j("", !0),
                              ae === "none" ? (T(), O(te, {
                                key: 1,
                                label: "Use JSON input",
                                onClick: (J) => Z("json")
                              }, null, 8, ["onClick"])) : j("", !0)
                            ]),
                            _: 2
                          }, 1024)
                        ])
                      ]),
                      _: 1
                    }, 8, ["values", "schema", "errors"]),
                    w(W, {
                      modelValue: o.value,
                      "onUpdate:modelValue": M[2] || (M[2] = (ae) => o.value = ae),
                      label: "Validate parameters"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ], 64)) : j("", !0),
              w(X),
              M[11] || (M[11] = re("h3", null, "Start", -1)),
              w(B_e, {
                start: d.value,
                "onUpdate:start": M[3] || (M[3] = (ae) => d.value = ae)
              }, null, 8, ["start"]),
              w(V, { sections: ["Additional Options"] }, {
                heading: k(({ section: ae }) => [
                  re("h3", null, ie(ae), 1)
                ]),
                content: k(() => [
                  w(G, { class: "pt-4" }, {
                    default: k(() => [
                      w(L, { label: "Message (Optional)" }, {
                        default: k(() => [
                          w(ne, {
                            modelValue: h.value,
                            "onUpdate:modelValue": M[4] || (M[4] = (ae) => h.value = ae),
                            placeholder: "Created from the Prefect UI"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      w(L, { label: "Tags (Optional)" }, {
                        default: k(() => [
                          w(L_e, {
                            tags: m.value,
                            "onUpdate:tags": M[5] || (M[5] = (ae) => m.value = ae),
                            deployment: C.deployment
                          }, null, 8, ["tags", "deployment"])
                        ]),
                        _: 1
                      }),
                      C.deployment.workPoolName ? (T(), O(U_e, {
                        key: 0,
                        "work-queue-name": g.value,
                        "onUpdate:workQueueName": M[6] || (M[6] = (ae) => g.value = ae),
                        "work-pool-name": C.deployment.workPoolName
                      }, null, 8, ["work-queue-name", "work-pool-name"])) : j("", !0),
                      re("div", V_e, [
                        w(L, { label: "Retries (Optional)" }, {
                          default: k(() => [
                            w(de, {
                              modelValue: _.value,
                              "onUpdate:modelValue": M[7] || (M[7] = (ae) => _.value = ae),
                              min: 0
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        w(L, { label: "Retry Delay (Optional)" }, {
                          default: k(() => [
                            w(de, {
                              modelValue: b.value,
                              "onUpdate:modelValue": M[8] || (M[8] = (ae) => b.value = ae),
                              min: 0,
                              append: "Seconds"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      w(L_, {
                        modelValue: x.value,
                        "onUpdate:modelValue": M[9] || (M[9] = (ae) => x.value = ae)
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      });
    };
  }
}), j_e = { class: "flow-run-details" }, z_e = /* @__PURE__ */ U({
  __name: "FlowRunDetails",
  props: {
    flowRun: {},
    alternate: { type: Boolean }
  },
  setup(t) {
    const e = t, n = D(() => e.alternate ? 6 : 5), r = D(() => e.flowRun.state?.message);
    return (o, s) => {
      const i = P("p-text-truncate"), u = P("p-divider"), l = P("p-heading");
      return T(), z("div", j_e, [
        w(v(Lt), {
          label: "Run Count",
          value: o.flowRun.runCount ?? 0,
          alternate: o.alternate
        }, null, 8, ["value", "alternate"]),
        w(v(Lt), {
          label: "Created",
          alternate: o.alternate
        }, {
          value: k(() => [
            w(hn, {
              date: o.flowRun.created,
              format: "numeric"
            }, null, 8, ["date"])
          ]),
          _: 1
        }, 8, ["alternate"]),
        o.flowRun.createdBy ? (T(), O(v(Lt), {
          key: 0,
          label: "Created By",
          value: o.flowRun.createdBy.displayValue,
          alternate: o.alternate
        }, null, 8, ["value", "alternate"])) : j("", !0),
        w(v(Lt), {
          label: "Last Updated",
          alternate: o.alternate
        }, {
          value: k(() => [
            w(hn, {
              date: o.flowRun.updated,
              format: "numeric"
            }, null, 8, ["date"])
          ]),
          _: 1
        }, 8, ["alternate"]),
        o.flowRun.idempotencyKey ? (T(), O(v(Lt), {
          key: 1,
          label: "Idempotency Key",
          value: o.flowRun.idempotencyKey,
          alternate: o.alternate
        }, null, 8, ["value", "alternate"])) : j("", !0),
        w(v(Lt), {
          label: "Tags",
          alternate: o.alternate
        }, Ut({ _: 2 }, [
          o.flowRun.tags?.length ? {
            name: "value",
            fn: k(() => [
              w(v(am), {
                tags: o.flowRun.tags
              }, null, 8, ["tags"])
            ]),
            key: "0"
          } : void 0
        ]), 1032, ["alternate"]),
        w(v(Lt), {
          label: "Flow Run ID",
          value: o.flowRun.id,
          alternate: o.alternate
        }, null, 8, ["value", "alternate"]),
        w(v(Lt), {
          label: "State Message",
          alternate: o.alternate
        }, Ut({ _: 2 }, [
          r.value ? {
            name: "value",
            fn: k(() => [
              w(i, { text: r.value }, null, 8, ["text"])
            ]),
            key: "0"
          } : void 0
        ]), 1032, ["alternate"]),
        o.flowRun.flowVersion || o.flowRun.empiricalPolicy ? (T(), z(ve, { key: 2 }, [
          w(u),
          w(l, { heading: n.value }, {
            default: k(() => [...s[0] || (s[0] = [
              q(" Flow configuration ", -1)
            ])]),
            _: 1
          }, 8, ["heading"]),
          w(v(Lt), {
            label: "Flow Version",
            value: o.flowRun.flowVersion,
            alternate: o.alternate
          }, null, 8, ["value", "alternate"]),
          o.flowRun.empiricalPolicy ? (T(), z(ve, { key: 0 }, [
            w(v(Lt), {
              label: "Retries",
              value: o.flowRun.empiricalPolicy.retries,
              alternate: o.alternate
            }, null, 8, ["value", "alternate"]),
            w(v(Lt), {
              label: "Retry Delay",
              value: `${o.flowRun.empiricalPolicy.retryDelaySeconds}s`,
              alternate: o.alternate
            }, null, 8, ["value", "alternate"])
          ], 64)) : j("", !0)
        ], 64)) : j("", !0)
      ]);
    };
  }
}), q_e = /* @__PURE__ */ U({
  __name: "FlowRunFilteredList",
  props: {
    filter: {},
    selectable: { type: Boolean },
    prefix: {},
    hideDetails: { type: Boolean },
    hideFlowName: { type: Boolean }
  },
  setup(t) {
    const e = t, n = Ke(), r = ge([]), o = ge(""), s = ns(o, 500), { value: i } = hl("flow-run-list-limit", 10), { filter: u, clear: l, isCustomFilter: a } = dN($t({}, e.filter, {
      flowRuns: {
        nameLike: s
      },
      limit: i
    }), e.prefix), { flowRuns: c, count: p, pages: d, subscription: h, errored: m, error: g } = kN(u, {
      interval: 3e4
    }), _ = D(() => h.executed && c.value.length === 0), b = () => {
      r.value = [], h.refresh();
    };
    return (x, S) => {
      const E = P("p-select-all-checkbox"), A = P("p-list-header"), C = P("p-button"), M = P("p-empty-results"), L = P("p-pager"), X = P("p-content");
      return T(), O(X, { class: "flow-run-filtered-list" }, {
        default: k(() => [
          w(A, { sticky: "" }, {
            controls: k(() => [
              w(Wo, {
                modelValue: o.value,
                "onUpdate:modelValue": S[1] || (S[1] = (te) => o.value = te),
                placeholder: "Search by run name",
                label: "Search by run name",
                class: "flow-run-filtered-list__search"
              }, null, 8, ["modelValue"]),
              w(v(qh), {
                selected: v(u).flowRuns.state.name,
                "onUpdate:selected": S[2] || (S[2] = (te) => v(u).flowRuns.state.name = te),
                multiple: "",
                "empty-message": "All run states"
              }, null, 8, ["selected"])
            ]),
            sort: k(() => [
              w(v(qU), {
                modelValue: v(u).sort,
                "onUpdate:modelValue": S[3] || (S[3] = (te) => v(u).sort = te)
              }, null, 8, ["modelValue"])
            ]),
            default: k(() => [
              x.selectable ? (T(), O(E, {
                key: 0,
                modelValue: r.value,
                "onUpdate:modelValue": S[0] || (S[0] = (te) => r.value = te),
                selectable: v(c).map((te) => te.id),
                "item-name": "flow run"
              }, null, 8, ["modelValue", "selectable"])) : j("", !0),
              r.value.length == 0 ? (T(), O(v(Uo), {
                key: 1,
                count: v(p),
                label: "Flow run"
              }, null, 8, ["count"])) : (T(), O(v(td), {
                key: 2,
                count: r.value.length
              }, null, 8, ["count"])),
              v(n).delete.flow_run ? (T(), O(v(zU), {
                key: 3,
                selected: r.value,
                onDelete: b
              }, null, 8, ["selected"])) : j("", !0)
            ]),
            _: 1
          }),
          _.value ? (T(), O(M, { key: 0 }, Ut({
            message: k(() => [
              v(m) ? Ve(x.$slots, "error-message", sn(yt({ key: 0 }, { error: v(g) })), () => [
                q(ie(v(le).error.readFlowRuns), 1)
              ]) : Ve(x.$slots, "empty-message", { key: 1 }, () => [
                S[7] || (S[7] = q(" No runs found ", -1))
              ])
            ]),
            _: 2
          }, [
            v(a) ? {
              name: "actions",
              fn: k(() => [
                w(C, {
                  size: "sm",
                  onClick: v(l)
                }, {
                  default: k(() => [...S[8] || (S[8] = [
                    q(" Clear Filters ", -1)
                  ])]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              key: "0"
            } : void 0
          ]), 1024)) : (T(), z(ve, { key: 1 }, [
            w(v(sw), {
              selected: r.value,
              "onUpdate:selected": S[4] || (S[4] = (te) => r.value = te),
              "hide-details": x.hideDetails,
              "hide-flow-name": x.hideFlowName,
              "flow-runs": v(c),
              selectable: x.selectable && v(n).delete.flow_run
            }, null, 8, ["selected", "hide-details", "hide-flow-name", "flow-runs", "selectable"]),
            w(L, {
              limit: v(u).limit,
              "onUpdate:limit": S[5] || (S[5] = (te) => v(u).limit = te),
              page: v(u).page,
              "onUpdate:page": S[6] || (S[6] = (te) => v(u).page = te),
              pages: v(d)
            }, null, 8, ["limit", "page", "pages"])
          ], 64))
        ]),
        _: 3
      });
    };
  }
}), G_e = { class: "flow-run-graph-confirmation__confirmation-header" }, Y_e = { class: "flow-run-graph-confirmation__confirmation-message" }, IL = /* @__PURE__ */ U({
  __name: "FlowRunGraphConfirmation",
  emits: ["confirm"],
  setup(t, { emit: e }) {
    const n = e, r = () => {
      n("confirm");
    };
    return (o, s) => {
      const i = P("p-icon"), u = P("p-button"), l = P("p-card");
      return T(), O(l, { class: "flow-run-graph-confirmation" }, {
        default: k(() => [
          w(i, {
            class: "flow-run-graph-confirmation__confirmation-icon",
            icon: "ExclamationCircleIcon"
          }),
          re("h3", G_e, ie(v(le).info.flowRunGraphNotDisplayedHeader), 1),
          re("p", Y_e, ie(v(le).info.flowRunGraphNotDisplayedCopy), 1),
          w(u, { onClick: r }, {
            default: k(() => [
              q(ie(v(le).info.flowRunGraphNotDisplayedCta), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      });
    };
  }
}), Q_e = {
  markdown: "ArtifactMarkdown",
  table: "ArtifactTable",
  result: "ArtifactResult",
  image: "ArtifactImage",
  progress: "ArtifactProgress",
  unknown: "Artifact"
}, K_e = ["flow-run", "task-run"];
function Gk(t) {
  return K_e.includes(t.kind);
}
function FL(t) {
  return t.kind === "artifact";
}
function Z_e(t) {
  return t.kind === "artifacts";
}
function J_e(t) {
  return t.kind === "state";
}
function ewe(t) {
  return t.kind === "event";
}
function twe(t) {
  return t.kind === "events";
}
function nwe(t) {
  return ["waterfall", "nearest-parent", "duration-sorted"].includes(t);
}
function rwe(t) {
  return ["temporal", "dependency", "left-aligned"].includes(t);
}
const NL = "nodes-container", owe = "node-container", swe = "edge-container", awe = 1, LL = 20, iwe = 200, uwe = 0.2, lwe = 0.2, cwe = 0.2, pwe = 0.1, BL = 10, UL = 4, XL = 20, LM = 64, BM = 0.25, UM = 30, dwe = 260, $L = 250, hwe = 1, fwe = 2, mwe = 3, ywe = 4, WL = 0, VL = 2, gwe = 1, vwe = 2, _we = 3, HL = 4, nv = 5;
var nd = /* @__PURE__ */ ((t) => (t[t.WEBGL_LEGACY = 0] = "WEBGL_LEGACY", t[t.WEBGL = 1] = "WEBGL", t[t.WEBGL2 = 2] = "WEBGL2", t))(nd || {}), jL = /* @__PURE__ */ ((t) => (t[t.UNKNOWN = 0] = "UNKNOWN", t[t.WEBGL = 1] = "WEBGL", t[t.CANVAS = 2] = "CANVAS", t))(jL || {}), Yk = /* @__PURE__ */ ((t) => (t[t.COLOR = 16384] = "COLOR", t[t.DEPTH = 256] = "DEPTH", t[t.STENCIL = 1024] = "STENCIL", t))(Yk || {}), Mt = /* @__PURE__ */ ((t) => (t[t.NORMAL = 0] = "NORMAL", t[t.ADD = 1] = "ADD", t[t.MULTIPLY = 2] = "MULTIPLY", t[t.SCREEN = 3] = "SCREEN", t[t.OVERLAY = 4] = "OVERLAY", t[t.DARKEN = 5] = "DARKEN", t[t.LIGHTEN = 6] = "LIGHTEN", t[t.COLOR_DODGE = 7] = "COLOR_DODGE", t[t.COLOR_BURN = 8] = "COLOR_BURN", t[t.HARD_LIGHT = 9] = "HARD_LIGHT", t[t.SOFT_LIGHT = 10] = "SOFT_LIGHT", t[t.DIFFERENCE = 11] = "DIFFERENCE", t[t.EXCLUSION = 12] = "EXCLUSION", t[t.HUE = 13] = "HUE", t[t.SATURATION = 14] = "SATURATION", t[t.COLOR = 15] = "COLOR", t[t.LUMINOSITY = 16] = "LUMINOSITY", t[t.NORMAL_NPM = 17] = "NORMAL_NPM", t[t.ADD_NPM = 18] = "ADD_NPM", t[t.SCREEN_NPM = 19] = "SCREEN_NPM", t[t.NONE = 20] = "NONE", t[t.SRC_OVER = 0] = "SRC_OVER", t[t.SRC_IN = 21] = "SRC_IN", t[t.SRC_OUT = 22] = "SRC_OUT", t[t.SRC_ATOP = 23] = "SRC_ATOP", t[t.DST_OVER = 24] = "DST_OVER", t[t.DST_IN = 25] = "DST_IN", t[t.DST_OUT = 26] = "DST_OUT", t[t.DST_ATOP = 27] = "DST_ATOP", t[t.ERASE = 26] = "ERASE", t[t.SUBTRACT = 28] = "SUBTRACT", t[t.XOR = 29] = "XOR", t))(Mt || {}), Zi = /* @__PURE__ */ ((t) => (t[t.POINTS = 0] = "POINTS", t[t.LINES = 1] = "LINES", t[t.LINE_LOOP = 2] = "LINE_LOOP", t[t.LINE_STRIP = 3] = "LINE_STRIP", t[t.TRIANGLES = 4] = "TRIANGLES", t[t.TRIANGLE_STRIP = 5] = "TRIANGLE_STRIP", t[t.TRIANGLE_FAN = 6] = "TRIANGLE_FAN", t))(Zi || {}), qe = /* @__PURE__ */ ((t) => (t[t.RGBA = 6408] = "RGBA", t[t.RGB = 6407] = "RGB", t[t.RG = 33319] = "RG", t[t.RED = 6403] = "RED", t[t.RGBA_INTEGER = 36249] = "RGBA_INTEGER", t[t.RGB_INTEGER = 36248] = "RGB_INTEGER", t[t.RG_INTEGER = 33320] = "RG_INTEGER", t[t.RED_INTEGER = 36244] = "RED_INTEGER", t[t.ALPHA = 6406] = "ALPHA", t[t.LUMINANCE = 6409] = "LUMINANCE", t[t.LUMINANCE_ALPHA = 6410] = "LUMINANCE_ALPHA", t[t.DEPTH_COMPONENT = 6402] = "DEPTH_COMPONENT", t[t.DEPTH_STENCIL = 34041] = "DEPTH_STENCIL", t))(qe || {}), Gd = /* @__PURE__ */ ((t) => (t[t.TEXTURE_2D = 3553] = "TEXTURE_2D", t[t.TEXTURE_CUBE_MAP = 34067] = "TEXTURE_CUBE_MAP", t[t.TEXTURE_2D_ARRAY = 35866] = "TEXTURE_2D_ARRAY", t[t.TEXTURE_CUBE_MAP_POSITIVE_X = 34069] = "TEXTURE_CUBE_MAP_POSITIVE_X", t[t.TEXTURE_CUBE_MAP_NEGATIVE_X = 34070] = "TEXTURE_CUBE_MAP_NEGATIVE_X", t[t.TEXTURE_CUBE_MAP_POSITIVE_Y = 34071] = "TEXTURE_CUBE_MAP_POSITIVE_Y", t[t.TEXTURE_CUBE_MAP_NEGATIVE_Y = 34072] = "TEXTURE_CUBE_MAP_NEGATIVE_Y", t[t.TEXTURE_CUBE_MAP_POSITIVE_Z = 34073] = "TEXTURE_CUBE_MAP_POSITIVE_Z", t[t.TEXTURE_CUBE_MAP_NEGATIVE_Z = 34074] = "TEXTURE_CUBE_MAP_NEGATIVE_Z", t))(Gd || {}), _t = /* @__PURE__ */ ((t) => (t[t.UNSIGNED_BYTE = 5121] = "UNSIGNED_BYTE", t[t.UNSIGNED_SHORT = 5123] = "UNSIGNED_SHORT", t[t.UNSIGNED_SHORT_5_6_5 = 33635] = "UNSIGNED_SHORT_5_6_5", t[t.UNSIGNED_SHORT_4_4_4_4 = 32819] = "UNSIGNED_SHORT_4_4_4_4", t[t.UNSIGNED_SHORT_5_5_5_1 = 32820] = "UNSIGNED_SHORT_5_5_5_1", t[t.UNSIGNED_INT = 5125] = "UNSIGNED_INT", t[t.UNSIGNED_INT_10F_11F_11F_REV = 35899] = "UNSIGNED_INT_10F_11F_11F_REV", t[t.UNSIGNED_INT_2_10_10_10_REV = 33640] = "UNSIGNED_INT_2_10_10_10_REV", t[t.UNSIGNED_INT_24_8 = 34042] = "UNSIGNED_INT_24_8", t[t.UNSIGNED_INT_5_9_9_9_REV = 35902] = "UNSIGNED_INT_5_9_9_9_REV", t[t.BYTE = 5120] = "BYTE", t[t.SHORT = 5122] = "SHORT", t[t.INT = 5124] = "INT", t[t.FLOAT = 5126] = "FLOAT", t[t.FLOAT_32_UNSIGNED_INT_24_8_REV = 36269] = "FLOAT_32_UNSIGNED_INT_24_8_REV", t[t.HALF_FLOAT = 36193] = "HALF_FLOAT", t))(_t || {}), st = /* @__PURE__ */ ((t) => (t[t.FLOAT = 0] = "FLOAT", t[t.INT = 1] = "INT", t[t.UINT = 2] = "UINT", t))(st || {}), qu = /* @__PURE__ */ ((t) => (t[t.NEAREST = 0] = "NEAREST", t[t.LINEAR = 1] = "LINEAR", t))(qu || {}), su = /* @__PURE__ */ ((t) => (t[t.CLAMP = 33071] = "CLAMP", t[t.REPEAT = 10497] = "REPEAT", t[t.MIRRORED_REPEAT = 33648] = "MIRRORED_REPEAT", t))(su || {}), yu = /* @__PURE__ */ ((t) => (t[t.OFF = 0] = "OFF", t[t.POW2 = 1] = "POW2", t[t.ON = 2] = "ON", t[t.ON_MANUAL = 3] = "ON_MANUAL", t))(yu || {}), gs = /* @__PURE__ */ ((t) => (t[t.NPM = 0] = "NPM", t[t.UNPACK = 1] = "UNPACK", t[t.PMA = 2] = "PMA", t[t.NO_PREMULTIPLIED_ALPHA = 0] = "NO_PREMULTIPLIED_ALPHA", t[t.PREMULTIPLY_ON_UPLOAD = 1] = "PREMULTIPLY_ON_UPLOAD", t[t.PREMULTIPLIED_ALPHA = 2] = "PREMULTIPLIED_ALPHA", t))(gs || {}), Gi = /* @__PURE__ */ ((t) => (t[t.NO = 0] = "NO", t[t.YES = 1] = "YES", t[t.AUTO = 2] = "AUTO", t[t.BLEND = 0] = "BLEND", t[t.CLEAR = 1] = "CLEAR", t[t.BLIT = 2] = "BLIT", t))(Gi || {}), bS = /* @__PURE__ */ ((t) => (t[t.AUTO = 0] = "AUTO", t[t.MANUAL = 1] = "MANUAL", t))(bS || {}), Ra = /* @__PURE__ */ ((t) => (t.LOW = "lowp", t.MEDIUM = "mediump", t.HIGH = "highp", t))(Ra || {}), io = /* @__PURE__ */ ((t) => (t[t.NONE = 0] = "NONE", t[t.SCISSOR = 1] = "SCISSOR", t[t.STENCIL = 2] = "STENCIL", t[t.SPRITE = 3] = "SPRITE", t[t.COLOR = 4] = "COLOR", t))(io || {}), jr = /* @__PURE__ */ ((t) => (t[t.NONE = 0] = "NONE", t[t.LOW = 2] = "LOW", t[t.MEDIUM = 4] = "MEDIUM", t[t.HIGH = 8] = "HIGH", t))(jr || {}), au = /* @__PURE__ */ ((t) => (t[t.ELEMENT_ARRAY_BUFFER = 34963] = "ELEMENT_ARRAY_BUFFER", t[t.ARRAY_BUFFER = 34962] = "ARRAY_BUFFER", t[t.UNIFORM_BUFFER = 35345] = "UNIFORM_BUFFER", t))(au || {});
const wwe = {
  /**
   * Creates a canvas element of the given size.
   * This canvas is created using the browser's native canvas element.
   * @param width - width of the canvas
   * @param height - height of the canvas
   */
  createCanvas: (t, e) => {
    const n = document.createElement("canvas");
    return n.width = t, n.height = e, n;
  },
  getCanvasRenderingContext2D: () => CanvasRenderingContext2D,
  getWebGLRenderingContext: () => WebGLRenderingContext,
  getNavigator: () => navigator,
  getBaseUrl: () => document.baseURI ?? window.location.href,
  getFontFaceSet: () => document.fonts,
  fetch: (t, e) => fetch(t, e),
  parseXML: (t) => new DOMParser().parseFromString(t, "text/xml")
}, at = {
  /**
   * This adapter is used to call methods that are platform dependent.
   * For example `document.createElement` only runs on the web but fails in node environments.
   * This allows us to support more platforms by abstracting away specific implementations per platform.
   *
   * By default the adapter is set to work in the browser. However you can create your own
   * by implementing the `IAdapter` interface. See `IAdapter` for more information.
   * @name ADAPTER
   * @memberof PIXI.settings
   * @type {PIXI.IAdapter}
   * @default PIXI.BrowserAdapter
   */
  ADAPTER: wwe,
  /**
   * Default resolution / device pixel ratio of the renderer.
   * @static
   * @name RESOLUTION
   * @memberof PIXI.settings
   * @type {number}
   * @default 1
   */
  RESOLUTION: 1,
  /**
   * Enables bitmap creation before image load. This feature is experimental.
   * @static
   * @name CREATE_IMAGE_BITMAP
   * @memberof PIXI.settings
   * @type {boolean}
   * @default false
   */
  CREATE_IMAGE_BITMAP: !1,
  /**
   * If true PixiJS will Math.floor() x/y values when rendering, stopping pixel interpolation.
   * Advantages can include sharper image quality (like text) and faster rendering on canvas.
   * The main disadvantage is movement of objects may appear less smooth.
   * @static
   * @memberof PIXI.settings
   * @type {boolean}
   * @default false
   */
  ROUND_PIXELS: !1
};
var F1 = /iPhone/i, XM = /iPod/i, $M = /iPad/i, WM = /\biOS-universal(?:.+)Mac\b/i, N1 = /\bAndroid(?:.+)Mobile\b/i, VM = /Android/i, kd = /(?:SD4930UR|\bSilk(?:.+)Mobile\b)/i, dg = /Silk/i, Xu = /Windows Phone/i, HM = /\bWindows(?:.+)ARM\b/i, jM = /BlackBerry/i, zM = /BB10/i, qM = /Opera Mini/i, GM = /\b(CriOS|Chrome)(?:.+)Mobile/i, YM = /Mobile(?:.+)Firefox\b/i, QM = function(t) {
  return typeof t < "u" && t.platform === "MacIntel" && typeof t.maxTouchPoints == "number" && t.maxTouchPoints > 1 && typeof MSStream > "u";
};
function bwe(t) {
  return function(e) {
    return e.test(t);
  };
}
function KM(t) {
  var e = {
    userAgent: "",
    platform: "",
    maxTouchPoints: 0
  };
  !t && typeof navigator < "u" ? e = {
    userAgent: navigator.userAgent,
    platform: navigator.platform,
    maxTouchPoints: navigator.maxTouchPoints || 0
  } : typeof t == "string" ? e.userAgent = t : t && t.userAgent && (e = {
    userAgent: t.userAgent,
    platform: t.platform,
    maxTouchPoints: t.maxTouchPoints || 0
  });
  var n = e.userAgent, r = n.split("[FBAN");
  typeof r[1] < "u" && (n = r[0]), r = n.split("Twitter"), typeof r[1] < "u" && (n = r[0]);
  var o = bwe(n), s = {
    apple: {
      phone: o(F1) && !o(Xu),
      ipod: o(XM),
      tablet: !o(F1) && (o($M) || QM(e)) && !o(Xu),
      universal: o(WM),
      device: (o(F1) || o(XM) || o($M) || o(WM) || QM(e)) && !o(Xu)
    },
    amazon: {
      phone: o(kd),
      tablet: !o(kd) && o(dg),
      device: o(kd) || o(dg)
    },
    android: {
      phone: !o(Xu) && o(kd) || !o(Xu) && o(N1),
      tablet: !o(Xu) && !o(kd) && !o(N1) && (o(dg) || o(VM)),
      device: !o(Xu) && (o(kd) || o(dg) || o(N1) || o(VM)) || o(/\bokhttp\b/i)
    },
    windows: {
      phone: o(Xu),
      tablet: o(HM),
      device: o(Xu) || o(HM)
    },
    other: {
      blackberry: o(jM),
      blackberry10: o(zM),
      opera: o(qM),
      firefox: o(YM),
      chrome: o(GM),
      device: o(jM) || o(zM) || o(qM) || o(YM) || o(GM)
    },
    any: !1,
    phone: !1,
    tablet: !1
  };
  return s.any = s.apple.device || s.android.device || s.windows.device || s.other.device, s.phone = s.apple.phone || s.android.phone || s.windows.phone, s.tablet = s.apple.tablet || s.android.tablet || s.windows.tablet, s;
}
const kwe = KM.default ?? KM, Gu = kwe(globalThis.navigator);
at.RETINA_PREFIX = /@([0-9\.]+)x/;
at.FAIL_IF_MAJOR_PERFORMANCE_CAVEAT = !1;
var Aa = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function iy(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
function Twe(t) {
  if (Object.prototype.hasOwnProperty.call(t, "__esModule")) return t;
  var e = t.default;
  if (typeof e == "function") {
    var n = function r() {
      var o = !1;
      try {
        o = this instanceof r;
      } catch {
      }
      return o ? Reflect.construct(e, arguments, this.constructor) : e.apply(this, arguments);
    };
    n.prototype = e.prototype;
  } else n = {};
  return Object.defineProperty(n, "__esModule", { value: !0 }), Object.keys(t).forEach(function(r) {
    var o = Object.getOwnPropertyDescriptor(t, r);
    Object.defineProperty(n, r, o.get ? o : {
      enumerable: !0,
      get: function() {
        return t[r];
      }
    });
  }), n;
}
var ZM = { exports: {} }, JM;
function xwe() {
  return JM || (JM = 1, function(t) {
    var e = Object.prototype.hasOwnProperty, n = "~";
    function r() {
    }
    Object.create && (r.prototype = /* @__PURE__ */ Object.create(null), new r().__proto__ || (n = !1));
    function o(l, a, c) {
      this.fn = l, this.context = a, this.once = c || !1;
    }
    function s(l, a, c, p, d) {
      if (typeof c != "function")
        throw new TypeError("The listener must be a function");
      var h = new o(c, p || l, d), m = n ? n + a : a;
      return l._events[m] ? l._events[m].fn ? l._events[m] = [l._events[m], h] : l._events[m].push(h) : (l._events[m] = h, l._eventsCount++), l;
    }
    function i(l, a) {
      --l._eventsCount === 0 ? l._events = new r() : delete l._events[a];
    }
    function u() {
      this._events = new r(), this._eventsCount = 0;
    }
    u.prototype.eventNames = function() {
      var l = [], a, c;
      if (this._eventsCount === 0) return l;
      for (c in a = this._events)
        e.call(a, c) && l.push(n ? c.slice(1) : c);
      return Object.getOwnPropertySymbols ? l.concat(Object.getOwnPropertySymbols(a)) : l;
    }, u.prototype.listeners = function(l) {
      var a = n ? n + l : l, c = this._events[a];
      if (!c) return [];
      if (c.fn) return [c.fn];
      for (var p = 0, d = c.length, h = new Array(d); p < d; p++)
        h[p] = c[p].fn;
      return h;
    }, u.prototype.listenerCount = function(l) {
      var a = n ? n + l : l, c = this._events[a];
      return c ? c.fn ? 1 : c.length : 0;
    }, u.prototype.emit = function(l, a, c, p, d, h) {
      var m = n ? n + l : l;
      if (!this._events[m]) return !1;
      var g = this._events[m], _ = arguments.length, b, x;
      if (g.fn) {
        switch (g.once && this.removeListener(l, g.fn, void 0, !0), _) {
          case 1:
            return g.fn.call(g.context), !0;
          case 2:
            return g.fn.call(g.context, a), !0;
          case 3:
            return g.fn.call(g.context, a, c), !0;
          case 4:
            return g.fn.call(g.context, a, c, p), !0;
          case 5:
            return g.fn.call(g.context, a, c, p, d), !0;
          case 6:
            return g.fn.call(g.context, a, c, p, d, h), !0;
        }
        for (x = 1, b = new Array(_ - 1); x < _; x++)
          b[x - 1] = arguments[x];
        g.fn.apply(g.context, b);
      } else {
        var S = g.length, E;
        for (x = 0; x < S; x++)
          switch (g[x].once && this.removeListener(l, g[x].fn, void 0, !0), _) {
            case 1:
              g[x].fn.call(g[x].context);
              break;
            case 2:
              g[x].fn.call(g[x].context, a);
              break;
            case 3:
              g[x].fn.call(g[x].context, a, c);
              break;
            case 4:
              g[x].fn.call(g[x].context, a, c, p);
              break;
            default:
              if (!b) for (E = 1, b = new Array(_ - 1); E < _; E++)
                b[E - 1] = arguments[E];
              g[x].fn.apply(g[x].context, b);
          }
      }
      return !0;
    }, u.prototype.on = function(l, a, c) {
      return s(this, l, a, c, !1);
    }, u.prototype.once = function(l, a, c) {
      return s(this, l, a, c, !0);
    }, u.prototype.removeListener = function(l, a, c, p) {
      var d = n ? n + l : l;
      if (!this._events[d]) return this;
      if (!a)
        return i(this, d), this;
      var h = this._events[d];
      if (h.fn)
        h.fn === a && (!p || h.once) && (!c || h.context === c) && i(this, d);
      else {
        for (var m = 0, g = [], _ = h.length; m < _; m++)
          (h[m].fn !== a || p && !h[m].once || c && h[m].context !== c) && g.push(h[m]);
        g.length ? this._events[d] = g.length === 1 ? g[0] : g : i(this, d);
      }
      return this;
    }, u.prototype.removeAllListeners = function(l) {
      var a;
      return l ? (a = n ? n + l : l, this._events[a] && i(this, a)) : (this._events = new r(), this._eventsCount = 0), this;
    }, u.prototype.off = u.prototype.removeListener, u.prototype.addListener = u.prototype.on, u.prefixed = n, u.EventEmitter = u, t.exports = u;
  }(ZM)), ZM.exports;
}
var Swe = xwe();
const uy = /* @__PURE__ */ iy(Swe);
var hg = { exports: {} }, eP;
function Rwe() {
  if (eP) return hg.exports;
  eP = 1, hg.exports = t, hg.exports.default = t;
  function t(V, Y, Q) {
    Q = Q || 2;
    var ae = Y && Y.length, Z = ae ? Y[0] * Q : V.length, J = e(V, 0, Z, Q, !0), oe = [];
    if (!J || J.next === J.prev) return oe;
    var ue, me, pe, Be, Ie, Me, fe;
    if (ae && (J = l(V, Y, J, Q)), V.length > 80 * Q) {
      ue = pe = V[0], me = Be = V[1];
      for (var Te = Q; Te < Z; Te += Q)
        Ie = V[Te], Me = V[Te + 1], Ie < ue && (ue = Ie), Me < me && (me = Me), Ie > pe && (pe = Ie), Me > Be && (Be = Me);
      fe = Math.max(pe - ue, Be - me), fe = fe !== 0 ? 32767 / fe : 0;
    }
    return r(J, oe, Q, ue, me, fe, 0), oe;
  }
  function e(V, Y, Q, ae, Z) {
    var J, oe;
    if (Z === de(V, Y, Q, ae) > 0)
      for (J = Y; J < Q; J += ae) oe = W(J, V[J], V[J + 1], oe);
    else
      for (J = Q - ae; J >= Y; J -= ae) oe = W(J, V[J], V[J + 1], oe);
    return oe && E(oe, oe.next) && (G(oe), oe = oe.next), oe;
  }
  function n(V, Y) {
    if (!V) return V;
    Y || (Y = V);
    var Q = V, ae;
    do
      if (ae = !1, !Q.steiner && (E(Q, Q.next) || S(Q.prev, Q, Q.next) === 0)) {
        if (G(Q), Q = Y = Q.prev, Q === Q.next) break;
        ae = !0;
      } else
        Q = Q.next;
    while (ae || Q !== Y);
    return Y;
  }
  function r(V, Y, Q, ae, Z, J, oe) {
    if (V) {
      !oe && J && h(V, ae, Z, J);
      for (var ue = V, me, pe; V.prev !== V.next; ) {
        if (me = V.prev, pe = V.next, J ? s(V, ae, Z, J) : o(V)) {
          Y.push(me.i / Q | 0), Y.push(V.i / Q | 0), Y.push(pe.i / Q | 0), G(V), V = pe.next, ue = pe.next;
          continue;
        }
        if (V = pe, V === ue) {
          oe ? oe === 1 ? (V = i(n(V), Y, Q), r(V, Y, Q, ae, Z, J, 2)) : oe === 2 && u(V, Y, Q, ae, Z, J) : r(n(V), Y, Q, ae, Z, J, 1);
          break;
        }
      }
    }
  }
  function o(V) {
    var Y = V.prev, Q = V, ae = V.next;
    if (S(Y, Q, ae) >= 0) return !1;
    for (var Z = Y.x, J = Q.x, oe = ae.x, ue = Y.y, me = Q.y, pe = ae.y, Be = Z < J ? Z < oe ? Z : oe : J < oe ? J : oe, Ie = ue < me ? ue < pe ? ue : pe : me < pe ? me : pe, Me = Z > J ? Z > oe ? Z : oe : J > oe ? J : oe, fe = ue > me ? ue > pe ? ue : pe : me > pe ? me : pe, Te = ae.next; Te !== Y; ) {
      if (Te.x >= Be && Te.x <= Me && Te.y >= Ie && Te.y <= fe && b(Z, ue, J, me, oe, pe, Te.x, Te.y) && S(Te.prev, Te, Te.next) >= 0) return !1;
      Te = Te.next;
    }
    return !0;
  }
  function s(V, Y, Q, ae) {
    var Z = V.prev, J = V, oe = V.next;
    if (S(Z, J, oe) >= 0) return !1;
    for (var ue = Z.x, me = J.x, pe = oe.x, Be = Z.y, Ie = J.y, Me = oe.y, fe = ue < me ? ue < pe ? ue : pe : me < pe ? me : pe, Te = Be < Ie ? Be < Me ? Be : Me : Ie < Me ? Ie : Me, Ae = ue > me ? ue > pe ? ue : pe : me > pe ? me : pe, we = Be > Ie ? Be > Me ? Be : Me : Ie > Me ? Ie : Me, $e = g(fe, Te, Y, Q, ae), ze = g(Ae, we, Y, Q, ae), Ue = V.prevZ, tt = V.nextZ; Ue && Ue.z >= $e && tt && tt.z <= ze; ) {
      if (Ue.x >= fe && Ue.x <= Ae && Ue.y >= Te && Ue.y <= we && Ue !== Z && Ue !== oe && b(ue, Be, me, Ie, pe, Me, Ue.x, Ue.y) && S(Ue.prev, Ue, Ue.next) >= 0 || (Ue = Ue.prevZ, tt.x >= fe && tt.x <= Ae && tt.y >= Te && tt.y <= we && tt !== Z && tt !== oe && b(ue, Be, me, Ie, pe, Me, tt.x, tt.y) && S(tt.prev, tt, tt.next) >= 0)) return !1;
      tt = tt.nextZ;
    }
    for (; Ue && Ue.z >= $e; ) {
      if (Ue.x >= fe && Ue.x <= Ae && Ue.y >= Te && Ue.y <= we && Ue !== Z && Ue !== oe && b(ue, Be, me, Ie, pe, Me, Ue.x, Ue.y) && S(Ue.prev, Ue, Ue.next) >= 0) return !1;
      Ue = Ue.prevZ;
    }
    for (; tt && tt.z <= ze; ) {
      if (tt.x >= fe && tt.x <= Ae && tt.y >= Te && tt.y <= we && tt !== Z && tt !== oe && b(ue, Be, me, Ie, pe, Me, tt.x, tt.y) && S(tt.prev, tt, tt.next) >= 0) return !1;
      tt = tt.nextZ;
    }
    return !0;
  }
  function i(V, Y, Q) {
    var ae = V;
    do {
      var Z = ae.prev, J = ae.next.next;
      !E(Z, J) && A(Z, ae, ae.next, J) && X(Z, J) && X(J, Z) && (Y.push(Z.i / Q | 0), Y.push(ae.i / Q | 0), Y.push(J.i / Q | 0), G(ae), G(ae.next), ae = V = J), ae = ae.next;
    } while (ae !== V);
    return n(ae);
  }
  function u(V, Y, Q, ae, Z, J) {
    var oe = V;
    do {
      for (var ue = oe.next.next; ue !== oe.prev; ) {
        if (oe.i !== ue.i && x(oe, ue)) {
          var me = B(oe, ue);
          oe = n(oe, oe.next), me = n(me, me.next), r(oe, Y, Q, ae, Z, J, 0), r(me, Y, Q, ae, Z, J, 0);
          return;
        }
        ue = ue.next;
      }
      oe = oe.next;
    } while (oe !== V);
  }
  function l(V, Y, Q, ae) {
    var Z = [], J, oe, ue, me, pe;
    for (J = 0, oe = Y.length; J < oe; J++)
      ue = Y[J] * ae, me = J < oe - 1 ? Y[J + 1] * ae : V.length, pe = e(V, ue, me, ae, !1), pe === pe.next && (pe.steiner = !0), Z.push(_(pe));
    for (Z.sort(a), J = 0; J < Z.length; J++)
      Q = c(Z[J], Q);
    return Q;
  }
  function a(V, Y) {
    return V.x - Y.x;
  }
  function c(V, Y) {
    var Q = p(V, Y);
    if (!Q)
      return Y;
    var ae = B(Q, V);
    return n(ae, ae.next), n(Q, Q.next);
  }
  function p(V, Y) {
    var Q = Y, ae = V.x, Z = V.y, J = -1 / 0, oe;
    do {
      if (Z <= Q.y && Z >= Q.next.y && Q.next.y !== Q.y) {
        var ue = Q.x + (Z - Q.y) * (Q.next.x - Q.x) / (Q.next.y - Q.y);
        if (ue <= ae && ue > J && (J = ue, oe = Q.x < Q.next.x ? Q : Q.next, ue === ae))
          return oe;
      }
      Q = Q.next;
    } while (Q !== Y);
    if (!oe) return null;
    var me = oe, pe = oe.x, Be = oe.y, Ie = 1 / 0, Me;
    Q = oe;
    do
      ae >= Q.x && Q.x >= pe && ae !== Q.x && b(Z < Be ? ae : J, Z, pe, Be, Z < Be ? J : ae, Z, Q.x, Q.y) && (Me = Math.abs(Z - Q.y) / (ae - Q.x), X(Q, V) && (Me < Ie || Me === Ie && (Q.x > oe.x || Q.x === oe.x && d(oe, Q))) && (oe = Q, Ie = Me)), Q = Q.next;
    while (Q !== me);
    return oe;
  }
  function d(V, Y) {
    return S(V.prev, V, Y.prev) < 0 && S(Y.next, V, V.next) < 0;
  }
  function h(V, Y, Q, ae) {
    var Z = V;
    do
      Z.z === 0 && (Z.z = g(Z.x, Z.y, Y, Q, ae)), Z.prevZ = Z.prev, Z.nextZ = Z.next, Z = Z.next;
    while (Z !== V);
    Z.prevZ.nextZ = null, Z.prevZ = null, m(Z);
  }
  function m(V) {
    var Y, Q, ae, Z, J, oe, ue, me, pe = 1;
    do {
      for (Q = V, V = null, J = null, oe = 0; Q; ) {
        for (oe++, ae = Q, ue = 0, Y = 0; Y < pe && (ue++, ae = ae.nextZ, !!ae); Y++)
          ;
        for (me = pe; ue > 0 || me > 0 && ae; )
          ue !== 0 && (me === 0 || !ae || Q.z <= ae.z) ? (Z = Q, Q = Q.nextZ, ue--) : (Z = ae, ae = ae.nextZ, me--), J ? J.nextZ = Z : V = Z, Z.prevZ = J, J = Z;
        Q = ae;
      }
      J.nextZ = null, pe *= 2;
    } while (oe > 1);
    return V;
  }
  function g(V, Y, Q, ae, Z) {
    return V = (V - Q) * Z | 0, Y = (Y - ae) * Z | 0, V = (V | V << 8) & 16711935, V = (V | V << 4) & 252645135, V = (V | V << 2) & 858993459, V = (V | V << 1) & 1431655765, Y = (Y | Y << 8) & 16711935, Y = (Y | Y << 4) & 252645135, Y = (Y | Y << 2) & 858993459, Y = (Y | Y << 1) & 1431655765, V | Y << 1;
  }
  function _(V) {
    var Y = V, Q = V;
    do
      (Y.x < Q.x || Y.x === Q.x && Y.y < Q.y) && (Q = Y), Y = Y.next;
    while (Y !== V);
    return Q;
  }
  function b(V, Y, Q, ae, Z, J, oe, ue) {
    return (Z - oe) * (Y - ue) >= (V - oe) * (J - ue) && (V - oe) * (ae - ue) >= (Q - oe) * (Y - ue) && (Q - oe) * (J - ue) >= (Z - oe) * (ae - ue);
  }
  function x(V, Y) {
    return V.next.i !== Y.i && V.prev.i !== Y.i && !L(V, Y) && // dones't intersect other edges
    (X(V, Y) && X(Y, V) && te(V, Y) && // locally visible
    (S(V.prev, V, Y.prev) || S(V, Y.prev, Y)) || // does not create opposite-facing sectors
    E(V, Y) && S(V.prev, V, V.next) > 0 && S(Y.prev, Y, Y.next) > 0);
  }
  function S(V, Y, Q) {
    return (Y.y - V.y) * (Q.x - Y.x) - (Y.x - V.x) * (Q.y - Y.y);
  }
  function E(V, Y) {
    return V.x === Y.x && V.y === Y.y;
  }
  function A(V, Y, Q, ae) {
    var Z = M(S(V, Y, Q)), J = M(S(V, Y, ae)), oe = M(S(Q, ae, V)), ue = M(S(Q, ae, Y));
    return !!(Z !== J && oe !== ue || Z === 0 && C(V, Q, Y) || J === 0 && C(V, ae, Y) || oe === 0 && C(Q, V, ae) || ue === 0 && C(Q, Y, ae));
  }
  function C(V, Y, Q) {
    return Y.x <= Math.max(V.x, Q.x) && Y.x >= Math.min(V.x, Q.x) && Y.y <= Math.max(V.y, Q.y) && Y.y >= Math.min(V.y, Q.y);
  }
  function M(V) {
    return V > 0 ? 1 : V < 0 ? -1 : 0;
  }
  function L(V, Y) {
    var Q = V;
    do {
      if (Q.i !== V.i && Q.next.i !== V.i && Q.i !== Y.i && Q.next.i !== Y.i && A(Q, Q.next, V, Y)) return !0;
      Q = Q.next;
    } while (Q !== V);
    return !1;
  }
  function X(V, Y) {
    return S(V.prev, V, V.next) < 0 ? S(V, Y, V.next) >= 0 && S(V, V.prev, Y) >= 0 : S(V, Y, V.prev) < 0 || S(V, V.next, Y) < 0;
  }
  function te(V, Y) {
    var Q = V, ae = !1, Z = (V.x + Y.x) / 2, J = (V.y + Y.y) / 2;
    do
      Q.y > J != Q.next.y > J && Q.next.y !== Q.y && Z < (Q.next.x - Q.x) * (J - Q.y) / (Q.next.y - Q.y) + Q.x && (ae = !ae), Q = Q.next;
    while (Q !== V);
    return ae;
  }
  function B(V, Y) {
    var Q = new ne(V.i, V.x, V.y), ae = new ne(Y.i, Y.x, Y.y), Z = V.next, J = Y.prev;
    return V.next = Y, Y.prev = V, Q.next = Z, Z.prev = Q, ae.next = Q, Q.prev = ae, J.next = ae, ae.prev = J, ae;
  }
  function W(V, Y, Q, ae) {
    var Z = new ne(V, Y, Q);
    return ae ? (Z.next = ae.next, Z.prev = ae, ae.next.prev = Z, ae.next = Z) : (Z.prev = Z, Z.next = Z), Z;
  }
  function G(V) {
    V.next.prev = V.prev, V.prev.next = V.next, V.prevZ && (V.prevZ.nextZ = V.nextZ), V.nextZ && (V.nextZ.prevZ = V.prevZ);
  }
  function ne(V, Y, Q) {
    this.i = V, this.x = Y, this.y = Q, this.prev = null, this.next = null, this.z = 0, this.prevZ = null, this.nextZ = null, this.steiner = !1;
  }
  t.deviation = function(V, Y, Q, ae) {
    var Z = Y && Y.length, J = Z ? Y[0] * Q : V.length, oe = Math.abs(de(V, 0, J, Q));
    if (Z)
      for (var ue = 0, me = Y.length; ue < me; ue++) {
        var pe = Y[ue] * Q, Be = ue < me - 1 ? Y[ue + 1] * Q : V.length;
        oe -= Math.abs(de(V, pe, Be, Q));
      }
    var Ie = 0;
    for (ue = 0; ue < ae.length; ue += 3) {
      var Me = ae[ue] * Q, fe = ae[ue + 1] * Q, Te = ae[ue + 2] * Q;
      Ie += Math.abs(
        (V[Me] - V[Te]) * (V[fe + 1] - V[Me + 1]) - (V[Me] - V[fe]) * (V[Te + 1] - V[Me + 1])
      );
    }
    return oe === 0 && Ie === 0 ? 0 : Math.abs((Ie - oe) / oe);
  };
  function de(V, Y, Q, ae) {
    for (var Z = 0, J = Y, oe = Q - ae; J < Q; J += ae)
      Z += (V[oe] - V[J]) * (V[J + 1] + V[oe + 1]), oe = J;
    return Z;
  }
  return t.flatten = function(V) {
    for (var Y = V[0][0].length, Q = { vertices: [], holes: [], dimensions: Y }, ae = 0, Z = 0; Z < V.length; Z++) {
      for (var J = 0; J < V[Z].length; J++)
        for (var oe = 0; oe < Y; oe++) Q.vertices.push(V[Z][J][oe]);
      Z > 0 && (ae += V[Z - 1].length, Q.holes.push(ae));
    }
    return Q;
  }, hg.exports;
}
var Awe = Rwe();
const Dwe = /* @__PURE__ */ iy(Awe);
var Yc = {}, e0 = { exports: {} };
/*! https://mths.be/punycode v1.4.1 by @mathias */
var Ewe = e0.exports, tP;
function Mwe() {
  return tP || (tP = 1, function(t, e) {
    (function(n) {
      var r = e && !e.nodeType && e, o = t && !t.nodeType && t, s = typeof Aa == "object" && Aa;
      (s.global === s || s.window === s || s.self === s) && (n = s);
      var i, u = 2147483647, l = 36, a = 1, c = 26, p = 38, d = 700, h = 72, m = 128, g = "-", _ = /^xn--/, b = /[^\x20-\x7E]/, x = /[\x2E\u3002\uFF0E\uFF61]/g, S = {
        overflow: "Overflow: input needs wider integers to process",
        "not-basic": "Illegal input >= 0x80 (not a basic code point)",
        "invalid-input": "Invalid input"
      }, E = l - a, A = Math.floor, C = String.fromCharCode, M;
      function L(Z) {
        throw new RangeError(S[Z]);
      }
      function X(Z, J) {
        for (var oe = Z.length, ue = []; oe--; )
          ue[oe] = J(Z[oe]);
        return ue;
      }
      function te(Z, J) {
        var oe = Z.split("@"), ue = "";
        oe.length > 1 && (ue = oe[0] + "@", Z = oe[1]), Z = Z.replace(x, ".");
        var me = Z.split("."), pe = X(me, J).join(".");
        return ue + pe;
      }
      function B(Z) {
        for (var J = [], oe = 0, ue = Z.length, me, pe; oe < ue; )
          me = Z.charCodeAt(oe++), me >= 55296 && me <= 56319 && oe < ue ? (pe = Z.charCodeAt(oe++), (pe & 64512) == 56320 ? J.push(((me & 1023) << 10) + (pe & 1023) + 65536) : (J.push(me), oe--)) : J.push(me);
        return J;
      }
      function W(Z) {
        return X(Z, function(J) {
          var oe = "";
          return J > 65535 && (J -= 65536, oe += C(J >>> 10 & 1023 | 55296), J = 56320 | J & 1023), oe += C(J), oe;
        }).join("");
      }
      function G(Z) {
        return Z - 48 < 10 ? Z - 22 : Z - 65 < 26 ? Z - 65 : Z - 97 < 26 ? Z - 97 : l;
      }
      function ne(Z, J) {
        return Z + 22 + 75 * (Z < 26) - ((J != 0) << 5);
      }
      function de(Z, J, oe) {
        var ue = 0;
        for (Z = oe ? A(Z / d) : Z >> 1, Z += A(Z / J); Z > E * c >> 1; ue += l)
          Z = A(Z / E);
        return A(ue + (E + 1) * Z / (Z + p));
      }
      function V(Z) {
        var J = [], oe = Z.length, ue, me = 0, pe = m, Be = h, Ie, Me, fe, Te, Ae, we, $e, ze, Ue;
        for (Ie = Z.lastIndexOf(g), Ie < 0 && (Ie = 0), Me = 0; Me < Ie; ++Me)
          Z.charCodeAt(Me) >= 128 && L("not-basic"), J.push(Z.charCodeAt(Me));
        for (fe = Ie > 0 ? Ie + 1 : 0; fe < oe; ) {
          for (Te = me, Ae = 1, we = l; fe >= oe && L("invalid-input"), $e = G(Z.charCodeAt(fe++)), ($e >= l || $e > A((u - me) / Ae)) && L("overflow"), me += $e * Ae, ze = we <= Be ? a : we >= Be + c ? c : we - Be, !($e < ze); we += l)
            Ue = l - ze, Ae > A(u / Ue) && L("overflow"), Ae *= Ue;
          ue = J.length + 1, Be = de(me - Te, ue, Te == 0), A(me / ue) > u - pe && L("overflow"), pe += A(me / ue), me %= ue, J.splice(me++, 0, pe);
        }
        return W(J);
      }
      function Y(Z) {
        var J, oe, ue, me, pe, Be, Ie, Me, fe, Te, Ae, we = [], $e, ze, Ue, tt;
        for (Z = B(Z), $e = Z.length, J = m, oe = 0, pe = h, Be = 0; Be < $e; ++Be)
          Ae = Z[Be], Ae < 128 && we.push(C(Ae));
        for (ue = me = we.length, me && we.push(g); ue < $e; ) {
          for (Ie = u, Be = 0; Be < $e; ++Be)
            Ae = Z[Be], Ae >= J && Ae < Ie && (Ie = Ae);
          for (ze = ue + 1, Ie - J > A((u - oe) / ze) && L("overflow"), oe += (Ie - J) * ze, J = Ie, Be = 0; Be < $e; ++Be)
            if (Ae = Z[Be], Ae < J && ++oe > u && L("overflow"), Ae == J) {
              for (Me = oe, fe = l; Te = fe <= pe ? a : fe >= pe + c ? c : fe - pe, !(Me < Te); fe += l)
                tt = Me - Te, Ue = l - Te, we.push(
                  C(ne(Te + tt % Ue, 0))
                ), Me = A(tt / Ue);
              we.push(C(ne(Me, 0))), pe = de(oe, ze, ue == me), oe = 0, ++ue;
            }
          ++oe, ++J;
        }
        return we.join("");
      }
      function Q(Z) {
        return te(Z, function(J) {
          return _.test(J) ? V(J.slice(4).toLowerCase()) : J;
        });
      }
      function ae(Z) {
        return te(Z, function(J) {
          return b.test(J) ? "xn--" + Y(J) : J;
        });
      }
      if (i = {
        /**
         * A string representing the current Punycode.js version number.
         * @memberOf punycode
         * @type String
         */
        version: "1.4.1",
        /**
         * An object of methods to convert from JavaScript's internal character
         * representation (UCS-2) to Unicode code points, and back.
         * @see <https://mathiasbynens.be/notes/javascript-encoding>
         * @memberOf punycode
         * @type Object
         */
        ucs2: {
          decode: B,
          encode: W
        },
        decode: V,
        encode: Y,
        toASCII: ae,
        toUnicode: Q
      }, r && o)
        if (t.exports == r)
          o.exports = i;
        else
          for (M in i)
            i.hasOwnProperty(M) && (r[M] = i[M]);
      else
        n.punycode = i;
    })(Ewe);
  }(e0, e0.exports)), e0.exports;
}
var nP, rP;
function Hh() {
  return rP || (rP = 1, nP = TypeError), nP;
}
const Pwe = {}, Cwe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Pwe
}, Symbol.toStringTag, { value: "Module" })), Owe = /* @__PURE__ */ Twe(Cwe);
var L1, oP;
function B_() {
  if (oP) return L1;
  oP = 1;
  var t = typeof Map == "function" && Map.prototype, e = Object.getOwnPropertyDescriptor && t ? Object.getOwnPropertyDescriptor(Map.prototype, "size") : null, n = t && e && typeof e.get == "function" ? e.get : null, r = t && Map.prototype.forEach, o = typeof Set == "function" && Set.prototype, s = Object.getOwnPropertyDescriptor && o ? Object.getOwnPropertyDescriptor(Set.prototype, "size") : null, i = o && s && typeof s.get == "function" ? s.get : null, u = o && Set.prototype.forEach, l = typeof WeakMap == "function" && WeakMap.prototype, a = l ? WeakMap.prototype.has : null, c = typeof WeakSet == "function" && WeakSet.prototype, p = c ? WeakSet.prototype.has : null, d = typeof WeakRef == "function" && WeakRef.prototype, h = d ? WeakRef.prototype.deref : null, m = Boolean.prototype.valueOf, g = Object.prototype.toString, _ = Function.prototype.toString, b = String.prototype.match, x = String.prototype.slice, S = String.prototype.replace, E = String.prototype.toUpperCase, A = String.prototype.toLowerCase, C = RegExp.prototype.test, M = Array.prototype.concat, L = Array.prototype.join, X = Array.prototype.slice, te = Math.floor, B = typeof BigInt == "function" ? BigInt.prototype.valueOf : null, W = Object.getOwnPropertySymbols, G = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Symbol.prototype.toString : null, ne = typeof Symbol == "function" && typeof Symbol.iterator == "object", de = typeof Symbol == "function" && Symbol.toStringTag && (typeof Symbol.toStringTag === ne || !0) ? Symbol.toStringTag : null, V = Object.prototype.propertyIsEnumerable, Y = (typeof Reflect == "function" ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype ? function(ke) {
    return ke.__proto__;
  } : null);
  function Q(ke, Re) {
    if (ke === 1 / 0 || ke === -1 / 0 || ke !== ke || ke && ke > -1e3 && ke < 1e3 || C.call(/e/, Re))
      return Re;
    var Qt = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if (typeof ke == "number") {
      var It = ke < 0 ? -te(-ke) : te(ke);
      if (It !== ke) {
        var on = String(It), Tt = x.call(Re, on.length + 1);
        return S.call(on, Qt, "$&_") + "." + S.call(S.call(Tt, /([0-9]{3})/g, "$&_"), /_$/, "");
      }
    }
    return S.call(Re, Qt, "$&_");
  }
  var ae = Owe, Z = ae.custom, J = ze(Z) ? Z : null, oe = {
    __proto__: null,
    double: '"',
    single: "'"
  }, ue = {
    __proto__: null,
    double: /(["\\])/g,
    single: /(['\\])/g
  };
  L1 = function ke(Re, Qt, It, on) {
    var Tt = Qt || {};
    if (Ot(Tt, "quoteStyle") && !Ot(oe, Tt.quoteStyle))
      throw new TypeError('option "quoteStyle" must be "single" or "double"');
    if (Ot(Tt, "maxStringLength") && (typeof Tt.maxStringLength == "number" ? Tt.maxStringLength < 0 && Tt.maxStringLength !== 1 / 0 : Tt.maxStringLength !== null))
      throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    var Ge = Ot(Tt, "customInspect") ? Tt.customInspect : !0;
    if (typeof Ge != "boolean" && Ge !== "symbol")
      throw new TypeError("option \"customInspect\", if provided, must be `true`, `false`, or `'symbol'`");
    if (Ot(Tt, "indent") && Tt.indent !== null && Tt.indent !== "	" && !(parseInt(Tt.indent, 10) === Tt.indent && Tt.indent > 0))
      throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    if (Ot(Tt, "numericSeparator") && typeof Tt.numericSeparator != "boolean")
      throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    var ct = Tt.numericSeparator;
    if (typeof Re > "u")
      return "undefined";
    if (Re === null)
      return "null";
    if (typeof Re == "boolean")
      return Re ? "true" : "false";
    if (typeof Re == "string")
      return ar(Re, Tt);
    if (typeof Re == "number") {
      if (Re === 0)
        return 1 / 0 / Re > 0 ? "0" : "-0";
      var bt = String(Re);
      return ct ? Q(Re, bt) : bt;
    }
    if (typeof Re == "bigint") {
      var Dn = String(Re) + "n";
      return ct ? Q(Re, Dn) : Dn;
    }
    var En = typeof Tt.depth > "u" ? 5 : Tt.depth;
    if (typeof It > "u" && (It = 0), It >= En && En > 0 && typeof Re == "object")
      return Ie(Re) ? "[Array]" : "[Object]";
    var Jn = Fs(Tt, It);
    if (typeof on > "u")
      on = [];
    else if (Pn(on, Re) >= 0)
      return "[Circular]";
    function Bn(is, ua, xu) {
      if (ua && (on = X.call(on), on.push(ua)), xu) {
        var er = {
          depth: Tt.depth
        };
        return Ot(Tt, "quoteStyle") && (er.quoteStyle = Tt.quoteStyle), ke(is, er, It + 1, on);
      }
      return ke(is, Tt, It + 1, on);
    }
    if (typeof Re == "function" && !fe(Re)) {
      var po = Xr(Re), Ai = In(Re, Bn);
      return "[Function" + (po ? ": " + po : " (anonymous)") + "]" + (Ai.length > 0 ? " { " + L.call(Ai, ", ") + " }" : "");
    }
    if (ze(Re)) {
      var ia = ne ? S.call(String(Re), /^(Symbol\(.*\))_[^)]*$/, "$1") : G.call(Re);
      return typeof Re == "object" && !ne ? $r(ia) : ia;
    }
    if (aa(Re)) {
      for (var Ns = "<" + A.call(String(Re.nodeName)), Ls = Re.attributes || [], as = 0; as < Ls.length; as++)
        Ns += " " + Ls[as].name + "=" + me(pe(Ls[as].value), "double", Tt);
      return Ns += ">", Re.childNodes && Re.childNodes.length && (Ns += "..."), Ns += "</" + A.call(String(Re.nodeName)) + ">", Ns;
    }
    if (Ie(Re)) {
      if (Re.length === 0)
        return "[]";
      var Wr = In(Re, Bn);
      return Jn && !Mo(Wr) ? "[" + To(Wr, Jn) + "]" : "[ " + L.call(Wr, ", ") + " ]";
    }
    if (Te(Re)) {
      var ir = In(Re, Bn);
      return !("cause" in Error.prototype) && "cause" in Re && !V.call(Re, "cause") ? "{ [" + String(Re) + "] " + L.call(M.call("[cause]: " + Bn(Re.cause), ir), ", ") + " }" : ir.length === 0 ? "[" + String(Re) + "]" : "{ [" + String(Re) + "] " + L.call(ir, ", ") + " }";
    }
    if (typeof Re == "object" && Ge) {
      if (J && typeof Re[J] == "function" && ae)
        return ae(Re, { depth: En - It });
      if (Ge !== "symbol" && typeof Re.inspect == "function")
        return Re.inspect();
    }
    if (On(Re)) {
      var Di = [];
      return r && r.call(Re, function(is, ua) {
        Di.push(Bn(ua, Re, !0) + " => " + Bn(is, Re));
      }), ko("Map", n.call(Re), Di, Jn);
    }
    if (sa(Re)) {
      var Ei = [];
      return u && u.call(Re, function(is) {
        Ei.push(Bn(is, Re));
      }), ko("Set", i.call(Re), Ei, Jn);
    }
    if (sr(Re))
      return gn("WeakMap");
    if (Eo(Re))
      return gn("WeakSet");
    if (Hn(Re))
      return gn("WeakRef");
    if (we(Re))
      return $r(Bn(Number(Re)));
    if (Ue(Re))
      return $r(Bn(B.call(Re)));
    if ($e(Re))
      return $r(m.call(Re));
    if (Ae(Re))
      return $r(Bn(String(Re)));
    if (typeof window < "u" && Re === window)
      return "{ [object Window] }";
    if (typeof globalThis < "u" && Re === globalThis || typeof Aa < "u" && Re === Aa)
      return "{ [object globalThis] }";
    if (!Me(Re) && !fe(Re)) {
      var Va = In(Re, Bn), Mi = Y ? Y(Re) === Object.prototype : Re instanceof Object || Re.constructor === Object, Po = Re instanceof Object ? "" : "null prototype", Un = !Mi && de && Object(Re) === Re && de in Re ? x.call(cn(Re), 8, -1) : Po ? "Object" : "", Tu = Mi || typeof Re.constructor != "function" ? "" : Re.constructor.name ? Re.constructor.name + " " : "", Ha = Tu + (Un || Po ? "[" + L.call(M.call([], Un || [], Po || []), ": ") + "] " : "");
      return Va.length === 0 ? Ha + "{}" : Jn ? Ha + "{" + To(Va, Jn) + "}" : Ha + "{ " + L.call(Va, ", ") + " }";
    }
    return String(Re);
  };
  function me(ke, Re, Qt) {
    var It = Qt.quoteStyle || Re, on = oe[It];
    return on + ke + on;
  }
  function pe(ke) {
    return S.call(String(ke), /"/g, "&quot;");
  }
  function Be(ke) {
    return !de || !(typeof ke == "object" && (de in ke || typeof ke[de] < "u"));
  }
  function Ie(ke) {
    return cn(ke) === "[object Array]" && Be(ke);
  }
  function Me(ke) {
    return cn(ke) === "[object Date]" && Be(ke);
  }
  function fe(ke) {
    return cn(ke) === "[object RegExp]" && Be(ke);
  }
  function Te(ke) {
    return cn(ke) === "[object Error]" && Be(ke);
  }
  function Ae(ke) {
    return cn(ke) === "[object String]" && Be(ke);
  }
  function we(ke) {
    return cn(ke) === "[object Number]" && Be(ke);
  }
  function $e(ke) {
    return cn(ke) === "[object Boolean]" && Be(ke);
  }
  function ze(ke) {
    if (ne)
      return ke && typeof ke == "object" && ke instanceof Symbol;
    if (typeof ke == "symbol")
      return !0;
    if (!ke || typeof ke != "object" || !G)
      return !1;
    try {
      return G.call(ke), !0;
    } catch {
    }
    return !1;
  }
  function Ue(ke) {
    if (!ke || typeof ke != "object" || !B)
      return !1;
    try {
      return B.call(ke), !0;
    } catch {
    }
    return !1;
  }
  var tt = Object.prototype.hasOwnProperty || function(ke) {
    return ke in this;
  };
  function Ot(ke, Re) {
    return tt.call(ke, Re);
  }
  function cn(ke) {
    return g.call(ke);
  }
  function Xr(ke) {
    if (ke.name)
      return ke.name;
    var Re = b.call(_.call(ke), /^function\s*([\w$]+)/);
    return Re ? Re[1] : null;
  }
  function Pn(ke, Re) {
    if (ke.indexOf)
      return ke.indexOf(Re);
    for (var Qt = 0, It = ke.length; Qt < It; Qt++)
      if (ke[Qt] === Re)
        return Qt;
    return -1;
  }
  function On(ke) {
    if (!n || !ke || typeof ke != "object")
      return !1;
    try {
      n.call(ke);
      try {
        i.call(ke);
      } catch {
        return !0;
      }
      return ke instanceof Map;
    } catch {
    }
    return !1;
  }
  function sr(ke) {
    if (!a || !ke || typeof ke != "object")
      return !1;
    try {
      a.call(ke, a);
      try {
        p.call(ke, p);
      } catch {
        return !0;
      }
      return ke instanceof WeakMap;
    } catch {
    }
    return !1;
  }
  function Hn(ke) {
    if (!h || !ke || typeof ke != "object")
      return !1;
    try {
      return h.call(ke), !0;
    } catch {
    }
    return !1;
  }
  function sa(ke) {
    if (!i || !ke || typeof ke != "object")
      return !1;
    try {
      i.call(ke);
      try {
        n.call(ke);
      } catch {
        return !0;
      }
      return ke instanceof Set;
    } catch {
    }
    return !1;
  }
  function Eo(ke) {
    if (!p || !ke || typeof ke != "object")
      return !1;
    try {
      p.call(ke, p);
      try {
        a.call(ke, a);
      } catch {
        return !0;
      }
      return ke instanceof WeakSet;
    } catch {
    }
    return !1;
  }
  function aa(ke) {
    return !ke || typeof ke != "object" ? !1 : typeof HTMLElement < "u" && ke instanceof HTMLElement ? !0 : typeof ke.nodeName == "string" && typeof ke.getAttribute == "function";
  }
  function ar(ke, Re) {
    if (ke.length > Re.maxStringLength) {
      var Qt = ke.length - Re.maxStringLength, It = "... " + Qt + " more character" + (Qt > 1 ? "s" : "");
      return ar(x.call(ke, 0, Re.maxStringLength), Re) + It;
    }
    var on = ue[Re.quoteStyle || "single"];
    on.lastIndex = 0;
    var Tt = S.call(S.call(ke, on, "\\$1"), /[\x00-\x1f]/g, Zn);
    return me(Tt, "single", Re);
  }
  function Zn(ke) {
    var Re = ke.charCodeAt(0), Qt = {
      8: "b",
      9: "t",
      10: "n",
      12: "f",
      13: "r"
    }[Re];
    return Qt ? "\\" + Qt : "\\x" + (Re < 16 ? "0" : "") + E.call(Re.toString(16));
  }
  function $r(ke) {
    return "Object(" + ke + ")";
  }
  function gn(ke) {
    return ke + " { ? }";
  }
  function ko(ke, Re, Qt, It) {
    var on = It ? To(Qt, It) : L.call(Qt, ", ");
    return ke + " (" + Re + ") {" + on + "}";
  }
  function Mo(ke) {
    for (var Re = 0; Re < ke.length; Re++)
      if (Pn(ke[Re], `
`) >= 0)
        return !1;
    return !0;
  }
  function Fs(ke, Re) {
    var Qt;
    if (ke.indent === "	")
      Qt = "	";
    else if (typeof ke.indent == "number" && ke.indent > 0)
      Qt = L.call(Array(ke.indent + 1), " ");
    else
      return null;
    return {
      base: Qt,
      prev: L.call(Array(Re + 1), Qt)
    };
  }
  function To(ke, Re) {
    if (ke.length === 0)
      return "";
    var Qt = `
` + Re.prev + Re.base;
    return Qt + L.call(ke, "," + Qt) + `
` + Re.prev;
  }
  function In(ke, Re) {
    var Qt = Ie(ke), It = [];
    if (Qt) {
      It.length = ke.length;
      for (var on = 0; on < ke.length; on++)
        It[on] = Ot(ke, on) ? Re(ke[on], ke) : "";
    }
    var Tt = typeof W == "function" ? W(ke) : [], Ge;
    if (ne) {
      Ge = {};
      for (var ct = 0; ct < Tt.length; ct++)
        Ge["$" + Tt[ct]] = Tt[ct];
    }
    for (var bt in ke)
      Ot(ke, bt) && (Qt && String(Number(bt)) === bt && bt < ke.length || ne && Ge["$" + bt] instanceof Symbol || (C.call(/[^\w$]/, bt) ? It.push(Re(bt, ke) + ": " + Re(ke[bt], ke)) : It.push(bt + ": " + Re(ke[bt], ke))));
    if (typeof W == "function")
      for (var Dn = 0; Dn < Tt.length; Dn++)
        V.call(ke, Tt[Dn]) && It.push("[" + Re(Tt[Dn]) + "]: " + Re(ke[Tt[Dn]], ke));
    return It;
  }
  return L1;
}
var B1, sP;
function Iwe() {
  if (sP) return B1;
  sP = 1;
  var t = /* @__PURE__ */ B_(), e = /* @__PURE__ */ Hh(), n = function(u, l, a) {
    for (var c = u, p; (p = c.next) != null; c = p)
      if (p.key === l)
        return c.next = p.next, a || (p.next = /** @type {NonNullable<typeof list.next>} */
        u.next, u.next = p), p;
  }, r = function(u, l) {
    if (u) {
      var a = n(u, l);
      return a && a.value;
    }
  }, o = function(u, l, a) {
    var c = n(u, l);
    c ? c.value = a : u.next = /** @type {import('./list.d.ts').ListNode<typeof value, typeof key>} */
    {
      // eslint-disable-line no-param-reassign, no-extra-parens
      key: l,
      next: u.next,
      value: a
    };
  }, s = function(u, l) {
    return u ? !!n(u, l) : !1;
  }, i = function(u, l) {
    if (u)
      return n(u, l, !0);
  };
  return B1 = function() {
    var u, l = {
      assert: function(a) {
        if (!l.has(a))
          throw new e("Side channel does not contain " + t(a));
      },
      delete: function(a) {
        var c = u && u.next, p = i(u, a);
        return p && c && c === p && (u = void 0), !!p;
      },
      get: function(a) {
        return r(u, a);
      },
      has: function(a) {
        return s(u, a);
      },
      set: function(a, c) {
        u || (u = {
          next: void 0
        }), o(
          /** @type {NonNullable<typeof $o>} */
          u,
          a,
          c
        );
      }
    };
    return l;
  }, B1;
}
var aP, iP;
function zL() {
  return iP || (iP = 1, aP = Object), aP;
}
var uP, lP;
function Fwe() {
  return lP || (lP = 1, uP = Error), uP;
}
var cP, pP;
function Nwe() {
  return pP || (pP = 1, cP = EvalError), cP;
}
var dP, hP;
function Lwe() {
  return hP || (hP = 1, dP = RangeError), dP;
}
var fP, mP;
function Bwe() {
  return mP || (mP = 1, fP = ReferenceError), fP;
}
var yP, gP;
function Uwe() {
  return gP || (gP = 1, yP = SyntaxError), yP;
}
var vP, _P;
function Xwe() {
  return _P || (_P = 1, vP = URIError), vP;
}
var wP, bP;
function $we() {
  return bP || (bP = 1, wP = Math.abs), wP;
}
var kP, TP;
function Wwe() {
  return TP || (TP = 1, kP = Math.floor), kP;
}
var xP, SP;
function Vwe() {
  return SP || (SP = 1, xP = Math.max), xP;
}
var RP, AP;
function Hwe() {
  return AP || (AP = 1, RP = Math.min), RP;
}
var DP, EP;
function jwe() {
  return EP || (EP = 1, DP = Math.pow), DP;
}
var MP, PP;
function zwe() {
  return PP || (PP = 1, MP = Math.round), MP;
}
var CP, OP;
function qwe() {
  return OP || (OP = 1, CP = Number.isNaN || function(t) {
    return t !== t;
  }), CP;
}
var U1, IP;
function Gwe() {
  if (IP) return U1;
  IP = 1;
  var t = /* @__PURE__ */ qwe();
  return U1 = function(e) {
    return t(e) || e === 0 ? e : e < 0 ? -1 : 1;
  }, U1;
}
var FP, NP;
function Ywe() {
  return NP || (NP = 1, FP = Object.getOwnPropertyDescriptor), FP;
}
var X1, LP;
function qL() {
  if (LP) return X1;
  LP = 1;
  var t = /* @__PURE__ */ Ywe();
  if (t)
    try {
      t([], "length");
    } catch {
      t = null;
    }
  return X1 = t, X1;
}
var $1, BP;
function Qwe() {
  if (BP) return $1;
  BP = 1;
  var t = Object.defineProperty || !1;
  if (t)
    try {
      t({}, "a", { value: 1 });
    } catch {
      t = !1;
    }
  return $1 = t, $1;
}
var UP, XP;
function Kwe() {
  return XP || (XP = 1, UP = function() {
    if (typeof Symbol != "function" || typeof Object.getOwnPropertySymbols != "function")
      return !1;
    if (typeof Symbol.iterator == "symbol")
      return !0;
    var t = {}, e = Symbol("test"), n = Object(e);
    if (typeof e == "string" || Object.prototype.toString.call(e) !== "[object Symbol]" || Object.prototype.toString.call(n) !== "[object Symbol]")
      return !1;
    var r = 42;
    t[e] = r;
    for (var o in t)
      return !1;
    if (typeof Object.keys == "function" && Object.keys(t).length !== 0 || typeof Object.getOwnPropertyNames == "function" && Object.getOwnPropertyNames(t).length !== 0)
      return !1;
    var s = Object.getOwnPropertySymbols(t);
    if (s.length !== 1 || s[0] !== e || !Object.prototype.propertyIsEnumerable.call(t, e))
      return !1;
    if (typeof Object.getOwnPropertyDescriptor == "function") {
      var i = (
        /** @type {PropertyDescriptor} */
        Object.getOwnPropertyDescriptor(t, e)
      );
      if (i.value !== r || i.enumerable !== !0)
        return !1;
    }
    return !0;
  }), UP;
}
var W1, $P;
function Zwe() {
  if ($P) return W1;
  $P = 1;
  var t = typeof Symbol < "u" && Symbol, e = Kwe();
  return W1 = function() {
    return typeof t != "function" || typeof Symbol != "function" || typeof t("foo") != "symbol" || typeof Symbol("bar") != "symbol" ? !1 : e();
  }, W1;
}
var WP, VP;
function GL() {
  return VP || (VP = 1, WP = typeof Reflect < "u" && Reflect.getPrototypeOf || null), WP;
}
var V1, HP;
function YL() {
  if (HP) return V1;
  HP = 1;
  var t = /* @__PURE__ */ zL();
  return V1 = t.getPrototypeOf || null, V1;
}
var H1, jP;
function Jwe() {
  if (jP) return H1;
  jP = 1;
  var t = "Function.prototype.bind called on incompatible ", e = Object.prototype.toString, n = Math.max, r = "[object Function]", o = function(u, l) {
    for (var a = [], c = 0; c < u.length; c += 1)
      a[c] = u[c];
    for (var p = 0; p < l.length; p += 1)
      a[p + u.length] = l[p];
    return a;
  }, s = function(u, l) {
    for (var a = [], c = l, p = 0; c < u.length; c += 1, p += 1)
      a[p] = u[c];
    return a;
  }, i = function(u, l) {
    for (var a = "", c = 0; c < u.length; c += 1)
      a += u[c], c + 1 < u.length && (a += l);
    return a;
  };
  return H1 = function(u) {
    var l = this;
    if (typeof l != "function" || e.apply(l) !== r)
      throw new TypeError(t + l);
    for (var a = s(arguments, 1), c, p = function() {
      if (this instanceof c) {
        var _ = l.apply(
          this,
          o(a, arguments)
        );
        return Object(_) === _ ? _ : this;
      }
      return l.apply(
        u,
        o(a, arguments)
      );
    }, d = n(0, l.length - a.length), h = [], m = 0; m < d; m++)
      h[m] = "$" + m;
    if (c = Function("binder", "return function (" + i(h, ",") + "){ return binder.apply(this,arguments); }")(p), l.prototype) {
      var g = function() {
      };
      g.prototype = l.prototype, c.prototype = new g(), g.prototype = null;
    }
    return c;
  }, H1;
}
var j1, zP;
function U_() {
  if (zP) return j1;
  zP = 1;
  var t = Jwe();
  return j1 = Function.prototype.bind || t, j1;
}
var qP, GP;
function kS() {
  return GP || (GP = 1, qP = Function.prototype.call), qP;
}
var YP, QP;
function QL() {
  return QP || (QP = 1, YP = Function.prototype.apply), YP;
}
var KP, ZP;
function e1e() {
  return ZP || (ZP = 1, KP = typeof Reflect < "u" && Reflect && Reflect.apply), KP;
}
var z1, JP;
function t1e() {
  if (JP) return z1;
  JP = 1;
  var t = U_(), e = QL(), n = kS(), r = e1e();
  return z1 = r || t.call(n, e), z1;
}
var q1, eC;
function KL() {
  if (eC) return q1;
  eC = 1;
  var t = U_(), e = /* @__PURE__ */ Hh(), n = kS(), r = t1e();
  return q1 = function(o) {
    if (o.length < 1 || typeof o[0] != "function")
      throw new e("a function is required");
    return r(t, n, o);
  }, q1;
}
var G1, tC;
function n1e() {
  if (tC) return G1;
  tC = 1;
  var t = KL(), e = /* @__PURE__ */ qL(), n;
  try {
    n = /** @type {{ __proto__?: typeof Array.prototype }} */
    [].__proto__ === Array.prototype;
  } catch (i) {
    if (!i || typeof i != "object" || !("code" in i) || i.code !== "ERR_PROTO_ACCESS")
      throw i;
  }
  var r = !!n && e && e(
    Object.prototype,
    /** @type {keyof typeof Object.prototype} */
    "__proto__"
  ), o = Object, s = o.getPrototypeOf;
  return G1 = r && typeof r.get == "function" ? t([r.get]) : typeof s == "function" ? (
    /** @type {import('./get')} */
    function(i) {
      return s(i == null ? i : o(i));
    }
  ) : !1, G1;
}
var Y1, nC;
function r1e() {
  if (nC) return Y1;
  nC = 1;
  var t = GL(), e = YL(), n = /* @__PURE__ */ n1e();
  return Y1 = t ? function(r) {
    return t(r);
  } : e ? function(r) {
    if (!r || typeof r != "object" && typeof r != "function")
      throw new TypeError("getProto: not an object");
    return e(r);
  } : n ? function(r) {
    return n(r);
  } : null, Y1;
}
var Q1, rC;
function o1e() {
  if (rC) return Q1;
  rC = 1;
  var t = Function.prototype.call, e = Object.prototype.hasOwnProperty, n = U_();
  return Q1 = n.call(t, e), Q1;
}
var K1, oC;
function TS() {
  if (oC) return K1;
  oC = 1;
  var t, e = /* @__PURE__ */ zL(), n = /* @__PURE__ */ Fwe(), r = /* @__PURE__ */ Nwe(), o = /* @__PURE__ */ Lwe(), s = /* @__PURE__ */ Bwe(), i = /* @__PURE__ */ Uwe(), u = /* @__PURE__ */ Hh(), l = /* @__PURE__ */ Xwe(), a = /* @__PURE__ */ $we(), c = /* @__PURE__ */ Wwe(), p = /* @__PURE__ */ Vwe(), d = /* @__PURE__ */ Hwe(), h = /* @__PURE__ */ jwe(), m = /* @__PURE__ */ zwe(), g = /* @__PURE__ */ Gwe(), _ = Function, b = function(fe) {
    try {
      return _('"use strict"; return (' + fe + ").constructor;")();
    } catch {
    }
  }, x = /* @__PURE__ */ qL(), S = /* @__PURE__ */ Qwe(), E = function() {
    throw new u();
  }, A = x ? function() {
    try {
      return arguments.callee, E;
    } catch {
      try {
        return x(arguments, "callee").get;
      } catch {
        return E;
      }
    }
  }() : E, C = Zwe()(), M = r1e(), L = YL(), X = GL(), te = QL(), B = kS(), W = {}, G = typeof Uint8Array > "u" || !M ? t : M(Uint8Array), ne = {
    __proto__: null,
    "%AggregateError%": typeof AggregateError > "u" ? t : AggregateError,
    "%Array%": Array,
    "%ArrayBuffer%": typeof ArrayBuffer > "u" ? t : ArrayBuffer,
    "%ArrayIteratorPrototype%": C && M ? M([][Symbol.iterator]()) : t,
    "%AsyncFromSyncIteratorPrototype%": t,
    "%AsyncFunction%": W,
    "%AsyncGenerator%": W,
    "%AsyncGeneratorFunction%": W,
    "%AsyncIteratorPrototype%": W,
    "%Atomics%": typeof Atomics > "u" ? t : Atomics,
    "%BigInt%": typeof BigInt > "u" ? t : BigInt,
    "%BigInt64Array%": typeof BigInt64Array > "u" ? t : BigInt64Array,
    "%BigUint64Array%": typeof BigUint64Array > "u" ? t : BigUint64Array,
    "%Boolean%": Boolean,
    "%DataView%": typeof DataView > "u" ? t : DataView,
    "%Date%": Date,
    "%decodeURI%": decodeURI,
    "%decodeURIComponent%": decodeURIComponent,
    "%encodeURI%": encodeURI,
    "%encodeURIComponent%": encodeURIComponent,
    "%Error%": n,
    "%eval%": eval,
    // eslint-disable-line no-eval
    "%EvalError%": r,
    "%Float16Array%": typeof Float16Array > "u" ? t : Float16Array,
    "%Float32Array%": typeof Float32Array > "u" ? t : Float32Array,
    "%Float64Array%": typeof Float64Array > "u" ? t : Float64Array,
    "%FinalizationRegistry%": typeof FinalizationRegistry > "u" ? t : FinalizationRegistry,
    "%Function%": _,
    "%GeneratorFunction%": W,
    "%Int8Array%": typeof Int8Array > "u" ? t : Int8Array,
    "%Int16Array%": typeof Int16Array > "u" ? t : Int16Array,
    "%Int32Array%": typeof Int32Array > "u" ? t : Int32Array,
    "%isFinite%": isFinite,
    "%isNaN%": isNaN,
    "%IteratorPrototype%": C && M ? M(M([][Symbol.iterator]())) : t,
    "%JSON%": typeof JSON == "object" ? JSON : t,
    "%Map%": typeof Map > "u" ? t : Map,
    "%MapIteratorPrototype%": typeof Map > "u" || !C || !M ? t : M((/* @__PURE__ */ new Map())[Symbol.iterator]()),
    "%Math%": Math,
    "%Number%": Number,
    "%Object%": e,
    "%Object.getOwnPropertyDescriptor%": x,
    "%parseFloat%": parseFloat,
    "%parseInt%": parseInt,
    "%Promise%": typeof Promise > "u" ? t : Promise,
    "%Proxy%": typeof Proxy > "u" ? t : Proxy,
    "%RangeError%": o,
    "%ReferenceError%": s,
    "%Reflect%": typeof Reflect > "u" ? t : Reflect,
    "%RegExp%": RegExp,
    "%Set%": typeof Set > "u" ? t : Set,
    "%SetIteratorPrototype%": typeof Set > "u" || !C || !M ? t : M((/* @__PURE__ */ new Set())[Symbol.iterator]()),
    "%SharedArrayBuffer%": typeof SharedArrayBuffer > "u" ? t : SharedArrayBuffer,
    "%String%": String,
    "%StringIteratorPrototype%": C && M ? M(""[Symbol.iterator]()) : t,
    "%Symbol%": C ? Symbol : t,
    "%SyntaxError%": i,
    "%ThrowTypeError%": A,
    "%TypedArray%": G,
    "%TypeError%": u,
    "%Uint8Array%": typeof Uint8Array > "u" ? t : Uint8Array,
    "%Uint8ClampedArray%": typeof Uint8ClampedArray > "u" ? t : Uint8ClampedArray,
    "%Uint16Array%": typeof Uint16Array > "u" ? t : Uint16Array,
    "%Uint32Array%": typeof Uint32Array > "u" ? t : Uint32Array,
    "%URIError%": l,
    "%WeakMap%": typeof WeakMap > "u" ? t : WeakMap,
    "%WeakRef%": typeof WeakRef > "u" ? t : WeakRef,
    "%WeakSet%": typeof WeakSet > "u" ? t : WeakSet,
    "%Function.prototype.call%": B,
    "%Function.prototype.apply%": te,
    "%Object.defineProperty%": S,
    "%Object.getPrototypeOf%": L,
    "%Math.abs%": a,
    "%Math.floor%": c,
    "%Math.max%": p,
    "%Math.min%": d,
    "%Math.pow%": h,
    "%Math.round%": m,
    "%Math.sign%": g,
    "%Reflect.getPrototypeOf%": X
  };
  if (M)
    try {
      null.error;
    } catch (fe) {
      var de = M(M(fe));
      ne["%Error.prototype%"] = de;
    }
  var V = function fe(Te) {
    var Ae;
    if (Te === "%AsyncFunction%")
      Ae = b("async function () {}");
    else if (Te === "%GeneratorFunction%")
      Ae = b("function* () {}");
    else if (Te === "%AsyncGeneratorFunction%")
      Ae = b("async function* () {}");
    else if (Te === "%AsyncGenerator%") {
      var we = fe("%AsyncGeneratorFunction%");
      we && (Ae = we.prototype);
    } else if (Te === "%AsyncIteratorPrototype%") {
      var $e = fe("%AsyncGenerator%");
      $e && M && (Ae = M($e.prototype));
    }
    return ne[Te] = Ae, Ae;
  }, Y = {
    __proto__: null,
    "%ArrayBufferPrototype%": ["ArrayBuffer", "prototype"],
    "%ArrayPrototype%": ["Array", "prototype"],
    "%ArrayProto_entries%": ["Array", "prototype", "entries"],
    "%ArrayProto_forEach%": ["Array", "prototype", "forEach"],
    "%ArrayProto_keys%": ["Array", "prototype", "keys"],
    "%ArrayProto_values%": ["Array", "prototype", "values"],
    "%AsyncFunctionPrototype%": ["AsyncFunction", "prototype"],
    "%AsyncGenerator%": ["AsyncGeneratorFunction", "prototype"],
    "%AsyncGeneratorPrototype%": ["AsyncGeneratorFunction", "prototype", "prototype"],
    "%BooleanPrototype%": ["Boolean", "prototype"],
    "%DataViewPrototype%": ["DataView", "prototype"],
    "%DatePrototype%": ["Date", "prototype"],
    "%ErrorPrototype%": ["Error", "prototype"],
    "%EvalErrorPrototype%": ["EvalError", "prototype"],
    "%Float32ArrayPrototype%": ["Float32Array", "prototype"],
    "%Float64ArrayPrototype%": ["Float64Array", "prototype"],
    "%FunctionPrototype%": ["Function", "prototype"],
    "%Generator%": ["GeneratorFunction", "prototype"],
    "%GeneratorPrototype%": ["GeneratorFunction", "prototype", "prototype"],
    "%Int8ArrayPrototype%": ["Int8Array", "prototype"],
    "%Int16ArrayPrototype%": ["Int16Array", "prototype"],
    "%Int32ArrayPrototype%": ["Int32Array", "prototype"],
    "%JSONParse%": ["JSON", "parse"],
    "%JSONStringify%": ["JSON", "stringify"],
    "%MapPrototype%": ["Map", "prototype"],
    "%NumberPrototype%": ["Number", "prototype"],
    "%ObjectPrototype%": ["Object", "prototype"],
    "%ObjProto_toString%": ["Object", "prototype", "toString"],
    "%ObjProto_valueOf%": ["Object", "prototype", "valueOf"],
    "%PromisePrototype%": ["Promise", "prototype"],
    "%PromiseProto_then%": ["Promise", "prototype", "then"],
    "%Promise_all%": ["Promise", "all"],
    "%Promise_reject%": ["Promise", "reject"],
    "%Promise_resolve%": ["Promise", "resolve"],
    "%RangeErrorPrototype%": ["RangeError", "prototype"],
    "%ReferenceErrorPrototype%": ["ReferenceError", "prototype"],
    "%RegExpPrototype%": ["RegExp", "prototype"],
    "%SetPrototype%": ["Set", "prototype"],
    "%SharedArrayBufferPrototype%": ["SharedArrayBuffer", "prototype"],
    "%StringPrototype%": ["String", "prototype"],
    "%SymbolPrototype%": ["Symbol", "prototype"],
    "%SyntaxErrorPrototype%": ["SyntaxError", "prototype"],
    "%TypedArrayPrototype%": ["TypedArray", "prototype"],
    "%TypeErrorPrototype%": ["TypeError", "prototype"],
    "%Uint8ArrayPrototype%": ["Uint8Array", "prototype"],
    "%Uint8ClampedArrayPrototype%": ["Uint8ClampedArray", "prototype"],
    "%Uint16ArrayPrototype%": ["Uint16Array", "prototype"],
    "%Uint32ArrayPrototype%": ["Uint32Array", "prototype"],
    "%URIErrorPrototype%": ["URIError", "prototype"],
    "%WeakMapPrototype%": ["WeakMap", "prototype"],
    "%WeakSetPrototype%": ["WeakSet", "prototype"]
  }, Q = U_(), ae = /* @__PURE__ */ o1e(), Z = Q.call(B, Array.prototype.concat), J = Q.call(te, Array.prototype.splice), oe = Q.call(B, String.prototype.replace), ue = Q.call(B, String.prototype.slice), me = Q.call(B, RegExp.prototype.exec), pe = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g, Be = /\\(\\)?/g, Ie = function(fe) {
    var Te = ue(fe, 0, 1), Ae = ue(fe, -1);
    if (Te === "%" && Ae !== "%")
      throw new i("invalid intrinsic syntax, expected closing `%`");
    if (Ae === "%" && Te !== "%")
      throw new i("invalid intrinsic syntax, expected opening `%`");
    var we = [];
    return oe(fe, pe, function($e, ze, Ue, tt) {
      we[we.length] = Ue ? oe(tt, Be, "$1") : ze || $e;
    }), we;
  }, Me = function(fe, Te) {
    var Ae = fe, we;
    if (ae(Y, Ae) && (we = Y[Ae], Ae = "%" + we[0] + "%"), ae(ne, Ae)) {
      var $e = ne[Ae];
      if ($e === W && ($e = V(Ae)), typeof $e > "u" && !Te)
        throw new u("intrinsic " + fe + " exists, but is not available. Please file an issue!");
      return {
        alias: we,
        name: Ae,
        value: $e
      };
    }
    throw new i("intrinsic " + fe + " does not exist!");
  };
  return K1 = function(fe, Te) {
    if (typeof fe != "string" || fe.length === 0)
      throw new u("intrinsic name must be a non-empty string");
    if (arguments.length > 1 && typeof Te != "boolean")
      throw new u('"allowMissing" argument must be a boolean');
    if (me(/^%?[^%]*%?$/, fe) === null)
      throw new i("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
    var Ae = Ie(fe), we = Ae.length > 0 ? Ae[0] : "", $e = Me("%" + we + "%", Te), ze = $e.name, Ue = $e.value, tt = !1, Ot = $e.alias;
    Ot && (we = Ot[0], J(Ae, Z([0, 1], Ot)));
    for (var cn = 1, Xr = !0; cn < Ae.length; cn += 1) {
      var Pn = Ae[cn], On = ue(Pn, 0, 1), sr = ue(Pn, -1);
      if ((On === '"' || On === "'" || On === "`" || sr === '"' || sr === "'" || sr === "`") && On !== sr)
        throw new i("property names with quotes must have matching quotes");
      if ((Pn === "constructor" || !Xr) && (tt = !0), we += "." + Pn, ze = "%" + we + "%", ae(ne, ze))
        Ue = ne[ze];
      else if (Ue != null) {
        if (!(Pn in Ue)) {
          if (!Te)
            throw new u("base intrinsic for " + fe + " exists, but the property is not available.");
          return;
        }
        if (x && cn + 1 >= Ae.length) {
          var Hn = x(Ue, Pn);
          Xr = !!Hn, Xr && "get" in Hn && !("originalValue" in Hn.get) ? Ue = Hn.get : Ue = Ue[Pn];
        } else
          Xr = ae(Ue, Pn), Ue = Ue[Pn];
        Xr && !tt && (ne[ze] = Ue);
      }
    }
    return Ue;
  }, K1;
}
var Z1, sC;
function ZL() {
  if (sC) return Z1;
  sC = 1;
  var t = /* @__PURE__ */ TS(), e = KL(), n = e([t("%String.prototype.indexOf%")]);
  return Z1 = function(r, o) {
    var s = (
      /** @type {(this: unknown, ...args: unknown[]) => unknown} */
      t(r, !!o)
    );
    return typeof s == "function" && n(r, ".prototype.") > -1 ? e(
      /** @type {const} */
      [s]
    ) : s;
  }, Z1;
}
var J1, aC;
function JL() {
  if (aC) return J1;
  aC = 1;
  var t = /* @__PURE__ */ TS(), e = /* @__PURE__ */ ZL(), n = /* @__PURE__ */ B_(), r = /* @__PURE__ */ Hh(), o = t("%Map%", !0), s = e("Map.prototype.get", !0), i = e("Map.prototype.set", !0), u = e("Map.prototype.has", !0), l = e("Map.prototype.delete", !0), a = e("Map.prototype.size", !0);
  return J1 = !!o && /** @type {Exclude<import('.'), false>} */
  function() {
    var c, p = {
      assert: function(d) {
        if (!p.has(d))
          throw new r("Side channel does not contain " + n(d));
      },
      delete: function(d) {
        if (c) {
          var h = l(c, d);
          return a(c) === 0 && (c = void 0), h;
        }
        return !1;
      },
      get: function(d) {
        if (c)
          return s(c, d);
      },
      has: function(d) {
        return c ? u(c, d) : !1;
      },
      set: function(d, h) {
        c || (c = new o()), i(c, d, h);
      }
    };
    return p;
  }, J1;
}
var eb, iC;
function s1e() {
  if (iC) return eb;
  iC = 1;
  var t = /* @__PURE__ */ TS(), e = /* @__PURE__ */ ZL(), n = /* @__PURE__ */ B_(), r = JL(), o = /* @__PURE__ */ Hh(), s = t("%WeakMap%", !0), i = e("WeakMap.prototype.get", !0), u = e("WeakMap.prototype.set", !0), l = e("WeakMap.prototype.has", !0), a = e("WeakMap.prototype.delete", !0);
  return eb = s ? (
    /** @type {Exclude<import('.'), false>} */
    function() {
      var c, p, d = {
        assert: function(h) {
          if (!d.has(h))
            throw new o("Side channel does not contain " + n(h));
        },
        delete: function(h) {
          if (s && h && (typeof h == "object" || typeof h == "function")) {
            if (c)
              return a(c, h);
          } else if (r && p)
            return p.delete(h);
          return !1;
        },
        get: function(h) {
          return s && h && (typeof h == "object" || typeof h == "function") && c ? i(c, h) : p && p.get(h);
        },
        has: function(h) {
          return s && h && (typeof h == "object" || typeof h == "function") && c ? l(c, h) : !!p && p.has(h);
        },
        set: function(h, m) {
          s && h && (typeof h == "object" || typeof h == "function") ? (c || (c = new s()), u(c, h, m)) : r && (p || (p = r()), p.set(h, m));
        }
      };
      return d;
    }
  ) : r, eb;
}
var tb, uC;
function a1e() {
  if (uC) return tb;
  uC = 1;
  var t = /* @__PURE__ */ Hh(), e = /* @__PURE__ */ B_(), n = Iwe(), r = JL(), o = s1e(), s = o || r || n;
  return tb = function() {
    var i, u = {
      assert: function(l) {
        if (!u.has(l))
          throw new t("Side channel does not contain " + e(l));
      },
      delete: function(l) {
        return !!i && i.delete(l);
      },
      get: function(l) {
        return i && i.get(l);
      },
      has: function(l) {
        return !!i && i.has(l);
      },
      set: function(l, a) {
        i || (i = s()), i.set(l, a);
      }
    };
    return u;
  }, tb;
}
var nb, lC;
function xS() {
  if (lC) return nb;
  lC = 1;
  var t = String.prototype.replace, e = /%20/g, n = {
    RFC1738: "RFC1738",
    RFC3986: "RFC3986"
  };
  return nb = {
    default: n.RFC3986,
    formatters: {
      RFC1738: function(r) {
        return t.call(r, e, "+");
      },
      RFC3986: function(r) {
        return String(r);
      }
    },
    RFC1738: n.RFC1738,
    RFC3986: n.RFC3986
  }, nb;
}
var rb, cC;
function eB() {
  if (cC) return rb;
  cC = 1;
  var t = /* @__PURE__ */ xS(), e = Object.prototype.hasOwnProperty, n = Array.isArray, r = function() {
    for (var _ = [], b = 0; b < 256; ++b)
      _.push("%" + ((b < 16 ? "0" : "") + b.toString(16)).toUpperCase());
    return _;
  }(), o = function(_) {
    for (; _.length > 1; ) {
      var b = _.pop(), x = b.obj[b.prop];
      if (n(x)) {
        for (var S = [], E = 0; E < x.length; ++E)
          typeof x[E] < "u" && S.push(x[E]);
        b.obj[b.prop] = S;
      }
    }
  }, s = function(_, b) {
    for (var x = b && b.plainObjects ? { __proto__: null } : {}, S = 0; S < _.length; ++S)
      typeof _[S] < "u" && (x[S] = _[S]);
    return x;
  }, i = function _(b, x, S) {
    if (!x)
      return b;
    if (typeof x != "object" && typeof x != "function") {
      if (n(b))
        b.push(x);
      else if (b && typeof b == "object")
        (S && (S.plainObjects || S.allowPrototypes) || !e.call(Object.prototype, x)) && (b[x] = !0);
      else
        return [b, x];
      return b;
    }
    if (!b || typeof b != "object")
      return [b].concat(x);
    var E = b;
    return n(b) && !n(x) && (E = s(b, S)), n(b) && n(x) ? (x.forEach(function(A, C) {
      if (e.call(b, C)) {
        var M = b[C];
        M && typeof M == "object" && A && typeof A == "object" ? b[C] = _(M, A, S) : b.push(A);
      } else
        b[C] = A;
    }), b) : Object.keys(x).reduce(function(A, C) {
      var M = x[C];
      return e.call(A, C) ? A[C] = _(A[C], M, S) : A[C] = M, A;
    }, E);
  }, u = function(_, b) {
    return Object.keys(b).reduce(function(x, S) {
      return x[S] = b[S], x;
    }, _);
  }, l = function(_, b, x) {
    var S = _.replace(/\+/g, " ");
    if (x === "iso-8859-1")
      return S.replace(/%[0-9a-f]{2}/gi, unescape);
    try {
      return decodeURIComponent(S);
    } catch {
      return S;
    }
  }, a = 1024, c = function(_, b, x, S, E) {
    if (_.length === 0)
      return _;
    var A = _;
    if (typeof _ == "symbol" ? A = Symbol.prototype.toString.call(_) : typeof _ != "string" && (A = String(_)), x === "iso-8859-1")
      return escape(A).replace(/%u[0-9a-f]{4}/gi, function(W) {
        return "%26%23" + parseInt(W.slice(2), 16) + "%3B";
      });
    for (var C = "", M = 0; M < A.length; M += a) {
      for (var L = A.length >= a ? A.slice(M, M + a) : A, X = [], te = 0; te < L.length; ++te) {
        var B = L.charCodeAt(te);
        if (B === 45 || B === 46 || B === 95 || B === 126 || B >= 48 && B <= 57 || B >= 65 && B <= 90 || B >= 97 && B <= 122 || E === t.RFC1738 && (B === 40 || B === 41)) {
          X[X.length] = L.charAt(te);
          continue;
        }
        if (B < 128) {
          X[X.length] = r[B];
          continue;
        }
        if (B < 2048) {
          X[X.length] = r[192 | B >> 6] + r[128 | B & 63];
          continue;
        }
        if (B < 55296 || B >= 57344) {
          X[X.length] = r[224 | B >> 12] + r[128 | B >> 6 & 63] + r[128 | B & 63];
          continue;
        }
        te += 1, B = 65536 + ((B & 1023) << 10 | L.charCodeAt(te) & 1023), X[X.length] = r[240 | B >> 18] + r[128 | B >> 12 & 63] + r[128 | B >> 6 & 63] + r[128 | B & 63];
      }
      C += X.join("");
    }
    return C;
  }, p = function(_) {
    for (var b = [{ obj: { o: _ }, prop: "o" }], x = [], S = 0; S < b.length; ++S)
      for (var E = b[S], A = E.obj[E.prop], C = Object.keys(A), M = 0; M < C.length; ++M) {
        var L = C[M], X = A[L];
        typeof X == "object" && X !== null && x.indexOf(X) === -1 && (b.push({ obj: A, prop: L }), x.push(X));
      }
    return o(b), _;
  }, d = function(_) {
    return Object.prototype.toString.call(_) === "[object RegExp]";
  }, h = function(_) {
    return !_ || typeof _ != "object" ? !1 : !!(_.constructor && _.constructor.isBuffer && _.constructor.isBuffer(_));
  }, m = function(_, b) {
    return [].concat(_, b);
  }, g = function(_, b) {
    if (n(_)) {
      for (var x = [], S = 0; S < _.length; S += 1)
        x.push(b(_[S]));
      return x;
    }
    return b(_);
  };
  return rb = {
    arrayToObject: s,
    assign: u,
    combine: m,
    compact: p,
    decode: l,
    encode: c,
    isBuffer: h,
    isRegExp: d,
    maybeMap: g,
    merge: i
  }, rb;
}
var ob, pC;
function i1e() {
  if (pC) return ob;
  pC = 1;
  var t = a1e(), e = /* @__PURE__ */ eB(), n = /* @__PURE__ */ xS(), r = Object.prototype.hasOwnProperty, o = {
    brackets: function(g) {
      return g + "[]";
    },
    comma: "comma",
    indices: function(g, _) {
      return g + "[" + _ + "]";
    },
    repeat: function(g) {
      return g;
    }
  }, s = Array.isArray, i = Array.prototype.push, u = function(g, _) {
    i.apply(g, s(_) ? _ : [_]);
  }, l = Date.prototype.toISOString, a = n.default, c = {
    addQueryPrefix: !1,
    allowDots: !1,
    allowEmptyArrays: !1,
    arrayFormat: "indices",
    charset: "utf-8",
    charsetSentinel: !1,
    commaRoundTrip: !1,
    delimiter: "&",
    encode: !0,
    encodeDotInKeys: !1,
    encoder: e.encode,
    encodeValuesOnly: !1,
    filter: void 0,
    format: a,
    formatter: n.formatters[a],
    // deprecated
    indices: !1,
    serializeDate: function(g) {
      return l.call(g);
    },
    skipNulls: !1,
    strictNullHandling: !1
  }, p = function(g) {
    return typeof g == "string" || typeof g == "number" || typeof g == "boolean" || typeof g == "symbol" || typeof g == "bigint";
  }, d = {}, h = function g(_, b, x, S, E, A, C, M, L, X, te, B, W, G, ne, de, V, Y) {
    for (var Q = _, ae = Y, Z = 0, J = !1; (ae = ae.get(d)) !== void 0 && !J; ) {
      var oe = ae.get(_);
      if (Z += 1, typeof oe < "u") {
        if (oe === Z)
          throw new RangeError("Cyclic object value");
        J = !0;
      }
      typeof ae.get(d) > "u" && (Z = 0);
    }
    if (typeof X == "function" ? Q = X(b, Q) : Q instanceof Date ? Q = W(Q) : x === "comma" && s(Q) && (Q = e.maybeMap(Q, function(Ue) {
      return Ue instanceof Date ? W(Ue) : Ue;
    })), Q === null) {
      if (A)
        return L && !de ? L(b, c.encoder, V, "key", G) : b;
      Q = "";
    }
    if (p(Q) || e.isBuffer(Q)) {
      if (L) {
        var ue = de ? b : L(b, c.encoder, V, "key", G);
        return [ne(ue) + "=" + ne(L(Q, c.encoder, V, "value", G))];
      }
      return [ne(b) + "=" + ne(String(Q))];
    }
    var me = [];
    if (typeof Q > "u")
      return me;
    var pe;
    if (x === "comma" && s(Q))
      de && L && (Q = e.maybeMap(Q, L)), pe = [{ value: Q.length > 0 ? Q.join(",") || null : void 0 }];
    else if (s(X))
      pe = X;
    else {
      var Be = Object.keys(Q);
      pe = te ? Be.sort(te) : Be;
    }
    var Ie = M ? String(b).replace(/\./g, "%2E") : String(b), Me = S && s(Q) && Q.length === 1 ? Ie + "[]" : Ie;
    if (E && s(Q) && Q.length === 0)
      return Me + "[]";
    for (var fe = 0; fe < pe.length; ++fe) {
      var Te = pe[fe], Ae = typeof Te == "object" && Te && typeof Te.value < "u" ? Te.value : Q[Te];
      if (!(C && Ae === null)) {
        var we = B && M ? String(Te).replace(/\./g, "%2E") : String(Te), $e = s(Q) ? typeof x == "function" ? x(Me, we) : Me : Me + (B ? "." + we : "[" + we + "]");
        Y.set(_, Z);
        var ze = t();
        ze.set(d, Y), u(me, g(
          Ae,
          $e,
          x,
          S,
          E,
          A,
          C,
          M,
          x === "comma" && de && s(Q) ? null : L,
          X,
          te,
          B,
          W,
          G,
          ne,
          de,
          V,
          ze
        ));
      }
    }
    return me;
  }, m = function(g) {
    if (!g)
      return c;
    if (typeof g.allowEmptyArrays < "u" && typeof g.allowEmptyArrays != "boolean")
      throw new TypeError("`allowEmptyArrays` option can only be `true` or `false`, when provided");
    if (typeof g.encodeDotInKeys < "u" && typeof g.encodeDotInKeys != "boolean")
      throw new TypeError("`encodeDotInKeys` option can only be `true` or `false`, when provided");
    if (g.encoder !== null && typeof g.encoder < "u" && typeof g.encoder != "function")
      throw new TypeError("Encoder has to be a function.");
    var _ = g.charset || c.charset;
    if (typeof g.charset < "u" && g.charset !== "utf-8" && g.charset !== "iso-8859-1")
      throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
    var b = n.default;
    if (typeof g.format < "u") {
      if (!r.call(n.formatters, g.format))
        throw new TypeError("Unknown format option provided.");
      b = g.format;
    }
    var x = n.formatters[b], S = c.filter;
    (typeof g.filter == "function" || s(g.filter)) && (S = g.filter);
    var E;
    if (g.arrayFormat in o ? E = g.arrayFormat : "indices" in g ? E = g.indices ? "indices" : "repeat" : E = c.arrayFormat, "commaRoundTrip" in g && typeof g.commaRoundTrip != "boolean")
      throw new TypeError("`commaRoundTrip` must be a boolean, or absent");
    var A = typeof g.allowDots > "u" ? g.encodeDotInKeys === !0 ? !0 : c.allowDots : !!g.allowDots;
    return {
      addQueryPrefix: typeof g.addQueryPrefix == "boolean" ? g.addQueryPrefix : c.addQueryPrefix,
      allowDots: A,
      allowEmptyArrays: typeof g.allowEmptyArrays == "boolean" ? !!g.allowEmptyArrays : c.allowEmptyArrays,
      arrayFormat: E,
      charset: _,
      charsetSentinel: typeof g.charsetSentinel == "boolean" ? g.charsetSentinel : c.charsetSentinel,
      commaRoundTrip: !!g.commaRoundTrip,
      delimiter: typeof g.delimiter > "u" ? c.delimiter : g.delimiter,
      encode: typeof g.encode == "boolean" ? g.encode : c.encode,
      encodeDotInKeys: typeof g.encodeDotInKeys == "boolean" ? g.encodeDotInKeys : c.encodeDotInKeys,
      encoder: typeof g.encoder == "function" ? g.encoder : c.encoder,
      encodeValuesOnly: typeof g.encodeValuesOnly == "boolean" ? g.encodeValuesOnly : c.encodeValuesOnly,
      filter: S,
      format: b,
      formatter: x,
      serializeDate: typeof g.serializeDate == "function" ? g.serializeDate : c.serializeDate,
      skipNulls: typeof g.skipNulls == "boolean" ? g.skipNulls : c.skipNulls,
      sort: typeof g.sort == "function" ? g.sort : null,
      strictNullHandling: typeof g.strictNullHandling == "boolean" ? g.strictNullHandling : c.strictNullHandling
    };
  };
  return ob = function(g, _) {
    var b = g, x = m(_), S, E;
    typeof x.filter == "function" ? (E = x.filter, b = E("", b)) : s(x.filter) && (E = x.filter, S = E);
    var A = [];
    if (typeof b != "object" || b === null)
      return "";
    var C = o[x.arrayFormat], M = C === "comma" && x.commaRoundTrip;
    S || (S = Object.keys(b)), x.sort && S.sort(x.sort);
    for (var L = t(), X = 0; X < S.length; ++X) {
      var te = S[X], B = b[te];
      x.skipNulls && B === null || u(A, h(
        B,
        te,
        C,
        M,
        x.allowEmptyArrays,
        x.strictNullHandling,
        x.skipNulls,
        x.encodeDotInKeys,
        x.encode ? x.encoder : null,
        x.filter,
        x.sort,
        x.allowDots,
        x.serializeDate,
        x.format,
        x.formatter,
        x.encodeValuesOnly,
        x.charset,
        L
      ));
    }
    var W = A.join(x.delimiter), G = x.addQueryPrefix === !0 ? "?" : "";
    return x.charsetSentinel && (x.charset === "iso-8859-1" ? G += "utf8=%26%2310003%3B&" : G += "utf8=%E2%9C%93&"), W.length > 0 ? G + W : "";
  }, ob;
}
var sb, dC;
function u1e() {
  if (dC) return sb;
  dC = 1;
  var t = /* @__PURE__ */ eB(), e = Object.prototype.hasOwnProperty, n = Array.isArray, r = {
    allowDots: !1,
    allowEmptyArrays: !1,
    allowPrototypes: !1,
    allowSparse: !1,
    arrayLimit: 20,
    charset: "utf-8",
    charsetSentinel: !1,
    comma: !1,
    decodeDotInKeys: !1,
    decoder: t.decode,
    delimiter: "&",
    depth: 5,
    duplicates: "combine",
    ignoreQueryPrefix: !1,
    interpretNumericEntities: !1,
    parameterLimit: 1e3,
    parseArrays: !0,
    plainObjects: !1,
    strictDepth: !1,
    strictNullHandling: !1,
    throwOnLimitExceeded: !1
  }, o = function(d) {
    return d.replace(/&#(\d+);/g, function(h, m) {
      return String.fromCharCode(parseInt(m, 10));
    });
  }, s = function(d, h, m) {
    if (d && typeof d == "string" && h.comma && d.indexOf(",") > -1)
      return d.split(",");
    if (h.throwOnLimitExceeded && m >= h.arrayLimit)
      throw new RangeError("Array limit exceeded. Only " + h.arrayLimit + " element" + (h.arrayLimit === 1 ? "" : "s") + " allowed in an array.");
    return d;
  }, i = "utf8=%26%2310003%3B", u = "utf8=%E2%9C%93", l = function(d, h) {
    var m = { __proto__: null }, g = h.ignoreQueryPrefix ? d.replace(/^\?/, "") : d;
    g = g.replace(/%5B/gi, "[").replace(/%5D/gi, "]");
    var _ = h.parameterLimit === 1 / 0 ? void 0 : h.parameterLimit, b = g.split(
      h.delimiter,
      h.throwOnLimitExceeded ? _ + 1 : _
    );
    if (h.throwOnLimitExceeded && b.length > _)
      throw new RangeError("Parameter limit exceeded. Only " + _ + " parameter" + (_ === 1 ? "" : "s") + " allowed.");
    var x = -1, S, E = h.charset;
    if (h.charsetSentinel)
      for (S = 0; S < b.length; ++S)
        b[S].indexOf("utf8=") === 0 && (b[S] === u ? E = "utf-8" : b[S] === i && (E = "iso-8859-1"), x = S, S = b.length);
    for (S = 0; S < b.length; ++S)
      if (S !== x) {
        var A = b[S], C = A.indexOf("]="), M = C === -1 ? A.indexOf("=") : C + 1, L, X;
        M === -1 ? (L = h.decoder(A, r.decoder, E, "key"), X = h.strictNullHandling ? null : "") : (L = h.decoder(A.slice(0, M), r.decoder, E, "key"), X = t.maybeMap(
          s(
            A.slice(M + 1),
            h,
            n(m[L]) ? m[L].length : 0
          ),
          function(B) {
            return h.decoder(B, r.decoder, E, "value");
          }
        )), X && h.interpretNumericEntities && E === "iso-8859-1" && (X = o(String(X))), A.indexOf("[]=") > -1 && (X = n(X) ? [X] : X);
        var te = e.call(m, L);
        te && h.duplicates === "combine" ? m[L] = t.combine(m[L], X) : (!te || h.duplicates === "last") && (m[L] = X);
      }
    return m;
  }, a = function(d, h, m, g) {
    var _ = 0;
    if (d.length > 0 && d[d.length - 1] === "[]") {
      var b = d.slice(0, -1).join("");
      _ = Array.isArray(h) && h[b] ? h[b].length : 0;
    }
    for (var x = g ? h : s(h, m, _), S = d.length - 1; S >= 0; --S) {
      var E, A = d[S];
      if (A === "[]" && m.parseArrays)
        E = m.allowEmptyArrays && (x === "" || m.strictNullHandling && x === null) ? [] : t.combine([], x);
      else {
        E = m.plainObjects ? { __proto__: null } : {};
        var C = A.charAt(0) === "[" && A.charAt(A.length - 1) === "]" ? A.slice(1, -1) : A, M = m.decodeDotInKeys ? C.replace(/%2E/g, ".") : C, L = parseInt(M, 10);
        !m.parseArrays && M === "" ? E = { 0: x } : !isNaN(L) && A !== M && String(L) === M && L >= 0 && m.parseArrays && L <= m.arrayLimit ? (E = [], E[L] = x) : M !== "__proto__" && (E[M] = x);
      }
      x = E;
    }
    return x;
  }, c = function(d, h, m, g) {
    if (d) {
      var _ = m.allowDots ? d.replace(/\.([^.[]+)/g, "[$1]") : d, b = /(\[[^[\]]*])/, x = /(\[[^[\]]*])/g, S = m.depth > 0 && b.exec(_), E = S ? _.slice(0, S.index) : _, A = [];
      if (E) {
        if (!m.plainObjects && e.call(Object.prototype, E) && !m.allowPrototypes)
          return;
        A.push(E);
      }
      for (var C = 0; m.depth > 0 && (S = x.exec(_)) !== null && C < m.depth; ) {
        if (C += 1, !m.plainObjects && e.call(Object.prototype, S[1].slice(1, -1)) && !m.allowPrototypes)
          return;
        A.push(S[1]);
      }
      if (S) {
        if (m.strictDepth === !0)
          throw new RangeError("Input depth exceeded depth option of " + m.depth + " and strictDepth is true");
        A.push("[" + _.slice(S.index) + "]");
      }
      return a(A, h, m, g);
    }
  }, p = function(d) {
    if (!d)
      return r;
    if (typeof d.allowEmptyArrays < "u" && typeof d.allowEmptyArrays != "boolean")
      throw new TypeError("`allowEmptyArrays` option can only be `true` or `false`, when provided");
    if (typeof d.decodeDotInKeys < "u" && typeof d.decodeDotInKeys != "boolean")
      throw new TypeError("`decodeDotInKeys` option can only be `true` or `false`, when provided");
    if (d.decoder !== null && typeof d.decoder < "u" && typeof d.decoder != "function")
      throw new TypeError("Decoder has to be a function.");
    if (typeof d.charset < "u" && d.charset !== "utf-8" && d.charset !== "iso-8859-1")
      throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
    if (typeof d.throwOnLimitExceeded < "u" && typeof d.throwOnLimitExceeded != "boolean")
      throw new TypeError("`throwOnLimitExceeded` option must be a boolean");
    var h = typeof d.charset > "u" ? r.charset : d.charset, m = typeof d.duplicates > "u" ? r.duplicates : d.duplicates;
    if (m !== "combine" && m !== "first" && m !== "last")
      throw new TypeError("The duplicates option must be either combine, first, or last");
    var g = typeof d.allowDots > "u" ? d.decodeDotInKeys === !0 ? !0 : r.allowDots : !!d.allowDots;
    return {
      allowDots: g,
      allowEmptyArrays: typeof d.allowEmptyArrays == "boolean" ? !!d.allowEmptyArrays : r.allowEmptyArrays,
      allowPrototypes: typeof d.allowPrototypes == "boolean" ? d.allowPrototypes : r.allowPrototypes,
      allowSparse: typeof d.allowSparse == "boolean" ? d.allowSparse : r.allowSparse,
      arrayLimit: typeof d.arrayLimit == "number" ? d.arrayLimit : r.arrayLimit,
      charset: h,
      charsetSentinel: typeof d.charsetSentinel == "boolean" ? d.charsetSentinel : r.charsetSentinel,
      comma: typeof d.comma == "boolean" ? d.comma : r.comma,
      decodeDotInKeys: typeof d.decodeDotInKeys == "boolean" ? d.decodeDotInKeys : r.decodeDotInKeys,
      decoder: typeof d.decoder == "function" ? d.decoder : r.decoder,
      delimiter: typeof d.delimiter == "string" || t.isRegExp(d.delimiter) ? d.delimiter : r.delimiter,
      // eslint-disable-next-line no-implicit-coercion, no-extra-parens
      depth: typeof d.depth == "number" || d.depth === !1 ? +d.depth : r.depth,
      duplicates: m,
      ignoreQueryPrefix: d.ignoreQueryPrefix === !0,
      interpretNumericEntities: typeof d.interpretNumericEntities == "boolean" ? d.interpretNumericEntities : r.interpretNumericEntities,
      parameterLimit: typeof d.parameterLimit == "number" ? d.parameterLimit : r.parameterLimit,
      parseArrays: d.parseArrays !== !1,
      plainObjects: typeof d.plainObjects == "boolean" ? d.plainObjects : r.plainObjects,
      strictDepth: typeof d.strictDepth == "boolean" ? !!d.strictDepth : r.strictDepth,
      strictNullHandling: typeof d.strictNullHandling == "boolean" ? d.strictNullHandling : r.strictNullHandling,
      throwOnLimitExceeded: typeof d.throwOnLimitExceeded == "boolean" ? d.throwOnLimitExceeded : !1
    };
  };
  return sb = function(d, h) {
    var m = p(h);
    if (d === "" || d === null || typeof d > "u")
      return m.plainObjects ? { __proto__: null } : {};
    for (var g = typeof d == "string" ? l(d, m) : d, _ = m.plainObjects ? { __proto__: null } : {}, b = Object.keys(g), x = 0; x < b.length; ++x) {
      var S = b[x], E = c(S, g[S], m, typeof d == "string");
      _ = t.merge(_, E, m);
    }
    return m.allowSparse === !0 ? _ : t.compact(_);
  }, sb;
}
var ab, hC;
function l1e() {
  if (hC) return ab;
  hC = 1;
  var t = /* @__PURE__ */ i1e(), e = /* @__PURE__ */ u1e(), n = /* @__PURE__ */ xS();
  return ab = {
    formats: n,
    parse: e,
    stringify: t
  }, ab;
}
var fC;
function c1e() {
  if (fC) return Yc;
  fC = 1;
  var t = Mwe();
  function e() {
    this.protocol = null, this.slashes = null, this.auth = null, this.host = null, this.port = null, this.hostname = null, this.hash = null, this.search = null, this.query = null, this.pathname = null, this.path = null, this.href = null;
  }
  var n = /^([a-z0-9.+-]+:)/i, r = /:[0-9]*$/, o = /^(\/\/?(?!\/)[^?\s]*)(\?[^\s]*)?$/, s = [
    "<",
    ">",
    '"',
    "`",
    " ",
    "\r",
    `
`,
    "	"
  ], i = [
    "{",
    "}",
    "|",
    "\\",
    "^",
    "`"
  ].concat(s), u = ["'"].concat(i), l = [
    "%",
    "/",
    "?",
    ";",
    "#"
  ].concat(u), a = [
    "/",
    "?",
    "#"
  ], c = 255, p = /^[+a-z0-9A-Z_-]{0,63}$/, d = /^([+a-z0-9A-Z_-]{0,63})(.*)$/, h = {
    javascript: !0,
    "javascript:": !0
  }, m = {
    javascript: !0,
    "javascript:": !0
  }, g = {
    http: !0,
    https: !0,
    ftp: !0,
    gopher: !0,
    file: !0,
    "http:": !0,
    "https:": !0,
    "ftp:": !0,
    "gopher:": !0,
    "file:": !0
  }, _ = /* @__PURE__ */ l1e();
  function b(A, C, M) {
    if (A && typeof A == "object" && A instanceof e)
      return A;
    var L = new e();
    return L.parse(A, C, M), L;
  }
  e.prototype.parse = function(A, C, M) {
    if (typeof A != "string")
      throw new TypeError("Parameter 'url' must be a string, not " + typeof A);
    var L = A.indexOf("?"), X = L !== -1 && L < A.indexOf("#") ? "?" : "#", te = A.split(X), B = /\\/g;
    te[0] = te[0].replace(B, "/"), A = te.join(X);
    var W = A;
    if (W = W.trim(), !M && A.split("#").length === 1) {
      var G = o.exec(W);
      if (G)
        return this.path = W, this.href = W, this.pathname = G[1], G[2] ? (this.search = G[2], C ? this.query = _.parse(this.search.substr(1)) : this.query = this.search.substr(1)) : C && (this.search = "", this.query = {}), this;
    }
    var ne = n.exec(W);
    if (ne) {
      ne = ne[0];
      var de = ne.toLowerCase();
      this.protocol = de, W = W.substr(ne.length);
    }
    if (M || ne || W.match(/^\/\/[^@/]+@[^@/]+/)) {
      var V = W.substr(0, 2) === "//";
      V && !(ne && m[ne]) && (W = W.substr(2), this.slashes = !0);
    }
    if (!m[ne] && (V || ne && !g[ne])) {
      for (var Y = -1, Q = 0; Q < a.length; Q++) {
        var ae = W.indexOf(a[Q]);
        ae !== -1 && (Y === -1 || ae < Y) && (Y = ae);
      }
      var Z, J;
      Y === -1 ? J = W.lastIndexOf("@") : J = W.lastIndexOf("@", Y), J !== -1 && (Z = W.slice(0, J), W = W.slice(J + 1), this.auth = decodeURIComponent(Z)), Y = -1;
      for (var Q = 0; Q < l.length; Q++) {
        var ae = W.indexOf(l[Q]);
        ae !== -1 && (Y === -1 || ae < Y) && (Y = ae);
      }
      Y === -1 && (Y = W.length), this.host = W.slice(0, Y), W = W.slice(Y), this.parseHost(), this.hostname = this.hostname || "";
      var oe = this.hostname[0] === "[" && this.hostname[this.hostname.length - 1] === "]";
      if (!oe)
        for (var ue = this.hostname.split(/\./), Q = 0, me = ue.length; Q < me; Q++) {
          var pe = ue[Q];
          if (pe && !pe.match(p)) {
            for (var Be = "", Ie = 0, Me = pe.length; Ie < Me; Ie++)
              pe.charCodeAt(Ie) > 127 ? Be += "x" : Be += pe[Ie];
            if (!Be.match(p)) {
              var fe = ue.slice(0, Q), Te = ue.slice(Q + 1), Ae = pe.match(d);
              Ae && (fe.push(Ae[1]), Te.unshift(Ae[2])), Te.length && (W = "/" + Te.join(".") + W), this.hostname = fe.join(".");
              break;
            }
          }
        }
      this.hostname.length > c ? this.hostname = "" : this.hostname = this.hostname.toLowerCase(), oe || (this.hostname = t.toASCII(this.hostname));
      var we = this.port ? ":" + this.port : "", $e = this.hostname || "";
      this.host = $e + we, this.href += this.host, oe && (this.hostname = this.hostname.substr(1, this.hostname.length - 2), W[0] !== "/" && (W = "/" + W));
    }
    if (!h[de])
      for (var Q = 0, me = u.length; Q < me; Q++) {
        var ze = u[Q];
        if (W.indexOf(ze) !== -1) {
          var Ue = encodeURIComponent(ze);
          Ue === ze && (Ue = escape(ze)), W = W.split(ze).join(Ue);
        }
      }
    var tt = W.indexOf("#");
    tt !== -1 && (this.hash = W.substr(tt), W = W.slice(0, tt));
    var Ot = W.indexOf("?");
    if (Ot !== -1 ? (this.search = W.substr(Ot), this.query = W.substr(Ot + 1), C && (this.query = _.parse(this.query)), W = W.slice(0, Ot)) : C && (this.search = "", this.query = {}), W && (this.pathname = W), g[de] && this.hostname && !this.pathname && (this.pathname = "/"), this.pathname || this.search) {
      var we = this.pathname || "", cn = this.search || "";
      this.path = we + cn;
    }
    return this.href = this.format(), this;
  };
  function x(A) {
    return typeof A == "string" && (A = b(A)), A instanceof e ? A.format() : e.prototype.format.call(A);
  }
  e.prototype.format = function() {
    var A = this.auth || "";
    A && (A = encodeURIComponent(A), A = A.replace(/%3A/i, ":"), A += "@");
    var C = this.protocol || "", M = this.pathname || "", L = this.hash || "", X = !1, te = "";
    this.host ? X = A + this.host : this.hostname && (X = A + (this.hostname.indexOf(":") === -1 ? this.hostname : "[" + this.hostname + "]"), this.port && (X += ":" + this.port)), this.query && typeof this.query == "object" && Object.keys(this.query).length && (te = _.stringify(this.query, {
      arrayFormat: "repeat",
      addQueryPrefix: !1
    }));
    var B = this.search || te && "?" + te || "";
    return C && C.substr(-1) !== ":" && (C += ":"), this.slashes || (!C || g[C]) && X !== !1 ? (X = "//" + (X || ""), M && M.charAt(0) !== "/" && (M = "/" + M)) : X || (X = ""), L && L.charAt(0) !== "#" && (L = "#" + L), B && B.charAt(0) !== "?" && (B = "?" + B), M = M.replace(/[?#]/g, function(W) {
      return encodeURIComponent(W);
    }), B = B.replace("#", "%23"), C + X + M + B + L;
  };
  function S(A, C) {
    return b(A, !1, !0).resolve(C);
  }
  e.prototype.resolve = function(A) {
    return this.resolveObject(b(A, !1, !0)).format();
  };
  function E(A, C) {
    return A ? b(A, !1, !0).resolveObject(C) : C;
  }
  return e.prototype.resolveObject = function(A) {
    if (typeof A == "string") {
      var C = new e();
      C.parse(A, !1, !0), A = C;
    }
    for (var M = new e(), L = Object.keys(this), X = 0; X < L.length; X++) {
      var te = L[X];
      M[te] = this[te];
    }
    if (M.hash = A.hash, A.href === "")
      return M.href = M.format(), M;
    if (A.slashes && !A.protocol) {
      for (var B = Object.keys(A), W = 0; W < B.length; W++) {
        var G = B[W];
        G !== "protocol" && (M[G] = A[G]);
      }
      return g[M.protocol] && M.hostname && !M.pathname && (M.pathname = "/", M.path = M.pathname), M.href = M.format(), M;
    }
    if (A.protocol && A.protocol !== M.protocol) {
      if (!g[A.protocol]) {
        for (var ne = Object.keys(A), de = 0; de < ne.length; de++) {
          var V = ne[de];
          M[V] = A[V];
        }
        return M.href = M.format(), M;
      }
      if (M.protocol = A.protocol, !A.host && !m[A.protocol]) {
        for (var me = (A.pathname || "").split("/"); me.length && !(A.host = me.shift()); )
          ;
        A.host || (A.host = ""), A.hostname || (A.hostname = ""), me[0] !== "" && me.unshift(""), me.length < 2 && me.unshift(""), M.pathname = me.join("/");
      } else
        M.pathname = A.pathname;
      if (M.search = A.search, M.query = A.query, M.host = A.host || "", M.auth = A.auth, M.hostname = A.hostname || A.host, M.port = A.port, M.pathname || M.search) {
        var Y = M.pathname || "", Q = M.search || "";
        M.path = Y + Q;
      }
      return M.slashes = M.slashes || A.slashes, M.href = M.format(), M;
    }
    var ae = M.pathname && M.pathname.charAt(0) === "/", Z = A.host || A.pathname && A.pathname.charAt(0) === "/", J = Z || ae || M.host && A.pathname, oe = J, ue = M.pathname && M.pathname.split("/") || [], me = A.pathname && A.pathname.split("/") || [], pe = M.protocol && !g[M.protocol];
    if (pe && (M.hostname = "", M.port = null, M.host && (ue[0] === "" ? ue[0] = M.host : ue.unshift(M.host)), M.host = "", A.protocol && (A.hostname = null, A.port = null, A.host && (me[0] === "" ? me[0] = A.host : me.unshift(A.host)), A.host = null), J = J && (me[0] === "" || ue[0] === "")), Z)
      M.host = A.host || A.host === "" ? A.host : M.host, M.hostname = A.hostname || A.hostname === "" ? A.hostname : M.hostname, M.search = A.search, M.query = A.query, ue = me;
    else if (me.length)
      ue || (ue = []), ue.pop(), ue = ue.concat(me), M.search = A.search, M.query = A.query;
    else if (A.search != null) {
      if (pe) {
        M.host = ue.shift(), M.hostname = M.host;
        var Be = M.host && M.host.indexOf("@") > 0 ? M.host.split("@") : !1;
        Be && (M.auth = Be.shift(), M.hostname = Be.shift(), M.host = M.hostname);
      }
      return M.search = A.search, M.query = A.query, (M.pathname !== null || M.search !== null) && (M.path = (M.pathname ? M.pathname : "") + (M.search ? M.search : "")), M.href = M.format(), M;
    }
    if (!ue.length)
      return M.pathname = null, M.search ? M.path = "/" + M.search : M.path = null, M.href = M.format(), M;
    for (var Ie = ue.slice(-1)[0], Me = (M.host || A.host || ue.length > 1) && (Ie === "." || Ie === "..") || Ie === "", fe = 0, Te = ue.length; Te >= 0; Te--)
      Ie = ue[Te], Ie === "." ? ue.splice(Te, 1) : Ie === ".." ? (ue.splice(Te, 1), fe++) : fe && (ue.splice(Te, 1), fe--);
    if (!J && !oe)
      for (; fe--; fe)
        ue.unshift("..");
    J && ue[0] !== "" && (!ue[0] || ue[0].charAt(0) !== "/") && ue.unshift(""), Me && ue.join("/").substr(-1) !== "/" && ue.push("");
    var Ae = ue[0] === "" || ue[0] && ue[0].charAt(0) === "/";
    if (pe) {
      M.hostname = Ae ? "" : ue.length ? ue.shift() : "", M.host = M.hostname;
      var Be = M.host && M.host.indexOf("@") > 0 ? M.host.split("@") : !1;
      Be && (M.auth = Be.shift(), M.hostname = Be.shift(), M.host = M.hostname);
    }
    return J = J || M.host && ue.length, J && !Ae && ue.unshift(""), ue.length > 0 ? M.pathname = ue.join("/") : (M.pathname = null, M.path = null), (M.pathname !== null || M.search !== null) && (M.path = (M.pathname ? M.pathname : "") + (M.search ? M.search : "")), M.auth = A.auth || M.auth, M.slashes = M.slashes || A.slashes, M.href = M.format(), M;
  }, e.prototype.parseHost = function() {
    var A = this.host, C = r.exec(A);
    C && (C = C[0], C !== ":" && (this.port = C.substr(1)), A = A.substr(0, A.length - C.length)), A && (this.hostname = A);
  }, Yc.parse = b, Yc.resolve = S, Yc.resolveObject = E, Yc.format = x, Yc.Url = e, Yc;
}
c1e();
const mC = {};
function un(t, e, n = 3) {
  if (mC[e])
    return;
  let r = new Error().stack;
  typeof r > "u" ? console.warn("PixiJS Deprecation Warning: ", `${e}
Deprecated since v${t}`) : (r = r.split(`
`).splice(n).join(`
`), console.groupCollapsed ? (console.groupCollapsed(
    "%cPixiJS Deprecation Warning: %c%s",
    "color:#614108;background:#fffbe6",
    "font-weight:normal;color:#614108;background:#fffbe6",
    `${e}
Deprecated since v${t}`
  ), console.warn(r), console.groupEnd()) : (console.warn("PixiJS Deprecation Warning: ", `${e}
Deprecated since v${t}`), console.warn(r))), mC[e] = !0;
}
function Ja(t) {
  if (typeof t != "string")
    throw new TypeError(`Path must be a string. Received ${JSON.stringify(t)}`);
}
function gf(t) {
  return t.split("?")[0].split("#")[0];
}
function p1e(t) {
  return t.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
function d1e(t, e, n) {
  return t.replace(new RegExp(p1e(e), "g"), n);
}
function h1e(t, e) {
  let n = "", r = 0, o = -1, s = 0, i = -1;
  for (let u = 0; u <= t.length; ++u) {
    if (u < t.length)
      i = t.charCodeAt(u);
    else {
      if (i === 47)
        break;
      i = 47;
    }
    if (i === 47) {
      if (!(o === u - 1 || s === 1))
        if (o !== u - 1 && s === 2) {
          if (n.length < 2 || r !== 2 || n.charCodeAt(n.length - 1) !== 46 || n.charCodeAt(n.length - 2) !== 46) {
            if (n.length > 2) {
              const l = n.lastIndexOf("/");
              if (l !== n.length - 1) {
                l === -1 ? (n = "", r = 0) : (n = n.slice(0, l), r = n.length - 1 - n.lastIndexOf("/")), o = u, s = 0;
                continue;
              }
            } else if (n.length === 2 || n.length === 1) {
              n = "", r = 0, o = u, s = 0;
              continue;
            }
          }
        } else
          n.length > 0 ? n += `/${t.slice(o + 1, u)}` : n = t.slice(o + 1, u), r = u - o - 1;
      o = u, s = 0;
    } else
      i === 46 && s !== -1 ? ++s : s = -1;
  }
  return n;
}
const lo = {
  /**
   * Converts a path to posix format.
   * @param path - The path to convert to posix
   */
  toPosix(t) {
    return d1e(t, "\\", "/");
  },
  /**
   * Checks if the path is a URL e.g. http://, https://
   * @param path - The path to check
   */
  isUrl(t) {
    return /^https?:/.test(this.toPosix(t));
  },
  /**
   * Checks if the path is a data URL
   * @param path - The path to check
   */
  isDataUrl(t) {
    return /^data:([a-z]+\/[a-z0-9-+.]+(;[a-z0-9-.!#$%*+.{}|~`]+=[a-z0-9-.!#$%*+.{}()_|~`]+)*)?(;base64)?,([a-z0-9!$&',()*+;=\-._~:@\/?%\s<>]*?)$/i.test(t);
  },
  /**
   * Checks if the path is a blob URL
   * @param path - The path to check
   */
  isBlobUrl(t) {
    return t.startsWith("blob:");
  },
  /**
   * Checks if the path has a protocol e.g. http://, https://, file:///, data:, blob:, C:/
   * This will return true for windows file paths
   * @param path - The path to check
   */
  hasProtocol(t) {
    return /^[^/:]+:/.test(this.toPosix(t));
  },
  /**
   * Returns the protocol of the path e.g. http://, https://, file:///, data:, blob:, C:/
   * @param path - The path to get the protocol from
   */
  getProtocol(t) {
    Ja(t), t = this.toPosix(t);
    const e = /^file:\/\/\//.exec(t);
    if (e)
      return e[0];
    const n = /^[^/:]+:\/{0,2}/.exec(t);
    return n ? n[0] : "";
  },
  /**
   * Converts URL to an absolute path.
   * When loading from a Web Worker, we must use absolute paths.
   * If the URL is already absolute we return it as is
   * If it's not, we convert it
   * @param url - The URL to test
   * @param customBaseUrl - The base URL to use
   * @param customRootUrl - The root URL to use
   */
  toAbsolute(t, e, n) {
    if (Ja(t), this.isDataUrl(t) || this.isBlobUrl(t))
      return t;
    const r = gf(this.toPosix(e ?? at.ADAPTER.getBaseUrl())), o = gf(this.toPosix(n ?? this.rootname(r)));
    return t = this.toPosix(t), t.startsWith("/") ? lo.join(o, t.slice(1)) : this.isAbsolute(t) ? t : this.join(r, t);
  },
  /**
   * Normalizes the given path, resolving '..' and '.' segments
   * @param path - The path to normalize
   */
  normalize(t) {
    if (Ja(t), t.length === 0)
      return ".";
    if (this.isDataUrl(t) || this.isBlobUrl(t))
      return t;
    t = this.toPosix(t);
    let e = "";
    const n = t.startsWith("/");
    this.hasProtocol(t) && (e = this.rootname(t), t = t.slice(e.length));
    const r = t.endsWith("/");
    return t = h1e(t), t.length > 0 && r && (t += "/"), n ? `/${t}` : e + t;
  },
  /**
   * Determines if path is an absolute path.
   * Absolute paths can be urls, data urls, or paths on disk
   * @param path - The path to test
   */
  isAbsolute(t) {
    return Ja(t), t = this.toPosix(t), this.hasProtocol(t) ? !0 : t.startsWith("/");
  },
  /**
   * Joins all given path segments together using the platform-specific separator as a delimiter,
   * then normalizes the resulting path
   * @param segments - The segments of the path to join
   */
  join(...t) {
    if (t.length === 0)
      return ".";
    let e;
    for (let n = 0; n < t.length; ++n) {
      const r = t[n];
      if (Ja(r), r.length > 0)
        if (e === void 0)
          e = r;
        else {
          const o = t[n - 1] ?? "";
          this.extname(o) ? e += `/../${r}` : e += `/${r}`;
        }
    }
    return e === void 0 ? "." : this.normalize(e);
  },
  /**
   * Returns the directory name of a path
   * @param path - The path to parse
   */
  dirname(t) {
    if (Ja(t), t.length === 0)
      return ".";
    t = this.toPosix(t);
    let e = t.charCodeAt(0);
    const n = e === 47;
    let r = -1, o = !0;
    const s = this.getProtocol(t), i = t;
    t = t.slice(s.length);
    for (let u = t.length - 1; u >= 1; --u)
      if (e = t.charCodeAt(u), e === 47) {
        if (!o) {
          r = u;
          break;
        }
      } else
        o = !1;
    return r === -1 ? n ? "/" : this.isUrl(i) ? s + t : s : n && r === 1 ? "//" : s + t.slice(0, r);
  },
  /**
   * Returns the root of the path e.g. /, C:/, file:///, http://domain.com/
   * @param path - The path to parse
   */
  rootname(t) {
    Ja(t), t = this.toPosix(t);
    let e = "";
    if (t.startsWith("/") ? e = "/" : e = this.getProtocol(t), this.isUrl(t)) {
      const n = t.indexOf("/", e.length);
      n !== -1 ? e = t.slice(0, n) : e = t, e.endsWith("/") || (e += "/");
    }
    return e;
  },
  /**
   * Returns the last portion of a path
   * @param path - The path to test
   * @param ext - Optional extension to remove
   */
  basename(t, e) {
    Ja(t), e && Ja(e), t = gf(this.toPosix(t));
    let n = 0, r = -1, o = !0, s;
    if (e !== void 0 && e.length > 0 && e.length <= t.length) {
      if (e.length === t.length && e === t)
        return "";
      let i = e.length - 1, u = -1;
      for (s = t.length - 1; s >= 0; --s) {
        const l = t.charCodeAt(s);
        if (l === 47) {
          if (!o) {
            n = s + 1;
            break;
          }
        } else
          u === -1 && (o = !1, u = s + 1), i >= 0 && (l === e.charCodeAt(i) ? --i === -1 && (r = s) : (i = -1, r = u));
      }
      return n === r ? r = u : r === -1 && (r = t.length), t.slice(n, r);
    }
    for (s = t.length - 1; s >= 0; --s)
      if (t.charCodeAt(s) === 47) {
        if (!o) {
          n = s + 1;
          break;
        }
      } else
        r === -1 && (o = !1, r = s + 1);
    return r === -1 ? "" : t.slice(n, r);
  },
  /**
   * Returns the extension of the path, from the last occurrence of the . (period) character to end of string in the last
   * portion of the path. If there is no . in the last portion of the path, or if there are no . characters other than
   * the first character of the basename of path, an empty string is returned.
   * @param path - The path to parse
   */
  extname(t) {
    Ja(t), t = gf(this.toPosix(t));
    let e = -1, n = 0, r = -1, o = !0, s = 0;
    for (let i = t.length - 1; i >= 0; --i) {
      const u = t.charCodeAt(i);
      if (u === 47) {
        if (!o) {
          n = i + 1;
          break;
        }
        continue;
      }
      r === -1 && (o = !1, r = i + 1), u === 46 ? e === -1 ? e = i : s !== 1 && (s = 1) : e !== -1 && (s = -1);
    }
    return e === -1 || r === -1 || s === 0 || s === 1 && e === r - 1 && e === n + 1 ? "" : t.slice(e, r);
  },
  /**
   * Parses a path into an object containing the 'root', `dir`, `base`, `ext`, and `name` properties.
   * @param path - The path to parse
   */
  parse(t) {
    Ja(t);
    const e = { root: "", dir: "", base: "", ext: "", name: "" };
    if (t.length === 0)
      return e;
    t = gf(this.toPosix(t));
    let n = t.charCodeAt(0);
    const r = this.isAbsolute(t);
    let o;
    e.root = this.rootname(t), r || this.hasProtocol(t) ? o = 1 : o = 0;
    let s = -1, i = 0, u = -1, l = !0, a = t.length - 1, c = 0;
    for (; a >= o; --a) {
      if (n = t.charCodeAt(a), n === 47) {
        if (!l) {
          i = a + 1;
          break;
        }
        continue;
      }
      u === -1 && (l = !1, u = a + 1), n === 46 ? s === -1 ? s = a : c !== 1 && (c = 1) : s !== -1 && (c = -1);
    }
    return s === -1 || u === -1 || c === 0 || c === 1 && s === u - 1 && s === i + 1 ? u !== -1 && (i === 0 && r ? e.base = e.name = t.slice(1, u) : e.base = e.name = t.slice(i, u)) : (i === 0 && r ? (e.name = t.slice(1, s), e.base = t.slice(1, u)) : (e.name = t.slice(i, s), e.base = t.slice(i, u)), e.ext = t.slice(s, u)), e.dir = this.dirname(t), e;
  },
  sep: "/",
  delimiter: ":"
};
let ib;
async function f1e() {
  return ib ?? (ib = (async () => {
    const t = document.createElement("canvas").getContext("webgl");
    if (!t)
      return gs.UNPACK;
    const e = await new Promise((s) => {
      const i = document.createElement("video");
      i.onloadeddata = () => s(i), i.onerror = () => s(null), i.autoplay = !1, i.crossOrigin = "anonymous", i.preload = "auto", i.src = "data:video/webm;base64,GkXfo59ChoEBQveBAULygQRC84EIQoKEd2VibUKHgQJChYECGFOAZwEAAAAAAAHTEU2bdLpNu4tTq4QVSalmU6yBoU27i1OrhBZUrmtTrIHGTbuMU6uEElTDZ1OsggEXTbuMU6uEHFO7a1OsggG97AEAAAAAAABZAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVSalmoCrXsYMPQkBNgIRMYXZmV0GETGF2ZkSJiEBEAAAAAAAAFlSua8yuAQAAAAAAAEPXgQFzxYgAAAAAAAAAAZyBACK1nIN1bmSIgQCGhVZfVlA5g4EBI+ODhAJiWgDglLCBArqBApqBAlPAgQFVsIRVuYEBElTDZ9Vzc9JjwItjxYgAAAAAAAAAAWfInEWjh0VOQ09ERVJEh49MYXZjIGxpYnZweC12cDlnyKJFo4hEVVJBVElPTkSHlDAwOjAwOjAwLjA0MDAwMDAwMAAAH0O2dcfngQCgwqGggQAAAIJJg0IAABAAFgA4JBwYSgAAICAAEb///4r+AAB1oZ2mm+6BAaWWgkmDQgAAEAAWADgkHBhKAAAgIABIQBxTu2uRu4+zgQC3iveBAfGCAXHwgQM=", i.load();
    });
    if (!e)
      return gs.UNPACK;
    const n = t.createTexture();
    t.bindTexture(t.TEXTURE_2D, n);
    const r = t.createFramebuffer();
    t.bindFramebuffer(t.FRAMEBUFFER, r), t.framebufferTexture2D(
      t.FRAMEBUFFER,
      t.COLOR_ATTACHMENT0,
      t.TEXTURE_2D,
      n,
      0
    ), t.pixelStorei(t.UNPACK_PREMULTIPLY_ALPHA_WEBGL, !1), t.pixelStorei(t.UNPACK_COLORSPACE_CONVERSION_WEBGL, t.NONE), t.texImage2D(t.TEXTURE_2D, 0, t.RGBA, t.RGBA, t.UNSIGNED_BYTE, e);
    const o = new Uint8Array(4);
    return t.readPixels(0, 0, 1, 1, t.RGBA, t.UNSIGNED_BYTE, o), t.deleteFramebuffer(r), t.deleteTexture(n), t.getExtension("WEBGL_lose_context")?.loseContext(), o[0] <= o[3] ? gs.PMA : gs.UNPACK;
  })()), ib;
}
let ub;
function m1e() {
  return typeof ub > "u" && (ub = function() {
    const t = {
      stencil: !0,
      failIfMajorPerformanceCaveat: at.FAIL_IF_MAJOR_PERFORMANCE_CAVEAT
    };
    try {
      if (!at.ADAPTER.getWebGLRenderingContext())
        return !1;
      const e = at.ADAPTER.createCanvas();
      let n = e.getContext("webgl", t) || e.getContext("experimental-webgl", t);
      const r = !!n?.getContextAttributes()?.stencil;
      if (n) {
        const o = n.getExtension("WEBGL_lose_context");
        o && o.loseContext();
      }
      return n = null, r;
    } catch {
      return !1;
    }
  }()), ub;
}
var y1e = { grad: 0.9, turn: 360, rad: 360 / (2 * Math.PI) }, $u = function(t) {
  return typeof t == "string" ? t.length > 0 : typeof t == "number";
}, yo = function(t, e, n) {
  return e === void 0 && (e = 0), n === void 0 && (n = Math.pow(10, e)), Math.round(n * t) / n + 0;
}, Da = function(t, e, n) {
  return e === void 0 && (e = 0), n === void 0 && (n = 1), t > n ? n : t > e ? t : e;
}, tB = function(t) {
  return (t = isFinite(t) ? t % 360 : 0) > 0 ? t : t + 360;
}, yC = function(t) {
  return { r: Da(t.r, 0, 255), g: Da(t.g, 0, 255), b: Da(t.b, 0, 255), a: Da(t.a) };
}, lb = function(t) {
  return { r: yo(t.r), g: yo(t.g), b: yo(t.b), a: yo(t.a, 3) };
}, g1e = /^#([0-9a-f]{3,8})$/i, fg = function(t) {
  var e = t.toString(16);
  return e.length < 2 ? "0" + e : e;
}, nB = function(t) {
  var e = t.r, n = t.g, r = t.b, o = t.a, s = Math.max(e, n, r), i = s - Math.min(e, n, r), u = i ? s === e ? (n - r) / i : s === n ? 2 + (r - e) / i : 4 + (e - n) / i : 0;
  return { h: 60 * (u < 0 ? u + 6 : u), s: s ? i / s * 100 : 0, v: s / 255 * 100, a: o };
}, rB = function(t) {
  var e = t.h, n = t.s, r = t.v, o = t.a;
  e = e / 360 * 6, n /= 100, r /= 100;
  var s = Math.floor(e), i = r * (1 - n), u = r * (1 - (e - s) * n), l = r * (1 - (1 - e + s) * n), a = s % 6;
  return { r: 255 * [r, u, i, i, l, r][a], g: 255 * [l, r, r, u, i, i][a], b: 255 * [i, i, l, r, r, u][a], a: o };
}, gC = function(t) {
  return { h: tB(t.h), s: Da(t.s, 0, 100), l: Da(t.l, 0, 100), a: Da(t.a) };
}, vC = function(t) {
  return { h: yo(t.h), s: yo(t.s), l: yo(t.l), a: yo(t.a, 3) };
}, _C = function(t) {
  return rB((n = (e = t).s, { h: e.h, s: (n *= ((r = e.l) < 50 ? r : 100 - r) / 100) > 0 ? 2 * n / (r + n) * 100 : 0, v: r + n, a: e.a }));
  var e, n, r;
}, Zf = function(t) {
  return { h: (e = nB(t)).h, s: (o = (200 - (n = e.s)) * (r = e.v) / 100) > 0 && o < 200 ? n * r / 100 / (o <= 100 ? o : 200 - o) * 100 : 0, l: o / 2, a: e.a };
  var e, n, r, o;
}, v1e = /^hsla?\(\s*([+-]?\d*\.?\d+)(deg|rad|grad|turn)?\s*,\s*([+-]?\d*\.?\d+)%\s*,\s*([+-]?\d*\.?\d+)%\s*(?:,\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i, _1e = /^hsla?\(\s*([+-]?\d*\.?\d+)(deg|rad|grad|turn)?\s+([+-]?\d*\.?\d+)%\s+([+-]?\d*\.?\d+)%\s*(?:\/\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i, w1e = /^rgba?\(\s*([+-]?\d*\.?\d+)(%)?\s*,\s*([+-]?\d*\.?\d+)(%)?\s*,\s*([+-]?\d*\.?\d+)(%)?\s*(?:,\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i, b1e = /^rgba?\(\s*([+-]?\d*\.?\d+)(%)?\s+([+-]?\d*\.?\d+)(%)?\s+([+-]?\d*\.?\d+)(%)?\s*(?:\/\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i, Qk = { string: [[function(t) {
  var e = g1e.exec(t);
  return e ? (t = e[1]).length <= 4 ? { r: parseInt(t[0] + t[0], 16), g: parseInt(t[1] + t[1], 16), b: parseInt(t[2] + t[2], 16), a: t.length === 4 ? yo(parseInt(t[3] + t[3], 16) / 255, 2) : 1 } : t.length === 6 || t.length === 8 ? { r: parseInt(t.substr(0, 2), 16), g: parseInt(t.substr(2, 2), 16), b: parseInt(t.substr(4, 2), 16), a: t.length === 8 ? yo(parseInt(t.substr(6, 2), 16) / 255, 2) : 1 } : null : null;
}, "hex"], [function(t) {
  var e = w1e.exec(t) || b1e.exec(t);
  return e ? e[2] !== e[4] || e[4] !== e[6] ? null : yC({ r: Number(e[1]) / (e[2] ? 100 / 255 : 1), g: Number(e[3]) / (e[4] ? 100 / 255 : 1), b: Number(e[5]) / (e[6] ? 100 / 255 : 1), a: e[7] === void 0 ? 1 : Number(e[7]) / (e[8] ? 100 : 1) }) : null;
}, "rgb"], [function(t) {
  var e = v1e.exec(t) || _1e.exec(t);
  if (!e) return null;
  var n, r, o = gC({ h: (n = e[1], r = e[2], r === void 0 && (r = "deg"), Number(n) * (y1e[r] || 1)), s: Number(e[3]), l: Number(e[4]), a: e[5] === void 0 ? 1 : Number(e[5]) / (e[6] ? 100 : 1) });
  return _C(o);
}, "hsl"]], object: [[function(t) {
  var e = t.r, n = t.g, r = t.b, o = t.a, s = o === void 0 ? 1 : o;
  return $u(e) && $u(n) && $u(r) ? yC({ r: Number(e), g: Number(n), b: Number(r), a: Number(s) }) : null;
}, "rgb"], [function(t) {
  var e = t.h, n = t.s, r = t.l, o = t.a, s = o === void 0 ? 1 : o;
  if (!$u(e) || !$u(n) || !$u(r)) return null;
  var i = gC({ h: Number(e), s: Number(n), l: Number(r), a: Number(s) });
  return _C(i);
}, "hsl"], [function(t) {
  var e = t.h, n = t.s, r = t.v, o = t.a, s = o === void 0 ? 1 : o;
  if (!$u(e) || !$u(n) || !$u(r)) return null;
  var i = function(u) {
    return { h: tB(u.h), s: Da(u.s, 0, 100), v: Da(u.v, 0, 100), a: Da(u.a) };
  }({ h: Number(e), s: Number(n), v: Number(r), a: Number(s) });
  return rB(i);
}, "hsv"]] }, wC = function(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n][0](t);
    if (r) return [r, e[n][1]];
  }
  return [null, void 0];
}, k1e = function(t) {
  return typeof t == "string" ? wC(t.trim(), Qk.string) : typeof t == "object" && t !== null ? wC(t, Qk.object) : [null, void 0];
}, cb = function(t, e) {
  var n = Zf(t);
  return { h: n.h, s: Da(n.s + 100 * e, 0, 100), l: n.l, a: n.a };
}, pb = function(t) {
  return (299 * t.r + 587 * t.g + 114 * t.b) / 1e3 / 255;
}, bC = function(t, e) {
  var n = Zf(t);
  return { h: n.h, s: n.s, l: Da(n.l + 100 * e, 0, 100), a: n.a };
}, Kk = function() {
  function t(e) {
    this.parsed = k1e(e)[0], this.rgba = this.parsed || { r: 0, g: 0, b: 0, a: 1 };
  }
  return t.prototype.isValid = function() {
    return this.parsed !== null;
  }, t.prototype.brightness = function() {
    return yo(pb(this.rgba), 2);
  }, t.prototype.isDark = function() {
    return pb(this.rgba) < 0.5;
  }, t.prototype.isLight = function() {
    return pb(this.rgba) >= 0.5;
  }, t.prototype.toHex = function() {
    return e = lb(this.rgba), n = e.r, r = e.g, o = e.b, i = (s = e.a) < 1 ? fg(yo(255 * s)) : "", "#" + fg(n) + fg(r) + fg(o) + i;
    var e, n, r, o, s, i;
  }, t.prototype.toRgb = function() {
    return lb(this.rgba);
  }, t.prototype.toRgbString = function() {
    return e = lb(this.rgba), n = e.r, r = e.g, o = e.b, (s = e.a) < 1 ? "rgba(" + n + ", " + r + ", " + o + ", " + s + ")" : "rgb(" + n + ", " + r + ", " + o + ")";
    var e, n, r, o, s;
  }, t.prototype.toHsl = function() {
    return vC(Zf(this.rgba));
  }, t.prototype.toHslString = function() {
    return e = vC(Zf(this.rgba)), n = e.h, r = e.s, o = e.l, (s = e.a) < 1 ? "hsla(" + n + ", " + r + "%, " + o + "%, " + s + ")" : "hsl(" + n + ", " + r + "%, " + o + "%)";
    var e, n, r, o, s;
  }, t.prototype.toHsv = function() {
    return e = nB(this.rgba), { h: yo(e.h), s: yo(e.s), v: yo(e.v), a: yo(e.a, 3) };
    var e;
  }, t.prototype.invert = function() {
    return $i({ r: 255 - (e = this.rgba).r, g: 255 - e.g, b: 255 - e.b, a: e.a });
    var e;
  }, t.prototype.saturate = function(e) {
    return e === void 0 && (e = 0.1), $i(cb(this.rgba, e));
  }, t.prototype.desaturate = function(e) {
    return e === void 0 && (e = 0.1), $i(cb(this.rgba, -e));
  }, t.prototype.grayscale = function() {
    return $i(cb(this.rgba, -1));
  }, t.prototype.lighten = function(e) {
    return e === void 0 && (e = 0.1), $i(bC(this.rgba, e));
  }, t.prototype.darken = function(e) {
    return e === void 0 && (e = 0.1), $i(bC(this.rgba, -e));
  }, t.prototype.rotate = function(e) {
    return e === void 0 && (e = 15), this.hue(this.hue() + e);
  }, t.prototype.alpha = function(e) {
    return typeof e == "number" ? $i({ r: (n = this.rgba).r, g: n.g, b: n.b, a: e }) : yo(this.rgba.a, 3);
    var n;
  }, t.prototype.hue = function(e) {
    var n = Zf(this.rgba);
    return typeof e == "number" ? $i({ h: e, s: n.s, l: n.l, a: n.a }) : yo(n.h);
  }, t.prototype.isEqual = function(e) {
    return this.toHex() === $i(e).toHex();
  }, t;
}(), $i = function(t) {
  return t instanceof Kk ? t : new Kk(t);
}, kC = [], T1e = function(t) {
  t.forEach(function(e) {
    kC.indexOf(e) < 0 && (e(Kk, Qk), kC.push(e));
  });
};
function x1e(t, e) {
  var n = { white: "#ffffff", bisque: "#ffe4c4", blue: "#0000ff", cadetblue: "#5f9ea0", chartreuse: "#7fff00", chocolate: "#d2691e", coral: "#ff7f50", antiquewhite: "#faebd7", aqua: "#00ffff", azure: "#f0ffff", whitesmoke: "#f5f5f5", papayawhip: "#ffefd5", plum: "#dda0dd", blanchedalmond: "#ffebcd", black: "#000000", gold: "#ffd700", goldenrod: "#daa520", gainsboro: "#dcdcdc", cornsilk: "#fff8dc", cornflowerblue: "#6495ed", burlywood: "#deb887", aquamarine: "#7fffd4", beige: "#f5f5dc", crimson: "#dc143c", cyan: "#00ffff", darkblue: "#00008b", darkcyan: "#008b8b", darkgoldenrod: "#b8860b", darkkhaki: "#bdb76b", darkgray: "#a9a9a9", darkgreen: "#006400", darkgrey: "#a9a9a9", peachpuff: "#ffdab9", darkmagenta: "#8b008b", darkred: "#8b0000", darkorchid: "#9932cc", darkorange: "#ff8c00", darkslateblue: "#483d8b", gray: "#808080", darkslategray: "#2f4f4f", darkslategrey: "#2f4f4f", deeppink: "#ff1493", deepskyblue: "#00bfff", wheat: "#f5deb3", firebrick: "#b22222", floralwhite: "#fffaf0", ghostwhite: "#f8f8ff", darkviolet: "#9400d3", magenta: "#ff00ff", green: "#008000", dodgerblue: "#1e90ff", grey: "#808080", honeydew: "#f0fff0", hotpink: "#ff69b4", blueviolet: "#8a2be2", forestgreen: "#228b22", lawngreen: "#7cfc00", indianred: "#cd5c5c", indigo: "#4b0082", fuchsia: "#ff00ff", brown: "#a52a2a", maroon: "#800000", mediumblue: "#0000cd", lightcoral: "#f08080", darkturquoise: "#00ced1", lightcyan: "#e0ffff", ivory: "#fffff0", lightyellow: "#ffffe0", lightsalmon: "#ffa07a", lightseagreen: "#20b2aa", linen: "#faf0e6", mediumaquamarine: "#66cdaa", lemonchiffon: "#fffacd", lime: "#00ff00", khaki: "#f0e68c", mediumseagreen: "#3cb371", limegreen: "#32cd32", mediumspringgreen: "#00fa9a", lightskyblue: "#87cefa", lightblue: "#add8e6", midnightblue: "#191970", lightpink: "#ffb6c1", mistyrose: "#ffe4e1", moccasin: "#ffe4b5", mintcream: "#f5fffa", lightslategray: "#778899", lightslategrey: "#778899", navajowhite: "#ffdead", navy: "#000080", mediumvioletred: "#c71585", powderblue: "#b0e0e6", palegoldenrod: "#eee8aa", oldlace: "#fdf5e6", paleturquoise: "#afeeee", mediumturquoise: "#48d1cc", mediumorchid: "#ba55d3", rebeccapurple: "#663399", lightsteelblue: "#b0c4de", mediumslateblue: "#7b68ee", thistle: "#d8bfd8", tan: "#d2b48c", orchid: "#da70d6", mediumpurple: "#9370db", purple: "#800080", pink: "#ffc0cb", skyblue: "#87ceeb", springgreen: "#00ff7f", palegreen: "#98fb98", red: "#ff0000", yellow: "#ffff00", slateblue: "#6a5acd", lavenderblush: "#fff0f5", peru: "#cd853f", palevioletred: "#db7093", violet: "#ee82ee", teal: "#008080", slategray: "#708090", slategrey: "#708090", aliceblue: "#f0f8ff", darkseagreen: "#8fbc8f", darkolivegreen: "#556b2f", greenyellow: "#adff2f", seagreen: "#2e8b57", seashell: "#fff5ee", tomato: "#ff6347", silver: "#c0c0c0", sienna: "#a0522d", lavender: "#e6e6fa", lightgreen: "#90ee90", orange: "#ffa500", orangered: "#ff4500", steelblue: "#4682b4", royalblue: "#4169e1", turquoise: "#40e0d0", yellowgreen: "#9acd32", salmon: "#fa8072", saddlebrown: "#8b4513", sandybrown: "#f4a460", rosybrown: "#bc8f8f", darksalmon: "#e9967a", lightgoldenrodyellow: "#fafad2", snow: "#fffafa", lightgrey: "#d3d3d3", lightgray: "#d3d3d3", dimgray: "#696969", dimgrey: "#696969", olivedrab: "#6b8e23", olive: "#808000" }, r = {};
  for (var o in n) r[n[o]] = o;
  var s = {};
  t.prototype.toName = function(i) {
    if (!(this.rgba.a || this.rgba.r || this.rgba.g || this.rgba.b)) return "transparent";
    var u, l, a = r[this.toHex()];
    if (a) return a;
    if (i?.closest) {
      var c = this.toRgb(), p = 1 / 0, d = "black";
      if (!s.length) for (var h in n) s[h] = new t(n[h]).toRgb();
      for (var m in n) {
        var g = (u = c, l = s[m], Math.pow(u.r - l.r, 2) + Math.pow(u.g - l.g, 2) + Math.pow(u.b - l.b, 2));
        g < p && (p = g, d = m);
      }
      return d;
    }
  }, e.string.push([function(i) {
    var u = i.toLowerCase(), l = u === "transparent" ? "#0000" : n[u];
    return l ? new t(l).toRgb() : null;
  }, "name"]);
}
T1e([x1e]);
const Md = class t0 {
  /**
   * @param {PIXI.ColorSource} value - Optional value to use, if not provided, white is used.
   */
  constructor(e = 16777215) {
    this._value = null, this._components = new Float32Array(4), this._components.fill(1), this._int = 16777215, this.value = e;
  }
  /** Get red component (0 - 1) */
  get red() {
    return this._components[0];
  }
  /** Get green component (0 - 1) */
  get green() {
    return this._components[1];
  }
  /** Get blue component (0 - 1) */
  get blue() {
    return this._components[2];
  }
  /** Get alpha component (0 - 1) */
  get alpha() {
    return this._components[3];
  }
  /**
   * Set the value, suitable for chaining
   * @param value
   * @see PIXI.Color.value
   */
  setValue(e) {
    return this.value = e, this;
  }
  /**
   * The current color source.
   *
   * When setting:
   * - Setting to an instance of `Color` will copy its color source and components.
   * - Otherwise, `Color` will try to normalize the color source and set the components.
   *   If the color source is invalid, an `Error` will be thrown and the `Color` will left unchanged.
   *
   * Note: The `null` in the setter's parameter type is added to match the TypeScript rule: return type of getter
   * must be assignable to its setter's parameter type. Setting `value` to `null` will throw an `Error`.
   *
   * When getting:
   * - A return value of `null` means the previous value was overridden (e.g., {@link PIXI.Color.multiply multiply},
   *   {@link PIXI.Color.premultiply premultiply} or {@link PIXI.Color.round round}).
   * - Otherwise, the color source used when setting is returned.
   * @type {PIXI.ColorSource}
   */
  set value(e) {
    if (e instanceof t0)
      this._value = this.cloneSource(e._value), this._int = e._int, this._components.set(e._components);
    else {
      if (e === null)
        throw new Error("Cannot set PIXI.Color#value to null");
      (this._value === null || !this.isSourceEqual(this._value, e)) && (this.normalize(e), this._value = this.cloneSource(e));
    }
  }
  get value() {
    return this._value;
  }
  /**
   * Copy a color source internally.
   * @param value - Color source
   */
  cloneSource(e) {
    return typeof e == "string" || typeof e == "number" || e instanceof Number || e === null ? e : Array.isArray(e) || ArrayBuffer.isView(e) ? e.slice(0) : typeof e == "object" && e !== null ? { ...e } : e;
  }
  /**
   * Equality check for color sources.
   * @param value1 - First color source
   * @param value2 - Second color source
   * @returns `true` if the color sources are equal, `false` otherwise.
   */
  isSourceEqual(e, n) {
    const r = typeof e;
    if (r !== typeof n)
      return !1;
    if (r === "number" || r === "string" || e instanceof Number)
      return e === n;
    if (Array.isArray(e) && Array.isArray(n) || ArrayBuffer.isView(e) && ArrayBuffer.isView(n))
      return e.length !== n.length ? !1 : e.every((o, s) => o === n[s]);
    if (e !== null && n !== null) {
      const o = Object.keys(e), s = Object.keys(n);
      return o.length !== s.length ? !1 : o.every((i) => e[i] === n[i]);
    }
    return e === n;
  }
  /**
   * Convert to a RGBA color object.
   * @example
   * import { Color } from 'pixi.js';
   * new Color('white').toRgb(); // returns { r: 1, g: 1, b: 1, a: 1 }
   */
  toRgba() {
    const [e, n, r, o] = this._components;
    return { r: e, g: n, b: r, a: o };
  }
  /**
   * Convert to a RGB color object.
   * @example
   * import { Color } from 'pixi.js';
   * new Color('white').toRgb(); // returns { r: 1, g: 1, b: 1 }
   */
  toRgb() {
    const [e, n, r] = this._components;
    return { r: e, g: n, b: r };
  }
  /** Convert to a CSS-style rgba string: `rgba(255,255,255,1.0)`. */
  toRgbaString() {
    const [e, n, r] = this.toUint8RgbArray();
    return `rgba(${e},${n},${r},${this.alpha})`;
  }
  toUint8RgbArray(e) {
    const [n, r, o] = this._components;
    return e = e ?? [], e[0] = Math.round(n * 255), e[1] = Math.round(r * 255), e[2] = Math.round(o * 255), e;
  }
  toRgbArray(e) {
    e = e ?? [];
    const [n, r, o] = this._components;
    return e[0] = n, e[1] = r, e[2] = o, e;
  }
  /**
   * Convert to a hexadecimal number.
   * @example
   * import { Color } from 'pixi.js';
   * new Color('white').toNumber(); // returns 16777215
   */
  toNumber() {
    return this._int;
  }
  /**
   * Convert to a hexadecimal number in little endian format (e.g., BBGGRR).
   * @example
   * import { Color } from 'pixi.js';
   * new Color(0xffcc99).toLittleEndianNumber(); // returns 0x99ccff
   * @returns {number} - The color as a number in little endian format.
   */
  toLittleEndianNumber() {
    const e = this._int;
    return (e >> 16) + (e & 65280) + ((e & 255) << 16);
  }
  /**
   * Multiply with another color. This action is destructive, and will
   * override the previous `value` property to be `null`.
   * @param {PIXI.ColorSource} value - The color to multiply by.
   */
  multiply(e) {
    const [n, r, o, s] = t0.temp.setValue(e)._components;
    return this._components[0] *= n, this._components[1] *= r, this._components[2] *= o, this._components[3] *= s, this.refreshInt(), this._value = null, this;
  }
  /**
   * Converts color to a premultiplied alpha format. This action is destructive, and will
   * override the previous `value` property to be `null`.
   * @param alpha - The alpha to multiply by.
   * @param {boolean} [applyToRGB=true] - Whether to premultiply RGB channels.
   * @returns {PIXI.Color} - Itself.
   */
  premultiply(e, n = !0) {
    return n && (this._components[0] *= e, this._components[1] *= e, this._components[2] *= e), this._components[3] = e, this.refreshInt(), this._value = null, this;
  }
  /**
   * Premultiplies alpha with current color.
   * @param {number} alpha - The alpha to multiply by.
   * @param {boolean} [applyToRGB=true] - Whether to premultiply RGB channels.
   * @returns {number} tint multiplied by alpha
   */
  toPremultiplied(e, n = !0) {
    if (e === 1)
      return (255 << 24) + this._int;
    if (e === 0)
      return n ? 0 : this._int;
    let r = this._int >> 16 & 255, o = this._int >> 8 & 255, s = this._int & 255;
    return n && (r = r * e + 0.5 | 0, o = o * e + 0.5 | 0, s = s * e + 0.5 | 0), (e * 255 << 24) + (r << 16) + (o << 8) + s;
  }
  /**
   * Convert to a hexidecimal string.
   * @example
   * import { Color } from 'pixi.js';
   * new Color('white').toHex(); // returns "#ffffff"
   */
  toHex() {
    const e = this._int.toString(16);
    return `#${"000000".substring(0, 6 - e.length) + e}`;
  }
  /**
   * Convert to a hexidecimal string with alpha.
   * @example
   * import { Color } from 'pixi.js';
   * new Color('white').toHexa(); // returns "#ffffffff"
   */
  toHexa() {
    const e = Math.round(this._components[3] * 255).toString(16);
    return this.toHex() + "00".substring(0, 2 - e.length) + e;
  }
  /**
   * Set alpha, suitable for chaining.
   * @param alpha
   */
  setAlpha(e) {
    return this._components[3] = this._clamp(e), this;
  }
  /**
   * Rounds the specified color according to the step. This action is destructive, and will
   * override the previous `value` property to be `null`. The alpha component is not rounded.
   * @param steps - Number of steps which will be used as a cap when rounding colors
   * @deprecated since 7.3.0
   */
  round(e) {
    const [n, r, o] = this._components;
    return this._components[0] = Math.round(n * e) / e, this._components[1] = Math.round(r * e) / e, this._components[2] = Math.round(o * e) / e, this.refreshInt(), this._value = null, this;
  }
  toArray(e) {
    e = e ?? [];
    const [n, r, o, s] = this._components;
    return e[0] = n, e[1] = r, e[2] = o, e[3] = s, e;
  }
  /**
   * Normalize the input value into rgba
   * @param value - Input value
   */
  normalize(e) {
    let n, r, o, s;
    if ((typeof e == "number" || e instanceof Number) && e >= 0 && e <= 16777215) {
      const i = e;
      n = (i >> 16 & 255) / 255, r = (i >> 8 & 255) / 255, o = (i & 255) / 255, s = 1;
    } else if ((Array.isArray(e) || e instanceof Float32Array) && e.length >= 3 && e.length <= 4)
      e = this._clamp(e), [n, r, o, s = 1] = e;
    else if ((e instanceof Uint8Array || e instanceof Uint8ClampedArray) && e.length >= 3 && e.length <= 4)
      e = this._clamp(e, 0, 255), [n, r, o, s = 255] = e, n /= 255, r /= 255, o /= 255, s /= 255;
    else if (typeof e == "string" || typeof e == "object") {
      if (typeof e == "string") {
        const u = t0.HEX_PATTERN.exec(e);
        u && (e = `#${u[2]}`);
      }
      const i = $i(e);
      i.isValid() && ({ r: n, g: r, b: o, a: s } = i.rgba, n /= 255, r /= 255, o /= 255);
    }
    if (n !== void 0)
      this._components[0] = n, this._components[1] = r, this._components[2] = o, this._components[3] = s, this.refreshInt();
    else
      throw new Error(`Unable to convert color ${e}`);
  }
  /** Refresh the internal color rgb number */
  refreshInt() {
    this._clamp(this._components);
    const [e, n, r] = this._components;
    this._int = (e * 255 << 16) + (n * 255 << 8) + (r * 255 | 0);
  }
  /**
   * Clamps values to a range. Will override original values
   * @param value - Value(s) to clamp
   * @param min - Minimum value
   * @param max - Maximum value
   */
  _clamp(e, n = 0, r = 1) {
    return typeof e == "number" ? Math.min(Math.max(e, n), r) : (e.forEach((o, s) => {
      e[s] = Math.min(Math.max(o, n), r);
    }), e);
  }
};
Md.shared = new Md(), /**
* Temporary Color object for static uses internally.
* As to not conflict with Color.shared.
* @ignore
*/
Md.temp = new Md(), /** Pattern for hex strings */
Md.HEX_PATTERN = /^(#|0x)?(([a-f0-9]{3}){1,2}([a-f0-9]{2})?)$/i;
let Gn = Md;
function S1e(t) {
  return un("7.2.0", "utils.hex2string is deprecated, use Color#toHex instead"), Gn.shared.setValue(t).toHex();
}
function R1e(t) {
  return un("7.2.0", "utils.rgb2hex is deprecated, use Color#toNumber instead"), Gn.shared.setValue(t).toNumber();
}
function A1e() {
  const t = [], e = [];
  for (let r = 0; r < 32; r++)
    t[r] = r, e[r] = r;
  t[Mt.NORMAL_NPM] = Mt.NORMAL, t[Mt.ADD_NPM] = Mt.ADD, t[Mt.SCREEN_NPM] = Mt.SCREEN, e[Mt.NORMAL] = Mt.NORMAL_NPM, e[Mt.ADD] = Mt.ADD_NPM, e[Mt.SCREEN] = Mt.SCREEN_NPM;
  const n = [];
  return n.push(e), n.push(t), n;
}
const oB = A1e();
function sB(t, e) {
  return oB[e ? 1 : 0][t];
}
function D1e(t, e = null) {
  const n = t * 6;
  if (e = e || new Uint16Array(n), e.length !== n)
    throw new Error(`Out buffer length is incorrect, got ${e.length} and expected ${n}`);
  for (let r = 0, o = 0; r < n; r += 6, o += 4)
    e[r + 0] = o + 0, e[r + 1] = o + 1, e[r + 2] = o + 2, e[r + 3] = o + 0, e[r + 4] = o + 2, e[r + 5] = o + 3;
  return e;
}
function aB(t) {
  if (t.BYTES_PER_ELEMENT === 4)
    return t instanceof Float32Array ? "Float32Array" : t instanceof Uint32Array ? "Uint32Array" : "Int32Array";
  if (t.BYTES_PER_ELEMENT === 2) {
    if (t instanceof Uint16Array)
      return "Uint16Array";
  } else if (t.BYTES_PER_ELEMENT === 1 && t instanceof Uint8Array)
    return "Uint8Array";
  return null;
}
function rv(t) {
  return t += t === 0 ? 1 : 0, --t, t |= t >>> 1, t |= t >>> 2, t |= t >>> 4, t |= t >>> 8, t |= t >>> 16, t + 1;
}
function TC(t) {
  return !(t & t - 1) && !!t;
}
function xC(t) {
  let e = (t > 65535 ? 1 : 0) << 4;
  t >>>= e;
  let n = (t > 255 ? 1 : 0) << 3;
  return t >>>= n, e |= n, n = (t > 15 ? 1 : 0) << 2, t >>>= n, e |= n, n = (t > 3 ? 1 : 0) << 1, t >>>= n, e |= n, e | t >> 1;
}
function Yd(t, e, n) {
  const r = t.length;
  let o;
  if (e >= r || n === 0)
    return;
  n = e + n > r ? r - e : n;
  const s = r - n;
  for (o = e; o < s; ++o)
    t[o] = t[o + n];
  t.length = s;
}
function ec(t) {
  return t === 0 ? 0 : t < 0 ? -1 : 1;
}
let E1e = 0;
function Up() {
  return ++E1e;
}
const Zk = class {
  /**
   * @param left - The left coordinate value of the bounding box.
   * @param top - The top coordinate value of the bounding box.
   * @param right - The right coordinate value of the bounding box.
   * @param bottom - The bottom coordinate value of the bounding box.
   */
  constructor(t, e, n, r) {
    this.left = t, this.top = e, this.right = n, this.bottom = r;
  }
  /** The width of the bounding box. */
  get width() {
    return this.right - this.left;
  }
  /** The height of the bounding box. */
  get height() {
    return this.bottom - this.top;
  }
  /** Determines whether the BoundingBox is empty. */
  isEmpty() {
    return this.left === this.right || this.top === this.bottom;
  }
};
Zk.EMPTY = new Zk(0, 0, 0, 0);
let SC = Zk;
const RC = {}, Wi = /* @__PURE__ */ Object.create(null), Vl = /* @__PURE__ */ Object.create(null);
class M1e {
  /**
   * @param width - the width for the newly created canvas
   * @param height - the height for the newly created canvas
   * @param {number} [resolution=PIXI.settings.RESOLUTION] - The resolution / device pixel ratio of the canvas
   */
  constructor(e, n, r) {
    this._canvas = at.ADAPTER.createCanvas(), this._context = this._canvas.getContext("2d"), this.resolution = r || at.RESOLUTION, this.resize(e, n);
  }
  /**
   * Clears the canvas that was created by the CanvasRenderTarget class.
   * @private
   */
  clear() {
    this._checkDestroyed(), this._context.setTransform(1, 0, 0, 1, 0, 0), this._context.clearRect(0, 0, this._canvas.width, this._canvas.height);
  }
  /**
   * Resizes the canvas to the specified width and height.
   * @param desiredWidth - the desired width of the canvas
   * @param desiredHeight - the desired height of the canvas
   */
  resize(e, n) {
    this._checkDestroyed(), this._canvas.width = Math.round(e * this.resolution), this._canvas.height = Math.round(n * this.resolution);
  }
  /** Destroys this canvas. */
  destroy() {
    this._context = null, this._canvas = null;
  }
  /**
   * The width of the canvas buffer in pixels.
   * @member {number}
   */
  get width() {
    return this._checkDestroyed(), this._canvas.width;
  }
  set width(e) {
    this._checkDestroyed(), this._canvas.width = Math.round(e);
  }
  /**
   * The height of the canvas buffer in pixels.
   * @member {number}
   */
  get height() {
    return this._checkDestroyed(), this._canvas.height;
  }
  set height(e) {
    this._checkDestroyed(), this._canvas.height = Math.round(e);
  }
  /** The Canvas object that belongs to this CanvasRenderTarget. */
  get canvas() {
    return this._checkDestroyed(), this._canvas;
  }
  /** A CanvasRenderingContext2D object representing a two-dimensional rendering context. */
  get context() {
    return this._checkDestroyed(), this._context;
  }
  _checkDestroyed() {
    if (this._canvas === null)
      throw new TypeError("The CanvasRenderTarget has already been destroyed");
  }
}
function AC(t, e, n) {
  for (let r = 0, o = 4 * n * e; r < e; ++r, o += 4)
    if (t[o + 3] !== 0)
      return !1;
  return !0;
}
function DC(t, e, n, r, o) {
  const s = 4 * e;
  for (let i = r, u = r * s + 4 * n; i <= o; ++i, u += s)
    if (t[u + 3] !== 0)
      return !1;
  return !0;
}
function P1e(t) {
  const { width: e, height: n } = t, r = t.getContext("2d", {
    willReadFrequently: !0
  });
  if (r === null)
    throw new TypeError("Failed to get canvas 2D context");
  const o = r.getImageData(0, 0, e, n).data;
  let s = 0, i = 0, u = e - 1, l = n - 1;
  for (; i < n && AC(o, e, i); )
    ++i;
  if (i === n)
    return SC.EMPTY;
  for (; AC(o, e, l); )
    --l;
  for (; DC(o, e, s, i, l); )
    ++s;
  for (; DC(o, e, u, i, l); )
    --u;
  return ++u, ++l, new SC(s, i, u, l);
}
function C1e(t) {
  const e = P1e(t), { width: n, height: r } = e;
  let o = null;
  if (!e.isEmpty()) {
    const s = t.getContext("2d");
    if (s === null)
      throw new TypeError("Failed to get canvas 2D context");
    o = s.getImageData(
      e.left,
      e.top,
      n,
      r
    );
  }
  return { width: n, height: r, data: o };
}
function O1e(t, e = globalThis.location) {
  if (t.startsWith("data:"))
    return "";
  e = e || globalThis.location;
  const n = new URL(t, document.baseURI);
  return n.hostname !== e.hostname || n.port !== e.port || n.protocol !== e.protocol ? "anonymous" : "";
}
function al(t, e = 1) {
  const n = at.RETINA_PREFIX?.exec(t);
  return n ? parseFloat(n[1]) : e;
}
var rt = /* @__PURE__ */ ((t) => (t.Renderer = "renderer", t.Application = "application", t.RendererSystem = "renderer-webgl-system", t.RendererPlugin = "renderer-webgl-plugin", t.CanvasRendererSystem = "renderer-canvas-system", t.CanvasRendererPlugin = "renderer-canvas-plugin", t.Asset = "asset", t.LoadParser = "load-parser", t.ResolveParser = "resolve-parser", t.CacheParser = "cache-parser", t.DetectionParser = "detection-parser", t))(rt || {});
const Jk = (t) => {
  if (typeof t == "function" || typeof t == "object" && t.extension) {
    if (!t.extension)
      throw new Error("Extension class must have an extension object");
    t = { ...typeof t.extension != "object" ? { type: t.extension } : t.extension, ref: t };
  }
  if (typeof t == "object")
    t = { ...t };
  else
    throw new Error("Invalid extension type");
  return typeof t.type == "string" && (t.type = [t.type]), t;
}, EC = (t, e) => Jk(t).priority ?? e, dt = {
  /** @ignore */
  _addHandlers: {},
  /** @ignore */
  _removeHandlers: {},
  /** @ignore */
  _queue: {},
  /**
   * Remove extensions from PixiJS.
   * @param extensions - Extensions to be removed.
   * @returns {PIXI.extensions} For chaining.
   */
  remove(...t) {
    return t.map(Jk).forEach((e) => {
      e.type.forEach((n) => this._removeHandlers[n]?.(e));
    }), this;
  },
  /**
   * Register new extensions with PixiJS.
   * @param extensions - The spread of extensions to add to PixiJS.
   * @returns {PIXI.extensions} For chaining.
   */
  add(...t) {
    return t.map(Jk).forEach((e) => {
      e.type.forEach((n) => {
        const r = this._addHandlers, o = this._queue;
        r[n] ? r[n](e) : (o[n] = o[n] || [], o[n].push(e));
      });
    }), this;
  },
  /**
   * Internal method to handle extensions by name.
   * @param type - The extension type.
   * @param onAdd  - Function for handling when extensions are added/registered passes {@link PIXI.ExtensionFormat}.
   * @param onRemove  - Function for handling when extensions are removed/unregistered passes {@link PIXI.ExtensionFormat}.
   * @returns {PIXI.extensions} For chaining.
   */
  handle(t, e, n) {
    const r = this._addHandlers, o = this._removeHandlers;
    if (r[t] || o[t])
      throw new Error(`Extension type ${t} already has a handler`);
    r[t] = e, o[t] = n;
    const s = this._queue;
    return s[t] && (s[t].forEach((i) => e(i)), delete s[t]), this;
  },
  /**
   * Handle a type, but using a map by `name` property.
   * @param type - Type of extension to handle.
   * @param map - The object map of named extensions.
   * @returns {PIXI.extensions} For chaining.
   */
  handleByMap(t, e) {
    return this.handle(
      t,
      (n) => {
        e[n.name] = n.ref;
      },
      (n) => {
        delete e[n.name];
      }
    );
  },
  /**
   * Handle a type, but using a list of extensions.
   * @param type - Type of extension to handle.
   * @param list - The list of extensions.
   * @param defaultPriority - The default priority to use if none is specified.
   * @returns {PIXI.extensions} For chaining.
   */
  handleByList(t, e, n = -1) {
    return this.handle(
      t,
      (r) => {
        e.includes(r.ref) || (e.push(r.ref), e.sort((o, s) => EC(s, n) - EC(o, n)));
      },
      (r) => {
        const o = e.indexOf(r.ref);
        o !== -1 && e.splice(o, 1);
      }
    );
  }
};
class eT {
  constructor(e) {
    typeof e == "number" ? this.rawBinaryData = new ArrayBuffer(e) : e instanceof Uint8Array ? this.rawBinaryData = e.buffer : this.rawBinaryData = e, this.uint32View = new Uint32Array(this.rawBinaryData), this.float32View = new Float32Array(this.rawBinaryData);
  }
  /** View on the raw binary data as a `Int8Array`. */
  get int8View() {
    return this._int8View || (this._int8View = new Int8Array(this.rawBinaryData)), this._int8View;
  }
  /** View on the raw binary data as a `Uint8Array`. */
  get uint8View() {
    return this._uint8View || (this._uint8View = new Uint8Array(this.rawBinaryData)), this._uint8View;
  }
  /**  View on the raw binary data as a `Int16Array`. */
  get int16View() {
    return this._int16View || (this._int16View = new Int16Array(this.rawBinaryData)), this._int16View;
  }
  /** View on the raw binary data as a `Uint16Array`. */
  get uint16View() {
    return this._uint16View || (this._uint16View = new Uint16Array(this.rawBinaryData)), this._uint16View;
  }
  /** View on the raw binary data as a `Int32Array`. */
  get int32View() {
    return this._int32View || (this._int32View = new Int32Array(this.rawBinaryData)), this._int32View;
  }
  /**
   * Returns the view of the given type.
   * @param type - One of `int8`, `uint8`, `int16`,
   *    `uint16`, `int32`, `uint32`, and `float32`.
   * @returns - typed array of given type
   */
  view(e) {
    return this[`${e}View`];
  }
  /** Destroys all buffer references. Do not use after calling this. */
  destroy() {
    this.rawBinaryData = null, this._int8View = null, this._uint8View = null, this._int16View = null, this._uint16View = null, this._int32View = null, this.uint32View = null, this.float32View = null;
  }
  static sizeOf(e) {
    switch (e) {
      case "int8":
      case "uint8":
        return 1;
      case "int16":
      case "uint16":
        return 2;
      case "int32":
      case "uint32":
      case "float32":
        return 4;
      default:
        throw new Error(`${e} isn't a valid view type`);
    }
  }
}
const I1e = [
  "precision mediump float;",
  "void main(void){",
  "float test = 0.1;",
  "%forloop%",
  "gl_FragColor = vec4(0.0);",
  "}"
].join(`
`);
function F1e(t) {
  let e = "";
  for (let n = 0; n < t; ++n)
    n > 0 && (e += `
else `), n < t - 1 && (e += `if(test == ${n}.0){}`);
  return e;
}
function N1e(t, e) {
  if (t === 0)
    throw new Error("Invalid value of `0` passed to `checkMaxIfStatementsInShader`");
  const n = e.createShader(e.FRAGMENT_SHADER);
  for (; ; ) {
    const r = I1e.replace(/%forloop%/gi, F1e(t));
    if (e.shaderSource(n, r), e.compileShader(n), !e.getShaderParameter(n, e.COMPILE_STATUS))
      t = t / 2 | 0;
    else
      break;
  }
  return t;
}
const db = 0, hb = 1, fb = 2, mb = 3, yb = 4, gb = 5;
class _u {
  constructor() {
    this.data = 0, this.blendMode = Mt.NORMAL, this.polygonOffset = 0, this.blend = !0, this.depthMask = !0;
  }
  /**
   * Activates blending of the computed fragment color values.
   * @default true
   */
  get blend() {
    return !!(this.data & 1 << db);
  }
  set blend(e) {
    !!(this.data & 1 << db) !== e && (this.data ^= 1 << db);
  }
  /**
   * Activates adding an offset to depth values of polygon's fragments
   * @default false
   */
  get offsets() {
    return !!(this.data & 1 << hb);
  }
  set offsets(e) {
    !!(this.data & 1 << hb) !== e && (this.data ^= 1 << hb);
  }
  /**
   * Activates culling of polygons.
   * @default false
   */
  get culling() {
    return !!(this.data & 1 << fb);
  }
  set culling(e) {
    !!(this.data & 1 << fb) !== e && (this.data ^= 1 << fb);
  }
  /**
   * Activates depth comparisons and updates to the depth buffer.
   * @default false
   */
  get depthTest() {
    return !!(this.data & 1 << mb);
  }
  set depthTest(e) {
    !!(this.data & 1 << mb) !== e && (this.data ^= 1 << mb);
  }
  /**
   * Enables or disables writing to the depth buffer.
   * @default true
   */
  get depthMask() {
    return !!(this.data & 1 << gb);
  }
  set depthMask(e) {
    !!(this.data & 1 << gb) !== e && (this.data ^= 1 << gb);
  }
  /**
   * Specifies whether or not front or back-facing polygons can be culled.
   * @default false
   */
  get clockwiseFrontFace() {
    return !!(this.data & 1 << yb);
  }
  set clockwiseFrontFace(e) {
    !!(this.data & 1 << yb) !== e && (this.data ^= 1 << yb);
  }
  /**
   * The blend mode to be applied when this state is set. Apply a value of `PIXI.BLEND_MODES.NORMAL` to reset the blend mode.
   * Setting this mode to anything other than NO_BLEND will automatically switch blending on.
   * @default PIXI.BLEND_MODES.NORMAL
   */
  get blendMode() {
    return this._blendMode;
  }
  set blendMode(e) {
    this.blend = e !== Mt.NONE, this._blendMode = e;
  }
  /**
   * The polygon offset. Setting this property to anything other than 0 will automatically enable polygon offset fill.
   * @default 0
   */
  get polygonOffset() {
    return this._polygonOffset;
  }
  set polygonOffset(e) {
    this.offsets = !!e, this._polygonOffset = e;
  }
  static for2d() {
    const e = new _u();
    return e.depthTest = !1, e.blend = !0, e;
  }
}
_u.prototype.toString = function() {
  return `[@pixi/core:State blendMode=${this.blendMode} clockwiseFrontFace=${this.clockwiseFrontFace} culling=${this.culling} depthMask=${this.depthMask} polygonOffset=${this.polygonOffset}]`;
};
const tT = [];
function iB(t, e) {
  if (!t)
    return null;
  let n = "";
  if (typeof t == "string") {
    const r = /\.(\w{3,4})(?:$|\?|#)/i.exec(t);
    r && (n = r[1].toLowerCase());
  }
  for (let r = tT.length - 1; r >= 0; --r) {
    const o = tT[r];
    if (o.test && o.test(t, n))
      return new o(t, e);
  }
  throw new Error("Unrecognized source type to auto-detect Resource");
}
class pi {
  /**
   * @param name - The function name that will be executed on the listeners added to this Runner.
   */
  constructor(e) {
    this.items = [], this._name = e, this._aliasCount = 0;
  }
  /* eslint-disable jsdoc/require-param, jsdoc/check-param-names */
  /**
   * Dispatch/Broadcast Runner to all listeners added to the queue.
   * @param {...any} params - (optional) parameters to pass to each listener
   */
  /*  eslint-enable jsdoc/require-param, jsdoc/check-param-names */
  emit(e, n, r, o, s, i, u, l) {
    if (arguments.length > 8)
      throw new Error("max arguments reached");
    const { name: a, items: c } = this;
    this._aliasCount++;
    for (let p = 0, d = c.length; p < d; p++)
      c[p][a](e, n, r, o, s, i, u, l);
    return c === this.items && this._aliasCount--, this;
  }
  ensureNonAliasedItems() {
    this._aliasCount > 0 && this.items.length > 1 && (this._aliasCount = 0, this.items = this.items.slice(0));
  }
  /**
   * Add a listener to the Runner
   *
   * Runners do not need to have scope or functions passed to them.
   * All that is required is to pass the listening object and ensure that it has contains a function that has the same name
   * as the name provided to the Runner when it was created.
   *
   * E.g. A listener passed to this Runner will require a 'complete' function.
   *
   * ```js
   * import { Runner } from '@pixi/runner';
   *
   * const complete = new Runner('complete');
   * ```
   *
   * The scope used will be the object itself.
   * @param {any} item - The object that will be listening.
   */
  add(e) {
    return e[this._name] && (this.ensureNonAliasedItems(), this.remove(e), this.items.push(e)), this;
  }
  /**
   * Remove a single listener from the dispatch queue.
   * @param {any} item - The listener that you would like to remove.
   */
  remove(e) {
    const n = this.items.indexOf(e);
    return n !== -1 && (this.ensureNonAliasedItems(), this.items.splice(n, 1)), this;
  }
  /**
   * Check to see if the listener is already in the Runner
   * @param {any} item - The listener that you would like to check.
   */
  contains(e) {
    return this.items.includes(e);
  }
  /** Remove all listeners from the Runner */
  removeAll() {
    return this.ensureNonAliasedItems(), this.items.length = 0, this;
  }
  /** Remove all references, don't use after this. */
  destroy() {
    this.removeAll(), this.items = null, this._name = null;
  }
  /**
   * `true` if there are no this Runner contains no listeners
   * @readonly
   */
  get empty() {
    return this.items.length === 0;
  }
  /**
   * The name of the runner.
   * @readonly
   */
  get name() {
    return this._name;
  }
}
Object.defineProperties(pi.prototype, {
  /**
   * Alias for `emit`
   * @memberof PIXI.Runner#
   * @method dispatch
   * @see PIXI.Runner#emit
   */
  dispatch: { value: pi.prototype.emit },
  /**
   * Alias for `emit`
   * @memberof PIXI.Runner#
   * @method run
   * @see PIXI.Runner#emit
   */
  run: { value: pi.prototype.emit }
});
class ym {
  /**
   * @param width - Width of the resource
   * @param height - Height of the resource
   */
  constructor(e = 0, n = 0) {
    this._width = e, this._height = n, this.destroyed = !1, this.internal = !1, this.onResize = new pi("setRealSize"), this.onUpdate = new pi("update"), this.onError = new pi("onError");
  }
  /**
   * Bind to a parent BaseTexture
   * @param baseTexture - Parent texture
   */
  bind(e) {
    this.onResize.add(e), this.onUpdate.add(e), this.onError.add(e), (this._width || this._height) && this.onResize.emit(this._width, this._height);
  }
  /**
   * Unbind to a parent BaseTexture
   * @param baseTexture - Parent texture
   */
  unbind(e) {
    this.onResize.remove(e), this.onUpdate.remove(e), this.onError.remove(e);
  }
  /**
   * Trigger a resize event
   * @param width - X dimension
   * @param height - Y dimension
   */
  resize(e, n) {
    (e !== this._width || n !== this._height) && (this._width = e, this._height = n, this.onResize.emit(e, n));
  }
  /**
   * Has been validated
   * @readonly
   */
  get valid() {
    return !!this._width && !!this._height;
  }
  /** Has been updated trigger event. */
  update() {
    this.destroyed || this.onUpdate.emit();
  }
  /**
   * This can be overridden to start preloading a resource
   * or do any other prepare step.
   * @protected
   * @returns Handle the validate event
   */
  load() {
    return Promise.resolve(this);
  }
  /**
   * The width of the resource.
   * @readonly
   */
  get width() {
    return this._width;
  }
  /**
   * The height of the resource.
   * @readonly
   */
  get height() {
    return this._height;
  }
  /**
   * Set the style, optional to override
   * @param _renderer - yeah, renderer!
   * @param _baseTexture - the texture
   * @param _glTexture - texture instance for this webgl context
   * @returns - `true` is success
   */
  style(e, n, r) {
    return !1;
  }
  /** Clean up anything, this happens when destroying is ready. */
  dispose() {
  }
  /**
   * Call when destroying resource, unbind any BaseTexture object
   * before calling this method, as reference counts are maintained
   * internally.
   */
  destroy() {
    this.destroyed || (this.destroyed = !0, this.dispose(), this.onError.removeAll(), this.onError = null, this.onResize.removeAll(), this.onResize = null, this.onUpdate.removeAll(), this.onUpdate = null);
  }
  /**
   * Abstract, used to auto-detect resource type.
   * @param {*} _source - The source object
   * @param {string} _extension - The extension of source, if set
   */
  static test(e, n) {
    return !1;
  }
}
class X_ extends ym {
  /**
   * @param source - Source buffer
   * @param options - Options
   * @param {number} options.width - Width of the texture
   * @param {number} options.height - Height of the texture
   * @param {1|2|4|8} [options.unpackAlignment=4] - The alignment of the pixel rows.
   */
  constructor(e, n) {
    const { width: r, height: o } = n || {};
    if (!r || !o)
      throw new Error("BufferResource width or height invalid");
    super(r, o), this.data = e, this.unpackAlignment = n.unpackAlignment ?? 4;
  }
  /**
   * Upload the texture to the GPU.
   * @param renderer - Upload to the renderer
   * @param baseTexture - Reference to parent texture
   * @param glTexture - glTexture
   * @returns - true is success
   */
  upload(e, n, r) {
    const o = e.gl;
    o.pixelStorei(o.UNPACK_ALIGNMENT, this.unpackAlignment), o.pixelStorei(o.UNPACK_PREMULTIPLY_ALPHA_WEBGL, n.alphaMode === gs.UNPACK);
    const s = n.realWidth, i = n.realHeight;
    return r.width === s && r.height === i ? o.texSubImage2D(
      n.target,
      0,
      0,
      0,
      s,
      i,
      n.format,
      r.type,
      this.data
    ) : (r.width = s, r.height = i, o.texImage2D(
      n.target,
      0,
      r.internalFormat,
      s,
      i,
      0,
      n.format,
      r.type,
      this.data
    )), !0;
  }
  /** Destroy and don't use after this. */
  dispose() {
    this.data = null;
  }
  /**
   * Used to auto-detect the type of resource.
   * @param {*} source - The source object
   * @returns {boolean} `true` if buffer source
   */
  static test(e) {
    return e === null || e instanceof Int8Array || e instanceof Uint8Array || e instanceof Uint8ClampedArray || e instanceof Int16Array || e instanceof Uint16Array || e instanceof Int32Array || e instanceof Uint32Array || e instanceof Float32Array;
  }
}
const L1e = {
  scaleMode: qu.NEAREST,
  alphaMode: gs.NPM
}, nT = class Pd extends uy {
  /**
   * @param {PIXI.Resource|HTMLImageElement|HTMLVideoElement|ImageBitmap|ICanvas|string} [resource=null] -
   *        The current resource to use, for things that aren't Resource objects, will be converted
   *        into a Resource.
   * @param options - Collection of options, default options inherited from {@link PIXI.BaseTexture.defaultOptions}.
   * @param {PIXI.MIPMAP_MODES} [options.mipmap] - If mipmapping is enabled for texture
   * @param {number} [options.anisotropicLevel] - Anisotropic filtering level of texture
   * @param {PIXI.WRAP_MODES} [options.wrapMode] - Wrap mode for textures
   * @param {PIXI.SCALE_MODES} [options.scaleMode] - Default scale mode, linear, nearest
   * @param {PIXI.FORMATS} [options.format] - GL format type
   * @param {PIXI.TYPES} [options.type] - GL data type
   * @param {PIXI.TARGETS} [options.target] - GL texture target
   * @param {PIXI.ALPHA_MODES} [options.alphaMode] - Pre multiply the image alpha
   * @param {number} [options.width=0] - Width of the texture
   * @param {number} [options.height=0] - Height of the texture
   * @param {number} [options.resolution=PIXI.settings.RESOLUTION] - Resolution of the base texture
   * @param {object} [options.resourceOptions] - Optional resource options,
   *        see {@link PIXI.autoDetectResource autoDetectResource}
   */
  constructor(e = null, n = null) {
    super(), n = Object.assign({}, Pd.defaultOptions, n);
    const {
      alphaMode: r,
      mipmap: o,
      anisotropicLevel: s,
      scaleMode: i,
      width: u,
      height: l,
      wrapMode: a,
      format: c,
      type: p,
      target: d,
      resolution: h,
      resourceOptions: m
    } = n;
    e && !(e instanceof ym) && (e = iB(e, m), e.internal = !0), this.resolution = h || at.RESOLUTION, this.width = Math.round((u || 0) * this.resolution) / this.resolution, this.height = Math.round((l || 0) * this.resolution) / this.resolution, this._mipmap = o, this.anisotropicLevel = s, this._wrapMode = a, this._scaleMode = i, this.format = c, this.type = p, this.target = d, this.alphaMode = r, this.uid = Up(), this.touched = 0, this.isPowerOfTwo = !1, this._refreshPOT(), this._glTextures = {}, this.dirtyId = 0, this.dirtyStyleId = 0, this.cacheId = null, this.valid = u > 0 && l > 0, this.textureCacheIds = [], this.destroyed = !1, this.resource = null, this._batchEnabled = 0, this._batchLocation = 0, this.parentTextureArray = null, this.setResource(e);
  }
  /**
   * Pixel width of the source of this texture
   * @readonly
   */
  get realWidth() {
    return Math.round(this.width * this.resolution);
  }
  /**
   * Pixel height of the source of this texture
   * @readonly
   */
  get realHeight() {
    return Math.round(this.height * this.resolution);
  }
  /**
   * Mipmap mode of the texture, affects downscaled images
   * @default PIXI.MIPMAP_MODES.POW2
   */
  get mipmap() {
    return this._mipmap;
  }
  set mipmap(e) {
    this._mipmap !== e && (this._mipmap = e, this.dirtyStyleId++);
  }
  /**
   * The scale mode to apply when scaling this texture
   * @default PIXI.SCALE_MODES.LINEAR
   */
  get scaleMode() {
    return this._scaleMode;
  }
  set scaleMode(e) {
    this._scaleMode !== e && (this._scaleMode = e, this.dirtyStyleId++);
  }
  /**
   * How the texture wraps
   * @default PIXI.WRAP_MODES.CLAMP
   */
  get wrapMode() {
    return this._wrapMode;
  }
  set wrapMode(e) {
    this._wrapMode !== e && (this._wrapMode = e, this.dirtyStyleId++);
  }
  /**
   * Changes style options of BaseTexture
   * @param scaleMode - Pixi scalemode
   * @param mipmap - enable mipmaps
   * @returns - this
   */
  setStyle(e, n) {
    let r;
    return e !== void 0 && e !== this.scaleMode && (this.scaleMode = e, r = !0), n !== void 0 && n !== this.mipmap && (this.mipmap = n, r = !0), r && this.dirtyStyleId++, this;
  }
  /**
   * Changes w/h/resolution. Texture becomes valid if width and height are greater than zero.
   * @param desiredWidth - Desired visual width
   * @param desiredHeight - Desired visual height
   * @param resolution - Optionally set resolution
   * @returns - this
   */
  setSize(e, n, r) {
    return r = r || this.resolution, this.setRealSize(e * r, n * r, r);
  }
  /**
   * Sets real size of baseTexture, preserves current resolution.
   * @param realWidth - Full rendered width
   * @param realHeight - Full rendered height
   * @param resolution - Optionally set resolution
   * @returns - this
   */
  setRealSize(e, n, r) {
    return this.resolution = r || this.resolution, this.width = Math.round(e) / this.resolution, this.height = Math.round(n) / this.resolution, this._refreshPOT(), this.update(), this;
  }
  /**
   * Refresh check for isPowerOfTwo texture based on size
   * @private
   */
  _refreshPOT() {
    this.isPowerOfTwo = TC(this.realWidth) && TC(this.realHeight);
  }
  /**
   * Changes resolution
   * @param resolution - res
   * @returns - this
   */
  setResolution(e) {
    const n = this.resolution;
    return n === e ? this : (this.resolution = e, this.valid && (this.width = Math.round(this.width * n) / e, this.height = Math.round(this.height * n) / e, this.emit("update", this)), this._refreshPOT(), this);
  }
  /**
   * Sets the resource if it wasn't set. Throws error if resource already present
   * @param resource - that is managing this BaseTexture
   * @returns - this
   */
  setResource(e) {
    if (this.resource === e)
      return this;
    if (this.resource)
      throw new Error("Resource can be set only once");
    return e.bind(this), this.resource = e, this;
  }
  /** Invalidates the object. Texture becomes valid if width and height are greater than zero. */
  update() {
    this.valid ? (this.dirtyId++, this.dirtyStyleId++, this.emit("update", this)) : this.width > 0 && this.height > 0 && (this.valid = !0, this.emit("loaded", this), this.emit("update", this));
  }
  /**
   * Handle errors with resources.
   * @private
   * @param event - Error event emitted.
   */
  onError(e) {
    this.emit("error", this, e);
  }
  /**
   * Destroys this base texture.
   * The method stops if resource doesn't want this texture to be destroyed.
   * Removes texture from all caches.
   * @fires PIXI.BaseTexture#destroyed
   */
  destroy() {
    this.resource && (this.resource.unbind(this), this.resource.internal && this.resource.destroy(), this.resource = null), this.cacheId && (delete Vl[this.cacheId], delete Wi[this.cacheId], this.cacheId = null), this.valid = !1, this.dispose(), Pd.removeFromCache(this), this.textureCacheIds = null, this.destroyed = !0, this.emit("destroyed", this), this.removeAllListeners();
  }
  /**
   * Frees the texture from WebGL memory without destroying this texture object.
   * This means you can still use the texture later which will upload it to GPU
   * memory again.
   * @fires PIXI.BaseTexture#dispose
   */
  dispose() {
    this.emit("dispose", this);
  }
  /** Utility function for BaseTexture|Texture cast. */
  castToBaseTexture() {
    return this;
  }
  /**
   * Helper function that creates a base texture based on the source you provide.
   * The source can be - image url, image element, canvas element. If the
   * source is an image url or an image element and not in the base texture
   * cache, it will be created and loaded.
   * @static
   * @param {HTMLImageElement|HTMLVideoElement|ImageBitmap|PIXI.ICanvas|string|string[]} source - The
   *        source to create base texture from.
   * @param options - See {@link PIXI.BaseTexture}'s constructor for options.
   * @param {string} [options.pixiIdPrefix=pixiid] - If a source has no id, this is the prefix of the generated id
   * @param {boolean} [strict] - Enforce strict-mode, see {@link PIXI.settings.STRICT_TEXTURE_CACHE}.
   * @returns {PIXI.BaseTexture} The new base texture.
   */
  static from(e, n, r = at.STRICT_TEXTURE_CACHE) {
    const o = typeof e == "string";
    let s = null;
    if (o)
      s = e;
    else {
      if (!e._pixiId) {
        const u = n?.pixiIdPrefix || "pixiid";
        e._pixiId = `${u}_${Up()}`;
      }
      s = e._pixiId;
    }
    let i = Vl[s];
    if (o && r && !i)
      throw new Error(`The cacheId "${s}" does not exist in BaseTextureCache.`);
    return i || (i = new Pd(e, n), i.cacheId = s, Pd.addToCache(i, s)), i;
  }
  /**
   * Create a new Texture with a BufferResource from a typed array.
   * @param buffer - The optional array to use. If no data is provided, a new Float32Array is created.
   * @param width - Width of the resource
   * @param height - Height of the resource
   * @param options - See {@link PIXI.BaseTexture}'s constructor for options.
   *        Default properties are different from the constructor's defaults.
   * @param {PIXI.FORMATS} [options.format] - The format is not given, the type is inferred from the
   *        type of the buffer: `RGBA` if Float32Array, Int8Array, Uint8Array, or Uint8ClampedArray,
   *        otherwise `RGBA_INTEGER`.
   * @param {PIXI.TYPES} [options.type] - The type is not given, the type is inferred from the
   *        type of the buffer. Maps Float32Array to `FLOAT`, Int32Array to `INT`, Uint32Array to
   *        `UNSIGNED_INT`, Int16Array to `SHORT`, Uint16Array to `UNSIGNED_SHORT`, Int8Array to `BYTE`,
   *        Uint8Array/Uint8ClampedArray to `UNSIGNED_BYTE`.
   * @param {PIXI.ALPHA_MODES} [options.alphaMode=PIXI.ALPHA_MODES.NPM]
   * @param {PIXI.SCALE_MODES} [options.scaleMode=PIXI.SCALE_MODES.NEAREST]
   * @returns - The resulting new BaseTexture
   */
  static fromBuffer(e, n, r, o) {
    e = e || new Float32Array(n * r * 4);
    const s = new X_(e, { width: n, height: r, ...o?.resourceOptions });
    let i, u;
    return e instanceof Float32Array ? (i = qe.RGBA, u = _t.FLOAT) : e instanceof Int32Array ? (i = qe.RGBA_INTEGER, u = _t.INT) : e instanceof Uint32Array ? (i = qe.RGBA_INTEGER, u = _t.UNSIGNED_INT) : e instanceof Int16Array ? (i = qe.RGBA_INTEGER, u = _t.SHORT) : e instanceof Uint16Array ? (i = qe.RGBA_INTEGER, u = _t.UNSIGNED_SHORT) : e instanceof Int8Array ? (i = qe.RGBA, u = _t.BYTE) : (i = qe.RGBA, u = _t.UNSIGNED_BYTE), s.internal = !0, new Pd(s, Object.assign({}, L1e, { type: u, format: i }, o));
  }
  /**
   * Adds a BaseTexture to the global BaseTextureCache. This cache is shared across the whole PIXI object.
   * @param {PIXI.BaseTexture} baseTexture - The BaseTexture to add to the cache.
   * @param {string} id - The id that the BaseTexture will be stored against.
   */
  static addToCache(e, n) {
    n && (e.textureCacheIds.includes(n) || e.textureCacheIds.push(n), Vl[n] && Vl[n] !== e && console.warn(`BaseTexture added to the cache with an id [${n}] that already had an entry`), Vl[n] = e);
  }
  /**
   * Remove a BaseTexture from the global BaseTextureCache.
   * @param {string|PIXI.BaseTexture} baseTexture - id of a BaseTexture to be removed, or a BaseTexture instance itself.
   * @returns {PIXI.BaseTexture|null} The BaseTexture that was removed.
   */
  static removeFromCache(e) {
    if (typeof e == "string") {
      const n = Vl[e];
      if (n) {
        const r = n.textureCacheIds.indexOf(e);
        return r > -1 && n.textureCacheIds.splice(r, 1), delete Vl[e], n;
      }
    } else if (e?.textureCacheIds) {
      for (let n = 0; n < e.textureCacheIds.length; ++n)
        delete Vl[e.textureCacheIds[n]];
      return e.textureCacheIds.length = 0, e;
    }
    return null;
  }
};
nT.defaultOptions = {
  /**
   * If mipmapping is enabled for texture.
   * @type {PIXI.MIPMAP_MODES}
   * @default PIXI.MIPMAP_MODES.POW2
   */
  mipmap: yu.POW2,
  /** Anisotropic filtering level of texture */
  anisotropicLevel: 0,
  /**
   * Default scale mode, linear, nearest.
   * @type {PIXI.SCALE_MODES}
   * @default PIXI.SCALE_MODES.LINEAR
   */
  scaleMode: qu.LINEAR,
  /**
   * Wrap mode for textures.
   * @type {PIXI.WRAP_MODES}
   * @default PIXI.WRAP_MODES.CLAMP
   */
  wrapMode: su.CLAMP,
  /**
   * Pre multiply the image alpha
   * @type {PIXI.ALPHA_MODES}
   * @default PIXI.ALPHA_MODES.UNPACK
   */
  alphaMode: gs.UNPACK,
  /**
   * GL texture target
   * @type {PIXI.TARGETS}
   * @default PIXI.TARGETS.TEXTURE_2D
   */
  target: Gd.TEXTURE_2D,
  /**
   * GL format type
   * @type {PIXI.FORMATS}
   * @default PIXI.FORMATS.RGBA
   */
  format: qe.RGBA,
  /**
   * GL data type
   * @type {PIXI.TYPES}
   * @default PIXI.TYPES.UNSIGNED_BYTE
   */
  type: _t.UNSIGNED_BYTE
}, /** Global number of the texture batch, used by multi-texture renderers. */
nT._globalBatch = 0;
let qt = nT;
class rT {
  constructor() {
    this.texArray = null, this.blend = 0, this.type = Zi.TRIANGLES, this.start = 0, this.size = 0, this.data = null;
  }
}
let B1e = 0;
class Fr {
  /**
   * @param {PIXI.IArrayBuffer} data - the data to store in the buffer.
   * @param _static - `true` for static buffer
   * @param index - `true` for index buffer
   */
  constructor(e, n = !0, r = !1) {
    this.data = e || new Float32Array(1), this._glBuffers = {}, this._updateID = 0, this.index = r, this.static = n, this.id = B1e++, this.disposeRunner = new pi("disposeBuffer");
  }
  // TODO could explore flagging only a partial upload?
  /**
   * Flags this buffer as requiring an upload to the GPU.
   * @param {PIXI.IArrayBuffer|number[]} [data] - the data to update in the buffer.
   */
  update(e) {
    e instanceof Array && (e = new Float32Array(e)), this.data = e || this.data, this._updateID++;
  }
  /** Disposes WebGL resources that are connected to this geometry. */
  dispose() {
    this.disposeRunner.emit(this, !1);
  }
  /** Destroys the buffer. */
  destroy() {
    this.dispose(), this.data = null;
  }
  /**
   * Flags whether this is an index buffer.
   *
   * Index buffers are of type `ELEMENT_ARRAY_BUFFER`. Note that setting this property to false will make
   * the buffer of type `ARRAY_BUFFER`.
   *
   * For backwards compatibility.
   */
  set index(e) {
    this.type = e ? au.ELEMENT_ARRAY_BUFFER : au.ARRAY_BUFFER;
  }
  get index() {
    return this.type === au.ELEMENT_ARRAY_BUFFER;
  }
  /**
   * Helper function that creates a buffer based on an array or TypedArray
   * @param {ArrayBufferView | number[]} data - the TypedArray that the buffer will store. If this is a regular Array it will be converted to a Float32Array.
   * @returns - A new Buffer based on the data provided.
   */
  static from(e) {
    return e instanceof Array && (e = new Float32Array(e)), new Fr(e);
  }
}
class ov {
  /**
   * @param buffer - the id of the buffer that this attribute will look for
   * @param size - the size of the attribute. If you have 2 floats per vertex (eg position x and y) this would be 2.
   * @param normalized - should the data be normalized.
   * @param {PIXI.TYPES} [type=PIXI.TYPES.FLOAT] - what type of number is the attribute. Check {@link PIXI.TYPES} to see the ones available
   * @param [stride=0] - How far apart, in bytes, the start of each value is. (used for interleaving data)
   * @param [start=0] - How far into the array to start reading values (used for interleaving data)
   * @param [instance=false] - Whether the geometry is instanced.
   * @param [divisor=1] - Divisor to use when doing instanced rendering
   */
  constructor(e, n = 0, r = !1, o = _t.FLOAT, s, i, u, l = 1) {
    this.buffer = e, this.size = n, this.normalized = r, this.type = o, this.stride = s, this.start = i, this.instance = u, this.divisor = l;
  }
  /** Destroys the Attribute. */
  destroy() {
    this.buffer = null;
  }
  /**
   * Helper function that creates an Attribute based on the information provided
   * @param buffer - the id of the buffer that this attribute will look for
   * @param [size=0] - the size of the attribute. If you have 2 floats per vertex (eg position x and y) this would be 2
   * @param [normalized=false] - should the data be normalized.
   * @param [type=PIXI.TYPES.FLOAT] - what type of number is the attribute. Check {@link PIXI.TYPES} to see the ones available
   * @param [stride=0] - How far apart, in bytes, the start of each value is. (used for interleaving data)
   * @returns - A new {@link PIXI.Attribute} based on the information provided
   */
  static from(e, n, r, o, s) {
    return new ov(e, n, r, o, s);
  }
}
const U1e = {
  Float32Array,
  Uint32Array,
  Int32Array,
  Uint8Array
};
function X1e(t, e) {
  let n = 0, r = 0;
  const o = {};
  for (let l = 0; l < t.length; l++)
    r += e[l], n += t[l].length;
  const s = new ArrayBuffer(n * 4);
  let i = null, u = 0;
  for (let l = 0; l < t.length; l++) {
    const a = e[l], c = t[l], p = aB(c);
    o[p] || (o[p] = new U1e[p](s)), i = o[p];
    for (let d = 0; d < c.length; d++) {
      const h = (d / a | 0) * r + u, m = d % a;
      i[h + m] = c[d];
    }
    u += a;
  }
  return new Float32Array(s);
}
const MC = { 5126: 4, 5123: 2, 5121: 1 };
let $1e = 0;
const W1e = {
  Float32Array,
  Uint32Array,
  Int32Array,
  Uint8Array,
  Uint16Array
};
class yc {
  /**
   * @param buffers - An array of buffers. optional.
   * @param attributes - Of the geometry, optional structure of the attributes layout
   */
  constructor(e = [], n = {}) {
    this.buffers = e, this.indexBuffer = null, this.attributes = n, this.glVertexArrayObjects = {}, this.id = $1e++, this.instanced = !1, this.instanceCount = 1, this.disposeRunner = new pi("disposeGeometry"), this.refCount = 0;
  }
  /**
   *
   * Adds an attribute to the geometry
   * Note: `stride` and `start` should be `undefined` if you dont know them, not 0!
   * @param id - the name of the attribute (matching up to a shader)
   * @param {PIXI.Buffer|number[]} buffer - the buffer that holds the data of the attribute . You can also provide an Array and a buffer will be created from it.
   * @param size - the size of the attribute. If you have 2 floats per vertex (eg position x and y) this would be 2
   * @param normalized - should the data be normalized.
   * @param [type=PIXI.TYPES.FLOAT] - what type of number is the attribute. Check {@link PIXI.TYPES} to see the ones available
   * @param [stride=0] - How far apart, in bytes, the start of each value is. (used for interleaving data)
   * @param [start=0] - How far into the array to start reading values (used for interleaving data)
   * @param instance - Instancing flag
   * @returns - Returns self, useful for chaining.
   */
  addAttribute(e, n, r = 0, o = !1, s, i, u, l = !1) {
    if (!n)
      throw new Error("You must pass a buffer when creating an attribute");
    n instanceof Fr || (n instanceof Array && (n = new Float32Array(n)), n = new Fr(n));
    const a = e.split("|");
    if (a.length > 1) {
      for (let p = 0; p < a.length; p++)
        this.addAttribute(a[p], n, r, o, s);
      return this;
    }
    let c = this.buffers.indexOf(n);
    return c === -1 && (this.buffers.push(n), c = this.buffers.length - 1), this.attributes[e] = new ov(c, r, o, s, i, u, l), this.instanced = this.instanced || l, this;
  }
  /**
   * Returns the requested attribute.
   * @param id - The name of the attribute required
   * @returns - The attribute requested.
   */
  getAttribute(e) {
    return this.attributes[e];
  }
  /**
   * Returns the requested buffer.
   * @param id - The name of the buffer required.
   * @returns - The buffer requested.
   */
  getBuffer(e) {
    return this.buffers[this.getAttribute(e).buffer];
  }
  /**
   *
   * Adds an index buffer to the geometry
   * The index buffer contains integers, three for each triangle in the geometry, which reference the various attribute buffers (position, colour, UV coordinates, other UV coordinates, normal, …). There is only ONE index buffer.
   * @param {PIXI.Buffer|number[]} [buffer] - The buffer that holds the data of the index buffer. You can also provide an Array and a buffer will be created from it.
   * @returns - Returns self, useful for chaining.
   */
  addIndex(e) {
    return e instanceof Fr || (e instanceof Array && (e = new Uint16Array(e)), e = new Fr(e)), e.type = au.ELEMENT_ARRAY_BUFFER, this.indexBuffer = e, this.buffers.includes(e) || this.buffers.push(e), this;
  }
  /**
   * Returns the index buffer
   * @returns - The index buffer.
   */
  getIndex() {
    return this.indexBuffer;
  }
  /**
   * This function modifies the structure so that all current attributes become interleaved into a single buffer
   * This can be useful if your model remains static as it offers a little performance boost
   * @returns - Returns self, useful for chaining.
   */
  interleave() {
    if (this.buffers.length === 1 || this.buffers.length === 2 && this.indexBuffer)
      return this;
    const e = [], n = [], r = new Fr();
    let o;
    for (o in this.attributes) {
      const s = this.attributes[o], i = this.buffers[s.buffer];
      e.push(i.data), n.push(s.size * MC[s.type] / 4), s.buffer = 0;
    }
    for (r.data = X1e(e, n), o = 0; o < this.buffers.length; o++)
      this.buffers[o] !== this.indexBuffer && this.buffers[o].destroy();
    return this.buffers = [r], this.indexBuffer && this.buffers.push(this.indexBuffer), this;
  }
  /** Get the size of the geometries, in vertices. */
  getSize() {
    for (const e in this.attributes) {
      const n = this.attributes[e];
      return this.buffers[n.buffer].data.length / (n.stride / 4 || n.size);
    }
    return 0;
  }
  /** Disposes WebGL resources that are connected to this geometry. */
  dispose() {
    this.disposeRunner.emit(this, !1);
  }
  /** Destroys the geometry. */
  destroy() {
    this.dispose(), this.buffers = null, this.indexBuffer = null, this.attributes = null;
  }
  /**
   * Returns a clone of the geometry.
   * @returns - A new clone of this geometry.
   */
  clone() {
    const e = new yc();
    for (let n = 0; n < this.buffers.length; n++)
      e.buffers[n] = new Fr(this.buffers[n].data.slice(0));
    for (const n in this.attributes) {
      const r = this.attributes[n];
      e.attributes[n] = new ov(
        r.buffer,
        r.size,
        r.normalized,
        r.type,
        r.stride,
        r.start,
        r.instance
      );
    }
    return this.indexBuffer && (e.indexBuffer = e.buffers[this.buffers.indexOf(this.indexBuffer)], e.indexBuffer.type = au.ELEMENT_ARRAY_BUFFER), e;
  }
  /**
   * Merges an array of geometries into a new single one.
   *
   * Geometry attribute styles must match for this operation to work.
   * @param geometries - array of geometries to merge
   * @returns - Shiny new geometry!
   */
  static merge(e) {
    const n = new yc(), r = [], o = [], s = [];
    let i;
    for (let u = 0; u < e.length; u++) {
      i = e[u];
      for (let l = 0; l < i.buffers.length; l++)
        o[l] = o[l] || 0, o[l] += i.buffers[l].data.length, s[l] = 0;
    }
    for (let u = 0; u < i.buffers.length; u++)
      r[u] = new W1e[aB(i.buffers[u].data)](o[u]), n.buffers[u] = new Fr(r[u]);
    for (let u = 0; u < e.length; u++) {
      i = e[u];
      for (let l = 0; l < i.buffers.length; l++)
        r[l].set(i.buffers[l].data, s[l]), s[l] += i.buffers[l].data.length;
    }
    if (n.attributes = i.attributes, i.indexBuffer) {
      n.indexBuffer = n.buffers[i.buffers.indexOf(i.indexBuffer)], n.indexBuffer.type = au.ELEMENT_ARRAY_BUFFER;
      let u = 0, l = 0, a = 0, c = 0;
      for (let p = 0; p < i.buffers.length; p++)
        if (i.buffers[p] !== i.indexBuffer) {
          c = p;
          break;
        }
      for (const p in i.attributes) {
        const d = i.attributes[p];
        (d.buffer | 0) === c && (l += d.size * MC[d.type] / 4);
      }
      for (let p = 0; p < e.length; p++) {
        const d = e[p].indexBuffer.data;
        for (let h = 0; h < d.length; h++)
          n.indexBuffer.data[h + a] += u;
        u += e[p].buffers[c].data.length / l, a += d.length;
      }
    }
    return n;
  }
}
class uB extends yc {
  /**
   * @param {boolean} [_static=false] - Optimization flag, where `false`
   *        is updated every frame, `true` doesn't change frame-to-frame.
   */
  constructor(e = !1) {
    super(), this._buffer = new Fr(null, e, !1), this._indexBuffer = new Fr(null, e, !0), this.addAttribute("aVertexPosition", this._buffer, 2, !1, _t.FLOAT).addAttribute("aTextureCoord", this._buffer, 2, !1, _t.FLOAT).addAttribute("aColor", this._buffer, 4, !0, _t.UNSIGNED_BYTE).addAttribute("aTextureId", this._buffer, 1, !0, _t.FLOAT).addIndex(this._indexBuffer);
  }
}
const sv = Math.PI * 2, V1e = 180 / Math.PI, oT = Math.PI / 180;
var Ao = /* @__PURE__ */ ((t) => (t[t.POLY = 0] = "POLY", t[t.RECT = 1] = "RECT", t[t.CIRC = 2] = "CIRC", t[t.ELIP = 3] = "ELIP", t[t.RREC = 4] = "RREC", t))(Ao || {});
class Rt {
  /**
   * Creates a new `Point`
   * @param {number} [x=0] - position of the point on the x axis
   * @param {number} [y=0] - position of the point on the y axis
   */
  constructor(e = 0, n = 0) {
    this.x = 0, this.y = 0, this.x = e, this.y = n;
  }
  /**
   * Creates a clone of this point
   * @returns A clone of this point
   */
  clone() {
    return new Rt(this.x, this.y);
  }
  /**
   * Copies `x` and `y` from the given point into this point
   * @param p - The point to copy from
   * @returns The point instance itself
   */
  copyFrom(e) {
    return this.set(e.x, e.y), this;
  }
  /**
   * Copies this point's x and y into the given point (`p`).
   * @param p - The point to copy to. Can be any of type that is or extends `IPointData`
   * @returns The point (`p`) with values updated
   */
  copyTo(e) {
    return e.set(this.x, this.y), e;
  }
  /**
   * Accepts another point (`p`) and returns `true` if the given point is equal to this point
   * @param p - The point to check
   * @returns Returns `true` if both `x` and `y` are equal
   */
  equals(e) {
    return e.x === this.x && e.y === this.y;
  }
  /**
   * Sets the point to a new `x` and `y` position.
   * If `y` is omitted, both `x` and `y` will be set to `x`.
   * @param {number} [x=0] - position of the point on the `x` axis
   * @param {number} [y=x] - position of the point on the `y` axis
   * @returns The point instance itself
   */
  set(e = 0, n = e) {
    return this.x = e, this.y = n, this;
  }
}
Rt.prototype.toString = function() {
  return `[@pixi/math:Point x=${this.x} y=${this.y}]`;
};
const mg = [new Rt(), new Rt(), new Rt(), new Rt()];
class Pt {
  /**
   * @param x - The X coordinate of the upper-left corner of the rectangle
   * @param y - The Y coordinate of the upper-left corner of the rectangle
   * @param width - The overall width of the rectangle
   * @param height - The overall height of the rectangle
   */
  constructor(e = 0, n = 0, r = 0, o = 0) {
    this.x = Number(e), this.y = Number(n), this.width = Number(r), this.height = Number(o), this.type = Ao.RECT;
  }
  /** Returns the left edge of the rectangle. */
  get left() {
    return this.x;
  }
  /** Returns the right edge of the rectangle. */
  get right() {
    return this.x + this.width;
  }
  /** Returns the top edge of the rectangle. */
  get top() {
    return this.y;
  }
  /** Returns the bottom edge of the rectangle. */
  get bottom() {
    return this.y + this.height;
  }
  /** A constant empty rectangle. */
  static get EMPTY() {
    return new Pt(0, 0, 0, 0);
  }
  /**
   * Creates a clone of this Rectangle
   * @returns a copy of the rectangle
   */
  clone() {
    return new Pt(this.x, this.y, this.width, this.height);
  }
  /**
   * Copies another rectangle to this one.
   * @param rectangle - The rectangle to copy from.
   * @returns Returns itself.
   */
  copyFrom(e) {
    return this.x = e.x, this.y = e.y, this.width = e.width, this.height = e.height, this;
  }
  /**
   * Copies this rectangle to another one.
   * @param rectangle - The rectangle to copy to.
   * @returns Returns given parameter.
   */
  copyTo(e) {
    return e.x = this.x, e.y = this.y, e.width = this.width, e.height = this.height, e;
  }
  /**
   * Checks whether the x and y coordinates given are contained within this Rectangle
   * @param x - The X coordinate of the point to test
   * @param y - The Y coordinate of the point to test
   * @returns Whether the x/y coordinates are within this Rectangle
   */
  contains(e, n) {
    return this.width <= 0 || this.height <= 0 ? !1 : e >= this.x && e < this.x + this.width && n >= this.y && n < this.y + this.height;
  }
  /**
   * Determines whether the `other` Rectangle transformed by `transform` intersects with `this` Rectangle object.
   * Returns true only if the area of the intersection is >0, this means that Rectangles
   * sharing a side are not overlapping. Another side effect is that an arealess rectangle
   * (width or height equal to zero) can't intersect any other rectangle.
   * @param {Rectangle} other - The Rectangle to intersect with `this`.
   * @param {Matrix} transform - The transformation matrix of `other`.
   * @returns {boolean} A value of `true` if the transformed `other` Rectangle intersects with `this`; otherwise `false`.
   */
  intersects(e, n) {
    if (!n) {
      const L = this.x < e.x ? e.x : this.x;
      if ((this.right > e.right ? e.right : this.right) <= L)
        return !1;
      const X = this.y < e.y ? e.y : this.y;
      return (this.bottom > e.bottom ? e.bottom : this.bottom) > X;
    }
    const r = this.left, o = this.right, s = this.top, i = this.bottom;
    if (o <= r || i <= s)
      return !1;
    const u = mg[0].set(e.left, e.top), l = mg[1].set(e.left, e.bottom), a = mg[2].set(e.right, e.top), c = mg[3].set(e.right, e.bottom);
    if (a.x <= u.x || l.y <= u.y)
      return !1;
    const p = Math.sign(n.a * n.d - n.b * n.c);
    if (p === 0 || (n.apply(u, u), n.apply(l, l), n.apply(a, a), n.apply(c, c), Math.max(u.x, l.x, a.x, c.x) <= r || Math.min(u.x, l.x, a.x, c.x) >= o || Math.max(u.y, l.y, a.y, c.y) <= s || Math.min(u.y, l.y, a.y, c.y) >= i))
      return !1;
    const d = p * (l.y - u.y), h = p * (u.x - l.x), m = d * r + h * s, g = d * o + h * s, _ = d * r + h * i, b = d * o + h * i;
    if (Math.max(m, g, _, b) <= d * u.x + h * u.y || Math.min(m, g, _, b) >= d * c.x + h * c.y)
      return !1;
    const x = p * (u.y - a.y), S = p * (a.x - u.x), E = x * r + S * s, A = x * o + S * s, C = x * r + S * i, M = x * o + S * i;
    return !(Math.max(E, A, C, M) <= x * u.x + S * u.y || Math.min(E, A, C, M) >= x * c.x + S * c.y);
  }
  /**
   * Pads the rectangle making it grow in all directions.
   * If paddingY is omitted, both paddingX and paddingY will be set to paddingX.
   * @param paddingX - The horizontal padding amount.
   * @param paddingY - The vertical padding amount.
   * @returns Returns itself.
   */
  pad(e = 0, n = e) {
    return this.x -= e, this.y -= n, this.width += e * 2, this.height += n * 2, this;
  }
  /**
   * Fits this rectangle around the passed one.
   * @param rectangle - The rectangle to fit.
   * @returns Returns itself.
   */
  fit(e) {
    const n = Math.max(this.x, e.x), r = Math.min(this.x + this.width, e.x + e.width), o = Math.max(this.y, e.y), s = Math.min(this.y + this.height, e.y + e.height);
    return this.x = n, this.width = Math.max(r - n, 0), this.y = o, this.height = Math.max(s - o, 0), this;
  }
  /**
   * Enlarges rectangle that way its corners lie on grid
   * @param resolution - resolution
   * @param eps - precision
   * @returns Returns itself.
   */
  ceil(e = 1, n = 1e-3) {
    const r = Math.ceil((this.x + this.width - n) * e) / e, o = Math.ceil((this.y + this.height - n) * e) / e;
    return this.x = Math.floor((this.x + n) * e) / e, this.y = Math.floor((this.y + n) * e) / e, this.width = r - this.x, this.height = o - this.y, this;
  }
  /**
   * Enlarges this rectangle to include the passed rectangle.
   * @param rectangle - The rectangle to include.
   * @returns Returns itself.
   */
  enlarge(e) {
    const n = Math.min(this.x, e.x), r = Math.max(this.x + this.width, e.x + e.width), o = Math.min(this.y, e.y), s = Math.max(this.y + this.height, e.y + e.height);
    return this.x = n, this.width = r - n, this.y = o, this.height = s - o, this;
  }
}
Pt.prototype.toString = function() {
  return `[@pixi/math:Rectangle x=${this.x} y=${this.y} width=${this.width} height=${this.height}]`;
};
class $_ {
  /**
   * @param x - The X coordinate of the center of this circle
   * @param y - The Y coordinate of the center of this circle
   * @param radius - The radius of the circle
   */
  constructor(e = 0, n = 0, r = 0) {
    this.x = e, this.y = n, this.radius = r, this.type = Ao.CIRC;
  }
  /**
   * Creates a clone of this Circle instance
   * @returns A copy of the Circle
   */
  clone() {
    return new $_(this.x, this.y, this.radius);
  }
  /**
   * Checks whether the x and y coordinates given are contained within this circle
   * @param x - The X coordinate of the point to test
   * @param y - The Y coordinate of the point to test
   * @returns Whether the x/y coordinates are within this Circle
   */
  contains(e, n) {
    if (this.radius <= 0)
      return !1;
    const r = this.radius * this.radius;
    let o = this.x - e, s = this.y - n;
    return o *= o, s *= s, o + s <= r;
  }
  /**
   * Returns the framing rectangle of the circle as a Rectangle object
   * @returns The framing rectangle
   */
  getBounds() {
    return new Pt(this.x - this.radius, this.y - this.radius, this.radius * 2, this.radius * 2);
  }
}
$_.prototype.toString = function() {
  return `[@pixi/math:Circle x=${this.x} y=${this.y} radius=${this.radius}]`;
};
class W_ {
  /**
   * @param x - The X coordinate of the center of this ellipse
   * @param y - The Y coordinate of the center of this ellipse
   * @param halfWidth - The half width of this ellipse
   * @param halfHeight - The half height of this ellipse
   */
  constructor(e = 0, n = 0, r = 0, o = 0) {
    this.x = e, this.y = n, this.width = r, this.height = o, this.type = Ao.ELIP;
  }
  /**
   * Creates a clone of this Ellipse instance
   * @returns {PIXI.Ellipse} A copy of the ellipse
   */
  clone() {
    return new W_(this.x, this.y, this.width, this.height);
  }
  /**
   * Checks whether the x and y coordinates given are contained within this ellipse
   * @param x - The X coordinate of the point to test
   * @param y - The Y coordinate of the point to test
   * @returns Whether the x/y coords are within this ellipse
   */
  contains(e, n) {
    if (this.width <= 0 || this.height <= 0)
      return !1;
    let r = (e - this.x) / this.width, o = (n - this.y) / this.height;
    return r *= r, o *= o, r + o <= 1;
  }
  /**
   * Returns the framing rectangle of the ellipse as a Rectangle object
   * @returns The framing rectangle
   */
  getBounds() {
    return new Pt(this.x - this.width, this.y - this.height, this.width, this.height);
  }
}
W_.prototype.toString = function() {
  return `[@pixi/math:Ellipse x=${this.x} y=${this.y} width=${this.width} height=${this.height}]`;
};
class xp {
  /**
   * @param {PIXI.IPointData[]|number[]} points - This can be an array of Points
   *  that form the polygon, a flat array of numbers that will be interpreted as [x,y, x,y, ...], or
   *  the arguments passed can be all the points of the polygon e.g.
   *  `new Polygon(new Point(), new Point(), ...)`, or the arguments passed can be flat
   *  x,y values e.g. `new Polygon(x,y, x,y, x,y, ...)` where `x` and `y` are Numbers.
   */
  constructor(...e) {
    let n = Array.isArray(e[0]) ? e[0] : e;
    if (typeof n[0] != "number") {
      const r = [];
      for (let o = 0, s = n.length; o < s; o++)
        r.push(n[o].x, n[o].y);
      n = r;
    }
    this.points = n, this.type = Ao.POLY, this.closeStroke = !0;
  }
  /**
   * Creates a clone of this polygon.
   * @returns - A copy of the polygon.
   */
  clone() {
    const e = this.points.slice(), n = new xp(e);
    return n.closeStroke = this.closeStroke, n;
  }
  /**
   * Checks whether the x and y coordinates passed to this function are contained within this polygon.
   * @param x - The X coordinate of the point to test.
   * @param y - The Y coordinate of the point to test.
   * @returns - Whether the x/y coordinates are within this polygon.
   */
  contains(e, n) {
    let r = !1;
    const o = this.points.length / 2;
    for (let s = 0, i = o - 1; s < o; i = s++) {
      const u = this.points[s * 2], l = this.points[s * 2 + 1], a = this.points[i * 2], c = this.points[i * 2 + 1];
      l > n != c > n && e < (a - u) * ((n - l) / (c - l)) + u && (r = !r);
    }
    return r;
  }
}
xp.prototype.toString = function() {
  return `[@pixi/math:PolygoncloseStroke=${this.closeStroke}points=${this.points.reduce((t, e) => `${t}, ${e}`, "")}]`;
};
class V_ {
  /**
   * @param x - The X coordinate of the upper-left corner of the rounded rectangle
   * @param y - The Y coordinate of the upper-left corner of the rounded rectangle
   * @param width - The overall width of this rounded rectangle
   * @param height - The overall height of this rounded rectangle
   * @param radius - Controls the radius of the rounded corners
   */
  constructor(e = 0, n = 0, r = 0, o = 0, s = 20) {
    this.x = e, this.y = n, this.width = r, this.height = o, this.radius = s, this.type = Ao.RREC;
  }
  /**
   * Creates a clone of this Rounded Rectangle.
   * @returns - A copy of the rounded rectangle.
   */
  clone() {
    return new V_(this.x, this.y, this.width, this.height, this.radius);
  }
  /**
   * Checks whether the x and y coordinates given are contained within this Rounded Rectangle
   * @param x - The X coordinate of the point to test.
   * @param y - The Y coordinate of the point to test.
   * @returns - Whether the x/y coordinates are within this Rounded Rectangle.
   */
  contains(e, n) {
    if (this.width <= 0 || this.height <= 0)
      return !1;
    if (e >= this.x && e <= this.x + this.width && n >= this.y && n <= this.y + this.height) {
      const r = Math.max(0, Math.min(this.radius, Math.min(this.width, this.height) / 2));
      if (n >= this.y + r && n <= this.y + this.height - r || e >= this.x + r && e <= this.x + this.width - r)
        return !0;
      let o = e - (this.x + r), s = n - (this.y + r);
      const i = r * r;
      if (o * o + s * s <= i || (o = e - (this.x + this.width - r), o * o + s * s <= i) || (s = n - (this.y + this.height - r), o * o + s * s <= i) || (o = e - (this.x + r), o * o + s * s <= i))
        return !0;
    }
    return !1;
  }
}
V_.prototype.toString = function() {
  return `[@pixi/math:RoundedRectangle x=${this.x} y=${this.y}width=${this.width} height=${this.height} radius=${this.radius}]`;
};
class Qn {
  /**
   * @param a - x scale
   * @param b - y skew
   * @param c - x skew
   * @param d - y scale
   * @param tx - x translation
   * @param ty - y translation
   */
  constructor(e = 1, n = 0, r = 0, o = 1, s = 0, i = 0) {
    this.array = null, this.a = e, this.b = n, this.c = r, this.d = o, this.tx = s, this.ty = i;
  }
  /**
   * Creates a Matrix object based on the given array. The Element to Matrix mapping order is as follows:
   *
   * a = array[0]
   * b = array[1]
   * c = array[3]
   * d = array[4]
   * tx = array[2]
   * ty = array[5]
   * @param array - The array that the matrix will be populated from.
   */
  fromArray(e) {
    this.a = e[0], this.b = e[1], this.c = e[3], this.d = e[4], this.tx = e[2], this.ty = e[5];
  }
  /**
   * Sets the matrix properties.
   * @param a - Matrix component
   * @param b - Matrix component
   * @param c - Matrix component
   * @param d - Matrix component
   * @param tx - Matrix component
   * @param ty - Matrix component
   * @returns This matrix. Good for chaining method calls.
   */
  set(e, n, r, o, s, i) {
    return this.a = e, this.b = n, this.c = r, this.d = o, this.tx = s, this.ty = i, this;
  }
  /**
   * Creates an array from the current Matrix object.
   * @param transpose - Whether we need to transpose the matrix or not
   * @param [out=new Float32Array(9)] - If provided the array will be assigned to out
   * @returns The newly created array which contains the matrix
   */
  toArray(e, n) {
    this.array || (this.array = new Float32Array(9));
    const r = n || this.array;
    return e ? (r[0] = this.a, r[1] = this.b, r[2] = 0, r[3] = this.c, r[4] = this.d, r[5] = 0, r[6] = this.tx, r[7] = this.ty, r[8] = 1) : (r[0] = this.a, r[1] = this.c, r[2] = this.tx, r[3] = this.b, r[4] = this.d, r[5] = this.ty, r[6] = 0, r[7] = 0, r[8] = 1), r;
  }
  /**
   * Get a new position with the current transformation applied.
   * Can be used to go from a child's coordinate space to the world coordinate space. (e.g. rendering)
   * @param pos - The origin
   * @param {PIXI.Point} [newPos] - The point that the new position is assigned to (allowed to be same as input)
   * @returns {PIXI.Point} The new point, transformed through this matrix
   */
  apply(e, n) {
    n = n || new Rt();
    const r = e.x, o = e.y;
    return n.x = this.a * r + this.c * o + this.tx, n.y = this.b * r + this.d * o + this.ty, n;
  }
  /**
   * Get a new position with the inverse of the current transformation applied.
   * Can be used to go from the world coordinate space to a child's coordinate space. (e.g. input)
   * @param pos - The origin
   * @param {PIXI.Point} [newPos] - The point that the new position is assigned to (allowed to be same as input)
   * @returns {PIXI.Point} The new point, inverse-transformed through this matrix
   */
  applyInverse(e, n) {
    n = n || new Rt();
    const r = 1 / (this.a * this.d + this.c * -this.b), o = e.x, s = e.y;
    return n.x = this.d * r * o + -this.c * r * s + (this.ty * this.c - this.tx * this.d) * r, n.y = this.a * r * s + -this.b * r * o + (-this.ty * this.a + this.tx * this.b) * r, n;
  }
  /**
   * Translates the matrix on the x and y.
   * @param x - How much to translate x by
   * @param y - How much to translate y by
   * @returns This matrix. Good for chaining method calls.
   */
  translate(e, n) {
    return this.tx += e, this.ty += n, this;
  }
  /**
   * Applies a scale transformation to the matrix.
   * @param x - The amount to scale horizontally
   * @param y - The amount to scale vertically
   * @returns This matrix. Good for chaining method calls.
   */
  scale(e, n) {
    return this.a *= e, this.d *= n, this.c *= e, this.b *= n, this.tx *= e, this.ty *= n, this;
  }
  /**
   * Applies a rotation transformation to the matrix.
   * @param angle - The angle in radians.
   * @returns This matrix. Good for chaining method calls.
   */
  rotate(e) {
    const n = Math.cos(e), r = Math.sin(e), o = this.a, s = this.c, i = this.tx;
    return this.a = o * n - this.b * r, this.b = o * r + this.b * n, this.c = s * n - this.d * r, this.d = s * r + this.d * n, this.tx = i * n - this.ty * r, this.ty = i * r + this.ty * n, this;
  }
  /**
   * Appends the given Matrix to this Matrix.
   * @param matrix - The matrix to append.
   * @returns This matrix. Good for chaining method calls.
   */
  append(e) {
    const n = this.a, r = this.b, o = this.c, s = this.d;
    return this.a = e.a * n + e.b * o, this.b = e.a * r + e.b * s, this.c = e.c * n + e.d * o, this.d = e.c * r + e.d * s, this.tx = e.tx * n + e.ty * o + this.tx, this.ty = e.tx * r + e.ty * s + this.ty, this;
  }
  /**
   * Sets the matrix based on all the available properties
   * @param x - Position on the x axis
   * @param y - Position on the y axis
   * @param pivotX - Pivot on the x axis
   * @param pivotY - Pivot on the y axis
   * @param scaleX - Scale on the x axis
   * @param scaleY - Scale on the y axis
   * @param rotation - Rotation in radians
   * @param skewX - Skew on the x axis
   * @param skewY - Skew on the y axis
   * @returns This matrix. Good for chaining method calls.
   */
  setTransform(e, n, r, o, s, i, u, l, a) {
    return this.a = Math.cos(u + a) * s, this.b = Math.sin(u + a) * s, this.c = -Math.sin(u - l) * i, this.d = Math.cos(u - l) * i, this.tx = e - (r * this.a + o * this.c), this.ty = n - (r * this.b + o * this.d), this;
  }
  /**
   * Prepends the given Matrix to this Matrix.
   * @param matrix - The matrix to prepend
   * @returns This matrix. Good for chaining method calls.
   */
  prepend(e) {
    const n = this.tx;
    if (e.a !== 1 || e.b !== 0 || e.c !== 0 || e.d !== 1) {
      const r = this.a, o = this.c;
      this.a = r * e.a + this.b * e.c, this.b = r * e.b + this.b * e.d, this.c = o * e.a + this.d * e.c, this.d = o * e.b + this.d * e.d;
    }
    return this.tx = n * e.a + this.ty * e.c + e.tx, this.ty = n * e.b + this.ty * e.d + e.ty, this;
  }
  /**
   * Decomposes the matrix (x, y, scaleX, scaleY, and rotation) and sets the properties on to a transform.
   * @param transform - The transform to apply the properties to.
   * @returns The transform with the newly applied properties
   */
  decompose(e) {
    const n = this.a, r = this.b, o = this.c, s = this.d, i = e.pivot, u = -Math.atan2(-o, s), l = Math.atan2(r, n), a = Math.abs(u + l);
    return a < 1e-5 || Math.abs(sv - a) < 1e-5 ? (e.rotation = l, e.skew.x = e.skew.y = 0) : (e.rotation = 0, e.skew.x = u, e.skew.y = l), e.scale.x = Math.sqrt(n * n + r * r), e.scale.y = Math.sqrt(o * o + s * s), e.position.x = this.tx + (i.x * n + i.y * o), e.position.y = this.ty + (i.x * r + i.y * s), e;
  }
  /**
   * Inverts this matrix
   * @returns This matrix. Good for chaining method calls.
   */
  invert() {
    const e = this.a, n = this.b, r = this.c, o = this.d, s = this.tx, i = e * o - n * r;
    return this.a = o / i, this.b = -n / i, this.c = -r / i, this.d = e / i, this.tx = (r * this.ty - o * s) / i, this.ty = -(e * this.ty - n * s) / i, this;
  }
  /**
   * Resets this Matrix to an identity (default) matrix.
   * @returns This matrix. Good for chaining method calls.
   */
  identity() {
    return this.a = 1, this.b = 0, this.c = 0, this.d = 1, this.tx = 0, this.ty = 0, this;
  }
  /**
   * Creates a new Matrix object with the same values as this one.
   * @returns A copy of this matrix. Good for chaining method calls.
   */
  clone() {
    const e = new Qn();
    return e.a = this.a, e.b = this.b, e.c = this.c, e.d = this.d, e.tx = this.tx, e.ty = this.ty, e;
  }
  /**
   * Changes the values of the given matrix to be the same as the ones in this matrix
   * @param matrix - The matrix to copy to.
   * @returns The matrix given in parameter with its values updated.
   */
  copyTo(e) {
    return e.a = this.a, e.b = this.b, e.c = this.c, e.d = this.d, e.tx = this.tx, e.ty = this.ty, e;
  }
  /**
   * Changes the values of the matrix to be the same as the ones in given matrix
   * @param {PIXI.Matrix} matrix - The matrix to copy from.
   * @returns {PIXI.Matrix} this
   */
  copyFrom(e) {
    return this.a = e.a, this.b = e.b, this.c = e.c, this.d = e.d, this.tx = e.tx, this.ty = e.ty, this;
  }
  /**
   * A default (identity) matrix
   * @readonly
   */
  static get IDENTITY() {
    return new Qn();
  }
  /**
   * A temp matrix
   * @readonly
   */
  static get TEMP_MATRIX() {
    return new Qn();
  }
}
Qn.prototype.toString = function() {
  return `[@pixi/math:Matrix a=${this.a} b=${this.b} c=${this.c} d=${this.d} tx=${this.tx} ty=${this.ty}]`;
};
const np = [1, 1, 0, -1, -1, -1, 0, 1, 1, 1, 0, -1, -1, -1, 0, 1], rp = [0, 1, 1, 1, 0, -1, -1, -1, 0, 1, 1, 1, 0, -1, -1, -1], op = [0, -1, -1, -1, 0, 1, 1, 1, 0, 1, 1, 1, 0, -1, -1, -1], sp = [1, 1, 0, -1, -1, -1, 0, 1, -1, -1, 0, 1, 1, 1, 0, -1], sT = [], lB = [], yg = Math.sign;
function H1e() {
  for (let t = 0; t < 16; t++) {
    const e = [];
    sT.push(e);
    for (let n = 0; n < 16; n++) {
      const r = yg(np[t] * np[n] + op[t] * rp[n]), o = yg(rp[t] * np[n] + sp[t] * rp[n]), s = yg(np[t] * op[n] + op[t] * sp[n]), i = yg(rp[t] * op[n] + sp[t] * sp[n]);
      for (let u = 0; u < 16; u++)
        if (np[u] === r && rp[u] === o && op[u] === s && sp[u] === i) {
          e.push(u);
          break;
        }
    }
  }
  for (let t = 0; t < 16; t++) {
    const e = new Qn();
    e.set(np[t], rp[t], op[t], sp[t], 0, 0), lB.push(e);
  }
}
H1e();
const hr = {
  /**
   * | Rotation | Direction |
   * |----------|-----------|
   * | 0°       | East      |
   * @readonly
   */
  E: 0,
  /**
   * | Rotation | Direction |
   * |----------|-----------|
   * | 45°↻     | Southeast |
   * @readonly
   */
  SE: 1,
  /**
   * | Rotation | Direction |
   * |----------|-----------|
   * | 90°↻     | South     |
   * @readonly
   */
  S: 2,
  /**
   * | Rotation | Direction |
   * |----------|-----------|
   * | 135°↻    | Southwest |
   * @readonly
   */
  SW: 3,
  /**
   * | Rotation | Direction |
   * |----------|-----------|
   * | 180°     | West      |
   * @readonly
   */
  W: 4,
  /**
   * | Rotation    | Direction    |
   * |-------------|--------------|
   * | -135°/225°↻ | Northwest    |
   * @readonly
   */
  NW: 5,
  /**
   * | Rotation    | Direction    |
   * |-------------|--------------|
   * | -90°/270°↻  | North        |
   * @readonly
   */
  N: 6,
  /**
   * | Rotation    | Direction    |
   * |-------------|--------------|
   * | -45°/315°↻  | Northeast    |
   * @readonly
   */
  NE: 7,
  /**
   * Reflection about Y-axis.
   * @readonly
   */
  MIRROR_VERTICAL: 8,
  /**
   * Reflection about the main diagonal.
   * @readonly
   */
  MAIN_DIAGONAL: 10,
  /**
   * Reflection about X-axis.
   * @readonly
   */
  MIRROR_HORIZONTAL: 12,
  /**
   * Reflection about reverse diagonal.
   * @readonly
   */
  REVERSE_DIAGONAL: 14,
  /**
   * @param {PIXI.GD8Symmetry} ind - sprite rotation angle.
   * @returns {PIXI.GD8Symmetry} The X-component of the U-axis
   *    after rotating the axes.
   */
  uX: (t) => np[t],
  /**
   * @param {PIXI.GD8Symmetry} ind - sprite rotation angle.
   * @returns {PIXI.GD8Symmetry} The Y-component of the U-axis
   *    after rotating the axes.
   */
  uY: (t) => rp[t],
  /**
   * @param {PIXI.GD8Symmetry} ind - sprite rotation angle.
   * @returns {PIXI.GD8Symmetry} The X-component of the V-axis
   *    after rotating the axes.
   */
  vX: (t) => op[t],
  /**
   * @param {PIXI.GD8Symmetry} ind - sprite rotation angle.
   * @returns {PIXI.GD8Symmetry} The Y-component of the V-axis
   *    after rotating the axes.
   */
  vY: (t) => sp[t],
  /**
   * @param {PIXI.GD8Symmetry} rotation - symmetry whose opposite
   *   is needed. Only rotations have opposite symmetries while
   *   reflections don't.
   * @returns {PIXI.GD8Symmetry} The opposite symmetry of `rotation`
   */
  inv: (t) => t & 8 ? t & 15 : -t & 7,
  /**
   * Composes the two D8 operations.
   *
   * Taking `^` as reflection:
   *
   * |       | E=0 | S=2 | W=4 | N=6 | E^=8 | S^=10 | W^=12 | N^=14 |
   * |-------|-----|-----|-----|-----|------|-------|-------|-------|
   * | E=0   | E   | S   | W   | N   | E^   | S^    | W^    | N^    |
   * | S=2   | S   | W   | N   | E   | S^   | W^    | N^    | E^    |
   * | W=4   | W   | N   | E   | S   | W^   | N^    | E^    | S^    |
   * | N=6   | N   | E   | S   | W   | N^   | E^    | S^    | W^    |
   * | E^=8  | E^  | N^  | W^  | S^  | E    | N     | W     | S     |
   * | S^=10 | S^  | E^  | N^  | W^  | S    | E     | N     | W     |
   * | W^=12 | W^  | S^  | E^  | N^  | W    | S     | E     | N     |
   * | N^=14 | N^  | W^  | S^  | E^  | N    | W     | S     | E     |
   *
   * [This is a Cayley table]{@link https://en.wikipedia.org/wiki/Cayley_table}
   * @param {PIXI.GD8Symmetry} rotationSecond - Second operation, which
   *   is the row in the above cayley table.
   * @param {PIXI.GD8Symmetry} rotationFirst - First operation, which
   *   is the column in the above cayley table.
   * @returns {PIXI.GD8Symmetry} Composed operation
   */
  add: (t, e) => sT[t][e],
  /**
   * Reverse of `add`.
   * @param {PIXI.GD8Symmetry} rotationSecond - Second operation
   * @param {PIXI.GD8Symmetry} rotationFirst - First operation
   * @returns {PIXI.GD8Symmetry} Result
   */
  sub: (t, e) => sT[t][hr.inv(e)],
  /**
   * Adds 180 degrees to rotation, which is a commutative
   * operation.
   * @param {number} rotation - The number to rotate.
   * @returns {number} Rotated number
   */
  rotate180: (t) => t ^ 4,
  /**
   * Checks if the rotation angle is vertical, i.e. south
   * or north. It doesn't work for reflections.
   * @param {PIXI.GD8Symmetry} rotation - The number to check.
   * @returns {boolean} Whether or not the direction is vertical
   */
  isVertical: (t) => (t & 3) === 2,
  // rotation % 4 === 2
  /**
   * Approximates the vector `V(dx,dy)` into one of the
   * eight directions provided by `groupD8`.
   * @param {number} dx - X-component of the vector
   * @param {number} dy - Y-component of the vector
   * @returns {PIXI.GD8Symmetry} Approximation of the vector into
   *  one of the eight symmetries.
   */
  byDirection: (t, e) => Math.abs(t) * 2 <= Math.abs(e) ? e >= 0 ? hr.S : hr.N : Math.abs(e) * 2 <= Math.abs(t) ? t > 0 ? hr.E : hr.W : e > 0 ? t > 0 ? hr.SE : hr.SW : t > 0 ? hr.NE : hr.NW,
  /**
   * Helps sprite to compensate texture packer rotation.
   * @param {PIXI.Matrix} matrix - sprite world matrix
   * @param {PIXI.GD8Symmetry} rotation - The rotation factor to use.
   * @param {number} tx - sprite anchoring
   * @param {number} ty - sprite anchoring
   */
  matrixAppendRotationInv: (t, e, n = 0, r = 0) => {
    const o = lB[hr.inv(e)];
    o.tx = n, o.ty = r, t.append(o);
  }
};
class Yu {
  /**
   * Creates a new `ObservablePoint`
   * @param cb - callback function triggered when `x` and/or `y` are changed
   * @param scope - owner of callback
   * @param {number} [x=0] - position of the point on the x axis
   * @param {number} [y=0] - position of the point on the y axis
   */
  constructor(e, n, r = 0, o = 0) {
    this._x = r, this._y = o, this.cb = e, this.scope = n;
  }
  /**
   * Creates a clone of this point.
   * The callback and scope params can be overridden otherwise they will default
   * to the clone object's values.
   * @override
   * @param cb - The callback function triggered when `x` and/or `y` are changed
   * @param scope - The owner of the callback
   * @returns a copy of this observable point
   */
  clone(e = this.cb, n = this.scope) {
    return new Yu(e, n, this._x, this._y);
  }
  /**
   * Sets the point to a new `x` and `y` position.
   * If `y` is omitted, both `x` and `y` will be set to `x`.
   * @param {number} [x=0] - position of the point on the x axis
   * @param {number} [y=x] - position of the point on the y axis
   * @returns The observable point instance itself
   */
  set(e = 0, n = e) {
    return (this._x !== e || this._y !== n) && (this._x = e, this._y = n, this.cb.call(this.scope)), this;
  }
  /**
   * Copies x and y from the given point (`p`)
   * @param p - The point to copy from. Can be any of type that is or extends `IPointData`
   * @returns The observable point instance itself
   */
  copyFrom(e) {
    return (this._x !== e.x || this._y !== e.y) && (this._x = e.x, this._y = e.y, this.cb.call(this.scope)), this;
  }
  /**
   * Copies this point's x and y into that of the given point (`p`)
   * @param p - The point to copy to. Can be any of type that is or extends `IPointData`
   * @returns The point (`p`) with values updated
   */
  copyTo(e) {
    return e.set(this._x, this._y), e;
  }
  /**
   * Accepts another point (`p`) and returns `true` if the given point is equal to this point
   * @param p - The point to check
   * @returns Returns `true` if both `x` and `y` are equal
   */
  equals(e) {
    return e.x === this._x && e.y === this._y;
  }
  /** Position of the observable point on the x axis. */
  get x() {
    return this._x;
  }
  set x(e) {
    this._x !== e && (this._x = e, this.cb.call(this.scope));
  }
  /** Position of the observable point on the y axis. */
  get y() {
    return this._y;
  }
  set y(e) {
    this._y !== e && (this._y = e, this.cb.call(this.scope));
  }
}
Yu.prototype.toString = function() {
  return `[@pixi/math:ObservablePoint x=${this.x} y=${this.y} scope=${this.scope}]`;
};
const aT = class {
  constructor() {
    this.worldTransform = new Qn(), this.localTransform = new Qn(), this.position = new Yu(this.onChange, this, 0, 0), this.scale = new Yu(this.onChange, this, 1, 1), this.pivot = new Yu(this.onChange, this, 0, 0), this.skew = new Yu(this.updateSkew, this, 0, 0), this._rotation = 0, this._cx = 1, this._sx = 0, this._cy = 0, this._sy = 1, this._localID = 0, this._currentLocalID = 0, this._worldID = 0, this._parentID = 0;
  }
  /** Called when a value changes. */
  onChange() {
    this._localID++;
  }
  /** Called when the skew or the rotation changes. */
  updateSkew() {
    this._cx = Math.cos(this._rotation + this.skew.y), this._sx = Math.sin(this._rotation + this.skew.y), this._cy = -Math.sin(this._rotation - this.skew.x), this._sy = Math.cos(this._rotation - this.skew.x), this._localID++;
  }
  /** Updates the local transformation matrix. */
  updateLocalTransform() {
    const t = this.localTransform;
    this._localID !== this._currentLocalID && (t.a = this._cx * this.scale.x, t.b = this._sx * this.scale.x, t.c = this._cy * this.scale.y, t.d = this._sy * this.scale.y, t.tx = this.position.x - (this.pivot.x * t.a + this.pivot.y * t.c), t.ty = this.position.y - (this.pivot.x * t.b + this.pivot.y * t.d), this._currentLocalID = this._localID, this._parentID = -1);
  }
  /**
   * Updates the local and the world transformation matrices.
   * @param parentTransform - The parent transform
   */
  updateTransform(t) {
    const e = this.localTransform;
    if (this._localID !== this._currentLocalID && (e.a = this._cx * this.scale.x, e.b = this._sx * this.scale.x, e.c = this._cy * this.scale.y, e.d = this._sy * this.scale.y, e.tx = this.position.x - (this.pivot.x * e.a + this.pivot.y * e.c), e.ty = this.position.y - (this.pivot.x * e.b + this.pivot.y * e.d), this._currentLocalID = this._localID, this._parentID = -1), this._parentID !== t._worldID) {
      const n = t.worldTransform, r = this.worldTransform;
      r.a = e.a * n.a + e.b * n.c, r.b = e.a * n.b + e.b * n.d, r.c = e.c * n.a + e.d * n.c, r.d = e.c * n.b + e.d * n.d, r.tx = e.tx * n.a + e.ty * n.c + n.tx, r.ty = e.tx * n.b + e.ty * n.d + n.ty, this._parentID = t._worldID, this._worldID++;
    }
  }
  /**
   * Decomposes a matrix and sets the transforms properties based on it.
   * @param matrix - The matrix to decompose
   */
  setFromMatrix(t) {
    t.decompose(this), this._localID++;
  }
  /** The rotation of the object in radians. */
  get rotation() {
    return this._rotation;
  }
  set rotation(t) {
    this._rotation !== t && (this._rotation = t, this.updateSkew());
  }
};
aT.IDENTITY = new aT();
let SS = aT;
SS.prototype.toString = function() {
  return `[@pixi/math:Transform position=(${this.position.x}, ${this.position.y}) rotation=${this.rotation} scale=(${this.scale.x}, ${this.scale.y}) skew=(${this.skew.x}, ${this.skew.y}) ]`;
};
var j1e = `varying vec2 vTextureCoord;

uniform sampler2D uSampler;

void main(void){
   gl_FragColor *= texture2D(uSampler, vTextureCoord);
}`, z1e = `attribute vec2 aVertexPosition;
attribute vec2 aTextureCoord;

uniform mat3 projectionMatrix;

varying vec2 vTextureCoord;

void main(void){
   gl_Position = vec4((projectionMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);
   vTextureCoord = aTextureCoord;
}
`;
function PC(t, e, n) {
  const r = t.createShader(e);
  return t.shaderSource(r, n), t.compileShader(r), r;
}
function vb(t) {
  const e = new Array(t);
  for (let n = 0; n < e.length; n++)
    e[n] = !1;
  return e;
}
function cB(t, e) {
  switch (t) {
    case "float":
      return 0;
    case "vec2":
      return new Float32Array(2 * e);
    case "vec3":
      return new Float32Array(3 * e);
    case "vec4":
      return new Float32Array(4 * e);
    case "int":
    case "uint":
    case "sampler2D":
    case "sampler2DArray":
      return 0;
    case "ivec2":
      return new Int32Array(2 * e);
    case "ivec3":
      return new Int32Array(3 * e);
    case "ivec4":
      return new Int32Array(4 * e);
    case "uvec2":
      return new Uint32Array(2 * e);
    case "uvec3":
      return new Uint32Array(3 * e);
    case "uvec4":
      return new Uint32Array(4 * e);
    case "bool":
      return !1;
    case "bvec2":
      return vb(2 * e);
    case "bvec3":
      return vb(3 * e);
    case "bvec4":
      return vb(4 * e);
    case "mat2":
      return new Float32Array([
        1,
        0,
        0,
        1
      ]);
    case "mat3":
      return new Float32Array([
        1,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        1
      ]);
    case "mat4":
      return new Float32Array([
        1,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        1
      ]);
  }
  return null;
}
const Qd = [
  // a float cache layer
  {
    test: (t) => t.type === "float" && t.size === 1 && !t.isArray,
    code: (t) => `
            if(uv["${t}"] !== ud["${t}"].value)
            {
                ud["${t}"].value = uv["${t}"]
                gl.uniform1f(ud["${t}"].location, uv["${t}"])
            }
            `
  },
  // handling samplers
  {
    test: (t, e) => (
      // eslint-disable-next-line max-len,no-eq-null,eqeqeq
      (t.type === "sampler2D" || t.type === "samplerCube" || t.type === "sampler2DArray") && t.size === 1 && !t.isArray && (e == null || e.castToBaseTexture !== void 0)
    ),
    code: (t) => `t = syncData.textureCount++;

            renderer.texture.bind(uv["${t}"], t);

            if(ud["${t}"].value !== t)
            {
                ud["${t}"].value = t;
                gl.uniform1i(ud["${t}"].location, t);
; // eslint-disable-line max-len
            }`
  },
  // uploading pixi matrix object to mat3
  {
    test: (t, e) => t.type === "mat3" && t.size === 1 && !t.isArray && e.a !== void 0,
    code: (t) => (
      // TODO and some smart caching dirty ids here!
      `
            gl.uniformMatrix3fv(ud["${t}"].location, false, uv["${t}"].toArray(true));
            `
    ),
    codeUbo: (t) => `
                var ${t}_matrix = uv.${t}.toArray(true);

                data[offset] = ${t}_matrix[0];
                data[offset+1] = ${t}_matrix[1];
                data[offset+2] = ${t}_matrix[2];
        
                data[offset + 4] = ${t}_matrix[3];
                data[offset + 5] = ${t}_matrix[4];
                data[offset + 6] = ${t}_matrix[5];
        
                data[offset + 8] = ${t}_matrix[6];
                data[offset + 9] = ${t}_matrix[7];
                data[offset + 10] = ${t}_matrix[8];
            `
  },
  // uploading a pixi point as a vec2 with caching layer
  {
    test: (t, e) => t.type === "vec2" && t.size === 1 && !t.isArray && e.x !== void 0,
    code: (t) => `
                cv = ud["${t}"].value;
                v = uv["${t}"];

                if(cv[0] !== v.x || cv[1] !== v.y)
                {
                    cv[0] = v.x;
                    cv[1] = v.y;
                    gl.uniform2f(ud["${t}"].location, v.x, v.y);
                }`,
    codeUbo: (t) => `
                v = uv.${t};

                data[offset] = v.x;
                data[offset+1] = v.y;
            `
  },
  // caching layer for a vec2
  {
    test: (t) => t.type === "vec2" && t.size === 1 && !t.isArray,
    code: (t) => `
                cv = ud["${t}"].value;
                v = uv["${t}"];

                if(cv[0] !== v[0] || cv[1] !== v[1])
                {
                    cv[0] = v[0];
                    cv[1] = v[1];
                    gl.uniform2f(ud["${t}"].location, v[0], v[1]);
                }
            `
  },
  // upload a pixi rectangle as a vec4 with caching layer
  {
    test: (t, e) => t.type === "vec4" && t.size === 1 && !t.isArray && e.width !== void 0,
    code: (t) => `
                cv = ud["${t}"].value;
                v = uv["${t}"];

                if(cv[0] !== v.x || cv[1] !== v.y || cv[2] !== v.width || cv[3] !== v.height)
                {
                    cv[0] = v.x;
                    cv[1] = v.y;
                    cv[2] = v.width;
                    cv[3] = v.height;
                    gl.uniform4f(ud["${t}"].location, v.x, v.y, v.width, v.height)
                }`,
    codeUbo: (t) => `
                    v = uv.${t};

                    data[offset] = v.x;
                    data[offset+1] = v.y;
                    data[offset+2] = v.width;
                    data[offset+3] = v.height;
                `
  },
  // upload a pixi color as vec4 with caching layer
  {
    test: (t, e) => t.type === "vec4" && t.size === 1 && !t.isArray && e.red !== void 0,
    code: (t) => `
                cv = ud["${t}"].value;
                v = uv["${t}"];

                if(cv[0] !== v.red || cv[1] !== v.green || cv[2] !== v.blue || cv[3] !== v.alpha)
                {
                    cv[0] = v.red;
                    cv[1] = v.green;
                    cv[2] = v.blue;
                    cv[3] = v.alpha;
                    gl.uniform4f(ud["${t}"].location, v.red, v.green, v.blue, v.alpha)
                }`,
    codeUbo: (t) => `
                    v = uv.${t};

                    data[offset] = v.red;
                    data[offset+1] = v.green;
                    data[offset+2] = v.blue;
                    data[offset+3] = v.alpha;
                `
  },
  // upload a pixi color as a vec3 with caching layer
  {
    test: (t, e) => t.type === "vec3" && t.size === 1 && !t.isArray && e.red !== void 0,
    code: (t) => `
                cv = ud["${t}"].value;
                v = uv["${t}"];

                if(cv[0] !== v.red || cv[1] !== v.green || cv[2] !== v.blue || cv[3] !== v.a)
                {
                    cv[0] = v.red;
                    cv[1] = v.green;
                    cv[2] = v.blue;
    
                    gl.uniform3f(ud["${t}"].location, v.red, v.green, v.blue)
                }`,
    codeUbo: (t) => `
                    v = uv.${t};

                    data[offset] = v.red;
                    data[offset+1] = v.green;
                    data[offset+2] = v.blue;
                `
  },
  // a caching layer for vec4 uploading
  {
    test: (t) => t.type === "vec4" && t.size === 1 && !t.isArray,
    code: (t) => `
                cv = ud["${t}"].value;
                v = uv["${t}"];

                if(cv[0] !== v[0] || cv[1] !== v[1] || cv[2] !== v[2] || cv[3] !== v[3])
                {
                    cv[0] = v[0];
                    cv[1] = v[1];
                    cv[2] = v[2];
                    cv[3] = v[3];

                    gl.uniform4f(ud["${t}"].location, v[0], v[1], v[2], v[3])
                }`
  }
], q1e = {
  float: `
    if (cv !== v)
    {
        cu.value = v;
        gl.uniform1f(location, v);
    }`,
  vec2: `
    if (cv[0] !== v[0] || cv[1] !== v[1])
    {
        cv[0] = v[0];
        cv[1] = v[1];

        gl.uniform2f(location, v[0], v[1])
    }`,
  vec3: `
    if (cv[0] !== v[0] || cv[1] !== v[1] || cv[2] !== v[2])
    {
        cv[0] = v[0];
        cv[1] = v[1];
        cv[2] = v[2];

        gl.uniform3f(location, v[0], v[1], v[2])
    }`,
  vec4: `
    if (cv[0] !== v[0] || cv[1] !== v[1] || cv[2] !== v[2] || cv[3] !== v[3])
    {
        cv[0] = v[0];
        cv[1] = v[1];
        cv[2] = v[2];
        cv[3] = v[3];

        gl.uniform4f(location, v[0], v[1], v[2], v[3]);
    }`,
  int: `
    if (cv !== v)
    {
        cu.value = v;

        gl.uniform1i(location, v);
    }`,
  ivec2: `
    if (cv[0] !== v[0] || cv[1] !== v[1])
    {
        cv[0] = v[0];
        cv[1] = v[1];

        gl.uniform2i(location, v[0], v[1]);
    }`,
  ivec3: `
    if (cv[0] !== v[0] || cv[1] !== v[1] || cv[2] !== v[2])
    {
        cv[0] = v[0];
        cv[1] = v[1];
        cv[2] = v[2];

        gl.uniform3i(location, v[0], v[1], v[2]);
    }`,
  ivec4: `
    if (cv[0] !== v[0] || cv[1] !== v[1] || cv[2] !== v[2] || cv[3] !== v[3])
    {
        cv[0] = v[0];
        cv[1] = v[1];
        cv[2] = v[2];
        cv[3] = v[3];

        gl.uniform4i(location, v[0], v[1], v[2], v[3]);
    }`,
  uint: `
    if (cv !== v)
    {
        cu.value = v;

        gl.uniform1ui(location, v);
    }`,
  uvec2: `
    if (cv[0] !== v[0] || cv[1] !== v[1])
    {
        cv[0] = v[0];
        cv[1] = v[1];

        gl.uniform2ui(location, v[0], v[1]);
    }`,
  uvec3: `
    if (cv[0] !== v[0] || cv[1] !== v[1] || cv[2] !== v[2])
    {
        cv[0] = v[0];
        cv[1] = v[1];
        cv[2] = v[2];

        gl.uniform3ui(location, v[0], v[1], v[2]);
    }`,
  uvec4: `
    if (cv[0] !== v[0] || cv[1] !== v[1] || cv[2] !== v[2] || cv[3] !== v[3])
    {
        cv[0] = v[0];
        cv[1] = v[1];
        cv[2] = v[2];
        cv[3] = v[3];

        gl.uniform4ui(location, v[0], v[1], v[2], v[3]);
    }`,
  bool: `
    if (cv !== v)
    {
        cu.value = v;
        gl.uniform1i(location, v);
    }`,
  bvec2: `
    if (cv[0] != v[0] || cv[1] != v[1])
    {
        cv[0] = v[0];
        cv[1] = v[1];

        gl.uniform2i(location, v[0], v[1]);
    }`,
  bvec3: `
    if (cv[0] !== v[0] || cv[1] !== v[1] || cv[2] !== v[2])
    {
        cv[0] = v[0];
        cv[1] = v[1];
        cv[2] = v[2];

        gl.uniform3i(location, v[0], v[1], v[2]);
    }`,
  bvec4: `
    if (cv[0] !== v[0] || cv[1] !== v[1] || cv[2] !== v[2] || cv[3] !== v[3])
    {
        cv[0] = v[0];
        cv[1] = v[1];
        cv[2] = v[2];
        cv[3] = v[3];

        gl.uniform4i(location, v[0], v[1], v[2], v[3]);
    }`,
  mat2: "gl.uniformMatrix2fv(location, false, v)",
  mat3: "gl.uniformMatrix3fv(location, false, v)",
  mat4: "gl.uniformMatrix4fv(location, false, v)",
  sampler2D: `
    if (cv !== v)
    {
        cu.value = v;

        gl.uniform1i(location, v);
    }`,
  samplerCube: `
    if (cv !== v)
    {
        cu.value = v;

        gl.uniform1i(location, v);
    }`,
  sampler2DArray: `
    if (cv !== v)
    {
        cu.value = v;

        gl.uniform1i(location, v);
    }`
}, G1e = {
  float: "gl.uniform1fv(location, v)",
  vec2: "gl.uniform2fv(location, v)",
  vec3: "gl.uniform3fv(location, v)",
  vec4: "gl.uniform4fv(location, v)",
  mat4: "gl.uniformMatrix4fv(location, false, v)",
  mat3: "gl.uniformMatrix3fv(location, false, v)",
  mat2: "gl.uniformMatrix2fv(location, false, v)",
  int: "gl.uniform1iv(location, v)",
  ivec2: "gl.uniform2iv(location, v)",
  ivec3: "gl.uniform3iv(location, v)",
  ivec4: "gl.uniform4iv(location, v)",
  uint: "gl.uniform1uiv(location, v)",
  uvec2: "gl.uniform2uiv(location, v)",
  uvec3: "gl.uniform3uiv(location, v)",
  uvec4: "gl.uniform4uiv(location, v)",
  bool: "gl.uniform1iv(location, v)",
  bvec2: "gl.uniform2iv(location, v)",
  bvec3: "gl.uniform3iv(location, v)",
  bvec4: "gl.uniform4iv(location, v)",
  sampler2D: "gl.uniform1iv(location, v)",
  samplerCube: "gl.uniform1iv(location, v)",
  sampler2DArray: "gl.uniform1iv(location, v)"
};
function Y1e(t, e) {
  const n = [`
        var v = null;
        var cv = null;
        var cu = null;
        var t = 0;
        var gl = renderer.gl;
    `];
  for (const r in t.uniforms) {
    const o = e[r];
    if (!o) {
      t.uniforms[r]?.group === !0 && (t.uniforms[r].ubo ? n.push(`
                        renderer.shader.syncUniformBufferGroup(uv.${r}, '${r}');
                    `) : n.push(`
                        renderer.shader.syncUniformGroup(uv.${r}, syncData);
                    `));
      continue;
    }
    const s = t.uniforms[r];
    let i = !1;
    for (let u = 0; u < Qd.length; u++)
      if (Qd[u].test(o, s)) {
        n.push(Qd[u].code(r, s)), i = !0;
        break;
      }
    if (!i) {
      const u = (o.size === 1 && !o.isArray ? q1e : G1e)[o.type].replace("location", `ud["${r}"].location`);
      n.push(`
            cu = ud["${r}"];
            cv = cu.value;
            v = uv["${r}"];
            ${u};`);
    }
  }
  return new Function("ud", "uv", "renderer", "syncData", n.join(`
`));
}
const pB = {};
let gg = pB;
function Q1e() {
  if (gg === pB || gg?.isContextLost()) {
    const t = at.ADAPTER.createCanvas();
    let e;
    at.PREFER_ENV >= nd.WEBGL2 && (e = t.getContext("webgl2", {})), e || (e = t.getContext("webgl", {}) || t.getContext("experimental-webgl", {}), e ? e.getExtension("WEBGL_draw_buffers") : e = null), gg = e;
  }
  return gg;
}
let vg;
function K1e() {
  if (!vg) {
    vg = Ra.MEDIUM;
    const t = Q1e();
    if (t && t.getShaderPrecisionFormat) {
      const e = t.getShaderPrecisionFormat(t.FRAGMENT_SHADER, t.HIGH_FLOAT);
      e && (vg = e.precision ? Ra.HIGH : Ra.MEDIUM);
    }
  }
  return vg;
}
function CC(t, e) {
  const n = t.getShaderSource(e).split(`
`).map((a, c) => `${c}: ${a}`), r = t.getShaderInfoLog(e), o = r.split(`
`), s = {}, i = o.map((a) => parseFloat(a.replace(/^ERROR\: 0\:([\d]+)\:.*$/, "$1"))).filter((a) => a && !s[a] ? (s[a] = !0, !0) : !1), u = [""];
  i.forEach((a) => {
    n[a - 1] = `%c${n[a - 1]}%c`, u.push("background: #FF0000; color:#FFFFFF; font-size: 10px", "font-size: 10px");
  });
  const l = n.join(`
`);
  u[0] = l, console.error(r), console.groupCollapsed("click to view full shader code"), console.warn(...u), console.groupEnd();
}
function Z1e(t, e, n, r) {
  t.getProgramParameter(e, t.LINK_STATUS) || (t.getShaderParameter(n, t.COMPILE_STATUS) || CC(t, n), t.getShaderParameter(r, t.COMPILE_STATUS) || CC(t, r), console.error("PixiJS Error: Could not initialize shader."), t.getProgramInfoLog(e) !== "" && console.warn("PixiJS Warning: gl.getProgramInfoLog()", t.getProgramInfoLog(e)));
}
const J1e = {
  float: 1,
  vec2: 2,
  vec3: 3,
  vec4: 4,
  int: 1,
  ivec2: 2,
  ivec3: 3,
  ivec4: 4,
  uint: 1,
  uvec2: 2,
  uvec3: 3,
  uvec4: 4,
  bool: 1,
  bvec2: 2,
  bvec3: 3,
  bvec4: 4,
  mat2: 4,
  mat3: 9,
  mat4: 16,
  sampler2D: 1
};
function dB(t) {
  return J1e[t];
}
let _g = null;
const OC = {
  FLOAT: "float",
  FLOAT_VEC2: "vec2",
  FLOAT_VEC3: "vec3",
  FLOAT_VEC4: "vec4",
  INT: "int",
  INT_VEC2: "ivec2",
  INT_VEC3: "ivec3",
  INT_VEC4: "ivec4",
  UNSIGNED_INT: "uint",
  UNSIGNED_INT_VEC2: "uvec2",
  UNSIGNED_INT_VEC3: "uvec3",
  UNSIGNED_INT_VEC4: "uvec4",
  BOOL: "bool",
  BOOL_VEC2: "bvec2",
  BOOL_VEC3: "bvec3",
  BOOL_VEC4: "bvec4",
  FLOAT_MAT2: "mat2",
  FLOAT_MAT3: "mat3",
  FLOAT_MAT4: "mat4",
  SAMPLER_2D: "sampler2D",
  INT_SAMPLER_2D: "sampler2D",
  UNSIGNED_INT_SAMPLER_2D: "sampler2D",
  SAMPLER_CUBE: "samplerCube",
  INT_SAMPLER_CUBE: "samplerCube",
  UNSIGNED_INT_SAMPLER_CUBE: "samplerCube",
  SAMPLER_2D_ARRAY: "sampler2DArray",
  INT_SAMPLER_2D_ARRAY: "sampler2DArray",
  UNSIGNED_INT_SAMPLER_2D_ARRAY: "sampler2DArray"
};
function hB(t, e) {
  if (!_g) {
    const n = Object.keys(OC);
    _g = {};
    for (let r = 0; r < n.length; ++r) {
      const o = n[r];
      _g[t[o]] = OC[o];
    }
  }
  return _g[e];
}
function IC(t, e, n) {
  if (t.substring(0, 9) !== "precision") {
    let r = e;
    return e === Ra.HIGH && n !== Ra.HIGH && (r = Ra.MEDIUM), `precision ${r} float;
${t}`;
  } else if (n !== Ra.HIGH && t.substring(0, 15) === "precision highp")
    return t.replace("precision highp", "precision mediump");
  return t;
}
let vf;
function ebe() {
  if (typeof vf == "boolean")
    return vf;
  try {
    vf = new Function("param1", "param2", "param3", "return param1[param2] === param3;")({ a: "b" }, "a", "b") === !0;
  } catch {
    vf = !1;
  }
  return vf;
}
let tbe = 0;
const wg = {}, iT = class Cd {
  /**
   * @param vertexSrc - The source of the vertex shader.
   * @param fragmentSrc - The source of the fragment shader.
   * @param name - Name for shader
   * @param extra - Extra data for shader
   */
  constructor(e, n, r = "pixi-shader", o = {}) {
    this.extra = {}, this.id = tbe++, this.vertexSrc = e || Cd.defaultVertexSrc, this.fragmentSrc = n || Cd.defaultFragmentSrc, this.vertexSrc = this.vertexSrc.trim(), this.fragmentSrc = this.fragmentSrc.trim(), this.extra = o, this.vertexSrc.substring(0, 8) !== "#version" && (r = r.replace(/\s+/g, "-"), wg[r] ? (wg[r]++, r += `-${wg[r]}`) : wg[r] = 1, this.vertexSrc = `#define SHADER_NAME ${r}
${this.vertexSrc}`, this.fragmentSrc = `#define SHADER_NAME ${r}
${this.fragmentSrc}`, this.vertexSrc = IC(
      this.vertexSrc,
      Cd.defaultVertexPrecision,
      Ra.HIGH
    ), this.fragmentSrc = IC(
      this.fragmentSrc,
      Cd.defaultFragmentPrecision,
      K1e()
    )), this.glPrograms = {}, this.syncUniforms = null;
  }
  /**
   * The default vertex shader source.
   * @readonly
   */
  static get defaultVertexSrc() {
    return z1e;
  }
  /**
   * The default fragment shader source.
   * @readonly
   */
  static get defaultFragmentSrc() {
    return j1e;
  }
  /**
   * A short hand function to create a program based of a vertex and fragment shader.
   *
   * This method will also check to see if there is a cached program.
   * @param vertexSrc - The source of the vertex shader.
   * @param fragmentSrc - The source of the fragment shader.
   * @param name - Name for shader
   * @returns A shiny new PixiJS shader program!
   */
  static from(e, n, r) {
    const o = e + n;
    let s = RC[o];
    return s || (RC[o] = s = new Cd(e, n, r)), s;
  }
};
iT.defaultVertexPrecision = Ra.HIGH, /**
* Default specify float precision in fragment shader.
* iOS is best set at highp due to https://github.com/pixijs/pixijs/issues/3742
* @static
* @type {PIXI.PRECISION}
* @default PIXI.PRECISION.MEDIUM
*/
iT.defaultFragmentPrecision = Gu.apple.device ? Ra.HIGH : Ra.MEDIUM;
let Qu = iT, nbe = 0;
class di {
  /**
   * @param {object | Buffer} [uniforms] - Custom uniforms to use to augment the built-in ones. Or a pixi buffer.
   * @param isStatic - Uniforms wont be changed after creation.
   * @param isUbo - If true, will treat this uniform group as a uniform buffer object.
   */
  constructor(e, n, r) {
    this.group = !0, this.syncUniforms = {}, this.dirtyId = 0, this.id = nbe++, this.static = !!n, this.ubo = !!r, e instanceof Fr ? (this.buffer = e, this.buffer.type = au.UNIFORM_BUFFER, this.autoManage = !1, this.ubo = !0) : (this.uniforms = e, this.ubo && (this.buffer = new Fr(new Float32Array(1)), this.buffer.type = au.UNIFORM_BUFFER, this.autoManage = !0));
  }
  update() {
    this.dirtyId++, !this.autoManage && this.buffer && this.buffer.update();
  }
  add(e, n, r) {
    if (!this.ubo)
      this.uniforms[e] = new di(n, r);
    else
      throw new Error("[UniformGroup] uniform groups in ubo mode cannot be modified, or have uniform groups nested in them");
  }
  static from(e, n, r) {
    return new di(e, n, r);
  }
  /**
   * A short hand function for creating a static UBO UniformGroup.
   * @param uniforms - the ubo item
   * @param _static - should this be updated each time it is used? defaults to true here!
   */
  static uboFrom(e, n) {
    return new di(e, n ?? !0, !0);
  }
}
class iu {
  /**
   * @param program - The program the shader will use.
   * @param uniforms - Custom uniforms to use to augment the built-in ones.
   */
  constructor(e, n) {
    this.uniformBindCount = 0, this.program = e, n ? n instanceof di ? this.uniformGroup = n : this.uniformGroup = new di(n) : this.uniformGroup = new di({}), this.disposeRunner = new pi("disposeShader");
  }
  // TODO move to shader system..
  checkUniformExists(e, n) {
    if (n.uniforms[e])
      return !0;
    for (const r in n.uniforms) {
      const o = n.uniforms[r];
      if (o.group === !0 && this.checkUniformExists(e, o))
        return !0;
    }
    return !1;
  }
  destroy() {
    this.uniformGroup = null, this.disposeRunner.emit(this), this.disposeRunner.destroy();
  }
  /**
   * Shader uniform values, shortcut for `uniformGroup.uniforms`.
   * @readonly
   */
  get uniforms() {
    return this.uniformGroup.uniforms;
  }
  /**
   * A short hand function to create a shader based of a vertex and fragment shader.
   * @param vertexSrc - The source of the vertex shader.
   * @param fragmentSrc - The source of the fragment shader.
   * @param uniforms - Custom uniforms to use to augment the built-in ones.
   * @returns A shiny new PixiJS shader!
   */
  static from(e, n, r) {
    const o = Qu.from(e, n);
    return new iu(o, r);
  }
}
class rbe {
  /**
   * @param vertexSrc - Vertex shader
   * @param fragTemplate - Fragment shader template
   */
  constructor(e, n) {
    if (this.vertexSrc = e, this.fragTemplate = n, this.programCache = {}, this.defaultGroupCache = {}, !n.includes("%count%"))
      throw new Error('Fragment template must contain "%count%".');
    if (!n.includes("%forloop%"))
      throw new Error('Fragment template must contain "%forloop%".');
  }
  generateShader(e) {
    if (!this.programCache[e]) {
      const r = new Int32Array(e);
      for (let s = 0; s < e; s++)
        r[s] = s;
      this.defaultGroupCache[e] = di.from({ uSamplers: r }, !0);
      let o = this.fragTemplate;
      o = o.replace(/%count%/gi, `${e}`), o = o.replace(/%forloop%/gi, this.generateSampleSrc(e)), this.programCache[e] = new Qu(this.vertexSrc, o);
    }
    const n = {
      tint: new Float32Array([1, 1, 1, 1]),
      translationMatrix: new Qn(),
      default: this.defaultGroupCache[e]
    };
    return new iu(this.programCache[e], n);
  }
  generateSampleSrc(e) {
    let n = "";
    n += `
`, n += `
`;
    for (let r = 0; r < e; r++)
      r > 0 && (n += `
else `), r < e - 1 && (n += `if(vTextureId < ${r}.5)`), n += `
{`, n += `
	color = texture2D(uSamplers[${r}], vTextureCoord);`, n += `
}`;
    return n += `
`, n += `
`, n;
  }
}
class uT {
  constructor() {
    this.elements = [], this.ids = [], this.count = 0;
  }
  clear() {
    for (let e = 0; e < this.count; e++)
      this.elements[e] = null;
    this.count = 0;
  }
}
function obe() {
  return !Gu.apple.device;
}
function sbe(t) {
  let e = !0;
  const n = at.ADAPTER.getNavigator();
  if (Gu.tablet || Gu.phone) {
    if (Gu.apple.device) {
      const r = n.userAgent.match(/OS (\d+)_(\d+)?/);
      r && parseInt(r[1], 10) < 11 && (e = !1);
    }
    if (Gu.android.device) {
      const r = n.userAgent.match(/Android\s([0-9.]*)/);
      r && parseInt(r[1], 10) < 7 && (e = !1);
    }
  }
  return e ? t : 4;
}
class H_ {
  /**
   * @param renderer - The renderer this manager works for.
   */
  constructor(e) {
    this.renderer = e;
  }
  /** Stub method that should be used to empty the current batch by rendering objects now. */
  flush() {
  }
  /** Generic destruction method that frees all resources. This should be called by subclasses. */
  destroy() {
    this.renderer = null;
  }
  /**
   * Stub method that initializes any state required before
   * rendering starts. It is different from the `prerender`
   * signal, which occurs every frame, in that it is called
   * whenever an object requests _this_ renderer specifically.
   */
  start() {
  }
  /** Stops the renderer. It should free up any state and become dormant. */
  stop() {
    this.flush();
  }
  /**
   * Keeps the object to render. It doesn't have to be
   * rendered immediately.
   * @param {PIXI.DisplayObject} _object - The object to render.
   */
  render(e) {
  }
}
var abe = `varying vec2 vTextureCoord;
varying vec4 vColor;
varying float vTextureId;
uniform sampler2D uSamplers[%count%];

void main(void){
    vec4 color;
    %forloop%
    gl_FragColor = color * vColor;
}
`, ibe = `precision highp float;
attribute vec2 aVertexPosition;
attribute vec2 aTextureCoord;
attribute vec4 aColor;
attribute float aTextureId;

uniform mat3 projectionMatrix;
uniform mat3 translationMatrix;
uniform vec4 tint;

varying vec2 vTextureCoord;
varying vec4 vColor;
varying float vTextureId;

void main(void){
    gl_Position = vec4((projectionMatrix * translationMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);

    vTextureCoord = aTextureCoord;
    vTextureId = aTextureId;
    vColor = aColor * tint;
}
`;
const Lf = class ti extends H_ {
  /**
   * This will hook onto the renderer's `contextChange`
   * and `prerender` signals.
   * @param {PIXI.Renderer} renderer - The renderer this works for.
   */
  constructor(e) {
    super(e), this.setShaderGenerator(), this.geometryClass = uB, this.vertexSize = 6, this.state = _u.for2d(), this.size = ti.defaultBatchSize * 4, this._vertexCount = 0, this._indexCount = 0, this._bufferedElements = [], this._bufferedTextures = [], this._bufferSize = 0, this._shader = null, this._packedGeometries = [], this._packedGeometryPoolSize = 2, this._flushId = 0, this._aBuffers = {}, this._iBuffers = {}, this.maxTextures = 1, this.renderer.on("prerender", this.onPrerender, this), e.runners.contextChange.add(this), this._dcIndex = 0, this._aIndex = 0, this._iIndex = 0, this._attributeBuffer = null, this._indexBuffer = null, this._tempBoundTextures = [];
  }
  /**
   * The maximum textures that this device supports.
   * @static
   * @default 32
   */
  static get defaultMaxTextures() {
    return this._defaultMaxTextures = this._defaultMaxTextures ?? sbe(32), this._defaultMaxTextures;
  }
  static set defaultMaxTextures(e) {
    this._defaultMaxTextures = e;
  }
  /**
   * Can we upload the same buffer in a single frame?
   * @static
   */
  static get canUploadSameBuffer() {
    return this._canUploadSameBuffer = this._canUploadSameBuffer ?? obe(), this._canUploadSameBuffer;
  }
  static set canUploadSameBuffer(e) {
    this._canUploadSameBuffer = e;
  }
  /**
   * @see PIXI.BatchRenderer#maxTextures
   * @deprecated since 7.1.0
   * @readonly
   */
  get MAX_TEXTURES() {
    return un("7.1.0", "BatchRenderer#MAX_TEXTURES renamed to BatchRenderer#maxTextures"), this.maxTextures;
  }
  /**
   * The default vertex shader source
   * @readonly
   */
  static get defaultVertexSrc() {
    return ibe;
  }
  /**
   * The default fragment shader source
   * @readonly
   */
  static get defaultFragmentTemplate() {
    return abe;
  }
  /**
   * Set the shader generator.
   * @param {object} [options]
   * @param {string} [options.vertex=PIXI.BatchRenderer.defaultVertexSrc] - Vertex shader source
   * @param {string} [options.fragment=PIXI.BatchRenderer.defaultFragmentTemplate] - Fragment shader template
   */
  setShaderGenerator({
    vertex: e = ti.defaultVertexSrc,
    fragment: n = ti.defaultFragmentTemplate
  } = {}) {
    this.shaderGenerator = new rbe(e, n);
  }
  /**
   * Handles the `contextChange` signal.
   *
   * It calculates `this.maxTextures` and allocating the packed-geometry object pool.
   */
  contextChange() {
    const e = this.renderer.gl;
    at.PREFER_ENV === nd.WEBGL_LEGACY ? this.maxTextures = 1 : (this.maxTextures = Math.min(
      e.getParameter(e.MAX_TEXTURE_IMAGE_UNITS),
      ti.defaultMaxTextures
    ), this.maxTextures = N1e(
      this.maxTextures,
      e
    )), this._shader = this.shaderGenerator.generateShader(this.maxTextures);
    for (let n = 0; n < this._packedGeometryPoolSize; n++)
      this._packedGeometries[n] = new this.geometryClass();
    this.initFlushBuffers();
  }
  /** Makes sure that static and dynamic flush pooled objects have correct dimensions. */
  initFlushBuffers() {
    const {
      _drawCallPool: e,
      _textureArrayPool: n
    } = ti, r = this.size / 4, o = Math.floor(r / this.maxTextures) + 1;
    for (; e.length < r; )
      e.push(new rT());
    for (; n.length < o; )
      n.push(new uT());
    for (let s = 0; s < this.maxTextures; s++)
      this._tempBoundTextures[s] = null;
  }
  /** Handles the `prerender` signal. It ensures that flushes start from the first geometry object again. */
  onPrerender() {
    this._flushId = 0;
  }
  /**
   * Buffers the "batchable" object. It need not be rendered immediately.
   * @param {PIXI.DisplayObject} element - the element to render when
   *    using this renderer
   */
  render(e) {
    e._texture.valid && (this._vertexCount + e.vertexData.length / 2 > this.size && this.flush(), this._vertexCount += e.vertexData.length / 2, this._indexCount += e.indices.length, this._bufferedTextures[this._bufferSize] = e._texture.baseTexture, this._bufferedElements[this._bufferSize++] = e);
  }
  buildTexturesAndDrawCalls() {
    const {
      _bufferedTextures: e,
      maxTextures: n
    } = this, r = ti._textureArrayPool, o = this.renderer.batch, s = this._tempBoundTextures, i = this.renderer.textureGC.count;
    let u = ++qt._globalBatch, l = 0, a = r[0], c = 0;
    o.copyBoundTextures(s, n);
    for (let p = 0; p < this._bufferSize; ++p) {
      const d = e[p];
      e[p] = null, d._batchEnabled !== u && (a.count >= n && (o.boundArray(a, s, u, n), this.buildDrawCalls(a, c, p), c = p, a = r[++l], ++u), d._batchEnabled = u, d.touched = i, a.elements[a.count++] = d);
    }
    a.count > 0 && (o.boundArray(a, s, u, n), this.buildDrawCalls(a, c, this._bufferSize), ++l, ++u);
    for (let p = 0; p < s.length; p++)
      s[p] = null;
    qt._globalBatch = u;
  }
  /**
   * Populating drawcalls for rendering
   * @param texArray
   * @param start
   * @param finish
   */
  buildDrawCalls(e, n, r) {
    const {
      _bufferedElements: o,
      _attributeBuffer: s,
      _indexBuffer: i,
      vertexSize: u
    } = this, l = ti._drawCallPool;
    let a = this._dcIndex, c = this._aIndex, p = this._iIndex, d = l[a];
    d.start = this._iIndex, d.texArray = e;
    for (let h = n; h < r; ++h) {
      const m = o[h], g = m._texture.baseTexture, _ = oB[g.alphaMode ? 1 : 0][m.blendMode];
      o[h] = null, n < h && d.blend !== _ && (d.size = p - d.start, n = h, d = l[++a], d.texArray = e, d.start = p), this.packInterleavedGeometry(m, s, i, c, p), c += m.vertexData.length / 2 * u, p += m.indices.length, d.blend = _;
    }
    n < r && (d.size = p - d.start, ++a), this._dcIndex = a, this._aIndex = c, this._iIndex = p;
  }
  /**
   * Bind textures for current rendering
   * @param texArray
   */
  bindAndClearTexArray(e) {
    const n = this.renderer.texture;
    for (let r = 0; r < e.count; r++)
      n.bind(e.elements[r], e.ids[r]), e.elements[r] = null;
    e.count = 0;
  }
  updateGeometry() {
    const {
      _packedGeometries: e,
      _attributeBuffer: n,
      _indexBuffer: r
    } = this;
    ti.canUploadSameBuffer ? (e[this._flushId]._buffer.update(n.rawBinaryData), e[this._flushId]._indexBuffer.update(r), this.renderer.geometry.updateBuffers()) : (this._packedGeometryPoolSize <= this._flushId && (this._packedGeometryPoolSize++, e[this._flushId] = new this.geometryClass()), e[this._flushId]._buffer.update(n.rawBinaryData), e[this._flushId]._indexBuffer.update(r), this.renderer.geometry.bind(e[this._flushId]), this.renderer.geometry.updateBuffers(), this._flushId++);
  }
  drawBatches() {
    const e = this._dcIndex, { gl: n, state: r } = this.renderer, o = ti._drawCallPool;
    let s = null;
    for (let i = 0; i < e; i++) {
      const { texArray: u, type: l, size: a, start: c, blend: p } = o[i];
      s !== u && (s = u, this.bindAndClearTexArray(u)), this.state.blendMode = p, r.set(this.state), n.drawElements(l, a, n.UNSIGNED_SHORT, c * 2);
    }
  }
  /** Renders the content _now_ and empties the current batch. */
  flush() {
    this._vertexCount !== 0 && (this._attributeBuffer = this.getAttributeBuffer(this._vertexCount), this._indexBuffer = this.getIndexBuffer(this._indexCount), this._aIndex = 0, this._iIndex = 0, this._dcIndex = 0, this.buildTexturesAndDrawCalls(), this.updateGeometry(), this.drawBatches(), this._bufferSize = 0, this._vertexCount = 0, this._indexCount = 0);
  }
  /** Starts a new sprite batch. */
  start() {
    this.renderer.state.set(this.state), this.renderer.texture.ensureSamplerType(this.maxTextures), this.renderer.shader.bind(this._shader), ti.canUploadSameBuffer && this.renderer.geometry.bind(this._packedGeometries[this._flushId]);
  }
  /** Stops and flushes the current batch. */
  stop() {
    this.flush();
  }
  /** Destroys this `BatchRenderer`. It cannot be used again. */
  destroy() {
    for (let e = 0; e < this._packedGeometryPoolSize; e++)
      this._packedGeometries[e] && this._packedGeometries[e].destroy();
    this.renderer.off("prerender", this.onPrerender, this), this._aBuffers = null, this._iBuffers = null, this._packedGeometries = null, this._attributeBuffer = null, this._indexBuffer = null, this._shader && (this._shader.destroy(), this._shader = null), super.destroy();
  }
  /**
   * Fetches an attribute buffer from `this._aBuffers` that can hold atleast `size` floats.
   * @param size - minimum capacity required
   * @returns - buffer than can hold atleast `size` floats
   */
  getAttributeBuffer(e) {
    const n = rv(Math.ceil(e / 8)), r = xC(n), o = n * 8;
    this._aBuffers.length <= r && (this._iBuffers.length = r + 1);
    let s = this._aBuffers[o];
    return s || (this._aBuffers[o] = s = new eT(o * this.vertexSize * 4)), s;
  }
  /**
   * Fetches an index buffer from `this._iBuffers` that can
   * have at least `size` capacity.
   * @param size - minimum required capacity
   * @returns - buffer that can fit `size` indices.
   */
  getIndexBuffer(e) {
    const n = rv(Math.ceil(e / 12)), r = xC(n), o = n * 12;
    this._iBuffers.length <= r && (this._iBuffers.length = r + 1);
    let s = this._iBuffers[r];
    return s || (this._iBuffers[r] = s = new Uint16Array(o)), s;
  }
  /**
   * Takes the four batching parameters of `element`, interleaves
   * and pushes them into the batching attribute/index buffers given.
   *
   * It uses these properties: `vertexData` `uvs`, `textureId` and
   * `indicies`. It also uses the "tint" of the base-texture, if
   * present.
   * @param {PIXI.DisplayObject} element - element being rendered
   * @param attributeBuffer - attribute buffer.
   * @param indexBuffer - index buffer
   * @param aIndex - number of floats already in the attribute buffer
   * @param iIndex - number of indices already in `indexBuffer`
   */
  packInterleavedGeometry(e, n, r, o, s) {
    const {
      uint32View: i,
      float32View: u
    } = n, l = o / this.vertexSize, a = e.uvs, c = e.indices, p = e.vertexData, d = e._texture.baseTexture._batchLocation, h = Math.min(e.worldAlpha, 1), m = Gn.shared.setValue(e._tintRGB).toPremultiplied(h, e._texture.baseTexture.alphaMode > 0);
    for (let g = 0; g < p.length; g += 2)
      u[o++] = p[g], u[o++] = p[g + 1], u[o++] = a[g], u[o++] = a[g + 1], i[o++] = m, u[o++] = d;
    for (let g = 0; g < c.length; g++)
      r[s++] = l + c[g];
  }
};
Lf.defaultBatchSize = 4096, /** @ignore */
Lf.extension = {
  name: "batch",
  type: rt.RendererPlugin
}, /**
* Pool of `BatchDrawCall` objects that `flush` used
* to create "batches" of the objects being rendered.
*
* These are never re-allocated again.
* Shared between all batch renderers because it can be only one "flush" working at the moment.
* @member {PIXI.BatchDrawCall[]}
*/
Lf._drawCallPool = [], /**
* Pool of `BatchDrawCall` objects that `flush` used
* to create "batches" of the objects being rendered.
*
* These are never re-allocated again.
* Shared between all batch renderers because it can be only one "flush" working at the moment.
* @member {PIXI.BatchTextureArray[]}
*/
Lf._textureArrayPool = [];
let ap = Lf;
dt.add(ap);
var ube = `varying vec2 vTextureCoord;

uniform sampler2D uSampler;

void main(void){
   gl_FragColor = texture2D(uSampler, vTextureCoord);
}
`, lbe = `attribute vec2 aVertexPosition;

uniform mat3 projectionMatrix;

varying vec2 vTextureCoord;

uniform vec4 inputSize;
uniform vec4 outputFrame;

vec4 filterVertexPosition( void )
{
    vec2 position = aVertexPosition * max(outputFrame.zw, vec2(0.)) + outputFrame.xy;

    return vec4((projectionMatrix * vec3(position, 1.0)).xy, 0.0, 1.0);
}

vec2 filterTextureCoord( void )
{
    return aVertexPosition * (outputFrame.zw * inputSize.zw);
}

void main(void)
{
    gl_Position = filterVertexPosition();
    vTextureCoord = filterTextureCoord();
}
`;
const lT = class Bf extends iu {
  /**
   * @param vertexSrc - The source of the vertex shader.
   * @param fragmentSrc - The source of the fragment shader.
   * @param uniforms - Custom uniforms to use to augment the built-in ones.
   */
  constructor(e, n, r) {
    const o = Qu.from(
      e || Bf.defaultVertexSrc,
      n || Bf.defaultFragmentSrc
    );
    super(o, r), this.padding = 0, this.resolution = Bf.defaultResolution, this.multisample = Bf.defaultMultisample, this.enabled = !0, this.autoFit = !0, this.state = new _u();
  }
  /**
   * Applies the filter
   * @param {PIXI.FilterSystem} filterManager - The renderer to retrieve the filter from
   * @param {PIXI.RenderTexture} input - The input render target.
   * @param {PIXI.RenderTexture} output - The target to output to.
   * @param {PIXI.CLEAR_MODES} [clearMode] - Should the output be cleared before rendering to it.
   * @param {object} [_currentState] - It's current state of filter.
   *        There are some useful properties in the currentState :
   *        target, filters, sourceFrame, destinationFrame, renderTarget, resolution
   */
  apply(e, n, r, o, s) {
    e.applyFilter(this, n, r, o);
  }
  /**
   * Sets the blend mode of the filter.
   * @default PIXI.BLEND_MODES.NORMAL
   */
  get blendMode() {
    return this.state.blendMode;
  }
  set blendMode(e) {
    this.state.blendMode = e;
  }
  /**
   * The resolution of the filter. Setting this to be lower will lower the quality but
   * increase the performance of the filter.
   * If set to `null` or `0`, the resolution of the current render target is used.
   * @default PIXI.Filter.defaultResolution
   */
  get resolution() {
    return this._resolution;
  }
  set resolution(e) {
    this._resolution = e;
  }
  /**
   * The default vertex shader source
   * @readonly
   */
  static get defaultVertexSrc() {
    return lbe;
  }
  /**
   * The default fragment shader source
   * @readonly
   */
  static get defaultFragmentSrc() {
    return ube;
  }
};
lT.defaultResolution = 1, /**
* Default filter samples for any filter.
* @static
* @type {PIXI.MSAA_QUALITY|null}
* @default PIXI.MSAA_QUALITY.NONE
*/
lT.defaultMultisample = jr.NONE;
let Jo = lT;
class av {
  constructor() {
    this.clearBeforeRender = !0, this._backgroundColor = new Gn(0), this.alpha = 1;
  }
  /**
   * initiates the background system
   * @param {PIXI.IRendererOptions} options - the options for the background colors
   */
  init(e) {
    this.clearBeforeRender = e.clearBeforeRender;
    const { backgroundColor: n, background: r, backgroundAlpha: o } = e, s = r ?? n;
    s !== void 0 && (this.color = s), this.alpha = o;
  }
  /**
   * The background color to fill if not transparent.
   * @member {PIXI.ColorSource}
   */
  get color() {
    return this._backgroundColor.value;
  }
  set color(e) {
    this._backgroundColor.setValue(e);
  }
  /**
   * The background color alpha. Setting this to 0 will make the canvas transparent.
   * @member {number}
   */
  get alpha() {
    return this._backgroundColor.alpha;
  }
  set alpha(e) {
    this._backgroundColor.setAlpha(e);
  }
  /** The background color object. */
  get backgroundColor() {
    return this._backgroundColor;
  }
  destroy() {
  }
}
av.defaultOptions = {
  /**
   * {@link PIXI.IRendererOptions.backgroundAlpha}
   * @default 1
   * @memberof PIXI.settings.RENDER_OPTIONS
   */
  backgroundAlpha: 1,
  /**
   * {@link PIXI.IRendererOptions.backgroundColor}
   * @default 0x000000
   * @memberof PIXI.settings.RENDER_OPTIONS
   */
  backgroundColor: 0,
  /**
   * {@link PIXI.IRendererOptions.clearBeforeRender}
   * @default true
   * @memberof PIXI.settings.RENDER_OPTIONS
   */
  clearBeforeRender: !0
}, /** @ignore */
av.extension = {
  type: [
    rt.RendererSystem,
    rt.CanvasRendererSystem
  ],
  name: "background"
};
dt.add(av);
class fB {
  /**
   * @param renderer - The renderer this System works for.
   */
  constructor(e) {
    this.renderer = e, this.emptyRenderer = new H_(e), this.currentRenderer = this.emptyRenderer;
  }
  /**
   * Changes the current renderer to the one given in parameter
   * @param objectRenderer - The object renderer to use.
   */
  setObjectRenderer(e) {
    this.currentRenderer !== e && (this.currentRenderer.stop(), this.currentRenderer = e, this.currentRenderer.start());
  }
  /**
   * This should be called if you wish to do some custom rendering
   * It will basically render anything that may be batched up such as sprites
   */
  flush() {
    this.setObjectRenderer(this.emptyRenderer);
  }
  /** Reset the system to an empty renderer */
  reset() {
    this.setObjectRenderer(this.emptyRenderer);
  }
  /**
   * Handy function for batch renderers: copies bound textures in first maxTextures locations to array
   * sets actual _batchLocation for them
   * @param arr - arr copy destination
   * @param maxTextures - number of copied elements
   */
  copyBoundTextures(e, n) {
    const { boundTextures: r } = this.renderer.texture;
    for (let o = n - 1; o >= 0; --o)
      e[o] = r[o] || null, e[o] && (e[o]._batchLocation = o);
  }
  /**
   * Assigns batch locations to textures in array based on boundTextures state.
   * All textures in texArray should have `_batchEnabled = _batchId`,
   * and their count should be less than `maxTextures`.
   * @param texArray - textures to bound
   * @param boundTextures - current state of bound textures
   * @param batchId - marker for _batchEnabled param of textures in texArray
   * @param maxTextures - number of texture locations to manipulate
   */
  boundArray(e, n, r, o) {
    const { elements: s, ids: i, count: u } = e;
    let l = 0;
    for (let a = 0; a < u; a++) {
      const c = s[a], p = c._batchLocation;
      if (p >= 0 && p < o && n[p] === c) {
        i[a] = p;
        continue;
      }
      for (; l < o; ) {
        const d = n[l];
        if (d && d._batchEnabled === r && d._batchLocation === l) {
          l++;
          continue;
        }
        i[a] = l, c._batchLocation = l, n[l] = c;
        break;
      }
    }
  }
  /**
   * @ignore
   */
  destroy() {
    this.renderer = null;
  }
}
fB.extension = {
  type: rt.RendererSystem,
  name: "batch"
};
dt.add(fB);
let FC = 0;
class iv {
  /** @param renderer - The renderer this System works for. */
  constructor(e) {
    this.renderer = e, this.webGLVersion = 1, this.extensions = {}, this.supports = {
      uint32Indices: !1
    }, this.handleContextLost = this.handleContextLost.bind(this), this.handleContextRestored = this.handleContextRestored.bind(this);
  }
  /**
   * `true` if the context is lost
   * @readonly
   */
  get isLost() {
    return !this.gl || this.gl.isContextLost();
  }
  /**
   * Handles the context change event.
   * @param {WebGLRenderingContext} gl - New WebGL context.
   */
  contextChange(e) {
    this.gl = e, this.renderer.gl = e, this.renderer.CONTEXT_UID = FC++;
  }
  init(e) {
    if (e.context)
      this.initFromContext(e.context);
    else {
      const n = this.renderer.background.alpha < 1, r = e.premultipliedAlpha;
      this.preserveDrawingBuffer = e.preserveDrawingBuffer, this.useContextAlpha = e.useContextAlpha, this.powerPreference = e.powerPreference, this.initFromOptions({
        alpha: n,
        premultipliedAlpha: r,
        antialias: e.antialias,
        stencil: !0,
        preserveDrawingBuffer: e.preserveDrawingBuffer,
        powerPreference: e.powerPreference
      });
    }
  }
  /**
   * Initializes the context.
   * @protected
   * @param {WebGLRenderingContext} gl - WebGL context
   */
  initFromContext(e) {
    this.gl = e, this.validateContext(e), this.renderer.gl = e, this.renderer.CONTEXT_UID = FC++, this.renderer.runners.contextChange.emit(e);
    const n = this.renderer.view;
    n.addEventListener !== void 0 && (n.addEventListener("webglcontextlost", this.handleContextLost, !1), n.addEventListener("webglcontextrestored", this.handleContextRestored, !1));
  }
  /**
   * Initialize from context options
   * @protected
   * @see https://developer.mozilla.org/en-US/docs/Web/API/HTMLCanvasElement/getContext
   * @param {object} options - context attributes
   */
  initFromOptions(e) {
    const n = this.createContext(this.renderer.view, e);
    this.initFromContext(n);
  }
  /**
   * Helper class to create a WebGL Context
   * @param canvas - the canvas element that we will get the context from
   * @param options - An options object that gets passed in to the canvas element containing the
   *    context attributes
   * @see https://developer.mozilla.org/en/docs/Web/API/HTMLCanvasElement/getContext
   * @returns {WebGLRenderingContext} the WebGL context
   */
  createContext(e, n) {
    let r;
    if (at.PREFER_ENV >= nd.WEBGL2 && (r = e.getContext("webgl2", n)), r)
      this.webGLVersion = 2;
    else if (this.webGLVersion = 1, r = e.getContext("webgl", n) || e.getContext("experimental-webgl", n), !r)
      throw new Error("This browser does not support WebGL. Try using the canvas renderer");
    return this.gl = r, this.getExtensions(), this.gl;
  }
  /** Auto-populate the {@link PIXI.ContextSystem.extensions extensions}. */
  getExtensions() {
    const { gl: e } = this, n = {
      loseContext: e.getExtension("WEBGL_lose_context"),
      anisotropicFiltering: e.getExtension("EXT_texture_filter_anisotropic"),
      floatTextureLinear: e.getExtension("OES_texture_float_linear"),
      s3tc: e.getExtension("WEBGL_compressed_texture_s3tc"),
      s3tc_sRGB: e.getExtension("WEBGL_compressed_texture_s3tc_srgb"),
      // eslint-disable-line camelcase
      etc: e.getExtension("WEBGL_compressed_texture_etc"),
      etc1: e.getExtension("WEBGL_compressed_texture_etc1"),
      pvrtc: e.getExtension("WEBGL_compressed_texture_pvrtc") || e.getExtension("WEBKIT_WEBGL_compressed_texture_pvrtc"),
      atc: e.getExtension("WEBGL_compressed_texture_atc"),
      astc: e.getExtension("WEBGL_compressed_texture_astc")
    };
    this.webGLVersion === 1 ? Object.assign(this.extensions, n, {
      drawBuffers: e.getExtension("WEBGL_draw_buffers"),
      depthTexture: e.getExtension("WEBGL_depth_texture"),
      vertexArrayObject: e.getExtension("OES_vertex_array_object") || e.getExtension("MOZ_OES_vertex_array_object") || e.getExtension("WEBKIT_OES_vertex_array_object"),
      uint32ElementIndex: e.getExtension("OES_element_index_uint"),
      // Floats and half-floats
      floatTexture: e.getExtension("OES_texture_float"),
      floatTextureLinear: e.getExtension("OES_texture_float_linear"),
      textureHalfFloat: e.getExtension("OES_texture_half_float"),
      textureHalfFloatLinear: e.getExtension("OES_texture_half_float_linear")
    }) : this.webGLVersion === 2 && Object.assign(this.extensions, n, {
      // Floats and half-floats
      colorBufferFloat: e.getExtension("EXT_color_buffer_float")
    });
  }
  /**
   * Handles a lost webgl context
   * @param {WebGLContextEvent} event - The context lost event.
   */
  handleContextLost(e) {
    e.preventDefault(), setTimeout(() => {
      this.gl.isContextLost() && this.extensions.loseContext && this.extensions.loseContext.restoreContext();
    }, 0);
  }
  /** Handles a restored webgl context. */
  handleContextRestored() {
    this.renderer.runners.contextChange.emit(this.gl);
  }
  destroy() {
    const e = this.renderer.view;
    this.renderer = null, e.removeEventListener !== void 0 && (e.removeEventListener("webglcontextlost", this.handleContextLost), e.removeEventListener("webglcontextrestored", this.handleContextRestored)), this.gl.useProgram(null), this.extensions.loseContext && this.extensions.loseContext.loseContext();
  }
  /** Handle the post-render runner event. */
  postrender() {
    this.renderer.objectRenderer.renderingToScreen && this.gl.flush();
  }
  /**
   * Validate context.
   * @param {WebGLRenderingContext} gl - Render context.
   */
  validateContext(e) {
    const n = e.getContextAttributes(), r = "WebGL2RenderingContext" in globalThis && e instanceof globalThis.WebGL2RenderingContext;
    r && (this.webGLVersion = 2), n && !n.stencil && console.warn("Provided WebGL context does not have a stencil buffer, masks may not render correctly");
    const o = r || !!e.getExtension("OES_element_index_uint");
    this.supports.uint32Indices = o, o || console.warn("Provided WebGL context does not support 32 index buffer, complex graphics may not render correctly");
  }
}
iv.defaultOptions = {
  /**
   * {@link PIXI.IRendererOptions.context}
   * @default null
   * @memberof PIXI.settings.RENDER_OPTIONS
   */
  context: null,
  /**
   * {@link PIXI.IRendererOptions.antialias}
   * @default false
   * @memberof PIXI.settings.RENDER_OPTIONS
   */
  antialias: !1,
  /**
   * {@link PIXI.IRendererOptions.premultipliedAlpha}
   * @default true
   * @memberof PIXI.settings.RENDER_OPTIONS
   */
  premultipliedAlpha: !0,
  /**
   * {@link PIXI.IRendererOptions.preserveDrawingBuffer}
   * @default false
   * @memberof PIXI.settings.RENDER_OPTIONS
   */
  preserveDrawingBuffer: !1,
  /**
   * {@link PIXI.IRendererOptions.powerPreference}
   * @default default
   * @memberof PIXI.settings.RENDER_OPTIONS
   */
  powerPreference: "default"
}, /** @ignore */
iv.extension = {
  type: rt.RendererSystem,
  name: "context"
};
dt.add(iv);
class cT {
  /**
   * @param width - Width of the frame buffer
   * @param height - Height of the frame buffer
   */
  constructor(e, n) {
    if (this.width = Math.round(e), this.height = Math.round(n), !this.width || !this.height)
      throw new Error("Framebuffer width or height is zero");
    this.stencil = !1, this.depth = !1, this.dirtyId = 0, this.dirtyFormat = 0, this.dirtySize = 0, this.depthTexture = null, this.colorTextures = [], this.glFramebuffers = {}, this.disposeRunner = new pi("disposeFramebuffer"), this.multisample = jr.NONE;
  }
  /**
   * Reference to the colorTexture.
   * @readonly
   */
  get colorTexture() {
    return this.colorTextures[0];
  }
  /**
   * Add texture to the colorTexture array.
   * @param index - Index of the array to add the texture to
   * @param texture - Texture to add to the array
   */
  addColorTexture(e = 0, n) {
    return this.colorTextures[e] = n || new qt(null, {
      scaleMode: qu.NEAREST,
      resolution: 1,
      mipmap: yu.OFF,
      width: this.width,
      height: this.height
    }), this.dirtyId++, this.dirtyFormat++, this;
  }
  /**
   * Add a depth texture to the frame buffer.
   * @param texture - Texture to add.
   */
  addDepthTexture(e) {
    return this.depthTexture = e || new qt(null, {
      scaleMode: qu.NEAREST,
      resolution: 1,
      width: this.width,
      height: this.height,
      mipmap: yu.OFF,
      format: qe.DEPTH_COMPONENT,
      type: _t.UNSIGNED_SHORT
    }), this.dirtyId++, this.dirtyFormat++, this;
  }
  /** Enable depth on the frame buffer. */
  enableDepth() {
    return this.depth = !0, this.dirtyId++, this.dirtyFormat++, this;
  }
  /** Enable stencil on the frame buffer. */
  enableStencil() {
    return this.stencil = !0, this.dirtyId++, this.dirtyFormat++, this;
  }
  /**
   * Resize the frame buffer
   * @param width - Width of the frame buffer to resize to
   * @param height - Height of the frame buffer to resize to
   */
  resize(e, n) {
    if (e = Math.round(e), n = Math.round(n), !e || !n)
      throw new Error("Framebuffer width and height must not be zero");
    if (!(e === this.width && n === this.height)) {
      this.width = e, this.height = n, this.dirtyId++, this.dirtySize++;
      for (let r = 0; r < this.colorTextures.length; r++) {
        const o = this.colorTextures[r], s = o.resolution;
        o.setSize(e / s, n / s);
      }
      if (this.depthTexture) {
        const r = this.depthTexture.resolution;
        this.depthTexture.setSize(e / r, n / r);
      }
    }
  }
  /** Disposes WebGL resources that are connected to this geometry. */
  dispose() {
    this.disposeRunner.emit(this, !1);
  }
  /** Destroys and removes the depth texture added to this framebuffer. */
  destroyDepthTexture() {
    this.depthTexture && (this.depthTexture.destroy(), this.depthTexture = null, ++this.dirtyId, ++this.dirtyFormat);
  }
}
class mB extends qt {
  /**
   * @param options
   * @param {number} [options.width=100] - The width of the base render texture.
   * @param {number} [options.height=100] - The height of the base render texture.
   * @param {PIXI.SCALE_MODES} [options.scaleMode=PIXI.BaseTexture.defaultOptions.scaleMode] - See {@link PIXI.SCALE_MODES}
   *   for possible values.
   * @param {number} [options.resolution=PIXI.settings.RESOLUTION] - The resolution / device pixel ratio
   *   of the texture being generated.
   * @param {PIXI.MSAA_QUALITY} [options.multisample=PIXI.MSAA_QUALITY.NONE] - The number of samples of the frame buffer.
   */
  constructor(e = {}) {
    if (typeof e == "number") {
      const n = arguments[0], r = arguments[1], o = arguments[2], s = arguments[3];
      e = { width: n, height: r, scaleMode: o, resolution: s };
    }
    e.width = e.width ?? 100, e.height = e.height ?? 100, e.multisample ?? (e.multisample = jr.NONE), super(null, e), this.mipmap = yu.OFF, this.valid = !0, this._clear = new Gn([0, 0, 0, 0]), this.framebuffer = new cT(this.realWidth, this.realHeight).addColorTexture(0, this), this.framebuffer.multisample = e.multisample, this.maskStack = [], this.filterStack = [{}];
  }
  /** Color when clearning the texture. */
  set clearColor(e) {
    this._clear.setValue(e);
  }
  get clearColor() {
    return this._clear.value;
  }
  /**
   * Color object when clearning the texture.
   * @readonly
   * @since 7.2.0
   */
  get clear() {
    return this._clear;
  }
  /**
   * Shortcut to `this.framebuffer.multisample`.
   * @default PIXI.MSAA_QUALITY.NONE
   */
  get multisample() {
    return this.framebuffer.multisample;
  }
  set multisample(e) {
    this.framebuffer.multisample = e;
  }
  /**
   * Resizes the BaseRenderTexture.
   * @param desiredWidth - The desired width to resize to.
   * @param desiredHeight - The desired height to resize to.
   */
  resize(e, n) {
    this.framebuffer.resize(e * this.resolution, n * this.resolution), this.setRealSize(this.framebuffer.width, this.framebuffer.height);
  }
  /**
   * Frees the texture and framebuffer from WebGL memory without destroying this texture object.
   * This means you can still use the texture later which will upload it to GPU
   * memory again.
   * @fires PIXI.BaseTexture#dispose
   */
  dispose() {
    this.framebuffer.dispose(), super.dispose();
  }
  /** Destroys this texture. */
  destroy() {
    super.destroy(), this.framebuffer.destroyDepthTexture(), this.framebuffer = null;
  }
}
class gc extends ym {
  /**
   * @param {HTMLImageElement|HTMLVideoElement|ImageBitmap|PIXI.ICanvas} source
   */
  constructor(e) {
    const n = e, r = n.naturalWidth || n.videoWidth || n.width, o = n.naturalHeight || n.videoHeight || n.height;
    super(r, o), this.source = e, this.noSubImage = !1;
  }
  /**
   * Set cross origin based detecting the url and the crossorigin
   * @param element - Element to apply crossOrigin
   * @param url - URL to check
   * @param crossorigin - Cross origin value to use
   */
  static crossOrigin(e, n, r) {
    r === void 0 && !n.startsWith("data:") ? e.crossOrigin = O1e(n) : r !== !1 && (e.crossOrigin = typeof r == "string" ? r : "anonymous");
  }
  /**
   * Upload the texture to the GPU.
   * @param renderer - Upload to the renderer
   * @param baseTexture - Reference to parent texture
   * @param glTexture
   * @param {HTMLImageElement|HTMLVideoElement|ImageBitmap|PIXI.ICanvas} [source] - (optional)
   * @returns - true is success
   */
  upload(e, n, r, o) {
    const s = e.gl, i = n.realWidth, u = n.realHeight;
    if (o = o || this.source, typeof HTMLImageElement < "u" && o instanceof HTMLImageElement) {
      if (!o.complete || o.naturalWidth === 0)
        return !1;
    } else if (typeof HTMLVideoElement < "u" && o instanceof HTMLVideoElement && o.readyState <= 1)
      return !1;
    return s.pixelStorei(s.UNPACK_PREMULTIPLY_ALPHA_WEBGL, n.alphaMode === gs.UNPACK), !this.noSubImage && n.target === s.TEXTURE_2D && r.width === i && r.height === u ? s.texSubImage2D(s.TEXTURE_2D, 0, 0, 0, n.format, r.type, o) : (r.width = i, r.height = u, s.texImage2D(n.target, 0, r.internalFormat, n.format, r.type, o)), !0;
  }
  /**
   * Checks if source width/height was changed, resize can cause extra baseTexture update.
   * Triggers one update in any case.
   */
  update() {
    if (this.destroyed)
      return;
    const e = this.source, n = e.naturalWidth || e.videoWidth || e.width, r = e.naturalHeight || e.videoHeight || e.height;
    this.resize(n, r), super.update();
  }
  /** Destroy this {@link PIXI.BaseImageResource} */
  dispose() {
    this.source = null;
  }
}
class yB extends gc {
  /**
   * @param source - image source or URL
   * @param options
   * @param {boolean} [options.autoLoad=true] - start loading process
   * @param {boolean} [options.createBitmap=PIXI.settings.CREATE_IMAGE_BITMAP] - whether its required to create
   *        a bitmap before upload
   * @param {boolean} [options.crossorigin=true] - Load image using cross origin
   * @param {PIXI.ALPHA_MODES} [options.alphaMode=PIXI.ALPHA_MODES.UNPACK] - Premultiply image alpha in bitmap
   */
  constructor(e, n) {
    if (n = n || {}, typeof e == "string") {
      const r = new Image();
      gc.crossOrigin(r, e, n.crossorigin), r.src = e, e = r;
    }
    super(e), !e.complete && this._width && this._height && (this._width = 0, this._height = 0), this.url = e.src, this._process = null, this.preserveBitmap = !1, this.createBitmap = (n.createBitmap ?? at.CREATE_IMAGE_BITMAP) && !!globalThis.createImageBitmap, this.alphaMode = typeof n.alphaMode == "number" ? n.alphaMode : null, this.bitmap = null, this._load = null, n.autoLoad !== !1 && this.load();
  }
  /**
   * Returns a promise when image will be loaded and processed.
   * @param createBitmap - whether process image into bitmap
   */
  load(e) {
    return this._load ? this._load : (e !== void 0 && (this.createBitmap = e), this._load = new Promise((n, r) => {
      const o = this.source;
      this.url = o.src;
      const s = () => {
        this.destroyed || (o.onload = null, o.onerror = null, this.update(), this._load = null, this.createBitmap ? n(this.process()) : n(this));
      };
      o.complete && o.src ? s() : (o.onload = s, o.onerror = (i) => {
        r(i), this.onError.emit(i);
      });
    }), this._load);
  }
  /**
   * Called when we need to convert image into BitmapImage.
   * Can be called multiple times, real promise is cached inside.
   * @returns - Cached promise to fill that bitmap
   */
  process() {
    const e = this.source;
    if (this._process !== null)
      return this._process;
    if (this.bitmap !== null || !globalThis.createImageBitmap)
      return Promise.resolve(this);
    const n = globalThis.createImageBitmap, r = !e.crossOrigin || e.crossOrigin === "anonymous";
    return this._process = fetch(
      e.src,
      {
        mode: r ? "cors" : "no-cors"
      }
    ).then((o) => o.blob()).then((o) => n(
      o,
      0,
      0,
      e.width,
      e.height,
      {
        premultiplyAlpha: this.alphaMode === null || this.alphaMode === gs.UNPACK ? "premultiply" : "none"
      }
    )).then((o) => this.destroyed ? Promise.reject() : (this.bitmap = o, this.update(), this._process = null, Promise.resolve(this))), this._process;
  }
  /**
   * Upload the image resource to GPU.
   * @param renderer - Renderer to upload to
   * @param baseTexture - BaseTexture for this resource
   * @param glTexture - GLTexture to use
   * @returns {boolean} true is success
   */
  upload(e, n, r) {
    if (typeof this.alphaMode == "number" && (n.alphaMode = this.alphaMode), !this.createBitmap)
      return super.upload(e, n, r);
    if (!this.bitmap && (this.process(), !this.bitmap))
      return !1;
    if (super.upload(e, n, r, this.bitmap), !this.preserveBitmap) {
      let o = !0;
      const s = n._glTextures;
      for (const i in s) {
        const u = s[i];
        if (u !== r && u.dirtyId !== n.dirtyId) {
          o = !1;
          break;
        }
      }
      o && (this.bitmap.close && this.bitmap.close(), this.bitmap = null);
    }
    return !0;
  }
  /** Destroys this resource. */
  dispose() {
    this.source.onload = null, this.source.onerror = null, super.dispose(), this.bitmap && (this.bitmap.close(), this.bitmap = null), this._process = null, this._load = null;
  }
  /**
   * Used to auto-detect the type of resource.
   * @param {*} source - The source object
   * @returns {boolean} `true` if current environment support HTMLImageElement, and source is string or HTMLImageElement
   */
  static test(e) {
    return typeof HTMLImageElement < "u" && (typeof e == "string" || e instanceof HTMLImageElement);
  }
}
class RS {
  constructor() {
    this.x0 = 0, this.y0 = 0, this.x1 = 1, this.y1 = 0, this.x2 = 1, this.y2 = 1, this.x3 = 0, this.y3 = 1, this.uvsFloat32 = new Float32Array(8);
  }
  /**
   * Sets the texture Uvs based on the given frame information.
   * @protected
   * @param frame - The frame of the texture
   * @param baseFrame - The base frame of the texture
   * @param rotate - Rotation of frame, see {@link PIXI.groupD8}
   */
  set(e, n, r) {
    const o = n.width, s = n.height;
    if (r) {
      const i = e.width / 2 / o, u = e.height / 2 / s, l = e.x / o + i, a = e.y / s + u;
      r = hr.add(r, hr.NW), this.x0 = l + i * hr.uX(r), this.y0 = a + u * hr.uY(r), r = hr.add(r, 2), this.x1 = l + i * hr.uX(r), this.y1 = a + u * hr.uY(r), r = hr.add(r, 2), this.x2 = l + i * hr.uX(r), this.y2 = a + u * hr.uY(r), r = hr.add(r, 2), this.x3 = l + i * hr.uX(r), this.y3 = a + u * hr.uY(r);
    } else
      this.x0 = e.x / o, this.y0 = e.y / s, this.x1 = (e.x + e.width) / o, this.y1 = e.y / s, this.x2 = (e.x + e.width) / o, this.y2 = (e.y + e.height) / s, this.x3 = e.x / o, this.y3 = (e.y + e.height) / s;
    this.uvsFloat32[0] = this.x0, this.uvsFloat32[1] = this.y0, this.uvsFloat32[2] = this.x1, this.uvsFloat32[3] = this.y1, this.uvsFloat32[4] = this.x2, this.uvsFloat32[5] = this.y2, this.uvsFloat32[6] = this.x3, this.uvsFloat32[7] = this.y3;
  }
}
RS.prototype.toString = function() {
  return `[@pixi/core:TextureUvs x0=${this.x0} y0=${this.y0} x1=${this.x1} y1=${this.y1} x2=${this.x2} y2=${this.y2} x3=${this.x3} y3=${this.y3}]`;
};
const NC = new RS();
function bg(t) {
  t.destroy = function() {
  }, t.on = function() {
  }, t.once = function() {
  }, t.emit = function() {
  };
}
class pt extends uy {
  /**
   * @param baseTexture - The base texture source to create the texture from
   * @param frame - The rectangle frame of the texture to show
   * @param orig - The area of original texture
   * @param trim - Trimmed rectangle of original texture
   * @param rotate - indicates how the texture was rotated by texture packer. See {@link PIXI.groupD8}
   * @param anchor - Default anchor point used for sprite placement / rotation
   * @param borders - Default borders used for 9-slice scaling. See {@link PIXI.NineSlicePlane}
   */
  constructor(e, n, r, o, s, i, u) {
    if (super(), this.noFrame = !1, n || (this.noFrame = !0, n = new Pt(0, 0, 1, 1)), e instanceof pt && (e = e.baseTexture), this.baseTexture = e, this._frame = n, this.trim = o, this.valid = !1, this.destroyed = !1, this._uvs = NC, this.uvMatrix = null, this.orig = r || n, this._rotate = Number(s || 0), s === !0)
      this._rotate = 2;
    else if (this._rotate % 2 !== 0)
      throw new Error("attempt to use diamond-shaped UVs. If you are sure, set rotation manually");
    this.defaultAnchor = i ? new Rt(i.x, i.y) : new Rt(0, 0), this.defaultBorders = u, this._updateID = 0, this.textureCacheIds = [], e.valid ? this.noFrame ? e.valid && this.onBaseTextureUpdated(e) : this.frame = n : e.once("loaded", this.onBaseTextureUpdated, this), this.noFrame && e.on("update", this.onBaseTextureUpdated, this);
  }
  /**
   * Updates this texture on the gpu.
   *
   * Calls the TextureResource update.
   *
   * If you adjusted `frame` manually, please call `updateUvs()` instead.
   */
  update() {
    this.baseTexture.resource && this.baseTexture.resource.update();
  }
  /**
   * Called when the base texture is updated
   * @protected
   * @param baseTexture - The base texture.
   */
  onBaseTextureUpdated(e) {
    if (this.noFrame) {
      if (!this.baseTexture.valid)
        return;
      this._frame.width = e.width, this._frame.height = e.height, this.valid = !0, this.updateUvs();
    } else
      this.frame = this._frame;
    this.emit("update", this);
  }
  /**
   * Destroys this texture
   * @param [destroyBase=false] - Whether to destroy the base texture as well
   * @fires PIXI.Texture#destroyed
   */
  destroy(e) {
    if (this.baseTexture) {
      if (e) {
        const { resource: n } = this.baseTexture;
        n?.url && Wi[n.url] && pt.removeFromCache(n.url), this.baseTexture.destroy();
      }
      this.baseTexture.off("loaded", this.onBaseTextureUpdated, this), this.baseTexture.off("update", this.onBaseTextureUpdated, this), this.baseTexture = null;
    }
    this._frame = null, this._uvs = null, this.trim = null, this.orig = null, this.valid = !1, pt.removeFromCache(this), this.textureCacheIds = null, this.destroyed = !0, this.emit("destroyed", this), this.removeAllListeners();
  }
  /**
   * Creates a new texture object that acts the same as this one.
   * @returns - The new texture
   */
  clone() {
    const e = this._frame.clone(), n = this._frame === this.orig ? e : this.orig.clone(), r = new pt(
      this.baseTexture,
      !this.noFrame && e,
      n,
      this.trim?.clone(),
      this.rotate,
      this.defaultAnchor,
      this.defaultBorders
    );
    return this.noFrame && (r._frame = e), r;
  }
  /**
   * Updates the internal WebGL UV cache. Use it after you change `frame` or `trim` of the texture.
   * Call it after changing the frame
   */
  updateUvs() {
    this._uvs === NC && (this._uvs = new RS()), this._uvs.set(this._frame, this.baseTexture, this.rotate), this._updateID++;
  }
  /**
   * Helper function that creates a new Texture based on the source you provide.
   * The source can be - frame id, image url, video url, canvas element, video element, base texture
   * @param {string|PIXI.BaseTexture|HTMLImageElement|HTMLVideoElement|ImageBitmap|PIXI.ICanvas} source -
   *        Source or array of sources to create texture from
   * @param options - See {@link PIXI.BaseTexture}'s constructor for options.
   * @param {string} [options.pixiIdPrefix=pixiid] - If a source has no id, this is the prefix of the generated id
   * @param {boolean} [strict] - Enforce strict-mode, see {@link PIXI.settings.STRICT_TEXTURE_CACHE}.
   * @returns {PIXI.Texture} The newly created texture
   */
  static from(e, n = {}, r = at.STRICT_TEXTURE_CACHE) {
    const o = typeof e == "string";
    let s = null;
    if (o)
      s = e;
    else if (e instanceof qt) {
      if (!e.cacheId) {
        const u = n?.pixiIdPrefix || "pixiid";
        e.cacheId = `${u}-${Up()}`, qt.addToCache(e, e.cacheId);
      }
      s = e.cacheId;
    } else {
      if (!e._pixiId) {
        const u = n?.pixiIdPrefix || "pixiid";
        e._pixiId = `${u}_${Up()}`;
      }
      s = e._pixiId;
    }
    let i = Wi[s];
    if (o && r && !i)
      throw new Error(`The cacheId "${s}" does not exist in TextureCache.`);
    return !i && !(e instanceof qt) ? (n.resolution || (n.resolution = al(e)), i = new pt(new qt(e, n)), i.baseTexture.cacheId = s, qt.addToCache(i.baseTexture, s), pt.addToCache(i, s)) : !i && e instanceof qt && (i = new pt(e), pt.addToCache(i, s)), i;
  }
  /**
   * Useful for loading textures via URLs. Use instead of `Texture.from` because
   * it does a better job of handling failed URLs more effectively. This also ignores
   * `PIXI.settings.STRICT_TEXTURE_CACHE`. Works for Videos, SVGs, Images.
   * @param url - The remote URL or array of URLs to load.
   * @param options - Optional options to include
   * @returns - A Promise that resolves to a Texture.
   */
  static fromURL(e, n) {
    const r = Object.assign({ autoLoad: !1 }, n?.resourceOptions), o = pt.from(e, Object.assign({ resourceOptions: r }, n), !1), s = o.baseTexture.resource;
    return o.baseTexture.valid ? Promise.resolve(o) : s.load().then(() => Promise.resolve(o));
  }
  /**
   * Create a new Texture with a BufferResource from a typed array.
   * @param buffer - The optional array to use. If no data is provided, a new Float32Array is created.
   * @param width - Width of the resource
   * @param height - Height of the resource
   * @param options - See {@link PIXI.BaseTexture}'s constructor for options.
   *        Default properties are different from the constructor's defaults.
   * @param {PIXI.FORMATS} [options.format] - The format is not given, the type is inferred from the
   *        type of the buffer: `RGBA` if Float32Array, Int8Array, Uint8Array, or Uint8ClampedArray,
   *        otherwise `RGBA_INTEGER`.
   * @param {PIXI.TYPES} [options.type] - The type is not given, the type is inferred from the
   *        type of the buffer. Maps Float32Array to `FLOAT`, Int32Array to `INT`, Uint32Array to
   *        `UNSIGNED_INT`, Int16Array to `SHORT`, Uint16Array to `UNSIGNED_SHORT`, Int8Array to `BYTE`,
   *        Uint8Array/Uint8ClampedArray to `UNSIGNED_BYTE`.
   * @param {PIXI.ALPHA_MODES} [options.alphaMode=PIXI.ALPHA_MODES.NPM]
   * @param {PIXI.SCALE_MODES} [options.scaleMode=PIXI.SCALE_MODES.NEAREST]
   * @returns - The resulting new BaseTexture
   */
  static fromBuffer(e, n, r, o) {
    return new pt(qt.fromBuffer(e, n, r, o));
  }
  /**
   * Create a texture from a source and add to the cache.
   * @param {HTMLImageElement|HTMLVideoElement|ImageBitmap|PIXI.ICanvas|string} source - The input source.
   * @param imageUrl - File name of texture, for cache and resolving resolution.
   * @param name - Human readable name for the texture cache. If no name is
   *        specified, only `imageUrl` will be used as the cache ID.
   * @param options
   * @returns - Output texture
   */
  static fromLoader(e, n, r, o) {
    const s = new qt(e, Object.assign({
      scaleMode: qt.defaultOptions.scaleMode,
      resolution: al(n)
    }, o)), { resource: i } = s;
    i instanceof yB && (i.url = n);
    const u = new pt(s);
    return r || (r = n), qt.addToCache(u.baseTexture, r), pt.addToCache(u, r), r !== n && (qt.addToCache(u.baseTexture, n), pt.addToCache(u, n)), u.baseTexture.valid ? Promise.resolve(u) : new Promise((l) => {
      u.baseTexture.once("loaded", () => l(u));
    });
  }
  /**
   * Adds a Texture to the global TextureCache. This cache is shared across the whole PIXI object.
   * @param texture - The Texture to add to the cache.
   * @param id - The id that the Texture will be stored against.
   */
  static addToCache(e, n) {
    n && (e.textureCacheIds.includes(n) || e.textureCacheIds.push(n), Wi[n] && Wi[n] !== e && console.warn(`Texture added to the cache with an id [${n}] that already had an entry`), Wi[n] = e);
  }
  /**
   * Remove a Texture from the global TextureCache.
   * @param texture - id of a Texture to be removed, or a Texture instance itself
   * @returns - The Texture that was removed
   */
  static removeFromCache(e) {
    if (typeof e == "string") {
      const n = Wi[e];
      if (n) {
        const r = n.textureCacheIds.indexOf(e);
        return r > -1 && n.textureCacheIds.splice(r, 1), delete Wi[e], n;
      }
    } else if (e?.textureCacheIds) {
      for (let n = 0; n < e.textureCacheIds.length; ++n)
        Wi[e.textureCacheIds[n]] === e && delete Wi[e.textureCacheIds[n]];
      return e.textureCacheIds.length = 0, e;
    }
    return null;
  }
  /**
   * Returns resolution of baseTexture
   * @readonly
   */
  get resolution() {
    return this.baseTexture.resolution;
  }
  /**
   * The frame specifies the region of the base texture that this texture uses.
   * Please call `updateUvs()` after you change coordinates of `frame` manually.
   */
  get frame() {
    return this._frame;
  }
  set frame(e) {
    this._frame = e, this.noFrame = !1;
    const { x: n, y: r, width: o, height: s } = e, i = n + o > this.baseTexture.width, u = r + s > this.baseTexture.height;
    if (i || u) {
      const l = i && u ? "and" : "or", a = `X: ${n} + ${o} = ${n + o} > ${this.baseTexture.width}`, c = `Y: ${r} + ${s} = ${r + s} > ${this.baseTexture.height}`;
      throw new Error(`Texture Error: frame does not fit inside the base Texture dimensions: ${a} ${l} ${c}`);
    }
    this.valid = o && s && this.baseTexture.valid, !this.trim && !this.rotate && (this.orig = e), this.valid && this.updateUvs();
  }
  /**
   * Indicates whether the texture is rotated inside the atlas
   * set to 2 to compensate for texture packer rotation
   * set to 6 to compensate for spine packer rotation
   * can be used to rotate or mirror sprites
   * See {@link PIXI.groupD8} for explanation
   */
  get rotate() {
    return this._rotate;
  }
  set rotate(e) {
    this._rotate = e, this.valid && this.updateUvs();
  }
  /** The width of the Texture in pixels. */
  get width() {
    return this.orig.width;
  }
  /** The height of the Texture in pixels. */
  get height() {
    return this.orig.height;
  }
  /** Utility function for BaseTexture|Texture cast. */
  castToBaseTexture() {
    return this.baseTexture;
  }
  /** An empty texture, used often to not have to create multiple empty textures. Can not be destroyed. */
  static get EMPTY() {
    return pt._EMPTY || (pt._EMPTY = new pt(new qt()), bg(pt._EMPTY), bg(pt._EMPTY.baseTexture)), pt._EMPTY;
  }
  /** A white texture of 16x16 size, used for graphics and other things Can not be destroyed. */
  static get WHITE() {
    if (!pt._WHITE) {
      const e = at.ADAPTER.createCanvas(16, 16), n = e.getContext("2d");
      e.width = 16, e.height = 16, n.fillStyle = "white", n.fillRect(0, 0, 16, 16), pt._WHITE = new pt(qt.from(e)), bg(pt._WHITE), bg(pt._WHITE.baseTexture);
    }
    return pt._WHITE;
  }
}
class rd extends pt {
  /**
   * @param baseRenderTexture - The base texture object that this texture uses.
   * @param frame - The rectangle frame of the texture to show.
   */
  constructor(e, n) {
    super(e, n), this.valid = !0, this.filterFrame = null, this.filterPoolKey = null, this.updateUvs();
  }
  /**
   * Shortcut to `this.baseTexture.framebuffer`, saves baseTexture cast.
   * @readonly
   */
  get framebuffer() {
    return this.baseTexture.framebuffer;
  }
  /**
   * Shortcut to `this.framebuffer.multisample`.
   * @default PIXI.MSAA_QUALITY.NONE
   */
  get multisample() {
    return this.framebuffer.multisample;
  }
  set multisample(e) {
    this.framebuffer.multisample = e;
  }
  /**
   * Resizes the RenderTexture.
   * @param desiredWidth - The desired width to resize to.
   * @param desiredHeight - The desired height to resize to.
   * @param resizeBaseTexture - Should the baseTexture.width and height values be resized as well?
   */
  resize(e, n, r = !0) {
    const o = this.baseTexture.resolution, s = Math.round(e * o) / o, i = Math.round(n * o) / o;
    this.valid = s > 0 && i > 0, this._frame.width = this.orig.width = s, this._frame.height = this.orig.height = i, r && this.baseTexture.resize(s, i), this.updateUvs();
  }
  /**
   * Changes the resolution of baseTexture, but does not change framebuffer size.
   * @param resolution - The new resolution to apply to RenderTexture
   */
  setResolution(e) {
    const { baseTexture: n } = this;
    n.resolution !== e && (n.setResolution(e), this.resize(n.width, n.height, !1));
  }
  /**
   * A short hand way of creating a render texture.
   * @param options - Options
   * @param {number} [options.width=100] - The width of the render texture
   * @param {number} [options.height=100] - The height of the render texture
   * @param {PIXI.SCALE_MODES} [options.scaleMode=PIXI.BaseTexture.defaultOptions.scaleMode] - See {@link PIXI.SCALE_MODES}
   *    for possible values
   * @param {number} [options.resolution=PIXI.settings.RESOLUTION] - The resolution / device pixel ratio of the texture
   *    being generated
   * @param {PIXI.MSAA_QUALITY} [options.multisample=PIXI.MSAA_QUALITY.NONE] - The number of samples of the frame buffer
   * @returns The new render texture
   */
  static create(e) {
    return new rd(new mB(e));
  }
}
class gB {
  /**
   * @param textureOptions - options that will be passed to BaseRenderTexture constructor
   * @param {PIXI.SCALE_MODES} [textureOptions.scaleMode] - See {@link PIXI.SCALE_MODES} for possible values.
   */
  constructor(e) {
    this.texturePool = {}, this.textureOptions = e || {}, this.enableFullScreen = !1, this._pixelsWidth = 0, this._pixelsHeight = 0;
  }
  /**
   * Creates texture with params that were specified in pool constructor.
   * @param realWidth - Width of texture in pixels.
   * @param realHeight - Height of texture in pixels.
   * @param multisample - Number of samples of the framebuffer.
   */
  createTexture(e, n, r = jr.NONE) {
    const o = new mB(Object.assign({
      width: e,
      height: n,
      resolution: 1,
      multisample: r
    }, this.textureOptions));
    return new rd(o);
  }
  /**
   * Gets a Power-of-Two render texture or fullScreen texture
   * @param minWidth - The minimum width of the render texture.
   * @param minHeight - The minimum height of the render texture.
   * @param resolution - The resolution of the render texture.
   * @param multisample - Number of samples of the render texture.
   * @returns The new render texture.
   */
  getOptimalTexture(e, n, r = 1, o = jr.NONE) {
    let s;
    e = Math.max(Math.ceil(e * r - 1e-6), 1), n = Math.max(Math.ceil(n * r - 1e-6), 1), !this.enableFullScreen || e !== this._pixelsWidth || n !== this._pixelsHeight ? (e = rv(e), n = rv(n), s = ((e & 65535) << 16 | n & 65535) >>> 0, o > 1 && (s += o * 4294967296)) : s = o > 1 ? -o : -1, this.texturePool[s] || (this.texturePool[s] = []);
    let i = this.texturePool[s].pop();
    return i || (i = this.createTexture(e, n, o)), i.filterPoolKey = s, i.setResolution(r), i;
  }
  /**
   * Gets extra texture of the same size as input renderTexture
   *
   * `getFilterTexture(input, 0.5)` or `getFilterTexture(0.5, input)`
   * @param input - renderTexture from which size and resolution will be copied
   * @param resolution - override resolution of the renderTexture
   *  It overrides, it does not multiply
   * @param multisample - number of samples of the renderTexture
   */
  getFilterTexture(e, n, r) {
    const o = this.getOptimalTexture(
      e.width,
      e.height,
      n || e.resolution,
      r || jr.NONE
    );
    return o.filterFrame = e.filterFrame, o;
  }
  /**
   * Place a render texture back into the pool.
   * @param renderTexture - The renderTexture to free
   */
  returnTexture(e) {
    const n = e.filterPoolKey;
    e.filterFrame = null, this.texturePool[n].push(e);
  }
  /**
   * Alias for returnTexture, to be compliant with FilterSystem interface.
   * @param renderTexture - The renderTexture to free
   */
  returnFilterTexture(e) {
    this.returnTexture(e);
  }
  /**
   * Clears the pool.
   * @param destroyTextures - Destroy all stored textures.
   */
  clear(e) {
    if (e = e !== !1, e)
      for (const n in this.texturePool) {
        const r = this.texturePool[n];
        if (r)
          for (let o = 0; o < r.length; o++)
            r[o].destroy(!0);
      }
    this.texturePool = {};
  }
  /**
   * If screen size was changed, drops all screen-sized textures,
   * sets new screen size, sets `enableFullScreen` to true
   *
   * Size is measured in pixels, `renderer.view` can be passed here, not `renderer.screen`
   * @param size - Initial size of screen.
   */
  setScreenSize(e) {
    if (!(e.width === this._pixelsWidth && e.height === this._pixelsHeight)) {
      this.enableFullScreen = e.width > 0 && e.height > 0;
      for (const n in this.texturePool) {
        if (!(Number(n) < 0))
          continue;
        const r = this.texturePool[n];
        if (r)
          for (let o = 0; o < r.length; o++)
            r[o].destroy(!0);
        this.texturePool[n] = [];
      }
      this._pixelsWidth = e.width, this._pixelsHeight = e.height;
    }
  }
}
gB.SCREEN_KEY = -1;
class cbe extends yc {
  constructor() {
    super(), this.addAttribute("aVertexPosition", new Float32Array([
      0,
      0,
      1,
      0,
      1,
      1,
      0,
      1
    ])).addIndex([0, 1, 3, 2]);
  }
}
class vB extends yc {
  constructor() {
    super(), this.vertices = new Float32Array([
      -1,
      -1,
      1,
      -1,
      1,
      1,
      -1,
      1
    ]), this.uvs = new Float32Array([
      0,
      0,
      1,
      0,
      1,
      1,
      0,
      1
    ]), this.vertexBuffer = new Fr(this.vertices), this.uvBuffer = new Fr(this.uvs), this.addAttribute("aVertexPosition", this.vertexBuffer).addAttribute("aTextureCoord", this.uvBuffer).addIndex([0, 1, 2, 0, 2, 3]);
  }
  /**
   * Maps two Rectangle to the quad.
   * @param targetTextureFrame - The first rectangle
   * @param destinationFrame - The second rectangle
   * @returns - Returns itself.
   */
  map(e, n) {
    let r = 0, o = 0;
    return this.uvs[0] = r, this.uvs[1] = o, this.uvs[2] = r + n.width / e.width, this.uvs[3] = o, this.uvs[4] = r + n.width / e.width, this.uvs[5] = o + n.height / e.height, this.uvs[6] = r, this.uvs[7] = o + n.height / e.height, r = n.x, o = n.y, this.vertices[0] = r, this.vertices[1] = o, this.vertices[2] = r + n.width, this.vertices[3] = o, this.vertices[4] = r + n.width, this.vertices[5] = o + n.height, this.vertices[6] = r, this.vertices[7] = o + n.height, this.invalidate(), this;
  }
  /**
   * Legacy upload method, just marks buffers dirty.
   * @returns - Returns itself.
   */
  invalidate() {
    return this.vertexBuffer._updateID++, this.uvBuffer._updateID++, this;
  }
}
class pbe {
  constructor() {
    this.renderTexture = null, this.target = null, this.legacy = !1, this.resolution = 1, this.multisample = jr.NONE, this.sourceFrame = new Pt(), this.destinationFrame = new Pt(), this.bindingSourceFrame = new Pt(), this.bindingDestinationFrame = new Pt(), this.filters = [], this.transform = null;
  }
  /** Clears the state */
  clear() {
    this.target = null, this.filters = null, this.renderTexture = null;
  }
}
const kg = [new Rt(), new Rt(), new Rt(), new Rt()], _b = new Qn();
class _B {
  /**
   * @param renderer - The renderer this System works for.
   */
  constructor(e) {
    this.renderer = e, this.defaultFilterStack = [{}], this.texturePool = new gB(), this.statePool = [], this.quad = new cbe(), this.quadUv = new vB(), this.tempRect = new Pt(), this.activeState = {}, this.globalUniforms = new di({
      outputFrame: new Pt(),
      inputSize: new Float32Array(4),
      inputPixel: new Float32Array(4),
      inputClamp: new Float32Array(4),
      resolution: 1,
      // legacy variables
      filterArea: new Float32Array(4),
      filterClamp: new Float32Array(4)
    }, !0), this.forceClear = !1, this.useMaxPadding = !1;
  }
  init() {
    this.texturePool.setScreenSize(this.renderer.view);
  }
  /**
   * Pushes a set of filters to be applied later to the system. This will redirect further rendering into an
   * input render-texture for the rest of the filtering pipeline.
   * @param {PIXI.DisplayObject} target - The target of the filter to render.
   * @param filters - The filters to apply.
   */
  push(e, n) {
    const r = this.renderer, o = this.defaultFilterStack, s = this.statePool.pop() || new pbe(), i = r.renderTexture;
    let u, l;
    if (i.current) {
      const _ = i.current;
      u = _.resolution, l = _.multisample;
    } else
      u = r.resolution, l = r.multisample;
    let a = n[0].resolution || u, c = n[0].multisample ?? l, p = n[0].padding, d = n[0].autoFit, h = n[0].legacy ?? !0;
    for (let _ = 1; _ < n.length; _++) {
      const b = n[_];
      a = Math.min(a, b.resolution || u), c = Math.min(c, b.multisample ?? l), p = this.useMaxPadding ? Math.max(p, b.padding) : p + b.padding, d = d && b.autoFit, h = h || (b.legacy ?? !0);
    }
    o.length === 1 && (this.defaultFilterStack[0].renderTexture = i.current), o.push(s), s.resolution = a, s.multisample = c, s.legacy = h, s.target = e, s.sourceFrame.copyFrom(e.filterArea || e.getBounds(!0)), s.sourceFrame.pad(p);
    const m = this.tempRect.copyFrom(i.sourceFrame);
    r.projection.transform && this.transformAABB(
      _b.copyFrom(r.projection.transform).invert(),
      m
    ), d ? (s.sourceFrame.fit(m), (s.sourceFrame.width <= 0 || s.sourceFrame.height <= 0) && (s.sourceFrame.width = 0, s.sourceFrame.height = 0)) : s.sourceFrame.intersects(m) || (s.sourceFrame.width = 0, s.sourceFrame.height = 0), this.roundFrame(
      s.sourceFrame,
      i.current ? i.current.resolution : r.resolution,
      i.sourceFrame,
      i.destinationFrame,
      r.projection.transform
    ), s.renderTexture = this.getOptimalFilterTexture(
      s.sourceFrame.width,
      s.sourceFrame.height,
      a,
      c
    ), s.filters = n, s.destinationFrame.width = s.renderTexture.width, s.destinationFrame.height = s.renderTexture.height;
    const g = this.tempRect;
    g.x = 0, g.y = 0, g.width = s.sourceFrame.width, g.height = s.sourceFrame.height, s.renderTexture.filterFrame = s.sourceFrame, s.bindingSourceFrame.copyFrom(i.sourceFrame), s.bindingDestinationFrame.copyFrom(i.destinationFrame), s.transform = r.projection.transform, r.projection.transform = null, i.bind(s.renderTexture, s.sourceFrame, g), r.framebuffer.clear(0, 0, 0, 0);
  }
  /** Pops off the filter and applies it. */
  pop() {
    const e = this.defaultFilterStack, n = e.pop(), r = n.filters;
    this.activeState = n;
    const o = this.globalUniforms.uniforms;
    o.outputFrame = n.sourceFrame, o.resolution = n.resolution;
    const s = o.inputSize, i = o.inputPixel, u = o.inputClamp;
    if (s[0] = n.destinationFrame.width, s[1] = n.destinationFrame.height, s[2] = 1 / s[0], s[3] = 1 / s[1], i[0] = Math.round(s[0] * n.resolution), i[1] = Math.round(s[1] * n.resolution), i[2] = 1 / i[0], i[3] = 1 / i[1], u[0] = 0.5 * i[2], u[1] = 0.5 * i[3], u[2] = n.sourceFrame.width * s[2] - 0.5 * i[2], u[3] = n.sourceFrame.height * s[3] - 0.5 * i[3], n.legacy) {
      const a = o.filterArea;
      a[0] = n.destinationFrame.width, a[1] = n.destinationFrame.height, a[2] = n.sourceFrame.x, a[3] = n.sourceFrame.y, o.filterClamp = o.inputClamp;
    }
    this.globalUniforms.update();
    const l = e[e.length - 1];
    if (this.renderer.framebuffer.blit(), r.length === 1)
      r[0].apply(this, n.renderTexture, l.renderTexture, Gi.BLEND, n), this.returnFilterTexture(n.renderTexture);
    else {
      let a = n.renderTexture, c = this.getOptimalFilterTexture(
        a.width,
        a.height,
        n.resolution
      );
      c.filterFrame = a.filterFrame;
      let p = 0;
      for (p = 0; p < r.length - 1; ++p) {
        p === 1 && n.multisample > 1 && (c = this.getOptimalFilterTexture(
          a.width,
          a.height,
          n.resolution
        ), c.filterFrame = a.filterFrame), r[p].apply(this, a, c, Gi.CLEAR, n);
        const d = a;
        a = c, c = d;
      }
      r[p].apply(this, a, l.renderTexture, Gi.BLEND, n), p > 1 && n.multisample > 1 && this.returnFilterTexture(n.renderTexture), this.returnFilterTexture(a), this.returnFilterTexture(c);
    }
    n.clear(), this.statePool.push(n);
  }
  /**
   * Binds a renderTexture with corresponding `filterFrame`, clears it if mode corresponds.
   * @param filterTexture - renderTexture to bind, should belong to filter pool or filter stack
   * @param clearMode - clearMode, by default its CLEAR/YES. See {@link PIXI.CLEAR_MODES}
   */
  bindAndClear(e, n = Gi.CLEAR) {
    const {
      renderTexture: r,
      state: o
    } = this.renderer;
    if (e === this.defaultFilterStack[this.defaultFilterStack.length - 1].renderTexture ? this.renderer.projection.transform = this.activeState.transform : this.renderer.projection.transform = null, e?.filterFrame) {
      const i = this.tempRect;
      i.x = 0, i.y = 0, i.width = e.filterFrame.width, i.height = e.filterFrame.height, r.bind(e, e.filterFrame, i);
    } else
      e !== this.defaultFilterStack[this.defaultFilterStack.length - 1].renderTexture ? r.bind(e) : this.renderer.renderTexture.bind(
        e,
        this.activeState.bindingSourceFrame,
        this.activeState.bindingDestinationFrame
      );
    const s = o.stateId & 1 || this.forceClear;
    (n === Gi.CLEAR || n === Gi.BLIT && s) && this.renderer.framebuffer.clear(0, 0, 0, 0);
  }
  /**
   * Draws a filter using the default rendering process.
   *
   * This should be called only by {@link PIXI.Filter#apply}.
   * @param filter - The filter to draw.
   * @param input - The input render target.
   * @param output - The target to output to.
   * @param clearMode - Should the output be cleared before rendering to it
   */
  applyFilter(e, n, r, o) {
    const s = this.renderer;
    s.state.set(e.state), this.bindAndClear(r, o), e.uniforms.uSampler = n, e.uniforms.filterGlobals = this.globalUniforms, s.shader.bind(e), e.legacy = !!e.program.attributeData.aTextureCoord, e.legacy ? (this.quadUv.map(n._frame, n.filterFrame), s.geometry.bind(this.quadUv), s.geometry.draw(Zi.TRIANGLES)) : (s.geometry.bind(this.quad), s.geometry.draw(Zi.TRIANGLE_STRIP));
  }
  /**
   * Multiply _input normalized coordinates_ to this matrix to get _sprite texture normalized coordinates_.
   *
   * Use `outputMatrix * vTextureCoord` in the shader.
   * @param outputMatrix - The matrix to output to.
   * @param {PIXI.Sprite} sprite - The sprite to map to.
   * @returns The mapped matrix.
   */
  calculateSpriteMatrix(e, n) {
    const { sourceFrame: r, destinationFrame: o } = this.activeState, { orig: s } = n._texture, i = e.set(
      o.width,
      0,
      0,
      o.height,
      r.x,
      r.y
    ), u = n.worldTransform.copyTo(Qn.TEMP_MATRIX);
    return u.invert(), i.prepend(u), i.scale(1 / s.width, 1 / s.height), i.translate(n.anchor.x, n.anchor.y), i;
  }
  /** Destroys this Filter System. */
  destroy() {
    this.renderer = null, this.texturePool.clear(!1);
  }
  /**
   * Gets a Power-of-Two render texture or fullScreen texture
   * @param minWidth - The minimum width of the render texture in real pixels.
   * @param minHeight - The minimum height of the render texture in real pixels.
   * @param resolution - The resolution of the render texture.
   * @param multisample - Number of samples of the render texture.
   * @returns - The new render texture.
   */
  getOptimalFilterTexture(e, n, r = 1, o = jr.NONE) {
    return this.texturePool.getOptimalTexture(e, n, r, o);
  }
  /**
   * Gets extra render texture to use inside current filter
   * To be compliant with older filters, you can use params in any order
   * @param input - renderTexture from which size and resolution will be copied
   * @param resolution - override resolution of the renderTexture
   * @param multisample - number of samples of the renderTexture
   */
  getFilterTexture(e, n, r) {
    if (typeof e == "number") {
      const s = e;
      e = n, n = s;
    }
    e = e || this.activeState.renderTexture;
    const o = this.texturePool.getOptimalTexture(
      e.width,
      e.height,
      n || e.resolution,
      r || jr.NONE
    );
    return o.filterFrame = e.filterFrame, o;
  }
  /**
   * Frees a render texture back into the pool.
   * @param renderTexture - The renderTarget to free
   */
  returnFilterTexture(e) {
    this.texturePool.returnTexture(e);
  }
  /** Empties the texture pool. */
  emptyPool() {
    this.texturePool.clear(!0);
  }
  /** Calls `texturePool.resize()`, affects fullScreen renderTextures. */
  resize() {
    this.texturePool.setScreenSize(this.renderer.view);
  }
  /**
   * @param matrix - first param
   * @param rect - second param
   */
  transformAABB(e, n) {
    const r = kg[0], o = kg[1], s = kg[2], i = kg[3];
    r.set(n.left, n.top), o.set(n.left, n.bottom), s.set(n.right, n.top), i.set(n.right, n.bottom), e.apply(r, r), e.apply(o, o), e.apply(s, s), e.apply(i, i);
    const u = Math.min(r.x, o.x, s.x, i.x), l = Math.min(r.y, o.y, s.y, i.y), a = Math.max(r.x, o.x, s.x, i.x), c = Math.max(r.y, o.y, s.y, i.y);
    n.x = u, n.y = l, n.width = a - u, n.height = c - l;
  }
  roundFrame(e, n, r, o, s) {
    if (!(e.width <= 0 || e.height <= 0 || r.width <= 0 || r.height <= 0)) {
      if (s) {
        const { a: i, b: u, c: l, d: a } = s;
        if ((Math.abs(u) > 1e-4 || Math.abs(l) > 1e-4) && (Math.abs(i) > 1e-4 || Math.abs(a) > 1e-4))
          return;
      }
      s = s ? _b.copyFrom(s) : _b.identity(), s.translate(-r.x, -r.y).scale(
        o.width / r.width,
        o.height / r.height
      ).translate(o.x, o.y), this.transformAABB(s, e), e.ceil(n), this.transformAABB(s.invert(), e);
    }
  }
}
_B.extension = {
  type: rt.RendererSystem,
  name: "filter"
};
dt.add(_B);
class dbe {
  constructor(e) {
    this.framebuffer = e, this.stencil = null, this.dirtyId = -1, this.dirtyFormat = -1, this.dirtySize = -1, this.multisample = jr.NONE, this.msaaBuffer = null, this.blitFramebuffer = null, this.mipLevel = 0;
  }
}
const hbe = new Pt();
class wB {
  /**
   * @param renderer - The renderer this System works for.
   */
  constructor(e) {
    this.renderer = e, this.managedFramebuffers = [], this.unknownFramebuffer = new cT(10, 10), this.msaaSamples = null;
  }
  /** Sets up the renderer context and necessary buffers. */
  contextChange() {
    this.disposeAll(!0);
    const e = this.gl = this.renderer.gl;
    if (this.CONTEXT_UID = this.renderer.CONTEXT_UID, this.current = this.unknownFramebuffer, this.viewport = new Pt(), this.hasMRT = !0, this.writeDepthTexture = !0, this.renderer.context.webGLVersion === 1) {
      let n = this.renderer.context.extensions.drawBuffers, r = this.renderer.context.extensions.depthTexture;
      at.PREFER_ENV === nd.WEBGL_LEGACY && (n = null, r = null), n ? e.drawBuffers = (o) => n.drawBuffersWEBGL(o) : (this.hasMRT = !1, e.drawBuffers = () => {
      }), r || (this.writeDepthTexture = !1);
    } else
      this.msaaSamples = e.getInternalformatParameter(e.RENDERBUFFER, e.RGBA8, e.SAMPLES);
  }
  /**
   * Bind a framebuffer.
   * @param framebuffer
   * @param frame - frame, default is framebuffer size
   * @param mipLevel - optional mip level to set on the framebuffer - defaults to 0
   */
  bind(e, n, r = 0) {
    const { gl: o } = this;
    if (e) {
      const s = e.glFramebuffers[this.CONTEXT_UID] || this.initFramebuffer(e);
      this.current !== e && (this.current = e, o.bindFramebuffer(o.FRAMEBUFFER, s.framebuffer)), s.mipLevel !== r && (e.dirtyId++, e.dirtyFormat++, s.mipLevel = r), s.dirtyId !== e.dirtyId && (s.dirtyId = e.dirtyId, s.dirtyFormat !== e.dirtyFormat ? (s.dirtyFormat = e.dirtyFormat, s.dirtySize = e.dirtySize, this.updateFramebuffer(e, r)) : s.dirtySize !== e.dirtySize && (s.dirtySize = e.dirtySize, this.resizeFramebuffer(e)));
      for (let i = 0; i < e.colorTextures.length; i++) {
        const u = e.colorTextures[i];
        this.renderer.texture.unbind(u.parentTextureArray || u);
      }
      if (e.depthTexture && this.renderer.texture.unbind(e.depthTexture), n) {
        const i = n.width >> r, u = n.height >> r, l = i / n.width;
        this.setViewport(
          n.x * l,
          n.y * l,
          i,
          u
        );
      } else {
        const i = e.width >> r, u = e.height >> r;
        this.setViewport(0, 0, i, u);
      }
    } else
      this.current && (this.current = null, o.bindFramebuffer(o.FRAMEBUFFER, null)), n ? this.setViewport(n.x, n.y, n.width, n.height) : this.setViewport(0, 0, this.renderer.width, this.renderer.height);
  }
  /**
   * Set the WebGLRenderingContext's viewport.
   * @param x - X position of viewport
   * @param y - Y position of viewport
   * @param width - Width of viewport
   * @param height - Height of viewport
   */
  setViewport(e, n, r, o) {
    const s = this.viewport;
    e = Math.round(e), n = Math.round(n), r = Math.round(r), o = Math.round(o), (s.width !== r || s.height !== o || s.x !== e || s.y !== n) && (s.x = e, s.y = n, s.width = r, s.height = o, this.gl.viewport(e, n, r, o));
  }
  /**
   * Get the size of the current width and height. Returns object with `width` and `height` values.
   * @readonly
   */
  get size() {
    return this.current ? { x: 0, y: 0, width: this.current.width, height: this.current.height } : { x: 0, y: 0, width: this.renderer.width, height: this.renderer.height };
  }
  /**
   * Clear the color of the context
   * @param r - Red value from 0 to 1
   * @param g - Green value from 0 to 1
   * @param b - Blue value from 0 to 1
   * @param a - Alpha value from 0 to 1
   * @param {PIXI.BUFFER_BITS} [mask=BUFFER_BITS.COLOR | BUFFER_BITS.DEPTH] - Bitwise OR of masks
   *  that indicate the buffers to be cleared, by default COLOR and DEPTH buffers.
   */
  clear(e, n, r, o, s = Yk.COLOR | Yk.DEPTH) {
    const { gl: i } = this;
    i.clearColor(e, n, r, o), i.clear(s);
  }
  /**
   * Initialize framebuffer for this context
   * @protected
   * @param framebuffer
   * @returns - created GLFramebuffer
   */
  initFramebuffer(e) {
    const { gl: n } = this, r = new dbe(n.createFramebuffer());
    return r.multisample = this.detectSamples(e.multisample), e.glFramebuffers[this.CONTEXT_UID] = r, this.managedFramebuffers.push(e), e.disposeRunner.add(this), r;
  }
  /**
   * Resize the framebuffer
   * @param framebuffer
   * @protected
   */
  resizeFramebuffer(e) {
    const { gl: n } = this, r = e.glFramebuffers[this.CONTEXT_UID];
    if (r.stencil) {
      n.bindRenderbuffer(n.RENDERBUFFER, r.stencil);
      let i;
      this.renderer.context.webGLVersion === 1 ? i = n.DEPTH_STENCIL : e.depth && e.stencil ? i = n.DEPTH24_STENCIL8 : e.depth ? i = n.DEPTH_COMPONENT24 : i = n.STENCIL_INDEX8, r.msaaBuffer ? n.renderbufferStorageMultisample(
        n.RENDERBUFFER,
        r.multisample,
        i,
        e.width,
        e.height
      ) : n.renderbufferStorage(n.RENDERBUFFER, i, e.width, e.height);
    }
    const o = e.colorTextures;
    let s = o.length;
    n.drawBuffers || (s = Math.min(s, 1));
    for (let i = 0; i < s; i++) {
      const u = o[i], l = u.parentTextureArray || u;
      this.renderer.texture.bind(l, 0), i === 0 && r.msaaBuffer && (n.bindRenderbuffer(n.RENDERBUFFER, r.msaaBuffer), n.renderbufferStorageMultisample(
        n.RENDERBUFFER,
        r.multisample,
        l._glTextures[this.CONTEXT_UID].internalFormat,
        e.width,
        e.height
      ));
    }
    e.depthTexture && this.writeDepthTexture && this.renderer.texture.bind(e.depthTexture, 0);
  }
  /**
   * Update the framebuffer
   * @param framebuffer
   * @param mipLevel
   * @protected
   */
  updateFramebuffer(e, n) {
    const { gl: r } = this, o = e.glFramebuffers[this.CONTEXT_UID], s = e.colorTextures;
    let i = s.length;
    r.drawBuffers || (i = Math.min(i, 1)), o.multisample > 1 && this.canMultisampleFramebuffer(e) ? o.msaaBuffer = o.msaaBuffer || r.createRenderbuffer() : o.msaaBuffer && (r.deleteRenderbuffer(o.msaaBuffer), o.msaaBuffer = null, o.blitFramebuffer && (o.blitFramebuffer.dispose(), o.blitFramebuffer = null));
    const u = [];
    for (let l = 0; l < i; l++) {
      const a = s[l], c = a.parentTextureArray || a;
      this.renderer.texture.bind(c, 0), l === 0 && o.msaaBuffer ? (r.bindRenderbuffer(r.RENDERBUFFER, o.msaaBuffer), r.renderbufferStorageMultisample(
        r.RENDERBUFFER,
        o.multisample,
        c._glTextures[this.CONTEXT_UID].internalFormat,
        e.width,
        e.height
      ), r.framebufferRenderbuffer(r.FRAMEBUFFER, r.COLOR_ATTACHMENT0, r.RENDERBUFFER, o.msaaBuffer)) : (r.framebufferTexture2D(
        r.FRAMEBUFFER,
        r.COLOR_ATTACHMENT0 + l,
        a.target,
        c._glTextures[this.CONTEXT_UID].texture,
        n
      ), u.push(r.COLOR_ATTACHMENT0 + l));
    }
    if (u.length > 1 && r.drawBuffers(u), e.depthTexture && this.writeDepthTexture) {
      const l = e.depthTexture;
      this.renderer.texture.bind(l, 0), r.framebufferTexture2D(
        r.FRAMEBUFFER,
        r.DEPTH_ATTACHMENT,
        r.TEXTURE_2D,
        l._glTextures[this.CONTEXT_UID].texture,
        n
      );
    }
    if ((e.stencil || e.depth) && !(e.depthTexture && this.writeDepthTexture)) {
      o.stencil = o.stencil || r.createRenderbuffer();
      let l, a;
      this.renderer.context.webGLVersion === 1 ? (l = r.DEPTH_STENCIL_ATTACHMENT, a = r.DEPTH_STENCIL) : e.depth && e.stencil ? (l = r.DEPTH_STENCIL_ATTACHMENT, a = r.DEPTH24_STENCIL8) : e.depth ? (l = r.DEPTH_ATTACHMENT, a = r.DEPTH_COMPONENT24) : (l = r.STENCIL_ATTACHMENT, a = r.STENCIL_INDEX8), r.bindRenderbuffer(r.RENDERBUFFER, o.stencil), o.msaaBuffer ? r.renderbufferStorageMultisample(
        r.RENDERBUFFER,
        o.multisample,
        a,
        e.width,
        e.height
      ) : r.renderbufferStorage(r.RENDERBUFFER, a, e.width, e.height), r.framebufferRenderbuffer(r.FRAMEBUFFER, l, r.RENDERBUFFER, o.stencil);
    } else
      o.stencil && (r.deleteRenderbuffer(o.stencil), o.stencil = null);
  }
  /**
   * Returns true if the frame buffer can be multisampled.
   * @param framebuffer
   */
  canMultisampleFramebuffer(e) {
    return this.renderer.context.webGLVersion !== 1 && e.colorTextures.length <= 1 && !e.depthTexture;
  }
  /**
   * Detects number of samples that is not more than a param but as close to it as possible
   * @param samples - number of samples
   * @returns - recommended number of samples
   */
  detectSamples(e) {
    const { msaaSamples: n } = this;
    let r = jr.NONE;
    if (e <= 1 || n === null)
      return r;
    for (let o = 0; o < n.length; o++)
      if (n[o] <= e) {
        r = n[o];
        break;
      }
    return r === 1 && (r = jr.NONE), r;
  }
  /**
   * Only works with WebGL2
   *
   * blits framebuffer to another of the same or bigger size
   * after that target framebuffer is bound
   *
   * Fails with WebGL warning if blits multisample framebuffer to different size
   * @param framebuffer - by default it blits "into itself", from renderBuffer to texture.
   * @param sourcePixels - source rectangle in pixels
   * @param destPixels - dest rectangle in pixels, assumed to be the same as sourcePixels
   */
  blit(e, n, r) {
    const { current: o, renderer: s, gl: i, CONTEXT_UID: u } = this;
    if (s.context.webGLVersion !== 2 || !o)
      return;
    const l = o.glFramebuffers[u];
    if (!l)
      return;
    if (!e) {
      if (!l.msaaBuffer)
        return;
      const c = o.colorTextures[0];
      if (!c)
        return;
      l.blitFramebuffer || (l.blitFramebuffer = new cT(o.width, o.height), l.blitFramebuffer.addColorTexture(0, c)), e = l.blitFramebuffer, e.colorTextures[0] !== c && (e.colorTextures[0] = c, e.dirtyId++, e.dirtyFormat++), (e.width !== o.width || e.height !== o.height) && (e.width = o.width, e.height = o.height, e.dirtyId++, e.dirtySize++);
    }
    n || (n = hbe, n.width = o.width, n.height = o.height), r || (r = n);
    const a = n.width === r.width && n.height === r.height;
    this.bind(e), i.bindFramebuffer(i.READ_FRAMEBUFFER, l.framebuffer), i.blitFramebuffer(
      n.left,
      n.top,
      n.right,
      n.bottom,
      r.left,
      r.top,
      r.right,
      r.bottom,
      i.COLOR_BUFFER_BIT,
      a ? i.NEAREST : i.LINEAR
    ), i.bindFramebuffer(i.READ_FRAMEBUFFER, e.glFramebuffers[this.CONTEXT_UID].framebuffer);
  }
  /**
   * Disposes framebuffer.
   * @param framebuffer - framebuffer that has to be disposed of
   * @param contextLost - If context was lost, we suppress all delete function calls
   */
  disposeFramebuffer(e, n) {
    const r = e.glFramebuffers[this.CONTEXT_UID], o = this.gl;
    if (!r)
      return;
    delete e.glFramebuffers[this.CONTEXT_UID];
    const s = this.managedFramebuffers.indexOf(e);
    s >= 0 && this.managedFramebuffers.splice(s, 1), e.disposeRunner.remove(this), n || (o.deleteFramebuffer(r.framebuffer), r.msaaBuffer && o.deleteRenderbuffer(r.msaaBuffer), r.stencil && o.deleteRenderbuffer(r.stencil)), r.blitFramebuffer && this.disposeFramebuffer(r.blitFramebuffer, n);
  }
  /**
   * Disposes all framebuffers, but not textures bound to them.
   * @param [contextLost=false] - If context was lost, we suppress all delete function calls
   */
  disposeAll(e) {
    const n = this.managedFramebuffers;
    this.managedFramebuffers = [];
    for (let r = 0; r < n.length; r++)
      this.disposeFramebuffer(n[r], e);
  }
  /**
   * Forcing creation of stencil buffer for current framebuffer, if it wasn't done before.
   * Used by MaskSystem, when its time to use stencil mask for Graphics element.
   *
   * Its an alternative for public lazy `framebuffer.enableStencil`, in case we need stencil without rebind.
   * @private
   */
  forceStencil() {
    const e = this.current;
    if (!e)
      return;
    const n = e.glFramebuffers[this.CONTEXT_UID];
    if (!n || n.stencil && e.stencil)
      return;
    e.stencil = !0;
    const r = e.width, o = e.height, s = this.gl, i = n.stencil = s.createRenderbuffer();
    s.bindRenderbuffer(s.RENDERBUFFER, i);
    let u, l;
    this.renderer.context.webGLVersion === 1 ? (u = s.DEPTH_STENCIL_ATTACHMENT, l = s.DEPTH_STENCIL) : e.depth ? (u = s.DEPTH_STENCIL_ATTACHMENT, l = s.DEPTH24_STENCIL8) : (u = s.STENCIL_ATTACHMENT, l = s.STENCIL_INDEX8), n.msaaBuffer ? s.renderbufferStorageMultisample(s.RENDERBUFFER, n.multisample, l, r, o) : s.renderbufferStorage(s.RENDERBUFFER, l, r, o), s.framebufferRenderbuffer(s.FRAMEBUFFER, u, s.RENDERBUFFER, i);
  }
  /** Resets framebuffer stored state, binds screen framebuffer. Should be called before renderTexture reset(). */
  reset() {
    this.current = this.unknownFramebuffer, this.viewport = new Pt();
  }
  destroy() {
    this.renderer = null;
  }
}
wB.extension = {
  type: rt.RendererSystem,
  name: "framebuffer"
};
dt.add(wB);
const wb = { 5126: 4, 5123: 2, 5121: 1 };
class bB {
  /** @param renderer - The renderer this System works for. */
  constructor(e) {
    this.renderer = e, this._activeGeometry = null, this._activeVao = null, this.hasVao = !0, this.hasInstance = !0, this.canUseUInt32ElementIndex = !1, this.managedGeometries = {};
  }
  /** Sets up the renderer context and necessary buffers. */
  contextChange() {
    this.disposeAll(!0);
    const e = this.gl = this.renderer.gl, n = this.renderer.context;
    if (this.CONTEXT_UID = this.renderer.CONTEXT_UID, n.webGLVersion !== 2) {
      let r = this.renderer.context.extensions.vertexArrayObject;
      at.PREFER_ENV === nd.WEBGL_LEGACY && (r = null), r ? (e.createVertexArray = () => r.createVertexArrayOES(), e.bindVertexArray = (o) => r.bindVertexArrayOES(o), e.deleteVertexArray = (o) => r.deleteVertexArrayOES(o)) : (this.hasVao = !1, e.createVertexArray = () => null, e.bindVertexArray = () => null, e.deleteVertexArray = () => null);
    }
    if (n.webGLVersion !== 2) {
      const r = e.getExtension("ANGLE_instanced_arrays");
      r ? (e.vertexAttribDivisor = (o, s) => r.vertexAttribDivisorANGLE(o, s), e.drawElementsInstanced = (o, s, i, u, l) => r.drawElementsInstancedANGLE(o, s, i, u, l), e.drawArraysInstanced = (o, s, i, u) => r.drawArraysInstancedANGLE(o, s, i, u)) : this.hasInstance = !1;
    }
    this.canUseUInt32ElementIndex = n.webGLVersion === 2 || !!n.extensions.uint32ElementIndex;
  }
  /**
   * Binds geometry so that is can be drawn. Creating a Vao if required
   * @param geometry - Instance of geometry to bind.
   * @param shader - Instance of shader to use vao for.
   */
  bind(e, n) {
    n = n || this.renderer.shader.shader;
    const { gl: r } = this;
    let o = e.glVertexArrayObjects[this.CONTEXT_UID], s = !1;
    o || (this.managedGeometries[e.id] = e, e.disposeRunner.add(this), e.glVertexArrayObjects[this.CONTEXT_UID] = o = {}, s = !0);
    const i = o[n.program.id] || this.initGeometryVao(e, n, s);
    this._activeGeometry = e, this._activeVao !== i && (this._activeVao = i, this.hasVao ? r.bindVertexArray(i) : this.activateVao(e, n.program)), this.updateBuffers();
  }
  /** Reset and unbind any active VAO and geometry. */
  reset() {
    this.unbind();
  }
  /** Update buffers of the currently bound geometry. */
  updateBuffers() {
    const e = this._activeGeometry, n = this.renderer.buffer;
    for (let r = 0; r < e.buffers.length; r++) {
      const o = e.buffers[r];
      n.update(o);
    }
  }
  /**
   * Check compatibility between a geometry and a program
   * @param geometry - Geometry instance.
   * @param program - Program instance.
   */
  checkCompatibility(e, n) {
    const r = e.attributes, o = n.attributeData;
    for (const s in o)
      if (!r[s])
        throw new Error(`shader and geometry incompatible, geometry missing the "${s}" attribute`);
  }
  /**
   * Takes a geometry and program and generates a unique signature for them.
   * @param geometry - To get signature from.
   * @param program - To test geometry against.
   * @returns - Unique signature of the geometry and program
   */
  getSignature(e, n) {
    const r = e.attributes, o = n.attributeData, s = ["g", e.id];
    for (const i in r)
      o[i] && s.push(i, o[i].location);
    return s.join("-");
  }
  /**
   * Creates or gets Vao with the same structure as the geometry and stores it on the geometry.
   * If vao is created, it is bound automatically. We use a shader to infer what and how to set up the
   * attribute locations.
   * @param geometry - Instance of geometry to to generate Vao for.
   * @param shader - Instance of the shader.
   * @param incRefCount - Increment refCount of all geometry buffers.
   */
  initGeometryVao(e, n, r = !0) {
    const o = this.gl, s = this.CONTEXT_UID, i = this.renderer.buffer, u = n.program;
    u.glPrograms[s] || this.renderer.shader.generateProgram(n), this.checkCompatibility(e, u);
    const l = this.getSignature(e, u), a = e.glVertexArrayObjects[this.CONTEXT_UID];
    let c = a[l];
    if (c)
      return a[u.id] = c, c;
    const p = e.buffers, d = e.attributes, h = {}, m = {};
    for (const g in p)
      h[g] = 0, m[g] = 0;
    for (const g in d)
      !d[g].size && u.attributeData[g] ? d[g].size = u.attributeData[g].size : d[g].size || console.warn(`PIXI Geometry attribute '${g}' size cannot be determined (likely the bound shader does not have the attribute)`), h[d[g].buffer] += d[g].size * wb[d[g].type];
    for (const g in d) {
      const _ = d[g], b = _.size;
      _.stride === void 0 && (h[_.buffer] === b * wb[_.type] ? _.stride = 0 : _.stride = h[_.buffer]), _.start === void 0 && (_.start = m[_.buffer], m[_.buffer] += b * wb[_.type]);
    }
    c = o.createVertexArray(), o.bindVertexArray(c);
    for (let g = 0; g < p.length; g++) {
      const _ = p[g];
      i.bind(_), r && _._glBuffers[s].refCount++;
    }
    return this.activateVao(e, u), a[u.id] = c, a[l] = c, o.bindVertexArray(null), i.unbind(au.ARRAY_BUFFER), c;
  }
  /**
   * Disposes geometry.
   * @param geometry - Geometry with buffers. Only VAO will be disposed
   * @param [contextLost=false] - If context was lost, we suppress deleteVertexArray
   */
  disposeGeometry(e, n) {
    if (!this.managedGeometries[e.id])
      return;
    delete this.managedGeometries[e.id];
    const r = e.glVertexArrayObjects[this.CONTEXT_UID], o = this.gl, s = e.buffers, i = this.renderer?.buffer;
    if (e.disposeRunner.remove(this), !!r) {
      if (i)
        for (let u = 0; u < s.length; u++) {
          const l = s[u]._glBuffers[this.CONTEXT_UID];
          l && (l.refCount--, l.refCount === 0 && !n && i.dispose(s[u], n));
        }
      if (!n) {
        for (const u in r)
          if (u[0] === "g") {
            const l = r[u];
            this._activeVao === l && this.unbind(), o.deleteVertexArray(l);
          }
      }
      delete e.glVertexArrayObjects[this.CONTEXT_UID];
    }
  }
  /**
   * Dispose all WebGL resources of all managed geometries.
   * @param [contextLost=false] - If context was lost, we suppress `gl.delete` calls
   */
  disposeAll(e) {
    const n = Object.keys(this.managedGeometries);
    for (let r = 0; r < n.length; r++)
      this.disposeGeometry(this.managedGeometries[n[r]], e);
  }
  /**
   * Activate vertex array object.
   * @param geometry - Geometry instance.
   * @param program - Shader program instance.
   */
  activateVao(e, n) {
    const r = this.gl, o = this.CONTEXT_UID, s = this.renderer.buffer, i = e.buffers, u = e.attributes;
    e.indexBuffer && s.bind(e.indexBuffer);
    let l = null;
    for (const a in u) {
      const c = u[a], p = i[c.buffer], d = p._glBuffers[o];
      if (n.attributeData[a]) {
        l !== d && (s.bind(p), l = d);
        const h = n.attributeData[a].location;
        if (r.enableVertexAttribArray(h), r.vertexAttribPointer(
          h,
          c.size,
          c.type || r.FLOAT,
          c.normalized,
          c.stride,
          c.start
        ), c.instance)
          if (this.hasInstance)
            r.vertexAttribDivisor(h, c.divisor);
          else
            throw new Error("geometry error, GPU Instancing is not supported on this device");
      }
    }
  }
  /**
   * Draws the currently bound geometry.
   * @param type - The type primitive to render.
   * @param size - The number of elements to be rendered. If not specified, all vertices after the
   *  starting vertex will be drawn.
   * @param start - The starting vertex in the geometry to start drawing from. If not specified,
   *  drawing will start from the first vertex.
   * @param instanceCount - The number of instances of the set of elements to execute. If not specified,
   *  all instances will be drawn.
   */
  draw(e, n, r, o) {
    const { gl: s } = this, i = this._activeGeometry;
    if (i.indexBuffer) {
      const u = i.indexBuffer.data.BYTES_PER_ELEMENT, l = u === 2 ? s.UNSIGNED_SHORT : s.UNSIGNED_INT;
      u === 2 || u === 4 && this.canUseUInt32ElementIndex ? i.instanced ? s.drawElementsInstanced(e, n || i.indexBuffer.data.length, l, (r || 0) * u, o || 1) : s.drawElements(e, n || i.indexBuffer.data.length, l, (r || 0) * u) : console.warn("unsupported index buffer type: uint32");
    } else
      i.instanced ? s.drawArraysInstanced(e, r, n || i.getSize(), o || 1) : s.drawArrays(e, r, n || i.getSize());
    return this;
  }
  /** Unbind/reset everything. */
  unbind() {
    this.gl.bindVertexArray(null), this._activeVao = null, this._activeGeometry = null;
  }
  destroy() {
    this.renderer = null;
  }
}
bB.extension = {
  type: rt.RendererSystem,
  name: "geometry"
};
dt.add(bB);
const LC = new Qn();
class kB {
  /**
   * @param texture - observed texture
   * @param clampMargin - Changes frame clamping, 0.5 by default. Use -0.5 for extra border.
   */
  constructor(e, n) {
    this._texture = e, this.mapCoord = new Qn(), this.uClampFrame = new Float32Array(4), this.uClampOffset = new Float32Array(2), this._textureID = -1, this._updateID = 0, this.clampOffset = 0, this.clampMargin = typeof n > "u" ? 0.5 : n, this.isSimple = !1;
  }
  /** Texture property. */
  get texture() {
    return this._texture;
  }
  set texture(e) {
    this._texture = e, this._textureID = -1;
  }
  /**
   * Multiplies uvs array to transform
   * @param uvs - mesh uvs
   * @param [out=uvs] - output
   * @returns - output
   */
  multiplyUvs(e, n) {
    n === void 0 && (n = e);
    const r = this.mapCoord;
    for (let o = 0; o < e.length; o += 2) {
      const s = e[o], i = e[o + 1];
      n[o] = s * r.a + i * r.c + r.tx, n[o + 1] = s * r.b + i * r.d + r.ty;
    }
    return n;
  }
  /**
   * Updates matrices if texture was changed.
   * @param [forceUpdate=false] - if true, matrices will be updated any case
   * @returns - Whether or not it was updated
   */
  update(e) {
    const n = this._texture;
    if (!n || !n.valid || !e && this._textureID === n._updateID)
      return !1;
    this._textureID = n._updateID, this._updateID++;
    const r = n._uvs;
    this.mapCoord.set(r.x1 - r.x0, r.y1 - r.y0, r.x3 - r.x0, r.y3 - r.y0, r.x0, r.y0);
    const o = n.orig, s = n.trim;
    s && (LC.set(
      o.width / s.width,
      0,
      0,
      o.height / s.height,
      -s.x / s.width,
      -s.y / s.height
    ), this.mapCoord.append(LC));
    const i = n.baseTexture, u = this.uClampFrame, l = this.clampMargin / i.resolution, a = this.clampOffset;
    return u[0] = (n._frame.x + l + a) / i.width, u[1] = (n._frame.y + l + a) / i.height, u[2] = (n._frame.x + n._frame.width - l + a) / i.width, u[3] = (n._frame.y + n._frame.height - l + a) / i.height, this.uClampOffset[0] = a / i.realWidth, this.uClampOffset[1] = a / i.realHeight, this.isSimple = n._frame.width === i.width && n._frame.height === i.height && n.rotate === 0, !0;
  }
}
var fbe = `varying vec2 vMaskCoord;
varying vec2 vTextureCoord;

uniform sampler2D uSampler;
uniform sampler2D mask;
uniform float alpha;
uniform float npmAlpha;
uniform vec4 maskClamp;

void main(void)
{
    float clip = step(3.5,
        step(maskClamp.x, vMaskCoord.x) +
        step(maskClamp.y, vMaskCoord.y) +
        step(vMaskCoord.x, maskClamp.z) +
        step(vMaskCoord.y, maskClamp.w));

    vec4 original = texture2D(uSampler, vTextureCoord);
    vec4 masky = texture2D(mask, vMaskCoord);
    float alphaMul = 1.0 - npmAlpha * (1.0 - masky.a);

    original *= (alphaMul * masky.r * alpha * clip);

    gl_FragColor = original;
}
`, mbe = `attribute vec2 aVertexPosition;
attribute vec2 aTextureCoord;

uniform mat3 projectionMatrix;
uniform mat3 otherMatrix;

varying vec2 vMaskCoord;
varying vec2 vTextureCoord;

void main(void)
{
    gl_Position = vec4((projectionMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);

    vTextureCoord = aTextureCoord;
    vMaskCoord = ( otherMatrix * vec3( aTextureCoord, 1.0)  ).xy;
}
`;
class ybe extends Jo {
  /** @ignore */
  constructor(e, n, r) {
    let o = null;
    typeof e != "string" && n === void 0 && r === void 0 && (o = e, e = void 0, n = void 0, r = void 0), super(e || mbe, n || fbe, r), this.maskSprite = o, this.maskMatrix = new Qn();
  }
  /**
   * Sprite mask
   * @type {PIXI.DisplayObject}
   */
  get maskSprite() {
    return this._maskSprite;
  }
  set maskSprite(e) {
    this._maskSprite = e, this._maskSprite && (this._maskSprite.renderable = !1);
  }
  /**
   * Applies the filter
   * @param filterManager - The renderer to retrieve the filter from
   * @param input - The input render target.
   * @param output - The target to output to.
   * @param clearMode - Should the output be cleared before rendering to it.
   */
  apply(e, n, r, o) {
    const s = this._maskSprite, i = s._texture;
    i.valid && (i.uvMatrix || (i.uvMatrix = new kB(i, 0)), i.uvMatrix.update(), this.uniforms.npmAlpha = i.baseTexture.alphaMode ? 0 : 1, this.uniforms.mask = i, this.uniforms.otherMatrix = e.calculateSpriteMatrix(this.maskMatrix, s).prepend(i.uvMatrix.mapCoord), this.uniforms.alpha = s.worldAlpha, this.uniforms.maskClamp = i.uvMatrix.uClampFrame, e.applyFilter(this, n, r, o));
  }
}
class gbe {
  /**
   * Create MaskData
   * @param {PIXI.DisplayObject} [maskObject=null] - object that describes the mask
   */
  constructor(e = null) {
    this.type = io.NONE, this.autoDetect = !0, this.maskObject = e || null, this.pooled = !1, this.isMaskData = !0, this.resolution = null, this.multisample = Jo.defaultMultisample, this.enabled = !0, this.colorMask = 15, this._filters = null, this._stencilCounter = 0, this._scissorCounter = 0, this._scissorRect = null, this._scissorRectLocal = null, this._colorMask = 15, this._target = null;
  }
  /**
   * The sprite mask filter.
   * If set to `null`, the default sprite mask filter is used.
   * @default null
   */
  get filter() {
    return this._filters ? this._filters[0] : null;
  }
  set filter(e) {
    e ? this._filters ? this._filters[0] = e : this._filters = [e] : this._filters = null;
  }
  /** Resets the mask data after popMask(). */
  reset() {
    this.pooled && (this.maskObject = null, this.type = io.NONE, this.autoDetect = !0), this._target = null, this._scissorRectLocal = null;
  }
  /**
   * Copies counters from maskData above, called from pushMask().
   * @param maskAbove
   */
  copyCountersOrReset(e) {
    e ? (this._stencilCounter = e._stencilCounter, this._scissorCounter = e._scissorCounter, this._scissorRect = e._scissorRect) : (this._stencilCounter = 0, this._scissorCounter = 0, this._scissorRect = null);
  }
}
class TB {
  /**
   * @param renderer - The renderer this System works for.
   */
  constructor(e) {
    this.renderer = e, this.enableScissor = !0, this.alphaMaskPool = [], this.maskDataPool = [], this.maskStack = [], this.alphaMaskIndex = 0;
  }
  /**
   * Changes the mask stack that is used by this System.
   * @param maskStack - The mask stack
   */
  setMaskStack(e) {
    this.maskStack = e, this.renderer.scissor.setMaskStack(e), this.renderer.stencil.setMaskStack(e);
  }
  /**
   * Enables the mask and appends it to the current mask stack.
   *
   * NOTE: The batch renderer should be flushed beforehand to prevent pending renders from being masked.
   * @param {PIXI.DisplayObject} target - Display Object to push the mask to
   * @param {PIXI.MaskData|PIXI.Sprite|PIXI.Graphics|PIXI.DisplayObject} maskDataOrTarget - The masking data.
   */
  push(e, n) {
    let r = n;
    if (!r.isMaskData) {
      const s = this.maskDataPool.pop() || new gbe();
      s.pooled = !0, s.maskObject = n, r = s;
    }
    const o = this.maskStack.length !== 0 ? this.maskStack[this.maskStack.length - 1] : null;
    if (r.copyCountersOrReset(o), r._colorMask = o ? o._colorMask : 15, r.autoDetect && this.detect(r), r._target = e, r.type !== io.SPRITE && this.maskStack.push(r), r.enabled)
      switch (r.type) {
        case io.SCISSOR:
          this.renderer.scissor.push(r);
          break;
        case io.STENCIL:
          this.renderer.stencil.push(r);
          break;
        case io.SPRITE:
          r.copyCountersOrReset(null), this.pushSpriteMask(r);
          break;
        case io.COLOR:
          this.pushColorMask(r);
          break;
      }
    r.type === io.SPRITE && this.maskStack.push(r);
  }
  /**
   * Removes the last mask from the mask stack and doesn't return it.
   *
   * NOTE: The batch renderer should be flushed beforehand to render the masked contents before the mask is removed.
   * @param {PIXI.IMaskTarget} target - Display Object to pop the mask from
   */
  pop(e) {
    const n = this.maskStack.pop();
    if (!(!n || n._target !== e)) {
      if (n.enabled)
        switch (n.type) {
          case io.SCISSOR:
            this.renderer.scissor.pop(n);
            break;
          case io.STENCIL:
            this.renderer.stencil.pop(n.maskObject);
            break;
          case io.SPRITE:
            this.popSpriteMask(n);
            break;
          case io.COLOR:
            this.popColorMask(n);
            break;
        }
      if (n.reset(), n.pooled && this.maskDataPool.push(n), this.maskStack.length !== 0) {
        const r = this.maskStack[this.maskStack.length - 1];
        r.type === io.SPRITE && r._filters && (r._filters[0].maskSprite = r.maskObject);
      }
    }
  }
  /**
   * Sets type of MaskData based on its maskObject.
   * @param maskData
   */
  detect(e) {
    const n = e.maskObject;
    n ? n.isSprite ? e.type = io.SPRITE : this.enableScissor && this.renderer.scissor.testScissor(e) ? e.type = io.SCISSOR : e.type = io.STENCIL : e.type = io.COLOR;
  }
  /**
   * Applies the Mask and adds it to the current filter stack.
   * @param maskData - Sprite to be used as the mask.
   */
  pushSpriteMask(e) {
    const { maskObject: n } = e, r = e._target;
    let o = e._filters;
    o || (o = this.alphaMaskPool[this.alphaMaskIndex], o || (o = this.alphaMaskPool[this.alphaMaskIndex] = [new ybe()])), o[0].resolution = e.resolution, o[0].multisample = e.multisample, o[0].maskSprite = n;
    const s = r.filterArea;
    r.filterArea = n.getBounds(!0), this.renderer.filter.push(r, o), r.filterArea = s, e._filters || this.alphaMaskIndex++;
  }
  /**
   * Removes the last filter from the filter stack and doesn't return it.
   * @param maskData - Sprite to be used as the mask.
   */
  popSpriteMask(e) {
    this.renderer.filter.pop(), e._filters ? e._filters[0].maskSprite = null : (this.alphaMaskIndex--, this.alphaMaskPool[this.alphaMaskIndex][0].maskSprite = null);
  }
  /**
   * Pushes the color mask.
   * @param maskData - The mask data
   */
  pushColorMask(e) {
    const n = e._colorMask, r = e._colorMask = n & e.colorMask;
    r !== n && this.renderer.gl.colorMask(
      (r & 1) !== 0,
      (r & 2) !== 0,
      (r & 4) !== 0,
      (r & 8) !== 0
    );
  }
  /**
   * Pops the color mask.
   * @param maskData - The mask data
   */
  popColorMask(e) {
    const n = e._colorMask, r = this.maskStack.length > 0 ? this.maskStack[this.maskStack.length - 1]._colorMask : 15;
    r !== n && this.renderer.gl.colorMask(
      (r & 1) !== 0,
      (r & 2) !== 0,
      (r & 4) !== 0,
      (r & 8) !== 0
    );
  }
  destroy() {
    this.renderer = null;
  }
}
TB.extension = {
  type: rt.RendererSystem,
  name: "mask"
};
dt.add(TB);
class xB {
  /**
   * @param renderer - The renderer this System works for.
   */
  constructor(e) {
    this.renderer = e, this.maskStack = [], this.glConst = 0;
  }
  /** Gets count of masks of certain type. */
  getStackLength() {
    return this.maskStack.length;
  }
  /**
   * Changes the mask stack that is used by this System.
   * @param {PIXI.MaskData[]} maskStack - The mask stack
   */
  setMaskStack(e) {
    const { gl: n } = this.renderer, r = this.getStackLength();
    this.maskStack = e;
    const o = this.getStackLength();
    o !== r && (o === 0 ? n.disable(this.glConst) : (n.enable(this.glConst), this._useCurrent()));
  }
  /**
   * Setup renderer to use the current mask data.
   * @private
   */
  _useCurrent() {
  }
  /** Destroys the mask stack. */
  destroy() {
    this.renderer = null, this.maskStack = null;
  }
}
const BC = new Qn(), UC = [], SB = class n0 extends xB {
  /**
   * @param {PIXI.Renderer} renderer - The renderer this System works for.
   */
  constructor(e) {
    super(e), this.glConst = at.ADAPTER.getWebGLRenderingContext().SCISSOR_TEST;
  }
  getStackLength() {
    const e = this.maskStack[this.maskStack.length - 1];
    return e ? e._scissorCounter : 0;
  }
  /**
   * evaluates _boundsTransformed, _scissorRect for MaskData
   * @param maskData
   */
  calcScissorRect(e) {
    if (e._scissorRectLocal)
      return;
    const n = e._scissorRect, { maskObject: r } = e, { renderer: o } = this, s = o.renderTexture, i = r.getBounds(!0, UC.pop() ?? new Pt());
    this.roundFrameToPixels(
      i,
      s.current ? s.current.resolution : o.resolution,
      s.sourceFrame,
      s.destinationFrame,
      o.projection.transform
    ), n && i.fit(n), e._scissorRectLocal = i;
  }
  static isMatrixRotated(e) {
    if (!e)
      return !1;
    const { a: n, b: r, c: o, d: s } = e;
    return (Math.abs(r) > 1e-4 || Math.abs(o) > 1e-4) && (Math.abs(n) > 1e-4 || Math.abs(s) > 1e-4);
  }
  /**
   * Test, whether the object can be scissor mask with current renderer projection.
   * Calls "calcScissorRect()" if its true.
   * @param maskData - mask data
   * @returns whether Whether the object can be scissor mask
   */
  testScissor(e) {
    const { maskObject: n } = e;
    if (!n.isFastRect || !n.isFastRect() || n0.isMatrixRotated(n.worldTransform) || n0.isMatrixRotated(this.renderer.projection.transform))
      return !1;
    this.calcScissorRect(e);
    const r = e._scissorRectLocal;
    return r.width > 0 && r.height > 0;
  }
  roundFrameToPixels(e, n, r, o, s) {
    n0.isMatrixRotated(s) || (s = s ? BC.copyFrom(s) : BC.identity(), s.translate(-r.x, -r.y).scale(
      o.width / r.width,
      o.height / r.height
    ).translate(o.x, o.y), this.renderer.filter.transformAABB(s, e), e.fit(o), e.x = Math.round(e.x * n), e.y = Math.round(e.y * n), e.width = Math.round(e.width * n), e.height = Math.round(e.height * n));
  }
  /**
   * Applies the Mask and adds it to the current stencil stack.
   * @author alvin
   * @param maskData - The mask data.
   */
  push(e) {
    e._scissorRectLocal || this.calcScissorRect(e);
    const { gl: n } = this.renderer;
    e._scissorRect || n.enable(n.SCISSOR_TEST), e._scissorCounter++, e._scissorRect = e._scissorRectLocal, this._useCurrent();
  }
  /**
   * This should be called after a mask is popped off the mask stack. It will rebind the scissor box to be latest with the
   * last mask in the stack.
   *
   * This can also be called when you directly modify the scissor box and want to restore PixiJS state.
   * @param maskData - The mask data.
   */
  pop(e) {
    const { gl: n } = this.renderer;
    e && UC.push(e._scissorRectLocal), this.getStackLength() > 0 ? this._useCurrent() : n.disable(n.SCISSOR_TEST);
  }
  /**
   * Setup renderer to use the current scissor data.
   * @private
   */
  _useCurrent() {
    const e = this.maskStack[this.maskStack.length - 1]._scissorRect;
    let n;
    this.renderer.renderTexture.current ? n = e.y : n = this.renderer.height - e.height - e.y, this.renderer.gl.scissor(e.x, n, e.width, e.height);
  }
};
SB.extension = {
  type: rt.RendererSystem,
  name: "scissor"
};
let vbe = SB;
dt.add(vbe);
class RB extends xB {
  /**
   * @param renderer - The renderer this System works for.
   */
  constructor(e) {
    super(e), this.glConst = at.ADAPTER.getWebGLRenderingContext().STENCIL_TEST;
  }
  getStackLength() {
    const e = this.maskStack[this.maskStack.length - 1];
    return e ? e._stencilCounter : 0;
  }
  /**
   * Applies the Mask and adds it to the current stencil stack.
   * @param maskData - The mask data
   */
  push(e) {
    const n = e.maskObject, { gl: r } = this.renderer, o = e._stencilCounter;
    o === 0 && (this.renderer.framebuffer.forceStencil(), r.clearStencil(0), r.clear(r.STENCIL_BUFFER_BIT), r.enable(r.STENCIL_TEST)), e._stencilCounter++;
    const s = e._colorMask;
    s !== 0 && (e._colorMask = 0, r.colorMask(!1, !1, !1, !1)), r.stencilFunc(r.EQUAL, o, 4294967295), r.stencilOp(r.KEEP, r.KEEP, r.INCR), n.renderable = !0, n.render(this.renderer), this.renderer.batch.flush(), n.renderable = !1, s !== 0 && (e._colorMask = s, r.colorMask(
      (s & 1) !== 0,
      (s & 2) !== 0,
      (s & 4) !== 0,
      (s & 8) !== 0
    )), this._useCurrent();
  }
  /**
   * Pops stencil mask. MaskData is already removed from stack
   * @param {PIXI.DisplayObject} maskObject - object of popped mask data
   */
  pop(e) {
    const n = this.renderer.gl;
    if (this.getStackLength() === 0)
      n.disable(n.STENCIL_TEST);
    else {
      const r = this.maskStack.length !== 0 ? this.maskStack[this.maskStack.length - 1] : null, o = r ? r._colorMask : 15;
      o !== 0 && (r._colorMask = 0, n.colorMask(!1, !1, !1, !1)), n.stencilOp(n.KEEP, n.KEEP, n.DECR), e.renderable = !0, e.render(this.renderer), this.renderer.batch.flush(), e.renderable = !1, o !== 0 && (r._colorMask = o, n.colorMask(
        (o & 1) !== 0,
        (o & 2) !== 0,
        (o & 4) !== 0,
        (o & 8) !== 0
      )), this._useCurrent();
    }
  }
  /**
   * Setup renderer to use the current stencil data.
   * @private
   */
  _useCurrent() {
    const e = this.renderer.gl;
    e.stencilFunc(e.EQUAL, this.getStackLength(), 4294967295), e.stencilOp(e.KEEP, e.KEEP, e.KEEP);
  }
}
RB.extension = {
  type: rt.RendererSystem,
  name: "stencil"
};
dt.add(RB);
class AB {
  constructor(e) {
    this.renderer = e, this.plugins = {}, Object.defineProperties(this.plugins, {
      extract: {
        enumerable: !1,
        get() {
          return un("7.0.0", "renderer.plugins.extract has moved to renderer.extract"), e.extract;
        }
      },
      prepare: {
        enumerable: !1,
        get() {
          return un("7.0.0", "renderer.plugins.prepare has moved to renderer.prepare"), e.prepare;
        }
      },
      interaction: {
        enumerable: !1,
        get() {
          return un("7.0.0", "renderer.plugins.interaction has been deprecated, use renderer.events"), e.events;
        }
      }
    });
  }
  /**
   * Initialize the plugins.
   * @protected
   */
  init() {
    const e = this.rendererPlugins;
    for (const n in e)
      this.plugins[n] = new e[n](this.renderer);
  }
  destroy() {
    for (const e in this.plugins)
      this.plugins[e].destroy(), this.plugins[e] = null;
  }
}
AB.extension = {
  type: [
    rt.RendererSystem,
    rt.CanvasRendererSystem
  ],
  name: "_plugin"
};
dt.add(AB);
class DB {
  /** @param renderer - The renderer this System works for. */
  constructor(e) {
    this.renderer = e, this.destinationFrame = null, this.sourceFrame = null, this.defaultFrame = null, this.projectionMatrix = new Qn(), this.transform = null;
  }
  /**
   * Updates the projection-matrix based on the sourceFrame → destinationFrame mapping provided.
   *
   * NOTE: It is expected you call `renderer.framebuffer.setViewport(destinationFrame)` after this. This is because
   * the framebuffer viewport converts shader vertex output in normalized device coordinates to window coordinates.
   *
   * NOTE-2: {@link PIXI.RenderTextureSystem#bind} updates the projection-matrix when you bind a render-texture.
   * It is expected
   * that you dirty the current bindings when calling this manually.
   * @param destinationFrame - The rectangle in the render-target to render the contents into. If rendering to the canvas,
   *  the origin is on the top-left; if rendering to a render-texture, the origin is on the bottom-left.
   * @param sourceFrame - The rectangle in world space that contains the contents being rendered.
   * @param resolution - The resolution of the render-target, which is the ratio of
   *  world-space (or CSS) pixels to physical pixels.
   * @param root - Whether the render-target is the screen. This is required because rendering to textures
   *  is y-flipped (i.e. upside down relative to the screen).
   */
  update(e, n, r, o) {
    this.destinationFrame = e || this.destinationFrame || this.defaultFrame, this.sourceFrame = n || this.sourceFrame || e, this.calculateProjection(this.destinationFrame, this.sourceFrame, r, o), this.transform && this.projectionMatrix.append(this.transform);
    const s = this.renderer;
    s.globalUniforms.uniforms.projectionMatrix = this.projectionMatrix, s.globalUniforms.update(), s.shader.shader && s.shader.syncUniformGroup(s.shader.shader.uniforms.globals);
  }
  /**
   * Calculates the `projectionMatrix` to map points inside `sourceFrame` to inside `destinationFrame`.
   * @param _destinationFrame - The destination frame in the render-target.
   * @param sourceFrame - The source frame in world space.
   * @param _resolution - The render-target's resolution, i.e. ratio of CSS to physical pixels.
   * @param root - Whether rendering into the screen. Otherwise, if rendering to a framebuffer, the projection
   *  is y-flipped.
   */
  calculateProjection(e, n, r, o) {
    const s = this.projectionMatrix, i = o ? -1 : 1;
    s.identity(), s.a = 1 / n.width * 2, s.d = i * (1 / n.height * 2), s.tx = -1 - n.x * s.a, s.ty = -i - n.y * s.d;
  }
  /**
   * Sets the transform of the active render target to the given matrix.
   * @param _matrix - The transformation matrix
   */
  setTransform(e) {
  }
  destroy() {
    this.renderer = null;
  }
}
DB.extension = {
  type: rt.RendererSystem,
  name: "projection"
};
dt.add(DB);
const _be = new SS(), XC = new Pt();
class EB {
  constructor(e) {
    this.renderer = e, this._tempMatrix = new Qn();
  }
  /**
   * A Useful function that returns a texture of the display object that can then be used to create sprites
   * This can be quite useful if your displayObject is complicated and needs to be reused multiple times.
   * @param displayObject - The displayObject the object will be generated from.
   * @param {IGenerateTextureOptions} options - Generate texture options.
   * @param {PIXI.Rectangle} options.region - The region of the displayObject, that shall be rendered,
   *        if no region is specified, defaults to the local bounds of the displayObject.
   * @param {number} [options.resolution] - If not given, the renderer's resolution is used.
   * @param {PIXI.MSAA_QUALITY} [options.multisample] - If not given, the renderer's multisample is used.
   * @returns a shiny new texture of the display object passed in
   */
  generateTexture(e, n) {
    const { region: r, ...o } = n || {}, s = r?.copyTo(XC) || e.getLocalBounds(XC, !0), i = o.resolution || this.renderer.resolution;
    s.width = Math.max(s.width, 1 / i), s.height = Math.max(s.height, 1 / i), o.width = s.width, o.height = s.height, o.resolution = i, o.multisample ?? (o.multisample = this.renderer.multisample);
    const u = rd.create(o);
    this._tempMatrix.tx = -s.x, this._tempMatrix.ty = -s.y;
    const l = e.transform;
    return e.transform = _be, this.renderer.render(e, {
      renderTexture: u,
      transform: this._tempMatrix,
      skipUpdateTransform: !!e.parent,
      blit: !0
    }), e.transform = l, u;
  }
  destroy() {
  }
}
EB.extension = {
  type: [
    rt.RendererSystem,
    rt.CanvasRendererSystem
  ],
  name: "textureGenerator"
};
dt.add(EB);
const Qc = new Pt(), _f = new Pt();
class MB {
  /**
   * @param renderer - The renderer this System works for.
   */
  constructor(e) {
    this.renderer = e, this.defaultMaskStack = [], this.current = null, this.sourceFrame = new Pt(), this.destinationFrame = new Pt(), this.viewportFrame = new Pt();
  }
  contextChange() {
    const e = this.renderer?.gl.getContextAttributes();
    this._rendererPremultipliedAlpha = !!(e && e.alpha && e.premultipliedAlpha);
  }
  /**
   * Bind the current render texture.
   * @param renderTexture - RenderTexture to bind, by default its `null` - the screen.
   * @param sourceFrame - Part of world that is mapped to the renderTexture.
   * @param destinationFrame - Part of renderTexture, by default it has the same size as sourceFrame.
   */
  bind(e = null, n, r) {
    const o = this.renderer;
    this.current = e;
    let s, i, u;
    e ? (s = e.baseTexture, u = s.resolution, n || (Qc.width = e.frame.width, Qc.height = e.frame.height, n = Qc), r || (_f.x = e.frame.x, _f.y = e.frame.y, _f.width = n.width, _f.height = n.height, r = _f), i = s.framebuffer) : (u = o.resolution, n || (Qc.width = o._view.screen.width, Qc.height = o._view.screen.height, n = Qc), r || (r = Qc, r.width = n.width, r.height = n.height));
    const l = this.viewportFrame;
    l.x = r.x * u, l.y = r.y * u, l.width = r.width * u, l.height = r.height * u, e || (l.y = o.view.height - (l.y + l.height)), l.ceil(), this.renderer.framebuffer.bind(i, l), this.renderer.projection.update(r, n, u, !i), e ? this.renderer.mask.setMaskStack(s.maskStack) : this.renderer.mask.setMaskStack(this.defaultMaskStack), this.sourceFrame.copyFrom(n), this.destinationFrame.copyFrom(r);
  }
  /**
   * Erases the render texture and fills the drawing area with a colour.
   * @param clearColor - The color as rgba, default to use the renderer backgroundColor
   * @param [mask=BUFFER_BITS.COLOR | BUFFER_BITS.DEPTH] - Bitwise OR of masks
   *  that indicate the buffers to be cleared, by default COLOR and DEPTH buffers.
   */
  clear(e, n) {
    const r = this.current ? this.current.baseTexture.clear : this.renderer.background.backgroundColor, o = Gn.shared.setValue(e || r);
    (this.current && this.current.baseTexture.alphaMode > 0 || !this.current && this._rendererPremultipliedAlpha) && o.premultiply(o.alpha);
    const s = this.destinationFrame, i = this.current ? this.current.baseTexture : this.renderer._view.screen, u = s.width !== i.width || s.height !== i.height;
    if (u) {
      let { x: l, y: a, width: c, height: p } = this.viewportFrame;
      l = Math.round(l), a = Math.round(a), c = Math.round(c), p = Math.round(p), this.renderer.gl.enable(this.renderer.gl.SCISSOR_TEST), this.renderer.gl.scissor(l, a, c, p);
    }
    this.renderer.framebuffer.clear(o.red, o.green, o.blue, o.alpha, n), u && this.renderer.scissor.pop();
  }
  resize() {
    this.bind(null);
  }
  /** Resets render-texture state. */
  reset() {
    this.bind(null);
  }
  destroy() {
    this.renderer = null;
  }
}
MB.extension = {
  type: rt.RendererSystem,
  name: "renderTexture"
};
dt.add(MB);
class wbe {
  /**
   * Makes a new Pixi program.
   * @param program - webgl program
   * @param uniformData - uniforms
   */
  constructor(e, n) {
    this.program = e, this.uniformData = n, this.uniformGroups = {}, this.uniformDirtyGroups = {}, this.uniformBufferBindings = {};
  }
  /** Destroys this program. */
  destroy() {
    this.uniformData = null, this.uniformGroups = null, this.uniformDirtyGroups = null, this.uniformBufferBindings = null, this.program = null;
  }
}
function bbe(t, e) {
  const n = {}, r = e.getProgramParameter(t, e.ACTIVE_ATTRIBUTES);
  for (let o = 0; o < r; o++) {
    const s = e.getActiveAttrib(t, o);
    if (s.name.startsWith("gl_"))
      continue;
    const i = hB(e, s.type), u = {
      type: i,
      name: s.name,
      size: dB(i),
      location: e.getAttribLocation(t, s.name)
    };
    n[s.name] = u;
  }
  return n;
}
function kbe(t, e) {
  const n = {}, r = e.getProgramParameter(t, e.ACTIVE_UNIFORMS);
  for (let o = 0; o < r; o++) {
    const s = e.getActiveUniform(t, o), i = s.name.replace(/\[.*?\]$/, ""), u = !!s.name.match(/\[.*?\]$/), l = hB(e, s.type);
    n[i] = {
      name: i,
      index: o,
      type: l,
      size: s.size,
      isArray: u,
      value: cB(l, s.size)
    };
  }
  return n;
}
function Tbe(t, e) {
  const n = PC(t, t.VERTEX_SHADER, e.vertexSrc), r = PC(t, t.FRAGMENT_SHADER, e.fragmentSrc), o = t.createProgram();
  t.attachShader(o, n), t.attachShader(o, r);
  const s = e.extra?.transformFeedbackVaryings;
  if (s && (typeof t.transformFeedbackVaryings != "function" ? console.warn("TransformFeedback is not supported but TransformFeedbackVaryings are given.") : t.transformFeedbackVaryings(
    o,
    s.names,
    s.bufferMode === "separate" ? t.SEPARATE_ATTRIBS : t.INTERLEAVED_ATTRIBS
  )), t.linkProgram(o), t.getProgramParameter(o, t.LINK_STATUS) || Z1e(t, o, n, r), e.attributeData = bbe(o, t), e.uniformData = kbe(o, t), !/^[ \t]*#[ \t]*version[ \t]+300[ \t]+es[ \t]*$/m.test(e.vertexSrc)) {
    const u = Object.keys(e.attributeData);
    u.sort((l, a) => l > a ? 1 : -1);
    for (let l = 0; l < u.length; l++)
      e.attributeData[u[l]].location = l, t.bindAttribLocation(o, l, u[l]);
    t.linkProgram(o);
  }
  t.deleteShader(n), t.deleteShader(r);
  const i = {};
  for (const u in e.uniformData) {
    const l = e.uniformData[u];
    i[u] = {
      location: t.getUniformLocation(o, u),
      value: cB(l.type, l.size)
    };
  }
  return new wbe(o, i);
}
function xbe(t, e, n, r, o) {
  n.buffer.update(o);
}
const Sbe = {
  float: `
        data[offset] = v;
    `,
  vec2: `
        data[offset] = v[0];
        data[offset+1] = v[1];
    `,
  vec3: `
        data[offset] = v[0];
        data[offset+1] = v[1];
        data[offset+2] = v[2];

    `,
  vec4: `
        data[offset] = v[0];
        data[offset+1] = v[1];
        data[offset+2] = v[2];
        data[offset+3] = v[3];
    `,
  mat2: `
        data[offset] = v[0];
        data[offset+1] = v[1];

        data[offset+4] = v[2];
        data[offset+5] = v[3];
    `,
  mat3: `
        data[offset] = v[0];
        data[offset+1] = v[1];
        data[offset+2] = v[2];

        data[offset + 4] = v[3];
        data[offset + 5] = v[4];
        data[offset + 6] = v[5];

        data[offset + 8] = v[6];
        data[offset + 9] = v[7];
        data[offset + 10] = v[8];
    `,
  mat4: `
        for(var i = 0; i < 16; i++)
        {
            data[offset + i] = v[i];
        }
    `
}, PB = {
  float: 4,
  vec2: 8,
  vec3: 12,
  vec4: 16,
  int: 4,
  ivec2: 8,
  ivec3: 12,
  ivec4: 16,
  uint: 4,
  uvec2: 8,
  uvec3: 12,
  uvec4: 16,
  bool: 4,
  bvec2: 8,
  bvec3: 12,
  bvec4: 16,
  mat2: 32,
  mat3: 48,
  mat4: 64
};
function Rbe(t) {
  const e = t.map((s) => ({
    data: s,
    offset: 0,
    dataLen: 0,
    dirty: 0
  }));
  let n = 0, r = 0, o = 0;
  for (let s = 0; s < e.length; s++) {
    const i = e[s];
    if (n = PB[i.data.type], i.data.size > 1 && (n = Math.max(n, 16) * i.data.size), i.dataLen = n, r % n !== 0 && r < 16) {
      const u = r % n % 16;
      r += u, o += u;
    }
    r + n > 16 ? (o = Math.ceil(o / 16) * 16, i.offset = o, o += n, r = n) : (i.offset = o, r += n, o += n);
  }
  return o = Math.ceil(o / 16) * 16, { uboElements: e, size: o };
}
function Abe(t, e) {
  const n = [];
  for (const r in t)
    e[r] && n.push(e[r]);
  return n.sort((r, o) => r.index - o.index), n;
}
function Dbe(t, e) {
  if (!t.autoManage)
    return { size: 0, syncFunc: xbe };
  const n = Abe(t.uniforms, e), { uboElements: r, size: o } = Rbe(n), s = [`
    var v = null;
    var v2 = null;
    var cv = null;
    var t = 0;
    var gl = renderer.gl
    var index = 0;
    var data = buffer.data;
    `];
  for (let i = 0; i < r.length; i++) {
    const u = r[i], l = t.uniforms[u.data.name], a = u.data.name;
    let c = !1;
    for (let p = 0; p < Qd.length; p++) {
      const d = Qd[p];
      if (d.codeUbo && d.test(u.data, l)) {
        s.push(
          `offset = ${u.offset / 4};`,
          Qd[p].codeUbo(u.data.name, l)
        ), c = !0;
        break;
      }
    }
    if (!c)
      if (u.data.size > 1) {
        const p = dB(u.data.type), d = Math.max(PB[u.data.type] / 16, 1), h = p / d, m = (4 - h % 4) % 4;
        s.push(`
                cv = ud.${a}.value;
                v = uv.${a};
                offset = ${u.offset / 4};

                t = 0;

                for(var i=0; i < ${u.data.size * d}; i++)
                {
                    for(var j = 0; j < ${h}; j++)
                    {
                        data[offset++] = v[t++];
                    }
                    offset += ${m};
                }

                `);
      } else {
        const p = Sbe[u.data.type];
        s.push(`
                cv = ud.${a}.value;
                v = uv.${a};
                offset = ${u.offset / 4};
                ${p};
                `);
      }
  }
  return s.push(`
       renderer.buffer.update(buffer);
    `), {
    size: o,
    // eslint-disable-next-line no-new-func
    syncFunc: new Function(
      "ud",
      "uv",
      "renderer",
      "syncData",
      "buffer",
      s.join(`
`)
    )
  };
}
let Ebe = 0;
const Tg = { textureCount: 0, uboCount: 0 };
class CB {
  /** @param renderer - The renderer this System works for. */
  constructor(e) {
    this.destroyed = !1, this.renderer = e, this.systemCheck(), this.gl = null, this.shader = null, this.program = null, this.cache = {}, this._uboCache = {}, this.id = Ebe++;
  }
  /**
   * Overrideable function by `@pixi/unsafe-eval` to silence
   * throwing an error if platform doesn't support unsafe-evals.
   * @private
   */
  systemCheck() {
    if (!ebe())
      throw new Error("Current environment does not allow unsafe-eval, please use @pixi/unsafe-eval module to enable support.");
  }
  contextChange(e) {
    this.gl = e, this.reset();
  }
  /**
   * Changes the current shader to the one given in parameter.
   * @param shader - the new shader
   * @param dontSync - false if the shader should automatically sync its uniforms.
   * @returns the glProgram that belongs to the shader.
   */
  bind(e, n) {
    e.disposeRunner.add(this), e.uniforms.globals = this.renderer.globalUniforms;
    const r = e.program, o = r.glPrograms[this.renderer.CONTEXT_UID] || this.generateProgram(e);
    return this.shader = e, this.program !== r && (this.program = r, this.gl.useProgram(o.program)), n || (Tg.textureCount = 0, Tg.uboCount = 0, this.syncUniformGroup(e.uniformGroup, Tg)), o;
  }
  /**
   * Uploads the uniforms values to the currently bound shader.
   * @param uniforms - the uniforms values that be applied to the current shader
   */
  setUniforms(e) {
    const n = this.shader.program, r = n.glPrograms[this.renderer.CONTEXT_UID];
    n.syncUniforms(r.uniformData, e, this.renderer);
  }
  /* eslint-disable @typescript-eslint/explicit-module-boundary-types */
  /**
   * Syncs uniforms on the group
   * @param group - the uniform group to sync
   * @param syncData - this is data that is passed to the sync function and any nested sync functions
   */
  syncUniformGroup(e, n) {
    const r = this.getGlProgram();
    (!e.static || e.dirtyId !== r.uniformDirtyGroups[e.id]) && (r.uniformDirtyGroups[e.id] = e.dirtyId, this.syncUniforms(e, r, n));
  }
  /**
   * Overrideable by the @pixi/unsafe-eval package to use static syncUniforms instead.
   * @param group
   * @param glProgram
   * @param syncData
   */
  syncUniforms(e, n, r) {
    (e.syncUniforms[this.shader.program.id] || this.createSyncGroups(e))(n.uniformData, e.uniforms, this.renderer, r);
  }
  createSyncGroups(e) {
    const n = this.getSignature(e, this.shader.program.uniformData, "u");
    return this.cache[n] || (this.cache[n] = Y1e(e, this.shader.program.uniformData)), e.syncUniforms[this.shader.program.id] = this.cache[n], e.syncUniforms[this.shader.program.id];
  }
  /**
   * Syncs uniform buffers
   * @param group - the uniform buffer group to sync
   * @param name - the name of the uniform buffer
   */
  syncUniformBufferGroup(e, n) {
    const r = this.getGlProgram();
    if (!e.static || e.dirtyId !== 0 || !r.uniformGroups[e.id]) {
      e.dirtyId = 0;
      const o = r.uniformGroups[e.id] || this.createSyncBufferGroup(e, r, n);
      e.buffer.update(), o(
        r.uniformData,
        e.uniforms,
        this.renderer,
        Tg,
        e.buffer
      );
    }
    this.renderer.buffer.bindBufferBase(e.buffer, r.uniformBufferBindings[n]);
  }
  /**
   * Will create a function that uploads a uniform buffer using the STD140 standard.
   * The upload function will then be cached for future calls
   * If a group is manually managed, then a simple upload function is generated
   * @param group - the uniform buffer group to sync
   * @param glProgram - the gl program to attach the uniform bindings to
   * @param name - the name of the uniform buffer (must exist on the shader)
   */
  createSyncBufferGroup(e, n, r) {
    const { gl: o } = this.renderer;
    this.renderer.buffer.bind(e.buffer);
    const s = this.gl.getUniformBlockIndex(n.program, r);
    n.uniformBufferBindings[r] = this.shader.uniformBindCount, o.uniformBlockBinding(n.program, s, this.shader.uniformBindCount), this.shader.uniformBindCount++;
    const i = this.getSignature(e, this.shader.program.uniformData, "ubo");
    let u = this._uboCache[i];
    if (u || (u = this._uboCache[i] = Dbe(e, this.shader.program.uniformData)), e.autoManage) {
      const l = new Float32Array(u.size / 4);
      e.buffer.update(l);
    }
    return n.uniformGroups[e.id] = u.syncFunc, n.uniformGroups[e.id];
  }
  /**
   * Takes a uniform group and data and generates a unique signature for them.
   * @param group - The uniform group to get signature of
   * @param group.uniforms
   * @param uniformData - Uniform information generated by the shader
   * @param preFix
   * @returns Unique signature of the uniform group
   */
  getSignature(e, n, r) {
    const o = e.uniforms, s = [`${r}-`];
    for (const i in o)
      s.push(i), n[i] && s.push(n[i].type);
    return s.join("-");
  }
  /**
   * Returns the underlying GLShade rof the currently bound shader.
   *
   * This can be handy for when you to have a little more control over the setting of your uniforms.
   * @returns The glProgram for the currently bound Shader for this context
   */
  getGlProgram() {
    return this.shader ? this.shader.program.glPrograms[this.renderer.CONTEXT_UID] : null;
  }
  /**
   * Generates a glProgram version of the Shader provided.
   * @param shader - The shader that the glProgram will be based on.
   * @returns A shiny new glProgram!
   */
  generateProgram(e) {
    const n = this.gl, r = e.program, o = Tbe(n, r);
    return r.glPrograms[this.renderer.CONTEXT_UID] = o, o;
  }
  /** Resets ShaderSystem state, does not affect WebGL state. */
  reset() {
    this.program = null, this.shader = null;
  }
  /**
   * Disposes shader.
   * If disposing one equals with current shader, set current as null.
   * @param shader - Shader object
   */
  disposeShader(e) {
    this.shader === e && (this.shader = null);
  }
  /** Destroys this System and removes all its textures. */
  destroy() {
    this.renderer = null, this.destroyed = !0;
  }
}
CB.extension = {
  type: rt.RendererSystem,
  name: "shader"
};
dt.add(CB);
class uv {
  constructor(e) {
    this.renderer = e;
  }
  /**
   * It all starts here! This initiates every system, passing in the options for any system by name.
   * @param options - the config for the renderer and all its systems
   */
  run(e) {
    const { renderer: n } = this;
    n.runners.init.emit(n.options), e.hello && console.log(`PixiJS 7.3.2 - ${n.rendererLogId} - https://pixijs.com`), n.resize(n.screen.width, n.screen.height);
  }
  destroy() {
  }
}
uv.defaultOptions = {
  /**
   * {@link PIXI.IRendererOptions.hello}
   * @default false
   * @memberof PIXI.settings.RENDER_OPTIONS
   */
  hello: !1
}, /** @ignore */
uv.extension = {
  type: [
    rt.RendererSystem,
    rt.CanvasRendererSystem
  ],
  name: "startup"
};
dt.add(uv);
function Mbe(t, e = []) {
  return e[Mt.NORMAL] = [t.ONE, t.ONE_MINUS_SRC_ALPHA], e[Mt.ADD] = [t.ONE, t.ONE], e[Mt.MULTIPLY] = [t.DST_COLOR, t.ONE_MINUS_SRC_ALPHA, t.ONE, t.ONE_MINUS_SRC_ALPHA], e[Mt.SCREEN] = [t.ONE, t.ONE_MINUS_SRC_COLOR, t.ONE, t.ONE_MINUS_SRC_ALPHA], e[Mt.OVERLAY] = [t.ONE, t.ONE_MINUS_SRC_ALPHA], e[Mt.DARKEN] = [t.ONE, t.ONE_MINUS_SRC_ALPHA], e[Mt.LIGHTEN] = [t.ONE, t.ONE_MINUS_SRC_ALPHA], e[Mt.COLOR_DODGE] = [t.ONE, t.ONE_MINUS_SRC_ALPHA], e[Mt.COLOR_BURN] = [t.ONE, t.ONE_MINUS_SRC_ALPHA], e[Mt.HARD_LIGHT] = [t.ONE, t.ONE_MINUS_SRC_ALPHA], e[Mt.SOFT_LIGHT] = [t.ONE, t.ONE_MINUS_SRC_ALPHA], e[Mt.DIFFERENCE] = [t.ONE, t.ONE_MINUS_SRC_ALPHA], e[Mt.EXCLUSION] = [t.ONE, t.ONE_MINUS_SRC_ALPHA], e[Mt.HUE] = [t.ONE, t.ONE_MINUS_SRC_ALPHA], e[Mt.SATURATION] = [t.ONE, t.ONE_MINUS_SRC_ALPHA], e[Mt.COLOR] = [t.ONE, t.ONE_MINUS_SRC_ALPHA], e[Mt.LUMINOSITY] = [t.ONE, t.ONE_MINUS_SRC_ALPHA], e[Mt.NONE] = [0, 0], e[Mt.NORMAL_NPM] = [t.SRC_ALPHA, t.ONE_MINUS_SRC_ALPHA, t.ONE, t.ONE_MINUS_SRC_ALPHA], e[Mt.ADD_NPM] = [t.SRC_ALPHA, t.ONE, t.ONE, t.ONE], e[Mt.SCREEN_NPM] = [t.SRC_ALPHA, t.ONE_MINUS_SRC_COLOR, t.ONE, t.ONE_MINUS_SRC_ALPHA], e[Mt.SRC_IN] = [t.DST_ALPHA, t.ZERO], e[Mt.SRC_OUT] = [t.ONE_MINUS_DST_ALPHA, t.ZERO], e[Mt.SRC_ATOP] = [t.DST_ALPHA, t.ONE_MINUS_SRC_ALPHA], e[Mt.DST_OVER] = [t.ONE_MINUS_DST_ALPHA, t.ONE], e[Mt.DST_IN] = [t.ZERO, t.SRC_ALPHA], e[Mt.DST_OUT] = [t.ZERO, t.ONE_MINUS_SRC_ALPHA], e[Mt.DST_ATOP] = [t.ONE_MINUS_DST_ALPHA, t.SRC_ALPHA], e[Mt.XOR] = [t.ONE_MINUS_DST_ALPHA, t.ONE_MINUS_SRC_ALPHA], e[Mt.SUBTRACT] = [t.ONE, t.ONE, t.ONE, t.ONE, t.FUNC_REVERSE_SUBTRACT, t.FUNC_ADD], e;
}
const Pbe = 0, Cbe = 1, Obe = 2, Ibe = 3, Fbe = 4, Nbe = 5, OB = class pT {
  constructor() {
    this.gl = null, this.stateId = 0, this.polygonOffset = 0, this.blendMode = Mt.NONE, this._blendEq = !1, this.map = [], this.map[Pbe] = this.setBlend, this.map[Cbe] = this.setOffset, this.map[Obe] = this.setCullFace, this.map[Ibe] = this.setDepthTest, this.map[Fbe] = this.setFrontFace, this.map[Nbe] = this.setDepthMask, this.checks = [], this.defaultState = new _u(), this.defaultState.blend = !0;
  }
  contextChange(e) {
    this.gl = e, this.blendModes = Mbe(e), this.set(this.defaultState), this.reset();
  }
  /**
   * Sets the current state
   * @param {*} state - The state to set.
   */
  set(e) {
    if (e = e || this.defaultState, this.stateId !== e.data) {
      let n = this.stateId ^ e.data, r = 0;
      for (; n; )
        n & 1 && this.map[r].call(this, !!(e.data & 1 << r)), n = n >> 1, r++;
      this.stateId = e.data;
    }
    for (let n = 0; n < this.checks.length; n++)
      this.checks[n](this, e);
  }
  /**
   * Sets the state, when previous state is unknown.
   * @param {*} state - The state to set
   */
  forceState(e) {
    e = e || this.defaultState;
    for (let n = 0; n < this.map.length; n++)
      this.map[n].call(this, !!(e.data & 1 << n));
    for (let n = 0; n < this.checks.length; n++)
      this.checks[n](this, e);
    this.stateId = e.data;
  }
  /**
   * Sets whether to enable or disable blending.
   * @param value - Turn on or off WebGl blending.
   */
  setBlend(e) {
    this.updateCheck(pT.checkBlendMode, e), this.gl[e ? "enable" : "disable"](this.gl.BLEND);
  }
  /**
   * Sets whether to enable or disable polygon offset fill.
   * @param value - Turn on or off webgl polygon offset testing.
   */
  setOffset(e) {
    this.updateCheck(pT.checkPolygonOffset, e), this.gl[e ? "enable" : "disable"](this.gl.POLYGON_OFFSET_FILL);
  }
  /**
   * Sets whether to enable or disable depth test.
   * @param value - Turn on or off webgl depth testing.
   */
  setDepthTest(e) {
    this.gl[e ? "enable" : "disable"](this.gl.DEPTH_TEST);
  }
  /**
   * Sets whether to enable or disable depth mask.
   * @param value - Turn on or off webgl depth mask.
   */
  setDepthMask(e) {
    this.gl.depthMask(e);
  }
  /**
   * Sets whether to enable or disable cull face.
   * @param {boolean} value - Turn on or off webgl cull face.
   */
  setCullFace(e) {
    this.gl[e ? "enable" : "disable"](this.gl.CULL_FACE);
  }
  /**
   * Sets the gl front face.
   * @param {boolean} value - true is clockwise and false is counter-clockwise
   */
  setFrontFace(e) {
    this.gl.frontFace(this.gl[e ? "CW" : "CCW"]);
  }
  /**
   * Sets the blend mode.
   * @param {number} value - The blend mode to set to.
   */
  setBlendMode(e) {
    if (e === this.blendMode)
      return;
    this.blendMode = e;
    const n = this.blendModes[e], r = this.gl;
    n.length === 2 ? r.blendFunc(n[0], n[1]) : r.blendFuncSeparate(n[0], n[1], n[2], n[3]), n.length === 6 ? (this._blendEq = !0, r.blendEquationSeparate(n[4], n[5])) : this._blendEq && (this._blendEq = !1, r.blendEquationSeparate(r.FUNC_ADD, r.FUNC_ADD));
  }
  /**
   * Sets the polygon offset.
   * @param {number} value - the polygon offset
   * @param {number} scale - the polygon offset scale
   */
  setPolygonOffset(e, n) {
    this.gl.polygonOffset(e, n);
  }
  // used
  /** Resets all the logic and disables the VAOs. */
  reset() {
    this.gl.pixelStorei(this.gl.UNPACK_FLIP_Y_WEBGL, !1), this.forceState(this.defaultState), this._blendEq = !0, this.blendMode = -1, this.setBlendMode(0);
  }
  /**
   * Checks to see which updates should be checked based on which settings have been activated.
   *
   * For example, if blend is enabled then we should check the blend modes each time the state is changed
   * or if polygon fill is activated then we need to check if the polygon offset changes.
   * The idea is that we only check what we have too.
   * @param func - the checking function to add or remove
   * @param value - should the check function be added or removed.
   */
  updateCheck(e, n) {
    const r = this.checks.indexOf(e);
    n && r === -1 ? this.checks.push(e) : !n && r !== -1 && this.checks.splice(r, 1);
  }
  /**
   * A private little wrapper function that we call to check the blend mode.
   * @param system - the System to perform the state check on
   * @param state - the state that the blendMode will pulled from
   */
  static checkBlendMode(e, n) {
    e.setBlendMode(n.blendMode);
  }
  /**
   * A private little wrapper function that we call to check the polygon offset.
   * @param system - the System to perform the state check on
   * @param state - the state that the blendMode will pulled from
   */
  static checkPolygonOffset(e, n) {
    e.setPolygonOffset(1, n.polygonOffset);
  }
  /**
   * @ignore
   */
  destroy() {
    this.gl = null;
  }
};
OB.extension = {
  type: rt.RendererSystem,
  name: "state"
};
let Lbe = OB;
dt.add(Lbe);
class Bbe extends uy {
  constructor() {
    super(...arguments), this.runners = {}, this._systemsHash = {};
  }
  /**
   * Set up a system with a collection of SystemClasses and runners.
   * Systems are attached dynamically to this class when added.
   * @param config - the config for the system manager
   */
  setup(e) {
    this.addRunners(...e.runners);
    const n = (e.priority ?? []).filter((o) => e.systems[o]), r = [
      ...n,
      ...Object.keys(e.systems).filter((o) => !n.includes(o))
    ];
    for (const o of r)
      this.addSystem(e.systems[o], o);
  }
  /**
   * Create a bunch of runners based of a collection of ids
   * @param runnerIds - the runner ids to add
   */
  addRunners(...e) {
    e.forEach((n) => {
      this.runners[n] = new pi(n);
    });
  }
  /**
   * Add a new system to the renderer.
   * @param ClassRef - Class reference
   * @param name - Property name for system, if not specified
   *        will use a static `name` property on the class itself. This
   *        name will be assigned as s property on the Renderer so make
   *        sure it doesn't collide with properties on Renderer.
   * @returns Return instance of renderer
   */
  addSystem(e, n) {
    const r = new e(this);
    if (this[n])
      throw new Error(`Whoops! The name "${n}" is already in use`);
    this[n] = r, this._systemsHash[n] = r;
    for (const o in this.runners)
      this.runners[o].add(r);
    return this;
  }
  /**
   * A function that will run a runner and call the runners function but pass in different options
   * to each system based on there name.
   *
   * E.g. If you have two systems added called `systemA` and `systemB` you could call do the following:
   *
   * ```js
   * system.emitWithCustomOptions(init, {
   *     systemA: {...optionsForA},
   *     systemB: {...optionsForB},
   * });
   * ```
   *
   * `init` would be called on system A passing `optionsForA` and on system B passing `optionsForB`.
   * @param runner - the runner to target
   * @param options - key value options for each system
   */
  emitWithCustomOptions(e, n) {
    const r = Object.keys(this._systemsHash);
    e.items.forEach((o) => {
      const s = r.find((i) => this._systemsHash[i] === o);
      o[e.name](n[s]);
    });
  }
  /** destroy the all runners and systems. Its apps job to */
  destroy() {
    Object.values(this.runners).forEach((e) => {
      e.destroy();
    }), this._systemsHash = {};
  }
  // TODO implement!
  // removeSystem(ClassRef: ISystemConstructor, name: string): void
  // {
  // }
}
const Uf = class r0 {
  /** @param renderer - The renderer this System works for. */
  constructor(e) {
    this.renderer = e, this.count = 0, this.checkCount = 0, this.maxIdle = r0.defaultMaxIdle, this.checkCountMax = r0.defaultCheckCountMax, this.mode = r0.defaultMode;
  }
  /**
   * Checks to see when the last time a texture was used.
   * If the texture has not been used for a specified amount of time, it will be removed from the GPU.
   */
  postrender() {
    this.renderer.objectRenderer.renderingToScreen && (this.count++, this.mode !== bS.MANUAL && (this.checkCount++, this.checkCount > this.checkCountMax && (this.checkCount = 0, this.run())));
  }
  /**
   * Checks to see when the last time a texture was used.
   * If the texture has not been used for a specified amount of time, it will be removed from the GPU.
   */
  run() {
    const e = this.renderer.texture, n = e.managedTextures;
    let r = !1;
    for (let o = 0; o < n.length; o++) {
      const s = n[o];
      s.resource && this.count - s.touched > this.maxIdle && (e.destroyTexture(s, !0), n[o] = null, r = !0);
    }
    if (r) {
      let o = 0;
      for (let s = 0; s < n.length; s++)
        n[s] !== null && (n[o++] = n[s]);
      n.length = o;
    }
  }
  /**
   * Removes all the textures within the specified displayObject and its children from the GPU.
   * @param {PIXI.DisplayObject} displayObject - the displayObject to remove the textures from.
   */
  unload(e) {
    const n = this.renderer.texture, r = e._texture;
    r && !r.framebuffer && n.destroyTexture(r);
    for (let o = e.children.length - 1; o >= 0; o--)
      this.unload(e.children[o]);
  }
  destroy() {
    this.renderer = null;
  }
};
Uf.defaultMode = bS.AUTO, /**
* Default maximum idle frames before a texture is destroyed by garbage collection.
* @static
* @default 3600
* @see PIXI.TextureGCSystem#maxIdle
*/
Uf.defaultMaxIdle = 3600, /**
* Default frames between two garbage collections.
* @static
* @default 600
* @see PIXI.TextureGCSystem#checkCountMax
*/
Uf.defaultCheckCountMax = 600, /** @ignore */
Uf.extension = {
  type: rt.RendererSystem,
  name: "textureGC"
};
let ip = Uf;
dt.add(ip);
class bb {
  constructor(e) {
    this.texture = e, this.width = -1, this.height = -1, this.dirtyId = -1, this.dirtyStyleId = -1, this.mipmap = !1, this.wrapMode = 33071, this.type = _t.UNSIGNED_BYTE, this.internalFormat = qe.RGBA, this.samplerType = 0;
  }
}
function Ube(t) {
  let e;
  return "WebGL2RenderingContext" in globalThis && t instanceof globalThis.WebGL2RenderingContext ? e = {
    [t.RGB]: st.FLOAT,
    [t.RGBA]: st.FLOAT,
    [t.ALPHA]: st.FLOAT,
    [t.LUMINANCE]: st.FLOAT,
    [t.LUMINANCE_ALPHA]: st.FLOAT,
    [t.R8]: st.FLOAT,
    [t.R8_SNORM]: st.FLOAT,
    [t.RG8]: st.FLOAT,
    [t.RG8_SNORM]: st.FLOAT,
    [t.RGB8]: st.FLOAT,
    [t.RGB8_SNORM]: st.FLOAT,
    [t.RGB565]: st.FLOAT,
    [t.RGBA4]: st.FLOAT,
    [t.RGB5_A1]: st.FLOAT,
    [t.RGBA8]: st.FLOAT,
    [t.RGBA8_SNORM]: st.FLOAT,
    [t.RGB10_A2]: st.FLOAT,
    [t.RGB10_A2UI]: st.FLOAT,
    [t.SRGB8]: st.FLOAT,
    [t.SRGB8_ALPHA8]: st.FLOAT,
    [t.R16F]: st.FLOAT,
    [t.RG16F]: st.FLOAT,
    [t.RGB16F]: st.FLOAT,
    [t.RGBA16F]: st.FLOAT,
    [t.R32F]: st.FLOAT,
    [t.RG32F]: st.FLOAT,
    [t.RGB32F]: st.FLOAT,
    [t.RGBA32F]: st.FLOAT,
    [t.R11F_G11F_B10F]: st.FLOAT,
    [t.RGB9_E5]: st.FLOAT,
    [t.R8I]: st.INT,
    [t.R8UI]: st.UINT,
    [t.R16I]: st.INT,
    [t.R16UI]: st.UINT,
    [t.R32I]: st.INT,
    [t.R32UI]: st.UINT,
    [t.RG8I]: st.INT,
    [t.RG8UI]: st.UINT,
    [t.RG16I]: st.INT,
    [t.RG16UI]: st.UINT,
    [t.RG32I]: st.INT,
    [t.RG32UI]: st.UINT,
    [t.RGB8I]: st.INT,
    [t.RGB8UI]: st.UINT,
    [t.RGB16I]: st.INT,
    [t.RGB16UI]: st.UINT,
    [t.RGB32I]: st.INT,
    [t.RGB32UI]: st.UINT,
    [t.RGBA8I]: st.INT,
    [t.RGBA8UI]: st.UINT,
    [t.RGBA16I]: st.INT,
    [t.RGBA16UI]: st.UINT,
    [t.RGBA32I]: st.INT,
    [t.RGBA32UI]: st.UINT,
    [t.DEPTH_COMPONENT16]: st.FLOAT,
    [t.DEPTH_COMPONENT24]: st.FLOAT,
    [t.DEPTH_COMPONENT32F]: st.FLOAT,
    [t.DEPTH_STENCIL]: st.FLOAT,
    [t.DEPTH24_STENCIL8]: st.FLOAT,
    [t.DEPTH32F_STENCIL8]: st.FLOAT
  } : e = {
    [t.RGB]: st.FLOAT,
    [t.RGBA]: st.FLOAT,
    [t.ALPHA]: st.FLOAT,
    [t.LUMINANCE]: st.FLOAT,
    [t.LUMINANCE_ALPHA]: st.FLOAT,
    [t.DEPTH_STENCIL]: st.FLOAT
  }, e;
}
function Xbe(t) {
  let e;
  return "WebGL2RenderingContext" in globalThis && t instanceof globalThis.WebGL2RenderingContext ? e = {
    [_t.UNSIGNED_BYTE]: {
      [qe.RGBA]: t.RGBA8,
      [qe.RGB]: t.RGB8,
      [qe.RG]: t.RG8,
      [qe.RED]: t.R8,
      [qe.RGBA_INTEGER]: t.RGBA8UI,
      [qe.RGB_INTEGER]: t.RGB8UI,
      [qe.RG_INTEGER]: t.RG8UI,
      [qe.RED_INTEGER]: t.R8UI,
      [qe.ALPHA]: t.ALPHA,
      [qe.LUMINANCE]: t.LUMINANCE,
      [qe.LUMINANCE_ALPHA]: t.LUMINANCE_ALPHA
    },
    [_t.BYTE]: {
      [qe.RGBA]: t.RGBA8_SNORM,
      [qe.RGB]: t.RGB8_SNORM,
      [qe.RG]: t.RG8_SNORM,
      [qe.RED]: t.R8_SNORM,
      [qe.RGBA_INTEGER]: t.RGBA8I,
      [qe.RGB_INTEGER]: t.RGB8I,
      [qe.RG_INTEGER]: t.RG8I,
      [qe.RED_INTEGER]: t.R8I
    },
    [_t.UNSIGNED_SHORT]: {
      [qe.RGBA_INTEGER]: t.RGBA16UI,
      [qe.RGB_INTEGER]: t.RGB16UI,
      [qe.RG_INTEGER]: t.RG16UI,
      [qe.RED_INTEGER]: t.R16UI,
      [qe.DEPTH_COMPONENT]: t.DEPTH_COMPONENT16
    },
    [_t.SHORT]: {
      [qe.RGBA_INTEGER]: t.RGBA16I,
      [qe.RGB_INTEGER]: t.RGB16I,
      [qe.RG_INTEGER]: t.RG16I,
      [qe.RED_INTEGER]: t.R16I
    },
    [_t.UNSIGNED_INT]: {
      [qe.RGBA_INTEGER]: t.RGBA32UI,
      [qe.RGB_INTEGER]: t.RGB32UI,
      [qe.RG_INTEGER]: t.RG32UI,
      [qe.RED_INTEGER]: t.R32UI,
      [qe.DEPTH_COMPONENT]: t.DEPTH_COMPONENT24
    },
    [_t.INT]: {
      [qe.RGBA_INTEGER]: t.RGBA32I,
      [qe.RGB_INTEGER]: t.RGB32I,
      [qe.RG_INTEGER]: t.RG32I,
      [qe.RED_INTEGER]: t.R32I
    },
    [_t.FLOAT]: {
      [qe.RGBA]: t.RGBA32F,
      [qe.RGB]: t.RGB32F,
      [qe.RG]: t.RG32F,
      [qe.RED]: t.R32F,
      [qe.DEPTH_COMPONENT]: t.DEPTH_COMPONENT32F
    },
    [_t.HALF_FLOAT]: {
      [qe.RGBA]: t.RGBA16F,
      [qe.RGB]: t.RGB16F,
      [qe.RG]: t.RG16F,
      [qe.RED]: t.R16F
    },
    [_t.UNSIGNED_SHORT_5_6_5]: {
      [qe.RGB]: t.RGB565
    },
    [_t.UNSIGNED_SHORT_4_4_4_4]: {
      [qe.RGBA]: t.RGBA4
    },
    [_t.UNSIGNED_SHORT_5_5_5_1]: {
      [qe.RGBA]: t.RGB5_A1
    },
    [_t.UNSIGNED_INT_2_10_10_10_REV]: {
      [qe.RGBA]: t.RGB10_A2,
      [qe.RGBA_INTEGER]: t.RGB10_A2UI
    },
    [_t.UNSIGNED_INT_10F_11F_11F_REV]: {
      [qe.RGB]: t.R11F_G11F_B10F
    },
    [_t.UNSIGNED_INT_5_9_9_9_REV]: {
      [qe.RGB]: t.RGB9_E5
    },
    [_t.UNSIGNED_INT_24_8]: {
      [qe.DEPTH_STENCIL]: t.DEPTH24_STENCIL8
    },
    [_t.FLOAT_32_UNSIGNED_INT_24_8_REV]: {
      [qe.DEPTH_STENCIL]: t.DEPTH32F_STENCIL8
    }
  } : e = {
    [_t.UNSIGNED_BYTE]: {
      [qe.RGBA]: t.RGBA,
      [qe.RGB]: t.RGB,
      [qe.ALPHA]: t.ALPHA,
      [qe.LUMINANCE]: t.LUMINANCE,
      [qe.LUMINANCE_ALPHA]: t.LUMINANCE_ALPHA
    },
    [_t.UNSIGNED_SHORT_5_6_5]: {
      [qe.RGB]: t.RGB
    },
    [_t.UNSIGNED_SHORT_4_4_4_4]: {
      [qe.RGBA]: t.RGBA
    },
    [_t.UNSIGNED_SHORT_5_5_5_1]: {
      [qe.RGBA]: t.RGBA
    }
  }, e;
}
class IB {
  /**
   * @param renderer - The renderer this system works for.
   */
  constructor(e) {
    this.renderer = e, this.boundTextures = [], this.currentLocation = -1, this.managedTextures = [], this._unknownBoundTextures = !1, this.unknownTexture = new qt(), this.hasIntegerTextures = !1;
  }
  /** Sets up the renderer context and necessary buffers. */
  contextChange() {
    const e = this.gl = this.renderer.gl;
    this.CONTEXT_UID = this.renderer.CONTEXT_UID, this.webGLVersion = this.renderer.context.webGLVersion, this.internalFormats = Xbe(e), this.samplerTypes = Ube(e);
    const n = e.getParameter(e.MAX_TEXTURE_IMAGE_UNITS);
    this.boundTextures.length = n;
    for (let o = 0; o < n; o++)
      this.boundTextures[o] = null;
    this.emptyTextures = {};
    const r = new bb(e.createTexture());
    e.bindTexture(e.TEXTURE_2D, r.texture), e.texImage2D(e.TEXTURE_2D, 0, e.RGBA, 1, 1, 0, e.RGBA, e.UNSIGNED_BYTE, new Uint8Array(4)), this.emptyTextures[e.TEXTURE_2D] = r, this.emptyTextures[e.TEXTURE_CUBE_MAP] = new bb(e.createTexture()), e.bindTexture(e.TEXTURE_CUBE_MAP, this.emptyTextures[e.TEXTURE_CUBE_MAP].texture);
    for (let o = 0; o < 6; o++)
      e.texImage2D(e.TEXTURE_CUBE_MAP_POSITIVE_X + o, 0, e.RGBA, 1, 1, 0, e.RGBA, e.UNSIGNED_BYTE, null);
    e.texParameteri(e.TEXTURE_CUBE_MAP, e.TEXTURE_MAG_FILTER, e.LINEAR), e.texParameteri(e.TEXTURE_CUBE_MAP, e.TEXTURE_MIN_FILTER, e.LINEAR);
    for (let o = 0; o < this.boundTextures.length; o++)
      this.bind(null, o);
  }
  /**
   * Bind a texture to a specific location
   *
   * If you want to unbind something, please use `unbind(texture)` instead of `bind(null, textureLocation)`
   * @param texture - Texture to bind
   * @param [location=0] - Location to bind at
   */
  bind(e, n = 0) {
    const { gl: r } = this;
    if (e = e?.castToBaseTexture(), e?.valid && !e.parentTextureArray) {
      e.touched = this.renderer.textureGC.count;
      const o = e._glTextures[this.CONTEXT_UID] || this.initTexture(e);
      this.boundTextures[n] !== e && (this.currentLocation !== n && (this.currentLocation = n, r.activeTexture(r.TEXTURE0 + n)), r.bindTexture(e.target, o.texture)), o.dirtyId !== e.dirtyId ? (this.currentLocation !== n && (this.currentLocation = n, r.activeTexture(r.TEXTURE0 + n)), this.updateTexture(e)) : o.dirtyStyleId !== e.dirtyStyleId && this.updateTextureStyle(e), this.boundTextures[n] = e;
    } else
      this.currentLocation !== n && (this.currentLocation = n, r.activeTexture(r.TEXTURE0 + n)), r.bindTexture(r.TEXTURE_2D, this.emptyTextures[r.TEXTURE_2D].texture), this.boundTextures[n] = null;
  }
  /** Resets texture location and bound textures Actual `bind(null, i)` calls will be performed at next `unbind()` call */
  reset() {
    this._unknownBoundTextures = !0, this.hasIntegerTextures = !1, this.currentLocation = -1;
    for (let e = 0; e < this.boundTextures.length; e++)
      this.boundTextures[e] = this.unknownTexture;
  }
  /**
   * Unbind a texture.
   * @param texture - Texture to bind
   */
  unbind(e) {
    const { gl: n, boundTextures: r } = this;
    if (this._unknownBoundTextures) {
      this._unknownBoundTextures = !1;
      for (let o = 0; o < r.length; o++)
        r[o] === this.unknownTexture && this.bind(null, o);
    }
    for (let o = 0; o < r.length; o++)
      r[o] === e && (this.currentLocation !== o && (n.activeTexture(n.TEXTURE0 + o), this.currentLocation = o), n.bindTexture(e.target, this.emptyTextures[e.target].texture), r[o] = null);
  }
  /**
   * Ensures that current boundTextures all have FLOAT sampler type,
   * see {@link PIXI.SAMPLER_TYPES} for explanation.
   * @param maxTextures - number of locations to check
   */
  ensureSamplerType(e) {
    const { boundTextures: n, hasIntegerTextures: r, CONTEXT_UID: o } = this;
    if (r)
      for (let s = e - 1; s >= 0; --s) {
        const i = n[s];
        i && i._glTextures[o].samplerType !== st.FLOAT && this.renderer.texture.unbind(i);
      }
  }
  /**
   * Initialize a texture
   * @private
   * @param texture - Texture to initialize
   */
  initTexture(e) {
    const n = new bb(this.gl.createTexture());
    return n.dirtyId = -1, e._glTextures[this.CONTEXT_UID] = n, this.managedTextures.push(e), e.on("dispose", this.destroyTexture, this), n;
  }
  initTextureType(e, n) {
    n.internalFormat = this.internalFormats[e.type]?.[e.format] ?? e.format, n.samplerType = this.samplerTypes[n.internalFormat] ?? st.FLOAT, this.webGLVersion === 2 && e.type === _t.HALF_FLOAT ? n.type = this.gl.HALF_FLOAT : n.type = e.type;
  }
  /**
   * Update a texture
   * @private
   * @param {PIXI.BaseTexture} texture - Texture to initialize
   */
  updateTexture(e) {
    const n = e._glTextures[this.CONTEXT_UID];
    if (!n)
      return;
    const r = this.renderer;
    if (this.initTextureType(e, n), e.resource?.upload(r, e, n))
      n.samplerType !== st.FLOAT && (this.hasIntegerTextures = !0);
    else {
      const o = e.realWidth, s = e.realHeight, i = r.gl;
      (n.width !== o || n.height !== s || n.dirtyId < 0) && (n.width = o, n.height = s, i.texImage2D(
        e.target,
        0,
        n.internalFormat,
        o,
        s,
        0,
        e.format,
        n.type,
        null
      ));
    }
    e.dirtyStyleId !== n.dirtyStyleId && this.updateTextureStyle(e), n.dirtyId = e.dirtyId;
  }
  /**
   * Deletes the texture from WebGL
   * @private
   * @param texture - the texture to destroy
   * @param [skipRemove=false] - Whether to skip removing the texture from the TextureManager.
   */
  destroyTexture(e, n) {
    const { gl: r } = this;
    if (e = e.castToBaseTexture(), e._glTextures[this.CONTEXT_UID] && (this.unbind(e), r.deleteTexture(e._glTextures[this.CONTEXT_UID].texture), e.off("dispose", this.destroyTexture, this), delete e._glTextures[this.CONTEXT_UID], !n)) {
      const o = this.managedTextures.indexOf(e);
      o !== -1 && Yd(this.managedTextures, o, 1);
    }
  }
  /**
   * Update texture style such as mipmap flag
   * @private
   * @param {PIXI.BaseTexture} texture - Texture to update
   */
  updateTextureStyle(e) {
    const n = e._glTextures[this.CONTEXT_UID];
    n && ((e.mipmap === yu.POW2 || this.webGLVersion !== 2) && !e.isPowerOfTwo ? n.mipmap = !1 : n.mipmap = e.mipmap >= 1, this.webGLVersion !== 2 && !e.isPowerOfTwo ? n.wrapMode = su.CLAMP : n.wrapMode = e.wrapMode, e.resource?.style(this.renderer, e, n) || this.setStyle(e, n), n.dirtyStyleId = e.dirtyStyleId);
  }
  /**
   * Set style for texture
   * @private
   * @param texture - Texture to update
   * @param glTexture
   */
  setStyle(e, n) {
    const r = this.gl;
    if (n.mipmap && e.mipmap !== yu.ON_MANUAL && r.generateMipmap(e.target), r.texParameteri(e.target, r.TEXTURE_WRAP_S, n.wrapMode), r.texParameteri(e.target, r.TEXTURE_WRAP_T, n.wrapMode), n.mipmap) {
      r.texParameteri(e.target, r.TEXTURE_MIN_FILTER, e.scaleMode === qu.LINEAR ? r.LINEAR_MIPMAP_LINEAR : r.NEAREST_MIPMAP_NEAREST);
      const o = this.renderer.context.extensions.anisotropicFiltering;
      if (o && e.anisotropicLevel > 0 && e.scaleMode === qu.LINEAR) {
        const s = Math.min(e.anisotropicLevel, r.getParameter(o.MAX_TEXTURE_MAX_ANISOTROPY_EXT));
        r.texParameterf(e.target, o.TEXTURE_MAX_ANISOTROPY_EXT, s);
      }
    } else
      r.texParameteri(e.target, r.TEXTURE_MIN_FILTER, e.scaleMode === qu.LINEAR ? r.LINEAR : r.NEAREST);
    r.texParameteri(e.target, r.TEXTURE_MAG_FILTER, e.scaleMode === qu.LINEAR ? r.LINEAR : r.NEAREST);
  }
  destroy() {
    this.renderer = null;
  }
}
IB.extension = {
  type: rt.RendererSystem,
  name: "texture"
};
dt.add(IB);
class FB {
  /**
   * @param renderer - The renderer this System works for.
   */
  constructor(e) {
    this.renderer = e;
  }
  /** Sets up the renderer context and necessary buffers. */
  contextChange() {
    this.gl = this.renderer.gl, this.CONTEXT_UID = this.renderer.CONTEXT_UID;
  }
  /**
   * Bind TransformFeedback and buffers
   * @param transformFeedback - TransformFeedback to bind
   */
  bind(e) {
    const { gl: n, CONTEXT_UID: r } = this, o = e._glTransformFeedbacks[r] || this.createGLTransformFeedback(e);
    n.bindTransformFeedback(n.TRANSFORM_FEEDBACK, o);
  }
  /** Unbind TransformFeedback */
  unbind() {
    const { gl: e } = this;
    e.bindTransformFeedback(e.TRANSFORM_FEEDBACK, null);
  }
  /**
   * Begin TransformFeedback
   * @param drawMode - DrawMode for TransformFeedback
   * @param shader - A Shader used by TransformFeedback. Current bound shader will be used if not provided.
   */
  beginTransformFeedback(e, n) {
    const { gl: r, renderer: o } = this;
    n && o.shader.bind(n), r.beginTransformFeedback(e);
  }
  /** End TransformFeedback */
  endTransformFeedback() {
    const { gl: e } = this;
    e.endTransformFeedback();
  }
  /**
   * Create TransformFeedback and bind buffers
   * @param tf - TransformFeedback
   * @returns WebGLTransformFeedback
   */
  createGLTransformFeedback(e) {
    const { gl: n, renderer: r, CONTEXT_UID: o } = this, s = n.createTransformFeedback();
    e._glTransformFeedbacks[o] = s, n.bindTransformFeedback(n.TRANSFORM_FEEDBACK, s);
    for (let i = 0; i < e.buffers.length; i++) {
      const u = e.buffers[i];
      u && (r.buffer.update(u), u._glBuffers[o].refCount++, n.bindBufferBase(n.TRANSFORM_FEEDBACK_BUFFER, i, u._glBuffers[o].buffer || null));
    }
    return n.bindTransformFeedback(n.TRANSFORM_FEEDBACK, null), e.disposeRunner.add(this), s;
  }
  /**
   * Disposes TransfromFeedback
   * @param {PIXI.TransformFeedback} tf - TransformFeedback
   * @param {boolean} [contextLost=false] - If context was lost, we suppress delete TransformFeedback
   */
  disposeTransformFeedback(e, n) {
    const r = e._glTransformFeedbacks[this.CONTEXT_UID], o = this.gl;
    e.disposeRunner.remove(this);
    const s = this.renderer.buffer;
    if (s)
      for (let i = 0; i < e.buffers.length; i++) {
        const u = e.buffers[i];
        if (!u)
          continue;
        const l = u._glBuffers[this.CONTEXT_UID];
        l && (l.refCount--, l.refCount === 0 && !n && s.dispose(u, n));
      }
    r && (n || o.deleteTransformFeedback(r), delete e._glTransformFeedbacks[this.CONTEXT_UID]);
  }
  destroy() {
    this.renderer = null;
  }
}
FB.extension = {
  type: rt.RendererSystem,
  name: "transformFeedback"
};
dt.add(FB);
class lv {
  constructor(e) {
    this.renderer = e;
  }
  /**
   * initiates the view system
   * @param {PIXI.ViewOptions} options - the options for the view
   */
  init(e) {
    this.screen = new Pt(0, 0, e.width, e.height), this.element = e.view || at.ADAPTER.createCanvas(), this.resolution = e.resolution || at.RESOLUTION, this.autoDensity = !!e.autoDensity;
  }
  /**
   * Resizes the screen and canvas to the specified dimensions.
   * @param desiredScreenWidth - The new width of the screen.
   * @param desiredScreenHeight - The new height of the screen.
   */
  resizeView(e, n) {
    this.element.width = Math.round(e * this.resolution), this.element.height = Math.round(n * this.resolution);
    const r = this.element.width / this.resolution, o = this.element.height / this.resolution;
    this.screen.width = r, this.screen.height = o, this.autoDensity && (this.element.style.width = `${r}px`, this.element.style.height = `${o}px`), this.renderer.emit("resize", r, o), this.renderer.runners.resize.emit(this.screen.width, this.screen.height);
  }
  /**
   * Destroys this System and optionally removes the canvas from the dom.
   * @param {boolean} [removeView=false] - Whether to remove the canvas from the DOM.
   */
  destroy(e) {
    e && this.element.parentNode?.removeChild(this.element), this.renderer = null, this.element = null, this.screen = null;
  }
}
lv.defaultOptions = {
  /**
   * {@link PIXI.IRendererOptions.width}
   * @default 800
   * @memberof PIXI.settings.RENDER_OPTIONS
   */
  width: 800,
  /**
   * {@link PIXI.IRendererOptions.height}
   * @default 600
   * @memberof PIXI.settings.RENDER_OPTIONS
   */
  height: 600,
  /**
   * {@link PIXI.IRendererOptions.resolution}
   * @type {number}
   * @default PIXI.settings.RESOLUTION
   * @memberof PIXI.settings.RENDER_OPTIONS
   */
  resolution: void 0,
  /**
   * {@link PIXI.IRendererOptions.autoDensity}
   * @default false
   * @memberof PIXI.settings.RENDER_OPTIONS
   */
  autoDensity: !1
}, /** @ignore */
lv.extension = {
  type: [
    rt.RendererSystem,
    rt.CanvasRendererSystem
  ],
  name: "_view"
};
dt.add(lv);
at.PREFER_ENV = nd.WEBGL2;
at.STRICT_TEXTURE_CACHE = !1;
at.RENDER_OPTIONS = {
  ...iv.defaultOptions,
  ...av.defaultOptions,
  ...lv.defaultOptions,
  ...uv.defaultOptions
};
Object.defineProperties(at, {
  /**
   * @static
   * @name WRAP_MODE
   * @memberof PIXI.settings
   * @type {PIXI.WRAP_MODES}
   * @deprecated since 7.1.0
   * @see PIXI.BaseTexture.defaultOptions.wrapMode
   */
  WRAP_MODE: {
    get() {
      return qt.defaultOptions.wrapMode;
    },
    set(t) {
      un("7.1.0", "settings.WRAP_MODE is deprecated, use BaseTexture.defaultOptions.wrapMode"), qt.defaultOptions.wrapMode = t;
    }
  },
  /**
   * @static
   * @name SCALE_MODE
   * @memberof PIXI.settings
   * @type {PIXI.SCALE_MODES}
   * @deprecated since 7.1.0
   * @see PIXI.BaseTexture.defaultOptions.scaleMode
   */
  SCALE_MODE: {
    get() {
      return qt.defaultOptions.scaleMode;
    },
    set(t) {
      un("7.1.0", "settings.SCALE_MODE is deprecated, use BaseTexture.defaultOptions.scaleMode"), qt.defaultOptions.scaleMode = t;
    }
  },
  /**
   * @static
   * @name MIPMAP_TEXTURES
   * @memberof PIXI.settings
   * @type {PIXI.MIPMAP_MODES}
   * @deprecated since 7.1.0
   * @see PIXI.BaseTexture.defaultOptions.mipmap
   */
  MIPMAP_TEXTURES: {
    get() {
      return qt.defaultOptions.mipmap;
    },
    set(t) {
      un("7.1.0", "settings.MIPMAP_TEXTURES is deprecated, use BaseTexture.defaultOptions.mipmap"), qt.defaultOptions.mipmap = t;
    }
    // MIPMAP_MODES.POW2,
  },
  /**
   * @static
   * @name ANISOTROPIC_LEVEL
   * @memberof PIXI.settings
   * @type {number}
   * @deprecated since 7.1.0
   * @see PIXI.BaseTexture.defaultOptions.anisotropicLevel
   */
  ANISOTROPIC_LEVEL: {
    get() {
      return qt.defaultOptions.anisotropicLevel;
    },
    set(t) {
      un(
        "7.1.0",
        "settings.ANISOTROPIC_LEVEL is deprecated, use BaseTexture.defaultOptions.anisotropicLevel"
      ), qt.defaultOptions.anisotropicLevel = t;
    }
  },
  /**
   * Default filter resolution.
   * @static
   * @name FILTER_RESOLUTION
   * @memberof PIXI.settings
   * @deprecated since 7.1.0
   * @type {number|null}
   * @see PIXI.Filter.defaultResolution
   */
  FILTER_RESOLUTION: {
    get() {
      return un("7.1.0", "settings.FILTER_RESOLUTION is deprecated, use Filter.defaultResolution"), Jo.defaultResolution;
    },
    set(t) {
      Jo.defaultResolution = t;
    }
  },
  /**
   * Default filter samples.
   * @static
   * @name FILTER_MULTISAMPLE
   * @memberof PIXI.settings
   * @deprecated since 7.1.0
   * @type {PIXI.MSAA_QUALITY}
   * @see PIXI.Filter.defaultMultisample
   */
  FILTER_MULTISAMPLE: {
    get() {
      return un("7.1.0", "settings.FILTER_MULTISAMPLE is deprecated, use Filter.defaultMultisample"), Jo.defaultMultisample;
    },
    set(t) {
      Jo.defaultMultisample = t;
    }
  },
  /**
   * The maximum textures that this device supports.
   * @static
   * @name SPRITE_MAX_TEXTURES
   * @memberof PIXI.settings
   * @deprecated since 7.1.0
   * @see PIXI.BatchRenderer.defaultMaxTextures
   * @type {number}
   */
  SPRITE_MAX_TEXTURES: {
    get() {
      return ap.defaultMaxTextures;
    },
    set(t) {
      un("7.1.0", "settings.SPRITE_MAX_TEXTURES is deprecated, use BatchRenderer.defaultMaxTextures"), ap.defaultMaxTextures = t;
    }
  },
  /**
   * The default sprite batch size.
   *
   * The default aims to balance desktop and mobile devices.
   * @static
   * @name SPRITE_BATCH_SIZE
   * @memberof PIXI.settings
   * @see PIXI.BatchRenderer.defaultBatchSize
   * @deprecated since 7.1.0
   * @type {number}
   */
  SPRITE_BATCH_SIZE: {
    get() {
      return ap.defaultBatchSize;
    },
    set(t) {
      un("7.1.0", "settings.SPRITE_BATCH_SIZE is deprecated, use BatchRenderer.defaultBatchSize"), ap.defaultBatchSize = t;
    }
  },
  /**
   * Can we upload the same buffer in a single frame?
   * @static
   * @name CAN_UPLOAD_SAME_BUFFER
   * @memberof PIXI.settings
   * @see PIXI.BatchRenderer.canUploadSameBuffer
   * @deprecated since 7.1.0
   * @type {boolean}
   */
  CAN_UPLOAD_SAME_BUFFER: {
    get() {
      return ap.canUploadSameBuffer;
    },
    set(t) {
      un("7.1.0", "settings.CAN_UPLOAD_SAME_BUFFER is deprecated, use BatchRenderer.canUploadSameBuffer"), ap.canUploadSameBuffer = t;
    }
  },
  /**
   * Default Garbage Collection mode.
   * @static
   * @name GC_MODE
   * @memberof PIXI.settings
   * @type {PIXI.GC_MODES}
   * @deprecated since 7.1.0
   * @see PIXI.TextureGCSystem.defaultMode
   */
  GC_MODE: {
    get() {
      return ip.defaultMode;
    },
    set(t) {
      un("7.1.0", "settings.GC_MODE is deprecated, use TextureGCSystem.defaultMode"), ip.defaultMode = t;
    }
  },
  /**
   * Default Garbage Collection max idle.
   * @static
   * @name GC_MAX_IDLE
   * @memberof PIXI.settings
   * @type {number}
   * @deprecated since 7.1.0
   * @see PIXI.TextureGCSystem.defaultMaxIdle
   */
  GC_MAX_IDLE: {
    get() {
      return ip.defaultMaxIdle;
    },
    set(t) {
      un("7.1.0", "settings.GC_MAX_IDLE is deprecated, use TextureGCSystem.defaultMaxIdle"), ip.defaultMaxIdle = t;
    }
  },
  /**
   * Default Garbage Collection maximum check count.
   * @static
   * @name GC_MAX_CHECK_COUNT
   * @memberof PIXI.settings
   * @type {number}
   * @deprecated since 7.1.0
   * @see PIXI.TextureGCSystem.defaultCheckCountMax
   */
  GC_MAX_CHECK_COUNT: {
    get() {
      return ip.defaultCheckCountMax;
    },
    set(t) {
      un("7.1.0", "settings.GC_MAX_CHECK_COUNT is deprecated, use TextureGCSystem.defaultCheckCountMax"), ip.defaultCheckCountMax = t;
    }
  },
  /**
   * Default specify float precision in vertex shader.
   * @static
   * @name PRECISION_VERTEX
   * @memberof PIXI.settings
   * @type {PIXI.PRECISION}
   * @deprecated since 7.1.0
   * @see PIXI.Program.defaultVertexPrecision
   */
  PRECISION_VERTEX: {
    get() {
      return Qu.defaultVertexPrecision;
    },
    set(t) {
      un("7.1.0", "settings.PRECISION_VERTEX is deprecated, use Program.defaultVertexPrecision"), Qu.defaultVertexPrecision = t;
    }
  },
  /**
   * Default specify float precision in fragment shader.
   * @static
   * @name PRECISION_FRAGMENT
   * @memberof PIXI.settings
   * @type {PIXI.PRECISION}
   * @deprecated since 7.1.0
   * @see PIXI.Program.defaultFragmentPrecision
   */
  PRECISION_FRAGMENT: {
    get() {
      return Qu.defaultFragmentPrecision;
    },
    set(t) {
      un("7.1.0", "settings.PRECISION_FRAGMENT is deprecated, use Program.defaultFragmentPrecision"), Qu.defaultFragmentPrecision = t;
    }
  }
});
var Xp = /* @__PURE__ */ ((t) => (t[t.INTERACTION = 50] = "INTERACTION", t[t.HIGH = 25] = "HIGH", t[t.NORMAL = 0] = "NORMAL", t[t.LOW = -25] = "LOW", t[t.UTILITY = -50] = "UTILITY", t))(Xp || {});
class kb {
  /**
   * Constructor
   * @private
   * @param fn - The listener function to be added for one update
   * @param context - The listener context
   * @param priority - The priority for emitting
   * @param once - If the handler should fire once
   */
  constructor(e, n = null, r = 0, o = !1) {
    this.next = null, this.previous = null, this._destroyed = !1, this.fn = e, this.context = n, this.priority = r, this.once = o;
  }
  /**
   * Simple compare function to figure out if a function and context match.
   * @private
   * @param fn - The listener function to be added for one update
   * @param context - The listener context
   * @returns `true` if the listener match the arguments
   */
  match(e, n = null) {
    return this.fn === e && this.context === n;
  }
  /**
   * Emit by calling the current function.
   * @private
   * @param deltaTime - time since the last emit.
   * @returns Next ticker
   */
  emit(e) {
    this.fn && (this.context ? this.fn.call(this.context, e) : this.fn(e));
    const n = this.next;
    return this.once && this.destroy(!0), this._destroyed && (this.next = null), n;
  }
  /**
   * Connect to the list.
   * @private
   * @param previous - Input node, previous listener
   */
  connect(e) {
    this.previous = e, e.next && (e.next.previous = this), this.next = e.next, e.next = this;
  }
  /**
   * Destroy and don't use after this.
   * @private
   * @param hard - `true` to remove the `next` reference, this
   *        is considered a hard destroy. Soft destroy maintains the next reference.
   * @returns The listener to redirect while emitting or removing.
   */
  destroy(e = !1) {
    this._destroyed = !0, this.fn = null, this.context = null, this.previous && (this.previous.next = this.next), this.next && (this.next.previous = this.previous);
    const n = this.next;
    return this.next = e ? null : n, this.previous = null, n;
  }
}
const NB = class Hs {
  constructor() {
    this.autoStart = !1, this.deltaTime = 1, this.lastTime = -1, this.speed = 1, this.started = !1, this._requestId = null, this._maxElapsedMS = 100, this._minElapsedMS = 0, this._protected = !1, this._lastFrame = -1, this._head = new kb(null, null, 1 / 0), this.deltaMS = 1 / Hs.targetFPMS, this.elapsedMS = 1 / Hs.targetFPMS, this._tick = (e) => {
      this._requestId = null, this.started && (this.update(e), this.started && this._requestId === null && this._head.next && (this._requestId = requestAnimationFrame(this._tick)));
    };
  }
  /**
   * Conditionally requests a new animation frame.
   * If a frame has not already been requested, and if the internal
   * emitter has listeners, a new frame is requested.
   * @private
   */
  _requestIfNeeded() {
    this._requestId === null && this._head.next && (this.lastTime = performance.now(), this._lastFrame = this.lastTime, this._requestId = requestAnimationFrame(this._tick));
  }
  /**
   * Conditionally cancels a pending animation frame.
   * @private
   */
  _cancelIfNeeded() {
    this._requestId !== null && (cancelAnimationFrame(this._requestId), this._requestId = null);
  }
  /**
   * Conditionally requests a new animation frame.
   * If the ticker has been started it checks if a frame has not already
   * been requested, and if the internal emitter has listeners. If these
   * conditions are met, a new frame is requested. If the ticker has not
   * been started, but autoStart is `true`, then the ticker starts now,
   * and continues with the previous conditions to request a new frame.
   * @private
   */
  _startIfPossible() {
    this.started ? this._requestIfNeeded() : this.autoStart && this.start();
  }
  /**
   * Register a handler for tick events. Calls continuously unless
   * it is removed or the ticker is stopped.
   * @param fn - The listener function to be added for updates
   * @param context - The listener context
   * @param {number} [priority=PIXI.UPDATE_PRIORITY.NORMAL] - The priority for emitting
   * @returns This instance of a ticker
   */
  add(e, n, r = Xp.NORMAL) {
    return this._addListener(new kb(e, n, r));
  }
  /**
   * Add a handler for the tick event which is only execute once.
   * @param fn - The listener function to be added for one update
   * @param context - The listener context
   * @param {number} [priority=PIXI.UPDATE_PRIORITY.NORMAL] - The priority for emitting
   * @returns This instance of a ticker
   */
  addOnce(e, n, r = Xp.NORMAL) {
    return this._addListener(new kb(e, n, r, !0));
  }
  /**
   * Internally adds the event handler so that it can be sorted by priority.
   * Priority allows certain handler (user, AnimatedSprite, Interaction) to be run
   * before the rendering.
   * @private
   * @param listener - Current listener being added.
   * @returns This instance of a ticker
   */
  _addListener(e) {
    let n = this._head.next, r = this._head;
    if (!n)
      e.connect(r);
    else {
      for (; n; ) {
        if (e.priority > n.priority) {
          e.connect(r);
          break;
        }
        r = n, n = n.next;
      }
      e.previous || e.connect(r);
    }
    return this._startIfPossible(), this;
  }
  /**
   * Removes any handlers matching the function and context parameters.
   * If no handlers are left after removing, then it cancels the animation frame.
   * @param fn - The listener function to be removed
   * @param context - The listener context to be removed
   * @returns This instance of a ticker
   */
  remove(e, n) {
    let r = this._head.next;
    for (; r; )
      r.match(e, n) ? r = r.destroy() : r = r.next;
    return this._head.next || this._cancelIfNeeded(), this;
  }
  /**
   * The number of listeners on this ticker, calculated by walking through linked list
   * @readonly
   * @member {number}
   */
  get count() {
    if (!this._head)
      return 0;
    let e = 0, n = this._head;
    for (; n = n.next; )
      e++;
    return e;
  }
  /** Starts the ticker. If the ticker has listeners a new animation frame is requested at this point. */
  start() {
    this.started || (this.started = !0, this._requestIfNeeded());
  }
  /** Stops the ticker. If the ticker has requested an animation frame it is canceled at this point. */
  stop() {
    this.started && (this.started = !1, this._cancelIfNeeded());
  }
  /** Destroy the ticker and don't use after this. Calling this method removes all references to internal events. */
  destroy() {
    if (!this._protected) {
      this.stop();
      let e = this._head.next;
      for (; e; )
        e = e.destroy(!0);
      this._head.destroy(), this._head = null;
    }
  }
  /**
   * Triggers an update. An update entails setting the
   * current {@link PIXI.Ticker#elapsedMS},
   * the current {@link PIXI.Ticker#deltaTime},
   * invoking all listeners with current deltaTime,
   * and then finally setting {@link PIXI.Ticker#lastTime}
   * with the value of currentTime that was provided.
   * This method will be called automatically by animation
   * frame callbacks if the ticker instance has been started
   * and listeners are added.
   * @param {number} [currentTime=performance.now()] - the current time of execution
   */
  update(e = performance.now()) {
    let n;
    if (e > this.lastTime) {
      if (n = this.elapsedMS = e - this.lastTime, n > this._maxElapsedMS && (n = this._maxElapsedMS), n *= this.speed, this._minElapsedMS) {
        const s = e - this._lastFrame | 0;
        if (s < this._minElapsedMS)
          return;
        this._lastFrame = e - s % this._minElapsedMS;
      }
      this.deltaMS = n, this.deltaTime = this.deltaMS * Hs.targetFPMS;
      const r = this._head;
      let o = r.next;
      for (; o; )
        o = o.emit(this.deltaTime);
      r.next || this._cancelIfNeeded();
    } else
      this.deltaTime = this.deltaMS = this.elapsedMS = 0;
    this.lastTime = e;
  }
  /**
   * The frames per second at which this ticker is running.
   * The default is approximately 60 in most modern browsers.
   * **Note:** This does not factor in the value of
   * {@link PIXI.Ticker#speed}, which is specific
   * to scaling {@link PIXI.Ticker#deltaTime}.
   * @member {number}
   * @readonly
   */
  get FPS() {
    return 1e3 / this.elapsedMS;
  }
  /**
   * Manages the maximum amount of milliseconds allowed to
   * elapse between invoking {@link PIXI.Ticker#update}.
   * This value is used to cap {@link PIXI.Ticker#deltaTime},
   * but does not effect the measured value of {@link PIXI.Ticker#FPS}.
   * When setting this property it is clamped to a value between
   * `0` and `Ticker.targetFPMS * 1000`.
   * @member {number}
   * @default 10
   */
  get minFPS() {
    return 1e3 / this._maxElapsedMS;
  }
  set minFPS(e) {
    const n = Math.min(this.maxFPS, e), r = Math.min(Math.max(0, n) / 1e3, Hs.targetFPMS);
    this._maxElapsedMS = 1 / r;
  }
  /**
   * Manages the minimum amount of milliseconds required to
   * elapse between invoking {@link PIXI.Ticker#update}.
   * This will effect the measured value of {@link PIXI.Ticker#FPS}.
   * If it is set to `0`, then there is no limit; PixiJS will render as many frames as it can.
   * Otherwise it will be at least `minFPS`
   * @member {number}
   * @default 0
   */
  get maxFPS() {
    return this._minElapsedMS ? Math.round(1e3 / this._minElapsedMS) : 0;
  }
  set maxFPS(e) {
    if (e === 0)
      this._minElapsedMS = 0;
    else {
      const n = Math.max(this.minFPS, e);
      this._minElapsedMS = 1 / (n / 1e3);
    }
  }
  /**
   * The shared ticker instance used by {@link PIXI.AnimatedSprite} and by
   * {@link PIXI.VideoResource} to update animation frames / video textures.
   *
   * It may also be used by {@link PIXI.Application} if created with the `sharedTicker` option property set to true.
   *
   * The property {@link PIXI.Ticker#autoStart} is set to `true` for this instance.
   * Please follow the examples for usage, including how to opt-out of auto-starting the shared ticker.
   * @example
   * import { Ticker } from 'pixi.js';
   *
   * const ticker = Ticker.shared;
   * // Set this to prevent starting this ticker when listeners are added.
   * // By default this is true only for the PIXI.Ticker.shared instance.
   * ticker.autoStart = false;
   *
   * // FYI, call this to ensure the ticker is stopped. It should be stopped
   * // if you have not attempted to render anything yet.
   * ticker.stop();
   *
   * // Call this when you are ready for a running shared ticker.
   * ticker.start();
   * @example
   * import { autoDetectRenderer, Container } from 'pixi.js';
   *
   * // You may use the shared ticker to render...
   * const renderer = autoDetectRenderer();
   * const stage = new Container();
   * document.body.appendChild(renderer.view);
   * ticker.add((time) => renderer.render(stage));
   *
   * // Or you can just update it manually.
   * ticker.autoStart = false;
   * ticker.stop();
   * const animate = (time) => {
   *     ticker.update(time);
   *     renderer.render(stage);
   *     requestAnimationFrame(animate);
   * };
   * animate(performance.now());
   * @member {PIXI.Ticker}
   * @static
   */
  static get shared() {
    if (!Hs._shared) {
      const e = Hs._shared = new Hs();
      e.autoStart = !0, e._protected = !0;
    }
    return Hs._shared;
  }
  /**
   * The system ticker instance used by {@link PIXI.BasePrepare} for core timing
   * functionality that shouldn't usually need to be paused, unlike the `shared`
   * ticker which drives visual animations and rendering which may want to be paused.
   *
   * The property {@link PIXI.Ticker#autoStart} is set to `true` for this instance.
   * @member {PIXI.Ticker}
   * @static
   */
  static get system() {
    if (!Hs._system) {
      const e = Hs._system = new Hs();
      e.autoStart = !0, e._protected = !0;
    }
    return Hs._system;
  }
};
NB.targetFPMS = 0.06;
let es = NB;
Object.defineProperties(at, {
  /**
   * Target frames per millisecond.
   * @static
   * @name TARGET_FPMS
   * @memberof PIXI.settings
   * @type {number}
   * @deprecated since 7.1.0
   * @see PIXI.Ticker.targetFPMS
   */
  TARGET_FPMS: {
    get() {
      return es.targetFPMS;
    },
    set(t) {
      un("7.1.0", "settings.TARGET_FPMS is deprecated, use Ticker.targetFPMS"), es.targetFPMS = t;
    }
  }
});
class LB {
  /**
   * Initialize the plugin with scope of application instance
   * @static
   * @private
   * @param {object} [options] - See application options
   */
  static init(e) {
    e = Object.assign({
      autoStart: !0,
      sharedTicker: !1
    }, e), Object.defineProperty(
      this,
      "ticker",
      {
        set(n) {
          this._ticker && this._ticker.remove(this.render, this), this._ticker = n, n && n.add(this.render, this, Xp.LOW);
        },
        get() {
          return this._ticker;
        }
      }
    ), this.stop = () => {
      this._ticker.stop();
    }, this.start = () => {
      this._ticker.start();
    }, this._ticker = null, this.ticker = e.sharedTicker ? es.shared : new es(), e.autoStart && this.start();
  }
  /**
   * Clean up the ticker, scoped to application.
   * @static
   * @private
   */
  static destroy() {
    if (this._ticker) {
      const e = this._ticker;
      this.ticker = null, e.destroy();
    }
  }
}
LB.extension = rt.Application;
dt.add(LB);
const BB = [];
dt.handleByList(rt.Renderer, BB);
function $be(t) {
  for (const e of BB)
    if (e.test(t))
      return new e(t);
  throw new Error("Unable to auto-detect a suitable renderer.");
}
var Wbe = `attribute vec2 aVertexPosition;
attribute vec2 aTextureCoord;

uniform mat3 projectionMatrix;

varying vec2 vTextureCoord;

void main(void)
{
    gl_Position = vec4((projectionMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);
    vTextureCoord = aTextureCoord;
}`, Vbe = `attribute vec2 aVertexPosition;

uniform mat3 projectionMatrix;

varying vec2 vTextureCoord;

uniform vec4 inputSize;
uniform vec4 outputFrame;

vec4 filterVertexPosition( void )
{
    vec2 position = aVertexPosition * max(outputFrame.zw, vec2(0.)) + outputFrame.xy;

    return vec4((projectionMatrix * vec3(position, 1.0)).xy, 0.0, 1.0);
}

vec2 filterTextureCoord( void )
{
    return aVertexPosition * (outputFrame.zw * inputSize.zw);
}

void main(void)
{
    gl_Position = filterVertexPosition();
    vTextureCoord = filterTextureCoord();
}
`;
const Hbe = Wbe, UB = Vbe;
class XB {
  constructor(e) {
    this.renderer = e;
  }
  contextChange(e) {
    let n;
    if (this.renderer.context.webGLVersion === 1) {
      const r = e.getParameter(e.FRAMEBUFFER_BINDING);
      e.bindFramebuffer(e.FRAMEBUFFER, null), n = e.getParameter(e.SAMPLES), e.bindFramebuffer(e.FRAMEBUFFER, r);
    } else {
      const r = e.getParameter(e.DRAW_FRAMEBUFFER_BINDING);
      e.bindFramebuffer(e.DRAW_FRAMEBUFFER, null), n = e.getParameter(e.SAMPLES), e.bindFramebuffer(e.DRAW_FRAMEBUFFER, r);
    }
    n >= jr.HIGH ? this.multisample = jr.HIGH : n >= jr.MEDIUM ? this.multisample = jr.MEDIUM : n >= jr.LOW ? this.multisample = jr.LOW : this.multisample = jr.NONE;
  }
  destroy() {
  }
}
XB.extension = {
  type: rt.RendererSystem,
  name: "_multisample"
};
dt.add(XB);
class jbe {
  constructor(e) {
    this.buffer = e || null, this.updateID = -1, this.byteLength = -1, this.refCount = 0;
  }
}
class $B {
  /**
   * @param {PIXI.Renderer} renderer - The renderer this System works for.
   */
  constructor(e) {
    this.renderer = e, this.managedBuffers = {}, this.boundBufferBases = {};
  }
  /**
   * @ignore
   */
  destroy() {
    this.renderer = null;
  }
  /** Sets up the renderer context and necessary buffers. */
  contextChange() {
    this.disposeAll(!0), this.gl = this.renderer.gl, this.CONTEXT_UID = this.renderer.CONTEXT_UID;
  }
  /**
   * This binds specified buffer. On first run, it will create the webGL buffers for the context too
   * @param buffer - the buffer to bind to the renderer
   */
  bind(e) {
    const { gl: n, CONTEXT_UID: r } = this, o = e._glBuffers[r] || this.createGLBuffer(e);
    n.bindBuffer(e.type, o.buffer);
  }
  unbind(e) {
    const { gl: n } = this;
    n.bindBuffer(e, null);
  }
  /**
   * Binds an uniform buffer to at the given index.
   *
   * A cache is used so a buffer will not be bound again if already bound.
   * @param buffer - the buffer to bind
   * @param index - the base index to bind it to.
   */
  bindBufferBase(e, n) {
    const { gl: r, CONTEXT_UID: o } = this;
    if (this.boundBufferBases[n] !== e) {
      const s = e._glBuffers[o] || this.createGLBuffer(e);
      this.boundBufferBases[n] = e, r.bindBufferBase(r.UNIFORM_BUFFER, n, s.buffer);
    }
  }
  /**
   * Binds a buffer whilst also binding its range.
   * This will make the buffer start from the offset supplied rather than 0 when it is read.
   * @param buffer - the buffer to bind
   * @param index - the base index to bind at, defaults to 0
   * @param offset - the offset to bind at (this is blocks of 256). 0 = 0, 1 = 256, 2 = 512 etc
   */
  bindBufferRange(e, n, r) {
    const { gl: o, CONTEXT_UID: s } = this;
    r = r || 0;
    const i = e._glBuffers[s] || this.createGLBuffer(e);
    o.bindBufferRange(o.UNIFORM_BUFFER, n || 0, i.buffer, r * 256, 256);
  }
  /**
   * Will ensure the data in the buffer is uploaded to the GPU.
   * @param {PIXI.Buffer} buffer - the buffer to update
   */
  update(e) {
    const { gl: n, CONTEXT_UID: r } = this, o = e._glBuffers[r] || this.createGLBuffer(e);
    if (e._updateID !== o.updateID)
      if (o.updateID = e._updateID, n.bindBuffer(e.type, o.buffer), o.byteLength >= e.data.byteLength)
        n.bufferSubData(e.type, 0, e.data);
      else {
        const s = e.static ? n.STATIC_DRAW : n.DYNAMIC_DRAW;
        o.byteLength = e.data.byteLength, n.bufferData(e.type, e.data, s);
      }
  }
  /**
   * Disposes buffer
   * @param {PIXI.Buffer} buffer - buffer with data
   * @param {boolean} [contextLost=false] - If context was lost, we suppress deleteVertexArray
   */
  dispose(e, n) {
    if (!this.managedBuffers[e.id])
      return;
    delete this.managedBuffers[e.id];
    const r = e._glBuffers[this.CONTEXT_UID], o = this.gl;
    e.disposeRunner.remove(this), r && (n || o.deleteBuffer(r.buffer), delete e._glBuffers[this.CONTEXT_UID]);
  }
  /**
   * dispose all WebGL resources of all managed buffers
   * @param {boolean} [contextLost=false] - If context was lost, we suppress `gl.delete` calls
   */
  disposeAll(e) {
    const n = Object.keys(this.managedBuffers);
    for (let r = 0; r < n.length; r++)
      this.dispose(this.managedBuffers[n[r]], e);
  }
  /**
   * creates and attaches a GLBuffer object tied to the current context.
   * @param buffer
   * @protected
   */
  createGLBuffer(e) {
    const { CONTEXT_UID: n, gl: r } = this;
    return e._glBuffers[n] = new jbe(r.createBuffer()), this.managedBuffers[e.id] = e, e.disposeRunner.add(this), e._glBuffers[n];
  }
}
$B.extension = {
  type: rt.RendererSystem,
  name: "buffer"
};
dt.add($B);
class WB {
  // renderers scene graph!
  constructor(e) {
    this.renderer = e;
  }
  /**
   * Renders the object to its WebGL view.
   * @param displayObject - The object to be rendered.
   * @param options - the options to be passed to the renderer
   */
  render(e, n) {
    const r = this.renderer;
    let o, s, i, u;
    if (n && (o = n.renderTexture, s = n.clear, i = n.transform, u = n.skipUpdateTransform), this.renderingToScreen = !o, r.runners.prerender.emit(), r.emit("prerender"), r.projection.transform = i, !r.context.isLost) {
      if (o || (this.lastObjectRendered = e), !u) {
        const l = e.enableTempParent();
        e.updateTransform(), e.disableTempParent(l);
      }
      r.renderTexture.bind(o), r.batch.currentRenderer.start(), (s ?? r.background.clearBeforeRender) && r.renderTexture.clear(), e.render(r), r.batch.currentRenderer.flush(), o && (n.blit && r.framebuffer.blit(), o.baseTexture.update()), r.runners.postrender.emit(), r.projection.transform = null, r.emit("postrender");
    }
  }
  destroy() {
    this.renderer = null, this.lastObjectRendered = null;
  }
}
WB.extension = {
  type: rt.RendererSystem,
  name: "objectRenderer"
};
dt.add(WB);
const o0 = class dT extends Bbe {
  /**
   * @param {PIXI.IRendererOptions} [options] - See {@link PIXI.settings.RENDER_OPTIONS} for defaults.
   */
  constructor(e) {
    super(), this.type = jL.WEBGL, e = Object.assign({}, at.RENDER_OPTIONS, e), this.gl = null, this.CONTEXT_UID = 0, this.globalUniforms = new di({
      projectionMatrix: new Qn()
    }, !0);
    const n = {
      runners: [
        "init",
        "destroy",
        "contextChange",
        "resolutionChange",
        "reset",
        "update",
        "postrender",
        "prerender",
        "resize"
      ],
      systems: dT.__systems,
      priority: [
        "_view",
        "textureGenerator",
        "background",
        "_plugin",
        "startup",
        // low level WebGL systems
        "context",
        "state",
        "texture",
        "buffer",
        "geometry",
        "framebuffer",
        "transformFeedback",
        // high level pixi specific rendering
        "mask",
        "scissor",
        "stencil",
        "projection",
        "textureGC",
        "filter",
        "renderTexture",
        "batch",
        "objectRenderer",
        "_multisample"
      ]
    };
    this.setup(n), "useContextAlpha" in e && (un("7.0.0", "options.useContextAlpha is deprecated, use options.premultipliedAlpha and options.backgroundAlpha instead"), e.premultipliedAlpha = e.useContextAlpha && e.useContextAlpha !== "notMultiplied", e.backgroundAlpha = e.useContextAlpha === !1 ? 1 : e.backgroundAlpha), this._plugin.rendererPlugins = dT.__plugins, this.options = e, this.startup.run(this.options);
  }
  /**
   * Create renderer if WebGL is available. Overrideable
   * by the **@pixi/canvas-renderer** package to allow fallback.
   * throws error if WebGL is not available.
   * @param options
   * @private
   */
  static test(e) {
    return e?.forceCanvas ? !1 : m1e();
  }
  /**
   * Renders the object to its WebGL view.
   * @param displayObject - The object to be rendered.
   * @param {object} [options] - Object to use for render options.
   * @param {PIXI.RenderTexture} [options.renderTexture] - The render texture to render to.
   * @param {boolean} [options.clear=true] - Should the canvas be cleared before the new render.
   * @param {PIXI.Matrix} [options.transform] - A transform to apply to the render texture before rendering.
   * @param {boolean} [options.skipUpdateTransform=false] - Should we skip the update transform pass?
   */
  render(e, n) {
    this.objectRenderer.render(e, n);
  }
  /**
   * Resizes the WebGL view to the specified width and height.
   * @param desiredScreenWidth - The desired width of the screen.
   * @param desiredScreenHeight - The desired height of the screen.
   */
  resize(e, n) {
    this._view.resizeView(e, n);
  }
  /**
   * Resets the WebGL state so you can render things however you fancy!
   * @returns Returns itself.
   */
  reset() {
    return this.runners.reset.emit(), this;
  }
  /** Clear the frame buffer. */
  clear() {
    this.renderTexture.bind(), this.renderTexture.clear();
  }
  /**
   * Removes everything from the renderer (event listeners, spritebatch, etc...)
   * @param [removeView=false] - Removes the Canvas element from the DOM.
   *  See: https://github.com/pixijs/pixijs/issues/2233
   */
  destroy(e = !1) {
    this.runners.destroy.items.reverse(), this.emitWithCustomOptions(this.runners.destroy, {
      _view: e
    }), super.destroy();
  }
  /** Collection of plugins */
  get plugins() {
    return this._plugin.plugins;
  }
  /** The number of msaa samples of the canvas. */
  get multisample() {
    return this._multisample.multisample;
  }
  /**
   * Same as view.width, actual number of pixels in the canvas by horizontal.
   * @member {number}
   * @readonly
   * @default 800
   */
  get width() {
    return this._view.element.width;
  }
  /**
   * Same as view.height, actual number of pixels in the canvas by vertical.
   * @default 600
   */
  get height() {
    return this._view.element.height;
  }
  /** The resolution / device pixel ratio of the renderer. */
  get resolution() {
    return this._view.resolution;
  }
  set resolution(e) {
    this._view.resolution = e, this.runners.resolutionChange.emit(e);
  }
  /** Whether CSS dimensions of canvas view should be resized to screen dimensions automatically. */
  get autoDensity() {
    return this._view.autoDensity;
  }
  /** The canvas element that everything is drawn to.*/
  get view() {
    return this._view.element;
  }
  /**
   * Measurements of the screen. (0, 0, screenWidth, screenHeight).
   *
   * Its safe to use as filterArea or hitArea for the whole stage.
   * @member {PIXI.Rectangle}
   */
  get screen() {
    return this._view.screen;
  }
  /** the last object rendered by the renderer. Useful for other plugins like interaction managers */
  get lastObjectRendered() {
    return this.objectRenderer.lastObjectRendered;
  }
  /** Flag if we are rendering to the screen vs renderTexture */
  get renderingToScreen() {
    return this.objectRenderer.renderingToScreen;
  }
  /** When logging Pixi to the console, this is the name we will show */
  get rendererLogId() {
    return `WebGL ${this.context.webGLVersion}`;
  }
  /**
   * This sets weather the screen is totally cleared between each frame withthe background color and alpha
   * @deprecated since 7.0.0
   */
  get clearBeforeRender() {
    return un("7.0.0", "renderer.clearBeforeRender has been deprecated, please use renderer.background.clearBeforeRender instead."), this.background.clearBeforeRender;
  }
  /**
   * Pass-thru setting for the canvas' context `alpha` property. This is typically
   * not something you need to fiddle with. If you want transparency, use `backgroundAlpha`.
   * @deprecated since 7.0.0
   * @member {boolean}
   */
  get useContextAlpha() {
    return un("7.0.0", "renderer.useContextAlpha has been deprecated, please use renderer.context.premultipliedAlpha instead."), this.context.useContextAlpha;
  }
  /**
   * readonly drawing buffer preservation
   * we can only know this if Pixi created the context
   * @deprecated since 7.0.0
   */
  get preserveDrawingBuffer() {
    return un("7.0.0", "renderer.preserveDrawingBuffer has been deprecated, we cannot truly know this unless pixi created the context"), this.context.preserveDrawingBuffer;
  }
  /**
   * The background color to fill if not transparent
   * @member {number}
   * @deprecated since 7.0.0
   */
  get backgroundColor() {
    return un("7.0.0", "renderer.backgroundColor has been deprecated, use renderer.background.color instead."), this.background.color;
  }
  set backgroundColor(e) {
    un("7.0.0", "renderer.backgroundColor has been deprecated, use renderer.background.color instead."), this.background.color = e;
  }
  /**
   * The background color alpha. Setting this to 0 will make the canvas transparent.
   * @member {number}
   * @deprecated since 7.0.0
   */
  get backgroundAlpha() {
    return un("7.0.0", "renderer.backgroundAlpha has been deprecated, use renderer.background.alpha instead."), this.background.alpha;
  }
  /**
   * @deprecated since 7.0.0
   */
  set backgroundAlpha(e) {
    un("7.0.0", "renderer.backgroundAlpha has been deprecated, use renderer.background.alpha instead."), this.background.alpha = e;
  }
  /**
   * @deprecated since 7.0.0
   */
  get powerPreference() {
    return un("7.0.0", "renderer.powerPreference has been deprecated, we can only know this if pixi creates the context"), this.context.powerPreference;
  }
  /**
   * Useful function that returns a texture of the display object that can then be used to create sprites
   * This can be quite useful if your displayObject is complicated and needs to be reused multiple times.
   * @param displayObject - The displayObject the object will be generated from.
   * @param {IGenerateTextureOptions} options - Generate texture options.
   * @param {PIXI.Rectangle} options.region - The region of the displayObject, that shall be rendered,
   *        if no region is specified, defaults to the local bounds of the displayObject.
   * @param {number} [options.resolution] - If not given, the renderer's resolution is used.
   * @param {PIXI.MSAA_QUALITY} [options.multisample] - If not given, the renderer's multisample is used.
   * @returns A texture of the graphics object.
   */
  generateTexture(e, n) {
    return this.textureGenerator.generateTexture(e, n);
  }
};
o0.extension = {
  type: rt.Renderer,
  priority: 1
}, /**
* Collection of installed plugins. These are included by default in PIXI, but can be excluded
* by creating a custom build. Consult the README for more information about creating custom
* builds and excluding plugins.
* @private
*/
o0.__plugins = {}, /**
* The collection of installed systems.
* @private
*/
o0.__systems = {};
let AS = o0;
dt.handleByMap(rt.RendererPlugin, AS.__plugins);
dt.handleByMap(rt.RendererSystem, AS.__systems);
dt.add(AS);
class VB extends ym {
  /**
   * @param length
   * @param options - Options to for Resource constructor
   * @param {number} [options.width] - Width of the resource
   * @param {number} [options.height] - Height of the resource
   */
  constructor(e, n) {
    const { width: r, height: o } = n || {};
    super(r, o), this.items = [], this.itemDirtyIds = [];
    for (let s = 0; s < e; s++) {
      const i = new qt();
      this.items.push(i), this.itemDirtyIds.push(-2);
    }
    this.length = e, this._load = null, this.baseTexture = null;
  }
  /**
   * Used from ArrayResource and CubeResource constructors.
   * @param resources - Can be resources, image elements, canvas, etc. ,
   *  length should be same as constructor length
   * @param options - Detect options for resources
   */
  initFromArray(e, n) {
    for (let r = 0; r < this.length; r++)
      e[r] && (e[r].castToBaseTexture ? this.addBaseTextureAt(e[r].castToBaseTexture(), r) : e[r] instanceof ym ? this.addResourceAt(e[r], r) : this.addResourceAt(iB(e[r], n), r));
  }
  /** Destroy this BaseImageResource. */
  dispose() {
    for (let e = 0, n = this.length; e < n; e++)
      this.items[e].destroy();
    this.items = null, this.itemDirtyIds = null, this._load = null;
  }
  /**
   * Set a resource by ID
   * @param resource
   * @param index - Zero-based index of resource to set
   * @returns - Instance for chaining
   */
  addResourceAt(e, n) {
    if (!this.items[n])
      throw new Error(`Index ${n} is out of bounds`);
    return e.valid && !this.valid && this.resize(e.width, e.height), this.items[n].setResource(e), this;
  }
  /**
   * Set the parent base texture.
   * @param baseTexture
   */
  bind(e) {
    if (this.baseTexture !== null)
      throw new Error("Only one base texture per TextureArray is allowed");
    super.bind(e);
    for (let n = 0; n < this.length; n++)
      this.items[n].parentTextureArray = e, this.items[n].on("update", e.update, e);
  }
  /**
   * Unset the parent base texture.
   * @param baseTexture
   */
  unbind(e) {
    super.unbind(e);
    for (let n = 0; n < this.length; n++)
      this.items[n].parentTextureArray = null, this.items[n].off("update", e.update, e);
  }
  /**
   * Load all the resources simultaneously
   * @returns - When load is resolved
   */
  load() {
    if (this._load)
      return this._load;
    const e = this.items.map((n) => n.resource).filter((n) => n).map((n) => n.load());
    return this._load = Promise.all(e).then(
      () => {
        const { realWidth: n, realHeight: r } = this.items[0];
        return this.resize(n, r), this.update(), Promise.resolve(this);
      }
    ), this._load;
  }
}
class zbe extends VB {
  /**
   * @param source - Number of items in array or the collection
   *        of image URLs to use. Can also be resources, image elements, canvas, etc.
   * @param options - Options to apply to {@link PIXI.autoDetectResource}
   * @param {number} [options.width] - Width of the resource
   * @param {number} [options.height] - Height of the resource
   */
  constructor(e, n) {
    const { width: r, height: o } = n || {};
    let s, i;
    Array.isArray(e) ? (s = e, i = e.length) : i = e, super(i, { width: r, height: o }), s && this.initFromArray(s, n);
  }
  /**
   * Set a baseTexture by ID,
   * ArrayResource just takes resource from it, nothing more
   * @param baseTexture
   * @param index - Zero-based index of resource to set
   * @returns - Instance for chaining
   */
  addBaseTextureAt(e, n) {
    if (e.resource)
      this.addResourceAt(e.resource, n);
    else
      throw new Error("ArrayResource does not support RenderTexture");
    return this;
  }
  /**
   * Add binding
   * @param baseTexture
   */
  bind(e) {
    super.bind(e), e.target = Gd.TEXTURE_2D_ARRAY;
  }
  /**
   * Upload the resources to the GPU.
   * @param renderer
   * @param texture
   * @param glTexture
   * @returns - whether texture was uploaded
   */
  upload(e, n, r) {
    const { length: o, itemDirtyIds: s, items: i } = this, { gl: u } = e;
    r.dirtyId < 0 && u.texImage3D(
      u.TEXTURE_2D_ARRAY,
      0,
      r.internalFormat,
      this._width,
      this._height,
      o,
      0,
      n.format,
      r.type,
      null
    );
    for (let l = 0; l < o; l++) {
      const a = i[l];
      s[l] < a.dirtyId && (s[l] = a.dirtyId, a.valid && u.texSubImage3D(
        u.TEXTURE_2D_ARRAY,
        0,
        0,
        // xoffset
        0,
        // yoffset
        l,
        // zoffset
        a.resource.width,
        a.resource.height,
        1,
        n.format,
        r.type,
        a.resource.source
      ));
    }
    return !0;
  }
}
class qbe extends gc {
  /**
   * @param source - Canvas element to use
   */
  // eslint-disable-next-line @typescript-eslint/no-useless-constructor
  constructor(e) {
    super(e);
  }
  /**
   * Used to auto-detect the type of resource.
   * @param {*} source - The source object
   * @returns {boolean} `true` if source is HTMLCanvasElement or OffscreenCanvas
   */
  static test(e) {
    const { OffscreenCanvas: n } = globalThis;
    return n && e instanceof n ? !0 : globalThis.HTMLCanvasElement && e instanceof HTMLCanvasElement;
  }
}
const HB = class Xf extends VB {
  /**
   * @param {Array<string|PIXI.Resource>} [source] - Collection of URLs or resources
   *        to use as the sides of the cube.
   * @param options - ImageResource options
   * @param {number} [options.width] - Width of resource
   * @param {number} [options.height] - Height of resource
   * @param {number} [options.autoLoad=true] - Whether to auto-load resources
   * @param {number} [options.linkBaseTexture=true] - In case BaseTextures are supplied,
   *   whether to copy them or use
   */
  constructor(e, n) {
    const { width: r, height: o, autoLoad: s, linkBaseTexture: i } = n || {};
    if (e && e.length !== Xf.SIDES)
      throw new Error(`Invalid length. Got ${e.length}, expected 6`);
    super(6, { width: r, height: o });
    for (let u = 0; u < Xf.SIDES; u++)
      this.items[u].target = Gd.TEXTURE_CUBE_MAP_POSITIVE_X + u;
    this.linkBaseTexture = i !== !1, e && this.initFromArray(e, n), s !== !1 && this.load();
  }
  /**
   * Add binding.
   * @param baseTexture - parent base texture
   */
  bind(e) {
    super.bind(e), e.target = Gd.TEXTURE_CUBE_MAP;
  }
  addBaseTextureAt(e, n, r) {
    if (r === void 0 && (r = this.linkBaseTexture), !this.items[n])
      throw new Error(`Index ${n} is out of bounds`);
    if (!this.linkBaseTexture || e.parentTextureArray || Object.keys(e._glTextures).length > 0)
      if (e.resource)
        this.addResourceAt(e.resource, n);
      else
        throw new Error("CubeResource does not support copying of renderTexture.");
    else
      e.target = Gd.TEXTURE_CUBE_MAP_POSITIVE_X + n, e.parentTextureArray = this.baseTexture, this.items[n] = e;
    return e.valid && !this.valid && this.resize(e.realWidth, e.realHeight), this.items[n] = e, this;
  }
  /**
   * Upload the resource
   * @param renderer
   * @param _baseTexture
   * @param glTexture
   * @returns {boolean} true is success
   */
  upload(e, n, r) {
    const o = this.itemDirtyIds;
    for (let s = 0; s < Xf.SIDES; s++) {
      const i = this.items[s];
      (o[s] < i.dirtyId || r.dirtyId < n.dirtyId) && (i.valid && i.resource ? (i.resource.upload(e, i, r), o[s] = i.dirtyId) : o[s] < -1 && (e.gl.texImage2D(
        i.target,
        0,
        r.internalFormat,
        n.realWidth,
        n.realHeight,
        0,
        n.format,
        r.type,
        null
      ), o[s] = -1));
    }
    return !0;
  }
  /**
   * Used to auto-detect the type of resource.
   * @param {*} source - The source object
   * @returns {boolean} `true` if source is an array of 6 elements
   */
  static test(e) {
    return Array.isArray(e) && e.length === Xf.SIDES;
  }
};
HB.SIDES = 6;
let Gbe = HB;
class Ld extends gc {
  /**
   * @param source - ImageBitmap or URL to use.
   * @param options - Options to use.
   */
  constructor(e, n) {
    n = n || {};
    let r, o, s;
    typeof e == "string" ? (r = Ld.EMPTY, o = e, s = !0) : (r = e, o = null, s = !1), super(r), this.url = o, this.crossOrigin = n.crossOrigin ?? !0, this.alphaMode = typeof n.alphaMode == "number" ? n.alphaMode : null, this.ownsImageBitmap = n.ownsImageBitmap ?? s, this._load = null, n.autoLoad !== !1 && this.load();
  }
  load() {
    return this._load ? this._load : (this._load = new Promise(async (e, n) => {
      if (this.url === null) {
        e(this);
        return;
      }
      try {
        const r = await at.ADAPTER.fetch(this.url, {
          mode: this.crossOrigin ? "cors" : "no-cors"
        });
        if (this.destroyed)
          return;
        const o = await r.blob();
        if (this.destroyed)
          return;
        const s = await createImageBitmap(o, {
          premultiplyAlpha: this.alphaMode === null || this.alphaMode === gs.UNPACK ? "premultiply" : "none"
        });
        if (this.destroyed) {
          s.close();
          return;
        }
        this.source = s, this.update(), e(this);
      } catch (r) {
        if (this.destroyed)
          return;
        n(r), this.onError.emit(r);
      }
    }), this._load);
  }
  /**
   * Upload the image bitmap resource to GPU.
   * @param renderer - Renderer to upload to
   * @param baseTexture - BaseTexture for this resource
   * @param glTexture - GLTexture to use
   * @returns {boolean} true is success
   */
  upload(e, n, r) {
    return this.source instanceof ImageBitmap ? (typeof this.alphaMode == "number" && (n.alphaMode = this.alphaMode), super.upload(e, n, r)) : (this.load(), !1);
  }
  /** Destroys this resource. */
  dispose() {
    this.ownsImageBitmap && this.source instanceof ImageBitmap && this.source.close(), super.dispose(), this._load = null;
  }
  /**
   * Used to auto-detect the type of resource.
   * @param {*} source - The source object
   * @returns {boolean} `true` if current environment support ImageBitmap, and source is string or ImageBitmap
   */
  static test(e) {
    return !!globalThis.createImageBitmap && typeof ImageBitmap < "u" && (typeof e == "string" || e instanceof ImageBitmap);
  }
  /**
   * ImageBitmap cannot be created synchronously, so a empty placeholder canvas is needed when loading from URLs.
   * Only for internal usage.
   * @returns The cached placeholder canvas.
   */
  static get EMPTY() {
    return Ld._EMPTY = Ld._EMPTY ?? at.ADAPTER.createCanvas(0, 0), Ld._EMPTY;
  }
}
const hT = class s0 extends gc {
  /**
   * @param sourceBase64 - Base64 encoded SVG element or URL for SVG file.
   * @param {object} [options] - Options to use
   * @param {number} [options.scale=1] - Scale to apply to SVG. Overridden by...
   * @param {number} [options.width] - Rasterize SVG this wide. Aspect ratio preserved if height not specified.
   * @param {number} [options.height] - Rasterize SVG this high. Aspect ratio preserved if width not specified.
   * @param {boolean} [options.autoLoad=true] - Start loading right away.
   */
  constructor(e, n) {
    n = n || {}, super(at.ADAPTER.createCanvas()), this._width = 0, this._height = 0, this.svg = e, this.scale = n.scale || 1, this._overrideWidth = n.width, this._overrideHeight = n.height, this._resolve = null, this._crossorigin = n.crossorigin, this._load = null, n.autoLoad !== !1 && this.load();
  }
  load() {
    return this._load ? this._load : (this._load = new Promise((e) => {
      if (this._resolve = () => {
        this.update(), e(this);
      }, s0.SVG_XML.test(this.svg.trim())) {
        if (!btoa)
          throw new Error("Your browser doesn't support base64 conversions.");
        this.svg = `data:image/svg+xml;base64,${btoa(unescape(encodeURIComponent(this.svg)))}`;
      }
      this._loadSvg();
    }), this._load);
  }
  /** Loads an SVG image from `imageUrl` or `data URL`. */
  _loadSvg() {
    const e = new Image();
    gc.crossOrigin(e, this.svg, this._crossorigin), e.src = this.svg, e.onerror = (n) => {
      this._resolve && (e.onerror = null, this.onError.emit(n));
    }, e.onload = () => {
      if (!this._resolve)
        return;
      const n = e.width, r = e.height;
      if (!n || !r)
        throw new Error("The SVG image must have width and height defined (in pixels), canvas API needs them.");
      let o = n * this.scale, s = r * this.scale;
      (this._overrideWidth || this._overrideHeight) && (o = this._overrideWidth || this._overrideHeight / r * n, s = this._overrideHeight || this._overrideWidth / n * r), o = Math.round(o), s = Math.round(s);
      const i = this.source;
      i.width = o, i.height = s, i._pixiId = `canvas_${Up()}`, i.getContext("2d").drawImage(e, 0, 0, n, r, 0, 0, o, s), this._resolve(), this._resolve = null;
    };
  }
  /**
   * Get size from an svg string using a regular expression.
   * @param svgString - a serialized svg element
   * @returns - image extension
   */
  static getSize(e) {
    const n = s0.SVG_SIZE.exec(e), r = {};
    return n && (r[n[1]] = Math.round(parseFloat(n[3])), r[n[5]] = Math.round(parseFloat(n[7]))), r;
  }
  /** Destroys this texture. */
  dispose() {
    super.dispose(), this._resolve = null, this._crossorigin = null;
  }
  /**
   * Used to auto-detect the type of resource.
   * @param {*} source - The source object
   * @param {string} extension - The extension of source, if set
   * @returns {boolean} - If the source is a SVG source or data file
   */
  static test(e, n) {
    return n === "svg" || typeof e == "string" && e.startsWith("data:image/svg+xml") || typeof e == "string" && s0.SVG_XML.test(e);
  }
  // eslint-disable-line max-len
};
hT.SVG_XML = /^(<\?xml[^?]+\?>)?\s*(<!--[^(-->)]*-->)?\s*\<svg/m, /**
* Regular expression for SVG size.
* @example &lt;svg width="100" height="100"&gt;&lt;/svg&gt;
* @readonly
*/
hT.SVG_SIZE = /<svg[^>]*(?:\s(width|height)=('|")(\d*(?:\.\d+)?)(?:px)?('|"))[^>]*(?:\s(width|height)=('|")(\d*(?:\.\d+)?)(?:px)?('|"))[^>]*>/i;
let fT = hT;
const mT = class yT extends gc {
  /**
   * @param {HTMLVideoElement|object|string|Array<string|object>} source - Video element to use.
   * @param {object} [options] - Options to use
   * @param {boolean} [options.autoLoad=true] - Start loading the video immediately
   * @param {boolean} [options.autoPlay=true] - Start playing video immediately
   * @param {number} [options.updateFPS=0] - How many times a second to update the texture from the video.
   * Leave at 0 to update at every render.
   * @param {boolean} [options.crossorigin=true] - Load image using cross origin
   * @param {boolean} [options.loop=false] - Loops the video
   * @param {boolean} [options.muted=false] - Mutes the video audio, useful for autoplay
   * @param {boolean} [options.playsinline=true] - Prevents opening the video on mobile devices
   */
  constructor(e, n) {
    if (n = n || {}, !(e instanceof HTMLVideoElement)) {
      const r = document.createElement("video");
      n.autoLoad !== !1 && r.setAttribute("preload", "auto"), n.playsinline !== !1 && (r.setAttribute("webkit-playsinline", ""), r.setAttribute("playsinline", "")), n.muted === !0 && (r.setAttribute("muted", ""), r.muted = !0), n.loop === !0 && r.setAttribute("loop", ""), n.autoPlay !== !1 && r.setAttribute("autoplay", ""), typeof e == "string" && (e = [e]);
      const o = e[0].src || e[0];
      gc.crossOrigin(r, o, n.crossorigin);
      for (let s = 0; s < e.length; ++s) {
        const i = document.createElement("source");
        let { src: u, mime: l } = e[s];
        if (u = u || e[s], u.startsWith("data:"))
          l = u.slice(5, u.indexOf(";"));
        else if (!u.startsWith("blob:")) {
          const a = u.split("?").shift().toLowerCase(), c = a.slice(a.lastIndexOf(".") + 1);
          l = l || yT.MIME_TYPES[c] || `video/${c}`;
        }
        i.src = u, l && (i.type = l), r.appendChild(i);
      }
      e = r;
    }
    super(e), this.noSubImage = !0, this._autoUpdate = !0, this._isConnectedToTicker = !1, this._updateFPS = n.updateFPS || 0, this._msToNextUpdate = 0, this.autoPlay = n.autoPlay !== !1, this._videoFrameRequestCallback = this._videoFrameRequestCallback.bind(this), this._videoFrameRequestCallbackHandle = null, this._load = null, this._resolve = null, this._reject = null, this._onCanPlay = this._onCanPlay.bind(this), this._onError = this._onError.bind(this), this._onPlayStart = this._onPlayStart.bind(this), this._onPlayStop = this._onPlayStop.bind(this), this._onSeeked = this._onSeeked.bind(this), n.autoLoad !== !1 && this.load();
  }
  /**
   * Trigger updating of the texture.
   * @param _deltaTime - time delta since last tick
   */
  update(e = 0) {
    if (!this.destroyed) {
      if (this._updateFPS) {
        const n = es.shared.elapsedMS * this.source.playbackRate;
        this._msToNextUpdate = Math.floor(this._msToNextUpdate - n);
      }
      (!this._updateFPS || this._msToNextUpdate <= 0) && (super.update(
        /* deltaTime*/
      ), this._msToNextUpdate = this._updateFPS ? Math.floor(1e3 / this._updateFPS) : 0);
    }
  }
  _videoFrameRequestCallback() {
    this.update(), this.destroyed ? this._videoFrameRequestCallbackHandle = null : this._videoFrameRequestCallbackHandle = this.source.requestVideoFrameCallback(
      this._videoFrameRequestCallback
    );
  }
  /**
   * Start preloading the video resource.
   * @returns {Promise<void>} Handle the validate event
   */
  load() {
    if (this._load)
      return this._load;
    const e = this.source;
    return (e.readyState === e.HAVE_ENOUGH_DATA || e.readyState === e.HAVE_FUTURE_DATA) && e.width && e.height && (e.complete = !0), e.addEventListener("play", this._onPlayStart), e.addEventListener("pause", this._onPlayStop), e.addEventListener("seeked", this._onSeeked), this._isSourceReady() ? this._onCanPlay() : (e.addEventListener("canplay", this._onCanPlay), e.addEventListener("canplaythrough", this._onCanPlay), e.addEventListener("error", this._onError, !0)), this._load = new Promise((n, r) => {
      this.valid ? n(this) : (this._resolve = n, this._reject = r, e.load());
    }), this._load;
  }
  /**
   * Handle video error events.
   * @param event
   */
  _onError(e) {
    this.source.removeEventListener("error", this._onError, !0), this.onError.emit(e), this._reject && (this._reject(e), this._reject = null, this._resolve = null);
  }
  /**
   * Returns true if the underlying source is playing.
   * @returns - True if playing.
   */
  _isSourcePlaying() {
    const e = this.source;
    return !e.paused && !e.ended;
  }
  /**
   * Returns true if the underlying source is ready for playing.
   * @returns - True if ready.
   */
  _isSourceReady() {
    return this.source.readyState > 2;
  }
  /** Runs the update loop when the video is ready to play. */
  _onPlayStart() {
    this.valid || this._onCanPlay(), this._configureAutoUpdate();
  }
  /** Fired when a pause event is triggered, stops the update loop. */
  _onPlayStop() {
    this._configureAutoUpdate();
  }
  /** Fired when the video is completed seeking to the current playback position. */
  _onSeeked() {
    this._autoUpdate && !this._isSourcePlaying() && (this._msToNextUpdate = 0, this.update(), this._msToNextUpdate = 0);
  }
  /** Fired when the video is loaded and ready to play. */
  _onCanPlay() {
    const e = this.source;
    e.removeEventListener("canplay", this._onCanPlay), e.removeEventListener("canplaythrough", this._onCanPlay);
    const n = this.valid;
    this._msToNextUpdate = 0, this.update(), this._msToNextUpdate = 0, !n && this._resolve && (this._resolve(this), this._resolve = null, this._reject = null), this._isSourcePlaying() ? this._onPlayStart() : this.autoPlay && e.play();
  }
  /** Destroys this texture. */
  dispose() {
    this._configureAutoUpdate();
    const e = this.source;
    e && (e.removeEventListener("play", this._onPlayStart), e.removeEventListener("pause", this._onPlayStop), e.removeEventListener("seeked", this._onSeeked), e.removeEventListener("canplay", this._onCanPlay), e.removeEventListener("canplaythrough", this._onCanPlay), e.removeEventListener("error", this._onError, !0), e.pause(), e.src = "", e.load()), super.dispose();
  }
  /** Should the base texture automatically update itself, set to true by default. */
  get autoUpdate() {
    return this._autoUpdate;
  }
  set autoUpdate(e) {
    e !== this._autoUpdate && (this._autoUpdate = e, this._configureAutoUpdate());
  }
  /**
   * How many times a second to update the texture from the video. Leave at 0 to update at every render.
   * A lower fps can help performance, as updating the texture at 60fps on a 30ps video may not be efficient.
   */
  get updateFPS() {
    return this._updateFPS;
  }
  set updateFPS(e) {
    e !== this._updateFPS && (this._updateFPS = e, this._configureAutoUpdate());
  }
  _configureAutoUpdate() {
    this._autoUpdate && this._isSourcePlaying() ? !this._updateFPS && this.source.requestVideoFrameCallback ? (this._isConnectedToTicker && (es.shared.remove(this.update, this), this._isConnectedToTicker = !1, this._msToNextUpdate = 0), this._videoFrameRequestCallbackHandle === null && (this._videoFrameRequestCallbackHandle = this.source.requestVideoFrameCallback(
      this._videoFrameRequestCallback
    ))) : (this._videoFrameRequestCallbackHandle !== null && (this.source.cancelVideoFrameCallback(this._videoFrameRequestCallbackHandle), this._videoFrameRequestCallbackHandle = null), this._isConnectedToTicker || (es.shared.add(this.update, this), this._isConnectedToTicker = !0, this._msToNextUpdate = 0)) : (this._videoFrameRequestCallbackHandle !== null && (this.source.cancelVideoFrameCallback(this._videoFrameRequestCallbackHandle), this._videoFrameRequestCallbackHandle = null), this._isConnectedToTicker && (es.shared.remove(this.update, this), this._isConnectedToTicker = !1, this._msToNextUpdate = 0));
  }
  /**
   * Used to auto-detect the type of resource.
   * @param {*} source - The source object
   * @param {string} extension - The extension of source, if set
   * @returns {boolean} `true` if video source
   */
  static test(e, n) {
    return globalThis.HTMLVideoElement && e instanceof HTMLVideoElement || yT.TYPES.includes(n);
  }
};
mT.TYPES = ["mp4", "m4v", "webm", "ogg", "ogv", "h264", "avi", "mov"], /**
* Map of video MIME types that can't be directly derived from file extensions.
* @readonly
*/
mT.MIME_TYPES = {
  ogv: "video/ogg",
  mov: "video/quicktime",
  m4v: "video/mp4"
};
let jB = mT;
tT.push(
  Ld,
  yB,
  qbe,
  jB,
  fT,
  X_,
  Gbe,
  zbe
);
class cv {
  constructor() {
    this.minX = 1 / 0, this.minY = 1 / 0, this.maxX = -1 / 0, this.maxY = -1 / 0, this.rect = null, this.updateID = -1;
  }
  /**
   * Checks if bounds are empty.
   * @returns - True if empty.
   */
  isEmpty() {
    return this.minX > this.maxX || this.minY > this.maxY;
  }
  /** Clears the bounds and resets. */
  clear() {
    this.minX = 1 / 0, this.minY = 1 / 0, this.maxX = -1 / 0, this.maxY = -1 / 0;
  }
  /**
   * Can return Rectangle.EMPTY constant, either construct new rectangle, either use your rectangle
   * It is not guaranteed that it will return tempRect
   * @param rect - Temporary object will be used if AABB is not empty
   * @returns - A rectangle of the bounds
   */
  getRectangle(e) {
    return this.minX > this.maxX || this.minY > this.maxY ? Pt.EMPTY : (e = e || new Pt(0, 0, 1, 1), e.x = this.minX, e.y = this.minY, e.width = this.maxX - this.minX, e.height = this.maxY - this.minY, e);
  }
  /**
   * This function should be inlined when its possible.
   * @param point - The point to add.
   */
  addPoint(e) {
    this.minX = Math.min(this.minX, e.x), this.maxX = Math.max(this.maxX, e.x), this.minY = Math.min(this.minY, e.y), this.maxY = Math.max(this.maxY, e.y);
  }
  /**
   * Adds a point, after transformed. This should be inlined when its possible.
   * @param matrix
   * @param point
   */
  addPointMatrix(e, n) {
    const { a: r, b: o, c: s, d: i, tx: u, ty: l } = e, a = r * n.x + s * n.y + u, c = o * n.x + i * n.y + l;
    this.minX = Math.min(this.minX, a), this.maxX = Math.max(this.maxX, a), this.minY = Math.min(this.minY, c), this.maxY = Math.max(this.maxY, c);
  }
  /**
   * Adds a quad, not transformed
   * @param vertices - The verts to add.
   */
  addQuad(e) {
    let n = this.minX, r = this.minY, o = this.maxX, s = this.maxY, i = e[0], u = e[1];
    n = i < n ? i : n, r = u < r ? u : r, o = i > o ? i : o, s = u > s ? u : s, i = e[2], u = e[3], n = i < n ? i : n, r = u < r ? u : r, o = i > o ? i : o, s = u > s ? u : s, i = e[4], u = e[5], n = i < n ? i : n, r = u < r ? u : r, o = i > o ? i : o, s = u > s ? u : s, i = e[6], u = e[7], n = i < n ? i : n, r = u < r ? u : r, o = i > o ? i : o, s = u > s ? u : s, this.minX = n, this.minY = r, this.maxX = o, this.maxY = s;
  }
  /**
   * Adds sprite frame, transformed.
   * @param transform - transform to apply
   * @param x0 - left X of frame
   * @param y0 - top Y of frame
   * @param x1 - right X of frame
   * @param y1 - bottom Y of frame
   */
  addFrame(e, n, r, o, s) {
    this.addFrameMatrix(e.worldTransform, n, r, o, s);
  }
  /**
   * Adds sprite frame, multiplied by matrix
   * @param matrix - matrix to apply
   * @param x0 - left X of frame
   * @param y0 - top Y of frame
   * @param x1 - right X of frame
   * @param y1 - bottom Y of frame
   */
  addFrameMatrix(e, n, r, o, s) {
    const i = e.a, u = e.b, l = e.c, a = e.d, c = e.tx, p = e.ty;
    let d = this.minX, h = this.minY, m = this.maxX, g = this.maxY, _ = i * n + l * r + c, b = u * n + a * r + p;
    d = _ < d ? _ : d, h = b < h ? b : h, m = _ > m ? _ : m, g = b > g ? b : g, _ = i * o + l * r + c, b = u * o + a * r + p, d = _ < d ? _ : d, h = b < h ? b : h, m = _ > m ? _ : m, g = b > g ? b : g, _ = i * n + l * s + c, b = u * n + a * s + p, d = _ < d ? _ : d, h = b < h ? b : h, m = _ > m ? _ : m, g = b > g ? b : g, _ = i * o + l * s + c, b = u * o + a * s + p, d = _ < d ? _ : d, h = b < h ? b : h, m = _ > m ? _ : m, g = b > g ? b : g, this.minX = d, this.minY = h, this.maxX = m, this.maxY = g;
  }
  /**
   * Adds screen vertices from array
   * @param vertexData - calculated vertices
   * @param beginOffset - begin offset
   * @param endOffset - end offset, excluded
   */
  addVertexData(e, n, r) {
    let o = this.minX, s = this.minY, i = this.maxX, u = this.maxY;
    for (let l = n; l < r; l += 2) {
      const a = e[l], c = e[l + 1];
      o = a < o ? a : o, s = c < s ? c : s, i = a > i ? a : i, u = c > u ? c : u;
    }
    this.minX = o, this.minY = s, this.maxX = i, this.maxY = u;
  }
  /**
   * Add an array of mesh vertices
   * @param transform - mesh transform
   * @param vertices - mesh coordinates in array
   * @param beginOffset - begin offset
   * @param endOffset - end offset, excluded
   */
  addVertices(e, n, r, o) {
    this.addVerticesMatrix(e.worldTransform, n, r, o);
  }
  /**
   * Add an array of mesh vertices.
   * @param matrix - mesh matrix
   * @param vertices - mesh coordinates in array
   * @param beginOffset - begin offset
   * @param endOffset - end offset, excluded
   * @param padX - x padding
   * @param padY - y padding
   */
  addVerticesMatrix(e, n, r, o, s = 0, i = s) {
    const u = e.a, l = e.b, a = e.c, c = e.d, p = e.tx, d = e.ty;
    let h = this.minX, m = this.minY, g = this.maxX, _ = this.maxY;
    for (let b = r; b < o; b += 2) {
      const x = n[b], S = n[b + 1], E = u * x + a * S + p, A = c * S + l * x + d;
      h = Math.min(h, E - s), g = Math.max(g, E + s), m = Math.min(m, A - i), _ = Math.max(_, A + i);
    }
    this.minX = h, this.minY = m, this.maxX = g, this.maxY = _;
  }
  /**
   * Adds other {@link PIXI.Bounds}.
   * @param bounds - The Bounds to be added
   */
  addBounds(e) {
    const n = this.minX, r = this.minY, o = this.maxX, s = this.maxY;
    this.minX = e.minX < n ? e.minX : n, this.minY = e.minY < r ? e.minY : r, this.maxX = e.maxX > o ? e.maxX : o, this.maxY = e.maxY > s ? e.maxY : s;
  }
  /**
   * Adds other Bounds, masked with Bounds.
   * @param bounds - The Bounds to be added.
   * @param mask - TODO
   */
  addBoundsMask(e, n) {
    const r = e.minX > n.minX ? e.minX : n.minX, o = e.minY > n.minY ? e.minY : n.minY, s = e.maxX < n.maxX ? e.maxX : n.maxX, i = e.maxY < n.maxY ? e.maxY : n.maxY;
    if (r <= s && o <= i) {
      const u = this.minX, l = this.minY, a = this.maxX, c = this.maxY;
      this.minX = r < u ? r : u, this.minY = o < l ? o : l, this.maxX = s > a ? s : a, this.maxY = i > c ? i : c;
    }
  }
  /**
   * Adds other Bounds, multiplied by matrix. Bounds shouldn't be empty.
   * @param bounds - other bounds
   * @param matrix - multiplicator
   */
  addBoundsMatrix(e, n) {
    this.addFrameMatrix(n, e.minX, e.minY, e.maxX, e.maxY);
  }
  /**
   * Adds other Bounds, masked with Rectangle.
   * @param bounds - TODO
   * @param area - TODO
   */
  addBoundsArea(e, n) {
    const r = e.minX > n.x ? e.minX : n.x, o = e.minY > n.y ? e.minY : n.y, s = e.maxX < n.x + n.width ? e.maxX : n.x + n.width, i = e.maxY < n.y + n.height ? e.maxY : n.y + n.height;
    if (r <= s && o <= i) {
      const u = this.minX, l = this.minY, a = this.maxX, c = this.maxY;
      this.minX = r < u ? r : u, this.minY = o < l ? o : l, this.maxX = s > a ? s : a, this.maxY = i > c ? i : c;
    }
  }
  /**
   * Pads bounds object, making it grow in all directions.
   * If paddingY is omitted, both paddingX and paddingY will be set to paddingX.
   * @param paddingX - The horizontal padding amount.
   * @param paddingY - The vertical padding amount.
   */
  pad(e = 0, n = e) {
    this.isEmpty() || (this.minX -= e, this.maxX += e, this.minY -= n, this.maxY += n);
  }
  /**
   * Adds padded frame. (x0, y0) should be strictly less than (x1, y1)
   * @param x0 - left X of frame
   * @param y0 - top Y of frame
   * @param x1 - right X of frame
   * @param y1 - bottom Y of frame
   * @param padX - padding X
   * @param padY - padding Y
   */
  addFramePad(e, n, r, o, s, i) {
    e -= s, n -= i, r += s, o += i, this.minX = this.minX < e ? this.minX : e, this.maxX = this.maxX > r ? this.maxX : r, this.minY = this.minY < n ? this.minY : n, this.maxY = this.maxY > o ? this.maxY : o;
  }
}
class vr extends uy {
  constructor() {
    super(), this.tempDisplayObjectParent = null, this.transform = new SS(), this.alpha = 1, this.visible = !0, this.renderable = !0, this.cullable = !1, this.cullArea = null, this.parent = null, this.worldAlpha = 1, this._lastSortedIndex = 0, this._zIndex = 0, this.filterArea = null, this.filters = null, this._enabledFilters = null, this._bounds = new cv(), this._localBounds = null, this._boundsID = 0, this._boundsRect = null, this._localBoundsRect = null, this._mask = null, this._maskRefCount = 0, this._destroyed = !1, this.isSprite = !1, this.isMask = !1;
  }
  /**
   * Mixes all enumerable properties and methods from a source object to DisplayObject.
   * @param source - The source of properties and methods to mix in.
   */
  static mixin(e) {
    const n = Object.keys(e);
    for (let r = 0; r < n.length; ++r) {
      const o = n[r];
      Object.defineProperty(
        vr.prototype,
        o,
        Object.getOwnPropertyDescriptor(e, o)
      );
    }
  }
  /**
   * Fired when this DisplayObject is added to a Container.
   * @instance
   * @event added
   * @param {PIXI.Container} container - The container added to.
   */
  /**
   * Fired when this DisplayObject is removed from a Container.
   * @instance
   * @event removed
   * @param {PIXI.Container} container - The container removed from.
   */
  /**
   * Fired when this DisplayObject is destroyed. This event is emitted once
   * destroy is finished.
   * @instance
   * @event destroyed
   */
  /** Readonly flag for destroyed display objects. */
  get destroyed() {
    return this._destroyed;
  }
  /** Recursively updates transform of all objects from the root to this one internal function for toLocal() */
  _recursivePostUpdateTransform() {
    this.parent ? (this.parent._recursivePostUpdateTransform(), this.transform.updateTransform(this.parent.transform)) : this.transform.updateTransform(this._tempDisplayObjectParent.transform);
  }
  /** Updates the object transform for rendering. TODO - Optimization pass! */
  updateTransform() {
    this._boundsID++, this.transform.updateTransform(this.parent.transform), this.worldAlpha = this.alpha * this.parent.worldAlpha;
  }
  /**
   * Calculates and returns the (world) bounds of the display object as a [Rectangle]{@link PIXI.Rectangle}.
   *
   * This method is expensive on containers with a large subtree (like the stage). This is because the bounds
   * of a container depend on its children's bounds, which recursively causes all bounds in the subtree to
   * be recalculated. The upside, however, is that calling `getBounds` once on a container will indeed update
   * the bounds of all children (the whole subtree, in fact). This side effect should be exploited by using
   * `displayObject._bounds.getRectangle()` when traversing through all the bounds in a scene graph. Otherwise,
   * calling `getBounds` on each object in a subtree will cause the total cost to increase quadratically as
   * its height increases.
   *
   * The transforms of all objects in a container's **subtree** and of all **ancestors** are updated.
   * The world bounds of all display objects in a container's **subtree** will also be recalculated.
   *
   * The `_bounds` object stores the last calculation of the bounds. You can use to entirely skip bounds
   * calculation if needed.
   *
   * ```js
   * const lastCalculatedBounds = displayObject._bounds.getRectangle(optionalRect);
   * ```
   *
   * Do know that usage of `getLocalBounds` can corrupt the `_bounds` of children (the whole subtree, actually). This
   * is a known issue that has not been solved. See [getLocalBounds]{@link PIXI.DisplayObject#getLocalBounds} for more
   * details.
   *
   * `getBounds` should be called with `skipUpdate` equal to `true` in a render() call. This is because the transforms
   * are guaranteed to be update-to-date. In fact, recalculating inside a render() call may cause corruption in certain
   * cases.
   * @param skipUpdate - Setting to `true` will stop the transforms of the scene graph from
   *  being updated. This means the calculation returned MAY be out of date BUT will give you a
   *  nice performance boost.
   * @param rect - Optional rectangle to store the result of the bounds calculation.
   * @returns - The minimum axis-aligned rectangle in world space that fits around this object.
   */
  getBounds(e, n) {
    return e || (this.parent ? (this._recursivePostUpdateTransform(), this.updateTransform()) : (this.parent = this._tempDisplayObjectParent, this.updateTransform(), this.parent = null)), this._bounds.updateID !== this._boundsID && (this.calculateBounds(), this._bounds.updateID = this._boundsID), n || (this._boundsRect || (this._boundsRect = new Pt()), n = this._boundsRect), this._bounds.getRectangle(n);
  }
  /**
   * Retrieves the local bounds of the displayObject as a rectangle object.
   * @param rect - Optional rectangle to store the result of the bounds calculation.
   * @returns - The rectangular bounding area.
   */
  getLocalBounds(e) {
    e || (this._localBoundsRect || (this._localBoundsRect = new Pt()), e = this._localBoundsRect), this._localBounds || (this._localBounds = new cv());
    const n = this.transform, r = this.parent;
    this.parent = null, this._tempDisplayObjectParent.worldAlpha = r?.worldAlpha ?? 1, this.transform = this._tempDisplayObjectParent.transform;
    const o = this._bounds, s = this._boundsID;
    this._bounds = this._localBounds;
    const i = this.getBounds(!1, e);
    return this.parent = r, this.transform = n, this._bounds = o, this._bounds.updateID += this._boundsID - s, i;
  }
  /**
   * Calculates the global position of the display object.
   * @param position - The world origin to calculate from.
   * @param point - A Point object in which to store the value, optional
   *  (otherwise will create a new Point).
   * @param skipUpdate - Should we skip the update transform.
   * @returns - A point object representing the position of this object.
   */
  toGlobal(e, n, r = !1) {
    return r || (this._recursivePostUpdateTransform(), this.parent ? this.displayObjectUpdateTransform() : (this.parent = this._tempDisplayObjectParent, this.displayObjectUpdateTransform(), this.parent = null)), this.worldTransform.apply(e, n);
  }
  /**
   * Calculates the local position of the display object relative to another point.
   * @param position - The world origin to calculate from.
   * @param from - The DisplayObject to calculate the global position from.
   * @param point - A Point object in which to store the value, optional
   *  (otherwise will create a new Point).
   * @param skipUpdate - Should we skip the update transform
   * @returns - A point object representing the position of this object
   */
  toLocal(e, n, r, o) {
    return n && (e = n.toGlobal(e, r, o)), o || (this._recursivePostUpdateTransform(), this.parent ? this.displayObjectUpdateTransform() : (this.parent = this._tempDisplayObjectParent, this.displayObjectUpdateTransform(), this.parent = null)), this.worldTransform.applyInverse(e, r);
  }
  /**
   * Set the parent Container of this DisplayObject.
   * @param container - The Container to add this DisplayObject to.
   * @returns - The Container that this DisplayObject was added to.
   */
  setParent(e) {
    if (!e || !e.addChild)
      throw new Error("setParent: Argument must be a Container");
    return e.addChild(this), e;
  }
  /** Remove the DisplayObject from its parent Container. If the DisplayObject has no parent, do nothing. */
  removeFromParent() {
    this.parent?.removeChild(this);
  }
  /**
   * Convenience function to set the position, scale, skew and pivot at once.
   * @param x - The X position
   * @param y - The Y position
   * @param scaleX - The X scale value
   * @param scaleY - The Y scale value
   * @param rotation - The rotation
   * @param skewX - The X skew value
   * @param skewY - The Y skew value
   * @param pivotX - The X pivot value
   * @param pivotY - The Y pivot value
   * @returns - The DisplayObject instance
   */
  setTransform(e = 0, n = 0, r = 1, o = 1, s = 0, i = 0, u = 0, l = 0, a = 0) {
    return this.position.x = e, this.position.y = n, this.scale.x = r || 1, this.scale.y = o || 1, this.rotation = s, this.skew.x = i, this.skew.y = u, this.pivot.x = l, this.pivot.y = a, this;
  }
  /**
   * Base destroy method for generic display objects. This will automatically
   * remove the display object from its parent Container as well as remove
   * all current event listeners and internal references. Do not use a DisplayObject
   * after calling `destroy()`.
   * @param _options
   */
  destroy(e) {
    this.removeFromParent(), this._destroyed = !0, this.transform = null, this.parent = null, this._bounds = null, this.mask = null, this.cullArea = null, this.filters = null, this.filterArea = null, this.hitArea = null, this.eventMode = "auto", this.interactiveChildren = !1, this.emit("destroyed"), this.removeAllListeners();
  }
  /**
   * @protected
   * @member {PIXI.Container}
   */
  get _tempDisplayObjectParent() {
    return this.tempDisplayObjectParent === null && (this.tempDisplayObjectParent = new Ybe()), this.tempDisplayObjectParent;
  }
  /**
   * Used in Renderer, cacheAsBitmap and other places where you call an `updateTransform` on root.
   *
   * ```js
   * const cacheParent = elem.enableTempParent();
   * elem.updateTransform();
   * elem.disableTempParent(cacheParent);
   * ```
   * @returns - Current parent
   */
  enableTempParent() {
    const e = this.parent;
    return this.parent = this._tempDisplayObjectParent, e;
  }
  /**
   * Pair method for `enableTempParent`
   * @param cacheParent - Actual parent of element
   */
  disableTempParent(e) {
    this.parent = e;
  }
  /**
   * The position of the displayObject on the x axis relative to the local coordinates of the parent.
   * An alias to position.x
   */
  get x() {
    return this.position.x;
  }
  set x(e) {
    this.transform.position.x = e;
  }
  /**
   * The position of the displayObject on the y axis relative to the local coordinates of the parent.
   * An alias to position.y
   */
  get y() {
    return this.position.y;
  }
  set y(e) {
    this.transform.position.y = e;
  }
  /**
   * Current transform of the object based on world (parent) factors.
   * @readonly
   */
  get worldTransform() {
    return this.transform.worldTransform;
  }
  /**
   * Current transform of the object based on local factors: position, scale, other stuff.
   * @readonly
   */
  get localTransform() {
    return this.transform.localTransform;
  }
  /**
   * The coordinate of the object relative to the local coordinates of the parent.
   * @since 4.0.0
   */
  get position() {
    return this.transform.position;
  }
  set position(e) {
    this.transform.position.copyFrom(e);
  }
  /**
   * The scale factors of this object along the local coordinate axes.
   *
   * The default scale is (1, 1).
   * @since 4.0.0
   */
  get scale() {
    return this.transform.scale;
  }
  set scale(e) {
    this.transform.scale.copyFrom(e);
  }
  /**
   * The center of rotation, scaling, and skewing for this display object in its local space. The `position`
   * is the projection of `pivot` in the parent's local space.
   *
   * By default, the pivot is the origin (0, 0).
   * @since 4.0.0
   */
  get pivot() {
    return this.transform.pivot;
  }
  set pivot(e) {
    this.transform.pivot.copyFrom(e);
  }
  /**
   * The skew factor for the object in radians.
   * @since 4.0.0
   */
  get skew() {
    return this.transform.skew;
  }
  set skew(e) {
    this.transform.skew.copyFrom(e);
  }
  /**
   * The rotation of the object in radians.
   * 'rotation' and 'angle' have the same effect on a display object; rotation is in radians, angle is in degrees.
   */
  get rotation() {
    return this.transform.rotation;
  }
  set rotation(e) {
    this.transform.rotation = e;
  }
  /**
   * The angle of the object in degrees.
   * 'rotation' and 'angle' have the same effect on a display object; rotation is in radians, angle is in degrees.
   */
  get angle() {
    return this.transform.rotation * V1e;
  }
  set angle(e) {
    this.transform.rotation = e * oT;
  }
  /**
   * The zIndex of the displayObject.
   *
   * If a container has the sortableChildren property set to true, children will be automatically
   * sorted by zIndex value; a higher value will mean it will be moved towards the end of the array,
   * and thus rendered on top of other display objects within the same container.
   * @see PIXI.Container#sortableChildren
   */
  get zIndex() {
    return this._zIndex;
  }
  set zIndex(e) {
    this._zIndex = e, this.parent && (this.parent.sortDirty = !0);
  }
  /**
   * Indicates if the object is globally visible.
   * @readonly
   */
  get worldVisible() {
    let e = this;
    do {
      if (!e.visible)
        return !1;
      e = e.parent;
    } while (e);
    return !0;
  }
  /**
   * Sets a mask for the displayObject. A mask is an object that limits the visibility of an
   * object to the shape of the mask applied to it. In PixiJS a regular mask must be a
   * {@link PIXI.Graphics} or a {@link PIXI.Sprite} object. This allows for much faster masking in canvas as it
   * utilities shape clipping. Furthermore, a mask of an object must be in the subtree of its parent.
   * Otherwise, `getLocalBounds` may calculate incorrect bounds, which makes the container's width and height wrong.
   * To remove a mask, set this property to `null`.
   *
   * For sprite mask both alpha and red channel are used. Black mask is the same as transparent mask.
   * @example
   * import { Graphics, Sprite } from 'pixi.js';
   *
   * const graphics = new Graphics();
   * graphics.beginFill(0xFF3300);
   * graphics.drawRect(50, 250, 100, 100);
   * graphics.endFill();
   *
   * const sprite = new Sprite(texture);
   * sprite.mask = graphics;
   * @todo At the moment, CanvasRenderer doesn't support Sprite as mask.
   */
  get mask() {
    return this._mask;
  }
  set mask(e) {
    if (this._mask !== e) {
      if (this._mask) {
        const n = this._mask.isMaskData ? this._mask.maskObject : this._mask;
        n && (n._maskRefCount--, n._maskRefCount === 0 && (n.renderable = !0, n.isMask = !1));
      }
      if (this._mask = e, this._mask) {
        const n = this._mask.isMaskData ? this._mask.maskObject : this._mask;
        n && (n._maskRefCount === 0 && (n.renderable = !1, n.isMask = !0), n._maskRefCount++);
      }
    }
  }
}
class Ybe extends vr {
  constructor() {
    super(...arguments), this.sortDirty = null;
  }
}
vr.prototype.displayObjectUpdateTransform = vr.prototype.updateTransform;
const Qbe = new Qn();
function Kbe(t, e) {
  return t.zIndex === e.zIndex ? t._lastSortedIndex - e._lastSortedIndex : t.zIndex - e.zIndex;
}
const zB = class gT extends vr {
  constructor() {
    super(), this.children = [], this.sortableChildren = gT.defaultSortableChildren, this.sortDirty = !1;
  }
  /**
   * Overridable method that can be used by Container subclasses whenever the children array is modified.
   * @param _length
   */
  onChildrenChange(e) {
  }
  /**
   * Adds one or more children to the container.
   *
   * Multiple items can be added like so: `myContainer.addChild(thingOne, thingTwo, thingThree)`
   * @param {...PIXI.DisplayObject} children - The DisplayObject(s) to add to the container
   * @returns {PIXI.DisplayObject} - The first child that was added.
   */
  addChild(...e) {
    if (e.length > 1)
      for (let n = 0; n < e.length; n++)
        this.addChild(e[n]);
    else {
      const n = e[0];
      n.parent && n.parent.removeChild(n), n.parent = this, this.sortDirty = !0, n.transform._parentID = -1, this.children.push(n), this._boundsID++, this.onChildrenChange(this.children.length - 1), this.emit("childAdded", n, this, this.children.length - 1), n.emit("added", this);
    }
    return e[0];
  }
  /**
   * Adds a child to the container at a specified index. If the index is out of bounds an error will be thrown.
   * If the child is already in this container, it will be moved to the specified index.
   * @param {PIXI.DisplayObject} child - The child to add.
   * @param {number} index - The absolute index where the child will be positioned at the end of the operation.
   * @returns {PIXI.DisplayObject} The child that was added.
   */
  addChildAt(e, n) {
    if (n < 0 || n > this.children.length)
      throw new Error(`${e}addChildAt: The index ${n} supplied is out of bounds ${this.children.length}`);
    return e.parent && e.parent.removeChild(e), e.parent = this, this.sortDirty = !0, e.transform._parentID = -1, this.children.splice(n, 0, e), this._boundsID++, this.onChildrenChange(n), e.emit("added", this), this.emit("childAdded", e, this, n), e;
  }
  /**
   * Swaps the position of 2 Display Objects within this container.
   * @param child - First display object to swap
   * @param child2 - Second display object to swap
   */
  swapChildren(e, n) {
    if (e === n)
      return;
    const r = this.getChildIndex(e), o = this.getChildIndex(n);
    this.children[r] = n, this.children[o] = e, this.onChildrenChange(r < o ? r : o);
  }
  /**
   * Returns the index position of a child DisplayObject instance
   * @param child - The DisplayObject instance to identify
   * @returns - The index position of the child display object to identify
   */
  getChildIndex(e) {
    const n = this.children.indexOf(e);
    if (n === -1)
      throw new Error("The supplied DisplayObject must be a child of the caller");
    return n;
  }
  /**
   * Changes the position of an existing child in the display object container
   * @param child - The child DisplayObject instance for which you want to change the index number
   * @param index - The resulting index number for the child display object
   */
  setChildIndex(e, n) {
    if (n < 0 || n >= this.children.length)
      throw new Error(`The index ${n} supplied is out of bounds ${this.children.length}`);
    const r = this.getChildIndex(e);
    Yd(this.children, r, 1), this.children.splice(n, 0, e), this.onChildrenChange(n);
  }
  /**
   * Returns the child at the specified index
   * @param index - The index to get the child at
   * @returns - The child at the given index, if any.
   */
  getChildAt(e) {
    if (e < 0 || e >= this.children.length)
      throw new Error(`getChildAt: Index (${e}) does not exist.`);
    return this.children[e];
  }
  /**
   * Removes one or more children from the container.
   * @param {...PIXI.DisplayObject} children - The DisplayObject(s) to remove
   * @returns {PIXI.DisplayObject} The first child that was removed.
   */
  removeChild(...e) {
    if (e.length > 1)
      for (let n = 0; n < e.length; n++)
        this.removeChild(e[n]);
    else {
      const n = e[0], r = this.children.indexOf(n);
      if (r === -1)
        return null;
      n.parent = null, n.transform._parentID = -1, Yd(this.children, r, 1), this._boundsID++, this.onChildrenChange(r), n.emit("removed", this), this.emit("childRemoved", n, this, r);
    }
    return e[0];
  }
  /**
   * Removes a child from the specified index position.
   * @param index - The index to get the child from
   * @returns The child that was removed.
   */
  removeChildAt(e) {
    const n = this.getChildAt(e);
    return n.parent = null, n.transform._parentID = -1, Yd(this.children, e, 1), this._boundsID++, this.onChildrenChange(e), n.emit("removed", this), this.emit("childRemoved", n, this, e), n;
  }
  /**
   * Removes all children from this container that are within the begin and end indexes.
   * @param beginIndex - The beginning position.
   * @param endIndex - The ending position. Default value is size of the container.
   * @returns - List of removed children
   */
  removeChildren(e = 0, n = this.children.length) {
    const r = e, o = n, s = o - r;
    let i;
    if (s > 0 && s <= o) {
      i = this.children.splice(r, s);
      for (let u = 0; u < i.length; ++u)
        i[u].parent = null, i[u].transform && (i[u].transform._parentID = -1);
      this._boundsID++, this.onChildrenChange(e);
      for (let u = 0; u < i.length; ++u)
        i[u].emit("removed", this), this.emit("childRemoved", i[u], this, u);
      return i;
    } else if (s === 0 && this.children.length === 0)
      return [];
    throw new RangeError("removeChildren: numeric values are outside the acceptable range.");
  }
  /** Sorts children by zIndex. Previous order is maintained for 2 children with the same zIndex. */
  sortChildren() {
    let e = !1;
    for (let n = 0, r = this.children.length; n < r; ++n) {
      const o = this.children[n];
      o._lastSortedIndex = n, !e && o.zIndex !== 0 && (e = !0);
    }
    e && this.children.length > 1 && this.children.sort(Kbe), this.sortDirty = !1;
  }
  /** Updates the transform on all children of this container for rendering. */
  updateTransform() {
    this.sortableChildren && this.sortDirty && this.sortChildren(), this._boundsID++, this.transform.updateTransform(this.parent.transform), this.worldAlpha = this.alpha * this.parent.worldAlpha;
    for (let e = 0, n = this.children.length; e < n; ++e) {
      const r = this.children[e];
      r.visible && r.updateTransform();
    }
  }
  /**
   * Recalculates the bounds of the container.
   *
   * This implementation will automatically fit the children's bounds into the calculation. Each child's bounds
   * is limited to its mask's bounds or filterArea, if any is applied.
   */
  calculateBounds() {
    this._bounds.clear(), this._calculateBounds();
    for (let e = 0; e < this.children.length; e++) {
      const n = this.children[e];
      if (!(!n.visible || !n.renderable))
        if (n.calculateBounds(), n._mask) {
          const r = n._mask.isMaskData ? n._mask.maskObject : n._mask;
          r ? (r.calculateBounds(), this._bounds.addBoundsMask(n._bounds, r._bounds)) : this._bounds.addBounds(n._bounds);
        } else
          n.filterArea ? this._bounds.addBoundsArea(n._bounds, n.filterArea) : this._bounds.addBounds(n._bounds);
    }
    this._bounds.updateID = this._boundsID;
  }
  /**
   * Retrieves the local bounds of the displayObject as a rectangle object.
   *
   * Calling `getLocalBounds` may invalidate the `_bounds` of the whole subtree below. If using it inside a render()
   * call, it is advised to call `getBounds()` immediately after to recalculate the world bounds of the subtree.
   * @param rect - Optional rectangle to store the result of the bounds calculation.
   * @param skipChildrenUpdate - Setting to `true` will stop re-calculation of children transforms,
   *  it was default behaviour of pixi 4.0-5.2 and caused many problems to users.
   * @returns - The rectangular bounding area.
   */
  getLocalBounds(e, n = !1) {
    const r = super.getLocalBounds(e);
    if (!n)
      for (let o = 0, s = this.children.length; o < s; ++o) {
        const i = this.children[o];
        i.visible && i.updateTransform();
      }
    return r;
  }
  /**
   * Recalculates the content bounds of this object. This should be overriden to
   * calculate the bounds of this specific object (not including children).
   * @protected
   */
  _calculateBounds() {
  }
  /**
   * Renders this object and its children with culling.
   * @protected
   * @param {PIXI.Renderer} renderer - The renderer
   */
  _renderWithCulling(e) {
    const n = e.renderTexture.sourceFrame;
    if (!(n.width > 0 && n.height > 0))
      return;
    let r, o;
    this.cullArea ? (r = this.cullArea, o = this.worldTransform) : this._render !== gT.prototype._render && (r = this.getBounds(!0));
    const s = e.projection.transform;
    if (s && (o ? (o = Qbe.copyFrom(o), o.prepend(s)) : o = s), r && n.intersects(r, o))
      this._render(e);
    else if (this.cullArea)
      return;
    for (let i = 0, u = this.children.length; i < u; ++i) {
      const l = this.children[i], a = l.cullable;
      l.cullable = a || !this.cullArea, l.render(e), l.cullable = a;
    }
  }
  /**
   * Renders the object using the WebGL renderer.
   *
   * The [_render]{@link PIXI.Container#_render} method is be overriden for rendering the contents of the
   * container itself. This `render` method will invoke it, and also invoke the `render` methods of all
   * children afterward.
   *
   * If `renderable` or `visible` is false or if `worldAlpha` is not positive or if `cullable` is true and
   * the bounds of this object are out of frame, this implementation will entirely skip rendering.
   * See {@link PIXI.DisplayObject} for choosing between `renderable` or `visible`. Generally,
   * setting alpha to zero is not recommended for purely skipping rendering.
   *
   * When your scene becomes large (especially when it is larger than can be viewed in a single screen), it is
   * advised to employ **culling** to automatically skip rendering objects outside of the current screen.
   * See [cullable]{@link PIXI.DisplayObject#cullable} and [cullArea]{@link PIXI.DisplayObject#cullArea}.
   * Other culling methods might be better suited for a large number static objects; see
   * [@pixi-essentials/cull]{@link https://www.npmjs.com/package/@pixi-essentials/cull} and
   * [pixi-cull]{@link https://www.npmjs.com/package/pixi-cull}.
   *
   * The [renderAdvanced]{@link PIXI.Container#renderAdvanced} method is internally used when when masking or
   * filtering is applied on a container. This does, however, break batching and can affect performance when
   * masking and filtering is applied extensively throughout the scene graph.
   * @param renderer - The renderer
   */
  render(e) {
    if (!(!this.visible || this.worldAlpha <= 0 || !this.renderable))
      if (this._mask || this.filters?.length)
        this.renderAdvanced(e);
      else if (this.cullable)
        this._renderWithCulling(e);
      else {
        this._render(e);
        for (let n = 0, r = this.children.length; n < r; ++n)
          this.children[n].render(e);
      }
  }
  /**
   * Render the object using the WebGL renderer and advanced features.
   * @param renderer - The renderer
   */
  renderAdvanced(e) {
    const n = this.filters, r = this._mask;
    if (n) {
      this._enabledFilters || (this._enabledFilters = []), this._enabledFilters.length = 0;
      for (let s = 0; s < n.length; s++)
        n[s].enabled && this._enabledFilters.push(n[s]);
    }
    const o = n && this._enabledFilters?.length || r && (!r.isMaskData || r.enabled && (r.autoDetect || r.type !== io.NONE));
    if (o && e.batch.flush(), n && this._enabledFilters?.length && e.filter.push(this, this._enabledFilters), r && e.mask.push(this, this._mask), this.cullable)
      this._renderWithCulling(e);
    else {
      this._render(e);
      for (let s = 0, i = this.children.length; s < i; ++s)
        this.children[s].render(e);
    }
    o && e.batch.flush(), r && e.mask.pop(this), n && this._enabledFilters?.length && e.filter.pop();
  }
  /**
   * To be overridden by the subclasses.
   * @param _renderer - The renderer
   */
  _render(e) {
  }
  /**
   * Removes all internal references and listeners as well as removes children from the display list.
   * Do not use a Container after calling `destroy`.
   * @param options - Options parameter. A boolean will act as if all options
   *  have been set to that value
   * @param {boolean} [options.children=false] - if set to true, all the children will have their destroy
   *  method called as well. 'options' will be passed on to those calls.
   * @param {boolean} [options.texture=false] - Only used for child Sprites if options.children is set to true
   *  Should it destroy the texture of the child sprite
   * @param {boolean} [options.baseTexture=false] - Only used for child Sprites if options.children is set to true
   *  Should it destroy the base texture of the child sprite
   */
  destroy(e) {
    super.destroy(), this.sortDirty = !1;
    const n = typeof e == "boolean" ? e : e?.children, r = this.removeChildren(0, this.children.length);
    if (n)
      for (let o = 0; o < r.length; ++o)
        r[o].destroy(e);
  }
  /** The width of the Container, setting this will actually modify the scale to achieve the value set. */
  get width() {
    return this.scale.x * this.getLocalBounds().width;
  }
  set width(e) {
    const n = this.getLocalBounds().width;
    n !== 0 ? this.scale.x = e / n : this.scale.x = 1, this._width = e;
  }
  /** The height of the Container, setting this will actually modify the scale to achieve the value set. */
  get height() {
    return this.scale.y * this.getLocalBounds().height;
  }
  set height(e) {
    const n = this.getLocalBounds().height;
    n !== 0 ? this.scale.y = e / n : this.scale.y = 1, this._height = e;
  }
};
zB.defaultSortableChildren = !1;
let fn = zB;
fn.prototype.containerUpdateTransform = fn.prototype.updateTransform;
Object.defineProperties(at, {
  /**
   * Sets the default value for the container property 'sortableChildren'.
   * @static
   * @name SORTABLE_CHILDREN
   * @memberof PIXI.settings
   * @deprecated since 7.1.0
   * @type {boolean}
   * @see PIXI.Container.defaultSortableChildren
   */
  SORTABLE_CHILDREN: {
    get() {
      return fn.defaultSortableChildren;
    },
    set(t) {
      un("7.1.0", "settings.SORTABLE_CHILDREN is deprecated, use Container.defaultSortableChildren"), fn.defaultSortableChildren = t;
    }
  }
});
const wf = new Rt(), Zbe = new Uint16Array([0, 1, 2, 0, 2, 3]);
class Vr extends fn {
  /** @param texture - The texture for this sprite. */
  constructor(e) {
    super(), this._anchor = new Yu(
      this._onAnchorUpdate,
      this,
      e ? e.defaultAnchor.x : 0,
      e ? e.defaultAnchor.y : 0
    ), this._texture = null, this._width = 0, this._height = 0, this._tintColor = new Gn(16777215), this._tintRGB = null, this.tint = 16777215, this.blendMode = Mt.NORMAL, this._cachedTint = 16777215, this.uvs = null, this.texture = e || pt.EMPTY, this.vertexData = new Float32Array(8), this.vertexTrimmedData = null, this._transformID = -1, this._textureID = -1, this._transformTrimmedID = -1, this._textureTrimmedID = -1, this.indices = Zbe, this.pluginName = "batch", this.isSprite = !0, this._roundPixels = at.ROUND_PIXELS;
  }
  /** When the texture is updated, this event will fire to update the scale and frame. */
  _onTextureUpdate() {
    this._textureID = -1, this._textureTrimmedID = -1, this._cachedTint = 16777215, this._width && (this.scale.x = ec(this.scale.x) * this._width / this._texture.orig.width), this._height && (this.scale.y = ec(this.scale.y) * this._height / this._texture.orig.height);
  }
  /** Called when the anchor position updates. */
  _onAnchorUpdate() {
    this._transformID = -1, this._transformTrimmedID = -1;
  }
  /** Calculates worldTransform * vertices, store it in vertexData. */
  calculateVertices() {
    const e = this._texture;
    if (this._transformID === this.transform._worldID && this._textureID === e._updateID)
      return;
    this._textureID !== e._updateID && (this.uvs = this._texture._uvs.uvsFloat32), this._transformID = this.transform._worldID, this._textureID = e._updateID;
    const n = this.transform.worldTransform, r = n.a, o = n.b, s = n.c, i = n.d, u = n.tx, l = n.ty, a = this.vertexData, c = e.trim, p = e.orig, d = this._anchor;
    let h = 0, m = 0, g = 0, _ = 0;
    if (c ? (m = c.x - d._x * p.width, h = m + c.width, _ = c.y - d._y * p.height, g = _ + c.height) : (m = -d._x * p.width, h = m + p.width, _ = -d._y * p.height, g = _ + p.height), a[0] = r * m + s * _ + u, a[1] = i * _ + o * m + l, a[2] = r * h + s * _ + u, a[3] = i * _ + o * h + l, a[4] = r * h + s * g + u, a[5] = i * g + o * h + l, a[6] = r * m + s * g + u, a[7] = i * g + o * m + l, this._roundPixels) {
      const b = at.RESOLUTION;
      for (let x = 0; x < a.length; ++x)
        a[x] = Math.round(a[x] * b) / b;
    }
  }
  /**
   * Calculates worldTransform * vertices for a non texture with a trim. store it in vertexTrimmedData.
   *
   * This is used to ensure that the true width and height of a trimmed texture is respected.
   */
  calculateTrimmedVertices() {
    if (!this.vertexTrimmedData)
      this.vertexTrimmedData = new Float32Array(8);
    else if (this._transformTrimmedID === this.transform._worldID && this._textureTrimmedID === this._texture._updateID)
      return;
    this._transformTrimmedID = this.transform._worldID, this._textureTrimmedID = this._texture._updateID;
    const e = this._texture, n = this.vertexTrimmedData, r = e.orig, o = this._anchor, s = this.transform.worldTransform, i = s.a, u = s.b, l = s.c, a = s.d, c = s.tx, p = s.ty, d = -o._x * r.width, h = d + r.width, m = -o._y * r.height, g = m + r.height;
    if (n[0] = i * d + l * m + c, n[1] = a * m + u * d + p, n[2] = i * h + l * m + c, n[3] = a * m + u * h + p, n[4] = i * h + l * g + c, n[5] = a * g + u * h + p, n[6] = i * d + l * g + c, n[7] = a * g + u * d + p, this._roundPixels) {
      const _ = at.RESOLUTION;
      for (let b = 0; b < n.length; ++b)
        n[b] = Math.round(n[b] * _) / _;
    }
  }
  /**
   *
   * Renders the object using the WebGL renderer
   * @param renderer - The webgl renderer to use.
   */
  _render(e) {
    this.calculateVertices(), e.batch.setObjectRenderer(e.plugins[this.pluginName]), e.plugins[this.pluginName].render(this);
  }
  /** Updates the bounds of the sprite. */
  _calculateBounds() {
    const e = this._texture.trim, n = this._texture.orig;
    !e || e.width === n.width && e.height === n.height ? (this.calculateVertices(), this._bounds.addQuad(this.vertexData)) : (this.calculateTrimmedVertices(), this._bounds.addQuad(this.vertexTrimmedData));
  }
  /**
   * Gets the local bounds of the sprite object.
   * @param rect - Optional output rectangle.
   * @returns The bounds.
   */
  getLocalBounds(e) {
    return this.children.length === 0 ? (this._localBounds || (this._localBounds = new cv()), this._localBounds.minX = this._texture.orig.width * -this._anchor._x, this._localBounds.minY = this._texture.orig.height * -this._anchor._y, this._localBounds.maxX = this._texture.orig.width * (1 - this._anchor._x), this._localBounds.maxY = this._texture.orig.height * (1 - this._anchor._y), e || (this._localBoundsRect || (this._localBoundsRect = new Pt()), e = this._localBoundsRect), this._localBounds.getRectangle(e)) : super.getLocalBounds.call(this, e);
  }
  /**
   * Tests if a point is inside this sprite
   * @param point - the point to test
   * @returns The result of the test
   */
  containsPoint(e) {
    this.worldTransform.applyInverse(e, wf);
    const n = this._texture.orig.width, r = this._texture.orig.height, o = -n * this.anchor.x;
    let s = 0;
    return wf.x >= o && wf.x < o + n && (s = -r * this.anchor.y, wf.y >= s && wf.y < s + r);
  }
  /**
   * Destroys this sprite and optionally its texture and children.
   * @param options - Options parameter. A boolean will act as if all options
   *  have been set to that value
   * @param [options.children=false] - if set to true, all the children will have their destroy
   *      method called as well. 'options' will be passed on to those calls.
   * @param [options.texture=false] - Should it destroy the current texture of the sprite as well
   * @param [options.baseTexture=false] - Should it destroy the base texture of the sprite as well
   */
  destroy(e) {
    if (super.destroy(e), this._texture.off("update", this._onTextureUpdate, this), this._anchor = null, typeof e == "boolean" ? e : e?.texture) {
      const n = typeof e == "boolean" ? e : e?.baseTexture;
      this._texture.destroy(!!n);
    }
    this._texture = null;
  }
  // some helper functions..
  /**
   * Helper function that creates a new sprite based on the source you provide.
   * The source can be - frame id, image url, video url, canvas element, video element, base texture
   * @param {string|PIXI.Texture|HTMLImageElement|HTMLVideoElement|ImageBitmap|PIXI.ICanvas} source
   *     - Source to create texture from
   * @param {object} [options] - See {@link PIXI.BaseTexture}'s constructor for options.
   * @returns The newly created sprite
   */
  static from(e, n) {
    const r = e instanceof pt ? e : pt.from(e, n);
    return new Vr(r);
  }
  /**
   * If true PixiJS will Math.floor() x/y values when rendering, stopping pixel interpolation.
   *
   * Advantages can include sharper image quality (like text) and faster rendering on canvas.
   * The main disadvantage is movement of objects may appear less smooth.
   *
   * To set the global default, change {@link PIXI.settings.ROUND_PIXELS}.
   * @default false
   */
  set roundPixels(e) {
    this._roundPixels !== e && (this._transformID = -1, this._transformTrimmedID = -1), this._roundPixels = e;
  }
  get roundPixels() {
    return this._roundPixels;
  }
  /** The width of the sprite, setting this will actually modify the scale to achieve the value set. */
  get width() {
    return Math.abs(this.scale.x) * this._texture.orig.width;
  }
  set width(e) {
    const n = ec(this.scale.x) || 1;
    this.scale.x = n * e / this._texture.orig.width, this._width = e;
  }
  /** The height of the sprite, setting this will actually modify the scale to achieve the value set. */
  get height() {
    return Math.abs(this.scale.y) * this._texture.orig.height;
  }
  set height(e) {
    const n = ec(this.scale.y) || 1;
    this.scale.y = n * e / this._texture.orig.height, this._height = e;
  }
  /**
   * The anchor sets the origin point of the sprite. The default value is taken from the {@link PIXI.Texture|Texture}
   * and passed to the constructor.
   *
   * The default is `(0,0)`, this means the sprite's origin is the top left.
   *
   * Setting the anchor to `(0.5,0.5)` means the sprite's origin is centered.
   *
   * Setting the anchor to `(1,1)` would mean the sprite's origin point will be the bottom right corner.
   *
   * If you pass only single parameter, it will set both x and y to the same value as shown in the example below.
   * @example
   * import { Sprite } from 'pixi.js';
   *
   * const sprite = new Sprite(Texture.WHITE);
   * sprite.anchor.set(0.5); // This will set the origin to center. (0.5) is same as (0.5, 0.5).
   */
  get anchor() {
    return this._anchor;
  }
  set anchor(e) {
    this._anchor.copyFrom(e);
  }
  /**
   * The tint applied to the sprite. This is a hex value.
   *
   * A value of 0xFFFFFF will remove any tint effect.
   * @default 0xFFFFFF
   */
  get tint() {
    return this._tintColor.value;
  }
  set tint(e) {
    this._tintColor.setValue(e), this._tintRGB = this._tintColor.toLittleEndianNumber();
  }
  /**
   * Get the tint as a RGB integer.
   * @ignore
   */
  get tintValue() {
    return this._tintColor.toNumber();
  }
  /** The texture that the sprite is using. */
  get texture() {
    return this._texture;
  }
  set texture(e) {
    this._texture !== e && (this._texture && this._texture.off("update", this._onTextureUpdate, this), this._texture = e || pt.EMPTY, this._cachedTint = 16777215, this._textureID = -1, this._textureTrimmedID = -1, e && (e.baseTexture.valid ? this._onTextureUpdate() : e.once("update", this._onTextureUpdate, this)));
  }
}
const qB = new Qn();
vr.prototype._cacheAsBitmap = !1;
vr.prototype._cacheData = null;
vr.prototype._cacheAsBitmapResolution = null;
vr.prototype._cacheAsBitmapMultisample = null;
class Jbe {
  constructor() {
    this.textureCacheId = null, this.originalRender = null, this.originalRenderCanvas = null, this.originalCalculateBounds = null, this.originalGetLocalBounds = null, this.originalUpdateTransform = null, this.originalDestroy = null, this.originalMask = null, this.originalFilterArea = null, this.originalContainsPoint = null, this.sprite = null;
  }
}
Object.defineProperties(vr.prototype, {
  /**
   * The resolution to use for cacheAsBitmap. By default this will use the renderer's resolution
   * but can be overriden for performance. Lower values will reduce memory usage at the expense
   * of render quality. A falsey value of `null` or `0` will default to the renderer's resolution.
   * If `cacheAsBitmap` is set to `true`, this will re-render with the new resolution.
   * @member {number|null} cacheAsBitmapResolution
   * @memberof PIXI.DisplayObject#
   * @default null
   */
  cacheAsBitmapResolution: {
    get() {
      return this._cacheAsBitmapResolution;
    },
    set(t) {
      t !== this._cacheAsBitmapResolution && (this._cacheAsBitmapResolution = t, this.cacheAsBitmap && (this.cacheAsBitmap = !1, this.cacheAsBitmap = !0));
    }
  },
  /**
   * The number of samples to use for cacheAsBitmap. If set to `null`, the renderer's
   * sample count is used.
   * If `cacheAsBitmap` is set to `true`, this will re-render with the new number of samples.
   * @member {number|null} cacheAsBitmapMultisample
   * @memberof PIXI.DisplayObject#
   * @default null
   */
  cacheAsBitmapMultisample: {
    get() {
      return this._cacheAsBitmapMultisample;
    },
    set(t) {
      t !== this._cacheAsBitmapMultisample && (this._cacheAsBitmapMultisample = t, this.cacheAsBitmap && (this.cacheAsBitmap = !1, this.cacheAsBitmap = !0));
    }
  },
  /**
   * Set this to true if you want this display object to be cached as a bitmap.
   * This basically takes a snapshot of the display object as it is at that moment. It can
   * provide a performance benefit for complex static displayObjects.
   * To remove simply set this property to `false`
   *
   * IMPORTANT GOTCHA - Make sure that all your textures are preloaded BEFORE setting this property to true
   * as it will take a snapshot of what is currently there. If the textures have not loaded then they will not appear.
   * @member {boolean}
   * @memberof PIXI.DisplayObject#
   */
  cacheAsBitmap: {
    get() {
      return this._cacheAsBitmap;
    },
    set(t) {
      if (this._cacheAsBitmap === t)
        return;
      this._cacheAsBitmap = t;
      let e;
      t ? (this._cacheData || (this._cacheData = new Jbe()), e = this._cacheData, e.originalRender = this.render, e.originalRenderCanvas = this.renderCanvas, e.originalUpdateTransform = this.updateTransform, e.originalCalculateBounds = this.calculateBounds, e.originalGetLocalBounds = this.getLocalBounds, e.originalDestroy = this.destroy, e.originalContainsPoint = this.containsPoint, e.originalMask = this._mask, e.originalFilterArea = this.filterArea, this.render = this._renderCached, this.renderCanvas = this._renderCachedCanvas, this.destroy = this._cacheAsBitmapDestroy) : (e = this._cacheData, e.sprite && this._destroyCachedDisplayObject(), this.render = e.originalRender, this.renderCanvas = e.originalRenderCanvas, this.calculateBounds = e.originalCalculateBounds, this.getLocalBounds = e.originalGetLocalBounds, this.destroy = e.originalDestroy, this.updateTransform = e.originalUpdateTransform, this.containsPoint = e.originalContainsPoint, this._mask = e.originalMask, this.filterArea = e.originalFilterArea);
    }
  }
});
vr.prototype._renderCached = function(t) {
  !this.visible || this.worldAlpha <= 0 || !this.renderable || (this._initCachedDisplayObject(t), this._cacheData.sprite.transform._worldID = this.transform._worldID, this._cacheData.sprite.worldAlpha = this.worldAlpha, this._cacheData.sprite._render(t));
};
vr.prototype._initCachedDisplayObject = function(t) {
  if (this._cacheData?.sprite)
    return;
  const e = this.alpha;
  this.alpha = 1, t.batch.flush();
  const n = this.getLocalBounds(new Pt(), !0);
  if (this.filters?.length) {
    const d = this.filters[0].padding;
    n.pad(d);
  }
  const r = this.cacheAsBitmapResolution || t.resolution;
  n.ceil(r), n.width = Math.max(n.width, 1 / r), n.height = Math.max(n.height, 1 / r);
  const o = t.renderTexture.current, s = t.renderTexture.sourceFrame.clone(), i = t.renderTexture.destinationFrame.clone(), u = t.projection.transform, l = rd.create({
    width: n.width,
    height: n.height,
    resolution: r,
    multisample: this.cacheAsBitmapMultisample ?? t.multisample
  }), a = `cacheAsBitmap_${Up()}`;
  this._cacheData.textureCacheId = a, qt.addToCache(l.baseTexture, a), pt.addToCache(l, a);
  const c = this.transform.localTransform.copyTo(qB).invert().translate(-n.x, -n.y);
  this.render = this._cacheData.originalRender, t.render(this, { renderTexture: l, clear: !0, transform: c, skipUpdateTransform: !1 }), t.framebuffer.blit(), t.projection.transform = u, t.renderTexture.bind(o, s, i), this.render = this._renderCached, this.updateTransform = this.displayObjectUpdateTransform, this.calculateBounds = this._calculateCachedBounds, this.getLocalBounds = this._getCachedLocalBounds, this._mask = null, this.filterArea = null, this.alpha = e;
  const p = new Vr(l);
  p.transform.worldTransform = this.transform.worldTransform, p.anchor.x = -(n.x / n.width), p.anchor.y = -(n.y / n.height), p.alpha = e, p._bounds = this._bounds, this._cacheData.sprite = p, this.transform._parentID = -1, this.parent ? this.updateTransform() : (this.enableTempParent(), this.updateTransform(), this.disableTempParent(null)), this.containsPoint = p.containsPoint.bind(p);
};
vr.prototype._renderCachedCanvas = function(t) {
  !this.visible || this.worldAlpha <= 0 || !this.renderable || (this._initCachedDisplayObjectCanvas(t), this._cacheData.sprite.worldAlpha = this.worldAlpha, this._cacheData.sprite._renderCanvas(t));
};
vr.prototype._initCachedDisplayObjectCanvas = function(t) {
  if (this._cacheData?.sprite)
    return;
  const e = this.getLocalBounds(new Pt(), !0), n = this.alpha;
  this.alpha = 1;
  const r = t.canvasContext.activeContext, o = t._projTransform, s = this.cacheAsBitmapResolution || t.resolution;
  e.ceil(s), e.width = Math.max(e.width, 1 / s), e.height = Math.max(e.height, 1 / s);
  const i = rd.create({
    width: e.width,
    height: e.height,
    resolution: s
  }), u = `cacheAsBitmap_${Up()}`;
  this._cacheData.textureCacheId = u, qt.addToCache(i.baseTexture, u), pt.addToCache(i, u);
  const l = qB;
  this.transform.localTransform.copyTo(l), l.invert(), l.tx -= e.x, l.ty -= e.y, this.renderCanvas = this._cacheData.originalRenderCanvas, t.render(this, { renderTexture: i, clear: !0, transform: l, skipUpdateTransform: !1 }), t.canvasContext.activeContext = r, t._projTransform = o, this.renderCanvas = this._renderCachedCanvas, this.updateTransform = this.displayObjectUpdateTransform, this.calculateBounds = this._calculateCachedBounds, this.getLocalBounds = this._getCachedLocalBounds, this._mask = null, this.filterArea = null, this.alpha = n;
  const a = new Vr(i);
  a.transform.worldTransform = this.transform.worldTransform, a.anchor.x = -(e.x / e.width), a.anchor.y = -(e.y / e.height), a.alpha = n, a._bounds = this._bounds, this._cacheData.sprite = a, this.transform._parentID = -1, this.parent ? this.updateTransform() : (this.parent = t._tempDisplayObjectParent, this.updateTransform(), this.parent = null), this.containsPoint = a.containsPoint.bind(a);
};
vr.prototype._calculateCachedBounds = function() {
  this._bounds.clear(), this._cacheData.sprite.transform._worldID = this.transform._worldID, this._cacheData.sprite._calculateBounds(), this._bounds.updateID = this._boundsID;
};
vr.prototype._getCachedLocalBounds = function() {
  return this._cacheData.sprite.getLocalBounds(null);
};
vr.prototype._destroyCachedDisplayObject = function() {
  this._cacheData.sprite._texture.destroy(!0), this._cacheData.sprite = null, qt.removeFromCache(this._cacheData.textureCacheId), pt.removeFromCache(this._cacheData.textureCacheId), this._cacheData.textureCacheId = null;
};
vr.prototype._cacheAsBitmapDestroy = function(t) {
  this.cacheAsBitmap = !1, this.destroy(t);
};
vr.prototype.name = null;
fn.prototype.getChildByName = function(t, e) {
  for (let n = 0, r = this.children.length; n < r; n++)
    if (this.children[n].name === t)
      return this.children[n];
  if (e)
    for (let n = 0, r = this.children.length; n < r; n++) {
      const o = this.children[n];
      if (!o.getChildByName)
        continue;
      const s = o.getChildByName(t, !0);
      if (s)
        return s;
    }
  return null;
};
vr.prototype.getGlobalPosition = function(t = new Rt(), e = !1) {
  return this.parent ? this.parent.toGlobal(this.position, t, e) : (t.x = this.position.x, t.y = this.position.y), t;
};
var eke = `varying vec2 vTextureCoord;

uniform sampler2D uSampler;
uniform float uAlpha;

void main(void)
{
   gl_FragColor = texture2D(uSampler, vTextureCoord) * uAlpha;
}
`;
class tke extends Jo {
  /**
   * @param alpha - Amount of alpha from 0 to 1, where 0 is transparent
   */
  constructor(e = 1) {
    super(Hbe, eke, { uAlpha: 1 }), this.alpha = e;
  }
  /**
   * Coefficient for alpha multiplication
   * @default 1
   */
  get alpha() {
    return this.uniforms.uAlpha;
  }
  set alpha(e) {
    this.uniforms.uAlpha = e;
  }
}
const nke = {
  5: [0.153388, 0.221461, 0.250301],
  7: [0.071303, 0.131514, 0.189879, 0.214607],
  9: [0.028532, 0.067234, 0.124009, 0.179044, 0.20236],
  11: [93e-4, 0.028002, 0.065984, 0.121703, 0.175713, 0.198596],
  13: [2406e-6, 9255e-6, 0.027867, 0.065666, 0.121117, 0.174868, 0.197641],
  15: [489e-6, 2403e-6, 9246e-6, 0.02784, 0.065602, 0.120999, 0.174697, 0.197448]
}, rke = [
  "varying vec2 vBlurTexCoords[%size%];",
  "uniform sampler2D uSampler;",
  "void main(void)",
  "{",
  "    gl_FragColor = vec4(0.0);",
  "    %blur%",
  "}"
].join(`
`);
function oke(t) {
  const e = nke[t], n = e.length;
  let r = rke, o = "";
  const s = "gl_FragColor += texture2D(uSampler, vBlurTexCoords[%index%]) * %value%;";
  let i;
  for (let u = 0; u < t; u++) {
    let l = s.replace("%index%", u.toString());
    i = u, u >= n && (i = t - u - 1), l = l.replace("%value%", e[i].toString()), o += l, o += `
`;
  }
  return r = r.replace("%blur%", o), r = r.replace("%size%", t.toString()), r;
}
const ske = `
    attribute vec2 aVertexPosition;

    uniform mat3 projectionMatrix;

    uniform float strength;

    varying vec2 vBlurTexCoords[%size%];

    uniform vec4 inputSize;
    uniform vec4 outputFrame;

    vec4 filterVertexPosition( void )
    {
        vec2 position = aVertexPosition * max(outputFrame.zw, vec2(0.)) + outputFrame.xy;

        return vec4((projectionMatrix * vec3(position, 1.0)).xy, 0.0, 1.0);
    }

    vec2 filterTextureCoord( void )
    {
        return aVertexPosition * (outputFrame.zw * inputSize.zw);
    }

    void main(void)
    {
        gl_Position = filterVertexPosition();

        vec2 textureCoord = filterTextureCoord();
        %blur%
    }`;
function ake(t, e) {
  const n = Math.ceil(t / 2);
  let r = ske, o = "", s;
  e ? s = "vBlurTexCoords[%index%] =  textureCoord + vec2(%sampleIndex% * strength, 0.0);" : s = "vBlurTexCoords[%index%] =  textureCoord + vec2(0.0, %sampleIndex% * strength);";
  for (let i = 0; i < t; i++) {
    let u = s.replace("%index%", i.toString());
    u = u.replace("%sampleIndex%", `${i - (n - 1)}.0`), o += u, o += `
`;
  }
  return r = r.replace("%blur%", o), r = r.replace("%size%", t.toString()), r;
}
class vT extends Jo {
  /**
   * @param horizontal - Do pass along the x-axis (`true`) or y-axis (`false`).
   * @param strength - The strength of the blur filter.
   * @param quality - The quality of the blur filter.
   * @param {number|null} [resolution=PIXI.Filter.defaultResolution] - The resolution of the blur filter.
   * @param kernelSize - The kernelSize of the blur filter.Options: 5, 7, 9, 11, 13, 15.
   */
  constructor(e, n = 8, r = 4, o = Jo.defaultResolution, s = 5) {
    const i = ake(s, e), u = oke(s);
    super(
      // vertex shader
      i,
      // fragment shader
      u
    ), this.horizontal = e, this.resolution = o, this._quality = 0, this.quality = r, this.blur = n;
  }
  /**
   * Applies the filter.
   * @param filterManager - The manager.
   * @param input - The input target.
   * @param output - The output target.
   * @param clearMode - How to clear
   */
  apply(e, n, r, o) {
    if (r ? this.horizontal ? this.uniforms.strength = 1 / r.width * (r.width / n.width) : this.uniforms.strength = 1 / r.height * (r.height / n.height) : this.horizontal ? this.uniforms.strength = 1 / e.renderer.width * (e.renderer.width / n.width) : this.uniforms.strength = 1 / e.renderer.height * (e.renderer.height / n.height), this.uniforms.strength *= this.strength, this.uniforms.strength /= this.passes, this.passes === 1)
      e.applyFilter(this, n, r, o);
    else {
      const s = e.getFilterTexture(), i = e.renderer;
      let u = n, l = s;
      this.state.blend = !1, e.applyFilter(this, u, l, Gi.CLEAR);
      for (let a = 1; a < this.passes - 1; a++) {
        e.bindAndClear(u, Gi.BLIT), this.uniforms.uSampler = l;
        const c = l;
        l = u, u = c, i.shader.bind(this), i.geometry.draw(5);
      }
      this.state.blend = !0, e.applyFilter(this, l, r, o), e.returnFilterTexture(s);
    }
  }
  /**
   * Sets the strength of both the blur.
   * @default 16
   */
  get blur() {
    return this.strength;
  }
  set blur(e) {
    this.padding = 1 + Math.abs(e) * 2, this.strength = e;
  }
  /**
   * Sets the quality of the blur by modifying the number of passes. More passes means higher
   * quality bluring but the lower the performance.
   * @default 4
   */
  get quality() {
    return this._quality;
  }
  set quality(e) {
    this._quality = e, this.passes = e;
  }
}
class ike extends Jo {
  /**
   * @param strength - The strength of the blur filter.
   * @param quality - The quality of the blur filter.
   * @param {number|null} [resolution=PIXI.Filter.defaultResolution] - The resolution of the blur filter.
   * @param kernelSize - The kernelSize of the blur filter.Options: 5, 7, 9, 11, 13, 15.
   */
  constructor(e = 8, n = 4, r = Jo.defaultResolution, o = 5) {
    super(), this._repeatEdgePixels = !1, this.blurXFilter = new vT(!0, e, n, r, o), this.blurYFilter = new vT(!1, e, n, r, o), this.resolution = r, this.quality = n, this.blur = e, this.repeatEdgePixels = !1;
  }
  /**
   * Applies the filter.
   * @param filterManager - The manager.
   * @param input - The input target.
   * @param output - The output target.
   * @param clearMode - How to clear
   */
  apply(e, n, r, o) {
    const s = Math.abs(this.blurXFilter.strength), i = Math.abs(this.blurYFilter.strength);
    if (s && i) {
      const u = e.getFilterTexture();
      this.blurXFilter.apply(e, n, u, Gi.CLEAR), this.blurYFilter.apply(e, u, r, o), e.returnFilterTexture(u);
    } else
      i ? this.blurYFilter.apply(e, n, r, o) : this.blurXFilter.apply(e, n, r, o);
  }
  updatePadding() {
    this._repeatEdgePixels ? this.padding = 0 : this.padding = Math.max(Math.abs(this.blurXFilter.strength), Math.abs(this.blurYFilter.strength)) * 2;
  }
  /**
   * Sets the strength of both the blurX and blurY properties simultaneously
   * @default 2
   */
  get blur() {
    return this.blurXFilter.blur;
  }
  set blur(e) {
    this.blurXFilter.blur = this.blurYFilter.blur = e, this.updatePadding();
  }
  /**
   * Sets the number of passes for blur. More passes means higher quality bluring.
   * @default 1
   */
  get quality() {
    return this.blurXFilter.quality;
  }
  set quality(e) {
    this.blurXFilter.quality = this.blurYFilter.quality = e;
  }
  /**
   * Sets the strength of the blurX property
   * @default 2
   */
  get blurX() {
    return this.blurXFilter.blur;
  }
  set blurX(e) {
    this.blurXFilter.blur = e, this.updatePadding();
  }
  /**
   * Sets the strength of the blurY property
   * @default 2
   */
  get blurY() {
    return this.blurYFilter.blur;
  }
  set blurY(e) {
    this.blurYFilter.blur = e, this.updatePadding();
  }
  /**
   * Sets the blendmode of the filter
   * @default PIXI.BLEND_MODES.NORMAL
   */
  get blendMode() {
    return this.blurYFilter.blendMode;
  }
  set blendMode(e) {
    this.blurYFilter.blendMode = e;
  }
  /**
   * If set to true the edge of the target will be clamped
   * @default false
   */
  get repeatEdgePixels() {
    return this._repeatEdgePixels;
  }
  set repeatEdgePixels(e) {
    this._repeatEdgePixels = e, this.updatePadding();
  }
}
var uke = `varying vec2 vTextureCoord;
uniform sampler2D uSampler;
uniform float m[20];
uniform float uAlpha;

void main(void)
{
    vec4 c = texture2D(uSampler, vTextureCoord);

    if (uAlpha == 0.0) {
        gl_FragColor = c;
        return;
    }

    // Un-premultiply alpha before applying the color matrix. See issue #3539.
    if (c.a > 0.0) {
      c.rgb /= c.a;
    }

    vec4 result;

    result.r = (m[0] * c.r);
        result.r += (m[1] * c.g);
        result.r += (m[2] * c.b);
        result.r += (m[3] * c.a);
        result.r += m[4];

    result.g = (m[5] * c.r);
        result.g += (m[6] * c.g);
        result.g += (m[7] * c.b);
        result.g += (m[8] * c.a);
        result.g += m[9];

    result.b = (m[10] * c.r);
       result.b += (m[11] * c.g);
       result.b += (m[12] * c.b);
       result.b += (m[13] * c.a);
       result.b += m[14];

    result.a = (m[15] * c.r);
       result.a += (m[16] * c.g);
       result.a += (m[17] * c.b);
       result.a += (m[18] * c.a);
       result.a += m[19];

    vec3 rgb = mix(c.rgb, result.rgb, uAlpha);

    // Premultiply alpha again.
    rgb *= result.a;

    gl_FragColor = vec4(rgb, result.a);
}
`;
class _T extends Jo {
  constructor() {
    const e = {
      m: new Float32Array([
        1,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        1,
        0
      ]),
      uAlpha: 1
    };
    super(UB, uke, e), this.alpha = 1;
  }
  /**
   * Transforms current matrix and set the new one
   * @param {number[]} matrix - 5x4 matrix
   * @param multiply - if true, current matrix and matrix are multiplied. If false,
   *  just set the current matrix with @param matrix
   */
  _loadMatrix(e, n = !1) {
    let r = e;
    n && (this._multiply(r, this.uniforms.m, e), r = this._colorMatrix(r)), this.uniforms.m = r;
  }
  /**
   * Multiplies two mat5's
   * @private
   * @param out - 5x4 matrix the receiving matrix
   * @param a - 5x4 matrix the first operand
   * @param b - 5x4 matrix the second operand
   * @returns {number[]} 5x4 matrix
   */
  _multiply(e, n, r) {
    return e[0] = n[0] * r[0] + n[1] * r[5] + n[2] * r[10] + n[3] * r[15], e[1] = n[0] * r[1] + n[1] * r[6] + n[2] * r[11] + n[3] * r[16], e[2] = n[0] * r[2] + n[1] * r[7] + n[2] * r[12] + n[3] * r[17], e[3] = n[0] * r[3] + n[1] * r[8] + n[2] * r[13] + n[3] * r[18], e[4] = n[0] * r[4] + n[1] * r[9] + n[2] * r[14] + n[3] * r[19] + n[4], e[5] = n[5] * r[0] + n[6] * r[5] + n[7] * r[10] + n[8] * r[15], e[6] = n[5] * r[1] + n[6] * r[6] + n[7] * r[11] + n[8] * r[16], e[7] = n[5] * r[2] + n[6] * r[7] + n[7] * r[12] + n[8] * r[17], e[8] = n[5] * r[3] + n[6] * r[8] + n[7] * r[13] + n[8] * r[18], e[9] = n[5] * r[4] + n[6] * r[9] + n[7] * r[14] + n[8] * r[19] + n[9], e[10] = n[10] * r[0] + n[11] * r[5] + n[12] * r[10] + n[13] * r[15], e[11] = n[10] * r[1] + n[11] * r[6] + n[12] * r[11] + n[13] * r[16], e[12] = n[10] * r[2] + n[11] * r[7] + n[12] * r[12] + n[13] * r[17], e[13] = n[10] * r[3] + n[11] * r[8] + n[12] * r[13] + n[13] * r[18], e[14] = n[10] * r[4] + n[11] * r[9] + n[12] * r[14] + n[13] * r[19] + n[14], e[15] = n[15] * r[0] + n[16] * r[5] + n[17] * r[10] + n[18] * r[15], e[16] = n[15] * r[1] + n[16] * r[6] + n[17] * r[11] + n[18] * r[16], e[17] = n[15] * r[2] + n[16] * r[7] + n[17] * r[12] + n[18] * r[17], e[18] = n[15] * r[3] + n[16] * r[8] + n[17] * r[13] + n[18] * r[18], e[19] = n[15] * r[4] + n[16] * r[9] + n[17] * r[14] + n[18] * r[19] + n[19], e;
  }
  /**
   * Create a Float32 Array and normalize the offset component to 0-1
   * @param {number[]} matrix - 5x4 matrix
   * @returns {number[]} 5x4 matrix with all values between 0-1
   */
  _colorMatrix(e) {
    const n = new Float32Array(e);
    return n[4] /= 255, n[9] /= 255, n[14] /= 255, n[19] /= 255, n;
  }
  /**
   * Adjusts brightness
   * @param b - value of the brigthness (0-1, where 0 is black)
   * @param multiply - if true, current matrix and matrix are multiplied. If false,
   *  just set the current matrix with @param matrix
   */
  brightness(e, n) {
    const r = [
      e,
      0,
      0,
      0,
      0,
      0,
      e,
      0,
      0,
      0,
      0,
      0,
      e,
      0,
      0,
      0,
      0,
      0,
      1,
      0
    ];
    this._loadMatrix(r, n);
  }
  /**
   * Sets each channel on the diagonal of the color matrix.
   * This can be used to achieve a tinting effect on Containers similar to the tint field of some
   * display objects like Sprite, Text, Graphics, and Mesh.
   * @param color - Color of the tint. This is a hex value.
   * @param multiply - if true, current matrix and matrix are multiplied. If false,
   *  just set the current matrix with @param matrix
   */
  tint(e, n) {
    const [r, o, s] = Gn.shared.setValue(e).toArray(), i = [
      r,
      0,
      0,
      0,
      0,
      0,
      o,
      0,
      0,
      0,
      0,
      0,
      s,
      0,
      0,
      0,
      0,
      0,
      1,
      0
    ];
    this._loadMatrix(i, n);
  }
  /**
   * Set the matrices in grey scales
   * @param scale - value of the grey (0-1, where 0 is black)
   * @param multiply - if true, current matrix and matrix are multiplied. If false,
   *  just set the current matrix with @param matrix
   */
  greyscale(e, n) {
    const r = [
      e,
      e,
      e,
      0,
      0,
      e,
      e,
      e,
      0,
      0,
      e,
      e,
      e,
      0,
      0,
      0,
      0,
      0,
      1,
      0
    ];
    this._loadMatrix(r, n);
  }
  /**
   * Set the black and white matrice.
   * @param multiply - if true, current matrix and matrix are multiplied. If false,
   *  just set the current matrix with @param matrix
   */
  blackAndWhite(e) {
    const n = [
      0.3,
      0.6,
      0.1,
      0,
      0,
      0.3,
      0.6,
      0.1,
      0,
      0,
      0.3,
      0.6,
      0.1,
      0,
      0,
      0,
      0,
      0,
      1,
      0
    ];
    this._loadMatrix(n, e);
  }
  /**
   * Set the hue property of the color
   * @param rotation - in degrees
   * @param multiply - if true, current matrix and matrix are multiplied. If false,
   *  just set the current matrix with @param matrix
   */
  hue(e, n) {
    e = (e || 0) / 180 * Math.PI;
    const r = Math.cos(e), o = Math.sin(e), s = Math.sqrt, i = 1 / 3, u = s(i), l = r + (1 - r) * i, a = i * (1 - r) - u * o, c = i * (1 - r) + u * o, p = i * (1 - r) + u * o, d = r + i * (1 - r), h = i * (1 - r) - u * o, m = i * (1 - r) - u * o, g = i * (1 - r) + u * o, _ = r + i * (1 - r), b = [
      l,
      a,
      c,
      0,
      0,
      p,
      d,
      h,
      0,
      0,
      m,
      g,
      _,
      0,
      0,
      0,
      0,
      0,
      1,
      0
    ];
    this._loadMatrix(b, n);
  }
  /**
   * Set the contrast matrix, increase the separation between dark and bright
   * Increase contrast : shadows darker and highlights brighter
   * Decrease contrast : bring the shadows up and the highlights down
   * @param amount - value of the contrast (0-1)
   * @param multiply - if true, current matrix and matrix are multiplied. If false,
   *  just set the current matrix with @param matrix
   */
  contrast(e, n) {
    const r = (e || 0) + 1, o = -0.5 * (r - 1), s = [
      r,
      0,
      0,
      0,
      o,
      0,
      r,
      0,
      0,
      o,
      0,
      0,
      r,
      0,
      o,
      0,
      0,
      0,
      1,
      0
    ];
    this._loadMatrix(s, n);
  }
  /**
   * Set the saturation matrix, increase the separation between colors
   * Increase saturation : increase contrast, brightness, and sharpness
   * @param amount - The saturation amount (0-1)
   * @param multiply - if true, current matrix and matrix are multiplied. If false,
   *  just set the current matrix with @param matrix
   */
  saturate(e = 0, n) {
    const r = e * 2 / 3 + 1, o = (r - 1) * -0.5, s = [
      r,
      o,
      o,
      0,
      0,
      o,
      r,
      o,
      0,
      0,
      o,
      o,
      r,
      0,
      0,
      0,
      0,
      0,
      1,
      0
    ];
    this._loadMatrix(s, n);
  }
  /** Desaturate image (remove color) Call the saturate function */
  desaturate() {
    this.saturate(-1);
  }
  /**
   * Negative image (inverse of classic rgb matrix)
   * @param multiply - if true, current matrix and matrix are multiplied. If false,
   *  just set the current matrix with @param matrix
   */
  negative(e) {
    const n = [
      -1,
      0,
      0,
      1,
      0,
      0,
      -1,
      0,
      1,
      0,
      0,
      0,
      -1,
      1,
      0,
      0,
      0,
      0,
      1,
      0
    ];
    this._loadMatrix(n, e);
  }
  /**
   * Sepia image
   * @param multiply - if true, current matrix and matrix are multiplied. If false,
   *  just set the current matrix with @param matrix
   */
  sepia(e) {
    const n = [
      0.393,
      0.7689999,
      0.18899999,
      0,
      0,
      0.349,
      0.6859999,
      0.16799999,
      0,
      0,
      0.272,
      0.5339999,
      0.13099999,
      0,
      0,
      0,
      0,
      0,
      1,
      0
    ];
    this._loadMatrix(n, e);
  }
  /**
   * Color motion picture process invented in 1916 (thanks Dominic Szablewski)
   * @param multiply - if true, current matrix and matrix are multiplied. If false,
   *  just set the current matrix with @param matrix
   */
  technicolor(e) {
    const n = [
      1.9125277891456083,
      -0.8545344976951645,
      -0.09155508482755585,
      0,
      11.793603434377337,
      -0.3087833385928097,
      1.7658908555458428,
      -0.10601743074722245,
      0,
      -70.35205161461398,
      -0.231103377548616,
      -0.7501899197440212,
      1.847597816108189,
      0,
      30.950940869491138,
      0,
      0,
      0,
      1,
      0
    ];
    this._loadMatrix(n, e);
  }
  /**
   * Polaroid filter
   * @param multiply - if true, current matrix and matrix are multiplied. If false,
   *  just set the current matrix with @param matrix
   */
  polaroid(e) {
    const n = [
      1.438,
      -0.062,
      -0.062,
      0,
      0,
      -0.122,
      1.378,
      -0.122,
      0,
      0,
      -0.016,
      -0.016,
      1.483,
      0,
      0,
      0,
      0,
      0,
      1,
      0
    ];
    this._loadMatrix(n, e);
  }
  /**
   * Filter who transforms : Red -> Blue and Blue -> Red
   * @param multiply - if true, current matrix and matrix are multiplied. If false,
   *  just set the current matrix with @param matrix
   */
  toBGR(e) {
    const n = [
      0,
      0,
      1,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      1,
      0
    ];
    this._loadMatrix(n, e);
  }
  /**
   * Color reversal film introduced by Eastman Kodak in 1935. (thanks Dominic Szablewski)
   * @param multiply - if true, current matrix and matrix are multiplied. If false,
   *  just set the current matrix with @param matrix
   */
  kodachrome(e) {
    const n = [
      1.1285582396593525,
      -0.3967382283601348,
      -0.03992559172921793,
      0,
      63.72958762196502,
      -0.16404339962244616,
      1.0835251566291304,
      -0.05498805115633132,
      0,
      24.732407896706203,
      -0.16786010706155763,
      -0.5603416277695248,
      1.6014850761964943,
      0,
      35.62982807460946,
      0,
      0,
      0,
      1,
      0
    ];
    this._loadMatrix(n, e);
  }
  /**
   * Brown delicious browni filter (thanks Dominic Szablewski)
   * @param multiply - if true, current matrix and matrix are multiplied. If false,
   *  just set the current matrix with @param matrix
   */
  browni(e) {
    const n = [
      0.5997023498159715,
      0.34553243048391263,
      -0.2708298674538042,
      0,
      47.43192855600873,
      -0.037703249837783157,
      0.8609577587992641,
      0.15059552388459913,
      0,
      -36.96841498319127,
      0.24113635128153335,
      -0.07441037908422492,
      0.44972182064877153,
      0,
      -7.562075277591283,
      0,
      0,
      0,
      1,
      0
    ];
    this._loadMatrix(n, e);
  }
  /**
   * Vintage filter (thanks Dominic Szablewski)
   * @param multiply - if true, current matrix and matrix are multiplied. If false,
   *  just set the current matrix with @param matrix
   */
  vintage(e) {
    const n = [
      0.6279345635605994,
      0.3202183420819367,
      -0.03965408211312453,
      0,
      9.651285835294123,
      0.02578397704808868,
      0.6441188644374771,
      0.03259127616149294,
      0,
      7.462829176470591,
      0.0466055556782719,
      -0.0851232987247891,
      0.5241648018700465,
      0,
      5.159190588235296,
      0,
      0,
      0,
      1,
      0
    ];
    this._loadMatrix(n, e);
  }
  /**
   * We don't know exactly what it does, kind of gradient map, but funny to play with!
   * @param desaturation - Tone values.
   * @param toned - Tone values.
   * @param lightColor - Tone values, example: `0xFFE580`
   * @param darkColor - Tone values, example: `0xFFE580`
   * @param multiply - if true, current matrix and matrix are multiplied. If false,
   *  just set the current matrix with @param matrix
   */
  colorTone(e, n, r, o, s) {
    e = e || 0.2, n = n || 0.15, r = r || 16770432, o = o || 3375104;
    const i = Gn.shared, [u, l, a] = i.setValue(r).toArray(), [c, p, d] = i.setValue(o).toArray(), h = [
      0.3,
      0.59,
      0.11,
      0,
      0,
      u,
      l,
      a,
      e,
      0,
      c,
      p,
      d,
      n,
      0,
      u - c,
      l - p,
      a - d,
      0,
      0
    ];
    this._loadMatrix(h, s);
  }
  /**
   * Night effect
   * @param intensity - The intensity of the night effect.
   * @param multiply - if true, current matrix and matrix are multiplied. If false,
   *  just set the current matrix with @param matrix
   */
  night(e, n) {
    e = e || 0.1;
    const r = [
      e * -2,
      -e,
      0,
      0,
      0,
      -e,
      0,
      e,
      0,
      0,
      0,
      e,
      e * 2,
      0,
      0,
      0,
      0,
      0,
      1,
      0
    ];
    this._loadMatrix(r, n);
  }
  /**
   * Predator effect
   *
   * Erase the current matrix by setting a new indepent one
   * @param amount - how much the predator feels his future victim
   * @param multiply - if true, current matrix and matrix are multiplied. If false,
   *  just set the current matrix with @param matrix
   */
  predator(e, n) {
    const r = [
      // row 1
      11.224130630493164 * e,
      -4.794486999511719 * e,
      -2.8746118545532227 * e,
      0 * e,
      0.40342438220977783 * e,
      // row 2
      -3.6330697536468506 * e,
      9.193157196044922 * e,
      -2.951810836791992 * e,
      0 * e,
      -1.316135048866272 * e,
      // row 3
      -3.2184197902679443 * e,
      -4.2375030517578125 * e,
      7.476448059082031 * e,
      0 * e,
      0.8044459223747253 * e,
      // row 4
      0,
      0,
      0,
      1,
      0
    ];
    this._loadMatrix(r, n);
  }
  /**
   * LSD effect
   *
   * Multiply the current matrix
   * @param multiply - if true, current matrix and matrix are multiplied. If false,
   *  just set the current matrix with @param matrix
   */
  lsd(e) {
    const n = [
      2,
      -0.4,
      0.5,
      0,
      0,
      -0.5,
      2,
      -0.4,
      0,
      0,
      -0.4,
      -0.5,
      3,
      0,
      0,
      0,
      0,
      0,
      1,
      0
    ];
    this._loadMatrix(n, e);
  }
  /** Erase the current matrix by setting the default one. */
  reset() {
    const e = [
      1,
      0,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      0,
      1,
      0
    ];
    this._loadMatrix(e, !1);
  }
  /**
   * The matrix of the color matrix filter
   * @member {number[]}
   * @default [1, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1, 0]
   */
  get matrix() {
    return this.uniforms.m;
  }
  set matrix(e) {
    this.uniforms.m = e;
  }
  /**
   * The opacity value to use when mixing the original and resultant colors.
   *
   * When the value is 0, the original color is used without modification.
   * When the value is 1, the result color is used.
   * When in the range (0, 1) the color is interpolated between the original and result by this amount.
   * @default 1
   */
  get alpha() {
    return this.uniforms.uAlpha;
  }
  set alpha(e) {
    this.uniforms.uAlpha = e;
  }
}
_T.prototype.grayscale = _T.prototype.greyscale;
var lke = `varying vec2 vFilterCoord;
varying vec2 vTextureCoord;

uniform vec2 scale;
uniform mat2 rotation;
uniform sampler2D uSampler;
uniform sampler2D mapSampler;

uniform highp vec4 inputSize;
uniform vec4 inputClamp;

void main(void)
{
  vec4 map =  texture2D(mapSampler, vFilterCoord);

  map -= 0.5;
  map.xy = scale * inputSize.zw * (rotation * map.xy);

  gl_FragColor = texture2D(uSampler, clamp(vec2(vTextureCoord.x + map.x, vTextureCoord.y + map.y), inputClamp.xy, inputClamp.zw));
}
`, cke = `attribute vec2 aVertexPosition;

uniform mat3 projectionMatrix;
uniform mat3 filterMatrix;

varying vec2 vTextureCoord;
varying vec2 vFilterCoord;

uniform vec4 inputSize;
uniform vec4 outputFrame;

vec4 filterVertexPosition( void )
{
    vec2 position = aVertexPosition * max(outputFrame.zw, vec2(0.)) + outputFrame.xy;

    return vec4((projectionMatrix * vec3(position, 1.0)).xy, 0.0, 1.0);
}

vec2 filterTextureCoord( void )
{
    return aVertexPosition * (outputFrame.zw * inputSize.zw);
}

void main(void)
{
	gl_Position = filterVertexPosition();
	vTextureCoord = filterTextureCoord();
	vFilterCoord = ( filterMatrix * vec3( vTextureCoord, 1.0)  ).xy;
}
`;
class pke extends Jo {
  /**
   * @param {PIXI.Sprite} sprite - The sprite used for the displacement map. (make sure its added to the scene!)
   * @param scale - The scale of the displacement
   */
  constructor(e, n) {
    const r = new Qn();
    e.renderable = !1, super(cke, lke, {
      mapSampler: e._texture,
      filterMatrix: r,
      scale: { x: 1, y: 1 },
      rotation: new Float32Array([1, 0, 0, 1])
    }), this.maskSprite = e, this.maskMatrix = r, n == null && (n = 20), this.scale = new Rt(n, n);
  }
  /**
   * Applies the filter.
   * @param filterManager - The manager.
   * @param input - The input target.
   * @param output - The output target.
   * @param clearMode - clearMode.
   */
  apply(e, n, r, o) {
    this.uniforms.filterMatrix = e.calculateSpriteMatrix(this.maskMatrix, this.maskSprite), this.uniforms.scale.x = this.scale.x, this.uniforms.scale.y = this.scale.y;
    const s = this.maskSprite.worldTransform, i = Math.sqrt(s.a * s.a + s.b * s.b), u = Math.sqrt(s.c * s.c + s.d * s.d);
    i !== 0 && u !== 0 && (this.uniforms.rotation[0] = s.a / i, this.uniforms.rotation[1] = s.b / i, this.uniforms.rotation[2] = s.c / u, this.uniforms.rotation[3] = s.d / u), e.applyFilter(this, n, r, o);
  }
  /** The texture used for the displacement map. Must be power of 2 sized texture. */
  get map() {
    return this.uniforms.mapSampler;
  }
  set map(e) {
    this.uniforms.mapSampler = e;
  }
}
var dke = `varying vec2 v_rgbNW;
varying vec2 v_rgbNE;
varying vec2 v_rgbSW;
varying vec2 v_rgbSE;
varying vec2 v_rgbM;

varying vec2 vFragCoord;
uniform sampler2D uSampler;
uniform highp vec4 inputSize;


/**
 Basic FXAA implementation based on the code on geeks3d.com with the
 modification that the texture2DLod stuff was removed since it's
 unsupported by WebGL.

 --

 From:
 https://github.com/mitsuhiko/webgl-meincraft

 Copyright (c) 2011 by Armin Ronacher.

 Some rights reserved.

 Redistribution and use in source and binary forms, with or without
 modification, are permitted provided that the following conditions are
 met:

 * Redistributions of source code must retain the above copyright
 notice, this list of conditions and the following disclaimer.

 * Redistributions in binary form must reproduce the above
 copyright notice, this list of conditions and the following
 disclaimer in the documentation and/or other materials provided
 with the distribution.

 * The names of the contributors may not be used to endorse or
 promote products derived from this software without specific
 prior written permission.

 THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
 "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
 LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
 A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT
 OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
 SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
 LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE,
 DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY
 THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
 OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */

#ifndef FXAA_REDUCE_MIN
#define FXAA_REDUCE_MIN   (1.0/ 128.0)
#endif
#ifndef FXAA_REDUCE_MUL
#define FXAA_REDUCE_MUL   (1.0 / 8.0)
#endif
#ifndef FXAA_SPAN_MAX
#define FXAA_SPAN_MAX     8.0
#endif

//optimized version for mobile, where dependent
//texture reads can be a bottleneck
vec4 fxaa(sampler2D tex, vec2 fragCoord, vec2 inverseVP,
          vec2 v_rgbNW, vec2 v_rgbNE,
          vec2 v_rgbSW, vec2 v_rgbSE,
          vec2 v_rgbM) {
    vec4 color;
    vec3 rgbNW = texture2D(tex, v_rgbNW).xyz;
    vec3 rgbNE = texture2D(tex, v_rgbNE).xyz;
    vec3 rgbSW = texture2D(tex, v_rgbSW).xyz;
    vec3 rgbSE = texture2D(tex, v_rgbSE).xyz;
    vec4 texColor = texture2D(tex, v_rgbM);
    vec3 rgbM  = texColor.xyz;
    vec3 luma = vec3(0.299, 0.587, 0.114);
    float lumaNW = dot(rgbNW, luma);
    float lumaNE = dot(rgbNE, luma);
    float lumaSW = dot(rgbSW, luma);
    float lumaSE = dot(rgbSE, luma);
    float lumaM  = dot(rgbM,  luma);
    float lumaMin = min(lumaM, min(min(lumaNW, lumaNE), min(lumaSW, lumaSE)));
    float lumaMax = max(lumaM, max(max(lumaNW, lumaNE), max(lumaSW, lumaSE)));

    mediump vec2 dir;
    dir.x = -((lumaNW + lumaNE) - (lumaSW + lumaSE));
    dir.y =  ((lumaNW + lumaSW) - (lumaNE + lumaSE));

    float dirReduce = max((lumaNW + lumaNE + lumaSW + lumaSE) *
                          (0.25 * FXAA_REDUCE_MUL), FXAA_REDUCE_MIN);

    float rcpDirMin = 1.0 / (min(abs(dir.x), abs(dir.y)) + dirReduce);
    dir = min(vec2(FXAA_SPAN_MAX, FXAA_SPAN_MAX),
              max(vec2(-FXAA_SPAN_MAX, -FXAA_SPAN_MAX),
                  dir * rcpDirMin)) * inverseVP;

    vec3 rgbA = 0.5 * (
                       texture2D(tex, fragCoord * inverseVP + dir * (1.0 / 3.0 - 0.5)).xyz +
                       texture2D(tex, fragCoord * inverseVP + dir * (2.0 / 3.0 - 0.5)).xyz);
    vec3 rgbB = rgbA * 0.5 + 0.25 * (
                                     texture2D(tex, fragCoord * inverseVP + dir * -0.5).xyz +
                                     texture2D(tex, fragCoord * inverseVP + dir * 0.5).xyz);

    float lumaB = dot(rgbB, luma);
    if ((lumaB < lumaMin) || (lumaB > lumaMax))
        color = vec4(rgbA, texColor.a);
    else
        color = vec4(rgbB, texColor.a);
    return color;
}

void main() {

      vec4 color;

      color = fxaa(uSampler, vFragCoord, inputSize.zw, v_rgbNW, v_rgbNE, v_rgbSW, v_rgbSE, v_rgbM);

      gl_FragColor = color;
}
`, hke = `
attribute vec2 aVertexPosition;

uniform mat3 projectionMatrix;

varying vec2 v_rgbNW;
varying vec2 v_rgbNE;
varying vec2 v_rgbSW;
varying vec2 v_rgbSE;
varying vec2 v_rgbM;

varying vec2 vFragCoord;

uniform vec4 inputSize;
uniform vec4 outputFrame;

vec4 filterVertexPosition( void )
{
    vec2 position = aVertexPosition * max(outputFrame.zw, vec2(0.)) + outputFrame.xy;

    return vec4((projectionMatrix * vec3(position, 1.0)).xy, 0.0, 1.0);
}

void texcoords(vec2 fragCoord, vec2 inverseVP,
               out vec2 v_rgbNW, out vec2 v_rgbNE,
               out vec2 v_rgbSW, out vec2 v_rgbSE,
               out vec2 v_rgbM) {
    v_rgbNW = (fragCoord + vec2(-1.0, -1.0)) * inverseVP;
    v_rgbNE = (fragCoord + vec2(1.0, -1.0)) * inverseVP;
    v_rgbSW = (fragCoord + vec2(-1.0, 1.0)) * inverseVP;
    v_rgbSE = (fragCoord + vec2(1.0, 1.0)) * inverseVP;
    v_rgbM = vec2(fragCoord * inverseVP);
}

void main(void) {

   gl_Position = filterVertexPosition();

   vFragCoord = aVertexPosition * outputFrame.zw;

   texcoords(vFragCoord, inputSize.zw, v_rgbNW, v_rgbNE, v_rgbSW, v_rgbSE, v_rgbM);
}
`;
class fke extends Jo {
  constructor() {
    super(hke, dke);
  }
}
var mke = `precision highp float;

varying vec2 vTextureCoord;
varying vec4 vColor;

uniform float uNoise;
uniform float uSeed;
uniform sampler2D uSampler;

float rand(vec2 co)
{
    return fract(sin(dot(co.xy, vec2(12.9898, 78.233))) * 43758.5453);
}

void main()
{
    vec4 color = texture2D(uSampler, vTextureCoord);
    float randomValue = rand(gl_FragCoord.xy * uSeed);
    float diff = (randomValue - 0.5) * uNoise;

    // Un-premultiply alpha before applying the color matrix. See issue #3539.
    if (color.a > 0.0) {
        color.rgb /= color.a;
    }

    color.r += diff;
    color.g += diff;
    color.b += diff;

    // Premultiply alpha again.
    color.rgb *= color.a;

    gl_FragColor = color;
}
`;
class yke extends Jo {
  /**
   * @param {number} [noise=0.5] - The noise intensity, should be a normalized value in the range [0, 1].
   * @param {number} [seed] - A random seed for the noise generation. Default is `Math.random()`.
   */
  constructor(e = 0.5, n = Math.random()) {
    super(UB, mke, {
      uNoise: 0,
      uSeed: 0
    }), this.noise = e, this.seed = n;
  }
  /**
   * The amount of noise to apply, this value should be in the range (0, 1].
   * @default 0.5
   */
  get noise() {
    return this.uniforms.uNoise;
  }
  set noise(e) {
    this.uniforms.uNoise = e;
  }
  /** A seed value to apply to the random noise generation. `Math.random()` is a good value to use. */
  get seed() {
    return this.uniforms.uSeed;
  }
  set seed(e) {
    this.uniforms.uSeed = e;
  }
}
const $C = {
  /**
   * @class
   * @memberof PIXI.filters
   * @deprecated since 7.1.0
   * @see PIXI.AlphaFilter
   */
  AlphaFilter: tke,
  /**
   * @class
   * @memberof PIXI.filters
   * @deprecated since 7.1.0
   * @see PIXI.BlurFilter
   */
  BlurFilter: ike,
  /**
   * @class
   * @memberof PIXI.filters
   * @deprecated since 7.1.0
   * @see PIXI.BlurFilterPass
   */
  BlurFilterPass: vT,
  /**
   * @class
   * @memberof PIXI.filters
   * @deprecated since 7.1.0
   * @see PIXI.ColorMatrixFilter
   */
  ColorMatrixFilter: _T,
  /**
   * @class
   * @memberof PIXI.filters
   * @deprecated since 7.1.0
   * @see PIXI.DisplacementFilter
   */
  DisplacementFilter: pke,
  /**
   * @class
   * @memberof PIXI.filters
   * @deprecated since 7.1.0
   * @see PIXI.FXAAFilter
   */
  FXAAFilter: fke,
  /**
   * @class
   * @memberof PIXI.filters
   * @deprecated since 7.1.0
   * @see PIXI.NoiseFilter
   */
  NoiseFilter: yke
};
Object.entries($C).forEach(([t, e]) => {
  Object.defineProperty($C, t, {
    get() {
      return un("7.1.0", `filters.${t} has moved to ${t}`), e;
    }
  });
});
class gke {
  constructor() {
    this.interactionFrequency = 10, this._deltaTime = 0, this._didMove = !1, this.tickerAdded = !1, this._pauseUpdate = !0;
  }
  /**
   * Initializes the event ticker.
   * @param events - The event system.
   */
  init(e) {
    this.removeTickerListener(), this.events = e, this.interactionFrequency = 10, this._deltaTime = 0, this._didMove = !1, this.tickerAdded = !1, this._pauseUpdate = !0;
  }
  /** Whether to pause the update checks or not. */
  get pauseUpdate() {
    return this._pauseUpdate;
  }
  set pauseUpdate(e) {
    this._pauseUpdate = e;
  }
  /** Adds the ticker listener. */
  addTickerListener() {
    this.tickerAdded || !this.domElement || (es.system.add(this.tickerUpdate, this, Xp.INTERACTION), this.tickerAdded = !0);
  }
  /** Removes the ticker listener. */
  removeTickerListener() {
    this.tickerAdded && (es.system.remove(this.tickerUpdate, this), this.tickerAdded = !1);
  }
  /** Sets flag to not fire extra events when the user has already moved there mouse */
  pointerMoved() {
    this._didMove = !0;
  }
  /** Updates the state of interactive objects. */
  update() {
    if (!this.domElement || this._pauseUpdate)
      return;
    if (this._didMove) {
      this._didMove = !1;
      return;
    }
    const e = this.events.rootPointerEvent;
    this.events.supportsTouchEvents && e.pointerType === "touch" || globalThis.document.dispatchEvent(new PointerEvent("pointermove", {
      clientX: e.clientX,
      clientY: e.clientY
    }));
  }
  /**
   * Updates the state of interactive objects if at least {@link interactionFrequency}
   * milliseconds have passed since the last invocation.
   *
   * Invoked by a throttled ticker update from {@link PIXI.Ticker.system}.
   * @param deltaTime - time delta since the last call
   */
  tickerUpdate(e) {
    this._deltaTime += e, !(this._deltaTime < this.interactionFrequency) && (this._deltaTime = 0, this.update());
  }
}
const Ql = new gke();
class ly {
  /**
   * @param manager - The event boundary which manages this event. Propagation can only occur
   *  within the boundary's jurisdiction.
   */
  constructor(e) {
    this.bubbles = !0, this.cancelBubble = !0, this.cancelable = !1, this.composed = !1, this.defaultPrevented = !1, this.eventPhase = ly.prototype.NONE, this.propagationStopped = !1, this.propagationImmediatelyStopped = !1, this.layer = new Rt(), this.page = new Rt(), this.NONE = 0, this.CAPTURING_PHASE = 1, this.AT_TARGET = 2, this.BUBBLING_PHASE = 3, this.manager = e;
  }
  /** @readonly */
  get layerX() {
    return this.layer.x;
  }
  /** @readonly */
  get layerY() {
    return this.layer.y;
  }
  /** @readonly */
  get pageX() {
    return this.page.x;
  }
  /** @readonly */
  get pageY() {
    return this.page.y;
  }
  /**
   * Fallback for the deprecated @code{PIXI.InteractionEvent.data}.
   * @deprecated since 7.0.0
   */
  get data() {
    return this;
  }
  /** The propagation path for this event. Alias for {@link PIXI.EventBoundary.propagationPath}. */
  composedPath() {
    return this.manager && (!this.path || this.path[this.path.length - 1] !== this.target) && (this.path = this.target ? this.manager.propagationPath(this.target) : []), this.path;
  }
  /**
   * Unimplemented method included for implementing the DOM interface {@code Event}. It will throw an {@code Error}.
   * @deprecated
   * @param _type
   * @param _bubbles
   * @param _cancelable
   */
  initEvent(e, n, r) {
    throw new Error("initEvent() is a legacy DOM API. It is not implemented in the Federated Events API.");
  }
  /**
   * Unimplemented method included for implementing the DOM interface {@code UIEvent}. It will throw an {@code Error}.
   * @deprecated
   * @param _typeArg
   * @param _bubblesArg
   * @param _cancelableArg
   * @param _viewArg
   * @param _detailArg
   */
  initUIEvent(e, n, r, o, s) {
    throw new Error("initUIEvent() is a legacy DOM API. It is not implemented in the Federated Events API.");
  }
  /** Prevent default behavior of PixiJS and the user agent. */
  preventDefault() {
    this.nativeEvent instanceof Event && this.nativeEvent.cancelable && this.nativeEvent.preventDefault(), this.defaultPrevented = !0;
  }
  /**
   * Stop this event from propagating to any addition listeners, including on the
   * {@link PIXI.FederatedEventTarget.currentTarget currentTarget} and also the following
   * event targets on the propagation path.
   */
  stopImmediatePropagation() {
    this.propagationImmediatelyStopped = !0;
  }
  /**
   * Stop this event from propagating to the next {@link PIXI.FederatedEventTarget}. The rest of the listeners
   * on the {@link PIXI.FederatedEventTarget.currentTarget currentTarget} will still be notified.
   */
  stopPropagation() {
    this.propagationStopped = !0;
  }
}
class pv extends ly {
  constructor() {
    super(...arguments), this.client = new Rt(), this.movement = new Rt(), this.offset = new Rt(), this.global = new Rt(), this.screen = new Rt();
  }
  /** @readonly */
  get clientX() {
    return this.client.x;
  }
  /** @readonly */
  get clientY() {
    return this.client.y;
  }
  /**
   * Alias for {@link PIXI.FederatedMouseEvent.clientX this.clientX}.
   * @readonly
   */
  get x() {
    return this.clientX;
  }
  /**
   * Alias for {@link PIXI.FederatedMouseEvent.clientY this.clientY}.
   * @readonly
   */
  get y() {
    return this.clientY;
  }
  /** @readonly */
  get movementX() {
    return this.movement.x;
  }
  /** @readonly */
  get movementY() {
    return this.movement.y;
  }
  /** @readonly */
  get offsetX() {
    return this.offset.x;
  }
  /** @readonly */
  get offsetY() {
    return this.offset.y;
  }
  /** @readonly */
  get globalX() {
    return this.global.x;
  }
  /** @readonly */
  get globalY() {
    return this.global.y;
  }
  /**
   * The pointer coordinates in the renderer's screen. Alias for {@code screen.x}.
   * @readonly
   */
  get screenX() {
    return this.screen.x;
  }
  /**
   * The pointer coordinates in the renderer's screen. Alias for {@code screen.y}.
   * @readonly
   */
  get screenY() {
    return this.screen.y;
  }
  /**
   * This will return the local coordinates of the specified displayObject for this InteractionData
   * @param {PIXI.DisplayObject} displayObject - The DisplayObject that you would like the local
   *  coords off
   * @param {PIXI.IPointData} point - A Point object in which to store the value, optional (otherwise
   *  will create a new point)
   * @param {PIXI.IPointData} globalPos - A Point object containing your custom global coords, optional
   *  (otherwise will use the current global coords)
   * @returns - A point containing the coordinates of the InteractionData position relative
   *  to the DisplayObject
   */
  getLocalPosition(e, n, r) {
    return e.worldTransform.applyInverse(r || this.global, n);
  }
  /**
   * Whether the modifier key was pressed when this event natively occurred.
   * @param key - The modifier key.
   */
  getModifierState(e) {
    return "getModifierState" in this.nativeEvent && this.nativeEvent.getModifierState(e);
  }
  /**
   * Not supported.
   * @param _typeArg
   * @param _canBubbleArg
   * @param _cancelableArg
   * @param _viewArg
   * @param _detailArg
   * @param _screenXArg
   * @param _screenYArg
   * @param _clientXArg
   * @param _clientYArg
   * @param _ctrlKeyArg
   * @param _altKeyArg
   * @param _shiftKeyArg
   * @param _metaKeyArg
   * @param _buttonArg
   * @param _relatedTargetArg
   * @deprecated since 7.0.0
   */
  // eslint-disable-next-line max-params
  initMouseEvent(e, n, r, o, s, i, u, l, a, c, p, d, h, m, g) {
    throw new Error("Method not implemented.");
  }
}
class ni extends pv {
  constructor() {
    super(...arguments), this.width = 0, this.height = 0, this.isPrimary = !1;
  }
  // Only included for completeness for now
  getCoalescedEvents() {
    return this.type === "pointermove" || this.type === "mousemove" || this.type === "touchmove" ? [this] : [];
  }
  // Only included for completeness for now
  getPredictedEvents() {
    throw new Error("getPredictedEvents is not supported!");
  }
}
class Kd extends pv {
  constructor() {
    super(...arguments), this.DOM_DELTA_PIXEL = 0, this.DOM_DELTA_LINE = 1, this.DOM_DELTA_PAGE = 2;
  }
}
Kd.DOM_DELTA_PIXEL = 0, /** Units specified in lines. */
Kd.DOM_DELTA_LINE = 1, /** Units specified in pages. */
Kd.DOM_DELTA_PAGE = 2;
const vke = 2048, _ke = new Rt(), Tb = new Rt();
class wke {
  /**
   * @param rootTarget - The holder of the event boundary.
   */
  constructor(e) {
    this.dispatch = new uy(), this.moveOnAll = !1, this.enableGlobalMoveEvents = !0, this.mappingState = {
      trackingData: {}
    }, this.eventPool = /* @__PURE__ */ new Map(), this._allInteractiveElements = [], this._hitElements = [], this._isPointerMoveEvent = !1, this.rootTarget = e, this.hitPruneFn = this.hitPruneFn.bind(this), this.hitTestFn = this.hitTestFn.bind(this), this.mapPointerDown = this.mapPointerDown.bind(this), this.mapPointerMove = this.mapPointerMove.bind(this), this.mapPointerOut = this.mapPointerOut.bind(this), this.mapPointerOver = this.mapPointerOver.bind(this), this.mapPointerUp = this.mapPointerUp.bind(this), this.mapPointerUpOutside = this.mapPointerUpOutside.bind(this), this.mapWheel = this.mapWheel.bind(this), this.mappingTable = {}, this.addEventMapping("pointerdown", this.mapPointerDown), this.addEventMapping("pointermove", this.mapPointerMove), this.addEventMapping("pointerout", this.mapPointerOut), this.addEventMapping("pointerleave", this.mapPointerOut), this.addEventMapping("pointerover", this.mapPointerOver), this.addEventMapping("pointerup", this.mapPointerUp), this.addEventMapping("pointerupoutside", this.mapPointerUpOutside), this.addEventMapping("wheel", this.mapWheel);
  }
  /**
   * Adds an event mapping for the event `type` handled by `fn`.
   *
   * Event mappings can be used to implement additional or custom events. They take an event
   * coming from the upstream scene (or directly from the {@link PIXI.EventSystem}) and dispatch new downstream events
   * generally trickling down and bubbling up to {@link PIXI.EventBoundary.rootTarget this.rootTarget}.
   *
   * To modify the semantics of existing events, the built-in mapping methods of EventBoundary should be overridden
   * instead.
   * @param type - The type of upstream event to map.
   * @param fn - The mapping method. The context of this function must be bound manually, if desired.
   */
  addEventMapping(e, n) {
    this.mappingTable[e] || (this.mappingTable[e] = []), this.mappingTable[e].push({
      fn: n,
      priority: 0
    }), this.mappingTable[e].sort((r, o) => r.priority - o.priority);
  }
  /**
   * Dispatches the given event
   * @param e
   * @param type
   */
  dispatchEvent(e, n) {
    e.propagationStopped = !1, e.propagationImmediatelyStopped = !1, this.propagate(e, n), this.dispatch.emit(n || e.type, e);
  }
  /**
   * Maps the given upstream event through the event boundary and propagates it downstream.
   * @param e
   */
  mapEvent(e) {
    if (!this.rootTarget)
      return;
    const n = this.mappingTable[e.type];
    if (n)
      for (let r = 0, o = n.length; r < o; r++)
        n[r].fn(e);
    else
      console.warn(`[EventBoundary]: Event mapping not defined for ${e.type}`);
  }
  /**
   * Finds the DisplayObject that is the target of a event at the given coordinates.
   *
   * The passed (x,y) coordinates are in the world space above this event boundary.
   * @param x
   * @param y
   */
  hitTest(e, n) {
    Ql.pauseUpdate = !0;
    const r = this._isPointerMoveEvent && this.enableGlobalMoveEvents ? "hitTestMoveRecursive" : "hitTestRecursive", o = this[r](
      this.rootTarget,
      this.rootTarget.eventMode,
      _ke.set(e, n),
      this.hitTestFn,
      this.hitPruneFn
    );
    return o && o[0];
  }
  /**
   * Propagate the passed event from from {@link PIXI.EventBoundary.rootTarget this.rootTarget} to its
   * target {@code e.target}.
   * @param e - The event to propagate.
   * @param type
   */
  propagate(e, n) {
    if (!e.target)
      return;
    const r = e.composedPath();
    e.eventPhase = e.CAPTURING_PHASE;
    for (let o = 0, s = r.length - 1; o < s; o++)
      if (e.currentTarget = r[o], this.notifyTarget(e, n), e.propagationStopped || e.propagationImmediatelyStopped)
        return;
    if (e.eventPhase = e.AT_TARGET, e.currentTarget = e.target, this.notifyTarget(e, n), !(e.propagationStopped || e.propagationImmediatelyStopped)) {
      e.eventPhase = e.BUBBLING_PHASE;
      for (let o = r.length - 2; o >= 0; o--)
        if (e.currentTarget = r[o], this.notifyTarget(e, n), e.propagationStopped || e.propagationImmediatelyStopped)
          return;
    }
  }
  /**
   * Emits the event {@code e} to all interactive display objects. The event is propagated in the bubbling phase always.
   *
   * This is used in the `globalpointermove` event.
   * @param e - The emitted event.
   * @param type - The listeners to notify.
   * @param targets - The targets to notify.
   */
  all(e, n, r = this._allInteractiveElements) {
    if (r.length === 0)
      return;
    e.eventPhase = e.BUBBLING_PHASE;
    const o = Array.isArray(n) ? n : [n];
    for (let s = r.length - 1; s >= 0; s--)
      o.forEach((i) => {
        e.currentTarget = r[s], this.notifyTarget(e, i);
      });
  }
  /**
   * Finds the propagation path from {@link PIXI.EventBoundary.rootTarget rootTarget} to the passed
   * {@code target}. The last element in the path is {@code target}.
   * @param target
   */
  propagationPath(e) {
    const n = [e];
    for (let r = 0; r < vke && e !== this.rootTarget; r++) {
      if (!e.parent)
        throw new Error("Cannot find propagation path to disconnected target");
      n.push(e.parent), e = e.parent;
    }
    return n.reverse(), n;
  }
  hitTestMoveRecursive(e, n, r, o, s, i = !1) {
    let u = !1;
    if (this._interactivePrune(e))
      return null;
    if ((e.eventMode === "dynamic" || n === "dynamic") && (Ql.pauseUpdate = !1), e.interactiveChildren && e.children) {
      const c = e.children;
      for (let p = c.length - 1; p >= 0; p--) {
        const d = c[p], h = this.hitTestMoveRecursive(
          d,
          this._isInteractive(n) ? n : d.eventMode,
          r,
          o,
          s,
          i || s(e, r)
        );
        if (h) {
          if (h.length > 0 && !h[h.length - 1].parent)
            continue;
          const m = e.isInteractive();
          (h.length > 0 || m) && (m && this._allInteractiveElements.push(e), h.push(e)), this._hitElements.length === 0 && (this._hitElements = h), u = !0;
        }
      }
    }
    const l = this._isInteractive(n), a = e.isInteractive();
    return l && a && this._allInteractiveElements.push(e), i || this._hitElements.length > 0 ? null : u ? this._hitElements : l && !s(e, r) && o(e, r) ? a ? [e] : [] : null;
  }
  /**
   * Recursive implementation for {@link PIXI.EventBoundary.hitTest hitTest}.
   * @param currentTarget - The DisplayObject that is to be hit tested.
   * @param eventMode - The event mode for the `currentTarget` or one of its parents.
   * @param location - The location that is being tested for overlap.
   * @param testFn - Callback that determines whether the target passes hit testing. This callback
   *  can assume that `pruneFn` failed to prune the display object.
   * @param pruneFn - Callback that determiness whether the target and all of its children
   *  cannot pass the hit test. It is used as a preliminary optimization to prune entire subtrees
   *  of the scene graph.
   * @returns An array holding the hit testing target and all its ancestors in order. The first element
   *  is the target itself and the last is {@link PIXI.EventBoundary.rootTarget rootTarget}. This is the opposite
   *  order w.r.t. the propagation path. If no hit testing target is found, null is returned.
   */
  hitTestRecursive(e, n, r, o, s) {
    if (this._interactivePrune(e) || s(e, r))
      return null;
    if ((e.eventMode === "dynamic" || n === "dynamic") && (Ql.pauseUpdate = !1), e.interactiveChildren && e.children) {
      const l = e.children;
      for (let a = l.length - 1; a >= 0; a--) {
        const c = l[a], p = this.hitTestRecursive(
          c,
          this._isInteractive(n) ? n : c.eventMode,
          r,
          o,
          s
        );
        if (p) {
          if (p.length > 0 && !p[p.length - 1].parent)
            continue;
          const d = e.isInteractive();
          return (p.length > 0 || d) && p.push(e), p;
        }
      }
    }
    const i = this._isInteractive(n), u = e.isInteractive();
    return i && o(e, r) ? u ? [e] : [] : null;
  }
  _isInteractive(e) {
    return e === "static" || e === "dynamic";
  }
  _interactivePrune(e) {
    return !!(!e || e.isMask || !e.visible || !e.renderable || e.eventMode === "none" || e.eventMode === "passive" && !e.interactiveChildren || e.isMask);
  }
  /**
   * Checks whether the display object or any of its children cannot pass the hit test at all.
   *
   * {@link PIXI.EventBoundary}'s implementation uses the {@link PIXI.DisplayObject.hitArea hitArea}
   * and {@link PIXI.DisplayObject._mask} for pruning.
   * @param displayObject
   * @param location
   */
  hitPruneFn(e, n) {
    if (e.hitArea && (e.worldTransform.applyInverse(n, Tb), !e.hitArea.contains(Tb.x, Tb.y)))
      return !0;
    if (e._mask) {
      const r = e._mask.isMaskData ? e._mask.maskObject : e._mask;
      if (r && !r.containsPoint?.(n))
        return !0;
    }
    return !1;
  }
  /**
   * Checks whether the display object passes hit testing for the given location.
   * @param displayObject
   * @param location
   * @returns - Whether `displayObject` passes hit testing for `location`.
   */
  hitTestFn(e, n) {
    return e.eventMode === "passive" ? !1 : e.hitArea ? !0 : e.containsPoint ? e.containsPoint(n) : !1;
  }
  /**
   * Notify all the listeners to the event's `currentTarget`.
   *
   * If the `currentTarget` contains the property `on<type>`, then it is called here,
   * simulating the behavior from version 6.x and prior.
   * @param e - The event passed to the target.
   * @param type
   */
  notifyTarget(e, n) {
    n = n ?? e.type;
    const r = `on${n}`;
    e.currentTarget[r]?.(e);
    const o = e.eventPhase === e.CAPTURING_PHASE || e.eventPhase === e.AT_TARGET ? `${n}capture` : n;
    this.notifyListeners(e, o), e.eventPhase === e.AT_TARGET && this.notifyListeners(e, n);
  }
  /**
   * Maps the upstream `pointerdown` events to a downstream `pointerdown` event.
   *
   * `touchstart`, `rightdown`, `mousedown` events are also dispatched for specific pointer types.
   * @param from
   */
  mapPointerDown(e) {
    if (!(e instanceof ni)) {
      console.warn("EventBoundary cannot map a non-pointer event as a pointer event");
      return;
    }
    const n = this.createPointerEvent(e);
    if (this.dispatchEvent(n, "pointerdown"), n.pointerType === "touch")
      this.dispatchEvent(n, "touchstart");
    else if (n.pointerType === "mouse" || n.pointerType === "pen") {
      const o = n.button === 2;
      this.dispatchEvent(n, o ? "rightdown" : "mousedown");
    }
    const r = this.trackingData(e.pointerId);
    r.pressTargetsByButton[e.button] = n.composedPath(), this.freeEvent(n);
  }
  /**
   * Maps the upstream `pointermove` to downstream `pointerout`, `pointerover`, and `pointermove` events, in that order.
   *
   * The tracking data for the specific pointer has an updated `overTarget`. `mouseout`, `mouseover`,
   * `mousemove`, and `touchmove` events are fired as well for specific pointer types.
   * @param from - The upstream `pointermove` event.
   */
  mapPointerMove(e) {
    if (!(e instanceof ni)) {
      console.warn("EventBoundary cannot map a non-pointer event as a pointer event");
      return;
    }
    this._allInteractiveElements.length = 0, this._hitElements.length = 0, this._isPointerMoveEvent = !0;
    const n = this.createPointerEvent(e);
    this._isPointerMoveEvent = !1;
    const r = n.pointerType === "mouse" || n.pointerType === "pen", o = this.trackingData(e.pointerId), s = this.findMountedTarget(o.overTargets);
    if (o.overTargets?.length > 0 && s !== n.target) {
      const l = e.type === "mousemove" ? "mouseout" : "pointerout", a = this.createPointerEvent(e, l, s);
      if (this.dispatchEvent(a, "pointerout"), r && this.dispatchEvent(a, "mouseout"), !n.composedPath().includes(s)) {
        const c = this.createPointerEvent(e, "pointerleave", s);
        for (c.eventPhase = c.AT_TARGET; c.target && !n.composedPath().includes(c.target); )
          c.currentTarget = c.target, this.notifyTarget(c), r && this.notifyTarget(c, "mouseleave"), c.target = c.target.parent;
        this.freeEvent(c);
      }
      this.freeEvent(a);
    }
    if (s !== n.target) {
      const l = e.type === "mousemove" ? "mouseover" : "pointerover", a = this.clonePointerEvent(n, l);
      this.dispatchEvent(a, "pointerover"), r && this.dispatchEvent(a, "mouseover");
      let c = s?.parent;
      for (; c && c !== this.rootTarget.parent && c !== n.target; )
        c = c.parent;
      if (!c || c === this.rootTarget.parent) {
        const p = this.clonePointerEvent(n, "pointerenter");
        for (p.eventPhase = p.AT_TARGET; p.target && p.target !== s && p.target !== this.rootTarget.parent; )
          p.currentTarget = p.target, this.notifyTarget(p), r && this.notifyTarget(p, "mouseenter"), p.target = p.target.parent;
        this.freeEvent(p);
      }
      this.freeEvent(a);
    }
    const i = [], u = this.enableGlobalMoveEvents ?? !0;
    this.moveOnAll ? i.push("pointermove") : this.dispatchEvent(n, "pointermove"), u && i.push("globalpointermove"), n.pointerType === "touch" && (this.moveOnAll ? i.splice(1, 0, "touchmove") : this.dispatchEvent(n, "touchmove"), u && i.push("globaltouchmove")), r && (this.moveOnAll ? i.splice(1, 0, "mousemove") : this.dispatchEvent(n, "mousemove"), u && i.push("globalmousemove"), this.cursor = n.target?.cursor), i.length > 0 && this.all(n, i), this._allInteractiveElements.length = 0, this._hitElements.length = 0, o.overTargets = n.composedPath(), this.freeEvent(n);
  }
  /**
   * Maps the upstream `pointerover` to downstream `pointerover` and `pointerenter` events, in that order.
   *
   * The tracking data for the specific pointer gets a new `overTarget`.
   * @param from - The upstream `pointerover` event.
   */
  mapPointerOver(e) {
    if (!(e instanceof ni)) {
      console.warn("EventBoundary cannot map a non-pointer event as a pointer event");
      return;
    }
    const n = this.trackingData(e.pointerId), r = this.createPointerEvent(e), o = r.pointerType === "mouse" || r.pointerType === "pen";
    this.dispatchEvent(r, "pointerover"), o && this.dispatchEvent(r, "mouseover"), r.pointerType === "mouse" && (this.cursor = r.target?.cursor);
    const s = this.clonePointerEvent(r, "pointerenter");
    for (s.eventPhase = s.AT_TARGET; s.target && s.target !== this.rootTarget.parent; )
      s.currentTarget = s.target, this.notifyTarget(s), o && this.notifyTarget(s, "mouseenter"), s.target = s.target.parent;
    n.overTargets = r.composedPath(), this.freeEvent(r), this.freeEvent(s);
  }
  /**
   * Maps the upstream `pointerout` to downstream `pointerout`, `pointerleave` events, in that order.
   *
   * The tracking data for the specific pointer is cleared of a `overTarget`.
   * @param from - The upstream `pointerout` event.
   */
  mapPointerOut(e) {
    if (!(e instanceof ni)) {
      console.warn("EventBoundary cannot map a non-pointer event as a pointer event");
      return;
    }
    const n = this.trackingData(e.pointerId);
    if (n.overTargets) {
      const r = e.pointerType === "mouse" || e.pointerType === "pen", o = this.findMountedTarget(n.overTargets), s = this.createPointerEvent(e, "pointerout", o);
      this.dispatchEvent(s), r && this.dispatchEvent(s, "mouseout");
      const i = this.createPointerEvent(e, "pointerleave", o);
      for (i.eventPhase = i.AT_TARGET; i.target && i.target !== this.rootTarget.parent; )
        i.currentTarget = i.target, this.notifyTarget(i), r && this.notifyTarget(i, "mouseleave"), i.target = i.target.parent;
      n.overTargets = null, this.freeEvent(s), this.freeEvent(i);
    }
    this.cursor = null;
  }
  /**
   * Maps the upstream `pointerup` event to downstream `pointerup`, `pointerupoutside`,
   * and `click`/`rightclick`/`pointertap` events, in that order.
   *
   * The `pointerupoutside` event bubbles from the original `pointerdown` target to the most specific
   * ancestor of the `pointerdown` and `pointerup` targets, which is also the `click` event's target. `touchend`,
   * `rightup`, `mouseup`, `touchendoutside`, `rightupoutside`, `mouseupoutside`, and `tap` are fired as well for
   * specific pointer types.
   * @param from - The upstream `pointerup` event.
   */
  mapPointerUp(e) {
    if (!(e instanceof ni)) {
      console.warn("EventBoundary cannot map a non-pointer event as a pointer event");
      return;
    }
    const n = performance.now(), r = this.createPointerEvent(e);
    if (this.dispatchEvent(r, "pointerup"), r.pointerType === "touch")
      this.dispatchEvent(r, "touchend");
    else if (r.pointerType === "mouse" || r.pointerType === "pen") {
      const u = r.button === 2;
      this.dispatchEvent(r, u ? "rightup" : "mouseup");
    }
    const o = this.trackingData(e.pointerId), s = this.findMountedTarget(o.pressTargetsByButton[e.button]);
    let i = s;
    if (s && !r.composedPath().includes(s)) {
      let u = s;
      for (; u && !r.composedPath().includes(u); ) {
        if (r.currentTarget = u, this.notifyTarget(r, "pointerupoutside"), r.pointerType === "touch")
          this.notifyTarget(r, "touchendoutside");
        else if (r.pointerType === "mouse" || r.pointerType === "pen") {
          const l = r.button === 2;
          this.notifyTarget(r, l ? "rightupoutside" : "mouseupoutside");
        }
        u = u.parent;
      }
      delete o.pressTargetsByButton[e.button], i = u;
    }
    if (i) {
      const u = this.clonePointerEvent(r, "click");
      u.target = i, u.path = null, o.clicksByButton[e.button] || (o.clicksByButton[e.button] = {
        clickCount: 0,
        target: u.target,
        timeStamp: n
      });
      const l = o.clicksByButton[e.button];
      if (l.target === u.target && n - l.timeStamp < 200 ? ++l.clickCount : l.clickCount = 1, l.target = u.target, l.timeStamp = n, u.detail = l.clickCount, u.pointerType === "mouse") {
        const a = u.button === 2;
        this.dispatchEvent(u, a ? "rightclick" : "click");
      } else
        u.pointerType === "touch" && this.dispatchEvent(u, "tap");
      this.dispatchEvent(u, "pointertap"), this.freeEvent(u);
    }
    this.freeEvent(r);
  }
  /**
   * Maps the upstream `pointerupoutside` event to a downstream `pointerupoutside` event, bubbling from the original
   * `pointerdown` target to `rootTarget`.
   *
   * (The most specific ancestor of the `pointerdown` event and the `pointerup` event must the
   * `{@link PIXI.EventBoundary}'s root because the `pointerup` event occurred outside of the boundary.)
   *
   * `touchendoutside`, `mouseupoutside`, and `rightupoutside` events are fired as well for specific pointer
   * types. The tracking data for the specific pointer is cleared of a `pressTarget`.
   * @param from - The upstream `pointerupoutside` event.
   */
  mapPointerUpOutside(e) {
    if (!(e instanceof ni)) {
      console.warn("EventBoundary cannot map a non-pointer event as a pointer event");
      return;
    }
    const n = this.trackingData(e.pointerId), r = this.findMountedTarget(n.pressTargetsByButton[e.button]), o = this.createPointerEvent(e);
    if (r) {
      let s = r;
      for (; s; )
        o.currentTarget = s, this.notifyTarget(o, "pointerupoutside"), o.pointerType === "touch" ? this.notifyTarget(o, "touchendoutside") : (o.pointerType === "mouse" || o.pointerType === "pen") && this.notifyTarget(o, o.button === 2 ? "rightupoutside" : "mouseupoutside"), s = s.parent;
      delete n.pressTargetsByButton[e.button];
    }
    this.freeEvent(o);
  }
  /**
   * Maps the upstream `wheel` event to a downstream `wheel` event.
   * @param from - The upstream `wheel` event.
   */
  mapWheel(e) {
    if (!(e instanceof Kd)) {
      console.warn("EventBoundary cannot map a non-wheel event as a wheel event");
      return;
    }
    const n = this.createWheelEvent(e);
    this.dispatchEvent(n), this.freeEvent(n);
  }
  /**
   * Finds the most specific event-target in the given propagation path that is still mounted in the scene graph.
   *
   * This is used to find the correct `pointerup` and `pointerout` target in the case that the original `pointerdown`
   * or `pointerover` target was unmounted from the scene graph.
   * @param propagationPath - The propagation path was valid in the past.
   * @returns - The most specific event-target still mounted at the same location in the scene graph.
   */
  findMountedTarget(e) {
    if (!e)
      return null;
    let n = e[0];
    for (let r = 1; r < e.length && e[r].parent === n; r++)
      n = e[r];
    return n;
  }
  /**
   * Creates an event whose {@code originalEvent} is {@code from}, with an optional `type` and `target` override.
   *
   * The event is allocated using {@link PIXI.EventBoundary#allocateEvent this.allocateEvent}.
   * @param from - The {@code originalEvent} for the returned event.
   * @param [type=from.type] - The type of the returned event.
   * @param target - The target of the returned event.
   */
  createPointerEvent(e, n, r) {
    const o = this.allocateEvent(ni);
    return this.copyPointerData(e, o), this.copyMouseData(e, o), this.copyData(e, o), o.nativeEvent = e.nativeEvent, o.originalEvent = e, o.target = r ?? this.hitTest(o.global.x, o.global.y) ?? this._hitElements[0], typeof n == "string" && (o.type = n), o;
  }
  /**
   * Creates a wheel event whose {@code originalEvent} is {@code from}.
   *
   * The event is allocated using {@link PIXI.EventBoundary#allocateEvent this.allocateEvent}.
   * @param from - The upstream wheel event.
   */
  createWheelEvent(e) {
    const n = this.allocateEvent(Kd);
    return this.copyWheelData(e, n), this.copyMouseData(e, n), this.copyData(e, n), n.nativeEvent = e.nativeEvent, n.originalEvent = e, n.target = this.hitTest(n.global.x, n.global.y), n;
  }
  /**
   * Clones the event {@code from}, with an optional {@code type} override.
   *
   * The event is allocated using {@link PIXI.EventBoundary#allocateEvent this.allocateEvent}.
   * @param from - The event to clone.
   * @param [type=from.type] - The type of the returned event.
   */
  clonePointerEvent(e, n) {
    const r = this.allocateEvent(ni);
    return r.nativeEvent = e.nativeEvent, r.originalEvent = e.originalEvent, this.copyPointerData(e, r), this.copyMouseData(e, r), this.copyData(e, r), r.target = e.target, r.path = e.composedPath().slice(), r.type = n ?? r.type, r;
  }
  /**
   * Copies wheel {@link PIXI.FederatedWheelEvent} data from {@code from} into {@code to}.
   *
   * The following properties are copied:
   * + deltaMode
   * + deltaX
   * + deltaY
   * + deltaZ
   * @param from
   * @param to
   */
  copyWheelData(e, n) {
    n.deltaMode = e.deltaMode, n.deltaX = e.deltaX, n.deltaY = e.deltaY, n.deltaZ = e.deltaZ;
  }
  /**
   * Copies pointer {@link PIXI.FederatedPointerEvent} data from {@code from} into {@code to}.
   *
   * The following properties are copied:
   * + pointerId
   * + width
   * + height
   * + isPrimary
   * + pointerType
   * + pressure
   * + tangentialPressure
   * + tiltX
   * + tiltY
   * @param from
   * @param to
   */
  copyPointerData(e, n) {
    e instanceof ni && n instanceof ni && (n.pointerId = e.pointerId, n.width = e.width, n.height = e.height, n.isPrimary = e.isPrimary, n.pointerType = e.pointerType, n.pressure = e.pressure, n.tangentialPressure = e.tangentialPressure, n.tiltX = e.tiltX, n.tiltY = e.tiltY, n.twist = e.twist);
  }
  /**
   * Copies mouse {@link PIXI.FederatedMouseEvent} data from {@code from} to {@code to}.
   *
   * The following properties are copied:
   * + altKey
   * + button
   * + buttons
   * + clientX
   * + clientY
   * + metaKey
   * + movementX
   * + movementY
   * + pageX
   * + pageY
   * + x
   * + y
   * + screen
   * + shiftKey
   * + global
   * @param from
   * @param to
   */
  copyMouseData(e, n) {
    e instanceof pv && n instanceof pv && (n.altKey = e.altKey, n.button = e.button, n.buttons = e.buttons, n.client.copyFrom(e.client), n.ctrlKey = e.ctrlKey, n.metaKey = e.metaKey, n.movement.copyFrom(e.movement), n.screen.copyFrom(e.screen), n.shiftKey = e.shiftKey, n.global.copyFrom(e.global));
  }
  /**
   * Copies base {@link PIXI.FederatedEvent} data from {@code from} into {@code to}.
   *
   * The following properties are copied:
   * + isTrusted
   * + srcElement
   * + timeStamp
   * + type
   * @param from - The event to copy data from.
   * @param to - The event to copy data into.
   */
  copyData(e, n) {
    n.isTrusted = e.isTrusted, n.srcElement = e.srcElement, n.timeStamp = performance.now(), n.type = e.type, n.detail = e.detail, n.view = e.view, n.which = e.which, n.layer.copyFrom(e.layer), n.page.copyFrom(e.page);
  }
  /**
   * @param id - The pointer ID.
   * @returns The tracking data stored for the given pointer. If no data exists, a blank
   *  state will be created.
   */
  trackingData(e) {
    return this.mappingState.trackingData[e] || (this.mappingState.trackingData[e] = {
      pressTargetsByButton: {},
      clicksByButton: {},
      overTarget: null
    }), this.mappingState.trackingData[e];
  }
  /**
   * Allocate a specific type of event from {@link PIXI.EventBoundary#eventPool this.eventPool}.
   *
   * This allocation is constructor-agnostic, as long as it only takes one argument - this event
   * boundary.
   * @param constructor - The event's constructor.
   */
  allocateEvent(e) {
    this.eventPool.has(e) || this.eventPool.set(e, []);
    const n = this.eventPool.get(e).pop() || new e(this);
    return n.eventPhase = n.NONE, n.currentTarget = null, n.path = null, n.target = null, n;
  }
  /**
   * Frees the event and puts it back into the event pool.
   *
   * It is illegal to reuse the event until it is allocated again, using `this.allocateEvent`.
   *
   * It is also advised that events not allocated from {@link PIXI.EventBoundary#allocateEvent this.allocateEvent}
   * not be freed. This is because of the possibility that the same event is freed twice, which can cause
   * it to be allocated twice & result in overwriting.
   * @param event - The event to be freed.
   * @throws Error if the event is managed by another event boundary.
   */
  freeEvent(e) {
    if (e.manager !== this)
      throw new Error("It is illegal to free an event not managed by this EventBoundary!");
    const n = e.constructor;
    this.eventPool.has(n) || this.eventPool.set(n, []), this.eventPool.get(n).push(e);
  }
  /**
   * Similar to {@link PIXI.EventEmitter.emit}, except it stops if the `propagationImmediatelyStopped` flag
   * is set on the event.
   * @param e - The event to call each listener with.
   * @param type - The event key.
   */
  notifyListeners(e, n) {
    const r = e.currentTarget._events[n];
    if (r && e.currentTarget.isInteractive())
      if ("fn" in r)
        r.once && e.currentTarget.removeListener(n, r.fn, void 0, !0), r.fn.call(r.context, e);
      else
        for (let o = 0, s = r.length; o < s && !e.propagationImmediatelyStopped; o++)
          r[o].once && e.currentTarget.removeListener(n, r[o].fn, void 0, !0), r[o].fn.call(r[o].context, e);
  }
}
const bke = 1, kke = {
  touchstart: "pointerdown",
  touchend: "pointerup",
  touchendoutside: "pointerupoutside",
  touchmove: "pointermove",
  touchcancel: "pointercancel"
}, wT = class bT {
  /**
   * @param {PIXI.Renderer} renderer
   */
  constructor(e) {
    this.supportsTouchEvents = "ontouchstart" in globalThis, this.supportsPointerEvents = !!globalThis.PointerEvent, this.domElement = null, this.resolution = 1, this.renderer = e, this.rootBoundary = new wke(null), Ql.init(this), this.autoPreventDefault = !0, this.eventsAdded = !1, this.rootPointerEvent = new ni(null), this.rootWheelEvent = new Kd(null), this.cursorStyles = {
      default: "inherit",
      pointer: "pointer"
    }, this.features = new Proxy({ ...bT.defaultEventFeatures }, {
      set: (n, r, o) => (r === "globalMove" && (this.rootBoundary.enableGlobalMoveEvents = o), n[r] = o, !0)
    }), this.onPointerDown = this.onPointerDown.bind(this), this.onPointerMove = this.onPointerMove.bind(this), this.onPointerUp = this.onPointerUp.bind(this), this.onPointerOverOut = this.onPointerOverOut.bind(this), this.onWheel = this.onWheel.bind(this);
  }
  /**
   * The default interaction mode for all display objects.
   * @see PIXI.DisplayObject.eventMode
   * @type {PIXI.EventMode}
   * @readonly
   * @since 7.2.0
   */
  static get defaultEventMode() {
    return this._defaultEventMode;
  }
  /**
   * Runner init called, view is available at this point.
   * @ignore
   */
  init(e) {
    const { view: n, resolution: r } = this.renderer;
    this.setTargetElement(n), this.resolution = r, bT._defaultEventMode = e.eventMode ?? "auto", Object.assign(this.features, e.eventFeatures ?? {}), this.rootBoundary.enableGlobalMoveEvents = this.features.globalMove;
  }
  /**
   * Handle changing resolution.
   * @ignore
   */
  resolutionChange(e) {
    this.resolution = e;
  }
  /** Destroys all event listeners and detaches the renderer. */
  destroy() {
    this.setTargetElement(null), this.renderer = null;
  }
  /**
   * Sets the current cursor mode, handling any callbacks or CSS style changes.
   * @param mode - cursor mode, a key from the cursorStyles dictionary
   */
  setCursor(e) {
    e = e || "default";
    let n = !0;
    if (globalThis.OffscreenCanvas && this.domElement instanceof OffscreenCanvas && (n = !1), this.currentCursor === e)
      return;
    this.currentCursor = e;
    const r = this.cursorStyles[e];
    if (r)
      switch (typeof r) {
        case "string":
          n && (this.domElement.style.cursor = r);
          break;
        case "function":
          r(e);
          break;
        case "object":
          n && Object.assign(this.domElement.style, r);
          break;
      }
    else
      n && typeof e == "string" && !Object.prototype.hasOwnProperty.call(this.cursorStyles, e) && (this.domElement.style.cursor = e);
  }
  /**
   * The global pointer event.
   * Useful for getting the pointer position without listening to events.
   * @since 7.2.0
   */
  get pointer() {
    return this.rootPointerEvent;
  }
  /**
   * Event handler for pointer down events on {@link PIXI.EventSystem#domElement this.domElement}.
   * @param nativeEvent - The native mouse/pointer/touch event.
   */
  onPointerDown(e) {
    if (!this.features.click)
      return;
    this.rootBoundary.rootTarget = this.renderer.lastObjectRendered;
    const n = this.normalizeToPointerData(e);
    this.autoPreventDefault && n[0].isNormalized && (e.cancelable || !("cancelable" in e)) && e.preventDefault();
    for (let r = 0, o = n.length; r < o; r++) {
      const s = n[r], i = this.bootstrapEvent(this.rootPointerEvent, s);
      this.rootBoundary.mapEvent(i);
    }
    this.setCursor(this.rootBoundary.cursor);
  }
  /**
   * Event handler for pointer move events on on {@link PIXI.EventSystem#domElement this.domElement}.
   * @param nativeEvent - The native mouse/pointer/touch events.
   */
  onPointerMove(e) {
    if (!this.features.move)
      return;
    this.rootBoundary.rootTarget = this.renderer.lastObjectRendered, Ql.pointerMoved();
    const n = this.normalizeToPointerData(e);
    for (let r = 0, o = n.length; r < o; r++) {
      const s = this.bootstrapEvent(this.rootPointerEvent, n[r]);
      this.rootBoundary.mapEvent(s);
    }
    this.setCursor(this.rootBoundary.cursor);
  }
  /**
   * Event handler for pointer up events on {@link PIXI.EventSystem#domElement this.domElement}.
   * @param nativeEvent - The native mouse/pointer/touch event.
   */
  onPointerUp(e) {
    if (!this.features.click)
      return;
    this.rootBoundary.rootTarget = this.renderer.lastObjectRendered;
    let n = e.target;
    e.composedPath && e.composedPath().length > 0 && (n = e.composedPath()[0]);
    const r = n !== this.domElement ? "outside" : "", o = this.normalizeToPointerData(e);
    for (let s = 0, i = o.length; s < i; s++) {
      const u = this.bootstrapEvent(this.rootPointerEvent, o[s]);
      u.type += r, this.rootBoundary.mapEvent(u);
    }
    this.setCursor(this.rootBoundary.cursor);
  }
  /**
   * Event handler for pointer over & out events on {@link PIXI.EventSystem#domElement this.domElement}.
   * @param nativeEvent - The native mouse/pointer/touch event.
   */
  onPointerOverOut(e) {
    if (!this.features.click)
      return;
    this.rootBoundary.rootTarget = this.renderer.lastObjectRendered;
    const n = this.normalizeToPointerData(e);
    for (let r = 0, o = n.length; r < o; r++) {
      const s = this.bootstrapEvent(this.rootPointerEvent, n[r]);
      this.rootBoundary.mapEvent(s);
    }
    this.setCursor(this.rootBoundary.cursor);
  }
  /**
   * Passive handler for `wheel` events on {@link PIXI.EventSystem.domElement this.domElement}.
   * @param nativeEvent - The native wheel event.
   */
  onWheel(e) {
    if (!this.features.wheel)
      return;
    const n = this.normalizeWheelEvent(e);
    this.rootBoundary.rootTarget = this.renderer.lastObjectRendered, this.rootBoundary.mapEvent(n);
  }
  /**
   * Sets the {@link PIXI.EventSystem#domElement domElement} and binds event listeners.
   *
   * To deregister the current DOM element without setting a new one, pass {@code null}.
   * @param element - The new DOM element.
   */
  setTargetElement(e) {
    this.removeEvents(), this.domElement = e, Ql.domElement = e, this.addEvents();
  }
  /** Register event listeners on {@link PIXI.Renderer#domElement this.domElement}. */
  addEvents() {
    if (this.eventsAdded || !this.domElement)
      return;
    Ql.addTickerListener();
    const e = this.domElement.style;
    e && (globalThis.navigator.msPointerEnabled ? (e.msContentZooming = "none", e.msTouchAction = "none") : this.supportsPointerEvents && (e.touchAction = "none")), this.supportsPointerEvents ? (globalThis.document.addEventListener("pointermove", this.onPointerMove, !0), this.domElement.addEventListener("pointerdown", this.onPointerDown, !0), this.domElement.addEventListener("pointerleave", this.onPointerOverOut, !0), this.domElement.addEventListener("pointerover", this.onPointerOverOut, !0), globalThis.addEventListener("pointerup", this.onPointerUp, !0)) : (globalThis.document.addEventListener("mousemove", this.onPointerMove, !0), this.domElement.addEventListener("mousedown", this.onPointerDown, !0), this.domElement.addEventListener("mouseout", this.onPointerOverOut, !0), this.domElement.addEventListener("mouseover", this.onPointerOverOut, !0), globalThis.addEventListener("mouseup", this.onPointerUp, !0), this.supportsTouchEvents && (this.domElement.addEventListener("touchstart", this.onPointerDown, !0), this.domElement.addEventListener("touchend", this.onPointerUp, !0), this.domElement.addEventListener("touchmove", this.onPointerMove, !0))), this.domElement.addEventListener("wheel", this.onWheel, {
      passive: !0,
      capture: !0
    }), this.eventsAdded = !0;
  }
  /** Unregister event listeners on {@link PIXI.EventSystem#domElement this.domElement}. */
  removeEvents() {
    if (!this.eventsAdded || !this.domElement)
      return;
    Ql.removeTickerListener();
    const e = this.domElement.style;
    globalThis.navigator.msPointerEnabled ? (e.msContentZooming = "", e.msTouchAction = "") : this.supportsPointerEvents && (e.touchAction = ""), this.supportsPointerEvents ? (globalThis.document.removeEventListener("pointermove", this.onPointerMove, !0), this.domElement.removeEventListener("pointerdown", this.onPointerDown, !0), this.domElement.removeEventListener("pointerleave", this.onPointerOverOut, !0), this.domElement.removeEventListener("pointerover", this.onPointerOverOut, !0), globalThis.removeEventListener("pointerup", this.onPointerUp, !0)) : (globalThis.document.removeEventListener("mousemove", this.onPointerMove, !0), this.domElement.removeEventListener("mousedown", this.onPointerDown, !0), this.domElement.removeEventListener("mouseout", this.onPointerOverOut, !0), this.domElement.removeEventListener("mouseover", this.onPointerOverOut, !0), globalThis.removeEventListener("mouseup", this.onPointerUp, !0), this.supportsTouchEvents && (this.domElement.removeEventListener("touchstart", this.onPointerDown, !0), this.domElement.removeEventListener("touchend", this.onPointerUp, !0), this.domElement.removeEventListener("touchmove", this.onPointerMove, !0))), this.domElement.removeEventListener("wheel", this.onWheel, !0), this.domElement = null, this.eventsAdded = !1;
  }
  /**
   * Maps x and y coords from a DOM object and maps them correctly to the PixiJS view. The
   * resulting value is stored in the point. This takes into account the fact that the DOM
   * element could be scaled and positioned anywhere on the screen.
   * @param  {PIXI.IPointData} point - the point that the result will be stored in
   * @param  {number} x - the x coord of the position to map
   * @param  {number} y - the y coord of the position to map
   */
  mapPositionToPoint(e, n, r) {
    const o = this.domElement.isConnected ? this.domElement.getBoundingClientRect() : {
      width: this.domElement.width,
      height: this.domElement.height,
      left: 0,
      top: 0
    }, s = 1 / this.resolution;
    e.x = (n - o.left) * (this.domElement.width / o.width) * s, e.y = (r - o.top) * (this.domElement.height / o.height) * s;
  }
  /**
   * Ensures that the original event object contains all data that a regular pointer event would have
   * @param event - The original event data from a touch or mouse event
   * @returns An array containing a single normalized pointer event, in the case of a pointer
   *  or mouse event, or a multiple normalized pointer events if there are multiple changed touches
   */
  normalizeToPointerData(e) {
    const n = [];
    if (this.supportsTouchEvents && e instanceof TouchEvent)
      for (let r = 0, o = e.changedTouches.length; r < o; r++) {
        const s = e.changedTouches[r];
        typeof s.button > "u" && (s.button = 0), typeof s.buttons > "u" && (s.buttons = 1), typeof s.isPrimary > "u" && (s.isPrimary = e.touches.length === 1 && e.type === "touchstart"), typeof s.width > "u" && (s.width = s.radiusX || 1), typeof s.height > "u" && (s.height = s.radiusY || 1), typeof s.tiltX > "u" && (s.tiltX = 0), typeof s.tiltY > "u" && (s.tiltY = 0), typeof s.pointerType > "u" && (s.pointerType = "touch"), typeof s.pointerId > "u" && (s.pointerId = s.identifier || 0), typeof s.pressure > "u" && (s.pressure = s.force || 0.5), typeof s.twist > "u" && (s.twist = 0), typeof s.tangentialPressure > "u" && (s.tangentialPressure = 0), typeof s.layerX > "u" && (s.layerX = s.offsetX = s.clientX), typeof s.layerY > "u" && (s.layerY = s.offsetY = s.clientY), s.isNormalized = !0, s.type = e.type, n.push(s);
      }
    else if (!globalThis.MouseEvent || e instanceof MouseEvent && (!this.supportsPointerEvents || !(e instanceof globalThis.PointerEvent))) {
      const r = e;
      typeof r.isPrimary > "u" && (r.isPrimary = !0), typeof r.width > "u" && (r.width = 1), typeof r.height > "u" && (r.height = 1), typeof r.tiltX > "u" && (r.tiltX = 0), typeof r.tiltY > "u" && (r.tiltY = 0), typeof r.pointerType > "u" && (r.pointerType = "mouse"), typeof r.pointerId > "u" && (r.pointerId = bke), typeof r.pressure > "u" && (r.pressure = 0.5), typeof r.twist > "u" && (r.twist = 0), typeof r.tangentialPressure > "u" && (r.tangentialPressure = 0), r.isNormalized = !0, n.push(r);
    } else
      n.push(e);
    return n;
  }
  /**
   * Normalizes the native {@link https://w3c.github.io/uievents/#interface-wheelevent WheelEvent}.
   *
   * The returned {@link PIXI.FederatedWheelEvent} is a shared instance. It will not persist across
   * multiple native wheel events.
   * @param nativeEvent - The native wheel event that occurred on the canvas.
   * @returns A federated wheel event.
   */
  normalizeWheelEvent(e) {
    const n = this.rootWheelEvent;
    return this.transferMouseData(n, e), n.deltaX = e.deltaX, n.deltaY = e.deltaY, n.deltaZ = e.deltaZ, n.deltaMode = e.deltaMode, this.mapPositionToPoint(n.screen, e.clientX, e.clientY), n.global.copyFrom(n.screen), n.offset.copyFrom(n.screen), n.nativeEvent = e, n.type = e.type, n;
  }
  /**
   * Normalizes the `nativeEvent` into a federateed {@link PIXI.FederatedPointerEvent}.
   * @param event
   * @param nativeEvent
   */
  bootstrapEvent(e, n) {
    return e.originalEvent = null, e.nativeEvent = n, e.pointerId = n.pointerId, e.width = n.width, e.height = n.height, e.isPrimary = n.isPrimary, e.pointerType = n.pointerType, e.pressure = n.pressure, e.tangentialPressure = n.tangentialPressure, e.tiltX = n.tiltX, e.tiltY = n.tiltY, e.twist = n.twist, this.transferMouseData(e, n), this.mapPositionToPoint(e.screen, n.clientX, n.clientY), e.global.copyFrom(e.screen), e.offset.copyFrom(e.screen), e.isTrusted = n.isTrusted, e.type === "pointerleave" && (e.type = "pointerout"), e.type.startsWith("mouse") && (e.type = e.type.replace("mouse", "pointer")), e.type.startsWith("touch") && (e.type = kke[e.type] || e.type), e;
  }
  /**
   * Transfers base & mouse event data from the {@code nativeEvent} to the federated event.
   * @param event
   * @param nativeEvent
   */
  transferMouseData(e, n) {
    e.isTrusted = n.isTrusted, e.srcElement = n.srcElement, e.timeStamp = performance.now(), e.type = n.type, e.altKey = n.altKey, e.button = n.button, e.buttons = n.buttons, e.client.x = n.clientX, e.client.y = n.clientY, e.ctrlKey = n.ctrlKey, e.metaKey = n.metaKey, e.movement.x = n.movementX, e.movement.y = n.movementY, e.page.x = n.pageX, e.page.y = n.pageY, e.relatedTarget = null, e.shiftKey = n.shiftKey;
  }
};
wT.extension = {
  name: "events",
  type: [
    rt.RendererSystem,
    rt.CanvasRendererSystem
  ]
}, /**
* The event features that are enabled by the EventSystem
* This option only is available when using **@pixi/events** package
* (included in the **pixi.js** and **pixi.js-legacy** bundle), otherwise it will be ignored.
* @since 7.2.0
*/
wT.defaultEventFeatures = {
  move: !0,
  globalMove: !0,
  click: !0,
  wheel: !0
};
let kT = wT;
dt.add(kT);
function WC(t) {
  return t === "dynamic" || t === "static";
}
const Tke = {
  /**
   * Property-based event handler for the `click` event.
   * @memberof PIXI.DisplayObject#
   * @default null
   * @example
   * this.onclick = (event) => {
   *  //some function here that happens on click
   * }
   */
  onclick: null,
  /**
   * Property-based event handler for the `mousedown` event.
   * @memberof PIXI.DisplayObject#
   * @default null
   * @example
   * this.onmousedown = (event) => {
   *  //some function here that happens on mousedown
   * }
   */
  onmousedown: null,
  /**
   * Property-based event handler for the `mouseenter` event.
   * @memberof PIXI.DisplayObject#
   * @default null
   * @example
   * this.onmouseenter = (event) => {
   *  //some function here that happens on mouseenter
   * }
   */
  onmouseenter: null,
  /**
   * Property-based event handler for the `mouseleave` event.
   * @memberof PIXI.DisplayObject#
   * @default null
   * @example
   * this.onmouseleave = (event) => {
   *  //some function here that happens on mouseleave
   * }
   */
  onmouseleave: null,
  /**
   * Property-based event handler for the `mousemove` event.
   * @memberof PIXI.DisplayObject#
   * @default null
   * @example
   * this.onmousemove = (event) => {
   *  //some function here that happens on mousemove
   * }
   */
  onmousemove: null,
  /**
   * Property-based event handler for the `globalmousemove` event.
   * @memberof PIXI.DisplayObject#
   * @default null
   * @example
   * this.onglobalmousemove = (event) => {
   *  //some function here that happens on globalmousemove
   * }
   */
  onglobalmousemove: null,
  /**
   * Property-based event handler for the `mouseout` event.
   * @memberof PIXI.DisplayObject#
   * @default null
   * @example
   * this.onmouseout = (event) => {
   *  //some function here that happens on mouseout
   * }
   */
  onmouseout: null,
  /**
   * Property-based event handler for the `mouseover` event.
   * @memberof PIXI.DisplayObject#
   * @default null
   * @example
   * this.onmouseover = (event) => {
   *  //some function here that happens on mouseover
   * }
   */
  onmouseover: null,
  /**
   * Property-based event handler for the `mouseup` event.
   * @memberof PIXI.DisplayObject#
   * @default null
   * @example
   * this.onmouseup = (event) => {
   *  //some function here that happens on mouseup
   * }
   */
  onmouseup: null,
  /**
   * Property-based event handler for the `mouseupoutside` event.
   * @memberof PIXI.DisplayObject#
   * @default null
   * @example
   * this.onmouseupoutside = (event) => {
   *  //some function here that happens on mouseupoutside
   * }
   */
  onmouseupoutside: null,
  /**
   * Property-based event handler for the `pointercancel` event.
   * @memberof PIXI.DisplayObject#
   * @default null
   * @example
   * this.onpointercancel = (event) => {
   *  //some function here that happens on pointercancel
   * }
   */
  onpointercancel: null,
  /**
   * Property-based event handler for the `pointerdown` event.
   * @memberof PIXI.DisplayObject#
   * @default null
   * @example
   * this.onpointerdown = (event) => {
   *  //some function here that happens on pointerdown
   * }
   */
  onpointerdown: null,
  /**
   * Property-based event handler for the `pointerenter` event.
   * @memberof PIXI.DisplayObject#
   * @default null
   * @example
   * this.onpointerenter = (event) => {
   *  //some function here that happens on pointerenter
   * }
   */
  onpointerenter: null,
  /**
   * Property-based event handler for the `pointerleave` event.
   * @memberof PIXI.DisplayObject#
   * @default null
   * @example
   * this.onpointerleave = (event) => {
   *  //some function here that happens on pointerleave
   * }
   */
  onpointerleave: null,
  /**
   * Property-based event handler for the `pointermove` event.
   * @memberof PIXI.DisplayObject#
   * @default null
   * @example
   * this.onpointermove = (event) => {
   *  //some function here that happens on pointermove
   * }
   */
  onpointermove: null,
  /**
   * Property-based event handler for the `globalpointermove` event.
   * @memberof PIXI.DisplayObject#
   * @default null
   * @example
   * this.onglobalpointermove = (event) => {
   *  //some function here that happens on globalpointermove
   * }
   */
  onglobalpointermove: null,
  /**
   * Property-based event handler for the `pointerout` event.
   * @memberof PIXI.DisplayObject#
   * @default null
   * @example
   * this.onpointerout = (event) => {
   *  //some function here that happens on pointerout
   * }
   */
  onpointerout: null,
  /**
   * Property-based event handler for the `pointerover` event.
   * @memberof PIXI.DisplayObject#
   * @default null
   * @example
   * this.onpointerover = (event) => {
   *  //some function here that happens on pointerover
   * }
   */
  onpointerover: null,
  /**
   * Property-based event handler for the `pointertap` event.
   * @memberof PIXI.DisplayObject#
   * @default null
   * @example
   * this.onpointertap = (event) => {
   *  //some function here that happens on pointertap
   * }
   */
  onpointertap: null,
  /**
   * Property-based event handler for the `pointerup` event.
   * @memberof PIXI.DisplayObject#
   * @default null
   * @example
   * this.onpointerup = (event) => {
   *  //some function here that happens on pointerup
   * }
   */
  onpointerup: null,
  /**
   * Property-based event handler for the `pointerupoutside` event.
   * @memberof PIXI.DisplayObject#
   * @default null
   * @example
   * this.onpointerupoutside = (event) => {
   *  //some function here that happens on pointerupoutside
   * }
   */
  onpointerupoutside: null,
  /**
   * Property-based event handler for the `rightclick` event.
   * @memberof PIXI.DisplayObject#
   * @default null
   * @example
   * this.onrightclick = (event) => {
   *  //some function here that happens on rightclick
   * }
   */
  onrightclick: null,
  /**
   * Property-based event handler for the `rightdown` event.
   * @memberof PIXI.DisplayObject#
   * @default null
   * @example
   * this.onrightdown = (event) => {
   *  //some function here that happens on rightdown
   * }
   */
  onrightdown: null,
  /**
   * Property-based event handler for the `rightup` event.
   * @memberof PIXI.DisplayObject#
   * @default null
   * @example
   * this.onrightup = (event) => {
   *  //some function here that happens on rightup
   * }
   */
  onrightup: null,
  /**
   * Property-based event handler for the `rightupoutside` event.
   * @memberof PIXI.DisplayObject#
   * @default null
   * @example
   * this.onrightupoutside = (event) => {
   *  //some function here that happens on rightupoutside
   * }
   */
  onrightupoutside: null,
  /**
   * Property-based event handler for the `tap` event.
   * @memberof PIXI.DisplayObject#
   * @default null
   * @example
   * this.ontap = (event) => {
   *  //some function here that happens on tap
   * }
   */
  ontap: null,
  /**
   * Property-based event handler for the `touchcancel` event.
   * @memberof PIXI.DisplayObject#
   * @default null
   * @example
   * this.ontouchcancel = (event) => {
   *  //some function here that happens on touchcancel
   * }
   */
  ontouchcancel: null,
  /**
   * Property-based event handler for the `touchend` event.
   * @memberof PIXI.DisplayObject#
   * @default null
   * @example
   * this.ontouchend = (event) => {
   *  //some function here that happens on touchend
   * }
   */
  ontouchend: null,
  /**
   * Property-based event handler for the `touchendoutside` event.
   * @memberof PIXI.DisplayObject#
   * @default null
   * @example
   * this.ontouchendoutside = (event) => {
   *  //some function here that happens on touchendoutside
   * }
   */
  ontouchendoutside: null,
  /**
   * Property-based event handler for the `touchmove` event.
   * @memberof PIXI.DisplayObject#
   * @default null
   * @example
   * this.ontouchmove = (event) => {
   *  //some function here that happens on touchmove
   * }
   */
  ontouchmove: null,
  /**
   * Property-based event handler for the `globaltouchmove` event.
   * @memberof PIXI.DisplayObject#
   * @default null
   * @example
   * this.onglobaltouchmove = (event) => {
   *  //some function here that happens on globaltouchmove
   * }
   */
  onglobaltouchmove: null,
  /**
   * Property-based event handler for the `touchstart` event.
   * @memberof PIXI.DisplayObject#
   * @default null
   * @example
   * this.ontouchstart = (event) => {
   *  //some function here that happens on touchstart
   * }
   */
  ontouchstart: null,
  /**
   * Property-based event handler for the `wheel` event.
   * @memberof PIXI.DisplayObject#
   * @default null
   * @example
   * this.onwheel = (event) => {
   *  //some function here that happens on wheel
   * }
   */
  onwheel: null,
  /**
   * @ignore
   */
  _internalInteractive: void 0,
  /**
   * Enable interaction events for the DisplayObject. Touch, pointer and mouse
   * @memberof PIXI.DisplayObject#
   */
  get interactive() {
    return this._internalInteractive ?? WC(kT.defaultEventMode);
  },
  set interactive(t) {
    un(
      "7.2.0",
      // eslint-disable-next-line max-len
      "Setting interactive is deprecated, use eventMode = 'none'/'passive'/'auto'/'static'/'dynamic' instead."
    ), this._internalInteractive = t, this.eventMode = t ? "static" : "auto";
  },
  /**
   * @ignore
   */
  _internalEventMode: void 0,
  /**
   * Enable interaction events for the DisplayObject. Touch, pointer and mouse.
   * This now replaces the `interactive` property.
   * There are 5 types of interaction settings:
   * - `'none'`: Ignores all interaction events, even on its children.
   * - `'passive'`: Does not emit events and ignores all hit testing on itself and non-interactive children.
   * Interactive children will still emit events.
   * - `'auto'`: Does not emit events but is hit tested if parent is interactive. Same as `interactive = false` in v7
   * - `'static'`: Emit events and is hit tested. Same as `interaction = true` in v7
   * - `'dynamic'`: Emits events and is hit tested but will also receive mock interaction events fired from a ticker to
   * allow for interaction when the mouse isn't moving
   * @example
   * import { Sprite } from 'pixi.js';
   *
   * const sprite = new Sprite(texture);
   * sprite.eventMode = 'static';
   * sprite.on('tap', (event) => {
   *     // Handle event
   * });
   * @memberof PIXI.DisplayObject#
   * @since 7.2.0
   */
  get eventMode() {
    return this._internalEventMode ?? kT.defaultEventMode;
  },
  set eventMode(t) {
    this._internalInteractive = WC(t), this._internalEventMode = t;
  },
  /**
   * Determines if the displayObject is interactive or not
   * @returns {boolean} Whether the displayObject is interactive or not
   * @memberof PIXI.DisplayObject#
   * @since 7.2.0
   * @example
   * import { Sprite } from 'pixi.js';
   * const sprite = new Sprite(texture);
   * sprite.eventMode = 'static';
   * sprite.isInteractive(); // true
   *
   * sprite.eventMode = 'dynamic';
   * sprite.isInteractive(); // true
   *
   * sprite.eventMode = 'none';
   * sprite.isInteractive(); // false
   *
   * sprite.eventMode = 'passive';
   * sprite.isInteractive(); // false
   *
   * sprite.eventMode = 'auto';
   * sprite.isInteractive(); // false
   */
  isInteractive() {
    return this.eventMode === "static" || this.eventMode === "dynamic";
  },
  /**
   * Determines if the children to the displayObject can be clicked/touched
   * Setting this to false allows PixiJS to bypass a recursive `hitTest` function
   * @memberof PIXI.Container#
   */
  interactiveChildren: !0,
  /**
   * Interaction shape. Children will be hit first, then this shape will be checked.
   * Setting this will cause this shape to be checked in hit tests rather than the displayObject's bounds.
   * @example
   * import { Rectangle, Sprite } from 'pixi.js';
   *
   * const sprite = new Sprite(texture);
   * sprite.interactive = true;
   * sprite.hitArea = new Rectangle(0, 0, 100, 100);
   * @member {PIXI.IHitArea}
   * @memberof PIXI.DisplayObject#
   */
  hitArea: null,
  /**
   * Unlike `on` or `addListener` which are methods from EventEmitter, `addEventListener`
   * seeks to be compatible with the DOM's `addEventListener` with support for options.
   * **IMPORTANT:** _Only_ available if using the `@pixi/events` package.
   * @memberof PIXI.DisplayObject
   * @param type - The type of event to listen to.
   * @param listener - The listener callback or object.
   * @param options - Listener options, used for capture phase.
   * @example
   * // Tell the user whether they did a single, double, triple, or nth click.
   * button.addEventListener('click', {
   *     handleEvent(e): {
   *         let prefix;
   *
   *         switch (e.detail) {
   *             case 1: prefix = 'single'; break;
   *             case 2: prefix = 'double'; break;
   *             case 3: prefix = 'triple'; break;
   *             default: prefix = e.detail + 'th'; break;
   *         }
   *
   *         console.log('That was a ' + prefix + 'click');
   *     }
   * });
   *
   * // But skip the first click!
   * button.parent.addEventListener('click', function blockClickOnce(e) {
   *     e.stopImmediatePropagation();
   *     button.parent.removeEventListener('click', blockClickOnce, true);
   * }, {
   *     capture: true,
   * });
   */
  addEventListener(t, e, n) {
    const r = typeof n == "boolean" && n || typeof n == "object" && n.capture, o = typeof e == "function" ? void 0 : e;
    t = r ? `${t}capture` : t, e = typeof e == "function" ? e : e.handleEvent, this.on(t, e, o);
  },
  /**
   * Unlike `off` or `removeListener` which are methods from EventEmitter, `removeEventListener`
   * seeks to be compatible with the DOM's `removeEventListener` with support for options.
   * **IMPORTANT:** _Only_ available if using the `@pixi/events` package.
   * @memberof PIXI.DisplayObject
   * @param type - The type of event the listener is bound to.
   * @param listener - The listener callback or object.
   * @param options - The original listener options. This is required to deregister a capture phase listener.
   */
  removeEventListener(t, e, n) {
    const r = typeof n == "boolean" && n || typeof n == "object" && n.capture, o = typeof e == "function" ? void 0 : e;
    t = r ? `${t}capture` : t, e = typeof e == "function" ? e : e.handleEvent, this.off(t, e, o);
  },
  /**
   * Dispatch the event on this {@link PIXI.DisplayObject} using the event's {@link PIXI.EventBoundary}.
   *
   * The target of the event is set to `this` and the `defaultPrevented` flag is cleared before dispatch.
   *
   * **IMPORTANT:** _Only_ available if using the `@pixi/events` package.
   * @memberof PIXI.DisplayObject
   * @param e - The event to dispatch.
   * @returns Whether the {@link PIXI.FederatedEvent.preventDefault preventDefault}() method was not invoked.
   * @example
   * // Reuse a click event!
   * button.dispatchEvent(clickEvent);
   */
  dispatchEvent(t) {
    if (!(t instanceof ly))
      throw new Error("DisplayObject cannot propagate events outside of the Federated Events API");
    return t.defaultPrevented = !1, t.path = null, t.target = this, t.manager.dispatchEvent(t), !t.defaultPrevented;
  }
};
vr.mixin(Tke);
const xke = {
  /**
   *  Flag for if the object is accessible. If true AccessibilityManager will overlay a
   *   shadow div with attributes set
   * @member {boolean}
   * @memberof PIXI.DisplayObject#
   */
  accessible: !1,
  /**
   * Sets the title attribute of the shadow div
   * If accessibleTitle AND accessibleHint has not been this will default to 'displayObject [tabIndex]'
   * @member {?string}
   * @memberof PIXI.DisplayObject#
   */
  accessibleTitle: null,
  /**
   * Sets the aria-label attribute of the shadow div
   * @member {string}
   * @memberof PIXI.DisplayObject#
   */
  accessibleHint: null,
  /**
   * @member {number}
   * @memberof PIXI.DisplayObject#
   * @private
   * @todo Needs docs.
   */
  tabIndex: 0,
  /**
   * @member {boolean}
   * @memberof PIXI.DisplayObject#
   * @todo Needs docs.
   */
  _accessibleActive: !1,
  /**
   * @member {boolean}
   * @memberof PIXI.DisplayObject#
   * @todo Needs docs.
   */
  _accessibleDiv: null,
  /**
   * Specify the type of div the accessible layer is. Screen readers treat the element differently
   * depending on this type. Defaults to button.
   * @member {string}
   * @memberof PIXI.DisplayObject#
   * @default 'button'
   */
  accessibleType: "button",
  /**
   * Specify the pointer-events the accessible div will use
   * Defaults to auto.
   * @member {string}
   * @memberof PIXI.DisplayObject#
   * @default 'auto'
   */
  accessiblePointerEvents: "auto",
  /**
   * Setting to false will prevent any children inside this container to
   * be accessible. Defaults to true.
   * @member {boolean}
   * @memberof PIXI.DisplayObject#
   * @default true
   */
  accessibleChildren: !0,
  renderId: -1
};
vr.mixin(xke);
const Ske = 9, xg = 100, Rke = 0, Ake = 0, VC = 2, HC = 1, Dke = -1e3, Eke = -1e3, Mke = 2;
class GB {
  // 2fps
  /**
   * @param {PIXI.CanvasRenderer|PIXI.Renderer} renderer - A reference to the current renderer
   */
  constructor(e) {
    this.debug = !1, this._isActive = !1, this._isMobileAccessibility = !1, this.pool = [], this.renderId = 0, this.children = [], this.androidUpdateCount = 0, this.androidUpdateFrequency = 500, this._hookDiv = null, (Gu.tablet || Gu.phone) && this.createTouchHook();
    const n = document.createElement("div");
    n.style.width = `${xg}px`, n.style.height = `${xg}px`, n.style.position = "absolute", n.style.top = `${Rke}px`, n.style.left = `${Ake}px`, n.style.zIndex = VC.toString(), this.div = n, this.renderer = e, this._onKeyDown = this._onKeyDown.bind(this), this._onMouseMove = this._onMouseMove.bind(this), globalThis.addEventListener("keydown", this._onKeyDown, !1);
  }
  /**
   * Value of `true` if accessibility is currently active and accessibility layers are showing.
   * @member {boolean}
   * @readonly
   */
  get isActive() {
    return this._isActive;
  }
  /**
   * Value of `true` if accessibility is enabled for touch devices.
   * @member {boolean}
   * @readonly
   */
  get isMobileAccessibility() {
    return this._isMobileAccessibility;
  }
  /**
   * Creates the touch hooks.
   * @private
   */
  createTouchHook() {
    const e = document.createElement("button");
    e.style.width = `${HC}px`, e.style.height = `${HC}px`, e.style.position = "absolute", e.style.top = `${Dke}px`, e.style.left = `${Eke}px`, e.style.zIndex = Mke.toString(), e.style.backgroundColor = "#FF0000", e.title = "select to enable accessibility for this content", e.addEventListener("focus", () => {
      this._isMobileAccessibility = !0, this.activate(), this.destroyTouchHook();
    }), document.body.appendChild(e), this._hookDiv = e;
  }
  /**
   * Destroys the touch hooks.
   * @private
   */
  destroyTouchHook() {
    this._hookDiv && (document.body.removeChild(this._hookDiv), this._hookDiv = null);
  }
  /**
   * Activating will cause the Accessibility layer to be shown.
   * This is called when a user presses the tab key.
   * @private
   */
  activate() {
    this._isActive || (this._isActive = !0, globalThis.document.addEventListener("mousemove", this._onMouseMove, !0), globalThis.removeEventListener("keydown", this._onKeyDown, !1), this.renderer.on("postrender", this.update, this), this.renderer.view.parentNode?.appendChild(this.div));
  }
  /**
   * Deactivating will cause the Accessibility layer to be hidden.
   * This is called when a user moves the mouse.
   * @private
   */
  deactivate() {
    !this._isActive || this._isMobileAccessibility || (this._isActive = !1, globalThis.document.removeEventListener("mousemove", this._onMouseMove, !0), globalThis.addEventListener("keydown", this._onKeyDown, !1), this.renderer.off("postrender", this.update), this.div.parentNode?.removeChild(this.div));
  }
  /**
   * This recursive function will run through the scene graph and add any new accessible objects to the DOM layer.
   * @private
   * @param {PIXI.Container} displayObject - The DisplayObject to check.
   */
  updateAccessibleObjects(e) {
    if (!e.visible || !e.accessibleChildren)
      return;
    e.accessible && e.isInteractive() && (e._accessibleActive || this.addChild(e), e.renderId = this.renderId);
    const n = e.children;
    if (n)
      for (let r = 0; r < n.length; r++)
        this.updateAccessibleObjects(n[r]);
  }
  /**
   * Before each render this function will ensure that all divs are mapped correctly to their DisplayObjects.
   * @private
   */
  update() {
    const e = performance.now();
    if (Gu.android.device && e < this.androidUpdateCount || (this.androidUpdateCount = e + this.androidUpdateFrequency, !this.renderer.renderingToScreen))
      return;
    this.renderer.lastObjectRendered && this.updateAccessibleObjects(this.renderer.lastObjectRendered);
    const { x: n, y: r, width: o, height: s } = this.renderer.view.getBoundingClientRect(), { width: i, height: u, resolution: l } = this.renderer, a = o / i * l, c = s / u * l;
    let p = this.div;
    p.style.left = `${n}px`, p.style.top = `${r}px`, p.style.width = `${i}px`, p.style.height = `${u}px`;
    for (let d = 0; d < this.children.length; d++) {
      const h = this.children[d];
      if (h.renderId !== this.renderId)
        h._accessibleActive = !1, Yd(this.children, d, 1), this.div.removeChild(h._accessibleDiv), this.pool.push(h._accessibleDiv), h._accessibleDiv = null, d--;
      else {
        p = h._accessibleDiv;
        let m = h.hitArea;
        const g = h.worldTransform;
        h.hitArea ? (p.style.left = `${(g.tx + m.x * g.a) * a}px`, p.style.top = `${(g.ty + m.y * g.d) * c}px`, p.style.width = `${m.width * g.a * a}px`, p.style.height = `${m.height * g.d * c}px`) : (m = h.getBounds(), this.capHitArea(m), p.style.left = `${m.x * a}px`, p.style.top = `${m.y * c}px`, p.style.width = `${m.width * a}px`, p.style.height = `${m.height * c}px`, p.title !== h.accessibleTitle && h.accessibleTitle !== null && (p.title = h.accessibleTitle), p.getAttribute("aria-label") !== h.accessibleHint && h.accessibleHint !== null && p.setAttribute("aria-label", h.accessibleHint)), (h.accessibleTitle !== p.title || h.tabIndex !== p.tabIndex) && (p.title = h.accessibleTitle, p.tabIndex = h.tabIndex, this.debug && this.updateDebugHTML(p));
      }
    }
    this.renderId++;
  }
  /**
   * private function that will visually add the information to the
   * accessability div
   * @param {HTMLElement} div -
   */
  updateDebugHTML(e) {
    e.innerHTML = `type: ${e.type}</br> title : ${e.title}</br> tabIndex: ${e.tabIndex}`;
  }
  /**
   * Adjust the hit area based on the bounds of a display object
   * @param {PIXI.Rectangle} hitArea - Bounds of the child
   */
  capHitArea(e) {
    e.x < 0 && (e.width += e.x, e.x = 0), e.y < 0 && (e.height += e.y, e.y = 0);
    const { width: n, height: r } = this.renderer;
    e.x + e.width > n && (e.width = n - e.x), e.y + e.height > r && (e.height = r - e.y);
  }
  /**
   * Adds a DisplayObject to the accessibility manager
   * @private
   * @param {PIXI.DisplayObject} displayObject - The child to make accessible.
   */
  addChild(e) {
    let n = this.pool.pop();
    n || (n = document.createElement("button"), n.style.width = `${xg}px`, n.style.height = `${xg}px`, n.style.backgroundColor = this.debug ? "rgba(255,255,255,0.5)" : "transparent", n.style.position = "absolute", n.style.zIndex = VC.toString(), n.style.borderStyle = "none", navigator.userAgent.toLowerCase().includes("chrome") ? n.setAttribute("aria-live", "off") : n.setAttribute("aria-live", "polite"), navigator.userAgent.match(/rv:.*Gecko\//) ? n.setAttribute("aria-relevant", "additions") : n.setAttribute("aria-relevant", "text"), n.addEventListener("click", this._onClick.bind(this)), n.addEventListener("focus", this._onFocus.bind(this)), n.addEventListener("focusout", this._onFocusOut.bind(this))), n.style.pointerEvents = e.accessiblePointerEvents, n.type = e.accessibleType, e.accessibleTitle && e.accessibleTitle !== null ? n.title = e.accessibleTitle : (!e.accessibleHint || e.accessibleHint === null) && (n.title = `displayObject ${e.tabIndex}`), e.accessibleHint && e.accessibleHint !== null && n.setAttribute("aria-label", e.accessibleHint), this.debug && this.updateDebugHTML(n), e._accessibleActive = !0, e._accessibleDiv = n, n.displayObject = e, this.children.push(e), this.div.appendChild(e._accessibleDiv), e._accessibleDiv.tabIndex = e.tabIndex;
  }
  /**
   * Dispatch events with the EventSystem.
   * @param e
   * @param type
   * @private
   */
  _dispatchEvent(e, n) {
    const { displayObject: r } = e.target, o = this.renderer.events.rootBoundary, s = Object.assign(new ly(o), { target: r });
    o.rootTarget = this.renderer.lastObjectRendered, n.forEach((i) => o.dispatchEvent(s, i));
  }
  /**
   * Maps the div button press to pixi's EventSystem (click)
   * @private
   * @param {MouseEvent} e - The click event.
   */
  _onClick(e) {
    this._dispatchEvent(e, ["click", "pointertap", "tap"]);
  }
  /**
   * Maps the div focus events to pixi's EventSystem (mouseover)
   * @private
   * @param {FocusEvent} e - The focus event.
   */
  _onFocus(e) {
    e.target.getAttribute("aria-live") || e.target.setAttribute("aria-live", "assertive"), this._dispatchEvent(e, ["mouseover"]);
  }
  /**
   * Maps the div focus events to pixi's EventSystem (mouseout)
   * @private
   * @param {FocusEvent} e - The focusout event.
   */
  _onFocusOut(e) {
    e.target.getAttribute("aria-live") || e.target.setAttribute("aria-live", "polite"), this._dispatchEvent(e, ["mouseout"]);
  }
  /**
   * Is called when a key is pressed
   * @private
   * @param {KeyboardEvent} e - The keydown event.
   */
  _onKeyDown(e) {
    e.keyCode === Ske && this.activate();
  }
  /**
   * Is called when the mouse moves across the renderer element
   * @private
   * @param {MouseEvent} e - The mouse event.
   */
  _onMouseMove(e) {
    e.movementX === 0 && e.movementY === 0 || this.deactivate();
  }
  /** Destroys the accessibility manager */
  destroy() {
    this.destroyTouchHook(), this.div = null, globalThis.document.removeEventListener("mousemove", this._onMouseMove, !0), globalThis.removeEventListener("keydown", this._onKeyDown), this.pool = null, this.children = null, this.renderer = null;
  }
}
GB.extension = {
  name: "accessibility",
  type: [
    rt.RendererPlugin,
    rt.CanvasRendererPlugin
  ]
};
dt.add(GB);
const YB = class TT {
  /**
   * @param options - The optional application and renderer parameters.
   */
  constructor(e) {
    this.stage = new fn(), e = Object.assign({
      forceCanvas: !1
    }, e), this.renderer = $be(e), TT._plugins.forEach((n) => {
      n.init.call(this, e);
    });
  }
  /** Render the current stage. */
  render() {
    this.renderer.render(this.stage);
  }
  /**
   * Reference to the renderer's canvas element.
   * @member {PIXI.ICanvas}
   * @readonly
   */
  get view() {
    return this.renderer?.view;
  }
  /**
   * Reference to the renderer's screen rectangle. Its safe to use as `filterArea` or `hitArea` for the whole screen.
   * @member {PIXI.Rectangle}
   * @readonly
   */
  get screen() {
    return this.renderer?.screen;
  }
  /**
   * Destroy and don't use after this.
   * @param {boolean} [removeView=false] - Automatically remove canvas from DOM.
   * @param {object|boolean} [stageOptions] - Options parameter. A boolean will act as if all options
   *  have been set to that value
   * @param {boolean} [stageOptions.children=false] - if set to true, all the children will have their destroy
   *  method called as well. 'stageOptions' will be passed on to those calls.
   * @param {boolean} [stageOptions.texture=false] - Only used for child Sprites if stageOptions.children is set
   *  to true. Should it destroy the texture of the child sprite
   * @param {boolean} [stageOptions.baseTexture=false] - Only used for child Sprites if stageOptions.children is set
   *  to true. Should it destroy the base texture of the child sprite
   */
  destroy(e, n) {
    const r = TT._plugins.slice(0);
    r.reverse(), r.forEach((o) => {
      o.destroy.call(this);
    }), this.stage.destroy(n), this.stage = null, this.renderer.destroy(e), this.renderer = null;
  }
};
YB._plugins = [];
let QB = YB;
dt.handleByList(rt.Application, QB._plugins);
class KB {
  /**
   * Initialize the plugin with scope of application instance
   * @static
   * @private
   * @param {object} [options] - See application options
   */
  static init(e) {
    Object.defineProperty(
      this,
      "resizeTo",
      /**
       * The HTML element or window to automatically resize the
       * renderer's view element to match width and height.
       * @member {Window|HTMLElement}
       * @name resizeTo
       * @memberof PIXI.Application#
       */
      {
        set(n) {
          globalThis.removeEventListener("resize", this.queueResize), this._resizeTo = n, n && (globalThis.addEventListener("resize", this.queueResize), this.resize());
        },
        get() {
          return this._resizeTo;
        }
      }
    ), this.queueResize = () => {
      this._resizeTo && (this.cancelResize(), this._resizeId = requestAnimationFrame(() => this.resize()));
    }, this.cancelResize = () => {
      this._resizeId && (cancelAnimationFrame(this._resizeId), this._resizeId = null);
    }, this.resize = () => {
      if (!this._resizeTo)
        return;
      this.cancelResize();
      let n, r;
      if (this._resizeTo === globalThis.window)
        n = globalThis.innerWidth, r = globalThis.innerHeight;
      else {
        const { clientWidth: o, clientHeight: s } = this._resizeTo;
        n = o, r = s;
      }
      this.renderer.resize(n, r), this.render();
    }, this._resizeId = null, this._resizeTo = null, this.resizeTo = e.resizeTo || null;
  }
  /**
   * Clean up the ticker, scoped to application
   * @static
   * @private
   */
  static destroy() {
    globalThis.removeEventListener("resize", this.queueResize), this.cancelResize(), this.cancelResize = null, this.queueResize = null, this.resizeTo = null, this.resize = null;
  }
}
KB.extension = rt.Application;
dt.add(KB);
const jC = {
  loader: rt.LoadParser,
  resolver: rt.ResolveParser,
  cache: rt.CacheParser,
  detection: rt.DetectionParser
};
dt.handle(rt.Asset, (t) => {
  const e = t.ref;
  Object.entries(jC).filter(([n]) => !!e[n]).forEach(([n, r]) => dt.add(Object.assign(
    e[n],
    // Allow the function to optionally define it's own
    // ExtensionMetadata, the use cases here is priority for LoaderParsers
    { extension: e[n].extension ?? r }
  )));
}, (t) => {
  const e = t.ref;
  Object.keys(jC).filter((n) => !!e[n]).forEach((n) => dt.remove(e[n]));
});
class Pke {
  /**
   * @param loader
   * @param verbose - should the loader log to the console
   */
  constructor(e, n = !1) {
    this._loader = e, this._assetList = [], this._isLoading = !1, this._maxConcurrent = 1, this.verbose = n;
  }
  /**
   * Adds an array of assets to load.
   * @param assetUrls - assets to load
   */
  add(e) {
    e.forEach((n) => {
      this._assetList.push(n);
    }), this.verbose && console.log("[BackgroundLoader] assets: ", this._assetList), this._isActive && !this._isLoading && this._next();
  }
  /**
   * Loads the next set of assets. Will try to load as many assets as it can at the same time.
   *
   * The max assets it will try to load at one time will be 4.
   */
  async _next() {
    if (this._assetList.length && this._isActive) {
      this._isLoading = !0;
      const e = [], n = Math.min(this._assetList.length, this._maxConcurrent);
      for (let r = 0; r < n; r++)
        e.push(this._assetList.pop());
      await this._loader.load(e), this._isLoading = !1, this._next();
    }
  }
  /**
   * Activate/Deactivate the loading. If set to true then it will immediately continue to load the next asset.
   * @returns whether the class is active
   */
  get active() {
    return this._isActive;
  }
  set active(e) {
    this._isActive !== e && (this._isActive = e, e && !this._isLoading && this._next());
  }
}
function jh(t, e) {
  if (Array.isArray(e)) {
    for (const n of e)
      if (t.startsWith(`data:${n}`))
        return !0;
    return !1;
  }
  return t.startsWith(`data:${e}`);
}
function Oc(t, e) {
  const n = t.split("?")[0], r = lo.extname(n).toLowerCase();
  return Array.isArray(e) ? e.includes(r) : r === e;
}
const ui = (t, e, n = !1) => (Array.isArray(t) || (t = [t]), e ? t.map((r) => typeof r == "string" || n ? e(r) : r) : t), xT = (t, e) => {
  const n = e.split("?")[1];
  return n && (t += `?${n}`), t;
};
function ZB(t, e, n, r, o) {
  const s = e[n];
  for (let i = 0; i < s.length; i++) {
    const u = s[i];
    n < e.length - 1 ? ZB(t.replace(r[n], u), e, n + 1, r, o) : o.push(t.replace(r[n], u));
  }
}
function Cke(t) {
  const e = /\{(.*?)\}/g, n = t.match(e), r = [];
  if (n) {
    const o = [];
    n.forEach((s) => {
      const i = s.substring(1, s.length - 1).split(",");
      o.push(i);
    }), ZB(t, o, 0, n, r);
  } else
    r.push(t);
  return r;
}
const dv = (t) => !Array.isArray(t);
class Oke {
  constructor() {
    this._parsers = [], this._cache = /* @__PURE__ */ new Map(), this._cacheMap = /* @__PURE__ */ new Map();
  }
  /** Clear all entries. */
  reset() {
    this._cacheMap.clear(), this._cache.clear();
  }
  /**
   * Check if the key exists
   * @param key - The key to check
   */
  has(e) {
    return this._cache.has(e);
  }
  /**
   * Fetch entry by key
   * @param key - The key of the entry to get
   */
  get(e) {
    const n = this._cache.get(e);
    return n || console.warn(`[Assets] Asset id ${e} was not found in the Cache`), n;
  }
  /**
   * Set a value by key or keys name
   * @param key - The key or keys to set
   * @param value - The value to store in the cache or from which cacheable assets will be derived.
   */
  set(e, n) {
    const r = ui(e);
    let o;
    for (let u = 0; u < this.parsers.length; u++) {
      const l = this.parsers[u];
      if (l.test(n)) {
        o = l.getCacheableAssets(r, n);
        break;
      }
    }
    o || (o = {}, r.forEach((u) => {
      o[u] = n;
    }));
    const s = Object.keys(o), i = {
      cacheKeys: s,
      keys: r
    };
    if (r.forEach((u) => {
      this._cacheMap.set(u, i);
    }), s.forEach((u) => {
      this._cache.has(u) && this._cache.get(u) !== n && console.warn("[Cache] already has key:", u), this._cache.set(u, o[u]);
    }), n instanceof pt) {
      const u = n;
      r.forEach((l) => {
        u.baseTexture !== pt.EMPTY.baseTexture && qt.addToCache(u.baseTexture, l), pt.addToCache(u, l);
      });
    }
  }
  /**
   * Remove entry by key
   *
   * This function will also remove any associated alias from the cache also.
   * @param key - The key of the entry to remove
   */
  remove(e) {
    if (!this._cacheMap.has(e)) {
      console.warn(`[Assets] Asset id ${e} was not found in the Cache`);
      return;
    }
    const n = this._cacheMap.get(e);
    n.cacheKeys.forEach((r) => {
      this._cache.delete(r);
    }), n.keys.forEach((r) => {
      this._cacheMap.delete(r);
    });
  }
  /** All loader parsers registered */
  get parsers() {
    return this._parsers;
  }
}
const lp = new Oke();
class Ike {
  constructor() {
    this._parsers = [], this._parsersValidated = !1, this.parsers = new Proxy(this._parsers, {
      set: (e, n, r) => (this._parsersValidated = !1, e[n] = r, !0)
    }), this.promiseCache = {};
  }
  /** function used for testing */
  reset() {
    this._parsersValidated = !1, this.promiseCache = {};
  }
  /**
   * Used internally to generate a promise for the asset to be loaded.
   * @param url - The URL to be loaded
   * @param data - any custom additional information relevant to the asset being loaded
   * @returns - a promise that will resolve to an Asset for example a Texture of a JSON object
   */
  _getLoadPromiseAndParser(e, n) {
    const r = {
      promise: null,
      parser: null
    };
    return r.promise = (async () => {
      let o = null, s = null;
      if (n.loadParser && (s = this._parserHash[n.loadParser], s || console.warn(`[Assets] specified load parser "${n.loadParser}" not found while loading ${e}`)), !s) {
        for (let i = 0; i < this.parsers.length; i++) {
          const u = this.parsers[i];
          if (u.load && u.test?.(e, n, this)) {
            s = u;
            break;
          }
        }
        if (!s)
          return console.warn(`[Assets] ${e} could not be loaded as we don't know how to parse it, ensure the correct parser has been added`), null;
      }
      o = await s.load(e, n, this), r.parser = s;
      for (let i = 0; i < this.parsers.length; i++) {
        const u = this.parsers[i];
        u.parse && u.parse && await u.testParse?.(o, n, this) && (o = await u.parse(o, n, this) || o, r.parser = u);
      }
      return o;
    })(), r;
  }
  async load(e, n) {
    this._parsersValidated || this._validateParsers();
    let r = 0;
    const o = {}, s = dv(e), i = ui(e, (a) => ({
      alias: [a],
      src: a
    })), u = i.length, l = i.map(async (a) => {
      const c = lo.toAbsolute(a.src);
      if (!o[a.src])
        try {
          this.promiseCache[c] || (this.promiseCache[c] = this._getLoadPromiseAndParser(c, a)), o[a.src] = await this.promiseCache[c].promise, n && n(++r / u);
        } catch (p) {
          throw delete this.promiseCache[c], delete o[a.src], new Error(`[Loader.load] Failed to load ${c}.
${p}`);
        }
    });
    return await Promise.all(l), s ? o[i[0].src] : o;
  }
  /**
   * Unloads one or more assets. Any unloaded assets will be destroyed, freeing up memory for your app.
   * The parser that created the asset, will be the one that unloads it.
   * @example
   * // Single asset:
   * const asset = await Loader.load('cool.png');
   *
   * await Loader.unload('cool.png');
   *
   * console.log(asset.destroyed); // true
   * @param assetsToUnloadIn - urls that you want to unload, or a single one!
   */
  async unload(e) {
    const n = ui(e, (r) => ({
      alias: [r],
      src: r
    })).map(async (r) => {
      const o = lo.toAbsolute(r.src), s = this.promiseCache[o];
      if (s) {
        const i = await s.promise;
        delete this.promiseCache[o], s.parser?.unload?.(i, r, this);
      }
    });
    await Promise.all(n);
  }
  /** validates our parsers, right now it only checks for name conflicts but we can add more here as required! */
  _validateParsers() {
    this._parsersValidated = !0, this._parserHash = this._parsers.filter((e) => e.name).reduce((e, n) => (e[n.name] && console.warn(`[Assets] loadParser name conflict "${n.name}"`), { ...e, [n.name]: n }), {});
  }
}
var Si = /* @__PURE__ */ ((t) => (t[t.Low = 0] = "Low", t[t.Normal = 1] = "Normal", t[t.High = 2] = "High", t))(Si || {});
const Fke = ".json", Nke = "application/json", Lke = {
  extension: {
    type: rt.LoadParser,
    priority: Si.Low
  },
  name: "loadJson",
  test(t) {
    return jh(t, Nke) || Oc(t, Fke);
  },
  async load(t) {
    return await (await at.ADAPTER.fetch(t)).json();
  }
};
dt.add(Lke);
const Bke = ".txt", Uke = "text/plain", Xke = {
  name: "loadTxt",
  extension: {
    type: rt.LoadParser,
    priority: Si.Low
  },
  test(t) {
    return jh(t, Uke) || Oc(t, Bke);
  },
  async load(t) {
    return await (await at.ADAPTER.fetch(t)).text();
  }
};
dt.add(Xke);
const $ke = [
  "normal",
  "bold",
  "100",
  "200",
  "300",
  "400",
  "500",
  "600",
  "700",
  "800",
  "900"
], Wke = [".ttf", ".otf", ".woff", ".woff2"], Vke = [
  "font/ttf",
  "font/otf",
  "font/woff",
  "font/woff2"
], Hke = /^(--|-?[A-Z_])[0-9A-Z_-]*$/i;
function jke(t) {
  const e = lo.extname(t), n = lo.basename(t, e).replace(/(-|_)/g, " ").toLowerCase().split(" ").map((s) => s.charAt(0).toUpperCase() + s.slice(1));
  let r = n.length > 0;
  for (const s of n)
    if (!s.match(Hke)) {
      r = !1;
      break;
    }
  let o = n.join(" ");
  return r || (o = `"${o.replace(/[\\"]/g, "\\$&")}"`), o;
}
const zke = /^[0-9A-Za-z%:/?#\[\]@!\$&'()\*\+,;=\-._~]*$/;
function qke(t) {
  return zke.test(t) ? t : encodeURI(t);
}
const Gke = {
  extension: {
    type: rt.LoadParser,
    priority: Si.Low
  },
  name: "loadWebFont",
  test(t) {
    return jh(t, Vke) || Oc(t, Wke);
  },
  async load(t, e) {
    const n = at.ADAPTER.getFontFaceSet();
    if (n) {
      const r = [], o = e.data?.family ?? jke(t), s = e.data?.weights?.filter((u) => $ke.includes(u)) ?? ["normal"], i = e.data ?? {};
      for (let u = 0; u < s.length; u++) {
        const l = s[u], a = new FontFace(o, `url(${qke(t)})`, {
          ...i,
          weight: l
        });
        await a.load(), n.add(a), r.push(a);
      }
      return r.length === 1 ? r[0] : r;
    }
    return console.warn("[loadWebFont] FontFace API is not supported. Skipping loading font"), null;
  },
  unload(t) {
    (Array.isArray(t) ? t : [t]).forEach((e) => at.ADAPTER.getFontFaceSet().delete(e));
  }
};
dt.add(Gke);
let zC = 0, xb;
const Yke = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8/x8AAwMCAO+ip1sAAAAASUVORK5CYII=", Qke = {
  code: `
    async function checkImageBitmap()
    {
        try
        {
            if (typeof createImageBitmap !== 'function') return false;

            const response = await fetch('${Yke}');
            const imageBlob =  await response.blob();
            const imageBitmap = await createImageBitmap(imageBlob);

            return imageBitmap.width === 1 && imageBitmap.height === 1;
        }
        catch (e)
        {
            return false;
        }
    }
    checkImageBitmap().then((result) => { self.postMessage(result); });
    `
}, Kke = {
  code: `
    async function loadImageBitmap(url)
    {
        const response = await fetch(url);

        if (!response.ok)
        {
            throw new Error(\`[WorkerManager.loadImageBitmap] Failed to fetch \${url}: \`
                + \`\${response.status} \${response.statusText}\`);
        }

        const imageBlob =  await response.blob();
        const imageBitmap = await createImageBitmap(imageBlob);

        return imageBitmap;
    }
    self.onmessage = async (event) =>
    {
        try
        {
            const imageBitmap = await loadImageBitmap(event.data.data[0]);

            self.postMessage({
                data: imageBitmap,
                uuid: event.data.uuid,
                id: event.data.id,
            }, [imageBitmap]);
        }
        catch(e)
        {
            self.postMessage({
                error: e,
                uuid: event.data.uuid,
                id: event.data.id,
            });
        }
    };`
};
let Sb;
class Zke {
  constructor() {
    this._initialized = !1, this._createdWorkers = 0, this.workerPool = [], this.queue = [], this.resolveHash = {};
  }
  isImageBitmapSupported() {
    return this._isImageBitmapSupported !== void 0 ? this._isImageBitmapSupported : (this._isImageBitmapSupported = new Promise((e) => {
      const n = URL.createObjectURL(new Blob(
        [Qke.code],
        { type: "application/javascript" }
      )), r = new Worker(n);
      r.addEventListener("message", (o) => {
        r.terminate(), URL.revokeObjectURL(n), e(o.data);
      });
    }), this._isImageBitmapSupported);
  }
  loadImageBitmap(e) {
    return this._run("loadImageBitmap", [e]);
  }
  async _initWorkers() {
    this._initialized || (this._initialized = !0);
  }
  getWorker() {
    xb === void 0 && (xb = navigator.hardwareConcurrency || 4);
    let e = this.workerPool.pop();
    return !e && this._createdWorkers < xb && (Sb || (Sb = URL.createObjectURL(new Blob([Kke.code], { type: "application/javascript" }))), this._createdWorkers++, e = new Worker(Sb), e.addEventListener("message", (n) => {
      this.complete(n.data), this.returnWorker(n.target), this.next();
    })), e;
  }
  returnWorker(e) {
    this.workerPool.push(e);
  }
  complete(e) {
    e.error !== void 0 ? this.resolveHash[e.uuid].reject(e.error) : this.resolveHash[e.uuid].resolve(e.data), this.resolveHash[e.uuid] = null;
  }
  async _run(e, n) {
    await this._initWorkers();
    const r = new Promise((o, s) => {
      this.queue.push({ id: e, arguments: n, resolve: o, reject: s });
    });
    return this.next(), r;
  }
  next() {
    if (!this.queue.length)
      return;
    const e = this.getWorker();
    if (!e)
      return;
    const n = this.queue.pop(), r = n.id;
    this.resolveHash[zC] = { resolve: n.resolve, reject: n.reject }, e.postMessage({
      data: n.arguments,
      uuid: zC++,
      id: r
    });
  }
}
const qC = new Zke();
function cy(t, e, n) {
  t.resource.internal = !0;
  const r = new pt(t), o = () => {
    delete e.promiseCache[n], lp.has(n) && lp.remove(n);
  };
  return r.baseTexture.once("destroyed", () => {
    n in e.promiseCache && (console.warn("[Assets] A BaseTexture managed by Assets was destroyed instead of unloaded! Use Assets.unload() instead of destroying the BaseTexture."), o());
  }), r.once("destroyed", () => {
    t.destroyed || (console.warn("[Assets] A Texture managed by Assets was destroyed instead of unloaded! Use Assets.unload() instead of destroying the Texture."), o());
  }), r;
}
const Jke = [".jpeg", ".jpg", ".png", ".webp", ".avif"], eTe = [
  "image/jpeg",
  "image/png",
  "image/webp",
  "image/avif"
];
async function tTe(t) {
  const e = await at.ADAPTER.fetch(t);
  if (!e.ok)
    throw new Error(`[loadImageBitmap] Failed to fetch ${t}: ${e.status} ${e.statusText}`);
  const n = await e.blob();
  return await createImageBitmap(n);
}
const j_ = {
  name: "loadTextures",
  extension: {
    type: rt.LoadParser,
    priority: Si.High
  },
  config: {
    preferWorkers: !0,
    preferCreateImageBitmap: !0,
    crossOrigin: "anonymous"
  },
  test(t) {
    return jh(t, eTe) || Oc(t, Jke);
  },
  async load(t, e, n) {
    const r = globalThis.createImageBitmap && this.config.preferCreateImageBitmap;
    let o;
    r ? this.config.preferWorkers && await qC.isImageBitmapSupported() ? o = await qC.loadImageBitmap(t) : o = await tTe(t) : o = await new Promise((u, l) => {
      const a = new Image();
      a.crossOrigin = this.config.crossOrigin, a.src = t, a.complete ? u(a) : (a.onload = () => u(a), a.onerror = (c) => l(c));
    });
    const s = { ...e.data };
    s.resolution ?? (s.resolution = al(t)), r && s.resourceOptions?.ownsImageBitmap === void 0 && (s.resourceOptions = { ...s.resourceOptions }, s.resourceOptions.ownsImageBitmap = !0);
    const i = new qt(o, s);
    return i.resource.src = t, cy(i, n, t);
  },
  unload(t) {
    t.destroy(!0);
  }
};
dt.add(j_);
const nTe = ".svg", rTe = "image/svg+xml", oTe = {
  extension: {
    type: rt.LoadParser,
    priority: Si.High
  },
  name: "loadSVG",
  test(t) {
    return jh(t, rTe) || Oc(t, nTe);
  },
  async testParse(t) {
    return fT.test(t);
  },
  async parse(t, e, n) {
    const r = new fT(t, e?.data?.resourceOptions);
    await r.load();
    const o = new qt(r, {
      resolution: al(t),
      ...e?.data
    });
    return o.resource.src = e.src, cy(o, n, e.src);
  },
  async load(t, e) {
    return (await at.ADAPTER.fetch(t)).text();
  },
  unload: j_.unload
};
dt.add(oTe);
const sTe = [".mp4", ".m4v", ".webm", ".ogv"], aTe = [
  "video/mp4",
  "video/webm",
  "video/ogg"
], iTe = {
  name: "loadVideo",
  extension: {
    type: rt.LoadParser,
    priority: Si.High
  },
  config: {
    defaultAutoPlay: !0
  },
  test(t) {
    return jh(t, aTe) || Oc(t, sTe);
  },
  async load(t, e, n) {
    let r;
    const o = await (await at.ADAPTER.fetch(t)).blob(), s = URL.createObjectURL(o);
    try {
      const i = {
        autoPlay: this.config.defaultAutoPlay,
        ...e?.data?.resourceOptions
      }, u = new jB(s, i);
      await u.load();
      const l = new qt(u, {
        alphaMode: await f1e(),
        resolution: al(t),
        ...e?.data
      });
      l.resource.src = t, r = cy(l, n, t), r.baseTexture.once("destroyed", () => {
        URL.revokeObjectURL(s);
      });
    } catch (i) {
      throw URL.revokeObjectURL(s), i;
    }
    return r;
  },
  unload(t) {
    t.destroy(!0);
  }
};
dt.add(iTe);
class uTe {
  constructor() {
    this._defaultBundleIdentifierOptions = {
      connector: "-",
      createBundleAssetId: (e, n) => `${e}${this._bundleIdConnector}${n}`,
      extractAssetIdFromBundle: (e, n) => n.replace(`${e}${this._bundleIdConnector}`, "")
    }, this._bundleIdConnector = this._defaultBundleIdentifierOptions.connector, this._createBundleAssetId = this._defaultBundleIdentifierOptions.createBundleAssetId, this._extractAssetIdFromBundle = this._defaultBundleIdentifierOptions.extractAssetIdFromBundle, this._assetMap = {}, this._preferredOrder = [], this._parsers = [], this._resolverHash = {}, this._bundles = {};
  }
  /**
   * Override how the resolver deals with generating bundle ids.
   * must be called before any bundles are added
   * @param bundleIdentifier - the bundle identifier options
   */
  setBundleIdentifier(e) {
    if (this._bundleIdConnector = e.connector ?? this._bundleIdConnector, this._createBundleAssetId = e.createBundleAssetId ?? this._createBundleAssetId, this._extractAssetIdFromBundle = e.extractAssetIdFromBundle ?? this._extractAssetIdFromBundle, this._extractAssetIdFromBundle("foo", this._createBundleAssetId("foo", "bar")) !== "bar")
      throw new Error("[Resolver] GenerateBundleAssetId are not working correctly");
  }
  /**
   * Let the resolver know which assets you prefer to use when resolving assets.
   * Multiple prefer user defined rules can be added.
   * @example
   * resolver.prefer({
   *     // first look for something with the correct format, and then then correct resolution
   *     priority: ['format', 'resolution'],
   *     params:{
   *         format:'webp', // prefer webp images
   *         resolution: 2, // prefer a resolution of 2
   *     }
   * })
   * resolver.add('foo', ['bar@2x.webp', 'bar@2x.png', 'bar.webp', 'bar.png']);
   * resolver.resolveUrl('foo') // => 'bar@2x.webp'
   * @param preferOrders - the prefer options
   */
  prefer(...e) {
    e.forEach((n) => {
      this._preferredOrder.push(n), n.priority || (n.priority = Object.keys(n.params));
    }), this._resolverHash = {};
  }
  /**
   * Set the base path to prepend to all urls when resolving
   * @example
   * resolver.basePath = 'https://home.com/';
   * resolver.add('foo', 'bar.ong');
   * resolver.resolveUrl('foo', 'bar.png'); // => 'https://home.com/bar.png'
   * @param basePath - the base path to use
   */
  set basePath(e) {
    this._basePath = e;
  }
  get basePath() {
    return this._basePath;
  }
  /**
   * Set the root path for root-relative URLs. By default the `basePath`'s root is used. If no `basePath` is set, then the
   * default value for browsers is `window.location.origin`
   * @example
   * // Application hosted on https://home.com/some-path/index.html
   * resolver.basePath = 'https://home.com/some-path/';
   * resolver.rootPath = 'https://home.com/';
   * resolver.add('foo', '/bar.png');
   * resolver.resolveUrl('foo', '/bar.png'); // => 'https://home.com/bar.png'
   * @param rootPath - the root path to use
   */
  set rootPath(e) {
    this._rootPath = e;
  }
  get rootPath() {
    return this._rootPath;
  }
  /**
   * All the active URL parsers that help the parser to extract information and create
   * an asset object-based on parsing the URL itself.
   *
   * Can be added using the extensions API
   * @example
   * resolver.add('foo', [
   *     {
   *         resolution: 2,
   *         format: 'png',
   *         src: 'image@2x.png',
   *     },
   *     {
   *         resolution:1,
   *         format:'png',
   *         src: 'image.png',
   *     },
   * ]);
   *
   * // With a url parser the information such as resolution and file format could extracted from the url itself:
   * extensions.add({
   *     extension: ExtensionType.ResolveParser,
   *     test: loadTextures.test, // test if url ends in an image
   *     parse: (value: string) =>
   *     ({
   *         resolution: parseFloat(settings.RETINA_PREFIX.exec(value)?.[1] ?? '1'),
   *         format: value.split('.').pop(),
   *         src: value,
   *     }),
   * });
   *
   * // Now resolution and format can be extracted from the url
   * resolver.add('foo', [
   *     'image@2x.png',
   *     'image.png',
   * ]);
   */
  get parsers() {
    return this._parsers;
  }
  /** Used for testing, this resets the resolver to its initial state */
  reset() {
    this.setBundleIdentifier(this._defaultBundleIdentifierOptions), this._assetMap = {}, this._preferredOrder = [], this._resolverHash = {}, this._rootPath = null, this._basePath = null, this._manifest = null, this._bundles = {}, this._defaultSearchParams = null;
  }
  /**
   * Sets the default URL search parameters for the URL resolver. The urls can be specified as a string or an object.
   * @param searchParams - the default url parameters to append when resolving urls
   */
  setDefaultSearchParams(e) {
    if (typeof e == "string")
      this._defaultSearchParams = e;
    else {
      const n = e;
      this._defaultSearchParams = Object.keys(n).map((r) => `${encodeURIComponent(r)}=${encodeURIComponent(n[r])}`).join("&");
    }
  }
  /**
   * Returns the aliases for a given asset
   * @param asset - the asset to get the aliases for
   */
  getAlias(e) {
    const { alias: n, name: r, src: o, srcs: s } = e;
    return ui(
      n || r || o || s,
      (i) => typeof i == "string" ? i : Array.isArray(i) ? i.map((u) => u?.src ?? u?.srcs ?? u) : i?.src || i?.srcs ? i.src ?? i.srcs : i,
      !0
    );
  }
  /**
   * Add a manifest to the asset resolver. This is a nice way to add all the asset information in one go.
   * generally a manifest would be built using a tool.
   * @param manifest - the manifest to add to the resolver
   */
  addManifest(e) {
    this._manifest && console.warn("[Resolver] Manifest already exists, this will be overwritten"), this._manifest = e, e.bundles.forEach((n) => {
      this.addBundle(n.name, n.assets);
    });
  }
  /**
   * This adds a bundle of assets in one go so that you can resolve them as a group.
   * For example you could add a bundle for each screen in you pixi app
   * @example
   * resolver.addBundle('animals', {
   *     bunny: 'bunny.png',
   *     chicken: 'chicken.png',
   *     thumper: 'thumper.png',
   * });
   *
   * const resolvedAssets = await resolver.resolveBundle('animals');
   * @param bundleId - The id of the bundle to add
   * @param assets - A record of the asset or assets that will be chosen from when loading via the specified key
   */
  addBundle(e, n) {
    const r = [];
    Array.isArray(n) ? n.forEach((o) => {
      const s = o.src ?? o.srcs, i = o.alias ?? o.name;
      let u;
      if (typeof i == "string") {
        const l = this._createBundleAssetId(e, i);
        r.push(l), u = [i, l];
      } else {
        const l = i.map((a) => this._createBundleAssetId(e, a));
        r.push(...l), u = [...i, ...l];
      }
      this.add({
        ...o,
        alias: u,
        src: s
      });
    }) : Object.keys(n).forEach((o) => {
      const s = [o, this._createBundleAssetId(e, o)];
      if (typeof n[o] == "string")
        this.add({
          alias: s,
          src: n[o]
        });
      else if (Array.isArray(n[o]))
        this.add({
          alias: s,
          src: n[o]
        });
      else {
        const i = n[o], u = i.src ?? i.srcs;
        this.add({
          ...i,
          alias: s,
          src: Array.isArray(u) ? u : [u]
        });
      }
      r.push(...s);
    }), this._bundles[e] = r;
  }
  add(e, n, r, o, s) {
    const i = [];
    typeof e == "string" || Array.isArray(e) && typeof e[0] == "string" ? (un("7.2.0", `Assets.add now uses an object instead of individual parameters.
Please use Assets.add({ alias, src, data, format, loadParser }) instead.`), i.push({ alias: e, src: n, data: r, format: o, loadParser: s })) : Array.isArray(e) ? i.push(...e) : i.push(e);
    let u;
    u = (l) => {
      this.hasKey(l) && console.warn(`[Resolver] already has key: ${l} overwriting`);
    }, ui(i).forEach((l) => {
      const { src: a, srcs: c } = l;
      let { data: p, format: d, loadParser: h } = l;
      const m = ui(a || c).map((b) => typeof b == "string" ? Cke(b) : Array.isArray(b) ? b : [b]), g = this.getAlias(l);
      Array.isArray(g) ? g.forEach(u) : u(g);
      const _ = [];
      m.forEach((b) => {
        b.forEach((x) => {
          let S = {};
          if (typeof x != "object") {
            S.src = x;
            for (let E = 0; E < this._parsers.length; E++) {
              const A = this._parsers[E];
              if (A.test(x)) {
                S = A.parse(x);
                break;
              }
            }
          } else
            p = x.data ?? p, d = x.format ?? d, h = x.loadParser ?? h, S = {
              ...S,
              ...x
            };
          if (!g)
            throw new Error(`[Resolver] alias is undefined for this asset: ${S.src}`);
          S = this.buildResolvedAsset(S, {
            aliases: g,
            data: p,
            format: d,
            loadParser: h
          }), _.push(S);
        });
      }), g.forEach((b) => {
        this._assetMap[b] = _;
      });
    });
  }
  // TODO: this needs an overload like load did in Assets
  /**
   * If the resolver has had a manifest set via setManifest, this will return the assets urls for
   * a given bundleId or bundleIds.
   * @example
   * // Manifest Example
   * const manifest = {
   *     bundles: [
   *         {
   *             name: 'load-screen',
   *             assets: [
   *                 {
   *                     alias: 'background',
   *                     src: 'sunset.png',
   *                 },
   *                 {
   *                     alias: 'bar',
   *                     src: 'load-bar.{png,webp}',
   *                 },
   *             ],
   *         },
   *         {
   *             name: 'game-screen',
   *             assets: [
   *                 {
   *                     alias: 'character',
   *                     src: 'robot.png',
   *                 },
   *                 {
   *                     alias: 'enemy',
   *                     src: 'bad-guy.png',
   *                 },
   *             ],
   *         },
   *     ]
   * };
   *
   * resolver.setManifest(manifest);
   * const resolved = resolver.resolveBundle('load-screen');
   * @param bundleIds - The bundle ids to resolve
   * @returns All the bundles assets or a hash of assets for each bundle specified
   */
  resolveBundle(e) {
    const n = dv(e);
    e = ui(e);
    const r = {};
    return e.forEach((o) => {
      const s = this._bundles[o];
      if (s) {
        const i = this.resolve(s), u = {};
        for (const l in i) {
          const a = i[l];
          u[this._extractAssetIdFromBundle(o, l)] = a;
        }
        r[o] = u;
      }
    }), n ? r[e[0]] : r;
  }
  /**
   * Does exactly what resolve does, but returns just the URL rather than the whole asset object
   * @param key - The key or keys to resolve
   * @returns - The URLs associated with the key(s)
   */
  resolveUrl(e) {
    const n = this.resolve(e);
    if (typeof e != "string") {
      const r = {};
      for (const o in n)
        r[o] = n[o].src;
      return r;
    }
    return n.src;
  }
  resolve(e) {
    const n = dv(e);
    e = ui(e);
    const r = {};
    return e.forEach((o) => {
      if (!this._resolverHash[o])
        if (this._assetMap[o]) {
          let s = this._assetMap[o];
          const i = s[0], u = this._getPreferredOrder(s);
          u?.priority.forEach((l) => {
            u.params[l].forEach((a) => {
              const c = s.filter((p) => p[l] ? p[l] === a : !1);
              c.length && (s = c);
            });
          }), this._resolverHash[o] = s[0] ?? i;
        } else
          this._resolverHash[o] = this.buildResolvedAsset({
            alias: [o],
            src: o
          }, {});
      r[o] = this._resolverHash[o];
    }), n ? r[e[0]] : r;
  }
  /**
   * Checks if an asset with a given key exists in the resolver
   * @param key - The key of the asset
   */
  hasKey(e) {
    return !!this._assetMap[e];
  }
  /**
   * Checks if a bundle with the given key exists in the resolver
   * @param key - The key of the bundle
   */
  hasBundle(e) {
    return !!this._bundles[e];
  }
  /**
   * Internal function for figuring out what prefer criteria an asset should use.
   * @param assets
   */
  _getPreferredOrder(e) {
    for (let n = 0; n < e.length; n++) {
      const r = e[0], o = this._preferredOrder.find((s) => s.params.format.includes(r.format));
      if (o)
        return o;
    }
    return this._preferredOrder[0];
  }
  /**
   * Appends the default url parameters to the url
   * @param url - The url to append the default parameters to
   * @returns - The url with the default parameters appended
   */
  _appendDefaultSearchParams(e) {
    if (!this._defaultSearchParams)
      return e;
    const n = /\?/.test(e) ? "&" : "?";
    return `${e}${n}${this._defaultSearchParams}`;
  }
  buildResolvedAsset(e, n) {
    const { aliases: r, data: o, loadParser: s, format: i } = n;
    return (this._basePath || this._rootPath) && (e.src = lo.toAbsolute(e.src, this._basePath, this._rootPath)), e.alias = r ?? e.alias ?? [e.src], e.src = this._appendDefaultSearchParams(e.src), e.data = { ...o || {}, ...e.data }, e.loadParser = s ?? e.loadParser, e.format = i ?? lo.extname(e.src).slice(1), e.srcs = e.src, e.name = e.alias, e;
  }
}
class lTe {
  constructor() {
    this._detections = [], this._initialized = !1, this.resolver = new uTe(), this.loader = new Ike(), this.cache = lp, this._backgroundLoader = new Pke(this.loader), this._backgroundLoader.active = !0, this.reset();
  }
  /**
   * Best practice is to call this function before any loading commences
   * Initiating is the best time to add any customization to the way things are loaded.
   *
   * you do not need to call this for the Asset class to work, only if you want to set any initial properties
   * @param options - options to initialize the Asset manager with
   */
  async init(e = {}) {
    if (this._initialized) {
      console.warn("[Assets]AssetManager already initialized, did you load before calling this Asset.init()?");
      return;
    }
    if (this._initialized = !0, e.defaultSearchParams && this.resolver.setDefaultSearchParams(e.defaultSearchParams), e.basePath && (this.resolver.basePath = e.basePath), e.bundleIdentifier && this.resolver.setBundleIdentifier(e.bundleIdentifier), e.manifest) {
      let s = e.manifest;
      typeof s == "string" && (s = await this.load(s)), this.resolver.addManifest(s);
    }
    const n = e.texturePreference?.resolution ?? 1, r = typeof n == "number" ? [n] : n, o = await this._detectFormats({
      preferredFormats: e.texturePreference?.format,
      skipDetections: e.skipDetections,
      detections: this._detections
    });
    this.resolver.prefer({
      params: {
        format: o,
        resolution: r
      }
    }), e.preferences && this.setPreferences(e.preferences);
  }
  add(e, n, r, o, s) {
    this.resolver.add(e, n, r, o, s);
  }
  async load(e, n) {
    this._initialized || await this.init();
    const r = dv(e), o = ui(e).map((u) => {
      if (typeof u != "string") {
        const l = this.resolver.getAlias(u);
        return l.some((a) => !this.resolver.hasKey(a)) && this.add(u), Array.isArray(l) ? l[0] : l;
      }
      return this.resolver.hasKey(u) || this.add({ alias: u, src: u }), u;
    }), s = this.resolver.resolve(o), i = await this._mapLoadToResolve(s, n);
    return r ? i[o[0]] : i;
  }
  /**
   * This adds a bundle of assets in one go so that you can load them as a group.
   * For example you could add a bundle for each screen in you pixi app
   * @example
   * import { Assets } from 'pixi.js';
   *
   * Assets.addBundle('animals', {
   *     bunny: 'bunny.png',
   *     chicken: 'chicken.png',
   *     thumper: 'thumper.png',
   * });
   *
   * const assets = await Assets.loadBundle('animals');
   * @param bundleId - the id of the bundle to add
   * @param assets - a record of the asset or assets that will be chosen from when loading via the specified key
   */
  addBundle(e, n) {
    this.resolver.addBundle(e, n);
  }
  /**
   * Bundles are a way to load multiple assets at once.
   * If a manifest has been provided to the init function then you can load a bundle, or bundles.
   * you can also add bundles via `addBundle`
   * @example
   * import { Assets } from 'pixi.js';
   *
   * // Manifest Example
   * const manifest = {
   *     bundles: [
   *         {
   *             name: 'load-screen',
   *             assets: [
   *                 {
   *                     alias: 'background',
   *                     src: 'sunset.png',
   *                 },
   *                 {
   *                     alias: 'bar',
   *                     src: 'load-bar.{png,webp}',
   *                 },
   *             ],
   *         },
   *         {
   *             name: 'game-screen',
   *             assets: [
   *                 {
   *                     alias: 'character',
   *                     src: 'robot.png',
   *                 },
   *                 {
   *                     alias: 'enemy',
   *                     src: 'bad-guy.png',
   *                 },
   *             ],
   *         },
   *     ]
   * };
   *
   * await Asset.init({ manifest });
   *
   * // Load a bundle...
   * loadScreenAssets = await Assets.loadBundle('load-screen');
   * // Load another bundle...
   * gameScreenAssets = await Assets.loadBundle('game-screen');
   * @param bundleIds - the bundle id or ids to load
   * @param onProgress - Optional function that is called when progress on asset loading is made.
   * The function is passed a single parameter, `progress`, which represents the percentage (0.0 - 1.0)
   * of the assets loaded. Do not use this function to detect when assets are complete and available,
   * instead use the Promise returned by this function.
   * @returns all the bundles assets or a hash of assets for each bundle specified
   */
  async loadBundle(e, n) {
    this._initialized || await this.init();
    let r = !1;
    typeof e == "string" && (r = !0, e = [e]);
    const o = this.resolver.resolveBundle(e), s = {}, i = Object.keys(o);
    let u = 0, l = 0;
    const a = () => {
      n?.(++u / l);
    }, c = i.map((p) => {
      const d = o[p];
      return l += Object.keys(d).length, this._mapLoadToResolve(d, a).then((h) => {
        s[p] = h;
      });
    });
    return await Promise.all(c), r ? s[e[0]] : s;
  }
  /**
   * Initiate a background load of some assets. It will passively begin to load these assets in the background.
   * So when you actually come to loading them you will get a promise that resolves to the loaded assets immediately
   *
   * An example of this might be that you would background load game assets after your inital load.
   * then when you got to actually load your game screen assets when a player goes to the game - the loading
   * would already have stared or may even be complete, saving you having to show an interim load bar.
   * @example
   * import { Assets } from 'pixi.js';
   *
   * Assets.backgroundLoad('bunny.png');
   *
   * // later on in your app...
   * await Assets.loadBundle('bunny.png'); // Will resolve quicker as loading may have completed!
   * @param urls - the url / urls you want to background load
   */
  async backgroundLoad(e) {
    this._initialized || await this.init(), typeof e == "string" && (e = [e]);
    const n = this.resolver.resolve(e);
    this._backgroundLoader.add(Object.values(n));
  }
  /**
   * Initiate a background of a bundle, works exactly like backgroundLoad but for bundles.
   * this can only be used if the loader has been initiated with a manifest
   * @example
   * import { Assets } from 'pixi.js';
   *
   * await Assets.init({
   *     manifest: {
   *         bundles: [
   *             {
   *                 name: 'load-screen',
   *                 assets: [...],
   *             },
   *             ...
   *         ],
   *     },
   * });
   *
   * Assets.backgroundLoadBundle('load-screen');
   *
   * // Later on in your app...
   * await Assets.loadBundle('load-screen'); // Will resolve quicker as loading may have completed!
   * @param bundleIds - the bundleId / bundleIds you want to background load
   */
  async backgroundLoadBundle(e) {
    this._initialized || await this.init(), typeof e == "string" && (e = [e]);
    const n = this.resolver.resolveBundle(e);
    Object.values(n).forEach((r) => {
      this._backgroundLoader.add(Object.values(r));
    });
  }
  /**
   * Only intended for development purposes.
   * This will wipe the resolver and caches.
   * You will need to reinitialize the Asset
   */
  reset() {
    this.resolver.reset(), this.loader.reset(), this.cache.reset(), this._initialized = !1;
  }
  get(e) {
    if (typeof e == "string")
      return lp.get(e);
    const n = {};
    for (let r = 0; r < e.length; r++)
      n[r] = lp.get(e[r]);
    return n;
  }
  /**
   * helper function to map resolved assets back to loaded assets
   * @param resolveResults - the resolve results from the resolver
   * @param onProgress - the progress callback
   */
  async _mapLoadToResolve(e, n) {
    const r = Object.values(e), o = Object.keys(e);
    this._backgroundLoader.active = !1;
    const s = await this.loader.load(r, n);
    this._backgroundLoader.active = !0;
    const i = {};
    return r.forEach((u, l) => {
      const a = s[u.src], c = [u.src];
      u.alias && c.push(...u.alias), i[o[l]] = a, lp.set(c, a);
    }), i;
  }
  /**
   * Unload an asset or assets. As the Assets class is responsible for creating the assets via the `load` function
   * this will make sure to destroy any assets and release them from memory.
   * Once unloaded, you will need to load the asset again.
   *
   * Use this to help manage assets if you find that you have a large app and you want to free up memory.
   *
   * - it's up to you as the developer to make sure that textures are not actively being used when you unload them,
   * Pixi won't break but you will end up with missing assets. Not a good look for the user!
   * @example
   * import { Assets } from 'pixi.js';
   *
   * // Load a URL:
   * const myImageTexture = await Assets.load('http://some.url.com/image.png'); // => returns a texture
   *
   * await Assets.unload('http://some.url.com/image.png')
   *
   * // myImageTexture will be destroyed now.
   *
   * // Unload multiple assets:
   * const textures = await Assets.unload(['thumper', 'chicko']);
   * @param urls - the urls to unload
   */
  async unload(e) {
    this._initialized || await this.init();
    const n = ui(e).map((o) => typeof o != "string" ? o.src : o), r = this.resolver.resolve(n);
    await this._unloadFromResolved(r);
  }
  /**
   * Bundles are a way to manage multiple assets at once.
   * this will unload all files in a bundle.
   *
   * once a bundle has been unloaded, you need to load it again to have access to the assets.
   * @example
   * import { Assets } from 'pixi.js';
   *
   * Assets.addBundle({
   *     'thumper': 'http://some.url.com/thumper.png',
   * })
   *
   * const assets = await Assets.loadBundle('thumper');
   *
   * // Now to unload...
   *
   * await Assets.unloadBundle('thumper');
   *
   * // All assets in the assets object will now have been destroyed and purged from the cache
   * @param bundleIds - the bundle id or ids to unload
   */
  async unloadBundle(e) {
    this._initialized || await this.init(), e = ui(e);
    const n = this.resolver.resolveBundle(e), r = Object.keys(n).map((o) => this._unloadFromResolved(n[o]));
    await Promise.all(r);
  }
  async _unloadFromResolved(e) {
    const n = Object.values(e);
    n.forEach((r) => {
      lp.remove(r.src);
    }), await this.loader.unload(n);
  }
  /**
   * Detects the supported formats for the browser, and returns an array of supported formats, respecting
   * the users preferred formats order.
   * @param options - the options to use when detecting formats
   * @param options.preferredFormats - the preferred formats to use
   * @param options.skipDetections - if we should skip the detections altogether
   * @param options.detections - the detections to use
   * @returns - the detected formats
   */
  async _detectFormats(e) {
    let n = [];
    e.preferredFormats && (n = Array.isArray(e.preferredFormats) ? e.preferredFormats : [e.preferredFormats]);
    for (const r of e.detections)
      e.skipDetections || await r.test() ? n = await r.add(n) : e.skipDetections || (n = await r.remove(n));
    return n = n.filter((r, o) => n.indexOf(r) === o), n;
  }
  /** All the detection parsers currently added to the Assets class. */
  get detections() {
    return this._detections;
  }
  /**
   * @deprecated since 7.2.0
   * @see {@link Assets.setPreferences}
   */
  get preferWorkers() {
    return j_.config.preferWorkers;
  }
  set preferWorkers(e) {
    un("7.2.0", "Assets.prefersWorkers is deprecated, use Assets.setPreferences({ preferWorkers: true }) instead."), this.setPreferences({ preferWorkers: e });
  }
  /**
   * General setter for preferences. This is a helper function to set preferences on all parsers.
   * @param preferences - the preferences to set
   */
  setPreferences(e) {
    this.loader.parsers.forEach((n) => {
      n.config && Object.keys(n.config).filter((r) => r in e).forEach((r) => {
        n.config[r] = e[r];
      });
    });
  }
}
const Sg = new lTe();
dt.handleByList(rt.LoadParser, Sg.loader.parsers).handleByList(rt.ResolveParser, Sg.resolver.parsers).handleByList(rt.CacheParser, Sg.cache.parsers).handleByList(rt.DetectionParser, Sg.detections);
const cTe = {
  extension: rt.CacheParser,
  test: (t) => Array.isArray(t) && t.every((e) => e instanceof pt),
  getCacheableAssets: (t, e) => {
    const n = {};
    return t.forEach((r) => {
      e.forEach((o, s) => {
        n[r + (s === 0 ? "" : s + 1)] = o;
      });
    }), n;
  }
};
dt.add(cTe);
async function JB(t) {
  if ("Image" in globalThis)
    return new Promise((e) => {
      const n = new Image();
      n.onload = () => {
        e(!0);
      }, n.onerror = () => {
        e(!1);
      }, n.src = t;
    });
  if ("createImageBitmap" in globalThis && "fetch" in globalThis) {
    try {
      const e = await (await fetch(t)).blob();
      await createImageBitmap(e);
    } catch {
      return !1;
    }
    return !0;
  }
  return !1;
}
const pTe = {
  extension: {
    type: rt.DetectionParser,
    priority: 1
  },
  test: async () => JB(
    // eslint-disable-next-line max-len
    "data:image/avif;base64,AAAAIGZ0eXBhdmlmAAAAAGF2aWZtaWYxbWlhZk1BMUIAAADybWV0YQAAAAAAAAAoaGRscgAAAAAAAAAAcGljdAAAAAAAAAAAAAAAAGxpYmF2aWYAAAAADnBpdG0AAAAAAAEAAAAeaWxvYwAAAABEAAABAAEAAAABAAABGgAAAB0AAAAoaWluZgAAAAAAAQAAABppbmZlAgAAAAABAABhdjAxQ29sb3IAAAAAamlwcnAAAABLaXBjbwAAABRpc3BlAAAAAAAAAAIAAAACAAAAEHBpeGkAAAAAAwgICAAAAAxhdjFDgQ0MAAAAABNjb2xybmNseAACAAIAAYAAAAAXaXBtYQAAAAAAAAABAAEEAQKDBAAAACVtZGF0EgAKCBgANogQEAwgMg8f8D///8WfhwB8+ErK42A="
  ),
  add: async (t) => [...t, "avif"],
  remove: async (t) => t.filter((e) => e !== "avif")
};
dt.add(pTe);
const dTe = {
  extension: {
    type: rt.DetectionParser,
    priority: 0
  },
  test: async () => JB(
    "data:image/webp;base64,UklGRh4AAABXRUJQVlA4TBEAAAAvAAAAAAfQ//73v/+BiOh/AAA="
  ),
  add: async (t) => [...t, "webp"],
  remove: async (t) => t.filter((e) => e !== "webp")
};
dt.add(dTe);
const GC = ["png", "jpg", "jpeg"], hTe = {
  extension: {
    type: rt.DetectionParser,
    priority: -1
  },
  test: () => Promise.resolve(!0),
  add: async (t) => [...t, ...GC],
  remove: async (t) => t.filter((e) => !GC.includes(e))
};
dt.add(hTe);
const fTe = "WorkerGlobalScope" in globalThis && globalThis instanceof globalThis.WorkerGlobalScope;
function DS(t) {
  return fTe ? !1 : document.createElement("video").canPlayType(t) !== "";
}
const mTe = {
  extension: {
    type: rt.DetectionParser,
    priority: 0
  },
  test: async () => DS("video/webm"),
  add: async (t) => [...t, "webm"],
  remove: async (t) => t.filter((e) => e !== "webm")
};
dt.add(mTe);
const yTe = {
  extension: {
    type: rt.DetectionParser,
    priority: 0
  },
  test: async () => DS("video/mp4"),
  add: async (t) => [...t, "mp4", "m4v"],
  remove: async (t) => t.filter((e) => e !== "mp4" && e !== "m4v")
};
dt.add(yTe);
const gTe = {
  extension: {
    type: rt.DetectionParser,
    priority: 0
  },
  test: async () => DS("video/ogg"),
  add: async (t) => [...t, "ogv"],
  remove: async (t) => t.filter((e) => e !== "ogv")
};
dt.add(gTe);
const vTe = {
  extension: rt.ResolveParser,
  test: j_.test,
  parse: (t) => ({
    resolution: parseFloat(at.RETINA_PREFIX.exec(t)?.[1] ?? "1"),
    format: lo.extname(t).slice(1),
    src: t
  })
};
dt.add(vTe);
var js = /* @__PURE__ */ ((t) => (t[t.COMPRESSED_RGB_S3TC_DXT1_EXT = 33776] = "COMPRESSED_RGB_S3TC_DXT1_EXT", t[t.COMPRESSED_RGBA_S3TC_DXT1_EXT = 33777] = "COMPRESSED_RGBA_S3TC_DXT1_EXT", t[t.COMPRESSED_RGBA_S3TC_DXT3_EXT = 33778] = "COMPRESSED_RGBA_S3TC_DXT3_EXT", t[t.COMPRESSED_RGBA_S3TC_DXT5_EXT = 33779] = "COMPRESSED_RGBA_S3TC_DXT5_EXT", t[t.COMPRESSED_SRGB_ALPHA_S3TC_DXT1_EXT = 35917] = "COMPRESSED_SRGB_ALPHA_S3TC_DXT1_EXT", t[t.COMPRESSED_SRGB_ALPHA_S3TC_DXT3_EXT = 35918] = "COMPRESSED_SRGB_ALPHA_S3TC_DXT3_EXT", t[t.COMPRESSED_SRGB_ALPHA_S3TC_DXT5_EXT = 35919] = "COMPRESSED_SRGB_ALPHA_S3TC_DXT5_EXT", t[t.COMPRESSED_SRGB_S3TC_DXT1_EXT = 35916] = "COMPRESSED_SRGB_S3TC_DXT1_EXT", t[t.COMPRESSED_R11_EAC = 37488] = "COMPRESSED_R11_EAC", t[t.COMPRESSED_SIGNED_R11_EAC = 37489] = "COMPRESSED_SIGNED_R11_EAC", t[t.COMPRESSED_RG11_EAC = 37490] = "COMPRESSED_RG11_EAC", t[t.COMPRESSED_SIGNED_RG11_EAC = 37491] = "COMPRESSED_SIGNED_RG11_EAC", t[t.COMPRESSED_RGB8_ETC2 = 37492] = "COMPRESSED_RGB8_ETC2", t[t.COMPRESSED_RGBA8_ETC2_EAC = 37496] = "COMPRESSED_RGBA8_ETC2_EAC", t[t.COMPRESSED_SRGB8_ETC2 = 37493] = "COMPRESSED_SRGB8_ETC2", t[t.COMPRESSED_SRGB8_ALPHA8_ETC2_EAC = 37497] = "COMPRESSED_SRGB8_ALPHA8_ETC2_EAC", t[t.COMPRESSED_RGB8_PUNCHTHROUGH_ALPHA1_ETC2 = 37494] = "COMPRESSED_RGB8_PUNCHTHROUGH_ALPHA1_ETC2", t[t.COMPRESSED_SRGB8_PUNCHTHROUGH_ALPHA1_ETC2 = 37495] = "COMPRESSED_SRGB8_PUNCHTHROUGH_ALPHA1_ETC2", t[t.COMPRESSED_RGB_PVRTC_4BPPV1_IMG = 35840] = "COMPRESSED_RGB_PVRTC_4BPPV1_IMG", t[t.COMPRESSED_RGBA_PVRTC_4BPPV1_IMG = 35842] = "COMPRESSED_RGBA_PVRTC_4BPPV1_IMG", t[t.COMPRESSED_RGB_PVRTC_2BPPV1_IMG = 35841] = "COMPRESSED_RGB_PVRTC_2BPPV1_IMG", t[t.COMPRESSED_RGBA_PVRTC_2BPPV1_IMG = 35843] = "COMPRESSED_RGBA_PVRTC_2BPPV1_IMG", t[t.COMPRESSED_RGB_ETC1_WEBGL = 36196] = "COMPRESSED_RGB_ETC1_WEBGL", t[t.COMPRESSED_RGB_ATC_WEBGL = 35986] = "COMPRESSED_RGB_ATC_WEBGL", t[t.COMPRESSED_RGBA_ATC_EXPLICIT_ALPHA_WEBGL = 35986] = "COMPRESSED_RGBA_ATC_EXPLICIT_ALPHA_WEBGL", t[t.COMPRESSED_RGBA_ATC_INTERPOLATED_ALPHA_WEBGL = 34798] = "COMPRESSED_RGBA_ATC_INTERPOLATED_ALPHA_WEBGL", t[t.COMPRESSED_RGBA_ASTC_4x4_KHR = 37808] = "COMPRESSED_RGBA_ASTC_4x4_KHR", t))(js || {});
const hv = {
  // WEBGL_compressed_texture_s3tc
  33776: 0.5,
  33777: 0.5,
  33778: 1,
  33779: 1,
  // WEBGL_compressed_texture_s3tc
  35916: 0.5,
  35917: 0.5,
  35918: 1,
  35919: 1,
  // WEBGL_compressed_texture_etc
  37488: 0.5,
  37489: 0.5,
  37490: 1,
  37491: 1,
  37492: 0.5,
  37496: 1,
  37493: 0.5,
  37497: 1,
  37494: 0.5,
  // ~~
  37495: 0.5,
  // ~~
  // WEBGL_compressed_texture_pvrtc
  35840: 0.5,
  35842: 0.5,
  35841: 0.25,
  35843: 0.25,
  // WEBGL_compressed_texture_etc1
  36196: 0.5,
  // @see https://www.khronos.org/registry/OpenGL/extensions/AMD/AMD_compressed_ATC_texture.txt
  // WEBGL_compressed_texture_atc
  35986: 0.5,
  35986: 1,
  34798: 1,
  // @see https://registry.khronos.org/OpenGL/extensions/KHR/KHR_texture_compression_astc_hdr.txt
  // WEBGL_compressed_texture_astc
  /* eslint-disable-next-line camelcase */
  37808: 1
};
let Hu, Od;
function YC() {
  Od = {
    s3tc: Hu.getExtension("WEBGL_compressed_texture_s3tc"),
    s3tc_sRGB: Hu.getExtension("WEBGL_compressed_texture_s3tc_srgb"),
    /* eslint-disable-line camelcase */
    etc: Hu.getExtension("WEBGL_compressed_texture_etc"),
    etc1: Hu.getExtension("WEBGL_compressed_texture_etc1"),
    pvrtc: Hu.getExtension("WEBGL_compressed_texture_pvrtc") || Hu.getExtension("WEBKIT_WEBGL_compressed_texture_pvrtc"),
    atc: Hu.getExtension("WEBGL_compressed_texture_atc"),
    astc: Hu.getExtension("WEBGL_compressed_texture_astc")
  };
}
const _Te = {
  extension: {
    type: rt.DetectionParser,
    priority: 2
  },
  test: async () => {
    const t = at.ADAPTER.createCanvas().getContext("webgl");
    return t ? (Hu = t, !0) : (console.warn("WebGL not available for compressed textures."), !1);
  },
  add: async (t) => {
    Od || YC();
    const e = [];
    for (const n in Od)
      Od[n] && e.push(n);
    return [...e, ...t];
  },
  remove: async (t) => (Od || YC(), t.filter((e) => !(e in Od)))
};
dt.add(_Te);
class wTe extends X_ {
  /**
   * @param source - The buffer/URL of the texture file.
   * @param {PIXI.IBlobResourceOptions} [options]
   * @param {boolean} [options.autoLoad=false] - Whether to fetch the data immediately;
   *  you can fetch it later via {@link PIXI.BlobResource#load}.
   * @param {number} [options.width=1] - The width in pixels.
   * @param {number} [options.height=1] - The height in pixels.
   * @param {1|2|4|8} [options.unpackAlignment=4] - The alignment of the pixel rows.
   */
  constructor(e, n = { width: 1, height: 1, autoLoad: !0 }) {
    let r, o;
    typeof e == "string" ? (r = e, o = new Uint8Array()) : (r = null, o = e), super(o, n), this.origin = r, this.buffer = o ? new eT(o) : null, this._load = null, this.loaded = !1, this.origin !== null && n.autoLoad !== !1 && this.load(), this.origin === null && this.buffer && (this._load = Promise.resolve(this), this.loaded = !0, this.onBlobLoaded(this.buffer.rawBinaryData));
  }
  onBlobLoaded(e) {
  }
  /** Loads the blob */
  load() {
    return this._load ? this._load : (this._load = fetch(this.origin).then((e) => e.blob()).then((e) => e.arrayBuffer()).then((e) => (this.data = new Uint32Array(e), this.buffer = new eT(e), this.loaded = !0, this.onBlobLoaded(e), this.update(), this)), this._load);
  }
}
class Sp extends wTe {
  /**
   * @param source - the buffer/URL holding the compressed texture data
   * @param options
   * @param {PIXI.INTERNAL_FORMATS} options.format - the compression format
   * @param {number} options.width - the image width in pixels.
   * @param {number} options.height - the image height in pixels.
   * @param {number} [options.level=1] - the mipmap levels stored in the compressed texture, including level 0.
   * @param {number} [options.levelBuffers] - the buffers for each mipmap level. `CompressedTextureResource` can allows you
   *      to pass `null` for `source`, for cases where each level is stored in non-contiguous memory.
   */
  constructor(e, n) {
    super(e, n), this.format = n.format, this.levels = n.levels || 1, this._width = n.width, this._height = n.height, this._extension = Sp._formatToExtension(this.format), (n.levelBuffers || this.buffer) && (this._levelBuffers = n.levelBuffers || Sp._createLevelBuffers(
      e instanceof Uint8Array ? e : this.buffer.uint8View,
      this.format,
      this.levels,
      4,
      4,
      // PVRTC has 8x4 blocks in 2bpp mode
      this.width,
      this.height
    ));
  }
  /**
   * @override
   * @param renderer - A reference to the current renderer
   * @param _texture - the texture
   * @param _glTexture - texture instance for this webgl context
   */
  upload(e, n, r) {
    const o = e.gl;
    if (!e.context.extensions[this._extension])
      throw new Error(`${this._extension} textures are not supported on the current machine`);
    if (!this._levelBuffers)
      return !1;
    o.pixelStorei(o.UNPACK_ALIGNMENT, 4);
    for (let s = 0, i = this.levels; s < i; s++) {
      const { levelID: u, levelWidth: l, levelHeight: a, levelBuffer: c } = this._levelBuffers[s];
      o.compressedTexImage2D(o.TEXTURE_2D, u, this.format, l, a, 0, c);
    }
    return !0;
  }
  /** @protected */
  onBlobLoaded() {
    this._levelBuffers = Sp._createLevelBuffers(
      this.buffer.uint8View,
      this.format,
      this.levels,
      4,
      4,
      // PVRTC has 8x4 blocks in 2bpp mode
      this.width,
      this.height
    );
  }
  /**
   * Returns the key (to ContextSystem#extensions) for the WebGL extension supporting the compression format
   * @private
   * @param format - the compression format to get the extension for.
   */
  static _formatToExtension(e) {
    if (e >= 33776 && e <= 33779)
      return "s3tc";
    if (e >= 37488 && e <= 37497)
      return "etc";
    if (e >= 35840 && e <= 35843)
      return "pvrtc";
    if (e >= 36196)
      return "etc1";
    if (e >= 35986 && e <= 34798)
      return "atc";
    throw new Error("Invalid (compressed) texture format given!");
  }
  /**
   * Pre-creates buffer views for each mipmap level
   * @private
   * @param buffer -
   * @param format - compression formats
   * @param levels - mipmap levels
   * @param blockWidth -
   * @param blockHeight -
   * @param imageWidth - width of the image in pixels
   * @param imageHeight - height of the image in pixels
   */
  static _createLevelBuffers(e, n, r, o, s, i, u) {
    const l = new Array(r);
    let a = e.byteOffset, c = i, p = u, d = c + o - 1 & ~(o - 1), h = p + s - 1 & ~(s - 1), m = d * h * hv[n];
    for (let g = 0; g < r; g++)
      l[g] = {
        levelID: g,
        levelWidth: r > 1 ? c : d,
        levelHeight: r > 1 ? p : h,
        levelBuffer: new Uint8Array(e.buffer, a, m)
      }, a += m, c = c >> 1 || 1, p = p >> 1 || 1, d = c + o - 1 & ~(o - 1), h = p + s - 1 & ~(s - 1), m = d * h * hv[n];
    return l;
  }
}
const Rb = 4, Rg = 124, bTe = 32, QC = 20, kTe = 542327876, Ag = {
  HEIGHT: 3,
  WIDTH: 4,
  MIPMAP_COUNT: 7,
  PIXEL_FORMAT: 19
}, TTe = {
  FOURCC: 2
}, Dg = {
  DXGI_FORMAT: 0,
  RESOURCE_DIMENSION: 1,
  MISC_FLAG: 2,
  ARRAY_SIZE: 3
}, xTe = 1, STe = 2, RTe = 4, ATe = 64, DTe = 512, ETe = 131072, MTe = 827611204, PTe = 861165636, CTe = 894720068, OTe = 808540228, ITe = 4, FTe = {
  [MTe]: js.COMPRESSED_RGBA_S3TC_DXT1_EXT,
  [PTe]: js.COMPRESSED_RGBA_S3TC_DXT3_EXT,
  [CTe]: js.COMPRESSED_RGBA_S3TC_DXT5_EXT
}, NTe = {
  // WEBGL_compressed_texture_s3tc
  70: js.COMPRESSED_RGBA_S3TC_DXT1_EXT,
  71: js.COMPRESSED_RGBA_S3TC_DXT1_EXT,
  73: js.COMPRESSED_RGBA_S3TC_DXT3_EXT,
  74: js.COMPRESSED_RGBA_S3TC_DXT3_EXT,
  76: js.COMPRESSED_RGBA_S3TC_DXT5_EXT,
  77: js.COMPRESSED_RGBA_S3TC_DXT5_EXT,
  // WEBGL_compressed_texture_s3tc_srgb
  72: js.COMPRESSED_SRGB_ALPHA_S3TC_DXT1_EXT,
  75: js.COMPRESSED_SRGB_ALPHA_S3TC_DXT3_EXT,
  78: js.COMPRESSED_SRGB_ALPHA_S3TC_DXT5_EXT
};
function LTe(t) {
  const e = new Uint32Array(t);
  if (e[0] !== kTe)
    throw new Error("Invalid DDS file magic word");
  const n = new Uint32Array(t, 0, Rg / Uint32Array.BYTES_PER_ELEMENT), r = n[Ag.HEIGHT], o = n[Ag.WIDTH], s = n[Ag.MIPMAP_COUNT], i = new Uint32Array(
    t,
    Ag.PIXEL_FORMAT * Uint32Array.BYTES_PER_ELEMENT,
    bTe / Uint32Array.BYTES_PER_ELEMENT
  ), u = i[xTe];
  if (u & RTe) {
    const l = i[TTe.FOURCC];
    if (l !== OTe) {
      const x = FTe[l], S = Rb + Rg, E = new Uint8Array(t, S);
      return [new Sp(E, {
        format: x,
        width: o,
        height: r,
        levels: s
        // CompressedTextureResource will separate the levelBuffers for us!
      })];
    }
    const a = Rb + Rg, c = new Uint32Array(
      e.buffer,
      a,
      QC / Uint32Array.BYTES_PER_ELEMENT
    ), p = c[Dg.DXGI_FORMAT], d = c[Dg.RESOURCE_DIMENSION], h = c[Dg.MISC_FLAG], m = c[Dg.ARRAY_SIZE], g = NTe[p];
    if (g === void 0)
      throw new Error(`DDSParser cannot parse texture data with DXGI format ${p}`);
    if (h === ITe)
      throw new Error("DDSParser does not support cubemap textures");
    if (d === 6)
      throw new Error("DDSParser does not supported 3D texture data");
    const _ = new Array(), b = Rb + Rg + QC;
    if (m === 1)
      _.push(new Uint8Array(t, b));
    else {
      const x = hv[g];
      let S = 0, E = o, A = r;
      for (let M = 0; M < s; M++) {
        const L = Math.max(1, E + 3 & -4), X = Math.max(1, A + 3 & -4), te = L * X * x;
        S += te, E = E >>> 1, A = A >>> 1;
      }
      let C = b;
      for (let M = 0; M < m; M++)
        _.push(new Uint8Array(t, C, S)), C += S;
    }
    return _.map((x) => new Sp(x, {
      format: g,
      width: o,
      height: r,
      levels: s
    }));
  }
  throw u & ATe ? new Error("DDSParser does not support uncompressed texture data.") : u & DTe ? new Error("DDSParser does not supported YUV uncompressed texture data.") : u & ETe ? new Error("DDSParser does not support single-channel (lumninance) texture data!") : u & STe ? new Error("DDSParser does not support single-channel (alpha) texture data!") : new Error("DDSParser failed to load a texture file due to an unknown reason!");
}
const KC = [171, 75, 84, 88, 32, 49, 49, 187, 13, 10, 26, 10], BTe = 67305985, ei = {
  ENDIANNESS: 12,
  GL_TYPE: 16,
  GL_FORMAT: 24,
  GL_INTERNAL_FORMAT: 28,
  PIXEL_WIDTH: 36,
  PIXEL_HEIGHT: 40,
  PIXEL_DEPTH: 44,
  NUMBER_OF_ARRAY_ELEMENTS: 48,
  NUMBER_OF_FACES: 52,
  NUMBER_OF_MIPMAP_LEVELS: 56,
  BYTES_OF_KEY_VALUE_DATA: 60
}, ST = 64, ZC = {
  [_t.UNSIGNED_BYTE]: 1,
  [_t.UNSIGNED_SHORT]: 2,
  [_t.INT]: 4,
  [_t.UNSIGNED_INT]: 4,
  [_t.FLOAT]: 4,
  [_t.HALF_FLOAT]: 8
}, UTe = {
  [qe.RGBA]: 4,
  [qe.RGB]: 3,
  [qe.RG]: 2,
  [qe.RED]: 1,
  [qe.LUMINANCE]: 1,
  [qe.LUMINANCE_ALPHA]: 2,
  [qe.ALPHA]: 1
}, XTe = {
  [_t.UNSIGNED_SHORT_4_4_4_4]: 2,
  [_t.UNSIGNED_SHORT_5_5_5_1]: 2,
  [_t.UNSIGNED_SHORT_5_6_5]: 2
};
function $Te(t, e, n = !1) {
  const r = new DataView(e);
  if (!WTe(t, r))
    return null;
  const o = r.getUint32(ei.ENDIANNESS, !0) === BTe, s = r.getUint32(ei.GL_TYPE, o), i = r.getUint32(ei.GL_FORMAT, o), u = r.getUint32(ei.GL_INTERNAL_FORMAT, o), l = r.getUint32(ei.PIXEL_WIDTH, o), a = r.getUint32(ei.PIXEL_HEIGHT, o) || 1, c = r.getUint32(ei.PIXEL_DEPTH, o) || 1, p = r.getUint32(ei.NUMBER_OF_ARRAY_ELEMENTS, o) || 1, d = r.getUint32(ei.NUMBER_OF_FACES, o), h = r.getUint32(ei.NUMBER_OF_MIPMAP_LEVELS, o), m = r.getUint32(ei.BYTES_OF_KEY_VALUE_DATA, o);
  if (a === 0 || c !== 1)
    throw new Error("Only 2D textures are supported");
  if (d !== 1)
    throw new Error("CubeTextures are not supported by KTXLoader yet!");
  if (p !== 1)
    throw new Error("WebGL does not support array textures");
  const g = 4, _ = 4, b = l + 3 & -4, x = a + 3 & -4, S = new Array(p);
  let E = l * a;
  s === 0 && (E = b * x);
  let A;
  if (s !== 0 ? ZC[s] ? A = ZC[s] * UTe[i] : A = XTe[s] : A = hv[u], A === void 0)
    throw new Error("Unable to resolve the pixel format stored in the *.ktx file!");
  const C = n ? HTe(r, m, o) : null;
  let M = E * A, L = l, X = a, te = b, B = x, W = ST + m;
  for (let G = 0; G < h; G++) {
    const ne = r.getUint32(W, o);
    let de = W + 4;
    for (let V = 0; V < p; V++) {
      let Y = S[V];
      Y || (Y = S[V] = new Array(h)), Y[G] = {
        levelID: G,
        // don't align mipWidth when texture not compressed! (glType not zero)
        levelWidth: h > 1 || s !== 0 ? L : te,
        levelHeight: h > 1 || s !== 0 ? X : B,
        levelBuffer: new Uint8Array(e, de, M)
      }, de += M;
    }
    W += ne + 4, W = W % 4 !== 0 ? W + 4 - W % 4 : W, L = L >> 1 || 1, X = X >> 1 || 1, te = L + g - 1 & -4, B = X + _ - 1 & -4, M = te * B * A;
  }
  return s !== 0 ? {
    uncompressed: S.map((G) => {
      let ne = G[0].levelBuffer, de = !1;
      return s === _t.FLOAT ? ne = new Float32Array(
        G[0].levelBuffer.buffer,
        G[0].levelBuffer.byteOffset,
        G[0].levelBuffer.byteLength / 4
      ) : s === _t.UNSIGNED_INT ? (de = !0, ne = new Uint32Array(
        G[0].levelBuffer.buffer,
        G[0].levelBuffer.byteOffset,
        G[0].levelBuffer.byteLength / 4
      )) : s === _t.INT && (de = !0, ne = new Int32Array(
        G[0].levelBuffer.buffer,
        G[0].levelBuffer.byteOffset,
        G[0].levelBuffer.byteLength / 4
      )), {
        resource: new X_(
          ne,
          {
            width: G[0].levelWidth,
            height: G[0].levelHeight
          }
        ),
        type: s,
        format: de ? VTe(i) : i
      };
    }),
    kvData: C
  } : {
    compressed: S.map((G) => new Sp(null, {
      format: u,
      width: l,
      height: a,
      levels: h,
      levelBuffers: G
    })),
    kvData: C
  };
}
function WTe(t, e) {
  for (let n = 0; n < KC.length; n++)
    if (e.getUint8(n) !== KC[n])
      return console.error(`${t} is not a valid *.ktx file!`), !1;
  return !0;
}
function VTe(t) {
  switch (t) {
    case qe.RGBA:
      return qe.RGBA_INTEGER;
    case qe.RGB:
      return qe.RGB_INTEGER;
    case qe.RG:
      return qe.RG_INTEGER;
    case qe.RED:
      return qe.RED_INTEGER;
    default:
      return t;
  }
}
function HTe(t, e, n) {
  const r = /* @__PURE__ */ new Map();
  let o = 0;
  for (; o < e; ) {
    const s = t.getUint32(ST + o, n), i = ST + o + 4, u = 3 - (s + 3) % 4;
    if (s === 0 || s > e - o) {
      console.error("KTXLoader: keyAndValueByteSize out of bounds");
      break;
    }
    let l = 0;
    for (; l < s && t.getUint8(i + l) !== 0; l++)
      ;
    if (l === -1) {
      console.error("KTXLoader: Failed to find null byte terminating kvData key");
      break;
    }
    const a = new TextDecoder().decode(
      new Uint8Array(t.buffer, i, l)
    ), c = new DataView(
      t.buffer,
      i + l + 1,
      s - l - 1
    );
    r.set(a, c), o += 4 + s + u;
  }
  return r;
}
const jTe = {
  extension: {
    type: rt.LoadParser,
    priority: Si.High
  },
  name: "loadDDS",
  test(t) {
    return Oc(t, ".dds");
  },
  async load(t, e, n) {
    const r = await (await at.ADAPTER.fetch(t)).arrayBuffer(), o = LTe(r).map((s) => {
      const i = new qt(s, {
        mipmap: yu.OFF,
        alphaMode: gs.NO_PREMULTIPLIED_ALPHA,
        resolution: al(t),
        ...e.data
      });
      return cy(i, n, t);
    });
    return o.length === 1 ? o[0] : o;
  },
  unload(t) {
    Array.isArray(t) ? t.forEach((e) => e.destroy(!0)) : t.destroy(!0);
  }
};
dt.add(jTe);
const zTe = {
  extension: {
    type: rt.LoadParser,
    priority: Si.High
  },
  name: "loadKTX",
  test(t) {
    return Oc(t, ".ktx");
  },
  async load(t, e, n) {
    const r = await (await at.ADAPTER.fetch(t)).arrayBuffer(), { compressed: o, uncompressed: s, kvData: i } = $Te(t, r), u = o ?? s, l = {
      mipmap: yu.OFF,
      alphaMode: gs.NO_PREMULTIPLIED_ALPHA,
      resolution: al(t),
      ...e.data
    }, a = u.map((c) => {
      u === s && Object.assign(l, {
        type: c.type,
        format: c.format
      });
      const p = c.resource ?? c, d = new qt(p, l);
      return d.ktxKeyValueData = i, cy(d, n, t);
    });
    return a.length === 1 ? a[0] : a;
  },
  unload(t) {
    Array.isArray(t) ? t.forEach((e) => e.destroy(!0)) : t.destroy(!0);
  }
};
dt.add(zTe);
const qTe = {
  extension: rt.ResolveParser,
  test: (t) => {
    const e = lo.extname(t).slice(1);
    return ["basis", "ktx", "dds"].includes(e);
  },
  parse: (t) => {
    const e = lo.extname(t).slice(1);
    if (e === "ktx") {
      const n = [
        ".s3tc.ktx",
        ".s3tc_sRGB.ktx",
        ".etc.ktx",
        ".etc1.ktx",
        ".pvrt.ktx",
        ".atc.ktx",
        ".astc.ktx"
      ];
      if (n.some((r) => t.endsWith(r)))
        return {
          resolution: parseFloat(at.RETINA_PREFIX.exec(t)?.[1] ?? "1"),
          format: n.find((r) => t.endsWith(r)),
          src: t
        };
    }
    return {
      resolution: parseFloat(at.RETINA_PREFIX.exec(t)?.[1] ?? "1"),
      format: e,
      src: t
    };
  }
};
dt.add(qTe);
const Eg = new Pt(), GTe = 4, e6 = class $f {
  /**
   * @param renderer - A reference to the current renderer
   */
  constructor(e) {
    this.renderer = e, this._rendererPremultipliedAlpha = !1;
  }
  contextChange() {
    const e = this.renderer?.gl.getContextAttributes();
    this._rendererPremultipliedAlpha = !!(e && e.alpha && e.premultipliedAlpha);
  }
  /**
   * Will return a HTML Image of the target
   * @param target - A displayObject or renderTexture
   *  to convert. If left empty will use the main renderer
   * @param format - Image format, e.g. "image/jpeg" or "image/webp".
   * @param quality - JPEG or Webp compression from 0 to 1. Default is 0.92.
   * @param frame - The frame the extraction is restricted to.
   * @returns - HTML Image of the target
   */
  async image(e, n, r, o) {
    const s = new Image();
    return s.src = await this.base64(e, n, r, o), s;
  }
  /**
   * Will return a base64 encoded string of this target. It works by calling
   *  `Extract.canvas` and then running toDataURL on that.
   * @param target - A displayObject or renderTexture
   *  to convert. If left empty will use the main renderer
   * @param format - Image format, e.g. "image/jpeg" or "image/webp".
   * @param quality - JPEG or Webp compression from 0 to 1. Default is 0.92.
   * @param frame - The frame the extraction is restricted to.
   * @returns - A base64 encoded string of the texture.
   */
  async base64(e, n, r, o) {
    const s = this.canvas(e, o);
    if (s.toBlob !== void 0)
      return new Promise((i, u) => {
        s.toBlob((l) => {
          if (!l) {
            u(new Error("ICanvas.toBlob failed!"));
            return;
          }
          const a = new FileReader();
          a.onload = () => i(a.result), a.onerror = u, a.readAsDataURL(l);
        }, n, r);
      });
    if (s.toDataURL !== void 0)
      return s.toDataURL(n, r);
    if (s.convertToBlob !== void 0) {
      const i = await s.convertToBlob({ type: n, quality: r });
      return new Promise((u, l) => {
        const a = new FileReader();
        a.onload = () => u(a.result), a.onerror = l, a.readAsDataURL(i);
      });
    }
    throw new Error("Extract.base64() requires ICanvas.toDataURL, ICanvas.toBlob, or ICanvas.convertToBlob to be implemented");
  }
  /**
   * Creates a Canvas element, renders this target to it and then returns it.
   * @param target - A displayObject or renderTexture
   *  to convert. If left empty will use the main renderer
   * @param frame - The frame the extraction is restricted to.
   * @returns - A Canvas element with the texture rendered on.
   */
  canvas(e, n) {
    const { pixels: r, width: o, height: s, flipY: i, premultipliedAlpha: u } = this._rawPixels(e, n);
    i && $f._flipY(r, o, s), u && $f._unpremultiplyAlpha(r);
    const l = new M1e(o, s, 1), a = new ImageData(new Uint8ClampedArray(r.buffer), o, s);
    return l.context.putImageData(a, 0, 0), l.canvas;
  }
  /**
   * Will return a one-dimensional array containing the pixel data of the entire texture in RGBA
   * order, with integer values between 0 and 255 (included).
   * @param target - A displayObject or renderTexture
   *  to convert. If left empty will use the main renderer
   * @param frame - The frame the extraction is restricted to.
   * @returns - One-dimensional array containing the pixel data of the entire texture
   */
  pixels(e, n) {
    const { pixels: r, width: o, height: s, flipY: i, premultipliedAlpha: u } = this._rawPixels(e, n);
    return i && $f._flipY(r, o, s), u && $f._unpremultiplyAlpha(r), r;
  }
  _rawPixels(e, n) {
    const r = this.renderer;
    if (!r)
      throw new Error("The Extract has already been destroyed");
    let o, s = !1, i = !1, u, l = !1;
    e && (e instanceof rd ? u = e : (u = r.generateTexture(e, {
      region: n,
      resolution: r.resolution,
      multisample: r.multisample
    }), l = !0, n && (Eg.width = n.width, Eg.height = n.height, n = Eg)));
    const a = r.gl;
    if (u) {
      if (o = u.baseTexture.resolution, n = n ?? u.frame, s = !1, i = u.baseTexture.alphaMode > 0 && u.baseTexture.format === qe.RGBA, !l) {
        r.renderTexture.bind(u);
        const h = u.framebuffer.glFramebuffers[r.CONTEXT_UID];
        h.blitFramebuffer && r.framebuffer.bind(h.blitFramebuffer);
      }
    } else
      o = r.resolution, n || (n = Eg, n.width = r.width / o, n.height = r.height / o), s = !0, i = this._rendererPremultipliedAlpha, r.renderTexture.bind();
    const c = Math.max(Math.round(n.width * o), 1), p = Math.max(Math.round(n.height * o), 1), d = new Uint8Array(GTe * c * p);
    return a.readPixels(
      Math.round(n.x * o),
      Math.round(n.y * o),
      c,
      p,
      a.RGBA,
      a.UNSIGNED_BYTE,
      d
    ), l && u?.destroy(!0), { pixels: d, width: c, height: p, flipY: s, premultipliedAlpha: i };
  }
  /** Destroys the extract. */
  destroy() {
    this.renderer = null;
  }
  static _flipY(e, n, r) {
    const o = n << 2, s = r >> 1, i = new Uint8Array(o);
    for (let u = 0; u < s; u++) {
      const l = u * o, a = (r - u - 1) * o;
      i.set(e.subarray(l, l + o)), e.copyWithin(l, a, a + o), e.set(i, a);
    }
  }
  static _unpremultiplyAlpha(e) {
    e instanceof Uint8ClampedArray && (e = new Uint8Array(e.buffer));
    const n = e.length;
    for (let r = 0; r < n; r += 4) {
      const o = e[r + 3];
      if (o !== 0) {
        const s = 255.001 / o;
        e[r] = e[r] * s + 0.5, e[r + 1] = e[r + 1] * s + 0.5, e[r + 2] = e[r + 2] * s + 0.5;
      }
    }
  }
};
e6.extension = {
  name: "extract",
  type: rt.RendererSystem
};
let YTe = e6;
dt.add(YTe);
const fv = {
  build(t) {
    const e = t.points;
    let n, r, o, s, i, u;
    if (t.type === Ao.CIRC) {
      const m = t.shape;
      n = m.x, r = m.y, i = u = m.radius, o = s = 0;
    } else if (t.type === Ao.ELIP) {
      const m = t.shape;
      n = m.x, r = m.y, i = m.width, u = m.height, o = s = 0;
    } else {
      const m = t.shape, g = m.width / 2, _ = m.height / 2;
      n = m.x + g, r = m.y + _, i = u = Math.max(0, Math.min(m.radius, Math.min(g, _))), o = g - i, s = _ - u;
    }
    if (!(i >= 0 && u >= 0 && o >= 0 && s >= 0)) {
      e.length = 0;
      return;
    }
    const l = Math.ceil(2.3 * Math.sqrt(i + u)), a = l * 8 + (o ? 4 : 0) + (s ? 4 : 0);
    if (e.length = a, a === 0)
      return;
    if (l === 0) {
      e.length = 8, e[0] = e[6] = n + o, e[1] = e[3] = r + s, e[2] = e[4] = n - o, e[5] = e[7] = r - s;
      return;
    }
    let c = 0, p = l * 4 + (o ? 2 : 0) + 2, d = p, h = a;
    {
      const m = o + i, g = s, _ = n + m, b = n - m, x = r + g;
      if (e[c++] = _, e[c++] = x, e[--p] = x, e[--p] = b, s) {
        const S = r - g;
        e[d++] = b, e[d++] = S, e[--h] = S, e[--h] = _;
      }
    }
    for (let m = 1; m < l; m++) {
      const g = Math.PI / 2 * (m / l), _ = o + Math.cos(g) * i, b = s + Math.sin(g) * u, x = n + _, S = n - _, E = r + b, A = r - b;
      e[c++] = x, e[c++] = E, e[--p] = E, e[--p] = S, e[d++] = S, e[d++] = A, e[--h] = A, e[--h] = x;
    }
    {
      const m = o, g = s + u, _ = n + m, b = n - m, x = r + g, S = r - g;
      e[c++] = _, e[c++] = x, e[--h] = S, e[--h] = _, o && (e[c++] = b, e[c++] = x, e[--h] = S, e[--h] = b);
    }
  },
  triangulate(t, e) {
    const n = t.points, r = e.points, o = e.indices;
    if (n.length === 0)
      return;
    let s = r.length / 2;
    const i = s;
    let u, l;
    if (t.type !== Ao.RREC) {
      const c = t.shape;
      u = c.x, l = c.y;
    } else {
      const c = t.shape;
      u = c.x + c.width / 2, l = c.y + c.height / 2;
    }
    const a = t.matrix;
    r.push(
      t.matrix ? a.a * u + a.c * l + a.tx : u,
      t.matrix ? a.b * u + a.d * l + a.ty : l
    ), s++, r.push(n[0], n[1]);
    for (let c = 2; c < n.length; c += 2)
      r.push(n[c], n[c + 1]), o.push(s++, i, s);
    o.push(i + 1, i, s);
  }
};
function JC(t, e = !1) {
  const n = t.length;
  if (n < 6)
    return;
  let r = 0;
  for (let o = 0, s = t[n - 2], i = t[n - 1]; o < n; o += 2) {
    const u = t[o], l = t[o + 1];
    r += (u - s) * (l + i), s = u, i = l;
  }
  if (!e && r > 0 || e && r <= 0) {
    const o = n / 2;
    for (let s = o + o % 2; s < n; s += 2) {
      const i = n - s - 2, u = n - s - 1, l = s, a = s + 1;
      [t[i], t[l]] = [t[l], t[i]], [t[u], t[a]] = [t[a], t[u]];
    }
  }
}
const t6 = {
  build(t) {
    t.points = t.shape.points.slice();
  },
  triangulate(t, e) {
    let n = t.points;
    const r = t.holes, o = e.points, s = e.indices;
    if (n.length >= 6) {
      JC(n, !1);
      const i = [];
      for (let a = 0; a < r.length; a++) {
        const c = r[a];
        JC(c.points, !0), i.push(n.length / 2), n = n.concat(c.points);
      }
      const u = Dwe(n, i, 2);
      if (!u)
        return;
      const l = o.length / 2;
      for (let a = 0; a < u.length; a += 3)
        s.push(u[a] + l), s.push(u[a + 1] + l), s.push(u[a + 2] + l);
      for (let a = 0; a < n.length; a++)
        o.push(n[a]);
    }
  }
}, QTe = {
  build(t) {
    const e = t.shape, n = e.x, r = e.y, o = e.width, s = e.height, i = t.points;
    i.length = 0, o >= 0 && s >= 0 && i.push(
      n,
      r,
      n + o,
      r,
      n + o,
      r + s,
      n,
      r + s
    );
  },
  triangulate(t, e) {
    const n = t.points, r = e.points;
    if (n.length === 0)
      return;
    const o = r.length / 2;
    r.push(
      n[0],
      n[1],
      n[2],
      n[3],
      n[6],
      n[7],
      n[4],
      n[5]
    ), e.indices.push(
      o,
      o + 1,
      o + 2,
      o + 1,
      o + 2,
      o + 3
    );
  }
}, KTe = {
  build(t) {
    fv.build(t);
  },
  triangulate(t, e) {
    fv.triangulate(t, e);
  }
};
var ka = /* @__PURE__ */ ((t) => (t.MITER = "miter", t.BEVEL = "bevel", t.ROUND = "round", t))(ka || {}), tc = /* @__PURE__ */ ((t) => (t.BUTT = "butt", t.ROUND = "round", t.SQUARE = "square", t))(tc || {});
const vh = {
  adaptive: !0,
  maxLength: 10,
  minSegments: 8,
  maxSegments: 2048,
  epsilon: 1e-4,
  _segmentsCount(t, e = 20) {
    if (!this.adaptive || !t || isNaN(t))
      return e;
    let n = Math.ceil(t / this.maxLength);
    return n < this.minSegments ? n = this.minSegments : n > this.maxSegments && (n = this.maxSegments), n;
  }
};
class eO {
  /**
   * Calculate information of the arc for {@link PIXI.Graphics.arcTo}.
   * @private
   * @param x1 - The x-coordinate of the first control point of the arc
   * @param y1 - The y-coordinate of the first control point of the arc
   * @param x2 - The x-coordinate of the second control point of the arc
   * @param y2 - The y-coordinate of the second control point of the arc
   * @param radius - The radius of the arc
   * @param points - Collection of points to add to
   * @returns - If the arc length is valid, return center of circle, radius and other info otherwise `null`.
   */
  static curveTo(e, n, r, o, s, i) {
    const u = i[i.length - 2], l = i[i.length - 1] - n, a = u - e, c = o - n, p = r - e, d = Math.abs(l * p - a * c);
    if (d < 1e-8 || s === 0)
      return (i[i.length - 2] !== e || i[i.length - 1] !== n) && i.push(e, n), null;
    const h = l * l + a * a, m = c * c + p * p, g = l * c + a * p, _ = s * Math.sqrt(h) / d, b = s * Math.sqrt(m) / d, x = _ * g / h, S = b * g / m, E = _ * p + b * a, A = _ * c + b * l, C = a * (b + x), M = l * (b + x), L = p * (_ + S), X = c * (_ + S), te = Math.atan2(M - A, C - E), B = Math.atan2(X - A, L - E);
    return {
      cx: E + e,
      cy: A + n,
      radius: s,
      startAngle: te,
      endAngle: B,
      anticlockwise: a * c > p * l
    };
  }
  /**
   * The arc method creates an arc/curve (used to create circles, or parts of circles).
   * @private
   * @param _startX - Start x location of arc
   * @param _startY - Start y location of arc
   * @param cx - The x-coordinate of the center of the circle
   * @param cy - The y-coordinate of the center of the circle
   * @param radius - The radius of the circle
   * @param startAngle - The starting angle, in radians (0 is at the 3 o'clock position
   *  of the arc's circle)
   * @param endAngle - The ending angle, in radians
   * @param _anticlockwise - Specifies whether the drawing should be
   *  counter-clockwise or clockwise. False is default, and indicates clockwise, while true
   *  indicates counter-clockwise.
   * @param points - Collection of points to add to
   */
  static arc(e, n, r, o, s, i, u, l, a) {
    const c = u - i, p = vh._segmentsCount(
      Math.abs(c) * s,
      Math.ceil(Math.abs(c) / sv) * 40
    ), d = c / (p * 2), h = d * 2, m = Math.cos(d), g = Math.sin(d), _ = p - 1, b = _ % 1 / _;
    for (let x = 0; x <= _; ++x) {
      const S = x + b * x, E = d + i + h * S, A = Math.cos(E), C = -Math.sin(E);
      a.push(
        (m * A + g * C) * s + r,
        (m * -C + g * A) * s + o
      );
    }
  }
}
class ZTe {
  constructor() {
    this.reset();
  }
  /**
   * Begin batch part.
   * @param style
   * @param startIndex
   * @param attribStart
   */
  begin(e, n, r) {
    this.reset(), this.style = e, this.start = n, this.attribStart = r;
  }
  /**
   * End batch part.
   * @param endIndex
   * @param endAttrib
   */
  end(e, n) {
    this.attribSize = n - this.attribStart, this.size = e - this.start;
  }
  reset() {
    this.style = null, this.size = 0, this.start = 0, this.attribStart = 0, this.attribSize = 0;
  }
}
class ES {
  /**
   * Calculate length of bezier curve.
   * Analytical solution is impossible, since it involves an integral that does not integrate in general.
   * Therefore numerical solution is used.
   * @private
   * @param fromX - Starting point x
   * @param fromY - Starting point y
   * @param cpX - Control point x
   * @param cpY - Control point y
   * @param cpX2 - Second Control point x
   * @param cpY2 - Second Control point y
   * @param toX - Destination point x
   * @param toY - Destination point y
   * @returns - Length of bezier curve
   */
  static curveLength(e, n, r, o, s, i, u, l) {
    let a = 0, c = 0, p = 0, d = 0, h = 0, m = 0, g = 0, _ = 0, b = 0, x = 0, S = 0, E = e, A = n;
    for (let C = 1; C <= 10; ++C)
      c = C / 10, p = c * c, d = p * c, h = 1 - c, m = h * h, g = m * h, _ = g * e + 3 * m * c * r + 3 * h * p * s + d * u, b = g * n + 3 * m * c * o + 3 * h * p * i + d * l, x = E - _, S = A - b, E = _, A = b, a += Math.sqrt(x * x + S * S);
    return a;
  }
  /**
   * Calculate the points for a bezier curve and then draws it.
   *
   * Ignored from docs since it is not directly exposed.
   * @ignore
   * @param cpX - Control point x
   * @param cpY - Control point y
   * @param cpX2 - Second Control point x
   * @param cpY2 - Second Control point y
   * @param toX - Destination point x
   * @param toY - Destination point y
   * @param points - Path array to push points into
   */
  static curveTo(e, n, r, o, s, i, u) {
    const l = u[u.length - 2], a = u[u.length - 1];
    u.length -= 2;
    const c = vh._segmentsCount(
      ES.curveLength(l, a, e, n, r, o, s, i)
    );
    let p = 0, d = 0, h = 0, m = 0, g = 0;
    u.push(l, a);
    for (let _ = 1, b = 0; _ <= c; ++_)
      b = _ / c, p = 1 - b, d = p * p, h = d * p, m = b * b, g = m * b, u.push(
        h * l + 3 * d * b * e + 3 * p * m * r + g * s,
        h * a + 3 * d * b * n + 3 * p * m * o + g * i
      );
  }
}
function tO(t, e, n, r, o, s, i, u) {
  const l = t - n * o, a = e - r * o, c = t + n * s, p = e + r * s;
  let d, h;
  i ? (d = r, h = -n) : (d = -r, h = n);
  const m = l + d, g = a + h, _ = c + d, b = p + h;
  return u.push(
    m,
    g,
    _,
    b
  ), 2;
}
function Kc(t, e, n, r, o, s, i, u) {
  const l = n - t, a = r - e;
  let c = Math.atan2(l, a), p = Math.atan2(o - t, s - e);
  u && c < p ? c += Math.PI * 2 : !u && c > p && (p += Math.PI * 2);
  let d = c;
  const h = p - c, m = Math.abs(h), g = Math.sqrt(l * l + a * a), _ = (15 * m * Math.sqrt(g) / Math.PI >> 0) + 1, b = h / _;
  if (d += b, u) {
    i.push(
      t,
      e,
      n,
      r
    );
    for (let x = 1, S = d; x < _; x++, S += b)
      i.push(
        t,
        e,
        t + Math.sin(S) * g,
        e + Math.cos(S) * g
      );
    i.push(
      t,
      e,
      o,
      s
    );
  } else {
    i.push(
      n,
      r,
      t,
      e
    );
    for (let x = 1, S = d; x < _; x++, S += b)
      i.push(
        t + Math.sin(S) * g,
        e + Math.cos(S) * g,
        t,
        e
      );
    i.push(
      o,
      s,
      t,
      e
    );
  }
  return _ * 2;
}
function JTe(t, e) {
  const n = t.shape;
  let r = t.points || n.points.slice();
  const o = e.closePointEps;
  if (r.length === 0)
    return;
  const s = t.lineStyle, i = new Rt(r[0], r[1]), u = new Rt(r[r.length - 2], r[r.length - 1]), l = n.type !== Ao.POLY || n.closeStroke, a = Math.abs(i.x - u.x) < o && Math.abs(i.y - u.y) < o;
  if (l) {
    r = r.slice(), a && (r.pop(), r.pop(), u.set(r[r.length - 2], r[r.length - 1]));
    const Y = (i.x + u.x) * 0.5, Q = (u.y + i.y) * 0.5;
    r.unshift(Y, Q), r.push(Y, Q);
  }
  const c = e.points, p = r.length / 2;
  let d = r.length;
  const h = c.length / 2, m = s.width / 2, g = m * m, _ = s.miterLimit * s.miterLimit;
  let b = r[0], x = r[1], S = r[2], E = r[3], A = 0, C = 0, M = -(x - E), L = b - S, X = 0, te = 0, B = Math.sqrt(M * M + L * L);
  M /= B, L /= B, M *= m, L *= m;
  const W = s.alignment, G = (1 - W) * 2, ne = W * 2;
  l || (s.cap === tc.ROUND ? d += Kc(
    b - M * (G - ne) * 0.5,
    x - L * (G - ne) * 0.5,
    b - M * G,
    x - L * G,
    b + M * ne,
    x + L * ne,
    c,
    !0
  ) + 2 : s.cap === tc.SQUARE && (d += tO(b, x, M, L, G, ne, !0, c))), c.push(
    b - M * G,
    x - L * G,
    b + M * ne,
    x + L * ne
  );
  for (let Y = 1; Y < p - 1; ++Y) {
    b = r[(Y - 1) * 2], x = r[(Y - 1) * 2 + 1], S = r[Y * 2], E = r[Y * 2 + 1], A = r[(Y + 1) * 2], C = r[(Y + 1) * 2 + 1], M = -(x - E), L = b - S, B = Math.sqrt(M * M + L * L), M /= B, L /= B, M *= m, L *= m, X = -(E - C), te = S - A, B = Math.sqrt(X * X + te * te), X /= B, te /= B, X *= m, te *= m;
    const Q = S - b, ae = x - E, Z = S - A, J = C - E, oe = Q * Z + ae * J, ue = ae * Z - J * Q, me = ue < 0;
    if (Math.abs(ue) < 1e-3 * Math.abs(oe)) {
      c.push(
        S - M * G,
        E - L * G,
        S + M * ne,
        E + L * ne
      ), oe >= 0 && (s.join === ka.ROUND ? d += Kc(
        S,
        E,
        S - M * G,
        E - L * G,
        S - X * G,
        E - te * G,
        c,
        !1
      ) + 4 : d += 2, c.push(
        S - X * ne,
        E - te * ne,
        S + X * G,
        E + te * G
      ));
      continue;
    }
    const pe = (-M + b) * (-L + E) - (-M + S) * (-L + x), Be = (-X + A) * (-te + E) - (-X + S) * (-te + C), Ie = (Q * Be - Z * pe) / ue, Me = (J * pe - ae * Be) / ue, fe = (Ie - S) * (Ie - S) + (Me - E) * (Me - E), Te = S + (Ie - S) * G, Ae = E + (Me - E) * G, we = S - (Ie - S) * ne, $e = E - (Me - E) * ne, ze = Math.min(Q * Q + ae * ae, Z * Z + J * J), Ue = me ? G : ne, tt = ze + Ue * Ue * g, Ot = fe <= tt;
    let cn = s.join;
    if (cn === ka.MITER && fe / g > _ && (cn = ka.BEVEL), Ot)
      switch (cn) {
        case ka.MITER: {
          c.push(
            Te,
            Ae,
            we,
            $e
          );
          break;
        }
        case ka.BEVEL: {
          me ? c.push(
            Te,
            Ae,
            // inner miter point
            S + M * ne,
            E + L * ne,
            // first segment's outer vertex
            Te,
            Ae,
            // inner miter point
            S + X * ne,
            E + te * ne
          ) : c.push(
            S - M * G,
            E - L * G,
            // first segment's inner vertex
            we,
            $e,
            // outer miter point
            S - X * G,
            E - te * G,
            // second segment's outer vertex
            we,
            $e
          ), d += 2;
          break;
        }
        case ka.ROUND: {
          me ? (c.push(
            Te,
            Ae,
            S + M * ne,
            E + L * ne
          ), d += Kc(
            S,
            E,
            S + M * ne,
            E + L * ne,
            S + X * ne,
            E + te * ne,
            c,
            !0
          ) + 4, c.push(
            Te,
            Ae,
            S + X * ne,
            E + te * ne
          )) : (c.push(
            S - M * G,
            E - L * G,
            we,
            $e
          ), d += Kc(
            S,
            E,
            S - M * G,
            E - L * G,
            S - X * G,
            E - te * G,
            c,
            !1
          ) + 4, c.push(
            S - X * G,
            E - te * G,
            we,
            $e
          ));
          break;
        }
      }
    else {
      switch (c.push(
        S - M * G,
        E - L * G,
        // first segment's inner vertex
        S + M * ne,
        E + L * ne
      ), cn) {
        case ka.MITER: {
          me ? c.push(
            we,
            $e,
            // inner miter point
            we,
            $e
          ) : c.push(
            Te,
            Ae,
            // outer miter point
            Te,
            Ae
          ), d += 2;
          break;
        }
        case ka.ROUND: {
          me ? d += Kc(
            S,
            E,
            S + M * ne,
            E + L * ne,
            S + X * ne,
            E + te * ne,
            c,
            !0
          ) + 2 : d += Kc(
            S,
            E,
            S - M * G,
            E - L * G,
            S - X * G,
            E - te * G,
            c,
            !1
          ) + 2;
          break;
        }
      }
      c.push(
        S - X * G,
        E - te * G,
        // second segment's inner vertex
        S + X * ne,
        E + te * ne
      ), d += 2;
    }
  }
  b = r[(p - 2) * 2], x = r[(p - 2) * 2 + 1], S = r[(p - 1) * 2], E = r[(p - 1) * 2 + 1], M = -(x - E), L = b - S, B = Math.sqrt(M * M + L * L), M /= B, L /= B, M *= m, L *= m, c.push(
    S - M * G,
    E - L * G,
    S + M * ne,
    E + L * ne
  ), l || (s.cap === tc.ROUND ? d += Kc(
    S - M * (G - ne) * 0.5,
    E - L * (G - ne) * 0.5,
    S - M * G,
    E - L * G,
    S + M * ne,
    E + L * ne,
    c,
    !1
  ) + 2 : s.cap === tc.SQUARE && (d += tO(S, E, M, L, G, ne, !1, c)));
  const de = e.indices, V = vh.epsilon * vh.epsilon;
  for (let Y = h; Y < d + h - 2; ++Y)
    b = c[Y * 2], x = c[Y * 2 + 1], S = c[(Y + 1) * 2], E = c[(Y + 1) * 2 + 1], A = c[(Y + 2) * 2], C = c[(Y + 2) * 2 + 1], !(Math.abs(b * (E - C) + S * (C - x) + A * (x - E)) < V) && de.push(Y, Y + 1, Y + 2);
}
function exe(t, e) {
  let n = 0;
  const r = t.shape, o = t.points || r.points, s = r.type !== Ao.POLY || r.closeStroke;
  if (o.length === 0)
    return;
  const i = e.points, u = e.indices, l = o.length / 2, a = i.length / 2;
  let c = a;
  for (i.push(o[0], o[1]), n = 1; n < l; n++)
    i.push(o[n * 2], o[n * 2 + 1]), u.push(c, c + 1), c++;
  s && u.push(c, a);
}
function nO(t, e) {
  t.lineStyle.native ? exe(t, e) : JTe(t, e);
}
class MS {
  /**
   * Calculate length of quadratic curve
   * @see {@link http://www.malczak.linuxpl.com/blog/quadratic-bezier-curve-length/}
   * for the detailed explanation of math behind this.
   * @private
   * @param fromX - x-coordinate of curve start point
   * @param fromY - y-coordinate of curve start point
   * @param cpX - x-coordinate of curve control point
   * @param cpY - y-coordinate of curve control point
   * @param toX - x-coordinate of curve end point
   * @param toY - y-coordinate of curve end point
   * @returns - Length of quadratic curve
   */
  static curveLength(e, n, r, o, s, i) {
    const u = e - 2 * r + s, l = n - 2 * o + i, a = 2 * r - 2 * e, c = 2 * o - 2 * n, p = 4 * (u * u + l * l), d = 4 * (u * a + l * c), h = a * a + c * c, m = 2 * Math.sqrt(p + d + h), g = Math.sqrt(p), _ = 2 * p * g, b = 2 * Math.sqrt(h), x = d / g;
    return (_ * m + g * d * (m - b) + (4 * h * p - d * d) * Math.log((2 * g + x + m) / (x + b))) / (4 * _);
  }
  /**
   * Calculate the points for a quadratic bezier curve and then draws it.
   * Based on: https://stackoverflow.com/questions/785097/how-do-i-implement-a-bezier-curve-in-c
   * @private
   * @param cpX - Control point x
   * @param cpY - Control point y
   * @param toX - Destination point x
   * @param toY - Destination point y
   * @param points - Points to add segments to.
   */
  static curveTo(e, n, r, o, s) {
    const i = s[s.length - 2], u = s[s.length - 1], l = vh._segmentsCount(
      MS.curveLength(i, u, e, n, r, o)
    );
    let a = 0, c = 0;
    for (let p = 1; p <= l; ++p) {
      const d = p / l;
      a = i + (e - i) * d, c = u + (n - u) * d, s.push(
        a + (e + (r - e) * d - a) * d,
        c + (n + (o - n) * d - c) * d
      );
    }
  }
}
const Ab = {
  [Ao.POLY]: t6,
  [Ao.CIRC]: fv,
  [Ao.ELIP]: fv,
  [Ao.RECT]: QTe,
  [Ao.RREC]: KTe
}, rO = [], Mg = [];
class mv {
  /**
   * @param {PIXI.Circle|PIXI.Ellipse|PIXI.Polygon|PIXI.Rectangle|PIXI.RoundedRectangle} shape - The shape object to draw.
   * @param fillStyle - the width of the line to draw
   * @param lineStyle - the color of the line to draw
   * @param matrix - Transform matrix
   */
  constructor(e, n = null, r = null, o = null) {
    this.points = [], this.holes = [], this.shape = e, this.lineStyle = r, this.fillStyle = n, this.matrix = o, this.type = e.type;
  }
  /**
   * Creates a new GraphicsData object with the same values as this one.
   * @returns - Cloned GraphicsData object
   */
  clone() {
    return new mv(
      this.shape,
      this.fillStyle,
      this.lineStyle,
      this.matrix
    );
  }
  /** Destroys the Graphics data. */
  destroy() {
    this.shape = null, this.holes.length = 0, this.holes = null, this.points.length = 0, this.points = null, this.lineStyle = null, this.fillStyle = null;
  }
}
const Td = new Rt(), n6 = class r6 extends uB {
  // eslint-disable-next-line @typescript-eslint/no-useless-constructor
  constructor() {
    super(), this.closePointEps = 1e-4, this.boundsPadding = 0, this.uvsFloat32 = null, this.indicesUint16 = null, this.batchable = !1, this.points = [], this.colors = [], this.uvs = [], this.indices = [], this.textureIds = [], this.graphicsData = [], this.drawCalls = [], this.batchDirty = -1, this.batches = [], this.dirty = 0, this.cacheDirty = -1, this.clearDirty = 0, this.shapeIndex = 0, this._bounds = new cv(), this.boundsDirty = -1;
  }
  /**
   * Get the current bounds of the graphic geometry.
   *
   * Since 6.5.0, bounds of the graphics geometry are calculated based on the vertices of generated geometry.
   * Since shapes or strokes with full transparency (`alpha: 0`) will not generate geometry, they are not considered
   * when calculating bounds for the graphics geometry. See PR [#8343]{@link https://github.com/pixijs/pixijs/pull/8343}
   * and issue [#8623]{@link https://github.com/pixijs/pixijs/pull/8623}.
   * @readonly
   */
  get bounds() {
    return this.updateBatches(), this.boundsDirty !== this.dirty && (this.boundsDirty = this.dirty, this.calculateBounds()), this._bounds;
  }
  /** Call if you changed graphicsData manually. Empties all batch buffers. */
  invalidate() {
    this.boundsDirty = -1, this.dirty++, this.batchDirty++, this.shapeIndex = 0, this.points.length = 0, this.colors.length = 0, this.uvs.length = 0, this.indices.length = 0, this.textureIds.length = 0;
    for (let e = 0; e < this.drawCalls.length; e++)
      this.drawCalls[e].texArray.clear(), Mg.push(this.drawCalls[e]);
    this.drawCalls.length = 0;
    for (let e = 0; e < this.batches.length; e++) {
      const n = this.batches[e];
      n.reset(), rO.push(n);
    }
    this.batches.length = 0;
  }
  /**
   * Clears the graphics that were drawn to this Graphics object, and resets fill and line style settings.
   * @returns - This GraphicsGeometry object. Good for chaining method calls
   */
  clear() {
    return this.graphicsData.length > 0 && (this.invalidate(), this.clearDirty++, this.graphicsData.length = 0), this;
  }
  /**
   * Draws the given shape to this Graphics object. Can be any of Circle, Rectangle, Ellipse, Line or Polygon.
   * @param {PIXI.Circle|PIXI.Ellipse|PIXI.Polygon|PIXI.Rectangle|PIXI.RoundedRectangle} shape - The shape object to draw.
   * @param fillStyle - Defines style of the fill.
   * @param lineStyle - Defines style of the lines.
   * @param matrix - Transform applied to the points of the shape.
   * @returns - Returns geometry for chaining.
   */
  drawShape(e, n = null, r = null, o = null) {
    const s = new mv(e, n, r, o);
    return this.graphicsData.push(s), this.dirty++, this;
  }
  /**
   * Draws the given shape to this Graphics object. Can be any of Circle, Rectangle, Ellipse, Line or Polygon.
   * @param {PIXI.Circle|PIXI.Ellipse|PIXI.Polygon|PIXI.Rectangle|PIXI.RoundedRectangle} shape - The shape object to draw.
   * @param matrix - Transform applied to the points of the shape.
   * @returns - Returns geometry for chaining.
   */
  drawHole(e, n = null) {
    if (!this.graphicsData.length)
      return null;
    const r = new mv(e, null, null, n), o = this.graphicsData[this.graphicsData.length - 1];
    return r.lineStyle = o.lineStyle, o.holes.push(r), this.dirty++, this;
  }
  /** Destroys the GraphicsGeometry object. */
  destroy() {
    super.destroy();
    for (let e = 0; e < this.graphicsData.length; ++e)
      this.graphicsData[e].destroy();
    this.points.length = 0, this.points = null, this.colors.length = 0, this.colors = null, this.uvs.length = 0, this.uvs = null, this.indices.length = 0, this.indices = null, this.indexBuffer.destroy(), this.indexBuffer = null, this.graphicsData.length = 0, this.graphicsData = null, this.drawCalls.length = 0, this.drawCalls = null, this.batches.length = 0, this.batches = null, this._bounds = null;
  }
  /**
   * Check to see if a point is contained within this geometry.
   * @param point - Point to check if it's contained.
   * @returns {boolean} `true` if the point is contained within geometry.
   */
  containsPoint(e) {
    const n = this.graphicsData;
    for (let r = 0; r < n.length; ++r) {
      const o = n[r];
      if (o.fillStyle.visible && o.shape && (o.matrix ? o.matrix.applyInverse(e, Td) : Td.copyFrom(e), o.shape.contains(Td.x, Td.y))) {
        let s = !1;
        if (o.holes) {
          for (let i = 0; i < o.holes.length; i++)
            if (o.holes[i].shape.contains(Td.x, Td.y)) {
              s = !0;
              break;
            }
        }
        if (!s)
          return !0;
      }
    }
    return !1;
  }
  /**
   * Generates intermediate batch data. Either gets converted to drawCalls
   * or used to convert to batch objects directly by the Graphics object.
   */
  updateBatches() {
    if (!this.graphicsData.length) {
      this.batchable = !0;
      return;
    }
    if (!this.validateBatching())
      return;
    this.cacheDirty = this.dirty;
    const e = this.uvs, n = this.graphicsData;
    let r = null, o = null;
    this.batches.length > 0 && (r = this.batches[this.batches.length - 1], o = r.style);
    for (let l = this.shapeIndex; l < n.length; l++) {
      this.shapeIndex++;
      const a = n[l], c = a.fillStyle, p = a.lineStyle;
      Ab[a.type].build(a), a.matrix && this.transformPoints(a.points, a.matrix), (c.visible || p.visible) && this.processHoles(a.holes);
      for (let d = 0; d < 2; d++) {
        const h = d === 0 ? c : p;
        if (!h.visible)
          continue;
        const m = h.texture.baseTexture, g = this.indices.length, _ = this.points.length / 2;
        m.wrapMode = su.REPEAT, d === 0 ? this.processFill(a) : this.processLine(a);
        const b = this.points.length / 2 - _;
        b !== 0 && (r && !this._compareStyles(o, h) && (r.end(g, _), r = null), r || (r = rO.pop() || new ZTe(), r.begin(h, g, _), this.batches.push(r), o = h), this.addUvs(this.points, e, h.texture, _, b, h.matrix));
      }
    }
    const s = this.indices.length, i = this.points.length / 2;
    if (r && r.end(s, i), this.batches.length === 0) {
      this.batchable = !0;
      return;
    }
    const u = i > 65535;
    this.indicesUint16 && this.indices.length === this.indicesUint16.length && u === this.indicesUint16.BYTES_PER_ELEMENT > 2 ? this.indicesUint16.set(this.indices) : this.indicesUint16 = u ? new Uint32Array(this.indices) : new Uint16Array(this.indices), this.batchable = this.isBatchable(), this.batchable ? this.packBatches() : this.buildDrawCalls();
  }
  /**
   * Affinity check
   * @param styleA
   * @param styleB
   */
  _compareStyles(e, n) {
    return !(!e || !n || e.texture.baseTexture !== n.texture.baseTexture || e.color + e.alpha !== n.color + n.alpha || !!e.native != !!n.native);
  }
  /** Test geometry for batching process. */
  validateBatching() {
    if (this.dirty === this.cacheDirty || !this.graphicsData.length)
      return !1;
    for (let e = 0, n = this.graphicsData.length; e < n; e++) {
      const r = this.graphicsData[e], o = r.fillStyle, s = r.lineStyle;
      if (o && !o.texture.baseTexture.valid || s && !s.texture.baseTexture.valid)
        return !1;
    }
    return !0;
  }
  /** Offset the indices so that it works with the batcher. */
  packBatches() {
    this.batchDirty++, this.uvsFloat32 = new Float32Array(this.uvs);
    const e = this.batches;
    for (let n = 0, r = e.length; n < r; n++) {
      const o = e[n];
      for (let s = 0; s < o.size; s++) {
        const i = o.start + s;
        this.indicesUint16[i] = this.indicesUint16[i] - o.attribStart;
      }
    }
  }
  /**
   * Checks to see if this graphics geometry can be batched.
   * Currently it needs to be small enough and not contain any native lines.
   */
  isBatchable() {
    if (this.points.length > 65535 * 2)
      return !1;
    const e = this.batches;
    for (let n = 0; n < e.length; n++)
      if (e[n].style.native)
        return !1;
    return this.points.length < r6.BATCHABLE_SIZE * 2;
  }
  /** Converts intermediate batches data to drawCalls. */
  buildDrawCalls() {
    let e = ++qt._globalBatch;
    for (let p = 0; p < this.drawCalls.length; p++)
      this.drawCalls[p].texArray.clear(), Mg.push(this.drawCalls[p]);
    this.drawCalls.length = 0;
    const n = this.colors, r = this.textureIds;
    let o = Mg.pop();
    o || (o = new rT(), o.texArray = new uT()), o.texArray.count = 0, o.start = 0, o.size = 0, o.type = Zi.TRIANGLES;
    let s = 0, i = null, u = 0, l = !1, a = Zi.TRIANGLES, c = 0;
    this.drawCalls.push(o);
    for (let p = 0; p < this.batches.length; p++) {
      const d = this.batches[p], h = 8, m = d.style, g = m.texture.baseTexture;
      l !== !!m.native && (l = !!m.native, a = l ? Zi.LINES : Zi.TRIANGLES, i = null, s = h, e++), i !== g && (i = g, g._batchEnabled !== e && (s === h && (e++, s = 0, o.size > 0 && (o = Mg.pop(), o || (o = new rT(), o.texArray = new uT()), this.drawCalls.push(o)), o.start = c, o.size = 0, o.texArray.count = 0, o.type = a), g.touched = 1, g._batchEnabled = e, g._batchLocation = s, g.wrapMode = su.REPEAT, o.texArray.elements[o.texArray.count++] = g, s++)), o.size += d.size, c += d.size, u = g._batchLocation, this.addColors(n, m.color, m.alpha, d.attribSize, d.attribStart), this.addTextureIds(r, u, d.attribSize, d.attribStart);
    }
    qt._globalBatch = e, this.packAttributes();
  }
  /** Packs attributes to single buffer. */
  packAttributes() {
    const e = this.points, n = this.uvs, r = this.colors, o = this.textureIds, s = new ArrayBuffer(e.length * 3 * 4), i = new Float32Array(s), u = new Uint32Array(s);
    let l = 0;
    for (let a = 0; a < e.length / 2; a++)
      i[l++] = e[a * 2], i[l++] = e[a * 2 + 1], i[l++] = n[a * 2], i[l++] = n[a * 2 + 1], u[l++] = r[a], i[l++] = o[a];
    this._buffer.update(s), this._indexBuffer.update(this.indicesUint16);
  }
  /**
   * Process fill part of Graphics.
   * @param data
   */
  processFill(e) {
    e.holes.length ? t6.triangulate(e, this) : Ab[e.type].triangulate(e, this);
  }
  /**
   * Process line part of Graphics.
   * @param data
   */
  processLine(e) {
    nO(e, this);
    for (let n = 0; n < e.holes.length; n++)
      nO(e.holes[n], this);
  }
  /**
   * Process the holes data.
   * @param holes
   */
  processHoles(e) {
    for (let n = 0; n < e.length; n++) {
      const r = e[n];
      Ab[r.type].build(r), r.matrix && this.transformPoints(r.points, r.matrix);
    }
  }
  /** Update the local bounds of the object. Expensive to use performance-wise. */
  calculateBounds() {
    const e = this._bounds;
    e.clear(), e.addVertexData(this.points, 0, this.points.length), e.pad(this.boundsPadding, this.boundsPadding);
  }
  /**
   * Transform points using matrix.
   * @param points - Points to transform
   * @param matrix - Transform matrix
   */
  transformPoints(e, n) {
    for (let r = 0; r < e.length / 2; r++) {
      const o = e[r * 2], s = e[r * 2 + 1];
      e[r * 2] = n.a * o + n.c * s + n.tx, e[r * 2 + 1] = n.b * o + n.d * s + n.ty;
    }
  }
  /**
   * Add colors.
   * @param colors - List of colors to add to
   * @param color - Color to add
   * @param alpha - Alpha to use
   * @param size - Number of colors to add
   * @param offset
   */
  addColors(e, n, r, o, s = 0) {
    const i = Gn.shared.setValue(n).toLittleEndianNumber(), u = Gn.shared.setValue(i).toPremultiplied(r);
    e.length = Math.max(e.length, s + o);
    for (let l = 0; l < o; l++)
      e[s + l] = u;
  }
  /**
   * Add texture id that the shader/fragment wants to use.
   * @param textureIds
   * @param id
   * @param size
   * @param offset
   */
  addTextureIds(e, n, r, o = 0) {
    e.length = Math.max(e.length, o + r);
    for (let s = 0; s < r; s++)
      e[o + s] = n;
  }
  /**
   * Generates the UVs for a shape.
   * @param verts - Vertices
   * @param uvs - UVs
   * @param texture - Reference to Texture
   * @param start - Index buffer start index.
   * @param size - The size/length for index buffer.
   * @param matrix - Optional transform for all points.
   */
  addUvs(e, n, r, o, s, i = null) {
    let u = 0;
    const l = n.length, a = r.frame;
    for (; u < s; ) {
      let p = e[(o + u) * 2], d = e[(o + u) * 2 + 1];
      if (i) {
        const h = i.a * p + i.c * d + i.tx;
        d = i.b * p + i.d * d + i.ty, p = h;
      }
      u++, n.push(p / a.width, d / a.height);
    }
    const c = r.baseTexture;
    (a.width < c.width || a.height < c.height) && this.adjustUvs(n, r, l, s);
  }
  /**
   * Modify uvs array according to position of texture region
   * Does not work with rotated or trimmed textures
   * @param uvs - array
   * @param texture - region
   * @param start - starting index for uvs
   * @param size - how many points to adjust
   */
  adjustUvs(e, n, r, o) {
    const s = n.baseTexture, i = 1e-6, u = r + o * 2, l = n.frame, a = l.width / s.width, c = l.height / s.height;
    let p = l.x / l.width, d = l.y / l.height, h = Math.floor(e[r] + i), m = Math.floor(e[r + 1] + i);
    for (let g = r + 2; g < u; g += 2)
      h = Math.min(h, Math.floor(e[g] + i)), m = Math.min(m, Math.floor(e[g + 1] + i));
    p -= h, d -= m;
    for (let g = r; g < u; g += 2)
      e[g] = (e[g] + p) * a, e[g + 1] = (e[g + 1] + d) * c;
  }
};
n6.BATCHABLE_SIZE = 100;
let txe = n6;
class z_ {
  constructor() {
    this.color = 16777215, this.alpha = 1, this.texture = pt.WHITE, this.matrix = null, this.visible = !1, this.reset();
  }
  /** Clones the object */
  clone() {
    const e = new z_();
    return e.color = this.color, e.alpha = this.alpha, e.texture = this.texture, e.matrix = this.matrix, e.visible = this.visible, e;
  }
  /** Reset */
  reset() {
    this.color = 16777215, this.alpha = 1, this.texture = pt.WHITE, this.matrix = null, this.visible = !1;
  }
  /** Destroy and don't use after this. */
  destroy() {
    this.texture = null, this.matrix = null;
  }
}
class PS extends z_ {
  constructor() {
    super(...arguments), this.width = 0, this.alignment = 0.5, this.native = !1, this.cap = tc.BUTT, this.join = ka.MITER, this.miterLimit = 10;
  }
  /** Clones the object. */
  clone() {
    const e = new PS();
    return e.color = this.color, e.alpha = this.alpha, e.texture = this.texture, e.matrix = this.matrix, e.visible = this.visible, e.width = this.width, e.alignment = this.alignment, e.native = this.native, e.cap = this.cap, e.join = this.join, e.miterLimit = this.miterLimit, e;
  }
  /** Reset the line style to default. */
  reset() {
    super.reset(), this.color = 0, this.alignment = 0.5, this.width = 0, this.native = !1, this.cap = tc.BUTT, this.join = ka.MITER, this.miterLimit = 10;
  }
}
const Db = {}, RT = class a0 extends fn {
  /**
   * @param geometry - Geometry to use, if omitted will create a new GraphicsGeometry instance.
   */
  constructor(e = null) {
    super(), this.shader = null, this.pluginName = "batch", this.currentPath = null, this.batches = [], this.batchTint = -1, this.batchDirty = -1, this.vertexData = null, this._fillStyle = new z_(), this._lineStyle = new PS(), this._matrix = null, this._holeMode = !1, this.state = _u.for2d(), this._geometry = e || new txe(), this._geometry.refCount++, this._transformID = -1, this._tintColor = new Gn(16777215), this.blendMode = Mt.NORMAL;
  }
  /**
   * Includes vertex positions, face indices, normals, colors, UVs, and
   * custom attributes within buffers, reducing the cost of passing all
   * this data to the GPU. Can be shared between multiple Mesh or Graphics objects.
   * @readonly
   */
  get geometry() {
    return this._geometry;
  }
  /**
   * Creates a new Graphics object with the same values as this one.
   * Note that only the geometry of the object is cloned, not its transform (position,scale,etc)
   * @returns - A clone of the graphics object
   */
  clone() {
    return this.finishPoly(), new a0(this._geometry);
  }
  /**
   * The blend mode to be applied to the graphic shape. Apply a value of
   * `PIXI.BLEND_MODES.NORMAL` to reset the blend mode.  Note that, since each
   * primitive in the GraphicsGeometry list is rendered sequentially, modes
   * such as `PIXI.BLEND_MODES.ADD` and `PIXI.BLEND_MODES.MULTIPLY` will
   * be applied per-primitive.
   * @default PIXI.BLEND_MODES.NORMAL
   */
  set blendMode(e) {
    this.state.blendMode = e;
  }
  get blendMode() {
    return this.state.blendMode;
  }
  /**
   * The tint applied to each graphic shape. This is a hex value. A value of
   * 0xFFFFFF will remove any tint effect.
   * @default 0xFFFFFF
   */
  get tint() {
    return this._tintColor.value;
  }
  set tint(e) {
    this._tintColor.setValue(e);
  }
  /**
   * The current fill style.
   * @readonly
   */
  get fill() {
    return this._fillStyle;
  }
  /**
   * The current line style.
   * @readonly
   */
  get line() {
    return this._lineStyle;
  }
  lineStyle(e = null, n = 0, r, o = 0.5, s = !1) {
    return typeof e == "number" && (e = { width: e, color: n, alpha: r, alignment: o, native: s }), this.lineTextureStyle(e);
  }
  /**
   * Like line style but support texture for line fill.
   * @param [options] - Collection of options for setting line style.
   * @param {number} [options.width=0] - width of the line to draw, will update the objects stored style
   * @param {PIXI.Texture} [options.texture=PIXI.Texture.WHITE] - Texture to use
   * @param {PIXI.ColorSource} [options.color=0x0] - color of the line to draw, will update the objects stored style.
   *  Default 0xFFFFFF if texture present.
   * @param {number} [options.alpha=1] - alpha of the line to draw, will update the objects stored style
   * @param {PIXI.Matrix} [options.matrix=null] - Texture matrix to transform texture
   * @param {number} [options.alignment=0.5] - alignment of the line to draw, (0 = inner, 0.5 = middle, 1 = outer).
   *        WebGL only.
   * @param {boolean} [options.native=false] - If true the lines will be draw using LINES instead of TRIANGLE_STRIP
   * @param {PIXI.LINE_CAP}[options.cap=PIXI.LINE_CAP.BUTT] - line cap style
   * @param {PIXI.LINE_JOIN}[options.join=PIXI.LINE_JOIN.MITER] - line join style
   * @param {number}[options.miterLimit=10] - miter limit ratio
   * @returns {PIXI.Graphics} This Graphics object. Good for chaining method calls
   */
  lineTextureStyle(e) {
    const n = {
      width: 0,
      texture: pt.WHITE,
      color: e?.texture ? 16777215 : 0,
      matrix: null,
      alignment: 0.5,
      native: !1,
      cap: tc.BUTT,
      join: ka.MITER,
      miterLimit: 10
    };
    e = Object.assign(n, e), this.normalizeColor(e), this.currentPath && this.startPoly();
    const r = e.width > 0 && e.alpha > 0;
    return r ? (e.matrix && (e.matrix = e.matrix.clone(), e.matrix.invert()), Object.assign(this._lineStyle, { visible: r }, e)) : this._lineStyle.reset(), this;
  }
  /**
   * Start a polygon object internally.
   * @protected
   */
  startPoly() {
    if (this.currentPath) {
      const e = this.currentPath.points, n = this.currentPath.points.length;
      n > 2 && (this.drawShape(this.currentPath), this.currentPath = new xp(), this.currentPath.closeStroke = !1, this.currentPath.points.push(e[n - 2], e[n - 1]));
    } else
      this.currentPath = new xp(), this.currentPath.closeStroke = !1;
  }
  /**
   * Finish the polygon object.
   * @protected
   */
  finishPoly() {
    this.currentPath && (this.currentPath.points.length > 2 ? (this.drawShape(this.currentPath), this.currentPath = null) : this.currentPath.points.length = 0);
  }
  /**
   * Moves the current drawing position to x, y.
   * @param x - the X coordinate to move to
   * @param y - the Y coordinate to move to
   * @returns - This Graphics object. Good for chaining method calls
   */
  moveTo(e, n) {
    return this.startPoly(), this.currentPath.points[0] = e, this.currentPath.points[1] = n, this;
  }
  /**
   * Draws a line using the current line style from the current drawing position to (x, y);
   * The current drawing position is then set to (x, y).
   * @param x - the X coordinate to draw to
   * @param y - the Y coordinate to draw to
   * @returns - This Graphics object. Good for chaining method calls
   */
  lineTo(e, n) {
    this.currentPath || this.moveTo(0, 0);
    const r = this.currentPath.points, o = r[r.length - 2], s = r[r.length - 1];
    return (o !== e || s !== n) && r.push(e, n), this;
  }
  /**
   * Initialize the curve
   * @param x
   * @param y
   */
  _initCurve(e = 0, n = 0) {
    this.currentPath ? this.currentPath.points.length === 0 && (this.currentPath.points = [e, n]) : this.moveTo(e, n);
  }
  /**
   * Calculate the points for a quadratic bezier curve and then draws it.
   * Based on: https://stackoverflow.com/questions/785097/how-do-i-implement-a-bezier-curve-in-c
   * @param cpX - Control point x
   * @param cpY - Control point y
   * @param toX - Destination point x
   * @param toY - Destination point y
   * @returns - This Graphics object. Good for chaining method calls
   */
  quadraticCurveTo(e, n, r, o) {
    this._initCurve();
    const s = this.currentPath.points;
    return s.length === 0 && this.moveTo(0, 0), MS.curveTo(e, n, r, o, s), this;
  }
  /**
   * Calculate the points for a bezier curve and then draws it.
   * @param cpX - Control point x
   * @param cpY - Control point y
   * @param cpX2 - Second Control point x
   * @param cpY2 - Second Control point y
   * @param toX - Destination point x
   * @param toY - Destination point y
   * @returns This Graphics object. Good for chaining method calls
   */
  bezierCurveTo(e, n, r, o, s, i) {
    return this._initCurve(), ES.curveTo(e, n, r, o, s, i, this.currentPath.points), this;
  }
  /**
   * The `arcTo` method creates an arc/curve between two tangents on the canvas.
   * The first tangent is from the start point to the first control point,
   * and the second tangent is from the first control point to the second control point.
   * Note that the second control point is not necessarily the end point of the arc.
   *
   * "borrowed" from https://code.google.com/p/fxcanvas/ - thanks google!
   * @param x1 - The x-coordinate of the first control point of the arc
   * @param y1 - The y-coordinate of the first control point of the arc
   * @param x2 - The x-coordinate of the second control point of the arc
   * @param y2 - The y-coordinate of the second control point of the arc
   * @param radius - The radius of the arc
   * @returns - This Graphics object. Good for chaining method calls
   */
  arcTo(e, n, r, o, s) {
    this._initCurve(e, n);
    const i = this.currentPath.points, u = eO.curveTo(e, n, r, o, s, i);
    if (u) {
      const { cx: l, cy: a, radius: c, startAngle: p, endAngle: d, anticlockwise: h } = u;
      this.arc(l, a, c, p, d, h);
    }
    return this;
  }
  /**
   * The arc method creates an arc/curve (used to create circles, or parts of circles).
   * @param cx - The x-coordinate of the center of the circle
   * @param cy - The y-coordinate of the center of the circle
   * @param radius - The radius of the circle
   * @param startAngle - The starting angle, in radians (0 is at the 3 o'clock position
   *  of the arc's circle)
   * @param endAngle - The ending angle, in radians
   * @param anticlockwise - Specifies whether the drawing should be
   *  counter-clockwise or clockwise. False is default, and indicates clockwise, while true
   *  indicates counter-clockwise.
   * @returns - This Graphics object. Good for chaining method calls
   */
  arc(e, n, r, o, s, i = !1) {
    if (o === s)
      return this;
    if (!i && s <= o ? s += sv : i && o <= s && (o += sv), s - o === 0)
      return this;
    const u = e + Math.cos(o) * r, l = n + Math.sin(o) * r, a = this._geometry.closePointEps;
    let c = this.currentPath ? this.currentPath.points : null;
    if (c) {
      const p = Math.abs(c[c.length - 2] - u), d = Math.abs(c[c.length - 1] - l);
      p < a && d < a || c.push(u, l);
    } else
      this.moveTo(u, l), c = this.currentPath.points;
    return eO.arc(u, l, e, n, r, o, s, i, c), this;
  }
  /**
   * Specifies a simple one-color fill that subsequent calls to other Graphics methods
   * (such as lineTo() or drawCircle()) use when drawing.
   * @param {PIXI.ColorSource} color - the color of the fill
   * @param alpha - the alpha of the fill, will override the color's alpha
   * @returns - This Graphics object. Suitable for chaining method calls
   */
  beginFill(e = 0, n) {
    return this.beginTextureFill({ texture: pt.WHITE, color: e, alpha: n });
  }
  /**
   * Normalize the color input from options for line style or fill
   * @param {PIXI.IFillStyleOptions} options - Fill style object.
   */
  normalizeColor(e) {
    const n = Gn.shared.setValue(e.color ?? 0);
    e.color = n.toNumber(), e.alpha ?? (e.alpha = n.alpha);
  }
  /**
   * Begin the texture fill.
   * Note: The wrap mode of the texture is forced to REPEAT on render.
   * @param options - Fill style object.
   * @param {PIXI.Texture} [options.texture=PIXI.Texture.WHITE] - Texture to fill
   * @param {PIXI.ColorSource} [options.color=0xffffff] - Background to fill behind texture
   * @param {number} [options.alpha] - Alpha of fill, overrides the color's alpha
   * @param {PIXI.Matrix} [options.matrix=null] - Transform matrix
   * @returns {PIXI.Graphics} This Graphics object. Good for chaining method calls
   */
  beginTextureFill(e) {
    const n = {
      texture: pt.WHITE,
      color: 16777215,
      matrix: null
    };
    e = Object.assign(n, e), this.normalizeColor(e), this.currentPath && this.startPoly();
    const r = e.alpha > 0;
    return r ? (e.matrix && (e.matrix = e.matrix.clone(), e.matrix.invert()), Object.assign(this._fillStyle, { visible: r }, e)) : this._fillStyle.reset(), this;
  }
  /**
   * Applies a fill to the lines and shapes that were added since the last call to the beginFill() method.
   * @returns - This Graphics object. Good for chaining method calls
   */
  endFill() {
    return this.finishPoly(), this._fillStyle.reset(), this;
  }
  /**
   * Draws a rectangle shape.
   * @param x - The X coord of the top-left of the rectangle
   * @param y - The Y coord of the top-left of the rectangle
   * @param width - The width of the rectangle
   * @param height - The height of the rectangle
   * @returns - This Graphics object. Good for chaining method calls
   */
  drawRect(e, n, r, o) {
    return this.drawShape(new Pt(e, n, r, o));
  }
  /**
   * Draw a rectangle shape with rounded/beveled corners.
   * @param x - The X coord of the top-left of the rectangle
   * @param y - The Y coord of the top-left of the rectangle
   * @param width - The width of the rectangle
   * @param height - The height of the rectangle
   * @param radius - Radius of the rectangle corners
   * @returns - This Graphics object. Good for chaining method calls
   */
  drawRoundedRect(e, n, r, o, s) {
    return this.drawShape(new V_(e, n, r, o, s));
  }
  /**
   * Draws a circle.
   * @param x - The X coordinate of the center of the circle
   * @param y - The Y coordinate of the center of the circle
   * @param radius - The radius of the circle
   * @returns - This Graphics object. Good for chaining method calls
   */
  drawCircle(e, n, r) {
    return this.drawShape(new $_(e, n, r));
  }
  /**
   * Draws an ellipse.
   * @param x - The X coordinate of the center of the ellipse
   * @param y - The Y coordinate of the center of the ellipse
   * @param width - The half width of the ellipse
   * @param height - The half height of the ellipse
   * @returns - This Graphics object. Good for chaining method calls
   */
  drawEllipse(e, n, r, o) {
    return this.drawShape(new W_(e, n, r, o));
  }
  /**
   * Draws a polygon using the given path.
   * @param {number[]|PIXI.IPointData[]|PIXI.Polygon} path - The path data used to construct the polygon.
   * @returns - This Graphics object. Good for chaining method calls
   */
  drawPolygon(...e) {
    let n, r = !0;
    const o = e[0];
    o.points ? (r = o.closeStroke, n = o.points) : Array.isArray(e[0]) ? n = e[0] : n = e;
    const s = new xp(n);
    return s.closeStroke = r, this.drawShape(s), this;
  }
  /**
   * Draw any shape.
   * @param {PIXI.Circle|PIXI.Ellipse|PIXI.Polygon|PIXI.Rectangle|PIXI.RoundedRectangle} shape - Shape to draw
   * @returns - This Graphics object. Good for chaining method calls
   */
  drawShape(e) {
    return this._holeMode ? this._geometry.drawHole(e, this._matrix) : this._geometry.drawShape(
      e,
      this._fillStyle.clone(),
      this._lineStyle.clone(),
      this._matrix
    ), this;
  }
  /**
   * Clears the graphics that were drawn to this Graphics object, and resets fill and line style settings.
   * @returns - This Graphics object. Good for chaining method calls
   */
  clear() {
    return this._geometry.clear(), this._lineStyle.reset(), this._fillStyle.reset(), this._boundsID++, this._matrix = null, this._holeMode = !1, this.currentPath = null, this;
  }
  /**
   * True if graphics consists of one rectangle, and thus, can be drawn like a Sprite and
   * masked with gl.scissor.
   * @returns - True if only 1 rect.
   */
  isFastRect() {
    const e = this._geometry.graphicsData;
    return e.length === 1 && e[0].shape.type === Ao.RECT && !e[0].matrix && !e[0].holes.length && !(e[0].lineStyle.visible && e[0].lineStyle.width);
  }
  /**
   * Renders the object using the WebGL renderer
   * @param renderer - The renderer
   */
  _render(e) {
    this.finishPoly();
    const n = this._geometry;
    n.updateBatches(), n.batchable ? (this.batchDirty !== n.batchDirty && this._populateBatches(), this._renderBatched(e)) : (e.batch.flush(), this._renderDirect(e));
  }
  /** Populating batches for rendering. */
  _populateBatches() {
    const e = this._geometry, n = this.blendMode, r = e.batches.length;
    this.batchTint = -1, this._transformID = -1, this.batchDirty = e.batchDirty, this.batches.length = r, this.vertexData = new Float32Array(e.points);
    for (let o = 0; o < r; o++) {
      const s = e.batches[o], i = s.style.color, u = new Float32Array(
        this.vertexData.buffer,
        s.attribStart * 4 * 2,
        s.attribSize * 2
      ), l = new Float32Array(
        e.uvsFloat32.buffer,
        s.attribStart * 4 * 2,
        s.attribSize * 2
      ), a = new Uint16Array(
        e.indicesUint16.buffer,
        s.start * 2,
        s.size
      ), c = {
        vertexData: u,
        blendMode: n,
        indices: a,
        uvs: l,
        _batchRGB: Gn.shared.setValue(i).toRgbArray(),
        _tintRGB: i,
        _texture: s.style.texture,
        alpha: s.style.alpha,
        worldAlpha: 1
      };
      this.batches[o] = c;
    }
  }
  /**
   * Renders the batches using the BathedRenderer plugin
   * @param renderer - The renderer
   */
  _renderBatched(e) {
    if (this.batches.length) {
      e.batch.setObjectRenderer(e.plugins[this.pluginName]), this.calculateVertices(), this.calculateTints();
      for (let n = 0, r = this.batches.length; n < r; n++) {
        const o = this.batches[n];
        o.worldAlpha = this.worldAlpha * o.alpha, e.plugins[this.pluginName].render(o);
      }
    }
  }
  /**
   * Renders the graphics direct
   * @param renderer - The renderer
   */
  _renderDirect(e) {
    const n = this._resolveDirectShader(e), r = this._geometry, o = this.worldAlpha, s = n.uniforms, i = r.drawCalls;
    s.translationMatrix = this.transform.worldTransform, Gn.shared.setValue(this._tintColor).premultiply(o).toArray(s.tint), e.shader.bind(n), e.geometry.bind(r, n), e.state.set(this.state);
    for (let u = 0, l = i.length; u < l; u++)
      this._renderDrawCallDirect(e, r.drawCalls[u]);
  }
  /**
   * Renders specific DrawCall
   * @param renderer
   * @param drawCall
   */
  _renderDrawCallDirect(e, n) {
    const { texArray: r, type: o, size: s, start: i } = n, u = r.count;
    for (let l = 0; l < u; l++)
      e.texture.bind(r.elements[l], l);
    e.geometry.draw(o, s, i);
  }
  /**
   * Resolves shader for direct rendering
   * @param renderer - The renderer
   */
  _resolveDirectShader(e) {
    let n = this.shader;
    const r = this.pluginName;
    if (!n) {
      if (!Db[r]) {
        const { maxTextures: o } = e.plugins[r], s = new Int32Array(o);
        for (let l = 0; l < o; l++)
          s[l] = l;
        const i = {
          tint: new Float32Array([1, 1, 1, 1]),
          translationMatrix: new Qn(),
          default: di.from({ uSamplers: s }, !0)
        }, u = e.plugins[r]._shader.program;
        Db[r] = new iu(u, i);
      }
      n = Db[r];
    }
    return n;
  }
  /**
   * Retrieves the bounds of the graphic shape as a rectangle object.
   * @see PIXI.GraphicsGeometry#bounds
   */
  _calculateBounds() {
    this.finishPoly();
    const e = this._geometry;
    if (!e.graphicsData.length)
      return;
    const { minX: n, minY: r, maxX: o, maxY: s } = e.bounds;
    this._bounds.addFrame(this.transform, n, r, o, s);
  }
  /**
   * Tests if a point is inside this graphics object
   * @param point - the point to test
   * @returns - the result of the test
   */
  containsPoint(e) {
    return this.worldTransform.applyInverse(e, a0._TEMP_POINT), this._geometry.containsPoint(a0._TEMP_POINT);
  }
  /** Recalculate the tint by applying tint to batches using Graphics tint. */
  calculateTints() {
    if (this.batchTint !== this.tint) {
      this.batchTint = this._tintColor.toNumber();
      for (let e = 0; e < this.batches.length; e++) {
        const n = this.batches[e];
        n._tintRGB = Gn.shared.setValue(this._tintColor).multiply(n._batchRGB).toLittleEndianNumber();
      }
    }
  }
  /** If there's a transform update or a change to the shape of the geometry, recalculate the vertices. */
  calculateVertices() {
    const e = this.transform._worldID;
    if (this._transformID === e)
      return;
    this._transformID = e;
    const n = this.transform.worldTransform, r = n.a, o = n.b, s = n.c, i = n.d, u = n.tx, l = n.ty, a = this._geometry.points, c = this.vertexData;
    let p = 0;
    for (let d = 0; d < a.length; d += 2) {
      const h = a[d], m = a[d + 1];
      c[p++] = r * h + s * m + u, c[p++] = i * m + o * h + l;
    }
  }
  /**
   * Closes the current path.
   * @returns - Returns itself.
   */
  closePath() {
    const e = this.currentPath;
    return e && (e.closeStroke = !0, this.finishPoly()), this;
  }
  /**
   * Apply a matrix to the positional data.
   * @param matrix - Matrix to use for transform current shape.
   * @returns - Returns itself.
   */
  setMatrix(e) {
    return this._matrix = e, this;
  }
  /**
   * Begin adding holes to the last draw shape
   * IMPORTANT: holes must be fully inside a shape to work
   * Also weirdness ensues if holes overlap!
   * Ellipses, Circles, Rectangles and Rounded Rectangles cannot be holes or host for holes in CanvasRenderer,
   * please use `moveTo` `lineTo`, `quadraticCurveTo` if you rely on pixi-legacy bundle.
   * @returns - Returns itself.
   */
  beginHole() {
    return this.finishPoly(), this._holeMode = !0, this;
  }
  /**
   * End adding holes to the last draw shape.
   * @returns - Returns itself.
   */
  endHole() {
    return this.finishPoly(), this._holeMode = !1, this;
  }
  /**
   * Destroys the Graphics object.
   * @param options - Options parameter. A boolean will act as if all
   *  options have been set to that value
   * @param {boolean} [options.children=false] - if set to true, all the children will have
   *  their destroy method called as well. 'options' will be passed on to those calls.
   * @param {boolean} [options.texture=false] - Only used for child Sprites if options.children is set to true
   *  Should it destroy the texture of the child sprite
   * @param {boolean} [options.baseTexture=false] - Only used for child Sprites if options.children is set to true
   *  Should it destroy the base texture of the child sprite
   */
  destroy(e) {
    this._geometry.refCount--, this._geometry.refCount === 0 && this._geometry.dispose(), this._matrix = null, this.currentPath = null, this._lineStyle.destroy(), this._lineStyle = null, this._fillStyle.destroy(), this._fillStyle = null, this._geometry = null, this.shader = null, this.vertexData = null, this.batches.length = 0, this.batches = null, super.destroy(e);
  }
};
RT.curves = vh, /**
* Temporary point to use for containsPoint.
* @private
*/
RT._TEMP_POINT = new Rt();
let vc = RT;
class nxe {
  /**
   * @param uvBuffer - Buffer with normalized uv's
   * @param uvMatrix - Material UV matrix
   */
  constructor(e, n) {
    this.uvBuffer = e, this.uvMatrix = n, this.data = null, this._bufferUpdateId = -1, this._textureUpdateId = -1, this._updateID = 0;
  }
  /**
   * Updates
   * @param forceUpdate - force the update
   */
  update(e) {
    if (!e && this._bufferUpdateId === this.uvBuffer._updateID && this._textureUpdateId === this.uvMatrix._updateID)
      return;
    this._bufferUpdateId = this.uvBuffer._updateID, this._textureUpdateId = this.uvMatrix._updateID;
    const n = this.uvBuffer.data;
    (!this.data || this.data.length !== n.length) && (this.data = new Float32Array(n.length)), this.uvMatrix.multiplyUvs(n, this.data), this._updateID++;
  }
}
const Eb = new Rt(), oO = new xp(), o6 = class s6 extends fn {
  /**
   * @param geometry - The geometry the mesh will use.
   * @param {PIXI.MeshMaterial} shader - The shader the mesh will use.
   * @param state - The state that the WebGL context is required to be in to render the mesh
   *        if no state is provided, uses {@link PIXI.State.for2d} to create a 2D state for PixiJS.
   * @param drawMode - The drawMode, can be any of the {@link PIXI.DRAW_MODES} constants.
   */
  constructor(e, n, r, o = Zi.TRIANGLES) {
    super(), this.geometry = e, this.shader = n, this.state = r || _u.for2d(), this.drawMode = o, this.start = 0, this.size = 0, this.uvs = null, this.indices = null, this.vertexData = new Float32Array(1), this.vertexDirty = -1, this._transformID = -1, this._roundPixels = at.ROUND_PIXELS, this.batchUvs = null;
  }
  /**
   * Includes vertex positions, face indices, normals, colors, UVs, and
   * custom attributes within buffers, reducing the cost of passing all
   * this data to the GPU. Can be shared between multiple Mesh objects.
   */
  get geometry() {
    return this._geometry;
  }
  set geometry(e) {
    this._geometry !== e && (this._geometry && (this._geometry.refCount--, this._geometry.refCount === 0 && this._geometry.dispose()), this._geometry = e, this._geometry && this._geometry.refCount++, this.vertexDirty = -1);
  }
  /**
   * To change mesh uv's, change its uvBuffer data and increment its _updateID.
   * @readonly
   */
  get uvBuffer() {
    return this.geometry.buffers[1];
  }
  /**
   * To change mesh vertices, change its uvBuffer data and increment its _updateID.
   * Incrementing _updateID is optional because most of Mesh objects do it anyway.
   * @readonly
   */
  get verticesBuffer() {
    return this.geometry.buffers[0];
  }
  /** Alias for {@link PIXI.Mesh#shader}. */
  set material(e) {
    this.shader = e;
  }
  get material() {
    return this.shader;
  }
  /**
   * The blend mode to be applied to the Mesh. Apply a value of
   * `PIXI.BLEND_MODES.NORMAL` to reset the blend mode.
   * @default PIXI.BLEND_MODES.NORMAL;
   */
  set blendMode(e) {
    this.state.blendMode = e;
  }
  get blendMode() {
    return this.state.blendMode;
  }
  /**
   * If true PixiJS will Math.floor() x/y values when rendering, stopping pixel interpolation.
   * Advantages can include sharper image quality (like text) and faster rendering on canvas.
   * The main disadvantage is movement of objects may appear less smooth.
   * To set the global default, change {@link PIXI.settings.ROUND_PIXELS}
   * @default false
   */
  set roundPixels(e) {
    this._roundPixels !== e && (this._transformID = -1), this._roundPixels = e;
  }
  get roundPixels() {
    return this._roundPixels;
  }
  /**
   * The multiply tint applied to the Mesh. This is a hex value. A value of
   * `0xFFFFFF` will remove any tint effect.
   *
   * Null for non-MeshMaterial shaders
   * @default 0xFFFFFF
   */
  get tint() {
    return "tint" in this.shader ? this.shader.tint : null;
  }
  set tint(e) {
    this.shader.tint = e;
  }
  /**
   * The tint color as a RGB integer
   * @ignore
   */
  get tintValue() {
    return this.shader.tintValue;
  }
  /** The texture that the Mesh uses. Null for non-MeshMaterial shaders */
  get texture() {
    return "texture" in this.shader ? this.shader.texture : null;
  }
  set texture(e) {
    this.shader.texture = e;
  }
  /**
   * Standard renderer draw.
   * @param renderer - Instance to renderer.
   */
  _render(e) {
    const n = this.geometry.buffers[0].data;
    this.shader.batchable && this.drawMode === Zi.TRIANGLES && n.length < s6.BATCHABLE_SIZE * 2 ? this._renderToBatch(e) : this._renderDefault(e);
  }
  /**
   * Standard non-batching way of rendering.
   * @param renderer - Instance to renderer.
   */
  _renderDefault(e) {
    const n = this.shader;
    n.alpha = this.worldAlpha, n.update && n.update(), e.batch.flush(), n.uniforms.translationMatrix = this.transform.worldTransform.toArray(!0), e.shader.bind(n), e.state.set(this.state), e.geometry.bind(this.geometry, n), e.geometry.draw(this.drawMode, this.size, this.start, this.geometry.instanceCount);
  }
  /**
   * Rendering by using the Batch system.
   * @param renderer - Instance to renderer.
   */
  _renderToBatch(e) {
    const n = this.geometry, r = this.shader;
    r.uvMatrix && (r.uvMatrix.update(), this.calculateUvs()), this.calculateVertices(), this.indices = n.indexBuffer.data, this._tintRGB = r._tintRGB, this._texture = r.texture;
    const o = this.material.pluginName;
    e.batch.setObjectRenderer(e.plugins[o]), e.plugins[o].render(this);
  }
  /** Updates vertexData field based on transform and vertices. */
  calculateVertices() {
    const e = this.geometry.buffers[0], n = e.data, r = e._updateID;
    if (r === this.vertexDirty && this._transformID === this.transform._worldID)
      return;
    this._transformID = this.transform._worldID, this.vertexData.length !== n.length && (this.vertexData = new Float32Array(n.length));
    const o = this.transform.worldTransform, s = o.a, i = o.b, u = o.c, l = o.d, a = o.tx, c = o.ty, p = this.vertexData;
    for (let d = 0; d < p.length / 2; d++) {
      const h = n[d * 2], m = n[d * 2 + 1];
      p[d * 2] = s * h + u * m + a, p[d * 2 + 1] = i * h + l * m + c;
    }
    if (this._roundPixels) {
      const d = at.RESOLUTION;
      for (let h = 0; h < p.length; ++h)
        p[h] = Math.round(p[h] * d) / d;
    }
    this.vertexDirty = r;
  }
  /** Updates uv field based on from geometry uv's or batchUvs. */
  calculateUvs() {
    const e = this.geometry.buffers[1], n = this.shader;
    n.uvMatrix.isSimple ? this.uvs = e.data : (this.batchUvs || (this.batchUvs = new nxe(e, n.uvMatrix)), this.batchUvs.update(), this.uvs = this.batchUvs.data);
  }
  /**
   * Updates the bounds of the mesh as a rectangle. The bounds calculation takes the worldTransform into account.
   * there must be a aVertexPosition attribute present in the geometry for bounds to be calculated correctly.
   */
  _calculateBounds() {
    this.calculateVertices(), this._bounds.addVertexData(this.vertexData, 0, this.vertexData.length);
  }
  /**
   * Tests if a point is inside this mesh. Works only for PIXI.DRAW_MODES.TRIANGLES.
   * @param point - The point to test.
   * @returns - The result of the test.
   */
  containsPoint(e) {
    if (!this.getBounds().contains(e.x, e.y))
      return !1;
    this.worldTransform.applyInverse(e, Eb);
    const n = this.geometry.getBuffer("aVertexPosition").data, r = oO.points, o = this.geometry.getIndex().data, s = o.length, i = this.drawMode === 4 ? 3 : 1;
    for (let u = 0; u + 2 < s; u += i) {
      const l = o[u] * 2, a = o[u + 1] * 2, c = o[u + 2] * 2;
      if (r[0] = n[l], r[1] = n[l + 1], r[2] = n[a], r[3] = n[a + 1], r[4] = n[c], r[5] = n[c + 1], oO.contains(Eb.x, Eb.y))
        return !0;
    }
    return !1;
  }
  destroy(e) {
    super.destroy(e), this._cachedTexture && (this._cachedTexture.destroy(), this._cachedTexture = null), this.geometry = null, this.shader = null, this.state = null, this.uvs = null, this.indices = null, this.vertexData = null;
  }
};
o6.BATCHABLE_SIZE = 100;
let AT = o6;
class a6 extends yc {
  /**
   * @param {Float32Array|number[]} [vertices] - Positional data on geometry.
   * @param {Float32Array|number[]} [uvs] - Texture UVs.
   * @param {Uint16Array|number[]} [index] - IndexBuffer
   */
  constructor(e, n, r) {
    super();
    const o = new Fr(e), s = new Fr(n, !0), i = new Fr(r, !0, !0);
    this.addAttribute("aVertexPosition", o, 2, !1, _t.FLOAT).addAttribute("aTextureCoord", s, 2, !1, _t.FLOAT).addIndex(i), this._updateId = -1;
  }
  /**
   * If the vertex position is updated.
   * @readonly
   * @private
   */
  get vertexDirtyId() {
    return this.buffers[0]._updateID;
  }
}
var rxe = `varying vec2 vTextureCoord;
uniform vec4 uColor;

uniform sampler2D uSampler;

void main(void)
{
    gl_FragColor = texture2D(uSampler, vTextureCoord) * uColor;
}
`, oxe = `attribute vec2 aVertexPosition;
attribute vec2 aTextureCoord;

uniform mat3 projectionMatrix;
uniform mat3 translationMatrix;
uniform mat3 uTextureMatrix;

varying vec2 vTextureCoord;

void main(void)
{
    gl_Position = vec4((projectionMatrix * translationMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);

    vTextureCoord = (uTextureMatrix * vec3(aTextureCoord, 1.0)).xy;
}
`;
class DT extends iu {
  /**
   * @param uSampler - Texture that material uses to render.
   * @param options - Additional options
   * @param {number} [options.alpha=1] - Default alpha.
   * @param {PIXI.ColorSource} [options.tint=0xFFFFFF] - Default tint.
   * @param {string} [options.pluginName='batch'] - Renderer plugin for batching.
   * @param {PIXI.Program} [options.program=0xFFFFFF] - Custom program.
   * @param {object} [options.uniforms] - Custom uniforms.
   */
  constructor(e, n) {
    const r = {
      uSampler: e,
      alpha: 1,
      uTextureMatrix: Qn.IDENTITY,
      uColor: new Float32Array([1, 1, 1, 1])
    };
    n = Object.assign({
      tint: 16777215,
      alpha: 1,
      pluginName: "batch"
    }, n), n.uniforms && Object.assign(r, n.uniforms), super(n.program || Qu.from(oxe, rxe), r), this._colorDirty = !1, this.uvMatrix = new kB(e), this.batchable = n.program === void 0, this.pluginName = n.pluginName, this._tintColor = new Gn(n.tint), this._tintRGB = this._tintColor.toLittleEndianNumber(), this._colorDirty = !0, this.alpha = n.alpha;
  }
  /** Reference to the texture being rendered. */
  get texture() {
    return this.uniforms.uSampler;
  }
  set texture(e) {
    this.uniforms.uSampler !== e && (!this.uniforms.uSampler.baseTexture.alphaMode != !e.baseTexture.alphaMode && (this._colorDirty = !0), this.uniforms.uSampler = e, this.uvMatrix.texture = e);
  }
  /**
   * This gets automatically set by the object using this.
   * @default 1
   */
  set alpha(e) {
    e !== this._alpha && (this._alpha = e, this._colorDirty = !0);
  }
  get alpha() {
    return this._alpha;
  }
  /**
   * Multiply tint for the material.
   * @default 0xFFFFFF
   */
  set tint(e) {
    e !== this.tint && (this._tintColor.setValue(e), this._tintRGB = this._tintColor.toLittleEndianNumber(), this._colorDirty = !0);
  }
  get tint() {
    return this._tintColor.value;
  }
  /**
   * Get the internal number from tint color
   * @ignore
   */
  get tintValue() {
    return this._tintColor.toNumber();
  }
  /** Gets called automatically by the Mesh. Intended to be overridden for custom {@link PIXI.MeshMaterial} objects. */
  update() {
    if (this._colorDirty) {
      this._colorDirty = !1;
      const e = this.texture.baseTexture.alphaMode;
      Gn.shared.setValue(this._tintColor).premultiply(this._alpha, e).toArray(this.uniforms.uColor);
    }
    this.uvMatrix.update() && (this.uniforms.uTextureMatrix = this.uvMatrix.mapCoord);
  }
}
class sxe extends a6 {
  /**
   * @param width - The width (i.e., thickness) of the rope.
   * @param points - An array of {@link PIXI.Point} objects to construct this rope.
   * @param textureScale - By default the rope texture will be stretched to match
   *     rope length. If textureScale is positive this value will be treated as a scaling
   *     factor and the texture will preserve its aspect ratio instead. To create a tiling rope
   *     set baseTexture.wrapMode to {@link PIXI.WRAP_MODES.REPEAT} and use a power of two texture,
   *     then set textureScale=1 to keep the original texture pixel size.
   *     In order to reduce alpha channel artifacts provide a larger texture and downsample -
   *     i.e. set textureScale=0.5 to scale it down twice.
   */
  constructor(e = 200, n, r = 0) {
    super(
      new Float32Array(n.length * 4),
      new Float32Array(n.length * 4),
      new Uint16Array((n.length - 1) * 6)
    ), this.points = n, this._width = e, this.textureScale = r, this.build();
  }
  /**
   * The width (i.e., thickness) of the rope.
   * @readonly
   */
  get width() {
    return this._width;
  }
  /** Refreshes Rope indices and uvs */
  build() {
    const e = this.points;
    if (!e)
      return;
    const n = this.getBuffer("aVertexPosition"), r = this.getBuffer("aTextureCoord"), o = this.getIndex();
    if (e.length < 1)
      return;
    n.data.length / 4 !== e.length && (n.data = new Float32Array(e.length * 4), r.data = new Float32Array(e.length * 4), o.data = new Uint16Array((e.length - 1) * 6));
    const s = r.data, i = o.data;
    s[0] = 0, s[1] = 0, s[2] = 0, s[3] = 1;
    let u = 0, l = e[0];
    const a = this._width * this.textureScale, c = e.length;
    for (let d = 0; d < c; d++) {
      const h = d * 4;
      if (this.textureScale > 0) {
        const m = l.x - e[d].x, g = l.y - e[d].y, _ = Math.sqrt(m * m + g * g);
        l = e[d], u += _ / a;
      } else
        u = d / (c - 1);
      s[h] = u, s[h + 1] = 0, s[h + 2] = u, s[h + 3] = 1;
    }
    let p = 0;
    for (let d = 0; d < c - 1; d++) {
      const h = d * 2;
      i[p++] = h, i[p++] = h + 1, i[p++] = h + 2, i[p++] = h + 2, i[p++] = h + 1, i[p++] = h + 3;
    }
    r.update(), o.update(), this.updateVertices();
  }
  /** refreshes vertices of Rope mesh */
  updateVertices() {
    const e = this.points;
    if (e.length < 1)
      return;
    let n = e[0], r, o = 0, s = 0;
    const i = this.buffers[0].data, u = e.length, l = this.textureScale > 0 ? this.textureScale * this._width / 2 : this._width / 2;
    for (let a = 0; a < u; a++) {
      const c = e[a], p = a * 4;
      a < e.length - 1 ? r = e[a + 1] : r = c, s = -(r.x - n.x), o = r.y - n.y;
      const d = Math.sqrt(o * o + s * s);
      d < 1e-6 ? (o = 0, s = 0) : (o /= d, s /= d, o *= l, s *= l), i[p] = c.x + o, i[p + 1] = c.y + s, i[p + 2] = c.x - o, i[p + 3] = c.y - s, n = c;
    }
    this.buffers[0].update();
  }
  update() {
    this.textureScale > 0 ? this.build() : this.updateVertices();
  }
}
class axe extends AT {
  /**
   * Note: The wrap mode of the texture is set to REPEAT if `textureScale` is positive.
   * @param texture - The texture to use on the rope.
   * @param points - An array of {@link PIXI.Point} objects to construct this rope.
   * @param {number} textureScale - Optional. Positive values scale rope texture
   * keeping its aspect ratio. You can reduce alpha channel artifacts by providing a larger texture
   * and downsampling here. If set to zero, texture will be stretched instead.
   */
  constructor(e, n, r = 0) {
    const o = new sxe(e.height, n, r), s = new DT(e);
    r > 0 && (e.baseTexture.wrapMode = su.REPEAT), super(o, s), this.autoUpdate = !0;
  }
  _render(e) {
    const n = this.geometry;
    (this.autoUpdate || n._width !== this.shader.texture.height) && (n._width = this.shader.texture.height, n.update()), super._render(e);
  }
}
class sO {
  /**
   * @param {object} properties - The properties to upload.
   * @param {boolean[]} dynamicPropertyFlags - Flags for which properties are dynamic.
   * @param {number} size - The size of the batch.
   */
  constructor(e, n, r) {
    this.geometry = new yc(), this.indexBuffer = null, this.size = r, this.dynamicProperties = [], this.staticProperties = [];
    for (let o = 0; o < e.length; ++o) {
      let s = e[o];
      s = {
        attributeName: s.attributeName,
        size: s.size,
        uploadFunction: s.uploadFunction,
        type: s.type || _t.FLOAT,
        offset: s.offset
      }, n[o] ? this.dynamicProperties.push(s) : this.staticProperties.push(s);
    }
    this.staticStride = 0, this.staticBuffer = null, this.staticData = null, this.staticDataUint32 = null, this.dynamicStride = 0, this.dynamicBuffer = null, this.dynamicData = null, this.dynamicDataUint32 = null, this._updateID = 0, this.initBuffers();
  }
  /** Sets up the renderer context and necessary buffers. */
  initBuffers() {
    const e = this.geometry;
    let n = 0;
    this.indexBuffer = new Fr(D1e(this.size), !0, !0), e.addIndex(this.indexBuffer), this.dynamicStride = 0;
    for (let i = 0; i < this.dynamicProperties.length; ++i) {
      const u = this.dynamicProperties[i];
      u.offset = n, n += u.size, this.dynamicStride += u.size;
    }
    const r = new ArrayBuffer(this.size * this.dynamicStride * 4 * 4);
    this.dynamicData = new Float32Array(r), this.dynamicDataUint32 = new Uint32Array(r), this.dynamicBuffer = new Fr(this.dynamicData, !1, !1);
    let o = 0;
    this.staticStride = 0;
    for (let i = 0; i < this.staticProperties.length; ++i) {
      const u = this.staticProperties[i];
      u.offset = o, o += u.size, this.staticStride += u.size;
    }
    const s = new ArrayBuffer(this.size * this.staticStride * 4 * 4);
    this.staticData = new Float32Array(s), this.staticDataUint32 = new Uint32Array(s), this.staticBuffer = new Fr(this.staticData, !0, !1);
    for (let i = 0; i < this.dynamicProperties.length; ++i) {
      const u = this.dynamicProperties[i];
      e.addAttribute(
        u.attributeName,
        this.dynamicBuffer,
        0,
        u.type === _t.UNSIGNED_BYTE,
        u.type,
        this.dynamicStride * 4,
        u.offset * 4
      );
    }
    for (let i = 0; i < this.staticProperties.length; ++i) {
      const u = this.staticProperties[i];
      e.addAttribute(
        u.attributeName,
        this.staticBuffer,
        0,
        u.type === _t.UNSIGNED_BYTE,
        u.type,
        this.staticStride * 4,
        u.offset * 4
      );
    }
  }
  /**
   * Uploads the dynamic properties.
   * @param children - The children to upload.
   * @param startIndex - The index to start at.
   * @param amount - The number to upload.
   */
  uploadDynamic(e, n, r) {
    for (let o = 0; o < this.dynamicProperties.length; o++) {
      const s = this.dynamicProperties[o];
      s.uploadFunction(
        e,
        n,
        r,
        s.type === _t.UNSIGNED_BYTE ? this.dynamicDataUint32 : this.dynamicData,
        this.dynamicStride,
        s.offset
      );
    }
    this.dynamicBuffer._updateID++;
  }
  /**
   * Uploads the static properties.
   * @param children - The children to upload.
   * @param startIndex - The index to start at.
   * @param amount - The number to upload.
   */
  uploadStatic(e, n, r) {
    for (let o = 0; o < this.staticProperties.length; o++) {
      const s = this.staticProperties[o];
      s.uploadFunction(
        e,
        n,
        r,
        s.type === _t.UNSIGNED_BYTE ? this.staticDataUint32 : this.staticData,
        this.staticStride,
        s.offset
      );
    }
    this.staticBuffer._updateID++;
  }
  /** Destroys the ParticleBuffer. */
  destroy() {
    this.indexBuffer = null, this.dynamicProperties = null, this.dynamicBuffer = null, this.dynamicData = null, this.dynamicDataUint32 = null, this.staticProperties = null, this.staticBuffer = null, this.staticData = null, this.staticDataUint32 = null, this.geometry.destroy();
  }
}
var ixe = `varying vec2 vTextureCoord;
varying vec4 vColor;

uniform sampler2D uSampler;

void main(void){
    vec4 color = texture2D(uSampler, vTextureCoord) * vColor;
    gl_FragColor = color;
}`, uxe = `attribute vec2 aVertexPosition;
attribute vec2 aTextureCoord;
attribute vec4 aColor;

attribute vec2 aPositionCoord;
attribute float aRotation;

uniform mat3 translationMatrix;
uniform vec4 uColor;

varying vec2 vTextureCoord;
varying vec4 vColor;

void main(void){
    float x = (aVertexPosition.x) * cos(aRotation) - (aVertexPosition.y) * sin(aRotation);
    float y = (aVertexPosition.x) * sin(aRotation) + (aVertexPosition.y) * cos(aRotation);

    vec2 v = vec2(x, y);
    v = v + aPositionCoord;

    gl_Position = vec4((translationMatrix * vec3(v, 1.0)).xy, 0.0, 1.0);

    vTextureCoord = aTextureCoord;
    vColor = aColor * uColor;
}
`;
class i6 extends H_ {
  /**
   * @param renderer - The renderer this sprite batch works for.
   */
  constructor(e) {
    super(e), this.shader = null, this.properties = null, this.tempMatrix = new Qn(), this.properties = [
      // verticesData
      {
        attributeName: "aVertexPosition",
        size: 2,
        uploadFunction: this.uploadVertices,
        offset: 0
      },
      // positionData
      {
        attributeName: "aPositionCoord",
        size: 2,
        uploadFunction: this.uploadPosition,
        offset: 0
      },
      // rotationData
      {
        attributeName: "aRotation",
        size: 1,
        uploadFunction: this.uploadRotation,
        offset: 0
      },
      // uvsData
      {
        attributeName: "aTextureCoord",
        size: 2,
        uploadFunction: this.uploadUvs,
        offset: 0
      },
      // tintData
      {
        attributeName: "aColor",
        size: 1,
        type: _t.UNSIGNED_BYTE,
        uploadFunction: this.uploadTint,
        offset: 0
      }
    ], this.shader = iu.from(uxe, ixe, {}), this.state = _u.for2d();
  }
  /**
   * Renders the particle container object.
   * @param container - The container to render using this ParticleRenderer.
   */
  render(e) {
    const n = e.children, r = e._maxSize, o = e._batchSize, s = this.renderer;
    let i = n.length;
    if (i === 0)
      return;
    i > r && !e.autoResize && (i = r);
    let u = e._buffers;
    u || (u = e._buffers = this.generateBuffers(e));
    const l = n[0]._texture.baseTexture, a = l.alphaMode > 0;
    this.state.blendMode = sB(e.blendMode, a), s.state.set(this.state);
    const c = s.gl, p = e.worldTransform.copyTo(this.tempMatrix);
    p.prepend(s.globalUniforms.uniforms.projectionMatrix), this.shader.uniforms.translationMatrix = p.toArray(!0), this.shader.uniforms.uColor = Gn.shared.setValue(e.tintRgb).premultiply(e.worldAlpha, a).toArray(this.shader.uniforms.uColor), this.shader.uniforms.uSampler = l, this.renderer.shader.bind(this.shader);
    let d = !1;
    for (let h = 0, m = 0; h < i; h += o, m += 1) {
      let g = i - h;
      g > o && (g = o), m >= u.length && u.push(this._generateOneMoreBuffer(e));
      const _ = u[m];
      _.uploadDynamic(n, h, g);
      const b = e._bufferUpdateIDs[m] || 0;
      d = d || _._updateID < b, d && (_._updateID = e._updateID, _.uploadStatic(n, h, g)), s.geometry.bind(_.geometry), c.drawElements(c.TRIANGLES, g * 6, c.UNSIGNED_SHORT, 0);
    }
  }
  /**
   * Creates one particle buffer for each child in the container we want to render and updates internal properties.
   * @param container - The container to render using this ParticleRenderer
   * @returns - The buffers
   */
  generateBuffers(e) {
    const n = [], r = e._maxSize, o = e._batchSize, s = e._properties;
    for (let i = 0; i < r; i += o)
      n.push(new sO(this.properties, s, o));
    return n;
  }
  /**
   * Creates one more particle buffer, because container has autoResize feature.
   * @param container - The container to render using this ParticleRenderer
   * @returns - The generated buffer
   */
  _generateOneMoreBuffer(e) {
    const n = e._batchSize, r = e._properties;
    return new sO(this.properties, r, n);
  }
  /**
   * Uploads the vertices.
   * @param children - the array of sprites to render
   * @param startIndex - the index to start from in the children array
   * @param amount - the amount of children that will have their vertices uploaded
   * @param array - The vertices to upload.
   * @param stride - Stride to use for iteration.
   * @param offset - Offset to start at.
   */
  uploadVertices(e, n, r, o, s, i) {
    let u = 0, l = 0, a = 0, c = 0;
    for (let p = 0; p < r; ++p) {
      const d = e[n + p], h = d._texture, m = d.scale.x, g = d.scale.y, _ = h.trim, b = h.orig;
      _ ? (l = _.x - d.anchor.x * b.width, u = l + _.width, c = _.y - d.anchor.y * b.height, a = c + _.height) : (u = b.width * (1 - d.anchor.x), l = b.width * -d.anchor.x, a = b.height * (1 - d.anchor.y), c = b.height * -d.anchor.y), o[i] = l * m, o[i + 1] = c * g, o[i + s] = u * m, o[i + s + 1] = c * g, o[i + s * 2] = u * m, o[i + s * 2 + 1] = a * g, o[i + s * 3] = l * m, o[i + s * 3 + 1] = a * g, i += s * 4;
    }
  }
  /**
   * Uploads the position.
   * @param children - the array of sprites to render
   * @param startIndex - the index to start from in the children array
   * @param amount - the amount of children that will have their positions uploaded
   * @param array - The vertices to upload.
   * @param stride - Stride to use for iteration.
   * @param offset - Offset to start at.
   */
  uploadPosition(e, n, r, o, s, i) {
    for (let u = 0; u < r; u++) {
      const l = e[n + u].position;
      o[i] = l.x, o[i + 1] = l.y, o[i + s] = l.x, o[i + s + 1] = l.y, o[i + s * 2] = l.x, o[i + s * 2 + 1] = l.y, o[i + s * 3] = l.x, o[i + s * 3 + 1] = l.y, i += s * 4;
    }
  }
  /**
   * Uploads the rotation.
   * @param children - the array of sprites to render
   * @param startIndex - the index to start from in the children array
   * @param amount - the amount of children that will have their rotation uploaded
   * @param array - The vertices to upload.
   * @param stride - Stride to use for iteration.
   * @param offset - Offset to start at.
   */
  uploadRotation(e, n, r, o, s, i) {
    for (let u = 0; u < r; u++) {
      const l = e[n + u].rotation;
      o[i] = l, o[i + s] = l, o[i + s * 2] = l, o[i + s * 3] = l, i += s * 4;
    }
  }
  /**
   * Uploads the UVs.
   * @param children - the array of sprites to render
   * @param startIndex - the index to start from in the children array
   * @param amount - the amount of children that will have their rotation uploaded
   * @param array - The vertices to upload.
   * @param stride - Stride to use for iteration.
   * @param offset - Offset to start at.
   */
  uploadUvs(e, n, r, o, s, i) {
    for (let u = 0; u < r; ++u) {
      const l = e[n + u]._texture._uvs;
      l ? (o[i] = l.x0, o[i + 1] = l.y0, o[i + s] = l.x1, o[i + s + 1] = l.y1, o[i + s * 2] = l.x2, o[i + s * 2 + 1] = l.y2, o[i + s * 3] = l.x3, o[i + s * 3 + 1] = l.y3, i += s * 4) : (o[i] = 0, o[i + 1] = 0, o[i + s] = 0, o[i + s + 1] = 0, o[i + s * 2] = 0, o[i + s * 2 + 1] = 0, o[i + s * 3] = 0, o[i + s * 3 + 1] = 0, i += s * 4);
    }
  }
  /**
   * Uploads the tint.
   * @param children - the array of sprites to render
   * @param startIndex - the index to start from in the children array
   * @param amount - the amount of children that will have their rotation uploaded
   * @param array - The vertices to upload.
   * @param stride - Stride to use for iteration.
   * @param offset - Offset to start at.
   */
  uploadTint(e, n, r, o, s, i) {
    for (let u = 0; u < r; ++u) {
      const l = e[n + u], a = Gn.shared.setValue(l._tintRGB).toPremultiplied(l.alpha, l.texture.baseTexture.alphaMode > 0);
      o[i] = a, o[i + s] = a, o[i + s * 2] = a, o[i + s * 3] = a, i += s * 4;
    }
  }
  /** Destroys the ParticleRenderer. */
  destroy() {
    super.destroy(), this.shader && (this.shader.destroy(), this.shader = null), this.tempMatrix = null;
  }
}
i6.extension = {
  name: "particle",
  type: rt.RendererPlugin
};
dt.add(i6);
var q_ = /* @__PURE__ */ ((t) => (t[t.LINEAR_VERTICAL = 0] = "LINEAR_VERTICAL", t[t.LINEAR_HORIZONTAL = 1] = "LINEAR_HORIZONTAL", t))(q_ || {});
const Pg = {
  // TextMetrics requires getImageData readback for measuring fonts.
  willReadFrequently: !0
}, Vi = class ft {
  /**
   * Checking that we can use modern canvas 2D API.
   *
   * Note: This is an unstable API, Chrome < 94 use `textLetterSpacing`, later versions use `letterSpacing`.
   * @see PIXI.TextMetrics.experimentalLetterSpacing
   * @see https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/letterSpacing
   * @see https://developer.chrome.com/origintrials/#/view_trial/3585991203293757441
   */
  static get experimentalLetterSpacingSupported() {
    let e = ft._experimentalLetterSpacingSupported;
    if (e !== void 0) {
      const n = at.ADAPTER.getCanvasRenderingContext2D().prototype;
      e = ft._experimentalLetterSpacingSupported = "letterSpacing" in n || "textLetterSpacing" in n;
    }
    return e;
  }
  /**
   * @param text - the text that was measured
   * @param style - the style that was measured
   * @param width - the measured width of the text
   * @param height - the measured height of the text
   * @param lines - an array of the lines of text broken by new lines and wrapping if specified in style
   * @param lineWidths - an array of the line widths for each line matched to `lines`
   * @param lineHeight - the measured line height for this style
   * @param maxLineWidth - the maximum line width for all measured lines
   * @param {PIXI.IFontMetrics} fontProperties - the font properties object from TextMetrics.measureFont
   */
  constructor(e, n, r, o, s, i, u, l, a) {
    this.text = e, this.style = n, this.width = r, this.height = o, this.lines = s, this.lineWidths = i, this.lineHeight = u, this.maxLineWidth = l, this.fontProperties = a;
  }
  /**
   * Measures the supplied string of text and returns a Rectangle.
   * @param text - The text to measure.
   * @param style - The text style to use for measuring
   * @param wordWrap - Override for if word-wrap should be applied to the text.
   * @param canvas - optional specification of the canvas to use for measuring.
   * @returns Measured width and height of the text.
   */
  static measureText(e, n, r, o = ft._canvas) {
    r = r ?? n.wordWrap;
    const s = n.toFontString(), i = ft.measureFont(s);
    i.fontSize === 0 && (i.fontSize = n.fontSize, i.ascent = n.fontSize);
    const u = o.getContext("2d", Pg);
    u.font = s;
    const l = (r ? ft.wordWrap(e, n, o) : e).split(/(?:\r\n|\r|\n)/), a = new Array(l.length);
    let c = 0;
    for (let m = 0; m < l.length; m++) {
      const g = ft._measureText(l[m], n.letterSpacing, u);
      a[m] = g, c = Math.max(c, g);
    }
    let p = c + n.strokeThickness;
    n.dropShadow && (p += n.dropShadowDistance);
    const d = n.lineHeight || i.fontSize + n.strokeThickness;
    let h = Math.max(d, i.fontSize + n.strokeThickness * 2) + n.leading + (l.length - 1) * (d + n.leading);
    return n.dropShadow && (h += n.dropShadowDistance), new ft(
      e,
      n,
      p,
      h,
      l,
      a,
      d + n.leading,
      c,
      i
    );
  }
  static _measureText(e, n, r) {
    let o = !1;
    ft.experimentalLetterSpacingSupported && (ft.experimentalLetterSpacing ? (r.letterSpacing = `${n}px`, r.textLetterSpacing = `${n}px`, o = !0) : (r.letterSpacing = "0px", r.textLetterSpacing = "0px"));
    let s = r.measureText(e).width;
    return s > 0 && (o ? s -= n : s += (ft.graphemeSegmenter(e).length - 1) * n), s;
  }
  /**
   * Applies newlines to a string to have it optimally fit into the horizontal
   * bounds set by the Text object's wordWrapWidth property.
   * @param text - String to apply word wrapping to
   * @param style - the style to use when wrapping
   * @param canvas - optional specification of the canvas to use for measuring.
   * @returns New string with new lines applied where required
   */
  static wordWrap(e, n, r = ft._canvas) {
    const o = r.getContext("2d", Pg);
    let s = 0, i = "", u = "";
    const l = /* @__PURE__ */ Object.create(null), { letterSpacing: a, whiteSpace: c } = n, p = ft.collapseSpaces(c), d = ft.collapseNewlines(c);
    let h = !p;
    const m = n.wordWrapWidth + a, g = ft.tokenize(e);
    for (let _ = 0; _ < g.length; _++) {
      let b = g[_];
      if (ft.isNewline(b)) {
        if (!d) {
          u += ft.addLine(i), h = !p, i = "", s = 0;
          continue;
        }
        b = " ";
      }
      if (p) {
        const S = ft.isBreakingSpace(b), E = ft.isBreakingSpace(i[i.length - 1]);
        if (S && E)
          continue;
      }
      const x = ft.getFromCache(b, a, l, o);
      if (x > m)
        if (i !== "" && (u += ft.addLine(i), i = "", s = 0), ft.canBreakWords(b, n.breakWords)) {
          const S = ft.wordWrapSplit(b);
          for (let E = 0; E < S.length; E++) {
            let A = S[E], C = A, M = 1;
            for (; S[E + M]; ) {
              const X = S[E + M];
              if (!ft.canBreakChars(C, X, b, E, n.breakWords))
                A += X;
              else
                break;
              C = X, M++;
            }
            E += M - 1;
            const L = ft.getFromCache(A, a, l, o);
            L + s > m && (u += ft.addLine(i), h = !1, i = "", s = 0), i += A, s += L;
          }
        } else {
          i.length > 0 && (u += ft.addLine(i), i = "", s = 0);
          const S = _ === g.length - 1;
          u += ft.addLine(b, !S), h = !1, i = "", s = 0;
        }
      else
        x + s > m && (h = !1, u += ft.addLine(i), i = "", s = 0), (i.length > 0 || !ft.isBreakingSpace(b) || h) && (i += b, s += x);
    }
    return u += ft.addLine(i, !1), u;
  }
  /**
   * Convienience function for logging each line added during the wordWrap method.
   * @param line    - The line of text to add
   * @param newLine - Add new line character to end
   * @returns A formatted line
   */
  static addLine(e, n = !0) {
    return e = ft.trimRight(e), e = n ? `${e}
` : e, e;
  }
  /**
   * Gets & sets the widths of calculated characters in a cache object
   * @param key            - The key
   * @param letterSpacing  - The letter spacing
   * @param cache          - The cache
   * @param context        - The canvas context
   * @returns The from cache.
   */
  static getFromCache(e, n, r, o) {
    let s = r[e];
    return typeof s != "number" && (s = ft._measureText(e, n, o) + n, r[e] = s), s;
  }
  /**
   * Determines whether we should collapse breaking spaces.
   * @param whiteSpace - The TextStyle property whiteSpace
   * @returns Should collapse
   */
  static collapseSpaces(e) {
    return e === "normal" || e === "pre-line";
  }
  /**
   * Determines whether we should collapse newLine chars.
   * @param whiteSpace - The white space
   * @returns should collapse
   */
  static collapseNewlines(e) {
    return e === "normal";
  }
  /**
   * Trims breaking whitespaces from string.
   * @param text - The text
   * @returns Trimmed string
   */
  static trimRight(e) {
    if (typeof e != "string")
      return "";
    for (let n = e.length - 1; n >= 0; n--) {
      const r = e[n];
      if (!ft.isBreakingSpace(r))
        break;
      e = e.slice(0, -1);
    }
    return e;
  }
  /**
   * Determines if char is a newline.
   * @param char - The character
   * @returns True if newline, False otherwise.
   */
  static isNewline(e) {
    return typeof e != "string" ? !1 : ft._newlines.includes(e.charCodeAt(0));
  }
  /**
   * Determines if char is a breaking whitespace.
   *
   * It allows one to determine whether char should be a breaking whitespace
   * For example certain characters in CJK langs or numbers.
   * It must return a boolean.
   * @param char - The character
   * @param [_nextChar] - The next character
   * @returns True if whitespace, False otherwise.
   */
  static isBreakingSpace(e, n) {
    return typeof e != "string" ? !1 : ft._breakingSpaces.includes(e.charCodeAt(0));
  }
  /**
   * Splits a string into words, breaking-spaces and newLine characters
   * @param text - The text
   * @returns A tokenized array
   */
  static tokenize(e) {
    const n = [];
    let r = "";
    if (typeof e != "string")
      return n;
    for (let o = 0; o < e.length; o++) {
      const s = e[o], i = e[o + 1];
      if (ft.isBreakingSpace(s, i) || ft.isNewline(s)) {
        r !== "" && (n.push(r), r = ""), n.push(s);
        continue;
      }
      r += s;
    }
    return r !== "" && n.push(r), n;
  }
  /**
   * Overridable helper method used internally by TextMetrics, exposed to allow customizing the class's behavior.
   *
   * It allows one to customise which words should break
   * Examples are if the token is CJK or numbers.
   * It must return a boolean.
   * @param _token - The token
   * @param breakWords - The style attr break words
   * @returns Whether to break word or not
   */
  static canBreakWords(e, n) {
    return n;
  }
  /**
   * Overridable helper method used internally by TextMetrics, exposed to allow customizing the class's behavior.
   *
   * It allows one to determine whether a pair of characters
   * should be broken by newlines
   * For example certain characters in CJK langs or numbers.
   * It must return a boolean.
   * @param _char - The character
   * @param _nextChar - The next character
   * @param _token - The token/word the characters are from
   * @param _index - The index in the token of the char
   * @param _breakWords - The style attr break words
   * @returns whether to break word or not
   */
  static canBreakChars(e, n, r, o, s) {
    return !0;
  }
  /**
   * Overridable helper method used internally by TextMetrics, exposed to allow customizing the class's behavior.
   *
   * It is called when a token (usually a word) has to be split into separate pieces
   * in order to determine the point to break a word.
   * It must return an array of characters.
   * @param token - The token to split
   * @returns The characters of the token
   * @see TextMetrics.graphemeSegmenter
   */
  static wordWrapSplit(e) {
    return ft.graphemeSegmenter(e);
  }
  /**
   * Calculates the ascent, descent and fontSize of a given font-style
   * @param font - String representing the style of the font
   * @returns Font properties object
   */
  static measureFont(e) {
    if (ft._fonts[e])
      return ft._fonts[e];
    const n = {
      ascent: 0,
      descent: 0,
      fontSize: 0
    }, r = ft._canvas, o = ft._context;
    o.font = e;
    const s = ft.METRICS_STRING + ft.BASELINE_SYMBOL, i = Math.ceil(o.measureText(s).width);
    let u = Math.ceil(o.measureText(ft.BASELINE_SYMBOL).width);
    const l = Math.ceil(ft.HEIGHT_MULTIPLIER * u);
    if (u = u * ft.BASELINE_MULTIPLIER | 0, i === 0 || l === 0)
      return ft._fonts[e] = n, n;
    r.width = i, r.height = l, o.fillStyle = "#f00", o.fillRect(0, 0, i, l), o.font = e, o.textBaseline = "alphabetic", o.fillStyle = "#000", o.fillText(s, 0, u);
    const a = o.getImageData(0, 0, i, l).data, c = a.length, p = i * 4;
    let d = 0, h = 0, m = !1;
    for (d = 0; d < u; ++d) {
      for (let g = 0; g < p; g += 4)
        if (a[h + g] !== 255) {
          m = !0;
          break;
        }
      if (!m)
        h += p;
      else
        break;
    }
    for (n.ascent = u - d, h = c - p, m = !1, d = l; d > u; --d) {
      for (let g = 0; g < p; g += 4)
        if (a[h + g] !== 255) {
          m = !0;
          break;
        }
      if (!m)
        h -= p;
      else
        break;
    }
    return n.descent = d - u, n.fontSize = n.ascent + n.descent, ft._fonts[e] = n, n;
  }
  /**
   * Clear font metrics in metrics cache.
   * @param {string} [font] - font name. If font name not set then clear cache for all fonts.
   */
  static clearMetrics(e = "") {
    e ? delete ft._fonts[e] : ft._fonts = {};
  }
  /**
   * Cached canvas element for measuring text
   * TODO: this should be private, but isn't because of backward compat, will fix later.
   * @ignore
   */
  static get _canvas() {
    if (!ft.__canvas) {
      let e;
      try {
        const n = new OffscreenCanvas(0, 0);
        if (n.getContext("2d", Pg)?.measureText)
          return ft.__canvas = n, n;
        e = at.ADAPTER.createCanvas();
      } catch {
        e = at.ADAPTER.createCanvas();
      }
      e.width = e.height = 10, ft.__canvas = e;
    }
    return ft.__canvas;
  }
  /**
   * TODO: this should be private, but isn't because of backward compat, will fix later.
   * @ignore
   */
  static get _context() {
    return ft.__context || (ft.__context = ft._canvas.getContext("2d", Pg)), ft.__context;
  }
};
Vi.METRICS_STRING = "|ÉqÅ", /** Baseline symbol for calculate font metrics. */
Vi.BASELINE_SYMBOL = "M", /** Baseline multiplier for calculate font metrics. */
Vi.BASELINE_MULTIPLIER = 1.4, /** Height multiplier for setting height of canvas to calculate font metrics. */
Vi.HEIGHT_MULTIPLIER = 2, /**
* A Unicode "character", or "grapheme cluster", can be composed of multiple Unicode code points,
* such as letters with diacritical marks (e.g. `'\u0065\u0301'`, letter e with acute)
* or emojis with modifiers (e.g. `'\uD83E\uDDD1\u200D\uD83D\uDCBB'`, technologist).
* The new `Intl.Segmenter` API in ES2022 can split the string into grapheme clusters correctly. If it is not available,
* PixiJS will fallback to use the iterator of String, which can only spilt the string into code points.
* If you want to get full functionality in environments that don't support `Intl.Segmenter` (such as Firefox),
* you can use other libraries such as [grapheme-splitter]{@link https://www.npmjs.com/package/grapheme-splitter}
* or [graphemer]{@link https://www.npmjs.com/package/graphemer} to create a polyfill. Since these libraries can be
* relatively large in size to handle various Unicode grapheme clusters properly, PixiJS won't use them directly.
*/
Vi.graphemeSegmenter = (() => {
  if (typeof Intl?.Segmenter == "function") {
    const t = new Intl.Segmenter();
    return (e) => [...t.segment(e)].map((n) => n.segment);
  }
  return (t) => [...t];
})(), /**
* New rendering behavior for letter-spacing which uses Chrome's new native API. This will
* lead to more accurate letter-spacing results because it does not try to manually draw
* each character. However, this Chrome API is experimental and may not serve all cases yet.
* @see PIXI.TextMetrics.experimentalLetterSpacingSupported
*/
Vi.experimentalLetterSpacing = !1, /** Cache of {@see PIXI.TextMetrics.FontMetrics} objects. */
Vi._fonts = {}, /** Cache of new line chars. */
Vi._newlines = [
  10,
  // line feed
  13
  // carriage return
], /** Cache of breaking spaces. */
Vi._breakingSpaces = [
  9,
  // character tabulation
  32,
  // space
  8192,
  // en quad
  8193,
  // em quad
  8194,
  // en space
  8195,
  // em space
  8196,
  // three-per-em space
  8197,
  // four-per-em space
  8198,
  // six-per-em space
  8200,
  // punctuation space
  8201,
  // thin space
  8202,
  // hair space
  8287,
  // medium mathematical space
  12288
  // ideographic space
];
let Gl = Vi;
const lxe = [
  "serif",
  "sans-serif",
  "monospace",
  "cursive",
  "fantasy",
  "system-ui"
], u6 = class Wf {
  /**
   * @param style - TextStyle properties to be set on the text. See {@link PIXI.TextStyle.defaultStyle}
   *       for the default values.
   */
  constructor(e) {
    this.styleID = 0, this.reset(), Pb(this, e, e);
  }
  /**
   * Creates a new TextStyle object with the same values as this one.
   * Note that the only the properties of the object are cloned.
   *
   * @return New cloned TextStyle object
   */
  clone() {
    const e = {};
    return Pb(e, this, Wf.defaultStyle), new Wf(e);
  }
  /** Resets all properties to the defaults specified in TextStyle.prototype._default */
  reset() {
    Pb(this, Wf.defaultStyle, Wf.defaultStyle);
  }
  /**
   * Alignment for multiline text, does not affect single line text.
   *
   * @member {'left'|'center'|'right'|'justify'}
   */
  get align() {
    return this._align;
  }
  set align(e) {
    this._align !== e && (this._align = e, this.styleID++);
  }
  /** Indicates if lines can be wrapped within words, it needs wordWrap to be set to true. */
  get breakWords() {
    return this._breakWords;
  }
  set breakWords(e) {
    this._breakWords !== e && (this._breakWords = e, this.styleID++);
  }
  /** Set a drop shadow for the text. */
  get dropShadow() {
    return this._dropShadow;
  }
  set dropShadow(e) {
    this._dropShadow !== e && (this._dropShadow = e, this.styleID++);
  }
  /** Set alpha for the drop shadow. */
  get dropShadowAlpha() {
    return this._dropShadowAlpha;
  }
  set dropShadowAlpha(e) {
    this._dropShadowAlpha !== e && (this._dropShadowAlpha = e, this.styleID++);
  }
  /** Set a angle of the drop shadow. */
  get dropShadowAngle() {
    return this._dropShadowAngle;
  }
  set dropShadowAngle(e) {
    this._dropShadowAngle !== e && (this._dropShadowAngle = e, this.styleID++);
  }
  /** Set a shadow blur radius. */
  get dropShadowBlur() {
    return this._dropShadowBlur;
  }
  set dropShadowBlur(e) {
    this._dropShadowBlur !== e && (this._dropShadowBlur = e, this.styleID++);
  }
  /** A fill style to be used on the dropshadow e.g., 'red', '#00FF00'. */
  get dropShadowColor() {
    return this._dropShadowColor;
  }
  set dropShadowColor(e) {
    const n = Mb(e);
    this._dropShadowColor !== n && (this._dropShadowColor = n, this.styleID++);
  }
  /** Set a distance of the drop shadow. */
  get dropShadowDistance() {
    return this._dropShadowDistance;
  }
  set dropShadowDistance(e) {
    this._dropShadowDistance !== e && (this._dropShadowDistance = e, this.styleID++);
  }
  /**
   * A canvas fillstyle that will be used on the text e.g., 'red', '#00FF00'.
   *
   * Can be an array to create a gradient e.g., `['#000000','#FFFFFF']`
   * {@link https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/fillStyle|MDN}
   *
   * @member {string|string[]|number|number[]|CanvasGradient|CanvasPattern}
   */
  get fill() {
    return this._fill;
  }
  set fill(e) {
    const n = Mb(e);
    this._fill !== n && (this._fill = n, this.styleID++);
  }
  /**
   * If fill is an array of colours to create a gradient, this can change the type/direction of the gradient.
   *
   * @type {PIXI.TEXT_GRADIENT}
   */
  get fillGradientType() {
    return this._fillGradientType;
  }
  set fillGradientType(e) {
    this._fillGradientType !== e && (this._fillGradientType = e, this.styleID++);
  }
  /**
   * If fill is an array of colours to create a gradient, this array can set the stop points
   * (numbers between 0 and 1) for the color, overriding the default behaviour of evenly spacing them.
   */
  get fillGradientStops() {
    return this._fillGradientStops;
  }
  set fillGradientStops(e) {
    cxe(this._fillGradientStops, e) || (this._fillGradientStops = e, this.styleID++);
  }
  /**
   * The font family, can be a single font name, or a list of names where the first
   * is the preferred font.
   */
  get fontFamily() {
    return this._fontFamily;
  }
  set fontFamily(e) {
    this.fontFamily !== e && (this._fontFamily = e, this.styleID++);
  }
  /**
   * The font size
   * (as a number it converts to px, but as a string, equivalents are '26px','20pt','160%' or '1.6em')
   */
  get fontSize() {
    return this._fontSize;
  }
  set fontSize(e) {
    this._fontSize !== e && (this._fontSize = e, this.styleID++);
  }
  /**
   * The font style.
   *
   * @member {'normal'|'italic'|'oblique'}
   */
  get fontStyle() {
    return this._fontStyle;
  }
  set fontStyle(e) {
    this._fontStyle !== e && (this._fontStyle = e, this.styleID++);
  }
  /**
   * The font variant.
   *
   * @member {'normal'|'small-caps'}
   */
  get fontVariant() {
    return this._fontVariant;
  }
  set fontVariant(e) {
    this._fontVariant !== e && (this._fontVariant = e, this.styleID++);
  }
  /**
   * The font weight.
   *
   * @member {'normal'|'bold'|'bolder'|'lighter'|'100'|'200'|'300'|'400'|'500'|'600'|'700'|'800'|'900'}
   */
  get fontWeight() {
    return this._fontWeight;
  }
  set fontWeight(e) {
    this._fontWeight !== e && (this._fontWeight = e, this.styleID++);
  }
  /** The amount of spacing between letters, default is 0. */
  get letterSpacing() {
    return this._letterSpacing;
  }
  set letterSpacing(e) {
    this._letterSpacing !== e && (this._letterSpacing = e, this.styleID++);
  }
  /** The line height, a number that represents the vertical space that a letter uses. */
  get lineHeight() {
    return this._lineHeight;
  }
  set lineHeight(e) {
    this._lineHeight !== e && (this._lineHeight = e, this.styleID++);
  }
  /** The space between lines. */
  get leading() {
    return this._leading;
  }
  set leading(e) {
    this._leading !== e && (this._leading = e, this.styleID++);
  }
  /**
   * The lineJoin property sets the type of corner created, it can resolve spiked text issues.
   * Default is 'miter' (creates a sharp corner).
   *
   * @member {'miter'|'round'|'bevel'}
   */
  get lineJoin() {
    return this._lineJoin;
  }
  set lineJoin(e) {
    this._lineJoin !== e && (this._lineJoin = e, this.styleID++);
  }
  /**
   * The miter limit to use when using the 'miter' lineJoin mode.
   *
   * This can reduce or increase the spikiness of rendered text.
   */
  get miterLimit() {
    return this._miterLimit;
  }
  set miterLimit(e) {
    this._miterLimit !== e && (this._miterLimit = e, this.styleID++);
  }
  /**
   * Occasionally some fonts are cropped. Adding some padding will prevent this from happening
   * by adding padding to all sides of the text.
   */
  get padding() {
    return this._padding;
  }
  set padding(e) {
    this._padding !== e && (this._padding = e, this.styleID++);
  }
  /**
   * A canvas fillstyle that will be used on the text stroke, e.g., 'blue', '#FCFF00'
   */
  get stroke() {
    return this._stroke;
  }
  set stroke(e) {
    const n = Mb(e);
    this._stroke !== n && (this._stroke = n, this.styleID++);
  }
  /**
   * A number that represents the thickness of the stroke.
   *
   * @default 0
   */
  get strokeThickness() {
    return this._strokeThickness;
  }
  set strokeThickness(e) {
    this._strokeThickness !== e && (this._strokeThickness = e, this.styleID++);
  }
  /**
   * The baseline of the text that is rendered.
   *
   * @member {'alphabetic'|'top'|'hanging'|'middle'|'ideographic'|'bottom'}
   */
  get textBaseline() {
    return this._textBaseline;
  }
  set textBaseline(e) {
    this._textBaseline !== e && (this._textBaseline = e, this.styleID++);
  }
  /** Trim transparent borders. */
  get trim() {
    return this._trim;
  }
  set trim(e) {
    this._trim !== e && (this._trim = e, this.styleID++);
  }
  /**
   * How newlines and spaces should be handled.
   * Default is 'pre' (preserve, preserve).
   *
   *  value       | New lines     |   Spaces
   *  ---         | ---           |   ---
   * 'normal'     | Collapse      |   Collapse
   * 'pre'        | Preserve      |   Preserve
   * 'pre-line'   | Preserve      |   Collapse
   *
   * @member {'normal'|'pre'|'pre-line'}
   */
  get whiteSpace() {
    return this._whiteSpace;
  }
  set whiteSpace(e) {
    this._whiteSpace !== e && (this._whiteSpace = e, this.styleID++);
  }
  /** Indicates if word wrap should be used. */
  get wordWrap() {
    return this._wordWrap;
  }
  set wordWrap(e) {
    this._wordWrap !== e && (this._wordWrap = e, this.styleID++);
  }
  /** The width at which text will wrap, it needs wordWrap to be set to true. */
  get wordWrapWidth() {
    return this._wordWrapWidth;
  }
  set wordWrapWidth(e) {
    this._wordWrapWidth !== e && (this._wordWrapWidth = e, this.styleID++);
  }
  /**
   * Generates a font style string to use for `TextMetrics.measureFont()`.
   *
   * @return Font style string, for passing to `TextMetrics.measureFont()`
   */
  toFontString() {
    const e = typeof this.fontSize == "number" ? `${this.fontSize}px` : this.fontSize;
    let n = this.fontFamily;
    Array.isArray(this.fontFamily) || (n = this.fontFamily.split(","));
    for (let r = n.length - 1; r >= 0; r--) {
      let o = n[r].trim();
      !/([\"\'])[^\'\"]+\1/.test(o) && !lxe.includes(o) && (o = `"${o}"`), n[r] = o;
    }
    return `${this.fontStyle} ${this.fontVariant} ${this.fontWeight} ${e} ${n.join(",")}`;
  }
};
u6.defaultStyle = {
  /**
   * See {@link PIXI.TextStyle.align}
   * @type {'left'|'center'|'right'|'justify'}
   */
  align: "left",
  /** See {@link PIXI.TextStyle.breakWords} */
  breakWords: !1,
  /** See {@link PIXI.TextStyle.dropShadow} */
  dropShadow: !1,
  /** See {@link PIXI.TextStyle.dropShadowAlpha} */
  dropShadowAlpha: 1,
  /**
   * See {@link PIXI.TextStyle.dropShadowAngle}
   * @type {number}
   * @default Math.PI / 6
   */
  dropShadowAngle: Math.PI / 6,
  /** See {@link PIXI.TextStyle.dropShadowBlur} */
  dropShadowBlur: 0,
  /**
   * See {@link PIXI.TextStyle.dropShadowColor}
   * @type {string|number}
   */
  dropShadowColor: "black",
  /** See {@link PIXI.TextStyle.dropShadowDistance} */
  dropShadowDistance: 5,
  /**
   * See {@link PIXI.TextStyle.fill}
   * @type {string|string[]|number|number[]|CanvasGradient|CanvasPattern}
   */
  fill: "black",
  /**
   * See {@link PIXI.TextStyle.fillGradientType}
   * @type {PIXI.TEXT_GRADIENT}
   * @default PIXI.TEXT_GRADIENT.LINEAR_VERTICAL
   */
  fillGradientType: q_.LINEAR_VERTICAL,
  /**
   * See {@link PIXI.TextStyle.fillGradientStops}
   * @type {number[]}
   * @default []
   */
  fillGradientStops: [],
  /**
   * See {@link PIXI.TextStyle.fontFamily}
   * @type {string|string[]}
   */
  fontFamily: "Arial",
  /**
   * See {@link PIXI.TextStyle.fontSize}
   * @type {number|string} 
   */
  fontSize: 26,
  /**
   * See {@link PIXI.TextStyle.fontStyle}
   * @type {'normal'|'italic'|'oblique'}
   */
  fontStyle: "normal",
  /**
   * See {@link PIXI.TextStyle.fontVariant}
   * @type {'normal'|'small-caps'}
   */
  fontVariant: "normal",
  /**
   * See {@link PIXI.TextStyle.fontWeight}
   * @type {'normal'|'bold'|'bolder'|'lighter'|'100'|'200'|'300'|'400'|'500'|'600'|'700'|'800'|'900'}
   */
  fontWeight: "normal",
  /** See {@link PIXI.TextStyle.leading} */
  leading: 0,
  /** See {@link PIXI.TextStyle.letterSpacing} */
  letterSpacing: 0,
  /** See {@link PIXI.TextStyle.lineHeight} */
  lineHeight: 0,
  /**
   * See {@link PIXI.TextStyle.lineJoin}
   * @type {'miter'|'round'|'bevel'}
   */
  lineJoin: "miter",
  /** See {@link PIXI.TextStyle.miterLimit} */
  miterLimit: 10,
  /** See {@link PIXI.TextStyle.padding} */
  padding: 0,
  /**
   * See {@link PIXI.TextStyle.stroke}
   * @type {string|number}
   */
  stroke: "black",
  /** See {@link PIXI.TextStyle.strokeThickness} */
  strokeThickness: 0,
  /**
   * See {@link PIXI.TextStyle.textBaseline} 
   * @type {'alphabetic'|'top'|'hanging'|'middle'|'ideographic'|'bottom'}
   */
  textBaseline: "alphabetic",
  /** See {@link PIXI.TextStyle.trim} */
  trim: !1,
  /**
   * See {@link PIXI.TextStyle.whiteSpace}
   * @type {'normal'|'pre'|'pre-line'}
   */
  whiteSpace: "pre",
  /** See {@link PIXI.TextStyle.wordWrap} */
  wordWrap: !1,
  /** See {@link PIXI.TextStyle.wordWrapWidth} */
  wordWrapWidth: 100
};
let _c = u6;
function Mb(t) {
  const e = Gn.shared, n = (r) => {
    const o = e.setValue(r);
    return o.alpha === 1 ? o.toHex() : o.toRgbaString();
  };
  return Array.isArray(t) ? t.map(n) : n(t);
}
function cxe(t, e) {
  if (!Array.isArray(t) || !Array.isArray(e) || t.length !== e.length)
    return !1;
  for (let n = 0; n < t.length; ++n)
    if (t[n] !== e[n])
      return !1;
  return !0;
}
function Pb(t, e, n) {
  for (const r in n)
    Array.isArray(e[r]) ? t[r] = e[r].slice() : t[r] = e[r];
}
const pxe = {
  texture: !0,
  children: !1,
  baseTexture: !0
}, l6 = class ET extends Vr {
  /**
   * @param text - The string that you would like the text to display
   * @param style - The style parameters
   * @param canvas - The canvas element for drawing text
   */
  constructor(e, n, r) {
    let o = !1;
    r || (r = at.ADAPTER.createCanvas(), o = !0), r.width = 3, r.height = 3;
    const s = pt.from(r);
    s.orig = new Pt(), s.trim = new Pt(), super(s), this._ownCanvas = o, this.canvas = r, this.context = r.getContext("2d", {
      // required for trimming to work without warnings
      willReadFrequently: !0
    }), this._resolution = ET.defaultResolution ?? at.RESOLUTION, this._autoResolution = ET.defaultAutoResolution, this._text = null, this._style = null, this._styleListener = null, this._font = "", this.text = e, this.style = n, this.localStyleID = -1;
  }
  /**
   * @see PIXI.TextMetrics.experimentalLetterSpacing
   * @deprecated since 7.1.0
   */
  static get experimentalLetterSpacing() {
    return Gl.experimentalLetterSpacing;
  }
  static set experimentalLetterSpacing(e) {
    un(
      "7.1.0",
      "Text.experimentalLetterSpacing is deprecated, use TextMetrics.experimentalLetterSpacing"
    ), Gl.experimentalLetterSpacing = e;
  }
  /**
   * Renders text to its canvas, and updates its texture.
   *
   * By default this is used internally to ensure the texture is correct before rendering,
   * but it can be used called externally, for example from this class to 'pre-generate' the texture from a piece of text,
   * and then shared across multiple Sprites.
   * @param respectDirty - Whether to abort updating the text if the Text isn't dirty and the function is called.
   */
  updateText(e) {
    const n = this._style;
    if (this.localStyleID !== n.styleID && (this.dirty = !0, this.localStyleID = n.styleID), !this.dirty && e)
      return;
    this._font = this._style.toFontString();
    const r = this.context, o = Gl.measureText(this._text || " ", this._style, this._style.wordWrap, this.canvas), s = o.width, i = o.height, u = o.lines, l = o.lineHeight, a = o.lineWidths, c = o.maxLineWidth, p = o.fontProperties;
    this.canvas.width = Math.ceil(Math.ceil(Math.max(1, s) + n.padding * 2) * this._resolution), this.canvas.height = Math.ceil(Math.ceil(Math.max(1, i) + n.padding * 2) * this._resolution), r.scale(this._resolution, this._resolution), r.clearRect(0, 0, this.canvas.width, this.canvas.height), r.font = this._font, r.lineWidth = n.strokeThickness, r.textBaseline = n.textBaseline, r.lineJoin = n.lineJoin, r.miterLimit = n.miterLimit;
    let d, h;
    const m = n.dropShadow ? 2 : 1;
    for (let g = 0; g < m; ++g) {
      const _ = n.dropShadow && g === 0, b = _ ? Math.ceil(Math.max(1, i) + n.padding * 2) : 0, x = b * this._resolution;
      if (_) {
        r.fillStyle = "black", r.strokeStyle = "black";
        const E = n.dropShadowColor, A = n.dropShadowBlur * this._resolution, C = n.dropShadowDistance * this._resolution;
        r.shadowColor = Gn.shared.setValue(E).setAlpha(n.dropShadowAlpha).toRgbaString(), r.shadowBlur = A, r.shadowOffsetX = Math.cos(n.dropShadowAngle) * C, r.shadowOffsetY = Math.sin(n.dropShadowAngle) * C + x;
      } else
        r.fillStyle = this._generateFillStyle(n, u, o), r.strokeStyle = n.stroke, r.shadowColor = "black", r.shadowBlur = 0, r.shadowOffsetX = 0, r.shadowOffsetY = 0;
      let S = (l - p.fontSize) / 2;
      l - p.fontSize < 0 && (S = 0);
      for (let E = 0; E < u.length; E++)
        d = n.strokeThickness / 2, h = n.strokeThickness / 2 + E * l + p.ascent + S, n.align === "right" ? d += c - a[E] : n.align === "center" && (d += (c - a[E]) / 2), n.stroke && n.strokeThickness && this.drawLetterSpacing(
          u[E],
          d + n.padding,
          h + n.padding - b,
          !0
        ), n.fill && this.drawLetterSpacing(
          u[E],
          d + n.padding,
          h + n.padding - b
        );
    }
    this.updateTexture();
  }
  /**
   * Render the text with letter-spacing.
   * @param text - The text to draw
   * @param x - Horizontal position to draw the text
   * @param y - Vertical position to draw the text
   * @param isStroke - Is this drawing for the outside stroke of the
   *  text? If not, it's for the inside fill
   */
  drawLetterSpacing(e, n, r, o = !1) {
    const s = this._style.letterSpacing;
    let i = !1;
    if (Gl.experimentalLetterSpacingSupported && (Gl.experimentalLetterSpacing ? (this.context.letterSpacing = `${s}px`, this.context.textLetterSpacing = `${s}px`, i = !0) : (this.context.letterSpacing = "0px", this.context.textLetterSpacing = "0px")), s === 0 || i) {
      o ? this.context.strokeText(e, n, r) : this.context.fillText(e, n, r);
      return;
    }
    let u = n;
    const l = Gl.graphemeSegmenter(e);
    let a = this.context.measureText(e).width, c = 0;
    for (let p = 0; p < l.length; ++p) {
      const d = l[p];
      o ? this.context.strokeText(d, u, r) : this.context.fillText(d, u, r);
      let h = "";
      for (let m = p + 1; m < l.length; ++m)
        h += l[m];
      c = this.context.measureText(h).width, u += a - c + s, a = c;
    }
  }
  /** Updates texture size based on canvas size. */
  updateTexture() {
    const e = this.canvas;
    if (this._style.trim) {
      const i = C1e(e);
      i.data && (e.width = i.width, e.height = i.height, this.context.putImageData(i.data, 0, 0));
    }
    const n = this._texture, r = this._style, o = r.trim ? 0 : r.padding, s = n.baseTexture;
    n.trim.width = n._frame.width = e.width / this._resolution, n.trim.height = n._frame.height = e.height / this._resolution, n.trim.x = -o, n.trim.y = -o, n.orig.width = n._frame.width - o * 2, n.orig.height = n._frame.height - o * 2, this._onTextureUpdate(), s.setRealSize(e.width, e.height, this._resolution), n.updateUvs(), this.dirty = !1;
  }
  /**
   * Renders the object using the WebGL renderer
   * @param renderer - The renderer
   */
  _render(e) {
    this._autoResolution && this._resolution !== e.resolution && (this._resolution = e.resolution, this.dirty = !0), this.updateText(!0), super._render(e);
  }
  /** Updates the transform on all children of this container for rendering. */
  updateTransform() {
    this.updateText(!0), super.updateTransform();
  }
  getBounds(e, n) {
    return this.updateText(!0), this._textureID === -1 && (e = !1), super.getBounds(e, n);
  }
  /**
   * Gets the local bounds of the text object.
   * @param rect - The output rectangle.
   * @returns The bounds.
   */
  getLocalBounds(e) {
    return this.updateText(!0), super.getLocalBounds.call(this, e);
  }
  /** Calculates the bounds of the Text as a rectangle. The bounds calculation takes the worldTransform into account. */
  _calculateBounds() {
    this.calculateVertices(), this._bounds.addQuad(this.vertexData);
  }
  /**
   * Generates the fill style. Can automatically generate a gradient based on the fill style being an array
   * @param style - The style.
   * @param lines - The lines of text.
   * @param metrics
   * @returns The fill style
   */
  _generateFillStyle(e, n, r) {
    const o = e.fill;
    if (Array.isArray(o)) {
      if (o.length === 1)
        return o[0];
    } else
      return o;
    let s;
    const i = e.dropShadow ? e.dropShadowDistance : 0, u = e.padding || 0, l = this.canvas.width / this._resolution - i - u * 2, a = this.canvas.height / this._resolution - i - u * 2, c = o.slice(), p = e.fillGradientStops.slice();
    if (!p.length) {
      const d = c.length + 1;
      for (let h = 1; h < d; ++h)
        p.push(h / d);
    }
    if (c.unshift(o[0]), p.unshift(0), c.push(o[o.length - 1]), p.push(1), e.fillGradientType === q_.LINEAR_VERTICAL) {
      s = this.context.createLinearGradient(l / 2, u, l / 2, a + u);
      const d = r.fontProperties.fontSize + e.strokeThickness;
      for (let h = 0; h < n.length; h++) {
        const m = r.lineHeight * (h - 1) + d, g = r.lineHeight * h;
        let _ = g;
        h > 0 && m > g && (_ = (g + m) / 2);
        const b = g + d, x = r.lineHeight * (h + 1);
        let S = b;
        h + 1 < n.length && x < b && (S = (b + x) / 2);
        const E = (S - _) / a;
        for (let A = 0; A < c.length; A++) {
          let C = 0;
          typeof p[A] == "number" ? C = p[A] : C = A / c.length;
          let M = Math.min(1, Math.max(
            0,
            _ / a + C * E
          ));
          M = Number(M.toFixed(5)), s.addColorStop(M, c[A]);
        }
      }
    } else {
      s = this.context.createLinearGradient(u, a / 2, l + u, a / 2);
      const d = c.length + 1;
      let h = 1;
      for (let m = 0; m < c.length; m++) {
        let g;
        typeof p[m] == "number" ? g = p[m] : g = h / d, s.addColorStop(g, c[m]), h++;
      }
    }
    return s;
  }
  /**
   * Destroys this text object.
   *
   * Note* Unlike a Sprite, a Text object will automatically destroy its baseTexture and texture as
   * the majority of the time the texture will not be shared with any other Sprites.
   * @param options - Options parameter. A boolean will act as if all options
   *  have been set to that value
   * @param {boolean} [options.children=false] - if set to true, all the children will have their
   *  destroy method called as well. 'options' will be passed on to those calls.
   * @param {boolean} [options.texture=true] - Should it destroy the current texture of the sprite as well
   * @param {boolean} [options.baseTexture=true] - Should it destroy the base texture of the sprite as well
   */
  destroy(e) {
    typeof e == "boolean" && (e = { children: e }), e = Object.assign({}, pxe, e), super.destroy(e), this._ownCanvas && (this.canvas.height = this.canvas.width = 0), this.context = null, this.canvas = null, this._style = null;
  }
  /** The width of the Text, setting this will actually modify the scale to achieve the value set. */
  get width() {
    return this.updateText(!0), Math.abs(this.scale.x) * this._texture.orig.width;
  }
  set width(e) {
    this.updateText(!0);
    const n = ec(this.scale.x) || 1;
    this.scale.x = n * e / this._texture.orig.width, this._width = e;
  }
  /** The height of the Text, setting this will actually modify the scale to achieve the value set. */
  get height() {
    return this.updateText(!0), Math.abs(this.scale.y) * this._texture.orig.height;
  }
  set height(e) {
    this.updateText(!0);
    const n = ec(this.scale.y) || 1;
    this.scale.y = n * e / this._texture.orig.height, this._height = e;
  }
  /**
   * Set the style of the text.
   *
   * Set up an event listener to listen for changes on the style object and mark the text as dirty.
   *
   * If setting the `style` can also be partial {@link PIXI.ITextStyle}.
   */
  get style() {
    return this._style;
  }
  set style(e) {
    e = e || {}, e instanceof _c ? this._style = e : this._style = new _c(e), this.localStyleID = -1, this.dirty = !0;
  }
  /** Set the copy for the text object. To split a line you can use '\n'. */
  get text() {
    return this._text;
  }
  set text(e) {
    e = String(e ?? ""), this._text !== e && (this._text = e, this.dirty = !0);
  }
  /**
   * The resolution / device pixel ratio of the canvas.
   *
   * This is set to automatically match the renderer resolution by default, but can be overridden by setting manually.
   * @default 1
   */
  get resolution() {
    return this._resolution;
  }
  set resolution(e) {
    this._autoResolution = !1, this._resolution !== e && (this._resolution = e, this.dirty = !0);
  }
};
l6.defaultAutoResolution = !0;
let c6 = l6;
class dxe {
  /**
   * @param maxItemsPerFrame - The maximum number of items that can be prepared each frame.
   */
  constructor(e) {
    this.maxItemsPerFrame = e, this.itemsLeft = 0;
  }
  /** Resets any counting properties to start fresh on a new frame. */
  beginFrame() {
    this.itemsLeft = this.maxItemsPerFrame;
  }
  /**
   * Checks to see if another item can be uploaded. This should only be called once per item.
   * @returns If the item is allowed to be uploaded.
   */
  allowedToUpload() {
    return this.itemsLeft-- > 0;
  }
}
function hxe(t, e) {
  let n = !1;
  if (t?._textures?.length) {
    for (let r = 0; r < t._textures.length; r++)
      if (t._textures[r] instanceof pt) {
        const o = t._textures[r].baseTexture;
        e.includes(o) || (e.push(o), n = !0);
      }
  }
  return n;
}
function fxe(t, e) {
  if (t.baseTexture instanceof qt) {
    const n = t.baseTexture;
    return e.includes(n) || e.push(n), !0;
  }
  return !1;
}
function mxe(t, e) {
  if (t._texture && t._texture instanceof pt) {
    const n = t._texture.baseTexture;
    return e.includes(n) || e.push(n), !0;
  }
  return !1;
}
function yxe(t, e) {
  return e instanceof c6 ? (e.updateText(!0), !0) : !1;
}
function gxe(t, e) {
  if (e instanceof _c) {
    const n = e.toFontString();
    return Gl.measureFont(n), !0;
  }
  return !1;
}
function vxe(t, e) {
  if (t instanceof c6) {
    e.includes(t.style) || e.push(t.style), e.includes(t) || e.push(t);
    const n = t._texture.baseTexture;
    return e.includes(n) || e.push(n), !0;
  }
  return !1;
}
function _xe(t, e) {
  return t instanceof _c ? (e.includes(t) || e.push(t), !0) : !1;
}
const p6 = class d6 {
  /**
   * @param {PIXI.IRenderer} renderer - A reference to the current renderer
   */
  constructor(e) {
    this.limiter = new dxe(d6.uploadsPerFrame), this.renderer = e, this.uploadHookHelper = null, this.queue = [], this.addHooks = [], this.uploadHooks = [], this.completes = [], this.ticking = !1, this.delayedTick = () => {
      this.queue && this.prepareItems();
    }, this.registerFindHook(vxe), this.registerFindHook(_xe), this.registerFindHook(hxe), this.registerFindHook(fxe), this.registerFindHook(mxe), this.registerUploadHook(yxe), this.registerUploadHook(gxe);
  }
  /**
   * Upload all the textures and graphics to the GPU.
   * @method PIXI.BasePrepare#upload
   * @param {PIXI.DisplayObject|PIXI.Container|PIXI.BaseTexture|PIXI.Texture|PIXI.Graphics|PIXI.Text} [item] -
   *        Container or display object to search for items to upload or the items to upload themselves,
   *        or optionally ommitted, if items have been added using {@link PIXI.BasePrepare#add `prepare.add`}.
   */
  upload(e) {
    return new Promise((n) => {
      e && this.add(e), this.queue.length ? (this.completes.push(n), this.ticking || (this.ticking = !0, es.system.addOnce(this.tick, this, Xp.UTILITY))) : n();
    });
  }
  /**
   * Handle tick update
   * @private
   */
  tick() {
    setTimeout(this.delayedTick, 0);
  }
  /**
   * Actually prepare items. This is handled outside of the tick because it will take a while
   * and we do NOT want to block the current animation frame from rendering.
   * @private
   */
  prepareItems() {
    for (this.limiter.beginFrame(); this.queue.length && this.limiter.allowedToUpload(); ) {
      const e = this.queue[0];
      let n = !1;
      if (e && !e._destroyed) {
        for (let r = 0, o = this.uploadHooks.length; r < o; r++)
          if (this.uploadHooks[r](this.uploadHookHelper, e)) {
            this.queue.shift(), n = !0;
            break;
          }
      }
      n || this.queue.shift();
    }
    if (this.queue.length)
      es.system.addOnce(this.tick, this, Xp.UTILITY);
    else {
      this.ticking = !1;
      const e = this.completes.slice(0);
      this.completes.length = 0;
      for (let n = 0, r = e.length; n < r; n++)
        e[n]();
    }
  }
  /**
   * Adds hooks for finding items.
   * @param {Function} addHook - Function call that takes two parameters: `item:*, queue:Array`
   *          function must return `true` if it was able to add item to the queue.
   * @returns Instance of plugin for chaining.
   */
  registerFindHook(e) {
    return e && this.addHooks.push(e), this;
  }
  /**
   * Adds hooks for uploading items.
   * @param {Function} uploadHook - Function call that takes two parameters: `prepare:CanvasPrepare, item:*` and
   *          function must return `true` if it was able to handle upload of item.
   * @returns Instance of plugin for chaining.
   */
  registerUploadHook(e) {
    return e && this.uploadHooks.push(e), this;
  }
  /**
   * Manually add an item to the uploading queue.
   * @param {PIXI.DisplayObject|PIXI.Container|PIXI.BaseTexture|PIXI.Texture|PIXI.Graphics|PIXI.Text|*} item - Object to
   *        add to the queue
   * @returns Instance of plugin for chaining.
   */
  add(e) {
    for (let n = 0, r = this.addHooks.length; n < r && !this.addHooks[n](e, this.queue); n++)
      ;
    if (e instanceof fn)
      for (let n = e.children.length - 1; n >= 0; n--)
        this.add(e.children[n]);
    return this;
  }
  /** Destroys the plugin, don't use after this. */
  destroy() {
    this.ticking && es.system.remove(this.tick, this), this.ticking = !1, this.addHooks = null, this.uploadHooks = null, this.renderer = null, this.completes = null, this.queue = null, this.limiter = null, this.uploadHookHelper = null;
  }
};
p6.uploadsPerFrame = 4;
let MT = p6;
Object.defineProperties(at, {
  /**
   * Default number of uploads per frame using prepare plugin.
   * @static
   * @memberof PIXI.settings
   * @name UPLOADS_PER_FRAME
   * @deprecated since 7.1.0
   * @see PIXI.BasePrepare.uploadsPerFrame
   * @type {number}
   */
  UPLOADS_PER_FRAME: {
    get() {
      return MT.uploadsPerFrame;
    },
    set(t) {
      un("7.1.0", "settings.UPLOADS_PER_FRAME is deprecated, use prepare.BasePrepare.uploadsPerFrame"), MT.uploadsPerFrame = t;
    }
  }
});
function h6(t, e) {
  return e instanceof qt ? (e._glTextures[t.CONTEXT_UID] || t.texture.bind(e), !0) : !1;
}
function wxe(t, e) {
  if (!(e instanceof vc))
    return !1;
  const { geometry: n } = e;
  e.finishPoly(), n.updateBatches();
  const { batches: r } = n;
  for (let o = 0; o < r.length; o++) {
    const { texture: s } = r[o].style;
    s && h6(t, s.baseTexture);
  }
  return n.batchable || t.geometry.bind(n, e._resolveDirectShader(t)), !0;
}
function bxe(t, e) {
  return t instanceof vc ? (e.push(t), !0) : !1;
}
class f6 extends MT {
  /**
   * @param {PIXI.Renderer} renderer - A reference to the current renderer
   */
  constructor(e) {
    super(e), this.uploadHookHelper = this.renderer, this.registerFindHook(bxe), this.registerUploadHook(h6), this.registerUploadHook(wxe);
  }
}
f6.extension = {
  name: "prepare",
  type: rt.RendererSystem
};
dt.add(f6);
var kxe = `#version 300 es
#define SHADER_NAME Tiling-Sprite-100

precision lowp float;

in vec2 vTextureCoord;

out vec4 fragmentColor;

uniform sampler2D uSampler;
uniform vec4 uColor;
uniform mat3 uMapCoord;
uniform vec4 uClampFrame;
uniform vec2 uClampOffset;

void main(void)
{
    vec2 coord = vTextureCoord + ceil(uClampOffset - vTextureCoord);
    coord = (uMapCoord * vec3(coord, 1.0)).xy;
    vec2 unclamped = coord;
    coord = clamp(coord, uClampFrame.xy, uClampFrame.zw);

    vec4 texSample = texture(uSampler, coord, unclamped == coord ? 0.0f : -32.0f);// lod-bias very negative to force lod 0

    fragmentColor = texSample * uColor;
}
`, Txe = `#version 300 es
#define SHADER_NAME Tiling-Sprite-300

precision lowp float;

in vec2 aVertexPosition;
in vec2 aTextureCoord;

uniform mat3 projectionMatrix;
uniform mat3 translationMatrix;
uniform mat3 uTransform;

out vec2 vTextureCoord;

void main(void)
{
    gl_Position = vec4((projectionMatrix * translationMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);

    vTextureCoord = (uTransform * vec3(aTextureCoord, 1.0)).xy;
}
`, xxe = `#version 100
#ifdef GL_EXT_shader_texture_lod
    #extension GL_EXT_shader_texture_lod : enable
#endif
#define SHADER_NAME Tiling-Sprite-100

precision lowp float;

varying vec2 vTextureCoord;

uniform sampler2D uSampler;
uniform vec4 uColor;
uniform mat3 uMapCoord;
uniform vec4 uClampFrame;
uniform vec2 uClampOffset;

void main(void)
{
    vec2 coord = vTextureCoord + ceil(uClampOffset - vTextureCoord);
    coord = (uMapCoord * vec3(coord, 1.0)).xy;
    vec2 unclamped = coord;
    coord = clamp(coord, uClampFrame.xy, uClampFrame.zw);

    #ifdef GL_EXT_shader_texture_lod
        vec4 texSample = unclamped == coord
            ? texture2D(uSampler, coord) 
            : texture2DLodEXT(uSampler, coord, 0);
    #else
        vec4 texSample = texture2D(uSampler, coord);
    #endif

    gl_FragColor = texSample * uColor;
}
`, aO = `#version 100
#define SHADER_NAME Tiling-Sprite-100

precision lowp float;

attribute vec2 aVertexPosition;
attribute vec2 aTextureCoord;

uniform mat3 projectionMatrix;
uniform mat3 translationMatrix;
uniform mat3 uTransform;

varying vec2 vTextureCoord;

void main(void)
{
    gl_Position = vec4((projectionMatrix * translationMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);

    vTextureCoord = (uTransform * vec3(aTextureCoord, 1.0)).xy;
}
`, Sxe = `#version 100
#define SHADER_NAME Tiling-Sprite-Simple-100

precision lowp float;

varying vec2 vTextureCoord;

uniform sampler2D uSampler;
uniform vec4 uColor;

void main(void)
{
    vec4 texSample = texture2D(uSampler, vTextureCoord);
    gl_FragColor = texSample * uColor;
}
`;
const Cg = new Qn();
class m6 extends H_ {
  /**
   * constructor for renderer
   * @param {PIXI.Renderer} renderer - The renderer this tiling awesomeness works for.
   */
  constructor(e) {
    super(e), e.runners.contextChange.add(this), this.quad = new vB(), this.state = _u.for2d();
  }
  /** Creates shaders when context is initialized. */
  contextChange() {
    const e = this.renderer, n = { globals: e.globalUniforms };
    this.simpleShader = iu.from(aO, Sxe, n), this.shader = e.context.webGLVersion > 1 ? iu.from(Txe, kxe, n) : iu.from(aO, xxe, n);
  }
  /**
   * @param {PIXI.TilingSprite} ts - tilingSprite to be rendered
   */
  render(e) {
    const n = this.renderer, r = this.quad;
    let o = r.vertices;
    o[0] = o[6] = e._width * -e.anchor.x, o[1] = o[3] = e._height * -e.anchor.y, o[2] = o[4] = e._width * (1 - e.anchor.x), o[5] = o[7] = e._height * (1 - e.anchor.y);
    const s = e.uvRespectAnchor ? e.anchor.x : 0, i = e.uvRespectAnchor ? e.anchor.y : 0;
    o = r.uvs, o[0] = o[6] = -s, o[1] = o[3] = -i, o[2] = o[4] = 1 - s, o[5] = o[7] = 1 - i, r.invalidate();
    const u = e._texture, l = u.baseTexture, a = l.alphaMode > 0, c = e.tileTransform.localTransform, p = e.uvMatrix;
    let d = l.isPowerOfTwo && u.frame.width === l.width && u.frame.height === l.height;
    d && (l._glTextures[n.CONTEXT_UID] ? d = l.wrapMode !== su.CLAMP : l.wrapMode === su.CLAMP && (l.wrapMode = su.REPEAT));
    const h = d ? this.simpleShader : this.shader, m = u.width, g = u.height, _ = e._width, b = e._height;
    Cg.set(
      c.a * m / _,
      c.b * m / b,
      c.c * g / _,
      c.d * g / b,
      c.tx / _,
      c.ty / b
    ), Cg.invert(), d ? Cg.prepend(p.mapCoord) : (h.uniforms.uMapCoord = p.mapCoord.toArray(!0), h.uniforms.uClampFrame = p.uClampFrame, h.uniforms.uClampOffset = p.uClampOffset), h.uniforms.uTransform = Cg.toArray(!0), h.uniforms.uColor = Gn.shared.setValue(e.tint).premultiply(e.worldAlpha, a).toArray(h.uniforms.uColor), h.uniforms.translationMatrix = e.transform.worldTransform.toArray(!0), h.uniforms.uSampler = u, n.shader.bind(h), n.geometry.bind(r), this.state.blendMode = sB(e.blendMode, a), n.state.set(this.state), n.geometry.draw(this.renderer.gl.TRIANGLES, 6, 0);
  }
}
m6.extension = {
  name: "tilingSprite",
  type: rt.RendererPlugin
};
dt.add(m6);
const y6 = class Vf {
  /**
   * @param texture - Reference to the source BaseTexture object.
   * @param {object} data - Spritesheet image data.
   * @param resolutionFilename - The filename to consider when determining
   *        the resolution of the spritesheet. If not provided, the imageUrl will
   *        be used on the BaseTexture.
   */
  constructor(e, n, r = null) {
    this.linkedSheets = [], this._texture = e instanceof pt ? e : null, this.baseTexture = e instanceof qt ? e : this._texture.baseTexture, this.textures = {}, this.animations = {}, this.data = n;
    const o = this.baseTexture.resource;
    this.resolution = this._updateResolution(r || (o ? o.url : null)), this._frames = this.data.frames, this._frameKeys = Object.keys(this._frames), this._batchIndex = 0, this._callback = null;
  }
  /**
   * Generate the resolution from the filename or fallback
   * to the meta.scale field of the JSON data.
   * @param resolutionFilename - The filename to use for resolving
   *        the default resolution.
   * @returns Resolution to use for spritesheet.
   */
  _updateResolution(e = null) {
    const { scale: n } = this.data.meta;
    let r = al(e, null);
    return r === null && (r = parseFloat(n ?? "1")), r !== 1 && this.baseTexture.setResolution(r), r;
  }
  /**
   * Parser spritesheet from loaded data. This is done asynchronously
   * to prevent creating too many Texture within a single process.
   * @method PIXI.Spritesheet#parse
   */
  parse() {
    return new Promise((e) => {
      this._callback = e, this._batchIndex = 0, this._frameKeys.length <= Vf.BATCH_SIZE ? (this._processFrames(0), this._processAnimations(), this._parseComplete()) : this._nextBatch();
    });
  }
  /**
   * Process a batch of frames
   * @param initialFrameIndex - The index of frame to start.
   */
  _processFrames(e) {
    let n = e;
    const r = Vf.BATCH_SIZE;
    for (; n - e < r && n < this._frameKeys.length; ) {
      const o = this._frameKeys[n], s = this._frames[o], i = s.frame;
      if (i) {
        let u = null, l = null;
        const a = s.trimmed !== !1 && s.sourceSize ? s.sourceSize : s.frame, c = new Pt(
          0,
          0,
          Math.floor(a.w) / this.resolution,
          Math.floor(a.h) / this.resolution
        );
        s.rotated ? u = new Pt(
          Math.floor(i.x) / this.resolution,
          Math.floor(i.y) / this.resolution,
          Math.floor(i.h) / this.resolution,
          Math.floor(i.w) / this.resolution
        ) : u = new Pt(
          Math.floor(i.x) / this.resolution,
          Math.floor(i.y) / this.resolution,
          Math.floor(i.w) / this.resolution,
          Math.floor(i.h) / this.resolution
        ), s.trimmed !== !1 && s.spriteSourceSize && (l = new Pt(
          Math.floor(s.spriteSourceSize.x) / this.resolution,
          Math.floor(s.spriteSourceSize.y) / this.resolution,
          Math.floor(i.w) / this.resolution,
          Math.floor(i.h) / this.resolution
        )), this.textures[o] = new pt(
          this.baseTexture,
          u,
          c,
          l,
          s.rotated ? 2 : 0,
          s.anchor,
          s.borders
        ), pt.addToCache(this.textures[o], o.toString());
      }
      n++;
    }
  }
  /** Parse animations config. */
  _processAnimations() {
    const e = this.data.animations || {};
    for (const n in e) {
      this.animations[n] = [];
      for (let r = 0; r < e[n].length; r++) {
        const o = e[n][r];
        this.animations[n].push(this.textures[o]);
      }
    }
  }
  /** The parse has completed. */
  _parseComplete() {
    const e = this._callback;
    this._callback = null, this._batchIndex = 0, e.call(this, this.textures);
  }
  /** Begin the next batch of textures. */
  _nextBatch() {
    this._processFrames(this._batchIndex * Vf.BATCH_SIZE), this._batchIndex++, setTimeout(() => {
      this._batchIndex * Vf.BATCH_SIZE < this._frameKeys.length ? this._nextBatch() : (this._processAnimations(), this._parseComplete());
    }, 0);
  }
  /**
   * Destroy Spritesheet and don't use after this.
   * @param {boolean} [destroyBase=false] - Whether to destroy the base texture as well
   */
  destroy(e = !1) {
    for (const n in this.textures)
      this.textures[n].destroy();
    this._frames = null, this._frameKeys = null, this.data = null, this.textures = null, e && (this._texture?.destroy(), this.baseTexture.destroy()), this._texture = null, this.baseTexture = null, this.linkedSheets = [];
  }
};
y6.BATCH_SIZE = 1e3;
let iO = y6;
const Rxe = ["jpg", "png", "jpeg", "avif", "webp"];
function g6(t, e, n) {
  const r = {};
  if (t.forEach((o) => {
    r[o] = e;
  }), Object.keys(e.textures).forEach((o) => {
    r[o] = e.textures[o];
  }), !n) {
    const o = lo.dirname(t[0]);
    e.linkedSheets.forEach((s, i) => {
      const u = g6([`${o}/${e.data.meta.related_multi_packs[i]}`], s, !0);
      Object.assign(r, u);
    });
  }
  return r;
}
const Axe = {
  extension: rt.Asset,
  /** Handle the caching of the related Spritesheet Textures */
  cache: {
    test: (t) => t instanceof iO,
    getCacheableAssets: (t, e) => g6(t, e, !1)
  },
  /** Resolve the the resolution of the asset. */
  resolver: {
    test: (t) => {
      const e = t.split("?")[0].split("."), n = e.pop(), r = e.pop();
      return n === "json" && Rxe.includes(r);
    },
    parse: (t) => {
      const e = t.split(".");
      return {
        resolution: parseFloat(at.RETINA_PREFIX.exec(t)?.[1] ?? "1"),
        format: e[e.length - 2],
        src: t
      };
    }
  },
  /**
   * Loader plugin that parses sprite sheets!
   * once the JSON has been loaded this checks to see if the JSON is spritesheet data.
   * If it is, we load the spritesheets image and parse the data into PIXI.Spritesheet
   * All textures in the sprite sheet are then added to the cache
   * @ignore
   */
  loader: {
    name: "spritesheetLoader",
    extension: {
      type: rt.LoadParser,
      priority: Si.Normal
    },
    async testParse(t, e) {
      return lo.extname(e.src).toLowerCase() === ".json" && !!t.frames;
    },
    async parse(t, e, n) {
      let r = lo.dirname(e.src);
      r && r.lastIndexOf("/") !== r.length - 1 && (r += "/");
      let o = r + t.meta.image;
      o = xT(o, e.src);
      const s = (await n.load([o]))[o], i = new iO(
        s.baseTexture,
        t,
        e.src
      );
      await i.parse();
      const u = t?.meta?.related_multi_packs;
      if (Array.isArray(u)) {
        const l = [];
        for (const c of u) {
          if (typeof c != "string")
            continue;
          let p = r + c;
          e.data?.ignoreMultiPack || (p = xT(p, e.src), l.push(n.load({
            src: p,
            data: {
              ignoreMultiPack: !0
            }
          })));
        }
        const a = await Promise.all(l);
        i.linkedSheets = a, a.forEach((c) => {
          c.linkedSheets = [i].concat(i.linkedSheets.filter((p) => p !== c));
        });
      }
      return i;
    },
    unload(t) {
      t.destroy(!0);
    }
  }
};
dt.add(Axe);
class yv {
  constructor() {
    this.info = [], this.common = [], this.page = [], this.char = [], this.kerning = [], this.distanceField = [];
  }
}
class i0 {
  /**
   * Check if resource refers to txt font data.
   * @param data
   * @returns - True if resource could be treated as font data, false otherwise.
   */
  static test(e) {
    return typeof e == "string" && e.startsWith("info face=");
  }
  /**
   * Convert text font data to a javascript object.
   * @param txt - Raw string data to be converted
   * @returns - Parsed font data
   */
  static parse(e) {
    const n = e.match(/^[a-z]+\s+.+$/gm), r = {
      info: [],
      common: [],
      page: [],
      char: [],
      chars: [],
      kerning: [],
      kernings: [],
      distanceField: []
    };
    for (const s in n) {
      const i = n[s].match(/^[a-z]+/gm)[0], u = n[s].match(/[a-zA-Z]+=([^\s"']+|"([^"]*)")/gm), l = {};
      for (const a in u) {
        const c = u[a].split("="), p = c[0], d = c[1].replace(/"/gm, ""), h = parseFloat(d), m = isNaN(h) ? d : h;
        l[p] = m;
      }
      r[i].push(l);
    }
    const o = new yv();
    return r.info.forEach((s) => o.info.push({
      face: s.face,
      size: parseInt(s.size, 10)
    })), r.common.forEach((s) => o.common.push({
      lineHeight: parseInt(s.lineHeight, 10)
    })), r.page.forEach((s) => o.page.push({
      id: parseInt(s.id, 10),
      file: s.file
    })), r.char.forEach((s) => o.char.push({
      id: parseInt(s.id, 10),
      page: parseInt(s.page, 10),
      x: parseInt(s.x, 10),
      y: parseInt(s.y, 10),
      width: parseInt(s.width, 10),
      height: parseInt(s.height, 10),
      xoffset: parseInt(s.xoffset, 10),
      yoffset: parseInt(s.yoffset, 10),
      xadvance: parseInt(s.xadvance, 10)
    })), r.kerning.forEach((s) => o.kerning.push({
      first: parseInt(s.first, 10),
      second: parseInt(s.second, 10),
      amount: parseInt(s.amount, 10)
    })), r.distanceField.forEach((s) => o.distanceField.push({
      distanceRange: parseInt(s.distanceRange, 10),
      fieldType: s.fieldType
    })), o;
  }
}
class PT {
  /**
   * Check if resource refers to xml font data.
   * @param data
   * @returns - True if resource could be treated as font data, false otherwise.
   */
  static test(e) {
    const n = e;
    return typeof e != "string" && "getElementsByTagName" in e && n.getElementsByTagName("page").length && n.getElementsByTagName("info")[0].getAttribute("face") !== null;
  }
  /**
   * Convert the XML into BitmapFontData that we can use.
   * @param xml
   * @returns - Data to use for BitmapFont
   */
  static parse(e) {
    const n = new yv(), r = e.getElementsByTagName("info"), o = e.getElementsByTagName("common"), s = e.getElementsByTagName("page"), i = e.getElementsByTagName("char"), u = e.getElementsByTagName("kerning"), l = e.getElementsByTagName("distanceField");
    for (let a = 0; a < r.length; a++)
      n.info.push({
        face: r[a].getAttribute("face"),
        size: parseInt(r[a].getAttribute("size"), 10)
      });
    for (let a = 0; a < o.length; a++)
      n.common.push({
        lineHeight: parseInt(o[a].getAttribute("lineHeight"), 10)
      });
    for (let a = 0; a < s.length; a++)
      n.page.push({
        id: parseInt(s[a].getAttribute("id"), 10) || 0,
        file: s[a].getAttribute("file")
      });
    for (let a = 0; a < i.length; a++) {
      const c = i[a];
      n.char.push({
        id: parseInt(c.getAttribute("id"), 10),
        page: parseInt(c.getAttribute("page"), 10) || 0,
        x: parseInt(c.getAttribute("x"), 10),
        y: parseInt(c.getAttribute("y"), 10),
        width: parseInt(c.getAttribute("width"), 10),
        height: parseInt(c.getAttribute("height"), 10),
        xoffset: parseInt(c.getAttribute("xoffset"), 10),
        yoffset: parseInt(c.getAttribute("yoffset"), 10),
        xadvance: parseInt(c.getAttribute("xadvance"), 10)
      });
    }
    for (let a = 0; a < u.length; a++)
      n.kerning.push({
        first: parseInt(u[a].getAttribute("first"), 10),
        second: parseInt(u[a].getAttribute("second"), 10),
        amount: parseInt(u[a].getAttribute("amount"), 10)
      });
    for (let a = 0; a < l.length; a++)
      n.distanceField.push({
        fieldType: l[a].getAttribute("fieldType"),
        distanceRange: parseInt(l[a].getAttribute("distanceRange"), 10)
      });
    return n;
  }
}
class CT {
  /**
   * Check if resource refers to text xml font data.
   * @param data
   * @returns - True if resource could be treated as font data, false otherwise.
   */
  static test(e) {
    return typeof e == "string" && e.includes("<font>") ? PT.test(at.ADAPTER.parseXML(e)) : !1;
  }
  /**
   * Convert the text XML into BitmapFontData that we can use.
   * @param xmlTxt
   * @returns - Data to use for BitmapFont
   */
  static parse(e) {
    return PT.parse(at.ADAPTER.parseXML(e));
  }
}
const Cb = [
  i0,
  PT,
  CT
];
function Dxe(t) {
  for (let e = 0; e < Cb.length; e++)
    if (Cb[e].test(t))
      return Cb[e];
  return null;
}
function Exe(t, e, n, r, o, s) {
  const i = n.fill;
  if (Array.isArray(i)) {
    if (i.length === 1)
      return i[0];
  } else
    return i;
  let u;
  const l = n.dropShadow ? n.dropShadowDistance : 0, a = n.padding || 0, c = t.width / r - l - a * 2, p = t.height / r - l - a * 2, d = i.slice(), h = n.fillGradientStops.slice();
  if (!h.length) {
    const m = d.length + 1;
    for (let g = 1; g < m; ++g)
      h.push(g / m);
  }
  if (d.unshift(i[0]), h.unshift(0), d.push(i[i.length - 1]), h.push(1), n.fillGradientType === q_.LINEAR_VERTICAL) {
    u = e.createLinearGradient(c / 2, a, c / 2, p + a);
    let m = 0;
    const g = (s.fontProperties.fontSize + n.strokeThickness) / p;
    for (let _ = 0; _ < o.length; _++) {
      const b = s.lineHeight * _;
      for (let x = 0; x < d.length; x++) {
        let S = 0;
        typeof h[x] == "number" ? S = h[x] : S = x / d.length;
        const E = b / p + S * g;
        let A = Math.max(m, E);
        A = Math.min(A, 1), u.addColorStop(A, d[x]), m = A;
      }
    }
  } else {
    u = e.createLinearGradient(a, p / 2, c + a, p / 2);
    const m = d.length + 1;
    let g = 1;
    for (let _ = 0; _ < d.length; _++) {
      let b;
      typeof h[_] == "number" ? b = h[_] : b = g / m, u.addColorStop(b, d[_]), g++;
    }
  }
  return u;
}
function Mxe(t, e, n, r, o, s, i) {
  const u = n.text, l = n.fontProperties;
  e.translate(r, o), e.scale(s, s);
  const a = i.strokeThickness / 2, c = -(i.strokeThickness / 2);
  if (e.font = i.toFontString(), e.lineWidth = i.strokeThickness, e.textBaseline = i.textBaseline, e.lineJoin = i.lineJoin, e.miterLimit = i.miterLimit, e.fillStyle = Exe(t, e, i, s, [u], n), e.strokeStyle = i.stroke, i.dropShadow) {
    const p = i.dropShadowColor, d = i.dropShadowBlur * s, h = i.dropShadowDistance * s;
    e.shadowColor = Gn.shared.setValue(p).setAlpha(i.dropShadowAlpha).toRgbaString(), e.shadowBlur = d, e.shadowOffsetX = Math.cos(i.dropShadowAngle) * h, e.shadowOffsetY = Math.sin(i.dropShadowAngle) * h;
  } else
    e.shadowColor = "black", e.shadowBlur = 0, e.shadowOffsetX = 0, e.shadowOffsetY = 0;
  i.stroke && i.strokeThickness && e.strokeText(u, a, c + n.lineHeight - l.descent), i.fill && e.fillText(u, a, c + n.lineHeight - l.descent), e.setTransform(1, 0, 0, 1, 0, 0), e.fillStyle = "rgba(0, 0, 0, 0)";
}
function u0(t) {
  return t.codePointAt ? t.codePointAt(0) : t.charCodeAt(0);
}
function v6(t) {
  return Array.from ? Array.from(t) : t.split("");
}
function Pxe(t) {
  typeof t == "string" && (t = [t]);
  const e = [];
  for (let n = 0, r = t.length; n < r; n++) {
    const o = t[n];
    if (Array.isArray(o)) {
      if (o.length !== 2)
        throw new Error(`[BitmapFont]: Invalid character range length, expecting 2 got ${o.length}.`);
      const s = o[0].charCodeAt(0), i = o[1].charCodeAt(0);
      if (i < s)
        throw new Error("[BitmapFont]: Invalid character range.");
      for (let u = s, l = i; u <= l; u++)
        e.push(String.fromCharCode(u));
    } else
      e.push(...v6(o));
  }
  if (e.length === 0)
    throw new Error("[BitmapFont]: Empty set when resolving characters.");
  return e;
}
const ql = class Hi {
  /**
   * @param data
   * @param textures
   * @param ownsTextures - Setting to `true` will destroy page textures
   *        when the font is uninstalled.
   */
  constructor(e, n, r) {
    const [o] = e.info, [s] = e.common, [i] = e.page, [u] = e.distanceField, l = al(i.file), a = {};
    this._ownsTextures = r, this.font = o.face, this.size = o.size, this.lineHeight = s.lineHeight / l, this.chars = {}, this.pageTextures = a;
    for (let c = 0; c < e.page.length; c++) {
      const { id: p, file: d } = e.page[c];
      a[p] = n instanceof Array ? n[c] : n[d], u?.fieldType && u.fieldType !== "none" && (a[p].baseTexture.alphaMode = gs.NO_PREMULTIPLIED_ALPHA, a[p].baseTexture.mipmap = yu.OFF);
    }
    for (let c = 0; c < e.char.length; c++) {
      const { id: p, page: d } = e.char[c];
      let { x: h, y: m, width: g, height: _, xoffset: b, yoffset: x, xadvance: S } = e.char[c];
      h /= l, m /= l, g /= l, _ /= l, b /= l, x /= l, S /= l;
      const E = new Pt(
        h + a[d].frame.x / l,
        m + a[d].frame.y / l,
        g,
        _
      );
      this.chars[p] = {
        xOffset: b,
        yOffset: x,
        xAdvance: S,
        kerning: {},
        texture: new pt(
          a[d].baseTexture,
          E
        ),
        page: d
      };
    }
    for (let c = 0; c < e.kerning.length; c++) {
      let { first: p, second: d, amount: h } = e.kerning[c];
      p /= l, d /= l, h /= l, this.chars[d] && (this.chars[d].kerning[p] = h);
    }
    this.distanceFieldRange = u?.distanceRange, this.distanceFieldType = u?.fieldType?.toLowerCase() ?? "none";
  }
  /** Remove references to created glyph textures. */
  destroy() {
    for (const e in this.chars)
      this.chars[e].texture.destroy(), this.chars[e].texture = null;
    for (const e in this.pageTextures)
      this._ownsTextures && this.pageTextures[e].destroy(!0), this.pageTextures[e] = null;
    this.chars = null, this.pageTextures = null;
  }
  /**
   * Register a new bitmap font.
   * @param data - The
   *        characters map that could be provided as xml or raw string.
   * @param textures - List of textures for each page.
   * @param ownsTextures - Set to `true` to destroy page textures
   *        when the font is uninstalled. By default fonts created with
   *        `BitmapFont.from` or from the `BitmapFontLoader` are `true`.
   * @returns {PIXI.BitmapFont} Result font object with font, size, lineHeight
   *         and char fields.
   */
  static install(e, n, r) {
    let o;
    if (e instanceof yv)
      o = e;
    else {
      const i = Dxe(e);
      if (!i)
        throw new Error("Unrecognized data format for font.");
      o = i.parse(e);
    }
    n instanceof pt && (n = [n]);
    const s = new Hi(o, n, r);
    return Hi.available[s.font] = s, s;
  }
  /**
   * Remove bitmap font by name.
   * @param name - Name of the font to uninstall.
   */
  static uninstall(e) {
    const n = Hi.available[e];
    if (!n)
      throw new Error(`No font found named '${e}'`);
    n.destroy(), delete Hi.available[e];
  }
  /**
   * Generates a bitmap-font for the given style and character set. This does not support
   * kernings yet. With `style` properties, only the following non-layout properties are used:
   *
   * - {@link PIXI.TextStyle#dropShadow|dropShadow}
   * - {@link PIXI.TextStyle#dropShadowDistance|dropShadowDistance}
   * - {@link PIXI.TextStyle#dropShadowColor|dropShadowColor}
   * - {@link PIXI.TextStyle#dropShadowBlur|dropShadowBlur}
   * - {@link PIXI.TextStyle#dropShadowAngle|dropShadowAngle}
   * - {@link PIXI.TextStyle#fill|fill}
   * - {@link PIXI.TextStyle#fillGradientStops|fillGradientStops}
   * - {@link PIXI.TextStyle#fillGradientType|fillGradientType}
   * - {@link PIXI.TextStyle#fontFamily|fontFamily}
   * - {@link PIXI.TextStyle#fontSize|fontSize}
   * - {@link PIXI.TextStyle#fontVariant|fontVariant}
   * - {@link PIXI.TextStyle#fontWeight|fontWeight}
   * - {@link PIXI.TextStyle#lineJoin|lineJoin}
   * - {@link PIXI.TextStyle#miterLimit|miterLimit}
   * - {@link PIXI.TextStyle#stroke|stroke}
   * - {@link PIXI.TextStyle#strokeThickness|strokeThickness}
   * - {@link PIXI.TextStyle#textBaseline|textBaseline}
   * @param name - The name of the custom font to use with BitmapText.
   * @param textStyle - Style options to render with BitmapFont.
   * @param options - Setup options for font or name of the font.
   * @returns Font generated by style options.
   * @example
   * import { BitmapFont, BitmapText } from 'pixi.js';
   *
   * BitmapFont.from('TitleFont', {
   *     fontFamily: 'Arial',
   *     fontSize: 12,
   *     strokeThickness: 2,
   *     fill: 'purple',
   * });
   *
   * const title = new BitmapText('This is the title', { fontName: 'TitleFont' });
   */
  static from(e, n, r) {
    if (!e)
      throw new Error("[BitmapFont] Property `name` is required.");
    const {
      chars: o,
      padding: s,
      resolution: i,
      textureWidth: u,
      textureHeight: l,
      ...a
    } = Object.assign({}, Hi.defaultOptions, r), c = Pxe(o), p = n instanceof _c ? n : new _c(n), d = u, h = new yv();
    h.info[0] = {
      face: p.fontFamily,
      size: p.fontSize
    }, h.common[0] = {
      lineHeight: p.fontSize
    };
    let m = 0, g = 0, _, b, x, S = 0;
    const E = [];
    for (let C = 0; C < c.length; C++) {
      _ || (_ = at.ADAPTER.createCanvas(), _.width = u, _.height = l, b = _.getContext("2d"), x = new qt(_, { resolution: i, ...a }), E.push(new pt(x)), h.page.push({
        id: E.length - 1,
        file: ""
      }));
      const M = c[C], L = Gl.measureText(M, p, !1, _), X = L.width, te = Math.ceil(L.height), B = Math.ceil((p.fontStyle === "italic" ? 2 : 1) * X);
      if (g >= l - te * i) {
        if (g === 0)
          throw new Error(`[BitmapFont] textureHeight ${l}px is too small (fontFamily: '${p.fontFamily}', fontSize: ${p.fontSize}px, char: '${M}')`);
        --C, _ = null, b = null, x = null, g = 0, m = 0, S = 0;
        continue;
      }
      if (S = Math.max(te + L.fontProperties.descent, S), B * i + m >= d) {
        if (m === 0)
          throw new Error(`[BitmapFont] textureWidth ${u}px is too small (fontFamily: '${p.fontFamily}', fontSize: ${p.fontSize}px, char: '${M}')`);
        --C, g += S * i, g = Math.ceil(g), m = 0, S = 0;
        continue;
      }
      Mxe(_, b, L, m, g, i, p);
      const W = u0(L.text);
      h.char.push({
        id: W,
        page: E.length - 1,
        x: m / i,
        y: g / i,
        width: B,
        height: te,
        xoffset: 0,
        yoffset: 0,
        xadvance: X - (p.dropShadow ? p.dropShadowDistance : 0) - (p.stroke ? p.strokeThickness : 0)
      }), m += (B + 2 * s) * i, m = Math.ceil(m);
    }
    if (!r?.skipKerning)
      for (let C = 0, M = c.length; C < M; C++) {
        const L = c[C];
        for (let X = 0; X < M; X++) {
          const te = c[X], B = b.measureText(L).width, W = b.measureText(te).width, G = b.measureText(L + te).width - (B + W);
          G && h.kerning.push({
            first: u0(L),
            second: u0(te),
            amount: G
          });
        }
      }
    const A = new Hi(h, E, !0);
    return Hi.available[e] !== void 0 && Hi.uninstall(e), Hi.available[e] = A, A;
  }
};
ql.ALPHA = [["a", "z"], ["A", "Z"], " "], /**
* This character set includes all decimal digits (from 0 to 9).
* @type {string[][]}
* @example
* BitmapFont.from('ExampleFont', style, { chars: BitmapFont.NUMERIC })
*/
ql.NUMERIC = [["0", "9"]], /**
* This character set is the union of `BitmapFont.ALPHA` and `BitmapFont.NUMERIC`.
* @type {string[][]}
*/
ql.ALPHANUMERIC = [["a", "z"], ["A", "Z"], ["0", "9"], " "], /**
* This character set consists of all the ASCII table.
* @member {string[][]}
* @see http://www.asciitable.com/
*/
ql.ASCII = [[" ", "~"]], /**
* Collection of default options when using `BitmapFont.from`.
* @property {number} [resolution=1] -
* @property {number} [textureWidth=512] -
* @property {number} [textureHeight=512] -
* @property {number} [padding=4] -
* @property {string|string[]|string[][]} chars = PIXI.BitmapFont.ALPHANUMERIC
*/
ql.defaultOptions = {
  resolution: 1,
  textureWidth: 512,
  textureHeight: 512,
  padding: 4,
  chars: ql.ALPHANUMERIC
}, /** Collection of available/installed fonts. */
ql.available = {};
let Ta = ql;
var Cxe = `// Pixi texture info\r
varying vec2 vTextureCoord;\r
uniform sampler2D uSampler;\r
\r
// Tint\r
uniform vec4 uColor;\r
\r
// on 2D applications fwidth is screenScale / glyphAtlasScale * distanceFieldRange\r
uniform float uFWidth;\r
\r
void main(void) {\r
\r
  // To stack MSDF and SDF we need a non-pre-multiplied-alpha texture.\r
  vec4 texColor = texture2D(uSampler, vTextureCoord);\r
\r
  // MSDF\r
  float median = texColor.r + texColor.g + texColor.b -\r
                  min(texColor.r, min(texColor.g, texColor.b)) -\r
                  max(texColor.r, max(texColor.g, texColor.b));\r
  // SDF\r
  median = min(median, texColor.a);\r
\r
  float screenPxDistance = uFWidth * (median - 0.5);\r
  float alpha = clamp(screenPxDistance + 0.5, 0.0, 1.0);\r
  if (median < 0.01) {\r
    alpha = 0.0;\r
  } else if (median > 0.99) {\r
    alpha = 1.0;\r
  }\r
\r
  // Gamma correction for coverage-like alpha\r
  float luma = dot(uColor.rgb, vec3(0.299, 0.587, 0.114));\r
  float gamma = mix(1.0, 1.0 / 2.2, luma);\r
  float coverage = pow(uColor.a * alpha, gamma);  \r
\r
  // NPM Textures, NPM outputs\r
  gl_FragColor = vec4(uColor.rgb, coverage);\r
}\r
`, Oxe = `// Mesh material default fragment\r
attribute vec2 aVertexPosition;\r
attribute vec2 aTextureCoord;\r
\r
uniform mat3 projectionMatrix;\r
uniform mat3 translationMatrix;\r
uniform mat3 uTextureMatrix;\r
\r
varying vec2 vTextureCoord;\r
\r
void main(void)\r
{\r
    gl_Position = vec4((projectionMatrix * translationMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);\r
\r
    vTextureCoord = (uTextureMatrix * vec3(aTextureCoord, 1.0)).xy;\r
}\r
`;
const uO = [], lO = [], cO = [], _6 = class w6 extends fn {
  /**
   * @param text - A string that you would like the text to display.
   * @param style - The style parameters.
   * @param {string} style.fontName - The installed BitmapFont name.
   * @param {number} [style.fontSize] - The size of the font in pixels, e.g. 24. If undefined,
   *.     this will default to the BitmapFont size.
   * @param {string} [style.align='left'] - Alignment for multiline text ('left', 'center', 'right' or 'justify'),
   *      does not affect single line text.
   * @param {PIXI.ColorSource} [style.tint=0xFFFFFF] - The tint color.
   * @param {number} [style.letterSpacing=0] - The amount of spacing between letters.
   * @param {number} [style.maxWidth=0] - The max width of the text before line wrapping.
   */
  constructor(e, n = {}) {
    super();
    const { align: r, tint: o, maxWidth: s, letterSpacing: i, fontName: u, fontSize: l } = Object.assign(
      {},
      w6.styleDefaults,
      n
    );
    if (!Ta.available[u])
      throw new Error(`Missing BitmapFont "${u}"`);
    this._activePagesMeshData = [], this._textWidth = 0, this._textHeight = 0, this._align = r, this._tintColor = new Gn(o), this._font = void 0, this._fontName = u, this._fontSize = l, this.text = e, this._maxWidth = s, this._maxLineHeight = 0, this._letterSpacing = i, this._anchor = new Yu(() => {
      this.dirty = !0;
    }, this, 0, 0), this._roundPixels = at.ROUND_PIXELS, this.dirty = !0, this._resolution = at.RESOLUTION, this._autoResolution = !0, this._textureCache = {};
  }
  /** Renders text and updates it when needed. This should only be called if the BitmapFont is regenerated. */
  updateText() {
    const e = Ta.available[this._fontName], n = this.fontSize, r = n / e.size, o = new Rt(), s = [], i = [], u = [], l = this._text.replace(/(?:\r\n|\r)/g, `
`) || " ", a = v6(l), c = this._maxWidth * e.size / n, p = e.distanceFieldType === "none" ? uO : lO;
    let d = null, h = 0, m = 0, g = 0, _ = -1, b = 0, x = 0, S = 0, E = 0;
    for (let B = 0; B < a.length; B++) {
      const W = a[B], G = u0(W);
      if (/(?:\s)/.test(W) && (_ = B, b = h, E++), W === "\r" || W === `
`) {
        i.push(h), u.push(-1), m = Math.max(m, h), ++g, ++x, o.x = 0, o.y += e.lineHeight, d = null, E = 0;
        continue;
      }
      const ne = e.chars[G];
      if (!ne)
        continue;
      d && ne.kerning[d] && (o.x += ne.kerning[d]);
      const de = cO.pop() || {
        texture: pt.EMPTY,
        line: 0,
        charCode: 0,
        prevSpaces: 0,
        position: new Rt()
      };
      de.texture = ne.texture, de.line = g, de.charCode = G, de.position.x = Math.round(o.x + ne.xOffset + this._letterSpacing / 2), de.position.y = Math.round(o.y + ne.yOffset), de.prevSpaces = E, s.push(de), h = de.position.x + Math.max(ne.xAdvance - ne.xOffset, ne.texture.orig.width), o.x += ne.xAdvance + this._letterSpacing, S = Math.max(S, ne.yOffset + ne.texture.height), d = G, _ !== -1 && c > 0 && o.x > c && (++x, Yd(s, 1 + _ - x, 1 + B - _), B = _, _ = -1, i.push(b), u.push(s.length > 0 ? s[s.length - 1].prevSpaces : 0), m = Math.max(m, b), g++, o.x = 0, o.y += e.lineHeight, d = null, E = 0);
    }
    const A = a[a.length - 1];
    A !== "\r" && A !== `
` && (/(?:\s)/.test(A) && (h = b), i.push(h), m = Math.max(m, h), u.push(-1));
    const C = [];
    for (let B = 0; B <= g; B++) {
      let W = 0;
      this._align === "right" ? W = m - i[B] : this._align === "center" ? W = (m - i[B]) / 2 : this._align === "justify" && (W = u[B] < 0 ? 0 : (m - i[B]) / u[B]), C.push(W);
    }
    const M = s.length, L = {}, X = [], te = this._activePagesMeshData;
    p.push(...te);
    for (let B = 0; B < M; B++) {
      const W = s[B].texture, G = W.baseTexture.uid;
      if (!L[G]) {
        let ne = p.pop();
        if (!ne) {
          const V = new a6();
          let Y, Q;
          e.distanceFieldType === "none" ? (Y = new DT(pt.EMPTY), Q = Mt.NORMAL) : (Y = new DT(
            pt.EMPTY,
            { program: Qu.from(Oxe, Cxe), uniforms: { uFWidth: 0 } }
          ), Q = Mt.NORMAL_NPM);
          const ae = new AT(V, Y);
          ae.blendMode = Q, ne = {
            index: 0,
            indexCount: 0,
            vertexCount: 0,
            uvsCount: 0,
            total: 0,
            mesh: ae,
            vertices: null,
            uvs: null,
            indices: null
          };
        }
        ne.index = 0, ne.indexCount = 0, ne.vertexCount = 0, ne.uvsCount = 0, ne.total = 0;
        const { _textureCache: de } = this;
        de[G] = de[G] || new pt(W.baseTexture), ne.mesh.texture = de[G], ne.mesh.tint = this._tintColor.value, X.push(ne), L[G] = ne;
      }
      L[G].total++;
    }
    for (let B = 0; B < te.length; B++)
      X.includes(te[B]) || this.removeChild(te[B].mesh);
    for (let B = 0; B < X.length; B++)
      X[B].mesh.parent !== this && this.addChild(X[B].mesh);
    this._activePagesMeshData = X;
    for (const B in L) {
      const W = L[B], G = W.total;
      if (!(W.indices?.length > 6 * G) || W.vertices.length < AT.BATCHABLE_SIZE * 2)
        W.vertices = new Float32Array(8 * G), W.uvs = new Float32Array(8 * G), W.indices = new Uint16Array(6 * G);
      else {
        const ne = W.total, de = W.vertices;
        for (let V = ne * 4 * 2; V < de.length; V++)
          de[V] = 0;
      }
      W.mesh.size = 6 * G;
    }
    for (let B = 0; B < M; B++) {
      const W = s[B];
      let G = W.position.x + C[W.line] * (this._align === "justify" ? W.prevSpaces : 1);
      this._roundPixels && (G = Math.round(G));
      const ne = G * r, de = W.position.y * r, V = W.texture, Y = L[V.baseTexture.uid], Q = V.frame, ae = V._uvs, Z = Y.index++;
      Y.indices[Z * 6 + 0] = 0 + Z * 4, Y.indices[Z * 6 + 1] = 1 + Z * 4, Y.indices[Z * 6 + 2] = 2 + Z * 4, Y.indices[Z * 6 + 3] = 0 + Z * 4, Y.indices[Z * 6 + 4] = 2 + Z * 4, Y.indices[Z * 6 + 5] = 3 + Z * 4, Y.vertices[Z * 8 + 0] = ne, Y.vertices[Z * 8 + 1] = de, Y.vertices[Z * 8 + 2] = ne + Q.width * r, Y.vertices[Z * 8 + 3] = de, Y.vertices[Z * 8 + 4] = ne + Q.width * r, Y.vertices[Z * 8 + 5] = de + Q.height * r, Y.vertices[Z * 8 + 6] = ne, Y.vertices[Z * 8 + 7] = de + Q.height * r, Y.uvs[Z * 8 + 0] = ae.x0, Y.uvs[Z * 8 + 1] = ae.y0, Y.uvs[Z * 8 + 2] = ae.x1, Y.uvs[Z * 8 + 3] = ae.y1, Y.uvs[Z * 8 + 4] = ae.x2, Y.uvs[Z * 8 + 5] = ae.y2, Y.uvs[Z * 8 + 6] = ae.x3, Y.uvs[Z * 8 + 7] = ae.y3;
    }
    this._textWidth = m * r, this._textHeight = (o.y + e.lineHeight) * r;
    for (const B in L) {
      const W = L[B];
      if (this.anchor.x !== 0 || this.anchor.y !== 0) {
        let V = 0;
        const Y = this._textWidth * this.anchor.x, Q = this._textHeight * this.anchor.y;
        for (let ae = 0; ae < W.total; ae++)
          W.vertices[V++] -= Y, W.vertices[V++] -= Q, W.vertices[V++] -= Y, W.vertices[V++] -= Q, W.vertices[V++] -= Y, W.vertices[V++] -= Q, W.vertices[V++] -= Y, W.vertices[V++] -= Q;
      }
      this._maxLineHeight = S * r;
      const G = W.mesh.geometry.getBuffer("aVertexPosition"), ne = W.mesh.geometry.getBuffer("aTextureCoord"), de = W.mesh.geometry.getIndex();
      G.data = W.vertices, ne.data = W.uvs, de.data = W.indices, G.update(), ne.update(), de.update();
    }
    for (let B = 0; B < s.length; B++)
      cO.push(s[B]);
    this._font = e, this.dirty = !1;
  }
  updateTransform() {
    this.validate(), this.containerUpdateTransform();
  }
  _render(e) {
    this._autoResolution && this._resolution !== e.resolution && (this._resolution = e.resolution, this.dirty = !0);
    const { distanceFieldRange: n, distanceFieldType: r, size: o } = Ta.available[this._fontName];
    if (r !== "none") {
      const { a: s, b: i, c: u, d: l } = this.worldTransform, a = Math.sqrt(s * s + i * i), c = Math.sqrt(u * u + l * l), p = (Math.abs(a) + Math.abs(c)) / 2, d = this.fontSize / o, h = e._view.resolution;
      for (const m of this._activePagesMeshData)
        m.mesh.shader.uniforms.uFWidth = p * n * d * h;
    }
    super._render(e);
  }
  /**
   * Validates text before calling parent's getLocalBounds
   * @returns - The rectangular bounding area
   */
  getLocalBounds() {
    return this.validate(), super.getLocalBounds();
  }
  /**
   * Updates text when needed
   * @private
   */
  validate() {
    const e = Ta.available[this._fontName];
    if (!e)
      throw new Error(`Missing BitmapFont "${this._fontName}"`);
    this._font !== e && (this.dirty = !0), this.dirty && this.updateText();
  }
  /**
   * The tint of the BitmapText object.
   * @default 0xffffff
   */
  get tint() {
    return this._tintColor.value;
  }
  set tint(e) {
    if (this.tint !== e) {
      this._tintColor.setValue(e);
      for (let n = 0; n < this._activePagesMeshData.length; n++)
        this._activePagesMeshData[n].mesh.tint = e;
    }
  }
  /**
   * The alignment of the BitmapText object.
   * @member {string}
   * @default 'left'
   */
  get align() {
    return this._align;
  }
  set align(e) {
    this._align !== e && (this._align = e, this.dirty = !0);
  }
  /** The name of the BitmapFont. */
  get fontName() {
    return this._fontName;
  }
  set fontName(e) {
    if (!Ta.available[e])
      throw new Error(`Missing BitmapFont "${e}"`);
    this._fontName !== e && (this._fontName = e, this.dirty = !0);
  }
  /** The size of the font to display. */
  get fontSize() {
    return this._fontSize ?? Ta.available[this._fontName].size;
  }
  set fontSize(e) {
    this._fontSize !== e && (this._fontSize = e, this.dirty = !0);
  }
  /**
   * The anchor sets the origin point of the text.
   *
   * The default is `(0,0)`, this means the text's origin is the top left.
   *
   * Setting the anchor to `(0.5,0.5)` means the text's origin is centered.
   *
   * Setting the anchor to `(1,1)` would mean the text's origin point will be the bottom right corner.
   */
  get anchor() {
    return this._anchor;
  }
  set anchor(e) {
    typeof e == "number" ? this._anchor.set(e) : this._anchor.copyFrom(e);
  }
  /** The text of the BitmapText object. */
  get text() {
    return this._text;
  }
  set text(e) {
    e = String(e ?? ""), this._text !== e && (this._text = e, this.dirty = !0);
  }
  /**
   * The max width of this bitmap text in pixels. If the text provided is longer than the
   * value provided, line breaks will be automatically inserted in the last whitespace.
   * Disable by setting the value to 0.
   */
  get maxWidth() {
    return this._maxWidth;
  }
  set maxWidth(e) {
    this._maxWidth !== e && (this._maxWidth = e, this.dirty = !0);
  }
  /**
   * The max line height. This is useful when trying to use the total height of the Text,
   * i.e. when trying to vertically align.
   * @readonly
   */
  get maxLineHeight() {
    return this.validate(), this._maxLineHeight;
  }
  /**
   * The width of the overall text, different from fontSize,
   * which is defined in the style object.
   * @readonly
   */
  get textWidth() {
    return this.validate(), this._textWidth;
  }
  /** Additional space between characters. */
  get letterSpacing() {
    return this._letterSpacing;
  }
  set letterSpacing(e) {
    this._letterSpacing !== e && (this._letterSpacing = e, this.dirty = !0);
  }
  /**
   * If true PixiJS will Math.floor() x/y values when rendering, stopping pixel interpolation.
   * Advantages can include sharper image quality (like text) and faster rendering on canvas.
   * The main disadvantage is movement of objects may appear less smooth.
   * To set the global default, change {@link PIXI.settings.ROUND_PIXELS}
   * @default PIXI.settings.ROUND_PIXELS
   */
  get roundPixels() {
    return this._roundPixels;
  }
  set roundPixels(e) {
    e !== this._roundPixels && (this._roundPixels = e, this.dirty = !0);
  }
  /**
   * The height of the overall text, different from fontSize,
   * which is defined in the style object.
   * @readonly
   */
  get textHeight() {
    return this.validate(), this._textHeight;
  }
  /**
   * The resolution / device pixel ratio of the canvas.
   *
   * This is set to automatically match the renderer resolution by default, but can be overridden by setting manually.
   * @default 1
   */
  get resolution() {
    return this._resolution;
  }
  set resolution(e) {
    this._autoResolution = !1, this._resolution !== e && (this._resolution = e, this.dirty = !0);
  }
  destroy(e) {
    const { _textureCache: n } = this, r = Ta.available[this._fontName].distanceFieldType === "none" ? uO : lO;
    r.push(...this._activePagesMeshData);
    for (const o of this._activePagesMeshData)
      this.removeChild(o.mesh);
    this._activePagesMeshData = [], r.filter((o) => n[o.mesh.texture.baseTexture.uid]).forEach((o) => {
      o.mesh.texture = pt.EMPTY;
    });
    for (const o in n)
      n[o].destroy(), delete n[o];
    this._font = null, this._tintColor = null, this._textureCache = null, super.destroy(e);
  }
};
_6.styleDefaults = {
  align: "left",
  tint: 16777215,
  maxWidth: 0,
  letterSpacing: 0
};
let Ixe = _6;
const Fxe = [".xml", ".fnt"], Nxe = {
  extension: {
    type: rt.LoadParser,
    priority: Si.Normal
  },
  name: "loadBitmapFont",
  test(t) {
    return Fxe.includes(lo.extname(t).toLowerCase());
  },
  async testParse(t) {
    return i0.test(t) || CT.test(t);
  },
  async parse(t, e, n) {
    const r = i0.test(t) ? i0.parse(t) : CT.parse(t), { src: o } = e, { page: s } = r, i = [];
    for (let a = 0; a < s.length; ++a) {
      const c = s[a].file;
      let p = lo.join(lo.dirname(o), c);
      p = xT(p, o), i.push(p);
    }
    const u = await n.load(i), l = i.map((a) => u[a]);
    return Ta.install(r, l, !0);
  },
  async load(t, e) {
    return (await at.ADAPTER.fetch(t)).text();
  },
  unload(t) {
    t.destroy();
  }
};
dt.add(Nxe);
const OT = class Id extends _c {
  constructor() {
    super(...arguments), this._fonts = [], this._overrides = [], this._stylesheet = "", this.fontsDirty = !1;
  }
  /**
   * Convert a TextStyle to HTMLTextStyle
   * @param originalStyle
   * @example
   * import {TextStyle } from 'pixi.js';
   * import {HTMLTextStyle} from '@pixi/text-html';
   * const style = new TextStyle();
   * const htmlStyle = HTMLTextStyle.from(style);
   */
  static from(e) {
    return new Id(
      Object.keys(Id.defaultOptions).reduce((n, r) => ({ ...n, [r]: e[r] }), {})
    );
  }
  /** Clear the current font */
  cleanFonts() {
    this._fonts.length > 0 && (this._fonts.forEach((e) => {
      URL.revokeObjectURL(e.src), e.refs--, e.refs === 0 && (e.fontFace && document.fonts.delete(e.fontFace), delete Id.availableFonts[e.originalUrl]);
    }), this.fontFamily = "Arial", this._fonts.length = 0, this.styleID++, this.fontsDirty = !0);
  }
  /**
   * Because of how HTMLText renders, fonts need to be imported
   * @param url
   * @param options
   */
  loadFont(e, n = {}) {
    const { availableFonts: r } = Id;
    if (r[e]) {
      const o = r[e];
      return this._fonts.push(o), o.refs++, this.styleID++, this.fontsDirty = !0, Promise.resolve();
    }
    return at.ADAPTER.fetch(e).then((o) => o.blob()).then(async (o) => new Promise((s, i) => {
      const u = URL.createObjectURL(o), l = new FileReader();
      l.onload = () => s([u, l.result]), l.onerror = i, l.readAsDataURL(o);
    })).then(async ([o, s]) => {
      const i = Object.assign({
        family: lo.basename(e, lo.extname(e)),
        weight: "normal",
        style: "normal",
        display: "auto",
        src: o,
        dataSrc: s,
        refs: 1,
        originalUrl: e,
        fontFace: null
      }, n);
      r[e] = i, this._fonts.push(i), this.styleID++;
      const u = new FontFace(i.family, `url(${i.src})`, {
        weight: i.weight,
        style: i.style,
        display: i.display
      });
      i.fontFace = u, await u.load(), document.fonts.add(u), await document.fonts.ready, this.styleID++, this.fontsDirty = !0;
    });
  }
  /**
   * Add a style override, this can be any CSS property
   * it will override any built-in style. This is the
   * property and the value as a string (e.g., `color: red`).
   * This will override any other internal style.
   * @param {string} value - CSS style(s) to add.
   * @example
   * style.addOverride('background-color: red');
   */
  addOverride(...e) {
    const n = e.filter((r) => !this._overrides.includes(r));
    n.length > 0 && (this._overrides.push(...n), this.styleID++);
  }
  /**
   * Remove any overrides that match the value.
   * @param {string} value - CSS style to remove.
   * @example
   * style.removeOverride('background-color: red');
   */
  removeOverride(...e) {
    const n = e.filter((r) => this._overrides.includes(r));
    n.length > 0 && (this._overrides = this._overrides.filter((r) => !n.includes(r)), this.styleID++);
  }
  /**
   * Internally converts all of the style properties into CSS equivalents.
   * @param scale
   * @returns The CSS style string, for setting `style` property of root HTMLElement.
   */
  toCSS(e) {
    return [
      `transform: scale(${e})`,
      "transform-origin: top left",
      "display: inline-block",
      `color: ${this.normalizeColor(this.fill)}`,
      `font-size: ${this.fontSize}px`,
      `font-family: ${this.fontFamily}`,
      `font-weight: ${this.fontWeight}`,
      `font-style: ${this.fontStyle}`,
      `font-variant: ${this.fontVariant}`,
      `letter-spacing: ${this.letterSpacing}px`,
      `text-align: ${this.align}`,
      `padding: ${this.padding}px`,
      `white-space: ${this.whiteSpace}`,
      ...this.lineHeight ? [`line-height: ${this.lineHeight}px`] : [],
      ...this.wordWrap ? [
        `word-wrap: ${this.breakWords ? "break-all" : "break-word"}`,
        `max-width: ${this.wordWrapWidth}px`
      ] : [],
      ...this.strokeThickness ? [
        `-webkit-text-stroke-width: ${this.strokeThickness}px`,
        `-webkit-text-stroke-color: ${this.normalizeColor(this.stroke)}`,
        `text-stroke-width: ${this.strokeThickness}px`,
        `text-stroke-color: ${this.normalizeColor(this.stroke)}`,
        "paint-order: stroke"
      ] : [],
      ...this.dropShadow ? [this.dropShadowToCSS()] : [],
      ...this._overrides
    ].join(";");
  }
  /** Get the font CSS styles from the loaded font, If available. */
  toGlobalCSS() {
    return this._fonts.reduce((e, n) => `${e}
            @font-face {
                font-family: "${n.family}";
                src: url('${n.dataSrc}');
                font-weight: ${n.weight};
                font-style: ${n.style};
                font-display: ${n.display};
            }`, this._stylesheet);
  }
  /** Internal stylesheet contents, useful for creating rules for rendering */
  get stylesheet() {
    return this._stylesheet;
  }
  set stylesheet(e) {
    this._stylesheet !== e && (this._stylesheet = e, this.styleID++);
  }
  /**
   * Convert numerical colors into hex-strings
   * @param color
   */
  normalizeColor(e) {
    return Array.isArray(e) && (e = R1e(e)), typeof e == "number" ? S1e(e) : e;
  }
  /** Convert the internal drop-shadow settings to CSS text-shadow */
  dropShadowToCSS() {
    let e = this.normalizeColor(this.dropShadowColor);
    const n = this.dropShadowAlpha, r = Math.round(Math.cos(this.dropShadowAngle) * this.dropShadowDistance), o = Math.round(Math.sin(this.dropShadowAngle) * this.dropShadowDistance);
    e.startsWith("#") && n < 1 && (e += (n * 255 | 0).toString(16).padStart(2, "0"));
    const s = `${r}px ${o}px`;
    return this.dropShadowBlur > 0 ? `text-shadow: ${s} ${this.dropShadowBlur}px ${e}` : `text-shadow: ${s} ${e}`;
  }
  /** Resets all properties to the defaults specified in TextStyle.prototype._default */
  reset() {
    Object.assign(this, Id.defaultOptions);
  }
  /**
   * Called after the image is loaded but before drawing to the canvas.
   * Mostly used to handle Safari's font loading bug.
   * @ignore
   */
  onBeforeDraw() {
    const { fontsDirty: e } = this;
    return this.fontsDirty = !1, this.isSafari && this._fonts.length > 0 && e ? new Promise((n) => setTimeout(n, 100)) : Promise.resolve();
  }
  /**
   * Proving that Safari is the new IE
   * @ignore
   */
  get isSafari() {
    const { userAgent: e } = at.ADAPTER.getNavigator();
    return /^((?!chrome|android).)*safari/i.test(e);
  }
  set fillGradientStops(e) {
    console.warn("[HTMLTextStyle] fillGradientStops is not supported by HTMLText");
  }
  get fillGradientStops() {
    return super.fillGradientStops;
  }
  set fillGradientType(e) {
    console.warn("[HTMLTextStyle] fillGradientType is not supported by HTMLText");
  }
  get fillGradientType() {
    return super.fillGradientType;
  }
  set miterLimit(e) {
    console.warn("[HTMLTextStyle] miterLimit is not supported by HTMLText");
  }
  get miterLimit() {
    return super.miterLimit;
  }
  set trim(e) {
    console.warn("[HTMLTextStyle] trim is not supported by HTMLText");
  }
  get trim() {
    return super.trim;
  }
  set textBaseline(e) {
    console.warn("[HTMLTextStyle] textBaseline is not supported by HTMLText");
  }
  get textBaseline() {
    return super.textBaseline;
  }
  set leading(e) {
    console.warn("[HTMLTextStyle] leading is not supported by HTMLText");
  }
  get leading() {
    return super.leading;
  }
  set lineJoin(e) {
    console.warn("[HTMLTextStyle] lineJoin is not supported by HTMLText");
  }
  get lineJoin() {
    return super.lineJoin;
  }
};
OT.availableFonts = {}, /**
* List of default options, these are largely the same as TextStyle,
* with the exception of whiteSpace, which is set to 'normal' by default.
*/
OT.defaultOptions = {
  /** Align */
  align: "left",
  /** Break words */
  breakWords: !1,
  /** Drop shadow */
  dropShadow: !1,
  /** Drop shadow alpha */
  dropShadowAlpha: 1,
  /**
   * Drop shadow angle
   * @type {number}
   * @default Math.PI / 6
   */
  dropShadowAngle: Math.PI / 6,
  /** Drop shadow blur */
  dropShadowBlur: 0,
  /** Drop shadow color */
  dropShadowColor: "black",
  /** Drop shadow distance */
  dropShadowDistance: 5,
  /** Fill */
  fill: "black",
  /** Font family */
  fontFamily: "Arial",
  /** Font size */
  fontSize: 26,
  /** Font style */
  fontStyle: "normal",
  /** Font variant */
  fontVariant: "normal",
  /** Font weight */
  fontWeight: "normal",
  /** Letter spacing */
  letterSpacing: 0,
  /** Line height */
  lineHeight: 0,
  /** Padding */
  padding: 0,
  /** Stroke */
  stroke: "black",
  /** Stroke thickness */
  strokeThickness: 0,
  /** White space */
  whiteSpace: "normal",
  /** Word wrap */
  wordWrap: !1,
  /** Word wrap width */
  wordWrapWidth: 100
};
let Ob = OT;
const Og = class Fd extends Vr {
  /**
   * @param {string} [text] - Text contents
   * @param {PIXI.HTMLTextStyle|PIXI.TextStyle|PIXI.ITextStyle} [style] - Style setting to use.
   *        Strongly recommend using an HTMLTextStyle object. Providing a PIXI.TextStyle
   *        will convert the TextStyle to an HTMLTextStyle and will no longer be linked.
   */
  constructor(e = "", n = {}) {
    super(pt.EMPTY), this._text = null, this._style = null, this._autoResolution = !0, this.localStyleID = -1, this.dirty = !1, this._updateID = 0, this.ownsStyle = !1;
    const r = new Image(), o = pt.from(r, {
      scaleMode: at.SCALE_MODE,
      resourceOptions: {
        autoLoad: !1
      }
    });
    o.orig = new Pt(), o.trim = new Pt(), this.texture = o;
    const s = "http://www.w3.org/2000/svg", i = "http://www.w3.org/1999/xhtml", u = document.createElementNS(s, "svg"), l = document.createElementNS(s, "foreignObject"), a = document.createElementNS(i, "div"), c = document.createElementNS(i, "style");
    l.setAttribute("width", "10000"), l.setAttribute("height", "10000"), l.style.overflow = "hidden", u.appendChild(l), this.maxWidth = Fd.defaultMaxWidth, this.maxHeight = Fd.defaultMaxHeight, this._domElement = a, this._styleElement = c, this._svgRoot = u, this._foreignObject = l, this._foreignObject.appendChild(c), this._foreignObject.appendChild(a), this._image = r, this._loadImage = new Image(), this._autoResolution = Fd.defaultAutoResolution, this._resolution = Fd.defaultResolution ?? at.RESOLUTION, this.text = e, this.style = n;
  }
  /**
   * Calculate the size of the output text without actually drawing it.
   * This includes the `padding` in the `style` object.
   * This can be used as a fast-pass to do things like text-fitting.
   * @param {object} [overrides] - Overrides for the text, style, and resolution.
   * @param {string} [overrides.text] - The text to measure, if not specified, the current text is used.
   * @param {PIXI.HTMLTextStyle} [overrides.style] - The style to measure, if not specified, the current style is used.
   * @param {number} [overrides.resolution] - The resolution to measure, if not specified, the current resolution is used.
   * @returns {PIXI.ISize} Width and height of the measured text.
   */
  measureText(e) {
    const { text: n, style: r, resolution: o } = Object.assign({
      text: this._text,
      style: this._style,
      resolution: this._resolution
    }, e);
    Object.assign(this._domElement, {
      innerHTML: n,
      style: r.toCSS(o)
    }), this._styleElement.textContent = r.toGlobalCSS(), document.body.appendChild(this._svgRoot);
    const s = this._domElement.getBoundingClientRect();
    this._svgRoot.remove();
    const { width: i, height: u } = s;
    (i > this.maxWidth || u > this.maxHeight) && console.warn("[HTMLText] Large expanse of text, increase HTMLText.maxWidth or HTMLText.maxHeight property.");
    const l = Math.min(this.maxWidth, Math.ceil(i)), a = Math.min(this.maxHeight, Math.ceil(u));
    return this._svgRoot.setAttribute("width", l.toString()), this._svgRoot.setAttribute("height", a.toString()), n !== this._text && (this._domElement.innerHTML = this._text), r !== this._style && (Object.assign(this._domElement, { style: this._style?.toCSS(o) }), this._styleElement.textContent = this._style?.toGlobalCSS()), {
      width: l + r.padding * 2,
      height: a + r.padding * 2
    };
  }
  /**
   * Manually refresh the text.
   * @public
   * @param {boolean} respectDirty - Whether to abort updating the
   *        text if the Text isn't dirty and the function is called.
   */
  async updateText(e = !0) {
    const { style: n, _image: r, _loadImage: o } = this;
    if (this.localStyleID !== n.styleID && (this.dirty = !0, this.localStyleID = n.styleID), !this.dirty && e)
      return;
    const { width: s, height: i } = this.measureText();
    r.width = o.width = Math.ceil(Math.max(1, s)), r.height = o.height = Math.ceil(Math.max(1, i)), this._updateID++;
    const u = this._updateID;
    await new Promise((l) => {
      o.onload = async () => {
        if (u < this._updateID) {
          l();
          return;
        }
        await n.onBeforeDraw(), r.src = o.src, o.onload = null, o.src = "", this.updateTexture(), l();
      };
      const a = new XMLSerializer().serializeToString(this._svgRoot);
      o.src = `data:image/svg+xml;charset=utf8,${encodeURIComponent(a)}`;
    });
  }
  /** The raw image element that is rendered under-the-hood. */
  get source() {
    return this._image;
  }
  /**
   * Update the texture resource.
   * @private
   */
  updateTexture() {
    const { style: e, texture: n, _image: r, resolution: o } = this, { padding: s } = e, { baseTexture: i } = n;
    n.trim.width = n._frame.width = r.width / o, n.trim.height = n._frame.height = r.height / o, n.trim.x = -s, n.trim.y = -s, n.orig.width = n._frame.width - s * 2, n.orig.height = n._frame.height - s * 2, this._onTextureUpdate(), i.setRealSize(r.width, r.height, o), this.dirty = !1;
  }
  /**
   * Renders the object using the WebGL renderer
   * @param {PIXI.Renderer} renderer - The renderer
   * @private
   */
  _render(e) {
    this._autoResolution && this._resolution !== e.resolution && (this._resolution = e.resolution, this.dirty = !0), this.updateText(!0), super._render(e);
  }
  /**
   * Renders the object using the Canvas Renderer.
   * @private
   * @param {PIXI.CanvasRenderer} renderer - The renderer
   */
  _renderCanvas(e) {
    this._autoResolution && this._resolution !== e.resolution && (this._resolution = e.resolution, this.dirty = !0), this.updateText(!0), super._renderCanvas(e);
  }
  /**
   * Get the local bounds.
   * @param {PIXI.Rectangle} rect - Input rectangle.
   * @returns {PIXI.Rectangle} Local bounds
   */
  getLocalBounds(e) {
    return this.updateText(!0), super.getLocalBounds(e);
  }
  _calculateBounds() {
    this.updateText(!0), this.calculateVertices(), this._bounds.addQuad(this.vertexData);
  }
  /**
   * Handle dirty style changes
   * @private
   */
  _onStyleChange() {
    this.dirty = !0;
  }
  /**
   * Destroy this Text object. Don't use after calling.
   * @param {boolean|object} options - Same as Sprite destroy options.
   */
  destroy(e) {
    typeof e == "boolean" && (e = { children: e }), e = Object.assign({}, Fd.defaultDestroyOptions, e), super.destroy(e);
    const n = null;
    this.ownsStyle && this._style?.cleanFonts(), this._style = n, this._svgRoot?.remove(), this._svgRoot = n, this._domElement?.remove(), this._domElement = n, this._foreignObject?.remove(), this._foreignObject = n, this._styleElement?.remove(), this._styleElement = n, this._loadImage.src = "", this._loadImage.onload = null, this._loadImage = n, this._image.src = "", this._image = n;
  }
  /**
   * Get the width in pixels.
   * @member {number}
   */
  get width() {
    return this.updateText(!0), Math.abs(this.scale.x) * this._image.width / this.resolution;
  }
  set width(e) {
    this.updateText(!0);
    const n = ec(this.scale.x) || 1;
    this.scale.x = n * e / this._image.width / this.resolution, this._width = e;
  }
  /**
   * Get the height in pixels.
   * @member {number}
   */
  get height() {
    return this.updateText(!0), Math.abs(this.scale.y) * this._image.height / this.resolution;
  }
  set height(e) {
    this.updateText(!0);
    const n = ec(this.scale.y) || 1;
    this.scale.y = n * e / this._image.height / this.resolution, this._height = e;
  }
  /** The base style to render with text. */
  get style() {
    return this._style;
  }
  set style(e) {
    this._style !== e && (e = e || {}, e instanceof Ob ? (this.ownsStyle = !1, this._style = e) : e instanceof _c ? (console.warn("[HTMLText] Cloning TextStyle, if this is not what you want, use HTMLTextStyle"), this.ownsStyle = !0, this._style = Ob.from(e)) : (this.ownsStyle = !0, this._style = new Ob(e)), this.localStyleID = -1, this.dirty = !0);
  }
  /**
   * Contents of text. This can be HTML text and include tags.
   * @example
   * const text = new HTMLText('This is a <em>styled</em> text!');
   * @member {string}
   */
  get text() {
    return this._text;
  }
  set text(e) {
    e = String(e === "" || e === null || e === void 0 ? " " : e), e = this.sanitiseText(e), this._text !== e && (this._text = e, this.dirty = !0);
  }
  /**
   * The resolution / device pixel ratio of the canvas.
   * This is set to automatically match the renderer resolution by default, but can be overridden by setting manually.
   * @member {number}
   * @default 1
   */
  get resolution() {
    return this._resolution;
  }
  set resolution(e) {
    this._autoResolution = !1, this._resolution !== e && (this._resolution = e, this.dirty = !0);
  }
  /**
   * Sanitise text - replace `<br>` with `<br/>`, `&nbsp;` with `&#160;`
   * @param text
   * @see https://www.sitepoint.com/community/t/xhtml-1-0-transitional-xml-parsing-error-entity-nbsp-not-defined/3392/3
   */
  sanitiseText(e) {
    return e.replace(/<br>/gi, "<br/>").replace(/<hr>/gi, "<hr/>").replace(/&nbsp;/gi, "&#160;");
  }
};
Og.defaultDestroyOptions = {
  texture: !0,
  children: !1,
  baseTexture: !0
}, /** Default maxWidth, set at construction */
Og.defaultMaxWidth = 2024, /** Default maxHeight, set at construction */
Og.defaultMaxHeight = 2024, /** Default autoResolution for all HTMLText objects */
Og.defaultAutoResolution = !0;
function Lxe() {
  const t = /* @__PURE__ */ new Map();
  function e(i, u) {
    const l = t.get(i);
    return l ? l.add(u) : t.set(i, /* @__PURE__ */ new Set([u])), () => r(i, u);
  }
  function n(i, u) {
    const l = (a) => {
      r(i, l), u(a);
    };
    e(i, l);
  }
  function r(i, u) {
    t.get(i)?.delete(u);
  }
  function o(i, u) {
    t.get(i)?.forEach((l) => l(u));
  }
  function s() {
    t.clear();
  }
  return {
    on: e,
    off: r,
    once: n,
    emit: o,
    clear: s
  };
}
const Ze = Lxe();
function Is(t) {
  let e;
  return new Promise((n) => {
    e = n, Ze.on(t, e);
  }).then((n) => (Ze.off(t, e), n));
}
let Ju = null;
const b6 = new ResizeObserver(() => {
  Ju && Ze.emit("stageUpdated", Ju);
});
function Bxe(t) {
  Ju = t, b6.observe(Ju), Ze.emit("stageCreated", Ju);
}
function Uxe() {
  Ju && b6.unobserve(Ju), Ju = null;
}
async function CS() {
  return Ju || await Is("stageCreated");
}
let Gs = null;
async function Xxe() {
  const t = await CS();
  Wxe(t), Ze.on("stageUpdated", Vxe);
}
function $xe() {
  Gs && (Gs.destroy(!0, {
    children: !0
  }), Gs = null);
}
function Wxe(t) {
  Gs || (Gs = new QB({
    backgroundAlpha: 0,
    resizeTo: t,
    antialias: !0,
    resolution: Math.ceil(window.devicePixelRatio)
  }), Gs.stage.sortableChildren = !0, t.appendChild(Gs.view), Ze.emit("applicationCreated", Gs), process.env.NODE_ENV === "development" && (globalThis.__PIXI_APP__ = Gs));
}
async function no() {
  return Gs || await Is("applicationCreated");
}
function Vxe(t) {
  Gs && (Gs.resizeTo = t, Ze.emit("applicationResized", Gs));
}
let l0 = /* @__PURE__ */ new Map();
function Hxe() {
  l0 = /* @__PURE__ */ new Map();
}
async function py(t, e) {
  const n = `${t.toString()}-${JSON.stringify(e)}`;
  if (l0.has(n))
    return l0.get(n);
  const r = await t(...e);
  return l0.set(n, r), r;
}
let Jf = null;
const jxe = {
  animationDuration: 500,
  disableAnimationsThreshold: 500,
  disableEdgesThreshold: 500,
  fetchEvents: () => [],
  fetchEventsInterval: 3e4,
  theme: "dark"
};
function zxe(t) {
  return {
    ...jxe,
    ...t
  };
}
function qxe(t) {
  k6(t);
}
function k6(t) {
  const e = zxe(t);
  if (!Jf) {
    Jf = e, Ze.emit("configCreated", e);
    return;
  }
  Object.assign(Jf, e), Ze.emit("configUpdated", e);
}
function Gxe() {
  Jf = null;
}
async function oa() {
  return Jf || await Is("configCreated");
}
const Zc = new Pt();
class Yxe {
  /**
   * @param options
   * @param [options.recursive] - whether culling should be recursive
   * @param [options.toggle='renderable'] - which property of display-object was be set to indicate
   *      its culling state. It should be one of `renderable`, `visible`.
   */
  constructor(e = {}) {
    this._recursive = typeof e.recursive == "boolean" ? e.recursive : !0, this._toggle = e.toggle || "visible", this._targetList = /* @__PURE__ */ new Set();
  }
  /**
   * Adds a display-object to the culling list
   *
   * @param target - the display-object to be culled
   * @return this
   */
  add(e) {
    return this._targetList.add(e), this;
  }
  /**
   * Adds all the display-objects to the culling list
   *
   * @param targets - the display-objects to be culled
   * @return this
   */
  addAll(e) {
    for (let n = 0, r = e.length; n < r; n++)
      this._targetList.add(e[n]);
    return this;
  }
  /**
   * Removes the display-object from the culling list
   *
   * @param target - the display-object to be removed
   * @return this
   */
  remove(e) {
    return this._targetList.delete(e), this;
  }
  /**
   * Removes all the passed display-objects from the culling list
   *
   * @param targets - the display-objects to be removed
   * @return this
   */
  removeAll(e) {
    for (let n = 0, r = e.length; n < r; n++)
      this._targetList.delete(e[n]);
    return this;
  }
  /**
   * Clears the culling list
   *
   * @return this
   */
  clear() {
    return this._targetList.clear(), this;
  }
  /**
   * @param rect - the rectangle outside of which display-objects should be culled
   * @param skipUpdate - whether to skip unculling, transform update, bounds calculation. It is
   *  highly recommended you enable this by calling _this.uncull()_ and _root.getBounds(false)_ manually
   *  before your render loop.
   * @return this
   */
  cull(e, n = !1) {
    return n || this.uncull(), this._targetList.forEach((r) => {
      n || r.getBounds(!1, Zc), this._recursive ? this.cullRecursive(e, r, n) : (n && r._bounds.getRectangle(e), r[this._toggle] = Zc.right > e.left && Zc.left < e.right && Zc.bottom > e.top && Zc.top < e.bottom);
    }), this;
  }
  /**
   * Sets all display-objects to the unculled state.
   *
   * This happens regardless of whether the culling toggle was set by {@code this.cull} or manually. This
   * is why it is recommended to one of `visible` or `renderable` for normal use and the other for culling.
   *
   * @return this
   */
  uncull() {
    return this._targetList.forEach((e) => {
      this._recursive ? this.uncullRecursive(e) : e[this._toggle] = !1;
    }), this;
  }
  /**
   * Recursively culls the subtree of {@code displayObject}.
   *
   * @param rect - the visiblity rectangle
   * @param displayObject - the root of the subtree to cull
   * @param skipUpdate - whether to skip bounds calculation. However, transforms are expected to be updated by the caller.
   */
  cullRecursive(e, n, r) {
    const o = r ? n._bounds.getRectangle(Zc) : n.getBounds(!0, Zc);
    if (n[this._toggle] = o.right > e.left && o.left < e.right && o.bottom > e.top && o.top < e.bottom, !(o.left >= e.left && o.top >= e.top && o.right <= e.right && o.bottom <= e.bottom) && n[this._toggle] && n.children && n.children.length) {
      const s = n.children;
      for (let i = 0, u = s.length; i < u; i++)
        this.cullRecursive(e, s[i]);
    }
  }
  /**
   * Recursively unculls the subtree of {@code displayObject}.
   *
   * @param displayObject
   */
  uncullRecursive(e) {
    if (e[this._toggle] = !0, e.children && e.children.length) {
      const n = e.children;
      for (let r = 0, o = n.length; r < o; r++)
        this.uncullRecursive(n[r]);
    }
  }
}
var c0 = { exports: {} };
c0.exports;
var pO;
function Qxe() {
  return pO || (pO = 1, function(t, e) {
    var n = 200, r = "__lodash_hash_undefined__", o = 1, s = 2, i = 9007199254740991, u = "[object Arguments]", l = "[object Array]", a = "[object AsyncFunction]", c = "[object Boolean]", p = "[object Date]", d = "[object Error]", h = "[object Function]", m = "[object GeneratorFunction]", g = "[object Map]", _ = "[object Number]", b = "[object Null]", x = "[object Object]", S = "[object Promise]", E = "[object Proxy]", A = "[object RegExp]", C = "[object Set]", M = "[object String]", L = "[object Symbol]", X = "[object Undefined]", te = "[object WeakMap]", B = "[object ArrayBuffer]", W = "[object DataView]", G = "[object Float32Array]", ne = "[object Float64Array]", de = "[object Int8Array]", V = "[object Int16Array]", Y = "[object Int32Array]", Q = "[object Uint8Array]", ae = "[object Uint8ClampedArray]", Z = "[object Uint16Array]", J = "[object Uint32Array]", oe = /[\\^$.*+?()[\]{}|]/g, ue = /^\[object .+?Constructor\]$/, me = /^(?:0|[1-9]\d*)$/, pe = {};
    pe[G] = pe[ne] = pe[de] = pe[V] = pe[Y] = pe[Q] = pe[ae] = pe[Z] = pe[J] = !0, pe[u] = pe[l] = pe[B] = pe[c] = pe[W] = pe[p] = pe[d] = pe[h] = pe[g] = pe[_] = pe[x] = pe[A] = pe[C] = pe[M] = pe[te] = !1;
    var Be = typeof Aa == "object" && Aa && Aa.Object === Object && Aa, Ie = typeof self == "object" && self && self.Object === Object && self, Me = Be || Ie || Function("return this")(), fe = e && !e.nodeType && e, Te = fe && !0 && t && !t.nodeType && t, Ae = Te && Te.exports === fe, we = Ae && Be.process, $e = function() {
      try {
        return we && we.binding && we.binding("util");
      } catch {
      }
    }(), ze = $e && $e.isTypedArray;
    function Ue(N, I) {
      for (var H = -1, se = N == null ? 0 : N.length, Ne = 0, Oe = []; ++H < se; ) {
        var Je = N[H];
        I(Je, H, N) && (Oe[Ne++] = Je);
      }
      return Oe;
    }
    function tt(N, I) {
      for (var H = -1, se = I.length, Ne = N.length; ++H < se; )
        N[Ne + H] = I[H];
      return N;
    }
    function Ot(N, I) {
      for (var H = -1, se = N == null ? 0 : N.length; ++H < se; )
        if (I(N[H], H, N))
          return !0;
      return !1;
    }
    function cn(N, I) {
      for (var H = -1, se = Array(N); ++H < N; )
        se[H] = I(H);
      return se;
    }
    function Xr(N) {
      return function(I) {
        return N(I);
      };
    }
    function Pn(N, I) {
      return N.has(I);
    }
    function On(N, I) {
      return N?.[I];
    }
    function sr(N) {
      var I = -1, H = Array(N.size);
      return N.forEach(function(se, Ne) {
        H[++I] = [Ne, se];
      }), H;
    }
    function Hn(N, I) {
      return function(H) {
        return N(I(H));
      };
    }
    function sa(N) {
      var I = -1, H = Array(N.size);
      return N.forEach(function(se) {
        H[++I] = se;
      }), H;
    }
    var Eo = Array.prototype, aa = Function.prototype, ar = Object.prototype, Zn = Me["__core-js_shared__"], $r = aa.toString, gn = ar.hasOwnProperty, ko = function() {
      var N = /[^.]+$/.exec(Zn && Zn.keys && Zn.keys.IE_PROTO || "");
      return N ? "Symbol(src)_1." + N : "";
    }(), Mo = ar.toString, Fs = RegExp(
      "^" + $r.call(gn).replace(oe, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
    ), To = Ae ? Me.Buffer : void 0, In = Me.Symbol, ke = Me.Uint8Array, Re = ar.propertyIsEnumerable, Qt = Eo.splice, It = In ? In.toStringTag : void 0, on = Object.getOwnPropertySymbols, Tt = To ? To.isBuffer : void 0, Ge = Hn(Object.keys, Object), ct = kr(Me, "DataView"), bt = kr(Me, "Map"), Dn = kr(Me, "Promise"), En = kr(Me, "Set"), Jn = kr(Me, "WeakMap"), Bn = kr(Object, "create"), po = Pr(ct), Ai = Pr(bt), ia = Pr(Dn), Ns = Pr(En), Ls = Pr(Jn), as = In ? In.prototype : void 0, Wr = as ? as.valueOf : void 0;
    function ir(N) {
      var I = -1, H = N == null ? 0 : N.length;
      for (this.clear(); ++I < H; ) {
        var se = N[I];
        this.set(se[0], se[1]);
      }
    }
    function Di() {
      this.__data__ = Bn ? Bn(null) : {}, this.size = 0;
    }
    function Ei(N) {
      var I = this.has(N) && delete this.__data__[N];
      return this.size -= I ? 1 : 0, I;
    }
    function Va(N) {
      var I = this.__data__;
      if (Bn) {
        var H = I[N];
        return H === r ? void 0 : H;
      }
      return gn.call(I, N) ? I[N] : void 0;
    }
    function Mi(N) {
      var I = this.__data__;
      return Bn ? I[N] !== void 0 : gn.call(I, N);
    }
    function Po(N, I) {
      var H = this.__data__;
      return this.size += this.has(N) ? 0 : 1, H[N] = Bn && I === void 0 ? r : I, this;
    }
    ir.prototype.clear = Di, ir.prototype.delete = Ei, ir.prototype.get = Va, ir.prototype.has = Mi, ir.prototype.set = Po;
    function Un(N) {
      var I = -1, H = N == null ? 0 : N.length;
      for (this.clear(); ++I < H; ) {
        var se = N[I];
        this.set(se[0], se[1]);
      }
    }
    function Tu() {
      this.__data__ = [], this.size = 0;
    }
    function Ha(N) {
      var I = this.__data__, H = ls(I, N);
      if (H < 0)
        return !1;
      var se = I.length - 1;
      return H == se ? I.pop() : Qt.call(I, H, 1), --this.size, !0;
    }
    function is(N) {
      var I = this.__data__, H = ls(I, N);
      return H < 0 ? void 0 : I[H][1];
    }
    function ua(N) {
      return ls(this.__data__, N) > -1;
    }
    function xu(N, I) {
      var H = this.__data__, se = ls(H, N);
      return se < 0 ? (++this.size, H.push([N, I])) : H[se][1] = I, this;
    }
    Un.prototype.clear = Tu, Un.prototype.delete = Ha, Un.prototype.get = is, Un.prototype.has = ua, Un.prototype.set = xu;
    function er(N) {
      var I = -1, H = N == null ? 0 : N.length;
      for (this.clear(); ++I < H; ) {
        var se = N[I];
        this.set(se[0], se[1]);
      }
    }
    function Pi() {
      this.size = 0, this.__data__ = {
        hash: new ir(),
        map: new (bt || Un)(),
        string: new ir()
      };
    }
    function Ci(N) {
      var I = Co(this, N).delete(N);
      return this.size -= I ? 1 : 0, I;
    }
    function la(N) {
      return Co(this, N).get(N);
    }
    function Fc(N) {
      return Co(this, N).has(N);
    }
    function Oi(N, I) {
      var H = Co(this, N), se = H.size;
      return H.set(N, I), this.size += H.size == se ? 0 : 1, this;
    }
    er.prototype.clear = Pi, er.prototype.delete = Ci, er.prototype.get = la, er.prototype.has = Fc, er.prototype.set = Oi;
    function us(N) {
      var I = -1, H = N == null ? 0 : N.length;
      for (this.__data__ = new er(); ++I < H; )
        this.add(N[I]);
    }
    function _l(N) {
      return this.__data__.set(N, r), this;
    }
    function wl(N) {
      return this.__data__.has(N);
    }
    us.prototype.add = us.prototype.push = _l, us.prototype.has = wl;
    function br(N) {
      var I = this.__data__ = new Un(N);
      this.size = I.size;
    }
    function bl() {
      this.__data__ = new Un(), this.size = 0;
    }
    function Nc(N) {
      var I = this.__data__, H = I.delete(N);
      return this.size = I.size, H;
    }
    function Lc(N) {
      return this.__data__.get(N);
    }
    function Bc(N) {
      return this.__data__.has(N);
    }
    function kl(N, I) {
      var H = this.__data__;
      if (H instanceof Un) {
        var se = H.__data__;
        if (!bt || se.length < n - 1)
          return se.push([N, I]), this.size = ++H.size, this;
        H = this.__data__ = new er(se);
      }
      return H.set(N, I), this.size = H.size, this;
    }
    br.prototype.clear = bl, br.prototype.delete = Nc, br.prototype.get = Lc, br.prototype.has = Bc, br.prototype.set = kl;
    function Tl(N, I) {
      var H = cs(N), se = !H && Cl(N), Ne = !H && !se && da(N), Oe = !H && !se && !Ne && Ni(N), Je = H || se || Ne || Oe, ut = Je ? cn(N.length, String) : [], Ye = ut.length;
      for (var et in N)
        gn.call(N, et) && !(Je && // Safari 9 has enumerable `arguments.length` in strict mode.
        (et == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
        Ne && (et == "offset" || et == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
        Oe && (et == "buffer" || et == "byteLength" || et == "byteOffset") || // Skip index properties.
        El(et, Ye))) && ut.push(et);
      return ut;
    }
    function ls(N, I) {
      for (var H = N.length; H--; )
        if (Ga(N[H][0], I))
          return H;
      return -1;
    }
    function Su(N, I, H) {
      var se = I(N);
      return cs(N) ? se : tt(se, H(N));
    }
    function Vo(N) {
      return N == null ? N === void 0 ? X : b : It && It in Object(N) ? Al(N) : Au(N);
    }
    function Ii(N) {
      return jo(N) && Vo(N) == u;
    }
    function ca(N, I, H, se, Ne) {
      return N === I ? !0 : N == null || I == null || !jo(N) && !jo(I) ? N !== N && I !== I : ja(N, I, H, se, ca, Ne);
    }
    function ja(N, I, H, se, Ne, Oe) {
      var Je = cs(N), ut = cs(I), Ye = Je ? l : ur(N), et = ut ? l : ur(I);
      Ye = Ye == u ? x : Ye, et = et == u ? x : et;
      var Ft = Ye == x, en = et == x, jt = Ye == et;
      if (jt && da(N)) {
        if (!da(I))
          return !1;
        Je = !0, Ft = !1;
      }
      if (jt && !Ft)
        return Oe || (Oe = new br()), Je || Ni(N) ? pa(N, I, H, se, Ne, Oe) : Uc(N, I, Ye, H, se, Ne, Oe);
      if (!(H & o)) {
        var Kt = Ft && gn.call(N, "__wrapped__"), Tn = en && gn.call(I, "__wrapped__");
        if (Kt || Tn) {
          var lr = Kt ? N.value() : N, Tr = Tn ? I.value() : I;
          return Oe || (Oe = new br()), Ne(lr, Tr, H, se, Oe);
        }
      }
      return jt ? (Oe || (Oe = new br()), Rl(N, I, H, se, Ne, Oe)) : !1;
    }
    function Ru(N) {
      if (!Fi(N) || Pl(N))
        return !1;
      var I = Ho(N) ? Fs : ue;
      return I.test(Pr(N));
    }
    function xl(N) {
      return jo(N) && Eu(N.length) && !!pe[Vo(N)];
    }
    function Sl(N) {
      if (!qa(N))
        return Ge(N);
      var I = [];
      for (var H in Object(N))
        gn.call(N, H) && H != "constructor" && I.push(H);
      return I;
    }
    function pa(N, I, H, se, Ne, Oe) {
      var Je = H & o, ut = N.length, Ye = I.length;
      if (ut != Ye && !(Je && Ye > ut))
        return !1;
      var et = Oe.get(N);
      if (et && Oe.get(I))
        return et == I;
      var Ft = -1, en = !0, jt = H & s ? new us() : void 0;
      for (Oe.set(N, I), Oe.set(I, N); ++Ft < ut; ) {
        var Kt = N[Ft], Tn = I[Ft];
        if (se)
          var lr = Je ? se(Tn, Kt, Ft, I, N, Oe) : se(Kt, Tn, Ft, N, I, Oe);
        if (lr !== void 0) {
          if (lr)
            continue;
          en = !1;
          break;
        }
        if (jt) {
          if (!Ot(I, function(Tr, ho) {
            if (!Pn(jt, ho) && (Kt === Tr || Ne(Kt, Tr, H, se, Oe)))
              return jt.push(ho);
          })) {
            en = !1;
            break;
          }
        } else if (!(Kt === Tn || Ne(Kt, Tn, H, se, Oe))) {
          en = !1;
          break;
        }
      }
      return Oe.delete(N), Oe.delete(I), en;
    }
    function Uc(N, I, H, se, Ne, Oe, Je) {
      switch (H) {
        case W:
          if (N.byteLength != I.byteLength || N.byteOffset != I.byteOffset)
            return !1;
          N = N.buffer, I = I.buffer;
        case B:
          return !(N.byteLength != I.byteLength || !Oe(new ke(N), new ke(I)));
        case c:
        case p:
        case _:
          return Ga(+N, +I);
        case d:
          return N.name == I.name && N.message == I.message;
        case A:
        case M:
          return N == I + "";
        case g:
          var ut = sr;
        case C:
          var Ye = se & o;
          if (ut || (ut = sa), N.size != I.size && !Ye)
            return !1;
          var et = Je.get(N);
          if (et)
            return et == I;
          se |= s, Je.set(N, I);
          var Ft = pa(ut(N), ut(I), se, Ne, Oe, Je);
          return Je.delete(N), Ft;
        case L:
          if (Wr)
            return Wr.call(N) == Wr.call(I);
      }
      return !1;
    }
    function Rl(N, I, H, se, Ne, Oe) {
      var Je = H & o, ut = za(N), Ye = ut.length, et = za(I), Ft = et.length;
      if (Ye != Ft && !Je)
        return !1;
      for (var en = Ye; en--; ) {
        var jt = ut[en];
        if (!(Je ? jt in I : gn.call(I, jt)))
          return !1;
      }
      var Kt = Oe.get(N);
      if (Kt && Oe.get(I))
        return Kt == I;
      var Tn = !0;
      Oe.set(N, I), Oe.set(I, N);
      for (var lr = Je; ++en < Ye; ) {
        jt = ut[en];
        var Tr = N[jt], ho = I[jt];
        if (se)
          var Ol = Je ? se(ho, Tr, jt, I, N, Oe) : se(Tr, ho, jt, N, I, Oe);
        if (!(Ol === void 0 ? Tr === ho || Ne(Tr, ho, H, se, Oe) : Ol)) {
          Tn = !1;
          break;
        }
        lr || (lr = jt == "constructor");
      }
      if (Tn && !lr) {
        var ha = N.constructor, cr = I.constructor;
        ha != cr && "constructor" in N && "constructor" in I && !(typeof ha == "function" && ha instanceof ha && typeof cr == "function" && cr instanceof cr) && (Tn = !1);
      }
      return Oe.delete(N), Oe.delete(I), Tn;
    }
    function za(N) {
      return Su(N, Xc, Dl);
    }
    function Co(N, I) {
      var H = N.__data__;
      return Ml(I) ? H[typeof I == "string" ? "string" : "hash"] : H.map;
    }
    function kr(N, I) {
      var H = On(N, I);
      return Ru(H) ? H : void 0;
    }
    function Al(N) {
      var I = gn.call(N, It), H = N[It];
      try {
        N[It] = void 0;
        var se = !0;
      } catch {
      }
      var Ne = Mo.call(N);
      return se && (I ? N[It] = H : delete N[It]), Ne;
    }
    var Dl = on ? function(N) {
      return N == null ? [] : (N = Object(N), Ue(on(N), function(I) {
        return Re.call(N, I);
      }));
    } : Sn, ur = Vo;
    (ct && ur(new ct(new ArrayBuffer(1))) != W || bt && ur(new bt()) != g || Dn && ur(Dn.resolve()) != S || En && ur(new En()) != C || Jn && ur(new Jn()) != te) && (ur = function(N) {
      var I = Vo(N), H = I == x ? N.constructor : void 0, se = H ? Pr(H) : "";
      if (se)
        switch (se) {
          case po:
            return W;
          case Ai:
            return g;
          case ia:
            return S;
          case Ns:
            return C;
          case Ls:
            return te;
        }
      return I;
    });
    function El(N, I) {
      return I = I ?? i, !!I && (typeof N == "number" || me.test(N)) && N > -1 && N % 1 == 0 && N < I;
    }
    function Ml(N) {
      var I = typeof N;
      return I == "string" || I == "number" || I == "symbol" || I == "boolean" ? N !== "__proto__" : N === null;
    }
    function Pl(N) {
      return !!ko && ko in N;
    }
    function qa(N) {
      var I = N && N.constructor, H = typeof I == "function" && I.prototype || ar;
      return N === H;
    }
    function Au(N) {
      return Mo.call(N);
    }
    function Pr(N) {
      if (N != null) {
        try {
          return $r.call(N);
        } catch {
        }
        try {
          return N + "";
        } catch {
        }
      }
      return "";
    }
    function Ga(N, I) {
      return N === I || N !== N && I !== I;
    }
    var Cl = Ii(/* @__PURE__ */ function() {
      return arguments;
    }()) ? Ii : function(N) {
      return jo(N) && gn.call(N, "callee") && !Re.call(N, "callee");
    }, cs = Array.isArray;
    function Du(N) {
      return N != null && Eu(N.length) && !Ho(N);
    }
    var da = Tt || vn;
    function Bs(N, I) {
      return ca(N, I);
    }
    function Ho(N) {
      if (!Fi(N))
        return !1;
      var I = Vo(N);
      return I == h || I == m || I == a || I == E;
    }
    function Eu(N) {
      return typeof N == "number" && N > -1 && N % 1 == 0 && N <= i;
    }
    function Fi(N) {
      var I = typeof N;
      return N != null && (I == "object" || I == "function");
    }
    function jo(N) {
      return N != null && typeof N == "object";
    }
    var Ni = ze ? Xr(ze) : xl;
    function Xc(N) {
      return Du(N) ? Tl(N) : Sl(N);
    }
    function Sn() {
      return [];
    }
    function vn() {
      return !1;
    }
    t.exports = Bs;
  }(c0, c0.exports)), c0.exports;
}
var Kxe = Qxe();
const T6 = /* @__PURE__ */ iy(Kxe);
class $a {
  /** @param {Viewport} parent */
  constructor(e) {
    this.parent = e, this.paused = !1;
  }
  /** Called when plugin is removed */
  destroy() {
  }
  /** Handler for pointerdown PIXI event */
  down(e) {
    return !1;
  }
  /** Handler for pointermove PIXI event */
  move(e) {
    return !1;
  }
  /** Handler for pointerup PIXI event */
  up(e) {
    return !1;
  }
  /** Handler for wheel event on div */
  wheel(e) {
    return !1;
  }
  /**
   * Called on each tick
   * @param {number} elapsed time in millisecond since last update
   */
  update(e) {
  }
  /** Called when the viewport is resized */
  resize() {
  }
  /** Called when the viewport is manually moved */
  reset() {
  }
  /** Pause the plugin */
  pause() {
    this.paused = !0;
  }
  /** Un-pause the plugin */
  resume() {
    this.paused = !1;
  }
}
var Zxe = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Jxe(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var x6 = { exports: {} };
(function(t, e) {
  (function() {
    var n, r;
    r = function(o) {
      return t.exports = o;
    }, n = {
      linear: function(o, s, i, u) {
        return i * o / u + s;
      },
      easeInQuad: function(o, s, i, u) {
        return i * (o /= u) * o + s;
      },
      easeOutQuad: function(o, s, i, u) {
        return -i * (o /= u) * (o - 2) + s;
      },
      easeInOutQuad: function(o, s, i, u) {
        return (o /= u / 2) < 1 ? i / 2 * o * o + s : -i / 2 * (--o * (o - 2) - 1) + s;
      },
      easeInCubic: function(o, s, i, u) {
        return i * (o /= u) * o * o + s;
      },
      easeOutCubic: function(o, s, i, u) {
        return i * ((o = o / u - 1) * o * o + 1) + s;
      },
      easeInOutCubic: function(o, s, i, u) {
        return (o /= u / 2) < 1 ? i / 2 * o * o * o + s : i / 2 * ((o -= 2) * o * o + 2) + s;
      },
      easeInQuart: function(o, s, i, u) {
        return i * (o /= u) * o * o * o + s;
      },
      easeOutQuart: function(o, s, i, u) {
        return -i * ((o = o / u - 1) * o * o * o - 1) + s;
      },
      easeInOutQuart: function(o, s, i, u) {
        return (o /= u / 2) < 1 ? i / 2 * o * o * o * o + s : -i / 2 * ((o -= 2) * o * o * o - 2) + s;
      },
      easeInQuint: function(o, s, i, u) {
        return i * (o /= u) * o * o * o * o + s;
      },
      easeOutQuint: function(o, s, i, u) {
        return i * ((o = o / u - 1) * o * o * o * o + 1) + s;
      },
      easeInOutQuint: function(o, s, i, u) {
        return (o /= u / 2) < 1 ? i / 2 * o * o * o * o * o + s : i / 2 * ((o -= 2) * o * o * o * o + 2) + s;
      },
      easeInSine: function(o, s, i, u) {
        return -i * Math.cos(o / u * (Math.PI / 2)) + i + s;
      },
      easeOutSine: function(o, s, i, u) {
        return i * Math.sin(o / u * (Math.PI / 2)) + s;
      },
      easeInOutSine: function(o, s, i, u) {
        return -i / 2 * (Math.cos(Math.PI * o / u) - 1) + s;
      },
      easeInExpo: function(o, s, i, u) {
        return o === 0 ? s : i * Math.pow(2, 10 * (o / u - 1)) + s;
      },
      easeOutExpo: function(o, s, i, u) {
        return o === u ? s + i : i * (-Math.pow(2, -10 * o / u) + 1) + s;
      },
      easeInOutExpo: function(o, s, i, u) {
        return (o /= u / 2) < 1 ? i / 2 * Math.pow(2, 10 * (o - 1)) + s : i / 2 * (-Math.pow(2, -10 * --o) + 2) + s;
      },
      easeInCirc: function(o, s, i, u) {
        return -i * (Math.sqrt(1 - (o /= u) * o) - 1) + s;
      },
      easeOutCirc: function(o, s, i, u) {
        return i * Math.sqrt(1 - (o = o / u - 1) * o) + s;
      },
      easeInOutCirc: function(o, s, i, u) {
        return (o /= u / 2) < 1 ? -i / 2 * (Math.sqrt(1 - o * o) - 1) + s : i / 2 * (Math.sqrt(1 - (o -= 2) * o) + 1) + s;
      },
      easeInElastic: function(o, s, i, u) {
        var l, a, c;
        return c = 1.70158, a = 0, l = i, o === 0 || (o /= u), a || (a = u * 0.3), l < Math.abs(i) ? (l = i, c = a / 4) : c = a / (2 * Math.PI) * Math.asin(i / l), -(l * Math.pow(2, 10 * (o -= 1)) * Math.sin((o * u - c) * (2 * Math.PI) / a)) + s;
      },
      easeOutElastic: function(o, s, i, u) {
        var l, a, c;
        return c = 1.70158, a = 0, l = i, o === 0 || (o /= u), a || (a = u * 0.3), l < Math.abs(i) ? (l = i, c = a / 4) : c = a / (2 * Math.PI) * Math.asin(i / l), l * Math.pow(2, -10 * o) * Math.sin((o * u - c) * (2 * Math.PI) / a) + i + s;
      },
      easeInOutElastic: function(o, s, i, u) {
        var l, a, c;
        return c = 1.70158, a = 0, l = i, o === 0 || (o /= u / 2), a || (a = u * (0.3 * 1.5)), l < Math.abs(i) ? (l = i, c = a / 4) : c = a / (2 * Math.PI) * Math.asin(i / l), o < 1 ? -0.5 * (l * Math.pow(2, 10 * (o -= 1)) * Math.sin((o * u - c) * (2 * Math.PI) / a)) + s : l * Math.pow(2, -10 * (o -= 1)) * Math.sin((o * u - c) * (2 * Math.PI) / a) * 0.5 + i + s;
      },
      easeInBack: function(o, s, i, u, l) {
        return l === void 0 && (l = 1.70158), i * (o /= u) * o * ((l + 1) * o - l) + s;
      },
      easeOutBack: function(o, s, i, u, l) {
        return l === void 0 && (l = 1.70158), i * ((o = o / u - 1) * o * ((l + 1) * o + l) + 1) + s;
      },
      easeInOutBack: function(o, s, i, u, l) {
        return l === void 0 && (l = 1.70158), (o /= u / 2) < 1 ? i / 2 * (o * o * (((l *= 1.525) + 1) * o - l)) + s : i / 2 * ((o -= 2) * o * (((l *= 1.525) + 1) * o + l) + 2) + s;
      },
      easeInBounce: function(o, s, i, u) {
        var l;
        return l = n.easeOutBounce(u - o, 0, i, u), i - l + s;
      },
      easeOutBounce: function(o, s, i, u) {
        return (o /= u) < 1 / 2.75 ? i * (7.5625 * o * o) + s : o < 2 / 2.75 ? i * (7.5625 * (o -= 1.5 / 2.75) * o + 0.75) + s : o < 2.5 / 2.75 ? i * (7.5625 * (o -= 2.25 / 2.75) * o + 0.9375) + s : i * (7.5625 * (o -= 2.625 / 2.75) * o + 0.984375) + s;
      },
      easeInOutBounce: function(o, s, i, u) {
        var l;
        return o < u / 2 ? (l = n.easeInBounce(o * 2, 0, i, u), l * 0.5 + s) : (l = n.easeOutBounce(o * 2 - u, 0, i, u), l * 0.5 + i * 0.5 + s);
      }
    }, r(n);
  }).call(Zxe);
})(x6);
var e2e = x6.exports;
const dO = /* @__PURE__ */ Jxe(e2e);
function G_(t, e) {
  if (t) {
    if (typeof t == "function")
      return t;
    if (typeof t == "string")
      return dO[t];
  } else
    return dO[e];
}
const t2e = {
  removeOnInterrupt: !1,
  ease: "linear",
  time: 1e3
};
class n2e extends $a {
  /**
   * This is called by {@link Viewport.animate}.
   *
   * @param parent
   * @param options
   */
  constructor(e, n = {}) {
    super(e), this.startWidth = null, this.startHeight = null, this.deltaWidth = null, this.deltaHeight = null, this.width = null, this.height = null, this.time = 0, this.options = Object.assign({}, t2e, n), this.options.ease = G_(this.options.ease), this.setupPosition(), this.setupZoom(), this.time = 0;
  }
  /**
   * Setup `startX`, `startY`, `deltaX`, `deltaY`, `keepCenter`.
   *
   * This is called during construction.
   */
  setupPosition() {
    typeof this.options.position < "u" ? (this.startX = this.parent.center.x, this.startY = this.parent.center.y, this.deltaX = this.options.position.x - this.parent.center.x, this.deltaY = this.options.position.y - this.parent.center.y, this.keepCenter = !1) : this.keepCenter = !0;
  }
  /**
   * Setup `startWidth, `startHeight`, `deltaWidth, `deltaHeight, `width`, `height`.
   *
   * This is called during construction.
   */
  setupZoom() {
    this.width = null, this.height = null, typeof this.options.scale < "u" ? this.width = this.parent.screenWidth / this.options.scale : typeof this.options.scaleX < "u" || typeof this.options.scaleY < "u" ? (typeof this.options.scaleX < "u" && (this.width = this.parent.screenWidth / this.options.scaleX), typeof this.options.scaleY < "u" && (this.height = this.parent.screenHeight / this.options.scaleY)) : (typeof this.options.width < "u" && (this.width = this.options.width), typeof this.options.height < "u" && (this.height = this.options.height)), this.width !== null && (this.startWidth = this.parent.screenWidthInWorldPixels, this.deltaWidth = this.width - this.startWidth), this.height !== null && (this.startHeight = this.parent.screenHeightInWorldPixels, this.deltaHeight = this.height - this.startHeight);
  }
  down() {
    return this.options.removeOnInterrupt && this.parent.plugins.remove("animate"), !1;
  }
  complete() {
    this.parent.plugins.remove("animate"), this.width !== null && this.parent.fitWidth(this.width, this.keepCenter, this.height === null), this.height !== null && this.parent.fitHeight(this.height, this.keepCenter, this.width === null), !this.keepCenter && this.options.position && this.parent.moveCenter(this.options.position), this.parent.emit("animate-end", this.parent), this.options.callbackOnComplete && this.options.callbackOnComplete(this.parent);
  }
  update(e) {
    if (this.paused)
      return;
    this.time += e;
    const n = new Rt(this.parent.scale.x, this.parent.scale.y);
    if (this.time >= this.options.time) {
      const r = this.parent.width, o = this.parent.height;
      this.complete(), (r !== this.parent.width || o !== this.parent.height) && this.parent.emit("zoomed", { viewport: this.parent, original: n, type: "animate" });
    } else {
      const r = this.options.ease(this.time, 0, 1, this.options.time);
      if (this.width !== null) {
        const o = this.startWidth, s = this.deltaWidth;
        this.parent.fitWidth(
          o + s * r,
          this.keepCenter,
          this.height === null
        );
      }
      if (this.height !== null) {
        const o = this.startHeight, s = this.deltaHeight;
        this.parent.fitHeight(
          o + s * r,
          this.keepCenter,
          this.width === null
        );
      }
      if (this.width === null ? this.parent.scale.x = this.parent.scale.y : this.height === null && (this.parent.scale.y = this.parent.scale.x), !this.keepCenter) {
        const o = this.startX, s = this.startY, i = this.deltaX, u = this.deltaY, l = new Rt(this.parent.x, this.parent.y);
        this.parent.moveCenter(o + i * r, s + u * r), this.parent.emit("moved", { viewport: this.parent, original: l, type: "animate" });
      }
      (this.width || this.height) && this.parent.emit("zoomed", { viewport: this.parent, original: n, type: "animate" });
    }
  }
}
const r2e = {
  sides: "all",
  friction: 0.5,
  time: 150,
  ease: "easeInOutSine",
  underflow: "center",
  bounceBox: null
};
class o2e extends $a {
  /**
   * This is called by {@link Viewport.bounce}.
   */
  constructor(e, n = {}) {
    super(e), this.options = Object.assign({}, r2e, n), this.ease = G_(this.options.ease, "easeInOutSine"), this.options.sides ? this.options.sides === "all" ? this.top = this.bottom = this.left = this.right = !0 : this.options.sides === "horizontal" ? (this.right = this.left = !0, this.top = this.bottom = !1) : this.options.sides === "vertical" ? (this.left = this.right = !1, this.top = this.bottom = !0) : (this.top = this.options.sides.indexOf("top") !== -1, this.bottom = this.options.sides.indexOf("bottom") !== -1, this.left = this.options.sides.indexOf("left") !== -1, this.right = this.options.sides.indexOf("right") !== -1) : this.left = this.top = this.right = this.bottom = !1;
    const r = this.options.underflow.toLowerCase();
    r === "center" ? (this.underflowX = 0, this.underflowY = 0) : (this.underflowX = r.indexOf("left") !== -1 ? -1 : r.indexOf("right") !== -1 ? 1 : 0, this.underflowY = r.indexOf("top") !== -1 ? -1 : r.indexOf("bottom") !== -1 ? 1 : 0), this.reset();
  }
  isActive() {
    return this.toX !== null || this.toY !== null;
  }
  down() {
    return this.toX = this.toY = null, !1;
  }
  up() {
    return this.bounce(), !1;
  }
  update(e) {
    if (!this.paused) {
      if (this.bounce(), this.toX) {
        const n = this.toX;
        n.time += e, this.parent.emit("moved", { viewport: this.parent, type: "bounce-x" }), n.time >= this.options.time ? (this.parent.x = n.end, this.toX = null, this.parent.emit("bounce-x-end", this.parent)) : this.parent.x = this.ease(n.time, n.start, n.delta, this.options.time);
      }
      if (this.toY) {
        const n = this.toY;
        n.time += e, this.parent.emit("moved", { viewport: this.parent, type: "bounce-y" }), n.time >= this.options.time ? (this.parent.y = n.end, this.toY = null, this.parent.emit("bounce-y-end", this.parent)) : this.parent.y = this.ease(n.time, n.start, n.delta, this.options.time);
      }
    }
  }
  /** @internal */
  calcUnderflowX() {
    let e;
    switch (this.underflowX) {
      case -1:
        e = 0;
        break;
      case 1:
        e = this.parent.screenWidth - this.parent.screenWorldWidth;
        break;
      default:
        e = (this.parent.screenWidth - this.parent.screenWorldWidth) / 2;
    }
    return e;
  }
  /** @internal */
  calcUnderflowY() {
    let e;
    switch (this.underflowY) {
      case -1:
        e = 0;
        break;
      case 1:
        e = this.parent.screenHeight - this.parent.screenWorldHeight;
        break;
      default:
        e = (this.parent.screenHeight - this.parent.screenWorldHeight) / 2;
    }
    return e;
  }
  oob() {
    const e = this.options.bounceBox;
    if (e) {
      const n = typeof e.x > "u" ? 0 : e.x, r = typeof e.y > "u" ? 0 : e.y, o = typeof e.width > "u" ? this.parent.worldWidth : e.width, s = typeof e.height > "u" ? this.parent.worldHeight : e.height;
      return {
        left: this.parent.left < n,
        right: this.parent.right > o,
        top: this.parent.top < r,
        bottom: this.parent.bottom > s,
        topLeft: new Rt(
          n * this.parent.scale.x,
          r * this.parent.scale.y
        ),
        bottomRight: new Rt(
          o * this.parent.scale.x - this.parent.screenWidth,
          s * this.parent.scale.y - this.parent.screenHeight
        )
      };
    }
    return {
      left: this.parent.left < 0,
      right: this.parent.right > this.parent.worldWidth,
      top: this.parent.top < 0,
      bottom: this.parent.bottom > this.parent.worldHeight,
      topLeft: new Rt(0, 0),
      bottomRight: new Rt(
        this.parent.worldWidth * this.parent.scale.x - this.parent.screenWidth,
        this.parent.worldHeight * this.parent.scale.y - this.parent.screenHeight
      )
    };
  }
  bounce() {
    var e, n;
    if (this.paused)
      return;
    let r, o = this.parent.plugins.get("decelerate", !0);
    o && (o.x || o.y) && (o.x && o.percentChangeX === ((e = o.options) == null ? void 0 : e.friction) || o.y && o.percentChangeY === ((n = o.options) == null ? void 0 : n.friction)) && (r = this.oob(), (r.left && this.left || r.right && this.right) && (o.percentChangeX = this.options.friction), (r.top && this.top || r.bottom && this.bottom) && (o.percentChangeY = this.options.friction));
    const s = this.parent.plugins.get("drag", !0) || {}, i = this.parent.plugins.get("pinch", !0) || {};
    if (o = o || {}, !(s != null && s.active) && !(i != null && i.active) && (!this.toX || !this.toY) && (!o.x || !o.y)) {
      r = r || this.oob();
      const u = r.topLeft, l = r.bottomRight;
      if (!this.toX && !o.x) {
        let a = null;
        r.left && this.left ? a = this.parent.screenWorldWidth < this.parent.screenWidth ? this.calcUnderflowX() : -u.x : r.right && this.right && (a = this.parent.screenWorldWidth < this.parent.screenWidth ? this.calcUnderflowX() : -l.x), a !== null && this.parent.x !== a && (this.toX = { time: 0, start: this.parent.x, delta: a - this.parent.x, end: a }, this.parent.emit("bounce-x-start", this.parent));
      }
      if (!this.toY && !o.y) {
        let a = null;
        r.top && this.top ? a = this.parent.screenWorldHeight < this.parent.screenHeight ? this.calcUnderflowY() : -u.y : r.bottom && this.bottom && (a = this.parent.screenWorldHeight < this.parent.screenHeight ? this.calcUnderflowY() : -l.y), a !== null && this.parent.y !== a && (this.toY = { time: 0, start: this.parent.y, delta: a - this.parent.y, end: a }, this.parent.emit("bounce-y-start", this.parent));
      }
    }
  }
  reset() {
    this.toX = this.toY = null, this.bounce();
  }
}
const s2e = {
  left: !1,
  right: !1,
  top: !1,
  bottom: !1,
  direction: null,
  underflow: "center"
};
class a2e extends $a {
  /**
   * This is called by {@link Viewport.clamp}.
   */
  constructor(e, n = {}) {
    super(e), this.options = Object.assign({}, s2e, n), this.options.direction && (this.options.left = this.options.direction === "x" || this.options.direction === "all" ? !0 : null, this.options.right = this.options.direction === "x" || this.options.direction === "all" ? !0 : null, this.options.top = this.options.direction === "y" || this.options.direction === "all" ? !0 : null, this.options.bottom = this.options.direction === "y" || this.options.direction === "all" ? !0 : null), this.parseUnderflow(), this.last = { x: null, y: null, scaleX: null, scaleY: null }, this.update();
  }
  parseUnderflow() {
    const e = this.options.underflow.toLowerCase();
    e === "none" ? this.noUnderflow = !0 : e === "center" ? (this.underflowX = this.underflowY = 0, this.noUnderflow = !1) : (this.underflowX = e.indexOf("left") !== -1 ? -1 : e.indexOf("right") !== -1 ? 1 : 0, this.underflowY = e.indexOf("top") !== -1 ? -1 : e.indexOf("bottom") !== -1 ? 1 : 0, this.noUnderflow = !1);
  }
  move() {
    return this.update(), !1;
  }
  update() {
    if (this.paused || this.parent.x === this.last.x && this.parent.y === this.last.y && this.parent.scale.x === this.last.scaleX && this.parent.scale.y === this.last.scaleY)
      return;
    const e = new Rt(this.parent.x, this.parent.y), n = this.parent.plugins.decelerate || {};
    if (this.options.left !== null || this.options.right !== null) {
      let r = !1;
      if (!this.noUnderflow && this.parent.screenWorldWidth < this.parent.screenWidth)
        switch (this.underflowX) {
          case -1:
            this.parent.x !== 0 && (this.parent.x = 0, r = !0);
            break;
          case 1:
            this.parent.x !== this.parent.screenWidth - this.parent.screenWorldWidth && (this.parent.x = this.parent.screenWidth - this.parent.screenWorldWidth, r = !0);
            break;
          default:
            this.parent.x !== (this.parent.screenWidth - this.parent.screenWorldWidth) / 2 && (this.parent.x = (this.parent.screenWidth - this.parent.screenWorldWidth) / 2, r = !0);
        }
      else
        this.options.left !== null && this.parent.left < (this.options.left === !0 ? 0 : this.options.left) && (this.parent.x = -(this.options.left === !0 ? 0 : this.options.left) * this.parent.scale.x, n.x = 0, r = !0), this.options.right !== null && this.parent.right > (this.options.right === !0 ? this.parent.worldWidth : this.options.right) && (this.parent.x = -(this.options.right === !0 ? this.parent.worldWidth : this.options.right) * this.parent.scale.x + this.parent.screenWidth, n.x = 0, r = !0);
      r && this.parent.emit("moved", { viewport: this.parent, original: e, type: "clamp-x" });
    }
    if (this.options.top !== null || this.options.bottom !== null) {
      let r = !1;
      if (!this.noUnderflow && this.parent.screenWorldHeight < this.parent.screenHeight)
        switch (this.underflowY) {
          case -1:
            this.parent.y !== 0 && (this.parent.y = 0, r = !0);
            break;
          case 1:
            this.parent.y !== this.parent.screenHeight - this.parent.screenWorldHeight && (this.parent.y = this.parent.screenHeight - this.parent.screenWorldHeight, r = !0);
            break;
          default:
            this.parent.y !== (this.parent.screenHeight - this.parent.screenWorldHeight) / 2 && (this.parent.y = (this.parent.screenHeight - this.parent.screenWorldHeight) / 2, r = !0);
        }
      else
        this.options.top !== null && this.parent.top < (this.options.top === !0 ? 0 : this.options.top) && (this.parent.y = -(this.options.top === !0 ? 0 : this.options.top) * this.parent.scale.y, n.y = 0, r = !0), this.options.bottom !== null && this.parent.bottom > (this.options.bottom === !0 ? this.parent.worldHeight : this.options.bottom) && (this.parent.y = -(this.options.bottom === !0 ? this.parent.worldHeight : this.options.bottom) * this.parent.scale.y + this.parent.screenHeight, n.y = 0, r = !0);
      r && this.parent.emit("moved", { viewport: this.parent, original: e, type: "clamp-y" });
    }
    this.last.x = this.parent.x, this.last.y = this.parent.y, this.last.scaleX = this.parent.scale.x, this.last.scaleY = this.parent.scale.y;
  }
  reset() {
    this.update();
  }
}
const i2e = {
  minWidth: null,
  minHeight: null,
  maxWidth: null,
  maxHeight: null,
  minScale: null,
  maxScale: null
};
class u2e extends $a {
  /**
   * This is called by {@link Viewport.clampZoom}.
   */
  constructor(e, n = {}) {
    super(e), this.options = Object.assign({}, i2e, n), this.clamp();
  }
  resize() {
    this.clamp();
  }
  /** Clamp the viewport scale zoom) */
  clamp() {
    if (!this.paused) {
      if (this.options.minWidth || this.options.minHeight || this.options.maxWidth || this.options.maxHeight) {
        let e = this.parent.worldScreenWidth, n = this.parent.worldScreenHeight;
        if (this.options.minWidth !== null && e < this.options.minWidth) {
          const r = this.parent.scale.x;
          this.parent.fitWidth(this.options.minWidth, !1, !1, !0), this.parent.scale.y *= this.parent.scale.x / r, e = this.parent.worldScreenWidth, n = this.parent.worldScreenHeight, this.parent.emit("zoomed", { viewport: this.parent, type: "clamp-zoom" });
        }
        if (this.options.maxWidth !== null && e > this.options.maxWidth) {
          const r = this.parent.scale.x;
          this.parent.fitWidth(this.options.maxWidth, !1, !1, !0), this.parent.scale.y *= this.parent.scale.x / r, e = this.parent.worldScreenWidth, n = this.parent.worldScreenHeight, this.parent.emit("zoomed", { viewport: this.parent, type: "clamp-zoom" });
        }
        if (this.options.minHeight !== null && n < this.options.minHeight) {
          const r = this.parent.scale.y;
          this.parent.fitHeight(this.options.minHeight, !1, !1, !0), this.parent.scale.x *= this.parent.scale.y / r, e = this.parent.worldScreenWidth, n = this.parent.worldScreenHeight, this.parent.emit("zoomed", { viewport: this.parent, type: "clamp-zoom" });
        }
        if (this.options.maxHeight !== null && n > this.options.maxHeight) {
          const r = this.parent.scale.y;
          this.parent.fitHeight(this.options.maxHeight, !1, !1, !0), this.parent.scale.x *= this.parent.scale.y / r, this.parent.emit("zoomed", { viewport: this.parent, type: "clamp-zoom" });
        }
      } else if (this.options.minScale || this.options.maxScale) {
        const e = { x: null, y: null }, n = { x: null, y: null };
        if (typeof this.options.minScale == "number")
          e.x = this.options.minScale, e.y = this.options.minScale;
        else if (this.options.minScale !== null) {
          const s = this.options.minScale;
          e.x = typeof s.x > "u" ? null : s.x, e.y = typeof s.y > "u" ? null : s.y;
        }
        if (typeof this.options.maxScale == "number")
          n.x = this.options.maxScale, n.y = this.options.maxScale;
        else if (this.options.maxScale !== null) {
          const s = this.options.maxScale;
          n.x = typeof s.x > "u" ? null : s.x, n.y = typeof s.y > "u" ? null : s.y;
        }
        let r = this.parent.scale.x, o = this.parent.scale.y;
        e.x !== null && r < e.x && (r = e.x), n.x !== null && r > n.x && (r = n.x), e.y !== null && o < e.y && (o = e.y), n.y !== null && o > n.y && (o = n.y), (r !== this.parent.scale.x || o !== this.parent.scale.y) && (this.parent.scale.set(r, o), this.parent.emit("zoomed", { viewport: this.parent, type: "clamp-zoom" }));
      }
    }
  }
  reset() {
    this.clamp();
  }
}
const l2e = {
  friction: 0.98,
  bounce: 0.8,
  minSpeed: 0.01
}, Hl = 16;
class c2e extends $a {
  /**
   * This is called by {@link Viewport.decelerate}.
   */
  constructor(e, n = {}) {
    super(e), this.options = Object.assign({}, l2e, n), this.saved = [], this.timeSinceRelease = 0, this.reset(), this.parent.on("moved", (r) => this.handleMoved(r));
  }
  down() {
    return this.saved = [], this.x = this.y = null, !1;
  }
  isActive() {
    return !!(this.x || this.y);
  }
  move() {
    if (this.paused)
      return !1;
    const e = this.parent.input.count();
    return (e === 1 || e > 1 && !this.parent.plugins.get("pinch", !0)) && (this.saved.push({ x: this.parent.x, y: this.parent.y, time: performance.now() }), this.saved.length > 60 && this.saved.splice(0, 30)), !1;
  }
  /** Listener to viewport's "moved" event. */
  handleMoved(e) {
    if (this.saved.length) {
      const n = this.saved[this.saved.length - 1];
      e.type === "clamp-x" && e.original ? n.x === e.original.x && (n.x = this.parent.x) : e.type === "clamp-y" && e.original && n.y === e.original.y && (n.y = this.parent.y);
    }
  }
  up() {
    if (this.parent.input.count() === 0 && this.saved.length) {
      const e = performance.now();
      for (const n of this.saved)
        if (n.time >= e - 100) {
          const r = e - n.time;
          this.x = (this.parent.x - n.x) / r, this.y = (this.parent.y - n.y) / r, this.percentChangeX = this.percentChangeY = this.options.friction, this.timeSinceRelease = 0;
          break;
        }
    }
    return !1;
  }
  /**
   * Manually activate deceleration, starting from the (x, y) velocity components passed in the options.
   *
   * @param {object} options
   * @param {number} [options.x] - Specify x-component of initial velocity.
   * @param {number} [options.y] - Specify y-component of initial velocity.
   */
  activate(e) {
    e = e || {}, typeof e.x < "u" && (this.x = e.x, this.percentChangeX = this.options.friction), typeof e.y < "u" && (this.y = e.y, this.percentChangeY = this.options.friction);
  }
  update(e) {
    if (this.paused)
      return;
    const n = this.x || this.y, r = this.timeSinceRelease, o = this.timeSinceRelease + e;
    if (this.x) {
      const s = this.percentChangeX, i = Math.log(s);
      this.parent.x += this.x * Hl / i * (Math.pow(s, o / Hl) - Math.pow(s, r / Hl)), this.x *= Math.pow(this.percentChangeX, e / Hl);
    }
    if (this.y) {
      const s = this.percentChangeY, i = Math.log(s);
      this.parent.y += this.y * Hl / i * (Math.pow(s, o / Hl) - Math.pow(s, r / Hl)), this.y *= Math.pow(this.percentChangeY, e / Hl);
    }
    this.timeSinceRelease += e, this.x && this.y ? Math.abs(this.x) < this.options.minSpeed && Math.abs(this.y) < this.options.minSpeed && (this.x = 0, this.y = 0) : (Math.abs(this.x || 0) < this.options.minSpeed && (this.x = 0), Math.abs(this.y || 0) < this.options.minSpeed && (this.y = 0)), n && this.parent.emit("moved", { viewport: this.parent, type: "decelerate" });
  }
  reset() {
    this.x = this.y = null;
  }
}
const p2e = {
  direction: "all",
  pressDrag: !0,
  wheel: !0,
  wheelScroll: 1,
  reverse: !1,
  clampWheel: !1,
  underflow: "center",
  factor: 1,
  mouseButtons: "all",
  keyToPress: null,
  ignoreKeyToPressOnTouch: !1,
  lineHeight: 20,
  wheelSwapAxes: !1
};
class d2e extends $a {
  /**
   * This is called by {@link Viewport.drag}.
   */
  constructor(e, n = {}) {
    super(e), this.windowEventHandlers = [], this.options = Object.assign({}, p2e, n), this.moved = !1, this.reverse = this.options.reverse ? 1 : -1, this.xDirection = !this.options.direction || this.options.direction === "all" || this.options.direction === "x", this.yDirection = !this.options.direction || this.options.direction === "all" || this.options.direction === "y", this.keyIsPressed = !1, this.parseUnderflow(), this.mouseButtons(this.options.mouseButtons), this.options.keyToPress && this.handleKeyPresses(this.options.keyToPress);
  }
  /**
   * Handles keypress events and set the keyIsPressed boolean accordingly
   *
   * @param {array} codes - key codes that can be used to trigger drag event
   */
  handleKeyPresses(e) {
    const n = (o) => {
      e.includes(o.code) && (this.keyIsPressed = !0);
    }, r = (o) => {
      e.includes(o.code) && (this.keyIsPressed = !1);
    };
    this.addWindowEventHandler("keyup", r), this.addWindowEventHandler("keydown", n);
  }
  addWindowEventHandler(e, n) {
    typeof window > "u" || (window.addEventListener(e, n), this.windowEventHandlers.push({ event: e, handler: n }));
  }
  destroy() {
    typeof window > "u" || this.windowEventHandlers.forEach(({ event: e, handler: n }) => {
      window.removeEventListener(e, n);
    });
  }
  /**
   * initialize mousebuttons array
   * @param {string} buttons
   */
  mouseButtons(e) {
    !e || e === "all" ? this.mouse = [!0, !0, !0] : this.mouse = [
      e.indexOf("left") !== -1,
      e.indexOf("middle") !== -1,
      e.indexOf("right") !== -1
    ];
  }
  parseUnderflow() {
    const e = this.options.underflow.toLowerCase();
    e === "center" ? (this.underflowX = 0, this.underflowY = 0) : (e.includes("left") ? this.underflowX = -1 : e.includes("right") ? this.underflowX = 1 : this.underflowX = 0, e.includes("top") ? this.underflowY = -1 : e.includes("bottom") ? this.underflowY = 1 : this.underflowY = 0);
  }
  /**
   * @param {PIXI.FederatedPointerEvent} event
   * @returns {boolean}
   */
  checkButtons(e) {
    const n = e.pointerType === "mouse", r = this.parent.input.count();
    return !!((r === 1 || r > 1 && !this.parent.plugins.get("pinch", !0)) && (!n || this.mouse[e.button]));
  }
  /**
   * @param {PIXI.FederatedPointerEvent} event
   * @returns {boolean}
   */
  checkKeyPress(e) {
    return !this.options.keyToPress || this.keyIsPressed || this.options.ignoreKeyToPressOnTouch && e.data.pointerType === "touch";
  }
  down(e) {
    return this.paused || !this.options.pressDrag ? !1 : this.checkButtons(e) && this.checkKeyPress(e) ? (this.last = { x: e.global.x, y: e.global.y }, this.current = e.pointerId, !0) : (this.last = null, !1);
  }
  get active() {
    return this.moved;
  }
  move(e) {
    if (this.paused || !this.options.pressDrag)
      return !1;
    if (this.last && this.current === e.data.pointerId) {
      const n = e.global.x, r = e.global.y, o = this.parent.input.count();
      if (o === 1 || o > 1 && !this.parent.plugins.get("pinch", !0)) {
        const s = n - this.last.x, i = r - this.last.y;
        if (this.moved || this.xDirection && this.parent.input.checkThreshold(s) || this.yDirection && this.parent.input.checkThreshold(i)) {
          const u = { x: n, y: r };
          return this.xDirection && (this.parent.x += (u.x - this.last.x) * this.options.factor), this.yDirection && (this.parent.y += (u.y - this.last.y) * this.options.factor), this.last = u, this.moved || this.parent.emit("drag-start", {
            event: e,
            screen: new Rt(this.last.x, this.last.y),
            world: this.parent.toWorld(new Rt(this.last.x, this.last.y)),
            viewport: this.parent
          }), this.moved = !0, this.parent.emit("moved", { viewport: this.parent, type: "drag" }), !0;
        }
      } else
        this.moved = !1;
    }
    return !1;
  }
  up(e) {
    if (this.paused)
      return !1;
    const n = this.parent.input.touches;
    if (n.length === 1) {
      const r = n[0];
      return r.last && (this.last = { x: r.last.x, y: r.last.y }, this.current = r.id), this.moved = !1, !0;
    } else if (this.last && this.moved) {
      const r = new Rt(this.last.x, this.last.y);
      return this.parent.emit("drag-end", {
        event: e,
        screen: r,
        world: this.parent.toWorld(r),
        viewport: this.parent
      }), this.last = null, this.moved = !1, !0;
    }
    return !1;
  }
  wheel(e) {
    if (this.paused)
      return !1;
    if (this.options.wheel) {
      const n = this.parent.plugins.get("wheel", !0);
      if (!n || !n.options.wheelZoom && !e.ctrlKey) {
        const r = e.deltaMode ? this.options.lineHeight : 1, o = [e.deltaX, e.deltaY], [s, i] = this.options.wheelSwapAxes ? o.reverse() : o;
        return this.xDirection && (this.parent.x += s * r * this.options.wheelScroll * this.reverse), this.yDirection && (this.parent.y += i * r * this.options.wheelScroll * this.reverse), this.options.clampWheel && this.clamp(), this.parent.emit("wheel-scroll", this.parent), this.parent.emit("moved", { viewport: this.parent, type: "wheel" }), this.parent.options.passiveWheel || e.preventDefault(), this.parent.options.stopPropagation && e.stopPropagation(), !0;
      }
    }
    return !1;
  }
  resume() {
    this.last = null, this.paused = !1;
  }
  clamp() {
    const e = this.parent.plugins.get("decelerate", !0) || {};
    if (this.options.clampWheel !== "y")
      if (this.parent.screenWorldWidth < this.parent.screenWidth)
        switch (this.underflowX) {
          case -1:
            this.parent.x = 0;
            break;
          case 1:
            this.parent.x = this.parent.screenWidth - this.parent.screenWorldWidth;
            break;
          default:
            this.parent.x = (this.parent.screenWidth - this.parent.screenWorldWidth) / 2;
        }
      else
        this.parent.left < 0 ? (this.parent.x = 0, e.x = 0) : this.parent.right > this.parent.worldWidth && (this.parent.x = -this.parent.worldWidth * this.parent.scale.x + this.parent.screenWidth, e.x = 0);
    if (this.options.clampWheel !== "x")
      if (this.parent.screenWorldHeight < this.parent.screenHeight)
        switch (this.underflowY) {
          case -1:
            this.parent.y = 0;
            break;
          case 1:
            this.parent.y = this.parent.screenHeight - this.parent.screenWorldHeight;
            break;
          default:
            this.parent.y = (this.parent.screenHeight - this.parent.screenWorldHeight) / 2;
        }
      else
        this.parent.top < 0 && (this.parent.y = 0, e.y = 0), this.parent.bottom > this.parent.worldHeight && (this.parent.y = -this.parent.worldHeight * this.parent.scale.y + this.parent.screenHeight, e.y = 0);
  }
}
const h2e = {
  speed: 0,
  acceleration: null,
  radius: null
};
class f2e extends $a {
  /**
   * This is called by {@link Viewport.follow}.
   *
   * @param parent
   * @param target - target to follow
   * @param options
   */
  constructor(e, n, r = {}) {
    super(e), this.target = n, this.options = Object.assign({}, h2e, r), this.velocity = { x: 0, y: 0 };
  }
  update(e) {
    if (this.paused)
      return;
    const n = this.parent.center;
    let r = this.target.x, o = this.target.y;
    if (this.options.radius)
      if (Math.sqrt(Math.pow(this.target.y - n.y, 2) + Math.pow(this.target.x - n.x, 2)) > this.options.radius) {
        const u = Math.atan2(this.target.y - n.y, this.target.x - n.x);
        r = this.target.x - Math.cos(u) * this.options.radius, o = this.target.y - Math.sin(u) * this.options.radius;
      } else
        return;
    const s = r - n.x, i = o - n.y;
    if (s || i)
      if (this.options.speed)
        if (this.options.acceleration) {
          const u = Math.atan2(o - n.y, r - n.x), l = Math.sqrt(Math.pow(s, 2) + Math.pow(i, 2));
          if (l) {
            const a = (Math.pow(this.velocity.x, 2) + Math.pow(this.velocity.y, 2)) / (2 * this.options.acceleration);
            l > a ? this.velocity = {
              x: Math.min(this.velocity.x + (this.options.acceleration * e, this.options.speed)),
              y: Math.min(this.velocity.y + (this.options.acceleration * e, this.options.speed))
            } : this.velocity = {
              x: Math.max(this.velocity.x - this.options.acceleration * this.options.speed, 0),
              y: Math.max(this.velocity.y - this.options.acceleration * this.options.speed, 0)
            };
            const c = Math.cos(u) * this.velocity.x, p = Math.sin(u) * this.velocity.y, d = Math.abs(c) > Math.abs(s) ? r : n.x + c, h = Math.abs(p) > Math.abs(i) ? o : n.y + p;
            this.parent.moveCenter(d, h), this.parent.emit("moved", { viewport: this.parent, type: "follow" });
          }
        } else {
          const u = Math.atan2(o - n.y, r - n.x), l = Math.cos(u) * this.options.speed, a = Math.sin(u) * this.options.speed, c = Math.abs(l) > Math.abs(s) ? r : n.x + l, p = Math.abs(a) > Math.abs(i) ? o : n.y + a;
          this.parent.moveCenter(c, p), this.parent.emit("moved", { viewport: this.parent, type: "follow" });
        }
      else
        this.parent.moveCenter(r, o), this.parent.emit("moved", { viewport: this.parent, type: "follow" });
  }
}
const m2e = {
  radius: null,
  distance: null,
  top: null,
  bottom: null,
  left: null,
  right: null,
  speed: 8,
  reverse: !1,
  noDecelerate: !1,
  linear: !1,
  allowButtons: !1
};
class y2e extends $a {
  /**
   * This is called by {@link Viewport.mouseEdges}.
   */
  constructor(e, n = {}) {
    super(e), this.options = Object.assign({}, m2e, n), this.reverse = this.options.reverse ? 1 : -1, this.radiusSquared = typeof this.options.radius == "number" ? Math.pow(this.options.radius, 2) : null, this.resize();
  }
  resize() {
    const e = this.options.distance;
    e !== null ? (this.left = e, this.top = e, this.right = this.parent.screenWidth - e, this.bottom = this.parent.screenHeight - e) : this.options.radius || (this.left = this.options.left, this.top = this.options.top, this.right = this.options.right === null ? null : this.parent.screenWidth - this.options.right, this.bottom = this.options.bottom === null ? null : this.parent.screenHeight - this.options.bottom);
  }
  down() {
    return this.paused || this.options.allowButtons || (this.horizontal = this.vertical = null), !1;
  }
  move(e) {
    if (this.paused || e.pointerType !== "mouse" && e.pointerId !== 1 || !this.options.allowButtons && e.buttons !== 0)
      return !1;
    const n = e.global.x, r = e.global.y;
    if (this.radiusSquared) {
      const o = this.parent.toScreen(this.parent.center);
      if (Math.pow(o.x - n, 2) + Math.pow(o.y - r, 2) >= this.radiusSquared) {
        const s = Math.atan2(o.y - r, o.x - n);
        this.options.linear ? (this.horizontal = Math.round(Math.cos(s)) * this.options.speed * this.reverse * (60 / 1e3), this.vertical = Math.round(Math.sin(s)) * this.options.speed * this.reverse * (60 / 1e3)) : (this.horizontal = Math.cos(s) * this.options.speed * this.reverse * (60 / 1e3), this.vertical = Math.sin(s) * this.options.speed * this.reverse * (60 / 1e3));
      } else
        this.horizontal && this.decelerateHorizontal(), this.vertical && this.decelerateVertical(), this.horizontal = this.vertical = 0;
    } else
      this.left !== null && n < this.left ? this.horizontal = Number(this.reverse) * this.options.speed * (60 / 1e3) : this.right !== null && n > this.right ? this.horizontal = -1 * this.reverse * this.options.speed * (60 / 1e3) : (this.decelerateHorizontal(), this.horizontal = 0), this.top !== null && r < this.top ? this.vertical = Number(this.reverse) * this.options.speed * (60 / 1e3) : this.bottom !== null && r > this.bottom ? this.vertical = -1 * this.reverse * this.options.speed * (60 / 1e3) : (this.decelerateVertical(), this.vertical = 0);
    return !1;
  }
  decelerateHorizontal() {
    const e = this.parent.plugins.get("decelerate", !0);
    this.horizontal && e && !this.options.noDecelerate && e.activate({ x: this.horizontal * this.options.speed * this.reverse / (1e3 / 60) });
  }
  decelerateVertical() {
    const e = this.parent.plugins.get("decelerate", !0);
    this.vertical && e && !this.options.noDecelerate && e.activate({ y: this.vertical * this.options.speed * this.reverse / (1e3 / 60) });
  }
  up() {
    return this.paused || (this.horizontal && this.decelerateHorizontal(), this.vertical && this.decelerateVertical(), this.horizontal = this.vertical = null), !1;
  }
  update() {
    if (!this.paused && (this.horizontal || this.vertical)) {
      const e = this.parent.center;
      this.horizontal && (e.x += this.horizontal * this.options.speed), this.vertical && (e.y += this.vertical * this.options.speed), this.parent.moveCenter(e), this.parent.emit("moved", { viewport: this.parent, type: "mouse-edges" });
    }
  }
}
const g2e = {
  noDrag: !1,
  percent: 1,
  center: null,
  factor: 1,
  axis: "all"
};
class v2e extends $a {
  /**
   * This is called by {@link Viewport.pinch}.
   */
  constructor(e, n = {}) {
    super(e), this.active = !1, this.pinching = !1, this.moved = !1, this.options = Object.assign({}, g2e, n);
  }
  down() {
    return this.parent.input.count() >= 2 ? (this.active = !0, !0) : !1;
  }
  isAxisX() {
    return ["all", "x"].includes(this.options.axis);
  }
  isAxisY() {
    return ["all", "y"].includes(this.options.axis);
  }
  move(e) {
    if (this.paused || !this.active)
      return !1;
    const n = e.global.x, r = e.global.y, o = this.parent.input.touches;
    if (o.length >= 2) {
      const s = o[0], i = o[1], u = s.last && i.last ? Math.sqrt(Math.pow(i.last.x - s.last.x, 2) + Math.pow(i.last.y - s.last.y, 2)) : null;
      if (s.id === e.pointerId ? s.last = { x: n, y: r, data: e } : i.id === e.pointerId && (i.last = { x: n, y: r, data: e }), u) {
        let l;
        const a = new Rt(
          s.last.x + (i.last.x - s.last.x) / 2,
          s.last.y + (i.last.y - s.last.y) / 2
        );
        this.options.center || (l = this.parent.toLocal(a));
        let c = Math.sqrt(Math.pow(
          i.last.x - s.last.x,
          2
        ) + Math.pow(i.last.y - s.last.y, 2));
        c = c === 0 ? c = 1e-10 : c;
        const p = (1 - u / c) * this.options.percent * (this.isAxisX() ? this.parent.scale.x : this.parent.scale.y);
        this.isAxisX() && (this.parent.scale.x += p), this.isAxisY() && (this.parent.scale.y += p), this.parent.emit("zoomed", { viewport: this.parent, type: "pinch", center: a });
        const d = this.parent.plugins.get("clamp-zoom", !0);
        if (d && d.clamp(), this.options.center)
          this.parent.moveCenter(this.options.center);
        else {
          const h = this.parent.toGlobal(l);
          this.parent.x += (a.x - h.x) * this.options.factor, this.parent.y += (a.y - h.y) * this.options.factor, this.parent.emit("moved", { viewport: this.parent, type: "pinch" });
        }
        !this.options.noDrag && this.lastCenter && (this.parent.x += (a.x - this.lastCenter.x) * this.options.factor, this.parent.y += (a.y - this.lastCenter.y) * this.options.factor, this.parent.emit("moved", { viewport: this.parent, type: "pinch" })), this.lastCenter = a, this.moved = !0;
      } else
        this.pinching || (this.parent.emit("pinch-start", this.parent), this.pinching = !0);
      return !0;
    }
    return !1;
  }
  up() {
    return this.pinching && this.parent.input.touches.length <= 1 ? (this.active = !1, this.lastCenter = null, this.pinching = !1, this.moved = !1, this.parent.emit("pinch-end", this.parent), !0) : !1;
  }
}
const _2e = {
  topLeft: !1,
  friction: 0.8,
  time: 1e3,
  ease: "easeInOutSine",
  interrupt: !0,
  removeOnComplete: !1,
  removeOnInterrupt: !1,
  forceStart: !1
};
class w2e extends $a {
  /**
   * This is called by {@link Viewport.snap}.
   */
  constructor(e, n, r, o = {}) {
    super(e), this.options = Object.assign({}, _2e, o), this.ease = G_(o.ease, "easeInOutSine"), this.x = n, this.y = r, this.options.forceStart && this.snapStart();
  }
  snapStart() {
    this.percent = 0, this.snapping = { time: 0 };
    const e = this.options.topLeft ? this.parent.corner : this.parent.center;
    this.deltaX = this.x - e.x, this.deltaY = this.y - e.y, this.startX = e.x, this.startY = e.y, this.parent.emit("snap-start", this.parent);
  }
  wheel() {
    return this.options.removeOnInterrupt && this.parent.plugins.remove("snap"), !1;
  }
  down() {
    return this.options.removeOnInterrupt ? this.parent.plugins.remove("snap") : this.options.interrupt && (this.snapping = null), !1;
  }
  up() {
    if (this.parent.input.count() === 0) {
      const e = this.parent.plugins.get("decelerate", !0);
      e && (e.x || e.y) && (e.percentChangeX = e.percentChangeY = this.options.friction);
    }
    return !1;
  }
  update(e) {
    if (!this.paused && !(this.options.interrupt && this.parent.input.count() !== 0))
      if (this.snapping) {
        const n = this.snapping;
        n.time += e;
        let r, o, s;
        const i = this.startX, u = this.startY, l = this.deltaX, a = this.deltaY;
        if (n.time > this.options.time)
          r = !0, o = i + l, s = u + a;
        else {
          const c = this.ease(n.time, 0, 1, this.options.time);
          o = i + l * c, s = u + a * c;
        }
        this.options.topLeft ? this.parent.moveCorner(o, s) : this.parent.moveCenter(o, s), this.parent.emit("moved", { viewport: this.parent, type: "snap" }), r && (this.options.removeOnComplete && this.parent.plugins.remove("snap"), this.parent.emit("snap-end", this.parent), this.snapping = null);
      } else {
        const n = this.options.topLeft ? this.parent.corner : this.parent.center;
        (n.x !== this.x || n.y !== this.y) && this.snapStart();
      }
  }
}
const b2e = {
  width: 0,
  height: 0,
  time: 1e3,
  ease: "easeInOutSine",
  center: null,
  interrupt: !0,
  removeOnComplete: !1,
  removeOnInterrupt: !1,
  forceStart: !1,
  noMove: !1
};
class k2e extends $a {
  /**
   * This is called by {@link Viewport.snapZoom}.
   */
  constructor(e, n = {}) {
    super(e), this.options = Object.assign({}, b2e, n), this.ease = G_(this.options.ease), this.xIndependent = !1, this.yIndependent = !1, this.xScale = 0, this.yScale = 0, this.options.width > 0 && (this.xScale = e.screenWidth / this.options.width, this.xIndependent = !0), this.options.height > 0 && (this.yScale = e.screenHeight / this.options.height, this.yIndependent = !0), this.xScale = this.xIndependent ? this.xScale : this.yScale, this.yScale = this.yIndependent ? this.yScale : this.xScale, this.options.time === 0 ? (e.container.scale.x = this.xScale, e.container.scale.y = this.yScale, this.options.removeOnComplete && this.parent.plugins.remove("snap-zoom")) : n.forceStart && this.createSnapping();
  }
  createSnapping() {
    const e = this.parent.worldScreenWidth, n = this.parent.worldScreenHeight, r = this.parent.screenWidth / this.xScale, o = this.parent.screenHeight / this.yScale;
    this.snapping = {
      time: 0,
      startX: e,
      startY: n,
      deltaX: r - e,
      deltaY: o - n
    }, this.parent.emit("snap-zoom-start", this.parent);
  }
  resize() {
    this.snapping = null, this.options.width > 0 && (this.xScale = this.parent.screenWidth / this.options.width), this.options.height > 0 && (this.yScale = this.parent.screenHeight / this.options.height), this.xScale = this.xIndependent ? this.xScale : this.yScale, this.yScale = this.yIndependent ? this.yScale : this.xScale;
  }
  wheel() {
    return this.options.removeOnInterrupt && this.parent.plugins.remove("snap-zoom"), !1;
  }
  down() {
    return this.options.removeOnInterrupt ? this.parent.plugins.remove("snap-zoom") : this.options.interrupt && (this.snapping = null), !1;
  }
  update(e) {
    if (this.paused || this.options.interrupt && this.parent.input.count() !== 0)
      return;
    let n;
    if (!this.options.center && !this.options.noMove && (n = this.parent.center), !this.snapping)
      (this.parent.scale.x !== this.xScale || this.parent.scale.y !== this.yScale) && this.createSnapping();
    else if (this.snapping) {
      const r = this.snapping;
      if (r.time += e, r.time >= this.options.time)
        this.parent.scale.set(this.xScale, this.yScale), this.options.removeOnComplete && this.parent.plugins.remove("snap-zoom"), this.parent.emit("snap-zoom-end", this.parent), this.snapping = null;
      else {
        const s = this.snapping, i = this.ease(s.time, s.startX, s.deltaX, this.options.time), u = this.ease(s.time, s.startY, s.deltaY, this.options.time);
        this.parent.scale.x = this.parent.screenWidth / i, this.parent.scale.y = this.parent.screenHeight / u;
      }
      const o = this.parent.plugins.get("clamp-zoom", !0);
      o && o.clamp(), this.options.noMove || (this.options.center ? this.parent.moveCenter(this.options.center) : this.parent.moveCenter(n));
    }
  }
  resume() {
    this.snapping = null, super.resume();
  }
}
const T2e = {
  percent: 0.1,
  smooth: !1,
  interrupt: !0,
  reverse: !1,
  center: null,
  lineHeight: 20,
  axis: "all",
  keyToPress: null,
  trackpadPinch: !1,
  wheelZoom: !0
};
class x2e extends $a {
  /**
   * This is called by {@link Viewport.wheel}.
   */
  constructor(e, n = {}) {
    super(e), this.options = Object.assign({}, T2e, n), this.keyIsPressed = !1, this.options.keyToPress && this.handleKeyPresses(this.options.keyToPress);
  }
  /**
   * Handles keypress events and set the keyIsPressed boolean accordingly
   *
   * @param {array} codes - key codes that can be used to trigger zoom event
   */
  handleKeyPresses(e) {
    typeof window > "u" || (window.addEventListener("keydown", (n) => {
      e.includes(n.code) && (this.keyIsPressed = !0);
    }), window.addEventListener("keyup", (n) => {
      e.includes(n.code) && (this.keyIsPressed = !1);
    }));
  }
  checkKeyPress() {
    return !this.options.keyToPress || this.keyIsPressed;
  }
  down() {
    return this.options.interrupt && (this.smoothing = null), !1;
  }
  isAxisX() {
    return ["all", "x"].includes(this.options.axis);
  }
  isAxisY() {
    return ["all", "y"].includes(this.options.axis);
  }
  update() {
    if (this.smoothing) {
      const e = this.smoothingCenter, n = this.smoothing;
      let r;
      this.options.center || (r = this.parent.toLocal(e)), this.isAxisX() && (this.parent.scale.x += n.x), this.isAxisY() && (this.parent.scale.y += n.y), this.parent.emit("zoomed", { viewport: this.parent, type: "wheel" });
      const o = this.parent.plugins.get("clamp-zoom", !0);
      if (o && o.clamp(), this.options.center)
        this.parent.moveCenter(this.options.center);
      else {
        const s = this.parent.toGlobal(r);
        this.parent.x += e.x - s.x, this.parent.y += e.y - s.y;
      }
      this.parent.emit("moved", { viewport: this.parent, type: "wheel" }), this.smoothingCount++, this.smoothingCount >= this.options.smooth && (this.smoothing = null);
    }
  }
  pinch(e) {
    if (this.paused)
      return;
    const n = this.parent.input.getPointerPosition(e), r = -e.deltaY * (e.deltaMode ? this.options.lineHeight : 1) / 200, o = Math.pow(2, (1 + this.options.percent) * r);
    let s;
    this.options.center || (s = this.parent.toLocal(n)), this.isAxisX() && (this.parent.scale.x *= o), this.isAxisY() && (this.parent.scale.y *= o), this.parent.emit("zoomed", { viewport: this.parent, type: "wheel" });
    const i = this.parent.plugins.get("clamp-zoom", !0);
    if (i && i.clamp(), this.options.center)
      this.parent.moveCenter(this.options.center);
    else {
      const u = this.parent.toGlobal(s);
      this.parent.x += n.x - u.x, this.parent.y += n.y - u.y;
    }
    this.parent.emit("moved", { viewport: this.parent, type: "wheel" }), this.parent.emit(
      "wheel-start",
      { event: e, viewport: this.parent }
    );
  }
  wheel(e) {
    if (this.paused || !this.checkKeyPress())
      return !1;
    if (e.ctrlKey && this.options.trackpadPinch)
      this.pinch(e);
    else if (this.options.wheelZoom) {
      const n = this.parent.input.getPointerPosition(e), r = (this.options.reverse ? -1 : 1) * -e.deltaY * (e.deltaMode ? this.options.lineHeight : 1) / 500, o = Math.pow(2, (1 + this.options.percent) * r);
      if (this.options.smooth) {
        const s = {
          x: this.smoothing ? this.smoothing.x * (this.options.smooth - this.smoothingCount) : 0,
          y: this.smoothing ? this.smoothing.y * (this.options.smooth - this.smoothingCount) : 0
        };
        this.smoothing = {
          x: ((this.parent.scale.x + s.x) * o - this.parent.scale.x) / this.options.smooth,
          y: ((this.parent.scale.y + s.y) * o - this.parent.scale.y) / this.options.smooth
        }, this.smoothingCount = 0, this.smoothingCenter = n;
      } else {
        let s;
        this.options.center || (s = this.parent.toLocal(n)), this.isAxisX() && (this.parent.scale.x *= o), this.isAxisY() && (this.parent.scale.y *= o), this.parent.emit("zoomed", { viewport: this.parent, type: "wheel" });
        const i = this.parent.plugins.get("clamp-zoom", !0);
        if (i && i.clamp(), this.options.center)
          this.parent.moveCenter(this.options.center);
        else {
          const u = this.parent.toGlobal(s);
          this.parent.x += n.x - u.x, this.parent.y += n.y - u.y;
        }
      }
      this.parent.emit("moved", { viewport: this.parent, type: "wheel" }), this.parent.emit(
        "wheel-start",
        { event: e, viewport: this.parent }
      );
    }
    return !this.parent.options.passiveWheel;
  }
}
class S2e {
  constructor(e) {
    this.viewport = e, this.touches = [], this.addListeners();
  }
  /** Add input listeners */
  addListeners() {
    this.viewport.eventMode = "static", this.viewport.forceHitArea || (this.viewport.hitArea = new Pt(0, 0, this.viewport.worldWidth, this.viewport.worldHeight)), this.viewport.on("pointerdown", this.down, this), this.viewport.options.allowPreserveDragOutside ? this.viewport.on("globalpointermove", this.move, this) : this.viewport.on("pointermove", this.move, this), this.viewport.on("pointerup", this.up, this), this.viewport.on("pointerupoutside", this.up, this), this.viewport.on("pointercancel", this.up, this), this.viewport.options.allowPreserveDragOutside || this.viewport.on("pointerleave", this.up, this), this.wheelFunction = (e) => this.handleWheel(e), this.viewport.options.events.domElement.addEventListener(
      "wheel",
      this.wheelFunction,
      { passive: this.viewport.options.passiveWheel }
    ), this.isMouseDown = !1;
  }
  /**
   * Removes all event listeners from viewport
   * (useful for cleanup of wheel when removing viewport)
   */
  destroy() {
    var e;
    (e = this.viewport.options.events.domElement) == null || e.removeEventListener("wheel", this.wheelFunction);
  }
  /**
   * handle down events for viewport
   *
   * @param {PIXI.FederatedPointerEvent} event
   */
  down(e) {
    if (!(this.viewport.pause || !this.viewport.visible)) {
      if (e.pointerType === "mouse" ? this.isMouseDown = !0 : this.get(e.pointerId) || this.touches.push({ id: e.pointerId, last: null }), this.count() === 1) {
        this.last = e.global.clone();
        const n = this.viewport.plugins.get("decelerate", !0), r = this.viewport.plugins.get("bounce", !0);
        (!n || !n.isActive()) && (!r || !r.isActive()) ? this.clickedAvailable = !0 : this.clickedAvailable = !1;
      } else
        this.clickedAvailable = !1;
      this.viewport.plugins.down(e) && this.viewport.options.stopPropagation && e.stopPropagation();
    }
  }
  /** Clears all pointer events */
  clear() {
    this.isMouseDown = !1, this.touches = [], this.last = null;
  }
  /**
   * @param {number} change
   * @returns whether change exceeds threshold
   */
  checkThreshold(e) {
    return Math.abs(e) >= this.viewport.threshold;
  }
  /** Handle move events for viewport */
  move(e) {
    if (this.viewport.pause || !this.viewport.visible)
      return;
    const n = this.viewport.plugins.move(e);
    if (this.clickedAvailable && this.last) {
      const r = e.global.x - this.last.x, o = e.global.y - this.last.y;
      (this.checkThreshold(r) || this.checkThreshold(o)) && (this.clickedAvailable = !1);
    }
    n && this.viewport.options.stopPropagation && e.stopPropagation();
  }
  /** Handle up events for viewport */
  up(e) {
    if (this.viewport.pause || !this.viewport.visible)
      return;
    e.pointerType === "mouse" && (this.isMouseDown = !1), e.pointerType !== "mouse" && this.remove(e.pointerId);
    const n = this.viewport.plugins.up(e);
    this.clickedAvailable && this.count() === 0 && this.last && (this.viewport.emit("clicked", {
      event: e,
      screen: this.last,
      world: this.viewport.toWorld(this.last),
      viewport: this.viewport
    }), this.clickedAvailable = !1), n && this.viewport.options.stopPropagation && e.stopPropagation();
  }
  /** Gets pointer position if this.interaction is set */
  getPointerPosition(e) {
    const n = new Rt();
    return this.viewport.options.events.mapPositionToPoint(n, e.clientX, e.clientY), n;
  }
  /** Handle wheel events */
  handleWheel(e) {
    if (this.viewport.pause || !this.viewport.visible)
      return;
    const n = this.viewport.toLocal(this.getPointerPosition(e));
    this.viewport.left <= n.x && n.x <= this.viewport.right && this.viewport.top <= n.y && n.y <= this.viewport.bottom && this.viewport.plugins.wheel(e) && !this.viewport.options.passiveWheel && e.preventDefault();
  }
  pause() {
    this.touches = [], this.isMouseDown = !1;
  }
  /** Get touch by id */
  get(e) {
    for (const n of this.touches)
      if (n.id === e)
        return n;
    return null;
  }
  /** Remove touch by number */
  remove(e) {
    for (let n = 0; n < this.touches.length; n++)
      if (this.touches[n].id === e) {
        this.touches.splice(n, 1);
        return;
      }
  }
  /**
   * @returns {number} count of mouse/touch pointers that are down on the viewport
   */
  count() {
    return (this.isMouseDown ? 1 : 0) + this.touches.length;
  }
}
const bf = [
  "drag",
  "pinch",
  "wheel",
  "follow",
  "mouse-edges",
  "decelerate",
  "animate",
  "bounce",
  "snap-zoom",
  "clamp-zoom",
  "snap",
  "clamp"
];
class R2e {
  /** This is called by {@link Viewport} to initialize the {@link Viewport.plugins plugins}. */
  constructor(e) {
    this.viewport = e, this.list = [], this.plugins = {};
  }
  /**
   * Inserts a named plugin or a user plugin into the viewport
   * default plugin order: 'drag', 'pinch', 'wheel', 'follow', 'mouse-edges', 'decelerate', 'bounce',
   * 'snap-zoom', 'clamp-zoom', 'snap', 'clamp'
   *
   * @param {string} name of plugin
   * @param {Plugin} plugin - instantiated Plugin class
   * @param {number} index to insert userPlugin (otherwise inserts it at the end)
   */
  add(e, n, r = bf.length) {
    const o = this.plugins[e];
    o && o.destroy(), this.plugins[e] = n;
    const s = bf.indexOf(e);
    s !== -1 && bf.splice(s, 1), bf.splice(r, 0, e), this.sort();
  }
  /**
   * Get plugin
   *
   * @param {string} name of plugin
   * @param {boolean} [ignorePaused] return null if plugin is paused
   */
  get(e, n) {
    var r;
    return n && (r = this.plugins[e]) != null && r.paused ? null : this.plugins[e];
  }
  /**
   * Update all active plugins
   *
   * @internal
   * @ignore
   * @param {number} elapsed type in milliseconds since last update
   */
  update(e) {
    for (const n of this.list)
      n.update(e);
  }
  /**
   * Resize all active plugins
   *
   * @internal
   * @ignore
   */
  resize() {
    for (const e of this.list)
      e.resize();
  }
  /** Clamps and resets bounce and decelerate (as needed) after manually moving viewport */
  reset() {
    for (const e of this.list)
      e.reset();
  }
  /** removes all installed plugins */
  removeAll() {
    this.list.forEach((e) => {
      e.destroy();
    }), this.plugins = {}, this.sort();
  }
  /**
   * Removes installed plugin
   *
   * @param {string} name of plugin (e.g., 'drag', 'pinch')
   */
  remove(e) {
    var n;
    this.plugins[e] && ((n = this.plugins[e]) == null || n.destroy(), delete this.plugins[e], this.viewport.emit("plugin-remove", e), this.sort());
  }
  /**
   * Pause plugin
   *
   * @param {string} name of plugin (e.g., 'drag', 'pinch')
   */
  pause(e) {
    var n;
    (n = this.plugins[e]) == null || n.pause();
  }
  /**
   * Resume plugin
   *
   * @param {string} name of plugin (e.g., 'drag', 'pinch')
   */
  resume(e) {
    var n;
    (n = this.plugins[e]) == null || n.resume();
  }
  /**
   * Sort plugins according to PLUGIN_ORDER
   *
   * @internal
   * @ignore
   */
  sort() {
    this.list = [];
    for (const e of bf)
      this.plugins[e] && this.list.push(this.plugins[e]);
  }
  /**
   * Handle down for all plugins
   *
   * @internal
   * @ignore
   */
  down(e) {
    let n = !1;
    for (const r of this.list)
      r.down(e) && (n = !0);
    return n;
  }
  /**
   * Handle move for all plugins
   *
   * @internal
   * @ignore
   */
  move(e) {
    let n = !1;
    for (const r of this.viewport.plugins.list)
      r.move(e) && (n = !0);
    return n;
  }
  /**
   * Handle up for all plugins
   *
   * @internal
   * @ignore
   */
  up(e) {
    let n = !1;
    for (const r of this.list)
      r.up(e) && (n = !0);
    return n;
  }
  /**
   * Handle wheel event for all plugins
   *
   * @internal
   * @ignore
   */
  wheel(e) {
    let n = !1;
    for (const r of this.list)
      r.wheel(e) && (n = !0);
    return n;
  }
}
const A2e = {
  screenWidth: typeof window > "u" ? 0 : window.innerWidth,
  screenHeight: typeof window > "u" ? 0 : window.innerHeight,
  worldWidth: null,
  worldHeight: null,
  threshold: 5,
  passiveWheel: !0,
  stopPropagation: !1,
  forceHitArea: null,
  noTicker: !1,
  disableOnContextMenu: !1,
  ticker: es.shared,
  allowPreserveDragOutside: !1
};
class D2e extends fn {
  /**
   * @param {IViewportOptions} ViewportOptions
   * @param {number} [options.screenWidth=window.innerWidth]
   * @param {number} [options.screenHeight=window.innerHeight]
   * @param {number} [options.worldWidth=this.width]
   * @param {number} [options.worldHeight=this.height]
   * @param {number} [options.threshold=5] number of pixels to move to trigger an input event (e.g., drag, pinch)
   * or disable a clicked event
   * @param {boolean} [options.passiveWheel=true] whether the 'wheel' event is set to passive (note: if false,
   * e.preventDefault() will be called when wheel is used over the viewport)
   * @param {boolean} [options.stopPropagation=false] whether to stopPropagation of events that impact the viewport
   * (except wheel events, see options.passiveWheel)
   * @param {HitArea} [options.forceHitArea] change the default hitArea from world size to a new value
   * @param {boolean} [options.noTicker] set this if you want to manually call update() function on each frame
   * @param {PIXI.Ticker} [options.ticker=PIXI.Ticker.shared] use this PIXI.ticker for updates
   * @param {PIXI.EventSystem} [options.events] EventSystem available from app.events or added manually and passed here
   * location on screen
   * @param {boolean} [options.disableOnContextMenu] remove oncontextmenu=() => {} from the pixi's events.domElement
   */
  constructor(e) {
    super(), this._disableOnContextMenu = (n) => n.preventDefault(), this.options = {
      ...A2e,
      ...e
    }, this.screenWidth = this.options.screenWidth, this.screenHeight = this.options.screenHeight, this._worldWidth = this.options.worldWidth, this._worldHeight = this.options.worldHeight, this.forceHitArea = this.options.forceHitArea, this.threshold = this.options.threshold, this.options.disableOnContextMenu && this.options.events.domElement.addEventListener("contextmenu", this._disableOnContextMenu), this.options.noTicker || (this.tickerFunction = () => this.update(this.options.ticker.elapsedMS), this.options.ticker.add(this.tickerFunction)), this.input = new S2e(this), this.plugins = new R2e(this);
  }
  /** Overrides PIXI.Container's destroy to also remove the 'wheel' and PIXI.Ticker listeners */
  destroy(e) {
    var n;
    !this.options.noTicker && this.tickerFunction && this.options.ticker.remove(this.tickerFunction), this.options.disableOnContextMenu && ((n = this.options.events.domElement) == null || n.removeEventListener("contextmenu", this._disableOnContextMenu)), this.input.destroy(), super.destroy(e);
  }
  /**
   * Update viewport on each frame.
   *
   * By default, you do not need to call this unless you set `options.noTicker=true`.
   *
   * @param {number} elapsed time in milliseconds since last update
   */
  update(e) {
    this.pause || (this.plugins.update(e), this.lastViewport && (this.lastViewport.x !== this.x || this.lastViewport.y !== this.y ? this.moving = !0 : this.moving && (this.emit("moved-end", this), this.moving = !1), this.lastViewport.scaleX !== this.scale.x || this.lastViewport.scaleY !== this.scale.y ? this.zooming = !0 : this.zooming && (this.emit("zoomed-end", this), this.zooming = !1)), this.forceHitArea || (this._hitAreaDefault = new Pt(this.left, this.top, this.worldScreenWidth, this.worldScreenHeight), this.hitArea = this._hitAreaDefault), this._dirty = this._dirty || !this.lastViewport || this.lastViewport.x !== this.x || this.lastViewport.y !== this.y || this.lastViewport.scaleX !== this.scale.x || this.lastViewport.scaleY !== this.scale.y, this.lastViewport = {
      x: this.x,
      y: this.y,
      scaleX: this.scale.x,
      scaleY: this.scale.y
    }, this.emit("frame-end", this));
  }
  /**
   * Use this to set screen and world sizes, needed for pinch/wheel/clamp/bounce.
   * @param {number} screenWidth=window.innerWidth
   * @param {number} screenHeight=window.innerHeight
   * @param {number} [worldWidth]
   * @param {number} [worldHeight]
   */
  resize(e = typeof window > "u" ? 0 : window.innerWidth, n = typeof window > "u" ? 0 : window.innerHeight, r, o) {
    this.screenWidth = e, this.screenHeight = n, typeof r < "u" && (this._worldWidth = r), typeof o < "u" && (this._worldHeight = o), this.plugins.resize(), this.dirty = !0;
  }
  /** World width, in pixels */
  get worldWidth() {
    return this._worldWidth ? this._worldWidth : this.width / this.scale.x;
  }
  set worldWidth(e) {
    this._worldWidth = e, this.plugins.resize();
  }
  /** World height, in pixels */
  get worldHeight() {
    return this._worldHeight ? this._worldHeight : this.height / this.scale.y;
  }
  set worldHeight(e) {
    this._worldHeight = e, this.plugins.resize();
  }
  /** Get visible world bounds of viewport */
  getVisibleBounds() {
    return new Pt(this.left, this.top, this.worldScreenWidth, this.worldScreenHeight);
  }
  /**
   * Changes coordinate from screen to world
   * @param {number|PIXI.Point} x
   * @param {number} y
   * @returns {PIXI.Point}
   */
  toWorld(e, n) {
    return arguments.length === 2 ? this.toLocal(new Rt(e, n)) : this.toLocal(e);
  }
  /**
   * Changes coordinate from world to screen
   * @param {number|PIXI.Point} x
   * @param {number} y
   * @returns {PIXI.Point}
   */
  toScreen(e, n) {
    return arguments.length === 2 ? this.toGlobal(new Rt(e, n)) : this.toGlobal(e);
  }
  /** Screen width in world coordinates */
  get worldScreenWidth() {
    return this.screenWidth / this.scale.x;
  }
  /** Screen height in world coordinates */
  get worldScreenHeight() {
    return this.screenHeight / this.scale.y;
  }
  /** World width in screen coordinates */
  get screenWorldWidth() {
    return this.worldWidth * this.scale.x;
  }
  /** World height in screen coordinates */
  get screenWorldHeight() {
    return this.worldHeight * this.scale.y;
  }
  /** Center of screen in world coordinates */
  get center() {
    return new Rt(
      this.worldScreenWidth / 2 - this.x / this.scale.x,
      this.worldScreenHeight / 2 - this.y / this.scale.y
    );
  }
  set center(e) {
    this.moveCenter(e);
  }
  /**
   * Move center of viewport to (x, y)
   * @param {number|PIXI.Point} x
   * @param {number} [y]
   * @return {Viewport}
   */
  moveCenter(...e) {
    let n, r;
    typeof e[0] == "number" ? (n = e[0], r = e[1]) : (n = e[0].x, r = e[0].y);
    const o = (this.worldScreenWidth / 2 - n) * this.scale.x, s = (this.worldScreenHeight / 2 - r) * this.scale.y;
    return (this.x !== o || this.y !== s) && (this.position.set(o, s), this.plugins.reset(), this.dirty = !0), this;
  }
  /** Top-left corner of Viewport */
  get corner() {
    return new Rt(-this.x / this.scale.x, -this.y / this.scale.y);
  }
  set corner(e) {
    this.moveCorner(e);
  }
  /**
   * MoveCorner
   * @param {number|PIXI.Point} x
   * @param {number} [y]
   * @returns {Viewport}
   */
  moveCorner(...e) {
    let n, r;
    return e.length === 1 ? (n = -e[0].x * this.scale.x, r = -e[0].y * this.scale.y) : (n = -e[0] * this.scale.x, r = -e[1] * this.scale.y), (n !== this.x || r !== this.y) && (this.position.set(n, r), this.plugins.reset(), this.dirty = !0), this;
  }
  /** Get how many world pixels fit in screen's width */
  get screenWidthInWorldPixels() {
    return this.screenWidth / this.scale.x;
  }
  /** Get how many world pixels fit on screen's height */
  get screenHeightInWorldPixels() {
    return this.screenHeight / this.scale.y;
  }
  /**
   * Find the scale value that fits a world width on the screen
   * does not change the viewport (use fit... to change)
   *
   * @param width - Width in world pixels
   * @return - scale
   */
  findFitWidth(e) {
    return this.screenWidth / e;
  }
  /**
   * Finds the scale value that fits a world height on the screens
   * does not change the viewport (use fit... to change)
   *
   * @param height - Height in world pixels
   * @return - scale
   */
  findFitHeight(e) {
    return this.screenHeight / e;
  }
  /**
   * Finds the scale value that fits the smaller of a world width and world height on the screen
   * does not change the viewport (use fit... to change)
   *
   * @param {number} width in world pixels
   * @param {number} height in world pixels
   * @returns {number} scale
   */
  findFit(e, n) {
    const r = this.screenWidth / e, o = this.screenHeight / n;
    return Math.min(r, o);
  }
  /**
   * Finds the scale value that fits the larger of a world width and world height on the screen
   * does not change the viewport (use fit... to change)
   *
   * @param {number} width in world pixels
   * @param {number} height in world pixels
   * @returns {number} scale
   */
  findCover(e, n) {
    const r = this.screenWidth / e, o = this.screenHeight / n;
    return Math.max(r, o);
  }
  /**
   * Change zoom so the width fits in the viewport
   *
   * @param width - width in world coordinates
   * @param center - maintain the same center
   * @param scaleY - whether to set scaleY=scaleX
   * @param noClamp - whether to disable clamp-zoom
   * @returns {Viewport} this
   */
  fitWidth(e = this.worldWidth, n, r = !0, o) {
    let s;
    n && (s = this.center), this.scale.x = this.screenWidth / e, r && (this.scale.y = this.scale.x);
    const i = this.plugins.get("clamp-zoom", !0);
    return !o && i && i.clamp(), n && s && this.moveCenter(s), this;
  }
  /**
   * Change zoom so the height fits in the viewport
   *
   * @param {number} [height=this.worldHeight] in world coordinates
   * @param {boolean} [center] maintain the same center of the screen after zoom
   * @param {boolean} [scaleX=true] whether to set scaleX = scaleY
   * @param {boolean} [noClamp] whether to disable clamp-zoom
   * @returns {Viewport} this
   */
  fitHeight(e = this.worldHeight, n, r = !0, o) {
    let s;
    n && (s = this.center), this.scale.y = this.screenHeight / e, r && (this.scale.x = this.scale.y);
    const i = this.plugins.get("clamp-zoom", !0);
    return !o && i && i.clamp(), n && s && this.moveCenter(s), this;
  }
  /**
   * Change zoom so it fits the entire world in the viewport
   *
   * @param {boolean} center maintain the same center of the screen after zoom
   * @returns {Viewport} this
   */
  fitWorld(e) {
    let n;
    e && (n = this.center), this.scale.x = this.screenWidth / this.worldWidth, this.scale.y = this.screenHeight / this.worldHeight, this.scale.x < this.scale.y ? this.scale.y = this.scale.x : this.scale.x = this.scale.y;
    const r = this.plugins.get("clamp-zoom", !0);
    return r && r.clamp(), e && n && this.moveCenter(n), this;
  }
  /**
   * Change zoom so it fits the size or the entire world in the viewport
   *
   * @param {boolean} [center] maintain the same center of the screen after zoom
   * @param {number} [width=this.worldWidth] desired width
   * @param {number} [height=this.worldHeight] desired height
   * @returns {Viewport} this
   */
  fit(e, n = this.worldWidth, r = this.worldHeight) {
    let o;
    e && (o = this.center), this.scale.x = this.screenWidth / n, this.scale.y = this.screenHeight / r, this.scale.x < this.scale.y ? this.scale.y = this.scale.x : this.scale.x = this.scale.y;
    const s = this.plugins.get("clamp-zoom", !0);
    return s && s.clamp(), e && o && this.moveCenter(o), this;
  }
  /**
   * Zoom viewport to specific value.
   *
   * @param {number} scale value (e.g., 1 would be 100%, 0.25 would be 25%)
   * @param {boolean} [center] maintain the same center of the screen after zoom
   * @return {Viewport} this
   */
  setZoom(e, n) {
    let r;
    n && (r = this.center), this.scale.set(e);
    const o = this.plugins.get("clamp-zoom", !0);
    return o && o.clamp(), n && r && this.moveCenter(r), this;
  }
  /**
   * Zoom viewport by a certain percent (in both x and y direction).
   *
   * @param {number} percent change (e.g., 0.25 would increase a starting scale of 1.0 to 1.25)
   * @param {boolean} [center] maintain the same center of the screen after zoom
   * @return {Viewport} this
   */
  zoomPercent(e, n) {
    return this.setZoom(this.scale.x + this.scale.x * e, n);
  }
  /**
   * Zoom viewport by increasing/decreasing width by a certain number of pixels.
   *
   * @param {number} change in pixels
   * @param {boolean} [center] maintain the same center of the screen after zoom
   * @return {Viewport} this
   */
  zoom(e, n) {
    return this.fitWidth(e + this.worldScreenWidth, n), this;
  }
  /** Changes scale of viewport and maintains center of viewport */
  get scaled() {
    return this.scale.x;
  }
  set scaled(e) {
    this.setZoom(e, !0);
  }
  /**
   * Returns zoom to the desired scale
   *
   * @param {ISnapZoomOptions} options
   * @param {number} [options.width=0] - the desired width to snap (to maintain aspect ratio, choose width or height)
   * @param {number} [options.height=0] - the desired height to snap (to maintain aspect ratio, choose width or height)
   * @param {number} [options.time=1000] - time for snapping in ms
   * @param {(string|function)} [options.ease=easeInOutSine] ease function or name (see http://easings.net/
   *   for supported names)
   * @param {PIXI.Point} [options.center] - place this point at center during zoom instead of center of the viewport
   * @param {boolean} [options.interrupt=true] - pause snapping with any user input on the viewport
   * @param {boolean} [options.removeOnComplete] - removes this plugin after snapping is complete
   * @param {boolean} [options.removeOnInterrupt] - removes this plugin if interrupted by any user input
   * @param {boolean} [options.forceStart] - starts the snap immediately regardless of whether the viewport is at the
   *   desired zoom
   * @param {boolean} [options.noMove] - zoom but do not move
   */
  snapZoom(e) {
    return this.plugins.add("snap-zoom", new k2e(this, e)), this;
  }
  /** Is container out of world bounds */
  OOB() {
    return {
      left: this.left < 0,
      right: this.right > this.worldWidth,
      top: this.top < 0,
      bottom: this.bottom > this.worldHeight,
      cornerPoint: new Rt(
        this.worldWidth * this.scale.x - this.screenWidth,
        this.worldHeight * this.scale.y - this.screenHeight
      )
    };
  }
  /** World coordinates of the right edge of the screen */
  get right() {
    return -this.x / this.scale.x + this.worldScreenWidth;
  }
  set right(e) {
    this.x = -e * this.scale.x + this.screenWidth, this.plugins.reset();
  }
  /** World coordinates of the left edge of the screen */
  get left() {
    return -this.x / this.scale.x;
  }
  set left(e) {
    this.x = -e * this.scale.x, this.plugins.reset();
  }
  /** World coordinates of the top edge of the screen */
  get top() {
    return -this.y / this.scale.y;
  }
  set top(e) {
    this.y = -e * this.scale.y, this.plugins.reset();
  }
  /** World coordinates of the bottom edge of the screen */
  get bottom() {
    return -this.y / this.scale.y + this.worldScreenHeight;
  }
  set bottom(e) {
    this.y = -e * this.scale.y + this.screenHeight, this.plugins.reset();
  }
  /**
   * Determines whether the viewport is dirty (i.e., needs to be rendered to the screen because of a change)
   */
  get dirty() {
    return !!this._dirty;
  }
  set dirty(e) {
    this._dirty = e;
  }
  /**
   * Permanently changes the Viewport's hitArea
   *
   * NOTE: if not set then hitArea = PIXI.Rectangle(Viewport.left, Viewport.top, Viewport.worldScreenWidth,
   * Viewport.worldScreenHeight)
   */
  get forceHitArea() {
    return this._forceHitArea;
  }
  set forceHitArea(e) {
    e ? (this._forceHitArea = e, this.hitArea = e) : (this._forceHitArea = null, this.hitArea = new Pt(0, 0, this.worldWidth, this.worldHeight));
  }
  /**
   * Enable one-finger touch to drag
   *
   * NOTE: if you expect users to use right-click dragging, you should enable `viewport.options.disableOnContextMenu`
   * to avoid the context menu popping up on each right-click drag.
   *
   * @param {IDragOptions} [options]
   * @param {string} [options.direction=all] direction to drag
   * @param {boolean} [options.pressDrag=true] whether click to drag is active
   * @param {boolean} [options.wheel=true] use wheel to scroll in direction (unless wheel plugin is active)
   * @param {number} [options.wheelScroll=1] number of pixels to scroll with each wheel spin
   * @param {boolean} [options.reverse] reverse the direction of the wheel scroll
   * @param {(boolean|string)} [options.clampWheel=false] clamp wheel(to avoid weird bounce with mouse wheel)
   * @param {string} [options.underflow=center] where to place world if too small for screen
   * @param {number} [options.factor=1] factor to multiply drag to increase the speed of movement
   * @param {string} [options.mouseButtons=all] changes which mouse buttons trigger drag, use: 'all', 'left',
   *  'right' 'middle', or some combination, like, 'middle-right'; you may want to set
   *   viewport.options.disableOnContextMenu if you want to use right-click dragging
   * @param {string[]} [options.keyToPress=null] - array containing
   *  {@link key|https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/code} codes of keys that can be
   *  pressed for the drag to be triggered, e.g.: ['ShiftLeft', 'ShiftRight'}.
   * @param {boolean} [options.ignoreKeyToPressOnTouch=false] - ignore keyToPress for touch events
   * @param {number} [options.lineHeight=20] - scaling factor for non-DOM_DELTA_PIXEL scrolling events
   * @returns {Viewport} this
   */
  drag(e) {
    return this.plugins.add("drag", new d2e(this, e)), this;
  }
  /**
   * Clamp to world boundaries or other provided boundaries
   * There are three ways to clamp:
   * 1. direction: 'all' = the world is clamped to its world boundaries, ie, you cannot drag any part of offscreen
   *    direction: 'x' | 'y' = only the x or y direction is clamped to its world boundary
   * 2. left, right, top, bottom = true | number = the world is clamped to the world's pixel location for each side;
   *    if any of these are set to true, then the location is set to the boundary
   *    [0, viewport.worldWidth/viewport.worldHeight], eg: to allow the world to be completely dragged offscreen,
   *    set [-viewport.worldWidth, -viewport.worldHeight, viewport.worldWidth * 2, viewport.worldHeight * 2]
   *
   * Underflow determines what happens when the world is smaller than the viewport
   * 1. none = the world is clamped but there is no special behavior
   * 2. center = the world is centered on the viewport
   * 3. combination of top/bottom/center and left/right/center (case insensitive) = the world is stuck to the
   *     appropriate boundaries
   *
   * NOTES:
   *   clamp is disabled if called with no options; use { direction: 'all' } for all edge clamping
   *   screenWidth, screenHeight, worldWidth, and worldHeight needs to be set for this to work properly
   *
   * @param {object} [options]
   * @param {(number|boolean)} [options.left=false] - clamp left; true = 0
   * @param {(number|boolean)} [options.right=false] - clamp right; true = viewport.worldWidth
   * @param {(number|boolean)} [options.top=false] - clamp top; true = 0
   * @param {(number|boolean)} [options.bottom=false] - clamp bottom; true = viewport.worldHeight
   * @param {string} [direction] - (all, x, or y) using clamps of [0, viewport.worldWidth/viewport.worldHeight];
   *  replaces left/right/top/bottom if set
   * @param {string} [underflow=center] - where to place world if too small for screen (e.g., top-right, center,
   *  none, bottomLeft)     * @returns {Viewport} this
   */
  clamp(e) {
    return this.plugins.add("clamp", new a2e(this, e)), this;
  }
  /**
   * Decelerate after a move
   *
   * NOTE: this fires 'moved' event during deceleration
   *
   * @param {IDecelerateOptions} [options]
   * @param {number} [options.friction=0.95] - percent to decelerate after movement
   * @param {number} [options.bounce=0.8] - percent to decelerate when past boundaries (only applicable when
   *   viewport.bounce() is active)
   * @param {number} [options.minSpeed=0.01] - minimum velocity before stopping/reversing acceleration
   * @return {Viewport} this
   */
  decelerate(e) {
    return this.plugins.add("decelerate", new c2e(this, e)), this;
  }
  /**
   * Bounce on borders
   * NOTES:
   *    screenWidth, screenHeight, worldWidth, and worldHeight needs to be set for this to work properly
   *    fires 'moved', 'bounce-x-start', 'bounce-y-start', 'bounce-x-end', and 'bounce-y-end' events
   * @param {object} [options]
   * @param {string} [options.sides=all] - all, horizontal, vertical, or combination of top, bottom, right, left
   *  (e.g., 'top-bottom-right')
   * @param {number} [options.friction=0.5] - friction to apply to decelerate if active
   * @param {number} [options.time=150] - time in ms to finish bounce
   * @param {object} [options.bounceBox] - use this bounceBox instead of (0, 0, viewport.worldWidth, viewport.worldHeight)
   * @param {number} [options.bounceBox.x=0]
   * @param {number} [options.bounceBox.y=0]
   * @param {number} [options.bounceBox.width=viewport.worldWidth]
   * @param {number} [options.bounceBox.height=viewport.worldHeight]
   * @param {string|function} [options.ease=easeInOutSine] - ease function or name
   *  (see http://easings.net/ for supported names)
   * @param {string} [options.underflow=center] - (top/bottom/center and left/right/center, or center)
   *  where to place world if too small for screen
   * @return {Viewport} this
   */
  bounce(e) {
    return this.plugins.add("bounce", new o2e(this, e)), this;
  }
  /**
   * Enable pinch to zoom and two-finger touch to drag
   *
   * @param {PinchOptions} [options]
   * @param {boolean} [options.noDrag] - disable two-finger dragging
   * @param {number} [options.percent=1] - percent to modify pinch speed
   * @param {number} [options.factor=1] - factor to multiply two-finger drag to increase the speed of movement
   * @param {PIXI.Point} [options.center] - place this point at center during zoom instead of center of two fingers
   * @param {('all'|'x'|'y')} [options.axis=all] - axis to zoom
   * @return {Viewport} this
   */
  pinch(e) {
    return this.plugins.add("pinch", new v2e(this, e)), this;
  }
  /**
   * Snap to a point
   *
   * @param {number} x
   * @param {number} y
   * @param {ISnapOptions} [options]
   * @param {boolean} [options.topLeft] - snap to the top-left of viewport instead of center
   * @param {number} [options.friction=0.8] - friction/frame to apply if decelerate is active
   * @param {number} [options.time=1000] - time in ms to snap
   * @param {string|function} [options.ease=easeInOutSine] - ease function or name (see http://easings.net/
   *   for supported names)
   * @param {boolean} [options.interrupt=true] - pause snapping with any user input on the viewport
   * @param {boolean} [options.removeOnComplete] - removes this plugin after snapping is complete
   * @param {boolean} [options.removeOnInterrupt] - removes this plugin if interrupted by any user input
   * @param {boolean} [options.forceStart] - starts the snap immediately regardless of whether the viewport is at
   *   the desired location
   * @return {Viewport} this
   */
  snap(e, n, r) {
    return this.plugins.add("snap", new w2e(this, e, n, r)), this;
  }
  /**
   * Follow a target
   *
   * NOTES:
   *    uses the (x, y) as the center to follow; for PIXI.Sprite to work properly, use sprite.anchor.set(0.5)
   *    options.acceleration is not perfect as it doesn't know the velocity of the target. It adds acceleration
   *    to the start of movement and deceleration to the end of movement when the target is stopped.
   *    To cancel the follow, use: `viewport.plugins.remove('follow')`
   *
   * @fires 'moved' event
   *
   * @param {PIXI.DisplayObject} target to follow
   * @param {IFollowOptions} [options]
   * @param {number} [options.speed=0] - to follow in pixels/frame (0=teleport to location)
   * @param {number} [options.acceleration] - set acceleration to accelerate and decelerate at this rate; speed
   *   cannot be 0 to use acceleration
   * @param {number} [options.radius] - radius (in world coordinates) of center circle where movement is allowed
   *   without moving the viewport     * @returns {Viewport} this
   * @returns {Viewport} this
   */
  follow(e, n) {
    return this.plugins.add("follow", new f2e(this, e, n)), this;
  }
  /**
   * Zoom using mouse wheel
   *
   * NOTE: the default event listener for 'wheel' event is the options.events.domElement.
   *
   * @param {IWheelOptions} [options]
   * @param {number} [options.percent=0.1] - percent to scroll with each spin
   * @param {number} [options.smooth] - smooth the zooming by providing the number of frames to zoom between wheel spins
   * @param {boolean} [options.interrupt=true] - stop smoothing with any user input on the viewport
   * @param {boolean} [options.reverse] - reverse the direction of the scroll
   * @param {PIXI.Point} [options.center] - place this point at center during zoom instead of current mouse position
   * @param {number} [options.lineHeight=20] - scaling factor for non-DOM_DELTA_PIXEL scrolling events
   * @param {('all'|'x'|'y')} [options.axis=all] - axis to zoom
   * @return {Viewport} this
   */
  wheel(e) {
    return this.plugins.add("wheel", new x2e(this, e)), this;
  }
  /**
   * Animate the position and/or scale of the viewport
   * To set the zoom level, use: (1) scale, (2) scaleX and scaleY, or (3) width and/or height
   * @param {object} options
   * @param {number} [options.time=1000] - time to animate
   * @param {PIXI.Point} [options.position=viewport.center] - position to move viewport
   * @param {number} [options.width] - desired viewport width in world pixels (use instead of scale;
   *  aspect ratio is maintained if height is not provided)
   * @param {number} [options.height] - desired viewport height in world pixels (use instead of scale;
   *  aspect ratio is maintained if width is not provided)
   * @param {number} [options.scale] - scale to change zoom (scale.x = scale.y)
   * @param {number} [options.scaleX] - independently change zoom in x-direction
   * @param {number} [options.scaleY] - independently change zoom in y-direction
   * @param {(function|string)} [options.ease=linear] - easing function to use
   * @param {function} [options.callbackOnComplete]
   * @param {boolean} [options.removeOnInterrupt] removes this plugin if interrupted by any user input
   * @returns {Viewport} this
   */
  animate(e) {
    return this.plugins.add("animate", new n2e(this, e)), this;
  }
  /**
   * Enable clamping of zoom to constraints
   *
   * The minWidth/Height settings are how small the world can get (as it would appear on the screen)
   * before clamping. The maxWidth/maxHeight is how larger the world can scale (as it would appear on
   * the screen) before clamping.
   *
   * For example, if you have a world size of 1000 x 1000 and a screen size of 100 x 100, if you set
   * minWidth/Height = 100 then the world will not be able to zoom smaller than the screen size (ie,
   * zooming out so it appears smaller than the screen). Similarly, if you set maxWidth/Height = 100
   * the world will not be able to zoom larger than the screen size (ie, zooming in so it appears
   * larger than the screen).
   *
   * @param {object} [options]
   * @param {number} [options.minWidth] - minimum width
   * @param {number} [options.minHeight] - minimum height
   * @param {number} [options.maxWidth] - maximum width
   * @param {number} [options.maxHeight] - maximum height
   * @param {number} [options.minScale] - minimum scale
   * @param {number} [options.maxScale] - minimum scale
   * @return {Viewport} this
   */
  clampZoom(e) {
    return this.plugins.add("clamp-zoom", new u2e(this, e)), this;
  }
  /**
   * Scroll viewport when mouse hovers near one of the edges or radius-distance from center of screen.
   *
   * NOTES: fires 'moved' event; there's a known bug where the mouseEdges does not work properly with "windowed" viewports
   *
   * @param {IMouseEdgesOptions} [options]
   * @param {number} [options.radius] - distance from center of screen in screen pixels
   * @param {number} [options.distance] - distance from all sides in screen pixels
   * @param {number} [options.top] - alternatively, set top distance (leave unset for no top scroll)
   * @param {number} [options.bottom] - alternatively, set bottom distance (leave unset for no top scroll)
   * @param {number} [options.left] - alternatively, set left distance (leave unset for no top scroll)
   * @param {number} [options.right] - alternatively, set right distance (leave unset for no top scroll)
   * @param {number} [options.speed=8] - speed in pixels/frame to scroll viewport
   * @param {boolean} [options.reverse] - reverse direction of scroll
   * @param {boolean} [options.noDecelerate] - don't use decelerate plugin even if it's installed
   * @param {boolean} [options.linear] - if using radius, use linear movement (+/- 1, +/- 1) instead of angled
   *   movement (Math.cos(angle from center), Math.sin(angle from center))
   * @param {boolean} [options.allowButtons] allows plugin to continue working even when there's a mousedown event
   */
  mouseEdges(e) {
    return this.plugins.add("mouse-edges", new y2e(this, e)), this;
  }
  /** Pause viewport (including animation updates such as decelerate) */
  get pause() {
    return !!this._pause;
  }
  set pause(e) {
    this._pause = e, this.lastViewport = null, this.moving = !1, this.zooming = !1, e && this.input.pause();
  }
  /**
   * Move the viewport so the bounding box is visible
   *
   * @param x - left
   * @param y - top
   * @param width
   * @param height
   * @param resizeToFit - Resize the viewport so the box fits within the viewport
   */
  ensureVisible(e, n, r, o, s) {
    s && (r > this.worldScreenWidth || o > this.worldScreenHeight) && (this.fit(!0, r, o), this.emit("zoomed", { viewport: this, type: "ensureVisible" }));
    let i = !1;
    e < this.left ? (this.left = e, i = !0) : e + r > this.right && (this.right = e + r, i = !0), n < this.top ? (this.top = n, i = !0) : n + o > this.bottom && (this.bottom = n + o, i = !0), i && this.emit("moved", { viewport: this, type: "ensureVisible" });
  }
}
const p0 = 1e3, hO = Symbol.for("constructDateFrom");
async function S6(t, e) {
  const n = await oa();
  let r, o = null;
  async function s() {
    try {
      o = await n.fetch(t), e(o);
    } catch (u) {
      console.error(u);
    }
    o && !o.end_time && (r = setTimeout(() => s(), E2e(o)));
  }
  function i() {
    clearTimeout(r);
  }
  return {
    start: s,
    stop: i
  };
}
function E2e(t) {
  const e = Math.floor(t.nodes.size / p0) * p0;
  return Math.max(p0, e);
}
function ju(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function R6(t, e) {
  t.prototype = Object.create(e.prototype), t.prototype.constructor = t, t.__proto__ = e;
}
/*!
 * GSAP 3.12.5
 * https://gsap.com
 *
 * @license Copyright 2008-2024, GreenSock. All rights reserved.
 * Subject to the terms at https://gsap.com/standard-license or for
 * Club GSAP members, the agreement issued with that membership.
 * @author: Jack Doyle, jack@greensock.com
*/
var ea = {
  autoSleep: 120,
  force3D: "auto",
  nullTargetWarn: 1,
  units: {
    lineHeight: ""
  }
}, _h = {
  duration: 0.5,
  overwrite: !1,
  delay: 0
}, OS, Lo, rr, Ea = 1e8, jn = 1 / Ea, IT = Math.PI * 2, M2e = IT / 4, P2e = 0, A6 = Math.sqrt, C2e = Math.cos, O2e = Math.sin, wo = function(t) {
  return typeof t == "string";
}, Ar = function(t) {
  return typeof t == "function";
}, il = function(t) {
  return typeof t == "number";
}, IS = function(t) {
  return typeof t > "u";
}, gu = function(t) {
  return typeof t == "object";
}, ks = function(t) {
  return t !== !1;
}, FS = function() {
  return typeof window < "u";
}, Ig = function(t) {
  return Ar(t) || wo(t);
}, D6 = typeof ArrayBuffer == "function" && ArrayBuffer.isView || function() {
}, Bo = Array.isArray, FT = /(?:-?\.?\d|\.)+/gi, E6 = /[-+=.]*\d+[.e\-+]*\d*[e\-+]*\d*/g, Bd = /[-+=.]*\d+[.e-]*\d*[a-z%]*/g, Ib = /[-+=.]*\d+\.?\d*(?:e-|e\+)?\d*/gi, M6 = /[+-]=-?[.\d]+/, P6 = /[^,'"\[\]\s]+/gi, I2e = /^[+\-=e\s\d]*\d+[.\d]*([a-z]*|%)\s*$/i, fr, qi, NT, NS, ta = {}, gv = {}, C6, O6 = function(t) {
  return (gv = $p(t, ta)) && Es;
}, LS = function(t, e) {
  return console.warn("Invalid property", t, "set to", e, "Missing plugin? gsap.registerPlugin()");
}, gm = function(t, e) {
  return !e && console.warn(t);
}, I6 = function(t, e) {
  return t && (ta[t] = e) && gv && (gv[t] = e) || ta;
}, vm = function() {
  return 0;
}, F2e = {
  suppressEvents: !0,
  isStart: !0,
  kill: !1
}, d0 = {
  suppressEvents: !0,
  kill: !1
}, N2e = {
  suppressEvents: !0
}, BS = {}, cc = [], LT = {}, F6, zs = {}, Fb = {}, fO = 30, h0 = [], US = "", XS = function(t) {
  var e = t[0], n, r;
  if (gu(e) || Ar(e) || (t = [t]), !(n = (e._gsap || {}).harness)) {
    for (r = h0.length; r-- && !h0[r].targetTest(e); )
      ;
    n = h0[r];
  }
  for (r = t.length; r--; )
    t[r] && (t[r]._gsap || (t[r]._gsap = new s5(t[r], n))) || t.splice(r, 1);
  return t;
}, Rp = function(t) {
  return t._gsap || XS(Ma(t))[0]._gsap;
}, N6 = function(t, e, n) {
  return (n = t[e]) && Ar(n) ? t[e]() : IS(n) && t.getAttribute && t.getAttribute(e) || n;
}, Ts = function(t, e) {
  return (t = t.split(",")).forEach(e) || t;
}, Ir = function(t) {
  return Math.round(t * 1e5) / 1e5 || 0;
}, go = function(t) {
  return Math.round(t * 1e7) / 1e7 || 0;
}, Zd = function(t, e) {
  var n = e.charAt(0), r = parseFloat(e.substr(2));
  return t = parseFloat(t), n === "+" ? t + r : n === "-" ? t - r : n === "*" ? t * r : t / r;
}, L2e = function(t, e) {
  for (var n = e.length, r = 0; t.indexOf(e[r]) < 0 && ++r < n; )
    ;
  return r < n;
}, vv = function() {
  var t = cc.length, e = cc.slice(0), n, r;
  for (LT = {}, cc.length = 0, n = 0; n < t; n++)
    r = e[n], r && r._lazy && (r.render(r._lazy[0], r._lazy[1], !0)._lazy = 0);
}, L6 = function(t, e, n, r) {
  cc.length && !Lo && vv(), t.render(e, n, Lo && e < 0 && (t._initted || t._startAt)), cc.length && !Lo && vv();
}, B6 = function(t) {
  var e = parseFloat(t);
  return (e || e === 0) && (t + "").match(P6).length < 2 ? e : wo(t) ? t.trim() : t;
}, U6 = function(t) {
  return t;
}, La = function(t, e) {
  for (var n in e)
    n in t || (t[n] = e[n]);
  return t;
}, B2e = function(t) {
  return function(e, n) {
    for (var r in n)
      r in e || r === "duration" && t || r === "ease" || (e[r] = n[r]);
  };
}, $p = function(t, e) {
  for (var n in e)
    t[n] = e[n];
  return t;
}, mO = function t(e, n) {
  for (var r in n)
    r !== "__proto__" && r !== "constructor" && r !== "prototype" && (e[r] = gu(n[r]) ? t(e[r] || (e[r] = {}), n[r]) : n[r]);
  return e;
}, _v = function(t, e) {
  var n = {}, r;
  for (r in t)
    r in e || (n[r] = t[r]);
  return n;
}, em = function(t) {
  var e = t.parent || fr, n = t.keyframes ? B2e(Bo(t.keyframes)) : La;
  if (ks(t.inherit))
    for (; e; )
      n(t, e.vars.defaults), e = e.parent || e._dp;
  return t;
}, U2e = function(t, e) {
  for (var n = t.length, r = n === e.length; r && n-- && t[n] === e[n]; )
    ;
  return n < 0;
}, X6 = function(t, e, n, r, o) {
  var s = t[r], i;
  if (o)
    for (i = e[o]; s && s[o] > i; )
      s = s._prev;
  return s ? (e._next = s._next, s._next = e) : (e._next = t[n], t[n] = e), e._next ? e._next._prev = e : t[r] = e, e._prev = s, e.parent = e._dp = t, e;
}, Y_ = function(t, e, n, r) {
  n === void 0 && (n = "_first"), r === void 0 && (r = "_last");
  var o = e._prev, s = e._next;
  o ? o._next = s : t[n] === e && (t[n] = s), s ? s._prev = o : t[r] === e && (t[r] = o), e._next = e._prev = e.parent = null;
}, wc = function(t, e) {
  t.parent && (!e || t.parent.autoRemoveChildren) && t.parent.remove && t.parent.remove(t), t._act = 0;
}, Ap = function(t, e) {
  if (t && (!e || e._end > t._dur || e._start < 0))
    for (var n = t; n; )
      n._dirty = 1, n = n.parent;
  return t;
}, X2e = function(t) {
  for (var e = t.parent; e && e.parent; )
    e._dirty = 1, e.totalDuration(), e = e.parent;
  return t;
}, BT = function(t, e, n, r) {
  return t._startAt && (Lo ? t._startAt.revert(d0) : t.vars.immediateRender && !t.vars.autoRevert || t._startAt.render(e, !0, r));
}, $2e = function t(e) {
  return !e || e._ts && t(e.parent);
}, yO = function(t) {
  return t._repeat ? wh(t._tTime, t = t.duration() + t._rDelay) * t : 0;
}, wh = function(t, e) {
  var n = Math.floor(t /= e);
  return t && n === t ? n - 1 : n;
}, wv = function(t, e) {
  return (t - e._start) * e._ts + (e._ts >= 0 ? 0 : e._dirty ? e.totalDuration() : e._tDur);
}, Q_ = function(t) {
  return t._end = go(t._start + (t._tDur / Math.abs(t._ts || t._rts || jn) || 0));
}, K_ = function(t, e) {
  var n = t._dp;
  return n && n.smoothChildTiming && t._ts && (t._start = go(n._time - (t._ts > 0 ? e / t._ts : ((t._dirty ? t.totalDuration() : t._tDur) - e) / -t._ts)), Q_(t), n._dirty || Ap(n, t)), t;
}, $6 = function(t, e) {
  var n;
  if ((e._time || !e._dur && e._initted || e._start < t._time && (e._dur || !e.add)) && (n = wv(t.rawTime(), e), (!e._dur || dy(0, e.totalDuration(), n) - e._tTime > jn) && e.render(n, !0)), Ap(t, e)._dp && t._initted && t._time >= t._dur && t._ts) {
    if (t._dur < t.duration())
      for (n = t; n._dp; )
        n.rawTime() >= 0 && n.totalTime(n._tTime), n = n._dp;
    t._zTime = -jn;
  }
}, Ki = function(t, e, n, r) {
  return e.parent && wc(e), e._start = go((il(n) ? n : n || t !== fr ? ba(t, n, e) : t._time) + e._delay), e._end = go(e._start + (e.totalDuration() / Math.abs(e.timeScale()) || 0)), X6(t, e, "_first", "_last", t._sort ? "_start" : 0), UT(e) || (t._recent = e), r || $6(t, e), t._ts < 0 && K_(t, t._tTime), t;
}, W6 = function(t, e) {
  return (ta.ScrollTrigger || LS("scrollTrigger", e)) && ta.ScrollTrigger.create(e, t);
}, V6 = function(t, e, n, r, o) {
  if (WS(t, e, o), !t._initted)
    return 1;
  if (!n && t._pt && !Lo && (t._dur && t.vars.lazy !== !1 || !t._dur && t.vars.lazy) && F6 !== Qs.frame)
    return cc.push(t), t._lazy = [o, r], 1;
}, W2e = function t(e) {
  var n = e.parent;
  return n && n._ts && n._initted && !n._lock && (n.rawTime() < 0 || t(n));
}, UT = function(t) {
  var e = t.data;
  return e === "isFromStart" || e === "isStart";
}, V2e = function(t, e, n, r) {
  var o = t.ratio, s = e < 0 || !e && (!t._start && W2e(t) && !(!t._initted && UT(t)) || (t._ts < 0 || t._dp._ts < 0) && !UT(t)) ? 0 : 1, i = t._rDelay, u = 0, l, a, c;
  if (i && t._repeat && (u = dy(0, t._tDur, e), a = wh(u, i), t._yoyo && a & 1 && (s = 1 - s), a !== wh(t._tTime, i) && (o = 1 - s, t.vars.repeatRefresh && t._initted && t.invalidate())), s !== o || Lo || r || t._zTime === jn || !e && t._zTime) {
    if (!t._initted && V6(t, e, r, n, u))
      return;
    for (c = t._zTime, t._zTime = e || (n ? jn : 0), n || (n = e && !c), t.ratio = s, t._from && (s = 1 - s), t._time = 0, t._tTime = u, l = t._pt; l; )
      l.r(s, l.d), l = l._next;
    e < 0 && BT(t, e, n, !0), t._onUpdate && !n && Js(t, "onUpdate"), u && t._repeat && !n && t.parent && Js(t, "onRepeat"), (e >= t._tDur || e < 0) && t.ratio === s && (s && wc(t, 1), !n && !Lo && (Js(t, s ? "onComplete" : "onReverseComplete", !0), t._prom && t._prom()));
  } else t._zTime || (t._zTime = e);
}, H2e = function(t, e, n) {
  var r;
  if (n > e)
    for (r = t._first; r && r._start <= n; ) {
      if (r.data === "isPause" && r._start > e)
        return r;
      r = r._next;
    }
  else
    for (r = t._last; r && r._start >= n; ) {
      if (r.data === "isPause" && r._start < e)
        return r;
      r = r._prev;
    }
}, bh = function(t, e, n, r) {
  var o = t._repeat, s = go(e) || 0, i = t._tTime / t._tDur;
  return i && !r && (t._time *= s / t._dur), t._dur = s, t._tDur = o ? o < 0 ? 1e10 : go(s * (o + 1) + t._rDelay * o) : s, i > 0 && !r && K_(t, t._tTime = t._tDur * i), t.parent && Q_(t), n || Ap(t.parent, t), t;
}, gO = function(t) {
  return t instanceof Ko ? Ap(t) : bh(t, t._dur);
}, j2e = {
  _start: 0,
  endTime: vm,
  totalDuration: vm
}, ba = function t(e, n, r) {
  var o = e.labels, s = e._recent || j2e, i = e.duration() >= Ea ? s.endTime(!1) : e._dur, u, l, a;
  return wo(n) && (isNaN(n) || n in o) ? (l = n.charAt(0), a = n.substr(-1) === "%", u = n.indexOf("="), l === "<" || l === ">" ? (u >= 0 && (n = n.replace(/=/, "")), (l === "<" ? s._start : s.endTime(s._repeat >= 0)) + (parseFloat(n.substr(1)) || 0) * (a ? (u < 0 ? s : r).totalDuration() / 100 : 1)) : u < 0 ? (n in o || (o[n] = i), o[n]) : (l = parseFloat(n.charAt(u - 1) + n.substr(u + 1)), a && r && (l = l / 100 * (Bo(r) ? r[0] : r).totalDuration()), u > 1 ? t(e, n.substr(0, u - 1), r) + l : i + l)) : n == null ? i : +n;
}, tm = function(t, e, n) {
  var r = il(e[1]), o = (r ? 2 : 1) + (t < 2 ? 0 : 1), s = e[o], i, u;
  if (r && (s.duration = e[1]), s.parent = n, t) {
    for (i = s, u = n; u && !("immediateRender" in i); )
      i = u.vars.defaults || {}, u = ks(u.vars.inherit) && u.parent;
    s.immediateRender = ks(i.immediateRender), t < 2 ? s.runBackwards = 1 : s.startAt = e[o - 1];
  }
  return new Hr(e[0], s, e[o + 1]);
}, Ic = function(t, e) {
  return t || t === 0 ? e(t) : e;
}, dy = function(t, e, n) {
  return n < t ? t : n > e ? e : n;
}, No = function(t, e) {
  return !wo(t) || !(e = I2e.exec(t)) ? "" : e[1];
}, z2e = function(t, e, n) {
  return Ic(n, function(r) {
    return dy(t, e, r);
  });
}, XT = [].slice, H6 = function(t, e) {
  return t && gu(t) && "length" in t && (!e && !t.length || t.length - 1 in t && gu(t[0])) && !t.nodeType && t !== qi;
}, q2e = function(t, e, n) {
  return n === void 0 && (n = []), t.forEach(function(r) {
    var o;
    return wo(r) && !e || H6(r, 1) ? (o = n).push.apply(o, Ma(r)) : n.push(r);
  }) || n;
}, Ma = function(t, e, n) {
  return rr && !e && rr.selector ? rr.selector(t) : wo(t) && !n && (NT || !kh()) ? XT.call((e || NS).querySelectorAll(t), 0) : Bo(t) ? q2e(t, n) : H6(t) ? XT.call(t, 0) : t ? [t] : [];
}, $T = function(t) {
  return t = Ma(t)[0] || gm("Invalid scope") || {}, function(e) {
    var n = t.current || t.nativeElement || t;
    return Ma(e, n.querySelectorAll ? n : n === t ? gm("Invalid scope") || NS.createElement("div") : t);
  };
}, j6 = function(t) {
  return t.sort(function() {
    return 0.5 - Math.random();
  });
}, z6 = function(t) {
  if (Ar(t))
    return t;
  var e = gu(t) ? t : {
    each: t
  }, n = Dp(e.ease), r = e.from || 0, o = parseFloat(e.base) || 0, s = {}, i = r > 0 && r < 1, u = isNaN(r) || i, l = e.axis, a = r, c = r;
  return wo(r) ? a = c = {
    center: 0.5,
    edges: 0.5,
    end: 1
  }[r] || 0 : !i && u && (a = r[0], c = r[1]), function(p, d, h) {
    var m = (h || e).length, g = s[m], _, b, x, S, E, A, C, M, L;
    if (!g) {
      if (L = e.grid === "auto" ? 0 : (e.grid || [1, Ea])[1], !L) {
        for (C = -Ea; C < (C = h[L++].getBoundingClientRect().left) && L < m; )
          ;
        L < m && L--;
      }
      for (g = s[m] = [], _ = u ? Math.min(L, m) * a - 0.5 : r % L, b = L === Ea ? 0 : u ? m * c / L - 0.5 : r / L | 0, C = 0, M = Ea, A = 0; A < m; A++)
        x = A % L - _, S = b - (A / L | 0), g[A] = E = l ? Math.abs(l === "y" ? S : x) : A6(x * x + S * S), E > C && (C = E), E < M && (M = E);
      r === "random" && j6(g), g.max = C - M, g.min = M, g.v = m = (parseFloat(e.amount) || parseFloat(e.each) * (L > m ? m - 1 : l ? l === "y" ? m / L : L : Math.max(L, m / L)) || 0) * (r === "edges" ? -1 : 1), g.b = m < 0 ? o - m : o, g.u = No(e.amount || e.each) || 0, n = n && m < 0 ? n5(n) : n;
    }
    return m = (g[p] - g.min) / g.max || 0, go(g.b + (n ? n(m) : m) * g.v) + g.u;
  };
}, WT = function(t) {
  var e = Math.pow(10, ((t + "").split(".")[1] || "").length);
  return function(n) {
    var r = go(Math.round(parseFloat(n) / t) * t * e);
    return (r - r % 1) / e + (il(n) ? 0 : No(n));
  };
}, q6 = function(t, e) {
  var n = Bo(t), r, o;
  return !n && gu(t) && (r = n = t.radius || Ea, t.values ? (t = Ma(t.values), (o = !il(t[0])) && (r *= r)) : t = WT(t.increment)), Ic(e, n ? Ar(t) ? function(s) {
    return o = t(s), Math.abs(o - s) <= r ? o : s;
  } : function(s) {
    for (var i = parseFloat(o ? s.x : s), u = parseFloat(o ? s.y : 0), l = Ea, a = 0, c = t.length, p, d; c--; )
      o ? (p = t[c].x - i, d = t[c].y - u, p = p * p + d * d) : p = Math.abs(t[c] - i), p < l && (l = p, a = c);
    return a = !r || l <= r ? t[a] : s, o || a === s || il(s) ? a : a + No(s);
  } : WT(t));
}, G6 = function(t, e, n, r) {
  return Ic(Bo(t) ? !e : n === !0 ? !!(n = 0) : !r, function() {
    return Bo(t) ? t[~~(Math.random() * t.length)] : (n = n || 1e-5) && (r = n < 1 ? Math.pow(10, (n + "").length - 2) : 1) && Math.floor(Math.round((t - n / 2 + Math.random() * (e - t + n * 0.99)) / n) * n * r) / r;
  });
}, G2e = function() {
  for (var t = arguments.length, e = new Array(t), n = 0; n < t; n++)
    e[n] = arguments[n];
  return function(r) {
    return e.reduce(function(o, s) {
      return s(o);
    }, r);
  };
}, Y2e = function(t, e) {
  return function(n) {
    return t(parseFloat(n)) + (e || No(n));
  };
}, Q2e = function(t, e, n) {
  return Q6(t, e, 0, 1, n);
}, Y6 = function(t, e, n) {
  return Ic(n, function(r) {
    return t[~~e(r)];
  });
}, K2e = function t(e, n, r) {
  var o = n - e;
  return Bo(e) ? Y6(e, t(0, e.length), n) : Ic(r, function(s) {
    return (o + (s - e) % o) % o + e;
  });
}, Z2e = function t(e, n, r) {
  var o = n - e, s = o * 2;
  return Bo(e) ? Y6(e, t(0, e.length - 1), n) : Ic(r, function(i) {
    return i = (s + (i - e) % s) % s || 0, e + (i > o ? s - i : i);
  });
}, _m = function(t) {
  for (var e = 0, n = "", r, o, s, i; ~(r = t.indexOf("random(", e)); )
    s = t.indexOf(")", r), i = t.charAt(r + 7) === "[", o = t.substr(r + 7, s - r - 7).match(i ? P6 : FT), n += t.substr(e, r - e) + G6(i ? o : +o[0], i ? 0 : +o[1], +o[2] || 1e-5), e = s + 1;
  return n + t.substr(e, t.length - e);
}, Q6 = function(t, e, n, r, o) {
  var s = e - t, i = r - n;
  return Ic(o, function(u) {
    return n + ((u - t) / s * i || 0);
  });
}, J2e = function t(e, n, r, o) {
  var s = isNaN(e + n) ? 0 : function(h) {
    return (1 - h) * e + h * n;
  };
  if (!s) {
    var i = wo(e), u = {}, l, a, c, p, d;
    if (r === !0 && (o = 1) && (r = null), i)
      e = {
        p: e
      }, n = {
        p: n
      };
    else if (Bo(e) && !Bo(n)) {
      for (c = [], p = e.length, d = p - 2, a = 1; a < p; a++)
        c.push(t(e[a - 1], e[a]));
      p--, s = function(h) {
        h *= p;
        var m = Math.min(d, ~~h);
        return c[m](h - m);
      }, r = n;
    } else o || (e = $p(Bo(e) ? [] : {}, e));
    if (!c) {
      for (l in n)
        $S.call(u, e, l, "get", n[l]);
      s = function(h) {
        return jS(h, u) || (i ? e.p : e);
      };
    }
  }
  return Ic(r, s);
}, vO = function(t, e, n) {
  var r = t.labels, o = Ea, s, i, u;
  for (s in r)
    i = r[s] - e, i < 0 == !!n && i && o > (i = Math.abs(i)) && (u = s, o = i);
  return u;
}, Js = function(t, e, n) {
  var r = t.vars, o = r[e], s = rr, i = t._ctx, u, l, a;
  if (o)
    return u = r[e + "Params"], l = r.callbackScope || t, n && cc.length && vv(), i && (rr = i), a = u ? o.apply(l, u) : o.call(l), rr = s, a;
}, Hf = function(t) {
  return wc(t), t.scrollTrigger && t.scrollTrigger.kill(!!Lo), t.progress() < 1 && Js(t, "onInterrupt"), t;
}, Ud, K6 = [], Z6 = function(t) {
  if (t)
    if (t = !t.name && t.default || t, FS() || t.headless) {
      var e = t.name, n = Ar(t), r = e && !n && t.init ? function() {
        this._props = [];
      } : t, o = {
        init: vm,
        render: jS,
        add: $S,
        kill: mSe,
        modifier: fSe,
        rawVars: 0
      }, s = {
        targetTest: 0,
        get: 0,
        getSetter: HS,
        aliases: {},
        register: 0
      };
      if (kh(), t !== r) {
        if (zs[e])
          return;
        La(r, La(_v(t, o), s)), $p(r.prototype, $p(o, _v(t, s))), zs[r.prop = e] = r, t.targetTest && (h0.push(r), BS[e] = 1), e = (e === "css" ? "CSS" : e.charAt(0).toUpperCase() + e.substr(1)) + "Plugin";
      }
      I6(e, r), t.register && t.register(Es, r, xs);
    } else
      K6.push(t);
}, $n = 255, jf = {
  aqua: [0, $n, $n],
  lime: [0, $n, 0],
  silver: [192, 192, 192],
  black: [0, 0, 0],
  maroon: [128, 0, 0],
  teal: [0, 128, 128],
  blue: [0, 0, $n],
  navy: [0, 0, 128],
  white: [$n, $n, $n],
  olive: [128, 128, 0],
  yellow: [$n, $n, 0],
  orange: [$n, 165, 0],
  gray: [128, 128, 128],
  purple: [128, 0, 128],
  green: [0, 128, 0],
  red: [$n, 0, 0],
  pink: [$n, 192, 203],
  cyan: [0, $n, $n],
  transparent: [$n, $n, $n, 0]
}, Nb = function(t, e, n) {
  return t += t < 0 ? 1 : t > 1 ? -1 : 0, (t * 6 < 1 ? e + (n - e) * t * 6 : t < 0.5 ? n : t * 3 < 2 ? e + (n - e) * (2 / 3 - t) * 6 : e) * $n + 0.5 | 0;
}, J6 = function(t, e, n) {
  var r = t ? il(t) ? [t >> 16, t >> 8 & $n, t & $n] : 0 : jf.black, o, s, i, u, l, a, c, p, d, h;
  if (!r) {
    if (t.substr(-1) === "," && (t = t.substr(0, t.length - 1)), jf[t])
      r = jf[t];
    else if (t.charAt(0) === "#") {
      if (t.length < 6 && (o = t.charAt(1), s = t.charAt(2), i = t.charAt(3), t = "#" + o + o + s + s + i + i + (t.length === 5 ? t.charAt(4) + t.charAt(4) : "")), t.length === 9)
        return r = parseInt(t.substr(1, 6), 16), [r >> 16, r >> 8 & $n, r & $n, parseInt(t.substr(7), 16) / 255];
      t = parseInt(t.substr(1), 16), r = [t >> 16, t >> 8 & $n, t & $n];
    } else if (t.substr(0, 3) === "hsl") {
      if (r = h = t.match(FT), !e)
        u = +r[0] % 360 / 360, l = +r[1] / 100, a = +r[2] / 100, s = a <= 0.5 ? a * (l + 1) : a + l - a * l, o = a * 2 - s, r.length > 3 && (r[3] *= 1), r[0] = Nb(u + 1 / 3, o, s), r[1] = Nb(u, o, s), r[2] = Nb(u - 1 / 3, o, s);
      else if (~t.indexOf("="))
        return r = t.match(E6), n && r.length < 4 && (r[3] = 1), r;
    } else
      r = t.match(FT) || jf.transparent;
    r = r.map(Number);
  }
  return e && !h && (o = r[0] / $n, s = r[1] / $n, i = r[2] / $n, c = Math.max(o, s, i), p = Math.min(o, s, i), a = (c + p) / 2, c === p ? u = l = 0 : (d = c - p, l = a > 0.5 ? d / (2 - c - p) : d / (c + p), u = c === o ? (s - i) / d + (s < i ? 6 : 0) : c === s ? (i - o) / d + 2 : (o - s) / d + 4, u *= 60), r[0] = ~~(u + 0.5), r[1] = ~~(l * 100 + 0.5), r[2] = ~~(a * 100 + 0.5)), n && r.length < 4 && (r[3] = 1), r;
}, e5 = function(t) {
  var e = [], n = [], r = -1;
  return t.split(pc).forEach(function(o) {
    var s = o.match(Bd) || [];
    e.push.apply(e, s), n.push(r += s.length + 1);
  }), e.c = n, e;
}, _O = function(t, e, n) {
  var r = "", o = (t + r).match(pc), s = e ? "hsla(" : "rgba(", i = 0, u, l, a, c;
  if (!o)
    return t;
  if (o = o.map(function(p) {
    return (p = J6(p, e, 1)) && s + (e ? p[0] + "," + p[1] + "%," + p[2] + "%," + p[3] : p.join(",")) + ")";
  }), n && (a = e5(t), u = n.c, u.join(r) !== a.c.join(r)))
    for (l = t.replace(pc, "1").split(Bd), c = l.length - 1; i < c; i++)
      r += l[i] + (~u.indexOf(i) ? o.shift() || s + "0,0,0,0)" : (a.length ? a : o.length ? o : n).shift());
  if (!l)
    for (l = t.split(pc), c = l.length - 1; i < c; i++)
      r += l[i] + o[i];
  return r + l[c];
}, pc = function() {
  var t = "(?:\\b(?:(?:rgb|rgba|hsl|hsla)\\(.+?\\))|\\B#(?:[0-9a-f]{3,4}){1,2}\\b", e;
  for (e in jf)
    t += "|" + e + "\\b";
  return new RegExp(t + ")", "gi");
}(), eSe = /hsl[a]?\(/, t5 = function(t) {
  var e = t.join(" "), n;
  if (pc.lastIndex = 0, pc.test(e))
    return n = eSe.test(e), t[1] = _O(t[1], n), t[0] = _O(t[0], n, e5(t[1])), !0;
}, wm, Qs = function() {
  var t = Date.now, e = 500, n = 33, r = t(), o = r, s = 1e3 / 240, i = s, u = [], l, a, c, p, d, h, m = function g(_) {
    var b = t() - o, x = _ === !0, S, E, A, C;
    if ((b > e || b < 0) && (r += b - n), o += b, A = o - r, S = A - i, (S > 0 || x) && (C = ++p.frame, d = A - p.time * 1e3, p.time = A = A / 1e3, i += S + (S >= s ? 4 : s - S), E = 1), x || (l = a(g)), E)
      for (h = 0; h < u.length; h++)
        u[h](A, d, C, _);
  };
  return p = {
    time: 0,
    frame: 0,
    tick: function() {
      m(!0);
    },
    deltaRatio: function(g) {
      return d / (1e3 / (g || 60));
    },
    wake: function() {
      C6 && (!NT && FS() && (qi = NT = window, NS = qi.document || {}, ta.gsap = Es, (qi.gsapVersions || (qi.gsapVersions = [])).push(Es.version), O6(gv || qi.GreenSockGlobals || !qi.gsap && qi || {}), K6.forEach(Z6)), c = typeof requestAnimationFrame < "u" && requestAnimationFrame, l && p.sleep(), a = c || function(g) {
        return setTimeout(g, i - p.time * 1e3 + 1 | 0);
      }, wm = 1, m(2));
    },
    sleep: function() {
      (c ? cancelAnimationFrame : clearTimeout)(l), wm = 0, a = vm;
    },
    lagSmoothing: function(g, _) {
      e = g || 1 / 0, n = Math.min(_ || 33, e);
    },
    fps: function(g) {
      s = 1e3 / (g || 240), i = p.time * 1e3 + s;
    },
    add: function(g, _, b) {
      var x = _ ? function(S, E, A, C) {
        g(S, E, A, C), p.remove(x);
      } : g;
      return p.remove(g), u[b ? "unshift" : "push"](x), kh(), x;
    },
    remove: function(g, _) {
      ~(_ = u.indexOf(g)) && u.splice(_, 1) && h >= _ && h--;
    },
    _listeners: u
  }, p;
}(), kh = function() {
  return !wm && Qs.wake();
}, yn = {}, tSe = /^[\d.\-M][\d.\-,\s]/, nSe = /["']/g, rSe = function(t) {
  for (var e = {}, n = t.substr(1, t.length - 3).split(":"), r = n[0], o = 1, s = n.length, i, u, l; o < s; o++)
    u = n[o], i = o !== s - 1 ? u.lastIndexOf(",") : u.length, l = u.substr(0, i), e[r] = isNaN(l) ? l.replace(nSe, "").trim() : +l, r = u.substr(i + 1).trim();
  return e;
}, oSe = function(t) {
  var e = t.indexOf("(") + 1, n = t.indexOf(")"), r = t.indexOf("(", e);
  return t.substring(e, ~r && r < n ? t.indexOf(")", n + 1) : n);
}, sSe = function(t) {
  var e = (t + "").split("("), n = yn[e[0]];
  return n && e.length > 1 && n.config ? n.config.apply(null, ~t.indexOf("{") ? [rSe(e[1])] : oSe(t).split(",").map(B6)) : yn._CE && tSe.test(t) ? yn._CE("", t) : n;
}, n5 = function(t) {
  return function(e) {
    return 1 - t(1 - e);
  };
}, r5 = function t(e, n) {
  for (var r = e._first, o; r; )
    r instanceof Ko ? t(r, n) : r.vars.yoyoEase && (!r._yoyo || !r._repeat) && r._yoyo !== n && (r.timeline ? t(r.timeline, n) : (o = r._ease, r._ease = r._yEase, r._yEase = o, r._yoyo = n)), r = r._next;
}, Dp = function(t, e) {
  return t && (Ar(t) ? t : yn[t] || sSe(t)) || e;
}, od = function(t, e, n, r) {
  n === void 0 && (n = function(i) {
    return 1 - e(1 - i);
  }), r === void 0 && (r = function(i) {
    return i < 0.5 ? e(i * 2) / 2 : 1 - e((1 - i) * 2) / 2;
  });
  var o = {
    easeIn: e,
    easeOut: n,
    easeInOut: r
  }, s;
  return Ts(t, function(i) {
    yn[i] = ta[i] = o, yn[s = i.toLowerCase()] = n;
    for (var u in o)
      yn[s + (u === "easeIn" ? ".in" : u === "easeOut" ? ".out" : ".inOut")] = yn[i + "." + u] = o[u];
  }), o;
}, o5 = function(t) {
  return function(e) {
    return e < 0.5 ? (1 - t(1 - e * 2)) / 2 : 0.5 + t((e - 0.5) * 2) / 2;
  };
}, Lb = function t(e, n, r) {
  var o = n >= 1 ? n : 1, s = (r || (e ? 0.3 : 0.45)) / (n < 1 ? n : 1), i = s / IT * (Math.asin(1 / o) || 0), u = function(a) {
    return a === 1 ? 1 : o * Math.pow(2, -10 * a) * O2e((a - i) * s) + 1;
  }, l = e === "out" ? u : e === "in" ? function(a) {
    return 1 - u(1 - a);
  } : o5(u);
  return s = IT / s, l.config = function(a, c) {
    return t(e, a, c);
  }, l;
}, Bb = function t(e, n) {
  n === void 0 && (n = 1.70158);
  var r = function(s) {
    return s ? --s * s * ((n + 1) * s + n) + 1 : 0;
  }, o = e === "out" ? r : e === "in" ? function(s) {
    return 1 - r(1 - s);
  } : o5(r);
  return o.config = function(s) {
    return t(e, s);
  }, o;
};
Ts("Linear,Quad,Cubic,Quart,Quint,Strong", function(t, e) {
  var n = e < 5 ? e + 1 : e;
  od(t + ",Power" + (n - 1), e ? function(r) {
    return Math.pow(r, n);
  } : function(r) {
    return r;
  }, function(r) {
    return 1 - Math.pow(1 - r, n);
  }, function(r) {
    return r < 0.5 ? Math.pow(r * 2, n) / 2 : 1 - Math.pow((1 - r) * 2, n) / 2;
  });
});
yn.Linear.easeNone = yn.none = yn.Linear.easeIn;
od("Elastic", Lb("in"), Lb("out"), Lb());
(function(t, e) {
  var n = 1 / e, r = 2 * n, o = 2.5 * n, s = function(i) {
    return i < n ? t * i * i : i < r ? t * Math.pow(i - 1.5 / e, 2) + 0.75 : i < o ? t * (i -= 2.25 / e) * i + 0.9375 : t * Math.pow(i - 2.625 / e, 2) + 0.984375;
  };
  od("Bounce", function(i) {
    return 1 - s(1 - i);
  }, s);
})(7.5625, 2.75);
od("Expo", function(t) {
  return t ? Math.pow(2, 10 * (t - 1)) : 0;
});
od("Circ", function(t) {
  return -(A6(1 - t * t) - 1);
});
od("Sine", function(t) {
  return t === 1 ? 1 : -C2e(t * M2e) + 1;
});
od("Back", Bb("in"), Bb("out"), Bb());
yn.SteppedEase = yn.steps = ta.SteppedEase = {
  config: function(t, e) {
    t === void 0 && (t = 1);
    var n = 1 / t, r = t + (e ? 0 : 1), o = e ? 1 : 0, s = 1 - jn;
    return function(i) {
      return ((r * dy(0, s, i) | 0) + o) * n;
    };
  }
};
_h.ease = yn["quad.out"];
Ts("onComplete,onUpdate,onStart,onRepeat,onReverseComplete,onInterrupt", function(t) {
  return US += t + "," + t + "Params,";
});
var s5 = function(t, e) {
  this.id = P2e++, t._gsap = this, this.target = t, this.harness = e, this.get = e ? e.get : N6, this.set = e ? e.getSetter : HS;
}, bm = /* @__PURE__ */ function() {
  function t(n) {
    this.vars = n, this._delay = +n.delay || 0, (this._repeat = n.repeat === 1 / 0 ? -2 : n.repeat || 0) && (this._rDelay = n.repeatDelay || 0, this._yoyo = !!n.yoyo || !!n.yoyoEase), this._ts = 1, bh(this, +n.duration, 1, 1), this.data = n.data, rr && (this._ctx = rr, rr.data.push(this)), wm || Qs.wake();
  }
  var e = t.prototype;
  return e.delay = function(n) {
    return n || n === 0 ? (this.parent && this.parent.smoothChildTiming && this.startTime(this._start + n - this._delay), this._delay = n, this) : this._delay;
  }, e.duration = function(n) {
    return arguments.length ? this.totalDuration(this._repeat > 0 ? n + (n + this._rDelay) * this._repeat : n) : this.totalDuration() && this._dur;
  }, e.totalDuration = function(n) {
    return arguments.length ? (this._dirty = 0, bh(this, this._repeat < 0 ? n : (n - this._repeat * this._rDelay) / (this._repeat + 1))) : this._tDur;
  }, e.totalTime = function(n, r) {
    if (kh(), !arguments.length)
      return this._tTime;
    var o = this._dp;
    if (o && o.smoothChildTiming && this._ts) {
      for (K_(this, n), !o._dp || o.parent || $6(o, this); o && o.parent; )
        o.parent._time !== o._start + (o._ts >= 0 ? o._tTime / o._ts : (o.totalDuration() - o._tTime) / -o._ts) && o.totalTime(o._tTime, !0), o = o.parent;
      !this.parent && this._dp.autoRemoveChildren && (this._ts > 0 && n < this._tDur || this._ts < 0 && n > 0 || !this._tDur && !n) && Ki(this._dp, this, this._start - this._delay);
    }
    return (this._tTime !== n || !this._dur && !r || this._initted && Math.abs(this._zTime) === jn || !n && !this._initted && (this.add || this._ptLookup)) && (this._ts || (this._pTime = n), L6(this, n, r)), this;
  }, e.time = function(n, r) {
    return arguments.length ? this.totalTime(Math.min(this.totalDuration(), n + yO(this)) % (this._dur + this._rDelay) || (n ? this._dur : 0), r) : this._time;
  }, e.totalProgress = function(n, r) {
    return arguments.length ? this.totalTime(this.totalDuration() * n, r) : this.totalDuration() ? Math.min(1, this._tTime / this._tDur) : this.rawTime() > 0 ? 1 : 0;
  }, e.progress = function(n, r) {
    return arguments.length ? this.totalTime(this.duration() * (this._yoyo && !(this.iteration() & 1) ? 1 - n : n) + yO(this), r) : this.duration() ? Math.min(1, this._time / this._dur) : this.rawTime() > 0 ? 1 : 0;
  }, e.iteration = function(n, r) {
    var o = this.duration() + this._rDelay;
    return arguments.length ? this.totalTime(this._time + (n - 1) * o, r) : this._repeat ? wh(this._tTime, o) + 1 : 1;
  }, e.timeScale = function(n, r) {
    if (!arguments.length)
      return this._rts === -jn ? 0 : this._rts;
    if (this._rts === n)
      return this;
    var o = this.parent && this._ts ? wv(this.parent._time, this) : this._tTime;
    return this._rts = +n || 0, this._ts = this._ps || n === -jn ? 0 : this._rts, this.totalTime(dy(-Math.abs(this._delay), this._tDur, o), r !== !1), Q_(this), X2e(this);
  }, e.paused = function(n) {
    return arguments.length ? (this._ps !== n && (this._ps = n, n ? (this._pTime = this._tTime || Math.max(-this._delay, this.rawTime()), this._ts = this._act = 0) : (kh(), this._ts = this._rts, this.totalTime(this.parent && !this.parent.smoothChildTiming ? this.rawTime() : this._tTime || this._pTime, this.progress() === 1 && Math.abs(this._zTime) !== jn && (this._tTime -= jn)))), this) : this._ps;
  }, e.startTime = function(n) {
    if (arguments.length) {
      this._start = n;
      var r = this.parent || this._dp;
      return r && (r._sort || !this.parent) && Ki(r, this, n - this._delay), this;
    }
    return this._start;
  }, e.endTime = function(n) {
    return this._start + (ks(n) ? this.totalDuration() : this.duration()) / Math.abs(this._ts || 1);
  }, e.rawTime = function(n) {
    var r = this.parent || this._dp;
    return r ? n && (!this._ts || this._repeat && this._time && this.totalProgress() < 1) ? this._tTime % (this._dur + this._rDelay) : this._ts ? wv(r.rawTime(n), this) : this._tTime : this._tTime;
  }, e.revert = function(n) {
    n === void 0 && (n = N2e);
    var r = Lo;
    return Lo = n, (this._initted || this._startAt) && (this.timeline && this.timeline.revert(n), this.totalTime(-0.01, n.suppressEvents)), this.data !== "nested" && n.kill !== !1 && this.kill(), Lo = r, this;
  }, e.globalTime = function(n) {
    for (var r = this, o = arguments.length ? n : r.rawTime(); r; )
      o = r._start + o / (Math.abs(r._ts) || 1), r = r._dp;
    return !this.parent && this._sat ? this._sat.globalTime(n) : o;
  }, e.repeat = function(n) {
    return arguments.length ? (this._repeat = n === 1 / 0 ? -2 : n, gO(this)) : this._repeat === -2 ? 1 / 0 : this._repeat;
  }, e.repeatDelay = function(n) {
    if (arguments.length) {
      var r = this._time;
      return this._rDelay = n, gO(this), r ? this.time(r) : this;
    }
    return this._rDelay;
  }, e.yoyo = function(n) {
    return arguments.length ? (this._yoyo = n, this) : this._yoyo;
  }, e.seek = function(n, r) {
    return this.totalTime(ba(this, n), ks(r));
  }, e.restart = function(n, r) {
    return this.play().totalTime(n ? -this._delay : 0, ks(r));
  }, e.play = function(n, r) {
    return n != null && this.seek(n, r), this.reversed(!1).paused(!1);
  }, e.reverse = function(n, r) {
    return n != null && this.seek(n || this.totalDuration(), r), this.reversed(!0).paused(!1);
  }, e.pause = function(n, r) {
    return n != null && this.seek(n, r), this.paused(!0);
  }, e.resume = function() {
    return this.paused(!1);
  }, e.reversed = function(n) {
    return arguments.length ? (!!n !== this.reversed() && this.timeScale(-this._rts || (n ? -jn : 0)), this) : this._rts < 0;
  }, e.invalidate = function() {
    return this._initted = this._act = 0, this._zTime = -jn, this;
  }, e.isActive = function() {
    var n = this.parent || this._dp, r = this._start, o;
    return !!(!n || this._ts && this._initted && n.isActive() && (o = n.rawTime(!0)) >= r && o < this.endTime(!0) - jn);
  }, e.eventCallback = function(n, r, o) {
    var s = this.vars;
    return arguments.length > 1 ? (r ? (s[n] = r, o && (s[n + "Params"] = o), n === "onUpdate" && (this._onUpdate = r)) : delete s[n], this) : s[n];
  }, e.then = function(n) {
    var r = this;
    return new Promise(function(o) {
      var s = Ar(n) ? n : U6, i = function() {
        var u = r.then;
        r.then = null, Ar(s) && (s = s(r)) && (s.then || s === r) && (r.then = u), o(s), r.then = u;
      };
      r._initted && r.totalProgress() === 1 && r._ts >= 0 || !r._tTime && r._ts < 0 ? i() : r._prom = i;
    });
  }, e.kill = function() {
    Hf(this);
  }, t;
}();
La(bm.prototype, {
  _time: 0,
  _start: 0,
  _end: 0,
  _tTime: 0,
  _tDur: 0,
  _dirty: 0,
  _repeat: 0,
  _yoyo: !1,
  parent: null,
  _initted: !1,
  _rDelay: 0,
  _ts: 1,
  _dp: 0,
  ratio: 0,
  _zTime: -jn,
  _prom: 0,
  _ps: !1,
  _rts: 1
});
var Ko = /* @__PURE__ */ function(t) {
  R6(e, t);
  function e(r, o) {
    var s;
    return r === void 0 && (r = {}), s = t.call(this, r) || this, s.labels = {}, s.smoothChildTiming = !!r.smoothChildTiming, s.autoRemoveChildren = !!r.autoRemoveChildren, s._sort = ks(r.sortChildren), fr && Ki(r.parent || fr, ju(s), o), r.reversed && s.reverse(), r.paused && s.paused(!0), r.scrollTrigger && W6(ju(s), r.scrollTrigger), s;
  }
  var n = e.prototype;
  return n.to = function(r, o, s) {
    return tm(0, arguments, this), this;
  }, n.from = function(r, o, s) {
    return tm(1, arguments, this), this;
  }, n.fromTo = function(r, o, s, i) {
    return tm(2, arguments, this), this;
  }, n.set = function(r, o, s) {
    return o.duration = 0, o.parent = this, em(o).repeatDelay || (o.repeat = 0), o.immediateRender = !!o.immediateRender, new Hr(r, o, ba(this, s), 1), this;
  }, n.call = function(r, o, s) {
    return Ki(this, Hr.delayedCall(0, r, o), s);
  }, n.staggerTo = function(r, o, s, i, u, l, a) {
    return s.duration = o, s.stagger = s.stagger || i, s.onComplete = l, s.onCompleteParams = a, s.parent = this, new Hr(r, s, ba(this, u)), this;
  }, n.staggerFrom = function(r, o, s, i, u, l, a) {
    return s.runBackwards = 1, em(s).immediateRender = ks(s.immediateRender), this.staggerTo(r, o, s, i, u, l, a);
  }, n.staggerFromTo = function(r, o, s, i, u, l, a, c) {
    return i.startAt = s, em(i).immediateRender = ks(i.immediateRender), this.staggerTo(r, o, i, u, l, a, c);
  }, n.render = function(r, o, s) {
    var i = this._time, u = this._dirty ? this.totalDuration() : this._tDur, l = this._dur, a = r <= 0 ? 0 : go(r), c = this._zTime < 0 != r < 0 && (this._initted || !l), p, d, h, m, g, _, b, x, S, E, A, C;
    if (this !== fr && a > u && r >= 0 && (a = u), a !== this._tTime || s || c) {
      if (i !== this._time && l && (a += this._time - i, r += this._time - i), p = a, S = this._start, x = this._ts, _ = !x, c && (l || (i = this._zTime), (r || !o) && (this._zTime = r)), this._repeat) {
        if (A = this._yoyo, g = l + this._rDelay, this._repeat < -1 && r < 0)
          return this.totalTime(g * 100 + r, o, s);
        if (p = go(a % g), a === u ? (m = this._repeat, p = l) : (m = ~~(a / g), m && m === a / g && (p = l, m--), p > l && (p = l)), E = wh(this._tTime, g), !i && this._tTime && E !== m && this._tTime - E * g - this._dur <= 0 && (E = m), A && m & 1 && (p = l - p, C = 1), m !== E && !this._lock) {
          var M = A && E & 1, L = M === (A && m & 1);
          if (m < E && (M = !M), i = M ? 0 : a % l ? l : a, this._lock = 1, this.render(i || (C ? 0 : go(m * g)), o, !l)._lock = 0, this._tTime = a, !o && this.parent && Js(this, "onRepeat"), this.vars.repeatRefresh && !C && (this.invalidate()._lock = 1), i && i !== this._time || _ !== !this._ts || this.vars.onRepeat && !this.parent && !this._act)
            return this;
          if (l = this._dur, u = this._tDur, L && (this._lock = 2, i = M ? l : -1e-4, this.render(i, !0), this.vars.repeatRefresh && !C && this.invalidate()), this._lock = 0, !this._ts && !_)
            return this;
          r5(this, C);
        }
      }
      if (this._hasPause && !this._forcing && this._lock < 2 && (b = H2e(this, go(i), go(p)), b && (a -= p - (p = b._start))), this._tTime = a, this._time = p, this._act = !x, this._initted || (this._onUpdate = this.vars.onUpdate, this._initted = 1, this._zTime = r, i = 0), !i && p && !o && !m && (Js(this, "onStart"), this._tTime !== a))
        return this;
      if (p >= i && r >= 0)
        for (d = this._first; d; ) {
          if (h = d._next, (d._act || p >= d._start) && d._ts && b !== d) {
            if (d.parent !== this)
              return this.render(r, o, s);
            if (d.render(d._ts > 0 ? (p - d._start) * d._ts : (d._dirty ? d.totalDuration() : d._tDur) + (p - d._start) * d._ts, o, s), p !== this._time || !this._ts && !_) {
              b = 0, h && (a += this._zTime = -jn);
              break;
            }
          }
          d = h;
        }
      else {
        d = this._last;
        for (var X = r < 0 ? r : p; d; ) {
          if (h = d._prev, (d._act || X <= d._end) && d._ts && b !== d) {
            if (d.parent !== this)
              return this.render(r, o, s);
            if (d.render(d._ts > 0 ? (X - d._start) * d._ts : (d._dirty ? d.totalDuration() : d._tDur) + (X - d._start) * d._ts, o, s || Lo && (d._initted || d._startAt)), p !== this._time || !this._ts && !_) {
              b = 0, h && (a += this._zTime = X ? -jn : jn);
              break;
            }
          }
          d = h;
        }
      }
      if (b && !o && (this.pause(), b.render(p >= i ? 0 : -jn)._zTime = p >= i ? 1 : -1, this._ts))
        return this._start = S, Q_(this), this.render(r, o, s);
      this._onUpdate && !o && Js(this, "onUpdate", !0), (a === u && this._tTime >= this.totalDuration() || !a && i) && (S === this._start || Math.abs(x) !== Math.abs(this._ts)) && (this._lock || ((r || !l) && (a === u && this._ts > 0 || !a && this._ts < 0) && wc(this, 1), !o && !(r < 0 && !i) && (a || i || !u) && (Js(this, a === u && r >= 0 ? "onComplete" : "onReverseComplete", !0), this._prom && !(a < u && this.timeScale() > 0) && this._prom())));
    }
    return this;
  }, n.add = function(r, o) {
    var s = this;
    if (il(o) || (o = ba(this, o, r)), !(r instanceof bm)) {
      if (Bo(r))
        return r.forEach(function(i) {
          return s.add(i, o);
        }), this;
      if (wo(r))
        return this.addLabel(r, o);
      if (Ar(r))
        r = Hr.delayedCall(0, r);
      else
        return this;
    }
    return this !== r ? Ki(this, r, o) : this;
  }, n.getChildren = function(r, o, s, i) {
    r === void 0 && (r = !0), o === void 0 && (o = !0), s === void 0 && (s = !0), i === void 0 && (i = -Ea);
    for (var u = [], l = this._first; l; )
      l._start >= i && (l instanceof Hr ? o && u.push(l) : (s && u.push(l), r && u.push.apply(u, l.getChildren(!0, o, s)))), l = l._next;
    return u;
  }, n.getById = function(r) {
    for (var o = this.getChildren(1, 1, 1), s = o.length; s--; )
      if (o[s].vars.id === r)
        return o[s];
  }, n.remove = function(r) {
    return wo(r) ? this.removeLabel(r) : Ar(r) ? this.killTweensOf(r) : (Y_(this, r), r === this._recent && (this._recent = this._last), Ap(this));
  }, n.totalTime = function(r, o) {
    return arguments.length ? (this._forcing = 1, !this._dp && this._ts && (this._start = go(Qs.time - (this._ts > 0 ? r / this._ts : (this.totalDuration() - r) / -this._ts))), t.prototype.totalTime.call(this, r, o), this._forcing = 0, this) : this._tTime;
  }, n.addLabel = function(r, o) {
    return this.labels[r] = ba(this, o), this;
  }, n.removeLabel = function(r) {
    return delete this.labels[r], this;
  }, n.addPause = function(r, o, s) {
    var i = Hr.delayedCall(0, o || vm, s);
    return i.data = "isPause", this._hasPause = 1, Ki(this, i, ba(this, r));
  }, n.removePause = function(r) {
    var o = this._first;
    for (r = ba(this, r); o; )
      o._start === r && o.data === "isPause" && wc(o), o = o._next;
  }, n.killTweensOf = function(r, o, s) {
    for (var i = this.getTweensOf(r, s), u = i.length; u--; )
      nc !== i[u] && i[u].kill(r, o);
    return this;
  }, n.getTweensOf = function(r, o) {
    for (var s = [], i = Ma(r), u = this._first, l = il(o), a; u; )
      u instanceof Hr ? L2e(u._targets, i) && (l ? (!nc || u._initted && u._ts) && u.globalTime(0) <= o && u.globalTime(u.totalDuration()) > o : !o || u.isActive()) && s.push(u) : (a = u.getTweensOf(i, o)).length && s.push.apply(s, a), u = u._next;
    return s;
  }, n.tweenTo = function(r, o) {
    o = o || {};
    var s = this, i = ba(s, r), u = o, l = u.startAt, a = u.onStart, c = u.onStartParams, p = u.immediateRender, d, h = Hr.to(s, La({
      ease: o.ease || "none",
      lazy: !1,
      immediateRender: !1,
      time: i,
      overwrite: "auto",
      duration: o.duration || Math.abs((i - (l && "time" in l ? l.time : s._time)) / s.timeScale()) || jn,
      onStart: function() {
        if (s.pause(), !d) {
          var m = o.duration || Math.abs((i - (l && "time" in l ? l.time : s._time)) / s.timeScale());
          h._dur !== m && bh(h, m, 0, 1).render(h._time, !0, !0), d = 1;
        }
        a && a.apply(h, c || []);
      }
    }, o));
    return p ? h.render(0) : h;
  }, n.tweenFromTo = function(r, o, s) {
    return this.tweenTo(o, La({
      startAt: {
        time: ba(this, r)
      }
    }, s));
  }, n.recent = function() {
    return this._recent;
  }, n.nextLabel = function(r) {
    return r === void 0 && (r = this._time), vO(this, ba(this, r));
  }, n.previousLabel = function(r) {
    return r === void 0 && (r = this._time), vO(this, ba(this, r), 1);
  }, n.currentLabel = function(r) {
    return arguments.length ? this.seek(r, !0) : this.previousLabel(this._time + jn);
  }, n.shiftChildren = function(r, o, s) {
    s === void 0 && (s = 0);
    for (var i = this._first, u = this.labels, l; i; )
      i._start >= s && (i._start += r, i._end += r), i = i._next;
    if (o)
      for (l in u)
        u[l] >= s && (u[l] += r);
    return Ap(this);
  }, n.invalidate = function(r) {
    var o = this._first;
    for (this._lock = 0; o; )
      o.invalidate(r), o = o._next;
    return t.prototype.invalidate.call(this, r);
  }, n.clear = function(r) {
    r === void 0 && (r = !0);
    for (var o = this._first, s; o; )
      s = o._next, this.remove(o), o = s;
    return this._dp && (this._time = this._tTime = this._pTime = 0), r && (this.labels = {}), Ap(this);
  }, n.totalDuration = function(r) {
    var o = 0, s = this, i = s._last, u = Ea, l, a, c;
    if (arguments.length)
      return s.timeScale((s._repeat < 0 ? s.duration() : s.totalDuration()) / (s.reversed() ? -r : r));
    if (s._dirty) {
      for (c = s.parent; i; )
        l = i._prev, i._dirty && i.totalDuration(), a = i._start, a > u && s._sort && i._ts && !s._lock ? (s._lock = 1, Ki(s, i, a - i._delay, 1)._lock = 0) : u = a, a < 0 && i._ts && (o -= a, (!c && !s._dp || c && c.smoothChildTiming) && (s._start += a / s._ts, s._time -= a, s._tTime -= a), s.shiftChildren(-a, !1, -1 / 0), u = 0), i._end > o && i._ts && (o = i._end), i = l;
      bh(s, s === fr && s._time > o ? s._time : o, 1, 1), s._dirty = 0;
    }
    return s._tDur;
  }, e.updateRoot = function(r) {
    if (fr._ts && (L6(fr, wv(r, fr)), F6 = Qs.frame), Qs.frame >= fO) {
      fO += ea.autoSleep || 120;
      var o = fr._first;
      if ((!o || !o._ts) && ea.autoSleep && Qs._listeners.length < 2) {
        for (; o && !o._ts; )
          o = o._next;
        o || Qs.sleep();
      }
    }
  }, e;
}(bm);
La(Ko.prototype, {
  _lock: 0,
  _hasPause: 0,
  _forcing: 0
});
var aSe = function(t, e, n, r, o, s, i) {
  var u = new xs(this._pt, t, e, 0, 1, p5, null, o), l = 0, a = 0, c, p, d, h, m, g, _, b;
  for (u.b = n, u.e = r, n += "", r += "", (_ = ~r.indexOf("random(")) && (r = _m(r)), s && (b = [n, r], s(b, t, e), n = b[0], r = b[1]), p = n.match(Ib) || []; c = Ib.exec(r); )
    h = c[0], m = r.substring(l, c.index), d ? d = (d + 1) % 5 : m.substr(-5) === "rgba(" && (d = 1), h !== p[a++] && (g = parseFloat(p[a - 1]) || 0, u._pt = {
      _next: u._pt,
      p: m || a === 1 ? m : ",",
      //note: SVG spec allows omission of comma/space when a negative sign is wedged between two numbers, like 2.5-5.3 instead of 2.5,-5.3 but when tweening, the negative value may switch to positive, so we insert the comma just in case.
      s: g,
      c: h.charAt(1) === "=" ? Zd(g, h) - g : parseFloat(h) - g,
      m: d && d < 4 ? Math.round : 0
    }, l = Ib.lastIndex);
  return u.c = l < r.length ? r.substring(l, r.length) : "", u.fp = i, (M6.test(r) || _) && (u.e = 0), this._pt = u, u;
}, $S = function(t, e, n, r, o, s, i, u, l, a) {
  Ar(r) && (r = r(o || 0, t, s));
  var c = t[e], p = n !== "get" ? n : Ar(c) ? l ? t[e.indexOf("set") || !Ar(t["get" + e.substr(3)]) ? e : "get" + e.substr(3)](l) : t[e]() : c, d = Ar(c) ? l ? pSe : l5 : VS, h;
  if (wo(r) && (~r.indexOf("random(") && (r = _m(r)), r.charAt(1) === "=" && (h = Zd(p, r) + (No(p) || 0), (h || h === 0) && (r = h))), !a || p !== r || VT)
    return !isNaN(p * r) && r !== "" ? (h = new xs(this._pt, t, e, +p || 0, r - (p || 0), typeof c == "boolean" ? hSe : c5, 0, d), l && (h.fp = l), i && h.modifier(i, this, t), this._pt = h) : (!c && !(e in t) && LS(e, r), aSe.call(this, t, e, p, r, d, u || ea.stringFilter, l));
}, iSe = function(t, e, n, r, o) {
  if (Ar(t) && (t = nm(t, o, e, n, r)), !gu(t) || t.style && t.nodeType || Bo(t) || D6(t))
    return wo(t) ? nm(t, o, e, n, r) : t;
  var s = {}, i;
  for (i in t)
    s[i] = nm(t[i], o, e, n, r);
  return s;
}, a5 = function(t, e, n, r, o, s) {
  var i, u, l, a;
  if (zs[t] && (i = new zs[t]()).init(o, i.rawVars ? e[t] : iSe(e[t], r, o, s, n), n, r, s) !== !1 && (n._pt = u = new xs(n._pt, o, t, 0, 1, i.render, i, 0, i.priority), n !== Ud))
    for (l = n._ptLookup[n._targets.indexOf(o)], a = i._props.length; a--; )
      l[i._props[a]] = u;
  return i;
}, nc, VT, WS = function t(e, n, r) {
  var o = e.vars, s = o.ease, i = o.startAt, u = o.immediateRender, l = o.lazy, a = o.onUpdate, c = o.runBackwards, p = o.yoyoEase, d = o.keyframes, h = o.autoRevert, m = e._dur, g = e._startAt, _ = e._targets, b = e.parent, x = b && b.data === "nested" ? b.vars.targets : _, S = e._overwrite === "auto" && !OS, E = e.timeline, A, C, M, L, X, te, B, W, G, ne, de, V, Y;
  if (E && (!d || !s) && (s = "none"), e._ease = Dp(s, _h.ease), e._yEase = p ? n5(Dp(p === !0 ? s : p, _h.ease)) : 0, p && e._yoyo && !e._repeat && (p = e._yEase, e._yEase = e._ease, e._ease = p), e._from = !E && !!o.runBackwards, !E || d && !o.stagger) {
    if (W = _[0] ? Rp(_[0]).harness : 0, V = W && o[W.prop], A = _v(o, BS), g && (g._zTime < 0 && g.progress(1), n < 0 && c && u && !h ? g.render(-1, !0) : g.revert(c && m ? d0 : F2e), g._lazy = 0), i) {
      if (wc(e._startAt = Hr.set(_, La({
        data: "isStart",
        overwrite: !1,
        parent: b,
        immediateRender: !0,
        lazy: !g && ks(l),
        startAt: null,
        delay: 0,
        onUpdate: a && function() {
          return Js(e, "onUpdate");
        },
        stagger: 0
      }, i))), e._startAt._dp = 0, e._startAt._sat = e, n < 0 && (Lo || !u && !h) && e._startAt.revert(d0), u && m && n <= 0 && r <= 0) {
        n && (e._zTime = n);
        return;
      }
    } else if (c && m && !g) {
      if (n && (u = !1), M = La({
        overwrite: !1,
        data: "isFromStart",
        //we tag the tween with as "isFromStart" so that if [inside a plugin] we need to only do something at the very END of a tween, we have a way of identifying this tween as merely the one that's setting the beginning values for a "from()" tween. For example, clearProps in CSSPlugin should only get applied at the very END of a tween and without this tag, from(...{height:100, clearProps:"height", delay:1}) would wipe the height at the beginning of the tween and after 1 second, it'd kick back in.
        lazy: u && !g && ks(l),
        immediateRender: u,
        //zero-duration tweens render immediately by default, but if we're not specifically instructed to render this tween immediately, we should skip this and merely _init() to record the starting values (rendering them immediately would push them to completion which is wasteful in that case - we'd have to render(-1) immediately after)
        stagger: 0,
        parent: b
        //ensures that nested tweens that had a stagger are handled properly, like gsap.from(".class", {y: gsap.utils.wrap([-100,100]), stagger: 0.5})
      }, A), V && (M[W.prop] = V), wc(e._startAt = Hr.set(_, M)), e._startAt._dp = 0, e._startAt._sat = e, n < 0 && (Lo ? e._startAt.revert(d0) : e._startAt.render(-1, !0)), e._zTime = n, !u)
        t(e._startAt, jn, jn);
      else if (!n)
        return;
    }
    for (e._pt = e._ptCache = 0, l = m && ks(l) || l && !m, C = 0; C < _.length; C++) {
      if (X = _[C], B = X._gsap || XS(_)[C]._gsap, e._ptLookup[C] = ne = {}, LT[B.id] && cc.length && vv(), de = x === _ ? C : x.indexOf(X), W && (G = new W()).init(X, V || A, e, de, x) !== !1 && (e._pt = L = new xs(e._pt, X, G.name, 0, 1, G.render, G, 0, G.priority), G._props.forEach(function(Q) {
        ne[Q] = L;
      }), G.priority && (te = 1)), !W || V)
        for (M in A)
          zs[M] && (G = a5(M, A, e, de, X, x)) ? G.priority && (te = 1) : ne[M] = L = $S.call(e, X, M, "get", A[M], de, x, 0, o.stringFilter);
      e._op && e._op[C] && e.kill(X, e._op[C]), S && e._pt && (nc = e, fr.killTweensOf(X, ne, e.globalTime(n)), Y = !e.parent, nc = 0), e._pt && l && (LT[B.id] = 1);
    }
    te && d5(e), e._onInit && e._onInit(e);
  }
  e._onUpdate = a, e._initted = (!e._op || e._pt) && !Y, d && n <= 0 && E.render(Ea, !0, !0);
}, uSe = function(t, e, n, r, o, s, i, u) {
  var l = (t._pt && t._ptCache || (t._ptCache = {}))[e], a, c, p, d;
  if (!l)
    for (l = t._ptCache[e] = [], p = t._ptLookup, d = t._targets.length; d--; ) {
      if (a = p[d][e], a && a.d && a.d._pt)
        for (a = a.d._pt; a && a.p !== e && a.fp !== e; )
          a = a._next;
      if (!a)
        return VT = 1, t.vars[e] = "+=0", WS(t, i), VT = 0, u ? gm(e + " not eligible for reset") : 1;
      l.push(a);
    }
  for (d = l.length; d--; )
    c = l[d], a = c._pt || c, a.s = (r || r === 0) && !o ? r : a.s + (r || 0) + s * a.c, a.c = n - a.s, c.e && (c.e = Ir(n) + No(c.e)), c.b && (c.b = a.s + No(c.b));
}, lSe = function(t, e) {
  var n = t[0] ? Rp(t[0]).harness : 0, r = n && n.aliases, o, s, i, u;
  if (!r)
    return e;
  o = $p({}, e);
  for (s in r)
    if (s in o)
      for (u = r[s].split(","), i = u.length; i--; )
        o[u[i]] = o[s];
  return o;
}, cSe = function(t, e, n, r) {
  var o = e.ease || r || "power1.inOut", s, i;
  if (Bo(e))
    i = n[t] || (n[t] = []), e.forEach(function(u, l) {
      return i.push({
        t: l / (e.length - 1) * 100,
        v: u,
        e: o
      });
    });
  else
    for (s in e)
      i = n[s] || (n[s] = []), s === "ease" || i.push({
        t: parseFloat(t),
        v: e[s],
        e: o
      });
}, nm = function(t, e, n, r, o) {
  return Ar(t) ? t.call(e, n, r, o) : wo(t) && ~t.indexOf("random(") ? _m(t) : t;
}, i5 = US + "repeat,repeatDelay,yoyo,repeatRefresh,yoyoEase,autoRevert", u5 = {};
Ts(i5 + ",id,stagger,delay,duration,paused,scrollTrigger", function(t) {
  return u5[t] = 1;
});
var Hr = /* @__PURE__ */ function(t) {
  R6(e, t);
  function e(r, o, s, i) {
    var u;
    typeof o == "number" && (s.duration = o, o = s, s = null), u = t.call(this, i ? o : em(o)) || this;
    var l = u.vars, a = l.duration, c = l.delay, p = l.immediateRender, d = l.stagger, h = l.overwrite, m = l.keyframes, g = l.defaults, _ = l.scrollTrigger, b = l.yoyoEase, x = o.parent || fr, S = (Bo(r) || D6(r) ? il(r[0]) : "length" in o) ? [r] : Ma(r), E, A, C, M, L, X, te, B;
    if (u._targets = S.length ? XS(S) : gm("GSAP target " + r + " not found. https://gsap.com", !ea.nullTargetWarn) || [], u._ptLookup = [], u._overwrite = h, m || d || Ig(a) || Ig(c)) {
      if (o = u.vars, E = u.timeline = new Ko({
        data: "nested",
        defaults: g || {},
        targets: x && x.data === "nested" ? x.vars.targets : S
      }), E.kill(), E.parent = E._dp = ju(u), E._start = 0, d || Ig(a) || Ig(c)) {
        if (M = S.length, te = d && z6(d), gu(d))
          for (L in d)
            ~i5.indexOf(L) && (B || (B = {}), B[L] = d[L]);
        for (A = 0; A < M; A++)
          C = _v(o, u5), C.stagger = 0, b && (C.yoyoEase = b), B && $p(C, B), X = S[A], C.duration = +nm(a, ju(u), A, X, S), C.delay = (+nm(c, ju(u), A, X, S) || 0) - u._delay, !d && M === 1 && C.delay && (u._delay = c = C.delay, u._start += c, C.delay = 0), E.to(X, C, te ? te(A, X, S) : 0), E._ease = yn.none;
        E.duration() ? a = c = 0 : u.timeline = 0;
      } else if (m) {
        em(La(E.vars.defaults, {
          ease: "none"
        })), E._ease = Dp(m.ease || o.ease || "none");
        var W = 0, G, ne, de;
        if (Bo(m))
          m.forEach(function(V) {
            return E.to(S, V, ">");
          }), E.duration();
        else {
          C = {};
          for (L in m)
            L === "ease" || L === "easeEach" || cSe(L, m[L], C, m.easeEach);
          for (L in C)
            for (G = C[L].sort(function(V, Y) {
              return V.t - Y.t;
            }), W = 0, A = 0; A < G.length; A++)
              ne = G[A], de = {
                ease: ne.e,
                duration: (ne.t - (A ? G[A - 1].t : 0)) / 100 * a
              }, de[L] = ne.v, E.to(S, de, W), W += de.duration;
          E.duration() < a && E.to({}, {
            duration: a - E.duration()
          });
        }
      }
      a || u.duration(a = E.duration());
    } else
      u.timeline = 0;
    return h === !0 && !OS && (nc = ju(u), fr.killTweensOf(S), nc = 0), Ki(x, ju(u), s), o.reversed && u.reverse(), o.paused && u.paused(!0), (p || !a && !m && u._start === go(x._time) && ks(p) && $2e(ju(u)) && x.data !== "nested") && (u._tTime = -jn, u.render(Math.max(0, -c) || 0)), _ && W6(ju(u), _), u;
  }
  var n = e.prototype;
  return n.render = function(r, o, s) {
    var i = this._time, u = this._tDur, l = this._dur, a = r < 0, c = r > u - jn && !a ? u : r < jn ? 0 : r, p, d, h, m, g, _, b, x, S;
    if (!l)
      V2e(this, r, o, s);
    else if (c !== this._tTime || !r || s || !this._initted && this._tTime || this._startAt && this._zTime < 0 !== a) {
      if (p = c, x = this.timeline, this._repeat) {
        if (m = l + this._rDelay, this._repeat < -1 && a)
          return this.totalTime(m * 100 + r, o, s);
        if (p = go(c % m), c === u ? (h = this._repeat, p = l) : (h = ~~(c / m), h && h === go(c / m) && (p = l, h--), p > l && (p = l)), _ = this._yoyo && h & 1, _ && (S = this._yEase, p = l - p), g = wh(this._tTime, m), p === i && !s && this._initted && h === g)
          return this._tTime = c, this;
        h !== g && (x && this._yEase && r5(x, _), this.vars.repeatRefresh && !_ && !this._lock && this._time !== m && this._initted && (this._lock = s = 1, this.render(go(m * h), !0).invalidate()._lock = 0));
      }
      if (!this._initted) {
        if (V6(this, a ? r : p, s, o, c))
          return this._tTime = 0, this;
        if (i !== this._time && !(s && this.vars.repeatRefresh && h !== g))
          return this;
        if (l !== this._dur)
          return this.render(r, o, s);
      }
      if (this._tTime = c, this._time = p, !this._act && this._ts && (this._act = 1, this._lazy = 0), this.ratio = b = (S || this._ease)(p / l), this._from && (this.ratio = b = 1 - b), p && !i && !o && !h && (Js(this, "onStart"), this._tTime !== c))
        return this;
      for (d = this._pt; d; )
        d.r(b, d.d), d = d._next;
      x && x.render(r < 0 ? r : x._dur * x._ease(p / this._dur), o, s) || this._startAt && (this._zTime = r), this._onUpdate && !o && (a && BT(this, r, o, s), Js(this, "onUpdate")), this._repeat && h !== g && this.vars.onRepeat && !o && this.parent && Js(this, "onRepeat"), (c === this._tDur || !c) && this._tTime === c && (a && !this._onUpdate && BT(this, r, !0, !0), (r || !l) && (c === this._tDur && this._ts > 0 || !c && this._ts < 0) && wc(this, 1), !o && !(a && !i) && (c || i || _) && (Js(this, c === u ? "onComplete" : "onReverseComplete", !0), this._prom && !(c < u && this.timeScale() > 0) && this._prom()));
    }
    return this;
  }, n.targets = function() {
    return this._targets;
  }, n.invalidate = function(r) {
    return (!r || !this.vars.runBackwards) && (this._startAt = 0), this._pt = this._op = this._onUpdate = this._lazy = this.ratio = 0, this._ptLookup = [], this.timeline && this.timeline.invalidate(r), t.prototype.invalidate.call(this, r);
  }, n.resetTo = function(r, o, s, i, u) {
    wm || Qs.wake(), this._ts || this.play();
    var l = Math.min(this._dur, (this._dp._time - this._start) * this._ts), a;
    return this._initted || WS(this, l), a = this._ease(l / this._dur), uSe(this, r, o, s, i, a, l, u) ? this.resetTo(r, o, s, i, 1) : (K_(this, 0), this.parent || X6(this._dp, this, "_first", "_last", this._dp._sort ? "_start" : 0), this.render(0));
  }, n.kill = function(r, o) {
    if (o === void 0 && (o = "all"), !r && (!o || o === "all"))
      return this._lazy = this._pt = 0, this.parent ? Hf(this) : this;
    if (this.timeline) {
      var s = this.timeline.totalDuration();
      return this.timeline.killTweensOf(r, o, nc && nc.vars.overwrite !== !0)._first || Hf(this), this.parent && s !== this.timeline.totalDuration() && bh(this, this._dur * this.timeline._tDur / s, 0, 1), this;
    }
    var i = this._targets, u = r ? Ma(r) : i, l = this._ptLookup, a = this._pt, c, p, d, h, m, g, _;
    if ((!o || o === "all") && U2e(i, u))
      return o === "all" && (this._pt = 0), Hf(this);
    for (c = this._op = this._op || [], o !== "all" && (wo(o) && (m = {}, Ts(o, function(b) {
      return m[b] = 1;
    }), o = m), o = lSe(i, o)), _ = i.length; _--; )
      if (~u.indexOf(i[_])) {
        p = l[_], o === "all" ? (c[_] = o, h = p, d = {}) : (d = c[_] = c[_] || {}, h = o);
        for (m in h)
          g = p && p[m], g && ((!("kill" in g.d) || g.d.kill(m) === !0) && Y_(this, g, "_pt"), delete p[m]), d !== "all" && (d[m] = 1);
      }
    return this._initted && !this._pt && a && Hf(this), this;
  }, e.to = function(r, o) {
    return new e(r, o, arguments[2]);
  }, e.from = function(r, o) {
    return tm(1, arguments);
  }, e.delayedCall = function(r, o, s, i) {
    return new e(o, 0, {
      immediateRender: !1,
      lazy: !1,
      overwrite: !1,
      delay: r,
      onComplete: o,
      onReverseComplete: o,
      onCompleteParams: s,
      onReverseCompleteParams: s,
      callbackScope: i
    });
  }, e.fromTo = function(r, o, s) {
    return tm(2, arguments);
  }, e.set = function(r, o) {
    return o.duration = 0, o.repeatDelay || (o.repeat = 0), new e(r, o);
  }, e.killTweensOf = function(r, o, s) {
    return fr.killTweensOf(r, o, s);
  }, e;
}(bm);
La(Hr.prototype, {
  _targets: [],
  _lazy: 0,
  _startAt: 0,
  _op: 0,
  _onInit: 0
});
Ts("staggerTo,staggerFrom,staggerFromTo", function(t) {
  Hr[t] = function() {
    var e = new Ko(), n = XT.call(arguments, 0);
    return n.splice(t === "staggerFromTo" ? 5 : 4, 0, 0), e[t].apply(e, n);
  };
});
var VS = function(t, e, n) {
  return t[e] = n;
}, l5 = function(t, e, n) {
  return t[e](n);
}, pSe = function(t, e, n, r) {
  return t[e](r.fp, n);
}, dSe = function(t, e, n) {
  return t.setAttribute(e, n);
}, HS = function(t, e) {
  return Ar(t[e]) ? l5 : IS(t[e]) && t.setAttribute ? dSe : VS;
}, c5 = function(t, e) {
  return e.set(e.t, e.p, Math.round((e.s + e.c * t) * 1e6) / 1e6, e);
}, hSe = function(t, e) {
  return e.set(e.t, e.p, !!(e.s + e.c * t), e);
}, p5 = function(t, e) {
  var n = e._pt, r = "";
  if (!t && e.b)
    r = e.b;
  else if (t === 1 && e.e)
    r = e.e;
  else {
    for (; n; )
      r = n.p + (n.m ? n.m(n.s + n.c * t) : Math.round((n.s + n.c * t) * 1e4) / 1e4) + r, n = n._next;
    r += e.c;
  }
  e.set(e.t, e.p, r, e);
}, jS = function(t, e) {
  for (var n = e._pt; n; )
    n.r(t, n.d), n = n._next;
}, fSe = function(t, e, n, r) {
  for (var o = this._pt, s; o; )
    s = o._next, o.p === r && o.modifier(t, e, n), o = s;
}, mSe = function(t) {
  for (var e = this._pt, n, r; e; )
    r = e._next, e.p === t && !e.op || e.op === t ? Y_(this, e, "_pt") : e.dep || (n = 1), e = r;
  return !n;
}, ySe = function(t, e, n, r) {
  r.mSet(t, e, r.m.call(r.tween, n, r.mt), r);
}, d5 = function(t) {
  for (var e = t._pt, n, r, o, s; e; ) {
    for (n = e._next, r = o; r && r.pr > e.pr; )
      r = r._next;
    (e._prev = r ? r._prev : s) ? e._prev._next = e : o = e, (e._next = r) ? r._prev = e : s = e, e = n;
  }
  t._pt = o;
}, xs = /* @__PURE__ */ function() {
  function t(n, r, o, s, i, u, l, a, c) {
    this.t = r, this.s = s, this.c = i, this.p = o, this.r = u || c5, this.d = l || this, this.set = a || VS, this.pr = c || 0, this._next = n, n && (n._prev = this);
  }
  var e = t.prototype;
  return e.modifier = function(n, r, o) {
    this.mSet = this.mSet || this.set, this.set = ySe, this.m = n, this.mt = o, this.tween = r;
  }, t;
}();
Ts(US + "parent,duration,ease,delay,overwrite,runBackwards,startAt,yoyo,immediateRender,repeat,repeatDelay,data,paused,reversed,lazy,callbackScope,stringFilter,id,yoyoEase,stagger,inherit,repeatRefresh,keyframes,autoRevert,scrollTrigger", function(t) {
  return BS[t] = 1;
});
ta.TweenMax = ta.TweenLite = Hr;
ta.TimelineLite = ta.TimelineMax = Ko;
fr = new Ko({
  sortChildren: !1,
  defaults: _h,
  autoRemoveChildren: !0,
  id: "root",
  smoothChildTiming: !0
});
ea.stringFilter = t5;
var Ep = [], f0 = {}, gSe = [], wO = 0, vSe = 0, Ub = function(t) {
  return (f0[t] || gSe).map(function(e) {
    return e();
  });
}, HT = function() {
  var t = Date.now(), e = [];
  t - wO > 2 && (Ub("matchMediaInit"), Ep.forEach(function(n) {
    var r = n.queries, o = n.conditions, s, i, u, l;
    for (i in r)
      s = qi.matchMedia(r[i]).matches, s && (u = 1), s !== o[i] && (o[i] = s, l = 1);
    l && (n.revert(), u && e.push(n));
  }), Ub("matchMediaRevert"), e.forEach(function(n) {
    return n.onMatch(n, function(r) {
      return n.add(null, r);
    });
  }), wO = t, Ub("matchMedia"));
}, h5 = /* @__PURE__ */ function() {
  function t(n, r) {
    this.selector = r && $T(r), this.data = [], this._r = [], this.isReverted = !1, this.id = vSe++, n && this.add(n);
  }
  var e = t.prototype;
  return e.add = function(n, r, o) {
    Ar(n) && (o = r, r = n, n = Ar);
    var s = this, i = function() {
      var u = rr, l = s.selector, a;
      return u && u !== s && u.data.push(s), o && (s.selector = $T(o)), rr = s, a = r.apply(s, arguments), Ar(a) && s._r.push(a), rr = u, s.selector = l, s.isReverted = !1, a;
    };
    return s.last = i, n === Ar ? i(s, function(u) {
      return s.add(null, u);
    }) : n ? s[n] = i : i;
  }, e.ignore = function(n) {
    var r = rr;
    rr = null, n(this), rr = r;
  }, e.getTweens = function() {
    var n = [];
    return this.data.forEach(function(r) {
      return r instanceof t ? n.push.apply(n, r.getTweens()) : r instanceof Hr && !(r.parent && r.parent.data === "nested") && n.push(r);
    }), n;
  }, e.clear = function() {
    this._r.length = this.data.length = 0;
  }, e.kill = function(n, r) {
    var o = this;
    if (n ? function() {
      for (var i = o.getTweens(), u = o.data.length, l; u--; )
        l = o.data[u], l.data === "isFlip" && (l.revert(), l.getChildren(!0, !0, !1).forEach(function(a) {
          return i.splice(i.indexOf(a), 1);
        }));
      for (i.map(function(a) {
        return {
          g: a._dur || a._delay || a._sat && !a._sat.vars.immediateRender ? a.globalTime(0) : -1 / 0,
          t: a
        };
      }).sort(function(a, c) {
        return c.g - a.g || -1 / 0;
      }).forEach(function(a) {
        return a.t.revert(n);
      }), u = o.data.length; u--; )
        l = o.data[u], l instanceof Ko ? l.data !== "nested" && (l.scrollTrigger && l.scrollTrigger.revert(), l.kill()) : !(l instanceof Hr) && l.revert && l.revert(n);
      o._r.forEach(function(a) {
        return a(n, o);
      }), o.isReverted = !0;
    }() : this.data.forEach(function(i) {
      return i.kill && i.kill();
    }), this.clear(), r)
      for (var s = Ep.length; s--; )
        Ep[s].id === this.id && Ep.splice(s, 1);
  }, e.revert = function(n) {
    this.kill(n || {});
  }, t;
}(), _Se = /* @__PURE__ */ function() {
  function t(n) {
    this.contexts = [], this.scope = n, rr && rr.data.push(this);
  }
  var e = t.prototype;
  return e.add = function(n, r, o) {
    gu(n) || (n = {
      matches: n
    });
    var s = new h5(0, o || this.scope), i = s.conditions = {}, u, l, a;
    rr && !s.selector && (s.selector = rr.selector), this.contexts.push(s), r = s.add("onMatch", r), s.queries = n;
    for (l in n)
      l === "all" ? a = 1 : (u = qi.matchMedia(n[l]), u && (Ep.indexOf(s) < 0 && Ep.push(s), (i[l] = u.matches) && (a = 1), u.addListener ? u.addListener(HT) : u.addEventListener("change", HT)));
    return a && r(s, function(c) {
      return s.add(null, c);
    }), this;
  }, e.revert = function(n) {
    this.kill(n || {});
  }, e.kill = function(n) {
    this.contexts.forEach(function(r) {
      return r.kill(n, !0);
    });
  }, t;
}(), bv = {
  registerPlugin: function() {
    for (var t = arguments.length, e = new Array(t), n = 0; n < t; n++)
      e[n] = arguments[n];
    e.forEach(function(r) {
      return Z6(r);
    });
  },
  timeline: function(t) {
    return new Ko(t);
  },
  getTweensOf: function(t, e) {
    return fr.getTweensOf(t, e);
  },
  getProperty: function(t, e, n, r) {
    wo(t) && (t = Ma(t)[0]);
    var o = Rp(t || {}).get, s = n ? U6 : B6;
    return n === "native" && (n = ""), t && (e ? s((zs[e] && zs[e].get || o)(t, e, n, r)) : function(i, u, l) {
      return s((zs[i] && zs[i].get || o)(t, i, u, l));
    });
  },
  quickSetter: function(t, e, n) {
    if (t = Ma(t), t.length > 1) {
      var r = t.map(function(a) {
        return Es.quickSetter(a, e, n);
      }), o = r.length;
      return function(a) {
        for (var c = o; c--; )
          r[c](a);
      };
    }
    t = t[0] || {};
    var s = zs[e], i = Rp(t), u = i.harness && (i.harness.aliases || {})[e] || e, l = s ? function(a) {
      var c = new s();
      Ud._pt = 0, c.init(t, n ? a + n : a, Ud, 0, [t]), c.render(1, c), Ud._pt && jS(1, Ud);
    } : i.set(t, u);
    return s ? l : function(a) {
      return l(t, u, n ? a + n : a, i, 1);
    };
  },
  quickTo: function(t, e, n) {
    var r, o = Es.to(t, $p((r = {}, r[e] = "+=0.1", r.paused = !0, r), n || {})), s = function(i, u, l) {
      return o.resetTo(e, i, u, l);
    };
    return s.tween = o, s;
  },
  isTweening: function(t) {
    return fr.getTweensOf(t, !0).length > 0;
  },
  defaults: function(t) {
    return t && t.ease && (t.ease = Dp(t.ease, _h.ease)), mO(_h, t || {});
  },
  config: function(t) {
    return mO(ea, t || {});
  },
  registerEffect: function(t) {
    var e = t.name, n = t.effect, r = t.plugins, o = t.defaults, s = t.extendTimeline;
    (r || "").split(",").forEach(function(i) {
      return i && !zs[i] && !ta[i] && gm(e + " effect requires " + i + " plugin.");
    }), Fb[e] = function(i, u, l) {
      return n(Ma(i), La(u || {}, o), l);
    }, s && (Ko.prototype[e] = function(i, u, l) {
      return this.add(Fb[e](i, gu(u) ? u : (l = u) && {}, this), l);
    });
  },
  registerEase: function(t, e) {
    yn[t] = Dp(e);
  },
  parseEase: function(t, e) {
    return arguments.length ? Dp(t, e) : yn;
  },
  getById: function(t) {
    return fr.getById(t);
  },
  exportRoot: function(t, e) {
    t === void 0 && (t = {});
    var n = new Ko(t), r, o;
    for (n.smoothChildTiming = ks(t.smoothChildTiming), fr.remove(n), n._dp = 0, n._time = n._tTime = fr._time, r = fr._first; r; )
      o = r._next, (e || !(!r._dur && r instanceof Hr && r.vars.onComplete === r._targets[0])) && Ki(n, r, r._start - r._delay), r = o;
    return Ki(fr, n, 0), n;
  },
  context: function(t, e) {
    return t ? new h5(t, e) : rr;
  },
  matchMedia: function(t) {
    return new _Se(t);
  },
  matchMediaRefresh: function() {
    return Ep.forEach(function(t) {
      var e = t.conditions, n, r;
      for (r in e)
        e[r] && (e[r] = !1, n = 1);
      n && t.revert();
    }) || HT();
  },
  addEventListener: function(t, e) {
    var n = f0[t] || (f0[t] = []);
    ~n.indexOf(e) || n.push(e);
  },
  removeEventListener: function(t, e) {
    var n = f0[t], r = n && n.indexOf(e);
    r >= 0 && n.splice(r, 1);
  },
  utils: {
    wrap: K2e,
    wrapYoyo: Z2e,
    distribute: z6,
    random: G6,
    snap: q6,
    normalize: Q2e,
    getUnit: No,
    clamp: z2e,
    splitColor: J6,
    toArray: Ma,
    selector: $T,
    mapRange: Q6,
    pipe: G2e,
    unitize: Y2e,
    interpolate: J2e,
    shuffle: j6
  },
  install: O6,
  effects: Fb,
  ticker: Qs,
  updateRoot: Ko.updateRoot,
  plugins: zs,
  globalTimeline: fr,
  core: {
    PropTween: xs,
    globals: I6,
    Tween: Hr,
    Timeline: Ko,
    Animation: bm,
    getCache: Rp,
    _removeLinkedListItem: Y_,
    reverting: function() {
      return Lo;
    },
    context: function(t) {
      return t && rr && (rr.data.push(t), t._ctx = rr), rr;
    },
    suppressOverwrites: function(t) {
      return OS = t;
    }
  }
};
Ts("to,from,fromTo,delayedCall,set,killTweensOf", function(t) {
  return bv[t] = Hr[t];
});
Qs.add(Ko.updateRoot);
Ud = bv.to({}, {
  duration: 0
});
var wSe = function(t, e) {
  for (var n = t._pt; n && n.p !== e && n.op !== e && n.fp !== e; )
    n = n._next;
  return n;
}, bSe = function(t, e) {
  var n = t._targets, r, o, s;
  for (r in e)
    for (o = n.length; o--; )
      s = t._ptLookup[o][r], s && (s = s.d) && (s._pt && (s = wSe(s, r)), s && s.modifier && s.modifier(e[r], t, n[o], r));
}, Xb = function(t, e) {
  return {
    name: t,
    rawVars: 1,
    //don't pre-process function-based values or "random()" strings.
    init: function(n, r, o) {
      o._onInit = function(s) {
        var i, u;
        if (wo(r) && (i = {}, Ts(r, function(l) {
          return i[l] = 1;
        }), r = i), e) {
          i = {};
          for (u in r)
            i[u] = e(r[u]);
          r = i;
        }
        bSe(s, r);
      };
    }
  };
}, Es = bv.registerPlugin({
  name: "attr",
  init: function(t, e, n, r, o) {
    var s, i, u;
    this.tween = n;
    for (s in e)
      u = t.getAttribute(s) || "", i = this.add(t, "setAttribute", (u || 0) + "", e[s], r, o, 0, 0, s), i.op = s, i.b = u, this._props.push(s);
  },
  render: function(t, e) {
    for (var n = e._pt; n; )
      Lo ? n.set(n.t, n.p, n.b, n) : n.r(t, n.d), n = n._next;
  }
}, {
  name: "endArray",
  init: function(t, e) {
    for (var n = e.length; n--; )
      this.add(t, n, t[n] || 0, e[n], 0, 0, 0, 0, 0, 1);
  }
}, Xb("roundProps", WT), Xb("modifiers"), Xb("snap", q6)) || bv;
Hr.version = Ko.version = Es.version = "3.12.5";
C6 = 1;
FS() && kh();
yn.Power0;
yn.Power1;
yn.Power2;
yn.Power3;
yn.Power4;
yn.Linear;
yn.Quad;
yn.Cubic;
yn.Quart;
yn.Quint;
yn.Strong;
yn.Elastic;
yn.Back;
yn.SteppedEase;
yn.Bounce;
yn.Sine;
yn.Expo;
yn.Circ;
/*!
 * CSSPlugin 3.12.5
 * https://gsap.com
 *
 * Copyright 2008-2024, GreenSock. All rights reserved.
 * Subject to the terms at https://gsap.com/standard-license or for
 * Club GSAP members, the agreement issued with that membership.
 * @author: Jack Doyle, jack@greensock.com
*/
var bO, rc, Jd, zS, mp, kO, qS, kSe = function() {
  return typeof window < "u";
}, ul = {}, up = 180 / Math.PI, eh = Math.PI / 180, xd = Math.atan2, TO = 1e8, GS = /([A-Z])/g, TSe = /(left|right|width|margin|padding|x)/i, xSe = /[\s,\(]\S/, Ji = {
  autoAlpha: "opacity,visibility",
  scale: "scaleX,scaleY",
  alpha: "opacity"
}, jT = function(t, e) {
  return e.set(e.t, e.p, Math.round((e.s + e.c * t) * 1e4) / 1e4 + e.u, e);
}, SSe = function(t, e) {
  return e.set(e.t, e.p, t === 1 ? e.e : Math.round((e.s + e.c * t) * 1e4) / 1e4 + e.u, e);
}, RSe = function(t, e) {
  return e.set(e.t, e.p, t ? Math.round((e.s + e.c * t) * 1e4) / 1e4 + e.u : e.b, e);
}, ASe = function(t, e) {
  var n = e.s + e.c * t;
  e.set(e.t, e.p, ~~(n + (n < 0 ? -0.5 : 0.5)) + e.u, e);
}, f5 = function(t, e) {
  return e.set(e.t, e.p, t ? e.e : e.b, e);
}, m5 = function(t, e) {
  return e.set(e.t, e.p, t !== 1 ? e.b : e.e, e);
}, DSe = function(t, e, n) {
  return t.style[e] = n;
}, ESe = function(t, e, n) {
  return t.style.setProperty(e, n);
}, MSe = function(t, e, n) {
  return t._gsap[e] = n;
}, PSe = function(t, e, n) {
  return t._gsap.scaleX = t._gsap.scaleY = n;
}, CSe = function(t, e, n, r, o) {
  var s = t._gsap;
  s.scaleX = s.scaleY = n, s.renderTransform(o, s);
}, OSe = function(t, e, n, r, o) {
  var s = t._gsap;
  s[e] = n, s.renderTransform(o, s);
}, gr = "transform", Ss = gr + "Origin", ISe = function t(e, n) {
  var r = this, o = this.target, s = o.style, i = o._gsap;
  if (e in ul && s) {
    if (this.tfm = this.tfm || {}, e !== "transform")
      e = Ji[e] || e, ~e.indexOf(",") ? e.split(",").forEach(function(u) {
        return r.tfm[u] = zu(o, u);
      }) : this.tfm[e] = i.x ? i[e] : zu(o, e), e === Ss && (this.tfm.zOrigin = i.zOrigin);
    else
      return Ji.transform.split(",").forEach(function(u) {
        return t.call(r, u, n);
      });
    if (this.props.indexOf(gr) >= 0)
      return;
    i.svg && (this.svgo = o.getAttribute("data-svg-origin"), this.props.push(Ss, n, "")), e = gr;
  }
  (s || n) && this.props.push(e, n, s[e]);
}, y5 = function(t) {
  t.translate && (t.removeProperty("translate"), t.removeProperty("scale"), t.removeProperty("rotate"));
}, FSe = function() {
  var t = this.props, e = this.target, n = e.style, r = e._gsap, o, s;
  for (o = 0; o < t.length; o += 3)
    t[o + 1] ? e[t[o]] = t[o + 2] : t[o + 2] ? n[t[o]] = t[o + 2] : n.removeProperty(t[o].substr(0, 2) === "--" ? t[o] : t[o].replace(GS, "-$1").toLowerCase());
  if (this.tfm) {
    for (s in this.tfm)
      r[s] = this.tfm[s];
    r.svg && (r.renderTransform(), e.setAttribute("data-svg-origin", this.svgo || "")), o = qS(), (!o || !o.isStart) && !n[gr] && (y5(n), r.zOrigin && n[Ss] && (n[Ss] += " " + r.zOrigin + "px", r.zOrigin = 0, r.renderTransform()), r.uncache = 1);
  }
}, g5 = function(t, e) {
  var n = {
    target: t,
    props: [],
    revert: FSe,
    save: ISe
  };
  return t._gsap || Es.core.getCache(t), e && e.split(",").forEach(function(r) {
    return n.save(r);
  }), n;
}, v5, zT = function(t, e) {
  var n = rc.createElementNS ? rc.createElementNS((e || "http://www.w3.org/1999/xhtml").replace(/^https/, "http"), t) : rc.createElement(t);
  return n && n.style ? n : rc.createElement(t);
}, uu = function t(e, n, r) {
  var o = getComputedStyle(e);
  return o[n] || o.getPropertyValue(n.replace(GS, "-$1").toLowerCase()) || o.getPropertyValue(n) || !r && t(e, Th(n) || n, 1) || "";
}, xO = "O,Moz,ms,Ms,Webkit".split(","), Th = function(t, e, n) {
  var r = e || mp, o = r.style, s = 5;
  if (t in o && !n)
    return t;
  for (t = t.charAt(0).toUpperCase() + t.substr(1); s-- && !(xO[s] + t in o); )
    ;
  return s < 0 ? null : (s === 3 ? "ms" : s >= 0 ? xO[s] : "") + t;
}, qT = function() {
  kSe() && window.document && (bO = window, rc = bO.document, Jd = rc.documentElement, mp = zT("div") || {
    style: {}
  }, zT("div"), gr = Th(gr), Ss = gr + "Origin", mp.style.cssText = "border-width:0;line-height:0;position:absolute;padding:0", v5 = !!Th("perspective"), qS = Es.core.reverting, zS = 1);
}, $b = function t(e) {
  var n = zT("svg", this.ownerSVGElement && this.ownerSVGElement.getAttribute("xmlns") || "http://www.w3.org/2000/svg"), r = this.parentNode, o = this.nextSibling, s = this.style.cssText, i;
  if (Jd.appendChild(n), n.appendChild(this), this.style.display = "block", e)
    try {
      i = this.getBBox(), this._gsapBBox = this.getBBox, this.getBBox = t;
    } catch {
    }
  else this._gsapBBox && (i = this._gsapBBox());
  return r && (o ? r.insertBefore(this, o) : r.appendChild(this)), Jd.removeChild(n), this.style.cssText = s, i;
}, SO = function(t, e) {
  for (var n = e.length; n--; )
    if (t.hasAttribute(e[n]))
      return t.getAttribute(e[n]);
}, _5 = function(t) {
  var e;
  try {
    e = t.getBBox();
  } catch {
    e = $b.call(t, !0);
  }
  return e && (e.width || e.height) || t.getBBox === $b || (e = $b.call(t, !0)), e && !e.width && !e.x && !e.y ? {
    x: +SO(t, ["x", "cx", "x1"]) || 0,
    y: +SO(t, ["y", "cy", "y1"]) || 0,
    width: 0,
    height: 0
  } : e;
}, w5 = function(t) {
  return !!(t.getCTM && (!t.parentNode || t.ownerSVGElement) && _5(t));
}, Wp = function(t, e) {
  if (e) {
    var n = t.style, r;
    e in ul && e !== Ss && (e = gr), n.removeProperty ? (r = e.substr(0, 2), (r === "ms" || e.substr(0, 6) === "webkit") && (e = "-" + e), n.removeProperty(r === "--" ? e : e.replace(GS, "-$1").toLowerCase())) : n.removeAttribute(e);
  }
}, oc = function(t, e, n, r, o, s) {
  var i = new xs(t._pt, e, n, 0, 1, s ? m5 : f5);
  return t._pt = i, i.b = r, i.e = o, t._props.push(n), i;
}, RO = {
  deg: 1,
  rad: 1,
  turn: 1
}, NSe = {
  grid: 1,
  flex: 1
}, bc = function t(e, n, r, o) {
  var s = parseFloat(r) || 0, i = (r + "").trim().substr((s + "").length) || "px", u = mp.style, l = TSe.test(n), a = e.tagName.toLowerCase() === "svg", c = (a ? "client" : "offset") + (l ? "Width" : "Height"), p = 100, d = o === "px", h = o === "%", m, g, _, b;
  if (o === i || !s || RO[o] || RO[i])
    return s;
  if (i !== "px" && !d && (s = t(e, n, r, "px")), b = e.getCTM && w5(e), (h || i === "%") && (ul[n] || ~n.indexOf("adius")))
    return m = b ? e.getBBox()[l ? "width" : "height"] : e[c], Ir(h ? s / m * p : s / 100 * m);
  if (u[l ? "width" : "height"] = p + (d ? i : o), g = ~n.indexOf("adius") || o === "em" && e.appendChild && !a ? e : e.parentNode, b && (g = (e.ownerSVGElement || {}).parentNode), (!g || g === rc || !g.appendChild) && (g = rc.body), _ = g._gsap, _ && h && _.width && l && _.time === Qs.time && !_.uncache)
    return Ir(s / _.width * p);
  if (h && (n === "height" || n === "width")) {
    var x = e.style[n];
    e.style[n] = p + o, m = e[c], x ? e.style[n] = x : Wp(e, n);
  } else
    (h || i === "%") && !NSe[uu(g, "display")] && (u.position = uu(e, "position")), g === e && (u.position = "static"), g.appendChild(mp), m = mp[c], g.removeChild(mp), u.position = "absolute";
  return l && h && (_ = Rp(g), _.time = Qs.time, _.width = g[c]), Ir(d ? m * s / p : m && s ? p / m * s : 0);
}, zu = function(t, e, n, r) {
  var o;
  return zS || qT(), e in Ji && e !== "transform" && (e = Ji[e], ~e.indexOf(",") && (e = e.split(",")[0])), ul[e] && e !== "transform" ? (o = Tm(t, r), o = e !== "transformOrigin" ? o[e] : o.svg ? o.origin : Tv(uu(t, Ss)) + " " + o.zOrigin + "px") : (o = t.style[e], (!o || o === "auto" || r || ~(o + "").indexOf("calc(")) && (o = kv[e] && kv[e](t, e, n) || uu(t, e) || N6(t, e) || (e === "opacity" ? 1 : 0))), n && !~(o + "").trim().indexOf(" ") ? bc(t, e, o, n) + n : o;
}, LSe = function(t, e, n, r) {
  if (!n || n === "none") {
    var o = Th(e, t, 1), s = o && uu(t, o, 1);
    s && s !== n ? (e = o, n = s) : e === "borderColor" && (n = uu(t, "borderTopColor"));
  }
  var i = new xs(this._pt, t.style, e, 0, 1, p5), u = 0, l = 0, a, c, p, d, h, m, g, _, b, x, S, E;
  if (i.b = n, i.e = r, n += "", r += "", r === "auto" && (m = t.style[e], t.style[e] = r, r = uu(t, e) || r, m ? t.style[e] = m : Wp(t, e)), a = [n, r], t5(a), n = a[0], r = a[1], p = n.match(Bd) || [], E = r.match(Bd) || [], E.length) {
    for (; c = Bd.exec(r); )
      g = c[0], b = r.substring(u, c.index), h ? h = (h + 1) % 5 : (b.substr(-5) === "rgba(" || b.substr(-5) === "hsla(") && (h = 1), g !== (m = p[l++] || "") && (d = parseFloat(m) || 0, S = m.substr((d + "").length), g.charAt(1) === "=" && (g = Zd(d, g) + S), _ = parseFloat(g), x = g.substr((_ + "").length), u = Bd.lastIndex - x.length, x || (x = x || ea.units[e] || S, u === r.length && (r += x, i.e += x)), S !== x && (d = bc(t, e, m, x) || 0), i._pt = {
        _next: i._pt,
        p: b || l === 1 ? b : ",",
        //note: SVG spec allows omission of comma/space when a negative sign is wedged between two numbers, like 2.5-5.3 instead of 2.5,-5.3 but when tweening, the negative value may switch to positive, so we insert the comma just in case.
        s: d,
        c: _ - d,
        m: h && h < 4 || e === "zIndex" ? Math.round : 0
      });
    i.c = u < r.length ? r.substring(u, r.length) : "";
  } else
    i.r = e === "display" && r === "none" ? m5 : f5;
  return M6.test(r) && (i.e = 0), this._pt = i, i;
}, AO = {
  top: "0%",
  bottom: "100%",
  left: "0%",
  right: "100%",
  center: "50%"
}, BSe = function(t) {
  var e = t.split(" "), n = e[0], r = e[1] || "50%";
  return (n === "top" || n === "bottom" || r === "left" || r === "right") && (t = n, n = r, r = t), e[0] = AO[n] || n, e[1] = AO[r] || r, e.join(" ");
}, USe = function(t, e) {
  if (e.tween && e.tween._time === e.tween._dur) {
    var n = e.t, r = n.style, o = e.u, s = n._gsap, i, u, l;
    if (o === "all" || o === !0)
      r.cssText = "", u = 1;
    else
      for (o = o.split(","), l = o.length; --l > -1; )
        i = o[l], ul[i] && (u = 1, i = i === "transformOrigin" ? Ss : gr), Wp(n, i);
    u && (Wp(n, gr), s && (s.svg && n.removeAttribute("transform"), Tm(n, 1), s.uncache = 1, y5(r)));
  }
}, kv = {
  clearProps: function(t, e, n, r, o) {
    if (o.data !== "isFromStart") {
      var s = t._pt = new xs(t._pt, e, n, 0, 0, USe);
      return s.u = r, s.pr = -10, s.tween = o, t._props.push(n), 1;
    }
  }
  /* className feature (about 0.4kb gzipped).
  , className(plugin, target, property, endValue, tween) {
  	let _renderClassName = (ratio, data) => {
  			data.css.render(ratio, data.css);
  			if (!ratio || ratio === 1) {
  				let inline = data.rmv,
  					target = data.t,
  					p;
  				target.setAttribute("class", ratio ? data.e : data.b);
  				for (p in inline) {
  					_removeProperty(target, p);
  				}
  			}
  		},
  		_getAllStyles = (target) => {
  			let styles = {},
  				computed = getComputedStyle(target),
  				p;
  			for (p in computed) {
  				if (isNaN(p) && p !== "cssText" && p !== "length") {
  					styles[p] = computed[p];
  				}
  			}
  			_setDefaults(styles, _parseTransform(target, 1));
  			return styles;
  		},
  		startClassList = target.getAttribute("class"),
  		style = target.style,
  		cssText = style.cssText,
  		cache = target._gsap,
  		classPT = cache.classPT,
  		inlineToRemoveAtEnd = {},
  		data = {t:target, plugin:plugin, rmv:inlineToRemoveAtEnd, b:startClassList, e:(endValue.charAt(1) !== "=") ? endValue : startClassList.replace(new RegExp("(?:\\s|^)" + endValue.substr(2) + "(?![\\w-])"), "") + ((endValue.charAt(0) === "+") ? " " + endValue.substr(2) : "")},
  		changingVars = {},
  		startVars = _getAllStyles(target),
  		transformRelated = /(transform|perspective)/i,
  		endVars, p;
  	if (classPT) {
  		classPT.r(1, classPT.d);
  		_removeLinkedListItem(classPT.d.plugin, classPT, "_pt");
  	}
  	target.setAttribute("class", data.e);
  	endVars = _getAllStyles(target, true);
  	target.setAttribute("class", startClassList);
  	for (p in endVars) {
  		if (endVars[p] !== startVars[p] && !transformRelated.test(p)) {
  			changingVars[p] = endVars[p];
  			if (!style[p] && style[p] !== "0") {
  				inlineToRemoveAtEnd[p] = 1;
  			}
  		}
  	}
  	cache.classPT = plugin._pt = new PropTween(plugin._pt, target, "className", 0, 0, _renderClassName, data, 0, -11);
  	if (style.cssText !== cssText) { //only apply if things change. Otherwise, in cases like a background-image that's pulled dynamically, it could cause a refresh. See https://gsap.com/forums/topic/20368-possible-gsap-bug-switching-classnames-in-chrome/.
  		style.cssText = cssText; //we recorded cssText before we swapped classes and ran _getAllStyles() because in cases when a className tween is overwritten, we remove all the related tweening properties from that class change (otherwise class-specific stuff can't override properties we've directly set on the target's style object due to specificity).
  	}
  	_parseTransform(target, true); //to clear the caching of transforms
  	data.css = new gsap.plugins.css();
  	data.css.init(target, changingVars, tween);
  	plugin._props.push(...data.css._props);
  	return 1;
  }
  */
}, km = [1, 0, 0, 1, 0, 0], b5 = {}, k5 = function(t) {
  return t === "matrix(1, 0, 0, 1, 0, 0)" || t === "none" || !t;
}, DO = function(t) {
  var e = uu(t, gr);
  return k5(e) ? km : e.substr(7).match(E6).map(Ir);
}, YS = function(t, e) {
  var n = t._gsap || Rp(t), r = t.style, o = DO(t), s, i, u, l;
  return n.svg && t.getAttribute("transform") ? (u = t.transform.baseVal.consolidate().matrix, o = [u.a, u.b, u.c, u.d, u.e, u.f], o.join(",") === "1,0,0,1,0,0" ? km : o) : (o === km && !t.offsetParent && t !== Jd && !n.svg && (u = r.display, r.display = "block", s = t.parentNode, (!s || !t.offsetParent) && (l = 1, i = t.nextElementSibling, Jd.appendChild(t)), o = DO(t), u ? r.display = u : Wp(t, "display"), l && (i ? s.insertBefore(t, i) : s ? s.appendChild(t) : Jd.removeChild(t))), e && o.length > 6 ? [o[0], o[1], o[4], o[5], o[12], o[13]] : o);
}, GT = function(t, e, n, r, o, s) {
  var i = t._gsap, u = o || YS(t, !0), l = i.xOrigin || 0, a = i.yOrigin || 0, c = i.xOffset || 0, p = i.yOffset || 0, d = u[0], h = u[1], m = u[2], g = u[3], _ = u[4], b = u[5], x = e.split(" "), S = parseFloat(x[0]) || 0, E = parseFloat(x[1]) || 0, A, C, M, L;
  n ? u !== km && (C = d * g - h * m) && (M = S * (g / C) + E * (-m / C) + (m * b - g * _) / C, L = S * (-h / C) + E * (d / C) - (d * b - h * _) / C, S = M, E = L) : (A = _5(t), S = A.x + (~x[0].indexOf("%") ? S / 100 * A.width : S), E = A.y + (~(x[1] || x[0]).indexOf("%") ? E / 100 * A.height : E)), r || r !== !1 && i.smooth ? (_ = S - l, b = E - a, i.xOffset = c + (_ * d + b * m) - _, i.yOffset = p + (_ * h + b * g) - b) : i.xOffset = i.yOffset = 0, i.xOrigin = S, i.yOrigin = E, i.smooth = !!r, i.origin = e, i.originIsAbsolute = !!n, t.style[Ss] = "0px 0px", s && (oc(s, i, "xOrigin", l, S), oc(s, i, "yOrigin", a, E), oc(s, i, "xOffset", c, i.xOffset), oc(s, i, "yOffset", p, i.yOffset)), t.setAttribute("data-svg-origin", S + " " + E);
}, Tm = function(t, e) {
  var n = t._gsap || new s5(t);
  if ("x" in n && !e && !n.uncache)
    return n;
  var r = t.style, o = n.scaleX < 0, s = "px", i = "deg", u = getComputedStyle(t), l = uu(t, Ss) || "0", a, c, p, d, h, m, g, _, b, x, S, E, A, C, M, L, X, te, B, W, G, ne, de, V, Y, Q, ae, Z, J, oe, ue, me;
  return a = c = p = m = g = _ = b = x = S = 0, d = h = 1, n.svg = !!(t.getCTM && w5(t)), u.translate && ((u.translate !== "none" || u.scale !== "none" || u.rotate !== "none") && (r[gr] = (u.translate !== "none" ? "translate3d(" + (u.translate + " 0 0").split(" ").slice(0, 3).join(", ") + ") " : "") + (u.rotate !== "none" ? "rotate(" + u.rotate + ") " : "") + (u.scale !== "none" ? "scale(" + u.scale.split(" ").join(",") + ") " : "") + (u[gr] !== "none" ? u[gr] : "")), r.scale = r.rotate = r.translate = "none"), C = YS(t, n.svg), n.svg && (n.uncache ? (Y = t.getBBox(), l = n.xOrigin - Y.x + "px " + (n.yOrigin - Y.y) + "px", V = "") : V = !e && t.getAttribute("data-svg-origin"), GT(t, V || l, !!V || n.originIsAbsolute, n.smooth !== !1, C)), E = n.xOrigin || 0, A = n.yOrigin || 0, C !== km && (te = C[0], B = C[1], W = C[2], G = C[3], a = ne = C[4], c = de = C[5], C.length === 6 ? (d = Math.sqrt(te * te + B * B), h = Math.sqrt(G * G + W * W), m = te || B ? xd(B, te) * up : 0, b = W || G ? xd(W, G) * up + m : 0, b && (h *= Math.abs(Math.cos(b * eh))), n.svg && (a -= E - (E * te + A * W), c -= A - (E * B + A * G))) : (me = C[6], oe = C[7], ae = C[8], Z = C[9], J = C[10], ue = C[11], a = C[12], c = C[13], p = C[14], M = xd(me, J), g = M * up, M && (L = Math.cos(-M), X = Math.sin(-M), V = ne * L + ae * X, Y = de * L + Z * X, Q = me * L + J * X, ae = ne * -X + ae * L, Z = de * -X + Z * L, J = me * -X + J * L, ue = oe * -X + ue * L, ne = V, de = Y, me = Q), M = xd(-W, J), _ = M * up, M && (L = Math.cos(-M), X = Math.sin(-M), V = te * L - ae * X, Y = B * L - Z * X, Q = W * L - J * X, ue = G * X + ue * L, te = V, B = Y, W = Q), M = xd(B, te), m = M * up, M && (L = Math.cos(M), X = Math.sin(M), V = te * L + B * X, Y = ne * L + de * X, B = B * L - te * X, de = de * L - ne * X, te = V, ne = Y), g && Math.abs(g) + Math.abs(m) > 359.9 && (g = m = 0, _ = 180 - _), d = Ir(Math.sqrt(te * te + B * B + W * W)), h = Ir(Math.sqrt(de * de + me * me)), M = xd(ne, de), b = Math.abs(M) > 2e-4 ? M * up : 0, S = ue ? 1 / (ue < 0 ? -ue : ue) : 0), n.svg && (V = t.getAttribute("transform"), n.forceCSS = t.setAttribute("transform", "") || !k5(uu(t, gr)), V && t.setAttribute("transform", V))), Math.abs(b) > 90 && Math.abs(b) < 270 && (o ? (d *= -1, b += m <= 0 ? 180 : -180, m += m <= 0 ? 180 : -180) : (h *= -1, b += b <= 0 ? 180 : -180)), e = e || n.uncache, n.x = a - ((n.xPercent = a && (!e && n.xPercent || (Math.round(t.offsetWidth / 2) === Math.round(-a) ? -50 : 0))) ? t.offsetWidth * n.xPercent / 100 : 0) + s, n.y = c - ((n.yPercent = c && (!e && n.yPercent || (Math.round(t.offsetHeight / 2) === Math.round(-c) ? -50 : 0))) ? t.offsetHeight * n.yPercent / 100 : 0) + s, n.z = p + s, n.scaleX = Ir(d), n.scaleY = Ir(h), n.rotation = Ir(m) + i, n.rotationX = Ir(g) + i, n.rotationY = Ir(_) + i, n.skewX = b + i, n.skewY = x + i, n.transformPerspective = S + s, (n.zOrigin = parseFloat(l.split(" ")[2]) || !e && n.zOrigin || 0) && (r[Ss] = Tv(l)), n.xOffset = n.yOffset = 0, n.force3D = ea.force3D, n.renderTransform = n.svg ? $Se : v5 ? T5 : XSe, n.uncache = 0, n;
}, Tv = function(t) {
  return (t = t.split(" "))[0] + " " + t[1];
}, Wb = function(t, e, n) {
  var r = No(e);
  return Ir(parseFloat(e) + parseFloat(bc(t, "x", n + "px", r))) + r;
}, XSe = function(t, e) {
  e.z = "0px", e.rotationY = e.rotationX = "0deg", e.force3D = 0, T5(t, e);
}, Jc = "0deg", kf = "0px", ep = ") ", T5 = function(t, e) {
  var n = e || this, r = n.xPercent, o = n.yPercent, s = n.x, i = n.y, u = n.z, l = n.rotation, a = n.rotationY, c = n.rotationX, p = n.skewX, d = n.skewY, h = n.scaleX, m = n.scaleY, g = n.transformPerspective, _ = n.force3D, b = n.target, x = n.zOrigin, S = "", E = _ === "auto" && t && t !== 1 || _ === !0;
  if (x && (c !== Jc || a !== Jc)) {
    var A = parseFloat(a) * eh, C = Math.sin(A), M = Math.cos(A), L;
    A = parseFloat(c) * eh, L = Math.cos(A), s = Wb(b, s, C * L * -x), i = Wb(b, i, -Math.sin(A) * -x), u = Wb(b, u, M * L * -x + x);
  }
  g !== kf && (S += "perspective(" + g + ep), (r || o) && (S += "translate(" + r + "%, " + o + "%) "), (E || s !== kf || i !== kf || u !== kf) && (S += u !== kf || E ? "translate3d(" + s + ", " + i + ", " + u + ") " : "translate(" + s + ", " + i + ep), l !== Jc && (S += "rotate(" + l + ep), a !== Jc && (S += "rotateY(" + a + ep), c !== Jc && (S += "rotateX(" + c + ep), (p !== Jc || d !== Jc) && (S += "skew(" + p + ", " + d + ep), (h !== 1 || m !== 1) && (S += "scale(" + h + ", " + m + ep), b.style[gr] = S || "translate(0, 0)";
}, $Se = function(t, e) {
  var n = e || this, r = n.xPercent, o = n.yPercent, s = n.x, i = n.y, u = n.rotation, l = n.skewX, a = n.skewY, c = n.scaleX, p = n.scaleY, d = n.target, h = n.xOrigin, m = n.yOrigin, g = n.xOffset, _ = n.yOffset, b = n.forceCSS, x = parseFloat(s), S = parseFloat(i), E, A, C, M, L;
  u = parseFloat(u), l = parseFloat(l), a = parseFloat(a), a && (a = parseFloat(a), l += a, u += a), u || l ? (u *= eh, l *= eh, E = Math.cos(u) * c, A = Math.sin(u) * c, C = Math.sin(u - l) * -p, M = Math.cos(u - l) * p, l && (a *= eh, L = Math.tan(l - a), L = Math.sqrt(1 + L * L), C *= L, M *= L, a && (L = Math.tan(a), L = Math.sqrt(1 + L * L), E *= L, A *= L)), E = Ir(E), A = Ir(A), C = Ir(C), M = Ir(M)) : (E = c, M = p, A = C = 0), (x && !~(s + "").indexOf("px") || S && !~(i + "").indexOf("px")) && (x = bc(d, "x", s, "px"), S = bc(d, "y", i, "px")), (h || m || g || _) && (x = Ir(x + h - (h * E + m * C) + g), S = Ir(S + m - (h * A + m * M) + _)), (r || o) && (L = d.getBBox(), x = Ir(x + r / 100 * L.width), S = Ir(S + o / 100 * L.height)), L = "matrix(" + E + "," + A + "," + C + "," + M + "," + x + "," + S + ")", d.setAttribute("transform", L), b && (d.style[gr] = L);
}, WSe = function(t, e, n, r, o) {
  var s = 360, i = wo(o), u = parseFloat(o) * (i && ~o.indexOf("rad") ? up : 1), l = u - r, a = r + l + "deg", c, p;
  return i && (c = o.split("_")[1], c === "short" && (l %= s, l !== l % (s / 2) && (l += l < 0 ? s : -s)), c === "cw" && l < 0 ? l = (l + s * TO) % s - ~~(l / s) * s : c === "ccw" && l > 0 && (l = (l - s * TO) % s - ~~(l / s) * s)), t._pt = p = new xs(t._pt, e, n, r, l, SSe), p.e = a, p.u = "deg", t._props.push(n), p;
}, EO = function(t, e) {
  for (var n in e)
    t[n] = e[n];
  return t;
}, VSe = function(t, e, n) {
  var r = EO({}, n._gsap), o = "perspective,force3D,transformOrigin,svgOrigin", s = n.style, i, u, l, a, c, p, d, h;
  r.svg ? (l = n.getAttribute("transform"), n.setAttribute("transform", ""), s[gr] = e, i = Tm(n, 1), Wp(n, gr), n.setAttribute("transform", l)) : (l = getComputedStyle(n)[gr], s[gr] = e, i = Tm(n, 1), s[gr] = l);
  for (u in ul)
    l = r[u], a = i[u], l !== a && o.indexOf(u) < 0 && (d = No(l), h = No(a), c = d !== h ? bc(n, u, l, h) : parseFloat(l), p = parseFloat(a), t._pt = new xs(t._pt, i, u, c, p - c, jT), t._pt.u = h || 0, t._props.push(u));
  EO(i, r);
};
Ts("padding,margin,Width,Radius", function(t, e) {
  var n = "Top", r = "Right", o = "Bottom", s = "Left", i = (e < 3 ? [n, r, o, s] : [n + s, n + r, o + r, o + s]).map(function(u) {
    return e < 2 ? t + u : "border" + u + t;
  });
  kv[e > 1 ? "border" + t : t] = function(u, l, a, c, p) {
    var d, h;
    if (arguments.length < 4)
      return d = i.map(function(m) {
        return zu(u, m, a);
      }), h = d.join(" "), h.split(d[0]).length === 5 ? d[0] : h;
    d = (c + "").split(" "), h = {}, i.forEach(function(m, g) {
      return h[m] = d[g] = d[g] || d[(g - 1) / 2 | 0];
    }), u.init(l, h, p);
  };
});
var x5 = {
  name: "css",
  register: qT,
  targetTest: function(t) {
    return t.style && t.nodeType;
  },
  init: function(t, e, n, r, o) {
    var s = this._props, i = t.style, u = n.vars.startAt, l, a, c, p, d, h, m, g, _, b, x, S, E, A, C, M;
    zS || qT(), this.styles = this.styles || g5(t), M = this.styles.props, this.tween = n;
    for (m in e)
      if (m !== "autoRound" && (a = e[m], !(zs[m] && a5(m, e, n, r, t, o)))) {
        if (d = typeof a, h = kv[m], d === "function" && (a = a.call(n, r, t, o), d = typeof a), d === "string" && ~a.indexOf("random(") && (a = _m(a)), h)
          h(this, t, m, a, n) && (C = 1);
        else if (m.substr(0, 2) === "--")
          l = (getComputedStyle(t).getPropertyValue(m) + "").trim(), a += "", pc.lastIndex = 0, pc.test(l) || (g = No(l), _ = No(a)), _ ? g !== _ && (l = bc(t, m, l, _) + _) : g && (a += g), this.add(i, "setProperty", l, a, r, o, 0, 0, m), s.push(m), M.push(m, 0, i[m]);
        else if (d !== "undefined") {
          if (u && m in u ? (l = typeof u[m] == "function" ? u[m].call(n, r, t, o) : u[m], wo(l) && ~l.indexOf("random(") && (l = _m(l)), No(l + "") || l === "auto" || (l += ea.units[m] || No(zu(t, m)) || ""), (l + "").charAt(1) === "=" && (l = zu(t, m))) : l = zu(t, m), p = parseFloat(l), b = d === "string" && a.charAt(1) === "=" && a.substr(0, 2), b && (a = a.substr(2)), c = parseFloat(a), m in Ji && (m === "autoAlpha" && (p === 1 && zu(t, "visibility") === "hidden" && c && (p = 0), M.push("visibility", 0, i.visibility), oc(this, i, "visibility", p ? "inherit" : "hidden", c ? "inherit" : "hidden", !c)), m !== "scale" && m !== "transform" && (m = Ji[m], ~m.indexOf(",") && (m = m.split(",")[0]))), x = m in ul, x) {
            if (this.styles.save(m), S || (E = t._gsap, E.renderTransform && !e.parseTransform || Tm(t, e.parseTransform), A = e.smoothOrigin !== !1 && E.smooth, S = this._pt = new xs(this._pt, i, gr, 0, 1, E.renderTransform, E, 0, -1), S.dep = 1), m === "scale")
              this._pt = new xs(this._pt, E, "scaleY", E.scaleY, (b ? Zd(E.scaleY, b + c) : c) - E.scaleY || 0, jT), this._pt.u = 0, s.push("scaleY", m), m += "X";
            else if (m === "transformOrigin") {
              M.push(Ss, 0, i[Ss]), a = BSe(a), E.svg ? GT(t, a, 0, A, 0, this) : (_ = parseFloat(a.split(" ")[2]) || 0, _ !== E.zOrigin && oc(this, E, "zOrigin", E.zOrigin, _), oc(this, i, m, Tv(l), Tv(a)));
              continue;
            } else if (m === "svgOrigin") {
              GT(t, a, 1, A, 0, this);
              continue;
            } else if (m in b5) {
              WSe(this, E, m, p, b ? Zd(p, b + a) : a);
              continue;
            } else if (m === "smoothOrigin") {
              oc(this, E, "smooth", E.smooth, a);
              continue;
            } else if (m === "force3D") {
              E[m] = a;
              continue;
            } else if (m === "transform") {
              VSe(this, a, t);
              continue;
            }
          } else m in i || (m = Th(m) || m);
          if (x || (c || c === 0) && (p || p === 0) && !xSe.test(a) && m in i)
            g = (l + "").substr((p + "").length), c || (c = 0), _ = No(a) || (m in ea.units ? ea.units[m] : g), g !== _ && (p = bc(t, m, l, _)), this._pt = new xs(this._pt, x ? E : i, m, p, (b ? Zd(p, b + c) : c) - p, !x && (_ === "px" || m === "zIndex") && e.autoRound !== !1 ? ASe : jT), this._pt.u = _ || 0, g !== _ && _ !== "%" && (this._pt.b = l, this._pt.r = RSe);
          else if (m in i)
            LSe.call(this, t, m, l, b ? b + a : a);
          else if (m in t)
            this.add(t, m, l || t[m], b ? b + a : a, r, o);
          else if (m !== "parseTransform") {
            LS(m, a);
            continue;
          }
          x || (m in i ? M.push(m, 0, i[m]) : M.push(m, 1, l || t[m])), s.push(m);
        }
      }
    C && d5(this);
  },
  render: function(t, e) {
    if (e.tween._time || !qS())
      for (var n = e._pt; n; )
        n.r(t, n.d), n = n._next;
    else
      e.styles.revert();
  },
  get: zu,
  aliases: Ji,
  getSetter: function(t, e, n) {
    var r = Ji[e];
    return r && r.indexOf(",") < 0 && (e = r), e in ul && e !== Ss && (t._gsap.x || zu(t, "x")) ? n && kO === n ? e === "scale" ? PSe : MSe : (kO = n || {}) && (e === "scale" ? CSe : OSe) : t.style && !IS(t.style[e]) ? DSe : ~e.indexOf("-") ? ESe : HS(t, e);
  },
  core: {
    _removeProperty: Wp,
    _getMatrix: YS
  }
};
Es.utils.checkPrefix = Th;
Es.core.getStyleSaver = g5;
(function(t, e, n, r) {
  var o = Ts(t + "," + e + "," + n, function(s) {
    ul[s] = 1;
  });
  Ts(e, function(s) {
    ea.units[s] = "deg", b5[s] = 1;
  }), Ji[o[13]] = t + "," + e, Ts(r, function(s) {
    var i = s.split(":");
    Ji[i[1]] = o[i[0]];
  });
})("x,y,z,scale,scaleX,scaleY,xPercent,yPercent", "rotation,rotationX,rotationY,skewX,skewY", "transform,transformOrigin,svgOrigin,force3D,smoothOrigin,transformPerspective", "0:translateX,1:translateY,2:translateZ,8:rotate,8:rotationZ,8:rotateZ,9:rotateX,10:rotateY");
Ts("x,y,z,top,right,bottom,left,width,height,fontSize,padding,margin,perspective", function(t) {
  ea.units[t] = "px";
});
Es.registerPlugin(x5);
var S5 = Es.registerPlugin(x5) || Es;
S5.core.Tween;
function R5(t, e) {
  return typeof t == "function" ? t(e) : t && typeof t == "object" && hO in t ? t[hO](e) : t instanceof Date ? new t.constructor(e) : new Date(e);
}
function YT(t, e) {
  return R5(t, t);
}
function HSe(t, e, n) {
  return R5(t, +YT(t) + e);
}
function jSe(t, e, n) {
  return HSe(t, e * 1e3);
}
function zSe(t) {
  return (e) => {
    const n = Math.trunc, r = n(e);
    return r === 0 ? 0 : r;
  };
}
function A5(t, e) {
  return +YT(t) - +YT(e);
}
function qSe(t, e, n) {
  const r = A5(t, e) / 1e3;
  return zSe()(r);
}
const GSe = (t) => ({
  font: { fontFamily: "ui-sans-serif, system-ui, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji'", type: "BitmapFont" },
  rowGap: 24,
  columnGap: 32,
  textDefault: t === "dark" ? "#ffffff" : "#161618",
  textInverse: t === "dark" ? "#161618" : "#ffffff",
  selectedBorderColor: t === "dark" ? "#3fa2c3" : "#297f9c",
  selectedBorderWidth: 2,
  selectedBorderOffset: 4,
  selectedBorderRadius: 9,
  nodesPadding: 16,
  nodeHeight: 32,
  nodePadding: 4,
  nodeRadius: 6,
  nodeBorderRadius: 9,
  nodeToggleSize: 28,
  nodeToggleBgColor: "#35363C",
  nodeToggleBorderRadius: 6,
  nodeToggleBorderColor: t === "dark" ? "#4d4f56" : "#bbbec9",
  nodeUnselectedAlpha: 0.2,
  artifactsGap: 4,
  artifactsNodeOverlap: 4,
  artifactPaddingLeft: 2,
  artifactPaddingRight: 4,
  artifactPaddingY: 2,
  artifactTextColor: "#ffffff",
  artifactBgColor: "#35363b",
  artifactBorderRadius: 4,
  artifactContentGap: 4,
  artifactIconSize: 16,
  artifactIconColor: "#ffffff",
  flowStateBarHeight: 8,
  flowStateSelectedBarHeight: 10,
  flowStateAreaAlpha: 0.1,
  eventTargetSize: 30,
  eventBottomMargin: 4,
  eventSelectedBorderInset: 8,
  eventRadiusDefault: 4,
  eventColor: "#A564F9",
  eventClusterRadiusDefault: 6,
  eventClusterColor: "#A564F9",
  edgeColor: t === "dark" ? "#adadad" : "#737682",
  guideLineWidth: 1,
  guideLineColor: t === "dark" ? "#4d4f56" : "#bbbec9",
  guideTextTopPadding: 8,
  guideTextLeftPadding: 8,
  guideTextSize: 12,
  guideTextColor: t === "dark" ? "#adadad" : "#737682",
  playheadWidth: 2,
  playheadColor: "#6272FF",
  node: () => ({
    background: "#ffffff"
  }),
  state: () => ({
    background: "#ffffff"
  })
});
let Xd = null;
async function YSe() {
  const t = await oa();
  Xd = MO(t), Ze.emit("stylesCreated", Xd), Ze.on("configUpdated", (e) => {
    Xd = MO(e), Ze.emit("stylesUpdated", Xd);
  });
}
function QSe() {
  Xd = null;
}
async function wr() {
  return Xd || await Is("stylesCreated");
}
function MO(t) {
  return {
    ...GSe(t.theme),
    ...t.styles?.(t.theme)
  };
}
function KSe(t) {
  let e = 0;
  for (const [, { children: n }] of t)
    e += n.length;
  return e;
}
function ZSe({ start_time: t, end_time: e, nodes: n }, r, o) {
  const s = Math.max(qSe(e ?? /* @__PURE__ */ new Date(), t), 1), i = r.nodeHeight + r.rowGap;
  return (n.size > 0 ? n.size * i * 0.5 : i * 4) * o / (s * LL);
}
async function JSe() {
  const t = await ku(), e = await oa(), n = await wr(), r = await no(), o = r.view.width / r.view.height, s = ZSe(t, n, o);
  xv(s, !0), t.nodes.size > e.disableAnimationsThreshold && (ot.disableAnimations = !0), KSe(t.nodes) > e.disableEdgesThreshold && (ot.disableEdges = !0);
}
function eRe() {
  ot.horizontal = "temporal", ot.vertical = "nearest-parent", ot.horizontalScaleMultiplierDefault = 0, ot.horizontalScaleMultiplier = 0, ot.disableAnimations = !1, ot.disableGuides = !1, ot.disableEdges = !1, ot.disableArtifacts = !1, ot.disableEvents = !1;
}
const ot = {
  horizontal: "temporal",
  vertical: "nearest-parent",
  horizontalScaleMultiplierDefault: 0,
  horizontalScaleMultiplier: 0,
  disableAnimations: !1,
  disableGuides: !1,
  disableEdges: !1,
  disableArtifacts: !1,
  disableEvents: !1,
  isTemporal() {
    return this.horizontal === "temporal";
  },
  isDependency() {
    return this.horizontal === "dependency";
  },
  isWaterfall() {
    return this.vertical === "waterfall";
  },
  isNearestParent() {
    return this.vertical === "nearest-parent";
  },
  isLeftAligned() {
    return this.horizontal === "left-aligned";
  }
};
async function eo() {
  return QT() ? ot : await Is("layoutSettingsCreated");
}
function QS() {
  return ot.isDependency() ? iwe : LL * ot.horizontalScaleMultiplier;
}
function tRe() {
  return [0, QS()];
}
function nRe(t) {
  if (ot.isDependency())
    return [0, 1];
  const e = t, n = jSe(e, awe);
  return [e, n];
}
function xv(t, e = !1) {
  if (ot.horizontalScaleMultiplier === t)
    return;
  const n = zh();
  ot.horizontalScaleMultiplier = t, e && (ot.horizontalScaleMultiplierDefault = t), n();
}
function rRe() {
  xv(ot.horizontalScaleMultiplierDefault);
}
function oRe(t) {
  if (ot.horizontal === t)
    return;
  const e = zh();
  ot.horizontal = t, ot.disableGuides = ot.isDependency() || ot.isLeftAligned(), e();
}
function sRe(t) {
  if (ot.vertical === t)
    return;
  const e = zh();
  ot.vertical = t, e();
}
function aRe(t) {
  if (ot.disableEdges === t)
    return;
  const e = zh();
  ot.disableEdges = t, e();
}
function iRe(t) {
  if (ot.disableArtifacts === t)
    return;
  const e = zh();
  ot.disableArtifacts = t, e();
}
function uRe(t) {
  if (ot.disableEvents === t)
    return;
  const e = zh();
  ot.disableEvents = t, e();
}
function zh() {
  const t = QT() ? "layoutSettingsUpdated" : "layoutSettingsCreated", { horizontal: e, vertical: n } = ot;
  return () => {
    QT() && Ze.emit(t, ot), (e !== ot.horizontal || n !== ot.vertical) && Ze.emit("layoutUpdated");
  };
}
function QT() {
  return ot.horizontalScaleMultiplier !== 0;
}
async function D5() {
  const t = await eo(), e = await oa();
  function n(r, o, s) {
    const i = t.disableAnimations || s ? 0 : e.animationDuration / 1e3;
    return S5.to(r, {
      ...o,
      duration: i,
      ease: "power1.out",
      onUpdate: () => {
        yy();
      }
    });
  }
  return {
    animate: n
  };
}
async function lRe({ size: t, stroke: e = 1, radius: n = 0 }) {
  const r = await no(), o = new vc();
  return o.lineStyle(e, "#fff", 1, 0), o.drawRoundedRect(0, 0, t * 2, t * 2, n), r.renderer.generateTexture(o, {
    // drew a rounded rectangle and then just using one corner as the "arrow"
    region: new Pt(0, 0, t, t),
    // manually bumping up the resolution to keep the border radius from being blurry
    resolution: 10
  });
}
async function zf(t) {
  return await py(lRe, [t]);
}
var Sv = /* @__PURE__ */ ((t) => (t[t.Up = 0] = "Up", t[t.Down = 180] = "Down", t[t.Left = 270] = "Left", t[t.Right = 90] = "Right", t))(Sv || {});
function E5() {
  const t = new Vr();
  async function e(n) {
    const { rotate: r = 0 } = n, o = {
      size: n.size,
      radius: n.radius,
      stroke: n.stroke
    }, s = await zf(o);
    return t.texture = s, t.anchor.set(0.5, 0.5), t.angle = 45 + r, t;
  }
  return {
    element: t,
    render: e
  };
}
async function cRe() {
  const t = await no(), e = new vc();
  return e.beginFill("#fff"), e.drawRect(0, 0, 1, 1), e.endFill(), t.renderer.generateTexture(e, {
    wrapMode: su.REPEAT
  });
}
async function KS() {
  return await py(cRe, []);
}
function KT(t, e) {
  return Array.from({ length: t }, (n, r) => e(r));
}
const pRe = 8, dRe = 2;
async function hRe() {
  const t = await wr(), e = await NU(), n = await WCe(), { animate: r } = await D5(), o = new fn(), { element: s, render: i } = await E5(), u = await KS(), l = KT(XL, () => new Rt()), a = new axe(u, l);
  let c = !1;
  o.name = swe, o.addChild(s), o.addChild(a), e.addAll([s, a]), n.add(o);
  async function p() {
    return await i({
      size: 10,
      rotate: Sv.Right
    }), s.tint = t.edgeColor, a.tint = t.edgeColor, o;
  }
  async function d(m, g) {
    const _ = h(g);
    c || await p();
    for (const [b, x] of l.entries()) {
      const { x: S, y: E } = _[b];
      r(x, {
        x: S,
        y: E
      }, !c);
    }
    r(o, {
      x: m.x,
      y: m.y
    }, !c), r(s, {
      x: g.x - pRe,
      y: g.y
    }, !c), c = !0;
  }
  function h({ x: m, y: g }) {
    const _ = [], b = { x: 0, y: 0 }, x = { x: m - dRe, y: g }, S = {
      x: PO(b.x, { source: b, target: x }),
      y: b.y
    }, E = {
      x: PO(x.x, { source: b, target: x }, !0),
      y: x.y
    };
    for (const [A] of l.entries()) {
      if (A === l.length - 1) {
        _[A] = x;
        continue;
      }
      const C = fRe(A, {
        source: b,
        target: x,
        sourceBezier: S,
        targetBezier: E
      });
      _[A] = C;
    }
    return _;
  }
  return {
    element: o,
    render: p,
    setPosition: d
  };
}
function PO(t, { source: e, target: n }, r) {
  const o = (n.x - e.x) / 2;
  return t + (o > LM ? o : LM) * (r ? -1 : 1);
}
function fRe(t, e) {
  const n = t / XL, { source: r, target: o, sourceBezier: s, targetBezier: i } = e, u = r.x + (s.x - r.x) * n, l = r.y + (s.y - r.y) * n, a = s.x + (i.x - s.x) * n, c = s.y + (i.y - s.y) * n, p = i.x + (o.x - i.x) * n, d = i.y + (o.y - i.y) * n, h = u + (a - u) * n, m = l + (c - l) * n, g = a + (p - a) * n, _ = c + (d - c) * n, b = h + (g - h) * n, x = m + (_ - m) * n;
  return { x: b, y: x };
}
async function mRe({ height: t, radius: e }) {
  const n = await no(), r = new vc();
  return r.beginFill("#fff"), r.drawRoundedRect(0, 0, e * 2, t, e), r.endFill(), n.renderer.generateTexture(r, {
    // drew a rounded rectangle and then just using half of the graphic to get just the left "cap"
    region: new Pt(0, 0, e, t),
    resolution: BL
  });
}
async function yRe(t) {
  return await py(mRe, [t]);
}
function gRe() {
  const t = new Vr(), e = new Vr();
  async function n(r) {
    const o = await yRe(r);
    return t.texture = o, e.texture = o, e.anchor.x = 1, e.scale.x = -1, {
      left: t,
      right: e
    };
  }
  return {
    left: t,
    right: e,
    render: n
  };
}
async function ll() {
  const t = await KS();
  return new Vr(t);
}
async function ZS() {
  const t = new fn(), e = await ll(), { left: n, right: r, render: o } = await gRe();
  t.addChild(e), t.addChild(n), t.addChild(r);
  async function s(l) {
    const { width: a, x: c, visible: p } = u(l);
    return await o({
      height: l.height,
      radius: l.radius
    }), e.visible = p, e.width = a, e.height = l.height, e.x = c, n.visible = i(l.capLeft, l.radius), r.visible = i(l.capRight, l.radius), r.x = l.radius + a, e.tint = l.background, n.tint = l.background, r.tint = l.background, t;
  }
  function i(l, a) {
    return a === 0 ? !1 : l ?? !0;
  }
  function u(l) {
    const a = i(l.capLeft, l.radius), c = i(l.capRight, l.radius);
    let p = 0;
    a && (p += l.radius), c && (p += l.radius);
    const d = Math.max(l.width - p, 0), h = d > 0, m = a ? l.radius : 0;
    return {
      width: d,
      visible: h,
      x: m
    };
  }
  return {
    element: t,
    render: s
  };
}
function Z_() {
  const t = new fn(), e = new Vr(), n = new Vr(), r = new Vr(), o = new Vr(), s = new Vr(), i = new Vr(), u = new Vr(), l = new Vr();
  e.name = "border-corner-top-left", n.name = "border-corner-top-right", r.name = "border-corner-bottom-left", o.name = "border-corner-bottom-right", s.name = "border-corner-left", i.name = "border-corner-right", u.name = "border-corner-top", l.name = "border-corner-bottom", n.anchor.x = 1, n.scale.x = -1, r.anchor.y = 1, r.scale.y = -1, o.anchor.x = 1, o.scale.x = -1, o.anchor.y = 1, o.scale.y = -1, t.addChild(e), t.addChild(n), t.addChild(r), t.addChild(o), t.addChild(s), t.addChild(i), t.addChild(u), t.addChild(l);
  async function a(m) {
    const { radius: g = 0, color: _ = "#fff", stroke: b, width: x, height: S } = m, E = typeof g == "number", A = {
      topLeft: c(E ? g : g[0], x, S),
      topRight: c(E ? g : g[1], x, S),
      bottomLeft: c(E ? g : g[2], x, S),
      bottomRight: c(E ? g : g[3], x, S)
    };
    return await p({
      width: x,
      height: S,
      stroke: b,
      cornerSizes: A
    }), await d({
      width: x,
      height: S,
      stroke: b,
      cornerSizes: A
    }), h(_), t;
  }
  function c(m, g, _) {
    const b = Math.min(g, _);
    return {
      size: m * 2 > b ? b / 2 : m,
      radius: m
    };
  }
  async function p({ width: m, height: g, stroke: _, cornerSizes: b }) {
    const {
      topLeft: x,
      topRight: S,
      bottomLeft: E,
      bottomRight: A
    } = b, [C, M, L, X] = await Promise.all([
      zf({ ...x, stroke: _ }),
      zf({ ...S, stroke: _ }),
      zf({ ...E, stroke: _ }),
      zf({ ...A, stroke: _ })
    ]);
    e.texture = C, n.texture = M, r.texture = X, o.texture = L, e.position.set(0, 0), n.position.set(m - S.size, 0), r.position.set(0, g - E.size), o.position.set(m - A.size, g - A.size);
  }
  async function d({ width: m, height: g, stroke: _, cornerSizes: b }) {
    const x = await KS(), { topLeft: S, topRight: E, bottomLeft: A, bottomRight: C } = b;
    u.texture = x, s.texture = x, i.texture = x, l.texture = x, s.position.set(0, S.size), s.height = Math.max(g - S.size - A.size, 0), s.width = _, i.position.set(m - _, E.size), i.height = Math.max(g - E.size - C.size, 0), i.width = _, u.position.set(S.size, 0), u.width = Math.max(m - S.size - E.size, 0), u.height = _, l.position.set(A.size, g - _), l.width = Math.max(m - A.size - C.size, 0), l.height = _;
  }
  function h(m) {
    e.tint = m, n.tint = m, r.tint = m, o.tint = m, u.tint = m, s.tint = m, i.tint = m, l.tint = m;
  }
  return {
    element: t,
    render: a
  };
}
async function J_() {
  const t = await wr(), e = new fn(), { element: n, render: r } = await Z_();
  async function o({ selected: s, width: i, height: u }) {
    if (!s)
      return e.removeChild(n), e;
    const {
      selectedBorderColor: l,
      selectedBorderWidth: a,
      selectedBorderOffset: c,
      selectedBorderRadius: p
    } = t;
    return n.position.set(-c, -c), e.addChild(n), await r({
      stroke: a,
      radius: p,
      width: i + c * 2,
      height: u + c * 2,
      color: l
    }), e;
  }
  return {
    element: e,
    render: o
  };
}
async function vRe() {
  const t = await wr(), e = new fn(), { element: n, render: r } = await ZS(), { element: o, render: s } = await J_();
  e.addChild(n), e.addChild(o);
  async function i({ selected: u, width: l, height: a }) {
    const {
      artifactBgColor: c,
      artifactBorderRadius: p
    } = t, d = {
      width: l,
      height: a,
      background: c,
      radius: p,
      capLeft: !0,
      capRight: !0
    };
    return await Promise.all([
      r(d),
      s({ selected: u, width: l, height: a })
    ]), e;
  }
  return {
    element: e,
    render: i
  };
}
var _Re = Object.defineProperty, wRe = (t, e, n) => e in t ? _Re(t, e, { enumerable: !0, configurable: !0, writable: !0, value: n }) : t[e] = n, Tf = (t, e, n) => (wRe(t, typeof e != "symbol" ? e + "" : e, n), n);
class bRe extends fn {
  /**
   * Creates a Circular ProgressBar.
   * @param { number } options - Options object to use.
   * @param { number } options.backgroundColor - Background color.
   * @param { number } options.fillColor - Fill color.
   * @param { number } options.lineWidth - Line width.
   * @param { number } options.radius - Radius.
   * @param { number } options.value - Progress value.
   * @param { number } options.backgroundAlpha - Background alpha.
   * @param { number } options.fillAlpha - Fill alpha.
   * @param { 'butt' | 'round' | 'square' } options.cap - Line cap.
   */
  constructor(e) {
    super(), Tf(this, "_progress", 0), Tf(this, "options"), Tf(this, "bgCircle", new vc()), Tf(this, "fillCircle", new vc()), Tf(this, "innerView", new fn()), this.options = e, this.addChild(this.innerView), this.innerView.addChild(this.bgCircle, this.fillCircle), this.addBackground(), e.value && (this.progress = e.value);
  }
  addBackground() {
    const {
      backgroundColor: e,
      lineWidth: n,
      radius: r,
      backgroundAlpha: o
    } = this.options;
    let s = 1;
    o > 0 && (s = o), e === void 0 && (s = 1e-6), this.bgCircle.lineStyle({
      width: n,
      color: e,
      alpha: s
    }).drawCircle(0, 0, r);
  }
  /**
   * Set progress value.
   * @param { number } value - Progress value.
   */
  set progress(e) {
    e > 100 && (e = 100), e < 0 && (e = 0), this._progress = e;
    const {
      lineWidth: n,
      radius: r,
      fillColor: o,
      fillAlpha: s,
      cap: i
    } = this.options;
    if (e === 0 && s === 0) {
      this.fillCircle.clear();
      return;
    }
    const u = 0, l = 360 / 100 * e;
    this.fillCircle.clear().lineStyle({
      width: n,
      color: o,
      cap: i,
      alpha: s
    }).arc(0, 0, r, (-90 + u) * oT, (-90 + u + l) * oT);
  }
  /**
   * Current progress value.
   * @returns { number } - Progress value.
   */
  get progress() {
    return this._progress;
  }
}
async function kRe(t = {}) {
  const e = await BU(), n = new bRe({
    fillColor: 16777215,
    cullAtZoomThreshold: !0,
    backgroundColor: 0,
    backgroundAlpha: 1,
    value: 50,
    cap: "round",
    fillAlpha: 1,
    lineWidth: 20,
    radius: 50,
    ...t
  });
  t.cullAtZoomThreshold && e.add(n);
  function r(o) {
    n.progress = o.value ?? 0;
    const s = (o.radius + o.lineWidth) * 2;
    return n.width = s, n.height = s, n.position.set(s / 2), n;
  }
  return {
    element: n,
    render: r
  };
}
const TRe = "data:image/svg+xml,%3csvg%20viewBox='0%200%2020%2020'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20clip-path='url(%23clip0_7_19)'%3e%3cmask%20id='mask0_7_19'%20style='mask-type:luminance'%20maskUnits='userSpaceOnUse'%20x='-1'%20y='-1'%20width='22'%20height='22'%3e%3cpath%20d='M20.9091%20-0.909058H-0.909088V20.9091H20.9091V-0.909058Z'%20fill='white'/%3e%3c/mask%3e%3cg%20mask='url(%23mask0_7_19)'%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M0%2010C0%204.47715%204.47715%200%2010%200C15.5228%200%2020%204.47715%2020%2010C20%2015.5228%2015.5228%2020%2010%2020C4.47715%2020%200%2015.5228%200%2010ZM10%201.81818C5.4813%201.81818%201.81818%205.4813%201.81818%2010C1.81818%2014.5187%205.48131%2018.1818%2010%2018.1818C14.5187%2018.1818%2018.1818%2014.5187%2018.1818%2010C18.1818%205.48131%2014.5187%201.81818%2010%201.81818Z'%20fill='white'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M5.68182%205.63634C5.68182%205.15937%206.06849%204.77271%206.54546%204.77271H13.4546C13.9316%204.77271%2014.3182%205.15937%2014.3182%205.63634V14.2512C14.3182%2014.8932%2013.6426%2015.3108%2013.0683%2015.0237L11.8182%2014.3986L10.3863%2015.1146C10.1431%2015.2362%209.85691%2015.2362%209.61373%2015.1146L8.18182%2014.3986L6.93169%2015.0237C6.35746%2015.3108%205.68182%2014.8932%205.68182%2014.2512V5.63634ZM7.04546%206.13634V13.4423L7.7956%2013.0672C8.03873%2012.9456%208.32491%2012.9456%208.5681%2013.0672L10%2013.7832L11.4319%2013.0672C11.6751%2012.9456%2011.9613%2012.9456%2012.2045%2013.0672L12.9546%2013.4423V6.13634H7.04546Z'%20fill='white'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M6.36365%208.63631C6.36365%208.38531%206.56716%208.18176%206.81819%208.18176H6.98566C7.23669%208.18176%207.4402%208.38531%207.4402%208.63631C7.4402%208.88731%207.23669%209.09085%206.98566%209.09085H6.81819C6.56716%209.09085%206.36365%208.88731%206.36365%208.63631ZM7.78709%208.63631C7.78709%208.38531%207.9906%208.18176%208.24165%208.18176H8.57656C8.82765%208.18176%209.0311%208.38531%209.0311%208.63631C9.0311%208.88731%208.82765%209.09085%208.57656%209.09085H8.24165C7.9906%209.09085%207.78709%208.88731%207.78709%208.63631ZM9.37801%208.63631C9.37801%208.38531%209.58147%208.18176%209.83256%208.18176H10.1675C10.4186%208.18176%2010.622%208.38531%2010.622%208.63631C10.622%208.88731%2010.4186%209.09085%2010.1675%209.09085H9.83256C9.58147%209.09085%209.37801%208.88731%209.37801%208.63631ZM10.9689%208.63631C10.9689%208.38531%2011.1724%208.18176%2011.4235%208.18176H11.7584C12.0095%208.18176%2012.2129%208.38531%2012.2129%208.63631C12.2129%208.88731%2012.0095%209.09085%2011.7584%209.09085H11.4235C11.1724%209.09085%2010.9689%208.88731%2010.9689%208.63631ZM12.5598%208.63631C12.5598%208.38531%2012.7633%208.18176%2013.0144%208.18176H13.1818C13.4328%208.18176%2013.6364%208.38531%2013.6364%208.63631C13.6364%208.88731%2013.4328%209.09085%2013.1818%209.09085H13.0144C12.7633%209.09085%2012.5598%208.88731%2012.5598%208.63631Z'%20fill='white'/%3e%3c/g%3e%3c/g%3e%3cdefs%3e%3cclipPath%20id='clip0_7_19'%3e%3crect%20width='20'%20height='20'%20fill='white'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e", xRe = "data:image/svg+xml,%3csvg%20viewBox='0%200%2020%2020'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20clip-path='url(%23clip0_7_27)'%3e%3cmask%20id='mask0_7_27'%20style='mask-type:luminance'%20maskUnits='userSpaceOnUse'%20x='-1'%20y='-1'%20width='22'%20height='22'%3e%3cpath%20d='M20.9091%20-0.909058H-0.909088V20.9091H20.9091V-0.909058Z'%20fill='white'/%3e%3c/mask%3e%3cg%20mask='url(%23mask0_7_27)'%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M0%2010C0%204.47715%204.47715%200%2010%200C15.5228%200%2020%204.47715%2020%2010C20%2015.5228%2015.5228%2020%2010%2020C4.47715%2020%200%2015.5228%200%2010ZM10%201.81818C5.4813%201.81818%201.81818%205.4813%201.81818%2010C1.81818%2014.5187%205.48131%2018.1818%2010%2018.1818C14.5187%2018.1818%2018.1818%2014.5187%2018.1818%2010C18.1818%205.48131%2014.5187%201.81818%2010%201.81818Z'%20fill='white'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M6.36365%2010C6.36365%209.49794%206.77067%209.09094%207.27274%209.09094H12.7273C13.2294%209.09094%2013.6364%209.49794%2013.6364%2010C13.6364%2010.5021%2013.2294%2010.9091%2012.7273%2010.9091H7.27274C6.77067%2010.9091%206.36365%2010.5021%206.36365%2010Z'%20fill='white'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M6.36365%2013.6364C6.36365%2013.1343%206.77067%2012.7273%207.27274%2012.7273H9.09092C9.59301%2012.7273%2010%2013.1343%2010%2013.6364C10%2014.1385%209.59301%2014.5455%209.09092%2014.5455H7.27274C6.77067%2014.5455%206.36365%2014.1385%206.36365%2013.6364Z'%20fill='white'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M6.36365%206.36368C6.36365%205.86161%206.77067%205.45459%207.27274%205.45459H11.8182C12.3203%205.45459%2012.7273%205.86161%2012.7273%206.36368C12.7273%206.86575%2012.3203%207.27277%2011.8182%207.27277H7.27274C6.77067%207.27277%206.36365%206.86575%206.36365%206.36368Z'%20fill='white'/%3e%3c/g%3e%3c/g%3e%3cdefs%3e%3cclipPath%20id='clip0_7_27'%3e%3crect%20width='20'%20height='20'%20fill='white'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e", SRe = "data:image/svg+xml,%3csvg%20viewBox='0%200%2020%2020'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20clip-path='url(%23clip0_7_19)'%3e%3cmask%20id='mask0_7_19'%20style='mask-type:luminance'%20maskUnits='userSpaceOnUse'%20x='-1'%20y='-1'%20width='22'%20height='22'%3e%3cpath%20d='M20.9091%20-0.909058H-0.909088V20.9091H20.9091V-0.909058Z'%20fill='white'/%3e%3c/mask%3e%3cg%20mask='url(%23mask0_7_19)'%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M0%2010C0%204.47715%204.47715%200%2010%200C15.5228%200%2020%204.47715%2020%2010C20%2015.5228%2015.5228%2020%2010%2020C4.47715%2020%200%2015.5228%200%2010ZM10%201.81818C5.4813%201.81818%201.81818%205.4813%201.81818%2010C1.81818%2014.5187%205.48131%2018.1818%2010%2018.1818C14.5187%2018.1818%2018.1818%2014.5187%2018.1818%2010C18.1818%205.48131%2014.5187%201.81818%2010%201.81818Z'%20fill='white'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M5.68182%205.63634C5.68182%205.15937%206.06849%204.77271%206.54546%204.77271H13.4546C13.9316%204.77271%2014.3182%205.15937%2014.3182%205.63634V14.2512C14.3182%2014.8932%2013.6426%2015.3108%2013.0683%2015.0237L11.8182%2014.3986L10.3863%2015.1146C10.1431%2015.2362%209.85691%2015.2362%209.61373%2015.1146L8.18182%2014.3986L6.93169%2015.0237C6.35746%2015.3108%205.68182%2014.8932%205.68182%2014.2512V5.63634ZM7.04546%206.13634V13.4423L7.7956%2013.0672C8.03873%2012.9456%208.32491%2012.9456%208.5681%2013.0672L10%2013.7832L11.4319%2013.0672C11.6751%2012.9456%2011.9613%2012.9456%2012.2045%2013.0672L12.9546%2013.4423V6.13634H7.04546Z'%20fill='white'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M6.36365%208.63631C6.36365%208.38531%206.56716%208.18176%206.81819%208.18176H6.98566C7.23669%208.18176%207.4402%208.38531%207.4402%208.63631C7.4402%208.88731%207.23669%209.09085%206.98566%209.09085H6.81819C6.56716%209.09085%206.36365%208.88731%206.36365%208.63631ZM7.78709%208.63631C7.78709%208.38531%207.9906%208.18176%208.24165%208.18176H8.57656C8.82765%208.18176%209.0311%208.38531%209.0311%208.63631C9.0311%208.88731%208.82765%209.09085%208.57656%209.09085H8.24165C7.9906%209.09085%207.78709%208.88731%207.78709%208.63631ZM9.37801%208.63631C9.37801%208.38531%209.58147%208.18176%209.83256%208.18176H10.1675C10.4186%208.18176%2010.622%208.38531%2010.622%208.63631C10.622%208.88731%2010.4186%209.09085%2010.1675%209.09085H9.83256C9.58147%209.09085%209.37801%208.88731%209.37801%208.63631ZM10.9689%208.63631C10.9689%208.38531%2011.1724%208.18176%2011.4235%208.18176H11.7584C12.0095%208.18176%2012.2129%208.38531%2012.2129%208.63631C12.2129%208.88731%2012.0095%209.09085%2011.7584%209.09085H11.4235C11.1724%209.09085%2010.9689%208.88731%2010.9689%208.63631ZM12.5598%208.63631C12.5598%208.38531%2012.7633%208.18176%2013.0144%208.18176H13.1818C13.4328%208.18176%2013.6364%208.38531%2013.6364%208.63631C13.6364%208.88731%2013.4328%209.09085%2013.1818%209.09085H13.0144C12.7633%209.09085%2012.5598%208.88731%2012.5598%208.63631Z'%20fill='white'/%3e%3c/g%3e%3c/g%3e%3cdefs%3e%3cclipPath%20id='clip0_7_19'%3e%3crect%20width='20'%20height='20'%20fill='white'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e", RRe = "data:image/svg+xml,%3csvg%20viewBox='0%200%2020%2020'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20clip-path='url(%23clip0_7_9)'%3e%3cmask%20id='mask0_7_9'%20style='mask-type:luminance'%20maskUnits='userSpaceOnUse'%20x='-1'%20y='-1'%20width='22'%20height='22'%3e%3cpath%20d='M20.9091%20-0.909058H-0.909088V20.9091H20.9091V-0.909058Z'%20fill='white'/%3e%3c/mask%3e%3cg%20mask='url(%23mask0_7_9)'%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M0%2010C0%204.47715%204.47715%200%2010%200C15.5228%200%2020%204.47715%2020%2010C20%2015.5228%2015.5228%2020%2010%2020C4.47715%2020%200%2015.5228%200%2010ZM10%201.81818C5.4813%201.81818%201.81818%205.4813%201.81818%2010C1.81818%2014.5187%205.48131%2018.1818%2010%2018.1818C14.5187%2018.1818%2018.1818%2014.5187%2018.1818%2010C18.1818%205.48131%2014.5187%201.81818%2010%201.81818Z'%20fill='white'/%3e%3cpath%20d='M8.18183%205.45459H6.36365C5.86157%205.45459%205.45456%205.8616%205.45456%206.36368V8.18186C5.45456%208.68394%205.86157%209.09095%206.36365%209.09095H8.18183C8.68391%209.09095%209.09092%208.68394%209.09092%208.18186V6.36368C9.09092%205.8616%208.68391%205.45459%208.18183%205.45459Z'%20fill='white'/%3e%3cpath%20d='M13.6364%205.45459H11.8182C11.3161%205.45459%2010.9091%205.8616%2010.9091%206.36368V8.18186C10.9091%208.68394%2011.3161%209.09095%2011.8182%209.09095H13.6364C14.1384%209.09095%2014.5455%208.68394%2014.5455%208.18186V6.36368C14.5455%205.8616%2014.1384%205.45459%2013.6364%205.45459Z'%20fill='white'/%3e%3cpath%20d='M13.6364%2010.9091H11.8182C11.3161%2010.9091%2010.9091%2011.3161%2010.9091%2011.8181V13.6363C10.9091%2014.1384%2011.3161%2014.5454%2011.8182%2014.5454H13.6364C14.1384%2014.5454%2014.5455%2014.1384%2014.5455%2013.6363V11.8181C14.5455%2011.3161%2014.1384%2010.9091%2013.6364%2010.9091Z'%20fill='white'/%3e%3cpath%20d='M8.18183%2010.9091H6.36365C5.86157%2010.9091%205.45456%2011.3161%205.45456%2011.8181V13.6363C5.45456%2014.1384%205.86157%2014.5454%206.36365%2014.5454H8.18183C8.68391%2014.5454%209.09092%2014.1384%209.09092%2013.6363V11.8181C9.09092%2011.3161%208.68391%2010.9091%208.18183%2010.9091Z'%20fill='white'/%3e%3c/g%3e%3c/g%3e%3cdefs%3e%3cclipPath%20id='clip0_7_9'%3e%3crect%20width='20'%20height='20'%20fill='white'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e", ARe = "data:image/svg+xml,%3csvg%20viewBox='0%200%2020%2020'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20clip-path='url(%23clip0_7_36)'%3e%3cmask%20id='mask0_7_36'%20style='mask-type:luminance'%20maskUnits='userSpaceOnUse'%20x='-1'%20y='-1'%20width='22'%20height='22'%3e%3cpath%20d='M20.9091%20-0.909058H-0.909088V20.9091H20.9091V-0.909058Z'%20fill='white'/%3e%3c/mask%3e%3cg%20mask='url(%23mask0_7_36)'%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M0%2010C0%204.47715%204.47715%200%2010%200C15.5228%200%2020%204.47715%2020%2010C20%2015.5228%2015.5228%2020%2010%2020C4.47715%2020%200%2015.5228%200%2010ZM10%201.81818C5.4813%201.81818%201.81818%205.4813%201.81818%2010C1.81818%2014.5187%205.48131%2018.1818%2010%2018.1818C14.5187%2018.1818%2018.1818%2014.5187%2018.1818%2010C18.1818%205.48131%2014.5187%201.81818%2010%201.81818Z'%20fill='white'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M11.4718%2010.0244C11.2567%209.97354%2011.0304%2010.0028%2010.8353%2010.1067L2.29995%2014.6522C1.8568%2014.8882%201.68886%2015.4387%201.92486%2015.8818C2.16086%2016.325%202.71143%2016.4929%203.15458%2016.2569L11.3872%2011.8727L17.9726%2013.4302C18.4612%2013.5457%2018.951%2013.2433%2019.0665%2012.7546C19.1821%2012.2661%2018.8796%2011.7764%2018.3911%2011.6607L11.4718%2010.0244Z'%20fill='white'/%3e%3cpath%20d='M6.07329%209.09092C5.32016%209.09092%204.70966%208.48037%204.70966%207.72728C4.70966%206.97417%205.32016%206.36365%206.07329%206.36365C6.82643%206.36365%207.43693%206.97417%207.43693%207.72728C7.43693%208.48037%206.82643%209.09092%206.07329%209.09092Z'%20fill='white'/%3e%3c/g%3e%3c/g%3e%3cdefs%3e%3cclipPath%20id='clip0_7_36'%3e%3crect%20width='20'%20height='20'%20fill='white'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e", DRe = "data:image/svg+xml,%3csvg%20viewBox='0%200%2020%2020'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20clip-path='url(%23clip0_7_2)'%3e%3cmask%20id='mask0_7_2'%20style='mask-type:luminance'%20maskUnits='userSpaceOnUse'%20x='-1'%20y='-1'%20width='22'%20height='22'%3e%3cpath%20d='M20.9091%20-0.909058H-0.909088V20.9091H20.9091V-0.909058Z'%20fill='white'/%3e%3c/mask%3e%3cg%20mask='url(%23mask0_7_2)'%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M8.04937%200.190318C8.681%200.0653727%209.33327%200%2010%200C10.6667%200%2011.319%200.0653727%2011.9506%200.190318L11.5978%201.97394C11.0817%201.87185%2010.5475%201.81818%2010%201.81818C9.45245%201.81818%208.91827%201.87185%208.40218%201.97394L8.04937%200.190318ZM15.5568%201.68489C16.6469%202.41471%2017.5853%203.35308%2018.3151%204.4432L16.8043%205.45469C16.2066%204.56206%2015.4379%203.79335%2014.5453%203.19574L15.5568%201.68489ZM1.68489%204.4432C2.41471%203.35308%203.35308%202.41471%204.4432%201.68489L5.45469%203.19574C4.56206%203.79335%203.79335%204.56206%203.19574%205.45469L1.68489%204.4432ZM19.8096%208.04937C19.9346%208.681%2020%209.33327%2020%2010C20%2010.6667%2019.9346%2011.319%2019.8096%2011.9506L18.0261%2011.5978C18.1282%2011.0817%2018.1818%2010.5475%2018.1818%2010C18.1818%209.45245%2018.1282%208.91827%2018.0261%208.40218L19.8096%208.04937ZM0%2010C0%209.33327%200.0653727%208.681%200.190318%208.04937L1.97394%208.40218C1.87185%208.91827%201.81818%209.45245%201.81818%2010C1.81818%2010.5475%201.87185%2011.0817%201.97394%2011.5978L0.190318%2011.9506C0.0653727%2011.319%200%2010.6667%200%2010ZM18.3151%2015.5568C17.5853%2016.6469%2016.6469%2017.5853%2015.5568%2018.3151L14.5453%2016.8043C15.4379%2016.2066%2016.2066%2015.4379%2016.8043%2014.5453L18.3151%2015.5568ZM4.4432%2018.3151C3.35308%2017.5853%202.41471%2016.6469%201.68489%2015.5568L3.19574%2014.5453C3.79335%2015.4379%204.56206%2016.2066%205.45469%2016.8043L4.4432%2018.3151ZM10%2020C9.33327%2020%208.681%2019.9346%208.04937%2019.8096L8.40218%2018.0261C8.91827%2018.1282%209.45245%2018.1818%2010%2018.1818C10.5475%2018.1818%2011.0817%2018.1282%2011.5978%2018.0261L11.9506%2019.8096C11.319%2019.9346%2010.6667%2020%2010%2020Z'%20fill='white'/%3e%3cpath%20d='M10%2011.8181C8.99582%2011.8181%208.18182%2011.0041%208.18182%209.99994C8.18182%208.99576%208.99582%208.18176%2010%208.18176C11.0042%208.18176%2011.8182%208.99576%2011.8182%209.99994C11.8182%2011.0041%2011.0042%2011.8181%2010%2011.8181Z'%20fill='white'/%3e%3c/g%3e%3c/g%3e%3cdefs%3e%3cclipPath%20id='clip0_7_2'%3e%3crect%20width='20'%20height='20'%20fill='white'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e", ERe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Artifact: TRe,
  ArtifactImage: ARe,
  ArtifactMarkdown: xRe,
  ArtifactProgress: DRe,
  ArtifactResult: SRe,
  ArtifactTable: RRe
}, Symbol.toStringTag, { value: "Module" }));
function MRe(t) {
  const e = {
    resolution: UL
  };
  return pt.from(ERe[t], e);
}
async function PRe(t) {
  return await py(MRe, [t]);
}
async function CRe({ cullAtZoomThreshold: t = !0 } = {}) {
  const e = await BU(), n = new Vr();
  t && e.add(n);
  async function r(o) {
    const s = await PRe(o);
    return n.texture = s, n;
  }
  return {
    element: n,
    render: r
  };
}
var CO = { exports: {} }, OO;
function ORe() {
  return OO || (OO = 1, function(t) {
    (function() {
      function e(g, _) {
        document.addEventListener ? g.addEventListener("scroll", _, !1) : g.attachEvent("scroll", _);
      }
      function n(g) {
        document.body ? g() : document.addEventListener ? document.addEventListener("DOMContentLoaded", function _() {
          document.removeEventListener("DOMContentLoaded", _), g();
        }) : document.attachEvent("onreadystatechange", function _() {
          (document.readyState == "interactive" || document.readyState == "complete") && (document.detachEvent("onreadystatechange", _), g());
        });
      }
      function r(g) {
        this.g = document.createElement("div"), this.g.setAttribute("aria-hidden", "true"), this.g.appendChild(document.createTextNode(g)), this.h = document.createElement("span"), this.i = document.createElement("span"), this.m = document.createElement("span"), this.j = document.createElement("span"), this.l = -1, this.h.style.cssText = "max-width:none;display:inline-block;position:absolute;height:100%;width:100%;overflow:scroll;font-size:16px;", this.i.style.cssText = "max-width:none;display:inline-block;position:absolute;height:100%;width:100%;overflow:scroll;font-size:16px;", this.j.style.cssText = "max-width:none;display:inline-block;position:absolute;height:100%;width:100%;overflow:scroll;font-size:16px;", this.m.style.cssText = "display:inline-block;width:200%;height:200%;font-size:16px;max-width:none;", this.h.appendChild(this.m), this.i.appendChild(this.j), this.g.appendChild(this.h), this.g.appendChild(this.i);
      }
      function o(g, _) {
        g.g.style.cssText = "max-width:none;min-width:20px;min-height:20px;display:inline-block;overflow:hidden;position:absolute;width:auto;margin:0;padding:0;top:-999px;white-space:nowrap;font-synthesis:none;font:" + _ + ";";
      }
      function s(g) {
        var _ = g.g.offsetWidth, b = _ + 100;
        return g.j.style.width = b + "px", g.i.scrollLeft = b, g.h.scrollLeft = g.h.scrollWidth + 100, g.l !== _ ? (g.l = _, !0) : !1;
      }
      function i(g, _) {
        function b() {
          var S = x;
          s(S) && S.g.parentNode !== null && _(S.l);
        }
        var x = g;
        e(g.h, b), e(g.i, b), s(g);
      }
      function u(g, _, b) {
        _ = _ || {}, b = b || window, this.family = g, this.style = _.style || "normal", this.weight = _.weight || "normal", this.stretch = _.stretch || "normal", this.context = b;
      }
      var l = null, a = null, c = null, p = null;
      function d(g) {
        return a === null && (h(g) && /Apple/.test(window.navigator.vendor) ? (g = /AppleWebKit\/([0-9]+)(?:\.([0-9]+))(?:\.([0-9]+))/.exec(window.navigator.userAgent), a = !!g && 603 > parseInt(g[1], 10)) : a = !1), a;
      }
      function h(g) {
        return p === null && (p = !!g.document.fonts), p;
      }
      function m(g, _) {
        var b = g.style, x = g.weight;
        if (c === null) {
          var S = document.createElement("div");
          try {
            S.style.font = "condensed 100px sans-serif";
          } catch {
          }
          c = S.style.font !== "";
        }
        return [b, x, c ? g.stretch : "", "100px", _].join(" ");
      }
      u.prototype.load = function(g, _) {
        var b = this, x = g || "BESbswy", S = 0, E = _ || 3e3, A = (/* @__PURE__ */ new Date()).getTime();
        return new Promise(function(C, M) {
          if (h(b.context) && !d(b.context)) {
            var L = new Promise(function(te, B) {
              function W() {
                (/* @__PURE__ */ new Date()).getTime() - A >= E ? B(Error("" + E + "ms timeout exceeded")) : b.context.document.fonts.load(m(b, '"' + b.family + '"'), x).then(function(G) {
                  1 <= G.length ? te() : setTimeout(W, 25);
                }, B);
              }
              W();
            }), X = new Promise(function(te, B) {
              S = setTimeout(function() {
                B(Error("" + E + "ms timeout exceeded"));
              }, E);
            });
            Promise.race([X, L]).then(function() {
              clearTimeout(S), C(b);
            }, M);
          } else n(function() {
            function te() {
              var oe;
              (oe = de != -1 && V != -1 || de != -1 && Y != -1 || V != -1 && Y != -1) && ((oe = de != V && de != Y && V != Y) || (l === null && (oe = /AppleWebKit\/([0-9]+)(?:\.([0-9]+))/.exec(window.navigator.userAgent), l = !!oe && (536 > parseInt(oe[1], 10) || parseInt(oe[1], 10) === 536 && 11 >= parseInt(oe[2], 10))), oe = l && (de == Q && V == Q && Y == Q || de == ae && V == ae && Y == ae || de == Z && V == Z && Y == Z)), oe = !oe), oe && (J.parentNode !== null && J.parentNode.removeChild(J), clearTimeout(S), C(b));
            }
            function B() {
              if ((/* @__PURE__ */ new Date()).getTime() - A >= E) J.parentNode !== null && J.parentNode.removeChild(J), M(Error("" + E + "ms timeout exceeded"));
              else {
                var oe = b.context.document.hidden;
                (oe === !0 || oe === void 0) && (de = W.g.offsetWidth, V = G.g.offsetWidth, Y = ne.g.offsetWidth, te()), S = setTimeout(B, 50);
              }
            }
            var W = new r(x), G = new r(x), ne = new r(x), de = -1, V = -1, Y = -1, Q = -1, ae = -1, Z = -1, J = document.createElement("div");
            J.dir = "ltr", o(W, m(b, "sans-serif")), o(G, m(b, "serif")), o(ne, m(b, "monospace")), J.appendChild(W.g), J.appendChild(G.g), J.appendChild(ne.g), b.context.document.body.appendChild(J), Q = W.g.offsetWidth, ae = G.g.offsetWidth, Z = ne.g.offsetWidth, B(), i(W, function(oe) {
              de = oe, te();
            }), o(W, m(b, '"' + b.family + '",sans-serif')), i(G, function(oe) {
              V = oe, te();
            }), o(G, m(b, '"' + b.family + '",serif')), i(ne, function(oe) {
              Y = oe, te();
            }), o(ne, m(b, '"' + b.family + '",monospace'));
          });
        });
      }, t.exports = u;
    })();
  }(CO)), CO.exports;
}
var IRe = ORe();
const FRe = /* @__PURE__ */ iy(IRe);
let Rv = null;
const NRe = {
  fontFamily: "Inter Variable",
  fontSize: 16,
  lineHeight: 20,
  fill: 16777215
}, Vb = {
  resolution: UL,
  chars: Ta.ASCII
}, Hb = "sans-serif";
async function LRe() {
  const { font: t } = await wr(), e = {
    ...NRe,
    fontFamily: t.fontFamily
  };
  await BRe(e, t.type), Rv = XRe(e), Ze.emit("fontLoaded", Rv);
}
async function BRe(t, e) {
  const { fontFamily: n, ...r } = t;
  try {
    e === "WebFont" ? await new FRe(n).load() : Ta.from(n, {
      fontFamily: Hb,
      ...r
    }, Vb);
  } catch (o) {
    console.error(o), console.warn(`fonts: font ${n} failed to load, falling back to ${Hb}`), Ta.from(n, {
      fontFamily: Hb,
      ...r
    }, Vb);
    return;
  }
  Ta.from(n, t, Vb);
}
function URe() {
  Rv = null;
}
async function M5() {
  return Rv || await Is("fontLoaded");
}
function XRe(t) {
  const { fontFamily: e, ...n } = t, r = {
    fontName: e,
    ...n
  };
  return (o) => new Ixe(o, r);
}
async function ew({ cullAtZoomThreshold: t = !0 } = {}) {
  const e = await M5(), n = await LU(), r = e("");
  t && n.add(r);
  async function o(s) {
    return r.text = s, await r;
  }
  return {
    element: r,
    render: o
  };
}
async function P5({ cullAtZoomThreshold: t }) {
  const e = await wr(), n = new fn(), r = new fn(), { element: o, render: s } = await CRe({ cullAtZoomThreshold: t }), { element: i, render: u } = await kRe(), { element: l, render: a } = await ew({ cullAtZoomThreshold: t }), { element: c, render: p } = await vRe();
  let d = !1, h = null, m;
  r.addChild(l), n.addChild(c), n.addChild(r);
  async function g(E) {
    const { selected: A, name: C, type: M } = E;
    return d = A ?? d, h = C ?? h, m = M, m === "progress" ? r.addChild(i) : r.addChild(o), E.type === "progress" ? await Promise.all([
      b(E.data),
      x()
    ]) : await Promise.all([
      _(),
      x()
    ]), await S(), n;
  }
  async function _() {
    if (m === "progress")
      return o;
    const E = Q_e[m], {
      artifactIconSize: A,
      artifactIconColor: C,
      artifactPaddingLeft: M,
      artifactPaddingY: L
    } = e, X = await s(E);
    return X.position = { x: M, y: L }, X.width = A, X.height = A, X.tint = C, X;
  }
  async function b(E) {
    const {
      artifactPaddingLeft: A,
      artifactPaddingRight: C,
      artifactPaddingY: M,
      artifactIconSize: L
    } = e, X = 20, te = (L - X * 2) / 2, B = u({
      value: E,
      radius: te,
      lineWidth: X
    });
    return h ? B.position.x += A : B.position.x += (A + C) / 2, B.position.y += M, i;
  }
  async function x() {
    if (!h)
      return l.visible = !1, l;
    await a(h);
    const {
      artifactPaddingLeft: E,
      artifactPaddingY: A,
      artifactTextColor: C,
      artifactIconSize: M,
      artifactContentGap: L
    } = e, X = h ? L : 0, te = E + M + X, B = A;
    return l.tint = C, l.scale.set(0.75), l.position = { x: te, y: B }, l.visible = !0, l;
  }
  async function S() {
    const {
      artifactPaddingLeft: E,
      artifactPaddingRight: A,
      artifactPaddingY: C
    } = e, M = {
      selected: d,
      width: r.width + E + A,
      height: r.height + C * 2
    };
    return await p(M);
  }
  return {
    element: n,
    render: g
  };
}
let dr = null, Av = !1;
async function $Re() {
  const t = await ro();
  t.on("click", () => wu(null)), t.on("drag-start", () => {
    Av = !0;
  }), t.on("drag-end", () => {
    setTimeout(() => {
      Av = !1;
    });
  });
}
function WRe() {
  dr = null, Av = !1;
}
function wu(t) {
  if (!Av && !(!t && !dr || t && vl(t))) {
    if (dr = t, t === null) {
      Ze.emit("itemSelected", null);
      return;
    }
    Ze.emit("itemSelected", t);
  }
}
function vl(t) {
  if (dr === null)
    return !1;
  const { kind: e } = t;
  switch (e) {
    case "task-run":
      return Gk(dr) && dr.id === t.id;
    case "flow-run":
      return Gk(dr) && dr.id === t.id;
    case "artifact":
      return FL(dr) && dr.id === t.id;
    case "artifacts":
      return Z_e(dr) && dr.ids.length === t.ids.length && dr.ids.every((r) => t.ids.includes(r));
    case "state":
      return J_e(dr) && dr.id === t.id;
    case "event":
      return ewe(dr) && dr.id === t.id;
    case "events":
      return twe(dr) && dr.ids.length === t.ids.length && dr.ids.every((r) => t.ids.includes(r));
    default:
      const n = e;
      throw new Error(`switch does not have case for value: ${n}`);
  }
}
function VRe() {
  return dr && Gk(dr) ? dr : null;
}
async function JS(t, {
  cullAtZoomThreshold: e = !0,
  enableLocalClickHandling: n = !1
} = {}) {
  const { element: r, render: o } = await P5({ cullAtZoomThreshold: e });
  let s = !1, i = t;
  r.eventMode = "static", r.cursor = "pointer", n && r.on("click", (p) => {
    p.stopPropagation(), wu({ kind: "artifact", id: i.id });
  }), Ze.on("itemSelected", () => {
    const p = vl({ kind: "artifact", id: i.id });
    p !== s && (s = p, u(i));
  });
  async function u(p) {
    i = p, await o({ selected: s, name: i.key, ...i });
  }
  function l() {
    return s;
  }
  function a() {
    return i.created;
  }
  function c() {
    return i.id;
  }
  return {
    isArtifact: !0,
    element: r,
    render: u,
    getSelected: l,
    getDate: a,
    getId: c
  };
}
function C5(t) {
  return t.isArtifact === !0;
}
function HRe(t) {
  return typeof t == "function";
}
function m0(t) {
  return HRe(t) ? t() : t;
}
async function O5(t, e) {
  const n = await ku(), r = await oa();
  let o, s = null;
  async function i() {
    try {
      s = await r.fetchEvents(m0(t)), e(s);
    } catch (l) {
      console.error(l);
    }
    n.end_time || (o = setTimeout(() => i(), r.fetchEventsInterval));
  }
  function u() {
    clearTimeout(o);
  }
  return {
    start: i,
    stop: u
  };
}
async function I5() {
  const t = await wr(), e = await LU(), n = new fn(), { element: r, render: o } = await E5(), { element: s, render: i } = await ZS(), { element: u, render: l } = await Z_();
  e.add(n);
  let a = !1;
  n.eventMode = "static", n.cursor = "pointer", n.addChild(s), n.addChild(r), n.addChild(u), n.on("mouseover", p), n.on("mouseout", d);
  async function c({ inside: h, isOpen: m }) {
    a = h;
    const g = {
      size: 10,
      stroke: 2,
      rotate: m ? Sv.Up : Sv.Down
    }, _ = await o(g), b = {
      width: t.nodeToggleSize,
      height: t.nodeToggleSize,
      background: t.nodeToggleBgColor,
      radius: t.nodeToggleBorderRadius
    }, x = await i(b);
    x.alpha = h ? 0 : 0.5;
    const S = await l({
      width: b.width,
      height: b.height,
      radius: b.radius,
      stroke: 1,
      color: t.nodeToggleBorderColor
    });
    S.alpha = h ? 0 : 1;
    const E = {
      y: x.height / 2,
      x: x.width / 2
    }, A = g.size / 4;
    return _.x = E.x, _.y = m ? E.y + A : E.y - A, n;
  }
  function p() {
    s.alpha = a ? 0.5 : 1;
  }
  function d() {
    s.alpha = a ? 0 : 0.5;
  }
  return {
    element: n,
    render: c
  };
}
async function F5() {
  const t = await wr(), e = await eo(), n = new fn(), { element: r, render: o } = await ZS(), { element: s, render: i } = await J_();
  n.addChild(r), n.addChild(s);
  async function u(a) {
    const { background: c = "#fff" } = t.node(a), { nodeHeight: p, nodeRadius: d } = t, h = vl({ kind: a.kind, id: a.id }), m = l(a, d), g = a.state_type !== "RUNNING" || e.isDependency();
    return await Promise.all([
      o({
        width: m,
        height: p,
        radius: d,
        background: c,
        capRight: g
      }),
      i({ selected: h, width: m, height: p })
    ]), r;
  }
  function l(a, c) {
    const p = QS();
    if (ot.isTemporal() || ot.isLeftAligned()) {
      const d = a.start_time, h = a.end_time ?? /* @__PURE__ */ new Date(), m = A5(h, d) / p0 * p;
      return Math.max(m, c * 2);
    }
    return p;
  }
  return {
    element: n,
    render: u
  };
}
var jb, IO;
function jRe() {
  if (IO) return jb;
  IO = 1;
  var t = "Expected a function", e = NaN, n = "[object Symbol]", r = /^\s+|\s+$/g, o = /^[-+]0x[0-9a-f]+$/i, s = /^0b[01]+$/i, i = /^0o[0-7]+$/i, u = parseInt, l = typeof Aa == "object" && Aa && Aa.Object === Object && Aa, a = typeof self == "object" && self && self.Object === Object && self, c = l || a || Function("return this")(), p = Object.prototype, d = p.toString, h = Math.max, m = Math.min, g = function() {
    return c.Date.now();
  };
  function _(C, M, L) {
    var X, te, B, W, G, ne, de = 0, V = !1, Y = !1, Q = !0;
    if (typeof C != "function")
      throw new TypeError(t);
    M = A(M) || 0, x(L) && (V = !!L.leading, Y = "maxWait" in L, B = Y ? h(A(L.maxWait) || 0, M) : B, Q = "trailing" in L ? !!L.trailing : Q);
    function ae(Me) {
      var fe = X, Te = te;
      return X = te = void 0, de = Me, W = C.apply(Te, fe), W;
    }
    function Z(Me) {
      return de = Me, G = setTimeout(ue, M), V ? ae(Me) : W;
    }
    function J(Me) {
      var fe = Me - ne, Te = Me - de, Ae = M - fe;
      return Y ? m(Ae, B - Te) : Ae;
    }
    function oe(Me) {
      var fe = Me - ne, Te = Me - de;
      return ne === void 0 || fe >= M || fe < 0 || Y && Te >= B;
    }
    function ue() {
      var Me = g();
      if (oe(Me))
        return me(Me);
      G = setTimeout(ue, J(Me));
    }
    function me(Me) {
      return G = void 0, Q && X ? ae(Me) : (X = te = void 0, W);
    }
    function pe() {
      G !== void 0 && clearTimeout(G), de = 0, X = ne = te = G = void 0;
    }
    function Be() {
      return G === void 0 ? W : me(g());
    }
    function Ie() {
      var Me = g(), fe = oe(Me);
      if (X = arguments, te = this, ne = Me, fe) {
        if (G === void 0)
          return Z(ne);
        if (Y)
          return G = setTimeout(ue, M), ae(ne);
      }
      return G === void 0 && (G = setTimeout(ue, M)), W;
    }
    return Ie.cancel = pe, Ie.flush = Be, Ie;
  }
  function b(C, M, L) {
    var X = !0, te = !0;
    if (typeof C != "function")
      throw new TypeError(t);
    return x(L) && (X = "leading" in L ? !!L.leading : X, te = "trailing" in L ? !!L.trailing : te), _(C, M, {
      leading: X,
      maxWait: M,
      trailing: te
    });
  }
  function x(C) {
    var M = typeof C;
    return !!C && (M == "object" || M == "function");
  }
  function S(C) {
    return !!C && typeof C == "object";
  }
  function E(C) {
    return typeof C == "symbol" || S(C) && d.call(C) == n;
  }
  function A(C) {
    if (typeof C == "number")
      return C;
    if (E(C))
      return e;
    if (x(C)) {
      var M = typeof C.valueOf == "function" ? C.valueOf() : C;
      C = x(M) ? M + "" : M;
    }
    if (typeof C != "string")
      return C === 0 ? C : +C;
    C = C.replace(r, "");
    var L = s.test(C);
    return L || i.test(C) ? u(C.slice(2), L ? 2 : 8) : o.test(C) ? e : +C;
  }
  return jb = b, jb;
}
var zRe = jRe();
const N5 = /* @__PURE__ */ iy(zRe);
async function L5() {
  const { element: t, render: e } = await P5({ cullAtZoomThreshold: !1 });
  let n = null, r = [], o = !1;
  t.eventMode = "static", t.cursor = "pointer", Ze.on("itemSelected", () => {
    const a = vl({ kind: "artifacts", ids: r });
    a !== o && n && (o = a, s({ ids: r, date: n }));
  });
  async function s(a) {
    if (!a) {
      n = null, r = [], t.visible = !1;
      return;
    }
    const { ids: c, date: p } = a;
    n = p, r = c, await e({ selected: o, type: "unknown", name: c.length.toString() }), t.visible = !0;
  }
  function i() {
    return o;
  }
  function u() {
    return n;
  }
  function l() {
    return r;
  }
  return {
    isArtifactCluster: !0,
    element: t,
    render: s,
    getSelected: i,
    getDate: u,
    getIds: l,
    isCluster: !0
  };
}
async function qRe({ radius: t }) {
  const e = await no(), n = new vc();
  return n.beginFill("#fff"), n.drawCircle(0, 0, t), n.endFill(), e.renderer.generateTexture(n, {
    resolution: BL
  });
}
async function GRe(t) {
  return await py(qRe, [t]);
}
async function B5(t) {
  const e = await GRe(t);
  return new Vr(e);
}
async function U5(t) {
  const e = new fn(), n = await wr(), r = await ll(), o = await B5({ radius: n.eventRadiusDefault }), { element: s, render: i } = await J_();
  let u = !1;
  e.addChild(r), e.addChild(o), e.addChild(s), e.eventMode = "static", e.cursor = "pointer", e.on("mouseenter", () => {
    u || o.scale.set(1.5);
  }), e.on("mouseleave", () => {
    u || o.scale.set(1);
  }), Ze.on("itemSelected", () => {
    const p = vl({ kind: "event", id: t.id, occurred: t.occurred });
    p !== u && (u = p, o.scale.set(p ? 1.5 : 1), l());
  });
  function l() {
    const { eventColor: p, eventTargetSize: d, eventSelectedBorderInset: h } = n;
    r.alpha = 0, r.width = d, r.height = d, o.tint = p, o.anchor.set(0.5), o.position.set(d / 2, d / 2), s.position.set(h, h), i({
      selected: u,
      width: d - h * 2,
      height: d - h * 2
    });
  }
  function a() {
    return t.id;
  }
  function c() {
    return t.occurred;
  }
  return {
    element: e,
    render: l,
    getId: a,
    getDate: c
  };
}
async function X5() {
  const t = new fn(), e = await wr(), n = await ll(), r = await B5({ radius: e.eventClusterRadiusDefault }), { element: o, render: s } = await J_(), { element: i, render: u } = await ew({ cullAtZoomThreshold: !1 });
  let l = null, a = [], c = !1;
  t.addChild(n), t.addChild(r), t.addChild(i), t.addChild(o), t.eventMode = "static", t.cursor = "pointer", t.on("mouseenter", () => {
    c || r.scale.set(1.5);
  }), t.on("mouseleave", () => {
    c || r.scale.set(1);
  }), Ze.on("itemSelected", () => {
    const x = vl({ kind: "events", ids: a });
    x !== c && (c = x, r.scale.set(x ? 1.5 : 1), l && p({ ids: a, date: l }));
  });
  async function p(x) {
    if (!x) {
      l = null, a = [], t.visible = !1;
      return;
    }
    const { ids: S, date: E } = x;
    l = E, a = S, d(), h(), g(), await m(S.length.toString()), t.visible = !0;
  }
  function d() {
    const { eventTargetSize: x } = e;
    n.alpha = 0, n.width = x, n.height = x;
  }
  function h() {
    const { eventClusterColor: x, eventTargetSize: S } = e;
    r.tint = x, r.anchor.set(0.5), r.position.set(S / 2, S / 2);
  }
  async function m(x) {
    if (a.length < 2)
      return;
    const { eventTargetSize: S } = e;
    i.scale.set(0.6), i.anchor.set(0.5), i.position.set(
      S / 2,
      S / 2 + -1
    ), await u(x);
  }
  function g() {
    const { eventSelectedBorderInset: x, eventTargetSize: S } = e;
    o.position.set(x, x), s({
      selected: c,
      width: S - x * 2,
      height: S - x * 2
    });
  }
  function _() {
    return a;
  }
  function b() {
    return l;
  }
  return {
    element: t,
    render: p,
    getIds: _,
    getDate: b
  };
}
function y0(t, e) {
  return t == null || e == null ? NaN : t < e ? -1 : t > e ? 1 : t >= e ? 0 : NaN;
}
function YRe(t, e) {
  return t == null || e == null ? NaN : e < t ? -1 : e > t ? 1 : e >= t ? 0 : NaN;
}
function eR(t) {
  let e, n, r;
  t.length !== 2 ? (e = y0, n = (u, l) => y0(t(u), l), r = (u, l) => t(u) - l) : (e = t === y0 || t === YRe ? t : QRe, n = t, r = t);
  function o(u, l, a = 0, c = u.length) {
    if (a < c) {
      if (e(l, l) !== 0) return c;
      do {
        const p = a + c >>> 1;
        n(u[p], l) < 0 ? a = p + 1 : c = p;
      } while (a < c);
    }
    return a;
  }
  function s(u, l, a = 0, c = u.length) {
    if (a < c) {
      if (e(l, l) !== 0) return c;
      do {
        const p = a + c >>> 1;
        n(u[p], l) <= 0 ? a = p + 1 : c = p;
      } while (a < c);
    }
    return a;
  }
  function i(u, l, a = 0, c = u.length) {
    const p = o(u, l, a, c - 1);
    return p > a && r(u[p - 1], l) > -r(u[p], l) ? p - 1 : p;
  }
  return { left: o, center: i, right: s };
}
function QRe() {
  return 0;
}
function KRe(t) {
  return t === null ? NaN : +t;
}
const ZRe = eR(y0), JRe = ZRe.right;
eR(KRe).center;
const eAe = Math.sqrt(50), tAe = Math.sqrt(10), nAe = Math.sqrt(2);
function Dv(t, e, n) {
  const r = (e - t) / Math.max(0, n), o = Math.floor(Math.log10(r)), s = r / Math.pow(10, o), i = s >= eAe ? 10 : s >= tAe ? 5 : s >= nAe ? 2 : 1;
  let u, l, a;
  return o < 0 ? (a = Math.pow(10, -o) / i, u = Math.round(t * a), l = Math.round(e * a), u / a < t && ++u, l / a > e && --l, a = -a) : (a = Math.pow(10, o) * i, u = Math.round(t / a), l = Math.round(e / a), u * a < t && ++u, l * a > e && --l), l < u && 0.5 <= n && n < 2 ? Dv(t, e, n * 2) : [u, l, a];
}
function rAe(t, e, n) {
  if (e = +e, t = +t, n = +n, !(n > 0)) return [];
  if (t === e) return [t];
  const r = e < t, [o, s, i] = r ? Dv(e, t, n) : Dv(t, e, n);
  if (!(s >= o)) return [];
  const u = s - o + 1, l = new Array(u);
  if (r)
    if (i < 0) for (let a = 0; a < u; ++a) l[a] = (s - a) / -i;
    else for (let a = 0; a < u; ++a) l[a] = (s - a) * i;
  else if (i < 0) for (let a = 0; a < u; ++a) l[a] = (o + a) / -i;
  else for (let a = 0; a < u; ++a) l[a] = (o + a) * i;
  return l;
}
function ZT(t, e, n) {
  return e = +e, t = +t, n = +n, Dv(t, e, n)[2];
}
function JT(t, e, n) {
  e = +e, t = +t, n = +n;
  const r = e < t, o = r ? ZT(e, t, n) : ZT(t, e, n);
  return (r ? -1 : 1) * (o < 0 ? 1 / -o : o);
}
var oAe = { value: () => {
} };
function $5() {
  for (var t = 0, e = arguments.length, n = {}, r; t < e; ++t) {
    if (!(r = arguments[t] + "") || r in n || /[\s.]/.test(r)) throw new Error("illegal type: " + r);
    n[r] = [];
  }
  return new g0(n);
}
function g0(t) {
  this._ = t;
}
function sAe(t, e) {
  return t.trim().split(/^|\s+/).map(function(n) {
    var r = "", o = n.indexOf(".");
    if (o >= 0 && (r = n.slice(o + 1), n = n.slice(0, o)), n && !e.hasOwnProperty(n)) throw new Error("unknown type: " + n);
    return { type: n, name: r };
  });
}
g0.prototype = $5.prototype = {
  constructor: g0,
  on: function(t, e) {
    var n = this._, r = sAe(t + "", n), o, s = -1, i = r.length;
    if (arguments.length < 2) {
      for (; ++s < i; ) if ((o = (t = r[s]).type) && (o = aAe(n[o], t.name))) return o;
      return;
    }
    if (e != null && typeof e != "function") throw new Error("invalid callback: " + e);
    for (; ++s < i; )
      if (o = (t = r[s]).type) n[o] = FO(n[o], t.name, e);
      else if (e == null) for (o in n) n[o] = FO(n[o], t.name, null);
    return this;
  },
  copy: function() {
    var t = {}, e = this._;
    for (var n in e) t[n] = e[n].slice();
    return new g0(t);
  },
  call: function(t, e) {
    if ((o = arguments.length - 2) > 0) for (var n = new Array(o), r = 0, o, s; r < o; ++r) n[r] = arguments[r + 2];
    if (!this._.hasOwnProperty(t)) throw new Error("unknown type: " + t);
    for (s = this._[t], r = 0, o = s.length; r < o; ++r) s[r].value.apply(e, n);
  },
  apply: function(t, e, n) {
    if (!this._.hasOwnProperty(t)) throw new Error("unknown type: " + t);
    for (var r = this._[t], o = 0, s = r.length; o < s; ++o) r[o].value.apply(e, n);
  }
};
function aAe(t, e) {
  for (var n = 0, r = t.length, o; n < r; ++n)
    if ((o = t[n]).name === e)
      return o.value;
}
function FO(t, e, n) {
  for (var r = 0, o = t.length; r < o; ++r)
    if (t[r].name === e) {
      t[r] = oAe, t = t.slice(0, r).concat(t.slice(r + 1));
      break;
    }
  return n != null && t.push({ name: e, value: n }), t;
}
var ex = "http://www.w3.org/1999/xhtml";
const NO = {
  svg: "http://www.w3.org/2000/svg",
  xhtml: ex,
  xlink: "http://www.w3.org/1999/xlink",
  xml: "http://www.w3.org/XML/1998/namespace",
  xmlns: "http://www.w3.org/2000/xmlns/"
};
function tw(t) {
  var e = t += "", n = e.indexOf(":");
  return n >= 0 && (e = t.slice(0, n)) !== "xmlns" && (t = t.slice(n + 1)), NO.hasOwnProperty(e) ? { space: NO[e], local: t } : t;
}
function iAe(t) {
  return function() {
    var e = this.ownerDocument, n = this.namespaceURI;
    return n === ex && e.documentElement.namespaceURI === ex ? e.createElement(t) : e.createElementNS(n, t);
  };
}
function uAe(t) {
  return function() {
    return this.ownerDocument.createElementNS(t.space, t.local);
  };
}
function W5(t) {
  var e = tw(t);
  return (e.local ? uAe : iAe)(e);
}
function lAe() {
}
function tR(t) {
  return t == null ? lAe : function() {
    return this.querySelector(t);
  };
}
function cAe(t) {
  typeof t != "function" && (t = tR(t));
  for (var e = this._groups, n = e.length, r = new Array(n), o = 0; o < n; ++o)
    for (var s = e[o], i = s.length, u = r[o] = new Array(i), l, a, c = 0; c < i; ++c)
      (l = s[c]) && (a = t.call(l, l.__data__, c, s)) && ("__data__" in l && (a.__data__ = l.__data__), u[c] = a);
  return new _i(r, this._parents);
}
function pAe(t) {
  return t == null ? [] : Array.isArray(t) ? t : Array.from(t);
}
function dAe() {
  return [];
}
function V5(t) {
  return t == null ? dAe : function() {
    return this.querySelectorAll(t);
  };
}
function hAe(t) {
  return function() {
    return pAe(t.apply(this, arguments));
  };
}
function fAe(t) {
  typeof t == "function" ? t = hAe(t) : t = V5(t);
  for (var e = this._groups, n = e.length, r = [], o = [], s = 0; s < n; ++s)
    for (var i = e[s], u = i.length, l, a = 0; a < u; ++a)
      (l = i[a]) && (r.push(t.call(l, l.__data__, a, i)), o.push(l));
  return new _i(r, o);
}
function H5(t) {
  return function() {
    return this.matches(t);
  };
}
function j5(t) {
  return function(e) {
    return e.matches(t);
  };
}
var mAe = Array.prototype.find;
function yAe(t) {
  return function() {
    return mAe.call(this.children, t);
  };
}
function gAe() {
  return this.firstElementChild;
}
function vAe(t) {
  return this.select(t == null ? gAe : yAe(typeof t == "function" ? t : j5(t)));
}
var _Ae = Array.prototype.filter;
function wAe() {
  return Array.from(this.children);
}
function bAe(t) {
  return function() {
    return _Ae.call(this.children, t);
  };
}
function kAe(t) {
  return this.selectAll(t == null ? wAe : bAe(typeof t == "function" ? t : j5(t)));
}
function TAe(t) {
  typeof t != "function" && (t = H5(t));
  for (var e = this._groups, n = e.length, r = new Array(n), o = 0; o < n; ++o)
    for (var s = e[o], i = s.length, u = r[o] = [], l, a = 0; a < i; ++a)
      (l = s[a]) && t.call(l, l.__data__, a, s) && u.push(l);
  return new _i(r, this._parents);
}
function z5(t) {
  return new Array(t.length);
}
function xAe() {
  return new _i(this._enter || this._groups.map(z5), this._parents);
}
function Ev(t, e) {
  this.ownerDocument = t.ownerDocument, this.namespaceURI = t.namespaceURI, this._next = null, this._parent = t, this.__data__ = e;
}
Ev.prototype = {
  constructor: Ev,
  appendChild: function(t) {
    return this._parent.insertBefore(t, this._next);
  },
  insertBefore: function(t, e) {
    return this._parent.insertBefore(t, e);
  },
  querySelector: function(t) {
    return this._parent.querySelector(t);
  },
  querySelectorAll: function(t) {
    return this._parent.querySelectorAll(t);
  }
};
function SAe(t) {
  return function() {
    return t;
  };
}
function RAe(t, e, n, r, o, s) {
  for (var i = 0, u, l = e.length, a = s.length; i < a; ++i)
    (u = e[i]) ? (u.__data__ = s[i], r[i] = u) : n[i] = new Ev(t, s[i]);
  for (; i < l; ++i)
    (u = e[i]) && (o[i] = u);
}
function AAe(t, e, n, r, o, s, i) {
  var u, l, a = /* @__PURE__ */ new Map(), c = e.length, p = s.length, d = new Array(c), h;
  for (u = 0; u < c; ++u)
    (l = e[u]) && (d[u] = h = i.call(l, l.__data__, u, e) + "", a.has(h) ? o[u] = l : a.set(h, l));
  for (u = 0; u < p; ++u)
    h = i.call(t, s[u], u, s) + "", (l = a.get(h)) ? (r[u] = l, l.__data__ = s[u], a.delete(h)) : n[u] = new Ev(t, s[u]);
  for (u = 0; u < c; ++u)
    (l = e[u]) && a.get(d[u]) === l && (o[u] = l);
}
function DAe(t) {
  return t.__data__;
}
function EAe(t, e) {
  if (!arguments.length) return Array.from(this, DAe);
  var n = e ? AAe : RAe, r = this._parents, o = this._groups;
  typeof t != "function" && (t = SAe(t));
  for (var s = o.length, i = new Array(s), u = new Array(s), l = new Array(s), a = 0; a < s; ++a) {
    var c = r[a], p = o[a], d = p.length, h = MAe(t.call(c, c && c.__data__, a, r)), m = h.length, g = u[a] = new Array(m), _ = i[a] = new Array(m), b = l[a] = new Array(d);
    n(c, p, g, _, b, h, e);
    for (var x = 0, S = 0, E, A; x < m; ++x)
      if (E = g[x]) {
        for (x >= S && (S = x + 1); !(A = _[S]) && ++S < m; ) ;
        E._next = A || null;
      }
  }
  return i = new _i(i, r), i._enter = u, i._exit = l, i;
}
function MAe(t) {
  return typeof t == "object" && "length" in t ? t : Array.from(t);
}
function PAe() {
  return new _i(this._exit || this._groups.map(z5), this._parents);
}
function CAe(t, e, n) {
  var r = this.enter(), o = this, s = this.exit();
  return typeof t == "function" ? (r = t(r), r && (r = r.selection())) : r = r.append(t + ""), e != null && (o = e(o), o && (o = o.selection())), n == null ? s.remove() : n(s), r && o ? r.merge(o).order() : o;
}
function OAe(t) {
  for (var e = t.selection ? t.selection() : t, n = this._groups, r = e._groups, o = n.length, s = r.length, i = Math.min(o, s), u = new Array(o), l = 0; l < i; ++l)
    for (var a = n[l], c = r[l], p = a.length, d = u[l] = new Array(p), h, m = 0; m < p; ++m)
      (h = a[m] || c[m]) && (d[m] = h);
  for (; l < o; ++l)
    u[l] = n[l];
  return new _i(u, this._parents);
}
function IAe() {
  for (var t = this._groups, e = -1, n = t.length; ++e < n; )
    for (var r = t[e], o = r.length - 1, s = r[o], i; --o >= 0; )
      (i = r[o]) && (s && i.compareDocumentPosition(s) ^ 4 && s.parentNode.insertBefore(i, s), s = i);
  return this;
}
function FAe(t) {
  t || (t = NAe);
  function e(p, d) {
    return p && d ? t(p.__data__, d.__data__) : !p - !d;
  }
  for (var n = this._groups, r = n.length, o = new Array(r), s = 0; s < r; ++s) {
    for (var i = n[s], u = i.length, l = o[s] = new Array(u), a, c = 0; c < u; ++c)
      (a = i[c]) && (l[c] = a);
    l.sort(e);
  }
  return new _i(o, this._parents).order();
}
function NAe(t, e) {
  return t < e ? -1 : t > e ? 1 : t >= e ? 0 : NaN;
}
function LAe() {
  var t = arguments[0];
  return arguments[0] = this, t.apply(null, arguments), this;
}
function BAe() {
  return Array.from(this);
}
function UAe() {
  for (var t = this._groups, e = 0, n = t.length; e < n; ++e)
    for (var r = t[e], o = 0, s = r.length; o < s; ++o) {
      var i = r[o];
      if (i) return i;
    }
  return null;
}
function XAe() {
  let t = 0;
  for (const e of this) ++t;
  return t;
}
function $Ae() {
  return !this.node();
}
function WAe(t) {
  for (var e = this._groups, n = 0, r = e.length; n < r; ++n)
    for (var o = e[n], s = 0, i = o.length, u; s < i; ++s)
      (u = o[s]) && t.call(u, u.__data__, s, o);
  return this;
}
function VAe(t) {
  return function() {
    this.removeAttribute(t);
  };
}
function HAe(t) {
  return function() {
    this.removeAttributeNS(t.space, t.local);
  };
}
function jAe(t, e) {
  return function() {
    this.setAttribute(t, e);
  };
}
function zAe(t, e) {
  return function() {
    this.setAttributeNS(t.space, t.local, e);
  };
}
function qAe(t, e) {
  return function() {
    var n = e.apply(this, arguments);
    n == null ? this.removeAttribute(t) : this.setAttribute(t, n);
  };
}
function GAe(t, e) {
  return function() {
    var n = e.apply(this, arguments);
    n == null ? this.removeAttributeNS(t.space, t.local) : this.setAttributeNS(t.space, t.local, n);
  };
}
function YAe(t, e) {
  var n = tw(t);
  if (arguments.length < 2) {
    var r = this.node();
    return n.local ? r.getAttributeNS(n.space, n.local) : r.getAttribute(n);
  }
  return this.each((e == null ? n.local ? HAe : VAe : typeof e == "function" ? n.local ? GAe : qAe : n.local ? zAe : jAe)(n, e));
}
function q5(t) {
  return t.ownerDocument && t.ownerDocument.defaultView || t.document && t || t.defaultView;
}
function QAe(t) {
  return function() {
    this.style.removeProperty(t);
  };
}
function KAe(t, e, n) {
  return function() {
    this.style.setProperty(t, e, n);
  };
}
function ZAe(t, e, n) {
  return function() {
    var r = e.apply(this, arguments);
    r == null ? this.style.removeProperty(t) : this.style.setProperty(t, r, n);
  };
}
function JAe(t, e, n) {
  return arguments.length > 1 ? this.each((e == null ? QAe : typeof e == "function" ? ZAe : KAe)(t, e, n ?? "")) : xh(this.node(), t);
}
function xh(t, e) {
  return t.style.getPropertyValue(e) || q5(t).getComputedStyle(t, null).getPropertyValue(e);
}
function eDe(t) {
  return function() {
    delete this[t];
  };
}
function tDe(t, e) {
  return function() {
    this[t] = e;
  };
}
function nDe(t, e) {
  return function() {
    var n = e.apply(this, arguments);
    n == null ? delete this[t] : this[t] = n;
  };
}
function rDe(t, e) {
  return arguments.length > 1 ? this.each((e == null ? eDe : typeof e == "function" ? nDe : tDe)(t, e)) : this.node()[t];
}
function G5(t) {
  return t.trim().split(/^|\s+/);
}
function nR(t) {
  return t.classList || new Y5(t);
}
function Y5(t) {
  this._node = t, this._names = G5(t.getAttribute("class") || "");
}
Y5.prototype = {
  add: function(t) {
    var e = this._names.indexOf(t);
    e < 0 && (this._names.push(t), this._node.setAttribute("class", this._names.join(" ")));
  },
  remove: function(t) {
    var e = this._names.indexOf(t);
    e >= 0 && (this._names.splice(e, 1), this._node.setAttribute("class", this._names.join(" ")));
  },
  contains: function(t) {
    return this._names.indexOf(t) >= 0;
  }
};
function Q5(t, e) {
  for (var n = nR(t), r = -1, o = e.length; ++r < o; ) n.add(e[r]);
}
function K5(t, e) {
  for (var n = nR(t), r = -1, o = e.length; ++r < o; ) n.remove(e[r]);
}
function oDe(t) {
  return function() {
    Q5(this, t);
  };
}
function sDe(t) {
  return function() {
    K5(this, t);
  };
}
function aDe(t, e) {
  return function() {
    (e.apply(this, arguments) ? Q5 : K5)(this, t);
  };
}
function iDe(t, e) {
  var n = G5(t + "");
  if (arguments.length < 2) {
    for (var r = nR(this.node()), o = -1, s = n.length; ++o < s; ) if (!r.contains(n[o])) return !1;
    return !0;
  }
  return this.each((typeof e == "function" ? aDe : e ? oDe : sDe)(n, e));
}
function uDe() {
  this.textContent = "";
}
function lDe(t) {
  return function() {
    this.textContent = t;
  };
}
function cDe(t) {
  return function() {
    var e = t.apply(this, arguments);
    this.textContent = e ?? "";
  };
}
function pDe(t) {
  return arguments.length ? this.each(t == null ? uDe : (typeof t == "function" ? cDe : lDe)(t)) : this.node().textContent;
}
function dDe() {
  this.innerHTML = "";
}
function hDe(t) {
  return function() {
    this.innerHTML = t;
  };
}
function fDe(t) {
  return function() {
    var e = t.apply(this, arguments);
    this.innerHTML = e ?? "";
  };
}
function mDe(t) {
  return arguments.length ? this.each(t == null ? dDe : (typeof t == "function" ? fDe : hDe)(t)) : this.node().innerHTML;
}
function yDe() {
  this.nextSibling && this.parentNode.appendChild(this);
}
function gDe() {
  return this.each(yDe);
}
function vDe() {
  this.previousSibling && this.parentNode.insertBefore(this, this.parentNode.firstChild);
}
function _De() {
  return this.each(vDe);
}
function wDe(t) {
  var e = typeof t == "function" ? t : W5(t);
  return this.select(function() {
    return this.appendChild(e.apply(this, arguments));
  });
}
function bDe() {
  return null;
}
function kDe(t, e) {
  var n = typeof t == "function" ? t : W5(t), r = e == null ? bDe : typeof e == "function" ? e : tR(e);
  return this.select(function() {
    return this.insertBefore(n.apply(this, arguments), r.apply(this, arguments) || null);
  });
}
function TDe() {
  var t = this.parentNode;
  t && t.removeChild(this);
}
function xDe() {
  return this.each(TDe);
}
function SDe() {
  var t = this.cloneNode(!1), e = this.parentNode;
  return e ? e.insertBefore(t, this.nextSibling) : t;
}
function RDe() {
  var t = this.cloneNode(!0), e = this.parentNode;
  return e ? e.insertBefore(t, this.nextSibling) : t;
}
function ADe(t) {
  return this.select(t ? RDe : SDe);
}
function DDe(t) {
  return arguments.length ? this.property("__data__", t) : this.node().__data__;
}
function EDe(t) {
  return function(e) {
    t.call(this, e, this.__data__);
  };
}
function MDe(t) {
  return t.trim().split(/^|\s+/).map(function(e) {
    var n = "", r = e.indexOf(".");
    return r >= 0 && (n = e.slice(r + 1), e = e.slice(0, r)), { type: e, name: n };
  });
}
function PDe(t) {
  return function() {
    var e = this.__on;
    if (e) {
      for (var n = 0, r = -1, o = e.length, s; n < o; ++n)
        s = e[n], (!t.type || s.type === t.type) && s.name === t.name ? this.removeEventListener(s.type, s.listener, s.options) : e[++r] = s;
      ++r ? e.length = r : delete this.__on;
    }
  };
}
function CDe(t, e, n) {
  return function() {
    var r = this.__on, o, s = EDe(e);
    if (r) {
      for (var i = 0, u = r.length; i < u; ++i)
        if ((o = r[i]).type === t.type && o.name === t.name) {
          this.removeEventListener(o.type, o.listener, o.options), this.addEventListener(o.type, o.listener = s, o.options = n), o.value = e;
          return;
        }
    }
    this.addEventListener(t.type, s, n), o = { type: t.type, name: t.name, value: e, listener: s, options: n }, r ? r.push(o) : this.__on = [o];
  };
}
function ODe(t, e, n) {
  var r = MDe(t + ""), o, s = r.length, i;
  if (arguments.length < 2) {
    var u = this.node().__on;
    if (u) {
      for (var l = 0, a = u.length, c; l < a; ++l)
        for (o = 0, c = u[l]; o < s; ++o)
          if ((i = r[o]).type === c.type && i.name === c.name)
            return c.value;
    }
    return;
  }
  for (u = e ? CDe : PDe, o = 0; o < s; ++o) this.each(u(r[o], e, n));
  return this;
}
function Z5(t, e, n) {
  var r = q5(t), o = r.CustomEvent;
  typeof o == "function" ? o = new o(e, n) : (o = r.document.createEvent("Event"), n ? (o.initEvent(e, n.bubbles, n.cancelable), o.detail = n.detail) : o.initEvent(e, !1, !1)), t.dispatchEvent(o);
}
function IDe(t, e) {
  return function() {
    return Z5(this, t, e);
  };
}
function FDe(t, e) {
  return function() {
    return Z5(this, t, e.apply(this, arguments));
  };
}
function NDe(t, e) {
  return this.each((typeof e == "function" ? FDe : IDe)(t, e));
}
function* LDe() {
  for (var t = this._groups, e = 0, n = t.length; e < n; ++e)
    for (var r = t[e], o = 0, s = r.length, i; o < s; ++o)
      (i = r[o]) && (yield i);
}
var BDe = [null];
function _i(t, e) {
  this._groups = t, this._parents = e;
}
function hy() {
  return new _i([[document.documentElement]], BDe);
}
function UDe() {
  return this;
}
_i.prototype = hy.prototype = {
  constructor: _i,
  select: cAe,
  selectAll: fAe,
  selectChild: vAe,
  selectChildren: kAe,
  filter: TAe,
  data: EAe,
  enter: xAe,
  exit: PAe,
  join: CAe,
  merge: OAe,
  selection: UDe,
  order: IAe,
  sort: FAe,
  call: LAe,
  nodes: BAe,
  node: UAe,
  size: XAe,
  empty: $Ae,
  each: WAe,
  attr: YAe,
  style: JAe,
  property: rDe,
  classed: iDe,
  text: pDe,
  html: mDe,
  raise: gDe,
  lower: _De,
  append: wDe,
  insert: kDe,
  remove: xDe,
  clone: ADe,
  datum: DDe,
  on: ODe,
  dispatch: NDe,
  [Symbol.iterator]: LDe
};
function rR(t, e, n) {
  t.prototype = e.prototype = n, n.constructor = t;
}
function J5(t, e) {
  var n = Object.create(t.prototype);
  for (var r in e) n[r] = e[r];
  return n;
}
function fy() {
}
var xm = 0.7, Mv = 1 / xm, th = "\\s*([+-]?\\d+)\\s*", Sm = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)\\s*", lu = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)%\\s*", XDe = /^#([0-9a-f]{3,8})$/, $De = new RegExp(`^rgb\\(${th},${th},${th}\\)$`), WDe = new RegExp(`^rgb\\(${lu},${lu},${lu}\\)$`), VDe = new RegExp(`^rgba\\(${th},${th},${th},${Sm}\\)$`), HDe = new RegExp(`^rgba\\(${lu},${lu},${lu},${Sm}\\)$`), jDe = new RegExp(`^hsl\\(${Sm},${lu},${lu}\\)$`), zDe = new RegExp(`^hsla\\(${Sm},${lu},${lu},${Sm}\\)$`), LO = {
  aliceblue: 15792383,
  antiquewhite: 16444375,
  aqua: 65535,
  aquamarine: 8388564,
  azure: 15794175,
  beige: 16119260,
  bisque: 16770244,
  black: 0,
  blanchedalmond: 16772045,
  blue: 255,
  blueviolet: 9055202,
  brown: 10824234,
  burlywood: 14596231,
  cadetblue: 6266528,
  chartreuse: 8388352,
  chocolate: 13789470,
  coral: 16744272,
  cornflowerblue: 6591981,
  cornsilk: 16775388,
  crimson: 14423100,
  cyan: 65535,
  darkblue: 139,
  darkcyan: 35723,
  darkgoldenrod: 12092939,
  darkgray: 11119017,
  darkgreen: 25600,
  darkgrey: 11119017,
  darkkhaki: 12433259,
  darkmagenta: 9109643,
  darkolivegreen: 5597999,
  darkorange: 16747520,
  darkorchid: 10040012,
  darkred: 9109504,
  darksalmon: 15308410,
  darkseagreen: 9419919,
  darkslateblue: 4734347,
  darkslategray: 3100495,
  darkslategrey: 3100495,
  darkturquoise: 52945,
  darkviolet: 9699539,
  deeppink: 16716947,
  deepskyblue: 49151,
  dimgray: 6908265,
  dimgrey: 6908265,
  dodgerblue: 2003199,
  firebrick: 11674146,
  floralwhite: 16775920,
  forestgreen: 2263842,
  fuchsia: 16711935,
  gainsboro: 14474460,
  ghostwhite: 16316671,
  gold: 16766720,
  goldenrod: 14329120,
  gray: 8421504,
  green: 32768,
  greenyellow: 11403055,
  grey: 8421504,
  honeydew: 15794160,
  hotpink: 16738740,
  indianred: 13458524,
  indigo: 4915330,
  ivory: 16777200,
  khaki: 15787660,
  lavender: 15132410,
  lavenderblush: 16773365,
  lawngreen: 8190976,
  lemonchiffon: 16775885,
  lightblue: 11393254,
  lightcoral: 15761536,
  lightcyan: 14745599,
  lightgoldenrodyellow: 16448210,
  lightgray: 13882323,
  lightgreen: 9498256,
  lightgrey: 13882323,
  lightpink: 16758465,
  lightsalmon: 16752762,
  lightseagreen: 2142890,
  lightskyblue: 8900346,
  lightslategray: 7833753,
  lightslategrey: 7833753,
  lightsteelblue: 11584734,
  lightyellow: 16777184,
  lime: 65280,
  limegreen: 3329330,
  linen: 16445670,
  magenta: 16711935,
  maroon: 8388608,
  mediumaquamarine: 6737322,
  mediumblue: 205,
  mediumorchid: 12211667,
  mediumpurple: 9662683,
  mediumseagreen: 3978097,
  mediumslateblue: 8087790,
  mediumspringgreen: 64154,
  mediumturquoise: 4772300,
  mediumvioletred: 13047173,
  midnightblue: 1644912,
  mintcream: 16121850,
  mistyrose: 16770273,
  moccasin: 16770229,
  navajowhite: 16768685,
  navy: 128,
  oldlace: 16643558,
  olive: 8421376,
  olivedrab: 7048739,
  orange: 16753920,
  orangered: 16729344,
  orchid: 14315734,
  palegoldenrod: 15657130,
  palegreen: 10025880,
  paleturquoise: 11529966,
  palevioletred: 14381203,
  papayawhip: 16773077,
  peachpuff: 16767673,
  peru: 13468991,
  pink: 16761035,
  plum: 14524637,
  powderblue: 11591910,
  purple: 8388736,
  rebeccapurple: 6697881,
  red: 16711680,
  rosybrown: 12357519,
  royalblue: 4286945,
  saddlebrown: 9127187,
  salmon: 16416882,
  sandybrown: 16032864,
  seagreen: 3050327,
  seashell: 16774638,
  sienna: 10506797,
  silver: 12632256,
  skyblue: 8900331,
  slateblue: 6970061,
  slategray: 7372944,
  slategrey: 7372944,
  snow: 16775930,
  springgreen: 65407,
  steelblue: 4620980,
  tan: 13808780,
  teal: 32896,
  thistle: 14204888,
  tomato: 16737095,
  turquoise: 4251856,
  violet: 15631086,
  wheat: 16113331,
  white: 16777215,
  whitesmoke: 16119285,
  yellow: 16776960,
  yellowgreen: 10145074
};
rR(fy, Vp, {
  copy(t) {
    return Object.assign(new this.constructor(), this, t);
  },
  displayable() {
    return this.rgb().displayable();
  },
  hex: BO,
  // Deprecated! Use color.formatHex.
  formatHex: BO,
  formatHex8: qDe,
  formatHsl: GDe,
  formatRgb: UO,
  toString: UO
});
function BO() {
  return this.rgb().formatHex();
}
function qDe() {
  return this.rgb().formatHex8();
}
function GDe() {
  return eU(this).formatHsl();
}
function UO() {
  return this.rgb().formatRgb();
}
function Vp(t) {
  var e, n;
  return t = (t + "").trim().toLowerCase(), (e = XDe.exec(t)) ? (n = e[1].length, e = parseInt(e[1], 16), n === 6 ? XO(e) : n === 3 ? new vs(e >> 8 & 15 | e >> 4 & 240, e >> 4 & 15 | e & 240, (e & 15) << 4 | e & 15, 1) : n === 8 ? Fg(e >> 24 & 255, e >> 16 & 255, e >> 8 & 255, (e & 255) / 255) : n === 4 ? Fg(e >> 12 & 15 | e >> 8 & 240, e >> 8 & 15 | e >> 4 & 240, e >> 4 & 15 | e & 240, ((e & 15) << 4 | e & 15) / 255) : null) : (e = $De.exec(t)) ? new vs(e[1], e[2], e[3], 1) : (e = WDe.exec(t)) ? new vs(e[1] * 255 / 100, e[2] * 255 / 100, e[3] * 255 / 100, 1) : (e = VDe.exec(t)) ? Fg(e[1], e[2], e[3], e[4]) : (e = HDe.exec(t)) ? Fg(e[1] * 255 / 100, e[2] * 255 / 100, e[3] * 255 / 100, e[4]) : (e = jDe.exec(t)) ? VO(e[1], e[2] / 100, e[3] / 100, 1) : (e = zDe.exec(t)) ? VO(e[1], e[2] / 100, e[3] / 100, e[4]) : LO.hasOwnProperty(t) ? XO(LO[t]) : t === "transparent" ? new vs(NaN, NaN, NaN, 0) : null;
}
function XO(t) {
  return new vs(t >> 16 & 255, t >> 8 & 255, t & 255, 1);
}
function Fg(t, e, n, r) {
  return r <= 0 && (t = e = n = NaN), new vs(t, e, n, r);
}
function YDe(t) {
  return t instanceof fy || (t = Vp(t)), t ? (t = t.rgb(), new vs(t.r, t.g, t.b, t.opacity)) : new vs();
}
function tx(t, e, n, r) {
  return arguments.length === 1 ? YDe(t) : new vs(t, e, n, r ?? 1);
}
function vs(t, e, n, r) {
  this.r = +t, this.g = +e, this.b = +n, this.opacity = +r;
}
rR(vs, tx, J5(fy, {
  brighter(t) {
    return t = t == null ? Mv : Math.pow(Mv, t), new vs(this.r * t, this.g * t, this.b * t, this.opacity);
  },
  darker(t) {
    return t = t == null ? xm : Math.pow(xm, t), new vs(this.r * t, this.g * t, this.b * t, this.opacity);
  },
  rgb() {
    return this;
  },
  clamp() {
    return new vs(Mp(this.r), Mp(this.g), Mp(this.b), Pv(this.opacity));
  },
  displayable() {
    return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
  },
  hex: $O,
  // Deprecated! Use color.formatHex.
  formatHex: $O,
  formatHex8: QDe,
  formatRgb: WO,
  toString: WO
}));
function $O() {
  return `#${yp(this.r)}${yp(this.g)}${yp(this.b)}`;
}
function QDe() {
  return `#${yp(this.r)}${yp(this.g)}${yp(this.b)}${yp((isNaN(this.opacity) ? 1 : this.opacity) * 255)}`;
}
function WO() {
  const t = Pv(this.opacity);
  return `${t === 1 ? "rgb(" : "rgba("}${Mp(this.r)}, ${Mp(this.g)}, ${Mp(this.b)}${t === 1 ? ")" : `, ${t})`}`;
}
function Pv(t) {
  return isNaN(t) ? 1 : Math.max(0, Math.min(1, t));
}
function Mp(t) {
  return Math.max(0, Math.min(255, Math.round(t) || 0));
}
function yp(t) {
  return t = Mp(t), (t < 16 ? "0" : "") + t.toString(16);
}
function VO(t, e, n, r) {
  return r <= 0 ? t = e = n = NaN : n <= 0 || n >= 1 ? t = e = NaN : e <= 0 && (t = NaN), new li(t, e, n, r);
}
function eU(t) {
  if (t instanceof li) return new li(t.h, t.s, t.l, t.opacity);
  if (t instanceof fy || (t = Vp(t)), !t) return new li();
  if (t instanceof li) return t;
  t = t.rgb();
  var e = t.r / 255, n = t.g / 255, r = t.b / 255, o = Math.min(e, n, r), s = Math.max(e, n, r), i = NaN, u = s - o, l = (s + o) / 2;
  return u ? (e === s ? i = (n - r) / u + (n < r) * 6 : n === s ? i = (r - e) / u + 2 : i = (e - n) / u + 4, u /= l < 0.5 ? s + o : 2 - s - o, i *= 60) : u = l > 0 && l < 1 ? 0 : i, new li(i, u, l, t.opacity);
}
function KDe(t, e, n, r) {
  return arguments.length === 1 ? eU(t) : new li(t, e, n, r ?? 1);
}
function li(t, e, n, r) {
  this.h = +t, this.s = +e, this.l = +n, this.opacity = +r;
}
rR(li, KDe, J5(fy, {
  brighter(t) {
    return t = t == null ? Mv : Math.pow(Mv, t), new li(this.h, this.s, this.l * t, this.opacity);
  },
  darker(t) {
    return t = t == null ? xm : Math.pow(xm, t), new li(this.h, this.s, this.l * t, this.opacity);
  },
  rgb() {
    var t = this.h % 360 + (this.h < 0) * 360, e = isNaN(t) || isNaN(this.s) ? 0 : this.s, n = this.l, r = n + (n < 0.5 ? n : 1 - n) * e, o = 2 * n - r;
    return new vs(
      zb(t >= 240 ? t - 240 : t + 120, o, r),
      zb(t, o, r),
      zb(t < 120 ? t + 240 : t - 120, o, r),
      this.opacity
    );
  },
  clamp() {
    return new li(HO(this.h), Ng(this.s), Ng(this.l), Pv(this.opacity));
  },
  displayable() {
    return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
  },
  formatHsl() {
    const t = Pv(this.opacity);
    return `${t === 1 ? "hsl(" : "hsla("}${HO(this.h)}, ${Ng(this.s) * 100}%, ${Ng(this.l) * 100}%${t === 1 ? ")" : `, ${t})`}`;
  }
}));
function HO(t) {
  return t = (t || 0) % 360, t < 0 ? t + 360 : t;
}
function Ng(t) {
  return Math.max(0, Math.min(1, t || 0));
}
function zb(t, e, n) {
  return (t < 60 ? e + (n - e) * t / 60 : t < 180 ? n : t < 240 ? e + (n - e) * (240 - t) / 60 : e) * 255;
}
const oR = (t) => () => t;
function ZDe(t, e) {
  return function(n) {
    return t + n * e;
  };
}
function JDe(t, e, n) {
  return t = Math.pow(t, n), e = Math.pow(e, n) - t, n = 1 / n, function(r) {
    return Math.pow(t + r * e, n);
  };
}
function eEe(t) {
  return (t = +t) == 1 ? tU : function(e, n) {
    return n - e ? JDe(e, n, t) : oR(isNaN(e) ? n : e);
  };
}
function tU(t, e) {
  var n = e - t;
  return n ? ZDe(t, n) : oR(isNaN(t) ? e : t);
}
const Cv = function t(e) {
  var n = eEe(e);
  function r(o, s) {
    var i = n((o = tx(o)).r, (s = tx(s)).r), u = n(o.g, s.g), l = n(o.b, s.b), a = tU(o.opacity, s.opacity);
    return function(c) {
      return o.r = i(c), o.g = u(c), o.b = l(c), o.opacity = a(c), o + "";
    };
  }
  return r.gamma = t, r;
}(1);
function tEe(t, e) {
  e || (e = []);
  var n = t ? Math.min(e.length, t.length) : 0, r = e.slice(), o;
  return function(s) {
    for (o = 0; o < n; ++o) r[o] = t[o] * (1 - s) + e[o] * s;
    return r;
  };
}
function nEe(t) {
  return ArrayBuffer.isView(t) && !(t instanceof DataView);
}
function rEe(t, e) {
  var n = e ? e.length : 0, r = t ? Math.min(n, t.length) : 0, o = new Array(r), s = new Array(n), i;
  for (i = 0; i < r; ++i) o[i] = sR(t[i], e[i]);
  for (; i < n; ++i) s[i] = e[i];
  return function(u) {
    for (i = 0; i < r; ++i) s[i] = o[i](u);
    return s;
  };
}
function oEe(t, e) {
  var n = /* @__PURE__ */ new Date();
  return t = +t, e = +e, function(r) {
    return n.setTime(t * (1 - r) + e * r), n;
  };
}
function ai(t, e) {
  return t = +t, e = +e, function(n) {
    return t * (1 - n) + e * n;
  };
}
function sEe(t, e) {
  var n = {}, r = {}, o;
  (t === null || typeof t != "object") && (t = {}), (e === null || typeof e != "object") && (e = {});
  for (o in e)
    o in t ? n[o] = sR(t[o], e[o]) : r[o] = e[o];
  return function(s) {
    for (o in n) r[o] = n[o](s);
    return r;
  };
}
var nx = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, qb = new RegExp(nx.source, "g");
function aEe(t) {
  return function() {
    return t;
  };
}
function iEe(t) {
  return function(e) {
    return t(e) + "";
  };
}
function nU(t, e) {
  var n = nx.lastIndex = qb.lastIndex = 0, r, o, s, i = -1, u = [], l = [];
  for (t = t + "", e = e + ""; (r = nx.exec(t)) && (o = qb.exec(e)); )
    (s = o.index) > n && (s = e.slice(n, s), u[i] ? u[i] += s : u[++i] = s), (r = r[0]) === (o = o[0]) ? u[i] ? u[i] += o : u[++i] = o : (u[++i] = null, l.push({ i, x: ai(r, o) })), n = qb.lastIndex;
  return n < e.length && (s = e.slice(n), u[i] ? u[i] += s : u[++i] = s), u.length < 2 ? l[0] ? iEe(l[0].x) : aEe(e) : (e = l.length, function(a) {
    for (var c = 0, p; c < e; ++c) u[(p = l[c]).i] = p.x(a);
    return u.join("");
  });
}
function sR(t, e) {
  var n = typeof e, r;
  return e == null || n === "boolean" ? oR(e) : (n === "number" ? ai : n === "string" ? (r = Vp(e)) ? (e = r, Cv) : nU : e instanceof Vp ? Cv : e instanceof Date ? oEe : nEe(e) ? tEe : Array.isArray(e) ? rEe : typeof e.valueOf != "function" && typeof e.toString != "function" || isNaN(e) ? sEe : ai)(t, e);
}
function uEe(t, e) {
  return t = +t, e = +e, function(n) {
    return Math.round(t * (1 - n) + e * n);
  };
}
var jO = 180 / Math.PI, rU = {
  translateX: 0,
  translateY: 0,
  rotate: 0,
  skewX: 0,
  scaleX: 1,
  scaleY: 1
};
function oU(t, e, n, r, o, s) {
  var i, u, l;
  return (i = Math.sqrt(t * t + e * e)) && (t /= i, e /= i), (l = t * n + e * r) && (n -= t * l, r -= e * l), (u = Math.sqrt(n * n + r * r)) && (n /= u, r /= u, l /= u), t * r < e * n && (t = -t, e = -e, l = -l, i = -i), {
    translateX: o,
    translateY: s,
    rotate: Math.atan2(e, t) * jO,
    skewX: Math.atan(l) * jO,
    scaleX: i,
    scaleY: u
  };
}
var Lg;
function lEe(t) {
  const e = new (typeof DOMMatrix == "function" ? DOMMatrix : WebKitCSSMatrix)(t + "");
  return e.isIdentity ? rU : oU(e.a, e.b, e.c, e.d, e.e, e.f);
}
function cEe(t) {
  return t == null || (Lg || (Lg = document.createElementNS("http://www.w3.org/2000/svg", "g")), Lg.setAttribute("transform", t), !(t = Lg.transform.baseVal.consolidate())) ? rU : (t = t.matrix, oU(t.a, t.b, t.c, t.d, t.e, t.f));
}
function sU(t, e, n, r) {
  function o(a) {
    return a.length ? a.pop() + " " : "";
  }
  function s(a, c, p, d, h, m) {
    if (a !== p || c !== d) {
      var g = h.push("translate(", null, e, null, n);
      m.push({ i: g - 4, x: ai(a, p) }, { i: g - 2, x: ai(c, d) });
    } else (p || d) && h.push("translate(" + p + e + d + n);
  }
  function i(a, c, p, d) {
    a !== c ? (a - c > 180 ? c += 360 : c - a > 180 && (a += 360), d.push({ i: p.push(o(p) + "rotate(", null, r) - 2, x: ai(a, c) })) : c && p.push(o(p) + "rotate(" + c + r);
  }
  function u(a, c, p, d) {
    a !== c ? d.push({ i: p.push(o(p) + "skewX(", null, r) - 2, x: ai(a, c) }) : c && p.push(o(p) + "skewX(" + c + r);
  }
  function l(a, c, p, d, h, m) {
    if (a !== p || c !== d) {
      var g = h.push(o(h) + "scale(", null, ",", null, ")");
      m.push({ i: g - 4, x: ai(a, p) }, { i: g - 2, x: ai(c, d) });
    } else (p !== 1 || d !== 1) && h.push(o(h) + "scale(" + p + "," + d + ")");
  }
  return function(a, c) {
    var p = [], d = [];
    return a = t(a), c = t(c), s(a.translateX, a.translateY, c.translateX, c.translateY, p, d), i(a.rotate, c.rotate, p, d), u(a.skewX, c.skewX, p, d), l(a.scaleX, a.scaleY, c.scaleX, c.scaleY, p, d), a = c = null, function(h) {
      for (var m = -1, g = d.length, _; ++m < g; ) p[(_ = d[m]).i] = _.x(h);
      return p.join("");
    };
  };
}
var pEe = sU(lEe, "px, ", "px)", "deg)"), dEe = sU(cEe, ", ", ")", ")"), Sh = 0, qf = 0, xf = 0, aU = 1e3, Ov, Gf, Iv = 0, Hp = 0, nw = 0, Rm = typeof performance == "object" && performance.now ? performance : Date, iU = typeof window == "object" && window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function(t) {
  setTimeout(t, 17);
};
function aR() {
  return Hp || (iU(hEe), Hp = Rm.now() + nw);
}
function hEe() {
  Hp = 0;
}
function Fv() {
  this._call = this._time = this._next = null;
}
Fv.prototype = uU.prototype = {
  constructor: Fv,
  restart: function(t, e, n) {
    if (typeof t != "function") throw new TypeError("callback is not a function");
    n = (n == null ? aR() : +n) + (e == null ? 0 : +e), !this._next && Gf !== this && (Gf ? Gf._next = this : Ov = this, Gf = this), this._call = t, this._time = n, rx();
  },
  stop: function() {
    this._call && (this._call = null, this._time = 1 / 0, rx());
  }
};
function uU(t, e, n) {
  var r = new Fv();
  return r.restart(t, e, n), r;
}
function fEe() {
  aR(), ++Sh;
  for (var t = Ov, e; t; )
    (e = Hp - t._time) >= 0 && t._call.call(void 0, e), t = t._next;
  --Sh;
}
function zO() {
  Hp = (Iv = Rm.now()) + nw, Sh = qf = 0;
  try {
    fEe();
  } finally {
    Sh = 0, yEe(), Hp = 0;
  }
}
function mEe() {
  var t = Rm.now(), e = t - Iv;
  e > aU && (nw -= e, Iv = t);
}
function yEe() {
  for (var t, e = Ov, n, r = 1 / 0; e; )
    e._call ? (r > e._time && (r = e._time), t = e, e = e._next) : (n = e._next, e._next = null, e = t ? t._next = n : Ov = n);
  Gf = t, rx(r);
}
function rx(t) {
  if (!Sh) {
    qf && (qf = clearTimeout(qf));
    var e = t - Hp;
    e > 24 ? (t < 1 / 0 && (qf = setTimeout(zO, t - Rm.now() - nw)), xf && (xf = clearInterval(xf))) : (xf || (Iv = Rm.now(), xf = setInterval(mEe, aU)), Sh = 1, iU(zO));
  }
}
function qO(t, e, n) {
  var r = new Fv();
  return e = e == null ? 0 : +e, r.restart((o) => {
    r.stop(), t(o + e);
  }, e, n), r;
}
var gEe = $5("start", "end", "cancel", "interrupt"), vEe = [], lU = 0, GO = 1, ox = 2, v0 = 3, YO = 4, sx = 5, _0 = 6;
function rw(t, e, n, r, o, s) {
  var i = t.__transition;
  if (!i) t.__transition = {};
  else if (n in i) return;
  _Ee(t, n, {
    name: e,
    index: r,
    // For context during callback.
    group: o,
    // For context during callback.
    on: gEe,
    tween: vEe,
    time: s.time,
    delay: s.delay,
    duration: s.duration,
    ease: s.ease,
    timer: null,
    state: lU
  });
}
function iR(t, e) {
  var n = Ri(t, e);
  if (n.state > lU) throw new Error("too late; already scheduled");
  return n;
}
function bu(t, e) {
  var n = Ri(t, e);
  if (n.state > v0) throw new Error("too late; already running");
  return n;
}
function Ri(t, e) {
  var n = t.__transition;
  if (!n || !(n = n[e])) throw new Error("transition not found");
  return n;
}
function _Ee(t, e, n) {
  var r = t.__transition, o;
  r[e] = n, n.timer = uU(s, 0, n.time);
  function s(a) {
    n.state = GO, n.timer.restart(i, n.delay, n.time), n.delay <= a && i(a - n.delay);
  }
  function i(a) {
    var c, p, d, h;
    if (n.state !== GO) return l();
    for (c in r)
      if (h = r[c], h.name === n.name) {
        if (h.state === v0) return qO(i);
        h.state === YO ? (h.state = _0, h.timer.stop(), h.on.call("interrupt", t, t.__data__, h.index, h.group), delete r[c]) : +c < e && (h.state = _0, h.timer.stop(), h.on.call("cancel", t, t.__data__, h.index, h.group), delete r[c]);
      }
    if (qO(function() {
      n.state === v0 && (n.state = YO, n.timer.restart(u, n.delay, n.time), u(a));
    }), n.state = ox, n.on.call("start", t, t.__data__, n.index, n.group), n.state === ox) {
      for (n.state = v0, o = new Array(d = n.tween.length), c = 0, p = -1; c < d; ++c)
        (h = n.tween[c].value.call(t, t.__data__, n.index, n.group)) && (o[++p] = h);
      o.length = p + 1;
    }
  }
  function u(a) {
    for (var c = a < n.duration ? n.ease.call(null, a / n.duration) : (n.timer.restart(l), n.state = sx, 1), p = -1, d = o.length; ++p < d; )
      o[p].call(t, c);
    n.state === sx && (n.on.call("end", t, t.__data__, n.index, n.group), l());
  }
  function l() {
    n.state = _0, n.timer.stop(), delete r[e];
    for (var a in r) return;
    delete t.__transition;
  }
}
function wEe(t, e) {
  var n = t.__transition, r, o, s = !0, i;
  if (n) {
    e = e == null ? null : e + "";
    for (i in n) {
      if ((r = n[i]).name !== e) {
        s = !1;
        continue;
      }
      o = r.state > ox && r.state < sx, r.state = _0, r.timer.stop(), r.on.call(o ? "interrupt" : "cancel", t, t.__data__, r.index, r.group), delete n[i];
    }
    s && delete t.__transition;
  }
}
function bEe(t) {
  return this.each(function() {
    wEe(this, t);
  });
}
function kEe(t, e) {
  var n, r;
  return function() {
    var o = bu(this, t), s = o.tween;
    if (s !== n) {
      r = n = s;
      for (var i = 0, u = r.length; i < u; ++i)
        if (r[i].name === e) {
          r = r.slice(), r.splice(i, 1);
          break;
        }
    }
    o.tween = r;
  };
}
function TEe(t, e, n) {
  var r, o;
  if (typeof n != "function") throw new Error();
  return function() {
    var s = bu(this, t), i = s.tween;
    if (i !== r) {
      o = (r = i).slice();
      for (var u = { name: e, value: n }, l = 0, a = o.length; l < a; ++l)
        if (o[l].name === e) {
          o[l] = u;
          break;
        }
      l === a && o.push(u);
    }
    s.tween = o;
  };
}
function xEe(t, e) {
  var n = this._id;
  if (t += "", arguments.length < 2) {
    for (var r = Ri(this.node(), n).tween, o = 0, s = r.length, i; o < s; ++o)
      if ((i = r[o]).name === t)
        return i.value;
    return null;
  }
  return this.each((e == null ? kEe : TEe)(n, t, e));
}
function uR(t, e, n) {
  var r = t._id;
  return t.each(function() {
    var o = bu(this, r);
    (o.value || (o.value = {}))[e] = n.apply(this, arguments);
  }), function(o) {
    return Ri(o, r).value[e];
  };
}
function cU(t, e) {
  var n;
  return (typeof e == "number" ? ai : e instanceof Vp ? Cv : (n = Vp(e)) ? (e = n, Cv) : nU)(t, e);
}
function SEe(t) {
  return function() {
    this.removeAttribute(t);
  };
}
function REe(t) {
  return function() {
    this.removeAttributeNS(t.space, t.local);
  };
}
function AEe(t, e, n) {
  var r, o = n + "", s;
  return function() {
    var i = this.getAttribute(t);
    return i === o ? null : i === r ? s : s = e(r = i, n);
  };
}
function DEe(t, e, n) {
  var r, o = n + "", s;
  return function() {
    var i = this.getAttributeNS(t.space, t.local);
    return i === o ? null : i === r ? s : s = e(r = i, n);
  };
}
function EEe(t, e, n) {
  var r, o, s;
  return function() {
    var i, u = n(this), l;
    return u == null ? void this.removeAttribute(t) : (i = this.getAttribute(t), l = u + "", i === l ? null : i === r && l === o ? s : (o = l, s = e(r = i, u)));
  };
}
function MEe(t, e, n) {
  var r, o, s;
  return function() {
    var i, u = n(this), l;
    return u == null ? void this.removeAttributeNS(t.space, t.local) : (i = this.getAttributeNS(t.space, t.local), l = u + "", i === l ? null : i === r && l === o ? s : (o = l, s = e(r = i, u)));
  };
}
function PEe(t, e) {
  var n = tw(t), r = n === "transform" ? dEe : cU;
  return this.attrTween(t, typeof e == "function" ? (n.local ? MEe : EEe)(n, r, uR(this, "attr." + t, e)) : e == null ? (n.local ? REe : SEe)(n) : (n.local ? DEe : AEe)(n, r, e));
}
function CEe(t, e) {
  return function(n) {
    this.setAttribute(t, e.call(this, n));
  };
}
function OEe(t, e) {
  return function(n) {
    this.setAttributeNS(t.space, t.local, e.call(this, n));
  };
}
function IEe(t, e) {
  var n, r;
  function o() {
    var s = e.apply(this, arguments);
    return s !== r && (n = (r = s) && OEe(t, s)), n;
  }
  return o._value = e, o;
}
function FEe(t, e) {
  var n, r;
  function o() {
    var s = e.apply(this, arguments);
    return s !== r && (n = (r = s) && CEe(t, s)), n;
  }
  return o._value = e, o;
}
function NEe(t, e) {
  var n = "attr." + t;
  if (arguments.length < 2) return (n = this.tween(n)) && n._value;
  if (e == null) return this.tween(n, null);
  if (typeof e != "function") throw new Error();
  var r = tw(t);
  return this.tween(n, (r.local ? IEe : FEe)(r, e));
}
function LEe(t, e) {
  return function() {
    iR(this, t).delay = +e.apply(this, arguments);
  };
}
function BEe(t, e) {
  return e = +e, function() {
    iR(this, t).delay = e;
  };
}
function UEe(t) {
  var e = this._id;
  return arguments.length ? this.each((typeof t == "function" ? LEe : BEe)(e, t)) : Ri(this.node(), e).delay;
}
function XEe(t, e) {
  return function() {
    bu(this, t).duration = +e.apply(this, arguments);
  };
}
function $Ee(t, e) {
  return e = +e, function() {
    bu(this, t).duration = e;
  };
}
function WEe(t) {
  var e = this._id;
  return arguments.length ? this.each((typeof t == "function" ? XEe : $Ee)(e, t)) : Ri(this.node(), e).duration;
}
function VEe(t, e) {
  if (typeof e != "function") throw new Error();
  return function() {
    bu(this, t).ease = e;
  };
}
function HEe(t) {
  var e = this._id;
  return arguments.length ? this.each(VEe(e, t)) : Ri(this.node(), e).ease;
}
function jEe(t, e) {
  return function() {
    var n = e.apply(this, arguments);
    if (typeof n != "function") throw new Error();
    bu(this, t).ease = n;
  };
}
function zEe(t) {
  if (typeof t != "function") throw new Error();
  return this.each(jEe(this._id, t));
}
function qEe(t) {
  typeof t != "function" && (t = H5(t));
  for (var e = this._groups, n = e.length, r = new Array(n), o = 0; o < n; ++o)
    for (var s = e[o], i = s.length, u = r[o] = [], l, a = 0; a < i; ++a)
      (l = s[a]) && t.call(l, l.__data__, a, s) && u.push(l);
  return new cl(r, this._parents, this._name, this._id);
}
function GEe(t) {
  if (t._id !== this._id) throw new Error();
  for (var e = this._groups, n = t._groups, r = e.length, o = n.length, s = Math.min(r, o), i = new Array(r), u = 0; u < s; ++u)
    for (var l = e[u], a = n[u], c = l.length, p = i[u] = new Array(c), d, h = 0; h < c; ++h)
      (d = l[h] || a[h]) && (p[h] = d);
  for (; u < r; ++u)
    i[u] = e[u];
  return new cl(i, this._parents, this._name, this._id);
}
function YEe(t) {
  return (t + "").trim().split(/^|\s+/).every(function(e) {
    var n = e.indexOf(".");
    return n >= 0 && (e = e.slice(0, n)), !e || e === "start";
  });
}
function QEe(t, e, n) {
  var r, o, s = YEe(e) ? iR : bu;
  return function() {
    var i = s(this, t), u = i.on;
    u !== r && (o = (r = u).copy()).on(e, n), i.on = o;
  };
}
function KEe(t, e) {
  var n = this._id;
  return arguments.length < 2 ? Ri(this.node(), n).on.on(t) : this.each(QEe(n, t, e));
}
function ZEe(t) {
  return function() {
    var e = this.parentNode;
    for (var n in this.__transition) if (+n !== t) return;
    e && e.removeChild(this);
  };
}
function JEe() {
  return this.on("end.remove", ZEe(this._id));
}
function eMe(t) {
  var e = this._name, n = this._id;
  typeof t != "function" && (t = tR(t));
  for (var r = this._groups, o = r.length, s = new Array(o), i = 0; i < o; ++i)
    for (var u = r[i], l = u.length, a = s[i] = new Array(l), c, p, d = 0; d < l; ++d)
      (c = u[d]) && (p = t.call(c, c.__data__, d, u)) && ("__data__" in c && (p.__data__ = c.__data__), a[d] = p, rw(a[d], e, n, d, a, Ri(c, n)));
  return new cl(s, this._parents, e, n);
}
function tMe(t) {
  var e = this._name, n = this._id;
  typeof t != "function" && (t = V5(t));
  for (var r = this._groups, o = r.length, s = [], i = [], u = 0; u < o; ++u)
    for (var l = r[u], a = l.length, c, p = 0; p < a; ++p)
      if (c = l[p]) {
        for (var d = t.call(c, c.__data__, p, l), h, m = Ri(c, n), g = 0, _ = d.length; g < _; ++g)
          (h = d[g]) && rw(h, e, n, g, d, m);
        s.push(d), i.push(c);
      }
  return new cl(s, i, e, n);
}
var nMe = hy.prototype.constructor;
function rMe() {
  return new nMe(this._groups, this._parents);
}
function oMe(t, e) {
  var n, r, o;
  return function() {
    var s = xh(this, t), i = (this.style.removeProperty(t), xh(this, t));
    return s === i ? null : s === n && i === r ? o : o = e(n = s, r = i);
  };
}
function pU(t) {
  return function() {
    this.style.removeProperty(t);
  };
}
function sMe(t, e, n) {
  var r, o = n + "", s;
  return function() {
    var i = xh(this, t);
    return i === o ? null : i === r ? s : s = e(r = i, n);
  };
}
function aMe(t, e, n) {
  var r, o, s;
  return function() {
    var i = xh(this, t), u = n(this), l = u + "";
    return u == null && (l = u = (this.style.removeProperty(t), xh(this, t))), i === l ? null : i === r && l === o ? s : (o = l, s = e(r = i, u));
  };
}
function iMe(t, e) {
  var n, r, o, s = "style." + e, i = "end." + s, u;
  return function() {
    var l = bu(this, t), a = l.on, c = l.value[s] == null ? u || (u = pU(e)) : void 0;
    (a !== n || o !== c) && (r = (n = a).copy()).on(i, o = c), l.on = r;
  };
}
function uMe(t, e, n) {
  var r = (t += "") == "transform" ? pEe : cU;
  return e == null ? this.styleTween(t, oMe(t, r)).on("end.style." + t, pU(t)) : typeof e == "function" ? this.styleTween(t, aMe(t, r, uR(this, "style." + t, e))).each(iMe(this._id, t)) : this.styleTween(t, sMe(t, r, e), n).on("end.style." + t, null);
}
function lMe(t, e, n) {
  return function(r) {
    this.style.setProperty(t, e.call(this, r), n);
  };
}
function cMe(t, e, n) {
  var r, o;
  function s() {
    var i = e.apply(this, arguments);
    return i !== o && (r = (o = i) && lMe(t, i, n)), r;
  }
  return s._value = e, s;
}
function pMe(t, e, n) {
  var r = "style." + (t += "");
  if (arguments.length < 2) return (r = this.tween(r)) && r._value;
  if (e == null) return this.tween(r, null);
  if (typeof e != "function") throw new Error();
  return this.tween(r, cMe(t, e, n ?? ""));
}
function dMe(t) {
  return function() {
    this.textContent = t;
  };
}
function hMe(t) {
  return function() {
    var e = t(this);
    this.textContent = e ?? "";
  };
}
function fMe(t) {
  return this.tween("text", typeof t == "function" ? hMe(uR(this, "text", t)) : dMe(t == null ? "" : t + ""));
}
function mMe(t) {
  return function(e) {
    this.textContent = t.call(this, e);
  };
}
function yMe(t) {
  var e, n;
  function r() {
    var o = t.apply(this, arguments);
    return o !== n && (e = (n = o) && mMe(o)), e;
  }
  return r._value = t, r;
}
function gMe(t) {
  var e = "text";
  if (arguments.length < 1) return (e = this.tween(e)) && e._value;
  if (t == null) return this.tween(e, null);
  if (typeof t != "function") throw new Error();
  return this.tween(e, yMe(t));
}
function vMe() {
  for (var t = this._name, e = this._id, n = dU(), r = this._groups, o = r.length, s = 0; s < o; ++s)
    for (var i = r[s], u = i.length, l, a = 0; a < u; ++a)
      if (l = i[a]) {
        var c = Ri(l, e);
        rw(l, t, n, a, i, {
          time: c.time + c.delay + c.duration,
          delay: 0,
          duration: c.duration,
          ease: c.ease
        });
      }
  return new cl(r, this._parents, t, n);
}
function _Me() {
  var t, e, n = this, r = n._id, o = n.size();
  return new Promise(function(s, i) {
    var u = { value: i }, l = { value: function() {
      --o === 0 && s();
    } };
    n.each(function() {
      var a = bu(this, r), c = a.on;
      c !== t && (e = (t = c).copy(), e._.cancel.push(u), e._.interrupt.push(u), e._.end.push(l)), a.on = e;
    }), o === 0 && s();
  });
}
var wMe = 0;
function cl(t, e, n, r) {
  this._groups = t, this._parents = e, this._name = n, this._id = r;
}
function dU() {
  return ++wMe;
}
var Wu = hy.prototype;
cl.prototype = {
  constructor: cl,
  select: eMe,
  selectAll: tMe,
  selectChild: Wu.selectChild,
  selectChildren: Wu.selectChildren,
  filter: qEe,
  merge: GEe,
  selection: rMe,
  transition: vMe,
  call: Wu.call,
  nodes: Wu.nodes,
  node: Wu.node,
  size: Wu.size,
  empty: Wu.empty,
  each: Wu.each,
  on: KEe,
  attr: PEe,
  attrTween: NEe,
  style: uMe,
  styleTween: pMe,
  text: fMe,
  textTween: gMe,
  remove: JEe,
  tween: xEe,
  delay: UEe,
  duration: WEe,
  ease: HEe,
  easeVarying: zEe,
  end: _Me,
  [Symbol.iterator]: Wu[Symbol.iterator]
};
function bMe(t) {
  return ((t *= 2) <= 1 ? t * t * t : (t -= 2) * t * t + 2) / 2;
}
var kMe = {
  time: null,
  // Set on use.
  delay: 0,
  duration: 250,
  ease: bMe
};
function TMe(t, e) {
  for (var n; !(n = t.__transition) || !(n = n[e]); )
    if (!(t = t.parentNode))
      throw new Error(`transition ${e} not found`);
  return n;
}
function xMe(t) {
  var e, n;
  t instanceof cl ? (e = t._id, t = t._name) : (e = dU(), (n = kMe).time = aR(), t = t == null ? null : t + "");
  for (var r = this._groups, o = r.length, s = 0; s < o; ++s)
    for (var i = r[s], u = i.length, l, a = 0; a < u; ++a)
      (l = i[a]) && rw(l, t, e, a, i, n || TMe(l, e));
  return new cl(r, this._parents, t, e);
}
hy.prototype.interrupt = bEe;
hy.prototype.transition = xMe;
function SMe(t) {
  return Math.abs(t = Math.round(t)) >= 1e21 ? t.toLocaleString("en").replace(/,/g, "") : t.toString(10);
}
function Nv(t, e) {
  if ((n = (t = e ? t.toExponential(e - 1) : t.toExponential()).indexOf("e")) < 0) return null;
  var n, r = t.slice(0, n);
  return [
    r.length > 1 ? r[0] + r.slice(2) : r,
    +t.slice(n + 1)
  ];
}
function Rh(t) {
  return t = Nv(Math.abs(t)), t ? t[1] : NaN;
}
function RMe(t, e) {
  return function(n, r) {
    for (var o = n.length, s = [], i = 0, u = t[0], l = 0; o > 0 && u > 0 && (l + u + 1 > r && (u = Math.max(1, r - l)), s.push(n.substring(o -= u, o + u)), !((l += u + 1) > r)); )
      u = t[i = (i + 1) % t.length];
    return s.reverse().join(e);
  };
}
function AMe(t) {
  return function(e) {
    return e.replace(/[0-9]/g, function(n) {
      return t[+n];
    });
  };
}
var DMe = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
function Lv(t) {
  if (!(e = DMe.exec(t))) throw new Error("invalid format: " + t);
  var e;
  return new lR({
    fill: e[1],
    align: e[2],
    sign: e[3],
    symbol: e[4],
    zero: e[5],
    width: e[6],
    comma: e[7],
    precision: e[8] && e[8].slice(1),
    trim: e[9],
    type: e[10]
  });
}
Lv.prototype = lR.prototype;
function lR(t) {
  this.fill = t.fill === void 0 ? " " : t.fill + "", this.align = t.align === void 0 ? ">" : t.align + "", this.sign = t.sign === void 0 ? "-" : t.sign + "", this.symbol = t.symbol === void 0 ? "" : t.symbol + "", this.zero = !!t.zero, this.width = t.width === void 0 ? void 0 : +t.width, this.comma = !!t.comma, this.precision = t.precision === void 0 ? void 0 : +t.precision, this.trim = !!t.trim, this.type = t.type === void 0 ? "" : t.type + "";
}
lR.prototype.toString = function() {
  return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === void 0 ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === void 0 ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
};
function EMe(t) {
  e: for (var e = t.length, n = 1, r = -1, o; n < e; ++n)
    switch (t[n]) {
      case ".":
        r = o = n;
        break;
      case "0":
        r === 0 && (r = n), o = n;
        break;
      default:
        if (!+t[n]) break e;
        r > 0 && (r = 0);
        break;
    }
  return r > 0 ? t.slice(0, r) + t.slice(o + 1) : t;
}
var hU;
function MMe(t, e) {
  var n = Nv(t, e);
  if (!n) return t + "";
  var r = n[0], o = n[1], s = o - (hU = Math.max(-8, Math.min(8, Math.floor(o / 3))) * 3) + 1, i = r.length;
  return s === i ? r : s > i ? r + new Array(s - i + 1).join("0") : s > 0 ? r.slice(0, s) + "." + r.slice(s) : "0." + new Array(1 - s).join("0") + Nv(t, Math.max(0, e + s - 1))[0];
}
function QO(t, e) {
  var n = Nv(t, e);
  if (!n) return t + "";
  var r = n[0], o = n[1];
  return o < 0 ? "0." + new Array(-o).join("0") + r : r.length > o + 1 ? r.slice(0, o + 1) + "." + r.slice(o + 1) : r + new Array(o - r.length + 2).join("0");
}
const KO = {
  "%": (t, e) => (t * 100).toFixed(e),
  b: (t) => Math.round(t).toString(2),
  c: (t) => t + "",
  d: SMe,
  e: (t, e) => t.toExponential(e),
  f: (t, e) => t.toFixed(e),
  g: (t, e) => t.toPrecision(e),
  o: (t) => Math.round(t).toString(8),
  p: (t, e) => QO(t * 100, e),
  r: QO,
  s: MMe,
  X: (t) => Math.round(t).toString(16).toUpperCase(),
  x: (t) => Math.round(t).toString(16)
};
function ZO(t) {
  return t;
}
var JO = Array.prototype.map, eI = ["y", "z", "a", "f", "p", "n", "µ", "m", "", "k", "M", "G", "T", "P", "E", "Z", "Y"];
function PMe(t) {
  var e = t.grouping === void 0 || t.thousands === void 0 ? ZO : RMe(JO.call(t.grouping, Number), t.thousands + ""), n = t.currency === void 0 ? "" : t.currency[0] + "", r = t.currency === void 0 ? "" : t.currency[1] + "", o = t.decimal === void 0 ? "." : t.decimal + "", s = t.numerals === void 0 ? ZO : AMe(JO.call(t.numerals, String)), i = t.percent === void 0 ? "%" : t.percent + "", u = t.minus === void 0 ? "−" : t.minus + "", l = t.nan === void 0 ? "NaN" : t.nan + "";
  function a(p) {
    p = Lv(p);
    var d = p.fill, h = p.align, m = p.sign, g = p.symbol, _ = p.zero, b = p.width, x = p.comma, S = p.precision, E = p.trim, A = p.type;
    A === "n" ? (x = !0, A = "g") : KO[A] || (S === void 0 && (S = 12), E = !0, A = "g"), (_ || d === "0" && h === "=") && (_ = !0, d = "0", h = "=");
    var C = g === "$" ? n : g === "#" && /[boxX]/.test(A) ? "0" + A.toLowerCase() : "", M = g === "$" ? r : /[%p]/.test(A) ? i : "", L = KO[A], X = /[defgprs%]/.test(A);
    S = S === void 0 ? 6 : /[gprs]/.test(A) ? Math.max(1, Math.min(21, S)) : Math.max(0, Math.min(20, S));
    function te(B) {
      var W = C, G = M, ne, de, V;
      if (A === "c")
        G = L(B) + G, B = "";
      else {
        B = +B;
        var Y = B < 0 || 1 / B < 0;
        if (B = isNaN(B) ? l : L(Math.abs(B), S), E && (B = EMe(B)), Y && +B == 0 && m !== "+" && (Y = !1), W = (Y ? m === "(" ? m : u : m === "-" || m === "(" ? "" : m) + W, G = (A === "s" ? eI[8 + hU / 3] : "") + G + (Y && m === "(" ? ")" : ""), X) {
          for (ne = -1, de = B.length; ++ne < de; )
            if (V = B.charCodeAt(ne), 48 > V || V > 57) {
              G = (V === 46 ? o + B.slice(ne + 1) : B.slice(ne)) + G, B = B.slice(0, ne);
              break;
            }
        }
      }
      x && !_ && (B = e(B, 1 / 0));
      var Q = W.length + B.length + G.length, ae = Q < b ? new Array(b - Q + 1).join(d) : "";
      switch (x && _ && (B = e(ae + B, ae.length ? b - G.length : 1 / 0), ae = ""), h) {
        case "<":
          B = W + B + G + ae;
          break;
        case "=":
          B = W + ae + B + G;
          break;
        case "^":
          B = ae.slice(0, Q = ae.length >> 1) + W + B + G + ae.slice(Q);
          break;
        default:
          B = ae + W + B + G;
          break;
      }
      return s(B);
    }
    return te.toString = function() {
      return p + "";
    }, te;
  }
  function c(p, d) {
    var h = a((p = Lv(p), p.type = "f", p)), m = Math.max(-8, Math.min(8, Math.floor(Rh(d) / 3))) * 3, g = Math.pow(10, -m), _ = eI[8 + m / 3];
    return function(b) {
      return h(g * b) + _;
    };
  }
  return {
    format: a,
    formatPrefix: c
  };
}
var Bg, fU, mU;
CMe({
  thousands: ",",
  grouping: [3],
  currency: ["$", ""]
});
function CMe(t) {
  return Bg = PMe(t), fU = Bg.format, mU = Bg.formatPrefix, Bg;
}
function OMe(t) {
  return Math.max(0, -Rh(Math.abs(t)));
}
function IMe(t, e) {
  return Math.max(0, Math.max(-8, Math.min(8, Math.floor(Rh(e) / 3))) * 3 - Rh(Math.abs(t)));
}
function FMe(t, e) {
  return t = Math.abs(t), e = Math.abs(e) - t, Math.max(0, Rh(e) - Rh(t)) + 1;
}
function yU(t, e) {
  switch (arguments.length) {
    case 0:
      break;
    case 1:
      this.range(t);
      break;
    default:
      this.range(e).domain(t);
      break;
  }
  return this;
}
function NMe(t) {
  return function() {
    return t;
  };
}
function LMe(t) {
  return +t;
}
var tI = [0, 1];
function $d(t) {
  return t;
}
function ax(t, e) {
  return (e -= t = +t) ? function(n) {
    return (n - t) / e;
  } : NMe(isNaN(e) ? NaN : 0.5);
}
function BMe(t, e) {
  var n;
  return t > e && (n = t, t = e, e = n), function(r) {
    return Math.max(t, Math.min(e, r));
  };
}
function UMe(t, e, n) {
  var r = t[0], o = t[1], s = e[0], i = e[1];
  return o < r ? (r = ax(o, r), s = n(i, s)) : (r = ax(r, o), s = n(s, i)), function(u) {
    return s(r(u));
  };
}
function XMe(t, e, n) {
  var r = Math.min(t.length, e.length) - 1, o = new Array(r), s = new Array(r), i = -1;
  for (t[r] < t[0] && (t = t.slice().reverse(), e = e.slice().reverse()); ++i < r; )
    o[i] = ax(t[i], t[i + 1]), s[i] = n(e[i], e[i + 1]);
  return function(u) {
    var l = JRe(t, u, 1, r) - 1;
    return s[l](o[l](u));
  };
}
function gU(t, e) {
  return e.domain(t.domain()).range(t.range()).interpolate(t.interpolate()).clamp(t.clamp()).unknown(t.unknown());
}
function $Me() {
  var t = tI, e = tI, n = sR, r, o, s, i = $d, u, l, a;
  function c() {
    var d = Math.min(t.length, e.length);
    return i !== $d && (i = BMe(t[0], t[d - 1])), u = d > 2 ? XMe : UMe, l = a = null, p;
  }
  function p(d) {
    return d == null || isNaN(d = +d) ? s : (l || (l = u(t.map(r), e, n)))(r(i(d)));
  }
  return p.invert = function(d) {
    return i(o((a || (a = u(e, t.map(r), ai)))(d)));
  }, p.domain = function(d) {
    return arguments.length ? (t = Array.from(d, LMe), c()) : t.slice();
  }, p.range = function(d) {
    return arguments.length ? (e = Array.from(d), c()) : e.slice();
  }, p.rangeRound = function(d) {
    return e = Array.from(d), n = uEe, c();
  }, p.clamp = function(d) {
    return arguments.length ? (i = d ? !0 : $d, c()) : i !== $d;
  }, p.interpolate = function(d) {
    return arguments.length ? (n = d, c()) : n;
  }, p.unknown = function(d) {
    return arguments.length ? (s = d, p) : s;
  }, function(d, h) {
    return r = d, o = h, c();
  };
}
function vU() {
  return $Me()($d, $d);
}
function WMe(t, e, n, r) {
  var o = JT(t, e, n), s;
  switch (r = Lv(r ?? ",f"), r.type) {
    case "s": {
      var i = Math.max(Math.abs(t), Math.abs(e));
      return r.precision == null && !isNaN(s = IMe(o, i)) && (r.precision = s), mU(r, i);
    }
    case "":
    case "e":
    case "g":
    case "p":
    case "r": {
      r.precision == null && !isNaN(s = FMe(o, Math.max(Math.abs(t), Math.abs(e)))) && (r.precision = s - (r.type === "e"));
      break;
    }
    case "f":
    case "%": {
      r.precision == null && !isNaN(s = OMe(o)) && (r.precision = s - (r.type === "%") * 2);
      break;
    }
  }
  return fU(r);
}
function VMe(t) {
  var e = t.domain;
  return t.ticks = function(n) {
    var r = e();
    return rAe(r[0], r[r.length - 1], n ?? 10);
  }, t.tickFormat = function(n, r) {
    var o = e();
    return WMe(o[0], o[o.length - 1], n ?? 10, r);
  }, t.nice = function(n) {
    n == null && (n = 10);
    var r = e(), o = 0, s = r.length - 1, i = r[o], u = r[s], l, a, c = 10;
    for (u < i && (a = i, i = u, u = a, a = o, o = s, s = a); c-- > 0; ) {
      if (a = ZT(i, u, n), a === l)
        return r[o] = i, r[s] = u, e(r);
      if (a > 0)
        i = Math.floor(i / a) * a, u = Math.ceil(u / a) * a;
      else if (a < 0)
        i = Math.ceil(i * a) / a, u = Math.floor(u * a) / a;
      else
        break;
      l = a;
    }
    return t;
  }, t;
}
function _U() {
  var t = vU();
  return t.copy = function() {
    return gU(t, _U());
  }, yU.apply(t, arguments), VMe(t);
}
function HMe(t, e) {
  t = t.slice();
  var n = 0, r = t.length - 1, o = t[n], s = t[r], i;
  return s < o && (i = n, n = r, r = i, i = o, o = s, s = i), t[n] = e.floor(o), t[r] = e.ceil(s), t;
}
const Gb = /* @__PURE__ */ new Date(), Yb = /* @__PURE__ */ new Date();
function co(t, e, n, r) {
  function o(s) {
    return t(s = arguments.length === 0 ? /* @__PURE__ */ new Date() : /* @__PURE__ */ new Date(+s)), s;
  }
  return o.floor = (s) => (t(s = /* @__PURE__ */ new Date(+s)), s), o.ceil = (s) => (t(s = new Date(s - 1)), e(s, 1), t(s), s), o.round = (s) => {
    const i = o(s), u = o.ceil(s);
    return s - i < u - s ? i : u;
  }, o.offset = (s, i) => (e(s = /* @__PURE__ */ new Date(+s), i == null ? 1 : Math.floor(i)), s), o.range = (s, i, u) => {
    const l = [];
    if (s = o.ceil(s), u = u == null ? 1 : Math.floor(u), !(s < i) || !(u > 0)) return l;
    let a;
    do
      l.push(a = /* @__PURE__ */ new Date(+s)), e(s, u), t(s);
    while (a < s && s < i);
    return l;
  }, o.filter = (s) => co((i) => {
    if (i >= i) for (; t(i), !s(i); ) i.setTime(i - 1);
  }, (i, u) => {
    if (i >= i)
      if (u < 0) for (; ++u <= 0; )
        for (; e(i, -1), !s(i); )
          ;
      else for (; --u >= 0; )
        for (; e(i, 1), !s(i); )
          ;
  }), n && (o.count = (s, i) => (Gb.setTime(+s), Yb.setTime(+i), t(Gb), t(Yb), Math.floor(n(Gb, Yb))), o.every = (s) => (s = Math.floor(s), !isFinite(s) || !(s > 0) ? null : s > 1 ? o.filter(r ? (i) => r(i) % s === 0 : (i) => o.count(0, i) % s === 0) : o)), o;
}
const Bv = co(() => {
}, (t, e) => {
  t.setTime(+t + e);
}, (t, e) => e - t);
Bv.every = (t) => (t = Math.floor(t), !isFinite(t) || !(t > 0) ? null : t > 1 ? co((e) => {
  e.setTime(Math.floor(e / t) * t);
}, (e, n) => {
  e.setTime(+e + n * t);
}, (e, n) => (n - e) / t) : Bv);
Bv.range;
const Ku = 1e3, Pa = Ku * 60, Zu = Pa * 60, pl = Zu * 24, cR = pl * 7, nI = pl * 30, Qb = pl * 365, Wd = co((t) => {
  t.setTime(t - t.getMilliseconds());
}, (t, e) => {
  t.setTime(+t + e * Ku);
}, (t, e) => (e - t) / Ku, (t) => t.getUTCSeconds());
Wd.range;
const pR = co((t) => {
  t.setTime(t - t.getMilliseconds() - t.getSeconds() * Ku);
}, (t, e) => {
  t.setTime(+t + e * Pa);
}, (t, e) => (e - t) / Pa, (t) => t.getMinutes());
pR.range;
const jMe = co((t) => {
  t.setUTCSeconds(0, 0);
}, (t, e) => {
  t.setTime(+t + e * Pa);
}, (t, e) => (e - t) / Pa, (t) => t.getUTCMinutes());
jMe.range;
const dR = co((t) => {
  t.setTime(t - t.getMilliseconds() - t.getSeconds() * Ku - t.getMinutes() * Pa);
}, (t, e) => {
  t.setTime(+t + e * Zu);
}, (t, e) => (e - t) / Zu, (t) => t.getHours());
dR.range;
const zMe = co((t) => {
  t.setUTCMinutes(0, 0, 0);
}, (t, e) => {
  t.setTime(+t + e * Zu);
}, (t, e) => (e - t) / Zu, (t) => t.getUTCHours());
zMe.range;
const my = co(
  (t) => t.setHours(0, 0, 0, 0),
  (t, e) => t.setDate(t.getDate() + e),
  (t, e) => (e - t - (e.getTimezoneOffset() - t.getTimezoneOffset()) * Pa) / pl,
  (t) => t.getDate() - 1
);
my.range;
const hR = co((t) => {
  t.setUTCHours(0, 0, 0, 0);
}, (t, e) => {
  t.setUTCDate(t.getUTCDate() + e);
}, (t, e) => (e - t) / pl, (t) => t.getUTCDate() - 1);
hR.range;
const qMe = co((t) => {
  t.setUTCHours(0, 0, 0, 0);
}, (t, e) => {
  t.setUTCDate(t.getUTCDate() + e);
}, (t, e) => (e - t) / pl, (t) => Math.floor(t / pl));
qMe.range;
function sd(t) {
  return co((e) => {
    e.setDate(e.getDate() - (e.getDay() + 7 - t) % 7), e.setHours(0, 0, 0, 0);
  }, (e, n) => {
    e.setDate(e.getDate() + n * 7);
  }, (e, n) => (n - e - (n.getTimezoneOffset() - e.getTimezoneOffset()) * Pa) / cR);
}
const ow = sd(0), Uv = sd(1), GMe = sd(2), YMe = sd(3), Ah = sd(4), QMe = sd(5), KMe = sd(6);
ow.range;
Uv.range;
GMe.range;
YMe.range;
Ah.range;
QMe.range;
KMe.range;
function ad(t) {
  return co((e) => {
    e.setUTCDate(e.getUTCDate() - (e.getUTCDay() + 7 - t) % 7), e.setUTCHours(0, 0, 0, 0);
  }, (e, n) => {
    e.setUTCDate(e.getUTCDate() + n * 7);
  }, (e, n) => (n - e) / cR);
}
const wU = ad(0), Xv = ad(1), ZMe = ad(2), JMe = ad(3), Dh = ad(4), ePe = ad(5), tPe = ad(6);
wU.range;
Xv.range;
ZMe.range;
JMe.range;
Dh.range;
ePe.range;
tPe.range;
const fR = co((t) => {
  t.setDate(1), t.setHours(0, 0, 0, 0);
}, (t, e) => {
  t.setMonth(t.getMonth() + e);
}, (t, e) => e.getMonth() - t.getMonth() + (e.getFullYear() - t.getFullYear()) * 12, (t) => t.getMonth());
fR.range;
const nPe = co((t) => {
  t.setUTCDate(1), t.setUTCHours(0, 0, 0, 0);
}, (t, e) => {
  t.setUTCMonth(t.getUTCMonth() + e);
}, (t, e) => e.getUTCMonth() - t.getUTCMonth() + (e.getUTCFullYear() - t.getUTCFullYear()) * 12, (t) => t.getUTCMonth());
nPe.range;
const dl = co((t) => {
  t.setMonth(0, 1), t.setHours(0, 0, 0, 0);
}, (t, e) => {
  t.setFullYear(t.getFullYear() + e);
}, (t, e) => e.getFullYear() - t.getFullYear(), (t) => t.getFullYear());
dl.every = (t) => !isFinite(t = Math.floor(t)) || !(t > 0) ? null : co((e) => {
  e.setFullYear(Math.floor(e.getFullYear() / t) * t), e.setMonth(0, 1), e.setHours(0, 0, 0, 0);
}, (e, n) => {
  e.setFullYear(e.getFullYear() + n * t);
});
dl.range;
const jp = co((t) => {
  t.setUTCMonth(0, 1), t.setUTCHours(0, 0, 0, 0);
}, (t, e) => {
  t.setUTCFullYear(t.getUTCFullYear() + e);
}, (t, e) => e.getUTCFullYear() - t.getUTCFullYear(), (t) => t.getUTCFullYear());
jp.every = (t) => !isFinite(t = Math.floor(t)) || !(t > 0) ? null : co((e) => {
  e.setUTCFullYear(Math.floor(e.getUTCFullYear() / t) * t), e.setUTCMonth(0, 1), e.setUTCHours(0, 0, 0, 0);
}, (e, n) => {
  e.setUTCFullYear(e.getUTCFullYear() + n * t);
});
jp.range;
function rPe(t, e, n, r, o, s) {
  const i = [
    [Wd, 1, Ku],
    [Wd, 5, 5 * Ku],
    [Wd, 15, 15 * Ku],
    [Wd, 30, 30 * Ku],
    [s, 1, Pa],
    [s, 5, 5 * Pa],
    [s, 15, 15 * Pa],
    [s, 30, 30 * Pa],
    [o, 1, Zu],
    [o, 3, 3 * Zu],
    [o, 6, 6 * Zu],
    [o, 12, 12 * Zu],
    [r, 1, pl],
    [r, 2, 2 * pl],
    [n, 1, cR],
    [e, 1, nI],
    [e, 3, 3 * nI],
    [t, 1, Qb]
  ];
  function u(a, c, p) {
    const d = c < a;
    d && ([a, c] = [c, a]);
    const h = p && typeof p.range == "function" ? p : l(a, c, p), m = h ? h.range(a, +c + 1) : [];
    return d ? m.reverse() : m;
  }
  function l(a, c, p) {
    const d = Math.abs(c - a) / p, h = eR(([, , _]) => _).right(i, d);
    if (h === i.length) return t.every(JT(a / Qb, c / Qb, p));
    if (h === 0) return Bv.every(Math.max(JT(a, c, p), 1));
    const [m, g] = i[d / i[h - 1][2] < i[h][2] / d ? h - 1 : h];
    return m.every(g);
  }
  return [u, l];
}
const [oPe, sPe] = rPe(dl, fR, ow, my, dR, pR);
function Kb(t) {
  if (0 <= t.y && t.y < 100) {
    var e = new Date(-1, t.m, t.d, t.H, t.M, t.S, t.L);
    return e.setFullYear(t.y), e;
  }
  return new Date(t.y, t.m, t.d, t.H, t.M, t.S, t.L);
}
function Zb(t) {
  if (0 <= t.y && t.y < 100) {
    var e = new Date(Date.UTC(-1, t.m, t.d, t.H, t.M, t.S, t.L));
    return e.setUTCFullYear(t.y), e;
  }
  return new Date(Date.UTC(t.y, t.m, t.d, t.H, t.M, t.S, t.L));
}
function Sf(t, e, n) {
  return { y: t, m: e, d: n, H: 0, M: 0, S: 0, L: 0 };
}
function aPe(t) {
  var e = t.dateTime, n = t.date, r = t.time, o = t.periods, s = t.days, i = t.shortDays, u = t.months, l = t.shortMonths, a = Rf(o), c = Af(o), p = Rf(s), d = Af(s), h = Rf(i), m = Af(i), g = Rf(u), _ = Af(u), b = Rf(l), x = Af(l), S = {
    a: Y,
    A: Q,
    b: ae,
    B: Z,
    c: null,
    d: uI,
    e: uI,
    f: EPe,
    g: UPe,
    G: $Pe,
    H: RPe,
    I: APe,
    j: DPe,
    L: bU,
    m: MPe,
    M: PPe,
    p: J,
    q: oe,
    Q: pI,
    s: dI,
    S: CPe,
    u: OPe,
    U: IPe,
    V: FPe,
    w: NPe,
    W: LPe,
    x: null,
    X: null,
    y: BPe,
    Y: XPe,
    Z: WPe,
    "%": cI
  }, E = {
    a: ue,
    A: me,
    b: pe,
    B: Be,
    c: null,
    d: lI,
    e: lI,
    f: zPe,
    g: nCe,
    G: oCe,
    H: VPe,
    I: HPe,
    j: jPe,
    L: TU,
    m: qPe,
    M: GPe,
    p: Ie,
    q: Me,
    Q: pI,
    s: dI,
    S: YPe,
    u: QPe,
    U: KPe,
    V: ZPe,
    w: JPe,
    W: eCe,
    x: null,
    X: null,
    y: tCe,
    Y: rCe,
    Z: sCe,
    "%": cI
  }, A = {
    a: te,
    A: B,
    b: W,
    B: G,
    c: ne,
    d: aI,
    e: aI,
    f: kPe,
    g: sI,
    G: oI,
    H: iI,
    I: iI,
    j: vPe,
    L: bPe,
    m: gPe,
    M: _Pe,
    p: X,
    q: yPe,
    Q: xPe,
    s: SPe,
    S: wPe,
    u: pPe,
    U: dPe,
    V: hPe,
    w: cPe,
    W: fPe,
    x: de,
    X: V,
    y: sI,
    Y: oI,
    Z: mPe,
    "%": TPe
  };
  S.x = C(n, S), S.X = C(r, S), S.c = C(e, S), E.x = C(n, E), E.X = C(r, E), E.c = C(e, E);
  function C(fe, Te) {
    return function(Ae) {
      var we = [], $e = -1, ze = 0, Ue = fe.length, tt, Ot, cn;
      for (Ae instanceof Date || (Ae = /* @__PURE__ */ new Date(+Ae)); ++$e < Ue; )
        fe.charCodeAt($e) === 37 && (we.push(fe.slice(ze, $e)), (Ot = rI[tt = fe.charAt(++$e)]) != null ? tt = fe.charAt(++$e) : Ot = tt === "e" ? " " : "0", (cn = Te[tt]) && (tt = cn(Ae, Ot)), we.push(tt), ze = $e + 1);
      return we.push(fe.slice(ze, $e)), we.join("");
    };
  }
  function M(fe, Te) {
    return function(Ae) {
      var we = Sf(1900, void 0, 1), $e = L(we, fe, Ae += "", 0), ze, Ue;
      if ($e != Ae.length) return null;
      if ("Q" in we) return new Date(we.Q);
      if ("s" in we) return new Date(we.s * 1e3 + ("L" in we ? we.L : 0));
      if (Te && !("Z" in we) && (we.Z = 0), "p" in we && (we.H = we.H % 12 + we.p * 12), we.m === void 0 && (we.m = "q" in we ? we.q : 0), "V" in we) {
        if (we.V < 1 || we.V > 53) return null;
        "w" in we || (we.w = 1), "Z" in we ? (ze = Zb(Sf(we.y, 0, 1)), Ue = ze.getUTCDay(), ze = Ue > 4 || Ue === 0 ? Xv.ceil(ze) : Xv(ze), ze = hR.offset(ze, (we.V - 1) * 7), we.y = ze.getUTCFullYear(), we.m = ze.getUTCMonth(), we.d = ze.getUTCDate() + (we.w + 6) % 7) : (ze = Kb(Sf(we.y, 0, 1)), Ue = ze.getDay(), ze = Ue > 4 || Ue === 0 ? Uv.ceil(ze) : Uv(ze), ze = my.offset(ze, (we.V - 1) * 7), we.y = ze.getFullYear(), we.m = ze.getMonth(), we.d = ze.getDate() + (we.w + 6) % 7);
      } else ("W" in we || "U" in we) && ("w" in we || (we.w = "u" in we ? we.u % 7 : "W" in we ? 1 : 0), Ue = "Z" in we ? Zb(Sf(we.y, 0, 1)).getUTCDay() : Kb(Sf(we.y, 0, 1)).getDay(), we.m = 0, we.d = "W" in we ? (we.w + 6) % 7 + we.W * 7 - (Ue + 5) % 7 : we.w + we.U * 7 - (Ue + 6) % 7);
      return "Z" in we ? (we.H += we.Z / 100 | 0, we.M += we.Z % 100, Zb(we)) : Kb(we);
    };
  }
  function L(fe, Te, Ae, we) {
    for (var $e = 0, ze = Te.length, Ue = Ae.length, tt, Ot; $e < ze; ) {
      if (we >= Ue) return -1;
      if (tt = Te.charCodeAt($e++), tt === 37) {
        if (tt = Te.charAt($e++), Ot = A[tt in rI ? Te.charAt($e++) : tt], !Ot || (we = Ot(fe, Ae, we)) < 0) return -1;
      } else if (tt != Ae.charCodeAt(we++))
        return -1;
    }
    return we;
  }
  function X(fe, Te, Ae) {
    var we = a.exec(Te.slice(Ae));
    return we ? (fe.p = c.get(we[0].toLowerCase()), Ae + we[0].length) : -1;
  }
  function te(fe, Te, Ae) {
    var we = h.exec(Te.slice(Ae));
    return we ? (fe.w = m.get(we[0].toLowerCase()), Ae + we[0].length) : -1;
  }
  function B(fe, Te, Ae) {
    var we = p.exec(Te.slice(Ae));
    return we ? (fe.w = d.get(we[0].toLowerCase()), Ae + we[0].length) : -1;
  }
  function W(fe, Te, Ae) {
    var we = b.exec(Te.slice(Ae));
    return we ? (fe.m = x.get(we[0].toLowerCase()), Ae + we[0].length) : -1;
  }
  function G(fe, Te, Ae) {
    var we = g.exec(Te.slice(Ae));
    return we ? (fe.m = _.get(we[0].toLowerCase()), Ae + we[0].length) : -1;
  }
  function ne(fe, Te, Ae) {
    return L(fe, e, Te, Ae);
  }
  function de(fe, Te, Ae) {
    return L(fe, n, Te, Ae);
  }
  function V(fe, Te, Ae) {
    return L(fe, r, Te, Ae);
  }
  function Y(fe) {
    return i[fe.getDay()];
  }
  function Q(fe) {
    return s[fe.getDay()];
  }
  function ae(fe) {
    return l[fe.getMonth()];
  }
  function Z(fe) {
    return u[fe.getMonth()];
  }
  function J(fe) {
    return o[+(fe.getHours() >= 12)];
  }
  function oe(fe) {
    return 1 + ~~(fe.getMonth() / 3);
  }
  function ue(fe) {
    return i[fe.getUTCDay()];
  }
  function me(fe) {
    return s[fe.getUTCDay()];
  }
  function pe(fe) {
    return l[fe.getUTCMonth()];
  }
  function Be(fe) {
    return u[fe.getUTCMonth()];
  }
  function Ie(fe) {
    return o[+(fe.getUTCHours() >= 12)];
  }
  function Me(fe) {
    return 1 + ~~(fe.getUTCMonth() / 3);
  }
  return {
    format: function(fe) {
      var Te = C(fe += "", S);
      return Te.toString = function() {
        return fe;
      }, Te;
    },
    parse: function(fe) {
      var Te = M(fe += "", !1);
      return Te.toString = function() {
        return fe;
      }, Te;
    },
    utcFormat: function(fe) {
      var Te = C(fe += "", E);
      return Te.toString = function() {
        return fe;
      }, Te;
    },
    utcParse: function(fe) {
      var Te = M(fe += "", !0);
      return Te.toString = function() {
        return fe;
      }, Te;
    }
  };
}
var rI = { "-": "", _: " ", 0: "0" }, bo = /^\s*\d+/, iPe = /^%/, uPe = /[\\^$*+?|[\]().{}]/g;
function xn(t, e, n) {
  var r = t < 0 ? "-" : "", o = (r ? -t : t) + "", s = o.length;
  return r + (s < n ? new Array(n - s + 1).join(e) + o : o);
}
function lPe(t) {
  return t.replace(uPe, "\\$&");
}
function Rf(t) {
  return new RegExp("^(?:" + t.map(lPe).join("|") + ")", "i");
}
function Af(t) {
  return new Map(t.map((e, n) => [e.toLowerCase(), n]));
}
function cPe(t, e, n) {
  var r = bo.exec(e.slice(n, n + 1));
  return r ? (t.w = +r[0], n + r[0].length) : -1;
}
function pPe(t, e, n) {
  var r = bo.exec(e.slice(n, n + 1));
  return r ? (t.u = +r[0], n + r[0].length) : -1;
}
function dPe(t, e, n) {
  var r = bo.exec(e.slice(n, n + 2));
  return r ? (t.U = +r[0], n + r[0].length) : -1;
}
function hPe(t, e, n) {
  var r = bo.exec(e.slice(n, n + 2));
  return r ? (t.V = +r[0], n + r[0].length) : -1;
}
function fPe(t, e, n) {
  var r = bo.exec(e.slice(n, n + 2));
  return r ? (t.W = +r[0], n + r[0].length) : -1;
}
function oI(t, e, n) {
  var r = bo.exec(e.slice(n, n + 4));
  return r ? (t.y = +r[0], n + r[0].length) : -1;
}
function sI(t, e, n) {
  var r = bo.exec(e.slice(n, n + 2));
  return r ? (t.y = +r[0] + (+r[0] > 68 ? 1900 : 2e3), n + r[0].length) : -1;
}
function mPe(t, e, n) {
  var r = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(e.slice(n, n + 6));
  return r ? (t.Z = r[1] ? 0 : -(r[2] + (r[3] || "00")), n + r[0].length) : -1;
}
function yPe(t, e, n) {
  var r = bo.exec(e.slice(n, n + 1));
  return r ? (t.q = r[0] * 3 - 3, n + r[0].length) : -1;
}
function gPe(t, e, n) {
  var r = bo.exec(e.slice(n, n + 2));
  return r ? (t.m = r[0] - 1, n + r[0].length) : -1;
}
function aI(t, e, n) {
  var r = bo.exec(e.slice(n, n + 2));
  return r ? (t.d = +r[0], n + r[0].length) : -1;
}
function vPe(t, e, n) {
  var r = bo.exec(e.slice(n, n + 3));
  return r ? (t.m = 0, t.d = +r[0], n + r[0].length) : -1;
}
function iI(t, e, n) {
  var r = bo.exec(e.slice(n, n + 2));
  return r ? (t.H = +r[0], n + r[0].length) : -1;
}
function _Pe(t, e, n) {
  var r = bo.exec(e.slice(n, n + 2));
  return r ? (t.M = +r[0], n + r[0].length) : -1;
}
function wPe(t, e, n) {
  var r = bo.exec(e.slice(n, n + 2));
  return r ? (t.S = +r[0], n + r[0].length) : -1;
}
function bPe(t, e, n) {
  var r = bo.exec(e.slice(n, n + 3));
  return r ? (t.L = +r[0], n + r[0].length) : -1;
}
function kPe(t, e, n) {
  var r = bo.exec(e.slice(n, n + 6));
  return r ? (t.L = Math.floor(r[0] / 1e3), n + r[0].length) : -1;
}
function TPe(t, e, n) {
  var r = iPe.exec(e.slice(n, n + 1));
  return r ? n + r[0].length : -1;
}
function xPe(t, e, n) {
  var r = bo.exec(e.slice(n));
  return r ? (t.Q = +r[0], n + r[0].length) : -1;
}
function SPe(t, e, n) {
  var r = bo.exec(e.slice(n));
  return r ? (t.s = +r[0], n + r[0].length) : -1;
}
function uI(t, e) {
  return xn(t.getDate(), e, 2);
}
function RPe(t, e) {
  return xn(t.getHours(), e, 2);
}
function APe(t, e) {
  return xn(t.getHours() % 12 || 12, e, 2);
}
function DPe(t, e) {
  return xn(1 + my.count(dl(t), t), e, 3);
}
function bU(t, e) {
  return xn(t.getMilliseconds(), e, 3);
}
function EPe(t, e) {
  return bU(t, e) + "000";
}
function MPe(t, e) {
  return xn(t.getMonth() + 1, e, 2);
}
function PPe(t, e) {
  return xn(t.getMinutes(), e, 2);
}
function CPe(t, e) {
  return xn(t.getSeconds(), e, 2);
}
function OPe(t) {
  var e = t.getDay();
  return e === 0 ? 7 : e;
}
function IPe(t, e) {
  return xn(ow.count(dl(t) - 1, t), e, 2);
}
function kU(t) {
  var e = t.getDay();
  return e >= 4 || e === 0 ? Ah(t) : Ah.ceil(t);
}
function FPe(t, e) {
  return t = kU(t), xn(Ah.count(dl(t), t) + (dl(t).getDay() === 4), e, 2);
}
function NPe(t) {
  return t.getDay();
}
function LPe(t, e) {
  return xn(Uv.count(dl(t) - 1, t), e, 2);
}
function BPe(t, e) {
  return xn(t.getFullYear() % 100, e, 2);
}
function UPe(t, e) {
  return t = kU(t), xn(t.getFullYear() % 100, e, 2);
}
function XPe(t, e) {
  return xn(t.getFullYear() % 1e4, e, 4);
}
function $Pe(t, e) {
  var n = t.getDay();
  return t = n >= 4 || n === 0 ? Ah(t) : Ah.ceil(t), xn(t.getFullYear() % 1e4, e, 4);
}
function WPe(t) {
  var e = t.getTimezoneOffset();
  return (e > 0 ? "-" : (e *= -1, "+")) + xn(e / 60 | 0, "0", 2) + xn(e % 60, "0", 2);
}
function lI(t, e) {
  return xn(t.getUTCDate(), e, 2);
}
function VPe(t, e) {
  return xn(t.getUTCHours(), e, 2);
}
function HPe(t, e) {
  return xn(t.getUTCHours() % 12 || 12, e, 2);
}
function jPe(t, e) {
  return xn(1 + hR.count(jp(t), t), e, 3);
}
function TU(t, e) {
  return xn(t.getUTCMilliseconds(), e, 3);
}
function zPe(t, e) {
  return TU(t, e) + "000";
}
function qPe(t, e) {
  return xn(t.getUTCMonth() + 1, e, 2);
}
function GPe(t, e) {
  return xn(t.getUTCMinutes(), e, 2);
}
function YPe(t, e) {
  return xn(t.getUTCSeconds(), e, 2);
}
function QPe(t) {
  var e = t.getUTCDay();
  return e === 0 ? 7 : e;
}
function KPe(t, e) {
  return xn(wU.count(jp(t) - 1, t), e, 2);
}
function xU(t) {
  var e = t.getUTCDay();
  return e >= 4 || e === 0 ? Dh(t) : Dh.ceil(t);
}
function ZPe(t, e) {
  return t = xU(t), xn(Dh.count(jp(t), t) + (jp(t).getUTCDay() === 4), e, 2);
}
function JPe(t) {
  return t.getUTCDay();
}
function eCe(t, e) {
  return xn(Xv.count(jp(t) - 1, t), e, 2);
}
function tCe(t, e) {
  return xn(t.getUTCFullYear() % 100, e, 2);
}
function nCe(t, e) {
  return t = xU(t), xn(t.getUTCFullYear() % 100, e, 2);
}
function rCe(t, e) {
  return xn(t.getUTCFullYear() % 1e4, e, 4);
}
function oCe(t, e) {
  var n = t.getUTCDay();
  return t = n >= 4 || n === 0 ? Dh(t) : Dh.ceil(t), xn(t.getUTCFullYear() % 1e4, e, 4);
}
function sCe() {
  return "+0000";
}
function cI() {
  return "%";
}
function pI(t) {
  return +t;
}
function dI(t) {
  return Math.floor(+t / 1e3);
}
var Sd, SU;
aCe({
  dateTime: "%x, %X",
  date: "%-m/%-d/%Y",
  time: "%-I:%M:%S %p",
  periods: ["AM", "PM"],
  days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
  shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
  shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
});
function aCe(t) {
  return Sd = aPe(t), SU = Sd.format, Sd.parse, Sd.utcFormat, Sd.utcParse, Sd;
}
function iCe(t) {
  return new Date(t);
}
function uCe(t) {
  return t instanceof Date ? +t : +/* @__PURE__ */ new Date(+t);
}
function RU(t, e, n, r, o, s, i, u, l, a) {
  var c = vU(), p = c.invert, d = c.domain, h = a(".%L"), m = a(":%S"), g = a("%I:%M"), _ = a("%I %p"), b = a("%a %d"), x = a("%b %d"), S = a("%B"), E = a("%Y");
  function A(C) {
    return (l(C) < C ? h : u(C) < C ? m : i(C) < C ? g : s(C) < C ? _ : r(C) < C ? o(C) < C ? b : x : n(C) < C ? S : E)(C);
  }
  return c.invert = function(C) {
    return new Date(p(C));
  }, c.domain = function(C) {
    return arguments.length ? d(Array.from(C, uCe)) : d().map(iCe);
  }, c.ticks = function(C) {
    var M = d();
    return t(M[0], M[M.length - 1], C ?? 10);
  }, c.tickFormat = function(C, M) {
    return M == null ? A : a(M);
  }, c.nice = function(C) {
    var M = d();
    return (!C || typeof C.range != "function") && (C = e(M[0], M[M.length - 1], C ?? 10)), C ? d(HMe(M, C)) : c;
  }, c.copy = function() {
    return gU(c, RU(t, e, n, r, o, s, i, u, l, a));
  }, c;
}
function lCe() {
  return yU.apply(RU(oPe, sPe, dl, fR, ow, my, dR, pR, Wd, SU).domain([new Date(2e3, 0, 1), new Date(2e3, 0, 2)]), arguments);
}
function Yf(t, e, n) {
  this.k = t, this.x = e, this.y = n;
}
Yf.prototype = {
  constructor: Yf,
  scale: function(t) {
    return t === 1 ? this : new Yf(this.k * t, this.x, this.y);
  },
  translate: function(t, e) {
    return t === 0 & e === 0 ? this : new Yf(this.k, this.x + this.k * t, this.y + this.k * e);
  },
  apply: function(t) {
    return [t[0] * this.k + this.x, t[1] * this.k + this.y];
  },
  applyX: function(t) {
    return t * this.k + this.x;
  },
  applyY: function(t) {
    return t * this.k + this.y;
  },
  invert: function(t) {
    return [(t[0] - this.x) / this.k, (t[1] - this.y) / this.k];
  },
  invertX: function(t) {
    return (t - this.x) / this.k;
  },
  invertY: function(t) {
    return (t - this.y) / this.k;
  },
  rescaleX: function(t) {
    return t.copy().domain(t.range().map(this.invertX, this).map(t.invert, t));
  },
  rescaleY: function(t) {
    return t.copy().domain(t.range().map(this.invertY, this).map(t.invert, t));
  },
  toString: function() {
    return "translate(" + this.x + "," + this.y + ") scale(" + this.k + ")";
  }
};
Yf.prototype;
function AU(t) {
  return t.mode === "temporal" || t.mode === "left-aligned" ? cCe(t) : pCe(t);
}
function cCe({ domain: t, range: e }) {
  return lCe().domain(t).range(e);
}
function pCe({ domain: t, range: e }) {
  return _U().domain(t).range(e);
}
function ix(t) {
  return {
    mode: ot.horizontal,
    range: tRe(),
    domain: nRe(t)
  };
}
function dCe() {
  return {
    mode: ot.vertical
  };
}
let rm = null;
async function hCe() {
  const t = await ku();
  hI(t.start_time), Ze.on("layoutSettingsUpdated", () => hI(t.start_time));
}
function fCe() {
  rm = null;
}
async function Wa() {
  return rm || await Is("scaleCreated");
}
async function hI(t) {
  await eo();
  const e = rm ? "scaleUpdated" : "scaleCreated", n = ix(t);
  rm = AU(n), Ze.emit(e, rm);
}
function sc(t) {
  return "getIds" in t;
}
async function DU({ items: t, createCluster: e }) {
  const n = [...t.values()].sort((i, u) => i.element.x - u.element.x);
  async function r(i) {
    let u, l = null, a = null;
    for (let c = i ?? 0; c < n.length; c++) {
      const p = n[c], d = p.element.x;
      if (p.element.visible = !0, l !== null && u && d < u) {
        a = c;
        break;
      }
      l = c, u = d + p.element.width;
    }
    if (a !== null && l !== null) {
      const c = n[l], p = n[a];
      c.element.visible = !1, p.element.visible = !1;
      const d = await o(c, p);
      d && (n.splice(l, 1, d), n.splice(a, 1)), r(l);
    }
  }
  async function o(i, u) {
    const l = i.getDate(), a = u.getDate(), c = sc(i) ? i.getIds() : [i.getId()], p = sc(u) ? u.getIds() : [u.getId()];
    if (!l || !a)
      return console.error("flowRunArtifacts: visible item is missing date"), null;
    let d;
    sc(i) ? d = i : sc(u) ? d = u : d = await e();
    const h = [...c, ...p], m = s(h);
    return await d.render({ ids: h, date: m }), d;
  }
  function s(i) {
    const u = i.reduce((c, p) => {
      const d = t.get(p)?.getDate();
      return d && c.push(d.getTime()), c;
    }, []), l = Math.min(...u), a = Math.max(...u);
    return new Date((l + a) / 2);
  }
  await r();
}
async function fI(t) {
  const e = await no(), n = await ro(), r = await wr(), o = await eo();
  let s = await Wa();
  const i = await l();
  i.element.on("click", (c) => {
    c.stopPropagation();
    const { element: p } = i, d = {
      x: p.position.x,
      y: p.position.y,
      width: p.width,
      height: p.height
    }, h = sc(i) ? { kind: "events", ids: i.getIds(), occurred: i.getDate(), position: d } : { kind: "event", id: i.getId(), occurred: i.getDate(), position: d };
    wu(h);
  }), Ze.on("scaleUpdated", (c) => {
    s = c, a();
  }), Ze.on("viewportMoved", () => a());
  async function u(c) {
    await i.render(c), a();
  }
  async function l() {
    return t.type === "event" ? await U5(t.event) : await X5();
  }
  function a() {
    const c = i.getDate();
    if (!c || o.disableEvents || !ot.isTemporal())
      return;
    const { element: p } = i, d = s(c) * n.scale._x + n.worldTransform.tx - p.width / 2, h = e.screen.height - p.height - r.eventBottomMargin;
    p.position.set(d, h);
  }
  return {
    ...i,
    render: u
  };
}
async function mI(t) {
  const e = await ro(), n = await eo();
  let r = await Wa();
  const o = await i();
  o.element.on("click", (l) => {
    l.stopPropagation();
    const { element: a } = o, c = a.getGlobalPosition(), p = {
      x: c.x,
      y: c.y,
      width: a.width * e.scale.x,
      height: a.height * e.scale.y
    }, d = sc(o) ? { kind: "events", ids: o.getIds(), occurred: o.getDate(), position: p } : { kind: "event", id: o.getId(), occurred: o.getDate(), position: p };
    wu(d);
  }), Ze.on("scaleUpdated", (l) => {
    r = l, u();
  });
  async function s(l) {
    await o.render(l), u();
  }
  async function i() {
    return t.type === "event" ? await U5(t.event) : await X5();
  }
  function u() {
    const l = o.getDate(), { parentStartDate: a } = t;
    if (!l || n.disableEvents || !ot.isTemporal() || !a)
      return;
    const { element: c } = o, p = r(l) - r(a) - c.width / 2, d = -c.height;
    c.position.set(p, d);
  }
  return {
    ...o,
    render: s
  };
}
async function EU({ isRoot: t, parentStartDate: e } = {}) {
  const n = await eo(), r = /* @__PURE__ */ new Map(), o = /* @__PURE__ */ new Map(), s = [];
  let i = [];
  const u = new fn();
  let l = null;
  Ze.on("scaleUpdated", () => p());
  async function a(m) {
    if (m && (l = m), !l)
      return;
    const g = [];
    for (const _ of l)
      g.push(c(_));
    await Promise.all(g), p();
  }
  async function c(m) {
    if (r.has(m.id))
      return r.get(m.id).render();
    if (o.has(m.id))
      return await o.get(m.id);
    const g = (async () => {
      const _ = t ? await fI({ type: "event", event: m }) : await mI({ type: "event", event: m, parentStartDate: e });
      r.set(m.id, _), u.addChild(_.element);
    })();
    return o.set(m.id, g), await g, o.delete(m.id), r.get(m.id).render();
  }
  function p() {
    n.disableEvents || !ot.isTemporal() || d();
  }
  const d = N5(async () => {
    i = [...s], await DU({
      items: r,
      createCluster: h
    });
    for (const m of i)
      m.render();
  }, $L);
  async function h() {
    if (i.length > 0)
      return i.pop();
    const m = t ? await fI({ type: "cluster" }) : await mI({ type: "cluster", parentStartDate: e });
    return u.addChild(m.element), s.push(m), m;
  }
  return {
    element: u,
    render: a,
    update: p
  };
}
let ux = null, om = null;
async function mCe() {
  const t = await no(), e = await oa(), n = await eo(), r = await ku(), { element: o, render: s, update: i } = await EU({ isRoot: !0 });
  o.zIndex = fwe;
  async function u(a) {
    if (!ot.isTemporal() || n.disableEvents) {
      t.stage.removeChild(o);
      return;
    }
    t.stage.addChild(o), await s(a);
  }
  const l = await O5(() => ({
    nodeId: e.runId,
    since: r.start_time,
    until: r.end_time ?? /* @__PURE__ */ new Date()
  }), (a) => {
    const c = om ? "eventDataUpdated" : "eventDataCreated";
    om = a, Ze.emit(c, om), u(a);
  });
  Ze.on("configUpdated", () => u()), Ze.on("viewportMoved", () => i()), Ze.on("layoutSettingsUpdated", () => u()), ux = l.stop, l.start();
}
function yCe() {
  ux?.(), ux = null, om = null;
}
async function gCe() {
  return om || await Is("eventDataCreated");
}
async function yI(t) {
  const e = await no(), n = await ro(), r = await wr(), o = await eo(), s = await gCe();
  let i = await Wa(), u = s && s.length > 0;
  const l = await c();
  l.element.on("click", (d) => {
    d.stopPropagation();
    const { element: h } = l, m = h.getGlobalPosition(), g = {
      x: m.x,
      y: m.y,
      width: h.width,
      height: h.height
    }, _ = sc(l) ? { kind: "artifacts", ids: l.getIds(), position: g } : { kind: "artifact", id: l.getId() };
    wu(_);
  }), Ze.on("scaleUpdated", (d) => {
    i = d, p();
  }), Ze.on("viewportMoved", () => p()), Ze.on("eventDataCreated", (d) => {
    u = d.length > 0, p();
  }), Ze.on("eventDataUpdated", (d) => {
    u = d.length > 0, p();
  });
  async function a(d) {
    if (C5(l)) {
      if (t.type !== "artifact")
        throw new Error(`ArtifactFactory attempted to render a ${t.type}`);
      await l.render(t.artifact);
    } else
      await l.render(d);
    p();
  }
  async function c() {
    return t.type === "artifact" ? await JS(t.artifact, { cullAtZoomThreshold: !1 }) : await L5();
  }
  function p() {
    const d = l.getDate();
    if (!d || !ot.isTemporal() || o.disableArtifacts)
      return;
    const h = l.getSelected(), { element: m } = l, { eventTargetSize: g, flowStateSelectedBarHeight: _ } = r;
    let b = 0;
    if (h) {
      const { selectedBorderOffset: A, selectedBorderWidth: C } = r;
      b = A + C * 2;
    }
    const x = i(d) * n.scale._x + n.worldTransform.tx - (m.width - b) / 2, S = u && !o.disableEvents ? g : _, E = e.screen.height - (m.height - b) - S;
    m.position.set(x, E);
  }
  return {
    ...l,
    render: a
  };
}
async function gI(t) {
  const e = await ro(), n = await wr(), r = await eo();
  let o = await Wa();
  const s = await u();
  s.element.on("click", (a) => {
    a.stopPropagation();
    const { element: c } = s, p = c.getGlobalPosition(), d = {
      x: p.x,
      y: p.y,
      width: c.width * e.scale.x,
      height: c.height * e.scale.y
    }, h = sc(s) ? { kind: "artifacts", ids: s.getIds(), position: d } : { kind: "artifact", id: s.getId() };
    wu(h);
  }), Ze.on("scaleUpdated", (a) => {
    o = a, l();
  });
  async function i(a) {
    if (C5(s)) {
      if (t.type !== "artifact")
        throw new Error(`ArtifactFactory attempted to render a ${t.type}`);
      await s.render(t.artifact);
    } else
      await s.render(a);
    l();
  }
  async function u() {
    return t.type === "artifact" ? await JS(t.artifact) : await L5();
  }
  function l() {
    const a = s.getDate(), { parentStartDate: c } = t;
    if (!a || !ot.isTemporal() || r.disableArtifacts || !c)
      return;
    const p = s.getSelected(), { element: d } = s;
    let h = 0;
    if (p) {
      const { selectedBorderOffset: _, selectedBorderWidth: b } = n;
      h = _ + b * 2;
    }
    const m = o(a) - o(c) - (d.width - h) / 2, g = -(d.height - h);
    d.position.set(m, g);
  }
  return {
    ...s,
    render: i
  };
}
async function MU({ isRoot: t, parentStartDate: e } = {}) {
  const n = await eo(), r = /* @__PURE__ */ new Map(), o = /* @__PURE__ */ new Map(), s = [];
  let i = [];
  const u = new fn();
  let l = null;
  async function a(m) {
    if (m && (l = m), !l)
      return;
    const g = [];
    for (const _ of l)
      g.push(c(_));
    await Promise.all(g), p();
  }
  async function c(m) {
    if (r.has(m.id))
      return r.get(m.id).render(m);
    o.has(m.id) && await o.get(m.id);
    const g = (async () => {
      const _ = t ? await yI({ type: "artifact", artifact: m }) : await gI({ type: "artifact", artifact: m, parentStartDate: e });
      r.set(m.id, _), u.addChild(_.element);
    })();
    return o.set(m.id, g), await g, o.delete(m.id), r.get(m.id).render(m);
  }
  function p() {
    if (!(n.disableArtifacts || !ot.isTemporal())) {
      if (!ot.isTemporal()) {
        u.visible = !1;
        return;
      }
      u.visible = !0, u.position.x = 0, d();
    }
  }
  const d = N5(async () => {
    i = [...s], await DU({
      items: r,
      createCluster: h
    });
    for (const m of i)
      m.render();
  }, $L);
  async function h() {
    if (i.length > 0)
      return i.pop();
    const m = t ? await yI({ type: "cluster" }) : await gI({ type: "cluster", parentStartDate: e });
    return u.addChild(m.element), s.push(m), m;
  }
  return {
    element: u,
    render: a,
    update: p
  };
}
async function vCe(t) {
  const e = await no(), n = await ro(), r = await wr(), o = await ku();
  let s = await Wa();
  const i = new fn(), u = await ll(), l = await ll();
  let a = null, c = !1, p = !1;
  e.stage.addChild(l), i.addChild(u), u.eventMode = "static", u.cursor = "pointer", u.on("mouseover", () => {
    c = !0, d();
  }), u.on("mouseleave", () => {
    c = !1, d();
  }), u.on("click", () => {
    const S = {
      x: u.position.x,
      y: u.position.y,
      width: u.width,
      height: u.height
    };
    wu({ ...t, kind: "state", position: S });
  }), Ze.on("viewportMoved", () => d()), Ze.on("scaleUpdated", (S) => {
    s = S, d();
  }), Ze.on("itemSelected", () => {
    const S = vl({ kind: "state", ...t });
    S !== p && (p = S, c = !1, d());
  }), t.type === "RUNNING" && !o.end_time && _();
  function d(S) {
    const { end: E } = S ?? {};
    if (E && (a = E), o.end_time && b(), !ot.isTemporal()) {
      l.visible = !1, i.visible = !1;
      return;
    }
    const A = h();
    m(A), g(A), l.visible = !0, i.visible = !0;
  }
  function h() {
    const { background: S = "#fff" } = r.state(t), E = Math.max(s(t.timestamp) * n.scale._x + n.worldTransform.tx, 0);
    let A = 0;
    return t.type === "RUNNING" && !o.end_time ? A = s(/* @__PURE__ */ new Date()) * n.scale._x + n.worldTransform.tx - E : a ? A = s(a) * n.scale._x + n.worldTransform.tx - E : A = e.screen.width - E, {
      x: E,
      width: Math.max(A, 0),
      background: S
    };
  }
  function m({ x: S, width: E, background: A }) {
    const { flowStateBarHeight: C, flowStateSelectedBarHeight: M } = r, L = c || p ? M : C;
    u.x = S, u.y = e.screen.height - L, u.width = E, u.height = L, u.tint = A;
  }
  function g({ x: S, width: E, background: A }) {
    if (t.type === "RUNNING") {
      l.visible = !1;
      return;
    }
    const { flowStateBarHeight: C, flowStateAreaAlpha: M } = r;
    l.x = S, l.y = 0, l.width = E, l.height = e.screen.height - C, l.tint = A, l.alpha = M;
  }
  function _() {
    e.ticker.add(x);
  }
  function b() {
    e.ticker.remove(x);
  }
  function x() {
    d();
  }
  return {
    element: i,
    render: d
  };
}
function _Ce(t) {
  return "isNodesFlowRunStateFactory" in t;
}
async function wCe(t) {
  const e = await no(), n = await ro(), r = await wr(), o = await ku();
  let s = await Wa();
  const i = new fn(), u = await ll(), l = await ll();
  let a = null, c = null, p = 0, d = 0, h = !1, m = !1;
  i.visible = !1, i.addChild(l), i.addChild(u), u.eventMode = "static", u.cursor = "pointer", u.on("mouseover", () => {
    h = !0, g();
  }), u.on("mouseleave", () => {
    h = !1, g();
  }), u.on("click", (C) => {
    C.stopPropagation();
    const M = u.getGlobalPosition(), L = {
      x: M.x,
      y: M.y,
      width: u.width * n.scale.x,
      height: u.height * n.scale.y
    };
    wu({ ...t, kind: "state", position: L });
  }), l.eventMode = "none", l.cursor = "default", Ze.on("scaleUpdated", (C) => {
    s = C, g();
  }), Ze.on("itemSelected", () => {
    const C = vl({ kind: "state", ...t });
    C !== m && (m = C, h = !1, g());
  }), t.type === "RUNNING" && !o.end_time && S();
  function g(C) {
    const { end: M, parentStartDate: L, width: X, height: te } = C ?? {};
    if (M && (a = M), L && (c = L), X && (p = X), te && (d = te), o.end_time && E(), !ot.isTemporal()) {
      i.visible = !1;
      return;
    }
    if (!c || p <= 0) {
      i.visible = !1;
      return;
    }
    const B = _();
    if (B.width <= 0) {
      i.visible = !1;
      return;
    }
    b(B), x(B), i.visible = !0;
  }
  function _() {
    const { background: C = "#fff" } = r.state(t);
    if (!c)
      return {
        x: 0,
        width: 0,
        background: C
      };
    const M = s(c);
    let L = s(t.timestamp) - M;
    if (L >= p)
      return {
        x: p,
        width: 0,
        background: C
      };
    L < 0 && (L = 0);
    let X = s(a ?? /* @__PURE__ */ new Date()) - M;
    X > p && (X = p);
    const te = Math.max(X - L, 0);
    return {
      x: L,
      width: te,
      background: C
    };
  }
  function b({ x: C, width: M, background: L }) {
    const { flowStateBarHeight: X, flowStateSelectedBarHeight: te } = r, B = h || m ? te : X;
    u.x = C, u.y = d - B, u.width = M, u.height = B, u.tint = L;
  }
  function x({ x: C, width: M, background: L }) {
    const { flowStateBarHeight: X, flowStateAreaAlpha: te, nodeHeight: B } = r, W = B / 2;
    l.x = C, l.y = W, l.width = M, l.height = d - X - W, l.tint = L, l.alpha = te;
  }
  function S() {
    e.ticker.add(A);
  }
  function E() {
    e.ticker.remove(A);
  }
  function A() {
    g();
  }
  return {
    element: i,
    render: g,
    isNodesFlowRunStateFactory: !0
  };
}
function PU({ isRoot: t } = {}) {
  const e = new fn(), n = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Map();
  let o = null;
  async function s(u, l) {
    if (u && (o = u), !o)
      return;
    const a = [];
    for (let c = 0; c < o.length; c++)
      a.push(i(o[c], c, l));
    await Promise.all(a);
  }
  async function i(u, l, a) {
    const c = o && o.length >= l + 1 && o[l + 1], p = c ? c.timestamp : void 0;
    let d;
    if (r.has(u.id) && await r.get(u.id), n.has(u.id))
      d = n.get(u.id);
    else {
      const h = (async () => {
        const m = t ? await vCe(u) : await wCe(u);
        n.set(u.id, m), e.addChild(m.element);
      })();
      r.set(u.id, h), await h, r.delete(u.id), d = n.get(u.id);
    }
    _Ce(d) ? await d.render({ end: p, ...a }) : await d.render(p ? { end: p } : void 0);
  }
  return {
    element: e,
    render: s
  };
}
class CU extends fn {
  updateTransform() {
    this.sortableChildren && this.sortDirty && this.sortChildren(), this._boundsID++, this.transform.updateTransform(this.parent.transform), this.worldAlpha = this.alpha * this.parent.worldAlpha;
    for (let e = 0, n = this.children.length; e < n; ++e)
      this.children[e].updateTransform();
  }
  calculateBounds() {
    this._bounds.clear(), this._calculateBounds();
    for (const e of this.children)
      if (e.calculateBounds(), e._mask) {
        const n = e._mask.isMaskData ? e._mask.maskObject : e._mask;
        n ? (n.calculateBounds(), this._bounds.addBoundsMask(e._bounds, n._bounds)) : this._bounds.addBounds(e._bounds);
      } else e.filterArea ? this._bounds.addBoundsArea(e._bounds, e.filterArea) : this._bounds.addBounds(e._bounds);
    this._bounds.updateID = this._boundsID;
  }
}
async function bCe(t) {
  const e = new CU(), n = await oa(), r = await wr(), o = await eo(), { element: s, render: i } = await F5(), { element: u, render: l } = await ew(), { element: a, render: c } = await I5(), { element: p, render: d } = await Z_(), { element: h, render: m, getSize: g, stopWorker: _ } = await mR(), { element: b, render: x } = await PU(), { element: S, render: E, update: A } = await EU({ parentStartDate: t.start_time }), { element: C, render: M, update: L } = await MU({ parentStartDate: t.start_time });
  let X = !1, te = !1, B = t, W = !1;
  e.sortableChildren = !0, p.zIndex = WL, s.zIndex = HL, u.zIndex = nv, a.zIndex = nv, h.zIndex = VL, S.zIndex = gwe, b.zIndex = vwe, C.zIndex = _we, p.eventMode = "none", p.cursor = "default";
  const { start: G, stop: ne } = await S6(B.id, (fe) => {
    te = !!fe.artifacts && fe.artifacts.length > 0, m(fe), Z(fe.states), oe(fe.artifacts), ae();
  }), { start: de, stop: V } = await O5(() => ({
    nodeId: B.id,
    since: B.start_time,
    until: B.end_time ?? /* @__PURE__ */ new Date()
  }), (fe) => {
    X = fe.length > 0, J(fe);
  });
  e.addChild(s), e.addChild(u), e.addChild(a), a.on("click", (fe) => {
    fe.stopPropagation(), Q();
  }), h.position = { x: 0, y: r.nodeHeight + r.nodesPadding }, h.on("rendered", () => {
    yy(), Ie();
  });
  async function Y(fe) {
    return B = fe, await i(fe), await pe(), await Be(), W && (await Z(), await J(), await oe(), await ae()), e;
  }
  async function Q() {
    W ? await me() : await ue();
  }
  async function ae() {
    const { background: fe = "#fff" } = r.node(B), { width: Te, height: Ae } = g(), { height: we } = Me(), { nodeBorderRadius: $e } = r, ze = 2;
    p.position = { x: -ze, y: -ze };
    const Ue = ot.isTemporal() ? we + ze * 2 : Ae + ze * 2;
    await d({
      width: Te + ze * 2,
      height: Ue,
      stroke: ze,
      radius: [$e, $e, 0, 0],
      color: fe
    });
  }
  async function Z(fe) {
    const { height: Te } = Me(), { width: Ae } = s;
    await x(fe ?? void 0, {
      parentStartDate: B.start_time,
      width: Ae,
      height: Te
    });
  }
  async function J(fe) {
    if (!W || !ot.isTemporal() || o.disableEvents) {
      e.removeChild(S);
      return;
    }
    e.addChild(S);
    const { height: Te } = Me();
    if (S.position = { x: 0, y: Te - r.eventBottomMargin }, fe) {
      await E(fe);
      return;
    }
    await A();
  }
  async function oe(fe) {
    if (!W || !ot.isTemporal() || o.disableArtifacts) {
      e.removeChild(C);
      return;
    }
    e.addChild(C);
    const { eventTargetSize: Te, flowStateSelectedBarHeight: Ae } = r, { height: we } = Me(), $e = we - (X && !o.disableEvents ? Te : Ae);
    if (C.position = { x: 0, y: $e }, fe) {
      await M(fe);
      return;
    }
    await L();
  }
  async function ue() {
    W = !0, e.addChild(b), e.addChild(h), e.addChild(p), await Promise.all([
      G(),
      de(),
      Y(B)
    ]), Ie();
  }
  async function me() {
    W = !1, e.removeChild(b), e.removeChild(h), e.removeChild(p), e.removeChild(S), e.removeChild(C), _(), await Promise.all([
      ne(),
      V(),
      Y(B)
    ]), Ie();
  }
  async function pe() {
    const fe = r.nodeToggleSize, Te = r.nodeHeight - fe, Ae = s.width > fe, we = await c({
      inside: Ae,
      isOpen: W
    });
    return we.x = Ae ? Te / 2 : s.width + r.nodePadding, we.y = Te / 2, we;
  }
  async function Be() {
    const fe = await l(B.label), Te = n.theme === "dark" ? r.textDefault : r.textInverse, Ae = r.nodePadding, we = a.x + a.width + Ae, $e = s.width + Ae, ze = s.width > we + fe.width + Ae, Ue = r.nodeHeight / 2 - fe.height / 2, tt = ze ? we : Math.max($e, we);
    return fe.position = { x: tt, y: Ue }, fe.tint = ze ? Te : r.textDefault, fe;
  }
  function Ie() {
    W && (Z(), J(), oe(), ae());
    const fe = Me();
    e.emit("resized", fe);
  }
  function Me() {
    const fe = g(), {
      nodeHeight: Te,
      nodesPadding: Ae,
      eventTargetSize: we,
      eventBottomMargin: $e,
      artifactPaddingY: ze,
      artifactIconSize: Ue
    } = r, tt = te && ot.isTemporal() && !o.disableArtifacts ? Ue + ze * 2 : 0, Ot = X && ot.isTemporal() && !o.disableEvents ? we + $e : 0, cn = W ? fe.height + tt + Ot + Ae * 2 : 0, Xr = W ? fe.width : 0;
    return {
      height: Te + cn,
      width: Math.max(Xr, e.width)
    };
  }
  return {
    kind: "flow-run",
    element: e,
    bar: s,
    render: Y
  };
}
async function kCe(t, e) {
  const n = await oa(), r = await wr(), o = new CU(), { element: s, render: i } = await ew(), { element: u, render: l } = await Z_(), { element: a, render: c } = await F5(), { element: p, render: d } = await I5(), { element: h, render: m, getSize: g, stopWorker: _ } = await mR();
  o.addChild(a), o.addChild(s);
  let b = !1, x = t, S = e;
  o.sortableChildren = !0, u.zIndex = WL, a.zIndex = HL, s.zIndex = nv, p.zIndex = nv, h.zIndex = VL, u.eventMode = "none", u.cursor = "default", h.position = { x: 0, y: r.nodeHeight + r.nodesPadding }, h.on("rendered", () => {
    yy(), W();
  }), p.on("click", (G) => {
    G.stopPropagation(), L();
  });
  async function E(G, ne) {
    return x = G, S = ne, ne && o.addChild(p), await c(G), ne && await A(), b && (ne && m(ne), await M()), await C(), o;
  }
  async function A() {
    const G = r.nodeToggleSize, ne = r.nodeHeight - G, de = a.width > G, V = await d({
      inside: de,
      isOpen: b
    });
    return V.x = de ? ne / 2 : a.width + r.nodePadding, V.y = ne / 2, V;
  }
  async function C() {
    const G = await i(x.label), ne = n.theme === "dark" ? r.textDefault : r.textInverse, de = r.nodePadding, V = p.x + p.width + de, Y = a.width + de, Q = a.width > V + G.width + de, ae = r.nodeHeight / 2 - G.height / 2, Z = Q ? V : Math.max(Y, V);
    return G.position = { x: Z, y: ae }, G.tint = Q ? ne : r.textDefault, G;
  }
  async function M() {
    const { background: G = "#fff" } = r.node(x), { width: ne, height: de } = g(), { height: V } = B(), { nodeBorderRadius: Y } = r, Q = 2;
    u.position = { x: -Q, y: -Q };
    const ae = ot.isTemporal() ? V + Q * 2 : de + Q * 2;
    await l({
      width: ne + Q * 2,
      height: ae,
      stroke: Q,
      radius: [Y, Y, 0, 0],
      color: G
    });
  }
  async function L() {
    b ? await te() : await X();
  }
  async function X() {
    if (b = !0, o.addChild(h), o.addChild(u), !S)
      throw new Error("Attempted to open without nested graph data");
    await Promise.all([
      m(S),
      E(x, S)
    ]), W();
  }
  async function te() {
    b = !1, o.removeChild(h), o.removeChild(u), _(), await E(x, S), W();
  }
  function B() {
    const G = g(), {
      nodeHeight: ne,
      nodesPadding: de
    } = r, V = b ? G.height + de * 2 : 0, Y = b ? G.width : 0;
    return {
      height: ne + V,
      width: Math.max(Y, o.width)
    };
  }
  function W() {
    b && M();
    const G = B();
    o.emit("resized", G);
  }
  return {
    kind: "task-run",
    element: o,
    render: E,
    bar: a
  };
}
async function TCe(t, e) {
  const n = await oa(), r = await wr(), o = await no(), s = await NU(), i = await eo();
  let u = null;
  const l = /* @__PURE__ */ new Map(), { animate: a } = await D5(), { element: c, render: p, bar: d } = await te(t, e);
  let h = t, m = e, g = null, _ = !1, b = !1;
  s.add(c), c.eventMode = "static", c.cursor = "pointer", c.name = owe, c.on("click", (G) => {
    G.stopPropagation(), wu({ kind: h.kind, id: h.id });
  }), h.end_time || M(), Ze.on("itemSelected", () => {
    const G = vl({ kind: h.kind, id: h.id });
    G !== _ && (_ = G, p(h, m));
  });
  async function x(G, ne) {
    h = G, m = ne;
    const de = B(G);
    return de === g || (g = de, await Promise.all([
      p(G, ne),
      S(G.artifacts)
    ]), G.end_time && L()), c;
  }
  async function S(G) {
    if (!G || (A(), i.disableArtifacts || !ot.isTemporal()))
      return;
    const ne = [];
    for (const de of G)
      ne.push(E(de));
    await Promise.all(ne), C();
  }
  async function E(G) {
    if (l.has(G.id))
      return l.get(G.id).render(G);
    const ne = await JS(G, { enableLocalClickHandling: !0 });
    return l.set(G.id, ne), u.addChild(ne.element), ne.render(G);
  }
  function A() {
    if (ot.isTemporal() && !i.disableArtifacts) {
      u || (u = new fn()), c.addChild(u);
      return;
    }
    u && c.removeChild(u);
  }
  function C() {
    if (!u)
      return;
    const { artifactsGap: G, artifactsNodeOverlap: ne } = r;
    let de = 0;
    for (const V of l.values())
      V.element.position.x = de, de += V.element.width + G;
    u.position.y = -u.height + ne, u.width < d.width && (u.position.x = d.width - u.width);
  }
  function M() {
    o.ticker.add(X);
  }
  function L() {
    o.ticker.remove(X);
  }
  function X() {
    x(h, m);
  }
  async function te(G, ne) {
    const { kind: de } = G;
    switch (de) {
      case "task-run":
        return await kCe(G, ne);
      case "flow-run":
        return await bCe(G);
      default:
        const V = de;
        throw new Error(`switch does not have case for value: ${V}`);
    }
  }
  function B(G) {
    const ne = G.end_time ?? /* @__PURE__ */ new Date(), de = G.artifacts?.map((Y) => Y.type === "progress" ? `${Y.id}-${Y.data}` : Y.id).join("|"), V = !!m;
    return [
      G.state_type,
      ne.getTime(),
      ot.horizontal,
      ot.horizontalScaleMultiplier,
      n.theme,
      i.disableArtifacts || de,
      V
    ].join("-");
  }
  function W({ x: G, y: ne }) {
    a(c, {
      x: G,
      y: ne
    }, !b), b = !0;
  }
  return {
    element: c,
    render: x,
    bar: d,
    setPosition: W
  };
}
function vI({ gap: t = 0, minimum: e = 0 } = {}) {
  const n = /* @__PURE__ */ new Map();
  function r(c) {
    const p = n.get(c) ?? [];
    return Math.max(...p.values(), m0(e)) + m0(t);
  }
  function o(c) {
    let p = 0;
    for (let d = 0; d < c; d++)
      p += r(d);
    return p;
  }
  function s(c) {
    return o(c + 1) - m0(t);
  }
  function i({ axis: c, nodeId: p, offset: d }) {
    const h = n.get(c) ?? /* @__PURE__ */ new Map();
    h.set(p, d), n.set(c, h);
  }
  function u({ axis: c, nodeId: p }) {
    let d, h;
    for (const [m, g] of n.entries())
      if (g.has(p)) {
        d = m, h = g.get(p);
        break;
      }
    d === c || d === void 0 || h === void 0 || (l({ axis: d, nodeId: p }), i({ axis: c, nodeId: p, offset: h }));
  }
  function l({ axis: c, nodeId: p }) {
    n.get(c)?.delete(p);
  }
  function a() {
    n.clear();
  }
  return {
    getOffset: r,
    getTotalOffset: o,
    getTotalValue: s,
    setOffset: i,
    updateNodeAxis: u,
    removeOffset: l,
    clear: a
  };
}
function xCe(t) {
  throw new Error(`switch does not have case for value: ${t}`);
}
const OU = '(function(){"use strict";function sr(t){throw new Error(`switch does not have case for value: ${t}`)}function Ht(t,n){return t==null||n==null?NaN:t<n?-1:t>n?1:t>=n?0:NaN}function cr(t,n){return t==null||n==null?NaN:n<t?-1:n>t?1:n>=t?0:NaN}function cn(t){let n,e,r;t.length!==2?(n=Ht,e=(u,c)=>Ht(t(u),c),r=(u,c)=>t(u)-c):(n=t===Ht||t===cr?t:fr,e=t,r=t);function i(u,c,s=0,f=u.length){if(s<f){if(n(c,c)!==0)return f;do{const l=s+f>>>1;e(u[l],c)<0?s=l+1:f=l}while(s<f)}return s}function o(u,c,s=0,f=u.length){if(s<f){if(n(c,c)!==0)return f;do{const l=s+f>>>1;e(u[l],c)<=0?s=l+1:f=l}while(s<f)}return s}function a(u,c,s=0,f=u.length){const l=i(u,c,s,f-1);return l>s&&r(u[l-1],c)>-r(u[l],c)?l-1:l}return{left:i,center:a,right:o}}function fr(){return 0}function lr(t){return t===null?NaN:+t}const hr=cn(Ht).right;cn(lr).center;const gr=Math.sqrt(50),dr=Math.sqrt(10),mr=Math.sqrt(2);function Yt(t,n,e){const r=(n-t)/Math.max(0,e),i=Math.floor(Math.log10(r)),o=r/Math.pow(10,i),a=o>=gr?10:o>=dr?5:o>=mr?2:1;let u,c,s;return i<0?(s=Math.pow(10,-i)/a,u=Math.round(t*s),c=Math.round(n*s),u/s<t&&++u,c/s>n&&--c,s=-s):(s=Math.pow(10,i)*a,u=Math.round(t/s),c=Math.round(n/s),u*s<t&&++u,c*s>n&&--c),c<u&&.5<=e&&e<2?Yt(t,n,e*2):[u,c,s]}function pr(t,n,e){if(n=+n,t=+t,e=+e,!(e>0))return[];if(t===n)return[t];const r=n<t,[i,o,a]=r?Yt(n,t,e):Yt(t,n,e);if(!(o>=i))return[];const u=o-i+1,c=new Array(u);if(r)if(a<0)for(let s=0;s<u;++s)c[s]=(o-s)/-a;else for(let s=0;s<u;++s)c[s]=(o-s)*a;else if(a<0)for(let s=0;s<u;++s)c[s]=(i+s)/-a;else for(let s=0;s<u;++s)c[s]=(i+s)*a;return c}function fn(t,n,e){return n=+n,t=+t,e=+e,Yt(t,n,e)[2]}function ln(t,n,e){n=+n,t=+t,e=+e;const r=n<t,i=r?fn(n,t,e):fn(t,n,e);return(r?-1:1)*(i<0?1/-i:i)}var yr={value:()=>{}};function zn(){for(var t=0,n=arguments.length,e={},r;t<n;++t){if(!(r=arguments[t]+"")||r in e||/[\\s.]/.test(r))throw new Error("illegal type: "+r);e[r]=[]}return new Rt(e)}function Rt(t){this._=t}function wr(t,n){return t.trim().split(/^|\\s+/).map(function(e){var r="",i=e.indexOf(".");if(i>=0&&(r=e.slice(i+1),e=e.slice(0,i)),e&&!n.hasOwnProperty(e))throw new Error("unknown type: "+e);return{type:e,name:r}})}Rt.prototype=zn.prototype={constructor:Rt,on:function(t,n){var e=this._,r=wr(t+"",e),i,o=-1,a=r.length;if(arguments.length<2){for(;++o<a;)if((i=(t=r[o]).type)&&(i=vr(e[i],t.name)))return i;return}if(n!=null&&typeof n!="function")throw new Error("invalid callback: "+n);for(;++o<a;)if(i=(t=r[o]).type)e[i]=Xn(e[i],t.name,n);else if(n==null)for(i in e)e[i]=Xn(e[i],t.name,null);return this},copy:function(){var t={},n=this._;for(var e in n)t[e]=n[e].slice();return new Rt(t)},call:function(t,n){if((i=arguments.length-2)>0)for(var e=new Array(i),r=0,i,o;r<i;++r)e[r]=arguments[r+2];if(!this._.hasOwnProperty(t))throw new Error("unknown type: "+t);for(o=this._[t],r=0,i=o.length;r<i;++r)o[r].value.apply(n,e)},apply:function(t,n,e){if(!this._.hasOwnProperty(t))throw new Error("unknown type: "+t);for(var r=this._[t],i=0,o=r.length;i<o;++i)r[i].value.apply(n,e)}};function vr(t,n){for(var e=0,r=t.length,i;e<r;++e)if((i=t[e]).name===n)return i.value}function Xn(t,n,e){for(var r=0,i=t.length;r<i;++r)if(t[r].name===n){t[r]=yr,t=t.slice(0,r).concat(t.slice(r+1));break}return e!=null&&t.push({name:n,value:e}),t}var hn="http://www.w3.org/1999/xhtml",qn={svg:"http://www.w3.org/2000/svg",xhtml:hn,xlink:"http://www.w3.org/1999/xlink",xml:"http://www.w3.org/XML/1998/namespace",xmlns:"http://www.w3.org/2000/xmlns/"};function It(t){var n=t+="",e=n.indexOf(":");return e>=0&&(n=t.slice(0,e))!=="xmlns"&&(t=t.slice(e+1)),qn.hasOwnProperty(n)?{space:qn[n],local:t}:t}function xr(t){return function(){var n=this.ownerDocument,e=this.namespaceURI;return e===hn&&n.documentElement.namespaceURI===hn?n.createElement(t):n.createElementNS(e,t)}}function _r(t){return function(){return this.ownerDocument.createElementNS(t.space,t.local)}}function Vn(t){var n=It(t);return(n.local?_r:xr)(n)}function Mr(){}function gn(t){return t==null?Mr:function(){return this.querySelector(t)}}function Tr(t){typeof t!="function"&&(t=gn(t));for(var n=this._groups,e=n.length,r=new Array(e),i=0;i<e;++i)for(var o=n[i],a=o.length,u=r[i]=new Array(a),c,s,f=0;f<a;++f)(c=o[f])&&(s=t.call(c,c.__data__,f,o))&&("__data__"in c&&(s.__data__=c.__data__),u[f]=s);return new X(r,this._parents)}function Nr(t){return t==null?[]:Array.isArray(t)?t:Array.from(t)}function Cr(){return[]}function Bn(t){return t==null?Cr:function(){return this.querySelectorAll(t)}}function br(t){return function(){return Nr(t.apply(this,arguments))}}function Sr(t){typeof t=="function"?t=br(t):t=Bn(t);for(var n=this._groups,e=n.length,r=[],i=[],o=0;o<e;++o)for(var a=n[o],u=a.length,c,s=0;s<u;++s)(c=a[s])&&(r.push(t.call(c,c.__data__,s,a)),i.push(c));return new X(r,i)}function Zn(t){return function(){return this.matches(t)}}function Gn(t){return function(n){return n.matches(t)}}var Dr=Array.prototype.find;function kr(t){return function(){return Dr.call(this.children,t)}}function Ar(){return this.firstElementChild}function Ur(t){return this.select(t==null?Ar:kr(typeof t=="function"?t:Gn(t)))}var Fr=Array.prototype.filter;function $r(){return Array.from(this.children)}function Lr(t){return function(){return Fr.call(this.children,t)}}function Pr(t){return this.selectAll(t==null?$r:Lr(typeof t=="function"?t:Gn(t)))}function Er(t){typeof t!="function"&&(t=Zn(t));for(var n=this._groups,e=n.length,r=new Array(e),i=0;i<e;++i)for(var o=n[i],a=o.length,u=r[i]=[],c,s=0;s<a;++s)(c=o[s])&&t.call(c,c.__data__,s,o)&&u.push(c);return new X(r,this._parents)}function Qn(t){return new Array(t.length)}function Hr(){return new X(this._enter||this._groups.map(Qn),this._parents)}function Ot(t,n){this.ownerDocument=t.ownerDocument,this.namespaceURI=t.namespaceURI,this._next=null,this._parent=t,this.__data__=n}Ot.prototype={constructor:Ot,appendChild:function(t){return this._parent.insertBefore(t,this._next)},insertBefore:function(t,n){return this._parent.insertBefore(t,n)},querySelector:function(t){return this._parent.querySelector(t)},querySelectorAll:function(t){return this._parent.querySelectorAll(t)}};function Yr(t){return function(){return t}}function Rr(t,n,e,r,i,o){for(var a=0,u,c=n.length,s=o.length;a<s;++a)(u=n[a])?(u.__data__=o[a],r[a]=u):e[a]=new Ot(t,o[a]);for(;a<c;++a)(u=n[a])&&(i[a]=u)}function Ir(t,n,e,r,i,o,a){var u,c,s=new Map,f=n.length,l=o.length,h=new Array(f),p;for(u=0;u<f;++u)(c=n[u])&&(h[u]=p=a.call(c,c.__data__,u,n)+"",s.has(p)?i[u]=c:s.set(p,c));for(u=0;u<l;++u)p=a.call(t,o[u],u,o)+"",(c=s.get(p))?(r[u]=c,c.__data__=o[u],s.delete(p)):e[u]=new Ot(t,o[u]);for(u=0;u<f;++u)(c=n[u])&&s.get(h[u])===c&&(i[u]=c)}function Or(t){return t.__data__}function Wr(t,n){if(!arguments.length)return Array.from(this,Or);var e=n?Ir:Rr,r=this._parents,i=this._groups;typeof t!="function"&&(t=Yr(t));for(var o=i.length,a=new Array(o),u=new Array(o),c=new Array(o),s=0;s<o;++s){var f=r[s],l=i[s],h=l.length,p=zr(t.call(f,f&&f.__data__,s,r)),x=p.length,b=u[s]=new Array(x),U=a[s]=new Array(x),I=c[s]=new Array(h);e(f,l,b,U,I,p,n);for(var E=0,k=0,H,m;E<x;++E)if(H=b[E]){for(E>=k&&(k=E+1);!(m=U[k])&&++k<x;);H._next=m||null}}return a=new X(a,r),a._enter=u,a._exit=c,a}function zr(t){return typeof t=="object"&&"length"in t?t:Array.from(t)}function Xr(){return new X(this._exit||this._groups.map(Qn),this._parents)}function qr(t,n,e){var r=this.enter(),i=this,o=this.exit();return typeof t=="function"?(r=t(r),r&&(r=r.selection())):r=r.append(t+""),n!=null&&(i=n(i),i&&(i=i.selection())),e==null?o.remove():e(o),r&&i?r.merge(i).order():i}function Vr(t){for(var n=t.selection?t.selection():t,e=this._groups,r=n._groups,i=e.length,o=r.length,a=Math.min(i,o),u=new Array(i),c=0;c<a;++c)for(var s=e[c],f=r[c],l=s.length,h=u[c]=new Array(l),p,x=0;x<l;++x)(p=s[x]||f[x])&&(h[x]=p);for(;c<i;++c)u[c]=e[c];return new X(u,this._parents)}function Br(){for(var t=this._groups,n=-1,e=t.length;++n<e;)for(var r=t[n],i=r.length-1,o=r[i],a;--i>=0;)(a=r[i])&&(o&&a.compareDocumentPosition(o)^4&&o.parentNode.insertBefore(a,o),o=a);return this}function Zr(t){t||(t=Gr);function n(l,h){return l&&h?t(l.__data__,h.__data__):!l-!h}for(var e=this._groups,r=e.length,i=new Array(r),o=0;o<r;++o){for(var a=e[o],u=a.length,c=i[o]=new Array(u),s,f=0;f<u;++f)(s=a[f])&&(c[f]=s);c.sort(n)}return new X(i,this._parents).order()}function Gr(t,n){return t<n?-1:t>n?1:t>=n?0:NaN}function Qr(){var t=arguments[0];return arguments[0]=this,t.apply(null,arguments),this}function Jr(){return Array.from(this)}function Kr(){for(var t=this._groups,n=0,e=t.length;n<e;++n)for(var r=t[n],i=0,o=r.length;i<o;++i){var a=r[i];if(a)return a}return null}function jr(){let t=0;for(const n of this)++t;return t}function ti(){return!this.node()}function ni(t){for(var n=this._groups,e=0,r=n.length;e<r;++e)for(var i=n[e],o=0,a=i.length,u;o<a;++o)(u=i[o])&&t.call(u,u.__data__,o,i);return this}function ei(t){return function(){this.removeAttribute(t)}}function ri(t){return function(){this.removeAttributeNS(t.space,t.local)}}function ii(t,n){return function(){this.setAttribute(t,n)}}function oi(t,n){return function(){this.setAttributeNS(t.space,t.local,n)}}function ai(t,n){return function(){var e=n.apply(this,arguments);e==null?this.removeAttribute(t):this.setAttribute(t,e)}}function ui(t,n){return function(){var e=n.apply(this,arguments);e==null?this.removeAttributeNS(t.space,t.local):this.setAttributeNS(t.space,t.local,e)}}function si(t,n){var e=It(t);if(arguments.length<2){var r=this.node();return e.local?r.getAttributeNS(e.space,e.local):r.getAttribute(e)}return this.each((n==null?e.local?ri:ei:typeof n=="function"?e.local?ui:ai:e.local?oi:ii)(e,n))}function Jn(t){return t.ownerDocument&&t.ownerDocument.defaultView||t.document&&t||t.defaultView}function ci(t){return function(){this.style.removeProperty(t)}}function fi(t,n,e){return function(){this.style.setProperty(t,n,e)}}function li(t,n,e){return function(){var r=n.apply(this,arguments);r==null?this.style.removeProperty(t):this.style.setProperty(t,r,e)}}function hi(t,n,e){return arguments.length>1?this.each((n==null?ci:typeof n=="function"?li:fi)(t,n,e??"")):lt(this.node(),t)}function lt(t,n){return t.style.getPropertyValue(n)||Jn(t).getComputedStyle(t,null).getPropertyValue(n)}function gi(t){return function(){delete this[t]}}function di(t,n){return function(){this[t]=n}}function mi(t,n){return function(){var e=n.apply(this,arguments);e==null?delete this[t]:this[t]=e}}function pi(t,n){return arguments.length>1?this.each((n==null?gi:typeof n=="function"?mi:di)(t,n)):this.node()[t]}function Kn(t){return t.trim().split(/^|\\s+/)}function dn(t){return t.classList||new jn(t)}function jn(t){this._node=t,this._names=Kn(t.getAttribute("class")||"")}jn.prototype={add:function(t){var n=this._names.indexOf(t);n<0&&(this._names.push(t),this._node.setAttribute("class",this._names.join(" ")))},remove:function(t){var n=this._names.indexOf(t);n>=0&&(this._names.splice(n,1),this._node.setAttribute("class",this._names.join(" ")))},contains:function(t){return this._names.indexOf(t)>=0}};function te(t,n){for(var e=dn(t),r=-1,i=n.length;++r<i;)e.add(n[r])}function ne(t,n){for(var e=dn(t),r=-1,i=n.length;++r<i;)e.remove(n[r])}function yi(t){return function(){te(this,t)}}function wi(t){return function(){ne(this,t)}}function vi(t,n){return function(){(n.apply(this,arguments)?te:ne)(this,t)}}function xi(t,n){var e=Kn(t+"");if(arguments.length<2){for(var r=dn(this.node()),i=-1,o=e.length;++i<o;)if(!r.contains(e[i]))return!1;return!0}return this.each((typeof n=="function"?vi:n?yi:wi)(e,n))}function _i(){this.textContent=""}function Mi(t){return function(){this.textContent=t}}function Ti(t){return function(){var n=t.apply(this,arguments);this.textContent=n??""}}function Ni(t){return arguments.length?this.each(t==null?_i:(typeof t=="function"?Ti:Mi)(t)):this.node().textContent}function Ci(){this.innerHTML=""}function bi(t){return function(){this.innerHTML=t}}function Si(t){return function(){var n=t.apply(this,arguments);this.innerHTML=n??""}}function Di(t){return arguments.length?this.each(t==null?Ci:(typeof t=="function"?Si:bi)(t)):this.node().innerHTML}function ki(){this.nextSibling&&this.parentNode.appendChild(this)}function Ai(){return this.each(ki)}function Ui(){this.previousSibling&&this.parentNode.insertBefore(this,this.parentNode.firstChild)}function Fi(){return this.each(Ui)}function $i(t){var n=typeof t=="function"?t:Vn(t);return this.select(function(){return this.appendChild(n.apply(this,arguments))})}function Li(){return null}function Pi(t,n){var e=typeof t=="function"?t:Vn(t),r=n==null?Li:typeof n=="function"?n:gn(n);return this.select(function(){return this.insertBefore(e.apply(this,arguments),r.apply(this,arguments)||null)})}function Ei(){var t=this.parentNode;t&&t.removeChild(this)}function Hi(){return this.each(Ei)}function Yi(){var t=this.cloneNode(!1),n=this.parentNode;return n?n.insertBefore(t,this.nextSibling):t}function Ri(){var t=this.cloneNode(!0),n=this.parentNode;return n?n.insertBefore(t,this.nextSibling):t}function Ii(t){return this.select(t?Ri:Yi)}function Oi(t){return arguments.length?this.property("__data__",t):this.node().__data__}function Wi(t){return function(n){t.call(this,n,this.__data__)}}function zi(t){return t.trim().split(/^|\\s+/).map(function(n){var e="",r=n.indexOf(".");return r>=0&&(e=n.slice(r+1),n=n.slice(0,r)),{type:n,name:e}})}function Xi(t){return function(){var n=this.__on;if(n){for(var e=0,r=-1,i=n.length,o;e<i;++e)o=n[e],(!t.type||o.type===t.type)&&o.name===t.name?this.removeEventListener(o.type,o.listener,o.options):n[++r]=o;++r?n.length=r:delete this.__on}}}function qi(t,n,e){return function(){var r=this.__on,i,o=Wi(n);if(r){for(var a=0,u=r.length;a<u;++a)if((i=r[a]).type===t.type&&i.name===t.name){this.removeEventListener(i.type,i.listener,i.options),this.addEventListener(i.type,i.listener=o,i.options=e),i.value=n;return}}this.addEventListener(t.type,o,e),i={type:t.type,name:t.name,value:n,listener:o,options:e},r?r.push(i):this.__on=[i]}}function Vi(t,n,e){var r=zi(t+""),i,o=r.length,a;if(arguments.length<2){var u=this.node().__on;if(u){for(var c=0,s=u.length,f;c<s;++c)for(i=0,f=u[c];i<o;++i)if((a=r[i]).type===f.type&&a.name===f.name)return f.value}return}for(u=n?qi:Xi,i=0;i<o;++i)this.each(u(r[i],n,e));return this}function ee(t,n,e){var r=Jn(t),i=r.CustomEvent;typeof i=="function"?i=new i(n,e):(i=r.document.createEvent("Event"),e?(i.initEvent(n,e.bubbles,e.cancelable),i.detail=e.detail):i.initEvent(n,!1,!1)),t.dispatchEvent(i)}function Bi(t,n){return function(){return ee(this,t,n)}}function Zi(t,n){return function(){return ee(this,t,n.apply(this,arguments))}}function Gi(t,n){return this.each((typeof n=="function"?Zi:Bi)(t,n))}function*Qi(){for(var t=this._groups,n=0,e=t.length;n<e;++n)for(var r=t[n],i=0,o=r.length,a;i<o;++i)(a=r[i])&&(yield a)}var Ji=[null];function X(t,n){this._groups=t,this._parents=n}function Nt(){return new X([[document.documentElement]],Ji)}function Ki(){return this}X.prototype=Nt.prototype={constructor:X,select:Tr,selectAll:Sr,selectChild:Ur,selectChildren:Pr,filter:Er,data:Wr,enter:Hr,exit:Xr,join:qr,merge:Vr,selection:Ki,order:Br,sort:Zr,call:Qr,nodes:Jr,node:Kr,size:jr,empty:ti,each:ni,attr:si,style:hi,property:pi,classed:xi,text:Ni,html:Di,raise:Ai,lower:Fi,append:$i,insert:Pi,remove:Hi,clone:Ii,datum:Oi,on:Vi,dispatch:Gi,[Symbol.iterator]:Qi};function mn(t,n,e){t.prototype=n.prototype=e,e.constructor=t}function re(t,n){var e=Object.create(t.prototype);for(var r in n)e[r]=n[r];return e}function Ct(){}var bt=.7,Wt=1/bt,ht="\\\\s*([+-]?\\\\d+)\\\\s*",St="\\\\s*([+-]?(?:\\\\d*\\\\.)?\\\\d+(?:[eE][+-]?\\\\d+)?)\\\\s*",G="\\\\s*([+-]?(?:\\\\d*\\\\.)?\\\\d+(?:[eE][+-]?\\\\d+)?)%\\\\s*",ji=/^#([0-9a-f]{3,8})$/,to=new RegExp(`^rgb\\\\(${ht},${ht},${ht}\\\\)$`),no=new RegExp(`^rgb\\\\(${G},${G},${G}\\\\)$`),eo=new RegExp(`^rgba\\\\(${ht},${ht},${ht},${St}\\\\)$`),ro=new RegExp(`^rgba\\\\(${G},${G},${G},${St}\\\\)$`),io=new RegExp(`^hsl\\\\(${St},${G},${G}\\\\)$`),oo=new RegExp(`^hsla\\\\(${St},${G},${G},${St}\\\\)$`),ie={aliceblue:15792383,antiquewhite:16444375,aqua:65535,aquamarine:8388564,azure:15794175,beige:16119260,bisque:16770244,black:0,blanchedalmond:16772045,blue:255,blueviolet:9055202,brown:10824234,burlywood:14596231,cadetblue:6266528,chartreuse:8388352,chocolate:13789470,coral:16744272,cornflowerblue:6591981,cornsilk:16775388,crimson:14423100,cyan:65535,darkblue:139,darkcyan:35723,darkgoldenrod:12092939,darkgray:11119017,darkgreen:25600,darkgrey:11119017,darkkhaki:12433259,darkmagenta:9109643,darkolivegreen:5597999,darkorange:16747520,darkorchid:10040012,darkred:9109504,darksalmon:15308410,darkseagreen:9419919,darkslateblue:4734347,darkslategray:3100495,darkslategrey:3100495,darkturquoise:52945,darkviolet:9699539,deeppink:16716947,deepskyblue:49151,dimgray:6908265,dimgrey:6908265,dodgerblue:2003199,firebrick:11674146,floralwhite:16775920,forestgreen:2263842,fuchsia:16711935,gainsboro:14474460,ghostwhite:16316671,gold:16766720,goldenrod:14329120,gray:8421504,green:32768,greenyellow:11403055,grey:8421504,honeydew:15794160,hotpink:16738740,indianred:13458524,indigo:4915330,ivory:16777200,khaki:15787660,lavender:15132410,lavenderblush:16773365,lawngreen:8190976,lemonchiffon:16775885,lightblue:11393254,lightcoral:15761536,lightcyan:14745599,lightgoldenrodyellow:16448210,lightgray:13882323,lightgreen:9498256,lightgrey:13882323,lightpink:16758465,lightsalmon:16752762,lightseagreen:2142890,lightskyblue:8900346,lightslategray:7833753,lightslategrey:7833753,lightsteelblue:11584734,lightyellow:16777184,lime:65280,limegreen:3329330,linen:16445670,magenta:16711935,maroon:8388608,mediumaquamarine:6737322,mediumblue:205,mediumorchid:12211667,mediumpurple:9662683,mediumseagreen:3978097,mediumslateblue:8087790,mediumspringgreen:64154,mediumturquoise:4772300,mediumvioletred:13047173,midnightblue:1644912,mintcream:16121850,mistyrose:16770273,moccasin:16770229,navajowhite:16768685,navy:128,oldlace:16643558,olive:8421376,olivedrab:7048739,orange:16753920,orangered:16729344,orchid:14315734,palegoldenrod:15657130,palegreen:10025880,paleturquoise:11529966,palevioletred:14381203,papayawhip:16773077,peachpuff:16767673,peru:13468991,pink:16761035,plum:14524637,powderblue:11591910,purple:8388736,rebeccapurple:6697881,red:16711680,rosybrown:12357519,royalblue:4286945,saddlebrown:9127187,salmon:16416882,sandybrown:16032864,seagreen:3050327,seashell:16774638,sienna:10506797,silver:12632256,skyblue:8900331,slateblue:6970061,slategray:7372944,slategrey:7372944,snow:16775930,springgreen:65407,steelblue:4620980,tan:13808780,teal:32896,thistle:14204888,tomato:16737095,turquoise:4251856,violet:15631086,wheat:16113331,white:16777215,whitesmoke:16119285,yellow:16776960,yellowgreen:10145074};mn(Ct,rt,{copy(t){return Object.assign(new this.constructor,this,t)},displayable(){return this.rgb().displayable()},hex:oe,formatHex:oe,formatHex8:ao,formatHsl:uo,formatRgb:ae,toString:ae});function oe(){return this.rgb().formatHex()}function ao(){return this.rgb().formatHex8()}function uo(){return le(this).formatHsl()}function ae(){return this.rgb().formatRgb()}function rt(t){var n,e;return t=(t+"").trim().toLowerCase(),(n=ji.exec(t))?(e=n[1].length,n=parseInt(n[1],16),e===6?ue(n):e===3?new Y(n>>8&15|n>>4&240,n>>4&15|n&240,(n&15)<<4|n&15,1):e===8?zt(n>>24&255,n>>16&255,n>>8&255,(n&255)/255):e===4?zt(n>>12&15|n>>8&240,n>>8&15|n>>4&240,n>>4&15|n&240,((n&15)<<4|n&15)/255):null):(n=to.exec(t))?new Y(n[1],n[2],n[3],1):(n=no.exec(t))?new Y(n[1]*255/100,n[2]*255/100,n[3]*255/100,1):(n=eo.exec(t))?zt(n[1],n[2],n[3],n[4]):(n=ro.exec(t))?zt(n[1]*255/100,n[2]*255/100,n[3]*255/100,n[4]):(n=io.exec(t))?fe(n[1],n[2]/100,n[3]/100,1):(n=oo.exec(t))?fe(n[1],n[2]/100,n[3]/100,n[4]):ie.hasOwnProperty(t)?ue(ie[t]):t==="transparent"?new Y(NaN,NaN,NaN,0):null}function ue(t){return new Y(t>>16&255,t>>8&255,t&255,1)}function zt(t,n,e,r){return r<=0&&(t=n=e=NaN),new Y(t,n,e,r)}function so(t){return t instanceof Ct||(t=rt(t)),t?(t=t.rgb(),new Y(t.r,t.g,t.b,t.opacity)):new Y}function pn(t,n,e,r){return arguments.length===1?so(t):new Y(t,n,e,r??1)}function Y(t,n,e,r){this.r=+t,this.g=+n,this.b=+e,this.opacity=+r}mn(Y,pn,re(Ct,{brighter(t){return t=t==null?Wt:Math.pow(Wt,t),new Y(this.r*t,this.g*t,this.b*t,this.opacity)},darker(t){return t=t==null?bt:Math.pow(bt,t),new Y(this.r*t,this.g*t,this.b*t,this.opacity)},rgb(){return this},clamp(){return new Y(it(this.r),it(this.g),it(this.b),Xt(this.opacity))},displayable(){return-.5<=this.r&&this.r<255.5&&-.5<=this.g&&this.g<255.5&&-.5<=this.b&&this.b<255.5&&0<=this.opacity&&this.opacity<=1},hex:se,formatHex:se,formatHex8:co,formatRgb:ce,toString:ce}));function se(){return`#${ot(this.r)}${ot(this.g)}${ot(this.b)}`}function co(){return`#${ot(this.r)}${ot(this.g)}${ot(this.b)}${ot((isNaN(this.opacity)?1:this.opacity)*255)}`}function ce(){const t=Xt(this.opacity);return`${t===1?"rgb(":"rgba("}${it(this.r)}, ${it(this.g)}, ${it(this.b)}${t===1?")":`, ${t})`}`}function Xt(t){return isNaN(t)?1:Math.max(0,Math.min(1,t))}function it(t){return Math.max(0,Math.min(255,Math.round(t)||0))}function ot(t){return t=it(t),(t<16?"0":"")+t.toString(16)}function fe(t,n,e,r){return r<=0?t=n=e=NaN:e<=0||e>=1?t=n=NaN:n<=0&&(t=NaN),new q(t,n,e,r)}function le(t){if(t instanceof q)return new q(t.h,t.s,t.l,t.opacity);if(t instanceof Ct||(t=rt(t)),!t)return new q;if(t instanceof q)return t;t=t.rgb();var n=t.r/255,e=t.g/255,r=t.b/255,i=Math.min(n,e,r),o=Math.max(n,e,r),a=NaN,u=o-i,c=(o+i)/2;return u?(n===o?a=(e-r)/u+(e<r)*6:e===o?a=(r-n)/u+2:a=(n-e)/u+4,u/=c<.5?o+i:2-o-i,a*=60):u=c>0&&c<1?0:a,new q(a,u,c,t.opacity)}function fo(t,n,e,r){return arguments.length===1?le(t):new q(t,n,e,r??1)}function q(t,n,e,r){this.h=+t,this.s=+n,this.l=+e,this.opacity=+r}mn(q,fo,re(Ct,{brighter(t){return t=t==null?Wt:Math.pow(Wt,t),new q(this.h,this.s,this.l*t,this.opacity)},darker(t){return t=t==null?bt:Math.pow(bt,t),new q(this.h,this.s,this.l*t,this.opacity)},rgb(){var t=this.h%360+(this.h<0)*360,n=isNaN(t)||isNaN(this.s)?0:this.s,e=this.l,r=e+(e<.5?e:1-e)*n,i=2*e-r;return new Y(yn(t>=240?t-240:t+120,i,r),yn(t,i,r),yn(t<120?t+240:t-120,i,r),this.opacity)},clamp(){return new q(he(this.h),qt(this.s),qt(this.l),Xt(this.opacity))},displayable(){return(0<=this.s&&this.s<=1||isNaN(this.s))&&0<=this.l&&this.l<=1&&0<=this.opacity&&this.opacity<=1},formatHsl(){const t=Xt(this.opacity);return`${t===1?"hsl(":"hsla("}${he(this.h)}, ${qt(this.s)*100}%, ${qt(this.l)*100}%${t===1?")":`, ${t})`}`}}));function he(t){return t=(t||0)%360,t<0?t+360:t}function qt(t){return Math.max(0,Math.min(1,t||0))}function yn(t,n,e){return(t<60?n+(e-n)*t/60:t<180?e:t<240?n+(e-n)*(240-t)/60:n)*255}var wn=t=>()=>t;function lo(t,n){return function(e){return t+e*n}}function ho(t,n,e){return t=Math.pow(t,e),n=Math.pow(n,e)-t,e=1/e,function(r){return Math.pow(t+r*n,e)}}function go(t){return(t=+t)==1?ge:function(n,e){return e-n?ho(n,e,t):wn(isNaN(n)?e:n)}}function ge(t,n){var e=n-t;return e?lo(t,e):wn(isNaN(t)?n:t)}var Vt=(function t(n){var e=go(n);function r(i,o){var a=e((i=pn(i)).r,(o=pn(o)).r),u=e(i.g,o.g),c=e(i.b,o.b),s=ge(i.opacity,o.opacity);return function(f){return i.r=a(f),i.g=u(f),i.b=c(f),i.opacity=s(f),i+""}}return r.gamma=t,r})(1);function mo(t,n){n||(n=[]);var e=t?Math.min(n.length,t.length):0,r=n.slice(),i;return function(o){for(i=0;i<e;++i)r[i]=t[i]*(1-o)+n[i]*o;return r}}function po(t){return ArrayBuffer.isView(t)&&!(t instanceof DataView)}function yo(t,n){var e=n?n.length:0,r=t?Math.min(e,t.length):0,i=new Array(r),o=new Array(e),a;for(a=0;a<r;++a)i[a]=_n(t[a],n[a]);for(;a<e;++a)o[a]=n[a];return function(u){for(a=0;a<r;++a)o[a]=i[a](u);return o}}function wo(t,n){var e=new Date;return t=+t,n=+n,function(r){return e.setTime(t*(1-r)+n*r),e}}function V(t,n){return t=+t,n=+n,function(e){return t*(1-e)+n*e}}function vo(t,n){var e={},r={},i;(t===null||typeof t!="object")&&(t={}),(n===null||typeof n!="object")&&(n={});for(i in n)i in t?e[i]=_n(t[i],n[i]):r[i]=n[i];return function(o){for(i in e)r[i]=e[i](o);return r}}var vn=/[-+]?(?:\\d+\\.?\\d*|\\.?\\d+)(?:[eE][-+]?\\d+)?/g,xn=new RegExp(vn.source,"g");function xo(t){return function(){return t}}function _o(t){return function(n){return t(n)+""}}function de(t,n){var e=vn.lastIndex=xn.lastIndex=0,r,i,o,a=-1,u=[],c=[];for(t=t+"",n=n+"";(r=vn.exec(t))&&(i=xn.exec(n));)(o=i.index)>e&&(o=n.slice(e,o),u[a]?u[a]+=o:u[++a]=o),(r=r[0])===(i=i[0])?u[a]?u[a]+=i:u[++a]=i:(u[++a]=null,c.push({i:a,x:V(r,i)})),e=xn.lastIndex;return e<n.length&&(o=n.slice(e),u[a]?u[a]+=o:u[++a]=o),u.length<2?c[0]?_o(c[0].x):xo(n):(n=c.length,function(s){for(var f=0,l;f<n;++f)u[(l=c[f]).i]=l.x(s);return u.join("")})}function _n(t,n){var e=typeof n,r;return n==null||e==="boolean"?wn(n):(e==="number"?V:e==="string"?(r=rt(n))?(n=r,Vt):de:n instanceof rt?Vt:n instanceof Date?wo:po(n)?mo:Array.isArray(n)?yo:typeof n.valueOf!="function"&&typeof n.toString!="function"||isNaN(n)?vo:V)(t,n)}function Mo(t,n){return t=+t,n=+n,function(e){return Math.round(t*(1-e)+n*e)}}var me=180/Math.PI,Mn={translateX:0,translateY:0,rotate:0,skewX:0,scaleX:1,scaleY:1};function pe(t,n,e,r,i,o){var a,u,c;return(a=Math.sqrt(t*t+n*n))&&(t/=a,n/=a),(c=t*e+n*r)&&(e-=t*c,r-=n*c),(u=Math.sqrt(e*e+r*r))&&(e/=u,r/=u,c/=u),t*r<n*e&&(t=-t,n=-n,c=-c,a=-a),{translateX:i,translateY:o,rotate:Math.atan2(n,t)*me,skewX:Math.atan(c)*me,scaleX:a,scaleY:u}}var Bt;function To(t){const n=new(typeof DOMMatrix=="function"?DOMMatrix:WebKitCSSMatrix)(t+"");return n.isIdentity?Mn:pe(n.a,n.b,n.c,n.d,n.e,n.f)}function No(t){return t==null||(Bt||(Bt=document.createElementNS("http://www.w3.org/2000/svg","g")),Bt.setAttribute("transform",t),!(t=Bt.transform.baseVal.consolidate()))?Mn:(t=t.matrix,pe(t.a,t.b,t.c,t.d,t.e,t.f))}function ye(t,n,e,r){function i(s){return s.length?s.pop()+" ":""}function o(s,f,l,h,p,x){if(s!==l||f!==h){var b=p.push("translate(",null,n,null,e);x.push({i:b-4,x:V(s,l)},{i:b-2,x:V(f,h)})}else(l||h)&&p.push("translate("+l+n+h+e)}function a(s,f,l,h){s!==f?(s-f>180?f+=360:f-s>180&&(s+=360),h.push({i:l.push(i(l)+"rotate(",null,r)-2,x:V(s,f)})):f&&l.push(i(l)+"rotate("+f+r)}function u(s,f,l,h){s!==f?h.push({i:l.push(i(l)+"skewX(",null,r)-2,x:V(s,f)}):f&&l.push(i(l)+"skewX("+f+r)}function c(s,f,l,h,p,x){if(s!==l||f!==h){var b=p.push(i(p)+"scale(",null,",",null,")");x.push({i:b-4,x:V(s,l)},{i:b-2,x:V(f,h)})}else(l!==1||h!==1)&&p.push(i(p)+"scale("+l+","+h+")")}return function(s,f){var l=[],h=[];return s=t(s),f=t(f),o(s.translateX,s.translateY,f.translateX,f.translateY,l,h),a(s.rotate,f.rotate,l,h),u(s.skewX,f.skewX,l,h),c(s.scaleX,s.scaleY,f.scaleX,f.scaleY,l,h),s=f=null,function(p){for(var x=-1,b=h.length,U;++x<b;)l[(U=h[x]).i]=U.x(p);return l.join("")}}}var Co=ye(To,"px, ","px)","deg)"),bo=ye(No,", ",")",")"),gt=0,Dt=0,kt=0,we=1e3,Zt,At,Gt=0,at=0,Qt=0,Ut=typeof performance=="object"&&performance.now?performance:Date,ve=typeof window=="object"&&window.requestAnimationFrame?window.requestAnimationFrame.bind(window):function(t){setTimeout(t,17)};function Tn(){return at||(ve(So),at=Ut.now()+Qt)}function So(){at=0}function Jt(){this._call=this._time=this._next=null}Jt.prototype=xe.prototype={constructor:Jt,restart:function(t,n,e){if(typeof t!="function")throw new TypeError("callback is not a function");e=(e==null?Tn():+e)+(n==null?0:+n),!this._next&&At!==this&&(At?At._next=this:Zt=this,At=this),this._call=t,this._time=e,Nn()},stop:function(){this._call&&(this._call=null,this._time=1/0,Nn())}};function xe(t,n,e){var r=new Jt;return r.restart(t,n,e),r}function Do(){Tn(),++gt;for(var t=Zt,n;t;)(n=at-t._time)>=0&&t._call.call(void 0,n),t=t._next;--gt}function _e(){at=(Gt=Ut.now())+Qt,gt=Dt=0;try{Do()}finally{gt=0,Ao(),at=0}}function ko(){var t=Ut.now(),n=t-Gt;n>we&&(Qt-=n,Gt=t)}function Ao(){for(var t,n=Zt,e,r=1/0;n;)n._call?(r>n._time&&(r=n._time),t=n,n=n._next):(e=n._next,n._next=null,n=t?t._next=e:Zt=e);At=t,Nn(r)}function Nn(t){if(!gt){Dt&&(Dt=clearTimeout(Dt));var n=t-at;n>24?(t<1/0&&(Dt=setTimeout(_e,t-Ut.now()-Qt)),kt&&(kt=clearInterval(kt))):(kt||(Gt=Ut.now(),kt=setInterval(ko,we)),gt=1,ve(_e))}}function Me(t,n,e){var r=new Jt;return n=n==null?0:+n,r.restart(i=>{r.stop(),t(i+n)},n,e),r}var Uo=zn("start","end","cancel","interrupt"),Fo=[],Te=0,Ne=1,Cn=2,Kt=3,Ce=4,bn=5,jt=6;function tn(t,n,e,r,i,o){var a=t.__transition;if(!a)t.__transition={};else if(e in a)return;$o(t,e,{name:n,index:r,group:i,on:Uo,tween:Fo,time:o.time,delay:o.delay,duration:o.duration,ease:o.ease,timer:null,state:Te})}function Sn(t,n){var e=B(t,n);if(e.state>Te)throw new Error("too late; already scheduled");return e}function Q(t,n){var e=B(t,n);if(e.state>Kt)throw new Error("too late; already running");return e}function B(t,n){var e=t.__transition;if(!e||!(e=e[n]))throw new Error("transition not found");return e}function $o(t,n,e){var r=t.__transition,i;r[n]=e,e.timer=xe(o,0,e.time);function o(s){e.state=Ne,e.timer.restart(a,e.delay,e.time),e.delay<=s&&a(s-e.delay)}function a(s){var f,l,h,p;if(e.state!==Ne)return c();for(f in r)if(p=r[f],p.name===e.name){if(p.state===Kt)return Me(a);p.state===Ce?(p.state=jt,p.timer.stop(),p.on.call("interrupt",t,t.__data__,p.index,p.group),delete r[f]):+f<n&&(p.state=jt,p.timer.stop(),p.on.call("cancel",t,t.__data__,p.index,p.group),delete r[f])}if(Me(function(){e.state===Kt&&(e.state=Ce,e.timer.restart(u,e.delay,e.time),u(s))}),e.state=Cn,e.on.call("start",t,t.__data__,e.index,e.group),e.state===Cn){for(e.state=Kt,i=new Array(h=e.tween.length),f=0,l=-1;f<h;++f)(p=e.tween[f].value.call(t,t.__data__,e.index,e.group))&&(i[++l]=p);i.length=l+1}}function u(s){for(var f=s<e.duration?e.ease.call(null,s/e.duration):(e.timer.restart(c),e.state=bn,1),l=-1,h=i.length;++l<h;)i[l].call(t,f);e.state===bn&&(e.on.call("end",t,t.__data__,e.index,e.group),c())}function c(){e.state=jt,e.timer.stop(),delete r[n];for(var s in r)return;delete t.__transition}}function Lo(t,n){var e=t.__transition,r,i,o=!0,a;if(e){n=n==null?null:n+"";for(a in e){if((r=e[a]).name!==n){o=!1;continue}i=r.state>Cn&&r.state<bn,r.state=jt,r.timer.stop(),r.on.call(i?"interrupt":"cancel",t,t.__data__,r.index,r.group),delete e[a]}o&&delete t.__transition}}function Po(t){return this.each(function(){Lo(this,t)})}function Eo(t,n){var e,r;return function(){var i=Q(this,t),o=i.tween;if(o!==e){r=e=o;for(var a=0,u=r.length;a<u;++a)if(r[a].name===n){r=r.slice(),r.splice(a,1);break}}i.tween=r}}function Ho(t,n,e){var r,i;if(typeof e!="function")throw new Error;return function(){var o=Q(this,t),a=o.tween;if(a!==r){i=(r=a).slice();for(var u={name:n,value:e},c=0,s=i.length;c<s;++c)if(i[c].name===n){i[c]=u;break}c===s&&i.push(u)}o.tween=i}}function Yo(t,n){var e=this._id;if(t+="",arguments.length<2){for(var r=B(this.node(),e).tween,i=0,o=r.length,a;i<o;++i)if((a=r[i]).name===t)return a.value;return null}return this.each((n==null?Eo:Ho)(e,t,n))}function Dn(t,n,e){var r=t._id;return t.each(function(){var i=Q(this,r);(i.value||(i.value={}))[n]=e.apply(this,arguments)}),function(i){return B(i,r).value[n]}}function be(t,n){var e;return(typeof n=="number"?V:n instanceof rt?Vt:(e=rt(n))?(n=e,Vt):de)(t,n)}function Ro(t){return function(){this.removeAttribute(t)}}function Io(t){return function(){this.removeAttributeNS(t.space,t.local)}}function Oo(t,n,e){var r,i=e+"",o;return function(){var a=this.getAttribute(t);return a===i?null:a===r?o:o=n(r=a,e)}}function Wo(t,n,e){var r,i=e+"",o;return function(){var a=this.getAttributeNS(t.space,t.local);return a===i?null:a===r?o:o=n(r=a,e)}}function zo(t,n,e){var r,i,o;return function(){var a,u=e(this),c;return u==null?void this.removeAttribute(t):(a=this.getAttribute(t),c=u+"",a===c?null:a===r&&c===i?o:(i=c,o=n(r=a,u)))}}function Xo(t,n,e){var r,i,o;return function(){var a,u=e(this),c;return u==null?void this.removeAttributeNS(t.space,t.local):(a=this.getAttributeNS(t.space,t.local),c=u+"",a===c?null:a===r&&c===i?o:(i=c,o=n(r=a,u)))}}function qo(t,n){var e=It(t),r=e==="transform"?bo:be;return this.attrTween(t,typeof n=="function"?(e.local?Xo:zo)(e,r,Dn(this,"attr."+t,n)):n==null?(e.local?Io:Ro)(e):(e.local?Wo:Oo)(e,r,n))}function Vo(t,n){return function(e){this.setAttribute(t,n.call(this,e))}}function Bo(t,n){return function(e){this.setAttributeNS(t.space,t.local,n.call(this,e))}}function Zo(t,n){var e,r;function i(){var o=n.apply(this,arguments);return o!==r&&(e=(r=o)&&Bo(t,o)),e}return i._value=n,i}function Go(t,n){var e,r;function i(){var o=n.apply(this,arguments);return o!==r&&(e=(r=o)&&Vo(t,o)),e}return i._value=n,i}function Qo(t,n){var e="attr."+t;if(arguments.length<2)return(e=this.tween(e))&&e._value;if(n==null)return this.tween(e,null);if(typeof n!="function")throw new Error;var r=It(t);return this.tween(e,(r.local?Zo:Go)(r,n))}function Jo(t,n){return function(){Sn(this,t).delay=+n.apply(this,arguments)}}function Ko(t,n){return n=+n,function(){Sn(this,t).delay=n}}function jo(t){var n=this._id;return arguments.length?this.each((typeof t=="function"?Jo:Ko)(n,t)):B(this.node(),n).delay}function ta(t,n){return function(){Q(this,t).duration=+n.apply(this,arguments)}}function na(t,n){return n=+n,function(){Q(this,t).duration=n}}function ea(t){var n=this._id;return arguments.length?this.each((typeof t=="function"?ta:na)(n,t)):B(this.node(),n).duration}function ra(t,n){if(typeof n!="function")throw new Error;return function(){Q(this,t).ease=n}}function ia(t){var n=this._id;return arguments.length?this.each(ra(n,t)):B(this.node(),n).ease}function oa(t,n){return function(){var e=n.apply(this,arguments);if(typeof e!="function")throw new Error;Q(this,t).ease=e}}function aa(t){if(typeof t!="function")throw new Error;return this.each(oa(this._id,t))}function ua(t){typeof t!="function"&&(t=Zn(t));for(var n=this._groups,e=n.length,r=new Array(e),i=0;i<e;++i)for(var o=n[i],a=o.length,u=r[i]=[],c,s=0;s<a;++s)(c=o[s])&&t.call(c,c.__data__,s,o)&&u.push(c);return new J(r,this._parents,this._name,this._id)}function sa(t){if(t._id!==this._id)throw new Error;for(var n=this._groups,e=t._groups,r=n.length,i=e.length,o=Math.min(r,i),a=new Array(r),u=0;u<o;++u)for(var c=n[u],s=e[u],f=c.length,l=a[u]=new Array(f),h,p=0;p<f;++p)(h=c[p]||s[p])&&(l[p]=h);for(;u<r;++u)a[u]=n[u];return new J(a,this._parents,this._name,this._id)}function ca(t){return(t+"").trim().split(/^|\\s+/).every(function(n){var e=n.indexOf(".");return e>=0&&(n=n.slice(0,e)),!n||n==="start"})}function fa(t,n,e){var r,i,o=ca(n)?Sn:Q;return function(){var a=o(this,t),u=a.on;u!==r&&(i=(r=u).copy()).on(n,e),a.on=i}}function la(t,n){var e=this._id;return arguments.length<2?B(this.node(),e).on.on(t):this.each(fa(e,t,n))}function ha(t){return function(){var n=this.parentNode;for(var e in this.__transition)if(+e!==t)return;n&&n.removeChild(this)}}function ga(){return this.on("end.remove",ha(this._id))}function da(t){var n=this._name,e=this._id;typeof t!="function"&&(t=gn(t));for(var r=this._groups,i=r.length,o=new Array(i),a=0;a<i;++a)for(var u=r[a],c=u.length,s=o[a]=new Array(c),f,l,h=0;h<c;++h)(f=u[h])&&(l=t.call(f,f.__data__,h,u))&&("__data__"in f&&(l.__data__=f.__data__),s[h]=l,tn(s[h],n,e,h,s,B(f,e)));return new J(o,this._parents,n,e)}function ma(t){var n=this._name,e=this._id;typeof t!="function"&&(t=Bn(t));for(var r=this._groups,i=r.length,o=[],a=[],u=0;u<i;++u)for(var c=r[u],s=c.length,f,l=0;l<s;++l)if(f=c[l]){for(var h=t.call(f,f.__data__,l,c),p,x=B(f,e),b=0,U=h.length;b<U;++b)(p=h[b])&&tn(p,n,e,b,h,x);o.push(h),a.push(f)}return new J(o,a,n,e)}var pa=Nt.prototype.constructor;function ya(){return new pa(this._groups,this._parents)}function wa(t,n){var e,r,i;return function(){var o=lt(this,t),a=(this.style.removeProperty(t),lt(this,t));return o===a?null:o===e&&a===r?i:i=n(e=o,r=a)}}function Se(t){return function(){this.style.removeProperty(t)}}function va(t,n,e){var r,i=e+"",o;return function(){var a=lt(this,t);return a===i?null:a===r?o:o=n(r=a,e)}}function xa(t,n,e){var r,i,o;return function(){var a=lt(this,t),u=e(this),c=u+"";return u==null&&(c=u=(this.style.removeProperty(t),lt(this,t))),a===c?null:a===r&&c===i?o:(i=c,o=n(r=a,u))}}function _a(t,n){var e,r,i,o="style."+n,a="end."+o,u;return function(){var c=Q(this,t),s=c.on,f=c.value[o]==null?u||(u=Se(n)):void 0;(s!==e||i!==f)&&(r=(e=s).copy()).on(a,i=f),c.on=r}}function Ma(t,n,e){var r=(t+="")=="transform"?Co:be;return n==null?this.styleTween(t,wa(t,r)).on("end.style."+t,Se(t)):typeof n=="function"?this.styleTween(t,xa(t,r,Dn(this,"style."+t,n))).each(_a(this._id,t)):this.styleTween(t,va(t,r,n),e).on("end.style."+t,null)}function Ta(t,n,e){return function(r){this.style.setProperty(t,n.call(this,r),e)}}function Na(t,n,e){var r,i;function o(){var a=n.apply(this,arguments);return a!==i&&(r=(i=a)&&Ta(t,a,e)),r}return o._value=n,o}function Ca(t,n,e){var r="style."+(t+="");if(arguments.length<2)return(r=this.tween(r))&&r._value;if(n==null)return this.tween(r,null);if(typeof n!="function")throw new Error;return this.tween(r,Na(t,n,e??""))}function ba(t){return function(){this.textContent=t}}function Sa(t){return function(){var n=t(this);this.textContent=n??""}}function Da(t){return this.tween("text",typeof t=="function"?Sa(Dn(this,"text",t)):ba(t==null?"":t+""))}function ka(t){return function(n){this.textContent=t.call(this,n)}}function Aa(t){var n,e;function r(){var i=t.apply(this,arguments);return i!==e&&(n=(e=i)&&ka(i)),n}return r._value=t,r}function Ua(t){var n="text";if(arguments.length<1)return(n=this.tween(n))&&n._value;if(t==null)return this.tween(n,null);if(typeof t!="function")throw new Error;return this.tween(n,Aa(t))}function Fa(){for(var t=this._name,n=this._id,e=De(),r=this._groups,i=r.length,o=0;o<i;++o)for(var a=r[o],u=a.length,c,s=0;s<u;++s)if(c=a[s]){var f=B(c,n);tn(c,t,e,s,a,{time:f.time+f.delay+f.duration,delay:0,duration:f.duration,ease:f.ease})}return new J(r,this._parents,t,e)}function $a(){var t,n,e=this,r=e._id,i=e.size();return new Promise(function(o,a){var u={value:a},c={value:function(){--i===0&&o()}};e.each(function(){var s=Q(this,r),f=s.on;f!==t&&(n=(t=f).copy(),n._.cancel.push(u),n._.interrupt.push(u),n._.end.push(c)),s.on=n}),i===0&&o()})}var La=0;function J(t,n,e,r){this._groups=t,this._parents=n,this._name=e,this._id=r}function De(){return++La}var K=Nt.prototype;J.prototype={constructor:J,select:da,selectAll:ma,selectChild:K.selectChild,selectChildren:K.selectChildren,filter:ua,merge:sa,selection:ya,transition:Fa,call:K.call,nodes:K.nodes,node:K.node,size:K.size,empty:K.empty,each:K.each,on:la,attr:qo,attrTween:Qo,style:Ma,styleTween:Ca,text:Da,textTween:Ua,remove:ga,tween:Yo,delay:jo,duration:ea,ease:ia,easeVarying:aa,end:$a,[Symbol.iterator]:K[Symbol.iterator]};function Pa(t){return((t*=2)<=1?t*t*t:(t-=2)*t*t+2)/2}var Ea={time:null,delay:0,duration:250,ease:Pa};function Ha(t,n){for(var e;!(e=t.__transition)||!(e=e[n]);)if(!(t=t.parentNode))throw new Error(`transition ${n} not found`);return e}function Ya(t){var n,e;t instanceof J?(n=t._id,t=t._name):(n=De(),(e=Ea).time=Tn(),t=t==null?null:t+"");for(var r=this._groups,i=r.length,o=0;o<i;++o)for(var a=r[o],u=a.length,c,s=0;s<u;++s)(c=a[s])&&tn(c,t,n,s,a,e||Ha(c,n));return new J(r,this._parents,t,n)}Nt.prototype.interrupt=Po,Nt.prototype.transition=Ya;function Ra(t){return Math.abs(t=Math.round(t))>=1e21?t.toLocaleString("en").replace(/,/g,""):t.toString(10)}function nn(t,n){if((e=(t=n?t.toExponential(n-1):t.toExponential()).indexOf("e"))<0)return null;var e,r=t.slice(0,e);return[r.length>1?r[0]+r.slice(2):r,+t.slice(e+1)]}function dt(t){return t=nn(Math.abs(t)),t?t[1]:NaN}function Ia(t,n){return function(e,r){for(var i=e.length,o=[],a=0,u=t[0],c=0;i>0&&u>0&&(c+u+1>r&&(u=Math.max(1,r-c)),o.push(e.substring(i-=u,i+u)),!((c+=u+1)>r));)u=t[a=(a+1)%t.length];return o.reverse().join(n)}}function Oa(t){return function(n){return n.replace(/[0-9]/g,function(e){return t[+e]})}}var Wa=/^(?:(.)?([<>=^]))?([+\\-( ])?([$#])?(0)?(\\d+)?(,)?(\\.\\d+)?(~)?([a-z%])?$/i;function en(t){if(!(n=Wa.exec(t)))throw new Error("invalid format: "+t);var n;return new kn({fill:n[1],align:n[2],sign:n[3],symbol:n[4],zero:n[5],width:n[6],comma:n[7],precision:n[8]&&n[8].slice(1),trim:n[9],type:n[10]})}en.prototype=kn.prototype;function kn(t){this.fill=t.fill===void 0?" ":t.fill+"",this.align=t.align===void 0?">":t.align+"",this.sign=t.sign===void 0?"-":t.sign+"",this.symbol=t.symbol===void 0?"":t.symbol+"",this.zero=!!t.zero,this.width=t.width===void 0?void 0:+t.width,this.comma=!!t.comma,this.precision=t.precision===void 0?void 0:+t.precision,this.trim=!!t.trim,this.type=t.type===void 0?"":t.type+""}kn.prototype.toString=function(){return this.fill+this.align+this.sign+this.symbol+(this.zero?"0":"")+(this.width===void 0?"":Math.max(1,this.width|0))+(this.comma?",":"")+(this.precision===void 0?"":"."+Math.max(0,this.precision|0))+(this.trim?"~":"")+this.type};function za(t){t:for(var n=t.length,e=1,r=-1,i;e<n;++e)switch(t[e]){case".":r=i=e;break;case"0":r===0&&(r=e),i=e;break;default:if(!+t[e])break t;r>0&&(r=0);break}return r>0?t.slice(0,r)+t.slice(i+1):t}var ke;function Xa(t,n){var e=nn(t,n);if(!e)return t+"";var r=e[0],i=e[1],o=i-(ke=Math.max(-8,Math.min(8,Math.floor(i/3)))*3)+1,a=r.length;return o===a?r:o>a?r+new Array(o-a+1).join("0"):o>0?r.slice(0,o)+"."+r.slice(o):"0."+new Array(1-o).join("0")+nn(t,Math.max(0,n+o-1))[0]}function Ae(t,n){var e=nn(t,n);if(!e)return t+"";var r=e[0],i=e[1];return i<0?"0."+new Array(-i).join("0")+r:r.length>i+1?r.slice(0,i+1)+"."+r.slice(i+1):r+new Array(i-r.length+2).join("0")}var Ue={"%":(t,n)=>(t*100).toFixed(n),b:t=>Math.round(t).toString(2),c:t=>t+"",d:Ra,e:(t,n)=>t.toExponential(n),f:(t,n)=>t.toFixed(n),g:(t,n)=>t.toPrecision(n),o:t=>Math.round(t).toString(8),p:(t,n)=>Ae(t*100,n),r:Ae,s:Xa,X:t=>Math.round(t).toString(16).toUpperCase(),x:t=>Math.round(t).toString(16)};function Fe(t){return t}var $e=Array.prototype.map,Le=["y","z","a","f","p","n","µ","m","","k","M","G","T","P","E","Z","Y"];function qa(t){var n=t.grouping===void 0||t.thousands===void 0?Fe:Ia($e.call(t.grouping,Number),t.thousands+""),e=t.currency===void 0?"":t.currency[0]+"",r=t.currency===void 0?"":t.currency[1]+"",i=t.decimal===void 0?".":t.decimal+"",o=t.numerals===void 0?Fe:Oa($e.call(t.numerals,String)),a=t.percent===void 0?"%":t.percent+"",u=t.minus===void 0?"−":t.minus+"",c=t.nan===void 0?"NaN":t.nan+"";function s(l){l=en(l);var h=l.fill,p=l.align,x=l.sign,b=l.symbol,U=l.zero,I=l.width,E=l.comma,k=l.precision,H=l.trim,m=l.type;m==="n"?(E=!0,m="g"):Ue[m]||(k===void 0&&(k=12),H=!0,m="g"),(U||h==="0"&&p==="=")&&(U=!0,h="0",p="=");var g=b==="$"?e:b==="#"&&/[boxX]/.test(m)?"0"+m.toLowerCase():"",v=b==="$"?r:/[%p]/.test(m)?a:"",_=Ue[m],A=/[defgprs%]/.test(m);k=k===void 0?6:/[gprs]/.test(m)?Math.max(1,Math.min(21,k)):Math.max(0,Math.min(20,k));function N(w){var S=g,F=v,$,xt,_t;if(m==="c")F=_(w)+F,w="";else{w=+w;var Mt=w<0||1/w<0;if(w=isNaN(w)?c:_(Math.abs(w),k),H&&(w=za(w)),Mt&&+w==0&&x!=="+"&&(Mt=!1),S=(Mt?x==="("?x:u:x==="-"||x==="("?"":x)+S,F=(m==="s"?Le[8+ke/3]:"")+F+(Mt&&x==="("?")":""),A){for($=-1,xt=w.length;++$<xt;)if(_t=w.charCodeAt($),48>_t||_t>57){F=(_t===46?i+w.slice($+1):w.slice($))+F,w=w.slice(0,$);break}}}E&&!U&&(w=n(w,1/0));var Tt=S.length+w.length+F.length,Z=Tt<I?new Array(I-Tt+1).join(h):"";switch(E&&U&&(w=n(Z+w,Z.length?I-F.length:1/0),Z=""),p){case"<":w=S+w+F+Z;break;case"=":w=S+Z+w+F;break;case"^":w=Z.slice(0,Tt=Z.length>>1)+S+w+F+Z.slice(Tt);break;default:w=Z+S+w+F;break}return o(w)}return N.toString=function(){return l+""},N}function f(l,h){var p=s((l=en(l),l.type="f",l)),x=Math.max(-8,Math.min(8,Math.floor(dt(h)/3)))*3,b=Math.pow(10,-x),U=Le[8+x/3];return function(I){return p(b*I)+U}}return{format:s,formatPrefix:f}}var rn,Pe,Ee;Va({thousands:",",grouping:[3],currency:["$",""]});function Va(t){return rn=qa(t),Pe=rn.format,Ee=rn.formatPrefix,rn}function Ba(t){return Math.max(0,-dt(Math.abs(t)))}function Za(t,n){return Math.max(0,Math.max(-8,Math.min(8,Math.floor(dt(n)/3)))*3-dt(Math.abs(t)))}function Ga(t,n){return t=Math.abs(t),n=Math.abs(n)-t,Math.max(0,dt(n)-dt(t))+1}function He(t,n){switch(arguments.length){case 0:break;case 1:this.range(t);break;default:this.range(n).domain(t);break}return this}function Qa(t){return function(){return t}}function Ja(t){return+t}var Ye=[0,1];function mt(t){return t}function An(t,n){return(n-=t=+t)?function(e){return(e-t)/n}:Qa(isNaN(n)?NaN:.5)}function Ka(t,n){var e;return t>n&&(e=t,t=n,n=e),function(r){return Math.max(t,Math.min(n,r))}}function ja(t,n,e){var r=t[0],i=t[1],o=n[0],a=n[1];return i<r?(r=An(i,r),o=e(a,o)):(r=An(r,i),o=e(o,a)),function(u){return o(r(u))}}function tu(t,n,e){var r=Math.min(t.length,n.length)-1,i=new Array(r),o=new Array(r),a=-1;for(t[r]<t[0]&&(t=t.slice().reverse(),n=n.slice().reverse());++a<r;)i[a]=An(t[a],t[a+1]),o[a]=e(n[a],n[a+1]);return function(u){var c=hr(t,u,1,r)-1;return o[c](i[c](u))}}function Re(t,n){return n.domain(t.domain()).range(t.range()).interpolate(t.interpolate()).clamp(t.clamp()).unknown(t.unknown())}function nu(){var t=Ye,n=Ye,e=_n,r,i,o,a=mt,u,c,s;function f(){var h=Math.min(t.length,n.length);return a!==mt&&(a=Ka(t[0],t[h-1])),u=h>2?tu:ja,c=s=null,l}function l(h){return h==null||isNaN(h=+h)?o:(c||(c=u(t.map(r),n,e)))(r(a(h)))}return l.invert=function(h){return a(i((s||(s=u(n,t.map(r),V)))(h)))},l.domain=function(h){return arguments.length?(t=Array.from(h,Ja),f()):t.slice()},l.range=function(h){return arguments.length?(n=Array.from(h),f()):n.slice()},l.rangeRound=function(h){return n=Array.from(h),e=Mo,f()},l.clamp=function(h){return arguments.length?(a=h?!0:mt,f()):a!==mt},l.interpolate=function(h){return arguments.length?(e=h,f()):e},l.unknown=function(h){return arguments.length?(o=h,l):o},function(h,p){return r=h,i=p,f()}}function Ie(){return nu()(mt,mt)}function eu(t,n,e,r){var i=ln(t,n,e),o;switch(r=en(r??",f"),r.type){case"s":{var a=Math.max(Math.abs(t),Math.abs(n));return r.precision==null&&!isNaN(o=Za(i,a))&&(r.precision=o),Ee(r,a)}case"":case"e":case"g":case"p":case"r":{r.precision==null&&!isNaN(o=Ga(i,Math.max(Math.abs(t),Math.abs(n))))&&(r.precision=o-(r.type==="e"));break}case"f":case"%":{r.precision==null&&!isNaN(o=Ba(i))&&(r.precision=o-(r.type==="%")*2);break}}return Pe(r)}function ru(t){var n=t.domain;return t.ticks=function(e){var r=n();return pr(r[0],r[r.length-1],e??10)},t.tickFormat=function(e,r){var i=n();return eu(i[0],i[i.length-1],e??10,r)},t.nice=function(e){e==null&&(e=10);var r=n(),i=0,o=r.length-1,a=r[i],u=r[o],c,s,f=10;for(u<a&&(s=a,a=u,u=s,s=i,i=o,o=s);f-- >0;){if(s=fn(a,u,e),s===c)return r[i]=a,r[o]=u,n(r);if(s>0)a=Math.floor(a/s)*s,u=Math.ceil(u/s)*s;else if(s<0)a=Math.ceil(a*s)/s,u=Math.floor(u*s)/s;else break;c=s}return t},t}function Oe(){var t=Ie();return t.copy=function(){return Re(t,Oe())},He.apply(t,arguments),ru(t)}function iu(t,n){t=t.slice();var e=0,r=t.length-1,i=t[e],o=t[r],a;return o<i&&(a=e,e=r,r=a,a=i,i=o,o=a),t[e]=n.floor(i),t[r]=n.ceil(o),t}const Un=new Date,Fn=new Date;function L(t,n,e,r){function i(o){return t(o=arguments.length===0?new Date:new Date(+o)),o}return i.floor=o=>(t(o=new Date(+o)),o),i.ceil=o=>(t(o=new Date(o-1)),n(o,1),t(o),o),i.round=o=>{const a=i(o),u=i.ceil(o);return o-a<u-o?a:u},i.offset=(o,a)=>(n(o=new Date(+o),a==null?1:Math.floor(a)),o),i.range=(o,a,u)=>{const c=[];if(o=i.ceil(o),u=u==null?1:Math.floor(u),!(o<a)||!(u>0))return c;let s;do c.push(s=new Date(+o)),n(o,u),t(o);while(s<o&&o<a);return c},i.filter=o=>L(a=>{if(a>=a)for(;t(a),!o(a);)a.setTime(a-1)},(a,u)=>{if(a>=a)if(u<0)for(;++u<=0;)for(;n(a,-1),!o(a););else for(;--u>=0;)for(;n(a,1),!o(a););}),e&&(i.count=(o,a)=>(Un.setTime(+o),Fn.setTime(+a),t(Un),t(Fn),Math.floor(e(Un,Fn))),i.every=o=>(o=Math.floor(o),!isFinite(o)||!(o>0)?null:o>1?i.filter(r?a=>r(a)%o===0:a=>i.count(0,a)%o===0):i)),i}const on=L(()=>{},(t,n)=>{t.setTime(+t+n)},(t,n)=>n-t);on.every=t=>(t=Math.floor(t),!isFinite(t)||!(t>0)?null:t>1?L(n=>{n.setTime(Math.floor(n/t)*t)},(n,e)=>{n.setTime(+n+e*t)},(n,e)=>(e-n)/t):on),on.range;const j=1e3,z=j*60,tt=z*60,nt=tt*24,$n=nt*7,We=nt*30,Ln=nt*365,pt=L(t=>{t.setTime(t-t.getMilliseconds())},(t,n)=>{t.setTime(+t+n*j)},(t,n)=>(n-t)/j,t=>t.getUTCSeconds());pt.range;const Pn=L(t=>{t.setTime(t-t.getMilliseconds()-t.getSeconds()*j)},(t,n)=>{t.setTime(+t+n*z)},(t,n)=>(n-t)/z,t=>t.getMinutes());Pn.range,L(t=>{t.setUTCSeconds(0,0)},(t,n)=>{t.setTime(+t+n*z)},(t,n)=>(n-t)/z,t=>t.getUTCMinutes()).range;const En=L(t=>{t.setTime(t-t.getMilliseconds()-t.getSeconds()*j-t.getMinutes()*z)},(t,n)=>{t.setTime(+t+n*tt)},(t,n)=>(n-t)/tt,t=>t.getHours());En.range,L(t=>{t.setUTCMinutes(0,0,0)},(t,n)=>{t.setTime(+t+n*tt)},(t,n)=>(n-t)/tt,t=>t.getUTCHours()).range;const Ft=L(t=>t.setHours(0,0,0,0),(t,n)=>t.setDate(t.getDate()+n),(t,n)=>(n-t-(n.getTimezoneOffset()-t.getTimezoneOffset())*z)/nt,t=>t.getDate()-1);Ft.range;const Hn=L(t=>{t.setUTCHours(0,0,0,0)},(t,n)=>{t.setUTCDate(t.getUTCDate()+n)},(t,n)=>(n-t)/nt,t=>t.getUTCDate()-1);Hn.range,L(t=>{t.setUTCHours(0,0,0,0)},(t,n)=>{t.setUTCDate(t.getUTCDate()+n)},(t,n)=>(n-t)/nt,t=>Math.floor(t/nt)).range;function ut(t){return L(n=>{n.setDate(n.getDate()-(n.getDay()+7-t)%7),n.setHours(0,0,0,0)},(n,e)=>{n.setDate(n.getDate()+e*7)},(n,e)=>(e-n-(e.getTimezoneOffset()-n.getTimezoneOffset())*z)/$n)}const an=ut(0),un=ut(1),ou=ut(2),au=ut(3),yt=ut(4),uu=ut(5),su=ut(6);an.range,un.range,ou.range,au.range,yt.range,uu.range,su.range;function st(t){return L(n=>{n.setUTCDate(n.getUTCDate()-(n.getUTCDay()+7-t)%7),n.setUTCHours(0,0,0,0)},(n,e)=>{n.setUTCDate(n.getUTCDate()+e*7)},(n,e)=>(e-n)/$n)}const ze=st(0),sn=st(1),cu=st(2),fu=st(3),wt=st(4),lu=st(5),hu=st(6);ze.range,sn.range,cu.range,fu.range,wt.range,lu.range,hu.range;const Yn=L(t=>{t.setDate(1),t.setHours(0,0,0,0)},(t,n)=>{t.setMonth(t.getMonth()+n)},(t,n)=>n.getMonth()-t.getMonth()+(n.getFullYear()-t.getFullYear())*12,t=>t.getMonth());Yn.range,L(t=>{t.setUTCDate(1),t.setUTCHours(0,0,0,0)},(t,n)=>{t.setUTCMonth(t.getUTCMonth()+n)},(t,n)=>n.getUTCMonth()-t.getUTCMonth()+(n.getUTCFullYear()-t.getUTCFullYear())*12,t=>t.getUTCMonth()).range;const et=L(t=>{t.setMonth(0,1),t.setHours(0,0,0,0)},(t,n)=>{t.setFullYear(t.getFullYear()+n)},(t,n)=>n.getFullYear()-t.getFullYear(),t=>t.getFullYear());et.every=t=>!isFinite(t=Math.floor(t))||!(t>0)?null:L(n=>{n.setFullYear(Math.floor(n.getFullYear()/t)*t),n.setMonth(0,1),n.setHours(0,0,0,0)},(n,e)=>{n.setFullYear(n.getFullYear()+e*t)}),et.range;const ct=L(t=>{t.setUTCMonth(0,1),t.setUTCHours(0,0,0,0)},(t,n)=>{t.setUTCFullYear(t.getUTCFullYear()+n)},(t,n)=>n.getUTCFullYear()-t.getUTCFullYear(),t=>t.getUTCFullYear());ct.every=t=>!isFinite(t=Math.floor(t))||!(t>0)?null:L(n=>{n.setUTCFullYear(Math.floor(n.getUTCFullYear()/t)*t),n.setUTCMonth(0,1),n.setUTCHours(0,0,0,0)},(n,e)=>{n.setUTCFullYear(n.getUTCFullYear()+e*t)}),ct.range;function gu(t,n,e,r,i,o){const a=[[pt,1,j],[pt,5,5*j],[pt,15,15*j],[pt,30,30*j],[o,1,z],[o,5,5*z],[o,15,15*z],[o,30,30*z],[i,1,tt],[i,3,3*tt],[i,6,6*tt],[i,12,12*tt],[r,1,nt],[r,2,2*nt],[e,1,$n],[n,1,We],[n,3,3*We],[t,1,Ln]];function u(s,f,l){const h=f<s;h&&([s,f]=[f,s]);const p=l&&typeof l.range=="function"?l:c(s,f,l),x=p?p.range(s,+f+1):[];return h?x.reverse():x}function c(s,f,l){const h=Math.abs(f-s)/l,p=cn(([,,U])=>U).right(a,h);if(p===a.length)return t.every(ln(s/Ln,f/Ln,l));if(p===0)return on.every(Math.max(ln(s,f,l),1));const[x,b]=a[h/a[p-1][2]<a[p][2]/h?p-1:p];return x.every(b)}return[u,c]}const[du,mu]=gu(et,Yn,an,Ft,En,Pn);function Rn(t){if(0<=t.y&&t.y<100){var n=new Date(-1,t.m,t.d,t.H,t.M,t.S,t.L);return n.setFullYear(t.y),n}return new Date(t.y,t.m,t.d,t.H,t.M,t.S,t.L)}function In(t){if(0<=t.y&&t.y<100){var n=new Date(Date.UTC(-1,t.m,t.d,t.H,t.M,t.S,t.L));return n.setUTCFullYear(t.y),n}return new Date(Date.UTC(t.y,t.m,t.d,t.H,t.M,t.S,t.L))}function $t(t,n,e){return{y:t,m:n,d:e,H:0,M:0,S:0,L:0}}function pu(t){var n=t.dateTime,e=t.date,r=t.time,i=t.periods,o=t.days,a=t.shortDays,u=t.months,c=t.shortMonths,s=Lt(i),f=Pt(i),l=Lt(o),h=Pt(o),p=Lt(a),x=Pt(a),b=Lt(u),U=Pt(u),I=Lt(c),E=Pt(c),k={a:Mt,A:Tt,b:Z,B:Ps,c:null,d:Ge,e:Ge,f:Ru,g:Gu,G:Ju,H:Eu,I:Hu,j:Yu,L:Qe,m:Iu,M:Ou,p:Es,q:Hs,Q:er,s:rr,S:Wu,u:zu,U:Xu,V:qu,w:Vu,W:Bu,x:null,X:null,y:Zu,Y:Qu,Z:Ku,"%":nr},H={a:Ys,A:Rs,b:Is,B:Os,c:null,d:Ke,e:Ke,f:es,g:hs,G:ds,H:ju,I:ts,j:ns,L:je,m:rs,M:is,p:Ws,q:zs,Q:er,s:rr,S:os,u:as,U:us,V:ss,w:cs,W:fs,x:null,X:null,y:ls,Y:gs,Z:ms,"%":nr},m={a:N,A:w,b:S,B:F,c:$,d:Be,e:Be,f:Fu,g:Ve,G:qe,H:Ze,I:Ze,j:Du,L:Uu,m:Su,M:ku,p:A,q:bu,Q:Lu,s:Pu,S:Au,u:_u,U:Mu,V:Tu,w:xu,W:Nu,x:xt,X:_t,y:Ve,Y:qe,Z:Cu,"%":$u};k.x=g(e,k),k.X=g(r,k),k.c=g(n,k),H.x=g(e,H),H.X=g(r,H),H.c=g(n,H);function g(y,M){return function(C){var d=[],R=-1,D=0,O=y.length,W,ft,ur;for(C instanceof Date||(C=new Date(+C));++R<O;)y.charCodeAt(R)===37&&(d.push(y.slice(D,R)),(ft=Xe[W=y.charAt(++R)])!=null?W=y.charAt(++R):ft=W==="e"?" ":"0",(ur=M[W])&&(W=ur(C,ft)),d.push(W),D=R+1);return d.push(y.slice(D,R)),d.join("")}}function v(y,M){return function(C){var d=$t(1900,void 0,1),R=_(d,y,C+="",0),D,O;if(R!=C.length)return null;if("Q"in d)return new Date(d.Q);if("s"in d)return new Date(d.s*1e3+("L"in d?d.L:0));if(M&&!("Z"in d)&&(d.Z=0),"p"in d&&(d.H=d.H%12+d.p*12),d.m===void 0&&(d.m="q"in d?d.q:0),"V"in d){if(d.V<1||d.V>53)return null;"w"in d||(d.w=1),"Z"in d?(D=In($t(d.y,0,1)),O=D.getUTCDay(),D=O>4||O===0?sn.ceil(D):sn(D),D=Hn.offset(D,(d.V-1)*7),d.y=D.getUTCFullYear(),d.m=D.getUTCMonth(),d.d=D.getUTCDate()+(d.w+6)%7):(D=Rn($t(d.y,0,1)),O=D.getDay(),D=O>4||O===0?un.ceil(D):un(D),D=Ft.offset(D,(d.V-1)*7),d.y=D.getFullYear(),d.m=D.getMonth(),d.d=D.getDate()+(d.w+6)%7)}else("W"in d||"U"in d)&&("w"in d||(d.w="u"in d?d.u%7:"W"in d?1:0),O="Z"in d?In($t(d.y,0,1)).getUTCDay():Rn($t(d.y,0,1)).getDay(),d.m=0,d.d="W"in d?(d.w+6)%7+d.W*7-(O+5)%7:d.w+d.U*7-(O+6)%7);return"Z"in d?(d.H+=d.Z/100|0,d.M+=d.Z%100,In(d)):Rn(d)}}function _(y,M,C,d){for(var R=0,D=M.length,O=C.length,W,ft;R<D;){if(d>=O)return-1;if(W=M.charCodeAt(R++),W===37){if(W=M.charAt(R++),ft=m[W in Xe?M.charAt(R++):W],!ft||(d=ft(y,C,d))<0)return-1}else if(W!=C.charCodeAt(d++))return-1}return d}function A(y,M,C){var d=s.exec(M.slice(C));return d?(y.p=f.get(d[0].toLowerCase()),C+d[0].length):-1}function N(y,M,C){var d=p.exec(M.slice(C));return d?(y.w=x.get(d[0].toLowerCase()),C+d[0].length):-1}function w(y,M,C){var d=l.exec(M.slice(C));return d?(y.w=h.get(d[0].toLowerCase()),C+d[0].length):-1}function S(y,M,C){var d=I.exec(M.slice(C));return d?(y.m=E.get(d[0].toLowerCase()),C+d[0].length):-1}function F(y,M,C){var d=b.exec(M.slice(C));return d?(y.m=U.get(d[0].toLowerCase()),C+d[0].length):-1}function $(y,M,C){return _(y,n,M,C)}function xt(y,M,C){return _(y,e,M,C)}function _t(y,M,C){return _(y,r,M,C)}function Mt(y){return a[y.getDay()]}function Tt(y){return o[y.getDay()]}function Z(y){return c[y.getMonth()]}function Ps(y){return u[y.getMonth()]}function Es(y){return i[+(y.getHours()>=12)]}function Hs(y){return 1+~~(y.getMonth()/3)}function Ys(y){return a[y.getUTCDay()]}function Rs(y){return o[y.getUTCDay()]}function Is(y){return c[y.getUTCMonth()]}function Os(y){return u[y.getUTCMonth()]}function Ws(y){return i[+(y.getUTCHours()>=12)]}function zs(y){return 1+~~(y.getUTCMonth()/3)}return{format:function(y){var M=g(y+="",k);return M.toString=function(){return y},M},parse:function(y){var M=v(y+="",!1);return M.toString=function(){return y},M},utcFormat:function(y){var M=g(y+="",H);return M.toString=function(){return y},M},utcParse:function(y){var M=v(y+="",!0);return M.toString=function(){return y},M}}}var Xe={"-":"",_:" ",0:"0"},P=/^\\s*\\d+/,yu=/^%/,wu=/[\\\\^$*+?|[\\]().{}]/g;function T(t,n,e){var r=t<0?"-":"",i=(r?-t:t)+"",o=i.length;return r+(o<e?new Array(e-o+1).join(n)+i:i)}function vu(t){return t.replace(wu,"\\\\$&")}function Lt(t){return new RegExp("^(?:"+t.map(vu).join("|")+")","i")}function Pt(t){return new Map(t.map((n,e)=>[n.toLowerCase(),e]))}function xu(t,n,e){var r=P.exec(n.slice(e,e+1));return r?(t.w=+r[0],e+r[0].length):-1}function _u(t,n,e){var r=P.exec(n.slice(e,e+1));return r?(t.u=+r[0],e+r[0].length):-1}function Mu(t,n,e){var r=P.exec(n.slice(e,e+2));return r?(t.U=+r[0],e+r[0].length):-1}function Tu(t,n,e){var r=P.exec(n.slice(e,e+2));return r?(t.V=+r[0],e+r[0].length):-1}function Nu(t,n,e){var r=P.exec(n.slice(e,e+2));return r?(t.W=+r[0],e+r[0].length):-1}function qe(t,n,e){var r=P.exec(n.slice(e,e+4));return r?(t.y=+r[0],e+r[0].length):-1}function Ve(t,n,e){var r=P.exec(n.slice(e,e+2));return r?(t.y=+r[0]+(+r[0]>68?1900:2e3),e+r[0].length):-1}function Cu(t,n,e){var r=/^(Z)|([+-]\\d\\d)(?::?(\\d\\d))?/.exec(n.slice(e,e+6));return r?(t.Z=r[1]?0:-(r[2]+(r[3]||"00")),e+r[0].length):-1}function bu(t,n,e){var r=P.exec(n.slice(e,e+1));return r?(t.q=r[0]*3-3,e+r[0].length):-1}function Su(t,n,e){var r=P.exec(n.slice(e,e+2));return r?(t.m=r[0]-1,e+r[0].length):-1}function Be(t,n,e){var r=P.exec(n.slice(e,e+2));return r?(t.d=+r[0],e+r[0].length):-1}function Du(t,n,e){var r=P.exec(n.slice(e,e+3));return r?(t.m=0,t.d=+r[0],e+r[0].length):-1}function Ze(t,n,e){var r=P.exec(n.slice(e,e+2));return r?(t.H=+r[0],e+r[0].length):-1}function ku(t,n,e){var r=P.exec(n.slice(e,e+2));return r?(t.M=+r[0],e+r[0].length):-1}function Au(t,n,e){var r=P.exec(n.slice(e,e+2));return r?(t.S=+r[0],e+r[0].length):-1}function Uu(t,n,e){var r=P.exec(n.slice(e,e+3));return r?(t.L=+r[0],e+r[0].length):-1}function Fu(t,n,e){var r=P.exec(n.slice(e,e+6));return r?(t.L=Math.floor(r[0]/1e3),e+r[0].length):-1}function $u(t,n,e){var r=yu.exec(n.slice(e,e+1));return r?e+r[0].length:-1}function Lu(t,n,e){var r=P.exec(n.slice(e));return r?(t.Q=+r[0],e+r[0].length):-1}function Pu(t,n,e){var r=P.exec(n.slice(e));return r?(t.s=+r[0],e+r[0].length):-1}function Ge(t,n){return T(t.getDate(),n,2)}function Eu(t,n){return T(t.getHours(),n,2)}function Hu(t,n){return T(t.getHours()%12||12,n,2)}function Yu(t,n){return T(1+Ft.count(et(t),t),n,3)}function Qe(t,n){return T(t.getMilliseconds(),n,3)}function Ru(t,n){return Qe(t,n)+"000"}function Iu(t,n){return T(t.getMonth()+1,n,2)}function Ou(t,n){return T(t.getMinutes(),n,2)}function Wu(t,n){return T(t.getSeconds(),n,2)}function zu(t){var n=t.getDay();return n===0?7:n}function Xu(t,n){return T(an.count(et(t)-1,t),n,2)}function Je(t){var n=t.getDay();return n>=4||n===0?yt(t):yt.ceil(t)}function qu(t,n){return t=Je(t),T(yt.count(et(t),t)+(et(t).getDay()===4),n,2)}function Vu(t){return t.getDay()}function Bu(t,n){return T(un.count(et(t)-1,t),n,2)}function Zu(t,n){return T(t.getFullYear()%100,n,2)}function Gu(t,n){return t=Je(t),T(t.getFullYear()%100,n,2)}function Qu(t,n){return T(t.getFullYear()%1e4,n,4)}function Ju(t,n){var e=t.getDay();return t=e>=4||e===0?yt(t):yt.ceil(t),T(t.getFullYear()%1e4,n,4)}function Ku(t){var n=t.getTimezoneOffset();return(n>0?"-":(n*=-1,"+"))+T(n/60|0,"0",2)+T(n%60,"0",2)}function Ke(t,n){return T(t.getUTCDate(),n,2)}function ju(t,n){return T(t.getUTCHours(),n,2)}function ts(t,n){return T(t.getUTCHours()%12||12,n,2)}function ns(t,n){return T(1+Hn.count(ct(t),t),n,3)}function je(t,n){return T(t.getUTCMilliseconds(),n,3)}function es(t,n){return je(t,n)+"000"}function rs(t,n){return T(t.getUTCMonth()+1,n,2)}function is(t,n){return T(t.getUTCMinutes(),n,2)}function os(t,n){return T(t.getUTCSeconds(),n,2)}function as(t){var n=t.getUTCDay();return n===0?7:n}function us(t,n){return T(ze.count(ct(t)-1,t),n,2)}function tr(t){var n=t.getUTCDay();return n>=4||n===0?wt(t):wt.ceil(t)}function ss(t,n){return t=tr(t),T(wt.count(ct(t),t)+(ct(t).getUTCDay()===4),n,2)}function cs(t){return t.getUTCDay()}function fs(t,n){return T(sn.count(ct(t)-1,t),n,2)}function ls(t,n){return T(t.getUTCFullYear()%100,n,2)}function hs(t,n){return t=tr(t),T(t.getUTCFullYear()%100,n,2)}function gs(t,n){return T(t.getUTCFullYear()%1e4,n,4)}function ds(t,n){var e=t.getUTCDay();return t=e>=4||e===0?wt(t):wt.ceil(t),T(t.getUTCFullYear()%1e4,n,4)}function ms(){return"+0000"}function nr(){return"%"}function er(t){return+t}function rr(t){return Math.floor(+t/1e3)}var vt,ir;ps({dateTime:"%x, %X",date:"%-m/%-d/%Y",time:"%-I:%M:%S %p",periods:["AM","PM"],days:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"],shortDays:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],months:["January","February","March","April","May","June","July","August","September","October","November","December"],shortMonths:["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"]});function ps(t){return vt=pu(t),ir=vt.format,vt.parse,vt.utcFormat,vt.utcParse,vt}function ys(t){return new Date(t)}function ws(t){return t instanceof Date?+t:+new Date(+t)}function or(t,n,e,r,i,o,a,u,c,s){var f=Ie(),l=f.invert,h=f.domain,p=s(".%L"),x=s(":%S"),b=s("%I:%M"),U=s("%I %p"),I=s("%a %d"),E=s("%b %d"),k=s("%B"),H=s("%Y");function m(g){return(c(g)<g?p:u(g)<g?x:a(g)<g?b:o(g)<g?U:r(g)<g?i(g)<g?I:E:e(g)<g?k:H)(g)}return f.invert=function(g){return new Date(l(g))},f.domain=function(g){return arguments.length?h(Array.from(g,ws)):h().map(ys)},f.ticks=function(g){var v=h();return t(v[0],v[v.length-1],g??10)},f.tickFormat=function(g,v){return v==null?m:s(v)},f.nice=function(g){var v=h();return(!g||typeof g.range!="function")&&(g=n(v[0],v[v.length-1],g??10)),g?h(iu(v,g)):f},f.copy=function(){return Re(f,or(t,n,e,r,i,o,a,u,c,s))},f}function vs(){return He.apply(or(du,mu,et,Yn,an,Ft,En,Pn,pt,ir).domain([new Date(2e3,0,1),new Date(2e3,0,2)]),arguments)}function Et(t,n,e){this.k=t,this.x=n,this.y=e}Et.prototype={constructor:Et,scale:function(t){return t===1?this:new Et(this.k*t,this.x,this.y)},translate:function(t,n){return t===0&n===0?this:new Et(this.k,this.x+this.k*t,this.y+this.k*n)},apply:function(t){return[t[0]*this.k+this.x,t[1]*this.k+this.y]},applyX:function(t){return t*this.k+this.x},applyY:function(t){return t*this.k+this.y},invert:function(t){return[(t[0]-this.x)/this.k,(t[1]-this.y)/this.k]},invertX:function(t){return(t-this.x)/this.k},invertY:function(t){return(t-this.y)/this.k},rescaleX:function(t){return t.copy().domain(t.range().map(this.invertX,this).map(t.invert,t))},rescaleY:function(t){return t.copy().domain(t.range().map(this.invertY,this).map(t.invert,t))},toString:function(){return"translate("+this.x+","+this.y+") scale("+this.k+")"}},Et.prototype;function On(t){return t.mode==="temporal"||t.mode==="left-aligned"?xs(t):_s(t)}function xs({domain:t,range:n}){return vs().domain(t).range(n)}function _s({domain:t,range:n}){return Oe().domain(t).range(n)}function Ms({root_node_ids:t,nodes:n}){try{return Ts(t,n)}catch(e){return console.error(e),ar(t,n)}}function Ts(t,n){const e=new Map,r=[];for(const i of t){e.set(i,0);const o=n.get(i);for(const{id:a}of o.children)r.push(a)}return Wn(r,n,e)}function Wn(t,n,e){for(const r of t){if(e.has(r))continue;const i=n.get(r);if(!i)throw new Error("Node id not found in nodes");const o=[];for(const c of i.parents){const s=e.get(c.id);if(s!==void 0){o.push(s);continue}Wn([c.id],n,e);const f=e.get(c.id);if(f===void 0)throw new Error("Could not determine parent column");o.push(f)}const a=Math.max(...o);e.set(r,a+1);const u=i.children.map(({id:c})=>c);u.length&&Wn(u,n,e)}return e}function ar(t,n,e=0,r=new Map){for(const i of t){const o=r.get(i);(!o||o<e)&&r.set(i,e);const a=n.get(i);for(const{id:u}of a.children)ar([u],n,e+1,r)}return r}function Ns(t){return t.horizontalSettings.mode==="dependency"?Cs(t):t.horizontalSettings.mode==="left-aligned"?Ss(t):bs(t)}function Cs({data:t,horizontalSettings:n}){const e=Ms(t),r=On(n),i=new Map;for(const[o]of t.nodes){const a=e.get(o);if(a===void 0){console.warn(`Node not found in columns: Skipping ${o}`);continue}i.set(o,{x:r(a),column:a})}return i}function bs({data:t,horizontalSettings:n}){const e=On(n),r=new Map;for(const[i,o]of t.nodes){const a=e(o.start_time);r.set(i,{column:a,x:a})}return r}function Ss({data:t,horizontalSettings:n}){const e=On(n),r=new Map;for(const[i]of t.nodes)r.set(i,{column:0,x:e(t.start_time)});return r}async function Ds(t,n){const i=new Map,o=new Map;let a=0;const u=new Map;for await(const[m]of t.data.nodes){const g=t.data.nodes.get(m);if(!g){console.warn("NearestParentLayout: Node was not found in the data",m);continue}const v=await c(g);k(m,v)}return H(),u;async function c(m){const{x:g}=n.get(m.id)??{};if(g===void 0)return console.warn("NearestParentLayout: Node was not found in the horizontal layout",m.id),0;if(m.parents.length===1)return u.has(m.parents[0].id)?await f(m.parents[0].id,g):(console.warn("NearestParentLayout: Parent node not found in layout",m.parents[0].id),0);if(m.parents.length>0){const v=m.parents.map(({id:w})=>{const S=u.get(w);return S===void 0?(console.warn("NearestParentLayout: Parent node not found in layout",w),0):S}),A=v.reduce((w,S)=>w+S,0)/v.length,N=Math.round(A);if(l(g,N)){const w=x(g,N),S=m.parents.map(({id:$})=>$),F=w.filter($=>S.includes($));if(F.length>0||w.length>1){const[$]=F.length>0?F:w,xt=b(v,N,i.get($));return i.set($,xt),await f($,g)}return await U({competingNodeId:w[0],upstreamRows:v,nodeStartX:g,desiredRow:N})}}return s(g,0)}function s(m,g){return l(m,g)?s(m,g+1):g}async function f(m,g){const v=u.get(m);if(v===void 0)return console.warn("NearestParentLayout: Upstream node not found in layout",m),0;i.get(m)||i.set(m,1);const _=i.get(m);return l(g,v)?_===1&&!l(g,v+1)?(i.set(m,-1),v+1):l(g,v-1)?(await h({direction:_,nodeStartX:g,desiredRow:v+_}),i.set(m,_===1?-1:1),v+_):(i.set(m,1),v-1):v}function l(m,g){if(u.size===0)return!1;let v=!1;const _=o.get(g)??[];for(const A of _){const N=u.get(A),w=E(A);if(p({firstNodeEndX:w,firstNodeRow:N,lastNodeStartX:m,lastNodeRow:g})){v=!0;break}}return v}async function h({direction:m,nodeStartX:g,desiredRow:v}){const _=x(g,v);if(_)for await(const A of _){const N=u.get(A),{x:w}=n.get(A)??{};if(N===void 0||w===void 0){console.warn("NearestParentLayout - shove: Node was not found in the vertical or horizontal layout",A);continue}const S=N+m;await h({direction:m,nodeStartX:w,desiredRow:S}),k(A,S)}}function p({firstNodeEndX:m,firstNodeRow:g,lastNodeStartX:v,lastNodeRow:_}){return g===_&&m+16>=v}function x(m,g){const v=[],_=o.get(g)??[];for(const A of _){const N=E(A),w=u.get(A);if(w===void 0){console.warn("NearestParentLayout - getOverlappingNodeIds: Node was not found in the layout",A);continue}p({firstNodeEndX:N,firstNodeRow:w,lastNodeStartX:m,lastNodeRow:g})&&v.push(A)}if(v.length!==0)return v.sort((A,N)=>{const w=E(A),S=E(N);return w<S?1:w>S?-1:0}),v}function b(m,g,v){const _=m.filter(N=>N<g).length,A=m.filter(N=>N>g).length;return _>A?-1:v??1}async function U({desiredRow:m,nodeStartX:g,upstreamRows:v,competingNodeId:_}){if(u.get(_)===void 0)return console.warn("NearestParentLayout - argueWithCompetingUpstreamPlacement: Competitor node was not found in the layout",_),m;const[N,w]=I(_),S=v.filter($=>$<m).length,F=v.filter($=>$>m).length;if(S>F){if(N>w&&N>S)return await h({direction:-1,nodeStartX:g,desiredRow:m}),m;if(w>N)return await h({direction:1,nodeStartX:g,desiredRow:m}),m;i.set(_,-1)}if(F>S){if(w>N&&w>F)return await h({direction:1,nodeStartX:g,desiredRow:m}),m;if(N>w)return await h({direction:-1,nodeStartX:g,desiredRow:m}),m;i.set(_,1)}return await f(_,g)}function I(m){const g=t.data.nodes.get(m),v=u.get(m);return!g||v===void 0?(console.warn("NearestParentLayout: Node was not found in either the data or layout",m),[0,0]):g.parents.reduce((_,A)=>{const N=u.get(A.id);return N===void 0?(console.warn("NearestParentLayout - getNodeParentDirectionCounts: Parent node not found on layout data",m),_):(N<v&&(_[0]+=1),N>v&&(_[1]+=1),_)},[0,0])}function E(m){const{x:g}=n.get(m)??{},v=t.widths.get(m);return g===void 0||v===void 0?(console.warn("NearestParentLayout: Node was not found in the horizontal layout and/or widths",m),0):g+v}function k(m,g){if(g<a&&(a=g),u.has(m)){const v=u.get(m);o.get(v)?.delete(m)}o.has(g)||o.set(g,new Set),o.get(g)?.add(m),u.set(m,g)}function H(){if(a<0)for(const[m]of u){const g=u.get(m);u.set(m,g+Math.abs(a))}}}async function ks(t,n){return t.verticalSettings.mode==="nearest-parent"?await Ds(t,n):t.verticalSettings.mode==="duration-sorted"?Us(t):As(t)}function As(t){const n=new Map;let e=0;for(const[r]of t.data.nodes)n.set(r,e++);return n}function Us(t){const n=new Map,e=[...t.data.nodes.values()].sort((i,o)=>{const a=(i.end_time?i.end_time.getTime():new Date().getTime())-i.start_time.getTime();return(o.end_time?o.end_time.getTime():new Date().getTime())-o.start_time.getTime()-a});let r=0;for(const i of e)n.set(i.id,r++);return n}onmessage=Fs;function Fs({data:t}){const{type:n}=t;switch(n){case"layout":Ls(t);return;default:sr(n)}}function $s(t){postMessage(t)}async function Ls(t){const{data:n}=t,e=Ns(t),r=await ks(t,e),i=new Map;let o=0,a=0;for(const[u,c]of n.nodes){const s=e.get(u),f=r.get(u);if(s===void 0){console.warn(`NodeId not found in horizontal layout: Skipping ${c.label}`);continue}if(f===void 0){console.warn(`NodeId not found in vertical layout: Skipping ${c.label}`);continue}o=Math.max(o,f),a=Math.max(a,s.column),i.set(u,{...s,y:f,row:f})}$s({type:"layout",layout:{maxRow:o,maxColumn:a,positions:i}})}})();\n//# sourceMappingURL=runGraph.worker-CMp6PAdj.js.map\n', _I = typeof self < "u" && self.Blob && new Blob(["(self.URL || self.webkitURL).revokeObjectURL(self.location.href);", OU], { type: "text/javascript;charset=utf-8" });
function SCe(t) {
  let e;
  try {
    if (e = _I && (self.URL || self.webkitURL).createObjectURL(_I), !e) throw "";
    const n = new Worker(e, {
      name: t?.name
    });
    return n.addEventListener("error", () => {
      (self.URL || self.webkitURL).revokeObjectURL(e);
    }), n;
  } catch {
    return new Worker(
      "data:text/javascript;charset=utf-8," + encodeURIComponent(OU),
      {
        name: t?.name
      }
    );
  }
}
function RCe(t) {
  const e = new SCe();
  return e.onmessage = t, e;
}
async function mR() {
  const t = /* @__PURE__ */ new Map(), e = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Map(), r = new fn(), o = new fn(), s = await wr();
  let i = null;
  const u = vI({
    gap: () => s.rowGap,
    minimum: () => s.nodeHeight
  }), l = vI({
    gap: () => s.columnGap,
    minimum: () => QS()
  });
  let a = null, c = null;
  r.name = NL, Ze.on("layoutUpdated", () => {
    u.clear(), l.clear();
  }), Ze.on("layoutSettingsUpdated", () => {
    c && r.parent && p(c), de();
  }), Ze.on("itemSelected", () => {
    de();
  });
  async function p(J) {
    d(), c = J, a = null, await Promise.all([
      m(J),
      _(J)
    ]), x(J);
  }
  function d() {
    i || (i = RCe(G));
  }
  function h() {
    i && (i.terminate(), i = null);
  }
  async function m(J) {
    const oe = [];
    for (const ue of J.nodes.values())
      oe.push(g(ue));
    await Promise.all(oe);
  }
  async function g(J) {
    const { render: oe } = await A(J), ue = M(J.id);
    return await oe(J, ue);
  }
  async function _(J) {
    if ((await eo()).disableEdges) {
      r.removeChild(o);
      return;
    }
    r.addChildAt(o, 0);
    const oe = [];
    for (const [ue, { children: me }] of J.nodes)
      for (const { id: pe } of me)
        oe.push(b(ue, pe));
    await Promise.all(oe);
  }
  async function b(J, oe) {
    const ue = `${J}_${oe}`;
    if (n.has(ue))
      return;
    const me = await hRe();
    n.has(ue) || (n.set(ue, me), o.addChild(me.element));
  }
  function x(J) {
    if (!i)
      throw new Error("Layout worker not initialized");
    const oe = /* @__PURE__ */ new Map();
    for (const [ue, { element: me }] of e)
      oe.set(ue, me.width);
    i.postMessage({
      type: "layout",
      data: J,
      widths: oe,
      horizontalSettings: ix(J.start_time),
      verticalSettings: dCe()
    });
  }
  function S() {
    if (a)
      for (const [J, oe] of n) {
        const [ue, me] = J.split("_"), pe = a.positions.get(ue), Be = a.positions.get(me), Ie = e.get(ue);
        if (!pe || !Be) {
          console.warn(`Could not find edge in layout: Skipping ${J}`);
          continue;
        }
        if (!Ie) {
          console.warn(`Could not find parent node in nodes: Skipping ${ue}`);
          continue;
        }
        const Me = Ie.bar.width, fe = L(pe), Te = {
          x: fe.x + Me,
          y: fe.y + s.nodeHeight / 2
        }, Ae = L(Be), we = {
          x: Ae.x - Te.x,
          y: Ae.y - Te.y + s.nodeHeight / 2
        };
        oe.setPosition(Te, we);
      }
  }
  function E() {
    if (a) {
      for (const [J, oe] of e) {
        const ue = a.positions.get(J);
        if (!ue) {
          console.warn(`Could not find node in layout: Skipping ${J}`);
          continue;
        }
        const me = L(ue);
        oe.setPosition(me), u.updateNodeAxis({ nodeId: J, axis: ue.y }), l.updateNodeAxis({ nodeId: J, axis: ue.column });
      }
      S(), r.emit("rendered"), r.emit("resized", W());
    }
  }
  async function A(J) {
    const oe = t.get(J.id);
    if (oe)
      return oe;
    const ue = M(J.id), me = TCe(J, ue);
    t.set(J.id, me);
    const pe = await me;
    return pe.element.on("resized", (Be) => C(J.id, Be)), r.addChild(pe.element), e.set(J.id, pe), pe;
  }
  function C(J, oe) {
    if (!a)
      return;
    const ue = e.get(J), me = a.positions.get(J);
    !ue || !me || (u.setOffset({ nodeId: J, axis: me.y, offset: oe.height }), l.setOffset({ nodeId: J, axis: me.column, offset: oe.width }), E());
  }
  function M(J) {
    return c?.nested_task_run_graphs?.get(J);
  }
  function L(J) {
    const oe = u.getTotalOffset(J.y);
    return {
      x: X(J),
      y: oe
    };
  }
  function X(J) {
    return ot.isDependency() ? l.getTotalOffset(J.column) : J.x;
  }
  function te() {
    return a ? u.getTotalValue(a.maxRow) : 0;
  }
  function B() {
    if (!a || !c)
      return 0;
    if (ot.isDependency())
      return l.getTotalValue(a.maxColumn);
    const J = ix(c.start_time), oe = AU(J), ue = oe(c.end_time ?? /* @__PURE__ */ new Date()), me = oe(c.start_time);
    return ue - me;
  }
  function W() {
    return {
      width: B(),
      height: te()
    };
  }
  function G({ data: J }) {
    const { type: oe } = J;
    switch (oe) {
      case "layout":
        ne(J);
        return;
      default:
        xCe(oe);
    }
  }
  function ne(J) {
    a = J.layout, E();
  }
  async function de() {
    const J = await eo(), oe = VRe();
    if (J.disableEdges || !oe || !c?.nodes.has(oe.id)) {
      V([]);
      return;
    }
    const ue = ae(oe.id);
    V(ue);
  }
  function V(J) {
    Y(J), Q(J);
  }
  function Y(J) {
    for (const [oe, { element: ue }] of e) {
      if (J.length === 0 || J.includes(oe)) {
        ue.alpha = 1;
        continue;
      }
      ue.alpha = s.nodeUnselectedAlpha;
    }
  }
  function Q(J) {
    for (const [oe, { element: ue }] of n) {
      const [me, pe] = oe.split("_");
      if (J.length === 0 || J.includes(me) && J.includes(pe)) {
        ue.alpha = 1;
        continue;
      }
      ue.alpha = s.nodeUnselectedAlpha;
    }
  }
  function ae(J) {
    const oe = Z(J, "parents"), ue = Z(J, "children");
    return [J, ...oe, ...ue];
  }
  function Z(J, oe) {
    const ue = c?.nodes.get(J);
    if (!ue)
      return [];
    const me = [];
    for (const { id: pe } of ue[oe])
      me.push(pe), me.push(...Z(pe, oe));
    return me;
  }
  return {
    element: r,
    stopWorker: h,
    getSize: W,
    render: p
  };
}
let lx = null, cp = null, zp = null;
async function ACe() {
  const t = await ro(), e = await oa(), { element: n, render: r } = await mR();
  t.addChild(n), n.alpha = 0;
  const o = await S6(e.runId, async (s) => {
    const i = cp ? "runDataUpdated" : "runDataCreated";
    cp = s, Ze.emit(i, cp), await eo(), r(s);
  });
  Ze.on("configUpdated", () => {
    cp && r(cp);
  }), zp = n, lx = o.stop, zp.once("rendered", () => ECe()), Ze.on("layoutUpdated", () => MCe()), o.start();
}
function DCe() {
  lx?.(), lx = null, zp = null, cp = null;
}
async function ku() {
  return cp || await Is("runDataCreated");
}
function ECe() {
  yR(), es.shared.addOnce(() => {
    zp && (zp.alpha = 1);
  });
}
async function MCe() {
  if (!zp)
    return;
  const t = await oa();
  zp.once("rendered", () => {
    setTimeout(() => {
      yR({ animate: !0 });
    }, t.animationDuration);
  });
}
let Ys = null, cx = null;
async function PCe() {
  const t = await no(), e = await CS();
  Ys = new D2e({
    screenHeight: e.clientHeight,
    screenWidth: e.clientWidth,
    events: t.renderer.events,
    passiveWheel: !1
  }), Ys.zIndex = hwe, Ys.drag().pinch().wheel({
    trackpadPinch: !0
  }).decelerate({
    friction: 0.9
  }).clampZoom({
    minWidth: e.clientWidth / 2
  }), Ys.on("moved", () => {
    Ze.emit("viewportMoved", null);
  }).on("moved-end", () => {
    Ze.emit("viewportMoved", null);
  }), t.stage.addChild(Ys), Ze.emit("viewportCreated", Ys), Ze.on("applicationResized", BCe), Ze.on("scaleUpdated", () => Am()), NCe();
}
function CCe() {
  Ys = null, cx = null;
}
async function yR({ animate: t } = {}) {
  const e = (await ro()).getChildByName(NL);
  if (!e)
    throw new Error("Nodes container not found");
  $Ce();
  const { x: n, y: r, width: o, height: s } = e.getLocalBounds();
  if (!o || !s) {
    ICe({ animate: t });
    return;
  }
  OCe({ x: n, y: r, width: o, height: s, animate: t });
}
async function OCe({ x: t, y: e, width: n, height: r, animate: o }) {
  const s = await oa(), i = await wr(), u = await ro(), {
    guideTextSize: l,
    guideTextTopPadding: a,
    columnGap: c,
    rowGap: p,
    eventTargetSize: d
  } = i, h = l + a, m = n + c * 2, g = r + p * 4 + h + d, _ = u.findFit(m, g);
  u.animate({
    position: {
      x: t + n / 2,
      y: e + r / 2 + h
    },
    scale: Math.min(_, 1),
    time: o ? s.animationDuration : 0,
    ease: "easeInOutQuad",
    removeOnInterrupt: !0,
    callbackOnComplete: () => {
      yy(), Am();
    }
  });
}
async function ICe({ animate: t }) {
  const e = await ku(), n = await oa(), r = await wr(), o = await ro(), s = await Wa();
  let i = s(e.start_time) - r.columnGap, u = s(e.end_time ?? /* @__PURE__ */ new Date()) + r.columnGap;
  if (i > u) {
    const p = i;
    i = u, u = p;
  }
  const l = u - i, a = i + l / 2, c = o.findFit(l, 0);
  o.animate({
    position: {
      x: a,
      y: 0
    },
    scale: c,
    time: t ? n.animationDuration : 0,
    ease: "easeInOutQuad",
    removeOnInterrupt: !0,
    callbackOnComplete: () => {
      yy(), Am();
    }
  });
}
async function ro() {
  return Ys || await Is("viewportCreated");
}
function IU(t) {
  T6(cx, t) || (cx = t, Ze.emit("viewportDateRangeUpdated", t));
}
function FCe({ xOffset: t, yOffset: e }) {
  if (!Ys)
    return;
  const { x: n, y: r } = Ys.transform.position;
  Ys.setTransform(
    n + t,
    r + e,
    Ys.transform.scale.x,
    Ys.transform.scale.y
  );
}
async function NCe() {
  const t = await ro();
  Am(), t.on("moved", () => Am());
}
async function Am() {
  const t = await FU();
  t && IU(t);
}
async function FU() {
  const t = await ro(), e = await Wa(), n = e.invert(t.left), r = e.invert(t.right);
  return n instanceof Date && r instanceof Date ? [n, r] : null;
}
async function LCe(t) {
  const e = await FU(), n = await eo();
  if (t === void 0 || n.isDependency() || T6(t, e))
    return;
  const r = await ro(), o = await Wa(), [s, i] = t, u = o(s), l = o(i), a = u + (l - u) / 2;
  IU(t), r.fitWidth(l - u, !0), r.moveCenter(a, r.center.y);
}
async function BCe() {
  const t = await no(), e = await ro(), n = await CS(), r = e.screenWidth, o = e.screenHeight, s = n.clientWidth, i = n.clientHeight, u = (s - r) / 2, l = (i - o) / 2;
  e.resize(t.screen.width, t.screen.height), FCe({
    xOffset: u,
    yOffset: l
  });
}
class Ug {
  status = "visible";
  labels = /* @__PURE__ */ new Set();
  get visible() {
    return this.status === "visible";
  }
  get hidden() {
    return this.status === "hidden";
  }
  show() {
    if (this.status !== "visible") {
      for (const e of this.labels)
        e.visible = !0;
      this.status = "visible";
    }
  }
  hide() {
    if (this.status !== "hidden") {
      for (const e of this.labels)
        e.visible = !1;
      this.status = "hidden";
    }
  }
  toggle(e) {
    e ? this.show() : this.hide();
  }
  add(e) {
    this.labels.add(e), e.visible = this.visible;
  }
  clear() {
    this.labels.clear();
  }
}
let Pp = null, gp = null, Dm = null, sm = null, nh = null;
async function UCe() {
  const t = await ro(), e = await no();
  Pp = new Yxe({
    toggle: "renderable"
  }), gp = new Ug(), Dm = new Ug(), nh = new Ug(), sm = new Ug(), e.ticker.add(() => {
    if (t.dirty) {
      const n = t.scale.x > pwe, r = t.scale.x > uwe, o = t.scale.x > lwe, s = t.scale.x > cwe;
      nh?.toggle(n), gp?.toggle(r), Dm?.toggle(o), sm?.toggle(s), Pp?.cull(e.renderer.screen), t.dirty = !1;
    }
  }), Ze.emit("cullCreated", Pp), Ze.emit("labelCullCreated", gp), Ze.emit("iconCullCreated", gp), Ze.emit("edgeCullCreated", nh), Ze.emit("toggleCullCreated", sm);
}
function XCe() {
  Pp = null, gp?.clear(), gp = null, Dm?.clear(), Dm = null, nh?.clear(), nh = null, sm?.clear(), sm = null;
}
async function yy() {
  const t = await ro();
  t.dirty = !0;
}
function $Ce() {
  Pp && Pp.uncull();
}
async function NU() {
  return Pp || await Is("cullCreated");
}
async function WCe() {
  return nh || await Is("edgeCullCreated");
}
async function LU() {
  return gp || await Is("labelCullCreated");
}
async function BU() {
  return Dm || await Is("iconCullCreated");
}
async function VCe() {
  const t = await no(), e = await ku(), n = await eo(), { element: r, render: o, update: s } = await MU({ isRoot: !0 });
  r.zIndex = ywe;
  function i(u) {
    if (ot.isTemporal() && !n.disableArtifacts) {
      t.stage.addChild(r), o(u?.artifacts);
      return;
    }
    t.stage.removeChild(r);
  }
  e.artifacts && i(e), Ze.on("viewportMoved", () => s()), Ze.on("runDataCreated", (u) => i(u)), Ze.on("runDataUpdated", (u) => i(u)), Ze.on("configUpdated", () => i()), Ze.on("layoutSettingsUpdated", () => i());
}
async function HCe() {
  const t = await no(), e = await ku(), { element: n, render: r } = await PU({ isRoot: !0 });
  n.zIndex = mwe, t.stage.addChild(n);
  function o(s) {
    r(s?.states);
  }
  e.states && o(e), Ze.on("runDataUpdated", (s) => o(s)), Ze.on("configUpdated", () => o()), Ze.on("layoutSettingsUpdated", () => o());
}
async function jCe() {
  const t = await no(), e = await ro(), n = await eo(), r = await wr(), o = await M5(), s = new fn(), i = await ll();
  s.addChild(i);
  const u = o("");
  s.addChild(u);
  let l = await Wa(), a, c;
  Ze.on("scaleUpdated", (g) => {
    l = g, m();
  }), Ze.on("viewportMoved", () => {
    n.disableGuides || (m(), s.height !== t.screen.height && d());
  });
  function p(g, _) {
    a = g, c = _, d(), h(g);
  }
  function d() {
    i.width = r.guideLineWidth, i.height = t.screen.height, i.tint = r.guideLineColor;
  }
  function h(g) {
    u.text = c(g), u.fontSize = r.guideTextSize, u.tint = r.guideTextColor, u.position.set(r.guideTextLeftPadding, r.guideTextTopPadding);
  }
  function m() {
    a !== void 0 && (s.position.x = l(a) * e.scale._x + e.worldTransform.tx);
  }
  return {
    element: s,
    render: p
  };
}
class wI extends Error {
  constructor() {
    super("Layout is not temporal");
  }
}
function zCe(t) {
  return t.toLocaleTimeString();
}
function bI(t) {
  const e = navigator.language;
  return new Intl.DateTimeFormat(e, { timeStyle: "short" }).format(t);
}
function qCe(t) {
  const e = navigator.language;
  return new Intl.DateTimeFormat(e, { dateStyle: "short" }).format(t);
}
function GCe(t) {
  return t.getHours() === 0 && t.getMinutes() === 0 ? `${w0.date(t)}
${bI(t)}` : bI(t);
}
const w0 = {
  timeBySeconds: zCe,
  timeByMinutesWithDates: GCe,
  date: qCe
}, ao = {
  seconds: "seconds",
  minutes: "minutes",
  date: "date"
}, Df = {
  day: (t) => {
    const e = new Date(t.getTime());
    return e.setHours(0, 0, 0, 0), e.getTime();
  },
  week: (t) => {
    const e = new Date(t.getTime());
    return e.setHours(0, 0, 0, 0), e.setDate(t.getDate() - t.getDay() + 1), e.getTime();
  }
}, _n = {
  second: 1e3,
  minute: 1e3 * 60,
  hour: 1e3 * 60 * 60,
  day: 1e3 * 60 * 60 * 24,
  week: 1e3 * 60 * 60 * 24 * 7
}, kI = [
  {
    ceiling: _n.second * 4,
    increment: _n.second,
    labelFormat: ao.seconds
  },
  {
    ceiling: _n.second * 8,
    increment: _n.second * 5,
    labelFormat: ao.seconds
  },
  {
    ceiling: _n.second * 13,
    increment: _n.second * 10,
    labelFormat: ao.seconds
  },
  {
    ceiling: _n.second * 20,
    increment: _n.second * 15,
    labelFormat: ao.seconds
  },
  {
    ceiling: _n.second * 45,
    increment: _n.second * 30,
    labelFormat: ao.seconds
  },
  {
    ceiling: _n.minute * 4,
    increment: _n.minute,
    labelFormat: ao.minutes
  },
  {
    ceiling: _n.minute * 8,
    increment: _n.minute * 5,
    labelFormat: ao.minutes
  },
  {
    ceiling: _n.minute * 13,
    increment: _n.minute * 10,
    labelFormat: ao.minutes
  },
  {
    ceiling: _n.minute * 28,
    increment: _n.minute * 15,
    labelFormat: ao.minutes
  },
  {
    ceiling: _n.hour * 1.24,
    increment: _n.minute * 30,
    labelFormat: ao.minutes
  },
  {
    ceiling: _n.hour * 3,
    increment: _n.hour,
    labelFormat: ao.minutes
  },
  {
    ceiling: _n.hour * 8,
    increment: _n.hour * 2,
    getAnchor: Df.day,
    labelFormat: ao.minutes
  },
  {
    ceiling: _n.hour * 13,
    increment: _n.hour * 6,
    getAnchor: Df.day,
    labelFormat: ao.minutes
  },
  {
    ceiling: _n.hour * 22,
    increment: _n.hour * 12,
    getAnchor: Df.day,
    labelFormat: ao.minutes
  },
  {
    ceiling: _n.day * 4,
    increment: _n.day,
    getAnchor: Df.day,
    labelFormat: ao.date
  },
  {
    ceiling: _n.week * 2,
    increment: _n.week,
    getAnchor: Df.week,
    labelFormat: ao.date
  },
  {
    ceiling: 1 / 0,
    increment: _n.week * 4,
    labelFormat: ao.date
  }
], YCe = 300;
async function QCe() {
  const t = await ro(), e = await eo(), n = new fn(), r = /* @__PURE__ */ new Map();
  let o = await Wa();
  Ze.on("scaleUpdated", (d) => o = d), await i();
  function s() {
    if (n.visible = !e.disableGuides, !e.disableGuides)
      try {
        const { anchor: d, increment: h, labelFormat: m } = u(), g = p(d, h);
        c(g, m);
      } catch (d) {
        if (d instanceof wI)
          return;
        console.error(d);
      }
  }
  async function i() {
    const d = [];
    KT(UM, async (h) => {
      const m = jCe();
      d.push(m);
      const g = await m;
      n.addChild(g.element), r.set(h, g);
    }), await Promise.all(d);
  }
  function u() {
    const d = t.left - YCe, h = o.invert(d), m = o.invert(d + dwe / t.scale.x);
    if (!(h instanceof Date) || !(m instanceof Date))
      throw new wI();
    const g = m.getTime() - h.getTime(), { increment: _, getAnchor: b, labelFormat: x } = l(g);
    return {
      anchor: b(h),
      increment: _,
      labelFormat: a(x)
    };
  }
  function l(d) {
    const h = kI.find((m) => m.ceiling > d) ?? kI[0];
    return h.getAnchor || (h.getAnchor = (m) => Math.floor(m.getTime() / h.increment) * h.increment), h;
  }
  function a(d) {
    switch (d) {
      case ao.minutes:
        return w0.timeByMinutesWithDates;
      case ao.date:
        return w0.date;
      default:
        return w0.timeBySeconds;
    }
  }
  function c(d, h) {
    const m = new Map(r.entries()), g = Array.from(m.keys()).filter((_) => !d.includes(_));
    r.clear();
    for (const _ of d) {
      if (m.has(_)) {
        const x = m.get(_);
        r.set(_, x), x.render(new Date(_), h);
        continue;
      }
      const b = m.get(g.pop() ?? -1);
      if (b === void 0) {
        console.warn("Guides: No unused guides available to render.");
        continue;
      }
      b.render(new Date(_), h), r.set(_, b);
    }
  }
  function p(d, h) {
    return KT(UM, (m) => d + h * m);
  }
  return {
    element: n,
    render: s
  };
}
async function KCe() {
  const t = await no(), { element: e, render: n } = await QCe();
  t.stage.addChild(e), n(), Ze.on("viewportDateRangeUpdated", () => n()), Ze.on("layoutSettingsUpdated", () => n()), Ze.on("configUpdated", () => n());
}
const ZCe = 80;
async function JCe() {
  const t = await no(), e = await ro(), n = await eo(), r = await wr(), o = await ll();
  let s = await Wa();
  Ze.on("scaleUpdated", (l) => s = l);
  function i() {
    if (!n.isTemporal()) {
      o.visible = !1;
      return;
    }
    o.width = r.playheadWidth, o.height = t.stage.height, o.tint = r.playheadColor, o.position.x = s(/* @__PURE__ */ new Date()) * e.scale.x + e.worldTransform.tx, u();
  }
  function u() {
    if (e.moving || !(o.position.x > 0 && o.position.x < t.screen.width) || !(o.position.x > t.screen.width - ZCe))
      return;
    const l = e.left;
    e.zoomPercent(-0.1, !0), e.left = l;
  }
  return {
    element: o,
    render: i
  };
}
async function eOe() {
  const t = await no(), e = await ku(), { element: n, render: r } = await JCe();
  e.end_time || (t.stage.addChild(n), t.ticker.add(r)), Ze.on("runDataUpdated", ({ end_time: o }) => {
    o && (t.ticker.remove(r), t.stage.removeChild(n));
  });
}
function tOe({ stage: t, config: e }) {
  Xxe(), PCe(), hCe(), KCe(), ACe(), VCe(), mCe(), HCe(), eOe(), LRe(), Bxe(t), qxe(e), YSe(), UCe(), JSe(), $Re();
}
function nOe() {
  Ze.clear();
  try {
    $xe(), CCe(), fCe(), Uxe(), DCe(), yCe(), Gxe(), QSe(), URe(), XCe(), eRe(), WRe(), Hxe();
  } catch (t) {
    console.error(t);
  }
}
function UU(t) {
  if (!(t instanceof HTMLElement))
    return !1;
  const e = t.tagName.toLowerCase();
  return ["input", "textarea"].includes(e);
}
const rOe = { class: "flex items-center gap-2" }, oOe = /* @__PURE__ */ U({
  __name: "RunGraphSettings",
  setup(t) {
    const e = [qr.topRight, qr.bottomRight, qr.topLeft, qr.bottomLeft];
    function n(_) {
      const [b, x] = _.split("_");
      return rwe(b) && nwe(x);
    }
    const r = [
      {
        label: "Temporal dependency",
        value: "temporal_nearest-parent"
      },
      {
        label: "Temporal sequence",
        value: "temporal_waterfall"
      },
      {
        label: "Dependency grid",
        value: "dependency_nearest-parent"
      },
      {
        label: "Sequential grid",
        value: "dependency_waterfall"
      },
      {
        label: "Comparative duration",
        value: "left-aligned_duration-sorted"
      }
    ], o = ge(`${ot.horizontal}_${ot.vertical}`);
    function s(_) {
      if (typeof _ != "string" || !n(_))
        return;
      o.value = _;
      const [b, x] = _.split("_");
      oRe(b), sRe(x);
    }
    const i = ge(ot.disableEdges);
    function u(_) {
      i.value = !!_, aRe(i.value);
    }
    const l = ge(ot.disableArtifacts);
    function a(_) {
      l.value = !!_, iRe(l.value);
    }
    const c = ge(ot.disableEvents);
    function p(_) {
      c.value = !!_, uRe(c.value);
    }
    function d() {
      const _ = BM + 1, b = ot.horizontalScaleMultiplier * _;
      xv(b);
    }
    function h() {
      const _ = Math.abs(BM - 1), b = ot.horizontalScaleMultiplier * _;
      xv(b);
    }
    $I(["-", "="], m);
    function m(_) {
      if (!(UU(_.target) || _.metaKey || _.ctrlKey))
        switch (_.key) {
          case "-":
            h();
            break;
          case "=":
            d();
            break;
        }
    }
    function g() {
      rRe();
    }
    return (_, b) => {
      const x = P("p-radio-group"), S = P("p-label"), E = P("p-divider"), A = P("p-checkbox"), C = P("p-overflow-menu");
      return T(), O(v(Hv), {
        class: "run-graph-settings",
        "auto-close": "",
        placement: e
      }, {
        target: k(({ toggle: M }) => [
          w(v(Zo), {
            "aria-label": "Run Graph Options",
            icon: "CogIcon",
            flat: "",
            onClick: M
          }, null, 8, ["onClick"])
        ]),
        default: k(() => [
          w(C, { class: "run-graph-settings__menu" }, {
            default: k(() => [
              w(S, { label: "Layout" }, {
                default: k(() => [
                  w(x, {
                    "model-value": o.value,
                    options: r,
                    "onUpdate:modelValue": s
                  }, {
                    label: k(({ option: M }) => [
                      q(ie(M.label), 1)
                    ]),
                    _: 1
                  }, 8, ["model-value"])
                ]),
                _: 1
              }),
              v(ot).isTemporal() || v(ot).isLeftAligned() ? (T(), z(ve, { key: 0 }, [
                w(E),
                w(S, { label: "Scaling" }, {
                  default: k(() => [
                    re("div", rOe, [
                      w(v(Zo), {
                        title: "Decrease scale (-)",
                        small: "",
                        icon: "MinusIcon",
                        onClick: h
                      }),
                      w(v(Zo), {
                        title: "Increase scale (+)",
                        small: "",
                        icon: "PlusIcon",
                        onClick: d
                      }),
                      w(v(Zo), {
                        small: "",
                        onClick: g
                      }, {
                        default: k(() => [...b[0] || (b[0] = [
                          q(" Reset ", -1)
                        ])]),
                        _: 1
                      })
                    ])
                  ]),
                  _: 1
                })
              ], 64)) : j("", !0),
              w(E),
              w(A, {
                "model-value": i.value,
                label: "Hide dependency arrows",
                "onUpdate:modelValue": u
              }, null, 8, ["model-value"]),
              w(A, {
                "model-value": l.value,
                label: "Hide artifacts",
                "onUpdate:modelValue": a
              }, null, 8, ["model-value"]),
              w(A, {
                "model-value": c.value,
                label: "Hide events",
                "onUpdate:modelValue": p
              }, null, 8, ["model-value"])
            ]),
            _: 1
          })
        ]),
        _: 1
      });
    };
  }
}), sOe = { class: "run-graph__actions" }, aOe = /* @__PURE__ */ U({
  __name: "RunGraph",
  props: {
    config: {},
    viewport: {},
    fullscreen: { type: [Boolean, null], default: null },
    selected: { default: null }
  },
  emits: ["update:viewport", "update:fullscreen", "update:selected"],
  setup(t, { emit: e }) {
    const n = t, r = e, o = ge(), s = ge(!1), i = D({
      get() {
        return n.fullscreen ?? s.value;
      },
      set(p) {
        s.value = p, r("update:fullscreen", p);
      }
    });
    Ct(() => n.selected, (p) => wu(p)), Ze.on("itemSelected", (p) => r("update:selected", p)), Ct(() => n.viewport, (p) => LCe(p)), Ct(() => n.config, (p) => k6(p));
    const u = D(() => ({
      root: {
        "run-graph--fullscreen": i.value
      }
    }));
    Ze.on("viewportDateRangeUpdated", (p) => r("update:viewport", p));
    function l() {
      yR({ animate: !0 });
    }
    function a() {
      i.value = !i.value;
    }
    wi(() => {
      if (!o.value)
        throw new Error("Stage does not exist");
      tOe({
        stage: o.value,
        config: n.config
      });
    }), CI(() => {
      nOe();
    }), $I(["c", "f", "Escape"], c);
    function c(p) {
      if (!(UU(p.target) || p.metaKey || p.ctrlKey))
        switch (p.key) {
          case "c":
            l();
            break;
          case "f":
            a();
            break;
          case "Escape":
            i.value && a();
            break;
        }
    }
    return (p, d) => {
      const h = P("p-button");
      return T(), z("div", {
        class: Bt(["run-graph", u.value.root])
      }, [
        re("div", {
          ref_key: "stage",
          ref: o,
          class: "run-graph__stage"
        }, null, 512),
        re("div", sOe, [
          w(h, {
            title: "Recenter graph (c)",
            icon: "Target",
            flat: "",
            onClick: l
          }),
          w(h, {
            title: "Toggle fullscreen (f)",
            icon: "ArrowsPointingOutIcon",
            flat: "",
            onClick: a
          }),
          w(oOe)
        ])
      ], 2);
    };
  }
}), iOe = {
  key: 0,
  class: "flow-run-graph__no-nodes-message"
}, uOe = {
  key: 1,
  class: "flow-run-graph__no-nodes-message"
}, lOe = 2e3, cOe = /* @__PURE__ */ U({
  __name: "FlowRunGraph",
  props: {
    flowRun: {},
    fullscreen: { type: Boolean },
    isCollapsed: { type: Boolean },
    selected: {},
    viewport: {},
    fetchEvents: { type: Function }
  },
  emits: ["update:viewport", "update:fullscreen", "update:selected"],
  async setup(t, { emit: e }) {
    let n, r;
    const o = t, s = e, i = Se(), { value: u } = Xj(), l = ge(!0), a = ge(!1), c = ge(""), p = D({
      get() {
        return o.viewport;
      },
      set(X) {
        s("update:viewport", X);
      }
    }), d = D({
      get() {
        return o.fullscreen;
      },
      set(X) {
        s("update:fullscreen", X);
      }
    }), h = D({
      get() {
        return o.selected;
      },
      set(X) {
        s("update:selected", X);
      }
    }), m = D(() => fi(o.flowRun.state?.type) ? "This flow run did not generate any task or subflow runs" : "This flow run has not yet generated any task or subflow runs"), g = {
      COMPLETED: "#219D4B",
      RUNNING: "#09439B",
      SCHEDULED: "#E08504",
      PENDING: "#554B58",
      FAILED: "#DE0529",
      CANCELLED: "#333333",
      CANCELLING: "#333333",
      CRASHED: "#EA580C",
      PAUSED: "#554B58"
    }, _ = getComputedStyle(document.documentElement);
    function b(X) {
      return _.getPropertyValue(X).trim();
    }
    const x = D(() => ({
      runId: o.flowRun.id,
      fetch: async (X) => {
        try {
          return await i.flowRuns.getFlowRunsGraph(X, { nestedTaskRunGraphs: !0 });
        } catch (te) {
          throw a.value = !0, c.value = Yt(te, "An error occurred retrieving graph data"), te;
        }
      },
      fetchEvents: o.fetchEvents,
      styles: () => ({
        textDefault: b("--p-color-text-default"),
        textInverse: b("--p-color-text-inverse"),
        nodeToggleBorderColor: b("--p-color-button-default-border"),
        selectedBorderColor: b("--p-color-flow-run-graph-node-selected-border"),
        edgeColor: b("--p-color-flow-run-graph-edge"),
        guideLineColor: b("--p-color-divider"),
        guideTextColor: b("--p-color-text-subdued"),
        node: (X) => ({
          background: g[X.state_type]
        }),
        state: (X) => ({
          background: g[X.type]
        })
      }),
      theme: u.value
    })), S = D(() => ({
      interval: fi(o.flowRun.state?.type) ? 1e4 : 1e3
    })), { count: E, subscription: A } = hp(() => ({
      flowRuns: {
        id: [o.flowRun.id]
      },
      taskRuns: {
        subFlowRunsExist: void 0
      }
    }), S), C = D(() => E.value && E.value > 0);
    [n, r] = fx(() => A.promise()), await n, r(), E.value > lOe && (l.value = !1);
    const M = D(() => ({
      root: {
        "flow-run-graph--no-nodes": !C.value
      }
    }));
    function L() {
      l.value = !0;
    }
    return (X, te) => (T(), z("div", {
      class: Bt(["flow-run-graph", M.value.root])
    }, [
      l.value ? (T(), z(ve, { key: 0 }, [
        w(aOe, {
          viewport: p.value,
          "onUpdate:viewport": te[0] || (te[0] = (B) => p.value = B),
          selected: h.value,
          "onUpdate:selected": te[1] || (te[1] = (B) => h.value = B),
          fullscreen: d.value,
          "onUpdate:fullscreen": te[2] || (te[2] = (B) => d.value = B),
          config: x.value,
          class: "flow-run-graph__graph p-background"
        }, null, 8, ["viewport", "selected", "fullscreen", "config"]),
        !C.value && !X.isCollapsed ? (T(), z("p", iOe, ie(m.value), 1)) : j("", !0),
        a.value && !X.isCollapsed ? (T(), z("p", uOe, " Failed to load graph: " + ie(c.value), 1)) : j("", !0)
      ], 64)) : (T(), O(IL, {
        key: 1,
        onConfirm: L
      }))
    ], 2));
  }
}), XU = /* @__PURE__ */ U({
  __name: "FlowRunGraphArtifactCard",
  props: {
    artifactId: {}
  },
  setup(t) {
    const e = t, n = je(), { artifact: r } = _2(() => e.artifactId);
    return (o, s) => {
      const i = P("router-link"), u = P("p-loading-icon");
      return v(r) ? (T(), O(i, {
        key: 0,
        to: v(n).artifact(v(r).id)
      }, {
        default: k(() => [
          w(v(hh), {
            condense: "",
            interactive: "",
            artifact: v(r)
          }, null, 8, ["artifact"])
        ]),
        _: 1
      }, 8, ["to"])) : (T(), O(u, { key: 1 }));
    };
  }
}), pOe = { class: "flow-run-graph-artifact-drawer__header" }, dOe = { class: "flow-run-graph-artifact-drawer__details" }, hOe = /* @__PURE__ */ U({
  __name: "FlowRunGraphArtifactDrawer",
  props: {
    selection: {}
  },
  emits: ["update:selection"],
  setup(t, { emit: e }) {
    const n = t, r = e, o = je();
    function s() {
      r("update:selection", null);
    }
    const i = D(() => n.selection && FL(n.selection) ? n.selection.id : null), { artifact: u } = _2(i), l = D(() => u.value?.taskRunId), { taskRun: a } = Kp(l);
    return (c, p) => {
      const d = P("p-key-value"), h = P("p-tags"), m = P("p-button"), g = P("p-divider"), _ = P("p-loading-icon"), b = P("p-drawer");
      return T(), O(b, {
        class: "flow-run-graph-artifact-drawer",
        open: i.value !== null,
        placement: "right",
        "onUpdate:open": s
      }, {
        default: k(() => [
          v(u) ? (T(), z(ve, { key: 0 }, [
            re("div", pOe, [
              re("div", dOe, [
                v(u).key ? (T(), O(d, {
                  key: 0,
                  label: "Key"
                }, {
                  value: k(() => [
                    w(v(L2), {
                      "artifact-id": v(u).id
                    }, null, 8, ["artifact-id"])
                  ]),
                  _: 1
                })) : j("", !0),
                v(a)?.tags?.length ? (T(), O(d, {
                  key: 1,
                  label: "Tags"
                }, {
                  value: k(() => [
                    w(h, {
                      tags: v(a).tags
                    }, null, 8, ["tags"])
                  ]),
                  _: 1
                })) : j("", !0),
                w(d, { label: "Description" }, {
                  value: k(() => [
                    w(v(m4), { artifact: v(u) }, null, 8, ["artifact"])
                  ]),
                  _: 1
                })
              ]),
              w(m, {
                size: "sm",
                variant: "ghost",
                icon: "ArrowTopRightOnSquareIcon",
                to: v(o).artifact(v(u).id),
                target: "_blank",
                title: "Open artifact in a new tab"
              }, null, 8, ["to"]),
              w(m, {
                size: "sm",
                variant: "ghost",
                icon: "XMarkIcon",
                title: "Close drawer",
                onClick: s
              })
            ]),
            w(g),
            w(v(N2), { artifact: v(u) }, null, 8, ["artifact"])
          ], 64)) : (T(), O(_, {
            key: 1,
            class: "flow-run-graph-artifact-drawer__loading"
          }))
        ]),
        _: 1
      }, 8, ["open"]);
    };
  }
}), fOe = { class: "flow-run-graph-artifacts-popover__content" }, mOe = /* @__PURE__ */ U({
  __name: "FlowRunGraphArtifactsPopover",
  props: {
    selection: {}
  },
  emits: ["update:selection"],
  setup(t, { emit: e }) {
    const n = e, r = () => {
      n("update:selection", null);
    };
    return (o, s) => o.selection.position ? (T(), O(v(gy), {
      key: 0,
      position: o.selection.position,
      onOnClose: r
    }, {
      default: k(() => [
        s[0] || (s[0] = re("h4", { class: "flow-run-graph-artifacts-popover__label" }, " Artifacts ", -1)),
        re("div", fOe, [
          (T(!0), z(ve, null, ln(o.selection.ids, (i) => (T(), O(v(XU), {
            key: i,
            "artifact-id": i
          }, null, 8, ["artifact-id"]))), 128))
        ])
      ]),
      _: 1
    }, 8, ["position"])) : j("", !0);
  }
}), yOe = { class: "flow-run-graph-popover" }, gy = /* @__PURE__ */ U({
  __name: "FlowRunGraphPopover",
  props: {
    position: {}
  },
  emits: ["onClose"],
  setup(t, { emit: e }) {
    const n = t, r = e, o = ge(), s = [qr.bottom, qr.top, qr.left, qr.right], i = D(() => ({
      cursor: "pointer",
      position: "absolute",
      top: `${n.position.y}px`,
      left: `${n.position.x}px`,
      width: `${n.position.width}px`,
      height: `${n.position.height}px`
    }));
    wi(() => {
      setTimeout(() => {
        o.value?.open();
      }, 0);
    });
    const u = () => {
      o.value?.visible || r("onClose", null);
    };
    return (l, a) => (T(), O(v(Hv), {
      ref_key: "popOver",
      ref: o,
      "auto-close": "",
      placement: s,
      style: b0(i.value),
      onOpen: u
    }, {
      default: k(() => [
        re("div", yOe, [
          Ve(l.$slots, "default")
        ])
      ]),
      _: 3
    }, 8, ["style"]));
  }
}), gOe = /* @__PURE__ */ U({
  __name: "FlowRunGraphEventPopover",
  props: {
    selection: {}
  },
  emits: ["update:selection"],
  setup(t, { emit: e }) {
    const n = e, r = () => {
      n("update:selection", null);
    };
    return (o, s) => o.selection.position ? (T(), O(gy, {
      key: 0,
      position: o.selection.position,
      onOnClose: r
    }, {
      default: k(() => [
        s[0] || (s[0] = re("h4", { class: "flow-run-graph-events-popover__label" }, " Event ", -1)),
        w(mS, {
          class: "flow-run-graph-events-popover__content",
          "event-id": o.selection.id,
          occurred: o.selection.occurred
        }, null, 8, ["event-id", "occurred"])
      ]),
      _: 1
    }, 8, ["position"])) : j("", !0);
  }
}), vOe = { class: "flow-run-graph-events-popover__label" }, _Oe = { class: "flow-run-graph-events-popover__content" }, wOe = /* @__PURE__ */ U({
  __name: "FlowRunGraphEventsPopover",
  props: {
    selection: {}
  },
  emits: ["update:selection"],
  setup(t, { emit: e }) {
    const n = e, r = () => {
      n("update:selection", null);
    };
    return (o, s) => o.selection.position && o.selection.occurred ? (T(), O(gy, {
      key: 0,
      position: o.selection.position,
      onOnClose: r
    }, {
      default: k(() => [
        re("h4", vOe, ie(o.selection.ids.length) + " Events ", 1),
        re("div", _Oe, [
          (T(!0), z(ve, null, ln(o.selection.ids, (i) => (T(), O(mS, {
            key: i,
            "event-id": i,
            occurred: o.selection.occurred
          }, null, 8, ["event-id", "occurred"]))), 128))
        ])
      ]),
      _: 1
    }, 8, ["position"])) : j("", !0);
  }
}), bOe = { class: "flow-run-graph-selection-panel" }, kOe = { class: "flex justify-end" }, TOe = /* @__PURE__ */ U({
  __name: "FlowRunGraphSelectionPanel",
  props: {
    selection: {}
  },
  emits: ["update:selection"],
  setup(t, { emit: e }) {
    const n = e;
    function r() {
      n("update:selection", null);
    }
    return (o, s) => {
      const i = P("p-button");
      return T(), z("div", bOe, [
        re("div", kOe, [
          w(i, {
            size: "sm",
            icon: "XMarkIcon",
            variant: "ghost",
            onClick: r
          })
        ]),
        o.selection.kind === "task-run" ? (T(), O(v(KU), {
          key: 0,
          "task-run-id": o.selection.id
        }, null, 8, ["task-run-id"])) : j("", !0),
        o.selection.kind === "flow-run" ? (T(), O(v(QU), {
          key: 1,
          "flow-run-id": o.selection.id
        }, null, 8, ["flow-run-id"])) : j("", !0)
      ]);
    };
  }
}), xOe = { class: "flow-run-graph-state-popover" }, SOe = /* @__PURE__ */ U({
  __name: "FlowRunGraphStatePopover",
  props: {
    selection: {}
  },
  emits: ["update:selection"],
  setup(t, { emit: e }) {
    const n = e, r = () => {
      n("update:selection", null);
    };
    return (o, s) => {
      const i = P("p-key-value");
      return o.selection.position ? (T(), O(v(gy), {
        key: 0,
        position: o.selection.position,
        onOnClose: r
      }, {
        default: k(() => [
          re("div", xOe, [
            w(i, { label: "State" }, {
              value: k(() => [
                q(ie(o.selection.name), 1)
              ]),
              _: 1
            }),
            w(i, { label: "Occurred" }, {
              value: k(() => [
                w(hn, {
                  date: o.selection.timestamp,
                  format: "numeric"
                }, null, 8, ["date"])
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }, 8, ["position"])) : j("", !0);
    };
  }
}), ROe = { class: "flow-run-history-card__header" }, AOe = /* @__PURE__ */ U({
  __name: "FlowRunHistoryCard",
  props: {
    filter: {}
  },
  setup(t) {
    const e = t, n = Xa(), { filter: r } = Nn(e), { count: o } = du(r, n);
    return (s, i) => {
      const u = P("p-heading"), l = P("p-card");
      return T(), O(l, { class: "flow-run-history-card" }, {
        default: k(() => [
          re("header", ROe, [
            w(u, { heading: "5" }, {
              default: k(() => [...i[0] || (i[0] = [
                q(" Flow Runs ", -1)
              ])]),
              _: 1
            }),
            v(o) ? (T(), O(Jl, {
              key: 0,
              label: "total",
              value: v(o)
            }, null, 8, ["value"])) : j("", !0)
          ]),
          w(Vh, {
            class: "flow-run-history-card__chart",
            filter: v(r)
          }, null, 8, ["filter"])
        ]),
        _: 1
      });
    };
  }
}), sw = /* @__PURE__ */ U({
  __name: "FlowRunList",
  props: {
    selected: {},
    flowRuns: {},
    selectable: { type: Boolean },
    hideFlowName: { type: Boolean },
    hideDetails: { type: Boolean }
  },
  emits: ["update:selected"],
  setup(t, { emit: e }) {
    const n = t, r = e, { FlowRunListItem: o } = Vn(), s = D({
      get() {
        return n.selected ?? [];
      },
      set(i) {
        r("update:selected", i);
      }
    });
    return (i, u) => {
      const l = P("p-virtual-scroller");
      return T(), O(l, {
        items: i.flowRuns,
        class: "flow-run-list"
      }, {
        default: k(({ item: a }) => [
          w(v(o), yt({
            selected: s.value,
            "onUpdate:selected": u[0] || (u[0] = (c) => s.value = c)
          }, { hideFlowName: i.hideFlowName, hideDetails: i.hideDetails, flowRun: a, selectable: i.selectable }), null, 16, ["selected"])
        ]),
        _: 1
      }, 8, ["items"]);
    };
  }
}), DOe = {
  key: 1,
  class: "flow-run-parameters-icon-text__none"
}, EOe = /* @__PURE__ */ U({
  inheritAttrs: !1,
  __name: "FlowRunParametersIconText",
  props: {
    flowRun: {}
  },
  setup(t) {
    const e = t, n = D(() => Object.keys(e.flowRun.parameters).length), r = D(() => n.value > 0), { showModal: o, open: s } = St();
    return (i, u) => {
      const l = P("p-icon-text"), a = P("p-code-highlight"), c = P("p-modal");
      return T(), z(ve, null, [
        w(l, yt(i.$attrs, {
          icon: "AdjustmentsVerticalIcon",
          class: "flow-run-parameters-icon-text"
        }), {
          default: k(() => [
            r.value ? (T(), z("button", {
              key: 0,
              type: "button",
              class: "flow-run-parameters-icon-text__button",
              onClick: u[0] || (u[0] = //@ts-ignore
              (...p) => v(s) && v(s)(...p))
            }, ie(n.value) + " " + ie(v(Ks)("Parameter", n.value)), 1)) : (T(), z("span", DOe, "0 Parameters"))
          ]),
          _: 1
        }, 16),
        w(c, {
          "show-modal": v(o),
          "onUpdate:showModal": u[1] || (u[1] = (p) => Xe(o) ? o.value = p : null),
          title: `Flow run parameters for ${i.flowRun.name}`,
          "auto-close": ""
        }, {
          default: k(() => [
            w(a, {
              lang: "json",
              text: v(or)(i.flowRun.parameters)
            }, null, 8, ["text"])
          ]),
          _: 1
        }, 8, ["show-modal", "title"])
      ], 64);
    };
  }
}), MOe = {
  key: 0,
  class: "flow-run-parameters-icon-text__button"
}, POe = {
  key: 1,
  class: "flow-run-tasks-icon-text__none"
}, COe = /* @__PURE__ */ U({
  __name: "FlowRunTasksIconText",
  props: {
    flowRun: {}
  },
  setup(t) {
    const e = t, { count: n } = Fse(() => e.flowRun.id), r = D(() => n.value ?? 0), o = D(() => r.value > 0);
    return (s, i) => {
      const u = P("p-icon-text");
      return T(), O(u, {
        icon: "Task",
        class: "flow-run-tasks-icon-text"
      }, {
        default: k(() => [
          o.value ? (T(), z("span", MOe, ie(r.value) + " " + ie(v(Ks)("Task run", r.value)), 1)) : (T(), z("span", POe, "0 Task runs"))
        ]),
        _: 1
      });
    };
  }
}), OOe = /* @__PURE__ */ U({
  __name: "FlowRunListItem",
  props: {
    selectable: { type: Boolean },
    selected: { type: [Boolean, Array, null] },
    flowRun: {},
    hideFlowName: { type: Boolean },
    hideDetails: { type: Boolean }
  },
  emits: ["update:selected"],
  setup(t, { emit: e }) {
    const n = t, r = e, o = D({
      get() {
        return n.selected ?? void 0;
      },
      set(h) {
        r("update:selected", h);
      }
    }), s = D(() => n.flowRun.state?.type), i = D(() => n.flowRun.tags), u = D(() => n.flowRun.id), l = ge(!1), a = ge();
    function c(h) {
      h.forEach((m) => {
        m.isIntersecting && (l.value = !0, d());
      });
    }
    const { observe: p, disconnect: d } = XI(c);
    return wi(() => {
      p(a);
    }), (h, m) => (T(), z("div", {
      ref_key: "el",
      ref: a,
      class: "flow-run-list-item"
    }, [
      w(W2, yt({
        selected: o.value,
        "onUpdate:selected": m[0] || (m[0] = (g) => o.value = g)
      }, { selectable: h.selectable, value: u.value, tags: i.value, stateType: s.value }), Ut({
        name: k(() => [
          w(nS, {
            "hide-flow-name": h.hideFlowName,
            "flow-run": h.flowRun
          }, null, 8, ["hide-flow-name", "flow-run"])
        ]),
        meta: k(() => [
          w(Dr, {
            state: h.flowRun.state
          }, null, 8, ["state"]),
          w(ay, { "flow-run": h.flowRun }, null, 8, ["flow-run"]),
          w(EOe, { "flow-run": h.flowRun }, null, 8, ["flow-run"]),
          l.value && h.flowRun.stateType !== "scheduled" ? (T(), z(ve, { key: 0 }, [
            w(Cc, {
              duration: h.flowRun.duration
            }, null, 8, ["duration"]),
            w(COe, { "flow-run": h.flowRun }, null, 8, ["flow-run"])
          ], 64)) : j("", !0)
        ]),
        default: k(() => [
          Ve(h.$slots, "after", { flowRun: h.flowRun })
        ]),
        _: 2
      }, [
        !h.hideDetails && l.value && (h.flowRun.deploymentId || h.flowRun.workQueueName) ? {
          name: "relationships",
          fn: k(() => [
            h.flowRun.deploymentId ? (T(), O(R_, {
              key: 0,
              "deployment-id": h.flowRun.deploymentId
            }, null, 8, ["deployment-id"])) : j("", !0),
            h.flowRun.workPoolName ? (T(), O(ny, {
              key: 1,
              "work-pool-name": h.flowRun.workPoolName
            }, null, 8, ["work-pool-name"])) : j("", !0),
            h.flowRun.workQueueName ? (T(), O(ry, {
              key: 2,
              "work-queue-name": h.flowRun.workQueueName,
              "work-pool-name": h.flowRun.workPoolName,
              "flow-run-state": h.flowRun.stateType
            }, null, 8, ["work-queue-name", "work-pool-name", "flow-run-state"])) : j("", !0)
          ]),
          key: "0"
        } : void 0
      ]), 1040, ["selected"])
    ], 512));
  }
}), $U = /* @__PURE__ */ U({
  __name: "FlowRunLogsDownloadButton",
  props: {
    flowRun: {}
  },
  setup(t) {
    const e = Se(), n = ge(!1);
    async function r() {
      n.value = !0;
      try {
        await e.flowRuns.downloadFlowRunLogs(t.flowRun.id, t.flowRun.name);
      } catch (o) {
        console.error(o), He("There was an error downloading logs", "error");
      }
      n.value = !1;
    }
    return (o, s) => {
      const i = P("p-button"), u = P("p-tooltip");
      return T(), O(u, {
        text: "Download a csv of all logs",
        "avoid-collisions": ""
      }, {
        default: k(() => [
          w(i, {
            class: "flow-run-logs-download-button",
            icon: "Download",
            loading: n.value,
            onClick: r
          }, null, 8, ["loading"])
        ]),
        _: 1
      });
    };
  }
}), IOe = { class: "flow-run-logs__empty-text" }, FOe = { key: 0 }, NOe = { key: 1 }, LOe = { key: 2 }, BOe = { key: 3 }, UOe = /* @__PURE__ */ U({
  __name: "FlowRunLogs",
  props: {
    flowRun: {}
  },
  setup(t) {
    const e = t, n = ge(0), { sort: r } = wN(), o = D(() => n.value !== 0), s = D(() => ({
      logs: {
        flowRunId: [e.flowRun.id],
        levelGreaterThan: n.value
      },
      sort: r.value
    })), { now: i } = gx({ interval: 5e3 }), u = D(() => e.flowRun.endTime && uc(i.value, e.flowRun.endTime) < 30), l = D(() => u.value ? { interval: 5e3 } : fi(e.flowRun.stateType) ? {} : { interval: 5e3 }), a = Se(), c = k2(a.logs.getLogs, [s], l), p = D(() => c.response ?? []), d = D(() => p.value.length > 0 ? !1 : u.value ? !0 : !fi(e.flowRun.stateType));
    function h() {
      n.value = 0;
    }
    return (m, g) => {
      const _ = P("p-list-header"), b = P("p-button"), x = P("p-empty-results"), S = P("p-content");
      return T(), O(S, { class: "flow-run-logs" }, {
        default: k(() => [
          w(_, null, {
            controls: k(() => [
              w(v(TR), {
                selected: n.value,
                "onUpdate:selected": g[0] || (g[0] = (E) => n.value = E)
              }, null, 8, ["selected"]),
              w(v(SR), {
                selected: v(r),
                "onUpdate:selected": g[1] || (g[1] = (E) => Xe(r) ? r.value = E : null)
              }, null, 8, ["selected"]),
              w($U, { "flow-run": m.flowRun }, null, 8, ["flow-run"])
            ]),
            _: 1
          }),
          w(v(xR), {
            logs: p.value,
            onBottom: v(c).loadMore
          }, {
            empty: k(() => [
              w(x, null, Ut({
                message: k(() => [
                  re("div", IOe, [
                    n.value > 0 ? (T(), z("div", FOe, " No logs match your filter criteria ")) : m.flowRun.stateType == "scheduled" ? (T(), z("div", NOe, " This run is scheduled and hasn't generated logs ")) : d.value ? (T(), z("div", LOe, " Waiting for logs... ")) : (T(), z("div", BOe, " This run didn't generate logs "))
                  ])
                ]),
                _: 2
              }, [
                o.value ? {
                  name: "actions",
                  fn: k(() => [
                    w(b, {
                      size: "sm",
                      onClick: h
                    }, {
                      default: k(() => [...g[2] || (g[2] = [
                        q(" Clear Filters ", -1)
                      ])]),
                      _: 1
                    })
                  ]),
                  key: "0"
                } : void 0
              ]), 1024)
            ]),
            _: 1
          }, 8, ["logs", "onBottom"])
        ]),
        _: 1
      });
    };
  }
}), XOe = { key: 1 }, gR = /* @__PURE__ */ U({
  __name: "FlowRunResumeModal",
  props: /* @__PURE__ */ Br({
    flowRun: {}
  }, {
    showModal: { type: Boolean },
    showModalModifiers: {}
  }),
  emits: /* @__PURE__ */ Br(["update"], ["update:showModal"]),
  setup(t, { emit: e }) {
    const n = zn(t, "showModal"), r = e, o = Se(), s = ge({}), i = ge(null), u = ge(null), { errors: l, validate: a, reset: c } = Xh(u, s);
    Ct(n, (m) => {
      if (!m) {
        d();
        return;
      }
      p();
    }, { immediate: !0 });
    async function p() {
      if (!t.flowRun.state?.stateDetails?.runInputKeyset)
        return;
      const [m, g] = await Promise.all([
        o.flowRuns.getFlowRunInputDescription(t.flowRun.id, t.flowRun.state.stateDetails.runInputKeyset),
        o.flowRuns.getFlowRunInputSchemaV2(t.flowRun.id, t.flowRun.state.stateDetails.runInputKeyset)
      ]);
      i.value = m, u.value = g;
    }
    function d() {
      i.value = null, u.value = null, s.value = {}, c();
    }
    const h = async () => {
      if (await a())
        try {
          const g = await o.flowRuns.resumeFlowRunV2(t.flowRun.id, s.value);
          if (g.status != "ACCEPT") {
            He(g.details.reason, "error"), console.log("Orchestration failed: ", g.details.reason);
            return;
          }
          r("update"), n.value = !1, He(le.success.resumeFlowRun, "success");
        } catch (g) {
          console.error(g);
          const _ = Yt(g, le.error.resumeFlowRun);
          He(_, "error");
        }
    };
    return (m, g) => {
      const _ = P("p-markdown-renderer"), b = P("p-content"), x = P("p-button"), S = P("p-modal");
      return m.flowRun ? (T(), O(S, {
        key: 0,
        showModal: n.value,
        "onUpdate:showModal": g[1] || (g[1] = (E) => n.value = E),
        title: "Resume Flow Run"
      }, {
        actions: k(() => [
          w(x, {
            variant: "default",
            onClick: h
          }, {
            default: k(() => [...g[2] || (g[2] = [
              q(" Submit ", -1)
            ])]),
            _: 1
          })
        ]),
        default: k(() => [
          u.value ? (T(), z(ve, { key: 0 }, [
            i.value ? (T(), O(_, {
              key: 0,
              text: i.value
            }, null, 8, ["text"])) : j("", !0),
            u.value ? (T(), O(b, { key: 1 }, {
              default: k(() => [
                w(v(Uh), {
                  values: s.value,
                  "onUpdate:values": g[0] || (g[0] = (E) => s.value = E),
                  schema: u.value,
                  errors: v(l),
                  kinds: ["none", "json", "workspace_variable"]
                }, null, 8, ["values", "schema", "errors"])
              ]),
              _: 1
            })) : j("", !0)
          ], 64)) : (T(), z("p", XOe, " Do you want to resume this flow run? "))
        ]),
        _: 1
      }, 8, ["showModal"])) : j("", !0);
    };
  }
}), $Oe = /* @__PURE__ */ U({
  inheritAttrs: !1,
  __name: "FlowRunMenu",
  props: {
    flowRun: {},
    showAll: { type: Boolean }
  },
  emits: ["delete", "update"],
  setup(t, { emit: e }) {
    const n = e, r = Ke(), o = Se(), s = je(), { showModal: i, open: u } = St(), { showModal: l, open: a } = St(), { showModal: c, open: p } = St(), { showModal: d, open: h } = St(), { showModal: m, open: g } = St(), { showModal: _, open: b } = St(), x = ge(!1), { deployment: S } = Zm(() => t.flowRun.deploymentId), E = D(() => !r.update.flow_run || !t.flowRun.stateType || !t.flowRun.deploymentId ? !1 : fi(t.flowRun.stateType)), A = D(() => !r.update.flow_run || !t.flowRun.stateType ? !1 : w8(t.flowRun.stateType)), C = D(() => !r.update.flow_run || !t.flowRun.stateType ? !1 : _8(t.flowRun.stateType)), M = D(() => !r.update.flow_run || !t.flowRun.stateType || !t.flowRun.deploymentId ? !1 : b8(t.flowRun.stateType)), L = D(() => !r.update.flow_run || !t.flowRun.stateType ? !1 : fi(t.flowRun.stateType)), X = async (B) => {
      try {
        await o.flowRuns.setFlowRunState(t.flowRun.id, { state: B }), n("update"), He(le.success.changeFlowRunState, "success");
      } catch (W) {
        console.error(W);
        const G = Yt(W, le.error.changeFlowRunState);
        He(G, "error");
      }
    }, te = async (B) => {
      await Ua(B, o.flowRuns.deleteFlowRun, "Flow run"), n("delete", B);
    };
    return (B, W) => {
      const G = P("p-overflow-menu-item"), ne = P("p-icon-button-menu");
      return T(), z(ve, null, [
        w(ne, yt({ class: "flow-run-menu" }, B.$attrs), {
          default: k(() => [
            B.flowRun?.deploymentId && v(S)?.can.run ? (T(), O(G, {
              key: 0,
              label: "Copy to new run",
              to: v(s).deploymentFlowRunCreate(B.flowRun.deploymentId, B.flowRun.parameters)
            }, null, 8, ["to"])) : j("", !0),
            E.value && B.showAll ? (T(), O(G, {
              key: 1,
              label: "Retry",
              onClick: v(u)
            }, null, 8, ["onClick"])) : j("", !0),
            A.value && B.showAll ? (T(), O(G, {
              key: 2,
              label: "Resume",
              onClick: v(a)
            }, null, 8, ["onClick"])) : j("", !0),
            M.value && B.showAll ? (T(), O(G, {
              key: 3,
              label: "Pause",
              onClick: v(h)
            }, null, 8, ["onClick"])) : j("", !0),
            C.value && B.showAll ? (T(), O(G, {
              key: 4,
              label: "Cancel",
              onClick: v(p)
            }, null, 8, ["onClick"])) : j("", !0),
            L.value ? (T(), O(G, {
              key: 5,
              label: "Change state",
              onClick: v(g)
            }, null, 8, ["onClick"])) : j("", !0),
            w(v(uo), {
              label: "Copy ID",
              item: B.flowRun.id
            }, null, 8, ["item"]),
            v(r).delete.flow_run ? (T(), O(G, {
              key: 6,
              label: "Delete",
              onClick: v(b)
            }, null, 8, ["onClick"])) : j("", !0),
            Ve(B.$slots, "default", sn(kn({ flowRun: B.flowRun })))
          ]),
          _: 3
        }, 16),
        w(v(_R), {
          showModal: v(i),
          "onUpdate:showModal": W[0] || (W[0] = (de) => Xe(i) ? i.value = de : null),
          retryingRun: x.value,
          "onUpdate:retryingRun": W[1] || (W[1] = (de) => x.value = de),
          "flow-run": B.flowRun
        }, null, 8, ["showModal", "retryingRun", "flow-run"]),
        w(gR, {
          showModal: v(l),
          "onUpdate:showModal": W[2] || (W[2] = (de) => Xe(l) ? l.value = de : null),
          "flow-run": B.flowRun,
          onUpdate: W[3] || (W[3] = (de) => n("update"))
        }, null, 8, ["showModal", "flow-run"]),
        w(v(vS), {
          showModal: v(c),
          "onUpdate:showModal": W[4] || (W[4] = (de) => Xe(c) ? c.value = de : null),
          "flow-run": B.flowRun,
          onUpdate: W[5] || (W[5] = (de) => n("update"))
        }, null, 8, ["showModal", "flow-run"]),
        w(v(bR), {
          showModal: v(d),
          "onUpdate:showModal": W[6] || (W[6] = (de) => Xe(d) ? d.value = de : null),
          "flow-run": B.flowRun,
          onUpdate: W[7] || (W[7] = (de) => n("update"))
        }, null, 8, ["showModal", "flow-run"]),
        w(v(z2), {
          showModal: v(m),
          "onUpdate:showModal": W[8] || (W[8] = (de) => Xe(m) ? m.value = de : null),
          run: B.flowRun,
          label: "Flow Run",
          onChange: X
        }, null, 8, ["showModal", "run"]),
        w(v(_r), {
          showModal: v(_),
          "onUpdate:showModal": W[9] || (W[9] = (de) => Xe(_) ? _.value = de : null),
          label: "Flow Run",
          name: B.flowRun.name,
          onDelete: W[10] || (W[10] = (de) => te(B.flowRun.id))
        }, null, 8, ["showModal", "name"])
      ], 64);
    };
  }
}), WOe = {
  key: 0,
  class: "flow-run-name"
}, vR = /* @__PURE__ */ U({
  __name: "FlowRunName",
  props: {
    flowRunId: {},
    flowRunName: {},
    stateType: {},
    stateName: {}
  },
  setup(t) {
    const e = je();
    return (n, r) => {
      const o = P("p-tooltip"), s = P("p-link");
      return n.flowRunId ? (T(), z("span", WOe, [
        n.stateType ? (T(), O(o, {
          key: 0,
          text: n.stateName ?? n.stateType
        }, {
          default: k(() => [
            w(v($2), { "state-type": n.stateType }, null, 8, ["state-type"])
          ]),
          _: 1
        }, 8, ["text"])) : j("", !0),
        w(s, {
          to: v(e).flowRun(n.flowRunId)
        }, {
          default: k(() => [
            q(ie(n.flowRunName ?? n.flowRunId), 1)
          ]),
          _: 1
        }, 8, ["to"])
      ])) : j("", !0);
    };
  }
}), VOe = {
  key: 0,
  class: "flow-run-parent-flow-run"
}, WU = /* @__PURE__ */ U({
  __name: "FlowRunParentFlowRun",
  props: {
    parentTaskRunId: {}
  },
  setup(t) {
    const e = t, { flowRuns: n } = Qp(() => ({
      taskRuns: {
        id: [e.parentTaskRunId]
      }
    })), r = D(() => {
      if (!n.value.length)
        return;
      const [o] = n.value;
      return o.id;
    });
    return (o, s) => r.value ? (T(), z("div", VOe, [
      re("span", null, ie(v(le).info.parentRun), 1),
      s[0] || (s[0] = q()),
      w(ty, { "flow-run-id": r.value }, null, 8, ["flow-run-id"])
    ])) : j("", !0);
  }
}), VU = /* @__PURE__ */ U({
  __name: "FlowRunPopOver",
  props: {
    flowRunId: {}
  },
  setup(t) {
    const e = ge(), n = ge(), r = ge();
    wi(() => {
      document.addEventListener("mouseover", i), document.addEventListener("click", s);
    }), Em(() => {
      document.removeEventListener("mouseover", i), document.removeEventListener("click", s);
    });
    function o() {
      e.value && e.value.open();
    }
    function s(u) {
      const l = u.target;
      !e.value || !r.value || r.value.contains(l) || e.value.close();
    }
    function i(u) {
      const l = u.target;
      !e.value || !n.value || n.value.contains(l) || !l.classList.contains("flow-run-pop-over__trigger") || e.value.close();
    }
    return (u, l) => (T(), O(v(Hv), {
      ref_key: "popover",
      ref: e,
      class: "flow-run-pop-over"
    }, {
      target: k(() => [
        re("div", {
          ref_key: "trigger",
          ref: n,
          class: "flow-run-pop-over__trigger",
          onMouseover: o
        }, null, 544)
      ]),
      default: k(() => [
        re("div", {
          ref_key: "content",
          ref: r,
          class: "flow-run-pop-over__content"
        }, [
          w(rS, { "flow-run-id": u.flowRunId }, null, 8, ["flow-run-id"])
        ], 512)
      ]),
      _: 1
    }, 512));
  }
}), HU = /* @__PURE__ */ U({
  inheritAttrs: !1,
  __name: "FlowRunResumeButton",
  props: {
    flowRun: {}
  },
  emits: ["update"],
  setup(t, { emit: e }) {
    const n = e, r = Eh(), o = Ke(), { showModal: s, open: i } = St(), u = D(() => !o.update.flow_run || !t.flowRun.stateType ? !1 : w8(t.flowRun.stateType));
    return (l, a) => {
      const c = P("p-button");
      return T(), z(ve, null, [
        u.value ? (T(), O(c, yt({
          key: 0,
          "icon-append": "PlayIcon"
        }, v(r), { onClick: v(i) }), {
          default: k(() => [...a[2] || (a[2] = [
            q(" Resume ", -1)
          ])]),
          _: 1
        }, 16, ["onClick"])) : j("", !0),
        w(gR, {
          showModal: v(s),
          "onUpdate:showModal": a[0] || (a[0] = (p) => Xe(s) ? s.value = p : null),
          "flow-run": l.flowRun,
          onUpdate: a[1] || (a[1] = (p) => n("update"))
        }, null, 8, ["showModal", "flow-run"])
      ], 64);
    };
  }
}), _R = /* @__PURE__ */ U({
  __name: "FlowRunRetryModal",
  props: /* @__PURE__ */ Br({
    flowRun: {}
  }, {
    showModal: { type: Boolean, required: !0 },
    showModalModifiers: {},
    retryingRun: { type: Boolean, required: !0 },
    retryingRunModifiers: {}
  }),
  emits: /* @__PURE__ */ Br(["update"], ["update:showModal", "update:retryingRun"]),
  setup(t, { emit: e }) {
    const n = zn(t, "showModal"), r = zn(t, "retryingRun"), o = e, s = Se(), i = async () => {
      r.value = !0;
      try {
        await s.flowRuns.retryFlowRun(t.flowRun.id), He(le.success.retryRun, "success"), o("update"), n.value = !1;
      } catch (u) {
        console.error(u);
        const l = Yt(u, le.error.retryRun);
        He(l, "error");
      } finally {
        r.value = !1;
      }
    };
    return (u, l) => {
      const a = P("p-link"), c = P("p-modal");
      return T(), O(c, {
        showModal: n.value,
        "onUpdate:showModal": l[0] || (l[0] = (p) => n.value = p),
        title: `Retry ${u.flowRun.name}?`
      }, {
        actions: k(() => [
          w(v(Zo), {
            variant: "default",
            onClick: i
          }, {
            default: k(() => [...l[4] || (l[4] = [
              q(" Retry ", -1)
            ])]),
            _: 1
          })
        ]),
        default: k(() => [
          q(" This will retry flow run " + ie(u.flowRun.name) + ". ", 1),
          re("div", null, [
            l[2] || (l[2] = q(" Any task runs without a ", -1)),
            w(a, {
              to: v(le).docs.resultsPersistence
            }, {
              default: k(() => [...l[1] || (l[1] = [
                q(" persisted result ", -1)
              ])]),
              _: 1
            }, 8, ["to"]),
            l[3] || (l[3] = q(" will be run again. ", -1))
          ])
        ]),
        _: 1
      }, 8, ["showModal", "title"]);
    };
  }
}), jU = /* @__PURE__ */ U({
  __name: "FlowRunRetryButton",
  props: {
    flowRun: {}
  },
  emits: ["update"],
  setup(t, { emit: e }) {
    const n = e, r = Ke(), { showModal: o, open: s } = St(), i = D(() => !r.update.flow_run || !t.flowRun.stateType || !t.flowRun.deploymentId ? !1 : fi(t.flowRun.stateType)), u = ge(!1);
    return (l, a) => {
      const c = P("p-button");
      return i.value ? (T(), O(c, {
        key: 0,
        "icon-append": "ArrowPathIcon",
        loading: u.value,
        onClick: v(s)
      }, {
        default: k(() => [
          a[3] || (a[3] = q(" Retry ", -1)),
          w(_R, {
            showModal: v(o),
            "onUpdate:showModal": a[0] || (a[0] = (p) => Xe(o) ? o.value = p : null),
            retryingRun: u.value,
            "onUpdate:retryingRun": a[1] || (a[1] = (p) => u.value = p),
            "flow-run": l.flowRun,
            onUpdate: a[2] || (a[2] = (p) => n("update"))
          }, null, 8, ["showModal", "retryingRun", "flow-run"])
        ]),
        _: 1
      }, 8, ["loading", "onClick"])) : j("", !0);
    };
  }
}), zU = /* @__PURE__ */ U({
  __name: "FlowRunsDeleteButton",
  props: {
    selected: {}
  },
  emits: ["delete"],
  setup(t, { emit: e }) {
    const n = e, { showModal: r, open: o, close: s } = St(), i = Se(), u = ge(!1), l = async (c) => {
      u.value = !0;
      const p = D(() => c.length === 1 ? "Flow run deleted" : `${c.length} flow runs deleted`), d = c.map((g) => a(g)), m = (await Promise.allSettled(d)).filter((g) => g.status === "rejected").map((g) => g.reason);
      if (m.length > 0) {
        if (m.length === 1) {
          const g = Yt(m[0], le.error.delete("Flow Run"));
          He(g, "error");
        } else
          He(`${m.length} flow runs failed to delete`, "error");
        u.value = !1;
        return;
      }
      u.value = !1, He(p, "success"), n("delete"), s();
    };
    async function a(c, p = 0) {
      try {
        await i.flowRuns.deleteFlowRun(c);
      } catch (d) {
        if (p < 2)
          return await new Promise((h) => setTimeout(h, 1e3)), a(c, p + 1);
        throw d;
      }
    }
    return (c, p) => {
      const d = P("p-button");
      return T(), z(ve, null, [
        w(mx, { name: "flow-runs-delete-button-transition" }, {
          default: k(() => [
            c.selected.length > 0 ? (T(), O(d, {
              key: 0,
              icon: "TrashIcon",
              small: "",
              onClick: v(o)
            }, null, 8, ["onClick"])) : j("", !0)
          ]),
          _: 1
        }),
        w(_r, {
          showModal: v(r),
          "onUpdate:showModal": p[0] || (p[0] = (h) => Xe(r) ? r.value = h : null),
          name: "selected flow runs",
          label: "Flow runs",
          loading: u.value,
          onDelete: p[1] || (p[1] = () => l(c.selected))
        }, null, 8, ["showModal", "loading"])
      ], 64);
    };
  }
}), wR = /* @__PURE__ */ U({
  __name: "FlowRunTagsInput",
  props: {
    selected: {},
    emptyMessage: {},
    filter: {}
  },
  emits: ["update:selected"],
  setup(t, { emit: e }) {
    const n = t, r = e, o = D(() => n.emptyMessage ?? "All tags"), s = D({
      get() {
        return n.selected ?? null;
      },
      set(l) {
        r("update:selected", l);
      }
    }), { flowRuns: i } = Qp(() => n.filter ?? {}), u = D(() => {
      const l = i.value.flatMap((a) => a.tags ?? []);
      return Bm(l).sort((a, c) => a.localeCompare(c));
    });
    return (l, a) => {
      const c = P("p-tags-input");
      return T(), O(c, yt({
        modelValue: s.value,
        "onUpdate:modelValue": a[0] || (a[0] = (p) => s.value = p),
        class: "flow-run-tags-input",
        "options-class": "flow-run-tags-input__options",
        placeholder: "Search or enter new tag"
      }, { options: u.value, emptyMessage: o.value }), null, 16, ["modelValue"]);
    };
  }
}), Rd = "allExceptScheduled", jl = "All run states", qh = /* @__PURE__ */ U({
  __name: "StateNameSelect",
  props: {
    selected: {},
    emptyMessage: {},
    multiple: { type: Boolean }
  },
  emits: ["update:selected"],
  setup(t, { emit: e }) {
    const n = t, r = e, o = D(() => n.multiple || eu(s.value) && s.value.length > 0), s = D({
      get() {
        return eu(n.selected) && !n.selected.length || !n.selected ? jl : n.selected.length === jg.length - 1 && !n.selected.includes("Scheduled") ? Rd : n.selected;
      },
      set(l) {
        if (!l)
          r("update:selected", []);
        else if (l === jl || l.includes(jl))
          r("update:selected", []);
        else if (o.value) {
          const a = eu(l) ? l : [l];
          a.includes(Rd) ? r("update:selected", jg.filter((c) => c !== "Scheduled")) : r("update:selected", a);
        } else
          r("update:selected", l);
      }
    }), i = D(() => {
      const l = jg.map((a) => {
        const { name: c, type: p } = uh(a);
        return {
          label: c,
          value: c,
          type: p
        };
      });
      return [
        {
          label: "All except scheduled",
          value: Rd
        },
        {
          label: "All run states",
          value: jl
        },
        ...l
      ];
    }), u = (l) => typeof l == "string" ? uh(l) : null;
    return (l, a) => (T(), O(v(Om), yt({
      modelValue: s.value,
      "onUpdate:modelValue": a[0] || (a[0] = (c) => s.value = c),
      class: "state-name-select"
    }, { options: i.value, multiple: o.value, emptyMessage: l.emptyMessage }), {
      option: k(({ option: c }) => [
        c.value === Rd ? (T(), z(ve, { key: 0 }, [
          q(" All except scheduled ")
        ], 64)) : c.value === jl ? (T(), z(ve, { key: 1 }, [
          q(" All run states ")
        ], 64)) : (T(), O(Dr, {
          key: 2,
          state: u(c.value)
        }, null, 8, ["state"]))
      ]),
      tag: k(({ value: c, dismiss: p }) => [
        c === Rd ? (T(), z(ve, { key: 0 }, [
          q(" All except scheduled ")
        ], 64)) : c === jl ? (T(), z(ve, { key: 1 }, [
          q(" All run states ")
        ], 64)) : (T(), O(Dr, {
          key: 2,
          class: "state-name-select__option state-name-select__option--multiple",
          state: u(c),
          dismissible: "",
          onDismiss: p
        }, null, 8, ["state", "onDismiss"]))
      ]),
      default: k(({ value: c }) => [
        c === Rd ? (T(), z(ve, { key: 0 }, [
          q(" All except scheduled ")
        ], 64)) : c === jl ? (T(), z(ve, { key: 1 }, [
          q(" All run states ")
        ], 64)) : (T(), O(Dr, {
          key: 2,
          class: "state-name-select__option",
          state: u(c),
          flat: ""
        }, null, 8, ["state"]))
      ]),
      _: 1
    }, 16, ["modelValue"]));
  }
}), aw = /* @__PURE__ */ U({
  __name: "WorkPoolCombobox",
  props: {
    selected: {},
    emptyMessage: {},
    allowUnset: { type: Boolean },
    multiple: { type: Boolean }
  },
  emits: ["update:selected"],
  setup(t, { emit: e }) {
    const n = t, r = e, o = D(() => Array.isArray(n.selected)), s = D({
      get() {
        return n.selected ?? null;
      },
      set(c) {
        c ? o.value ? r("update:selected", Array.isArray(c) ? c : [c]) : r("update:selected", c) : r("update:selected", null);
      }
    }), i = Se(), u = mt(i.workPools.getWorkPools, []), l = D(() => u.response ?? []), a = D(() => {
      const c = l.value.map((p) => ({
        value: p.name,
        label: p.name
      }));
      return n.allowUnset && c.unshift({
        value: null,
        label: "None"
      }), c;
    });
    return (c, p) => (T(), O(v(ts), yt({
      modelValue: s.value,
      "onUpdate:modelValue": p[0] || (p[0] = (d) => s.value = d)
    }, { options: a.value, emptyMessage: c.emptyMessage, multiple: o.value }), {
      "combobox-options-empty": k(() => [...p[1] || (p[1] = [
        q(" No work pools ", -1)
      ])]),
      default: k((d) => [
        Ve(c.$slots, "default", sn(kn(d)))
      ]),
      option: k(({ option: d }) => [
        Ve(c.$slots, "option", { option: d })
      ]),
      _: 3
    }, 16, ["modelValue"]));
  }
}), HOe = { class: "flow-runs-filter-group" }, jOe = { class: "flow-runs-filter-group__row" }, zOe = { class: "flow-runs-filter-group__row" }, qOe = /* @__PURE__ */ U({
  __name: "FlowRunsFilterGroup",
  props: {
    filter: {},
    nameSearch: {}
  },
  emits: ["update:filter", "update:name"],
  setup(t, { emit: e }) {
    const n = t, r = e, o = D({
      get() {
        return n.filter;
      },
      set(d) {
        r("update:filter", d);
      }
    }), s = D({
      get() {
        return n.nameSearch;
      },
      set(d) {
        r("update:name", d);
      }
    }), i = mr(o, "state"), u = mr(o, "flow"), l = mr(o, "deployment"), a = mr(o, "workPool"), c = mr(o, "tag"), p = mr(o, "range");
    return (d, h) => (T(), z("div", HOe, [
      re("div", jOe, [
        w(v(nr), { label: "Date Range" }, {
          default: k(() => [
            w(fL, {
              modelValue: v(p),
              "onUpdate:modelValue": h[0] || (h[0] = (m) => Xe(p) ? p.value = m : null)
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        w(v(nr), { label: "States" }, {
          default: k(() => [
            w(qh, {
              selected: v(i),
              "onUpdate:selected": h[1] || (h[1] = (m) => Xe(i) ? i.value = m : null),
              "empty-message": "All run states",
              multiple: ""
            }, null, 8, ["selected"])
          ]),
          _: 1
        })
      ]),
      re("div", zOe, [
        w(v(nr), { label: "Flows" }, {
          default: k(() => [
            w(gS, {
              selected: v(u),
              "onUpdate:selected": h[2] || (h[2] = (m) => Xe(u) ? u.value = m : null),
              "empty-message": "All flows",
              multiple: ""
            }, null, 8, ["selected"])
          ]),
          _: 1
        }),
        w(v(nr), { label: "Deployments" }, {
          default: k(() => [
            w(oS, {
              selected: v(l),
              "onUpdate:selected": h[3] || (h[3] = (m) => Xe(l) ? l.value = m : null),
              "empty-message": "All deployments",
              multiple: ""
            }, null, 8, ["selected"])
          ]),
          _: 1
        }),
        w(v(nr), { label: "Work Pools" }, {
          default: k(() => [
            w(aw, {
              selected: v(a),
              "onUpdate:selected": h[4] || (h[4] = (m) => Xe(a) ? a.value = m : null),
              "empty-message": "All pools",
              multiple: ""
            }, null, 8, ["selected"])
          ]),
          _: 1
        }),
        w(v(nr), { label: "Tags" }, {
          default: k(() => [
            w(wR, {
              selected: v(c),
              "onUpdate:selected": h[5] || (h[5] = (m) => Xe(c) ? c.value = m : null),
              "empty-message": "All tags"
            }, null, 8, ["selected"])
          ]),
          _: 1
        })
      ]),
      w(v(nr), {
        class: "flow-runs-filter-group__search",
        label: "Search"
      }, {
        default: k(() => [
          w(Wo, {
            modelValue: s.value,
            "onUpdate:modelValue": h[6] || (h[6] = (m) => s.value = m),
            placeholder: "Search by flow run name",
            label: "Search by flow run name"
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      })
    ]));
  }
}), GOe = /* @__PURE__ */ U({
  __name: "FlowRunsPageEmptyState",
  setup(t) {
    return (e, n) => (T(), O(v(na), { class: "flow-runs-page-empty-state" }, {
      icon: k(() => [
        w(v(vo), { icon: "FlowRun" })
      ]),
      heading: k(() => [...n[0] || (n[0] = [
        q(" Run a task or flow to get started ", -1)
      ])]),
      description: k(() => [...n[1] || (n[1] = [
        q(" Runs store the state history for each execution of a task or flow. ", -1)
      ])]),
      actions: k(() => [
        Ve(e.$slots, "actions", {}, () => [
          w(Os, {
            to: v(le).docs.gettingStarted
          }, {
            default: k(() => [...n[2] || (n[2] = [
              q(" Get Started ", -1)
            ])]),
            _: 1
          }, 8, ["to"])
        ])
      ]),
      _: 3
    }));
  }
}), YOe = { class: "flow-runs-scatter-plot-plot" }, QOe = /* @__PURE__ */ U({
  __name: "FlowRunsScatterPlot",
  props: {
    history: {},
    startDate: {},
    endDate: {}
  },
  setup(t) {
    const e = t, n = D(() => ye.map("UiFlowRunHistory", e.history, "ScatterPlotItem"));
    return (r, o) => (T(), z("div", YOe, [
      w(v(_j), {
        items: n.value,
        "start-date": r.startDate,
        "end-date": r.endDate,
        "dot-diameter": 16
      }, {
        default: k(({ item: s }) => [
          w(VU, {
            "flow-run-id": s.id
          }, null, 8, ["flow-run-id"])
        ]),
        _: 1
      }, 8, ["items", "start-date", "end-date"])
    ]));
  }
}), qU = /* @__PURE__ */ U({
  __name: "FlowRunsSort",
  props: {
    modelValue: {}
  },
  emits: ["update:modelValue"],
  setup(t, { emit: e }) {
    const n = t, r = e, o = D({
      get() {
        return n.modelValue;
      },
      set(i) {
        r("update:modelValue", i);
      }
    }), s = [
      { label: "Newest to oldest", value: "START_TIME_DESC" },
      { label: "Oldest to newest", value: "START_TIME_ASC" },
      { label: "A to Z", value: "NAME_ASC" },
      { label: "Z to A", value: "NAME_DESC" }
    ];
    return (i, u) => (T(), O(v(Om), {
      modelValue: o.value,
      "onUpdate:modelValue": u[0] || (u[0] = (l) => o.value = l),
      options: s
    }, null, 8, ["modelValue"]));
  }
}), KOe = /* @__PURE__ */ U({
  __name: "FlowRunsAccordionContent",
  props: {
    flowId: {},
    filter: {}
  },
  setup(t) {
    const e = t, { filter: n } = dN($t({}, e.filter, {
      flows: {
        ...e.filter?.flows,
        id: [e.flowId]
      },
      limit: 3
    })), { flowRuns: r, pages: o } = kN(n);
    return (s, i) => {
      const u = P("p-pager"), l = P("p-content");
      return T(), O(l, null, {
        default: k(() => [
          w(sw, {
            "flow-runs": v(r),
            selected: null,
            class: "flow-flow-runs-list",
            "hide-flow-name": "",
            "hide-details": ""
          }, null, 8, ["flow-runs"]),
          v(o) > 1 ? (T(), O(u, {
            key: 0,
            page: v(n).page,
            "onUpdate:page": i[0] || (i[0] = (a) => v(n).page = a),
            pages: v(o)
          }, null, 8, ["page", "pages"])) : j("", !0)
        ]),
        _: 1
      });
    };
  }
}), ZOe = ["id"], JOe = { class: "flow-runs-accordion-header__content" }, eIe = { class: "flow-runs-accordion-header__time" }, tIe = { class: "flow-runs-accordion-header__count" }, nIe = /* @__PURE__ */ U({
  __name: "FlowRunsAccordionHeader",
  props: {
    flow: {},
    filter: {}
  },
  setup(t) {
    const e = t, n = je(), r = D(() => ({
      ...e.filter,
      flows: {
        ...e.filter?.flows,
        id: [e.flow.id]
      }
    })), { flowRun: o } = _N(r), { count: s } = du(r);
    return (i, u) => {
      const l = P("p-link");
      return T(), z("div", {
        id: i.flow.id,
        class: "flow-runs-accordion-header"
      }, [
        re("div", JOe, [
          w(l, {
            to: v(n).flow(i.flow.id),
            class: "flow-runs-accordion-header__name"
          }, {
            default: k(() => [
              q(ie(i.flow.name), 1)
            ]),
            _: 1
          }, 8, ["to"]),
          v(o)?.startTime ? (T(), O(hn, {
            key: 0,
            date: v(o).startTime,
            format: "relative"
          }, {
            default: k(({ date: a }) => [
              re("span", eIe, ie(a), 1)
            ]),
            _: 1
          }, 8, ["date"])) : j("", !0)
        ]),
        re("span", tIe, ie(v(s)), 1)
      ], 8, ZOe);
    };
  }
}), rIe = {}, oIe = {
  viewBox: "0 0 92 128",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function sIe(t, e) {
  return T(), z("svg", oIe, [...e[0] || (e[0] = [
    Pm('<rect x="88.2922" y="96.4243" width="10.974" height="10.974" rx="2.9264" transform="rotate(180 88.2922 96.4243)" fill="#FFEAC4"></rect><rect x="69.6321" y="22.974" width="10.974" height="10.974" rx="2.9264" transform="rotate(180 69.6321 22.974)" fill="#2C0C00"></rect><rect x="88.2922" y="78.1342" width="10.974" height="10.974" rx="2.9264" transform="rotate(180 88.2922 78.1342)" fill="#FFEAC4"></rect><rect x="52.6266" y="97.3386" width="12.803" height="12.803" rx="2.1948" transform="rotate(180 52.6266 97.3386)" fill="#FFEAC4"></rect><rect x="52.6266" y="42.4686" width="12.803" height="12.803" rx="2.1948" transform="rotate(180 52.6266 42.4686)" fill="#FFB838"></rect><rect x="70.9166" y="60.7586" width="12.803" height="12.803" rx="2.1948" transform="rotate(180 70.9166 60.7586)" fill="#FFAD1A"></rect><rect x="53.5411" y="79.9631" width="14.632" height="14.632" rx="1.4632" transform="rotate(180 53.5411 79.9631)" fill="#FFEAC4"></rect><rect x="70.9166" y="97.3386" width="12.803" height="12.803" rx="2.1948" transform="rotate(180 70.9166 97.3386)" fill="#FFEAC4"></rect><rect x="52.6266" y="115.629" width="12.803" height="12.803" rx="2.1948" transform="rotate(180 52.6266 115.629)" fill="#FFEAC4"></rect><rect x="53.5411" y="61.6732" width="14.632" height="14.632" rx="1.4632" transform="rotate(180 53.5411 61.6732)" fill="#FFAD1A"></rect><rect x="70.0022" y="41.5541" width="10.974" height="10.974" rx="2.9264" transform="rotate(180 70.0022 41.5541)" fill="#2C0C00"></rect><rect x="70.0022" y="114.714" width="10.974" height="10.974" rx="2.9264" transform="rotate(180 70.0022 114.714)" fill="#FFEAC4"></rect><rect x="70.9166" y="79.0486" width="12.803" height="12.803" rx="2.1948" transform="rotate(180 70.9166 79.0486)" fill="#FFEAC4"></rect><rect x="33.4221" y="114.714" width="10.974" height="10.974" rx="2.9264" transform="rotate(180 33.4221 114.714)" fill="#FFEAC4"></rect><rect x="34.3365" y="97.3386" width="12.803" height="12.803" rx="2.1948" transform="rotate(180 34.3365 97.3386)" fill="#FFEAC4"></rect><rect x="34.3365" y="79.0486" width="12.803" height="12.803" rx="2.1948" transform="rotate(180 34.3365 79.0486)" fill="#FFEAC4"></rect><rect x="34.3365" y="61.1785" width="12.803" height="12.803" rx="2.1948" transform="rotate(180 34.3365 61.1785)" fill="#FFAD1A"></rect><rect x="33.4221" y="41.5541" width="10.974" height="10.974" rx="2.9264" transform="rotate(180 33.4221 41.5541)" fill="#2C0C00"></rect><rect x="33.4221" y="22.974" width="10.974" height="10.974" rx="2.9264" transform="rotate(180 33.4221 22.974)" fill="#2C0C00"></rect><rect x="87.3777" y="113.8" width="9.145" height="9.145" rx="3.658" transform="rotate(180 87.3777 113.8)" fill="#FFEAC4"></rect><rect x="87.3777" y="40.6396" width="9.145" height="9.145" rx="3.658" transform="rotate(180 87.3777 40.6396)" fill="#FFB838"></rect><rect x="14.2175" y="113.8" width="9.145" height="9.145" rx="3.658" transform="rotate(180 14.2175 113.8)" fill="#FFEAC4"></rect><rect x="15.1321" y="96.4243" width="10.974" height="10.974" rx="2.9264" transform="rotate(180 15.1321 96.4243)" fill="#FFEAC4"></rect><rect x="15.1321" y="78.1342" width="10.974" height="10.974" rx="2.9264" transform="rotate(180 15.1321 78.1342)" fill="#FFEAC4"></rect><rect x="15.1321" y="59.8441" width="10.974" height="10.974" rx="2.9264" transform="rotate(180 15.1321 59.8441)" fill="#FFAD1A"></rect><rect x="14.2175" y="40.6396" width="9.145" height="9.145" rx="3.658" transform="rotate(180 14.2175 40.6396)" fill="#FFB838"></rect><rect x="88.2922" y="59.8441" width="10.974" height="10.974" rx="2.9264" transform="rotate(180 88.2922 59.8441)" fill="#FFAD1A"></rect>', 27)
  ])]);
}
const aIe = /* @__PURE__ */ Dc(rIe, [["render", sIe]]), iIe = {}, uIe = {
  viewBox: "0 0 157 128",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function lIe(t, e) {
  return T(), z("svg", uIe, [...e[0] || (e[0] = [
    Pm('<rect x="16.2571" y="88.6859" width="12.8" height="12.8" rx="2.19428" transform="rotate(180 16.2571 88.6859)" fill="#A4E392"></rect><rect x="81.3142" y="89.6" width="14.6286" height="14.6286" rx="1.46286" transform="rotate(180 81.3142 89.6)" fill="#306739"></rect><rect x="117.886" y="89.6" width="14.6286" height="14.6286" rx="1.46286" transform="rotate(180 117.886 89.6)" fill="#78D382"></rect><rect x="15.3428" y="69.4857" width="10.9714" height="10.9714" rx="2.92571" transform="rotate(180 15.3428 69.4857)" fill="#D4F8B5"></rect><rect x="81.3142" y="71.3143" width="14.6286" height="14.6286" rx="1.46286" transform="rotate(180 81.3142 71.3143)" fill="#51A456"></rect><rect x="117.886" y="71.3143" width="14.6286" height="14.6286" rx="1.46286" transform="rotate(180 117.886 71.3143)" fill="#78D382"></rect><rect x="81.3142" y="53.0286" width="14.6286" height="14.6286" rx="1.46286" transform="rotate(180 81.3142 53.0286)" fill="#78D382"></rect><rect x="98.6858" y="33.8286" width="12.8" height="12.8" rx="2.19428" transform="rotate(180 98.6858 33.8286)" fill="#A4E392"></rect><rect x="35.4573" y="89.6002" width="14.6286" height="14.6286" rx="1.46286" transform="rotate(180 35.4573 89.6002)" fill="#78D382"></rect><rect x="99.6001" y="89.6" width="14.6286" height="14.6286" rx="1.46286" transform="rotate(180 99.6001 89.6)" fill="#51A456"></rect><rect x="135.257" y="88.6857" width="12.8" height="12.8" rx="2.19428" transform="rotate(180 135.257 88.6857)" fill="#78D382"></rect><rect x="63.0286" y="89.6" width="14.6286" height="14.6286" rx="1.46286" transform="rotate(180 63.0286 89.6)" fill="#306739"></rect><rect x="34.543" y="70.4" width="12.8" height="12.8" rx="2.19428" transform="rotate(180 34.543 70.4)" fill="#A4E392"></rect><rect x="99.6001" y="71.3143" width="14.6286" height="14.6286" rx="1.46286" transform="rotate(180 99.6001 71.3143)" fill="#51A456"></rect><rect x="135.257" y="70.4" width="12.8" height="12.8" rx="2.19428" transform="rotate(180 135.257 70.4)" fill="#78D382"></rect><rect x="97.6287" y="14.6285" width="10.9714" height="10.9714" rx="2.92571" transform="rotate(180 97.6287 14.6285)" fill="#A4E392"></rect><rect x="61.6287" y="51.6285" width="10.9714" height="10.9714" rx="2.92571" transform="rotate(180 61.6287 51.6285)" fill="#A4E392"></rect><rect x="80.2571" y="33.8286" width="12.8" height="12.8" rx="2.19428" transform="rotate(180 80.2571 33.8286)" fill="#78D382"></rect><rect x="63.0286" y="71.3143" width="14.6286" height="14.6286" rx="1.46286" transform="rotate(180 63.0286 71.3143)" fill="#51A456"></rect><rect x="35.4573" y="107.886" width="14.6286" height="14.6286" rx="1.46286" transform="rotate(180 35.4573 107.886)" fill="#78D382"></rect><rect x="99.6001" y="107.886" width="14.6286" height="14.6286" rx="1.46286" transform="rotate(180 99.6001 107.886)" fill="#51A456"></rect><rect x="135.257" y="106.971" width="12.8" height="12.8" rx="2.19428" transform="rotate(180 135.257 106.971)" fill="#78D382"></rect><rect x="63.0286" y="107.886" width="14.6286" height="14.6286" rx="1.46286" transform="rotate(180 63.0286 107.886)" fill="#51A456"></rect><rect x="34.543" y="125.257" width="12.8" height="12.8" rx="2.19428" transform="rotate(180 34.543 125.257)" fill="#A4E392"></rect><rect x="99.6001" y="126.171" width="14.6286" height="14.6286" rx="1.46286" transform="rotate(180 99.6001 126.171)" fill="#78D382"></rect><rect x="63.0286" y="126.171" width="14.6286" height="14.6286" rx="1.46286" transform="rotate(180 63.0286 126.171)" fill="#78D382"></rect><rect x="16.2571" y="106.971" width="12.8" height="12.8" rx="2.19428" transform="rotate(180 16.2571 106.971)" fill="#A4E392"></rect><rect x="81.3142" y="107.886" width="14.6286" height="14.6286" rx="1.46286" transform="rotate(180 81.3142 107.886)" fill="#51A456"></rect><rect x="117.886" y="107.886" width="14.6286" height="14.6286" rx="1.46286" transform="rotate(180 117.886 107.886)" fill="#78D382"></rect><rect x="15.3428" y="124.343" width="10.9714" height="10.9714" rx="2.92571" transform="rotate(180 15.3428 124.343)" fill="#D4F8B5"></rect><rect x="81.3142" y="126.171" width="14.6286" height="14.6286" rx="1.46286" transform="rotate(180 81.3142 126.171)" fill="#78D382"></rect><rect x="116.971" y="125.257" width="12.8" height="12.8" rx="2.19428" transform="rotate(180 116.971 125.257)" fill="#78D382"></rect>', 32)
  ])]);
}
const cIe = /* @__PURE__ */ Dc(iIe, [["render", lIe]]), pIe = {}, dIe = {
  viewBox: "0 0 111 110",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function hIe(t, e) {
  return T(), z("svg", dIe, [...e[0] || (e[0] = [
    Pm('<rect x="54.4553" y="90.4055" width="16.461" height="16.461" rx="0.7316" transform="rotate(180 54.4553 90.4055)" fill="#9B0806"></rect><rect x="51.7119" y="14.502" width="10.974" height="10.974" rx="2.9264" transform="rotate(180 51.7119 14.502)" fill="#FFD3D3"></rect><rect x="89.2063" y="88.5764" width="12.803" height="12.803" rx="2.1948" transform="rotate(180 89.2063 88.5764)" fill="#FFD3D3"></rect><rect x="88.2917" y="14.502" width="10.974" height="10.974" rx="2.9264" transform="rotate(180 88.2917 14.502)" fill="#FFD3D3"></rect><rect x="53.5408" y="71.201" width="14.632" height="14.632" rx="1.4632" transform="rotate(180 53.5408 71.201)" fill="#EB8583"></rect><rect x="89.2063" y="70.2865" width="12.803" height="12.803" rx="2.1948" transform="rotate(180 89.2063 70.2865)" fill="#EB8583"></rect><rect x="15.1318" y="87.6619" width="10.974" height="10.974" rx="2.9264" transform="rotate(180 15.1318 87.6619)" fill="#FFD3D3"></rect><rect x="70.9165" y="88.5764" width="12.803" height="12.803" rx="2.1948" transform="rotate(180 70.9165 88.5764)" fill="#EB8583"></rect><rect x="70.002" y="14.502" width="10.974" height="10.974" rx="2.9264" transform="rotate(180 70.002 14.502)" fill="#FFD3D3"></rect><rect x="106.582" y="87.6619" width="10.974" height="10.974" rx="2.9264" transform="rotate(180 106.582 87.6619)" fill="#FFD3D3"></rect><rect x="34.3364" y="88.5764" width="12.803" height="12.803" rx="2.1948" transform="rotate(180 34.3364 88.5764)" fill="#FFD3D3"></rect><rect x="33.4219" y="14.502" width="10.974" height="10.974" rx="2.9264" transform="rotate(180 33.4219 14.502)" fill="#FFD3D3"></rect><rect x="15.1318" y="69.372" width="10.974" height="10.974" rx="2.9264" transform="rotate(180 15.1318 69.372)" fill="#FFD3D3"></rect><rect x="71.8308" y="71.201" width="14.632" height="14.632" rx="1.4632" transform="rotate(180 71.8308 71.201)" fill="#9B0806"></rect><rect x="106.582" y="69.372" width="10.974" height="10.974" rx="2.9264" transform="rotate(180 106.582 69.372)" fill="#FFD3D3"></rect><rect x="35.2507" y="71.201" width="14.632" height="14.632" rx="1.4632" transform="rotate(180 35.2507 71.201)" fill="#9B0806"></rect><rect x="15.1318" y="32.7919" width="10.974" height="10.974" rx="2.9264" transform="rotate(180 15.1318 32.7919)" fill="#FFD3D3"></rect><rect x="70.002" y="105.952" width="10.974" height="10.974" rx="2.9264" transform="rotate(180 70.002 105.952)" fill="#FFD3D3"></rect><rect x="70.9165" y="33.7064" width="12.803" height="12.803" rx="2.1948" transform="rotate(180 70.9165 33.7064)" fill="#EB8583"></rect><rect x="106.582" y="32.7919" width="10.974" height="10.974" rx="2.9264" transform="rotate(180 106.582 32.7919)" fill="#FFD3D3"></rect><rect x="33.4219" y="105.952" width="10.974" height="10.974" rx="2.9264" transform="rotate(180 33.4219 105.952)" fill="#FFD3D3"></rect><rect x="34.3364" y="33.7064" width="12.803" height="12.803" rx="2.1948" transform="rotate(180 34.3364 33.7064)" fill="#FFD3D3"></rect><rect x="15.1318" y="51.082" width="10.974" height="10.974" rx="2.9264" transform="rotate(180 15.1318 51.082)" fill="#FFD3D3"></rect><rect x="71.8308" y="52.911" width="14.632" height="14.632" rx="1.4632" transform="rotate(180 71.8308 52.911)" fill="#EB8583"></rect><rect x="34.3364" y="51.9965" width="12.803" height="12.803" rx="2.1948" transform="rotate(180 34.3364 51.9965)" fill="#EB8583"></rect><rect x="51.7119" y="105.952" width="10.974" height="10.974" rx="2.9264" transform="rotate(180 51.7119 105.952)" fill="#FFD3D3"></rect><rect x="52.6265" y="33.7064" width="12.803" height="12.803" rx="2.1948" transform="rotate(180 52.6265 33.7064)" fill="#EB8583"></rect><rect x="88.2917" y="105.952" width="10.974" height="10.974" rx="2.9264" transform="rotate(180 88.2917 105.952)" fill="#FFD3D3"></rect><rect x="89.2063" y="33.7064" width="12.803" height="12.803" rx="2.1948" transform="rotate(180 89.2063 33.7064)" fill="#FFD3D3"></rect><rect x="53.5408" y="52.911" width="14.632" height="14.632" rx="1.4632" transform="rotate(180 53.5408 52.911)" fill="#EB8583"></rect><rect x="89.2063" y="51.9965" width="12.803" height="12.803" rx="2.1948" transform="rotate(180 89.2063 51.9965)" fill="#9B0806"></rect><rect x="106.582" y="51.082" width="10.974" height="10.974" rx="2.9264" transform="rotate(180 106.582 51.082)" fill="#FFD3D3"></rect>', 32)
  ])]);
}
const fIe = /* @__PURE__ */ Dc(pIe, [["render", hIe]]), mIe = {}, yIe = {
  viewBox: "0 0 129 128",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function gIe(t, e) {
  return T(), z("svg", yIe, [...e[0] || (e[0] = [
    Pm('<rect x="52.4965" y="88.7064" width="12.803" height="12.803" rx="2.1948" transform="rotate(180 52.4965 88.7064)" fill="#080072"></rect><rect x="50.6675" y="13.7175" width="9.145" height="9.145" rx="3.658" transform="rotate(180 50.6675 13.7175)" fill="#8FDDFF"></rect><rect x="89.0764" y="88.7064" width="12.803" height="12.803" rx="2.1948" transform="rotate(180 89.0764 88.7064)" fill="#080072"></rect><rect x="88.6321" y="105.632" width="10.974" height="10.974" rx="2.9264" transform="rotate(180 88.6321 105.632)" fill="#13A7FF"></rect><rect x="106.422" y="105.922" width="10.974" height="10.974" rx="2.9264" transform="rotate(180 106.422 105.922)" fill="#8FDDFF"></rect><rect x="52.4965" y="70.4165" width="12.803" height="12.803" rx="2.1948" transform="rotate(180 52.4965 70.4165)" fill="#13A7FF"></rect><rect x="89.0764" y="70.4165" width="12.803" height="12.803" rx="2.1948" transform="rotate(180 89.0764 70.4165)" fill="#13A7FF"></rect><rect x="70.7865" y="88.7064" width="12.803" height="12.803" rx="2.1948" transform="rotate(180 70.7865 88.7064)" fill="#13A7FF"></rect><rect x="68.9575" y="13.7175" width="9.145" height="9.145" rx="3.658" transform="rotate(180 68.9575 13.7175)" fill="#8FDDFF"></rect><rect x="87.2175" y="13.7175" width="9.145" height="9.145" rx="3.658" transform="rotate(180 87.2175 13.7175)" fill="#8FDDFF"></rect><rect x="33.292" y="87.7919" width="10.974" height="10.974" rx="2.9264" transform="rotate(180 33.292 87.7919)" fill="#13A7FF"></rect><rect x="33.292" y="105.922" width="10.974" height="10.974" rx="2.9264" transform="rotate(180 33.292 105.922)" fill="#8FDDFF"></rect><rect x="14.0875" y="68.5875" width="9.145" height="9.145" rx="3.658" transform="rotate(180 14.0875 68.5875)" fill="#8FDDFF"></rect><rect x="14.0875" y="86.7175" width="9.145" height="9.145" rx="3.658" transform="rotate(180 14.0875 86.7175)" fill="#8FDDFF"></rect><rect x="71.701" y="71.3311" width="14.632" height="14.632" rx="1.4632" transform="rotate(180 71.701 71.3311)" fill="#080072"></rect><rect x="107.366" y="70.4165" width="12.803" height="12.803" rx="2.1948" transform="rotate(180 107.366 70.4165)" fill="#13A7FF"></rect><rect x="123.798" y="68.5875" width="9.145" height="9.145" rx="3.658" transform="rotate(180 123.798 68.5875)" fill="#8FDDFF"></rect><rect x="106.452" y="87.632" width="10.974" height="10.974" rx="2.9264" transform="rotate(180 106.452 87.632)" fill="#13A7FF"></rect><rect x="123.798" y="86.7175" width="9.145" height="9.145" rx="3.658" transform="rotate(180 123.798 86.7175)" fill="#8FDDFF"></rect><rect x="34.2064" y="70.4165" width="12.803" height="12.803" rx="2.1948" transform="rotate(180 34.2064 70.4165)" fill="#13A7FF"></rect><rect x="70.7865" y="106.996" width="12.803" height="12.803" rx="2.1948" transform="rotate(180 70.7865 106.996)" fill="#13A7FF"></rect><rect x="68.9575" y="123.297" width="9.145" height="9.145" rx="3.658" transform="rotate(180 68.9575 123.297)" fill="#8FDDFF"></rect><rect x="87.2175" y="123.297" width="9.145" height="9.145" rx="3.658" transform="rotate(180 87.2175 123.297)" fill="#8FDDFF"></rect><rect x="70.7865" y="33.8364" width="12.803" height="12.803" rx="2.1948" transform="rotate(180 70.7865 33.8364)" fill="#13A7FF"></rect><rect x="33.292" y="32.9219" width="10.974" height="10.974" rx="2.9264" transform="rotate(180 33.292 32.9219)" fill="#8FDDFF"></rect><rect x="14.0875" y="50.2975" width="9.145" height="9.145" rx="3.658" transform="rotate(180 14.0875 50.2975)" fill="#8FDDFF"></rect><rect x="70.7865" y="52.1265" width="12.803" height="12.803" rx="2.1948" transform="rotate(180 70.7865 52.1265)" fill="#13A7FF"></rect><rect x="33.292" y="51.212" width="10.974" height="10.974" rx="2.9264" transform="rotate(180 33.292 51.212)" fill="#13A7FF"></rect><rect x="51.582" y="106.082" width="10.974" height="10.974" rx="2.9264" transform="rotate(180 51.582 106.082)" fill="#13A7FF"></rect><rect x="50.6675" y="123.297" width="9.145" height="9.145" rx="3.658" transform="rotate(180 50.6675 123.297)" fill="#8FDDFF"></rect><rect x="51.582" y="32.9219" width="10.974" height="10.974" rx="2.9264" transform="rotate(180 51.582 32.9219)" fill="#13A7FF"></rect><rect x="88.162" y="32.9219" width="10.974" height="10.974" rx="2.9264" transform="rotate(180 88.162 32.9219)" fill="#13A7FF"></rect><rect x="106.422" y="32.9219" width="10.974" height="10.974" rx="2.9264" transform="rotate(180 106.422 32.9219)" fill="#8FDDFF"></rect><rect x="52.4965" y="52.1265" width="12.803" height="12.803" rx="2.1948" transform="rotate(180 52.4965 52.1265)" fill="#080072"></rect><rect x="89.0764" y="52.1265" width="12.803" height="12.803" rx="2.1948" transform="rotate(180 89.0764 52.1265)" fill="#080072"></rect><rect x="106.452" y="51.212" width="10.974" height="10.974" rx="2.9264" transform="rotate(180 106.452 51.212)" fill="#13A7FF"></rect><rect x="123.798" y="50.2975" width="9.145" height="9.145" rx="3.658" transform="rotate(180 123.798 50.2975)" fill="#8FDDFF"></rect>', 37)
  ])]);
}
const vIe = /* @__PURE__ */ Dc(mIe, [["render", gIe]]), _Ie = { class: "flow-run-state-type-empty" }, wIe = { class: "flow-run-state-type-empty__message" }, bIe = /* @__PURE__ */ U({
  __name: "FlowRunStateTypeEmpty",
  props: {
    stateType: {}
  },
  setup(t) {
    const e = t, n = D(() => tl(e.stateType).map((i) => i === "scheduled" ? "late" : i)), r = new Intl.ListFormat("en", { style: "long", type: "disjunction" }), o = D(() => `You currently have 0 ${r.format(n.value)} runs.`), s = D(() => n.value.includes("failed") ? cIe : n.value.includes("running") ? vIe : n.value.includes("completed") ? fIe : n.value.includes("late") ? aIe : null);
    return (i, u) => (T(), z("div", _Ie, [
      s.value ? (T(), O(Mr(s.value), {
        key: 0,
        class: "flow-run-state-type-empty__img"
      })) : j("", !0),
      re("p", wIe, ie(o.value), 1)
    ]));
  }
}), kIe = /* @__PURE__ */ U({
  __name: "FlowRunsAccordion",
  props: {
    filter: { type: Function },
    stateType: {}
  },
  setup(t) {
    const n = xe(t.filter), r = () => {
      const { sort: d, limit: h, offset: m, ...g } = n.value;
      return {
        ...g,
        sort: "UPDATED_DESC"
      };
    }, o = Xa(), { count: s, subscription: i } = du(n, o), u = D(() => i.executed), { flows: l } = b2(r, o), a = D(() => l.value.map((d) => d.id)), c = D(() => cu(l.value, "id"));
    function p(d) {
      const h = c.value.get(d);
      if (!h)
        throw new Error(`FlowRunsAccordion: Flow with id ${d} not found in flowsLookup`);
      return h;
    }
    return (d, h) => {
      const m = P("p-accordion");
      return T(), z(ve, null, [
        a.value ? (T(), O(m, {
          key: 0,
          sections: a.value,
          class: "flow-runs-accordion"
        }, {
          heading: k(({ section: g }) => [
            w(nIe, {
              flow: p(g),
              filter: n.value
            }, null, 8, ["flow", "filter"])
          ]),
          content: k(({ section: g }) => [
            w(KOe, {
              "flow-id": g,
              filter: n.value
            }, null, 8, ["flow-id", "filter"])
          ]),
          _: 1
        }, 8, ["sections"])) : j("", !0),
        !v(s) && u.value ? (T(), O(bIe, {
          key: 1,
          "state-type": d.stateType
        }, null, 8, ["state-type"])) : j("", !0)
      ], 64);
    };
  }
}), TIe = { class: "flow-run-state-type-count" }, xIe = { class: "flow-run-state-type-count__badge" }, SIe = { class: "flow-run-state-type-count__value" }, RIe = /* @__PURE__ */ U({
  __name: "FlowRunStateTypeCount",
  props: {
    stateType: {},
    filter: { type: Function }
  },
  setup(t) {
    const e = t, n = D(() => tl(e.stateType)), r = () => {
      const u = Qe(e.filter), l = {
        flowRuns: {
          state: {
            type: n.value
          }
        }
      };
      return $t({}, u, l);
    }, o = Xa(), { count: s } = du(r, o);
    function i(u) {
      return `bg-state-${u}-500`;
    }
    return (u, l) => (T(), z("div", TIe, [
      re("span", xIe, [
        (T(!0), z(ve, null, ln(n.value, (a) => (T(), z("span", {
          key: a,
          class: Bt(["flow-run-state-type-count__state", i(a)])
        }, null, 2))), 128))
      ]),
      re("span", SIe, ie(v(s)), 1)
    ]));
  }
}), GU = /* @__PURE__ */ U({
  __name: "FlowRunStateTypeTabs",
  props: {
    filter: { type: Function }
  },
  setup(t) {
    const e = t, n = {
      failed: ["failed", "crashed"],
      running: ["running", "pending", "cancelling"],
      completed: ["completed"],
      scheduled: ["scheduled", "paused"],
      cancelled: ["cancelled"]
    }, { count: r } = du(u("cancelled")), o = D(() => {
      const l = Object.keys(n);
      return (!r.value || r.value < 1) && l.filter((a) => a !== "cancelled"), l;
    }), s = dn("flow-run-state", "failed");
    function i(l) {
      return n[l];
    }
    function u(l) {
      return () => {
        const a = Qe(e.filter), c = {
          flowRuns: {
            state: {
              type: i(l)
            }
          },
          sort: "EXPECTED_START_TIME_DESC"
        };
        return $t({}, a, c);
      };
    }
    return (l, a) => {
      const c = P("p-content"), p = P("p-tabs");
      return T(), O(p, {
        selected: v(s),
        "onUpdate:selected": a[0] || (a[0] = (d) => Xe(s) ? s.value = d : null),
        tabs: o.value,
        class: "flow-run-state-type-tabs"
      }, {
        heading: k(({ tab: d }) => [
          d ? (T(), O(RIe, {
            key: 0,
            "state-type": i(d.label),
            filter: u(d.label)
          }, null, 8, ["state-type", "filter"])) : j("", !0)
        ]),
        content: k(({ tab: d }) => [
          w(c, null, {
            default: k(() => [
              w(kIe, {
                filter: u(d.label),
                "state-type": i(d.label)
              }, null, 8, ["filter", "state-type"])
            ]),
            _: 2
          }, 1024)
        ]),
        _: 1
      }, 8, ["selected", "tabs"]);
    };
  }
}), bR = /* @__PURE__ */ U({
  __name: "FlowRunSuspendModal",
  props: /* @__PURE__ */ Br({
    flowRun: {}
  }, {
    showModal: { type: Boolean, required: !0 },
    showModalModifiers: {}
  }),
  emits: /* @__PURE__ */ Br(["update"], ["update:showModal"]),
  setup(t, { emit: e }) {
    const n = zn(t, "showModal"), r = t, o = e, s = ge(300), { handleSubmit: i, isSubmitting: u } = Mc(), { value: l, meta: a, errorMessage: c } = Rs("timeout", qp("Limit", Kr, a2(4)), { initialValue: s }), p = Se(), d = i(async (h) => {
      try {
        const { timeout: m } = h, g = {
          type: "paused",
          name: "Suspended",
          stateDetails: {
            pauseTimeout: Ax(/* @__PURE__ */ new Date(), m),
            pauseReschedule: !0
          }
        };
        await p.flowRuns.setFlowRunState(r.flowRun.id, { state: g }), o("update"), n.value = !1, He(le.success.suspendFlowRun, "success");
      } catch (m) {
        console.error(m);
        const g = Yt(m, le.error.suspendFlowRun);
        He(g, "error");
      }
    });
    return (h, m) => {
      const g = P("p-label"), _ = P("p-number-input"), b = P("p-button"), x = P("p-modal");
      return h.flowRun ? (T(), O(x, {
        key: 0,
        showModal: n.value,
        "onUpdate:showModal": m[1] || (m[1] = (S) => n.value = S),
        title: "Suspend Flow Run"
      }, {
        actions: k(() => [
          w(b, {
            variant: "default",
            loading: v(u),
            onClick: v(d)
          }, {
            default: k(() => [...m[2] || (m[2] = [
              q(" Submit ", -1)
            ])]),
            _: 1
          }, 8, ["loading", "onClick"])
        ]),
        default: k(() => [
          w(g, { label: "Current Flow Run State" }, {
            default: k(() => [
              w(Dr, {
                state: h.flowRun.state
              }, null, 8, ["state"])
            ]),
            _: 1
          }),
          w(g, {
            label: "Timeout",
            message: v(c),
            state: v(a)
          }, {
            default: k(() => [
              w(_, {
                modelValue: v(l),
                "onUpdate:modelValue": m[0] || (m[0] = (S) => Xe(l) ? l.value = S : null),
                min: "5",
                state: v(a)
              }, null, 8, ["modelValue", "state"])
            ]),
            _: 1
          }, 8, ["message", "state"]),
          re("div", null, [
            q(" Do you want to suspend " + ie(h.flowRun.name) + "? This will put flow run into a ", 1),
            w(Dr, {
              state: { name: "Suspended", type: "paused" },
              class: "flow-run-suspend-modal__state-badge"
            }),
            q(" state for " + ie(v(fc)(v(l))) + ". ", 1)
          ])
        ]),
        _: 1
      }, 8, ["showModal"])) : j("", !0);
    };
  }
}), YU = /* @__PURE__ */ U({
  __name: "FlowRunSuspendButton",
  props: {
    flowRun: {}
  },
  emits: ["update"],
  setup(t, { emit: e }) {
    const n = e, r = Ke(), { showModal: o, open: s } = St(), i = D(() => !r.update.flow_run || !t.flowRun.stateType || !t.flowRun.deploymentId ? !1 : b8(t.flowRun.stateType));
    return (u, l) => {
      const a = P("p-button");
      return i.value ? (T(), O(a, {
        key: 0,
        "icon-append": "PauseIcon",
        onClick: v(s)
      }, {
        default: k(() => [
          l[2] || (l[2] = q(" Suspend ", -1)),
          w(bR, {
            showModal: v(o),
            "onUpdate:showModal": l[0] || (l[0] = (c) => Xe(o) ? o.value = c : null),
            "flow-run": u.flowRun,
            onUpdate: l[1] || (l[1] = (c) => n("update"))
          }, null, 8, ["showModal", "flow-run"])
        ]),
        _: 1
      }, 8, ["onClick"])) : j("", !0);
    };
  }
}), AIe = {
  key: 0,
  class: "flow-run-task-counts"
}, DIe = /* @__PURE__ */ U({
  __name: "FlowRunTaskCounts",
  props: {
    flowRunId: {}
  },
  setup(t) {
    const e = t, n = Se(), r = D(() => ({
      flowRuns: {
        id: [e.flowRunId]
      },
      taskRuns: {
        subFlowRunsExist: !1
      }
    })), o = mt(n.ui.getTaskRunsCountByState, [r], { interval: 3e4 }), s = D(() => o.response ? Object.entries(o.response).reduce((i, [u, l]) => (l && i.push(`${l} ${u}`), i), []).join(", ") : "");
    return (i, u) => s.value ? (T(), z("span", AIe, " (" + ie(s.value) + ") ", 1)) : j("", !0);
  }
}), EIe = /* @__PURE__ */ U({
  __name: "TaskRunTagsInput",
  props: {
    selected: {},
    emptyMessage: {},
    filter: {}
  },
  emits: ["update:selected"],
  setup(t, { emit: e }) {
    const n = t, r = e, o = D(() => n.emptyMessage ?? "All tags"), s = D({
      get() {
        return n.selected ?? null;
      },
      set(l) {
        r("update:selected", l);
      }
    }), { taskRuns: i } = Tse(() => n.filter ?? {}), u = D(() => {
      const l = i.value.flatMap((a) => a.tags ?? []);
      return Bm(l).sort((a, c) => a.localeCompare(c));
    });
    return (l, a) => {
      const c = P("p-tags-input");
      return T(), O(c, yt({
        modelValue: s.value,
        "onUpdate:modelValue": a[0] || (a[0] = (p) => s.value = p),
        class: "task-run-tags-input",
        placeholder: "Search or enter new tag"
      }, { options: u.value, emptyMessage: o.value }), null, 16, ["modelValue"]);
    };
  }
}), MIe = { class: "flow-run-task-runs__count" }, PIe = /* @__PURE__ */ U({
  __name: "FlowRunTaskRuns",
  props: {
    flowRunId: {}
  },
  setup(t) {
    const e = t, n = ge([]), r = ge(), o = ns(r, 1200), s = D(() => [e.flowRunId]), { filter: i, isCustomFilter: u } = pN({
      flowRuns: {
        id: s
      },
      taskRuns: {
        subFlowRunsExist: !1,
        nameLike: o,
        state: {
          name: n
        },
        tags: {
          name: []
        }
      }
    }), l = Se(), a = k2(l.taskRuns.getTaskRuns, [i], { interval: 3e4 }), c = D(() => a.response ?? []), p = D(() => a.executed && c.value.length === 0), { count: d } = hp(i);
    function h() {
      n.value = [], r.value = "";
    }
    return (m, g) => {
      const _ = P("p-list-header"), b = P("p-button"), x = P("PEmptyResults"), S = P("p-content");
      return T(), O(S, { class: "flow-run-task-runs" }, {
        default: k(() => [
          w(_, { sticky: "" }, {
            controls: k(() => [
              w(v(Wo), {
                modelValue: r.value,
                "onUpdate:modelValue": g[0] || (g[0] = (E) => r.value = E),
                placeholder: "Search by run name",
                label: "Search by run name",
                class: "flow-run-task-runs__search"
              }, null, 8, ["modelValue"]),
              w(v(qh), {
                selected: n.value,
                "onUpdate:selected": g[1] || (g[1] = (E) => n.value = E),
                "empty-message": "All states",
                multiple: ""
              }, null, 8, ["selected"]),
              v(_s).xl ? (T(), O(EIe, {
                key: 0,
                selected: v(i).taskRuns.tags.name,
                "onUpdate:selected": g[2] || (g[2] = (E) => v(i).taskRuns.tags.name = E),
                multiple: "",
                filter: v(i)
              }, null, 8, ["selected", "filter"])) : j("", !0)
            ]),
            sort: k(() => [
              w(v(yX), {
                modelValue: v(i).sort,
                "onUpdate:modelValue": g[3] || (g[3] = (E) => v(i).sort = E)
              }, null, 8, ["modelValue"])
            ]),
            default: k(() => [
              re("div", MIe, [
                w(v(Uo), {
                  count: v(d),
                  label: "Task run"
                }, null, 8, ["count"]),
                w(DIe, { "flow-run-id": m.flowRunId }, null, 8, ["flow-run-id"])
              ])
            ]),
            _: 1
          }),
          w(v(V2), {
            "task-runs": c.value,
            onBottom: v(a).loadMore
          }, null, 8, ["task-runs", "onBottom"]),
          p.value ? (T(), O(x, { key: 0 }, Ut({
            message: k(() => [
              g[4] || (g[4] = q(" No task runs ", -1))
            ]),
            _: 2
          }, [
            v(u) ? {
              name: "actions",
              fn: k(() => [
                w(b, {
                  size: "sm",
                  onClick: h
                }, {
                  default: k(() => [...g[5] || (g[5] = [
                    q(" Clear Filters ", -1)
                  ])]),
                  _: 1
                })
              ]),
              key: "0"
            } : void 0
          ]), 1024)) : j("", !0)
        ]),
        _: 1
      });
    };
  }
}), CIe = { key: 0 }, OIe = { class: "flow-run-timeline-sub-flow-run-details__content" }, Ef = !0, QU = /* @__PURE__ */ U({
  __name: "FlowRunTimelineSubFlowRunDetails",
  props: {
    flowRunId: {}
  },
  setup(t) {
    const e = t, { flowRunId: n } = Nn(e), r = je(), { flowRun: o } = yl(n), s = D(() => o.value?.flowId), { flow: i } = Ec(s), u = D(() => {
      const l = [];
      return i.value?.name && l.push({
        text: i.value.name,
        to: r.flow(i.value.id)
      }), o.value?.name && l.push({
        text: o.value.name,
        to: r.flowRun(o.value.id)
      }), l;
    });
    return (l, a) => {
      const c = P("p-bread-crumbs"), p = P("p-key-value"), d = P("p-tags");
      return v(o) ? (T(), z("div", CIe, [
        w(c, {
          class: "flow-run-timeline-sub-flow-run-details__heading",
          crumbs: u.value
        }, null, 8, ["crumbs"]),
        re("div", OIe, [
          w(p, {
            label: "State",
            alternate: Ef
          }, {
            value: k(() => [
              w(v(Dr), {
                state: v(o).state,
                class: "timeline-task-details__state-badge"
              }, null, 8, ["state"])
            ]),
            _: 1
          }),
          w(p, {
            label: "Flow Run ID",
            value: v(o).id,
            alternate: Ef
          }, null, 8, ["value"]),
          w(p, {
            label: "Duration",
            alternate: Ef
          }, {
            value: k(() => [
              w(v(Cc), {
                duration: v(o).duration
              }, null, 8, ["duration"])
            ]),
            _: 1
          }),
          w(p, {
            label: "Created",
            alternate: Ef
          }, {
            value: k(() => [
              w(hn, {
                date: v(o).created,
                format: "numeric"
              }, null, 8, ["date"])
            ]),
            _: 1
          }),
          w(p, {
            label: "Tags",
            alternate: Ef
          }, Ut({ _: 2 }, [
            v(o).tags?.length ? {
              name: "value",
              fn: k(() => [
                w(d, {
                  tags: v(o).tags,
                  class: "flow-run-timeline-sub-flow-run-details__tags"
                }, null, 8, ["tags"])
              ]),
              key: "0"
            } : void 0
          ]), 1024)
        ])
      ])) : j("", !0);
    };
  }
}), IIe = { key: 0 }, FIe = { class: "flow-run-timeline-task-details__content" }, Mf = !0, KU = /* @__PURE__ */ U({
  __name: "FlowRunTimelineTaskDetails",
  props: {
    taskRunId: {}
  },
  setup(t) {
    const e = t, { taskRunId: n } = Nn(e), r = je(), { taskRun: o } = Kp(n);
    return (s, i) => {
      const u = P("p-link"), l = P("p-heading"), a = P("p-key-value"), c = P("p-tags");
      return v(o) ? (T(), z("div", IIe, [
        w(l, {
          element: "h3",
          heading: "5"
        }, {
          default: k(() => [
            w(u, {
              to: v(r).taskRun(v(n))
            }, {
              default: k(() => [
                q(ie(v(o).name), 1)
              ]),
              _: 1
            }, 8, ["to"])
          ]),
          _: 1
        }),
        re("div", FIe, [
          w(a, {
            label: "State",
            alternate: Mf
          }, {
            value: k(() => [
              w(v(Dr), {
                state: v(o).state,
                class: "flow-run-timeline-task-details__state-badge"
              }, null, 8, ["state"])
            ]),
            _: 1
          }),
          w(a, {
            label: "Task Run ID",
            value: v(o).id,
            alternate: Mf
          }, null, 8, ["value"]),
          w(a, {
            label: "Duration",
            alternate: Mf
          }, {
            value: k(() => [
              w(v(Cc), {
                duration: v(o).duration
              }, null, 8, ["duration"])
            ]),
            _: 1
          }),
          w(a, {
            label: "Created",
            alternate: Mf
          }, {
            value: k(() => [
              w(hn, {
                date: v(o).created,
                format: "numeric"
              }, null, 8, ["date"])
            ]),
            _: 1
          }),
          w(a, {
            label: "Tags",
            alternate: Mf
          }, Ut({ _: 2 }, [
            v(o).tags?.length ? {
              name: "value",
              fn: k(() => [
                w(c, {
                  tags: v(o).tags,
                  class: "flow-run-timeline-task-details__tags"
                }, null, 8, ["tags"])
              ]),
              key: "0"
            } : void 0
          ]), 1024)
        ])
      ])) : j("", !0);
    };
  }
}), ZU = /* @__PURE__ */ U({
  inheritAttrs: !1,
  __name: "FlowsDeleteButton",
  props: {
    selected: {}
  },
  emits: ["delete"],
  setup(t, { emit: e }) {
    const n = e, { showModal: r, open: o, close: s } = St(), i = Se(), u = Eh(), l = async (a) => {
      const c = D(() => a.length === 1 ? le.success.delete("Flow") : le.success.delete(`${a.length} flows`));
      try {
        const p = a.map(i.flows.deleteFlow);
        await Promise.all(p), He(c, "success"), n("delete");
      } catch (p) {
        const d = Yt(p, le.error.delete("flows"));
        He(d, "error");
      } finally {
        s();
      }
    };
    return (a, c) => {
      const p = P("p-button");
      return T(), z(ve, null, [
        a.selected.length > 0 ? (T(), O(p, yt({ key: 0 }, v(u), {
          icon: "TrashIcon",
          onClick: v(o)
        }), null, 16, ["onClick"])) : j("", !0),
        w(_r, {
          showModal: v(r),
          "onUpdate:showModal": c[0] || (c[0] = (d) => Xe(r) ? r.value = d : null),
          name: "selected flows",
          label: "Flows",
          onDelete: c[1] || (c[1] = (d) => l(a.selected))
        }, null, 8, ["showModal"])
      ], 64);
    };
  }
}), NIe = { class: "flows-filter-group" }, LIe = { class: "flows-filter-group__row" }, BIe = { class: "flows-filter-group__row" }, UIe = /* @__PURE__ */ U({
  __name: "FlowsFilterGroup",
  setup(t) {
    const e = ge(null), n = [
      { label: le.info.all, value: null },
      { label: le.info.active, value: !0 },
      { label: le.info.inactive, value: !1 }
    ], r = D(() => {
      if (!Gt(e.value))
        return e.value;
    }), { filter: o, isDefaultFilter: s, clear: i } = Goe({
      deployments: {
        isScheduleActive: r
      }
    });
    return D({
      get() {
        return [o.flowRuns.expectedStartTimeAfter, o.flowRuns.expectedStartTimeBefore];
      },
      set([u, l]) {
        o.flowRuns.expectedStartTimeAfter = u, o.flowRuns.expectedStartTimeBefore = l;
      }
    }), (u, l) => {
      const a = P("p-select"), c = P("p-button");
      return T(), z("div", NIe, [
        re("div", LIe, [
          w(v(nr), {
            label: v(le).info.deploymentTags
          }, {
            default: k(() => [
              w(v(fS), {
                selected: v(o).flowRuns.tags.name,
                "onUpdate:selected": l[0] || (l[0] = (p) => v(o).flowRuns.tags.name = p),
                filter: v(o),
                class: "flows-filter-group__deployment-tags"
              }, null, 8, ["selected", "filter"])
            ]),
            _: 1
          }, 8, ["label"]),
          w(v(nr), {
            label: v(le).info.schedule
          }, {
            default: k(() => [
              w(a, {
                modelValue: e.value,
                "onUpdate:modelValue": l[1] || (l[1] = (p) => e.value = p),
                options: n
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["label"]),
          w(v(nr), {
            label: v(le).info.workPools
          }, {
            default: k(() => [
              w(v(aw), {
                selected: v(o).workPools.name,
                "onUpdate:selected": l[2] || (l[2] = (p) => v(o).workPools.name = p),
                "empty-message": v(le).info.all,
                multiple: ""
              }, null, 8, ["selected", "empty-message"])
            ]),
            _: 1
          }, 8, ["label"])
        ]),
        j("", !0),
        re("div", BIe, [
          w(c, {
            size: "sm",
            disabled: v(s),
            onClick: v(i)
          }, {
            default: k(() => [
              q(ie(v(le).info.resetFilters), 1)
            ]),
            _: 1
          }, 8, ["disabled", "onClick"])
        ])
      ]);
    };
  }
}), XIe = /* @__PURE__ */ U({
  __name: "FlowsPageEmptyState",
  setup(t) {
    return (e, n) => (T(), O(v(na), null, {
      icon: k(() => [
        w(v(vo), {
          icon: "Flow",
          class: "empty-flow--icon"
        })
      ]),
      heading: k(() => [...n[0] || (n[0] = [
        q(" Run a flow to get started ", -1)
      ])]),
      description: k(() => [...n[1] || (n[1] = [
        q(" Flows are Python functions that encapsulate workflow logic and allow users to interact with and reason about the state of their workflows. ", -1)
      ])]),
      actions: k(() => [
        Ve(e.$slots, "actions", {}, () => [
          w(Os, {
            to: v(le).docs.flows
          }, null, 8, ["to"])
        ])
      ]),
      _: 3
    }));
  }
}), $Ie = { class: "four-zero-four" }, WIe = /* @__PURE__ */ U({
  __name: "FourZeroFour",
  setup(t) {
    const e = ge([]), n = ge(0), r = (l, a) => Math.floor(Math.random() * (a - l + 1) + l), o = (l, a, c) => c.indexOf(l) === a, s = (l) => {
      const a = "four-zero-four__circle--animate";
      l.addEventListener(
        "animationend",
        () => {
          l.classList.remove(a);
        },
        { once: !0 }
      ), l.classList.add(a);
    }, i = () => {
      const l = [];
      for (; l.length < 3; ) {
        const a = r(0, e.value.length - 1), c = e.value[a];
        l.push(c);
      }
      l.filter(o).forEach(s);
    }, u = () => {
      const l = r(3, 4) * 1e3;
      n.value = window.setTimeout(() => {
        i(), u();
      }, l);
    };
    return wi(() => {
      e.value = Array.from(document.querySelectorAll(".four-zero-four__circle")), u();
    }), CI(() => {
      window.clearInterval(n.value);
    }), (l, a) => (T(), z("div", $Ie, [...a[0] || (a[0] = [
      Pm('<svg class="four-zero-four__message" fill="none" viewBox="0 0 607 511" xmlns="http://www.w3.org/2000/svg"><title>404 Page Not Found</title><text x="50%" y="90%" class="four-zero-four__text">Page not found</text><circle cx="126.5" cy="301.5" r="4.5" fill="#fff"></circle><circle cx="21.5" cy="279.5" r="4.5" fill="#fff"></circle><circle cx="276.5" cy="233.5" r="4.5" fill="#fff"></circle><circle cx="276.5" cy="311.5" r="4.5" fill="#fff"></circle><circle cx="429.5" cy="86.5" r="4.5" fill="#fff"></circle><circle cx="533.5" cy="108.5" r="4.5" fill="#fff"></circle><g filter="url(#a)" class="four-zero-four__circle"><circle cx="22" cy="280" r="16" fill="#fff" fill-opacity=".2"></circle></g><g filter="url(#b)" class="four-zero-four__circle"><circle cx="126" cy="302" r="16" fill="#fff" fill-opacity=".2"></circle></g><g filter="url(#c)" class="four-zero-four__circle"><circle cx="276" cy="234" r="16" fill="#fff" fill-opacity=".2"></circle></g><g filter="url(#d)" class="four-zero-four__circle"><circle cx="429" cy="87" r="16" fill="#fff" fill-opacity=".2"></circle></g><g filter="url(#e)" class="four-zero-four__circle"><circle cx="533" cy="109" r="16" fill="#fff" fill-opacity=".2"></circle></g><g filter="url(#f)" class="four-zero-four__circle"><circle cx="276" cy="312" r="16" fill="#fff" fill-opacity=".2"></circle></g><g filter="url(#g)"><path d="M126.4 296.9V225l61.7-29V432l-80.5 37.8V392l-85.8 39.3v-147m0 0a5 5 0 1 0 0-10 5 5 0 0 0 0 10Zm259 24.8 64.9-30.4v-77.3l-65 30.4M533.5 104V32.3l61.7-29V239L514.7 277V199L429 238.5v-147m0 0a5 5 0 1 0 0-10 5 5 0 0 0 0 10Zm-37.3 6.2v235.8l-166.3 78.2V175.9l166.3-78.2ZM131.4 301.9a5 5 0 1 1-10 0 5 5 0 0 1 10 0Zm149.8-68a5 5 0 1 1-10 0 5 5 0 0 1 10 0Zm0 77.5a5 5 0 1 1-10 0 5 5 0 0 1 10 0ZM538.6 109a5 5 0 1 1-10 0 5 5 0 0 1 10 0Z" stroke="url(#h)" stroke-width="3" stroke-miterlimit="10"></path></g><defs><filter id="a" x="0" y="262" width="44" height="44" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood><feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"></feColorMatrix><feOffset dy="4"></feOffset><feGaussianBlur stdDeviation="3"></feGaussianBlur><feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"></feColorMatrix><feBlend in2="BackgroundImageFix" result="effect1_dropShadow"></feBlend><feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"></feColorMatrix><feOffset dy="2"></feOffset><feGaussianBlur stdDeviation="2"></feGaussianBlur><feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"></feColorMatrix><feBlend in2="effect1_dropShadow" result="effect2_dropShadow"></feBlend><feBlend in="SourceGraphic" in2="effect2_dropShadow" result="shape"></feBlend></filter><filter id="b" x="104" y="284" width="44" height="44" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood><feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"></feColorMatrix><feOffset dy="4"></feOffset><feGaussianBlur stdDeviation="3"></feGaussianBlur><feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"></feColorMatrix><feBlend in2="BackgroundImageFix" result="effect1_dropShadow"></feBlend><feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"></feColorMatrix><feOffset dy="2"></feOffset><feGaussianBlur stdDeviation="2"></feGaussianBlur><feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"></feColorMatrix><feBlend in2="effect1_dropShadow" result="effect2_dropShadow"></feBlend><feBlend in="SourceGraphic" in2="effect2_dropShadow" result="shape"></feBlend></filter><filter id="c" x="254" y="216" width="44" height="44" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood><feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"></feColorMatrix><feOffset dy="4"></feOffset><feGaussianBlur stdDeviation="3"></feGaussianBlur><feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"></feColorMatrix><feBlend in2="BackgroundImageFix" result="effect1_dropShadow"></feBlend><feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"></feColorMatrix><feOffset dy="2"></feOffset><feGaussianBlur stdDeviation="2"></feGaussianBlur><feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"></feColorMatrix><feBlend in2="effect1_dropShadow" result="effect2_dropShadow"></feBlend><feBlend in="SourceGraphic" in2="effect2_dropShadow" result="shape"></feBlend></filter><filter id="d" x="407" y="69" width="44" height="44" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood><feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"></feColorMatrix><feOffset dy="4"></feOffset><feGaussianBlur stdDeviation="3"></feGaussianBlur><feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"></feColorMatrix><feBlend in2="BackgroundImageFix" result="effect1_dropShadow"></feBlend><feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"></feColorMatrix><feOffset dy="2"></feOffset><feGaussianBlur stdDeviation="2"></feGaussianBlur><feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"></feColorMatrix><feBlend in2="effect1_dropShadow" result="effect2_dropShadow"></feBlend><feBlend in="SourceGraphic" in2="effect2_dropShadow" result="shape"></feBlend></filter><filter id="e" x="511" y="91" width="44" height="44" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood><feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"></feColorMatrix><feOffset dy="4"></feOffset><feGaussianBlur stdDeviation="3"></feGaussianBlur><feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"></feColorMatrix><feBlend in2="BackgroundImageFix" result="effect1_dropShadow"></feBlend><feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"></feColorMatrix><feOffset dy="2"></feOffset><feGaussianBlur stdDeviation="2"></feGaussianBlur><feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"></feColorMatrix><feBlend in2="effect1_dropShadow" result="effect2_dropShadow"></feBlend><feBlend in="SourceGraphic" in2="effect2_dropShadow" result="shape"></feBlend></filter><filter id="f" x="254" y="294" width="44" height="44" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood><feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"></feColorMatrix><feOffset dy="4"></feOffset><feGaussianBlur stdDeviation="3"></feGaussianBlur><feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"></feColorMatrix><feBlend in2="BackgroundImageFix" result="effect1_dropShadow"></feBlend><feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"></feColorMatrix><feOffset dy="2"></feOffset><feGaussianBlur stdDeviation="2"></feGaussianBlur><feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"></feColorMatrix><feBlend in2="effect1_dropShadow" result="effect2_dropShadow"></feBlend><feBlend in="SourceGraphic" in2="effect2_dropShadow" result="shape"></feBlend></filter><filter id="g" x="5.3" y=".9" width="601.4" height="491.2" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood><feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"></feColorMatrix><feOffset dy="10"></feOffset><feGaussianBlur stdDeviation="5"></feGaussianBlur><feComposite in2="hardAlpha" operator="out"></feComposite><feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"></feColorMatrix><feBlend in2="BackgroundImageFix" result="effect1_dropShadow"></feBlend><feBlend in="SourceGraphic" in2="effect1_dropShadow" result="shape"></feBlend></filter><linearGradient id="h" x1="306" y1="3.3" x2="306" y2="469.7" gradientUnits="userSpaceOnUse"><stop stop-color="#2CCFFE"></stop><stop offset="1" stop-color="#115AF4"></stop></linearGradient></defs></svg>', 1)
    ])]));
  }
}), JU = /* @__PURE__ */ U({
  __name: "IconTextCount",
  props: {
    count: {},
    label: {},
    icon: {}
  },
  setup(t) {
    const e = t, n = D(() => e.label ? mc(e.label, e.count) : "");
    return (r, o) => {
      const s = P("p-icon-text");
      return T(), O(s, {
        icon: r.icon,
        class: "icon-text-count"
      }, {
        default: k(() => [
          r.count > 0 ? Ve(r.$slots, "default", sn(yt({ key: 0 }, { count: r.count, formattedLabel: n.value })), () => [
            q(ie(r.count) + " " + ie(n.value), 1)
          ]) : Ve(r.$slots, "empty", { key: 1 }, () => [
            o[0] || (o[0] = re("span", { class: "icon-text-count--empty" }, "None", -1))
          ])
        ]),
        _: 3
      }, 8, ["icon"]);
    };
  }
}), VIe = { class: "interval-schedule-form__row" }, eX = /* @__PURE__ */ U({
  __name: "IntervalScheduleForm",
  props: {
    hideActions: { type: Boolean },
    schedule: { default: () => new im({ interval: 3600, anchorDate: /* @__PURE__ */ new Date(), timezone: "UTC" }) }
  },
  emits: ["cancel", "update:schedule", "submit", "update:disabled"],
  setup(t, { emit: e }) {
    const n = t, r = e, o = {
      interval: qp("Interval", Kr, MF(1))
    }, s = ge(n.schedule.anchorDate), i = ge(n.schedule.timezone);
    s.value && i.value && (s.value = HJ(s.value, i.value));
    const { value: u, meta: l, errors: a } = Rs("interval", o.interval, { initialValue: IE(n.schedule.interval) }), c = ge(FE(n.schedule.interval)), p = D(() => ["Second", "Minute", "Hour", "Day"].map((x) => ({
      label: mc(x, u.value),
      value: mc(x)
    }))), d = D(() => u.value * Vu[c.value]), h = D(() => new im({
      interval: d.value,
      anchorDate: s.value,
      timezone: i.value
    })), m = D(() => a.value.length > 0), g = () => {
      r("cancel");
    }, _ = () => {
      m.value || r("submit", h.value);
    };
    return Ct(() => h.value, () => r("update:schedule", h.value)), Ct(() => m.value, () => r("update:disabled", m.value)), Ct(() => n.schedule, (b, x) => {
      s.value = b?.anchorDate ?? s.value, i.value = b?.timezone ?? i.value, b && !x && (u.value = IE(b.interval), c.value = FE(b.interval));
    }, { deep: !0 }), wi(() => {
      r("update:disabled", m.value), r("update:schedule", h.value);
    }), (b, x) => {
      const S = P("p-number-input"), E = P("p-label"), A = P("p-select"), C = P("p-date-input"), M = P("p-content"), L = P("p-button"), X = P("p-form");
      return T(), O(X, { onSubmit: _ }, Ut({
        default: k(() => [
          w(M, null, {
            default: k(() => [
              re("div", VIe, [
                w(E, {
                  label: "Value",
                  class: "interval-schedule-form__column--span-3",
                  message: v(a)?.[0],
                  state: v(l)
                }, {
                  default: k(() => [
                    w(S, {
                      modelValue: v(u),
                      "onUpdate:modelValue": x[0] || (x[0] = (te) => Xe(u) ? u.value = te : null),
                      min: "1",
                      step: "1"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["message", "state"]),
                w(E, { label: "Interval" }, {
                  default: k(() => [
                    w(A, {
                      modelValue: c.value,
                      "onUpdate:modelValue": x[1] || (x[1] = (te) => c.value = te),
                      options: p.value,
                      "data-testid": "interval-select"
                    }, null, 8, ["modelValue", "options"])
                  ]),
                  _: 1
                })
              ]),
              re("div", null, [
                w(E, { label: "Anchor date" }, {
                  default: k(() => [
                    w(C, {
                      modelValue: s.value,
                      "onUpdate:modelValue": x[2] || (x[2] = (te) => s.value = te),
                      "show-time": ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              re("div", null, [
                w(E, { label: "Timezone" }, {
                  default: k(() => [
                    w(M_, {
                      modelValue: i.value,
                      "onUpdate:modelValue": x[3] || (x[3] = (te) => i.value = te),
                      "hide-unset": ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          })
        ]),
        _: 2
      }, [
        b.hideActions ? void 0 : {
          name: "footer",
          fn: k(() => [
            Ve(b.$slots, "footer", { disabled: m.value }, () => [
              w(L, { onClick: g }, {
                default: k(() => [...x[4] || (x[4] = [
                  q(" Cancel ", -1)
                ])]),
                _: 1
              }),
              w(L, {
                variant: "default",
                disabled: m.value,
                type: "submit"
              }, {
                default: k(() => [...x[5] || (x[5] = [
                  q(" Save ", -1)
                ])]),
                _: 1
              }, 8, ["disabled"])
            ])
          ]),
          key: "0"
        }
      ]), 1024);
    };
  }
}), kR = /* @__PURE__ */ U({
  __name: "LastFlowRun",
  props: {
    flowId: {}
  },
  setup(t) {
    const e = t, { flowRun: n } = _N(() => ({
      flows: {
        id: [e.flowId]
      }
    }));
    return (r, o) => v(n) ? (T(), O(v(vR), {
      key: 0,
      "flow-run-id": v(n).id,
      "flow-run-name": v(n).name,
      "state-type": v(n).stateType,
      "state-name": v(n)?.stateName
    }, null, 8, ["flow-run-id", "flow-run-name", "state-type", "state-name"])) : j("", !0);
  }
}), tX = /* @__PURE__ */ U({
  __name: "LogLevelLabel",
  props: {
    level: {}
  },
  setup(t) {
    const e = t, n = D(() => bte(e.level)), r = D(() => `log-level-label--${bF(n.value)}`);
    return (o, s) => (T(), O(v(LI), {
      class: Bt(["log-level-label", r.value])
    }, {
      default: k(() => [
        q(ie(n.value), 1)
      ]),
      _: 1
    }, 8, ["class"]));
  }
}), TR = /* @__PURE__ */ U({
  __name: "LogLevelSelect",
  props: {
    selected: {}
  },
  emits: ["update:selected"],
  setup(t, { emit: e }) {
    const n = t, r = e, o = D({
      get() {
        return n.selected;
      },
      set(i) {
        r("update:selected", i);
      }
    }), s = [
      { label: "All", value: 0 },
      { label: "Critical only", value: 50 },
      { label: "Error and above", value: 40 },
      { label: "Warning and above", value: 30 },
      { label: "Info and above", value: 20 },
      { label: "Debug and above", value: 10 }
    ];
    return (i, u) => {
      const l = P("p-select");
      return T(), O(l, {
        modelValue: o.value,
        "onUpdate:modelValue": u[0] || (u[0] = (a) => o.value = a),
        options: s,
        class: "log-level-select"
      }, {
        default: k(({ label: a }) => [
          q(" Level: " + ie(a.toLowerCase()), 1)
        ]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }
}), HIe = { class: "log-row" }, jIe = { class: "log-row__leading" }, zIe = { class: "log-row__content" }, qIe = { class: "log-row__trailing" }, GIe = { key: 0 }, YIe = {
  key: 1,
  class: "log-row__logger"
}, nX = /* @__PURE__ */ U({
  __name: "LogRow",
  props: {
    log: {}
  },
  setup(t) {
    const e = t, { taskRun: n } = Kp(() => e.log.taskRunId), r = D(() => n.value?.name), o = D(() => {
      const s = [], { message: i } = e.log;
      let u = [];
      const l = (p, d) => {
        let h = 0;
        const m = p.matchAll(Tte);
        for (const g of m) {
          h < g.index && s.push({
            type: d,
            value: p.slice(h, g.index),
            classes: [...u]
          });
          const [_, b] = g, x = kte[b];
          x === "" ? u = [] : x && (u.includes(x) || (u.push("text-default"), u.push(x))), h = g.index + _.length;
        }
        h < p.length && s.push({
          type: d,
          value: p.slice(h),
          classes: [...u]
        });
      };
      let a = 0;
      const c = i.matchAll(Hte);
      for (const p of c) {
        a < p.index && l(i.slice(a, p.index), "text");
        const [d] = p;
        l(d, "link"), a = p.index + d.length;
      }
      return a < i.length && l(i.slice(a), "text"), s;
    });
    return (s, i) => {
      const u = P("p-link");
      return T(), z("div", HIe, [
        re("div", jIe, [
          w(tX, {
            level: s.log.level
          }, null, 8, ["level"])
        ]),
        re("div", zIe, [
          (T(!0), z(ve, null, ln(o.value, (l, a) => (T(), z("span", {
            key: a,
            class: Bt(l.classes)
          }, [
            l.type === "text" ? (T(), z(ve, { key: 0 }, [
              q(ie(l.value), 1)
            ], 64)) : j("", !0),
            l.type === "link" ? (T(), O(u, {
              key: 1,
              to: l.value,
              rel: "noopener noreferrer"
            }, {
              default: k(() => [
                q(ie(l.value), 1)
              ]),
              _: 2
            }, 1032, ["to"])) : j("", !0)
          ], 2))), 128))
        ]),
        re("div", qIe, [
          re("div", null, ie(v($3)(s.log.timestamp)), 1),
          r.value ? (T(), z("div", GIe, ie(r.value), 1)) : j("", !0),
          s.log.name ? (T(), z("div", YIe, ie(s.log.name), 1)) : j("", !0)
        ])
      ]);
    };
  }
}), QIe = {
  key: 0,
  class: "logs__divider"
}, KIe = { class: "logs__divider-time" }, xR = /* @__PURE__ */ U({
  __name: "LogsContainer",
  props: {
    logs: {}
  },
  emits: ["bottom"],
  setup(t, { emit: e }) {
    const n = t, r = e, o = D(() => n.logs.length == 0), s = (i) => {
      if (i == 0)
        return !0;
      const u = n.logs[i - 1], l = n.logs[i];
      return !Gr.isSameDay(u.timestamp, l.timestamp);
    };
    return (i, u) => {
      const l = P("p-virtual-scroller");
      return T(), O(v($j), {
        multiline: "",
        class: "logs"
      }, {
        default: k(() => [
          w(l, {
            items: i.logs,
            onBottom: u[0] || (u[0] = (a) => r("bottom"))
          }, {
            default: k(({ item: a, index: c }) => [
              s(c) ? (T(), z("div", QIe, [
                re("span", KIe, ie(v(Xo)(a.timestamp)), 1)
              ])) : j("", !0),
              w(nX, { log: a }, null, 8, ["log"])
            ]),
            _: 1
          }, 8, ["items"]),
          o.value ? Ve(i.$slots, "empty", { key: 0 }, () => [
            u[1] || (u[1] = re("div", { class: "logs__empty" }, [
              re("p", null, "No logs")
            ], -1))
          ]) : j("", !0)
        ]),
        _: 3
      });
    };
  }
}), SR = /* @__PURE__ */ U({
  __name: "LogsSort",
  props: {
    selected: {}
  },
  emits: ["update:selected"],
  setup(t, { emit: e }) {
    const n = t, r = e, o = D({
      get() {
        return n.selected;
      },
      set(i) {
        r("update:selected", i);
      }
    }), s = [
      { label: "Newest to oldest", value: "TIMESTAMP_DESC" },
      { label: "Oldest to newest", value: "TIMESTAMP_ASC" }
    ];
    return (i, u) => {
      const l = P("p-select");
      return T(), O(l, {
        modelValue: o.value,
        "onUpdate:modelValue": u[0] || (u[0] = (a) => o.value = a),
        options: s,
        class: "logs-sort"
      }, null, 8, ["modelValue"]);
    };
  }
}), ZIe = { class: "marketing-banner__message" }, JIe = {
  key: 1,
  class: "marketing-banner__subtitle"
}, e8e = { class: "marketing-banner__actions" }, t8e = /* @__PURE__ */ U({
  __name: "MarketingBanner",
  props: {
    title: {},
    subtitle: {},
    alternate: { type: Boolean },
    centered: { type: Boolean }
  },
  setup(t) {
    const e = t, n = D(() => ({
      root: {
        "marketing-banner--alternate": e.alternate
      },
      content: {
        "marketing-banner__content--centered": e.centered
      }
    }));
    return (r, o) => {
      const s = P("p-heading"), i = P("p-card");
      return T(), O(i, {
        class: Bt(["marketing-banner", n.value.root])
      }, {
        default: k(() => [
          re("div", {
            class: Bt(["marketing-banner__content", n.value.content])
          }, [
            Ve(r.$slots, "default", {}, () => [
              re("div", ZIe, [
                r.title ? (T(), O(s, {
                  key: 0,
                  heading: 2,
                  class: "marketing-banner__title"
                }, {
                  default: k(() => [
                    q(ie(r.title), 1)
                  ]),
                  _: 1
                })) : j("", !0),
                r.subtitle ? (T(), z("div", JIe, ie(r.subtitle), 1)) : j("", !0)
              ])
            ]),
            re("div", e8e, [
              Ve(r.$slots, "actions")
            ])
          ], 2)
        ]),
        _: 3
      }, 8, ["class"]);
    };
  }
}), rX = /* @__PURE__ */ U({
  __name: "MiniDeploymentHistory",
  props: {
    deploymentId: {},
    timeSpanInSeconds: {}
  },
  setup(t) {
    const e = t, n = D(() => ({
      deploymentId: e.deploymentId,
      timeSpanInSeconds: e.timeSpanInSeconds
    })), r = D(() => ye.map("DeploymentStatsFilter", n.value, "FlowRunsFilter"));
    return (o, s) => (T(), O(v(Vh), {
      class: "deployment-list__activity-chart",
      mini: "",
      filter: r.value
    }, null, 8, ["filter"]));
  }
}), oX = /* @__PURE__ */ U({
  __name: "MiniFlowHistory",
  props: {
    flowId: {},
    timeSpanInSeconds: {}
  },
  setup(t) {
    const e = t, n = D(() => ({
      flowId: e.flowId,
      range: { type: "span", seconds: e.timeSpanInSeconds }
    })), r = D(() => ye.map("FlowStatsFilter", n.value, "FlowRunsFilter"));
    return (o, s) => (T(), O(v(Vh), {
      class: "flow-list__activity-chart",
      mini: "",
      filter: r.value
    }, null, 8, ["filter"]));
  }
}), RR = /* @__PURE__ */ U({
  __name: "NextFlowRun",
  props: {
    flowId: {}
  },
  setup(t) {
    const e = t, { flowRun: n } = hse(() => e.flowId);
    return (r, o) => v(n) ? (T(), O(v(vR), {
      key: 0,
      "flow-run-id": v(n).id,
      "flow-run-name": v(n).name,
      "state-type": v(n).stateType,
      "state-name": v(n)?.stateName
    }, null, 8, ["flow-run-id", "flow-run-name", "state-type", "state-name"])) : j("", !0);
  }
}), n8e = { class: "separated-list" }, r8e = { class: "separated-list__tags" }, o8e = {
  key: 1,
  class: "separated-list__bold"
}, px = /* @__PURE__ */ U({
  __name: "SeparatedList",
  props: {
    itemArray: {}
  },
  setup(t) {
    const e = t, n = D(() => gG(e.itemArray));
    return (r, o) => (T(), z("span", n8e, [
      r.itemArray.length ? (T(), z(ve, { key: 0 }, [
        re("div", r8e, [
          (T(!0), z(ve, null, ln(v(vG)(r.itemArray), (s) => Ve(r.$slots, "default", {
            key: s,
            item: s
          }, () => [
            q(ie(s), 1)
          ])), 128))
        ]),
        r.itemArray.length > 1 ? (T(), z(ve, { key: 0 }, [
          q(" or ")
        ], 64)) : j("", !0),
        Ve(r.$slots, "default", { item: n.value }, () => [
          q(ie(n.value), 1)
        ])
      ], 64)) : (T(), z("span", o8e, "any"))
    ]));
  }
}), s8e = { class: "notification-details" }, a8e = { key: 0 }, i8e = { class: "notification-details__tag" }, u8e = { class: "notification-details__send-to" }, l8e = { class: "notification-details__item" }, AR = /* @__PURE__ */ U({
  __name: "NotificationDetails",
  props: {
    notification: {},
    blockType: {},
    data: {}
  },
  setup(t) {
    const e = t, n = D(() => {
      switch (e.blockType.name) {
        case "Email Addresses":
          return {
            value: tl(e.data.email_addresses),
            icon: "EnvelopeIcon"
          };
        case "Slack Webhook":
          return {
            value: ["Slack"],
            icon: "Slack"
          };
        default:
          return {
            value: tl(Object.values(e.data)[0]),
            icon: "BellIcon"
          };
      }
    }), r = D(() => ({
      "notification-details__icon--gray": n.value.icon !== "Slack"
    }));
    return (o, s) => (T(), z("div", s8e, [
      s[0] || (s[0] = q(" If a run of any flow with ", -1)),
      o.notification.tags?.length ? (T(), z("span", a8e, "a")) : j("", !0),
      w(px, {
        "item-array": o.notification.tags || []
      }, {
        default: k(({ item: i }) => [
          re("span", i8e, [
            w(v(LI), null, {
              default: k(() => [
                q(ie(i), 1)
              ]),
              _: 2
            }, 1024)
          ])
        ]),
        _: 1
      }, 8, ["item-array"]),
      s[1] || (s[1] = q(" tag enters ", -1)),
      w(px, {
        "item-array": o.notification.stateNames || []
      }, {
        default: k(({ item: i }) => [
          w(Dr, {
            state: v(uh)(i)
          }, null, 8, ["state"])
        ]),
        _: 1
      }, 8, ["item-array"]),
      s[2] || (s[2] = q(" state, send a notification to ", -1)),
      re("span", u8e, [
        (T(!0), z(ve, null, ln(n.value.value, (i) => (T(), z(ve, { key: i }, [
          i ? (T(), O(v(vo), {
            key: 0,
            icon: n.value.icon,
            class: Bt(["notification-details__icon", r.value])
          }, null, 8, ["icon", "class"])) : j("", !0),
          re("span", l8e, ie(i), 1)
        ], 64))), 128))
      ])
    ]));
  }
}), c8e = { class: "notification-form__horizontal-fields" }, p8e = { class: "notification-form__review-block p-background" }, d8e = /* @__PURE__ */ U({
  __name: "NotificationForm",
  props: {
    notification: {},
    action: {}
  },
  emits: ["update:notification", "submit", "cancel"],
  setup(t, { emit: e }) {
    const n = t, r = e, { handleSubmit: o } = Mc({
      initialValues: {
        stateNames: n.notification?.stateNames ?? [],
        tags: n.notification?.tags ?? [],
        blockData: {}
      }
    }), { value: s } = Rs("stateNames"), { value: i } = Rs("tags"), u = Se(), l = ge(), a = lt({}), c = D({
      get() {
        if (l.value === void 0 || A.value === void 0)
          return;
        const X = a[l.value];
        return X || Bh(A.value.fields);
      },
      set(X) {
        l.value !== void 0 && (a[l.value] = X);
      }
    });
    bse(c, "blockData");
    const p = D(() => n.notification?.blockDocumentId ? [n.notification.blockDocumentId] : null), d = xt(u.blockDocuments.getBlockDocument, p), h = D(() => d.response);
    Ct(h, (X) => {
      X && (l.value = X.blockTypeId, c.value = X.data);
    }, { immediate: !0 });
    const m = {
      blockSchemas: {
        blockCapabilities: ["notify"]
      }
    }, g = mt(u.blockTypes.getBlockTypes, [m]), _ = D(() => g.response ?? []), b = D(() => _.value.find((X) => X.id === l.value)), x = D(() => _.value.map((X) => ({
      label: X.name,
      value: X.id
    })));
    dx(() => {
      l.value || n.notification?.blockDocumentId || _.value.length && (l.value = _.value[0].id);
    });
    const S = D(() => !l.value || h.value && l.value === h.value.blockTypeId ? null : l.value), { blockSchema: E } = yN(S), A = D(() => h.value && l.value === h.value.blockTypeId ? h.value.blockSchema : E.value), C = ge(), M = o(async (X) => {
      if (A.value === void 0 || l.value === void 0 || c.value === void 0) {
        He(le.error.submitNotification);
        return;
      }
      try {
        if (h.value?.id && h.value.blockSchemaId === A.value.id && h.value.blockTypeId === l.value)
          C.value = h.value.id, await u.blockDocuments.updateBlockDocument(C.value, {
            blockSchema: A.value,
            data: c.value
          });
        else {
          const B = await u.blockDocuments.createBlockDocument({
            isAnonymous: !0,
            blockSchema: A.value,
            data: c.value
          });
          C.value = B.id;
        }
        const te = { ...X, blockDocumentId: C.value };
        r("update:notification", te), r("submit", te);
      } catch (te) {
        const B = Yt(te, le.error.submitNotification);
        He(B, "error");
      }
    });
    function L() {
      r("cancel");
    }
    return (X, te) => {
      const B = P("p-button");
      return T(), O(v(Vv), {
        class: "notification-form p-background",
        onSubmit: v(M),
        onCancel: L
      }, {
        footer: k(() => [
          w(B, { onClick: L }, {
            default: k(() => [...te[3] || (te[3] = [
              q(" Cancel ", -1)
            ])]),
            _: 1
          }),
          w(Pc, { action: X.action }, null, 8, ["action"])
        ]),
        default: k(() => [
          te[4] || (te[4] = re("p", { class: "notification-form__message" }, " Choose which flow run states and tags trigger this notification. ", -1)),
          re("div", c8e, [
            w(v(nr), { label: "Run states" }, {
              default: k(() => [
                w(qh, {
                  selected: v(s),
                  "onUpdate:selected": te[0] || (te[0] = (W) => Xe(s) ? s.value = W : null),
                  "empty-message": "All states",
                  multiple: ""
                }, null, 8, ["selected"])
              ]),
              _: 1
            }),
            w(v(nr), { label: "Tags (Optional)" }, {
              default: k(() => [
                w(v(Wj), {
                  modelValue: v(i),
                  "onUpdate:modelValue": te[1] || (te[1] = (W) => Xe(i) ? i.value = W : null),
                  "empty-message": "All tags"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          w(v(Vj), {
            modelValue: l.value,
            "onUpdate:modelValue": te[2] || (te[2] = (W) => l.value = W),
            options: x.value
          }, null, 8, ["modelValue", "options"]),
          A.value && c.value ? (T(), O(ed, {
            key: 0,
            schema: A.value.fields,
            property: "blockData"
          }, null, 8, ["schema"])) : j("", !0),
          te[5] || (te[5] = re("p", { class: "notification-form__message" }, " Review your notification. ", -1)),
          re("div", p8e, [
            b.value && c.value ? (T(), O(AR, {
              key: 0,
              notification: { stateNames: v(s), tags: v(i) },
              "block-type": b.value,
              data: c.value
            }, null, 8, ["notification", "block-type", "data"])) : j("", !0)
          ])
        ]),
        _: 1
      }, 8, ["onSubmit"]);
    };
  }
}), sX = /* @__PURE__ */ U({
  inheritAttrs: !1,
  __name: "NotificationMenu",
  props: {
    notification: {}
  },
  emits: ["delete"],
  setup(t, { emit: e }) {
    const n = e, r = Ke(), o = Se(), s = je(), { showModal: i, open: u, close: l } = St(), a = async (c) => {
      l(), await Ua(c, o.notifications.deleteNotification, "Notification"), n("delete", c);
    };
    return (c, p) => {
      const d = P("p-overflow-menu-item"), h = P("router-link"), m = P("p-icon-button-menu");
      return T(), z(ve, null, [
        w(m, null, {
          default: k(() => [
            j("", !0),
            v(r).update.notification_policy ? (T(), O(h, {
              key: 1,
              to: v(s).notificationEdit(c.notification.id)
            }, {
              default: k(() => [
                w(d, { label: "Edit" })
              ]),
              _: 1
            }, 8, ["to"])) : j("", !0),
            v(r).delete.notification_policy ? (T(), O(d, {
              key: 2,
              label: "Delete",
              onClick: v(u)
            }, null, 8, ["onClick"])) : j("", !0)
          ]),
          _: 1
        }),
        w(_r, {
          showModal: v(i),
          "onUpdate:showModal": p[0] || (p[0] = (g) => Xe(i) ? i.value = g : null),
          label: "Notification",
          name: "this notification",
          onDelete: p[1] || (p[1] = (g) => a(c.notification.id))
        }, null, 8, ["showModal"])
      ], 64);
    };
  }
}), h8e = /* @__PURE__ */ U({
  __name: "NotificationsPageEmptyState",
  setup(t) {
    const e = Ke(), n = je();
    return (r, o) => (T(), O(v(na), { class: "workspace-notifications-empty-state" }, {
      icon: k(() => [
        w(v(vo), {
          icon: "BellIcon",
          class: "workspace-notifications-empty-state__icon"
        })
      ]),
      heading: k(() => [...o[0] || (o[0] = [
        q(" Create a notification to begin monitoring your flows ", -1)
      ])]),
      description: k(() => [...o[1] || (o[1] = [
        q(" Send an alert when a flow run enters a specific state. ", -1)
      ])]),
      actions: k(() => [
        v(e).create.notification_policy ? (T(), O(v(Zo), {
          key: 0,
          primary: "",
          "icon-append": "PlusIcon",
          to: v(n).notificationCreate()
        }, {
          default: k(() => [...o[2] || (o[2] = [
            q(" Create Notification ", -1)
          ])]),
          _: 1
        }, 8, ["to"])) : j("", !0),
        w(Os, {
          to: v(le).docs.notifications
        }, null, 8, ["to"])
      ]),
      _: 1
    }));
  }
}), f8e = /* @__PURE__ */ U({
  __name: "BlockDocument",
  props: {
    blockDocumentId: {}
  },
  setup(t) {
    const e = t, n = Se(), r = mt(n.blockDocuments.getBlockDocument, [e.blockDocumentId]), o = D(() => r.response);
    return (s, i) => (T(), z("div", null, [
      o.value ? Ve(s.$slots, "default", {
        key: 0,
        blockDocument: o.value
      }) : j("", !0)
    ]));
  }
}), aX = /* @__PURE__ */ U({
  __name: "NotificationStatusSelect",
  props: {
    selected: {}
  },
  emits: ["update:selected"],
  setup(t, { emit: e }) {
    const n = t, r = e, o = D({
      get() {
        return n.selected;
      },
      set(i) {
        r("update:selected", i);
      }
    }), s = [
      { label: "Status: All", value: "all" },
      { label: "Status: Active", value: "active" },
      { label: "Status: Paused", value: "paused" }
    ];
    return (i, u) => {
      const l = P("p-select");
      return T(), O(l, {
        modelValue: o.value,
        "onUpdate:modelValue": u[0] || (u[0] = (a) => o.value = a),
        options: s,
        class: "notification-status-select"
      }, null, 8, ["modelValue"]);
    };
  }
}), iX = /* @__PURE__ */ U({
  __name: "NotificationToggle",
  props: {
    notification: {}
  },
  emits: ["update"],
  setup(t, { emit: e }) {
    const n = t, r = e, o = Ke(), s = Se(), i = D({
      get() {
        return !!n.notification.isActive;
      },
      set(a) {
        l(a);
      }
    }), u = ge(!1), l = async (a) => {
      u.value = !0;
      try {
        const c = { isActive: a };
        await s.notifications.updateNotification(n.notification.id, c);
        const p = a ? le.success.activateNotification : le.success.pauseNotification;
        He(p, "success"), r("update");
      } catch (c) {
        const p = a ? le.error.activateNotification : le.error.pauseNotification, d = Yt(c, p);
        He(d, "error"), console.error(c);
      } finally {
        u.value = !1;
      }
    };
    return (a, c) => {
      const p = P("p-tooltip");
      return T(), O(p, { text: "Pause or resume this notification" }, {
        default: k(() => [
          v(o).update.notification_policy ? (T(), O(v(Mh), {
            key: 0,
            modelValue: i.value,
            "onUpdate:modelValue": c[0] || (c[0] = (d) => i.value = d),
            loading: u.value
          }, null, 8, ["modelValue", "loading"])) : j("", !0)
        ]),
        _: 1
      });
    };
  }
}), m8e = { class: "notifications-table" }, y8e = { class: "notifications-table__search" }, g8e = ["data-notification-id"], v8e = { class: "notifications-table__actions" }, _8e = /* @__PURE__ */ U({
  __name: "NotificationsTable",
  props: {
    notifications: {}
  },
  emits: ["update", "delete"],
  setup(t, { emit: e }) {
    const n = t, r = e, o = ge("all"), s = D(() => o.value !== "all"), i = Ke(), u = [
      {
        label: "Notification"
      },
      {
        label: "Action",
        width: "42px",
        visible: i.update.notification_policy
      }
    ], l = D(() => o.value === "active" ? n.notifications.filter((c) => c.isActive) : o.value === "paused" ? n.notifications.filter((c) => !c.isActive) : n.notifications);
    function a() {
      o.value = "all";
    }
    return (c, p) => {
      const d = P("p-button");
      return T(), z("div", m8e, [
        re("div", y8e, [
          w(Uo, {
            label: "Notification",
            count: l.value.length
          }, null, 8, ["count"]),
          w(aX, {
            selected: o.value,
            "onUpdate:selected": p[0] || (p[0] = (h) => o.value = h)
          }, null, 8, ["selected"])
        ]),
        w(v(BI), {
          data: l.value,
          columns: u,
          class: "notifications-table"
        }, {
          notification: k(({ row: h }) => [
            re("div", {
              class: "notifications-table__details",
              "data-notification-id": h.id
            }, [
              w(f8e, {
                "block-document-id": h.blockDocumentId
              }, {
                default: k(({ blockDocument: m }) => [
                  w(AR, {
                    notification: h,
                    "block-type": m.blockType,
                    data: m.data
                  }, null, 8, ["notification", "block-type", "data"])
                ]),
                _: 2
              }, 1032, ["block-document-id"])
            ], 8, g8e)
          ]),
          "action-heading": k(() => [...p[3] || (p[3] = [
            re("span", null, null, -1)
          ])]),
          action: k(({ row: h }) => [
            re("div", v8e, [
              w(iX, {
                notification: h,
                onUpdate: p[1] || (p[1] = (m) => r("update"))
              }, null, 8, ["notification"]),
              w(sX, {
                size: "xs",
                notification: h,
                onDelete: p[2] || (p[2] = (m) => r("delete", m))
              }, null, 8, ["notification"])
            ])
          ]),
          "empty-state": k(() => [
            w(v(el), null, Ut({
              message: k(() => [
                p[4] || (p[4] = q(" No notifications ", -1))
              ]),
              _: 2
            }, [
              s.value ? {
                name: "actions",
                fn: k(() => [
                  w(d, {
                    size: "sm",
                    onClick: a
                  }, {
                    default: k(() => [...p[5] || (p[5] = [
                      q(" Clear Filters ", -1)
                    ])]),
                    _: 1
                  })
                ]),
                key: "0"
              } : void 0
            ]), 1024)
          ]),
          _: 1
        }, 8, ["data"])
      ]);
    };
  }
}), w8e = { class: "page-heading" }, b8e = { class: "page-heading__leading" }, k8e = { class: "page-heading__crumbs" }, T8e = { class: "page-heading__trailing" }, nn = /* @__PURE__ */ U({
  __name: "PageHeading",
  props: {
    crumbs: {},
    size: { default: "xl" }
  },
  setup(t) {
    const e = t, n = D(() => ({
      "page-heading__crumbs--xs": e.size === "xs",
      "page-heading__crumbs--sm": e.size === "sm",
      "page-heading__crumbs--md": e.size === "md",
      "page-heading__crumbs--lg": e.size === "lg",
      "page-heading__crumbs--xl": e.size === "xl"
    }));
    return (r, o) => (T(), z("header", w8e, [
      re("div", b8e, [
        re("div", k8e, [
          w(v(Hj), {
            class: Bt(n.value),
            crumbs: r.crumbs
          }, null, 8, ["class", "crumbs"]),
          Ve(r.$slots, "after-crumbs")
        ]),
        Ve(r.$slots, "default")
      ]),
      re("div", T8e, [
        Ve(r.$slots, "actions")
      ])
    ]));
  }
}), x8e = /* @__PURE__ */ U({
  __name: "PageHeadingAccountSettings",
  setup(t) {
    const e = [{ text: "Account Settings" }];
    return (n, r) => (T(), O(nn, {
      class: "page-heading-user-settings",
      crumbs: e
    }));
  }
}), S8e = /* @__PURE__ */ U({
  __name: "PageHeadingApiKeys",
  setup(t) {
    const e = [{ text: "API Keys" }];
    return (n, r) => {
      const o = P("p-button");
      return T(), O(nn, {
        class: "page-heading-api-keys",
        crumbs: e
      }, {
        "after-crumbs": k(() => [
          w(o, {
            size: "sm",
            icon: "PlusIcon"
          })
        ]),
        _: 1
      });
    };
  }
}), R8e = /* @__PURE__ */ U({
  __name: "PageHeadingArtifact",
  props: {
    artifact: {}
  },
  setup(t) {
    const e = t, n = je(), { ArtifactMenu: r } = Vn(), o = D(() => e.artifact.flowRunId), s = D(() => e.artifact.taskRunId), { flowRun: i } = yl(o), { taskRun: u } = Kp(s), l = D(() => !!e.artifact.flowRunId || !!e.artifact.taskRunId), a = D(() => {
      const c = [];
      return l.value && !e.artifact.key ? (i.value && c.push({
        text: i.value.name ?? "",
        to: n.flowRun(i.value.id)
      }), u.value && c.push({
        text: u.value.name ?? "",
        to: n.taskRun(u.value.id)
      })) : e.artifact.key && c.push({
        text: e.artifact.key,
        to: n.artifactKey(e.artifact.key)
      }), c.push({
        text: e.artifact.id
      }), c;
    });
    return (c, p) => (T(), O(nn, {
      class: "page-heading-artifact",
      crumbs: a.value
    }, {
      actions: k(() => [
        w(v(r), { artifact: c.artifact }, null, 8, ["artifact"])
      ]),
      _: 1
    }, 8, ["crumbs"]));
  }
}), A8e = /* @__PURE__ */ U({
  __name: "PageHeadingArtifactKey",
  props: {
    artifact: {}
  },
  setup(t) {
    const e = t, n = je(), { ArtifactMenu: r } = Vn(), o = D(() => {
      const s = [
        {
          text: le.info.artifacts,
          to: n.artifacts()
        }
      ];
      return e.artifact.key && s.push({
        text: e.artifact.key
      }), s;
    });
    return (s, i) => (T(), O(nn, {
      class: "page-heading-artifact-key",
      crumbs: o.value
    }, {
      actions: k(() => [
        w(v(r), { artifact: s.artifact }, null, 8, ["artifact"])
      ]),
      _: 1
    }, 8, ["crumbs"]));
  }
}), D8e = /* @__PURE__ */ U({
  __name: "PageHeadingArtifacts",
  setup(t) {
    const e = [{ text: le.info.artifacts }];
    return (n, r) => (T(), O(nn, {
      class: "page-heading-artifacts",
      crumbs: e
    }));
  }
}), E8e = /* @__PURE__ */ U({
  __name: "AutomationToggle",
  props: {
    automation: {}
  },
  emits: ["update"],
  setup(t, { emit: e }) {
    const n = t, r = e, o = Ke(), s = Se(), i = D({
      get() {
        return !!n.automation.enabled;
      },
      set(a) {
        l(a);
      }
    }), u = lt({ pending: !1 }), l = async (a) => {
      u.pending = !0;
      try {
        await s.automations.enableAutomation(n.automation.id, a), He(le.success.automationEnable(a), "success"), r("update");
      } catch (c) {
        He(le.error.automationToggle(a)), console.error(c);
      } finally {
        u.pending = !1;
      }
    };
    return (a, c) => (T(), O(v(Mh), {
      modelValue: i.value,
      "onUpdate:modelValue": c[0] || (c[0] = (p) => i.value = p),
      disabled: !v(o).update.automation,
      state: u
    }, null, 8, ["modelValue", "disabled", "state"]));
  }
}), M8e = /* @__PURE__ */ U({
  __name: "PageHeadingAutomation",
  props: {
    automation: {}
  },
  emits: ["refresh"],
  setup(t, { emit: e }) {
    const n = t, r = e, { AutomationMenu: o } = Vn(), s = rs(), i = je(), u = D(() => [
      { text: "Automations", to: i.automations() },
      { text: n.automation.name }
    ]), l = D(() => ({
      anyResource: {
        id: [`prefect-cloud.automation.${n.automation.id}`]
      }
    }));
    function a() {
      s.push(i.automations());
    }
    return (c, p) => (T(), O(nn, {
      class: "page-heading-automation",
      crumbs: u.value
    }, {
      actions: k(() => [
        w(E8e, {
          automation: c.automation,
          onUpdate: p[0] || (p[0] = (d) => r("refresh"))
        }, null, 8, ["automation"]),
        w(EL, { filter: l.value }, null, 8, ["filter"]),
        w(v(o), {
          automation: c.automation,
          onDelete: a
        }, null, 8, ["automation"])
      ]),
      _: 1
    }, 8, ["crumbs"]));
  }
}), P8e = /* @__PURE__ */ U({
  __name: "PageHeadingBlock",
  props: {
    blockDocument: {}
  },
  emits: ["delete"],
  setup(t, { emit: e }) {
    const n = t, r = e, o = je(), { BlockDocumentMenu: s } = Vn(), i = [
      { text: "Blocks", to: o.blocks() },
      { text: n.blockDocument.name }
    ];
    return (u, l) => (T(), O(nn, {
      class: "page-heading-blocks",
      crumbs: i
    }, {
      actions: k(() => [
        w(v(s), {
          "block-document": u.blockDocument,
          onDelete: l[0] || (l[0] = (a) => r("delete"))
        }, null, 8, ["block-document"])
      ]),
      _: 1
    }));
  }
}), C8e = /* @__PURE__ */ U({
  __name: "PageHeadingBlockEdit",
  props: {
    blockDocument: {}
  },
  setup(t) {
    const e = t, n = je(), r = [
      { text: "Blocks", to: n.blocks() },
      { text: e.blockDocument.name, to: n.block(e.blockDocument.id) },
      { text: "Edit" }
    ];
    return (o, s) => (T(), O(nn, {
      class: "page-heading-block-edit",
      crumbs: r
    }));
  }
}), O8e = /* @__PURE__ */ U({
  __name: "PageHeadingBlocks",
  setup(t) {
    const e = [{ text: "Blocks" }], n = Ke(), r = je();
    return (o, s) => {
      const i = P("p-button");
      return T(), O(nn, {
        class: "page-heading-blocks",
        crumbs: e
      }, Ut({ _: 2 }, [
        v(n).create.block ? {
          name: "after-crumbs",
          fn: k(() => [
            w(i, {
              size: "sm",
              icon: "PlusIcon",
              to: v(r).blocksCatalog()
            }, null, 8, ["to"])
          ]),
          key: "0"
        } : void 0
      ]), 1024);
    };
  }
}), I8e = /* @__PURE__ */ U({
  __name: "PageHeadingBlocksCatalog",
  setup(t) {
    const n = [
      { text: "Blocks", to: je().blocks() },
      { text: "Catalog" }
    ];
    return (r, o) => {
      const s = P("p-link"), i = P("p-message"), u = P("p-content");
      return T(), O(u, null, {
        default: k(() => [
          w(nn, {
            class: "page-heading-blocks-catalog",
            crumbs: n
          }),
          w(i, null, {
            default: k(() => [
              o[1] || (o[1] = q(" Can't find a block for your service? Check out the ", -1)),
              w(s, {
                to: v(le).docs.collections
              }, {
                default: k(() => [...o[0] || (o[0] = [
                  q(" docs ", -1)
                ])]),
                _: 1
              }, 8, ["to"]),
              o[2] || (o[2] = q(" for a full list of integrations in the SDK. ", -1))
            ]),
            _: 1
          })
        ]),
        _: 1
      });
    };
  }
}), F8e = /* @__PURE__ */ U({
  __name: "PageHeadingBlocksCatalogCreate",
  props: {
    blockType: {}
  },
  setup(t) {
    const e = t, n = je(), r = D(() => [
      { text: "Blocks", to: n.blocks() },
      { text: "Choose a Block", to: n.blocksCatalog() },
      { text: e.blockType.name, to: n.blocksCatalogView(e.blockType.slug) },
      { text: "Create" }
    ]);
    return (o, s) => (T(), O(nn, {
      class: "page-heading-blocks-catalog-create",
      crumbs: r.value
    }, null, 8, ["crumbs"]));
  }
}), N8e = /* @__PURE__ */ U({
  __name: "PageHeadingBlocksCatalogView",
  props: {
    blockType: {}
  },
  setup(t) {
    const e = t, n = je(), r = D(() => [
      { text: "Blocks", to: n.blocks() },
      { text: "Catalog", to: n.blocksCatalog() },
      { text: e.blockType.slug }
    ]);
    return (o, s) => (T(), O(nn, {
      class: "page-heading-blocks-catalog-create",
      crumbs: r.value
    }, null, 8, ["crumbs"]));
  }
}), L8e = /* @__PURE__ */ U({
  __name: "PageHeadingConcurrencyLimit",
  props: {
    concurrencyLimit: {}
  },
  setup(t) {
    const e = t, n = rs(), r = je(), o = D(() => [
      { text: "Concurrency Limits", to: r.concurrencyLimits() },
      { text: e.concurrencyLimit.tag }
    ]), s = () => {
      n.back();
    };
    return (i, u) => (T(), O(nn, {
      class: "page-heading-concurrency-limit",
      crumbs: o.value
    }, {
      actions: k(() => [
        w(H2, {
          "concurrency-limit": i.concurrencyLimit,
          onDelete: s
        }, null, 8, ["concurrency-limit"])
      ]),
      _: 1
    }, 8, ["crumbs"]));
  }
}), B8e = /* @__PURE__ */ U({
  __name: "PageHeadingConcurrencyLimits",
  setup(t) {
    const e = Ke(), { showModal: n, open: r } = St();
    return (o, s) => {
      const i = P("p-button");
      return T(), z(ve, null, [
        w(nn, { crumbs: [{ text: "Task Run Concurrency Limits" }] }, {
          "after-crumbs": k(() => [
            v(e).create.concurrency_limit ? (T(), O(i, {
              key: 0,
              size: "sm",
              icon: "PlusIcon",
              onClick: v(r)
            }, null, 8, ["onClick"])) : j("", !0)
          ]),
          _: 1
        }),
        w(j2, {
          showModal: v(n),
          "onUpdate:showModal": s[0] || (s[0] = (u) => Xe(n) ? n.value = u : null)
        }, null, 8, ["showModal"])
      ], 64);
    };
  }
}), U8e = /* @__PURE__ */ U({
  __name: "PageHeadingDeployment",
  props: {
    deployment: {},
    deploymentDisableToggle: { type: Boolean }
  },
  emits: ["update"],
  setup(t, { emit: e }) {
    const n = t, r = e, o = rs(), s = je(), { DeploymentMenu: i } = Vn(), u = D(() => [
      { text: "Deployments", to: s.deployments() },
      { text: n.deployment.name }
    ]), l = () => {
      o.back();
    };
    return (a, c) => (T(), O(v(nn), {
      class: "page-heading-deployment",
      crumbs: u.value
    }, {
      actions: k(() => [
        a.deploymentDisableToggle ? (T(), O(aS, {
          key: 0,
          deployment: a.deployment,
          onUpdate: c[0] || (c[0] = (p) => r("update"))
        }, null, 8, ["deployment"])) : j("", !0),
        a.deployment.can.run && v(_s).sm ? (T(), O(v(hX), {
          key: 1,
          deployment: a.deployment
        }, null, 8, ["deployment"])) : j("", !0),
        w(v(i), {
          deployment: a.deployment,
          "show-all": !v(_s).sm,
          onDelete: l
        }, null, 8, ["deployment", "show-all"])
      ]),
      default: k(() => [
        w(v(dS), { deployment: a.deployment }, null, 8, ["deployment"])
      ]),
      _: 1
    }, 8, ["crumbs"]));
  }
}), X8e = /* @__PURE__ */ U({
  __name: "PageHeadingDeploymentDuplicate",
  props: {
    deployment: {}
  },
  setup(t) {
    const e = t, n = je(), r = D(() => [
      { text: "Deployments", to: n.deployments() },
      { text: e.deployment.name, to: n.deployment(e.deployment.id) },
      { text: "Duplicate" }
    ]);
    return (o, s) => (T(), O(nn, {
      class: "page-heading-deployment-duplicate",
      crumbs: r.value
    }, null, 8, ["crumbs"]));
  }
}), $8e = /* @__PURE__ */ U({
  __name: "PageHeadingDeploymentEdit",
  props: {
    deployment: {}
  },
  setup(t) {
    const e = t, n = je(), r = D(() => [
      { text: "Deployments", to: n.deployments() },
      { text: e.deployment.name, to: n.deployment(e.deployment.id) },
      { text: "Edit" }
    ]);
    return (o, s) => (T(), O(nn, {
      class: "page-heading-deployment-edit",
      crumbs: r.value
    }, null, 8, ["crumbs"]));
  }
}), W8e = /* @__PURE__ */ U({
  __name: "PageHeadingDeployments",
  setup(t) {
    const e = [{ text: "Deployments" }];
    return (n, r) => (P("p-button"), T(), O(nn, {
      class: "page-heading-deployments",
      crumbs: e
    }, {
      "after-crumbs": k(() => [
        j("", !0)
      ]),
      _: 1
    }));
  }
}), V8e = /* @__PURE__ */ U({
  __name: "PageHeadingFlow",
  props: {
    flow: {}
  },
  emits: ["delete"],
  setup(t, { emit: e }) {
    const n = t, r = e, { FlowMenu: o } = Vn(), s = je(), i = D(() => [
      { text: "Flows", to: s.flows() },
      { text: n.flow.name }
    ]), u = (l) => {
      r("delete", l);
    };
    return (l, a) => (T(), O(nn, {
      class: "page-heading-flow",
      crumbs: i.value
    }, {
      actions: k(() => [
        w(v(o), {
          flow: l.flow,
          onDelete: u
        }, null, 8, ["flow"])
      ]),
      _: 1
    }, 8, ["crumbs"]));
  }
}), H8e = /* @__PURE__ */ U({
  __name: "PageHeadingFlowCollection",
  props: {
    collectionItem: {}
  },
  setup(t) {
    const e = t, n = je(), r = D(() => [
      { text: "Flows", to: n.flows() },
      { text: "Collections", to: n.flowCollections() },
      { text: e.collectionItem.name }
    ]);
    return (o, s) => (T(), O(nn, {
      class: "page-heading-flow-collection",
      crumbs: r.value
    }, null, 8, ["crumbs"]));
  }
}), j8e = /* @__PURE__ */ U({
  __name: "PageHeadingFlowCollections",
  setup(t) {
    const n = [
      { text: "Flows", to: je().flows() },
      { text: "Collections" }
    ];
    return (r, o) => (T(), O(nn, {
      class: "page-heading-flow-collections",
      crumbs: n
    }));
  }
}), z8e = {
  key: 0,
  class: "state-list-item__tags"
}, q8e = { class: "page-heading-flow-run__flow-details" }, G8e = { class: "page-heading-flow-run__meta" }, Y8e = { class: "page-heading-flow-run__relationships" }, Q8e = /* @__PURE__ */ U({
  __name: "PageHeadingFlowRun",
  props: {
    flowRunId: {}
  },
  emits: ["delete"],
  setup(t, { emit: e }) {
    const n = t, { FlowRunMenu: r } = Vn(), o = je(), s = e, i = D(() => [
      { text: "Runs", to: o.runs({ tab: "flow-runs" }) },
      { text: u.value?.name ?? "" }
    ]), { flowRun: u, subscription: l } = yl(() => n.flowRunId, { interval: 3e4 }), a = D(() => u.value?.stateType ? Kq(u.value.stateType) : !0), { count: c } = hp(() => ({
      flowRuns: {
        id: [n.flowRunId]
      }
    }));
    function p() {
      l.refresh();
    }
    return (d, h) => {
      const m = P("p-tag-wrapper");
      return v(u) ? (T(), O(v(nn), {
        key: 0,
        class: "page-heading-flow-run",
        crumbs: i.value
      }, {
        "after-crumbs": k(() => [
          v(u).tags && v(u).tags.length > 0 ? (T(), z("div", z8e, [
            w(m, sn(kn({ tags: v(u).tags })), null, 16)
          ])) : j("", !0)
        ]),
        actions: k(() => [
          v(u) ? (T(), z(ve, { key: 0 }, [
            v(_s).sm ? (T(), z(ve, { key: 0 }, [
              w(v(YU), {
                "flow-run": v(u),
                onUpdate: p
              }, null, 8, ["flow-run"]),
              w(v(HU), {
                "flow-run": v(u),
                onUpdate: p
              }, null, 8, ["flow-run"]),
              w(v(jU), {
                "flow-run": v(u),
                onUpdate: p
              }, null, 8, ["flow-run"]),
              w(v(OL), {
                "flow-run": v(u),
                onUpdate: p
              }, null, 8, ["flow-run"])
            ], 64)) : j("", !0),
            w(v(r), {
              "flow-run": v(u),
              "show-all": !v(_s).sm,
              onDelete: h[0] || (h[0] = (g) => s("delete"))
            }, null, 8, ["flow-run", "show-all"])
          ], 64)) : j("", !0)
        ]),
        default: k(() => [
          re("div", q8e, [
            re("div", G8e, [
              w(v(Dr), {
                state: v(u).state
              }, null, 8, ["state"]),
              w(v(ay), { "flow-run": v(u) }, null, 8, ["flow-run"]),
              a.value ? j("", !0) : (T(), z(ve, { key: 0 }, [
                w(v(Cc), {
                  duration: v(u).duration
                }, null, 8, ["duration"]),
                w(JU, {
                  icon: "Task",
                  count: v(c) ?? 0,
                  label: "Task run"
                }, null, 8, ["count"])
              ], 64))
            ]),
            re("div", Y8e, [
              v(u).flowId ? (T(), O(pS, {
                key: 0,
                "flow-id": v(u).flowId
              }, null, 8, ["flow-id"])) : j("", !0),
              v(u).parentTaskRunId ? (T(), O(WU, {
                key: 1,
                "parent-task-run-id": v(u).parentTaskRunId
              }, null, 8, ["parent-task-run-id"])) : j("", !0),
              v(u).deploymentId ? (T(), O(R_, {
                key: 2,
                "deployment-id": v(u).deploymentId
              }, null, 8, ["deployment-id"])) : j("", !0),
              v(u).workPoolName ? (T(), O(ny, {
                key: 3,
                "work-pool-name": v(u).workPoolName
              }, null, 8, ["work-pool-name"])) : j("", !0),
              v(u).workQueueName ? (T(), O(ry, {
                key: 4,
                "work-queue-name": v(u).workQueueName,
                "work-pool-name": v(u).workPoolName,
                "flow-run-state": v(u).stateType
              }, null, 8, ["work-queue-name", "work-pool-name", "flow-run-state"])) : j("", !0),
              w(CL, { "flow-run": v(u) }, null, 8, ["flow-run"])
            ])
          ])
        ]),
        _: 1
      }, 8, ["crumbs"])) : j("", !0);
    };
  }
}), K8e = /* @__PURE__ */ U({
  __name: "PageHeadingFlowRunCreate",
  props: {
    deployment: {}
  },
  setup(t) {
    const e = t, n = je(), r = D(() => [
      { text: "Deployments", to: n.deployments() },
      { text: e.deployment.name, to: n.deployment(e.deployment.id) },
      { text: "Run" }
    ]);
    return (o, s) => (T(), O(nn, { crumbs: r.value }, {
      "after-crumbs": k(() => [
        Ve(o.$slots, "after-crumbs")
      ]),
      default: k(() => [
        w(dS, { deployment: o.deployment }, null, 8, ["deployment"])
      ]),
      _: 3
    }, 8, ["crumbs"]));
  }
}), Z8e = c_("prefect-ui-library-custom-default-flow-runs-filter"), { value: TI, set: xI } = hl(Z8e);
function uX() {
  const t = D(() => TI.value ?? Tk.filters), e = D(() => TI.value !== null);
  function n(o) {
    d_(o, Tk.filters) ? r() : xI(o);
  }
  function r() {
    xI(null);
  }
  return {
    value: t,
    set: n,
    remove: r,
    isCustom: e
  };
}
function DR() {
  const t = Se(), e = mt(t.savedSearches.getSavedSearches), n = D(() => Wte.concat(e.response ?? [])), { value: r } = uX(), o = D(() => {
    let u = !1;
    const l = n.value.map((a) => d_(a.filters, r.value) ? (u = !0, { ...a, isDefault: !0 }) : { ...a, isDefault: !1 });
    if (!u) {
      const a = {
        ...xF,
        filters: r.value,
        isDefault: !0
      }, c = l.findIndex((p) => p.name === Tk.name);
      l.splice(c, 0, a);
    }
    return l;
  });
  async function s(u) {
    await t.savedSearches.deleteSavedSearch(u), e.refresh();
  }
  async function i(u) {
    const l = await t.savedSearches.createSavedSearch(u);
    return e.refresh(), l;
  }
  return {
    savedFlowRunsSearches: o,
    createSavedFlowRunsSearch: i,
    deleteSavedFlowRunsSearch: s
  };
}
const lX = /* @__PURE__ */ U({
  __name: "SavedFiltersDeleteModal",
  props: {
    showModal: { type: Boolean },
    savedSearch: {}
  },
  emits: ["update:showModal", "deleted"],
  setup(t, { emit: e }) {
    const n = t, r = e, o = D({
      get() {
        return n.showModal;
      },
      set(u) {
        r("update:showModal", u);
      }
    }), { deleteSavedFlowRunsSearch: s } = DR();
    async function i() {
      try {
        n.savedSearch.id && (await s(n.savedSearch.id), He(le.success.deleteSavedSearch, "success"), o.value = !1, r("deleted"));
      } catch (u) {
        console.error(u);
        const l = Yt(u, le.error.deleteSavedSearch);
        He(l, "error");
      }
    }
    return (u, l) => (T(), O(_r, {
      showModal: o.value,
      "onUpdate:showModal": l[0] || (l[0] = (a) => o.value = a),
      label: "Saved Filter",
      name: u.savedSearch.name,
      onDelete: i
    }, null, 8, ["showModal", "name"]));
  }
}), cX = /* @__PURE__ */ U({
  __name: "SaveFilterModal",
  props: {
    showModal: { type: Boolean },
    savedSearch: {}
  },
  emits: ["update:showModal", "saved"],
  setup(t, { emit: e }) {
    const n = t, r = e, o = D({
      get() {
        return n.showModal;
      },
      set(b) {
        r("update:showModal", b);
      }
    }), { handleSubmit: s, handleReset: i, isSubmitting: u } = Mc(), { savedFlowRunsSearches: l, createSavedFlowRunsSearch: a } = DR(), c = qte((b) => !l.value.some(({ name: x }) => x === b)), p = [Kr("Name"), DF(c, "Name must be unique")], { value: d, meta: h, errorMessage: m } = Rs("filterName", p), g = s(({ filterName: b }) => {
      _(b), i();
    }), _ = async (b) => {
      try {
        const x = await a({
          name: b,
          filters: n.savedSearch.filters
        });
        He(le.success.createSavedSearch, "success"), o.value = !1, r("saved", x);
      } catch (x) {
        console.error(x);
        const S = Yt(x, le.error.createSavedSearch);
        He(S, "error");
      }
    };
    return (b, x) => {
      const S = P("p-text-input"), E = P("p-label"), A = P("p-content"), C = P("p-form"), M = P("p-button"), L = P("p-modal");
      return T(), O(L, {
        showModal: o.value,
        "onUpdate:showModal": x[1] || (x[1] = (X) => o.value = X),
        class: "save-filter-modal",
        title: "Save View"
      }, {
        actions: k(() => [
          Ve(b.$slots, "actions", {}, () => [
            w(M, {
              variant: "default",
              loading: v(u),
              onClick: v(g)
            }, {
              default: k(() => [...x[2] || (x[2] = [
                q(" Save ", -1)
              ])]),
              _: 1
            }, 8, ["loading", "onClick"])
          ])
        ]),
        default: k(() => [
          w(C, { onSubmit: v(g) }, {
            default: k(() => [
              w(A, null, {
                default: k(() => [
                  w(E, {
                    label: "View Name",
                    state: v(h),
                    message: v(m)
                  }, {
                    default: k(() => [
                      w(S, {
                        modelValue: v(d),
                        "onUpdate:modelValue": x[0] || (x[0] = (X) => Xe(d) ? d.value = X : null)
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["state", "message"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["onSubmit"])
        ]),
        _: 3
      }, 8, ["showModal"]);
    };
  }
}), pX = /* @__PURE__ */ U({
  inheritAttrs: !1,
  __name: "SavedFiltersMenu",
  props: {
    savedSearch: {}
  },
  emits: ["update:selectedSearchOption"],
  setup(t, { emit: e }) {
    const n = t, r = e, o = Eh(), s = D({
      get() {
        return n.savedSearch;
      },
      set(A) {
        r("update:selectedSearchOption", A);
      }
    }), i = D(() => s.value?.name === zg.name || s.value?.name === xF.name), u = D(() => i.value && d.create.saved_search), l = D(() => s.value?.id && d.delete.saved_search), a = D(() => !(i.value || n.savedSearch?.isDefault && !c.isCustom.value)), c = uX();
    function p() {
      n.savedSearch?.isDefault ? c.remove() : n.savedSearch && c.set(n.savedSearch.filters);
    }
    const d = Ke(), h = kc(), m = D(() => window.location.origin + h.fullPath), { showModal: g, open: _ } = St(), { showModal: b, open: x } = St();
    function S(A) {
      s.value = { ...A, isDefault: !1 };
    }
    function E() {
      s.value = null;
    }
    return (A, C) => {
      const M = P("p-overflow-menu-item"), L = P("p-icon-button-menu");
      return T(), z(ve, null, [
        w(L, sn(kn(v(o))), {
          default: k(() => [
            w(uo, {
              label: "Share View",
              item: m.value
            }, null, 8, ["item"]),
            u.value ? (T(), O(M, {
              key: 0,
              onClick: v(_)
            }, {
              default: k(() => [...C[2] || (C[2] = [
                q(" Save View ", -1)
              ])]),
              _: 1
            }, 8, ["onClick"])) : j("", !0),
            l.value ? (T(), O(M, {
              key: 1,
              inset: "",
              onClick: v(x)
            }, {
              default: k(() => [...C[3] || (C[3] = [
                q(" Delete View ", -1)
              ])]),
              _: 1
            }, 8, ["onClick"])) : j("", !0),
            a.value ? (T(), O(M, {
              key: 2,
              inset: "",
              onClick: p
            }, {
              default: k(() => [
                A.savedSearch?.isDefault ? (T(), z(ve, { key: 0 }, [
                  q(" Remove as default ")
                ], 64)) : (T(), z(ve, { key: 1 }, [
                  q(" Set as default ")
                ], 64))
              ]),
              _: 1
            })) : j("", !0)
          ]),
          _: 1
        }, 16),
        A.savedSearch ? (T(), O(cX, {
          key: 0,
          showModal: v(g),
          "onUpdate:showModal": C[0] || (C[0] = (X) => Xe(g) ? g.value = X : null),
          "saved-search": A.savedSearch,
          onSave: S
        }, null, 8, ["showModal", "saved-search"])) : j("", !0),
        s.value && l.value ? (T(), O(lX, {
          key: 1,
          showModal: v(b),
          "onUpdate:showModal": C[1] || (C[1] = (X) => Xe(b) ? b.value = X : null),
          "saved-search": s.value,
          onDelete: E
        }, null, 8, ["showModal", "saved-search"])) : j("", !0)
      ], 64);
    };
  }
}), J8e = { class: "saved-filters" }, ER = /* @__PURE__ */ U({
  __name: "SavedFilters",
  props: {
    filter: {},
    small: { type: Boolean }
  },
  emits: ["update:filter"],
  setup(t, { emit: e }) {
    const n = t, r = e, { savedFlowRunsSearches: o } = DR(), s = D(() => {
      const c = o.value.map(({ name: p, isDefault: d }) => ({
        label: d ? `${p} (default)` : p,
        value: p
      }));
      return l(n.filter) ? c : [
        { label: zg.name, value: zg.name, disabled: !0 },
        ...c
      ];
    }), i = D({
      get() {
        const c = l(n.filter);
        return c || { ...zg, filters: n.filter, isDefault: !1 };
      },
      set(c) {
        r("update:filter", c.filters);
      }
    }), u = D({
      get() {
        return i.value.name;
      },
      set(c) {
        const p = a(c);
        p && r("update:filter", p.filters);
      }
    });
    function l(c) {
      return o.value.find((p) => d_(p.filters, c));
    }
    function a(c) {
      return o.value.find((p) => p.name === c);
    }
    return (c, p) => {
      const d = P("p-select");
      return T(), z("div", J8e, [
        w(d, {
          modelValue: u.value,
          "onUpdate:modelValue": p[0] || (p[0] = (h) => u.value = h),
          small: c.small,
          options: s.value,
          class: "saved-filters__select"
        }, null, 8, ["modelValue", "small", "options"]),
        w(pX, {
          "saved-search": i.value,
          "onUpdate:savedSearch": p[1] || (p[1] = (h) => i.value = h),
          size: c.small && "sm"
        }, null, 8, ["saved-search", "size"])
      ]);
    };
  }
}), e3e = /* @__PURE__ */ U({
  __name: "PageHeadingFlowRuns",
  props: {
    filter: {},
    hideActions: { type: Boolean }
  },
  emits: ["update:filter"],
  setup(t, { emit: e }) {
    const n = t, r = e, o = [{ text: "Flow Runs" }], s = D({
      get() {
        return n.filter;
      },
      set(i) {
        r("update:filter", i);
      }
    });
    return (i, u) => (T(), O(nn, {
      class: "page-heading-flow-runs",
      crumbs: o
    }, Ut({ _: 2 }, [
      i.hideActions ? void 0 : {
        name: "actions",
        fn: k(() => [
          w(ER, {
            filter: s.value,
            "onUpdate:filter": u[0] || (u[0] = (l) => s.value = l)
          }, null, 8, ["filter"])
        ]),
        key: "0"
      }
    ]), 1024));
  }
}), t3e = /* @__PURE__ */ U({
  __name: "PageHeadingFlows",
  setup(t) {
    const e = [{ text: "Flows" }];
    return (n, r) => (T(), O(nn, {
      class: "page-heading-flows",
      crumbs: e
    }));
  }
}), n3e = /* @__PURE__ */ U({
  __name: "PageHeadingNotificationCreate",
  setup(t) {
    const e = [{ text: "Create Notification" }];
    return (n, r) => (T(), O(nn, { crumbs: e }));
  }
}), r3e = /* @__PURE__ */ U({
  __name: "PageHeadingNotificationEdit",
  setup(t) {
    const n = [
      { text: "Notifications", to: je().notifications() },
      { text: "Edit" }
    ];
    return (r, o) => (T(), O(nn, { crumbs: n }));
  }
}), o3e = /* @__PURE__ */ U({
  __name: "PageHeadingNotifications",
  setup(t) {
    const e = [{ text: "Notifications" }], n = Ke(), r = je();
    return (o, s) => {
      const i = P("p-button");
      return T(), O(nn, {
        class: "page-heading-notifications",
        crumbs: e
      }, Ut({ _: 2 }, [
        v(n).create.notification_policy ? {
          name: "after-crumbs",
          fn: k(() => [
            w(i, {
              size: "sm",
              icon: "PlusIcon",
              to: v(r).notificationCreate()
            }, null, 8, ["to"])
          ]),
          key: "0"
        } : void 0
      ]), 1024);
    };
  }
}), s3e = /* @__PURE__ */ U({
  __name: "PageHeadingRuns",
  props: {
    filter: {},
    hideActions: { type: Boolean }
  },
  emits: ["update:filter"],
  setup(t, { emit: e }) {
    const n = t, r = e, o = [{ text: "Runs" }], s = D({
      get() {
        return n.filter;
      },
      set(i) {
        r("update:filter", i);
      }
    });
    return (i, u) => (T(), O(nn, {
      class: "page-heading-runs",
      crumbs: o
    }, Ut({ _: 2 }, [
      i.hideActions ? void 0 : {
        name: "actions",
        fn: k(() => [
          w(ER, {
            filter: s.value,
            "onUpdate:filter": u[0] || (u[0] = (l) => s.value = l)
          }, null, 8, ["filter"])
        ]),
        key: "0"
      }
    ]), 1024));
  }
}), a3e = /* @__PURE__ */ U({
  __name: "PageHeadingTaskRun",
  props: {
    taskRunId: {}
  },
  emits: ["delete"],
  setup(t, { emit: e }) {
    const n = t, r = e, o = je(), { taskRun: s, subscription: i } = Kp(() => n.taskRunId), { flowRun: u } = yl(() => s.value?.flowRunId), l = D(() => {
      const a = [{ text: "Runs", to: o.runs({ tab: "task-runs" }) }];
      return u.value && a.push({ text: u.value.name ?? "", to: o.flowRun(u.value.id) }), a.push({ text: s.value?.name ?? "" }), a;
    });
    return (a, c) => v(s) ? (T(), O(v(nn), {
      key: 0,
      class: "page-heading-task-run",
      crumbs: l.value
    }, {
      "after-crumbs": k(() => [
        w(v(Dr), {
          state: v(s).state
        }, null, 8, ["state"])
      ]),
      actions: k(() => [
        w(v(mX), {
          "task-run": v(s),
          onDelete: c[0] || (c[0] = (p) => r("delete")),
          onUpdate: v(i).refresh
        }, null, 8, ["task-run", "onUpdate"])
      ]),
      _: 1
    }, 8, ["crumbs"])) : j("", !0);
  }
}), MR = /* @__PURE__ */ U({
  __name: "VariableCreateModal",
  props: {
    showModal: { type: Boolean }
  },
  emits: ["update:showModal", "create"],
  setup(t, { emit: e }) {
    const n = t, r = e, o = D({
      get() {
        return n.showModal;
      },
      set(S) {
        r("update:showModal", S);
      }
    }), s = Se(), i = async (S, E, { signal: A, source: C, previousValue: M }) => {
      if (S !== M && (C === "validator" && await new Promise((L) => setTimeout(L, 1e3)), !A.aborted)) {
        if (hu.isNull(S) || !Ht(S))
          return !1;
        try {
          return await s.variables.getVariableByName(S) ? le.error.variableAlreadyExists : !0;
        } catch {
          return !0;
        }
      }
    }, { validate: u, pending: l } = Ms(), a = ge(), c = ge(), p = ge([]), d = {
      name: [
        Kr(le.info.name),
        Fp(Kx)(le.info.value),
        f_,
        i
      ],
      value: [
        Kr(le.info.value),
        Fp(Zx)(le.info.value),
        ml(le.info.value)
      ]
    }, { error: h, state: m } = bn(a, le.info.name, d.name), { error: g, state: _ } = bn(c, le.info.value, d.value), b = () => {
      a.value = void 0, c.value = void 0, p.value = [];
    }, x = async () => {
      if (await u())
        try {
          const E = {
            name: a.value,
            value: c.value,
            tags: p.value
          }, A = await s.variables.createVariable(E);
          He(le.success.createVariable, "success"), r("create", A), o.value = !1, b();
        } catch (E) {
          console.error(E);
          const A = Yt(E, le.error.createVariable);
          He(A, "error");
        }
    };
    return (S, E) => {
      const A = P("p-text-input"), C = P("p-label"), M = P("p-tags-input"), L = P("p-content"), X = P("p-form"), te = P("p-button"), B = P("p-modal");
      return T(), O(B, {
        showModal: o.value,
        "onUpdate:showModal": E[3] || (E[3] = (W) => o.value = W),
        title: v(le).info.newVariable
      }, {
        actions: k(() => [
          w(te, {
            variant: "default",
            loading: v(l),
            onClick: x
          }, {
            default: k(() => [
              q(ie(v(le).info.create), 1)
            ]),
            _: 1
          }, 8, ["loading"])
        ]),
        default: k(() => [
          w(X, { onSubmit: x }, {
            default: k(() => [
              w(L, null, {
                default: k(() => [
                  w(C, {
                    label: v(le).info.name,
                    state: v(m),
                    message: v(h)
                  }, {
                    default: k(() => [
                      w(A, {
                        modelValue: a.value,
                        "onUpdate:modelValue": E[0] || (E[0] = (W) => a.value = W),
                        state: v(m)
                      }, null, 8, ["modelValue", "state"])
                    ]),
                    _: 1
                  }, 8, ["label", "state", "message"]),
                  w(C, {
                    label: v(le).info.value,
                    state: v(_),
                    message: v(g)
                  }, {
                    default: k(() => [
                      w(Rr, {
                        modelValue: c.value,
                        "onUpdate:modelValue": E[1] || (E[1] = (W) => c.value = W),
                        state: v(_),
                        "show-format-button": ""
                      }, null, 8, ["modelValue", "state"])
                    ]),
                    _: 1
                  }, 8, ["label", "state", "message"]),
                  w(C, {
                    label: v(le).info.tags
                  }, {
                    default: k(() => [
                      w(M, {
                        modelValue: p.value,
                        "onUpdate:modelValue": E[2] || (E[2] = (W) => p.value = W)
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["showModal", "title"]);
    };
  }
}), i3e = /* @__PURE__ */ U({
  __name: "PageHeadingVariables",
  emits: ["create"],
  setup(t, { emit: e }) {
    const n = [{ text: "Variables" }], r = e, o = Ke(), { showModal: s, open: i } = St();
    return (u, l) => {
      const a = P("p-button");
      return T(), z(ve, null, [
        w(nn, {
          class: "page-heading-variables",
          crumbs: n
        }, Ut({ _: 2 }, [
          v(o).create.variable ? {
            name: "after-crumbs",
            fn: k(() => [
              w(a, {
                size: "sm",
                icon: "PlusIcon",
                onClick: v(i)
              }, null, 8, ["onClick"])
            ]),
            key: "0"
          } : void 0
        ]), 1024),
        w(MR, {
          "show-modal": v(s),
          "onUpdate:showModal": l[0] || (l[0] = (c) => Xe(s) ? s.value = c : null),
          onCreate: l[1] || (l[1] = (c) => r("create"))
        }, null, 8, ["show-modal"])
      ], 64);
    };
  }
}), u3e = /* @__PURE__ */ U({
  __name: "PageHeadingWorkPool",
  props: {
    workPool: {}
  },
  emits: ["update", "delete"],
  setup(t, { emit: e }) {
    const n = t, { WorkPoolMenu: r } = Vn(), o = je(), s = rs(), i = e, u = D(() => [
      { text: "Work Pools", to: o.workPools() },
      { text: n.workPool.name }
    ]), l = () => {
      s.push(o.workPools());
    };
    return (a, c) => (T(), O(v(nn), {
      class: "page-heading-work-pool",
      crumbs: u.value
    }, {
      actions: k(() => [
        w(v(FR), {
          "work-pool": a.workPool,
          onUpdate: c[0] || (c[0] = (p) => i("update"))
        }, null, 8, ["work-pool"]),
        w(v(r), {
          "work-pool": a.workPool,
          "show-all": !v(_s).sm,
          onDelete: l
        }, null, 8, ["work-pool", "show-all"])
      ]),
      _: 1
    }, 8, ["crumbs"]));
  }
}), l3e = /* @__PURE__ */ U({
  __name: "PageHeadingWorkPoolCreate",
  setup(t) {
    const n = [
      { text: "Work Pools", to: je().workPools() },
      { text: "Create" }
    ];
    return (r, o) => (T(), O(nn, { crumbs: n }));
  }
}), c3e = /* @__PURE__ */ U({
  __name: "PageHeadingWorkPoolEdit",
  props: {
    workPool: {}
  },
  setup(t) {
    const e = t, n = je(), r = D(() => [
      { text: "Work Pools", to: n.workPools() },
      { text: e.workPool.name, to: n.workPool(e.workPool.name) },
      { text: "Edit" }
    ]);
    return (o, s) => (T(), O(nn, { crumbs: r.value }, null, 8, ["crumbs"]));
  }
}), p3e = /* @__PURE__ */ U({
  __name: "PageHeadingWorkPoolQueue",
  props: {
    workPoolName: {},
    workPoolQueue: {}
  },
  emits: ["update", "delete"],
  setup(t, { emit: e }) {
    const n = t, r = je(), o = rs(), { WorkPoolQueueMenu: s } = Vn(), i = e, u = D(() => [
      { text: "Work Pools", to: r.workPools() },
      { text: n.workPoolName, to: r.workPool(n.workPoolName) },
      { text: n.workPoolQueue.name }
    ]), l = () => {
      o.back();
    };
    return (a, c) => (T(), O(v(nn), {
      class: "page-heading-work-pool-queue",
      crumbs: u.value
    }, {
      actions: k(() => [
        w(v(IR), {
          "work-pool-queue": a.workPoolQueue,
          "work-pool-name": a.workPoolName,
          onUpdate: c[0] || (c[0] = (p) => i("update"))
        }, null, 8, ["work-pool-queue", "work-pool-name"]),
        w(v(s), {
          "work-pool-queue": a.workPoolQueue,
          "work-pool-name": a.workPoolName,
          "show-all": !v(_s).sm,
          onDelete: l
        }, null, 8, ["work-pool-queue", "work-pool-name", "show-all"])
      ]),
      _: 1
    }, 8, ["crumbs"]));
  }
}), d3e = /* @__PURE__ */ U({
  __name: "PageHeadingWorkPoolQueueCreate",
  props: {
    workPoolName: {}
  },
  setup(t) {
    const e = t, n = je(), r = [
      { text: "Work Pools", to: n.workPools() },
      { text: e.workPoolName, to: n.workPool(e.workPoolName) },
      { text: "Create" }
    ];
    return (o, s) => (T(), O(nn, { crumbs: r }));
  }
}), h3e = /* @__PURE__ */ U({
  __name: "PageHeadingWorkPoolQueueEdit",
  props: {
    workPoolName: {},
    workPoolQueueName: {}
  },
  setup(t) {
    const e = t, n = je(), r = D(() => [
      { text: "Work Pools", to: n.workPools() },
      { text: e.workPoolName, to: n.workPool(e.workPoolName) },
      { text: e.workPoolQueueName, to: n.workPoolQueue(e.workPoolName, e.workPoolQueueName) },
      { text: "Edit" }
    ]);
    return (o, s) => (T(), O(nn, { crumbs: r.value }, null, 8, ["crumbs"]));
  }
}), f3e = /* @__PURE__ */ U({
  __name: "PageHeadingWorkPools",
  props: {
    hideCreateButton: { type: Boolean }
  },
  setup(t) {
    const e = [{ text: "Work Pools" }], n = Ke(), r = je();
    return (o, s) => {
      const i = P("p-button");
      return T(), O(v(nn), {
        class: "page-heading-work-pools",
        crumbs: e
      }, {
        "after-crumbs": k(() => [
          v(n).create.work_pool && !o.hideCreateButton ? (T(), O(i, {
            key: 0,
            size: "sm",
            icon: "PlusIcon",
            to: v(r).workPoolCreate()
          }, null, 8, ["to"])) : j("", !0)
        ]),
        _: 1
      });
    };
  }
}), m3e = /* @__PURE__ */ U({
  __name: "PageHeadingWorkspaceSettings",
  setup(t) {
    const e = [{ text: "Settings" }];
    return (n, r) => (T(), O(nn, {
      class: "page-heading-workspace-settings",
      crumbs: e
    }));
  }
}), y3e = { class: "deployment-parameters-table" }, g3e = { class: "deployment-parameters-table__search" }, v3e = /* @__PURE__ */ U({
  __name: "ParametersTable",
  props: {
    deployment: {}
  },
  setup(t) {
    const e = t, n = [
      { label: "Key", property: "key", width: "200px" },
      { label: "Override", property: "value" },
      { label: "Default", property: "defaultValue" },
      { label: "Type", property: "type", width: "80px" }
    ], r = ge(""), o = D(() => e.deployment.parameterOpenApiSchema.properties ?? {}), s = D(() => Object.entries(o.value).map(([a, c]) => ({
      key: a,
      value: e.deployment.parameters[a],
      defaultValue: c.default,
      type: c.type,
      position: c.position ?? 0
    })).sort((a, c) => a.position - c.position)), i = D(() => r.value.length === 0 ? s.value : s.value.filter(u));
    function u({ key: a, value: c, defaultValue: p, type: d }) {
      return `${a} ${c} ${p} ${d}`.toLowerCase().includes(r.value.toLowerCase());
    }
    function l() {
      r.value = "";
    }
    return (a, c) => {
      const p = P("p-button"), d = P("p-table");
      return T(), z("div", y3e, [
        re("div", g3e, [
          w(Uo, {
            count: i.value.length,
            label: "parameter"
          }, null, 8, ["count"]),
          w(Wo, {
            modelValue: r.value,
            "onUpdate:modelValue": c[0] || (c[0] = (h) => r.value = h),
            placeholder: "Search parameters",
            label: "Search parameters"
          }, null, 8, ["modelValue"])
        ]),
        w(d, {
          data: i.value,
          columns: n
        }, {
          "empty-state": k(() => [
            w(v(el), null, Ut({ _: 2 }, [
              r.value.length ? {
                name: "actions",
                fn: k(() => [
                  w(p, {
                    size: "sm",
                    onClick: l
                  }, {
                    default: k(() => [...c[1] || (c[1] = [
                      q(" Clear Filters ", -1)
                    ])]),
                    _: 1
                  })
                ]),
                key: "0"
              } : void 0
            ]), 1024)
          ]),
          _: 1
        }, 8, ["data"])
      ]);
    };
  }
}), dX = /* @__PURE__ */ U({
  __name: "ProcessTypeBadge",
  props: {
    typeLabel: {}
  },
  setup(t) {
    return (e, n) => {
      const r = P("p-icon"), o = P("p-tag");
      return T(), O(o, { class: "process-type-badge" }, {
        default: k(() => [
          w(r, { icon: "CogIcon" }),
          re("span", null, ie(e.typeLabel), 1)
        ]),
        _: 1
      });
    };
  }
}), _3e = /* @__PURE__ */ U({
  __name: "ResourceLink",
  props: {
    resource: {}
  },
  setup(t) {
    const e = t, { resource: n } = Nn(e), { id: r, name: o, role: s, resourceId: i } = Cs(n), u = je(), l = D(() => {
      if (r.value)
        switch (s.value) {
          case "work-queue":
            return u.workQueue(r.value);
          case "work-pool":
            return o.value ? u.workPool(o.value) : u.workPools();
          case "flow-run":
            return u.flowRun(r.value);
          case "automation":
            return u.automation(r.value);
          case "flow":
            return u.flow(r.value);
          case "deployment":
            return u.deployment(r.value);
          case "task-run":
            return u.taskRun(r.value);
          case "block-document":
            return u.block(r.value);
          case "concurrency-limit":
            return u.concurrencyLimit(r.value);
          case "artifact-collection":
            return u.artifactKey(r.value);
          default:
            return;
        }
    });
    return (a, c) => {
      const p = P("p-link");
      return T(), O(p, { to: l.value }, {
        default: k(() => [
          Ve(a.$slots, "default", sn(kn({ id: v(r), name: v(o), role: v(s), resourceId: v(i) })))
        ]),
        _: 3
      }, 8, ["to"]);
    };
  }
}), hX = /* @__PURE__ */ U({
  inheritAttrs: !1,
  __name: "RunMenu",
  props: {
    deployment: {}
  },
  setup(t) {
    const e = ge(), n = ge(), r = [qr.bottomRight, qr.bottomLeft, qr.topRight, qr.topLeft], { showModal: o, open: s } = St();
    function i() {
      e.value && e.value.close();
    }
    function u() {
      i(), n.value?.el && n.value.el.focus();
    }
    return (l, a) => {
      const c = P("p-overflow-menu");
      return T(), z(ve, null, [
        w(v(Hv), {
          ref_key: "popOver",
          ref: e,
          class: "run-menu",
          "auto-close": "",
          placement: r,
          onKeydown: PI(u, ["esc"])
        }, {
          target: k(({ toggle: p }) => [
            w(v(Zo), yt(l.$attrs, {
              ref_key: "runButton",
              ref: n,
              class: "run-menu__run-button",
              "icon-append": "PlayIcon",
              solid: "",
              disabled: l.deployment.deprecated || l.deployment.disabled,
              onClick: p
            }), {
              default: k(() => [...a[1] || (a[1] = [
                q(" Run ", -1)
              ])]),
              _: 1
            }, 16, ["disabled", "onClick"])
          ]),
          default: k(() => [
            w(c, {
              class: "run-menu__overflow-menu",
              onClick: i
            }, {
              default: k(() => [
                w(v(lS), {
                  deployment: l.deployment,
                  "open-modal": v(s)
                }, null, 8, ["deployment", "open-modal"]),
                w(v(sS), { deployment: l.deployment }, null, 8, ["deployment"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 512),
        w(v(iS), {
          showModal: v(o),
          "onUpdate:showModal": a[0] || (a[0] = (p) => Xe(o) ? o.value = p : null),
          deployment: l.deployment
        }, null, 8, ["showModal", "deployment"])
      ], 64);
    };
  }
}), w3e = { key: 0 }, b3e = { class: "schedule-form-modal__parameters-container" }, iw = /* @__PURE__ */ U({
  inheritAttrs: !1,
  __name: "ScheduleFormModal",
  props: {
    slug: {},
    active: { type: [Boolean, null] },
    schedule: {},
    jobVariables: {},
    deploymentParameters: {},
    scheduleParameters: {},
    parameterOpenApiSchema: {},
    deployment: {},
    deploymentScheduleId: {}
  },
  emits: ["submit"],
  setup(t, { expose: e, emit: n }) {
    const { showModal: r, open: o, close: s } = St();
    e({ publicOpen: () => {
      o();
    } });
    const u = t, l = Ke(), a = ge(u.slug), c = ge(u.active ?? !0), { validate: p } = Ms(), d = async (J) => f8(J) || Ps(J) || !u.deployment ? !0 : u.deployment.schedules.some(
      (oe) => oe.slug !== null && u.deploymentScheduleId !== oe.id && oe.slug === J
    ) ? le.error.scheduleSlugAlreadyExists : !0, { state: h, error: m } = bn(
      a,
      "Slug",
      [f_, d]
    ), g = ge(
      u.jobVariables ? or(u.jobVariables) : void 0
    ), _ = n, b = ge(u.scheduleParameters ?? {}), x = ge(Object.keys(b.value)), S = D(
      () => u.parameterOpenApiSchema?.properties ?? {}
    ), E = D(() => Object.keys(S.value)), A = D(
      () => E.value.filter(
        (J) => !x.value.includes(J)
      )
    ), C = D(() => ({
      ...u.parameterOpenApiSchema,
      required: [],
      properties: R1(S.value, A.value)
    }));
    Ct(r, () => {
      r.value && (b.value = u.scheduleParameters ?? {}, x.value = Object.keys(b.value), a.value = u.slug ?? null);
    }), Ct(A, () => {
      const J = R1(b.value, A.value), oe = R1(
        u.deploymentParameters,
        A.value
      );
      b.value = $t(oe, J);
    });
    const M = D(
      () => !ru(u.parameterOpenApiSchema?.properties ?? {})
    ), { errors: L, validate: X } = Xh(
      C,
      b
    );
    async function te(J) {
      if (!await p() || !await X())
        return;
      let me;
      l.access.deploymentScheduleFlowRunInfraOverrides ? me = g.value ? JSON.parse(g.value) : void 0 : me = void 0;
      const pe = ru(b.value) ? void 0 : b.value, Be = {
        active: c.value,
        schedule: J,
        jobVariables: me,
        parameters: pe,
        slug: a.value ?? null
      };
      _("submit", Be), s();
    }
    const B = ge(!1), W = ge(!1), G = D(() => Y.value === "rrule" || Y.value === "cron" && B.value || Y.value === "interval" && W.value), ne = async () => {
      let J = null;
      G.value || (Y.value === "cron" && de.value ? J = de.value : Y.value === "interval" && V.value && (J = V.value), await te(J));
    }, de = ge(
      um(u.schedule) ? u.schedule : void 0
    ), V = ge(
      lm(u.schedule) ? u.schedule : void 0
    ), Y = ge(
      Vee(u.schedule) ?? "interval"
    ), Q = [
      { label: "Interval", value: "interval" },
      { label: "Cron", value: "cron" },
      { label: "RRule", value: "rrule" }
    ], ae = () => {
      de.value = um(u.schedule) ? u.schedule : void 0, V.value = lm(u.schedule) ? u.schedule : void 0, c.value = u.active ?? !0, g.value = u.jobVariables ? or(u.jobVariables) : void 0;
    };
    Ct(() => u.schedule, ae);
    function Z(J) {
      J || ae();
    }
    return (J, oe) => {
      const ue = P("p-text-input"), me = P("p-label"), pe = P("p-button-group"), Be = P("p-toggle"), Ie = P("p-divider"), Me = P("p-overflow-menu-item"), fe = P("p-icon-button-menu"), Te = P("p-combobox"), Ae = P("p-button"), we = P("p-modal");
      return T(), z(ve, null, [
        Ve(J.$slots, "default", {
          open: v(o),
          close: v(s)
        }),
        w(we, {
          showModal: v(r),
          "onUpdate:showModal": [
            oe[10] || (oe[10] = ($e) => Xe(r) ? r.value = $e : null),
            Z
          ],
          title: J.schedule ? "Edit schedule" : "Add schedule"
        }, {
          actions: k(() => [
            w(Ae, {
              variant: "default",
              type: "submit",
              disabled: G.value,
              onClick: ne
            }, {
              default: k(() => [...oe[11] || (oe[11] = [
                q(" Save ", -1)
              ])]),
              _: 1
            }, 8, ["disabled"])
          ]),
          default: k(() => [
            w(me, {
              label: "Slug (Optional)",
              message: v(m),
              state: v(h)
            }, {
              default: k(() => [
                w(ue, {
                  modelValue: a.value,
                  "onUpdate:modelValue": oe[0] || (oe[0] = ($e) => a.value = $e),
                  placeholder: "Enter a unique identifier for this schedule",
                  state: v(h)
                }, null, 8, ["modelValue", "state"])
              ]),
              _: 1
            }, 8, ["message", "state"]),
            w(me, { label: "Schedule type" }, {
              default: k(() => [
                w(pe, {
                  modelValue: Y.value,
                  "onUpdate:modelValue": oe[1] || (oe[1] = ($e) => Y.value = $e),
                  options: Q,
                  small: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            w(me, { label: "Active" }, {
              default: k(() => [
                w(Be, {
                  modelValue: c.value,
                  "onUpdate:modelValue": oe[2] || (oe[2] = ($e) => c.value = $e)
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            Y.value == "rrule" ? (T(), z("p", w3e, " Sorry, modifying RRule schedules via the UI is currently unsupported; select a different schedule type above or modify your schedule in code. ")) : Y.value == "cron" ? (T(), O(L4, {
              key: 1,
              schedule: de.value,
              "onUpdate:schedule": oe[3] || (oe[3] = ($e) => de.value = $e),
              disabled: B.value,
              "onUpdate:disabled": oe[4] || (oe[4] = ($e) => B.value = $e),
              "hide-actions": "",
              onSubmit: te
            }, null, 8, ["schedule", "disabled"])) : Y.value == "interval" ? (T(), O(eX, {
              key: 2,
              schedule: V.value,
              "onUpdate:schedule": oe[5] || (oe[5] = ($e) => V.value = $e),
              disabled: W.value,
              "onUpdate:disabled": oe[6] || (oe[6] = ($e) => W.value = $e),
              "hide-actions": "",
              onSubmit: te
            }, null, 8, ["schedule", "disabled"])) : j("", !0),
            v(l).access.deploymentScheduleFlowRunInfraOverrides ? (T(), O(L_, {
              key: 3,
              modelValue: g.value,
              "onUpdate:modelValue": oe[7] || (oe[7] = ($e) => g.value = $e)
            }, null, 8, ["modelValue"])) : j("", !0),
            M.value ? (T(), z(ve, { key: 4 }, [
              w(Ie),
              w(v(Uh), {
                values: b.value,
                "onUpdate:values": oe[9] || (oe[9] = ($e) => b.value = $e),
                schema: C.value,
                errors: v(L),
                kinds: ["none", "json"]
              }, {
                default: k(({ kind: $e, setKind: ze }) => [
                  re("div", b3e, [
                    re("h3", null, ie(v(le).info.parameterOverrides), 1),
                    w(fe, { small: "" }, {
                      default: k(() => [
                        $e === "json" ? (T(), O(Me, {
                          key: 0,
                          label: "Use form input",
                          onClick: (Ue) => ze("none")
                        }, null, 8, ["onClick"])) : j("", !0),
                        $e === "none" ? (T(), O(Me, {
                          key: 1,
                          label: "Use JSON input",
                          onClick: (Ue) => ze("json")
                        }, null, 8, ["onClick"])) : j("", !0)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  $e !== "json" ? (T(), O(Te, {
                    key: 0,
                    modelValue: x.value,
                    "onUpdate:modelValue": oe[8] || (oe[8] = (Ue) => x.value = Ue),
                    options: E.value,
                    "empty-message": "Select parameters to override for this schedule"
                  }, null, 8, ["modelValue", "options"])) : j("", !0)
                ]),
                _: 1
              }, 8, ["values", "schema", "errors"])
            ], 64)) : j("", !0)
          ]),
          _: 1
        }, 8, ["showModal", "title"])
      ], 64);
    };
  }
}), k3e = { class: "schedule-fieldset" }, T3e = {
  key: 0,
  class: "schedule-fieldset__schedule"
}, x3e = {
  key: 1,
  class: "schedule-fieldset__buttons"
}, S3e = /* @__PURE__ */ U({
  __name: "ScheduleFieldset",
  props: {
    modelValue: {},
    loading: { type: Boolean },
    readonly: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(t, { emit: e }) {
    const n = t, r = e, o = D({
      get() {
        return n.modelValue;
      },
      set(u) {
        r("update:modelValue", u);
      }
    }), s = (u) => {
      o.value = u.schedule;
    }, i = () => {
      o.value = null;
    };
    return (u, l) => {
      const a = P("p-button");
      return T(), z("div", k3e, [
        o.value ? (T(), z("div", T3e, ie(o.value.toString({ verbose: !0 })), 1)) : j("", !0),
        u.readonly ? j("", !0) : (T(), z("div", x3e, [
          w(iw, {
            slug: null,
            active: null,
            schedule: o.value,
            "job-variables": {},
            "deployment-parameters": {},
            "schedule-parameters": {},
            "parameter-open-api-schema": {},
            onSubmit: s
          }, {
            default: k(({ open: c }) => [
              w(a, {
                size: "sm",
                icon: "PencilIcon",
                class: "schedule-fieldset__button",
                disabled: u.loading,
                onClick: c
              }, {
                default: k(() => [
                  q(ie(o.value ? "Edit" : "Add"), 1)
                ]),
                _: 1
              }, 8, ["disabled", "onClick"])
            ]),
            _: 1
          }, 8, ["schedule"]),
          o.value ? (T(), O(a, {
            key: 0,
            size: "sm",
            class: "schedule-fieldset__button",
            icon: "TrashIcon",
            disabled: u.loading,
            onClick: i
          }, {
            default: k(() => [...l[0] || (l[0] = [
              q(" Remove ", -1)
            ])]),
            _: 1
          }, 8, ["disabled"])) : j("", !0)
        ]))
      ]);
    };
  }
}), R3e = /* @__PURE__ */ U({
  __name: "SchemaForm",
  props: {
    modelValue: {},
    schema: {}
  },
  emits: ["update:modelValue", "submit"],
  setup(t, { emit: e }) {
    const n = t, r = e, o = D({
      get() {
        return n.modelValue ?? {};
      },
      set(u) {
        r("update:modelValue", u);
      }
    }), { handleSubmit: s } = T2(o, { initialValues: { ...n.modelValue } }), i = s((u) => r("submit", u));
    return (u, l) => {
      const a = P("p-button"), c = P("p-form");
      return T(), O(c, { onSubmit: v(i) }, {
        footer: k(() => [
          w(a, {
            variant: "default",
            type: "submit"
          }, {
            default: k(() => [...l[0] || (l[0] = [
              q(" Save ", -1)
            ])]),
            _: 1
          })
        ]),
        default: k(() => [
          w(ed, { schema: u.schema }, null, 8, ["schema"])
        ]),
        _: 1
      }, 8, ["onSubmit"]);
    };
  }
}), fX = /* @__PURE__ */ U({
  __name: "SchemaFormFieldsWithValues",
  props: {
    schema: {},
    values: {}
  },
  emits: ["update:values"],
  setup(t, { emit: e }) {
    const n = t, r = e, o = D({
      get() {
        return n.values ? ye.map("SchemaValuesResponse", { values: n.values, schema: n.schema }, "SchemaValues") : Bh(n.schema);
      },
      set(u) {
        r("update:values", ye.map("SchemaValues", { values: u, schema: n.schema }, "SchemaValuesRequest"));
      }
    }), { validate: s, errors: i } = T2(o, {
      initialValues: o.value
    });
    return bn(o, "Parameters", async () => (await s(), Object.entries(i.value).length === 0)), (u, l) => (T(), O(ed, {
      schema: u.schema,
      class: "schema-form-fields"
    }, null, 8, ["schema"]));
  }
}), A3e = {
  key: 0,
  class: "schema-input__button-group"
}, D3e = /* @__PURE__ */ U({
  __name: "SchemaInput",
  props: {
    modelValue: {},
    schema: {},
    inputType: {},
    disableInputTypes: { type: Boolean }
  },
  emits: ["update:modelValue", "update:inputType"],
  setup(t, { emit: e }) {
    const n = t, r = e, o = D(() => !ru(n.schema.properties ?? {})), s = [
      { value: "form", label: le.info.form },
      { value: "json", label: le.info.json }
    ], i = ge(n.inputType ?? "form"), u = D({
      get() {
        return Qv(n.inputType) ? n.inputType : i.value;
      },
      set(S) {
        i.value = S, r("update:inputType", S);
      }
    }), l = D({
      get() {
        return Gt(n.modelValue) || ru(n.modelValue) ? Bh(n.schema) : n.modelValue;
      },
      set(S) {
        r("update:modelValue", S);
      }
    }), a = h(l.value), c = ge(or(a)), { state: p, error: d } = bn(c, qp("parameters", ml));
    function h(S) {
      return ye.map("SchemaValues", { values: S, schema: n.schema }, "SchemaValuesRequest");
    }
    function m(S) {
      return ye.map("SchemaValuesResponse", { values: S, schema: n.schema }, "SchemaValues");
    }
    const { validate: g, errors: _ } = T2(l, {
      initialValues: l.value
    });
    bn(l, le.info.values, async () => u.value === "json" ? !0 : (await g(), ru(_.value)));
    function b() {
      const S = h(l.value);
      c.value = or(S);
    }
    function x() {
      const { value: S, success: E } = jN(c.value);
      E && (l.value = m(S));
    }
    return Ct(u, (S, E) => {
      if (S === "form")
        return x();
      if (S === "json" || E === "form")
        return b();
      if (E === "json")
        return x();
    }), (S, E) => {
      const A = P("p-button-group"), C = P("p-code-input"), M = P("p-label"), L = P("p-content");
      return T(), O(L, { class: "schema-input" }, {
        default: k(() => [
          S.disableInputTypes ? j("", !0) : (T(), z("div", A3e, [
            Ve(S.$slots, "button-group", {}, () => [
              w(A, {
                modelValue: u.value,
                "onUpdate:modelValue": E[0] || (E[0] = (X) => u.value = X),
                options: s,
                small: ""
              }, null, 8, ["modelValue"])
            ])
          ])),
          S.modelValue && o.value ? (T(), O(hx, { key: 1 }, [
            u.value === "form" ? (T(), O(v(ed), {
              key: 0,
              schema: S.schema
            }, null, 8, ["schema"])) : u.value === "json" ? (T(), O(M, {
              key: 1,
              state: v(p),
              message: v(d)
            }, {
              default: k(() => [
                w(C, {
                  modelValue: c.value,
                  "onUpdate:modelValue": E[1] || (E[1] = (X) => c.value = X),
                  lang: "json",
                  "min-lines": 3,
                  "show-line-numbers": "",
                  onFocusout: x
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["state", "message"])) : Ve(S.$slots, "null-input-type", { key: 2 })
          ], 1024)) : Ve(S.$slots, "empty", { key: 2 }, () => [
            re("em", null, ie(v(le).info.schemaHasNoProperties), 1)
          ])
        ]),
        _: 3
      });
    };
  }
}), E3e = { class: "task-run-artifacts" }, M3e = { class: "task-run-artifacts__button-group-container" }, P3e = /* @__PURE__ */ U({
  __name: "TaskRunArtifacts",
  props: {
    taskRun: {}
  },
  setup(t) {
    const e = t, n = D(() => kp.value !== "grid"), r = Se(), o = je(), s = D(() => ({
      artifacts: {
        taskRunId: [e.taskRun.id],
        notType: ["result"]
      }
    })), i = D(() => e.taskRun.state?.name ?? null), u = x2(i, 1e4), l = mt(r.artifacts.getArtifacts, [s], u), a = D(() => l.response ?? []), c = D(() => fi(e.taskRun.state?.type)), p = D(() => l.executed && a.value.length === 0 ? c.value ? le.info.terminalTaskRunNoArtifacts : le.info.nonTerminalTaskRunNoArtifacts : "");
    return (d, h) => {
      const m = P("router-link"), g = P("p-markdown-renderer"), _ = P("p-empty-state");
      return T(), z("div", E3e, [
        re("div", M3e, [
          Ve(d.$slots, "actions"),
          w(S_, { class: "task-run-artifacts__view-mode-button-group" })
        ]),
        w(W0, { items: a.value }, Ut({
          default: k(({ item: b }) => [
            w(m, {
              to: v(o).artifact(b.id)
            }, {
              default: k(() => [
                w(hh, {
                  artifact: b,
                  condense: n.value,
                  interactive: ""
                }, null, 8, ["artifact", "condense"])
              ]),
              _: 2
            }, 1032, ["to"])
          ]),
          _: 2
        }, [
          v(l).executed ? {
            name: "empty",
            fn: k(() => [
              w(_, null, {
                description: k(() => [
                  w(g, { text: p.value }, null, 8, ["text"])
                ]),
                _: 1
              })
            ]),
            key: "0"
          } : void 0
        ]), 1032, ["items"])
      ]);
    };
  }
}), C3e = { class: "task-run-details" }, O3e = /* @__PURE__ */ U({
  __name: "TaskRunDetails",
  props: {
    taskRun: {},
    alternate: { type: Boolean }
  },
  setup(t) {
    const e = t, { result: n } = kse(e.taskRun.id), r = D(() => e.alternate ? 6 : 5);
    return (o, s) => {
      const i = P("p-markdown-renderer"), u = P("p-divider"), l = P("p-heading");
      return T(), z("div", C3e, [
        o.taskRun.flowRunId ? (T(), O(v(Lt), {
          key: 0,
          label: "Flow Run",
          alternate: o.alternate
        }, {
          value: k(() => [
            w(ty, {
              "flow-run-id": o.taskRun.flowRunId
            }, null, 8, ["flow-run-id"])
          ]),
          _: 1
        }, 8, ["alternate"])) : j("", !0),
        o.taskRun.startTime ? (T(), O(v(Lt), {
          key: 1,
          label: "Start Time",
          alternate: o.alternate
        }, {
          value: k(() => [
            w(hn, {
              date: o.taskRun.startTime,
              format: "numeric"
            }, null, 8, ["date"])
          ]),
          _: 1
        }, 8, ["alternate"])) : j("", !0),
        w(v(Lt), {
          label: "Duration",
          alternate: o.alternate
        }, {
          value: k(() => [
            w(Cc, {
              duration: o.taskRun.duration
            }, null, 8, ["duration"])
          ]),
          _: 1
        }, 8, ["alternate"]),
        w(v(Lt), {
          label: "Run Count",
          value: o.taskRun.runCount ?? 0,
          alternate: o.alternate
        }, null, 8, ["value", "alternate"]),
        w(v(Lt), {
          label: "Estimated Run Time",
          value: v(fc)(o.taskRun.estimatedRunTime ?? 0),
          alternate: o.alternate
        }, null, 8, ["value", "alternate"]),
        w(v(Lt), {
          label: "Created",
          alternate: o.alternate
        }, {
          value: k(() => [
            w(hn, {
              date: o.taskRun.created,
              format: "numeric"
            }, null, 8, ["date"])
          ]),
          _: 1
        }, 8, ["alternate"]),
        w(v(Lt), {
          label: "Last Updated",
          alternate: o.alternate
        }, {
          value: k(() => [
            w(hn, {
              date: o.taskRun.updated,
              format: "numeric"
            }, null, 8, ["date"])
          ]),
          _: 1
        }, 8, ["alternate"]),
        w(v(Lt), {
          label: "Cache Key",
          value: o.taskRun.cacheKey,
          alternate: o.alternate
        }, null, 8, ["value", "alternate"]),
        w(v(Lt), {
          label: "Cache Expiration",
          value: o.taskRun.cacheExpiration,
          alternate: o.alternate
        }, null, 8, ["value", "alternate"]),
        w(v(Lt), {
          label: "Dynamic Key",
          value: o.taskRun.dynamicKey,
          alternate: o.alternate
        }, null, 8, ["value", "alternate"]),
        w(v(Lt), {
          label: "Task Run ID",
          value: o.taskRun.id,
          alternate: o.alternate
        }, null, 8, ["value", "alternate"]),
        v(n) ? (T(), O(v(Lt), {
          key: 2,
          label: v(le).info.result,
          alternate: o.alternate
        }, Ut({ _: 2 }, [
          v(n).description ? {
            name: "value",
            fn: k(() => [
              v(n).description ? (T(), O(i, {
                key: 0,
                text: v(n).description,
                class: "task-run-details__markdown-renderer"
              }, null, 8, ["text"])) : j("", !0)
            ]),
            key: "0"
          } : void 0
        ]), 1032, ["label", "alternate"])) : j("", !0),
        w(u),
        w(l, { heading: r.value }, {
          default: k(() => [...s[0] || (s[0] = [
            q(" Task configuration ", -1)
          ])]),
          _: 1
        }, 8, ["heading"]),
        w(v(Lt), {
          label: "Version",
          value: o.taskRun.taskVersion,
          alternate: o.alternate
        }, null, 8, ["value", "alternate"]),
        w(v(Lt), {
          label: "Retries",
          value: o.taskRun.empiricalPolicy?.retries,
          alternate: o.alternate
        }, null, 8, ["value", "alternate"]),
        w(v(Lt), {
          label: "Retry Delay",
          value: v(fc)(o.taskRun.empiricalPolicy?.retryDelay ?? 0),
          alternate: o.alternate
        }, null, 8, ["value", "alternate"]),
        w(v(Lt), {
          label: "Retry Jitter Factor",
          value: o.taskRun.empiricalPolicy?.retryJitterFactor,
          alternate: o.alternate
        }, null, 8, ["value", "alternate"]),
        w(v(Lt), {
          label: "Tags",
          alternate: o.alternate
        }, Ut({ _: 2 }, [
          o.taskRun.tags?.length ? {
            name: "value",
            fn: k(() => [
              w(v(am), {
                tags: o.taskRun.tags
              }, null, 8, ["tags"])
            ]),
            key: "0"
          } : void 0
        ]), 1032, ["alternate"])
      ]);
    };
  }
}), I3e = { class: "task-run-logs" }, F3e = { class: "task-run-logs__search" }, N3e = { key: 0 }, L3e = { key: 1 }, B3e = { key: 2 }, U3e = { key: 3 }, X3e = /* @__PURE__ */ U({
  __name: "TaskRunLogs",
  props: {
    taskRun: {}
  },
  setup(t) {
    const e = t, n = ge(0), { sort: r } = wN(), o = D(() => n.value !== 0), s = D(() => ({
      logs: {
        taskRunId: [e.taskRun.id],
        levelGreaterThan: n.value
      },
      sort: r.value
    })), i = Se(), u = D(() => e.taskRun.state?.name ?? null), l = x2(u), a = k2(i.logs.getLogs, [s], l), c = D(() => a.response ?? []);
    function p() {
      n.value = 0;
    }
    return (d, h) => {
      const m = P("p-button"), g = P("p-empty-results");
      return T(), z("div", I3e, [
        re("div", F3e, [
          w(TR, {
            selected: n.value,
            "onUpdate:selected": h[0] || (h[0] = (_) => n.value = _)
          }, null, 8, ["selected"]),
          w(SR, {
            selected: v(r),
            "onUpdate:selected": h[1] || (h[1] = (_) => Xe(r) ? r.value = _ : null)
          }, null, 8, ["selected"])
        ]),
        w(xR, {
          logs: c.value,
          onBottom: v(a).loadMore
        }, {
          empty: k(() => [
            w(g, null, Ut({
              message: k(() => [
                n.value > 0 ? (T(), z("div", N3e, " No logs match your filter criteria ")) : d.taskRun.stateType == "scheduled" ? (T(), z("div", L3e, " This run is scheduled and hasn't generated logs ")) : d.taskRun.stateType == "running" ? (T(), z("div", B3e, " Waiting for logs... ")) : (T(), z("div", U3e, " This run didn't generate Logs "))
              ]),
              _: 2
            }, [
              o.value ? {
                name: "actions",
                fn: k(() => [
                  w(m, {
                    size: "sm",
                    onClick: p
                  }, {
                    default: k(() => [...h[2] || (h[2] = [
                      q(" Clear Filters ", -1)
                    ])]),
                    _: 1
                  })
                ]),
                key: "0"
              } : void 0
            ]), 1024)
          ]),
          _: 1
        }, 8, ["logs", "onBottom"])
      ]);
    };
  }
}), mX = /* @__PURE__ */ U({
  inheritAttrs: !1,
  __name: "TaskRunMenu",
  props: {
    taskRun: {}
  },
  emits: ["delete", "update"],
  setup(t, { emit: e }) {
    const n = e, r = Ke(), o = Se(), s = D(() => !!(r.update.task_run && t.taskRun.stateType && fi(t.taskRun.stateType))), { showModal: i, open: u } = St(), { showModal: l, open: a } = St(), c = async () => {
      await Ua(t.taskRun.id, o.taskRuns.deleteTaskRun, "Task run"), n("delete", t.taskRun.id);
    }, p = async (d) => {
      try {
        await o.taskRuns.setTaskRunState(t.taskRun.id, { state: d }), n("update"), He(le.success.changeTaskRunState, "success");
      } catch (h) {
        console.error(h);
        const m = Yt(h, le.error.changeTaskRunState);
        He(m, "error");
      }
    };
    return (d, h) => {
      const m = P("p-overflow-menu-item"), g = P("p-icon-button-menu");
      return T(), z(ve, null, [
        w(g, yt({ class: "task-run-menu" }, d.$attrs), {
          default: k(() => [
            s.value ? (T(), O(m, {
              key: 0,
              label: "Change state",
              onClick: v(u)
            }, null, 8, ["onClick"])) : j("", !0),
            w(v(uo), {
              label: "Copy ID",
              item: d.taskRun.id
            }, null, 8, ["item"]),
            v(r).delete.task_run ? (T(), O(m, {
              key: 1,
              label: "Delete",
              onClick: v(a)
            }, null, 8, ["onClick"])) : j("", !0)
          ]),
          _: 1
        }, 16),
        w(v(_r), {
          showModal: v(l),
          "onUpdate:showModal": h[0] || (h[0] = (_) => Xe(l) ? l.value = _ : null),
          label: "Task Run",
          name: d.taskRun.name,
          onDelete: h[1] || (h[1] = () => c())
        }, null, 8, ["showModal", "name"]),
        w(v(z2), {
          showModal: v(i),
          "onUpdate:showModal": h[2] || (h[2] = (_) => Xe(i) ? i.value = _ : null),
          run: d.taskRun,
          label: "Task Run",
          onChange: p
        }, null, 8, ["showModal", "run"])
      ], 64);
    };
  }
}), $3e = /* @__PURE__ */ U({
  __name: "TaskRunsDeleteButton",
  props: {
    selected: {}
  },
  emits: ["delete"],
  setup(t, { emit: e }) {
    const n = e, { showModal: r, open: o, close: s } = St(), i = Se(), u = async (l) => {
      const a = D(() => l.length === 1 ? "Task run deleted" : `${l.length} flow runs deleted`);
      s();
      try {
        const c = l.map(i.taskRuns.deleteTaskRun);
        await Promise.all(c), He(a, "success"), n("delete");
      } catch (c) {
        const p = Yt(c, le.error.delete("Task run"));
        He(p, "error");
      }
    };
    return (l, a) => {
      const c = P("p-button");
      return T(), z(ve, null, [
        w(mx, { name: "task-runs-delete-button-transition" }, {
          default: k(() => [
            l.selected.length > 0 ? (T(), O(c, {
              key: 0,
              icon: "TrashIcon",
              small: "",
              onClick: v(o)
            }, null, 8, ["onClick"])) : j("", !0)
          ]),
          _: 1
        }),
        w(_r, {
          showModal: v(r),
          "onUpdate:showModal": a[0] || (a[0] = (p) => Xe(r) ? r.value = p : null),
          name: "selected task runs",
          label: "Task runs",
          onDelete: a[1] || (a[1] = () => u(l.selected))
        }, null, 8, ["showModal"])
      ], 64);
    };
  }
}), yX = /* @__PURE__ */ U({
  __name: "TaskRunsSort",
  props: {
    modelValue: {}
  },
  emits: ["update:modelValue"],
  setup(t, { emit: e }) {
    const n = t, r = e, o = D({
      get() {
        return n.modelValue;
      },
      set(i) {
        r("update:modelValue", i);
      }
    }), s = [
      { label: "Newest to Oldest", value: "EXPECTED_START_TIME_DESC" },
      { label: "Oldest to Newest", value: "EXPECTED_START_TIME_ASC" }
    ];
    return (i, u) => (T(), O(v(Om), {
      modelValue: o.value,
      "onUpdate:modelValue": u[0] || (u[0] = (l) => o.value = l),
      options: s
    }, null, 8, ["modelValue"]));
  }
}), W3e = /* @__PURE__ */ U({
  __name: "TimeSpanFilter",
  props: {
    selected: {},
    small: { type: Boolean }
  },
  emits: ["update:selected"],
  setup(t, { emit: e }) {
    const n = t, r = e, o = D({
      get: () => n.selected,
      set: (i) => r("update:selected", i)
    }), s = [
      { label: "8h", value: ac * 8 },
      { label: "24h", value: ic },
      { label: "1w", value: Ih }
    ];
    return (i, u) => {
      const l = P("p-button-group");
      return T(), O(l, {
        modelValue: o.value,
        "onUpdate:modelValue": u[0] || (u[0] = (a) => o.value = a),
        small: i.small,
        options: s,
        class: "time-span-filter"
      }, null, 8, ["modelValue", "small"]);
    };
  }
}), PR = /* @__PURE__ */ U({
  __name: "VariableEditModal",
  props: {
    variable: {},
    showModal: { type: Boolean }
  },
  emits: ["update:showModal", "update"],
  setup(t, { emit: e }) {
    const n = t, r = e, o = D({
      get() {
        return n.showModal;
      },
      set(x) {
        r("update:showModal", x);
      }
    }), s = Se(), i = async (x, S, { signal: E, source: A, previousValue: C }) => {
      if (x !== C && (A === "validator" && await new Promise((M) => setTimeout(M, 1e3)), !E.aborted)) {
        if (hu.isNull(x) || !Ht(x))
          return !1;
        try {
          return (await s.variables.getVariableByName(x))?.id === n.variable.id ? !0 : le.error.variableAlreadyExists;
        } catch {
          return !0;
        }
      }
    }, { validate: u, pending: l } = Ms(), a = ge(n.variable.name), c = ge(n.variable.valueString), p = ge(n.variable.tags), d = {
      name: [
        Kr(le.info.name),
        Fp(Kx)(le.info.name),
        f_,
        i
      ],
      value: [
        Kr(le.info.value),
        Fp(Zx)(le.info.value),
        ml(le.info.value)
      ]
    }, { error: h, state: m } = bn(a, le.info.name, d.name), { error: g, state: _ } = bn(c, le.info.value, d.value), b = async () => {
      if (await u())
        try {
          const S = {
            name: a.value,
            value: c.value,
            tags: p.value
          }, E = await s.variables.editVariable(n.variable.id, S);
          He(le.success.editVariable, "success"), o.value = !1, r("update", E);
        } catch (S) {
          console.error(S);
          const E = Yt(S, le.error.editVariable);
          He(E, "error");
        }
    };
    return (x, S) => {
      const E = P("p-text-input"), A = P("p-label"), C = P("p-tags-input"), M = P("p-content"), L = P("p-form"), X = P("p-button"), te = P("p-modal");
      return T(), O(te, {
        showModal: o.value,
        "onUpdate:showModal": S[3] || (S[3] = (B) => o.value = B),
        title: v(le).info.editVariable(a.value)
      }, {
        actions: k(() => [
          w(X, {
            variant: "default",
            loading: v(l),
            onClick: b
          }, {
            default: k(() => [
              q(ie(v(le).info.save), 1)
            ]),
            _: 1
          }, 8, ["loading"])
        ]),
        default: k(() => [
          w(L, { onSubmit: b }, {
            default: k(() => [
              w(M, null, {
                default: k(() => [
                  w(A, {
                    label: v(le).info.name,
                    state: v(m),
                    message: v(h)
                  }, {
                    default: k(() => [
                      w(E, {
                        modelValue: a.value,
                        "onUpdate:modelValue": S[0] || (S[0] = (B) => a.value = B),
                        state: v(m)
                      }, null, 8, ["modelValue", "state"])
                    ]),
                    _: 1
                  }, 8, ["label", "state", "message"]),
                  w(A, {
                    label: v(le).info.value,
                    state: v(_),
                    message: v(g)
                  }, {
                    default: k(() => [
                      w(Rr, {
                        modelValue: c.value,
                        "onUpdate:modelValue": S[1] || (S[1] = (B) => c.value = B),
                        state: v(_),
                        "show-format-button": ""
                      }, null, 8, ["modelValue", "state"])
                    ]),
                    _: 1
                  }, 8, ["label", "state", "message"]),
                  w(A, {
                    label: v(le).info.tags
                  }, {
                    default: k(() => [
                      w(C, {
                        modelValue: p.value,
                        "onUpdate:modelValue": S[2] || (S[2] = (B) => p.value = B)
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["showModal", "title"]);
    };
  }
}), gX = /* @__PURE__ */ U({
  __name: "VariableDuplicateModal",
  props: {
    showModal: { type: Boolean },
    variable: {}
  },
  emits: ["update:showModal", "create"],
  setup(t, { emit: e }) {
    const n = t, r = e, o = D({
      get() {
        return n.showModal;
      },
      set(x) {
        r("update:showModal", x);
      }
    }), s = Se(), i = async (x, S, { signal: E, source: A, previousValue: C }) => {
      if (x !== C && (A === "validator" && await new Promise((M) => setTimeout(M, 1e3)), !E.aborted)) {
        if (hu.isNull(x) || !Ht(x) || x.trim() === "")
          return !1;
        try {
          return await s.variables.getVariableByName(x) ? le.error.variableAlreadyExists : !0;
        } catch {
          return !0;
        }
      }
    }, { validate: u, pending: l } = Ms(), a = ge(n.variable.name + "_copy"), c = ge(n.variable.valueString ?? ""), p = ge([...n.variable.tags ?? []]);
    Ct(() => n.variable, (x) => {
      a.value = x.name + "_copy", c.value = x.valueString ?? "", p.value = [...x.tags ?? []];
    }, { deep: !0 });
    const d = {
      name: [Kr(le.info.name), Fp(Kx)(le.info.name), f_, i],
      value: [Kr(le.info.value), Fp(Zx)(le.info.value), ml(le.info.value)]
    }, { error: h, state: m } = bn(a, le.info.name, d.name), { error: g, state: _ } = bn(c, le.info.value, d.value), b = async () => {
      if (await u())
        try {
          const S = {
            name: a.value,
            value: c.value,
            tags: p.value
          }, E = await s.variables.createVariable(S);
          He(le.success.duplicateVariable, "success"), r("create", E), o.value = !1;
        } catch (S) {
          console.error(S);
          const E = Yt(S, le.error.duplicateVariable);
          He(E, "error");
        }
    };
    return (x, S) => {
      const E = P("p-text-input"), A = P("p-label"), C = P("p-tags-input"), M = P("p-content"), L = P("p-form"), X = P("p-button"), te = P("p-modal");
      return T(), O(te, {
        showModal: o.value,
        "onUpdate:showModal": S[3] || (S[3] = (B) => o.value = B),
        title: v(le).info.duplicateVariable(x.variable.name)
      }, {
        actions: k(() => [
          w(X, {
            variant: "default",
            loading: v(l),
            onClick: b
          }, {
            default: k(() => [
              q(ie(v(le).info.duplicate), 1)
            ]),
            _: 1
          }, 8, ["loading"])
        ]),
        default: k(() => [
          w(L, { onSubmit: b }, {
            default: k(() => [
              w(M, null, {
                default: k(() => [
                  w(A, {
                    label: v(le).info.name,
                    state: v(m),
                    message: v(h)
                  }, {
                    default: k(() => [
                      w(E, {
                        modelValue: a.value,
                        "onUpdate:modelValue": S[0] || (S[0] = (B) => a.value = B),
                        state: v(m)
                      }, null, 8, ["modelValue", "state"])
                    ]),
                    _: 1
                  }, 8, ["label", "state", "message"]),
                  w(A, {
                    label: v(le).info.value,
                    state: v(_),
                    message: v(g)
                  }, {
                    default: k(() => [
                      w(Rr, {
                        modelValue: c.value,
                        "onUpdate:modelValue": S[1] || (S[1] = (B) => c.value = B),
                        state: v(_),
                        "show-format-button": ""
                      }, null, 8, ["modelValue", "state"])
                    ]),
                    _: 1
                  }, 8, ["label", "state", "message"]),
                  w(A, {
                    label: v(le).info.tags
                  }, {
                    default: k(() => [
                      w(C, {
                        modelValue: p.value,
                        "onUpdate:modelValue": S[2] || (S[2] = (B) => p.value = B)
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["showModal", "title"]);
    };
  }
}), vX = /* @__PURE__ */ U({
  inheritAttrs: !1,
  __name: "VariableMenu",
  props: {
    variable: {}
  },
  emits: ["delete", "update", "create"],
  setup(t, { emit: e }) {
    const n = e, r = Ke(), { showModal: o, open: s, close: i } = St(), { showModal: u, open: l } = St(), { showModal: a, open: c } = St(), p = Se(), d = async (g) => {
      i();
      try {
        await p.variables.deleteVariable(g), He(le.success.delete(le.info.variable), "success"), n("delete", g);
      } catch (_) {
        console.error(_);
        const b = Yt(_, le.info.variable.toLowerCase());
        He(b, "error");
      }
    }, h = (g) => {
      n("update", g);
    }, m = (g) => {
      n("create", g);
    };
    return (g, _) => {
      const b = P("p-overflow-menu-item"), x = P("p-icon-button-menu");
      return T(), z(ve, null, [
        w(x, sn(kn(g.$attrs)), {
          default: k(() => [
            w(v(uo), {
              label: v(le).info.copyId,
              item: g.variable.id
            }, null, 8, ["label", "item"]),
            w(v(uo), {
              label: v(le).info.copyName,
              item: g.variable.name
            }, null, 8, ["label", "item"]),
            w(v(uo), {
              label: v(le).info.copyValue,
              item: g.variable.valueString
            }, null, 8, ["label", "item"]),
            v(r).update.variable ? (T(), O(b, {
              key: 0,
              label: v(le).info.edit,
              onClick: v(l)
            }, null, 8, ["label", "onClick"])) : j("", !0),
            w(b, {
              label: v(le).info.duplicate,
              onClick: v(c)
            }, null, 8, ["label", "onClick"]),
            v(r).delete.variable ? (T(), O(b, {
              key: 1,
              label: v(le).info.delete,
              onClick: v(s)
            }, null, 8, ["label", "onClick"])) : j("", !0)
          ]),
          _: 1
        }, 16),
        w(v(PR), {
          showModal: v(u),
          "onUpdate:showModal": _[0] || (_[0] = (S) => Xe(u) ? u.value = S : null),
          variable: g.variable,
          onUpdate: h
        }, null, 8, ["showModal", "variable"]),
        w(v(gX), {
          showModal: v(a),
          "onUpdate:showModal": _[1] || (_[1] = (S) => Xe(a) ? a.value = S : null),
          variable: g.variable,
          onCreate: m
        }, null, 8, ["showModal", "variable"]),
        w(v(_r), {
          showModal: v(o),
          "onUpdate:showModal": _[2] || (_[2] = (S) => Xe(o) ? o.value = S : null),
          label: v(le).info.delete,
          name: g.variable.name,
          onDelete: _[3] || (_[3] = (S) => d(g.variable.id))
        }, null, 8, ["showModal", "label", "name"])
      ], 64);
    };
  }
}), _X = /* @__PURE__ */ U({
  __name: "VariablesDeleteButton",
  props: {
    variableIds: {}
  },
  emits: ["delete"],
  setup(t, { emit: e }) {
    const n = t, r = e, { showModal: o, open: s, close: i } = St(), u = Se(), l = D(() => n.variableIds.length === 1 ? le.info.thisVariable : le.info.theseVariables), a = async (c) => {
      try {
        const p = c.map(u.variables.deleteVariable);
        await Promise.all(p);
        const d = le.success.delete(`${c.length} ${mc(le.info.variable, c.length)}`);
        He(d, "success"), r("delete");
      } catch (p) {
        const d = Yt(p, le.error.delete(le.info.variables));
        He(d, "error");
      } finally {
        i();
      }
    };
    return (c, p) => {
      const d = P("p-button");
      return T(), z(ve, null, [
        c.variableIds.length > 0 ? (T(), O(d, {
          key: 0,
          size: "sm",
          icon: "TrashIcon",
          onClick: v(s)
        }, null, 8, ["onClick"])) : j("", !0),
        w(_r, {
          showModal: v(o),
          "onUpdate:showModal": p[0] || (p[0] = (h) => Xe(o) ? o.value = h : null),
          name: l.value,
          label: v(le).info.variables,
          onDelete: p[1] || (p[1] = (h) => a(c.variableIds))
        }, null, 8, ["showModal", "name", "label"])
      ], 64);
    };
  }
}), V3e = /* @__PURE__ */ U({
  __name: "VariablesPageEmptyState",
  emits: ["create"],
  setup(t, { emit: e }) {
    const n = e, r = Ke(), { showModal: o, open: s } = St();
    return (i, u) => (T(), O(v(na), null, {
      icon: k(() => [
        w(v(vo), {
          icon: "VariableIcon",
          class: "variables-page-empty-state__icon"
        })
      ]),
      heading: k(() => [...u[2] || (u[2] = [
        q(" Add a variable to get started ", -1)
      ])]),
      description: k(() => [...u[3] || (u[3] = [
        q(" Variables store non-sensitive pieces of JSON. ", -1)
      ])]),
      actions: k(() => [
        v(r).create.variable ? (T(), O(v(Zo), {
          key: 0,
          primary: "",
          "icon-append": "PlusIcon",
          onClick: v(s)
        }, {
          default: k(() => [...u[4] || (u[4] = [
            q(" Add Variable ", -1)
          ])]),
          _: 1
        }, 8, ["onClick"])) : j("", !0),
        w(Os, {
          to: v(le).docs.variables
        }, null, 8, ["to"]),
        w(MR, {
          "show-modal": v(o),
          "onUpdate:showModal": u[0] || (u[0] = (l) => Xe(o) ? o.value = l : null),
          onCreate: u[1] || (u[1] = (l) => n("create"))
        }, null, 8, ["show-modal"])
      ]),
      _: 1
    }));
  }
}), H3e = /* @__PURE__ */ U({
  __name: "VariableDisplayPreview",
  props: {
    variable: {},
    valueOverflowText: {}
  },
  emits: ["update"],
  setup(t, { emit: e }) {
    const { showModal: n, open: r } = St(), o = e, s = (i) => {
      o("update", i);
    };
    return (i, u) => {
      const l = P("p-button"), a = P("p-code-highlight");
      return T(), z(ve, null, [
        u[1] || (u[1] = re("div", { class: "variable-link" }, null, -1)),
        i.variable.valueString.length > 64 ? (T(), O(l, {
          key: 0,
          size: "sm",
          onClick: v(r)
        }, {
          default: k(() => [
            q(ie(i.valueOverflowText), 1)
          ]),
          _: 1
        }, 8, ["onClick"])) : (T(), O(a, {
          key: 1,
          text: i.variable.valueString,
          lang: "json",
          inline: ""
        }, null, 8, ["text"])),
        w(PR, {
          showModal: v(n),
          "onUpdate:showModal": u[0] || (u[0] = (c) => Xe(n) ? n.value = c : null),
          variable: i.variable,
          onUpdate: s
        }, null, 8, ["showModal", "variable"])
      ], 64);
    };
  }
}), j3e = ["title"], z3e = { class: "variables-table__value" }, Jb = 25, q3e = /* @__PURE__ */ U({
  __name: "VariablesTable",
  props: {
    filter: {}
  },
  emits: ["delete", "update", "create"],
  setup(t, { expose: e, emit: n }) {
    const r = t, o = Se(), s = Ke(), i = ge(), u = ns(i, 1e3), l = ge(1), a = D(() => (l.value - 1) * Jb), c = D(() => Math.ceil((A.value ?? Jb) / Jb)), { value: p } = hl("variables-table-limit", 10), { filter: d, isCustomFilter: h, clear: m } = zoe($t({}, r.filter, {
      variables: {
        nameLike: u
      },
      offset: a
    })), g = [
      {
        property: "name",
        label: "Name",
        width: "192px"
      },
      {
        property: "value",
        label: "Value"
      },
      {
        property: "updated",
        label: "Updated",
        width: "124px"
      },
      {
        property: "tags",
        label: "Tags",
        width: "248px"
      },
      {
        label: "Action",
        width: "42px"
      }
    ];
    function _(B) {
      return {
        "variables-table__value-td": B.label === "Value"
      };
    }
    const b = ge([]), x = mt(o.variables.getVariables, [d]), S = D(() => x.response ?? []), E = mt(o.variables.getVariablesCount, [d]), A = D(() => E.response);
    function C() {
      x.refresh(), E.refresh();
    }
    e({
      refreshSubscriptions: C
    });
    const M = n, L = () => {
      b.value = [], C(), M("delete");
    }, X = (B) => {
      M("update", B);
    }, te = (B) => {
      b.value = [], C(), M("create", B);
    };
    return (B, W) => {
      const G = P("p-select"), ne = P("p-list-header"), de = P("p-tag-wrapper"), V = P("p-button"), Y = P("p-loading-icon"), Q = P("p-pager"), ae = P("p-content");
      return T(), O(ae, { class: "variables-table" }, {
        default: k(() => [
          w(ne, { sticky: "" }, {
            controls: k(() => [
              w(v(Wo), {
                modelValue: i.value,
                "onUpdate:modelValue": W[0] || (W[0] = (Z) => i.value = Z),
                placeholder: v(le).info.variablesSearch,
                label: v(le).info.variablesSearch
              }, null, 8, ["modelValue", "placeholder", "label"]),
              w(v(wX), {
                selected: v(d).variables.tags.name,
                "onUpdate:selected": W[1] || (W[1] = (Z) => v(d).variables.tags.name = Z),
                class: "variables-table__tags-input"
              }, null, 8, ["selected"])
            ]),
            sort: k(() => [
              w(G, {
                modelValue: v(d).sort,
                "onUpdate:modelValue": W[2] || (W[2] = (Z) => v(d).sort = Z),
                options: v(soe)
              }, null, 8, ["modelValue", "options"])
            ]),
            default: k(() => [
              b.value.length == 0 ? (T(), O(v(Uo), {
                key: 0,
                label: v(le).info.variable,
                count: A.value
              }, null, 8, ["label", "count"])) : (T(), O(v(td), {
                key: 1,
                count: b.value.length
              }, null, 8, ["count"])),
              v(s).delete.variable ? (T(), O(v(_X), {
                key: 2,
                "variable-ids": b.value.map((Z) => Z.id),
                onDelete: L
              }, null, 8, ["variable-ids"])) : j("", !0)
            ]),
            _: 1
          }),
          w(v(BI), {
            selected: v(s).delete.variable ? b.value : void 0,
            data: S.value,
            columns: g,
            "column-classes": _,
            "row-key": (Z) => Z.id,
            "onUpdate:selected": W[3] || (W[3] = (Z) => b.value = Z)
          }, {
            name: k(({ row: Z }) => [
              re("div", {
                class: "variables-table__name",
                title: Z.name
              }, ie(Z.name), 9, j3e)
            ]),
            value: k(({ row: Z }) => [
              re("div", z3e, [
                w(H3e, {
                  variable: Z,
                  "value-overflow-text": "click to view",
                  onUpdate: X
                }, null, 8, ["variable"])
              ])
            ]),
            updated: k(({ row: Z }) => [
              w(hn, {
                date: Z.updated,
                format: "numeric"
              }, null, 8, ["date"])
            ]),
            tags: k(({ row: Z }) => [
              w(de, {
                class: "variables-table__tags",
                tags: Z.tags,
                justify: "left"
              }, null, 8, ["tags"])
            ]),
            "action-heading": k(() => [...W[6] || (W[6] = [
              re("span", null, null, -1)
            ])]),
            action: k(({ row: Z }) => [
              (T(), z("div", {
                key: Z.id,
                class: "variables-table__action"
              }, [
                w(v(vX), {
                  variable: Z,
                  size: "xs",
                  onDelete: C,
                  onUpdate: X,
                  onCreate: te
                }, null, 8, ["variable"])
              ]))
            ]),
            "empty-state": k(() => [
              v(x).executed ? (T(), O(v(el), { key: 0 }, Ut({
                message: k(() => [
                  q(ie(v(le).info.noVariables), 1)
                ]),
                _: 2
              }, [
                v(h) ? {
                  name: "actions",
                  fn: k(() => [
                    w(V, {
                      size: "sm",
                      onClick: v(m)
                    }, {
                      default: k(() => [...W[7] || (W[7] = [
                        q(" Clear Filters ", -1)
                      ])]),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  key: "0"
                } : void 0
              ]), 1024)) : (T(), O(v(el), { key: 1 }, {
                message: k(() => [
                  w(Y)
                ]),
                _: 1
              }))
            ]),
            _: 1
          }, 8, ["selected", "data", "row-key"]),
          S.value.length ? (T(), O(Q, {
            key: 0,
            limit: v(p),
            "onUpdate:limit": W[4] || (W[4] = (Z) => Xe(p) ? p.value = Z : null),
            page: l.value,
            "onUpdate:page": W[5] || (W[5] = (Z) => l.value = Z),
            pages: c.value
          }, null, 8, ["limit", "page", "pages"])) : j("", !0)
        ]),
        _: 1
      });
    };
  }
}), wX = /* @__PURE__ */ U({
  __name: "VariableTagsInput",
  props: {
    selected: {},
    filter: {}
  },
  emits: ["update:selected"],
  setup(t, { emit: e }) {
    const n = t, r = e, { filter: o = {} } = Nn(n), s = D({
      get() {
        return n.selected ?? null;
      },
      set(l) {
        r("update:selected", l);
      }
    }), { variables: i } = TN(o), u = D(() => {
      const l = i.value.flatMap((a) => a.tags);
      return Bm(l).sort((a, c) => a.localeCompare(c));
    });
    return (l, a) => {
      const c = P("p-tags-input");
      return T(), O(c, {
        modelValue: s.value,
        "onUpdate:modelValue": a[0] || (a[0] = (p) => s.value = p),
        placeholder: v(le).info.addTagPlaceholder,
        options: u.value,
        "empty-message": v(le).info.all
      }, null, 8, ["modelValue", "placeholder", "options", "empty-message"]);
    };
  }
}), bX = /* @__PURE__ */ U({
  inheritAttrs: !1,
  __name: "WorkerMenu",
  props: {
    workPoolName: {},
    worker: {}
  },
  emits: ["delete"],
  setup(t, { emit: e }) {
    const n = t, r = e, o = Se(), { showModal: s, open: i, close: u } = St();
    async function l(a) {
      u(), await Ua({ workPoolName: n.workPoolName, workerName: a }, o.workPoolWorkers.deleteWorker, "Worker"), r("delete");
    }
    return (a, c) => {
      const p = P("p-overflow-menu-item"), d = P("p-icon-button-menu");
      return T(), z(ve, null, [
        w(d, sn(kn(a.$attrs)), {
          default: k(() => [
            w(v(uo), {
              label: "Copy ID",
              item: a.worker.id
            }, null, 8, ["item"]),
            w(p, {
              label: "Delete",
              onClick: v(i)
            }, null, 8, ["onClick"])
          ]),
          _: 1
        }, 16),
        w(v(_r), {
          showModal: v(s),
          "onUpdate:showModal": c[0] || (c[0] = (h) => Xe(s) ? s.value = h : null),
          label: "Worker",
          name: a.worker.name,
          onDelete: c[1] || (c[1] = (h) => l(a.worker.name))
        }, null, 8, ["showModal", "name"])
      ], 64);
    };
  }
}), $v = /* @__PURE__ */ U({
  inheritAttrs: !1,
  __name: "WorkersLateIndicator",
  props: {
    workPoolName: {},
    workPoolQueueNames: {}
  },
  setup(t) {
    const e = t, n = Se(), r = D(() => ({
      workPools: {
        name: [e.workPoolName]
      },
      workPoolQueues: {
        name: e.workPoolQueueNames
      },
      flowRuns: {
        state: {
          name: ["Late"]
        }
      }
    })), o = mt(n.flowRuns.getFlowRunsCount, [r], { interval: 3e4 }), s = D(() => o.response ?? 0);
    return (i, u) => {
      const l = P("p-tag");
      return s.value ? (T(), O(l, {
        key: 0,
        class: "workers-late-indicator"
      }, {
        default: k(() => [
          q(ie(s.value) + " " + ie(v(mc)("Late run", s.value)), 1)
        ]),
        _: 1
      })) : j("", !0);
    };
  }
}), G3e = { class: "workers-table" }, Y3e = { class: "workers-table__filters" }, Q3e = /* @__PURE__ */ U({
  __name: "WorkersTable",
  props: {
    workPoolName: {}
  },
  emits: ["delete"],
  setup(t, { emit: e }) {
    const n = t, r = Se(), o = {
      interval: 3e4
    }, { workPoolName: s } = Nn(n), i = mt(r.workPoolWorkers.getWorkers, [s.value], o), u = D(() => i.response ?? []), l = ge(""), a = D(() => l.value ? u.value.filter(
      (h) => h.name.toLowerCase().includes(l.value.toLowerCase())
    ) : u.value), c = D(() => !!l.value), p = [
      {
        property: "name",
        label: "Name"
      },
      {
        property: "lastHeartbeatTime",
        label: "Last Seen"
      },
      {
        property: "status",
        label: "Status"
      },
      {
        label: "Action",
        width: "42px"
      }
    ];
    function d() {
      l.value = "";
    }
    return (h, m) => {
      const g = P("p-button"), _ = P("PEmptyResults"), b = P("p-table");
      return T(), z("div", G3e, [
        re("div", Y3e, [
          w(v(Uo), {
            label: "Worker",
            count: a.value.length,
            class: "workers-table__results"
          }, null, 8, ["count"]),
          w(v(Wo), {
            modelValue: l.value,
            "onUpdate:modelValue": m[0] || (m[0] = (x) => l.value = x),
            class: "workers-table__search",
            placeholder: "Search workers"
          }, null, 8, ["modelValue"])
        ]),
        w(b, {
          data: a.value,
          columns: p
        }, {
          name: k(({ row: x }) => [
            re("span", null, ie(x.name), 1)
          ]),
          "last-seen": k(({ value: x }) => [
            w(hn, {
              date: x,
              format: "relative"
            }, null, 8, ["date"])
          ]),
          status: k(({ row: x }) => [
            w(v(kX), { worker: x }, null, 8, ["worker"])
          ]),
          "action-heading": k(() => [...m[2] || (m[2] = [
            re("span", null, null, -1)
          ])]),
          action: k(({ row: x }) => [
            w(v(bX), {
              worker: x,
              "work-pool-name": v(s),
              onDelete: m[1] || (m[1] = () => v(i).refresh())
            }, null, 8, ["worker", "work-pool-name"])
          ]),
          "empty-state": k(() => [
            w(_, null, Ut({
              message: k(() => [
                m[3] || (m[3] = q(" No workers ", -1))
              ]),
              _: 2
            }, [
              c.value ? {
                name: "actions",
                fn: k(() => [
                  w(g, {
                    size: "sm",
                    onClick: d
                  }, {
                    default: k(() => [...m[4] || (m[4] = [
                      q(" Clear Filters ", -1)
                    ])]),
                    _: 1
                  })
                ]),
                key: "0"
              } : void 0
            ]), 1024)
          ]),
          _: 1
        }, 8, ["data"])
      ]);
    };
  }
}), K3e = { class: "worker-status-badge--status-text" }, kX = /* @__PURE__ */ U({
  __name: "WorkerStatusBadge",
  props: {
    worker: {}
  },
  setup(t) {
    return (e, n) => {
      const r = P("p-tag");
      return T(), O(r, null, {
        default: k(() => [
          w(A_, {
            status: e.worker.status === "online" ? "ready" : "not_ready"
          }, null, 8, ["status"]),
          re("span", K3e, ie(e.worker.status), 1)
        ]),
        _: 1
      });
    };
  }
}), Z3e = { class: "work-pool-base-job-template-section__advanced_tab" }, CR = /* @__PURE__ */ U({
  __name: "WorkPoolBaseJobTemplateFormSection",
  props: {
    baseJobTemplate: {}
  },
  emits: ["update:base-job-template"],
  setup(t, { emit: e }) {
    const n = t, r = e, o = () => {
      l.value !== null && r("update:base-job-template", l.value);
    }, s = ge(or(n.baseJobTemplate)), { state: i, error: u } = bn(s, ml("Base Job Template")), l = D(() => {
      try {
        return JSON.parse(s.value);
      } catch (m) {
        if (m instanceof SyntaxError)
          return null;
        throw m;
      }
    });
    Ct(() => n.baseJobTemplate, (m) => {
      hu.isEqual(m, l.value) || (s.value = or(m));
    });
    const a = D(() => n.baseJobTemplate.variables ?? {}), c = D(() => ye.map("SchemaResponse", Ste(a.value), "Schema")), p = D(() => a.value.properties ?? {}), d = D(() => Object.keys(p.value).length > 0), h = D({
      get() {
        const m = ye.map("SchemaResponse", a.value, "Schema");
        return Bh(m);
      },
      set(m) {
        const g = {
          ...n.baseJobTemplate,
          variables: {
            ...n.baseJobTemplate.variables,
            properties: Ds(p.value, (_, b) => ({
              ...b,
              default: m[_]
            }))
          }
        };
        r("update:base-job-template", g);
      }
    });
    return (m, g) => {
      const _ = P("p-message"), b = P("p-link"), x = P("p-label"), S = P("p-tabs");
      return T(), z("div", null, [
        g[10] || (g[10] = re("h3", null, " Base Job Template ", -1)),
        w(S, {
          tabs: ["Defaults", "Advanced"],
          class: "overflow-auto"
        }, {
          defaults: k(() => [
            d.value ? (T(), z(ve, { key: 0 }, [
              w(_, {
                info: "",
                class: "work-pool-base-job-template-section__info_message"
              }, {
                default: k(() => [...g[2] || (g[2] = [
                  q(" The fields below control the default values for the base job template. These values can be overridden by deployments. ", -1)
                ])]),
                _: 1
              }),
              w(v(fX), {
                values: h.value,
                "onUpdate:values": g[0] || (g[0] = (E) => h.value = E),
                schema: c.value
              }, null, 8, ["values", "schema"])
            ], 64)) : (T(), O(_, {
              key: 1,
              warning: ""
            }, {
              default: k(() => [...g[3] || (g[3] = [
                q(" This work pool's base job template does not have any customizations. To add customizations, edit the base job template directly with the ", -1),
                re("b", null, "Advanced", -1),
                q(" tab. ", -1)
              ])]),
              _: 1
            }))
          ]),
          advanced: k(() => [
            re("div", Z3e, [
              w(_, {
                info: "",
                class: "work-pool-base-job-template-section__info_message"
              }, {
                default: k(() => [
                  g[5] || (g[5] = q(" This is the JSON representation of the base job template. A work pool's job template controls infrastructure configuration for all flow runs in the work pool, and specifies the configuration that can be overridden by deployments. ", -1)),
                  g[6] || (g[6] = re("br", null, null, -1)),
                  g[7] || (g[7] = re("br", null, null, -1)),
                  g[8] || (g[8] = q(" For more information on the structure of a work pool's base job template, check out ", -1)),
                  w(b, {
                    to: v(le).docs.workPools
                  }, {
                    default: k(() => [...g[4] || (g[4] = [
                      q(" the docs. ", -1)
                    ])]),
                    _: 1
                  }, 8, ["to"]),
                  g[9] || (g[9] = q(". ", -1))
                ]),
                _: 1
              }),
              w(x, {
                message: v(u),
                state: v(i)
              }, {
                default: k(() => [
                  w(v(Rr), {
                    "model-value": s.value,
                    "onUpdate:modelValue": [
                      g[1] || (g[1] = (E) => s.value = E),
                      o
                    ],
                    state: v(i),
                    "show-format-button": ""
                  }, null, 8, ["model-value", "state"])
                ]),
                _: 1
              }, 8, ["message", "state"])
            ])
          ]),
          _: 1
        })
      ]);
    };
  }
}), J3e = { class: "work-pool-card__header" }, eFe = { class: "work-pool-card__heading" }, tFe = { class: "work-pool-card__name" }, nFe = { class: "work-pool-card__header-actions" }, rFe = {
  key: 0,
  class: "work-pool-card__description"
}, oFe = { class: "work-pool-card__details" }, sFe = { key: 0 }, TX = /* @__PURE__ */ U({
  __name: "WorkPoolCard",
  props: {
    workPool: {}
  },
  emits: ["update"],
  setup(t, { emit: e }) {
    const n = t, { WorkPoolMenu: r } = Vn(), o = je(), s = {
      interval: 3e4
    }, i = D(() => n.workPool.name), { lastPolled: u } = SN(i, s), l = e;
    return (a, c) => {
      const p = P("p-link"), d = P("p-content"), h = P("p-card");
      return T(), O(h, { class: "work-pool-card" }, {
        default: k(() => [
          w(d, { secondary: "" }, {
            default: k(() => [
              re("div", J3e, [
                re("div", eFe, [
                  re("div", tFe, [
                    w(p, {
                      class: "work-pool-card__name",
                      to: v(o).workPool(a.workPool.name)
                    }, {
                      default: k(() => [
                        q(ie(a.workPool.name), 1)
                      ]),
                      _: 1
                    }, 8, ["to"]),
                    w(v(I_), { "work-pool": a.workPool }, null, 8, ["work-pool"])
                  ]),
                  w(v(dX), {
                    "type-label": a.workPool.typeLabel
                  }, null, 8, ["type-label"]),
                  v(_s).sm ? j("", !0) : (T(), O(v($v), {
                    key: 0,
                    "work-pool-name": a.workPool.name
                  }, null, 8, ["work-pool-name"]))
                ]),
                re("div", nFe, [
                  v(_s).sm ? (T(), O(v($v), {
                    key: 0,
                    "work-pool-name": a.workPool.name
                  }, null, 8, ["work-pool-name"])) : j("", !0),
                  w(v(FR), {
                    "work-pool": a.workPool,
                    onUpdate: c[0] || (c[0] = (m) => l("update"))
                  }, null, 8, ["work-pool"]),
                  w(v(r), {
                    "work-pool": a.workPool,
                    onDelete: c[1] || (c[1] = (m) => l("update"))
                  }, null, 8, ["work-pool"])
                ])
              ]),
              a.workPool.description ? (T(), z("p", rFe, ie(a.workPool.description), 1)) : j("", !0),
              re("div", oFe, [
                re("div", null, [
                  c[2] || (c[2] = re("span", { class: "work-pool-card__details-label" }, "Concurrency Limit", -1)),
                  q(" " + ie(a.workPool.concurrencyLimit ? a.workPool.concurrencyLimit : "Unlimited"), 1)
                ]),
                v(u) ? (T(), z("div", sFe, [
                  c[3] || (c[3] = re("span", { class: "work-pool-card__details-label" }, "Last Polled", -1)),
                  q(" " + ie(v(u)), 1)
                ])) : j("", !0)
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      });
    };
  }
}), aFe = /* @__PURE__ */ U({
  __name: "WorkPoolCreateWizard",
  setup(t) {
    const e = rs(), n = je(), r = ge({}), o = [
      { title: "Infrastructure Type", key: "work-pool-infrastructure-type" },
      { title: "Details", key: "work-pool-information" },
      { title: "Configuration", key: "work-pool-infrastructure-configuration" }
    ], s = Se(), i = mt(s.collections.getWorkerCollection, []), u = D(() => i.response ?? []), l = D(() => u.value.find((d) => d.type === r.value.type)?.defaultBaseJobConfiguration ?? {}), { subscription: a } = RN();
    async function c() {
      r.value.baseJobTemplate || (r.value.baseJobTemplate = l.value);
      const d = {
        ...r.value,
        description: r.value.description ?? "",
        concurrencyLimit: r.value.concurrencyLimit ?? void 0,
        isPaused: !1
      };
      try {
        const { name: h } = await s.workPools.createWorkPool(d);
        He(le.success.createWorkPool, "success"), WI(s.workPools.getWorkPools, []), a.refresh(), e.push(n.workPool(h));
      } catch (h) {
        console.error(h);
        const m = Yt(h, le.error.createWorkPool);
        He(m, "error");
      }
    }
    function p() {
      e.back();
    }
    return (d, h) => {
      const m = P("p-wizard");
      return T(), O(m, {
        steps: o,
        "last-step-text": "Create",
        "show-cancel": "",
        onSubmit: c,
        onCancel: p
      }, {
        "work-pool-infrastructure-type": k(() => [
          w(v(RX), {
            workPool: r.value,
            "onUpdate:workPool": h[0] || (h[0] = (g) => r.value = g),
            workers: u.value
          }, null, 8, ["workPool", "workers"])
        ]),
        "work-pool-information": k(() => [
          w(v(xX), {
            workPool: r.value,
            "onUpdate:workPool": h[1] || (h[1] = (g) => r.value = g),
            workers: u.value
          }, null, 8, ["workPool", "workers"])
        ]),
        "work-pool-infrastructure-configuration": k(() => [
          w(v(SX), {
            workPool: r.value,
            "onUpdate:workPool": h[2] || (h[2] = (g) => r.value = g),
            "default-base-job-template": l.value
          }, null, 8, ["workPool", "default-base-job-template"])
        ]),
        _: 1
      });
    };
  }
}), xX = /* @__PURE__ */ U({
  __name: "WorkPoolCreateWizardStepInformation",
  props: {
    workPool: {}
  },
  emits: ["update:workPool"],
  setup(t, { emit: e }) {
    const n = t, r = e, o = D({
      get() {
        return n.workPool;
      },
      set(d) {
        r("update:workPool", d);
      }
    }), s = mr(o, "name"), i = mr(o, "description"), u = mr(o, "concurrencyLimit"), { defineValidate: l } = yx(), { validate: a } = Ms(), { state: c, error: p } = bn(s, "Work pool name", (d) => d?.toLowerCase().startsWith("prefect") ? 'Work pools starting with "prefect" are reserved for internal use.' : d ? !0 : "Name is required");
    return l(a), (d, h) => {
      const m = P("p-text-input"), g = P("p-label"), _ = P("p-textarea"), b = P("p-number-input"), x = P("p-content");
      return T(), O(x, null, {
        default: k(() => [
          w(g, {
            label: "Name",
            message: v(p),
            state: v(c)
          }, {
            default: k(({ id: S }) => [
              w(m, {
                id: S,
                modelValue: v(s),
                "onUpdate:modelValue": h[0] || (h[0] = (E) => Xe(s) ? s.value = E : null),
                state: v(c)
              }, null, 8, ["id", "modelValue", "state"])
            ]),
            _: 1
          }, 8, ["message", "state"]),
          w(g, { label: "Description (Optional)" }, {
            default: k(({ id: S }) => [
              w(_, {
                id: S,
                modelValue: v(i),
                "onUpdate:modelValue": h[1] || (h[1] = (E) => Xe(i) ? i.value = E : null),
                rows: "7"
              }, null, 8, ["id", "modelValue"])
            ]),
            _: 1
          }),
          w(g, { label: "Flow Run Concurrency (Optional)" }, {
            default: k(({ id: S }) => [
              w(b, {
                id: S,
                modelValue: v(u),
                "onUpdate:modelValue": h[2] || (h[2] = (E) => Xe(u) ? u.value = E : null),
                placeholder: "Unlimited",
                min: 0
              }, null, 8, ["id", "modelValue"])
            ]),
            _: 1
          })
        ]),
        _: 1
      });
    };
  }
}), SX = /* @__PURE__ */ U({
  __name: "WorkPoolCreateWizardStepInfrastructureConfiguration",
  props: {
    workPool: {},
    defaultBaseJobTemplate: {}
  },
  emits: ["update:workPool"],
  setup(t, { emit: e }) {
    const n = t, r = D(() => n.workPool.type === "prefect-agent"), o = e, s = D({
      get() {
        return n.workPool;
      },
      set(c) {
        o("update:workPool", c);
      }
    }), { validate: i } = Ms(), { defineValidate: u } = yx();
    u(i);
    const l = lt(/* @__PURE__ */ new Map()), a = D({
      get() {
        return n.workPool.type ? l.get(n.workPool.type) ?? n.defaultBaseJobTemplate : {};
      },
      set(c) {
        n.workPool.type && (l.set(n.workPool.type, c), s.value.baseJobTemplate = c);
      }
    });
    return (c, p) => {
      const d = P("p-markdown-renderer");
      return r.value ? (T(), O(d, {
        key: 1,
        text: v(le).info.workPoolInfrastructureConfigurationAgent
      }, null, 8, ["text"])) : (T(), z(ve, { key: 0 }, [
        w(d, {
          text: v(le).info.workPoolInfrastructureConfigurationInstructions,
          class: "work-pool-create-wizard-step-infrastructure-configuration__explainer-text"
        }, null, 8, ["text"]),
        w(v(CR), {
          "base-job-template": a.value,
          "onUpdate:baseJobTemplate": p[0] || (p[0] = (h) => a.value = h),
          class: "work-pool-create-wizard-step-infrastructure-configuration__base-job-template-form"
        }, null, 8, ["base-job-template"])
      ], 64));
    };
  }
}), iFe = { class: "work-pool-create-wizard-step-infrastructure-type__infra_type_card_content_container" }, uFe = { class: "work-pool-create-wizard-step-infrastructure-type__infra_type_card_text_container" }, lFe = { class: "work-pool-create-wizard-step-infrastructure-type__infra_type_card_type_text" }, cFe = { class: "work-pool-create-wizard-step-infrastructure-type__infra_type_card_description_text" }, RX = /* @__PURE__ */ U({
  __name: "WorkPoolCreateWizardStepInfrastructureType",
  props: {
    workPool: {},
    workers: {}
  },
  emits: ["update:workPool"],
  setup(t, { emit: e }) {
    const n = t, r = e, o = D({
      get() {
        return n.workPool;
      },
      set(d) {
        r("update:workPool", d);
      }
    }), s = mr(o, "type"), i = D(() => n.workers.map(({ type: h, logoUrl: m, description: g, documentationUrl: _, displayName: b, isBeta: x }) => ({
      label: b ?? Hm(h),
      value: h,
      logoUrl: m,
      description: g,
      documentationUrl: _,
      isBeta: x ?? !1
    })).sort((h, m) => h.isBeta && !m.isBeta ? 1 : !h.isBeta && m.isBeta ? -1 : h.label.localeCompare(m.label))), { defineValidate: u, wizard: l } = yx(), { validate: a } = Ms(), { state: c, error: p } = bn(s, "Work pool infrastructure type", (d) => d ? !0 : "Infrastructure type is required");
    return u(a), (d, h) => {
      const m = P("p-label"), g = P("p-radio"), _ = P("p-card"), b = P("p-content");
      return T(), O(b, null, {
        default: k(() => [
          w(m, {
            label: "Select the infrastructure you want to use to execute your flow runs",
            message: v(p),
            state: v(c)
          }, null, 8, ["message", "state"]),
          (T(!0), z(ve, null, ln(i.value, ({ label: x, value: S, logoUrl: E, description: A, isBeta: C }) => (T(), O(_, { key: S }, {
            default: k(() => [
              w(g, {
                modelValue: v(s),
                "onUpdate:modelValue": [
                  h[0] || (h[0] = (M) => Xe(s) ? s.value = M : null),
                  h[1] || (h[1] = (M) => v(l).next())
                ],
                value: S,
                state: v(c),
                label: x
              }, {
                label: k(() => [
                  re("div", iFe, [
                    w(v(fu), {
                      url: E,
                      alt: x,
                      size: "md",
                      class: "block-type-card-preview__logo"
                    }, null, 8, ["url", "alt"]),
                    re("div", uFe, [
                      re("p", lFe, [
                        q(ie(x), 1),
                        C ? (T(), O(v(v4), {
                          key: 0,
                          class: "work-pool-create-wizard-step-infrastructure-type__infra_type_card_beta_label"
                        })) : j("", !0)
                      ]),
                      re("p", cFe, ie(A), 1)
                    ])
                  ])
                ]),
                _: 2
              }, 1032, ["modelValue", "value", "state", "label"])
            ]),
            _: 2
          }, 1024))), 128))
        ]),
        _: 1
      });
    };
  }
}), pFe = { class: "work-pool-details" }, dFe = /* @__PURE__ */ U({
  __name: "WorkPoolDetails",
  props: {
    workPool: {},
    alternate: { type: Boolean }
  },
  setup(t) {
    const e = t, n = Se(), r = {
      interval: 3e4
    }, o = mt(n.workPoolWorkers.getWorkers, [e.workPool.name, {}], r), s = D(() => o.response ?? []), i = D(() => s.value[0].lastHeartbeatTime), u = D(() => {
      const { properties: p } = e.workPool.baseJobTemplate.variables ?? {};
      return p && Object.keys(p).length > 0;
    }), l = D(() => ye.map("SchemaResponse", e.workPool.baseJobTemplate.variables ?? {}, "Schema")), a = D(() => e.workPool.type && u.value), c = D(() => Bh(l.value));
    return (p, d) => {
      const h = P("p-key-value"), m = P("p-divider");
      return T(), z("div", pFe, [
        p.workPool.status ? (T(), O(h, {
          key: 0,
          label: "Status",
          alternate: p.alternate
        }, {
          value: k(() => [
            w(v(EX), { "work-pool": p.workPool }, null, 8, ["work-pool"])
          ]),
          _: 1
        }, 8, ["alternate"])) : j("", !0),
        w(h, {
          label: "Description",
          value: p.workPool.description,
          alternate: p.alternate
        }, null, 8, ["value", "alternate"]),
        w(h, {
          label: "Type",
          value: p.workPool.typeLabel,
          alternate: p.alternate
        }, null, 8, ["value", "alternate"]),
        w(h, {
          label: "Concurrency Limit",
          value: p.workPool.concurrencyLimit,
          alternate: p.alternate
        }, null, 8, ["value", "alternate"]),
        w(h, {
          label: "Created",
          alternate: p.alternate
        }, {
          value: k(() => [
            w(hn, {
              date: p.workPool.created,
              format: "numeric"
            }, null, 8, ["date"])
          ]),
          _: 1
        }, 8, ["alternate"]),
        w(h, {
          label: "Last Updated",
          alternate: p.alternate
        }, {
          value: k(() => [
            w(hn, {
              date: p.workPool.updated,
              format: "numeric"
            }, null, 8, ["date"])
          ]),
          _: 1
        }, 8, ["alternate"]),
        s.value.length ? (T(), O(h, {
          key: 1,
          label: "Last Polled",
          alternate: p.alternate
        }, {
          value: k(() => [
            w(hn, {
              date: i.value,
              format: "numeric"
            }, null, 8, ["date"])
          ]),
          _: 1
        }, 8, ["alternate"])) : j("", !0),
        a.value ? (T(), z(ve, { key: 2 }, [
          w(m),
          d[0] || (d[0] = re("h3", null, " Base Job Configuration ", -1)),
          w(v(X2), yt({ values: c.value }, { schema: l.value, alternate: p.alternate }), null, 16, ["values"])
        ], 64)) : j("", !0)
      ]);
    };
  }
}), hFe = /* @__PURE__ */ U({
  __name: "WorkPoolEditForm",
  props: {
    workPool: {}
  },
  setup(t) {
    const e = t, n = Se(), r = rs(), o = je(), { validate: s, pending: i } = Ms(), u = ge(e.workPool.description), l = ge(e.workPool.type), a = ge(e.workPool.concurrencyLimit), c = ge(e.workPool.baseJobTemplate), p = D(() => l.value !== "prefect-agent"), d = D(() => l.value && p.value);
    function h() {
      r.back();
    }
    const m = async () => {
      if (await s()) {
        const _ = {
          description: u.value,
          concurrencyLimit: a.value,
          baseJobTemplate: c.value
        };
        try {
          await n.workPools.updateWorkPool(e.workPool.name, _), He(le.success.updateWorkPool, "success"), r.push(o.workPool(e.workPool.name));
        } catch (b) {
          const x = Yt(b, le.error.updateWorkPool);
          He(x, "error"), console.error(b);
        }
      }
    };
    return (g, _) => {
      const b = P("p-text-input"), x = P("p-label"), S = P("p-textarea"), E = P("p-number-input"), A = P("p-content"), C = P("p-button"), M = P("p-form");
      return T(), O(M, {
        class: "work-pool-edit-form p-background",
        onSubmit: m
      }, {
        footer: k(() => [
          w(C, { onClick: h }, {
            default: k(() => [..._[3] || (_[3] = [
              q(" Cancel ", -1)
            ])]),
            _: 1
          }),
          w(v(Pc), {
            action: "Save",
            loading: v(i)
          }, null, 8, ["loading"])
        ]),
        default: k(() => [
          w(A, null, {
            default: k(() => [
              w(x, { label: "Name" }, {
                default: k(({ id: L }) => [
                  w(b, {
                    id: L,
                    "model-value": g.workPool.name,
                    disabled: ""
                  }, null, 8, ["id", "model-value"])
                ]),
                _: 1
              }),
              w(x, { label: "Description (Optional)" }, {
                default: k(({ id: L }) => [
                  w(S, {
                    id: L,
                    modelValue: u.value,
                    "onUpdate:modelValue": _[0] || (_[0] = (X) => u.value = X),
                    rows: "7"
                  }, null, 8, ["id", "modelValue"])
                ]),
                _: 1
              }),
              w(x, { label: "Flow Run Concurrency (Optional)" }, {
                default: k(({ id: L }) => [
                  w(E, {
                    id: L,
                    modelValue: a.value,
                    "onUpdate:modelValue": _[1] || (_[1] = (X) => a.value = X),
                    placeholder: "Unlimited",
                    min: 0
                  }, null, 8, ["id", "modelValue"])
                ]),
                _: 1
              }),
              w(x, { label: "Type" }, {
                default: k(() => [
                  w(v(PX), {
                    selected: l.value,
                    disabled: ""
                  }, null, 8, ["selected"])
                ]),
                _: 1
              }),
              d.value ? (T(), O(v(CR), {
                key: 0,
                "base-job-template": c.value,
                "onUpdate:baseJobTemplate": _[2] || (_[2] = (L) => c.value = L)
              }, null, 8, ["base-job-template"])) : j("", !0)
            ]),
            _: 1
          })
        ]),
        _: 1
      });
    };
  }
}), fFe = /* @__PURE__ */ U({
  __name: "WorkPoolLateIndicator",
  props: {
    workPoolName: {}
  },
  setup(t) {
    const e = t, n = Se(), { workPoolName: r } = Nn(e), o = mt(n.workPools.getWorkPoolScheduledRuns, [r.value, {}], { interval: 3e4 }), s = D(() => o.response ?? []), i = D(() => s.value.filter((u) => u.flowRun.stateName === "Late").length);
    return (u, l) => {
      const a = P("p-tag");
      return i.value ? (T(), O(a, {
        key: 0,
        class: "work-pool-late-indicator"
      }, {
        default: k(() => [
          q(ie(i.value) + " " + ie(v(mc)("Late run", i.value)), 1)
        ]),
        _: 1
      })) : j("", !0);
    };
  }
}), AX = /* @__PURE__ */ U({
  __name: "WorkPoolList",
  props: {
    workPools: {}
  },
  emits: ["delete", "update"],
  setup(t, { emit: e }) {
    const n = e;
    return (r, o) => {
      const s = P("p-virtual-scroller");
      return T(), O(s, {
        items: r.workPools,
        class: "work-pools-list"
      }, {
        default: k(({ item: i }) => [
          w(v(TX), {
            "work-pool": i,
            onUpdate: o[0] || (o[0] = (u) => n("update"))
          }, null, 8, ["work-pool"])
        ]),
        _: 1
      }, 8, ["items"]);
    };
  }
}), mFe = /* @__PURE__ */ U({
  inheritAttrs: !1,
  __name: "WorkPoolMenu",
  props: {
    workPool: {}
  },
  emits: ["delete"],
  setup(t, { emit: e }) {
    const n = e, r = Se(), o = je(), { showModal: s, open: i, close: u } = St(), { subscription: l } = RN();
    async function a(c) {
      u(), await Ua(c, r.workPools.deleteWorkPool, "Work pool"), WI(r.workPools.getWorkPools, []), l.refresh(), n("delete");
    }
    return (c, p) => {
      const d = P("p-overflow-menu-item"), h = P("router-link"), m = P("p-icon-button-menu");
      return T(), z(ve, null, [
        w(m, yt(c.$attrs, { class: "work-pool-menu" }), {
          default: k(() => [
            w(v(uo), {
              label: "Copy ID",
              item: c.workPool.id
            }, null, 8, ["item"]),
            c.workPool.can.update ? (T(), O(h, {
              key: 0,
              to: v(o).workPoolEdit(c.workPool.name)
            }, {
              default: k(() => [
                w(d, { label: "Edit" })
              ]),
              _: 1
            }, 8, ["to"])) : j("", !0),
            c.workPool.can.delete ? (T(), O(d, {
              key: 1,
              label: "Delete",
              onClick: v(i)
            }, null, 8, ["onClick"])) : j("", !0),
            w(h, {
              to: v(o).automateWorkPool(c.workPool.id)
            }, {
              default: k(() => [
                w(d, { label: "Automate" })
              ]),
              _: 1
            }, 8, ["to"]),
            Ve(c.$slots, "default", sn(kn({ workPool: c.workPool })))
          ]),
          _: 3
        }, 16),
        w(v(_r), {
          showModal: v(s),
          "onUpdate:showModal": p[0] || (p[0] = (g) => Xe(s) ? s.value = g : null),
          label: "Work Pool",
          name: c.workPool.name,
          onDelete: p[1] || (p[1] = (g) => a(c.workPool.name))
        }, null, 8, ["showModal", "name"])
      ], 64);
    };
  }
}), yFe = /* @__PURE__ */ U({
  __name: "WorkPoolQueueCreateForm",
  props: {
    workPoolName: {}
  },
  setup(t) {
    const e = t, n = Se(), r = rs(), o = je(), { validate: s, pending: i } = Ms(), u = ge(""), l = ge(), a = ge(), c = ge(), p = (S) => S !== void 0 && S.trim().length > 0, d = (S, E) => S == null || S > 0 ? !0 : `${E} must be greater than 0`, { error: h, state: m } = bn(u, "Name", [p]), { error: g, state: _ } = bn(c, "Priority", [d]);
    function b() {
      r.back();
    }
    const x = async () => {
      if (!await s())
        return;
      const E = {
        name: u.value,
        description: l.value,
        isPaused: !1,
        concurrencyLimit: a.value,
        priority: c.value
      };
      try {
        const { name: A } = await n.workPoolQueues.createWorkPoolQueue(e.workPoolName, E);
        He(le.success.createWorkPoolQueue, "success"), r.push(o.workPoolQueue(e.workPoolName, A));
      } catch (A) {
        const C = Yt(A, le.error.createWorkPoolQueue);
        He(C, "error"), console.error(A);
      }
    };
    return (S, E) => {
      const A = P("p-text-input"), C = P("p-label"), M = P("p-textarea"), L = P("p-number-input"), X = P("p-content"), te = P("p-button"), B = P("p-form");
      return T(), O(B, {
        class: "work-pool-queue-create-form p-background",
        onSubmit: x
      }, {
        footer: k(() => [
          w(te, { onClick: b }, {
            default: k(() => [...E[4] || (E[4] = [
              q(" Cancel ", -1)
            ])]),
            _: 1
          }),
          w(v(Pc), {
            action: "Create",
            loading: v(i)
          }, null, 8, ["loading"])
        ]),
        default: k(() => [
          w(X, null, {
            default: k(() => [
              w(C, {
                label: "Name",
                message: v(h),
                state: v(m)
              }, {
                default: k(({ id: W }) => [
                  w(A, {
                    id: W,
                    modelValue: u.value,
                    "onUpdate:modelValue": E[0] || (E[0] = (G) => u.value = G),
                    state: v(m)
                  }, null, 8, ["id", "modelValue", "state"])
                ]),
                _: 1
              }, 8, ["message", "state"]),
              w(C, { label: "Description (Optional)" }, {
                default: k(({ id: W }) => [
                  w(M, {
                    id: W,
                    modelValue: l.value,
                    "onUpdate:modelValue": E[1] || (E[1] = (G) => l.value = G),
                    rows: "7"
                  }, null, 8, ["id", "modelValue"])
                ]),
                _: 1
              }),
              w(C, { label: "Flow Run Concurrency (Optional)" }, {
                default: k(({ id: W }) => [
                  w(L, {
                    id: W,
                    modelValue: a.value,
                    "onUpdate:modelValue": E[2] || (E[2] = (G) => a.value = G),
                    placeholder: "Unlimited",
                    min: 0
                  }, null, 8, ["id", "modelValue"])
                ]),
                _: 1
              }),
              w(C, {
                label: "Priority (Optional)",
                message: v(g),
                state: v(_)
              }, {
                label: k(() => [
                  w(v(uw))
                ]),
                default: k(({ id: W }) => [
                  w(L, {
                    id: W,
                    modelValue: c.value,
                    "onUpdate:modelValue": E[3] || (E[3] = (G) => c.value = G),
                    min: 1,
                    state: v(_)
                  }, null, 8, ["id", "modelValue", "state"])
                ]),
                _: 1
              }, 8, ["message", "state"])
            ]),
            _: 1
          })
        ]),
        _: 1
      });
    };
  }
}), gFe = { class: "work-pool-queue-details" }, vFe = { key: 1 }, _Fe = /* @__PURE__ */ U({
  __name: "WorkPoolQueueDetails",
  props: {
    workPoolQueue: {},
    workPoolName: {},
    alternate: { type: Boolean }
  },
  setup(t) {
    const e = t, { workPoolName: n } = Nn(e), r = Se(), o = D(() => [
      {
        workPools: {
          id: [e.workPoolQueue.workPoolId]
        }
      }
    ]), s = xt(r.workPools.getWorkPools, o), i = D(() => s.response ?? []), u = D(() => i.value[0]);
    return (l, a) => {
      const c = P("p-key-value"), p = P("p-divider");
      return T(), z("div", gFe, [
        w(c, {
          label: "Work Pool",
          alternate: l.alternate
        }, {
          value: k(() => [
            w(v(Wh), { "work-pool-name": v(n) }, null, 8, ["work-pool-name"])
          ]),
          _: 1
        }, 8, ["alternate"]),
        w(c, {
          label: "Status",
          alternate: l.alternate
        }, {
          value: k(() => [
            u.value ? (T(), O(v(OR), {
              key: 0,
              "work-queue": l.workPoolQueue
            }, null, 8, ["work-queue"])) : j("", !0)
          ]),
          _: 1
        }, 8, ["alternate"]),
        w(c, {
          label: "Last Polled",
          alternate: l.alternate
        }, {
          value: k(() => [
            l.workPoolQueue.lastPolled ? (T(), O(hn, {
              key: 0,
              date: l.workPoolQueue.lastPolled,
              format: "numeric"
            }, null, 8, ["date"])) : (T(), z("span", vFe, "Never"))
          ]),
          _: 1
        }, 8, ["alternate"]),
        w(c, {
          label: "Description",
          value: l.workPoolQueue.description,
          alternate: l.alternate
        }, null, 8, ["value", "alternate"]),
        w(c, {
          label: "Priority",
          value: l.workPoolQueue.priority,
          alternate: l.alternate
        }, null, 8, ["value", "alternate"]),
        w(p),
        w(c, {
          label: "Work Queue ID",
          value: l.workPoolQueue.id,
          alternate: l.alternate
        }, null, 8, ["value", "alternate"]),
        w(c, {
          label: "Flow Run Concurrency",
          value: l.workPoolQueue.concurrencyLimit,
          alternate: l.alternate
        }, null, 8, ["value", "alternate"]),
        w(c, {
          label: "Created",
          alternate: l.alternate
        }, {
          value: k(() => [
            w(hn, {
              date: l.workPoolQueue.created,
              format: "numeric"
            }, null, 8, ["date"])
          ]),
          _: 1
        }, 8, ["alternate"]),
        w(c, {
          label: "Last Updated",
          alternate: l.alternate
        }, {
          value: k(() => [
            w(hn, {
              date: l.workPoolQueue.updated,
              format: "numeric"
            }, null, 8, ["date"])
          ]),
          _: 1
        }, 8, ["alternate"])
      ]);
    };
  }
}), wFe = /* @__PURE__ */ U({
  __name: "WorkPoolQueueEditForm",
  props: {
    workPoolName: {},
    workPoolQueue: {}
  },
  setup(t) {
    const e = t, n = Se(), r = rs(), o = je(), { validate: s, pending: i } = Ms(), u = ge(e.workPoolQueue.name), l = ge(e.workPoolQueue.description), a = ge(e.workPoolQueue.concurrencyLimit), c = ge(e.workPoolQueue.priority), p = (S) => S !== void 0 && S.trim().length > 0, d = (S, E) => S && S > 0 ? !0 : `${E} must be greater than 0`, { error: h, state: m } = bn(u, "Name", [p]), { error: g, state: _ } = bn(c, "Priority", [d]);
    function b() {
      r.back();
    }
    const x = async () => {
      if (await s()) {
        const E = {
          name: u.value,
          description: l.value,
          concurrencyLimit: a.value,
          priority: c.value
        };
        try {
          await n.workPoolQueues.updateWorkPoolQueue(e.workPoolName, e.workPoolQueue.name, E), He(le.success.updateWorkPoolQueue, "success"), r.push(o.workPoolQueue(e.workPoolName, E.name));
        } catch (A) {
          const C = Yt(A, le.error.updateWorkPool);
          He(C, "error"), console.error(A);
        }
      }
    };
    return (S, E) => {
      const A = P("p-text-input"), C = P("p-label"), M = P("p-textarea"), L = P("p-number-input"), X = P("p-content"), te = P("p-button"), B = P("p-form");
      return T(), O(B, {
        class: "work-pool-queue-edit-form p-background",
        onSubmit: x
      }, {
        footer: k(() => [
          w(te, { onClick: b }, {
            default: k(() => [...E[4] || (E[4] = [
              q(" Cancel ", -1)
            ])]),
            _: 1
          }),
          w(v(Pc), {
            action: "Save",
            loading: v(i)
          }, null, 8, ["loading"])
        ]),
        default: k(() => [
          w(X, null, {
            default: k(() => [
              w(C, {
                label: "Name",
                message: v(h),
                state: v(m)
              }, {
                default: k(({ id: W }) => [
                  w(A, {
                    id: W,
                    modelValue: u.value,
                    "onUpdate:modelValue": E[0] || (E[0] = (G) => u.value = G),
                    state: v(m)
                  }, null, 8, ["id", "modelValue", "state"])
                ]),
                _: 1
              }, 8, ["message", "state"]),
              w(C, { label: "Description (Optional)" }, {
                default: k(({ id: W }) => [
                  w(M, {
                    id: W,
                    modelValue: l.value,
                    "onUpdate:modelValue": E[1] || (E[1] = (G) => l.value = G),
                    rows: "7"
                  }, null, 8, ["id", "modelValue"])
                ]),
                _: 1
              }),
              w(C, { label: "Flow Run Concurrency (Optional)" }, {
                default: k(({ id: W }) => [
                  w(L, {
                    id: W,
                    modelValue: a.value,
                    "onUpdate:modelValue": E[2] || (E[2] = (G) => a.value = G),
                    placeholder: "Unlimited",
                    min: 0
                  }, null, 8, ["id", "modelValue"])
                ]),
                _: 1
              }),
              w(C, {
                label: "Priority",
                message: v(g),
                state: v(_)
              }, {
                label: k(() => [
                  w(v(uw))
                ]),
                default: k(({ id: W }) => [
                  w(L, {
                    id: W,
                    modelValue: c.value,
                    "onUpdate:modelValue": E[3] || (E[3] = (G) => c.value = G),
                    min: 1,
                    state: v(_)
                  }, null, 8, ["id", "modelValue", "state"])
                ]),
                _: 1
              }, 8, ["message", "state"])
            ]),
            _: 1
          })
        ]),
        _: 1
      });
    };
  }
}), bFe = /* @__PURE__ */ U({
  inheritAttrs: !1,
  __name: "WorkPoolQueueMenu",
  props: {
    workPoolName: {},
    workPoolQueue: {}
  },
  emits: ["delete"],
  setup(t, { emit: e }) {
    const n = t, r = e, o = Ke(), s = Se(), i = je(), { showModal: u, open: l, close: a } = St(), { workPool: c } = Jm(() => n.workPoolName), p = D(() => c.value ? !(c.value.defaultQueueId === n.workPoolQueue.id) && n.workPoolQueue.can.delete : !1);
    async function d(h) {
      a(), await Ua([n.workPoolName, h], s.workPoolQueues.deleteWorkPoolQueue, "Work queue"), r("delete");
    }
    return (h, m) => {
      const g = P("p-overflow-menu-item"), _ = P("router-link"), b = P("p-icon-button-menu");
      return T(), z(ve, null, [
        w(b, yt(h.$attrs, { class: "work-pool-queue-menu" }), {
          default: k(() => [
            w(v(uo), {
              label: "Copy ID",
              item: h.workPoolQueue.id
            }, null, 8, ["item"]),
            h.workPoolQueue.can.update ? (T(), O(_, {
              key: 0,
              to: v(i).workPoolQueueEdit(h.workPoolName, h.workPoolQueue.name)
            }, {
              default: k(() => [
                w(g, { label: "Edit" })
              ]),
              _: 1
            }, 8, ["to"])) : j("", !0),
            p.value ? (T(), O(g, {
              key: 1,
              label: "Delete",
              onClick: v(l)
            }, null, 8, ["onClick"])) : j("", !0),
            Ve(h.$slots, "default", sn(kn({ workPoolQueue: h.workPoolQueue })), () => [
              v(o).create.automation ? (T(), O(_, {
                key: 0,
                to: v(i).automateWorkPoolQueue(h.workPoolQueue.id)
              }, {
                default: k(() => [
                  w(g, { label: "Automate" })
                ]),
                _: 1
              }, 8, ["to"])) : j("", !0)
            ])
          ]),
          _: 3
        }, 16),
        w(v(_r), {
          showModal: v(u),
          "onUpdate:showModal": m[0] || (m[0] = (x) => Xe(u) ? u.value = x : null),
          label: "Work Queue",
          name: h.workPoolQueue.name,
          onDelete: m[1] || (m[1] = (x) => d(h.workPoolQueue.name))
        }, null, 8, ["showModal", "name"])
      ], 64);
    };
  }
}), uw = /* @__PURE__ */ U({
  __name: "WorkPoolQueuePriorityLabel",
  setup(t) {
    return (e, n) => (T(), z("span", null, [
      n[1] || (n[1] = q(" Priority ", -1)),
      w(v(E_), { title: "Priority" }, {
        default: k(() => [...n[0] || (n[0] = [
          q(" Priority specifies how Prefect prioritizes the delivery of work — more precisely, execution of flow runs among worker pools. Priority must be a unique, positive integer. Lower numbers indicate higher pool priorities. For example, 1 is the highest priority queue and its flow run execution takes precedence over any lower-priority pool. 10 is a lower priority queue than 1, and 100 is lower priority than both 1 and 10. If you specify a priority that already exists, the new priority supersedes any previously set priority on a worker pool. ", -1)
        ])]),
        _: 1
      })
    ]));
  }
}), DX = /* @__PURE__ */ U({
  __name: "WorkPoolQueuesDeleteButton",
  props: {
    workPoolName: {},
    workPoolQueues: {}
  },
  emits: ["delete"],
  setup(t, { emit: e }) {
    const n = t, r = e, { showModal: o, open: s, close: i } = St(), u = Se(), l = async (a) => {
      const c = D(() => a.length === 1 ? le.success.delete("Work queue") : le.success.delete(`${a.length} work queues`));
      try {
        const p = a.map((d) => u.workPoolQueues.deleteWorkPoolQueue(n.workPoolName, d.name));
        await Promise.all(p), He(c, "success"), r("delete");
      } catch (p) {
        const d = Yt(p, le.error.delete("work queues"));
        He(d, "error");
      } finally {
        i();
      }
    };
    return (a, c) => {
      const p = P("p-button");
      return T(), z(ve, null, [
        w(mx, { name: "work-pool-queues-delete-button-transition" }, {
          default: k(() => [
            a.workPoolQueues.length > 0 ? (T(), O(p, {
              key: 0,
              icon: "TrashIcon",
              onClick: v(s)
            }, null, 8, ["onClick"])) : j("", !0)
          ]),
          _: 1
        }),
        w(_r, {
          showModal: v(o),
          "onUpdate:showModal": c[0] || (c[0] = (d) => Xe(o) ? o.value = d : null),
          name: "selected work queues",
          label: "Work Queues",
          onDelete: c[1] || (c[1] = (d) => l(a.workPoolQueues))
        }, null, 8, ["showModal"])
      ], 64);
    };
  }
}), kFe = { class: "worker-pool-queues-table__actions" }, TFe = /* @__PURE__ */ U({
  __name: "WorkPoolQueuesTable",
  props: {
    workPoolName: {}
  },
  setup(t) {
    const e = t, n = Se(), r = Ke(), o = je(), { WorkPoolQueueMenu: s } = Vn(), i = ge(""), { workPool: u, subscription: l } = Jm(() => e.workPoolName), a = mt(n.workPoolQueues.getWorkPoolQueues, [e.workPoolName]), c = D(() => a.response ?? []), p = D(() => c.value.map((b) => new Gee({
      ...b,
      disabled: !u.value || u.value.defaultQueueId == b.id
    }))), d = D(() => i.value.length == 0 ? p.value : p.value.filter((b) => wn(b) && eee(b, i.value))), h = ge([]), m = [
      {
        property: "name",
        label: "Name"
      },
      {
        property: "concurrencyLimit",
        label: "Concurrency Limit"
      },
      {
        property: "priority",
        label: "Priority"
      },
      {
        label: "Status"
      },
      {
        label: "Actions",
        width: "42px"
      }
    ], g = async () => {
      await a.refresh(), h.value = [];
    };
    function _() {
      l.refresh(), a.refresh();
    }
    return (b, x) => {
      const S = P("p-button"), E = P("p-list-header"), A = P("p-link"), C = P("p-table"), M = P("p-content");
      return T(), O(M, { class: "work-pool-queues-table" }, {
        default: k(() => [
          w(E, { sticky: "" }, {
            controls: k(() => [
              w(v(Wo), {
                modelValue: i.value,
                "onUpdate:modelValue": x[0] || (x[0] = (L) => i.value = L),
                label: "Search",
                placeholder: "Search"
              }, null, 8, ["modelValue"])
            ]),
            default: k(() => [
              h.value.length == 0 ? (T(), O(v(Uo), {
                key: 0,
                label: "Work Queue",
                count: d.value.length
              }, null, 8, ["count"])) : (T(), O(v(td), {
                key: 1,
                count: h.value.length
              }, null, 8, ["count"])),
              v(u)?.can.update && !h.value.length ? (T(), O(S, {
                key: 2,
                size: "sm",
                icon: "PlusIcon",
                to: v(o).workPoolQueueCreate(b.workPoolName)
              }, null, 8, ["to"])) : j("", !0),
              v(u)?.can.update ? (T(), O(v(DX), {
                key: 3,
                "work-pool-name": b.workPoolName,
                "work-pool-queues": h.value,
                onDelete: g
              }, null, 8, ["work-pool-name", "work-pool-queues"])) : j("", !0)
            ]),
            _: 1
          }),
          w(C, {
            selected: v(r).delete.work_queue ? h.value : void 0,
            data: d.value,
            columns: m,
            "onUpdate:selected": x[1] || (x[1] = (L) => h.value = L)
          }, {
            "priority-heading": k(() => [
              w(v(uw))
            ]),
            "actions-heading": k(() => [...x[2] || (x[2] = [
              re("span", null, null, -1)
            ])]),
            name: k(({ row: L }) => [
              w(A, {
                to: v(o).workPoolQueue(b.workPoolName, L.name)
              }, {
                default: k(() => [
                  re("span", null, ie(L.name), 1)
                ]),
                _: 2
              }, 1032, ["to"])
            ]),
            status: k(({ row: L }) => [
              v(u) ? (T(), O(v(OR), {
                key: 0,
                "work-queue": L
              }, null, 8, ["work-queue"])) : j("", !0)
            ]),
            actions: k(({ row: L }) => [
              re("div", kFe, [
                w(v($v), {
                  "work-pool-name": b.workPoolName,
                  "work-pool-queue-names": [L.name]
                }, null, 8, ["work-pool-name", "work-pool-queue-names"]),
                w(v(IR), {
                  "work-pool-queue": L,
                  "work-pool-name": b.workPoolName,
                  onUpdate: _
                }, null, 8, ["work-pool-queue", "work-pool-name"]),
                w(v(s), {
                  "work-pool-name": b.workPoolName,
                  "work-pool-queue": L,
                  size: "xs",
                  onDelete: g
                }, null, 8, ["work-pool-name", "work-pool-queue"])
              ])
            ]),
            _: 1
          }, 8, ["selected", "data"])
        ]),
        _: 1
      });
    };
  }
}), OR = /* @__PURE__ */ U({
  __name: "WorkPoolQueueStatusBadge",
  props: {
    workQueue: {}
  },
  setup(t) {
    return (e, n) => {
      const r = P("p-tag");
      return e.workQueue ? (T(), O(r, {
        key: 0,
        class: "work-pool-queue-status-badge"
      }, {
        default: k(() => [
          w(D_, { "work-pool-queue": e.workQueue }, null, 8, ["work-pool-queue"]),
          q(" " + ie(v(e2)(e.workQueue.status)), 1)
        ]),
        _: 1
      })) : j("", !0);
    };
  }
}), IR = /* @__PURE__ */ U({
  __name: "WorkPoolQueueToggle",
  props: {
    workPoolName: {},
    workPoolQueue: {}
  },
  emits: ["update"],
  setup(t, { emit: e }) {
    const n = t, { workPoolName: r } = Nn(n), { workPoolQueue: o } = Nn(n), s = e;
    Ke();
    const i = Se(), u = D({
      get() {
        return !n.workPoolQueue.isPaused;
      },
      set(a) {
        l(a);
      }
    }), l = async (a) => {
      try {
        a ? (await i.workPoolQueues.resumeWorkPoolQueue(r.value, o.value.name), He(le.success.activateWorkPoolQueue, "success")) : (await i.workPoolQueues.pauseWorkPoolQueue(r.value, o.value.name), He(le.success.pauseWorkPoolQueue, "success")), s("update");
      } catch (c) {
        const p = a ? le.error.pauseWorkPoolQueue : le.error.activateWorkPoolQueue, d = Yt(c, p);
        He(d, "error"), console.error(c);
      }
    };
    return (a, c) => {
      const p = P("p-tooltip");
      return v(o).can.update ? (T(), O(p, {
        key: 0,
        text: "Pause or resume this work queue"
      }, {
        default: k(() => [
          w(v(Mh), {
            modelValue: u.value,
            "onUpdate:modelValue": c[0] || (c[0] = (d) => u.value = d)
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      })) : j("", !0);
    };
  }
}), xFe = { class: "work-pool-queue-upcoming-flow-runs-list" }, SFe = /* @__PURE__ */ U({
  __name: "WorkPoolQueueUpcomingFlowRunsList",
  props: {
    workPoolName: {},
    workPoolQueue: {}
  },
  setup(t) {
    const e = t, { workPoolQueue: n } = Nn(e), r = () => ({
      flowRuns: {
        state: {
          name: ["Scheduled"]
        }
      },
      workPools: {
        name: [e.workPoolName]
      },
      workPoolQueues: {
        name: [e.workPoolQueue.name]
      }
    }), { flowRuns: o, subscription: s } = Qp(r), i = D(() => s.executed && o.value.length === 0), u = D(() => n.value.isPaused);
    return Ct(() => n, () => {
      s.refresh();
    }), (l, a) => {
      const c = P("p-icon"), p = P("p-empty-results");
      return T(), z("div", xFe, [
        w(v(sw), { "flow-runs": v(o) }, null, 8, ["flow-runs"]),
        i.value ? (T(), O(p, { key: 0 }, Ut({ _: 2 }, [
          u.value ? {
            name: "message",
            fn: k(() => [
              w(c, {
                class: "work-queue-flow-runs-list__icon",
                icon: "PauseIcon"
              }),
              a[0] || (a[0] = q(" This work queue is paused and will not submit runs ", -1))
            ]),
            key: "0"
          } : {
            name: "message",
            fn: k(() => [
              a[1] || (a[1] = q(" No upcoming runs ", -1))
            ]),
            key: "1"
          }
        ]), 1024)) : j("", !0)
      ]);
    };
  }
}), RFe = { class: "work-pools" }, AFe = { class: "work-pools__filters" }, DFe = { class: "work-pools__list" }, EFe = /* @__PURE__ */ U({
  __name: "WorkPools",
  emits: ["update"],
  setup(t, { emit: e }) {
    const n = Se(), r = {
      interval: 3e4
    }, o = e, s = mt(n.workPools.getWorkPools, [], r), i = D(() => s.response ?? []), u = ge(""), l = D(() => u.value ? i.value.filter(
      (c) => c.name.toLowerCase().includes(u.value.toLowerCase())
    ) : i.value);
    function a() {
      s.refresh(), o("update");
    }
    return (c, p) => (T(), z("div", RFe, [
      re("div", AFe, [
        w(v(Uo), {
          label: "Work pool",
          count: l.value.length,
          class: "work-pools__results"
        }, null, 8, ["count"]),
        w(v(Wo), {
          modelValue: u.value,
          "onUpdate:modelValue": p[0] || (p[0] = (d) => u.value = d),
          class: "work-pools__search",
          placeholder: "Search work pools"
        }, null, 8, ["modelValue"])
      ]),
      re("div", DFe, [
        w(v(AX), {
          "work-pools": l.value,
          onUpdate: a
        }, null, 8, ["work-pools"])
      ])
    ]));
  }
}), MFe = /* @__PURE__ */ U({
  __name: "WorkPoolsPageEmptyState",
  setup(t) {
    const e = Ke(), n = je();
    return (r, o) => (T(), O(v(na), null, {
      icon: k(() => [
        w(v(vo), {
          icon: "PWorkPool",
          class: "work-pools-page-empty-state__icon"
        })
      ]),
      heading: k(() => [...o[0] || (o[0] = [
        q(" Create a work pool to get started ", -1)
      ])]),
      description: k(() => [...o[1] || (o[1] = [
        q(" Work pools allow you to prioritize and manage deployment runs and control the infrastructure they run on ", -1)
      ])]),
      actions: k(() => [
        v(e).create.work_pool ? (T(), O(v(Zo), {
          key: 0,
          primary: "",
          to: v(n).workPoolCreate()
        }, {
          default: k(() => [...o[2] || (o[2] = [
            q(" Create work pool ", -1)
          ])]),
          _: 1
        }, 8, ["to"])) : j("", !0),
        w(Os, {
          to: v(le).docs.workPools
        }, null, 8, ["to"])
      ]),
      _: 1
    }));
  }
}), EX = /* @__PURE__ */ U({
  __name: "WorkPoolStatusBadge",
  props: {
    workPool: {}
  },
  setup(t) {
    return (e, n) => {
      const r = P("p-tag");
      return e.workPool.status ? (T(), O(r, { key: 0 }, {
        default: k(() => [
          w(I_, { "work-pool": e.workPool }, null, 8, ["work-pool"]),
          q(" " + ie(v(n2)(e.workPool.status)), 1)
        ]),
        _: 1
      })) : j("", !0);
    };
  }
}), MX = /* @__PURE__ */ U({
  __name: "WorkPoolStatusSelect",
  props: {
    selected: {}
  },
  emits: ["update:selected"],
  setup(t, { emit: e }) {
    const n = t, r = e, o = U0.map((i) => ({
      label: n2(i),
      value: i
    })), s = D({
      get() {
        return n.selected;
      },
      set(i) {
        r("update:selected", i);
      }
    });
    return (i, u) => {
      const l = P("p-select");
      return T(), O(l, {
        modelValue: s.value,
        "onUpdate:modelValue": u[0] || (u[0] = (a) => s.value = a),
        options: v(o)
      }, null, 8, ["modelValue", "options"]);
    };
  }
}), FR = /* @__PURE__ */ U({
  __name: "WorkPoolToggle",
  props: {
    workPool: {}
  },
  emits: ["update"],
  setup(t, { emit: e }) {
    const n = t, r = e, o = Se(), s = D({
      get() {
        return !n.workPool.isPaused;
      },
      set(u) {
        i(u);
      }
    }), i = async (u) => {
      try {
        u ? (await o.workPools.resumeWorkPool(n.workPool.name), He(le.success.activateWorkPool, "success")) : (await o.workPools.pauseWorkPool(n.workPool.name), He(le.success.pauseWorkPool, "success")), r("update");
      } catch (l) {
        const a = u ? le.error.pauseWorkPool : le.error.activateWorkPool, c = Yt(l, a);
        He(c, "error"), console.error(l);
      }
    };
    return (u, l) => {
      const a = P("p-tooltip");
      return u.workPool.can.update ? (T(), O(a, {
        key: 0,
        text: "Pause or resume this work pool"
      }, {
        default: k(() => [
          w(v(Mh), {
            modelValue: s.value,
            "onUpdate:modelValue": l[0] || (l[0] = (c) => s.value = c)
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      })) : j("", !0);
    };
  }
}), PX = /* @__PURE__ */ U({
  __name: "WorkPoolTypeSelect",
  props: {
    selected: {},
    disabled: { type: Boolean }
  },
  emits: ["update:selected"],
  setup(t, { emit: e }) {
    const n = t, r = e, o = D({
      get() {
        return n.selected ?? null;
      },
      set(a) {
        r("update:selected", a);
      }
    }), s = Se(), i = mt(s.collections.getWorkerCollection, []), u = D(() => i.response ?? []), l = D(() => u.value.map(({ type: c }) => ({
      label: Fte(c),
      value: c
    })).sort((c, p) => c.label.localeCompare(p.label)));
    return (a, c) => {
      const p = P("PSelect");
      return T(), O(p, yt({
        modelValue: o.value,
        "onUpdate:modelValue": c[0] || (c[0] = (d) => o.value = d),
        class: "block-type-select"
      }, { options: l.value, disabled: a.disabled }), {
        default: k(({ label: d }) => [
          q(ie(d), 1)
        ]),
        _: 1
      }, 16, ["modelValue"]);
    };
  }
}), CX = /* @__PURE__ */ U({
  __name: "WorkQueueCombobox",
  props: {
    selected: {},
    emptyMessage: {},
    allowUnset: { type: Boolean },
    multiple: { type: Boolean },
    workPoolFilter: {}
  },
  emits: ["update:selected"],
  setup(t, { emit: e }) {
    const n = t, r = e, o = D(() => n.multiple || Array.isArray(n.selected)), s = D({
      get() {
        return n.selected ?? null;
      },
      set(c) {
        c ? o.value ? r("update:selected", Array.isArray(c) ? c : [c]) : r("update:selected", c) : r("update:selected", null);
      }
    }), i = Se(), u = mt(i.workQueues.getWorkQueues, [{}]), l = D(() => u.response ?? []), a = D(() => {
      const c = l.value.reduce((d, h) => {
        if ((n.workPoolFilter?.id || n.workPoolFilter?.name) && !n.workPoolFilter.id?.includes(h.workPoolId) && !(h.workPoolName && n.workPoolFilter.name?.includes(h.workPoolName)))
          return d;
        const m = h.workPoolName ?? "No work pool";
        return d.set(m, (d.get(m) ?? []).concat(h)), d;
      }, /* @__PURE__ */ new Map()), p = [];
      for (const [d, h] of c.entries())
        p.push({
          label: d,
          options: h.map((m) => ({
            value: m.id,
            label: m.name
          }))
        });
      return n.allowUnset && p.unshift({
        options: [{ value: null, label: "None" }],
        label: ""
      }), p;
    });
    return Ct(a, (c, p) => {
      const d = new Set(c.flatMap((m) => m.options.map((g) => XD(g) ? g.value : null))), h = /* @__PURE__ */ new Set();
      for (const m of p)
        for (const g of m.options)
          XD(g) && !d.has(g.value) && h.add(g.value);
      h.size !== 0 && (!o.value && s.value && h.has(s.value) ? s.value = void 0 : Array.isArray(s.value) && s.value.length && (s.value = s.value.filter((m) => !h.has(m))));
    }), (c, p) => (T(), O(v(ts), yt({
      modelValue: s.value,
      "onUpdate:modelValue": p[0] || (p[0] = (d) => s.value = d)
    }, { options: a.value, multiple: o.value, emptyMessage: c.emptyMessage }), {
      "combobox-options-empty": k(() => [...p[1] || (p[1] = [
        q(" No work queues ", -1)
      ])]),
      default: k((d) => [
        Ve(c.$slots, "default", sn(kn(d)))
      ]),
      option: k(({ option: d }) => [
        Ve(c.$slots, "option", { option: d })
      ]),
      _: 3
    }, 16, ["modelValue"]));
  }
}), lw = /* @__PURE__ */ U({
  __name: "WorkQueueIconText",
  props: {
    workQueueName: {},
    workPoolName: {},
    workPoolId: {}
  },
  setup(t) {
    const e = t, n = Se(), r = je(), o = D(() => e.workPoolId ? [
      {
        workPools: {
          id: [e.workPoolId]
        }
      }
    ] : null), s = xt(n.workPools.getWorkPools, o), i = D(() => s.response ?? []), u = D(() => e.workPoolName ?? i.value[0].name), l = D(() => e.workPoolName ? [e.workPoolName, e.workQueueName] : e.workPoolId ? [u.value, e.workQueueName] : null), a = xt(n.workPoolQueues.getWorkPoolQueueByName, l), c = D(() => a.response);
    return (p, d) => {
      const h = P("p-icon-text"), m = P("p-link");
      return c.value ? (T(), O(m, {
        key: 0,
        to: v(r).workPoolQueue(u.value, p.workQueueName)
      }, {
        default: k(() => [
          w(h, { icon: "PWorkPool" }, {
            default: k(() => [
              q(ie(p.workQueueName), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["to"])) : (T(), O(h, {
        key: 1,
        icon: "PWorkPool",
        title: "Unknown work queue"
      }, {
        default: k(() => [
          q(ie(p.workQueueName), 1)
        ]),
        _: 1
      }));
    };
  }
}), OX = /* @__PURE__ */ U({
  __name: "WorkQueueStatusSelect",
  props: {
    selected: {}
  },
  emits: ["update:selected"],
  setup(t, { emit: e }) {
    const n = t, r = e, o = uF.map((i) => ({
      label: e2(i),
      value: i
    })), s = D({
      get() {
        return n.selected;
      },
      set(i) {
        r("update:selected", i);
      }
    });
    return (i, u) => {
      const l = P("p-select");
      return T(), O(l, {
        modelValue: s.value,
        "onUpdate:modelValue": u[0] || (u[0] = (a) => s.value = a),
        class: "work-queue-status-select",
        options: v(o)
      }, null, 8, ["modelValue", "options"]);
    };
  }
}), PFe = { class: "workspace-dashboard-flow-runs-card__header" }, CFe = /* @__PURE__ */ U({
  __name: "WorkspaceDashboardFlowRunsCard",
  props: {
    filter: {}
  },
  setup(t) {
    const e = t, n = Xa(), r = () => ye.map("WorkspaceDashboardFilter", e.filter, "FlowRunsFilter"), { count: o } = du(r, n);
    return (s, i) => {
      const u = P("p-heading"), l = P("p-content"), a = P("p-card");
      return T(), O(a, { class: "workspace-dashboard-flow-runs-card" }, {
        default: k(() => [
          re("header", PFe, [
            w(u, { heading: "5" }, {
              default: k(() => [...i[0] || (i[0] = [
                q(" Flow Runs ", -1)
              ])]),
              _: 1
            }),
            v(o) ? (T(), O(Jl, {
              key: 0,
              label: "total",
              value: v(o)
            }, null, 8, ["value"])) : j("", !0)
          ]),
          w(l, null, {
            default: k(() => [
              w(Vh, {
                class: "workspace-dashboard-flow-runs-card__chart",
                filter: r
              }),
              w(GU, { filter: r })
            ]),
            _: 1
          })
        ]),
        _: 1
      });
    };
  }
}), OFe = /* @__PURE__ */ U({
  __name: "WorkspaceEventDetails",
  props: {
    event: {}
  },
  setup(t) {
    const e = dn("tab", "Details");
    return (n, r) => {
      const o = P("p-key-value"), s = P("p-content"), i = P("p-code-highlight"), u = P("p-tabs");
      return T(), O(u, {
        selected: v(e),
        "onUpdate:selected": r[0] || (r[0] = (l) => Xe(e) ? e.value = l : null),
        tabs: ["Details", "Raw"],
        class: "workspace-event-details"
      }, {
        details: k(() => [
          w(s, null, {
            default: k(() => [
              w(o, {
                label: "Event",
                value: n.event.event
              }, null, 8, ["value"]),
              w(o, {
                label: "Occurred",
                value: n.event.occurredFormatted
              }, null, 8, ["value"]),
              w(N_, { event: n.event }, null, 8, ["event"]),
              w(F_, { event: n.event }, null, 8, ["event"])
            ]),
            _: 1
          })
        ]),
        raw: k(() => [
          w(i, {
            lang: "json",
            text: v(or)(n.event)
          }, null, 8, ["text"])
        ]),
        _: 1
      }, 8, ["selected"]);
    };
  }
}), IFe = /* @__PURE__ */ U({
  __name: "WorkspaceEventMenu",
  props: {
    event: {}
  },
  setup(t) {
    const e = je(), n = Ke();
    return (r, o) => {
      const s = P("p-overflow-menu-item"), i = P("router-link"), u = P("p-icon-button-menu");
      return T(), O(u, { class: "workspace-event-menu" }, {
        default: k(() => [
          v(n).create.automation ? (T(), O(i, {
            key: 0,
            to: v(e).automateEvent(r.event)
          }, {
            default: k(() => [
              w(s, { label: "Automate" })
            ]),
            _: 1
          }, 8, ["to"])) : j("", !0),
          w(uo, {
            label: "Copy ID",
            item: r.event.id
          }, null, 8, ["item"])
        ]),
        _: 1
      });
    };
  }
}), FFe = { class: "chart-cursor__date" }, NFe = { class: "chart-cursor__time" }, LFe = /* @__PURE__ */ U({
  __name: "WorkspaceEventsLineChart",
  props: {
    startDate: {},
    endDate: {},
    filter: {},
    zoomOptions: {}
  },
  emits: ["update:startDate", "update:endDate"],
  setup(t, { emit: e }) {
    const n = t, r = e, o = D({
      get() {
        return n.startDate;
      },
      set(E) {
        r("update:startDate", E);
      }
    }), s = D({
      get() {
        return n.endDate;
      },
      set(E) {
        r("update:endDate", E);
      }
    }), { cursor: i } = OI(), u = ge(), { interval: l } = Ise({ startDate: o, endDate: s, container: u }), { selectionStart: a, selectionEnd: c } = II(), p = Se(), d = D(() => l.value ? [
      {
        unit: "second",
        interval: l.value,
        filter: {
          ...n.filter,
          occurred: {
            since: n.startDate,
            until: n.endDate
          }
        }
      }
    ] : null), h = ns(d, 500), m = xt(p.events.getEventsHistory, h), g = D(() => m.response ?? []), _ = D(() => m.loading), b = D(() => g.value.map((E) => {
      const A = new Date((E.intervalStart.getTime() + E.intervalEnd.getTime()) / 2), C = E.value;
      return [A, C];
    })), x = D(() => ({
      chart: {
        "workspace-events-line-chart--loading": _.value
      }
    }));
    function S(E) {
      return Gr.format(E, "MMM do, hh:mm a");
    }
    return (E, A) => (T(), z("div", {
      ref_key: "container",
      ref: u,
      class: "workspace-events-line-chart"
    }, [
      w(v(wj), yt({
        cursor: v(i),
        "onUpdate:cursor": A[4] || (A[4] = (C) => Xe(i) ? i.value = C : null)
      }, { startDate: o.value, endDate: s.value }), {
        label: k(({ value: C }) => [
          re("span", FFe, ie(v(Xo)(C)), 1),
          re("span", NFe, ie(v(X3)(C)), 1)
        ]),
        default: k(() => [
          w(v(bj), yt({
            "selection-start": v(a),
            "onUpdate:selectionStart": A[2] || (A[2] = (C) => Xe(a) ? a.value = C : null),
            "selection-end": v(c),
            "onUpdate:selectionEnd": A[3] || (A[3] = (C) => Xe(c) ? c.value = C : null)
          }, { startDate: o.value, endDate: s.value }), {
            label: k(({ start: C, end: M }) => [
              q(ie(S(C)) + " - " + ie(S(M)), 1)
            ]),
            default: k(() => [
              w(v(kj), {
                "start-date": o.value,
                "onUpdate:startDate": A[0] || (A[0] = (C) => o.value = C),
                "end-date": s.value,
                "onUpdate:endDate": A[1] || (A[1] = (C) => s.value = C),
                options: E.zoomOptions
              }, {
                default: k(() => [
                  w(v(tk), {
                    class: Bt(x.value.chart),
                    data: b.value,
                    options: { curve: "bumpX", startDate: o.value, endDate: s.value }
                  }, null, 8, ["class", "data", "options"])
                ]),
                _: 1
              }, 8, ["start-date", "end-date", "options"])
            ]),
            _: 1
          }, 16, ["selection-start", "selection-end"])
        ]),
        _: 1
      }, 16, ["cursor"])
    ], 512));
  }
}), BFe = { class: "event-resource-block-document-icon" }, UFe = ["src"], XFe = /* @__PURE__ */ U({
  __name: "EventResourceBlockDocumentIcon",
  props: {
    resource: {}
  },
  setup(t) {
    const e = t, { resource: n } = Nn(e), { id: r } = Cs(n), { blockDocument: o } = x_(r), s = D(() => o.value?.blockType.logoUrl);
    return (i, u) => {
      const l = P("p-icon");
      return T(), z("div", BFe, [
        s.value ? (T(), z("img", {
          key: 0,
          src: s.value,
          class: "event-resource-block-document-icon__logo"
        }, null, 8, UFe)) : (T(), O(l, {
          key: 1,
          icon: "CubeIcon"
        }))
      ]);
    };
  }
}), $Fe = /* @__PURE__ */ U({
  __name: "WorkspaceEventIcon",
  props: {
    event: {}
  },
  setup(t) {
    const e = t, n = D(() => e.event.resource), { role: r } = Cs(n), o = D(() => {
      switch (r.value) {
        case "block-document":
          return XFe;
        default:
          return null;
      }
    }), s = D(() => {
      switch (r.value) {
        case "work-queue":
          return "PWorkPool";
        case "flow-run":
          return "FlowRun";
        case "automation":
          return "Automation";
        case "flow":
          return "Flow";
        case "deployment":
          return "PDeployment";
        case "task-run":
          return "Task";
        case "block-document":
          return "CubeIcon";
        default:
          return null;
      }
    });
    return (i, u) => {
      const l = P("p-icon"), a = P("p-timeline-point");
      return T(), O(a, { class: "workspace-event-icon" }, {
        default: k(() => [
          o.value ? (T(), O(Mr(o.value), {
            key: 0,
            resource: n.value
          }, null, 8, ["resource"])) : s.value ? (T(), O(l, {
            key: 1,
            icon: s.value
          }, null, 8, ["icon"])) : j("", !0)
        ]),
        _: 1
      });
    };
  }
}), WFe = { class: "workspace-event-list-item-date__event-time" }, VFe = { class: "workspace-event-list-item-date__event-date" }, HFe = /* @__PURE__ */ U({
  __name: "WorkspaceEventListItemDate",
  props: {
    event: {},
    startDate: {},
    endDate: {},
    layout: {}
  },
  setup(t) {
    const e = t, { cursor: n } = OI(), { selectionStart: r, selectionEnd: o } = II(), s = je(), i = kc(), u = D(() => ({
      date: `workspace-event-list-item-date__occurred--${e.layout}`
    }));
    function l() {
      n.value = e.event.occurred;
    }
    function a() {
      n.value = null;
    }
    const c = D(() => {
      const d = e.event.occurred, h = o.value ?? e.endDate, m = {
        ...i.query,
        since: d.toISOString(),
        until: h.toISOString()
      };
      return gi(s.events(), m);
    }), p = D(() => {
      const d = r.value ?? e.startDate, h = e.event.occurred, m = {
        ...i.query,
        since: d.toISOString(),
        until: h.toISOString()
      };
      return gi(s.events(), m);
    });
    return (d, h) => {
      const m = P("p-icon-text"), g = P("p-link"), _ = P("p-tooltip");
      return T(), O(_, null, {
        content: k(() => [
          re("div", {
            class: "workspace-event-list-item-date__tooltip",
            onPointerenter: l,
            onPointerleave: a
          }, [
            w(g, { to: c.value }, {
              default: k(() => [
                w(m, { icon: "ArrowSmallRightIcon" }, {
                  default: k(() => [...h[0] || (h[0] = [
                    q(" Events since ", -1)
                  ])]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["to"]),
            w(g, { to: p.value }, {
              default: k(() => [
                w(m, { icon: "ArrowSmallLeftIcon" }, {
                  default: k(() => [...h[1] || (h[1] = [
                    q(" Events until ", -1)
                  ])]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["to"])
          ], 32)
        ]),
        default: k(() => [
          re("div", {
            class: Bt(["workspace-event-list-item-date workspace-event-list-item-date__occurred", u.value.date]),
            onPointerenter: l,
            onPointerleave: a
          }, [
            re("span", WFe, ie(d.event.occurredTime), 1),
            re("span", VFe, ie(d.event.occurredDate), 1)
          ], 34)
        ]),
        _: 1
      });
    };
  }
}), jFe = { class: "workspace-events-timeline-container__header" }, zFe = /* @__PURE__ */ U({
  __name: "WorkspaceEventsTimelineContent",
  props: {
    event: {}
  },
  setup(t) {
    const e = ge(!1), n = ns(e, 150), r = D(() => ({
      root: {
        "workspace-events-timeline-content--expanded": e.value
      },
      expander: {
        "workspace-events-timeline-content__expander--expanded": e.value
      },
      toggle: {
        "workspace-events-timeline-content__toggle--expanded": e.value
      },
      container: {
        "workspace-events-timeline-content__container--expanded": e.value
      }
    }));
    function o() {
      e.value = !e.value;
    }
    return (s, i) => {
      const u = P("p-button"), l = P("p-divider"), a = P("p-code-highlight"), c = P("p-card");
      return T(), O(c, {
        class: Bt(["workspace-events-timeline-content", r.value.root]),
        flat: !e.value
      }, {
        default: k(() => [
          re("div", {
            class: Bt(["workspace-events-timeline-content__container", r.value.container])
          }, [
            re("header", jFe, [
              w(DL, { event: s.event }, null, 8, ["event"]),
              w(N_, {
                class: "workspace-events-list-item__resource",
                event: s.event,
                alternate: ""
              }, null, 8, ["event"]),
              s.event.related.length ? (T(), O(F_, {
                key: 0,
                event: s.event,
                alternate: ""
              }, null, 8, ["event"])) : j("", !0)
            ]),
            re("div", {
              class: Bt(["workspace-events-timeline-content__expander", r.value.expander]),
              onClick: o
            }, [
              w(u, {
                size: "sm",
                class: Bt(["workspace-events-timeline-content__toggle", r.value.toggle]),
                icon: "ChevronDownIcon"
              }, null, 8, ["class"]),
              w(l)
            ], 2),
            e.value ? (T(), z(ve, { key: 0 }, [
              v(n) ? (T(), O(a, {
                key: 0,
                lang: "json",
                class: "workspace-events-timeline-content__raw",
                text: v(or)(s.event)
              }, null, 8, ["text"])) : j("", !0)
            ], 64)) : j("", !0)
          ], 2)
        ]),
        _: 1
      }, 8, ["class", "flat"]);
    };
  }
}), qFe = /* @__PURE__ */ U({
  __name: "WorkspaceEventsTimeline",
  props: {
    events: {},
    startDate: {},
    endDate: {},
    layout: {}
  },
  setup(t) {
    const e = t, n = D(() => e.layout ? e.layout : _s.sm ? "date-left" : "stacked-left");
    return (r, o) => {
      const s = P("p-timeline");
      return T(), O(s, {
        items: r.events,
        class: "workspace-events-timeline",
        layout: n.value
      }, {
        date: k(({ item: i }) => [
          v(M1)(i) ? (T(), O(HFe, sn(yt({ key: 0 }, { event: i, startDate: r.startDate, endDate: r.endDate, layout: n.value })), null, 16)) : j("", !0)
        ]),
        point: k(({ item: i }) => [
          v(M1)(i) ? (T(), O($Fe, {
            key: 0,
            event: i
          }, null, 8, ["event"])) : j("", !0)
        ]),
        content: k(({ item: i }) => [
          v(M1)(i) ? (T(), O(zFe, {
            key: 0,
            event: i
          }, null, 8, ["event"])) : j("", !0)
        ]),
        _: 1
      }, 8, ["items", "layout"]);
    };
  }
});
class GFe extends Ba {
  parse(e) {
    return JSON.parse(decodeURIComponent(e ?? ""));
  }
  format(e) {
    return encodeURIComponent(JSON.stringify(e));
  }
}
function i6e(t, e) {
  switch (t) {
    case "send-notification":
      return YFe(e);
    case "cancel-flow-run":
    case "suspend-flow-run":
    case "resume-flow-run":
    case "change-flow-run-state":
    case "run-deployment":
    case "pause-deployment":
    case "resume-deployment":
    case "pause-work-queue":
    case "resume-work-queue":
    case "pause-work-pool":
    case "resume-work-pool":
    case "pause-automation":
    case "resume-automation":
    case "do-nothing":
      return { type: t };
    default:
      throw new Error(`getDefaultValueForAction does not have case for action type: ${t}`);
  }
}
function YFe(t) {
  return {
    type: "send-notification",
    subject: nNe(t),
    body: tNe(t)
  };
}
const QFe = `
Name: {{ flow.name }}/{{ deployment.name }}
Status: {{ deployment.status }}
URL: {{ deployment|ui_url }}
`, KFe = `
Name: {{ work_pool.name }}
Status: {{ work_pool.status }}
URL: {{ work_pool|ui_url }}
`.trim(), ZFe = `
Name: {{ work_queue.name }}
Status: {{ work_queue.status }}
URL: {{ work_queue|ui_url }}
`.trim(), JFe = `
Flow run {{ flow.name }}/{{ flow_run.name }} observed in state \`{{ flow_run.state.name }}\` at {{ flow_run.state.timestamp }}.
Flow ID: {{ flow_run.flow_id }}
Flow run ID: {{ flow_run.id }}
Flow run URL: {{ flow_run|ui_url }}
State message: {{ flow_run.state.message }}
`.trim(), eNe = `
Automation: {{ automation.name }}
Description: {{ automation.description }}

Event: {{ event.id }}
Resource:
{% for label, value in event.resource %}
{{ label }}: {{ value }}
{% endfor %}
Related Resources:
{% for related in event.related %}
    Role: {{ related.role }}
    {% for label, value in related %}
    {{ label }}: {{ value }}
    {% endfor %}
{% endfor %}
`.trim();
function tNe(t) {
  switch (t) {
    case "deployment-status":
      return QFe;
    case "flow-run-state":
      return JFe;
    case "work-pool-status":
      return KFe;
    case "work-queue-status":
      return ZFe;
    case "custom":
      return eNe;
    default:
      const e = t;
      throw new Error(`Default notification body missing for template type: ${e}`);
  }
}
function nNe(t) {
  switch (t) {
    case "deployment-status":
      return "Prefect deployment '{{ flow.name }}/{{ deployment.name }}' has entered status '{{ deployment.status }}'";
    case "flow-run-state":
      return "Prefect flow run notification";
    case "work-pool-status":
      return "Prefect work pool '{{ work_pool.name }}' has entered status '{{ work_pool.status }}'";
    case "work-queue-status":
      return "Prefect work queue '{{ work_queue.name }}' has entered status '{{ work_queue.status }}'";
    case "custom":
      return "A Prefect automation '{{ automation.name }}' was triggered";
    default:
      const e = t;
      throw new Error(`Default notification subject missing for template type: ${e}`);
  }
}
function u6e(t) {
  return rNe[t];
}
const rNe = {
  "deployment-status": ye.map("DeploymentStatusTrigger", {
    deployments: [],
    posture: "Reactive",
    status: "not_ready",
    time: 30
  }, "AutomationTrigger"),
  "flow-run-state": ye.map("FlowRunStateTrigger", {
    posture: "Reactive",
    flowIds: [],
    tags: [],
    states: [],
    time: 30
  }, "AutomationTrigger"),
  "work-pool-status": ye.map("WorkPoolStatusTrigger", {
    workPools: [],
    posture: "Reactive",
    status: "not_ready",
    time: 30
  }, "AutomationTrigger"),
  "work-queue-status": ye.map("WorkQueueStatusTrigger", {
    workPools: [],
    workQueues: [],
    status: "not_ready",
    posture: "Reactive",
    time: 30
  }, "AutomationTrigger"),
  custom: new $o({
    posture: "Reactive",
    match: {
      "prefect.resource.id": ["prefect.flow-run.*"]
    },
    forEach: [],
    expect: ["prefect.flow-run.Failed"],
    threshold: 5,
    within: 60
  })
}, oNe = /* @__PURE__ */ U({
  __name: "AutomationActionChangeFlowRunStateInput",
  props: {
    action: {}
  },
  emits: ["update:action"],
  setup(t, { emit: e }) {
    const n = t, r = e, o = D(() => oh.map((a) => ({
      label: yi(a),
      value: a.toUpperCase()
    }))), s = D({
      get() {
        return n.action.state;
      },
      set(a) {
        r("update:action", { ...n.action, state: a });
      }
    }), i = D({
      get() {
        return n.action.name ?? "";
      },
      set(a) {
        r("update:action", { ...n.action, name: a });
      }
    }), u = D(() => {
      const a = s.value ?? "";
      return yi(a.toLowerCase());
    }), l = D({
      get() {
        return n.action.message ?? "";
      },
      set(a) {
        r("update:action", { ...n.action, message: a });
      }
    });
    return (a, c) => {
      const p = P("p-select"), d = P("p-label"), h = P("p-text-input"), m = P("p-textarea"), g = P("p-content");
      return T(), O(g, { class: "automation-action-change-flow-run-state-input" }, {
        default: k(() => [
          w(d, { label: "State" }, {
            default: k(() => [
              w(p, {
                modelValue: s.value,
                "onUpdate:modelValue": c[0] || (c[0] = (_) => s.value = _),
                options: o.value
              }, null, 8, ["modelValue", "options"])
            ]),
            _: 1
          }),
          w(d, { label: "Name" }, {
            default: k(() => [
              w(h, {
                modelValue: i.value,
                "onUpdate:modelValue": c[1] || (c[1] = (_) => i.value = _),
                placeholder: u.value
              }, null, 8, ["modelValue", "placeholder"])
            ]),
            _: 1
          }),
          w(d, { label: "Message" }, {
            default: k(() => [
              w(m, {
                modelValue: l.value,
                "onUpdate:modelValue": c[2] || (c[2] = (_) => l.value = _),
                placeholder: "State changed by Automation <id>"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _: 1
      });
    };
  }
}), sNe = /* @__PURE__ */ U({
  __name: "AutomationCombobox",
  props: {
    selected: {},
    emptyMessage: {},
    allowUnset: { type: Boolean },
    multiple: { type: Boolean }
  },
  emits: ["update:selected"],
  setup(t, { emit: e }) {
    const n = t, r = e, o = D(() => n.multiple || Array.isArray(n.selected)), s = D({
      get() {
        return n.selected ?? null;
      },
      set(c) {
        c ? o.value ? r("update:selected", Array.isArray(c) ? c : [c]) : r("update:selected", c) : r("update:selected", null);
      }
    }), i = Se(), u = mt(i.automations.getAutomations), l = D(() => u.response ?? []), a = D(() => {
      const c = l.value.map((p) => ({
        value: p.id,
        label: p.name
      }));
      return n.allowUnset && c.unshift({
        value: null,
        label: "None"
      }), c;
    });
    return (c, p) => (T(), O(v(ts), yt({
      modelValue: s.value,
      "onUpdate:modelValue": p[0] || (p[0] = (d) => s.value = d)
    }, { options: a.value, multiple: o.value, emptyMessage: c.emptyMessage }), {
      "combobox-options-empty": k(() => [...p[1] || (p[1] = [
        q(" No automations ", -1)
      ])]),
      default: k((d) => [
        Ve(c.$slots, "default", sn(kn(d)))
      ]),
      option: k(({ option: d }) => [
        Ve(c.$slots, "option", { option: d })
      ]),
      _: 3
    }, 16, ["modelValue"]));
  }
}), IX = /* @__PURE__ */ U({
  __name: "AutomationAutomationCombobox",
  props: {
    selected: {}
  },
  emits: ["update:selected"],
  setup(t, { emit: e }) {
    const n = t, r = e, o = D({
      get() {
        return n.selected;
      },
      set(s) {
        r("update:selected", s);
      }
    });
    return (s, i) => (T(), O(sNe, {
      selected: o.value,
      "onUpdate:selected": i[0] || (i[0] = (u) => o.value = u),
      "empty-message": "Infer Automation",
      class: "automation-automation-combobox"
    }, {
      option: k(({ option: u }) => [
        u.value === null ? (T(), z(ve, { key: 0 }, [
          q(" Infer Automation ")
        ], 64)) : j("", !0)
      ]),
      _: 1
    }, 8, ["selected"]));
  }
}), aNe = /* @__PURE__ */ U({
  __name: "AutomationActionPauseAutomationInput",
  props: {
    action: {}
  },
  emits: ["update:action"],
  setup(t, { emit: e }) {
    const n = t, r = e, o = D({
      get() {
        return n.action.automationId ?? null;
      },
      set(s) {
        r("update:action", { ...n.action, automationId: s });
      }
    });
    return (s, i) => {
      const u = P("p-label"), l = P("p-content");
      return T(), O(l, { class: "automation-action-pause-automation-input" }, {
        default: k(() => [
          w(u, { label: "Automation To Pause" }, {
            default: k(({ id: a }) => [
              w(IX, {
                id: a,
                selected: o.value,
                "onUpdate:selected": i[0] || (i[0] = (c) => o.value = c),
                "allow-unset": ""
              }, null, 8, ["id", "selected"])
            ]),
            _: 1
          })
        ]),
        _: 1
      });
    };
  }
}), cw = /* @__PURE__ */ U({
  __name: "AutomationDeploymentCombobox",
  props: {
    selected: {}
  },
  emits: ["update:selected"],
  setup(t, { emit: e }) {
    const n = t, r = e, o = D({
      get() {
        return n.selected ?? null;
      },
      set(s) {
        r("update:selected", s);
      }
    });
    return (s, i) => (T(), O(oS, {
      selected: o.value,
      "onUpdate:selected": i[0] || (i[0] = (u) => o.value = u),
      "allow-unset": "",
      "empty-message": "Infer Deployment",
      class: "automation-deployment-combobox"
    }, {
      option: k(({ option: u }) => [
        u.value === null ? (T(), z(ve, { key: 0 }, [
          q(" Infer Deployment ")
        ], 64)) : j("", !0)
      ]),
      _: 1
    }, 8, ["selected"]));
  }
}), iNe = /* @__PURE__ */ U({
  __name: "AutomationActionPauseDeploymentInput",
  props: {
    action: {}
  },
  emits: ["update:action"],
  setup(t, { emit: e }) {
    const n = t, r = e, o = D({
      get() {
        return n.action.deploymentId ?? null;
      },
      set(s) {
        r("update:action", { ...n.action, deploymentId: s });
      }
    });
    return (s, i) => {
      const u = P("p-label"), l = P("p-content");
      return T(), O(l, { class: "automation-action-pause-deployment-input" }, {
        default: k(() => [
          w(u, { label: "Deployment To Pause" }, {
            default: k(({ id: a }) => [
              w(cw, {
                id: a,
                selected: o.value,
                "onUpdate:selected": i[0] || (i[0] = (c) => o.value = c),
                "allow-unset": ""
              }, null, 8, ["id", "selected"])
            ]),
            _: 1
          })
        ]),
        _: 1
      });
    };
  }
}), pw = /* @__PURE__ */ U({
  __name: "AutomationWorkPoolCombobox",
  props: {
    selected: {}
  },
  emits: ["update:selected"],
  async setup(t, { emit: e }) {
    let n, r;
    const o = t, s = e, i = Se(), u = Array.isArray(o.selected), l = ([n, r] = fx(() => mt(i.workPools.getWorkPools, [{}]).promise()), n = await n, r(), n), a = D(() => l.response.filter((h) => !!h.status));
    function c(h) {
      return h instanceof Jx;
    }
    const p = D(() => a.value.map((m) => ({
      value: m.name,
      label: m.name
    }))), d = D({
      get() {
        const g = tl(o.selected).map((b) => a.value.find((x) => x.id === b)).filter(c).map((b) => b.name);
        if (u)
          return g;
        const [_ = null] = g;
        return _;
      },
      set(h) {
        const _ = tl(h).map((x) => a.value.find((S) => S.name === x)).filter(c).map((x) => x.id);
        if (u) {
          s("update:selected", _);
          return;
        }
        const [b = null] = _;
        return s("update:selected", b);
      }
    });
    return (h, m) => {
      const g = P("p-combobox");
      return T(), O(g, {
        modelValue: d.value,
        "onUpdate:modelValue": m[0] || (m[0] = (_) => d.value = _),
        multiple: v(u),
        "empty-message": "Infer Work Pool",
        options: p.value
      }, {
        option: k(({ option: _ }) => [
          _.value === null ? (T(), z(ve, { key: 0 }, [
            q(" Infer Work Pool ")
          ], 64)) : j("", !0)
        ]),
        _: 1
      }, 8, ["modelValue", "multiple", "options"]);
    };
  }
}), uNe = /* @__PURE__ */ U({
  __name: "AutomationActionPauseWorkPoolInput",
  props: {
    action: {}
  },
  emits: ["update:action"],
  setup(t, { emit: e }) {
    const n = t, r = e, o = D({
      get() {
        return n.action.workPoolId ?? null;
      },
      set(s) {
        r("update:action", { ...n.action, workPoolId: s });
      }
    });
    return (s, i) => {
      const u = P("p-label"), l = P("p-content");
      return T(), O(l, { class: "automation-action-pause-work-pool-input" }, {
        default: k(() => [
          w(u, { label: "Work Pool To Pause" }, {
            default: k(({ id: a }) => [
              w(pw, {
                id: a,
                selected: o.value,
                "onUpdate:selected": i[0] || (i[0] = (c) => o.value = c),
                "allow-unset": ""
              }, null, 8, ["id", "selected"])
            ]),
            _: 1
          })
        ]),
        _: 1
      });
    };
  }
}), NR = /* @__PURE__ */ U({
  __name: "AutomationWorkQueueCombobox",
  props: {
    selected: {},
    workPoolIds: {}
  },
  emits: ["update:selected"],
  setup(t, { emit: e }) {
    const n = t, r = e, o = D(() => n.workPoolIds?.length ? { id: n.workPoolIds } : {}), s = D({
      get() {
        return n.selected;
      },
      set(i) {
        r("update:selected", i);
      }
    });
    return (i, u) => (T(), O(CX, {
      selected: s.value,
      "onUpdate:selected": u[0] || (u[0] = (l) => s.value = l),
      "empty-message": "Infer Work Queue",
      class: "automation-work-queue-combobox",
      "work-pool-filter": o.value
    }, {
      option: k(({ option: l }) => [
        l.value === null ? (T(), z(ve, { key: 0 }, [
          q(" Infer Work Queue ")
        ], 64)) : j("", !0)
      ]),
      _: 1
    }, 8, ["selected", "work-pool-filter"]));
  }
}), lNe = /* @__PURE__ */ U({
  __name: "AutomationActionPauseWorkQueueInput",
  props: {
    action: {}
  },
  emits: ["update:action"],
  setup(t, { emit: e }) {
    const n = t, r = e, o = D({
      get() {
        return n.action.workQueueId ?? null;
      },
      set(s) {
        r("update:action", { ...n.action, workQueueId: s });
      }
    });
    return (s, i) => {
      const u = P("p-label"), l = P("p-content");
      return T(), O(l, { class: "automation-action-pause-work-queue-input" }, {
        default: k(() => [
          w(u, { label: "Work Queue To Pause" }, {
            default: k(({ id: a }) => [
              w(NR, {
                id: a,
                selected: o.value,
                "onUpdate:selected": i[0] || (i[0] = (c) => o.value = c),
                "allow-unset": ""
              }, null, 8, ["id", "selected"])
            ]),
            _: 1
          })
        ]),
        _: 1
      });
    };
  }
}), cNe = /* @__PURE__ */ U({
  __name: "AutomationActionResumeAutomationInput",
  props: {
    action: {}
  },
  emits: ["update:action"],
  setup(t, { emit: e }) {
    const n = t, r = e, o = D({
      get() {
        return n.action.automationId ?? null;
      },
      set(s) {
        r("update:action", { ...n.action, automationId: s });
      }
    });
    return (s, i) => {
      const u = P("p-label"), l = P("p-content");
      return T(), O(l, { class: "automation-action-resume-automation-input" }, {
        default: k(() => [
          w(u, { label: "Automation To Resume" }, {
            default: k(({ id: a }) => [
              w(IX, {
                id: a,
                selected: o.value,
                "onUpdate:selected": i[0] || (i[0] = (c) => o.value = c),
                "allow-unset": ""
              }, null, 8, ["id", "selected"])
            ]),
            _: 1
          })
        ]),
        _: 1
      });
    };
  }
}), pNe = /* @__PURE__ */ U({
  __name: "AutomationActionResumeDeploymentInput",
  props: {
    action: {}
  },
  emits: ["update:action"],
  setup(t, { emit: e }) {
    const n = t, r = e, o = D({
      get() {
        return n.action.deploymentId ?? null;
      },
      set(s) {
        r("update:action", { ...n.action, deploymentId: s });
      }
    });
    return (s, i) => {
      const u = P("p-label"), l = P("p-content");
      return T(), O(l, { class: "automation-action-resume-deployment-input" }, {
        default: k(() => [
          w(u, { label: "Deployment To Resume" }, {
            default: k(({ id: a }) => [
              w(cw, {
                id: a,
                selected: o.value,
                "onUpdate:selected": i[0] || (i[0] = (c) => o.value = c)
              }, null, 8, ["id", "selected"])
            ]),
            _: 1
          })
        ]),
        _: 1
      });
    };
  }
}), dNe = /* @__PURE__ */ U({
  __name: "AutomationActionResumeWorkPoolInput",
  props: {
    action: {}
  },
  emits: ["update:action"],
  setup(t, { emit: e }) {
    const n = t, r = e, o = D({
      get() {
        return n.action.workPoolId ?? null;
      },
      set(s) {
        r("update:action", { ...n.action, workPoolId: s });
      }
    });
    return (s, i) => {
      const u = P("p-label"), l = P("p-content");
      return T(), O(l, { class: "automation-action-resume-work-pool-input" }, {
        default: k(() => [
          w(u, { label: "Work Pool To Resume" }, {
            default: k(({ id: a }) => [
              w(pw, {
                id: a,
                selected: o.value,
                "onUpdate:selected": i[0] || (i[0] = (c) => o.value = c),
                "allow-unset": ""
              }, null, 8, ["id", "selected"])
            ]),
            _: 1
          })
        ]),
        _: 1
      });
    };
  }
}), hNe = /* @__PURE__ */ U({
  __name: "AutomationActionResumeWorkQueueInput",
  props: {
    action: {}
  },
  emits: ["update:action"],
  setup(t, { emit: e }) {
    const n = t, r = e, o = D({
      get() {
        return n.action.workQueueId ?? null;
      },
      set(s) {
        r("update:action", { ...n.action, workQueueId: s });
      }
    });
    return (s, i) => {
      const u = P("p-label"), l = P("p-content");
      return T(), O(l, { class: "automation-action-resume-work-queue-input" }, {
        default: k(() => [
          w(u, { label: "Work Queue To Resume" }, {
            default: k(({ id: a }) => [
              w(NR, {
                id: a,
                selected: o.value,
                "onUpdate:selected": i[0] || (i[0] = (c) => o.value = c),
                "allow-unset": ""
              }, null, 8, ["id", "selected"])
            ]),
            _: 1
          })
        ]),
        _: 1
      });
    };
  }
}), fNe = { class: "automation-action-run-deployment-parameters__header" }, mNe = /* @__PURE__ */ U({
  __name: "AutomationActionRunDeploymentParameters",
  props: {
    deployment: {},
    values: {}
  },
  emits: ["update:values"],
  setup(t, { emit: e }) {
    const n = t, r = e, o = D({
      get() {
        return wn(n.values) ? n.values : {};
      },
      set(d) {
        r("update:values", d);
      }
    }), s = D(() => {
      const d = n.deployment.parameterOpenApiSchema, h = [], m = Object.keys(n.deployment.parameters);
      return d.required?.forEach((g) => {
        m.includes(g) || h.push(g);
      }), { ...d, required: h };
    }), { errors: i, validate: u } = Xh(s, o);
    bn(o, async (d, h, { signal: m, source: g, previousValue: _ }) => {
      if (d !== _ && (g === "validator" && await RF(5e3, m), !m.aborted))
        return await u();
    });
    const { value: a, set: c } = hl("automation-action-run-deployment-parameters-merge-message", !1);
    function p() {
      c(!0);
    }
    return (d, h) => {
      const m = P("p-overflow-menu-item"), g = P("p-icon-button-menu"), _ = P("p-message"), b = P("p-content");
      return T(), O(b, { class: "automation-action-run-deployment-parameters" }, {
        default: k(() => [
          w(v(Uh), {
            values: o.value,
            "onUpdate:values": h[0] || (h[0] = (x) => o.value = x),
            schema: s.value,
            errors: v(i),
            kinds: ["none", "json", "jinja", "workspace_variable"],
            "skip-default-value-initialization": ""
          }, {
            default: k(({ kind: x, setKind: S }) => [
              w(b, { secondary: "" }, {
                default: k(() => [
                  re("div", fNe, [
                    h[1] || (h[1] = re("h3", { class: "deployment-form__heading" }, " Parameters ", -1)),
                    w(g, { small: "" }, {
                      default: k(() => [
                        x !== "none" ? (T(), O(m, {
                          key: 0,
                          label: "Use form input",
                          onClick: (E) => S("none")
                        }, null, 8, ["onClick"])) : j("", !0),
                        x !== "json" ? (T(), O(m, {
                          key: 1,
                          label: "Use JSON input",
                          onClick: (E) => S("json")
                        }, null, 8, ["onClick"])) : j("", !0),
                        x !== "jinja" ? (T(), O(m, {
                          key: 2,
                          label: "Use Jinja input",
                          onClick: (E) => S("jinja")
                        }, null, 8, ["onClick"])) : j("", !0)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  v(a) ? j("", !0) : (T(), O(_, {
                    key: 0,
                    dismissible: "",
                    onDismiss: p
                  }, {
                    default: k(() => [...h[2] || (h[2] = [
                      q(" Parameters defined for an automation action will be merged with the deployment's default parameters when the action is executed. ", -1)
                    ])]),
                    _: 1
                  }))
                ]),
                _: 2
              }, 1024)
            ]),
            _: 1
          }, 8, ["values", "schema", "errors"])
        ]),
        _: 1
      });
    };
  }
}), yNe = /* @__PURE__ */ U({
  __name: "AutomationActionRunDeploymentInput",
  props: {
    action: {}
  },
  emits: ["update:action"],
  setup(t, { emit: e }) {
    const n = t, r = e, o = Se(), s = /* @__PURE__ */ new Map(), i = D(() => n.action.deploymentId ?? null), u = ge();
    async function l(m) {
      if (!Ht(m))
        return;
      u.value = await o.deployments.getDeployment(m);
      const g = c(m) ?? { ...u.value.parameters };
      r("update:action", { ...n.action, deploymentId: m, parameters: g });
    }
    const a = D({
      get() {
        return n.action.parameters ?? {};
      },
      set(m) {
        p(i.value, m), r("update:action", { ...n.action, parameters: m });
      }
    });
    function c(m) {
      return m !== null ? s.get(m) ?? null : null;
    }
    function p(m, g) {
      m !== null && g !== null && s.set(m, g);
    }
    const d = ge(or(n.action.jobVariables ?? {}));
    Ct(n.action, () => d.value = or(n.action.jobVariables ?? {}));
    function h(m) {
      d.value = m ?? "{}";
      try {
        const g = JSON.parse(m ?? "{}");
        r("update:action", { ...n.action, jobVariables: g });
      } catch {
      }
    }
    return wi(() => {
      i.value && (l(i.value), n.action.parameters && p(i.value, n.action.parameters));
    }), (m, g) => {
      const _ = P("p-label"), b = P("p-content");
      return T(), O(b, { class: "automation-action-run-deployment" }, {
        default: k(() => [
          w(_, { label: "Deployment To Run" }, {
            default: k(({ id: x }) => [
              w(cw, {
                id: x,
                selected: i.value,
                "onUpdate:selected": l
              }, null, 8, ["id", "selected"])
            ]),
            _: 1
          }),
          u.value && u.value.id === i.value ? (T(), z(ve, { key: 0 }, [
            (T(), O(mNe, {
              key: i.value,
              values: a.value,
              "onUpdate:values": g[0] || (g[0] = (x) => a.value = x),
              deployment: u.value
            }, null, 8, ["values", "deployment"])),
            w(L_, {
              "model-value": d.value,
              "onUpdate:modelValue": h
            }, null, 8, ["model-value"])
          ], 64)) : j("", !0)
        ]),
        _: 1
      });
    };
  }
}), gNe = /* @__PURE__ */ U({
  __name: "AutomationActionSendNotificationInput",
  props: {
    action: {}
  },
  emits: ["update:action"],
  setup(t, { emit: e }) {
    const n = t, r = e, o = Se(), s = async (S, E, A) => await u(S, E, A), i = async (S, E, A) => await u(S, E, A), u = async (S, E, { signal: A, source: C, previousValue: M }) => {
      if (S === M || (C === "validator" && await RF(3e3, A), A.aborted))
        return;
      const L = await o.automations.validateTemplate(S);
      return L === !0 ? !0 : L;
    }, l = D({
      get() {
        return n.action.blockDocumentId ?? "";
      },
      set(S) {
        r("update:action", { ...n.action, blockDocumentId: S });
      }
    }), { state: a, error: c } = bn(l, "Block", Kr("Block")), { blockDocument: p } = x_(l), d = D(() => p.value?.isAnonymous ?? !1), h = D({
      get() {
        return n.action.subject ?? "";
      },
      set(S) {
        r("update:action", { ...n.action, subject: S });
      }
    }), { state: m, error: g } = bn(h, "Subject", [Kr("Subject"), s]), _ = D({
      get() {
        return n.action.body ?? "";
      },
      set(S) {
        r("update:action", { ...n.action, body: S });
      }
    }), { state: b, error: x } = bn(_, "Body", [Kr("Body"), i]);
    return (S, E) => {
      const A = P("p-label"), C = P("p-message"), M = P("p-code-input"), L = P("p-code"), X = P("p-content");
      return T(), O(X, { class: "automation-action-send-notification" }, {
        default: k(() => [
          w(A, {
            label: "Block",
            state: v(a),
            message: v(c)
          }, {
            default: k(() => [
              w(_4, {
                modelValue: l.value,
                "onUpdate:modelValue": E[0] || (E[0] = (te) => l.value = te),
                state: v(a),
                capability: "notify",
                required: "",
                "use-modal": ""
              }, null, 8, ["modelValue", "state"])
            ]),
            _: 1
          }, 8, ["state", "message"]),
          d.value ? (T(), O(C, {
            key: 0,
            info: ""
          }, {
            default: k(() => [...E[3] || (E[3] = [
              q(" This notification action is using an anonymous block. This is most likely because it was migrated from an existing notification. ", -1)
            ])]),
            _: 1
          })) : j("", !0),
          w(A, {
            label: "Subject",
            state: v(m),
            message: v(g)
          }, {
            default: k(() => [
              w(M, {
                modelValue: h.value,
                "onUpdate:modelValue": E[1] || (E[1] = (te) => h.value = te),
                state: v(m),
                lang: "jinja"
              }, null, 8, ["modelValue", "state"])
            ]),
            _: 1
          }, 8, ["state", "message"]),
          w(A, {
            label: "Body",
            state: v(b),
            message: v(x)
          }, {
            default: k(() => [
              w(M, {
                modelValue: _.value,
                "onUpdate:modelValue": E[2] || (E[2] = (te) => _.value = te),
                state: v(b),
                rows: "5",
                lang: "jinja"
              }, null, 8, ["modelValue", "state"])
            ]),
            _: 1
          }, 8, ["state", "message"]),
          w(C, { info: "" }, {
            default: k(() => [
              E[10] || (E[10] = q(" In addition to any fields present on the triggering event, the following objects can be used in notification templates: ", -1)),
              w(L, { inline: "" }, {
                default: k(() => [...E[4] || (E[4] = [
                  q(" flow ", -1)
                ])]),
                _: 1
              }),
              E[11] || (E[11] = q(", ", -1)),
              w(L, { inline: "" }, {
                default: k(() => [...E[5] || (E[5] = [
                  q(" deployment ", -1)
                ])]),
                _: 1
              }),
              E[12] || (E[12] = q(", ", -1)),
              w(L, { inline: "" }, {
                default: k(() => [...E[6] || (E[6] = [
                  q(" flow_run ", -1)
                ])]),
                _: 1
              }),
              E[13] || (E[13] = q(", ", -1)),
              w(L, { inline: "" }, {
                default: k(() => [...E[7] || (E[7] = [
                  q(" work_pool ", -1)
                ])]),
                _: 1
              }),
              E[14] || (E[14] = q(", ", -1)),
              w(L, { inline: "" }, {
                default: k(() => [...E[8] || (E[8] = [
                  q(" work_queue ", -1)
                ])]),
                _: 1
              }),
              E[15] || (E[15] = q(", and ", -1)),
              w(L, { inline: "" }, {
                default: k(() => [...E[9] || (E[9] = [
                  q(" metric ", -1)
                ])]),
                _: 1
              }),
              E[16] || (E[16] = q(". ", -1))
            ]),
            _: 1
          })
        ]),
        _: 1
      });
    };
  }
}), l6e = /* @__PURE__ */ U({
  __name: "AutomationActionInput",
  props: {
    action: {}
  },
  emits: ["update:action"],
  setup(t, { emit: e }) {
    const n = t, r = e, o = D(() => {
      switch (n.action.type) {
        case "change-flow-run-state":
          return wt(oNe, {
            action: n.action,
            "onUpdate:action": (i) => r("update:action", i)
          });
        case "run-deployment":
          return wt(yNe, {
            action: n.action,
            "onUpdate:action": (i) => r("update:action", i)
          });
        case "pause-deployment":
          return wt(iNe, {
            action: n.action,
            "onUpdate:action": (i) => r("update:action", i)
          });
        case "resume-deployment":
          return wt(pNe, {
            action: n.action,
            "onUpdate:action": (i) => r("update:action", i)
          });
        case "pause-work-pool":
          return wt(uNe, {
            action: n.action,
            "onUpdate:action": (i) => r("update:action", i)
          });
        case "resume-work-pool":
          return wt(dNe, {
            action: n.action,
            "onUpdate:action": (i) => r("update:action", i)
          });
        case "pause-work-queue":
          return wt(lNe, {
            action: n.action,
            "onUpdate:action": (i) => r("update:action", i)
          });
        case "resume-work-queue":
          return wt(hNe, {
            action: n.action,
            "onUpdate:action": (i) => r("update:action", i)
          });
        case "pause-automation":
          return wt(aNe, {
            action: n.action,
            "onUpdate:action": (i) => r("update:action", i)
          });
        case "resume-automation":
          return wt(cNe, {
            action: n.action,
            "onUpdate:action": (i) => r("update:action", i)
          });
        case "send-notification":
          return wt(gNe, {
            action: n.action,
            "onUpdate:action": (i) => r("update:action", i)
          });
        case "cancel-flow-run":
        case "suspend-flow-run":
        case "resume-flow-run":
        case "do-nothing":
          return null;
        case void 0:
          throw new Error("AutomationActionInput.vue action.type is undefined");
        default:
          const s = n.action;
          throw new Error(`AutomationActionInput.vue missing case for action type: ${s.type}`);
      }
    });
    return (s, i) => o.value ? (T(), O(Mr(o.value.component), yt({ key: 0 }, o.value.props, { class: "automation-action-input" }), null, 16)) : j("", !0);
  }
}), vNe = { class: "automation-action-description-change-flow-run-state" }, _Ne = /* @__PURE__ */ U({
  __name: "AutomationActionDescriptionChangeFlowRunState",
  props: {
    action: {}
  },
  setup(t) {
    const e = t, n = D(() => ({
      type: ye.map("ServerStateType", e.action.state, "StateType"),
      name: SF(e.action.name ?? e.action.state)
    }));
    return (r, o) => (T(), z("div", vNe, [
      o[0] || (o[0] = q(" Change the state of the flow run inferred from the triggering event to ", -1)),
      w(Dr, { state: n.value }, null, 8, ["state"])
    ]));
  }
}), wNe = { class: "automation-action-description-pause-resume-automation" }, bNe = { key: 1 }, kNe = /* @__PURE__ */ U({
  __name: "AutomationActionDescriptionPauseResumeAutomation",
  props: {
    action: {}
  },
  setup(t) {
    const e = t, n = D(() => e.action.type === "pause-automation" ? "Pause" : "Resume");
    return (r, o) => (T(), z("div", wNe, [
      r.action.automationId ? (T(), z(ve, { key: 0 }, [
        q(ie(n.value) + " automation: ", 1),
        w(yL, {
          "automation-id": r.action.automationId
        }, null, 8, ["automation-id"])
      ], 64)) : (T(), z("span", bNe, ie(n.value) + " automation inferred from the triggering event", 1))
    ]));
  }
}), TNe = { class: "automation-action-description-pause-resume-deployment" }, xNe = { key: 1 }, SNe = /* @__PURE__ */ U({
  __name: "AutomationActionDescriptionPauseResumeDeployment",
  props: {
    action: {}
  },
  setup(t) {
    const e = t, n = D(() => e.action.type === "pause-deployment" ? "Pause" : "Resume");
    return (r, o) => (T(), z("div", TNe, [
      r.action.deploymentId ? (T(), z(ve, { key: 0 }, [
        q(ie(n.value) + " deployment: ", 1),
        w($h, {
          "deployment-id": r.action.deploymentId
        }, null, 8, ["deployment-id"])
      ], 64)) : (T(), z("span", xNe, ie(n.value) + " deployment inferred from the triggering event", 1))
    ]));
  }
}), RNe = { class: "automation-action-description-pause-resume-work-pool" }, ANe = { key: 1 }, DNe = /* @__PURE__ */ U({
  __name: "AutomationActionDescriptionPauseResumeWorkPool",
  props: {
    action: {}
  },
  setup(t) {
    const e = t, { workPool: n } = xN(() => e.action.workPoolId), r = D(() => e.action.type === "pause-work-pool" ? "Pause" : "Resume");
    return (o, s) => (T(), z("div", RNe, [
      o.action.workPoolId ? (T(), z(ve, { key: 0 }, [
        v(n) ? (T(), z(ve, { key: 0 }, [
          q(ie(r.value) + " work pool: ", 1),
          w(Wh, {
            "work-pool-name": v(n).name
          }, null, 8, ["work-pool-name"])
        ], 64)) : j("", !0)
      ], 64)) : (T(), z("span", ANe, ie(r.value) + " work pool inferred from the triggering event", 1))
    ]));
  }
}), ENe = { class: "automation-action-description-pause-resume-work-queue" }, MNe = { key: 1 }, PNe = /* @__PURE__ */ U({
  __name: "AutomationActionDescriptionPauseResumeWorkQueue",
  props: {
    action: {}
  },
  setup(t) {
    const e = t, { workPoolQueue: n } = AN(() => e.action.workQueueId), r = D(() => e.action.type === "pause-work-queue" ? "Pause" : "Resume");
    return (o, s) => (T(), z("div", ENe, [
      o.action.workQueueId ? (T(), z(ve, { key: 0 }, [
        v(n) ? (T(), z(ve, { key: 0 }, [
          q(ie(r.value) + " work queue: ", 1),
          w(lw, {
            "work-queue-name": v(n).name,
            "work-pool-name": v(n).workPoolName
          }, null, 8, ["work-queue-name", "work-pool-name"])
        ], 64)) : j("", !0)
      ], 64)) : (T(), z("span", MNe, ie(r.value) + " work queue inferred from the triggering event", 1))
    ]));
  }
}), CNe = {};
function ONe(t, e) {
  return T(), z("p", null, "Resume a flow run inferred from the triggering event");
}
const INe = /* @__PURE__ */ Dc(CNe, [["render", ONe]]), FNe = { class: "automation_action-description-run-deployment__deployment" }, NNe = { key: 1 }, LNe = /* @__PURE__ */ U({
  inheritAttrs: !1,
  __name: "AutomationActionDescriptionRunDeployment",
  props: {
    action: {}
  },
  setup(t) {
    const { showModal: e, open: n, close: r } = St(), { showModal: o, open: s, close: i } = St();
    return (u, l) => {
      const a = P("p-button"), c = P("p-code-highlight"), p = P("p-modal");
      return T(), z(ve, null, [
        re("div", yt({ class: "automation-action-description-run-deployment" }, u.$attrs), [
          u.action.deploymentId ? (T(), z(ve, { key: 0 }, [
            re("span", FNe, [
              l[2] || (l[2] = q("Run deployment: ", -1)),
              w($h, {
                "deployment-id": u.action.deploymentId
              }, null, 8, ["deployment-id"])
            ]),
            w(a, {
              size: "sm",
              onClick: v(n)
            }, {
              default: k(() => [...l[3] || (l[3] = [
                q(" Show parameters ", -1)
              ])]),
              _: 1
            }, 8, ["onClick"]),
            u.action.jobVariables ? (T(), O(a, {
              key: 0,
              size: "sm",
              onClick: v(s)
            }, {
              default: k(() => [...l[4] || (l[4] = [
                q(" Show job variables ", -1)
              ])]),
              _: 1
            }, 8, ["onClick"])) : j("", !0)
          ], 64)) : (T(), z("span", NNe, "Run deployment inferred from the triggering event"))
        ], 16),
        w(p, {
          "show-modal": v(e),
          "onUpdate:showModal": l[0] || (l[0] = (d) => Xe(e) ? e.value = d : null),
          title: "Parameters",
          "auto-close": ""
        }, {
          cancel: k(() => [
            w(a, { onClick: v(r) }, {
              default: k(() => [...l[5] || (l[5] = [
                q(" Close ", -1)
              ])]),
              _: 1
            }, 8, ["onClick"])
          ]),
          default: k(() => [
            w(c, {
              text: v(or)(u.action.parameters),
              lang: "json"
            }, null, 8, ["text"])
          ]),
          _: 1
        }, 8, ["show-modal"]),
        w(p, {
          "show-modal": v(o),
          "onUpdate:showModal": l[1] || (l[1] = (d) => Xe(o) ? o.value = d : null),
          title: "Job Variables",
          "auto-close": ""
        }, {
          cancel: k(() => [
            w(a, { onClick: v(i) }, {
              default: k(() => [...l[6] || (l[6] = [
                q(" Close ", -1)
              ])]),
              _: 1
            }, 8, ["onClick"])
          ]),
          default: k(() => [
            w(c, {
              text: v(or)(u.action.jobVariables),
              lang: "json"
            }, null, 8, ["text"])
          ]),
          _: 1
        }, 8, ["show-modal"])
      ], 64);
    };
  }
}), BNe = { class: "automation-action-description-send-notification" }, UNe = /* @__PURE__ */ U({
  __name: "AutomationActionDescriptionSendNotification",
  props: {
    action: {}
  },
  setup(t) {
    const e = t, { blockDocument: n } = x_(() => e.action.blockDocumentId), r = () => ["a", "e", "i", "o", "u"].includes(n.value?.blockType.name[0].toLowerCase() ?? "") ? "an" : "a", o = D(() => {
      if (n.value?.blockType.name === "Email")
        try {
          return `to ${JSON.parse(n.value.data.emails).join(", ")}`;
        } catch {
          return "";
        }
      return "";
    });
    return (s, i) => (T(), z("div", BNe, [
      q(" Send " + ie(r()) + " " + ie(v(n)?.blockType.name.toLocaleLowerCase() ?? "") + " notification using ", 1),
      w(v(V0), {
        "block-document-id": s.action.blockDocumentId
      }, null, 8, ["block-document-id"]),
      q(" " + ie(o.value), 1)
    ]));
  }
}), XNe = { class: "automation-action-description-suspend-cancel-flow-run" }, $Ne = /* @__PURE__ */ U({
  __name: "AutomationActionDescriptionSuspendCancelFlowRun",
  props: {
    action: {}
  },
  setup(t) {
    const e = t, n = D(() => e.action.type === "suspend-flow-run" ? "Suspend" : "Cancel");
    return (r, o) => (T(), z("div", XNe, [
      re("span", null, ie(n.value) + " flow run inferred from the triggering event", 1)
    ]));
  }
}), c6e = /* @__PURE__ */ U({
  __name: "AutomationActionDescription",
  props: {
    action: {}
  },
  setup(t) {
    const e = t, n = D(() => {
      switch (e.action.type) {
        case "pause-deployment":
        case "resume-deployment":
          return wt(SNe, {
            action: e.action
          });
        case "pause-work-queue":
        case "resume-work-queue":
          return wt(PNe, {
            action: e.action
          });
        case "change-flow-run-state":
          return wt(_Ne, {
            action: e.action
          });
        case "pause-work-pool":
        case "resume-work-pool":
          return wt(DNe, {
            action: e.action
          });
        case "pause-automation":
        case "resume-automation":
          return wt(kNe, {
            action: e.action
          });
        case "suspend-flow-run":
        case "cancel-flow-run":
          return wt($Ne, {
            action: e.action
          });
        case "resume-flow-run":
          return wt(INe, {
            action: e.action
          });
        case "run-deployment":
          return wt(LNe, {
            action: e.action
          });
        case "send-notification":
          return wt(UNe, {
            action: e.action
          });
        case "do-nothing":
          return null;
        default:
          const r = e.action;
          throw new Error(`AutomationActionDescription has no case for type: ${r.type}`);
      }
    });
    return (r, o) => n.value ? (T(), O(Mr(n.value.component), yt({ key: 0 }, n.value.props, { class: "automation-action-description" }), null, 16)) : j("", !0);
  }
}), WNe = {}, VNe = { class: "automation-trigger-description-custom" };
function HNe(t, e) {
  return T(), z("div", VNe, " A custom trigger ");
}
const jNe = /* @__PURE__ */ Dc(WNe, [["render", HNe]]), zNe = { class: "automation-trigger-description-deployment-status" }, qNe = /* @__PURE__ */ U({
  __name: "AutomationTriggerDescriptionDeploymentStatus",
  props: {
    trigger: {}
  },
  setup(t) {
    const e = D(() => t.trigger.deployments.length === 0);
    return (n, r) => (T(), z("div", zNe, [
      r[0] || (r[0] = q(" When ", -1)),
      e.value ? (T(), z(ve, { key: 0 }, [
        q(" any deployment ")
      ], 64)) : (T(), z(ve, { key: 1 }, [
        q(ie(v(Ks)("deployment", n.trigger.deployments.length)) + " ", 1),
        (T(!0), z(ve, null, ln(n.trigger.deployments, (o, s) => (T(), z(ve, { key: o }, [
          w($h, { "deployment-id": o }, null, 8, ["deployment-id"]),
          s === n.trigger.deployments.length - 2 ? (T(), z(ve, { key: 0 }, [
            q(" or ")
          ], 64)) : j("", !0)
        ], 64))), 128))
      ], 64)),
      q(" " + ie(v(qm)(n.trigger.posture)) + " " + ie(v(qx)(n.trigger.status).toLowerCase()) + " ", 1),
      n.trigger.posture === "Proactive" ? (T(), z(ve, { key: 2 }, [
        q(" for " + ie(v(_p)(n.trigger.time)), 1)
      ], 64)) : j("", !0)
    ]));
  }
}), GNe = { class: "automation-trigger-description-flow-run-state" }, YNe = /* @__PURE__ */ U({
  __name: "AutomationTriggerDescriptionFlowRunState",
  props: {
    trigger: {}
  },
  setup(t) {
    return (e, n) => {
      const r = P("p-tag-wrapper");
      return T(), z("div", GNe, [
        n[2] || (n[2] = q(" When any flow run ", -1)),
        e.trigger.flowIds.length ? (T(), z(ve, { key: 0 }, [
          n[0] || (n[0] = q(" of flow ", -1)),
          (T(!0), z(ve, null, ln(e.trigger.flowIds, (o, s) => (T(), z(ve, { key: o }, [
            w(cS, { "flow-id": o }, null, 8, ["flow-id"]),
            s === e.trigger.flowIds.length - 2 ? (T(), z(ve, { key: 0 }, [
              q(" or ")
            ], 64)) : j("", !0)
          ], 64))), 128))
        ], 64)) : j("", !0),
        e.trigger.tags.length ? (T(), z(ve, { key: 1 }, [
          n[1] || (n[1] = q(" with the tag ", -1)),
          w(r, {
            tags: e.trigger.tags,
            small: ""
          }, null, 8, ["tags"])
        ], 64)) : j("", !0),
        q(" " + ie(v(qm)(e.trigger.posture)) + " ", 1),
        e.trigger.states.length ? (T(!0), z(ve, { key: 2 }, ln(e.trigger.states, (o) => (T(), O(Dr, {
          key: o,
          state: v(uh)(o),
          small: ""
        }, null, 8, ["state"]))), 128)) : (T(), z(ve, { key: 3 }, [
          q(" any state ")
        ], 64)),
        e.trigger.posture === "Proactive" ? (T(), z(ve, { key: 4 }, [
          q(" for " + ie(v(_p)(e.trigger.time)), 1)
        ], 64)) : j("", !0)
      ]);
    };
  }
}), QNe = { class: "automation-trigger-description-work-pool-status" }, KNe = /* @__PURE__ */ U({
  __name: "AutomationTriggerDescriptionWorkPoolStatus",
  props: {
    trigger: {}
  },
  setup(t) {
    const e = t, n = D(() => e.trigger.workPools.length === 0), { workPools: r } = EN(() => n.value ? null : {
      workPools: {
        id: e.trigger.workPools
      }
    });
    return (o, s) => (T(), z("div", QNe, [
      s[0] || (s[0] = q(" When ", -1)),
      n.value ? (T(), z(ve, { key: 0 }, [
        q(" any work pool ")
      ], 64)) : (T(), z(ve, { key: 1 }, [
        q(ie(v(Ks)("work pool", o.trigger.workPools.length)) + " ", 1),
        (T(!0), z(ve, null, ln(v(r), (i, u) => (T(), z(ve, {
          key: i.id
        }, [
          w(Wh, {
            "work-pool-name": i.name
          }, null, 8, ["work-pool-name"]),
          u === o.trigger.workPools.length - 2 ? (T(), z(ve, { key: 0 }, [
            q(" or ")
          ], 64)) : j("", !0)
        ], 64))), 128))
      ], 64)),
      q(" " + ie(v(qm)(o.trigger.posture)) + " " + ie(v(n2)(o.trigger.status).toLowerCase()) + " ", 1),
      o.trigger.posture === "Proactive" ? (T(), z(ve, { key: 2 }, [
        q(" for " + ie(v(_p)(o.trigger.time)), 1)
      ], 64)) : j("", !0)
    ]));
  }
}), ZNe = { class: "automation-trigger-description-work-queue-status" }, JNe = /* @__PURE__ */ U({
  __name: "AutomationTriggerDescriptionWorkQueueStatus",
  props: {
    trigger: {}
  },
  setup(t) {
    const e = t, n = D(() => e.trigger.workPools.length === 0), { workPools: r } = EN(() => n.value ? null : {
      workPools: {
        id: e.trigger.workPools
      }
    }), o = D(() => e.trigger.workQueues.length === 0), { workQueues: s } = Nse(() => o.value ? null : {
      workQueues: {
        id: e.trigger.workQueues
      }
    });
    return (i, u) => (T(), z("div", ZNe, [
      u[0] || (u[0] = q(" When ", -1)),
      o.value ? (T(), z(ve, { key: 0 }, [
        q(" any work queue ")
      ], 64)) : (T(), z(ve, { key: 1 }, [
        q(ie(v(Ks)("work queue", i.trigger.workQueues.length)) + " ", 1),
        (T(!0), z(ve, null, ln(v(s), (l, a) => (T(), z(ve, {
          key: l.id
        }, [
          w(lw, {
            "work-pool-name": l.workPoolName,
            "work-queue-name": l.name
          }, null, 8, ["work-pool-name", "work-queue-name"]),
          a === i.trigger.workQueues.length - 2 ? (T(), z(ve, { key: 0 }, [
            q(" or ")
          ], 64)) : j("", !0)
        ], 64))), 128))
      ], 64)),
      n.value ? j("", !0) : (T(), z(ve, { key: 2 }, [
        q(" from the " + ie(v(Ks)("work pool", i.trigger.workPools.length)) + " ", 1),
        (T(!0), z(ve, null, ln(v(r), (l, a) => (T(), z(ve, {
          key: l.id
        }, [
          w(Wh, {
            "work-pool-name": l.name
          }, null, 8, ["work-pool-name"]),
          a === i.trigger.workPools.length - 2 ? (T(), z(ve, { key: 0 }, [
            q(" or ")
          ], 64)) : j("", !0)
        ], 64))), 128))
      ], 64)),
      q(" " + ie(v(qm)(i.trigger.posture)) + " " + ie(v(e2)(i.trigger.status).toLowerCase()) + " ", 1),
      i.trigger.posture === "Proactive" ? (T(), z(ve, { key: 3 }, [
        q(" for " + ie(v(_p)(i.trigger.time)), 1)
      ], 64)) : j("", !0)
    ]));
  }
}), p6e = /* @__PURE__ */ U({
  __name: "AutomationTriggerDescription",
  props: {
    trigger: {}
  },
  setup(t) {
    const e = t, n = D(() => {
      const r = Lne(e.trigger);
      switch (r) {
        case "deployment-status":
          return wt(qNe, {
            trigger: ye.map("AutomationTrigger", e.trigger, "DeploymentStatusTrigger")
          });
        case "flow-run-state":
          return wt(YNe, {
            trigger: ye.map("AutomationTrigger", e.trigger, "FlowRunStateTrigger")
          });
        case "work-pool-status":
          return wt(KNe, {
            trigger: ye.map("AutomationTrigger", e.trigger, "WorkPoolStatusTrigger")
          });
        case "work-queue-status":
          return wt(JNe, {
            trigger: ye.map("AutomationTrigger", e.trigger, "WorkQueueStatusTrigger")
          });
        case "custom":
          return wt(jNe, {});
        default:
          const o = r;
          throw new Error(`AutomationTriggerDescription missing case for trigger template: ${o}`);
      }
    });
    return (r, o) => (T(), O(Mr(n.value.component), yt(n.value.props, { class: "automation-trigger-description" }), null, 16));
  }
}), dw = /* @__PURE__ */ U({
  __name: "AutomationTriggerEventPostureSelect",
  props: {
    selected: {}
  },
  emits: ["update:selected"],
  setup(t, { emit: e }) {
    const n = t, r = e, o = _ne.map((i) => ({
      label: yi(qm(i)),
      value: i
    })), s = D({
      get() {
        return n.selected;
      },
      set(i) {
        r("update:selected", i);
      }
    });
    return (i, u) => {
      const l = P("p-select");
      return T(), O(l, {
        modelValue: s.value,
        "onUpdate:modelValue": u[0] || (u[0] = (a) => s.value = a),
        class: "automation-trigger-event-posture-select",
        options: v(o)
      }, null, 8, ["modelValue", "options"]);
    };
  }
}), vy = /* @__PURE__ */ U({
  __name: "AutomationWithinInput",
  props: /* @__PURE__ */ Br({
    posture: {}
  }, {
    time: { required: !0 },
    timeModifiers: {}
  }),
  emits: ["update:time"],
  setup(t) {
    const e = zn(t, "time"), n = t, { state: r, error: o, validate: s } = bn(e, "time", [
      (l, a, c) => {
        switch (n.posture) {
          case "Proactive":
            if (i(10)(l, a, c) !== !0)
              return "Time must be at least 10 seconds";
            break;
          case "Reactive":
            if (i(0)(l, a, c) !== !0)
              return "Time must be at least 0";
            break;
        }
        return !0;
      },
      u(30 * ic)
    ]);
    Ct(() => n.posture, async () => await s());
    function i(l) {
      return (a, c) => !Vt(a) || a >= l ? !0 : `${c} must be greater than or equal to ${l}`;
    }
    function u(l) {
      return (a) => !Vt(a) || a <= l ? !0 : "Time cannot be greater than 30 days";
    }
    return (l, a) => {
      const c = P("p-label");
      return T(), O(c, {
        class: "automation-within-input",
        label: "For",
        state: v(r),
        message: v(o)
      }, {
        label: k(({ id: p }) => [
          Ve(l.$slots, "label", { id: p })
        ]),
        default: k(({ id: p }) => [
          w(AL, {
            id: p,
            modelValue: e.value,
            "onUpdate:modelValue": a[0] || (a[0] = (d) => e.value = d),
            state: v(r),
            min: 0
          }, null, 8, ["id", "modelValue", "state"])
        ]),
        _: 3
      }, 8, ["state", "message"]);
    };
  }
}), e4e = { class: "automation-trigger-custom-event-input__threshold-and-within" }, t4e = ["for"], n4e = { class: "automation-trigger-custom-event-input__threshold-and-within-in-between" }, r4e = ["for"], o4e = { class: "automation-trigger-custom-event-input__evaluation-options-accordion-content" }, FX = /* @__PURE__ */ U({
  __name: "AutomationTriggerCustomEventInput",
  props: {
    trigger: { required: !0 },
    triggerModifiers: {}
  },
  emits: ["update:trigger"],
  setup(t) {
    const e = zn(t, "trigger"), { EventResourceCombobox: n } = Vn(), { state: r } = bn(() => e.value.threshold, "Threshold", [l, a(0)]);
    function o(c) {
      if (c.length === 0) {
        delete e.value.match["prefect.resource.id"];
        return;
      }
      e.value.match["prefect.resource.id"] = c;
    }
    function s(c) {
      if (Gt(c)) {
        e.value.expect = [];
        return;
      }
      e.value.expect = Sa(c);
    }
    function i(c) {
      if (Gt(c)) {
        e.value.after = [];
        return;
      }
      e.value.after = Sa(c);
    }
    function u(c) {
      if (c.length === 0) {
        delete e.value.matchRelated["prefect.resource.id"];
        return;
      }
      e.value.matchRelated["prefect.resource.id"] = c;
    }
    function l(c, p) {
      return Gt(c) || Tc(c) || Ps(c) || wp(c) ? `${p} is required` : !0;
    }
    function a(c) {
      return (p, d) => !Qv(p) || p > c ? !0 : `${d} must be greater than ${c}`;
    }
    return (c, p) => {
      const d = P("p-radio-group"), h = P("p-label"), m = P("p-number-input"), g = P("p-accordion"), _ = P("p-form");
      return T(), O(_, null, {
        default: k(() => [
          w(h, { label: "When I" }, {
            default: k(() => [
              w(d, {
                modelValue: e.value.posture,
                "onUpdate:modelValue": p[0] || (p[0] = (b) => e.value.posture = b),
                class: "automation-trigger-custom-event-input__posture-radio-group mt-2",
                options: [{ value: "Reactive", label: "Observe" }, { value: "Proactive", label: "Don't observe" }]
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          w(h, { label: "Any event matching" }, {
            default: k(() => [
              w(qk, {
                selected: e.value.expect,
                multiple: "",
                "onUpdate:selected": s
              }, null, 8, ["selected"])
            ]),
            _: 1
          }),
          w(h, { label: "From the following resources" }, {
            default: k(() => [
              w(v(n), {
                selected: e.value.match["prefect.resource.id"] ?? [],
                multiple: "",
                "onUpdate:selected": p[1] || (p[1] = (b) => o(v(Sa)(b ?? [])))
              }, null, 8, ["selected"])
            ]),
            _: 1
          }),
          re("div", null, [
            re("div", e4e, [
              w(h, {
                state: v(r),
                message: v(r).error,
                label: "Threshold",
                class: "automation-trigger-custom-event-input__threshold-input"
              }, {
                label: k(({ id: b }) => [
                  re("label", {
                    class: "sr-only",
                    for: b
                  }, "Threshold", 8, t4e)
                ]),
                default: k(({ id: b }) => [
                  w(m, {
                    id: b,
                    modelValue: e.value.threshold,
                    "onUpdate:modelValue": p[2] || (p[2] = (x) => e.value.threshold = x),
                    min: "1",
                    state: v(r)
                  }, null, 8, ["id", "modelValue", "state"])
                ]),
                _: 1
              }, 8, ["state", "message"]),
              re("span", n4e, ie(v(Ks)("time", e.value.threshold)) + " within", 1),
              w(vy, {
                time: e.value.within,
                "onUpdate:time": p[3] || (p[3] = (b) => e.value.within = b),
                posture: e.value.posture,
                class: "automation-trigger-custom-event-input__within-input"
              }, {
                label: k(({ id: b }) => [
                  re("label", {
                    class: "sr-only",
                    for: b
                  }, "Within", 8, r4e)
                ]),
                _: 1
              }, 8, ["time", "posture"])
            ])
          ]),
          w(g, {
            sections: ["Evaluation Options"],
            class: "automation-trigger-custom-event-input__evaluation-options-accordion"
          }, {
            content: k(() => [
              re("div", o4e, [
                w(h, { label: "Evaluate trigger only after observing an event matching" }, {
                  default: k(() => [
                    w(qk, {
                      selected: e.value.after,
                      multiple: "",
                      "onUpdate:selected": i
                    }, null, 8, ["selected"])
                  ]),
                  _: 1
                }),
                w(h, { label: "Filter for events related to" }, {
                  default: k(() => [
                    w(v(n), {
                      selected: e.value.matchRelated["prefect.resource.id"] ?? [],
                      multiple: "",
                      "onUpdate:selected": p[4] || (p[4] = (b) => u(v(Sa)(b ?? [])))
                    }, null, 8, ["selected"])
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      });
    };
  }
}), s4e = { class: "automation-trigger-deployment-status__status" }, a4e = /* @__PURE__ */ U({
  __name: "AutomationTriggerDeploymentStatusInput",
  props: {
    trigger: { required: !0 },
    triggerModifiers: {}
  },
  emits: ["update:trigger"],
  setup(t) {
    const e = zn(t, "trigger"), n = D({
      get() {
        return ye.map("AutomationTrigger", e.value, "DeploymentStatusTrigger");
      },
      set(u) {
        e.value = ye.map("DeploymentStatusTrigger", u, "AutomationTrigger");
      }
    }), r = mr(n, "deployments"), o = mr(n, "status"), s = mr(n, "time"), i = D({
      get() {
        return n.value.posture;
      },
      set(u) {
        if (u === "Proactive" && s.value === jm) {
          n.value = { ...n.value, time: 30, posture: u };
          return;
        }
        n.value = { ...n.value, posture: u };
      }
    });
    return (u, l) => {
      const a = P("p-label"), c = P("p-content");
      return T(), O(c, null, {
        default: k(() => [
          w(a, { label: "Deployments" }, {
            default: k(({ id: p }) => [
              w(cw, {
                id: p,
                selected: v(r),
                "onUpdate:selected": l[0] || (l[0] = (d) => Xe(r) ? r.value = d : null),
                "empty-message": "All deployments",
                "allow-unset": !1
              }, null, 8, ["id", "selected"])
            ]),
            _: 1
          }),
          w(a, { label: "Deployment" }, {
            default: k(() => [
              re("div", s4e, [
                w(dw, {
                  selected: i.value,
                  "onUpdate:selected": l[1] || (l[1] = (p) => i.value = p)
                }, null, 8, ["selected"]),
                w(RL, {
                  selected: v(o),
                  "onUpdate:selected": l[2] || (l[2] = (p) => Xe(o) ? o.value = p : null)
                }, null, 8, ["selected"])
              ])
            ]),
            _: 1
          }),
          i.value === "Proactive" ? (T(), O(vy, {
            key: 0,
            time: v(s),
            "onUpdate:time": l[3] || (l[3] = (p) => Xe(s) ? s.value = p : null),
            posture: i.value
          }, null, 8, ["time", "posture"])) : j("", !0)
        ]),
        _: 1
      });
    };
  }
}), i4e = { class: "automation-trigger-flow-run-state-input__states" }, u4e = /* @__PURE__ */ U({
  __name: "AutomationTriggerFlowRunStateInput",
  props: {
    trigger: { required: !0 },
    triggerModifiers: {}
  },
  emits: ["update:trigger"],
  setup(t) {
    const e = zn(t, "trigger"), n = D({
      get() {
        return ye.map("AutomationTrigger", e.value, "FlowRunStateTrigger");
      },
      set(l) {
        e.value = ye.map("FlowRunStateTrigger", l, "AutomationTrigger");
      }
    }), r = D({
      get() {
        return n.value.posture;
      },
      set(l) {
        if (l === "Proactive" && u.value === jm) {
          n.value = { ...n.value, time: 30, posture: l };
          return;
        }
        n.value = { ...n.value, posture: l };
      }
    }), o = D({
      get() {
        return n.value.flowIds;
      },
      set(l) {
        l.length > 0 && (n.value = { ...n.value, flowIds: l, tags: [] }), n.value = { ...n.value, flowIds: l };
      }
    }), s = mr(n, "tags"), i = mr(n, "states"), u = mr(n, "time");
    return (l, a) => {
      const c = P("p-label"), p = P("p-tags-input"), d = P("p-content");
      return T(), O(d, { class: "automation-trigger-flow-run-state-input" }, {
        default: k(() => [
          w(c, { label: "Flows" }, {
            default: k(({ id: h }) => [
              w(gS, {
                id: h,
                selected: o.value,
                "onUpdate:selected": a[0] || (a[0] = (m) => o.value = m),
                "empty-message": "All flows"
              }, null, 8, ["id", "selected"])
            ]),
            _: 1
          }),
          o.value.length === 0 ? (T(), O(c, {
            key: 0,
            label: "Flow Run Tags"
          }, {
            default: k(({ id: h }) => [
              w(p, {
                id: h,
                modelValue: v(s),
                "onUpdate:modelValue": a[1] || (a[1] = (m) => Xe(s) ? s.value = m : null),
                "empty-message": "All tags"
              }, null, 8, ["id", "modelValue"])
            ]),
            _: 1
          })) : j("", !0),
          w(c, { label: "Flow Run" }, {
            default: k(() => [
              re("div", i4e, [
                w(dw, {
                  selected: r.value,
                  "onUpdate:selected": a[2] || (a[2] = (h) => r.value = h)
                }, null, 8, ["selected"]),
                w(qh, {
                  selected: v(i),
                  "onUpdate:selected": a[3] || (a[3] = (h) => Xe(i) ? i.value = h : null),
                  multiple: "",
                  "empty-message": "Any state"
                }, null, 8, ["selected"])
              ])
            ]),
            _: 1
          }),
          r.value === "Proactive" ? (T(), O(vy, {
            key: 1,
            time: v(u),
            "onUpdate:time": a[4] || (a[4] = (h) => Xe(u) ? u.value = h : null),
            posture: r.value
          }, null, 8, ["time", "posture"])) : j("", !0)
        ]),
        _: 1
      });
    };
  }
}), l4e = { class: "automation-trigger-work-pool-status-input__status" }, c4e = /* @__PURE__ */ U({
  __name: "AutomationTriggerWorkPoolStatusInput",
  props: {
    trigger: { required: !0 },
    triggerModifiers: {}
  },
  emits: ["update:trigger"],
  setup(t) {
    const e = zn(t, "trigger"), n = D({
      get() {
        return ye.map("AutomationTrigger", e.value, "WorkPoolStatusTrigger");
      },
      set(u) {
        e.value = ye.map("WorkPoolStatusTrigger", u, "AutomationTrigger");
      }
    }), r = mr(n, "workPools"), o = mr(n, "status"), s = mr(n, "time"), i = D({
      get() {
        return n.value.posture;
      },
      set(u) {
        if (u === "Proactive" && s.value === jm) {
          n.value = { ...n.value, time: 30, posture: u };
          return;
        }
        n.value = { ...n.value, posture: u };
      }
    });
    return (u, l) => {
      const a = P("p-label"), c = P("p-content");
      return T(), O(c, { class: "automation-trigger-work-pool-status-input" }, {
        default: k(() => [
          w(a, { label: "Work Pools" }, {
            default: k(({ id: p }) => [
              w(pw, {
                id: p,
                selected: v(r),
                "onUpdate:selected": l[0] || (l[0] = (d) => Xe(r) ? r.value = d : null),
                "empty-message": "All work pools"
              }, null, 8, ["id", "selected"])
            ]),
            _: 1
          }),
          w(a, { label: "Work Pool" }, {
            default: k(() => [
              re("div", l4e, [
                w(dw, {
                  selected: i.value,
                  "onUpdate:selected": l[1] || (l[1] = (p) => i.value = p)
                }, null, 8, ["selected"]),
                w(MX, {
                  selected: v(o),
                  "onUpdate:selected": l[2] || (l[2] = (p) => Xe(o) ? o.value = p : null)
                }, null, 8, ["selected"])
              ])
            ]),
            _: 1
          }),
          i.value === "Proactive" ? (T(), O(vy, {
            key: 0,
            time: v(s),
            "onUpdate:time": l[3] || (l[3] = (p) => Xe(s) ? s.value = p : null),
            posture: i.value
          }, null, 8, ["time", "posture"])) : j("", !0)
        ]),
        _: 1
      });
    };
  }
}), p4e = { class: "automation-trigger-work-queue-status-input__status" }, d4e = /* @__PURE__ */ U({
  __name: "AutomationTriggerWorkQueueStatusInput",
  props: {
    trigger: { required: !0 },
    triggerModifiers: {}
  },
  emits: ["update:trigger"],
  setup(t) {
    const e = zn(t, "trigger"), n = D({
      get() {
        return ye.map("AutomationTrigger", e.value, "WorkQueueStatusTrigger");
      },
      set(l) {
        e.value = ye.map("WorkQueueStatusTrigger", l, "AutomationTrigger");
      }
    }), r = mr(n, "workPools"), o = mr(n, "workQueues"), s = mr(n, "status"), i = mr(n, "time"), u = D({
      get() {
        return n.value.posture;
      },
      set(l) {
        if (l === "Proactive" && i.value === jm) {
          n.value = { ...n.value, time: 30, posture: l };
          return;
        }
        n.value = { ...n.value, posture: l };
      }
    });
    return (l, a) => {
      const c = P("p-label"), p = P("p-content");
      return T(), O(p, { class: "automation-trigger-work-queue-status-input" }, {
        default: k(() => [
          w(c, { label: "Work Pools" }, {
            default: k(({ id: d }) => [
              w(pw, {
                id: d,
                selected: v(r),
                "onUpdate:selected": a[0] || (a[0] = (h) => Xe(r) ? r.value = h : null),
                "empty-message": "All work pools"
              }, null, 8, ["id", "selected"])
            ]),
            _: 1
          }),
          w(c, { label: "Work Queues" }, {
            default: k(({ id: d }) => [
              w(NR, {
                id: d,
                selected: v(o),
                "onUpdate:selected": a[1] || (a[1] = (h) => Xe(o) ? o.value = h : null),
                "empty-message": "All work queues",
                "work-pool-ids": v(r)
              }, null, 8, ["id", "selected", "work-pool-ids"])
            ]),
            _: 1
          }),
          w(c, { label: "Work Queue" }, {
            default: k(() => [
              re("div", p4e, [
                w(dw, {
                  selected: u.value,
                  "onUpdate:selected": a[2] || (a[2] = (d) => u.value = d)
                }, null, 8, ["selected"]),
                w(OX, {
                  selected: v(s),
                  "onUpdate:selected": a[3] || (a[3] = (d) => Xe(s) ? s.value = d : null)
                }, null, 8, ["selected"])
              ])
            ]),
            _: 1
          }),
          u.value === "Proactive" ? (T(), O(vy, {
            key: 0,
            time: v(i),
            "onUpdate:time": a[4] || (a[4] = (d) => Xe(i) ? i.value = d : null),
            posture: u.value
          }, null, 8, ["time", "posture"])) : j("", !0)
        ]),
        _: 1
      });
    };
  }
}), d6e = /* @__PURE__ */ U({
  __name: "AutomationTriggerEventInput",
  props: /* @__PURE__ */ Br({
    template: {}
  }, {
    trigger: { required: !0 },
    triggerModifiers: {}
  }),
  emits: ["update:trigger"],
  setup(t) {
    const e = zn(t, "trigger"), n = D(() => {
      switch (t.template) {
        case "deployment-status":
          return wt(a4e, {
            trigger: e.value,
            "onUpdate:trigger": r
          });
        case "flow-run-state":
          return wt(u4e, {
            trigger: e.value,
            "onUpdate:trigger": r
          });
        case "work-pool-status":
          return wt(c4e, {
            trigger: e.value,
            "onUpdate:trigger": r
          });
        case "work-queue-status":
          return wt(d4e, {
            trigger: e.value,
            "onUpdate:trigger": r
          });
        case "custom":
          return wt(FX, {
            trigger: e.value,
            "onUpdate:trigger": r
          });
        default:
          throw new Error(`AutomationTriggerEventInput does not support template: ${t.template}`);
      }
    });
    function r(o) {
      e.value = o;
    }
    return (o, s) => (T(), O(Mr(n.value.component), yt(n.value.props, { class: "automation-trigger-event-input" }), null, 16));
  }
}), h6e = /* @__PURE__ */ U({
  __name: "AutomationTriggerCustomInput",
  props: {
    trigger: { required: !0 },
    triggerModifiers: {}
  },
  emits: ["update:trigger"],
  setup(t) {
    const e = zn(t, "trigger");
    return (n, r) => {
      const o = P("p-message");
      return T(), O(v(NI), { class: "automation-trigger-custom-input" }, {
        default: k(() => [
          e.value.type === "event" ? (T(), O(FX, {
            key: 0,
            trigger: e.value,
            "onUpdate:trigger": r[0] || (r[0] = (s) => e.value = s)
          }, null, 8, ["trigger"])) : (T(), O(o, {
            key: 1,
            info: ""
          }, {
            default: k(() => [...r[1] || (r[1] = [
              q(" The custom trigger form view only supports triggers of type ", -1),
              re("code", null, "event", -1),
              q(". Switch to JSON to configure other trigger types ", -1)
            ])]),
            _: 1
          }))
        ]),
        _: 1
      });
    };
  }
}), f6e = /* @__PURE__ */ U({
  __name: "AutomationsPageEmptyState",
  setup(t) {
    const e = Ke(), n = je();
    return (r, o) => {
      const s = P("p-button");
      return T(), O(v(na), { class: "automations-page-empty-state" }, Ut({
        icon: k(() => [
          w(v(vo), { icon: "Automation" })
        ]),
        description: k(() => [
          o[1] || (o[1] = q(" Automations bring reactivity to your data stack and let you configure triggers and actions based on events. ", -1))
        ]),
        actions: k(() => [
          v(e).create.automation ? (T(), O(s, {
            key: 0,
            primary: "",
            "icon-append": "PlusIcon",
            to: v(n).automationCreate()
          }, {
            default: k(() => [...o[2] || (o[2] = [
              q(" Add Automation ", -1)
            ])]),
            _: 1
          }, 8, ["to"])) : j("", !0),
          w(Os, {
            to: v(le).docs.automations
          }, null, 8, ["to"])
        ]),
        _: 2
      }, [
        v(e).create.automation ? {
          name: "heading",
          fn: k(() => [
            o[0] || (o[0] = q(" Create an automation to get started ", -1))
          ]),
          key: "0"
        } : void 0
      ]), 1024);
    };
  }
});
function m6e() {
  const t = Se(), { value: e } = dn("actions", [GFe], []), { value: n } = dn("from"), { value: r } = dn("eventId"), { value: o } = dn("occurred", mo), { value: s } = dn("flowId"), { value: i } = dn("workPoolId"), { value: u } = dn("workPoolQueueId");
  async function l() {
    switch (n) {
      case "event":
        return await c();
      case "flow":
        return await p();
      case "workPool":
        return await d();
      case "workPoolQueue":
        return await h();
      default:
        return null;
    }
  }
  async function a() {
    const m = e.filter(PF);
    return m.length ? m : await null;
  }
  async function c() {
    if (!r)
      throw new Error("Failed creating automation trigger from event. Missing eventId query param.");
    if (!o)
      throw new Error("Failed creating automation trigger from event. Missing occurred query param.");
    const m = await t.events.getEvent(r, o);
    return ye.map("WorkspaceEvent", m, "AutomationTrigger");
  }
  async function p() {
    if (!s)
      throw new Error("Failed creating automation trigger from flow. Missing flowId query param.");
    const m = await t.flows.getFlow(s);
    return ye.map("Flow", m, "AutomationTrigger");
  }
  async function d() {
    if (!i)
      throw new Error("Failed creating automation trigger from work pool. Missing workPoolId query param.");
    const m = await t.workPools.getWorkPoolById(i);
    return ye.map("WorkPool", m, "AutomationTrigger");
  }
  async function h() {
    if (!u)
      throw new Error("Failed creating automation trigger from work pool queue. Missing workPoolQueueId query param.");
    const m = await t.workQueues.getWorkQueue(u);
    return ye.map("WorkPoolQueue", m, "AutomationTrigger");
  }
  return {
    getTrigger: l,
    getActions: a
  };
}
if (typeof window > "u") {
  const t = {};
  Object.assign(global, { window: t });
}
const y6e = {
  install(t) {
    t.use(jj), pte();
  }
};
export {
  S4 as $,
  C2 as A,
  v4 as B,
  hhe as C,
  fhe as D,
  _he as E,
  V0 as F,
  whe as G,
  bhe as H,
  GN as I,
  khe as J,
  The as K,
  She as L,
  w4 as M,
  P2 as N,
  YN as O,
  k4 as P,
  U2 as Q,
  Mhe as R,
  T4 as S,
  Nhe as T,
  Xhe as U,
  Vhe as V,
  Nk as W,
  ife as X,
  lfe as Y,
  H2 as Z,
  c4 as _,
  ru as a,
  gS as a$,
  j2 as a0,
  R4 as a1,
  cfe as a2,
  D4 as a3,
  E4 as a4,
  pfe as a5,
  M4 as a6,
  P4 as a7,
  C4 as a8,
  O4 as a9,
  dS as aA,
  vL as aB,
  _L as aC,
  wL as aD,
  bL as aE,
  kL as aF,
  TL as aG,
  xL as aH,
  $ve as aI,
  hS as aJ,
  SL as aK,
  RL as aL,
  fS as aM,
  gL as aN,
  Os as aO,
  Cc as aP,
  AL as aQ,
  mS as aR,
  F_ as aS,
  Yve as aT,
  g_e as aU,
  N_ as aV,
  qk as aW,
  EL as aX,
  E_ as aY,
  yS as aZ,
  v_e as a_,
  I4 as aa,
  _r as ab,
  z2 as ac,
  fh as ad,
  uo as ae,
  L4 as af,
  kfe as ag,
  nve as ah,
  $0 as ai,
  rve as aj,
  fL as ak,
  N4 as al,
  oS as am,
  zk as an,
  ive as ao,
  sS as ap,
  lve as aq,
  cve as ar,
  pve as as,
  mve as at,
  aS as au,
  _ve as av,
  $h as aw,
  Sve as ax,
  Ave as ay,
  lS as az,
  Se as b,
  JU as b$,
  b_e as b0,
  cS as b1,
  S_e as b2,
  R_e as b3,
  PL as b4,
  tv as b5,
  I_e as b6,
  CL as b7,
  nS as b8,
  OL as b9,
  VU as bA,
  rS as bB,
  HU as bC,
  gR as bD,
  jU as bE,
  _R as bF,
  Vh as bG,
  zU as bH,
  qOe as bI,
  GOe as bJ,
  QOe as bK,
  qU as bL,
  ay as bM,
  GU as bN,
  YU as bO,
  bR as bP,
  wR as bQ,
  PIe as bR,
  QU as bS,
  KU as bT,
  ny as bU,
  ry as bV,
  ZU as bW,
  UIe as bX,
  XIe as bY,
  hn as bZ,
  WIe as b_,
  vS as ba,
  H_e as bb,
  R_ as bc,
  z_e as bd,
  q_e as be,
  pS as bf,
  cOe as bg,
  XU as bh,
  hOe as bi,
  mOe as bj,
  IL as bk,
  gOe as bl,
  wOe as bm,
  gy as bn,
  TOe as bo,
  SOe as bp,
  AOe as bq,
  ty as br,
  L_ as bs,
  sw as bt,
  OOe as bu,
  UOe as bv,
  $U as bw,
  $Oe as bx,
  vR as by,
  WU as bz,
  je as c,
  iS as c$,
  eX as c0,
  wS as c1,
  Rr as c2,
  kR as c3,
  tX as c4,
  TR as c5,
  fu as c6,
  nX as c7,
  xR as c8,
  SR as c9,
  U8e as cA,
  X8e as cB,
  $8e as cC,
  W8e as cD,
  V8e as cE,
  H8e as cF,
  j8e as cG,
  Q8e as cH,
  K8e as cI,
  e3e as cJ,
  t3e as cK,
  n3e as cL,
  r3e as cM,
  o3e as cN,
  s3e as cO,
  a3e as cP,
  i3e as cQ,
  u3e as cR,
  l3e as cS,
  c3e as cT,
  p3e as cU,
  d3e as cV,
  h3e as cW,
  f3e as cX,
  m3e as cY,
  v3e as cZ,
  dX as c_,
  t8e as ca,
  rX as cb,
  oX as cc,
  RR as cd,
  AR as ce,
  d8e as cf,
  sX as cg,
  h8e as ch,
  _8e as ci,
  aX as cj,
  iX as ck,
  nn as cl,
  x8e as cm,
  S8e as cn,
  R8e as co,
  A8e as cp,
  D8e as cq,
  M8e as cr,
  P8e as cs,
  C8e as ct,
  O8e as cu,
  I8e as cv,
  F8e as cw,
  N8e as cx,
  L8e as cy,
  B8e as cz,
  hh as d,
  SX as d$,
  _3e as d0,
  Uo as d1,
  hX as d2,
  ER as d3,
  lX as d4,
  pX as d5,
  cX as d6,
  S3e as d7,
  iw as d8,
  R3e as d9,
  X3e as dA,
  mX as dB,
  $3e as dC,
  yX as dD,
  W3e as dE,
  M_ as dF,
  uS as dG,
  mL as dH,
  ML as dI,
  MR as dJ,
  PR as dK,
  gX as dL,
  vX as dM,
  _X as dN,
  V3e as dO,
  q3e as dP,
  wX as dQ,
  S_ as dR,
  bX as dS,
  $v as dT,
  Q3e as dU,
  kX as dV,
  CR as dW,
  TX as dX,
  aw as dY,
  aFe as dZ,
  xX as d_,
  ed as da,
  fX as db,
  Pk as dc,
  BN as dd,
  bp as de,
  UN as df,
  qN as dg,
  D3e as dh,
  X2 as di,
  b4 as dj,
  Wo as dk,
  td as dl,
  px as dm,
  Dr as dn,
  $2 as dp,
  W2 as dq,
  qh as dr,
  F4 as ds,
  Jl as dt,
  Pc as du,
  P3e as dv,
  O3e as dw,
  B2 as dx,
  V2 as dy,
  x4 as dz,
  vde as e,
  $oe as e$,
  RX as e0,
  dFe as e1,
  hFe as e2,
  Wh as e3,
  fFe as e4,
  AX as e5,
  mFe as e6,
  _S as e7,
  yFe as e8,
  _Fe as e9,
  boe as eA,
  Toe as eB,
  QF as eC,
  ZF as eD,
  eN as eE,
  nN as eF,
  oN as eG,
  c2 as eH,
  aN as eI,
  uN as eJ,
  d2 as eK,
  Soe as eL,
  cN as eM,
  mBe as eN,
  Doe as eO,
  yBe as eP,
  Moe as eQ,
  Coe as eR,
  Ooe as eS,
  gBe as eT,
  Foe as eU,
  f2 as eV,
  pN as eW,
  Noe as eX,
  Loe as eY,
  Boe as eZ,
  Uoe as e_,
  wFe as ea,
  bFe as eb,
  uw as ec,
  DX as ed,
  TFe as ee,
  OR as ef,
  D_ as eg,
  IR as eh,
  SFe as ei,
  EFe as ej,
  MFe as ek,
  EX as el,
  I_ as em,
  MX as en,
  FR as eo,
  PX as ep,
  CX as eq,
  lw as er,
  OX as es,
  CFe as et,
  OFe as eu,
  IFe as ev,
  LFe as ew,
  qFe as ex,
  e4 as ey,
  Qm as ez,
  p4 as f,
  x2 as f$,
  Voe as f0,
  dN as f1,
  joe as f2,
  zoe as f3,
  Goe as f4,
  vBe as f5,
  _Be as f6,
  wBe as f7,
  bBe as f8,
  Koe as f9,
  yl as fA,
  zE as fB,
  MBe as fC,
  Qp as fD,
  dse as fE,
  du as fF,
  b2 as fG,
  PBe as fH,
  Mc as fI,
  hse as fJ,
  fse as fK,
  Xa as fL,
  CBe as fM,
  _N as fN,
  wN as fO,
  bN as fP,
  OBe as fQ,
  IBe as fR,
  kN as fS,
  FBe as fT,
  NBe as fU,
  k2 as fV,
  mN as fW,
  bse as fX,
  T2 as fY,
  LBe as fZ,
  St as f_,
  kBe as fa,
  Zoe as fb,
  TBe as fc,
  ese as fd,
  xBe as fe,
  _2 as ff,
  tse as fg,
  nse as fh,
  x_ as fi,
  sse as fj,
  RBe as fk,
  yN as fl,
  ABe as fm,
  DBe as fn,
  Ke as fo,
  ase as fp,
  Vn as fq,
  ise as fr,
  gN as fs,
  Zm as ft,
  w2 as fu,
  EBe as fv,
  vN as fw,
  hN as fx,
  SBe as fy,
  Ec as fz,
  d4 as g,
  K3 as g$,
  fN as g0,
  BBe as g1,
  Kp as g2,
  UBe as g3,
  kse as g4,
  Tse as g5,
  hp as g6,
  XBe as g7,
  Rse as g8,
  $Be as g9,
  GF as gA,
  Ro as gB,
  _oe as gC,
  GFe as gD,
  le as gE,
  Qpe as gF,
  zx as gG,
  L0 as gH,
  j3 as gI,
  z3 as gJ,
  q3 as gK,
  G3 as gL,
  hee as gM,
  dLe as gN,
  hLe as gO,
  fLe as gP,
  fee as gQ,
  mee as gR,
  yee as gS,
  gee as gT,
  vee as gU,
  _ee as gV,
  Y3 as gW,
  wk as gX,
  Q3 as gY,
  wee as gZ,
  m8 as g_,
  WBe as ga,
  TN as gb,
  VBe as gc,
  Jm as gd,
  xN as ge,
  SN as gf,
  RN as gg,
  AN as gh,
  HBe as gi,
  jBe as gj,
  Mse as gk,
  Pse as gl,
  GBe as gm,
  Cs as gn,
  YBe as go,
  Ise as gp,
  DN as gq,
  QBe as gr,
  KBe as gs,
  Fse as gt,
  EN as gu,
  Nse as gv,
  MN as gw,
  yoe as gx,
  qF as gy,
  l2 as gz,
  wde as h,
  Gee as h$,
  bee as h0,
  Z3 as h1,
  J3 as h2,
  B0 as h3,
  Ree as h4,
  Pee as h5,
  mLe as h6,
  Cee as h7,
  Oee as h8,
  bk as h9,
  lm as hA,
  bLe as hB,
  Vee as hC,
  Gx as hD,
  oh as hE,
  B4e as hF,
  y8 as hG,
  Qq as hH,
  Kq as hI,
  g8 as hJ,
  fi as hK,
  v8 as hL,
  _8 as hM,
  w8 as hN,
  b8 as hO,
  Hee as hP,
  jee as hQ,
  zee as hR,
  iF as hS,
  Kx as hT,
  Zx as hU,
  qee as hV,
  Jx as hW,
  uF as hX,
  kLe as hY,
  e2 as hZ,
  t2 as h_,
  Iee as ha,
  qx as hb,
  Fee as hc,
  Ac as hd,
  Lee as he,
  yLe as hf,
  gLe as hg,
  vLe as hh,
  Bee as hi,
  Uee as hj,
  tF as hk,
  nF as hl,
  $ee as hm,
  im as hn,
  jd as ho,
  RE as hp,
  rF as hq,
  _Le as hr,
  wLe as hs,
  oF as ht,
  sF as hu,
  aF as hv,
  Yx as hw,
  Wee as hx,
  Qx as hy,
  um as hz,
  ELe as i,
  aae as i$,
  U0 as i0,
  Yee as i1,
  TLe as i2,
  Qee as i3,
  n2 as i4,
  lF as i5,
  AE as i6,
  dF as i7,
  Jee as i8,
  ete as i9,
  F2 as iA,
  o6e as iB,
  r6e as iC,
  dae as iD,
  hae as iE,
  fae as iF,
  mae as iG,
  yae as iH,
  gae as iI,
  gl as iJ,
  vae as iK,
  _ae as iL,
  dh as iM,
  kae as iN,
  M2 as iO,
  Gg as iP,
  xae as iQ,
  zN as iR,
  XN as iS,
  Bh as iT,
  Ck as iU,
  $N as iV,
  rae as iW,
  E2 as iX,
  WN as iY,
  oae as iZ,
  sae as i_,
  hF as ia,
  M1 as ib,
  tte as ic,
  nte as id,
  xLe as ie,
  SLe as ig,
  rte as ih,
  kce as ii,
  zBe as ij,
  Ese as ik,
  qBe as il,
  Pq as im,
  Cq as io,
  Oq as ip,
  kx as iq,
  hi as ir,
  N4e as is,
  Iq as it,
  L4e as iu,
  Fq as iv,
  xce as iw,
  Zq as ix,
  Tce as iy,
  Kpe as iz,
  h4 as j,
  BE as j$,
  iae as j0,
  uae as j1,
  Ok as j2,
  lae as j3,
  VN as j4,
  cae as j5,
  pae as j6,
  HN as j7,
  s6e as j8,
  Zpe as j9,
  ote as jA,
  ste as jB,
  ate as jC,
  eBe as jD,
  i2 as jE,
  tBe as jF,
  nBe as jG,
  HF as jH,
  jF as jI,
  Rre as jJ,
  s2 as jK,
  cBe as jL,
  woe as jM,
  HE as jN,
  pBe as jO,
  YF as jP,
  zd as jQ,
  noe as jR,
  rBe as jS,
  oBe as jT,
  sBe as jU,
  roe as jV,
  ooe as jW,
  aBe as jX,
  soe as jY,
  aoe as jZ,
  w_ as j_,
  Xee as ja,
  tde as jb,
  a6e as jc,
  ede as jd,
  nG as je,
  eG as jf,
  qn as jg,
  rG as jh,
  iG as ji,
  lG as jj,
  cG as jk,
  pG as jl,
  dG as jm,
  hG as jn,
  fG as jo,
  wG as jp,
  zJ as jq,
  nde as jr,
  qJ as js,
  GJ as jt,
  YJ as ju,
  QJ as jv,
  cee as jw,
  rde as jx,
  pee as jy,
  dee as jz,
  f4 as k,
  u_ as k$,
  ioe as k0,
  uoe as k1,
  b_ as k2,
  UE as k3,
  loe as k4,
  coe as k5,
  Lh as k6,
  XE as k7,
  poe as k8,
  zF as k9,
  Tc as kA,
  T0 as kB,
  lk as kC,
  V4e as kD,
  Tx as kE,
  H4e as kF,
  j4e as kG,
  z4e as kH,
  _G as kI,
  xx as kJ,
  fF as kK,
  c_ as kL,
  ALe as kM,
  cte as kN,
  DE as kO,
  pte as kP,
  kk as kQ,
  EE as kR,
  DLe as kS,
  dte as kT,
  wt as kU,
  hte as kV,
  fte as kW,
  gF as kX,
  i_ as kY,
  Vx as kZ,
  L3 as k_,
  $E as ka,
  iBe as kb,
  WE as kc,
  uBe as kd,
  VE as ke,
  moe as kf,
  lBe as kg,
  jg as kh,
  Bte as ki,
  Ute as kj,
  dBe as kk,
  hBe as kl,
  fBe as km,
  RLe as kn,
  ite as ko,
  S8 as kp,
  cu as kq,
  Qr as kr,
  rE as ks,
  Bm as kt,
  X4e as ku,
  tl as kv,
  $4e as kw,
  gG as kx,
  vG as ky,
  W4e as kz,
  N2 as l,
  Sr as l$,
  Hx as l0,
  l_ as l1,
  B3 as l2,
  U3 as l3,
  NJ as l4,
  ol as l5,
  wp as l6,
  vk as l7,
  Xo as l8,
  G4e as l9,
  E8 as lA,
  M8 as lB,
  ac as lC,
  Oa as lD,
  ic as lE,
  Ih as lF,
  P8 as lG,
  C8 as lH,
  TG as lI,
  Ua as lJ,
  gte as lK,
  Yt as lL,
  cF as lM,
  pF as lN,
  r2 as lO,
  Kee as lP,
  sG as lQ,
  vt as lR,
  aG as lS,
  p_ as lT,
  wte as lU,
  or as lV,
  ME as lW,
  vF as lX,
  bte as lY,
  kte as lZ,
  Tte as l_,
  X3 as la,
  Y4e as lb,
  LJ as lc,
  Q4e as ld,
  $3 as le,
  K4e as lf,
  Z4e as lg,
  J4e as lh,
  eLe as li,
  tLe as lj,
  qs as lk,
  bE as ll,
  nLe as lm,
  rLe as ln,
  W3 as lo,
  BJ as lp,
  oLe as lq,
  R8 as lr,
  x0 as ls,
  kG as lt,
  Ia as lu,
  nl as lv,
  Kv as lw,
  q4e as lx,
  sh as ly,
  D8 as lz,
  ye as m,
  Vu as m$,
  Vd as m0,
  mG as m1,
  U4e as m2,
  Yn as m3,
  x8 as m4,
  yG as m5,
  ih as m6,
  _F as m7,
  uLe as m8,
  R1 as m9,
  ms as mA,
  _p as mB,
  fc as mC,
  uh as mD,
  OLe as mE,
  SF as mF,
  lh as mG,
  wF as mH,
  Ete as mI,
  mc as mJ,
  bF as mK,
  Mte as mL,
  Pte as mM,
  Hm as mN,
  Ht as mO,
  yi as mP,
  Cte as mQ,
  Ps as mR,
  Ite as mS,
  MLe as mT,
  CE as mU,
  ILe as mV,
  FLe as mW,
  NLe as mX,
  LLe as mY,
  BLe as mZ,
  RF as m_,
  KJ as ma,
  lLe as mb,
  ZJ as mc,
  Ds as md,
  JJ as me,
  cLe as mf,
  eee as mg,
  wn as mh,
  lc as mi,
  Wn as mj,
  Ste as mk,
  Ip as ml,
  Fte as mm,
  gi as mn,
  PLe as mo,
  CLe as mp,
  d_ as mq,
  h_ as mr,
  kF as ms,
  Xte as mt,
  TF as mu,
  $te as mv,
  zg as mw,
  xF as mx,
  Tk as my,
  Wte as mz,
  m4 as n,
  m6e as n$,
  IE as n0,
  FE as n1,
  Op as n2,
  H3 as n3,
  sLe as n4,
  UJ as n5,
  XJ as n6,
  aLe as n7,
  Zs as n8,
  ci as n9,
  ml as nA,
  Kte as nB,
  HLe as nC,
  f_ as nD,
  h8 as nE,
  Gt as nF,
  f8 as nG,
  Mq as nH,
  Qv as nI,
  fie as nJ,
  Uh as nK,
  jx as nL,
  Xh as nM,
  i6e as nN,
  YFe as nO,
  tNe as nP,
  nNe as nQ,
  u6e as nR,
  l6e as nS,
  c6e as nT,
  p6e as nU,
  dw as nV,
  vy as nW,
  d6e as nX,
  h6e as nY,
  f6e as nZ,
  E8e as n_,
  _k as na,
  N0 as nb,
  WJ as nc,
  iLe as nd,
  Gr as ne,
  VJ as nf,
  HJ as ng,
  to as nh,
  Hte as ni,
  jte as nj,
  DF as nk,
  qp as nl,
  zte as nm,
  Kr as nn,
  qte as no,
  Gte as np,
  EF as nq,
  ULe as nr,
  Yte as ns,
  Fp as nt,
  a2 as nu,
  MF as nv,
  XLe as nw,
  $Le as nx,
  WLe as ny,
  VLe as nz,
  Nde as o,
  qLe as o0,
  vne as o1,
  gne as o2,
  PF as o3,
  jLe as o4,
  ene as o5,
  zLe as o6,
  bne as o7,
  xne as o8,
  Ti as o9,
  One as oA,
  NF as oa,
  LF as ob,
  BF as oc,
  ZLe as od,
  Ine as oe,
  JLe as of,
  Nne as og,
  Lne as oh,
  Bne as oi,
  Une as oj,
  GLe as ok,
  Sne as ol,
  jm as om,
  zm as on,
  qm as oo,
  $o as op,
  Xne as oq,
  YLe as or,
  Sk as os,
  Ane as ot,
  Dne as ou,
  QLe as ov,
  Rk as ow,
  Cne as ox,
  KLe as oy,
  Ak as oz,
  y6e as p,
  L2 as q,
  Lde as r,
  Qde as s,
  y4 as t,
  uX as u,
  g4 as v,
  ehe as w,
  _4 as x,
  dhe as y,
  KN as z
};
//# sourceMappingURL=index-DjDBGSho.js.map
